(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[425],{

/***/ 5752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var tslib = __webpack_require__(70655);
var util = __webpack_require__(31313);
var component = __webpack_require__(79730);
var logger$1 = __webpack_require__(14594);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);

var name$1 = "@firebase/app";
var version = "0.6.11";

var name$2 = "@firebase/analytics";

var name$3 = "@firebase/auth";

var name$4 = "@firebase/database";

var name$5 = "@firebase/functions";

var name$6 = "@firebase/installations";

var name$7 = "@firebase/messaging";

var name$8 = "@firebase/performance";

var name$9 = "@firebase/remote-config";

var name$a = "@firebase/storage";

var name$b = "@firebase/firestore";

var name$c = "firebase-wrapper";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_a$1 = {},
    _a$1[name$1] = 'fire-core',
    _a$1[name$2] = 'fire-analytics',
    _a$1[name$3] = 'fire-auth',
    _a$1[name$4] = 'fire-rtdb',
    _a$1[name$5] = 'fire-fn',
    _a$1[name$6] = 'fire-iid',
    _a$1[name$7] = 'fire-fcm',
    _a$1[name$8] = 'fire-perf',
    _a$1[name$9] = 'fire-rc',
    _a$1[name$a] = 'fire-gcs',
    _a$1[name$b] = 'fire-fst',
    _a$1['fire-js'] = 'fire-js',
    _a$1[name$c] = 'fire-js-all',
    _a$1);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.container = new component.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
        try {
            // populate ComponentContainer with existing components
            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */
    FirebaseAppImpl.prototype._addComponent = function (component) {
        try {
            this.container.addComponent(component);
        }
        catch (e) {
            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version$1 = "7.20.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: logger$1.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!util.contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (util.contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    namespace[componentName]
                : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function (appArg) {
                if (appArg === void 0) { appArg = app(); }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                util.deepExtend(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        try {
            // add the component to existing app instances
            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return component.type === "PUBLIC" /* PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentName]
            : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) {
            library += "-" + variant;
        }
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) {
                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            }
            if (libraryMismatch && versionMismatch) {
                warning.push('and');
            }
            if (versionMismatch) {
                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            }
            logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') {
            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
                appName: name
            });
        }
        logger$1.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: util.createSubscribe,
        ErrorFactory: util.ErrorFactory,
        deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}
var firebase = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = /** @class */ (function () {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function () {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(function (provider) {
            if (isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            }
            else {
                return null;
            }
        })
            .filter(function (logString) { return logString; })
            .join(' ');
    };
    return PlatformLoggerService;
}());
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    firebase.registerVersion(name$1, version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (util.isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var initializeApp = firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebase.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase$1 = firebase;
registerCoreComponents(firebase$1);

exports["default"] = firebase$1;
exports.firebase = firebase$1;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 79730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var tslib = __webpack_require__(70655);
var util = __webpack_require__(31313);

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = /** @class */ (function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
    }
    Component.prototype.setInstantiationMode = function (mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function (multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function (props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
var Provider = /** @class */ (function () {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    Provider.prototype.get = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new util.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) {
                    deferred.resolve(instance);
                }
            }
            catch (e) {
                // when the instance factory throws an exception during get(), it should not cause
                // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function (options) {
        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) {
                    return null;
                }
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        }
        catch (e) {
            if (optional) {
                return null;
            }
            else {
                throw e;
            }
        }
    };
    Provider.prototype.getComponent = function () {
        return this.component;
    };
    Provider.prototype.setComponent = function (component) {
        var e_1, _a;
        if (component.name !== this.name) {
            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        }
        if (this.component) {
            throw Error("Component for " + this.name + " has already been provided");
        }
        this.component = component;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                }
                catch (e) {
                    // when the instance factory throws an exception, it should not cause
                    // a fatal error. We just leave the promise unresolved.
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Provider.prototype.clearInstance = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var services;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services = Array.from(this.instances.values());
                        return [4 /*yield*/, Promise.all(tslib.__spread(services
                                .filter(function (service) { return 'INTERNAL' in service; }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service.INTERNAL.delete(); }), services
                                .filter(function (service) { return '_delete' in service; }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service._delete(); })))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function () {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function (identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    };
    return Provider;
}());
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
var ComponentContainer = /** @class */ (function () {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    ComponentContainer.prototype.addComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error("Component " + component.name + " has already been registered with " + this.name);
        }
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    ComponentContainer.prototype.getProvider = function (name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function () {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}());

exports.Component = Component;
exports.ComponentContainer = ComponentContainer;
exports.Provider = Provider;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 14594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LogLevel": function() { return /* binding */ LogLevel; },
/* harmony export */   "Logger": function() { return /* binding */ Logger; },
/* harmony export */   "setLogLevel": function() { return /* binding */ setLogLevel; },
/* harmony export */   "setUserLogHandler": function() { return /* binding */ setUserLogHandler; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_a = {},
    _a[LogLevel.DEBUG] = 'log',
    _a[LogLevel.VERBOSE] = 'log',
    _a[LogLevel.INFO] = 'info',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        console[method].apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
    }
    else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function (val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function () {
            return this._userLogHandler;
        },
        set: function (val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
    };
    return Logger;
}());
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop_1 = function (instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = function (instance, level) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var message = args
                    .map(function (arg) {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(function (arg) { return arg; })
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 31313:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var tslib = __webpack_require__(70655);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    var runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    var ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return 'indexedDB' in self && indexedDB != null;
}
/**
 * This method validates browser context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 */
function validateIndexedDBOpenable() {
    return new Promise(function (resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = 'validate-browser-context-for-indexeddb-analytics-module';
            var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function () {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) {
                    window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                }
                resolve(true);
            };
            request_1.onupgradeneeded = function () {
                preExist_1 = false;
            };
            request_1.onerror = function () {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (!navigator || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) { intervalMillis = DEFAULT_INTERVAL_MILLIS; }
    if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.MAX_VALUE_MILLIS = MAX_VALUE_MILLIS;
exports.RANDOM_FACTOR = RANDOM_FACTOR;
exports.Sha1 = Sha1;
exports.areCookiesEnabled = areCookiesEnabled;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.calculateBackoffMillis = calculateBackoffMillis;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.getUA = getUA;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isBrowserExtension = isBrowserExtension;
exports.isElectron = isElectron;
exports.isEmpty = isEmpty;
exports.isIE = isIE;
exports.isIndexedDBAvailable = isIndexedDBAvailable;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.isSafari = isSafari;
exports.isUWP = isUWP;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateIndexedDBOpenable = validateIndexedDBOpenable;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 15897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(47815);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {}

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports["default"] = createReactContext;
module.exports = exports['default'];

/***/ }),

/***/ 88740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(15897);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),

/***/ 83065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Accordion/styled.js
'use client';





var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    ", "\n"])), function (_a) {
    var haveDefaultBackgroundColor = _a.haveDefaultBackgroundColor, isExpand = _a.isExpand;
    return haveDefaultBackgroundColor
        ? "\n                background-color: ".concat(isExpand ? Colors/* colors.primary.100 */.O9.primary[100] : Colors/* colors.neutral.99 */.O9.neutral[99], ";\n            ")
        : '';
});
var AccordionSummary = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    z-index: 3;\n    width: ", ";\n"], ["\n    position: relative;\n    z-index: 3;\n    width: ", ";\n"])), function (_a) {
    var $isHaveExpandIcon = _a.$isHaveExpandIcon;
    return ($isHaveExpandIcon ? 'calc(100% - 36px)' : '100%');
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 5;\n    padding: 4px;\n    top: 50%;\n    right: -36px;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: translateY(-50%) rotate(", "deg);\n"], ["\n    position: absolute;\n    z-index: 5;\n    padding: 4px;\n    top: 50%;\n    right: -36px;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: translateY(-50%) rotate(", "deg);\n"])), function (_a) {
    var isExpand = _a.isExpand;
    return (isExpand ? '0' : '180');
});
var AccordionDetails = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"
    // transition: height 0.25s ease-in-out, opacity 0.2s ease-out;
])), function (_a) {
    var enableMaskImage = _a.enableMaskImage, isExpand = _a.isExpand;
    return enableMaskImage && isExpand ? 'mask-image: linear-gradient(180deg, #fff, transparent);' : '';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
// transition: height 0.25s ease-in-out, opacity 0.2s ease-out;


//# sourceMappingURL=styled.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Accordion/helpers.js
'use client';

function getTextNodeHeight(node, isCustom) {
    if (!isCustom) {
        return {
            lineHeight: 0
        };
    }
    if (node.nodeType === Node.TEXT_NODE) {
        var lineHeight = 0;
        if (node.parentElement) {
            var getLineHeight = window.getComputedStyle(node.parentElement).lineHeight;
            lineHeight = parseFloat(getLineHeight);
        }
        return {
            lineHeight: lineHeight
        };
    }
    if (node.childNodes[0]) {
        return getTextNodeHeight(node.childNodes[0], isCustom);
    }
    return {
        lineHeight: 0
    };
}


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useTransition.js
var useTransition = __webpack_require__(98638);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Accordion/index.js
'use client';











function Accordion(_a) {
    var title = _a.title, expandIcon = _a.expandIcon, children = _a.children, _b = _a.expand, expand = _b === void 0 ? true : _b, custom = _a.custom, settings = _a.settings, onChange = _a.onChange, rest = (0,_tslib/* __rest */._T)(_a, ["title", "expandIcon", "children", "expand", "custom", "settings", "onChange"]);
    var _c = settings || {}, _d = _c.contentOffset, contentOffset = _d === void 0 ? 0 : _d, _e = _c.haveDefaultBackgroundColor, haveDefaultBackgroundColor = _e === void 0 ? true : _e;
    // Collapse state
    var _f = (0,react.useState)(expand), isExpand = _f[0], setExpand = _f[1];
    // Element ref
    var collapsibleContentRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    // Height of collapsible content
    var contentExpandHeightRef = (0,react.useRef)(0);
    var _g = (0,react.useState)(0), contentCollapseHeight = _g[0], setContentCollapseHeight = _g[1];
    // Store previous value of collapse state
    var prevValue = (0,react.useRef)(expand);
    var TitleComponent = title && typeof title === 'function' ? title(isExpand) : title;
    var isHaveExpandIcon = !!expandIcon;
    (0,react.useEffect)(function () {
        if (prevValue.current !== expand) {
            setExpand(expand);
        }
    }, [expand]);
    (0,react.useEffect)(function () {
        prevValue.current = isExpand;
    }, [isExpand]);
    (0,react.useEffect)(function () {
        var handleExpandContent = function () {
            var _a;
            if (contentRef.current && collapsibleContentRef.current) {
                var collapsibleContentEl = collapsibleContentRef.current;
                /*
                 * Handle action if enable viewMoreShadow
                 * */
                var lineHeight = getTextNodeHeight(collapsibleContentEl.childNodes[0], (_a = custom === null || custom === void 0 ? void 0 : custom.enable) !== null && _a !== void 0 ? _a : false).lineHeight;
                var contentHeight = contentRef.current.scrollHeight + contentOffset;
                if (isExpand) {
                    var maxHeight = 0;
                    if (custom === null || custom === void 0 ? void 0 : custom.enable) {
                        maxHeight += lineHeight * (custom === null || custom === void 0 ? void 0 : custom.numberOfLine);
                        if (contentCollapseHeight !== maxHeight) {
                            setContentCollapseHeight(maxHeight);
                        }
                        return;
                    }
                }
                contentExpandHeightRef.current = contentHeight;
            }
        };
        document.fonts.ready.then(function () {
            handleExpandContent();
        });
        // Observe changes of collapsible content
        if (collapsibleContentRef.current) {
            var observer_1 = new MutationObserver(handleExpandContent);
            observer_1.observe(collapsibleContentRef.current, {
                childList: true,
                subtree: true
            });
            return function () {
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [isExpand, expand, children, contentCollapseHeight]);
    // Handle transition of collapsible
    var styles = (0,useTransition/* default */.Z)({
        open: !isExpand,
        args: {
            expandHeight: contentExpandHeightRef.current,
            collapseHeight: contentCollapseHeight,
            enableCustom: (custom === null || custom === void 0 ? void 0 : custom.enable) || false
        }
    }, {
        initial: function (_a) {
            var collapseHeight = _a.collapseHeight, enableCustom = _a.enableCustom;
            return {
                height: collapseHeight,
                opacity: enableCustom ? 1 : 0
            };
        },
        enter: function (_a) {
            var expandHeight = _a.expandHeight;
            return {
                height: expandHeight,
                opacity: 1
            };
        },
        entered: {
            height: 'auto',
            opacity: 1
        },
        beforeLeave: function (_a) {
            var expandHeight = _a.expandHeight;
            return {
                height: expandHeight,
                opacity: 1
            };
        },
        leave: function (_a) {
            var collapseHeight = _a.collapseHeight, enableCustom = _a.enableCustom;
            return {
                height: collapseHeight,
                opacity: enableCustom ? 1 : 0
            };
        }
    }).styles;
    var handleHeaderAction = (0,react.useCallback)(function () {
        setExpand(function (prevState) {
            onChange && onChange(!prevState);
            return !prevState;
        });
    }, [onChange]);
    return (react.createElement(Container, (0,_tslib/* __assign */.pi)({ isExpand: isExpand, haveDefaultBackgroundColor: haveDefaultBackgroundColor }, rest),
        react.createElement(AccordionSummary, { className: 'accordion__summary', onClick: handleHeaderAction, "$isHaveExpandIcon": isHaveExpandIcon },
            TitleComponent,
            expandIcon ? (react.createElement(IconWrapper, { className: 'accordion__summary--icon', isExpand: isExpand }, expandIcon)) : null),
        react.createElement(AccordionDetails, { ref: collapsibleContentRef, isExpand: isExpand, style: styles },
            react.createElement("div", { style: { marginTop: contentOffset }, ref: contentRef }, children))));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 6687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AlertIcon/index.js
'use client';



var AlertIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#FF4A53' : _b;
    return (react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z', stroke: color, strokeWidth: '0.64', strokeLinecap: 'round' }),
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10.8192 6.31817C11.0628 5.89626 11.5129 5.63635 12.0001 5.63635C12.4873 5.63635 12.9375 5.89626 13.1811 6.31817C13.4246 6.74008 13.4246 7.2599 13.1811 7.68181C12.9375 8.10372 12.4873 8.36363 12.0001 8.36363C11.5129 8.36363 11.0628 8.10372 10.8192 7.68181C10.5756 7.2599 10.5756 6.74008 10.8192 6.31817ZM12.9092 10.1818H11.091V17.9091H12.9092V10.1818Z', fill: color }),
        react.createElement("path", { d: 'M10.6365 10.3164H10.3165V10.9564H10.6365V10.3164ZM12.4547 10.9564H12.7747V10.3164H12.4547V10.9564ZM10.6365 17.1345H10.3165V17.7745H10.6365V17.1345ZM13.3637 17.7745H13.6837V17.1345H13.3637V17.7745ZM10.6365 10.9564H12.4547V10.3164H10.6365V10.9564ZM10.6365 17.7745H13.3637V17.1345H10.6365V17.7745Z', fill: color })));
};
var AlertIcon$1 = /*#__PURE__*/ react.memo(AlertIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveIcon/index.js
var RemoveIcon = __webpack_require__(10786);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Alert/Alert.css.js
'use client';





var hiding = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    100% {\n        opacity: 0;\n        display: none;\n    }\n"], ["\n    100% {\n        opacity: 0;\n        display: none;\n    }\n"])));
var AlertWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    padding-left: ", ";\n    padding-right: ", ";\n    border: 1px solid;\n    border-radius: 6px;\n    font-size: 14px;\n    line-height: 22px;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    padding-left: ", ";\n    padding-right: ", ";\n    border: 1px solid;\n    border-radius: 6px;\n    font-size: 14px;\n    line-height: 22px;\n    ", "\n    ", "\n"])), function (_a) {
    var isHaveIcon = _a.isHaveIcon;
    return (isHaveIcon ? '50px' : '16px');
}, function (_a) {
    var isHaveClose = _a.isHaveClose;
    return (isHaveClose ? '50px' : '16px');
}, function (_a) {
    var type = _a.type;
    switch (type) {
        case 'warning':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #fdf2cd;\n                    border: 1px solid ", ";\n                "], ["\n                    background-color: #fdf2cd;\n                    border: 1px solid ", ";\n                "])), constants/* colors.highlightColor */.O9.highlightColor);
        case 'error':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #ffdbdd;\n                    border: 1px solid ", ";\n                "], ["\n                    background-color: #ffdbdd;\n                    border: 1px solid ", ";\n                "])), constants/* colors.dangerColor */.O9.dangerColor);
        case 'info':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #ecf8ff;\n                    border: 1px solid ", ";\n                "], ["\n                    background-color: #ecf8ff;\n                    border: 1px solid ", ";\n                "])), constants/* colors.infoColor */.O9.infoColor);
        case 'success':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #e2f1d2;\n                    border: 1px solid ", ";\n                "], ["\n                    background-color: #e2f1d2;\n                    border: 1px solid ", ";\n                "])), constants/* colors.successColor */.O9.successColor);
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #e2f1d2;\n                    border: 1px solid ", ";\n                "], ["\n                    background-color: #e2f1d2;\n                    border: 1px solid ", ";\n                "])), constants/* colors.successColor */.O9.successColor);
    }
}, function (_a) {
    var isClosed = _a.isClosed;
    return isClosed && (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            opacity: 1;\n            animation: ", " 0.25s;\n        "], ["\n            opacity: 1;\n            animation: ", " 0.25s;\n        "])), hiding);
});
var Icon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 14px;\n    left: 14px;\n    display: inline-flex;\n"], ["\n    position: absolute;\n    top: 14px;\n    left: 14px;\n    display: inline-flex;\n"])));
var CloseButton = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 6px;\n    top: 13px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 6px;\n    top: 13px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


//# sourceMappingURL=Alert.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Alert/index.js
'use client';







var Alert = /*#__PURE__*/ react.memo(function (props) {
    var type = props.type, children = props.children, style = props.style, onClick = props.onClick, onClickClose = props.onClickClose, _a = props.isHaveClose, isHaveClose = _a === void 0 ? true : _a, iconType = props.iconType;
    var _b = (0,react.useState)(false), isClosed = _b[0], setClose = _b[1];
    var _c = (0,react.useState)(false), isRemoved = _c[0], setRemove = _c[1];
    var getColor = function () {
        switch (type) {
            case 'success':
                return constants/* colors.successColor */.O9.successColor;
            case 'error':
                return constants/* colors.dangerColor */.O9.dangerColor;
            case 'info':
                return constants/* colors.infoColor */.O9.infoColor;
            case 'warning':
                return constants/* colors.highlightColor */.O9.highlightColor;
            default:
                return constants/* colors.successColor */.O9.successColor;
        }
    };
    var handleOnClick = (0,react.useCallback)(function () {
        onClick && onClick();
    }, [onClick]);
    var handleOnClose = (0,react.useCallback)(function () {
        setClose(true);
        onClickClose && onClickClose();
    }, [onClickClose]);
    return isRemoved ? (react.createElement(react.Fragment, null)) : (react.createElement(AlertWrapper, { isClosed: isClosed, type: type, style: style, onClick: handleOnClick, onAnimationEnd: function () { return setRemove(true); }, isHaveClose: isHaveClose, isHaveIcon: !!iconType },
        iconType === 'warning' && (react.createElement(Icon, null,
            react.createElement(AlertIcon$1, { color: getColor() }))),
        react.createElement("div", null, children),
        isHaveClose && (react.createElement(CloseButton, { onClick: handleOnClose },
            react.createElement(RemoveIcon/* default */.Z, null)))));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 80832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getLastUpload; },
/* harmony export */   "R": function() { return /* binding */ getDefaultResume; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46641);
'use client';



/**
 * Get last uploaded attach file from resumeInfo list
 * @param resumeInfo List of resume file
 * @returns single attach that is last uploaded
 */
function getLastUpload(resumeInfo) {
    if (!(resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.attributes)) {
        return null;
    }
    var attachResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .EResumeType.ATTACH */ .lY.ATTACH; });
    if (attachResumes.length === 0) {
        return null;
    }
    // Case 1.4: Have both online and attach resume => get latest update
    var sortedAttachResumes = JSON.parse(JSON.stringify(attachResumes)).sort(function (a, b) {
        return new Date(b === null || b === void 0 ? void 0 : b.lastProcessedOn).getTime() - new Date(a === null || a === void 0 ? void 0 : a.lastProcessedOn).getTime();
    });
    // Latest update is first item in array
    if (sortedAttachResumes.length > 0) {
        return sortedAttachResumes[0];
    }
    return null;
}
/**
 * Get default resume (online or attach)
 * @param resumeInfo List of resume file
 * @returns single default selected resume (online or attach)
 */
function getDefaultResume(resumeInfo) {
    if (!(resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.attributes)) {
        return null;
    }
    var lastAppliedResumes = resumeInfo.attributes.filter(function (item) { return item.isLastApplied; });
    var isHaveLastApplied = lastAppliedResumes.length > 0;
    // Case 2: Get last applied resume
    if (isHaveLastApplied) {
        // Last applied is online profile and must be allowSearchableDisplay
        if (!lastAppliedResumes[0].isAttach && lastAppliedResumes[0].allowSearchableDisplay !== _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ALLOW_SEARCHABLE */ .b2) {
            return null;
        }
        return lastAppliedResumes[0];
    }
    // Case 1: Don't have applied resume
    // Case 1.1: Don't have any resume
    var isHaveResume = resumeInfo.attributes.length > 0;
    if (!isHaveResume) {
        return null;
    }
    // Online
    var onlineResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .EResumeType.ONLINE */ .lY.ONLINE; });
    var isHaveOnline = onlineResumes.length > 0;
    // Attach
    var attachResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .EResumeType.ATTACH */ .lY.ATTACH; });
    var isHaveAttach = attachResumes.length > 0;
    // Case 1.2: Have online resume but don't have attach resume
    // Online resume must allowSearchableDisplay (approved)
    if (isHaveOnline && !isHaveAttach && onlineResumes[0].allowSearchableDisplay === _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ALLOW_SEARCHABLE */ .b2) {
        return onlineResumes[0];
    }
    // Case 1.3: Have attach resume but don't have online resume
    if (!isHaveOnline && isHaveAttach) {
        return attachResumes[0];
    }
    // Case 1.4: Have both online and attach resume => get latest update
    return getLastUpload(resumeInfo);
}


//# sourceMappingURL=getDefaultResume.js.map


/***/ }),

/***/ 46641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ah": function() { return /* binding */ nationalityList; },
/* harmony export */   "CI": function() { return /* binding */ HTTP_CODE_SUCCESS; },
/* harmony export */   "DE": function() { return /* binding */ DEFAULT_MIN_SALARY; },
/* harmony export */   "DU": function() { return /* binding */ OTHER_CITY_ID; },
/* harmony export */   "F6": function() { return /* binding */ INTERNATIONAL_CITY_ID; },
/* harmony export */   "Fp": function() { return /* binding */ HRINSIDER_ATTACH_RESUME_LINK; },
/* harmony export */   "JI": function() { return /* binding */ JOB_TITLE_LENGTH; },
/* harmony export */   "Jb": function() { return /* binding */ VIETNAM_COUNTRY_ID; },
/* harmony export */   "Lx": function() { return /* binding */ IS_REQUIRED_COVER_LETTER; },
/* harmony export */   "Nk": function() { return /* binding */ DEFAULT_COMPANY_LOGO; },
/* harmony export */   "T0": function() { return /* binding */ DIRECTOR_LEVEL; },
/* harmony export */   "Wx": function() { return /* binding */ DEFAULT_ALLOW_EXT; },
/* harmony export */   "X4": function() { return /* binding */ DEFAULT_MAX_SALARY; },
/* harmony export */   "Xh": function() { return /* binding */ IS_RESUME_ATTACHMENT; },
/* harmony export */   "b2": function() { return /* binding */ ALLOW_SEARCHABLE; },
/* harmony export */   "dv": function() { return /* binding */ INTERNSHIP_ID; },
/* harmony export */   "fs": function() { return /* binding */ INTERN_LEVEL; },
/* harmony export */   "gW": function() { return /* binding */ COLLAPSE_ANIMATION_DURATION; },
/* harmony export */   "h9": function() { return /* binding */ MAX_NUMBER_OF_CV; },
/* harmony export */   "jH": function() { return /* binding */ FRESHER_LEVEL; },
/* harmony export */   "jR": function() { return /* binding */ MEKONG_CITY_ID; },
/* harmony export */   "jY": function() { return /* binding */ META_API_LINK; },
/* harmony export */   "kH": function() { return /* binding */ LIMIT_CHARACTERS; },
/* harmony export */   "lY": function() { return /* binding */ EResumeType; },
/* harmony export */   "mx": function() { return /* binding */ MODAL_SCROLLABLE_BODY_MODAL; },
/* harmony export */   "s5": function() { return /* binding */ FORM_FIELD_ERROR_CONTROL; },
/* harmony export */   "tw": function() { return /* binding */ NAME_LENGTH; },
/* harmony export */   "vI": function() { return /* binding */ educations; },
/* harmony export */   "vs": function() { return /* binding */ LIMIT_MODAL_HEIGHT; },
/* harmony export */   "wK": function() { return /* binding */ MANAGER_LEVEL; },
/* harmony export */   "yE": function() { return /* binding */ FRESHER_ID; },
/* harmony export */   "zR": function() { return /* binding */ EFormFieldIDs; }
/* harmony export */ });
'use client';

/*
 * Global constant
 * */
var _a;
var HRINSIDER_ATTACH_RESUME_LINK = 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html';
var LIMIT_CHARACTERS = 5000;
var DEFAULT_ALLOW_EXT = ['.doc', '.docx', '.pdf'];
var MAX_NUMBER_OF_CV = 3;
var IS_REQUIRED_COVER_LETTER = 1;
var IS_RESUME_ATTACHMENT = 1;
var HTTP_CODE_SUCCESS = 200;
var DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;
var MODAL_SCROLLABLE_BODY_MODAL = 'SCROLLABLE_BODY_MODAL';
/*
 * Styles constant
 * */
var LIMIT_MODAL_HEIGHT = 350;
var COLLAPSE_ANIMATION_DURATION = 250;
/*
 * Application information constant
 * */
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var JOB_TITLE_LENGTH = 80;
var NAME_LENGTH = 50;
/*
 * Working preference constant
 * */
var DEFAULT_MIN_SALARY = 0;
var DEFAULT_MAX_SALARY = 500000;
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var META_API_LINK = 'meta/v1.0/international-phone-number';
var nationalityList = function (langCode) {
    var nationalityList = {
        en: [
            { id: 1, name: 'Local Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    };
    return nationalityList[langCode];
};
var educations = [
    { id: 2, name: 'Trung học', nameEn: 'High school' },
    { id: 3, name: 'Trung cấp', nameEn: "Associate's degree" },
    { id: 12, name: 'Cao đẳng', nameEn: 'College' },
    { id: 4, name: 'Cử nhân', nameEn: 'Bachelors' },
    { id: 5, name: 'Thạc sĩ', nameEn: 'Masters' },
    { id: 6, name: 'Tiến sĩ', nameEn: 'Doctorate' },
    { id: 11, name: 'Khác', nameEn: 'Others' }
];
/*
 * Form control constants
 * */
var EFormFieldIDs;
(function (EFormFieldIDs) {
    EFormFieldIDs["yourResume"] = "YOUR_RESUME";
    EFormFieldIDs["coverLetter"] = "COVER_LETTER";
    EFormFieldIDs["applicationInfomation"] = "APPLICATION_INFOMATION";
    EFormFieldIDs["workingPreferences"] = "WORKING_PREFERENCES";
})(EFormFieldIDs || (EFormFieldIDs = {}));
var FORM_FIELD_ERROR_CONTROL = (_a = {},
    _a[EFormFieldIDs.yourResume] = new Set(['applyResume']),
    _a[EFormFieldIDs.coverLetter] = new Set(['coverLetter']),
    _a[EFormFieldIDs.applicationInfomation] = new Set([
        'firstName',
        'lastName',
        'jobTitle',
        'currentJobFunction',
        'currentIndustries',
        'currentSalary',
        'jobLevelId',
        'yearsExperience',
        'highestDegreeId',
        'phone',
        'birthday',
        'nationalityId',
        'genderId',
        'maritalStatusId',
        'levelLocations'
    ]),
    _a[EFormFieldIDs.workingPreferences] = new Set([
        'locations',
        'companyIndustries',
        'salary',
        'benefits',
        'jobFunction',
        'desiredJobLevelId'
    ]),
    _a);
var EResumeType;
(function (EResumeType) {
    EResumeType[EResumeType["ONLINE"] = 0] = "ONLINE";
    EResumeType[EResumeType["ATTACH"] = 1] = "ATTACH";
})(EResumeType || (EResumeType = {}));
var ALLOW_SEARCHABLE = 1;


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 83699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ApplyJobs; }
});

// UNUSED EXPORTS: ApplyJobForm, ApplyJobsProvider

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/store/provider.js + 1 modules
var provider = __webpack_require__(45650);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/constants.js
var constants = __webpack_require__(46641);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/styles.js
'use client';









var ModalContainer = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: ", ";\n"], ["\n    background-color: ", ";\n"])), Colors/* colors.neutral.99 */.O9.neutral[99]);
var LeftLayout = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n"], ["\n    padding: 16px;\n"])));
var RightLayout = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: calc(100vh - ", "px);\n    overflow-y: auto;\n    background-color: #fff;\n    padding: 16px;\n    ", "\n    @media (max-width: 768px) {\n        height: unset;\n    }\n"], ["\n    height: calc(100vh - ", "px);\n    overflow-y: auto;\n    background-color: #fff;\n    padding: 16px;\n    ", "\n    @media (max-width: 768px) {\n        height: unset;\n    }\n"])), constants/* LIMIT_MODAL_HEIGHT */.vs, styledCss/* default.scrollbar */.ZP.scrollbar);
styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    & > svg {\n        flex-shrink: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    & > svg {\n        flex-shrink: 0;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


//# sourceMappingURL=styles.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/translations.js
var translations = __webpack_require__(54028);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/deepEqual.js
var deepEqual = __webpack_require__(17312);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PopupWarning/index.js + 2 modules
var PopupWarning = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(6017);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(36802);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/index.js
var resumes = __webpack_require__(93843);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var Utils_constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(82100);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/types.js
var types = __webpack_require__(53877);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/index.js + 1 modules
var jobs = __webpack_require__(10650);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/helper.js
var helper = __webpack_require__(4488);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/tracking/applyJob.js
var applyJob = __webpack_require__(25491);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/services/update-info.js
'use client';





var UPDATE_INFO_API = '/api-gateway/v1.0/profile/basic-info';
function updateUserInfo(params, body) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, data, error_1, data;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(params.baseMsUrl + UPDATE_INFO_API, {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(params.accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': params.langCode
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, data];
                    }
                    return [2 /*return*/, new model/* default */.Z({
                            error: {
                                message: data.message || data.error || ''
                            }
                        })];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.message === 'Timeout' ||
                        error_1.message === 'Network request failed' ||
                        error_1.message === 'Failed to fetch') {
                        data = {
                            data: {
                                ERR_INTERNET_DISCONNECTED: 'ERR_INTERNET_DISCONNECTED'
                            },
                            error: {
                                message: params.langCode === Utils_constants/* ELanguage.EN */.Df.EN
                                    ? 'No internet connection. Please check your internet connection and try again.'
                                    : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.',
                                status: 503
                            }
                        };
                        return [2 /*return*/, new model/* default */.Z(data)];
                    }
                    return [2 /*return*/, new model/* default */.Z(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=update-info.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/index.js
'use client';



























var ApplyJobForm = react.lazy(function () { return __webpack_require__.e(/* import() */ 986).then(__webpack_require__.bind(__webpack_require__, 46986)); });
var JobInfoCard = react.lazy(function () { return __webpack_require__.e(/* import() */ 520).then(__webpack_require__.bind(__webpack_require__, 94520)); });
var ModalFooter = react.lazy(function () { return __webpack_require__.e(/* import() */ 566).then(__webpack_require__.bind(__webpack_require__, 16566)); });
function ApplyJobsMain(_a) {
    var _this = this;
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose;
    /*
     * Store
     * */
    var props = (0,provider/* useApplyJobsProps */.OG)();
    var tracking = (0,useHog/* default */.Z)().tracking;
    /*
     * State
     * */
    var _c = (0,react.useState)(null), jobLevels = _c[0], setJobLevels = _c[1];
    var _d = (0,react.useState)(false), isLoading = _d[0], setLoading = _d[1];
    var _e = (0,react.useState)(false), showPopupApply = _e[0], setShowPopupApply = _e[1];
    var _f = (0,react.useState)(false), showPopupWarning = _f[0], setShowPopupWarning = _f[1];
    var _g = (0,react.useState)(''), errorSystemMessage = _g[0], setErrorSystemMessage = _g[1];
    var _h = (0,react.useState)(0), footerHeight = _h[0], setFooterHeight = _h[1];
    /*
     * Refs and values
     * */
    var scrollSectionRef = (0,react.useRef)(null);
    var scrollContainerRef = (0,react.useRef)(null);
    var formRef = (0,react.useRef)(null);
    var mobileBreakpoint = (0,useMediaQuery/* default */.Z)('(max-width: 768px)');
    var errorSystemRef = (0,react.useRef)(null);
    var modalFooterRef = (0,react.useRef)(null);
    /*
     * Get job levels and open popup
     * */
    var handlePopupAction = (0,react.useCallback)(function () {
        var _a, _b, _c, _d;
        var isUserLowLevel = ((_a = props.user) === null || _a === void 0 ? void 0 : _a.jobLevelId) === constants/* INTERN_LEVEL */.fs || ((_b = props.user) === null || _b === void 0 ? void 0 : _b.jobLevelId) === constants/* FRESHER_LEVEL */.jH;
        var isJobHighLevel = ((_c = props.jobInfo) === null || _c === void 0 ? void 0 : _c.jobLevelId) === constants/* MANAGER_LEVEL */.wK || ((_d = props.jobInfo) === null || _d === void 0 ? void 0 : _d.jobLevelId) === constants/* DIRECTOR_LEVEL */.T0;
        var isAllowApplyJobs = !(isJobHighLevel && isUserLowLevel);
        if (isAllowApplyJobs) {
            setShowPopupApply(isOpen);
        }
        else {
            setShowPopupWarning(isOpen);
        }
    }, [props.user, props.jobInfo, isOpen]);
    (0,react.useEffect)(function () {
        if (isOpen) {
            if (!jobLevels || jobLevels.length < 1) {
                (function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var jobLevels;
                    var _a;
                    return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, (0,resumes/* getJobLevelList */.e1)(props.langCode, (_a = props.baseMsUrl) !== null && _a !== void 0 ? _a : '')];
                            case 1:
                                jobLevels = _b.sent();
                                if (jobLevels && jobLevels.length > 0) {
                                    setJobLevels(jobLevels);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
            handlePopupAction();
        }
    }, [props.langCode, props.baseMsUrl, isOpen, jobLevels, handlePopupAction]);
    /*
     * Get footer height
     * */
    (0,react.useEffect)(function () {
        var getFooterHeight = function () {
            var _a;
            setFooterHeight(((_a = modalFooterRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
        };
        if (modalFooterRef.current) {
            getFooterHeight();
            var observer_1 = new MutationObserver(getFooterHeight);
            observer_1.observe(modalFooterRef.current, {
                childList: true,
                subtree: true
            });
            return function () {
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [modalFooterRef.current]);
    /**
     * Get scroll container
     * */
    (0,react.useEffect)(function () {
        var scrollableBodyModal = document.querySelector(".".concat(constants/* MODAL_SCROLLABLE_BODY_MODAL */.mx));
        scrollContainerRef.current = mobileBreakpoint ? scrollableBodyModal : scrollSectionRef.current;
    });
    /*
     * Scroll to system error if has
     * */
    (0,react.useEffect)(function () {
        if (errorSystemMessage && errorSystemRef.current) {
            errorSystemRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [errorSystemMessage]);
    /*
     * Scroll to warning status
     * */
    (0,react.useEffect)(function () {
        if (errorSystemMessage) {
            if (scrollContainerRef.current) {
                var scrollContainer_1 = scrollContainerRef.current;
                /*
                 * Get scrolling container
                 * */
                var scrollIntoError = function () {
                    scrollContainer_1.scrollTo({ top: scrollContainer_1.scrollHeight, behavior: 'smooth' });
                };
                var timeOut_1 = setTimeout(scrollIntoError, constants/* COLLAPSE_ANIMATION_DURATION */.gW);
                return function () {
                    clearTimeout(timeOut_1);
                };
            }
        }
        return function () { };
    }, [errorSystemMessage]);
    var handleUserLevelName = (0,react.useCallback)(function () {
        var level = jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.find(function (level) { var _a; return level.id === ((_a = props.user) === null || _a === void 0 ? void 0 : _a.jobLevelId); });
        return props.langCode === Utils_constants/* ELanguage.EN */.Df.EN ? level === null || level === void 0 ? void 0 : level.attributes.nameEn : level === null || level === void 0 ? void 0 : level.attributes.nameVi;
    }, [props.langCode, jobLevels, props.user]);
    var handleSubmitForm = function (values) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var birthday, updateUserInfoBody, updateUserInfoResponse, initialValues, isUpdatedBasicInfo, isUpdatedWorkingPreference, updatedBlock, resumeType, body_1, jobSearchParams, apply, info, postHogProperties, ABAnalysis, link, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        return (0,_tslib/* __generator */.Jh)(this, function (_x) {
            switch (_x.label) {
                case 0:
                    if (!props.jobInfo) {
                        /*
                         * Return immediately if don't have job info
                         * */
                        return [2 /*return*/];
                    }
                    if (values.initialSubmitValues.applyResume.resumeId === -1) {
                        /*
                         * Scroll to error if resumeId equal -1
                         * */
                        if (scrollContainerRef.current) {
                            scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _x.label = 1;
                case 1:
                    _x.trys.push([1, 8, , 9]);
                    birthday = new Date(values.birthday).toISOString();
                    updateUserInfoBody = {
                        resumeId: 0,
                        currentJobFunction: values.currentJobFunction,
                        currentIndustries: values.currentIndustries,
                        currentSalary: values.currentSalary,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        jobTitle: values.jobTitle,
                        jobLevelId: values.jobLevelId,
                        highestDegreeId: values.highestDegreeId,
                        yearsExperience: values.yearsExperience,
                        email: values.email,
                        phone: values.phone,
                        birthday: birthday,
                        genderId: values.genderId,
                        countryId: values.countryId,
                        cityId: values.cityId,
                        address: values.address,
                        nationalityId: values.nationalityId,
                        maritalStatusId: values.maritalStatusId,
                        districtId: values.districtId,
                        locations: values.locations,
                        companyIndustries: values.companyIndustries,
                        desiredJobLevelId: values.desiredJobLevelId,
                        salary: values.salary,
                        benefits: values.benefits,
                        jobFunction: values.jobFunction
                    };
                    return [4 /*yield*/, updateUserInfo({ accessToken: props.accessToken, baseMsUrl: props.baseMsUrl, langCode: props.langCode }, updateUserInfoBody)
                        /*
                         * Handle error of updating information
                         * */
                    ];
                case 2:
                    updateUserInfoResponse = _x.sent();
                    /*
                     * Handle error of updating information
                     * */
                    if (updateUserInfoResponse instanceof model/* default */.Z) {
                        setLoading(false);
                        setErrorSystemMessage((_b = (_a = updateUserInfoResponse.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '');
                        return [2 /*return*/];
                    }
                    initialValues = values.initialSubmitValues.initialValues;
                    isUpdatedBasicInfo = !(0,deepEqual/* default */.Z)({
                        firstName: updateUserInfoBody.firstName,
                        lastName: updateUserInfoBody.lastName,
                        yearsExperience: updateUserInfoBody.yearsExperience,
                        highestDegreeId: updateUserInfoBody.highestDegreeId,
                        currentJobFunction: updateUserInfoBody.currentJobFunction,
                        currentIndustries: updateUserInfoBody.currentIndustries,
                        currentSalary: updateUserInfoBody.currentSalary,
                        jobLevelId: updateUserInfoBody.jobLevelId,
                        phone: updateUserInfoBody.phone,
                        nationalityId: updateUserInfoBody.nationalityId,
                        genderId: updateUserInfoBody.genderId,
                        maritalStatusId: updateUserInfoBody.maritalStatusId,
                        countryId: updateUserInfoBody.countryId
                    }, {
                        firstName: initialValues.firstName,
                        lastName: initialValues.lastName,
                        yearsExperience: initialValues.yearsExperience,
                        highestDegreeId: initialValues.highestDegreeId,
                        currentJobFunction: initialValues.currentJobFunction,
                        currentIndustries: initialValues.currentIndustries,
                        currentSalary: initialValues.currentSalary,
                        jobLevelId: initialValues.jobLevelId,
                        phone: initialValues.phone,
                        nationalityId: initialValues.nationalityId,
                        genderId: initialValues.genderId,
                        maritalStatusId: initialValues.maritalStatusId,
                        countryId: initialValues.countryId
                    });
                    isUpdatedWorkingPreference = !(0,deepEqual/* default */.Z)({
                        locations: updateUserInfoBody.locations,
                        benefits: updateUserInfoBody.benefits,
                        salary: updateUserInfoBody.salary,
                        desiredJobLevelId: updateUserInfoBody.desiredJobLevelId,
                        jobFunction: updateUserInfoBody.jobFunction,
                        companyIndustries: updateUserInfoBody.companyIndustries
                    }, {
                        locations: initialValues.locations,
                        benefits: initialValues.benefits,
                        salary: initialValues.salary,
                        desiredJobLevelId: initialValues.desiredJobLevelId,
                        jobFunction: initialValues.jobFunction,
                        companyIndustries: initialValues.companyIndustries
                    });
                    updatedBlock = [];
                    if (isUpdatedBasicInfo) {
                        updatedBlock.push('basicInfo');
                    }
                    if (isUpdatedWorkingPreference) {
                        updatedBlock.push('workingPreferences');
                    }
                    if (updatedBlock.length > 0) {
                        tracking({
                            eventName: 'js_profile_management:update_myprofile',
                            properties: {
                                fromPage: 'apply_form',
                                blockUpdated: updatedBlock.join(', ')
                            }
                        });
                    }
                    resumeType = ((_c = values.initialSubmitValues.applyResume.type) === null || _c === void 0 ? void 0 : _c.includes(types/* EApplyType.lastAttachment */.bf.lastAttachment))
                        ? types/* EApplyType.lastAttachment */.bf.lastAttachment
                        : values.initialSubmitValues.applyResume.type;
                    body_1 = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ 'jobIds[]': (_d = props.jobInfo) === null || _d === void 0 ? void 0 : _d.jobId, resumeId: (_f = (_e = values.initialSubmitValues.applyResume) === null || _e === void 0 ? void 0 : _e.resumeId) !== null && _f !== void 0 ? _f : 0, appliedType: resumeType }, (!values.coverLetter ? undefined : { coverLetter: values.coverLetter })), (((_g = props.user) === null || _g === void 0 ? void 0 : _g.userIp) ? { client_ip: (_h = props.user) === null || _h === void 0 ? void 0 : _h.userIp } : undefined));
                    jobSearchParams = (0,helper/* getJobUrlParams */.zj)((_k = (_j = props.jobInfo) === null || _j === void 0 ? void 0 : _j.jobUrl) !== null && _k !== void 0 ? _k : '');
                    return [4 /*yield*/, (0,jobs/* applyJobs */.m)((_l = props.baseMsUrl) !== null && _l !== void 0 ? _l : '', props.accessToken, body_1, props.langCode, jobSearchParams)
                        /*
                         * Handle error of apply job
                         * */
                    ];
                case 3:
                    apply = _x.sent();
                    /*
                     * Handle error of apply job
                     * */
                    if (apply instanceof model/* default */.Z) {
                        setLoading(false);
                        setErrorSystemMessage((_o = (_m = apply.error) === null || _m === void 0 ? void 0 : _m.message) !== null && _o !== void 0 ? _o : '');
                        return [2 /*return*/];
                    }
                    if (!(apply && (apply === null || apply === void 0 ? void 0 : apply["".concat(props.jobInfo.jobId)]))) return [3 /*break*/, 7];
                    info = apply === null || apply === void 0 ? void 0 : apply["".concat(props.jobInfo.jobId)];
                    if (!(info.code === 200)) return [3 /*break*/, 6];
                    // PostHog tracking
                    if (props.hogTracking) {
                        postHogProperties = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, props.hogTracking.properties), { resumeId: body_1.resumeId, resumeType: body_1.appliedType === types/* EApplyType.online */.bf.online ? 'online' : 'attachment', resumeLastedUpload: (_q = (_p = values.initialSubmitValues.resumeInfo) === null || _p === void 0 ? void 0 : _p.attributes.find(function (item) { return item.id === body_1.resumeId; })) === null || _q === void 0 ? void 0 : _q.lastProcessedOn, invitation: false });
                        // Tracking job invitation
                        if (props.jobInfo.jobInvitation && props.jobInfo.jobInvitation.jobInvitationId > 0) {
                            postHogProperties.invitationId = props.jobInfo.jobInvitation.jobInvitationId;
                        }
                        tracking({
                            eventName: 'js_job_management:job_apply_single_success' ,
                            properties: postHogProperties
                        }, {
                            transport: 'sendBeacon'
                        });
                    }
                    else {
                        tracking({
                            eventName: 'js_job_management:job_apply_preview_success',
                            properties: {
                                resumeId: body_1.resumeId,
                                resumeType: body_1.appliedType === types/* EApplyType.online */.bf.online ? 'online' : 'attachment',
                                jobId: (_r = props.jobInfo) === null || _r === void 0 ? void 0 : _r.jobId
                            }
                        }, {
                            transport: 'sendBeacon'
                        });
                    }
                    ABAnalysis = (0,cookie/* getCookie */.e)('ABJobAnalysis');
                    if (!(props.enableTracking && ABAnalysis)) return [3 /*break*/, 5];
                    // Wait for tracking first then redirect later
                    return [4 /*yield*/, (0,applyJob/* trackingABJobAnalysis */.y)((_s = props.baseMsUrl) !== null && _s !== void 0 ? _s : '', {
                            userId: (_u = (_t = props.user) === null || _t === void 0 ? void 0 : _t.userId) !== null && _u !== void 0 ? _u : -1,
                            version: ABAnalysis,
                            action: 'apply'
                        })];
                case 4:
                    // Wait for tracking first then redirect later
                    _x.sent();
                    _x.label = 5;
                case 5:
                    link = (0,helper/* applySuccessLink */.Vw)((_v = props.baseUrl) !== null && _v !== void 0 ? _v : '', props.translator, props.jobInfo);
                    setLoading(false);
                    setShowPopupApply(false);
                    onClose && onClose();
                    link && window.location.assign(link);
                    return [3 /*break*/, 7];
                case 6:
                    setErrorSystemMessage((_w = info.message) !== null && _w !== void 0 ? _w : '');
                    setLoading(false);
                    _x.label = 7;
                case 7:
                    setLoading(false);
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _x.sent();
                    console.error(error_1);
                    setLoading(false);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitError = (0,react.useCallback)(function (errorFieldId) {
        if (scrollContainerRef.current) {
            /*
             * Get scrolling container
             * */
            var scrollContainer = scrollContainerRef.current;
            var firstErrorElement = document.querySelector("#".concat(errorFieldId));
            scrollContainer.scrollTo({
                behavior: 'smooth',
                top: (firstErrorElement === null || firstErrorElement === void 0 ? void 0 : firstErrorElement.offsetTop) || 0
            });
        }
    }, []);
    return (react.createElement(react.Fragment, null,
        showPopupWarning ? (react.createElement(PopupWarning/* default */.Z, { isShow: showPopupWarning, langCode: props.langCode, onClose: function () {
                setShowPopupWarning(false);
                onClose && onClose();
            }, onAccept: function () {
                setShowPopupApply(true);
                setShowPopupWarning(false);
            }, title: props.translator('Application confirmation'), warningTxt: props.translator('Do you want to continue to apply?') },
            props.translator('Your current job level'),
            ": ", (_b = handleUserLevelName()) !== null && _b !== void 0 ? _b : '',
            "\u00A0",
            props.translator('is not matching to this job requirement'),
            ".")) : null,
        react.createElement(Popup/* default */.Z, { onClose: function () {
                setShowPopupApply(false);
                setShowPopupWarning(false);
                setErrorSystemMessage('');
                onClose && onClose();
            }, onClickOutside: function () {
                setShowPopupApply(false);
                setShowPopupWarning(false);
                setErrorSystemMessage('');
                onClose && onClose();
            }, text: {
                header: props.translator('Apply job')
            }, isShow: showPopupApply, lang: props.langCode, styleOption: { size: 'lg' }, custom: {
                additionalFooterHeight: footerHeight,
                footer: (react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                    react.createElement(ModalFooter, { ref: modalFooterRef, isLoading: isLoading, onApply: function () { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit(); } }))),
                bodyClass: constants/* MODAL_SCROLLABLE_BODY_MODAL */.mx
            } },
            react.createElement(ModalContainer, { footerHeight: footerHeight },
                react.createElement(LeftLayout, { xs: 24, sm: 8 },
                    react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                        react.createElement(JobInfoCard, null))),
                react.createElement(RightLayout, { xs: 24, sm: 'fill', ref: scrollSectionRef },
                    react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                        react.createElement(ApplyJobForm, { ref: formRef, handleSubmit: handleSubmitForm, handleSumbitError: handleSubmitError, errorSystemMessage: errorSystemMessage, onCloseErrorSystemMessage: setErrorSystemMessage, requestScrollToFirstErrorElement: true })))))));
}
function ApplyJobs(props) {
    var isMobile = (0,useMediaQuery/* default */.Z)('(max-width: 768px)') || false;
    return (react.createElement(provider/* default */.ZP, { globalProps: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, props), { translator: (0,helpers/* createTranslator */.eX)({ translations: translations/* default */.Z, currentLanguage: props.langCode }), isMobile: isMobile }) },
        react.createElement(ApplyJobsMain, { isOpen: props.isOpen, onClose: props.onClose })));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getResume; },
/* harmony export */   "M": function() { return /* binding */ getProfileLevel; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _services_resumes_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93843);
'use client';




function getResume(params) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var accessToken, baseMsUrl, langCode, resumeSettingInfo, error_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    accessToken = params.accessToken, baseMsUrl = params.baseMsUrl, langCode = params.langCode;
                    return [4 /*yield*/, (0,_services_resumes_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getResumeSettingInfo */ .Z0)(accessToken, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', langCode)];
                case 1:
                    resumeSettingInfo = _a.sent();
                    if (!resumeSettingInfo) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, resumeSettingInfo];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getProfileLevel(params) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var baseMsUrl, langCode, accessToken, response, data, err_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    baseMsUrl = params.baseMsUrl, langCode = params.langCode, accessToken = params.accessToken;
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/api-gateway/v1.0/profile/level"), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=your-resume.js.map


/***/ }),

/***/ 45650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ApplyJobsProvider; },
  "Q8": function() { return /* binding */ useApplyJobsDispatch; },
  "OG": function() { return /* binding */ useApplyJobsProps; },
  "Wk": function() { return /* binding */ useApplyJobsState; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/types.js
var types = __webpack_require__(53877);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/constants.js
var constants = __webpack_require__(46641);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/store/reducer.js
'use client';





var initialState = {
    resumeInfo: null,
    workingPreference: null,
    applicationInformation: null,
    collapsiblesControl: new Set([
        constants/* EFormFieldIDs.yourResume */.zR.yourResume,
        constants/* EFormFieldIDs.coverLetter */.zR.coverLetter,
        constants/* EFormFieldIDs.applicationInfomation */.zR.applicationInfomation,
        constants/* EFormFieldIDs.workingPreferences */.zR.workingPreferences
    ]),
    errorsControl: [],
    submitControl: [],
    applyResume: {
        resumeId: -1,
        type: types/* EApplyType.none */.bf.none
    },
    justUploadedResumeId: -1,
    isSumitted: false
};
function reducer(state, action) {
    switch (action.type) {
        case 'setResumeSettingInfo':
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { resumeInfo: action.payload });
        case 'setSelectResume':
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { applyResume: action.payload });
        case 'setApplicationInformation':
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { applicationInformation: action.payload });
        case 'setWorkingPreference':
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { workingPreference: action.payload });
        case 'addCollapsibleControl': {
            var collapsibleControlValues_1 = state.collapsiblesControl;
            if (Array.isArray(action.payload)) {
                var filtedCollapsibleControlValues = action.payload.filter(function (item) { return !collapsibleControlValues_1.has(item); });
                if (filtedCollapsibleControlValues.length > 0) {
                    filtedCollapsibleControlValues.forEach(collapsibleControlValues_1.add, collapsibleControlValues_1);
                }
            }
            else {
                if (!state.collapsiblesControl.has(action.payload)) {
                    collapsibleControlValues_1.add(action.payload);
                }
            }
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { collapsiblesControl: collapsibleControlValues_1 });
        }
        case 'setCollapsibleControl': {
            var collapsibleControlValues = state.collapsiblesControl;
            if (state.collapsiblesControl.has(action.payload)) {
                collapsibleControlValues.delete(action.payload);
            }
            else {
                collapsibleControlValues.add(action.payload);
            }
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { collapsiblesControl: collapsibleControlValues });
        }
        case 'addErrorsControl': {
            var errorsControlValues = state.errorsControl;
            errorsControlValues.push(action.payload);
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { errorsControl: errorsControlValues });
        }
        case 'removeErrorsControl': {
            var errorsControlValues = state.errorsControl.filter(function (item) { return item !== action.payload; });
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { errorsControl: errorsControlValues });
        }
        case 'setResumeInfo': {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { resumeInfo: action.payload });
        }
        case 'setApplyResume': {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { applyResume: action.payload });
        }
        case 'setJustUploadedResumeId': {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { justUploadedResumeId: action.payload });
        }
        case 'addSubmitControl': {
            var submitControlValues = state.submitControl;
            submitControlValues.push(action.payload);
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { submitControl: submitControlValues });
        }
        case 'deleteSubmitControl': {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { submitControl: [] });
        }
        case 'setSumitted': {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isSumitted: action.payload });
        }
        default:
            return state;
    }
}


//# sourceMappingURL=reducer.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var Utils_constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/store/provider.js
'use client';





var ApplyJobsContext = react.createContext({
    state: initialState,
    dispatch: function () { return null; },
    globalProps: {
        accessToken: '',
        langCode: Utils_constants/* ELanguage.VI */.Df.VI,
        translator: function () { return ''; },
        user: null,
        jobInfo: null,
        baseMsUrl: '',
        baseUrl: '',
        multiple: false,
        initData: {
            locations: [],
            jobFunctions: { parent: [], child: {} },
            companyIndustries: [],
            jobLevels: [],
            educations: [],
            countries: [],
            cities: [],
            districts: {},
            benefits: []
        },
        isMobile: false,
        enableTracking: false
    }
});
function useApplyJobsState() {
    return react.useContext(ApplyJobsContext).state;
}
function useApplyJobsDispatch() {
    return react.useContext(ApplyJobsContext).dispatch;
}
function useApplyJobsProps() {
    return react.useContext(ApplyJobsContext).globalProps;
}
function ApplyJobsProvider(_a) {
    var children = _a.children, globalProps = _a.globalProps;
    var _b = react.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    return react.createElement(ApplyJobsContext.Provider, { value: { state: state, dispatch: dispatch, globalProps: globalProps } }, children);
}


//# sourceMappingURL=provider.js.map


/***/ }),

/***/ 54028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ translations; }
/* harmony export */ });
'use client';

var translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Please upload your attached CV to apply': 'Vui lòng đính kèm CV của bạn để ứng tuyển',
    'Upload your attached CV to apply': 'Đính kèm CV của bạn để ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks profile': 'Hồ sơ VietnamWorks',
    'Profile online': 'Hồ sơ trực tuyến',
    'Attached resume': 'Hồ sơ đính kèm',
    'Completed:': 'Hoàn thiện:',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'This is not a valid number.': 'Số không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    'Attached CV': 'Hồ Sơ Đính Kèm',
    'CV Just Uploaded': 'Hồ Sơ Vừa Tải Lên',
    'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:': 'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:',
    'Not enough information to use the function Allow Employers to search attached CV. Update information at': 'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại',
    'Profile settings': 'Thiết lập hồ sơ',
    'my-profile': 'ho-so',
    'profile-settings': 'thiet-lap-ho-so',
    'my-career-center': 'quan-ly-nghe-nghiep',
    'Updated:': 'Đã cập nhật:',
    'Uploaded:': 'Đã tải lên:',
    'Uploaded on:': 'Đã tải lên:',
    Update: 'Cập nhật',
    'Update profile': 'Cập nhật',
    'VietnamWorks online Profile': 'Hồ sơ online VietnamWorks',
    Resume: 'Resume',
    View: 'Xem',
    'View CV': 'Xem hồ sơ',
    Any: 'Bất kỳ',
    completed: 'hoàn thiện',
    'By Vietnamworks profile': 'Bằng hồ sơ Vietnamworks',
    'By attached CVs': 'Bằng hồ sơ đính kèm',
    Cancel: 'Huỷ',
    'Just uploaded': 'Vừa tải lên',
    'Job applied': 'Đã ứng tuyển',
    'Not approved': 'Chưa được duyệt',
    'preview-resume/': 'xem-truoc-ho-so/',
    'View as employer': 'Xem như nhà tuyển dụng',
    'Apply job': 'Ứng tuyển công việc',
    'View resume': 'Xem hồ sơ',
    'Delete resume': 'Xóa cv',
    'Expected Location': 'Nơi làm việc mong muốn',
    'Expected Function': 'Ngành nghề',
    'Expected Job Function': 'Ngành nghề',
    'Expected Industry': 'Lĩnh vực',
    'Expected Job Level': 'Cấp bậc mong muốn',
    'Expected Salary (USD per month)': 'Mức lương mong muốn (USD / tháng)',
    'Expected Salary': 'Mức lương mong muốn',
    'USD/month': 'USD/tháng',
    'Expected Top 5 Benefits': '5 Phúc Lợi Mong Muốn Nhất',
    'Please select...': 'Vui lòng chọn...',
    'First Name': 'Tên',
    'Last Name': 'Họ',
    'Enter your job title': 'Nhập chức danh của bạn',
    'Enter your first name': 'Nhập tên của bạn',
    'Enter your last name': 'Nhập họ của bạn',
    'Enter your address': 'Nhập địa chỉ của bạn',
    'Enter your current salary': 'Nhập mức lương hiện tại',
    'Enter your expected salary': 'Nhập mức lương mong muốn',
    'Enter your year experience': 'Nhập số năm kinh nghiệm',
    'No Result Found': 'Không Có Kết Quả Nào',
    'Years of experience': 'Số năm kinh nghiệm',
    Years: 'Năm',
    Search: 'Tìm',
    Year: 'Năm',
    'Current Job Level': 'Cấp bậc hiện tại',
    'Current Job Function': 'Ngành nghề hiện tại',
    'Current Industry': 'Lĩnh vực hiện tại',
    'Current Salary': 'Mức lương hiện tại',
    'Highest Education': 'Bằng cấp cao nhất',
    'Cell Number': 'Điện thoại',
    'Date of Birth': 'Ngày sinh',
    Nationality: 'Quốc tịch',
    'Marital Status': 'Tình trạng hôn nhân',
    'Country/ City/ District': 'Quốc gia/ Tỉnh thành/ Quận huyện',
    'Select your location': 'Chọn địa điểm của bạn',
    Location: 'Địa điểm',
    Address: 'Địa chỉ',
    Gender: 'Giới tính',
    'Select job function': 'Chọn ngành nghề',
    'You have selected the maximum number of benefits! Remove one to add another.': 'Bạn đã chọn tối đa số lượng phúc lợi! Xóa bớt để có thể chọn thêm.',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba nơi làm việc',
    'Your resume': 'Hồ sơ của bạn',
    'Working preference': 'Công việc mong muốn',
    'I agree to the': 'Tôi đồng ý với',
    'Privacy Policy': 'Quy định bảo mật',
    'of this employer.': 'của nhà tuyển dụng này.',
    'Please tick the checkbox if you want to proceed.': 'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.',
    'Application information': 'Thông tin ứng tuyển',
    Male: 'Nam',
    Female: 'Nữ',
    Single: 'Độc thân',
    Married: 'Đã kết hôn',
    'Apply now': 'Ứng tuyển',
    'Application confirmation': 'Xác nhận ứng tuyển',
    'Your current job level': 'Cấp bậc hiện tại của bạn',
    'is not matching to this job requirement': 'chưa phù hợp với yêu cầu công việc này',
    'Do you want to continue to apply?': 'Bạn có muốn tiếp tục nộp đơn?',
    '/success-apply': '/ung-tuyen-thanh-cong',
    '/my-profile': '/ho-so',
    'Please select an attachment to apply': 'Vui lòng chọn hồ sơ ứng tuyển',
    'Choose benefit': 'Chọn phúc lợi',
    '5 Expected Benefits': '5 phúc lợi mong muốn',
    'Enter salary': 'Nhập mức lương',
    Close: 'Đóng',
    'Accept invitation': 'Chấp nhận lời mời',
    Delete: 'Xoá',
    'Delete the attached CV': 'Xóa tập tin đính kèm',
    'Are you sure to delete it?': 'Bạn chắc chắn muốn xóa CV?',
    'The attached CV “{0}” will be deleted from our system.': 'CV đính kèm "{0}" sẽ được xóa khỏi hệ thống.',
    Success: 'Thành công',
    'Delete CV successfully': 'Xóa CV thành công',
    Searchable: 'Cho phép tìm kiếm',
    'Your CV is not able to process, please try another file.': 'Rất tiếc chúng tôi không thể xử lý CV của bạn, vui lòng chọn CV khác.',
    'We cannot process this file. Please ensure that the selected file contains the content of a CV and does not include too many images.': 'Chúng tôi không thể xử lý hồ sơ này. Hãy đảm bảo hồ sơ được chọn có chứa nội dung của một CV và không chứa quá nhiều hình ảnh.',
    'preview-resume': 'xem-truoc-ho-so'
};


//# sourceMappingURL=translations.js.map


/***/ }),

/***/ 36615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EJobInvitationStatus; }
/* harmony export */ });
'use client';

var EJobInvitationStatus;
(function (EJobInvitationStatus) {
    EJobInvitationStatus[EJobInvitationStatus["WAITING"] = 0] = "WAITING";
    EJobInvitationStatus[EJobInvitationStatus["ACCEPTED"] = 1] = "ACCEPTED";
    EJobInvitationStatus[EJobInvitationStatus["REJECTED"] = 2] = "REJECTED";
})(EJobInvitationStatus || (EJobInvitationStatus = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 79506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ HTTP_CODE_SUCCESS; },
/* harmony export */   "Fp": function() { return /* binding */ HRINSIDER_ATTACH_RESUME_LINK; },
/* harmony export */   "Lx": function() { return /* binding */ IS_REQUIRED_COVER_LETTER; },
/* harmony export */   "Wx": function() { return /* binding */ DEFAULT_ALLOW_EXT; },
/* harmony export */   "Xh": function() { return /* binding */ IS_RESUME_ATTACHMENT; },
/* harmony export */   "h9": function() { return /* binding */ MAX_NUMBER_OF_CV; },
/* harmony export */   "kH": function() { return /* binding */ LIMIT_CHARACTERS; }
/* harmony export */ });
'use client';

var HRINSIDER_ATTACH_RESUME_LINK = 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html';
var LIMIT_CHARACTERS = 5000;
var DEFAULT_ALLOW_EXT = ['.doc', '.docx', '.pdf'];
var MAX_NUMBER_OF_CV = 3;
var IS_REQUIRED_COVER_LETTER = 1;
var IS_RESUME_ATTACHMENT = 1;
var HTTP_CODE_SUCCESS = 200;


//# sourceMappingURL=const.js.map


/***/ }),

/***/ 35753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UW": function() { return /* binding */ dateToString; },
/* harmony export */   "Wb": function() { return /* binding */ hrefWowCV; },
/* harmony export */   "Yp": function() { return /* binding */ fileName; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; }
/* harmony export */ });
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96306);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79506);
'use client';




var hrefWowCV = function (_a) {
    var source = _a.source, langCode = _a.langCode, baseUrl = _a.baseUrl;
    return "".concat(baseUrl, "/wowcv").concat(langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.EN */ .Df.EN ? '/en' : '', "?utm_medium_navi=popup_apply_v2&utm_source_navi=").concat(source);
};
var formatDateTime = function (timestamp, type) {
    if (timestamp === 0)
        return '';
    var date = new Date(timestamp * 1000);
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (type) {
        case 'DDMMYYYY-HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' - ' + hours + ':' + minutes;
        case 'DDMMYYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return '';
    }
};
var dateToString = function (dateTime, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    var date;
    if (!dateTime) {
        date = new Date();
    }
    else {
        date = new Date(typeof dateTime === 'number' ? dateTime * 1000 : dateTime);
    }
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes;
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds();
    }
};
var fileName = function (fileName, maxLength) {
    if (maxLength === void 0) { maxLength = 15; }
    var name = '';
    var matchExt = '';
    // Find extension in filename
    _const_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ALLOW_EXT.map */ .Wx.map(function (extension) {
        if (fileName.indexOf(extension) > 0) {
            // Match
            matchExt = extension;
        }
    });
    var fileNameWithoutMatchExt = fileName.replace(matchExt, '');
    if (fileNameWithoutMatchExt.length > maxLength) {
        name = "".concat(fileNameWithoutMatchExt.slice(0, maxLength), "..");
    }
    else {
        name = fileNameWithoutMatchExt;
    }
    return "".concat(name).concat(matchExt);
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 77634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ SCREEN_WIDTH_MOBILE; },
/* harmony export */   "DL": function() { return /* binding */ VNW_TRACKING_GA_FIRST; },
/* harmony export */   "KK": function() { return /* binding */ VNW_TRACKING_GA; },
/* harmony export */   "T0": function() { return /* binding */ DIRECTOR_LEVEL; },
/* harmony export */   "bp": function() { return /* binding */ ADDITIONAL_HEIGHT_PRIVACY_POLICY; },
/* harmony export */   "c8": function() { return /* binding */ UNDEFINED_VALUE; },
/* harmony export */   "fs": function() { return /* binding */ INTERN_LEVEL; },
/* harmony export */   "jH": function() { return /* binding */ FRESHER_LEVEL; },
/* harmony export */   "rS": function() { return /* binding */ POLICY_ERROR; },
/* harmony export */   "wK": function() { return /* binding */ MANAGER_LEVEL; }
/* harmony export */ });
'use client';

var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;
var VNW_TRACKING_GA = 'VNW_TRACKING_GA';
var VNW_TRACKING_GA_FIRST = 'VNW_TRACKING_GA_FIRST';
// Additional height for privacy policy of Popup footer in responsive
var ADDITIONAL_HEIGHT_PRIVACY_POLICY = 72;
// Additional height for footer when privacy have error
var POLICY_ERROR = 50;
var UNDEFINED_VALUE = 'undefined';
var SCREEN_WIDTH_MOBILE = 768;


//# sourceMappingURL=const.js.map


/***/ }),

/***/ 63235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vw": function() { return /* binding */ applySuccessLink; },
/* harmony export */   "yC": function() { return /* binding */ getUTMTracking; },
/* harmony export */   "zj": function() { return /* binding */ getJobUrlParams; }
/* harmony export */ });
/* harmony import */ var _Utils_cookie_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6017);
/* harmony import */ var _Utils_urlBuilder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60332);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77634);
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55613);
'use client';






var getUTMTracking = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    try {
        var vnwTrackingGA = (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .e)(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .VNW_TRACKING_GA */ .KK);
        var vnwTrackingGAFirst = (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .e)(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .VNW_TRACKING_GA_FIRST */ .DL);
        var utmGA = JSON.parse(decodeURIComponent(vnwTrackingGA !== null && vnwTrackingGA !== void 0 ? vnwTrackingGA : '{}'));
        var queryParamsUtmGA = (0,_Utils_urlBuilder_js__WEBPACK_IMPORTED_MODULE_2__/* .objToQueryStr */ .G7)(utmGA);
        var headderUtmsGA = {
            'X-Tracking-UTM-Campaign': (_a = utmGA.utm_campaign) !== null && _a !== void 0 ? _a : '',
            'X-Tracking-UTM-Content': (_b = utmGA.utm_content) !== null && _b !== void 0 ? _b : '',
            'X-Tracking-UTM-Datetime': (_c = utmGA.utm_datetime) !== null && _c !== void 0 ? _c : '',
            'X-Tracking-UTM-Medium': (_d = utmGA.utm_medium) !== null && _d !== void 0 ? _d : '',
            'X-Tracking-UTM-Referer': (_e = utmGA.utm_referer) !== null && _e !== void 0 ? _e : '',
            'X-Tracking-UTM-Source': (_f = utmGA.utm_source) !== null && _f !== void 0 ? _f : '',
            'X-Tracking-UTM-Term': (_g = utmGA.utm_term) !== null && _g !== void 0 ? _g : '',
            'X-Tracking-UTM-Url': (_h = utmGA.utm_url) !== null && _h !== void 0 ? _h : ''
        };
        var utmGAFirst = JSON.parse(decodeURIComponent(vnwTrackingGAFirst !== null && vnwTrackingGAFirst !== void 0 ? vnwTrackingGAFirst : '{}'));
        var headerUtmsGAfirst = {
            'X-Tracking-UTM-Campaign-First': (_j = utmGAFirst.utm_campaign) !== null && _j !== void 0 ? _j : '',
            'X-Tracking-UTM-Content-First': (_k = utmGAFirst.utm_content) !== null && _k !== void 0 ? _k : '',
            'X-Tracking-UTM-Datetime-First': (_l = utmGAFirst.utm_datetime) !== null && _l !== void 0 ? _l : '',
            'X-Tracking-UTM-Medium-First': (_m = utmGAFirst.utm_medium) !== null && _m !== void 0 ? _m : '',
            'X-Tracking-UTM-Referer-First': (_o = utmGAFirst.utm_referer) !== null && _o !== void 0 ? _o : '',
            'X-Tracking-UTM-Source-First': (_p = utmGAFirst.utm_source) !== null && _p !== void 0 ? _p : '',
            'X-Tracking-UTM-Term-First': (_q = utmGAFirst.utm_term) !== null && _q !== void 0 ? _q : '',
            'X-Tracking-UTM-Url-First': (_r = utmGAFirst.utm_url) !== null && _r !== void 0 ? _r : ''
        };
        return {
            queryParamsUtmGA: queryParamsUtmGA,
            headderUtmsGA: headderUtmsGA,
            headerUtmsGAfirst: headerUtmsGAfirst
        };
    }
    catch (error) {
        console.log(error);
        return null;
    }
};
var getJobUrlParams = function (link) {
    if (!link)
        return '';
    var urlSearch = link.split('?');
    if (!urlSearch || urlSearch.length < 1)
        return '';
    return urlSearch[1];
};
var applySuccessLink = function (baseUrl, t, jobInfo) {
    if (typeof window === undefined)
        return;
    var searchParams = new URLSearchParams(window.location.href);
    var isHaveCompetitiveParam = !!searchParams.has('applycompetitive');
    var alias = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.alias) || (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .slugify */ .lV)((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobTitle) || '');
    var link = "".concat(baseUrl).concat(t('/success-apply'), "/").concat(alias, "-").concat(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId).concat(isHaveCompetitiveParam ? '?applycompetitive' : '');
    return link;
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 1247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Avatar/index.css.js
'use client';




var Box = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"], ["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"])));
var templateObject_1;


//# sourceMappingURL=index.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/DefaultAvatar/index.js
var DefaultAvatar = __webpack_require__(8083);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Avatar/index.js
'use client';






function Avatar(_a) {
    var image = _a.image, alt = _a.alt, rest = (0,_tslib/* __rest */._T)(_a, ["image", "alt"]);
    return react.createElement(Box, (0,_tslib/* __assign */.pi)({}, rest), image ? react.createElement("img", { src: image, alt: alt !== null && alt !== void 0 ? alt : 'avatar user' }) : react.createElement(DefaultAvatar/* default */.Z, { size: 88 }));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 25139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BadgeTag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/BadgeTag.css.js
'use client';





var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 2px 4px;\n    border-radius: 4px;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 500;\n\n    display: inline-flex;\n    align-items: center;\n\n    ", "\n"], ["\n    padding: 2px 4px;\n    border-radius: 4px;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 500;\n\n    display: inline-flex;\n    align-items: center;\n\n    ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case 'Hot':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: #fceded;\n                    color: #dc362e;\n                "], ["\n                    background: #fceded;\n                    color: #dc362e;\n                "])));
        case 'Urgent':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: #ffece6;\n                    color: #ff7d55;\n                "], ["\n                    background: #ffece6;\n                    color: #ff7d55;\n                "])));
        case 'Premium':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: #eff5ea;\n                    color: #418703;\n                    & > svg {\n                        margin-right: 4px;\n                    }\n                "], ["\n                    background: #eff5ea;\n                    color: #418703;\n                    & > svg {\n                        margin-right: 4px;\n                    }\n                "])));
        case 'Top management':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: #fff9ec;\n                    color: #ffaf00;\n                    & > svg {\n                        margin-right: 2px;\n                    }\n                "], ["\n                    background: #fff9ec;\n                    color: #ffaf00;\n                    & > svg {\n                        margin-right: 2px;\n                    }\n                "])));
        case 'Head hunter':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: #fceded;\n                    color: #dc362e;\n                    & > svg {\n                        margin-right: 4px;\n                    }\n                "], ["\n                    background: #fceded;\n                    color: #dc362e;\n                    & > svg {\n                        margin-right: 4px;\n                    }\n                "])));
        case 'New':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background: ", ";\n                    color: ", ";\n                "], ["\n                    background: ", ";\n                    color: ", ";\n                "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.40 */.O9.primary[40]);
        case 'Matching':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", ";\n                    & > svg {\n                        margin-right: 2px;\n                    }\n                "], ["\n                    color: ", ";\n                    & > svg {\n                        margin-right: 2px;\n                    }\n                "])), Colors/* colors.neutral.40 */.O9.neutral[40]);
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;


//# sourceMappingURL=BadgeTag.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/PremiumIcon.js
'use client';



var PremiumIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#418703' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7.11622 1.75C6.86868 1.75 6.63129 1.84833 6.45625 2.02337C6.28122 2.1984 6.18289 2.4358 6.18289 2.68333C6.18296 2.8524 6.22896 3.01827 6.31597 3.16323C6.40298 3.3082 6.52773 3.4268 6.6769 3.50638L4.83119 6.96719L2.32013 5.48971C2.40467 5.34639 2.44935 5.18307 2.44955 5.01667C2.44955 4.76913 2.35122 4.53173 2.17619 4.3567C2.00115 4.18167 1.76375 4.08333 1.51622 4.08333C1.26868 4.08333 1.03129 4.18167 0.856253 4.3567C0.681219 4.53173 0.582886 4.76913 0.582886 5.01667C0.582886 5.2642 0.681219 5.5016 0.856253 5.67663C1.03129 5.85167 1.26868 5.95 1.51622 5.95C1.54728 5.94973 1.57831 5.9479 1.60919 5.94453L1.98289 9.68333H3.38289H9.44955H10.8496H12.2496L12.6233 5.94544C12.6541 5.94851 12.6852 5.95003 12.7162 5.95C12.9638 5.95 13.2012 5.85167 13.3762 5.67663C13.5512 5.5016 13.6496 5.2642 13.6496 5.01667C13.6496 4.76913 13.5512 4.53173 13.3762 4.3567C13.2012 4.18167 12.9638 4.08333 12.7162 4.08333C12.4687 4.08333 12.2313 4.18167 12.0563 4.3567C11.8812 4.53173 11.7829 4.76913 11.7829 5.01667C11.7831 5.18307 11.8278 5.34639 11.9123 5.48971L9.40125 6.96719L7.55554 3.50638C7.70471 3.4268 7.82946 3.3082 7.91647 3.16323C8.00348 3.01827 8.04948 2.8524 8.04955 2.68333C8.04955 2.4358 7.95122 2.1984 7.77619 2.02337C7.60115 1.84833 7.36375 1.75 7.11622 1.75ZM1.98289 10.6167V11.55C1.98289 12.0657 2.40055 12.4833 2.91622 12.4833H11.3162C11.8319 12.4833 12.2496 12.0657 12.2496 11.55V10.6167H1.98289Z', fill: color })));
};


//# sourceMappingURL=PremiumIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/UrgentIcon.js
'use client';



var UrgentIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#FD7D55' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M5.36645 1.1665C5.25679 1.16655 5.15064 1.20521 5.06663 1.27572C4.98263 1.34622 4.92614 1.44405 4.90708 1.55205L3.51619 7.57497L3.5171 7.57588C3.50579 7.61623 3.49997 7.65793 3.49979 7.69984C3.49979 7.8236 3.54895 7.9423 3.63647 8.02982C3.72399 8.11734 3.84269 8.1665 3.96645 8.1665H6.53312L5.84223 12.7402C5.83609 12.7708 5.83304 12.802 5.83312 12.8332C5.83312 12.9569 5.88229 13.0756 5.9698 13.1632C6.05732 13.2507 6.17602 13.2998 6.29979 13.2998C6.38458 13.2997 6.46774 13.2765 6.54033 13.2326C6.61291 13.1888 6.67218 13.126 6.71177 13.051H6.71268L9.94289 7.04176L9.93833 7.03356C9.99357 6.95689 10.0331 6.86815 10.0331 6.7665C10.0331 6.5089 9.82405 6.29984 9.56645 6.29984H6.99979L8.5921 1.82458C8.61915 1.76439 8.63313 1.69915 8.63312 1.63317C8.63312 1.5094 8.58395 1.3907 8.49644 1.30319C8.40892 1.21567 8.29022 1.1665 8.16645 1.1665H5.36645Z', fill: color })));
};


//# sourceMappingURL=UrgentIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/TopManageIcon.js
'use client';



var TopManageIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#FFAF00' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7.35702 1.13576L8.69868 5.10803L12.8907 5.15656C13.2515 5.16076 13.4008 5.62043 13.1115 5.83556L9.74822 8.33876L10.9975 12.3409C11.1048 12.6853 10.7142 12.969 10.4197 12.7604L7.00002 10.3352L3.57982 12.76C3.28582 12.9686 2.89475 12.6844 3.00208 12.3404L4.25135 8.33829L0.888083 5.83509C0.598749 5.61996 0.748083 5.16029 1.10882 5.15609L5.30088 5.10756L6.64255 1.13529C6.75828 0.793692 7.24175 0.793692 7.35702 1.13576Z', fill: color })));
};


//# sourceMappingURL=TopManageIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/HotIcon.js
'use client';



var HotIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#DC362E' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M6.06668 0.93335C5.94291 0.93335 5.82421 0.982516 5.73669 1.07003C5.64918 1.15755 5.60001 1.27625 5.60001 1.40002C5.60001 3.75995 2.33334 5.60002 2.33334 8.86668C2.33334 11.3483 5.02297 12.9528 5.97006 13.0567C6.00183 13.0634 6.03421 13.0667 6.06668 13.0667C6.19044 13.0667 6.30914 13.0175 6.39666 12.93C6.48418 12.8425 6.53334 12.7238 6.53334 12.6C6.53331 12.5307 6.51783 12.4622 6.48803 12.3997C6.45823 12.3371 6.41487 12.2819 6.36108 12.2382V12.2373C5.93641 11.8929 5.13334 10.8937 5.13334 9.9814C5.13334 8.48386 6.53334 7.93335 6.53334 7.93335C5.73488 10.192 8.35121 10.4649 8.87761 12.7012H8.87853C8.90152 12.8047 8.9591 12.8973 9.04177 12.9638C9.12444 13.0302 9.22728 13.0665 9.33334 13.0667C9.43162 13.0664 9.52731 13.0352 9.60678 12.9774C9.6152 12.9713 9.6234 12.9649 9.63139 12.9582C9.70734 12.9089 11.6667 11.613 11.6667 8.86668C11.6667 7.74546 11.1059 5.81958 10.7024 4.96655L10.7014 4.96382L10.7005 4.962C10.6662 4.87494 10.6064 4.80023 10.5291 4.74757C10.4517 4.69491 10.3603 4.66673 10.2667 4.66668C10.1577 4.66679 10.0522 4.70503 9.96843 4.77479C9.88469 4.84454 9.82801 4.94141 9.80821 5.04858V5.05041C9.80707 5.05551 9.59273 6.00743 8.86668 6.53335C8.86668 4.33459 7.27925 2.06344 6.4422 1.12384C6.42964 1.10683 6.41593 1.09069 6.40118 1.07554C6.35777 1.03067 6.3058 0.994962 6.24834 0.970538C6.19088 0.946115 6.12911 0.933469 6.06668 0.93335Z', fill: color })));
};


//# sourceMappingURL=HotIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/HeadHunterIcon.js
'use client';



var HeadHunterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#DC362E' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7 0a5.612 5.612 0 0 0-1.083.108c-.042.004-.083.013-.13.022C4.219.457 1.969 1.535 1.87 4.895c-.004.08-.004.159-.004.238V6.38l.205-.135a1.034 1.034 0 0 1 1.279.093c.004-.028.014-.055.023-.083a.41.41 0 0 1 .023-.07.685.685 0 0 1 .066-.146.14.14 0 0 1 .028-.05c.019-.047.047-.089.075-.131a.085.085 0 0 1 .027-.033.623.623 0 0 1 .09-.116.266.266 0 0 1 .05-.052.856.856 0 0 1 .117-.107c.005-.005.004-.01.01-.005a.782.782 0 0 1 .125-.098c.014-.01.029-.019.047-.033.052-.033.107-.06.168-.088.06-.033.126-.06.196-.089.065-.028.135-.056.205-.074.681-.22 1.54-.285 2.357-.5.07-.014.14-.038.21-.056.13-.038.261-.08.387-.13a1.83 1.83 0 0 0 .2-.085.838.838 0 0 0 .546-.308c.42-.284.78-.695 1.032-1.283 0 0 .206.187.458.583.037.056.075.122.112.187.047.075.088.154.13.238.271.532.542 1.274.65 2.259.018.149.032.303.037.466.009.15.013.308.013.467h.467v.467c0 .457-.159.653-.308.788-.15.13-.27.159-.27.159l-.252.06-.08.243s-.644 1.998-2.572 2.408l.836.523a.97.97 0 0 1 .163.13c1.587-.709 2.254-2.263 2.385-2.599.13-.051.21-.056.406-.224.317-.275.625-.779.625-1.488V5.133c0-1.866-.933-4.2-2.8-4.2C9.333.933 8.867 0 7 0ZM4.9 6.533a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4Zm4.2 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4ZM2.562 7c-.037 0-.08 0-.117.01a1.2 1.2 0 0 0-.565.34l-.013.014c-.649.658-.976 1.769 1.479 4.223 2.473 2.474 3.58 2.124 4.237 1.466.21-.21.304-.411.341-.565a.373.373 0 0 0-.173-.406c-.005-.004-.009-.005-.018-.014-.355-.206-1.092-.64-1.442-.84a.36.36 0 0 0-.37.005l-.583.345a.366.366 0 0 1-.41-.023 10.085 10.085 0 0 1-.826-.723c-.29-.29-.56-.622-.723-.827a.358.358 0 0 1-.024-.41l.346-.583a.342.342 0 0 0 .05-.178.335.335 0 0 0-.05-.196l-.038-.066-.033-.097-.027-.01-.752-1.283a.665.665 0 0 0-.051-.07A.392.392 0 0 0 2.562 7Z', fill: color })));
};


//# sourceMappingURL=HeadHunterIcon.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/translation.js
'use client';

var translation = {
    '/management-jobs': '/viec-lam-quan-ly',
    New: 'Mới',
    Matching: 'Phù hợp'
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/Images/MatchingIcon.js
'use client';



var MatchingIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 18 : _b;
    return (react.createElement("svg", { width: size, height: size, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M1.5 3.75h6a.75.75 0 0 1 .75.75v8.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75Zm1.406 3.495v.338c-.06.195-.218.266-.396.346-.24.107-.517.231-.635.696h3c-.118-.465-.394-.589-.635-.696-.178-.08-.336-.151-.396-.346v-.338c.07-.038.272-.297.293-.5.055-.004.142-.06.167-.277.014-.116-.041-.182-.074-.202 0 0 .082-.17.082-.375 0-.412-.148-.762-.468-.762 0 0-.111-.254-.469-.254-.663 0-.938.46-.938 1.016 0 .187.083.375.083.375-.033.02-.088.086-.074.202.026.218.113.273.168.277.02.203.222.462.292.5ZM2.25 12h4.5a.375.375 0 0 0 0-.75h-4.5a.375.375 0 0 0 0 .75Zm0-1.5h4.5a.375.375 0 0 0 0-.75h-4.5a.375.375 0 0 0 0 .75ZM6 8.625h.75a.375.375 0 0 0 0-.75H6a.375.375 0 0 0 0 .75Zm0-1.5h.75a.375.375 0 0 0 0-.75H6a.375.375 0 0 0 0 .75Zm7.5 2.625 1-2 2-1-2-1-1-2-1 2-2 1 2 1 1 2Zm2.25 4.5.75-1.5L18 12l-1.5-.75-.75-1.5-.75 1.5-1.5.75 1.5.75.75 1.5Z', fill: '#6B7792' })));
};


//# sourceMappingURL=MatchingIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/index.js
'use client';












var BadgeTag = function (props) {
    var type = props.type, langCode = props.langCode, utm = props.utm;
    var name = type;
    var Icon;
    var url = '';
    var t = function (key) {
        if (langCode === constants/* ELanguage.VI */.Df.VI) {
            return translation[key] || key;
        }
        else {
            return key;
        }
    };
    switch (type) {
        case 'Hot':
            Icon = HotIcon;
            break;
        case 'Premium':
            Icon = PremiumIcon;
            break;
        case 'Top management':
            Icon = TopManageIcon;
            url = t('/management-jobs') + utm;
            break;
        case 'Urgent':
            Icon = UrgentIcon;
            break;
        case 'Head hunter':
            Icon = HeadHunterIcon;
            break;
        case 'New':
            name = t(type);
            break;
        case 'Matching':
            Icon = MatchingIcon;
            name = t(type);
            break;
    }
    return url ? (react.createElement("a", { href: url, title: name },
        react.createElement(Container, { type: type },
            Icon && react.createElement(Icon, null),
            " ",
            name))) : (react.createElement(Container, { type: type, title: name },
        Icon && react.createElement(Icon, null),
        " ",
        name));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 6031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BottomSheet; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/BottomSheet.css.js
'use client';





var extendFromBottom = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var collapseToBottom = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n"])));
var BottomSheetWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: ", ";\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: ", ";\n"])), function (props) { return props.zIndex || 200; });
var BottomSheetContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    position: fixed;\n    bottom: 0;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: 100vw;\n    border-radius: 10px 10px 0 0;\n"], ["\n    background-color: #fff;\n    position: fixed;\n    bottom: 0;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: 100vw;\n    border-radius: 10px 10px 0 0;\n"])), function (_a) {
    var isClose = _a.isClose;
    return (isClose ? collapseToBottom : extendFromBottom);
});
var Backdrop = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n"])));
var Header = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #F1F1F1;\n    ", "\n"], ["\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #F1F1F1;\n    ", "\n"])), function (_a) {
    var isReverseHeader = _a.isReverseHeader;
    return isReverseHeader
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  flex-direction: row-reverse;\n                  justify-content: flex-end;\n              "], ["\n                  flex-direction: row-reverse;\n                  justify-content: flex-end;\n              "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  flex-direction: row;\n                  justify-content: space-between;\n              "], ["\n                  flex-direction: row;\n                  justify-content: space-between;\n              "])));
});
var HeaderLabel = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 600;\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    width: 100%;\n"], ["\n    font-weight: 600;\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    width: 100%;\n"])), constants/* colors.textColor */.O9.textColor);
styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n"], ["\n    cursor: pointer;\n"])));
var Body = styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    p {\n        margin: 0;\n    }\n"], ["\n    padding: 16px;\n    p {\n        margin: 0;\n    }\n"])));
var Footer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n"], ["\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


//# sourceMappingURL=BottomSheet.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(54033);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/constants.js
'use client';

var DEFAULT_OPTION = {
    isCloseOnClickBackdrop: true,
    isHaveCloseIcon: true
};
var DEFAULT_FOOTER_OTPION = {
    text: 'Ok',
    buttonType: 'primary',
    isCloseOnClick: true,
    callbackOnClick: function () { }
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/index.js
'use client';









var BottomSheet = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, header = props.header, headerOption = props.headerOption, children = props.children, footer = props.footer, options = props.options, footerOptions = props.footerOptions, onClose = props.onClose, trackingOnClose = props.trackingOnClose, _b = props.styleOption, styleOption = _b === void 0 ? {} : _b;
    var mergedOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTION), options);
    var mergedFooterOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_FOOTER_OTPION), footerOptions);
    var _c = (0,react.useState)(false), isMounted = _c[0], setMounted = _c[1];
    var _d = (0,react.useState)(true), isCloseModal = _d[0], setCloseModal = _d[1];
    var removeOverflowClass = function () {
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
    };
    var onAnimationEnd = function () {
        if (!isCloseModal) {
            return;
        }
        removeOverflowClass();
        setMounted(false);
        onClose(false);
    };
    var onClickFooterButton = function () {
        mergedFooterOptions.isCloseOnClick && setCloseModal(true);
        mergedFooterOptions.callbackOnClick && mergedFooterOptions.callbackOnClick();
        trackingOnClose && trackingOnClose('BUTTON');
    };
    (0,react.useEffect)(function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (!bodyNode) {
            return;
        }
        if (isMounted) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        return function () {
            removeOverflowClass();
        };
    }, []);
    (0,react.useEffect)(function () {
        setCloseModal(!isOpen);
        if (isOpen) {
            setMounted(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return (0,react_dom.createPortal)(isMounted ? (react.createElement(BottomSheetWrapper, { "data-cname": 'BottomSheet', zIndex: styleOption.zIndex },
        react.createElement(Backdrop, { onClick: function () {
                mergedOption.isCloseOnClickBackdrop && setCloseModal(true);
                trackingOnClose && trackingOnClose('BACKDROP');
            } }),
        react.createElement(BottomSheetContent, { isClose: isCloseModal, onAnimationEnd: onAnimationEnd },
            header && (react.createElement(Header, { isReverseHeader: mergedOption.isReverseHeader, style: (0,_tslib/* __assign */.pi)({}, headerOption === null || headerOption === void 0 ? void 0 : headerOption.styles) },
                react.createElement(HeaderLabel, null, header),
                mergedOption.isHaveCloseIcon && (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                        setCloseModal(true);
                        trackingOnClose && trackingOnClose('BACKDROP');
                    } },
                    react.createElement(CloseIcon/* default */.Z, null))))),
            react.createElement(Body, null, children),
            footer || (react.createElement(Footer, null,
                react.createElement(Button/* default */.Z, { type: mergedFooterOptions.buttonType, onClick: onClickFooterButton, style: { width: '100%' } }, mergedFooterOptions.text)))))) : (react.createElement(react.Fragment, null)), document === null || document === void 0 ? void 0 : document.body);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button$1; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Button/Button.css.js
'use client';






// import { colors } from '../Utils/constants'
var rippleAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(10);\n        opacity: 0.375;\n    }\n    100% {\n        transform: scale(35);\n        opacity: 0;\n    }\n"], ["\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(10);\n        opacity: 0.375;\n    }\n    100% {\n        transform: scale(35);\n        opacity: 0;\n    }\n"])));
var ButtonWrapper = styled_components_browser_esm/* default.button */.ZP.button(templateObject_48 || (templateObject_48 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    &.clickable {\n        cursor: pointer;\n    }\n\n    // Disabled button\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &.pointer-disabled {\n        pointer-events: none;\n    }\n\n    &.btn-white {\n        color: #333;\n        background-color: #ffffff;\n        border: 1px solid #d6d6d6;\n        &:hover,\n        &:focus {\n            background-color: #ffffff;\n            box-shadow: none;\n        }\n    }\n    /** NEW **/\n    border-radius: 8px;\n    border: none;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    ", "\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n"], ["\n    &.clickable {\n        cursor: pointer;\n    }\n\n    // Disabled button\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &.pointer-disabled {\n        pointer-events: none;\n    }\n\n    &.btn-white {\n        color: #333;\n        background-color: #ffffff;\n        border: 1px solid #d6d6d6;\n        &:hover,\n        &:focus {\n            background-color: #ffffff;\n            box-shadow: none;\n        }\n    }\n    /** NEW **/\n    border-radius: 8px;\n    border: none;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    ", "\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n"])), function (_a) {
    var buttonClass = _a.buttonClass, isLightMode = _a.isLightMode, hasValueFilter = _a.hasValueFilter;
    switch (buttonClass) {
        case 'primary':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #fff !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: #fff !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.95 */.O9.secondary[95], Colors/* colors.secondary.95 */.O9.secondary[95], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.40 */.O9.secondary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.secondary.50 */.O9.secondary[50]).toString(), (0,helpers/* hexToRgb */.oo)(Colors/* colors.secondary.50 */.O9.secondary[50]).toString(), Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'default':
            if (hasValueFilter) {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        border: 1px solid #a0c1ff;\n                        display: inline-block;\n                        overflow: hidden;\n                        background: #eff5ff;\n                        color: #003699;\n                        &:before {\n                            content: '';\n                            top: 0px;\n                            left: 0px;\n                            width: 100%;\n                            height: 100%;\n                            position: absolute;\n                            border-radius: 6px;\n                            border: 4px solid #fff !important;\n                        }\n                    "], ["\n                        border: 1px solid #a0c1ff;\n                        display: inline-block;\n                        overflow: hidden;\n                        background: #eff5ff;\n                        color: #003699;\n                        &:before {\n                            content: '';\n                            top: 0px;\n                            left: 0px;\n                            width: 100%;\n                            height: 100%;\n                            position: absolute;\n                            border-radius: 6px;\n                            border: 4px solid #fff !important;\n                        }\n                    "])));
            }
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n\n                    ", "\n                "])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.20 */.O9.grey[20], (0,helpers/* hexToRgb */.oo)(Colors/* colors.neutral.50 */.O9.neutral[50]).toString(), (0,helpers/* hexToRgb */.oo)(Colors/* colors.neutral.50 */.O9.neutral[50]).toString(), Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'danger':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.40 */.O9.error[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.error.50 */.O9.error[50]).toString(), Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'info':
            if (!isLightMode) {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        &:hover {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        &:focus,\n                        &:active {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                            box-shadow: inset 0 0 0 1px ", " !important;\n                        }\n                        &.btn-disabled,\n                        &[disabled] {\n                            color: ", " !important;\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        ", "\n                    "], ["\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        &:hover {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        &:focus,\n                        &:active {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                            box-shadow: inset 0 0 0 1px ", " !important;\n                        }\n                        &.btn-disabled,\n                        &[disabled] {\n                            color: ", " !important;\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        ", "\n                    "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.50 */.O9.primary[50], Colors/* colors.primary.50 */.O9.primary[50], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                    var outline = _a.outline;
                    switch (outline) {
                        default:
                        case 'solid':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                        case 'none':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                        background-color: ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            border: 2px solid transparent !important;\n                                            background-color: ", " !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 1px ", " !important;\n                                            color: ", " !important;\n                                            border: 2px solid ", " !important;\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid transparent !important;\n                                        }\n                                    "], ["\n                                        background-color: ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            border: 2px solid transparent !important;\n                                            background-color: ", " !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 1px ", " !important;\n                                            color: ", " !important;\n                                            border: 2px solid ", " !important;\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid transparent !important;\n                                        }\n                                    "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                        case 'outline':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                        background-color: transparent !important;\n                                        color: ", " !important;\n                                        border: none !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            background-color: rgba(\n                                                ", ",\n                                                0.15\n                                            ) !important;\n                                            border: none !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 2px ", " !important;\n                                            border: none !important;\n                                            &::before {\n                                                content: ' ';\n                                                position: absolute;\n                                                left: 2px;\n                                                top: 2px;\n                                                width: calc(100% - 4px);\n                                                height: calc(100% - 4px);\n                                                pointer-events: none;\n                                                user-select: none;\n                                                border: 1px solid ", ";\n                                                border-radius: 6px;\n                                            }\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid ", " !important;\n                                            box-shadow: none !important;\n                                        }\n                                    "], ["\n                                        background-color: transparent !important;\n                                        color: ", " !important;\n                                        border: none !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            background-color: rgba(\n                                                ", ",\n                                                0.15\n                                            ) !important;\n                                            border: none !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 2px ", " !important;\n                                            border: none !important;\n                                            &::before {\n                                                content: ' ';\n                                                position: absolute;\n                                                left: 2px;\n                                                top: 2px;\n                                                width: calc(100% - 4px);\n                                                height: calc(100% - 4px);\n                                                pointer-events: none;\n                                                user-select: none;\n                                                border: 1px solid ", ";\n                                                border-radius: 6px;\n                                            }\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid ", " !important;\n                                            box-shadow: none !important;\n                                        }\n                                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                    }
                });
            }
            // info already have light mode
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'outline':
            // OLD style outline (Used for keep consistent of old component)
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: transparent;\n                    border: 1px solid ", ";\n                    color: ", ";\n                    &:hover,\n                    &:focus {\n                        background-color: #fff;\n                    }\n                "], ["\n                    background-color: transparent;\n                    border: 1px solid ", ";\n                    color: ", ";\n                    &:hover,\n                    &:focus {\n                        background-color: #fff;\n                    }\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40]);
        case 'transparent':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: #e9e9f2;\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: #d6d6e0 !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                    ", "\n                "], ["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: #e9e9f2;\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: #d6d6e0 !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                    ", "\n                "])), function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                    default:
                        return '';
                }
            });
        case 'opacity':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: rgba(174, 174, 174, 0.5);\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: rgba(174, 174, 174, 0.5) !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                "], ["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: rgba(174, 174, 174, 0.5);\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: rgba(174, 174, 174, 0.5) !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                "])));
        case 'highlight':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'ai':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #c006e9 !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid transparent !important;\n                    }\n                    ", "\n                "], ["\n                    color: #c006e9 !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid transparent !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%) !important;\n                                    color: #fff !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        border: 2px solid #c006e9 !important;\n                                        background: linear-gradient(\n                                            90deg,\n                                            rgba(224, 54, 155, 0.8) 0%,\n                                            rgba(192, 6, 233, 0.8) 100%\n                                        );\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        border: 2px solid #c006e9 !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                    }\n                                "], ["\n                                    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%) !important;\n                                    color: #fff !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        border: 2px solid #c006e9 !important;\n                                        background: linear-gradient(\n                                            90deg,\n                                            rgba(224, 54, 155, 0.8) 0%,\n                                            rgba(192, 6, 233, 0.8) 100%\n                                        );\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        border: 2px solid #c006e9 !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                    }\n                                "])), Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.100 */.O9.primary[100]);
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: #c006e9 !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px #c006e9 !important;\n                                    &:hover {\n                                        color: #c006e9 !important;\n                                        background-color: #f0dcf5 !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: #f0dcf5 !important;\n                                        box-shadow: inset 0 0 0 2px #c006e9 !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: #c006e9 !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px #c006e9 !important;\n                                    &:hover {\n                                        color: #c006e9 !important;\n                                        background-color: #f0dcf5 !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: #f0dcf5 !important;\n                                        box-shadow: inset 0 0 0 2px #c006e9 !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        default:
            return '';
    }
}, function (_a) {
    var buttonSize = _a.buttonSize;
    switch (buttonSize) {
        case 'xs':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 12px;\n                    height: 28px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 12px;\n                    height: 28px;\n                    line-height: 20px;\n                "])));
        case 'sm':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_37 || (templateObject_37 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 12px;\n                    height: 32px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 12px;\n                    height: 32px;\n                    line-height: 20px;\n                "])));
        case 'md-h':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_38 || (templateObject_38 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "])));
        case 'md-up':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_39 || (templateObject_39 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 44px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 44px;\n                    line-height: 20px;\n                "])));
        case 'lg':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_40 || (templateObject_40 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 15px;\n                    height: 48px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 15px;\n                    height: 48px;\n                    line-height: 20px;\n                "])));
        case 'md':
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_41 || (templateObject_41 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "])));
    }
}, function (_a) {
    var isIcon = _a.isIcon;
    if (!isIcon) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_44 || (templateObject_44 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding: 0;\n            svg {\n                pointer-events: none;\n                width: 16px;\n                height: 16px;\n            }\n            ", "\n        "], ["\n            padding: 0;\n            svg {\n                pointer-events: none;\n                width: 16px;\n                height: 16px;\n            }\n            ", "\n        "])), function (_a) {
        var buttonSize = _a.buttonSize;
        switch (buttonSize) {
            case 'xs':
            case 'sm':
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_42 || (templateObject_42 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            width: 32px;\n                            height: 32px;\n                            min-width: 32px;\n                            min-height: 32px;\n                            font-size: 12px;\n                            height: 32px;\n                            line-height: 20px;\n                        "], ["\n                            width: 32px;\n                            height: 32px;\n                            min-width: 32px;\n                            min-height: 32px;\n                            font-size: 12px;\n                            height: 32px;\n                            line-height: 20px;\n                        "])));
            case 'lg':
            case 'md':
            default:
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_43 || (templateObject_43 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            font-size: 14px;\n                            height: 40px;\n                            line-height: 20px;\n                            width: 40px;\n                            height: 40px;\n                            min-width: 40px;\n                            min-height: 40px;\n                            svg {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        "], ["\n                            font-size: 14px;\n                            height: 40px;\n                            line-height: 20px;\n                            width: 40px;\n                            height: 40px;\n                            min-width: 40px;\n                            min-height: 40px;\n                            svg {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        "])));
        }
    });
}, function (_a) {
    var isRounded = _a.isRounded;
    if (!isRounded) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_45 || (templateObject_45 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-radius: 48px;\n            &::before {\n                border-radius: 48px !important;\n            }\n        "], ["\n            border-radius: 48px;\n            &::before {\n                border-radius: 48px !important;\n            }\n        "])));
}, function (_a) {
    var forResponsive = _a.forResponsive, hasValueFilter = _a.hasValueFilter;
    if (forResponsive && !hasValueFilter) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_46 || (templateObject_46 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                background: #f1f2f4 !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "], ["\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                background: #f1f2f4 !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "])));
    }
    if (hasValueFilter && forResponsive) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_47 || (templateObject_47 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background: #eff5ff !important;\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "], ["\n                background: #eff5ff !important;\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "])));
    }
    return '';
});
var Ripple = styled_components_browser_esm/* default.span */.ZP.span(templateObject_56 || (templateObject_56 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    display: block;\n    content: '';\n    border-radius: 100%;\n    opacity: 1;\n    animation: 1s ease 1 forwards ", ";\n    ", "\n"], ["\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    display: block;\n    content: '';\n    border-radius: 100%;\n    opacity: 1;\n    animation: 1s ease 1 forwards ", ";\n    ", "\n"])), rippleAnimation, function (_a) {
    var buttonClass = _a.buttonClass;
    switch (buttonClass) {
        case 'primary':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_50 || (templateObject_50 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", "80;\n                    ", "\n                "], ["\n                    background-color: ", "80;\n                    ", "\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40], function (_a) {
                var isOutline = _a.isOutline;
                if (!isOutline) {
                    return '';
                }
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_49 || (templateObject_49 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            background-color: #fff;\n                        "], ["\n                            background-color: #fff;\n                        "])));
            });
        case 'default':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_52 || (templateObject_52 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #f4f4f7;\n                    ", "\n                "], ["\n                    background-color: #f4f4f7;\n                    ", "\n                "])), function (_a) {
                var isOutline = _a.isOutline;
                if (!isOutline) {
                    return '';
                }
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_51 || (templateObject_51 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            background-color: #fff;\n                        "], ["\n                            background-color: #fff;\n                        "])));
            });
        case 'danger':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_54 || (templateObject_54 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #f85a5a;\n                    ", "\n                "], ["\n                    background-color: #f85a5a;\n                    ", "\n                "])), function (_a) {
                var isOutline = _a.isOutline;
                if (!isOutline) {
                    return '';
                }
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_53 || (templateObject_53 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            background-color: rgba(255, 255, 255, 0.9);\n                        "], ["\n                            background-color: rgba(255, 255, 255, 0.9);\n                        "])));
            });
        case 'outline':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_55 || (templateObject_55 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #fff;\n                "], ["\n                    background-color: #fff;\n                "])));
        default:
            return '';
    }
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_59 || (templateObject_59 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    ", "\n"])), function (_a) {
    var isLeft = _a.isLeft;
    if (isLeft) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_57 || (templateObject_57 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-right: 6px;\n            "], ["\n                margin-right: 6px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_58 || (templateObject_58 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-left: 6px;\n        "], ["\n            margin-left: 6px;\n        "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59;


//# sourceMappingURL=Button.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js
'use client';





var Button = function (_a, refs) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseDown = _a.onMouseDown, _c = _a.size, size = _c === void 0 ? 'md' : _c; _a.isOutline; var _e = _a.outline, outline = _e === void 0 ? 'solid' : _e, children = _a.children, style = _a.style, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.htmlType, htmlType = _g === void 0 ? 'button' : _g, _h = _a.isRounded, isRounded = _h === void 0 ? false : _h, _j = _a.isIcon, isIcon = _j === void 0 ? false : _j, _k = _a.isLightMode, isLightMode = _k === void 0 ? false : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? 'left' : _l, _m = _a.iconComponent, iconComponent = _m === void 0 ? null : _m, _o = _a.hasValueFilter, hasValueFilter = _o === void 0 ? false : _o, forResponsive = _a.forResponsive, rest = (0,_tslib/* __rest */._T)(_a, ["type", "onClick", "onMouseEnter", "onMouseLeave", "onMouseDown", "size", "isOutline", "outline", "children", "style", "className", "htmlType", "isRounded", "isIcon", "isLightMode", "iconPosition", "iconComponent", "hasValueFilter", "forResponsive"]);
    var _p = (0,react.useState)({ x: -1, y: -1 }), coord = _p[0], setCoord = _p[1];
    var _q = (0,react.useState)(false), isRippling = _q[0], setRipping = _q[1];
    var typeClass = "btn-".concat(type);
    var sizeClass = size === 'lg'
        ? 'btn-lg'
        : size === 'md'
            ? 'btn-md'
            : size === 'md-h'
                ? 'btn-md-h'
                : size === 'sm'
                    ? 'btn-sm'
                    : 'btn-xs';
    var isClickable = type !== 'disabled' && !!onClick;
    var handleOnClick = (0,react.useCallback)(function (e) {
        // TODO: temporary disable Ripple effect due to un-consistent between reactjs project vs vanilla project
        // const rect = e.target.getBoundingClientRect()
        // setCoord({ x: e.clientX - rect.left, y: e.clientY - rect.top })
        onClick && onClick(e);
    }, [onClick]);
    (0,react.useEffect)(function () {
        if (coord.x !== -1 && coord.y !== -1) {
            setRipping(true);
            setTimeout(function () { return setRipping(false); }, 300);
        }
        else {
            setRipping(false);
        }
    }, [coord]);
    (0,react.useEffect)(function () {
        if (!isRippling)
            setCoord({ x: -1, y: -1 });
    }, [isRippling]);
    return (react.createElement(ButtonWrapper, (0,_tslib/* __assign */.pi)({ type: htmlType, buttonClass: type, buttonSize: size, isRounded: isRounded, isIcon: isIcon, outline: outline, isLightMode: isLightMode, className: "".concat(typeClass, " ").concat(sizeClass, " ").concat(className, " ").concat(isClickable ? 'clickable' : ''), onClick: handleOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, style: style, ref: refs, hasValueFilter: hasValueFilter, forResponsive: forResponsive }, rest),
        iconComponent && iconPosition === 'left' && react.createElement(IconWrapper, { isLeft: true }, iconComponent),
        children,
        iconComponent && iconPosition === 'right' && react.createElement(IconWrapper, { isLeft: false }, iconComponent),
        isRippling ? react.createElement(Ripple, { buttonClass: type, style: { left: coord.x, top: coord.y } }) : null));
};
var Button$1 = (0,react.forwardRef)(Button);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": function() { return /* binding */ ViewMoreContainer; },
/* harmony export */   "Mm": function() { return /* binding */ BottomSheetOptionItem; },
/* harmony export */   "RZ": function() { return /* binding */ DesktopSheetOptionItem; },
/* harmony export */   "eB": function() { return /* binding */ BottomSheetOptions; },
/* harmony export */   "oF": function() { return /* binding */ ButtonViewMoreWrapper; },
/* harmony export */   "q": function() { return /* binding */ ViewMoreWrapper; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33089);
/* harmony import */ var _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79962);
'use client';






var ButtonViewMoreWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n\n    button {\n        width: 36px;\n        height: 36px;\n        min-height: 36px;\n        min-width: 36px;\n    }\n"], ["\n    position: relative;\n\n    button {\n        width: 36px;\n        height: 36px;\n        min-height: 36px;\n        min-width: 36px;\n    }\n"])));
var ViewMoreWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: absolute;\n    z-index: 100;\n"], ["\n    position: absolute;\n    z-index: 100;\n"])));
var ViewMoreContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    ", "\n    width: max-content;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.12);\n    margin: 2px 4px 4px 4px;\n    padding: ", ";\n    ", ";\n    ", "\n"], ["\n    ", "\n    width: max-content;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.12);\n    margin: 2px 4px 4px 4px;\n    padding: ", ";\n    ", ";\n    ", "\n"])), function (_a) {
    var mode = _a.mode;
    return mode === 'horizontal'
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  display: flex;\n                  gap: 4px;\n              "], ["\n                  display: flex;\n                  gap: 4px;\n              "]))) : undefined;
}, function (_a) {
    var mode = _a.mode;
    return (mode === 'horizontal' ? '4px' : '16px');
}, function (_a) {
    var isShow = _a.isShow;
    return _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dropdownAnimation */ .ZP.dropdownAnimation(isShow);
}, function (_a) {
    var customPadding = _a.customPadding;
    if (!customPadding || customPadding === '') {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            padding: ", ";\n        "], ["\n            padding: ", ";\n        "])), customPadding);
});
var BottomSheetOptions = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    flex-direction: column;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    ", "\n"])), function (_a) {
    var mode = _a.mode;
    return mode === 'horizontal'
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  justify-content: space-around;\n                  flex-direction: row;\n              "], ["\n                  justify-content: space-around;\n                  flex-direction: row;\n              "]))) : undefined;
});
var BottomSheetOptionItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    cursor: pointer;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n    gap: 8px;\n\n    &:active {\n        background-color: ", ";\n    }\n\n    ", "\n"], ["\n    cursor: pointer;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n    gap: 8px;\n\n    &:active {\n        background-color: ", ";\n    }\n\n    ", "\n"])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.neutral[99] */ .O9.neutral[99], function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            opacity: 0.5;\n            cursor: default;\n\n            &:active {\n                background-color: transparent;\n            }\n        "], ["\n            opacity: 0.5;\n            cursor: default;\n\n            &:active {\n                background-color: transparent;\n            }\n        "])));
});
var DesktopSheetOptionItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    cursor: pointer;\n    ", "\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n    gap: 8px;\n    &:hover {\n        background-color: ", ";\n    }\n\n    ", "\n"], ["\n    position: relative;\n    cursor: pointer;\n    ", "\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n    gap: 8px;\n    &:hover {\n        background-color: ", ";\n    }\n\n    ", "\n"])), function (_a) {
    var mode = _a.mode;
    return mode === 'horizontal'
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  padding: 8px 13px;\n              "], ["\n                  padding: 8px 13px;\n              "]))) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  padding: 8px 8px 8px 16px;\n              "], ["\n                  padding: 8px 8px 8px 16px;\n              "])));
}, _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primary[99] */ .O9.primary[99], function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            opacity: 0.5;\n            cursor: default;\n\n            &:hover {\n                background-color: transparent;\n            }\n        "], ["\n            opacity: 0.5;\n            cursor: default;\n\n            &:hover {\n                background-color: transparent;\n            }\n        "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


//# sourceMappingURL=ButtonViewMore.css.js.map


/***/ }),

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResponsiveSheet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _BottomSheet_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6031);
/* harmony import */ var _ButtonViewMore_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19269);
'use client';





var ResponsiveSheet = function (props) {
    var options = props.options, textOptions = props.textOptions, responsiveButton = props.responsiveButton, isShow = props.isShow, setIsShow = props.setIsShow, _a = props.header, header = _a === void 0 ? '' : _a, _b = props.sheetStyles, sheetStyles = _b === void 0 ? {} : _b, _c = props.mode, mode = _c === void 0 ? 'vertical' : _c;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isShow), isChildShow = _d[0], setChildShow = _d[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BottomSheet_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { styleOption: sheetStyles, onClose: function () { return setIsShow(false); }, isOpen: isChildShow, options: {
            isHaveCloseIcon: false
        }, header: header, footerOptions: {
            text: textOptions.closeText,
            buttonType: responsiveButton.type || 'default'
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonViewMore_css_js__WEBPACK_IMPORTED_MODULE_2__/* .BottomSheetOptions */ .eB, { mode: mode }, options.map(function (item, index) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonViewMore_css_js__WEBPACK_IMPORTED_MODULE_2__/* .BottomSheetOptionItem */ .Mm, { key: "item-".concat(index), mode: mode, onClick: function () {
                    if (item.isDisabled)
                        return;
                    // Close dropdown on click
                    item.isCloseOnClick && setChildShow(false);
                    // callback onClick function
                    item.onClick && item.onClick();
                }, isDisabled: !!item.isDisabled },
                item.icon ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, item.icon) : null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, item.label)));
        }))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonViewMore; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/ButtonViewMore.css.js
var ButtonViewMore_css = __webpack_require__(19269);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ThreeDotIcon/index.js
var ThreeDotIcon = __webpack_require__(79229);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/constants.js
'use client';

var DEFAULT_STYLE_OTPIONS = {
    displayAlign: 'right',
    isRounded: false,
    button: {
        size: 'md',
        type: 'default',
        outline: 'none',
        isIcon: true
    },
    customPadding: '',
    responsiveButton: {
        type: 'default'
    }
};
var DEFAULT_TEXT_OPTIONS = {
    closeText: 'Close'
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/components/ResponsiveSheet/index.js
var ResponsiveSheet = __webpack_require__(90231);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/components/DesktopSheet/index.js
'use client';










var DesktopSheet = function (props, refs) {
    var displayAlign = props.displayAlign, options = props.options, isShow = props.isShow, context = props.context, setIsShow = props.setIsShow, _a = props.mode, mode = _a === void 0 ? 'vertical' : _a;
    var _b = (0,react.useState)(isShow), isChildShow = _b[0], setChildShow = _b[1];
    var ref = (0,useClickAway/* default */.Z)(function () {
        setChildShow(false);
    });
    var onAnimationEnd = function () {
        if (isChildShow)
            return;
        setIsShow(false);
    };
    return (react.createElement(ButtonViewMore_css/* ViewMoreWrapper */.q, { displayAlign: displayAlign, ref: refs, style: { position: context.position, left: context.x, top: context.y } },
        react.createElement(ButtonViewMore_css/* ViewMoreContainer */.Dl, { isShow: isChildShow, mode: mode, onAnimationEnd: onAnimationEnd, ref: ref, "data-floating-placement": context.placement, customPadding: props.customPadding }, options.map(function (item, index) {
            return (react.createElement(ButtonViewMore_css/* DesktopSheetOptionItem */.RZ, { mode: mode, key: "item-".concat(index), onClick: function (e) {
                    if (item.isDisabled)
                        return;
                    // prevent being clicked and
                    // trigger click event from parent component
                    e.preventDefault();
                    // Close dropdown on click
                    item.isCloseOnClick && setChildShow(false);
                    // callback onClick function
                    item.onClick && item.onClick();
                }, isDisabled: !!item.isDisabled },
                item.icon ? item.icon : null,
                item.label ? react.createElement("div", null,
                    " ",
                    item.label) : null));
        }))));
};
var DesktopSheet$1 = (0,react.forwardRef)(DesktopSheet);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/index.js
'use client';















var ButtonViewMore = function (props) {
    var options = props.options, styleOptions = props.styleOptions, textOptions = props.textOptions, icon = props.icon, onClick = props.onClick, _a = props.mode, mode = _a === void 0 ? 'vertical' : _a, header = props.header;
    var mergedStyleOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_STYLE_OTPIONS), styleOptions);
    var mergedTextOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_TEXT_OPTIONS), textOptions);
    var _b = (0,react.useState)(false), isShow = _b[0], setIsShow = _b[1];
    var _c = (0,useFloating/* default */.Z)({
        placement: mergedStyleOptions.displayAlign === 'right' ? 'bottom-end' : 'bottom-start'
    }), context = _c.context, refs = _c.refs;
    var isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : true;
    return (react.createElement(ButtonViewMore_css/* ButtonViewMoreWrapper */.oF, { onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e, isShow); } },
        react.createElement(Button/* default */.Z, { "aria-label": 'button-view-more', key: "rounded-".concat(isMobile), type: mergedStyleOptions.button.type, size: mergedStyleOptions.button.size, outline: mergedStyleOptions.button.outline, isIcon: mergedStyleOptions.button.isIcon, isRounded: mergedStyleOptions.isRounded, onClick: function () { return setIsShow(true); }, ref: refs.setReference }, icon || react.createElement(ThreeDotIcon/* default */.Z, null)),
        isShow &&
            isMobile &&
            (0,react_dom.createPortal)(
            // we insert sheet on document body to prevent z-index issue of nested parent element
            react.createElement(ResponsiveSheet/* default */.Z, { isShow: true, mode: mode, sheetStyles: { zIndex: 10001 }, setIsShow: setIsShow, options: options, header: header, textOptions: mergedTextOptions, responsiveButton: mergedStyleOptions.responsiveButton }), document === null || document === void 0 ? void 0 : document.body),
        isShow && !isMobile && (react.createElement(DesktopSheet$1, { displayAlign: mergedStyleOptions.displayAlign, isShow: true, mode: mode, setIsShow: setIsShow, options: options, context: context, customPadding: mergedStyleOptions.customPadding, ref: refs.setPopup }))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 21810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Calendar$1; }
});

// UNUSED EXPORTS: ECalendarStyle, ECalendarType

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/types.js
var types = __webpack_require__(36433);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/context/calendar.js
'use client';





var initCalendarState = {
    type: types/* ECalendarType.month */.i.month,
    langCode: constants/* ELanguage.EN */.Df.EN,
    calendarStyle: types/* ECalendarStyle.single */.w.single,
    currentDate: new Date(),
    setCurrentDate: function () { },
    minDate: null,
    maxDate: null,
    selectedDates: null,
    setSelectedDates: function () { },
    handleDatesClick: function () { },
    year: 0,
    setYear: function () { },
    month: 0,
    setMonth: function () { },
    calendarType: types/* ECalendarType.month */.i.month,
    setCalendarType: function () { },
    temporaryDates: [],
    setTemporaryDates: function () { },
    rangeYears: [1900, new Date().getFullYear()]
};
var CalendarContext = react.createContext(initCalendarState);
var useCalendar = function () { return (0,react.useContext)(CalendarContext); };


//# sourceMappingURL=calendar.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/styles.css.js
'use client';







var CalendarWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: #ffffff;\n    padding: 16px;\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n"], ["\n    background: #ffffff;\n    padding: 16px;\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n"])));
var CalendarContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    overflow: hidden;\n    max-width: max-content;\n    display: flex;\n    flex-direction: column;\n    ", "\n"], ["\n    width: 100%;\n    overflow: hidden;\n    max-width: max-content;\n    display: flex;\n    flex-direction: column;\n    ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n            opacity: 0.5;\n            cursor: default;\n        "], ["\n            pointer-events: none;\n            opacity: 0.5;\n            cursor: default;\n        "])));
});
var CalendarHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #828282;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    padding: 4px 0;\n    box-shadow: 0px 1px 0px 0px #f2f2f2;\n    -webkit-box-shadow: 0px 1px 0px 0px #f2f2f2;\n    -moz-box-shadow: 0px 1px 0px 0px #f2f2f2;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #828282;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    padding: 4px 0;\n    box-shadow: 0px 1px 0px 0px #f2f2f2;\n    -webkit-box-shadow: 0px 1px 0px 0px #f2f2f2;\n    -moz-box-shadow: 0px 1px 0px 0px #f2f2f2;\n"])));
var TittleHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    &:hover {\n        color: ", ";\n    }\n"], ["\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    &:hover {\n        color: ", ";\n    }\n"])), Colors/* colors.primary.40 */.O9.primary[40]);
var CalendarFooter = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    /* padding: 9px 0; */\n    text-align: center;\n    span {\n        cursor: pointer;\n        color: #005aff;\n        &:hover,\n        &:focus {\n            color: #0047cc;\n        }\n    }\n"], ["\n    width: 100%;\n    /* padding: 9px 0; */\n    text-align: center;\n    span {\n        cursor: pointer;\n        color: #005aff;\n        &:hover,\n        &:focus {\n            color: #0047cc;\n        }\n    }\n"])));
var ButtonGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n"])));
var MonthPanelContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    height: 270px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    height: 270px;\n    overflow: hidden;\n"])));
var CalendarWeekDayWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    padding: 4px 0px;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    padding: 4px 0px;\n"])));
var WeekDayLabel = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px 0;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px 0;\n"])));
var CalendarGrid = styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-gap: 2px 0;\n    ", "\n"], ["\n    display: grid;\n    grid-gap: 2px 0;\n    ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case types/* ECalendarType.year */.i.year:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    grid-template-columns: repeat(3, 1fr);\n                "], ["\n                    grid-template-columns: repeat(3, 1fr);\n                "])));
        case types/* ECalendarType.decade */.i.decade:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    grid-template-columns: repeat(3, 1fr);\n                "], ["\n                    grid-template-columns: repeat(3, 1fr);\n                "])));
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    grid-template-columns: repeat(7, 1fr);\n                "], ["\n                    grid-template-columns: repeat(7, 1fr);\n                "])));
    }
});
var CalendarItemWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    &:nth-child(7n + 1) {\n        border-top-left-radius: 50% !important;\n        border-bottom-left-radius: 50% !important;\n        overflow: hidden;\n    }\n    &:nth-child(7n) {\n        border-top-right-radius: 50% !important;\n        border-bottom-right-radius: 50% !important;\n        overflow: hidden;\n    }\n"], ["\n    &:nth-child(7n + 1) {\n        border-top-left-radius: 50% !important;\n        border-bottom-left-radius: 50% !important;\n        overflow: hidden;\n    }\n    &:nth-child(7n) {\n        border-top-right-radius: 50% !important;\n        border-bottom-right-radius: 50% !important;\n        overflow: hidden;\n    }\n"])));
var CalendarItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 38px;\n    width: 38px;\n    padding: 1px;\n    cursor: pointer;\n    color: #333333;\n    transition: initial 0.25s ease-in;\n    ", "\n\n    ", "\n  ", "\n", "\n\n\n", "\n", "\n", "\n", "\n     ", "\n\n    span {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: ", ";\n        &:hover {\n            background: #cfe0ff;\n            border: 1px solid #005aff !important;\n            color: ", " !important;\n            border-radius: ", ";\n        }\n\n        ", ";\n        ", "\n\n        ", "\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 38px;\n    width: 38px;\n    padding: 1px;\n    cursor: pointer;\n    color: #333333;\n    transition: initial 0.25s ease-in;\n    ", "\n\n    ", "\n  ", "\n", "\n\n\n", "\n", "\n", "\n", "\n     ", "\n\n    span {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: ", ";\n        &:hover {\n            background: #cfe0ff;\n            border: 1px solid #005aff !important;\n            color: ", " !important;\n            border-radius: ", ";\n        }\n\n        ", ";\n        ", "\n\n        ", "\n    }\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case types/* ECalendarType.year */.i.year:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 84px;\n                "], ["\n                    width: 84px;\n                "])));
        case types/* ECalendarType.decade */.i.decade:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 84px;\n                "], ["\n                    width: 84px;\n                "])));
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 38px;\n                "], ["\n                    width: 38px;\n                "])));
    }
}, function (_a) {
    var pickerRange = _a.pickerRange;
    return pickerRange
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  border-radius: 100% !important;\n              "], ["\n                  border-radius: 100% !important;\n              "]))) : undefined;
}, function (_a) {
    var start = _a.start, fullRange = _a.fullRange;
    return start
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  border-top-left-radius: 50% !important;\n                  border-bottom-left-radius: 50% !important;\n                  border-top-right-radius: ", "!important;\n                  border-bottom-right-radius: ", "!important;\n              "], ["\n                  border-top-left-radius: 50% !important;\n                  border-bottom-left-radius: 50% !important;\n                  border-top-right-radius: ", "!important;\n                  border-bottom-right-radius: ", "!important;\n              "])), fullRange ? '0' : '50%', fullRange ? '0' : '50%') : undefined;
}, function (_a) {
    var end = _a.end;
    return end
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  border-top-right-radius: 50% !important;\n                  border-bottom-right-radius: 50% !important;\n              "], ["\n                  border-top-right-radius: 50% !important;\n                  border-bottom-right-radius: 50% !important;\n              "]))) : undefined;
}, function (_a) {
    var disable = _a.disable;
    return disable
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  cursor: none;\n                  pointer-events: none !important;\n                  user-select: none !important;\n                  opacity: 0.4;\n              "], ["\n                  cursor: none;\n                  pointer-events: none !important;\n                  user-select: none !important;\n                  opacity: 0.4;\n              "]))) : undefined;
}, function (_a) {
    var active = _a.active;
    return active
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background-color: #eff5ff;\n                  color: #fff;\n              "], ["\n                  background-color: #eff5ff;\n                  color: #fff;\n              "]))) : undefined;
}, function (_a) {
    var inRangeActive = _a.inRangeActive;
    return inRangeActive
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background-color: #eff5ff !important;\n                  border-radius: unset !important;\n                  border: unset !important;\n                  transition: initial 0.25s ease-in;\n              "], ["\n                  background-color: #eff5ff !important;\n                  border-radius: unset !important;\n                  border: unset !important;\n                  transition: initial 0.25s ease-in;\n              "]))) : undefined;
}, function (_a) {
    var blur = _a.blur;
    return blur
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  opacity: 0.4;\n              "], ["\n                  opacity: 0.4;\n              "]))) : undefined;
}, function (_a) {
    var visible = _a.visible;
    return visible
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  opacity: 0;\n                  visibility: hidden;\n                  pointer-events: none !important;\n                  user-select: none !important;\n              "], ["\n                  opacity: 0;\n                  visibility: hidden;\n                  pointer-events: none !important;\n                  user-select: none !important;\n              "]))) : undefined;
}, function (_a) {
    var type = _a.type;
    return (type === types/* ECalendarType.year */.i.year || type === types/* ECalendarType.decade */.i.decade ? '6px' : ' 50%');
}, function (_a) {
    var active = _a.active;
    return (active ? '#fff' : '#005aff');
}, function (_a) {
    var type = _a.type;
    return type === types/* ECalendarType.year */.i.year || type === types/* ECalendarType.decade */.i.decade ? '6px' : ' 50%';
}, function (_a) {
    var active = _a.active;
    return active
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      background-color: #007bff !important;\n                      color: #fff !important;\n                  "], ["\n                      background-color: #007bff !important;\n                      color: #fff !important;\n                  "]))) : undefined;
}, function (_a) {
    var inRangeActive = _a.inRangeActive;
    return inRangeActive
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      color: #616161 !important;\n                      border-radius: unset;\n                      border: unset !important;\n                  "], ["\n                      color: #616161 !important;\n                      border-radius: unset;\n                      border: unset !important;\n                  "]))) : undefined;
}, function (_a) {
    var today = _a.today, type = _a.type;
    return today
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      border: 1px solid #4d8cff;\n                      color: #005aff;\n                      border-radius: ", ";\n                  "], ["\n                      border: 1px solid #4d8cff;\n                      color: #005aff;\n                      border-radius: ", ";\n                  "])), type === types/* ECalendarType.month */.i.month ? '50%' : '6px') : undefined;
});
var RangeCalendar = styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: start;\n    width: 100%;\n    gap: 24px;\n"], ["\n    display: flex;\n    align-items: start;\n    width: 100%;\n    gap: 24px;\n"])));
var ContentWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    text-transform: capitalize;\n"], ["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    text-transform: capitalize;\n"])));
var CombinePanelContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
var CombinePanelWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: fit-content;\n    justify-content: space-around;\n    min-width: 242px;\n    height: ", "px;\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-left: 8px;\n    }\n"], ["\n    display: flex;\n    width: fit-content;\n    justify-content: space-around;\n    min-width: 242px;\n    height: ", "px;\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-left: 8px;\n    }\n"])), function (_a) {
    var height = _a.height;
    return height !== null && height !== void 0 ? height : 300;
});
var CombinePanelItem = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    min-height: 44px;\n    min-width: 75px;\n    pointer-events: auto !important;\n"], ["\n    min-height: 44px;\n    min-width: 75px;\n    pointer-events: auto !important;\n"])));
var CombinePanelColumn = styled_components_browser_esm/* default.div */.ZP.div(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n    padding-bottom: 16px;\n    &::-webkit-scrollbar {\n        display: none;\n    }\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-top: 12px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n    padding-bottom: 16px;\n    &::-webkit-scrollbar {\n        display: none;\n    }\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-top: 12px;\n    }\n"])));
var CombinePanelButtonGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_37 || (templateObject_37 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    padding-top: 8px;\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-left: 8px;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    padding-top: 8px;\n    & > :not([hidden]) ~ :not([hidden]) {\n        margin-left: 8px;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37;


//# sourceMappingURL=styles.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/Arrows/index.js
var Arrows = __webpack_require__(17499);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/const.js
'use client';

var daysInWeekEn = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
var daysInWeek = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
var months = [
    {
        name: 'Tháng 1',
        sortName: 'Th 1',
        nameEn: 'January',
        sortNameEn: 'Jan',
        id: 0
    },
    {
        nameEn: 'February',
        sortNameEn: 'Feb',
        name: 'Tháng 2',
        sortName: 'Th 2',
        id: 1
    },
    {
        nameEn: 'March',
        sortNameEn: 'Mar',
        name: 'Tháng 3',
        sortName: 'Th 3',
        id: 2
    },
    {
        nameEn: 'April',
        sortNameEn: 'Apr',
        name: 'Tháng 4',
        sortName: 'Th 4',
        id: 3
    },
    {
        nameEn: 'May',
        sortNameEn: 'May',
        name: 'Tháng 5',
        sortName: 'Th 5',
        id: 4
    },
    {
        nameEn: 'June',
        sortNameEn: 'Jun',
        name: 'Tháng 6',
        sortName: 'Th 6',
        id: 5
    },
    {
        nameEn: 'July',
        sortNameEn: 'Jul',
        name: 'Tháng 7',
        sortName: 'Th 7',
        id: 6
    },
    {
        nameEn: 'August',
        sortNameEn: 'Aug',
        name: 'Tháng 8',
        sortName: 'Th 8',
        id: 7
    },
    {
        nameEn: 'September',
        sortNameEn: 'Sep',
        name: 'Tháng 9',
        sortName: 'Th 9',
        id: 8
    },
    {
        nameEn: 'October',
        sortNameEn: 'Oct',
        name: 'Tháng 10',
        sortName: 'Th 10',
        id: 9
    },
    {
        nameEn: 'November',
        sortNameEn: 'Nov',
        name: 'Tháng 11',
        sortName: 'Th 11',
        id: 10
    },
    {
        nameEn: 'December',
        sortNameEn: 'Dec',
        name: 'Tháng 12',
        sortName: 'Th 12',
        id: 11
    }
];
var FIRST_MONTH = 0;
var FIRST_DAY = 1;
var LAST_DAY = 0;
var TODAY = new Date();


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/utils/calendar.js
'use client';

var handleActiveItem = function (selectedDates, date) {
    var _a, _b;
    var isSelectedStart = selectedDates && selectedDates.length > 0;
    var isSelectedEnd = selectedDates && selectedDates.length > 1;
    var isActiveStart = isSelectedStart && date.toDateString() === ((_a = selectedDates[0]) === null || _a === void 0 ? void 0 : _a.toDateString());
    var isActiveEnd = isSelectedEnd && date.toDateString() === ((_b = selectedDates[1]) === null || _b === void 0 ? void 0 : _b.toDateString());
    var isInRangeActive = null;
    if (isSelectedStart && isSelectedEnd) {
        isInRangeActive = selectedDates[0] < date && date < selectedDates[1];
    }
    return { isActiveStart: isActiveStart, isActiveEnd: isActiveEnd, isInRangeActive: isInRangeActive };
};
var getFullYear = function (date) {
    try {
        return date.getFullYear();
    }
    catch (error) {
        throw Error('Invalid Date when get year');
    }
};
var getMonth = function (date) {
    try {
        return date.getMonth();
    }
    catch (error) {
        throw Error('Invalid Date when get month');
    }
};
var getDate = function (date) {
    try {
        return date.getDate();
    }
    catch (error) {
        throw Error('Invalid Date when get date');
    }
};
var getDay = function (date) {
    try {
        return date.getDay();
    }
    catch (error) {
        throw Error('Invalid Date when get day');
    }
};
var getNewDate = function (date, type) {
    try {
        return new Date(getFullYear(date), getMonth(date), getDate(date));
    }
    catch (error) {
        throw Error('Invalid date');
    }
};


//# sourceMappingURL=calendar.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/header.js
'use client';












function HeaderCalendar(_a) {
    var onClickNext = _a.onClickNext, onClickPrev = _a.onClickPrev, onClickSupperNext = _a.onClickSupperNext, onClickSupperPrev = _a.onClickSupperPrev;
    var _b = useCalendar(), currentDate = _b.currentDate, calendarStyle = _b.calendarStyle, year = _b.year, setYear = _b.setYear, langCode = _b.langCode, setCalendarType = _b.setCalendarType, calendarType = _b.calendarType;
    var currentYear = getFullYear(currentDate);
    var currentMonth = getMonth(currentDate);
    var newDate = new Date(currentYear, currentMonth + 1, FIRST_DAY);
    var startYear = year - 6;
    var endYear = startYear + 11;
    var renderTitleSingleCalendar = function () {
        var _a;
        switch (calendarType) {
            case types/* ECalendarType.year */.i.year:
                return (react.createElement(ContentWrap, null,
                    react.createElement(Typography/* default */.Z, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'title', size: 'medium' }, currentYear)));
            case types/* ECalendarType.decade */.i.decade:
                return (react.createElement(ContentWrap, null,
                    react.createElement("div", null,
                        react.createElement(Typography/* default */.Z, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'title', size: 'medium' },
                            react.createElement("span", null, startYear),
                            " - ",
                            react.createElement("span", null, endYear)))));
            default:
                return (react.createElement(ContentWrap, null,
                    react.createElement(Typography/* default */.Z, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'title', size: 'medium' }, (_a = currentDate === null || currentDate === void 0 ? void 0 : currentDate.toLocaleString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _a !== void 0 ? _a : '')));
        }
    };
    var renderTitleRangeCalendar = function () {
        var _a, _b;
        switch (calendarType) {
            case types/* ECalendarType.year */.i.year:
                return (react.createElement(ContentWrap, null,
                    react.createElement("span", null, currentYear),
                    react.createElement("span", null, currentYear + 1)));
            default:
                return (react.createElement(ContentWrap, null,
                    react.createElement("span", null, (_a = currentDate === null || currentDate === void 0 ? void 0 : currentDate.toLocaleDateString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _a !== void 0 ? _a : ''),
                    react.createElement("span", null, (_b = newDate === null || newDate === void 0 ? void 0 : newDate.toLocaleDateString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _b !== void 0 ? _b : '')));
        }
    };
    var handleChangeCalendarType = function () {
        switch (calendarType) {
            case types/* ECalendarType.month */.i.month:
                setCalendarType(types/* ECalendarType.year */.i.year);
                break;
            case types/* ECalendarType.year */.i.year:
                setCalendarType(types/* ECalendarType.decade */.i.decade);
                break;
            case types/* ECalendarType.decade */.i.decade:
                break;
        }
    };
    return (react.createElement(CalendarHeader, null,
        react.createElement(ButtonGroup, null,
            react.createElement(Button/* default */.Z, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                    onClickSupperPrev();
                    if (calendarType === types/* ECalendarType.decade */.i.decade) {
                        setYear(year - 12);
                    }
                } },
                react.createElement(Arrows/* DoubleArrowLeft */.At, { color: Colors/* colors.grey.40 */.O9.grey[40] })),
            calendarType === types/* ECalendarType.month */.i.month && (react.createElement(Button/* default */.Z, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: onClickPrev },
                react.createElement(Arrows/* ArrowLeft */.Xd, { color: Colors/* colors.grey.40 */.O9.grey[40] })))),
        react.createElement(TittleHeader, { onClick: handleChangeCalendarType }, calendarStyle === types/* ECalendarStyle.single */.w.single ? renderTitleSingleCalendar() : renderTitleRangeCalendar()),
        react.createElement(ButtonGroup, null,
            calendarType === types/* ECalendarType.month */.i.month && (react.createElement(Button/* default */.Z, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: onClickNext },
                react.createElement(Arrows/* ArrowRight */.ol, { color: Colors/* colors.grey.40 */.O9.grey[40] }))),
            react.createElement(Button/* default */.Z, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                    onClickSupperNext();
                    if (calendarType === types/* ECalendarType.decade */.i.decade) {
                        setYear(year + 12);
                    }
                } },
                react.createElement(Arrows/* DoubleArrowRight */.Ct, { color: Colors/* colors.grey.40 */.O9.grey[40] })))));
}


//# sourceMappingURL=header.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/panel/monthPanel.js
'use client';











function MonthPanel(_a) {
    var currentDate = _a.currentDate;
    var _b = useCalendar(), selectedDates = _b.selectedDates, handleDatesClick = _b.handleDatesClick, minDate = _b.minDate, maxDate = _b.maxDate, calendarStyle = _b.calendarStyle, pickerType = _b.pickerType, langCode = _b.langCode;
    var currentMonth = getMonth(currentDate);
    var currentYear = getFullYear(currentDate);
    var firstDayOfMonth = new Date(currentYear, currentMonth, FIRST_DAY);
    var lastDayOfMonth = new Date(currentYear, currentMonth + 1, LAST_DAY);
    var daysInMonth = getDate(lastDayOfMonth);
    var firstDayOfWeek = getDay(firstDayOfMonth);
    var handleClickItem = function (day) {
        handleDatesClick(day);
    };
    /**
     * render
     */
    // Fill the preceding days of the current month
    var calendarGrid = [];
    var _loop_1 = function (i) {
        var day = new Date(currentYear, currentMonth, -firstDayOfWeek + i + 1);
        var _c = handleActiveItem(selectedDates, day), isActiveStart = _c.isActiveStart, isActiveEnd = _c.isActiveEnd, isInRangeActive = _c.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        calendarGrid.push(react.createElement(CalendarItem, { type: types/* ECalendarType.month */.i.month, today: TODAY.toDateString() === day.toDateString() ? 1 : 0, key: "".concat(currentMonth - 1, "-").concat(i), active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, blur: calendarStyle === types/* ECalendarStyle.range */.w.range ? 0 : 1, visible: calendarStyle === types/* ECalendarStyle.range */.w.range ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            react.createElement("span", null,
                " ",
                getDate(day))));
    };
    for (var i = 0; i < firstDayOfWeek; i++) {
        _loop_1(i);
    }
    var _loop_2 = function (i) {
        var day = new Date(currentYear, currentMonth, i);
        var _d = handleActiveItem(selectedDates, day), isActiveStart = _d.isActiveStart, isActiveEnd = _d.isActiveEnd, isInRangeActive = _d.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        var isBorderStartDay = i === 1 && calendarStyle === types/* ECalendarStyle.range */.w.range;
        var isBorderEndDay = i === daysInMonth && calendarStyle === types/* ECalendarStyle.range */.w.range;
        calendarGrid.push(react.createElement(CalendarItem, { type: types/* ECalendarType.month */.i.month, key: "".concat(currentMonth, "-").concat(i), fullRange: selectedDates && selectedDates.length > 1 ? 1 : 0, today: TODAY.toDateString() === day.toDateString() ? 1 : 0, pickerRange: pickerType === types/* ECalendarStyle.single */.w.single ? 1 : 0, start: isActiveStart || isBorderStartDay ? 1 : 0, end: isActiveEnd || isBorderEndDay ? 1 : 0, active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            react.createElement("span", null,
                " ",
                i)));
    };
    // Fill the days of the current month
    for (var i = 1; i <= daysInMonth; i++) {
        _loop_2(i);
    }
    // Fill the remaining days of the calendar grid
    var lastDayOfWeek = getDay(lastDayOfMonth);
    var _loop_3 = function (i) {
        var day = new Date(currentYear, currentMonth + 1, i);
        var _e = handleActiveItem(selectedDates, day), isActiveStart = _e.isActiveStart, isActiveEnd = _e.isActiveEnd, isInRangeActive = _e.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        calendarGrid.push(react.createElement(CalendarItem, { type: types/* ECalendarType.month */.i.month, today: TODAY.toDateString() === day.toDateString() && !isInRangeActive ? 1 : 0, key: "day-".concat(daysInMonth + i), active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, blur: calendarStyle === types/* ECalendarStyle.range */.w.range ? 0 : 1, visible: calendarStyle === types/* ECalendarStyle.range */.w.range ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            react.createElement("span", null,
                " ",
                day.getDate())));
    };
    for (var i = 1; i <= 6 - lastDayOfWeek; i++) {
        _loop_3(i);
    }
    return (react.createElement(MonthPanelContainer, null,
        react.createElement(CalendarWeekDayWrap, null, (langCode === constants/* ELanguage.EN */.Df.EN ? daysInWeekEn : daysInWeek).map(function (item) { return (react.createElement(WeekDayLabel, { key: item },
            react.createElement(Typography/* default */.Z, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'paragraph', size: 'small' }, item))); })),
        react.createElement(CalendarGrid, null, calendarGrid.map(function (elm, index) { return (react.createElement(CalendarItemWrap, { key: index }, elm)); }))));
}


//# sourceMappingURL=monthPanel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/panel/yearPanel.js
'use client';









function YearPanel(_a) {
    var currentDate = _a.currentDate;
    var _b = useCalendar(), type = _b.type, calendarType = _b.calendarType, setCalendarType = _b.setCalendarType, setSelectedDates = _b.setSelectedDates, selectedDates = _b.selectedDates, handleDatesClick = _b.handleDatesClick, minDate = _b.minDate, maxDate = _b.maxDate, langCode = _b.langCode, setCurrentDate = _b.setCurrentDate;
    var currentYear = getFullYear(currentDate);
    var currentMonth = getMonth(currentDate);
    var yearNow = getFullYear(new Date());
    var monthNow = getMonth(new Date());
    var dateNow = new Date(yearNow, monthNow, FIRST_DAY);
    var getNewSeletedDates = function () {
        var selectedMoths = [];
        if (!selectedDates || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) < 1) {
            selectedMoths = [new Date(currentYear, currentMonth, FIRST_DAY)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 1) {
            selectedMoths = [getNewDate(selectedDates[0], types/* ECalendarType.year */.i.year)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 2) {
            selectedMoths = [
                getNewDate(selectedDates[0], types/* ECalendarType.year */.i.year),
                getNewDate(selectedDates[1], types/* ECalendarType.year */.i.year)
            ];
        }
        return selectedMoths;
    };
    var onClickMonth = function (month) {
        if (type === calendarType) {
            handleDatesClick(month);
            return;
        }
        switch (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) {
            case 1:
                setSelectedDates([new Date(getFullYear(selectedDates[0]), getMonth(month), getDate(selectedDates[0]))]);
                break;
            case 2:
                setSelectedDates([new Date(getFullYear(selectedDates[1]), getMonth(month), getDate(selectedDates[1]))]);
                break;
        }
        setCurrentDate(new Date(getFullYear(currentDate), getMonth(month), getDate(currentDate)));
        setCalendarType(types/* ECalendarType.month */.i.month);
    };
    return (react.createElement(CalendarGrid, { type: types/* ECalendarType.year */.i.year }, months.map(function (item, _) {
        var month = new Date(currentYear, item.id, 1);
        var _a = handleActiveItem(getNewSeletedDates(), month), isActiveEnd = _a.isActiveEnd, isActiveStart = _a.isActiveStart, isInRangeActive = _a.isInRangeActive;
        var isDisabled = (maxDate && month > maxDate) || (minDate && month < minDate);
        return (react.createElement(CalendarItem, { key: item.id, type: types/* ECalendarType.year */.i.year, active: isActiveEnd || isActiveStart ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return onClickMonth(month); }, today: dateNow.toDateString() === month.toDateString() && !isInRangeActive ? 1 : 0 },
            react.createElement("span", null,
                " ",
                langCode === constants/* ELanguage.EN */.Df.EN ? item.sortNameEn : item.name)));
    })));
}


//# sourceMappingURL=yearPanel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/rangePanel.js
'use client';








function CalendarRangePanel() {
    var _a = useCalendar(), currentDate = _a.currentDate, calendarType = _a.calendarType;
    var currentMonth = currentDate.getMonth();
    var crrentYear = currentDate.getFullYear();
    var nextMonth = currentMonth + 1;
    var nextYear = crrentYear + 1;
    var newMonth = new Date(crrentYear, nextMonth);
    var newYear = new Date(nextYear, currentMonth);
    var renderPanel = function () {
        switch (calendarType) {
            case types/* ECalendarType.year */.i.year:
                return (react.createElement(RangeCalendar, null,
                    react.createElement(YearPanel, { currentDate: currentDate }),
                    react.createElement(YearPanel, { currentDate: newYear })));
            default:
                return (react.createElement(RangeCalendar, null,
                    react.createElement(MonthPanel, { currentDate: currentDate }),
                    react.createElement(MonthPanel, { currentDate: newMonth })));
        }
    };
    return renderPanel();
}


//# sourceMappingURL=rangePanel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/panel/decadePanel.js
'use client';








function DecadePanel(_a) {
    var currentDate = _a.currentDate;
    var currentYear = getFullYear(currentDate);
    var yearNow = getFullYear(new Date());
    var _b = useCalendar(), type = _b.type, calendarType = _b.calendarType, setCalendarType = _b.setCalendarType, selectedDates = _b.selectedDates, handleDatesClick = _b.handleDatesClick, minDate = _b.minDate, maxDate = _b.maxDate, year = _b.year, setSelectedDates = _b.setSelectedDates, setCurrentDate = _b.setCurrentDate;
    var today = new Date(yearNow, FIRST_MONTH, FIRST_DAY);
    var startYear = year - 6; // Show 12 years: 6 before and 6 after the current year
    var endYear = startYear + 11;
    var years = [];
    for (var i = startYear; i <= endYear; i++) {
        years.push(i);
    }
    var getNewSeletedDates = function () {
        var selectedYears = [];
        if (!selectedDates || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) < 1) {
            selectedYears = [new Date(currentYear, FIRST_MONTH, FIRST_DAY)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 1) {
            selectedYears = [getNewDate(selectedDates[0], types/* ECalendarType.decade */.i.decade)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 2) {
            selectedYears = [
                getNewDate(selectedDates[0], types/* ECalendarType.decade */.i.decade),
                getNewDate(selectedDates[1], types/* ECalendarType.decade */.i.decade)
            ];
        }
        return selectedYears;
    };
    var onClickYear = function (year) {
        if (type === calendarType) {
            handleDatesClick(year);
            return;
        }
        switch (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) {
            case 1:
                setSelectedDates([new Date(getFullYear(year), getMonth(selectedDates[0]), getDate(selectedDates[0]))]);
                break;
            case 2:
                setSelectedDates([new Date(getFullYear(year), getMonth(selectedDates[1]), getDate(selectedDates[1]))]);
                break;
        }
        setCurrentDate(new Date(getFullYear(year), getMonth(currentDate), getDate(currentDate)));
        setCalendarType(types/* ECalendarType.year */.i.year);
    };
    return (react.createElement(CalendarGrid, { type: types/* ECalendarType.decade */.i.decade }, years.map(function (item, _) {
        var year = selectedDates && selectedDates.length > 0
            ? new Date(item, getMonth(selectedDates[0]), getDate(selectedDates[0]))
            : new Date(item, FIRST_MONTH, FIRST_DAY);
        var _a = handleActiveItem(getNewSeletedDates(), year), isActiveEnd = _a.isActiveEnd, isActiveStart = _a.isActiveStart, isInRangeActive = _a.isInRangeActive;
        var isDisabled = (minDate && year < minDate) || (maxDate && year > maxDate);
        return (react.createElement(CalendarItem, { key: item, type: types/* ECalendarType.decade */.i.decade, active: isActiveEnd || isActiveStart ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return onClickYear(year); }, today: today.toDateString() === year.toDateString() && !isInRangeActive ? 1 : 0 },
            react.createElement("span", null,
                " ",
                item)));
    })));
}


//# sourceMappingURL=decadePanel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/combinePanel/index.js
'use client';










var DELAY_TIME_TO_DETECT_DOM_MOUNTED = 100;
var behaviorOption = { behavior: 'smooth', block: 'center', inline: 'center' };
function CombinePanel() {
    var _a = useCalendar(), currentDate = _a.currentDate, langCode = _a.langCode, rangeYears = _a.rangeYears, handleDatesClick = _a.handleDatesClick, minDate = _a.minDate, maxDate = _a.maxDate, calendarType = _a.calendarType;
    var _b = (0,react.useState)(false), isMounted = _b[0], setIsMounted = _b[1];
    var _c = (0,react.useState)(function () { var _a; return (_a = getDate(currentDate)) !== null && _a !== void 0 ? _a : 1; }), day = _c[0], setDay = _c[1];
    var _d = (0,react.useState)(function () { var _a; return (_a = getMonth(currentDate)) !== null && _a !== void 0 ? _a : 0; }), month = _d[0], setMonth = _d[1];
    var _e = (0,react.useState)(function () { return getFullYear(currentDate !== null && currentDate !== void 0 ? currentDate : new Date()); }), year = _e[0], setYear = _e[1];
    var timer = (0,react.useRef)();
    var dayActiveRef = (0,react.useRef)();
    var monthActiveRef = (0,react.useRef)();
    var yearActiveRef = (0,react.useRef)();
    var memoRangeYear = (0,react.useMemo)(function () {
        var _a, _b;
        var startYear = (_a = rangeYears === null || rangeYears === void 0 ? void 0 : rangeYears[0]) !== null && _a !== void 0 ? _a : 1900;
        var endYear = (_b = rangeYears === null || rangeYears === void 0 ? void 0 : rangeYears[1]) !== null && _b !== void 0 ? _b : new Date().getFullYear();
        return Array.from({ length: endYear - (startYear - 1) }, function (_, a) { return a + startYear; });
    }, [rangeYears]);
    var memoDays = (0,react.useMemo)(function () {
        if (calendarType === types/* ECalendarType.combineMonthAndYear */.i.combineMonthAndYear)
            return;
        var lastDayOfThisMonth = new Date(year, month + 1, LAST_DAY);
        var numberOfdaysInMonth = getDate(lastDayOfThisMonth);
        var days = [];
        for (var i = 1; i <= numberOfdaysInMonth; i++) {
            var day_1 = new Date(year, month, i);
            days.push(getDate(day_1));
        }
        if (day && !days.includes(day)) {
            setDay(null);
        }
        return days;
    }, [day, year, month, calendarType]);
    var handleClickDay = function (value) {
        setDay(value);
    };
    var handleClickMonth = function (value) {
        setMonth(value);
    };
    var handleClickYear = function (value) {
        setYear(value);
    };
    var handleApprove = (0,react.useCallback)(function () {
        if (typeof day !== 'number')
            return;
        var newDate = new Date(year, month, day);
        handleDatesClick(newDate);
    }, [day, month, year, handleDatesClick]);
    var handleCancel = (0,react.useCallback)(function () {
        var _a, _b;
        handleDatesClick(currentDate);
        setDay((_a = getDate(currentDate)) !== null && _a !== void 0 ? _a : 1);
        setMonth((_b = getMonth(currentDate)) !== null && _b !== void 0 ? _b : 0);
        setYear(getFullYear(currentDate !== null && currentDate !== void 0 ? currentDate : new Date()));
    }, [currentDate, handleDatesClick]);
    (0,react.useEffect)(function () {
        if (timer.current) {
            return;
        }
        if (!isMounted) {
            setIsMounted(true);
            return;
        }
        if (isMounted) {
            timer.current = setTimeout(function () {
                dayActiveRef.current && dayActiveRef.current.scrollIntoView(behaviorOption);
                monthActiveRef.current && monthActiveRef.current.scrollIntoView(behaviorOption);
                yearActiveRef.current && yearActiveRef.current.scrollIntoView(behaviorOption);
            }, DELAY_TIME_TO_DETECT_DOM_MOUNTED);
        }
        return function () {
            dayActiveRef.current = undefined;
            monthActiveRef.current = undefined;
            yearActiveRef.current = undefined;
            clearTimeout(timer.current);
            setIsMounted(false);
        };
    }, [isMounted]);
    return (react.createElement(CombinePanelContainer, null,
        react.createElement(CombinePanelWrap, { height: 270 },
            calendarType !== types/* ECalendarType.combineMonthAndYear */.i.combineMonthAndYear ? (react.createElement(CombinePanelColumn, null, memoDays === null || memoDays === void 0 ? void 0 : memoDays.map(function (d, i) {
                var isActive = i + 1 === day;
                var newDate = new Date(year, month !== null && month !== void 0 ? month : FIRST_MONTH, d);
                var disabled = (maxDate && newDate > maxDate) || (minDate && newDate < minDate);
                return (react.createElement(CombinePanelItem, { ref: function (el) {
                        if (isActive && el) {
                            dayActiveRef.current = el;
                        }
                    }, key: d, "data-active": !!day, type: isActive ? 'highlight' : 'transparent', onClick: function () { return handleClickDay(d); }, disabled: disabled }, d));
            }))) : null,
            react.createElement(CombinePanelColumn, null, months === null || months === void 0 ? void 0 : months.map(function (m) {
                var isActive = m.id === month;
                var newDate = new Date(year, m.id, day !== null && day !== void 0 ? day : FIRST_DAY);
                var disabled = (maxDate && newDate > maxDate) || (minDate && newDate < minDate);
                return (react.createElement(CombinePanelItem, { ref: function (el) {
                        if (isActive && el) {
                            monthActiveRef.current = el;
                        }
                    }, key: m.id, type: isActive ? 'highlight' : 'transparent', onClick: function () { return handleClickMonth(m.id); }, disabled: disabled }, langCode === constants/* ELanguage.VI */.Df.VI ? m.name : m.sortNameEn));
            })),
            react.createElement(CombinePanelColumn, null, memoRangeYear === null || memoRangeYear === void 0 ? void 0 : memoRangeYear.map(function (y) {
                var isActive = y === year;
                var newDate = new Date(y, month !== null && month !== void 0 ? month : FIRST_MONTH, day !== null && day !== void 0 ? day : FIRST_DAY);
                var disabled = (maxDate && newDate > maxDate) || (minDate && newDate < minDate);
                return (react.createElement(CombinePanelItem, { ref: function (el) {
                        if (isActive && el) {
                            yearActiveRef.current = el;
                        }
                    }, key: y, type: isActive ? 'highlight' : 'transparent', onClick: function () { return handleClickYear(y); }, disabled: disabled }, y));
            }))),
        react.createElement(CombinePanelButtonGroup, null,
            react.createElement(Button/* default */.Z, { type: 'default', onClick: handleCancel }, langCode === constants/* ELanguage.VI */.Df.VI ? 'Huỷ' : 'Cancel'),
            react.createElement(Button/* default */.Z, { type: 'primary', onClick: handleApprove, disabled: typeof day !== 'number' }, langCode === constants/* ELanguage.VI */.Df.VI ? 'Chọn' : 'Done'))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/components/panel.js
'use client';









function CalendarPanel() {
    var _a = useCalendar(), currentDate = _a.currentDate, calendarType = _a.calendarType;
    var renderPanel = function () {
        switch (calendarType) {
            case types/* ECalendarType.year */.i.year:
                return react.createElement(YearPanel, { currentDate: currentDate });
            case types/* ECalendarType.decade */.i.decade:
                return react.createElement(DecadePanel, { currentDate: currentDate });
            case types/* ECalendarType.combine */.i.combine:
            case types/* ECalendarType.combineMonthAndYear */.i.combineMonthAndYear:
                return react.createElement(CombinePanel, null);
            default:
                return react.createElement(MonthPanel, { currentDate: currentDate });
        }
    };
    return renderPanel();
}


//# sourceMappingURL=panel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/index.js
'use client';














var Calendar = react.forwardRef(function CalendarComponent(_a, ref) {
    var _b;
    var initDates = _a.initDates, _c = _a.type, type = _c === void 0 ? types/* ECalendarType.month */.i.month : _c, _d = _a.pickerType, pickerType = _d === void 0 ? types/* ECalendarStyle.single */.w.single : _d, _e = _a.calendarStyle, calendarStyle = _e === void 0 ? types/* ECalendarStyle.single */.w.single : _e, min = _a.min, max = _a.max, handleDateClick = _a.handleDateClick, _f = _a.langCode, langCode = _f === void 0 ? constants/* ELanguage.EN */.Df.EN : _f, disabled = _a.disabled, rangeYears = _a.rangeYears;
    var _g = (0,react.useState)(type), calendarType = _g[0], setCalendarType = _g[1];
    var _h = (0,react.useState)((_b = (initDates && initDates[0])) !== null && _b !== void 0 ? _b : new Date()), currentDate = _h[0], setCurrentDate = _h[1];
    var _j = (0,react.useState)(initDates !== null && initDates !== void 0 ? initDates : []), selectedDates = _j[0], setSelectedDates = _j[1];
    var _k = (0,react.useState)(getFullYear(currentDate)), year = _k[0], setYear = _k[1];
    var _l = (0,react.useState)(getMonth(currentDate)), month = _l[0], setMonth = _l[1];
    var _m = (0,react.useState)([]), temporaryDates = _m[0], setTemporaryDates = _m[1];
    var onPicker = function (date) {
        if (!date) {
            setCurrentDate(new Date());
            setSelectedDates([]);
            return;
        }
        var selectedStartMonth = getMonth(date);
        var selectedStartYear = getFullYear(date);
        var currentMonth = getMonth(currentDate);
        var currentYear = getFullYear(currentDate);
        if (selectedStartMonth !== currentMonth || selectedStartYear !== currentYear) {
            setCurrentDate(date);
        }
        var datesRange = selectedDates;
        var startDate = datesRange[0];
        var endDate = datesRange[1];
        switch (pickerType) {
            case types/* ECalendarStyle.range */.w.range:
                if ((!endDate && date > startDate) || date > endDate) {
                    handleDateClick([startDate, date]);
                    setSelectedDates([startDate, date]);
                }
                else if (!endDate && date < startDate) {
                    handleDateClick([date, startDate]);
                    setSelectedDates([date, startDate]);
                }
                else if (datesRange && datesRange.length > 1 && date < startDate) {
                    handleDateClick([date, endDate]);
                    setSelectedDates([date, endDate]);
                }
                else {
                    handleDateClick([date]);
                    setSelectedDates([date]);
                }
                break;
            default:
                handleDateClick([date]);
                setSelectedDates([date]);
                break;
        }
    };
    (0,react.useImperativeHandle)(ref, function () { return ({ onPicker: onPicker }); });
    var goToNextMonth = function () {
        setCurrentDate(function (prevDate) {
            var currentMonth = getMonth(prevDate);
            var currentYear = getFullYear(prevDate);
            var nextMonth = currentMonth === 11 ? 0 : currentMonth + 1;
            var nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
            return new Date(nextYear, nextMonth, FIRST_DAY);
        });
    };
    var goToPreviousMonth = function () {
        setCurrentDate(function (prevDate) {
            var currentMonth = getMonth(prevDate);
            var currentYear = getFullYear(prevDate);
            var previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
            var previousYear = currentMonth === 0 ? currentYear - 1 : currentYear;
            return new Date(previousYear, previousMonth, FIRST_DAY);
        });
    };
    var goToNextYear = function () {
        setCurrentDate(function (prevDate) {
            var nextYear = getFullYear(prevDate) + 1;
            var currentMonth = getMonth(prevDate);
            return new Date(nextYear, currentMonth, FIRST_DAY);
        });
    };
    var goToPreviousYear = function () {
        setCurrentDate(function (prevDate) {
            var previousYear = getFullYear(prevDate) - 1;
            var currentMonth = getMonth(prevDate);
            return new Date(previousYear, currentMonth, FIRST_DAY);
        });
    };
    var checkSameDate = function () {
        try {
            if (!selectedDates || selectedDates.length < 1) {
                return false;
            }
            var isSameDate_1 = new Date(getFullYear(TODAY), getMonth(TODAY), getDate(TODAY), 0, 0, 0).toDateString() ===
                new Date(getFullYear(selectedDates[0]), getMonth(selectedDates[0]), getDate(selectedDates[0]), 0, 0, 0).toDateString();
            return isSameDate_1;
        }
        catch (error) {
            console.error(error);
        }
    };
    var isSameDate = checkSameDate() ? checkSameDate() : false;
    (0,react.useEffect)(function () {
        setSelectedDates(initDates !== null && initDates !== void 0 ? initDates : []);
        setCurrentDate(initDates && initDates.length > 0 ? initDates[0] : new Date());
    }, [initDates]);
    var contextValue = {
        type: type,
        langCode: langCode,
        minDate: min,
        maxDate: max,
        calendarStyle: calendarStyle,
        pickerType: pickerType,
        currentDate: currentDate,
        setCurrentDate: setCurrentDate,
        selectedDates: selectedDates,
        setSelectedDates: setSelectedDates,
        handleDatesClick: onPicker,
        year: year,
        setYear: setYear,
        calendarType: calendarType,
        setCalendarType: setCalendarType,
        temporaryDates: temporaryDates,
        setTemporaryDates: setTemporaryDates,
        month: month,
        setMonth: setMonth,
        rangeYears: rangeYears
    };
    return (react.createElement(CalendarContext.Provider, { value: contextValue },
        react.createElement(CalendarWrapper, null,
            calendarType === types/* ECalendarType.combine */.i.combine || calendarType === types/* ECalendarType.combineMonthAndYear */.i.combineMonthAndYear ? null : (react.createElement(HeaderCalendar, { onClickNext: goToNextMonth, onClickPrev: goToPreviousMonth, onClickSupperNext: goToNextYear, onClickSupperPrev: goToPreviousYear })),
            react.createElement(CalendarContainer, { disabled: disabled },
                calendarStyle === types/* ECalendarStyle.range */.w.range ? react.createElement(CalendarRangePanel, null) : react.createElement(CalendarPanel, null),
                calendarType !== types/* ECalendarType.month */.i.month || isSameDate ? null : (react.createElement(CalendarFooter, null,
                    react.createElement(Button/* default */.Z, { outline: 'none', size: 'md', type: 'info', onClick: function () {
                            if ((max && TODAY > max) || (min && TODAY < min)) {
                                setCurrentDate(TODAY);
                                setYear(TODAY.getFullYear());
                                return;
                            }
                            setSelectedDates([TODAY]);
                            setCurrentDate(TODAY);
                            setYear(TODAY.getFullYear());
                            onPicker(TODAY);
                        } }, langCode === constants/* ELanguage.EN */.Df.EN ? 'Today' : 'Hôm nay')))))));
});
var Calendar$1 = react.memo(Calendar);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 36433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ECalendarType; },
/* harmony export */   "w": function() { return /* binding */ ECalendarStyle; }
/* harmony export */ });
'use client';

var ECalendarType;
(function (ECalendarType) {
    ECalendarType["month"] = "month";
    ECalendarType["year"] = "year";
    ECalendarType["decade"] = "decade";
    ECalendarType["combine"] = "combine";
    ECalendarType["combineMonthAndYear"] = "combineMonthAndYear";
})(ECalendarType || (ECalendarType = {}));
var ECalendarStyle;
(function (ECalendarStyle) {
    ECalendarStyle["single"] = "single";
    ECalendarStyle["range"] = "range";
})(ECalendarStyle || (ECalendarStyle = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 75113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G6": function() { return /* binding */ DEFAULT_FLOATING_CONFIG; },
/* harmony export */   "Ps": function() { return /* binding */ KEYCODE; },
/* harmony export */   "U_": function() { return /* binding */ QUERY_SELECTOR_FIRST_RIGHT_ELEMENT; },
/* harmony export */   "Y4": function() { return /* binding */ DEFAULT_TEXT_OPTIONS; },
/* harmony export */   "bX": function() { return /* binding */ VIEWINDEX; },
/* harmony export */   "br": function() { return /* binding */ OTHER_PARENT_ID; },
/* harmony export */   "eY": function() { return /* binding */ DEFAULT_STYLE_OPTION; },
/* harmony export */   "mt": function() { return /* binding */ DEFAULT_SELECT_OPTIONS; }
/* harmony export */ });
'use client';

var DEFAULT_FLOATING_CONFIG = {
    placement: 'bottom-start',
    position: 'absolute',
    enablePortal: false,
    useWindowAsFlippingContainer: false,
    isFlip: true
};
var DEFAULT_STYLE_OPTION = {
    isFlex: false,
    placeholderColor: '#999',
    isShowSecondaryBtn: true,
    primaryBtnType: 'primary',
    secondaryBtnType: 'default'
};
var DEFAULT_SELECT_OPTIONS = {
    isSingleSelect: false,
    displayAsPopup: false,
    hiddenFooter: false
};
var DEFAULT_TEXT_OPTIONS = {
    placeholder: '',
    primaryBtnText: '',
    secondaryBtnText: ''
};
var VIEWINDEX;
(function (VIEWINDEX) {
    VIEWINDEX[VIEWINDEX["LEFT"] = 0] = "LEFT";
    VIEWINDEX[VIEWINDEX["RIGHT"] = 1] = "RIGHT";
})(VIEWINDEX || (VIEWINDEX = {}));
var KEYCODE;
(function (KEYCODE) {
    KEYCODE["SPACE"] = "Space";
    KEYCODE["ARROW_RIGHT"] = "ArrowRight";
})(KEYCODE || (KEYCODE = {}));
var OTHER_PARENT_ID = 30;
var QUERY_SELECTOR_FIRST_RIGHT_ELEMENT = '[data-cname="dropdown__body__rightColumn"] [data-id="-1"]';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 90081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ getSelectedParentName; },
/* harmony export */   "Dh": function() { return /* binding */ filterResultByAPI; },
/* harmony export */   "Nb": function() { return /* binding */ getSelectedSingleChildrenName; },
/* harmony export */   "Ul": function() { return /* binding */ getParentCheckState; },
/* harmony export */   "dG": function() { return /* binding */ mergeProps; },
/* harmony export */   "l_": function() { return /* binding */ countSelectedChildrenFromParentId; },
/* harmony export */   "wh": function() { return /* binding */ filterResult; },
/* harmony export */   "xT": function() { return /* binding */ getChildrenCheckState; }
/* harmony export */ });
/* unused harmony exports getParentByChildrenId, mergeJobCount, sortSearchChildrenAlphabet */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33294);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96306);
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55613);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75113);
'use client';







var mergeJobCount = function (options, children, jobCount) {
    var mergedParents = [];
    var mergedChildrens = children;
    var childrenKeys = Object.keys(children);
    var _loop_1 = function (i) {
        var parentItem = options[i];
        var filteredJobCount = jobCount && jobCount.filter(function (item) { return item.parentId === parentItem.id; });
        // Push jobs count for parent
        mergedParents.push({
            id: parentItem.id,
            name: parentItem.name,
            jobs: filteredJobCount.length > 0 ? filteredJobCount[0].jobs : 0
        });
        if (!filteredJobCount ||
            filteredJobCount.length === 0 ||
            (filteredJobCount.length > 0 && filteredJobCount[0].children.length === 0)) {
            return "continue";
        }
        var parentIndex = childrenKeys.findIndex(function (item) { return item === parentItem.id.toString(); });
        var _loop_2 = function (j) {
            var childrenItem = filteredJobCount[0].children[j];
            var childItemIndex = mergedChildrens[parentIndex].findIndex(function (childItem) { return childItem.id === childrenItem.childrenId; });
            if (childItemIndex === -1) {
                return "continue";
            }
            // Set children jobs count
            mergedChildrens[parentIndex][childItemIndex].jobs = childrenItem.jobs;
        };
        for (var j = 0; j < filteredJobCount[0].children.length; j++) {
            _loop_2(j);
        }
    };
    // Merge parent
    for (var i = 0; i < options.length; i++) {
        _loop_1(i);
    }
    // Merge children
    return [mergedParents, mergedChildrens];
};
var mergeProps = function (props) {
    var _a, _b;
    var floatingConfig = props.floatingConfig, options = props.options, langCode = props.langCode, styleOptions = props.styleOptions, selectOptions = props.selectOptions, textOptions = props.textOptions;
    var parent = options.parent, children = options.children, jobCount = options.jobCount, isEnableSearchAPI = options.isEnableSearchAPI;
    // Merge floating config
    var mergedFloatingConfig = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_FLOATING_CONFIG */ .G6), floatingConfig);
    var mergedStyleOptions = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_STYLE_OPTION */ .eY), styleOptions);
    var mergedSelectOptions = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_SELECT_OPTIONS */ .mt), selectOptions);
    var mergedTextOptions = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_TEXT_OPTIONS */ .Y4), textOptions);
    // Sort parent, children option first
    var sortedParent = (0,_TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .sortOptionsAlphabet */ .t_)(parent, true);
    // Remove 'Others' || 'Khác' parent out of array then push it to bottom
    var filteredOther = sortedParent.filter(function (item) { return item.id === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .OTHER_PARENT_ID */ .br; });
    sortedParent = sortedParent.filter(function (item) { return item.id !== _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .OTHER_PARENT_ID */ .br; });
    if (filteredOther.length > 0) {
        sortedParent.push(filteredOther[0]);
    }
    var sortedChildren = (0,_TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .sortChildOptionAlphabet */ .j5)(children, langCode, true);
    // Map job count to each job function
    var _c = mergeJobCount(sortedParent, sortedChildren, jobCount), optionParents = _c[0], optionChildrens = _c[1];
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, props), { lockTarget: (_a = props.lockTarget) !== null && _a !== void 0 ? _a : '', scrollLockMode: (_b = props.scrollLockMode) !== null && _b !== void 0 ? _b : 'hard', floatingConfig: mergedFloatingConfig, styleOptions: mergedStyleOptions, selectOptions: mergedSelectOptions, textOptions: mergedTextOptions, options: {
            parent: optionParents,
            children: optionChildrens,
            isEnableSearchAPI: isEnableSearchAPI
        } });
};
var sortSearchChildrenAlphabet = function (options, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var removedItem = null;
    var filteredHaveAllItem = options.filter(function (item) { return item.parentId === -1; });
    if (filteredHaveAllItem.length > 0) {
        removedItem = options.splice(0, 1);
    }
    options.sort(function (itemA, itemB) {
        if (itemA.parentName < itemB.parentName) {
            return -1;
        }
        if (itemA.parentName > itemB.parentName) {
            return 1;
        }
        return 0;
    });
    if (removedItem !== null) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], removedItem, true), options, true);
    }
    return options;
};
var getParentByChildrenId = function (id, parent, children) {
    var childrenIndexKey = Object.keys(children);
    var childrens = Object.values(children);
    var _loop_3 = function (i) {
        var parentItem = childrens[i];
        var filteredChildItems = parentItem.filter(function (item) { return item.id === id; });
        if (filteredChildItems.length === 0) {
            return "continue";
        }
        var parentId = Number(childrenIndexKey[i]);
        var filteredParent = parent.filter(function (item) { return item.id === parentId; });
        if (filteredParent.length === 0) {
            return "continue";
        }
        return { value: filteredParent[0] };
    };
    for (var i = 0; i < childrens.length; i++) {
        var state_1 = _loop_3(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return null;
};
var filterResult = function (_a) {
    var _b;
    var keyword = _a.keyword, parent = _a.parent, children = _a.children, langCode = _a.langCode;
    var childrenIndexKey = Object.keys(children);
    var childrens = Object.values(children);
    var formattedKeyword = (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .transformToLatin */ .nr)(keyword).toLowerCase();
    var responseParent = [];
    var responseChildren = [];
    var _loop_4 = function (i) {
        var child = childrens[i];
        // Looking for children name that match keyword
        var filteredChildren = child.filter(function (item) {
            var convertedItemName = (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .transformToLatin */ .nr)(langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .ELanguage.EN */ .Df.EN ? item.nameEn : item.name).toLowerCase();
            return convertedItemName.indexOf(formattedKeyword) >= 0;
        });
        if (filteredChildren.length === 0) {
            return "continue";
        }
        // Found match children
        var parentId = Number((_b = childrenIndexKey[i]) !== null && _b !== void 0 ? _b : '-1');
        var filteredParents = parent.filter(function (parentItem) { return parentItem.id === parentId; });
        var parentName = '';
        if (filteredParents.length > 0) {
            parentName = filteredParents[0].name;
            responseParent.push({
                id: parentId,
                name: parentName,
                jobs: filteredParents[0].jobs
            });
        }
        // Push to responseChildren array
        responseChildren.push({
            parentId: parentId,
            parentName: parentName,
            childrens: filteredChildren
        });
    };
    for (var i = 0; i < childrens.length; i++) {
        _loop_4(i);
    }
    // Filter parent
    var filteredParent = parent.filter(function (optionItem) {
        var convertedItemName = (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .transformToLatin */ .nr)(optionItem.name).toLowerCase();
        return convertedItemName.indexOf(formattedKeyword) >= 0;
    });
    var _loop_5 = function (i) {
        var firstItem = filteredParent[i];
        var filteredMatch = responseParent.filter(function (secondItem) { return secondItem.id === firstItem.id; });
        if (filteredMatch.length > 0) {
            return "continue";
        }
        responseParent.push(firstItem);
    };
    // Filter matched from children
    for (var i = 0; i < filteredParent.length; i++) {
        _loop_5(i);
    }
    // Sort parent by Alphabet
    var sortedParents = (0,_TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .sortOptionsAlphabet */ .t_)(responseParent, true);
    // Filter 'Khác' || 'Other' to bottom
    // Remove 'Others' || 'Khác' parent out of array then push it to bottom
    var filteredOther = sortedParents.filter(function (item) { return item.id === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .OTHER_PARENT_ID */ .br; });
    sortedParents = sortedParents.filter(function (item) { return item.id !== _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .OTHER_PARENT_ID */ .br; });
    if (filteredOther.length > 0) {
        sortedParents.push(filteredOther[0]);
    }
    var sortedChildrens = sortSearchChildrenAlphabet(responseChildren, true);
    return [sortedParents, sortedChildrens];
};
var getFilteredDuplicateChildren = function (filteredChildren, searchResult) {
    var jobFunctions = searchResult.jobFunctions;
    var filteredDuplicateChildren = [];
    var _loop_6 = function (i) {
        var childItem = filteredChildren[i];
        if (!childItem || jobFunctions.some(function (item) { return item.id === childItem.parentId; })) {
            filteredDuplicateChildren.push(jobFunctions[filteredDuplicateChildren.length]);
        }
    };
    // Only get response from API
    for (var i = 0; i < jobFunctions.length; i++) {
        _loop_6(i);
    }
    return filteredDuplicateChildren;
};
var mapToAPIResponseItems = function (filteredDuplicateChildren, parent, children) {
    var apiResponseItems = [];
    filteredDuplicateChildren.forEach(function (item) {
        var _a;
        if (!item) {
            return;
        }
        var parentInfo = getParentByChildrenId(item.id, parent, children);
        apiResponseItems.push({
            parentId: parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.id,
            parentName: (_a = parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.name) !== null && _a !== void 0 ? _a : '',
            childrens: [
                {
                    id: item.id,
                    name: item.attributes.nameVi,
                    nameEn: item.attributes.nameEn
                }
            ]
        });
    });
    return apiResponseItems;
};
var filterResultByAPI = function (_a) {
    var searchResult = _a.searchResult, parent = _a.parent, children = _a.children, langCode = _a.langCode, keyword = _a.keyword;
    var _b = filterResult({
        keyword: keyword,
        parent: parent,
        children: children,
        langCode: langCode
    }), filteredParent = _b[0], filteredChildren = _b[1];
    var filteredDuplicateChildren = getFilteredDuplicateChildren(filteredChildren, searchResult);
    var apiResponseItems = mapToAPIResponseItems(filteredDuplicateChildren, parent, children);
    return [filteredParent, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], filteredChildren, true), apiResponseItems, true)];
};
var getParentCheckState = function (parentId, temporaryValue) {
    var checkState = 'none';
    var filteredValue = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredValue.length > 0) {
        var isHaveAllOption = filteredValue[0].childrenIds.includes(-1);
        checkState = isHaveAllOption ? 'checked' : 'half';
    }
    return checkState;
};
var getChildrenCheckState = function (parentId, childrenId, temporaryValue) {
    var checkState = 'none';
    // Filter parent first
    var filteredValue = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredValue.length === 0) {
        return checkState;
    }
    // Get children from parent
    // parentId is unique so there is only one result
    var filteredChildrens = filteredValue[0].childrenIds.filter(function (item) { return item === childrenId; });
    if (filteredChildrens.length === 0) {
        return checkState;
    }
    checkState = 'checked';
    return checkState;
};
var getSelectedParentName = function (value, option) {
    var selectedValues = [];
    if (value.length === 0) {
        return [];
    }
    var _loop_7 = function (i) {
        var selectedParent = value[i];
        var filteredParents = option.filter(function (item) { return item.id === selectedParent.parentId; });
        if (filteredParents.length === 0) {
            return "continue";
        }
        selectedValues.push(filteredParents[0]);
    };
    for (var i = 0; i < value.length; i++) {
        _loop_7(i);
    }
    return selectedValues;
};
var getSelectedSingleChildrenName = function (value, children) {
    if (value.length === 0) {
        return null;
    }
    if (value[0].childrenIds.length === 0) {
        return null;
    }
    var selectedChildId = value[0].childrenIds[0];
    var childrens = Object.values(children);
    // Filter children
    var responseChildren = null;
    for (var i = 0; i < childrens.length; i++) {
        var parentItem = childrens[i];
        var filteredChildren = parentItem.filter(function (item) { return item.id === selectedChildId; });
        if (filteredChildren.length === 0) {
            continue;
        }
        responseChildren = filteredChildren[0];
    }
    return responseChildren;
};
var countSelectedChildrenFromParentId = function (parentId, temporaryValue) {
    var _a, _b, _c;
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredParents.length <= 0) {
        return 0;
    }
    if (filteredParents[0].childrenIds.length === 0) {
        return 0;
    }
    if (filteredParents[0].childrenIds[0] === -1) {
        return -1;
    }
    return (_c = (_b = (_a = filteredParents[0]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 1136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Cascader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/Cascader.css.js
'use client';




var CascaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    position: relative;\n"], ["\n    width: ", ";\n    position: relative;\n"])), function (_a) {
    var isFlex = _a.isFlex;
    return (isFlex ? '100%' : 'fit-content');
});
var templateObject_1;


//# sourceMappingURL=Cascader.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/constants.js
var Cascader_constants = __webpack_require__(75113);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/context/index.js
'use client';




var initialCascaderState = {
    keyword: '',
    isShow: false,
    parentId: -1,
    hoverParentId: -1,
    viewIndex: Cascader_constants/* VIEWINDEX.LEFT */.bX.LEFT,
    isHover: false,
    value: [],
    temporaryValue: [],
    scrollPosition: {
        left: 0,
        right: 0
    },
    searchResult: {
        groupJobFunctions: [],
        jobFunctions: []
    }
};
var initialCascaderProps = {
    langCode: constants/* ELanguage.VI */.Df.VI,
    isMobile: false,
    floatingConfig: Cascader_constants/* DEFAULT_FLOATING_CONFIG */.G6,
    value: [],
    hasError: false,
    options: {
        parent: [],
        children: {},
        jobCount: [],
        isEnableSearchAPI: false
    },
    onConfirm: function (_) { },
    onCancel: function (_) { },
    onBlur: function () { },
    styleOptions: {
        isFlex: false,
        placeholderColor: '',
        isShowSecondaryBtn: false,
        primaryBtnType: 'primary',
        secondaryBtnType: 'primary'
    },
    selectOptions: {
        isSingleSelect: false,
        displayAsPopup: false,
        hiddenFooter: false
    },
    textOptions: {
        placeholder: '',
        primaryBtnText: '',
        secondaryBtnText: ''
    },
    msBaseUrl: 'https://staging-ms.vietnamworks.com',
    lockTarget: '',
    scrollLockMode: 'hard'
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/context/actions.js
'use client';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "SHOW";
    ACTIONS["HIDE"] = "HIDE";
    ACTIONS["TOGGLE"] = "TOGGLE";
    ACTIONS["SET_KEYWORD"] = "SET_KEYWORD";
    ACTIONS["APPLY_CALLBACK"] = "APPLY_CALLBACK";
    ACTIONS["SYNC_TEMPORARY_TO_VALUE"] = "SYNC_TEMPORARY_TO_VALUE";
    ACTIONS["SET_SELECT_PARENT_ID"] = "SET_SELECT_PARENT_ID";
    ACTIONS["MOBILE_SET_SELECT_PARENT_ID"] = "MOBILE_SET_SELECT_PARENT_ID";
    ACTIONS["REMOVE_SELECTED_OR_HOVER"] = "REMOVE_SELECTED_OR_HOVER";
    ACTIONS["SET_HOVER"] = "SET_HOVER";
    ACTIONS["SET_HOVER_ID"] = "SET_HOVER_ID";
    ACTIONS["SET_MOUSE_LEAVE"] = "SET_MOUSE_LEAVE";
    ACTIONS["SET_TEMPORARY_VALUE"] = "SET_TEMPORARY_VALUE";
    ACTIONS["SET_SINGLE_TEMPORARY_VALUE"] = "SET_SINGLE_TEMPORARY_VALUE";
    ACTIONS["REMOVE_ALL_TEMPORARY_VALUE"] = "REMOVE_ALL_TEMPORARY_VALUE";
    ACTIONS["REMOVE_PARENT_ID"] = "REMOVE_PARENT_ID";
    ACTIONS["SET_VALUE_FROM_PROP"] = "SET_VALUE_FROM_PROP";
    ACTIONS["ON_CANCEL"] = "ON_CANCEL";
    ACTIONS["ON_CONFIRM"] = "ON_CONFIRM";
    ACTIONS["ON_DROPDOWN_ITEM_FOCUS"] = "ON_DROPDOWN_ITEM_FOCUS";
    ACTIONS["SET_SEARCH_RESULT"] = "SET_SEARCH_RESULT";
})(ACTIONS || (ACTIONS = {}));


//# sourceMappingURL=actions.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/helpers.js
var helpers = __webpack_require__(33294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/context/childReducer/selectReducer.js
'use client';




var setTemporaryValue = function (state, action) {
    var _a, _b;
    var temporaryValue = (0,helpers/* deepCloneArray */.NU)(state.temporaryValue);
    var formattedPayload = action.payload;
    var _c = formattedPayload.parentId, parentId = _c === void 0 ? -1 : _c, _d = formattedPayload.childrenId, childrenId = _d === void 0 ? -1 : _d, children = formattedPayload.children;
    // 0. No parent
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredParents.length === 0) {
        // Dont have parent
        // Easy case push all to temporaryValue
        var updateChildrenIds = [childrenId];
        // Check if parent have only 1 children or not
        var childrenList_1 = (0,helpers/* getChildrenListByParentId */.fq)(parentId.toString(), children);
        if (childrenList_1.length === 1) {
            updateChildrenIds = [-1];
        }
        temporaryValue.push({
            parentId: parentId,
            childrenIds: updateChildrenIds
        });
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
    }
    var selectedChildrenIds = filteredParents[0].childrenIds;
    // HAVE PARENT
    // 1. REMOVE parent when user select '-1' again
    if (selectedChildrenIds.includes(-1) && childrenId === -1) {
        temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
    }
    // Select another item
    var filteredChildrenId = selectedChildrenIds.filter(function (item) { return item === childrenId; });
    var parentIndex = temporaryValue.findIndex(function (item) { return item.parentId === parentId; });
    // 2. Have children ids already but user select '-1'
    if (!selectedChildrenIds.includes(-1) && childrenId === -1) {
        // set to all
        temporaryValue[parentIndex].childrenIds = [-1];
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
    }
    // 3. Already exist then remove it
    if (filteredChildrenId.length > 0) {
        temporaryValue[parentIndex].childrenIds = temporaryValue[parentIndex].childrenIds.filter(function (item) { return item !== childrenId; });
        // 3.1 Remove parent out of array when there is no children remain
        if (temporaryValue[parentIndex].childrenIds.length === 0) {
            temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        }
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
    }
    // 4. From all item (-1) to remain item
    if (selectedChildrenIds.length === 1 && selectedChildrenIds[0] === -1 && childrenId !== -1) {
        var childrenList_2 = (0,helpers/* getChildrenListByParentId */.fq)(parentId.toString(), children);
        var filteredOutItem = childrenList_2.filter(function (item) { return item.id !== childrenId; });
        var selectedItems = filteredOutItem.map(function (item) { return item.id; });
        temporaryValue[parentIndex].childrenIds = selectedItems;
        // 4.1 Remove parent out of array when there is no children remain
        if (selectedItems.length === 0) {
            // No more item remains in parent then remove parent too
            temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        }
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
    }
    // 5. Doesn't exist then add it
    temporaryValue[parentIndex].childrenIds.push(childrenId);
    // 5.1 Check max then set back to all
    var currentCountItem = (_b = (_a = temporaryValue[parentIndex]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length;
    var childrenList = (0,helpers/* getChildrenListByParentId */.fq)(parentId.toString(), children);
    if (childrenList.length === currentCountItem) {
        temporaryValue[parentIndex].childrenIds = [-1];
    }
    return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: temporaryValue });
};
var removeParentId = function (state, parentId) {
    var temporaryValue = state.temporaryValue;
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
    return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: filteredParents, value: filteredParents });
};


//# sourceMappingURL=selectReducer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/context/childReducer/selectSingleReducer.js
'use client';



var setSingleTemporaryValue = function (state, action) {
    var formattedPayload = action.payload;
    var _a = formattedPayload.parentId, parentId = _a === void 0 ? -1 : _a, _b = formattedPayload.childrenId, childrenId = _b === void 0 ? -1 : _b;
    return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: [
            {
                parentId: parentId,
                childrenIds: [childrenId]
            }
        ] });
};


//# sourceMappingURL=selectSingleReducer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/context/reducer.js
'use client';










var cascaderReducer = function (state, action) {
    var type = action.type;
    switch (type) {
        case ACTIONS.SHOW: {
            // clone from value to temporaryValue (Refresh)
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: true, temporaryValue: state.value });
        }
        case ACTIONS.HIDE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: false });
        }
        case ACTIONS.TOGGLE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: action.payload });
        }
        case ACTIONS.SET_KEYWORD: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { keyword: action.payload });
        }
        case ACTIONS.APPLY_CALLBACK: {
            typeof action.payload === 'function' && action.payload(state.temporaryValue);
            return state;
        }
        case ACTIONS.SYNC_TEMPORARY_TO_VALUE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { value: state.temporaryValue });
        }
        case ACTIONS.SET_SELECT_PARENT_ID: {
            var parentId = action.payload;
            var viewIndex = parentId !== -1 ? Cascader_constants/* VIEWINDEX.RIGHT */.bX.RIGHT : Cascader_constants/* VIEWINDEX.LEFT */.bX.LEFT;
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { parentId: parentId, viewIndex: viewIndex });
        }
        case ACTIONS.MOBILE_SET_SELECT_PARENT_ID: {
            var _a = action.payload, parentId = _a.parentId, leftScrollPosition = _a.leftScrollPosition;
            var viewIndex = parentId !== -1 ? Cascader_constants/* VIEWINDEX.RIGHT */.bX.RIGHT : Cascader_constants/* VIEWINDEX.LEFT */.bX.LEFT;
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { parentId: parentId, viewIndex: viewIndex, scrollPosition: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state.scrollPosition), { left: leftScrollPosition }) });
        }
        case ACTIONS.REMOVE_SELECTED_OR_HOVER: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isHover: false, hoverParentId: -1, parentId: -1 });
        }
        case ACTIONS.SET_HOVER: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isHover: action.payload });
        }
        case ACTIONS.SET_HOVER_ID: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { hoverParentId: action.payload, isHover: true });
        }
        case ACTIONS.SET_MOUSE_LEAVE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { hoverParentId: -1, isHover: false });
        }
        case ACTIONS.SET_TEMPORARY_VALUE: {
            var clonedState = (0,helpers/* deepCloneObject */.kh)(state);
            return setTemporaryValue(clonedState, action);
        }
        case ACTIONS.SET_SINGLE_TEMPORARY_VALUE: {
            var clonedState = (0,helpers/* deepCloneObject */.kh)(state);
            return setSingleTemporaryValue(clonedState, action);
        }
        case ACTIONS.REMOVE_ALL_TEMPORARY_VALUE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { temporaryValue: [] });
        }
        case ACTIONS.ON_CANCEL: {
            // Reset temporaryValue and close drop down
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: false, temporaryValue: state.value, keyword: '', parentId: -1, hoverParentId: -1 });
        }
        case ACTIONS.ON_CONFIRM: {
            // Copy temporaryValue to value
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: false, value: state.temporaryValue, keyword: '', parentId: -1, hoverParentId: -1 });
        }
        case ACTIONS.SET_VALUE_FROM_PROP: {
            var newValue = action.payload;
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isShow: false, value: newValue, temporaryValue: newValue });
        }
        case ACTIONS.REMOVE_PARENT_ID: {
            var clonedState = (0,helpers/* deepCloneObject */.kh)(state);
            // Modify directly value and temporaryValue
            return removeParentId(clonedState, action.payload);
        }
        case ACTIONS.ON_DROPDOWN_ITEM_FOCUS: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { hoverParentId: action.payload, isHover: true, viewIndex: Cascader_constants/* VIEWINDEX.LEFT */.bX.LEFT });
        }
        case ACTIONS.SET_SEARCH_RESULT: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { searchResult: action.payload });
        }
        default:
            console.error('Unknown type of Reducer');
            return (0,_tslib/* __assign */.pi)({}, state);
    }
};
var CascaderContext = (0,react.createContext)({
    state: initialCascaderState,
    props: initialCascaderProps,
    t: function (_) { return ''; },
    dispatch: function () { }
});


//# sourceMappingURL=reducer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/translations.js
'use client';

var translations = {
    Search: 'Tìm kiếm',
    Cancel: 'Hủy',
    'No result': 'Không có kết quả',
    'Job Function': 'Ngành nghề',
    'All job function': 'Ngành nghề',
    'Select job function.': 'Hãy chọn nghề nghiệp chuyên môn.',
    'Remove all': 'Xóa tất cả',
    All: 'Tất cả'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/InputContainer/InputContainer.css.js
'use client';






var dimAnim = (0,styled_components_browser_esm/* keyframes */.F4)(InputContainer_css_templateObject_1 || (InputContainer_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var ArrowDownContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
var SelectedName = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    overflow: hidden;\n    padding: 4px;\n"], ["\n    overflow: hidden;\n    padding: 4px;\n"])));
var RemoveSpan = styled_components_browser_esm/* default.span */.ZP.span(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"], ["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"])));
var EmptyItem = styled_components_browser_esm/* default.span */.ZP.span(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: ", ";\n    line-height: ", ";\n    padding: ", ";\n    font-size: 14px;\n    white-space: nowrap;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    color: ", ";\n"], ["\n    height: ", ";\n    line-height: ", ";\n    padding: ", ";\n    font-size: 14px;\n    white-space: nowrap;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    color: ", ";\n"])), function (_a) {
    var forResponsive = _a.forResponsive;
    return (!forResponsive ? '30px' : '22px');
}, function (_a) {
    var forResponsive = _a.forResponsive;
    return (!forResponsive ? '30px' : '22px');
}, function (_a) {
    var clearSpaceLeft = _a.clearSpaceLeft;
    return (!clearSpaceLeft ? '0 8px' : '0 8px 0 0');
}, function (_a) {
    var placeholderColor = _a.placeholderColor;
    return (!placeholderColor ? '#999' : placeholderColor);
});
var OverflowWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: auto;\n    display: flex;\n"], ["\n    width: auto;\n    display: flex;\n"])));
var Label = styled_components_browser_esm/* default.span */.ZP.span(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var ParentItemWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    line-height: 20px;\n    color: #333;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: max-content;\n\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n\n    ", "\n"], ["\n    font-size: 14px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    line-height: 20px;\n    color: #333;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: max-content;\n\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n\n    ", "\n"])), dimAnim, function (_a) {
    var isSingle = _a.isSingle, selectLayout = _a.selectLayout;
    if (selectLayout === 'highlight') {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background-color: ", ";\n                border: 1px solid ", ";\n                color: ", ";\n\n                svg path {\n                    fill: ", ";\n                }\n            "], ["\n                background-color: ", ";\n                border: 1px solid ", ";\n                color: ", ";\n\n                svg path {\n                    fill: ", ";\n                }\n            "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.30 */.O9.primary[30], Colors/* colors.primary.30 */.O9.primary[30]);
    }
    if (isSingle) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                border: 1px solid transparent;\n            "], ["\n                border: 1px solid transparent;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: #eff5ff;\n            border: 1px solid #eff5ff;\n            color: #003699;\n        "], ["\n            background-color: #eff5ff;\n            border: 1px solid #eff5ff;\n            color: #003699;\n        "])));
}, function (_a) {
    var isHaveRemoveIcon = _a.isHaveRemoveIcon;
    return isHaveRemoveIcon && (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-right: 26px !important;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "], ["\n            padding-right: 26px !important;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "])), RemoveSpan);
});
var InputContainerWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    border: 1px solid ", ";\n    height: 40px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n    color: ", ";\n    cursor: pointer;\n    user-select: none;\n    > svg {\n        margin-left: 8px;\n    }\n\n    &:hover {\n        border: 1px solid ", ";\n    }\n\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n"], ["\n    background-color: #fff;\n    border: 1px solid ", ";\n    height: 40px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n    color: ", ";\n    cursor: pointer;\n    user-select: none;\n    > svg {\n        margin-left: 8px;\n    }\n\n    &:hover {\n        border: 1px solid ", ";\n    }\n\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n"])), Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.20 */.O9.grey[20], constants/* colors.borderHover */.O9.borderHover, function (_a) {
    var isShow = _a.isShow;
    return isShow && (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n        "], ["\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n        "])), constants/* colors.borderFocus */.O9.borderFocus, constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var hasError = _a.hasError;
    if (!hasError) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid #ff4a53;\n            &:hover {\n                border: 1px solid #ff4a53;\n            }\n        "], ["\n            border: 1px solid #ff4a53;\n            &:hover {\n                border: 1px solid #ff4a53;\n            }\n        "])));
}, function (_a) {
    var isFlex = _a.isFlex;
    if (!isFlex) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            justify-content: space-between;\n        "], ["\n            justify-content: space-between;\n        "])));
}, function (_a) {
    var selectLayout = _a.selectLayout, hasValue = _a.hasValue;
    return selectLayout === 'highlight' &&
        hasValue && (0,styled_components_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n        "], ["\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n        "])), constants/* colors.borderFocus */.O9.borderFocus, constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var forResponsive = _a.forResponsive;
    return forResponsive && (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            height: 32px;\n            background: #f1f2f4;\n            border: 1px solid transparent;\n\n            &:hover {\n                border-color: transparent;\n            }\n\n            ", " {\n                width: 30px;\n                height: 30px;\n            }\n            ", " {\n                background: none;\n                padding: 0;\n            }\n            ", " {\n                padding: 0;\n            }\n        "], ["\n            height: 32px;\n            background: #f1f2f4;\n            border: 1px solid transparent;\n\n            &:hover {\n                border-color: transparent;\n            }\n\n            ", " {\n                width: 30px;\n                height: 30px;\n            }\n            ", " {\n                background: none;\n                padding: 0;\n            }\n            ", " {\n                padding: 0;\n            }\n        "])), ArrowDownContainer, ParentItemWrapper, EmptyItem);
}, function (_a) {
    var forResponsive = _a.forResponsive, hasValue = _a.hasValue;
    return forResponsive &&
        hasValue && (0,styled_components_browser_esm/* css */.iv)(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background: #eff5ff;\n\n            svg {\n                path {\n                    fill: rgb(0, 54, 153) !important;\n                }\n            }\n        "], ["\n            background: #eff5ff;\n\n            svg {\n                path {\n                    fill: rgb(0, 54, 153) !important;\n                }\n            }\n        "])));
});
var InputContainer_css_templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;


//# sourceMappingURL=InputContainer.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/helper.js
var helper = __webpack_require__(90081);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CheckTagIcon/index.js
var CheckTagIcon = __webpack_require__(17362);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/InputContainer/components/ParentItem/index.js
'use client';








var ParentItem = function (params) {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch;
    var id = params.id, label = params.label, _b = params.isHaveRemoveIcon, isHaveRemoveIcon = _b === void 0 ? false : _b;
    var onConfirm = props.onConfirm, selectOptions = props.selectOptions, selectLayout = props.selectLayout;
    var value = state.value;
    var onRemoveItem = function (e) {
        e.stopPropagation();
        dispatch({
            type: ACTIONS.REMOVE_PARENT_ID,
            payload: id
        });
        var clonedTemporary = (0,helpers/* deepCloneArray */.NU)(value);
        var filteredParents = clonedTemporary.filter(function (item) { return item.parentId !== id; });
        onConfirm && onConfirm(filteredParents);
    };
    return (0,react.useMemo)(function () { return (react.createElement(ParentItemWrapper, { "data-item-id": id, isSingle: selectOptions.isSingleSelect, isHaveRemoveIcon: isHaveRemoveIcon, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
        react.createElement(Label, null, label),
        isHaveRemoveIcon && (react.createElement(RemoveSpan, { onClick: onRemoveItem },
            react.createElement(CheckTagIcon/* default */.Z, null))))); }, [id, label, value]);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/InputContainer/components/OverflowItems/index.js
'use client';








var OverflowItems = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state;
    var options = props.options, selectOptions = props.selectOptions, langCode = props.langCode;
    var isShow = state.isShow, temporaryValue = state.temporaryValue, value = state.value;
    return (0,react.useMemo)(function () {
        var displayValue = isShow ? temporaryValue : value;
        var selectedParentName = null;
        var selectedChildren = null;
        if (selectOptions.isSingleSelect) {
            selectedChildren = (0,helper/* getSelectedSingleChildrenName */.Nb)(displayValue, options.children);
        }
        else {
            selectedParentName = (0,helper/* getSelectedParentName */.AU)(displayValue, options.parent);
        }
        return (react.createElement(OverflowWrapper, null, selectOptions.isSingleSelect ? (react.createElement(react.Fragment, null, selectedChildren !== null && (react.createElement(ParentItem, { label: langCode === constants/* ELanguage.EN */.Df.EN ? selectedChildren.nameEn : selectedChildren.name, id: selectedChildren.id, isHaveRemoveIcon: false })))) : (react.createElement(react.Fragment, null,
            selectedParentName !== null && selectedParentName.length > 0 && (react.createElement(ParentItem, { label: selectedParentName[0].name, id: selectedParentName[0].id, isHaveRemoveIcon: true })),
            selectedParentName !== null && selectedParentName.length > 1 && (react.createElement(ParentItem, { label: "+".concat(selectedParentName.length - 1), id: -1 }))))));
    }, [isShow, options.parent, options.children, temporaryValue, value, langCode]);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/InputContainer/index.js
'use client';








var InputContainer = (0,react.forwardRef)(function (_, ref) {
    var _a = (0,react.useContext)(CascaderContext), state = _a.state, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isShow = state.isShow, temporaryValue = state.temporaryValue, value = state.value;
    var hasError = props.hasError, styleOptions = props.styleOptions, textOptions = props.textOptions, forResponsive = props.forResponsive, selectLayout = props.selectLayout;
    var handleOnClick = function () {
        if (isShow) {
            dispatch({
                type: ACTIONS.ON_CANCEL
            });
        }
        else {
            dispatch({
                type: ACTIONS.TOGGLE,
                payload: true
            });
        }
    };
    return (0,react.useMemo)(function () {
        return (react.createElement(InputContainerWrapper, { isFlex: styleOptions.isFlex, hasError: hasError, hasValue: temporaryValue.length > 0, onClick: handleOnClick, ref: ref, forResponsive: forResponsive, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type, "data-input-container": true },
            react.createElement(SelectedName, null, temporaryValue.length === 0 ? (react.createElement(EmptyItem, { placeholderColor: styleOptions.placeholderColor, clearSpaceLeft: styleOptions.clearSpaceLeft, forResponsive: forResponsive }, textOptions.placeholder === '' ? t('All job function') : textOptions.placeholder)) : (react.createElement(OverflowItems, null))),
            react.createElement(ArrowDownContainer, null,
                react.createElement(ArrowDownIcon/* default */.Z, { width: 20, height: 20 }))));
    }, [isShow, hasError, temporaryValue, value]);
});
var InputContainer$1 = react.memo(InputContainer);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownContainer/DropdownContainer.css.js
'use client';






var openResponsivePopup = (0,styled_components_browser_esm/* keyframes */.F4)(DropdownContainer_css_templateObject_1 || (DropdownContainer_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        top: 150%;\n    }\n    100% {\n        top: 0%;\n    }\n"], ["\n    0% {\n        top: 150%;\n    }\n    100% {\n        top: 0%;\n    }\n"])));
var closeResponsivePopup = (0,styled_components_browser_esm/* keyframes */.F4)(DropdownContainer_css_templateObject_2 || (DropdownContainer_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        top: 0%;\n    }\n    100% {\n        top: 150%;\n    }\n"], ["\n    0% {\n        top: 0%;\n    }\n    100% {\n        top: 150%;\n    }\n"])));
var DropdownContainerWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownContainer_css_templateObject_6 || (DropdownContainer_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    width: ", ";\n    max-height: 480px;\n    z-index: 1101;\n    ", "\n\n    ", "\n"], ["\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    width: ", ";\n    max-height: 480px;\n    z-index: 1101;\n    ", "\n\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '100%' : '710px');
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(DropdownContainer_css_templateObject_3 || (DropdownContainer_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                will-change: transform;\n                overflow: hidden;\n                ", ";\n            "], ["\n                will-change: transform;\n                overflow: hidden;\n                ", ";\n            "])), function (_a) {
            var isShow = _a.isShow;
            return styledCss/* default.dropdownAnimation */.ZP.dropdownAnimation(isShow);
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownContainer_css_templateObject_4 || (DropdownContainer_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: none;\n            box-shadow: none;\n            padding: 0;\n            position: fixed;\n            top: 0;\n            left: 0;\n            width: 100vw;\n            height: 100vh;\n            max-height: 100vh;\n            animation: ", " 0.25s ease-in-out\n                forwards;\n        "], ["\n            border: none;\n            box-shadow: none;\n            padding: 0;\n            position: fixed;\n            top: 0;\n            left: 0;\n            width: 100vw;\n            height: 100vh;\n            max-height: 100vh;\n            animation: ", " 0.25s ease-in-out\n                forwards;\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? openResponsivePopup : closeResponsivePopup);
    });
}, function (_a) {
    var isSingleSelect = _a.isSingleSelect;
    if (!isSingleSelect) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownContainer_css_templateObject_5 || (DropdownContainer_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: 100%;\n            box-shadow: none;\n            border: none;\n        "], ["\n            width: 100%;\n            box-shadow: none;\n            border: none;\n        "])));
});
var Title = styled_components_browser_esm/* default.div */.ZP.div(DropdownContainer_css_templateObject_7 || (DropdownContainer_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 10px 0;\n\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    color: ", ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 10px 0;\n\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownContainer_css_templateObject_8 || (DropdownContainer_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    input {\n        background-color: ", " !important;\n        border: 1px solid ", ";\n        &:hover {\n            background-color: ", " !important;\n        }\n    }\n"], ["\n    input {\n        background-color: ", " !important;\n        border: 1px solid ", ";\n        &:hover {\n            background-color: ", " !important;\n        }\n    }\n"])), Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95]);
var EmptyFooter = styled_components_browser_esm/* default.div */.ZP.div(DropdownContainer_css_templateObject_9 || (DropdownContainer_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 20px;\n"], ["\n    margin-top: 20px;\n"])));
var DropdownContainer_css_templateObject_1, DropdownContainer_css_templateObject_2, DropdownContainer_css_templateObject_3, DropdownContainer_css_templateObject_4, DropdownContainer_css_templateObject_5, DropdownContainer_css_templateObject_6, DropdownContainer_css_templateObject_7, DropdownContainer_css_templateObject_8, DropdownContainer_css_templateObject_9;


//# sourceMappingURL=DropdownContainer.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/DropdownBody.css.js
'use client';




var DropdownBodyWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownBody_css_templateObject_4 || (DropdownBody_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: ", ";\n    margin-bottom: 4px;\n    display: flex;\n    padding: 0 16px;\n    // Total-Height: 480px\n    // Header: 96px\n    // isHaveItem: 38px\n    // Footer: 80px\n    // FakeFooter: 20px\n    // Body: isHaveItem margin-top: 4px OR margin-top: 20px\n    ", "\n    ", "\n"], ["\n    margin-top: ", ";\n    margin-bottom: 4px;\n    display: flex;\n    padding: 0 16px;\n    // Total-Height: 480px\n    // Header: 96px\n    // isHaveItem: 38px\n    // Footer: 80px\n    // FakeFooter: 20px\n    // Body: isHaveItem margin-top: 4px OR margin-top: 20px\n    ", "\n    ", "\n"])), function (_a) {
    var isHaveItem = _a.isHaveItem;
    return (isHaveItem ? '4px' : '20px');
}, function (_a) {
    var isSingleSelect = _a.isSingleSelect;
    if (isSingleSelect) {
        return (0,styled_components_browser_esm/* css */.iv)(DropdownBody_css_templateObject_1 || (DropdownBody_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                // Total-Height - Header - FakeFooter - isHaveItem = 326px\n                // 480px - 96px - 38px - 20px = 326px\n                // Total-Height - Header - FakeFooter = 344px\n                // 480px - 96px - 20px - 20px = 344px\n                max-height: ", ";\n            "], ["\n                // Total-Height - Header - FakeFooter - isHaveItem = 326px\n                // 480px - 96px - 38px - 20px = 326px\n                // Total-Height - Header - FakeFooter = 344px\n                // 480px - 96px - 20px - 20px = 344px\n                max-height: ", ";\n            "])), function (_a) {
            var isHaveItem = _a.isHaveItem;
            return (isHaveItem ? '326px' : '344px');
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownBody_css_templateObject_2 || (DropdownBody_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            // Total-Height - Header - Footer - isHaveItem - Body-Margin = 258px\n            // 480px - 96px - 80px - 38px - 4px - 4px = 258px\n            // Total-Height - Header - Footer - Body-Margin = 280px\n            // 480px - 96px - 80px - 4px - 20px = 280px\n            max-height: ", ";\n        "], ["\n            // Total-Height - Header - Footer - isHaveItem - Body-Margin = 258px\n            // 480px - 96px - 80px - 38px - 4px - 4px = 258px\n            // Total-Height - Header - Footer - Body-Margin = 280px\n            // 480px - 96px - 80px - 4px - 20px = 280px\n            max-height: ", ";\n        "])), function (_a) {
        var isHaveItem = _a.isHaveItem;
        return (isHaveItem ? '258px' : '280px');
    });
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownBody_css_templateObject_3 || (DropdownBody_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: relative;\n            margin: 0 !important;\n            // Header: 96px + 38px\n            // Footer: 80px\n            height: ", ";\n            max-height: ", ";\n            @supports (height: 100dvh) {\n                height: ", ";\n                max-height: ", ";\n            }\n        "], ["\n            position: relative;\n            margin: 0 !important;\n            // Header: 96px + 38px\n            // Footer: 80px\n            height: ", ";\n            max-height: ", ";\n            @supports (height: 100dvh) {\n                height: ", ";\n                max-height: ", ";\n            }\n        "])), function (_a) {
        var isHaveItem = _a.isHaveItem;
        return (isHaveItem ? 'calc(100vh - 214px)' : 'calc(100vh - 176px)');
    }, function (_a) {
        var isHaveItem = _a.isHaveItem;
        return (isHaveItem ? 'calc(100vh - 214px)' : 'calc(100vh - 176px)');
    }, function (_a) {
        var isHaveItem = _a.isHaveItem;
        return (isHaveItem ? 'calc(100dvh - 214px)' : 'calc(100dvh - 176px)');
    }, function (_a) {
        var isHaveItem = _a.isHaveItem;
        return (isHaveItem ? 'calc(100dvh - 214px)' : 'calc(100dvh - 176px)');
    });
});
var DropdownBody_css_templateObject_1, DropdownBody_css_templateObject_2, DropdownBody_css_templateObject_3, DropdownBody_css_templateObject_4;


//# sourceMappingURL=DropdownBody.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/LeftColumnContent/LeftColumnContent.css.js
'use client';





var LeftColumnContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(LeftColumnContent_css_templateObject_2 || (LeftColumnContent_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n    ", "\n"], ["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '100%' : '50%');
}, styledCss/* default.scrollbar */.ZP.scrollbar, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(LeftColumnContent_css_templateObject_1 || (LeftColumnContent_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-bottom: 80px;\n            @supports (height: 100dvh) {\n                padding-bottom: 0;\n            }\n        "], ["\n            padding-bottom: 80px;\n            @supports (height: 100dvh) {\n                padding-bottom: 0;\n            }\n        "])));
});
var LeftColumnContent_css_templateObject_1, LeftColumnContent_css_templateObject_2;


//# sourceMappingURL=LeftColumnContent.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/DropdownItem/DropdownItem.css.js
'use client';





var DropdownItemWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownItem_css_templateObject_3 || (DropdownItem_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 3px 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    user-select: none;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        background-color: ", ";\n    }\n    ", "\n    ", "\n    [data-check-state] {\n        width: ", ";\n        label > span {\n            max-width: 100% !important;\n            width: 100% !important;\n        }\n    }\n"], ["\n    padding: 3px 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    user-select: none;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        background-color: ", ";\n    }\n    ", "\n    ", "\n    [data-check-state] {\n        width: ", ";\n        label > span {\n            max-width: 100% !important;\n            width: 100% !important;\n        }\n    }\n"])), Colors/* colors.primary.99 */.O9.primary[99], function (_a) {
    var isSelected = _a.isSelected;
    if (!isSelected) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownItem_css_templateObject_1 || (DropdownItem_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: ", ";\n        "], ["\n            background-color: ", ";\n        "])), Colors/* colors.primary.99 */.O9.primary[99]);
}, function (_a) {
    var isSelectedValue = _a.isSelectedValue;
    if (!isSelectedValue) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownItem_css_templateObject_2 || (DropdownItem_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: ", ";\n            color: ", ";\n        "], ["\n            background-color: ", ";\n            color: ", ";\n        "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.40 */.O9.primary[40]);
}, function (_a) {
    var isHaveChildren = _a.isHaveChildren;
    return (isHaveChildren ? 'calc(100% - 32px)' : '100%');
});
var JobCount = styled_components_browser_esm/* default.span */.ZP.span(DropdownItem_css_templateObject_4 || (DropdownItem_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), Colors/* colors.secondary.40 */.O9.secondary[40]);
var CheckBoxLabelWrapper = styled_components_browser_esm/* default.span */.ZP.span(DropdownItem_css_templateObject_5 || (DropdownItem_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var CheckBoxLabel = styled_components_browser_esm/* default.span */.ZP.span(DropdownItem_css_templateObject_6 || (DropdownItem_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    max-width: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: 400 !important;\n    margin-right: 4px;\n"], ["\n    max-width: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: 400 !important;\n    margin-right: 4px;\n"])), function (_a) {
    var isHaveJobCount = _a.isHaveJobCount;
    return (isHaveJobCount ? 'calc(100% - 38px)' : '100%');
});
var CountText = styled_components_browser_esm/* default.span */.ZP.span(DropdownItem_css_templateObject_7 || (DropdownItem_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #999;\n    font-size: 14px;\n    line-height: 14px;\n    margin-left: 8px;\n    display: flex;\n    align-items: center;\n"], ["\n    color: #999;\n    font-size: 14px;\n    line-height: 14px;\n    margin-left: 8px;\n    display: flex;\n    align-items: center;\n"])));
var SingleCheckItem = styled_components_browser_esm/* default.div */.ZP.div(DropdownItem_css_templateObject_8 || (DropdownItem_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: calc(100% - 32px);\n    padding: 10px 8px;\n    cursor: pointer;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        background-color: ", ";\n    }\n"], ["\n    width: calc(100% - 32px);\n    padding: 10px 8px;\n    cursor: pointer;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        background-color: ", ";\n    }\n"])), Colors/* colors.primary.99 */.O9.primary[99]);
var DropdownItem_css_templateObject_1, DropdownItem_css_templateObject_2, DropdownItem_css_templateObject_3, DropdownItem_css_templateObject_4, DropdownItem_css_templateObject_5, DropdownItem_css_templateObject_6, DropdownItem_css_templateObject_7, DropdownItem_css_templateObject_8;


//# sourceMappingURL=DropdownItem.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/index.js + 1 modules
var CheckBox = __webpack_require__(95140);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/index.js + 2 modules
var GlyphIcons = __webpack_require__(12578);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var Utils_helpers = __webpack_require__(55613);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/HighlightText/index.js
'use client';




/**
 * Highlight matching keyword in children
 * - Case sensitive
 * - Can search even with or without unicode (transform to latin)
 * By: ThienTD
 *
 * @param {string} keyword
 * @param {string} children
 * @returns {React.ReactNode} that highlight matching keyword in children
 */
var HighlightText = function (params) {
    var _a = params.keyword, keyword = _a === void 0 ? '' : _a, _b = params.children, children = _b === void 0 ? '' : _b;
    var formattedKeyword = (0,Utils_helpers/* transformToLatin */.nr)(keyword === null || keyword === void 0 ? void 0 : keyword.trim()).toLowerCase();
    if (formattedKeyword === '') {
        return react.createElement(react.Fragment, null, children);
    }
    // formattedKeyword have value
    var convertedName = (0,Utils_helpers/* transformToLatin */.nr)(children).toLowerCase();
    var matchIndex = convertedName === null || convertedName === void 0 ? void 0 : convertedName.indexOf(formattedKeyword);
    if (matchIndex === -1) {
        return react.createElement(react.Fragment, null, children);
    }
    // Split children item to 3 parts (before, matched, after)
    var beforeMatchedText = children === null || children === void 0 ? void 0 : children.substring(0, matchIndex);
    var matchedText = children === null || children === void 0 ? void 0 : children.substring(matchIndex, matchIndex + (formattedKeyword === null || formattedKeyword === void 0 ? void 0 : formattedKeyword.length));
    var afterMatchedText = children === null || children === void 0 ? void 0 : children.substring(matchIndex + (formattedKeyword === null || formattedKeyword === void 0 ? void 0 : formattedKeyword.length), children === null || children === void 0 ? void 0 : children.length);
    // Join it again with highlight strong
    return (react.createElement(react.Fragment, null,
        beforeMatchedText,
        react.createElement("strong", { style: { fontWeight: 700 } }, matchedText),
        afterMatchedText));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/DropdownItem/index.js
'use client';











var DropdownItem = function (params) {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var label = params.label, id = params.id, parentId = params.parentId, _b = params.isHaveChildren, isHaveChildren = _b === void 0 ? false : _b, checkState = params.checkState, isSelected = params.isSelected, _c = params.isSelectedValue, isSelectedValue = _c === void 0 ? false : _c, _d = params.jobCount, jobCount = _d === void 0 ? 0 : _d, leftColumnRef = params.leftColumnRef, _e = params.selectedCount, selectedCount = _e === void 0 ? 0 : _e, _f = params.isHighlightText, isHighlightText = _f === void 0 ? false : _f;
    var options = props.options, isMobile = props.isMobile, langCode = props.langCode, selectOptions = props.selectOptions, onConfirm = props.onConfirm;
    var isHover = state.isHover, hoverParentId = state.hoverParentId, keyword = state.keyword, viewIndex = state.viewIndex;
    var selectedParentId = state.parentId;
    var onClickViewChild = function () {
        var _a, _b;
        if (!isHaveChildren) {
            return;
        }
        // Allow to de-select by click on that value again
        var selectedId = id;
        if (keyword === '' && selectedParentId === id) {
            selectedId = -1;
        }
        if (isMobile) {
            dispatch({
                type: ACTIONS.MOBILE_SET_SELECT_PARENT_ID,
                payload: {
                    parentId: selectedId,
                    leftScrollPosition: (_b = (_a = leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0
                }
            });
        }
        else {
            dispatch({
                type: ACTIONS.SET_SELECT_PARENT_ID,
                payload: selectedId
            });
        }
    };
    var onCheckChange = function () {
        if (isHaveChildren) {
            if (selectOptions.isSingleSelect) {
                onClickViewChild();
                return;
            }
            dispatch({
                type: ACTIONS.SET_TEMPORARY_VALUE,
                payload: {
                    parentId: id,
                    children: options.children
                }
            });
            if (selectOptions.hiddenFooter) {
                dispatch({
                    type: ACTIONS.APPLY_CALLBACK,
                    payload: onConfirm
                });
                dispatch({
                    type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
                });
            }
        }
        else {
            dispatch({
                type: selectOptions.isSingleSelect ? ACTIONS.SET_SINGLE_TEMPORARY_VALUE : ACTIONS.SET_TEMPORARY_VALUE,
                payload: {
                    parentId: parentId,
                    childrenId: id,
                    children: options.children
                }
            });
            if (selectOptions.hiddenFooter) {
                dispatch({
                    type: ACTIONS.APPLY_CALLBACK,
                    payload: onConfirm
                });
                dispatch({
                    type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
                });
            }
            if (selectOptions.isSingleSelect) {
                // onCofirm on single select is simple because it only return 1 value
                onConfirm &&
                    onConfirm([
                        {
                            parentId: parentId,
                            childrenIds: [id]
                        }
                    ]);
                dispatch({
                    type: ACTIONS.ON_CONFIRM
                });
            }
        }
    };
    var onMouseOver = function () {
        if (isMobile) {
            return;
        }
        if (!isHaveChildren) {
            return;
        }
        if (isHover && hoverParentId === id) {
            return;
        }
        dispatch({
            type: ACTIONS.SET_HOVER_ID,
            payload: id
        });
    };
    var onFocus = function () {
        if (isMobile || !isHaveChildren) {
            return;
        }
        dispatch({
            type: ACTIONS.ON_DROPDOWN_ITEM_FOCUS,
            payload: id
        });
    };
    var onKeyDown = function (e) {
        switch (e.code) {
            case Cascader_constants/* KEYCODE.SPACE */.Ps.SPACE: {
                e.preventDefault();
                onCheckChange();
                break;
            }
            case Cascader_constants/* KEYCODE.ARROW_RIGHT */.Ps.ARROW_RIGHT: {
                e.preventDefault();
                if (!isHaveChildren) {
                    break;
                }
                onClickViewChild();
                // Auto focus on first child
                setTimeout(function () {
                    var _a;
                    if (!(leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) || !leftColumnRef.current.parentElement) {
                        return;
                    }
                    var element = (_a = leftColumnRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(Cascader_constants/* QUERY_SELECTOR_FIRST_RIGHT_ELEMENT */.U_);
                    element === null || element === void 0 ? void 0 : element.focus();
                }, 50);
                break;
            }
        }
    };
    return (0,react.useMemo)(function () {
        var selectCountText = react.createElement(react.Fragment, null);
        if (selectedCount === -1) {
            selectCountText = react.createElement(CountText, null, t('All'));
        }
        else if (selectedCount > 0) {
            selectCountText = react.createElement(CountText, null, selectedCount);
        }
        var formattedLabel = react.createElement(react.Fragment, null, label);
        if (isHighlightText && keyword !== '') {
            formattedLabel = react.createElement(HighlightText, { keyword: keyword }, label);
        }
        // Render label
        var checkBoxLabel = (react.createElement(CheckBoxLabelWrapper, null,
            react.createElement(CheckBoxLabel, { isHaveJobCount: jobCount > 0 }, formattedLabel),
            jobCount > 0 && react.createElement(JobCount, null,
                "(",
                jobCount,
                ")"),
            (selectedCount === -1 || selectedCount > 0) && !selectOptions.isSingleSelect && react.createElement(react.Fragment, null, selectCountText)));
        var tabIndex = 0;
        if (parentId !== -1 && parentId !== id) {
            tabIndex = -1;
        }
        if (hoverParentId !== parentId) {
            tabIndex = -1;
        }
        // Current cursor on left column OR
        // For children (It always allowed to select)
        if (viewIndex === Cascader_constants/* VIEWINDEX.LEFT */.bX.LEFT || (viewIndex === Cascader_constants/* VIEWINDEX.RIGHT */.bX.RIGHT && !isHaveChildren)) {
            tabIndex = 0;
        }
        return (react.createElement(DropdownItemWrapper, { "data-id": id, "data-parent-id": parentId, isSelected: isSelected, isSelectedValue: selectOptions.isSingleSelect ? isSelectedValue : false, isHaveChildren: isHaveChildren, onMouseOver: onMouseOver, tabIndex: tabIndex, onFocus: onFocus, onKeyDown: onKeyDown },
            selectOptions.isSingleSelect ? (react.createElement(SingleCheckItem, { isChecked: checkState !== 'none', onClick: onCheckChange }, checkBoxLabel)) : (react.createElement(CheckBox/* default */.Z, { state: checkState, label: checkBoxLabel, onCheckChange: onCheckChange, tabIndex: -1 })),
            isHaveChildren && (react.createElement(Button/* default */.Z, { isIcon: true, isRounded: true, tabIndex: -1, outline: 'none', type: 'default', size: 'sm', onClick: onClickViewChild },
                react.createElement(GlyphIcons/* default.NextArrowIcon */.Z.NextArrowIcon, null)))));
    }, [
        checkState,
        id,
        hoverParentId,
        isHaveChildren,
        isSelected,
        label,
        parentId,
        jobCount,
        viewIndex,
        selectedCount,
        langCode,
        keyword,
        isHighlightText
    ]);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/ChildrenSearchFilter/ChildrenSearchFilter.css.js
'use client';





var ChildrenSearchFilterWrapper = styled_components_browser_esm/* default.div */.ZP.div(ChildrenSearchFilter_css_templateObject_2 || (ChildrenSearchFilter_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-right: 16px;\n    ", "\n"], ["\n    margin-right: 16px;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(ChildrenSearchFilter_css_templateObject_1 || (ChildrenSearchFilter_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin: 0;\n            p {\n                padding: 0 16px;\n            }\n        "], ["\n            margin: 0;\n            p {\n                padding: 0 16px;\n            }\n        "])));
});
var ChildrenItemWrapper = styled_components_browser_esm/* default.div */.ZP.div(ChildrenSearchFilter_css_templateObject_3 || (ChildrenSearchFilter_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ParentWrapper = styled_components_browser_esm/* default.div */.ZP.div(ChildrenSearchFilter_css_templateObject_5 || (ChildrenSearchFilter_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isBorder = _a.isBorder;
    if (!isBorder) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(ChildrenSearchFilter_css_templateObject_4 || (ChildrenSearchFilter_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-bottom: 1px solid ", ";\n        "], ["\n            border-bottom: 1px solid ", ";\n        "])), Colors/* colors.grey.90 */.O9.grey[90]);
});
var ChildrenSearchFilter_css_templateObject_1, ChildrenSearchFilter_css_templateObject_2, ChildrenSearchFilter_css_templateObject_3, ChildrenSearchFilter_css_templateObject_4, ChildrenSearchFilter_css_templateObject_5;


//# sourceMappingURL=ChildrenSearchFilter.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/RightColumnContent/RightColumnContent.css.js
'use client';






var RightColumnContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(RightColumnContent_css_templateObject_1 || (RightColumnContent_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n"], ["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '100%' : '50%');
}, styledCss/* default.scrollbar */.ZP.scrollbar);
var NotSelectedParent = styled_components_browser_esm/* default.div */.ZP.div(RightColumnContent_css_templateObject_2 || (RightColumnContent_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n"])));
var ChildrensContent = styled_components_browser_esm/* default.div */.ZP.div(RightColumnContent_css_templateObject_3 || (RightColumnContent_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ChildrensWrapper = styled_components_browser_esm/* default.div */.ZP.div(RightColumnContent_css_templateObject_4 || (RightColumnContent_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ParentTitle = styled_components_browser_esm/* default.span */.ZP.span(RightColumnContent_css_templateObject_5 || (RightColumnContent_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    display: block;\n    user-select: none;\n    padding: 8px;\n"], ["\n    color: ", ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    display: block;\n    user-select: none;\n    padding: 8px;\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var RightColumnContent_css_templateObject_1, RightColumnContent_css_templateObject_2, RightColumnContent_css_templateObject_3, RightColumnContent_css_templateObject_4, RightColumnContent_css_templateObject_5;


//# sourceMappingURL=RightColumnContent.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/ChildrenSearchFilter/index.js
'use client';











var ChildrenSearchFilter = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var options = props.options, langCode = props.langCode, isMobile = props.isMobile;
    var _b = options.parent, parent = _b === void 0 ? [] : _b, children = options.children;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue, searchResult = state.searchResult;
    var _c = (0,react.useState)(true), isLockAutoFocus = _c[0], setLockAutoFocus = _c[1];
    var debounceKeyword = (0,hooks/* default */.ZP)([keyword], 300);
    var _d = (0,react.useMemo)(function () {
        return (0,helper/* filterResultByAPI */.Dh)({
            searchResult: searchResult,
            parent: parent,
            children: children,
            keyword: keyword,
            langCode: langCode
        });
    }, [children, keyword, langCode, parent, searchResult]), filteredParent = _d[0], filteredChildren = _d[1];
    (0,react.useEffect)(function () {
        // No result found and already focus
        if (filteredParent.length === 0 && parentId !== -1) {
            dispatch({
                type: ACTIONS.REMOVE_SELECTED_OR_HOVER
            });
            return;
        }
        if (filteredParent.length === 0) {
            return;
        }
        if (isLockAutoFocus) {
            return;
        }
        // Lock dispatch and it should only work on desktop
        if (isMobile) {
            return;
        }
        // Prevent set parentId multiple time even it is same value
        if (parentId === filteredParent[0].id) {
            return;
        }
        setLockAutoFocus(true);
        // Auto selected first parent
        dispatch({
            type: ACTIONS.SET_SELECT_PARENT_ID,
            payload: filteredParent[0].id
        });
    }, [isLockAutoFocus, filteredParent, parentId, isMobile]);
    (0,react.useEffect)(function () {
        if (!debounceKeyword) {
            return;
        }
        setLockAutoFocus(false);
    }, [debounceKeyword]);
    return (react.createElement(ChildrenSearchFilterWrapper, { isMobile: isMobile },
        filteredParent.length > 0 ? (react.createElement(ParentWrapper, { isBorder: filteredChildren.length > 0 }, filteredParent.map(function (item, index) {
            var _a;
            var checkState = (0,helper/* getParentCheckState */.Ul)(item.id, temporaryValue);
            var countChildren = (0,helper/* countSelectedChildrenFromParentId */.l_)(item.id, temporaryValue);
            return (react.createElement(DropdownItem, { key: "search-parent-item-".concat(index), checkState: checkState, label: item.name, id: item.id, parentId: item.id, isSelected: parentId === item.id, isSelectedValue: false, isHaveChildren: true, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0, selectedCount: countChildren, isHighlightText: true }));
        }))) : null,
        filteredChildren.length > 0
            ? filteredChildren.map(function (item, index) {
                return (react.createElement(ChildrenItemWrapper, { key: "child-search-item-".concat(index) },
                    react.createElement(ParentTitle, null, item.parentName),
                    item.childrens.map(function (childItem) {
                        var _a;
                        var parentCheckState = (0,helper/* getParentCheckState */.Ul)(item.parentId, temporaryValue);
                        var itemCheckState = 'none';
                        if (parentCheckState === 'checked') {
                            itemCheckState = 'checked';
                        }
                        else if (parentCheckState === 'half') {
                            // Get item check state
                            itemCheckState = (0,helper/* getChildrenCheckState */.xT)(item.parentId, childItem.id, temporaryValue);
                        }
                        return (react.createElement(DropdownItem, { key: "child-item-".concat(childItem.id), checkState: itemCheckState, label: langCode === constants/* ELanguage.EN */.Df.EN ? childItem.nameEn : childItem.name, id: childItem.id, parentId: item.parentId, isHaveChildren: false, isSelected: false, isSelectedValue: false, jobCount: (_a = childItem.jobs) !== null && _a !== void 0 ? _a : 0, isHighlightText: true }));
                    })));
            })
            : null,
        filteredChildren.length === 0 && filteredParent.length === 0 && react.createElement("p", null, t('No result'))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/LeftColumnContent/index.js
'use client';








var LeftColumnContent = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state;
    var isMobile = props.isMobile, options = props.options, langCode = props.langCode;
    var _b = options.parent, parent = _b === void 0 ? [] : _b;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue, scrollPosition = state.scrollPosition;
    var leftColumnRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var _a, _b;
        if (!leftColumnRef.current) {
            return;
        }
        if (!isMobile) {
            return;
        }
        if ((scrollPosition === null || scrollPosition === void 0 ? void 0 : scrollPosition.left) === 0) {
            return;
        }
        (_a = leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, (_b = scrollPosition === null || scrollPosition === void 0 ? void 0 : scrollPosition.left) !== null && _b !== void 0 ? _b : 0);
    }, [isMobile, scrollPosition]);
    return (0,react.useMemo)(function () { return (react.createElement(LeftColumnContentWrapper, { "data-cname": 'dropdown__body__leftColumn', isMobile: isMobile, ref: leftColumnRef }, keyword !== '' ? (react.createElement(ChildrenSearchFilter, null)) : (parent.map(function (item, index) {
        var _a;
        // detect have children or not
        var checkState = (0,helper/* getParentCheckState */.Ul)(item.id, temporaryValue);
        var countChildren = (0,helper/* countSelectedChildrenFromParentId */.l_)(item.id, temporaryValue);
        return (react.createElement(DropdownItem, { key: "parent-item-".concat(index), checkState: checkState, label: item.name, id: item.id, parentId: item.id, isSelected: parentId === item.id, isSelectedValue: checkState !== 'none', isHaveChildren: true, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0, selectedCount: countChildren, leftColumnRef: leftColumnRef }));
    })))); }, [isMobile, keyword, parent, parentId, temporaryValue, langCode]);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/images/BriefcaseIcon/index.js
'use client';



var BriefcaseIcon = function () {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '49', height: '48', viewBox: '0 0 49 48', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_20281_181993)' },
            react.createElement("path", { d: 'M22.9002 4.7998C21.1322 4.7998 19.7002 6.2318 19.7002 7.9998H6.9002C5.1322 7.9998 3.7002 9.4318 3.7002 11.1998V25.5998C3.7002 27.3678 5.1322 28.7998 6.9002 28.7998H24.6314C26.849 24.9806 30.9738 22.3998 35.7002 22.3998C39.4346 22.3998 42.789 24.0179 45.1314 26.5779C45.2306 26.2675 45.3002 25.9422 45.3002 25.5998V11.1998C45.3002 9.4318 43.8682 7.9998 42.1002 7.9998H29.3002C29.3002 6.2318 27.8682 4.7998 26.1002 4.7998H22.9002ZM24.5002 22.3998C25.3834 22.3998 26.1002 23.1166 26.1002 23.9998C26.1002 24.883 25.3834 25.5998 24.5002 25.5998C23.617 25.5998 22.9002 24.883 22.9002 23.9998C22.9002 23.1166 23.617 22.3998 24.5002 22.3998ZM35.7002 25.5998C30.4172 25.5998 26.1002 29.9168 26.1002 35.1998C26.1002 40.4828 30.4172 44.7998 35.7002 44.7998C37.7666 44.7998 39.6799 44.1327 41.2502 43.0123L45.7689 47.5311C45.9164 47.6846 46.093 47.8072 46.2884 47.8917C46.4838 47.9761 46.6941 48.0207 46.9069 48.0229C47.1198 48.0251 47.331 47.9847 47.528 47.9043C47.7251 47.8238 47.9042 47.7048 48.0547 47.5543C48.2052 47.4038 48.3242 47.2247 48.4047 47.0277C48.4851 46.8306 48.5255 46.6194 48.5233 46.4066C48.5211 46.1937 48.4765 45.9834 48.3921 45.788C48.3076 45.5926 48.185 45.416 48.0314 45.2686L43.5127 40.7498C44.6331 39.1795 45.3002 37.2662 45.3002 35.1998C45.3002 29.9168 40.9832 25.5998 35.7002 25.5998ZM35.7002 28.7998C39.2538 28.7998 42.1002 31.6462 42.1002 35.1998C42.1002 38.7534 39.2538 41.5998 35.7002 41.5998C32.1466 41.5998 29.3002 38.7534 29.3002 35.1998C29.3002 31.6462 32.1466 28.7998 35.7002 28.7998ZM3.7002 31.1092V36.7998C3.7002 38.5678 5.1322 39.9998 6.9002 39.9998H23.8439C23.2407 38.5166 22.9002 36.8974 22.9002 35.1998C22.9002 34.0926 23.0581 33.0254 23.3221 31.9998H6.9002C5.729 31.9998 4.6458 31.6596 3.7002 31.1092Z', fill: '#939393' })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_20281_181993' },
                react.createElement("rect", { width: '48', height: '48', fill: 'white', transform: 'translate(0.5)' })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/RightColumnContent/index.js
'use client';










var RightColumnContent = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, t = _a.t;
    var parentId = state.parentId, keyword = state.keyword, hoverParentId = state.hoverParentId, isHover = state.isHover, temporaryValue = state.temporaryValue;
    var langCode = props.langCode, options = props.options, isMobile = props.isMobile, selectOptions = props.selectOptions;
    var parent = options.parent, children = options.children;
    var _b = (0,react.useState)(-1), selectedParentId = _b[0], setSelectedParentId = _b[1];
    (0,react.useEffect)(function () {
        if (isMobile && parentId === -1) {
            return;
        }
        var newParentId = parentId;
        if (isHover) {
            newParentId = hoverParentId;
        }
        setSelectedParentId(newParentId);
    }, [isMobile, parentId, hoverParentId]);
    var renderChildren = function () {
        if (!isMobile && selectedParentId === -1 && keyword.length > 0) {
            return react.createElement(react.Fragment, null);
        }
        if (!isMobile && selectedParentId === -1) {
            return (react.createElement(NotSelectedParent, null,
                react.createElement(BriefcaseIcon, null),
                react.createElement("p", null, t('Select job function.'))));
        }
        // Find children by parentId
        var childrens = (0,helpers/* getChildrenListByParentId */.fq)(selectedParentId.toString(), children);
        if (!selectOptions.isSingleSelect) {
            childrens.unshift({
                id: -1,
                name: 'Tất cả',
                nameEn: 'All'
            });
        }
        // Get Parent info
        var parentFiltered = parent.filter(function (item) { return item.id === selectedParentId; });
        var parentItemName = '';
        if (parentFiltered.length > 0) {
            parentItemName = parentFiltered[0].name;
        }
        return (react.createElement(ChildrensWrapper, null,
            !isMobile && react.createElement(ParentTitle, null, parentItemName),
            react.createElement(ChildrensContent, null, childrens.map(function (item, index) {
                var _a;
                // detect have children or not
                var parentCheckState = (0,helper/* getParentCheckState */.Ul)(selectedParentId, temporaryValue);
                var itemCheckState = 'none';
                if (parentCheckState === 'checked') {
                    itemCheckState = 'checked';
                }
                else if (parentCheckState === 'half') {
                    // Get item check state
                    itemCheckState = (0,helper/* getChildrenCheckState */.xT)(selectedParentId, item.id, temporaryValue);
                }
                // Special case is '-1' (All) option
                if (item.id === -1) {
                    itemCheckState = parentCheckState;
                }
                return (react.createElement(DropdownItem, { key: "children-".concat(parentId, "-").concat(item.id, "-").concat(index), checkState: itemCheckState, isSelected: false, isSelectedValue: itemCheckState !== 'none', label: langCode === constants/* ELanguage.VI */.Df.VI ? item.name : item.nameEn, id: item.id, parentId: selectedParentId, isHaveChildren: false, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0 }));
            }))));
    };
    return (0,react.useMemo)(function () { return (react.createElement(RightColumnContentWrapper, { "data-cname": 'dropdown__body__rightColumn', isMobile: isMobile }, renderChildren())); }, [keyword, selectedParentId, parent, children, isMobile, temporaryValue]);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/components/Dropdown/Dropdown.css.js
var Dropdown_css = __webpack_require__(90548);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/ResponsiveBody/ResponsiveBody.css.js
'use client';






var RepsonsiveChildWrapper = styled_components_browser_esm/* default.div */.ZP.div(ResponsiveBody_css_templateObject_3 || (ResponsiveBody_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    ", ";\n    transition: all 0.25s ease-in-out;\n\n    animation: ", " 0.25s ease-in-out\n        forwards;\n\n    ", "\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    ", ";\n    transition: all 0.25s ease-in-out;\n\n    animation: ", " 0.25s ease-in-out\n        forwards;\n\n    ", "\n"])), styledCss/* default.scrollbar */.ZP.scrollbar, function (_a) {
    var side = _a.side;
    return (side === 'right' ? Dropdown_css/* animSlide.second.open */.cj.second.open : Dropdown_css/* animSlide.first.close */.cj.first.close);
}, function (_a) {
    var isShow = _a.isShow, side = _a.side;
    if (!isShow && side === 'right') {
        return (0,styled_components_browser_esm/* css */.iv)(ResponsiveBody_css_templateObject_1 || (ResponsiveBody_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), Dropdown_css/* animSlide.second.close */.cj.second.close);
    }
    if (!isShow && side === 'left') {
        return (0,styled_components_browser_esm/* css */.iv)(ResponsiveBody_css_templateObject_2 || (ResponsiveBody_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), Dropdown_css/* animSlide.first.open */.cj.first.open);
    }
    return '';
});
var ResponsiveBody_css_templateObject_1, ResponsiveBody_css_templateObject_2, ResponsiveBody_css_templateObject_3;


//# sourceMappingURL=ResponsiveBody.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/components/ResponsiveBody/index.js
'use client';







var ResponsiveBody = function () {
    var state = (0,react.useContext)(CascaderContext).state;
    var parentId = state.parentId;
    var _a = (0,react.useState)(false), isMountedLeft = _a[0], setMountedLeft = _a[1];
    var _b = (0,react.useState)(false), isMountedRight = _b[0], setMountedRight = _b[1];
    var onAnimationEnd = function (type) {
        if (type === 'left') {
            if (parentId === -1) {
                return;
            }
            setMountedLeft(false);
        }
        else {
            if (parentId !== -1) {
                return;
            }
            setMountedRight(false);
        }
    };
    (0,react.useEffect)(function () {
        if (parentId === -1) {
            setMountedLeft(true);
        }
        else {
            setMountedRight(true);
        }
    }, [parentId]);
    return (react.createElement(react.Fragment, null,
        isMountedLeft ? (react.createElement(RepsonsiveChildWrapper, { isShow: parentId === -1, side: 'left', onAnimationEnd: function () { return onAnimationEnd('left'); } },
            react.createElement(LeftColumnContent, null))) : null,
        isMountedRight ? (react.createElement(RepsonsiveChildWrapper, { isShow: parentId !== -1, side: 'right', onAnimationEnd: function () { return onAnimationEnd('right'); } },
            react.createElement(RightColumnContent, null))) : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownBody/index.js
'use client';









var DropdownBody = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch;
    var isMobile = props.isMobile, selectOptions = props.selectOptions;
    var isShow = state.isShow, temporaryValue = state.temporaryValue;
    var onMouseLeave = function () {
        dispatch({
            type: ACTIONS.SET_MOUSE_LEAVE
        });
    };
    (0,react.useEffect)(function () {
        if (!isShow || !isMobile) {
            return;
        }
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = 'initial';
        };
    }, [isShow, isMobile]);
    return (react.createElement(DropdownBodyWrapper, { "data-cname": 'dropdown__body', isMobile: isMobile, isHaveItem: temporaryValue.length > 0, isSingleSelect: selectOptions.isSingleSelect, onMouseLeave: onMouseLeave }, isMobile ? (react.createElement(ResponsiveBody, null)) : (react.createElement(react.Fragment, null,
        react.createElement(LeftColumnContent, null),
        react.createElement(RightColumnContent, null)))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 1 modules
var Input = __webpack_require__(46779);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/SearchIcon/index.js
var SearchIcon = __webpack_require__(7217);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownHeader/DropdownHeader.css.js
'use client';





var DropdownHeaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownHeader_css_templateObject_1 || (DropdownHeader_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    padding-bottom: 0;\n"], ["\n    padding: 16px;\n    padding-bottom: 0;\n"])));
var ResponsiveHeader = styled_components_browser_esm/* default.div */.ZP.div(DropdownHeader_css_templateObject_2 || (DropdownHeader_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    > button {\n        margin-right: 8px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    > button {\n        margin-right: 8px;\n    }\n"])));
var RemoveAllSection = styled_components_browser_esm/* default.div */.ZP.div(DropdownHeader_css_templateObject_3 || (DropdownHeader_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 10px 6px;\n    line-height: 18px;\n    display: flex;\n    justify-content: flex-end;\n"], ["\n    padding: 10px 6px;\n    line-height: 18px;\n    display: flex;\n    justify-content: flex-end;\n"])));
var RemoveBtn = styled_components_browser_esm/* default.a */.ZP.a(DropdownHeader_css_templateObject_4 || (DropdownHeader_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    color: ", " !important;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        color: ", " !important;\n    }\n"], ["\n    cursor: pointer;\n    color: ", " !important;\n    &:focus-visible,\n    &:hover {\n        outline: none !important;\n        color: ", " !important;\n    }\n"])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.secondary.40 */.O9.secondary[40]);
var DropdownHeader_css_templateObject_1, DropdownHeader_css_templateObject_2, DropdownHeader_css_templateObject_3, DropdownHeader_css_templateObject_4;


//# sourceMappingURL=DropdownHeader.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/services.js
'use client';



var searchJobFunctions = function (msBaseUrl, keyword) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var api, requestOptions, response, responseJson, err_1;
    var _a, _b;
    return (0,_tslib/* __generator */.Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                api = "".concat(msBaseUrl, "/meta/v1.2/search-job-functions?keyword=").concat(keyword);
                requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                responseJson = _c.sent();
                return [2 /*return*/, {
                        groupJobFunctions: (_a = responseJson === null || responseJson === void 0 ? void 0 : responseJson.data) !== null && _a !== void 0 ? _a : [],
                        jobFunctions: (_b = responseJson === null || responseJson === void 0 ? void 0 : responseJson.included) !== null && _b !== void 0 ? _b : []
                    }];
            case 3:
                err_1 = _c.sent();
                console.error(err_1);
                return [2 /*return*/, {
                        groupJobFunctions: [],
                        jobFunctions: []
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownHeader/index.js
'use client';















var DropdownHeader = function (params) {
    var isShowTitle = params.isShowTitle;
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var isMobile = props.isMobile, options = props.options, selectOptions = props.selectOptions, msBaseUrl = props.msBaseUrl, onConfirm = props.onConfirm, onBlur = props.onBlur;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue;
    var debounceKeyword = (0,hooks/* default */.ZP)([keyword], 300);
    var getSearchResult = function (keyword) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(options === null || options === void 0 ? void 0 : options.isEnableSearchAPI)) {
                        return [2 /*return*/];
                    }
                    if (keyword === '') {
                        // reset search result
                        dispatch({
                            type: ACTIONS.SET_SEARCH_RESULT,
                            payload: {
                                groupJobFunctions: [],
                                jobFunctions: []
                            }
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, searchJobFunctions(msBaseUrl, keyword)];
                case 1:
                    response = _a.sent();
                    dispatch({
                        type: ACTIONS.SET_SEARCH_RESULT,
                        payload: response
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var onInputChange = function (value) {
        dispatch({
            type: ACTIONS.SET_KEYWORD,
            payload: value
        });
    };
    var onClickBack = function () {
        dispatch({
            type: ACTIONS.SET_SELECT_PARENT_ID,
            payload: -1
        });
    };
    var renderTitle = function () {
        if (!isShowTitle) {
            return react.createElement(react.Fragment, null);
        }
        if (!isMobile) {
            return react.createElement(Title, null, t('Job Function'));
        }
        var parentItem = (0,helper/* getSelectedParentName */.AU)([
            {
                parentId: parentId,
                childrenIds: [-1]
            }
        ], options.parent);
        if (parentItem.length === 0) {
            return react.createElement(Title, null, t('Job Function'));
        }
        return (react.createElement(ResponsiveHeader, null,
            react.createElement(Button/* default */.Z, { isRounded: true, tabIndex: -1, isIcon: true, outline: 'none', type: 'default', size: 'sm', onClick: onClickBack },
                react.createElement(GlyphIcons/* default.BackArrowIcon */.Z.BackArrowIcon, { width: 20, height: 20 })),
            react.createElement(Title, null, parentItem[0].name)));
    };
    var onClickRemoveAll = function (e) {
        e.preventDefault();
        dispatch({
            type: ACTIONS.REMOVE_ALL_TEMPORARY_VALUE
        });
        if (selectOptions.hiddenFooter) {
            dispatch({
                type: ACTIONS.APPLY_CALLBACK,
                payload: onConfirm
            });
            dispatch({
                type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
            });
        }
        if (selectOptions.isSingleSelect) {
            // update on single
            onConfirm && onConfirm([]);
            onBlur && onBlur();
            dispatch({
                type: ACTIONS.ON_CONFIRM
            });
        }
    };
    (0,react.useEffect)(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(keyword);
    }, [debounceKeyword]);
    return (react.createElement(DropdownHeaderWrapper, { "data-cname": 'dropdown__header' },
        renderTitle(),
        react.createElement(InputWrapper, null,
            react.createElement(Input/* default */.Z, { value: keyword, autoFocus: true, onChange: onInputChange, placeholder: t('Search'), prefixIcon: react.createElement(SearchIcon/* default */.Z, null) })),
        temporaryValue.length > 0 && (react.createElement(RemoveAllSection, null,
            react.createElement(RemoveBtn, { onClick: onClickRemoveAll, href: '#' }, t('Remove all'))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownFooter/DropdownFooter.css.js
'use client';





var DropdownFooterWrapper = styled_components_browser_esm/* default.div */.ZP.div(DropdownFooter_css_templateObject_2 || (DropdownFooter_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px 16px;\n    background-color: #fff;\n    height: 80px;\n    border-radius: 0 0 12px 12px;\n    button {\n        &:first-child {\n            margin-right: ", "px;\n        }\n    }\n    ", "\n"], ["\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px 16px;\n    background-color: #fff;\n    height: 80px;\n    border-radius: 0 0 12px 12px;\n    button {\n        &:first-child {\n            margin-right: ", "px;\n        }\n    }\n    ", "\n"])), Colors/* colors.grey.90 */.O9.grey[90], function (_a) {
    var isSingleSelect = _a.isSingleSelect;
    return (isSingleSelect ? 0 : 10);
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(DropdownFooter_css_templateObject_1 || (DropdownFooter_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: ", ";\n            bottom: 0;\n            width: 100vw;\n            z-index: 10;\n            > button {\n                width: ", ";\n            }\n        "], ["\n            position: ", ";\n            bottom: 0;\n            width: 100vw;\n            z-index: 10;\n            > button {\n                width: ", ";\n            }\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? 'fixed' : 'absolute');
    }, function (_a) {
        var isSingleSelect = _a.isSingleSelect;
        return (isSingleSelect ? '100%' : '50%');
    });
});
var DropdownFooter_css_templateObject_1, DropdownFooter_css_templateObject_2;


//# sourceMappingURL=DropdownFooter.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownFooter/index.js
'use client';







var DropdownFooter = function () {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var onCancel = props.onCancel, onConfirm = props.onConfirm, onBlur = props.onBlur, isMobile = props.isMobile, langCode = props.langCode, selectOptions = props.selectOptions, styleOptions = props.styleOptions, textOptions = props.textOptions;
    var value = state.value, isShow = state.isShow, temporaryValue = state.temporaryValue;
    var onClickCancel = function () {
        onCancel && onCancel(value);
        dispatch({
            type: ACTIONS.ON_CANCEL
        });
    };
    var onClickSearch = function () {
        onConfirm && onConfirm(temporaryValue);
        onBlur && onBlur();
        dispatch({
            type: ACTIONS.ON_CONFIRM
        });
    };
    return (0,react.useMemo)(function () { return (react.createElement(DropdownFooterWrapper, { "data-cname": 'dropdown__footer', isShow: isShow, isMobile: isMobile, isSingleSelect: selectOptions.isSingleSelect },
        styleOptions.isShowSecondaryBtn && (react.createElement(Button/* default */.Z, { type: styleOptions.secondaryBtnType, "data-btn-type": 'secondary', onClick: onClickCancel }, textOptions.secondaryBtnText && textOptions.secondaryBtnText !== ''
            ? textOptions.secondaryBtnText
            : t('Cancel'))),
        !selectOptions.isSingleSelect && (react.createElement(Button/* default */.Z, { type: styleOptions.primaryBtnType || 'primary', "data-btn-type": 'primary', onClick: onClickSearch }, textOptions.primaryBtnText && textOptions.primaryBtnText !== ''
            ? textOptions.primaryBtnText
            : t('Search'))))); }, [temporaryValue, isShow, value, langCode, isMobile]);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/components/DropdownContainer/index.js
'use client';











var DropdownContainer = function (params) {
    var _a = (0,react.useContext)(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch, t = _a.t;
    var isMobile = props.isMobile, floatingConfig = props.floatingConfig, selectOptions = props.selectOptions, onBlur = props.onBlur, lockTarget = props.lockTarget, scrollLockMode = props.scrollLockMode;
    var isShow = state.isShow;
    var _b = params.floatingState, refs = _b.refs, context = _b.context, FloatingPortal = _b.FloatingPortal;
    var _c = (0,react.useState)(false), isMounted = _c[0], setMounted = _c[1];
    var onAnimationEnd = function () {
        if (isShow) {
            return;
        }
        setMounted(false);
        dispatch({
            type: ACTIONS.HIDE
        });
    };
    (0,react.useEffect)(function () {
        if (!isShow) {
            return;
        }
        setMounted(true);
    }, [isShow]);
    var dropdownStyle = isMobile
        ? {}
        : {
            position: context.position,
            top: context.y,
            left: context.x,
            display: context.isReferenceHidden ? 'none' : 'block',
            zIndex: 1100
        };
    // console.log('casscader > lockTarget: ', lockTarget)
    return (react.createElement(react.Fragment, null, selectOptions.displayAsPopup && !isMobile ? (isMounted ? (react.createElement(Popup/* default */.Z, { isShow: isShow, onClose: function () {
            dispatch({
                type: ACTIONS.HIDE
            });
            onBlur && onBlur();
        }, custom: {
            footer: null,
            lockTarget: lockTarget,
            scrollLockMode: scrollLockMode
        }, text: {
            header: t('Job Function')
        }, option: {
            isCloseOnClickBackdrop: true
        }, lang: constants/* ELanguage.EN */.Df.EN },
        react.createElement(DropdownContainerWrapper, { isShow: isShow, isMobile: isMobile, "data-floating-placement": floatingConfig.placement, onAnimationEnd: onAnimationEnd, isSingleSelect: true },
            react.createElement(DropdownHeader, { isShowTitle: false }),
            react.createElement(DropdownBody, null),
            (selectOptions.isSingleSelect || selectOptions.hiddenFooter) && !isMobile ? (react.createElement(EmptyFooter, null)) : (react.createElement(DropdownFooter, null))))) : (react.createElement(react.Fragment, null))) : (react.createElement(FloatingPortal, { enable: floatingConfig.enablePortal }, isMounted ? (react.createElement("div", { ref: refs.setPopup, style: dropdownStyle },
        react.createElement(DropdownContainerWrapper, { isShow: isShow, isMobile: isMobile, "data-floating-placement": context.placement, onAnimationEnd: onAnimationEnd, isSingleSelect: false },
            react.createElement(DropdownHeader, { isShowTitle: true }),
            react.createElement(DropdownBody, null),
            (selectOptions.isSingleSelect || selectOptions.hiddenFooter) && !isMobile ? (react.createElement(EmptyFooter, null)) : (react.createElement(DropdownFooter, null))))) : (react.createElement(react.Fragment, null))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/index.js
'use client';


















var Cascader = function (props) {
    var _a = (0,react.useReducer)(cascaderReducer, initialCascaderState), state = _a[0], dispatch = _a[1];
    var mergedProps = (0,react.useMemo)(function () { return (0,helper/* mergeProps */.dG)(props); }, [props]);
    var floatingConfig = mergedProps.floatingConfig;
    var useFloatingResult = (0,useFloating/* default */.Z)({
        placement: floatingConfig.placement,
        position: floatingConfig.position,
        config: {
            useWindowAsFlippingContainer: floatingConfig.useWindowAsFlippingContainer,
            isFlip: floatingConfig.isFlip,
            detectHidden: true
        }
    });
    var refs = useFloatingResult.refs;
    (0,useClickAway/* default */.Z)(function () {
        if (!state.isShow) {
            return;
        }
        dispatch({
            type: ACTIONS.ON_CANCEL
        });
        mergedProps.onBlur && mergedProps.onBlur();
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    var t = function (text) {
        var _a;
        if (props.langCode === 'en') {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    (0,react.useEffect)(function () {
        // isLocationChanged is using for compare variable that have type TNestedGenericId[]
        var isValueChanged = (0,Utils_helpers/* isLocationChanged */.G)(state.value, props.value);
        if (!isValueChanged) {
            return;
        }
        dispatch({
            type: ACTIONS.SET_VALUE_FROM_PROP,
            payload: props.value
        });
    }, [props.value]);
    return (react.createElement(CascaderContext.Provider, { value: {
            state: state,
            props: mergedProps,
            t: t,
            dispatch: dispatch
        } },
        react.createElement(CascaderWrapper, { isFlex: mergedProps.styleOptions.isFlex },
            react.createElement(InputContainer$1, { ref: refs.setReference }),
            react.createElement(DropdownContainer, { floatingState: useFloatingResult }))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 95140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CheckBox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/CheckBox.css.js
'use client';





var CheckBoxWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    width: 100%;\n    ", "\n    ", "\n"], ["\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var hiddenCheckBox = _a.hiddenCheckBox, disabled = _a.disabled;
    return hiddenCheckBox
        ? ''
        : "\n\n    padding: 10px 8px;\n    &:hover {\n        background-color: ".concat(disabled ? '#f5f5f8' : '#f8faff', ";\n    }\n    ");
}, function (_a) {
    var disabled = _a.disabled;
    if (!disabled)
        return '';
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            opacity: 0.4;\n            cursor: no-drop;\n        "], ["\n            opacity: 0.4;\n            cursor: no-drop;\n        "])));
});
var CheckBoxDiv = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 18px;\n    min-width: 18px;\n    height: 18px;\n    min-height: 18px;\n    border: 1px solid #333;\n    display: inline-block;\n    border-radius: 3px;\n    position: relative;\n    transition: all 0.25s;\n    ", "\n"], ["\n    width: 18px;\n    min-width: 18px;\n    height: 18px;\n    min-height: 18px;\n    border: 1px solid #333;\n    display: inline-block;\n    border-radius: 3px;\n    position: relative;\n    transition: all 0.25s;\n    ", "\n"])), function (_a) {
    var state = _a.state;
    switch (state) {
        case 'half':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border: 1px solid ", ";\n                    background-color: ", ";\n                    &::after {\n                        content: ' ';\n                        display: block;\n                        width: 10px;\n                        height: 1px;\n                        background-color: #fff;\n                        border-radius: 6px;\n                        position: absolute;\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        top: 7px;\n                        left: 3px;\n                    }\n                "], ["\n                    border: 1px solid ", ";\n                    background-color: ", ";\n                    &::after {\n                        content: ' ';\n                        display: block;\n                        width: 10px;\n                        height: 1px;\n                        background-color: #fff;\n                        border-radius: 6px;\n                        position: absolute;\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        top: 7px;\n                        left: 3px;\n                    }\n                "])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.primaryColor */.O9.primaryColor);
        case 'checked':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border: 1px solid ", ";\n                    background-color: ", ";\n                    &::after {\n                        content: ' ';\n                        display: block;\n                        width: 9px;\n                        height: 5px;\n                        border-bottom: 1px solid white;\n                        border-left: 1px solid white;\n                        -webkit-transform: rotate(-45deg) scale(1);\n                        transform: rotate(-45deg) scale(1);\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        position: absolute;\n                        top: 4px;\n                        left: 4px;\n                    }\n                "], ["\n                    border: 1px solid ", ";\n                    background-color: ", ";\n                    &::after {\n                        content: ' ';\n                        display: block;\n                        width: 9px;\n                        height: 5px;\n                        border-bottom: 1px solid white;\n                        border-left: 1px solid white;\n                        -webkit-transform: rotate(-45deg) scale(1);\n                        transform: rotate(-45deg) scale(1);\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        position: absolute;\n                        top: 4px;\n                        left: 4px;\n                    }\n                "])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.primaryColor */.O9.primaryColor);
        case 'none':
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    ::after {\n                        content: ' ';\n                        display: block;\n                        width: 9px;\n                        height: 5px;\n                        border-bottom: 1px solid white;\n                        border-left: 1px solid white;\n                        -webkit-transform: rotate(0) scale(0);\n                        transform: rotate(0) scale(0);\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        position: absolute;\n                        top: 4px;\n                        left: 4px;\n                    }\n                "], ["\n                    ::after {\n                        content: ' ';\n                        display: block;\n                        width: 9px;\n                        height: 5px;\n                        border-bottom: 1px solid white;\n                        border-left: 1px solid white;\n                        -webkit-transform: rotate(0) scale(0);\n                        transform: rotate(0) scale(0);\n                        will-change: transform;\n                        transition: ease-in-out 0.25s;\n                        position: absolute;\n                        top: 4px;\n                        left: 4px;\n                    }\n                "])));
    }
});
var Label = styled_components_browser_esm/* default.label */.ZP.label(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 6px;\n    margin-bottom: 0px !important;\n    cursor: pointer;\n    width: calc(100% - 18px);\n    line-height: 18px;\n"], ["\n    margin-left: 6px;\n    margin-bottom: 0px !important;\n    cursor: pointer;\n    width: calc(100% - 18px);\n    line-height: 18px;\n"])));
var SubLabel = styled_components_browser_esm/* default.span */.ZP.span(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #999;\n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 8px;\n"], ["\n    color: #999;\n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 8px;\n"])));
var LabelText = styled_components_browser_esm/* default.span */.ZP.span(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    max-width: calc(100% - ", "px);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: 400 !important;\n"], ["\n    max-width: calc(100% - ", "px);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: 400 !important;\n"])), function (props) { return props.labelRightMargin; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;


//# sourceMappingURL=CheckBox.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/index.js
'use client';




var CheckBox = function (props) {
    var _a = props.state, state = _a === void 0 ? 'none' : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.labelRightMargin, labelRightMargin = _c === void 0 ? 60 : _c, label = props.label, _d = props.subLabel, subLabel = _d === void 0 ? '' : _d, _e = props.tabIndex, tabIndex = _e === void 0 ? 0 : _e, onCheckChange = props.onCheckChange, onFocus = props.onFocus, disabled = props.disabled, _f = props.isShowTooltip, isShowTooltip = _f === void 0 ? false : _f, customLabel = props.customLabel, _g = props.hiddenCheckBox, hiddenCheckBox = _g === void 0 ? false : _g;
    var _h = (0,react.useState)(state), checkState = _h[0], setCheckState = _h[1];
    var handleClickCheck = function () {
        if (disabled) {
            return;
        }
        var checkStateChange = checkState;
        switch (checkState) {
            case 'none':
                checkStateChange = 'checked';
                break;
            case 'half':
                checkStateChange = 'none';
                break;
            case 'checked':
            default:
                checkStateChange = 'none';
                break;
        }
        setCheckState(checkStateChange);
        onCheckChange && onCheckChange(checkStateChange);
    };
    var handleEnter = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            handleClickCheck();
        }
    };
    (0,react.useEffect)(function () {
        setCheckState(state);
    }, [state]);
    var getCustomLabel = (0,react.useMemo)(function () {
        if (customLabel) {
            return typeof customLabel === 'function' ? customLabel(checkState) : customLabel;
        }
        return null;
    }, [checkState, customLabel]);
    return (react.createElement(CheckBoxWrapper, { hiddenCheckBox: hiddenCheckBox, title: isShowTooltip ? label : '', onClick: handleClickCheck, onFocus: onFocus, disabled: disabled, style: style, "data-check-state": checkState },
        !hiddenCheckBox ? react.createElement(CheckBoxDiv, { state: checkState, onKeyDown: handleEnter, tabIndex: tabIndex }) : null,
        getCustomLabel || (react.createElement(Label, null,
            react.createElement(LabelText, { labelRightMargin: labelRightMargin }, label),
            subLabel && react.createElement(SubLabel, null, subLabel)))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 50697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Collapse; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Collapse/Collapse.css.js
'use client';




var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customEnable = _a.customEnable;
    return !customEnable
        ? "\n    background-color: #fff;\n    border: 1px solid #005aff;\n    border-radius: 10px;\n    overflow: hidden;\n    "
        : '';
});
var Header = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customEnable = _a.customEnable;
    return !customEnable
        ? "\n    display: grid;\n    grid-template-columns: 1fr auto;\n    background-color: #005aff;\n    align-items: center;\n    "
        : '';
});
var HeaderContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: ", ";\n"], ["\n    cursor: ", ";\n"])), function (_a) {
    var customContent = _a.customContent;
    return (customContent ? 'auto' : 'pointer');
});
var CollapsibleContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: max-height 0.25s ease-in-out, opacity 0.2s ease-out;\n    ", "\n"], ["\n    transition: max-height 0.25s ease-in-out, opacity 0.2s ease-out;\n    ", "\n"])), function (_a) {
    var enableMaskImage = _a.enableMaskImage, isCollapse = _a.isCollapse;
    return enableMaskImage && isCollapse ? 'mask-image: linear-gradient(180deg, #fff, transparent);' : '';
});
var Content = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n"], ["\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n"])));
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: rotate(", "deg);\n"], ["\n    display: flex;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: rotate(", "deg);\n"])), function (_a) {
    var isCollapse = _a.isCollapse;
    return (isCollapse ? '0' : '180');
});
var ViewMoreButton = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    width: fit-content;\n"], ["\n    cursor: pointer;\n    width: fit-content;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


//# sourceMappingURL=Collapse.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Collapse/helpers.js
'use client';

function getTextNodeHeight(node, isCustom) {
    if (!isCustom) {
        return {
            lineHeight: 0
        };
    }
    if (node.nodeType === Node.TEXT_NODE) {
        var lineHeight = 0;
        if (node.parentElement) {
            var getLineHeight = window.getComputedStyle(node.parentElement)['line-height'];
            lineHeight = parseFloat(getLineHeight);
        }
        return {
            lineHeight: lineHeight
        };
    }
    if (node.childNodes[0]) {
        return getTextNodeHeight(node.childNodes[0], isCustom);
    }
    return {
        lineHeight: 0
    };
}


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Collapse/index.js
'use client';







var BORDER_HEIGHT = 2;
var Collapse = function (_a) {
    var header = _a.header, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.collapse, collapse = _c === void 0 ? true : _c, custom = _a.custom, _d = _a.disableCollapsible, disableCollapsible = _d === void 0 ? false : _d, onTransitionEnd = _a.onTransitionEnd, restProps = (0,_tslib/* __rest */._T)(_a, ["header", "className", "children", "collapse", "custom", "disableCollapsible", "onTransitionEnd"]);
    var _e = custom || {}, _f = _e.enable, customEnable = _f === void 0 ? false : _f, _g = _e.numberOfLines, numberOfLines = _g === void 0 ? 0 : _g, viewMoreText = _e.viewMoreText, _h = _e.enableViewMoreShadow, enableViewMoreShadow = _h === void 0 ? false : _h, _j = _e.alwaysShowViewMore, alwaysShowViewMore = _j === void 0 ? false : _j;
    var _k = (0,react.useState)(collapse), isCollapse = _k[0], setCollapse = _k[1];
    var _l = (0,react.useState)(false), enableViewMore = _l[0], setEnableViewMore = _l[1];
    var collapsibleContentRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var prevValue = (0,react.useRef)(collapse);
    (0,react.useEffect)(function () {
        if (prevValue.current !== collapse) {
            setCollapse(collapse);
        }
    }, [collapse]);
    (0,react.useEffect)(function () {
        prevValue.current = isCollapse;
    }, [isCollapse]);
    (0,react.useEffect)(function () {
        var handleCollapseContent = function () {
            if (contentRef.current && collapsibleContentRef.current) {
                var collapsibleContentEl = collapsibleContentRef.current;
                /*
                 * Handle action if enable viewMoreShadow
                 * */
                var lineHeight = getTextNodeHeight(collapsibleContentEl.childNodes[0], customEnable).lineHeight;
                var contentHeight = contentRef.current.scrollHeight;
                if (isCollapse) {
                    var maxHeight = 0;
                    if (customEnable) {
                        maxHeight += lineHeight * numberOfLines + BORDER_HEIGHT;
                        collapsibleContentEl.style.maxHeight = maxHeight + 'px';
                        collapsibleContentEl.style.overflow = 'hidden';
                        if (alwaysShowViewMore) {
                            setEnableViewMore(true);
                            return;
                        }
                        if (contentHeight > lineHeight * numberOfLines) {
                            setEnableViewMore(true);
                        }
                        return;
                    }
                    collapsibleContentEl.style.maxHeight = '0';
                    collapsibleContentEl.style.opacity = '0';
                    return;
                }
                collapsibleContentEl.style.maxHeight = contentHeight + BORDER_HEIGHT + 'px';
                collapsibleContentEl.style.opacity = '1';
            }
        };
        if (collapse) {
            handleCollapseContent();
        }
        else {
            /*
             * Make sure font is loaded before we doing collapse content
             * Because, our content is almost text, and font is effected to the height of content
             * */
            document.fonts.ready.then(function () {
                handleCollapseContent();
            });
        }
    }, [isCollapse, collapse, customEnable, numberOfLines, children, alwaysShowViewMore]);
    var handleHeaderAction = function () {
        if (customEnable || disableCollapsible) {
            return;
        }
        setCollapse(function (prevState) { return !prevState; });
    };
    var handleCustomCollapseButton = function () {
        if (disableCollapsible) {
            return;
        }
        setCollapse(function (prevState) { return !prevState; });
    };
    var handleTransitionEnd = function (e) {
        onTransitionEnd && onTransitionEnd();
        !isCollapse && e.target.style.removeProperty('overflow');
    };
    return (react.createElement(Container, (0,_tslib/* __assign */.pi)({ className: className, customEnable: customEnable }, restProps),
        header ? (react.createElement(Header, { customEnable: customEnable, className: 'vnw-collapse-header' },
            react.createElement(HeaderContent, { customContent: customEnable, onClick: handleHeaderAction }, header),
            !customEnable ? (react.createElement(IconWrapper, { onClick: function () { return setCollapse(function (prevState) { return !prevState; }); }, isCollapse: isCollapse },
                react.createElement(ArrowDownIcon/* default */.Z, { color: '#fff', thickness: 1 }))) : null)) : null,
        react.createElement(CollapsibleContent, { ref: collapsibleContentRef, onTransitionEnd: handleTransitionEnd, enableMaskImage: enableViewMoreShadow, isCollapse: isCollapse },
            react.createElement(Content, { ref: contentRef }, children)),
        customEnable && enableViewMore ? (react.createElement(ViewMoreButton, { onClick: handleCustomCollapseButton, className: 'vnw-custom-collapse-button' }, viewMoreText ? viewMoreText(isCollapse) : '')) : null));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 33089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O9": function() { return /* binding */ colors; },
/* harmony export */   "RA": function() { return /* binding */ getAlertColorRange; }
/* harmony export */ });
/* unused harmony export EColorName */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
'use client';




var EColorName;
(function (EColorName) {
    EColorName["primary"] = "primary";
    EColorName["secondary"] = "secondary";
    EColorName["green"] = "green";
    EColorName["yellow"] = "yellow";
    EColorName["error"] = "error";
    EColorName["neutral"] = "neutral";
    EColorName["grey"] = "grey";
})(EColorName || (EColorName = {}));
var mainColor = {
    0: '#000',
    100: '#fff'
};
var colors = {
    primary: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#002466', 20: '#003699', 30: '#0047CC', 40: '#005AFF', 50: '#347BFF', 60: '#4D8CFF', 70: '#80ADFF', 80: '#A0C1FF', 90: '#D4E4FF', 95: '#EFF5FF', 99: '#F9FBFF' }),
    secondary: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#3F1F15', 20: '#7F3F2B', 30: '#BE5E40', 40: '#FF7D55', 50: '#FD916F', 60: '#FEA488', 70: '#FEB8A2', 80: '#FFCBBB', 90: '#FFDFD5', 95: '#FFEFEA', 99: '#FCFBFA' }),
    green: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#102201', 20: '#214402', 30: '#316503', 40: '#418703', 50: '#609B2D', 60: '#7FAE56', 70: '#9DC27E', 80: '#BCD5A7', 90: '#DCE9D0', 95: '#EFF5EA', 99: '#FAFCF8' }),
    yellow: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#402C00', 20: '#805800', 30: '#BF8400', 40: '#FFAF00', 50: '#FFBC2B', 60: '#FFCA56', 70: '#FFD780', 80: '#FFE4AA', 90: '#FFF2D5', 95: '#FFF9EC', 99: '#FFFEFC' }),
    error: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#370E0C', 20: '#6E1B17', 30: '#A52923', 40: '#DC362E', 50: '#E35750', 60: '#EA7872', 70: '#F19895', 80: '#F8B9B7', 90: '#FFDAD9', 95: '#FCEDED', 99: '#FFFAFA' }),
    neutral: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#1B1E25', 20: '#363C49', 30: '#50596E', 40: '#6B7792', 50: '#838DA3', 60: '#9AA2B4', 70: '#B2B8C5', 80: '#C9CDD6', 90: '#E1E3E8', 95: '#F1F2F4', 99: '#F8F9FA' }),
    grey: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#1D1D1D', 20: '#333333', 30: '#494949', 40: '#616161', 50: '#797979', 60: '#939393', 70: '#AEAEAE', 80: '#C9C9C9', 90: '#E2E2E2', 95: '#F1F1F1', 99: '#FCFCFC' })
};
var getAlertColorRange = function (type) {
    var _a;
    return type ? (_a = {},
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.info */ .P.info] = colors.primary,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.warning */ .P.warning] = colors.yellow,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.danger */ .P.danger] = colors.error,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.success */ .P.success] = colors.green,
        _a)[type] : colors.primary;
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 15225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompanyCardSquare; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/CompanyItem.css.js
'use client';





var CompanyItemWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: inline-block;\n    margin-right: 16px;\n    margin-bottom: 16px;\n    border-radius: 6px;\n    padding: 8px;\n    background-color: #fff;\n    border: 1px solid #eee;\n    &:nth-child(3n) {\n        margin-right: 0;\n    }\n"], ["\n    width: 100%;\n    display: inline-block;\n    margin-right: 16px;\n    margin-bottom: 16px;\n    border-radius: 6px;\n    padding: 8px;\n    background-color: #fff;\n    border: 1px solid #eee;\n    &:nth-child(3n) {\n        margin-right: 0;\n    }\n"])));
var BannerSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var CoverWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 0;\n    padding-top: calc(1 / (64 / 17) * 100%);\n    border-radius: 6px;\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 0px;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 8px;\n    img {\n        position: absolute;\n        inset: 0px;\n        box-sizing: border-box;\n        padding: 0px;\n        border: none;\n        margin: auto;\n        display: block;\n        width: 0px;\n        height: 0px;\n        min-width: 100%;\n        max-width: 100%;\n        min-height: 100%;\n        max-height: 100%;\n        object-fit: cover;\n    }\n"], ["\n    width: 100%;\n    height: 0;\n    padding-top: calc(1 / (64 / 17) * 100%);\n    border-radius: 6px;\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 0px;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 8px;\n    img {\n        position: absolute;\n        inset: 0px;\n        box-sizing: border-box;\n        padding: 0px;\n        border: none;\n        margin: auto;\n        display: block;\n        width: 0px;\n        height: 0px;\n        min-width: 100%;\n        max-width: 100%;\n        min-height: 100%;\n        max-height: 100%;\n        object-fit: cover;\n    }\n"])));
var CompanyHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    padding: 0 8px;\n"], ["\n    display: flex;\n    padding: 0 8px;\n"])));
var CompanyInfo = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex-grow: 1;\n    padding: 12px 0 0 12px;\n"], ["\n    flex-grow: 1;\n    padding: 12px 0 0 12px;\n"])));
var CompanyLogo = styled_components_browser_esm/* default.a */.ZP.a(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n    min-width: 88px;\n    max-width: 88px;\n    width: 88px;\n    height: 88px;\n    position: relative;\n    border-radius: 6px;\n    overflow: hidden;\n    background-color: #fff;\n\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.26);\n    img {\n        object-fit: contain;\n        width: 100%;\n        height: 100%;\n        padding: 10px !important;\n    }\n"], ["\n    display: block;\n    min-width: 88px;\n    max-width: 88px;\n    width: 88px;\n    height: 88px;\n    position: relative;\n    border-radius: 6px;\n    overflow: hidden;\n    background-color: #fff;\n\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.26);\n    img {\n        object-fit: contain;\n        width: 100%;\n        height: 100%;\n        padding: 10px !important;\n    }\n"])));
var ContentSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px 8px 8px 8px;\n    height: 172px;\n"], ["\n    padding: 16px 8px 8px 8px;\n    height: 172px;\n"])));
var CompanyJob = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid #f1f1f1;\n    margin-bottom: 8px;\n    p {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        margin: 0px;\n        line-height: 18px;\n    }\n\n    .job-title {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 18px;\n        letter-spacing: 0px;\n        text-align: left;\n        margin-bottom: 4px;\n    }\n    .job-salary {\n        color: #ff7d55;\n        font-size: 14px;\n    }\n    .job-location {\n        color: #797979;\n        font-size: 14px;\n    }\n"], ["\n    display: block;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid #f1f1f1;\n    margin-bottom: 8px;\n    p {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        margin: 0px;\n        line-height: 18px;\n    }\n\n    .job-title {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 18px;\n        letter-spacing: 0px;\n        text-align: left;\n        margin-bottom: 4px;\n    }\n    .job-salary {\n        color: #ff7d55;\n        font-size: 14px;\n    }\n    .job-location {\n        color: #797979;\n        font-size: 14px;\n    }\n"])));
var CompanyName = styled_components_browser_esm/* default.a */.ZP.a(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    color: #333;\n    margin-bottom: 6px;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n"], ["\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    color: #333;\n    margin-bottom: 6px;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 17px;\n    height: 17px;\n    color: ", ";\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    margin-bottom: 6px;\n    word-break: break-all;\n    svg {\n        vertical-align: top;\n        margin-right: 3px;\n        margin-top: 2px;\n    }\n"], ["\n    font-size: 14px;\n    line-height: 17px;\n    height: 17px;\n    color: ", ";\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    margin-bottom: 6px;\n    word-break: break-all;\n    svg {\n        vertical-align: top;\n        margin-right: 3px;\n        margin-top: 2px;\n    }\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var FollowSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0 8px 16px 8px;\n    button {\n        width: 100%;\n    }\n"], ["\n    padding: 0 8px 16px 8px;\n    button {\n        width: 100%;\n    }\n"])));
var EmptyTextWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    color: ", ";\n"], ["\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    color: ", ";\n"])), Colors/* colors.neutral.70 */.O9.neutral[70]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


//# sourceMappingURL=CompanyItem.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/index.js + 5 modules
var PreviewJob = __webpack_require__(91867);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/index.js + 2 modules
var ApplyJobs = __webpack_require__(83699);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MailAddIcon/index.js
var MailAddIcon = __webpack_require__(29082);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/JobCard.css.js
var JobCard_css = __webpack_require__(8203);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/JobItem.js
'use client';





























































































































































var JobItem = function (props) {
    var _a, _b;
    var job = props.job, user = props.user, _c = props.langCode, langCode = _c === void 0 ? constants/* ELanguage.VI */.Df.VI : _c, baseMsUrl = props.baseMsUrl, baseUrl = props.baseUrl, decryptToken = props.decryptToken;
    var _d = (0,react.useState)(false), isShowPopUpApplyJob = _d[0], setIsShowPopUpApplyJob = _d[1];
    var togglePopApplyJob = function () {
        setIsShowPopUpApplyJob(!isShowPopUpApplyJob);
    };
    var salary = job.salary && job.salary !== '' ? job.salary : job.prettySalary;
    var userToken = decryptToken ? (0,helpers/* decrypt */.pe)((user === null || user === void 0 ? void 0 : user.accessToken) || '') : (user === null || user === void 0 ? void 0 : user.accessToken) || '';
    var PreviewJobWrapper = function (_a) {
        var _b, _c, _d, _e;
        var children = _a.children;
        return (0,helpers/* isMobile */.tq)() ? (react.createElement(react.Fragment, null, children)) : (react.createElement(PreviewJob/* default */.Z, { content: {
                jobId: job === null || job === void 0 ? void 0 : job.jobId,
                logo: job === null || job === void 0 ? void 0 : job.companyLogo,
                title: job === null || job === void 0 ? void 0 : job.jobTitle,
                salary: String(salary),
                jobLevel: langCode === constants/* ELanguage.VI */.Df.VI ? job === null || job === void 0 ? void 0 : job.jobLevelVI : job === null || job === void 0 ? void 0 : job.jobLevel,
                address: job === null || job === void 0 ? void 0 : job.address,
                jobDescription: job === null || job === void 0 ? void 0 : job.jobDescription,
                jobRequirements: job === null || job === void 0 ? void 0 : job.jobRequirement,
                link: job.jobUrl,
                isSaved: (_b = job === null || job === void 0 ? void 0 : job.isSaved) !== null && _b !== void 0 ? _b : false,
                isApplied: (_c = job === null || job === void 0 ? void 0 : job.isApplied) !== null && _c !== void 0 ? _c : false,
                isBlackList: (_d = job === null || job === void 0 ? void 0 : job.isBlackList) !== null && _d !== void 0 ? _d : false,
                redirectTo: '',
                jobInvitation: (_e = job === null || job === void 0 ? void 0 : job.jobInvitation) !== null && _e !== void 0 ? _e : { jobInvitationId: 0, status: 0 }
            }, api: {
                accessToken: userToken,
                baseUrl: baseMsUrl
            }, onApplyClick: function () { return setIsShowPopUpApplyJob(true); }, langCode: langCode, isLogin: !!(user === null || user === void 0 ? void 0 : user.accessToken) }, children));
    };
    return (react.createElement(CompanyJob, null,
        react.createElement(PreviewJobWrapper, null,
            react.createElement("p", { className: 'job-title' },
                job.jobInvitation && ((_a = job.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 && ((_b = job.jobInvitation) === null || _b === void 0 ? void 0 : _b.status) === 0 ? (react.createElement(JobCard_css/* JobInvitationIcon */.YZ, { style: { float: 'left' } },
                    react.createElement(MailAddIcon/* default */.Z, null))) : null,
                react.createElement(Variant/* Anchor */.ee, { name: 'title', size: 'small', color: Colors/* colors.grey.40 */.O9.grey[40], href: job.jobUrl +
                        '?utm_source_navi=CompanyRecommendation&utm_medium_navi=Dashboard&utm_campaign_navi=OpenningJob', target: '_blank' }, job.jobTitle))),
        react.createElement(ApplyJobs/* default */.ZP, { accessToken: userToken, isOpen: isShowPopUpApplyJob, langCode: langCode, user: user, jobInfo: job, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', initData: props.initData, onClose: togglePopApplyJob }),
        react.createElement("p", null,
            react.createElement("span", { className: 'job-salary' }, salary),
            ' ',
            react.createElement("span", { className: 'job-location' },
                "| ",
                langCode === constants/* ELanguage.VI */.Df.VI ? job.locationsVI : job.locations))));
};


//# sourceMappingURL=JobItem.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/PlusIcon/index.js
var PlusIcon = __webpack_require__(60819);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/services.js
var services = __webpack_require__(39668);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/urlBuilder.js
var urlBuilder = __webpack_require__(60332);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/company/const.js
'use client';

var FOLLOW_COMPANY_API_END_POINT = 'api-gateway/v1.0/profile/follow';
var DEFAULT_SUCCESS_CODE = 200;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/company/index.js
'use client';





var followCompany = function (baseMsUrl, companyId, isFollow, accessToken, langCode) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var postData, response, err_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                postData = {
                    companyId: companyId,
                    status: isFollow
                };
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(FOLLOW_COMPANY_API_END_POINT), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode || constants/* ELanguage.VI */.Df.VI,
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/const.js
'use client';

var EMPTY_COMPANY_IMAGE = "img/company-default-logo.svg";
var EMPTY_BANNER_IMAGE = "company-assets/images/banner-default-company.png";


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/translations.js
'use client';

var translations = {
    Following: 'Đang theo dõi',
    Follow: 'Theo dõi',
    'opening jobs': 'việc làm',
    'opening job': 'việc làm',
    Unfollowed: 'Đã bỏ theo dõi',
    Unfollow: 'Bỏ theo dõi',
    'Unfollow company?': 'Bỏ theo dõi công ty?',
    "You'll stop receive the newest jobs from this company.": 'Bạn sẽ ngừng nhận thông báo về công việc mới nhất từ ​​công ty này.',
    'Yay! Thanks for following': 'Cảm ơn bạn đã theo dõi',
    'You will receive the newest jobs from this company.': 'Bạn sẽ nhận được thông báo về công việc mới nhất từ công ty này.',
    'You will not able to received notifications from this company.': 'Bạn sẽ ngừng nhận thông tin việc làm từ công ty này.',
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    Negotiate: 'Thương Lượng',
    'View company profile': 'Xem công ty',
    'No opening jobs': 'Chưa có công việc đang tuyển',
    'Invited by employer': 'Được mời ứng tuyển'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/index.js
'use client';






















function CompanyCardSquare(props) {
    var _this = this;
    var companyInfo = props.companyInfo, langCode = props.langCode, user = props.user, baseMsUrl = props.baseMsUrl, baseImgUrl = props.baseImgUrl, baseUrl = props.baseUrl, appMode = props.appMode, _a = props.displayCompanyEvenHaveNoJob, displayCompanyEvenHaveNoJob = _a === void 0 ? false : _a, _b = props.decryptToken, decryptToken = _b === void 0 ? false : _b;
    var _c = (0,react.useState)(companyInfo), company = _c[0], setCompany = _c[1];
    var _d = (0,react.useState)(companyInfo !== null ? (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isFollowed) === 1 : false), isFollowed = _d[0], setFollowed = _d[1];
    var _e = (0,react.useState)(companyInfo !== null && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount : 1), followCount = _e[0], setFollowCount = _e[1];
    var _f = (0,react.useState)(false), isShowUnfollowDialog = _f[0], setShowUnfollowDialog = _f[1];
    var t = function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var isCCP = [1, 3].includes(Number(companyInfo.profilePublishedSiteMask));
    var companyUrl = (0,urlBuilder/* buildCompanyUrl */.kQ)({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || -1,
        companySlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companySlug) || '',
        companyCCPSlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companySlug) || '',
        langCode: langCode !== null && langCode !== void 0 ? langCode : constants/* ELanguage.VI */.Df.VI,
        isCCP: isCCP
    });
    var userToken = decryptToken ? (0,helpers/* decrypt */.pe)((user === null || user === void 0 ? void 0 : user.accessToken) || '') : (user === null || user === void 0 ? void 0 : user.accessToken) || '';
    var doFollow = function (isFollowed) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var response, toastTitle, toastMessage, count, count;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (user === null || !user.accessToken) {
                        return [2 /*return*/];
                    }
                    if (companyInfo === null || !companyInfo.companyId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, followCompany(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', companyInfo.companyId, isFollowed ? 1 : 0, userToken, langCode !== null && langCode !== void 0 ? langCode : constants/* ELanguage.VI */.Df.VI)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        return [2 /*return*/];
                    }
                    toastTitle = t('Unfollowed');
                    toastMessage = t("You'll stop receive the newest jobs from this company.");
                    if (isFollowed) {
                        toastTitle = t('Yay! Thanks for following');
                        toastMessage = t('You will receive the newest jobs from this company.');
                        count = followCount + 1;
                        setFollowCount(count);
                    }
                    else {
                        count = followCount - 1;
                        setFollowCount(count);
                    }
                    (0,Toast/* showToast */.CF)(toastTitle, toastMessage, 'success');
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickFollow = function () {
        if (user === null || !user.accessToken) {
            var loginEvent = new CustomEvent('LOGIN_POPUP', {
                detail: {
                    langCode: langCode
                }
            });
            window.dispatchEvent(loginEvent);
            return;
        }
        if (companyInfo === null || !companyInfo.companyId) {
            return;
        }
        if (isFollowed) {
            setShowUnfollowDialog(true);
        }
        else {
            setFollowed(!isFollowed);
            doFollow(!isFollowed);
        }
    };
    var handleOnClickCompanyDetail = function () {
        if (companyInfo === null || !companyInfo.companyId) {
            return;
        }
        var link = document.createElement('a');
        link.href = companyUrl;
        link.target = isCCP ? '_blank' : '_self';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    var onClickConfirmUnfollow = function () {
        setShowUnfollowDialog(false);
        setFollowed(false);
        doFollow(false);
    };
    // combine default logo | companyLogoURL | companyLogoUrlCCP => companyLogoURL
    var companyLogo = (0,react.useMemo)(function () {
        var _a;
        var logo = companyInfo.companyLogoURL ? companyInfo.companyLogoURL : "".concat(baseImgUrl, "/").concat(EMPTY_COMPANY_IMAGE);
        if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1) {
            logo = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoUrlCCP) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoUrlCCP : (_a = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) !== null && _a !== void 0 ? _a : '';
        }
        if (logo === '') {
            logo = "".concat(baseImgUrl, "/").concat(EMPTY_COMPANY_IMAGE);
        }
        return logo;
    }, [companyInfo]);
    var getJobAttribute = function (jobs) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var res_1, error_1;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,services/* getSpecialJob */.nL)({
                            baseUrl: baseMsUrl || '',
                            accessToken: userToken,
                            jobs: jobs
                        })];
                case 1:
                    res_1 = _b.sent();
                    if (res_1.data && res_1.data.length > 0) {
                        setCompany((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, companyInfo), { bannerDesktopUri: companyInfo.bannerDesktopUri
                                ? companyInfo.bannerDesktopUri
                                : "".concat(baseImgUrl, "/").concat(EMPTY_BANNER_IMAGE), companyLogoURL: companyLogo, jobs: (_a = companyInfo.jobs) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                                var _a, _b, _c, _d, _e, _f, _g;
                                return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { isMatching: (_a = res_1.data[index]) === null || _a === void 0 ? void 0 : _a.isMatching, isSaved: (_b = res_1.data[index]) === null || _b === void 0 ? void 0 : _b.isSaved, isApplied: (_c = res_1.data[index]) === null || _c === void 0 ? void 0 : _c.isApplied, isBlackList: (_d = res_1.data[index]) === null || _d === void 0 ? void 0 : _d.isBlackList, redirectTo: (_e = res_1.data[index]) === null || _e === void 0 ? void 0 : _e.redirectTo, jobInvitation: (_g = (_f = res_1.data[index]) === null || _f === void 0 ? void 0 : _f.jobInvitation) !== null && _g !== void 0 ? _g : { jobInvitationId: 0, status: 0 } });
                            }) }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (companyInfo !== null) {
            if (companyInfo.jobs && companyInfo.jobs.length > 0) {
                getJobAttribute(companyInfo.jobs);
            }
            setFollowed(companyInfo !== null ? companyInfo.isFollowed === 1 : false);
            setFollowCount(companyInfo !== null && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount : 1);
        }
    }, [companyInfo]);
    var jobs = (company === null || company === void 0 ? void 0 : company.jobs) || [];
    jobs.forEach(function (job) {
        var _a;
        if (job.salary === 'Thương lượng') {
            job.salary = t('Negotiate');
        }
        if (job.prettySalary === 'Thương lượng') {
            job.prettySalary = t('Negotiate');
        }
        job.companyLogo = (_a = companyInfo.companyLogoURL) !== null && _a !== void 0 ? _a : '';
    });
    var companyName = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName;
    if (isCCP && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP) !== '') {
        companyName = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP) || '';
    }
    return jobs.length > 0 || displayCompanyEvenHaveNoJob ? (react.createElement(CompanyItemWrapper, { datatype: 'item-wrapper', className: 'view_job_item' },
        react.createElement(BannerSection, null,
            react.createElement(CoverWrapper, null,
                react.createElement("img", { src: company.bannerDesktopUri, alt: companyName || '', placeholder: 'blur', loading: 'lazy' })),
            react.createElement(CompanyHeader, null,
                react.createElement(CompanyLogo, { href: companyUrl, target: isCCP ? '_blank' : '_self' },
                    react.createElement("img", { src: company.companyLogoURL, alt: companyName || '', placeholder: 'blur', loading: 'lazy' })),
                react.createElement(CompanyInfo, null,
                    react.createElement(CompanyName, { href: companyUrl, target: isCCP ? '_blank' : '_self' }, companyName),
                    react.createElement(Row/* default */.Z, null,
                        react.createElement(Col/* default */.Z, null,
                            react.createElement(Typography/* default */.Z, { variant: 'p', name: 'paragraph', size: 'small', color: Colors/* colors.grey.60 */.O9.grey[60] },
                                followCount,
                                " ",
                                followCount > 1 ? t('followers') : t('follower'))),
                        react.createElement(Col/* default */.Z, null,
                            react.createElement(Button/* default */.Z, { type: 'info', outline: 'none', onClick: handleOnClickFollow, iconComponent: react.createElement(PlusIcon/* default */.Z, null), iconPosition: 'left', style: { padding: '2px', height: 32, float: 'right' } }, isFollowed ? t('Following') : t('Follow'))))))),
        react.createElement(ContentSection, null, jobs.length > 0 ? (jobs.map(function (job) { return (react.createElement(JobItem, { key: job.jobId, job: job, user: user, langCode: langCode !== null && langCode !== void 0 ? langCode : constants/* ELanguage.VI */.Df.VI, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', appMode: appMode !== null && appMode !== void 0 ? appMode : '', decryptToken: decryptToken, initData: props.initData })); })) : (react.createElement(EmptyTextWrapper, null, t('No opening jobs')))),
        react.createElement(FollowSection, null,
            react.createElement(Button/* default */.Z, { type: 'outline', isOutline: true, onClick: handleOnClickCompanyDetail }, t('View company profile'))),
        isShowUnfollowDialog && (react.createElement(Popup/* default */.Z, { isShow: isShowUnfollowDialog, lang: langCode !== null && langCode !== void 0 ? langCode : constants/* ELanguage.VI */.Df.VI, styleOption: { size: 'sm' }, text: {
                header: t('Unfollow company?'),
                primaryBtn: t('Unfollow')
            }, onClose: function () { return setShowUnfollowDialog(false); }, onClickPrimary: onClickConfirmUnfollow }, t('You will not able to received notifications from this company.'))))) : null;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 21319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompanyIndustry; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/index.js + 9 modules
var MultipleRadio = __webpack_require__(49336);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/index.js + 2 modules
var MultipleSelect = __webpack_require__(42865);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyIndustry/translations.js
'use client';

var translations = {
    'Select company industry': 'Chọn lĩnh vực công ty',
    'You have selected the max number of 3 industries': 'Bạn đã lựa chọn tối đa 3 lĩnh vực công ty'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyIndustry/index.js
'use client';








var CompanyIndustry = function (props) {
    var _a = props.type, type = _a === void 0 ? 'single-select' : _a, options = props.options, langCode = props.langCode, _b = props.hasError, hasError = _b === void 0 ? false : _b, _c = props.name, name = _c === void 0 ? 'CompanyIndustry' : _c, onChange = props.onChange, onBlur = props.onBlur, placeholder = props.placeholder, _d = props.dropdown, dropdown = _d === void 0 ? {} : _d, isMobile = props.isMobile, _e = props.placement, placement = _e === void 0 ? 'bottom-start' : _e, value = props.value, floatingConfig = props.floatingConfig, _f = props.isEnableSearchAPI, isEnableSearchAPI = _f === void 0 ? false : _f, _g = props.msBaseUrl, msBaseUrl = _g === void 0 ? '' : _g, otherProps = (0,_tslib/* __rest */._T)(props, ["type", "options", "langCode", "hasError", "name", "onChange", "onBlur", "placeholder", "dropdown", "isMobile", "placement", "value", "floatingConfig", "isEnableSearchAPI", "msBaseUrl"]);
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var memoOptions = (0,react.useMemo)(function () {
        return options
            .map(function (item) {
            return {
                id: item.id,
                name: langCode === constants/* ELanguage.EN */.Df.EN ? item.nameEn : item.name
            };
        })
            .sort(function (a, b) { return (a.id < 0 ? -1 : b.id < 0 ? 1 : a.name < b.name ? -1 : 1); });
    }, [options]);
    var handleSelectChange = function (ids) {
        onChange(ids);
    };
    return type === 'single-select' ? (react.createElement(MultipleRadio/* default */.Z, (0,_tslib/* __assign */.pi)({ options: memoOptions, name: name, onChange: function (item) { return handleSelectChange([item.value]); }, hasError: hasError, onBlur: onBlur, dropdown: (0,_tslib/* __assign */.pi)({ maxHeight: '287px', isSearchable: true, emptyText: langCode === constants/* ELanguage.EN */.Df.EN ? 'No result' : 'Không có kết quả', searchBoxPlaceholder: langCode === constants/* ELanguage.EN */.Df.EN ? 'Search' : 'Tìm kiếm', floatingConfig: (0,_tslib/* __assign */.pi)({}, floatingConfig) }, dropdown), placement: placement, isMobile: isMobile, value: value, isEnableSearchAPI: isEnableSearchAPI, msBaseUrl: msBaseUrl, langCode: langCode, placeholder: placeholder }, otherProps))) : (react.createElement(MultipleSelect/* default */.Z, (0,_tslib/* __assign */.pi)({ name: name, options: memoOptions, onChange: function (item) { return handleSelectChange(item.value); }, onBlur: onBlur, langCode: langCode, hasError: hasError, isMobile: isMobile, selectPlaceholder: placeholder || t('Select company industry'), defaultSelect: value, limitText: t("You have selected the max number of 3 industries"), limit: 3, dropdownPlacement: placement, sortEnable: true, floatingConfig: floatingConfig, msBaseUrl: msBaseUrl, isEnableSearchAPI: isEnableSearchAPI }, otherProps)));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 91461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LayoutSystem_Col_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18978);
/* harmony import */ var _LayoutSystem_Row_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39724);
'use client';






var Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.full, full = _b === void 0 ? false : _b, _c = _a.noOffset, noOffset = _c === void 0 ? false : _c; _a.container; var props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["children", "full", "noOffset", "container"]);
    var size = full ? 'full' : 'vnw';
    var xsOffset = noOffset ? 0 : 8;
    var smOffset = noOffset ? 0 : 16;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LayoutSystem_Row_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ ref: ref, container: {
            responsive: {
                xs: {
                    size: size,
                    offset: xsOffset
                },
                sm: {
                    size: size,
                    offset: smOffset
                }
            }
        } }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LayoutSystem_Col_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null, children)));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 16697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ translator; }
/* harmony export */ });
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96306);
'use client';



var translator = function (txt, resource, language) {
    if (!(resource === null || resource === void 0 ? void 0 : resource[txt]))
        return txt;
    switch (language) {
        case _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.EN */ .Df.EN:
            return txt;
        case _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.VI */ .Df.VI:
            return resource[txt];
        default:
            return txt;
    }
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 70092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomRadio$1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CustomRadio/styled.js
'use client';




var Gird = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-gap: 8px;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-gap: 8px;\n"])), function (_a) {
    var col = _a.col;
    return col !== null && col !== void 0 ? col : 1;
});
var templateObject_1;


//# sourceMappingURL=styled.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CustomRadio/index.js
'use client';







function CustomRadio(_a) {
    var _b;
    var options = _a.options, defaultValue = _a.defaultValue, onChangeProp = _a.onChange;
    if (!options || options.length < 0) {
        throw new Error('Some thing wrong, No data found');
    }
    var _c = (0,react.useState)(defaultValue), state = _c[0], setState = _c[1];
    var onClickCb = (0,react.useCallback)(function (value) {
        if (state === value)
            return;
        onChangeProp && onChangeProp(value);
        setState(value);
    }, [state, onChangeProp]);
    (0,react.useEffect)(function () {
        if (defaultValue) {
            setState(defaultValue);
        }
    }, [defaultValue]);
    return (react.createElement(Gird, { col: (_b = options.length) !== null && _b !== void 0 ? _b : 0 }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
        return (react.createElement(Button/* default */.Z, { key: "".concat(option.value, "_").concat(index), outline: 'outline', onClick: function () {
                onClickCb(option.value);
            }, type: option.value === state ? 'info' : 'default' },
            react.createElement(Typography/* default */.Z, { name: 'body', size: 'medium', color: option.value === state ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.20 */.O9.grey[20] }, option.name)));
    })));
}
var CustomRadio$1 = (0,react.memo)(CustomRadio);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 70034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DateInput$1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 1 modules
var Input = __webpack_require__(46779);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DateInput.tsx/const.js
'use client';

// eslint-disable-next-line no-useless-escape
var REGEXP_DDMMYYYY = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
// eslint-disable-next-line no-useless-escape
var REGEXP_MMYYYY = new RegExp(/^(0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
var REGEXP_YYYY = new RegExp(/^((19|20)\d{2})$/); // format: DD/MM/YYYY
var FIRST_MONTH = 0;
var FIRST_DAY = 1;
var defaultPlaceholder = {
    date: {
        en: 'DD/MM/YYYY',
        vi: 'Ngày/Tháng/Năm'
    },
    month: {
        en: 'MM/YYYY',
        vi: 'Tháng/Năm'
    },
    year: {
        en: 'YYYY',
        vi: 'Năm'
    }
};
var MAX_LENGTH_DATE_INPUT = 10;
var MAX_LENGTH_MONTH_INPUT = 7;
var MAX_LENGTH_YEAR_INPUT = 4;


//# sourceMappingURL=const.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/type.js
var DatePicker_type = __webpack_require__(46685);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DateInput.tsx/utils/index.js
'use client';




var getInputMaxlength = function (type) {
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return MAX_LENGTH_DATE_INPUT;
        case DatePicker_type/* EDatePicker.month */.f.month:
            return MAX_LENGTH_MONTH_INPUT;
        case DatePicker_type/* EDatePicker.year */.f.year:
            return MAX_LENGTH_YEAR_INPUT;
        default:
            return MAX_LENGTH_DATE_INPUT;
    }
};
var isValidDateFormat = function (value, type) {
    // Regex pattern for dd/mm/yyyy format
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return REGEXP_DDMMYYYY.test(value);
        case DatePicker_type/* EDatePicker.month */.f.month:
            return REGEXP_MMYYYY.test(value);
        case DatePicker_type/* EDatePicker.year */.f.year:
            return REGEXP_YYYY.test(value);
        default:
            throw new Error('Invalid type. Supported types are "date", "month", and "year".');
    }
};
var padZero = function (value) {
    return value.toString().padStart(2, '0');
};
var formatInputDate = function (value, type, formatTo) {
    var dateParts = value.split('/');
    var date = '';
    var month = '';
    var year = '';
    switch (dateParts.length) {
        case 1:
            year = dateParts[0];
            break;
        case 2:
            month = dateParts[0];
            year = dateParts[1];
            break;
        case 3:
            date = dateParts[0];
            month = dateParts[1];
            year = dateParts[2];
            break;
        default:
            throw new Error('Invalid date format. Supported formats are "dd/mm/yyyy", "mm/yyyy", and "yyyy".');
    }
    // Check if the entered date is a valid date
    var isValidDate = isValidDateFormat(value, type);
    var output = '';
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            // If the date is valid and not "00/00/0000", format it as "dd/mm/yyyy"
            if (isValidDate && !(date === '00' && month === '00' && year === '0000')) {
                output =
                    formatTo === 'string'
                        ? "".concat(padZero(date), "/").concat(padZero(month), "/").concat(year)
                        : new Date(Number(year), Number(month) - 1, Number(date));
                return output;
            }
            break;
        case DatePicker_type/* EDatePicker.month */.f.month:
            // If the date is valid and not "00/0000", format it as "mm/yyyy"
            if (isValidDate && !(month === '00' && year === '0000')) {
                output =
                    formatTo === 'string' ? "".concat(padZero(month), "/").concat(year) : new Date(Number(year), Number(month) - 1, 1);
                return output;
            }
            break;
        case DatePicker_type/* EDatePicker.year */.f.year:
            // If the date is valid and not "0000", format it as "yyyy"
            if (isValidDate && !(year === '0000')) {
                output = formatTo === 'string' ? year : new Date(Number(year), FIRST_MONTH, FIRST_DAY);
                return output;
            }
            break;
        default:
            throw new Error('Invalid type. Supported types are "day", "month", and "year".');
    }
    // If the date is not valid or "00/00/0000", return the empty string
    return '';
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DateInput.tsx/index.js
'use client';









function DateInput(_a) {
    var _b = _a.type, type = _b === void 0 ? DatePicker_type/* EDatePicker.date */.f.date : _b, _c = _a.value, valueProps = _c === void 0 ? '' : _c, hasError = _a.hasError, onChangeProps = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, _d = _a.langCode, langCode = _d === void 0 ? constants/* ELanguage.EN */.Df.EN : _d, placeholder = _a.placeholder, min = _a.min, max = _a.max, isShowIcon = _a.isShowIcon, _e = _a.isPresent, isPresent = _e === void 0 ? false : _e;
    var _f = (0,react.useState)(valueProps || ''), inputValue = _f[0], setInputValue = _f[1];
    var onChange = function (value) {
        try {
            if (value) {
                var date = formatInputDate(value, type, 'Date');
                onChangeProps && onChangeProps(new Date(date));
                return;
            }
            onChangeProps && onChangeProps(null);
        }
        catch (error) {
            throw Error('Invalid date');
        }
    };
    var dateCheck = function (value) {
        if (!isPresent) {
            var isValid = isValidDateFormat(value, type);
            if (!isValid) {
                setInputValue('');
            }
            var date = formatInputDate(value, type, 'Date');
            var checkMinMax = (min && min > new Date(date)) || (max && max < new Date(date));
            if (isValid && checkMinMax) {
                setInputValue('');
            }
        }
    };
    var onInputChange = function (value) {
        if (!value) {
            onChangeProps && onChangeProps(null);
        }
        try {
            setInputValue(value);
            switch (type) {
                case DatePicker_type/* EDatePicker.date */.f.date:
                    // if (value.length === 2 && REGEXP_DD.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    // if (value.length === 5 && REGEXP_DDMM.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    if (REGEXP_DDMMYYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                case DatePicker_type/* EDatePicker.month */.f.month:
                    // if (value.length === 2 && REGEXP_DD.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    if (REGEXP_MMYYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                case DatePicker_type/* EDatePicker.year */.f.year:
                    if (REGEXP_YYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                default:
                    break;
            }
        }
        catch (error) {
            throw Error('Invalid date');
        }
    };
    var onKeyDown = function (e) {
        if (e.key === 'Tab' || e.code === 'Tab') {
            dateCheck(inputValue);
            onBlur && onBlur(inputValue);
        }
    };
    (0,react.useEffect)(function () {
        setInputValue(valueProps || '');
    }, [valueProps]);
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (!inputValue) {
            onChange(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);
    return (react.createElement(Input/* default */.Z, { type: 'text', clearValue: isShowIcon, hasError: hasError, value: inputValue, onFocus: function (e) {
            var _a;
            onFocus && onFocus((_a = e.target) === null || _a === void 0 ? void 0 : _a.value, e);
        }, onBlur: function (e) {
            var _a, _b;
            dateCheck((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
            onBlur && onBlur((_b = e.target) === null || _b === void 0 ? void 0 : _b.value, e);
        }, onChange: onInputChange, onKeyDown: onKeyDown, placeholder: placeholder || defaultPlaceholder[type][langCode], disabled: disabled, maxLength: getInputMaxlength(type) }));
}
var DateInput$1 = react.memo(DateInput);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 81599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CombinePicker; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Calendar_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21810);
/* harmony import */ var _styles_css_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1620);
/* harmony import */ var _Calendar_types_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36433);
/* harmony import */ var _type_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46685);
/* harmony import */ var _utils_dateTimeFormat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9865);
/* harmony import */ var _Images_Calendar_Calendar_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43762);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96306);
/* harmony import */ var _DateInput_tsx_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70034);
/* harmony import */ var _hooks_useFloating_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80200);
/* harmony import */ var _hooks_useClickAway_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15758);
/* harmony import */ var _hooks_useDropdownAnimation_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91623);
'use client';

















function CombinePicker(_a) {
    var defaultDate = _a.defaultDate, onChangeProps = _a.onChange, _b = _a.min, min = _b === void 0 ? new Date(1900, 0, 1) : _b, max = _a.max, _c = _a.type, type = _c === void 0 ? _type_js__WEBPACK_IMPORTED_MODULE_1__/* .EDatePicker.date */ .f.date : _c, placeholder = _a.placeholder, _d = _a.hasError, hasError = _d === void 0 ? false : _d, onBlur = _a.onBlur, onFocus = _a.onFocus, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.langCode, langCode = _f === void 0 ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .ELanguage.EN */ .Df.EN : _f, calendarConfig = _a.calendarConfig, _g = _a.isFlip, isFlip = _g === void 0 ? false : _g, _h = _a.isShowIcon, isShowIcon = _h === void 0 ? true : _h, rangeYears = _a.rangeYears;
    var _j = calendarConfig || {}, floatingConfig = _j.floatingConfig, _k = _j.placement, placement = _k === void 0 ? 'bottom-start' : _k, _l = _j.dropdownOffset, dropdownOffset = _l === void 0 ? 0 : _l;
    var _m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultDate), date = _m[0], setDate = _m[1];
    var inputValue = date && (0,_utils_dateTimeFormat_js__WEBPACK_IMPORTED_MODULE_3__/* .datetimeFormat */ ._I)(date, type);
    var _o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showCalendar = _o[0], setShowCalendar = _o[1];
    var _p = (0,_hooks_useFloating_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        placement: placement,
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .pi)({ offset: dropdownOffset, detectHidden: true, useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false }, (!isFlip ? undefined : { isFlip: isFlip }))
    }), refs = _p.refs, context = _p.context, FloatingPortal = _p.FloatingPortal;
    (0,_hooks_useClickAway_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function () {
        setShowCalendar(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    var _q = (0,_hooks_useDropdownAnimation_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(showCalendar, context.placement), isMounted = _q.isMounted, dropdownStyles = _q.styles;
    var onShowCalendar = function () {
        if (disabled)
            return;
        setShowCalendar(function (state) { return !state; });
    };
    var onChange = function (date) {
        var timer = null;
        timer && clearTimeout(timer);
        if ((date && min && min > new Date(date)) || (date && max && max < new Date(date))) {
            onChangeProps && onChangeProps(null);
            setDate(null);
            setShowCalendar(false);
            return;
        }
        timer = setTimeout(function () {
            setDate(date);
            onChangeProps && onChangeProps(date);
            if (date instanceof Date) {
                setShowCalendar(false);
            }
        }, 0);
    };
    var onKeyDown = function (e) {
        if (e.key === 'Tab' || e.code === 'Tab') {
            setShowCalendar(false);
            onBlur && onBlur();
        }
    };
    /*
     * Update date after defaultDate updated
     * */
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // check invalid date, if not return null
        if (defaultDate) {
            var newDate = !isNaN(new Date(defaultDate).getTime()) ? new Date(defaultDate) : null;
            setDate(newDate);
        }
        else {
            setDate(null);
        }
    }, [defaultDate]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* .PickerContainer */ .U1, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* .InputWrap */ .Rd, { ref: refs.setReference, onKeyDown: onKeyDown },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DateInput_tsx_index_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { type: type, value: inputValue, placeholder: placeholder, onChange: onChange, onBlur: function (value) {
                    var isValid = value && (0,_utils_dateTimeFormat_js__WEBPACK_IMPORTED_MODULE_3__/* .isValidDateFormat */ .Gt)(value, type);
                    if (!isValid) {
                        setDate(null);
                    }
                }, onFocus: function () {
                    setShowCalendar(true);
                    onFocus && onFocus();
                }, disabled: disabled, hasError: hasError, min: min, max: max, isShowIcon: isShowIcon }),
            isShowIcon && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, { isIcon: true, onClick: onShowCalendar, position: 'absolute', outline: 'none' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Images_Calendar_Calendar_js__WEBPACK_IMPORTED_MODULE_10__/* .CalendarIcon */ .Q, { size: 20 })))),
        isMounted ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles_css_js__WEBPACK_IMPORTED_MODULE_8__/* .Wrapper */ .im, { ref: refs.setPopup, style: {
                    position: context.position,
                    left: context.x,
                    top: context.y,
                    display: context.isReferenceHidden ? 'none' : 'block'
                } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: dropdownStyles },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Calendar_index_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, { langCode: langCode, initDates: date ? [date] : null, min: min, max: max, type: (0,_utils_dateTimeFormat_js__WEBPACK_IMPORTED_MODULE_3__/* .calendarCombineType */ .eQ)(type), pickerType: _Calendar_types_js__WEBPACK_IMPORTED_MODULE_12__/* .ECalendarStyle.single */ .w.single, calendarStyle: _Calendar_types_js__WEBPACK_IMPORTED_MODULE_12__/* .ECalendarStyle.single */ .w.single, handleDateClick: function (dates) {
                            if (dates && dates.length > 0) {
                                onChange(dates[0]);
                                return;
                            }
                            onChange(null);
                        }, rangeYears: rangeYears }))))) : null));
}


//# sourceMappingURL=CombinePicker.js.map


/***/ }),

/***/ 1620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JO": function() { return /* binding */ Icon; },
/* harmony export */   "OX": function() { return /* binding */ InputRange; },
/* harmony export */   "Rc": function() { return /* binding */ Present; },
/* harmony export */   "Rd": function() { return /* binding */ InputWrap; },
/* harmony export */   "U1": function() { return /* binding */ PickerContainer; },
/* harmony export */   "_z": function() { return /* binding */ CalendarWrap; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zY": function() { return /* binding */ InputRangeField; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Button_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1189);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96306);
/* harmony import */ var _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79962);
'use client';







var PickerContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    width: 100%;\n    height: auto;\n    input[type='date']::-webkit-inner-spin-button,\n    input[type='date']::-webkit-calendar-picker-indicator {\n        display: none;\n        -webkit-appearance: none;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n    height: auto;\n    input[type='date']::-webkit-inner-spin-button,\n    input[type='date']::-webkit-calendar-picker-indicator {\n        display: none;\n        -webkit-appearance: none;\n    }\n"])));
var InputWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    width: 100%;\n    svg.remove-icon {\n        right: 35px !important;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n    svg.remove-icon {\n        right: 35px !important;\n    }\n"])));
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Button_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: ", ";\n    top: 2px;\n    right: 2px;\n    min-width: 36px;\n    min-height: 36px;\n    width: 36px;\n    height: 36px;\n    &:focus,\n    &:hover {\n        border: none !important;\n        box-shadow: none !important;\n    }\n"], ["\n    position: ", ";\n    top: 2px;\n    right: 2px;\n    min-width: 36px;\n    min-height: 36px;\n    width: 36px;\n    height: 36px;\n    &:focus,\n    &:hover {\n        border: none !important;\n        box-shadow: none !important;\n    }\n"])), function (_a) {
    var position = _a.position;
    return position || 'static';
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    z-index: 1099;\n    width: max-content;\n"], ["\n    z-index: 1099;\n    width: max-content;\n"])));
var CalendarWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var show = _a.show;
    return _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dropdownAnimation */ .ZP.dropdownAnimation(show);
});
var Present = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    height: 44px;\n    margin-top: 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    border-radius: 8px;\n    background: white;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    font-weight: normal;\n"], ["\n    display: flex;\n    height: 44px;\n    margin-top: 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    border-radius: 8px;\n    background: white;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    font-weight: normal;\n"])));
var InputRange = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    background-color: #fff;\n    border-radius: 6px;\n    border-radius: 6px;\n    background-color: #fff;\n    border: 1px solid ", ";\n    color: ", ";\n    &:hover {\n        border: 1px solid ", ";\n        box-shadow: none;\n        background-color: #fff;\n    }\n    &:focus,\n    &:active {\n        border: 1px solid ", ";\n    }\n    &:disabled {\n        box-shadow: none;\n        border: 1px solid ", ";\n        background-color: ", ";\n        color: #999;\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n    &::placeholder {\n        color: #999;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    background-color: #fff;\n    border-radius: 6px;\n    border-radius: 6px;\n    background-color: #fff;\n    border: 1px solid ", ";\n    color: ", ";\n    &:hover {\n        border: 1px solid ", ";\n        box-shadow: none;\n        background-color: #fff;\n    }\n    &:focus,\n    &:active {\n        border: 1px solid ", ";\n    }\n    &:disabled {\n        box-shadow: none;\n        border: 1px solid ", ";\n        background-color: ", ";\n        color: #999;\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n    &::placeholder {\n        color: #999;\n    }\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.borderNormal */ .O9.borderNormal, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.textColor */ .O9.textColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.borderHover */ .O9.borderHover, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.borderFocus */ .O9.borderFocus, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.borderDisable */ .O9.borderDisable, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.bgDisable */ .O9.bgDisable);
var InputRangeField = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    justify-content: space-between;\n    gap: 10px;\n\n    input {\n        border: none !important ;\n        outline: none !important;\n        &:hover,\n        &:focus {\n            border: none !important ;\n            outline: none !important;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    justify-content: space-between;\n    gap: 10px;\n\n    input {\n        border: none !important ;\n        outline: none !important;\n        &:hover,\n        &:focus {\n            border: none !important ;\n            outline: none !important;\n        }\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


//# sourceMappingURL=styles.css.js.map


/***/ }),

/***/ 46685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ EDatePicker; }
/* harmony export */ });
'use client';

var EDatePicker;
(function (EDatePicker) {
    EDatePicker["date"] = "date";
    EDatePicker["month"] = "month";
    EDatePicker["year"] = "year";
})(EDatePicker || (EDatePicker = {}));


//# sourceMappingURL=type.js.map


/***/ }),

/***/ 9865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eQ": function() { return /* binding */ calendarCombineType; },
  "NW": function() { return /* binding */ calendarType; },
  "_I": function() { return /* binding */ datetimeFormat; },
  "zB": function() { return /* binding */ formatInputDate; },
  "Gt": function() { return /* binding */ isValidDateFormat; }
});

// UNUSED EXPORTS: padZero

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/const.js
'use client';

// eslint-disable-next-line no-useless-escape
var REGEXP_DDMMYYYY = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
// eslint-disable-next-line no-useless-escape
var REGEXP_MMYYYY = new RegExp(/^(0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
var REGEXP_YYYY = new RegExp(/^((19|20)\d{2})$/); // format: DD/MM/YYYY
var FIRST_MONTH = 0;
var FIRST_DAY = 1;


//# sourceMappingURL=const.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/type.js
var DatePicker_type = __webpack_require__(46685);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/types.js
var types = __webpack_require__(36433);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/utils/dateTimeFormat.js
'use client';






var isValidDateFormat = function (value, type) {
    // Regex pattern for dd/mm/yyyy format
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return REGEXP_DDMMYYYY.test(value);
        case DatePicker_type/* EDatePicker.month */.f.month:
            return REGEXP_MMYYYY.test(value);
        case DatePicker_type/* EDatePicker.year */.f.year:
            return REGEXP_YYYY.test(value);
        default:
            throw new Error('Invalid type. Supported types are "date", "month", and "year".');
    }
};
function datetimeFormat(date, type, _locale) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = String(date.getFullYear());
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return "".concat(day, "/").concat(month, "/").concat(year);
        case DatePicker_type/* EDatePicker.month */.f.month:
            return "".concat(month, "/").concat(year);
        case DatePicker_type/* EDatePicker.year */.f.year:
            return year;
        default:
            throw new Error('Invalid type. Supported types are "date", "month", and "year".');
    }
}
var padZero = function (value) {
    return value.toString().padStart(2, '0');
};
var formatInputDate = function (value, type, formatTo) {
    var dateParts = value.split('/');
    var date = '';
    var month = '';
    var year = '';
    switch (dateParts.length) {
        case 1:
            year = dateParts[0];
            break;
        case 2:
            month = dateParts[0];
            year = dateParts[1];
            break;
        case 3:
            date = dateParts[0];
            month = dateParts[1];
            year = dateParts[2];
            break;
        default:
            throw new Error('Invalid date format. Supported formats are "dd/mm/yyyy", "mm/yyyy", and "yyyy".');
    }
    // Check if the entered date is a valid date
    var isValidDate = isValidDateFormat(value, type);
    var output = '';
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            // If the date is valid and not "00/00/0000", format it as "dd/mm/yyyy"
            if (isValidDate && !(date === '00' && month === '00' && year === '0000')) {
                output =
                    formatTo === 'string'
                        ? "".concat(padZero(date), "/").concat(padZero(month), "/").concat(year)
                        : new Date(Number(year), Number(month) - 1, Number(date));
                return output;
            }
            break;
        case DatePicker_type/* EDatePicker.month */.f.month:
            // If the date is valid and not "00/0000", format it as "mm/yyyy"
            if (isValidDate && !(month === '00' && year === '0000')) {
                output =
                    formatTo === 'string' ? "".concat(padZero(month), "/").concat(year) : new Date(Number(year), Number(month) - 1, 1);
                return output;
            }
            break;
        case DatePicker_type/* EDatePicker.year */.f.year:
            // If the date is valid and not "0000", format it as "yyyy"
            if (isValidDate && !(year === '0000')) {
                output = formatTo === 'string' ? year : new Date(Number(year), FIRST_MONTH, FIRST_DAY);
                return output;
            }
            break;
        default:
            throw new Error('Invalid type. Supported types are "day", "month", and "year".');
    }
    // If the date is not valid or "00/00/0000", return the empty string
    return '';
};
var calendarType = function (type) {
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return types/* ECalendarType.month */.i.month;
        case DatePicker_type/* EDatePicker.month */.f.month:
            return types/* ECalendarType.year */.i.year;
        case DatePicker_type/* EDatePicker.year */.f.year:
            return types/* ECalendarType.decade */.i.decade;
        default:
            return types/* ECalendarType.month */.i.month;
    }
};
var calendarCombineType = function (type) {
    switch (type) {
        case DatePicker_type/* EDatePicker.date */.f.date:
            return types/* ECalendarType.combine */.i.combine;
        case DatePicker_type/* EDatePicker.month */.f.month:
            return types/* ECalendarType.combineMonthAndYear */.i.combineMonthAndYear;
        case DatePicker_type/* EDatePicker.year */.f.year:
            return types/* ECalendarType.decade */.i.decade;
        default:
            return types/* ECalendarType.month */.i.month;
    }
};


//# sourceMappingURL=dateTimeFormat.js.map


/***/ }),

/***/ 46475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DragDropResumeUpload$1; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/index.js
var resumes = __webpack_require__(93843);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/const.js
var resumes_const = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/UploadIcon/index.js
var UploadIcon = __webpack_require__(63606);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LoadingIcon/index.js
var LoadingIcon = __webpack_require__(50293);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/styles.css.js
var styles_css = __webpack_require__(42661);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/translations.js
'use client';

var translations = {
    'Upload file from your device': 'Chọn hồ sơ từ máy của bạn',
    '.doc, .docx and .pdf files that are less than 5120KB in size': 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB',
    or: 'hoặc',
    'Choose file to upload': 'Chọn hồ sơ từ máy bạn',
    'Drag your file here': 'Kéo hồ sơ của bạn vào đây',
    'Upload success': 'Tải lên thành công',
    'Replace file': 'Thay thế hồ sơ',
    'Your upload was successful': 'Tải lên thành công',
    'Drag & drop your CV here to quickly create your profile with AI': 'Kéo thả CV của bạn để tạo nhanh hồ sơ với AI'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/type.js
var type = __webpack_require__(65834);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/constants.js
'use client';



var DEFAULT_DRAG_DROP_FILE_STYLE = {
    borderColor: Colors/* colors.primary.30 */.O9.primary[30],
    backgroundColor: Colors/* colors.primary.100 */.O9.primary[100]
};
var DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE = {
    borderColor: Colors/* colors.grey.60 */.O9.grey[60],
    backgroundColor: Colors/* colors.grey.99 */.O9.grey[99]
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SuccessIcon/index.js
var SuccessIcon = __webpack_require__(85658);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DocumentsIcon/index.js
'use client';




function DocumentsIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? "".concat(Colors/* colors.primary.40 */.O9.primary[40]) : _b, _c = _a.width, width = _c === void 0 ? 21 : _c, _d = _a.height, height = _d === void 0 ? 21 : _d, style = _a.style;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', style: style, width: width, height: height, viewBox: '0 0 21 21', fill: 'none' },
        react.createElement("path", { d: 'M16.971 6.36265L12.6377 2.02932C12.5123 1.90398 12.343 1.83398 12.1663 1.83398H5.16634C4.42967 1.83398 3.83301 2.43065 3.83301 3.16732V17.834C3.83301 18.5707 4.42967 19.1673 5.16634 19.1673H15.833C16.5697 19.1673 17.1663 18.5707 17.1663 17.834V6.83398C17.1663 6.65732 17.0963 6.48798 16.971 6.36265ZM12.4997 14.5007H7.16634C6.79834 14.5007 6.49967 14.202 6.49967 13.834C6.49967 13.466 6.79834 13.1673 7.16634 13.1673H12.4997C12.8677 13.1673 13.1663 13.466 13.1663 13.834C13.1663 14.202 12.8677 14.5007 12.4997 14.5007ZM13.833 11.834H7.16634C6.79834 11.834 6.49967 11.5353 6.49967 11.1673C6.49967 10.7993 6.79834 10.5007 7.16634 10.5007H13.833C14.201 10.5007 14.4997 10.7993 14.4997 11.1673C14.4997 11.5353 14.201 11.834 13.833 11.834ZM12.4997 7.16732C12.1317 7.16732 11.833 6.86865 11.833 6.50065V3.10332L15.897 7.16732H12.4997Z', fill: color })));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/apiServices.js
var apiServices = __webpack_require__(84214);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddFilledIcon/index.js
var AddFilledIcon = __webpack_require__(94864);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/Documentv2Icon/index.js
'use client';



var Documentv2Icon = function (props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, _b = props.width, width = _b === void 0 ? 50 : _b, _c = props.height, height = _c === void 0 ? 53 : _c, style = props.style, _d = props.color, color = _d === void 0 ? '#0047CC' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, style: style, viewBox: '0 0 50 54', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Documents', clipPath: 'url(#clip0_29878_281683)' },
            react.createElement("path", { id: 'Vector', d: 'M3.60039 17.4C1.83239 17.4 0.400391 18.832 0.400391 20.6V49.4C0.400391 51.168 1.83239 52.6 3.60039 52.6H6.09102C5.54062 51.6544 5.20039 50.5712 5.20039 49.4V20.6C5.20039 19.4288 5.54062 18.3456 6.09102 17.4H3.60039ZM11.6004 17.4C9.83239 17.4 8.40039 18.832 8.40039 20.6V49.4C8.40039 51.168 9.83239 52.6 11.6004 52.6H32.4004C34.1684 52.6 35.6004 51.168 35.6004 49.4V27.8C35.6004 27.376 35.4324 26.9695 35.1316 26.6687L26.3316 17.8687C26.0308 17.5679 25.6244 17.4 25.2004 17.4H11.6004ZM24.4004 20.4469L32.5535 28.6H26.0004C25.1172 28.6 24.4004 27.8832 24.4004 27V20.4469ZM16.4004 35H27.6004C28.4836 35 29.2004 35.7168 29.2004 36.6C29.2004 37.4832 28.4836 38.2 27.6004 38.2H16.4004C15.5172 38.2 14.8004 37.4832 14.8004 36.6C14.8004 35.7168 15.5172 35 16.4004 35ZM16.4004 41.4H24.4004C25.2836 41.4 26.0004 42.1168 26.0004 43C26.0004 43.8832 25.2836 44.6 24.4004 44.6H16.4004C15.5172 44.6 14.8004 43.8832 14.8004 43C14.8004 42.1168 15.5172 41.4 16.4004 41.4Z', fill: color }),
            react.createElement("path", { id: 'Vector_2', d: 'M31.2538 2.78088C30.8555 2.9125 30.8555 3.47613 31.2538 3.60663C32.1718 3.90813 32.8918 4.62925 33.1944 5.54725C33.326 5.9455 33.8896 5.9455 34.0201 5.54725C34.3216 4.62925 35.0428 3.90925 35.9608 3.60663C36.359 3.475 36.359 2.91138 35.9608 2.78088C35.0428 2.47938 34.3228 1.75825 34.0201 0.840252C33.8885 0.442002 33.3249 0.442002 33.1944 0.840252C32.8918 1.75938 32.1718 2.47938 31.2538 2.78088ZM43.8943 2.10588C43.739 1.63338 43.0696 1.63338 42.9144 2.10588L42.1876 4.31763C41.8299 5.40663 40.9749 6.2605 39.887 6.61825L37.6753 7.345C37.2028 7.50025 37.2028 8.16963 37.6753 8.32488L39.887 9.05163C40.976 9.40938 41.8299 10.2644 42.1876 11.3523L42.9144 13.564C43.0696 14.0365 43.739 14.0365 43.8943 13.564L44.6221 11.3523C44.9799 10.2633 45.8338 9.40938 46.9228 9.05163L49.1345 8.32488C49.607 8.16963 49.607 7.50025 49.1345 7.345L46.9228 6.61713C45.8338 6.25938 44.9799 5.4055 44.6221 4.3165L43.8943 2.10588ZM36.1599 11.3871C36.0046 10.9146 35.3353 10.9146 35.18 11.3871L35.0911 11.6583C34.7334 12.7473 33.8795 13.6011 32.7905 13.9589L32.5194 14.0478C32.0469 14.203 32.0469 14.8724 32.5194 15.0276L32.7905 15.1165C33.8795 15.4743 34.7334 16.3281 35.0911 17.4171L35.18 17.6883C35.3353 18.1608 36.0046 18.1608 36.1599 17.6883L36.2488 17.4171C36.6065 16.3281 37.4615 15.4743 38.5494 15.1165L38.8205 15.0276C39.293 14.8724 39.293 14.203 38.8205 14.0478L38.5494 13.9589C37.4604 13.6011 36.6065 12.7461 36.2488 11.6583L36.1599 11.3871Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_29878_281683' },
                react.createElement("rect", { width: '50', height: '53', fill: 'white', transform: 'translate(0 0.5)' })))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Contexts/translator/helper.js
var helper = __webpack_require__(16697);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/index.js
'use client';



























var DragDropResumeUpload = function (_a, ref) {
    var _b;
    var accessToken = _a.accessToken, _c = _a.lang, lang = _c === void 0 ? constants/* ELanguage.VI */.Df.VI : _c, baseUrl = _a.baseUrl, userId = _a.userId, jobId = _a.jobId, contentOptions = _a.contentOptions, onUpload = _a.onUpload, onUploadDone = _a.onUploadDone, onUploadError = _a.onUploadError, isUploadResume = _a.isUploadResume, dragDropStyle = _a.dragDropStyle, _d = _a.boxType, boxType = _d === void 0 ? type/* EBoxType.primary */.Y.primary : _d, // read docs stories book for more information,
    style = _a.style, fileInfo = _a.fileInfo, _e = _a.apiUploadVersion, apiUploadVersion = _e === void 0 ? 'v2.0' : _e, _f = _a.isCheckSpam, isCheckSpam = _f === void 0 ? true : _f, _g = _a.isLoading, isLoading = _g === void 0 ? false : _g, _h = _a.isNewUploadUI, isNewUploadUI = _h === void 0 ? false : _h;
    var _j = (0,react.useState)(false), isDrag = _j[0], setIsDrag = _j[1];
    var _k = (0,react.useState)(false), isError = _k[0], setIsError = _k[1];
    var _l = (0,react.useState)((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : null), message = _l[0], setMessage = _l[1];
    var _m = (0,react.useState)(!(fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.name) ? 'none' : 'success'), uploadStatus = _m[0], setUploadStatus = _m[1];
    var _o = (0,react.useState)(fileInfo), file = _o[0], setFile = _o[1];
    var inputRef = (0,react.useRef)(null);
    var unitId = (0,helpers/* randomId */.kb)();
    var mergedDragDropStyles = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, (boxType === type/* EBoxType.secondary */.Y.secondary ? DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE : DEFAULT_DRAG_DROP_FILE_STYLE)), dragDropStyle);
    var t = function (txt) {
        var text = (0,helper/* translator */.O)(txt, translations, lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI);
        return text;
    };
    var validateResume = function (uploadFileInfo) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0,_tslib/* __generator */.Jh)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* validateFile */.D0)({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: uploadFileInfo,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            userId: userId !== null && userId !== void 0 ? userId : 0,
                            jobId: jobId !== null && jobId !== void 0 ? jobId : 0
                        })];
                case 1:
                    response = _j.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) && !((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.spam)) {
                        !isUploadResume &&
                            setMessage(((_d = response.meta) === null || _d === void 0 ? void 0 : _d.statusCode) === 200
                                ? t('Your upload was successful')
                                : (_f = (_e = response === null || response === void 0 ? void 0 : response.meta) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : '');
                        !isUploadResume && setUploadStatus('success');
                        setIsError(false);
                        !isUploadResume && onUpload ? onUpload(uploadFileInfo) : null;
                        return [2 /*return*/, true];
                    }
                    setMessage((_h = (_g = response === null || response === void 0 ? void 0 : response.meta) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : '');
                    setUploadStatus('none');
                    setIsError(true);
                    return [2 /*return*/, false];
                case 2:
                    error_1 = _j.sent();
                    setUploadStatus('none');
                    console.error(error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reset = function () {
        var _a;
        if (inputRef.current) {
            setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _a !== void 0 ? _a : '');
            inputRef.current.value = '';
            if (!/safari/i.test(navigator.userAgent)) {
                inputRef.current.type = '';
                inputRef.current.type = 'file';
            }
        }
    };
    var doUploadFile = function (file, resumeId, customResponseMessage, action) {
        if (resumeId === void 0) { resumeId = -1; }
        if (customResponseMessage === void 0) { customResponseMessage = ''; }
        if (action === void 0) { action = -1; }
        return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var requestParams, response, responseMessage, jobAlertData, error_2;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return (0,_tslib/* __generator */.Jh)(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!file)
                            return [2 /*return*/, null];
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 7, , 8]);
                        if (isLoading)
                            setUploadStatus('processing');
                        requestParams = {
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: file,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            resumeId: resumeId,
                            apiUploadVersion: apiUploadVersion
                        };
                        if (action !== -1) {
                            requestParams.action = action;
                        }
                        return [4 /*yield*/, (0,resumes/* uploadFile */.cT)(requestParams)];
                    case 2:
                        response = _l.sent();
                        if (response instanceof model/* default */.Z) {
                            setIsError(true);
                            setUploadStatus('none');
                            setMessage((_b = (_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '');
                            onUploadError && onUploadError(response);
                            return [2 /*return*/, null];
                        }
                        if (!(response && response.data)) return [3 /*break*/, 5];
                        onUploadDone && onUploadDone(response);
                        responseMessage = customResponseMessage !== '' ? customResponseMessage : (_c = response === null || response === void 0 ? void 0 : response.message) !== null && _c !== void 0 ? _c : '';
                        setMessage(response.status === 200 ? t('Your upload was successful') : responseMessage);
                        setFile({
                            name: (_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ' ',
                            link: (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.link) !== null && _g !== void 0 ? _g : '',
                            id: (_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : 0
                        });
                        jobAlertData = response.data.job_alert_data;
                        if (!((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.summary) && jobAlertData.summary !== '')) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0,apiServices/* updateSummaryProfileSetting */.ni)({
                                url: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                                summary: (_k = jobAlertData.summary) !== null && _k !== void 0 ? _k : '',
                                accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : ''
                            })];
                    case 3:
                        _l.sent();
                        _l.label = 4;
                    case 4:
                        setUploadStatus('success');
                        setIsError(false);
                        return [2 /*return*/, response.data];
                    case 5:
                        onUploadError && onUploadError(response);
                        _l.label = 6;
                    case 6: return [2 /*return*/, null];
                    case 7:
                        error_2 = _l.sent();
                        setUploadStatus('none');
                        console.error(error_2);
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            reset: reset,
            doUploadFile: function (file, resumeId, customResponseMessage, action) {
                if (customResponseMessage === void 0) { customResponseMessage = ''; }
                if (action === void 0) { action = -1; }
                return doUploadFile(file, resumeId, customResponseMessage, action);
            }
        };
    }, [accessToken]);
    var checkUploadFile = function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var uploadFileInfo, isValid, _a;
        var _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setUploadStatus('processing');
                    uploadFileInfo = file;
                    // check file extensions
                    if (!resumes_const/* DEFAULT_ALLOW_FILES_EXT.includes */.Ri.includes(uploadFileInfo.type)) {
                        // show error file type doesn't support
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // check file size
                    if (uploadFileInfo.size > resumes_const/* DEFAULT_LIMIT_FILE_SIZE */.hS) {
                        // File is over 5MB
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // validate spam cv
                    setMessage((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : '');
                    if (!isCheckSpam) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateResume(file)];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = true;
                    _c.label = 3;
                case 3:
                    isValid = _a;
                    // do upload file
                    if (isUploadResume && isValid) {
                        doUploadFile(uploadFileInfo);
                    }
                    if (!isCheckSpam && !isUploadResume) {
                        setIsError(false);
                        setUploadStatus('success');
                        onUpload && onUpload(file);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setIsDrag(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setIsDrag(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDrag(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    var renderIcon = function () {
        switch (uploadStatus) {
            case 'none':
                // Removed settingIcon
                return react.createElement(AddFilledIcon/* default */.Z, null);
            case 'processing':
                return react.createElement(LoadingIcon/* default */.Z, null);
            case 'success':
                return boxType === type/* EBoxType.primary */.Y.primary ? react.createElement(UploadIcon/* default */.Z, null) : react.createElement(SuccessIcon/* default */.Z, { width: 24, height: 24 });
            default:
                return null;
        }
    };
    var renderLabel = function () {
        if (boxType === type/* EBoxType.primary */.Y.primary) {
            return t('Upload file from your device');
        }
        switch (uploadStatus) {
            case 'success':
                return t('Upload success');
            default:
                return t('Drag your file here');
        }
    };
    var renderResponseMsgColor = function () {
        switch (boxType) {
            case type/* EBoxType.primary */.Y.primary:
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
            case type/* EBoxType.secondary */.Y.secondary:
                if (uploadStatus === 'success') {
                    return Colors/* colors.grey.20 */.O9.grey[20];
                }
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
            default:
                return isError ? Colors/* colors.error.40 */.O9.error[40] : Colors/* colors.grey.60 */.O9.grey[60];
        }
    };
    (0,react.useEffect)(function () {
        var _a;
        setIsError(!!(contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg));
        setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg) !== null && _a !== void 0 ? _a : t('.doc, .docx and .pdf files that are less than 5120KB in size'));
    }, [contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg]);
    if (isNewUploadUI) {
        return (react.createElement(styles_css/* NewUIContainer */.v2, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
            react.createElement(styles_css/* IconWrapper */.a1, null,
                react.createElement(Documentv2Icon, null)),
            react.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: resumes_const/* DEFAULT_ALLOW_EXT */.Wx, onChange: handleOnFileChange }),
            react.createElement(styles_css/* InfoMessage */.$J, null, t('Drag & drop your CV here to quickly create your profile with AI')),
            react.createElement(styles_css/* ResponseMsg */.bU, { variant: 'p', name: 'body', size: boxType === type/* EBoxType.primary */.Y.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() }, message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
            react.createElement(styles_css/* Placeholder */.Vm, { boxType: boxType },
                react.createElement(Button/* default */.Z, { isRounded: true, type: 'highlight', outline: 'outline', size: 'sm', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()))));
    }
    return (react.createElement(styles_css/* Container */.W2, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
        react.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: resumes_const/* DEFAULT_ALLOW_EXT */.Wx, onChange: handleOnFileChange }),
        react.createElement(styles_css/* Placeholder */.Vm, { boxType: boxType },
            react.createElement(Button/* default */.Z, { iconPosition: 'left', iconComponent: renderIcon(), isRounded: true, type: 'highlight', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()),
            boxType === type/* EBoxType.secondary */.Y.secondary && (react.createElement(react.Fragment, null, !(file === null || file === void 0 ? void 0 : file.name) ? (react.createElement(react.Fragment, null,
                react.createElement(Typography/* default */.Z, { variant: 'p', name: 'body', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20] }, t('or')),
                react.createElement(Button/* default */.Z, { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, type: 'primary' }, t('Choose file to upload')))) : (react.createElement(react.Fragment, null,
                react.createElement(styles_css/* Link */.rU, { name: 'body', size: 'medium', color: Colors/* colors.primary.40 */.O9.primary[40], href: '#', onClick: function (e) {
                        var _a;
                        e.preventDefault();
                        if (!(file === null || file === void 0 ? void 0 : file.id)) {
                            return;
                        }
                        (0,helpers/* downloadAttachFile */.jE)({
                            resumeId: file === null || file === void 0 ? void 0 : file.id,
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            msBaseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            fileName: (_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : ''
                        });
                    }, target: '_blank', isDragging: isDrag },
                    react.createElement(Variant/* Span */.Dr, { name: 'body', size: 'medium', color: Colors/* colors.primary.40 */.O9.primary[40], style: { width: '100%', marginLeft: 4, textAlign: 'unset' } },
                        react.createElement(DocumentsIcon, { style: { marginBottom: -1 } }),
                        " ",
                        react.createElement("span", null, file.name)))))))),
        react.createElement(styles_css/* ResponseMsg */.bU, { variant: 'p', name: 'body', size: boxType === type/* EBoxType.primary */.Y.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() },
            (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.customMsg) ? (react.createElement(react.Fragment, null, contentOptions === null || contentOptions === void 0 ? void 0 :
                contentOptions.customMsg,
                react.createElement("br", null))) : (''),
            message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
        boxType === type/* EBoxType.secondary */.Y.secondary && (file === null || file === void 0 ? void 0 : file.name) ? (react.createElement(styles_css/* ReplaceButton */.CX, { outline: 'outline', size: 'md', type: 'default' }, t('Replace file'))) : null));
};
var DragDropResumeUpload$1 = (0,react.forwardRef)(DragDropResumeUpload);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 42661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ InfoMessage; },
/* harmony export */   "CX": function() { return /* binding */ ReplaceButton; },
/* harmony export */   "Vm": function() { return /* binding */ Placeholder; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "bU": function() { return /* binding */ ResponseMsg; },
/* harmony export */   "rU": function() { return /* binding */ Link; },
/* harmony export */   "v2": function() { return /* binding */ NewUIContainer; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33089);
/* harmony import */ var _type_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65834);
/* harmony import */ var _Typography_components_Variant_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73851);
/* harmony import */ var _Button_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1189);
/* harmony import */ var _Typography_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17739);
'use client';









var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].label */ .ZP.label(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    opacity: ", ";\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: ", ";\n    gap: 10px;\n    border: 1px dashed ", ";\n    border-radius: 12px;\n    background-color: ", ";\n    cursor: pointer;\n    input {\n        display: none;\n        visibility: hidden;\n    }\n    ", "\n"], ["\n    opacity: ", ";\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: ", ";\n    gap: 10px;\n    border: 1px dashed ", ";\n    border-radius: 12px;\n    background-color: ", ";\n    cursor: pointer;\n    input {\n        display: none;\n        visibility: hidden;\n    }\n    ", "\n"])), function (_a) {
    var disable = _a.disable;
    return (!disable ? 1 : 0.5);
}, function (_a) {
    var boxType = _a.boxType;
    return (boxType === _type_js__WEBPACK_IMPORTED_MODULE_2__/* .EBoxType.secondary */ .Y.secondary ? '103px 12px' : '24px 12px');
}, function (_a) {
    var active = _a.active;
    return (!active ? '#b2b8c5' : _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.secondary[40] */ .O9.secondary[40]);
}, function (_a) {
    var active = _a.active, dragDropStyles = _a.dragDropStyles;
    return !active ? dragDropStyles.backgroundColor : 'rgba(255, 153, 0, 0.12)';
}, function (_a) {
    var active = _a.active;
    if (!active) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            > div,\n            > p {\n                pointer-events: none;\n            }\n        "], ["\n            > div,\n            > p {\n                pointer-events: none;\n            }\n        "])));
});
var ResponseMsg = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Typography_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    margin: 4px 0 0 0;\n    text-align: center;\n    pointer-events: none;\n"], ["\n    margin: 4px 0 0 0;\n    text-align: center;\n    pointer-events: none;\n"])));
var Placeholder = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n    padding: 0 15px;\n    text-align: center;\n    flex-direction: ", ";\n\n    svg {\n        pointer-events: none;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n    padding: 0 15px;\n    text-align: center;\n    flex-direction: ", ";\n\n    svg {\n        pointer-events: none;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n    }\n"])), function (_a) {
    var boxType = _a.boxType;
    return (boxType === _type_js__WEBPACK_IMPORTED_MODULE_2__/* .EBoxType.secondary */ .Y.secondary ? '16px' : '5px');
}, function (_a) {
    var boxType = _a.boxType;
    return (boxType === _type_js__WEBPACK_IMPORTED_MODULE_2__/* .EBoxType.secondary */ .Y.secondary ? 'column' : 'row');
});
var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Typography_components_Variant_js__WEBPACK_IMPORTED_MODULE_5__/* .Anchor */ .ee)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: inherit;\n    ", "\n"], ["\n    display: inherit;\n    ", "\n"])), function (_a) {
    var isDragging = _a.isDragging;
    return !isDragging
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  pointer-events: painted !important;\n                  cursor: pointer !important;\n              "], ["\n                  pointer-events: painted !important;\n                  cursor: pointer !important;\n              "]))) : null;
});
var ReplaceButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Button_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    pointer-events: none;\n    margin-top: 8px;\n"], ["\n    pointer-events: none;\n    margin-top: 8px;\n"
    /**
     * NEW UI
     */
])));
/**
 * NEW UI
 */
var NewUIContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(Container)(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    border: 1px dashed ", ";\n"], ["\n    border: 1px dashed ", ";\n"])), function (_a) {
    var active = _a.active;
    return (!active ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primary[40] */ .O9.primary[40] : _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.secondary[40] */ .O9.secondary[40]);
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    border-radius: 12px;\n    background-color: ", ";\n    padding: 9px 11px;\n"], ["\n    border-radius: 12px;\n    background-color: ", ";\n    padding: 9px 11px;\n"])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primary[95] */ .O9.primary[95]);
var InfoMessage = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n    display: flex;\n    justify-content: center;\n"], ["\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n    display: flex;\n    justify-content: center;\n"])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primary[30] */ .O9.primary[30]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


//# sourceMappingURL=styles.css.js.map


/***/ }),

/***/ 65834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ EBoxType; }
/* harmony export */ });
/* unused harmony export EOptionGroupType */
'use client';

var EBoxType;
(function (EBoxType) {
    EBoxType["primary"] = "primary";
    EBoxType["secondary"] = "secondary";
})(EBoxType || (EBoxType = {}));
var EOptionGroupType;
(function (EOptionGroupType) {
    EOptionGroupType["applyForm"] = "apply-popup-form";
    EOptionGroupType["other"] = "other";
})(EOptionGroupType || (EOptionGroupType = {}));


//# sourceMappingURL=type.js.map


/***/ }),

/***/ 83948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/deepEqual.js
var deepEqual = __webpack_require__(17312);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/context.js
'use client';



var GlobalStateContext = (0,react.createContext)({
    globalState: {},
    subscribeField: function () { return function () { return undefined; }; }
});
var useGlobalState = function () { return (0,react.useContext)(GlobalStateContext).globalState; };
function getFieldValue(field, state) {
    var fieldPath = field.split('.');
    var value = state;
    for (var _i = 0, fieldPath_1 = fieldPath; _i < fieldPath_1.length; _i++) {
        var path = fieldPath_1[_i];
        value = value === null || value === void 0 ? void 0 : value[path];
    }
    return value;
}
function useSubscribeField(field) {
    var _a = (0,react.useContext)(GlobalStateContext), globalState = _a.globalState, subscribeField = _a.subscribeField;
    var _b = (0,react.useState)(getFieldValue(field, globalState)), fieldValue = _b[0], setFieldValue = _b[1];
    (0,react.useEffect)(function () {
        var unsubscribe = subscribeField(field, function (props) {
            setFieldValue(props.value);
        });
        return function () {
            unsubscribe();
        };
    }, [field, subscribeField]);
    (0,react.useEffect)(function () {
        setFieldValue(getFieldValue(field, globalState));
    }, [field, globalState]);
    return fieldValue;
}


//# sourceMappingURL=context.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/formErrorsControl.js
'use client';



function formErrorsControl(_a) {
    var fieldName = _a.fieldName, formValues = _a.formValues, errorMsg = _a.errorMsg, requestScrollToFirstErrorElement = _a.requestScrollToFirstErrorElement;
    var formErrors = formValues.errors;
    if (formErrors[fieldName] !== undefined && errorMsg === '') {
        delete formErrors[fieldName];
        return;
    }
    if (errorMsg !== '') {
        formErrors[fieldName] = errorMsg;
        if (requestScrollToFirstErrorElement) {
            formValues.errorFields = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], formValues.errorFields, true), [fieldName], false);
            formValues.isScrollToFirstErrorElement = true;
        }
    }
}


//# sourceMappingURL=formErrorsControl.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/unproxify.js
'use client';

function unproxify(values) {
    if (values instanceof Date)
        return values;
    if (typeof window !== 'undefined' && values instanceof File)
        return values;
    if (values instanceof Array)
        return values.map(unproxify);
    if (values instanceof Object)
        return Object.fromEntries(Object.entries(Object.assign({}, values)).map(function (_a) {
            var key = _a[0], value = _a[1];
            return [key, unproxify(value)];
        }));
    return values;
}


//# sourceMappingURL=unproxify.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/validators.js + 1 modules
var validators = __webpack_require__(90488);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/getFieldValidatedMessage.js
'use client';




/*
 * Validate form value by user's rule
 * @param: {
 *    fieldValue: value of target field
 *    fieldRules: rules of target field
 *    isEnable: enable validate or not
 * }
 * @return {
 *    message: error message after validated
 * }
 * */
function getFieldValidatedMessage(_a) {
    var fieldValue = _a.fieldValue, fieldRules = _a.fieldRules, fieldWatch = _a.fieldWatch, isEnable = _a.isEnable;
    if (!isEnable) {
        return '';
    }
    var message = '';
    /*
     * Use the [].every trick to break when has the error message
     * so that, we must return false if has any error, otherwise return true to continue
     * */
    fieldRules.every(function (rule) {
        switch (rule.type) {
            case 'required': {
                var valid = validators/* default.required */.Z.required(fieldValue);
                if (!valid) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'email': {
                if (fieldValue && !validators/* default.validateEmail */.Z.validateEmail(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'number': {
                if (fieldValue && !validators/* default.validateNumber */.Z.validateNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-number-email': {
                if (fieldValue && validators/* default.validateNoNumberAndEmail */.Z.validateNoNumberAndEmail(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'url': {
                if (fieldValue && !validators/* default.validateUrl */.Z.validateUrl(fieldValue)) {
                    message = rule.msg;
                }
                return true;
            }
            case 'no-special-chars': {
                if (fieldValue && validators/* default.validateNoSpecialChars */.Z.validateNoSpecialChars(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-special-chars-without-number': {
                if (fieldValue && validators/* default.validateNoSpecialCharsWithoutNumber */.Z.validateNoSpecialCharsWithoutNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'international-phone-number': {
                if (fieldValue &&
                    !fieldValue.includes('+84') &&
                    !validators/* default.validateI11lPhoneNumber */.Z.validateI11lPhoneNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'vn-phone-number': {
                if (fieldValue &&
                    fieldValue.includes('+84') &&
                    !validators/* default.validateVietNamPhoneNumber */.Z.validateVietNamPhoneNumber(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'no-special-chars-for-job-title': {
                if (fieldValue && validators/* default.validateNoSpecialCharsForJobTitle */.Z.validateNoSpecialCharsForJobTitle(fieldValue)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            case 'custom': {
                var convertedFieldWatch = unproxify(fieldWatch);
                var convertedFieldValue = unproxify(fieldValue);
                if (typeof rule.validator === 'function' && !rule.validator(convertedFieldValue, convertedFieldWatch)) {
                    message = rule.msg;
                    return false;
                }
                return true;
            }
            default:
                return true;
        }
    });
    return message;
}


//# sourceMappingURL=getFieldValidatedMessage.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/validateOnSubmit.js
'use client';




/*
 * Validate all fields when user submit
 * @param: {
 *    formValues: global values of form
 * }
 * */
function validateOnSubmit(formValues, requestScrollToFirstErrorElement) {
    var formRules = formValues.formRules;
    var values = formValues.values;
    var errors = formValues.errors;
    var watch = formValues.watchValues;
    // Set submit state
    formValues.isSubmited = true;
    Object.keys(formRules).map(function (key) {
        var errorMsg = getFieldValidatedMessage({
            fieldValue: values[key],
            fieldRules: formRules[key],
            fieldWatch: watch[key],
            isEnable: true
        });
        formErrorsControl({
            fieldName: key,
            formValues: formValues,
            errorMsg: errorMsg,
            requestScrollToFirstErrorElement: requestScrollToFirstErrorElement
        });
    });
    return Object.keys(errors).length > 0;
}


//# sourceMappingURL=validateOnSubmit.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/HTMLForm.js
'use client';







var HTMLForm = (0,react.forwardRef)(function (_a, ref) {
    var children = _a.children, requestScrollToFirstErrorElement = _a.requestScrollToFirstErrorElement;
    var globalState = useGlobalState();
    var formRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function () { return ({
        dispatchEvent: function (event) {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
        },
        requestSubmit: function (submitter) {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.requestSubmit(submitter);
        },
        requestGetCurrentValues: function () {
            var values = unproxify(globalState.values);
            globalState.getCurrentValues && globalState.getCurrentValues(values);
        }
    }); });
    var handleSubmit = function (e) {
        e.preventDefault();
        var containErrors = validateOnSubmit(globalState, requestScrollToFirstErrorElement);
        if (containErrors) {
            globalState.onSubmitError &&
                globalState.onSubmitError({
                    currentValues: unproxify(globalState.values),
                    errors: unproxify(globalState.errors)
                });
            return;
        }
        /**
         *   formState:state, error
         *
         */
        /*
         * Deep clone values
         * */
        var convertedFormValues = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, unproxify(globalState.values)), { initialSubmitValues: (0,_tslib/* __assign */.pi)({}, unproxify(globalState.initialSubmitValues || {})) });
        globalState.onSubmit(convertedFormValues);
    };
    return (react.createElement("form", { ref: formRef, onSubmit: handleSubmit }, children));
});


//# sourceMappingURL=HTMLForm.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/setFormFieldValue.js
'use client';





function setFormFieldValue(_a) {
    var formState = _a.formState, field = _a.field, value = _a.value, rules = _a.rules;
    formState.values[field] = value;
    /*
     * Add value to watch field
     * */
    var watchFields = formState.watch;
    if (Object.keys(watchFields).length > 0) {
        Object.keys(watchFields).forEach(function (key) {
            var _a;
            if (watchFields[key].includes(field)) {
                formState.watchValues[key] = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, formState.watchValues[key]), (_a = {}, _a[field] = value, _a));
            }
        });
    }
    var isFieldTouched = formState.touched.includes(field);
    var isEnableValidate = formState.isSubmited || isFieldTouched;
    /*
     * Validate field onChange
     * */
    if (rules !== undefined) {
        var watchValueFields = formState.watchValues[field];
        var errorMsg = getFieldValidatedMessage({
            fieldValue: value,
            fieldRules: rules,
            fieldWatch: watchValueFields,
            isEnable: isEnableValidate
        });
        formErrorsControl({
            fieldName: field,
            formValues: formState,
            errorMsg: errorMsg,
            requestScrollToFirstErrorElement: false
        });
    }
}


//# sourceMappingURL=setFormFieldValue.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/getScrollableParent.js
'use client';

function isDocumentElement(element) {
    return element === document.documentElement || element instanceof Document;
}
function isBodyElement(element) {
    return element === document.body;
}
function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}
function isAbsolutePositioning(element) {
    var position = window.getComputedStyle(element).position;
    return position === 'absolute';
}
function getScrollableParent(element) {
    if (isDocumentElement(element) || isBodyElement(element)) {
        return window;
    }
    var computedStyle = window.getComputedStyle(element);
    if (isOverflowSet(computedStyle.overflow) ||
        isOverflowSet(computedStyle.overflowX) ||
        isOverflowSet(computedStyle.overflowY)) {
        if (!isAbsolutePositioning(element)) {
            return element;
        }
    }
    if (element.parentNode) {
        return getScrollableParent(element.parentNode);
    }
    return window;
}


//# sourceMappingURL=getScrollableParent.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/Item/context.js
'use client';



var FormItemContext = (0,react.createContext)({
    rules: [],
    errorMsg: ''
});
function useFormItemContext() {
    return (0,react.useContext)(FormItemContext);
}


//# sourceMappingURL=context.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/Item/index.js
'use client';











var FormItem = function (_a) {
    var children = _a.children, name = _a.name, rules = _a.rules, watch = _a.watch;
    // Get value
    var watchValue = useSubscribeField("values.".concat(name));
    var watchError = useSubscribeField("errors.".concat(name));
    var watchErrorFields = useSubscribeField('errorFields');
    var isScrollToFirstErrorElement = useSubscribeField('isScrollToFirstErrorElement');
    var watchFieldValue = useSubscribeField("watchValues.".concat(name));
    var globalValues = useSubscribeField('values');
    // Set value
    var formState = useGlobalState();
    var fieldRules = formState.formRules[name];
    (0,react.useEffect)(function () {
        /*
         * Set rules to global state
         * */
        if (!Object.keys(formState.formRules).includes(name) && rules !== undefined) {
            formState.formRules[name] = rules;
        }
        /*
         * Set watch field and value to global state
         * */
        if (watch && watch.length > 0) {
            var watchValues_1 = {};
            formState.watch[name] = watch;
            watch.forEach(function (key) {
                var _a;
                return Object.assign(watchValues_1, (_a = {}, _a[key] = globalValues[key], _a));
            });
            formState.watchValues[name] = watchValues_1;
        }
    }, [watch, name, rules, globalValues]);
    /*
     * Scroll to error action
     * */
    var itemRef = (0,react.useRef)(null);
    var setItemRef = (0,react.useCallback)(function (node) {
        if (itemRef.current !== node) {
            itemRef.current = node;
        }
    }, []);
    (0,react.useEffect)(function () {
        var firstErrorField = watchErrorFields[0];
        if (isScrollToFirstErrorElement && firstErrorField && firstErrorField === name) {
            if (itemRef.current) {
                var scrollableElement = getScrollableParent(itemRef.current);
                var scrollableElementTop = scrollableElement instanceof Window ? 0 : scrollableElement.getBoundingClientRect().top;
                var itemTop = itemRef.current.offsetTop;
                if (firstErrorField === name) {
                    /*
                     * Only scroll to first error if element is off screen
                     * */
                    scrollableElement.scrollTo({
                        top: itemTop - scrollableElementTop,
                        behavior: 'smooth'
                    });
                }
                formState.isScrollToFirstErrorElement = false;
                formState.errorFields = [];
            }
        }
        return function () { return undefined; };
    }, [watchErrorFields, isScrollToFirstErrorElement, name]);
    /*
     * Handle field action
     * */
    var handleTouchedField = function () {
        /*
         * Validate field onBlur
         * */
        if (fieldRules !== undefined) {
            var watchValueFields = formState.watchValues[name];
            var fieldValue = formState.values[name];
            var errorMsg = getFieldValidatedMessage({
                fieldValue: fieldValue,
                fieldRules: fieldRules,
                fieldWatch: watchValueFields,
                isEnable: true
            });
            formErrorsControl({
                fieldName: name,
                formValues: formState,
                errorMsg: errorMsg,
                requestScrollToFirstErrorElement: false
            });
        }
        if (formState.touched.includes(name)) {
            return;
        }
        formState.touched = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], formState.touched, true), [name], false);
    };
    var handleChangeField = function (value) {
        setFormFieldValue({
            formState: formState,
            field: name,
            value: value,
            rules: fieldRules
        });
    };
    var setFieldValue = function (field, value) {
        setFormFieldValue({
            formState: formState,
            field: field,
            value: value
        });
    };
    return (react.createElement(FormItemContext.Provider, { value: {
            rules: fieldRules || [],
            errorMsg: watchError || ''
        } },
        isScrollToFirstErrorElement ? react.createElement("div", { ref: setItemRef, id: name }) : null,
        children({
            value: unproxify(watchValue),
            onChange: handleChangeField,
            onBlur: handleTouchedField,
            error: watchError,
            isError: watchError !== undefined && watchError !== '',
            watch: unproxify(watchFieldValue),
            setFieldValue: setFieldValue,
            setItemRef: setItemRef
        })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/FormProvider.js
'use client';





function FormProvider(_a) {
    var initialState = _a.initialState, children = _a.children;
    var subscribers = new Map();
    function subscribeField(field, callback) {
        var fieldSubscribers = subscribers.get(field) || [];
        subscribers.set(field, (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], fieldSubscribers, true), [callback], false));
        return function () {
            var updatedSubscribers = fieldSubscribers.filter(function (subscriber) {
                return subscriber !== callback;
            });
            subscribers.set(field, updatedSubscribers);
        };
    }
    var notifySubscribers = function (field, value) {
        var fieldSubscribers = subscribers.get(field) || [];
        fieldSubscribers.forEach(function (subscriber) {
            subscriber({ field: field, value: value });
        });
    };
    var createNestedProxy = function (state, path) {
        if (path === void 0) { path = []; }
        var proxyHandler = {
            get: function (target, prop) {
                var newPath = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], path, true), [prop.toString()], false); // Create new path
                if (typeof window !== 'undefined' && target[prop] instanceof File) {
                    return target[prop];
                }
                if (target[prop] instanceof Date) {
                    return target[prop];
                }
                if (target[prop] instanceof Array) {
                    return target[prop].map(function (value) {
                        if (typeof window !== 'undefined' && target[prop] instanceof File) {
                            return value;
                        }
                        if (value instanceof Date) {
                            return value;
                        }
                        if (value instanceof Object) {
                            return createNestedProxy(value, newPath);
                        }
                        return value;
                    });
                }
                if (target[prop] instanceof Object && target[prop] !== null) {
                    return createNestedProxy(target[prop], newPath);
                }
                return target[prop];
            },
            set: function (target, prop, value) {
                var fullPath = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], path, true), [prop.toString()], false);
                target[prop] = value;
                notifySubscribers(fullPath.join('.'), value);
                return true;
            },
            deleteProperty: function (target, prop) {
                var fullPath = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], path, true), [prop.toString()], false);
                if (prop in target) {
                    delete target[prop];
                }
                notifySubscribers(fullPath.join('.'), undefined);
                return true;
            }
        };
        return new Proxy(state, proxyHandler);
    };
    var globalState = createNestedProxy(initialState);
    var globalStateContextValue = {
        globalState: globalState,
        subscribeField: subscribeField
    };
    return react.createElement(GlobalStateContext.Provider, { value: globalStateContextValue }, children);
}


//# sourceMappingURL=FormProvider.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/Label.js
'use client';








var Label = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    margin-bottom: 6px;\n    ", "\n"], ["\n    display: inline-block;\n    margin-bottom: 6px;\n    ", "\n"])), function (_a) {
    var requiredPosition = _a.requiredPosition, isRequired = _a.isRequired;
    return isRequired
        ? requiredPosition === 'left'
            ? "\n    &::before {\n        content: '*';\n        color: ".concat(Colors/* colors.error.40 */.O9.error[40], ";\n        margin-right: 4px;\n    }\n    ")
            : "\n    &::after {\n        content: '*';\n        color: ".concat(Colors/* colors.error.40 */.O9.error[40], ";\n        margin-left: 4px;\n    }\n    ")
        : '';
});
var FormLabel = function (props) {
    var children = props.children, _a = props.requiredPosition, requiredPosition = _a === void 0 ? 'left' : _a, require = props.require;
    var rules = useFormItemContext().rules;
    var isRequired = rules.some(function (rule) { return rule.type === 'required'; });
    if (typeof require !== 'undefined') {
        isRequired = require;
    }
    return (react.createElement(Label, { variant: 'label', name: 'label', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], isRequired: isRequired, requiredPosition: requiredPosition }, children));
};
var templateObject_1;


//# sourceMappingURL=Label.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/constant.js
'use client';

var HIDDEN_MSG = '_HIDDEN_';


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/component/Error.js
'use client';








var ErrorMsg = styled_components_browser_esm/* default.p */.ZP.p(Error_templateObject_1 || (Error_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 12px;\n    color: ", ";\n    margin-top: 4px;\n"], ["\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 12px;\n    color: ", ";\n    margin-top: 4px;\n"])), constants/* colors.dangerColor */.O9.dangerColor);
function FormError(_a) {
    var disable = _a.disable, forceMsg = _a.forceMsg;
    var errorMsg = useFormItemContext().errorMsg;
    if (forceMsg && forceMsg !== '') {
        return react.createElement(ErrorMsg, null, forceMsg);
    }
    return !disable && errorMsg !== '' && errorMsg !== HIDDEN_MSG ? react.createElement(ErrorMsg, null, errorMsg) : null;
}
var Error_templateObject_1;


//# sourceMappingURL=Error.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/constants.js
'use client';

var errorMsgs = function (translate) {
    if (translate) {
        return {
            required: translate('This field is required.'),
            email: translate('This is not a valid email address.'),
            number: '',
            'no-number-email': translate('Please do not enter phone number or email.'),
            url: translate('This is not a valid URL.'),
            'no-special-chars': translate('Please do not enter numbers or special characters.'),
            'no-special-chars-without-number': translate('Please do not enter special characters.'),
            'vn-phone-number': translate('The phone number format is invalid.'),
            'international-phone-number': translate('The phone number format is invalid.'),
            'no-special-chars-for-job-title': translate('Please do not enter special characters.')
        };
    }
    return {
        required: 'This field is required.',
        email: 'This is not a valid email address.',
        number: '',
        'no-number-email': 'Please do not enter phone number or email.',
        url: 'This is not a valid URL.',
        'no-special-chars': 'Please do not enter numbers or special characters.',
        'no-special-chars-without-number': 'Please do not enter special characters.',
        'vn-phone-number': 'The phone number format is invalid.',
        'international-phone-number': 'The phone number format is invalid.',
        'no-special-chars-for-job-title': 'Please do not enter special characters.'
    };
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/base.js
'use client';



var Base = /** @class */ (function () {
    function Base(translate) {
        this.rules = [];
        this.translate = translate;
    }
    Base.prototype.require = function (msg) {
        this.rules.push({
            type: 'required',
            msg: msg || errorMsgs(this.translate).required
        });
        return this;
    };
    Base.prototype.custom = function (validator, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: validator
        });
        return this;
    };
    Base.prototype.generate = function () {
        return this.rules;
    };
    return Base;
}());


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/string.js
'use client';





var StringValidator = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(StringValidator, _super);
    function StringValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringValidator.prototype.email = function (msg) {
        this.rules.push({
            type: 'email',
            msg: msg || errorMsgs(this.translate).email
        });
        return this;
    };
    StringValidator.prototype.url = function (msg) {
        this.rules.push({
            type: 'url',
            msg: msg || errorMsgs(this.translate).url
        });
        return this;
    };
    StringValidator.prototype.noNumberAndEmail = function (msg) {
        this.rules.push({
            type: 'no-number-email',
            msg: msg || errorMsgs(this.translate)['no-number-email']
        });
        return this;
    };
    StringValidator.prototype.noSpecialChars = function (msg) {
        this.rules.push({
            type: 'no-special-chars',
            msg: msg || errorMsgs(this.translate)['no-special-chars']
        });
        return this;
    };
    StringValidator.prototype.noSpecialCharsWithoutNumber = function (msg) {
        this.rules.push({
            type: 'no-special-chars-without-number',
            msg: msg || errorMsgs(this.translate)['no-special-chars-without-number']
        });
        return this;
    };
    StringValidator.prototype.vnPhoneNumber = function (msg) {
        this.rules.push({
            type: 'vn-phone-number',
            msg: msg || errorMsgs(this.translate)['vn-phone-number']
        });
        return this;
    };
    StringValidator.prototype.internationalPhoneNumber = function (msg) {
        this.rules.push({
            type: 'international-phone-number',
            msg: msg || errorMsgs(this.translate)['international-phone-number']
        });
        return this;
    };
    StringValidator.prototype.noSpecialCharsForJobTitle = function (msg) {
        this.rules.push({
            type: 'no-special-chars-for-job-title',
            msg: msg || errorMsgs(this.translate)['no-special-chars-for-job-title']
        });
        return this;
    };
    StringValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length > limit;
                }
                return false;
            }
        });
        return this;
    };
    StringValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length < limit;
                }
                return false;
            }
        });
        return this;
    };
    StringValidator.prototype.length = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length <= limit;
                }
                return false;
            }
        });
        return this;
    };
    return StringValidator;
}(Base));


//# sourceMappingURL=string.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/number.js
'use client';





var NumberValidator = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(NumberValidator, _super);
    function NumberValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberValidator.prototype.isNumber = function (msg) {
        this.rules.push({
            type: 'number',
            msg: msg || errorMsgs(this.translate).number
        });
        return this;
    };
    NumberValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'number') {
                    return value >= limit;
                }
                return false;
            }
        });
        return this;
    };
    NumberValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'number') {
                    return value <= limit;
                }
                return false;
            }
        });
        return this;
    };
    NumberValidator.prototype.lessThan = function (max, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'number') {
                    return value > max;
                }
                return false;
            }
        });
        return this;
    };
    NumberValidator.prototype.moreThan = function (min, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'number') {
                    return value < min;
                }
                return false;
            }
        });
        return this;
    };
    return NumberValidator;
}(Base));


//# sourceMappingURL=number.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/date.js
'use client';




var DateValidator = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(DateValidator, _super);
    function DateValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (value instanceof Date) {
                    return value.getTime() > limit.getTime();
                }
                return false;
            }
        });
        return this;
    };
    DateValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (value instanceof Date) {
                    return value.getTime() < limit.getTime();
                }
                return false;
            }
        });
        return this;
    };
    return DateValidator;
}(Base));


//# sourceMappingURL=date.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/array.js
'use client';




var ArrayValidator = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(ArrayValidator, _super);
    function ArrayValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrayValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length > limit;
                }
                return false;
            }
        });
        return this;
    };
    ArrayValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length < limit;
                }
                return false;
            }
        });
        return this;
    };
    ArrayValidator.prototype.length = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length <= limit;
                }
                return false;
            }
        });
        return this;
    };
    return ArrayValidator;
}(Base));


//# sourceMappingURL=array.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/validator/index.js
'use client';






function validation(translate) {
    return {
        string: function () { return new StringValidator(translate); },
        number: function () { return new NumberValidator(translate); },
        date: function () { return new DateValidator(translate); },
        array: function () { return new ArrayValidator(translate); }
    };
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/index.js
'use client';











var Form = (0,react.forwardRef)(function (_a, ref) {
    var initialValues = _a.initialValues, initialSubmitValues = _a.initialSubmitValues, onSubmit = _a.onSubmit, onSubmitError = _a.onSubmitError, getCurrentValues = _a.getCurrentValues, _b = _a.requestScrollToFirstErrorElement, requestScrollToFirstErrorElement = _b === void 0 ? false : _b, validation = _a.validation, children = _a.children;
    var values = (0,_tslib/* __assign */.pi)({}, initialValues);
    var formRules = validation ? (0,_tslib/* __assign */.pi)({}, validation) : {};
    var _c = (0,react.useState)({
        values: values,
        errors: {},
        errorFields: [],
        touched: [],
        formRules: formRules,
        watch: {},
        watchValues: {},
        isSubmited: false,
        isScrollToFirstErrorElement: false,
        onSubmit: onSubmit,
        onSubmitError: onSubmitError,
        getCurrentValues: getCurrentValues,
        initialSubmitValues: initialSubmitValues
    }), formValues = _c[0], setFormValues = _c[1];
    var formValuesRef = (0,react.useRef)();
    var initialSubmitValuesRef = (0,react.useRef)();
    (0,react.useEffect)(function () {
        if (!(0,deepEqual/* default */.Z)(formValuesRef.current, initialValues)) {
            /*
             * Only set values again if initial values has any changes
             * */
            formValuesRef.current = initialValues;
            setFormValues(function (prevFormValues) {
                var values = (0,_tslib/* __assign */.pi)({}, initialValues);
                return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, prevFormValues), { values: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, prevFormValues.initialSubmitValues), values) });
            });
        }
    }, [initialValues]);
    (0,react.useEffect)(function () {
        if (!(0,deepEqual/* default */.Z)(initialSubmitValuesRef.current, initialSubmitValues)) {
            /*
             * Only set values again if initial submit values has any changes
             * */
            initialSubmitValuesRef.current = initialSubmitValues;
            setFormValues(function (prevFormValues) {
                var values = (0,_tslib/* __assign */.pi)({}, initialSubmitValues);
                return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, prevFormValues), { initialSubmitValues: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, prevFormValues.initialSubmitValues), values) });
            });
        }
    }, [initialSubmitValues]);
    return (react.createElement(FormProvider, { initialState: formValues },
        react.createElement(HTMLForm, { requestScrollToFirstErrorElement: requestScrollToFirstErrorElement, ref: ref }, children)));
});
Form.Item = FormItem;
Form.Label = FormLabel;
Form.Error = FormError;
Form.validator = validation;


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepEqual; }
/* harmony export */ });
'use client';

/*
 * Forked of https://github.com/epoberezkin/fast-deep-equal
 * */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) {
            return false;
        }
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!{}.hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
}


//# sourceMappingURL=deepEqual.js.map


/***/ }),

/***/ 90488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ validateFunctions; }
});

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/isProxyDate.js
'use client';

function isProxyDate(value) {
    var _a = Proxy.revocable(new Date(), {}), proxy = _a.proxy, revoke = _a.revoke;
    var isProxy = value instanceof proxy.constructor;
    revoke();
    return isProxy;
}


//# sourceMappingURL=isProxyDate.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/validators.js
'use client';



var validateEmail = function (email) {
    var regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
    return regExp.test(String(email).toLowerCase());
};
var validateUrl = function (text) {
    var url;
    try {
        url = new URL(text);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
var validateNoSpecialChars = function (text) {
    var NO_SPECIAL_CHARS = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateNoSpecialCharsWithoutNumber = function (text) {
    var NO_SPECIAL_CHARS = /[#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateVietNamPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
    return VN_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateI11lPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var I11L_PHONE_NUMBER_REGEX = /^\d[0-9 ]{6,14}$/;
    return I11L_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateNumber = function (value) {
    var regex = /^\d+$/;
    return regex.test(value);
};
var validateNoSpecialCharsForJobTitle = function (text) {
    var NO_SPECIAL_CHARS = /[@!$%^*()_|~=`{}\[\]:";'<>?,]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateNoNumberAndEmail = function (text) {
    var NO_NUMBER_EMAIL = /^[^\d]*$/gm;
    return !NO_NUMBER_EMAIL.test(text);
};
var required = function (fieldValue) {
    if (!fieldValue) {
        return false;
    }
    if (Array.isArray(fieldValue) && fieldValue.length === 0) {
        return false;
    }
    if (typeof fieldValue === 'object' &&
        Object.keys(fieldValue).length === 0 &&
        !isProxyDate(fieldValue)) {
        return false;
    }
    var clonedFieldValue = fieldValue;
    if (typeof clonedFieldValue === 'string') {
        clonedFieldValue = clonedFieldValue.trim();
    }
    if (!clonedFieldValue) {
        return false;
    }
    return true;
};
var compareValue = function (value, compareValue) {
    return value >= compareValue;
};
var validateFunctions = {
    validateEmail: validateEmail,
    validateNumber: validateNumber,
    validateUrl: validateUrl,
    validateI11lPhoneNumber: validateI11lPhoneNumber,
    validateVietNamPhoneNumber: validateVietNamPhoneNumber,
    validateNoSpecialChars: validateNoSpecialChars,
    validateNoSpecialCharsWithoutNumber: validateNoSpecialCharsWithoutNumber,
    validateNoSpecialCharsForJobTitle: validateNoSpecialCharsForJobTitle,
    validateNoNumberAndEmail: validateNoNumberAndEmail,
    required: required,
    compareValue: compareValue
};


//# sourceMappingURL=validators.js.map


/***/ }),

/***/ 7217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var NextArrowIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.onClick, onClick = _c === void 0 ? function () { } : _c, _d = props.style, style = _d === void 0 ? {} : _d, _e = props.color, color = _e === void 0 ? '#888' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, style: style, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: function () { return onClick && onClick(); } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10.0799 1.43994C5.56867 1.43994 1.91992 5.08869 1.91992 9.59994C1.91992 14.1112 5.56867 17.7599 10.0799 17.7599C11.6905 17.7599 13.1812 17.2874 14.4449 16.4849L20.3399 22.3799L22.3799 20.3399L16.5599 14.5349C17.6062 13.1624 18.2399 11.4618 18.2399 9.59994C18.2399 5.08869 14.5912 1.43994 10.0799 1.43994ZM10.0799 3.35994C13.5355 3.35994 16.3199 6.14432 16.3199 9.59994C16.3199 13.0556 13.5355 15.8399 10.0799 15.8399C6.6243 15.8399 3.83992 13.0556 3.83992 9.59994C3.83992 6.14432 6.6243 3.35994 10.0799 3.35994Z', fill: color })));
};
var SearchIcon = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(NextArrowIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 12578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlyphIcons; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/BackArrowIcon/index.js
'use client';



var BackArrowIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.onClick, onClick = _c === void 0 ? function () { } : _c, _d = props.style, style = _d === void 0 ? {} : _d, _e = props.color, color = _e === void 0 ? '#888' : _e;
    return (react.createElement("svg", { width: width, height: height, style: style, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: function () { return onClick && onClick(); } },
        react.createElement("path", { d: 'M16.0639 3.00036C15.8516 3.00668 15.65 3.09542 15.502 3.24777L7.32913 11.4204C7.17591 11.5737 7.08984 11.7815 7.08984 11.9982C7.08984 12.215 7.17591 12.4228 7.32913 12.5761L15.502 20.7487C15.5773 20.8272 15.6675 20.8898 15.7673 20.9329C15.8671 20.9761 15.9746 20.9988 16.0833 21C16.192 21.0011 16.2999 20.9805 16.4006 20.9394C16.5012 20.8983 16.5927 20.8375 16.6696 20.7606C16.7465 20.6837 16.8072 20.5923 16.8483 20.4916C16.8894 20.3909 16.91 20.2831 16.9089 20.1743C16.9078 20.0656 16.885 19.9582 16.8419 19.8584C16.7988 19.7586 16.7361 19.6684 16.6577 19.5931L9.06267 11.9982L16.6577 4.40343C16.7758 4.28864 16.8565 4.14084 16.8891 3.97942C16.9218 3.81799 16.9049 3.65046 16.8407 3.49879C16.7765 3.34712 16.668 3.21838 16.5294 3.12943C16.3908 3.04049 16.2285 2.9955 16.0639 3.00036Z', fill: color })));
};
var BackArrowIcon$1 = /*#__PURE__*/ react.memo(BackArrowIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/NextArrowIcon/index.js
'use client';



var NextArrowIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.onClick, onClick = _c === void 0 ? function () { } : _c, _d = props.style, style = _d === void 0 ? {} : _d, _e = props.color, color = _e === void 0 ? '#888' : _e;
    return (react.createElement("svg", { width: width, height: height, style: style, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: function () { return onClick && onClick(); } },
        react.createElement("path", { d: 'M7.91099 3C7.74841 3.00004 7.58953 3.04857 7.45467 3.13938C7.31981 3.23019 7.21509 3.35916 7.15392 3.5098C7.09274 3.66043 7.07787 3.82589 7.11122 3.98501C7.14457 4.14414 7.22461 4.28971 7.34113 4.40311L14.9362 11.9981L7.34113 19.593C7.26269 19.6683 7.20007 19.7585 7.15692 19.8584C7.11378 19.9582 7.09099 20.0656 7.08989 20.1743C7.08878 20.2831 7.10938 20.3909 7.15048 20.4916C7.19158 20.5923 7.25236 20.6837 7.32925 20.7606C7.40614 20.8375 7.49759 20.8983 7.59827 20.9394C7.69894 20.9805 7.8068 21.0011 7.91553 21C8.02426 20.9989 8.13168 20.9761 8.2315 20.9329C8.33131 20.8898 8.42151 20.8272 8.49682 20.7487L16.6697 12.5759C16.8229 12.4226 16.909 12.2148 16.909 11.9981C16.909 11.7814 16.8229 11.5735 16.6697 11.4202L8.49682 3.24742C8.42066 3.16913 8.32958 3.1069 8.22896 3.0644C8.12834 3.0219 8.02022 3.00001 7.91099 3Z', fill: color })));
};
var NextArrowIcon$1 = /*#__PURE__*/ react.memo(NextArrowIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/SearchIcon/index.js
var SearchIcon = __webpack_require__(7217);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/GlyphIcons/index.js
'use client';





var GlyphIcons = {
    BackArrowIcon: BackArrowIcon$1,
    NextArrowIcon: NextArrowIcon$1,
    SearchIcon: SearchIcon/* default */.Z
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 95300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ I11lPhoneNumberInput; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/index.js + 9 modules
var MultipleRadio = __webpack_require__(49336);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/I11lPhoneNumberInput/I11lPhoneNumberInput.css.js
'use client';







var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ErrorMsg = styled_components_browser_esm/* default.p */.ZP.p(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    color: ", ";\n    margin: 4px 0 0 0;\n"], ["\n    font-size: 12px;\n    color: ", ";\n    margin: 4px 0 0 0;\n"])), constants/* colors.borderError */.O9.borderError);
var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n    align-items: center;\n\n    &.error {\n        .i11l-input {\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n            &:focus {\n                border-color: ", ";\n            }\n        }\n    }\n"], ["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n    align-items: center;\n\n    &.error {\n        .i11l-input {\n            border-color: ", ";\n            &:hover {\n                border-color: ", ";\n            }\n            &:focus {\n                border-color: ", ";\n            }\n        }\n    }\n"])), constants/* colors.borderError */.O9.borderError, constants/* colors.borderError */.O9.borderError, constants/* colors.borderError */.O9.borderError);
var Flag = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n    background: url(", ");\n    background-position: ", "px 0;\n"], ["\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n    background: url(", ");\n    background-position: ", "px 0;\n"])), function (_a) {
    var url = _a.url;
    return url;
}, function (_a) {
    var x = _a.x;
    return x;
});
var CustomValue = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n"], ["\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n"])));
var CustomOptionItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex: 1;\n    padding: 8px 0;\n"], ["\n    display: flex;\n    align-items: center;\n    flex: 1;\n    padding: 8px 0;\n"])));
var Text = styled_components_browser_esm/* default.span */.ZP.span(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    &.i11l-value {\n        line-height: 24px;\n        ", ";\n    }\n"], ["\n    &.i11l-value {\n        line-height: 24px;\n        ", ";\n    }\n"])), function (_a) {
    var active = _a.active;
    return active
        ? "\n      color: ".concat(constants/* colors.textColor */.O9.textColor, ";\n      font-weight: 500;\n    ")
        : "\n      color: ".concat("".concat(constants/* colors.textColor */.O9.textColor, "66"), ";\n      font-weight: 400\n    ");
});
var InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Input = styled_components_browser_esm/* default.input */.ZP.input(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 6px;\n    outline: none;\n    box-shadow: none;\n    border: 1px solid ", ";\n    padding: 9px 8px;\n    font-size: 14px;\n    line-height: 20px;\n    width: 100%;\n    &::placeholder {\n        color: ", ";\n        font-size: 14px;\n    }\n    &:hover {\n        border-color: ", ";\n    }\n    &:focus {\n        border-color: ", ";\n    }\n"], ["\n    border-radius: 6px;\n    outline: none;\n    box-shadow: none;\n    border: 1px solid ", ";\n    padding: 9px 8px;\n    font-size: 14px;\n    line-height: 20px;\n    width: 100%;\n    &::placeholder {\n        color: ", ";\n        font-size: 14px;\n    }\n    &:hover {\n        border-color: ", ";\n    }\n    &:focus {\n        border-color: ", ";\n    }\n"])), constants/* colors.borderNormal */.O9.borderNormal, Colors/* colors.grey.50 */.O9.grey[50], constants/* colors.borderHover */.O9.borderHover, constants/* colors.borderFocus */.O9.borderFocus);
var LabelWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"])));
var TextDanger = styled_components_browser_esm/* default.span */.ZP.span(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), constants/* colors.dangerColor */.O9.dangerColor);
var RemoveIcon = (0,styled_components_browser_esm/* default */.ZP)(RemoveFillIcon/* default */.Z)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    transform: translateY(-50%);\n    opacity: 0.5;\n    cursor: pointer;\n    transition: all 0.3s;\n    &.hidden {\n        opacity: 0;\n    }\n"], ["\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    transform: translateY(-50%);\n    opacity: 0.5;\n    cursor: pointer;\n    transition: all 0.3s;\n    &.hidden {\n        opacity: 0;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


//# sourceMappingURL=I11lPhoneNumberInput.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/I11lPhoneNumberInput/vi.json.js
'use client';

var vi = {
	"Type country name or code": "Nhập tên hoặc mã quốc tế",
	"This field is required.": "Vui lòng nhập thông tin.",
	"The phone number format is invalid.": "Số điện thoại của bạn không hợp lệ.",
	"Accept 7 - 15 digits.": "Chấp nhận 7 - 15 chữ số.",
	"No result found": "Không có kết quả"
};


//# sourceMappingURL=vi.json.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/I11lPhoneNumberInput/helpers.js
'use client';




var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
var I11L_LIMIT_NUMBER = /^[0-9]{15}/;
var I11L_PHONE_NUMBER_REGEX = /^\d[0-9]{6,14}$/;
var VN_DIALCODE = '+84';
var IMG_URL = 'https://images.vietnamworks.com/images/icons';
var t = function (text, language) {
    if (language === constants/* ELanguage.EN */.Df.EN)
        return text;
    return vi[text];
};
/**
 * @Note place this function into onKeyPress Input, which you want to force it enter only number
 * */
var exceptKeys = new Set(['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Tab']);
var enterOnlyNumber = function (event) {
    var key = event.key;
    if (exceptKeys.has(key))
        return;
    if (!/[0-9]/.test(key)) {
        event.preventDefault();
    }
};
var validateVietNamPhoneNumber = function (value) {
    return VN_PHONE_NUMBER_REGEX.test(value);
};
var validateI11lPhoneNumber = function (value) {
    return I11L_PHONE_NUMBER_REGEX.test(value);
};
var renderErrorMsg = function (language, phoneNumber, isVietNam) {
    if (!phoneNumber)
        return t('This field is required.', language);
    if (isVietNam && !validateVietNamPhoneNumber(phoneNumber)) {
        return t('The phone number format is invalid.', language);
    }
    if (!isVietNam && !validateI11lPhoneNumber(phoneNumber)) {
        return t('Accept 7 - 15 digits.', language);
    }
    return '';
};


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useElementSize.js
var useElementSize = __webpack_require__(19191);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFetch.js
var useFetch = __webpack_require__(86760);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/I11lPhoneNumberInput/index.js
'use client';














var COUNTRY_SPRITE_SHEET = IMG_URL + '/country-spritesheet.png?v=1';
var I11lPhoneNumberInput = (0,react.forwardRef)(function (_a, ref) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.isRequired, isRequired = _c === void 0 ? false : _c, onChange = _a.onChange, _d = _a.className, className = _d === void 0 ? 'i11l-input-container' : _d, _e = _a.value, value = _e === void 0 ? '' : _e, _f = _a.language, language = _f === void 0 ? constants/* ELanguage.VI */.Df.VI : _f, _g = _a.urlMeta, urlMeta = _g === void 0 ? 'https://ms.vietnamworks.com/meta/v1.0/international-phone-number' : _g, renderErrorElement = _a.renderErrorElement, _h = _a.hiddenDefaultError, hiddenDefaultError = _h === void 0 ? true : _h, _j = _a.hasError, hasError = _j === void 0 ? false : _j, _k = _a.dropdownWidth, dropdownWidth = _k === void 0 ? '' : _k, _l = _a.dropdownHeight, dropdownHeight = _l === void 0 ? '250px' : _l, _m = _a.enableClearInput, enableClearInput = _m === void 0 ? true : _m, _o = _a.hiddenInput, hiddenInput = _o === void 0 ? {
        id: '',
        className: '',
        name: ''
    } : _o, onFocus = _a.onFocus, onBlur = _a.onBlur, onPressEnter = _a.onPressEnter, placeholder = _a.placeholder, floatingConfig = _a.floatingConfig;
    var _p = (0,react.useState)([]), options = _p[0], setOptions = _p[1];
    var _q = (0,react.useState)(VN_DIALCODE), dialCode = _q[0], setDialCode = _q[1];
    var _r = (0,useElementSize/* default */.Z)(), setRef = _r[0], size = _r[1];
    var _s = (0,react.useState)(value), inputValue = _s[0], setInputValue = _s[1];
    var _t = (0,react.useState)(value), hiddenValue = _t[0], setHiddenValue = _t[1];
    var _u = (0,react.useState)(false), isVietNam = _u[0], setIsVietNam = _u[1];
    var _v = (0,react.useState)(''), error = _v[0], setError = _v[1];
    var _w = (0,react.useState)(false), touched = _w[0], setTouched = _w[1];
    var _x = (0,react.useState)('none'), inputRemoveState = _x[0], setInputRemoveState = _x[1];
    var inputRef = (0,react.useRef)(null);
    var isSetInitialValue = (0,react.useRef)(false);
    var validate = function (phoneNumber) {
        var errorMsg = renderErrorMsg(language, phoneNumber, isVietNam);
        if (errorMsg === '') {
            setTouched(false);
        }
        if (!hiddenDefaultError) {
            setError(errorMsg);
        }
        return errorMsg;
    };
    var convertedPhoneNumber = (0,react.useCallback)(function (dialCode, value) {
        if (value === '')
            return '';
        return "".concat(dialCode, "-").concat(value);
    }, []);
    var setValue = function (target) {
        var _a;
        var value = target.value;
        value = value.replace(/\. /g, '');
        if (value.match(I11L_LIMIT_NUMBER)) {
            value = ((_a = value.match(I11L_LIMIT_NUMBER)) === null || _a === void 0 ? void 0 : _a[0]) || '';
            target.value = value;
        }
        setInputValue(value);
        // Handle validate phone number input if user touched
        if (touched) {
            validate(value);
        }
        // Convert data
        if (/^0/g.test(value) && isVietNam) {
            value = value.substring(1);
        }
        var convertedValue = convertedPhoneNumber(dialCode, value.trim());
        setHiddenValue(convertedValue);
        onChange && onChange(convertedValue);
    };
    var handleChange = function (e) {
        setValue(e.target);
        isSetInitialValue.current = true;
    };
    var handleChangeNation = (0,react.useCallback)(function (result) {
        isSetInitialValue.current = true;
        var value = inputValue;
        setDialCode(result.value);
        if (result.value === VN_DIALCODE && /^0/g.test(value)) {
            // Convert data
            value = value.substring(1);
        }
        var convertedValue = convertedPhoneNumber(result.value, value.trim());
        setHiddenValue(convertedValue);
        onChange && onChange(convertedValue);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [onChange, inputValue, convertedPhoneNumber]);
    var getValueSelected = (0,react.useMemo)(function () { return options.findIndex(function (item) { return item.dialCode === dialCode; }) + 1; }, [dialCode, options]);
    var handleClearInput = (0,react.useCallback)(function () {
        onChange && onChange('');
        if (inputRef.current) {
            inputRef.current.focus();
            setInputRemoveState('focus');
        }
        setInputValue('');
        setHiddenValue('');
    }, [onChange]);
    var handleInputFocus = function () {
        setInputRemoveState('focus');
        onFocus && onFocus();
    };
    (0,react.useImperativeHandle)(ref, function () { return ({
        validate: function () {
            return validate(inputValue);
        },
        errorMsg: function (phoneNumber) {
            var convertedPhoneNumber = phoneNumber.split('-');
            return validate(convertedPhoneNumber[1]);
        }
    }); });
    // Set initial value
    (0,react.useEffect)(function () {
        if (isSetInitialValue.current)
            return;
        if (value) {
            if (!value.match('-')) {
                var convertedValue = value.replace(/^0/, '');
                setDialCode(VN_DIALCODE);
                setInputValue(convertedValue);
                onChange && onChange(convertedPhoneNumber(VN_DIALCODE, convertedValue));
                setHiddenValue(convertedPhoneNumber(VN_DIALCODE, convertedValue));
                return;
            }
            var getValue = value.split('-');
            setDialCode(getValue[0]);
            setInputValue(getValue[1]);
            setHiddenValue(convertedPhoneNumber(getValue[0], getValue[1]));
        }
    }, [value, convertedPhoneNumber, onChange]);
    (0,react.useEffect)(function () {
        if (dialCode === '+84') {
            setIsVietNam(true);
            return;
        }
        setIsVietNam(false);
    }, [dialCode]);
    (0,react.useEffect)(function () {
        if (error !== '' && !touched)
            setTouched(true);
    }, [error, touched]);
    (0,useFetch/* default */.Z)(urlMeta, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }, function (data) {
        var convertedData = data.data.relationships.data.map(function (item) { return item.attributes; });
        setOptions(convertedData);
    });
    (0,react.useEffect)(function () {
        var setDialCodeFromUMD = function (e) {
            var _a = e.detail, dialCode = _a.dialCode, phoneNumber = _a.phoneNumber;
            setDialCode(dialCode);
            setInputValue(phoneNumber);
            setHiddenValue(convertedPhoneNumber(dialCode, phoneNumber));
        };
        if (typeof window === 'undefined')
            return;
        window.addEventListener('I11LPHONENUMBER', setDialCodeFromUMD);
        return function () {
            window.removeEventListener('I11LPHONENUMBER', setDialCodeFromUMD);
        };
    }, []);
    if (typeof window !== 'undefined') {
        window.I11lPhoneNumberInput = {
            validate: function () {
                return validate(inputValue);
            },
            errorMsg: function (phoneNumber) {
                var convertedPhoneNumber = phoneNumber.split('-');
                return validate(convertedPhoneNumber[1]);
            }
        };
    }
    var renderError = function (error) {
        return renderErrorElement ? renderErrorElement(error) : react.createElement(ErrorMsg, null, error);
    };
    var isError = error !== '';
    var renderDropdownWidth = size.width > 0 ? "".concat(size.width, "px") : '320px';
    var onKeyDown = function (e) {
        enterOnlyNumber(e);
        if (e.key === 'Enter') {
            onPressEnter && onPressEnter();
        }
    };
    return (react.createElement(Wrapper, null,
        label !== '' ? (react.createElement(LabelWrapper, null,
            isRequired ? react.createElement(TextDanger, null, "*") : null,
            " ",
            react.createElement("label", null, label))) : null,
        react.createElement(Container, { ref: setRef, className: "".concat(className, " ").concat(hasError ? 'error' : '', " ").concat(isError ? 'error' : '') },
            react.createElement(MultipleRadio/* default */.Z, { name: 'i11l-multiple-radio', width: 'fit-content', value: getValueSelected, options: options, fieldValue: 'dialCode', fieldLabel: 'countryName', onChange: handleChangeNation, onBlur: onBlur, customValue: function (value) {
                    var _a, _b;
                    var dialCode = (_a = value === null || value === void 0 ? void 0 : value.dialCode) !== null && _a !== void 0 ? _a : VN_DIALCODE;
                    var iconPosition = (_b = value === null || value === void 0 ? void 0 : value.iconPosition) !== null && _b !== void 0 ? _b : { x: 0, y: 0 };
                    return (react.createElement(CustomValue, { className: 'i11l-flag-selected' },
                        react.createElement(Flag, { url: COUNTRY_SPRITE_SHEET, x: iconPosition.x }),
                        dialCode));
                }, arrowDownSize: { width: 16, height: 16 }, spacingElement: 2, isMobile: (0,responsiveHelper/* isPhone */.Mn)(), dropdown: {
                    width: dropdownWidth !== '' ? dropdownWidth : renderDropdownWidth,
                    isSearchable: true,
                    searchBoxPlaceholder: t('Type country name or code', language),
                    searchFields: ['countryName', 'dialCode'],
                    maxHeight: dropdownHeight,
                    emptyText: t('No result found', language),
                    floatingConfig: (0,_tslib/* __assign */.pi)({}, floatingConfig),
                    customOptionItem: function (value) {
                        var countryName = value.countryName, dialCode = value.dialCode, iconPosition = value.iconPosition, active = value.active;
                        return (react.createElement(CustomOptionItem, null,
                            react.createElement(Flag, { url: COUNTRY_SPRITE_SHEET, x: iconPosition.x }),
                            react.createElement(Text, { className: 'i11l-value', active: active }, "".concat(countryName, " ").concat(dialCode))));
                    }
                } }),
            react.createElement(InputWrapper, null,
                react.createElement(Input, { type: 'tel', placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : '', value: inputValue, onChange: handleChange, onKeyDown: onKeyDown, className: 'i11l-input', onFocus: handleInputFocus, onMouseEnter: function () { return inputRemoveState !== 'focus' && setInputRemoveState('hover'); }, onMouseLeave: function () { return inputRemoveState !== 'focus' && setInputRemoveState('none'); }, onBlur: function () {
                        setInputRemoveState('none');
                        onBlur && onBlur();
                    }, ref: inputRef }),
                enableClearInput && (react.createElement(RemoveIcon, { onMouseOver: function () { return inputRemoveState !== 'focus' && setInputRemoveState('hover'); }, onMouseLeave: function () { return inputRemoveState !== 'focus' && setInputRemoveState('none'); }, className: "i11l-remove-icon ".concat(inputRemoveState === 'none' ? 'hidden' : inputValue !== '' ? '' : 'hidden'), onClick: handleClearInput })))),
        error && !hiddenDefaultError && renderError(error),
        react.createElement("input", { name: hiddenInput.name, className: hiddenInput.className, id: hiddenInput.id, type: 'hidden', value: hiddenValue })));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 94864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddFilledIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';




var AddFilledIcon =  function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[40] */ .O9.primary[40] : _e, _f = _a.rotate, rotate = _f === void 0 ? '' : _f;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 25 24', fill: 'none', style: { transform: "rotate(".concat(rotate, ")") } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M12.5 2.39844C7.19839 2.39844 2.89999 6.69684 2.89999 11.9984C2.89999 17.3 7.19839 21.5984 12.5 21.5984C17.8016 21.5984 22.1 17.3 22.1 11.9984C22.1 6.69684 17.8016 2.39844 12.5 2.39844ZM16.5 12.7984H13.3V15.9984C13.3 16.4408 12.9416 16.7984 12.5 16.7984C12.0584 16.7984 11.7 16.4408 11.7 15.9984V12.7984H8.49999C8.05839 12.7984 7.69999 12.4408 7.69999 11.9984C7.69999 11.556 8.05839 11.1984 8.49999 11.1984H11.7V7.99844C11.7 7.55604 12.0584 7.19844 12.5 7.19844C12.9416 7.19844 13.3 7.55604 13.3 7.99844V11.1984H16.5C16.9416 11.1984 17.3 11.556 17.3 11.9984C17.3 12.4408 16.9416 12.7984 16.5 12.7984Z', fill: color })));
};
var AddFilledIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(AddFilledIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowBackIcon$1; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var ArrowBackIcon = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ width: '22px', height: '16px', viewBox: '0 0 22 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'RESPONSIVE', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Responsive/Menu-Suggestion', transform: 'translate(-18.000000, -53.000000)', fill: '#555555', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Group-15', transform: 'translate(17.000000, 40.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icon/search', transform: 'translate(1.000000, 13.000000)' },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M7.78398042,0.0083441098 C7.64390879,0.0333572205 7.51884516,0.103393034 7.42379623,0.208446434 L0.440225114,7.17200732 L0,7.63224267 L0.440225114,8.09247801 L7.42379623,15.0560389 C7.57887585,15.2461361 7.826502,15.333681 8.06662479,15.2786526 C8.30424646,15.2236248 8.49184255,15.0360287 8.54687037,14.798407 C8.60189883,14.5582842 8.5143539,14.3106581 8.32425669,14.1555784 L2.44124836,8.2725701 L21.350918,8.2725701 C21.5810357,8.27507122 21.796146,8.15500983 21.9137056,7.9549075 C22.0287648,7.75480518 22.0287648,7.50968015 21.9137056,7.30957783 C21.796146,7.1094755 21.5810357,6.98941411 21.350918,6.99191523 L2.44124836,6.99191523 L8.32425669,1.10890689 C8.53186301,0.916308567 8.58689083,0.611152202 8.4618272,0.358523177 C8.33926469,0.103393034 8.06162255,-0.036678593 7.78398042,0.0083441098 Z', id: 'Path' })))))));
};
var ArrowBackIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(ArrowBackIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowDownIcon$1; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var ArrowDownIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c; _a.color; var _d = _a.thickness, thickness = _d === void 0 ? 1 : _d, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["width", "height", "color", "thickness"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ width: width, height: height, viewBox: '0 0 20 20', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.8028 5.8332C16.6231 5.83744 16.4524 5.91251 16.3279 6.04205L9.99853 12.3714L3.66918 6.04205C3.60571 5.9768 3.52981 5.92494 3.44596 5.88953C3.3621 5.85411 3.272 5.83586 3.18098 5.83586C3.04549 5.83589 2.91309 5.87634 2.8007 5.95201C2.68831 6.02769 2.60105 6.13517 2.55006 6.2607C2.49908 6.38623 2.48669 6.52412 2.51448 6.65673C2.54227 6.78934 2.60898 6.91065 2.70608 7.00515L9.51698 13.816C9.64471 13.9437 9.81792 14.0154 9.99853 14.0154C10.1791 14.0154 10.3523 13.9437 10.4801 13.816L17.291 7.00515C17.3899 6.91003 17.4578 6.78726 17.4857 6.65291C17.5137 6.51856 17.5004 6.37891 17.4476 6.25223C17.3949 6.12556 17.3051 6.01778 17.19 5.943C17.0749 5.86823 16.94 5.82996 16.8028 5.8332Z", fill: "#616161", strokeWidth: thickness })));
};
var ArrowDownIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(ArrowDownIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowRoundedLeft$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var ArrowRoundedLeft = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Group', transform: 'translate(-3.000000, -3.000000)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/icon-arrow-left', transform: 'translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M12,3 C7.03379765,3 3,7.03379765 3,12 C3,16.9662023 7.03379765,21 12,21 C16.9662023,21 21,16.9662023 21,12 C21,7.03379765 16.9662023,3 12,3 Z M12,3.7826087 C16.5427989,3.7826087 20.2173913,7.45720109 20.2173913,12 C20.2173913,16.5427989 16.5427989,20.2173913 12,20.2173913 C7.45720109,20.2173913 3.7826087,16.5427989 3.7826087,12 C3.7826087,7.45720109 7.45720109,3.7826087 12,3.7826087 Z M10.7894022,7.68342391 C10.7725882,7.68648117 10.7557747,7.69106648 10.7404891,7.69565217 C10.59375,7.72163713 10.4760531,7.82863461 10.4347826,7.97078804 C10.3935121,8.1144703 10.436311,8.26732357 10.544837,8.36820652 L14.1766304,12 L10.544837,15.6317935 C10.3889268,15.787704 10.3889268,16.0383833 10.544837,16.1942935 C10.7007475,16.350204 10.9514268,16.350204 11.107337,16.1942935 L15.0203804,12.28125 C15.0968073,12.2078804 15.1396062,12.1054687 15.1396062,12 C15.1396062,11.8945313 15.0968073,11.7921196 15.0203804,11.71875 L11.107337,7.80570652 C11.0263248,7.71858026 10.9086279,7.67425291 10.7894022,7.68342391 Z', id: 'Shape', fill: '#555555' }))))));
};
var ArrowRoundedLeft$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(ArrowRoundedLeft);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 2284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowRoundedRight$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var ArrowRoundedRight = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'atom-/-ic-/-Chevron-Right-Circle-Thin-Copy', transform: 'translate(-3.000000, -3.000000)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M12,3 C7.03379765,3 3,7.03379765 3,12 C3,16.9662023 7.03379765,21 12,21 C16.9662023,21 21,16.9662023 21,12 C21,7.03379765 16.9662023,3 12,3 Z M12,3.7826087 C16.5427989,3.7826087 20.2173913,7.45720109 20.2173913,12 C20.2173913,16.5427989 16.5427989,20.2173913 12,20.2173913 C7.45720109,20.2173913 3.7826087,16.5427989 3.7826087,12 C3.7826087,7.45720109 7.45720109,3.7826087 12,3.7826087 Z M10.7894022,7.68342391 C10.7725882,7.68648117 10.7557747,7.69106648 10.7404891,7.69565217 C10.59375,7.72163713 10.4760531,7.82863461 10.4347826,7.97078804 C10.3935121,8.1144703 10.436311,8.26732357 10.544837,8.36820652 L14.1766304,12 L10.544837,15.6317935 C10.3889268,15.787704 10.3889268,16.0383833 10.544837,16.1942935 C10.7007475,16.350204 10.9514268,16.350204 11.107337,16.1942935 L15.0203804,12.28125 C15.0968073,12.2078804 15.1396062,12.1054687 15.1396062,12 C15.1396062,11.8945313 15.0968073,11.7921196 15.0203804,11.71875 L11.107337,7.80570652 C11.0263248,7.71858026 10.9086279,7.67425291 10.7894022,7.68342391 Z', id: 'Shape', fill: '#555555' })))));
};
var ArrowRoundedRight$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(ArrowRoundedRight);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ DoubleArrowLeft; },
/* harmony export */   "Ct": function() { return /* binding */ DoubleArrowRight; },
/* harmony export */   "RD": function() { return /* binding */ LongArrowRight; },
/* harmony export */   "Xd": function() { return /* binding */ ArrowLeft; },
/* harmony export */   "ol": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var ArrowLeft = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10.6497 2.00024C10.5082 2.00445 10.3738 2.06361 10.2752 2.16518L4.82657 7.61361C4.72443 7.71579 4.66705 7.85435 4.66705 7.99883C4.66705 8.14331 4.72443 8.28187 4.82657 8.38405L10.2752 13.8325C10.3254 13.8848 10.3855 13.9265 10.452 13.9553C10.5186 13.984 10.5902 13.9992 10.6627 14C10.7352 14.0007 10.8071 13.987 10.8742 13.9596C10.9413 13.9322 11.0023 13.8917 11.0535 13.8404C11.1048 13.7891 11.1453 13.7282 11.1727 13.6611C11.2001 13.5939 11.2139 13.522 11.2131 13.4496C11.2124 13.3771 11.1972 13.3055 11.1684 13.2389C11.1397 13.1724 11.0979 13.1122 11.0456 13.062L5.98227 7.99883L11.0456 2.93562C11.1244 2.85909 11.1781 2.76056 11.1999 2.65294C11.2217 2.54533 11.2104 2.43364 11.1676 2.33253C11.1248 2.23141 11.0525 2.14558 10.9601 2.08629C10.8677 2.02699 10.7595 1.997 10.6497 2.00024Z', fill: color !== null && color !== void 0 ? color : '#888' })));
};
var ArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M5.27436 2C5.16597 2.00003 5.06005 2.03238 4.97015 2.09292C4.88024 2.15346 4.81043 2.23944 4.76964 2.33986C4.72886 2.44029 4.71895 2.55059 4.74118 2.65668C4.76341 2.76276 4.81678 2.85981 4.89445 2.9354L9.9578 7.99871L4.89445 13.062C4.84216 13.1122 4.80041 13.1724 4.77165 13.2389C4.74289 13.3054 4.72769 13.3771 4.72696 13.4495C4.72622 13.522 4.73995 13.5939 4.76735 13.6611C4.79475 13.7282 4.83527 13.7891 4.88653 13.8404C4.93779 13.8917 4.99876 13.9322 5.06588 13.9596C5.13299 13.987 5.2049 14.0007 5.27739 14C5.34988 13.9992 5.42149 13.984 5.48803 13.9553C5.55457 13.9265 5.61471 13.8848 5.66492 13.8325L11.1135 8.38394C11.2156 8.28176 11.273 8.14319 11.273 7.99871C11.273 7.85423 11.2156 7.71567 11.1135 7.61348L5.66492 2.16495C5.61414 2.11275 5.55342 2.07126 5.48634 2.04293C5.41926 2.0146 5.34718 2 5.27436 2Z', fill: color !== null && color !== void 0 ? color : '#888' })));
};
var DoubleArrowLeft = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M8.5229 2.12816C8.38434 2.13229 8.25283 2.1902 8.15623 2.28962L2.8229 7.62295C2.72291 7.72298 2.66675 7.85861 2.66675 8.00004C2.66675 8.14146 2.72291 8.2771 2.8229 8.37712L8.15623 13.7105C8.20537 13.7616 8.26424 13.8025 8.32937 13.8307C8.39451 13.8588 8.46461 13.8737 8.53556 13.8744C8.60652 13.8751 8.6769 13.8617 8.7426 13.8349C8.80829 13.808 8.86797 13.7684 8.91815 13.7182C8.96833 13.668 9.00798 13.6083 9.03481 13.5427C9.06163 13.477 9.07507 13.4066 9.07435 13.3356C9.07363 13.2647 9.05875 13.1946 9.0306 13.1294C9.00245 13.0643 8.96158 13.0054 8.9104 12.9563L3.95415 8.00004L8.9104 3.04379C8.98746 2.96887 9.0401 2.87242 9.06141 2.76708C9.08273 2.66174 9.07172 2.55241 9.02983 2.45343C8.98794 2.35445 8.91713 2.27044 8.82667 2.2124C8.73621 2.15435 8.63033 2.12499 8.5229 2.12816ZM12.2562 2.12816C12.1177 2.13229 11.9862 2.1902 11.8896 2.28962L6.55623 7.62295C6.45625 7.72298 6.40008 7.85861 6.40008 8.00004C6.40008 8.14146 6.45625 8.2771 6.55623 8.37712L11.8896 13.7105C11.9387 13.7616 11.9976 13.8025 12.0627 13.8307C12.1278 13.8588 12.1979 13.8737 12.2689 13.8744C12.3398 13.8751 12.4102 13.8617 12.4759 13.8349C12.5416 13.808 12.6013 13.7684 12.6515 13.7182C12.7017 13.668 12.7413 13.6083 12.7681 13.5427C12.795 13.477 12.8084 13.4066 12.8077 13.3356C12.807 13.2647 12.7921 13.1946 12.7639 13.1294C12.7358 13.0643 12.6949 13.0054 12.6437 12.9563L7.68748 8.00004L12.6437 3.04379C12.7208 2.96887 12.7734 2.87242 12.7947 2.76708C12.8161 2.66174 12.805 2.55241 12.7632 2.45343C12.7213 2.35445 12.6505 2.27044 12.56 2.2124C12.4695 2.15435 12.3637 2.12499 12.2562 2.12816Z', fill: color !== null && color !== void 0 ? color : '#888' })));
};
var DoubleArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M3.72811 2.12793C3.62202 2.12796 3.51834 2.15963 3.43033 2.21889C3.34233 2.27815 3.27399 2.36231 3.23407 2.46061C3.19415 2.55891 3.18445 2.66688 3.20621 2.77072C3.22797 2.87456 3.28021 2.96956 3.35624 3.04355L8.31249 7.9998L3.35624 12.9561C3.30505 13.0052 3.26419 13.0641 3.23603 13.1292C3.20788 13.1943 3.19301 13.2644 3.19229 13.3354C3.19157 13.4063 3.20501 13.4767 3.23183 13.5424C3.25865 13.6081 3.29831 13.6678 3.34849 13.718C3.39866 13.7681 3.45834 13.8078 3.52404 13.8346C3.58973 13.8615 3.66012 13.8749 3.73107 13.8742C3.80203 13.8734 3.87213 13.8586 3.93726 13.8304C4.0024 13.8023 4.06126 13.7614 4.1104 13.7102L9.44374 8.37689C9.54372 8.27687 9.59988 8.14123 9.59988 7.9998C9.59988 7.85838 9.54372 7.72274 9.44374 7.62272L4.1104 2.28939C4.0607 2.2383 4.00127 2.19769 3.9356 2.16996C3.86994 2.14222 3.79939 2.12793 3.72811 2.12793ZM7.46145 2.12793C7.35535 2.12796 7.25167 2.15963 7.16366 2.21889C7.07566 2.27815 7.00733 2.36231 6.9674 2.46061C6.92748 2.55891 6.91778 2.66688 6.93954 2.77072C6.9613 2.87456 7.01354 2.96956 7.08957 3.04355L12.0458 7.9998L7.08957 12.9561C7.03838 13.0052 6.99752 13.0641 6.96937 13.1292C6.94121 13.1943 6.92634 13.2644 6.92562 13.3354C6.9249 13.4063 6.93834 13.4767 6.96516 13.5424C6.99198 13.6081 7.03164 13.6678 7.08182 13.718C7.13199 13.7682 7.19168 13.8078 7.25737 13.8346C7.32306 13.8615 7.39345 13.8749 7.46441 13.8742C7.53536 13.8735 7.60546 13.8586 7.67059 13.8304C7.73573 13.8023 7.79459 13.7614 7.84374 13.7102L13.1771 8.37689C13.2771 8.27687 13.3332 8.14123 13.3332 7.9998C13.3332 7.85838 13.2771 7.72274 13.1771 7.62272L7.84374 2.28939C7.79404 2.2383 7.7346 2.19769 7.66894 2.16996C7.60328 2.14222 7.53272 2.12793 7.46145 2.12793Z', fill: color !== null && color !== void 0 ? color : '#888' })));
};
var LongArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 20, height: size !== null && size !== void 0 ? size : 20, viewBox: '0 0 20 20', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M15.3272 5.99316C15.1946 5.9932 15.065 6.03278 14.955 6.10686C14.8449 6.18094 14.7595 6.28614 14.7096 6.40901C14.6597 6.53189 14.6476 6.66685 14.6748 6.79665C14.702 6.92646 14.7673 7.0452 14.8623 7.1377L17.0576 9.33301H1.33369C1.24535 9.33176 1.15764 9.34808 1.07566 9.38102C0.993686 9.41396 0.919072 9.46287 0.856159 9.5249C0.793246 9.58693 0.743288 9.66085 0.70919 9.74235C0.675091 9.82386 0.657532 9.91132 0.657532 9.99967C0.657532 10.088 0.675091 10.1755 0.70919 10.257C0.743288 10.3385 0.793246 10.4124 0.856159 10.4744C0.919072 10.5365 0.993686 10.5854 1.07566 10.6183C1.15764 10.6513 1.24535 10.6676 1.33369 10.6663H17.0576L14.8623 12.8617C14.7984 12.9231 14.7473 12.9967 14.7121 13.0781C14.6769 13.1595 14.6583 13.2471 14.6574 13.3358C14.6565 13.4245 14.6733 13.5125 14.7068 13.5946C14.7404 13.6767 14.7899 13.7513 14.8526 13.8141C14.9154 13.8768 14.99 13.9263 15.0721 13.9599C15.1542 13.9934 15.2422 14.0102 15.3309 14.0093C15.4196 14.0084 15.5072 13.9898 15.5886 13.9546C15.67 13.9194 15.7436 13.8683 15.805 13.8044L19.0798 10.5296C19.1612 10.4676 19.2272 10.3876 19.2728 10.2959C19.3183 10.2043 19.3421 10.1033 19.3424 10.001C19.3426 9.8986 19.3193 9.79756 19.2742 9.70566C19.2291 9.61376 19.1635 9.53347 19.0824 9.47103C19.0811 9.47016 19.0798 9.46929 19.0785 9.46842L15.805 6.19499C15.7429 6.13112 15.6686 6.08036 15.5865 6.0457C15.5045 6.01103 15.4163 5.99317 15.3272 5.99316Z', fill: color !== null && color !== void 0 ? color : '#616161' })));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AttachIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var AttachIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#616161' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 20 20', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M12.8686 1.66797C11.8864 1.66797 10.9051 2.0571 10.1693 2.83333L4.83081 8.46484C2.83472 10.5713 2.83472 13.9574 4.83081 16.0638C4.89234 16.1286 4.96629 16.1805 5.04825 16.2161C5.04955 16.2166 5.05086 16.217 5.05216 16.2174C7.06325 18.1232 10.2002 18.1019 12.1316 16.0638L15.8868 12.1016C15.9504 12.0387 16.0007 11.9637 16.0347 11.8811C16.0687 11.7984 16.0857 11.7097 16.0848 11.6203C16.0838 11.531 16.0649 11.4427 16.0291 11.3607C15.9934 11.2788 15.9415 11.2049 15.8766 11.1434C15.8117 11.0819 15.7352 11.0341 15.6514 11.0028C15.5677 10.9716 15.4785 10.9574 15.3892 10.9613C15.2999 10.9652 15.2123 10.987 15.1316 11.0254C15.0508 11.0638 14.9787 11.118 14.9193 11.1849L11.1641 15.1471C9.66295 16.7313 7.30074 16.7313 5.79956 15.1471C4.29831 13.5629 4.29831 10.9657 5.79956 9.38151L11.1368 3.75C12.1133 2.71981 13.6252 2.71981 14.6016 3.75C15.578 4.78009 15.578 6.48033 14.6016 7.51042L9.74357 12.6367C9.29097 13.1139 8.6303 13.1135 8.17846 12.6367C7.72662 12.1599 7.72662 11.357 8.17846 10.8802L12.086 6.75651C12.1496 6.69367 12.1999 6.61868 12.2339 6.53601C12.2679 6.45334 12.2849 6.36468 12.284 6.27529C12.283 6.1859 12.2641 6.09762 12.2284 6.01569C12.1926 5.93376 12.1407 5.85986 12.0759 5.79838C12.011 5.73689 11.9344 5.68909 11.8506 5.6578C11.7669 5.62651 11.6777 5.61238 11.5884 5.61625C11.4991 5.62012 11.4115 5.64191 11.3308 5.68032C11.2501 5.71873 11.1779 5.77298 11.1186 5.83984L7.20971 9.96354C6.26289 10.9627 6.26289 12.5542 7.20971 13.5534C7.27291 13.6199 7.34915 13.6726 7.43367 13.7083C8.3941 14.5107 9.82882 14.4835 10.711 13.5534L15.5691 8.42708C16.98 6.93856 17.0003 4.60906 15.7058 3.04948C15.6746 2.96928 15.6282 2.89588 15.5691 2.83333C14.8333 2.0571 13.8508 1.66797 12.8686 1.66797Z', fill: color })));
};
var AttachIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(AttachIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 88073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var AwardsIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-award-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-gold-medal-100-2', transform: 'translate(14.000000, 8.020815)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M1.28,0 C1.05,0 0.83249984,0.12 0.72,0.32 C0.60500032,0.52 0.62,0.76249984 0.74,0.96 L5.54,9 L9.5,2.42 L8.22,0.32 C8.10500032,0.12750016 7.90500032,0 7.68,0 L1.28,0 Z M12.8,0 C12.5750003,0 12.3750003,0.12750016 12.26,0.32 L10.24,3.68 L7.46,8.32 L7.44,8.32 L5.76,10.88 L5.76,12.56 C2.35500032,14.2250003 0,17.72 0,21.76 C0,27.4050003 4.59500032,32 10.24,32 C15.8850003,32 20.48,27.4050003 20.48,21.76 C20.48,17.72 18.1250003,14.2250003 14.72,12.56 L14.72,10.04 C14.7250003,9.87750016 14.6675002,9.72 14.56,9.6 L19.74,0.96 C19.86,0.76249984 19.8750003,0.52 19.76,0.32 C19.6450003,0.12 19.43,0 19.2,0 L12.8,0 Z M7.04,10.88 L13.44,10.88 L13.44,12.04 C12.4324998,11.7075002 11.36,11.52 10.24,11.52 C9.12,11.52 8.04750016,11.7075002 7.04,12.04 L7.04,10.88 Z M10.24,14.08 C14.4750003,14.08 17.92,17.5250003 17.92,21.76 C17.92,25.9950003 14.4750003,29.44 10.24,29.44 C6.00500032,29.44 2.56,25.9950003 2.56,21.76 C2.56,17.5250003 6.00500032,14.08 10.24,14.08 Z M10.24,15.36 C6.71,15.36 3.84,18.23 3.84,21.76 C3.84,25.29 6.71,28.16 10.24,28.16 C13.77,28.16 16.64,25.29 16.64,21.76 C16.64,18.23 13.77,15.36 10.24,15.36 Z M8.32,18.56 L12.16,18.56 L12.16,19.84 L10.88,19.84 L10.88,24.32 L12.16,24.32 L12.16,25.6 L8.32,25.6 L8.32,24.32 L9.6,24.32 L9.6,19.84 L8.32,19.84 L8.32,18.56 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(AwardsIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 27553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var BonusIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-paidleave-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-receive-dollar-100', transform: 'translate(8.000000, 9.859626)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M12.5209091,0 C12.1369346,0 11.825303,0.311631516 11.825303,0.695606061 L11.825303,9.51431468 C11.825303,13.4966594 14.7742922,16.9819831 18.7392468,17.354828 C23.2885104,17.7833213 27.1286364,14.2007977 27.1286364,9.73848486 L27.1286364,0.695606061 C27.1286364,0.311631516 26.8170049,0 26.4330303,0 C26.0490558,0 25.7374243,0.311631516 25.7374243,0.695606061 L25.7374243,4.51736384 C25.7374243,5.13854006 24.9783984,5.44233487 24.5540787,4.98879972 C24.5485139,4.98323487 24.5433406,4.97670244 24.5377758,4.97113759 C24.4181316,4.84245047 24.3462122,4.67704856 24.3462122,4.50106023 L24.3462122,0.695606061 C24.3462122,0.311631516 24.0345806,0 23.6506061,0 C23.2666315,0 22.955,0.311631516 22.955,0.695606061 L22.955,2.62210875 C22.955,3.09859897 22.4769336,3.44754322 22.0352238,3.27016367 C22.0303545,3.26807685 22.024453,3.26681607 22.0202794,3.26472925 C21.7496886,3.15691031 21.5637879,2.90810071 21.5637879,2.61803299 L21.5637879,0.695606061 C21.5637879,0.311631516 21.2521564,0 20.8681818,0 C20.4842073,0 20.1725758,0.311631516 20.1725758,0.695606061 L20.1725758,2.1139903 C20.1725758,2.4930956 19.8655854,2.8000861 19.48648,2.8000861 L19.4688179,2.8000861 C19.089017,2.8000861 18.7813637,2.4930956 18.7813637,2.1139903 L18.7813637,0.695606061 C18.7813637,0.311631516 18.4697321,0 18.0857576,0 C17.7017831,0 17.3901515,0.311631516 17.3901515,0.695606061 L17.3901515,2.61803299 C17.3901515,2.90810071 17.2042181,3.15691031 16.9350186,3.26472925 C16.9294537,3.26681607 16.9235849,3.26807685 16.9187157,3.27016367 C16.4770058,3.44754322 15.9989394,3.09926196 15.9989394,2.62346741 L15.9989394,0.695606061 C15.9989394,0.311631516 15.6873079,0 15.3033334,0 C14.9193588,0 14.6077273,0.311631516 14.6077273,0.695606061 L14.6077273,4.50106023 C14.6077273,4.67704856 14.5365035,4.84314607 14.4161636,4.97113759 C14.4105988,4.97670244 14.4040671,4.98323487 14.3985022,4.98879972 C13.9748781,5.44303048 13.2165152,5.13854006 13.2165152,4.51736384 L13.2165152,0.695606061 C13.2165152,0.311631516 12.9048837,0 12.5209091,0 Z M18.7813637,4.86924243 L18.8479352,4.86924243 L20.1155145,4.86924243 L20.1712173,4.86924243 L20.1712173,6.10149744 C20.6810965,6.19679547 21.1251867,6.43452997 21.4632513,6.80389679 C21.8493126,7.22682527 22.0685259,7.80748243 22.0678303,8.34727274 L20.7771555,8.34727274 C20.7416796,7.79565713 20.4823271,7.18974043 19.4973489,7.18974112 C18.5923654,7.18974112 18.1713498,7.54482576 18.1713498,8.3065144 C18.1713498,8.94299394 18.7401274,9.10539639 19.7459738,9.33633761 C20.8658996,9.59371185 22.2600896,9.91348404 22.2593942,11.5766781 C22.2593942,11.8931789 22.1522706,13.4277186 20.1725758,13.7490886 L20.1725758,14.6077273 L20.1155145,14.6077273 L18.8492938,14.6077273 L18.7827222,14.6077273 L18.7827222,13.7273509 C17.4290728,13.4699766 16.7457922,12.6353036 16.7040558,11.1745309 L16.7026973,11.129697 L17.9947313,11.129697 L17.9933728,11.1731724 C17.9815475,11.6343592 18.1023214,11.9953899 18.3520439,12.2451124 C18.7749731,12.6680409 19.4498084,12.6730729 19.4783282,12.6730729 C20.7763292,12.6730729 20.970077,11.9917268 20.970077,11.5861885 C20.970077,10.9100594 20.4013001,10.7491351 19.395453,10.5237587 C18.2748317,10.2733405 16.8806744,9.96226342 16.8806744,8.23994281 C16.8806744,8.04586872 16.9393988,6.40898801 18.7813637,6.10013892 L18.7813637,4.86924243 Z M29.4559277,15.3046919 C28.9515778,15.2880544 28.4383318,15.4166629 27.9818404,15.7041221 L21.4781957,19.7133673 C21.9713804,20.2162905 22.259394,20.8982125 22.259394,21.6167736 C22.259394,23.1262388 21.0312688,24.354364 19.5218036,24.354364 C19.3089482,24.354364 19.0979402,24.3289959 18.8941277,24.2809991 C18.3592066,24.1543988 11.5256165,22.1085998 10.7479289,21.8762674 C10.3799533,21.765666 10.1720213,21.3774524 10.2819271,21.0094768 C10.3925285,20.6415012 10.7800791,20.4335693 11.1473591,20.543475 C14.1843752,21.4533278 18.8398273,22.8401492 19.2147589,22.9291868 C19.3142306,22.9528374 19.4174627,22.9645104 19.5218036,22.9645104 C20.2640153,22.9645104 20.8681818,22.3603438 20.8681818,21.6181321 C20.8681818,21.1388596 20.6191333,20.7081055 20.2024653,20.4660346 C20.0000439,20.3484772 13.1340747,17.3466108 11.7532967,16.7407379 C9.58996184,15.79054 7.09552963,15.7670633 4.91271781,16.6755248 L0.427960778,18.5436076 C0.0732016865,18.6896849 0,19.0121964 0,19.452515 L0,27.8310357 C0,28.2150103 0.311631516,28.5266418 0.695606061,28.5266418 C0.90776591,28.5266418 1.07741769,28.412312 1.10454633,28.3921394 L3.5282987,26.6137251 C4.76369506,25.7073504 6.41058582,25.5081136 7.85953324,26.104248 L15.9948639,28.9885674 C16.451877,29.1506436 16.9253566,29.230399 17.3955856,29.230399 C18.2936137,29.230399 19.1784246,28.9412335 19.9171576,28.3812706 L30.8634434,20.085625 C32.0258012,19.2842868 32.3463559,17.7217929 31.5930145,16.5274372 C31.1113073,15.7631401 30.2965106,15.3324208 29.4559277,15.3046919 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(BonusIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 43762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CalendarIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var CalendarIcon = function (_a) {
    var color = _a.color, size = _a.size;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 24, height: size !== null && size !== void 0 ? size : 24, viewBox: '0 0 24 24', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M6.34783 1C5.87228 1 5.47826 1.39402 5.47826 1.86957V2.73913H2.86957C2.36515 2.73913 2 3.10428 2 3.6087V6.65217H22V3.6087C22 3.10428 21.6348 2.73913 21.1304 2.73913H18.5217V1.86957C18.5217 1.39402 18.1277 1 17.6522 1H16.7826C16.3071 1 15.913 1.39402 15.913 1.86957V2.73913H8.08696V1.86957C8.08696 1.39402 7.69293 1 7.21739 1H6.34783ZM6.34783 1.86957H7.21739V4.47826H6.34783V1.86957ZM16.7826 1.86957H17.6522V4.47826H16.7826V1.86957ZM2 7.52174V21C2 21.5044 2.36515 21.8696 2.86957 21.8696H21.1304C21.6348 21.8696 22 21.5044 22 21V7.52174H2ZM6.34783 10.1304H8.52174V12.3043H6.34783V10.1304ZM9.3913 10.1304H11.5652V12.3043H9.3913V10.1304ZM12.4348 10.1304H14.6087V12.3043H12.4348V10.1304ZM15.4783 10.1304H17.6522V12.3043H15.4783V10.1304ZM6.34783 13.1739H8.52174V15.3478H6.34783V13.1739ZM9.3913 13.1739H11.5652V15.3478H9.3913V13.1739ZM12.4348 13.1739H14.6087V15.3478H12.4348V13.1739ZM15.4783 13.1739H17.6522V15.3478H15.4783V13.1739ZM6.34783 16.2174H8.52174V18.3913H6.34783V16.2174ZM9.3913 16.2174H11.5652V18.3913H9.3913V16.2174ZM12.4348 16.2174H14.6087V18.3913H12.4348V16.2174ZM15.4783 16.2174H17.6522V18.3913H15.4783V16.2174Z', fill: color !== null && color !== void 0 ? color : '#888' })));
};


//# sourceMappingURL=Calendar.js.map


/***/ }),

/***/ 29683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var CanteenIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-canteen-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-dining-room-100', transform: 'translate(14.000000, 8.447170)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M1.84,0 C1.52249984,0 1.24500032,0.22500032 1.2,0.54 C1.07750016,1.40500032 0,9.04750016 0,10.24 C0,11.4650003 1.75,13.4775002 2.54,14.32 L1.92,29.44 C1.92,30.9724998 3.20500032,32 5.12,32 C7.03500032,32 8.32,30.9775002 8.32,29.42 L7.7,14.32 C8.48500032,13.4675002 10.24,11.4224998 10.24,10.24 C10.24,9.09500032 9.16249984,1.43 9.04,0.56 C8.99500032,0.24500032 8.71750016,0 8.4,0 L7.04,0 L7.04,9.92 C7.04,10.0975002 6.89750016,10.24 6.72,10.24 C6.54249984,10.24 6.4,10.0975002 6.4,9.92 L6.4,0 L3.84,0 L3.84,9.92 C3.84,10.0975002 3.69750016,10.24 3.52,10.24 C3.34249984,10.24 3.2,10.0975002 3.2,9.92 L3.2,0 L1.84,0 Z M18.56,0 C16.8750003,0 13.44,3.60249984 13.44,7.78 C13.44,12.2550003 14.7,14.61 15.46,16.02 C15.7575002,16.5724998 16,17.01 16,17.28 C16,18.47 15.79,19.73 15.54,21.18 C15.1775002,23.27 14.72,25.8650003 14.72,29.44 C14.72,31.02 15.8250003,32 17.6,32 C19.3750003,32 20.48,31.02 20.48,29.44 L20.48,2.44 C20.48,0.81500032 19.8324998,0 18.56,0 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(CanteenIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckTagIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var CheckTagIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#003699' : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '12', height: '12', viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M1.2939 0.666992C1.13335 0.666992 0.972782 0.728306 0.850271 0.850816C0.605248 1.09584 0.605248 1.49305 0.850271 1.73807L5.11257 6.00033L0.850271 10.2626C0.605249 10.5076 0.605248 10.9048 0.850271 11.1498C0.972939 11.2725 1.13327 11.3337 1.2939 11.3337C1.45453 11.3337 1.61487 11.2725 1.73754 11.1498L5.99984 6.88758L10.2621 11.1498C10.3848 11.2725 10.5451 11.3337 10.7058 11.3337C10.8664 11.3337 11.0267 11.2725 11.1494 11.1498C11.3944 10.9048 11.3944 10.5076 11.1494 10.2626L6.8871 6.00033L11.1494 1.73807C11.3944 1.49305 11.3944 1.09584 11.1494 0.850816C10.9044 0.605796 10.5072 0.605796 10.2621 0.850816L5.99984 5.11307L1.73754 0.850816C1.61502 0.728306 1.45445 0.666992 1.2939 0.666992Z', fill: color })));
};
var CheckTagIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(CheckTagIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CloseIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var CloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#888' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 20 20' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M4.1175 3.3335C3.91681 3.3335 3.7161 3.41014 3.56296 3.56328C3.25668 3.86955 3.25668 4.36607 3.56296 4.67234L8.89084 10.0002L3.56296 15.328C3.25668 15.6343 3.25668 16.1308 3.56296 16.437C3.7163 16.5904 3.91671 16.6668 4.1175 16.6668C4.31829 16.6668 4.51871 16.5904 4.67204 16.437L9.99992 11.1092L15.3278 16.437C15.4811 16.5904 15.6815 16.6668 15.8823 16.6668C16.0831 16.6668 16.2835 16.5904 16.4369 16.437C16.7432 16.1308 16.7432 15.6343 16.4369 15.328L11.109 10.0002L16.4369 4.67234C16.7432 4.36607 16.7432 3.86955 16.4369 3.56328C16.1306 3.257 15.6341 3.257 15.3278 3.56328L9.99992 8.89109L4.67204 3.56328C4.5189 3.41014 4.31819 3.3335 4.1175 3.3335Z', fill: fill })));
};
var CloseIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(CloseIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var CopyIcon = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M8.6 2C7.716 2 7 2.716 7 3.6V16.4C7 17.284 7.716 18 8.6 18H19C19.884 18 20.6 17.284 20.6 16.4V7.2C20.6 6.988 20.516 6.78477 20.3656 6.63438L15.9656 2.23438C15.8152 2.08397 15.612 2 15.4 2H8.6ZM15 3.52344L19.0766 7.6H15.8C15.3584 7.6 15 7.2416 15 6.8V3.52344ZM4.6 6C3.716 6 3 6.716 3 7.6V20.4C3 21.284 3.716 22 4.6 22H15C15.884 22 16.6 21.284 16.6 20.4V19.6H8.6C6.8352 19.6 5.4 18.1648 5.4 16.4V6H4.6Z', fill: '#888' })));
};
var CopyIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(CopyIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 8083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultAvatar$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var DefaultAvatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 110 : _b;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: size, height: size, viewBox: '0 0 110 110', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: '10', y: '10', width: '90', height: '90', rx: '45', fill: '#E6EFFF' }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M55.9759 54.1993C62.3237 54.1993 67.8409 48.5041 67.8409 41.0884C67.8409 33.7618 62.3237 28.3335 55.9759 28.3335C49.6281 28.3335 44.1109 33.8804 44.1109 41.1477C44.1109 48.5041 49.5984 54.1993 55.9759 54.1993ZM37.3181 81.6668H74.5743C79.261 81.6668 80.9221 80.332 80.9221 77.7217C80.9221 70.0688 71.3411 59.5089 55.9462 59.5089C40.581 59.5089 31 70.0688 31 77.7217C31 80.332 32.6611 81.6668 37.3181 81.6668Z', fill: '#CCDEFF' })));
};
var DefaultAvatar$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(DefaultAvatar);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 2237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EyesCloseIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var EyesCloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/icon-forms/icon-eye-closed', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-eyelashes-3d', transform: 'translate(2.000000, 5.000000)', fill: '#666666', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M0.700175,9.1 C0.879375,9.1 1.058575,9.0314 1.195075,8.8949 L2.595075,7.4949 C2.618875,7.4711 2.628675,7.441 2.648275,7.4151 C2.914975,7.6734 3.203375,7.9261 3.511375,8.1711 L2.217775,10.1115 C2.002875,10.4335 2.089675,10.8675 2.411675,11.0824 C2.531375,11.1615 2.665775,11.2 2.799475,11.2 C3.025575,11.2 3.248175,11.0908 3.382575,10.8885 L4.657275,8.9761 C5.162675,9.2869 5.705875,9.5634 6.279875,9.7951 L5.621175,12.4306 C5.526675,12.8051 5.754875,13.1852 6.130775,13.279 C6.187475,13.293 6.244875,13.3 6.300875,13.3 C6.614475,13.3 6.899375,13.0879 6.979175,12.7694 L7.614775,10.2284 C8.094275,10.3467 8.589175,10.4328 9.100875,10.4727 L9.100875,13.3 C9.100875,13.6871 9.413775,14 9.800875,14 C10.187975,14 10.500875,13.6871 10.500875,13.3 L10.500875,10.4727 C11.011875,10.4328 11.506775,10.3467 11.986975,10.2284 L12.622575,12.7694 C12.700275,13.0879 12.985875,13.3 13.299475,13.3 C13.355475,13.3 13.412875,13.293 13.469575,13.279 C13.844775,13.1852 14.072975,12.8051 13.979175,12.4306 L13.320475,9.7958 C13.894475,9.5641 14.437675,9.2876 14.943075,8.9768 L16.217775,10.8892 C16.352175,11.0908 16.574075,11.2 16.800875,11.2 C16.933875,11.2 17.068975,11.1615 17.188675,11.0824 C17.510675,10.8675 17.597475,10.4335 17.382575,10.1115 L16.088975,8.1711 C16.396975,7.9261 16.685375,7.6734 16.952075,7.4151 C16.971675,7.441 16.981475,7.4711 17.005275,7.4949 L18.405275,8.8949 C18.541775,9.0314 18.720975,9.1 18.900175,9.1 C19.079375,9.1 19.258575,9.0314 19.395075,8.8949 C19.668775,8.6212 19.668775,8.1788 19.395075,7.9051 L17.995075,6.5051 C17.957275,6.4673 17.911075,6.4477 17.867675,6.4204 C17.972675,6.2895 18.072075,6.16 18.165175,6.0312 C18.391275,5.7183 18.321275,5.2801 18.007675,5.054 C17.694075,4.8265 17.255875,4.8972 17.030475,5.2115 C15.733375,7.0049 13.062175,9.1 9.800175,9.1 C6.538175,9.1 3.866275,7.0049 2.569875,5.2108 C2.343075,4.8972 1.904875,4.8258 1.592675,5.0533 C1.279775,5.2794 1.209075,5.7176 1.435175,6.0305 C1.528275,6.1593 1.627675,6.2888 1.732675,6.4197 C1.689275,6.447 1.643075,6.4666 1.605275,6.5044 L0.205275,7.9044 C-0.068425,8.1781 -0.068425,8.6205 0.205275,8.8942 C0.341775,9.0314 0.520975,9.1 0.700175,9.1 Z M4.300975,3.6722 C4.436075,3.6722 4.573275,3.633 4.693675,3.5511 C4.823175,3.4629 4.968775,3.3579 5.129775,3.2417 C6.142675,2.5081 7.674975,1.4 9.800175,1.4 C12.031075,1.4 13.642475,2.5585 14.604975,3.2515 C14.763175,3.3642 14.904575,3.4664 15.028475,3.5497 C15.351875,3.7667 15.785175,3.6799 16.000075,3.3593 C16.215675,3.038 16.130275,2.6033 15.809675,2.3877 C15.695575,2.3114 15.566075,2.2183 15.422575,2.1147 C14.394275,1.3755 12.481875,0 9.800175,0 C7.220675,0 5.398575,1.3195 4.308675,2.1077 C4.160975,2.2148 4.027275,2.3121 3.907575,2.3933 C3.587675,2.6103 3.504375,3.0457 3.721375,3.3656 C3.857175,3.5651 4.076975,3.6722 4.300975,3.6722 Z', id: 'Shape' })))));
};
var EyesCloseIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(EyesCloseIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 18585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EyesOpenIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var EyesOpenIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? '#666666' : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/icon-forms/icon-eye-open', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-eye-(5)', transform: 'translate(2.000000, 5.000000)', fill: color, fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10.5,0 C4.2571921,0 0.224691691,6.447826 0.151757816,6.5652342 C0.0535873741,6.68889382 0,6.8421104 0,7 C0,7.13544939 0.0395429981,7.26795363 0.113476566,7.3814454 C0.114383206,7.3828157 0.115294667,7.38418281 0.116210934,7.3855467 C0.128246496,7.4103827 3.51318191,14 10.5,14 C17.4571754,14 20.8371282,7.4751187 20.8783204,7.3951171 C20.8811066,7.39059116 20.8838413,7.38603363 20.8865237,7.3814454 C20.9604572,7.2679536 21,7.13544937 21,7 C21,6.84274207 20.9469987,6.69007331 20.8496092,6.5666013 C20.8491541,6.56614497 20.8486984,6.56568927 20.8482421,6.5652342 C20.7753084,6.447826 16.7428079,0 10.5,0 Z M10.5,2.1 C13.2062,2.1 15.4,4.2938 15.4,7 C15.4,9.7062 13.2062,11.9 10.5,11.9 C7.7938,11.9 5.6,9.7062 5.6,7 C5.6,4.2938 7.7938,2.1 10.5,2.1 Z M10.5,4.9 C9.34020203,4.9 8.4,5.84020203 8.4,7 C8.4,8.15979797 9.34020203,9.1 10.5,9.1 C11.659798,9.1 12.6,8.15979797 12.6,7 C12.6,5.84020203 11.659798,4.9 10.5,4.9 Z', id: 'Shape' })))));
};
var EyesOpenIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(EyesOpenIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 66887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FacebookIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var FacebookIcon = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10.3333 22.4V12.4H7V9.06669H10.3333V7.27669C10.3333 3.88752 11.9842 2.40002 14.8008 2.40002C16.15 2.40002 16.8633 2.50002 17.2008 2.54586V5.73336H15.28C14.0842 5.73336 13.6667 6.36419 13.6667 7.64252V9.06669H17.1708L16.695 12.4H13.6667V22.4H10.3333Z', fill: '#888' })));
};
var FacebookIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(FacebookIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 82999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var HealthcarePlanIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-healthcare-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-medical-doctor-100', transform: 'translate(10.000000, 9.000000)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M13.8,0 C9.178125,0 8.3390628,1.303125 8.19375,1.70625 C8.1773436,1.7507814 8.1609378,1.809375 8.15625,1.85625 L7.4625,7.96875 C8.38125,7.5679686 9.6398436,7.6195314 11.26875,7.70625 C12.0257814,7.7460936 12.8835936,7.8 13.8,7.8 C14.7140628,7.8 15.5742186,7.7460936 16.33125,7.70625 C17.9578128,7.6195314 19.21875,7.5679686 20.1375,7.96875 L19.44375,1.85625 C19.4390628,1.809375 19.4226564,1.7507814 19.40625,1.70625 C19.2609378,1.303125 18.4195314,0 13.8,0 Z M13.2,2.4 L14.4,2.4 L14.4,4.2 L16.2,4.2 L16.2,5.4 L14.4,5.4 L14.4,7.2 L13.2,7.2 L13.2,5.4 L11.4,5.4 L11.4,4.2 L13.2,4.2 L13.2,2.4 Z M9.99375,8.85 C8.86875,8.8171878 8.00625,8.8898436 7.59375,9.28125 C7.3242186,9.5390628 7.2,9.9984378 7.2,10.6875 C7.2,14.3273436 10.1601564,17.2875 13.8,17.2875 C17.4398436,17.2875 20.4,14.3273436 20.4,10.6875 C20.4,9.9984378 20.2757814,9.5390628 20.00625,9.28125 C19.4578128,8.7609378 18.0960936,8.8171878 16.3875,8.90625 C15.6164064,8.9460936 14.746875,9 13.8,9 C12.853125,9 11.9835936,8.9460936 11.2125,8.90625 C10.7859378,8.8828128 10.36875,8.8617186 9.99375,8.85 Z M13.8,17.8875 C12.4546878,17.8875 11.1164064,18.009375 9.84375,18.24375 L13.8,27.84375 L17.8125,18.2625 C16.51875,18.01875 15.16875,17.8875 13.8,17.8875 Z M8.6625,18.50625 C3.7804686,19.6921878 0,22.4085936 0,25.25625 L0,30 L13.8,30 C13.5585936,30 13.3289064,29.85 13.2375,29.625 L8.6625,18.50625 Z M13.8,30 L27.6,30 L27.6,25.25625 C27.6,22.4226564 23.8617186,19.7015628 19.0125,18.50625 L14.3625,29.625 C14.26875,29.8476564 14.0414064,30 13.8,30 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(HealthcarePlanIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HideIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var HideIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#333333' : _b, _c = _a.width, width = _c === void 0 ? 16 : _c, _d = _a.height, height = _d === void 0 ? 16 : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M0.910417 0.15625L0.15625 0.910417L15.0896 15.8438L15.8438 15.0896L12.6302 11.876C14.8146 10.397 15.8929 8.32887 15.9073 8.30104C15.9678 8.21232 16.0001 8.10739 16 8C15.9999 7.8797 15.9592 7.76297 15.8844 7.66875C15.8288 7.5793 12.7564 2.66667 8 2.66667C6.65059 2.66667 5.43964 3.06677 4.39167 3.6375L0.910417 0.15625ZM8 4.26667C10.0619 4.26667 11.7333 5.93813 11.7333 8C11.7333 8.83838 11.4507 9.60685 10.9833 10.2292L9.83438 9.08021C10.0229 8.76379 10.1333 8.39558 10.1333 8C10.1333 6.82187 9.17813 5.86667 8 5.86667C7.60442 5.86667 7.23621 5.97707 6.91979 6.16563L5.77083 5.01667C6.39315 4.54931 7.16162 4.26667 8 4.26667ZM2.64063 4.84063C1.05555 6.17393 0.146656 7.61975 0.116667 7.66771C0.0412742 7.76207 0.000141568 7.87922 0 8C0.000105292 8.10448 0.0308933 8.20662 0.0885417 8.29375C0.0977116 8.31267 2.67671 13.3333 8 13.3333C8.98667 13.3333 9.87762 13.1592 10.6771 12.8781L9.29688 11.4969C8.89208 11.6473 8.45653 11.7333 8 11.7333C5.93813 11.7333 4.26667 10.0619 4.26667 8C4.26667 7.54347 4.35273 7.10793 4.50313 6.70313L2.64063 4.84063ZM5.87292 8.05938C5.90492 9.18844 6.81052 10.0951 7.93958 10.1271L5.87292 8.05938Z', fill: color })));
};
var HideIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(HideIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 21835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var KindergartenIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-kindergarden-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-mother-100-2', transform: 'translate(8.000000, 8.108492)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M7.64898345,0 C5.53378943,0 3.8040861,1.72970333 3.8040861,3.84489735 C3.8040861,5.96009137 5.53378943,7.6897947 7.64898345,7.6897947 C9.76417747,7.6897947 11.4938808,5.96009137 11.4938808,3.84489735 C11.4938808,1.72970333 9.76417747,0 7.64898345,0 Z M5.98686637,8.33061092 C3.99933512,8.33061092 3.10820005,9.48458061 2.72270872,10.8938758 C2.72270872,10.8938758 0.159443824,18.8389961 0.159443824,18.9040786 C-0.160964289,19.8002204 -0.0758558838,20.7664508 1.14069367,20.7664508 C1.84659311,20.7664508 2.0293257,20.3684437 2.22207105,19.985456 L4.3648003,13.9577784 C4.369807,13.9402559 4.37731608,13.9327468 4.38482581,13.9177274 L4.38482581,13.8977019 C4.4373926,13.7925683 4.54002381,13.7174723 4.66518291,13.7174723 C4.84290944,13.7174723 4.98559102,13.8601539 4.98559102,14.0378804 C4.98559102,14.0629126 4.97057221,14.0929509 4.96556551,14.1179825 L1.92168844,22.8090525 C1.85660586,23.0017979 1.90917266,23.1970469 2.00179047,23.3897922 C2.12945324,23.5825376 2.30717977,23.7102003 2.56250467,23.7102003 L12.7354622,23.7102003 C12.9907878,23.7102003 13.1885392,23.5825376 13.3162019,23.3897922 C13.4088198,23.1970469 13.4413617,23.0017979 13.3762785,22.8090525 L10.3524269,14.1179825 C10.3474208,14.0929509 10.3324014,14.0829381 10.3324014,14.0579059 C10.3324014,13.8801794 10.475083,13.7374978 10.6528095,13.7374978 C10.7779692,13.7374978 10.8805998,13.7925683 10.9331666,13.8977019 L10.9331666,13.9177274 C10.9406763,13.9327468 10.9481861,13.9402559 10.9531921,13.9577784 L13.0758959,19.985456 C13.2686412,20.3709473 13.4713999,20.7664508 14.1772987,20.7664508 C15.3963516,20.7664508 15.4789567,19.8002204 15.1585486,18.9040786 C15.1585486,18.8389961 12.5952837,10.8938758 12.5952837,10.8938758 C12.209793,9.48458061 11.3186579,8.33061092 9.33112604,8.33061092 L5.98686637,8.33061092 Z M25.2313786,12.1554828 C25.0186078,12.1755083 24.848391,12.303171 24.7507665,12.4959164 L22.007272,17.9428543 L31.7396684,17.9428543 C30.9711894,15.2519266 28.6131863,13.0090698 25.4716847,12.1755083 C25.3915827,12.1604895 25.3014679,12.147973 25.2313786,12.1554828 Z M15.9795944,19.2244867 C15.5941037,19.2244867 15.3387782,19.4798123 15.3387782,19.865303 C15.3387782,22.3084148 16.5853663,24.4811823 18.5228338,25.8929806 C17.3913926,26.3836055 16.6204106,27.5075369 16.6204106,28.8367301 C16.6204106,30.631516 18.0297058,32.0408112 19.8244917,32.0408112 C21.6192776,32.0408112 23.0285729,30.631516 23.0285729,28.8367301 C23.0285729,28.3611247 22.9259423,27.9180598 22.7482158,27.5150467 C23.0485984,27.5450849 23.3614967,27.5550977 23.6693891,27.5550977 C24.2250972,27.5550977 24.7657859,27.4900151 25.2914551,27.3948936 C25.0761813,27.827945 24.9510215,28.3135639 24.9510215,28.8367301 C24.9510215,30.631516 26.3603167,32.0408112 28.1551027,32.0408112 C29.9498886,32.0408112 31.3591838,30.631516 31.3591838,28.8367301 C31.3591838,27.3423268 30.380437,26.1207709 29.0161995,25.752802 C30.8410236,24.3385008 32,22.2258098 32,19.865303 C32,19.4798123 31.7446751,19.2244867 31.3591838,19.2244867 L15.9795944,19.2244867 Z M4.44490233,24.3510165 L4.44490233,30.7591788 C4.44490233,31.4650782 5.02063598,32.0408112 5.72653478,32.0408112 C6.43243422,32.0408112 7.00816723,31.4650782 7.00816723,30.7591788 L7.00816723,24.3510165 L4.44490233,24.3510165 Z M7.64898345,24.3510165 L7.64898345,30.7591788 C7.64898345,31.4650782 8.2247171,32.0408112 8.9306159,32.0408112 C9.63651535,32.0408112 10.2122484,31.4650782 10.2122484,30.7591788 L10.2122484,24.3510165 L7.64898345,24.3510165 Z M19.8244917,26.9142814 C20.9133788,26.9142814 21.7469404,27.747843 21.7469404,28.8367301 C21.7469404,29.9256172 20.9133788,30.7591788 19.8244917,30.7591788 C18.7356046,30.7591788 17.9020431,29.9256172 17.9020431,28.8367301 C17.9020431,27.747843 18.7356046,26.9142814 19.8244917,26.9142814 Z M28.1551027,26.9142814 C29.2439898,26.9142814 30.0775513,27.747843 30.0775513,28.8367301 C30.0775513,29.9256172 29.2439898,30.7591788 28.1551027,30.7591788 C27.0662155,30.7591788 26.232654,29.9256172 26.232654,28.8367301 C26.232654,27.747843 27.0662155,26.9142814 28.1551027,26.9142814 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(KindergartenIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 66074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LaptopIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-laptop-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-macbook-100-2', transform: 'translate(8.000000, 12.059816)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M1.92,-5.68434189e-16 C1.5665524,-5.68434189e-16 1.28003534,0.286552399 1.28,0.64 L1.28,19.2 L0.64,19.2 C0.286552399,19.2000353 0,19.4865524 0,19.84 L0,21.12 C0,22.0531008 0.453611622,22.7654157 0.992499968,23.1575002 C1.53138842,23.549584 2.10457779,23.68 2.56,23.68 L29.44,23.68 C30.1313274,23.68 30.7906106,23.5660678 31.2912499,23.1150003 C31.7918899,22.6639322 32,21.9644026 32,21.12 L32,19.84 C32,19.4865524 31.7134476,19.2000353 31.36,19.2 L30.72,19.2 L30.72,0.64 C30.7199647,0.286552399 30.4334476,-5.68434189e-16 30.08,-5.68434189e-16 L1.92,-5.68434189e-16 Z M17.5412499,6.4 C17.6052499,6.912 17.4135002,7.42374976 17.1575002,7.74374976 C16.8375002,8.12774976 16.3895002,8.38374976 15.8775002,8.38374976 C15.7495002,7.93574976 15.9412499,7.48774976 16.2612499,7.10374976 C16.5812499,6.71974976 17.0932499,6.464 17.5412499,6.4 Z M14.5337498,8.38374976 C15.1737498,8.38374976 15.6217498,8.76750016 16.1337498,8.76750016 C16.6457498,8.76750016 16.9657498,8.38374976 17.7337498,8.38374976 C18.3097498,8.38374976 18.8857498,8.70425024 19.3337498,9.21625024 C17.9257498,9.98425024 18.182,11.9677498 19.59,12.5437498 C19.334,12.9917498 19.2057498,13.1835002 19.0137498,13.5675002 C18.6297498,14.0795002 18.1172499,14.7837498 17.5412499,14.7837498 C16.9652499,14.7837498 16.8377498,14.3997498 16.1337498,14.4637498 C15.3657498,14.4637498 15.2372499,14.8477498 14.6612499,14.7837498 C14.0212499,14.7837498 13.5737498,14.2084998 13.2537498,13.6324998 C12.2937498,12.1604998 12.1662502,10.3675002 12.8062502,9.40750016 C13.2542502,8.76750016 13.8937498,8.38374976 14.5337498,8.38374976 Z M1.28,20.48 L11.52,20.48 C11.5200353,20.8334476 11.8065524,21.1199647 12.16,21.12 L19.84,21.12 C20.1934476,21.1199647 20.4799647,20.8334476 20.48,20.48 L30.08,20.48 L30.72,20.48 L30.72,21.12 C30.72,21.7687174 30.5855603,22.0293478 30.4350003,22.1649997 C30.2844397,22.3006522 29.9838726,22.4 29.44,22.4 L2.56,22.4 C2.40102221,22.4 2.0137616,22.317136 1.74624998,22.1224998 C1.47873843,21.9278643 1.28,21.6800192 1.28,21.12 L1.28,20.48 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(LaptopIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 51785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LibraryIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-library-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            ' ',
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-open-book-100-2', transform: 'translate(8.000000, 9.130231)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M2.7826087,0 L2.7826087,2.7826087 L0,2.7826087 L0,27.1304348 L0.695652174,27.1304348 C9.47010852,27.1304348 15.657609,29.826087 15.7173913,29.8532612 L16,29.9782609 L16.2826087,29.8532612 C16.3423917,29.826087 22.5298915,27.1304348 31.3043478,27.1304348 L32,27.1304348 L32,2.7826087 L29.2173913,2.7826087 L29.2173913,0 L28.5217391,0 C21.6766303,0 16.4456522,2.51902191 16,2.73913043 C15.5543478,2.51902191 10.3233697,0 3.47826087,0 L2.7826087,0 Z M4.17391304,1.45380452 C9.91032626,1.616848 14.366848,3.51086957 15.3043478,3.93478261 L15.3043478,25.3940216 C13.8233697,24.7554351 9.66032626,23.1657607 4.17391304,23.0190219 L4.17391304,1.45380452 Z M27.826087,1.45380452 L27.826087,23.0190219 C22.3396737,23.1657607 18.1766303,24.7554351 16.6956522,25.3940216 L16.6956522,3.93478261 C17.633152,3.51086957 22.0896737,1.616848 27.826087,1.45380452 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(LibraryIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkedInIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LinkedInIcon = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M7.1157 21.1091H3V8.76198H7.1157V21.1091ZM5.05867 7.1157C3.92027 7.1157 3 6.19296 3 5.05703C3 3.92109 3.92192 3 5.05867 3C6.19296 3 7.1157 3.92274 7.1157 5.05703C7.1157 6.19296 6.19296 7.1157 5.05867 7.1157ZM21.9322 21.1091H17.9754V15.1002C17.9754 13.6671 17.9482 11.8241 15.9184 11.8241C13.858 11.8241 13.5411 13.3847 13.5411 14.9964V21.1091H9.58512V8.75293H13.3831V10.4412H13.4366C13.9651 9.46988 15.2566 8.4459 17.1827 8.4459C21.1914 8.4459 21.9322 11.005 21.9322 14.3322V21.1091Z', fill: '#888' })));
};
var LinkedInIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(LinkedInIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 50293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LoadingIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.bgColor, bgColor = _c === void 0 ? '#FF7D55' : _c, _d = props.durationTime, durationTime = _d === void 0 ? 0.8 : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { version: '1.1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', width: width, height: height, viewBox: '0 0 24 30' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: '0', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0s', dur: durationTime, repeatCount: 'indefinite' })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: '8', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: '16', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' }))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 29082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MailAddIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';




var MailAddIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.bgColor, bgColor = _c === void 0 ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.green[50] */ .O9.green[50] : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M11.9977 0.808594C11.3363 0.808594 10.6747 1.02086 10.1227 1.44766L2.03516 7.69609L6.39766 11.1258V7.19922C6.39766 6.31522 7.11366 5.59922 7.99766 5.59922H15.9977C16.8817 5.59922 17.5977 6.31522 17.5977 7.19922V11.1258L21.9602 7.69609L13.8727 1.44766C13.3207 1.02086 12.6591 0.808594 11.9977 0.808594ZM11.9852 7.18828C11.7733 7.19159 11.5713 7.27884 11.4237 7.43088C11.276 7.58291 11.1948 7.78731 11.1977 7.99922V9.59922H9.59766C9.49165 9.59772 9.3864 9.6173 9.28802 9.65684C9.18965 9.69637 9.10011 9.75506 9.02461 9.82949C8.94912 9.90393 8.88917 9.99262 8.84825 10.0904C8.80733 10.1882 8.78626 10.2932 8.78626 10.3992C8.78626 10.5052 8.80733 10.6102 8.84825 10.708C8.88917 10.8058 8.94912 10.8945 9.02461 10.9689C9.10011 11.0434 9.18965 11.1021 9.28802 11.1416C9.3864 11.1811 9.49165 11.2007 9.59766 11.1992H11.1977V12.7992C11.1962 12.9052 11.2157 13.0105 11.2553 13.1089C11.2948 13.2072 11.3535 13.2968 11.4279 13.3723C11.5024 13.4478 11.5911 13.5077 11.6889 13.5486C11.7867 13.5895 11.8916 13.6106 11.9977 13.6106C12.1037 13.6106 12.2086 13.5895 12.3064 13.5486C12.4043 13.5077 12.4929 13.4478 12.5674 13.3723C12.6418 13.2968 12.7005 13.2072 12.74 13.1089C12.7796 13.0105 12.7992 12.9052 12.7977 12.7992V11.1992H14.3977C14.5037 11.2007 14.6089 11.1811 14.7073 11.1416C14.8057 11.1021 14.8952 11.0434 14.9707 10.9689C15.0462 10.8945 15.1061 10.8058 15.1471 10.708C15.188 10.6102 15.209 10.5052 15.209 10.3992C15.209 10.2932 15.188 10.1882 15.1471 10.0904C15.1061 9.99262 15.0462 9.90393 14.9707 9.82949C14.8952 9.75506 14.8057 9.69637 14.7073 9.65684C14.6089 9.6173 14.5037 9.59772 14.3977 9.59922H12.7977V7.99922C12.7991 7.89219 12.7791 7.78595 12.7388 7.6868C12.6984 7.58765 12.6386 7.49759 12.5628 7.42198C12.4871 7.34636 12.3969 7.28672 12.2977 7.24657C12.1985 7.20643 12.0922 7.18661 11.9852 7.18828ZM1.59766 9.38828V18.868L6.90547 13.5586L1.59766 9.38828ZM22.3977 9.38828L17.0898 13.5602L22.3977 18.868V9.38828ZM8.17266 14.5539L1.92891 20.7992H22.0664L15.8227 14.5555L13.7273 16.2008C13.2177 16.6008 12.6081 16.8008 11.9977 16.8008C11.3873 16.8008 10.7768 16.6008 10.268 16.2008L8.17266 14.5539Z', fill: bgColor })));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var MobileIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-mobile-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-phonelink-ring-100-2', transform: 'translate(9.000000, 8.000000)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M2.18181818,0 C0.985795636,0 0,0.985795636 0,2.18181818 L0,29.8181818 C0,31.0142044 0.985795636,32 2.18181818,32 L16.7272727,32 C17.9232953,32 18.9090909,31.0142044 18.9090909,29.8181818 L18.9090909,2.18181818 C18.9090909,0.985795636 17.9232953,0 16.7272727,0 L2.18181818,0 Z M1.45454545,5.09090909 L17.4545455,5.09090909 L17.4545455,26.1818182 L1.45454545,26.1818182 L1.45454545,5.09090909 Z M25.1903411,6.80965891 L24.1590909,7.84090909 C26.2869316,9.77272727 27.6363636,12.5426138 27.6363636,15.6363636 C27.6363636,18.5426138 26.448864,21.1761367 24.5397731,23.0852276 L25.5596589,24.1051135 C27.7357956,21.9346589 29.0909091,18.9460225 29.0909091,15.6363636 C29.0909091,12.1420458 27.5795455,9.00568218 25.1903411,6.80965891 Z M22.1051135,9.89488655 L21.0681818,10.9318182 C22.4119316,12.0625004 23.2727273,13.7471593 23.2727273,15.6363636 C23.2727273,17.3409091 22.5681818,18.875 21.448864,19.9943185 L22.4772727,21.0227273 C23.8607956,19.6420458 24.7272727,17.7414771 24.7272727,15.6363636 C24.7272727,13.3465913 23.7073862,11.2954545 22.1051135,9.89488655 Z M7.27272727,28.3636364 L11.6363636,28.3636364 C12.0369316,28.3636364 12.3636364,28.6903411 12.3636364,29.0909091 C12.3636364,29.4914771 12.0369316,29.8181818 11.6363636,29.8181818 L7.27272727,29.8181818 C6.87215927,29.8181818 6.54545455,29.4914771 6.54545455,29.0909091 C6.54545455,28.6903411 6.87215927,28.3636364 7.27272727,28.3636364 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(MobileIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 62095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var PaidLeaveIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-paidleave-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-receipt-terminal-100', transform: 'translate(10.000000, 8.000000)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M5.06384592,0.000472694281 C4.67278398,0.015032275 4.3633401,0.336401861 4.36357191,0.727734679 L4.36357191,16.7274983 L2.88774142,16.7274983 C1.28340148,16.7274983 0,18.0322063 0,19.6365463 L0,31.272738 C0,31.6749139 0.303779585,32 0.705955463,32 L3.61500333,32 L3.61500333,30.545476 C3.61500333,30.1440274 3.9408167,29.818214 4.34226531,29.818214 L8.70583722,29.818214 C9.10728583,29.818214 9.4330992,30.1440274 9.4330992,30.545476 L9.4330992,32 L10.8876232,32 L10.8876232,30.545476 C10.8876232,30.1440274 11.2134365,29.818214 11.6148852,29.818214 L15.9784571,29.818214 C16.3799057,29.818214 16.705719,30.1440274 16.705719,30.545476 L16.705719,32 L18.160243,32 L18.160243,30.545476 C18.160243,30.1440274 18.4860564,29.818214 18.887505,29.818214 L23.2510769,29.818214 C23.6525255,29.818214 23.9783389,30.1440274 23.9783389,30.545476 L23.9783389,32 L26.8873868,32 C27.2895627,32 27.6146488,31.6749139 27.6146488,31.272738 L27.6146488,19.6365463 C27.6146488,18.0322063 26.3099408,16.7274983 24.7056009,16.7274983 L23.2723835,16.7274983 L23.2723835,0.727734679 C23.2723755,0.475674198 23.1418641,0.241587198 22.9274534,0.109063483 C22.7130427,-0.0234602313 22.4453033,-0.0355254638 22.219842,0.077176143 L21.0905975,0.642508665 L19.9613531,0.077176143 C19.7565854,-0.0252099401 19.5155618,-0.0252099401 19.310794,0.077176143 L18.1815496,0.642508665 L17.0523052,0.077176143 C16.8475374,-0.0252099401 16.6065138,-0.0252099401 16.4017461,0.077176143 L15.2725017,0.642508665 L14.1432573,0.077176143 C13.9384895,-0.0252099401 13.6974659,-0.0252099401 13.4926981,0.077176143 L12.3634537,0.642508665 L11.2342093,0.077176143 C11.0294416,-0.0252099401 10.788418,-0.0252099401 10.5836502,0.077176143 L9.45440579,0.642508665 L8.32516139,0.077176143 C8.12039362,-0.0252099401 7.87937004,-0.0252099401 7.67460227,0.077176143 L6.54535786,0.642508665 L5.41611345,0.077176143 C5.30698874,0.022450629 5.18584479,-0.00392750187 5.06384592,0.000472694281 Z M7.99988183,1.54022268 L9.12912624,2.1055552 C9.33389401,2.20794128 9.57491758,2.20794128 9.77968535,2.1055552 L10.9089298,1.54022268 L12.0381742,2.1055552 C12.2429419,2.20794128 12.4839655,2.20794128 12.6887333,2.1055552 L13.8179777,1.54022268 L14.9472221,2.1055552 C15.1519899,2.20794128 15.3930135,2.20794128 15.5977812,2.1055552 L16.7270256,1.54022268 L17.85627,2.1055552 C18.0610378,2.20794128 18.3020614,2.20794128 18.5068292,2.1055552 L19.6360736,1.54022268 L20.765318,2.1055552 C20.9700858,2.20794128 21.2111093,2.20794128 21.4158771,2.1055552 L21.8178595,1.90385367 L21.8178595,22.5455942 L5.81809587,22.5455942 L5.81809587,1.90385367 L6.2200783,2.1055552 C6.42484607,2.20794128 6.66586965,2.20794128 6.87063742,2.1055552 L7.99988183,1.54022268 Z M13.0907157,5.09130658 L13.0907157,6.70633945 C11.9271213,6.89558029 11.0622286,7.37797171 10.6646148,7.98473002 C10.1791565,8.72554017 10.1816678,9.49322992 10.1816678,9.49322992 C10.1816678,10.5325535 10.8063851,11.3347198 11.5438637,11.800014 C12.2813415,12.2653082 13.1427266,12.5217154 13.9557597,12.7872154 C14.7687927,13.0527163 15.5295321,13.3265457 16.0153881,13.6650432 C16.5012442,14.0035415 16.7270256,14.3023036 16.7270256,14.9420134 C16.7270256,14.9420134 16.729862,15.329743 16.4102689,15.7715466 C16.0906772,16.2133503 15.4685715,16.7274983 13.8179777,16.7274983 C12.1937595,16.7274983 11.5917233,16.1577766 11.2526745,15.6152988 C10.9136257,15.072821 10.9089298,14.5457124 10.9089298,14.5457124 L9.45440454,14.5457124 C9.45440454,14.5457124 9.44967859,15.4731278 10.0197385,16.3851739 C10.5048208,17.1613057 11.5774639,17.8077369 13.0907157,18.0158313 L13.0907157,19.6365463 L14.5452397,19.6365463 L14.5452397,18.0385582 C16.0322308,17.8611136 17.0887374,17.315686 17.5892289,16.6238068 C18.1787147,15.8089017 18.1815496,14.9420134 18.1815496,14.9420134 C18.1815496,13.8453853 17.5891613,12.9884147 16.8477628,12.4718797 C16.1063643,11.9553441 15.2307641,11.673989 14.4074577,11.405134 C13.5841513,11.1362784 12.809197,10.8789316 12.3194202,10.5699187 C11.8296442,10.2609066 11.6361917,10.0287929 11.6361917,9.49322992 C11.6361917,9.49322992 11.6387372,9.1505848 11.8805067,8.78159316 C12.1223097,8.41260152 12.5484205,8.00035452 13.8179777,8.00035452 C15.0906862,8.00035452 15.518786,8.40813177 15.7582901,8.76738901 C15.9977942,9.12664407 15.9997637,9.45487849 15.9997637,9.45487849 L17.4542876,9.45487849 C17.4542876,9.45487849 17.4562512,8.69221994 16.9684992,7.96058202 C16.569188,7.36161632 15.7056931,6.88923203 14.5452397,6.70349877 L14.5452397,5.09130658 L13.0907157,5.09130658 Z M4.34226531,19.6365463 L4.36357191,19.6365463 L4.36357191,22.5455942 L4.34226531,22.5455942 C3.53864082,22.5455942 2.88774142,21.8946947 2.88774142,21.0910702 C2.88774142,20.2874457 3.53864082,19.6365463 4.34226531,19.6365463 Z M23.2723835,19.639387 C24.0659143,19.6510682 24.7056009,20.2947482 24.7056009,21.0910702 C24.7056009,21.8873923 24.0659143,22.5310722 23.2723835,22.5427535 L23.2723835,19.639387 Z M4.34226531,25.4546421 L8.70583722,25.4546421 C9.10728583,25.4546421 9.4330992,25.7804555 9.4330992,26.1819041 L9.4330992,27.6364281 C9.4330992,28.0378767 9.10728583,28.3636901 8.70583722,28.3636901 L4.34226531,28.3636901 C3.94008943,28.3636901 3.61500333,28.0378767 3.61500333,27.6364281 L3.61500333,26.1819041 C3.61500333,25.7804555 3.9408167,25.4546421 4.34226531,25.4546421 Z M11.6148852,25.4546421 L15.9784571,25.4546421 C16.3799057,25.4546421 16.705719,25.7804555 16.705719,26.1819041 L16.705719,27.6364281 C16.705719,28.0378767 16.3799057,28.3636901 15.9784571,28.3636901 L11.6148852,28.3636901 C11.2134365,28.3636901 10.8876232,28.0378767 10.8876232,27.6364281 L10.8876232,26.1819041 C10.8876232,25.7804555 11.2134365,25.4546421 11.6148852,25.4546421 Z M18.887505,25.4546421 L23.2510769,25.4546421 C23.6525255,25.4546421 23.9783389,25.7804555 23.9783389,26.1819041 L23.9783389,27.6364281 C23.9783389,28.0378767 23.6525255,28.3636901 23.2510769,28.3636901 L18.887505,28.3636901 C18.4860564,28.3636901 18.160243,28.0378767 18.160243,27.6364281 L18.160243,26.1819041 C18.160243,25.7804555 18.4860564,25.4546421 18.887505,25.4546421 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(PaidLeaveIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 60819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlusIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';




function PlusIcon(_a) {
    var _b = _a.fill, fill = _b === void 0 ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[40] */ .O9.primary[40] : _b, _c = _a.size, size = _c === void 0 ? 12 : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { className: 'mr-1', width: size, height: size, viewBox: '0 0 14 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M6.66812 0.0209872C6.38827 0.0250885 6.12149 0.140123 5.92641 0.340814C5.73132 0.541504 5.62389 0.811434 5.62772 1.09129V5.31476H1.40425C1.26433 5.31278 1.12542 5.33863 0.995583 5.39081C0.865745 5.44298 0.747571 5.52044 0.647929 5.61868C0.548287 5.71693 0.469165 5.83399 0.41516 5.96308C0.361154 6.09217 0.333344 6.2307 0.333344 6.37063C0.333344 6.51056 0.361154 6.64909 0.41516 6.77818C0.469165 6.90727 0.548287 7.02433 0.647929 7.12258C0.747571 7.22082 0.865745 7.29828 0.995583 7.35045C1.12542 7.40263 1.26433 7.42848 1.40425 7.4265H5.62772V11.65C5.62574 11.7899 5.65159 11.9288 5.70377 12.0586C5.75594 12.1885 5.8334 12.3066 5.93164 12.4063C6.02989 12.5059 6.14695 12.5851 6.27604 12.6391C6.40513 12.6931 6.54366 12.7209 6.68359 12.7209C6.82352 12.7209 6.96205 12.6931 7.09114 12.6391C7.22023 12.5851 7.33729 12.5059 7.43554 12.4063C7.53378 12.3066 7.61124 12.1885 7.66341 12.0586C7.71559 11.9288 7.74144 11.7899 7.73946 11.65V7.4265H11.9629C12.1028 7.42848 12.2418 7.40263 12.3716 7.35045C12.5014 7.29828 12.6196 7.22082 12.7192 7.12258C12.8189 7.02433 12.898 6.90727 12.952 6.77818C13.006 6.64909 13.0338 6.51056 13.0338 6.37063C13.0338 6.2307 13.006 6.09217 12.952 5.96308C12.898 5.83399 12.8189 5.71693 12.7192 5.61868C12.6196 5.52044 12.5014 5.44298 12.3716 5.39081C12.2418 5.33863 12.1028 5.31278 11.9629 5.31476H7.73946V1.09129C7.74139 0.950115 7.71499 0.809985 7.66182 0.67919C7.60865 0.548395 7.52979 0.42959 7.42991 0.329802C7.33003 0.230014 7.21115 0.15127 7.0803 0.0982275C6.94945 0.0451846 6.8093 0.0189201 6.66812 0.0209872Z', fill: fill })));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 83112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoveFillIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var RemoveFillIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.fill, fill = _c === void 0 ? '#666' : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.onMouseOver, onMouseOver = _e === void 0 ? function () { } : _e, _f = _a.onMouseLeave, onMouseLeave = _f === void 0 ? function () { } : _f;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { className: className, onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM10.9427 10C10.9427 10 13.0353 12.0927 13.138 12.1953C13.3987 12.456 13.3987 12.878 13.138 13.138C12.8773 13.3987 12.4553 13.3987 12.1953 13.138C12.0927 13.036 10 10.9427 10 10.9427C10 10.9427 7.90733 13.0353 7.80467 13.138C7.544 13.3987 7.122 13.3987 6.862 13.138C6.60133 12.8773 6.60133 12.4553 6.862 12.1953C6.964 12.0927 9.05733 10 9.05733 10C9.05733 10 6.96467 7.90733 6.862 7.80467C6.60133 7.544 6.60133 7.122 6.862 6.862C7.12267 6.60133 7.54467 6.60133 7.80467 6.862C7.90733 6.964 10 9.05733 10 9.05733C10 9.05733 12.0927 6.96467 12.1953 6.862C12.456 6.60133 12.878 6.60133 13.138 6.862C13.3987 7.12267 13.3987 7.54467 13.138 7.80467C13.036 7.90733 10.9427 10 10.9427 10Z', fill: fill })));
};
var RemoveFillIcon$1 = /* #__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.memo(RemoveFillIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoveIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var RemoveIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 12 : _b, _c = _a.height, height = _c === void 0 ? 10 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.onMouseOver, onMouseOver = _f === void 0 ? function () { } : _f, _g = _a.onMouseLeave, onMouseLeave = _g === void 0 ? function () { } : _g;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 12 10', version: '1.1', onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', opacity: '0.5', strokeLinejoin: 'round' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'responsive/list/list-item-normal', transform: 'translate(-304.000000, -19.000000)', fill: 'black', fillRule: 'nonzero', stroke: 'black', strokeWidth: '0.2' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/nav/icon-close-outline/size-s', transform: 'translate(305.000000, 19.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { id: 'Path', points: '0.383973289 0 0 0.383973289 4.61602671 5 0 9.61602671 0.383973289 10 5 5.38397329 9.61602671 10 10 9.61602671 5.38397329 5 10 0.383973289 9.61602671 0 5 4.61602671' }))))));
};
var RemoveIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(RemoveIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 35425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReportIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var ReportIcon = function (_a) {
    var color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "16", height: "18", viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M1.18287 0.666757C0.999141 0.669629 0.824059 0.745277 0.696047 0.877098C0.568036 1.00892 0.497553 1.18615 0.500069 1.36988V16.6299C0.498769 16.7218 0.515751 16.8131 0.550026 16.8984C0.584301 16.9837 0.635187 17.0613 0.699726 17.1268C0.764265 17.1922 0.84117 17.2442 0.925972 17.2797C1.01077 17.3151 1.10178 17.3334 1.19371 17.3334C1.28563 17.3334 1.37664 17.3151 1.46144 17.2797C1.54624 17.2442 1.62315 17.1922 1.68769 17.1268C1.75223 17.0613 1.80311 16.9837 1.83739 16.8984C1.87166 16.8131 1.88864 16.7218 1.88734 16.6299V8.99989H8.13008C8.51297 8.99989 8.82372 8.68914 8.82372 8.30625V2.06351C8.82372 1.29705 8.20291 0.67624 7.43644 0.67624H1.30073C1.26179 0.66973 1.22235 0.666558 1.18287 0.666757ZM10.211 3.45079V8.99989C10.211 9.76636 9.59019 10.3872 8.82372 10.3872H5.35553V11.7744C5.35553 12.5409 5.97634 13.1617 6.74281 13.1617H15.7601L14.3728 8.30625L15.7601 3.45079H10.211Z", fill: color !== null && color !== void 0 ? color : '#888' })));
};
var ReportIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(ReportIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 6538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var SearchIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#333333' : _e, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f, _g = _a.onMouseOver, onMouseOver = _g === void 0 ? function () { } : _g, _h = _a.onMouseLeave, onMouseLeave = _h === void 0 ? function () { } : _h;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Search-Result-WithSkills', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Search-Result-Filter-Category', transform: 'translate(-277.000000, -242.000000)', fill: color },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Menu', transform: 'translate(253.000000, 217.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'modecule-/-form-/-desktop-/-dropdown-menu-/-searchbox', transform: 'translate(15.914286, 16.000000)' },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'atom-/-ic-/-Search-Thin', transform: 'translate(9.000000, 9.000000)' },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M7.13182811,0 C3.19719603,0 0,3.19719603 0,7.13182811 C0,11.0664602 3.19719603,14.2636562 7.13182811,14.2636562 C8.68863823,14.2636562 10.1274581,13.7621998 11.3008012,12.9133285 L16.820102,18.4195193 L18,17.2396213 L12.5462491,11.7727604 C13.61799,10.5240352 14.2636562,8.90331381 14.2636562,7.13182811 C14.2636562,3.19719603 11.0664602,0 7.13182811,0 Z M7.13182811,0.839038602 C10.6125273,0.839038602 13.4246176,3.65112891 13.4246176,7.13182811 C13.4246176,10.6125273 10.6125273,13.4246176 7.13182811,13.4246176 C3.65112891,13.4246176 0.839038602,10.6125273 0.839038602,7.13182811 C0.839038602,3.65112891 3.65112891,0.839038602 7.13182811,0.839038602 Z', id: 'Shape' }))))))));
};
var SearchIcon$1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(SearchIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 67468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShareIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var ShareIcon = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#clip0_341_10959)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M18 3.00012C17.2044 3.00012 16.4413 3.31619 15.8787 3.8788C15.3161 4.44141 15 5.20447 15 6.00012C15.0013 6.211 15.0249 6.42114 15.0703 6.62708L8.25879 10.0328C7.97785 9.7094 7.63091 9.44988 7.24128 9.27175C6.85166 9.09362 6.42841 9.001 6 9.00012C5.20435 9.00012 4.44129 9.31619 3.87868 9.8788C3.31607 10.4414 3 11.2045 3 12.0001C3 12.7958 3.31607 13.5588 3.87868 14.1214C4.44129 14.6841 5.20435 15.0001 6 15.0001C6.42854 14.9996 6.85201 14.9073 7.24189 14.7295C7.63178 14.5516 7.97902 14.2922 8.26025 13.9689L15.0674 17.3732C15.023 17.5792 15.0004 17.7894 15 18.0001C15 18.7958 15.3161 19.5588 15.8787 20.1214C16.4413 20.6841 17.2044 21.0001 18 21.0001C18.7956 21.0001 19.5587 20.6841 20.1213 20.1214C20.6839 19.5588 21 18.7958 21 18.0001C21 17.2045 20.6839 16.4414 20.1213 15.8788C19.5587 15.3162 18.7956 15.0001 18 15.0001C17.5715 15.0006 17.148 15.0929 16.7581 15.2708C16.3682 15.4487 16.021 15.708 15.7397 16.0314L8.93262 12.6271C8.97704 12.421 8.99963 12.2109 9 12.0001C8.99856 11.7897 8.97499 11.5801 8.92969 11.3746L15.7412 7.96887C16.0223 8.29204 16.3693 8.55128 16.7589 8.72916C17.1485 8.90704 17.5717 8.99943 18 9.00012C18.7956 9.00012 19.5587 8.68405 20.1213 8.12144C20.6839 7.55883 21 6.79577 21 6.00012C21 5.20447 20.6839 4.44141 20.1213 3.8788C19.5587 3.31619 18.7956 3.00012 18 3.00012Z', fill: '#888' })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'clip0_341_10959' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var ShareIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(ShareIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 22204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SortMobileIcon$1; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var SortMobileIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c; _a.color; var _d = _a.thickness, thickness = _d === void 0 ? 1 : _d, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["width", "height", "color", "thickness"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ width: width, height: height, viewBox: '0 0 16 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3.32281 0.657548C3.22163 0.659192 3.12215 0.683847 3.03191 0.729643C2.94167 0.77544 2.86304 0.841176 2.80197 0.921871L0.195203 3.52864C0.131221 3.59007 0.0801398 3.66365 0.0449505 3.74507C0.00976111 3.82649 -0.00882906 3.91411 -0.00973114 4.0028C-0.0106332 4.0915 0.00617092 4.17948 0.039697 4.2616C0.0732231 4.34372 0.122797 4.41832 0.185516 4.48104C0.248235 4.54376 0.322838 4.59333 0.404956 4.62686C0.487073 4.66038 0.575055 4.67719 0.663749 4.67628C0.752442 4.67538 0.840064 4.65679 0.921483 4.6216C1.0029 4.58641 1.07648 4.53533 1.13791 4.47135L2.66656 2.9427V9.33333C2.66531 9.42167 2.68163 9.50938 2.71457 9.59136C2.74751 9.67334 2.79642 9.74795 2.85845 9.81087C2.92048 9.87378 2.99439 9.92374 3.0759 9.95783C3.1574 9.99193 3.24487 10.0095 3.33322 10.0095C3.42157 10.0095 3.50904 9.99193 3.59055 9.95783C3.67205 9.92374 3.74597 9.87378 3.808 9.81087C3.87003 9.74795 3.91893 9.67334 3.95188 9.59136C3.98482 9.50938 4.00114 9.42167 3.99989 9.33333V2.9427L5.52854 4.47135C5.58997 4.53533 5.66355 4.58641 5.74496 4.6216C5.82638 4.65679 5.91401 4.67538 6.0027 4.67629C6.09139 4.67719 6.17938 4.66039 6.26149 4.62686C6.34361 4.59333 6.41821 4.54376 6.48093 4.48104C6.54365 4.41832 6.59323 4.34372 6.62675 4.2616C6.66028 4.17948 6.67708 4.0915 6.67618 4.00281C6.67528 3.91411 6.65669 3.82649 6.6215 3.74507C6.58631 3.66365 6.53523 3.59007 6.47124 3.52864L3.86057 0.917965C3.79737 0.835719 3.71585 0.769353 3.62249 0.724145C3.52914 0.678937 3.42652 0.656134 3.32281 0.657548ZM12.6666 0.666663C12.4897 0.666663 12.3202 0.736901 12.1952 0.861925C12.0701 0.986949 11.9999 1.15652 11.9999 1.33333C11.9999 1.51014 12.0701 1.67971 12.1952 1.80473C12.3202 1.92976 12.4897 2 12.6666 2C12.8434 2 13.0129 1.92976 13.138 1.80473C13.263 1.67971 13.3332 1.51014 13.3332 1.33333C13.3332 1.15652 13.263 0.986949 13.138 0.861925C13.0129 0.736901 12.8434 0.666663 12.6666 0.666663ZM12.6666 3.33333C12.4897 3.33333 12.3202 3.40357 12.1952 3.52859C12.0701 3.65362 11.9999 3.82319 11.9999 4C11.9999 4.17681 12.0701 4.34638 12.1952 4.4714C12.3202 4.59643 12.4897 4.66666 12.6666 4.66666C12.8434 4.66666 13.0129 4.59643 13.138 4.4714C13.263 4.34638 13.3332 4.17681 13.3332 4C13.3332 3.82319 13.263 3.65362 13.138 3.52859C13.0129 3.40357 12.8434 3.33333 12.6666 3.33333ZM12.6561 5.99088C12.4796 5.99364 12.3113 6.06635 12.1882 6.19305C12.0652 6.31974 11.9975 6.49008 11.9999 6.66666V13.0573L10.4712 11.5286C10.4091 11.4648 10.3348 11.414 10.2527 11.3794C10.1707 11.3447 10.0825 11.3268 9.99338 11.3268C9.86076 11.3269 9.73116 11.3664 9.62115 11.4405C9.51114 11.5146 9.42573 11.6198 9.37582 11.7427C9.32592 11.8655 9.31379 12.0005 9.341 12.1303C9.3682 12.2601 9.43349 12.3789 9.52853 12.4714L12.1366 15.0794C12.1987 15.1608 12.2786 15.2269 12.3703 15.2724C12.462 15.318 12.5629 15.3418 12.6653 15.342C12.7676 15.3423 12.8687 15.319 12.9606 15.2739C13.0525 15.2288 13.1328 15.1631 13.1952 15.082C13.1961 15.0807 13.1969 15.0794 13.1978 15.0781L15.8046 12.4714C15.8686 12.4099 15.9196 12.3363 15.9548 12.2549C15.99 12.1735 16.0086 12.0859 16.0095 11.9972C16.0104 11.9085 15.9936 11.8205 15.9601 11.7384C15.9266 11.6563 15.877 11.5817 15.8143 11.519C15.7516 11.4562 15.6769 11.4067 15.5948 11.3731C15.5127 11.3396 15.4247 11.3228 15.336 11.3237C15.2473 11.3246 15.1597 11.3432 15.0783 11.3784C14.9969 11.4136 14.9233 11.4647 14.8619 11.5286L13.3332 13.0573V6.66666C13.3344 6.57747 13.3178 6.48894 13.2841 6.40631C13.2505 6.32369 13.2007 6.24864 13.1375 6.18563C13.0744 6.12261 12.9993 6.07291 12.9166 6.03946C12.8339 6.00601 12.7453 5.98949 12.6561 5.99088ZM3.33322 11.3333C3.15641 11.3333 2.98684 11.4036 2.86182 11.5286C2.73679 11.6536 2.66656 11.8232 2.66656 12C2.66656 12.1768 2.73679 12.3464 2.86182 12.4714C2.98684 12.5964 3.15641 12.6667 3.33322 12.6667C3.51003 12.6667 3.6796 12.5964 3.80463 12.4714C3.92965 12.3464 3.99989 12.1768 3.99989 12C3.99989 11.8232 3.92965 11.6536 3.80463 11.5286C3.6796 11.4036 3.51003 11.3333 3.33322 11.3333ZM3.33322 14C3.15641 14 2.98684 14.0702 2.86182 14.1953C2.73679 14.3203 2.66656 14.4899 2.66656 14.6667C2.66656 14.8435 2.73679 15.013 2.86182 15.1381C2.98684 15.2631 3.15641 15.3333 3.33322 15.3333C3.51003 15.3333 3.6796 15.2631 3.80463 15.1381C3.92965 15.013 3.99989 14.8435 3.99989 14.6667C3.99989 14.4899 3.92965 14.3203 3.80463 14.1953C3.6796 14.0702 3.51003 14 3.33322 14Z", fill: "#333333", strokeWidth: thickness })));
};
var SortMobileIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(SortMobileIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 85658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



function SuccessIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? '#6FB920' : _b, _c = _a.width, width = _c === void 0 ? 48 : _c, _d = _a.height, height = _d === void 0 ? 49 : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 49', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M23.9998 5.30078C13.3966 5.30078 4.7998 13.8976 4.7998 24.5008C4.7998 35.104 13.3966 43.7008 23.9998 43.7008C34.603 43.7008 43.1998 35.104 43.1998 24.5008C43.1998 13.8976 34.603 5.30078 23.9998 5.30078ZM34.731 20.832L22.635 32.928C22.3342 33.2288 21.9278 33.3968 21.5038 33.3968C21.0798 33.3968 20.6718 33.2288 20.3726 32.928L14.8478 27.4032C14.2222 26.7776 14.2222 25.7664 14.8478 25.1408C15.4734 24.5152 16.4846 24.5152 17.1102 25.1408L21.5038 29.5344L32.4686 18.5696C33.0942 17.944 34.1054 17.944 34.731 18.5696C35.3566 19.1952 35.3566 20.2064 34.731 20.832Z', fill: color })));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 84485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var TeamActivitiesIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-activities-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-swimming-100', transform: 'translate(5.000000, 15.090025)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M17.104092,0 C16.7330963,0 16.3858443,0.112783128 16.0949832,0.296796704 L16.0860791,0.296796704 L7.17327464,4.74281172 L7.17327464,4.74874727 C6.53219376,5.05148029 6.08699833,5.7014645 6.08699833,6.45829629 C6.08699833,7.508957 6.93583728,8.3577952 7.98649723,8.3577952 C8.3040699,8.3577952 8.59789882,8.27172434 8.8620477,8.13519748 L8.86501548,8.14410157 L16.4066195,4.59144521 L18.8462888,8.54774509 L6.71917512,15.9320471 C3.18432694,14.872483 1.28482803,13.1184143 1.28482803,13.1184143 C1.13346152,12.9759519 0.934607536,12.9017529 0.726850223,12.910657 C0.41818165,12.9225289 0.148096459,13.1213821 0.0442174229,13.4122433 C-0.0596614617,13.7031037 0.0234416916,14.0295804 0.251975496,14.2343699 C0.251975496,14.2343699 4.63269485,18.2351895 12.1653948,18.2351895 C15.9050333,18.2351895 18.5376203,17.4397744 20.8051471,16.677007 C23.0697061,15.9112711 24.939525,15.1959913 27.3613861,15.1959913 C32.2021405,15.1959913 36.8262328,18.1164708 36.8262328,18.1164708 C37.1823889,18.3420363 37.651328,18.2411258 37.8798613,17.8879376 C38.1054268,17.5317815 38.0045163,17.0628423 37.651328,16.8343091 C37.651328,16.8343091 32.8016695,13.6763921 27.3613861,13.6763921 C26.7856009,13.6763921 26.2424627,13.7179441 25.7141642,13.783239 C25.7972673,13.5072182 25.841787,13.2163571 25.841787,12.9165926 C25.841787,12.3200314 25.6637089,11.7650214 25.3669122,11.2990507 L25.36988,11.2901466 L18.6830505,0.845870418 C18.3417341,0.335380086 17.7629811,0 17.104092,0 Z M30.4005844,3.79899782 C28.3022315,3.79899782 26.6015865,5.49964274 26.6015865,7.59799563 C26.6015865,9.69634852 28.3022315,11.3969935 30.4005844,11.3969935 C32.4989372,11.3969935 34.1995822,9.69634852 34.1995822,7.59799563 C34.1995822,5.49964274 32.4989372,3.79899782 30.4005844,3.79899782 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(TeamActivitiesIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 79229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThreeDotIcon$1; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var ThreeDotIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, rest = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["width", "height", "color"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, rest),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-more-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-ellipsis-100-2', transform: 'translate(8.000000, 20.020815)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M4.17391304,0 C1.86956522,0 0,1.86956522 0,4.17391304 C0,6.47826087 1.86956522,8.34782609 4.17391304,8.34782609 C6.47826087,8.34782609 8.34782609,6.47826087 8.34782609,4.17391304 C8.34782609,1.86956522 6.47826087,0 4.17391304,0 Z M16,0 C13.6956522,0 11.826087,1.86956522 11.826087,4.17391304 C11.826087,6.47826087 13.6956522,8.34782609 16,8.34782609 C18.3043478,8.34782609 20.173913,6.47826087 20.173913,4.17391304 C20.173913,1.86956522 18.3043478,0 16,0 Z M27.826087,0 C25.5217391,0 23.6521739,1.86956522 23.6521739,4.17391304 C23.6521739,6.47826087 25.5217391,8.34782609 27.826087,8.34782609 C30.1304348,8.34782609 32,6.47826087 32,4.17391304 C32,1.86956522 30.1304348,0 27.826087,0 Z', id: 'Shape' })))));
};
var ThreeDotIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(ThreeDotIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 97379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var TrainingIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-training-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-training-100-2', transform: 'translate(8.000000, 7.824247)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M6.95652174,0 C5.03804383,0 3.47826087,1.55978296 3.47826087,3.47826087 C3.47826087,5.39673948 5.03804383,6.95652174 6.95652174,6.95652174 C8.87500035,6.95652174 10.4347826,5.39673948 10.4347826,3.47826087 C10.4347826,1.55978296 8.87500035,0 6.95652174,0 Z M18.7826087,0 L18.7826087,1.39130435 L11.3478261,1.39130435 C11.6494567,2.02445635 11.826087,2.73097809 11.826087,3.47826087 C11.826087,4.51358678 11.5081523,5.47010852 10.9565217,6.26086957 L18.4347826,6.26086957 C20.1603263,6.26086957 21.5652174,7.6657607 21.5652174,9.39130435 C21.5652174,11.116848 20.1603263,12.5217391 18.4347826,12.5217391 L12.5217391,12.5217391 L12.5217391,22.2608696 L31.3043478,22.2608696 C31.6902177,22.2608696 32,21.9510873 32,21.5652174 L32,2.08695652 C32,1.70380452 31.6902177,1.39130435 31.3043478,1.39130435 L20.173913,1.39130435 L20.173913,0 L18.7826087,0 Z M3.82608696,7.65217391 C1.7173913,7.65217391 0,9.36956522 0,11.4782609 L0,20.8695652 C0,21.6385871 0.625000348,22.2608696 1.39130435,22.2608696 C2.15760904,22.2608696 2.7826087,21.6385871 2.7826087,20.8695652 L2.7826087,12.9130435 C2.7826087,12.7255437 2.94293496,12.5652174 3.13043478,12.5652174 C3.31793461,12.5652174 3.47826087,12.7255437 3.47826087,12.9130435 L3.47826087,30.1304348 C3.47826087,31.2173913 4.06250017,32 5.15217391,32 C6.18206539,32 6.95652174,31.2010873 6.95652174,30.1304348 L6.95652174,22.0434783 C6.95652174,21.8505433 7.11141287,21.6956522 7.30434783,21.6956522 C7.49728278,21.6956522 7.65217391,21.8505433 7.65217391,22.0434783 L7.65217391,30.326087 C7.65489113,30.3315221 7.67119583,30.3206525 7.67391304,30.326087 C7.76902191,31.2880438 8.49456557,32 9.45652174,32 C10.5434783,32 11.1304348,31.2173913 11.1304348,30.1304348 L11.1304348,11.1304348 L18.4347826,11.1304348 C19.3967395,11.1304348 20.173913,10.3532612 20.173913,9.39130435 C20.173913,8.42934817 19.3967395,7.65217391 18.4347826,7.65217391 L9.41304348,7.65217391 L6.95652174,12.5217391 L4.54347826,7.65217391 L3.82608696,7.65217391 Z M17.7391304,23.6521739 L14.6086957,29.9130435 L16,29.9130435 L19.1304348,23.6521739 L17.7391304,23.6521739 Z M19.826087,23.6521739 L22.9565217,29.9130435 L24.3478261,29.9130435 L21.2173913,23.6521739 L19.826087,23.6521739 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(TrainingIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 55007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var TransportationIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-car-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-car-100-2', transform: 'translate(8.000000, 12.354148)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M16,0 C11.6015627,0 9.994792,0.575520667 9.6875,0.708333333 C8.653646,1.059896 7.122396,1.58593733 6.45833333,2.875 C6.00781267,3.752604 3.04427067,11.6458333 2.70833333,12.5416667 L2.66666667,12.6666667 L2.66666667,20.6666667 C2.66666667,21.7682293 3.565104,22.6666667 4.66666667,22.6666667 L7.33333333,22.6666667 C8.434896,22.6666667 9.33333333,21.7682293 9.33333333,20.6666667 L9.33333333,20 L22.6666667,20 L22.6666667,20.6666667 C22.6666667,21.7682293 23.565104,22.6666667 24.6666667,22.6666667 L27.3333333,22.6666667 C28.434896,22.6666667 29.3333333,21.7682293 29.3333333,20.6666667 L29.3333333,12.6666667 L29.2916667,12.5416667 C29.221354,12.3541667 28.2734373,9.877604 27.3333333,7.45833333 C27.3229167,7.4375 27.3203127,7.41666667 27.3125,7.39583333 C26.53125,5.38541667 25.7656253,3.434896 25.5208333,2.875 C24.9609373,1.60677067 23.4192707,1.03125 22.2916667,0.708333333 C21.9453127,0.565104 20.3203127,0 16,0 Z M16,1.33333333 C20.3671873,1.33333333 21.7656253,1.934896 21.7708333,1.9375 L21.875,1.97916667 C22.377604,2.122396 23.9140627,2.557292 24.2916667,3.41666667 C24.5156253,3.92447933 25.2057293,5.69791667 25.9375,7.58333333 L26,7.70833333 C26.0104167,7.73437533 26.0078127,7.76041667 26.0208333,7.79166667 C26.0390627,7.838542 26.065104,7.89062533 26.0833333,7.9375 C26.247396,8.36718733 26.4270833,9.00781267 26.1666667,9.39583333 C25.8984373,9.79166667 25.1354167,10 24,10 L8,10 C6.86458333,10 6.057292,9.73177067 5.79166667,9.33333333 C5.47916667,8.869792 5.81770867,8.04166667 5.97916667,7.64583333 L6.04166667,7.52083333 C6.815104,5.502604 7.47916667,3.82291667 7.64583333,3.5 C8.07031267,2.67708333 9.315104,2.23958333 10.1458333,1.95833333 L10.2083333,1.9375 C10.221354,1.932292 11.6328127,1.33333333 16,1.33333333 Z M2.72916667,7.33333333 C0.713542,7.33333333 0,8.57291667 0,9.72916667 C0,10.2916667 0.252604,11.1979167 1.75,11.3125 C2.16927067,10.2005207 2.70833333,8.752604 3.25,7.33333333 L2.72916667,7.33333333 Z M28.7083333,7.33333333 C29.3125,8.89322933 29.908854,10.4270833 30.25,11.3125 C31.752604,11.2005207 32,10.2942707 32,9.72916667 C32,8.57291667 31.2864587,7.33333333 29.2708333,7.33333333 L28.7083333,7.33333333 Z M6.66666667,12.6666667 L9.33333333,12.6666667 C10.4375,12.6666667 11.3333333,13.5625 11.3333333,14.6666667 C11.3333333,15.7708333 10.4375,16.6666667 9.33333333,16.6666667 C8.216146,16.6666667 7.88541667,16.3828127 6.72916667,15.7291667 C5.95572933,15.2916667 5.33333333,14.872396 5.33333333,14 C5.33333333,13.2630207 5.92968733,12.6666667 6.66666667,12.6666667 Z M22.6666667,12.6666667 L25.3333333,12.6666667 C26.0703127,12.6666667 26.6666667,13.2630207 26.6666667,14 C26.6666667,14.872396 26.0442707,15.2916667 25.2708333,15.7291667 C24.1171873,16.3828127 23.783854,16.6666667 22.6666667,16.6666667 C21.5625,16.6666667 20.6666667,15.7708333 20.6666667,14.6666667 C20.6666667,13.5625 21.5625,12.6666667 22.6666667,12.6666667 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(TransportationIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 61431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var TravelOpportunitiesIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-airplane-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-airport-100', transform: 'translate(8.000000, 8.149303)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M30.0665366,0 C27.6486979,0 23.5235595,2.89236761 22.6749305,3.79623249 L18.3363791,8.1347839 L2.91041852,6.04585174 C2.70955966,6.01823348 2.51121137,6.10108824 2.36809959,6.2467106 L0.178737999,8.49632985 C0.0280938524,8.64948457 -0.0271423345,8.86791874 0.0180509093,9.07882055 C0.0632444746,9.28972235 0.198823885,9.46296296 0.399682746,9.54079593 L12.2905274,14.2007215 L6.16433208,20.4474321 L3.21170681,20.4474321 C3.05855209,20.4474321 2.90539737,20.5076898 2.7899032,20.6081192 L0.218909771,22.7773949 C0.0356260919,22.9330609 -0.0371852776,23.186645 0.0180509093,23.4201433 C0.0732874177,23.6536415 0.246528025,23.8444575 0.480026291,23.9022045 L6.60622157,25.408646 L8.11266303,31.5348413 C8.16789954,31.7532755 8.33862957,31.9290266 8.55455253,31.9968167 C8.76796491,32.0646067 8.98890966,32.004349 9.15712911,31.8562155 L11.3464907,29.9279704 C11.4845813,29.8049445 11.5674355,29.6291927 11.5674355,29.4459091 L11.5674355,25.8706214 L17.8744037,19.7243402 L22.4740716,31.6151848 C22.5519046,31.8160437 22.7251452,31.9516237 22.936047,31.9968167 C22.9812406,32.0068596 23.0314553,32.0169025 23.0766482,32.0169025 C23.2423571,32.0169025 23.3980224,31.9541343 23.5185377,31.8361296 L25.768157,29.646768 C25.91378,29.5036562 25.9966341,29.3053079 25.9690158,29.1044491 L23.8800837,13.6784885 L28.2186351,9.33993707 C29.1074359,8.45113693 33.4660732,2.56346106 31.4926345,0.502147154 C31.1436421,0.168219457 30.6615808,0 30.0665366,0 Z', id: 'Path' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(TravelOpportunitiesIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 63606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UploadIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';




function UploadIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? "".concat(_Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[40] */ .O9.primary[40]) : _b, _c = _a.width, width = _c === void 0 ? 19 : _c, _d = _a.height, height = _d === void 0 ? 21 : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 19 21', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M2.10073 0C1.21673 0 0.500732 0.716 0.500732 1.6V15.2C0.500732 16.084 1.21673 16.8 2.10073 16.8H8.50073V6.73125L6.66636 8.56562C6.35356 8.87842 5.84791 8.87842 5.53511 8.56562C5.22231 8.25282 5.22231 7.74717 5.53511 7.43437L8.73511 4.23437C8.89111 4.07837 9.09593 4 9.30073 4C9.50553 4 9.71036 4.07837 9.86636 4.23437L13.0664 7.43437C13.3792 7.74717 13.3792 8.25282 13.0664 8.56562C12.7536 8.87842 12.2479 8.87842 11.9351 8.56562L10.1007 6.73125V16.8H16.5007C17.3847 16.8 18.1007 16.084 18.1007 15.2V1.6C18.1007 0.716 17.3847 0 16.5007 0H2.10073ZM10.1007 16.8H8.50073V20C8.50073 20.4416 8.85913 20.8 9.30073 20.8C9.74233 20.8 10.1007 20.4416 10.1007 20V16.8Z', fill: color })));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 37373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ VerticalMoreIcon$1; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var VerticalMoreIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#939393' : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, rest = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["color", "width"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, rest, { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '12', cy: '4.5', r: '2.5', fill: color }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '12', cy: '12', r: '2.5', fill: color }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '12', cy: '19.5', r: '2.5', fill: color })));
};
var VerticalMoreIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(VerticalMoreIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 7408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var VoucherIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/company-benefits/size-xl/icon-voucher-fill', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons8-movie-ticket-100-2', transform: 'translate(8.000000, 8.459816)', className: 'benefits-icon-color', fillRule: 'nonzero' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: color !== null && color !== void 0 ? color : '#888', d: 'M31.4837354,9.58776308 L29.5002329,7.60426058 C29.2704064,7.37443406 28.9031834,7.35444914 28.6483761,7.55679625 C28.0763074,8.01644929 27.4367901,8.24877377 26.7473105,8.24877377 C25.0885626,8.24877377 23.7420794,6.89979201 23.7420794,5.24354201 C23.7420794,4.55406244 23.9744039,3.91454516 24.431559,3.33997917 C24.636404,3.08517118 24.6164191,2.71794885 24.3865926,2.48812233 L22.4030901,0.50711714 C21.7285989,-0.169872018 20.5095191,-0.167373424 19.8375265,0.504619185 L16.4076156,3.9120472 L17.2869519,4.79138347 C17.5367633,5.0411949 17.5367633,5.44588975 17.2869519,5.69570119 C17.1620458,5.82060659 16.9971706,5.88305929 16.8347927,5.88305929 C16.6699174,5.88305929 16.5075402,5.82060659 16.3826341,5.69570119 L15.5007999,4.81386634 L0.522106066,19.6926356 C0.184860464,20.0298812 0,20.4845383 0,20.9741688 C0,21.4662971 0.184860464,21.9209536 0.522106066,22.2581992 L2.50560857,24.2417024 C2.73543509,24.4715289 3.10016011,24.4940118 3.35746605,24.2891661 C3.96450737,23.8020342 4.66397939,23.5322379 5.32348159,23.5322379 C6.97973159,23.5322379 8.32871335,24.8812197 8.32871335,26.537469 C8.32871335,27.2644205 8.06890946,27.9539 7.596766,28.4760058 C7.36943743,28.7308138 7.37942989,29.1155231 7.62174682,29.3578406 L9.60275201,31.3388452 C9.93999697,31.6760908 10.3971521,31.8634489 10.8867825,31.8634489 C11.3764129,31.8634489 11.833568,31.6760908 12.1708136,31.3388452 L27.0995451,16.4101136 L26.2302013,15.5432678 C25.9803899,15.2934563 25.9803899,14.8887621 26.2302013,14.6389507 C26.4825107,14.3891392 26.884707,14.3891392 27.1345184,14.6389507 L28.0038622,15.5057959 L31.3913053,12.1183528 C31.7435393,11.836066 31.9633734,11.4163828 31.9958493,10.9567298 C32.0308226,10.4471144 31.8434639,9.94749155 31.4837354,9.58776308 Z M18.173782,6.58253132 C18.4235934,6.33271988 18.8257903,6.33271988 19.0780997,6.58253132 L19.9749229,7.47935454 C20.2247344,7.72916598 20.2247344,8.13386083 19.9749229,8.38367227 C19.8500169,8.50857767 19.6876396,8.57103037 19.5227637,8.57103037 C19.3578885,8.57103037 19.1955112,8.50857767 19.0706052,8.38367227 L18.173782,7.48684905 C17.9239705,7.23703761 17.9239705,6.83234276 18.173782,6.58253132 Z M16.5774874,18.8008089 L15.7481134,22.572962 L13.8295615,19.1830203 L9.99245785,19.5027789 L12.6129797,16.6249511 L11.0791371,13.0451534 L14.5964822,14.6439466 L17.5392612,12.0858775 L17.027148,16.0503852 L20.3521377,18.0338877 L16.5774874,18.8008089 Z M22.6678899,11.0766393 C22.5429845,11.2015453 22.3806066,11.263998 22.2157314,11.263998 C22.0533541,11.263998 21.8884782,11.2015453 21.7635728,11.0766393 L20.8667496,10.179816 C20.6169382,9.93000459 20.6169382,9.52281243 20.8667496,9.27549894 C21.116561,9.02568751 21.5212552,9.02568751 21.7710667,9.27549894 L22.6678899,10.1723222 C22.9177013,10.4221336 22.9177013,10.8268278 22.6678899,11.0766393 Z M25.3608575,13.7696069 C25.2359515,13.8945123 25.0735742,13.956965 24.9086984,13.956965 C24.7463211,13.956965 24.5814458,13.8945123 24.4565398,13.7696069 L23.5597166,12.8727837 C23.3099051,12.6229722 23.3099051,12.2182774 23.5597166,11.9684659 C23.809528,11.7186545 24.2142229,11.7186545 24.4640343,11.9684659 L25.3608575,12.8652892 C25.610669,13.1151006 25.610669,13.5197954 25.3608575,13.7696069 Z', id: 'Shape' })))));
};
var index = react__WEBPACK_IMPORTED_MODULE_0__.memo(VoucherIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 14083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WarningIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



function WarningIcon(props) {
    var _a = props.width, width = _a === void 0 ? 22 : _a, _b = props.height, height = _b === void 0 ? 19 : _b, _c = props.fill, fill = _c === void 0 ? '#F7BE06' : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 22 19', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M11.0001 0.399902C10.3348 0.399902 9.76495 0.805281 9.52353 1.38271L0.840723 16.3577V16.3593C0.684019 16.6117 0.600699 16.9028 0.600098 17.1999C0.600098 17.6242 0.768669 18.0312 1.06873 18.3313C1.36878 18.6313 1.77575 18.7999 2.2001 18.7999C2.23764 18.7997 2.27516 18.7981 2.3126 18.7952L2.31572 18.7999H11.0001H19.6845L19.6876 18.7937C19.725 18.7971 19.7625 18.7991 19.8001 18.7999C20.2244 18.7999 20.6314 18.6313 20.9315 18.3313C21.2315 18.0312 21.4001 17.6242 21.4001 17.1999C21.3998 16.9023 21.3165 16.6106 21.1595 16.3577L21.147 16.3358C21.1465 16.3353 21.1459 16.3348 21.1454 16.3343L12.4767 1.38271C12.2352 0.805281 11.6654 0.399902 11.0001 0.399902ZM10.0298 7.0874H11.9704L11.8095 12.2655H10.1907L10.0298 7.0874ZM11.0032 13.8483C11.6608 13.8483 12.0548 14.2022 12.0548 14.8062C12.0548 15.399 11.6608 15.7515 11.0032 15.7515C10.3408 15.7515 9.94385 15.399 9.94385 14.8062C9.94385 14.2022 10.34 13.8483 11.0032 13.8483Z', fill: fill })));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ InputGroup; },
/* harmony export */   "R4": function() { return /* binding */ InputGroupWrapper; },
/* harmony export */   "SP": function() { return /* binding */ InputWrapper; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "be": function() { return /* binding */ ListRecommend; },
/* harmony export */   "bp": function() { return /* binding */ RecommendItem; },
/* harmony export */   "f9": function() { return /* binding */ TextDanger; },
/* harmony export */   "gy": function() { return /* binding */ InputRecommend; },
/* harmony export */   "jG": function() { return /* binding */ PrefixIcon; },
/* harmony export */   "ub": function() { return /* binding */ LabelWrapper; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96306);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33089);
'use client';






var InputGroupWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    .remove-icon {\n        opacity: ", ";\n        transition: all 0.25s;\n        &.none {\n            opacity: 0;\n            pointer-events: none;\n        }\n        &.is-show {\n            opacity: 0.5;\n        }\n    }\n    &:hover,\n    &:focus {\n        .remove-icon {\n            opacity: 0.5;\n            &:hover {\n                opacity: 1;\n            }\n            &.none {\n                opacity: 0;\n                pointer-events: none;\n            }\n        }\n    }\n    ", "\n    ", "\n    ", "\n"], ["\n    .remove-icon {\n        opacity: ", ";\n        transition: all 0.25s;\n        &.none {\n            opacity: 0;\n            pointer-events: none;\n        }\n        &.is-show {\n            opacity: 0.5;\n        }\n    }\n    &:hover,\n    &:focus {\n        .remove-icon {\n            opacity: 0.5;\n            &:hover {\n                opacity: 1;\n            }\n            &.none {\n                opacity: 0;\n                pointer-events: none;\n            }\n        }\n    }\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var isFocus = _a.isFocus;
    return (isFocus ? '0.5' : '0');
}, function (_a) {
    var isHover = _a.isHover, isHaveValue = _a.isHaveValue, isClearValue = _a.isClearValue;
    if (!isHover) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            input {\n                border: 1px solid ", ";\n                box-shadow: none;\n                background-color: #fff;\n                ", "\n                .remove-icon {\n                    opacity: 1 !important;\n                }\n            }\n        "], ["\n            input {\n                border: 1px solid ", ";\n                box-shadow: none;\n                background-color: #fff;\n                ", "\n                .remove-icon {\n                    opacity: 1 !important;\n                }\n            }\n        "])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderHover */ .O9.borderHover, isHaveValue && isClearValue ? 'padding-right: 36px !important;' : '');
}, function (_a) {
    var isFocus = _a.isFocus, isHaveValue = _a.isHaveValue, isClearValue = _a.isClearValue;
    if (!isFocus) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            input {\n                ", "\n                border-color: ", ";\n            }\n        "], ["\n            input {\n                ", "\n                border-color: ", ";\n            }\n        "])), isHaveValue && isClearValue ? 'padding-right: 36px !important;' : '', _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderFocus */ .O9.borderFocus);
}, function (_a) {
    var icon = _a.icon;
    if (icon === 'password') {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                .remove-icon {\n                    opacity: 0 !important;\n                    pointer-events: none !important;\n                }\n            "], ["\n                .remove-icon {\n                    opacity: 0 !important;\n                    pointer-events: none !important;\n                }\n            "])));
    }
    return '';
});
var InputGroup = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    svg {\n        &.remove-icon {\n            position: absolute;\n            z-index: 1;\n            top: 8px;\n            right: 6px;\n            cursor: pointer;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n    }\n    input {\n        background-color: #fff;\n        border: 1px solid ", ";\n        color: ", ";\n        &:hover {\n            border: 1px solid ", ";\n            box-shadow: none;\n            background-color: #fff;\n        }\n        &:focus,\n        &:active {\n            border: 1px solid ", ";\n        }\n        &:disabled {\n            box-shadow: none;\n            border: 1px solid ", ";\n            background-color: ", ";\n            color: #999;\n            cursor: not-allowed;\n            pointer-events: none;\n        }\n        &::placeholder {\n            color: #999;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 18px;\n        }\n    }\n    ", "\n"], ["\n    position: relative;\n    svg {\n        &.remove-icon {\n            position: absolute;\n            z-index: 1;\n            top: 8px;\n            right: 6px;\n            cursor: pointer;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n    }\n    input {\n        background-color: #fff;\n        border: 1px solid ", ";\n        color: ", ";\n        &:hover {\n            border: 1px solid ", ";\n            box-shadow: none;\n            background-color: #fff;\n        }\n        &:focus,\n        &:active {\n            border: 1px solid ", ";\n        }\n        &:disabled {\n            box-shadow: none;\n            border: 1px solid ", ";\n            background-color: ", ";\n            color: #999;\n            cursor: not-allowed;\n            pointer-events: none;\n        }\n        &::placeholder {\n            color: #999;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 18px;\n        }\n    }\n    ", "\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderNormal */ .O9.borderNormal, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textColor */ .O9.textColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderHover */ .O9.borderHover, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderFocus */ .O9.borderFocus, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderDisable */ .O9.borderDisable, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.bgDisable */ .O9.bgDisable, function (_a) {
    var isClearValue = _a.isClearValue;
    if (!isClearValue) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            input {\n                padding-right: 10px;\n            }\n        "], ["\n            input {\n                padding-right: 10px;\n            }\n        "])));
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: grid;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 4px;\n"], ["\n    display: grid;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 4px;\n"])));
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].input */ .ZP.input(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    width: 100%;\n    height: 40px;\n    border: 1px solid rgba(224, 224, 233, 0.5);\n    border-radius: 6px;\n    padding: 15px 10px 15px 10px;\n    font-size: 13px;\n    outline: none;\n    transition: all 0.3s, font-size 0s, letter-spacing 0s;\n    white-space: nowrap;\n    overflow: hidden !important;\n\n    /* Safari text color input change */\n    -webkit-text-fill-color: ", ";\n    opacity: 1;\n\n    &::placeholder {\n        -webkit-text-fill-color: ", ";\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &::-webkit-input-placeholder {\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n\n    ", "\n    ", "\n"], ["\n    width: 100%;\n    height: 40px;\n    border: 1px solid rgba(224, 224, 233, 0.5);\n    border-radius: 6px;\n    padding: 15px 10px 15px 10px;\n    font-size: 13px;\n    outline: none;\n    transition: all 0.3s, font-size 0s, letter-spacing 0s;\n    white-space: nowrap;\n    overflow: hidden !important;\n\n    /* Safari text color input change */\n    -webkit-text-fill-color: ", ";\n    opacity: 1;\n\n    &::placeholder {\n        -webkit-text-fill-color: ", ";\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &::-webkit-input-placeholder {\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n\n    ", "\n    ", "\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textColor */ .O9.textColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textPlaceholder */ .O9.textPlaceholder, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textPlaceholder */ .O9.textPlaceholder, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textPlaceholder */ .O9.textPlaceholder, function (_a) {
    var isError = _a.isError;
    if (!isError) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            border-color: ", " !important;\n            background-color: #fff !important;\n            &:focus,\n            &:active {\n                border-color: ", " !important;\n            }\n        "], ["\n            border-color: ", " !important;\n            background-color: #fff !important;\n            &:focus,\n            &:active {\n                border-color: ", " !important;\n            }\n        "])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderError */ .O9.borderError, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderErrorFocus */ .O9.borderErrorFocus);
}, function (_a) {
    var isHavePrefix = _a.isHavePrefix;
    if (!isHavePrefix) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            padding-left: 40px;\n        "], ["\n            padding-left: 40px;\n        "])));
});
var InputRecommend = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"], ["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"])));
var ListRecommend = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul */ .ZP.ul(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var RecommendItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li */ .ZP.li(templateObject_15 || (templateObject_15 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    padding: 8px 16px;\n    cursor: pointer;\n    &:hover {\n        background: #f2f2f2;\n    }\n    ", "\n    ", "\n"], ["\n    padding: 8px 16px;\n    cursor: pointer;\n    &:hover {\n        background: #f2f2f2;\n    }\n    ", "\n    ", "\n"])), function (_a) {
    var isActive = _a.isActive;
    if (!isActive) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            background: #f2f2f2;\n        "], ["\n            background: #f2f2f2;\n        "])));
}, function (_a) {
    var isEmpty = _a.isEmpty;
    if (!isEmpty) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_14 || (templateObject_14 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.grey[60] */ .O9.grey[60]);
});
var LabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_16 || (templateObject_16 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"])));
var TextDanger = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_17 || (templateObject_17 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.dangerColor */ .O9.dangerColor);
var PrefixIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_18 || (templateObject_18 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;


//# sourceMappingURL=Input.css.js.map


/***/ }),

/***/ 46779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/EyesCloseIcon/index.js
var EyesCloseIcon = __webpack_require__(2237);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/EyesOpenIcon/index.js
var EyesOpenIcon = __webpack_require__(18585);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/Input.css.js
var Input_css = __webpack_require__(76109);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Input/const.js
'use client';

var DELAY_TIMEOUT = 200;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js
'use client';













var Input = function (props) {
    var onChange = props.onChange, onPressEnter = props.onPressEnter, _a = props.onClickSuggestionItem, onClickSuggestionItem = _a === void 0 ? function (item) { return console.log("".concat(item, " was clicked/selected")); } : _a, value = props.value, _b = props.isRequired, isRequired = _b === void 0 ? false : _b, _c = props.label, label = _c === void 0 ? '' : _c, hasError = props.hasError, listRecommend = props.listRecommend, searchNotFound = props.searchNotFound, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = props.clearValue, clearValue = _g === void 0 ? true : _g, icon = props.icon, type = props.type, _h = props.prefixIcon, prefixIcon = _h === void 0 ? null : _h, _j = props.numberFieldRule, numberFieldRule = _j === void 0 ? 'all' : _j, inputRef = props.inputRef, rest = (0,_tslib/* __rest */._T)(props, ["onChange", "onPressEnter", "onClickSuggestionItem", "value", "isRequired", "label", "hasError", "listRecommend", "searchNotFound", "className", "disabled", "autoFocus", "clearValue", "icon", "type", "prefixIcon", "numberFieldRule", "inputRef"]);
    var _k = (0,react.useState)(false), isFocus = _k[0], setIsFocus = _k[1];
    var _l = (0,react.useState)(false), showPassword = _l[0], setShowPassword = _l[1];
    var _m = (0,react.useState)(false), isHover = _m[0], setHover = _m[1];
    var inputGroupRef = (0,react.useRef)(null);
    var _o = (0,useFloating/* default */.Z)({
        placement: 'bottom-start',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true,
            detectHidden: true
        }
    }), context = _o.context, refs = _o.refs, FloatingPortal = _o.FloatingPortal;
    var timer = null;
    var handleClickOnScreen = function (e) {
        timer && clearTimeout(timer);
        timer = setTimeout(function () {
            var _a, _b;
            setIsFocus((_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) !== null && _b !== void 0 ? _b : false);
        }, DELAY_TIMEOUT);
    };
    (0,react.useEffect)(function () {
        // We're using touchend because of some old IOS versions, they're not fired click event, so the handleClickOnScreen func is not worked properly
        window.addEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        return function () {
            window.removeEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        };
    }, []);
    /**
     * `activeSuggestionIndex`: used to highlight which suggestion is being focused by using up/down key
     */
    var _p = (0,react.useState)(null), activeSuggestionIndex = _p[0], setActiveSuggestionIndex = _p[1];
    var numberOfRecommendedSkills = listRecommend ? listRecommend.length : 0;
    var handleKeyUp = function (event) {
        var _a, _b;
        switch (event.key) {
            case 'ArrowDown': {
                var newIndex = activeSuggestionIndex !== null ? activeSuggestionIndex + 1 : 0;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = 0;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_a = refs.popup.current.querySelectorAll('li')) === null || _a === void 0 ? void 0 : _a[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'ArrowUp': {
                var newIndex = activeSuggestionIndex && activeSuggestionIndex > 0
                    ? activeSuggestionIndex - 1
                    : numberOfRecommendedSkills - 1;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = numberOfRecommendedSkills - 1;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_b = refs.popup.current.querySelectorAll('li')) === null || _b === void 0 ? void 0 : _b[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'Enter': {
                var currentActiveItem = listRecommend === null || listRecommend === void 0 ? void 0 : listRecommend.find(function (_item, index) { return index === activeSuggestionIndex; });
                if (onClickSuggestionItem && currentActiveItem) {
                    onClickSuggestionItem(currentActiveItem);
                    setIsFocus(false);
                    setActiveSuggestionIndex(null);
                }
                break;
            }
        }
    };
    var handleType = (0,react.useCallback)(function () {
        if (type === 'password') {
            if (showPassword)
                return 'text';
            else
                return 'password';
        }
        else if (type) {
            return type;
        }
        else {
            return 'text';
        }
    }, [type, showPassword]);
    var handleOnChange = (0,react.useCallback)(function (e) {
        setActiveSuggestionIndex(null);
        onChange(e.target.value, e);
        setIsFocus(true);
    }, [onChange]);
    var handleOnKeyPress = (0,react.useCallback)(function (e) {
        // If user press `enter` and NOT focusing on the dropdown list
        // We call the input onPressEnter
        if (e.key === 'Enter' && activeSuggestionIndex === null) {
            setIsFocus(false);
            onPressEnter && onPressEnter();
        }
        // If field type is number then
        // numberFieldRule = 'positive-int'
        // positive-int: no negative number, no float and can't be
        if (type === 'number' &&
            numberFieldRule === 'positive-int' &&
            (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+')) {
            e.preventDefault();
        }
        // numberFieldRule = 'float'
        if (type === 'number' && numberFieldRule === 'float' && (e.key === 'e' || e.key === 'E')) {
            e.preventDefault();
        }
    }, [activeSuggestionIndex, onPressEnter, type]);
    var handleOnClickSuggestItem = (0,react.useCallback)(function (item) {
        if (onClickSuggestionItem) {
            onClickSuggestionItem(item);
            setIsFocus(false);
        }
    }, [onClickSuggestionItem]);
    (0,react.useCallback)(function () {
        if (handleType() === 'password' && !showPassword) {
            return value.replace(/./g, '*');
        }
        return value;
    }, [type, value, showPassword]);
    var handleOnRemoveClick = (0,react.useCallback)(function () {
        var _a, _b;
        onChange('');
        if (inputGroupRef !== undefined && inputGroupRef !== null) {
            (_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [onChange, inputGroupRef]);
    (0,react.useEffect)(function () {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.addEventListener('focus', function () { return setIsFocus(true); });
        }
        return function () {
            var _a;
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', function () { return setIsFocus(false); });
            }
        };
    }, [inputRef === null || inputRef === void 0 ? void 0 : inputRef.current]);
    return (react.createElement(Input_css/* InputGroupWrapper */.R4, { ref: inputGroupRef, isFocus: isFocus, isHover: isHover, isHaveValue: value !== '', isClearValue: clearValue, icon: icon, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        label ? (react.createElement(Input_css/* LabelWrapper */.ub, null,
            isRequired ? react.createElement(Input_css/* TextDanger */.f9, null, "*") : null,
            " ",
            react.createElement("label", null, label))) : null,
        react.createElement(Input_css/* InputGroup */.BZ, { isClearValue: clearValue, ref: refs.setReference },
            prefixIcon !== null ? react.createElement(Input_css/* PrefixIcon */.jG, null, prefixIcon) : null,
            react.createElement(Input_css/* InputWrapper */.SP, (0,_tslib/* __assign */.pi)({ ref: inputRef, value: value, className: "".concat(className, " class-input-recommend"), onChange: handleOnChange, onKeyPress: handleOnKeyPress, onKeyUp: handleKeyUp, disabled: disabled, autoFocus: autoFocus, type: handleType(), isError: hasError, isHavePrefix: prefixIcon !== null }, rest)),
            icon === 'password' && (react.createElement(Input_css/* IconWrapper */.a1, { onClick: function () { return setShowPassword(!showPassword); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }, showPassword ? react.createElement(EyesOpenIcon/* default */.Z, null) : react.createElement(EyesCloseIcon/* default */.Z, null))),
            value !== '' ? (react.createElement(RemoveFillIcon/* default */.Z, { className: "remove-icon ".concat(value && !disabled && clearValue && (isFocus || isHover) ? 'is-show' : 'none'), onClick: function () { return handleOnRemoveClick(); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } })) : null,
            value && listRecommend && isFocus ? (react.createElement(FloatingPortal, { enable: true },
                react.createElement(Input_css/* InputRecommend */.gy, { ref: refs.setPopup, style: {
                        position: context.position,
                        top: context.y,
                        left: context.x,
                        width: refs.reference.current.offsetWidth,
                        zIndex: 1100,
                        display: context.isReferenceHidden ? 'none' : 'block'
                    } },
                    react.createElement(Input_css/* ListRecommend */.be, null, listRecommend.length !== 0 ? (listRecommend.map(function (item, index) {
                        return (react.createElement(Input_css/* RecommendItem */.bp, { isActive: activeSuggestionIndex === index, key: index, onClick: function () { return handleOnClickSuggestItem(item); } }, item.name));
                    })) : (react.createElement(Input_css/* RecommendItem */.bp, { isEmpty: true }, searchNotFound)))))) : null)));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InputYOE; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 1 modules
var Input = __webpack_require__(46779);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputYOE/constants.js
'use client';

var DEFAULT_OPTION = {
    max: 99,
    min: 0,
    canBeEmpty: false,
    fontSizeErrorText: 12
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputYOE/InputYOE.css.js
'use client';





var InputYOEWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var Label = styled_components_browser_esm/* default.label */.ZP.label(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    font-size: 14px;\n    line-height: 21px;\n    color: #333;\n    ", "\n    display: block;\n    span {\n        margin-right: 4px;\n        color: #f85a5a;\n        font-weight: 600;\n    }\n"], ["\n    margin-bottom: 4px;\n    font-size: 14px;\n    line-height: 21px;\n    color: #333;\n    ", "\n    display: block;\n    span {\n        margin-right: 4px;\n        color: #f85a5a;\n        font-weight: 600;\n    }\n"])), function (_a) {
    var thinLabel = _a.thinLabel;
    return (thinLabel ? '' : 'font-weight: 500;');
});
var Postfix = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0 12px;\n    color: rgba(51, 51, 51, 0.7);\n    background-color: #fbfbfb;\n    border-radius: 0 6px 6px 0;\n    border-left: 1px solid ", ";\n    border: 1px solid ", ";\n    display: flex;\n    align-items: center;\n"], ["\n    padding: 0 12px;\n    color: rgba(51, 51, 51, 0.7);\n    background-color: #fbfbfb;\n    border-radius: 0 6px 6px 0;\n    border-left: 1px solid ", ";\n    border: 1px solid ", ";\n    display: flex;\n    align-items: center;\n"])), constants/* colors.borderNormal */.O9.borderNormal, constants/* colors.borderNormal */.O9.borderNormal);
var InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    height: 40px;\n    border: 1px solid ", ";\n    border-radius: 6px;\n    background: #fff;\n    overflow: hidden;\n    > div:nth-child(1) {\n        width: 100%;\n        input {\n            border: none;\n            background: transparent;\n            outline: none;\n            height: 40px;\n            &::placeholder {\n                color: #999;\n            }\n        }\n        svg.remove-icon {\n            top: 7px;\n        }\n    }\n    ", " {\n        border: none;\n        border-left: 1px solid ", ";\n    }\n    ", "\n    ", "\n"], ["\n    display: flex;\n    height: 40px;\n    border: 1px solid ", ";\n    border-radius: 6px;\n    background: #fff;\n    overflow: hidden;\n    > div:nth-child(1) {\n        width: 100%;\n        input {\n            border: none;\n            background: transparent;\n            outline: none;\n            height: 40px;\n            &::placeholder {\n                color: #999;\n            }\n        }\n        svg.remove-icon {\n            top: 7px;\n        }\n    }\n    ", " {\n        border: none;\n        border-left: 1px solid ", ";\n    }\n    ", "\n    ", "\n"])), function (_a) {
    var isError = _a.isError;
    return (isError ? '#ff4a53' : constants/* colors.borderNormal */.O9.borderNormal);
}, Postfix, function (_a) {
    var isError = _a.isError;
    return (isError ? '#ff4a53' : constants/* colors.borderNormal */.O9.borderNormal);
}, function (_a) {
    var isError = _a.isError;
    if (isError) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            &:hover {\n                border: 1px solid ", ";\n                ", " {\n                    border-left: 1px solid ", ";\n                }\n            }\n            &:focus-within {\n                border: 1px solid ", ";\n                ", " {\n                    border-left: 1px solid ", ";\n                }\n            }\n        "], ["\n            &:hover {\n                border: 1px solid ", ";\n                ", " {\n                    border-left: 1px solid ", ";\n                }\n            }\n            &:focus-within {\n                border: 1px solid ", ";\n                ", " {\n                    border-left: 1px solid ", ";\n                }\n            }\n        "])), constants/* colors.borderHover */.O9.borderHover, Postfix, constants/* colors.borderHover */.O9.borderHover, constants/* colors.borderFocus */.O9.borderFocus, Postfix, constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var typeInput = _a.typeInput;
    if (typeInput === 'number') {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            input {\n                /* Chrome, Safari, Edge, Opera */\n                &::-webkit-outer-spin-button,\n                &::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    margin: 0;\n                }\n\n                /* Firefox */\n                &[type='number'] {\n                    -moz-appearance: textfield;\n                }\n            }\n        "], ["\n            input {\n                /* Chrome, Safari, Edge, Opera */\n                &::-webkit-outer-spin-button,\n                &::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    margin: 0;\n                }\n\n                /* Firefox */\n                &[type='number'] {\n                    -moz-appearance: textfield;\n                }\n            }\n        "])));
});
var ErrorMessage = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #f85a5a;\n    margin-top: 4px;\n    margin-bottom: 10px;\n    font-size: ", "px;\n"], ["\n    color: #f85a5a;\n    margin-top: 4px;\n    margin-bottom: 10px;\n    font-size: ", "px;\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


//# sourceMappingURL=InputYOE.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputYOE/index.js
'use client';







var InputYOE = function (props) {
    var labelText = props.labelText, isRequired = props.isRequired, _a = props.isError, isError = _a === void 0 ? false : _a, _b = props.errorText, errorText = _b === void 0 ? '' : _b, postfixText = props.postfixText, _c = props.defaultValue, defaultValue = _c === void 0 ? '' : _c, _d = props.placeholder, placeholder = _d === void 0 ? '' : _d, _e = props.typeInput, typeInput = _e === void 0 ? 'number' : _e, options = props.options, onChange = props.onChange, onFocus = props.onFocus, _f = props.thinLabel, thinLabel = _f === void 0 ? false : _f;
    var mergedOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTION), options);
    var _g = (0,react.useState)(''), value = _g[0], setValue = _g[1];
    var onChangeValue = function (value) {
        var parsedValue = Number(value);
        if (value === '' && mergedOptions.canBeEmpty) {
            setValue('');
            onChange && onChange(value);
            return;
        }
        if (parsedValue < mergedOptions.min) {
            return;
        }
        if (parsedValue > mergedOptions.max) {
            return;
        }
        setValue(value);
        onChange && onChange(value);
    };
    (0,react.useEffect)(function () {
        setValue(defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);
    return (react.createElement(InputYOEWrapper, null,
        labelText ? (react.createElement(Label, { thinLabel: thinLabel },
            isRequired && react.createElement("span", null, "*"),
            labelText)) : null,
        react.createElement(InputWrapper, { isError: isError, typeInput: typeInput },
            react.createElement(Input/* default */.Z, (0,_tslib/* __assign */.pi)({}, props, { type: 'number', value: value.toString(), min: mergedOptions.min, max: mergedOptions.max, numberFieldRule: 'positive-int' // No 'e', no float, no negative integer
                , placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : '', onFocus: function () { return onFocus && onFocus(); }, onChange: onChangeValue })),
            react.createElement(Postfix, null, postfixText)),
        isError && errorText ? (react.createElement(ErrorMessage, { fontSize: mergedOptions.fontSizeErrorText || 12 }, errorText)) : (react.createElement(react.Fragment, null))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 75243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SaveLoadingIcon; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var SaveLoadingIcon = function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    var iconColor = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([], props, true)[0].iconColor;
    var color = iconColor || '#4D8CFF';
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: '20px', className: 'loading-with-tail', height: '20px', viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", { id: 'loading-with-tail-filter', x: '-100%', y: '-100%', width: '300%', height: '300%', colorInterpolationFilters: 'sRGB' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", { in: 'SourceGraphic', stdDeviation: '3' }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComponentTransfer", { result: 'cutoff' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("feFuncA", { type: 'linear', slope: '60', intercept: '-40' })))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { filter: 'url(#loading-with-tail-filter)', transform: 'rotate(35.0739 50 50)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', type: 'rotate', repeatCount: 'indefinite', dur: '3.0303030303030303s', values: '0 50 50;360 50 50', keyTimes: '0;1' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(22.1098 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '0', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.7666666666666666 0 0.6666666666666666 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(24.4977 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '1', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.7333333333333333 0 0.6333333333333333 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(27.2957 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '2', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.7 0 0.6 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(30.6021 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '3', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.6666666666666666 0 0.5666666666666667 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(34.5447 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '4', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.6333333333333333 0 0.5333333333333333 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(39.2913 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '5', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.6 0 0.5 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(45.0627 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '6', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.5666666666666667 0 0.4666666666666667 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(52.1475 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '7', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.5333333333333333 0 0.43333333333333335 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(60.9142 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '8', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.5 0 0.4 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(71.8063 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '9', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.4666666666666667 0 0.36666666666666664 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(85.2846 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '10', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.43333333333333335 0 0.3333333333333333 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(101.661 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '11', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.4 0 0.3 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(120.796 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '12', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.3666666666666667 0 0.26666666666666666 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(141.827 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '13', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.33333333333333337 0 0.23333333333333334 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(163.303 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '14', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.30000000000000004 0 0.2 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(183.792 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '15', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.26666666666666666 0 0.16666666666666666 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(202.388 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '16', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.23333333333333334 0 0.13333333333333333 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(218.77 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '17', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.2 0 0.1 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(232.996 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '18', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.16666666666666669 0 0.06666666666666667 1', repeatCount: 'indefinite' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'rotate(245.288 50 50)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(50 20)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: '0', cy: '0', r: '19', fill: color, transform: 'scale(0.5)' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", { attributeName: 'transform', calcMode: 'spline', type: 'rotate', values: '0 50 50;360 50 50', keyTimes: '0;1', dur: '1.0101010101010102', keySplines: '0.13333333333333333 0 0.03333333333333333 1', repeatCount: 'indefinite' })))));
};


//# sourceMappingURL=SaveLoadingIcon.js.map


/***/ }),

/***/ 8203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ Widget; },
/* harmony export */   "Ct": function() { return /* binding */ Badge; },
/* harmony export */   "Fk": function() { return /* binding */ JobInvitationBlock; },
/* harmony export */   "JM": function() { return /* binding */ NextImageContainer; },
/* harmony export */   "N9": function() { return /* binding */ JobTitleSecondary; },
/* harmony export */   "O6": function() { return /* binding */ Right; },
/* harmony export */   "QV": function() { return /* binding */ HideJob; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "YZ": function() { return /* binding */ JobInvitationIcon; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "Zb": function() { return /* binding */ Salary; },
/* harmony export */   "Zc": function() { return /* binding */ BadgeMatchJob; },
/* harmony export */   "_c": function() { return /* binding */ SkillTagWrapper; },
/* harmony export */   "dv": function() { return /* binding */ Left; },
/* harmony export */   "hG": function() { return /* binding */ Separate; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zo": function() { return /* binding */ CompanyName; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96306);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33089);
'use client';






var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    color: ", ";\n"], ["\n    position: relative;\n    color: ", ";\n"])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[20] */ .O9.grey[20]);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: grid;\n\n    column-gap: 16px;\n    padding: 16px;\n    transition: all 0.25s;\n    ", "\n    ", "\n    ", "\n    ", "\n    @media screen and (max-width: 768px) {\n        column-gap: 12px;\n        padding: 12px;\n    }\n"], ["\n    display: grid;\n\n    column-gap: 16px;\n    padding: 16px;\n    transition: all 0.25s;\n    ", "\n    ", "\n    ", "\n    ", "\n    @media screen and (max-width: 768px) {\n        column-gap: 12px;\n        padding: 12px;\n    }\n"])), function (_a) {
    var variant = _a.variant;
    return variant === 'secondary'
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  grid-template-columns: 1fr auto;\n                  background-color: #fff !important;\n                  border: 1px solid ", " !important;\n              "], ["\n                  grid-template-columns: 1fr auto;\n                  background-color: #fff !important;\n                  border: 1px solid ", " !important;\n              "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.neutral[90] */ .O9.neutral[90]) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                  grid-template-columns: auto 1fr auto;\n              "], ["\n                  grid-template-columns: auto 1fr auto;\n              "])));
}, function (_a) {
    var haveRoundedBorder = _a.haveRoundedBorder;
    return (haveRoundedBorder ? 'border-radius: 12px;' : '');
}, function (_a) {
    var isPriorityJob = _a.isPriorityJob, noBorderTop = _a.noBorderTop;
    return isPriorityJob
        ? "\n            border: 1px solid #A0C1FF;\n            background-color: #EFF5FF;\n        &:hover {\n            background-color: #F9FBFF;\n            ".concat(noBorderTop ? 'border-top: 0;' : '', "\n        }\n        ")
        : "\n        border: 1px solid ".concat(_Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.jobCardBorder */ .O9.jobCardBorder, ";\n        background-color: white;\n        &:hover {\n            border: 1px solid #A0C1FF;\n            background-color: #F9FBFF;\n            ").concat(noBorderTop ? 'border-top: 0;' : '', "\n        }\n    ");
}, function (_a) {
    var noBorderTop = _a.noBorderTop;
    return (noBorderTop ? 'border-top: 0;' : '');
});
var NextImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: relative;\n    width: 108px;\n    height: 108px;\n    padding: 4px;\n    background-color: white;\n    border-radius: 12px;\n    @media screen and (max-width: 768px) {\n        width: 80px;\n        height: 80px;\n    }\n    > span {\n        margin: 4px !important;\n    }\n    img {\n        object-fit: contain;\n    }\n"], ["\n    position: relative;\n    width: 108px;\n    height: 108px;\n    padding: 4px;\n    background-color: white;\n    border-radius: 12px;\n    @media screen and (max-width: 768px) {\n        width: 80px;\n        height: 80px;\n    }\n    > span {\n        margin: 4px !important;\n    }\n    img {\n        object-fit: contain;\n    }\n"])));
var Left = {
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        a {\n            display: inline-flex;\n        }\n    "], ["\n        display: flex;\n        a {\n            display: inline-flex;\n        }\n    "]))),
    Avatar: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].img */ .ZP.img(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        width: 108px;\n        height: 108px;\n        padding: 4px;\n        object-fit: contain;\n        background-color: white;\n        border-radius: 12px;\n        @media screen and (max-width: 768px) {\n            width: 80px;\n            height: 80px;\n        }\n    "], ["\n        width: 108px;\n        height: 108px;\n        padding: 4px;\n        object-fit: contain;\n        background-color: white;\n        border-radius: 12px;\n        @media screen and (max-width: 768px) {\n            width: 80px;\n            height: 80px;\n        }\n    "])))
};
var Right = {
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        flex-direction: column;\n        a {\n            color: ", ";\n            transition: all 0.25s;\n\n            &:hover {\n                color: ", ";\n            }\n        }\n    "], ["\n        display: flex;\n        flex-direction: column;\n        a {\n            color: ", ";\n            transition: all 0.25s;\n\n            &:hover {\n                color: ", ";\n            }\n        }\n    "])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.textColor */ .O9.textColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.buttonColor */ .O9.buttonColor),
    Wrapper: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        ", "\n    "], ["\n        ", "\n    "])), function (_a) {
        var notMargin = _a.notMargin, flexLayout = _a.flexLayout, displayColumnOnMobile = _a.displayColumnOnMobile, alignCenter = _a.alignCenter, hiddenOnMobile = _a.hiddenOnMobile, cssString = _a.cssString;
        return "\n            ".concat(notMargin ? '' : 'margin-bottom: 4px;', "\n            ").concat(flexLayout ? 'display: flex;' : '', "\n            ").concat(alignCenter ? 'align-items: center;' : '', "\n            @media screen and (max-width: 768px) {\n              ").concat(displayColumnOnMobile ? 'flex-direction: column;' : '', "\n              ").concat(hiddenOnMobile ? 'display: none;' : '', "\n            }\n            ").concat(cssString, "\n        ");
    }),
    Title: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: inline-flex;\n        position: relative;\n        font-size: 16px !important;\n        font-weight: 500 !important;\n        width: fit-content;\n        line-height: 20px !important;\n        word-break: break-word;\n        color: ", ";\n        h2,\n        h3 {\n            font-size: 16px !important;\n            font-weight: 500 !important;\n            line-height: 20px !important;\n        }\n        h2,\n        h3,\n        p {\n            margin: 0;\n            margin-bottom: 0.5rem;\n        }\n        a {\n            span {\n                border-radius: 4px;\n                background-color: #ebf2ff;\n                padding: 2px 4px;\n                color: ", ";\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 14px;\n                margin-right: 4px;\n                transform: translateY(-1px);\n            }\n            ", "\n\n            ", "\n            ", "\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n            @media screen and (max-width: 768px) {\n                -webkit-line-clamp: 2;\n            }\n        }\n        span {\n            font-weight: 500;\n            white-space: nowrap;\n            color: ", ";\n        }\n    "], ["\n        display: inline-flex;\n        position: relative;\n        font-size: 16px !important;\n        font-weight: 500 !important;\n        width: fit-content;\n        line-height: 20px !important;\n        word-break: break-word;\n        color: ", ";\n        h2,\n        h3 {\n            font-size: 16px !important;\n            font-weight: 500 !important;\n            line-height: 20px !important;\n        }\n        h2,\n        h3,\n        p {\n            margin: 0;\n            margin-bottom: 0.5rem;\n        }\n        a {\n            span {\n                border-radius: 4px;\n                background-color: #ebf2ff;\n                padding: 2px 4px;\n                color: ", ";\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 14px;\n                margin-right: 4px;\n                transform: translateY(-1px);\n            }\n            ", "\n\n            ", "\n            ", "\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n            @media screen and (max-width: 768px) {\n                -webkit-line-clamp: 2;\n            }\n        }\n        span {\n            font-weight: 500;\n            white-space: nowrap;\n            color: ", ";\n        }\n    "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[20] */ .O9.grey[20], _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primaryColor */ .O9.primaryColor, function (_a) {
        var isPriorityJob = _a.isPriorityJob;
        return isPriorityJob
            ? "\n                color: #DC362E;\n                font-weight: 600;\n            "
            : '';
    }, function (_a) {
        var isViewed = _a.isViewed, isPriorityJob = _a.isPriorityJob;
        return isViewed
            ? "\n                color: ".concat(isPriorityJob ? '#A52923' : '#6B7792', ";\n            ")
            : '';
    }, function (_a) {
        var isMobile = _a.isMobile, isApplied = _a.isApplied, langcode = _a.langcode;
        return isMobile
            ? "\n                ".concat(isApplied && langcode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI ? 'margin-right: 40px;' : '', "\n            ")
            : 'margin-right: 24px;';
    }, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.buttonColor */ .O9.buttonColor),
    Text: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        font-size: 14px;\n    "], ["\n        font-size: 14px;\n    "]))),
    Bottom: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n    "], ["\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n    "]))),
    BottomRight: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    "], ["\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    "])))
};
var Badge = {
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_14 || (templateObject_14 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        flex-wrap: wrap;\n        margin-bottom: -4px;\n    "], ["\n        display: flex;\n        flex-wrap: wrap;\n        margin-bottom: -4px;\n    "]))),
    Wrapper: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_15 || (templateObject_15 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        margin-bottom: 4px;\n        height: 18px;\n        &:not(:last-of-type) {\n            margin-right: 4px;\n        }\n    "], ["\n        margin-bottom: 4px;\n        height: 18px;\n        &:not(:last-of-type) {\n            margin-right: 4px;\n        }\n    "])))
};
var BadgeMatchJob = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_16 || (templateObject_16 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: grid;\n    grid-template-columns: auto auto 1fr;\n    column-gap: 2px;\n    align-items: center;\n    font-size: 12px;\n    color: #6b7792;\n    font-weight: 500;\n    cursor: default;\n    ", "\n"], ["\n    display: grid;\n    grid-template-columns: auto auto 1fr;\n    column-gap: 2px;\n    align-items: center;\n    font-size: 12px;\n    color: #6b7792;\n    font-weight: 500;\n    cursor: default;\n    ", "\n"])), function (_a) {
    var isHaveSeparator = _a.isHaveSeparator;
    return isHaveSeparator
        ? "\n    &::before {\n        content: '';\n        display: inline-block;\n        height: 80%;\n        width: 1px;\n        background-color: #c9c9c9;\n        margin-right: 4px;\n    }\n    "
        : '';
});
var JobTitleSecondary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(templateObject_17 || (templateObject_17 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    line-height: 20px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    max-height: 40px;\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n"], ["\n    line-height: 20px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    max-height: 40px;\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n"])));
var HideJob = {
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_18 || (templateObject_18 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        background-color: white;\n        border: 1px solid #ebebeb;\n        border-radius: 6px;\n        padding: 16px;\n        margin-bottom: 10px;\n\n        display: grid;\n        grid-template-columns: 1fr auto;\n        gap: 16px;\n        align-items: center;\n        justify-content: space-between;\n        transition: 0.25s;\n\n        &:hover {\n            border: 1px solid ", ";\n        }\n\n        @media (max-width: 768px) {\n            border: none;\n            border-bottom: 1px solid #ececec;\n            margin-bottom: 0;\n            border-radius: 0;\n        }\n    "], ["\n        background-color: white;\n        border: 1px solid #ebebeb;\n        border-radius: 6px;\n        padding: 16px;\n        margin-bottom: 10px;\n\n        display: grid;\n        grid-template-columns: 1fr auto;\n        gap: 16px;\n        align-items: center;\n        justify-content: space-between;\n        transition: 0.25s;\n\n        &:hover {\n            border: 1px solid ", ";\n        }\n\n        @media (max-width: 768px) {\n            border: none;\n            border-bottom: 1px solid #ececec;\n            margin-bottom: 0;\n            border-radius: 0;\n        }\n    "])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.borderHover */ .O9.borderHover),
    Text: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_19 || (templateObject_19 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        p {\n            font-size: 16px;\n            margin: 0 0 4px 0;\n        }\n    "], ["\n        p {\n            font-size: 16px;\n            margin: 0 0 4px 0;\n        }\n    "])))
};
var Widget = {
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_20 || (templateObject_20 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        align-items: center;\n        flex-direction: ", ";\n        height: 100%;\n        justify-content: ", ";\n    "], ["\n        display: flex;\n        align-items: center;\n        flex-direction: ", ";\n        height: 100%;\n        justify-content: ", ";\n    "])), function (_a) {
        var variant = _a.variant;
        return (variant === 'secondary' ? 'column-reverse' : 'column');
    }, function (_a) {
        var isApplied = _a.isApplied;
        return (isApplied ? 'end' : 'space-between');
    }),
    SaveIconWrapper: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_21 || (templateObject_21 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        transition: background-color 0.25s;\n        display: grid;\n        place-content: center;\n        &:hover {\n            background-color: ", ";\n        }\n    "], ["\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        transition: background-color 0.25s;\n        display: grid;\n        place-content: center;\n        &:hover {\n            background-color: ", ";\n        }\n    "])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.saveIconHover */ .O9.saveIconHover),
    SaveIcon: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_22 || (templateObject_22 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        fill: hsl(105, 0%, 64%);\n        position: relative;\n        display: inline-flex;\n        svg {\n            cursor: pointer;\n            transition: all 0.25s;\n        }\n    "], ["\n        fill: hsl(105, 0%, 64%);\n        position: relative;\n        display: inline-flex;\n        svg {\n            cursor: pointer;\n            transition: all 0.25s;\n        }\n    "]))),
    AppliedBadge: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_24 || (templateObject_24 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        background-color: #eff5ea;\n        color: #609b2d;\n        padding: 5px 8px;\n        position: absolute;\n        line-height: 14px;\n        top: 1px;\n        right: 1px;\n        border-radius: 0 12px 0 12px;\n        font-size: 12px;\n        font-weight: 500;\n        ", "\n    "], ["\n        background-color: #eff5ea;\n        color: #609b2d;\n        padding: 5px 8px;\n        position: absolute;\n        line-height: 14px;\n        top: 1px;\n        right: 1px;\n        border-radius: 0 12px 0 12px;\n        font-size: 12px;\n        font-weight: 500;\n        ", "\n    "])), function (_a) {
        var isPreviewJob = _a.isPreviewJob;
        if (!isPreviewJob) {
            return '';
        }
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_23 || (templateObject_23 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                top: 0;\n                right: 0;\n            "], ["\n                top: 0;\n                right: 0;\n            "])));
    }),
    HideJobWrapper: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_25 || (templateObject_25 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        opacity: 0;\n        padding: 0 10px;\n        transition: opacity 0.25s ease-in-out;\n        ", ":hover & {\n            opacity: 1;\n        }\n        ", "\n        @media screen and (max-width: 768px) {\n            opacity: 1;\n        }\n    "], ["\n        opacity: 0;\n        padding: 0 10px;\n        transition: opacity 0.25s ease-in-out;\n        ", ":hover & {\n            opacity: 1;\n        }\n        ", "\n        @media screen and (max-width: 768px) {\n            opacity: 1;\n        }\n    "])), Container, function (_a) {
        var isShow = _a.isShow;
        return (isShow ? 'opacity: 1;' : '');
    })
};
var CompanyName = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_26 || (templateObject_26 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    font-size: 14px;\n    line-height: 18px;\n"], ["\n    font-size: 14px;\n    line-height: 18px;\n"])));
var Separate = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_27 || (templateObject_27 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    height: 14px;\n    width: 1px;\n    background-color: #c9c9c9;\n    margin: 0 6px;\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n"], ["\n    height: 14px;\n    width: 1px;\n    background-color: #c9c9c9;\n    margin: 0 6px;\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n"])));
var Salary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_28 || (templateObject_28 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: ", ";\n    @media screen and (max-width: 768px) {\n        margin-bottom: 4px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: ", ";\n    @media screen and (max-width: 768px) {\n        margin-bottom: 4px;\n    }\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.buttonColor */ .O9.buttonColor);
var Location = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_29 || (templateObject_29 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n"])));
var SkillTagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_30 || (templateObject_30 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(templateObject_31 || (templateObject_31 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    margin: 0;\n    font-size: 14px;\n    & > a {\n        cursor: pointer;\n        color: ", ";\n        transition: color 0.25s ease-in-out;\n        &:hover {\n            color: ", ";\n        }\n    }\n"], ["\n    margin: 0;\n    font-size: 14px;\n    & > a {\n        cursor: pointer;\n        color: ", ";\n        transition: color 0.25s ease-in-out;\n        &:hover {\n            color: ", ";\n        }\n    }\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.primaryColor */ .O9.primaryColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.buttonColor */ .O9.buttonColor);
var JobInvitationBlock = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_32 || (templateObject_32 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 8px;\n    padding: 4px;\n    width: 100%;\n    grid-column: 1/ -1;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-top: 16px;\n    > svg {\n        margin-right: 8px;\n        min-width: 20px;\n        min-height: 20px;\n    }\n    span {\n        white-space: normal;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        line-clamp: 1;\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 8px;\n    padding: 4px;\n    width: 100%;\n    grid-column: 1/ -1;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-top: 16px;\n    > svg {\n        margin-right: 8px;\n        min-width: 20px;\n        min-height: 20px;\n    }\n    span {\n        white-space: normal;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        line-clamp: 1;\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n    }\n"])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[90] */ .O9.green[90], _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[40] */ .O9.green[40]);
var JobInvitationIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_33 || (templateObject_33 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    align-items: center;\n    margin-right: 4px;\n    svg {\n        max-width: 20px;\n        max-height: 20px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    margin-right: 4px;\n    svg {\n        max-width: 20px;\n        max-height: 20px;\n    }\n"])));
({
    Container: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_34 || (templateObject_34 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        padding-top: 4px;\n        ul {\n            margin: 0;\n            padding-left: 26px;\n            li {\n                margin: 4px 0;\n            }\n        }\n    "], ["\n        padding-top: 4px;\n        ul {\n            margin: 0;\n            padding-left: 26px;\n            li {\n                margin: 4px 0;\n            }\n        }\n    "]))),
    Label: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_35 || (templateObject_35 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        padding: 4px 0;\n        font-weight: 500;\n    "], ["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        padding: 4px 0;\n        font-weight: 500;\n    "]))),
    Badge: styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_36 || (templateObject_36 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        color: ", ";\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 14px;\n        border-radius: 4px;\n        background: ", ";\n        padding: 2px 4px;\n    "], ["\n        color: ", ";\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 14px;\n        border-radius: 4px;\n        background: ", ";\n        padding: 2px 4px;\n    "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[50] */ .O9.green[50], _Colors_index_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[90] */ .O9.green[90])
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36;


//# sourceMappingURL=JobCard.css.js.map


/***/ }),

/***/ 38248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ badgeSettings; },
/* harmony export */   "EF": function() { return /* binding */ SERVICE_CODE_URGENT_JOB; },
/* harmony export */   "Gh": function() { return /* binding */ SUCCESS_CODE; },
/* harmony export */   "I4": function() { return /* binding */ SERVICE_CODE_HEADHUNT_JOB_MOBILE; },
/* harmony export */   "UF": function() { return /* binding */ DEFAULT_IMAGE; },
/* harmony export */   "ho": function() { return /* binding */ REQUIRED_COVER_LETTER; },
/* harmony export */   "uO": function() { return /* binding */ SERVICE_CODE_HEADHUNT_JOB; },
/* harmony export */   "ys": function() { return /* binding */ SERVICE_CODE_TOP_MANAGEMENT_JOB; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var DEFAULT_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';
var SERVICE_CODE_URGENT_JOB = 'UJ';
var SERVICE_CODE_TOP_MANAGEMENT_JOB = 'TMJ';
var SERVICE_CODE_HEADHUNT_JOB = 'JPHH';
var SERVICE_CODE_HEADHUNT_JOB_MOBILE = 'JPHM';
var SUCCESS_CODE = 200;
var REQUIRED_COVER_LETTER = 1;
var badgeSettings = {
    premium: {
        name: 'Premium'
    },
    urgent: {
        name: 'Urgent'
    },
    topManagement: {
        name: 'Top management',
        utm: '?utm_source_navi=vnw_searchresults&utm_medium_navi=TopManagementJobs'
    },
    headHunter: {
        name: 'Head hunter'
    }
};


//# sourceMappingURL=constant.js.map


/***/ }),

/***/ 59304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JobCard; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/JobCard.css.js
var JobCard_css = __webpack_require__(8203);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(41524);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/Components/SkillTag/SkillTag.css.js
'use client';




var ListItem = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-flow: row wrap;\n    margin-left: -2px;\n    margin-right: -2px;\n    margin-top: -4px;\n    list-style: none;\n    margin-bottom: 0;\n    padding: 0;\n    width: fit-content;\n"], ["\n    display: flex;\n    flex-flow: row wrap;\n    margin-left: -2px;\n    margin-right: -2px;\n    margin-top: -4px;\n    list-style: none;\n    margin-bottom: 0;\n    padding: 0;\n    width: fit-content;\n"])));
var Item = styled_components_browser_esm/* default.li */.ZP.li(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 2px;\n    padding-right: 2px;\n    margin-top: 4px;\n"], ["\n    padding-left: 2px;\n    padding-right: 2px;\n    margin-top: 4px;\n"])));
var templateObject_1, templateObject_2;


//# sourceMappingURL=SkillTag.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Tag/index.js + 2 modules
var Tag = __webpack_require__(149);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/index.js + 2 modules
var SimpleTooltip = __webpack_require__(17068);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/Components/SkillTag/index.js
'use client';













var LIMIT_ITEMS = 3;
var LIMIT_RATIO = 0.8;
var SkillTag = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b;
    var _c = (0,react.useState)(data ? data.filter(function (item) { return item; }) : []), listSkills = _c[0], setListSkills = _c[1];
    var _d = (0,react.useState)([]), hiddenSkills = _d[0], setHiddenSkills = _d[1];
    var containerRef = (0,react.useRef)(null);
    var isComplete = (0,react.useRef)(false);
    var handleSliceData = function (data, to, limit) {
        var cloneData = (0,_tslib/* __spreadArray */.ev)([], data, true);
        var listSkills = cloneData.slice(0, to);
        var hiddenSkills = cloneData.slice(to, limit);
        setListSkills(listSkills);
        setHiddenSkills(hiddenSkills);
        isComplete.current = true;
    };
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        var _a;
        if ((0,responsiveHelper/* isPhone */.Mn)())
            return;
        var filtedData = data ? data.filter(function (item) { return item; }) : [];
        if (!isComplete.current) {
            if (containerRef && containerRef.current) {
                var containerElement = containerRef.current;
                var containerWidth = containerElement.getBoundingClientRect().width;
                var parentWidth = ((_a = containerElement.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
                var limitWidth_1 = parentWidth * LIMIT_RATIO;
                if (containerWidth > limitWidth_1) {
                    var validWidth_1 = 0;
                    var validChildren_1 = 0;
                    Array.from(containerElement.childNodes).some(function (children) {
                        if (validWidth_1 > limitWidth_1) {
                            return true;
                        }
                        validWidth_1 += children.clientWidth;
                        validChildren_1++;
                        if (validChildren_1 > LIMIT_ITEMS)
                            return true;
                        return false;
                    });
                    handleSliceData(filtedData, validChildren_1 - 1, filtedData.length);
                    return;
                }
                if (filtedData.length > LIMIT_ITEMS) {
                    handleSliceData(filtedData, LIMIT_ITEMS, filtedData.length);
                }
            }
        }
    }, [data]);
    var renderHiddenSkillText = hiddenSkills.map(function (skill) { return skill.skillName; }).join(', ');
    return (react.createElement(ListItem, { ref: containerRef },
        listSkills.map(function (skill) {
            if (skill === null) {
                return null;
            }
            var skillId = skill.skillId, skillName = skill.skillName;
            return (react.createElement(Item, { key: skillId },
                react.createElement(Tag/* default */.Z, { maxWidth: (0,responsiveHelper/* isPhone */.Mn)() ? 'unset' : '150px', size: 'extra-small', label: skillName !== null && skillName !== void 0 ? skillName : '', isMobile: false, readOnly: true, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792',
                        styles: { padding: '2px 4px' }
                    } })));
        }),
        hiddenSkills.length > 0 && (react.createElement(Item, { key: 'hidden-skills' },
            react.createElement(SimpleTooltip/* default */.Z, { content: renderHiddenSkillText, referenceElement: react.createElement(Tag/* default */.Z, { size: 'extra-small', label: "+".concat(hiddenSkills.length), isMobile: false, readOnly: true, enableTooltip: false, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792',
                        styles: { padding: '2px 4px' }
                    } }) })))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/Components/Images/SaveLoadingIcon.js
var SaveLoadingIcon = __webpack_require__(75243);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/Components/Images/MatchedJob.js
'use client';



var MatchedJob = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 18 : _b;
    return (react.createElement("svg", { width: size, height: size, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M1.5 3.75h6a.75.75 0 0 1 .75.75v8.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75Zm1.406 3.495v.338c-.06.195-.218.266-.396.346-.24.107-.517.231-.635.696h3c-.118-.465-.394-.589-.635-.696-.178-.08-.336-.151-.396-.346v-.338c.07-.038.272-.297.293-.5.055-.004.142-.06.167-.277.014-.116-.041-.182-.074-.202 0 0 .082-.17.082-.375 0-.412-.148-.762-.468-.762 0 0-.111-.254-.469-.254-.663 0-.938.46-.938 1.016 0 .187.083.375.083.375-.033.02-.088.086-.074.202.026.218.113.273.168.277.02.203.222.462.292.5ZM2.25 12h4.5a.375.375 0 0 0 0-.75h-4.5a.375.375 0 0 0 0 .75Zm0-1.5h4.5a.375.375 0 0 0 0-.75h-4.5a.375.375 0 0 0 0 .75ZM6 8.625h.75a.375.375 0 0 0 0-.75H6a.375.375 0 0 0 0 .75Zm0-1.5h.75a.375.375 0 0 0 0-.75H6a.375.375 0 0 0 0 .75Zm7.5 2.625 1-2 2-1-2-1-1-2-1 2-2 1 2 1 1 2Zm2.25 4.5.75-1.5L18 12l-1.5-.75-.75-1.5-.75 1.5-1.5.75 1.5.75.75 1.5Z', fill: '#6B7792' })));
};


//# sourceMappingURL=MatchedJob.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/index.js + 8 modules
var BadgeTag = __webpack_require__(25139);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/constant.js
var constant = __webpack_require__(38248);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/translations.js
'use client';

var translations = {
    New: 'Mới',
    'Login to view salary': 'Đăng nhập để xem lương',
    Posted: 'Đã đăng',
    'Expires: ': 'Hết hạn: ',
    in: 'trong',
    'Expires on today': 'Hết hạn trong hôm nay',
    day: 'ngày',
    s: '',
    Bonus: 'Thưởng',
    'Healthcare Plan': 'Khám sức khỏe',
    'Paid Leave': 'Nghỉ phép',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Laptop',
    Mobile: 'Điện thoại',
    'Travel Opportunities': 'Du lịch',
    'Team Activities': 'Hoạt động',
    Transportation: 'Trợ cấp đi lại',
    Canteen: 'Căn-tin',
    Vouchers: 'Thưởng quà',
    Kindergarten: 'Trông trẻ',
    Others: 'Khác',
    Applied: 'Đã nộp đơn',
    'You should': 'Bạn phải',
    'Sign In': 'đăng nhập',
    'to save jobs': 'để lưu công việc',
    'Save job successfully': 'Lưu công việc thành công',
    'Remove job successfully': 'Xóa công việc thành công',
    Updated: 'Cập nhật',
    Today: 'Hôm nay',
    'Posted 3 days ago': 'Cập nhật cách đây 3 ngày',
    'Posted on': 'Đăng ngày',
    'You have': 'Bạn còn',
    'days to apply': 'ngày để ứng tuyển',
    'day to apply': 'ngày để ứng tuyển',
    Expire: 'Hết hạn',
    'TODAY!': 'HÔM NAY!',
    'Latest ': '',
    'employment/hiring with high salary & attractive benefits': 'tuyển dụng - Tìm việc mới nhất, lương thưởng hấp dẫn.',
    '/job-channel/top-management': '/kenh-viec-lam/quan-ly',
    '/management-jobs': '/viec-lam-quan-ly',
    Featured: 'Tiêu biểu',
    Matching: 'Phù Hợp',
    'This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.': 'Việc làm này phù hợp với các tiêu chí sau trong hồ sơ của bạn: Chức danh, Kỹ năng, Địa điểm làm việc, Ngành nghề.',
    'Information of this employer is hidden for confidentiality purposes.': 'Thông tin nhà tuyển dụng đã được ẩn đi vì mục đích bảo mật.',
    'Trusted company': 'Công ty uy tín',
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    Success: 'Thành công',
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Employer highly values your resume and has sent you an invitation to apply.': 'Nhà tuyển dụng đánh giá cao hồ sơ của bạn và đã gửi lời mời ứng tuyển.',
    'AI summary': 'AI tóm tắt'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/time.js
var time = __webpack_require__(56665);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/utils.js
'use client';




function convertISOToMillisecond(dateTime) {
    return Date.parse(dateTime) / 1000;
}
var SERVICE_CODE_REFRESH_JOB_CLP_REWARD = 'RJF';
var checkIsNew = function (item) {
    if (item.onlineServiceCode === SERVICE_CODE_REFRESH_JOB_CLP_REWARD) {
        return false;
    }
    return (0,time/* convertDateTime */.jF)(new Date(item.onlineOn || ''), 7) === (0,time/* convertDateTime */.jF)(Date.now(), 7);
};
var buildCompanyUrl = function (companyId, companyName, langCode) {
    var companyNameStr = (0,helpers/* slugify */.lV)(companyName);
    var prefixCompanyPath = langCode === 'vi' ? 'nha-tuyen-dung' : 'companies';
    return "/".concat(prefixCompanyPath, "/").concat(companyNameStr, "-c").concat(companyId);
};
var formatedJob = function (job) {
    var categoryVIs = [];
    var categoryIds = [];
    var categories = [];
    var locationIds = [];
    var locationVIs = [];
    var locations = [];
    var services = [];
    if (job.industries !== null && job.industries !== undefined) {
        job.industries.map(function (industry) {
            categoryVIs.push(industry.industryNameVI);
            categoryIds.push(industry.industryId);
            categories.push(industry.industryName);
        });
    }
    if (job.workingLocations !== null && job.workingLocations !== undefined) {
        job.workingLocations.map(function (wl) {
            locationIds.push(wl.workingLocationId);
            if (locationVIs && locationVIs.indexOf(wl.cityNameVI) < 0) {
                locationVIs.push(wl.cityNameVI);
            }
            if (locations && locations.indexOf(wl.cityName) < 0) {
                locations.push(wl.cityName);
            }
        });
    }
    if (job.services !== null && job.services !== undefined) {
        job.services.map(function (service) {
            services.push(service.serviceCode);
        });
    }
    return {
        categoryVIs: categoryVIs,
        categoryIds: categoryIds,
        categories: categories,
        locationVIs: locationVIs,
        locationIds: locationIds,
        locations: locations,
        serviceCode: services,
        isPremium: !job.simpleServices ? false : job.simpleServices.includes('isPremium'),
        isHeadhuntJob: !job.simpleServices ? false : job.simpleServices.includes('isHeadhunt'),
        isUrgentJob: job.isUrgentJob,
        isTopManagementJob: !services ? false : services.includes('TMJ'),
        isPriorityJob: !services ? false : services.includes('PJ')
    };
};


//# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SettingJob/index.js + 2 modules
var SettingJob = __webpack_require__(67366);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/services.js
var services = __webpack_require__(79430);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/Images/HeartFillIcon.js
var HeartFillIcon = __webpack_require__(8842);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/index.js + 5 modules
var PreviewJob = __webpack_require__(91867);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/index.js + 14 modules
var InfoOverviewGroupIcons = __webpack_require__(67824);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/index.js + 6 modules
var MiscGroupIcons = __webpack_require__(70203);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/index.js + 2 modules
var ApplyJobs = __webpack_require__(83699);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(36802);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MailAddIcon/index.js
var MailAddIcon = __webpack_require__(29082);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementOnScreen/index.js
var UseElementOnScreen = __webpack_require__(85694);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/image.js
var Utils_image = __webpack_require__(4053);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/index.js
'use client';




























































































































































var JobCard = function (props) {
    var _a, _b, _c;
    var data = props.data, langCode = props.langCode, robot = props.robot, isMobile = props.isMobile, api = props.api, isManagementJobPage = props.isManagementJobPage, custom = props.custom, _d = props.utm, utm = _d === void 0 ? '' : _d, _e = props.companyUTM, companyUTM = _e === void 0 ? '' : _e, _f = props.classSelector, classSelector = _f === void 0 ? '' : _f, userInfo = props.userInfo, _g = props.isJobSearchPage, isJobSearchPage = _g === void 0 ? false : _g, _h = props.nextImage, nextImage = _h === void 0 ? null : _h, _j = props.isForceJobLinkVI, isForceJobLinkVI = _j === void 0 ? false : _j, headingTagTitleJob = props.headingTagTitleJob, trackingSetting = props.trackingSetting;
    var previewJob = (0,_tslib/* __assign */.pi)({ enable: true }, props.previewJob);
    var _k = custom || {}, _l = _k.haveRoundedBorder, haveRoundedBorder = _l === void 0 ? true : _l, _m = _k.noBorderTop, noBorderTop = _m === void 0 ? false : _m, _o = _k.forceNormalJob, forceNormalJob = _o === void 0 ? false : _o, _p = _k.variant, variant = _p === void 0 ? 'primary' : _p;
    var jobCardRef = (0,react.useRef)(null);
    var _q = (0,react.useState)(false), isShowApplyPopup = _q[0], setShowApplyPopup = _q[1];
    var _r = (0,react.useState)(false), isHideJob = _r[0], setHideJob = _r[1];
    var _s = (0,react.useState)(!!(data === null || data === void 0 ? void 0 : data.isSaved)), isSaved = _s[0], setSaved = _s[1];
    var _t = (0,react.useState)(false), isSaveLoading = _t[0], setSaveLoading = _t[1];
    var _u = (0,react.useState)(false), isShowSettingJob = _u[0], setShowSettingJob = _u[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: jobCardRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var isAleadyTrackingViewJob = (0,react.useRef)(false);
    var formatedJobData = formatedJob(data);
    // Premium job can't detect by service code
    var serviceCode = formatedJobData.serviceCode, isPremium = formatedJobData.isPremium, isUrgentJob = formatedJobData.isUrgentJob, isTopManagementJob = formatedJobData.isTopManagementJob, isHeadhuntJob = formatedJobData.isHeadhuntJob;
    var badges = [];
    if (robot === null || robot === void 0 ? void 0 : robot.enable) {
        isUrgentJob = serviceCode.indexOf(constant/* SERVICE_CODE_URGENT_JOB */.EF) > -1;
        isTopManagementJob = serviceCode.indexOf(constant/* SERVICE_CODE_TOP_MANAGEMENT_JOB */.ys) > -1;
        isHeadhuntJob =
            serviceCode.indexOf(constant/* SERVICE_CODE_HEADHUNT_JOB */.uO) > -1 ||
                serviceCode.indexOf(constant/* SERVICE_CODE_HEADHUNT_JOB_MOBILE */.I4) > -1;
    }
    var showLogo = !!(data.companyLogo && data.isShowLogo && !data.isAnonymous);
    var location = langCode === constants/* ELanguage.EN */.Df.EN
        ? (formatedJobData.locations || []).join(', ')
        : (formatedJobData.locationVIs || []).join(', ');
    var isLogin = !!(api === null || api === void 0 ? void 0 : api.accessToken);
    var boldAndRed = ((data.isBoldAndRedJob || data.visibilityDisplay) && forceNormalJob === false) || false;
    var shouldMakeJobPriority = data.priorityOrder !== undefined && convertISOToMillisecond(data.priorityOrder) > 0 && !isManagementJobPage;
    var companyUrl = buildCompanyUrl(data.companyId || 0, data.companyName || '', langCode);
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var handleUnsavedJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var success;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLogin) {
                        /* redirectToLogin() */
                        return [2 /*return*/];
                    }
                    setSaveLoading(true);
                    return [4 /*yield*/, (0,services/* unsaveJob */.z)({
                            jobId: data.jobId,
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    success = (_a.sent()).data;
                    setSaveLoading(false);
                    if (success) {
                        setSaved(false);
                        (0,Toast/* showToast */.CF)(t('Success'), t('Just removed 1 save job'));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveJob = function (isFromPreviewJob) {
        if (isFromPreviewJob === void 0) { isFromPreviewJob = false; }
        return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var success;
            var _a;
            return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isLogin) {
                            /* redirectToLogin() */
                            return [2 /*return*/];
                        }
                        setSaveLoading(true);
                        return [4 /*yield*/, (0,services/* saveJob */.P)({
                                jobId: data.jobId,
                                accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                                language: langCode,
                                baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                            })];
                    case 1:
                        success = (_b.sent()).data;
                        setSaveLoading(false);
                        if (success) {
                            tracking({
                                eventName: 'js_job_management:save_job_click',
                                properties: {
                                    jobId: (_a = data === null || data === void 0 ? void 0 : data.jobId) !== null && _a !== void 0 ? _a : -1,
                                    pageZone: isFromPreviewJob ? 'preview' : 'job_card_full'
                                }
                            });
                            setSaved(true);
                            (0,Toast/* showToast */.CF)(t('Success'), react.createElement("div", null,
                                t('You have saved job, view'),
                                ' ',
                                react.createElement("a", { href: t('/my-career-center/my-jobs?section=saved') }, t('My jobs'))));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleLogin = function () {
        if (isLogin) {
            return;
        }
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en',
                isNeedReload: false
            }
        });
        window.dispatchEvent(loginEvent);
    };
    (0,react.useEffect)(function () {
        setSaved(data.isSaved || false);
    }, [data]);
    (0,react.useEffect)(function () {
        var _a, _b, _c, _d;
        if ((trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.isTrackingOnSeen) && isElementOnScreen && !isAleadyTrackingViewJob.current) {
            var properties = {
                jobTitle: data.jobTitle,
                prettySalary: (data === null || data === void 0 ? void 0 : data.prettySalary) === 'Thương lượng' ? 'Negotiable' : (data === null || data === void 0 ? void 0 : data.prettySalary) || '',
                createdOn: (data === null || data === void 0 ? void 0 : data.createdOn) || '',
                workingLocationCityId: ((data === null || data === void 0 ? void 0 : data.workingLocations) || []).map(function (item) { return item.cityId; }),
                expiredDate: data.expiredOn,
                jobIndustryId: ((data === null || data === void 0 ? void 0 : data.industriesV3) || []).map(function (item) { return item.industryV3Id; }),
                jobFunctionId: (_a = data === null || data === void 0 ? void 0 : data.jobFunctionsV3) === null || _a === void 0 ? void 0 : _a.jobFunctionV3Id,
                jobGroupFunctionId: (_b = data === null || data === void 0 ? void 0 : data.groupJobFunctionsV3) === null || _b === void 0 ? void 0 : _b.groupJobFunctionV3Id,
                jobLevelId: Number(data === null || data === void 0 ? void 0 : data.jobLevelId),
                typeWorkingId: data === null || data === void 0 ? void 0 : data.typeWorkingId,
                skillTag: ((data === null || data === void 0 ? void 0 : data.skills) || []).map(function (item) { return item.skillName; }).join(', '),
                isCoverLetterRequired: (data === null || data === void 0 ? void 0 : data.requiredCoverLetter)
                    ? (data === null || data === void 0 ? void 0 : data.requiredCoverLetter) === constant/* REQUIRED_COVER_LETTER */.ho
                    : false,
                jobId: data.jobId,
                isAnonymous: data.isAnonymous,
                isPremium: isPremium,
                isHeadhunt: isHeadhuntJob,
                isUrgent: isUrgentJob,
                isUrgentM: data === null || data === void 0 ? void 0 : data.isUrgentJobM,
                isTopmanagement: isTopManagementJob,
                isAdr: data === null || data === void 0 ? void 0 : data.isAdrLiteJob,
                isBoldandred: boldAndRed,
                isBoldandredM: data === null || data === void 0 ? void 0 : data.isBoldAndRedJobM,
                isPriority: shouldMakeJobPriority,
                isPriorityM: shouldMakeJobPriority && (data === null || data === void 0 ? void 0 : data.isTopPriorityM),
                isNew: checkIsNew(data),
                companyId: Number(data === null || data === void 0 ? void 0 : data.companyId)
            };
            if (data.jobInvitation && ((_c = data.jobInvitation) === null || _c === void 0 ? void 0 : _c.jobInvitationId) > 0) {
                properties.invitationId = (_d = data === null || data === void 0 ? void 0 : data.jobInvitation) === null || _d === void 0 ? void 0 : _d.jobInvitationId;
            }
            tracking({
                eventName: 'js_search_result_page:search_job_impression',
                properties: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.additionalField), properties)
            });
            isAleadyTrackingViewJob.current = true;
        }
    }, [isElementOnScreen]);
    var renderMatchTooltipBadge = function (isHaveSeparator) {
        return (data === null || data === void 0 ? void 0 : data.isMatching) ? (react.createElement(SimpleTooltip/* default */.Z, { className: 'matched-job', tooltipClassName: 'matched-job-tooltip', custom: { maxWidth: '220px' }, content: t('This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.'), isMobile: isMobile, referenceElement: react.createElement(JobCard_css/* BadgeMatchJob */.Zc, { isHaveSeparator: isHaveSeparator },
                react.createElement(MatchedJob, null),
                react.createElement("span", null, t('Matching'))) })) : null;
    };
    var renderBadges = function () {
        if (forceNormalJob || variant === 'secondary') {
            return null;
        }
        if (isUrgentJob || data.isUrgentJobM) {
            badges.push(constant/* badgeSettings.urgent */.Br.urgent);
        }
        if (isPremium) {
            badges.push(constant/* badgeSettings.premium */.Br.premium);
        }
        if (isHeadhuntJob) {
            badges.push(constant/* badgeSettings.headHunter */.Br.headHunter);
        }
        if (isTopManagementJob) {
            badges.push(constant/* badgeSettings.topManagement */.Br.topManagement);
        }
        if (badges.length === 0) {
            return (react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, { notMargin: !data.isMatching },
                react.createElement(JobCard_css/* Badge.Container */.Ct.Container, null, renderMatchTooltipBadge(false))));
        }
        return (react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, null,
            react.createElement(JobCard_css/* Badge.Container */.Ct.Container, null,
                badges.map(function (badge, index) {
                    if (badge.utm) {
                        return (react.createElement(JobCard_css/* Badge.Wrapper */.Ct.Wrapper, { key: "".concat(badge.name, "-").concat(index) },
                            react.createElement(BadgeTag/* default */.Z, { key: badge.name, type: badge.name, langCode: langCode, utm: badge.utm })));
                    }
                    else {
                        return (react.createElement(JobCard_css/* Badge.Wrapper */.Ct.Wrapper, { key: "".concat(badge.name, "-").concat(index) },
                            react.createElement(BadgeTag/* default */.Z, { type: badge.name, langCode: langCode })));
                    }
                }),
                renderMatchTooltipBadge(true))));
    };
    var renderPostedJobDay = function () {
        var priorityOrder = new Date(data.priorityOrder || '').getTime();
        var postedDate = data.onlineOnText;
        if (new RegExp('sortBy=latest|sortBy=oldest', 'g').test(utm)) {
            postedDate = data.approvedOnText;
        }
        else if (priorityOrder > 0) {
            postedDate = data.priorityOrderText;
        }
        return postedDate;
    };
    var renderHideJob = function () {
        return (react.createElement(JobCard_css/* HideJob.Container */.QV.Container, null,
            react.createElement(JobCard_css/* HideJob.Text */.QV.Text, null,
                react.createElement("p", null, t('Job hidden')),
                react.createElement("span", null, t('You will not see this job on the search page.'))),
            react.createElement(SettingJob/* default */.Z, { api: {
                    baseUrl: api.baseUrl,
                    accessToken: api.accessToken,
                    appId: (api === null || api === void 0 ? void 0 : api.appId) || '',
                    source: (api === null || api === void 0 ? void 0 : api.source) || ''
                }, jobId: data.jobId || 0, langCode: langCode, isHide: isHideJob, onHideJobClick: function () { return setHideJob(!isHideJob); } })));
    };
    var renderAppliedTextAndSaveIcon = function () {
        var isApplied = data.isApplied;
        return (react.createElement(react.Fragment, null, isApplied ? (react.createElement(JobCard_css/* Widget.AppliedBadge */.$L.AppliedBadge, null, t('Applied')) // applied Text
        ) : (react.createElement(JobCard_css/* Widget.SaveIconWrapper */.$L.SaveIconWrapper, { className: 'SJ_SaveJob', onClick: handleLogin },
            react.createElement(JobCard_css/* Widget.SaveIcon */.$L.SaveIcon, { onClick: function () { return (isSaved ? handleUnsavedJob() : handleSaveJob()); } }, !isSaveLoading ? (isSaved ? (react.createElement(HeartFillIcon/* default */.Z, { width: 24 })) : (react.createElement(MiscGroupIcons/* default.UnFavoriteIcon */.Z.UnFavoriteIcon, { width: 24, color: Colors/* colors.primary.60 */.O9.primary[60] }))) : (react.createElement(SaveLoadingIcon/* default */.Z, null)))))));
    };
    var linkJobLangCode = langCode === constants/* ELanguage.EN */.Df.EN ? 'en' : 'vi';
    if (isForceJobLinkVI) {
        linkJobLangCode = 'vi';
    }
    var jobUrl = (0,helpers/* generateJobUrl */.z6)(data.jobId || 0, data.alias || '', linkJobLangCode, '', utm);
    var previewJobUrl = jobUrl;
    if (data.jobInvitation && data.jobInvitation.jobInvitationId > 0) {
        var prefixQueryParams = jobUrl.indexOf('?') > 0 ? '&' : '?';
        jobUrl += "".concat(prefixQueryParams, "utm_source=job_search_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
        previewJobUrl += "".concat(prefixQueryParams, "utm_source=preview_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
    }
    var renderTitle = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var isNew = checkIsNew(data);
        var title = function () {
            return headingTagTitleJob === 'h3' ? (react.createElement("h3", { style: { fontSize: '18px' } },
                react.createElement("a", { href: jobUrl, target: isMobile ? '_self' : '_blank', "data-new-job": t('New') },
                    isNew ? react.createElement("span", null,
                        t('New'),
                        " ") : '',
                    data.jobTitle))) : (react.createElement("h2", null,
                react.createElement("a", { href: jobUrl, target: isMobile ? '_self' : '_blank', "data-new-job": t('New') },
                    isNew ? react.createElement("span", null,
                        t('New'),
                        " ") : '',
                    data.jobTitle)));
        };
        if (variant === 'secondary') {
            return react.createElement(JobCard_css/* JobTitleSecondary */.N9, null, data.jobTitle);
        }
        return !isMobile && previewJob.enable ? (react.createElement(react.Fragment, null,
            react.createElement(PreviewJob/* default */.Z, { content: {
                    jobId: (_a = data.jobId) !== null && _a !== void 0 ? _a : 0,
                    logo: (_b = data.companyLogo) !== null && _b !== void 0 ? _b : '',
                    title: (_c = data.jobTitle) !== null && _c !== void 0 ? _c : '',
                    salary: (_d = data.prettySalary) !== null && _d !== void 0 ? _d : '',
                    jobLevel: langCode === constants/* ELanguage.VI */.Df.VI ? data.jobLevelVI : data.jobLevel,
                    address: (_e = data.address) !== null && _e !== void 0 ? _e : '',
                    jobDescription: (_f = data.jobDescription) !== null && _f !== void 0 ? _f : '',
                    jobRequirements: (_g = data.jobRequirement) !== null && _g !== void 0 ? _g : '',
                    link: previewJobUrl,
                    isSaved: isSaved,
                    isApplied: !!data.isApplied,
                    isBlackList: !!data.isBlackList,
                    redirectTo: data.redirectTo || '',
                    jobInvitation: (_h = data.jobInvitation) !== null && _h !== void 0 ? _h : { jobInvitationId: 0, status: 0 }
                }, api: {
                    disableSelfApi: true
                }, onSaveClick: function () { return (isSaved ? handleUnsavedJob() : handleSaveJob(true)); }, onApplyClick: function () { return setShowApplyPopup(true); }, langCode: langCode, isLogin: isLogin }, title()),
            react.createElement(ApplyJobs/* default */.ZP, { accessToken: (_j = api === null || api === void 0 ? void 0 : api.accessToken) !== null && _j !== void 0 ? _j : '', isOpen: isShowApplyPopup, langCode: langCode, user: userInfo, jobInfo: data, baseMsUrl: (_k = api.baseUrl) !== null && _k !== void 0 ? _k : '', baseUrl: (_l = previewJob === null || previewJob === void 0 ? void 0 : previewJob.baseUrl) !== null && _l !== void 0 ? _l : '', initData: props.initData, onClose: function () { return setShowApplyPopup(false); } }))) : (title());
    };
    var renderCompanyName = function () {
        if (variant === 'secondary')
            return;
        if (companyUrl && !data.isAnonymous) {
            var companyUrlWithUtm = "".concat(companyUrl);
            if (companyUTM !== '') {
                companyUrlWithUtm += "?".concat(companyUTM);
            }
            return (react.createElement("a", { href: companyUrlWithUtm, target: isMobile ? '_self' : '_blank', title: data.companyName, rel: 'noreferrer' }, data.companyName));
        }
        return (react.createElement("span", { className: 'company-name', title: !data.isAnonymous
                ? data.companyName
                : t('Information of this employer is hidden for confidentiality purposes.') }, !data.isAnonymous ? data.companyName : "Vietnamworks' Client"));
    };
    // Init next/image component
    var NextImageWrapper = nextImage !== null ? nextImage() : null;
    return (react.createElement(JobCard_css/* Container */.W2, { ref: jobCardRef, className: classSelector }, isHideJob ? (renderHideJob()) : (react.createElement(JobCard_css/* Wrapper */.im, { isPriorityJob: shouldMakeJobPriority && forceNormalJob === false, haveRoundedBorder: haveRoundedBorder, noBorderTop: noBorderTop, variant: variant, style: variant === 'secondary' ? { columnGap: 'unset' } : undefined },
        variant === 'secondary' ? null : (react.createElement(JobCard_css/* Left.Container */.dv.Container, null,
            react.createElement("a", { className: 'img_job_card', href: jobUrl, target: isMobile ? '_self' : '_blank', title: data.jobTitle, rel: 'noreferrer' }, nextImage !== null && NextImageWrapper !== null ? (react.createElement(JobCard_css/* NextImageContainer */.JM, null,
                react.createElement(NextImageWrapper, { loader: Utils_image/* imageLoader */.X, src: showLogo ? data.companyLogo : constant/* DEFAULT_IMAGE */.UF, alt: data.jobTitle, layout: 'fill' }))) : (react.createElement(JobCard_css/* Left.Avatar */.dv.Avatar, { src: showLogo ? data.companyLogo : constant/* DEFAULT_IMAGE */.UF, loading: 'lazy', alt: data.jobTitle }))))),
        react.createElement(JobCard_css/* Right.Container */.O6.Container, null,
            react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, { cssString: variant === 'primary'
                    ? "\n                                height: 20px;\n                                @media screen and (max-width: 768px) {\n                                  height: auto;\n                                }\n                            "
                    : '' },
                react.createElement(JobCard_css/* Right.Title */.O6.Title, { isMobile: isMobile, isNew: checkIsNew(data), isPriorityJob: boldAndRed !== null && boldAndRed !== void 0 ? boldAndRed : false, isApplied: data.isApplied || false, langcode: langCode, isViewed: !!(isJobSearchPage && data.isViewed) }, renderTitle())),
            renderBadges(),
            react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, null,
                react.createElement(JobCard_css/* CompanyName */.zo, null, renderCompanyName())),
            react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, { flexLayout: variant === 'primary', displayColumnOnMobile: true, cssString: "\n                              align-items: center;\n                              line-height: 18px;\n                              @media screen and (max-width: 768px) {\n                                align-items: unset;\n                              }\n                            " },
                react.createElement(JobCard_css/* Salary */.Zb, { style: variant === 'secondary' ? { marginBottom: 4 } : undefined },
                    variant === 'secondary' && react.createElement(InfoOverviewGroupIcons/* default.SalaryIcon */.Z.SalaryIcon, { width: 16, height: 16 }),
                    data.prettySalary),
                variant === 'primary' && react.createElement(JobCard_css/* Separate */.hG, null),
                react.createElement(JobCard_css/* Location */.Ye, null,
                    variant === 'secondary' && react.createElement(InfoOverviewGroupIcons/* default.AddressIcon */.Z.AddressIcon, { width: 16, height: 16 }),
                    location)),
            variant === 'primary' && (react.createElement(JobCard_css/* Right.Wrapper */.O6.Wrapper, { flexLayout: true, notMargin: true, alignCenter: true, hiddenOnMobile: true, cssString: "\n                                line-height: 18px;\n                                height: 18px;\n                            " },
                react.createElement(JobCard_css/* Right.Text */.O6.Text, null, renderPostedJobDay()),
                data.skills && data.skills.length > 0 ? (react.createElement(react.Fragment, null,
                    react.createElement(JobCard_css/* Separate */.hG, null),
                    react.createElement(JobCard_css/* SkillTagWrapper */._c, null,
                        react.createElement(SkillTag, { data: data.skills || [] })))) : null))),
        variant === 'primary' ? (react.createElement(JobCard_css/* Widget.Container */.$L.Container, { isApplied: data.isApplied || false, variant: variant },
            renderAppliedTextAndSaveIcon(),
            react.createElement(JobCard_css/* Widget.HideJobWrapper */.$L.HideJobWrapper, { isShow: isMobile || isShowSettingJob },
                react.createElement(SettingJob/* default */.Z, { className: 'hide-job', type: 'horizontal', api: {
                        baseUrl: api.baseUrl,
                        accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                        appId: (api === null || api === void 0 ? void 0 : api.appId) || '',
                        source: (api === null || api === void 0 ? void 0 : api.source) || ''
                    }, jobId: (_a = data.jobId) !== null && _a !== void 0 ? _a : 0, langCode: langCode, isHide: isHideJob, onHideJobClick: function () { return setHideJob(!isHideJob); }, onShowChange: setShowSettingJob })))) : null,
        data.jobInvitation &&
            ((_b = data.jobInvitation) === null || _b === void 0 ? void 0 : _b.jobInvitationId) > 0 &&
            ((_c = data.jobInvitation) === null || _c === void 0 ? void 0 : _c.status) === 0 ? (react.createElement(JobCard_css/* JobInvitationBlock */.Fk, null,
            react.createElement(MailAddIcon/* default */.Z, null),
            ' ',
            react.createElement("span", null, t('Employer highly values your resume and has sent you an invitation to apply.')))) : null))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 79430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ saveJob; },
/* harmony export */   "z": function() { return /* binding */ unsaveJob; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96306);
/* harmony import */ var _constant_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38248);
'use client';





var saveJob = function (_a) {
    var _b = _a.jobId, jobId = _b === void 0 ? -1 : _b, _c = _a.accessToken, accessToken = _c === void 0 ? '' : _c, _d = _a.language, language = _d === void 0 ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.VI */ .Df.VI : _d, _e = _a.baseUrl, baseUrl = _e === void 0 ? '' : _e;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var apiUrl, res;
        var _f;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .Jh)(this, function (_g) {
            switch (_g.label) {
                case 0:
                    apiUrl = baseUrl + '/api-gateway/v1.0/save-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': language
                            },
                            body: JSON.stringify({ jobId: jobId })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _g.sent();
                    if (((_f = res === null || res === void 0 ? void 0 : res.meta) === null || _f === void 0 ? void 0 : _f.code) === _constant_js__WEBPACK_IMPORTED_MODULE_2__/* .SUCCESS_CODE */ .Gh) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var unsaveJob = function (_a) {
    var _b = _a.jobId, jobId = _b === void 0 ? -1 : _b, _c = _a.accessToken, accessToken = _c === void 0 ? '' : _c, _d = _a.language, language = _d === void 0 ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.VI */ .Df.VI : _d, _e = _a.baseUrl, baseUrl = _e === void 0 ? '' : _e;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var apiUrl, res;
        var _f;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .Jh)(this, function (_g) {
            switch (_g.label) {
                case 0:
                    apiUrl = baseUrl + '/api-gateway/v1.0/unsave-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': language
                            },
                            body: JSON.stringify({ jobId: jobId })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _g.sent();
                    if (((_f = res === null || res === void 0 ? void 0 : res.meta) === null || _f === void 0 ? void 0 : _f.code) === _constant_js__WEBPACK_IMPORTED_MODULE_2__/* .SUCCESS_CODE */ .Gh) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};


//# sourceMappingURL=services.js.map


/***/ }),

/***/ 53704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JobFunction; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobFunction/JobFunction.css.js
'use client';





var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .placeholder {\n        color: ", ";\n        font-style: normal;\n    }\n"], ["\n    .placeholder {\n        color: ", ";\n        font-style: normal;\n    }\n"])), Colors/* colors.grey.60 */.O9.grey[60]);
var templateObject_1;


//# sourceMappingURL=JobFunction.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/index.js + 32 modules
var Cascader = __webpack_require__(1136);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobFunction/index.js
'use client';






var JobFunction = function (props) {
    var _a, _b, _c, _d, _e;
    var langCode = props.langCode, data = props.data, isMobile = props.isMobile, onChange = props.onChange, value = props.value, floatingConfig = props.floatingConfig, onBlur = props.onBlur, hasError = props.hasError, _f = props.isFlex, isFlex = _f === void 0 ? false : _f, _g = props.placeholderColor, placeholderColor = _g === void 0 ? '#999' : _g, _h = props.isSingleSelect, isSingleSelect = _h === void 0 ? false : _h, _j = props.displayAsPopup, displayAsPopup = _j === void 0 ? false : _j, _k = props.hiddenFooter, hiddenFooter = _k === void 0 ? false : _k, _l = props.textOptions, textOptions = _l === void 0 ? {
        placeholder: '',
        primaryBtnText: '',
        secondaryBtnText: ''
    } : _l, styleOptions = props.styleOptions, _m = props.msBaseUrl, msBaseUrl = _m === void 0 ? '' : _m, lockTarget = props.lockTarget, scrollLockMode = props.scrollLockMode, forResponsive = props.forResponsive, selectLayout = props.selectLayout;
    var optionsParent = data.parent.map(function (item) {
        return {
            id: item.id,
            name: langCode === constants/* ELanguage.VI */.Df.VI ? item.name : item.nameEn
        };
    });
    return (react.createElement(Container, null,
        react.createElement(Cascader/* default */.Z, { langCode: langCode, isMobile: isMobile, floatingConfig: floatingConfig !== null && floatingConfig !== void 0 ? floatingConfig : {}, value: value !== null && value !== void 0 ? value : [], options: {
                parent: optionsParent,
                children: data.child,
                jobCount: (_a = data.jobCount) !== null && _a !== void 0 ? _a : [],
                isEnableSearchAPI: true
            }, hasError: hasError !== null && hasError !== void 0 ? hasError : false, styleOptions: {
                isFlex: isFlex,
                placeholderColor: placeholderColor,
                isShowSecondaryBtn: (_b = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.isShowSecondaryBtn) !== null && _b !== void 0 ? _b : true,
                primaryBtnType: (_c = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.primaryBtnType) !== null && _c !== void 0 ? _c : 'primary',
                secondaryBtnType: (_d = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.secondaryBtnType) !== null && _d !== void 0 ? _d : 'default',
                clearSpaceLeft: (_e = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.clearSpaceLeft) !== null && _e !== void 0 ? _e : false
            }, selectOptions: {
                isSingleSelect: isSingleSelect,
                displayAsPopup: displayAsPopup,
                hiddenFooter: hiddenFooter
            }, textOptions: textOptions, onConfirm: onChange, onCancel: function () { return onBlur && onBlur(); }, onBlur: function () { return onBlur && onBlur(); }, msBaseUrl: msBaseUrl !== null && msBaseUrl !== void 0 ? msBaseUrl : '', lockTarget: lockTarget, scrollLockMode: scrollLockMode, forResponsive: forResponsive, selectLayout: selectLayout })));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 39668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SX": function() { return /* binding */ getJobYouWillLove; },
/* harmony export */   "hX": function() { return /* binding */ trackImpression; },
/* harmony export */   "nL": function() { return /* binding */ getSpecialJob; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



var getJobYouWillLove = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, query = _a.query, smartNaviVersion = _a.smartNaviVersion, formDataExcludeJobIds = _a.formDataExcludeJobIds;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var encodeQuery, urlApi, res;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    encodeQuery = query
                        ? "?".concat(new URLSearchParams((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, query), { t: String(Date.now()) })).toString(), "&").concat(new URLSearchParams(formDataExcludeJobIds).toString())
                        : '';
                    urlApi = "".concat(baseUrl, "/smartnavi/").concat(smartNaviVersion, "/jobs").concat(encodeQuery);
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'GET',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.total) > 0) {
                        return [2 /*return*/, {
                                data: res,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: {
                                    jobs: [],
                                    source: ''
                                },
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var STATUS_CODE = 200;
var getSpecialJob = function (_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, jobs = _a.jobs;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var emptySpecialJob, urlApi, ids, res;
        var _b;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    emptySpecialJob = jobs.map(function (item) {
                        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, item), { isSaved: false, isApplied: false, isBlackList: false, isMatching: false, redirectTo: '' });
                    });
                    if (!accessToken) {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: ''
                            }];
                    }
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/special-jobs");
                    ids = jobs.map(function (item) { return item.jobId; });
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({ jobId: ids })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _c.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.status) === null || _b === void 0 ? void 0 : _b.code) === STATUS_CODE) {
                        return [2 /*return*/, {
                                data: jobs.map(function (item, idx) {
                                    var _a, _b, _c, _d, _e, _f, _g;
                                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, item), { isMatching: (_a = res.data[idx].attributes) === null || _a === void 0 ? void 0 : _a.matching, isSaved: (_b = res.data[idx].attributes) === null || _b === void 0 ? void 0 : _b.saved, isApplied: (_c = res.data[idx].attributes) === null || _c === void 0 ? void 0 : _c.applied, isBlackList: (_d = res.data[idx].attributes) === null || _d === void 0 ? void 0 : _d.userBlackList, redirectTo: (_e = res.data[idx].attributes) === null || _e === void 0 ? void 0 : _e.redirectTo, jobInvitation: (_g = (_f = res.data[idx].attributes) === null || _f === void 0 ? void 0 : _f.jobInvitation) !== null && _g !== void 0 ? _g : { jobInvitationId: 0, status: 0 } });
                                }),
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var trackImpression = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var baseMsUrl, langCode, body, url, rawResponse, ex_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                baseMsUrl = params.baseMsUrl, langCode = params.langCode, body = params.body;
                url = "".concat(baseMsUrl, "/smartnavi/v1/tracking-impression");
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                rawResponse = _a.sent();
                return [4 /*yield*/, rawResponse.json()];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map


/***/ }),

/***/ 18978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _LayoutContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70925);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61032);
/* harmony import */ var _helper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8045);
'use client';








var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var Col = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_a, ref) {
    var _b = _a.xs, xs = _b === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_3__/* .MAXIMUM_COL */ .bD : _b, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, vnw = _a.vnw, children = _a.children, restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["xs", "sm", "md", "lg", "xl", "vnw", "children"]);
    var gutter = (0,_LayoutContext_js__WEBPACK_IMPORTED_MODULE_4__/* .useLayoutContext */ .l)().gutter;
    var cssString = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_5__/* .renderCssStringOfCol */ .vy)({ xs: xs, sm: sm, md: md, lg: lg, xl: xl, vnw: vnw }, gutter); }, [gutter, lg, md, sm, xl, xs, vnw]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ cssString: cssString, id: 'vnwLayout__col', ref: ref }, restProps), children));
});
var templateObject_1;


//# sourceMappingURL=Col.js.map


/***/ }),

/***/ 70925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LayoutContext; },
/* harmony export */   "l": function() { return /* binding */ useLayoutContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LayoutContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    gutter: 0
});
var useLayoutContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LayoutContext); };


//# sourceMappingURL=LayoutContext.js.map


/***/ }),

/***/ 39724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _helper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8045);
/* harmony import */ var _LayoutContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70925);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61032);
'use client';








var RowLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"])), function (_a) {
    var align = _a.align;
    return _constants_js__WEBPACK_IMPORTED_MODULE_3__/* .alignValues */ .wr[align];
}, function (_a) {
    var justify = _a.justify;
    return justify;
}, function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var ContainerLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var containerCssString = _a.containerCssString;
    return containerCssString;
});
var Row = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_a, ref) {
    var _b = _a.gutter, gutter = _b === void 0 ? 0 : _b, _c = _a.align, align = _c === void 0 ? 'top' : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, container = _a.container, children = _a.children, restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["gutter", "align", "justify", "container", "children"]);
    var rowCssString = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_4__/* .renderCssStringOfRow */ .S$)(gutter); }, [gutter]);
    var containerCssString = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_4__/* .renderCssStringOfContainer */ .tT)(container); }, [container]);
    var props = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        gutter: gutter
    });
    var renderContainerLayout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (children) {
        if (container) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContainerLayout, { className: 'vnwLayout__container', containerCssString: containerCssString }, children));
        }
        return children;
    }, [container, containerCssString]);
    return renderContainerLayout(react__WEBPACK_IMPORTED_MODULE_0__.createElement(RowLayout, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ id: 'vnwLayout__row', cssString: rowCssString, align: align, justify: justify, ref: ref }, restProps),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LayoutContext_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Provider */ .Z.Provider, { value: props.current }, children)));
});
var templateObject_1, templateObject_2;


//# sourceMappingURL=Row.js.map


/***/ }),

/***/ 61032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bD": function() { return /* binding */ MAXIMUM_COL; },
/* harmony export */   "j$": function() { return /* binding */ BREAKPOINTS; },
/* harmony export */   "rZ": function() { return /* binding */ CONTAINER; },
/* harmony export */   "wr": function() { return /* binding */ alignValues; }
/* harmony export */ });
'use client';

var BREAKPOINTS = {
    xs: 0,
    sm: 769,
    md: 1025,
    lg: 1301,
    xl: 1441,
    vnw: 1141
};
var CONTAINER = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1300,
    xl: 1440,
    vnw: 1140,
    full: '100%'
};
var MAXIMUM_COL = 24;
var alignValues = {
    top: 'start',
    middle: 'center',
    bottom: 'end'
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 8045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S$": function() { return /* binding */ renderCssStringOfRow; },
/* harmony export */   "tT": function() { return /* binding */ renderCssStringOfContainer; },
/* harmony export */   "vy": function() { return /* binding */ renderCssStringOfCol; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61032);
'use client';



var createRowCssString = function (gutter) {
    if (gutter[0] === 0 && gutter[1] === 0)
        return '';
    var rowGap = gutter[0];
    var colGap = gutter[1];
    return "\n        margin-left: calc(-0.5 * ".concat(colGap, "px);\n        margin-right: calc(-0.5 * ").concat(colGap, "px);\n        margin-top: calc(-1 * ").concat(rowGap, "px);\n      ");
};
var getGapFromGutter = function (gutter) {
    if (!gutter)
        return [0, 0];
    if (typeof gutter === 'number') {
        return [gutter, gutter];
    }
    return gutter;
};
var renderCssStringOfRow = function (gutter) {
    var gap = null;
    var responsive = null;
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    if (gap) {
        return createRowCssString(gap);
    }
    if (responsive) {
        var cssString_1 = '';
        Object.keys(responsive).map(function (breakpoint) {
            if (breakpoint === 'xs') {
                cssString_1 += createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint]));
            }
            cssString_1 += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                  ").concat(createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint])), "\n                }\n            ");
        });
        return cssString_1;
    }
    return '';
};
var renderGap = function (colGap, rowGap) {
    return "\n        ".concat(colGap > 0 ? "padding-left: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(colGap > 0 ? "padding-right: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(rowGap > 0 ? "padding-top: ".concat(rowGap, "px;") : '', "\n");
};
var renderAutoLayoutString = function (type) {
    if (type === 'auto') {
        return 'flex: 0 0 auto;max-width:none;';
    }
    return "flex: 1 1 0;max-width:100%;";
};
var createColCssString = function (gutter, col) {
    var colSpan = 0;
    var colOffset = 0;
    var colOrder = 0;
    var rowGap = gutter[0];
    var colGap = gutter[1];
    if (col) {
        if (typeof col === 'number') {
            colSpan = col;
        }
        else if (col instanceof Object) {
            colSpan = col.span;
            colOffset = col.offset || 0;
            colOrder = col.order || 0;
        }
        else {
            /*
             * Return css string immediately if column has auto layout
             * */
            return "\n                ".concat(renderAutoLayoutString(col), "\n                ").concat(renderGap(colGap, rowGap), "\n                ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n            ");
        }
    }
    var containerWidth = (colSpan / _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .MAXIMUM_COL */ .bD) * 100;
    var containerOffset = colOffset > 0 ? (colOffset / _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .MAXIMUM_COL */ .bD) * 100 : null;
    return "\n        ".concat(containerWidth > 0 ? "flex: 0 0 ".concat(containerWidth, "%;") : '', "\n        ").concat(containerWidth > 0 ? "max-width: ".concat(containerWidth, "%;") : '', "\n        ").concat(renderGap(colGap, rowGap), "\n        ").concat(containerOffset !== null ? "margin-left: ".concat(containerOffset, "%;") : '', "\n        ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n    ");
};
var renderCssStringOfCol = function (breakpoints, gutter) {
    var gap = null;
    var responsive = null;
    var cssString = '';
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    Object.keys(breakpoints).map(function (breakpoint) {
        if (breakpoint === 'xs') {
            if (gap) {
                cssString += createColCssString(gap, breakpoints[breakpoint]);
                return;
            }
            if (responsive) {
                cssString += createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]);
                return;
            }
        }
        if (responsive) {
            if (!breakpoints[breakpoint] && !responsive[breakpoint])
                return;
            cssString += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                    ").concat(createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]), "\n                }\n            ");
            return;
        }
        if (breakpoints[breakpoint]) {
            cssString += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                    ").concat(createColCssString([0, 0], breakpoints[breakpoint]), "\n                }\n            ");
        }
    });
    return cssString;
};
var renderCssStringOfContainer = function (container) {
    var cssString = '';
    var containerKey;
    var padding = 0;
    if (container) {
        containerKey = Object.keys(container)[0];
        if (containerKey) {
            if (containerKey !== 'responsive') {
                padding = container[containerKey] || 0;
                cssString = "\n                  width: 100%;\n                  max-width: ".concat(containerKey === 'full'
                    ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[containerKey]
                    : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[containerKey]) + padding * 2, "px"), ";\n                  padding: 0 ").concat(padding, "px;\n                  margin: 0 auto;\n                ");
            }
            else {
                /*
                 * When container has responsive, the responsive is always has at least 1 item (xs is required).
                 * So that, i can make type convention containerResponsive as TContainerResponsive
                 * */
                var containerResponsive_1 = container[containerKey];
                Object.keys(containerResponsive_1).forEach(function (key) {
                    var containerResponsiveItem = containerResponsive_1[key];
                    if (containerResponsiveItem) {
                        var size = containerResponsiveItem.size;
                        padding = containerResponsiveItem.offset || 0;
                        if (key === 'xs') {
                            cssString += "\n                                width: 100%;\n                                max-width: ".concat(size === 'full' ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size] : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size]) + padding * 2, "px"), ";\n                                padding: 0 ").concat(padding, "px;\n                                margin: 0 auto;\n                            ");
                            return;
                        }
                        cssString += "\n                            width: 100%;\n                            @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[key], "px) {\n                                max-width: ").concat(size === 'full' ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size] : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size]) + padding * 2, "px"), ";\n                                ").concat(padding ? "padding: 0 ".concat(padding, "px;") : '', "\n                            }\n                        ");
                    }
                });
            }
        }
    }
    return cssString;
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 21221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LimitedTextarea; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LimitedTextarea/CheckBoxTextarea.module.scss.js
'use client';

var s = {"textArea":"CheckBoxTextarea-module_textArea__2nGbq","totalText":"CheckBoxTextarea-module_totalText__3nHV0","label":"CheckBoxTextarea-module_label__2ZM7u"};


//# sourceMappingURL=CheckBoxTextarea.module.scss.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LimitedTextarea/index.js
'use client';





var LimitedTextarea = function (props) {
    // TODO create component with limit
    var inputText = props.inputText, _a = props.placeholder, placeholder = _a === void 0 ? '' : _a;
    var _b = (0,react.useState)(props.value.slice(0, props.limit)), content = _b[0], setContent = _b[1];
    var isMaxContent = content.length > props.limit;
    var setFormattedContent = (0,react.useCallback)(function (text) {
        setContent(text);
    }, [setContent]);
    return (react.createElement(react.Fragment, null,
        react.createElement("textarea", { className: s.textArea, rows: 4, onChange: function (e) {
                setFormattedContent(e.target.value);
                inputText && inputText(e.target.value);
            }, value: content, placeholder: placeholder }),
        react.createElement("div", { style: { fontSize: 12, color: isMaxContent ? '#f85a5a' : '#6c757d', marginTop: 6 } }, "".concat(content.length, "/").concat(props.limit)),
        isMaxContent && (react.createElement("div", { style: { fontSize: 12, color: '#f85a5a', marginTop: 4 } }, "".concat((0,helpers.t)('Exceeded maximum character length of', props.language || 'vi'), " ").concat(props.limit)))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 33874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ USER_BANNED_EN; },
/* harmony export */   "$v": function() { return /* binding */ USER_NOT_ACTIVE_VI; },
/* harmony export */   "AX": function() { return /* binding */ UPDATE_USER; },
/* harmony export */   "Ic": function() { return /* binding */ USER_EMPLOYER_EN; },
/* harmony export */   "JT": function() { return /* binding */ VNW_NEW_REGISTERED; },
/* harmony export */   "QS": function() { return /* binding */ EPages; },
/* harmony export */   "S3": function() { return /* binding */ USER_NOT_ACTIVE_EN; },
/* harmony export */   "bU": function() { return /* binding */ USER_BANNED_VI; },
/* harmony export */   "dD": function() { return /* binding */ WS_TOKEN; },
/* harmony export */   "eS": function() { return /* binding */ LOGIN_POPUP; },
/* harmony export */   "fQ": function() { return /* binding */ USER_EMPLOYER_VI; },
/* harmony export */   "fT": function() { return /* binding */ USER_COOKIE; },
/* harmony export */   "h4": function() { return /* binding */ JS_TOKEN; },
/* harmony export */   "kd": function() { return /* binding */ WS_COOKIE; },
/* harmony export */   "uK": function() { return /* binding */ VNW_CSRF_JWT_TOKEN; },
/* harmony export */   "vG": function() { return /* binding */ KEY_AUTH_TOKEN; },
/* harmony export */   "xX": function() { return /* binding */ JS_ALL_TOKEN; },
/* harmony export */   "z4": function() { return /* binding */ UTM_SOURCE_MAPPING; }
/* harmony export */ });
'use client';

// Event name using for trigger open/close login popup
var LOGIN_POPUP = 'LOGIN_POPUP';
// UPDATE_USER event used for dispatch userInfo to other microfrontend pages
var UPDATE_USER = 'UPDATE_USER';
// KEY_AUTH_TOKEN is query params that is passed by mobile from WebView
var KEY_AUTH_TOKEN = 'authtoken';
var WS_TOKEN = 'VNWWS128450527232960';
var JS_TOKEN = 'VNW128450527232960';
var JS_ALL_TOKEN = 'VNWJSAll128450527232960';
var USER_COOKIE = 'VNW_USER_COOKIE';
var WS_COOKIE = 'VNW_WS_COOKIE';
var VNW_NEW_REGISTERED = 'VNW_NEW_REGISTERED';
// VNW_CSRF_JWT_TOKEN in cookie
var VNW_CSRF_JWT_TOKEN = 'VNW_CSRF_JWT_TOKEN';
// response message USER_NOT_ACTIVE
var USER_NOT_ACTIVE_EN = 'You have not verified your email. Please check your email inbox for instruction.';
var USER_NOT_ACTIVE_VI = 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.';
// Response message USER_EMPLOYER
var USER_EMPLOYER_EN = 'This email address is registered as Employer, please Sign in from Employer Site.';
var USER_EMPLOYER_VI = 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.';
// BAN case
var USER_BANNED_EN = 'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.';
var USER_BANNED_VI = 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.';
// PageName (type EPages)
var EPages;
(function (EPages) {
    EPages["HOME_PAGE"] = "homepage";
    EPages["SEARCH_RESULT"] = "searchResult";
    EPages["SEO_LANDING_PAGE"] = "SEOLandingPage";
    EPages["TOP_MANAGEMENT_JOBS"] = "topManagementJobs";
    EPages["INTERVIEW"] = "interview";
    EPages["SALARY"] = "salary";
    EPages["COMPANY_LIST"] = "companyList";
    EPages["JOB_DETAIL"] = "jobDetail";
    EPages["MY_CAREER_CENTER"] = "myCareerCenter";
    EPages["DASHBOARD"] = "dashboard";
    EPages["PROFILE_SETTINGS"] = "profileSettings";
    EPages["MY_COMPANIES"] = "myCompanies";
    EPages["PROFILE_VIEWS"] = "profileViews";
    EPages["MY_JOBS"] = "myJobs";
    EPages["JOB_ALERTS"] = "jobAlerts";
    EPages["MY_PROFILE"] = "myProfile";
    EPages["ACCOUNT_SETTINGS"] = "accountSettings";
    EPages["OTHER"] = "other";
    EPages["MY_ACCOUNT"] = "myAccount";
    EPages["WOW_CV"] = "wowCv";
    EPages["REFERRAL_CANDIDATES"] = "referralCandidates";
    EPages["CAREER_TOOLS"] = "careerTools";
    EPages["SALARY_CONVERTER"] = "salaryConverter";
    EPages["CAREER_PATH"] = "careerPath";
    EPages["NUMEROLOGY"] = "numerology";
    EPages["EMPOWER_GROWTH"] = "empowerGrowth";
    EPages["PROFILE_SETTING"] = "profileSettings";
    EPages["VIEWED_JOBS"] = "viewedJobs";
    EPages["ACCOUNT_SETTING"] = "accountSettings";
    EPages["RECOMMENDED_JOBS"] = "recommendedJobs";
    EPages["APPLIED_JOB"] = "appliedJobs";
    EPages["ORDER_MANAGEMENT"] = "orderMangagement";
})(EPages || (EPages = {}));
var UTM_SOURCE_MAPPING = {
    wowCv: 'WowCv'
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 85124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SlideModal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Modal/SlideModal.module.css.js
'use client';

var styles = {"container":"SlideModal-module_container__fsD4N","isOpen":"SlideModal-module_isOpen__2hooY","header":"SlideModal-module_header__TIczo","title":"SlideModal-module_title__2wqTw","icon":"SlideModal-module_icon__2OM9w","backdrop":"SlideModal-module_backdrop__2klfi"};


//# sourceMappingURL=SlideModal.module.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Modal/deleteIcon.js
var deleteIcon = __webpack_require__(68856);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Modal/SlideModal.js
'use client';






var SlideModal = function (props) {
    var isOpen = props.isOpen, onBack = props.onBack, title = props.title, titleStyle = props.titleStyle, headerStyle = props.headerStyle;
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside) {
                onBack();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (!bodyNode) {
            return;
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        return function () {
            removeOverflowClass();
        };
    }, [isOpen]);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? styles.isOpen : '';
    return react_dom.createPortal(react.createElement("div", null,
        react.createElement("div", { className: "".concat(styles.backdrop, " ").concat(classOpen) }),
        react.createElement("div", { className: "".concat(styles.container, " ").concat(classOpen), ref: containerRef },
            react.createElement("div", { className: styles.header, style: headerStyle },
                react.createElement("div", { className: styles.title, style: titleStyle }, title),
                react.createElement("div", { onClick: onBack, className: "".concat(styles.icon) },
                    react.createElement(deleteIcon/* default */.Z, null))),
            react.createElement("div", { className: styles.body }, props.children))), bodyNode);
};


//# sourceMappingURL=SlideModal.js.map


/***/ }),

/***/ 68856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ closeIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var closeIcon = function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { fill: '#000000', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' })));
};


//# sourceMappingURL=deleteIcon.js.map


/***/ }),

/***/ 81234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MultiLevelSelect; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TextField/index.js + 4 modules
var TextField = __webpack_require__(65906);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var SearchIcon = __webpack_require__(6538);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/index.js
var SingleRadio = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDropdownAnimation.js
var useDropdownAnimation = __webpack_require__(91623);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/helpers/getAdaptiveHeightList.js
'use client';

function getAdaptiveHeightList(element) {
    var result = [];
    var lists = element.childNodes;
    if (lists && lists.length > 0) {
        lists.forEach(function (list) {
            var stackedHeight = 0;
            if (list.childNodes && list.childNodes.length > 0) {
                list.childNodes.forEach(function (item) {
                    stackedHeight += item.offsetHeight;
                });
                result.push(stackedHeight);
            }
        });
    }
    return result;
}


//# sourceMappingURL=getAdaptiveHeightList.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useKeyboardAccessibility.js
var useKeyboardAccessibility = __webpack_require__(18094);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelCore/styles.js
'use client';





var TRANSITION_TIMING = 200;
var MultiLevelCoreContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: height ", "ms ease-in-out;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    ", "\n"], ["\n    transition: height ", "ms ease-in-out;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    ", "\n"])), TRANSITION_TIMING, styledCss/* default.scrollbar */.ZP.scrollbar);
var ListWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", ";\n    display: flex;\n    transition: transform ", "ms ease-in-out;\n"], ["\n    ", ";\n    display: flex;\n    transition: transform ", "ms ease-in-out;\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return (maxHeight ? "max-height: ".concat(maxHeight, "px") : '');
}, TRANSITION_TIMING);
var List = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", "px;\n    flex-shrink: 0;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    ", "\n"], ["\n    width: ", "px;\n    flex-shrink: 0;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    ", "\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var isActive = _a.isActive;
    return isActive
        ? ''
        : "\n        height: 0;\n        overflow: hidden;\n    ";
});
var Item = styled_components_browser_esm/* default.li */.ZP.li(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ItemWrapper = styled_components_browser_esm/* default.span */.ZP.span(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n"], ["\n    display: block;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelCore/index.js
'use client';












var LIST_ID = 'multi-level-list-';
var MultiLevelCore = (0,react.forwardRef)(function (_a, ref) {
    var _b;
    var enableKeyboardNavigation = _a.enableKeyboardNavigation, onClickEscape = _a.onClickEscape, values = _a.values, maxHeight = _a.maxHeight, options = _a.options, renderItem = _a.renderItem, fieldValue = _a.fieldValue, fieldKey = _a.fieldKey, onChange = _a.onChange, _c = _a.adaptiveHeight, adaptiveHeight = _c === void 0 ? true : _c, _d = _a.searchKeywords, searchKeywords = _d === void 0 ? '' : _d, onClearSearchKeywords = _a.onClearSearchKeywords, onClickLeafItem = _a.onClickLeafItem, emptyNode = _a.emptyNode, onChangeTitle = _a.onChangeTitle, onShowBackButton = _a.onShowBackButton;
    /**
     * State
     * */
    var _e = (0,react.useState)([]), selectedValues = _e[0], setSelectedValues = _e[1];
    var _f = (0,react.useState)([options]), multiOptions = _f[0], setMultiOptions = _f[1];
    var _g = (0,react.useState)([]), adaptiveHeightList = _g[0], setAdaptiveHeightList = _g[1];
    var _h = (0,react.useState)(0), level = _h[0], setLevel = _h[1];
    /**
     * Ref
     * */
    var containerRef = (0,react.useRef)(null);
    var listWrapperRef = (0,react.useRef)(null);
    var cachedMultiDropdowns = (0,react.useRef)([options]);
    var canSetInitialValues = (0,react.useRef)(true);
    /**
     * Effects
     * */
    // Set values
    (0,react.useEffect)(function () {
        /**
         * Only set selected values in first mount
         * this avoid selectedValues being set after onChange values
         * because the values after onChange may be missing
         * */
        if (canSetInitialValues.current && values) {
            setSelectedValues(values);
            canSetInitialValues.current = false;
        }
    }, [values]);
    // Set dropdown title
    (0,react.useEffect)(function () {
        var displayLevel = level - 1;
        var displayValue = selectedValues[displayLevel];
        if (displayValue) {
            var titleToDisplay = displayValue[fieldValue];
            onChangeTitle(titleToDisplay);
        }
        else {
            onChangeTitle('');
        }
    }, [selectedValues, level, fieldValue]);
    // Set initial options
    (0,react.useEffect)(function () {
        if (canSetInitialValues.current && options) {
            setMultiOptions([options]);
            canSetInitialValues.current = false;
        }
    }, [options]);
    // Transition to next level
    (0,react.useEffect)(function () {
        if (containerRef.current && listWrapperRef.current) {
            var transitionWidth = containerRef.current.offsetWidth * level;
            listWrapperRef.current.style.transform = "translateX(-".concat(transitionWidth, "px)");
            if (adaptiveHeight && maxHeight) {
                var height = adaptiveHeightList[level];
                if (height > maxHeight) {
                    containerRef.current.style.height = maxHeight + 'px';
                    containerRef.current.style.overflowY = 'auto';
                }
                else {
                    containerRef.current.style.height = height + 'px';
                    containerRef.current.style.overflowY = 'hidden';
                }
            }
        }
    }, [level, adaptiveHeightList, adaptiveHeight, maxHeight]);
    // Filter options by keyword
    (0,react.useEffect)(function () {
        if (level < 0) {
            return;
        }
        var changedMultiOptionsByKeywords = (0,helpers/* quickFilterByKeywords */.PB)(cachedMultiDropdowns.current[level], searchKeywords, fieldValue);
        var changedMultiOptions = (0,_tslib/* __spreadArray */.ev)([], cachedMultiDropdowns.current, true);
        changedMultiOptions[level] = changedMultiOptionsByKeywords;
        setMultiOptions(changedMultiOptions);
    }, [level, searchKeywords, fieldValue, fieldKey]);
    // Adaptive height
    (0,react.useEffect)(function () {
        if (listWrapperRef.current) {
            var adaptiveHeight_1 = getAdaptiveHeightList(listWrapperRef.current);
            setAdaptiveHeightList(adaptiveHeight_1);
        }
    }, [multiOptions, maxHeight]);
    // Show back button
    (0,react.useEffect)(function () {
        if (level > 0) {
            onShowBackButton(true);
        }
        else {
            onShowBackButton(false);
        }
    }, [level]);
    /**
     * Render
     * */
    var dropdownWidth = ((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
    /**
     * Logic
     * */
    var handleBack = (0,react.useCallback)(function () {
        onClearSearchKeywords && onClearSearchKeywords();
        setLevel(function (prevLevel) {
            if (prevLevel === 0) {
                return prevLevel;
            }
            var changedLevel = prevLevel - 1;
            return changedLevel;
        });
        /**
         * Scroll to top when back
         * If QC want to scroll to selected values, create a cached to save selected value positions
         * But might do it later if asked
         * */
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [onClearSearchKeywords]);
    var handleSelectItem = (0,react.useCallback)(function (option, index) {
        var _a;
        /**
         * Set multi options
         * */
        setMultiOptions(function (prevMultiOption) {
            if (option.children) {
                var changedMultiOptions = (0,_tslib/* __spreadArray */.ev)([], prevMultiOption, true);
                changedMultiOptions[index + 1] = option.children;
                cachedMultiDropdowns.current[index + 1] = option.children;
                return changedMultiOptions;
            }
            return prevMultiOption;
        });
        /**
         * Set multi values
         * */
        var valuesLength = selectedValues.length - 1;
        var changedValues = (0,_tslib/* __spreadArray */.ev)([], selectedValues, true);
        var inputValues = (_a = {}, _a[fieldKey] = option[fieldKey], _a[fieldValue] = option[fieldValue], _a);
        /**
         * Rules:
         *  0: If selected value is already containt in selectedValues, don't do anything
         *  1: If index is greater than values's length -> Push new value
         *  2: If index is less or equal than values's length -> replace item's value of index position and remove all value behind
         * */
        var selectedValuesIds = changedValues.map(function (value) { return value[fieldValue]; });
        if (!selectedValuesIds.includes(option[fieldValue])) {
            switch (true) {
                case index > valuesLength: {
                    changedValues.push(inputValues);
                    break;
                }
                case index <= valuesLength: {
                    changedValues = changedValues.slice(0, index);
                    changedValues.push(inputValues);
                    break;
                }
            }
        }
        // Clear keywords before set active level
        onClearSearchKeywords && onClearSearchKeywords();
        setSelectedValues(changedValues);
        if (option.children && option.children.length > 0) {
            setLevel(index + 1);
            return;
        }
        /**
         * Click leaf item
         * */
        onClickLeafItem();
        setLevel(0);
        onChange(changedValues);
    }, [fieldKey, fieldValue, onChange, onClearSearchKeywords, onClickLeafItem, selectedValues]);
    /**
     * Hooks
     * */
    // Keyboard navigation
    var activeIndex = (0,useKeyboardAccessibility/* default */.Z)(enableKeyboardNavigation, {
        target: "#".concat(LIST_ID + level),
        optionsLength: multiOptions[level].length,
        onClickEscape: onClickEscape,
        forceResetIndexDeps: [level, searchKeywords],
        onSelelected: function (index) {
            var selectedOption = multiOptions[level][index];
            handleSelectItem(selectedOption, level);
        }
    }).activeIndex;
    (0,react.useImperativeHandle)(ref, function () { return ({
        back: handleBack
    }); });
    return (react.createElement(MultiLevelCoreContainer, { ref: containerRef },
        react.createElement(ListWrapper, { maxHeight: maxHeight, ref: listWrapperRef }, multiOptions.map(function (options, multiOptionsIndex) {
            // Render list
            var isActiveList = multiOptionsIndex === level;
            return (react.createElement(List, { key: LIST_ID + multiOptionsIndex, id: LIST_ID + multiOptionsIndex, width: dropdownWidth, isActive: isActiveList, style: {
                    height: !isActiveList ? 0 : undefined,
                    overflow: !isActiveList ? 'hidden' : undefined
                } }, options.length > 0 ? (options.map(function (option, index) {
                var valueIds = selectedValues.map(function (item) { return item[fieldValue]; });
                // Render item
                return (react.createElement(Item, { key: option[fieldKey] },
                    react.createElement(ItemWrapper, { role: 'button', onClick: function () { return handleSelectItem(option, multiOptionsIndex); } }, renderItem({
                        displayValue: option[fieldValue],
                        isSelected: valueIds.includes(option[fieldValue]),
                        isHaveChild: !!option.children,
                        isHover: index === activeIndex
                    }))));
            })) : (react.createElement(react.Fragment, null, emptyNode))));
        }))));
});


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/store.js
'use client';




var MultiLevelSelectContext = (0,react.createContext)({
    values: [],
    options: [],
    onChange: function () { },
    fieldKey: '',
    fieldValue: '',
    floatingConfig: {},
    onBlur: function () { },
    dropdown: {},
    placeholder: '',
    langCode: constants/* ELanguage.VI */.Df.VI,
    translate: function () { return ''; },
    hasError: false,
    separate: ''
});
var useMultiLevelContext = function () { return (0,react.useContext)(MultiLevelSelectContext); };


//# sourceMappingURL=store.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelDropdown/styles.js
'use client';





var DropdownWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_1 || (styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    border-radius: 6px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    background: #fff;\n"], ["\n    padding: 16px;\n    border-radius: 6px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    background: #fff;\n"])));
var DropdownTitle = styled_components_browser_esm/* default.p */.ZP.p(styles_templateObject_2 || (styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 32px;\n    margin-top: 0;\n    margin-bottom: 12px;\n"], ["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 32px;\n    margin-top: 0;\n    margin-bottom: 12px;\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var SearchWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_3 || (styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n"], ["\n    margin-bottom: 4px;\n"])));
var SearchIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_4 || (styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 12px;\n"], ["\n    padding-left: 12px;\n"])));
var Empty = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_5 || (styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    height: 36px;\n"], ["\n    display: flex;\n    align-items: center;\n    height: 36px;\n"])));
var styles_templateObject_1, styles_templateObject_2, styles_templateObject_3, styles_templateObject_4, styles_templateObject_5;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelDropdown/index.js
'use client';


































































































































































function MultiLevelDropdown(_a) {
    var _b, _c;
    var renderReference = _a.renderReference;
    var _d = useMultiLevelContext(), dropdown = _d.dropdown, fieldValue = _d.fieldValue, fieldKey = _d.fieldKey, onChange = _d.onChange, values = _d.values, options = _d.options, floatingConfig = _d.floatingConfig, onBlur = _d.onBlur, translate = _d.translate;
    /**
     * State
     * */
    var _e = (0,react.useState)(false), show = _e[0], setShow = _e[1];
    var _f = (0,react.useState)(''), search = _f[0], setSearch = _f[1];
    var _g = (0,react.useState)(''), dropdownTitle = _g[0], setDropdownTitle = _g[1];
    var _h = (0,react.useState)(false), showBackButton = _h[0], setShowBackButton = _h[1];
    /**
     * Ref
     * */
    var dropdownRef = (0,react.useRef)({ back: function () { } });
    /**
     * Logic
     * */
    var handleToggleDropdown = function () {
        setShow(function (prevState) { return !prevState; });
    };
    /**
     * Hooks
     * */
    // Floating
    var _j = (0,useFloating/* default */.Z)({
        placement: floatingConfig.placement || 'bottom-start',
        position: floatingConfig.position,
        config: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, floatingConfig), { detectHidden: true, offset: 4 })
    }), refs = _j.refs, context = _j.context, FloatingPortal = _j.FloatingPortal;
    // Click away
    (0,useClickAway/* default */.Z)(function () {
        setShow(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // Animation
    var _k = (0,useDropdownAnimation/* default */.Z)(show, context.placement), animationStyles = _k.styles, isMounted = _k.isMounted;
    /**
     * Effects
     * */
    // Action when not show
    (0,react.useEffect)(function () {
        if (!show) {
            setSearch('');
        }
    }, [show]);
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { ref: refs.setReference }, renderReference({
            onToggle: handleToggleDropdown,
            isShow: show
        })),
        isMounted ? (react.createElement(FloatingPortal, { enable: floatingConfig.enablePortal },
            react.createElement("div", { ref: refs.setPopup, style: {
                    position: context.position,
                    top: context.y,
                    left: context.x,
                    display: context.isReferenceHidden ? 'none' : 'block',
                    width: dropdown.width ? dropdown.width : ((_b = refs.reference.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0,
                    zIndex: 1100
                } },
                react.createElement(DropdownWrapper, { style: animationStyles },
                    react.createElement(DropdownTitle, null,
                        showBackButton ? (react.createElement(Button/* default */.Z, { isIcon: true, size: 'sm', isRounded: true, type: 'default', outline: 'none', tabIndex: -1, onClick: (_c = dropdownRef.current) === null || _c === void 0 ? void 0 : _c.back },
                            react.createElement(ArrowDownIcon/* default */.Z, { style: { transform: 'rotate(90deg)' } }))) : null,
                        dropdownTitle !== '' ? dropdownTitle : dropdown.title),
                    dropdown.allowSearch ? (react.createElement(SearchWrapper, null,
                        react.createElement(TextField/* default */.Z, { id: 'multi-level-search', value: search, onChange: setSearch, theme: 'normal', placeholder: dropdown.searchBoxPlaceholder, autoComplete: 'off', autoFocus: true, prefix: react.createElement(SearchIconWrapper, null,
                                react.createElement(SearchIcon/* default */.Z, { height: 19 })) }))) : null,
                    react.createElement(MultiLevelCore, { enableKeyboardNavigation: show, ref: dropdownRef, values: values, onChangeTitle: setDropdownTitle, onShowBackButton: setShowBackButton, searchKeywords: search, options: options, onChange: onChange, fieldKey: fieldKey, fieldValue: fieldValue, maxHeight: dropdown.maxHeight || 0, onClearSearchKeywords: function () { return setSearch(''); }, renderItem: function (_a) {
                            var displayValue = _a.displayValue, isSelected = _a.isSelected, isHaveChild = _a.isHaveChild, isHover = _a.isHover;
                            return (react.createElement(SingleRadio/* default */.Z, { id: displayValue, onChange: function () { }, label: displayValue, checked: isSelected, isLeftRadio: true, isHover: isHover, cssHover: false, decoration: isHaveChild ? (react.createElement(ArrowDownIcon/* default */.Z, { style: { transform: 'rotate(-90deg)' }, width: 16, height: 16 })) : null }));
                        }, onClickLeafItem: function () {
                            setShow(false);
                        }, onClickEscape: function () {
                            setShow(false);
                        }, emptyNode: react.createElement(Empty, null, dropdown.emptyString || translate('No result')) }))))) : null));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelPopup/styles.js
'use client';





var Header = styled_components_browser_esm/* default.div */.ZP.div(MultiLevelPopup_styles_templateObject_1 || (MultiLevelPopup_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 12px 16px;\n    border-bottom: 1px solid #efefef;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n"], ["\n    padding: 12px 16px;\n    border-bottom: 1px solid #efefef;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n"])));
var Title = styled_components_browser_esm/* default.p */.ZP.p(MultiLevelPopup_styles_templateObject_2 || (MultiLevelPopup_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 32px;\n    margin-top: 0;\n    margin-bottom: 0;\n"], ["\n    font-size: 16px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 32px;\n    margin-top: 0;\n    margin-bottom: 0;\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var styles_SearchWrapper = styled_components_browser_esm/* default.div */.ZP.div(MultiLevelPopup_styles_templateObject_3 || (MultiLevelPopup_styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 8px;\n"], ["\n    margin-bottom: 8px;\n"])));
var styles_SearchIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(MultiLevelPopup_styles_templateObject_4 || (MultiLevelPopup_styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 12px;\n"], ["\n    padding-left: 12px;\n"])));
var styles_Empty = styled_components_browser_esm/* default.div */.ZP.div(MultiLevelPopup_styles_templateObject_5 || (MultiLevelPopup_styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    height: 36px;\n"], ["\n    display: flex;\n    align-items: center;\n    height: 36px;\n"])));
var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-rows: auto 1fr;\n    height: 100%;\n    padding: 16px;\n"], ["\n    display: grid;\n    grid-template-rows: auto 1fr;\n    height: 100%;\n    padding: 16px;\n"])));
var MultiLevelWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 100%;\n    overflow-y: auto;\n"], ["\n    height: 100%;\n    overflow-y: auto;\n"])));
var MultiLevelPopup_styles_templateObject_1, MultiLevelPopup_styles_templateObject_2, MultiLevelPopup_styles_templateObject_3, MultiLevelPopup_styles_templateObject_4, MultiLevelPopup_styles_templateObject_5, templateObject_6, templateObject_7;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelPopup/index.js
'use client';






























































































































































function MultiLevelPopup(_a) {
    var renderReference = _a.renderReference;
    var _b = useMultiLevelContext(), dropdown = _b.dropdown, fieldValue = _b.fieldValue, fieldKey = _b.fieldKey, onChange = _b.onChange, values = _b.values, options = _b.options, langCode = _b.langCode, translate = _b.translate;
    /**
     * State
     * */
    var _c = (0,react.useState)(false), show = _c[0], setShow = _c[1];
    var _d = (0,react.useState)(''), search = _d[0], setSearch = _d[1];
    var _e = (0,react.useState)(''), dropdownTitle = _e[0], setDropdownTitle = _e[1];
    var _f = (0,react.useState)(false), showBackButton = _f[0], setShowBackButton = _f[1];
    /**
     * Ref
     * */
    var dropdownRef = (0,react.useRef)({ back: function () { } });
    var scrollableContainerRef = (0,react.useRef)(null);
    /**
     * Logic
     * */
    var handleToggleDropdown = function () {
        setShow(function (prevState) { return !prevState; });
    };
    var handleBack = (0,react.useCallback)(function () {
        var _a;
        if ((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.back) {
            dropdownRef.current.back();
        }
        if (scrollableContainerRef.current) {
            scrollableContainerRef.current.scrollTop = 0;
        }
    }, []);
    /**
     * Effects
     * */
    // Action when not show
    (0,react.useEffect)(function () {
        if (!show) {
            setSearch('');
        }
    }, [show]);
    /**
     * Render
     * */
    var renderHeader = (0,react.useCallback)(function () {
        return (react.createElement(Header, null,
            showBackButton ? (react.createElement(Button/* default */.Z, { isIcon: true, size: 'sm', isRounded: true, type: 'default', outline: 'none', tabIndex: -1, onClick: handleBack },
                react.createElement(ArrowDownIcon/* default */.Z, { style: { transform: 'rotate(90deg)' } }))) : null,
            react.createElement(Title, null, dropdownTitle !== '' ? dropdownTitle : dropdown.title)));
    }, [dropdown.title, dropdownTitle, handleBack, showBackButton]);
    return (react.createElement(react.Fragment, null,
        renderReference({
            onToggle: handleToggleDropdown,
            isShow: show
        }),
        react.createElement(Popup/* default */.Z, { isShow: show, lang: langCode, onClose: function () { return setShow(false); }, text: {
                secondaryBtn: translate('Cancel')
            }, option: {
                isShowPrimaryButton: false
            }, custom: {
                header: renderHeader()
            }, styleOption: {
                isPushViewBehind: true,
                size: 'xs',
                isFooterButtonFullWidth: true
            } },
            react.createElement(Container, null,
                dropdown.allowSearch ? (react.createElement(styles_SearchWrapper, null,
                    react.createElement(TextField/* default */.Z, { id: 'multi-level-search', value: search, onChange: setSearch, theme: 'normal', placeholder: dropdown.searchBoxPlaceholder, autoComplete: 'off', autoFocus: true, prefix: react.createElement(styles_SearchIconWrapper, null,
                            react.createElement(SearchIcon/* default */.Z, { height: 19 })) }))) : null,
                react.createElement(MultiLevelWrapper, { ref: scrollableContainerRef },
                    react.createElement(MultiLevelCore, { enableKeyboardNavigation: false, ref: dropdownRef, values: values, onChangeTitle: setDropdownTitle, onShowBackButton: setShowBackButton, searchKeywords: search, options: options, onChange: onChange, fieldKey: fieldKey, fieldValue: fieldValue, onClearSearchKeywords: function () { return setSearch(''); }, renderItem: function (_a) {
                            var displayValue = _a.displayValue, isSelected = _a.isSelected, isHaveChild = _a.isHaveChild, isHover = _a.isHover;
                            return (react.createElement(SingleRadio/* default */.Z, { id: displayValue, onChange: function () { }, label: displayValue, checked: isSelected, isLeftRadio: true, isHover: isHover, cssHover: false, decoration: isHaveChild ? (react.createElement(ArrowDownIcon/* default */.Z, { style: { transform: 'rotate(-90deg)' }, width: 16, height: 16 })) : null }));
                        }, onClickLeafItem: function () {
                            setShow(false);
                        }, onClickEscape: function () {
                            setShow(false);
                        }, emptyNode: react.createElement(styles_Empty, null, dropdown.emptyString || translate('No result')) }))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/constants.js
'use client';

var INITIAL_FLOATING_CONFIG = {
    placement: 'bottom-start',
    position: 'absolute',
    useWindowAsFlippingContainer: false,
    enablePortal: false,
    isFlip: true
};
var INITIAL_DROPDOWN_STYLES = {
    maxHeight: 200,
    title: 'Title',
    width: 0,
    allowSearch: true,
    emptyString: '',
    searchBoxPlaceholder: 'Search'
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/translations.js
'use client';

var translations = {
    Cancel: 'Hủy',
    'No result': 'Không có kết quả'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelSelect/index.js
'use client';































































































































































function MultiLevelSelect(_a) {
    var values = _a.values, _b = _a.placeholder, placeholder = _b === void 0 ? 'Select...' : _b, options = _a.options, dropdown = _a.dropdown, onChange = _a.onChange, children = _a.children, _c = _a.fieldValue, fieldValue = _c === void 0 ? 'name' : _c, _d = _a.fieldKey, fieldKey = _d === void 0 ? 'id' : _d, floatingConfig = _a.floatingConfig, onBlur = _a.onBlur, _e = _a.type, type = _e === void 0 ? 'dropdown' : _e, langCode = _a.langCode, _f = _a.hasError, hasError = _f === void 0 ? false : _f, _g = _a.separate, separate = _g === void 0 ? '/ ' : _g;
    var _floatingConfig = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, INITIAL_FLOATING_CONFIG), floatingConfig);
    var _dropdown = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, INITIAL_DROPDOWN_STYLES), dropdown);
    /**
     * Render
     * */
    var renderValues = (0,react.useMemo)(function () { return (values ? values.map(function (value) { return value[fieldValue]; }) : []); }, [values, fieldValue]);
    var renderChildren = (0,react.useCallback)(function (_a) {
        var isShow = _a.isShow, onToggle = _a.onToggle;
        return children ? (children({ onToggle: onToggle, isShow: isShow })) : (react.createElement(TextField/* default */.Z, { id: 'multi-level-select', value: renderValues.join(separate), placeholder: placeholder, allowClear: false, type: 'button', suffix: react.createElement(ArrowDownIcon/* default */.Z, null), onClick: onToggle, isFocus: isShow, hasError: hasError }));
    }, [children, renderValues, separate, placeholder, hasError]);
    return (react.createElement(MultiLevelSelectContext.Provider, { value: {
            values: values,
            placeholder: placeholder,
            options: options,
            dropdown: _dropdown,
            onChange: onChange,
            fieldValue: fieldValue,
            fieldKey: fieldKey,
            floatingConfig: _floatingConfig,
            onBlur: onBlur,
            langCode: langCode,
            translate: (0,helpers/* createTranslator */.eX)({ translations: translations, currentLanguage: langCode }),
            hasError: hasError,
            separate: separate
        } },
        type === 'dropdown' ? react.createElement(MultiLevelDropdown, { renderReference: renderChildren }) : null,
        type === 'popup' ? react.createElement(MultiLevelPopup, { renderReference: renderChildren }) : null));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 89826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "El": function() { return /* binding */ MAX_ADDITIONAL_ITEMS; },
/* harmony export */   "iL": function() { return /* binding */ useMultipleRadioGroupContext; },
/* harmony export */   "iV": function() { return /* binding */ MultipleRadioGroupContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var MultipleRadioGroupContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useMultipleRadioGroupContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(MultipleRadioGroupContext); };
var MAX_ADDITIONAL_ITEMS = 3;


//# sourceMappingURL=context.js.map


/***/ }),

/***/ 49336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MultipleRadio; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/MultipleRadio.css.js
'use client';






var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    cursor: ", ";\n"], ["\n    width: ", ";\n    cursor: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var Placeholder = styled_components_browser_esm/* default.span */.ZP.span(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    user-select: none;\n"], ["\n    color: ", ";\n    user-select: none;\n"])), function (_a) {
    var color = _a.color;
    return color || constants/* colors.textPlaceholder */.O9.textPlaceholder;
});
var ValueContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 4px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n"], ["\n    padding: 4px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n"])));
var Value = styled_components_browser_esm/* default.p */.ZP.p(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    user-select: none;\n    margin: 0;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 18px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 6px 8px;\n    max-width: 100%;\n\n    ", "\n"], ["\n    user-select: none;\n    margin: 0;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 18px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 6px 8px;\n    max-width: 100%;\n\n    ", "\n"])), function (_a) {
    var selectLayoutType = _a.selectLayoutType, hasChecked = _a.hasChecked;
    return selectLayoutType === 'highlight' &&
        hasChecked && (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: ", ";\n            color: ", ";\n            border-radius: 4px;\n        "], ["\n            background-color: ", ";\n            color: ", ";\n            border-radius: 4px;\n        "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.30 */.O9.primary[30]);
});
var ArrowDownContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
var SelectContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    pointer-events: auto;\n    display: grid;\n    grid-template-columns: ", ";\n    align-items: center;\n    background-color: ", ";\n    width: 100%;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: ", "px;\n    height: ", "px;\n    border: 1px solid\n        ", ";\n    ", ";\n\n    ", ";\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    ", "\n\n    color: ", ";\n    transition: background-color 0.25s;\n    &:hover {\n        border-color: ", ";\n        ", "\n        ", ";\n        ", ";\n    }\n    & > span {\n        word-break: break-word;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        -webkit-line-clamp: 1;\n    }\n    ", "\n"], ["\n    pointer-events: auto;\n    display: grid;\n    grid-template-columns: ", ";\n    align-items: center;\n    background-color: ", ";\n    width: 100%;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: ", "px;\n    height: ", "px;\n    border: 1px solid\n        ", ";\n    ", ";\n\n    ", ";\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    ", "\n\n    color: ", ";\n    transition: background-color 0.25s;\n    &:hover {\n        border-color: ", ";\n        ", "\n        ", ";\n        ", ";\n    }\n    & > span {\n        word-break: break-word;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        -webkit-line-clamp: 1;\n    }\n    ", "\n"])), function (_a) {
    var templateCol = _a.templateCol;
    return templateCol || '1fr auto';
}, function (_a) {
    var background = _a.background, name = _a.name;
    return (name && background ? background : '#fff');
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize || 14;
}, function (_a) {
    var height = _a.height;
    return height || 40;
}, function (_a) {
    var isFocus = _a.isFocus, color = _a.color, name = _a.name;
    return isFocus || (color && name) ? "".concat(constants/* colors.borderFocus */.O9.borderFocus) : "".concat(constants/* colors.borderNormal */.O9.borderNormal);
}, function (_a) {
    var isTransparent = _a.isTransparent;
    return isTransparent &&
        "\n    background-color: transparent;\n    border-color: transparent;\n    ";
}, function (_a) {
    var isError = _a.isError;
    return isError && "border: 1px solid ".concat(constants/* colors.borderError */.O9.borderError);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n    border-color: ".concat(constants/* colors.borderDisable */.O9.borderDisable, ";\n    pointer-events: none;\n    background-color: ").concat(constants/* colors.bgDisable */.O9.bgDisable, ";\n    ");
}, function (_a) {
    var selectLayoutType = _a.selectLayoutType;
    return selectLayoutType === 'responsive' && (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: none !important;\n            height: 32px;\n            background: #f1f2f4 !important;\n\n            ", " {\n                width: 30px;\n                height: 30px;\n            }\n            ", " {\n                padding: 0;\n            }\n            ", " {\n                padding: 0;\n            }\n        "], ["\n            border: none !important;\n            height: 32px;\n            background: #f1f2f4 !important;\n\n            ", " {\n                width: 30px;\n                height: 30px;\n            }\n            ", " {\n                padding: 0;\n            }\n            ", " {\n                padding: 0;\n            }\n        "])), ArrowDownContainer, Placeholder, Value);
}, function (_a) {
    var selectLayoutType = _a.selectLayoutType, hasChecked = _a.hasChecked;
    return selectLayoutType === 'responsive' &&
        hasChecked && (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: rgb(239, 245, 255) !important;\n            color: rgb(0, 54, 153) !important;\n\n            svg {\n                path {\n                    fill: rgb(0, 54, 153) !important;\n                }\n            }\n        "], ["\n            background-color: rgb(239, 245, 255) !important;\n            color: rgb(0, 54, 153) !important;\n\n            svg {\n                path {\n                    fill: rgb(0, 54, 153) !important;\n                }\n            }\n        "])));
}, function (_a) {
    var isSortOnMobile = _a.isSortOnMobile;
    return isSortOnMobile
        ? "\n            background-color: transparent !important;\n            & > span {\n                background-color: transparent !important;\n                color: #333 !important;\n            }\n            svg {\n                path {\n                    fill: #333 !important;\n                }\n            }\n        "
        : '';
}, function (_a) {
    var hasChecked = _a.hasChecked, selectLayoutType = _a.selectLayoutType;
    return hasChecked &&
        selectLayoutType === 'highlight' && (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid ", ";\n        "], ["\n            border: 1px solid ", ";\n        "])), constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var color = _a.color, name = _a.name;
    return (name && color ? color : constants/* colors.textColor */.O9.textColor);
}, function (_a) {
    var isFocus = _a.isFocus;
    return (isFocus ? "".concat(constants/* colors.borderFocus */.O9.borderFocus) : "".concat(constants/* colors.borderHover */.O9.borderHover));
}, function (_a) {
    var hasChecked = _a.hasChecked;
    return hasChecked && (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                border: 1px solid ", ";\n            "], ["\n                border: 1px solid ", ";\n            "])), constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var isTransparent = _a.isTransparent, noHover = _a.noHover;
    return isTransparent && (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background-color: ", ";\n                border-color: transparent;\n            "], ["\n                background-color: ", ";\n                border-color: transparent;\n            "])), noHover ? 'unset' : constants/* colors.tagSelectBorder */.O9.tagSelectBorder);
}, function (_a) {
    var isError = _a.isError;
    return isError && "border-color: ".concat(constants/* colors.borderError */.O9.borderError);
}, function (_a) {
    var selectLayoutType = _a.selectLayoutType;
    if (selectLayoutType === 'empty-bg') {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background-color: transparent;\n                height: 36px;\n                padding-left: 6px !important;\n                padding-right: 4px !important;\n                ", " {\n                    padding: 2px 8px;\n                }\n                ", " {\n                    width: 34px;\n                    height: 34px;\n                }\n            "], ["\n                background-color: transparent;\n                height: 36px;\n                padding-left: 6px !important;\n                padding-right: 4px !important;\n                ", " {\n                    padding: 2px 8px;\n                }\n                ", " {\n                    width: 34px;\n                    height: 34px;\n                }\n            "])), Placeholder, ArrowDownContainer);
    }
    // VariantType = 'empty-bg'
    return '';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


//# sourceMappingURL=MultipleRadio.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/context.js
var MultipleRadio_context = __webpack_require__(89826);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SortMobileIcon/index.js
var SortMobileIcon = __webpack_require__(22204);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/Dropdown/Dropdown.css.js
'use client';






var Dropdown_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Dropdown_css_templateObject_1 || (Dropdown_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    z-index: 1099;\n"], ["\n    z-index: 1099;\n"])));
var DropdownWrapper = styled_components_browser_esm/* default.div */.ZP.div(Dropdown_css_templateObject_2 || (Dropdown_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    padding: 16px;\n    border-radius: 12px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n"], ["\n    background-color: #fff;\n    padding: 16px;\n    border-radius: 12px;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n"])));
var DropdownContainer = styled_components_browser_esm/* default.ul */.ZP.ul(Dropdown_css_templateObject_3 || (Dropdown_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    max-height: ", ";\n    list-style: none;\n    overflow-y: auto;\n\n    ", "\n"], ["\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    max-height: ", ";\n    list-style: none;\n    overflow-y: auto;\n\n    ", "\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight;
}, styledCss/* default.scrollbar */.ZP.scrollbar);
var List = styled_components_browser_esm/* default.ul */.ZP.ul(Dropdown_css_templateObject_4 || (Dropdown_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    list-style: none;\n    padding: 0;\n"], ["\n    list-style: none;\n    padding: 0;\n"])));
var Item = styled_components_browser_esm/* default.li */.ZP.li(Dropdown_css_templateObject_5 || (Dropdown_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    > label {\n        background: ", ";\n        > p {\n            color: ", ";\n        }\n    }\n"], ["\n    > label {\n        background: ", ";\n        > p {\n            color: ", ";\n        }\n    }\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? Colors/* colors.primary.95 */.O9.primary[95] : 'unset');
}, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.20 */.O9.grey[20]);
});
var FieldSet = styled_components_browser_esm/* default.fieldset */.ZP.fieldset(Dropdown_css_templateObject_6 || (Dropdown_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0;\n    border: unset;\n"], ["\n    padding: 0;\n    border: unset;\n"])));
var EmptyPlaceholder = styled_components_browser_esm/* default.p */.ZP.p(Dropdown_css_templateObject_7 || (Dropdown_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 10px 8px;\n    font-size: 14px;\n    color: ", ";\n    margin: 0;\n"], ["\n    padding: 10px 8px;\n    font-size: 14px;\n    color: ", ";\n    margin: 0;\n"])), Colors/* colors.grey.50 */.O9.grey[50]);
var TitleDropDown = styled_components_browser_esm/* default.p */.ZP.p(Dropdown_css_templateObject_8 || (Dropdown_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    display: flex;\n    height: 44px;\n    align-items: center;\n    margin: 0;\n"], ["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    display: flex;\n    height: 44px;\n    align-items: center;\n    margin: 0;\n"])));
var Dropdown_css_templateObject_1, Dropdown_css_templateObject_2, Dropdown_css_templateObject_3, Dropdown_css_templateObject_4, Dropdown_css_templateObject_5, Dropdown_css_templateObject_6, Dropdown_css_templateObject_7, Dropdown_css_templateObject_8;


//# sourceMappingURL=Dropdown.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/index.js
var SingleRadio = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/Dropdown/Search/Search.css.js
'use client';






var Container = styled_components_browser_esm/* default.div */.ZP.div(Search_css_templateObject_1 || (Search_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    display: grid;\n    align-items: center;\n    grid-template-columns: auto 1fr auto;\n    background-color: ", ";\n    color: ", ";\n    padding: 8px 12px;\n    border-radius: 8px;\n    column-gap: 8px;\n    margin: 4px 0;\n    height: 44px;\n"], ["\n    position: relative;\n    display: grid;\n    align-items: center;\n    grid-template-columns: auto 1fr auto;\n    background-color: ", ";\n    color: ", ";\n    padding: 8px 12px;\n    border-radius: 8px;\n    column-gap: 8px;\n    margin: 4px 0;\n    height: 44px;\n"])), Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.grey.50 */.O9.grey[50]);
var Input = styled_components_browser_esm/* default.input */.ZP.input(Search_css_templateObject_2 || (Search_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: none;\n    outline: none;\n    background: unset;\n"], ["\n    border: none;\n    outline: none;\n    background: unset;\n"])));
var RemoveIcon = (0,styled_components_browser_esm/* default */.ZP)(RemoveFillIcon/* default */.Z)(Search_css_templateObject_3 || (Search_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: 0.5;\n    visibility: visible;\n    cursor: pointer;\n    transition: all 0.3s;\n    &.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n"], ["\n    opacity: 0.5;\n    visibility: visible;\n    cursor: pointer;\n    transition: all 0.3s;\n    &.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n"])));
var Search_css_templateObject_1, Search_css_templateObject_2, Search_css_templateObject_3;


//# sourceMappingURL=Search.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var SearchIcon = __webpack_require__(6538);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/Dropdown/Search/index.js
'use client';





var Search = function (_a) {
    var placeholder = _a.placeholder, _onChange = _a.onChange, _b = _a.searchText, searchText = _b === void 0 ? '' : _b;
    var searchRef = (0,react.useRef)(null);
    var _c = (0,react.useState)('none'), inputRemoveState = _c[0], setInputRemoveState = _c[1];
    var handleClickClear = function () {
        _onChange('');
        if (searchRef.current) {
            searchRef.current.value = '';
            searchRef.current.focus();
            setInputRemoveState('focus');
        }
    };
    (0,react.useEffect)(function () {
        if (searchRef.current) {
            searchRef.current.focus({
                preventScroll: true
            });
            setInputRemoveState('focus');
        }
    }, []);
    return (react.createElement(Container, null,
        react.createElement(SearchIcon/* default */.Z, { height: 19 }),
        react.createElement(Input, { ref: searchRef, placeholder: placeholder, onChange: function (e) { return _onChange(e.target.value); }, className: 'multiple-radio-search-input', onFocus: function () { return setInputRemoveState('focus'); }, onBlur: function () { return inputRemoveState !== 'focus' && setInputRemoveState('none'); } }),
        react.createElement(RemoveIcon, { className: "i11l-remove-icon ".concat(inputRemoveState === 'none' ? 'hidden' : searchText !== '' ? '' : 'hidden'), onClick: handleClickClear })));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDropdownAnimation.js
var useDropdownAnimation = __webpack_require__(91623);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/services.js
var services = __webpack_require__(69023);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/Dropdown/index.js
'use client';
















var Dropdown = (0,react.forwardRef)(function (_a, ref) {
    var show = _a.show, isBackgroundChecked = _a.isBackgroundChecked, title = _a.title, placement = _a.placement, searchTextState = _a.searchTextState, _b = _a.isEnableSearchAPI, isEnableSearchAPI = _b === void 0 ? false : _b, _c = _a.msBaseUrl, msBaseUrl = _c === void 0 ? '' : _c, _d = _a.langCode, langCode = _d === void 0 ? constants/* ELanguage.VI */.Df.VI : _d, restProps = (0,_tslib/* __rest */._T)(_a, ["show", "isBackgroundChecked", "title", "placement", "searchTextState", "isEnableSearchAPI", "msBaseUrl", "langCode"]);
    var _e = (0,MultipleRadio_context/* useMultipleRadioGroupContext */.iL)(), handleChange = _e.handleChange, dropdown = _e.dropdown, options = _e.options, selectedItem = _e.selectedItem, name = _e.name, fieldLabel = _e.fieldLabel;
    var _f = dropdown || {}, _g = _f.maxHeight, maxHeight = _g === void 0 ? 'unset' : _g, _h = _f.isLeftRadio, isLeftRadio = _h === void 0 ? true : _h, _j = _f.emptyText, emptyText = _j === void 0 ? 'No result found' : _j, _k = _f.isSearchable, isSearchable = _k === void 0 ? false : _k, _l = _f.searchBoxPlaceholder, searchBoxPlaceholder = _l === void 0 ? 'Search' : _l, _m = _f.customOptionItem, customOptionItem = _m === void 0 ? function () { return null; } : _m, _o = _f.searchFields, searchFields = _o === void 0 ? ['name'] : _o;
    var searchText = searchTextState[0], setSearchText = searchTextState[1];
    var _p = (0,react.useState)([]), searchResult = _p[0], setSearchResult = _p[1];
    var debounceKeyword = (0,hooks/* default */.ZP)([searchText], 300);
    var handleClickItem = function (value) {
        handleChange(value);
    };
    var getSearchResult = function (keyword) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (keyword === '') {
                        setSearchResult([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,services/* searchCompanyIndustries */.I)(msBaseUrl, keyword)];
                case 1:
                    response = _b.sent();
                    setSearchResult((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetSearchText = function (value) {
        setSearchText((0,helpers/* transformToLatin */.nr)(value));
    };
    (0,react.useEffect)(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(searchText);
    }, [debounceKeyword]);
    var renderOptions = (0,react.useMemo)(function () {
        var _a, _b;
        var responseOptions = options.filter(function (option) {
            if (searchText === '')
                return true;
            var optionSearch = '';
            searchFields.map(function (field) {
                optionSearch += option[field];
            });
            return (0,helpers/* transformToLatin */.nr)(optionSearch).indexOf(searchText) > -1;
        });
        if (isEnableSearchAPI && searchResult.length > 0) {
            var responseAPI = [];
            var _loop_1 = function (i) {
                var companyItem = searchResult[i];
                if (!companyItem) {
                    return "continue";
                }
                if (responseAPI.length >= MultipleRadio_context/* MAX_ADDITIONAL_ITEMS */.El) {
                    return "break";
                }
                var filteredMatch = responseOptions.filter(function (item) { return item.id === companyItem.id; });
                if (filteredMatch.length > 0) {
                    return "continue";
                }
                else {
                    responseAPI.push({
                        id: companyItem.id,
                        name: langCode === constants/* ELanguage.VI */.Df.VI
                            ? (_a = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _a === void 0 ? void 0 : _a.nameVi
                            : (_b = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _b === void 0 ? void 0 : _b.nameEn
                    });
                }
            };
            for (var i = 0; i < searchResult.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
            responseOptions = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], responseOptions, true), responseAPI, true);
        }
        return responseOptions;
    }, [searchText, searchResult, options]);
    var _q = (0,useDropdownAnimation/* default */.Z)(show, placement), isMounted = _q.isMounted, styles = _q.styles;
    return (isMounted && (react.createElement(Dropdown_css_Wrapper, (0,_tslib/* __assign */.pi)({ ref: ref, id: 'multiple-radio' }, restProps),
        react.createElement(DropdownWrapper, { "data-floating-placement": placement, style: styles },
            title && react.createElement(TitleDropDown, null, title),
            isSearchable && (react.createElement(Search, { searchText: searchText, placeholder: searchBoxPlaceholder, onChange: handleSetSearchText })),
            react.createElement(DropdownContainer, { maxHeight: maxHeight },
                react.createElement(FieldSet, { id: name },
                    react.createElement(List, null,
                        renderOptions.map(function (option) {
                            var id = option.id;
                            return (react.createElement(Item, { key: id, "data-value": id, isActive: isBackgroundChecked && id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) },
                                react.createElement(SingleRadio/* default */.Z, { id: id, label: option[fieldLabel], onChange: function () { return handleClickItem(option); }, name: name, checked: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), isLeftRadio: isLeftRadio, isDropdownRadio: true, height: 44, customValue: customOptionItem((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, option), { active: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) })) })));
                        }),
                        renderOptions.length === 0 ? (react.createElement("li", null,
                            react.createElement(EmptyPlaceholder, null, emptyText))) : (react.createElement(react.Fragment, null)))))))));
});


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowBackIcon/index.js
var ArrowBackIcon = __webpack_require__(40468);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/MobileDialog/MobileDialog.css.js
'use client';





var MobileDialog_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_1 || (MobileDialog_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 10099;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n"], ["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 10099;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n"])));
var Header = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_2 || (MobileDialog_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n"], ["\n    padding: 16px;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n"])));
var MainContainer = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_3 || (MobileDialog_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-rows: auto 1fr;\n    background-color: #fafafa;\n    box-shadow: 0 0 0 1px rgb(0 0 0 / 5%);\n    padding: 16px;\n    overflow-y: auto;\n    flex: 1 1 0;\n"], ["\n    display: grid;\n    grid-template-rows: auto 1fr;\n    background-color: #fafafa;\n    box-shadow: 0 0 0 1px rgb(0 0 0 / 5%);\n    padding: 16px;\n    overflow-y: auto;\n    flex: 1 1 0;\n"])));
var ScrollableContainer = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_4 || (MobileDialog_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    overflow-y: auto;\n"], ["\n    overflow-y: auto;\n"])));
var MobileDialog_css_List = styled_components_browser_esm/* default.ul */.ZP.ul(MobileDialog_css_templateObject_5 || (MobileDialog_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var MobileDialog_css_EmptyPlaceholder = styled_components_browser_esm/* default.p */.ZP.p(MobileDialog_css_templateObject_6 || (MobileDialog_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 10px 8px;\n    font-size: 14px;\n    color: ", ";\n    margin: 0;\n"], ["\n    padding: 10px 8px;\n    font-size: 14px;\n    color: ", ";\n    margin: 0;\n"])), constants/* colors.textGrayColor */.O9.textGrayColor);
var MobileDialog_css_templateObject_1, MobileDialog_css_templateObject_2, MobileDialog_css_templateObject_3, MobileDialog_css_templateObject_4, MobileDialog_css_templateObject_5, MobileDialog_css_templateObject_6;


//# sourceMappingURL=MobileDialog.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/MobileDialog/index.js
'use client';















var MobileDialog = function (_a) {
    var onCancel = _a.onCancel, mobilePopupTitle = _a.mobilePopupTitle, msBaseUrl = _a.msBaseUrl, isEnableSearchAPI = _a.isEnableSearchAPI, langCode = _a.langCode;
    var _b = (0,MultipleRadio_context/* useMultipleRadioGroupContext */.iL)(), handleChange = _b.handleChange, dropdown = _b.dropdown, options = _b.options, selectedItem = _b.selectedItem, name = _b.name, fieldLabel = _b.fieldLabel;
    var _c = dropdown || {}, _d = _c.isLeftRadio, isLeftRadio = _d === void 0 ? true : _d, _e = _c.hoverBgOff, hoverBgOff = _e === void 0 ? false : _e, _f = _c.emptyText, emptyText = _f === void 0 ? 'No result found' : _f, _g = _c.isSearchable, isSearchable = _g === void 0 ? false : _g, _h = _c.searchBoxPlaceholder, searchBoxPlaceholder = _h === void 0 ? 'Search' : _h, _j = _c.customOptionItem, customOptionItem = _j === void 0 ? function () { return null; } : _j, _k = _c.searchFields, searchFields = _k === void 0 ? ['name'] : _k;
    var _l = (0,react.useState)(''), searchText = _l[0], setSearchText = _l[1];
    var _m = (0,react.useState)([]), searchResult = _m[0], setSearchResult = _m[1];
    var debounceKeyword = (0,hooks/* default */.ZP)([searchText], 300);
    var handleClickItem = function (value) {
        setTimeout(function () {
            setSearchText('');
        }, 200);
        handleChange(value);
    };
    var handleSetSearchText = function (value) {
        setSearchText((0,helpers/* transformToLatin */.nr)(value));
    };
    var getSearchResult = function (keyword) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (keyword === '') {
                        setSearchResult([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,services/* searchCompanyIndustries */.I)(msBaseUrl, keyword)];
                case 1:
                    response = _b.sent();
                    setSearchResult((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderOptions = (0,react.useMemo)(function () {
        var _a, _b;
        var responseOptions = options.filter(function (option) {
            if (searchText === '')
                return true;
            var optionSearch = '';
            searchFields.map(function (field) {
                optionSearch += option[field];
            });
            return (0,helpers/* transformToLatin */.nr)(optionSearch).indexOf(searchText) > -1;
        });
        if (isEnableSearchAPI && searchResult.length > 0) {
            var responseAPI = [];
            var _loop_1 = function (i) {
                var companyItem = searchResult[i];
                if (!companyItem) {
                    return "continue";
                }
                if (responseAPI.length >= MultipleRadio_context/* MAX_ADDITIONAL_ITEMS */.El) {
                    return "break";
                }
                var filteredMatch = responseOptions.filter(function (item) { return item.id === companyItem.id; });
                if (filteredMatch.length > 0) {
                    return "continue";
                }
                else {
                    responseAPI.push({
                        id: companyItem.id,
                        name: langCode === constants/* ELanguage.VI */.Df.VI
                            ? (_a = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _a === void 0 ? void 0 : _a.nameVi
                            : (_b = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _b === void 0 ? void 0 : _b.nameEn
                    });
                }
            };
            for (var i = 0; i < searchResult.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
            responseOptions = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], responseOptions, true), responseAPI, true);
        }
        return responseOptions;
    }, [searchText, searchResult, options]);
    (0,react.useEffect)(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(searchText);
    }, [debounceKeyword]);
    if (typeof window === 'undefined')
        return react.createElement(react.Fragment, null);
    return react_dom.createPortal(react.createElement(MobileDialog_css_Wrapper, null,
        react.createElement(Header, null,
            react.createElement(ArrowBackIcon/* default */.Z, { onClick: onCancel }),
            react.createElement(Variant/* Span */.Dr, { size: 'medium', name: 'title', style: { marginLeft: 24 } }, mobilePopupTitle || '')),
        react.createElement(MainContainer, null,
            isSearchable && (react.createElement(Search, { searchText: searchText, placeholder: searchBoxPlaceholder, onChange: handleSetSearchText })),
            react.createElement(ScrollableContainer, null,
                react.createElement(MobileDialog_css_List, null,
                    renderOptions.map(function (option) {
                        var id = option.id;
                        return (react.createElement("li", { key: id },
                            react.createElement(SingleRadio/* default */.Z, { id: id, label: option[fieldLabel], onChange: function () { return handleClickItem(option); }, name: name, checked: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), isLeftRadio: isLeftRadio, hoverBgOff: hoverBgOff, noBg: true, customValue: customOptionItem((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, option), { active: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) })) })));
                    }),
                    renderOptions.length === 0 && (react.createElement("li", null,
                        react.createElement(MobileDialog_css_EmptyPlaceholder, null, emptyText))))))), document.body);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/index.js + 2 modules
var BottomSheet = __webpack_require__(6031);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/PopupBottom/styles.css.js
'use client';




var Body = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_1 || (styles_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n"], ["\n    background-color: #fff;\n"])));
var styles_css_List = styled_components_browser_esm/* default.ul */.ZP.ul(styles_css_templateObject_2 || (styles_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var ListItem = styled_components_browser_esm/* default.li */.ZP.li(styles_css_templateObject_5 || (styles_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px;\n    font-size: 1rem;\n    line-height: 20px;\n    &:hover {\n        background-color: #f7faff;\n    }\n    ", "\n"], ["\n    padding: 8px;\n    font-size: 1rem;\n    line-height: 20px;\n    &:hover {\n        background-color: #f7faff;\n    }\n    ", "\n"])), function (_a) {
    var active = _a.active;
    return active
        ? (0,styled_components_browser_esm/* css */.iv)(styles_css_templateObject_3 || (styles_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background-color: #f7faff;\n                  font-weight: 500;\n              "], ["\n                  background-color: #f7faff;\n                  font-weight: 500;\n              "]))) : (0,styled_components_browser_esm/* css */.iv)(styles_css_templateObject_4 || (styles_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background-color: #fff;\n                  font-weight: 400;\n              "], ["\n                  background-color: #fff;\n                  font-weight: 400;\n              "])));
});
styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_6 || (styles_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    margin: -16px;\n"], ["\n    padding: 16px;\n    margin: -16px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_7 || (styles_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    margin: -16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border-bottom: 1px solid #f1f1f1;\n"], ["\n    padding: 16px;\n    margin: -16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border-bottom: 1px solid #f1f1f1;\n"])));
var styles_css_templateObject_1, styles_css_templateObject_2, styles_css_templateObject_3, styles_css_templateObject_4, styles_css_templateObject_5, styles_css_templateObject_6, styles_css_templateObject_7;


//# sourceMappingURL=styles.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/PopupBottom/index.js
'use client';










function PopupBottom(_a) {
    var onCancel = _a.onCancel, isOpen = _a.isOpen, titleDropDown = _a.titleDropDown;
    var _b = (0,MultipleRadio_context/* useMultipleRadioGroupContext */.iL)(), handleChange = _b.handleChange, dropdown = _b.dropdown, options = _b.options, selectedItem = _b.selectedItem;
    var _c = dropdown || {}, _d = _c.emptyText, emptyText = _d === void 0 ? 'No result found' : _d, _e = _c.isSearchable, isSearchable = _e === void 0 ? false : _e, _f = _c.searchBoxPlaceholder, searchBoxPlaceholder = _f === void 0 ? 'Search' : _f, _g = _c.searchFields, searchFields = _g === void 0 ? ['name'] : _g;
    var _h = (0,react.useState)(''), searchText = _h[0], setSearchText = _h[1];
    var handleClickItem = function (value) {
        setTimeout(function () {
            setSearchText('');
        }, 200);
        handleChange(value);
    };
    var handleSetSearchText = function (value) {
        setSearchText((0,helpers/* transformToLatin */.nr)(value));
    };
    var renderOptions = (0,react.useMemo)(function () {
        return options.filter(function (option) {
            if (searchText === '')
                return true;
            var optionSearch = '';
            searchFields.map(function (field) {
                optionSearch += option[field];
            });
            return (0,helpers/* transformToLatin */.nr)(optionSearch).indexOf(searchText) > -1;
        });
    }, [searchText, options]);
    return (react.createElement(BottomSheet/* default */.Z, { onClose: onCancel, isOpen: isOpen, header: titleDropDown, footer: react.createElement(react.Fragment, null), options: { isReverseHeader: true } },
        react.createElement(Body, null,
            isSearchable && (react.createElement(Search, { searchText: searchText, placeholder: searchBoxPlaceholder, onChange: handleSetSearchText })),
            react.createElement(ScrollableContainer, null,
                react.createElement(styles_css_List, null,
                    renderOptions.map(function (option) {
                        return (react.createElement(ListItem, { key: option.id, onClick: function () { return handleClickItem(option); }, active: option.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) }, option.name));
                    }),
                    renderOptions.length === 0 && (react.createElement(ListItem, null,
                        react.createElement(EmptyPlaceholder, null, emptyText))))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/index.js
'use client';
















var MultipleRadio = function (_a) {
    var _b, _c, _d, _e, _f;
    var name = _a.name, _g = _a.width, width = _g === void 0 ? '100%' : _g, height = _a.height, fontSize = _a.fontSize, options = _a.options, dropdown = _a.dropdown, _h = _a.placeholder, placeholder = _h === void 0 ? '' : _h, placeholderColor = _a.placeholderColor, _j = _a.value, value = _j === void 0 ? null : _j, _k = _a.hasError, hasError = _k === void 0 ? false : _k, _l = _a.disable, disable = _l === void 0 ? false : _l, onChange = _a.onChange, _m = _a.isMobile, isMobile = _m === void 0 ? false : _m, _o = _a.placement, placement = _o === void 0 ? 'bottom-start' : _o, _p = _a.isTransparent, isTransparent = _p === void 0 ? false : _p, _q = _a.noHover, noHover = _q === void 0 ? false : _q, _r = _a.arrowDownSize, arrowDownSize = _r === void 0 ? {
        width: 20,
        height: 20
    } : _r, _s = _a.spacingElement, spacingElement = _s === void 0 ? 0 : _s, _t = _a.fieldValue, fieldValue = _t === void 0 ? 'id' : _t, _u = _a.fieldLabel, fieldLabel = _u === void 0 ? 'name' : _u, isBackgroundChecked = _a.isBackgroundChecked, background = _a.background, color = _a.color, onFocus = _a.onFocus, onBlur = _a.onBlur, selectStyle = _a.selectStyle, dropdownStyle = _a.dropdownStyle, 
    // For custom only
    customValue = _a.customValue, prefix = _a.prefix, titleDropdown = _a.titleDropdown, mobilePopupTitle = _a.mobilePopupTitle, isNewPopupBottom = _a.isNewPopupBottom, children = _a.children, _v = _a.isEnableSearchAPI, isEnableSearchAPI = _v === void 0 ? false : _v, _w = _a.msBaseUrl, msBaseUrl = _w === void 0 ? '' : _w, _x = _a.langCode, langCode = _x === void 0 ? constants/* ELanguage.VI */.Df.VI : _x, isSortOnMobile = _a.isSortOnMobile, selectLayout = _a.selectLayout, _y = _a.notCountedAsValue, notCountedAsValue = _y === void 0 ? [] : _y;
    var selectedIndex = options.findIndex(function (option) { return JSON.stringify(option.id) === JSON.stringify(value); });
    var _z = (0,react.useState)(options[selectedIndex]), selectedItem = _z[0], setSelectedItem = _z[1];
    // Dropdown control
    var _0 = (0,react.useState)(false), showDropdown = _0[0], setShowDropdown = _0[1];
    // Mobile dialog control
    var _1 = (0,react.useState)(false), showDialog = _1[0], setShowDialog = _1[1];
    var _2 = (0,react.useState)(''), searchText = _2[0], setSearchText = _2[1];
    // Store prev value
    var prevValue = (0,react.useRef)(value);
    var handleToggle = function () {
        if (disable)
            return;
        if (isMobile) {
            setShowDialog(true);
            return;
        }
        setShowDropdown(function (state) { return !state; });
    };
    var handleChange = function (value) {
        var valueFromFields = {};
        var result = {};
        if (Array.isArray(fieldValue)) {
            fieldValue.forEach(function (field) { return (valueFromFields[field] = value[field]); });
            result = { value: valueFromFields };
        }
        else {
            result = { value: value[fieldValue] };
        }
        setSelectedItem(value);
        onChange(result);
        setSearchText('');
        if (isMobile) {
            setShowDialog(false);
            return;
        }
        setShowDropdown(false);
    };
    // Handle dialog action
    var handleDialogCancel = function () {
        setShowDialog(false);
    };
    var _3 = (0,useFloating/* default */.Z)({
        placement: placement,
        position: ((_b = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _b === void 0 ? void 0 : _b.position) || 'absolute',
        config: {
            offset: spacingElement,
            detectHidden: true,
            useWindowAsFlippingContainer: ((_c = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _c === void 0 ? void 0 : _c.useWindowAsFlippingContainer) || false
        }
    }), refs = _3.refs, context = _3.context, FloatingPortal = _3.FloatingPortal;
    (0,useClickAway/* default */.Z)(function () {
        setShowDropdown(false);
        setSearchText('');
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // Context props
    var selectRadioProps = {
        name: name,
        dropdown: dropdown,
        options: options,
        handleChange: handleChange,
        selectedItem: selectedItem,
        fieldLabel: fieldLabel
    };
    (0,react.useEffect)(function () {
        if (JSON.stringify(prevValue.current) === JSON.stringify(value)) {
            return;
        }
        var selectedIndex = options.findIndex(function (option) { return JSON.stringify(option.id) === JSON.stringify(value); });
        setSelectedItem(options[selectedIndex]);
    }, [value, JSON.stringify(options)]);
    (0,react.useEffect)(function () {
        prevValue.current = selectedItem;
    }, [selectedItem]);
    // block scroll body when dropdownDialog open
    (0,react.useEffect)(function () {
        if (showDialog) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
            return;
        }
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [showDialog]);
    // check not nullist & not in notCountedAsValue list
    var hasValueChecked = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) != null && !notCountedAsValue.includes(selectedItem.id);
    var renderValue = function () {
        return customValue ? (customValue(selectedItem)) : (react.createElement(Value, { hasChecked: hasValueChecked, selectLayoutType: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type }, hasValueChecked ? (selectedItem.name) : (react.createElement(Placeholder, { color: placeholderColor }, placeholder))));
    };
    var renderPopup = function () {
        if (isNewPopupBottom) {
            return react.createElement(PopupBottom, { onCancel: handleDialogCancel, isOpen: showDialog, titleDropDown: titleDropdown });
        }
        return (react.createElement(MobileDialog, { onCancel: handleDialogCancel, mobilePopupTitle: mobilePopupTitle, langCode: langCode, msBaseUrl: msBaseUrl, isEnableSearchAPI: isEnableSearchAPI }));
    };
    return (react.createElement(Wrapper, { disabled: disable, width: width, id: 'multiple-radio', style: {
            position: ((_d = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _d === void 0 ? void 0 : _d.enablePortal) ? 'static' : 'relative'
        } },
        children ? (react.createElement("div", { ref: refs.setReference, onClick: handleToggle, className: 'multiple-radio-container', onBlur: onBlur, style: selectStyle }, children)) : (react.createElement(SelectContainer, { ref: refs.setReference, isFocus: showDropdown, isError: hasError, onClick: handleToggle, disabled: disable, isTransparent: isTransparent, noHover: noHover, height: height, fontSize: fontSize, background: background, color: color, name: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name, className: 'multiple-radio-container', onFocus: function () {
                onFocus && onFocus();
            }, onBlur: onBlur, style: selectStyle, templateCol: prefix ? 'auto 1fr auto' : undefined, hasChecked: hasValueChecked, isSortOnMobile: isSortOnMobile, selectLayoutType: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type, "data-input-container": true },
            prefix && prefix,
            react.createElement(ValueContainer, null, renderValue()),
            !isSortOnMobile ? (react.createElement(ArrowDownContainer, null,
                react.createElement(ArrowDownIcon/* default */.Z, { width: arrowDownSize.width, height: arrowDownSize.height }))) : (react.createElement(ArrowDownContainer, null,
                react.createElement(SortMobileIcon/* default */.Z, null))))),
        react.createElement(FloatingPortal, { enable: (_e = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _e === void 0 ? void 0 : _e.enablePortal },
            react.createElement(MultipleRadio_context/* MultipleRadioGroupContext.Provider */.iV.Provider, { value: selectRadioProps },
                react.createElement(Dropdown, { ref: refs.setPopup, placement: context.placement, style: (0,_tslib/* __assign */.pi)({ display: context.isReferenceHidden ? 'none' : 'block', position: context.position, left: context.x, top: context.y, width: (dropdown === null || dropdown === void 0 ? void 0 : dropdown.width) || ((_f = refs.reference.current) === null || _f === void 0 ? void 0 : _f.offsetWidth) }, dropdownStyle), searchTextState: [searchText, setSearchText], show: showDropdown, isBackgroundChecked: isBackgroundChecked, isEnableSearchAPI: isEnableSearchAPI, msBaseUrl: msBaseUrl, langCode: langCode, title: titleDropdown }),
                showDialog && renderPopup()))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 69023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ searchCompanyIndustries; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



var searchCompanyIndustries = function (msBaseUrl, keyword) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var api, requestOptions, response, err_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                api = "".concat(msBaseUrl, "/meta/v1.2/search-company-industries?keyword=").concat(keyword);
                requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [2 /*return*/, {
                        data: [],
                        meta: {
                            statusCode: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map


/***/ }),

/***/ 42865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MultipleSelect$1; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleCheckBox/index.js + 1 modules
var SingleCheckBox = __webpack_require__(75297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/MultipleSelect.css.js
'use client';







var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    width: 100%;\n    font-size: 14px;\n    line-height: 20px;\n"], ["\n    display: inline-block;\n    width: 100%;\n    font-size: 14px;\n    line-height: 20px;\n"])));
var SelectContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    background-color: white;\n    border-radius: 6px;\n    border: 1px solid ", ";\n    max-width: ", ";\n    width: ", ";\n    height: 40px;\n\n    display: flex;\n    justify-content: space-between;\n    gap: 4px;\n    cursor: pointer;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    position: relative;\n    background-color: white;\n    border-radius: 6px;\n    border: 1px solid ", ";\n    max-width: ", ";\n    width: ", ";\n    height: 40px;\n\n    display: flex;\n    justify-content: space-between;\n    gap: 4px;\n    cursor: pointer;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), Colors/* colors.grey.80 */.O9.grey[80], function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "".concat(maxWidth, "px") : '100%');
}, function (_a) {
    var width = _a.width;
    return (width ? "".concat(width, "px") : '100%');
}, function (_a) {
    var type = _a.type, active = _a.active;
    switch (type) {
        case 'default':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                    ", "\n                "], ["\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                    ", "\n                "])), constants/* colors.borderHover */.O9.borderHover, active && (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        border: 1px solid ", ";\n\n                        &:hover {\n                            border: 1px solid ", ";\n                        }\n                    "], ["\n                        border: 1px solid ", ";\n\n                        &:hover {\n                            border: 1px solid ", ";\n                        }\n                    "])), constants/* colors.borderFocus */.O9.borderFocus, constants/* colors.borderFocus */.O9.borderFocus));
        case 'notBackground':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding: 0 30px 0 0;\n                "], ["\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding: 0 30px 0 0;\n                "])));
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n            background-color: ", ";\n            border: 1px solid ", ";\n        "], ["\n            pointer-events: none;\n            background-color: ", ";\n            border: 1px solid ", ";\n        "])), constants/* colors.bgDisable */.O9.bgDisable, constants/* colors.borderDisable */.O9.borderDisable);
}, function (_a) {
    var hasError = _a.hasError;
    return hasError && (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid ", ";\n            &:hover {\n                border: 1px solid ", ";\n            }\n        "], ["\n            border: 1px solid ", ";\n            &:hover {\n                border: 1px solid ", ";\n            }\n        "])), constants/* colors.borderError */.O9.borderError, constants/* colors.borderError */.O9.borderError);
}, function (_a) {
    var hasValue = _a.hasValue, selectLayout = _a.selectLayout;
    return hasValue &&
        selectLayout === 'highlight' && (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid ", ";\n            &:hover {\n                border: 1px solid ", ";\n            }\n        "], ["\n            border: 1px solid ", ";\n            &:hover {\n                border: 1px solid ", ";\n            }\n        "])), constants/* colors.borderFocus */.O9.borderFocus, constants/* colors.borderFocus */.O9.borderFocus);
});
var SelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    padding: 4px;\n    gap: 4px;\n\n    width: calc(100% - 44px);\n"], ["\n    display: flex;\n    padding: 4px;\n    gap: 4px;\n\n    width: calc(100% - 44px);\n"])));
var SelectItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 6px 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    background-color: ", ";\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n\n    > span {\n        display: block;\n    }\n\n    ", "\n    ", "\n"], ["\n    position: relative;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 6px 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    background-color: ", ";\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n\n    > span {\n        display: block;\n    }\n\n    ", "\n    ", "\n"])), constants/* colors.tagSelectBorder */.O9.tagSelectBorder, constants/* colors.tagSelect */.O9.tagSelect, function (_a) {
    var hoverOn = _a.hoverOn;
    return hoverOn && (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            &:hover {\n                padding: 6px 24px 6px 8px;\n            }\n        "], ["\n            &:hover {\n                padding: 6px 24px 6px 8px;\n            }\n        "])));
}, function (_a) {
    var selectLayout = _a.selectLayout;
    return selectLayout === 'highlight' && (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: ", ";\n            color: ", ";\n            border: none;\n        "], ["\n            background-color: ", ";\n            color: ", ";\n            border: none;\n        "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.30 */.O9.primary[30]);
});
var SelectItemIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    opacity: 0;\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: all 0.2s;\n    z-index: 5;\n    cursor: pointer;\n\n    ", ":hover & {\n        opacity: 1;\n        right: 5px;\n    }\n    > svg {\n        vertical-align: baseline;\n    }\n    ", "\n"], ["\n    display: inline-flex;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    opacity: 0;\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: all 0.2s;\n    z-index: 5;\n    cursor: pointer;\n\n    ", ":hover & {\n        opacity: 1;\n        right: 5px;\n    }\n    > svg {\n        vertical-align: baseline;\n    }\n    ", "\n"])), SelectItem, function (_a) {
    var selectLayout = _a.selectLayout;
    return selectLayout === 'highlight' && (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            > svg path {\n                fill: ", ";\n            }\n        "], ["\n            > svg path {\n                fill: ", ";\n            }\n        "])), Colors/* colors.primary.30 */.O9.primary[30]);
});
var SelectPlaceholder = styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 6px 8px;\n    color: ", ";\n"], ["\n    padding: 6px 8px;\n    color: ", ";\n"])), constants/* colors.textPlaceholder */.O9.textPlaceholder);
var SelectIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
var DropdownWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    z-index: 1099;\n    overflow: hidden;\n"], ["\n    width: 100%;\n    z-index: 1099;\n    overflow: hidden;\n"])));
var Dropdown = styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: white;\n    width: 100%;\n    box-shadow: 0px 2px 4px 0 ", ";\n    border: 1px solid #e0e0e9;\n    border-radius: 6px;\n    ", "\n    will-change: transform;\n"], ["\n    background-color: white;\n    width: 100%;\n    box-shadow: 0px 2px 4px 0 ", ";\n    border: 1px solid #e0e0e9;\n    border-radius: 6px;\n    ", "\n    will-change: transform;\n"])), constants/* colors.cardShadow */.O9.cardShadow, function (_a) {
    var isVisible = _a.isVisible;
    return styledCss/* default.dropdownAnimation */.ZP.dropdownAnimation(isVisible);
});
var DropdownHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px 16px 0 16px;\n"], ["\n    padding: 16px 16px 0 16px;\n"])));
var DropdownBody = styled_components_browser_esm/* default.div */.ZP.div(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0 16px;\n"], ["\n    padding: 0 16px;\n"])));
var DropdownFooter = styled_components_browser_esm/* default.div */.ZP.div(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    border-top: 1px solid #f4f4f7;\n    border-radius: 0 0 6px 6px;\n"], ["\n    padding: 16px;\n    border-top: 1px solid #f4f4f7;\n    border-radius: 0 0 6px 6px;\n"])));
var SearchRemoveIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-grid;\n    pointer-events: ", ";\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    z-index: 1;\n    opacity: 0;\n    transition: 0.25s;\n    cursor: pointer;\n"], ["\n    display: inline-grid;\n    pointer-events: ", ";\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    z-index: 1;\n    opacity: 0;\n    transition: 0.25s;\n    cursor: pointer;\n"])), function (_a) {
    var isDisplay = _a.isDisplay;
    return (isDisplay ? 'all' : 'none');
});
var SearchBox = styled_components_browser_esm/* default.div */.ZP.div(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 8px;\n    border-radius: 6px;\n    background-color: #f4f4f7;\n    display: flex;\n    align-items: center;\n    height: 40px;\n\n    &:hover ", " {\n        opacity: ", ";\n        &:hover {\n            opacity: 1;\n        }\n    }\n"], ["\n    position: relative;\n    padding: 8px;\n    border-radius: 6px;\n    background-color: #f4f4f7;\n    display: flex;\n    align-items: center;\n    height: 40px;\n\n    &:hover ", " {\n        opacity: ", ";\n        &:hover {\n            opacity: 1;\n        }\n    }\n"])), SearchRemoveIcon, function (_a) {
    var isDisplayRemoveIcon = _a.isDisplayRemoveIcon;
    return (isDisplayRemoveIcon ? 0.5 : 0);
});
var SearchInput = styled_components_browser_esm/* default.input */.ZP.input(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 16px;\n    margin-left: 8px;\n    padding-right: 24px;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    width: 100%;\n\n    &:focus ~ ", " {\n        opacity: ", ";\n    }\n"], ["\n    font-size: 14px;\n    line-height: 16px;\n    margin-left: 8px;\n    padding-right: 24px;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    width: 100%;\n\n    &:focus ~ ", " {\n        opacity: ", ";\n    }\n"])), SearchRemoveIcon, function (_a) {
    var isDisplayRemoveIcon = _a.isDisplayRemoveIcon;
    return (isDisplayRemoveIcon ? 0.5 : 0);
});
var NotificationBox = styled_components_browser_esm/* default.div */.ZP.div(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n"], ["\n    display: ", ";\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n"])), function (_a) {
    var isVisible = _a.isVisible;
    return (isVisible ? 'flex' : 'none');
});
var LimitText = styled_components_browser_esm/* default.div */.ZP.div(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    line-height: 18px;\n    color: ", ";\n    margin-right: 8px;\n"], ["\n    font-size: 12px;\n    line-height: 18px;\n    color: ", ";\n    margin-right: 8px;\n"])), constants/* colors.buttonColor */.O9.buttonColor);
var ClearAllText = styled_components_browser_esm/* default.div */.ZP.div(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    line-height: 18px;\n    color: ", ";\n    transition: 0.25s;\n    white-space: nowrap;\n    cursor: pointer;\n\n    &:hover {\n        color: ", ";\n    }\n"], ["\n    font-size: 12px;\n    line-height: 18px;\n    color: ", ";\n    transition: 0.25s;\n    white-space: nowrap;\n    cursor: pointer;\n\n    &:hover {\n        color: ", ";\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor);
var OptionsContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 8px 0 16px 0;\n    max-height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    ", "\n"], ["\n    margin: 8px 0 16px 0;\n    max-height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    ", "\n"])), styledCss/* default.scrollbar */.ZP.scrollbar);
var OptionItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var NoResultText = styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), constants/* colors.textGrayColor */.O9.textGrayColor);
var ApplyBox = styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n"])));
var DropdownDialog = styled_components_browser_esm/* default.div */.ZP.div(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1100;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1100;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n"])));
var DialogHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 50px;\n    padding: 16px;\n    background-color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n"], ["\n    height: 50px;\n    padding: 16px;\n    background-color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n"])));
var DialogBody = styled_components_browser_esm/* default.div */.ZP.div(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    background-color: rgb(250, 250, 250);\n    overflow: auto;\n    flex: 1;\n    box-shadow: 0 0 0 1px #0000000d;\n\n    ", "\n"], ["\n    padding: 16px;\n    background-color: rgb(250, 250, 250);\n    overflow: auto;\n    flex: 1;\n    box-shadow: 0 0 0 1px #0000000d;\n\n    ", "\n"])), styledCss/* default.scrollbar */.ZP.scrollbar);
var DialogFooter = styled_components_browser_esm/* default.div */.ZP.div(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    padding: 16px;\n    background-color: white;\n    box-shadow: 0 0 0 1px #0000000d;\n\n    > button {\n        flex: 1;\n    }\n"], ["\n    display: flex;\n    padding: 16px;\n    background-color: white;\n    box-shadow: 0 0 0 1px #0000000d;\n\n    > button {\n        flex: 1;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36;


//# sourceMappingURL=MultipleSelect.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowBackIcon/index.js
var ArrowBackIcon = __webpack_require__(40468);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CheckTagIcon/index.js
var CheckTagIcon = __webpack_require__(17362);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/translations.js
'use client';

/* eslint-disable prettier/prettier */
var translations = {
    Apply: 'Áp dụng',
    'Clear all': 'Xóa tất cả',
    Cancel: 'Hủy',
    Search: 'Tìm kiếm',
    'No result': 'Không có kết quả'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var SearchIcon = __webpack_require__(6538);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/services.js
var services = __webpack_require__(69023);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/context.js
var MultipleRadio_context = __webpack_require__(89826);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/index.js
'use client';























var MAX_DISPLAY = 1000;
var MultipleSelect = function (props, ref) {
    var name = props.name, options = props.options, defaultSelect = props.defaultSelect, onChange = props.onChange, onBlur = props.onBlur, _a = props.type, type = _a === void 0 ? 'singleApply' : _a, _b = props.optionsStyle, optionsStyle = _b === void 0 ? { maxHeight: '250px' } : _b, _c = props.dropdownStyle, dropdownStyle = _c === void 0 ? { width: '350px' } : _c, _d = props.dropdownPlacement, dropdownPlacement = _d === void 0 ? 'bottom-start' : _d, dropdownTopPosition = props.dropdownTopPosition, dropdownButton = props.dropdownButton, _e = props.selectType, selectType = _e === void 0 ? 'default' : _e, selectWidth = props.selectWidth, selectMaxWidth = props.selectMaxWidth, selectPlaceholder = props.selectPlaceholder, selectPlaceholderColor = props.selectPlaceholderColor, _f = props.limit, limit = _f === void 0 ? MAX_DISPLAY : _f, limitText = props.limitText, maxDisplay = props.maxDisplay, langCode = props.langCode, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.isMobile, isMobile = _h === void 0 ? false : _h, _j = props.hasError, hasError = _j === void 0 ? false : _j, _k = props.hasSearch, hasSearch = _k === void 0 ? true : _k, _l = props.sortEnable, sortEnable = _l === void 0 ? false : _l, _m = props.sortType, sortType = _m === void 0 ? 'asc' : _m, _o = props.sortKey, sortKey = _o === void 0 ? 'name' : _o, floatingConfig = props.floatingConfig, _p = props.msBaseUrl, msBaseUrl = _p === void 0 ? '' : _p, _q = props.isEnableSearchAPI, isEnableSearchAPI = _q === void 0 ? false : _q, selectLayout = props.selectLayout;
    // convert list value [10, 25] to list option [{id: 10, name: ''}, {id: 25, name: ''}]
    var convertValueToOption = function (newOptions) {
        if (Array.isArray(newOptions)) {
            return newOptions.reduce(function (result, item) {
                var newItem = options.find(function (optionItem) { return (0,helpers/* compareVariable */.sf)(item, optionItem.id); });
                if (newItem)
                    return (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], result, true), [newItem], false);
                else
                    return result;
            }, []);
        }
        return [];
    };
    var _r = (0,react.useState)(convertValueToOption(defaultSelect || [])), selectedOptions = _r[0], setSeletedOptions = _r[1]; // all selected option
    var _s = (0,react.useState)([]), selectedOptionsMemo = _s[0], setSeletedOptionsMemo = _s[1]; // groups when <Dropdown> isVisible, click cancel button will change selectedOptions equal selectedOptionsMemo
    var _t = (0,react.useState)(options), displayOptions = _t[0], setDisplayOptions = _t[1]; // options display
    var _u = (0,react.useState)(''), searchQuery = _u[0], setSearchQuery = _u[1]; // search option by label
    var _v = (0,react.useState)(MAX_DISPLAY), maxElementDisplay = _v[0], setMaxElementDisplay = _v[1]; // number of <Select Title> can display
    var _w = (0,react.useState)(false), dropdownDialog = _w[0], setDropdownDialog = _w[1]; // dropdown for responsive
    var _x = (0,react.useState)(false), isDropdownVisible = _x[0], setDropdownVisible = _x[1];
    var wrapperRef = (0,react.useRef)(null);
    var maxOptionDisplay = maxDisplay || maxElementDisplay;
    var _y = (0,react.useState)([]), searchResult = _y[0], setSearchResult = _y[1];
    var debounceKeyword = (0,hooks/* default */.ZP)([searchQuery], 300);
    var hasTransitionedIn = (0,hooks/* useMountTransition */.R5)(isDropdownVisible, 250); // handle animation when mount/unmount Dropdown
    var searchInputRef = (0,react.useRef)(null);
    var _z = (0,useFloating/* default */.Z)({
        placement: dropdownPlacement,
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: {
            offset: dropdownTopPosition,
            detectHidden: true,
            useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false
        }
    }), refs = _z.refs, context = _z.context, FloatingPortal = _z.FloatingPortal;
    var t = function (key) {
        if (langCode === constants/* ELanguage.VI */.Df.VI) {
            return translations[key] || key;
        }
        else {
            return key;
        }
    };
    var responseSelectedOptions = function (options) {
        var response = {
            value: []
        };
        response.value = options.map(function (item) { return item.id; });
        return response;
    };
    var changeSelectedOptions = function (newOptions) {
        if (!(0,helpers/* compareVariable */.sf)(selectedOptions, newOptions)) {
            setSeletedOptions(newOptions);
            setMaxElementDisplay(MAX_DISPLAY);
        }
        // if type is 'singleApply' and not on mobile screen, return response on selected option
        if (type === 'singleApply' && !isMobile)
            onChange(responseSelectedOptions(newOptions));
    };
    var handleRemoveOption = function (option) {
        var newOptions = selectedOptions.filter(function (item) { return item.id !== option.id; });
        changeSelectedOptions(newOptions);
        // if type is 'singleApply', changeSelectedOptions already run onChange callback
        if (type !== 'singleApply')
            onChange(responseSelectedOptions(newOptions));
    };
    var handleOnSelected = function (isChecked, option) {
        if (isChecked) {
            var newOptions = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], selectedOptions, true), [option], false);
            changeSelectedOptions(newOptions);
        }
        else {
            var newOptions = selectedOptions.filter(function (item) { return item.id !== option.id; });
            changeSelectedOptions(newOptions);
        }
    };
    var handleOnSearch = function (text) {
        var formatText = (0,helpers/* transformToLatin */.nr)(text).toLowerCase();
        var newOptions = options.filter(function (item) {
            var formatItemLabel = (0,helpers/* transformToLatin */.nr)(item.name).toLowerCase();
            return formatItemLabel.indexOf(formatText) > -1;
        });
        setDisplayOptions(newOptions);
        setSearchQuery(text);
    };
    var handleClickCancel = function () {
        changeSelectedOptions(selectedOptionsMemo);
        setDropdownVisible(false);
        setDropdownDialog(false);
    };
    var handleClickApply = function () {
        if (!(0,helpers/* compareVariable */.sf)(selectedOptions, selectedOptionsMemo)) {
            onChange(responseSelectedOptions(selectedOptions));
        }
        setDropdownVisible(false);
        setDropdownDialog(false);
    };
    var handleClickClearAll = function () {
        changeSelectedOptions([]);
    };
    var handleDropdown = function () {
        if (isMobile) {
            setDropdownDialog(true);
        }
        else {
            setDropdownVisible(function (state) { return !state; });
        }
    };
    var getSearchResult = function (keyword) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (keyword === '') {
                        setSearchResult([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,services/* searchCompanyIndustries */.I)(msBaseUrl, keyword)];
                case 1:
                    response = _b.sent();
                    setSearchResult((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                    return [2 /*return*/];
            }
        });
    }); };
    (0,useClickAway/* default */.Z)(function () {
        if (type === 'multipleApply' && isDropdownVisible) {
            changeSelectedOptions(selectedOptionsMemo);
        }
        setDropdownVisible(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // calculate width each element SelectItem, handle display
    (0,react.useEffect)(function () {
        if (refs.reference.current === null) {
            return;
        }
        // const listTitleElement = document.querySelectorAll<HTMLElement>(`[data-id="${`${name}-${nameId}`}"]`)
        var selectElement = refs.reference.current;
        var listTitleElement = (selectElement === null || selectElement === void 0 ? void 0 : selectElement.querySelectorAll("[data-id=\"".concat(name, "\"]"))) || [];
        var arrayTitleElement = Array.from(listTitleElement);
        // 90 is number of width ArrowDownIcon, padding, numberDisplay,...
        var totalWidthLeft = 0;
        if (selectWidth)
            totalWidthLeft = selectWidth - 90;
        if (selectMaxWidth)
            totalWidthLeft = selectMaxWidth - 90;
        if (!selectWidth && !selectMaxWidth && wrapperRef.current)
            totalWidthLeft = wrapperRef.current.offsetWidth - 90 || 0;
        arrayTitleElement.find(function (item, idx) {
            // if first element have width > totalWidthLeft, add ellipsis css\
            if (idx === 0 && totalWidthLeft < item.scrollWidth + 6) {
                // 4 (gap) + 2 (border)
                item.style.textOverflow = 'ellipsis';
                item.style.overflow = 'hidden';
                setMaxElementDisplay(1);
                return true;
            }
            else {
                item.style.textOverflow = 'clip';
                item.style.overflow = 'visible';
            }
            totalWidthLeft -= item.offsetWidth + 4; // 4 is gap width between item
            if (totalWidthLeft < 0) {
                setMaxElementDisplay(idx);
                return true;
            }
            return false;
        });
    }, [selectedOptions, refs.reference]);
    // save groups when <Dropdown> isDropdownVisible
    (0,react.useEffect)(function () {
        if (!isMobile && isDropdownVisible)
            setSeletedOptionsMemo(selectedOptions);
        if (isMobile && dropdownDialog)
            setSeletedOptionsMemo(selectedOptions);
        if (!isDropdownVisible) {
            return;
        }
        searchInputRef.current &&
            searchInputRef.current.focus({
                preventScroll: true
            });
    }, [isDropdownVisible, dropdownDialog, isMobile]);
    // when click outside Dropdown, trigger apply event
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (!isDropdownVisible) {
            handleOnSearch(''); // reset search query when dropdown off
        }
    }, [isDropdownVisible]);
    // init display options
    (0,react.useEffect)(function () {
        if (!(0,helpers/* compareVariable */.sf)(displayOptions, options))
            setDisplayOptions((0,_tslib/* __spreadArray */.ev)([], options, true));
    }, [options]);
    // change selected options from props
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (defaultSelect) {
            var newOptions = convertValueToOption(defaultSelect);
            if (!(0,helpers/* compareVariable */.sf)(selectedOptions, newOptions)) {
                setSeletedOptions(newOptions);
                setMaxElementDisplay(MAX_DISPLAY);
            }
        }
    }, [defaultSelect, options]);
    // block scroll body when dropdownDialog open
    (0,react.useEffect)(function () {
        if (dropdownDialog) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        if (!dropdownDialog) {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        }
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [dropdownDialog]);
    /**
     * Allow parent to change selected options. Combine useRef and useImperativeHandle
     *
     * @author Tri, Tran Minh
     * @since 18 Aug, 2022
     * @ref https://stackoverflow.com/questions/37949981/call-child-method-from-parent
     */
    (0,react.useImperativeHandle)(ref, function () { return ({
        onSeletedOptionChange: function (selectOptions) {
            changeSelectedOptions(convertValueToOption(selectOptions));
        },
        selectedOptions: selectedOptions
    }); });
    (0,react.useEffect)(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(searchQuery);
    }, [debounceKeyword]);
    var renderSelectItem = function () {
        return (react.createElement(react.Fragment, null,
            selectedOptions.slice(0, maxOptionDisplay).map(function (item) { return (
            // if on mobile screen, not display remove icon and hover animation
            react.createElement(SelectItem, { key: String(item.id), "data-id": name, hoverOn: !isMobile, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                item.name,
                !isMobile && (react.createElement(SelectItemIcon, { onClick: function (e) {
                        e.stopPropagation(); // not trigger <SelectItem> when click <SelectItemIcon>
                        handleRemoveOption(item);
                    }, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                    react.createElement(CheckTagIcon/* default */.Z, null))))); }),
            selectedOptions.length - maxOptionDisplay > 0 && maxOptionDisplay < MAX_DISPLAY && (react.createElement(SelectItem, { selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                "+",
                selectedOptions.length - maxOptionDisplay))));
    };
    var renderDropdownResponsive = function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            return react_dom.createPortal(react.createElement(DropdownDialog, null,
                react.createElement(DialogHeader, null,
                    react.createElement(ArrowBackIcon/* default */.Z, { onClick: handleClickCancel }),
                    selectedOptions.length > 0 && (react.createElement(ClearAllText, { onClick: handleClickClearAll }, t('Clear all')))),
                react.createElement(DialogBody, null,
                    hasSearch && (react.createElement(SearchBox, null,
                        react.createElement(SearchIcon/* default */.Z, null),
                        react.createElement(SearchInput, { ref: searchInputRef, placeholder: t('Search'), onChange: function (e) { return handleOnSearch(e.target.value); }, value: searchQuery, isDisplayRemoveIcon: searchQuery.length > 0 }),
                        react.createElement(SearchRemoveIcon, { onClick: function () { return handleOnSearch(''); }, isDisplay: searchQuery.length > 0 },
                            react.createElement(RemoveFillIcon/* default */.Z, null)))),
                    limitText && selectedOptions.length >= limit && (react.createElement(LimitText, { style: { marginTop: 5 } }, limitText)),
                    !sortEnable &&
                        displayOptions.map(function (item) {
                            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
                            return (react.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                                react.createElement(SingleCheckBox/* default */.Z, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
                        }),
                    sortEnable &&
                        (0,helpers/* sortArray */.qr)(displayOptions, sortType, sortKey).map(function (item) {
                            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
                            return (react.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                                react.createElement(SingleCheckBox/* default */.Z, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
                        }),
                    displayOptions.length === 0 && react.createElement(NoResultText, null, t('No result'))),
                react.createElement(DialogFooter, null,
                    react.createElement(Button/* default */.Z, { type: 'default', size: 'md', onClick: handleClickCancel, style: { marginRight: 8 } }, t('Cancel')),
                    react.createElement(Button/* default */.Z, { type: 'primary', size: 'md', onClick: handleClickApply }, (dropdownButton === null || dropdownButton === void 0 ? void 0 : dropdownButton.primaryText) || t('Search')))), bodyNode);
        }
        else
            return null;
    };
    var getDropdownWidth = (0,react.useCallback)(function () {
        var _a;
        if (context.position === 'fixed') {
            return (_a = refs.reference.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        }
        return dropdownStyle.width;
    }, [dropdownStyle.width, context.position, refs.reference]);
    var renderOptionItem = function () {
        var _a, _b;
        var responseOptions = displayOptions;
        if (isEnableSearchAPI && searchResult.length > 0) {
            var responseAPI = [];
            var _loop_1 = function (i) {
                var companyItem = searchResult[i];
                if (!companyItem) {
                    return "continue";
                }
                if (responseAPI.length >= MultipleRadio_context/* MAX_ADDITIONAL_ITEMS */.El) {
                    return "break";
                }
                var filteredMatch = responseOptions.filter(function (item) { return item.id === companyItem.id; });
                if (filteredMatch.length > 0) {
                    return "continue";
                }
                else {
                    responseAPI.push({
                        id: companyItem.id,
                        name: langCode === constants/* ELanguage.VI */.Df.VI
                            ? (_a = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _a === void 0 ? void 0 : _a.nameVi
                            : (_b = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _b === void 0 ? void 0 : _b.nameEn
                    });
                }
            };
            for (var i = 0; i < searchResult.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
            responseOptions = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], responseOptions, true), responseAPI, true);
        }
        if (sortEnable) {
            responseOptions = (0,helpers/* sortArray */.qr)(responseOptions, sortType, sortKey);
        }
        if (responseOptions.length === 0) {
            return react.createElement(NoResultText, null, t('No result'));
        }
        return responseOptions.map(function (item) {
            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
            return (react.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                react.createElement(SingleCheckBox/* default */.Z, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
        });
    };
    var hasValue = selectedOptions.length > 0;
    return (react.createElement(Container, { ref: wrapperRef, "data-id": "multiple-select-".concat(name), style: {
            position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal) ? 'static' : 'relative'
        } },
        react.createElement(SelectContainer, { ref: refs.setReference, active: isDropdownVisible, onClick: handleDropdown, width: selectWidth, maxWidth: selectMaxWidth, type: selectType, disabled: disabled, hasError: hasError, hasValue: hasValue, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
            react.createElement(SelectWrapper, null, hasValue ? (renderSelectItem()) : (react.createElement(SelectPlaceholder, { style: { color: selectPlaceholderColor } }, selectPlaceholder))),
            react.createElement(SelectIcon, null,
                react.createElement(ArrowDownIcon/* default */.Z, null))),
        (isDropdownVisible || hasTransitionedIn) && (react.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
            react.createElement(DropdownWrapper, { style: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, dropdownStyle), { position: context.position, left: context.x, top: context.y, width: getDropdownWidth(), display: context.isReferenceHidden ? 'none' : 'block' }), ref: refs.setPopup },
                react.createElement(Dropdown, { isVisible: isDropdownVisible, "data-floating-placement": context.placement },
                    react.createElement(DropdownHeader, null,
                        hasSearch && (react.createElement(SearchBox, { isDisplayRemoveIcon: searchQuery.length > 0 },
                            react.createElement(SearchIcon/* default */.Z, null),
                            react.createElement(SearchInput, { ref: searchInputRef, placeholder: t('Search'), onChange: function (e) { return handleOnSearch(e.target.value); }, value: searchQuery, isDisplayRemoveIcon: searchQuery.length > 0 }),
                            react.createElement(SearchRemoveIcon, { onClick: function () { return handleOnSearch(''); }, isDisplay: searchQuery.length > 0 },
                                react.createElement(RemoveFillIcon/* default */.Z, null)))),
                        react.createElement(NotificationBox, { isVisible: selectedOptions.length > 0 },
                            react.createElement(LimitText, null, selectedOptions.length >= limit && limitText),
                            searchQuery.length === 0 && (react.createElement(ClearAllText, { onClick: handleClickClearAll }, t('Clear all'))))),
                    react.createElement(DropdownBody, null,
                        react.createElement(OptionsContainer, { style: optionsStyle }, renderOptionItem())),
                    type === 'multipleApply' && (react.createElement(DropdownFooter, null,
                        react.createElement(ApplyBox, null,
                            react.createElement(Button/* default */.Z, { type: 'default', size: 'md', onClick: handleClickCancel, style: { marginRight: 8 } }, t('Cancel')),
                            react.createElement(Button/* default */.Z, { type: 'primary', size: 'md', onClick: handleClickApply }, (dropdownButton === null || dropdownButton === void 0 ? void 0 : dropdownButton.primaryText) || t('Search'))))))))),
        dropdownDialog && renderDropdownResponsive()));
};
var MultipleSelect$1 = (0,react.forwardRef)(MultipleSelect);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 12103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ NOTIFY_ACTION; },
/* harmony export */   "k": function() { return /* binding */ FILTER_TYPE; }
/* harmony export */ });
'use client';

var NOTIFY_ACTION;
(function (NOTIFY_ACTION) {
    NOTIFY_ACTION[NOTIFY_ACTION["SHOW"] = 0] = "SHOW";
    NOTIFY_ACTION[NOTIFY_ACTION["HIDE"] = 1] = "HIDE";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFY_COUNT"] = 2] = "SET_NOTIFY_COUNT";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_LOADING"] = 3] = "SET_LOADING";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFICATIONS"] = 4] = "SET_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_FILTER"] = 5] = "SET_FILTER";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFY_READ"] = 6] = "SET_NOTIFY_READ";
    NOTIFY_ACTION[NOTIFY_ACTION["PUSH_TO_NOTIFICATIONS"] = 7] = "PUSH_TO_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["MAP_JOB_INVITATION_NOTIFICATIONS"] = 8] = "MAP_JOB_INVITATION_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_READ_JOB_INVITATION"] = 9] = "SET_READ_JOB_INVITATION";
})(NOTIFY_ACTION || (NOTIFY_ACTION = {}));
var FILTER_TYPE;
(function (FILTER_TYPE) {
    FILTER_TYPE[FILTER_TYPE["ALL"] = 0] = "ALL";
    FILTER_TYPE[FILTER_TYPE["UNREAD"] = 1] = "UNREAD";
    FILTER_TYPE[FILTER_TYPE["READ"] = 2] = "READ";
})(FILTER_TYPE || (FILTER_TYPE = {}));


//# sourceMappingURL=action.js.map


/***/ }),

/***/ 36234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ NotificationProvider; },
  "PV": function() { return /* binding */ useNotifyStore; }
});

// UNUSED EXPORTS: initialStore

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/action.js
var context_action = __webpack_require__(12103);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/types.js
var types = __webpack_require__(15168);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/childReducers/mapJobInvitationNotifications.js
'use client';




var mapJobInvitationNotificationReducer = function (params) {
    var state = params.state, jobInvitations = params.jobInvitations;
    var jobInvitationNotifications = jobInvitations.map(function (item) {
        var _a, _b, _c, _d, _e;
        return ({
            notifyKey: "JI-".concat(item.id, "-").concat(item.jobId),
            companyLogo: (_a = item.companyLogo) !== null && _a !== void 0 ? _a : '',
            companyName: (_b = item.companyName) !== null && _b !== void 0 ? _b : '',
            employerId: -1,
            isAttached: -1,
            isRead: item.status,
            isShowLogo: 1,
            noOfEmployerViews: 0,
            resumeId: -1,
            sentDate: item.time,
            source: -1,
            statusId: "-1",
            type: types/* ENotificationTypes.JOB_INVITATION */.Fj.JOB_INVITATION,
            userId: -1,
            jobInvitationId: item.id,
            viewDate: item.time,
            jobTitle: (_c = item.jobTitle) !== null && _c !== void 0 ? _c : '',
            expiredDate: 0,
            aliasEn: '',
            aliasVi: '',
            alias: (_d = item.alias) !== null && _d !== void 0 ? _d : '',
            content: (_e = item.content) !== null && _e !== void 0 ? _e : ''
        });
    });
    return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { jobInvitationNotifications: jobInvitationNotifications });
};


//# sourceMappingURL=mapJobInvitationNotifications.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/reducer.js
'use client';





var notificationReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case context_action/* NOTIFY_ACTION.SHOW */.D.SHOW: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isOpen: true });
        }
        case context_action/* NOTIFY_ACTION.HIDE */.D.HIDE: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isOpen: false });
        }
        case context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT: {
            var countPayload = payload;
            var notifyCount = countPayload.type === 'notify'
                ? { notificationCount: countPayload.value }
                : { notificationBellCount: countPayload.value };
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), notifyCount);
        }
        case context_action/* NOTIFY_ACTION.SET_LOADING */.D.SET_LOADING: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { isLoading: payload });
        }
        case context_action/* NOTIFY_ACTION.SET_NOTIFICATIONS */.D.SET_NOTIFICATIONS: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { notifications: payload, isLoading: false });
        }
        case context_action/* NOTIFY_ACTION.SET_FILTER */.D.SET_FILTER: {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { filter: payload });
        }
        case context_action/* NOTIFY_ACTION.SET_NOTIFY_READ */.D.SET_NOTIFY_READ: {
            var notifyKey_1 = payload;
            // Deep-clone notifications list first
            var newNotifications = JSON.parse(JSON.stringify(state.notifications));
            var indexKey = newNotifications.findIndex(function (item) { return item.notifyKey === notifyKey_1; });
            if (indexKey < 0) {
                return (0,_tslib/* __assign */.pi)({}, state);
            }
            newNotifications[indexKey].isRead = 1;
            // Set back to state
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { notifications: newNotifications });
        }
        case context_action/* NOTIFY_ACTION.PUSH_TO_NOTIFICATIONS */.D.PUSH_TO_NOTIFICATIONS: {
            var newNotifications = JSON.parse(JSON.stringify(state.notifications));
            // Push to first index of notifications
            newNotifications.unshift(payload);
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { notifications: newNotifications });
        }
        case context_action/* NOTIFY_ACTION.MAP_JOB_INVITATION_NOTIFICATIONS */.D.MAP_JOB_INVITATION_NOTIFICATIONS: {
            var jobInvitations = payload;
            // Using child reducer
            return mapJobInvitationNotificationReducer({
                state: state,
                jobInvitations: jobInvitations
            });
        }
        case context_action/* NOTIFY_ACTION.SET_READ_JOB_INVITATION */.D.SET_READ_JOB_INVITATION: {
            var jobInvitationId_1 = payload;
            var newNotifications = JSON.parse(JSON.stringify(state.jobInvitationNotifications));
            newNotifications = newNotifications.map(function (notify) {
                if (notify.jobInvitationId && notify.jobInvitationId === jobInvitationId_1) {
                    notify.isRead = 1;
                }
                return notify;
            });
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { jobInvitationNotifications: newNotifications });
        }
        default:
            console.error('Unknown type of Reducer');
            return (0,_tslib/* __assign */.pi)({}, state);
    }
};


//# sourceMappingURL=reducer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/translations.js
'use client';

var translations = {
    'Notifications & News': 'Thông Báo & Tin Tức',
    'Get notifications for news or jobs': 'Nhận thông báo tin tức hoặc công việc',
    Notifications: 'Thông Báo',
    'Get notifications for jobs': 'Nhận thông báo công việc',
    All: 'Tất cả',
    Unread: 'Chưa đọc',
    Read: 'Đã đọc',
    'has invited you to apply': 'đã mời bạn ứng tuyển vị trí',
    'viewed your profile.': 'đã xem hồ sơ của bạn.',
    ago: 'trước',
    years: 'năm',
    months: 'tháng',
    weeks: 'tuần',
    days: 'ngày',
    hours: 'giờ',
    minutes: 'phút',
    year: 'năm',
    month: 'tháng',
    week: 'tuần',
    day: 'ngày',
    hour: 'giờ',
    minute: 'phút',
    'Just now': 'Vừa xong',
    Job: 'Việc làm',
    'saved jobs': 'đã lưu',
    'expires in': 'hết hạn trong',
    'Who viewed my profile': 'Nhà tuyển dụng xem hồ sơ',
    'Employer viewed your application': 'Nhà tuyển dụng đã xem đơn ứng tuyển',
    'viewed your application': 'đã xem đơn ứng tuyển',
    'viewed your application for position': 'đã xem đơn ứng tuyển vị trí',
    'Saved jobs': 'Việc làm đã lưu',
    'Viewed resume': 'Đã xem hồ sơ',
    'Apply status': 'Trạng thái ứng tuyển',
    'Job invitation': 'Mời ứng tuyển',
    'Which employers have viewed your profile in the last 7 days?': 'Nhà tuyển dụng nào đã quan tâm đến bạn trong 7 ngày vừa qua?',
    'And more information, hot jobs waiting for you.': 'Các thông tin, việc làm hấp dẫn đang chờ bạn.',
    'LOGIN NOW!': 'ĐĂNG NHẬP NGAY!',
    'Login now': 'Đăng nhập ngay',
    'Update profile': 'Cập nhật hồ sơ',
    "Your profile hasn't been viewed by any employer for the last 7 days": 'Hồ sơ của bạn rất ít tương tác trong 7 ngày qua',
    'Update your profile for more opportunities': 'Cập nhật hồ sơ để nâng cao cơ hội tìm việc',
    'There are no unread notifications.': 'Không có thông báo nào chưa đọc.',
    'There are no read notifications.': 'Không có thông báo nào đã đọc.',
    '/my-profile': '/ho-so',
    'Employer declined your application': 'Nhà tuyển dụng từ chối hồ sơ',
    'reviews you unsuitable for the position': 'đánh giá bạn không phù hợp cho vị trí',
    'selected you for position': 'đã chọn bạn cho vị trí',
    'Employer selected your application': 'Hồ sơ của bạn đã được chọn'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/firebase/app/dist/index.cjs.js
var index_cjs = __webpack_require__(81923);
var index_cjs_default = /*#__PURE__*/__webpack_require__.n(index_cjs);
// EXTERNAL MODULE: ./node_modules/@firebase/auth/dist/auth.js
var auth = __webpack_require__(48818);
;// CONCATENATED MODULE: ./node_modules/firebase/auth/dist/index.esm.js

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./node_modules/@firebase/database/dist/index.cjs.js
var dist_index_cjs = __webpack_require__(94707);
;// CONCATENATED MODULE: ./node_modules/firebase/database/dist/index.esm.js

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/helpers/FireBaseService.js
'use client';







var INVALID_CUSTOM_TOKEN = 'auth/invalid-custom-token';
var FIREBASE_JWT_COOKIE_NAME = 'FIREBASE_JWT';
var VNW_WS_COOKIE = 'VNWWS128450527232960';
var FIREBASE_APP_NAME_VNW_MESSAGE = 'FIREBASE_VNW_MESSAGE';
var FireBaseService = /** @class */ (function () {
    function FireBaseService(config) {
        var _this = this;
        this.TAG = '[FireBaseService]';
        this.refreshJWT = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
            var response, vnwWSCookie, responseData;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        vnwWSCookie = js_cookie_default().get(VNW_WS_COOKIE);
                        // Without VNW_WS_COOKIE then there is no need to call refresh JWT
                        if (!vnwWSCookie) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetch(this.refreshJWTUrl)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseData = _a.sent();
                        if (responseData.jwt) {
                            if (typeof window !== 'undefined') {
                                js_cookie_default().set('FIREBASE_JWT', responseData.jwt, { expires: 90 });
                            }
                            return [2 /*return*/, Promise.resolve(responseData.jwt)];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        _a.sent();
                        console.error('[Error Caught] refresh JWT', response);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, null];
                }
            });
        }); };
        try {
            var firebaseApp = index_cjs_default().app(FIREBASE_APP_NAME_VNW_MESSAGE);
            this.firebase = firebaseApp;
        }
        catch (e) {
            console.debug(this.TAG, "will create a new instance of ".concat(FIREBASE_APP_NAME_VNW_MESSAGE, " "));
            this.firebase = index_cjs_default().initializeApp(config, FIREBASE_APP_NAME_VNW_MESSAGE);
        }
        this.refreshJWTUrl = config.refreshJWTUrl;
        this.refreshJWTRetry = 0;
        this.firstAuth = false;
    }
    FireBaseService.prototype._handleAuthFail = function (error) {
        return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
            var errorCode, token;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorCode = error.code;
                        console.error('Retry when firebase authentication failed', error);
                        return [4 /*yield*/, this.getAuth().signOut()];
                    case 1:
                        _a.sent();
                        if (!(errorCode === INVALID_CUSTOM_TOKEN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.refreshJWT()];
                    case 2:
                        token = _a.sent();
                        if (token) {
                            this.refreshJWTRetry++;
                            return [2 /*return*/, this.authenticate(token)];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, undefined];
                }
            });
        });
    };
    FireBaseService.prototype.authenticate = function (token) {
        return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
            var err_1;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 5]);
                        return [4 /*yield*/, this.getAuth().signInWithCustomToken(token)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        if (!(this.refreshJWTRetry < 3)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._handleAuthFail(err_1)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        console.error('Firebase Authentication failed ' + this.refreshJWTRetry, err_1);
                        return [2 /*return*/, undefined];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FireBaseService.prototype.authenticatedConnect = function () {
        return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
            var jwtToken;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // for the first time authentication, always need to use JWT stored in cookie to verify the user
                        // otherwise firebase will recognise the previous logged in user base on session
                        if (!this.firstAuth) {
                            // check if firebase has already signed in
                            if (this.getAuth().currentUser) {
                                return [2 /*return*/, Promise.resolve(this.getAuth())];
                            }
                        }
                        jwtToken = js_cookie_default().get(FIREBASE_JWT_COOKIE_NAME);
                        if (!!jwtToken) return [3 /*break*/, 2];
                        this.getAuth().signOut();
                        return [4 /*yield*/, this.refreshJWT()];
                    case 1:
                        jwtToken = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!jwtToken) {
                            console.log('Cannot authenticate firebase at the moment');
                            return [2 /*return*/, Promise.resolve()];
                        }
                        this.firstAuth = true;
                        return [2 /*return*/, this.authenticate(jwtToken)];
                }
            });
        });
    };
    FireBaseService.prototype.getAuth = function () {
        return this.firebase.auth();
    };
    FireBaseService.prototype.getDatabase = function () {
        return this.firebase.database();
    };
    FireBaseService.prototype.getUserId = function () {
        return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
            var currentUser;
            var _this = this;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                currentUser = this.getAuth().currentUser;
                if (currentUser) {
                    return [2 /*return*/, Promise.resolve(currentUser.uid)];
                }
                else {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.getAuth().onAuthStateChanged(function (user) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
                                return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                                    if (user) {
                                        resolve(user.uid);
                                    }
                                    else {
                                        resolve(null);
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                        })];
                }
            });
        });
    };
    FireBaseService.prototype.signOut = function () {
        return this.getAuth().signOut();
    };
    return FireBaseService;
}());


//# sourceMappingURL=FireBaseService.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/hooks/useFirebase/index.js
'use client';






var PREFIX_NEARLY_EXPIRED_JOBS = 'E-';
var useFirebase = function (params) {
    var state = params.state, props = params.props, dispatch = params.dispatch;
    var notificationCount = state.notificationCount, notificationBellCount = state.notificationBellCount;
    var firebaseConnected = (0,react.useRef)(false);
    var isValueChanged = (0,react.useRef)(false);
    var firebaseService = (0,react.useMemo)(function () {
        var _a;
        return new FireBaseService((_a = props.config) === null || _a === void 0 ? void 0 : _a.firebaseConfig);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var isAuthenticated = function () {
        var currentUser = firebaseService.getAuth().currentUser;
        return Boolean(currentUser);
    };
    /**
     * Get notifications count of user
     * @returns Promise<firebase.database.Reference>
     */
    var getUserNotificationCountRef = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebaseService.getUserId()];
                case 1:
                    userId = _a.sent();
                    if (!userId) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, firebaseService.getDatabase().ref("my-notification-users/".concat(userId, "/noOfNotifications"))];
            }
        });
    }); };
    var getUserBellNotificationCountRef = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebaseService.getUserId()];
                case 1:
                    userId = _a.sent();
                    if (!userId) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, firebaseService.getDatabase().ref("my-notification-users/".concat(userId, "/noOfBellNotifications"))];
            }
        });
    }); };
    var getUserNotificationsRef = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebaseService.getUserId()];
                case 1:
                    userId = _a.sent();
                    if (!userId) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, firebaseService
                            .getDatabase()
                            .ref("my-notification-users/".concat(userId, "/notifications"))
                            .orderByChild('sentDate')
                            .limitToLast(20)];
            }
        });
    }); };
    var getOneUserNotificationRef = function (index) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebaseService.getUserId()];
                case 1:
                    userId = _a.sent();
                    return [2 /*return*/, firebaseService.getDatabase().ref("my-notification-users/".concat(userId, "/notifications/").concat(index))];
            }
        });
    }); };
    // End Ref
    /// ///////////////////////////////////////////////////////////
    var _resetNumOfNotifications = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserNotificationCountRef()];
                case 1:
                    userRef = _a.sent();
                    if (!userRef) {
                        return [2 /*return*/, 0];
                    }
                    return [2 /*return*/, userRef.transaction(function (noOfNotifications) {
                            if (noOfNotifications) {
                                noOfNotifications = 0;
                            }
                            return noOfNotifications;
                        })];
            }
        });
    }); };
    // End Reset
    /// ///////////////////////////////////////////////////////////
    var _removeExpiredJob = function (jobId) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId, jobNotificationRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (jobId <= 0 || !isAuthenticated()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, firebaseService.getUserId()];
                case 1:
                    userId = _a.sent();
                    jobNotificationRef = firebaseService
                        .getDatabase()
                        .ref("my-notification-users/".concat(userId, "/notifications/").concat(PREFIX_NEARLY_EXPIRED_JOBS).concat(jobId));
                    jobNotificationRef.remove();
                    return [2 /*return*/];
            }
        });
    }); };
    var _onValueChange = function (snapshot) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var snapshotValue, keys, values, newNotifications;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            snapshotValue = snapshot.val();
            if (snapshotValue === null) {
                dispatch({
                    type: context_action/* NOTIFY_ACTION.SET_NOTIFICATIONS */.D.SET_NOTIFICATIONS,
                    payload: []
                });
                return [2 /*return*/];
            }
            keys = Object.keys(snapshotValue);
            values = Object.values(snapshotValue);
            newNotifications = values.map(function (item, index) {
                var jobId = item.jobId, expiredDate = item.expiredDate;
                expiredDate = expiredDate * 1000 || Date.now();
                var remainDays = (expiredDate - Date.now()) / 86400000;
                if (remainDays <= 0) {
                    _removeExpiredJob(jobId);
                }
                var notifyItem = (0,_tslib/* __assign */.pi)({ notifyKey: keys[index] }, item);
                if (item.statusId) {
                    notifyItem.statusId = Number(item.statusId);
                }
                return notifyItem;
            });
            dispatch({
                type: context_action/* NOTIFY_ACTION.SET_NOTIFICATIONS */.D.SET_NOTIFICATIONS,
                payload: newNotifications.sort(function (a, b) { return b.sentDate - a.sentDate; })
            });
            isValueChanged.current = true;
            return [2 /*return*/];
        });
    }); };
    var _getNotifications = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAuthenticated()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getUserNotificationsRef()];
                case 1:
                    userRef = _a.sent();
                    if (!userRef) {
                        return [2 /*return*/];
                    }
                    userRef.off('child_added');
                    userRef.on('child_added', function (snapshot) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
                        var snapshotKey, snapshotValue;
                        var _a;
                        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                            // This function should run when received new notification only
                            // isValueChanged Ref was used to prevent duplicate notification at initial time
                            if (!isValueChanged.current) {
                                return [2 /*return*/];
                            }
                            snapshotKey = (_a = snapshot.key) !== null && _a !== void 0 ? _a : '';
                            snapshotValue = snapshot.val();
                            // Do not push any null to array of notifications
                            if (snapshotKey === null || snapshotKey === '' || snapshotValue === null) {
                                return [2 /*return*/];
                            }
                            // Push to array notification
                            dispatch({
                                type: context_action/* NOTIFY_ACTION.PUSH_TO_NOTIFICATIONS */.D.PUSH_TO_NOTIFICATIONS,
                                payload: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, snapshotValue), { notifyKey: snapshotKey })
                            });
                            return [2 /*return*/];
                        });
                    }); });
                    userRef.once('value', _onValueChange);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Get Notification, trigger when user want to view list of notifications
     */
    var getNotification = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            dispatch({
                type: context_action/* NOTIFY_ACTION.SET_LOADING */.D.SET_LOADING,
                payload: true
            });
            firebaseService.getAuth().onAuthStateChanged(function (user) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
                return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                    if (!user) {
                        return [2 /*return*/];
                    }
                    // Reset number of notifications to zero to display there're nothing new notificaions
                    _resetNumOfNotifications().then(function (result) {
                        return dispatch({
                            type: context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT,
                            payload: {
                                type: 'notifyBell',
                                value: result.snapshot.val()
                            }
                        });
                    });
                    // [Firebase] Read a list of Expiring Jobs and Who Viewed My Profile notifications at
                    // my-notification-users/<JobseekerId>/notifications
                    _getNotifications();
                    return [2 /*return*/];
                });
            }); });
            return [2 /*return*/];
        });
    }); };
    /// ///////////////////////////////////////////////////////////
    var setReadNotificationItem = function (notifyKey) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAuthenticated()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getOneUserNotificationRef(notifyKey)];
                case 1:
                    userRef = _a.sent();
                    return [4 /*yield*/, userRef.update({ isRead: 1 })
                        // Update notifications list state
                    ];
                case 2:
                    _a.sent();
                    // Update notifications list state
                    dispatch({
                        type: context_action/* NOTIFY_ACTION.SET_NOTIFY_READ */.D.SET_NOTIFY_READ,
                        payload: notifyKey
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Check if user is logged out then reset notification count
     *
     */
    var resetNotifyWhenLoggedOut = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if ((_a = props.user) === null || _a === void 0 ? void 0 : _a.userId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, firebaseService.signOut()];
                case 1:
                    _b.sent();
                    if (notificationCount > 0) {
                        // Reset Notification count
                        dispatch({
                            type: context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT,
                            payload: {
                                type: 'notify',
                                value: 0
                            }
                        });
                    }
                    if (notificationBellCount > 0) {
                        dispatch({
                            type: context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT,
                            payload: {
                                type: 'notifyBell',
                                value: 0
                            }
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var authenticateOnce = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (firebaseConnected.current) {
                        return [2 /*return*/];
                    }
                    // We don't listing productNews so
                    // do not call authenticate firebase when user is not logged in
                    if (!((_a = props.user) === null || _a === void 0 ? void 0 : _a.userId)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, firebaseService.authenticatedConnect()];
                case 1:
                    _b.sent();
                    firebaseConnected.current = true;
                    return [2 /*return*/];
            }
        });
    }); };
    var authConnect = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebaseService.authenticatedConnect()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onNotificationCountChanged = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserNotificationCountRef()];
                case 1:
                    userRef = _a.sent();
                    if (!userRef) {
                        return [2 /*return*/];
                    }
                    userRef.on('value', function (snapshot) {
                        return dispatch({
                            type: context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT,
                            payload: {
                                type: 'notify',
                                value: snapshot.val()
                            }
                        });
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var onBellNotificationCountChanged = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userRef;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserBellNotificationCountRef()];
                case 1:
                    userRef = _a.sent();
                    if (!userRef) {
                        return [2 /*return*/];
                    }
                    userRef.on('value', function (snapshot) {
                        return dispatch({
                            type: context_action/* NOTIFY_ACTION.SET_NOTIFY_COUNT */.D.SET_NOTIFY_COUNT,
                            payload: {
                                type: 'notifyBell',
                                value: snapshot.val()
                            }
                        });
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var doFetchNotification = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resetNotifyWhenLoggedOut();
                    // Make a global connection promise to reduce mutiple connections at same time
                    return [4 /*yield*/, authenticateOnce()
                        // Watch and update number of notifications state from the user
                    ];
                case 1:
                    // Make a global connection promise to reduce mutiple connections at same time
                    _a.sent();
                    // Watch and update number of notifications state from the user
                    onNotificationCountChanged();
                    onBellNotificationCountChanged();
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        doFetchNotification();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * Additional missing
     * - Add a watch for user change and call 'authenticateOnce' again
     */
    return {
        getNotification: getNotification,
        setReadNotificationItem: setReadNotificationItem,
        doAuthenticate: authConnect
    };
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/index.js
'use client';









var initialStore = {
    isOpen: false,
    isLoading: true,
    notifications: [],
    jobInvitationNotifications: [],
    notificationCount: 0,
    notificationBellCount: 0,
    filter: context_action/* FILTER_TYPE.ALL */.k.ALL
};
var Context = (0,react.createContext)({
    state: initialStore,
    props: {
        langCode: constants/* ELanguage.VI */.Df.VI,
        config: null,
        user: null
    },
    firebase: {
        getNotification: function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () { return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        setReadNotificationItem: function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () { return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            return [2 /*return*/];
        }); }); }
    },
    t: function (_) { return ''; },
    dispatch: function () { }
});
var useNotifyStore = function () { return (0,react.useContext)(Context); };
var NotificationProvider = function (props) {
    var _a = (0,react.useReducer)(notificationReducer, initialStore), state = _a[0], dispatch = _a[1];
    var _b = useFirebase({
        state: state,
        dispatch: dispatch,
        props: props
    }), getNotification = _b.getNotification, setReadNotificationItem = _b.setReadNotificationItem, doAuthenticate = _b.doAuthenticate;
    var t = function (text) {
        var _a;
        if (props.langCode === constants/* ELanguage.VI */.Df.VI) {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    };
    (0,react.useEffect)(function () {
        var _a;
        if (!props.user || (props.user && ((_a = props.user) === null || _a === void 0 ? void 0 : _a.accessToken) === '')) {
            return;
        }
        // Re-authenticate again after user logged-in
        doAuthenticate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user]);
    var firebase = {
        getNotification: getNotification,
        setReadNotificationItem: setReadNotificationItem
    };
    return react.createElement(Context.Provider, { value: { state: state, props: props, firebase: firebase, t: t, dispatch: dispatch } }, props.children);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ updateReadJobInvitationNotification; },
/* harmony export */   "q": function() { return /* binding */ getJobInvitationNotifications; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



var SUCCESS_CODE = 200;
var API_GET_JOB_INVITATION_NOTIFICATION = 'api-gateway/v1.0/profile/job-invitation/notification';
var getJobInvitationNotifications = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var msBaseUrl, langCode, _a, accessToken, url, response, responseData, ex_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, langCode = params.langCode, _a = params.accessToken, accessToken = _a === void 0 ? '' : _a;
                if (accessToken === '') {
                    return [2 /*return*/, null];
                }
                url = "".concat(msBaseUrl, "/").concat(API_GET_JOB_INVITATION_NOTIFICATION, "?limit=10");
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: {
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _b.sent();
                if (!response) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _b.sent();
                if (responseData.status === SUCCESS_CODE) {
                    return [2 /*return*/, responseData.data];
                }
                return [2 /*return*/, null];
            case 3:
                ex_1 = _b.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateReadJobInvitationNotification = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var msBaseUrl, langCode, _a, accessToken, jobInvitationId, response, ex_2;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, langCode = params.langCode, _a = params.accessToken, accessToken = _a === void 0 ? '' : _a, jobInvitationId = params.jobInvitationId;
                if (accessToken === '') {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, fetch("".concat(msBaseUrl, "/").concat(API_GET_JOB_INVITATION_NOTIFICATION), {
                        method: 'PUT',
                        headers: {
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            jobInvitationId: jobInvitationId
                        })
                    })];
            case 1:
                response = _b.sent();
                if (!response) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_2 = _b.sent();
                console.error(ex_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=jobInvitation.js.map


/***/ }),

/***/ 15168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DB": function() { return /* binding */ EApplicationStatusTypes; },
/* harmony export */   "Fj": function() { return /* binding */ ENotificationTypes; },
/* harmony export */   "JG": function() { return /* binding */ ALLOW_NOTIFY_TYPE; }
/* harmony export */ });
'use client';

var ENotificationTypes;
(function (ENotificationTypes) {
    ENotificationTypes[ENotificationTypes["EXPIRE_JOB"] = 1] = "EXPIRE_JOB";
    ENotificationTypes[ENotificationTypes["EMPLOYER_VIEW_PROFILE"] = 3] = "EMPLOYER_VIEW_PROFILE";
    ENotificationTypes[ENotificationTypes["OLD_EMPLOYER_VIEW_PROFILE"] = 4] = "OLD_EMPLOYER_VIEW_PROFILE";
    ENotificationTypes[ENotificationTypes["UNKNOWN_NOTIFY"] = 6] = "UNKNOWN_NOTIFY";
    ENotificationTypes[ENotificationTypes["EMPLOYER_VIEW_APPLICATION"] = 8] = "EMPLOYER_VIEW_APPLICATION";
    ENotificationTypes[ENotificationTypes["EMPLOYER_CHANGE_APPLICATION_STATUS"] = 11] = "EMPLOYER_CHANGE_APPLICATION_STATUS";
    ENotificationTypes[ENotificationTypes["JOB_INVITATION"] = 20] = "JOB_INVITATION";
})(ENotificationTypes || (ENotificationTypes = {}));
var ALLOW_NOTIFY_TYPE = [1, 3, 8, 11, 20];
var EApplicationStatusTypes;
(function (EApplicationStatusTypes) {
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_VIEWED_YOUR_APPLICATION"] = 3] = "EMPLOYER_VIEWED_YOUR_APPLICATION";
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_DECLINED_YOUR_APPLICATION"] = 4] = "EMPLOYER_DECLINED_YOUR_APPLICATION";
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_SELECTED_YOUR_APPLICATION"] = 6] = "EMPLOYER_SELECTED_YOUR_APPLICATION";
})(EApplicationStatusTypes || (EApplicationStatusTypes = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 19891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ah": function() { return /* binding */ nationalityList; },
/* harmony export */   "DE": function() { return /* binding */ DEFAULT_MIN_SALARY; },
/* harmony export */   "F6": function() { return /* binding */ INTERNATIONAL_CITY_ID; },
/* harmony export */   "G2": function() { return /* binding */ initFormData; },
/* harmony export */   "GM": function() { return /* binding */ CLICK_DELAY_TIME; },
/* harmony export */   "I6": function() { return /* binding */ notAllowCityId; },
/* harmony export */   "JC": function() { return /* binding */ SEARCH_DELAY_TIME; },
/* harmony export */   "JT": function() { return /* binding */ VNW_NEW_REGISTERED; },
/* harmony export */   "Jb": function() { return /* binding */ VIETNAM_COUNTRY_ID; },
/* harmony export */   "P2": function() { return /* binding */ EGender; },
/* harmony export */   "QV": function() { return /* binding */ INTERNATION_PHONE_NUMBER_END_POINT; },
/* harmony export */   "X4": function() { return /* binding */ DEFAULT_MAX_SALARY; },
/* harmony export */   "dv": function() { return /* binding */ INTERNSHIP_ID; },
/* harmony export */   "f1": function() { return /* binding */ MAX_DATE; },
/* harmony export */   "oj": function() { return /* binding */ EMaritalStatus; },
/* harmony export */   "vI": function() { return /* binding */ educations; },
/* harmony export */   "yE": function() { return /* binding */ FRESHER_ID; }
/* harmony export */ });
/* unused harmony exports MEKONG_CITY_ID, OTHER_CITY_ID */
'use client';

var INTERNATION_PHONE_NUMBER_END_POINT = 'meta/v1.0/international-phone-number';
var VNW_NEW_REGISTERED = 'VNW_NEW_REGISTERED';
var initFormData = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    jobLevelId: 0,
    highestDegreeId: 0,
    yearsExperience: 0,
    currentIndustries: [],
    currentJobFunction: 0,
    currentSalary: 0,
    email: '',
    phone: '',
    birthday: '',
    skills: [],
    genderId: 0,
    countryId: 0,
    cityId: 0,
    address: '',
    nationalityId: 0,
    maritalStatusId: 0,
    districtId: 0,
    isSearchable: 0,
    locations: [],
    industries: [],
    companyIndustries: [],
    isRelocate: 0,
    desiredJobLevelId: 0,
    salary: 0,
    benefits: []
};
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var notAllowCityId = [INTERNATIONAL_CITY_ID, MEKONG_CITY_ID, OTHER_CITY_ID];
var SEARCH_DELAY_TIME = 1000;
var CLICK_DELAY_TIME = 500;
var DEFAULT_MIN_SALARY = 0;
var DEFAULT_MAX_SALARY = 500000;
var TODAY = new Date();
var MAX_DATE = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate(), 23, 59, 59); // yyyy/mm/dd-23:59:59
var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["NEW"] = 0] = "NEW";
    EMaritalStatus[EMaritalStatus["SINGLE"] = 1] = "SINGLE";
    EMaritalStatus[EMaritalStatus["MARRIED"] = 2] = "MARRIED";
})(EMaritalStatus || (EMaritalStatus = {}));
var EGender;
(function (EGender) {
    EGender[EGender["MALE"] = 1] = "MALE";
    EGender[EGender["FEMALE"] = 2] = "FEMALE";
})(EGender || (EGender = {}));
var nationalityList = function (langCode) {
    var nationalityList = {
        en: [
            { id: 1, name: 'Local Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    };
    return nationalityList["".concat(langCode)];
};
var educations = [
    { id: 2, name: 'Trung học', nameEn: 'High school' },
    { id: 3, name: 'Trung cấp', nameEn: "Associate's degree" },
    { id: 12, name: 'Cao đẳng', nameEn: 'College' },
    { id: 4, name: 'Cử nhân', nameEn: 'Bachelors' },
    { id: 5, name: 'Thạc sĩ', nameEn: 'Doctorate' },
    { id: 6, name: 'Tiến sĩ', nameEn: 'Others' },
    { id: 11, name: 'Khác', nameEn: 'Others' }
];


//# sourceMappingURL=const.js.map


/***/ }),

/***/ 46021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ Footer; },
/* harmony export */   "Jk": function() { return /* binding */ PopupContentWrapper; },
/* harmony export */   "Ow": function() { return /* binding */ BackdropWrapper; },
/* harmony export */   "QF": function() { return /* binding */ CustomBody; },
/* harmony export */   "SM": function() { return /* binding */ PopupWrapper; },
/* harmony export */   "Wf": function() { return /* binding */ TopWrapper; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "pP": function() { return /* binding */ PopupContent; },
/* harmony export */   "sL": function() { return /* binding */ MoreFooterButton; },
/* harmony export */   "sg": function() { return /* binding */ Column; },
/* harmony export */   "uT": function() { return /* binding */ Body; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
'use client';




var openPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var closePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var openResponsivePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        top: calc(100% + 15px);\n    }\n    100% {\n        top: 15px;\n    }\n"], ["\n    0% {\n        top: calc(100% + 15px);\n    }\n    100% {\n        top: 15px;\n    }\n"])));
var closeResponsivePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        top: 15px;\n    }\n    100% {\n        top: calc(100% + 15px);\n    }\n"], ["\n    0% {\n        top: 15px;\n    }\n    100% {\n        top: calc(100% + 15px);\n    }\n"])));
var animFooterOpenPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n"], ["\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n"])));
var animFooterClosePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n"], ["\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n"])));
var PopupWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1099;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        animation: ", " 0.4s ease forwards;\n    }\n    ", "\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1099;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        animation: ", " 0.4s ease forwards;\n    }\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openPopup : closePopup);
}, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openResponsivePopup : closeResponsivePopup);
}, function (_a) {
    var isDisplayNone = _a.isDisplayNone;
    if (!isDisplayNone) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            display: none;\n        "], ["\n            display: none;\n        "])));
});
var BackdropWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1001;\n    ", "\n    display: ", ";\n"], ["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1001;\n    ", "\n    display: ", ";\n"])), function (_a) {
    var clickableBackdrop = _a.clickableBackdrop;
    return (clickableBackdrop ? 'cursor: pointer;' : '');
}, function (_a) {
    var isShowBackdrop = _a.isShowBackdrop;
    return (isShowBackdrop ? 'block' : 'none');
});
var PopupContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n"], ["\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n"])));
var PopupContent = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_19 || (templateObject_19 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    height: auto;\n    background: #fff;\n    z-index: 1002;\n    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    overflow: visible;\n    border-radius: 12px;\n    max-height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    ", "\n    ", "\n    ", "\n"], ["\n    height: auto;\n    background: #fff;\n    z-index: 1002;\n    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    overflow: visible;\n    border-radius: 12px;\n    max-height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openPopup : closePopup);
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case 'xxs':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 375px;\n                "], ["\n                    width: 375px;\n                "])));
        case 'xs':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 450px;\n                "], ["\n                    width: 450px;\n                "])));
        case 'sm':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 500px;\n                "], ["\n                    width: 500px;\n                "])));
        case 'lg':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_14 || (templateObject_14 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 960px;\n                "], ["\n                    width: 960px;\n                "])));
        case 'md':
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_15 || (templateObject_15 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 700px;\n                "], ["\n                    width: 700px;\n                "])));
    }
}, function (_a) {
    var isFullScreenOnMobile = _a.isFullScreenOnMobile, isPopupCenter = _a.isPopupCenter;
    if (!isFullScreenOnMobile || isPopupCenter) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_16 || (templateObject_16 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                margin: 16px;\n            "], ["\n                margin: 16px;\n            "])));
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_17 || (templateObject_17 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                height: calc(100% - 32px);\n                display: flex;\n                flex-direction: column;\n                top: calc(50% + 15px);\n                animation: ", " 0.4s ease forwards;\n            }\n        "], ["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                height: calc(100% - 32px);\n                display: flex;\n                flex-direction: column;\n                top: calc(50% + 15px);\n                animation: ", " 0.4s ease forwards;\n            }\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? openResponsivePopup : closeResponsivePopup);
    });
}, function (_a) {
    var isHaveBorder = _a.isHaveBorder;
    if (!isHaveBorder) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_18 || (templateObject_18 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            border: 1px solid #ddd;\n        "], ["\n            border: 1px solid #ddd;\n        "])));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_21 || (templateObject_21 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    border-bottom: 1px solid #efefef;\n    padding: 10px 14px 10px 24px;\n    display: flex;\n    justify-content: ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 10px 10px 0 0;\n    @media screen and (max-width: 768px) {\n        justify-content: center;\n        height: 61px;\n        .close-btn {\n            position: absolute;\n            left: 8px;\n        }\n    }\n    ", "\n"], ["\n    border-bottom: 1px solid #efefef;\n    padding: 10px 14px 10px 24px;\n    display: flex;\n    justify-content: ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 10px 10px 0 0;\n    @media screen and (max-width: 768px) {\n        justify-content: center;\n        height: 61px;\n        .close-btn {\n            position: absolute;\n            left: 8px;\n        }\n    }\n    ", "\n"])), function (_a) {
    var isCenterTitle = _a.isCenterTitle;
    return (isCenterTitle ? 'center' : 'space-between');
}, function (_a) {
    var bgColor = _a.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : '#fff';
}, function (_a) {
    var bgColor = _a.bgColor;
    if (bgColor === '#fff') {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_20 || (templateObject_20 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            .close-btn:hover {\n                svg {\n                    path {\n                        fill: ", ";\n                    }\n                }\n                background-color: rgba(174, 174, 174, 0.5); //colors.grey[70]\n            }\n        "], ["\n            .close-btn:hover {\n                svg {\n                    path {\n                        fill: ", ";\n                    }\n                }\n                background-color: rgba(174, 174, 174, 0.5); //colors.grey[70]\n            }\n        "])), function (_a) {
        var bgColor = _a.bgColor;
        return bgColor !== null && bgColor !== void 0 ? bgColor : '#888';
    });
});
var Body = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_22 || (templateObject_22 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    overflow-y: ", ";\n    padding: 16px;\n    height: auto;\n\n    //32px is padding top bottom\n    max-height: ", ";\n    z-index: 0; // prevent children elements from overflow footer if their z-index is set higher than 1\n    @media screen and (max-width: 768px) {\n        // position of footer is fixed by default on mobile, so we using a number = 90px replace for footer height\n        max-height: ", ";\n    }\n"], ["\n    overflow-y: ", ";\n    padding: 16px;\n    height: auto;\n\n    //32px is padding top bottom\n    max-height: ", ";\n    z-index: 0; // prevent children elements from overflow footer if their z-index is set higher than 1\n    @media screen and (max-width: 768px) {\n        // position of footer is fixed by default on mobile, so we using a number = 90px replace for footer height\n        max-height: ", ";\n    }\n"])), function (_a) {
    var overflow = _a.overflow;
    return overflow || 'auto';
}, function (_a) {
    var headerHeight = _a.headerHeight, footerHeight = _a.footerHeight;
    return "calc(100vh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - ").concat(footerHeight !== null && footerHeight !== void 0 ? footerHeight : 0, "px - 32px)");
}, function (_a) {
    var headerHeight = _a.headerHeight, additionalFooterHeight = _a.additionalFooterHeight;
    return "calc(100vh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - 72px - 32px - ").concat(additionalFooterHeight !== null && additionalFooterHeight !== void 0 ? additionalFooterHeight : 0, "px)");
});
var Column = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_23 || (templateObject_23 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: inline-flex;\n    width: 50%;\n    align-items: center;\n    &:first-child {\n        justify-content: left;\n    }\n    &:last-child {\n        justify-content: right;\n    }\n    &:only-child {\n        width: 100%;\n    }\n    > button {\n        margin: 0 4px;\n        &:first-child {\n            margin-right: 4px;\n            margin-left: 0;\n        }\n        &:last-child {\n            margin-left: 4px;\n            margin-right: 0;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        &:first-child {\n            justify-content: center;\n        }\n        &:last-child {\n            justify-content: center;\n        }\n    }\n"], ["\n    display: inline-flex;\n    width: 50%;\n    align-items: center;\n    &:first-child {\n        justify-content: left;\n    }\n    &:last-child {\n        justify-content: right;\n    }\n    &:only-child {\n        width: 100%;\n    }\n    > button {\n        margin: 0 4px;\n        &:first-child {\n            margin-right: 4px;\n            margin-left: 0;\n        }\n        &:last-child {\n            margin-left: 4px;\n            margin-right: 0;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        &:first-child {\n            justify-content: center;\n        }\n        &:last-child {\n            justify-content: center;\n        }\n    }\n"])));
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_27 || (templateObject_27 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    padding: 24px;\n    display: flex;\n    background-color: #fff;\n    border-top: 1px solid #efefef;\n    border-radius: 0px 0 12px 12px;\n    > button {\n        &:nth-child(2) {\n            margin-left: 8px;\n        }\n    }\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    padding: 24px;\n    display: flex;\n    background-color: #fff;\n    border-top: 1px solid #efefef;\n    border-radius: 0px 0 12px 12px;\n    > button {\n        &:nth-child(2) {\n            margin-left: 8px;\n        }\n    }\n    ", "\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var isFullScreenOnMobile = _a.isFullScreenOnMobile;
    if (!isFullScreenOnMobile) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_24 || (templateObject_24 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                height: ", "px;\n                display: flex;\n                flex-direction: column;\n                animation: ", " 0.25s ease-in-out\n                    forwards;\n                ", " {\n                    flex: 1;\n                    width: 100%;\n                    &:last-child {\n                        margin-top: 16px;\n                    }\n                    &:only-child {\n                        margin-top: 0;\n                    }\n                }\n                button {\n                    flex: 1;\n                }\n            }\n        "], ["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                height: ", "px;\n                display: flex;\n                flex-direction: column;\n                animation: ", " 0.25s ease-in-out\n                    forwards;\n                ", " {\n                    flex: 1;\n                    width: 100%;\n                    &:last-child {\n                        margin-top: 16px;\n                    }\n                    &:only-child {\n                        margin-top: 0;\n                    }\n                }\n                button {\n                    flex: 1;\n                }\n            }\n        "])), function (_a) {
        var isHaveLeftFooter = _a.isHaveLeftFooter;
        return (isHaveLeftFooter ? 123 : 90);
    }, function (_a) {
        var isShow = _a.isShow;
        return (isShow ? animFooterOpenPopup : animFooterClosePopup);
    }, Column);
}, function (_a) {
    var isCenter = _a.isCenter;
    if (!isCenter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_25 || (templateObject_25 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            text-align: center;\n        "], ["\n            text-align: center;\n        "])));
}, function (_a) {
    var isFooterButtonFullWidth = _a.isFooterButtonFullWidth;
    if (!isFooterButtonFullWidth) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_26 || (templateObject_26 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            ", " {\n                justify-content: center;\n                > button {\n                    width: 50%;\n                    &:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n        "], ["\n            ", " {\n                justify-content: center;\n                > button {\n                    width: 50%;\n                    &:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n        "])), Column);
});
var CustomBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_29 || (templateObject_29 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    overflow-y: ", ";\n    height: auto;\n\n    max-height: ", ";\n    @media screen and (max-width: 768px) {\n        height: ", ";\n        overflow-y: auto;\n        overflow-x: hidden;\n        ", "\n    }\n"], ["\n    overflow-y: ", ";\n    height: auto;\n\n    max-height: ", ";\n    @media screen and (max-width: 768px) {\n        height: ", ";\n        overflow-y: auto;\n        overflow-x: hidden;\n        ", "\n    }\n"])), function (_a) {
    var overflow = _a.overflow;
    return overflow || 'auto';
}, function (_a) {
    var headerHeight = _a.headerHeight, footerHeight = _a.footerHeight;
    return "calc(100vh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - ").concat(footerHeight !== null && footerHeight !== void 0 ? footerHeight : 0, "px )");
}, function (_a) {
    var responsiveHeight = _a.responsiveHeight;
    return responsiveHeight;
}, function (_a) {
    var isHaveLeftFooter = _a.isHaveLeftFooter;
    if (!isHaveLeftFooter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_28 || (templateObject_28 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                height: calc(100vh - 200px);\n            "], ["\n                height: calc(100vh - 200px);\n            "])));
});
var HeaderText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_30 || (templateObject_30 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    font-size: 18px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 22px;\n"], ["\n    font-size: 18px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 22px;\n"])), function (_a) {
    var textColor = _a.textColor;
    return textColor !== null && textColor !== void 0 ? textColor : '#333';
});
styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_34 || (templateObject_34 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    cursor: pointer;\n    display: ", ";\n    ", "\n"], ["\n    cursor: pointer;\n    display: ", ";\n    ", "\n"])), function (_a) {
    var isShowClose = _a.isShowClose;
    return (isShowClose ? 'block' : 'none');
}, function (_a) {
    var isHeaderCenter = _a.isHeaderCenter;
    if (!isHeaderCenter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_33 || (templateObject_33 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            position: absolute;\n            padding: 15px;\n            top: 0;\n            ", "\n        "], ["\n            position: absolute;\n            padding: 15px;\n            top: 0;\n            ", "\n        "])), function (_a) {
        var btnPosition = _a.btnPosition;
        if (btnPosition === 'left') {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_31 || (templateObject_31 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        left: 0;\n                    "], ["\n                        left: 0;\n                    "])));
        }
        else {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_32 || (templateObject_32 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        right: 0;\n                    "], ["\n                        right: 0;\n                    "])));
        }
    });
});
var MoreFooterButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_35 || (templateObject_35 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)([""], [""])));
var openWrapperResponsive = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_36 || (templateObject_36 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        translate: 0 0;\n        scale: 1;\n    }\n    100% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n"], ["\n    0% {\n        translate: 0 0;\n        scale: 1;\n    }\n    100% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n"])));
var closeWrapperResponsive = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_37 || (templateObject_37 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n    100% {\n        translate: 0 0;\n        scale: 1;\n    }\n"], ["\n    0% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n    100% {\n        translate: 0 0;\n        scale: 1;\n    }\n"])));
var TopWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_38 || (templateObject_38 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    @media screen and (max-width: 768px) {\n        width: 100vw;\n        position: fixed;\n        z-index: 10;\n        top: ", ";\n        left: 0;\n        height: 100vh;\n        border-top: 16px solid #000;\n        transition: 0.4s ease;\n        &::before {\n            content: ' ';\n            height: calc(100vh + 50px);\n            width: 100vw;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            box-shadow: 0 0 0 150px #000;\n            border-radius: 12px;\n            transition: 0.4s ease;\n            animation: ", " 0.4s ease forwards;\n        }\n    }\n"], ["\n    @media screen and (max-width: 768px) {\n        width: 100vw;\n        position: fixed;\n        z-index: 10;\n        top: ", ";\n        left: 0;\n        height: 100vh;\n        border-top: 16px solid #000;\n        transition: 0.4s ease;\n        &::before {\n            content: ' ';\n            height: calc(100vh + 50px);\n            width: 100vw;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            box-shadow: 0 0 0 150px #000;\n            border-radius: 12px;\n            transition: 0.4s ease;\n            animation: ", " 0.4s ease forwards;\n        }\n    }\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 0 : '-16px');
}, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openWrapperResponsive : closeWrapperResponsive);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38;


//# sourceMappingURL=Popup.css.js.map


/***/ }),

/***/ 30744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Popup; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(54033);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/Popup.css.js
var Popup_css = __webpack_require__(46021);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Popup/translation.js
'use client';

var translations = {
    Yes: 'Đồng ý',
    No: 'Không',
    Cancel: 'Huỷ',
    Alert: 'Thông báo'
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Popup/constants.js
'use client';

var DEFAULT_STYLE_OPTION = {
    primaryBtnStyle: 'primary',
    secondaryBtnStyle: 'default',
    primaryBtnOutline: 'solid',
    secondaryBtnOutline: 'solid',
    size: 'md',
    isCenterTitle: false,
    closeButtonPosition: 'right',
    className: '',
    bodyDivQuerySelector: '',
    isPushViewBehind: false,
    isFooterButtonFullWidth: false,
    headerBg: '#fff',
    closeIconColor: '#888',
    headerTextColor: '#333',
    isHaveBorder: true,
    primaryBtnWidth: '',
    isDisplayNone: false
};
var DEFAULT_OPTION = {
    isShowBackdrop: true,
    isCloseOnClickBackdrop: true,
    isShowClose: true,
    isFullScreenOnMobile: true,
    isShowSecondaryButton: true,
    isShowPrimaryButton: true,
    isCenterFooter: false,
    isReverseAction: false
};
var DEFAULT_HEIGHT_FIX = 135;


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useScrollLock.js
var useScrollLock = __webpack_require__(35394);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js
'use client';















var Popup = function (props) {
    var _a;
    var isShow = props.isShow, _b = props.custom, custom = _b === void 0 ? null : _b, children = props.children, _c = props.text, text = _c === void 0 ? null : _c, lang = props.lang, styleOption = props.styleOption, option = props.option, onClickPrimary = props.onClickPrimary, onClickOutside = props.onClickOutside, onClose = props.onClose, _d = props.className, className = _d === void 0 ? '' : _d, customActionPopup = props.customActionPopup;
    var mergedStyleOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_STYLE_OPTION), styleOption);
    var mergedOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTION), option);
    var bodyOverflow = (custom === null || custom === void 0 ? void 0 : custom.bodyOverflow) || 'auto';
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    var _e = (0,react.useState)(), headerHeight = _e[0], setHeaderHeight = _e[1];
    var _f = (0,react.useState)(), footerHeight = _f[0], setFooterHeight = _f[1];
    var customRef = (0,react.useCallback)(function (node, ref) {
        if (node === null)
            return;
        switch (ref) {
            case 'header':
                setHeaderHeight(node.clientHeight);
                break;
            case 'footer':
                setFooterHeight(node.clientHeight);
                break;
        }
    }, []);
    /*
     * when toggle popup, it add and remove overflow: hidden on body tag.
     * On ios device, this action make header on mobile flickering when scroll up and doww.
     * So we must delay the close popup state to fix this bug
     * */
    var _g = customActionPopup || {}, _h = _g.enable, enableCustomPopup = _h === void 0 ? false : _h, actionCustomPopupAfterShow = _g.actionCustomPopupAfterShow, _j = _g.delayTime, delayTime = _j === void 0 ? 100 : _j;
    var _k = (0,react.useState)(isShow), customActionPopupState = _k[0], setCustomActionPopupState = _k[1];
    var _l = (0,react.useState)(false), isMounted = _l[0], setMounted = _l[1];
    var _m = (0,useScrollLock/* default */.Z)({
        autoLock: (custom === null || custom === void 0 ? void 0 : custom.autoLockScroll) || false,
        lockTarget: custom === null || custom === void 0 ? void 0 : custom.lockTarget
    }), lock = _m.lock, unlock = _m.unlock;
    var isPopupOpened = (0,react.useRef)(false);
    var isInMobile = (0,helpers/* isMobile */.tq)();
    var getPopupState = (0,react.useMemo)(function () {
        if (enableCustomPopup) {
            return customActionPopupState;
        }
        return isShow;
    }, [enableCustomPopup, isShow, customActionPopupState]);
    var updatePushView = function () {
        // Is in mobile and option isPushViewBehind true
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        bodyNode.style.backgroundColor = '#000';
        rootElement.style.transition = '0.4s ease';
        rootElement.style.transform = "translate(0, ".concat(window.scrollY < DEFAULT_HEIGHT_FIX ? "-".concat(DEFAULT_HEIGHT_FIX - window.scrollY, "px") : 0, ") scale(0.9)");
        rootElement.style.borderRadius = '12px';
        rootElement.style.backgroundColor = '#fff';
    };
    (0,react.useEffect)(function () {
        var _a;
        setCustomActionPopupState(isShow);
        if (isShow) {
            setMounted(isShow);
            if (!isPopupOpened.current) {
                lock();
                isPopupOpened.current = true;
            }
        }
        else {
            if (isPopupOpened.current) {
                unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
                isPopupOpened.current = false;
            }
        }
    }, [isShow, lock, unlock, (_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode]);
    (0,react.useEffect)(function () {
        if (!enableCustomPopup) {
            return;
        }
        if (!isShow) {
            setTimeout(function () {
                setCustomActionPopupState(false);
                actionCustomPopupAfterShow && actionCustomPopupAfterShow();
            }, delayTime);
            return;
        }
        setCustomActionPopupState(isShow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableCustomPopup, delayTime, isShow]);
    (0,react.useEffect)(function () {
        if (!bodyNode) {
            return;
        }
        var resetBodyPopupPush = function () {
            if (!isInMobile) {
                return;
            }
            if (!mergedStyleOption.isPushViewBehind) {
                return;
            }
            // Make sure it will not action when bodyDiv element was not exist
            if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
                return;
            }
            var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
            if (rootElement === null) {
                return;
            }
            rootElement.style.transform = 'initial';
        };
        // lock scrolling on body
        if (isShow) {
            updatePushView();
        }
        else {
            resetBodyPopupPush();
        }
        // Component will unmount
        return function () {
            resetBodyPopupPush();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyNode, isInMobile, isShow]);
    if (!bodyNode) {
        return react.createElement(react.Fragment, null);
    }
    if (!isMounted) {
        return react.createElement(react.Fragment, null);
    }
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var doClosePopup = function () {
        var _a;
        if (enableCustomPopup) {
            setCustomActionPopupState(false);
        }
        unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
        onClose && onClose();
    };
    var handleOnClickSecondary = function () {
        var _a;
        if (mergedOption.isReverseAction) {
            onClickPrimary && onClickPrimary();
            unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
            return;
        }
        doClosePopup();
    };
    var handleOnClickPrimary = function () {
        var _a;
        if (mergedOption.isReverseAction) {
            doClosePopup();
            return;
        }
        onClickPrimary && onClickPrimary();
        unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
    };
    var handleOnClickBackdrop = function () {
        onClickOutside && onClickOutside();
        if (mergedOption.isCloseOnClickBackdrop) {
            doClosePopup();
        }
    };
    var onAnimationEndClosePushView = function () {
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        rootElement.style.overflow = 'initial';
        rootElement.style.height = 'initial';
        rootElement.style.borderRadius = 'initial';
        bodyNode.style.backgroundColor = 'initial';
    };
    var onAnimationEnd = function () {
        if (getPopupState) {
            return;
        }
        onAnimationEndClosePushView();
        setMounted(false);
    };
    var calculateBodyHeight = function () {
        var _a;
        if (typeof window === 'undefined') {
            return "100vh";
        }
        if (custom === null || custom === void 0 ? void 0 : custom.isPopupCenter) {
            return '';
        }
        var height = window.innerHeight;
        var headerHeight = 61;
        var footerHeight = 90;
        var additionalFooterHeight = (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0;
        var isHaveCustomFooter = (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined;
        if (isHaveCustomFooter) {
            footerHeight = 0;
        }
        if (!isHaveCustomFooter && (custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert)) {
            footerHeight = 123;
        }
        // Calculate body height by removed all other element height
        // 34px is margin-top pixel of main popup
        return "".concat(height - headerHeight - footerHeight - 34 - additionalFooterHeight, "px");
    };
    /**
     * Render
     */
    var renderHeader = function () {
        return (react.createElement("div", { ref: function (node) { return customRef(node, 'header'); } }, (custom === null || custom === void 0 ? void 0 : custom.header) !== undefined ? (custom.header) : (react.createElement(Popup_css/* Header */.h4, { isCenterTitle: mergedStyleOption.isCenterTitle, bgColor: mergedStyleOption.headerBg },
            react.createElement(Popup_css/* HeaderText */.z, { textColor: mergedStyleOption.headerTextColor }, text === null || text.header === undefined ? t('Alert') : text.header),
            mergedOption.isShowClose ? (react.createElement(Button/* default */.Z, { className: 'close-btn', isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return doClosePopup(); } },
                react.createElement(CloseIcon/* default */.Z, { fill: mergedStyleOption.closeIconColor }))) : null))));
    };
    var renderFooter = function () {
        var primaryBtnStyle = {};
        if (mergedOption.isShowPrimaryButton && mergedStyleOption.primaryBtnWidth !== '') {
            primaryBtnStyle = {
                width: mergedStyleOption.primaryBtnWidth
            };
        }
        return (react.createElement("div", { ref: function (node) { return customRef(node, 'footer'); } }, (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined ? (custom.footer) : (react.createElement(Popup_css/* Footer */.$_, { isShow: getPopupState, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, isCenter: mergedOption.isCenterFooter, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), isFooterButtonFullWidth: mergedStyleOption.isFooterButtonFullWidth },
            (custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert) ? react.createElement(Popup_css/* Column */.sg, null, custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert) : null,
            react.createElement(Popup_css/* Column */.sg, null,
                (custom === null || custom === void 0 ? void 0 : custom.footerButtons) !== undefined
                    ? custom === null || custom === void 0 ? void 0 : custom.footerButtons.map(function (item, index) {
                        return react.createElement(Popup_css/* MoreFooterButton */.sL, { key: "footer-button-".concat(index) }, item);
                    })
                    : null,
                mergedOption.isShowSecondaryButton && (react.createElement(Button/* default */.Z, { type: mergedStyleOption.secondaryBtnStyle, outline: mergedStyleOption.secondaryBtnOutline, onClick: handleOnClickSecondary }, text === null || text.secondaryBtn === undefined ? t('Cancel') : text.secondaryBtn)),
                mergedOption.isShowPrimaryButton && (react.createElement(Button/* default */.Z, { disabled: (option === null || option === void 0 ? void 0 : option.disabledPrimary) || false, type: mergedStyleOption.primaryBtnStyle, outline: mergedStyleOption.primaryBtnOutline, onClick: handleOnClickPrimary, style: primaryBtnStyle }, text === null || text.primaryBtn === undefined ? t('Yes') : text.primaryBtn)))))));
    };
    var renderCustom = function () {
        var _a;
        var bodyHeight = calculateBodyHeight();
        return (react.createElement(react.Fragment, null,
            renderHeader(),
            (custom === null || custom === void 0 ? void 0 : custom.withDefaultBody) ? (react.createElement(Popup_css/* Body */.uT, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null, additionalFooterHeight: (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0 }, children)) : (react.createElement(Popup_css/* CustomBody */.QF, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null }, children)),
            renderFooter()));
    };
    var renderPopupDefault = function () {
        var bodyHeight = calculateBodyHeight();
        return (react.createElement(react.Fragment, null,
            renderHeader(),
            react.createElement(Popup_css/* Body */.uT, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null }, children),
            renderFooter()));
    };
    return (0,react_dom.createPortal)(react.createElement(react.Fragment, null,
        react.createElement(Popup_css/* PopupWrapper */.SM, { className: className, isShow: getPopupState, isDisplayNone: mergedStyleOption.isDisplayNone },
            react.createElement(Popup_css/* BackdropWrapper */.Ow, { isShowBackdrop: mergedOption.isShowBackdrop, onClick: handleOnClickBackdrop, clickableBackdrop: mergedOption.isCloseOnClickBackdrop }),
            react.createElement(Popup_css/* PopupContentWrapper */.Jk, null,
                react.createElement(Popup_css/* PopupContent */.pP, { isShow: getPopupState, className: "vnw-popup-content ".concat(mergedStyleOption.className), size: mergedStyleOption.size, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, onAnimationEnd: onAnimationEnd, isHaveBorder: mergedStyleOption.isHaveBorder, isPopupCenter: custom === null || custom === void 0 ? void 0 : custom.isPopupCenter }, custom !== null ? renderCustom() : renderPopupDefault()))),
        mergedStyleOption.isPushViewBehind && (0,react_dom.createPortal)(react.createElement(Popup_css/* TopWrapper */.Wf, { isShow: getPopupState }), bodyNode)), bodyNode);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 33288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PopupCVReplace$1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupCVReplace/translations.js
'use client';

var translations = {
    'You get maximum _s attached CVs': 'Bạn đã tải lên tối đa _s CVs',
    Cancel: 'Huỷ bỏ',
    'Select your existing CV': 'Chọn CV đã tải lên trước đó của bạn',
    Searchable: 'Cho phép tìm kiếm',
    Replace: 'Thay thế',
    'Updated:': 'Cập nhật lúc:',
    'You have got the maximum of _s attached CV on VietnamWorks. ': 'Bạn đã đạt đến số lượng tải lên tối đa _s CV trên VietnamWorks.',
    'Choose one of existed CV to replace:': 'Chọn một CV trước đó để thay thế',
    'The replaced attached CV will automatically marks as "Searchable".': 'CV được thay thế sẽ tự động đánh dấu là "Cho phép tìm kiếm"',
    'You can': 'Bạn có thể',
    'switch the searchable CVs in Profile settings': 'chuyển trạng thái tìm kiếm CV trong Cài đặt hồ sơ',
    'Please select a CV to replace': 'Vui lòng chọn một CV để thay thế',
    'my-profile': 'ho-so',
    'Note: The CV replacement': 'Chú ý: Việc thay thế hồ sơ sẽ',
    'will not change the CV sent to employers.': 'không làm thay đổi hồ sơ đã gửi cho nhà tuyển dụng.'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupCVReplace/styles.css.js
'use client';






var ReplaceCVPopupWrapper = (0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n        }\n    }\n    .vnw-popup-content {\n        div:has(button.btn-default, button.btn-primary) {\n            button {\n                flex-basis: 50%;\n            }\n        }\n    }\n"], ["\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n        }\n    }\n    .vnw-popup-content {\n        div:has(button.btn-default, button.btn-primary) {\n            button {\n                flex-basis: 50%;\n            }\n        }\n    }\n"])));
var CVFileName = styled_components_browser_esm/* default.span */.ZP.span(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 400 !important;\n"], ["\n    font-weight: 400 !important;\n"])));
var CVFileNameContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    > * {\n        flex-shrink: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    > * {\n        flex-shrink: 0;\n    }\n"])));
var SearchableTag = styled_components_browser_esm/* default.span */.ZP.span(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: ", ";\n    height: 18px;\n    padding: 2px 6px;\n    align-items: center;\n    border-radius: 14px;\n    background: ", ";\n    display: inline-flex;\n"], ["\n    margin: ", ";\n    height: 18px;\n    padding: 2px 6px;\n    align-items: center;\n    border-radius: 14px;\n    background: ", ";\n    display: inline-flex;\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 0 : '0px 8px');
}, Colors/* colors.green.90 */.O9.green[90]);
var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0 9px;\n    min-height: 156px;\n"], ["\n    padding: 0 9px;\n    min-height: 156px;\n"])));
var WarningCard = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    border-radius: 8px;\n    background: ", ";\n    margin-bottom: 8px;\n    gap: 8px;\n"], ["\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    border-radius: 8px;\n    background: ", ";\n    margin-bottom: 8px;\n    gap: 8px;\n"])), Colors/* colors.yellow.95 */.O9.yellow[95]);
var Footer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n    gap: 8px;\n"], ["\n    display: flex;\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n    gap: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


//# sourceMappingURL=styles.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/index.js
var SingleRadio = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/helper.js
var helper = __webpack_require__(35753);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/WarnIcon.js
var WarnIcon = __webpack_require__(29451);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/index.js + 2 modules
var BottomSheet = __webpack_require__(6031);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupCVReplace/index.js
'use client';














var PopupCVReplace = function (props, ref) {
    var _a = props.maxNumberOfCV, maxNumberOfCV = _a === void 0 ? 3 : _a, _b = props.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, formControl = props.formControl, cvList = props.cvList;
    var t = (0,helpers/* createTranslator */.eX)({ translations: translations, currentLanguage: langCode });
    var _c = (0,react.useState)(0), replaceById = _c[0], setReplaceById = _c[1];
    var _d = (0,react.useState)(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = (0,react.useState)(false), hasError = _e[0], setHasError = _e[1];
    var _f = (0,react.useState)(null), popupResolve = _f[0], setPopupResolve = _f[1];
    var memorizedAttachedCVList = (0,react.useMemo)(function () {
        var maxLength = function (isSearchable) {
            if (!(0,helpers/* isMobile */.tq)()) {
                return isSearchable ? 21 : 48;
            }
            return isSearchable ? 10 : 25;
        };
        return cvList
            .filter(function (item) { return item.isAttach === 1; })
            .map(function (item) {
            var _a, _b;
            return {
                id: item.id,
                name: (0,helper/* fileName */.Yp)((_a = item.fileName) !== null && _a !== void 0 ? _a : '', maxLength(item.isSearchable)),
                isSearchable: item.isSearchable,
                updatedOn: (0,helper/* formatDateTime */.o0)((_b = item.updatedDate) !== null && _b !== void 0 ? _b : 0, 'DDMMYYYY')
            };
        });
    }, [cvList]);
    var open = function () {
        setIsOpen(true);
        return new Promise(function (resolve) {
            setPopupResolve(function () { return resolve; });
        });
    };
    var handleCancel = function (closeBy) { return function () {
        setIsOpen(false);
        setHasError(false);
        popupResolve === null || popupResolve === void 0 ? void 0 : popupResolve({ closeBy: closeBy, data: { formControl: formControl } });
        setPopupResolve(null);
    }; };
    var handleConfirm = function () {
        if (!replaceById) {
            setHasError(true);
            return;
        }
        setIsOpen(false);
        popupResolve === null || popupResolve === void 0 ? void 0 : popupResolve({ data: { resumeId: replaceById, formControl: formControl }, closeBy: 'accept' });
        setPopupResolve(null);
        setHasError(false);
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            open: open,
            isOpen: isOpen
        };
    }, [isOpen]);
    return (react.createElement(react.Fragment, null, !(0,helpers/* isMobile */.tq)() ? (react.createElement(ReplaceCVPopupWrapper, { isShow: isOpen, lang: langCode, onClose: handleCancel('closeBtn'), onClickOutside: handleCancel('backdrop'), onClickPrimary: handleConfirm, styleOption: {
            size: 'sm'
        }, option: { isShowClose: false }, text: {
            header: t('You get maximum _s attached CVs', { _s: maxNumberOfCV }),
            primaryBtn: t('Replace'),
            secondaryBtn: t('Cancel')
        } },
        react.createElement(Container, null,
            react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'medium', style: { textAlign: 'center', marginBottom: 16 } }, t('You have got the maximum of _s attached CV on VietnamWorks. ', { _s: maxNumberOfCV })),
            react.createElement(Variant/* Paragraph */.nv, { name: 'title', size: 'medium', style: { textAlign: 'center', marginBottom: 8 } }, t('Choose one of existed CV to replace:', { _s: maxNumberOfCV })),
            memorizedAttachedCVList.map(function (cv, index) { return (react.createElement(react.Fragment, { key: "".concat(cv.id, "-").concat(index) },
                react.createElement(SingleRadio/* default */.Z, { id: cv.id.toString(), name: 'cv-file', isLeftRadio: true, label: cv.isSearchable
                        ? function () { return (react.createElement(CVFileNameContainer, null,
                            react.createElement(CVFileName, null, cv.name),
                            react.createElement(SearchableTag, null,
                                react.createElement(Variant/* Span */.Dr, { color: Colors/* colors.green.50 */.O9.green[50], name: 'label', size: 'small' }, t('Searchable'))))); }
                        : function () { return react.createElement(CVFileName, null, cv.name); }, onChange: function (value) {
                        setReplaceById(+value);
                        setHasError(false);
                    } }),
                cv.isSearchable ? (react.createElement(WarningCard, null,
                    react.createElement(WarnIcon/* default */.Z, { size: 16 }),
                    react.createElement("div", null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'small' }, t('The replaced attached CV will automatically marks as "Searchable".')),
                        react.createElement(Variant/* Paragraph */.nv, null,
                            react.createElement(Variant/* Span */.Dr, { name: 'body', size: 'small' }, t('You can')),
                            ' ',
                            react.createElement(Variant/* Anchor */.ee, { name: 'body', size: 'small', href: "/".concat(t('my-profile'), "?tab=profile-settings"), color: Colors/* colors.primary.40 */.O9.primary[40] }, t('switch the searchable CVs in Profile settings')))))) : null)); }),
            react.createElement(Variant/* Paragraph */.nv, { style: { margin: '8px 0', textAlign: 'left' }, size: 'medium' },
                t('Note: The CV replacement'),
                ' ',
                react.createElement("strong", null, t('will not change the CV sent to employers.'))),
            hasError ? (react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'medium', style: { textAlign: 'right' }, color: Colors/* colors.error.40 */.O9.error[40] }, t('Please select a CV to replace'))) : null))) : (react.createElement(BottomSheet/* default */.Z, { isOpen: isOpen, onClose: handleCancel('closeBtn'), options: { isHaveCloseIcon: false }, header: t('You get maximum _s attached CVs', { _s: maxNumberOfCV }), footer: react.createElement(Footer, null,
            react.createElement(Button/* default */.Z, { onClick: handleCancel('closeBtn'), style: { width: '50%' } }, t('Cancel')),
            react.createElement(Button/* default */.Z, { type: 'primary', onClick: function () { return handleConfirm(); }, style: { width: '50%' } }, t('Replace'))), styleOption: {
            zIndex: 1100
        } },
        react.createElement(Container, null,
            react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'medium', style: { marginBottom: 16 } }, t('You have got the maximum of _s attached CV on VietnamWorks. ', { _s: maxNumberOfCV })),
            react.createElement(Variant/* Paragraph */.nv, { name: 'title', size: 'medium', style: { marginBottom: 8 } }, t('Choose one of existed CV to replace:', { _s: maxNumberOfCV })),
            memorizedAttachedCVList.map(function (cv, index) { return (react.createElement(react.Fragment, { key: "".concat(cv.id, "-").concat(index) },
                react.createElement(SingleRadio/* default */.Z, { id: cv.id.toString(), name: 'cv-file', isLeftRadio: true, label: cv.isSearchable
                        ? function () { return (react.createElement(CVFileNameContainer, null,
                            react.createElement(CVFileName, null,
                                cv.name,
                                " - ",
                                cv.updatedOn),
                            react.createElement(SearchableTag, { isMobile: (0,helpers/* isMobile */.tq)() },
                                react.createElement(Variant/* Span */.Dr, { color: Colors/* colors.green.50 */.O9.green[50], name: 'label', size: 'small' }, t('Searchable'))))); }
                        : cv.name, onChange: function (value) {
                        setReplaceById(+value);
                        setHasError(false);
                    } }),
                cv.isSearchable ? (react.createElement(WarningCard, null,
                    react.createElement(WarnIcon/* default */.Z, { size: 16 }),
                    react.createElement("div", null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'small' }, t('The replaced attached CV will automatically marks as "Searchable".')),
                        react.createElement(Variant/* Paragraph */.nv, null,
                            react.createElement(Variant/* Span */.Dr, { name: 'body', size: 'small' }, t('You can')),
                            ' ',
                            react.createElement(Variant/* Anchor */.ee, { name: 'body', size: 'small', href: "/".concat(t('my-profile'), "?tab=profile-settings"), color: Colors/* colors.primary.40 */.O9.primary[40] }, t('switch the searchable CVs in Profile settings')))))) : null)); }),
            react.createElement(Variant/* Paragraph */.nv, { style: { margin: '8px 0', textAlign: 'left' }, size: 'medium' },
                t('Note: The CV replacement'),
                ' ',
                react.createElement("strong", null, t('will not change the CV sent to employers.'))),
            hasError ? (react.createElement(Variant/* Paragraph */.nv, { name: 'body', size: 'medium', style: { textAlign: 'right' }, color: Colors/* colors.error.40 */.O9.error[40] }, t('Please select a CV to replace'))) : null)))));
};
var PopupCVReplace$1 = react.forwardRef(PopupCVReplace);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 26209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PopupWarning; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupWarning/translations.js
'use client';

var translations = {
    'New term of use and privacy policy': 'Thỏa thuận sử dụng và Quy định bảo mật mới',
    'Yes, I turn it on': 'Có, bật chia sẻ',
    'No, I turn it off': 'Không, tắt chia sẻ',
    'Yes, turn it off': 'Có, tắt chia sẻ',
    'No, keep sharing': 'Không, tiếp tục chia sẻ',
    'The following functions had granted permission': 'Những chức năng sau đã được cấp quyền',
    'Not able to apply for jobs on VietnamWorks': 'Không thể nộp đơn cho các công việc trên Vietnamworks',
    'Not able to make your profile searchable to Employers': 'Không thể cho phép nhà tuyển dụng tìm hồ sơ của bạn',
    'Not receive any in-app notifications': 'Không nhận bất cứ thông báo nào trên ứng dụng',
    'Not receive any emails from us': 'Không nhận bất kỳ email từ chúng tôi',
    'Status:': 'Trạng thái:',
    ON: 'BẬT',
    OFF: 'TẮT',
    'The following functions had been disabled': 'Những chức năng sau đã được vô hiệu',
    'Able to apply for jobs on VietnamWorks': 'Nộp đơn cho các công việc trên Vietnamworks',
    'Able to make your profile searchable to Employers': 'Cho phép nhà tuyển dụng tìm hồ sơ của bạn',
    'Allow to receive any in-app notifications': 'Nhận các thông báo trên ứng dụng',
    'Allow to receive any emails from us': 'Nhận các email từ chúng tôi',
    'Are you sure to turn off data sharing with us?': 'Bạn chắc chắn muốn tắt chia sẻ dữ liệu với chúng tôi?',
    'By clicking “Yes, turn it off", you will:': 'Bằng việc bấm "Có, tắt chia sẻ", bạn sẽ:',
    Cancel: 'Huỷ',
    Continue: 'Tiếp tục'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/Warning/index.js
var Warning = __webpack_require__(14083);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupWarning/styles.css.js
'use client';





var WarninglWrapper = (0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n        }\n    }\n    .vnw-popup-content {\n        div:has(button.btn-default, button.btn-primary) {\n            button {\n                flex-basis: 50%;\n            }\n        }\n    }\n"], ["\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n        }\n    }\n    .vnw-popup-content {\n        div:has(button.btn-default, button.btn-primary) {\n            button {\n                flex-basis: 50%;\n            }\n        }\n    }\n"])));
var WarningAlert = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    column-gap: 16px;\n    background: linear-gradient(0deg, rgba(247, 190, 6, 0.15), rgba(247, 190, 6, 0.15)), #ffffff;\n    border-radius: 6px;\n    padding: 10px 8px;\n    margin-top: 16px;\n"], ["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    column-gap: 16px;\n    background: linear-gradient(0deg, rgba(247, 190, 6, 0.15), rgba(247, 190, 6, 0.15)), #ffffff;\n    border-radius: 6px;\n    padding: 10px 8px;\n    margin-top: 16px;\n"])));
var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0 9px;\n    p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n    }\n"], ["\n    padding: 0 9px;\n    p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3;


//# sourceMappingURL=styles.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupWarning/index.js
'use client';







var PopupWarning = function (props) {
    var _a = props.isShow, isShow = _a === void 0 ? false : _a, _b = props.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, _c = props.title, title = _c === void 0 ? '' : _c, _d = props.primaryText, primaryText = _d === void 0 ? '' : _d, _e = props.secondaryText, secondaryText = _e === void 0 ? '' : _e, children = props.children, warningTxt = props.warningTxt, onClose = props.onClose, onAccept = props.onAccept;
    var t = function (text) {
        var _a;
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClickClose = function () {
        onClose && onClose();
    };
    var onClickAccept = function () {
        onAccept && onAccept();
    };
    return (react.createElement(WarninglWrapper, { isShow: isShow, lang: langCode, onClose: onClickClose, onClickOutside: onClickClose, onClickPrimary: onClickAccept, styleOption: {
            size: 'sm'
        }, text: {
            header: title !== null && title !== void 0 ? title : ' ',
            primaryBtn: primaryText || t('Continue'),
            secondaryBtn: secondaryText || t('Cancel')
        } },
        react.createElement(Container, null,
            children,
            warningTxt ? (react.createElement(WarningAlert, null,
                react.createElement(Warning/* default */.Z, null),
                warningTxt)) : (''))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 74313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HogProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Utils_cookie_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6017);
/* harmony import */ var _hooks_useHog_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36802);
'use client';





var VNW_DOMAIN = '.vietnamworks.com';
// This HogProvider is used to centralize PostHog.
// In the future, any further requirements or changes can
// easily be updated here.
var HogProvider = function (props) {
    var children = props.children;
    var trackingQueue = (0,_hooks_useHog_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().trackingQueue;
    var detectSocialAuth = function () {
        var registerProvider = (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .e)('VNW_REGISTER_PROVIDER');
        var loginProvider = (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .e)('VNW_LOGIN_PROVIDER');
        if (!loginProvider && !registerProvider) {
            return;
        }
        var isSignedUp = registerProvider !== null && registerProvider !== '';
        // Register
        if (isSignedUp) {
            trackingQueue({
                eventName: 'js_registration:account_verify_success',
                properties: {
                    isSignedupByEmail: registerProvider === 'email',
                    isSignedupByFacebook: registerProvider === 'facebook',
                    isSignedupByGoogle: registerProvider === 'google'
                }
            });
            (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d)('VNW_REGISTER_PROVIDER', '', -1, VNW_DOMAIN);
            return;
        }
        if (!loginProvider) {
            return;
        }
        // Login
        trackingQueue({
            eventName: 'js_registration:login_success',
            properties: {
                isEmail: loginProvider === 'email',
                isFacebook: loginProvider === 'facebook',
                isGoogle: loginProvider === 'google'
            }
        });
        (0,_Utils_cookie_js__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d)('VNW_LOGIN_PROVIDER', '', -1, VNW_DOMAIN);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // if (!posthogConfig.host || !posthogConfig.key) {
        //     console.error('Missing PostHog Config!')
        //     return
        // }
        // posthog.init(posthogConfig.key, {
        //     api_host: posthogConfig.host ?? 'https://us.i.posthog.com',
        //     capture_pageleave: false,
        //     person_profiles: 'identified_only',
        //     // Include or don't include webdriver, crawler, bot
        //     // opt_out_useragent_filter = false => Don't record tracking from bot, webdriver, Unkown user-agent
        //     opt_out_useragent_filter: posthogConfig.options?.optOutUserAgentFilter ?? false,
        //     loaded: (posthog) => {
        //         if (posthogConfig.options?.debugMode) {
        //             posthog.debug()
        //         }
        //     }
        // })
        // TrackingQueue will await until posthog is ready
        detectSocialAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // return <PostHogProvider client={posthog}>{children}</PostHogProvider>
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 36802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHog; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32322);
'use client';





var INTERVAL_TIME = 500;
// This useHog function is used to centralize PostHog.
// In the future, any further requirements or changes can
// easily be updated here.
/**
 * A Hog Hook that return a tracking function and a tracking queue function.
 *
 * @returns  tracking, trackingQueue
 */
var useHog = function () {
    // Queue
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isEnableQueue = _a[0], setIsEnableQueue = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), trackingQueues = _b[0], setTrackingQueues = _b[1];
    var intervalIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var tracking = function (params, options) {
        try {
            if (!window.posthog) {
                console.error('PostHog is not ready!');
                return;
            }
            var _a = params.eventName, eventName = _a === void 0 ? '' : _a, _b = params.properties, properties = _b === void 0 ? {} : _b;
            // Do not tracking when there is no eventName provided
            if (eventName === '') {
                console.error('eventName is empty!');
                return;
            }
            // Parse page-name from window.location.pathname
            properties.pageName = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .getPageName */ .j0)();
            var parsedProperties = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .convertKeysToSnakeCase */ .K9)(properties);
            window.posthog.capture(eventName, parsedProperties, options);
        }
        catch (ex) {
            console.error('PostHog Error', ex);
        }
    };
    var trackingQueue = function (params, options) {
        try {
            // Run tracking when postHog is ready! No need to queue
            if (window.posthog) {
                tracking(params, options);
                return;
            }
            // PostHog is not ready then we should add it to queue
            var newTrackingQueues = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], trackingQueues, true);
            newTrackingQueues.push({
                id: "".concat(params.eventName, "_").concat(trackingQueues.length + 1),
                trackingParams: params,
                options: options
            });
            setTrackingQueues(newTrackingQueues);
            setIsEnableQueue(true);
        }
        catch (ex) {
            console.error('Tracking Queue Error', ex);
        }
    };
    var checkingPostHog = function () {
        if (!window.posthog) {
            return;
        }
        // Disable interval to prevent javascript running endless
        if (trackingQueues.length === 0) {
            setIsEnableQueue(false);
            return;
        }
        // Loop through queues
        trackingQueues.forEach(function (trackingItem) {
            // Send tracking event
            tracking(trackingItem.trackingParams, trackingItem === null || trackingItem === void 0 ? void 0 : trackingItem.options);
        });
        // All tracking is sent then we should empty it
        setTrackingQueues([]);
        setIsEnableQueue(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!isEnableQueue) {
            return;
        }
        if (trackingQueues.length === 0) {
            return;
        }
        intervalIdRef.current = setInterval(checkingPostHog, INTERVAL_TIME);
        return function () {
            intervalIdRef.current && clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        };
    }, [isEnableQueue, trackingQueues]);
    return {
        tracking: tracking,
        trackingQueue: trackingQueue
    };
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PJ": function() { return /* binding */ sendHogIdentify; },
/* harmony export */   "ZP": function() { return /* binding */ useIdentify; }
/* harmony export */ });
/* unused harmony export DEFAULT_INTERVAL_CHECK_IDENTIFY */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _services_resumes_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93843);
/* harmony import */ var _UploadResumeModal_type_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88845);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96306);
/* harmony import */ var _services_model_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90222);
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55613);
'use client';









var DEFAULT_INTERVAL_CHECK_IDENTIFY = 50;
var sendHogIdentify = function (postHog, user, baseMsUrl) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var userProfilePromise, userLevelPromise, promiseResponse, response_1, userProfile, userLevel, maritalStatus, ex_1;
    var _a, _b;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!user || !(user === null || user === void 0 ? void 0 : user.userId) || !(user === null || user === void 0 ? void 0 : user.accessToken)) {
                    return [2 /*return*/];
                }
                if (!postHog) {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                userProfilePromise = (0,_services_resumes_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getUserProfile */ .et)((0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .detectEncryptAccessToken */ .If)(user === null || user === void 0 ? void 0 : user.accessToken), baseMsUrl);
                userLevelPromise = (0,_services_resumes_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getProfileLevel */ .Mz)((0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .detectEncryptAccessToken */ .If)(user === null || user === void 0 ? void 0 : user.accessToken), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .ELanguage.VI */ .Df.VI, baseMsUrl);
                return [4 /*yield*/, Promise.allSettled([userProfilePromise, userLevelPromise])];
            case 2:
                promiseResponse = _c.sent();
                response_1 = [null, null];
                promiseResponse.forEach(function (result) {
                    if (result.status === 'rejected') {
                        response_1.push(null);
                        return;
                    }
                    // fulfilled and no Model
                    if (result.status === 'fulfilled' && ((result === null || result === void 0 ? void 0 : result.value) instanceof _services_model_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z || !(result === null || result === void 0 ? void 0 : result.value))) {
                        response_1.push(null);
                        return;
                    }
                    response_1.push(result.value);
                });
                userProfile = response_1[0];
                userLevel = response_1[1];
                maritalStatus = 'Empty';
                if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === _UploadResumeModal_type_js__WEBPACK_IMPORTED_MODULE_6__/* .EMaritalStatus.SINGLE */ .oj.SINGLE) {
                    maritalStatus = 'Single';
                }
                else if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === _UploadResumeModal_type_js__WEBPACK_IMPORTED_MODULE_6__/* .EMaritalStatus.MARRIED */ .oj.MARRIED) {
                    maritalStatus = 'Married';
                }
                postHog === null || postHog === void 0 ? void 0 : postHog.identify(user === null || user === void 0 ? void 0 : user.userId.toString(), {
                    is_jobseeker: true,
                    user_id: user === null || user === void 0 ? void 0 : user.userId,
                    resume_id: user === null || user === void 0 ? void 0 : user.resumeId,
                    job_title: user === null || user === void 0 ? void 0 : user.jobTitle,
                    job_level: user === null || user === void 0 ? void 0 : user.jobLevelId,
                    years_experience: user === null || user === void 0 ? void 0 : user.yearExperience,
                    location_city: user === null || user === void 0 ? void 0 : user.locationList,
                    current_jobfunction_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentJobFunction,
                    current_industry_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentIndustries,
                    highest_degree_id: (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.highestDegreeId) !== null && _a !== void 0 ? _a : '',
                    gender: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.genderId) === _UploadResumeModal_type_js__WEBPACK_IMPORTED_MODULE_6__/* .EGender.MALE */ .P2.MALE ? 'Male' : 'Female',
                    marrigal_status: maritalStatus,
                    expected_job_level_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.jobLevelId,
                    is_searchable: !!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.isSearchable),
                    wowcv_template_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.wowcvTemplateId,
                    profile_strength: (_b = userLevel === null || userLevel === void 0 ? void 0 : userLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength,
                    search_setting_id: user === null || user === void 0 ? void 0 : user.searchSettingSortType
                });
                return [3 /*break*/, 4];
            case 3:
                ex_1 = _c.sent();
                console.error('PostHog Error: ', ex_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * This useIdentify function is used to identify a user in PostHog.
 * @param user TAuthUser
 */
var useIdentify = function (user, baseMsUrl, options) {
    var _a;
    // Config
    var intervalTime = (_a = options === null || options === void 0 ? void 0 : options.intervalTime) !== null && _a !== void 0 ? _a : DEFAULT_INTERVAL_CHECK_IDENTIFY;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIdentified = _b[0], setIsIdentified = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isEnable = _c[0], setIsEnable = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSentIdentify = _d[0], setIsSentIdentify = _d[1];
    var intervalIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var clearAllInterval = function () {
        intervalIdRef.current && clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
    };
    var checkingIdentified = function () {
        var _a;
        if (!window.posthog || !window.posthog._isIdentified || typeof window.posthog._isIdentified !== 'function') {
            return;
        }
        var isIdentifiedValue = (_a = window === null || window === void 0 ? void 0 : window.posthog) === null || _a === void 0 ? void 0 : _a._isIdentified();
        // Response value is not a boolean
        if (typeof isIdentifiedValue !== 'boolean') {
            return;
        }
        // Already identified
        if (isIdentifiedValue) {
            setIsIdentified(true);
            // Disable interval
            setIsEnable(false);
            clearAllInterval();
            return;
        }
        // Send identify
        if (!isSentIdentify) {
            sendHogIdentify(window === null || window === void 0 ? void 0 : window.posthog, user, baseMsUrl);
            setIsSentIdentify(true);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!isEnable) {
            clearAllInterval();
            return;
        }
        clearAllInterval();
        intervalIdRef.current = setInterval(checkingIdentified, intervalTime);
        return function () { return clearAllInterval(); };
    }, [isEnable, isSentIdentify, user]);
    return {
        isIdentified: isIdentified
    };
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 32322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K9": function() { return /* binding */ convertKeysToSnakeCase; },
/* harmony export */   "Yt": function() { return /* binding */ generateUuidV4; },
/* harmony export */   "gw": function() { return /* binding */ delay; },
/* harmony export */   "j0": function() { return /* binding */ getPageName; }
/* harmony export */ });
/* unused harmony export camelToSnake */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



function camelToSnake(key) {
    return key.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); });
}
function convertKeysToSnakeCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return convertKeysToSnakeCase(item); });
    }
    else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce(function (acc, key) {
            var snakeKey = camelToSnake(key);
            acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}
function getPageName() {
    if (typeof window === 'undefined') {
        return '';
    }
    var pathname = window.location.pathname;
    // Homepage
    if (pathname === '/') {
        return 'homepage';
    }
    // page-container
    // Search result: All jobs
    if (pathname === '/tim-viec-lam/tim-tat-ca-viec-lam' || pathname === '/job-search/all-jobs') {
        return 'search_results';
    }
    // multiple-job-apply
    if (pathname.match(/^\/ung-tuyen-nhieu-viec-lam/) || pathname.match(/^\/apply-multiple-jobs/)) {
        return 'multiple_job_apply';
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/thong-bao-viec-lam' || pathname === '/my-career-center/my-job-alert') {
        return 'my_job_alert';
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/viec-lam-cua-toi' || pathname === '/my-career-center/my-jobs') {
        return 'my_jobs';
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/cong-ty-cua-toi' || pathname === '/my-career-center/my-companies') {
        return 'my_companies';
    }
    // page-container
    // Search result: filtered jobs
    if (pathname.indexOf('-en') >= 1 && pathname.indexOf('-vn') >= 1) {
        return 'search_results';
    }
    // wealth-container
    if (pathname.match(/^\/muc-luong/) || pathname.match(/^\/salary/)) {
        return 'landing_career_salary';
    }
    // wealth-container
    // Interview Page
    if (pathname.match(/^\/cau-hoi-phong-van/) || pathname.match(/^\/interview/)) {
        return 'interview_page';
    }
    // wow-cv-container
    if (pathname === '/wowcv/en' || pathname === '/wowcv') {
        return 'wow_cv';
    }
    // new-wowcv-container
    if (pathname === '/preview-cv' || pathname === '/xem-truoc') {
        return 'new_wow_cv';
    }
    // marketing-landing-container
    // intech
    if (pathname === '/intech') {
        return 'intech_page';
    }
    // landing-page-container
    // career-newbies
    if (pathname === '/career-newbies') {
        return 'career_newbies';
    }
    // landing-page-container
    if (pathname === '/job-search' || pathname === '/tim-viec-lam') {
        return 'landing_job_search';
    }
    // landing-page-container
    if (pathname.match(/^\/lo-trinh-su-nghiep/) || pathname.match(/^\/career-path/)) {
        return 'landing_career_path';
    }
    // landing-page-container
    if (pathname === '/nhan-so-hoc' || pathname === '/numberology') {
        return 'numerology';
    }
    // landing-page-container
    if (pathname.match(/\/so-chu-dao/) || pathname.match(/\/ruling-number/)) {
        return 'numerology_ruling_number';
    }
    // companyprofile
    if (pathname.indexOf('/company/') >= 0) {
        return 'company_culture_profile';
    }
    // company-container
    if (pathname.match(/\/nha-tuyen-dung/) || pathname.match(/\/companies/)) {
        return 'company_profile';
    }
    // company-container
    if (pathname === '/danh-sach-cong-ty' || pathname === '/company-list') {
        return 'company_profile';
    }
    // job-details
    if (window.location.pathname.match(/\d{6}(-jd|-jv)/)) {
        return 'job_detail';
    }
    // page-container
    if (pathname.match(/\/viec-lam-quan-ly|\/management-jobs/)) {
        return 'search_results';
    }
    // page-container
    if (pathname.match(/-kv|-kw|-i\d{2}|-v\d{2}|jobs|all-jobs|viec-lam|tat-ca-viec-lam|e\d{7}-vn|e\d{7}-en/gi)) {
        return 'search_results';
    }
    // landing-page-container Onboarding
    if (pathname.match(/\/onboarding|\/chao-don-ung-vien-moi/)) {
        return 'onboarding_page';
    }
    // sso
    if (pathname.match(/\/login\/vi|\/login\/en/)) {
        return 'sso';
    }
    // career-center-container
    if (pathname.match(/\/my-career-center|\/quan-ly-nghe-nghiep/)) {
        return 'my_career_center';
    }
    // career-center-container
    if (pathname === '/quan-ly-tai-khoan' || pathname === '/account-settings') {
        return 'account_settings';
    }
    // career-center-container
    if (pathname === '/ho-so' || pathname === '/my-profile') {
        return 'my_profile';
    }
    // vietnamworks
    if (pathname === '/logout' || pathname === '/thoat') {
        return 'logout';
    }
    if (pathname === '/welcome/start' ||
        pathname === '/chao-mung/bat-dau' ||
        pathname === '/welcome/create-profile' ||
        pathname === '/chao-mung/tao-ho-so' ||
        pathname === '/welcome/work-info' ||
        pathname === '/chao-mung/nghe-nghiep' ||
        pathname === '/welcome/skills' ||
        pathname === '/chao-mung/ky-nang' ||
        pathname === '/welcome/experience' ||
        pathname === '/chao-mung/kinh-nghiem' ||
        pathname === '/welcome/contact' ||
        pathname === '/chao-mung/lien-he' ||
        pathname === '/welcome/basic' ||
        pathname === '/chao-mung/co-ban' ||
        pathname === '/welcome/preference' ||
        pathname === '/chao-mung/mong-muon') {
        return 'new-onboarding';
    }
    return pathname;
}
function delay(ms) {
    if (ms === void 0) { ms = 0; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
function generateUuidV4() {
    // Replace x and y in the template with random hexadecimal digits
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
        var random = (Math.random() * 16) | 0;
        // Ensures the 4 and y positions follow the UUIDv4 spec
        var value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 8842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeartFillIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var HeartFillIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#4D8CFF' : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#clip0_7199_169040)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M7.4541 2.8335C4.4416 2.8335 2 5.2751 2 8.2876C2 13.5313 8.08248 18.5417 10.9242 20.7729C10.9269 20.7751 10.9296 20.7773 10.9323 20.7795C10.9518 20.7947 10.9782 20.8165 10.9974 20.8315L10.999 20.8299C11.2873 21.0478 11.6386 21.166 12 21.1668C12.3619 21.1664 12.7138 21.0481 13.0026 20.8299V20.8315C13.0082 20.8271 13.0165 20.8213 13.0221 20.8169C13.0264 20.8135 13.0325 20.8089 13.0368 20.8055C13.0422 20.8007 13.0477 20.7958 13.0531 20.7909C15.8859 18.5676 22 13.5438 22 8.2876C22 5.2751 19.5584 2.8335 16.5459 2.8335C13.6667 2.8335 12 5.3335 12 5.3335C12 5.3335 10.3333 2.8335 7.4541 2.8335Z', fill: color })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'clip0_7199_169040' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: '20', height: '20', fill: 'white', transform: 'translate(2 2)' })))));
};
var HeartFillIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(HeartFillIcon);


//# sourceMappingURL=HeartFillIcon.js.map


/***/ }),

/***/ 91867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PreviewJob; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/Images/HeartFillIcon.js
var HeartFillIcon = __webpack_require__(8842);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/Images/HeartIcon.js
'use client';



var HeartIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_7199_169050)' },
            react.createElement("path", { d: 'M7.80379 2.8335C4.60737 2.8335 2 5.44087 2 8.63728C2 11.5128 4.23119 14.4371 6.35397 16.7713C8.47674 19.1055 10.5938 20.8098 10.5938 20.8098C10.6002 20.8149 10.6067 20.8199 10.6133 20.8248C10.956 21.0836 11.386 21.2518 11.8528 21.283C11.9013 21.2917 11.9506 21.2958 12 21.295C12.0488 21.2957 12.0976 21.2916 12.1457 21.283C12.1482 21.2825 12.1507 21.282 12.1532 21.2815C12.6176 21.2492 13.0455 21.0825 13.3867 20.8248C13.3933 20.8199 13.3998 20.8149 13.4063 20.8098C13.4063 20.8098 15.5233 19.1055 17.646 16.7713C19.7688 14.4371 22 11.5128 22 8.63728C22 5.44087 19.3926 2.8335 16.1962 2.8335C14.1854 2.8335 12.7615 3.94007 12 4.72352C11.2385 3.94007 9.81458 2.8335 7.80379 2.8335ZM7.80379 4.37196C9.90471 4.37196 11.1829 6.09692 11.3104 6.2755C11.3755 6.40086 11.4739 6.50586 11.5947 6.57901C11.7156 6.65215 11.8542 6.69061 11.9955 6.69017C12.0015 6.69024 12.0075 6.69024 12.0135 6.69017C12.0195 6.68974 12.0255 6.68924 12.0316 6.68866C12.0511 6.68791 12.0707 6.68641 12.0901 6.68416C12.2151 6.67044 12.3349 6.62629 12.4389 6.55557C12.5428 6.48485 12.6279 6.38972 12.6866 6.27851C12.8076 6.1085 14.0893 4.37196 16.1962 4.37196C18.5613 4.37196 20.4615 6.27216 20.4615 8.63728C20.4615 10.6394 18.5383 13.5028 16.5072 15.7361C14.4831 17.9619 12.4675 19.5877 12.4537 19.5988C12.3186 19.6994 12.1685 19.7566 12 19.7566C11.8315 19.7566 11.6814 19.6994 11.5463 19.5988C11.5325 19.5877 9.51695 17.9619 7.49279 15.7361C5.46172 13.5028 3.53846 10.6394 3.53846 8.63728C3.53846 6.27216 5.43866 4.37196 7.80379 4.37196Z', fill: '#4D8CFF' })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_7199_169050' },
                react.createElement("rect", { width: '20', height: '20', fill: 'white', transform: 'translate(2 2)' })))));
};
var HeartIcon$1 = react.memo(HeartIcon);


//# sourceMappingURL=HeartIcon.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/PreviewJob.css.js
'use client';






var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    h2 {\n        font-size: 16px;\n        font-weight: 500;\n        margin: 0 24px 0 0;\n        line-height: 20px;\n    }\n"], ["\n    h2 {\n        font-size: 16px;\n        font-weight: 500;\n        margin: 0 24px 0 0;\n        line-height: 20px;\n    }\n"])));
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var Popup = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 522px;\n        position: absolute;\n        top: ", ";\n        bottom: ", ";\n        left: ", ";\n        right: ", ";\n        z-index: 1098;\n        opacity: 0;\n    "], ["\n        width: 522px;\n        position: absolute;\n        top: ", ";\n        bottom: ", ";\n        left: ", ";\n        right: ", ";\n        z-index: 1098;\n        opacity: 0;\n    "])), function (_a) {
        var top = _a.top;
        return (top > 0 ? "".concat(top, "px") : "");
    }, function (_a) {
        var bottom = _a.bottom;
        return (bottom > 0 ? "".concat(bottom, "px") : "");
    }, function (_a) {
        var left = _a.left;
        return (left > 0 ? "".concat(left, "px") : "");
    }, function (_a) {
        var right = _a.right;
        return (right > 0 ? "".concat(right, "px") : "");
    }),
    Wrapper: styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        background: white;\n        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);\n        border-radius: 12px;\n    "], ["\n        background: white;\n        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);\n        border-radius: 12px;\n    "]))),
    Header: styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px 16px 0 16px;\n        display: flex;\n        align-items: center;\n        gap: 16px;\n    "], ["\n        padding: 24px 16px 0 16px;\n        display: flex;\n        align-items: center;\n        gap: 16px;\n    "]))),
    Logo: styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 64px;\n        height: 64px;\n        display: flex;\n        border-radius: 10px;\n        overflow: hidden;\n\n        img {\n            object-fit: contain;\n            width: 64px;\n            height: 64px;\n        }\n    "], ["\n        width: 64px;\n        height: 64px;\n        display: flex;\n        border-radius: 10px;\n        overflow: hidden;\n\n        img {\n            object-fit: contain;\n            width: 64px;\n            height: 64px;\n        }\n    "]))),
    Content: styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: calc(100% - 80px);\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        p {\n            margin: 0;\n\n            span {\n                color: ", ";\n            }\n            &.address {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                max-width: calc(100% - 20px);\n            }\n        }\n    "], ["\n        width: calc(100% - 80px);\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        p {\n            margin: 0;\n\n            span {\n                color: ", ";\n            }\n            &.address {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                max-width: calc(100% - 20px);\n            }\n        }\n    "])), constants/* colors.buttonColor */.O9.buttonColor),
    Title: styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        color: ", ";\n        transition: all 0.25s;\n        cursor: pointer;\n\n        &:hover {\n            color: ", ";\n        }\n    "], ["\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        color: ", ";\n        transition: all 0.25s;\n        cursor: pointer;\n\n        &:hover {\n            color: ", ";\n        }\n    "])), constants/* colors.textColor */.O9.textColor, constants/* colors.buttonColor */.O9.buttonColor),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 16px;\n        padding: 12px 16px;\n        background-color: #f9f9f9;\n        border-radius: 8px;\n        line-height: 1.5;\n    "], ["\n        margin: 16px;\n        padding: 12px 16px;\n        background-color: #f9f9f9;\n        border-radius: 8px;\n        line-height: 1.5;\n    "]))),
    BodyContent: styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        overflow: auto;\n        overscroll-behavior: contain;\n\n        ", "\n\n        > p {\n            font-weight: 500;\n            margin: 0;\n        }\n    "], ["\n        overflow: auto;\n        overscroll-behavior: contain;\n\n        ", "\n\n        > p {\n            font-weight: 500;\n            margin: 0;\n        }\n    "])), styledCss/* default.scrollbar */.ZP.scrollbar),
    BodyViewDetail: styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        a {\n            color: ", ";\n            transition: all 0.25s;\n            cursor: pointer;\n\n            &:hover {\n                color: ", ";\n            }\n        }\n    "], ["\n        a {\n            color: ", ";\n            transition: all 0.25s;\n            cursor: pointer;\n\n            &:hover {\n                color: ", ";\n            }\n        }\n    "])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor),
    JobInvitation: styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 0 16px;\n        margin-bottom: 16px;\n    "], ["\n        padding: 0 16px;\n        margin-bottom: 16px;\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 0 16px 24px 16px;\n        display: flex;\n        gap: 16px;\n\n        ", "\n    "], ["\n        padding: 0 16px 24px 16px;\n        display: flex;\n        gap: 16px;\n\n        ", "\n    "])), function (_a) {
        var isApplied = _a.isApplied;
        if (!isApplied) {
            return '';
        }
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                padding: 0;\n            "], ["\n                padding: 0;\n            "])));
    }),
    SaveButton: styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        position: relative;\n        background: #f2f7ff;\n        border-radius: 8px;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        ", "\n    "], ["\n        position: relative;\n        background: #f2f7ff;\n        border-radius: 8px;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        ", "\n    "])), function (_a) {
        var disabled = _a.disabled;
        return disabled && (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                pointer-events: none;\n                opacity: 0.5;\n            "], ["\n                pointer-events: none;\n                opacity: 0.5;\n            "])));
    }),
    IconButton: styled_components_browser_esm/* default.div */.ZP.div(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        opacity: ", ";\n        transition: 0.25s;\n    "], ["\n        display: flex;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        opacity: ", ";\n        transition: 0.25s;\n    "])), function (_a) {
        var show = _a.show;
        return (show ? 1 : 0);
    })
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;


//# sourceMappingURL=PreviewJob.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/constant.js
'use client';

var SUCCESS_CODE = 200;


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/services.js
'use client';



var apiSaveJob = function (data) {
    if (data === void 0) { data = {
        postData: {
            jobId: -1
        },
        accessToken: '',
        language: 'vi',
        baseUrl: ''
    }; }
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var apiUrl, savedJobResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = data.baseUrl + '/api-gateway/v1.0/save-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': data.language
                            },
                            body: JSON.stringify(data.postData)
                        })];
                case 1:
                    savedJobResponse = _a.sent();
                    return [4 /*yield*/, savedJobResponse.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
var apiUnsavedJob = function (data) {
    if (data === void 0) { data = {
        postData: {
            jobId: -1
        },
        accessToken: '',
        language: 'vi',
        baseUrl: ''
    }; }
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var apiUrl, savedJobResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = data.baseUrl + '/api-gateway/v1.0/unsave-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': data.language
                            },
                            body: JSON.stringify(data.postData)
                        })];
                case 1:
                    savedJobResponse = _a.sent();
                    return [4 /*yield*/, savedJobResponse.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/translation.js
'use client';

var translation = {
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    'Job Description': 'Mô tả công việc',
    'Job Requirements': 'Yêu cầu công việc',
    'View detail': 'Xem chi tiết',
    Applied: 'Đã Nộp Đơn',
    'Apply Now': 'Nộp Đơn',
    Success: 'Thành công',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Accept invitation': 'Chấp nhận lời mời',
    'Employer has sent you an invitation.': 'Nhà tuyển dụng đã gửi lời mời ứng tuyển.'
};


//# sourceMappingURL=translation.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/JobCard.css.js
var JobCard_css = __webpack_require__(8203);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(36802);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/types.js
var types = __webpack_require__(36615);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MailAddIcon/index.js
var MailAddIcon = __webpack_require__(29082);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/index.js
'use client';



















var isWindow = typeof window !== 'undefined';
var PreviewJob = function (props) {
    var children = props.children, content = props.content, langCode = props.langCode, onSaveClick = props.onSaveClick, onApplyClick = props.onApplyClick, classContainer = props.classContainer, api = props.api, isLogin = props.isLogin, _a = props.isNLDPage, isNLDPage = _a === void 0 ? false : _a;
    var debounceTimeShow = (0,react.useState)(500)[0];
    var debounceTimeHide = (0,react.useState)(200)[0];
    var debounceShow = (0,react.useRef)(null);
    var debounceHide = (0,react.useRef)(null);
    var eventInfo = (0,react.useRef)(null);
    var _b = (0,react.useState)(!!content.isSaved), isSaved = _b[0], setSaved = _b[1];
    var _c = (0,react.useState)(false), showPopup = _c[0], setShowPopup = _c[1];
    var _d = (0,react.useState)({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }), positionPopup = _d[0], setPositionPopup = _d[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var containerRef = (0,react.useRef)(null);
    var popupRef = (0,react.useRef)(null);
    var isSavedStatus = (api === null || api === void 0 ? void 0 : api.disableSelfApi) ? !!content.isSaved : isSaved;
    var maxBodyHeight = isWindow ? window.screen.height / 5 : 280;
    var t = function (key) {
        if (langCode === constants/* ELanguage.VI */.Df.VI) {
            return translation[key] || key;
        }
        else {
            return key;
        }
    };
    var showLoginModal = function () {
        if (!isWindow) {
            return;
        }
        setShowPopup(false);
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'
            }
        });
        window.dispatchEvent(loginEvent);
    };
    var handleUnsavedJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var responseResult;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isLogin) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    if (api === null || api === void 0 ? void 0 : api.disableSelfApi) {
                        onSaveClick && onSaveClick();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiUnsavedJob({
                            postData: { jobId: content.jobId || -1 },
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    responseResult = _b.sent();
                    if (((_a = responseResult === null || responseResult === void 0 ? void 0 : responseResult.meta) === null || _a === void 0 ? void 0 : _a.code) === SUCCESS_CODE) {
                        setSaved(false);
                        (0,Toast/* showToast */.CF)(t('Success'), t('Just removed 1 save job'));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var saveJobResponse;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!isLogin) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    if (api === null || api === void 0 ? void 0 : api.disableSelfApi) {
                        onSaveClick && onSaveClick();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiSaveJob({
                            postData: { jobId: content.jobId || -1 },
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    saveJobResponse = _c.sent();
                    if (((_a = saveJobResponse === null || saveJobResponse === void 0 ? void 0 : saveJobResponse.meta) === null || _a === void 0 ? void 0 : _a.code) === SUCCESS_CODE) {
                        tracking({
                            eventName: 'js_job_management:save_job_click',
                            properties: {
                                jobId: (_b = content === null || content === void 0 ? void 0 : content.jobId) !== null && _b !== void 0 ? _b : -1,
                                pageZone: 'preview'
                            }
                        });
                        setSaved(true);
                        (0,Toast/* showToast */.CF)(t('Success'), react.createElement("div", null,
                            t('You have saved job, view'),
                            ' ',
                            react.createElement("a", { href: t('/my-career-center/my-jobs?section=saved') }, t('My jobs'))));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleApplyClick = function () {
        if (isNLDPage) {
            window.location.assign(content.link);
            return;
        }
        if (!isLogin) {
            showLoginModal();
            return;
        }
        if (content.redirectTo) {
            window.location.assign(content.redirectTo);
            return;
        }
        onApplyClick();
        setShowPopup(false);
    };
    var debounceShowPopup = function (e) {
        if (debounceHide.current)
            clearTimeout(debounceHide.current);
        debounceShow.current = setTimeout(function () {
            eventInfo.current = e;
            setShowPopup(true);
        }, debounceTimeShow);
    };
    var debounceHidePopup = function () {
        if (debounceShow.current)
            clearTimeout(debounceShow.current);
        debounceHide.current = setTimeout(function () {
            eventInfo.current = null;
            setShowPopup(false);
        }, debounceTimeHide);
    };
    (0,react.useEffect)(function () {
        setSaved(content.isSaved);
    }, [content.isSaved]);
    (0,react.useEffect)(function () {
        var _a, _b;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', function (e) { return debounceShowPopup(e); });
        (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', debounceHidePopup);
    }, []);
    (0,react.useEffect)(function () {
        var _a, _b, _c, _d;
        if (showPopup && eventInfo.current && popupRef.current) {
            (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', function (e) { return debounceShowPopup(e); });
            (_b = popupRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', debounceHidePopup);
            var e = eventInfo.current;
            var position = {
                left: 0,
                top: 0,
                bottom: 0,
                right: 0
            };
            if (e.clientY > window.innerHeight / 2) {
                position.top = e.pageY - ((_c = popupRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight);
            }
            else {
                position.top = e.pageY;
            }
            if (e.clientX > window.innerWidth / 2) {
                position.left = e.pageX - ((_d = popupRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth) - 20;
            }
            else {
                position.left = e.pageX + 20;
            }
            setPositionPopup(position);
            popupRef.current.style.opacity = '1';
        }
    }, [showPopup]);
    var renderPopup = function () {
        var _a, _b, _c, _d, _e;
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            return react_dom.createPortal(react.createElement(Popup.Container, { ref: popupRef, left: positionPopup.left, top: positionPopup.top, bottom: positionPopup.bottom, right: positionPopup.right },
                content.isApplied && react.createElement(JobCard_css/* Widget.AppliedBadge */.$L.AppliedBadge, { isPreviewJob: true }, t('Applied')),
                react.createElement(Popup.Wrapper, null,
                    react.createElement(Popup.Header, null,
                        react.createElement(Popup.Logo, null,
                            react.createElement("img", { src: content.logo || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'logo' })),
                        react.createElement(Popup.Content, null,
                            react.createElement("a", { href: content.link, target: '_blank', onClick: function () { return setShowPopup(false); } },
                                react.createElement(Popup.Title, null, content.title)),
                            react.createElement("p", null,
                                react.createElement("span", null, content.salary),
                                content.jobLevel && " | ".concat(content.jobLevel)),
                            react.createElement("p", { className: 'address' }, content.address))),
                    react.createElement(Popup.Body, null,
                        react.createElement(Popup.BodyContent, { style: { maxHeight: maxBodyHeight } },
                            content.jobDescription && (react.createElement(react.Fragment, null,
                                react.createElement("p", null,
                                    t('Job Description'),
                                    ":"),
                                react.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: content.jobDescription.replace(/\r\n/g, '<br />') || ''
                                    } }))),
                            content.jobRequirements && (react.createElement(react.Fragment, null,
                                react.createElement("p", { style: { marginTop: 8 } },
                                    t('Job Requirements'),
                                    ":"),
                                react.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: ((_a = content.jobRequirements) === null || _a === void 0 ? void 0 : _a.replace(/\r\n/g, '<br />')) || ''
                                    } })))),
                        content.link && (react.createElement(Popup.BodyViewDetail, null,
                            react.createElement("a", { href: content.link, target: '_blank' },
                                react.createElement("p", { style: { margin: '6px 0 0 0' } }, t('View detail')))))),
                    props.content.jobInvitation &&
                        ((_b = props.content) === null || _b === void 0 ? void 0 : _b.jobInvitation.jobInvitationId) > 0 &&
                        ((_c = props.content) === null || _c === void 0 ? void 0 : _c.jobInvitation.status) === types/* EJobInvitationStatus.WAITING */.Z.WAITING ? (react.createElement(Popup.JobInvitation, null,
                        react.createElement(JobCard_css/* JobInvitationBlock */.Fk, null,
                            react.createElement(MailAddIcon/* default */.Z, null),
                            react.createElement("span", null, t('Employer has sent you an invitation.'))))) : null,
                    react.createElement(Popup.Footer, { isApplied: content.isApplied },
                        !content.isApplied && !isNLDPage && (react.createElement(Popup.SaveButton, { onClick: isSavedStatus ? handleUnsavedJob : handleSaveJob },
                            react.createElement(Popup.IconButton, { show: true },
                                react.createElement(HeartIcon$1, null)),
                            react.createElement(Popup.IconButton, { show: !!isSavedStatus },
                                react.createElement(HeartFillIcon/* default */.Z, null)))),
                        !content.isApplied && (react.createElement(Button/* default */.Z, { className: 'apply-btn', type: 'primary', style: { flex: 1, cursor: 'pointer' }, disabled: content.isBlackList, onClick: handleApplyClick }, props.content.jobInvitation &&
                            ((_d = props.content) === null || _d === void 0 ? void 0 : _d.jobInvitation.jobInvitationId) > 0 &&
                            ((_e = props.content) === null || _e === void 0 ? void 0 : _e.jobInvitation.status) === types/* EJobInvitationStatus.WAITING */.Z.WAITING
                            ? t('Accept invitation')
                            : t('Apply Now')))))), bodyNode);
        }
        else {
            return null;
        }
    };
    return (react.createElement(Container, { "data-cname": 'preview-job', ref: containerRef, className: classContainer },
        react.createElement(Wrapper, { onClick: function () { return setShowPopup(false); } }, children),
        showPopup && renderPopup()));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 52665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReportCompanyModal; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/index.js + 1 modules
var CheckBox = __webpack_require__(95140);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LoadingIcon/index.js
var LoadingIcon = __webpack_require__(50293);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveIcon/index.js
var RemoveIcon = __webpack_require__(10786);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LimitedTextarea/index.js + 1 modules
var LimitedTextarea = __webpack_require__(21221);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/helper.js
'use client';

var EventHelper = /** @class */ (function () {
    function EventHelper() {
        this.on = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.addEventListener(eventName, handler);
            }
        };
        this.off = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventName, handler);
            }
        };
        this.emit = function (eventName, pamarater) {
            if (typeof window !== 'undefined') {
                var event_1 = new CustomEvent(eventName, pamarater);
                window.dispatchEvent(event_1);
            }
        };
    }
    return EventHelper;
}());
var eventHelper = new EventHelper();


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/hooks.js
'use client';



var ReportCompanyModalContext = react.createContext({
    data: null,
    language: '',
    useGlobalToast: false,
    t: function (text) { return ''; },
    locationClassName: "",
});
var useReportCompany = function () { return (0,react.useContext)(ReportCompanyModalContext); };


//# sourceMappingURL=hooks.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/services.js
'use client';



var getReportList = function (url, tokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headerData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: headerData
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var makeReport = function (postData, url, tokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headerData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: headerData,
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var reportCompanyService = {
    getReportList: getReportList,
    makeReport: makeReport
};


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/styles.css.js
'use client';







var BORDER_COLOR_PRIMARY = '#B3CEFF';
var WHITE_COLOR = '#FFFFFF';
var TEXT_COLOR = '#333333';
var LINK_COLOR = '#005AFF';
var PRIMARY_COLOR = '#FF7D55';
var BORDER_COLOR = '#D9D9D9';
var BORDER_COLOR_DISBALE = '#FFCBBB';
var BACKGROUND_COLOR_DISABLE = '#FFF9F7';
styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    background: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n"], ["\n    width: 100%;\n    background: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n"])), WHITE_COLOR, BORDER_COLOR_PRIMARY);
styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
styled_components_browser_esm/* default.p */.ZP.p(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-transform: uppercase;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    margin: 0px 0px 16px 0px;\n    color: ", ";\n    margin-bottom: 20px;\n    font-weight: 700;\n"], ["\n    text-transform: uppercase;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    margin: 0px 0px 16px 0px;\n    color: ", ";\n    margin-bottom: 20px;\n    font-weight: 700;\n"])), TEXT_COLOR);
styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 32px;\n    width: 100%;\n"], ["\n    margin-bottom: 32px;\n    width: 100%;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
styled_components_browser_esm/* default.img */.ZP.img(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 186px;\n    object-fit: contain;\n    margin-bottom: 24px;\n"], ["\n    width: 100%;\n    height: 186px;\n    object-fit: contain;\n    margin-bottom: 24px;\n"])));
styled_components_browser_esm/* default.p */.ZP.p(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    margin-bottom: 8px;\n    font-size: 20px;\n    color: ", ";\n    font-weight: 700;\n    line-height: 24px;\n    text-align: center;\n"], ["\n    margin: 0;\n    margin-bottom: 8px;\n    font-size: 20px;\n    color: ", ";\n    font-weight: 700;\n    line-height: 24px;\n    text-align: center;\n"])), TEXT_COLOR);
styled_components_browser_esm/* default.p */.ZP.p(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 400;\n    line-height: 22px;\n    text-align: center;\n"], ["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 400;\n    line-height: 22px;\n    text-align: center;\n"])), TEXT_COLOR);
styled_components_browser_esm/* default.a */.ZP.a(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 500;\n    line-height: 22px;\n    text-align: center;\n"], ["\n    margin: 0;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 500;\n    line-height: 22px;\n    text-align: center;\n"])), LINK_COLOR);
(0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n    border-radius: 6px;\n    :hover,\n    :active,\n    :focus {\n        background-color: ", " !important;\n        border-color: ", " !important;\n        border: 1px solid ", " !important;\n        color: ", " !important;\n    }\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        opacity: 0.5;\n        pointer-events: none;\n        background-color: ", " !important;\n        color: ", " !important;\n        border-color: ", " !important;\n    }\n"], ["\n    width: 100%;\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n    border-radius: 6px;\n    :hover,\n    :active,\n    :focus {\n        background-color: ", " !important;\n        border-color: ", " !important;\n        border: 1px solid ", " !important;\n        color: ", " !important;\n    }\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        opacity: 0.5;\n        pointer-events: none;\n        background-color: ", " !important;\n        color: ", " !important;\n        border-color: ", " !important;\n    }\n"])), PRIMARY_COLOR, PRIMARY_COLOR, WHITE_COLOR, WHITE_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, BACKGROUND_COLOR_DISABLE, PRIMARY_COLOR, BORDER_COLOR_DISBALE);
var ReportCompanyDialog = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: ", ";\n        height: 100%;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n    "], ["\n        border-radius: 12px;\n        background: ", ";\n        height: 100%;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n    "])), WHITE_COLOR),
    Header: styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        border-bottom: 1px solid ", ";\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    "], ["\n        padding: 24px;\n        border-bottom: 1px solid ", ";\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    "])), BORDER_COLOR),
    Title: styled_components_browser_esm/* default.p */.ZP.p(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n    "], ["\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n    "])), TEXT_COLOR),
    Action: styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        cursor: pointer;\n    "], ["\n        cursor: pointer;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        overflow-y: scroll;\n    "], ["\n        padding: 24px;\n        overflow-y: scroll;\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 0px 24px 24px 24px;\n    "], ["\n        padding: 0px 24px 24px 24px;\n    "]))),
    Button: (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        text-align: center;\n    "], ["\n        width: 100%;\n        text-align: center;\n    "]))),
    TextError: styled_components_browser_esm/* default.span */.ZP.span(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])))
};
var Company = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        align-items: center;\n    "], ["\n        display: flex;\n        align-items: center;\n    "]))),
    Image: styled_components_browser_esm/* default.img */.ZP.img(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 44px;\n        height: 44px;\n        border-radius: 4px;\n        border: 1px solid ", ";\n        margin-right: 16px;\n    "], ["\n        width: 44px;\n        height: 44px;\n        border-radius: 4px;\n        border: 1px solid ", ";\n        margin-right: 16px;\n    "])), BORDER_COLOR),
    Wrapper: styled_components_browser_esm/* default.div */.ZP.div(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""]))),
    Name: styled_components_browser_esm/* default.p */.ZP.p(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        margin-bottom: 4px;\n        font-size: 16px;\n        font-weight: 500;\n        color: ", ";\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "], ["\n        margin: 0;\n        margin-bottom: 4px;\n        font-size: 16px;\n        font-weight: 500;\n        color: ", ";\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "])), TEXT_COLOR),
    Description: styled_components_browser_esm/* default.a */.ZP.a(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        &:hover {\n            color: ", ";\n        }\n        &:visited {\n            color: ", ";\n            &:hover {\n                color: ", ";\n            }\n        }\n    "], ["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        &:hover {\n            color: ", ";\n        }\n        &:visited {\n            color: ", ";\n            &:hover {\n                color: ", ";\n            }\n        }\n    "])), LINK_COLOR, constants/* colors.buttonColor */.O9.buttonColor, LINK_COLOR, constants/* colors.buttonColor */.O9.buttonColor),
    AnonymousCompany: styled_components_browser_esm/* default.p */.ZP.p(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "], ["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "])), LINK_COLOR)
};
var Reason = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 16px 0 16px -8px;\n    "], ["\n        margin: 16px 0 16px -8px;\n    "]))),
    Skeleton: (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-bottom: 10px;\n    "], ["\n        margin-bottom: 10px;\n    "]))),
    SkeletonContainer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 16px 0px;\n    "], ["\n        margin: 16px 0px;\n    "])))
};
var ReportCompanySuccess = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: ", ";\n        padding: 24px;\n    "], ["\n        border-radius: 12px;\n        background: ", ";\n        padding: 24px;\n    "])), WHITE_COLOR),
    Header: styled_components_browser_esm/* default.div */.ZP.div(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    "], ["\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-top: 24px;\n    "], ["\n        margin-top: 24px;\n    "]))),
    Action: styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        cursor: pointer;\n    "], ["\n        cursor: pointer;\n    "]))),
    Button: (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        text-align: center;\n        background-color: ", ";\n        color: ", ";\n        border: 1px solid ", ";\n        :hover {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            color: ", " !important;\n        }\n        :focus,\n        :active {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            box-shadow: 0 0 0 1px ", " !important;\n            color: ", " !important;\n        }\n        &.btn-disabled,\n        &[disabled] {\n            cursor: not-allowed;\n            opacity: 0.5;\n            pointer-events: none;\n            background-color: ", " !important;\n            color: ", " !important;\n            border: 1px solid ", " !important;\n        }\n    "], ["\n        width: 100%;\n        text-align: center;\n        background-color: ", ";\n        color: ", ";\n        border: 1px solid ", ";\n        :hover {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            color: ", " !important;\n        }\n        :focus,\n        :active {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            box-shadow: 0 0 0 1px ", " !important;\n            color: ", " !important;\n        }\n        &.btn-disabled,\n        &[disabled] {\n            cursor: not-allowed;\n            opacity: 0.5;\n            pointer-events: none;\n            background-color: ", " !important;\n            color: ", " !important;\n            border: 1px solid ", " !important;\n        }\n    "])), PRIMARY_COLOR, WHITE_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, WHITE_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, WHITE_COLOR, BACKGROUND_COLOR_DISABLE, PRIMARY_COLOR, BORDER_COLOR_DISBALE),
    IconWrapper: styled_components_browser_esm/* default.div */.ZP.div(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    "], ["\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    "]))),
    Title: styled_components_browser_esm/* default.p */.ZP.p(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 30px 0px 0px 0px;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n        text-align: center;\n    "], ["\n        margin: 30px 0px 0px 0px;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n        text-align: center;\n    "])), TEXT_COLOR),
    Description: styled_components_browser_esm/* default.p */.ZP.p(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 8px 0px 0px 0px;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-align: center;\n    "], ["\n        margin: 8px 0px 0px 0px;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-align: center;\n    "])), TEXT_COLOR)
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36;


//# sourceMappingURL=styles.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/ReportCompanyDialog.js
'use client';















var LIMIT_TEXT = 500;
var OPEN_REPORT_DIALOG = 'open-report-company-dialog';
var CLOSE_REPORT_DIALOG = 'close-report-company-dialog';
var DEFAULT_COMPANY_LOGO = 'img/company-default-logo.svg';
var otherReasonID = 1;
var openReportDialog = function (locationClassName) {
    return new Promise(function (resolve) {
        eventHelper.emit("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function (e) {
            resolve(e.detail);
        });
    });
};
var ReportCompanyDialog_ReportCompanyDialog = function () {
    var _a, _b;
    var _c = useReportCompany(), data = _c.data, language = _c.language, t = _c.t, locationClassName = _c.locationClassName;
    var _d = (0,react.useState)(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = (0,react.useState)([]), reasonsSelected = _e[0], setReasonsSelected = _e[1];
    var _f = (0,react.useState)([]), reasons = _f[0], setReasons = _f[1];
    var _g = (0,react.useState)(false), isLoadingFetchReasons = _g[0], setIsLoadingFetchReason = _g[1];
    var _h = (0,react.useState)(false), isLoadingReportCompany = _h[0], setIsLoadingReportCompany = _h[1];
    var _j = (0,react.useState)(''), detailDescription = _j[0], setDetailDescription = _j[1];
    var _k = (0,react.useState)(false), isShowButton = _k[0], setIsShowButton = _k[1];
    var _l = (0,react.useState)(false), isShowError = _l[0], setIsShowError = _l[1];
    var handleClose = function (status) {
        if (status === void 0) { status = false; }
        setIsOpen(false);
        setDetailDescription('');
        setIsShowButton(false);
        setIsShowError(false);
        eventHelper.emit("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), {
            detail: status
        });
    };
    var fetchReasons = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingFetchReason(true);
                    if (!(data === null || data === void 0 ? void 0 : data.apiTokenAccess)) return [3 /*break*/, 2];
                    return [4 /*yield*/, reportCompanyService.getReportList("".concat(data.apiGetway, "/company/report-reasons"), data.apiTokenAccess)];
                case 1:
                    response = _a.sent();
                    setReasons((response === null || response === void 0 ? void 0 : response.data) || []);
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingFetchReason(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    (0,react.useEffect)(function () {
        if (isOpen && reasons.length === 0) {
            fetchReasons();
        }
    }, [isOpen]);
    var handleReportCompany = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var postData, reportCompanyResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (detailDescription.length === 0) {
                        setIsShowError(true);
                        return [2 /*return*/];
                    }
                    if (detailDescription.length > LIMIT_TEXT) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoadingReportCompany(true);
                    postData = {
                        reasonIds: reasonsSelected,
                        description: detailDescription,
                        companyId: data === null || data === void 0 ? void 0 : data.company.companyId,
                        userId: data === null || data === void 0 ? void 0 : data.userId
                    };
                    return [4 /*yield*/, reportCompanyService.makeReport(postData, "".concat(data === null || data === void 0 ? void 0 : data.apiGetway, "/company/report"), (data === null || data === void 0 ? void 0 : data.apiTokenAccess) || '')];
                case 2:
                    reportCompanyResponse = _a.sent();
                    if ((reportCompanyResponse === null || reportCompanyResponse === void 0 ? void 0 : reportCompanyResponse.success) === true) {
                        handleClose(true);
                    }
                    else {
                        (0,Toast/* showToast */.CF)(t('Report Company error'), t("Can't update this Report Company"), Toast/* TOAST_TYPE_ERROR */.rn);
                        handleClose(false);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a.sent();
                    (0,Toast/* showToast */.CF)(t('Report Company error'), t("Can't update this Report Company"), Toast/* TOAST_TYPE_ERROR */.rn);
                    handleClose(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingReportCompany(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleReasonChecked = function (checked, item) {
        var myReasonList = reasonsSelected;
        if (checked) {
            myReasonList.push(item.reasonId);
        }
        else {
            myReasonList = myReasonList.filter(function (reason) { return reason !== item.reasonId; });
        }
        if (item.reasonId === otherReasonID) {
            if (isShowError && !checked) {
                setIsShowError(false);
            }
        }
        if (myReasonList.length === 0) {
            setIsShowButton(false);
        }
        else {
            setIsShowButton(true);
        }
        setReasonsSelected(myReasonList);
    };
    var getInputText = function (text) {
        var finalText = text.trim();
        if (finalText.length > 0) {
            setIsShowError(false);
        }
        setDetailDescription(finalText);
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(Popup/* default */.Z, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, custom: {
                footer: react.createElement(react.Fragment, null),
                header: react.createElement(react.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            react.createElement(ReportCompanyDialog.Container, null,
                react.createElement(ReportCompanyDialog.Header, null,
                    react.createElement(ReportCompanyDialog.Title, null, t('Report company')),
                    react.createElement(ReportCompanyDialog.Action, { onClick: function () { return handleClose(); } },
                        react.createElement(RemoveIcon/* default */.Z, null))),
                react.createElement(ReportCompanyDialog.Body, null,
                    react.createElement(Company.Container, null,
                        react.createElement(Company.Image, { src: ((_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.companyLogo) || "".concat(data === null || data === void 0 ? void 0 : data.imagesService, "/").concat(DEFAULT_COMPANY_LOGO) }),
                        react.createElement(Company.Wrapper, null,
                            react.createElement(Company.Name, null, (_b = data === null || data === void 0 ? void 0 : data.company) === null || _b === void 0 ? void 0 : _b.companyName))),
                    isLoadingFetchReasons && (react.createElement(Reason.SkeletonContainer, null, new Array(9).fill(1).map(function (_, index) {
                        return react.createElement(Reason.Skeleton, { height: 28, key: index });
                    }))),
                    !isLoadingFetchReasons && reasons.length > 0 && (react.createElement(Reason.Container, null, reasons.map(function (item, index) { return (react.createElement(CheckBox/* default */.Z, { label: language === 'vi' ? item.reasonVi : item.reasonEn, onCheckChange: function (checked) { return handleReasonChecked(checked === 'checked', item); }, key: "report-company-checkbox-".concat(index) })); }))),
                    react.createElement(LimitedTextarea/* default */.Z, { rows: 4, limit: LIMIT_TEXT, value: detailDescription, language: language, inputText: getInputText, placeholder: t('Details of the reason.') }),
                    isShowError && (react.createElement(ReportCompanyDialog.TextError, { className: 'text-danger', style: {
                            marginTop: 8
                        } }, t('Please input detail description.')))),
                react.createElement(ReportCompanyDialog.Footer, null,
                    react.createElement(ReportCompanyDialog.Button, { onClick: handleReportCompany, type: "primary", disabled: !isShowButton },
                        isLoadingReportCompany && react.createElement(LoadingIcon/* default */.Z, { bgColor: constants/* colors.bgNormal */.O9.bgNormal }),
                        react.createElement("span", { style: {
                                marginLeft: isLoadingReportCompany ? 8 : 0
                            } }, t('Send'))))))));
};


//# sourceMappingURL=ReportCompanyDialog.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/icons.js
'use client';



var IconSuccess = function () {
    return (react.createElement("svg", { width: '66px', height: '66px', viewBox: '0 0 66 66', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: '\u27A4-Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Company-Detail---Report-Popup---Thanks', transform: 'translate(-650.000000, -301.000000)', fill: '#00B70B', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Popup', transform: 'translate(451.000000, 253.000000)' },
                    react.createElement("g", { id: 'Body', transform: 'translate(15.000000, 48.000000)' },
                        react.createElement("g", { id: 'icons8-checked', transform: 'translate(184.000000, 0.000000)' },
                            react.createElement("path", { d: 'M33,0 C14.804688,0 0,14.804688 0,33 C0,51.195313 14.804688,66 33,66 C51.195313,66 66,51.195313 66,33 C66,27.417969 64.601563,22.160156 62.144531,17.546875 L60.648438,19.007813 C62.785156,23.214844 64,27.96875 64,33 C64,50.09375 50.09375,64 33,64 C15.90625,64 2,50.09375 2,33 C2,15.90625 15.90625,2 33,2 C41.789063,2 49.726563,5.679688 55.375,11.578125 L56.800781,10.179688 C50.792969,3.914063 42.347656,0 33,0 Z M33,5 C32.449219,5 32,5.449219 32,6 C32,6.550781 32.449219,7 33,7 C33.550781,7 34,6.550781 34,6 C34,5.449219 33.550781,5 33,5 Z M38.292969,5.515625 C37.804688,5.503906 37.382813,5.84375 37.285156,6.324219 C37.179688,6.863281 37.53125,7.390625 38.074219,7.5 C38.613281,7.605469 39.140625,7.253906 39.25,6.714844 C39.355469,6.171875 39.003906,5.644531 38.464844,5.535156 C38.40625,5.527344 38.351563,5.519531 38.292969,5.515625 Z M27.738281,5.519531 C27.671875,5.519531 27.605469,5.523438 27.539063,5.535156 C26.996094,5.644531 26.644531,6.171875 26.753906,6.714844 C26.804688,6.972656 26.957031,7.203125 27.179688,7.351563 C27.398438,7.496094 27.667969,7.550781 27.929688,7.5 C28.472656,7.390625 28.824219,6.867188 28.714844,6.324219 C28.621094,5.859375 28.214844,5.523438 27.738281,5.519531 Z M22.675781,7.054688 C22.542969,7.054688 22.410156,7.078125 22.285156,7.128906 C21.773438,7.34375 21.53125,7.925781 21.746094,8.4375 C21.957031,8.949219 22.539063,9.191406 23.050781,8.980469 C23.5625,8.765625 23.804688,8.183594 23.59375,7.671875 C23.4375,7.300781 23.078125,7.058594 22.675781,7.054688 Z M43.355469,7.054688 C42.941406,7.046875 42.566406,7.289063 42.40625,7.671875 C42.195313,8.183594 42.4375,8.765625 42.949219,8.980469 C43.460938,9.191406 44.042969,8.949219 44.253906,8.4375 C44.46875,7.925781 44.226563,7.34375 43.714844,7.128906 C43.601563,7.082031 43.476563,7.058594 43.355469,7.054688 Z M18.011719,9.546875 C17.808594,9.546875 17.609375,9.605469 17.441406,9.71875 C16.984375,10.023438 16.859375,10.644531 17.167969,11.105469 C17.472656,11.5625 18.09375,11.6875 18.554688,11.378906 C19.015625,11.074219 19.136719,10.453125 18.832031,9.996094 C18.648438,9.71875 18.339844,9.550781 18.011719,9.546875 Z M48.015625,9.546875 C47.675781,9.542969 47.355469,9.710938 47.167969,9.996094 C46.859375,10.453125 46.984375,11.074219 47.441406,11.378906 C47.902344,11.6875 48.523438,11.5625 48.828125,11.105469 C48.976563,10.886719 49.03125,10.613281 48.980469,10.355469 C48.929688,10.09375 48.777344,9.863281 48.554688,9.71875 C48.394531,9.609375 48.210938,9.550781 48.015625,9.546875 Z M61.113281,10.15625 L30.859375,39.777344 L20.035156,28.722656 L17.890625,30.824219 L30.8125,44.019531 L63.214844,12.300781 L61.113281,10.15625 Z M13.921875,12.90625 C13.652344,12.90625 13.390625,13.011719 13.203125,13.203125 C12.8125,13.589844 12.8125,14.226563 13.203125,14.613281 C13.589844,15.003906 14.226563,15.003906 14.613281,14.613281 C15.003906,14.226563 15.003906,13.589844 14.613281,13.203125 C14.429688,13.015625 14.183594,12.910156 13.921875,12.90625 Z M52.105469,12.90625 C51.835938,12.90625 51.574219,13.011719 51.386719,13.203125 C50.996094,13.589844 50.996094,14.226563 51.386719,14.613281 C51.773438,15.003906 52.410156,15.003906 52.796875,14.613281 C53.1875,14.226563 53.1875,13.589844 52.796875,13.203125 C52.613281,13.015625 52.367188,12.910156 52.105469,12.90625 Z M10.566406,17 C10.226563,16.992188 9.90625,17.160156 9.71875,17.441406 C9.414063,17.902344 9.535156,18.523438 9.996094,18.828125 C10.457031,19.136719 11.074219,19.011719 11.382813,18.554688 C11.6875,18.09375 11.566406,17.472656 11.105469,17.167969 C10.945313,17.0625 10.761719,17.003906 10.566406,17 Z M57.953125,21.667969 C57.820313,21.664063 57.6875,21.691406 57.5625,21.742188 C57.050781,21.953125 56.808594,22.539063 57.019531,23.046875 C57.234375,23.558594 57.816406,23.800781 58.328125,23.589844 C58.839844,23.378906 59.082031,22.792969 58.871094,22.28125 C58.714844,21.914063 58.355469,21.667969 57.953125,21.667969 Z M8.078125,21.667969 C7.664063,21.660156 7.289063,21.902344 7.132813,22.285156 C6.921875,22.796875 7.164063,23.378906 7.671875,23.59375 C8.183594,23.804688 8.769531,23.5625 8.980469,23.050781 C9.191406,22.539063 8.949219,21.957031 8.4375,21.746094 C8.324219,21.695313 8.203125,21.671875 8.078125,21.667969 Z M59.484375,26.734375 C59.417969,26.730469 59.351563,26.738281 59.285156,26.75 C58.746094,26.859375 58.394531,27.386719 58.5,27.925781 C58.609375,28.46875 59.136719,28.820313 59.675781,28.714844 C60.21875,28.605469 60.570313,28.078125 60.464844,27.535156 C60.371094,27.070313 59.960938,26.734375 59.484375,26.734375 Z M6.546875,26.734375 C6.058594,26.722656 5.636719,27.058594 5.539063,27.535156 C5.488281,27.796875 5.539063,28.070313 5.6875,28.289063 C5.835938,28.511719 6.066406,28.664063 6.328125,28.714844 C6.585938,28.765625 6.855469,28.710938 7.078125,28.566406 C7.296875,28.417969 7.449219,28.1875 7.5,27.925781 C7.609375,27.386719 7.257813,26.859375 6.71875,26.75 C6.660156,26.742188 6.605469,26.734375 6.546875,26.734375 Z M6,32 C5.449219,32 5,32.449219 5,33 C5,33.550781 5.449219,34 6,34 C6.550781,34 7,33.550781 7,33 C7,32.449219 6.550781,32 6,32 Z M60,32 C59.449219,32 59,32.449219 59,33 C59,33.550781 59.449219,34 60,34 C60.550781,34 61,33.550781 61,33 C61,32.449219 60.550781,32 60,32 Z M6.523438,37.265625 C6.457031,37.265625 6.390625,37.273438 6.324219,37.285156 C5.78125,37.394531 5.429688,37.921875 5.539063,38.464844 C5.648438,39.003906 6.171875,39.355469 6.714844,39.25 C7.257813,39.140625 7.609375,38.613281 7.5,38.074219 C7.40625,37.605469 7,37.269531 6.523438,37.265625 Z M59.507813,37.265625 C59.019531,37.253906 58.597656,37.59375 58.5,38.074219 C58.394531,38.613281 58.746094,39.140625 59.285156,39.25 C59.828125,39.355469 60.355469,39.003906 60.464844,38.464844 C60.570313,37.921875 60.21875,37.394531 59.675781,37.285156 C59.621094,37.277344 59.566406,37.269531 59.507813,37.265625 Z M57.96875,42.328125 C57.554688,42.320313 57.179688,42.566406 57.019531,42.949219 C56.808594,43.457031 57.050781,44.042969 57.5625,44.253906 C58.074219,44.464844 58.65625,44.222656 58.871094,43.714844 C59.082031,43.203125 58.839844,42.617188 58.328125,42.40625 C58.214844,42.359375 58.089844,42.332031 57.96875,42.328125 Z M8.0625,42.332031 C7.929688,42.332031 7.796875,42.355469 7.671875,42.40625 C7.429688,42.507813 7.234375,42.703125 7.132813,42.949219 C7.03125,43.195313 7.03125,43.46875 7.128906,43.714844 C7.34375,44.226563 7.925781,44.46875 8.4375,44.253906 C8.683594,44.15625 8.878906,43.960938 8.980469,43.714844 C9.082031,43.46875 9.082031,43.195313 8.980469,42.949219 C8.828125,42.578125 8.464844,42.335938 8.0625,42.332031 Z M55.46875,47 C55.128906,46.992188 54.808594,47.160156 54.621094,47.441406 C54.3125,47.902344 54.4375,48.519531 54.894531,48.828125 C55.113281,48.976563 55.386719,49.03125 55.644531,48.976563 C55.90625,48.925781 56.136719,48.773438 56.28125,48.550781 C56.589844,48.09375 56.464844,47.472656 56.003906,47.167969 C55.847656,47.058594 55.660156,47 55.46875,47 Z M10.5625,47 C10.359375,46.996094 10.164063,47.054688 9.996094,47.167969 C9.539063,47.476563 9.414063,48.09375 9.71875,48.554688 C10.027344,49.011719 10.648438,49.136719 11.109375,48.828125 C11.566406,48.523438 11.691406,47.902344 11.382813,47.441406 C11.199219,47.167969 10.890625,47.003906 10.5625,47 Z M13.921875,51.09375 C13.652344,51.089844 13.390625,51.195313 13.203125,51.386719 C12.8125,51.773438 12.8125,52.410156 13.203125,52.796875 C13.589844,53.1875 14.226563,53.1875 14.613281,52.796875 C15.003906,52.410156 15.003906,51.773438 14.613281,51.386719 C14.429688,51.199219 14.183594,51.09375 13.921875,51.09375 Z M52.105469,51.09375 C51.835938,51.089844 51.574219,51.195313 51.386719,51.386719 C50.996094,51.773438 50.996094,52.410156 51.386719,52.796875 C51.773438,53.1875 52.410156,53.1875 52.796875,52.796875 C53.1875,52.410156 53.1875,51.773438 52.796875,51.386719 C52.613281,51.199219 52.367188,51.09375 52.105469,51.09375 Z M18.019531,54.449219 C17.679688,54.441406 17.359375,54.609375 17.171875,54.890625 C16.863281,55.351563 16.988281,55.972656 17.449219,56.28125 C17.90625,56.585938 18.527344,56.460938 18.832031,56.003906 C19.140625,55.542969 19.015625,54.925781 18.558594,54.617188 C18.398438,54.511719 18.210938,54.449219 18.019531,54.449219 Z M48.011719,54.449219 C47.808594,54.445313 47.613281,54.503906 47.445313,54.613281 C47.222656,54.761719 47.070313,54.992188 47.019531,55.253906 C46.96875,55.511719 47.023438,55.785156 47.171875,56.003906 C47.476563,56.460938 48.097656,56.585938 48.558594,56.28125 C49.015625,55.972656 49.140625,55.351563 48.832031,54.890625 C48.652344,54.617188 48.34375,54.449219 48.011719,54.449219 Z M22.691406,56.941406 C22.277344,56.933594 21.902344,57.179688 21.746094,57.5625 C21.535156,58.070313 21.777344,58.65625 22.285156,58.867188 C22.796875,59.078125 23.382813,58.835938 23.59375,58.328125 C23.804688,57.816406 23.5625,57.230469 23.050781,57.019531 C22.9375,56.972656 22.816406,56.945313 22.691406,56.941406 Z M43.339844,56.941406 C43.207031,56.941406 43.074219,56.96875 42.953125,57.019531 C42.707031,57.121094 42.511719,57.316406 42.410156,57.558594 C42.308594,57.804688 42.308594,58.082031 42.40625,58.328125 C42.621094,58.835938 43.203125,59.078125 43.714844,58.867188 C43.960938,58.765625 44.15625,58.570313 44.257813,58.328125 C44.359375,58.082031 44.359375,57.804688 44.257813,57.5625 C44.105469,57.1875 43.742188,56.945313 43.339844,56.941406 Z M27.761719,58.480469 C27.273438,58.46875 26.847656,58.808594 26.753906,59.285156 C26.644531,59.828125 26.996094,60.351563 27.539063,60.460938 C28.082031,60.570313 28.605469,60.21875 28.714844,59.675781 C28.824219,59.132813 28.472656,58.609375 27.929688,58.5 C27.875,58.488281 27.816406,58.480469 27.761719,58.480469 Z M38.269531,58.484375 C38.203125,58.480469 38.136719,58.488281 38.074219,58.5 C37.53125,58.609375 37.179688,59.132813 37.285156,59.675781 C37.339844,59.9375 37.492188,60.164063 37.710938,60.3125 C37.933594,60.460938 38.203125,60.515625 38.464844,60.464844 C38.722656,60.410156 38.953125,60.257813 39.101563,60.039063 C39.246094,59.816406 39.300781,59.546875 39.25,59.285156 C39.15625,58.820313 38.746094,58.484375 38.269531,58.484375 Z M33,59 C32.449219,59 32,59.449219 32,60 C32,60.550781 32.449219,61 33,61 C33.550781,61 34,60.550781 34,60 C34,59.449219 33.550781,59 33,59 Z', id: 'Shape' }))))))));
};


//# sourceMappingURL=icons.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/ReportSuccessDialog.js
'use client';










var OPEN_REPORT_SUCCESS_DIALOG = 'open-report-success-dialog';
var CLOSE_REPORT_SUCCESS_DIALOG = 'close-report-success-dialog';
var openReportSuccessDialog = function (locationClassName) {
    return new Promise(function (res, _) {
        eventHelper.emit("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () {
            res(null);
        });
    });
};
var ReportCompanySuccessDialog = function () {
    var _a = (0,react.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useReportCompany(), language = _b.language, t = _b.t, locationClassName = _b.locationClassName;
    var handleClose = function () {
        setIsOpen(false);
        eventHelper.emit("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
    };
    (0,react.useEffect)(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    return (react.createElement(react.Fragment, null,
        react.createElement(Popup/* default */.Z, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, custom: {
                footer: react.createElement(react.Fragment, null),
                header: react.createElement(react.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            react.createElement(ReportCompanySuccess.Container, null,
                react.createElement(ReportCompanySuccess.Header, null,
                    react.createElement(ReportCompanySuccess.Action, { onClick: function () { return handleClose(); } },
                        react.createElement(RemoveIcon/* default */.Z, null))),
                react.createElement(ReportCompanySuccess.Body, null,
                    react.createElement(ReportCompanySuccess.IconWrapper, null,
                        react.createElement(IconSuccess, null)),
                    react.createElement(ReportCompanySuccess.Title, null, t("Report a company successfully")),
                    react.createElement(ReportCompanySuccess.Description, null, t("Your comments make an important contribution to protecting the Company Seeker Community."))),
                react.createElement(ReportCompanySuccess.Footer, null,
                    react.createElement(ReportCompanySuccess.Button, { onClick: handleClose }, t("Close")))))));
};


//# sourceMappingURL=ReportSuccessDialog.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/translation.js
'use client';

var translations = {
    'Report company': 'Báo cáo công ty',
    'VietnamWorks has received the report. VietnamWorks is checking and working with the company. And we will reply to you as soon as possible.': 'VietnamWorks đã tiếp nhận báo cáo. VietnamWorks đang kiểm tra và làm việc với công ty. Và chúng tôi sẽ hồi âm bạn trong thời gian sớm nhất.',
    'Reported this company': 'Đã báo cáo công ty này',
    Send: 'Gửi',
    'Please input detail description.': 'Bạn cần nhập mô tả chi tiết.',
    'Your comments make an important contribution to protecting the Company Seeker Community.': 'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a company successfully': 'Báo cáo công ty thành công',
    'Scam detection': 'Nhận diện một số hình thức lừa đảo',
    'View detail': 'Xem chi tiết',
    Close: 'Đóng',
    "Can't update this Report Company": 'Không thể cập nhật báo cáo công ty này',
    'Report Company error': 'Lỗi báo cáo công ty',
    'Details of the reason.': 'Mô tả chi tiết lý do báo cáo.',
    login: 'dang-nhap'
};


//# sourceMappingURL=translation.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/constants.js
var LoginModal_constants = __webpack_require__(33874);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ReportIcon/index.js
var ReportIcon = __webpack_require__(35425);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/index.js + 2 modules
var SimpleTooltip = __webpack_require__(17068);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/index.js
'use client';













var ReportCompanyModal = function (props) {
    var _a = (0,react.useState)(false), isReportSuccess = _a[0], setIsReportSuccess = _a[1];
    var _b = (0,react.useState)(false); _b[0]; _b[1];
    var _c = props.data, data = _c === void 0 ? {
        company: {
            companyId: 0,
            companyLogo: '',
            companyName: ''
        },
        apiTokenAccess: '',
        isAuthenticated: 0,
        apiGetway: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0',
        isReportCompany: false,
        imagesService: 'https://staging-images.vietnamworks.com/images',
        faqService: '',
        redirectPage: '',
        wnwBaseURL: ''
    } : _c, _d = props.language, language = _d === void 0 ? 'vi' : _d, _e = props.useGlobalToast, useGlobalToast = _e === void 0 ? false : _e, _f = props.locationClassName, locationClassName = _f === void 0 ? '' : _f;
    var _g = data || {}, isAuthenticated = _g.isAuthenticated, isReportCompany = _g.isReportCompany;
    var t = function (text) {
        if (language === 'vi') {
            return translations[text];
        }
        return text;
    };
    var handleReport = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var isSuccess;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openReportDialog(locationClassName)];
                case 1:
                    isSuccess = _a.sent();
                    if (!isSuccess) return [3 /*break*/, 3];
                    return [4 /*yield*/, openReportSuccessDialog(locationClassName)];
                case 2:
                    _a.sent();
                    setIsReportSuccess(true);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickReport = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var loginEvent;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            if (!isAuthenticated) {
                loginEvent = new CustomEvent(LoginModal_constants/* LOGIN_POPUP */.eS, {
                    detail: {
                        langCode: language,
                        isNeedReload: true
                    }
                });
                window.dispatchEvent(loginEvent);
                return [2 /*return*/];
            }
            handleReport();
            return [2 /*return*/];
        });
    }); };
    var isReportedCompany = isReportCompany || isReportSuccess;
    var isMobile = typeof window !== "undefined" ? window.innerWidth < 480 : false;
    return (react.createElement(ReportCompanyModalContext.Provider, { value: {
            data: data,
            language: language,
            useGlobalToast: useGlobalToast,
            locationClassName: locationClassName,
            t: t
        } },
        react.createElement(react.Fragment, null,
            !useGlobalToast && react.createElement(Toast/* default */.ZP, null),
            react.createElement(ReportCompanyDialog_ReportCompanyDialog, null),
            react.createElement(ReportCompanySuccessDialog, null),
            !isReportedCompany &&
                react.createElement(Button/* default */.Z, { type: 'default', outline: "solid", onClick: handleClickReport, style: { padding: '8px 8px', 'maxWidth': '44px', width: '44px', margin: '0 8px', height: '42px' } },
                    react.createElement(ReportIcon/* default */.Z, { color: '#888' })),
            isReportedCompany &&
                react.createElement(SimpleTooltip/* default */.Z, { isMobile: isMobile, content: isMobile ? t('VietnamWorks has received the report. VietnamWorks is checking and working with the company. And we will reply to you as soon as possible.') : t('Reported this company'), title: t('Reported this company'), align: 'end', referenceElement: react.createElement(Button/* default */.Z, { type: 'default', outline: "solid", disabled: true, style: { padding: '8px 8px', 'maxWidth': '44px', width: '44px', margin: '0 8px', height: '42px' } },
                        react.createElement(ReportIcon/* default */.Z, { color: '#C9C9C9' })) }))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ getSuggestionKeyword; },
/* harmony export */   "SX": function() { return /* binding */ getJobYouWillLove; },
/* harmony export */   "s4": function() { return /* binding */ getSearchBarHighLight; },
/* harmony export */   "tC": function() { return /* binding */ getSearchJob; },
/* harmony export */   "x_": function() { return /* binding */ getHotKeywords; },
/* harmony export */   "zK": function() { return /* binding */ trackSuggestionKeywords; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55613);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37148);
'use client';





var getHotKeywords = function (msBaseUrl, rawUserId, language) {
    if (language === void 0) { language = 'vi'; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var userId, apiUrl, response, err_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = rawUserId !== undefined && rawUserId !== null && rawUserId !== -1 ? rawUserId : 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v1/hot-keywords?userId=").concat(userId, "&lang=").concat(language);
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/vnd.api+json',
                                Accept: 'application/vnd.api+json',
                                'Accept-Language': language
                            }
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    // TODO: Log Error To Sentry
                    console.debug('error getHotKeywords', err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, { data: [] }];
            }
        });
    });
};
var getSearchBarHighLight = function (msBaseUrl, jobFunctionIds, lang) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var URL, response;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .attachQueryParamToUrl */ ._2)("".concat(msBaseUrl, "/banners/v1.0/searchbar-highlight"), {
                    jobFunctionIds: jobFunctionIds
                });
                return [4 /*yield*/, fetch(URL, {
                        method: 'GET',
                        headers: {
                            'Accept-Language': lang,
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getSuggestionKeyword = function (msBaseUrl, keyword, language, limit) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var encodedKeyword, apiUrl, suggestions, response, err_2;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedKeyword = encodeURIComponent(keyword);
                apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion?query=").concat(encodedKeyword, "&limit=").concat(limit, "&lang=").concat(language);
                suggestions = {
                    data: []
                };
                if (keyword === '') {
                    return [2 /*return*/, suggestions];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json',
                            'Accept-Language': language
                        }
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                err_2 = _a.sent();
                // TODO: Log Error To Sentry
                console.debug('error getHotKeywords', err_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, suggestions];
        }
    });
}); };
var EMPTY_RESPONSE = {
    data: [],
    facets: {},
    meta: {
        code: 400,
        message: '',
        nbHits: 0,
        page: 0,
        nbPages: 0,
        hitsPerPage: 0
    }
};
var getSearchJob = function (msBaseUrl, postData) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var URL_1, onlyAddText, response, responseData, ex_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                URL_1 = "".concat(msBaseUrl, "/job-search/v1.0/search");
                onlyAddText = localStorage.getItem('onlyAddText');
                if (!!onlyAddText) return [3 /*break*/, 3];
                return [4 /*yield*/, fetch(URL_1, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Source': 'Page-Container'
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                if (!(response.status === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .SUCCESS_CODE */ .Gh)) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                return [2 /*return*/, responseData !== null && responseData !== void 0 ? responseData : EMPTY_RESPONSE];
            case 3: return [2 /*return*/, EMPTY_RESPONSE];
            case 4:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, EMPTY_RESPONSE];
            case 5: return [2 /*return*/];
        }
    });
}); };
var trackSuggestionKeywords = function (_a) {
    var msBaseUrl = _a.msBaseUrl, language = _a.language, body = _a.body;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var URL_2, err_3;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    URL_2 = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion");
                    return [4 /*yield*/, fetch(URL_2, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': language
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _b.sent();
                    // TODO: Log Error To Sentry
                    console.error('error track suggestion keyword', err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
var getJobYouWillLove = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var msBaseUrl, _a, jobId, _b, limit, userId, langCode, URL_3, response, err_4;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, _a = params.jobId, jobId = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 5 : _b, userId = params.userId, langCode = params.langCode;
                URL_3 = "".concat(msBaseUrl, "/smartnavi/v2/jobs?jobId=").concat(jobId, "&limit=").concat(limit, "&user=").concat(userId, "&l=").concat(langCode);
                return [4 /*yield*/, fetch(URL_3, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                err_4 = _c.sent();
                console.error('getJobYouWillLove', err_4);
                return [2 /*return*/, {
                        jobs: [],
                        total: 0,
                        source: ''
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=apiServices.js.map


/***/ }),

/***/ 37148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ UTM_JOB_YOU_WILL_LOVE; },
/* harmony export */   "DG": function() { return /* binding */ UTM_SEARCH_JOB_YOU_LOVE; },
/* harmony export */   "FB": function() { return /* binding */ defaultSearchFilterParams; },
/* harmony export */   "Gf": function() { return /* binding */ DEBOUNCE_SEARCH_TIME; },
/* harmony export */   "Gh": function() { return /* binding */ SUCCESS_CODE; },
/* harmony export */   "JI": function() { return /* binding */ DEBOUNCE_SEARCH_TOP_JOB_TIME; },
/* harmony export */   "Kr": function() { return /* binding */ VNW_SEARCH_JOB_CITY_COOKIE_NAME; },
/* harmony export */   "Mt": function() { return /* binding */ RECENT_SEARCH; },
/* harmony export */   "Nk": function() { return /* binding */ DEFAULT_COMPANY_LOGO; },
/* harmony export */   "Ps": function() { return /* binding */ KEYCODE; },
/* harmony export */   "R_": function() { return /* binding */ SUGGEST_COMPANY_MAX; },
/* harmony export */   "TT": function() { return /* binding */ COMPANY_LOGO_NAME; },
/* harmony export */   "Uj": function() { return /* binding */ DEFAULT_SEARCH_BAR_OPTIONS; },
/* harmony export */   "YA": function() { return /* binding */ RETRIEVE_FIELDS_SEARCH; },
/* harmony export */   "_o": function() { return /* binding */ SEARCH_INPUT_QUERY_STRING; },
/* harmony export */   "m5": function() { return /* binding */ DEFAULT_MAX_LENGTH_INPUT; },
/* harmony export */   "mF": function() { return /* binding */ DEFAULT_LIMIT_SUGGESTION; },
/* harmony export */   "rw": function() { return /* binding */ keyCode; }
/* harmony export */ });
'use client';

var keyCode = {
    Escape: 'Escape',
    ArrowDown: 'ArrowDown',
    ArrowUp: 'ArrowUp',
    Enter: 'Enter',
    Tab: 'Tab',
    Space: ' '
};
var VNW_SEARCH_JOB_CITY_COOKIE_NAME = 'VNWSearchJob[city]';
var RECENT_SEARCH = '_recent_searches_v1';
var DEFAULT_LIMIT_SUGGESTION = 5;
var DEBOUNCE_SEARCH_TIME = 400;
var DEBOUNCE_SEARCH_TOP_JOB_TIME = 1000; // 1s
var RETRIEVE_FIELDS_SEARCH = [
    'address',
    'benefits',
    'jobTitle',
    'salaryMax',
    'isSalaryVisible',
    'jobLevelVI',
    'isShowLogo',
    'salaryMin',
    'companyLogo',
    'userId',
    'jobUrl',
    'jobLevel',
    'jobLevelId',
    'jobId',
    'companyId',
    'approvedOn',
    'isAnonymous',
    'alias',
    'expiredOn',
    'industries',
    'workingLocations',
    'services',
    'companyName',
    'salary',
    'onlineOn',
    'simpleServices',
    'visibilityDisplay',
    'isShowLogoInSearch',
    'priorityOrder',
    'skills',
    'profilePublishedSiteMask',
    'jobDescription',
    'jobRequirement',
    'prettySalary',
    'requiredCoverLetter',
    'languageSelectedVI',
    'languageSelected',
    'languageSelectedId'
];
var DEFAULT_MAX_LENGTH_INPUT = 100;
// Input className using for querySelector
var SEARCH_INPUT_QUERY_STRING = 'input.class-input-recommend';
var defaultSearchFilterParams = {
    salary: [-1, -1],
    benefitIds: [],
    categoryId: [],
    locationId: [],
    districtId: [],
    jobLevelId: -1,
    typeWorkingId: -1,
    isUrgentJob: false,
    companySizeId: -1,
    salaryCurrency: 1
};
/**
 * VNW - 16434 [SearchBar] Company Search
 *
 * SUGGEST_COMPANY_MAX means each suggestion keyword count equal company slice
 * This only happen when have topJobItem
 * example:
 * 0 keyword equal 4 companies      (Display: 4 companies, 0 keyword, 1 top job item)
 * 1 keyword equal 3 companies      (Display: 3 companies, 1 keyword, 1 top job item)
 * 2 keywords equal 2 companies     (Display: 2 companies, 2 keywords, 1 top job item)
 * 3 keywords equal 2 companies     (Display: 2 companies, 3 keywords, 1 top job item)
 * 4 keywords equals 2 companies    (Display: 2 companies, 2 keywords, 1 top job item)
 */
var SUGGEST_COMPANY_MAX = [4, 3, 2, 2, 2];
var DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
// Link of company logo response from server
var COMPANY_LOGO_NAME = 'company-default-logo.png';
var DEFAULT_SEARCH_BAR_OPTIONS = {
    isNeedNavigate: true,
    isHomepage: false,
    maxInputLength: DEFAULT_MAX_LENGTH_INPUT
};
// KeyCode
var KEYCODE = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    TAB: 'Tab',
    SPACE: 'Space'
};
var UTM_SEARCH_JOB_YOU_LOVE = 'utm_source_navi=searchbox&utm_campaign_navi=jobyouwilllove&utm_content_navi=searchjob';
var UTM_JOB_YOU_WILL_LOVE = 'utm_source_navi=searchbox&utm_campaign_navi=jobyouwilllove&utm_content_navi=SmartNaviIOP';
var SUCCESS_CODE = 200;


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 1437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ACTIONS; }
/* harmony export */ });
'use client';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "SHOW";
    ACTIONS["FORCE_CONTROL"] = "FORCE_CONTROL";
    ACTIONS["SET_KEYWORD"] = "SET_KEYWORD";
    ACTIONS["SET_TOP_JOB_ITEM"] = "SET_TOP_JOB_ITEM";
    ACTIONS["SET_HOT_KEYWORDS"] = "SET_HOT_KEYWORDS";
    ACTIONS["SET_SUGGESTIONS"] = "SET_SUGGESTIONS";
    ACTIONS["BLUR_BACKGROUND"] = "BLUR_BACKGROUND";
    ACTIONS["SET_HIGHLIGHT_JOB"] = "SET_HIGHLIGHT_JOB";
    ACTIONS["SET_FIRST_TIME_LOAD"] = "SET_FIRST_TIME_LOAD";
    ACTIONS["OPEN_DROP_DOWN"] = "OPEN_DROP_DOWN";
    ACTIONS["CLOSE_DROP_DOWN"] = "CLOSE_DROP_DOWN";
    ACTIONS["UPDATE_SELECTED_SUGGESTION_INDEX"] = "UPDATE_SELECTED_SUGGESTION_INDEX";
    ACTIONS["TOGGLE_LOCK_DEBOUNCE"] = "TOGGLE_LOCK_DEBOUNCE";
    ACTIONS["SET_JOB_YOU_WILL_LOVE"] = "SET_JOB_YOU_WILL_LOVE";
    ACTIONS["SET_SEARCH_JOB_YOU_LOVE"] = "SET_SEARCH_JOB_YOU_LOVE";
    ACTIONS["SET_RECENT_KEYWORDS"] = "SET_RECENT_KEYWORDS";
    ACTIONS["SET_LOCATIONS"] = "SET_LOCATIONS";
})(ACTIONS || (ACTIONS = {}));


//# sourceMappingURL=actions.js.map


/***/ }),

/***/ 28704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ initialSearchBar; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52077);
'use client';



var initialSearchBar = {
    keyword: '',
    isShow: false,
    forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_0__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT,
    isLoaded: false,
    isBlurBackground: false,
    isInMobile: true,
    topJobItem: null,
    highlightJob: null,
    hotKeywords: [],
    suggestions: [],
    selectedSuggestionIndex: -1,
    isLockedDebounce: false,
    jobYouWillLove: [],
    searchJobYouLove: [],
    recentSearch: [],
    locations: []
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SearchBarContext; },
/* harmony export */   "V": function() { return /* binding */ searchBarReducer; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28704);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52077);
/* harmony import */ var _actions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1437);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96306);
/* harmony import */ var _TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33294);
'use client';









var searchBarReducer = function (state, action) {
    var _a, _b, _c, _d, _e;
    var type = action.type;
    var clonedState = (0,_TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .deepCloneObject */ .kh)(state);
    switch (type) {
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SHOW */ .a.SHOW: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isShow: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.FORCE_CONTROL */ .a.FORCE_CONTROL: {
            switch (action.payload) {
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.CLOSE_ALL */ .q.CLOSE_ALL:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.CLOSE_ALL */ .q.CLOSE_ALL, isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT, isBlurBackground: true, isShow: true });
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */ .q.JUST_SHOW_DROPDOWN_TREE_SELECT:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: true, isShow: true, forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */ .q.JUST_SHOW_DROPDOWN_TREE_SELECT });
                default:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state);
            }
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.BLUR_BACKGROUND */ .a.BLUR_BACKGROUND: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_KEYWORD */ .a.SET_KEYWORD: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { keyword: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_TOP_JOB_ITEM */ .a.SET_TOP_JOB_ITEM: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { topJobItem: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_HIGHLIGHT_JOB */ .a.SET_HIGHLIGHT_JOB: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { highlightJob: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_FIRST_TIME_LOAD */ .a.SET_FIRST_TIME_LOAD: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isLoaded: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.OPEN_DROP_DOWN */ .a.OPEN_DROP_DOWN: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: true, isShow: true });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.CLOSE_DROP_DOWN */ .a.CLOSE_DROP_DOWN: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_HOT_KEYWORDS */ .a.SET_HOT_KEYWORDS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { hotKeywords: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_SUGGESTIONS */ .a.SET_SUGGESTIONS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { suggestions: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */ .a.UPDATE_SELECTED_SUGGESTION_INDEX: {
            var nextIndex = action.payload;
            var _f = clonedState.suggestions, suggestions = _f === void 0 ? [] : _f, keyword = clonedState.keyword;
            var isSuggest = ((_a = suggestions[nextIndex]) === null || _a === void 0 ? void 0 : _a.type) === 'suggest';
            var nextKeyword = isSuggest
                ? (_c = (_b = suggestions[nextIndex]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.suggest
                : (_e = (_d = suggestions[nextIndex]) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.companyName;
            var updateKeyword = keyword;
            if (nextKeyword) {
                updateKeyword = nextKeyword;
            }
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { selectedSuggestionIndex: action.payload, keyword: updateKeyword, isLockedDebounce: true });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.TOGGLE_LOCK_DEBOUNCE */ .a.TOGGLE_LOCK_DEBOUNCE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isLockedDebounce: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_JOB_YOU_WILL_LOVE */ .a.SET_JOB_YOU_WILL_LOVE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { jobYouWillLove: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_SEARCH_JOB_YOU_LOVE */ .a.SET_SEARCH_JOB_YOU_LOVE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { searchJobYouLove: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_RECENT_KEYWORDS */ .a.SET_RECENT_KEYWORDS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { recentSearch: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_LOCATIONS */ .a.SET_LOCATIONS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { locations: action.payload });
        }
        default:
            console.error('Unknown type of Search Bar Reducer');
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state);
    }
};
var SearchBarContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    state: _index_js__WEBPACK_IMPORTED_MODULE_5__/* .initialSearchBar */ .n,
    props: {
        langCode: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_6__/* .ELanguage.VI */ .Df.VI,
        isMobile: true,
        pageName: '',
        msBaseUrl: '',
        dataProvider: null,
        userId: 0,
        userIP: '::1',
        VNWAppId: '',
        responsiveStyle: 'fill',
        optionList: [],
        mode: 'staging',
        userJobFunction: []
    },
    t: function (text) {
        return text;
    },
    dispatch: function () { },
    search: function () { }
});


//# sourceMappingURL=reducer.js.map


/***/ }),

/***/ 52077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ EForceControDropdown; }
/* harmony export */ });
'use client';

var EForceControDropdown;
(function (EForceControDropdown) {
    EForceControDropdown["JUST_SHOW_DROPDOWN_CONTENT"] = "JUST_SHOW_DROPDOWN_CONTENT";
    EForceControDropdown["JUST_SHOW_DROPDOWN_TREE_SELECT"] = "JUST_SHOW_DROPDOWN_TREE_SELECT";
    EForceControDropdown["CLOSE_ALL"] = "CLOSE_ALL";
})(EForceControDropdown || (EForceControDropdown = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 51727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ix": function() { return /* binding */ buildJobsByCompanyUrl; },
  "aH": function() { return /* binding */ buildSearchUrl; },
  "zF": function() { return /* binding */ changeLocation; },
  "Ak": function() { return /* binding */ getDistrictIdFromLocations; },
  "$o": function() { return /* binding */ getLocalStorage; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/constants.js
var SearchBarUnstable_constants = __webpack_require__(37148);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/types.js
'use client';

var SEARCH_PARAMS = {
    QUERY: 'q',
    LOCATION: 'l',
    DISTRICT: 'd',
    CATEGORY: 'f',
    INDUSTRY: 'i',
    WORKING_TYPE: 'w',
    JOB_LEVEL: 'level',
    URGENT: 'urgent',
    PAGE: 'page'
};


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/searchbarHelpers.js
'use client';







var getDistrictIdFromLocations = function (locations) {
    var updatedList = [];
    // Loop through cities
    locations === null || locations === void 0 ? void 0 : locations.map(function (location) {
        var _a;
        // Loop through district
        (_a = location === null || location === void 0 ? void 0 : location.childrenIds) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            // Do not push -1 to list
            if (item === -1) {
                return;
            }
            if (updatedList.indexOf(item) >= 0) {
                return;
            }
            updatedList.push(item);
        });
    });
    return updatedList;
};
var buildSearchUrl = function (keyword, locationObj, language) {
    var params = {};
    if (keyword) {
        params[SEARCH_PARAMS.QUERY] = keyword.replace(/ /g, '-');
    }
    if (Array.isArray(locationObj) && locationObj.length > 0) {
        params[SEARCH_PARAMS.LOCATION] = locationObj.map(function (i) { return i.parentId; }).join('.');
        var districtId = getDistrictIdFromLocations(locationObj);
        if (districtId && districtId.length > 0) {
            params[SEARCH_PARAMS.DISTRICT] = districtId.join('.');
        }
    }
    if (Object.keys(params).length > 0) {
        var paramsString = '?' + new URLSearchParams(params).toString();
        var baseUrl = language === constants/* ELanguage.VI */.Df.VI ? '/viec-lam' : '/jobs';
        return baseUrl + paramsString;
    }
    else {
        return language === constants/* ELanguage.VI */.Df.VI ? '/tim-viec-lam/tim-tat-ca-viec-lam' : '/job-search/all-jobs';
    }
};
var buildJobsByCompanyUrl = function (companyId, companyName, lang) {
    var prefix = lang === 'en' ? 'companies' : 'nha-tuyen-dung';
    return "/".concat(prefix, "/").concat((0,helpers/* slugify */.lV)(companyName), "-c").concat(companyId);
};
var changeLocation = function (url, isReturn, onlyFillInput) {
    if (isReturn === void 0) { isReturn = false; }
    var locationHref = window.location.origin;
    if (onlyFillInput) {
        return '';
    }
    // Remove wowcv from location (Because wowcv is using different domain)
    if (locationHref.indexOf('wowcv.') >= 0) {
        locationHref = locationHref.replace('wowcv.', '');
        // only for staging
        if (locationHref.indexOf('staging-vietnamworks') >= 0) {
            locationHref = locationHref.replace('staging-vietnamworks', 'staging.vietnamworks');
        }
        // only for release
        if (locationHref.indexOf('release-vietnamworks') >= 0) {
            locationHref = locationHref.replace('release-vietnamworks', 'release.vietnamworks');
        }
        if (!isReturn) {
            window.location.assign(locationHref + url);
        }
        return locationHref + url;
    }
    else {
        if (!isReturn) {
            window.location.assign(url);
        }
        return url;
    }
};
var getLocalStorage = function (mainKey, key) {
    if (mainKey === void 0) { mainKey = 'params'; }
    var params = typeof window !== 'undefined' ? localStorage.getItem(mainKey) : '';
    var defaultValue = {};
    if (mainKey === SearchBarUnstable_constants/* RECENT_SEARCH */.Mt) {
        defaultValue = [];
    }
    else if (mainKey === 'params') {
        if (key === 'query') {
            defaultValue = '';
        }
        else if (key === 'categoryId') {
            defaultValue = [];
        }
        else if (key === 'companyIndustries') {
            defaultValue = [];
        }
        else if (key === 'locationId') {
            defaultValue = [];
        }
        else if (key === 'locations') {
            defaultValue = [];
        }
        else if (key === '') {
            defaultValue = SearchBarUnstable_constants/* defaultSearchFilterParams */.FB;
        }
    }
    var localParams = params !== '' && params !== null ? JSON.parse(params) : defaultValue;
    if (localParams[key] !== undefined && localParams[key] !== null && key !== '') {
        return localParams[key];
    }
    else if (key !== undefined && key !== '' && localParams[key] === undefined) {
        return defaultValue;
    }
    return localParams;
};


//# sourceMappingURL=searchbarHelpers.js.map


/***/ }),

/***/ 67366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SettingJob; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SettingJob/SettingJob.css.js
'use client';




var More = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    position: relative;\n    display: inline-flex;\n\n    > svg {\n        transition: 0.25s;\n\n        &:hover {\n            circle {\n                fill: #616161;\n            }\n        }\n\n        ", "\n    }\n"], ["\n    cursor: pointer;\n    position: relative;\n    display: inline-flex;\n\n    > svg {\n        transition: 0.25s;\n\n        &:hover {\n            circle {\n                fill: #616161;\n            }\n        }\n\n        ", "\n    }\n"])), function (_a) {
    var isShowPopup = _a.isShowPopup;
    return isShowPopup && (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                circle {\n                    fill: #616161;\n                }\n            "], ["\n                circle {\n                    fill: #616161;\n                }\n            "])));
});
var MorePopup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 0;\n    padding: 8px;\n    overflow: hidden;\n    z-index: 99;\n    ", "\n"], ["\n    position: absolute;\n    right: 0;\n    padding: 8px;\n    overflow: hidden;\n    z-index: 99;\n    ", "\n"])), function (_a) {
    var showType = _a.showType;
    return showType === 'bottom'
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  top: calc(100% + 5px);\n              "], ["\n                  top: calc(100% + 5px);\n              "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  bottom: calc(100%);\n              "], ["\n                  bottom: calc(100%);\n              "])));
});
var extendAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% { transform: translateY(-100%); opacity: 0; }\n    100% { transform: translateY(0); opacity: 1; }\n"], ["\n    0% { transform: translateY(-100%); opacity: 0; }\n    100% { transform: translateY(0); opacity: 1; }\n"])));
var extendTopAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% { transform: translateY(100%); opacity: 0 }\n    100% { transform: translateY(0); opacity: 1 }\n"], ["\n    0% { transform: translateY(100%); opacity: 0 }\n    100% { transform: translateY(0); opacity: 1 }\n"])));
var collapseAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% { transform: translateY(0); opacity: 1; }\n    100% { transform: translateY(-100%); opacity: 0; }\n"], ["\n    0% { transform: translateY(0); opacity: 1; }\n    100% { transform: translateY(-100%); opacity: 0; }\n"])));
var collapseTopAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% { transform: translateY(0); opacity: 1 }\n    100% { transform: translateY(100%); opacity: 0 }\n"], ["\n    0% { transform: translateY(0); opacity: 1 }\n    100% { transform: translateY(100%); opacity: 0 }\n"])));
var MoreWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n\n    ", "\n"], ["\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n\n    ", "\n"])), function (_a) {
    var active = _a.active, showType = _a.showType;
    return active
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  animation: ", " 0.25s ease-in-out;\n                  opacity: 1;\n              "], ["\n                  animation: ", " 0.25s ease-in-out;\n                  opacity: 1;\n              "])), showType === 'bottom' ? extendAnimation : extendTopAnimation) : (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  animation: ", " 0.25s ease-in-out;\n                  opacity: 0;\n              "], ["\n                  animation: ", " 0.25s ease-in-out;\n                  opacity: 0;\n              "])), showType === 'bottom' ? collapseAnimation : collapseTopAnimation);
});
var MoreItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background-color: white;\n    line-height: 18px;\n    height: 44px;\n\n    &:hover {\n        background-color: rgb(249, 252, 255);\n    }\n\n    > span {\n        white-space: nowrap;\n    }\n"], ["\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background-color: white;\n    line-height: 18px;\n    height: 44px;\n\n    &:hover {\n        background-color: rgb(249, 252, 255);\n    }\n\n    > span {\n        white-space: nowrap;\n    }\n"])));
var MoreIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;


//# sourceMappingURL=SettingJob.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/HideIcon/index.js
var HideIcon = __webpack_require__(98616);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/VerticalMoreIcon/index.js
var VerticalMoreIcon = __webpack_require__(37373);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickOutSide.js
var useClickOutSide = __webpack_require__(67094);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SettingJob/services.js
'use client';



var hideJob = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, jobId = _a.jobId, accessToken = _a.accessToken, appId = _a.appId, source = _a.source;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var urlApi, res;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/job/").concat(jobId, "/hide");
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'X-App-Id': appId,
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({ source: source })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.message
                            }];
                    }
            }
        });
    });
};
var unhideJob = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, jobId = _a.jobId, accessToken = _a.accessToken;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var urlApi, res;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/job/").concat(jobId, "/unhide");
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.message
                            }];
                    }
            }
        });
    });
};


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SettingJob/index.js
'use client';
















var SettingJob = (0,react.forwardRef)(function (props, ref) {
    var api = props.api, jobId = props.jobId, langCode = props.langCode, onHideJobClick = props.onHideJobClick, onShowChange = props.onShowChange, isHide = props.isHide, _a = props.type, type = _a === void 0 ? 'vertical' : _a, _b = props.showPopupType, showPopupType = _b === void 0 ? 'bottom' : _b, _c = props.className, className = _c === void 0 ? '' : _c;
    var _d = (0,useClickOutSide/* default */.Z)(false), elementRef = _d.elementRef, isVisible = _d.isVisible, setElementVisible = _d.setElementVisible;
    var hasTransitionedIn = (0,hooks/* useMountTransition */.R5)(isVisible, 250);
    var isVI = langCode === constants/* ELanguage.VI */.Df.VI;
    var isWindow = typeof window !== 'undefined';
    var showLoginModal = function () {
        if (isWindow) {
            var loginEvent = new CustomEvent('LOGIN_POPUP', {
                detail: {
                    langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'
                }
            });
            window.dispatchEvent(loginEvent);
        }
    };
    var handleShowPopup = function (isShow) {
        setElementVisible(isShow);
    };
    var handleHideJobClick = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, data, error, message;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    handleShowPopup(false);
                    if (!api.accessToken) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, hideJob((0,_tslib/* __assign */.pi)({ jobId: jobId, langCode: langCode, accessToken: '' }, api))];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (data) {
                        onHideJobClick(jobId);
                    }
                    else {
                        message = error;
                        if (error === 'jobId exists') {
                            message = isVI ? 'Bạn đã ẩn công việc này.' : 'You have hidden this job.';
                        }
                        (0,Toast/* showToast */.CF)(isVI ? 'Ẩn việc làm' : 'Hide job', message, 'error');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUnhideJobClick = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, data, error;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, unhideJob((0,_tslib/* __assign */.pi)({ jobId: jobId, langCode: langCode, accessToken: '' }, api))];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (data) {
                        onHideJobClick(jobId);
                    }
                    else {
                        (0,Toast/* showToast */.CF)(isVI ? 'Ẩn việc làm' : 'Hide job', error, 'error');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        onShowChange && onShowChange(isVisible);
    }, [isVisible]);
    (0,react.useImperativeHandle)(ref, function () { return ({
        isShow: isVisible,
        onLeaveSetting: function () {
            setElementVisible(false);
        }
    }); });
    if (isHide) {
        return (react.createElement(Button/* default */.Z, { type: 'outline', onClick: handleUnhideJobClick }, isVI ? 'Hoàn tác' : 'Undo'));
    }
    return (react.createElement(More, { ref: elementRef, isShowPopup: isVisible, className: className },
        react.createElement(VerticalMoreIcon/* default */.Z, { style: { transform: type === 'horizontal' ? 'rotate(90deg)' : '' }, width: 20, onClick: function () { return handleShowPopup(!isVisible); } }),
        (isVisible || hasTransitionedIn) && (react.createElement(MorePopup, { showType: showPopupType },
            react.createElement(MoreWrapper, { showType: showPopupType, active: isVisible && hasTransitionedIn },
                react.createElement(MoreItem, { className: 'SJ_HideJob', onClick: handleHideJobClick },
                    react.createElement(MoreIcon, null,
                        react.createElement(HideIcon/* default */.Z, null)),
                    react.createElement("span", null, isVI ? 'Ẩn việc làm này' : 'Hide this job')))))));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 32053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareButton; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CopyIcon/index.js
var CopyIcon = __webpack_require__(708);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/FacebookIcon/index.js
var FacebookIcon = __webpack_require__(66887);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LinkedInIcon/index.js
var LinkedInIcon = __webpack_require__(10545);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ShareIcon/index.js
var ShareIcon = __webpack_require__(67468);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Modal/SlideModal.js + 1 modules
var SlideModal = __webpack_require__(85124);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ShareButton/ShareButton.css.js
'use client';





var ShareButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 1px;\n"], ["\n    position: relative;\n    padding: 1px;\n"])));
var extendFromTop = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 0;\n        transform: translateY(-100%);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"], ["\n    0% {\n        opacity: 0;\n        transform: translateY(-100%);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"])));
var collapseToTop = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(-100%);\n    }\n"], ["\n    0% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(-100%);\n    }\n"])));
var ShareDropdown = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 10;\n    overflow: hidden;\n\n    ", "\n"], ["\n    position: absolute;\n    z-index: 10;\n    overflow: hidden;\n\n    ", "\n"])), function (_a) {
    var position = _a.position;
    return position === 'left'
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  top: 100%;\n                  left: -4px;\n              "], ["\n                  top: 100%;\n                  left: -4px;\n              "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  top: 100%;\n                  left: -260px;\n              "], ["\n                  top: 100%;\n                  left: -260px;\n              "])));
});
var ShareWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 300px;\n    background-color: #fff;\n    border-radius: 6px;\n    border: 1px solid #e0e0e9;\n    box-shadow: 0 2px 4px 0 #efefef;\n    margin: 2px 4px 4px 4px;\n    animation: ", " 0.25s ease-in-out forwards;\n"], ["\n    width: 300px;\n    background-color: #fff;\n    border-radius: 6px;\n    border: 1px solid #e0e0e9;\n    box-shadow: 0 2px 4px 0 #efefef;\n    margin: 2px 4px 4px 4px;\n    animation: ", " 0.25s ease-in-out forwards;\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? extendFromTop : collapseToTop);
});
var ShareListUl = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    list-style-type: none;\n    padding: ", ";\n    ", "\n"], ["\n    margin: 0;\n    list-style-type: none;\n    padding: ", ";\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0 16px 16px 16px' : '16px');
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-bottom: 16px;\n        "], ["\n            margin-bottom: 16px;\n        "])));
});
var ShareText = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 600;\n    padding-bottom: 10px;\n    font-size: 16px;\n"], ["\n    font-weight: 600;\n    padding-bottom: 10px;\n    font-size: 16px;\n"])));
var ShareItem = styled_components_browser_esm/* default.li */.ZP.li(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n    ", "\n"], ["\n    padding: 8px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n    ", "\n"])), constants/* colors.bgHover */.O9.bgHover, function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            &:first-child {\n                font-weight: 500;\n                font-size: 16px;\n                &:hover {\n                    background-color: transparent !important;\n                }\n            }\n        "], ["\n            &:first-child {\n                font-weight: 500;\n                font-size: 16px;\n                &:hover {\n                    background-color: transparent !important;\n                }\n            }\n        "])));
});
var ShareItemIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    width: 40px;\n\n    svg {\n        margin-left: ", "px;\n    }\n"], ["\n    display: inline-flex;\n    width: 40px;\n\n    svg {\n        margin-left: ", "px;\n    }\n"])), function (_a) {
    var iconLeft = _a.iconLeft;
    return iconLeft || 0;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


//# sourceMappingURL=ShareButton.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ShareButton/translations.js
'use client';

var translations = {
    'Share to...': 'Share to...',
    'Share by ': 'Share by ',
    'Copy link': 'Copy link'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ShareButton/index.js
'use client';













var ShareButton = function (props) {
    var _a;
    var langCode = props.langCode, buttonStyle = props.buttonStyle, _b = props.position, position = _b === void 0 ? 'left' : _b;
    var _c = (0,react.useState)(false), isShow = _c[0], setShowDropdown = _c[1];
    var _d = (0,react.useState)(false), isMounted = _d[0], setMount = _d[1];
    var dropdownRef = (0,react.useRef)(null);
    var isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
    // Get page title and page URL
    var currentHref = '';
    var pageTitle = '';
    if (typeof window !== 'undefined') {
        pageTitle = encodeURIComponent(((_a = document.querySelector('meta[property="og:title"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '');
        currentHref = encodeURIComponent(window.location.href);
    }
    var facebookShareLink = "https://www.facebook.com/sharer.php?t=".concat(pageTitle, "&u=").concat(currentHref);
    // const twitterShareLink = `https://twitter.com/intent/tweet?text=${pageTitle}&url=${currentHref}`
    var linkedinShareLink = "https://www.linkedin.com/shareArticle?title=".concat(pageTitle, "&url=").concat(currentHref);
    var t = function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleClickShare = function (e) {
        e.stopPropagation();
        var isHideDropdown = !isShow;
        if (isHideDropdown) {
            setMount(true);
        }
        setShowDropdown(isHideDropdown);
    };
    var onAnimationEnd = function () {
        if (!isShow)
            setMount(false);
    };
    var isClickOutside = function (event, ref, isReactRef) {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && isReactRef) {
            if (ref.current.contains(event.target))
                return false;
        }
        else if (!isReactRef && ref) {
            if (ref.contains(event.target))
                return false;
        }
        return true;
    };
    var openInNewWindow = function (link) {
        var left = window.innerWidth / 2 - 720 / 2;
        var top = window.innerHeight / 2 - 480 / 2;
        window.open(link, '_blank', "toolbar=no,\n                    location=no,\n                    status=no,\n                    menubar=no,\n                    scrollbars=yes,\n                    resizable=yes,\n                    width=720,\n                    height=480\n                    top=".concat(top, ",\n                    left=").concat(left, "\n                    "));
    };
    var handleOnClickFacebook = function () {
        openInNewWindow(facebookShareLink);
        setShowDropdown(false);
    };
    // const handleOnClickZalo = () => {
    //     // TODO: Handle click zalo share
    //     setShowDropdown(false)
    // }
    var handleOnClickLinkedIn = function () {
        openInNewWindow(linkedinShareLink);
        setShowDropdown(false);
    };
    var handleOnClickCopyLink = function () {
        if (typeof window === 'undefined') {
            return;
        }
        if (!navigator.clipboard) {
            // Create a temporary textarea element
            var textArea = document.createElement('textarea');
            textArea.id = 'copyTextArea';
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            document.body.append(textArea);
            // Set the content of the area with the current HREF
            textArea.innerHTML = window.location.href;
            // Copy the value of the textarea
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
        }
        else {
            navigator.clipboard.writeText(window.location.href);
        }
        setShowDropdown(false);
    };
    (0,react.useEffect)(function () {
        var handleClickOnScreen = function (e) {
            var isClickOutsideDropdown = isClickOutside(e, dropdownRef, true);
            if (isClickOutsideDropdown) {
                setShowDropdown(false);
            }
        };
        if (typeof window !== undefined) {
            document.addEventListener('click', handleClickOnScreen);
        }
        // on component did unmount
        return function () {
            if (typeof window !== undefined) {
                document.removeEventListener('click', handleClickOnScreen);
            }
        };
    }, []);
    var renderShareList = function () {
        return (react.createElement(ShareListUl, { isMobile: isMobile },
            !isMobile && react.createElement(ShareText, null, t('Share to...')),
            react.createElement(ShareItem, { onClick: handleOnClickFacebook, isMobile: isMobile },
                react.createElement(ShareItemIcon, null,
                    react.createElement(FacebookIcon/* default */.Z, null)),
                t('Share by '),
                " Facebook"),
            react.createElement(ShareItem, { onClick: handleOnClickLinkedIn, isMobile: isMobile },
                react.createElement(ShareItemIcon, null,
                    react.createElement(LinkedInIcon/* default */.Z, null)),
                t('Share by '),
                " LinkedIn"),
            react.createElement(ShareItem, { onClick: handleOnClickCopyLink, isMobile: isMobile },
                react.createElement(ShareItemIcon, null,
                    react.createElement(CopyIcon/* default */.Z, null)),
                t('Copy link'))));
    };
    return (react.createElement(ShareButtonWrapper, null,
        react.createElement(Button/* default */.Z, { type: 'default', onClick: handleClickShare, style: (0,_tslib/* __assign */.pi)({ padding: '8px 12px' }, buttonStyle) },
            react.createElement(ShareIcon/* default */.Z, null)),
        isMounted && !isMobile && (react.createElement(ShareDropdown, { position: position },
            react.createElement(ShareWrapper, { isShow: isShow, onAnimationEnd: onAnimationEnd, ref: dropdownRef }, renderShareList()))),
        isMounted && isMobile && (react.createElement(SlideModal/* default */.Z, { isOpen: isShow, title: t('Share to...'), onBack: function () { return setShowDropdown(false); } }, renderShareList()))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SimpleTooltip; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Modal/SlideModal.js + 1 modules
var SlideModal = __webpack_require__(85124);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/SimpleTooltip.css.js
'use client';





var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n"], ["\n    display: inline-block;\n"])));
var TooltipContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    border: 1px solid ", ";\n    padding: 8px;\n    font-size: 12px;\n    border-radius: 6px;\n    max-width: ", ";\n    box-shadow: 0 2px 4px 0 rgba(224, 224, 224, 0.5);\n    &::before {\n        content: '';\n        position: absolute;\n        ", "\n        left: 0;\n        width: 100%;\n    }\n    &::after {\n        content: '';\n        position: absolute;\n        ", "\n        left: 0;\n        width: 100%;\n    }\n"], ["\n    background-color: #fff;\n    border: 1px solid ", ";\n    padding: 8px;\n    font-size: 12px;\n    border-radius: 6px;\n    max-width: ", ";\n    box-shadow: 0 2px 4px 0 rgba(224, 224, 224, 0.5);\n    &::before {\n        content: '';\n        position: absolute;\n        ", "\n        left: 0;\n        width: 100%;\n    }\n    &::after {\n        content: '';\n        position: absolute;\n        ", "\n        left: 0;\n        width: 100%;\n    }\n"])), constants/* colors.borderCard */.O9.borderCard, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth;
}, function (_a) {
    var offsetHeight = _a.offsetHeight;
    return offsetHeight &&
        "\n        top: -".concat(offsetHeight, "px;\n        height: ").concat(offsetHeight, "px;\n        ");
}, function (_a) {
    var offsetHeight = _a.offsetHeight;
    return offsetHeight &&
        "\n        bottom: -".concat(offsetHeight, "px;\n        height: ").concat(offsetHeight, "px;\n        ");
});
var TooltipContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n"], ["\n    padding: 24px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;


//# sourceMappingURL=SimpleTooltip.css.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useTransition.js
var useTransition = __webpack_require__(98638);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/Tooltip.js
'use client';










var Tooltip = (0,react.forwardRef)(function (_a, ref) {
    var content = _a.content, offsetHeight = _a.offsetHeight, show = _a.show, custom = _a.custom, restProps = (0,_tslib/* __rest */._T)(_a, ["content", "offsetHeight", "show", "custom"]);
    var _b = custom || {}, _c = _b.maxWidth, maxWidth = _c === void 0 ? '300px' : _c, _d = _b.duration, duration = _d === void 0 ? 100 : _d;
    var _e = (0,useTransition/* default */.Z)({ open: show }, {
        initial: {
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        },
        duration: duration
    }), isMounted = _e.isMounted, styles = _e.styles;
    return isMounted ? (react.createElement(TooltipContainer, (0,_tslib/* __assign */.pi)({ maxWidth: maxWidth, offsetHeight: offsetHeight, style: styles, ref: ref }, restProps), content)) : (react.createElement(react.Fragment, null));
});


//# sourceMappingURL=Tooltip.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/index.js
'use client';












var TIMEOUT = 10;
var SimpleTooltip = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b, _c = _a.gap, gap = _c === void 0 ? 5 : _c, content = _a.content, referenceElement = _a.referenceElement, isMobile = _a.isMobile, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.title, title = _e === void 0 ? null : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.isOriginal, isOriginal = _g === void 0 ? false : _g, _h = _a.tooltipClassName, tooltipClassName = _h === void 0 ? '' : _h, custom = _a.custom, _j = _a.position, position = _j === void 0 ? 'absolute' : _j, _k = _a.isShifting, isShifting = _k === void 0 ? false : _k, _l = _a.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _l === void 0 ? false : _l, _m = _a.enablePortal, enablePortal = _m === void 0 ? false : _m;
    var _o = (0,react.useState)(null), mouseOverElement = _o[0], setElementMouseOver = _o[1];
    var _p = (0,react.useState)('enter'), mouseState = _p[0], setMouseState = _p[1];
    var leaveTimeout = (0,react.useRef)(null);
    var _q = (0,react.useState)(false), isVisible = _q[0], setElementVisible = _q[1];
    var _r = (0,useFloating/* default */.Z)({
        placement: placement,
        position: position,
        config: {
            offset: gap,
            isShift: isShifting,
            useWindowAsFlippingContainer: useWindowAsFlippingContainer
        }
    }), refs = _r.refs, context = _r.context, FloatingPortal = _r.FloatingPortal;
    (0,useClickAway/* default */.Z)(function () {
        setElementVisible(false);
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    var handleMouseEnter = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (isMobile) {
            return;
        }
        setElementVisible(true);
        setElementMouseOver(e.target);
    }, [disabled]);
    var handleMouseLeave = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setMouseState('leave');
        setElementMouseOver(null);
    }, [disabled]);
    var handleMouseEnterTooltip = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setElementMouseOver(e.target);
    }, [disabled]);
    var handleMouseClick = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (!isMobile) {
            return;
        }
        setElementVisible(function (prevState) { return !prevState; });
    }, [disabled]);
    var handleMouseLeaveTooltip = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (isMobile) {
            return;
        }
        if (leaveTimeout && leaveTimeout.current)
            clearTimeout(leaveTimeout.current);
        leaveTimeout.current = setTimeout(function () {
            setElementVisible(false);
        }, TIMEOUT);
        setElementMouseOver(null);
    }, [disabled, isMobile]);
    (0,react.useEffect)(function () {
        if (isMobile) {
            return;
        }
        if (leaveTimeout && leaveTimeout.current)
            clearTimeout(leaveTimeout.current);
        leaveTimeout.current = setTimeout(function () {
            if (mouseState === 'leave' && !mouseOverElement) {
                setElementVisible(false);
                setMouseState('enter');
            }
        }, TIMEOUT);
    }, [mouseState, mouseOverElement, isMobile]);
    return (react.createElement(react.Fragment, null,
        react.createElement(Container, { ref: refs.setReference, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleMouseClick, className: className }, referenceElement),
        isMobile && !isOriginal ? (react.createElement(SlideModal/* default */.Z, { isOpen: isVisible, title: title, onBack: function () {
                setElementVisible(false);
            }, titleStyle: {
                flex: '1',
                textAlign: 'center',
                height: 20
            } },
            react.createElement(TooltipContent, null, content))) : (react.createElement(FloatingPortal, { enable: enablePortal },
            react.createElement(Tooltip, { show: isVisible, onMouseEnter: handleMouseEnterTooltip, onMouseLeave: handleMouseLeaveTooltip, content: content, style: {
                    position: context.position,
                    top: context.y,
                    left: context.x,
                    zIndex: 9999
                }, className: tooltipClassName, ref: refs.setPopup, offsetHeight: gap, custom: custom })))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 75297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SingleCheckBox; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SingleCheckBox/SingleCheckBox.css.js
'use client';






var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    padding: 4px;\n    border-radius: 8px;\n    height: ", "px;\n    position: relative;\n    opacity: 1;\n    overflow:hidden;\n    ", "\n    ", "\n"], ["\n    width: 100%;\n    padding: 4px;\n    border-radius: 8px;\n    height: ", "px;\n    position: relative;\n    opacity: 1;\n    overflow:hidden;\n    ", "\n    ", "\n"])), function (_a) {
    var height = _a.height;
    return height < 24 ? 24 : height;
}, function (_a) {
    var hasBorder = _a.hasBorder;
    if (!hasBorder) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid transparent;\n            &:hover {\n                background-color: rgb(248, 250, 255);\n            }\n        "], ["\n            border: 1px solid transparent;\n            &:hover {\n                background-color: rgb(248, 250, 255);\n            }\n        "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid rgb(217, 217, 217);\n        "], ["\n            border: 1px solid rgb(217, 217, 217);\n        "])));
}, function (_a) {
    var hasCheck = _a.hasCheck, hasBorder = _a.hasBorder;
    if (hasCheck && hasBorder) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid #a0c1ff;\n        "], ["\n            border: 1px solid #a0c1ff;\n        "])));
    }
    return '';
});
var WrapSingleChecbox = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    ", "\n    border-radius: 4px;\n    display: block;\n    position: relative;\n    opacity: 1;\n    padding: 0 10px;\n\n    ", "\n"], ["\n    width: 100%;\n    ", "\n    border-radius: 4px;\n    display: block;\n    position: relative;\n    opacity: 1;\n    padding: 0 10px;\n\n    ", "\n"])), function (_a) {
    var height = _a.height;
    if (!height) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        line-height: calc(", "px - 10px);\n        "], ["\n        line-height: calc(", "px - 10px);\n        "])), height);
}, function (_a) {
    var hasCheck = _a.hasCheck, hasBorder = _a.hasBorder;
    if (hasCheck && hasBorder) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: #eff5ff;\n            color: #003699;\n        "], ["\n            background-color: #eff5ff;\n            color: #003699;\n        "])));
    }
    return '';
});
var Label = styled_components_browser_esm/* default.label.attrs */.ZP.label.attrs(function (props) {
    return {
        colorRangeBaseOnType: (0,Colors/* getAlertColorRange */.RA)(props.alertType),
    };
})(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    left: inherit;\n    right: -99999rem;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border-radius: 3px;\n\n    border: 1px solid ", ";\n    background-color: white;\n    transition: all 0.25s;\n    cursor: pointer;\n\n    ", ":hover & {\n        border-color: ", "\n    }\n\n    &::after {\n        content: '';\n        display: block;\n        width: 9px;\n        height: 5px;\n        border-bottom: 1px solid white;\n        border-left: 1px solid white;\n        -webkit-transform: rotate(-45deg) scale(0);\n        transform: rotate(-45deg) scale(0);\n        will-change: transform;\n        transition: ease-in-out 0.25s;\n        position: absolute;\n        top: 4px;\n        left: 4px;\n    }\n\n    ", "\n\n    ", "\n"], ["\n    position: absolute;\n    top: 50%;\n    left: inherit;\n    right: -99999rem;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border-radius: 3px;\n\n    border: 1px solid ", ";\n    background-color: white;\n    transition: all 0.25s;\n    cursor: pointer;\n\n    ", ":hover & {\n        border-color: ", "\n    }\n\n    &::after {\n        content: '';\n        display: block;\n        width: 9px;\n        height: 5px;\n        border-bottom: 1px solid white;\n        border-left: 1px solid white;\n        -webkit-transform: rotate(-45deg) scale(0);\n        transform: rotate(-45deg) scale(0);\n        will-change: transform;\n        transition: ease-in-out 0.25s;\n        position: absolute;\n        top: 4px;\n        left: 4px;\n    }\n\n    ", "\n\n    ", "\n"])), function (props) {
    if (props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return Colors/* colors.grey.40 */.O9.grey[40];
}, Container, function (props) {
    if (props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    else if (props.disabled) {
        return Colors/* colors.grey.40 */.O9.grey[40];
    }
    return props.colorRangeBaseOnType[70];
}, function (_a) {
    var disabled = _a.disabled;
    if (!disabled) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: #333;\n            opacity: 0.4;\n        "], ["\n            color: #333;\n            opacity: 0.4;\n        "])));
}, function (_a) {
    var isLeftCheckbox = _a.isLeftCheckbox;
    if (!isLeftCheckbox) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            left: initial;\n            right: calc(100% - 26px);\n        "], ["\n            left: initial;\n            right: calc(100% - 26px);\n        "])));
});
var LabelText = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    white-space: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ", "\n\n    ", "\n"], ["\n    white-space: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var textEllipsis = _a.textEllipsis;
    return (textEllipsis ? 'nowrap' : 'unset');
}, function (_a) {
    var isDisabled = _a.isDisabled;
    if (!isDisabled) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: #333;\n            opacity: 0.4;\n        "], ["\n            color: #333;\n            opacity: 0.4;\n        "])));
}, function (_a) {
    var isLeftCheckbox = _a.isLeftCheckbox;
    if (!isLeftCheckbox) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-left: 26px;\n        "], ["\n            margin-left: 26px;\n        "])));
});
var Input = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(function (props) {
    return {
        colorRangeBaseOnType: (0,Colors/* getAlertColorRange */.RA)(props.alertType),
    };
})(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    cursor: pointer;\n\n    &:checked ~ ", "::after {\n        -webkit-transform: rotate(-45deg) scale(1);\n        transform: rotate(-45deg) scale(1);\n    }\n    &:checked ~ ", " {\n        background-color: ", ";\n        border-color: ", ";\n    }\n    &:disabled {\n        cursor: no-drop;\n    }\n    &:disabled ~ ", " {\n        cursor: no-drop;\n    }\n    &:disabled ~ ", " {\n        cursor: no-drop;\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    cursor: pointer;\n\n    &:checked ~ ", "::after {\n        -webkit-transform: rotate(-45deg) scale(1);\n        transform: rotate(-45deg) scale(1);\n    }\n    &:checked ~ ", " {\n        background-color: ", ";\n        border-color: ", ";\n    }\n    &:disabled {\n        cursor: no-drop;\n    }\n    &:disabled ~ ", " {\n        cursor: no-drop;\n    }\n    &:disabled ~ ", " {\n        cursor: no-drop;\n    }\n"])), Label, Label, function (props) { return props.colorRangeBaseOnType[40]; }, function (props) { return props.colorRangeBaseOnType[40]; }, Label, LabelText);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;


//# sourceMappingURL=SingleCheckBox.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SingleCheckBox/index.js
'use client';






var SingleCheckBox = function (props) {
    var id = props.id, label = props.label, isChecked = props.isChecked, onChecked = props.onChecked, disabled = props.disabled, _a = props.isLeftCheckbox, isLeftCheckbox = _a === void 0 ? false : _a, hoverBgOff = props.hoverBgOff, _b = props.textEllipsis, textEllipsis = _b === void 0 ? true : _b, _c = props.alertType, alertType = _c === void 0 ? constants/* EAlertType.info */.P.info : _c; props.noBg; var _e = props.height, height = _e === void 0 ? 40 : _e, _f = props.isShowTooltip, isShowTooltip = _f === void 0 ? false : _f, _g = props.hasBorder, hasBorder = _g === void 0 ? false : _g, rest = (0,_tslib/* __rest */._T)(props, ["id", "label", "isChecked", "onChecked", "disabled", "isLeftCheckbox", "hoverBgOff", "textEllipsis", "alertType", "noBg", "height", "isShowTooltip", "hasBorder"]);
    var handleOnChange = function (e) {
        e.stopPropagation();
        onChecked(e.target.checked ? id : '');
    };
    return (react.createElement(Container, { hasCheck: isChecked, isDisabled: disabled, height: height, hoverBgOff: hoverBgOff, hasBorder: hasBorder },
        react.createElement(WrapSingleChecbox, { height: height, hasCheck: isChecked, hasBorder: hasBorder },
            react.createElement(Input, (0,_tslib/* __assign */.pi)({ disabled: disabled, type: 'checkbox', id: id, alertType: alertType, checked: isChecked, onChange: function (e) { return handleOnChange(e); } }, rest)),
            react.createElement(Label, { alertType: alertType, checked: isChecked, htmlFor: id, isLeftCheckbox: isLeftCheckbox, disabled: disabled }),
            react.createElement(LabelText, { isLeftCheckbox: isLeftCheckbox, isDisabled: disabled, textEllipsis: textEllipsis, title: isShowTooltip ? label : '' }, label))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 51979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "__": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96306);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';






var Input = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].input.attrs */ .ZP.input.attrs(function (props) {
    return {
        colorRangeBaseOnType: (0,_Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getAlertColorRange */ .RA)(props.alertType)
    };
})(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    -webkit-appearance: none;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid\n        ", ";\n    background: unset;\n    opacity: ", ";\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n\n    ", "\n\n    &:checked {\n        border: 5px solid\n            ", ";\n    }\n"], ["\n    -webkit-appearance: none;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid\n        ", ";\n    background: unset;\n    opacity: ", ";\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n\n    ", "\n\n    &:checked {\n        border: 5px solid\n            ", ";\n    }\n"])), function (props) {
    if (props.alertType === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .EAlertType.danger */ .P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey[40] */ .O9.grey[40];
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.4 : 1);
}, function (_a) {
    var isDropdownRadio = _a.isDropdownRadio, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["isDropdownRadio"]);
    return !isDropdownRadio && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n            &:hover {\n                border-color: ", ";\n            }\n        "], ["\n            &:hover {\n                border-color: ", ";\n            }\n        "])), props.alertType === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .EAlertType.danger */ .P.danger || props.checked
        ? props.colorRangeBaseOnType[40]
        : props.disabled
            ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey[40] */ .O9.grey[40]
            : props.colorRangeBaseOnType[70]);
}, function (props) {
    return props.isHover
        ? "\n        border-color: ".concat(props.colorRangeBaseOnType[70], ";\n    ")
        : '';
}, function (props) {
    if (props.alertType === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .EAlertType.danger */ .P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return props.colorRangeBaseOnType[40];
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].label */ .ZP.label(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    flex-direction: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n    margin: 0;\n    column-gap: 16px;\n    height: ", ";\n    font-size: 14px;\n    ", ";\n    ", "\n    cursor: ", ";\n    ", ";\n    ", "\n    > * {\n        pointer-events: ", ";\n    }\n    input[type='radio'] {\n        margin: 0;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    ", "\n"], ["\n    display: flex;\n    flex-direction: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n    margin: 0;\n    column-gap: 16px;\n    height: ", ";\n    font-size: 14px;\n    ", ";\n    ", "\n    cursor: ", ";\n    ", ";\n    ", "\n    > * {\n        pointer-events: ", ";\n    }\n    input[type='radio'] {\n        margin: 0;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    ", "\n"])), function (_a) {
    var isLeftRadio = _a.isLeftRadio;
    return (isLeftRadio ? 'row' : 'row-reverse');
}, function (_a) {
    var customLabel = _a.customLabel;
    return (customLabel ? 'start' : 'center');
}, function (_a) {
    var customLabel = _a.customLabel;
    return (customLabel ? 'space-between' : 'start');
}, function (_a) {
    var noLabel = _a.noLabel;
    return !noLabel && 'padding: 0 8px';
}, function (_a) {
    var height = _a.height, customLabel = _a.customLabel;
    if (!customLabel) {
        return height < 24 ? '24px' : "".concat(height, "px");
    }
    return 'auto';
}, function (_a) {
    var width = _a.width;
    return width && "width: ".concat(width);
}, function (_a) {
    var isDropdownRadio = _a.isDropdownRadio, disabled = _a.disabled, notLabel = _a.notLabel;
    return isDropdownRadio && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n            &:hover {\n                background-color: ", ";\n                ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n                ", ";\n            }\n        "])), disabled ? "tranparent" : "".concat(_Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[99] */ .O9.primary[99]), notLabel && 'background-color: unset;');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var notLabel = _a.notLabel;
    return notLabel && 'background-color: unset;';
}, function (_a) {
    var isHover = _a.isHover;
    return (isHover ? "background-color: ".concat(_Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.bgHover */ .O9.bgHover, ";") : '');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'all');
}, function (_a) {
    var checked = _a.checked, isDropdownRadio = _a.isDropdownRadio; _a.disabled;
    return checked &&
        isDropdownRadio && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n            background: ", " !important;\n            p {\n                color: ", " !important;\n            }\n        "], ["\n            background: ", " !important;\n            p {\n                color: ", " !important;\n            }\n        "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[95] */ .O9.primary[95], _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primary[40] */ .O9.primary[40]);
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n"], ["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .colors.textColor */ .O9.textColor, function (_a) {
    var isDisable = _a.isDisable;
    return (isDisable ? 0.4 : 1);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


//# sourceMappingURL=Radio.css.js.map


/***/ }),

/***/ 12056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleRadio; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Radio_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51979);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
'use client';





var SingleRadio = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.id, id = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.name, name = _e === void 0 ? '' : _e, checked = _a.checked, onChange = _a.onChange, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.width, width = _g === void 0 ? '100%' : _g, _h = _a.isLeftRadio, isLeftRadio = _h === void 0 ? false : _h, _j = _a.alertType, alertType = _j === void 0 ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.info */ .P.info : _j, _k = _a.height, height = _k === void 0 ? 36 : _k, 
    // For custom only
    customValue = _a.customValue, _l = _a.isCustomLabel, isCustomLabel = _l === void 0 ? false : _l, decoration = _a.decoration, _m = _a.isHover, isHover = _m === void 0 ? false : _m, _o = _a.isDropdownRadio, isDropdownRadio = _o === void 0 ? false : _o;
    var handleChecked = function () {
        if (disabled)
            return;
        onChange(id);
    };
    var uid = "".concat(id, "-").concat(name, "-radio-button");
    var renderLabel = function () {
        if (customValue)
            return customValue;
        return label ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Radio_css_js__WEBPACK_IMPORTED_MODULE_2__/* .Label */ .__, { isDisable: disabled }, typeof label === 'function' ? label() : label) : null;
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Radio_css_js__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { disabled: disabled, htmlFor: uid, className: className, width: width, notLabel: !label, isLeftRadio: isLeftRadio, height: height, isDropdownRadio: isDropdownRadio, noLabel: label === '', customLabel: isCustomLabel, isHover: isHover, checked: !!checked },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Radio_css_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, { id: uid, checked: checked, onClick: handleChecked, type: 'radio', disabled: disabled, alertType: alertType, name: name, readOnly: true, isHover: isHover, isDropdownRadio: isDropdownRadio }),
        renderLabel(),
        decoration));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
'use client';





var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    100% {\n        transform: translateX(100%);\n    }\n"], ["\n    100% {\n        transform: translateX(100%);\n    }\n"])));
var StyledSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"], ["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"])), function (props) { return props.height; }, function (props) { return (props.width ? "".concat(props.width, "px") : '100%'); }, shimmer);
function Skeleton(props) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSkeleton, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, props));
}
var templateObject_1, templateObject_2;


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 5817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/Slider.css.js
'use client';




var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"])), function (_a) {
    var height = _a.height;
    return "".concat(height, "px");
});
var SliderContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"], ["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"], ["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"])), function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement;
});
styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: 100%;\n    ", "\n"], ["\n    display: inline-block;\n    height: 100%;\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: ", "px !important;\n    "], ["\n        width: ", "px !important;\n    "])), widthElement);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


//# sourceMappingURL=Slider.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/Slides/Slides.css.js
'use client';




var Slides_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_1 || (Slides_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"], ["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"])), function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement;
});
var Slide = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_3 || (Slides_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: 100%;\n    ", "\n"], ["\n    display: inline-block;\n    height: 100%;\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return (0,styled_components_browser_esm/* css */.iv)(Slides_css_templateObject_2 || (Slides_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: ", "px !important;\n    "], ["\n        width: ", "px !important;\n    "])), widthElement);
});
var Slides_css_templateObject_1, Slides_css_templateObject_2, Slides_css_templateObject_3;


//# sourceMappingURL=Slides.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/Slides/index.js
'use client';






var Slides = function (props) {
    var innerRef = props.innerRef, spaceBetween = props.spaceBetween, elementPerView = props.elementPerView, widthElement = props.widthElement, children = props.children, loading = props.loading, _a = props.loadingHeight, loadingHeight = _a === void 0 ? 250 : _a, extraElement = props.extraElement, activeItem = props.activeItem, activeClassName = props.activeClassName;
    var renderLoading = function () {
        return (react.createElement(Slides_css_Container, { spaceElement: spaceBetween }, (0,_tslib/* __spreadArray */.ev)([], Array(elementPerView), true).map(function (_, idx) { return (react.createElement(Slide, { widthElement: widthElement, key: idx },
            react.createElement(Skeleton/* default */.Z, { height: loadingHeight, width: widthElement }))); })));
    };
    var renderSlides = function () {
        var slides;
        if (Array.isArray(children) && extraElement) {
            slides = Object.values(children);
            var afterSlides = slides.concat(slides.slice(0, extraElement));
            var beforeSlides = slides.slice(slides.length - extraElement).concat(afterSlides);
            slides = beforeSlides;
        }
        else {
            slides = [children];
        }
        return (react.createElement(Slides_css_Container, { ref: innerRef, spaceElement: spaceBetween }, slides.map(function (item, idx) { return (react.createElement(Slide, { className: idx === activeItem + extraElement ? activeClassName : '', widthElement: widthElement, key: idx }, item)); })));
    };
    return loading ? renderLoading() : renderSlides();
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/index.js + 1 modules
var Pagination = __webpack_require__(56479);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/index.js
'use client';









var Slider = function (props) {
    var slidesProps = props.slides, id = props.id, paginationProps = props.pagination, containerProps = props.container, autoEnable = props.autoEnable, _a = props.autoTime, autoTime = _a === void 0 ? 4000 : _a, loadingEnable = props.loadingEnable, loadingHeight = props.loadingHeight, _b = props.transitionTime, transitionTime = _b === void 0 ? 250 : _b, _c = props.transitionSensitivity, transitionSensitivity = _c === void 0 ? 0.15 : _c, _d = props.isRobot, isRobot = _d === void 0 ? false : _d, _e = props.className, className = _e === void 0 ? '' : _e, children = props.children;
    // init value props
    var slides = (0,_tslib/* __assign */.pi)({ spaceBetween: 8, elementPerView: 1 }, slidesProps);
    var pagination = (0,_tslib/* __assign */.pi)({ elementPerPage: 1, type: 'default', position: 'default', extraPage: 2, defaultPage: 0 }, paginationProps);
    var container = (0,_tslib/* __assign */.pi)({}, containerProps);
    var _f = (0,react.useState)(null), sliderContainer = _f[0], setSliderContainer = _f[1];
    var _g = (0,react.useState)(null), innerSlider = _g[0], setInnerSlider = _g[1];
    var _h = (0,react.useState)(null), containerElement = _h[0], setContainerElement = _h[1];
    var calculateCenterIndex = function () {
        return Math.ceil((slides.elementPerView || 1) / 2) - 1;
    };
    var calculateAmountOfPage = function () {
        var childrenLength = Array.isArray(children) ? Object.values(children).length : 1;
        if (slides.elementPerView && pagination.elementPerPage && children)
            return Math.ceil((childrenLength - pagination.elementPerPage) / pagination.elementPerPage) + 1;
        return 0;
    };
    var _j = (0,react.useState)(0), paginationIndex = _j[0], setPaginationIndex = _j[1];
    var _k = (0,react.useState)(calculateAmountOfPage()), paginationAmount = _k[0], setPaginationAmount = _k[1];
    var _l = (0,react.useState)(false), paginationDisable = _l[0], setPaginationDisable = _l[1];
    // page additional start & end list slides
    // if not enough page to add, extra = 0
    var getExtraPage = function () {
        if (pagination.extraPage) {
            if (paginationAmount < 2 && paginationAmount <= pagination.extraPage) {
                return 0;
            }
            else {
                return pagination.extraPage;
            }
        }
        return 0;
    };
    var getWidthSlideElement = function () {
        if (sliderContainer) {
            var container_1 = sliderContainer.getBoundingClientRect();
            var elementPerView = slides.elementPerView || 0;
            var spaceBetween = slides.spaceBetween || 0;
            return container_1.width / elementPerView - (spaceBetween * (elementPerView - 1)) / elementPerView;
        }
        return 0;
    };
    var isTouchDevice = function () {
        return !!('ontouchstart' in window);
    };
    var smoothTransition = function (position) {
        if (innerSlider) {
            innerSlider.style.transform = "translateX(-".concat(position, "px)");
            innerSlider.style.transition = "".concat(transitionTime, "ms");
            setTimeout(function () { return (innerSlider.style.transition = '0s'); }, transitionTime);
        }
    };
    var handlePaginationChange = function (idx) {
        if (innerSlider && sliderContainer) {
            setPaginationDisable(true);
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            var widthEachPage_1 = (getWidthSlideElement() + spaceBetween) * elementPerPage;
            smoothTransition((idx + getExtraPage()) * widthEachPage_1);
            if (idx < 0) {
                setTimeout(function () {
                    innerSlider.style.transform = "translateX(-".concat((paginationAmount + getExtraPage() - 1) * widthEachPage_1, "px)");
                }, transitionTime);
                setPaginationIndex(paginationAmount - 1);
                setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
                return;
            }
            if (idx >= paginationAmount) {
                setTimeout(function () {
                    innerSlider.style.transform = "translateX(-".concat(getExtraPage() * widthEachPage_1, "px)");
                }, transitionTime);
                setPaginationIndex(0);
                setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
                return;
            }
            setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
            setPaginationIndex(idx);
        }
    };
    // add grab and move slide event
    (0,react.useEffect)(function () {
        if (sliderContainer && innerSlider && paginationAmount) {
            var body_1 = document.querySelector('body');
            var scrollStatus_1 = ''; // detect mouse move is horizontal or vertical
            var pressed_1 = false; // mouse down or not?
            var startX_1; // position X when mouse down
            var x_1; // position X when mouse move
            var downX_1; // screen X when mouse down
            var downY_1; // screen Y when mouse down
            var upX_1; // screen X when mouse up
            // position transform of InnerSlider
            var getInnerPosition_1 = function () {
                var position = innerSlider.style.transform.match(/[-.\d]/g);
                if (position)
                    return Number(position.join(''));
                else
                    return 0;
            };
            // move <Slides> back to position of nearest element
            var checkBoundary_1 = function () {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var position = getInnerPosition_1();
                var spaceBetween = slides.spaceBetween || 0;
                var elementPerPage = pagination.elementPerPage || 0;
                // width on a page, a page can have so many slide
                var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                // handle grab slides move out container on left side
                if (position > 0) {
                    // because if only 1 item, next index will be 0
                    var index_1 = paginationAmount === 1 ? 0 : paginationAmount;
                    smoothTransition(0);
                    setTimeout(function () {
                        innerSlider.style.transform = "translateX(-".concat(index_1 * widthEachPage, "px)");
                    }, transitionTime);
                    setPaginationIndex(index_1 - getExtraPage());
                    return;
                }
                // handle grab slides move out container on right side
                if (inner.right < outer.right) {
                    var index_2 = getExtraPage();
                    smoothTransition(inner.width - outer.width);
                    setTimeout(function () {
                        innerSlider.style.transform = "translateX(-".concat(index_2 * widthEachPage, "px)");
                    }, transitionTime);
                    setPaginationIndex(index_2 - getExtraPage());
                    return;
                }
                // handle grab slides move in container
                if (position <= 0) {
                    // if move to left downX < upX will rounding 0.85 -> 0 & 0.86 -> 1, make grab move smooth
                    var indexPage = Math.abs((0,helpers/* fixedNumber */.Bs)(position / widthEachPage, downX_1 < upX_1 ? 1 - transitionSensitivity : transitionSensitivity));
                    smoothTransition(indexPage * widthEachPage);
                    // order page: 0 1 2 3 4 5 6 7 - 0 1 6 7 is additional page - 2 3 4 5 is real page
                    // if indexPage is addtional page, transform it to real page
                    // indexPage = 0 => index = 4 | indexPage = 6 => index = 2
                    if (indexPage < getExtraPage()) {
                        var index_3 = paginationAmount + indexPage;
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(index_3 * widthEachPage, "px)");
                        }, transitionTime);
                        setPaginationIndex(index_3 - getExtraPage());
                        return;
                    }
                    if (indexPage >= getExtraPage() + paginationAmount) {
                        var index_4 = indexPage - paginationAmount;
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(index_4 * widthEachPage, "px)");
                        }, transitionTime);
                        setPaginationIndex(index_4 - getExtraPage());
                        return;
                    }
                    setPaginationIndex(indexPage - getExtraPage());
                }
            };
            if (!isTouchDevice()) {
                // Desktop device event
                sliderContainer.addEventListener('mousedown', function (e) {
                    pressed_1 = true;
                    startX_1 = e.clientX - getInnerPosition_1();
                    downX_1 = e.clientX;
                    if (body_1)
                        body_1.style.cursor = 'grabbing';
                });
                window.addEventListener('mousemove', function (e) {
                    if (!pressed_1)
                        return;
                    e.preventDefault();
                    x_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'none'; // prevent click child after mouse up
                    innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                });
                window.addEventListener('mouseup', function (e) {
                    if (!pressed_1)
                        return;
                    if (body_1)
                        body_1.style.cursor = 'default';
                    pressed_1 = false;
                    upX_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'auto';
                    checkBoundary_1();
                });
            }
            else {
                // Mobile device event
                sliderContainer.addEventListener('touchstart', function (e) {
                    pressed_1 = true;
                    downX_1 = e.changedTouches[0].pageX;
                    downY_1 = e.changedTouches[0].pageY;
                    startX_1 = e.changedTouches[0].pageX - getInnerPosition_1();
                });
                sliderContainer.addEventListener('touchmove', function (e) {
                    if (!pressed_1)
                        return;
                    // find out touch move is vertical or horizontal, do nothing if scrollStatus !== 'horizontal'
                    if (scrollStatus_1 === '' && Math.abs(downY_1 - e.changedTouches[0].pageY) > 10) {
                        scrollStatus_1 = 'vertical';
                        return;
                    }
                    if (scrollStatus_1 === '' && Math.abs(downX_1 - e.changedTouches[0].pageX) > 10) {
                        scrollStatus_1 = 'horizontal';
                        return;
                    }
                    if (scrollStatus_1 === 'horizontal') {
                        e.preventDefault();
                        x_1 = e.changedTouches[0].pageX;
                        innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                    }
                });
                sliderContainer.addEventListener('touchend', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
                sliderContainer.addEventListener('touchcancel', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
            }
        }
    }, [innerSlider, sliderContainer, paginationAmount]);
    // handle automation transform slide event
    (0,react.useEffect)(function () {
        if (autoEnable && containerElement && innerSlider && paginationAmount && getExtraPage() > 0) {
            var interval_1 = null;
            var startInterval_1 = function () {
                var elements = containerElement.querySelectorAll("[data-id^=".concat(id, "-pagination]"));
                var max = paginationAmount;
                var index = paginationIndex;
                elements.forEach(function (e, idx) {
                    var _a;
                    if ((_a = e.getAttribute('data-id')) === null || _a === void 0 ? void 0 : _a.includes('true'))
                        index = idx;
                });
                interval_1 = setInterval(function () {
                    var spaceBetween = slides.spaceBetween || 0;
                    var elementPerPage = pagination.elementPerPage || 0;
                    if (index === max - 1) {
                        var widthEachPage_2 = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                        var idx_1 = getExtraPage();
                        smoothTransition((paginationAmount + getExtraPage()) * widthEachPage_2);
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(idx_1 * widthEachPage_2, "px)");
                        }, transitionTime);
                        setPaginationIndex(0);
                        index = 0;
                    }
                    else {
                        handlePaginationChange(index + 1);
                        index++;
                    }
                }, autoTime);
            };
            var stopInterval_1 = function () {
                clearInterval(interval_1);
                interval_1 = null;
            };
            startInterval_1();
            if (isTouchDevice()) {
                containerElement.addEventListener('touchstart', function () { return setTimeout(stopInterval_1, 200); });
                containerElement.addEventListener('touchend', function () { return setTimeout(startInterval_1, 200); });
            }
            else {
                containerElement.addEventListener('mouseover', stopInterval_1);
                containerElement.addEventListener('mouseout', startInterval_1);
            }
        }
    }, [autoEnable, containerElement, innerSlider, paginationAmount]);
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (children && slides.elementPerView)
            setPaginationAmount(calculateAmountOfPage());
    }, [children, slides.elementPerView]);
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        pagination.onPageChange && pagination.onPageChange(paginationIndex);
    }, [paginationIndex]);
    // transform to position of start page at begin slideshow
    (0,react.useEffect)(function () {
        if (innerSlider && children) {
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
            innerSlider.style.transform = "translateX(-".concat((getExtraPage() + (pagination.defaultPage || 0)) * widthEachPage, "px)");
            setPaginationIndex(pagination.defaultPage || 0);
        }
    }, [innerSlider, children]);
    return !isRobot ? (react.createElement(Container, { id: id, style: container.style, ref: setContainerElement, className: className },
        react.createElement(SliderContainer, { style: slides.style, ref: setSliderContainer },
            react.createElement("div", { style: {
                    transform: "translateX(".concat((getWidthSlideElement() + (slides.spaceBetween || 0)) * calculateCenterIndex(), "px)")
                } },
                react.createElement(Slides, { innerRef: setInnerSlider, spaceBetween: slides.spaceBetween, elementPerView: slides.elementPerView, widthElement: getWidthSlideElement(), loading: loadingEnable, loadingHeight: loadingHeight, extraElement: getExtraPage(), activeItem: paginationIndex, activeClassName: pagination.activeClassName }, children))),
        pagination.type !== 'none' && (react.createElement(Pagination/* default */.Z, { type: pagination.type, position: pagination.position, style: pagination.style, isLoading: loadingEnable, id: "".concat(id, "-pagination"), onItemClick: function (idx) { return handlePaginationChange(idx); }, activeItem: paginationIndex, amountItem: paginationAmount, maxItem: (pagination.maxShow || 0) > paginationAmount ? paginationAmount : pagination.maxShow, styleString: pagination.styleString, customNavigation: pagination.navigation, isDisable: paginationDisable, isLoop: true })))) : (react.createElement(react.Fragment, null, children));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 56479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/Pagination.css.js
'use client';





var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    ", "\n"])), function (_a) {
    var position = _a.position, styleString = _a.styleString;
    switch (position) {
        case 'absolute':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    position: absolute;\n                    left: 50%;\n                    bottom: 10px;\n                    transform: translateX(-50%);\n                    ", "\n                "], ["\n                    position: absolute;\n                    left: 50%;\n                    bottom: 10px;\n                    transform: translateX(-50%);\n                    ", "\n                "])), styleString);
        default:
            return styleString;
    }
});
var PaginationWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    overflow: hidden;\n    width: ", ";\n"], ["\n    overflow: hidden;\n    width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return (width ? "".concat(width, "px") : 'auto');
});
var PaginationList = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    transform: translateX(-", "px);\n    transition: 0.25s;\n"], ["\n    display: flex;\n    align-items: center;\n    transform: translateX(-", "px);\n    transition: 0.25s;\n"])), function (_a) {
    var xPosition = _a.xPosition;
    return xPosition;
});
var PaginationItem = styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 5px;\n    cursor: pointer;\n"], ["\n    padding: 5px;\n    cursor: pointer;\n"])));
var PaginationIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-right: ", ";\n    padding-left: ", ";\n    display: inline-flex;\n    cursor: pointer;\n\n    svg path {\n        transition: 0.25s;\n    }\n\n    &:hover {\n        svg path {\n            fill: ", " !important;\n        }\n    }\n\n    ", "\n\n    ", "\n    ", "\n"], ["\n    padding-right: ", ";\n    padding-left: ", ";\n    display: inline-flex;\n    cursor: pointer;\n\n    svg path {\n        transition: 0.25s;\n    }\n\n    &:hover {\n        svg path {\n            fill: ", " !important;\n        }\n    }\n\n    ", "\n\n    ", "\n    ", "\n"])), function (_a) {
    var left = _a.left;
    return left && '15px';
}, function (_a) {
    var right = _a.right;
    return right && '15px';
}, constants/* colors.buttonColor */.O9.buttonColor, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n            opacity: 0.3;\n\n            &:hover {\n                svg path {\n                    fill: #333333 !important;\n                }\n            }\n        "], ["\n            pointer-events: none;\n            opacity: 0.3;\n\n            &:hover {\n                svg path {\n                    fill: #333333 !important;\n                }\n            }\n        "])));
}, function (_a) {
    var position = _a.position;
    switch (position) {
        case 'left':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "], ["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "])));
        case 'right':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    right: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "], ["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    right: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "])));
        default:
            return '';
    }
}, function (_a) {
    var styleString = _a.styleString;
    return styleString;
});
var Item = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: 0.25s;\n\n    ", "\n"], ["\n    transition: 0.25s;\n\n    ", "\n"])), function (_a) {
    var type = _a.type, active = _a.active;
    switch (type) {
        case 'white':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "])), active ? 'white' : 'transparent');
        case 'whiteArrowWithPagination':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "])), active ? 'white' : 'transparent');
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                "])), active ? constants/* colors.primaryColor */.O9.primaryColor : '#e5e5ea');
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


//# sourceMappingURL=Pagination.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedLeft/index.js
var ArrowRoundedLeft = __webpack_require__(68996);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedRight/index.js
var ArrowRoundedRight = __webpack_require__(2284);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/index.js
'use client';








var Pagination = function (props) {
    var onItemClick = props.onItemClick, amountItem = props.amountItem, activeItem = props.activeItem, id = props.id, type = props.type, position = props.position, isLoading = props.isLoading, maxItem = props.maxItem, style = props.style, _a = props.styleString, styleString = _a === void 0 ? '' : _a, customNavigation = props.customNavigation, _b = props.isDisable, isDisable = _b === void 0 ? false : _b, isLoop = props.isLoop;
    var getWidthPaginationItem = function () {
        switch (type) {
            case 'defaultNotArrow':
                return 20;
            case 'white':
                return 30;
            case 'whiteArrowOnly':
                return 0;
            default:
                return 20;
        }
    };
    var renderPagination = function () {
        var x = 0;
        var middleItem = 0;
        if (maxItem && maxItem < amountItem) {
            middleItem = maxItem % 2 === 0 ? Math.floor(maxItem / 2) - 1 : Math.floor(maxItem / 2);
            if (activeItem > middleItem && activeItem < amountItem - middleItem) {
                x = getWidthPaginationItem() * (activeItem - middleItem);
            }
            if (activeItem >= amountItem - (maxItem - middleItem - 1)) {
                x = getWidthPaginationItem() * (amountItem - maxItem);
            }
        }
        if (amountItem <= 1)
            return react.createElement(react.Fragment, null);
        switch (type) {
            case 'defaultNotArrow':
                return (react.createElement(Container, { style: style, position: position, styleString: styleString },
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); })))));
            case 'white':
                return (react.createElement(Container, { style: style, position: position, styleString: styleString },
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); })))));
            case 'whiteArrowOnly': {
                return (react.createElement(react.Fragment, null,
                    react.createElement(PaginationIcon, { position: 'left', disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); }, className: 'navigation-prev', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon : react.createElement(ArrowRoundedLeft/* default */.Z, null)),
                    react.createElement(PaginationIcon, { position: 'right', disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); }, className: 'navigation-next', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon : react.createElement(ArrowRoundedRight/* default */.Z, null))));
            }
            case 'whiteArrowWithPagination': {
                return (react.createElement(react.Fragment, null,
                    react.createElement(PaginationIcon, { position: 'left', disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); }, className: 'navigation-prev', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon : react.createElement(ArrowRoundedLeft/* default */.Z, null)),
                    react.createElement(Container, { style: style, position: position, styleString: styleString },
                        react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                            react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                                react.createElement(Item, { type: type, active: activeItem === idx }))); })))),
                    react.createElement(PaginationIcon, { position: 'right', disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); }, className: 'navigation-next', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon : react.createElement(ArrowRoundedRight/* default */.Z, null))));
            }
            default:
                return (react.createElement(Container, { style: style, position: position },
                    react.createElement(PaginationIcon, { left: true, disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); } },
                        react.createElement(ArrowRoundedLeft/* default */.Z, null)),
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { "data-id": "".concat(id, "-").concat(activeItem === idx), key: idx, onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); }))),
                    react.createElement(PaginationIcon, { right: true, disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); } },
                        react.createElement(ArrowRoundedRight/* default */.Z, null))));
        }
    };
    var renderLoading = function () {
        return (react.createElement(Container, { style: style, styleString: styleString },
            react.createElement(PaginationIcon, { left: true, disabled: true },
                react.createElement(ArrowRoundedLeft/* default */.Z, null)),
            react.createElement(PaginationItem, null,
                react.createElement(Skeleton/* default */.Z, { height: 10, width: 100 })),
            react.createElement(PaginationIcon, { right: true, disabled: true },
                react.createElement(ArrowRoundedRight/* default */.Z, null))));
    };
    return isLoading ? renderLoading() : renderPagination();
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tag/type.js
'use client';

var ETag;
(function (ETag) {
    ETag["DEFAULT"] = "default";
    ETag["HIGHLIGHT"] = "highlight";
})(ETag || (ETag = {}));


//# sourceMappingURL=type.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tag/Tag.css.js
'use client';







var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n"], ["\n    display: ", ";\n"])), function (_a) {
    var display = _a.display;
    return display !== null && display !== void 0 ? display : 'inline-block';
});
var TagWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    z-index: 1;\n    ", "\n    background: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: ", ";\n    gap: ", ";\n    ", "\n\n    transition: all 0.25s;\n    ", ";\n    ", ";\n    cursor: ", ";\n    &:focus {\n        border-color: ", ";\n        background-color: ", ";\n    }\n    &:hover {\n        background-color: ", ";\n        border-color: ", ";\n        ", "\n        ", "\n        ", ";\n    }\n\n    ", "\n\n    ", "\n\n"], ["\n    position: relative;\n    z-index: 1;\n    ", "\n    background: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: ", ";\n    gap: ", ";\n    ", "\n\n    transition: all 0.25s;\n    ", ";\n    ", ";\n    cursor: ", ";\n    &:focus {\n        border-color: ", ";\n        background-color: ", ";\n    }\n    &:hover {\n        background-color: ", ";\n        border-color: ", ";\n        ", "\n        ", "\n        ", ";\n    }\n\n    ", "\n\n    ", "\n\n"])), function (_a) {
    var haveBorder = _a.haveBorder, borderColor = _a.borderColor;
    return (haveBorder ? "border: 1px solid ".concat(borderColor !== null && borderColor !== void 0 ? borderColor : Colors/* colors.grey.90 */.O9.grey[90], ";") : '');
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : Colors/* colors.grey.99 */.O9.grey[99];
}, function (_a) {
    var type = _a.type;
    return (type === ETag.HIGHLIGHT ? 'column' : 'row');
}, function (_a) {
    var type = _a.type;
    return (type === ETag.HIGHLIGHT ? '4px' : '8px');
}, function (_a) {
    var type = _a.type, isHaveIcon = _a.isHaveIcon, isMobile = _a.isMobile, readOnly = _a.readOnly, isShowIcon = _a.isShowIcon, size = _a.size;
    var paddingHaveIcon = size === 'large' ? ' 10px 26px 10px 10px' : ' 8px 26px 8px 8px';
    var paddingNoIcon = ' 8px';
    var paddingFixed = (isHaveIcon && isShowIcon) ? paddingHaveIcon : paddingNoIcon;
    return ((isHaveIcon && isMobile) || isShowIcon) && !readOnly
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  padding: ", ";\n              "], ["\n                  padding: ", ";\n              "])), type === ETag.HIGHLIGHT ? ' 12px 8px' : paddingFixed) : (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  padding: ", ";\n              "], ["\n                  padding: ", ";\n              "])), type === ETag.HIGHLIGHT ? '12px 8px' : paddingFixed);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return "max-width: ".concat(maxWidth);
}, function (_a) {
    var width = _a.width;
    return "width: ".concat(width);
}, function (_a) {
    var readOnly = _a.readOnly;
    return (readOnly ? 'auto' : 'pointer');
}, Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.80 */.O9.primary[80], function (_a) {
    var type = _a.type, isHaveIcon = _a.isHaveIcon, readOnly = _a.readOnly, size = _a.size;
    var paddingHaveIcon = ' 8px 26px 8px 8px';
    var paddingNoIcon = ' 8px';
    var paddingFixed = isHaveIcon ? paddingHaveIcon : paddingNoIcon;
    return !readOnly ? (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    padding: ", ";\n                "], ["\n                    padding: ", ";\n                "])), type === ETag.HIGHLIGHT ? '12px 8px' : "".concat(size === 'large' ? ' 10px 26px 10px 10px' : paddingFixed)) : (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    padding: ", ";\n                "], ["\n                    padding: ", ";\n                "])), type === ETag.HIGHLIGHT ? '12px 8px' : "".concat(size === 'large' ? ' 10px 8px' : paddingFixed));
}, function (_a) {
    var readOnly = _a.readOnly, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    return readOnly &&
        "\n            background: ".concat(backgroundColor, ";\n            border-color: ").concat(borderColor, ";\n        ");
}, function (_a) {
    var isActive = _a.isActive, isHiddenIconActive = _a.isHiddenIconActive, type = _a.type, isHaveIcon = _a.isHaveIcon, isShowIcon = _a.isShowIcon;
    return ((isActive && isHiddenIconActive) || (type && isHaveIcon && !isShowIcon)) && (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                .icon-right {\n                  opacity: 1 !important;\n                }\n            "], ["\n                .icon-right {\n                  opacity: 1 !important;\n                }\n            "])));
}, function (_a) {
    var size = _a.size, isRounded = _a.isRounded, haveBorder = _a.haveBorder;
    switch (size) {
        case 'extra-small':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border-radius: ", ";\n                    padding-top: 4px;\n                    padding-bottom: 4px;\n                    &:hover {\n                        padding-top: 4px;\n                        padding-bottom: 4px;\n                    }\n                    > label {\n                        font-size: 12px;\n                        line-height: ", ";\n                    }\n                "], ["\n                    border-radius: ", ";\n                    padding-top: 4px;\n                    padding-bottom: 4px;\n                    &:hover {\n                        padding-top: 4px;\n                        padding-bottom: 4px;\n                    }\n                    > label {\n                        font-size: 12px;\n                        line-height: ", ";\n                    }\n                "])), isRounded ? '18px' : '6px', haveBorder ? '17px' : '18px');
        case 'small':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border-radius: ", ";\n                    > label {\n                        font-size: 12px;\n                    }\n                "], ["\n                    border-radius: ", ";\n                    > label {\n                        font-size: 12px;\n                    }\n                "])), isRounded ? '18px' : '6px');
        case 'normal':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border-radius: 6px;\n                    > label {\n                        font-size: 13px;\n                    }\n                "], ["\n                    border-radius: 6px;\n                    > label {\n                        font-size: 13px;\n                    }\n                "])));
        case 'medium':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border-radius: 6px;\n                    > label {\n                        font-size: 14px;\n                    }\n                "], ["\n                    border-radius: 6px;\n                    > label {\n                        font-size: 14px;\n                    }\n                "])));
        case 'large':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    border-radius: 6px;\n                    padding-top: 10px;\n                    padding-bottom: 10px;\n                    > label {\n                        font-size: 14px;\n                    }\n                "], ["\n                    border-radius: 6px;\n                    padding-top: 10px;\n                    padding-bottom: 10px;\n                    > label {\n                        font-size: 14px;\n                    }\n                "])));
        default:
            return "";
    }
}, function (_a) {
    var isActive = _a.isActive, readOnly = _a.readOnly, size = _a.size;
    switch (size) {
        case 'extra-small':
            return isActive &&
                !readOnly && (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 0px 26px 0px 8px;\n                    "], ["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 0px 26px 0px 8px;\n                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.95 */.O9.primary[95]);
        case 'small':
            return isActive &&
                !readOnly && (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 4px 26px 4px 8px;\n                    "], ["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 4px 26px 4px 8px;\n                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.95 */.O9.primary[95]);
        case 'medium':
            return isActive &&
                !readOnly && (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 8px 26px 8px 8px;\n                    "], ["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 8px 26px 8px 8px;\n                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.95 */.O9.primary[95]);
        case 'large':
            return isActive &&
                !readOnly && (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 10px;\n                    "], ["\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                        padding: 10px;\n                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.95 */.O9.primary[95]);
    }
    return;
});
var MainIConWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  path {\n                      fill: ", ";\n                  }\n              "], ["\n                  path {\n                      fill: ", ";\n                  }\n              "])), Colors/* colors.primary.40 */.O9.primary[40]) : (0,styled_components_browser_esm/* css */.iv)(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var TagLabel = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    z-index: 1;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n    color: ", ";\n    cursor: ", ";\n    ", "\n"], ["\n    position: relative;\n    z-index: 1;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n    color: ", ";\n    cursor: ", ";\n    ", "\n"])), function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : Colors/* colors.grey.20 */.O9.grey[20];
}, function (_a) {
    var readOnly = _a.readOnly;
    return (readOnly ? 'default' : 'pointer');
}, function (_a) {
    var isActive = _a.isActive, readOnly = _a.readOnly;
    return isActive &&
        !readOnly && (0,styled_components_browser_esm/* css */.iv)(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), Colors/* colors.primary.40 */.O9.primary[40]);
});
var TagIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    position: absolute;\n    z-index: 2;\n    top: 50%;\n    right: 4px;\n    transform: translateY(-50%);\n    ", ";\n    opacity: ", ";\n    transition: 0.25s;\n    cursor: pointer;\n    svg {\n        ", ";\n\n        opacity: ", ";\n        ", "\n\n    ", ":hover {\n            ", "\n    }\n"], ["\n    display: inline-flex;\n    position: absolute;\n    z-index: 2;\n    top: 50%;\n    right: 4px;\n    transform: translateY(-50%);\n    ", ";\n    opacity: ", ";\n    transition: 0.25s;\n    cursor: pointer;\n    svg {\n        ", ";\n\n        opacity: ", ";\n        ", "\n\n    ", ":hover {\n            ", "\n    }\n"])), function (_a) {
    var isActive = _a.isActive, isShowIcon = _a.isShowIcon, isHiddenIconActive = _a.isHiddenIconActive;
    return (isActive || isShowIcon) && !isHiddenIconActive && (0,styled_components_browser_esm/* css */.iv)(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            opacity: 1 !important;\n        "], ["\n            opacity: 1 !important;\n        "])));
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 1 : 0);
}, function (_a) {
    var isActive = _a.isActive, isHiddenIconActive = _a.isHiddenIconActive;
    return isActive && !isHiddenIconActive && (0,styled_components_browser_esm/* css */.iv)(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                opacity: 1 !important;\n            "], ["\n                opacity: 1 !important;\n            "])));
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 1 : 0.5);
}, function (_a) {
    var readonly = _a.readonly;
    return !readonly ? (0,styled_components_browser_esm/* css */.iv)(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                &:hover {\n                    opacity: 1;\n                }\n            "], ["\n                &:hover {\n                    opacity: 1;\n                }\n            "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                cursor: default;\n            "], ["\n                cursor: default;\n            "])));
}, TagWrapper, function (_a) {
    var readonly = _a.readonly;
    return !readonly ? (0,styled_components_browser_esm/* css */.iv)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    opacity: 1;\n                "], ["\n                    opacity: 1;\n                "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;


//# sourceMappingURL=Tag.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddFilledIcon/index.js
var AddFilledIcon = __webpack_require__(94864);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SuccessIcon/index.js
var SuccessIcon = __webpack_require__(85658);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tag/index.js
'use client';








var Tag = function (props) {
    var label = props.label, iconType = props.iconType, iconRight = props.icon, iconLeft = props.iconLeft, _a = props.size, size = _a === void 0 ? 'normal' : _a, _b = props.isActive, isActive = _b === void 0 ? false : _b, _c = props.isShowIcon, isShowIcon = _c === void 0 ? false : _c, _d = props.readOnly, readOnly = _d === void 0 ? false : _d, onClick = props.onClick, _e = props.isMobile, isMobile = _e === void 0 ? false : _e, _f = props.maxWidth, maxWidth = _f === void 0 ? 'none' : _f, _g = props.enableTooltip, enableTooltip = _g === void 0 ? true : _g, _h = props.isRounded, isRounded = _h === void 0 ? true : _h, custom = props.custom, customContainer = props.customContainer, _j = props.tagType, tagType = _j === void 0 ? ETag.DEFAULT : _j, _k = props.classSelector, classSelector = _k === void 0 ? '' : _k, _l = props.isHiddenIconActive, isHiddenIconActive = _l === void 0 ? false : _l;
    var isHaveIcon = !!(iconRight || iconType);
    var _m = custom || {}, _o = _m.backgroundColor, backgroundColor = _o === void 0 ? '#fbfbfb' : _o, _p = _m.haveBorder, haveBorder = _p === void 0 ? true : _p, _q = _m.borderColor, borderColor = _q === void 0 ? '#dddddd' : _q, _r = _m.color, color = _r === void 0 ? Colors/* colors.grey.20 */.O9.grey[20] : _r, styles = _m.styles;
    var handleOnClick = function () {
        if (readOnly)
            return;
        onClick && onClick();
    };
    var renderIcon = function () {
        if (iconRight) {
            return iconRight;
        }
        switch (iconType) {
            case 'remove':
                return (react.createElement(AddFilledIcon/* default */.Z, { color: isActive ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.40 */.O9.grey[40], width: 16, height: 16, rotate: '45deg' }));
            case 'add':
                return react.createElement(AddFilledIcon/* default */.Z, { color: Colors/* colors.grey.40 */.O9.grey[40], width: 16, height: 16 });
            case 'active':
                return react.createElement(SuccessIcon/* default */.Z, { color: Colors/* colors.primary.40 */.O9.primary[40], width: 16, height: 16 });
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(Container, { display: customContainer === null || customContainer === void 0 ? void 0 : customContainer.display, className: classSelector },
        react.createElement(TagWrapper, { isHaveIcon: isHaveIcon, isShowIcon: isShowIcon, size: size, onClick: handleOnClick, isActive: isActive, isMobile: isMobile, readOnly: readOnly, maxWidth: maxWidth, isRounded: isRounded, backgroundColor: backgroundColor, haveBorder: haveBorder, borderColor: borderColor, type: tagType, isHiddenIconActive: isHiddenIconActive, style: styles },
            iconLeft ? react.createElement(MainIConWrap, { isActive: isActive }, iconLeft) : null,
            react.createElement(TagLabel, { variant: 'label', name: 'label', size: 'medium', isActive: isActive, readOnly: readOnly, title: enableTooltip ? label : '', color: color }, label),
            tagType === ETag.DEFAULT && isHaveIcon && !readOnly ? (react.createElement(TagIcon, { className: 'icon-right', isMobile: isMobile, isActive: isActive, isShowIcon: isShowIcon, readonly: readOnly, isHiddenIconActive: isHiddenIconActive }, renderIcon())) : null)));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 65906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextField; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextField/themes.js
'use client';




var themes = {
    primary: {
        borderFocus: constants/* colors.borderFocus */.O9.borderFocus,
        borderHover: constants/* colors.borderHover */.O9.borderHover,
        borderNormal: constants/* colors.borderNormal */.O9.borderNormal,
        background: '#fff',
        text: Colors/* colors.grey.20 */.O9.grey[20]
    },
    normal: {
        borderFocus: Colors/* colors.neutral.95 */.O9.neutral[95],
        borderHover: Colors/* colors.neutral.95 */.O9.neutral[95],
        borderNormal: Colors/* colors.neutral.95 */.O9.neutral[95],
        background: Colors/* colors.neutral.95 */.O9.neutral[95],
        text: Colors/* colors.grey.50 */.O9.grey[50]
    }
};


//# sourceMappingURL=themes.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextField/styles.js
'use client';






var TextFieldContainer = styled_components_browser_esm/* default.label */.ZP.label(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    --vnw-tag-gap-top: 2px;\n    --vnw-tag-gap-right: 2px;\n    --vnw-tag-gap-bottom: 2px;\n    --vnw-tag-gap-left: 2px;\n\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    font-size: 14px;\n    line-height: 18px;\n    cursor: ", ";\n"], ["\n    --vnw-tag-gap-top: 2px;\n    --vnw-tag-gap-right: 2px;\n    --vnw-tag-gap-bottom: 2px;\n    --vnw-tag-gap-left: 2px;\n\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    font-size: 14px;\n    line-height: 18px;\n    cursor: ", ";\n"])), function (_a) {
    var isPointer = _a.isPointer;
    return (isPointer ? 'pointer' : 'text');
});
var TextFieldWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    border-radius: 6px;\n    padding: 2px 12px 2px 2px;\n    transition: 150ms border-color ease-in-out;\n    ", "\n"], ["\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    border-radius: 6px;\n    padding: 2px 12px 2px 2px;\n    transition: 150ms border-color ease-in-out;\n    ", "\n"])), function (_a) {
    var themeType = _a.themeType, focus = _a.focus, hasError = _a.hasError;
    var borderFocus = themes[themeType].borderFocus;
    var borderHover = themes[themeType].borderHover;
    var borderNormal = themes[themeType].borderNormal;
    var background = themes[themeType].background;
    return "\n            background: ".concat(background, ";\n            border: 1px solid ").concat(focus ? borderFocus : borderNormal, ";\n            ").concat(hasError ? "border-color: ".concat(constants/* colors.borderError */.O9.borderError, ";") : '', "\n            &:hover {\n                border-color: ").concat(focus ? borderFocus : borderHover, ";\n                ").concat(hasError ? "border-color: ".concat(constants/* colors.borderError */.O9.borderError, ";") : '', "\n            }\n        ");
});
var SectionWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n"], ["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n"])));
var InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    flex-grow: 1;\n    width: 0;\n    min-width: ", "px;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    flex-grow: 1;\n    width: 0;\n    min-width: ", "px;\n    ", "\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
}, function (_a) {
    var isHavePlaceHolder = _a.isHavePlaceHolder, placeholderContent = _a.placeholderContent;
    return isHavePlaceHolder && placeholderContent
        ? "\n        &::before {\n            content: '".concat(placeholderContent, "';\n            margin-left: 8px;\n            color: #999;\n        }\n    ")
        : '';
});
var Input = styled_components_browser_esm/* default.input */.ZP.input(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex-grow: 1;\n    width: 0;\n    border: none;\n    background-image: none;\n    background-color: transparent;\n    line-height: inherit;\n    padding: 8px 0px 8px 8px;\n    color: ", ";\n    &:focus {\n        outline: none;\n        border: none;\n    }\n    &::placeholder {\n        color: #999;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &[type='button'] {\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n"], ["\n    flex-grow: 1;\n    width: 0;\n    border: none;\n    background-image: none;\n    background-color: transparent;\n    line-height: inherit;\n    padding: 8px 0px 8px 8px;\n    color: ", ";\n    &:focus {\n        outline: none;\n        border: none;\n    }\n    &::placeholder {\n        color: #999;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &[type='button'] {\n        text-align: left;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n"])), function (_a) {
    var themeType = _a.themeType;
    return themes[themeType].text;
});
var ClearBtn = styled_components_browser_esm/* default.span */.ZP.span(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    cursor: pointer;\n    & > svg {\n        transition: 150ms opacity ease-in-out;\n        opacity: 0.5;\n        &:hover {\n            opacity: 1;\n        }\n    }\n"], ["\n    display: flex;\n    cursor: pointer;\n    & > svg {\n        transition: 150ms opacity ease-in-out;\n        opacity: 0.5;\n        &:hover {\n            opacity: 1;\n        }\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


//# sourceMappingURL=styles.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextField/useClearBtnControl.js
'use client';



function useClearBtnControl(value) {
    var _a = (0,react.useState)('none'), initStatus = _a[0], setInitStatus = _a[1];
    var _b = (0,react.useState)(false), showClear = _b[0], setShowClear = _b[1];
    /**
     * Since blur trigger faster than user click on clear button so
     * this flag is prevent blur is trigger hidden before user click on it
     * */
    var allowHidden = (0,react.useRef)(true);
    var show = (0,react.useCallback)(function (status, inputValue) {
        switch (status) {
            case 'focus': {
                setInitStatus(status);
                if (inputValue !== '') {
                    setShowClear(true);
                }
                break;
            }
            case 'enter': {
                if (initStatus !== 'focus') {
                    if (inputValue !== '') {
                        setInitStatus(status);
                        setShowClear(true);
                    }
                }
                break;
            }
            case 'enter-clear': {
                allowHidden.current = false;
                setShowClear(true);
            }
        }
    }, [initStatus]);
    var hidden = (0,react.useCallback)(function (status) {
        switch (status) {
            case 'blur': {
                if (allowHidden.current) {
                    setInitStatus(status);
                    setShowClear(false);
                }
                break;
            }
            case 'leave': {
                if (initStatus !== 'focus' && allowHidden.current) {
                    setInitStatus(status);
                    setShowClear(false);
                }
                break;
            }
            case 'leave-clear': {
                allowHidden.current = true;
            }
        }
    }, [initStatus]);
    (0,react.useEffect)(function () {
        if (value === '') {
            allowHidden.current = true;
        }
    }, [value]);
    return {
        isShow: showClear && value !== '',
        show: show,
        hidden: hidden,
        status: initStatus
    };
}


//# sourceMappingURL=useClearBtnControl.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextField/getTextWidth.js
'use client';

/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 *
 * @param {String} text The text to be rendered.
 * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
function getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}
function getCanvasFont(el) {
    if (el === void 0) { el = document.body; }
    var fontWeight = getCssStyle(el, 'font-weight') || 'normal';
    var fontSize = getCssStyle(el, 'font-size') || '16px';
    var fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman';
    return "".concat(fontWeight, " ").concat(fontSize, " ").concat(fontFamily);
}
function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (context) {
        context.font = font;
        var metrics = context.measureText(text);
        return metrics.width;
    }
    return 0;
}


//# sourceMappingURL=getTextWidth.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextField/index.js
'use client';








var MIN_INPUT_WIDTH = 80;
function TextField(_a) {
    var id = _a.id, prefix = _a.prefix, suffix = _a.suffix, _b = _a.allowClear, allowClear = _b === void 0 ? true : _b, value = _a.value, onChange = _a.onChange, _c = _a.hasError, hasError = _c === void 0 ? false : _c, className = _a.className, _d = _a.adaptiveInputWidth, adaptiveInputWidth = _d === void 0 ? true : _d, placeholder = _a.placeholder, _e = _a.type, type = _e === void 0 ? 'text' : _e, _f = _a.isFocus, isFocus = _f === void 0 ? false : _f, _g = _a.theme, theme = _g === void 0 ? 'primary' : _g, styles = _a.styles, rest = (0,_tslib/* __rest */._T)(_a, ["id", "prefix", "suffix", "allowClear", "value", "onChange", "hasError", "className", "adaptiveInputWidth", "placeholder", "type", "isFocus", "theme", "styles"]);
    /*
     * Hooks, state and refs
     * */
    var removeBtnRef = (0,react.useRef)(null);
    var _h = useClearBtnControl(value), isShow = _h.isShow, showClearBtn = _h.show, hiddenClearBtn = _h.hidden, status = _h.status;
    var referenceRef = (0,react.useRef)(null);
    var _j = (0,react.useState)(MIN_INPUT_WIDTH), minInputWidth = _j[0], setMinInputWidth = _j[1];
    /**
     * Handle logic and actions
     * */
    var handleChange = function (event) {
        var text = event.target.value;
        showClearBtn('focus', text);
        onChange && onChange(text);
    };
    var handleClear = function () {
        onChange && onChange('');
        hiddenClearBtn('blur');
        if (referenceRef.current) {
            referenceRef.current.focus();
        }
    };
    /**
     * Effects
     * */
    // Set adaptive width for input container
    (0,react.useEffect)(function () {
        if (placeholder && placeholder !== '' && adaptiveInputWidth) {
            setMinInputWidth(getTextWidth(placeholder, getCanvasFont()));
        }
    }, [placeholder, adaptiveInputWidth]);
    return (react.createElement(TextFieldContainer, { htmlFor: id, ref: referenceRef, onFocus: function () { return showClearBtn('focus', value); }, onBlur: function () { return hiddenClearBtn('blur'); }, onMouseEnter: function () { return showClearBtn('enter', value); }, onMouseLeave: function () { return hiddenClearBtn('leave'); }, isPointer: type === 'button' },
        react.createElement(TextFieldWrapper, { focus: status === 'focus' || isFocus, hasError: hasError, className: className, style: styles === null || styles === void 0 ? void 0 : styles.container, themeType: theme },
            react.createElement(SectionWrapper, null,
                prefix,
                react.createElement(InputWrapper, { minWidth: minInputWidth, isHavePlaceHolder: type === 'button' && (!value || value === ''), placeholderContent: placeholder },
                    react.createElement(Input, (0,_tslib/* __assign */.pi)({ id: id, type: type, value: value, onChange: handleChange, placeholder: placeholder, themeType: theme }, rest)),
                    allowClear && isShow ? (react.createElement(ClearBtn, { ref: removeBtnRef, onClick: handleClear, onMouseEnter: function () { return showClearBtn('enter-clear', value); }, onMouseLeave: function () { return hiddenClearBtn('leave-clear'); } },
                        react.createElement(RemoveFillIcon/* default */.Z, null))) : null)),
            suffix)));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 30178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Textarea; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextareaNew/index.css.js
'use client';





var TextareaCss = styled_components_browser_esm/* default.textarea */.ZP.textarea(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    resize: none;\n    padding: 8px 0px 8px 12px;\n    gap: 8px;\n    min-height: 44px;\n    line-height: 24px;\n    max-height: calc(24px * 4);\n    overflow: auto;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    width: 100%;\n    outline: none;\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n    &::placeholder {\n        color: ", ";\n    }\n    ", "\n"], ["\n    resize: none;\n    padding: 8px 0px 8px 12px;\n    gap: 8px;\n    min-height: 44px;\n    line-height: 24px;\n    max-height: calc(24px * 4);\n    overflow: auto;\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    width: 100%;\n    outline: none;\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n    &::placeholder {\n        color: ", ";\n    }\n    ", "\n"])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.50 */.O9.grey[50], function (_a) {
    var hasError = _a.hasError;
    if (hasError) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                border: 1px solid ", " !important;\n            "], ["\n                border: 1px solid ", " !important;\n            "])), Colors/* colors.error.40 */.O9.error[40]);
    }
    return '';
});
var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n"], ["\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;


//# sourceMappingURL=index.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextareaNew/index.js
'use client';







function Textarea(props) {
    var children = props.children, label = props.label, _a = props.hasError, hasError = _a === void 0 ? false : _a, onChange = props.onChange, value = props.value;
    var handleChange = function (e) {
        var _a, _b;
        onChange && onChange((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
    };
    return (react.createElement(Container, null,
        label && (react.createElement(Typography/* default */.Z, { variant: 'label', typoName: 'label', typoSize: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20] }, label)),
        react.createElement(TextareaCss, (0,_tslib/* __assign */.pi)({}, props, { hasError: hasError, value: value, onChange: handleChange }), children)));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 60500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rn": function() { return /* binding */ TOAST_TYPE_ERROR; },
  "ZP": function() { return /* binding */ Toast; },
  "CF": function() { return /* binding */ showToast; }
});

// UNUSED EXPORTS: TOAST_TYPE_SUCCESS

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/index.js
var icons = __webpack_require__(97228);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/IconSuccess.js
'use client';



var IconSuccess = function () {
    return (react.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M9.9999 0.399902C4.6983 0.399902 0.399902 4.6983 0.399902 9.9999C0.399902 15.3015 4.6983 19.5999 9.9999 19.5999C15.3015 19.5999 19.5999 15.3015 19.5999 9.9999C19.5999 4.6983 15.3015 0.399902 9.9999 0.399902ZM15.3655 8.1655L9.3175 14.2135C9.1671 14.3639 8.9639 14.4479 8.7519 14.4479C8.5399 14.4479 8.3359 14.3639 8.1863 14.2135L5.4239 11.4511C5.1111 11.1383 5.1111 10.6327 5.4239 10.3199C5.7367 10.0071 6.2423 10.0071 6.5551 10.3199L8.7519 12.5167L14.2343 7.0343C14.5471 6.7215 15.0527 6.7215 15.3655 7.0343C15.6783 7.3471 15.6783 7.8527 15.3655 8.1655Z", fill: "#6FB920" })));
};


//# sourceMappingURL=IconSuccess.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Toast/Toast.module.css.js
'use client';

var styles = {"container":"Toast-module_container__2Bybb","toast":"Toast-module_toast__2oDAM","toast-in-right":"Toast-module_toast-in-right__1CJZe","title":"Toast-module_title__5tkl9","messageContainer":"Toast-module_messageContainer__6GBY3","message":"Toast-module_message__2WJDC","checkIcon":"Toast-module_checkIcon__3p179","errorIcon":"Toast-module_errorIcon__1V8Wg","closeIcon":"Toast-module_closeIcon__U9tgH"};


//# sourceMappingURL=Toast.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js
'use client';







var EVENT_NAME = 'VNW_TOAST_SHOW';
var TOAST_DISPLAY_MAXIMUM = 3;
var TOAST_TYPE_SUCCESS = 'success';
var TOAST_TYPE_ERROR = 'error';
var TOAST_TIMEOUT = 5000;
var TOAST_REMAINING = 3000;
function Toast () {
    var _a = (0,react.useState)([]), toastList = _a[0], setToastList = _a[1];
    var _b = (0,react.useState)(), intervalId = _b[0], setIntervalId = _b[1];
    var deleteToast = function (index) {
        var deletedToastList = toastList.filter(function (_item, itemIndex) {
            return itemIndex !== index;
        });
        setToastList(deletedToastList);
    };
    var pauseTimeOut = function () {
        clearTimeout(intervalId);
    };
    var resumeTimeOut = function () {
        var interval;
        if (toastList.length > 0) {
            interval = setTimeout(function () {
                deleteToast(0);
            }, TOAST_REMAINING);
            setIntervalId(interval);
        }
    };
    (0,react.useEffect)(function () {
        if (toastList.length > TOAST_DISPLAY_MAXIMUM) {
            deleteToast(0);
            return;
        }
        var interval;
        if (toastList.length > 0) {
            interval = setTimeout(function () {
                deleteToast(0);
            }, TOAST_TIMEOUT);
            setIntervalId(interval);
        }
        return function () {
            interval && clearTimeout(interval);
        };
    }, [toastList]);
    (0,react.useEffect)(function () {
        var showToast = function (e) {
            var message = e.detail.message;
            var title = e.detail.title;
            var type = e.detail.type;
            setToastList((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], toastList, true), [
                {
                    title: title,
                    message: message,
                    type: type
                }
            ], false));
        };
        window.addEventListener(EVENT_NAME, showToast);
        return function () {
            window.removeEventListener(EVENT_NAME, showToast);
        };
    }, [toastList]);
    return (react.createElement("div", { className: styles.container }, toastList.map(function (toast, index) {
        return (react.createElement("div", { className: styles.toast, key: index, onMouseOver: pauseTimeOut, onMouseLeave: resumeTimeOut },
            react.createElement("div", { className: styles.messageContainer },
                react.createElement("div", { className: styles.icon },
                    toast.type === TOAST_TYPE_ERROR && (react.createElement(icons/* IconError */.Uc, { width: 20, height: 20, className: styles.errorIcon })),
                    toast.type === TOAST_TYPE_SUCCESS && react.createElement(IconSuccess, null)),
                react.createElement("div", { className: styles.title }, toast.title),
                react.createElement("div", { onClick: function () { return deleteToast(index); } },
                    react.createElement(icons/* IconClose */.bM, { width: 14, height: 14, className: styles.closeIcon }))),
            react.createElement("div", { className: styles.message }, toast.message)));
    })));
}
function showToast(title, message, type) {
    if (type === void 0) { type = TOAST_TYPE_SUCCESS; }
    if (typeof window === 'undefined') {
        return;
    }
    var event = new CustomEvent(EVENT_NAME, {
        detail: {
            title: title,
            message: message,
            type: type
        }
    });
    window.dispatchEvent(event);
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ DropdownParentWrapper; },
/* harmony export */   "DZ": function() { return /* binding */ DropdownContainer; },
/* harmony export */   "Hp": function() { return /* binding */ ChildrenWrapper; },
/* harmony export */   "Z_": function() { return /* binding */ DropdownWrapper; },
/* harmony export */   "bF": function() { return /* binding */ LimitText; },
/* harmony export */   "cj": function() { return /* binding */ animSlide; },
/* harmony export */   "h": function() { return /* binding */ DropdownItemContainer; },
/* harmony export */   "hP": function() { return /* binding */ DropdownItem; },
/* harmony export */   "ik": function() { return /* binding */ DropdownBody; },
/* harmony export */   "kq": function() { return /* binding */ RemoveAllText; },
/* harmony export */   "pB": function() { return /* binding */ EmptyText; },
/* harmony export */   "p_": function() { return /* binding */ DropdownLimitWrapper; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96306);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33089);
/* harmony import */ var _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79962);
'use client';







var firstSlideToLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(-100%);\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(-100%);\n  }\n"])));
var firstSlideToRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 1;\n    transform: translateX(-100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: translateX(-100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])));
var sencondSlideToLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 1;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])));
var sencondSlideToRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(100%);\n  }\n"], ["\n    0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(100%);\n  }\n"])));
var animSlide = {
    first: {
        open: firstSlideToLeft,
        close: firstSlideToRight
    },
    second: {
        open: sencondSlideToLeft,
        close: sencondSlideToRight
    }
};
var DropdownParentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: ", ";\n    width: ", ";\n    overflow: hidden;\n    z-index: 1099;\n    border-radius: ", ";\n\n    svg {\n        overflow: visible;\n    }\n\n    ", "\n    ", "\n"], ["\n    position: ", ";\n    width: ", ";\n    overflow: hidden;\n    z-index: 1099;\n    border-radius: ", ";\n\n    svg {\n        overflow: visible;\n    }\n\n    ", "\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'relative' : 'absolute');
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return "".concat(borderRadius, "px");
}, function (_a) {
    var marginTop = _a.marginTop;
    if (!marginTop) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            margin-top: ", "px;\n        "], ["\n            margin-top: ", "px;\n        "])), marginTop);
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            display: block;\n            height: 100%;\n            overflow: visible;\n        "], ["\n            display: block;\n            height: 100%;\n            overflow: visible;\n        "])));
});
var DropdownWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: block;\n    height: 100%;\n    background-color: #fff;\n    padding: 16px;\n    border-radius: ", ";\n    box-shadow: 0 2px 4px 0 #efefef;\n    border: 1px solid ", ";\n    ", "\n"], ["\n    display: block;\n    height: 100%;\n    background-color: #fff;\n    padding: 16px;\n    border-radius: ", ";\n    box-shadow: 0 2px 4px 0 #efefef;\n    border: 1px solid ", ";\n    ", "\n"])), function (_a) {
    var borderRadius = _a.borderRadius;
    return "".concat(borderRadius, "px");
}, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.borderCard */ .O9.borderCard, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                will-change: transform;\n                ", ";\n            "], ["\n                will-change: transform;\n                ", ";\n            "])), function (_a) {
            var isShow = _a.isShow;
            return _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dropdownAnimation */ .ZP.dropdownAnimation(isShow);
        });
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            border: none;\n            box-shadow: none;\n            padding: 0;\n        "], ["\n            border: none;\n            box-shadow: none;\n            padding: 0;\n        "])));
});
var DropdownContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n"])));
var DropdownBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_14 || (templateObject_14 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    margin-top: 4px;\n    overflow: hidden auto;\n    max-height: 100%;\n    position: relative;\n    min-height: ", "px;\n    ", "\n    &:focus {\n        outline: none;\n    }\n    ", "\n    ", "\n"], ["\n    margin-top: 4px;\n    overflow: hidden auto;\n    max-height: 100%;\n    position: relative;\n    min-height: ", "px;\n    ", "\n    &:focus {\n        outline: none;\n    }\n    ", "\n    ", "\n"])), function (_a) {
    var totalMinHeight = _a.totalMinHeight;
    return totalMinHeight !== null && totalMinHeight !== void 0 ? totalMinHeight : 240;
}, function (_a) {
    var isHaveBottom = _a.isHaveBottom;
    if (!isHaveBottom) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            margin-bottom: 8px;\n        "], ["\n            margin-bottom: 8px;\n        "])));
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            margin-bottom: ", "px;\n            /* height: calc(100% - ", "px - 60px); */\n            flex: 1;\n            /* height: 100%;\n            max-height: 100%; */\n            /* padding-bottom: env(safe-area-inset-bottom); */\n            /* height: calc(100% - ", "px - env(safe-area-inset-bottom)); */\n        "], ["\n            margin-bottom: ", "px;\n            /* height: calc(100% - ", "px - 60px); */\n            flex: 1;\n            /* height: 100%;\n            max-height: 100%; */\n            /* padding-bottom: env(safe-area-inset-bottom); */\n            /* height: calc(100% - ", "px - env(safe-area-inset-bottom)); */\n        "])), function (_a) {
        var isSingleSelect = _a.isSingleSelect;
        return (isSingleSelect ? 0 : 60);
    }, function (_a) {
        var mobileFixedHeight = _a.mobileFixedHeight;
        return mobileFixedHeight;
    }, function (_a) {
        var mobileFixedHeight = _a.mobileFixedHeight;
        return mobileFixedHeight;
    });
}, _Utils_styledCss_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].scrollbar */ .ZP.scrollbar);
var ChildrenWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_17 || (templateObject_17 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    min-height: ", "px;\n    background-color: #fff;\n    transition: all 0.25s ease-in-out;\n    animation: ", " 0.25s ease-in-out forwards;\n    padding-bottom: ", "px; // Safari mobile on scroll fix\n    ", "\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    min-height: ", "px;\n    background-color: #fff;\n    transition: all 0.25s ease-in-out;\n    animation: ", " 0.25s ease-in-out forwards;\n    padding-bottom: ", "px; // Safari mobile on scroll fix\n    ", "\n"])), function (_a) {
    var totalMinHeight = _a.totalMinHeight;
    return totalMinHeight !== null && totalMinHeight !== void 0 ? totalMinHeight : 240;
}, function (_a) {
    var isChild = _a.isChild;
    return (isChild ? animSlide.second.open : animSlide.first.close);
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 150 : 0);
}, function (_a) {
    var isShow = _a.isShow, isChild = _a.isChild;
    if (!isShow && isChild) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_15 || (templateObject_15 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), animSlide.second.close);
    }
    if (!isShow && !isChild) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_16 || (templateObject_16 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                animation: ", " 0.25s ease-in-out forwards;\n            "], ["\n                animation: ", " 0.25s ease-in-out forwards;\n            "])), animSlide.first.open);
    }
    return '';
});
var DropdownItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_27 || (templateObject_27 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    align-items: center;\n    height: 40px;\n    padding-right: 4px;\n    polyline {\n        stroke: #888;\n        opacity: ", ";\n    }\n    label {\n        margin-bottom: 0 !important;\n    }\n    > div {\n        width: calc(100% - 32px);\n    }\n    cursor: ", ";\n    &:hover {\n        background-color: ", ";\n        > div {\n            background-color: ", ";\n        }\n        polyline {\n            stroke: ", ";\n        }\n        ", "\n    }\n    ", "\n    ", "\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    height: 40px;\n    padding-right: 4px;\n    polyline {\n        stroke: #888;\n        opacity: ", ";\n    }\n    label {\n        margin-bottom: 0 !important;\n    }\n    > div {\n        width: calc(100% - 32px);\n    }\n    cursor: ", ";\n    &:hover {\n        background-color: ", ";\n        > div {\n            background-color: ", ";\n        }\n        polyline {\n            stroke: ", ";\n        }\n        ", "\n    }\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.4 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'no-drop' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '#f5f5f8' : '#f8faff');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '#f5f5f8' : '#f8faff');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '#888' : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
}, function (_a) {
    var isChild = _a.isChild;
    if (isChild) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_18 || (templateObject_18 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    label {\n                        left: 8px;\n                        border: 1px solid ", ";\n                    }\n                "], ["\n                    label {\n                        left: 8px;\n                        border: 1px solid ", ";\n                    }\n                "])), function (_a) {
            var disabled = _a.disabled;
            return (disabled ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textGrayColor */ .O9.textGrayColor : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
        });
    }
    else {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_19 || (templateObject_19 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    > div > label {\n                        cursor: ", ";\n                    }\n                    > div > div {\n                        border: 1px solid ", ";\n                    }\n                "], ["\n                    > div > label {\n                        cursor: ", ";\n                    }\n                    > div > div {\n                        border: 1px solid ", ";\n                    }\n                "])), function (_a) {
            var disabled = _a.disabled;
            return (disabled ? 'no-drop' : 'pointer');
        }, function (_a) {
            var disabled = _a.disabled;
            return (disabled ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textGrayColor */ .O9.textGrayColor : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
        });
    }
}, function (_a) {
    var isChild = _a.isChild;
    if (isChild) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_20 || (templateObject_20 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                label {\n                    left: 8px;\n                }\n                > div {\n                    > div {\n                        color: #333;\n                    }\n                }\n            "], ["\n                label {\n                    left: 8px;\n                }\n                > div {\n                    > div {\n                        color: #333;\n                    }\n                }\n            "])));
    }
    else {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_21 || (templateObject_21 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                label {\n                    display: flex;\n                    margin-left: 10px;\n                    margin-bottom: 0px !important;\n                    font-weight: 400;\n                    > span {\n                        line-height: 20px;\n                    }\n                    > span:nth-child(1) {\n                        color: #333;\n                    }\n                }\n            "], ["\n                label {\n                    display: flex;\n                    margin-left: 10px;\n                    margin-bottom: 0px !important;\n                    font-weight: 400;\n                    > span {\n                        line-height: 20px;\n                    }\n                    > span:nth-child(1) {\n                        color: #333;\n                    }\n                }\n            "])));
    }
}, function (_a) {
    var isFocusing = _a.isFocusing;
    if (!isFocusing) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_24 || (templateObject_24 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            background-color: ", ";\n            > div {\n                background-color: ", ";\n            }\n            polyline {\n                stroke: ", ";\n            }\n            ", "\n        "], ["\n            background-color: ", ";\n            > div {\n                background-color: ", ";\n            }\n            polyline {\n                stroke: ", ";\n            }\n            ", "\n        "])), function (_a) {
        var disabled = _a.disabled;
        return (disabled ? '#f5f5f8' : '#f8faff');
    }, function (_a) {
        var disabled = _a.disabled;
        return (disabled ? '#f5f5f8' : '#f8faff');
    }, function (_a) {
        var disabled = _a.disabled;
        return (disabled ? '#888' : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
    }, function (_a) {
        var isChild = _a.isChild;
        if (isChild) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_22 || (templateObject_22 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        label {\n                            left: 8px;\n                            border: 1px solid\n                                ", ";\n                        }\n                    "], ["\n                        label {\n                            left: 8px;\n                            border: 1px solid\n                                ", ";\n                        }\n                    "])), function (_a) {
                var disabled = _a.disabled;
                return (disabled ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textGrayColor */ .O9.textGrayColor : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
            });
        }
        else {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_23 || (templateObject_23 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        > div > label {\n                            cursor: ", ";\n                        }\n                        > div > div {\n                            border: 1px solid\n                                ", ";\n                        }\n                    "], ["\n                        > div > label {\n                            cursor: ", ";\n                        }\n                        > div > div {\n                            border: 1px solid\n                                ", ";\n                        }\n                    "])), function (_a) {
                var disabled = _a.disabled;
                return (disabled ? 'no-drop' : 'pointer');
            }, function (_a) {
                var disabled = _a.disabled;
                return (disabled ? _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.textGrayColor */ .O9.textGrayColor : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor);
            });
        }
    });
}, function (_a) {
    var isSingle = _a.isSingle, isSelected = _a.isSelected;
    if (!isSingle) {
        return '';
    }
    if (isSelected) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_25 || (templateObject_25 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                justify-content: space-between;\n                background-color: ", ";\n                color: ", ";\n            "], ["\n                justify-content: space-between;\n                background-color: ", ";\n                color: ", ";\n            "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.primary[95] */ .O9.primary[95], _Colors_index_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.primary[40] */ .O9.primary[40]);
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_26 || (templateObject_26 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            justify-content: space-between;\n        "], ["\n            justify-content: space-between;\n        "])));
});
var DropdownLimitWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_28 || (templateObject_28 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 8px;\n"], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 8px;\n"])));
var LimitText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_29 || (templateObject_29 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    color: ", ";\n    font-size: 12px;\n    line-height: 18px;\n"], ["\n    color: ", ";\n    font-size: 12px;\n    line-height: 18px;\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.buttonColor */ .O9.buttonColor);
var RemoveAllText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZP.span(templateObject_30 || (templateObject_30 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    color: ", ";\n    transition: all 0.25s ease;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", ";\n        outline: none;\n    }\n"], ["\n    color: ", ";\n    transition: all 0.25s ease;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", ";\n        outline: none;\n    }\n"])), _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.primaryColor */ .O9.primaryColor, _Utils_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .colors.buttonColor */ .O9.buttonColor);
var EmptyText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_31 || (templateObject_31 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    color: #848484;\n    line-height: 30px;\n"], ["\n    color: #848484;\n    line-height: 30px;\n"])));
var DropdownItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_33 || (templateObject_33 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    padding-left: 8px;\n    ", "\n"], ["\n    padding-left: 8px;\n    ", "\n"])), function (_a) {
    var isChecked = _a.isChecked;
    if (!isChecked) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_32 || (templateObject_32 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            background-color: ", ";\n            color: ", ";\n        "], ["\n            background-color: ", ";\n            color: ", ";\n        "])), _Colors_index_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.primary[95] */ .O9.primary[95], _Colors_index_js__WEBPACK_IMPORTED_MODULE_4__/* .colors.primary[40] */ .O9.primary[40]);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33;


//# sourceMappingURL=Dropdown.css.js.map


/***/ }),

/***/ 71490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR; },
/* harmony export */   "Bk": function() { return /* binding */ DEFAULT_MOBILE_FIXED_HEIGHT; },
/* harmony export */   "P7": function() { return /* binding */ DEFAULT_MARGIN_WIDTH; },
/* harmony export */   "Rh": function() { return /* binding */ SELECT_CATE_LEVEL_SUB; },
/* harmony export */   "Rm": function() { return /* binding */ DEFAULT_PADDING_WIDTH; },
/* harmony export */   "Y4": function() { return /* binding */ DEFAULT_TEXT_OPTIONS; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_BORDER_WIDTH; },
/* harmony export */   "av": function() { return /* binding */ SELECT_CATE_LEVEL_PARENT; },
/* harmony export */   "bx": function() { return /* binding */ DEFAULT_DROPDOWN_FOOTER_OPTIONS; },
/* harmony export */   "mG": function() { return /* binding */ DEFAULT_REMOVE_ICON_WIDTH; },
/* harmony export */   "mg": function() { return /* binding */ FIXED_WIDTH_OF_INPUT; },
/* harmony export */   "mt": function() { return /* binding */ DEFAULT_SELECT_OPTIONS; },
/* harmony export */   "r$": function() { return /* binding */ DEFAULT_CHARACTER_WIDTH; },
/* harmony export */   "tX": function() { return /* binding */ DEFAULT_DROPDOWN_STYLE_OPTIONS; },
/* harmony export */   "uQ": function() { return /* binding */ DEFAULT_OPTION_ITEM_HEIGHT; },
/* harmony export */   "v1": function() { return /* binding */ DEFAULT_INPUT_STYLE; },
/* harmony export */   "y8": function() { return /* binding */ DEFAULT_MIN_HEIGHT_OF_DROPDOWN; }
/* harmony export */ });
/* unused harmony export DEFAULT_LIMIT_SELECT_COUNT */
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35617);
'use client';



// Limit number option user can select
var DEFAULT_LIMIT_SELECT_COUNT = 3;
// 1 character is ~ 6.8px => 7px
var DEFAULT_CHARACTER_WIDTH = 7;
// 1 item padding is 16px
var DEFAULT_PADDING_WIDTH = 16;
// other item (except first one) have margin-left 4px
var DEFAULT_MARGIN_WIDTH = 4;
// 1 item have border width 2px (left + right)
var DEFAULT_BORDER_WIDTH = 2;
// Remove icon button width is 24px with extra plus item (34px)
var DEFAULT_REMOVE_ICON_WIDTH = 88;
var DEFAULT_MOBILE_FIXED_HEIGHT = 206;
var DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR = 168;
var FIXED_WIDTH_OF_INPUT = 36;
// Job Function Level
var SELECT_CATE_LEVEL_PARENT = 0;
var SELECT_CATE_LEVEL_SUB = 1;
var DEFAULT_INPUT_STYLE = {
    arrowDownSize: {
        width: 24,
        height: 24
    },
    isTransparentBackground: false,
    limitDisplay: 3,
    variant: _types_js__WEBPACK_IMPORTED_MODULE_0__/* .EVariant.PRIMARY */ .e.PRIMARY,
    cssString: '',
    leftIcon: function (_props) {
        return null;
    },
    forceLimitDisplay: 0
};
// Default option item height in pixel is 40px
var DEFAULT_OPTION_ITEM_HEIGHT = 40;
// Min height of dropdown item in pixel: 240px
var DEFAULT_MIN_HEIGHT_OF_DROPDOWN = 240;
var DEFAULT_DROPDOWN_FOOTER_OPTIONS = {
    isEnableFooter: false,
    setElementVisible: function () { },
    onClickApply: function () { },
    onClickCancel: function () { },
    resetSelectedValue: function () { }
};
var DEFAULT_TEXT_OPTIONS = {
    headerLabel: 'Header',
    searchPlaceholder: 'Search',
    allText: 'All',
    maxLimitText: 'Limit reached!',
    removeAllText: 'Remove all',
    backText: 'Back',
    noResultText: 'No result',
    selectedCountText: '',
    selectAllText: '',
    primaryButtonText: '',
    subOptionText: ''
};
var DEFAULT_DROPDOWN_STYLE_OPTIONS = {
    width: '100%',
    marginTop: 0,
    isShowTooltip: false,
    primaryBtnType: 'primary',
    borderRadius: 6,
    delayTime: 0,
    isForceClose: false
};
var DEFAULT_SELECT_OPTIONS = {
    limitParentCount: DEFAULT_LIMIT_SELECT_COUNT,
    isSortAlphabet: false,
    isSingleSelect: false,
    isFilter: false,
    isStripFirstItem: false,
    limitFirstItemLength: 24
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 48901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ initialTreeSelect; }
/* harmony export */ });
'use client';

var initialTreeSelect = {
    selectedParentId: -1,
    selectLevel: 0,
    history: {
        selectedParentId: -1,
        selectLevel: 0,
        bodyScrollPosition: []
    }
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 55561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TreeSelectContext; },
/* harmony export */   "s": function() { return /* binding */ treeSelectReducer; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48901);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3810);
'use client';






var treeSelectReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SELECTED_PARENT_ID */ .N.UPDATE_SELECTED_PARENT_ID: {
            var parentId = payload;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { selectedParentId: parentId });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SELECT_LEVEL */ .N.UPDATE_SELECT_LEVEL: {
            var levelIndex = payload;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { selectLevel: levelIndex });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_HISTORY */ .N.UPDATE_HISTORY: {
            var _a = payload, _b = _a.selectedParentId, selectedParentId = _b === void 0 ? -1 : _b, _c = _a.selectLevel, selectLevel = _c === void 0 ? 0 : _c;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { history: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state.history), { selectedParentId: selectedParentId, selectLevel: selectLevel }) });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SCROLLING_POSITION */ .N.UPDATE_SCROLLING_POSITION: {
            var history_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state.history);
            var updateItemPosition = payload;
            // This only work for 2 levels categories.
            // If we using 3 levels (currently not supported in TreeSelect) then this need to rework.
            var bodyScrollPosition = [updateItemPosition];
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { history: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, history_1), { bodyScrollPosition: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], bodyScrollPosition, true) }) });
        }
        default:
            console.error('Unknown type of Reducer');
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state);
    }
};
var TreeSelectContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    state: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .initialTreeSelect */ .b,
    dispatch: function () { }
});


//# sourceMappingURL=reducer.js.map


/***/ }),

/***/ 3810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ TreeSelectAction; }
/* harmony export */ });
'use client';

var TreeSelectAction;
(function (TreeSelectAction) {
    TreeSelectAction[TreeSelectAction["UPDATE_SELECTED_PARENT_ID"] = 0] = "UPDATE_SELECTED_PARENT_ID";
    TreeSelectAction[TreeSelectAction["UPDATE_SELECT_LEVEL"] = 1] = "UPDATE_SELECT_LEVEL";
    TreeSelectAction[TreeSelectAction["UPDATE_HISTORY"] = 2] = "UPDATE_HISTORY";
    TreeSelectAction[TreeSelectAction["UPDATE_SCROLLING_POSITION"] = 3] = "UPDATE_SCROLLING_POSITION";
})(TreeSelectAction || (TreeSelectAction = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 33294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ deepCloneArray; },
/* harmony export */   "fq": function() { return /* binding */ getChildrenListByParentId; },
/* harmony export */   "j5": function() { return /* binding */ sortChildOptionAlphabet; },
/* harmony export */   "kh": function() { return /* binding */ deepCloneObject; },
/* harmony export */   "t_": function() { return /* binding */ sortOptionsAlphabet; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
'use client';




/**
 * Get sub-level list from parent Id
 * @param parentId Parent Id in string
 * @param list Parent List. It should be look like districtData from app-shell-v2 (initialDataProvider)
 * @returns List of sub-level list from parent
 */
var getChildrenListByParentId = function (parentId, list) {
    var keyList = Object.keys(list);
    var valueList = Object.values(list);
    var index = keyList.indexOf(parentId.toString());
    if (!valueList[index]) {
        return [];
    }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], valueList[index], true);
};
var sortOptionsAlphabet = function (options, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var removedItem = null;
    var filteredHaveAllItem = options.filter(function (item) { return item.id === -1; });
    if (filteredHaveAllItem.length > 0) {
        removedItem = options.splice(0, 1);
    }
    options.sort(function (itemA, itemB) {
        if (itemA.name < itemB.name) {
            return -1;
        }
        if (itemA.name > itemB.name) {
            return 1;
        }
        return 0;
    });
    if (removedItem !== null) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], removedItem, true), options, true);
    }
    return options;
};
var sortChildOptionAlphabet = function (options, langCode, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var returnValue = {};
    var values = Object.values(options);
    /**
     * TODO: Find a more effective solution to resolve this problem without using unshift.
     * The 'childrenList' starts with an ID of 1, whereas the array starts at 0.
     * This misalignment is causing a shift of one item.
     */
    values.unshift([]);
    var newValues = values.map(function (item) {
        return item.sort(function (itemA, itemB) {
            if (langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI) {
                if (itemA.name < itemB.name) {
                    return -1;
                }
                if (itemA.name > itemB.name) {
                    return 1;
                }
            }
            else {
                if (itemA.nameEn < itemB.nameEn) {
                    return -1;
                }
                if (itemA.nameEn > itemB.nameEn) {
                    return 1;
                }
            }
            return 0;
        });
    });
    Object.assign(returnValue, newValues);
    return returnValue;
};
/**
 * Completely deep clone array
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneArray(arr) {
    var clone = [];
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var element = arr_1[_i];
        if (Array.isArray(element)) {
            clone.push(deepCloneArray(element));
        }
        else if (typeof element === 'object' && element !== null) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            clone.push(deepCloneObject(element));
        }
        else {
            clone.push(element);
        }
    }
    return clone;
}
/**
 * Completely deep clone object (Alternative with  )
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneObject(obj) {
    var clone = {};
    for (var key in obj) {
        if (Array.isArray(obj[key])) {
            clone[key] = deepCloneArray(obj[key]);
        }
        else if (typeof obj[key] === 'object' && obj[key] !== null) {
            clone[key] = deepCloneObject(obj[key]);
        }
        else {
            clone[key] = obj[key];
        }
    }
    return clone;
}


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 35617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ EVariant; }
/* harmony export */ });
'use client';

var EVariant;
(function (EVariant) {
    EVariant["PRIMARY"] = "PRIMARY";
    EVariant["SECONDARY"] = "SECONDARY";
})(EVariant || (EVariant = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 78525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustedCompanyName; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TrustedCompanyName/trusted-icon.js
'use client';




var TrustedIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? constants/* colors.primaryColor */.O9.primaryColor : _b, _c = _a.size, size = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.title, title = _e === void 0 ? '' : _e;
    return (react.createElement("svg", { width: size, height: size, className: className, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("circle", { cx: 10, cy: 10, r: 10, fill: color }),
        react.createElement("path", { d: 'm10 3 1.572 4.837h5.085l-4.114 2.99 1.572 4.836L10 12.673l-4.114 2.99 1.571-4.837-4.114-2.99h5.085L10 3Z', fill: '#fff' }),
        react.createElement("title", null, title)));
};


//# sourceMappingURL=trusted-icon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TrustedCompanyName/TrustedCompanyName.css.js
'use client';






var sizes = {
    xs: 12,
    sm: 14,
    md: 15
};
var Container = styled_components_browser_esm/* default.p */.ZP.p(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: fit-content;\n    ", "\n    font-weight: 500;\n    font-size: ", "px;\n    margin-top: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n"], ["\n    position: relative;\n    width: fit-content;\n    ", "\n    font-weight: 500;\n    font-size: ", "px;\n    margin-top: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n"])), function (_a) {
    var isTrusted = _a.isTrusted, paddingRight = _a.paddingRight;
    return isTrusted
        ? "\n        padding-right: ".concat(paddingRight, "px;\n    ")
        : '';
}, function (_a) {
    var size = _a.size, fontSize = _a.fontSize;
    return (fontSize !== 0 ? fontSize : sizes[size]);
});
var Link = styled_components_browser_esm/* default.a */.ZP.a(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n"], ["\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n"])), function (_a) {
    var color = _a.color;
    return color;
}, constants/* colors.buttonColor */.O9.buttonColor);
var Name = styled_components_browser_esm/* default.span */.ZP.span(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: default;\n    color: ", ";\n"], ["\n    cursor: default;\n    color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
(0,styled_components_browser_esm/* default */.ZP)(TrustedIcon)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n"], ["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


//# sourceMappingURL=TrustedCompanyName.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TrustedCompanyName/index.js
'use client';





var iconSizes = {
    xs: 12,
    sm: 14,
    md: 15
};
var TrustedCompanyName = function (props) {
    var // isTrusted = false,
    size = props.size, _a = props.color, color = _a === void 0 ? constants/* colors.textColor */.O9.textColor : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.className, className = _c === void 0 ? '' : _c, href = props.href, name = props.name; props.tooltip;
    /**
     * VNW-19840 [Web] Remove "Trusted" tag all page
     *
     * Set isTrusted = false
     * @author PhongGP
     * @since Dec 26, 2022
     */
    var isTrusted = false;
    var sizeType = 'md';
    var fontSize = 0;
    var iconSize = 0;
    if (typeof size === 'string') {
        sizeType = size;
    }
    else {
        fontSize = (size === null || size === void 0 ? void 0 : size.fontSize) || 0;
        iconSize = (size === null || size === void 0 ? void 0 : size.iconSize) || 0;
    }
    return (react.createElement(Container, { style: style, className: className, size: sizeType, fontSize: fontSize, isTrusted: isTrusted, paddingRight: iconSize !== 0 ? iconSize + 6 : iconSizes[sizeType] + 6 },
        href ? (react.createElement(Link, { title: name, color: color, className: 'trusted-company-name', href: href, target: '_blank' }, name)) : (react.createElement(Name, { title: name, color: color, className: 'trusted-company-name' }, name)),
        (react.createElement(react.Fragment, null))));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 73851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ee": function() { return /* binding */ Anchor; },
  "H1": function() { return /* binding */ H1; },
  "H2": function() { return /* binding */ H2; },
  "H3": function() { return /* binding */ H3; },
  "H4": function() { return /* binding */ H4; },
  "H5": function() { return /* binding */ H5; },
  "H6": function() { return /* binding */ H6; },
  "__": function() { return /* binding */ Label; },
  "nv": function() { return /* binding */ Paragraph; },
  "Dr": function() { return /* binding */ Span; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/styled.css.js
'use client';






var AnchorCss = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"], ["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"])), Colors/* colors.secondary.40 */.O9.secondary[40]);
var templateObject_1;


//# sourceMappingURL=styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js
'use client';






var H1 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h1' }, rest), children));
});
var H2 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h2' }, rest), children));
});
var H3 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h3' }, rest), children));
});
var H4 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h4' }, rest), children));
});
var H5 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h5' }, rest), children));
});
var H6 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h6' }, rest), children));
});
var Label = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'label' }, rest), children));
});
var Paragraph = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'p' }, rest), children));
});
var Span = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'span' }, rest), children));
});
var Anchor = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return (react.createElement(AnchorCss, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'a' }, rest), children));
});


//# sourceMappingURL=Variant.js.map


/***/ }),

/***/ 17739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Typography/const.js
'use client';

var display = {
    extraLarge: {},
    large: {
        'font-size': '57px',
        'font-weight': '400',
        'line-height': '64px'
    },
    medium: {
        'font-size': '45px',
        'font-weight': '400',
        'line-height': '52px'
    },
    small: {
        'font-size': '36px',
        'font-weight': '400',
        'line-height': '44px'
    }
};
var headline = {
    extraLarge: {},
    large: {
        'font-size': '32px',
        'font-weight': '600',
        'line-height': '40px'
    },
    medium: {
        'font-size': '28px',
        'font-weight': '600',
        'line-height': '36px'
    },
    small: { 'font-size': '24px', 'font-weight': '600', 'line-height': '32px' }
};
var title = {
    extraLarge: {
        'font-size': '20px',
        'font-weight': '600',
        'line-height': '24px'
    },
    large: {
        'font-size': '18px',
        'font-weight': '600',
        'line-height': '22px'
    },
    medium: {
        'font-size': '16px',
        'font-weight': '600',
        'line-height': '20px'
    },
    small: {
        'font-size': '14px',
        'font-weight': '600',
        'line-height': '18px'
    }
};
var label = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '500',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '500',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '500', 'line-height': '14px' }
};
var body = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '14px' }
};
var paragraph = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '24px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '20px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '18px' }
};


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Typography/styled.css.js
'use client';





var typoStyles = (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var name = _a.name, size = _a.size;
    switch (name) {
        case 'display':
            return function () {
                switch (size) {
                    case 'large':
                        return display.large;
                    case 'medium':
                        return display.medium;
                    case 'small':
                        return display.small;
                }
            };
        case 'headline':
            return function () {
                switch (size) {
                    case 'large':
                        return headline.large;
                    case 'medium':
                        return headline.medium;
                    case 'small':
                        return headline.small;
                }
            };
        case 'title':
            return function () {
                switch (size) {
                    case 'extraLarge':
                        return title.extraLarge;
                    case 'large':
                        return title.large;
                    case 'medium':
                        return title.medium;
                    case 'small':
                        return title.small;
                }
            };
        case 'label':
            return function () {
                switch (size) {
                    case 'large':
                        return label.large;
                    case 'medium':
                        return label.medium;
                    case 'small':
                        return label.small;
                }
            };
        case 'body':
            return function () {
                switch (size) {
                    case 'large':
                        return body.large;
                    case 'medium':
                        return body.medium;
                    case 'small':
                        return body.small;
                }
            };
        case 'paragraph':
            return function () {
                switch (size) {
                    case 'large':
                        return paragraph.large;
                    case 'medium':
                        return paragraph.medium;
                    case 'small':
                        return paragraph.small;
                }
            };
    }
});
var Typo = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"], ["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily;
}, typoStyles);
var templateObject_1, templateObject_2;


//# sourceMappingURL=styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js
'use client';






var Typography = react.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'p' : _b, _c = _a.name, name = _c === void 0 ? 'paragraph' : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, className = _a.className, style = _a.style, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'Inter' : _e, _f = _a.color, color = _f === void 0 ? Colors/* colors.primary.0 */.O9.primary[0] : _f, rest = (0,_tslib/* __rest */._T)(_a, ["children", "variant", "name", "size", "className", "style", "fontFamily", "color"]);
    return (react.createElement(Typo, (0,_tslib/* __assign */.pi)({ ref: ref, style: (0,_tslib/* __assign */.pi)({}, style), className: className, as: variant, name: name, size: size, color: color, fontFamily: fontFamily }, rest), children));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 84214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ updateUserContactInfo; },
/* harmony export */   "$W": function() { return /* binding */ apiDoUpload; },
/* harmony export */   "PS": function() { return /* binding */ apiGetResume; },
/* harmony export */   "Sk": function() { return /* binding */ getUserContactInfo; },
/* harmony export */   "_s": function() { return /* binding */ apiPostResume; },
/* harmony export */   "e1": function() { return /* binding */ getJobLevelList; },
/* harmony export */   "e2": function() { return /* binding */ autoCompleteJobTitle; },
/* harmony export */   "ni": function() { return /* binding */ updateSummaryProfileSetting; }
/* harmony export */ });
/* unused harmony export formatSummary */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53001);
'use client';




var apiGetResume = function (accessToken, langCode, url) {
    if (accessToken === void 0) { accessToken = ''; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response, responseJson, e_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseJson = _a.sent();
                    if (responseJson) {
                        return [2 /*return*/, responseJson];
                    }
                    return [2 /*return*/, {}];
                case 3:
                    e_1 = _a.sent();
                    console.error('apiGetResume ', e_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var apiDoUpload = function (accessToken, langCode, url, file, resumeId, isReplace) {
    if (accessToken === void 0) { accessToken = ''; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var formData, response, e_2;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    if (resumeId && isReplace) {
                        formData.append('resume_id', resumeId.toString());
                        // When resumeId is provided it always replaced
                        formData.append('is_replaced', 'true');
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_2 = _a.sent();
                    console.log('apiDoUpload ', e_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var apiPostResume = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var accessToken, url, data, body, response, ex_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, url = params.url, data = params.data;
                body = {
                    jobTitle: data.jobTitle,
                    yearsExperience: data.yearsExperience,
                    locations: data.locations,
                    jobLevelId: data.jobLevelId,
                    highestDegreeId: data.highestDegreeId,
                    salary: data.salary,
                    companyIndustries: data.companyIndustries,
                    industries: data.industries,
                    resumeId: data.resumeId,
                    jobFunction: data.jobFunction
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.log(ex_1);
                return [2 /*return*/, {
                        meta: {
                            message: '',
                            code: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateUserContactInfo = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var accessToken, url, data, postData, response;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, url = params.url, data = params.data;
                postData = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, data), { isSearchable: data.isSearchable ? 1 : 0 });
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                _a.sent();
                return [2 /*return*/, {
                        meta: {
                            message: '',
                            code: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getJobLevelList = function (url) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET'
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var autoCompleteJobTitle = function (url, keyword, accessToken) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer ".concat(accessToken)
                    },
                    body: JSON.stringify({
                        keyword: keyword
                    })
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getUserContactInfo = function (accessToken, langCode, url) {
    if (accessToken === void 0) { accessToken = ''; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response, e_3;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_3 = _a.sent();
                    console.log('getUserContactInfo ', e_3);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var formatSummary = function (summary) {
    var formattedSummary = summary;
    if (formattedSummary.length > _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_MAX_SUMMARY_LENGTH */ .dY) {
        formattedSummary = summary.slice(0, _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_MAX_SUMMARY_LENGTH */ .dY);
    }
    return formattedSummary;
};
var updateSummaryProfileSetting = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var url, accessToken, _a, summary, API_URL, response, ex_3;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                url = params.url, accessToken = params.accessToken, _a = params.summary, summary = _a === void 0 ? '' : _a;
                API_URL = "".concat(url, "/api-gateway/v1.0/profile/cookie");
                return [4 /*yield*/, fetch(API_URL, {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            summary: formatSummary(summary)
                        })
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_3 = _b.sent();
                console.error(ex_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=apiServices.js.map


/***/ }),

/***/ 53001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F6": function() { return /* binding */ INTERNATIONAL_CITY_ID; },
/* harmony export */   "FG": function() { return /* binding */ LITMIT_SELECTION; },
/* harmony export */   "I6": function() { return /* binding */ notAllowCityId; },
/* harmony export */   "Jb": function() { return /* binding */ VIETNAM_COUNTRY_ID; },
/* harmony export */   "QB": function() { return /* binding */ DEFAULT_1MB_SIZE; },
/* harmony export */   "Ri": function() { return /* binding */ DEFAULT_ALLOW_FILES_EXT; },
/* harmony export */   "Wx": function() { return /* binding */ DEFAULT_ALLOW_EXT; },
/* harmony export */   "al": function() { return /* binding */ DEFAULT_1KB_SIZE; },
/* harmony export */   "dY": function() { return /* binding */ DEFAULT_MAX_SUMMARY_LENGTH; },
/* harmony export */   "dv": function() { return /* binding */ INTERNSHIP_ID; },
/* harmony export */   "hS": function() { return /* binding */ DEFAULT_LIMIT_FILE_SIZE; },
/* harmony export */   "i0": function() { return /* binding */ noSpecialCharsForJobTitle; },
/* harmony export */   "jY": function() { return /* binding */ META_API_LINK; },
/* harmony export */   "kF": function() { return /* binding */ MAX_YEAR_OF_EXPERIENCE; },
/* harmony export */   "lG": function() { return /* binding */ defaultProps; },
/* harmony export */   "lk": function() { return /* binding */ MAX_SALARY; },
/* harmony export */   "r3": function() { return /* binding */ DEFAULT_MAX_LENGTH_JOB_TITLE; },
/* harmony export */   "s1": function() { return /* binding */ initWorkingReferenceData; },
/* harmony export */   "s9": function() { return /* binding */ MIN_SALARY; },
/* harmony export */   "sE": function() { return /* binding */ MIN_YEAR_OF_EXPERIENCE; },
/* harmony export */   "se": function() { return /* binding */ DEFAULT_SUCCESS_CODE; },
/* harmony export */   "yE": function() { return /* binding */ FRESHER_ID; }
/* harmony export */ });
/* unused harmony exports MEKONG_CITY_ID, OTHER_CITY_ID */
'use client';

var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_1MB_SIZE = 1000000;
var DEFAULT_1KB_SIZE = 1000;
var DEFAULT_LIMIT_FILE_SIZE = 5242880; // 5MB - update theo size backend validate
var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_MAX_LENGTH_JOB_TITLE = 80;
var MIN_YEAR_OF_EXPERIENCE = 0;
var MAX_YEAR_OF_EXPERIENCE = 99;
var MIN_SALARY = 0;
var MAX_SALARY = 500000;
var noSpecialCharsForJobTitle = /[@!$%^*()_|~=`{}[\]:";'<>?,]/;
var META_API_LINK = "/meta/v1.0/international-phone-number";
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var LITMIT_SELECTION = 3;
var DEFAULT_MAX_SUMMARY_LENGTH = 5000; // Max 5000 characters for summary field in my-profile
var defaultProps = {
    initialData: {
        address: '',
        birthday: new Date(1990, 0, 1),
        cityId: 0,
        countryId: 0,
        districtId: 0,
        email: '',
        genderId: 0,
        isSearchable: false,
        maritalStatusId: 0,
        nationalityId: 0,
        phone: '',
        userId: 0,
        resumeId: 0
    },
    onCancel: function () { return null; },
    onSave: function () { return null; }
};
var initWorkingReferenceData = {
    jobTitle: '',
    jobLevelId: 0,
    locations: [],
    industries: [],
    companyIndustries: [],
    salary: 0,
    isSearchable: 0,
    yearsExperience: 0,
    highestDegreeId: 0,
    resumeId: -1,
    jobFunction: []
};
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var notAllowCityId = [INTERNATIONAL_CITY_ID, MEKONG_CITY_ID, OTHER_CITY_ID];


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 88845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JF": function() { return /* binding */ ETab; },
/* harmony export */   "P2": function() { return /* binding */ EGender; },
/* harmony export */   "oj": function() { return /* binding */ EMaritalStatus; }
/* harmony export */ });
'use client';

var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["NEW"] = 0] = "NEW";
    EMaritalStatus[EMaritalStatus["SINGLE"] = 1] = "SINGLE";
    EMaritalStatus[EMaritalStatus["MARRIED"] = 2] = "MARRIED";
})(EMaritalStatus || (EMaritalStatus = {}));
var EGender;
(function (EGender) {
    EGender[EGender["MALE"] = 1] = "MALE";
    EGender[EGender["FEMALE"] = 2] = "FEMALE";
})(EGender || (EGender = {}));
var ETab;
(function (ETab) {
    ETab[ETab["UPLOAD_CV"] = 1] = "UPLOAD_CV";
    ETab[ETab["CONTACT_INFORMATION"] = 2] = "CONTACT_INFORMATION";
    ETab[ETab["WORKING_PREFERENCE"] = 3] = "WORKING_PREFERENCE";
})(ETab || (ETab = {}));


//# sourceMappingURL=type.js.map


/***/ }),

/***/ 6017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ setCookie; },
/* harmony export */   "e": function() { return /* binding */ getCookie; }
/* harmony export */ });
'use client';

var setCookie = function (name, value, days, domain) {
    if (domain === void 0) { domain = ''; }
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    var domainStr = '';
    if (domain !== '') {
        domainStr = 'domain=' + domain + '; ';
    }
    document.cookie = name + '=' + value + expires + '; ' + domainStr + 'path=/';
};
var getCookie = function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};


//# sourceMappingURL=cookie.js.map


/***/ }),

/***/ 55613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ isDifferentArrayData; },
/* harmony export */   "BN": function() { return /* binding */ debounceHandler; },
/* harmony export */   "Bs": function() { return /* binding */ fixedNumber; },
/* harmony export */   "Ew": function() { return /* binding */ addCommaToNumber; },
/* harmony export */   "G": function() { return /* binding */ isLocationChanged; },
/* harmony export */   "HI": function() { return /* binding */ encrypt; },
/* harmony export */   "If": function() { return /* binding */ detectEncryptAccessToken; },
/* harmony export */   "Ji": function() { return /* binding */ getNumberFromString; },
/* harmony export */   "NF": function() { return /* binding */ encodeKeyword; },
/* harmony export */   "PB": function() { return /* binding */ quickFilterByKeywords; },
/* harmony export */   "RH": function() { return /* binding */ deepMerge; },
/* harmony export */   "SO": function() { return /* binding */ filterHTMLTag; },
/* harmony export */   "YK": function() { return /* binding */ isCompanyWhitelisted; },
/* harmony export */   "_2": function() { return /* binding */ attachQueryParamToUrl; },
/* harmony export */   "ce": function() { return /* binding */ locationsMappingHelperForMultiLevelSelect; },
/* harmony export */   "eX": function() { return /* binding */ createTranslator; },
/* harmony export */   "ec": function() { return /* binding */ filterObjectArrayBasedOnObjectArray; },
/* harmony export */   "fJ": function() { return /* binding */ filterInt; },
/* harmony export */   "hw": function() { return /* binding */ formatSalary; },
/* harmony export */   "iz": function() { return /* binding */ detectPage; },
/* harmony export */   "jE": function() { return /* binding */ downloadAttachFile; },
/* harmony export */   "jI": function() { return /* binding */ textToLatin; },
/* harmony export */   "kb": function() { return /* binding */ randomId; },
/* harmony export */   "l6": function() { return /* binding */ isRobot; },
/* harmony export */   "lV": function() { return /* binding */ slugify; },
/* harmony export */   "mT": function() { return /* binding */ ConvertHexToRgbA; },
/* harmony export */   "n3": function() { return /* binding */ checkIfEmailInString; },
/* harmony export */   "nI": function() { return /* binding */ isDesktop; },
/* harmony export */   "nr": function() { return /* binding */ transformToLatin; },
/* harmony export */   "oB": function() { return /* binding */ isIPv4FromGoogle; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "pe": function() { return /* binding */ decrypt; },
/* harmony export */   "qr": function() { return /* binding */ sortArray; },
/* harmony export */   "sf": function() { return /* binding */ compareVariable; },
/* harmony export */   "t": function() { return /* binding */ t; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "u1": function() { return /* binding */ getiOSVersion; },
/* harmony export */   "vZ": function() { return /* binding */ deepEqual; },
/* harmony export */   "z6": function() { return /* binding */ generateJobUrl; },
/* harmony export */   "zD": function() { return /* binding */ filterPrivateIP; }
/* harmony export */ });
/* unused harmony exports isPrivateIP, isVietnamese */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
/* harmony import */ var _translations_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93412);
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
'use client';





function filterInt(value) {
    if (/^[-+]?(\d+|Infinity)$/.test(value)) {
        return Number(value);
    }
    else {
        return NaN;
    }
}
function isMobile() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}
function isDesktop() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 992;
    }
    return false;
}
// Hex to RGBA with 20% opacity
function ConvertHexToRgbA(hex, opacity) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ",".concat(opacity, ")");
    }
    throw new Error('Bad Hex');
}
function addCommaToNumber(number) {
    var nums = number.toString().replace(/,/g, '');
    if (!nums || nums.endsWith('.'))
        return number.toString();
    return parseFloat(nums).toLocaleString('en-US');
}
function getNumberFromString(string) {
    if (string) {
        return Number(string.replace(/,/g, ''));
    }
    else
        return '';
}
function encodeKeyword(rawKeyword) {
    var blackList = [
        { regex: /C#/gi, replace: 'C_sharp' },
        {
            regex: /C\+\+/gi,
            replace: 'C_plus_plus'
        },
        { regex: /[[\]\\/:~^?!()><"'@%|{}`*#]/gi, replace: ' ' },
        { regex: /&/gi, replace: encodeURIComponent('&') }
    ];
    var tempkeyword;
    for (var i in blackList) {
        rawKeyword = rawKeyword.replace(blackList[i].regex, blackList[i].replace);
    }
    do {
        tempkeyword = rawKeyword;
        rawKeyword = tempkeyword.replace('  ', ' ');
    } while (tempkeyword !== rawKeyword);
    rawKeyword = rawKeyword.replace(/[-]{1,}/g, '--');
    rawKeyword = rawKeyword.trim();
    return rawKeyword.replace(/ /g, '-');
}
/**
 * Transform all characters with accent into latin, e.g. `Ô kìa Con vịt` to `o kia con vit`
 * @param text - the text you want to transform
 */
function transformToLatin(text, isUrl) {
    if (isUrl === void 0) { isUrl = false; }
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    if (!isUrl) {
        sets.push({ to: '-', from: "[·/_,:;']" });
    }
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    text = text.replace(/[^ -~]/gi, '');
    return text;
}
/**
 * Clean slugs by removing spaces, invalid characters and dashes
 * @param slug - the slug you wanna clean
 */
function slugify(slug) {
    slug = slug.replace(/^\s+|\s+$/g, ''); // trim
    slug = slug.toLowerCase();
    // remove accents
    slug = transformToLatin(slug);
    slug = slug
        .replace(/[^a-z0-9 -]/g, '-') // invalid chars to -
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
    return slug;
}
function t(key, language) {
    var _a;
    if (language === 'en') {
        return key;
    }
    else {
        return (_a = _translations_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[key]) !== null && _a !== void 0 ? _a : key;
    }
}
/**
 * Decrypt accessToken (Copied from app-shell-v2/src/helpers/helper.ts:245 )
 * @param token accessToken (Example: user.accessToken from homepage)
 * @returns decrypted accessToken
 */
function decrypt(token) {
    if (typeof atob === 'function') {
        return atob(atob(token));
    }
    var nodeAtob = function (str) {
        return Buffer.from(str, 'base64').toString('binary');
    };
    return nodeAtob(nodeAtob(token));
}
function encrypt(token) {
    if (typeof btoa === 'function') {
        return btoa(btoa(token)).replace(/=/g, '');
    }
    var nodeBtoa = function (str) {
        return Buffer.from(str).toString('base64');
    };
    return nodeBtoa(nodeBtoa(token));
}
var detectPage = function () {
    if (typeof window === undefined) {
        return 'search-result';
    }
    var url = window.location.href;
    for (var i = 0; i < _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .pathPage.length */ .Xs.length; i++) {
        var pathItem = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .pathPage */ .Xs[i];
        var checkPath = pathItem.path.filter(function (path) { return url.indexOf(path) >= 0; });
        if (checkPath.length > 0) {
            return pathItem.page;
        }
    }
    return 'homepage';
};
var filterHTMLTag = function (text) {
    if (text === void 0) { text = ''; }
    return text !== undefined && text !== null ? text.replace(/<\/?[^>]+(>|$)/g, '') : '';
};
function generateJobUrl(jobId, alias, lang, domain, utmString) {
    if (lang === void 0) { lang = 'en'; }
    if (domain === void 0) { domain = ''; }
    if (utmString === void 0) { utmString = ''; }
    var linkJob = domain + '/' + alias + '-' + jobId;
    if (lang === 'en') {
        linkJob += '-jd';
    }
    else {
        linkJob += '-jv';
    }
    if (utmString.length > 0) {
        linkJob += '?' + utmString;
    }
    return linkJob;
}
var compareVariable = function (val1, val2) {
    return JSON.stringify(val1) === JSON.stringify(val2);
};
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return null;
    }
    var _a = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    }, r = _a.r, g = _a.g, b = _a.b;
    return {
        r: r,
        g: g,
        b: b,
        toString: function () {
            return [r, g, b].join(',');
        }
    };
}
function isDifferentArrayData(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
        console.trace("[isDifferentArrayData] Invalid input data ".concat(arr1, " ").concat(arr2));
        return true;
    }
    return arr1.some(function (item) { return !arr2.includes(item); }) || arr2.some(function (item) { return !arr1.includes(item); });
}
var sortArray = function (options, type, objectKey) {
    if (type === void 0) { type = 'asc'; }
    if (objectKey === void 0) { objectKey = ''; }
    if (options.length > 0) {
        switch (typeof options[0]) {
            case 'number':
                return options.sort(function (a, b) { return (type === 'asc' ? a - b : b - a); });
            case 'string':
                return options.sort(function (a, b) {
                    if (transformToLatin(a) < transformToLatin(b)) {
                        return type === 'asc' ? 1 : -1;
                    }
                    if (transformToLatin(a) > transformToLatin(b)) {
                        return type === 'asc' ? -1 : 1;
                    }
                    return 0;
                });
            case 'object': {
                var firstObject = options[0];
                switch (typeof firstObject[objectKey]) {
                    case 'number':
                        return options.sort(function (a, b) {
                            return type === 'asc' ? a[objectKey] - b[objectKey] : b[objectKey] - a[objectKey];
                        });
                    case 'string':
                        return options.sort(function (a, b) {
                            if (transformToLatin(a[objectKey]) < transformToLatin(b[objectKey])) {
                                return type === 'asc' ? -1 : 1;
                            }
                            if (transformToLatin(a[objectKey]) > transformToLatin(b[objectKey])) {
                                return type === 'asc' ? 1 : -1;
                            }
                            return 0;
                        });
                    default:
                        return [];
                }
            }
            default:
                return [];
        }
    }
    else {
        return [];
    }
};
var fixedNumber = function (number, rounding) {
    if (rounding === void 0) { rounding = 0.5; }
    var numb = Number(number);
    if (numb > 0) {
        var plusNumb = Math.abs(numb - Math.floor(numb)) < rounding ? 0 : 1;
        return Math.floor(numb) + plusNumb;
    }
    else {
        var plusNumb = Math.abs(numb - Math.ceil(numb)) < rounding ? 0 : 1;
        return Math.ceil(numb) - plusNumb;
    }
};
var textToLatin = function (text) {
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    return text;
};
function checkIfEmailInString(text) {
    var regex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
    return regex.test(text);
}
var addrToNumber = function (addr) {
    return addr.split('.').reduce(function (acc, cur, i) { return (acc += Number(cur) << ((3 - i) * 8)); }, 0);
};
var subnetMaskToNumber = function (mask) {
    return (0xffffffff << (32 - Number(mask))) & 0xffffffff;
};
var isIPv4FromGoogle = function (userIP) {
    var googleBotIPRange = [
        '66.249.64.0/27',
        '66.249.64.128/27',
        '66.249.64.160/27',
        '66.249.64.192/27',
        '66.249.64.224/27',
        '66.249.64.32/27',
        '66.249.64.64/27',
        '66.249.64.96/27',
        '66.249.65.0/27',
        '66.249.65.128/27',
        '66.249.65.160/27',
        '66.249.65.192/27',
        '66.249.65.224/27',
        '66.249.65.32/27',
        '66.249.65.64/27',
        '66.249.65.96/27',
        '66.249.66.0/27',
        '66.249.66.128/27',
        '66.249.66.192/27',
        '66.249.66.32/27',
        '66.249.66.64/27',
        '66.249.68.0/27',
        '66.249.68.32/27',
        '66.249.68.64/27',
        '66.249.69.0/27',
        '66.249.69.128/27',
        '66.249.69.160/27',
        '66.249.69.192/27',
        '66.249.69.224/27',
        '66.249.69.32/27',
        '66.249.69.64/27',
        '66.249.69.96/27',
        '66.249.70.0/27',
        '66.249.70.128/27',
        '66.249.70.160/27',
        '66.249.70.192/27',
        '66.249.70.224/27',
        '66.249.70.32/27',
        '66.249.70.64/27',
        '66.249.70.96/27',
        '66.249.71.0/27',
        '66.249.71.128/27',
        '66.249.71.160/27',
        '66.249.71.192/27',
        '66.249.71.32/27',
        '66.249.71.64/27',
        '66.249.71.96/27',
        '66.249.72.0/27',
        '66.249.72.128/27',
        '66.249.72.160/27',
        '66.249.72.192/27',
        '66.249.72.224/27',
        '66.249.72.32/27',
        '66.249.72.64/27',
        '66.249.72.96/27',
        '66.249.73.0/27',
        '66.249.73.128/27',
        '66.249.73.160/27',
        '66.249.73.192/27',
        '66.249.73.224/27',
        '66.249.73.32/27',
        '66.249.73.64/27',
        '66.249.73.96/27',
        '66.249.74.0/27',
        '66.249.74.32/27',
        '66.249.74.64/27',
        '66.249.74.96/27',
        '66.249.75.0/27',
        '66.249.75.128/27',
        '66.249.75.160/27',
        '66.249.75.192/27',
        '66.249.75.224/27',
        '66.249.75.32/27',
        '66.249.75.64/27',
        '66.249.75.96/27',
        '66.249.76.0/27',
        '66.249.76.128/27',
        '66.249.76.160/27',
        '66.249.76.192/27',
        '66.249.76.224/27',
        '66.249.76.32/27',
        '66.249.76.64/27',
        '66.249.76.96/27',
        '66.249.77.0/27',
        '66.249.77.128/27',
        '66.249.77.32/27',
        '66.249.77.64/27',
        '66.249.77.96/27',
        '66.249.79.0/27',
        '66.249.79.128/27',
        '66.249.79.160/27',
        '66.249.79.192/27',
        '66.249.79.224/27',
        '66.249.79.32/27',
        '66.249.79.64/27',
        '66.249.79.96/27',
        '66.249.91.0/27'
    ];
    var isFromGoogle = false;
    // Loop through all CIDR from google IPv4 to find match IP
    googleBotIPRange.map(function (cidr) {
        var _a = cidr.split('/'), networkAddr = _a[0], subnetMask = _a[1];
        var match = (addrToNumber(userIP) & subnetMaskToNumber(subnetMask)) === addrToNumber(networkAddr);
        if (match) {
            isFromGoogle = true;
        }
    });
    return isFromGoogle;
};
// For IPv6
var isIPv6FromGoogle = function (userIP) {
    var isFromGoogle = false;
    // TODO: Loop through all CIDR from google IPv6 to find match IP
    // IPv6 is not support yet
    return isFromGoogle;
};
/**
 * Check user IP address if it is a bot or not
 * @param userIP string
 */
var isIPFromGoogleBot = function (userIP) {
    if (userIP.length === 0) {
        return false;
    }
    var isFromGoogle = false;
    for (var i = 0; i < userIP.length; i++) {
        if (!userIP[i]) {
            continue;
        }
        var isIPv4 = userIP[i].indexOf('.') > 0;
        var userIPSplitted = isIPv4 ? userIP[i].split('.') : userIP[i].split(':');
        if (isIPv4 && userIPSplitted[0] === '66' && userIPSplitted[1] === '249') {
            isFromGoogle = isIPv4FromGoogle(userIP[i]);
        }
        else if (!isIPv4 &&
            userIPSplitted.length > 1 &&
            userIPSplitted[0] === '2001' &&
            userIPSplitted[1] === '4860' &&
            userIPSplitted[2] === '4801') {
            isFromGoogle = isIPv6FromGoogle(userIP[i]);
        }
    }
    return isFromGoogle;
};
/**
 * Check a user-agent if it's a robot
 * @param userAgent
 */
var isRobot = function (userAgent, userIP) {
    var botUserAgents = [
        'googlebot',
        'google-structured-data-testing-tool',
        'bingbot',
        'linkedinbot',
        'mediapartners-google',
        'apis-google',
        'feedfetcher-google',
        'googlebot-image',
        'storebot-google',
        'adsBot-google-mobile',
        'adsBot-google-mobile-apps',
        'adsBot-google',
        'googlebot-news',
        'googlebot-video',
        'storebot-google'
    ];
    var currentUserAgent = userAgent.toLowerCase();
    var isBot = botUserAgents.some(function (item) {
        return currentUserAgent.includes(item);
    });
    // Detect IP from Google bot
    // Only call detect IP when isBot = false (For better performance)
    if (!isBot && userIP !== undefined) {
        isBot = isIPFromGoogleBot(userIP);
    }
    return isBot;
};
var isCompanyWhitelisted = function (props) {
    var companyId = props.companyId, appMode = props.appMode;
    // staging
    if (appMode === 'staging') {
        return _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGOS_COMPANY_ID.staging.includes */ .x0.staging.includes(companyId);
    }
    // release
    if (appMode === 'release') {
        return _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGOS_COMPANY_ID.release.includes */ .x0.release.includes(companyId);
    }
    // production
    return _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGOS_COMPANY_ID.production.includes */ .x0.production.includes(companyId);
};
/**
 * Return Random UID - @SangNguyen
 * @returns unique id (Ex: rand-bdc08475-7af48ce5-9da0d3be)
 */
var randomId = function () {
    var s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return "rand-".concat(s4()).concat(s4(), "-").concat(s4()).concat(s4(), "-").concat(s4()).concat(s4());
};
/**
 * Check values change
 * @param firstLocations first item locations need to compare
 * @param secondLocations second item locations need to compare
 * @returns boolean true when 2 variables is different
 */
function isLocationChanged(firstLocations, secondLocations) {
    var _a, _b, _c, _d, _e, _f;
    // parents is have more or less item
    if (firstLocations.length !== secondLocations.length) {
        return true;
    }
    var _loop_1 = function (i) {
        var currentItem = firstLocations[i];
        var filtered = secondLocations.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.parentId) === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.parentId); });
        // length match then detect child item
        // second item doesn't have item that first item have
        if (filtered.length === 0) {
            return { value: true };
        }
        // Child is have more or less selected
        if (((_b = (_a = filtered[0]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length) !== ((_c = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _c === void 0 ? void 0 : _c.length)) {
            return { value: true };
        }
        var _loop_2 = function (j) {
            var childId = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds[j];
            var filteredChild = (_f = (_e = filtered[0]) === null || _e === void 0 ? void 0 : _e.childrenIds) === null || _f === void 0 ? void 0 : _f.filter(function (childItemId) { return childItemId === childId; });
            if (filteredChild.length === 0) {
                return { value: true };
            }
        };
        // length does match need to compare child
        for (var j = 0; j < ((_d = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _d === void 0 ? void 0 : _d.length); j++) {
            var state_2 = _loop_2(j);
            if (typeof state_2 === "object")
                return state_2;
        }
    };
    // Check districts
    for (var i = 0; i < firstLocations.length; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return false;
}
function formatSalary(_a, isShowSalary, language) {
    var min = _a.min, max = _a.max;
    if (!isShowSalary) {
        return language === 'en' ? 'Negotiate' : 'Thương Lượng';
    }
    if (min > 0 && max > 0) {
        return "$".concat(min, " - $").concat(max);
    }
    if (min > 0) {
        return "".concat(language === 'en' ? 'From' : 'Từ', " $").concat(min);
    }
    if (max > 0) {
        return "".concat(language === 'en' ? 'Up To' : 'Tới', " $").concat(max);
    }
    return '';
}
function isVietnamese(text) {
    return /[\u0300-\u036f]|[đĐ]/gi.test(text.normalize('NFD'));
}
function createTranslator(_a) {
    var translations = _a.translations, defaultLanguage = _a.defaultLanguage, currentLanguage = _a.currentLanguage;
    var firstEntry = null;
    var detectedDefaultLanguage = defaultLanguage;
    if (!detectedDefaultLanguage) {
        for (var _i = 0, _b = Object.entries(translations); _i < _b.length; _i++) {
            var _c = _b[_i], keyText = _c[0], valueText = _c[1];
            if (!firstEntry) {
                firstEntry = [keyText, valueText];
            }
            if (isVietnamese(keyText)) {
                detectedDefaultLanguage = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI;
                break;
            }
            if (isVietnamese(valueText)) {
                detectedDefaultLanguage = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN;
                break;
            }
        }
    }
    if (!detectedDefaultLanguage) {
        console.warn("Cannot detect default language from provided dictionary. First entry is \"".concat(firstEntry, "\""));
        console.warn("Fallback to English as default language");
        detectedDefaultLanguage = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN;
    }
    return function (text, replacement) {
        if (!text) {
            return '';
        }
        var matchedText = currentLanguage === detectedDefaultLanguage ? text : translations[text];
        if (!matchedText) {
            matchedText = text;
        }
        return replacement
            ? Object.keys(replacement).reduce(function (acc, key) { return acc.replace(new RegExp(key, 'g'), replacement[key].toString()); }, matchedText)
            : matchedText;
    };
}
// this fnc using when not using state in input => using custom debounce
// for example in Form management
function debounceHandler(func, delay) {
    var timer;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, args);
        }, delay);
    };
}
function attachQueryParamToUrl(url, params) {
    if (!Object.keys(params).length) {
        return url;
    }
    var urlEntity = new URL(url);
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === undefined) {
            urlEntity.searchParams.delete(key);
            continue;
        }
        if ((typeof value === 'object' && !Array.isArray(value)) || Number.isNaN(value)) {
            continue;
        }
        urlEntity.searchParams.set(key, value);
    }
    return urlEntity.toString();
}
function extractFileNameAndExtension(fileName) {
    var lastDotIndex = fileName === null || fileName === void 0 ? void 0 : fileName.lastIndexOf('.');
    var name = fileName === null || fileName === void 0 ? void 0 : fileName.slice(0, lastDotIndex);
    var extension = fileName === null || fileName === void 0 ? void 0 : fileName.slice(lastDotIndex + 1);
    return [name, extension];
}
function downloadAttachFile(params) {
    var _a;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var resumeId, accessToken, msBaseUrl, fileName, _b, downloadRequest, _c, body, _d, onOpenOrDownload_1, docExtensions, pdfMineType, API_DOWNLOAD_CV, requestOptions, response, blob, file_1, _e, extractedFilename_1, fileExtension_1, responseMineType, requestState, download, openNewTab, ex_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__generator */ .Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    resumeId = params.resumeId, accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, fileName = params.fileName, _b = params.downloadRequest, downloadRequest = _b === void 0 ? 'all' : _b, _c = params.body, body = _c === void 0 ? null : _c, _d = params.onOpenOrDownload, onOpenOrDownload_1 = _d === void 0 ? null : _d;
                    if (!accessToken) {
                        return [2 /*return*/];
                    }
                    docExtensions = ['docx', 'doc'];
                    pdfMineType = 'application/pdf';
                    API_DOWNLOAD_CV = "".concat(msBaseUrl, "/api-gateway/v1.0/profile/resume-file/").concat(resumeId);
                    requestOptions = {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    };
                    if (body !== null) {
                        requestOptions.headers['Content-Type'] = 'application/json';
                        requestOptions.body = JSON.stringify(body);
                    }
                    return [4 /*yield*/, fetch(API_DOWNLOAD_CV, requestOptions)];
                case 1:
                    response = _f.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _f.sent();
                    file_1 = window.URL.createObjectURL(blob);
                    _e = extractFileNameAndExtension(fileName), extractedFilename_1 = _e[0], fileExtension_1 = _e[1];
                    responseMineType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type');
                    requestState = downloadRequest;
                    if (docExtensions.includes(fileExtension_1) && responseMineType !== pdfMineType) {
                        requestState = 'download';
                    }
                    download = function () {
                        var a = document.createElement('a');
                        a.href = file_1;
                        a.download = transformToLatin("".concat(extractedFilename_1, ".").concat(fileExtension_1));
                        a.click();
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                    };
                    openNewTab = function () {
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                        if (typeof window === 'undefined') {
                            return;
                        }
                        window.open(file_1, '_blank');
                    };
                    switch (requestState) {
                        case 'download':
                            download();
                            break;
                        case 'new-window':
                            openNewTab();
                            break;
                        case 'all':
                        default:
                            download();
                            openNewTab();
                            break;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    ex_1 = _f.sent();
                    console.error('Error when download file', ex_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var ACCESS_TOKEN_LENGTH = 86;
var detectEncryptAccessToken = function (accessToken) {
    // If access token length is larger than 86 characters
    // then it should be decrypted
    return accessToken.length === ACCESS_TOKEN_LENGTH ? accessToken : decrypt(accessToken !== null && accessToken !== void 0 ? accessToken : '');
};
function getiOSVersion() {
    if (typeof window === 'undefined') {
        return -2;
    }
    var userAgent = window.navigator.userAgent;
    var match = userAgent.match(/(iPad|iPhone|iPod)\s+OS\s+(\d+)/);
    if (!match) {
        // Not iOS
        return -2;
    }
    if (match && match[2]) {
        var versionInNumber = Number(match[2]);
        if (isNaN(versionInNumber)) {
            return -1;
        }
        return versionInNumber;
    }
    // -1 is standing for Unknown
    return -1;
}
function isPrivateIP(ip) {
    // Localhost range
    var privateRanges = [
        { start: '10.0.0.0', end: '10.255.255.255' },
        { start: '172.16.0.0', end: '172.31.255.255' },
        { start: '192.168.0.0', end: '192.168.255.255' },
        { start: '127.0.0.0', end: '127.255.255.255' }
    ];
    var ipToNumber = function (ip) {
        return ip.split('.').reduce(function (acc, octet) { return acc * 256 + parseInt(octet, 10); }, 0);
    };
    var ipNumber = ipToNumber(ip.trim());
    return privateRanges.some(function (range) {
        return ipNumber >= ipToNumber(range.start) && ipNumber <= ipToNumber(range.end);
    });
}
var filterPrivateIP = function (ipList) {
    // Filter out all Fortiweb IP
    var filteredNotFortiweb = ipList.filter(function (ip) { return !_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .FORTIWEB_IP.includes */ .Jh.includes(ip); });
    // Filter out all private IP
    var filteredPublic = filteredNotFortiweb.filter(function (ip) { return !isPrivateIP(ip); });
    if (filteredPublic.length > 0) {
        return filteredPublic;
    }
    // If no public IP remain then return filtered not fortiweb
    return filteredNotFortiweb;
};
/*
 * Forked of https://github.com/epoberezkin/fast-deep-equal
 * */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) {
            return false;
        }
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!{}.hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
}
function filterObjectArrayBasedOnObjectArray(targetArray, filterArray, key, omit) {
    var filterArrayKeys = filterArray.map(function (item) { return item[key]; });
    if (omit && omit.length > 0) {
        filterArrayKeys = filterArrayKeys.concat(omit);
    }
    return targetArray.filter(function (item) { return !filterArrayKeys.includes(item[key]); });
}
function quickFilterByKeywords(options, keywords, fieldSearch) {
    var cpOptions = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], options, true);
    return cpOptions.filter(function (option) {
        if (keywords === '') {
            return true;
        }
        return transformToLatin(option[fieldSearch]).indexOf(transformToLatin(keywords)) > -1;
    });
}
function locationsMappingHelperForMultiLevelSelect(countries, cities, districts, langcode) {
    var mappedVietNamCities = [];
    cities.forEach(function (city) {
        if (districts[city.id]) {
            var result = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, city), { name: langcode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? city.name : city.nameEn, children: districts[city.id].map(function (district) { return ((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, district), { name: langcode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? district.name : district.nameEn })); }) });
            mappedVietNamCities.push(result);
        }
        else {
            mappedVietNamCities.push((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, city), { name: langcode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? city.name : city.nameEn }));
        }
    });
    mappedVietNamCities = mappedVietNamCities.filter(function (city) { return city.id !== _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_CITY_ID */ .F6; });
    var mappedCountries = [];
    countries.forEach(function (country) {
        if (country.id === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .VIETNAM_COUNTRY_ID */ .Jb) {
            var result = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, country), { name: langcode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? country.name : country.nameEn, children: mappedVietNamCities });
            mappedCountries.push(result);
        }
        else {
            var result = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, country), { name: langcode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? country.name : country.nameEn });
            mappedCountries.push(result);
        }
    });
    return mappedCountries;
}
/**
 * Deeply merge two or more objects
 * @param  {...object} objects - Objects to merge
 */
function deepMerge() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var target = {};
    var merge = function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if (obj[prop] === null || obj[prop] === undefined) {
                    continue;
                }
                if (typeof obj[prop] === 'object' && !Array.isArray(obj[prop])) {
                    target[prop] = deepMerge(target[prop], obj[prop]);
                }
                else if (typeof obj[prop] === 'object' && Array.isArray(obj[prop])) {
                    target[prop] = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], (target[prop] || []), true), (obj[prop] || []), true);
                }
                else {
                    target[prop] = obj[prop];
                }
            }
        }
    };
    objects.forEach(function (object) { return merge(object); });
    return target;
}


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 68664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": function() { return /* binding */ usePrevious; },
/* harmony export */   "Dz": function() { return /* binding */ useDidUpdateEffect; },
/* harmony export */   "R5": function() { return /* binding */ useMountTransition; },
/* harmony export */   "ZP": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
}
/**
 *
 * @see: https://usehooks.com/useDebounce/
 * @param value
 * @param delay
 */
function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var dependancies = [value, delay];
    if (typeof value !== 'string') {
        dependancies = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([], value, true), [delay], false);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, dependancies // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}
var useDidUpdateEffect = function (func, deps) {
    var didMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (didMount.current)
            func();
        else
            didMount.current = true;
    }, deps);
};
var useMountTransition = function (isMounted, unmountDelay) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasTransitionedIn = _a[0], setHasTransitionedIn = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var timeoutId;
        if (isMounted && !hasTransitionedIn) {
            setHasTransitionedIn(true);
        }
        else if (!isMounted && hasTransitionedIn) {
            timeoutId = setTimeout(function () { return setHasTransitionedIn(false); }, unmountDelay);
        }
        return function () {
            clearTimeout(timeoutId);
        };
    }, [unmountDelay, isMounted, hasTransitionedIn]);
    return hasTransitionedIn;
};


//# sourceMappingURL=hooks.js.map


/***/ }),

/***/ 85694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useElementOnScreen; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var useElementOnScreen = function (props) {
    var target = props.target, options = props.options;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), enable = _a[0], setEnable = _a[1];
    var isUseReactRef = props.options && props.options.isUseReactRef !== undefined ? props.options.isUseReactRef : true;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isElementOnScreen = _b[0], setElementOnScreen = _b[1];
    var callbackObserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (entities) {
        var entry = entities[0];
        setElementOnScreen(entry.isIntersecting);
        if (entry.isIntersecting && (options === null || options === void 0 ? void 0 : options.runOnce)) {
            setEnable(false);
        }
    }, [options === null || options === void 0 ? void 0 : options.runOnce]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // on mount
        if (target === undefined || target === null) {
            return;
        }
        if (typeof window === 'undefined') {
            return;
        }
        if (options === null) {
            return;
        }
        if (!enable) {
            return;
        }
        var intersectionObserver = null;
        if (typeof window.IntersectionObserver !== 'undefined') {
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            intersectionObserver = new IntersectionObserver(callbackObserve, options);
            intersectionObserver.observe(isUseReactRef ? target.current : target);
        }
        return function () {
            // on disMount
            if (target === undefined || target === null) {
                return;
            }
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            if (intersectionObserver !== null) {
                intersectionObserver.unobserve(isUseReactRef ? target.current : target);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, enable]);
    return [isElementOnScreen];
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 72831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useInitNotification; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * Hook to manage `isShowNotification` state
 * This state is used to render lazy loaded @vnw/notification package
 * Should load notification package when:
 * - Has mousedown event which means user has clicked something in the site
 * - User clicks on Bell icon
 *
 */
function useInitNotification() {
    var _a = react__WEBPACK_IMPORTED_MODULE_0__.useState(false), isShowNotification = _a[0], setIsShowNotification = _a[1];
    var triggerNotification = function () {
        if (typeof window === 'undefined')
            return;
        var event = new CustomEvent('VNW_OPEN_NOTIFICATION');
        window.dispatchEvent(event);
    };
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        if (typeof document === 'undefined')
            return;
        var notiIconNodes = document.querySelectorAll('.notification-icon');
        var burgerBtnNode = document.querySelector('.burger-btn');
        var mobileNotiIconNode = null;
        var timer = null;
        var handleClickBell = function () {
            if (!isShowNotification) {
                setIsShowNotification(true);
            }
            else {
                triggerNotification();
            }
        };
        var handleClickBurgerMenu = function () {
            timer && clearTimeout(timer);
            if (!isShowNotification) {
                setIsShowNotification(true);
            }
            timer = setTimeout(function () {
                mobileNotiIconNode = document.querySelector('.menu-notification');
                mobileNotiIconNode === null || mobileNotiIconNode === void 0 ? void 0 : mobileNotiIconNode.addEventListener('click', handleClickBell);
            }, 0);
        };
        var handleShowNotification = function () {
            if (!isShowNotification) {
                setIsShowNotification(true);
            }
        };
        notiIconNodes.forEach(function (node) {
            node.addEventListener('click', handleClickBell);
        });
        burgerBtnNode === null || burgerBtnNode === void 0 ? void 0 : burgerBtnNode.addEventListener('click', handleClickBurgerMenu);
        window.addEventListener('mousedown', handleShowNotification, { once: true });
        return function () {
            notiIconNodes.forEach(function (node) {
                node.removeEventListener('click', handleClickBell);
            });
            burgerBtnNode === null || burgerBtnNode === void 0 ? void 0 : burgerBtnNode.removeEventListener('click', handleClickBurgerMenu);
            mobileNotiIconNode === null || mobileNotiIconNode === void 0 ? void 0 : mobileNotiIconNode.removeEventListener('click', handleClickBell);
            window.removeEventListener('mousedown', handleShowNotification);
            timer && clearTimeout(timer);
        };
    }, [isShowNotification]);
    return isShowNotification;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
'use client';

function imageLoader(_a) {
    var src = _a.src, width = _a.width, quality = _a.quality;
    // SVG is not supported by next/image
    var extension = src === null || src === void 0 ? void 0 : src.substring(src.length - 4);
    if (extension.indexOf('.svg') === 0) {
        return src;
    }
    return "".concat(process.env.NEXT_PUBLIC_IMAGE_LOADER, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}


//# sourceMappingURL=image.js.map


/***/ }),

/***/ 67430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": function() { return /* binding */ isTablet; },
/* harmony export */   "FB": function() { return /* binding */ screens; },
/* harmony export */   "Mn": function() { return /* binding */ isPhone; },
/* harmony export */   "T": function() { return /* binding */ isTouch; },
/* harmony export */   "nI": function() { return /* binding */ isDesktop; }
/* harmony export */ });
'use client';

/**
 * Responsive Helpers
 */
function isPhone() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}
function isTablet() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 768 && window.innerWidth < 992;
    }
    return false;
}
function isTouch() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 992;
    }
    return false;
}
function isDesktop() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 992;
    }
    return false;
}
var screens = {
    mobile: 768,
    tablet: 991
};


//# sourceMappingURL=responsiveHelper.js.map


/***/ }),

/***/ 79962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ styledCss; }
/* harmony export */ });
/* unused harmony exports collapseToBottom, extendFromBottom */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
'use client';




var scrollbar = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    /* total width */\n    ::-webkit-scrollbar {\n        background-color: transparent;\n        width: 6px;\n        height: 6px;\n    }\n\n    /* background of the scrollbar except button or resizer */\n    ::-webkit-scrollbar-track {\n        background-color: #f9f9fa;\n        border-radius: 10px;\n    }\n\n    /* scrollbar itself */\n    ::-webkit-scrollbar-thumb {\n        background-color: #e0e0e0;\n        border-radius: 10px;\n    }\n\n    /* set button(top and bottom of the scrollbar) */\n    ::-webkit-scrollbar-button {\n        display: none;\n    }\n"], ["\n    /* total width */\n    ::-webkit-scrollbar {\n        background-color: transparent;\n        width: 6px;\n        height: 6px;\n    }\n\n    /* background of the scrollbar except button or resizer */\n    ::-webkit-scrollbar-track {\n        background-color: #f9f9fa;\n        border-radius: 10px;\n    }\n\n    /* scrollbar itself */\n    ::-webkit-scrollbar-thumb {\n        background-color: #e0e0e0;\n        border-radius: 10px;\n    }\n\n    /* set button(top and bottom of the scrollbar) */\n    ::-webkit-scrollbar-button {\n        display: none;\n    }\n"])));
var extendFromTop = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: top;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: top;\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: top;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: top;\n  }\n"])));
var collapseToTop = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: top;\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: top;\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: top;\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: top;\n  }\n"])));
var extendFromBottom = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: bottom;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: bottom;\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: bottom;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: bottom;\n  }\n"])));
var collapseToBottom = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: bottom;\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: bottom;\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: bottom;\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n    transform-origin: bottom;\n  }\n"])));
var dropdownAnimation = function (show) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        &[data-floating-placement^='top'] {\n            animation: ", " 0.25s ease-in-out forwards;\n        }\n        &[data-floating-placement^='bottom'] {\n            animation: ", " 0.25s ease-in-out forwards;\n        }\n    "], ["\n        &[data-floating-placement^='top'] {\n            animation: ", " 0.25s ease-in-out forwards;\n        }\n        &[data-floating-placement^='bottom'] {\n            animation: ", " 0.25s ease-in-out forwards;\n        }\n    "])), show ? extendFromBottom : collapseToBottom, show ? extendFromTop : collapseToTop);
};
var dropdownTransition = function (show) {
    var transformValue = show ? 1 : 0;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n        transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;\n        opacity: ", ";\n        transform: scaleY(", ");\n        &[data-floating-placement^='top'] {\n            transform-origin: bottom;\n        }\n        &[data-floating-placement^='bottom'] {\n            transform-origin: top;\n        }\n    "], ["\n        transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;\n        opacity: ", ";\n        transform: scaleY(", ");\n        &[data-floating-placement^='top'] {\n            transform-origin: bottom;\n        }\n        &[data-floating-placement^='bottom'] {\n            transform-origin: top;\n        }\n    "])), transformValue, transformValue);
};
var styledCss = {
    scrollbar: scrollbar,
    dropdownAnimation: dropdownAnimation,
    dropdownTransition: dropdownTransition
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


//# sourceMappingURL=styledCss.js.map


/***/ }),

/***/ 56665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QE": function() { return /* binding */ formatInvalidDate; },
/* harmony export */   "UW": function() { return /* binding */ dateToString; },
/* harmony export */   "f1": function() { return /* binding */ convertDateToISO; },
/* harmony export */   "jF": function() { return /* binding */ convertDateTime; }
/* harmony export */ });
'use client';

var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
var nth = function (d) {
    if (d > 3 && d < 21)
        return 'th';
    switch (d % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
var convertDateTime = function (time, type) {
    if (type === void 0) { type = 0; }
    var date = new Date(time);
    var day = date.getDate();
    var dayName = days[date.getDay()];
    var month = date.getMonth() + 1;
    var monthName = months[month];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var addZero = function (date) { return String(date).padStart(2, '0'); };
    switch (type) {
        case 0: {
            // 30/10/2022 07:30
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            var formatTime = addZero(hours) + ':' + addZero(minutes);
            return "".concat(formatDate, " ").concat(formatTime);
        }
        case 1: {
            // Friday, 15 Oct 2022
            return "".concat(dayName, ", ").concat(day, " ").concat(monthName, " ").concat(year);
        }
        case 2: {
            // Oct 5th, 2022
            return "".concat(monthName, " ").concat(day).concat(nth(day), ", ").concat(year);
        }
        case 3: {
            // 06:30
            return "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
        }
        case 4: {
            // 15 Wed, 2022
            return "".concat(day, " ").concat(monthName.slice(0, 3), ", ").concat(year);
        }
        case 5: {
            // Wed 15, 2022
            return "".concat(monthName.slice(0, 3), " ").concat(day, ", ").concat(year);
        }
        case 6: {
            // 2022-10-18 11:04:20
            return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
        }
        case 7: {
            // 30/10/2022
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            return formatDate;
        }
        default:
            return '';
    }
};
var formatInvalidDate = function (dateTime, format) {
    switch (format) {
        case 'YYYY-MM-DD HH:MM:SS':
            return dateTime.slice(0, 10);
        default:
            return '';
    }
};
var convertDateToISO = function (dateString) {
    // Regular expression to match the exact format YYYY-MM-DD HH:mm:ss
    var regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (regex.test(dateString)) {
        // Replace the space with 'T' to convert to ISO 8601 format
        return dateString.replace(' ', 'T');
    }
    else {
        return dateString;
    }
};
var dateToString = function (dateTime, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    var date;
    if (!dateTime) {
        date = new Date();
    }
    else {
        if (typeof dateTime === 'string') {
            var a = dateTime.split(/[^0-9]/);
            date = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]), Number(a[5]));
        }
        else {
            date = new Date(dateTime * 1000);
        }
    }
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes;
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return (day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds());
    }
};


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 93412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ translations; }
/* harmony export */ });
'use client';

var translations = {
    'Job alert created successfully': 'Tạo thông báo việc làm thành công',
    'Job alert "{0}" created': 'Thông báo việc làm "{0}" đã được tạo',
    'Job alert updated successfully': 'Đã cập nhật thông báo việc làm',
    'Job alert "{0}" updated': 'Thông báo việc làm "{0}" đã được cập nhật',
    'Job alert deleted successfully': 'Đã xóa thông báo việc làm',
    'Job alert "{0}" deleted': 'Thông báo việc làm "{0}" đã được xóa',
    'You already created 10 job alerts!': 'Bạn đã tạo tối đa 10 Thông Báo Việc Làm!',
    'Job alert error': 'Lỗi',
    'You already created this job alert': 'Bạn đã tạo thông báo việc làm này trước đó!',
    'Receive Job Alerts': 'Nhận thông báo',
    'Job title': 'Chức danh việc làm',
    'This field is required': 'Thông tin bắt buộc',
    Required: 'Bắt buộc',
    Save: 'Lưu',
    Delete: 'Xoá',
    Cancel: 'Huỷ',
    Email: 'Email',
    App: 'Ứng dụng',
    Both: 'Cả hai',
    Remove: 'Xoá',
    'I want alerts': 'Nhận thông báo',
    Weekly: 'Hàng tuần',
    Daily: 'Hàng ngày',
    'Delete this Job Alert?': 'Xoá thông báo?',
    'You will not be able to receive email for job alert': 'Bạn sẽ ngừng nhận email thông báo việc làm này.',
    'Salary from': 'Mức lương tối thiểu',
    'Job level': 'Cấp bậc',
    Category: 'Ngành nghề',
    Location: 'Địa điểm',
    'No result': 'Không có kết quả',
    'Notification Settings': 'Thiết lập thông báo',
    'You can only choose maximum 3 locations': 'Bạn chỉ có thể chọn tối đa 3 địa điểm',
    'Notify via': 'Thông báo qua',
    Frequency: 'Tần suất',
    'Please select ...': 'Vui lòng chọn ...',
    'Discard this job alert?': 'Hủy thông báo việc làm?',
    'This job alert will not be saved': 'Thông báo việc làm sẽ không được lưu',
    Yes: 'Có',
    No: 'Không',
    'Enter email': 'Nhập email',
    'Enter job title': 'Nhập chức danh',
    "Can't delete this job alert": 'Không thể xóa thông báo việc làm này',
    "Can't update this job alert": 'Không thể cập nhật thông báo việc làm này',
    'Create Job Alert': 'Thông báo việc làm',
    'Update Your Profile': 'Cập nhật hồ sơ của bạn',
    'Attached CV': 'Hồ sơ đính kèm',
    Allow: 'Cho phép',
    'Select location': 'Chọn địa điểm',
    'Select job category': 'Chọn ngành nghề',
    Successful: 'Thành công',
    'It may take a few minutes to import the data...': 'Có thể mất vài phút để nhập dữ liệu ...',
    'Please fill in your correct Linkedln link. Example: https://www.linkedin.com/in/ryanroslansky/': 'Vui lòng điền đúng liên kết Linkedln của bạn. Ví dụ: https://www.linkedin.com/in/ryanroslansky/',
    'Something went wrong. Can not import data, please try again.': 'Có lỗi xảy ra không thể tự động điền dữ liệu. Vui lòng thử lại.',
    'Save time by importing your existing LinkedIn profile!': 'Tiết kiệm thời gian bằng cách nhập hồ sơ LinkedIn hiện có của bạn!',
    'By clicking the “Import Profile” button, we will replace the information on VietnamWorks’ profile with the one from your LinkedIn account, such as Skills, Education, Experiences,… and you can not undo it.': 'Bằng cách nhấp vào nút “Nhập hồ sơ”, chúng tôi sẽ thay thế thông tin trên hồ sơ của VietnamWorks bằng thông tin từ tài khoản LinkedIn của bạn, chẳng hạn như Kỹ năng, Học vấn, Kinh nghiệm,… và bạn không thể hoàn tác.',
    Processing: 'Đang xử lý',
    'Your LinkedIn profile has been updated to VietnamWorks’s profile successfully. Go to My Profile to review your updated profile.': 'Hồ sơ trên Linkedln của bạn đã được cập nhật thành công lên hồ sơ của VietnamWorks. Đi tới "Hồ sơ của tôi" để xem lại hồ sơ cập nhật của bạn.',
    'Click “Import Again” to update new information from Linkedln.': 'Nhấp vào “Nhập lại” để cập nhật thông tin mới từ Linkedln.',
    'Import again': 'Nhập lại',
    'Import Profile From LinkedIn': 'Nhập hồ sơ từ LinkedIn',
    'Import Profile': 'Nhập hồ sơ',
    'Enter your LinkedIn profile link': 'Nhập đường dẫn hồ sơ LinkedIn của bạn',
    'The LinkedIn URL you provided us is wrong or unavailable. Please check and Import Profile again.': 'Đường dẫn hồ sơ LinkedIn mà bạn cung cấp không hợp lệ. Vui lòng thử lại.',
    'Importing...': 'Đang cập nhật...',
    'Your Linked profile has been updated to VietnamWorks’s profile successfully.': 'Hồ sơ LinkedIn của bạn đã được cập nhật lên hồ sơ Vietnamworks thành công.',
    'Reload Profile': 'Tải lại trang',
    'to view the updated data.': 'để xem những thông tin đã được cập nhật.',
    Back: 'Trở về',
    'Go to': 'Đi tới',
    'My Profile': 'Hồ sơ của tôi',
    'to review your updated profile.': 'để xem lại hồ sơ cập nhật của bạn.',
    'my-profile': 'ho-so',
    'Email me similar jobs': 'Gửi tôi việc tương tự',
    'Receive job alerts for jobs like this search!': 'Gửi tôi việc tương tự',
    'Pay period': 'Thời gian trả lương',
    'Send me jobs': 'Nhận thông báo',
    'This is not a valid email address': 'Địa chỉ email không hợp lệ ',
    'Your email': 'Email của bạn',
    'Email to receive jobs': 'Email nhận thông báo',
    Close: 'Đóng',
    'Your comments make an important contribution to protecting the Job Seeker Community.': 'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a job successfully': 'Báo cáo việc làm thành công',
    Submit: 'Gửi',
    Other: 'Khác',
    Report: 'Báo cáo',
    'characters remaining': 'ký tự còn lại',
    'Report this job': 'Báo cáo việc làm này',
    'Please input detail description for Other reason': 'Bạn cần nhập mô tả chi tiết cho Lý do khác',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'The Email must be a valid Email address.': 'Email không hợp lệ.',
    'Accept {0} digits.': 'Chấp nhận {0} chữ số.',
    'Accept {0} characters.': 'Chấp nhận {0} ký tự.',
    '{0} characters limit.': 'Tối đa {0} ký tự.',
    '{0} digits limit.': 'Tối đa {0} chữ số.',
    'Exceeded maximum character length of': 'Đã vượt quá độ dài ký tự tối đa là',
    Play: 'Phát',
    Pause: 'Tạm dừng',
    Month: 'Tháng',
    'Select job function': 'Chọn ngành nghề',
    'Add more criteria': 'Thêm điều kiện khác',
    "Create a job alert to seize a new opportunity. Don't miss the opportunity to find your dream job": 'Tạo thông báo việc làm để có cơ hội mới. Đừng bỏ lỡ cơ hội công việc mơ ước của bạn',
    "Expected working location": "Nơi làm việc mong muốn",
    "Create alert": "Tạo thông báo",
    "Job alert": "Thông báo việc làm",
    "Save alert": "Lưu",
};


//# sourceMappingURL=translations.js.map


/***/ }),

/***/ 60332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G7": function() { return /* binding */ objToQueryStr; },
/* harmony export */   "S9": function() { return /* binding */ buildCompanyLink; },
/* harmony export */   "Te": function() { return /* binding */ buildLoginUrl; },
/* harmony export */   "Ty": function() { return /* binding */ buildJobUrl; },
/* harmony export */   "WV": function() { return /* binding */ buildSearchPath; },
/* harmony export */   "aH": function() { return /* binding */ buildSearchUrl; },
/* harmony export */   "kQ": function() { return /* binding */ buildCompanyUrl; }
/* harmony export */ });
/* unused harmony export generateCompanyLink */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55613);
'use client';





function joinPath(pathComponents) {
    return pathComponents.filter(function (str) { return str !== ''; }).join('-');
}
function composePath(slug, code, suffix) {
    return joinPath([slug, code, suffix]);
}
function _hasInputSearchFilter(searchParams) {
    return {
        keyword: searchParams.query && searchParams.query !== '',
        location: searchParams.locationId && searchParams.locationId > -1,
        category: searchParams.categoryId && searchParams.categoryId > -1,
        isUrgentJob: searchParams.isUrgentJob === true,
        typeWorkingId: searchParams.typeWorkingId && searchParams.typeWorkingId > -1,
        level: searchParams.jobLevelId && searchParams.jobLevelId > -1
    };
}
function determineUrgentJobPage(searchStatus, providedPath) {
    var searchPath = '';
    if (providedPath !== undefined && providedPath) {
        if (providedPath.match(/viec-can-tuyen-gap|urgent-jobs/) && searchStatus.isUrgentJob) {
            searchPath = providedPath;
        }
    }
    else {
        if (window &&
            window.location &&
            window.location.pathname &&
            window.location.pathname.match(/viec-can-tuyen-gap|urgent-jobs/) &&
            searchStatus.isUrgentJob) {
            searchPath = window.location.pathname;
        }
    }
    return searchPath;
}
function buildTypeWorkingSlug(typeWorkingId, typeWorkingSelectData, language) {
    var typeWorkingItem = typeWorkingSelectData.find(function (item) { return item.id === typeWorkingId; });
    var typeWorkingViSlug = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .lV)((0,_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .transformToLatin */ .nr)((typeWorkingItem === null || typeWorkingItem === void 0 ? void 0 : typeWorkingItem.name) || ''));
    var typeWorkingSlug = ((language === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN ? typeWorkingItem === null || typeWorkingItem === void 0 ? void 0 : typeWorkingItem.nameEn : typeWorkingViSlug) || '').toLowerCase();
    return typeWorkingSlug;
}
function _buildSearchSlugText(keyword, categorySlug, locationSlug, language, isUrgentJob, typeWorkingSlug, hasAnyFilter) {
    var slug = '';
    var isEn = language === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN;
    var AT = isEn ? 'at' : 'nganh';
    var IN = isEn ? 'in' : 'tai';
    var JOBS = isEn ? 'jobs' : 'viec-lam';
    var URGENT = isEn ? 'urgent' : 'tuyen-gap';
    if (keyword !== '') {
        var filterSlug = typeWorkingSlug;
        if (categorySlug !== '') {
            filterSlug += "".concat(filterSlug !== '' ? '-' : '').concat(AT, "-").concat(categorySlug);
        }
        if (locationSlug !== '') {
            filterSlug += "".concat(filterSlug !== '' ? '-' : '').concat(IN, "-").concat(locationSlug);
        }
        slug += filterSlug !== '' ? "".concat(keyword, "+").concat(filterSlug) : "".concat(keyword, "+");
    }
    else {
        var prefixSlug = joinPath(isEn ? [typeWorkingSlug, categorySlug, JOBS] : [JOBS, typeWorkingSlug, categorySlug]);
        slug = hasAnyFilter ? prefixSlug : '';
        if (categorySlug !== '' && locationSlug !== '') {
            slug = "".concat(prefixSlug, "-").concat(IN, "-").concat(locationSlug);
        }
        else {
            if (locationSlug !== '') {
                slug = "".concat(isEn ? '' : "".concat(prefixSlug, "-")).concat(locationSlug).concat(isEn ? "-".concat(prefixSlug) : '');
            }
        }
    }
    if (isUrgentJob) {
        slug = "".concat(slug, "-").concat(URGENT, "-uj");
    }
    return slug;
}
function _buildSearchCode(searchParams) {
    var _a = searchParams.categoryId, categoryId = _a === void 0 ? -1 : _a, _b = searchParams.locationId, locationId = _b === void 0 ? -1 : _b, _c = searchParams.jobLevelId, jobLevelId = _c === void 0 ? -1 : _c, _d = searchParams.typeWorkingId, typeWorkingId = _d === void 0 ? -1 : _d;
    var categoryCode = categoryId > 0 ? 'i' + categoryId : '';
    var locationCode = locationId > 0 ? 'v' + locationId : '';
    var jobLevelCode = jobLevelId > 0 ? 'l' + jobLevelId : '';
    var typeWorkingCode = typeWorkingId > 0 ? 't' + typeWorkingId : '';
    return categoryCode + locationCode + jobLevelCode + typeWorkingCode;
}
/**
 * Convert searchParams to URL
 * @param searchParams
 * @param selectData
 * @param language
 * @param providedPath
 * @return URL
 */
function buildSearchPath(searchParams, selectData, language, providedPath) {
    if (Object.keys(selectData).length === 0) {
        return '';
    }
    var searchPath = '';
    var keyword = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .encodeKeyword */ .NF)(searchParams.query || '');
    var langCode = language;
    var isEn = langCode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN;
    var suffixPath = isEn ? 'en' : 'vn';
    var suffixOnlyKeyword = isEn ? 'kw' : 'kv';
    // detect if search params has keyword, category, location has filtered data rather than default values
    var searchStatus = _hasInputSearchFilter(searchParams);
    searchStatus.isUrgentJob; searchStatus.keyword; var searchStatusOnlyFilter = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(searchStatus, ["isUrgentJob", "keyword"]);
    var hasFilter = Object.values(searchStatusOnlyFilter).some(function (hasSet) { return !!hasSet; });
    // Exceptional case: Only keyword provided
    if (searchStatus.keyword && !hasFilter) {
        if (searchStatus.isUrgentJob) {
            var URGENT = isEn ? 'urgent' : 'tuyen-gap';
            return "/".concat(keyword, "-").concat(suffixOnlyKeyword, "-").concat(URGENT, "-uj");
        }
        else {
            return "/".concat(keyword, "-").concat(suffixOnlyKeyword);
        }
    }
    searchPath = determineUrgentJobPage(searchStatus, providedPath);
    if (!searchStatus.keyword && !hasFilter && searchStatus.isUrgentJob) {
        return isEn ? '/urgent-jobs' : '/viec-can-tuyen-gap';
    }
    var categoryId = searchParams.categoryId || -1;
    var categorySlug = categoryId > 0 ? selectData.categoryById[categoryId].slug : '';
    var locationId = searchParams.locationId || -1;
    var locationSlug = locationId > 0 ? selectData.locationById[locationId].slug : '';
    var isUrgentJob = searchParams.isUrgentJob || false;
    var typeWorkingId = searchParams.typeWorkingId || -1;
    var typeWorkingSlug = buildTypeWorkingSlug(typeWorkingId, selectData.typeWorking, language);
    var searchSlug = _buildSearchSlugText(keyword, categorySlug, locationSlug, langCode, isUrgentJob, typeWorkingSlug, hasFilter);
    var searchCodeStr = _buildSearchCode(searchParams);
    if (searchSlug !== '' || searchCodeStr !== '') {
        searchPath = "/".concat(composePath(searchSlug, searchCodeStr, suffixPath));
    }
    searchPath = searchPath.replace('+-', '+');
    return searchPath;
}
function generateCompanyLink(companyId, companySlug, langCode) {
    var prefixPath = langCode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN ? 'companies' : 'nha-tuyen-dung';
    return "/".concat(prefixPath, "/").concat(companySlug, "-c").concat(companyId);
}
function objToQueryStr(params) {
    if (typeof params !== 'object') {
        return;
    }
    return Object.keys(params)
        .map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(params[key])); })
        .join('&');
}
function buildCompanyLink(companyId, companySlug, companyCCPSlug, langCode, isCCP) {
    if (isCCP === void 0) { isCCP = false; }
    return isCCP ? "/company/".concat(companyCCPSlug) : generateCompanyLink(companyId, companySlug, langCode);
}
var buildCompanyUrl = function (_a) {
    var companyId = _a.companyId, companySlug = _a.companySlug, companyCCPSlug = _a.companyCCPSlug, langCode = _a.langCode, _b = _a.isCCP, isCCP = _b === void 0 ? false : _b;
    var prefix = langCode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN ? 'companies' : 'nha-tuyen-dung';
    var companyUrl = "/".concat(prefix, "/").concat((0,_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .lV)(companySlug || ''), "-c").concat(companyId);
    return isCCP ? "/company/".concat(companyCCPSlug) : companyUrl;
};
var buildJobUrl = function (_a) {
    var alias = _a.alias, jobId = _a.jobId, utm = _a.utm, langCode = _a.langCode;
    return "".concat("/".concat(alias, "-").concat(jobId, "-").concat(langCode === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.EN */ .Df.EN ? 'jd' : 'jv')).concat(utm);
};
var buildSearchUrl = function (searchParams, language) {
    var params = {};
    if (searchParams.query) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.QUERY */ .AQ.QUERY] = searchParams.query.replace(/ /g, '-');
    }
    if (searchParams.locationId && searchParams.locationId.length > 0) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.LOCATION */ .AQ.LOCATION] = searchParams.locationId.join('.');
    }
    if (searchParams.categoryId && searchParams.categoryId.length > 0) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.CATEGORY */ .AQ.CATEGORY] = searchParams.categoryId.join('.');
    }
    if (searchParams.jobFunctionId && searchParams.jobFunctionId.length > 0) {
        var groupJobFunctionId_1 = [];
        var jobFunctionId_1 = [];
        searchParams.jobFunctionId.map(function (item) {
            groupJobFunctionId_1.push(item.parentId);
            item.childrenIds.map(function (child) { return child !== -1 && jobFunctionId_1.push(child); });
        });
        if (groupJobFunctionId_1.length > 0) {
            params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.GROUP_JOB_FUNCTION */ .AQ.GROUP_JOB_FUNCTION] = groupJobFunctionId_1.join('.');
        }
        if (jobFunctionId_1.length > 0) {
            params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.JOB_FUNCTION */ .AQ.JOB_FUNCTION] = jobFunctionId_1.join('.');
        }
    }
    if (searchParams.companyIndustries && searchParams.companyIndustries.length > 0) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.INDUSTRY */ .AQ.INDUSTRY] = searchParams.companyIndustries.join('.');
    }
    if (searchParams.typeWorkingId !== undefined && searchParams.typeWorkingId > -1) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.WORKING_TYPE */ .AQ.WORKING_TYPE] = searchParams.typeWorkingId;
    }
    if (searchParams.jobLevelId !== undefined && searchParams.jobLevelId > -1) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.JOB_LEVEL */ .AQ.JOB_LEVEL] = searchParams.jobLevelId;
    }
    if (searchParams.isUrgentJob) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.URGENT */ .AQ.URGENT] = String(searchParams.isUrgentJob);
    }
    if (searchParams.page !== undefined && searchParams.page > 0) {
        params[_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_PARAMS.PAGE */ .AQ.PAGE] = searchParams.page + 1;
    }
    if (Object.keys(params).length > 0) {
        var paramsString = '?' + new URLSearchParams(params).toString();
        var baseUrl = language === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_SEARCH.JOBS_VI */ .AI.JOBS_VI : _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_SEARCH.JOBS */ .AI.JOBS;
        return baseUrl + paramsString;
    }
    else {
        return language === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_SEARCH.RESULT_VI */ .AI.RESULT_VI : _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_SEARCH.RESULT */ .AI.RESULT;
    }
};
function buildLoginUrl(loginUrl, hash) {
    if (loginUrl === void 0) { loginUrl = ''; }
    var currentUrl = window.location.href;
    return "".concat(loginUrl, "?redirectURL=").concat(encodeURIComponent(currentUrl)).concat(hash);
}


//# sourceMappingURL=urlBuilder.js.map


/***/ }),

/***/ 17804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eW": function() { return /* binding */ callTrackingUTM; },
/* harmony export */   "zv": function() { return /* binding */ formatCanonicalUrl; }
/* harmony export */ });
/* unused harmony export getUrlParameter */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



var getUrlParameter = function (url, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var callTrackingUTM = function (event, apiLink) {
    var getFiltersFromNaviCMS = function (form) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(apiLink, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(form)
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var form = {
        utm_source: '',
        utm_campaign: '',
        utm_medium: '',
        utm_content: '',
        utm_term: ''
    };
    var element = event.currentTarget;
    form.utm_source = getUrlParameter(element.href, 'utm_source');
    form.utm_campaign = getUrlParameter(element.href, 'utm_campaign');
    form.utm_medium = getUrlParameter(element.href, 'utm_medium');
    form.utm_content = getUrlParameter(element.href, 'utm_content');
    form.utm_term = getUrlParameter(element.href, 'utm_term');
    if (!form.utm_source)
        form.utm_source = getUrlParameter(element.href, 'utm_source_navi');
    if (!form.utm_campaign)
        form.utm_campaign = getUrlParameter(element.href, 'utm_campaign_navi');
    if (!form.utm_medium)
        form.utm_medium = getUrlParameter(element.href, 'utm_medium_navi');
    if (!form.utm_content)
        form.utm_content = getUrlParameter(element.href, 'utm_content_navi');
    if (!form.utm_term)
        form.utm_term = getUrlParameter(element.href, 'utm_term_navi');
    getFiltersFromNaviCMS(form);
};
var formatCanonicalUrl = function (url) {
    var urlFormat = url.split('?')[0];
    // remove '/' if it's final word, www.vietnamworks.com/hcm-kw/ -> www.vietnamworks.com/hcm-kw
    return urlFormat.replace(/\/$/, '');
};


//# sourceMappingURL=utmTracking.js.map


/***/ }),

/***/ 5895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "cy": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
'use client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};


//# sourceMappingURL=_tslib.js.map


/***/ }),

/***/ 15758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickAway; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



function useClickAway(handler, options) {
    var _a = options || {}, nodeRefs = _a.nodeRefs, _b = _a.event, event = _b === void 0 ? 'mouseup' : _b;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var listener = function (e) {
            var target = (e !== null && e !== void 0 ? e : {}).target;
            if (Array.isArray(nodeRefs)) {
                var shouldIgnore = !document.body.contains(target) && target.tagName !== 'HTML';
                var shouldTrigger = nodeRefs.every(function (ref) {
                    if (ref.current) {
                        return !e.composedPath().includes(ref.current);
                    }
                    return false;
                });
                shouldTrigger && !shouldIgnore && handler();
            }
            else {
                if (ref.current && !ref.current.contains(target)) {
                    handler();
                }
            }
        };
        document.addEventListener(event, listener, { passive: true });
        return function () {
            document.removeEventListener(event, listener);
        };
    }, [event, handler, nodeRefs]);
    return ref;
}


//# sourceMappingURL=useClickAway.js.map


/***/ }),

/***/ 67094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickOutSide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var useClickOutSide = function (initState, options) {
    var callback = (options || {}).callback;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initState), isVisible = _a[0], setElementVisible = _a[1];
    var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handleKeyDropdown = function (e) {
        if (e.key === 'Escape') {
            setElementVisible(false);
        }
    };
    var handleClickOutSide = function (e) {
        if (elementRef.current && !elementRef.current.contains(e.target) && isVisible) {
            setElementVisible(false);
            callback && callback();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDropdown);
        document.addEventListener('click', handleClickOutSide);
        return function () {
            document.removeEventListener('keydown', handleKeyDropdown);
            document.removeEventListener('click', handleClickOutSide);
        };
    }, [isVisible]);
    return { elementRef: elementRef, isVisible: isVisible, setElementVisible: setElementVisible };
};


//# sourceMappingURL=useClickOutSide.js.map


/***/ }),

/***/ 90401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



function useDebounce(value, delay, ignoreEmptyString) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay) {
            var timer_1 = setTimeout(function () { return setDebouncedValue(value); }, delay);
            return function () {
                clearTimeout(timer_1);
            };
        }
        return function () { };
    }, [value, delay]);
    if (typeof ignoreEmptyString !== 'undefined' && ignoreEmptyString === true && value === '') {
        return value;
    }
    if (!delay) {
        return value;
    }
    return debouncedValue;
}


//# sourceMappingURL=useDebounce.js.map


/***/ }),

/***/ 91623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDropdownAnimation; }
/* harmony export */ });
/* harmony import */ var _useTransition_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98638);
'use client';



function useDropdownAnimation(open, placement) {
    var side = placement.split('-')[0];
    var _a = (0,_useTransition_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        open: open,
        args: {
            side: side
        }
    }, {
        initial: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        enter: function (_a) {
            var side = _a.side;
            return {
                opacity: 1,
                transform: 'scaleY(1)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        leave: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        }
    }), isMounted = _a.isMounted, styles = _a.styles;
    return { isMounted: isMounted, styles: styles };
}


//# sourceMappingURL=useDropdownAnimation.js.map


/***/ }),

/***/ 19191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useElementSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41524);
'use client';




var useElementSize = function () {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), ref = _a[0], setRef = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    }), size = _b[0], setSize = _b[1];
    var handleSetSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if (typeof window === 'undefined')
            return;
        handleSetSize();
        window.addEventListener('resize', handleSetSize);
        return function () {
            window.removeEventListener('resize', handleSetSize);
        };
    }, [handleSetSize]);
    return [setRef, size, ref];
};


//# sourceMappingURL=useElementSize.js.map


/***/ }),

/***/ 86760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFetch; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var useFetch = function (url, options, callback) {
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    var isEnable = options === null || options === void 0 ? void 0 : options.enable;
    var cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var initialState = {
        data: undefined,
        error: undefined,
        loading: true
    };
    var fetchReducer = function (state, action) {
        switch (action.type) {
            case 'loading':
                return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, state), { loading: action.payload });
            case 'fetched':
                callback && callback(action.payload);
                return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, state), { data: action.payload });
            case 'error':
                return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, state), { error: action.payload });
            default:
                return state;
        }
    };
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(fetchReducer, initialState), state = _a[0], dispatch = _a[1];
    var fetchData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (options) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // do nothing if the url not given
                    if (!url)
                        return [2 /*return*/];
                    cancelRequest.current = false;
                    // if has a cache for this url, return it
                    if (cache.current[url]) {
                        dispatch({ type: 'fetched', payload: cache.current[url] });
                        dispatch({ type: 'loading', payload: false });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, options)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = (_a.sent());
                    cache.current[url] = data;
                    if (cancelRequest.current)
                        return [2 /*return*/];
                    dispatch({ type: 'fetched', payload: data });
                    dispatch({ type: 'loading', payload: false });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (cancelRequest.current)
                        return [2 /*return*/];
                    dispatch({ type: 'loading', payload: false });
                    dispatch({ type: 'error', payload: error_1 });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [url]);
    var additionalDispatch = function (reqOptions) {
        var additionalOptions = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, options), reqOptions);
        fetchData(additionalOptions);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof isEnable !== 'undefined' && isEnable === false)
            return;
        fetchData(options);
        // Use the cleanup function for avoiding a possibly...
        // ...state update after the component was unmounted
        return function () {
            cancelRequest.current = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, isEnable]);
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, state), { dispatch: additionalDispatch });
};


//# sourceMappingURL=useFetch.js.map


/***/ }),

/***/ 80200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useFloating; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/use-isomorphic-layout-effect.js
'use client';



var useIsomorphicLayoutEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;


//# sourceMappingURL=use-isomorphic-layout-effect.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isAbsolutePositioning.js
'use client';

function isAbsolutePositioning(element) {
    var position = window.getComputedStyle(element).position;
    return position === 'absolute';
}


//# sourceMappingURL=isAbsolutePositioning.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isBodyElement.js
'use client';

function isBodyElement(element) {
    return element === document.body;
}


//# sourceMappingURL=isBodyElement.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isDocumentElement.js
'use client';

function isDocumentElement(element) {
    return element === document.documentElement || element instanceof Document;
}


//# sourceMappingURL=isDocumentElement.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isOverflowSet.js
'use client';

function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}


//# sourceMappingURL=isOverflowSet.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getScrollableParents.js
'use client';






var getScrollableParents = function (element, containers) {
    if (containers === void 0) { containers = new Set(); }
    if (isDocumentElement(element) || isBodyElement(element)) {
        containers.add(window);
    }
    else {
        var computedStyle = window.getComputedStyle(element);
        if (isOverflowSet(computedStyle.overflow) ||
            isOverflowSet(computedStyle.overflowX) ||
            isOverflowSet(computedStyle.overflowY)) {
            if (!isAbsolutePositioning(element)) {
                containers.add(element);
            }
        }
    }
    if (element.parentNode) {
        getScrollableParents(element.parentNode, containers);
    }
    return containers;
};


//# sourceMappingURL=getScrollableParents.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/deepEqual.js
'use client';

/*
 * Forked of https://github.com/epoberezkin/fast-deep-equal
 * */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) {
            return false;
        }
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!{}.hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
}


//# sourceMappingURL=deepEqual.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getElementClientRect.js
'use client';

function getElementClientRect(element) {
    if (element instanceof Window) {
        var width_1 = window.innerWidth;
        var height_1 = window.innerHeight;
        return {
            width: width_1,
            height: height_1,
            top: 0,
            left: 0,
            bottom: height_1,
            right: width_1,
            x: 0,
            y: height_1
        };
    }
    var _a = element.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}


//# sourceMappingURL=getElementClientRect.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/flip.js
'use client';




function getOpositePlacement(placement) {
    switch (placement) {
        case 'top-start':
            return 'bottom-start';
        case 'top':
            return 'bottom';
        case 'top-end':
            return 'bottom-end';
        case 'right-start':
            return 'left-start';
        case 'right':
            return 'left';
        case 'right-end':
            return 'left-end';
        case 'left-start':
            return 'right-start';
        case 'left':
            return 'right';
        case 'left-end':
            return 'right-end';
        case 'bottom-start':
            return 'top-start';
        case 'bottom':
            return 'top';
        case 'bottom-end':
            return 'top-end';
    }
}
function shouldFlip(_a) {
    var placement = _a.placement, offset = _a.offset, referenceRect = _a.referenceRect, popupRect = _a.popupRect, scrollableParent = _a.scrollableParent;
    var scrollableParentRect = getElementClientRect(scrollableParent);
    var popupHeight = popupRect.height;
    var referenceHeight = referenceRect.height;
    var popupWidth = popupRect.width;
    var referenceWidth = referenceRect.width;
    /*
     * Calculate the top, right bottom, left of popup if it touch the limit
     * of scrollable parent
     * */
    var top = referenceRect.y - (popupHeight + offset);
    var bottom = referenceRect.y + referenceHeight + popupHeight + offset;
    var left = referenceRect.x - popupWidth - offset;
    var right = referenceRect.x + referenceWidth + popupWidth + offset;
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            return top < scrollableParentRect.top;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            return bottom > scrollableParentRect.bottom;
        case 'left-start':
        case 'left':
        case 'left-end':
            return left < scrollableParentRect.left;
        case 'right-start':
        case 'right':
        case 'right-end':
            return right > scrollableParentRect.right;
    }
}
function flip(_a) {
    var reference = _a.reference, popup = _a.popup, scrollableParents = _a.scrollableParents, placement = _a.placement, popupConfigs = _a.popupConfigs;
    var _b = popupConfigs || {}, _c = _b.offset, offset = _c === void 0 ? 0 : _c, _d = _b.isFlip, isFlip = _d === void 0 ? true : _d, _e = _b.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _e === void 0 ? false : _e;
    /*
     * Return immediately if flip doesn't enable
     * */
    if (!isFlip || scrollableParents.size === 0) {
        return placement;
    }
    var returnPlacement = placement;
    var getScrollableParents = scrollableParents;
    if (useWindowAsFlippingContainer) {
        getScrollableParents = new Set([window]);
    }
    var referenceRect = reference.getBoundingClientRect();
    var popupRect = popup.getBoundingClientRect();
    getScrollableParents.forEach(function (scrollableParent) {
        if (shouldFlip({
            placement: placement,
            referenceRect: referenceRect,
            popupRect: popupRect,
            offset: offset,
            scrollableParent: scrollableParent
        })) {
            returnPlacement = getOpositePlacement(placement);
        }
    });
    return returnPlacement;
}


//# sourceMappingURL=flip.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getElementClientRectByPosition.js
'use client';

function getElementClientRectByPosition(element, position) {
    if (element instanceof Window) {
        var width_1 = window.innerWidth;
        var height_1 = window.innerHeight;
        return {
            width: width_1,
            height: height_1,
            top: 0,
            left: 0,
            bottom: height_1,
            right: width_1,
            x: 0,
            y: height_1
        };
    }
    var _a = element.getBoundingClientRect(), _x = _a.x, _y = _a.y, width = _a.width, height = _a.height;
    var isFixed = position === 'fixed';
    var offsetTop = element.offsetTop;
    var offsetLeft = element.offsetLeft;
    var x = isFixed ? _x : offsetLeft;
    var y = isFixed ? _y : offsetTop;
    var top = y;
    var left = x;
    var right = x + width;
    var bottom = y + height;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}


//# sourceMappingURL=getElementClientRectByPosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/getPosition.js
'use client';




function getPosition(options) {
    var placement = options.placement, position = options.position, reference = options.reference, popup = options.popup, popupConfigs = options.popupConfigs, shiftValues = options.shiftValues;
    var _a = (popupConfigs || {}).offset, offset = _a === void 0 ? 0 : _a;
    var referenceRect = getElementClientRectByPosition(reference, position);
    var popupRect = getElementClientRectByPosition(popup, position);
    var xPos = referenceRect.x;
    var yPos = referenceRect.y;
    var referenceHeight = referenceRect.height;
    var referenceWidth = referenceRect.width;
    var popupHeight = popupRect.height;
    var popupWidth = popupRect.width;
    var returnPosition = {
        x: 0,
        y: 0
    };
    /*
     * Calculate y position
     * */
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            returnPosition.y = yPos - (popupHeight + offset);
            break;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            returnPosition.y = yPos + referenceHeight + offset;
            break;
        case 'left-start':
        case 'right-start':
            returnPosition.y = yPos;
            break;
        case 'left':
        case 'right':
            returnPosition.y = yPos + referenceHeight / 2 - popupHeight / 2;
            break;
        case 'left-end':
        case 'right-end':
            returnPosition.y = yPos + referenceHeight - popupHeight;
            break;
    }
    /*
     * Calculate x position
     * */
    switch (placement) {
        case 'left-start':
        case 'left':
        case 'left-end':
            returnPosition.x = xPos - (popupWidth + offset);
            break;
        case 'right-start':
        case 'right':
        case 'right-end':
            returnPosition.x = xPos + referenceWidth + offset;
            break;
        case 'top-start':
        case 'bottom-start':
            returnPosition.x = xPos;
            break;
        case 'top':
        case 'bottom':
            returnPosition.x = xPos + referenceWidth / 2 - popupWidth / 2;
            break;
        case 'top-end':
        case 'bottom-end':
            returnPosition.x = xPos + referenceWidth - popupRect.width;
            break;
    }
    /*
     * Add shift values
     * */
    returnPosition.x -= shiftValues.x;
    returnPosition.y -= shiftValues.y;
    return returnPosition;
}


//# sourceMappingURL=getPosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/hide.js
'use client';




function hide(_a) {
    var scrollableParents = _a.scrollableParents, reference = _a.reference, popupConfigs = _a.popupConfigs;
    var _b = (popupConfigs || {}).detectHidden, detectHidden = _b === void 0 ? false : _b;
    /*
     * Return immediately if not enable detect hidden
     * */
    if (!detectHidden) {
        return false;
    }
    var isHidden = false;
    /*
     * Reference values
     * */
    var referenceRect = reference.getBoundingClientRect();
    var referenceLeft = referenceRect.left;
    var referenceRight = referenceRect.right;
    var referenceTop = referenceRect.top;
    var referenceBottom = referenceRect.bottom;
    var scrollableParentsLength = scrollableParents.size;
    var arrayScrollableParents = Array.from(scrollableParents);
    for (var i = 0; i < scrollableParentsLength; ++i) {
        var parentRect = getElementClientRect(arrayScrollableParents[i]);
        var parentLeft = parentRect.left;
        var parentRight = parentRect.right;
        var parentTop = parentRect.top;
        var parentBottom = parentRect.bottom;
        isHidden =
            referenceRight < parentLeft ||
                referenceLeft > parentRight ||
                referenceBottom < parentTop ||
                referenceTop > parentBottom;
        if (isHidden) {
            break;
        }
    }
    return isHidden;
}


//# sourceMappingURL=hide.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/within.js
'use client';

function within(_a) {
    var min = _a.min, value = _a.value, max = _a.max;
    return Math.max(min, Math.min(value, max));
}


//# sourceMappingURL=within.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/shift.js
'use client';





function shift(_a) {
    var placement = _a.placement, position = _a.position, reference = _a.reference, popup = _a.popup, popupConfigs = _a.popupConfigs, scrollableParents = _a.scrollableParents;
    var returnShiftValues = {
        x: 0,
        y: 0
    };
    var _b = (popupConfigs || {}).isShift, isShift = _b === void 0 ? false : _b;
    /*
     * Return immediately if isShift not enable
     * or postion is fixed
     * */
    if (!isShift || position === 'fixed' || scrollableParents.size === 0) {
        return returnShiftValues;
    }
    /*
     * Calculate shifting value
     * */
    var scrollableParent = getElementClientRect(Array.from(scrollableParents)[0]);
    var referenceRect = getElementClientRect(reference);
    var popupRect = getElementClientRect(popup);
    /*
     * scrollable container value
     * */
    var scrollableParentLeft = scrollableParent.left;
    var scrollableParentRight = scrollableParent.right;
    var scrollableParentTop = scrollableParent.top;
    var scrollableParentBottom = scrollableParent.bottom;
    /*
     * Popup value
     * */
    var popupWidth = popupRect.width;
    var popupHeight = popupRect.height;
    /*
     * Reference value
     * */
    var referenceLeft = referenceRect.left;
    var referenceTop = referenceRect.top;
    var referenceWidth = referenceRect.width;
    var referenceHeight = referenceRect.height;
    switch (placement) {
        case 'top-start':
        case 'bottom-start':
            {
                var popupLeft = referenceLeft;
                var popupRight = referenceLeft + popupWidth;
                var limitLeft = -referenceWidth;
                var limitRight = popupWidth;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'top':
        case 'bottom':
            {
                var popupLeft = referenceLeft + referenceWidth / 2 - popupWidth / 2;
                var popupRight = referenceLeft + referenceWidth / 2 + popupWidth / 2;
                var limitLeft = -(referenceWidth / 2 + popupWidth / 2);
                var limitRight = referenceWidth / 2 + popupWidth / 2;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'top-end':
        case 'bottom-end':
            {
                var popupLeft = referenceLeft + referenceWidth - popupWidth;
                var popupRight = referenceLeft + referenceWidth;
                var limitLeft = -popupWidth;
                var limitRight = referenceWidth;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'left-start':
        case 'right-start':
            {
                var popupTop = referenceTop;
                var popupBottom = referenceTop + popupHeight;
                var limitTop = -referenceHeight;
                var limitBottom = popupHeight;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
        case 'left':
        case 'right':
            {
                var popupTop = referenceTop + referenceHeight / 2 - popupHeight / 2;
                var popupBottom = referenceTop + referenceHeight / 2 + popupHeight / 2;
                var limitTop = -(referenceHeight / 2 + popupHeight / 2);
                var limitBottom = referenceHeight / 2 + popupHeight / 2;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
        case 'left-end':
        case 'right-end':
            {
                var popupTop = referenceTop + referenceHeight - popupHeight;
                var popupBottom = referenceTop + referenceHeight;
                var limitTop = -popupHeight;
                var limitBottom = referenceHeight;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
    }
    return returnShiftValues;
}


//# sourceMappingURL=shift.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/computePosition.js
'use client';






function computePosition(reference, popup, configs) {
    var position = configs.position, placement = configs.placement, scrollableParents = configs.scrollableParents, popupConfigs = configs.popupConfigs;
    /*
     * Make popup flip
     * */
    var flippedPlacement = flip({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var shiftValues = shift({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var isReferenceHidden = hide({
        reference: reference,
        scrollableParents: scrollableParents,
        popupConfigs: popupConfigs
    });
    var args = {
        placement: flippedPlacement,
        position: position,
        reference: reference,
        popup: popup,
        popupConfigs: popupConfigs,
        shiftValues: shiftValues
    };
    var _a = getPosition(args), x = _a.x, y = _a.y;
    return {
        x: x,
        y: y,
        position: position,
        placement: flippedPlacement,
        isReferenceHidden: isReferenceHidden
    };
}


//# sourceMappingURL=computePosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/core/autoUpdate.js
'use client';

function autoUpdate(scrollParents, fn) {
    scrollParents.forEach(function (container) {
        container.addEventListener('scroll', fn, { passive: true });
        container.addEventListener('resize', fn, { passive: true });
    });
    fn();
    return function () {
        scrollParents.forEach(function (container) {
            container.removeEventListener('scroll', fn);
            container.removeEventListener('resize', fn);
        });
    };
}


//# sourceMappingURL=autoUpdate.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/FloatingPortal.js
'use client';



function FloatingPortal(_a) {
    var children = _a.children, nodeRef = _a.nodeRef, enable = _a.enable;
    if (!enable) {
        return children;
    }
    if (typeof window === 'undefined' && !nodeRef) {
        return null;
    }
    var node = (nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current) || document.body;
    return (0,react_dom.createPortal)(children, node);
}


//# sourceMappingURL=FloatingPortal.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js
'use client';









var useFloating = function (options) {
    var _a = options.position, position = _a === void 0 ? 'absolute' : _a, placement = options.placement, config = options.config;
    var _b = (config || {}).autoUpdate, autoUpdate$1 = _b === void 0 ? true : _b;
    var _c = (0,react.useState)(null), _reference = _c[0], _setReference = _c[1];
    var _d = (0,react.useState)(null), _popup = _d[0], _setPopup = _d[1];
    var referenceRef = (0,react.useRef)(null);
    var popupRef = (0,react.useRef)(null);
    var scrollableParents = (0,react.useRef)(new Set());
    var _e = (0,react.useState)({
        x: 0,
        y: 0,
        position: position,
        placement: placement,
        isReferenceHidden: false
    }), context = _e[0], setContext = _e[1];
    var contextRef = (0,react.useRef)();
    /*
     * Custom function to avoid node being set multiple time
     * */
    var setReference = (0,react.useCallback)(function (node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [_setReference]);
    var setPopup = (0,react.useCallback)(function (node) {
        if (node !== popupRef.current) {
            popupRef.current = node;
            _setPopup(node);
        }
    }, [_setPopup]);
    /*
     * Update function will be called to calculated popup position
     * */
    var update = (0,react.useCallback)(function () {
        if (!referenceRef.current || !popupRef.current) {
            return;
        }
        var computePositionConfigs = {
            placement: placement,
            position: position,
            scrollableParents: scrollableParents.current,
            popupConfigs: config
        };
        var context = computePosition(referenceRef.current, popupRef.current, computePositionConfigs);
        if (!deepEqual(context, contextRef.current)) {
            contextRef.current = context;
            setContext(context);
        }
    }, [placement, position, config]);
    useIsomorphicLayoutEffect(function () {
        if (_reference) {
            referenceRef.current = _reference;
        }
        if (_popup) {
            popupRef.current = _popup;
        }
        if (_reference && _popup) {
            var target = position === 'fixed' ? _reference : _popup;
            var scrollableParentsByTarget = getScrollableParents(target);
            if (scrollableParents.current.size === 0 && scrollableParentsByTarget.size > 0) {
                /*
                 * Get and store scrollableParents
                 * */
                scrollableParents.current = scrollableParentsByTarget;
            }
            /*
             * Update function will calculate the position of popup element
             * */
            if (autoUpdate$1) {
                var clear_1 = autoUpdate(scrollableParents.current, update);
                /*
                 * Observer the changes of popup element when auto update is enable
                 * */
                var observer_1 = new MutationObserver(update);
                observer_1.observe(_popup, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                return function () {
                    clear_1();
                    observer_1.disconnect();
                };
            }
            update();
        }
        return function () { };
    }, [_reference, _popup, update, position, autoUpdate$1]);
    var refs = {
        setReference: setReference,
        setPopup: setPopup,
        reference: referenceRef,
        popup: popupRef
    };
    return {
        refs: refs,
        context: context,
        FloatingPortal: FloatingPortal
    };
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 41524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


//# sourceMappingURL=useIsomorphicLayoutEffect.js.map


/***/ }),

/***/ 18094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardAccessibility; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}
function getScrollableParent(element) {
    var computedStyle = window.getComputedStyle(element);
    if (isOverflowSet(computedStyle.overflow) ||
        isOverflowSet(computedStyle.overflowX) ||
        isOverflowSet(computedStyle.overflowY)) {
        return element;
    }
    if (element.parentNode) {
        return getScrollableParent(element.parentNode);
    }
    return element;
}
function useKeyboardAccessibility(enable, _a) {
    var optionsLength = _a.optionsLength, onSelelected = _a.onSelelected, target = _a.target, _b = _a.resetIndex, resetIndex = _b === void 0 ? true : _b, forceResetIndexDeps = _a.forceResetIndexDeps, onClickEscape = _a.onClickEscape, onClickBackSpace = _a.onClickBackSpace;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1), activeIndex = _c[0], setActiveIndex = _c[1];
    var listChildNodes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var scrollableElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var canMouseSelectActiveIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var targetNode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var selectedIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    /**
     * Logic and handler
     * */
    var handleSetIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
        setActiveIndex(index);
        selectedIndex.current = index;
    }, []);
    var handleSelected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        onSelelected(selectedIndex.current);
        if (resetIndex) {
            handleSetIndex(-1);
            if (scrollableElement.current) {
                scrollableElement.current.scrollTop = 0;
            }
        }
    }, [onSelelected, resetIndex, selectedIndex.current, scrollableElement.current, handleSetIndex]);
    var handleNavigation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (action) {
        setActiveIndex(function (prevIndex) {
            var currentIndex = prevIndex;
            if (targetNode.current && scrollableElement.current) {
                /**
                 * Focus to current item
                 * */
                if (listChildNodes.current) {
                    /**
                     * Set active index
                     * */
                    switch (action) {
                        case '^': {
                            currentIndex--;
                            if (currentIndex < 0) {
                                currentIndex = optionsLength - 1;
                            }
                            break;
                        }
                        case 'v': {
                            currentIndex++;
                            if (currentIndex > optionsLength - 1) {
                                currentIndex = 0;
                            }
                            break;
                        }
                    }
                    /**
                     * Focus to active item
                     * */
                    var child = listChildNodes.current[currentIndex];
                    var childTop = child.offsetTop;
                    var childHeight = child.offsetHeight;
                    var scrollableElementHeight = scrollableElement.current.offsetHeight;
                    var scrollableElementScrollHeight = scrollableElement.current.scrollHeight;
                    var _a = child.getBoundingClientRect(), childBoundTop = _a.top, childBoundBottom = _a.bottom;
                    var _b = scrollableElement.current.getBoundingClientRect(), scrollableElementBoundTop = _b.top, scrollableElementBoundBottom = _b.bottom;
                    var canFocusToActiveElement = false;
                    var childPosition = 0;
                    switch (action) {
                        case '^': {
                            if (childBoundTop < scrollableElementBoundTop) {
                                canFocusToActiveElement = true;
                                childPosition = childTop;
                            }
                            if (childTop + childHeight === scrollableElementScrollHeight) {
                                canFocusToActiveElement = true;
                                childPosition = scrollableElementScrollHeight;
                            }
                            break;
                        }
                        case 'v': {
                            if (childBoundBottom > scrollableElementBoundBottom) {
                                canFocusToActiveElement = true;
                                childPosition = childTop - scrollableElementHeight + childHeight;
                            }
                            if (childTop === 0) {
                                canFocusToActiveElement = true;
                                childPosition = 0;
                            }
                            break;
                        }
                    }
                    if (canFocusToActiveElement) {
                        scrollableElement.current.scrollTo({ top: childPosition, behavior: 'smooth' });
                    }
                }
            }
            selectedIndex.current = currentIndex;
            return currentIndex;
        });
    }, [targetNode.current, optionsLength, listChildNodes]);
    var onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
        // Disable mouse select active index
        canMouseSelectActiveIndex.current = false;
        // Handle keyboard navigation
        switch (event.key) {
            case 'ArrowDown':
                // Do something for "down arrow" key press.
                event.preventDefault();
                handleNavigation('v');
                break;
            case 'ArrowUp':
                event.preventDefault();
                handleNavigation('^');
                break;
            case 'ArrowLeft':
                // Will handle navigation later
                // handleNavigation()
                break;
            case 'ArrowRight':
                // Do something for "right arrow" key press.
                // Will handle navigation later
                // handleNavigation()
                break;
            case 'Enter':
                event.preventDefault();
                if (selectedIndex.current !== -1) {
                    handleSelected();
                }
                break;
            case 'Escape': {
                onClickEscape && onClickEscape();
                break;
            }
            case 'Backspace': {
                onClickBackSpace && onClickBackSpace();
                break;
            }
        }
    }, [handleNavigation, handleSelected, onClickBackSpace, onClickEscape]);
    /**
     * Effects
     * */
    // Set target node and scrollable element
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof target === 'string') {
            targetNode.current = document.querySelector(target);
        }
        else {
            targetNode.current = target.current;
        }
        // Only set scrollableElement when have target node
        if (targetNode.current) {
            scrollableElement.current = getScrollableParent(targetNode.current);
        }
    });
    var handleMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
        if (canMouseSelectActiveIndex.current) {
            handleSetIndex(index);
        }
    }, [handleSetIndex]);
    var handleMouseMove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        canMouseSelectActiveIndex.current = true;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!enable) {
            return;
        }
        if (targetNode.current) {
            targetNode.current.addEventListener('mousemove', handleMouseMove, { passive: true });
            var listChildrenItems = targetNode.current.childNodes;
            listChildrenItems.forEach(function (node, index) {
                node.addEventListener('mouseenter', function () { return handleMouseEnter(index); }, {
                    passive: true
                });
            });
            /**
             * Set list child nodes
             * */
            listChildNodes.current = listChildrenItems;
        }
    }, [handleMouseEnter, targetNode.current, handleMouseMove, enable]);
    // Reset values based on condition
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        handleSetIndex(-1);
        if (scrollableElement.current) {
            scrollableElement.current.scrollTop = 0;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, forceResetIndexDeps);
    // Handle key down
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof window === undefined) {
            return;
        }
        if (enable) {
            window.document.addEventListener('keydown', onKeyDown);
        }
        else {
            window.document.removeEventListener('keydown', onKeyDown);
        }
        return function () {
            window.document.removeEventListener('keydown', onKeyDown);
        };
    }, [enable, onKeyDown]);
    return {
        activeIndex: activeIndex
    };
}


//# sourceMappingURL=useKeyboardAccessibility.js.map


/***/ }),

/***/ 42533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLatestRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41524);
'use client';




function useLatestRef(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        ref.current = value;
    });
    return ref;
}


//# sourceMappingURL=useLatestRef.js.map


/***/ }),

/***/ 82100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41524);
'use client';




/**
 * Older versions of Safari (shipped withCatalina and before) do not support addEventListener on matchMedia
 * https://stackoverflow.com/questions/56466261/matchmedia-addlistener-marked-as-deprecated-addeventlistener-equivalent
 * */
function attachMediaListener(query, callback) {
    try {
        query.addEventListener('change', callback);
        return function () { return query.removeEventListener('change', callback); };
    }
    catch (e) {
        query.addListener(callback);
        return function () { return query.removeListener(callback); };
    }
}
function getInitialValue(query, initialValue) {
    if (typeof initialValue === 'boolean') {
        return initialValue;
    }
    if (typeof window !== 'undefined' && 'matchMedia' in window) {
        return window.matchMedia(query).matches;
    }
    return false;
}
function useMediaQuery(query, initialValue, _a) {
    var _b = _a === void 0 ? {
        getInitialValueInEffect: true
    } : _a, getInitialValueInEffect = _b.getInitialValueInEffect;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialValueInEffect ? initialValue : getInitialValue(query, initialValue)), matches = _c[0], setMatches = _c[1];
    var queryRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if ('matchMedia' in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return attachMediaListener(queryRef.current, function (event) { return setMatches(event.matches); });
        }
        return undefined;
    }, [query]);
    return matches;
}


//# sourceMappingURL=useMediaQuery.js.map


/***/ }),

/***/ 35394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScrollLock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41524);
'use client';




var IS_SERVER = typeof window === 'undefined';
function useScrollLock(options) {
    if (options === void 0) { options = {}; }
    var _a = options.autoLock, autoLock = _a === void 0 ? true : _a, lockTarget = options.lockTarget, _b = options.widthReflow, widthReflow = _b === void 0 ? true : _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLocked = _c[0], setIsLocked = _c[1];
    var target = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var originalStyle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var lock = function () {
        if (target.current) {
            var _a = target.current.style, overflow = _a.overflow, paddingRight = _a.paddingRight;
            // Save the original styles
            originalStyle.current = { overflow: overflow, paddingRight: paddingRight };
            // Prevent width reflow
            if (widthReflow) {
                // Use window inner width if body is the target as global scrollbar isn't part of the document
                var offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                // Get current computed padding right in pixels
                var currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                var scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = "".concat(scrollbarWidth + currentPaddingRight, "px");
            }
            // Lock the scroll
            target.current.style.overflow = 'hidden';
            setIsLocked(true);
        }
    };
    var unlock = function (mode) {
        if (mode === void 0) { mode = 'hard'; }
        if (target.current && originalStyle.current) {
            var initStyles = { overflow: '', paddingRight: '' };
            if (mode === 'soft') {
                initStyles = originalStyle.current;
            }
            target.current.style.overflow = initStyles.overflow;
            // Only reset padding right if we changed it
            if (widthReflow) {
                target.current.style.paddingRight = initStyles.paddingRight;
            }
        }
        setIsLocked(false);
    };
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if (IS_SERVER)
            return;
        if (lockTarget) {
            target.current = typeof lockTarget === 'string' ? document.querySelector(lockTarget) : lockTarget;
        }
        if (!target.current) {
            target.current = document.body;
        }
        if (autoLock) {
            lock();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoLock, lockTarget, widthReflow]);
    return { isLocked: isLocked, lock: lock, unlock: unlock };
}


//# sourceMappingURL=useScrollLock.js.map


/***/ }),

/***/ 98638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTransition; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41524);
/* harmony import */ var _useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42533);
'use client';






var DEFAULT_DURATION = 250;
function camelCaseToKebabCase(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function ($, ofs) { return (ofs ? '-' : '') + $.toLowerCase(); });
}
function execWithArgsOrReturn(valueOrFunc, args) {
    return typeof valueOrFunc === 'function' ? valueOrFunc(args) : valueOrFunc;
}
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
function useDelayUnmount(open, duration) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(open), isMounted = _a[0], setMounted = _a[1];
    if (open && !isMounted) {
        setMounted(true);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!open) {
            var timeout_1 = setTimeout(function () { return setMounted(false); }, duration);
            return function () {
                clearTimeout(timeout_1);
            };
        }
        return function () { };
    }, [open, duration]);
    return isMounted;
}
function useTransitionStatus(open, duration) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('initial'), status = _a[0], setStatus = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), initiated = _b[0], setInitiated = _b[1];
    var isNumberDuration = typeof duration === 'number';
    var enterDuration = isNumberDuration ? duration : duration.enter || 0;
    var leaveDuration = isNumberDuration ? duration : duration.leave || 0;
    var isMounted = useDelayUnmount(open, leaveDuration);
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if (initiated && !isMounted) {
            setStatus('unmount');
        }
    }, [isMounted, initiated]);
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if (!isMounted)
            return;
        if (open) {
            setStatus('initial');
            var timeout_2;
            var frame_1 = requestAnimationFrame(function () {
                setStatus('enter');
                timeout_2 = setTimeout(function () { return setStatus('entered'); }, enterDuration);
            });
            return function () {
                cancelAnimationFrame(frame_1);
                clearTimeout(timeout_2);
            };
        }
        setInitiated(true);
        setStatus('before-leave');
        var leaveFrame = requestAnimationFrame(function () { return setStatus('leave'); });
        return function () {
            cancelAnimationFrame(leaveFrame);
        };
    }, [open, isMounted, enterDuration]);
    return {
        isMounted: isMounted,
        status: status
    };
}
function useTransition(context, transitions) {
    var open = context.open, args = context.args;
    var _a = transitions.duration, duration = _a === void 0 ? DEFAULT_DURATION : _a, _b = transitions.initial, initial = _b === void 0 ? { opacity: 0 } : _b, _c = transitions.enter, enter = _c === void 0 ? {} : _c, _d = transitions.entered, entered = _d === void 0 ? {} : _d, _e = transitions.beforeLeave, beforeLeave = _e === void 0 ? {} : _e, _f = transitions.leave, leave = _f === void 0 ? {} : _f;
    var funcArgs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return args; }, [JSON.stringify(args)]);
    var _g = useTransitionStatus(open, duration), isMounted = _g.isMounted, status = _g.status;
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, execWithArgsOrReturn(initial, funcArgs))), styles = _h[0], setStyles = _h[1];
    var initialRef = (0,_useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(initial);
    var enterRef = (0,_useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(enter);
    var enteredRef = (0,_useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(entered);
    var beforeLeaveRef = (0,_useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(beforeLeave);
    var leaveRef = (0,_useLatestRef_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(leave);
    var isNumberDuration = typeof duration === 'number';
    var enterDuration = isNumberDuration ? duration : duration.enter || 0;
    var leaveDuration = isNumberDuration ? duration : duration.leave || 0;
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        var initialStyles = execWithArgsOrReturn(initialRef.current, funcArgs);
        var enterStyles = execWithArgsOrReturn(enterRef.current, funcArgs);
        var enteredStyles = execWithArgsOrReturn(enteredRef.current, funcArgs);
        var beforeLeaveStyles = execWithArgsOrReturn(beforeLeaveRef.current, funcArgs);
        var leaveStyles = execWithArgsOrReturn(leaveRef.current, funcArgs);
        if (status === 'initial') {
            setStyles(function (styles) { return ((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ transitionProperty: styles.transitionProperty }, initialStyles)); });
        }
        if (status === 'enter') {
            setStyles((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ transitionDuration: "".concat(enterDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, enterStyles));
        }
        if (status === 'entered') {
            var styles_1 = isEmptyObject(enteredStyles) ? enterStyles : enteredStyles;
            setStyles((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ transitionDuration: "".concat(enterDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_1));
        }
        if (status === 'before-leave') {
            var styles_2 = isEmptyObject(beforeLeaveRef) ? initialStyles : beforeLeaveStyles;
            setStyles((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ transitionDuration: "".concat(leaveDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_2));
        }
        if (status === 'leave') {
            var styles_3 = isEmptyObject(leaveStyles) ? initialStyles : leaveStyles;
            setStyles((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ transitionDuration: "".concat(leaveDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_3));
        }
    }, [initialRef, enterRef, enteredRef, beforeLeaveRef, leaveRef, status, enterDuration, leaveDuration, funcArgs]);
    return { isMounted: isMounted, styles: styles };
}


//# sourceMappingURL=useTransition.js.map


/***/ }),

/***/ 67824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InfoOverview; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CompanySize.js
'use client';




var CompanySizeIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12 4C9.4544 4 8.4 5.6328 8.4 7.6C8.4 8.2624 8.71719 8.92812 8.71719 8.92812C8.58999 9.00172 8.37845 9.23564 8.43125 9.64844C8.52965 10.418 8.86376 10.6121 9.07656 10.6281C9.15736 11.3465 9.9304 12.2664 10.2 12.4V13.4734C9.6 15.2734 4.8 15 4.8 19.2H19.2C19.2 15 14.4 15.2734 13.8 13.4734V12.4C14.0704 12.2664 14.8426 11.3465 14.9234 10.6281C15.1362 10.6121 15.4704 10.418 15.5688 9.64844C15.6215 9.23484 15.41 9.00172 15.2828 8.92812C15.2828 8.92812 15.6 8.3272 15.6 7.6C15.6 6.1432 15.028 4.9 13.8 4.9C13.8 4.9 13.3736 4 12 4ZM18 5.59844C17.5904 5.59844 17.2419 5.67253 16.9219 5.77813C17.0971 6.32133 17.2 6.9272 17.2 7.6C17.2 8.0256 17.1332 8.41579 17.0484 8.74219C17.1644 9.08539 17.2043 9.4628 17.1547 9.85C17.0419 10.7308 16.6999 11.3294 16.2703 11.7062C16.1455 12.0086 15.9746 12.2951 15.7906 12.5688C16.0178 13.0351 16.3504 13.4504 16.5 13.5344V13.5437C18.1296 14.3077 20.8 15.592 20.8 19.2H24C24 15.2336 20 15.8031 19.5 14.1031V13.5328C19.7248 13.4064 20.3687 12.5378 20.4359 11.8594C20.6127 11.8442 20.8918 11.6616 20.9734 10.9344C21.0174 10.544 20.8415 10.3243 20.7359 10.2547C20.7359 10.2547 21 9.6856 21 9C21 7.624 20.5232 6.45 19.5 6.45C19.5 6.45 19.1448 5.59844 18 5.59844ZM6 5.6C4.8552 5.6 4.5 6.45 4.5 6.45C3.4768 6.45 3 7.62556 3 9.00156C3 9.68796 3.26406 10.2547 3.26406 10.2547C3.15766 10.3235 2.98256 10.544 3.02656 10.9344C3.10816 11.6616 3.38726 11.8457 3.56406 11.8609C3.63126 12.5393 4.2752 13.408 4.5 13.5344V14.1031C4 15.8023 0 15.2336 0 19.2H3.2C3.2 15.592 5.8704 14.3085 7.5 13.5437V13.5328C7.6496 13.4488 7.98218 13.036 8.20938 12.5688C8.02538 12.2952 7.85449 12.0071 7.72969 11.7047C7.30009 11.3287 6.95731 10.73 6.84531 9.85C6.79491 9.458 6.83629 9.07452 6.95469 8.72813C6.86829 8.39932 6.8 8.0088 6.8 7.6C6.8 6.9384 6.89366 6.3302 7.06406 5.775C6.74806 5.6718 6.404 5.6 6 5.6Z', fill: color })));
};
var CompanySizeIcon$1 = react.memo(CompanySizeIcon);


//# sourceMappingURL=CompanySize.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Location.js
'use client';




var LocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0003 0.47998C7.76656 0.47998 4.32031 3.92623 4.32031 8.15998C4.32031 14.9344 11.3422 23.0137 11.6403 23.355C11.7322 23.46 11.8616 23.52 12.0003 23.52C12.1484 23.5106 12.2684 23.46 12.3603 23.355C12.6584 23.0081 19.6803 14.79 19.6803 8.15998C19.6803 3.92623 16.2341 0.47998 12.0003 0.47998ZM12.0003 5.75998C13.5903 5.75998 14.8803 7.04998 14.8803 8.63998C14.8803 10.23 13.5903 11.52 12.0003 11.52C10.4103 11.52 9.12031 10.23 9.12031 8.63998C9.12031 7.04998 10.4103 5.75998 12.0003 5.75998Z', fill: color })));
};
var LocationIcon$1 = react.memo(LocationIcon);


//# sourceMappingURL=Location.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Education.js
'use client';




var EducationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_720_5761)' },
            react.createElement("path", { d: 'M12 2.3999C11.868 2.4 11.7381 2.43274 11.6219 2.49521L0.429688 8.09053V8.09209C0.300312 8.15965 0.191884 8.26132 0.116145 8.38608C0.0404055 8.51084 0.00024084 8.65395 0 8.7999C0.00024084 8.94586 0.0404055 9.08896 0.116145 9.21373C0.191884 9.33849 0.300312 9.44015 0.429688 9.50771V9.50928L11.6172 15.1015C11.7345 15.1658 11.8662 15.1996 12 15.1999C12.132 15.1998 12.2619 15.1671 12.3781 15.1046L23.5625 9.5124C23.5651 9.51137 23.5677 9.51033 23.5703 9.50928V9.50771C23.6997 9.44015 23.8081 9.33849 23.8839 9.21373C23.9596 9.08896 23.9998 8.94586 24 8.7999C23.9998 8.65395 23.9596 8.51084 23.8839 8.38608C23.8081 8.26132 23.6997 8.15965 23.5703 8.09209V8.09053L12.3828 2.49834C12.2655 2.43402 12.1338 2.40018 12 2.3999ZM23.2 11.4827L21.6 12.2827V19.4218C21.1235 19.6988 20.8 20.2087 20.8 20.7999C20.8 21.6839 22.4 23.9999 22.4 23.9999C22.4 23.9999 24 21.6839 24 20.7999C24 20.2087 23.6765 19.6988 23.2 19.4218V11.4827ZM4.8 13.4812V16.7999C4.8 19.0087 8.0232 20.7999 12 20.7999C15.9768 20.7999 19.2 19.0087 19.2 16.7999V13.4812L13.0922 16.5358C13.025 16.5694 12.9579 16.597 12.8891 16.6202C12.5995 16.7394 12.3016 16.7999 12 16.7999C11.6992 16.7999 11.4021 16.7394 11.1141 16.6202C11.0445 16.597 10.9758 16.5687 10.9078 16.5343L4.8 13.4812Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_720_5761' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var EducationIcon$1 = react.memo(EducationIcon);


//# sourceMappingURL=Education.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/PhoneNumber.js
'use client';




var PhoneNumberIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M16.9792 14.3111C16.6544 14.1207 16.2552 14.1247 15.932 14.3167L14.2952 15.2919C13.9288 15.5103 13.4712 15.4847 13.1352 15.2223C12.5544 14.7687 11.6192 14.0055 10.8056 13.1919C9.99202 12.3783 9.22882 11.4431 8.77522 10.8623C8.51282 10.5263 8.48723 10.0687 8.70563 9.70233L9.68082 8.06553C9.87362 7.74233 9.87522 7.33993 9.68482 7.01513L7.28322 2.91273C7.05042 2.51593 6.58802 2.32073 6.14082 2.43033C5.70642 2.53593 5.14242 2.79353 4.55122 3.38553C2.70003 5.23673 1.71683 8.35913 8.67842 15.3207C15.64 22.2823 18.7616 21.2999 20.6136 19.4479C21.2064 18.8551 21.4632 18.2903 21.5696 17.8551C21.6776 17.4087 21.4856 16.9495 21.0896 16.7175C20.1008 16.1391 17.968 14.8903 16.9792 14.3111Z', fill: color })));
};
var PhoneNumberIcon$1 = react.memo(PhoneNumberIcon);


//# sourceMappingURL=PhoneNumber.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js
'use client';




var CalendarIOS16GlyphIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M19.2002 3.2002H4.8002C3.9162 3.2002 3.2002 3.9162 3.2002 4.8002V19.2002C3.2002 20.0842 3.9162 20.8002 4.8002 20.8002H19.2002C20.0842 20.8002 20.8002 20.0842 20.8002 19.2002V4.8002C20.8002 3.9162 20.0842 3.2002 19.2002 3.2002ZM5.6002 18.4002C5.1586 18.4002 4.8002 18.0418 4.8002 17.6002C4.8002 17.1586 5.1586 16.8002 5.6002 16.8002C6.0418 16.8002 6.4002 17.1586 6.4002 17.6002C6.4002 18.0418 6.0418 18.4002 5.6002 18.4002ZM5.6002 15.2002C5.1586 15.2002 4.8002 14.8418 4.8002 14.4002C4.8002 13.9586 5.1586 13.6002 5.6002 13.6002C6.0418 13.6002 6.4002 13.9586 6.4002 14.4002C6.4002 14.8418 6.0418 15.2002 5.6002 15.2002ZM8.8002 18.4002C8.3586 18.4002 8.0002 18.0418 8.0002 17.6002C8.0002 17.1586 8.3586 16.8002 8.8002 16.8002C9.2418 16.8002 9.6002 17.1586 9.6002 17.6002C9.6002 18.0418 9.2418 18.4002 8.8002 18.4002ZM8.8002 15.2002C8.3586 15.2002 8.0002 14.8418 8.0002 14.4002C8.0002 13.9586 8.3586 13.6002 8.8002 13.6002C9.2418 13.6002 9.6002 13.9586 9.6002 14.4002C9.6002 14.8418 9.2418 15.2002 8.8002 15.2002ZM8.8002 12.0002C8.3586 12.0002 8.0002 11.6418 8.0002 11.2002C8.0002 10.7586 8.3586 10.4002 8.8002 10.4002C9.2418 10.4002 9.6002 10.7586 9.6002 11.2002C9.6002 11.6418 9.2418 12.0002 8.8002 12.0002ZM12.0002 18.4002C11.5586 18.4002 11.2002 18.0418 11.2002 17.6002C11.2002 17.1586 11.5586 16.8002 12.0002 16.8002C12.4418 16.8002 12.8002 17.1586 12.8002 17.6002C12.8002 18.0418 12.4418 18.4002 12.0002 18.4002ZM12.0002 15.2002C11.5586 15.2002 11.2002 14.8418 11.2002 14.4002C11.2002 13.9586 11.5586 13.6002 12.0002 13.6002C12.4418 13.6002 12.8002 13.9586 12.8002 14.4002C12.8002 14.8418 12.4418 15.2002 12.0002 15.2002ZM12.0002 12.0002C11.5586 12.0002 11.2002 11.6418 11.2002 11.2002C11.2002 10.7586 11.5586 10.4002 12.0002 10.4002C12.4418 10.4002 12.8002 10.7586 12.8002 11.2002C12.8002 11.6418 12.4418 12.0002 12.0002 12.0002ZM15.2002 18.4002C14.7586 18.4002 14.4002 18.0418 14.4002 17.6002C14.4002 17.1586 14.7586 16.8002 15.2002 16.8002C15.6418 16.8002 16.0002 17.1586 16.0002 17.6002C16.0002 18.0418 15.6418 18.4002 15.2002 18.4002ZM15.2002 15.2002C14.7586 15.2002 14.4002 14.8418 14.4002 14.4002C14.4002 13.9586 14.7586 13.6002 15.2002 13.6002C15.6418 13.6002 16.0002 13.9586 16.0002 14.4002C16.0002 14.8418 15.6418 15.2002 15.2002 15.2002ZM14.4002 11.2002C14.4002 10.7586 14.7586 10.4002 15.2002 10.4002C15.6418 10.4002 16.0002 10.7586 16.0002 11.2002C16.0002 11.6418 15.6418 12.0002 15.2002 12.0002C14.7586 12.0002 14.4002 11.6418 14.4002 11.2002ZM18.4002 15.2002C17.9586 15.2002 17.6002 14.8418 17.6002 14.4002C17.6002 13.9586 17.9586 13.6002 18.4002 13.6002C18.8418 13.6002 19.2002 13.9586 19.2002 14.4002C19.2002 14.8418 18.8418 15.2002 18.4002 15.2002ZM18.4002 12.0002C17.9586 12.0002 17.6002 11.6418 17.6002 11.2002C17.6002 10.7586 17.9586 10.4002 18.4002 10.4002C18.8418 10.4002 19.2002 10.7586 19.2002 11.2002C19.2002 11.6418 18.8418 12.0002 18.4002 12.0002ZM19.2002 8.0002H4.8002V4.8002H19.2002V8.0002Z', fill: color })));
};
var CalendarIOS16GlyphICon = react.memo(CalendarIOS16GlyphIcon);


//# sourceMappingURL=CalendarIOS16Glyph.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Admin.js
'use client';




var AdminIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.199 3C11.7747 3 11.3677 3.16857 11.0677 3.46863C10.7676 3.76869 10.599 4.17565 10.599 4.6C10.5992 4.88983 10.678 5.17418 10.8272 5.42269C10.9763 5.67119 11.1902 5.87451 11.4459 6.01094L8.28184 11.9438L3.97715 9.41094C4.12207 9.16524 4.19868 8.88526 4.19902 8.6C4.19902 8.17565 4.03045 7.76869 3.73039 7.46863C3.43034 7.16857 3.02337 7 2.59902 7C2.17468 7 1.76771 7.16857 1.46765 7.46863C1.16759 7.76869 0.999023 8.17565 0.999023 8.6C0.999023 9.02435 1.16759 9.43131 1.46765 9.73137C1.76771 10.0314 2.17468 10.2 2.59902 10.2C2.65227 10.1995 2.70546 10.1964 2.7584 10.1906L3.39902 16.6H5.79902H16.199H18.599H20.999L21.6396 10.1922C21.6926 10.1974 21.7458 10.2 21.799 10.2C22.2234 10.2 22.6303 10.0314 22.9304 9.73137C23.2305 9.43131 23.399 9.02435 23.399 8.6C23.399 8.17565 23.2305 7.76869 22.9304 7.46863C22.6303 7.16857 22.2234 7 21.799 7C21.3747 7 20.9677 7.16857 20.6677 7.46863C20.3676 7.76869 20.199 8.17565 20.199 8.6C20.1994 8.88526 20.276 9.16524 20.4209 9.41094L16.1162 11.9438L12.9521 6.01094C13.2079 5.87451 13.4217 5.67119 13.5709 5.42269C13.72 5.17418 13.7989 4.88983 13.799 4.6C13.799 4.17565 13.6305 3.76869 13.3304 3.46863C13.0303 3.16857 12.6234 3 12.199 3ZM3.39902 18.2V19.8C3.39902 20.684 4.11502 21.4 4.99902 21.4H19.399C20.283 21.4 20.999 20.684 20.999 19.8V18.2H3.39902Z', fill: color })));
};
var AdminIcon$1 = react.memo(AdminIcon);


//# sourceMappingURL=Admin.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/HeadHunter.js
'use client';




var HeadHunterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7 0a5.612 5.612 0 0 0-1.083.108c-.042.004-.083.013-.13.022C4.219.457 1.969 1.535 1.87 4.895c-.004.08-.004.159-.004.238V6.38l.205-.135a1.034 1.034 0 0 1 1.279.093c.004-.028.014-.055.023-.083a.41.41 0 0 1 .023-.07.685.685 0 0 1 .066-.146.14.14 0 0 1 .028-.05c.019-.047.047-.089.075-.131a.085.085 0 0 1 .027-.033.623.623 0 0 1 .09-.116.266.266 0 0 1 .05-.052.856.856 0 0 1 .117-.107c.005-.005.004-.01.01-.005a.782.782 0 0 1 .125-.098c.014-.01.029-.019.047-.033.052-.033.107-.06.168-.088.06-.033.126-.06.196-.089.065-.028.135-.056.205-.074.681-.22 1.54-.285 2.357-.5.07-.014.14-.038.21-.056.13-.038.261-.08.387-.13a1.83 1.83 0 0 0 .2-.085.838.838 0 0 0 .546-.308c.42-.284.78-.695 1.032-1.283 0 0 .206.187.458.583.037.056.075.122.112.187.047.075.088.154.13.238.271.532.542 1.274.65 2.259.018.149.032.303.037.466.009.15.013.308.013.467h.467v.467c0 .457-.159.653-.308.788-.15.13-.27.159-.27.159l-.252.06-.08.243s-.644 1.998-2.572 2.408l.836.523a.97.97 0 0 1 .163.13c1.587-.709 2.254-2.263 2.385-2.599.13-.051.21-.056.406-.224.317-.275.625-.779.625-1.488V5.133c0-1.866-.933-4.2-2.8-4.2C9.333.933 8.867 0 7 0ZM4.9 6.533a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4Zm4.2 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4ZM2.562 7c-.037 0-.08 0-.117.01a1.2 1.2 0 0 0-.565.34l-.013.014c-.649.658-.976 1.769 1.479 4.223 2.473 2.474 3.58 2.124 4.237 1.466.21-.21.304-.411.341-.565a.373.373 0 0 0-.173-.406c-.005-.004-.009-.005-.018-.014-.355-.206-1.092-.64-1.442-.84a.36.36 0 0 0-.37.005l-.583.345a.366.366 0 0 1-.41-.023 10.085 10.085 0 0 1-.826-.723c-.29-.29-.56-.622-.723-.827a.358.358 0 0 1-.024-.41l.346-.583a.342.342 0 0 0 .05-.178.335.335 0 0 0-.05-.196l-.038-.066-.033-.097-.027-.01-.752-1.283a.665.665 0 0 0-.051-.07A.392.392 0 0 0 2.562 7Z', fill: color })));
};
var HeadHunterIcon$1 = react.memo(HeadHunterIcon);


//# sourceMappingURL=HeadHunter.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Address.js
'use client';




var Address = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0001 1.6001C8.46572 1.6001 5.60012 4.4657 5.60012 8.0001C5.60012 12.8001 11.2001 14.4001 11.2001 17.6001C11.2001 18.0417 11.5585 18.4001 12.0001 18.4001C12.4417 18.4001 12.8001 18.0417 12.8001 17.6001C12.8001 14.4001 18.4001 12.8001 18.4001 8.0001C18.4001 4.4657 15.5345 1.6001 12.0001 1.6001ZM12.0001 6.4001C12.8841 6.4001 13.6001 7.1161 13.6001 8.0001C13.6001 8.8841 12.8841 9.6001 12.0001 9.6001C11.1161 9.6001 10.4001 8.8841 10.4001 8.0001C10.4001 7.1161 11.1161 6.4001 12.0001 6.4001ZM4.80012 13.6001C4.46652 13.6001 4.16772 13.8076 4.05012 14.1188L1.65012 20.5188C1.55812 20.7652 1.59351 21.0388 1.74231 21.2548C1.89271 21.4708 2.13772 21.6001 2.40012 21.6001H21.6001C21.8625 21.6001 22.1083 21.4708 22.2579 21.2548C22.4075 21.0396 22.4421 20.7652 22.3501 20.5188L19.9501 14.1188C19.8325 13.8076 19.5337 13.6001 19.2001 13.6001H17.6189C17.1805 14.0897 16.7281 14.5371 16.3017 14.9579C16.2177 15.0395 16.1372 15.1201 16.0564 15.2001H18.6454L20.4454 20.0001H3.55481L5.35481 15.2001H7.94387C7.86307 15.1201 7.78332 15.0395 7.70012 14.9579C7.27292 14.5371 6.81977 14.0897 6.38137 13.6001H4.80012Z', fill: color })));
};
var AddressIcon = react.memo(Address);


//# sourceMappingURL=Address.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Salary.js
'use client';




var Salary = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M3.19961 4C3.09571 4.00035 2.9921 4.01081 2.89023 4.03125C2.88176 4.03295 2.87366 4.03566 2.86523 4.0375C2.50741 4.11397 2.18661 4.31077 1.95631 4.5951C1.726 4.87942 1.60011 5.2341 1.59961 5.6V15.2C1.59996 15.3039 1.61042 15.4075 1.63086 15.5094C1.63256 15.5178 1.63527 15.5259 1.63711 15.5344C1.71358 15.8922 1.91038 16.213 2.19471 16.4433C2.47903 16.6736 2.83371 16.7995 3.19961 16.8H20.7996C20.9035 16.7997 21.0071 16.7892 21.109 16.7688C21.1175 16.767 21.1256 16.7643 21.134 16.7625C21.4918 16.686 21.8126 16.4892 22.0429 16.2049C22.2732 15.9206 22.3991 15.5659 22.3996 15.2V5.6C22.3993 5.4961 22.3888 5.39249 22.3684 5.29062C22.3667 5.28215 22.3639 5.27405 22.3621 5.26562C22.2856 4.9078 22.0888 4.587 21.8045 4.3567C21.5202 4.12639 21.1655 4.0005 20.7996 4H3.19961ZM4.79961 5.6H19.1996C19.1996 6.02435 19.3682 6.43131 19.6682 6.73137C19.9683 7.03143 20.3753 7.2 20.7996 7.2V13.6C20.3753 13.6 19.9683 13.7686 19.6682 14.0686C19.3682 14.3687 19.1996 14.7757 19.1996 15.2H4.79961C4.79961 14.7757 4.63104 14.3687 4.33098 14.0686C4.03092 13.7686 3.62396 13.6 3.19961 13.6V7.2C3.62396 7.2 4.03092 7.03143 4.33098 6.73137C4.63104 6.43131 4.79961 6.02435 4.79961 5.6ZM11.9996 7.2C10.2324 7.2 8.79961 8.812 8.79961 10.8C8.79961 11.9376 9.27775 12.94 10.0105 13.6H13.9887C14.7215 12.94 15.1996 11.9376 15.1996 10.8C15.1996 8.812 13.7668 7.2 11.9996 7.2ZM5.59961 9.6C5.38744 9.6 5.18395 9.68429 5.03392 9.83431C4.88389 9.98434 4.79961 10.1878 4.79961 10.4C4.79961 10.6122 4.88389 10.8157 5.03392 10.9657C5.18395 11.1157 5.38744 11.2 5.59961 11.2C5.81178 11.2 6.01527 11.1157 6.16529 10.9657C6.31532 10.8157 6.39961 10.6122 6.39961 10.4C6.39961 10.1878 6.31532 9.98434 6.16529 9.83431C6.01527 9.68429 5.81178 9.6 5.59961 9.6ZM18.3996 9.6C18.1874 9.6 17.984 9.68429 17.8339 9.83431C17.6839 9.98434 17.5996 10.1878 17.5996 10.4C17.5996 10.6122 17.6839 10.8157 17.8339 10.9657C17.984 11.1157 18.1874 11.2 18.3996 11.2C18.6118 11.2 18.8153 11.1157 18.9653 10.9657C19.1153 10.8157 19.1996 10.6122 19.1996 10.4C19.1996 10.1878 19.1153 9.98434 18.9653 9.83431C18.8153 9.68429 18.6118 9.6 18.3996 9.6ZM3.19961 18.4C3.0936 18.3985 2.98835 18.4181 2.88997 18.4576C2.7916 18.4971 2.70206 18.5558 2.62657 18.6303C2.55107 18.7047 2.49112 18.7934 2.4502 18.8912C2.40929 18.989 2.38822 19.094 2.38822 19.2C2.38822 19.306 2.40929 19.411 2.4502 19.5088C2.49112 19.6066 2.55107 19.6953 2.62657 19.7697C2.70206 19.8442 2.7916 19.9029 2.88997 19.9424C2.98835 19.9819 3.0936 20.0015 3.19961 20H20.7996C20.9056 20.0015 21.0109 19.9819 21.1092 19.9424C21.2076 19.9029 21.2972 19.8442 21.3727 19.7697C21.4481 19.6953 21.5081 19.6066 21.549 19.5088C21.5899 19.411 21.611 19.306 21.611 19.2C21.611 19.094 21.5899 18.989 21.549 18.8912C21.5081 18.7934 21.4481 18.7047 21.3727 18.6303C21.2972 18.5558 21.2076 18.4971 21.1092 18.4576C21.0109 18.4181 20.9056 18.3985 20.7996 18.4H3.19961Z', fill: color })));
};
var SalaryIcon = react.memo(Salary);


//# sourceMappingURL=Salary.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Gender.js
'use client';




var GenderIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M16.8003 2.39998C16.6943 2.39848 16.589 2.41807 16.4906 2.4576C16.3923 2.49713 16.3027 2.55582 16.2272 2.63025C16.1517 2.70469 16.0918 2.79339 16.0509 2.89119C16.0099 2.989 15.9889 3.09396 15.9889 3.19998C15.9889 3.306 16.0099 3.41097 16.0509 3.50877C16.0918 3.60658 16.1517 3.69527 16.2272 3.76971C16.3027 3.84415 16.3923 3.90283 16.4906 3.94237C16.589 3.9819 16.6943 4.00148 16.8003 3.99998H18.869L16.38 6.48905C15.5957 5.93099 14.6389 5.59842 13.6049 5.59842C10.9578 5.59842 8.80495 7.75122 8.80495 10.3984C8.80495 12.2976 9.91734 13.9396 11.5221 14.7172C11.5677 14.6716 11.622 14.6379 11.6628 14.5875C11.818 14.3899 12.005 14.0568 12.005 13.5984C12.005 13.4288 11.9718 13.267 11.9206 13.1094C11.0142 12.5438 10.405 11.544 10.405 10.3984C10.405 8.63362 11.8401 7.19842 13.6049 7.19842C15.3698 7.19842 16.8049 8.63362 16.8049 10.3984C16.8049 10.8656 16.6982 11.307 16.5175 11.7078C16.7046 12.3134 16.8049 12.9488 16.8049 13.5984C16.8049 13.7264 16.7965 13.854 16.7893 13.9812C17.7781 13.1012 18.405 11.8232 18.405 10.3984C18.405 9.36221 18.0715 8.40554 17.5112 7.6203L20.0003 5.13123V7.19998C19.9988 7.30599 20.0183 7.41124 20.0579 7.50962C20.0974 7.60799 20.1561 7.69753 20.2305 7.77302C20.305 7.84852 20.3937 7.90847 20.4915 7.94939C20.5893 7.9903 20.6942 8.01138 20.8003 8.01138C20.9063 8.01138 21.0112 7.9903 21.1091 7.94939C21.2069 7.90847 21.2956 7.84852 21.37 7.77302C21.4444 7.69753 21.5031 7.60799 21.5426 7.50962C21.5822 7.41124 21.6018 7.30599 21.6003 7.19998V2.39998H16.8003ZM12.4831 9.28123C12.4375 9.32683 12.3817 9.36052 12.3409 9.41092C12.1857 9.60932 12.0003 9.94158 12.0003 10.4C12.0003 10.5696 12.0334 10.733 12.0846 10.8906C12.991 11.4562 13.6003 12.4544 13.6003 13.6C13.6003 15.3648 12.1651 16.8 10.4003 16.8C8.63546 16.8 7.20026 15.3648 7.20026 13.6C7.20026 13.1328 7.30696 12.6914 7.48776 12.2906C7.30056 11.685 7.20026 11.0496 7.20026 10.4C7.20026 10.272 7.20869 10.1444 7.21589 10.0172C6.22709 10.8972 5.60026 12.1752 5.60026 13.6C5.60026 14.6352 5.93162 15.5933 6.49089 16.3781L4.80026 18.0687L3.76589 17.0344C3.69134 16.9577 3.60218 16.8968 3.50369 16.8552C3.4052 16.8136 3.29937 16.7922 3.19245 16.7922C3.0333 16.7922 2.87779 16.8397 2.74578 16.9286C2.61377 17.0175 2.51127 17.1437 2.45139 17.2912C2.3915 17.4386 2.37695 17.6006 2.40959 17.7564C2.44223 17.9121 2.52059 18.0546 2.63464 18.1656L3.66901 19.2L2.63464 20.2344C2.55786 20.3081 2.49656 20.3964 2.45433 20.4941C2.4121 20.5918 2.3898 20.6969 2.38871 20.8034C2.38763 20.9098 2.4078 21.0154 2.44803 21.1139C2.48826 21.2124 2.54775 21.302 2.62301 21.3772C2.69827 21.4525 2.7878 21.512 2.88634 21.5522C2.98488 21.5925 3.09046 21.6126 3.19689 21.6115C3.30332 21.6104 3.40847 21.5881 3.50617 21.5459C3.60388 21.5037 3.69217 21.4424 3.76589 21.3656L4.80026 20.3312L5.83464 21.3656C5.90835 21.4424 5.99665 21.5037 6.09435 21.5459C6.19205 21.5881 6.2972 21.6104 6.40363 21.6115C6.51007 21.6126 6.61564 21.5925 6.71419 21.5522C6.81273 21.512 6.90225 21.4525 6.97752 21.3772C7.05278 21.302 7.11227 21.2124 7.1525 21.1139C7.19273 21.0154 7.21289 20.9098 7.21181 20.8034C7.21073 20.6969 7.18842 20.5918 7.14619 20.4941C7.10396 20.3964 7.04267 20.3081 6.96589 20.2344L5.93151 19.2L7.62214 17.5094C8.40696 18.0686 9.36505 18.4 10.4003 18.4C13.0475 18.4 15.2003 16.2472 15.2003 13.6C15.2003 11.7 14.0887 10.0588 12.4831 9.28123Z', fill: color })));
};
var GenderIcon$1 = react.memo(GenderIcon);


//# sourceMappingURL=Gender.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Translator.js
'use client';




var TranslatorIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M15.8272 1.43994C15.6078 1.44369 15.396 1.45869 15.1878 1.47744C15.111 1.48494 15.0341 1.49244 14.9572 1.49994C14.8466 1.51494 14.7378 1.53182 14.631 1.54869C13.2603 1.76619 12.1841 2.32307 11.4153 3.20994C11.3985 3.23057 11.3797 3.25119 11.3628 3.27182C11.3178 3.32619 11.2672 3.37307 11.226 3.43119C11.0647 3.64119 10.9278 3.86432 10.806 4.09494C10.8003 4.10619 10.7928 4.11557 10.7872 4.12869C10.7403 4.21682 10.6991 4.30682 10.6578 4.39682C10.6503 4.41369 10.641 4.43057 10.6353 4.44744C10.6316 4.45307 10.6297 4.45869 10.6278 4.46432C9.83283 6.29994 10.0653 8.56119 10.4928 10.3481C10.431 10.3968 10.3691 10.4606 10.3128 10.5337V10.5356C10.2641 10.5974 10.2228 10.6706 10.1872 10.7493C10.1235 10.8881 10.0803 11.0568 10.0728 11.2649V11.2668C10.0691 11.3624 10.0691 11.4637 10.0822 11.5781C10.1028 11.7374 10.1291 11.8893 10.1572 12.0356C10.1647 12.0768 10.1741 12.1143 10.1835 12.1537C10.2041 12.2493 10.2266 12.3431 10.2528 12.4331C10.2641 12.4781 10.2791 12.5231 10.2922 12.5662C10.3203 12.6543 10.3503 12.7387 10.3803 12.8193C10.3916 12.8456 10.4028 12.8737 10.4122 12.8999C10.5903 13.3181 10.8191 13.6256 11.0853 13.7868C11.2935 14.8856 11.9703 15.9412 12.4803 16.5093V19.8506L7.48158 22.1231C7.26408 22.2187 7.14971 22.4587 7.20971 22.6874C7.27158 22.9162 7.49096 23.0662 7.72721 23.0399H23.5203C23.5747 23.0399 23.6272 23.0306 23.6778 23.0118C23.6797 23.0137 23.6797 23.0137 23.6797 23.0118C23.7303 22.9949 23.7772 22.9687 23.8185 22.9349H23.8203C23.8616 22.9012 23.8953 22.8637 23.9253 22.8206C23.9253 22.8187 23.9253 22.8168 23.9253 22.8168C23.9535 22.7718 23.9741 22.7231 23.9872 22.6724C23.9872 22.6706 23.9872 22.6706 23.9872 22.6706C23.9891 22.6687 23.9872 22.6668 23.9872 22.6649C24.0003 22.6143 24.0022 22.5637 23.9985 22.5112C23.9966 22.5093 23.9966 22.5074 23.9966 22.5056C23.991 22.4531 23.9778 22.4024 23.9553 22.3574C23.9553 22.3556 23.9553 22.3556 23.9553 22.3556C23.9328 22.3068 23.901 22.2637 23.8653 22.2262C23.8278 22.1868 23.7828 22.1549 23.736 22.1306L19.2003 19.8637V16.5093C19.7085 15.9431 20.3853 14.8856 20.5935 13.7868C20.7941 13.6668 20.9741 13.4606 21.126 13.1906C21.1297 13.1849 21.1316 13.1774 21.1353 13.1718C21.1803 13.0893 21.2235 13.0031 21.2628 12.9074C21.2778 12.8756 21.2891 12.8399 21.3022 12.8081C21.3322 12.7312 21.3603 12.6543 21.3866 12.5718C21.4016 12.5268 21.4147 12.4818 21.4278 12.4331C21.4522 12.3468 21.4747 12.2568 21.4953 12.1649C21.5047 12.1181 21.516 12.0749 21.5253 12.0262C21.5535 11.8818 21.5778 11.7337 21.5966 11.5781C21.6097 11.4637 21.6116 11.3624 21.6078 11.2649C21.6078 11.2649 21.6097 11.2649 21.6078 11.2649C21.6003 11.0587 21.5572 10.8937 21.4953 10.7568C21.4691 10.6968 21.4372 10.6443 21.4035 10.5937C21.3922 10.5768 21.3847 10.5562 21.3735 10.5412C21.3716 10.5393 21.3697 10.5374 21.3678 10.5356C21.3603 10.5243 21.3547 10.5224 21.3472 10.5149C21.3022 10.4587 21.2553 10.4043 21.2085 10.3631C21.3397 9.93182 21.4822 9.36932 21.5985 8.75432C21.6153 8.65869 21.6341 8.56119 21.651 8.46182C21.6622 8.38682 21.6753 8.31369 21.6866 8.23682C21.7203 8.00432 21.7466 7.76619 21.7653 7.52432C21.7672 7.48307 21.7691 7.44182 21.771 7.40057C21.7841 7.18869 21.7878 6.97682 21.7841 6.76307C21.7822 6.69744 21.7841 6.63369 21.7803 6.56994C21.7803 6.55119 21.7803 6.53432 21.7803 6.51744C21.7785 6.49119 21.7747 6.46682 21.7728 6.44057C21.7635 6.29057 21.7485 6.14244 21.7278 5.99432C21.7241 5.95307 21.7203 5.91182 21.7128 5.87244C21.6866 5.69994 21.651 5.53307 21.6078 5.36994C21.5797 5.26119 21.5497 5.15619 21.5122 5.05119V5.04932C21.471 4.92932 21.4222 4.81119 21.3678 4.69682C21.3622 4.68369 21.3566 4.67244 21.351 4.65932C21.3041 4.56557 21.2535 4.47369 21.201 4.38369C21.1916 4.37057 21.186 4.35744 21.1785 4.34432C21.1672 4.32557 21.1522 4.30869 21.141 4.28994C21.1203 4.25994 21.1035 4.22807 21.0828 4.19994C21.0697 4.17932 21.051 4.15869 21.036 4.13807C21.0003 4.09119 20.9666 4.04619 20.931 4.00307C20.916 3.98619 20.901 3.96932 20.886 3.95244C20.4228 3.41807 19.7947 3.06932 19.0053 2.92119C18.8291 2.68307 18.5797 2.45244 18.2853 2.24244C18.2403 2.20869 18.1935 2.17494 18.1447 2.14119C18.111 2.12057 18.0735 2.09994 18.0378 2.07744C17.976 2.03994 17.916 1.99682 17.8485 1.96119C17.8166 1.94432 17.7828 1.93119 17.7528 1.91619C17.7097 1.89369 17.6647 1.87494 17.6197 1.85432C17.5203 1.80744 17.4191 1.76244 17.3122 1.72119C17.2653 1.70244 17.2166 1.68932 17.1678 1.67244C17.061 1.63682 16.956 1.60119 16.8435 1.57119C16.7835 1.55619 16.7197 1.54682 16.6578 1.53369C16.5566 1.51307 16.4553 1.48869 16.3503 1.47557C16.221 1.45869 16.0897 1.45307 15.9603 1.44744C15.9191 1.44744 15.8816 1.43994 15.8403 1.43994H15.8347C15.8347 1.43994 15.8328 1.43994 15.831 1.43994C15.8291 1.43994 15.8291 1.43994 15.8272 1.43994ZM6.51221 1.53744C6.03408 1.54307 5.54846 1.59369 5.06658 1.68932C3.14096 2.07369 1.28096 3.28119 0.504709 5.60807C-0.430916 8.41494 0.602209 10.7343 1.83408 12.4837C1.60346 12.9037 1.27533 13.4249 0.952834 13.8974C0.765334 14.1693 0.592834 14.4168 0.465334 14.6043C0.399709 14.6981 0.347209 14.7768 0.304084 14.8424C0.283459 14.8762 0.266584 14.9043 0.247834 14.9399C0.238459 14.9568 0.229084 14.9756 0.215959 15.0056C0.202834 15.0337 0.174709 15.0543 0.174709 15.2024L0.262834 15.4799C0.262834 15.4818 0.313459 15.5418 0.337834 15.5624C0.360334 15.5849 0.382834 15.5999 0.401584 15.6131C0.480334 15.6618 0.523459 15.6674 0.555334 15.6749C0.620959 15.6899 0.647209 15.6881 0.675334 15.6899C0.727834 15.6899 0.769084 15.6881 0.817834 15.6824C0.915334 15.6749 1.03533 15.6562 1.17971 15.6299C1.47033 15.5756 1.85846 15.4837 2.28033 15.3412C3.02846 15.0881 3.86096 14.6418 4.45908 13.9481C4.72908 14.0343 5.20158 14.1993 6.04533 14.2443C7.05033 14.3006 8.32346 14.1581 9.40721 13.3443C9.62096 13.1849 9.66408 12.8849 9.50471 12.6731C9.34533 12.4593 9.04533 12.4162 8.83346 12.5756C7.99721 13.2018 6.96596 13.3331 6.09783 13.2862C5.23158 13.2393 4.53408 13.0068 4.48158 12.9881L4.12908 12.8624L3.92096 13.1737C3.54596 13.7381 2.71908 14.1806 1.97283 14.4318C1.86783 14.4674 1.80033 14.4749 1.69908 14.5049C1.71783 14.4787 1.72721 14.4637 1.74408 14.4393C2.12283 13.8843 2.56346 13.2262 2.82971 12.6956L2.96096 12.4312L2.78658 12.1949C1.55096 10.5262 0.553459 8.50119 1.41596 5.91182C2.07971 3.91869 3.57971 2.96619 5.25408 2.63057C6.92846 2.29494 8.76783 2.65119 9.83283 3.29244C9.98096 3.38619 10.1685 3.39369 10.3222 3.31119C10.4778 3.22682 10.5735 3.06557 10.5753 2.89119C10.5753 2.71494 10.4797 2.55369 10.3278 2.46744C9.32658 1.86932 7.95033 1.51494 6.51221 1.53744ZM6.20283 4.31244C5.93846 4.31619 5.72658 4.53557 5.73033 4.79994V5.96807H3.82533C3.65096 5.96432 3.48971 6.05619 3.40346 6.20432C3.31533 6.35432 3.31533 6.53994 3.40346 6.68994C3.48971 6.83807 3.65096 6.92994 3.82533 6.92807H7.60346C7.54346 7.17744 7.44033 7.50182 7.23971 7.87494C7.06346 8.20494 6.81408 8.56119 6.46533 8.90807C5.90096 8.33244 5.59533 7.88994 5.59533 7.88994C5.50346 7.75494 5.35158 7.67432 5.18846 7.67807C5.01033 7.67994 4.84721 7.78119 4.76658 7.93869C4.68596 8.09807 4.69908 8.28744 4.80221 8.43369C4.80221 8.43369 5.12658 8.90244 5.72283 9.51744C5.29908 9.80244 4.78533 10.0668 4.14783 10.2843C3.97908 10.3368 3.85158 10.4737 3.81596 10.6462C3.78033 10.8187 3.84033 10.9968 3.97533 11.1112C4.11033 11.2256 4.29408 11.2556 4.45908 11.1918C5.25596 10.9199 5.89908 10.5693 6.42783 10.1868C6.72033 10.4418 7.04283 10.7024 7.40846 10.9556C7.54908 11.0587 7.73471 11.0774 7.89408 11.0043C8.05346 10.9312 8.16033 10.7774 8.17158 10.6031C8.18471 10.4287 8.10033 10.2599 7.95221 10.1643C7.66346 9.96557 7.40658 9.75932 7.16846 9.55682C7.57346 9.14807 7.87346 8.72619 8.08533 8.33057C8.38346 7.77369 8.51471 7.27682 8.58033 6.92807H9.03033C9.20283 6.92994 9.36408 6.83807 9.45033 6.68994C9.53846 6.53994 9.53846 6.35432 9.45033 6.20432C9.36408 6.05619 9.20283 5.96432 9.03033 5.96807H8.24283C8.21658 5.96244 8.18846 5.96057 8.16221 5.96057C8.13408 5.96057 8.10783 5.96244 8.07971 5.96807H6.69033V4.79994C6.69033 4.67057 6.63971 4.54494 6.54971 4.45307C6.45783 4.36307 6.33221 4.31244 6.20283 4.31244ZM15.8403 5.27994C16.0447 5.27994 16.2266 5.40932 16.2941 5.60244L18.6941 12.5362C18.7803 12.7874 18.6472 13.0612 18.3978 13.1474C18.3453 13.1643 18.2928 13.1737 18.2403 13.1737C18.0416 13.1737 17.856 13.0481 17.7866 12.8493L17.1603 11.0399H14.5203L13.8941 12.8493C13.806 13.1006 13.5341 13.2318 13.2828 13.1474C13.0335 13.0593 12.9003 12.7856 12.9866 12.5362L15.3866 5.60244C15.4541 5.40932 15.636 5.27994 15.8403 5.27994ZM15.8403 7.22807L14.8522 10.0799H16.8285L15.8403 7.22807Z', fill: color })));
};
var TranslatorIcon$1 = react.memo(TranslatorIcon);


//# sourceMappingURL=Translator.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Birthday.js
'use client';




var BirthdayIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M6.40039 0.799805C6.40039 0.799805 4.80039 3.1158 4.80039 3.9998C4.80039 4.8838 5.51639 5.5998 6.40039 5.5998C7.28439 5.5998 8.00039 4.8838 8.00039 3.9998C8.00039 3.1158 6.40039 0.799805 6.40039 0.799805ZM12.0004 0.799805C12.0004 0.799805 10.4004 3.1158 10.4004 3.9998C10.4004 4.8838 11.1164 5.5998 12.0004 5.5998C12.8844 5.5998 13.6004 4.8838 13.6004 3.9998C13.6004 3.1158 12.0004 0.799805 12.0004 0.799805ZM17.6004 0.799805C17.6004 0.799805 16.0004 3.1158 16.0004 3.9998C16.0004 4.8838 16.7164 5.5998 17.6004 5.5998C18.4844 5.5998 19.2004 4.8838 19.2004 3.9998C19.2004 3.1158 17.6004 0.799805 17.6004 0.799805ZM4.80039 7.1998V10.5154C3.42775 10.8753 2.40039 12.1195 2.40039 13.5998C2.40039 14.4 2.70903 15.1258 3.20039 15.6889V19.1998C3.20039 20.0838 3.91639 20.7998 4.80039 20.7998H19.2004C20.0844 20.7998 20.8004 20.0838 20.8004 19.1998V15.6889C21.2917 15.1258 21.6004 14.4 21.6004 13.5998C21.6004 12.1195 20.573 10.8753 19.2004 10.5154V7.1998H16.0004V10.3998H13.6004V7.1998H10.4004V10.3998H8.00039V7.1998H4.80039ZM5.60039 11.9998H18.4004C19.2937 11.9998 20.0004 12.7065 20.0004 13.5998C20.0004 14.4931 19.2937 15.1998 18.4004 15.1998C17.99 15.1998 17.6275 15.0448 17.3363 14.7826L16.8004 14.2998L16.2645 14.7826C15.9733 15.0448 15.6107 15.1998 15.2004 15.1998C14.79 15.1998 14.4275 15.0448 14.1363 14.7826L13.6004 14.2998L13.0645 14.7826C12.7733 15.0448 12.4107 15.1998 12.0004 15.1998C11.59 15.1998 11.2275 15.0448 10.9363 14.7826L10.4004 14.2998L9.86445 14.7826C9.57326 15.0448 9.21074 15.1998 8.80039 15.1998C8.39004 15.1998 8.02752 15.0448 7.73633 14.7826L7.20039 14.2998L6.66445 14.7826C6.37326 15.0448 6.01074 15.1998 5.60039 15.1998C4.70706 15.1998 4.00039 14.4931 4.00039 13.5998C4.00039 12.7065 4.70706 11.9998 5.60039 11.9998Z', fill: color })));
};
var BirthdayIcon$1 = react.memo(BirthdayIcon);


//# sourceMappingURL=Birthday.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js
'use client';




var LocationIOS16GlyphIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0002 1.6001C7.1402 1.6001 3.2002 5.5401 3.2002 10.4001C3.2002 16.1873 8.9218 18.9577 9.6386 19.6025C10.3706 20.2609 10.9754 21.7369 11.2194 22.5737C11.3378 22.9801 11.6706 23.1857 12.0002 23.1945C12.3306 23.1849 12.6626 22.9793 12.781 22.5737C13.025 21.7369 13.6298 20.2617 14.3618 19.6025C15.0786 18.9577 20.8002 16.1873 20.8002 10.4001C20.8002 5.5401 16.8602 1.6001 12.0002 1.6001ZM12.0002 12.8001C10.6746 12.8001 9.6002 11.7257 9.6002 10.4001C9.6002 9.0745 10.6746 8.0001 12.0002 8.0001C13.3258 8.0001 14.4002 9.0745 14.4002 10.4001C14.4002 11.7257 13.3258 12.8001 12.0002 12.8001Z', fill: color })));
};
var LocationIOS16GlyphIcon$1 = react.memo(LocationIOS16GlyphIcon);


//# sourceMappingURL=LocationIOS16Glyph.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CreditIcon.js
'use client';




var CreditIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M17.5922 3.97668C17.5327 3.97789 17.4735 3.98575 17.4157 4.00011H12.0407H11.961H6.52191C6.48214 3.99344 6.44192 3.98978 6.4016 3.98918C6.26567 3.98843 6.1318 4.02232 6.01261 4.08766C5.89341 4.153 5.79283 4.24762 5.72035 4.36261L1.05941 9.80168C0.970892 9.88014 0.900872 9.97725 0.854393 10.086C0.807913 10.1948 0.786131 10.3125 0.790614 10.4307C0.795097 10.5489 0.825734 10.6647 0.880319 10.7696C0.934904 10.8745 1.01208 10.9661 1.10629 11.0376L11.4157 21.347C11.4182 21.3501 11.4208 21.3533 11.4235 21.3564L11.4344 21.3657C11.4721 21.4036 11.5134 21.4377 11.5578 21.4673C11.5599 21.4684 11.562 21.4694 11.5641 21.4704C11.5834 21.4833 11.6032 21.4952 11.6235 21.5064C11.6276 21.508 11.6318 21.5095 11.636 21.5111C11.7279 21.5585 11.8282 21.5877 11.9313 21.597C11.9583 21.5994 11.9854 21.6004 12.0125 21.6001C12.023 21.5998 12.0334 21.5993 12.0438 21.5986C12.0574 21.5979 12.0709 21.5968 12.0844 21.5954C12.087 21.5954 12.0896 21.5954 12.0922 21.5954C12.0969 21.5944 12.1016 21.5934 12.1063 21.5923C12.1278 21.5895 12.1492 21.5859 12.1703 21.5814C12.1914 21.577 12.2122 21.5718 12.2328 21.5657C12.2381 21.5642 12.2433 21.5627 12.2485 21.5611C12.2542 21.559 12.26 21.5569 12.2657 21.5548C12.31 21.5393 12.3529 21.52 12.3938 21.497L12.3953 21.4954C12.4135 21.4852 12.4312 21.4742 12.4485 21.4626C12.4527 21.4595 12.4568 21.4564 12.461 21.4532C12.4983 21.4271 12.5333 21.3978 12.5657 21.3657L12.5719 21.3611C12.5756 21.3569 12.5792 21.3528 12.5828 21.3486L22.8953 11.0361C22.9892 10.9644 23.066 10.8728 23.1203 10.768C23.1745 10.6631 23.2049 10.5475 23.2093 10.4296C23.2136 10.3116 23.1918 10.1941 23.1453 10.0855C23.0989 9.97696 23.029 9.88003 22.9407 9.80168L18.3141 4.4048C18.2452 4.27359 18.1413 4.16408 18.0138 4.08849C17.8863 4.01289 17.7404 3.97418 17.5922 3.97668ZM7.45941 5.60011H10.4438L8.31254 8.58449L7.45941 5.60011ZM13.5563 5.60011H16.5407L15.6875 8.58449L13.5563 5.60011ZM12 6.17824L14.4438 9.60011H9.55629L12 6.17824ZM6.0391 6.44855L6.9391 9.60011H3.3391L6.0391 6.44855ZM17.961 6.44855L20.661 9.60011H17.061L17.961 6.44855ZM3.53129 11.2001H7.45004L9.90004 17.5689L3.53129 11.2001ZM9.16566 11.2001H14.8344L12 18.5704L9.16566 11.2001ZM16.55 11.2001H20.4688L14.1 17.5689L16.55 11.2001Z', fill: color })));
};
var CreditIcon$1 = react.memo(CreditIcon);


//# sourceMappingURL=CreditIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/index.js
'use client';
















var InfoOverview = {
    CompanySizeIcon: CompanySizeIcon$1,
    LocationIcon: LocationIcon$1,
    EducationIcon: EducationIcon$1,
    PhoneNumberIcon: PhoneNumberIcon$1,
    CalendarIOS16GlyphICon: CalendarIOS16GlyphICon,
    AdminIcon: AdminIcon$1,
    HeadHunterIcon: HeadHunterIcon$1,
    SalaryIcon: SalaryIcon,
    AddressIcon: AddressIcon,
    GenderIcon: GenderIcon$1,
    TranslatorIcon: TranslatorIcon$1,
    BirthdayIcon: BirthdayIcon$1,
    LocationIOS16GlyphIcon: LocationIOS16GlyphIcon$1,
    CreditIcon: CreditIcon$1
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 70203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Misc; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/Link.js
'use client';




var LinkIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M17.7595 1.92188C16.6532 1.92182 15.5466 2.34346 14.7042 3.18562L12.3042 5.58562C11.108 6.78179 10.7661 8.50909 11.2692 10.0144L12.9932 8.29031C13.0652 7.79735 13.283 7.32185 13.6617 6.94312L16.0617 4.54312C16.5297 4.0756 17.1451 3.84094 17.7595 3.84094C18.3739 3.84094 18.9888 4.07512 19.4564 4.54312C20.3919 5.47913 20.3919 7.00135 19.4564 7.93687L17.0564 10.3369C16.6776 10.7156 16.2026 10.9328 15.7092 11.0053L13.9842 12.7303C14.4296 12.8791 14.8934 12.9581 15.3586 12.9581C16.465 12.9581 17.5715 12.5368 18.4139 11.6944L20.8139 9.29437C22.4987 7.61005 22.4982 4.86995 20.8139 3.18562C19.9715 2.3437 18.8658 1.92194 17.7595 1.92188ZM14.8607 8.15062C14.6113 8.15806 14.3746 8.26229 14.2007 8.44125L8.44074 14.2013C8.3486 14.2897 8.27505 14.3957 8.22437 14.5129C8.1737 14.6302 8.14693 14.7563 8.14563 14.884C8.14433 15.0118 8.16852 15.1385 8.2168 15.2567C8.26508 15.375 8.33647 15.4824 8.42678 15.5727C8.5171 15.663 8.62453 15.7344 8.74278 15.7827C8.86103 15.831 8.98772 15.8552 9.11544 15.8539C9.24316 15.8526 9.36934 15.8258 9.48658 15.7751C9.60383 15.7244 9.70978 15.6509 9.79824 15.5588L15.5582 9.79875C15.697 9.66391 15.7917 9.4903 15.8301 9.30068C15.8684 9.11106 15.8486 8.91428 15.7732 8.73611C15.6978 8.55795 15.5704 8.40672 15.4075 8.30225C15.2447 8.19777 15.0541 8.14492 14.8607 8.15062ZM8.85511 11.0512C7.67812 10.9914 6.48259 11.4076 5.58511 12.3047L3.18511 14.7047C1.5008 16.389 1.5008 19.1301 3.18511 20.8144C4.02751 21.6563 5.13357 22.0772 6.23949 22.0772C7.34541 22.0772 8.45147 21.6558 9.29386 20.8134L11.6939 18.4134C12.89 17.2173 13.2328 15.49 12.7298 13.9847L11.0048 15.7097C10.9328 16.2026 10.7151 16.6782 10.3364 17.0569L7.93637 19.4569C7.00084 20.3929 5.47814 20.3929 4.54261 19.4569C3.6071 18.5209 3.6071 16.9986 4.54261 16.0631L6.94262 13.6631C7.32133 13.2844 7.79684 13.0662 8.2898 12.9937L10.0139 11.2697C9.63755 11.1439 9.24745 11.0712 8.85511 11.0512Z', fill: color })));
};
var LinkIcon$1 = react.memo(LinkIcon);


//# sourceMappingURL=Link.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/History.js
'use client';




var HistoryIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0004 2.39998C6.70802 2.39998 2.40039 6.70761 2.40039 12C2.40039 17.2924 6.70802 21.6 12.0004 21.6C17.2928 21.6 21.6004 17.2924 21.6004 12C21.6004 8.68821 19.9187 5.76011 17.3598 4.03436L18.277 2.85779L14.4004 2.71717L15.5191 6.39998L16.3691 5.3078C18.3423 6.59772 19.7118 8.72735 19.9566 11.2015C19.7524 11.2127 19.5602 11.3017 19.4196 11.4502C19.2789 11.5987 19.2005 11.7954 19.2004 12C19.2006 12.2053 19.2796 12.4027 19.4213 12.5513C19.5629 12.6999 19.7563 12.7884 19.9613 12.7984C19.5878 16.5859 16.5863 19.5874 12.7988 19.9609C12.7888 19.7559 12.7003 19.5625 12.5517 19.4209C12.4031 19.2792 12.2057 19.2001 12.0004 19.2C11.7951 19.2001 11.5977 19.2792 11.4491 19.4209C11.3005 19.5625 11.212 19.7559 11.202 19.9609C7.41444 19.5874 4.41296 16.5859 4.03945 12.7984C4.24451 12.7884 4.43787 12.6999 4.57951 12.5513C4.72115 12.4027 4.80024 12.2053 4.80039 12C4.80024 11.7947 4.72115 11.5973 4.57951 11.4487C4.43787 11.3 4.24451 11.2116 4.03945 11.2015C4.43889 7.15115 7.84262 3.99998 12.0004 3.99998C12.1064 4.00148 12.2117 3.9819 12.31 3.94237C12.4084 3.90283 12.4979 3.84415 12.5734 3.76971C12.6489 3.69527 12.7089 3.60658 12.7498 3.50877C12.7907 3.41097 12.8118 3.306 12.8118 3.19998C12.8118 3.09396 12.7907 2.989 12.7498 2.89119C12.7089 2.79339 12.6489 2.70469 12.5734 2.63025C12.4979 2.55582 12.4084 2.49713 12.31 2.4576C12.2117 2.41807 12.1064 2.39848 12.0004 2.39998ZM11.9879 6.38905C11.776 6.39236 11.5741 6.47961 11.4264 6.63164C11.2788 6.78368 11.1975 6.98808 11.2004 7.19998V11.6L8.3207 13.7594C8.1508 13.8866 8.03839 14.0761 8.00821 14.2862C7.97803 14.4963 8.03255 14.7098 8.15977 14.8797C8.28699 15.0496 8.47649 15.162 8.68659 15.1922C8.89669 15.2223 9.11018 15.1678 9.28008 15.0406L12.4801 12.6406C12.5796 12.5661 12.6603 12.4693 12.7159 12.3581C12.7715 12.2469 12.8004 12.1243 12.8004 12V7.19998C12.8019 7.09295 12.7818 6.98671 12.7415 6.88756C12.7012 6.78841 12.6413 6.69836 12.5656 6.62274C12.4898 6.54712 12.3997 6.48748 12.3004 6.44734C12.2012 6.4072 12.0949 6.38737 11.9879 6.38905Z', fill: color })));
};
var HistoryIcon$1 = react.memo(HistoryIcon);


//# sourceMappingURL=History.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/Favorite.js
'use client';




var FavoriteIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M6.54492 1C2.92992 1 0 3.92992 0 7.54492C0 13.8373 7.29898 19.8498 10.709 22.5273C10.7122 22.53 10.7155 22.5326 10.7188 22.5352C10.7421 22.5535 10.7739 22.5796 10.7969 22.5977L10.7988 22.5957C11.1448 22.8571 11.5664 22.999 12 23C12.4343 22.9994 12.8566 22.8575 13.2031 22.5957V22.5977C13.2099 22.5924 13.2198 22.5854 13.2266 22.5801C13.2317 22.576 13.239 22.5705 13.2441 22.5664C13.2507 22.5606 13.2572 22.5547 13.2637 22.5488C16.6631 19.8809 24 13.8523 24 7.54492C24 3.92992 21.0701 1 17.4551 1C14.0001 1 12 4 12 4C12 4 9.99992 1 6.54492 1Z', fill: color })));
};
var FavoriteIcon$1 = react.memo(FavoriteIcon);


//# sourceMappingURL=Favorite.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/UnFavorite.js
'use client';




var UnFavoriteIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M6.96454 1C3.12884 1 0 4.12884 0 7.96454C0 11.4152 2.67743 14.9244 5.22476 17.7254C7.77209 20.5264 10.3125 22.5715 10.3125 22.5715C10.3202 22.5777 10.328 22.5837 10.3359 22.5895C10.7472 22.9001 11.2632 23.102 11.8233 23.1394C11.8816 23.1499 11.9408 23.1547 12 23.1538C12.0586 23.1546 12.1172 23.1498 12.1749 23.1394C12.1779 23.1388 12.1809 23.1382 12.1839 23.1376C12.7412 23.0989 13.2546 22.8988 13.6641 22.5895C13.672 22.5837 13.6798 22.5777 13.6875 22.5715C13.6875 22.5715 16.2279 20.5264 18.7752 17.7254C21.3226 14.9244 24 11.4152 24 7.96454C24 4.12884 20.8712 1 17.0355 1C14.6225 1 12.9138 2.32789 12 3.26803C11.0862 2.32789 9.3775 1 6.96454 1ZM6.96454 2.84615C9.48566 2.84615 11.0195 4.91611 11.1725 5.13041C11.2506 5.28083 11.3687 5.40684 11.5137 5.49461C11.6587 5.58238 11.8251 5.62854 11.9946 5.62801C12.0018 5.62809 12.009 5.62809 12.0162 5.62801C12.0234 5.62749 12.0307 5.62689 12.0379 5.6262C12.0614 5.6253 12.0848 5.62349 12.1082 5.62079C12.2582 5.60433 12.4019 5.55135 12.5266 5.46649C12.6514 5.38163 12.7535 5.26747 12.8239 5.13401C12.9692 4.93001 14.5072 2.84615 17.0355 2.84615C19.8736 2.84615 22.1538 5.1264 22.1538 7.96454C22.1538 10.3671 19.8459 13.8032 17.4087 16.4832C14.9797 19.1541 12.561 21.105 12.5445 21.1184C12.3824 21.239 12.2022 21.3077 12 21.3077C11.7978 21.3077 11.6176 21.239 11.4555 21.1184C11.439 21.105 9.02034 19.1541 6.59135 16.4832C4.15406 13.8032 1.84615 10.3671 1.84615 7.96454C1.84615 5.1264 4.1264 2.84615 6.96454 2.84615Z', fill: color })));
};
var UnFavoriteIcon$1 = react.memo(UnFavoriteIcon);


//# sourceMappingURL=UnFavorite.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/ProductDocuments.js
'use client';




var ProductDocumentsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5.60039 2.39998C5.49438 2.39848 5.38913 2.41807 5.29076 2.4576C5.19238 2.49713 5.10284 2.55582 5.02735 2.63025C4.95185 2.70469 4.8919 2.79339 4.85099 2.89119C4.81007 2.989 4.789 3.09396 4.789 3.19998C4.789 3.306 4.81007 3.41097 4.85099 3.50877C4.8919 3.60658 4.95185 3.69527 5.02735 3.76971C5.10284 3.84415 5.19238 3.90283 5.29076 3.94237C5.38913 3.9819 5.49438 4.00148 5.60039 3.99998H18.4004C18.5064 4.00148 18.6117 3.9819 18.71 3.94237C18.8084 3.90283 18.8979 3.84415 18.9734 3.76971C19.0489 3.69527 19.1089 3.60658 19.1498 3.50877C19.1907 3.41097 19.2118 3.306 19.2118 3.19998C19.2118 3.09396 19.1907 2.989 19.1498 2.89119C19.1089 2.79339 19.0489 2.70469 18.9734 2.63025C18.8979 2.55582 18.8084 2.49713 18.71 2.4576C18.6117 2.41807 18.5064 2.39848 18.4004 2.39998H5.60039ZM5.60039 5.59998C4.72594 5.59998 4.00039 6.32553 4.00039 7.19998V12H5.60039V7.19998H18.4004V12H20.0004V7.19998C20.0004 6.32553 19.2748 5.59998 18.4004 5.59998H5.60039ZM2.40039 13.6V19.2C2.40039 20.5256 3.47479 21.6 4.80039 21.6H19.2004C20.526 21.6 21.6004 20.5256 21.6004 19.2V13.6H14.2535C13.9231 14.5304 13.0436 15.2 12.0004 15.2C10.9572 15.2 10.0777 14.5304 9.74727 13.6H2.40039Z', fill: color })));
};
var ProductDocumentsIcon$1 = react.memo(ProductDocumentsIcon);


//# sourceMappingURL=ProductDocuments.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/Star.js
'use client';




var StarIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.6128 1.94722L14.9128 8.75682L22.0992 8.84002C22.7176 8.84722 22.9736 9.63522 22.4776 10.004L16.712 14.2952L18.8536 21.156C19.0376 21.7464 18.368 22.2328 17.8632 21.8752L12.0008 17.7176L6.13763 21.8744C5.63363 22.232 4.96323 21.7448 5.14723 21.1552L7.28883 14.2944L1.52323 10.0032C1.02723 9.63442 1.28323 8.84642 1.90163 8.83922L9.08803 8.75602L11.388 1.94642C11.5864 1.36082 12.4152 1.36082 12.6128 1.94722Z', fill: color })));
};
var StarIcon$1 = react.memo(StarIcon);


//# sourceMappingURL=Star.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/index.js
'use client';








var Misc = {
    LinkIcon: LinkIcon$1,
    HistoryIcon: HistoryIcon$1,
    FavoriteIcon: FavoriteIcon$1,
    UnFavoriteIcon: UnFavoriteIcon$1,
    ProductDocumentsIcon: ProductDocumentsIcon$1,
    StarIcon: StarIcon$1
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 29451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WarnIcon$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33089);
'use client';




var WarnIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.fill, fill = _c === void 0 ? _Colors_index_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.yellow[40] */ .O9.yellow[40] : _c;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: size, height: size, viewBox: "0 0 ".concat(size, " ").concat(size), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: "WarningIconSVG" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { id: "Vector", d: "M7.99998 1.6001C7.55648 1.6001 7.17655 1.87035 7.01561 2.25531L1.22707 12.2386V12.2397C1.1226 12.408 1.06705 12.602 1.06665 12.8001C1.06665 13.083 1.17903 13.3543 1.37907 13.5543C1.57911 13.7544 1.85042 13.8668 2.13332 13.8668C2.15835 13.8666 2.18336 13.8656 2.20832 13.8636L2.2104 13.8668H7.99998H13.7896L13.7916 13.8626C13.8166 13.8649 13.8416 13.8663 13.8666 13.8668C14.1495 13.8668 14.4209 13.7544 14.6209 13.5543C14.8209 13.3543 14.9333 13.083 14.9333 12.8001C14.9331 12.6017 14.8776 12.4072 14.7729 12.2386L14.7646 12.2241C14.7642 12.2237 14.7639 12.2234 14.7635 12.223L8.98436 2.25531C8.82342 1.87035 8.44349 1.6001 7.99998 1.6001ZM7.35311 6.05843H8.64686L8.53957 9.51051H7.4604L7.35311 6.05843ZM8.00207 10.5657C8.44047 10.5657 8.70311 10.8016 8.70311 11.2043C8.70311 11.5995 8.44047 11.8345 8.00207 11.8345C7.56047 11.8345 7.29582 11.5995 7.29582 11.2043C7.29582 10.8016 7.55993 10.5657 8.00207 10.5657Z", fill: fill }))));
};
var WarnIcon$1 = react__WEBPACK_IMPORTED_MODULE_0__.memo(WarnIcon);


//# sourceMappingURL=WarnIcon.js.map


/***/ }),

/***/ 97228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A_": function() { return /* binding */ IconDeleteGrey; },
/* harmony export */   "C2": function() { return /* binding */ IconChevronDown; },
/* harmony export */   "D6": function() { return /* binding */ IconArrowLeft; },
/* harmony export */   "NO": function() { return /* binding */ IconCheck; },
/* harmony export */   "N_": function() { return /* binding */ IconAdd; },
/* harmony export */   "Tg": function() { return /* binding */ NavIcons; },
/* harmony export */   "Uc": function() { return /* binding */ IconError; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "jV": function() { return /* binding */ IconSearch; },
/* harmony export */   "k$": function() { return /* binding */ IconDeleteWhite; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';




var IconArrowLeft = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 50 : _b, _c = _a.height, height = _c === void 0 ? 50 : _c, _d = _a.fill, fill = _d === void 0 ? 'unset' : _d, _e = _a.stroke, stroke = _e === void 0 ? 'unset' : _e, _f = _a.className, className = _f === void 0 ? '' : _f;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, fill: fill, className: className, stroke: stroke, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M 19.8125 13.09375 C 19.59375 13.132813 19.398438 13.242188 19.25 13.40625 L 8.34375 24.28125 L 7.65625 25 L 8.34375 25.71875 L 19.25 36.59375 C 19.492188 36.890625 19.878906 37.027344 20.253906 36.941406 C 20.625 36.855469 20.917969 36.5625 21.003906 36.191406 C 21.089844 35.816406 20.953125 35.429688 20.65625 35.1875 L 11.46875 26 L 41 26 C 41.359375 26.003906 41.695313 25.816406 41.878906 25.503906 C 42.058594 25.191406 42.058594 24.808594 41.878906 24.496094 C 41.695313 24.183594 41.359375 23.996094 41 24 L 11.46875 24 L 20.65625 14.8125 C 20.980469 14.511719 21.066406 14.035156 20.871094 13.640625 C 20.679688 13.242188 20.246094 13.023438 19.8125 13.09375 Z' })));
};
var IconSearch = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fill, fill = _d === void 0 ? '#333333' : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 21 20', fill: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M8.87958 1.6665C5.05481 1.6665 1.93933 4.78198 1.93933 8.60676C1.93933 12.4315 5.05481 15.547 8.87958 15.547C10.5428 15.547 12.0703 14.9564 13.2674 13.976L17.4112 18.1198C17.4752 18.1864 17.5518 18.2396 17.6365 18.2762C17.7213 18.3128 17.8125 18.3322 17.9048 18.3331C17.9972 18.3341 18.0888 18.3166 18.1743 18.2817C18.2597 18.2468 18.3374 18.1952 18.4027 18.1299C18.468 18.0646 18.5196 17.9869 18.5545 17.9014C18.5894 17.8159 18.6069 17.7243 18.606 17.632C18.605 17.5397 18.5857 17.4485 18.549 17.3637C18.5124 17.2789 18.4592 17.2023 18.3926 17.1384L14.2488 12.9946C15.2292 11.7975 15.8198 10.27 15.8198 8.60676C15.8198 4.78198 12.7044 1.6665 8.87958 1.6665ZM8.87958 3.05455C11.9542 3.05455 14.4318 5.53214 14.4318 8.60676C14.4318 11.6814 11.9542 14.159 8.87958 14.159C5.80497 14.159 3.32738 11.6814 3.32738 8.60676C3.32738 5.53214 5.80497 3.05455 8.87958 3.05455Z', fill: fill })));
};
var IconCheck = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.stroke, stroke = _e === void 0 ? '#ffffff' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", { id: 'filter-selected-tag' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/icon-forms/icon-check', stroke: stroke, strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { filter: 'url(#filter-selected-tag)', id: 'icons8-checkmark-(5)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(5.000000, 6.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polyline", { id: 'Path', stroke: stroke, strokeWidth: '1.6', points: '0 7.7248 5.5684 12.5392 13.6 0.2608' }))))));
};
var IconClose = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 50 50' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M9.156 6.313L6.312 9.155 22.157 25 6.22 40.969 9.03 43.78 25 27.844 40.938 43.78l2.843-2.843L27.844 25 43.687 9.156l-2.843-2.844L25 22.157z' })));
};
var IconError = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 50 50' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M49.777 45.348L25.867 3.93c-.36-.618-1.375-.618-1.734 0l-24 41.57a1.014 1.014 0 000 1c.18.309.512.5.867.5h48.02c.554 0 1-.445 1-1 0-.25-.09-.477-.243-.652zM23.492 19.266c0-.215.145-.36.36-.36h2.296c.215 0 .356.145.356.36v14.46c0 .215-.14.36-.356.36h-2.296c-.215 0-.36-.145-.36-.36zm3.086 20.672c0 .214-.144.355-.355.355H23.78c-.215 0-.355-.145-.355-.355v-2.622c0-.214.144-.355.355-.355h2.442c.215 0 .355.14.355.355z' })));
};
var IconDeleteWhite = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.stroke, stroke = _e === void 0 ? '#ffffff' : _e, _f = _a.onClick, onClick = _f === void 0 ? function (e) { } : _f;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/icon-forms/icon-remove-w', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { id: 'Oval', stroke: stroke, cx: '12', cy: '12', r: '7.5' }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Group-5', transform: 'translate(9.000000, 9.000000)', stroke: stroke, strokeLinecap: 'round', strokeLinejoin: 'round' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Group-4', transform: 'translate(3.000000, 0.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polyline", { id: 'Stroke-718', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ', points: '0 0 3 3 0 6' })),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'Group-4', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polyline", { id: 'Stroke-718', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ', points: '0 0 3 3 0 6' }))))));
};
var IconDeleteGrey = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32 32', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", { id: 'filter-delete-formModal' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { id: 'icons/action/icon-delete/size-m', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { filter: 'url(#filter-delete-formModal)', id: 'icons8-trash-can-(3)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(8.000000, 5.000000)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M5.28,2.4 L5.28,0.96 C5.28,0.432 5.712,0 6.24,0 L10.08,0 C10.608,0 11.04,0.432 11.04,0.96 L11.04,2.4 M0,2.4 L16.32,2.4 M8.16,5.76 L8.16,17.76 M11.04,5.76 L11.04,17.76 M5.28,5.76 L5.28,17.76', id: 'Shape', stroke: '#000000', strokeWidth: '0.96' }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M15.36,2.4 L15.36,20.16 C15.36,20.688 14.928,21.12 14.4,21.12 L1.92,21.12 C1.392,21.12 0.96,20.688 0.96,20.16 L0.96,2.4', id: 'Path', stroke: '#000000', strokeWidth: '0.96' }))))));
};
var IconChevronDown = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, rest = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["width", "height", "className", "onClick"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 30 30', onClick: onClick }, rest),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M3 12v-2a1.002 1.002 0 011.634-.774L15 17.708l10.367-8.482A1.001 1.001 0 0127 10v2a1 1 0 01-.367.774l-11 9a1.002 1.002 0 01-1.267 0l-11-9A1.003 1.003 0 013 12z' })));
};
var IconAdd = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? 'currentColor' : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 50 50', className: className, style: { fill: fill } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M25 2C12.264 2 2 12.264 2 25s10.264 23 23 23 23-10.264 23-23S37.736 2 25 2zm0 2c11.664 0 21 9.336 21 21s-9.336 21-21 21S4 36.664 4 25 13.336 4 25 4zm-1 9v11H13v2h11v11h2V26h11v-2H26V13h-2z' })));
};
var IconSpeedometer = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, viewBox: '0 0 32.0 32.0', className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-speedometer-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M11.197422,0 C17.385422,0 22.3948437,5.07733333 22.3948437,11.3333333 L22.3722654,11.9 L22.3722654,11.9907553 C22.3495988,12.1720886 22.3493336,12.330578 22.3266669,12.4892447 L22.3266669,12.511823 C22.0546669,15.0731563 20.944177,17.476177 19.1081773,19.3348437 C19.1081773,19.3575104 19.0852449,19.3573333 19.0625783,19.38 C17.0452449,21.42 14.257422,22.6666667 11.197422,22.6666667 C8.13742197,22.6666667 5.34959899,21.42 3.33226566,19.38 L3.28666667,19.3348437 C1.45066667,17.476177 0.340177259,15.095823 0.0681772586,12.511823 L0.0681772586,12.4892447 C0.045510592,12.3079114 0.022578272,12.149422 0.022578272,11.9907553 L0.022578272,11.9 C0,11.7186667 0,11.5373333 0,11.3333333 C0,5.07733333 5.00942197,0 11.197422,0 Z M11.197422,4.03484369 C7.20808863,4.03484369 3.98924494,7.29866667 3.98924494,11.3333333 C3.98924494,13.2826667 4.73742197,15.1188437 6.09742197,16.5015104 C6.36942197,16.7735104 6.36942197,17.1813333 6.09742197,17.4533333 L4.73742197,18.8359114 C6.4827553,20.3772449 8.7267553,21.3066667 11.197422,21.3066667 C13.6680886,21.3066667 15.9120886,20.3772449 17.657422,18.8359114 L16.297422,17.4533333 C16.025422,17.1813333 16.025422,16.7735104 16.297422,16.5015104 C17.657422,15.1188437 18.405599,13.2826667 18.405599,11.3333333 C18.405599,7.29866667 15.1867553,4.03484369 11.197422,4.03484369 Z M13.26,18.088177 C13.6453333,18.088177 13.9625783,18.3828437 13.9625783,18.768177 C13.9625783,19.1535104 13.6679116,19.448177 13.2825783,19.448177 L9.13484393,19.448177 C8.74951059,19.448177 8.45484393,19.1535104 8.45484393,18.768177 C8.45484393,18.3828437 8.74951059,18.088177 9.13484393,18.088177 Z M11.197422,1.36 C5.78008863,1.36 1.36000001,5.82533333 1.36000001,11.3333333 C1.36000001,11.5146667 1.38257827,11.6731563 1.38257827,11.831823 L1.38257827,11.968177 C1.38257827,12.0815104 1.38293233,12.217422 1.40559899,12.3307553 C1.42826566,12.353422 1.42817726,12.3987553 1.42817726,12.4440886 C1.45084393,12.557422 1.4507553,12.6933333 1.4507553,12.8066667 C1.47342197,12.8293333 1.47333334,12.8747553 1.47333334,12.897422 C1.49600001,13.0560886 1.51884393,13.192177 1.54151059,13.328177 L1.54151059,13.3507553 C1.90417726,15.0507553 2.67457827,16.592177 3.76257827,17.8615104 L4.66924494,16.9548437 C3.35457827,15.3908437 2.62924494,13.4186667 2.62924494,11.3333333 C2.62924494,6.55066667 6.46008863,2.67484369 11.197422,2.67484369 C15.9347553,2.67484369 19.7655988,6.55066667 19.7655988,11.3333333 L21.0348437,11.3333333 C21.0348437,5.82533333 16.6147553,1.36 11.197422,1.36 Z M15.4500783,6.3325 C15.6229116,6.32966667 15.7988439,6.39217703 15.9348439,6.52817703 C16.2068439,6.80017703 16.2068439,7.23066667 15.9348439,7.48 L13.305599,10.1548437 C13.4869323,10.5175104 13.6,10.9026667 13.6,11.3333333 C13.6,12.6706667 12.5347553,13.7584896 11.197422,13.7584896 C9.86008863,13.7584896 8.79484393,12.6706667 8.79484393,11.3333333 C8.79484393,9.996 9.86008863,8.90817703 11.197422,8.90817703 C11.6280886,8.90817703 12.0133333,9.02124471 12.3533333,9.20257804 L14.9825783,6.52817703 C15.1072449,6.40351036 15.2772449,6.33533333 15.4500783,6.3325 Z M11.197422,10.268177 C10.6307553,10.268177 10.1548439,10.744 10.1548439,11.3333333 C10.1548439,11.9226667 10.6080886,12.3984896 11.197422,12.3984896 C11.7867553,12.3984896 12.24,11.9226667 12.24,11.3333333 C12.24,10.744 11.7640886,10.268177 11.197422,10.268177 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(4.666666666666668 4.666666666666668)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(0.13591136803800552 0.0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-speedometer-i0)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '0,0 22.3948437,0 22.3948437,22.6666667 0,22.6666667 0,0', stroke: 'none', fill: fill }))))));
};
var IconPerson = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M10.4267652,14.0487805 C14.6934319,14.0487805 18.6477002,16.3641259 20.7550175,20.0584351 C20.9631476,20.4226628 20.8331678,20.9168702 20.4689401,21.1250003 C20.1047125,21.3331304 19.610505,21.2031506 19.4023749,20.8389229 C17.5552205,17.6129064 14.1210741,15.6097561 10.4267652,15.6097561 C6.73245624,15.6097561 3.29820818,17.6129064 1.47706997,20.8389229 C1.34698867,21.0990855 1.06091153,21.2291668 0.800748928,21.2291668 C0.670667627,21.2291668 0.540586326,21.2030491 0.410505025,21.1250003 C0.0202611227,20.9168702 -0.109616991,20.4226628 0.0985130901,20.0584351 C2.20583016,16.3641259 6.16009852,14.0487805 10.4267652,14.0487805 Z M10.4267652,0 C13.7308302,0 16.410505,2.6796748 16.410505,5.98373984 C16.410505,9.28780488 13.7308302,11.9674797 10.4267652,11.9674797 C7.12270015,11.9674797 4.44302535,9.28780488 4.44302535,5.98373984 C4.44302535,2.6796748 7.12270015,0 10.4267652,0 Z M10.4267652,1.56097561 C7.98123673,1.56097561 6.00400096,3.53821138 6.00400096,5.98373984 C6.00400096,8.42926829 7.98123673,10.4065041 10.4267652,10.4065041 C12.8722936,10.4065041 14.8495294,8.42926829 14.8495294,5.98373984 C14.8495294,3.53821138 12.8722936,1.56097561 10.4267652,1.56097561 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(5.333333333333334 5.333333333333334)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(0.23990147896259373 0.0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-i0)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '-1.38777878e-17,0 20.8543723,0 20.8543723,21.2291668 -1.38777878e-17,21.2291668 -1.38777878e-17,0', stroke: 'none', fill: fill }))))));
};
var IconPersonSetting = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-setting-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M7.60977029,0 C7.89866969,0 8.16120308,0.155555556 8.29252098,0.388888889 L10.5777599,4.27777778 C10.7353413,4.51111111 10.7353413,4.82222222 10.5777599,5.05555556 L8.29252098,8.94444444 C8.16120308,9.17777778 7.89866969,9.33333333 7.60977029,9.33333333 L3.06647825,9.33333333 C2.77757886,9.33333333 2.5145328,9.17777778 2.3832149,8.94444444 L0.0984884304,5.05555556 C-0.0328294768,4.82222222 -0.0328294768,4.51111111 0.0984884304,4.27777778 L2.3832149,0.388888889 C2.5145328,0.155555556 2.77757886,0 3.06647825,0 Z M5.35120472,1.79487179 C3.73498432,1.79487179 2.44200801,3.07122507 2.44200801,4.66666667 C2.44200801,6.26210826 3.73498432,7.53846154 5.35120472,7.53846154 C6.96742511,7.53846154 8.26040143,6.26210826 8.26040143,4.66666667 C8.26040143,3.07122507 6.96742511,1.79487179 5.35120472,1.79487179 Z' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-setting-i1' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-setting-i2' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(3.9999999999999982 4.666666666666666)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(13.815912984942466 13.929395790902763)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-setting-i0)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '-1.38777878e-17,0 10.695946,0 10.695946,9.33333333 -1.38777878e-17,9.33333333 -1.38777878e-17,0', stroke: 'none', fill: fill }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(3.969203456768203 0.0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-setting-i1)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(0.0 12.548185612648314)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-setting-i2)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 1.38777878e-17,6.41342647 1.38777878e-17,0', stroke: 'none', fill: fill }))))));
};
var IconPersonSearch = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-search-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M6,0 C9.27807674,0 11.4896334,3.07568764 11.8590524,3.62591191 L11.9049635,3.69565436 L11.9132812,3.70872605 C11.9697136,3.77924814 12,3.86549131 12,3.95432692 C12,4.03084279 11.9774041,4.10569494 11.9351564,4.1698069 C11.9069304,4.2227233 9.9755288,7.90865385 6,7.90865385 C2.00753252,7.90865385 0.073283712,4.18615369 0.066406248,4.17212374 C0.0225959989,4.10569496 0,4.03084281 0,3.95432692 C0,3.86513448 0.0306213566,3.77858185 0.086718752,3.70872605 C0.0878451439,3.7069335 0.0906242819,3.70252877 0.0950364322,3.69565436 L0.140947612,3.62591191 C0.510366601,3.07568764 2.72192326,0 6,0 Z M6,1.18629808 C4.4536,1.18629808 3.2,2.42558413 3.2,3.95432692 C3.2,5.48306971 4.4536,6.72235577 6,6.72235577 C7.5464,6.72235577 8.8,5.48306971 8.8,3.95432692 C8.8,2.42558413 7.5464,1.18629808 6,1.18629808 Z M6,2.76802885 C6.6627417,2.76802885 7.2,3.29915259 7.2,3.95432692 C7.2,4.60950126 6.6627417,5.140625 6,5.140625 C5.3372583,5.140625 4.8,4.60950126 4.8,3.95432692 C4.8,3.29915259 5.3372583,2.76802885 6,2.76802885 Z' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-search-i1' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-search-i2' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(4.0 4.666666666666668)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(12.018945570341808 14.67299297779452)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-search-i0)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '0,0 12,0 12,7.90865385 0,7.90865385 0,0', stroke: 'none', fill: fill }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(3.969203456768202 0.0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-search-i1)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(0.0 12.548185612648314)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-search-i2)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '-1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 -1.38777878e-17,6.41342647 -1.38777878e-17,0', stroke: 'none', fill: fill }))))));
};
var IconBriefcase = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 47 : _b, _c = _a.height, height = _c === void 0 ? 53 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { version: '1.1', width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-briefcase-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M22.0251572,13.2578616 C22.3886792,13.2578616 22.6666667,13.5358491 22.6666667,13.8993711 L22.6666667,19.8867925 C22.6666667,21.4264151 21.4264151,22.6666667 19.8867925,22.6666667 L2.77987421,22.6666667 C1.24025157,22.6666667 0,21.4264151 0,19.8867925 L0,13.8993711 C0,13.5358491 0.277987421,13.2578616 0.641509434,13.2578616 C1.00503145,13.2578616 1.28301887,13.5358491 1.28301887,13.8993711 L1.28301887,19.8867925 C1.28301887,20.7207547 1.94591195,21.3836478 2.77987421,21.3836478 L19.8867925,21.3836478 C20.7207547,21.3836478 21.3836478,20.7207547 21.3836478,19.8867925 L21.3836478,13.8993711 C21.3836478,13.5358491 21.6616352,13.2578616 22.0251572,13.2578616 Z M19.8867925,4.27672956 C21.4264151,4.27672956 22.6666667,5.51698113 22.6666667,7.05660377 L22.6666667,10.6918239 C22.6666667,10.927044 22.5383648,11.1194132 22.3459119,11.2477151 C18.9459119,13.2791617 15.1396226,14.305744 11.3333333,14.305744 C7.52704403,14.305744 3.72075472,13.2791617 0.320754717,11.2477151 C0.128301887,11.1194132 0,10.927044 0,10.6918239 L0,7.05660377 C0,5.51698113 1.24025157,4.27672956 2.77987421,4.27672956 Z M19.8867925,5.55974843 L2.77987421,5.55974843 C1.94591195,5.55974843 1.28301887,6.22264151 1.28301887,7.05660377 L1.28301887,10.3284689 C7.50566038,13.9209217 15.1610063,13.9209217 21.3836478,10.3284689 L21.3836478,7.05660377 C21.3836478,6.22264151 20.7207547,5.55974843 19.8867925,5.55974843 Z M13.0440252,0 C14.5836478,0 15.8238994,1.24025157 15.8238994,2.77987421 C15.8238994,3.14339623 15.5459119,3.42138365 15.1823899,3.42138365 C14.8188679,3.42138365 14.5408805,3.14339623 14.5408805,2.77987421 C14.5408805,1.94591195 13.8779874,1.28301887 13.0440252,1.28301887 L9.62264151,1.28301887 C8.78867925,1.28301887 8.12578616,1.94591195 8.12578616,2.77987421 C8.12578616,3.14339623 7.84779874,3.42138365 7.48427673,3.42138365 C7.12075472,3.42138365 6.8427673,3.14339623 6.8427673,2.77987421 C6.8427673,1.24025157 8.08301887,0 9.62264151,0 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(4.666666666666668 4.666666666666668)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-briefcase-i0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '0,0 22.6666667,0 22.6666667,22.6666667 0,22.6666667 0,0', stroke: 'none', fill: fill })))));
};
var IconBell = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 47 : _b, _c = _a.height, height = _c === void 0 ? 53 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-bell-i0' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M8.77473001,0.000231813462 C9.59335403,-0.0140999131 10.2685233,0.637903475 10.2827699,1.45652898 L10.2934067,2.06773459 C14.0182869,2.70154063 16.8981339,5.91668492 16.9662047,9.8281184 L17.0544849,14.9008281 C17.0721746,15.9172824 17.3204742,16.916495 17.7824252,17.8217302 L18.0675387,18.3786578 C18.533203,19.2924754 17.8420335,20.4442062 16.8160383,20.4621683 L12.4254066,20.5390359 C12.8407052,21.7390334 12.5888646,23.1276782 11.6514871,24.098361 C10.3249929,25.471986 8.11171323,25.5107341 6.73823119,24.1843779 C5.7678885,23.2473288 5.46734451,21.8686479 5.84020943,20.6550619 L1.45105418,20.7319034 C0.424625929,20.7498732 -0.306760373,19.6228291 0.127793618,18.6919922 L0.330682327,18.2579553 C0.801654463,17.2502044 1.03605946,16.1485804 1.01669922,15.036139 L0.930211326,10.1088621 C0.89176499,7.89968813 1.75736866,5.87970185 3.18416119,4.40221493 C4.28356357,3.26375044 5.71851736,2.45218991 7.32891811,2.11963409 L7.31828135,1.50842856 C7.30403478,0.68980305 7.95647736,0.0141789799 8.77473001,0.000231813462 Z M11.4822968,20.5749025 L7.0297131,20.5749025 C6.91400097,20.8565852 6.85019346,21.1650738 6.85019346,21.4884655 C6.85019346,22.8171585 7.92731196,23.894277 9.25600496,23.894277 C10.584698,23.894277 11.6618165,22.8171585 11.6618165,21.4884655 C11.6618165,21.1650738 11.5980089,20.8565852 11.4822968,20.5749025 Z M1.91947107,17.1571744 C1.76545999,17.7438532 1.55811546,18.3165282 1.29198736,18.8650468 L1.19820143,19.0594803 L16.9065763,19.133899 L16.7422173,18.7981661 C16.4932705,18.2922852 16.305085,17.7633867 16.1572616,17.223917 L1.91947107,17.1571744 Z M8.97217689,3.2956275 C7.10646658,3.28586434 5.42563457,4.02789941 4.21382026,5.23971372 C3.00200595,6.45152802 2.25997088,8.13236003 2.26973404,9.99807035 L2.29604734,15.1746492 C2.2973268,15.4191508 2.2857886,15.6630526 2.26807768,15.9057964 L15.7977662,15.9765965 C15.783979,15.7844985 15.7748141,15.5918406 15.7738039,15.398726 L15.7451358,10.0685864 C15.7256095,6.33716574 12.7035975,3.31515381 8.97217689,3.2956275 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(6.666666666666666 3.333333333333334)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-bell-i0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '-1.20192745e-12,1.53866991e-14 18.2156673,1.53866991e-14 18.2156673,25.1544028 -1.20192745e-12,25.1544028 -1.20192745e-12,1.53866991e-14', stroke: 'none', fill: fill })))));
};
var IconPersonPassword = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("pattern", { id: 'icon-person-password-i0', patternUnits: 'userSpaceOnUse', x: '0px', y: '0px', width: '8.83809524px', height: '10.6666667px' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("image", { width: '8.83809524px', height: '10.6666667px', preserveAspectRatio: 'none', xlinkHref: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABgCAYAAACKa/UAAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAUKADAAQAAAABAAAAYAAAAACQwfTJAAAE/UlEQVR4Ae2dy2vUUBTGW6U+sAi684VYxQpW8QGKbqyCCurOgntRUHQr+jdIi+7duRBfIOgouBDxWbUPEBR8bHwsXFgLVkUFX9+XmunNmZlO5p7MJGnPgc/Jvcm599zfnCQ3mSY2N2XD2hFGJ7QGWg4thuZCrRDtKzQMvYVeQk+h29AraNLaaoy8B3oP/fXUO/h1Q2xrUlgzRrkbegD5Qqvkdx9t7oLYx4S09RjVY6gSgKTqe9HHuolEcAYGcxr6BVWCNIJ116Hj0B6Ix8Q5UMt/cZl1XMdtbkBfoErtsa9T0HQo17YM0Q9C5Qb6B/UFaC/kM1B+MV0QwbOtcn0MoH4plEvbhKg/QXJgHOx5qANKylahoYuQ7IvlIWgjlCvbgWg59ZADeoG6Tqhetg0Nc5oj+2Us2+vVadLtbkCD5eCdRX1r0p2VaW8m6s5AEuI31G0us32mqnjMk7std9ljKUR5An3KY+NH1LWlEEusLnlQlycMDuBALO/6bHQQzUqIfajzOWnVJ0KnVU5V5G6TRuY5IQWLnPbIuLrlRmmXOUmW87xzaQfl9M/jrwuRsa511qe6yEsneYXBs+2sVKOKds6TF288uBB56ZcJ47WtGxiXOZ3Imm1BQPJ4uDMLQcobA5wkZ9UuITD3y76bdqAdIiB+w6zLqq1EYL8hFyKvYlKzHvTsBlNILZL4HfNGhBvzyfiuyW8pb4Z2Jd9F4i3uQ4suwDeJ9xCzwXYRCG9JZXKCKsbDSz15qckrKC+b4uU16rRV+N5D+aeoy2LxO4KSUxjvWYMGoPwdIvUzWg3f1h2xrRyLWF25qAG4QjT7TJSzXHwuguPhyMs0AJeIHl+LcpaL8ufQNt9gNQBni06HRDnLRRmrHEtDYucJw50OTGtIr8l0wtmCG/sP32Z5I8DXGIBrmrbcdhq1nEj8ml24UQPNdD8GUPn1GEADqCSgdLcMNIBKAkp3y0ADqCSgdLcMNIBKAkp3y8AEAfJmwFHoESRvebsX3uGy7Dqsz8tnrfGTSS90BCq5cTIflYNQXgafdpwDYDUPCow0DV7tydMPbi1T8c9haD9kVhsB7rUf6MJjnrtLXEWZK82iBBageA1yWT3kJvJxAW5oVp7AQlS7AEd4F5kVruXtzrIbeyOWI7xsHqhEbgANoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t03Axeh38sQHzCkrkC1PO2Td38Md8zcX5kiP5iMbRJZ4uDlu2HoNwxxXTXLu38Jr5KKKgSYedInLPP9VdUs7/7hWMPPEhjVAHCXDZ3l5+dqzlifd//ImH2PgZU4sXGN5c7fB+CtcQjdHGdduCrv/uE4ip+RlCzWVl7g2ZYnDOk3hDr+6UM1y7u/HHcJiGoAuJ5nUp4weMyjLkBx4GGzwPLsHwFofxsTfqXxPwmwaD7HwKKzLTQ1GUBlFhhAA6gkoHS3DDSASgJKd8tAA6gkoHS3DDSASgJKd8tAA6gkoHS3DDSASgJKd8tAA6gkoHS3DEwAIB93dc0ed3VpRJflzxYBO/nANR8qNohRcCwRXgFyfxMJHrjmWyjcSluOz+MQ2AWv8OBbKAxcbQyegBn/48DA+AqPfsggxmPQB1bF154EBPEPafINHvz/QeR7FAzsKBOy4W5bzLx/cIr0XT4zV84AAAAASUVORK5CYII=' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-password-i1' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: 'icon-person-password-i2' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(4.666666666666666 4.666666666666666)' },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(14.443906380247428 11.402298850574574)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '0,0 8.83809524,0 8.83809524,10.6666667 0,10.6666667 0,0', stroke: 'none', fill: 'url(#icon-person-password-i0)', opacity: '69.9999988%' })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(3.969203456768202 0.0)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-password-i1)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { transform: 'translate(0.0 12.548185612648314)' },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: 'url(#icon-person-password-i2)' },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", { points: '-1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 -1.38777878e-17,6.41342647 -1.38777878e-17,0', stroke: 'none', fill: fill }))))));
};
var NavIcons = {
    IconSpeedometer: IconSpeedometer,
    IconPerson: IconPerson,
    IconPersonSetting: IconPersonSetting,
    IconPersonSearch: IconPersonSearch,
    IconBriefcase: IconBriefcase,
    IconBell: IconBell,
    IconPersonPassword: IconPersonPassword
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 71567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AIBanner": function() { return /* reexport */ AIBanner; },
  "AIBeforeApply": function() { return /* reexport */ AIBeforeApply; },
  "AICircleProgressBar": function() { return /* reexport */ AICircleProgressBar; },
  "AIReviewCV": function() { return /* reexport */ AIReviewCV; },
  "Accordion": function() { return /* reexport */ Accordion/* default */.Z; },
  "AdrTurboBanner": function() { return /* reexport */ AdrTurboBanner; },
  "Alert": function() { return /* reexport */ Alert/* default */.Z; },
  "Anchor": function() { return /* reexport */ Variant/* Anchor */.ee; },
  "ApplyJobs": function() { return /* reexport */ ApplyJobs/* default */.ZP; },
  "ApplyJobsForm": function() { return /* reexport */ ApplyJobsForm$1; },
  "ApplyJobsModal": function() { return /* reexport */ ApplyJobsModal; },
  "AspectRatio": function() { return /* reexport */ AspectRatio; },
  "AttachName": function() { return /* reexport */ AttachName; },
  "AutoComplete": function() { return /* reexport */ AutoComplete; },
  "Avatar": function() { return /* reexport */ Avatar/* default */.Z; },
  "BREAKPOINTS": function() { return /* reexport */ LayoutSystem_constants/* BREAKPOINTS */.j$; },
  "BarChart": function() { return /* reexport */ BarChart; },
  "BottomSheet": function() { return /* reexport */ BottomSheet/* default */.Z; },
  "Button": function() { return /* reexport */ Button/* default */.Z; },
  "ButtonAI": function() { return /* reexport */ ButtonAI; },
  "ButtonPrimary": function() { return /* reexport */ ButtonPrimary; },
  "ButtonViewMore": function() { return /* reexport */ ButtonViewMore/* default */.Z; },
  "Calendar": function() { return /* reexport */ Calendar/* default */.ZP; },
  "Cascader": function() { return /* reexport */ Cascader/* default */.Z; },
  "Chart": function() { return /* reexport */ Chart; },
  "CheckBox": function() { return /* reexport */ CheckBox/* default */.Z; },
  "Chip": function() { return /* reexport */ Chip; },
  "CircleProgressBar": function() { return /* reexport */ CircleProgressBar; },
  "Col": function() { return /* reexport */ Col/* default */.Z; },
  "Collapse": function() { return /* reexport */ Collapse/* default */.Z; },
  "Colors": function() { return /* binding */ components_Colors; },
  "CombinePicker": function() { return /* reexport */ CombinePicker/* default */.Z; },
  "CompaniesYouWillLove": function() { return /* reexport */ CompaniesYouWillLove; },
  "CompanyCard": function() { return /* reexport */ CompanyCard; },
  "CompanyCardSquare": function() { return /* reexport */ CompanyCardSquare/* default */.Z; },
  "CompanyIndustry": function() { return /* reexport */ CompanyIndustry/* default */.Z; },
  "CompanyInfo": function() { return /* reexport */ CompanyInfo; },
  "CompanySelect": function() { return /* reexport */ CompanySelect; },
  "Container": function() { return /* reexport */ components_Container/* default */.Z; },
  "ContentEditable": function() { return /* reexport */ ContentEditable; },
  "CustomRadio": function() { return /* reexport */ components_CustomRadio/* default */.Z; },
  "DatePicker": function() { return /* reexport */ DatePicker; },
  "DatePickerInput": function() { return /* reexport */ DatePickerInput; },
  "Dialog": function() { return /* reexport */ Dialog; },
  "DragDropResumeUpload": function() { return /* reexport */ DragDropResumeUpload/* default */.Z; },
  "EAppMode": function() { return /* reexport */ constants/* EAppMode */.Cn; },
  "EBoxType": function() { return /* reexport */ DragDropResumeUpload_type/* EBoxType */.Y; },
  "ECalendarStyle": function() { return /* reexport */ Calendar_types/* ECalendarStyle */.w; },
  "ECalendarType": function() { return /* reexport */ Calendar_types/* ECalendarType */.i; },
  "EDatePicker": function() { return /* reexport */ DatePicker_type/* EDatePicker */.f; },
  "ELanguage": function() { return /* reexport */ constants/* ELanguage */.Df; },
  "ENestedDatasetName": function() { return /* reexport */ types/* ENestedDatasetName */.X; },
  "EmptyResult": function() { return /* reexport */ EmptyResult; },
  "FMCheckBox": function() { return /* reexport */ FMCheckBox; },
  "FMCompanySelect": function() { return /* reexport */ FMCompanySelect; },
  "FMDatePicker": function() { return /* reexport */ FMDatePicker; },
  "FMForm": function() { return /* reexport */ FMForm; },
  "FMI11lPhoneNumberInput": function() { return /* reexport */ FMI11lPhoneNumberInput; },
  "FMInput": function() { return /* reexport */ FMInput; },
  "FMInputYOE": function() { return /* reexport */ InputYOE_FMInput; },
  "FMSelect": function() { return /* reexport */ FMSelect; },
  "FMTextEditor": function() { return /* reexport */ FMTextEditor; },
  "ForceLogOut": function() { return /* reexport */ ForceLogOut; },
  "Form": function() { return /* reexport */ Form/* default */.Z; },
  "FormManager": function() { return /* reexport */ FormManager; },
  "FormModal": function() { return /* reexport */ FormModal; },
  "FormView": function() { return /* reexport */ FormView; },
  "H1": function() { return /* reexport */ Variant.H1; },
  "H2": function() { return /* reexport */ Variant.H2; },
  "H3": function() { return /* reexport */ Variant.H3; },
  "H4": function() { return /* reexport */ Variant.H4; },
  "H5": function() { return /* reexport */ Variant.H5; },
  "H6": function() { return /* reexport */ Variant.H6; },
  "HRInsider": function() { return /* reexport */ ArticleList; },
  "HogProvider": function() { return /* reexport */ HogProvider/* default */.Z; },
  "Hooks": function() { return /* reexport */ components_hooks_namespaceObject; },
  "I11lPhoneNumberInput": function() { return /* reexport */ I11lPhoneNumberInput/* default */.Z; },
  "Icons": function() { return /* reexport */ Icons; },
  "Images": function() { return /* reexport */ Images_namespaceObject; },
  "Input": function() { return /* reexport */ components_Input/* default */.Z; },
  "InputYOE": function() { return /* reexport */ InputYOE/* default */.Z; },
  "JobAlert": function() { return /* reexport */ JobAlert; },
  "JobAlertBar": function() { return /* reexport */ JobAlertBar; },
  "JobCard": function() { return /* reexport */ JobCard/* default */.Z; },
  "JobCardList": function() { return /* reexport */ JobCardList; },
  "JobCardMini": function() { return /* reexport */ JobCardMini; },
  "JobCardMiniList": function() { return /* reexport */ JobCardMiniList; },
  "JobFunction": function() { return /* reexport */ JobFunction/* default */.Z; },
  "JobItem": function() { return /* reexport */ JobItem; },
  "JobMatchingAnalysis": function() { return /* reexport */ JobMatchingAnalysis; },
  "JobPostCard": function() { return /* reexport */ JobPostCard; },
  "JobYouWillLove": function() { return /* reexport */ JobYouWillLove; },
  "Label": function() { return /* reexport */ Variant/* Label */.__; },
  "LazyloadCSR": function() { return /* reexport */ LazyloadCSR; },
  "LinkedIn": function() { return /* reexport */ LinkedIn; },
  "LoginModal": function() { return /* reexport */ LoginModal; },
  "MailBoxJobAlert": function() { return /* reexport */ PopupUMD_JobAlert; },
  "MobileFullScreenList": function() { return /* reexport */ MobileFullScreenList; },
  "MobileSelect": function() { return /* reexport */ MobileSelect; },
  "MobileSelectMode": function() { return /* reexport */ types/* MobileSelectMode */.P; },
  "MobileSort": function() { return /* reexport */ MobileSort; },
  "Modal": function() { return /* reexport */ Modal; },
  "MultiLevelSelect": function() { return /* reexport */ MultiLevelSelect/* default */.Z; },
  "MultiTagSelect": function() { return /* reexport */ MultiTagSelect; },
  "MultiTagSelectV2": function() { return /* reexport */ MultiTagSelectV2_MultiTagSelect; },
  "MultipleRadio": function() { return /* reexport */ MultipleRadio/* default */.Z; },
  "MultipleSelect": function() { return /* reexport */ MultipleSelect/* default */.Z; },
  "NTag": function() { return /* reexport */ NTag; },
  "NavIcons": function() { return /* reexport */ icons/* NavIcons */.Tg; },
  "NoResult": function() { return /* reexport */ NoResult; },
  "Notifications": function() { return /* reexport */ Notifications_index; },
  "OnBoarding": function() { return /* reexport */ OnBoarding; },
  "OptionGroup": function() { return /* reexport */ OptionGroup; },
  "OptionGroupStyled": function() { return /* reexport */ OptionGroupStyled; },
  "Pagination": function() { return /* reexport */ Pagination_Pagination; },
  "Paragraph": function() { return /* reexport */ Variant/* Paragraph */.nv; },
  "PieChart": function() { return /* reexport */ PieChart; },
  "Podcast": function() { return /* reexport */ Podcast; },
  "PopoverWhatNew": function() { return /* reexport */ PopoverWhatNews; },
  "Popup": function() { return /* reexport */ Popup/* default */.Z; },
  "PopupCVReplace": function() { return /* reexport */ PopupCVReplace/* default */.Z; },
  "PopupNewUser": function() { return /* reexport */ PopupNewUser_PopupNewUser; },
  "PopupWarning": function() { return /* reexport */ PopupWarning/* default */.Z; },
  "PreviewJob": function() { return /* reexport */ PreviewJob/* default */.Z; },
  "Proficiency": function() { return /* reexport */ Proficiency; },
  "ProgressBar": function() { return /* reexport */ ProgressBar; },
  "QuestionMarkIcon": function() { return /* reexport */ QuestionMarkIcon_QuestionMarkIcon$1; },
  "QuickApplyJobModal": function() { return /* reexport */ QuickApplyJobModal; },
  "Radio": function() { return /* reexport */ Radio; },
  "RangePicker": function() { return /* reexport */ RangePicker; },
  "RecommendJobs": function() { return /* reexport */ RecommnendJobs; },
  "ReportCompanyModal": function() { return /* reexport */ ReportCompanyModal/* default */.Z; },
  "ReportJobModal": function() { return /* reexport */ ReportJobModal; },
  "Row": function() { return /* reexport */ Row/* default */.Z; },
  "SEARCH_PARAMS": function() { return /* reexport */ constants/* SEARCH_PARAMS */.AQ; },
  "SearchBarUnstable": function() { return /* reexport */ index; },
  "Select": function() { return /* reexport */ Select; },
  "SelectOptionType": function() { return /* reexport */ SelectOptionType; },
  "SelectedTag": function() { return /* reexport */ SelectedTag; },
  "Services": function() { return /* reexport */ components_services_namespaceObject; },
  "SettingJob": function() { return /* reexport */ SettingJob/* default */.Z; },
  "ShareButton": function() { return /* reexport */ ShareButton/* default */.Z; },
  "SimpleTooltip": function() { return /* reexport */ SimpleTooltip/* default */.Z; },
  "SingleCheckBox": function() { return /* reexport */ SingleCheckBox/* default */.Z; },
  "SingleRadio": function() { return /* reexport */ SingleRadio/* default */.Z; },
  "Skeleton": function() { return /* reexport */ Skeleton/* default */.Z; },
  "Skills": function() { return /* reexport */ Skills_Skills; },
  "SlideModal": function() { return /* reexport */ SlideModal/* default */.Z; },
  "SlideShow": function() { return /* reexport */ SlideShow/* default */.Z; },
  "Slider": function() { return /* reexport */ Slider; },
  "SocialShare": function() { return /* reexport */ SocialShare; },
  "Span": function() { return /* reexport */ Variant/* Span */.Dr; },
  "StyledCss": function() { return /* reexport */ styledCss/* default */.ZP; },
  "Switcher": function() { return /* reexport */ Switcher; },
  "Tabs": function() { return /* reexport */ Tabs_Tabs; },
  "Tag": function() { return /* reexport */ components_Tag/* default */.Z; },
  "TagBasic": function() { return /* reexport */ TagBasic; },
  "TagSelect": function() { return /* reexport */ TagSelect; },
  "TextEditor": function() { return /* reexport */ TextEditor$1; },
  "TextEditorQuill": function() { return /* reexport */ TextEditorQuill; },
  "TextField": function() { return /* reexport */ TextField/* default */.Z; },
  "Textarea": function() { return /* reexport */ Textarea; },
  "TextareaForm": function() { return /* reexport */ TextareaForm; },
  "TikTok": function() { return /* reexport */ TikTok_index; },
  "Toast": function() { return /* reexport */ Toast/* default */.ZP; },
  "Tooltip": function() { return /* reexport */ Tooltip; },
  "TranslateContext": function() { return /* reexport */ TranslateContext; },
  "TravelLine": function() { return /* reexport */ TravelLine; },
  "TreeSelect": function() { return /* reexport */ TreeSelect$1; },
  "TrustedCompanyName": function() { return /* reexport */ TrustedCompanyName/* default */.Z; },
  "Typography": function() { return /* reexport */ Typography/* default */.Z; },
  "UploadFile": function() { return /* reexport */ UploadFile_UploadFile; },
  "UploadResumeModal": function() { return /* reexport */ UploadResumeModal; },
  "Utils": function() { return /* reexport */ Utils_namespaceObject; },
  "XaloLead": function() { return /* reexport */ XaloLead; },
  "YourResumeScore": function() { return /* reexport */ YourResumeScore; },
  "ZaloWidget": function() { return /* reexport */ ZaloWidget; },
  "callTrackingUTM": function() { return /* reexport */ utmTracking/* callTrackingUTM */.eW; },
  "colors": function() { return /* reexport */ Colors/* colors */.O9; },
  "convertDateToISO": function() { return /* reexport */ time/* convertDateToISO */.f1; },
  "dateToString": function() { return /* reexport */ time/* dateToString */.UW; },
  "formatCanonicalUrl": function() { return /* reexport */ utmTracking/* formatCanonicalUrl */.zv; },
  "getLastViewJobId": function() { return /* reexport */ getLastViewJobId; },
  "getRecommendJobs": function() { return /* reexport */ getRecommendJobs; },
  "openNotification": function() { return /* reexport */ openNotification; },
  "textEditorUtils": function() { return /* reexport */ TextEditorUtils; },
  "translator": function() { return /* reexport */ translator_helper/* translator */.O; },
  "useFMFormContext": function() { return /* reexport */ useFMFormContext; },
  "useHog": function() { return /* reexport */ useHog/* default */.Z; },
  "useIdentify": function() { return /* reexport */ useIdentify/* default */.ZP; },
  "useTranslate": function() { return /* reexport */ useTranslate; }
});

// NAMESPACE OBJECT: ./node_modules/@microfrontends/react-components/components/Utils/index.js
var Utils_namespaceObject = {};
__webpack_require__.r(Utils_namespaceObject);
__webpack_require__.d(Utils_namespaceObject, {
  "ConvertHexToRgbA": function() { return helpers/* ConvertHexToRgbA */.mT; },
  "addCommaToNumber": function() { return helpers/* addCommaToNumber */.Ew; },
  "attachQueryParamToUrl": function() { return helpers/* attachQueryParamToUrl */._2; },
  "buildCompanyLink": function() { return urlBuilder/* buildCompanyLink */.S9; },
  "buildCompanyUrl": function() { return urlBuilder/* buildCompanyUrl */.kQ; },
  "buildJobUrl": function() { return urlBuilder/* buildJobUrl */.Ty; },
  "buildSearchPath": function() { return urlBuilder/* buildSearchPath */.WV; },
  "buildSearchUrl": function() { return urlBuilder/* buildSearchUrl */.aH; },
  "compareVariable": function() { return helpers/* compareVariable */.sf; },
  "createTranslator": function() { return helpers/* createTranslator */.eX; },
  "debounceHandler": function() { return helpers/* debounceHandler */.BN; },
  "decrypt": function() { return helpers/* decrypt */.pe; },
  "deepEqual": function() { return helpers/* deepEqual */.vZ; },
  "deepMerge": function() { return helpers/* deepMerge */.RH; },
  "downloadAttachFile": function() { return helpers/* downloadAttachFile */.jE; },
  "encrypt": function() { return helpers/* encrypt */.HI; },
  "filterResult": function() { return Cascader_helper/* filterResult */.wh; },
  "fixedNumber": function() { return helpers/* fixedNumber */.Bs; },
  "formatInvalidDate": function() { return time/* formatInvalidDate */.QE; },
  "generateJobUrl": function() { return helpers/* generateJobUrl */.z6; },
  "generateUuidV4": function() { return utils/* generateUuidV4 */.Yt; },
  "getCookie": function() { return cookie/* getCookie */.e; },
  "getNumberFromString": function() { return helpers/* getNumberFromString */.Ji; },
  "imageLoader": function() { return Utils_image/* imageLoader */.X; },
  "isCompanyWhitelisted": function() { return helpers/* isCompanyWhitelisted */.YK; },
  "isDesktop": function() { return responsiveHelper/* isDesktop */.nI; },
  "isDifferentArrayData": function() { return helpers/* isDifferentArrayData */.AU; },
  "isIPv4FromGoogle": function() { return helpers/* isIPv4FromGoogle */.oB; },
  "isLocationChanged": function() { return helpers/* isLocationChanged */.G; },
  "isPhone": function() { return responsiveHelper/* isPhone */.Mn; },
  "isRobot": function() { return helpers/* isRobot */.l6; },
  "isTablet": function() { return responsiveHelper/* isTablet */.Em; },
  "isTouch": function() { return responsiveHelper/* isTouch */.T; },
  "locationsMappingHelperForMultiLevelSelect": function() { return helpers/* locationsMappingHelperForMultiLevelSelect */.ce; },
  "objToQueryStr": function() { return urlBuilder/* objToQueryStr */.G7; },
  "randomId": function() { return helpers/* randomId */.kb; },
  "screens": function() { return responsiveHelper/* screens */.FB; },
  "setCookie": function() { return cookie/* setCookie */.d; },
  "showToast": function() { return Toast/* showToast */.CF; },
  "slugify": function() { return helpers/* slugify */.lV; },
  "textToLatin": function() { return helpers/* textToLatin */.jI; },
  "transformToLatin": function() { return helpers/* transformToLatin */.nr; },
  "validateFormat": function() { return validateFormat; },
  "validateFunctions": function() { return validators/* default */.Z; }
});

// NAMESPACE OBJECT: ./node_modules/@microfrontends/react-components/components/services/index.js
var components_services_namespaceObject = {};
__webpack_require__.r(components_services_namespaceObject);
__webpack_require__.d(components_services_namespaceObject, {
  "ModelError": function() { return model/* default */.Z; },
  "getJobYouWillLove": function() { return services/* getJobYouWillLove */.SX; },
  "getSpecialJob": function() { return services/* getSpecialJob */.nL; },
  "saveJob": function() { return JobCard_services/* saveJob */.P; },
  "unsaveJob": function() { return JobCard_services/* unsaveJob */.z; }
});

// NAMESPACE OBJECT: ./node_modules/@microfrontends/react-components/components/Images/index.js
var Images_namespaceObject = {};
__webpack_require__.r(Images_namespaceObject);
__webpack_require__.d(Images_namespaceObject, {
  "AISalaryIcon": function() { return AISalaryIcon; },
  "AIStarListIcon": function() { return AIStarListIcon; },
  "AccountCenter": function() { return AccountCenter; },
  "AccountSettingsIcon": function() { return AccountSettingsIcon$1; },
  "AddFilledIcon": function() { return AddFilledIcon/* default */.Z; },
  "AddIcon": function() { return AddIcon; },
  "AddOutlinedIcon": function() { return AddOutlinedIcon; },
  "AiIcon": function() { return AiIcon$1; },
  "AlertGroup": function() { return AlertGroupIcons_Alert; },
  "ArrowBackIcon": function() { return ArrowBackIcon/* default */.Z; },
  "ArrowDownIcon": function() { return ArrowDownIcon/* default */.Z; },
  "ArrowLeft": function() { return Arrows/* ArrowLeft */.Xd; },
  "ArrowRight": function() { return Arrows/* ArrowRight */.ol; },
  "ArrowRightIcon": function() { return ArrowRightIcon_index; },
  "ArrowRoundedLeft": function() { return ArrowRoundedLeft/* default */.Z; },
  "ArrowRoundedRight": function() { return ArrowRoundedRight/* default */.Z; },
  "AttachIcon": function() { return Images_AttachIcon/* default */.Z; },
  "AwardsIcon": function() { return AwardsIcon/* default */.Z; },
  "BellIcon": function() { return BellIcon_index; },
  "Benefit": function() { return Benefit; },
  "BonusIcon": function() { return BonusIcon/* default */.Z; },
  "BriefcaseIcon": function() { return BriefcaseIcon_index; },
  "CancelIcon": function() { return CancelIcon; },
  "CanteenIcon": function() { return CanteenIcon/* default */.Z; },
  "CheckIcon": function() { return CheckIcon_index; },
  "CheckSuccessIcon": function() { return CheckSuccessIcon; },
  "CheckTagIcon": function() { return CheckTagIcon/* default */.Z; },
  "CircleArrowRightIcon": function() { return CircleArrowRightIcon; },
  "CircleChecked": function() { return CircleChecked$1; },
  "CloseIcon": function() { return CloseIcon/* default */.Z; },
  "CommercialIcon": function() { return CommercialIcon$1; },
  "CompanySizeIcon": function() { return CompanySizeIcon_index; },
  "ContactIcon": function() { return ContactIcon_index; },
  "CopyIcon": function() { return CopyIcon/* default */.Z; },
  "DangerIcon": function() { return DangerIcon_index; },
  "DashboardIcon": function() { return DashboardIcon$1; },
  "DefaultAvatar": function() { return DefaultAvatar/* default */.Z; },
  "DefaultCompanyLogo": function() { return DefaultCompanyLogo; },
  "DefaultCompanyLogoUrl": function() { return DefaultCompanyLogoUrl; },
  "DoubleArrowLeft": function() { return Arrows/* DoubleArrowLeft */.At; },
  "DoubleArrowRight": function() { return Arrows/* DoubleArrowRight */.Ct; },
  "DoubleTickIcon": function() { return DoubleTickIcon$1; },
  "DownloadIcon": function() { return DownloadIcon; },
  "DragReorderIcon": function() { return DragReorderIcon_index; },
  "EmployerViewIcon": function() { return EmployerViewIcon; },
  "EmployerViewProfileIcon": function() { return EmployerViewProfileIcon; },
  "EmptyIcon": function() { return EmptyIcon; },
  "EnvelopeIcon": function() { return EnvelopeIcon_index; },
  "ExternalLinkIcon": function() { return ExternalLinkIcon_index; },
  "EyesCloseIcon": function() { return EyesCloseIcon/* default */.Z; },
  "EyesOpenIcon": function() { return EyesOpenIcon/* default */.Z; },
  "FacebookIcon": function() { return Images_FacebookIcon/* default */.Z; },
  "FacebookLogoIcon": function() { return FacebookLogoIcon$1; },
  "FilterIcon": function() { return FilterIcon_index; },
  "FormAction": function() { return FormAction; },
  "ForwardIcon": function() { return ForwardIcon_index; },
  "GoogleLogoIcon": function() { return GoogleLogoIcon$1; },
  "GraduationCapIcon": function() { return GraduationCapIcon_index; },
  "HealthcarePlanIcon": function() { return HealthcarePlanIcon/* default */.Z; },
  "HeartIcon": function() { return HeartIcon_index; },
  "HeartOutlineIcon": function() { return HeartOutlineIcon_index; },
  "HideIcon": function() { return HideIcon/* default */.Z; },
  "HomeIcon": function() { return HomeIcon_index; },
  "HyperLinkIcon": function() { return HyperLinkIcon_index; },
  "InfoOverview": function() { return InfoOverviewGroupIcons/* default */.Z; },
  "JobAlertsIcon": function() { return JobAlertsIcon$1; },
  "KindergartenIcon": function() { return KindergartenIcon/* default */.Z; },
  "LanguageIcon": function() { return LanguageIcon$1; },
  "LaptopIcon": function() { return LaptopIcon/* default */.Z; },
  "LibraryIcon": function() { return LibraryIcon/* default */.Z; },
  "LinkIcon": function() { return LinkIcon_index; },
  "LinkedInIcon": function() { return LinkedInIcon/* default */.Z; },
  "LoadingCircleIcon": function() { return LoadingCircleIcon; },
  "LoadingIcon": function() { return LoadingIcon/* default */.Z; },
  "LogoutIcon": function() { return LogoutIcon; },
  "LongArrowRight": function() { return Arrows/* LongArrowRight */.RD; },
  "MailAddIcon": function() { return MailAddIcon/* default */.Z; },
  "MarkerIcon": function() { return MarkerIcon_index; },
  "MiniAiIcon": function() { return MiniAiIcon; },
  "Misc": function() { return MiscGroupIcons/* default */.Z; },
  "MobileIcon": function() { return MobileIcon/* default */.Z; },
  "MyCompaniesIcon": function() { return MyCompaniesIcon$1; },
  "MyJobsIcon": function() { return MyJobsIcon$1; },
  "MyProfileIcon": function() { return MyProfileIcon$1; },
  "Navigation": function() { return Navigation; },
  "OrderManagementIcon": function() { return OrderManagementIcon$1; },
  "PDFIcon": function() { return PDFIcon; },
  "PaidLeaveIcon": function() { return PaidLeaveIcon/* default */.Z; },
  "Pencil": function() { return Pencil$1; },
  "PencilIcon": function() { return PencilIcon_index; },
  "PencilIconV2": function() { return PencilIconV2; },
  "PhoneIcon": function() { return PhoneIcon_index; },
  "PlusIcon": function() { return PlusIcon/* default */.Z; },
  "ProfileSettingsIcon": function() { return ProfileSettingsIcon$1; },
  "RemoveFillIcon": function() { return RemoveFillIcon/* default */.Z; },
  "RemoveIcon": function() { return RemoveIcon/* default */.Z; },
  "ReportIcon": function() { return ReportIcon/* default */.Z; },
  "RewardsType": function() { return RewardsType; },
  "SalaryIcon": function() { return SalaryIcon$1; },
  "SearchIcon": function() { return Images_SearchIcon/* default */.Z; },
  "ShareIcon": function() { return ShareIcon/* default */.Z; },
  "SocialMedia": function() { return SocialMedia; },
  "SortIcon": function() { return SortIcon; },
  "SortMobileIcon": function() { return SortMobileIcon/* default */.Z; },
  "StatsIcon": function() { return StatsIcon$1; },
  "SyncProfileIcon": function() { return SyncProfileIcon; },
  "TeamActivitiesIcon": function() { return TeamActivitiesIcon/* default */.Z; },
  "ThreeDotIcon": function() { return ThreeDotIcon/* default */.Z; },
  "TrainingIcon": function() { return TrainingIcon/* default */.Z; },
  "TransportationIcon": function() { return TransportationIcon/* default */.Z; },
  "Trash": function() { return Trash$1; },
  "TrashIcon": function() { return TrashIcon_index; },
  "TravelOpportunitiesIcon": function() { return TravelOpportunitiesIcon/* default */.Z; },
  "TwinkleLinearGradientIcon": function() { return TwinkleLinearGradientIcon$1; },
  "UploadIcon": function() { return UploadIcon/* default */.Z; },
  "VerticalMoreIcon": function() { return VerticalMoreIcon/* default */.Z; },
  "VoucherIcon": function() { return VoucherIcon/* default */.Z; },
  "WarnIcon": function() { return WarnIcon/* default */.Z; },
  "WarningIcon": function() { return Warning/* default */.Z; },
  "WorkingLocationIcon": function() { return WorkingLocationIcon$1; },
  "WowCVIcon": function() { return WowCVIcon$1; },
  "ZaloIcon": function() { return ZaloIcon_index; }
});

// NAMESPACE OBJECT: ./node_modules/@microfrontends/react-components/components/hooks/index.js
var components_hooks_namespaceObject = {};
__webpack_require__.r(components_hooks_namespaceObject);
__webpack_require__.d(components_hooks_namespaceObject, {
  "useAnimationControl": function() { return useAnimationControl; },
  "useBeforeunload": function() { return useBeforeunload; },
  "useClickAway": function() { return useClickAway/* default */.Z; },
  "useClickOutSide": function() { return useClickOutSide/* default */.Z; },
  "useCollapseElement": function() { return useCollapseElement; },
  "useCountNumber": function() { return useCountNumber; },
  "useCountdown": function() { return useCountdown; },
  "useDebounce": function() { return useDebounce/* default */.Z; },
  "useDelay": function() { return useDelay; },
  "useDidUpdateEffect": function() { return hooks/* useDidUpdateEffect */.Dz; },
  "useDropdownAnimation": function() { return useDropdownAnimation/* default */.Z; },
  "useElementOnScreen": function() { return UseElementOnScreen/* default */.Z; },
  "useElementSize": function() { return useElementSize/* default */.Z; },
  "useFetch": function() { return useFetch/* default */.Z; },
  "useFloating": function() { return useFloating/* default */.Z; },
  "useInitNotification": function() { return UseInitNotification/* useInitNotification */.U; },
  "useInterval": function() { return useInterval; },
  "useIsomorphicLayoutEffect": function() { return useIsomorphicLayoutEffect/* default */.Z; },
  "useKeyboardAccessibility": function() { return useKeyboardAccessibility/* default */.Z; },
  "useLatestRef": function() { return useLatestRef/* default */.Z; },
  "useMakeSearchable": function() { return useMakeSearchable; },
  "useMediaQuery": function() { return useMediaQuery/* default */.Z; },
  "useMountTransition": function() { return hooks/* useMountTransition */.R5; },
  "useOnClickOutside": function() { return useOnClickOutside; },
  "usePlacement": function() { return usePlacement; },
  "useResize": function() { return useResize; },
  "useScrollLock": function() { return useScrollLock/* default */.Z; },
  "useThrottle": function() { return useThrottle; },
  "useTransition": function() { return useTransition/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Alert/index.js + 2 modules
var Alert = __webpack_require__(6687);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/index.js + 1 modules
var CheckBox = __webpack_require__(95140);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/IconLoading.js
'use client';



var IconLoading = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid' },
        react.createElement("circle", { cx: '75', cy: '50', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.9166666666666666s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.9166666666666666s' })),
        react.createElement("circle", { cx: '71.65063509461098', cy: '62.5', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.8333333333333334s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.8333333333333334s' })),
        react.createElement("circle", { cx: '62.5', cy: '71.65063509461096', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.75s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.75s' })),
        react.createElement("circle", { cx: '50', cy: '75', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.6666666666666666s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.6666666666666666s' })),
        react.createElement("circle", { cx: '37.50000000000001', cy: '71.65063509461098', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.5833333333333334s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.5833333333333334s' })),
        react.createElement("circle", { cx: '28.34936490538903', cy: '62.5', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.5s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.5s' })),
        react.createElement("circle", { cx: '25', cy: '50', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.4166666666666667s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.4166666666666667s' })),
        react.createElement("circle", { cx: '28.34936490538903', cy: '37.50000000000001', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.3333333333333333s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.3333333333333333s' })),
        react.createElement("circle", { cx: '37.499999999999986', cy: '28.349364905389038', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.25s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.25s' })),
        react.createElement("circle", { cx: '49.99999999999999', cy: '25', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.16666666666666666s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.16666666666666666s' })),
        react.createElement("circle", { cx: '62.5', cy: '28.349364905389034', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.08333333333333333s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.08333333333333333s' })),
        react.createElement("circle", { cx: '71.65063509461096', cy: '37.499999999999986', fill: 'rgba(255, 255, 255, 0.5)', r: '5' },
            react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '0s' }),
            react.createElement("animate", { attributeName: 'fill', values: 'rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5);#ffffff;rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.5)', repeatCount: 'indefinite', times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '0s' }))));
};


//# sourceMappingURL=IconLoading.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Dialog/deleteIcon.js
'use client';



var closeIcon = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.fill, fill = _c === void 0 ? '' : _c;
    return (react.createElement("svg", { style: style, fill: fill, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        react.createElement("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' })));
};


//# sourceMappingURL=deleteIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Dialog/Dialog.module.scss.js
'use client';

var s = {"container":"Dialog-module_container__1Yxa-","zoomIn":"Dialog-module_zoomIn__1_VAq","isOpen":"Dialog-module_isOpen__35t3J","size-medium":"Dialog-module_size-medium__1f-nY","fullHeight":"Dialog-module_fullHeight__16Oos","header":"Dialog-module_header__1KSgt","body":"Dialog-module_body__2zpyd","left":"Dialog-module_left__1_qiw","right":"Dialog-module_right__nRG0g","title":"Dialog-module_title__2ZSky","icon":"Dialog-module_icon__ELISm","backdrop":"Dialog-module_backdrop__1-_ze","closeIcon":"Dialog-module_closeIcon__2Rw9h","footer":"Dialog-module_footer__rJQ0Z","fullScreen":"Dialog-module_fullScreen__1vQ-g","container-delete":"Dialog-module_container-delete__2OOJ6"};


//# sourceMappingURL=Dialog.module.scss.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Dialog/index.js
'use client';









var defaultOnBack = function () {
    console.warn("no \"onBack\" event handler");
};
var Dialog = function (props) {
    var isOpen = props.isOpen, _a = props.onBack, onBack = _a === void 0 ? defaultOnBack : _a, title = props.title, zIndex = props.zIndex, _b = props.backdrop, backdrop = _b === void 0 ? false : _b, _c = props.backdropClassName, backdropClassName = _c === void 0 ? '' : _c, onClickOutside = props.onClickOutside, onClickAction = props.onClickAction, onClickSecondaryButton = props.onClickSecondaryButton, _d = props.type, type = _d === void 0 ? 'default' : _d, _e = props.secondaryButtonText, secondaryButtonText = _e === void 0 ? 'Cancel' : _e, _f = props.actionText, actionText = _f === void 0 ? 'Save' : _f, _g = props.deleteText, deleteText = _g === void 0 ? 'Delete' : _g, _h = props.size, size = _h === void 0 ? 'default' : _h, _j = props.zoomIn, zoomIn = _j === void 0 ? false : _j, _k = props.primaryButtonType, primaryButtonType = _k === void 0 ? 'primary' : _k, _l = props.secondaryButtonType, secondaryButtonType = _l === void 0 ? 'default' : _l, fullScreenOnMobile = props.fullScreenOnMobile, isPrimaryButtonDisabled = props.isPrimaryButtonDisabled, _m = props.isSecondaryButtonDisabled, isSecondaryButtonDisabled = _m === void 0 ? true : _m, isShowSecondaryButton = props.isShowSecondaryButton, _o = props.isLoading, isLoading = _o === void 0 ? false : _o, _p = props.isNoHeader, isNoHeader = _p === void 0 ? false : _p, isNoFooter = props.isNoFooter, _q = props.dialogClass, dialogClass = _q === void 0 ? '' : _q, modalContainerStyle = props.modalContainerStyle, _r = props.sizeButton, sizeButton = _r === void 0 ? 'md' : _r, _s = props.gridButton, gridButton = _s === void 0 ? '1fr 1fr' : _s, _t = props.bodyStyle, bodyStyle = _t === void 0 ? {} : _t, _u = props.className, className = _u === void 0 ? '' : _u;
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside && onClickOutside) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function () {
        if (isOpen && backdrop) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        if (!isOpen) {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        }
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [isOpen, backdrop]);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? s.isOpen : '';
    var modalStyle = {};
    if (zIndex) {
        modalStyle.zIndex = zIndex;
    }
    if (modalContainerStyle) {
        modalStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, modalStyle), modalContainerStyle);
    }
    // Container classes
    var fullScreenClass = fullScreenOnMobile ? s.fullScreen : '';
    var sizeClass = s["size-".concat(size)];
    var typeClass = s["container-".concat(type)];
    var zoomClass = zoomIn ? s.zoomIn : '';
    /* Render */
    return react_dom.createPortal(react.createElement("div", null,
        backdrop && react.createElement("div", { className: "".concat(s.backdrop, " ").concat(classOpen, " ").concat(backdropClassName) }),
        react.createElement("div", { className: "box-dialog ".concat(s.container, " ").concat(typeClass, " ").concat(classOpen, " ").concat(sizeClass, " ").concat(zoomClass, " ").concat(fullScreenClass, " ").concat(dialogClass, " ").concat(className), style: modalStyle, ref: containerRef },
            isNoHeader ? (react.createElement("span", { onClick: onBack, className: "".concat(s.icon, " ").concat(s.right, " ").concat(s.closeIcon) },
                react.createElement(closeIcon, null))) : (react.createElement("div", { className: s.header },
                react.createElement("div", { className: 'text-h2' }, title),
                react.createElement("span", { onClick: onBack, className: "".concat(s.icon, " ").concat(s.right) },
                    react.createElement(closeIcon, null)))),
            react.createElement("div", { className: s.body, style: bodyStyle }, props.children),
            react.createElement("div", { className: s.footer, style: { gridTemplateColumns: gridButton, display: isNoFooter ? 'none' : 'flex' } },
                isShowSecondaryButton && (react.createElement(Button/* default */.Z, { type: secondaryButtonType, onClick: onClickSecondaryButton || onBack, disabled: isSecondaryButtonDisabled, size: sizeButton }, secondaryButtonText)),
                type === 'delete' ? (react.createElement(Button/* default */.Z, { type: 'danger', onClick: onClickAction, disabled: isPrimaryButtonDisabled, size: sizeButton }, deleteText)) : (react.createElement(Button/* default */.Z, { type: primaryButtonType, onClick: onClickAction, disabled: isPrimaryButtonDisabled || isLoading, size: sizeButton }, isLoading ? react.createElement(IconLoading, { width: 32, height: 32 }) : actionText))))), bodyNode);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Textarea/index.js
'use client';





var StyledTextarea = styled_components_browser_esm/* default.textarea */.ZP.textarea(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n    width: 100%;\n    height: auto;\n    padding: 16px;\n    border: 1px solid ", ";\n    background: white;\n    font-size: 14px;\n    border-radius: 4px;\n    resize: none;\n    transition: all 0.3s;\n\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n\n    &:focus {\n        box-shadow: rgb(226, 226, 226) 0px 0px 0px 3px;\n        outline: none;\n    }\n"], ["\n    display: block;\n    width: 100%;\n    height: auto;\n    padding: 16px;\n    border: 1px solid ", ";\n    background: white;\n    font-size: 14px;\n    border-radius: 4px;\n    resize: none;\n    transition: all 0.3s;\n\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n\n    &:focus {\n        box-shadow: rgb(226, 226, 226) 0px 0px 0px 3px;\n        outline: none;\n    }\n"])), function (props) { return (props.hasError ? '#f85a5a' : '#cccccc'); }, function (props) { return (props.hasError ? '#f85a5a' : '#FF7D55'); });
var defaultOnChange = function (value) {
    return value;
};
function Textarea(_a) {
    var _b = _a.rows, rows = _b === void 0 ? 4 : _b, name = _a.name, value = _a.value, _c = _a.onChange, onChange = _c === void 0 ? defaultOnChange : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, rest = (0,_tslib/* __rest */._T)(_a, ["rows", "name", "value", "onChange", "hasError"]);
    return (react.createElement(StyledTextarea, (0,_tslib/* __assign */.pi)({ rows: rows, name: name, id: name, onChange: function (e) { return onChange && onChange(e.target.value); }, hasError: hasError, value: value }, rest)));
}
var templateObject_1;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormComponent/index.js
'use client';







var StyledFormField = styled_components_browser_esm/* default.div */.ZP.div(FormComponent_templateObject_1 || (FormComponent_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    > label {\n        margin-bottom: 4px;\n        display: inline-block;\n\n        > .isRequired {\n            color: #f85a5a;\n        }\n    }\n"], ["\n    > label {\n        margin-bottom: 4px;\n        display: inline-block;\n\n        > .isRequired {\n            color: #f85a5a;\n        }\n    }\n"])));
var TextareaForm = function (_a) {
    var name = _a.name, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.isRequired, isRequired = _c === void 0 ? false : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, _e = _a.value, value = _e === void 0 ? '' : _e, onChange = _a.onChange, rest = (0,_tslib/* __rest */._T)(_a, ["name", "label", "isRequired", "hasError", "value", "onChange"]);
    return (react.createElement(StyledFormField, null,
        label !== '' && (react.createElement("label", { htmlFor: name },
            isRequired && react.createElement("span", { className: 'isRequired' }, "*"),
            " ",
            label)),
        react.createElement(Textarea, (0,_tslib/* __assign */.pi)({ name: name, value: value, hasError: hasError, onChange: onChange }, rest))));
};
var FormComponent_templateObject_1;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/translations.js
var translations = __webpack_require__(93412);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/validator.js
'use client';





function validateEmail(email) {
    var regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
    return regExp.test(String(email).toLowerCase());
}
function validatePhoneNumber(phone) {
    var regExp = /^(\+|\(\+\d{1,2}\)\s?)?[\d,-,\s]{10,10}$/g;
    var validateResult = regExp.test(phone);
    if (!validateResult) {
        return false;
    }
    var filterZero = (phone.match(/0/g) || []).length;
    return filterZero < 8;
}
function validateUrl(text) {
    var url;
    try {
        url = new URL(text);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
}
function validateNoSpecialChars(text) {
    var NO_SPECIAL_CHARS = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
}
var validateVietNamPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
    return VN_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateI11lPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var I11L_PHONE_NUMBER_REGEX = /^\d[0-9 ]{6,14}$/;
    return I11L_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateFormat = function (form, formRules, langCode) {
    var errors = (0,_tslib/* __assign */.pi)({}, form);
    for (var key in errors) {
        errors[key] = '';
    }
    var isValid = true;
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN)
            return key;
        else
            return translations/* default */.Z[key];
    };
    var _loop_1 = function (key, value) {
        var textValue = String(value);
        // validate requried
        if (formRules[key].errors.includes('required')) {
            if (!value) {
                errors[key] = t('This field is required.');
                isValid = false;
                return "continue";
            }
        }
        // validate range
        formRules[key].errors.some(function (error) {
            var _a;
            if (error.includes('char')) {
                var errorFormat = (_a = error.match(/[0-9-]/g)) === null || _a === void 0 ? void 0 : _a.join('');
                if (errorFormat === null || errorFormat === void 0 ? void 0 : errorFormat.includes('-')) {
                    var min = Number(errorFormat.split('-')[0]);
                    var max = Number(errorFormat.split('-')[1]);
                    if (textValue.length < min || textValue.length > max) {
                        errors[key] = t('Accept {0} characters.').replace('{0}', "".concat(min, " - ").concat(max));
                        isValid = false;
                        return true;
                    }
                }
                else {
                    var max = Number(errorFormat);
                    if (textValue.length > max) {
                        errors[key] = t('{0} characters limit.').replace('{0}', "".concat(max));
                    }
                }
            }
            return false;
        });
        if (errors[key])
            return "continue";
        // validate range number
        formRules[key].errors.some(function (error) {
            var _a;
            if (error.includes('number')) {
                var errorFormat = (_a = error.match(/[0-9-]/g)) === null || _a === void 0 ? void 0 : _a.join('');
                if (errorFormat === null || errorFormat === void 0 ? void 0 : errorFormat.includes('-')) {
                    var min = Number(errorFormat.split('-')[0]);
                    var max = Number(errorFormat.split('-')[1]);
                    if (textValue.length < min || textValue.length > max || !textValue.match(/^[0-9]*$/)) {
                        errors[key] = t('Accept {0} digits.').replace('{0}', "".concat(min, " - ").concat(max));
                        isValid = false;
                        return true;
                    }
                }
                else {
                    var max = Number(errorFormat);
                    if (textValue.length > max) {
                        errors[key] = t('{0} digits limit.').replace('{0}', "".concat(max));
                    }
                }
            }
            return false;
        });
        if (errors[key])
            return "continue";
        // validate email
        if (formRules[key].errors.includes('email')) {
            var isValidEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(textValue);
            if (textValue.length === 0 || textValue.indexOf('@') < 0 || textValue.indexOf('.') < 0 || !isValidEmail) {
                errors[key] = t('The Email must be a valid Email address.');
                isValid = false;
                return "continue";
            }
        }
    };
    for (var _i = 0, _a = Object.entries(form); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return { isValid: isValid, errors: errors };
};


//# sourceMappingURL=validator.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/index.js
'use client';





/**
 * FormContext
 *
 * Store all necessary states, setters, handlers....
 */
var FormContext = react.createContext({
    values: {},
    touched: {},
    onSubmit: function () { },
    setValues: function () { },
    setTouched: function () { },
    rules: [],
    errors: {},
    setErrors: function () { },
    advancedValidate: function () {
        return {};
    },
    onAnyChange: function () { },
    validateForm: function () { return false; },
    submitForm: function () { },
    hasSubmittedRef: {
        current: false
    },
    forceShowError: false
});
/**
 * FormManager
 * Entry point of Form
 *
 * Accepts initial values, settings as props
 */
function FormManager(_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, children = _a.children, _b = _a.rules, rules = _b === void 0 ? [] : _b, _c = _a.advancedValidate, advancedValidate = _c === void 0 ? function () {
        return {};
    } : _c, _d = _a.onAnyChange, onAnyChange = _d === void 0 ? function () { } : _d, onValidation = _a.onValidation, _e = _a.forceShowError, forceShowError = _e === void 0 ? false : _e, user = _a.user;
    var _f = (0,react.useState)(initialValues), values = _f[0], setValues = _f[1];
    var _g = (0,react.useState)({}), errors = _g[0], setErrors = _g[1];
    var _h = (0,react.useState)({}), touched = _h[0], setTouched = _h[1];
    var hasSubmittedRef = (0,react.useRef)(false);
    var parseJSON = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            return str;
        }
    };
    var validateForm = function () {
        var errorObj = {};
        rules.map(function (rule) {
            var field = rule.field;
            var value = values[field];
            // get value text of textEditor
            if (field.includes('description')) {
                // {"blocks":[{"key":"dfj3h","text":"Bold text should be bolded","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}
                value = parseJSON(value);
                if (typeof value === 'object') {
                    value = value.blocks
                        .map(function (block) { return (block.text.trim() ? block.text : '\n'); })
                        .join('\n')
                        .trim();
                }
            }
            for (var i = 0; i < rule.rules.length; i++) {
                var ruleItem = rule.rules[i];
                if (errorObj[field]) {
                    break;
                }
                switch (ruleItem.check) {
                    case 'required':
                        if (!value) {
                            errorObj[field] = ruleItem.msg;
                            return;
                        }
                        if (typeof value === 'object' &&
                            Object.keys(value).every(function (key) {
                                var fieldValue = value[key];
                                if (typeof fieldValue === 'string') {
                                    fieldValue = fieldValue.trim();
                                }
                                return !fieldValue;
                            })) {
                            errorObj[field] = ruleItem.msg;
                            return;
                        }
                        if (Array.isArray(value) && value.length === 0) {
                            errorObj[field] = ruleItem.msg;
                            return;
                        }
                        break;
                    case 'email':
                        if (value && !validateEmail(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'phone':
                        if (value && !validatePhoneNumber(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'url':
                        if (value && !validateUrl(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'vn-phone':
                        if (value && value.includes('+84') && !validateVietNamPhoneNumber(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'i11l-phone':
                        if (value && !value.includes('+84') && !validateI11lPhoneNumber(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'duplicateEmail':
                        // check email Basic info and email Reference
                        if (value && value === (user === null || user === void 0 ? void 0 : user.userName)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                    case 'noSpecialChars':
                        // check email Basic info and email Reference
                        if (value && validateNoSpecialChars(value)) {
                            errorObj[field] = ruleItem.msg;
                        }
                        break;
                }
            }
        });
        var advancedErrors = advancedValidate(values);
        var mergedErrors = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errorObj), advancedErrors);
        if (onValidation) {
            onValidation(mergedErrors);
        }
        setErrors(mergedErrors);
        return Object.values(mergedErrors).some(function (item) { return item !== ''; });
    };
    var submitForm = function () {
        hasSubmittedRef.current = true;
        var newTouched = (0,_tslib/* __assign */.pi)({}, touched);
        Object.keys(values).map(function (field) { return (newTouched[field] = true); });
        setTouched(newTouched);
        var hasError = validateForm();
        if (!hasError) {
            onSubmit(values);
        }
    };
    (0,react.useEffect)(function () {
        validateForm();
    }, [values]);
    return (react.createElement(FormContext.Provider, { value: {
            values: values,
            touched: touched,
            onSubmit: onSubmit,
            setValues: setValues,
            setTouched: setTouched,
            rules: rules,
            errors: errors,
            setErrors: setErrors,
            advancedValidate: advancedValidate,
            onAnyChange: onAnyChange,
            validateForm: validateForm,
            submitForm: submitForm,
            hasSubmittedRef: hasSubmittedRef,
            forceShowError: forceShowError
        } }, typeof children === 'function' ? children({ validateForm: validateForm, submitForm: submitForm, values: values }) : children));
}
/**
 * FMForm
 *
 * Handle onSubmit, validation
 */
var FMForm = react.forwardRef(function FMFormComponent(_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    var _b = (0,react.useContext)(FormContext), submitForm = _b.submitForm, hasSubmittedRef = _b.hasSubmittedRef;
    return (react.createElement("form", (0,_tslib/* __assign */.pi)({ ref: ref, onSubmit: function (e) {
            e.preventDefault();
            submitForm();
            hasSubmittedRef.current = true;
        } }, rest), children));
});
/**
 * Hook to retrieve FormContext
 */
function useFMFormContext() {
    return (0,react.useContext)(FormContext);
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleCheckBox/index.js + 1 modules
var SingleCheckBox = __webpack_require__(75297);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/CheckBox/index.js
'use client';






/**
 * Basic Input component
 */
function FMCheckBox(props) {
    var name = props.name; props.width; var _a = props.label, label = _a === void 0 ? '' : _a, rest = (0,_tslib/* __rest */._T)(props, ["name", "width", "label"]);
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        react.createElement(SingleCheckBox/* default */.Z, (0,_tslib/* __assign */.pi)({ id: label }, rest, { label: label, isLeftCheckbox: true, checked: values[name], onChecked: function (value) {
                var _a;
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = value, _a)));
                onAnyChange(value, name);
            }, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            } })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
var RemoveFillIcon = __webpack_require__(83112);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanySelect/SearchIcon.js
'use client';



var SearchIcon = function (_a) {
    var className = _a.className;
    return (react.createElement("svg", { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: className },
        react.createElement("path", { d: 'M10.08 1.44A8.154 8.154 0 0 0 1.92 9.6a8.154 8.154 0 0 0 8.16 8.16c1.61 0 3.101-.473 4.365-1.275l5.895 5.895 2.04-2.04-5.82-5.805A8.102 8.102 0 0 0 18.24 9.6a8.154 8.154 0 0 0-8.16-8.16Zm0 1.92a6.228 6.228 0 0 1 6.24 6.24 6.228 6.228 0 0 1-6.24 6.24A6.228 6.228 0 0 1 3.84 9.6a6.228 6.228 0 0 1 6.24-6.24Z', fill: '#888' })));
};


//# sourceMappingURL=SearchIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanySelect/styles.js
'use client';







var CompanySelectContainer = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_1 || (styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Input = styled_components_browser_esm/* default.input */.ZP.input(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: none;\n    background: transparent;\n    flex: 1;\n    &:focus {\n        outline: none;\n    }\n"], ["\n    border: none;\n    background: transparent;\n    flex: 1;\n    &:focus {\n        outline: none;\n    }\n"])));
var InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    display: flex;\n    column-gap: 8px;\n    padding: 7px 12px;\n    border-radius: 6px;\n    cursor: text;\n    ", "\n"], ["\n    background-color: #fff;\n    display: flex;\n    column-gap: 8px;\n    padding: 7px 12px;\n    border-radius: 6px;\n    cursor: text;\n    ", "\n"])), function (_a) {
    var hasError = _a.hasError;
    return "\n        border: 1px solid ".concat(hasError ? constants/* colors.borderError */.O9.borderError : constants/* colors.borderNormal */.O9.borderNormal, ";\n        &:hover {\n            border-color: ").concat(hasError ? constants/* colors.borderError */.O9.borderError : constants/* colors.borderHover */.O9.borderHover, ";\n        }\n        &:has(").concat(Input, ":focus) {\n            border-color: ").concat(hasError ? constants/* colors.borderError */.O9.borderError : constants/* colors.borderFocus */.O9.borderFocus, ";\n        }\n    ");
});
var DropdownList = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    list-style: none;\n    margin: 0;\n    padding: 16px 4px;\n    border: 1px solid ", ";\n    border-radius: 6px;\n    background: #fff;\n    color: black !important;\n    width: 100%;\n    z-index: 10;\n    max-height: 200px;\n    box-shadow: 0px 1px 8px 0px #0000001f;\n    overflow: auto;\n"], ["\n    list-style: none;\n    margin: 0;\n    padding: 16px 4px;\n    border: 1px solid ", ";\n    border-radius: 6px;\n    background: #fff;\n    color: black !important;\n    width: 100%;\n    z-index: 10;\n    max-height: 200px;\n    box-shadow: 0px 1px 8px 0px #0000001f;\n    overflow: auto;\n"])), constants/* colors.borderNormal */.O9.borderNormal);
var DropdownItem = styled_components_browser_esm/* default.li */.ZP.li(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 10px 8px;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 16px;\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    padding: 10px 8px;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 16px;\n    &:hover {\n        background-color: ", ";\n    }\n"])), constants/* colors.bgHover */.O9.bgHover);
var CompanyLogo = styled_components_browser_esm/* default.img */.ZP.img(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 4px;\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    flex-shrink: 0;\n"], ["\n    border-radius: 4px;\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    flex-shrink: 0;\n"])));
var LabelWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"])));
var TextDanger = styled_components_browser_esm/* default.span */.ZP.span(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), constants/* colors.dangerColor */.O9.dangerColor);
var RemovedIcon = (0,styled_components_browser_esm/* default */.ZP)(RemoveFillIcon/* default */.Z)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    transition: all 0.25s ease-in-out;\n    opacity: 1;\n"], ["\n    cursor: pointer;\n    transition: all 0.25s ease-in-out;\n    opacity: 1;\n"])));
var RemovedIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    &.hidden {\n        ", " {\n            opacity: 0;\n        }\n    }\n"], ["\n    display: flex;\n    &.hidden {\n        ", " {\n            opacity: 0;\n        }\n    }\n"])), RemovedIcon);
var styles_SearchIcon = (0,styled_components_browser_esm/* default */.ZP)(SearchIcon)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"])));
var styles_templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;


//# sourceMappingURL=styles.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFetch.js
var useFetch = __webpack_require__(86760);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDebounce.js
var useDebounce = __webpack_require__(90401);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(15758);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanySelect/index.js
'use client';












var LIMIT = 5;
var CompanySelect = function (_a) {
    var _b;
    var label = _a.label, isRequired = _a.isRequired, msBasePath = _a.msBasePath, _c = _a.langCode, langCode = _c === void 0 ? constants/* ELanguage.VI */.Df.VI : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Search' : _d, _e = _a.limit, limit = _e === void 0 ? LIMIT : _e, onChange = _a.onChange, _f = _a.companyLogoUrl, companyLogoUrl = _f === void 0 ? '' : _f, _g = _a.companyName, companyName = _g === void 0 ? '' : _g, onInputChange = _a.onInputChange, onFocus = _a.onFocus, onBlur = _a.onBlur, _h = _a.apiEndPoint, apiEndPoint = _h === void 0 ? '/hot-keywords/api/v2/keywords/suggestion-company' : _h, _j = _a.hasError, hasError = _j === void 0 ? false : _j, _k = _a.defaultLogo, defaultLogo = _k === void 0 ? 'https://images.vietnamworks.com/img/company-default-logo.svg' : _k, renderOptions = _a.renderOptions, _l = _a.searchWithEmptyQuery, searchWithEmptyQuery = _l === void 0 ? false : _l, floatingConfig = _a.floatingConfig, _m = _a.isInputOnly, isInputOnly = _m === void 0 ? false : _m, _o = _a.inputStyle, inputStyle = _o === void 0 ? {} : _o, isAlwaysUpdateValue = _a.isAlwaysUpdateValue;
    var isFirstMounted = (0,react.useRef)(true);
    var isUserTouched = (0,react.useRef)(false);
    var inputRef = (0,react.useRef)(null);
    var _p = (0,react.useState)(''), inputValue = _p[0], setInputValue = _p[1];
    var _q = (0,react.useState)(''), selectedLogo = _q[0], setSelectedLogo = _q[1];
    var debouncedInputValue = (0,useDebounce/* default */.Z)(inputValue, 300);
    var _r = (0,react.useState)('none'), removedIconState = _r[0], setRemovedIconState = _r[1];
    /*
     * Sync data
     * */
    (0,react.useEffect)(function () {
        /*
         * Check for user touched component
         * I only want data only sync when user not touched component
         * */
        if (isUserTouched.current && !isAlwaysUpdateValue) {
            return;
        }
        if (companyName !== '') {
            setInputValue(companyName);
        }
        /*
         * If has companyLogoUrl, setSelectedLogo.
         * If companyLogoUrl is empty and companyName not empty, setSelectedLogo by DEFAULT_COMPANY_LOGO
         * */
        if (companyLogoUrl !== '') {
            setSelectedLogo(companyLogoUrl);
            return;
        }
        if (companyName !== '') {
            setSelectedLogo(defaultLogo);
        }
    }, [companyLogoUrl, companyName, defaultLogo]);
    /*
     * Handle fetch and store data
     * */
    var _s = (0,react.useState)([]), options = _s[0], setOptions = _s[1];
    var SUGGESTION_COMPANY_API = "".concat(msBasePath).concat(apiEndPoint);
    (0,useFetch/* default */.Z)(SUGGESTION_COMPANY_API + "?query=".concat(debouncedInputValue, "&limit=").concat(limit), {
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': langCode
        },
        enable: searchWithEmptyQuery || debouncedInputValue !== ''
    }, function (data) {
        if (renderOptions) {
            var options_1 = renderOptions(data);
            setOptions(options_1);
            return;
        }
        setOptions(data.data.map(function (item) { return item.attributes; }));
    });
    /*
     * Setup auto placement for dropdown element
     * */
    var _t = (0,react.useState)(false), isVisible = _t[0], setElementVisible = _t[1];
    var _u = (0,useFloating/* default */.Z)({
        placement: 'bottom-start',
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: {
            detectHidden: true,
            useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false
        }
    }), refs = _u.refs, context = _u.context, FloatingPortal = _u.FloatingPortal;
    /*
     * Setup handle click outside
     * */
    (0,useClickAway/* default */.Z)(function () {
        setElementVisible(false);
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    (0,react.useEffect)(function () {
        /*
         * Check for first mounted
         * This will make sure the selectedLogo won't be reset
         * */
        if (isFirstMounted.current) {
            isFirstMounted.current = false;
            return;
        }
        // End check
        if (inputValue === '') {
            /*
             * Reset option and logo when input value is empty string
             * */
            setOptions([]);
            setSelectedLogo('');
        }
    }, [inputValue]);
    var handleClearInput = function () {
        if (selectedLogo !== '') {
            setSelectedLogo('');
        }
        setInputValue('');
        onInputChange && onInputChange('');
    };
    return (react.createElement("div", null,
        label ? (react.createElement(LabelWrapper, null,
            isRequired ? react.createElement(TextDanger, null, "*") : null,
            " ",
            react.createElement("label", null, label))) : null,
        react.createElement(CompanySelectContainer, { onMouseEnter: function () { return removedIconState !== 'focus' && setRemovedIconState('hover'); }, onMouseLeave: function () { return removedIconState !== 'focus' && setRemovedIconState('none'); } },
            isInputOnly ? (react.createElement("div", { ref: refs.setReference },
                react.createElement(Input, { ref: inputRef, placeholder: placeholder, onBlur: function (e) {
                        setRemovedIconState('none');
                        onBlur && onBlur(e.target.value);
                    }, onFocus: function () {
                        setElementVisible(true);
                        setRemovedIconState('focus');
                        onFocus && onFocus();
                    }, onChange: function (e) {
                        isUserTouched.current = true;
                        // Reset logo when user input
                        if (selectedLogo !== '') {
                            setSelectedLogo('');
                        }
                        var companyName = e.target.value;
                        setInputValue(companyName);
                        onInputChange && onInputChange(companyName);
                    }, value: inputValue, style: inputStyle }))) : (react.createElement(InputWrapper, { hasError: hasError, ref: refs.setReference, onClick: function () {
                    if (inputRef && inputRef.current) {
                        inputRef.current.focus();
                        onFocus && onFocus();
                        setRemovedIconState('focus');
                    }
                } },
                selectedLogo !== '' ? (react.createElement(CompanyLogo, { width: 24, height: 24, src: selectedLogo, alt: 'Company logo' })) : (react.createElement(styles_SearchIcon, null)),
                react.createElement(Input, { ref: inputRef, placeholder: placeholder, onBlur: function (e) {
                        setRemovedIconState('none');
                        onBlur && onBlur(e.target.value);
                    }, onFocus: function () {
                        setElementVisible(true);
                        setRemovedIconState('focus');
                        onFocus && onFocus();
                    }, onChange: function (e) {
                        isUserTouched.current = true;
                        // Reset logo when user input
                        if (selectedLogo !== '') {
                            setSelectedLogo('');
                        }
                        var companyName = e.target.value;
                        setInputValue(companyName);
                        onInputChange && onInputChange(companyName);
                    }, value: inputValue, style: inputStyle }),
                react.createElement(RemovedIconWrapper, { className: "".concat(removedIconState === 'none' ? 'hidden' : inputValue === '' ? 'hidden' : '') },
                    react.createElement(RemovedIcon, { onClick: handleClearInput })))),
            (isVisible || (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === (document === null || document === void 0 ? void 0 : document.activeElement)) && options.length > 0 ? (react.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
                react.createElement(DropdownList, { "data-floating-placement": context.placement, ref: refs.setPopup, style: {
                        position: context.position,
                        top: context.y + ((floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.y) || 0),
                        left: context.x + ((floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.x) || 0),
                        display: context.isReferenceHidden ? 'none' : 'block',
                        width: context.position === 'fixed'
                            ? (((_b = refs.reference.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0) + 'px'
                            : '100%',
                        zIndex: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.zIndex) || 1099
                    } }, options.map(function (option, index) {
                    return (react.createElement(DropdownItem, { key: "".concat(option.companyName, "-").concat(index), onClick: function () {
                            isUserTouched.current = true;
                            setInputValue(option.companyName);
                            setSelectedLogo(option.companyLogoUrl || defaultLogo);
                            setElementVisible(false);
                            onChange(option);
                        } },
                        react.createElement(CompanyLogo, { width: 24, height: 24, src: option.companyLogoUrl || defaultLogo, alt: 'Company logo' }),
                        option.companyName));
                })))) : null)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/CompanySelect/index.js
'use client';






function FMCompanySelect(_a) {
    var name = _a.name; _a.width; var urlMeta = _a.urlMeta, apiEndPoint = _a.apiEndPoint, defaultLogo = _a.defaultLogo, renderOptions = _a.renderOptions, _b = _a.searchWithEmptyQuery, searchWithEmptyQuery = _b === void 0 ? false : _b, limit = _a.limit, rest = (0,_tslib/* __rest */._T)(_a, ["name", "width", "urlMeta", "apiEndPoint", "defaultLogo", "renderOptions", "searchWithEmptyQuery", "limit"]);
    var FIELD_KEY = {
        companyName: 'companyName',
        companyLogoUrl: 'companyLogoUrl'
    };
    var _c = (0,react.useContext)(FormContext), values = _c.values, setValues = _c.setValues, errors = _c.errors, onAnyChange = _c.onAnyChange, touched = _c.touched, setTouched = _c.setTouched, hasSubmittedRef = _c.hasSubmittedRef, forceShowError = _c.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        react.createElement(CompanySelect, (0,_tslib/* __assign */.pi)({}, rest, { limit: limit, companyName: values[name][FIELD_KEY.companyName], companyLogoUrl: values[name][FIELD_KEY.companyLogoUrl], msBasePath: urlMeta, searchWithEmptyQuery: searchWithEmptyQuery, apiEndPoint: apiEndPoint, defaultLogo: defaultLogo, renderOptions: renderOptions, onChange: function (value) {
                var _a;
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = value, _a)));
                onAnyChange(value, name);
            }, hasError: showError, onInputChange: function (value) {
                var _a, _b;
                var changedValue = (_a = {}, _a[FIELD_KEY.companyName] = value, _a);
                if (value === '') {
                    changedValue = '';
                }
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_b = {}, _b[name] = changedValue, _b)));
                onAnyChange(changedValue, name);
            }, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            } })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 1 modules
var components_Input = __webpack_require__(46779);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/DatePicker/index.js
'use client';







var DatePickerInput = function (props) {
    var _a = props.value, value = _a === void 0 ? '' : _a, _b = props.onClick, onClick = _b === void 0 ? function () { } : _b, _c = props.onChange, onChange = _c === void 0 ? function (_e) { } : _c, _d = props.onClear, onClear = _d === void 0 ? function () { } : _d, _f = props.label, label = _f === void 0 ? '' : _f, _g = props.isRequired, isRequired = _g === void 0 ? false : _g, _h = props.hasError, hasError = _h === void 0 ? false : _h, _j = props.onFocus, onFocus = _j === void 0 ? function () { } : _j, _k = props.disabled, disabled = _k === void 0 ? false : _k;
    return (react.createElement("div", { onClick: onClick },
        react.createElement(components_Input/* default */.Z, { type: 'text', value: value, onChange: function (value, e) {
                if (e) {
                    onChange(e);
                }
                else if (value === '') {
                    onClear();
                }
            }, label: label, disabled: disabled, isRequired: isRequired, hasError: hasError, onFocus: onFocus })));
};
function FMDatePickerComponents(props, ref) {
    var name = props.name, locale = props.locale, label = props.label, _a = props.pickerType, pickerType = _a === void 0 ? 'monthPicker' : _a, isRequired = props.isRequired, maxDate = props.maxDate, disabled = props.disabled;
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var setDate = function (date) {
        var _a;
        setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = date, _a)));
        onAnyChange(date, name);
    };
    var typeProps = pickerType === 'monthPicker'
        ? {
            showMonthYearPicker: true,
            dateFormat: 'MM/yyyy'
        }
        : {
            showYearPicker: true,
            dateFormat: 'yyyy'
        };
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    (0,react.useImperativeHandle)(ref, function () {
        return {
            setDate: setDate
        };
    }, [values]);
    return (react.createElement(react.Fragment, null,
        react.createElement((react_datepicker_min_default()), (0,_tslib/* __assign */.pi)({ selected: values[name], onChange: function (date) {
                if (date) {
                    setDate(new Date(date));
                }
                else {
                    setDate(null);
                }
            }, customInput: react.createElement(DatePickerInput, { onClear: function () { return setDate(null); }, label: label, isRequired: isRequired, hasError: showError, disabled: disabled }), showPopperArrow: false, disabled: disabled }, typeProps, { strictParsing: true, locale: locale, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            }, maxDate: maxDate })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}
var FMDatePicker = (0,react.forwardRef)(FMDatePickerComponents);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/I11lPhoneNumberInput/index.js + 3 modules
var I11lPhoneNumberInput = __webpack_require__(95300);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/I11lPhoneNumberInput/index.js
'use client';






function FMI11lPhoneNumberInput(_a) {
    var name = _a.name, language = _a.language, urlMeta = _a.urlMeta, floatingConfigs = _a.floatingConfigs, rest = (0,_tslib/* __rest */._T)(_a, ["name", "language", "urlMeta", "floatingConfigs"]);
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        react.createElement(I11lPhoneNumberInput/* default */.Z, (0,_tslib/* __assign */.pi)({}, rest, { value: values[name], language: language, urlMeta: urlMeta, onChange: function (value) {
                var _a;
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = value, _a)));
                onAnyChange(value, name);
            }, hasError: showError, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            }, floatingConfig: floatingConfigs })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/Input/index.js
'use client';






function FMInput(_a) {
    var name = _a.name; _a.width; var label = _a.label, trimValue = _a.trimValue, rest = (0,_tslib/* __rest */._T)(_a, ["name", "width", "label", "trimValue"]);
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        react.createElement(components_Input/* default */.Z, (0,_tslib/* __assign */.pi)({}, rest, { value: values[name], onChange: function (value) {
                var _a;
                var inputValue = value;
                if (trimValue) {
                    inputValue = value.trimStart();
                }
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = inputValue, _a)));
                onAnyChange(value, name);
            }, label: label, hasError: showError, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            } })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/InputYOE/index.js + 2 modules
var InputYOE = __webpack_require__(54352);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/InputYOE/index.js
'use client';






/**
 * Basic Input component
 */
function InputYOE_FMInput(_a) {
    var name = _a.name; _a.width; var label = _a.label, postfixText = _a.postfixText, _b = _a.thinLabel, thinLabel = _b === void 0 ? true : _b, rest = (0,_tslib/* __rest */._T)(_a, ["name", "width", "label", "postfixText", "thinLabel"]);
    var _c = (0,react.useContext)(FormContext), values = _c.values, setValues = _c.setValues, errors = _c.errors, onAnyChange = _c.onAnyChange, touched = _c.touched, setTouched = _c.setTouched, hasSubmittedRef = _c.hasSubmittedRef, forceShowError = _c.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        react.createElement(InputYOE/* default */.Z, (0,_tslib/* __assign */.pi)({}, rest, { defaultValue: values[name], onChange: function (value) {
                var _a;
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = value, _a)));
                onAnyChange(value, name);
            }, labelText: label || '', isError: showError, errorText: errors[name], postfixText: postfixText, thinLabel: thinLabel, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            } }))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/Input.css.js
var Input_css = __webpack_require__(76109);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleRadio/index.js + 9 modules
var MultipleRadio = __webpack_require__(49336);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/Select/Select.css.js
'use client';




var Label = styled_components_browser_esm/* default.label */.ZP.label(Select_css_templateObject_1 || (Select_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    display: block;\n"], ["\n    margin-bottom: 4px;\n    display: block;\n"])));
var Select_css_templateObject_1;


//# sourceMappingURL=Select.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/Select/index.js
'use client';








/**
 * Basic Input component
 */
function FMSelect(_a) {
    var name = _a.name; _a.width; var label = _a.label, options = _a.options; _a.floatingConfigs; var rest = (0,_tslib/* __rest */._T)(_a, ["name", "width", "label", "options", "floatingConfigs"]);
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var isRequired = rest.isRequired;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (react.createElement(react.Fragment, null,
        label && (react.createElement(Label, null,
            isRequired ? react.createElement(Input_css/* TextDanger */.f9, null, "*") : null,
            " ",
            label)),
        react.createElement(MultipleRadio/* default */.Z, (0,_tslib/* __assign */.pi)({ options: options, name: "".concat(label), hasError: showError, value: values[name], onChange: function (value) {
                var _a;
                setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = value.value, _a)));
                onAnyChange(value.value, name);
            }, onFocus: function () {
                var _a;
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            } }, rest)),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditor/TextEditor.module.scss.js
'use client';

var TextEditor_module_scss_s = {"editorContainer":"TextEditor-module_editorContainer__-0-63","isError":"TextEditor-module_isError__1O_EJ","toolbar":"TextEditor-module_toolbar__h9y2b","disabled":"TextEditor-module_disabled__2xwOq","separator":"TextEditor-module_separator__1GYSh","urlInput":"TextEditor-module_urlInput__1u3sO","urlConfirmButton":"TextEditor-module_urlConfirmButton__1YMRI","limitTextError":"TextEditor-module_limitTextError__2ADXg"};


//# sourceMappingURL=TextEditor.module.scss.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditor/textEditorUtils.js
'use client';



var TextEditorUtils = {
    getTextFromStringyContentState: function (content) {
        // Content could be escaped, e.g. the quote replaced by '&#34;', so we need to unescape it
        var unEscapedContent = content.replace(/&#34;/gi, '"');
        var isRawContentState = this.checkRawDraftContentState(unEscapedContent);
        if (isRawContentState) {
            try {
                var contentObject = JSON.parse(unEscapedContent);
                return contentObject.blocks.map(function (block) { return block.text; }).join('\n');
            }
            catch (error) {
                console.info('Error paring JSON', error);
                console.info('JSON to parse:', unEscapedContent);
            }
        }
        return unEscapedContent.trim();
    },
    checkRawDraftContentState: function (content) {
        var objectRegex = /^{.*}$/gi;
        var thisIsAnObject = !!content.match(objectRegex);
        return thisIsAnObject && content.includes('blocks') && content.includes('entityMap');
    },
    convertDraftRawContentToHTML: function (content, draftToHtml) {
        var unEscapedContent = content.replace(/&#34;/gi, '"');
        var isRawDraftContentState = this.checkRawDraftContentState(unEscapedContent);
        // If this is a raw draft content state
        if (isRawDraftContentState) {
            try {
                var rawContentState = JSON.parse(unEscapedContent);
                /**
                 * VNW-18264 Lost word when input special characters
                 * when type of rawContentState is article, draftToHtml return wrong
                 *
                 * @author Tran Minh Tri
                 * @since Oct 5, 2022
                 */
                rawContentState = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, rawContentState), { blocks: rawContentState.blocks.map(function (item) {
                        if (item.type === 'article')
                            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { type: 'unstyled' });
                        else
                            return item;
                    }) });
                var markup = draftToHtml(rawContentState);
                // Extra processes for some cases that `draftToHtml` does not work well
                var processedMarkup = markup
                    .replace(/\n/gi, '') // Remove \n
                    .replace(/<ins>/g, '<u>')
                    .replace(/<\/ins>/g, '</u>')
                    .replace(/<.?><img .*?><\/.?>/g, '') // Remove img tag inside any tag
                    .replace(/<img .*?>/g, ''); // Remove img tag
                var removedHTMLTag = processedMarkup.replace(/<\/?[^>]*>/g, '');
                if (removedHTMLTag === '') {
                    return removedHTMLTag;
                }
                return processedMarkup;
            }
            catch (error) {
                console.info('Error paring JSON', error);
                console.info('JSON to parse:', unEscapedContent);
            }
        }
        // Otherwise, it's might be html
        return unEscapedContent;
    }
};


//# sourceMappingURL=textEditorUtils.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditor/index.js
'use client';








var Link = function (props) {
    var url = props.contentState.getEntity(props.entityKey).getData().url;
    var handleLinkClick = function () {
        if (typeof window !== 'undefined') {
            window.open(url);
        }
    };
    return (react.createElement("a", { href: url, className: TextEditor_module_scss_s.link, onClick: handleLinkClick }, props.children));
};
var TextEditor = function (props, ref) {
    var draftJs = props.draftJs;
    function findLinkEntities(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function (character) {
            var entityKey = character.getEntity();
            return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
        }, callback);
    }
    var linkDecorator = new draftJs.CompositeDecorator([
        {
            strategy: findLinkEntities,
            component: Link
        }
    ]);
    var _a = props.content, content = _a === void 0 ? '' : _a, onChange = props.onChange, _b = props.onFocus, onFocus = _b === void 0 ? function (_e) { } : _b, onBlur = props.onBlur, onContentChange = props.onContentChange, limit = props.limit, _c = props.placeholder, placeholder = _c === void 0 ? '' : _c, isError = props.isError, lang = props.lang;
    var limitText = lang === constants/* ELanguage.EN */.Df.EN
        ? "Exceeded maximum character length of ".concat(limit)
        : "\u0110\u00E3 v\u01B0\u1EE3t qu\u00E1 \u0111\u1ED9 d\u00E0i k\u00FD t\u1EF1 t\u1ED1i \u0111a l\u00E0 ".concat(5000);
    /* Initial text */
    var _d = (0,react.useState)(draftJs.EditorState.createEmpty(linkDecorator)), editorState = _d[0], setEditorState = _d[1];
    var linkInputRef = (0,react.useRef)(null);
    /* Handle Editor Change */
    var _f = (0,react.useState)(0), remainingChars = _f[0], setRemainingChars = _f[1];
    var handleEditorChange = function (newEditorState) {
        if (limit) {
            var rawContentState = draftJs.convertToRaw(newEditorState.getCurrentContent());
            var text = TextEditorUtils.getTextFromStringyContentState(JSON.stringify(rawContentState));
            var remainingChars_1 = limit - text.length;
            setRemainingChars(remainingChars_1);
        }
        var editorStateWithDecorator = draftJs.EditorState.set(newEditorState, { decorator: linkDecorator });
        setEditorState(editorStateWithDecorator);
        // Compare the content before outputting the change
        var rawData = draftJs.convertToRaw(newEditorState.getCurrentContent());
        onChange && onChange(JSON.stringify(rawData));
        // We need to compare to check for the content difference.
        // It's because when the editorState changes, it includes both the content change, or the selection change, e.g.
        // focus, select...
        if (onContentChange) {
            var oldContent = editorState.getCurrentContent();
            var newContent = newEditorState.getCurrentContent();
            if (oldContent !== newContent) {
                onContentChange(JSON.stringify(rawData));
            }
        }
    };
    var debouncedContent = (0,hooks/* default */.ZP)([content], 300);
    (0,react.useEffect)(function () {
        if (typeof window !== 'undefined') {
            var isRawDraftContentState = TextEditorUtils.checkRawDraftContentState(content);
            // Convert content from string to Raw data
            if (isRawDraftContentState) {
                var currentRawData = JSON.stringify(draftJs.convertToRaw(editorState.getCurrentContent()));
                var contentIsDifferent = currentRawData !== content;
                if (contentIsDifferent) {
                    var newState = draftJs.EditorState.moveSelectionToEnd(draftJs.EditorState.createWithContent(draftJs.convertFromRaw(JSON.parse(content.replace(/&#34;/gi, '"')))));
                    handleEditorChange(newState);
                }
            }
            else {
                // Otherwise, it's HTML, convert it to data from HTML
                var blocksFromHTML = draftJs.convertFromHTML(content);
                var newContent = draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
                var newState = draftJs.EditorState.createWithContent(newContent);
                handleEditorChange(newState);
            }
        }
    }, [debouncedContent]);
    /* Handle Key Command */
    var handleKeyCommand = function (command) {
        var newState = draftJs.RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return 'handled';
        }
        return 'not-handled';
    };
    /* UI Toolbar */
    var onItalicClick = function (event) {
        event.stopPropagation();
        var newState = draftJs.RichUtils.toggleInlineStyle(editorState, 'ITALIC');
        handleEditorChange(newState);
    };
    var onUnderlineClick = function (event) {
        event.stopPropagation();
        var newState = draftJs.RichUtils.toggleInlineStyle(editorState, 'UNDERLINE');
        handleEditorChange(newState);
    };
    var onBoldClick = function (event) {
        event.stopPropagation();
        var newState = draftJs.RichUtils.toggleInlineStyle(editorState, 'BOLD');
        handleEditorChange(newState);
    };
    var onClickUnOrderList = function (event) {
        event.stopPropagation();
        var newState = draftJs.RichUtils.toggleBlockType(editorState, 'unordered-list-item');
        handleEditorChange(newState);
    };
    var onClickOrderList = function (event) {
        event.stopPropagation();
        var newState = draftJs.RichUtils.toggleBlockType(editorState, 'ordered-list-item');
        handleEditorChange(newState);
    };
    var _g = (0,react.useState)(false), showURLInput = _g[0], setShowURLInput = _g[1];
    var _h = (0,react.useState)(''), urlValue = _h[0], setUrlValue = _h[1];
    var promptForLink = function (event) {
        event.preventDefault();
        var selection = editorState.getSelection();
        // If there is any text selected
        if (!selection.isCollapsed()) {
            var contentState = editorState.getCurrentContent();
            var startKey = editorState.getSelection().getStartKey();
            var startOffset = editorState.getSelection().getStartOffset();
            var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
            var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
            var url = '';
            if (linkKey) {
                var linkInstance = contentState.getEntity(linkKey);
                url = linkInstance.getData().url;
            }
            setShowURLInput(true);
            setUrlValue(url);
            setTimeout(function () { var _a; return (_a = linkInputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    };
    var onURLChange = function (e) { return setUrlValue(e.target.value); };
    var confirmLink = function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        var contentState = editorState.getCurrentContent();
        var contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url: urlValue });
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var newEditorState = draftJs.EditorState.set(editorState, {
            currentContent: contentStateWithEntity
        });
        setShowURLInput(false);
        setUrlValue('');
        handleEditorChange(draftJs.RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
    };
    var onLinkInputKeyDown = function (e) {
        if (e.key === 'enter') {
            confirmLink();
        }
    };
    // const getEntityKeyAtCurrentSelection = () => {
    //     const selection = editorState.getSelection()
    //     const contentState = editorState.getCurrentContent()
    //     const anchorOffset = selection.getAnchorOffset()
    //     const currentBlockKey = selection.getAnchorKey()
    //     const currentBlock = contentState.getBlockForKey(currentBlockKey)
    //     const currentEntity = currentBlock.getEntityAt(anchorOffset)
    //     return currentEntity
    // }
    var onClickRemoveLink = function (event) {
        event.preventDefault();
        event.stopPropagation();
        var selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            // Remove the link
            var newState = draftJs.RichUtils.toggleLink(editorState, selection, null);
            handleEditorChange(newState);
            // Clear the link input
            setUrlValue('');
            // Collapse the link input
            setShowURLInput(false);
        }
    };
    /* Handle Focus */
    var editorRef = (0,react.useRef)(null);
    var _j = (0,react.useState)(false), hasSelection = _j[0], setHasSelection = _j[1];
    var handleEditorContainerClick = function (event) {
        var _a;
        event.stopPropagation();
        // Focus on the editor
        (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        // Check the current selection
        var selection = editorState.getSelection();
        setHasSelection(!selection.isCollapsed());
    };
    var handleEditorContainerKeyUp = function () {
        // Check the current selection
        var selection = editorState.getSelection();
        setHasSelection(!selection.isCollapsed());
    };
    (0,react.useImperativeHandle)(ref, function () {
        return { isError: remainingChars < 0 };
    });
    /* Render */
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: "".concat(TextEditor_module_scss_s.editorContainer, " ").concat(isError && TextEditor_module_scss_s.isError), onClick: handleEditorContainerClick, onKeyUp: handleEditorContainerKeyUp, onBlur: function () { return onBlur && onBlur(); }, onFocus: function (event) {
                event.preventDefault();
                onFocus(event);
            } },
            react.createElement("div", { className: TextEditor_module_scss_s.toolbar },
                react.createElement("span", { onClick: onBoldClick },
                    react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                        react.createElement("path", { d: 'M8,17 L8,7 L11.7707948,7 C13.0770244,7 14.0677723,7.23236947 14.7430684,7.69711538 C15.4183644,8.1618613 15.7560074,8.84294423 15.7560074,9.74038462 C15.7560074,10.2303138 15.6204573,10.6618571 15.349353,11.0350275 C15.0782488,11.4081978 14.7011731,11.6817757 14.2181146,11.8557692 C14.7701814,11.983975 15.205174,12.242672 15.5231054,12.6318681 C15.8410367,13.0210642 16,13.4972499 16,14.0604396 C16,15.0219828 15.6697507,15.7499975 15.0092421,16.2445055 C14.3487336,16.7390135 13.4072766,16.9908424 12.1848429,17 L8,17 Z M10.2181146,12.6456044 L10.2181146,15.3447802 L12.1182994,15.3447802 C12.6407913,15.3447802 13.0486738,15.2291678 13.3419593,14.9979396 C13.6352448,14.7667113 13.7818854,14.4473464 13.7818854,14.0398352 C13.7818854,13.1240797 13.2717241,12.6593407 12.2513863,12.6456044 L10.2181146,12.6456044 Z M10.2181146,11.1895604 L11.8595194,11.1895604 C12.9784406,11.1712453 13.5378928,10.7568722 13.5378928,9.94642857 C13.5378928,9.4931296 13.3961813,9.1668966 13.1127542,8.96771978 C12.829327,8.76854296 12.3820117,8.66895604 11.7707948,8.66895604 L10.2181146,8.66895604 L10.2181146,11.1895604 Z' }))),
                react.createElement("span", { onClick: onItalicClick },
                    react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                        react.createElement("path", { d: 'M10.1737981,15.5714286 L11.5584135,8.42857143 L9.95714286,8.42857143 C9.7598983,8.42857143 9.6,8.26867312 9.6,8.07142857 L9.6,7.35714286 C9.6,7.1598983 9.7598983,7 9.95714286,7 L15.6428571,7 C15.8401017,7 16,7.1598983 16,7.35714286 L16,8.07142857 C16,8.26867312 15.8401017,8.42857143 15.6428571,8.42857143 L13.7330228,8.42857143 L12.3484075,15.5714286 L14.0428571,15.5714286 C14.2401017,15.5714286 14.4,15.7313269 14.4,15.9285714 L14.4,16.6428571 C14.4,16.8401017 14.2401017,17 14.0428571,17 L8.35714286,17 C8.1598983,17 8,16.8401017 8,16.6428571 L8,15.9285714 C8,15.7313269 8.1598983,15.5714286 8.35714286,15.5714286 L10.1737981,15.5714286 Z' }))),
                react.createElement("span", { onClick: onUnderlineClick },
                    react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                        react.createElement("path", { d: 'M16.3453125,7 L16.3453125,13.402819 C16.3453125,14.4666225 15.951127,15.3078604 15.1627441,15.9265579 C14.3743613,16.5452553 13.2972725,16.8545994 11.9314453,16.8545994 C10.586712,16.8545994 9.51885161,16.5541573 8.72783203,15.9532641 C7.93681245,15.3523709 7.53339852,14.5267115 7.51757812,13.4762611 L7.51757812,7 L9.890625,7 L9.890625,13.4161721 C9.890625,14.0526738 10.0712384,14.5166899 10.4324707,14.8082344 C10.793703,15.0997789 11.2933562,15.245549 11.9314453,15.245549 C13.2656317,15.245549 13.9432616,14.6535668 13.9643555,13.4695846 L13.9643555,7 L16.3453125,7 Z M7.87982196,17.4807122 L16.120178,17.4807122 C16.3299479,17.4807122 16.5,17.6507642 16.5,17.8605341 L16.5,18.620178 C16.5,18.8299479 16.3299479,19 16.120178,19 L7.87982196,19 C7.67005208,19 7.5,18.8299479 7.5,18.620178 L7.5,17.8605341 C7.5,17.6507642 7.67005208,17.4807122 7.87982196,17.4807122 Z' }))),
                react.createElement("i", { className: TextEditor_module_scss_s.separator }),
                react.createElement("span", { onClick: onClickOrderList },
                    react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                        react.createElement("path", { d: 'M9,6.2 L9,7.8 C9,7.91045695 9.08954305,8 9.2,8 L19.8,8 C19.9104569,8 20,7.91045695 20,7.8 L20,6.2 C20,6.08954305 19.9104569,6 19.8,6 L9.2,6 C9.08954305,6 9,6.08954305 9,6.2 Z M9.2,18 L19.8,18 C19.9104569,18 20,17.9104569 20,17.8 L20,16.2 C20,16.0895431 19.9104569,16 19.8,16 L9.2,16 C9.08954305,16 9,16.0895431 9,16.2 L9,17.8 C9,17.9104569 9.08954305,18 9.2,18 Z M9.2,13 C9.08954305,13 9,12.9104569 9,12.8 L9,11.2 C9,11.0895431 9.08954305,11 9.2,11 L19.8,11 C19.9104569,11 20,11.0895431 20,11.2 L20,12.8 C20,12.9104569 19.9104569,13 19.8,13 L9.2,13 Z M4,16 L4,15 L7,15 L7,19 L4,19 L4,18 L6,18 L6,17.5 L5,17.5 L5,16.5 L6,16.5 L6,16 L4,16 Z M5,9 L5,6 L4,6 L4,5 L6,5 L6,9 L5,9 Z M4,11 L4,10 L7,10 L7,10.9 L5.2,13 L7,13 L7,14 L4,14 L4,13.1 L5.8,11 L4,11 Z' }))),
                react.createElement("span", { onClick: onClickUnOrderList },
                    react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                        react.createElement("path", { d: 'M9,6.7 L9,8.3 C9,8.41045695 9.08954305,8.5 9.2,8.5 L19.8,8.5 C19.9104569,8.5 20,8.41045695 20,8.3 L20,6.7 C20,6.58954305 19.9104569,6.5 19.8,6.5 L9.2,6.5 C9.08954305,6.5 9,6.58954305 9,6.7 Z M9.2,18.5 L19.8,18.5 C19.9104569,18.5 20,18.4104569 20,18.3 L20,16.7 C20,16.5895431 19.9104569,16.5 19.8,16.5 L9.2,16.5 C9.08954305,16.5 9,16.5895431 9,16.7 L9,18.3 C9,18.4104569 9.08954305,18.5 9.2,18.5 Z M9.2,13.5 C9.08954305,13.5 9,13.4104569 9,13.3 L9,11.7 C9,11.5895431 9.08954305,11.5 9.2,11.5 L19.8,11.5 C19.9104569,11.5 20,11.5895431 20,11.7 L20,13.3 C20,13.4104569 19.9104569,13.5 19.8,13.5 L9.2,13.5 Z M5.5,9 C4.67157288,9 4,8.32842712 4,7.5 C4,6.67157288 4.67157288,6 5.5,6 C6.32842712,6 7,6.67157288 7,7.5 C7,8.32842712 6.32842712,9 5.5,9 Z M5.5,14 C4.67157288,14 4,13.3284271 4,12.5 C4,11.6715729 4.67157288,11 5.5,11 C6.32842712,11 7,11.6715729 7,12.5 C7,13.3284271 6.32842712,14 5.5,14 Z M5.5,19 C4.67157288,19 4,18.3284271 4,17.5 C4,16.6715729 4.67157288,16 5.5,16 C6.32842712,16 7,16.6715729 7,17.5 C7,18.3284271 6.32842712,19 5.5,19 Z' }))),
                props.showHyperlinkInput ? (react.createElement(react.Fragment, null,
                    react.createElement("i", { className: TextEditor_module_scss_s.separator }),
                    react.createElement("span", { onClick: promptForLink, className: hasSelection ? '' : TextEditor_module_scss_s.disabled },
                        react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                            react.createElement("path", { d: 'M16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 Z M13.943728,15.6737311 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L8.32626889,10.056272 L9.45091165,11.1809148 L11.1361494,9.49567706 L10.0115066,8.3710343 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L15.6289657,13.9884934 L15.6301166,13.9896443 L13.9448789,15.6748821 L13.943728,15.6737311 Z M13.943728,15.6737311 L15.6289657,13.9884934 L14.5054739,12.8650016 L12.8202362,14.5502393 L13.943728,15.6737311 Z M13.9658723,10.0344648 C13.6556286,9.72422109 13.1526242,9.72422109 12.8423805,10.0344648 L10.033651,12.8431943 C9.72340725,13.153438 9.72340725,13.6564425 10.033651,13.9666862 C10.3438947,14.2769299 10.8468991,14.2769299 11.1571428,13.9666862 L13.9658723,11.1579566 C14.276116,10.8477129 14.276116,10.3447085 13.9658723,10.0344648 Z' }))),
                    showURLInput && hasSelection && (react.createElement("div", { className: TextEditor_module_scss_s.urlInputContainer },
                        react.createElement("input", { onChange: onURLChange, ref: linkInputRef, className: TextEditor_module_scss_s.urlInput, type: 'text', onClick: function (event) { return event.stopPropagation(); }, value: urlValue, onKeyDown: onLinkInputKeyDown }),
                        react.createElement(Button/* default */.Z, { className: TextEditor_module_scss_s.urlConfirmButton, onClick: function (e) { return e.stopPropagation(); }, onMouseDown: confirmLink }, props.lang === 'en' ? 'Link' : 'Liên Kết'))),
                    react.createElement("span", { onClick: onClickRemoveLink, className: hasSelection ? '' : TextEditor_module_scss_s.disabled },
                        react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                            react.createElement("path", { d: 'M11.7289758,8.90054871 L10.605484,7.7770569 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L16.2229431,13.394516 L15.0994513,12.2710242 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L11.7289758,8.90054871 Z M8.90054871,11.7289758 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L12.2710242,15.0994513 L13.394516,16.2229431 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L7.7770569,10.605484 L8.90054871,11.7289758 Z M13.9760363,11.1476092 L12.8527279,10.0243008 C13.1637094,9.72425892 13.6590544,9.72764691 13.9658723,10.0344648 C14.2726902,10.3412827 14.2760782,10.8366277 13.9760363,11.1476092 Z M11.1476231,13.9760503 C10.8366936,14.2768978 10.3407412,14.2737764 10.033651,13.9666862 C9.72656068,13.6595959 9.72343931,13.1636435 10.0242868,12.852714 L11.1476231,13.9760503 Z M6.43431458,7.56568542 L7.56568542,6.43431458 L17.5656854,16.4343146 L16.4343146,17.5656854 L6.43431458,7.56568542 Z' }))))) : null),
            react.createElement(draftJs.Editor, { ref: editorRef, textDirectionality: 'LTR', editorState: editorState, placeholder: placeholder, handleKeyCommand: handleKeyCommand, onChange: handleEditorChange })),
        limit && (react.createElement("div", { className: "form-text ".concat(remainingChars < 0 ? TextEditor_module_scss_s.limitTextError : ''), style: { lineHeight: '17px' } },
            limit - remainingChars,
            "/",
            limit,
            " ",
            react.createElement("br", null),
            remainingChars < 0 && limitText))));
};
var TextEditor$1 = (0,react.forwardRef)(TextEditor);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/TextEditor/TextEditor.module.scss.js
'use client';

var TextEditor_TextEditor_module_scss_s = {"labelWrapper":"TextEditor-module_labelWrapper__1n_jm"};


//# sourceMappingURL=TextEditor.module.scss.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormManager/TextEditor/index.js
'use client';







var FMTextEditor = function (_a) {
    var name = _a.name, label = _a.label, isRequired = _a.isRequired, onError = _a.onError, textEditorRef = _a.textEditorRef, rest = (0,_tslib/* __rest */._T)(_a, ["name", "label", "isRequired", "onError", "textEditorRef"]);
    var _b = (0,react.useContext)(FormContext), values = _b.values, setValues = _b.setValues, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError, errors = _b.errors;
    var content = values[name] || '';
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    var onChange = function (content) {
        var _a;
        setValues((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), (_a = {}, _a[name] = content, _a)));
        onAnyChange(content, name);
        if (onError) {
            onError(showError);
        }
    };
    /* Render */
    return (react.createElement("div", null,
        label ? (react.createElement("div", { className: TextEditor_TextEditor_module_scss_s.labelWrapper },
            isRequired ? react.createElement("span", { className: 'text-danger' }, "*") : null,
            " ",
            react.createElement("label", null, label))) : null,
        react.createElement(TextEditor$1, (0,_tslib/* __assign */.pi)({}, rest, { ref: textEditorRef, content: content, onChange: onChange, onFocus: function (event) {
                var _a;
                event.preventDefault();
                setTouched((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, touched), (_a = {}, _a[name] = true, _a)));
            }, isError: showError })),
        showError && react.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/index.js
var icons = __webpack_require__(97228);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormModal/FormModal.module.css.js
'use client';

var FormModal_module_css_s = {"formModal":"FormModal-module_formModal__2kIX2","formModalOpened":"FormModal-module_formModalOpened__2e08E","header":"FormModal-module_header__3QRnW","title":"FormModal-module_title__3Qtfe","body":"FormModal-module_body__15VYG","footer":"FormModal-module_footer__1jLDY","button":"FormModal-module_button__3nBGH","saveBtn":"FormModal-module_saveBtn__15V20","cancelBtn":"FormModal-module_cancelBtn__xEQSK","fullFlex":"FormModal-module_fullFlex__7WYlx","disabledBtn":"FormModal-module_disabledBtn__3mR9s","vnwStopScrollingIOS":"FormModal-module_vnwStopScrollingIOS__c62Oc"};


//# sourceMappingURL=FormModal.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormModal/index.js
'use client';






/* eslint-disable no-unused-vars */
var FormModal = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, _b = props.children, children = _b === void 0 ? null : _b, title = props.title, _c = props.onBack, onBack = _c === void 0 ? function () { } : _c, onSave = props.onSave, onDelete = props.onDelete, submitFormId = props.submitFormId, isDisabledSaveBtn = props.isDisabledSaveBtn, langCode = props.langCode, closeText = props.closeText, textData = props.textData;
    var ANIMATION_DURATION = FormModal.ANIMATION_DURATION;
    var _d = (0,react.useState)(false), transforming = _d[0], setTransforming = _d[1];
    (0,react.useEffect)(function () {
        var body = document.getElementsByTagName('body')[0];
        if (isOpen) {
            // body.style.overflow = 'hidden'
            // body.style.touchAction = 'none'
            body.setAttribute('style', 'touch-action:none; -ms-touch-action: none; overflow: hidden; height: 100%; -webkit-overflow-scrolling: touch;');
            setTimeout(function () {
                setTransforming(true);
            }, 50);
        }
        else {
            setTimeout(function () {
                setTransforming(false);
                // body.style.overflow = ''
                // body.style.touchAction = 'auto'
                body.setAttribute('style', 'touch-action:auto; -ms-touch-action: auto; overflow: visible');
            }, ANIMATION_DURATION);
        }
        return function () {
            body.setAttribute('style', 'touch-action:auto; -ms-touch-action: auto; overflow: visible');
        };
    }, [isOpen]);
    if (!isOpen && !transforming)
        return null;
    var saveText = (textData === null || textData === void 0 ? void 0 : textData.saveText) ? textData === null || textData === void 0 ? void 0 : textData.saveText : langCode === 'vi' ? 'Lưu' : 'Save';
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    return react_dom.createPortal(react.createElement("div", { className: "".concat(FormModal_module_css_s.formModal, " ").concat(isOpen && transforming ? FormModal_module_css_s.formModalOpened : null) },
        react.createElement("div", { className: FormModal_module_css_s.header },
            react.createElement("div", { style: { cursor: 'pointer' }, onClick: function () { return onBack(); } },
                react.createElement(icons/* IconArrowLeft */.D6, { width: 30, height: 30 })),
            react.createElement("span", { className: FormModal_module_css_s.title }, title),
            onDelete ? (react.createElement("div", { style: { cursor: 'pointer' }, onClick: function () { return onDelete(); } },
                react.createElement(icons/* IconDeleteGrey */.A_, { width: 30, height: 30 }))) : null),
        react.createElement("div", { className: FormModal_module_css_s.body }, children),
        react.createElement("div", { className: FormModal_module_css_s.footer },
            react.createElement("div", { className: "".concat(FormModal_module_css_s.button, " ").concat(FormModal_module_css_s.cancelBtn, " ").concat(!onSave && !submitFormId ? FormModal_module_css_s.fullFlex : ''), onClick: function () { return onBack(); } }, closeText || (langCode === 'vi' ? 'Hủy' : 'Cancel')),
            onSave ? (react.createElement("div", { className: "".concat(FormModal_module_css_s.button, " ").concat(FormModal_module_css_s.saveBtn, " ").concat(isDisabledSaveBtn ? FormModal_module_css_s.disabledBtn : ''), onClick: function () {
                    if (!isDisabledSaveBtn) {
                        onSave();
                    }
                } }, saveText)) : null,
            submitFormId && (react.createElement("button", { className: "".concat(FormModal_module_css_s.button, " ").concat(FormModal_module_css_s.saveBtn), form: submitFormId, type: 'submit' }, saveText)))), bodyNode);
};
FormModal.ANIMATION_DURATION = 400;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormView/styled.css.js
'use client';




var StyledFormView = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_1 || (styled_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    background: #ffffff;\n    position: relative;\n    transition: box-shadow 0.3s;\n    cursor: ", ";\n    :hover,\n    :focus {\n        /* box-shadow: 0 1px 10px 0 ", "; */\n        background: #fcfcfc;\n        .icon-group {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        padding: 8px;\n    }\n"], ["\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    background: #ffffff;\n    position: relative;\n    transition: box-shadow 0.3s;\n    cursor: ", ";\n    :hover,\n    :focus {\n        /* box-shadow: 0 1px 10px 0 ", "; */\n        background: #fcfcfc;\n        .icon-group {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        padding: 8px;\n    }\n"])), function (props) { return (!props.isMobile ? 'pointer' : 'auto'); }, function (props) { return (props.hasError ? 'rgba(252,205,205,0.8)' : 'rgba(0, 0, 0, 0.1)'); });
var StyledBlock = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_2 || (styled_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 8px;\n\n    :first-child {\n        margin-left: 0;\n    }\n"], ["\n    margin-left: 8px;\n\n    :first-child {\n        margin-left: 0;\n    }\n"])));
var MainContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_3 || (styled_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding-left: 16px;\n    padding-right: 40px;\n    line-height: 1.5;\n    flex-grow: 1;\n    flex-basis: 0;\n    min-width: 0;\n"], ["\n    position: relative;\n    padding-left: 16px;\n    padding-right: 40px;\n    line-height: 1.5;\n    flex-grow: 1;\n    flex-basis: 0;\n    min-width: 0;\n"])));
var StyledMainContent = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_4 || (styled_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n"], ["\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n"])));
var Title = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_5 || (styled_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 600;\n    max-width: calc(85%);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-right: 8px;\n"], ["\n    font-size: 16px;\n    font-weight: 600;\n    max-width: calc(85%);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-right: 8px;\n"])));
var IconGroup = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_6 || (styled_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: ", ";\n    /* visibility: ", "; */\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    transition: all 0.3s;\n    display: inline-flex;\n    align-items: ", ";\n    gap: 2px;\n    z-index: 4;\n"], ["\n    opacity: ", ";\n    /* visibility: ", "; */\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    transition: all 0.3s;\n    display: inline-flex;\n    align-items: ", ";\n    gap: 2px;\n    z-index: 4;\n"])), function (props) { return (props.isMobile ? 1 : 0); }, function (props) { return (props.isMobile ? 'visible' : 'hidden'); }, function (_a) {
    var position = _a.position;
    return position;
});
styled_components_browser_esm/* default.span */.ZP.span(styled_css_templateObject_7 || (styled_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 8px;\n    display: inline-flex;\n\n    svg {\n        transform: rotate(", ");\n        transition: transform 0.3s ease;\n    }\n"], ["\n    margin-left: 8px;\n    display: inline-flex;\n\n    svg {\n        transform: rotate(", ");\n        transition: transform 0.3s ease;\n    }\n"])), function (props) { return (props.isRotate ? '180deg' : '0'); });
var Extend = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_8 || (styled_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex-basis: 100%;\n    margin-top: ", ";\n    height: ", ";\n    overflow: hidden;\n"], ["\n    flex-basis: 100%;\n    margin-top: ", ";\n    height: ", ";\n    overflow: hidden;\n"])), function (_a) {
    var isExtend = _a.isExtend;
    return (isExtend ? '8px' : '0');
}, function (_a) {
    var isExtend = _a.isExtend;
    return (isExtend ? 'max-content' : '0');
});
var ViewContainer = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_9 || (styled_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n"])));
var ExternalTag = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_10 || (styled_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    ", "\n"], ["\n    position: absolute;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return isMobile
        ? "\n    top: 8px;\n    right: 8px;\n    "
        : "\n    top: 16px;\n    right: 16px;\n    ";
});
var BodyBottomSheet = styled_components_browser_esm/* default.div */.ZP.div(styled_css_templateObject_11 || (styled_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: start;\n    gap: 6px;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: start;\n    gap: 6px;\n    width: 100%;\n"])));
var ItemBottomSheet = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 2px;\n    cursor: pointer;\n"], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 2px;\n    cursor: pointer;\n"])));
var styled_css_templateObject_1, styled_css_templateObject_2, styled_css_templateObject_3, styled_css_templateObject_4, styled_css_templateObject_5, styled_css_templateObject_6, styled_css_templateObject_7, styled_css_templateObject_8, styled_css_templateObject_9, styled_css_templateObject_10, styled_css_templateObject_11, templateObject_12;


//# sourceMappingURL=styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/Pencil/index.js
'use client';



var Pencil = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 20, height: height !== null && height !== void 0 ? height : 20, viewBox: '0 0 20 20', fill: 'none' },
        react.createElement("path", { d: 'M15.2188 2C14.8776 2 14.5364 2.13029 14.276 2.39062L12.6667 4L16 7.33333L17.6094 5.72396C18.13 5.20329 18.13 4.35921 17.6094 3.83854L16.1615 2.39062C15.9011 2.13029 15.5599 2 15.2188 2ZM11.3333 5.33333L3.50651 13.1602C3.50651 13.1602 4.11835 13.1053 4.34635 13.3333C4.57435 13.5613 4.38667 15.0533 4.66667 15.3333C4.94667 15.6133 6.42926 15.4162 6.64193 15.6289C6.85459 15.8416 6.83984 16.4935 6.83984 16.4935L14.6667 8.66667L11.3333 5.33333ZM2.66667 15.3333L2.03776 17.1146C2.01304 17.1849 2.00027 17.2588 2 17.3333C2 17.5101 2.07024 17.6797 2.19526 17.8047C2.32029 17.9298 2.48986 18 2.66667 18C2.74118 17.9997 2.81512 17.987 2.88542 17.9622C2.88759 17.9614 2.88976 17.9605 2.89193 17.9596L2.90885 17.9544C2.91016 17.9536 2.91146 17.9527 2.91276 17.9518L4.66667 17.3333L3.66667 16.3333L2.66667 15.3333Z', fill: color !== null && color !== void 0 ? color : '#888888' })));
};
var Pencil$1 = react.memo(Pencil);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/Trash/index.js
'use client';



var Trash = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 20, height: height !== null && height !== void 0 ? height : 20, viewBox: '0 0 20 20', fill: 'none' },
        react.createElement("path", { d: 'M8.66668 2.00006C8.57837 1.99886 8.4907 2.01522 8.40877 2.04819C8.32683 2.08115 8.25227 2.13007 8.18939 2.19209C8.12652 2.25412 8.0766 2.32801 8.04252 2.40949C8.00845 2.49097 7.9909 2.57841 7.9909 2.66673H4.00001C3.91167 2.66548 3.82396 2.6818 3.74199 2.71474C3.66001 2.74768 3.58539 2.79659 3.52248 2.85862C3.45957 2.92065 3.40961 2.99457 3.37551 3.07607C3.34141 3.15758 3.32385 3.24504 3.32385 3.33339C3.32385 3.42174 3.34141 3.50921 3.37551 3.59072C3.40961 3.67222 3.45957 3.74614 3.52248 3.80817C3.58539 3.8702 3.66001 3.9191 3.74199 3.95205C3.82396 3.98499 3.91167 4.00131 4.00001 4.00006H16C16.0884 4.00131 16.1761 3.98499 16.258 3.95205C16.34 3.9191 16.4146 3.8702 16.4775 3.80817C16.5405 3.74614 16.5904 3.67222 16.6245 3.59072C16.6586 3.50921 16.6762 3.42174 16.6762 3.33339C16.6762 3.24504 16.6586 3.15758 16.6245 3.07607C16.5904 2.99457 16.5405 2.92065 16.4775 2.85862C16.4146 2.79659 16.34 2.74768 16.258 2.71474C16.1761 2.6818 16.0884 2.66548 16 2.66673H12.0091C12.0091 2.57841 11.9916 2.49097 11.9575 2.40949C11.9234 2.32801 11.8735 2.25412 11.8106 2.19209C11.7478 2.13007 11.6732 2.08115 11.5913 2.04819C11.5093 2.01522 11.4217 1.99886 11.3333 2.00006H8.66668ZM4.00001 5.33339V16.0001C4.00001 16.7367 4.59668 17.3334 5.33335 17.3334H14.6667C15.4033 17.3334 16 16.7367 16 16.0001V5.33339H4.00001Z', fill: color !== null && color !== void 0 ? color : '#888888' })));
};
var Trash$1 = react.memo(Trash);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ThreeDotIcon/index.js
var ThreeDotIcon = __webpack_require__(79229);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/BottomSheet/index.js + 2 modules
var BottomSheet = __webpack_require__(6031);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormView/translations.js
'use client';

/* eslint-disable prettier/prettier */
var translations_translations = {
    Cancel: 'Hủy',
    Edit: 'Sửa',
    Delete: 'Xoá'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormView/index.js
'use client';











function FormView(_a) {
    var title = _a.title, children = _a.children, vBlocks = _a.vBlocks, handleEdit = _a.handleEdit, handleDelete = _a.handleDelete, handleClick = _a.handleClick, extendContent = _a.extendContent, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, _c = _a.hasError, hasError = _c === void 0 ? false : _c, _d = _a.hiddenEdit, hiddenEdit = _d === void 0 ? false : _d, className = _a.className, style = _a.style, customAction = _a.customAction, externalTag = _a.externalTag, mode = _a.mode, _e = _a.lang, lang = _e === void 0 ? constants/* ELanguage.VI */.Df.VI : _e;
    var _f = (customAction || {}).position, position = _f === void 0 ? 'start' : _f;
    var _g = (0,react.useState)(false), isExendted = _g[0], setIsExtended = _g[1];
    var _h = (0,react.useState)(false), isShowBottomSheet = _h[0], setIsShowBottomSheet = _h[1];
    // const handleClickWholeBox = isMobile ? () => {} : handleClick
    // const handleClickIconEdit = isMobile ? handleClick : () => {}
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return translations_translations[text];
        }
    };
    var handleClickOnBox = function (e) {
        e.preventDefault();
        setIsExtended(!isExendted);
    };
    var handleShowBottomSheet = function () {
        setIsShowBottomSheet(!isShowBottomSheet);
    };
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    return (react.createElement(react.Fragment, null,
        react.createElement(StyledFormView, { isMobile: isMobile, hasError: hasError, className: className, style: style },
            externalTag ? react.createElement(ExternalTag, { isMobile: isMobile }, externalTag) : null,
            react.createElement(ViewContainer, { onClick: handleClickOnBox },
                vBlocks.map(function (block, index) { return (react.createElement(StyledBlock, { key: index }, block)); }),
                react.createElement(MainContentWrapper, null,
                    react.createElement(StyledMainContent, null,
                        react.createElement(Title, null,
                            title,
                            " "),
                        children),
                    react.createElement(IconGroup, { className: 'icon-group', isMobile: isMobile, position: position }, !isMobile ? (react.createElement(react.Fragment, null,
                        !hiddenEdit ? (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: mode === 'myProfile' ? handleEdit : handleClick },
                            react.createElement(Pencil$1, null))) : null,
                        mode === 'myProfile' && (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: handleDelete },
                            react.createElement(Trash$1, null))))) : (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: handleShowBottomSheet },
                        react.createElement(ThreeDotIcon/* default */.Z, null))))),
                extendContent ? react.createElement(Extend, { isExtend: isExendted !== null && isExendted !== void 0 ? isExendted : false }, extendContent) : null)),
        isShowBottomSheet && (react.createElement(BottomSheet/* default */.Z, { onClose: handleShowBottomSheet, isOpen: isShowBottomSheet, header: '', 
            // footer={<></>}
            footerOptions: {
                buttonType: 'default',
                text: t('Cancel')
            } },
            react.createElement(BodyBottomSheet, null,
                !hiddenEdit ? (react.createElement(ItemBottomSheet, { onClick: mode === 'myProfile' ? handleEdit : handleClick },
                    react.createElement(Button/* default */.Z, { type: 'transparent', isRounded: true, isIcon: true },
                        react.createElement(Pencil$1, null)),
                    ' ',
                    t('Edit'))) : null,
                mode === 'myProfile' && (react.createElement(ItemBottomSheet, { onClick: handleDelete },
                    react.createElement(Button/* default */.Z, { type: 'transparent', isRounded: true, isIcon: true },
                        react.createElement(Trash$1, null)),
                    t('Delete'))))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlertBar/icon.js
'use client';



function Icon() {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '92', height: '65' },
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'a', x1: '50%', x2: '50%', y1: '0%', y2: '100%' },
                react.createElement("stop", { offset: '0%', stopColor: '#0E7CCD' }),
                react.createElement("stop", { offset: '100%', stopColor: '#005AFF' })),
            react.createElement("path", { id: 'b', d: 'M.126.063h2.667V2.72H.126z' })),
        react.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { transform: 'translate(20.984 7.875)' },
                react.createElement("ellipse", { cx: '24.276', cy: '24.188', fill: 'url(#a)', opacity: '.2', rx: '24.276', ry: '24.188' }),
                react.createElement("g", { fillRule: 'nonzero', transform: 'translate(11.856 11.813)' },
                    react.createElement("path", { fill: '#005AFF', d: 'M25.271 17.848V8.253a4.806 4.806 0 0 0-4.813-4.798H7.822c-2.658 0-4.814 2.148-4.814 4.798v9.595h22.263z' }),
                    react.createElement("path", { fill: '#2196F3', d: 'M4.814 17.248a.6.6 0 0 1-.602.6H.602a.6.6 0 1 1 0-1.2h3.61a.6.6 0 0 1 .602.6z' }),
                    react.createElement("path", { fill: '#0D47A1', d: 'M7.385 4.607c-2.118 0-3.84 1.627-3.84 3.628v8.466h7.68V8.235c0-2-1.722-3.628-3.84-3.628z' }),
                    react.createElement("g", { fill: '#FF3D00', transform: 'translate(14.18)' },
                        react.createElement("path", { d: 'M.591 0h3.545v2.448H.591z' }),
                        react.createElement("path", { d: 'M.591 1.224h1.182v6.731H.591z' }),
                        react.createElement("ellipse", { cx: '1.182', cy: '8.566', rx: '1.182', ry: '1.224' })),
                    react.createElement("circle", { cx: '15.361', cy: '8.638', fill: '#DD2C00', r: '1' }),
                    react.createElement("path", { fill: '#FF7D55', d: 'M12.998 17.853h2.954v6.335h-2.954z' }),
                    react.createElement("path", { fill: '#FFA726', d: 'M12.998 18.429h2.954v1.152h-2.954z' }),
                    react.createElement("path", { fill: '#CFD8DC', d: 'M5.908 9.879v5.582c0 .635.576 1.24 1.182 1.24h4.135V8.638H7.09c-.606 0-1.182.605-1.182 1.24z' }),
                    react.createElement("path", { fill: '#78909C', d: 'M5.908 10.278v.587l5.317 4.108V13.8L6.037 9.79c-.08.153-.129.318-.129.488z' }))),
            react.createElement("path", { fill: '#ECF6FF', d: 'M16.186 52.265a.799.799 0 0 1-.8-.796c0-.44.358-.797.8-.797.442 0 .8.357.8.797 0 .44-.358.797-.8.797m0-2.766a1.973 1.973 0 0 0-1.976 1.969c0 1.087.885 1.968 1.976 1.968a1.972 1.972 0 0 0 1.976-1.968 1.972 1.972 0 0 0-1.976-1.969M64.455 58.5a1.128 1.128 0 0 1-1.129-1.125c0-.622.506-1.125 1.13-1.125.623 0 1.129.503 1.129 1.125 0 .621-.506 1.125-1.13 1.125m-.282-3.938a3.1 3.1 0 0 0-3.105 3.094c0 1.71 1.39 3.094 3.105 3.094a3.1 3.1 0 0 0 3.105-3.094 3.1 3.1 0 0 0-3.105-3.093M81.674 30.938a.845.845 0 0 1-.846-.844.847.847 0 0 1 1.694 0c0 .466-.38.843-.848.843m0-2.812a1.972 1.972 0 0 0-1.976 1.969c0 1.087.885 1.968 1.976 1.968a1.972 1.972 0 0 0 1.976-1.968 1.973 1.973 0 0 0-1.976-1.969M57.398 7.875a.846.846 0 0 1-.846-.844.847.847 0 0 1 1.694 0c0 .466-.38.844-.848.844m0-2.813a1.973 1.973 0 0 0-1.975 1.97c0 1.087.884 1.968 1.976 1.968 1.09 0 1.975-.881 1.975-1.969a1.973 1.973 0 0 0-1.975-1.969' }),
            react.createElement("g", { transform: 'translate(43.002 3.375)' },
                react.createElement("mask", { id: 'c', fill: '#fff' },
                    react.createElement("use", { xlinkHref: '#b' })),
                react.createElement("path", { fill: '#F2F2F2', d: 'm2.127 1.391.529-.527A.47.47 0 1 0 1.989.2l-.53.527L.932.2a.47.47 0 1 0-.667.665l.528.526-.528.528a.47.47 0 1 0 .667.664l.529-.527.529.527a.47.47 0 1 0 .667-.665l-.53-.527z', mask: 'url(#c)' })),
            react.createElement("path", { fill: '#F2F2F2', d: 'm78.147 50.344 1.231-1.227a1.096 1.096 0 1 0-1.552-1.548l-1.232 1.228-1.232-1.228a1.096 1.096 0 1 0-1.553 1.548l1.231 1.227-1.232 1.227a1.097 1.097 0 1 0 1.554 1.548l1.232-1.228 1.232 1.228a1.096 1.096 0 1 0 1.552-1.548l-1.231-1.227z' }),
            react.createElement("g", null,
                react.createElement("path", { fill: '#CDE0F3', d: 'm7.435 11.813 5.073 11.258 3.71-2.399 2.148 2.954.388-4.982 4.488-2.587z' }),
                react.createElement("path", { fill: '#CDE0F3', d: 'm16.966 19.925-4.65 3.113 3.806-2.547 2.206 3.135.398-5.288-7.34-4.275z' }),
                react.createElement("path", { fill: '#779FCD', d: 'm18.628 19.688-7.242-5.062 7.34 3.884z' }),
                react.createElement("path", { fill: '#CDE0F3', d: 'm18.545 27.803-.348-.058c.081-.431.123-.871.125-1.307l.353.002a7.622 7.622 0 0 1-.13 1.364zM16.128 28a5.938 5.938 0 0 0-1.223-.128l-.143.002-.009-.334c.486-.011.976.033 1.453.135l-.078.325zm-3.889.652-.246-.239c.31-.287.735-.503 1.299-.659l.118.315c-.519.144-.906.338-1.17.583zm6.347.502a9.8 9.8 0 0 0-1.05-.654l-.118-.06.161-.296.126.063c.396.205.77.457 1.09.677l-.209.27zm15.163.44-.109-.318c.449-.137.896-.281 1.34-.43l.118.314c-.447.15-.897.295-1.349.434zm-2.743.74-.083-.325c.442-.102.901-.216 1.366-.342l.097.32a37.1 37.1 0 0 1-1.38.346zm-13.442.036-.307-.166c.23-.376.425-.777.583-1.19l.332.113c-.165.432-.37.85-.608 1.243zm3.522.133a7.038 7.038 0 0 1-1.32-.576l.181-.286a6.664 6.664 0 0 0 1.253.546l-.114.316zm7.115.337-.048-.33c.454-.059.923-.132 1.391-.217l.067.327c-.475.087-.95.161-1.41.22zm-4.285.152-.225-.016c-.434-.034-.827-.08-1.202-.142l.06-.329c.365.06.748.105 1.172.138l.22.016-.025.333zm1.433.044-.002-.334c.46-.002.933-.02 1.406-.053l.026.333a21.71 21.71 0 0 1-1.43.054zm-13.659.076a2.63 2.63 0 0 1-.301-1.314l.004-.072.352.024-.004.061-.002.089c0 .36.093.729.268 1.064l-.317.148zm3.867 1.241-.156-.3c.367-.17.723-.434 1.056-.786l.263.223a3.881 3.881 0 0 1-1.163.863zm-1.466.273a3.034 3.034 0 0 1-1.418-.448l.195-.278c.364.228.795.364 1.246.392l-.023.334zM7.553 14.851 9.1 18.577a.382.382 0 0 1-.186.493l-.055.025a.35.35 0 0 1-.47-.198l-1.491-3.752a.38.38 0 0 1 .205-.496.35.35 0 0 1 .45.202' })),
            react.createElement("g", null,
                react.createElement("path", { fill: '#CDE0F3', d: 'M76.649 22.5a.333.333 0 0 1-.337-.292.327.327 0 0 1 .305-.352 8.197 8.197 0 0 0 5.31-2.62.351.351 0 0 1 .477-.032.31.31 0 0 1 .033.455 8.88 8.88 0 0 1-5.788 2.841M74.75 6.785c-3.381.33-6.083 3.108-6.325 6.485a6.962 6.962 0 0 0 1.238 4.504 1.7 1.7 0 0 1 .163 1.626l-.557 1.337 2.28-.589a1.726 1.726 0 0 1 1.115.087 7.068 7.068 0 0 0 3.497.544c3.32-.32 6.005-2.991 6.326-6.298.43-4.437-3.282-8.131-7.737-7.696' }),
                react.createElement("g", { fill: '#FFF' },
                    react.createElement("path", { d: 'm75.713 18.001.393-.392s-.312-.733.996-1.97c.78-.735.954-1.447.89-2.03a2.038 2.038 0 0 0-1.79-1.784c-.585-.063-1.3.11-2.039.887-1.239 1.303-1.976.991-1.976.991l-.393.393 3.919 3.905zM72.564 15.188a1.058 1.058 0 0 0 .106 1.377c.377.376.965.41 1.382.106l-1.487-1.483z' }),
                    react.createElement("path", { d: 'm77.851 12.699-.24.239a2.307 2.307 0 0 0-.736-.732l.241-.24a.52.52 0 1 1 .735.734' })),
                react.createElement("path", { fill: '#D3E5F7', d: 'M75.497 6.752c2.632.75 4.551 3.07 4.551 5.82 0 3.355-2.858 6.076-6.385 6.076a6.51 6.51 0 0 1-4.691-1.965c.183.383.399.748.649 1.09.347.476.404 1.091.17 1.626l-.583 1.338 2.387-.589c.389-.096.8-.066 1.168.086a7.711 7.711 0 0 0 3.663.545c3.476-.32 6.288-2.992 6.624-6.299.433-4.263-3.137-7.838-7.554-7.728' })))));
}


//# sourceMappingURL=icon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlertBar/index.js
'use client';







var StyledJobAlertBar = styled_components_browser_esm/* default.div */.ZP.div(JobAlertBar_templateObject_1 || (JobAlertBar_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: white;\n    border: 1px solid rgba(51, 51, 51, 0.08);\n    border-radius: 3px;\n    padding: 6px 24px;\n\n    > button {\n        margin-left: auto;\n    }\n\n    > .text-content {\n        margin-left: 24px;\n\n        > .heading {\n            font-size: 16px;\n            font-weight: bold;\n            color: #555;\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: white;\n    border: 1px solid rgba(51, 51, 51, 0.08);\n    border-radius: 3px;\n    padding: 6px 24px;\n\n    > button {\n        margin-left: auto;\n    }\n\n    > .text-content {\n        margin-left: 24px;\n\n        > .heading {\n            font-size: 16px;\n            font-weight: bold;\n            color: #555;\n        }\n    }\n"])));
function JobAlertBar(_a) {
    var _b = _a.title, title = _b === void 0 ? 'Receive Job alert via email' : _b, _c = _a.description, description = _c === void 0 ? 'Get notified when new jobs become available' : _c, _d = _a.buttonText, buttonText = _d === void 0 ? 'Send me jobs' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e;
    return (react.createElement(StyledJobAlertBar, null,
        react.createElement(Icon, null),
        react.createElement("div", { className: 'text-content' },
            react.createElement("div", { className: 'heading' }, title),
            react.createElement("div", null, description)),
        react.createElement(Button/* default */.Z, { className: 'SJ_SendJobBottom', onClick: onClick }, buttonText)));
}
var JobAlertBar_templateObject_1;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TrustedCompanyName/index.js + 2 modules
var TrustedCompanyName = __webpack_require__(78525);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/index.js + 5 modules
var PreviewJob = __webpack_require__(91867);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/index.js + 2 modules
var ApplyJobs = __webpack_require__(83699);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobItem/index.js
/* provided dependency */ var process = __webpack_require__(83454);
'use client';










var StyledJobItem = styled_components_browser_esm/* default.div */.ZP.div(JobItem_templateObject_1 || (JobItem_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    height: 100%;\n\n    > .job-logo {\n        border: 1px solid #eeeeee;\n        border-radius: 4px;\n        width: 56px;\n        height: 56px;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        margin-right: 12px;\n        flex-shrink: 0;\n\n        > img {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    > .job-info {\n        overflow: hidden;\n        color: #777;\n        font-size: 12px;\n\n        a.job-title {\n            display: block;\n            font-weight: 500;\n            font-size: 16px;\n            color: #333;\n\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n\n            &:hover {\n                text-decoration: none;\n                color: #ff7d55;\n            }\n        }\n\n        > .company-name {\n            margin: 2px 0 0 0;\n            display: block;\n        }\n\n        > .salary {\n            color: #ff7d55;\n            margin-top: 4px;\n            a {\n                color: #005aff;\n                &:hover {\n                    text-decoration: none;\n                    color: #ff7d55;\n                }\n            }\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    height: 100%;\n\n    > .job-logo {\n        border: 1px solid #eeeeee;\n        border-radius: 4px;\n        width: 56px;\n        height: 56px;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        margin-right: 12px;\n        flex-shrink: 0;\n\n        > img {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    > .job-info {\n        overflow: hidden;\n        color: #777;\n        font-size: 12px;\n\n        a.job-title {\n            display: block;\n            font-weight: 500;\n            font-size: 16px;\n            color: #333;\n\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n\n            &:hover {\n                text-decoration: none;\n                color: #ff7d55;\n            }\n        }\n\n        > .company-name {\n            margin: 2px 0 0 0;\n            display: block;\n        }\n\n        > .salary {\n            color: #ff7d55;\n            margin-top: 4px;\n            a {\n                color: #005aff;\n                &:hover {\n                    text-decoration: none;\n                    color: #ff7d55;\n                }\n            }\n        }\n    }\n"])));
function JobItem(_a) {
    var _b, _c, _d;
    var jobTitle = _a.jobTitle, jobUrl = _a.jobUrl, jobLogo = _a.jobLogo, companyName = _a.companyName, companyUrl = _a.companyUrl, salary = _a.salary, isShowSalary = _a.isShowSalary, defaultLogoUrl = _a.defaultLogoUrl, _e = _a.language, language = _e === void 0 ? 'vi' : _e, _f = _a.loginUrl, loginUrl = _f === void 0 ? '/' : _f, _g = _a.requireLogin, requireLogin = _g === void 0 ? false : _g, _h = _a.isAnonymous, isAnonymous = _h === void 0 ? false : _h, _j = _a.trustedCompany, trustedCompany = _j === void 0 ? false : _j, previewJob = _a.previewJob, userInfo = _a.userInfo, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, initData = _a.initData;
    var _k = (0,react.useState)(false), isShowPopUpApplyJob = _k[0], setIsShowPopUpApplyJob = _k[1];
    var jobInfo = previewJob === null || previewJob === void 0 ? void 0 : previewJob.jobInfo;
    var togglePopApplyJob = function () {
        setIsShowPopUpApplyJob(!isShowPopUpApplyJob);
    };
    var loginText = language === 'en' ? 'Login to view salary' : 'Đăng nhập để xem lương';
    var anonymousTitle = language === 'en'
        ? 'Information of this employer is hidden for confidentiality purposes.'
        : 'Thông tin nhà tuyển dụng đã được ẩn đi vì mục đích bảo mật.';
    var anonymousCompanyName = "Vietnamworks' Client";
    var trustedTooltip = language === 'en' ? 'Trusted company' : 'Công ty uy tín';
    return (react.createElement(StyledJobItem, { className: 'view_job_item imp-click search_recommend' },
        react.createElement("a", { className: 'job-logo', href: jobUrl, title: jobTitle, target: (previewJob === null || previewJob === void 0 ? void 0 : previewJob.isMobile) ? '_self' : '_blank' },
            react.createElement("img", { src: jobLogo && !isAnonymous ? jobLogo : defaultLogoUrl, title: isAnonymous ? anonymousTitle : companyName })),
        react.createElement("div", { className: 'job-info' },
            (previewJob === null || previewJob === void 0 ? void 0 : previewJob.enabledPreviewJob) && !(previewJob === null || previewJob === void 0 ? void 0 : previewJob.isMobile) ? (react.createElement(react.Fragment, null,
                react.createElement(PreviewJob/* default */.Z, { content: {
                        jobId: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId,
                        logo: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.companyLogo,
                        title: jobTitle,
                        salary: (_b = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.prettySalary) !== null && _b !== void 0 ? _b : '',
                        jobLevel: language === constants/* ELanguage.VI */.Df.VI ? jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelVI : jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevel,
                        address: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.address,
                        jobDescription: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobDescription,
                        jobRequirements: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobRequirement,
                        link: jobUrl,
                        isSaved: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.isSaved,
                        isApplied: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.isApplied,
                        isBlackList: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.isBlackList,
                        redirectTo: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.redirectTo
                    }, api: {
                        accessToken: (_c = previewJob === null || previewJob === void 0 ? void 0 : previewJob.accessToken) !== null && _c !== void 0 ? _c : '',
                        baseUrl: process.env.MICROSERVICE_DOMAIN
                    }, onApplyClick: togglePopApplyJob, langCode: language === constants/* ELanguage.VI */.Df.VI ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, isLogin: !!(previewJob === null || previewJob === void 0 ? void 0 : previewJob.accessToken) },
                    react.createElement("a", { href: jobUrl, className: 'job-title', target: (previewJob === null || previewJob === void 0 ? void 0 : previewJob.isMobile) ? '_self' : '_blank' }, jobTitle)),
                react.createElement(ApplyJobs/* default */.ZP, { accessToken: (_d = previewJob === null || previewJob === void 0 ? void 0 : previewJob.accessToken) !== null && _d !== void 0 ? _d : '', isOpen: isShowPopUpApplyJob, langCode: language, user: userInfo, jobInfo: jobInfo, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', initData: initData, onClose: togglePopApplyJob }))) : (react.createElement("a", { href: jobUrl, title: jobTitle, className: 'job-title', target: (previewJob === null || previewJob === void 0 ? void 0 : previewJob.isMobile) ? '_self' : '_blank' }, jobTitle)),
            !isAnonymous ? (react.createElement(TrustedCompanyName/* default */.Z, { href: companyUrl, name: companyName, isTrusted: trustedCompany, tooltip: trustedTooltip, color: '#777', size: 'xs', style: { marginBottom: 0, marginTop: 2 } })) : (react.createElement("span", { className: 'company-name', title: anonymousTitle }, anonymousCompanyName)),
            react.createElement("div", { className: 'salary' }, requireLogin ? (react.createElement("a", { href: loginUrl, title: loginText }, loginText)) : ((0,helpers/* formatSalary */.hw)(salary, isShowSalary, language))))));
}
var JobItem_templateObject_1;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/icons/IconClose2.js
'use client';



var IconClose2 = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32 32' },
        react.createElement("g", { id: 'icons/nav/icon-close-outline/size-m', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'icons8-delete', transform: 'translate(4.000000, 4.000000)', fill: '#555555', fillRule: 'nonzero' },
                react.createElement("polygon", { id: 'Path', points: '1.08552632 0.177631579 0.177631579 1.08552632 11.0921053 12 0.177631579 22.9144737 1.08552632 23.8223684 12 12.9078947 22.9144737 23.8223684 23.8223684 22.9144737 12.9078947 12 23.8223684 1.08552632 22.9144737 0.177631579 12 11.0921053' })))));
};


//# sourceMappingURL=IconClose2.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileFullScreenList/icons/IconArrowLeft.js
'use client';



var IconArrowLeft = function (props) {
    return (react.createElement("svg", { onClick: props.onClick, className: 'iconArrowLeft', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        react.createElement("path", { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '2', d: 'M19.946 35.891L9.057 25 19.947 14.11M41 25L9.662 25' })));
};


//# sourceMappingURL=IconArrowLeft.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileFullScreenList/icons/IconCheck.js
'use client';



var IconCheck = function () {
    return (react.createElement("svg", { className: 'iconOptionCheck', viewBox: '0 0 50 50' },
        react.createElement("path", { d: 'M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z' })));
};


//# sourceMappingURL=IconCheck.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileFullScreenList/icons/IconClose.js
'use client';



var IconClose = function (props) {
    return (react.createElement("svg", { onClick: props.onClick, className: 'filterClose', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 44 44' },
        react.createElement("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' })));
};


//# sourceMappingURL=IconClose.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileFullScreenList/MobileFullScreenList.css.js
'use client';




var DivMobileFullScreenList = styled_components_browser_esm/* default.div */.ZP.div(MobileFullScreenList_css_templateObject_1 || (MobileFullScreenList_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .modalContainer {\n        position: fixed;\n        height: 100%;\n        width: 100%;\n        background: #fff;\n        top: 0;\n        left: 100%;\n        z-index: 1010;\n        opacity: 0;\n        transition: left 0.3s, opacity 0.3s;\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    }\n\n    .modalContainerIsOpen {\n        left: 0;\n        opacity: 1;\n    }\n\n    .modalHeader {\n        background: #ccf3ff;\n        padding: 10px 20px;\n    }\n\n    .modalBody {\n        height: calc(100% - 50px);\n        overflow: auto;\n    }\n\n    .optionItem {\n        border-top: 1px solid #e1e1e1;\n        border-bottom: 1px solid #e1e1e1;\n        margin-top: -1px;\n        padding: 10px 20px;\n        position: relative;\n    }\n\n    .optionItemHighlighted {\n        background: #f3fbfe;\n    }\n\n    .iconOptionCheck {\n        width: 20px;\n        height: 20px;\n        fill: #005aff;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n    }\n\n    .inputWrapper {\n        position: relative;\n    }\n\n    .inputWrapper input {\n        height: 40px;\n        padding-left: 40px;\n        border-color: #fff;\n        border-radius: 4px;\n        width: 100%;\n        border: none;\n    }\n\n    .iconArrowLeft {\n        position: absolute;\n        top: 8px;\n        left: 10px;\n        width: 24px;\n        height: 24px;\n        stroke: #555555;\n    }\n    .filterClose {\n        position: absolute;\n        top: 13px;\n        right: 10px;\n        fill: rgb(255, 255, 255);\n        opacity: 0.5;\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        padding: 3px;\n        background: rgb(153, 153, 153);\n        transition: all 0.3s ease 0s;\n        cursor: pointer;\n        &:hover {\n            opacity: 1;\n        }\n    }\n\n    .limitAlert {\n        position: fixed;\n        bottom: -100%;\n        transition: all 0.4s ease-out;\n        width: 100%;\n        text-align: center;\n    }\n\n    .limitAlertContent {\n        background-color: #fff;\n        border-radius: 6px;\n        border: 1px solid #e1e1e1;\n        padding: 12px;\n        display: flex;\n        width: 80%;\n        margin: auto;\n        justify-content: space-between;\n        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);\n    }\n\n    .limitAlertContent span {\n        display: flex;\n    }\n\n    .limitAlertContentText {\n        text-align: center;\n    }\n\n    .limitAlertCloseIcon svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .limitAlertActive {\n        bottom: 20px;\n    }\n"], ["\n    .modalContainer {\n        position: fixed;\n        height: 100%;\n        width: 100%;\n        background: #fff;\n        top: 0;\n        left: 100%;\n        z-index: 1010;\n        opacity: 0;\n        transition: left 0.3s, opacity 0.3s;\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    }\n\n    .modalContainerIsOpen {\n        left: 0;\n        opacity: 1;\n    }\n\n    .modalHeader {\n        background: #ccf3ff;\n        padding: 10px 20px;\n    }\n\n    .modalBody {\n        height: calc(100% - 50px);\n        overflow: auto;\n    }\n\n    .optionItem {\n        border-top: 1px solid #e1e1e1;\n        border-bottom: 1px solid #e1e1e1;\n        margin-top: -1px;\n        padding: 10px 20px;\n        position: relative;\n    }\n\n    .optionItemHighlighted {\n        background: #f3fbfe;\n    }\n\n    .iconOptionCheck {\n        width: 20px;\n        height: 20px;\n        fill: #005aff;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n    }\n\n    .inputWrapper {\n        position: relative;\n    }\n\n    .inputWrapper input {\n        height: 40px;\n        padding-left: 40px;\n        border-color: #fff;\n        border-radius: 4px;\n        width: 100%;\n        border: none;\n    }\n\n    .iconArrowLeft {\n        position: absolute;\n        top: 8px;\n        left: 10px;\n        width: 24px;\n        height: 24px;\n        stroke: #555555;\n    }\n    .filterClose {\n        position: absolute;\n        top: 13px;\n        right: 10px;\n        fill: rgb(255, 255, 255);\n        opacity: 0.5;\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        padding: 3px;\n        background: rgb(153, 153, 153);\n        transition: all 0.3s ease 0s;\n        cursor: pointer;\n        &:hover {\n            opacity: 1;\n        }\n    }\n\n    .limitAlert {\n        position: fixed;\n        bottom: -100%;\n        transition: all 0.4s ease-out;\n        width: 100%;\n        text-align: center;\n    }\n\n    .limitAlertContent {\n        background-color: #fff;\n        border-radius: 6px;\n        border: 1px solid #e1e1e1;\n        padding: 12px;\n        display: flex;\n        width: 80%;\n        margin: auto;\n        justify-content: space-between;\n        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);\n    }\n\n    .limitAlertContent span {\n        display: flex;\n    }\n\n    .limitAlertContentText {\n        text-align: center;\n    }\n\n    .limitAlertCloseIcon svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .limitAlertActive {\n        bottom: 20px;\n    }\n"])));
var MobileFullScreenList_css_templateObject_1;


//# sourceMappingURL=MobileFullScreenList.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileFullScreenList/index.js
'use client';










var MobileFullScreenList = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(MobileFullScreenList, _super);
    function MobileFullScreenList(props) {
        var _this = _super.call(this, props) || this;
        _this.isCheckedFocusOnScroll = false;
        _this.isTouchedOptionList = false;
        _this.state = {
            keyword: '',
            isShowLimitAlert: false
        };
        _this._bindMethods();
        _this.inputRef = (0,react.createRef)();
        _this.optionContainerRef = (0,react.createRef)();
        return _this;
    }
    MobileFullScreenList.prototype._bindMethods = function () {
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this._clearKeywordInput = this._clearKeywordInput.bind(this);
        this.handleOnScroll = this.handleOnScroll.bind(this);
        this.handleOnTouch = this.handleOnTouch.bind(this);
        this.handleOnClickCloseAlert = this.handleOnClickCloseAlert.bind(this);
    };
    MobileFullScreenList.prototype._clearKeywordInput = function () {
        this.setState({ keyword: '' });
    };
    MobileFullScreenList.prototype.componentDidMount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.addEventListener('touchend', this.handleOnTouch);
    };
    MobileFullScreenList.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (!prevProps.isOpen && this.props.isOpen) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            this.isCheckedFocusOnScroll = false;
        }
    };
    MobileFullScreenList.prototype.componentWillUnmount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.removeEventListener('touchend', this.handleOnTouch);
    };
    MobileFullScreenList.prototype.handleOnScroll = function () {
        var _a, _b;
        var isFocusAndScroll = (document === null || document === void 0 ? void 0 : document.hasFocus()) && !this.isCheckedFocusOnScroll && this.isTouchedOptionList;
        if (isFocusAndScroll) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.blur();
            this.isCheckedFocusOnScroll = true;
        }
    };
    MobileFullScreenList.prototype.handleOnTouch = function (event) {
        if (event.type === 'touchstart') {
            this.isTouchedOptionList = true;
        }
        if (event.type === 'touchend') {
            this.isTouchedOptionList = false;
        }
    };
    MobileFullScreenList.prototype.handleKeywordChange = function (event) {
        var value = event.target.value;
        this.setState({ keyword: value });
    };
    MobileFullScreenList.prototype.handleOnClickCloseAlert = function () {
        this.setState({ isShowLimitAlert: false });
    };
    MobileFullScreenList.prototype.selectOption = function (option) {
        var _this = this;
        var _a = this.props, options = _a.options, selectedOptionId = _a.selectedOptionId, isMultiSelect = _a.isMultiSelect, limit = _a.limit;
        this._clearKeywordInput();
        if (isMultiSelect) {
            if (option.id === -1) {
                this.props.onOptionMultiSelected && this.props.onOptionMultiSelected([option]);
                return;
            }
            var returnList_1 = [];
            var selectedOptionListId = selectedOptionId;
            // check item is selected then remove it from list
            var selectedItemList = selectedOptionListId.filter(function (item) { return item === option.id; });
            var isItemExist = selectedItemList.length > 0;
            if (selectedOptionListId.length > 0) {
                selectedOptionListId.map(function (optionItemId) {
                    var filteredOptionList = options.filter(function (item) { return item.id === optionItemId; });
                    // push filter item to returnList
                    if (filteredOptionList.length > 0 && optionItemId !== option.id && optionItemId !== -1) {
                        returnList_1.push(filteredOptionList[0]);
                    }
                });
            }
            // Check if item not exist from list then push to list
            var limitCheck = limit !== undefined ? limit : 3;
            var isReachLimit = returnList_1.length >= limitCheck;
            if (!isItemExist && !isReachLimit) {
                returnList_1.push(option);
            }
            if (isReachLimit) {
                this.setState({
                    isShowLimitAlert: true
                });
                setTimeout(function () { return _this.setState({ isShowLimitAlert: false }); }, 3000);
            }
            this.props.onOptionMultiSelected && this.props.onOptionMultiSelected(returnList_1);
            return;
        }
        this.props.onOptionSelected(option);
    };
    MobileFullScreenList.prototype.render = function () {
        var _this = this;
        var _a = this.state, keyword = _a.keyword, isShowLimitAlert = _a.isShowLimitAlert;
        var _b = this.props, isOpen = _b.isOpen, selectedOptionId = _b.selectedOptionId, isMultiSelect = _b.isMultiSelect, limitAlertText = _b.limitAlertText;
        // Render the list of options
        var optionListNode = this.props.options
            .filter(function (option) {
            // Filter only the options that match our keyword
            var optionNameInLatin = (0,helpers/* transformToLatin */.nr)(option.name);
            var keywordInLatin = (0,helpers/* transformToLatin */.nr)(keyword);
            return optionNameInLatin.includes(keywordInLatin);
        })
            .map(function (option) {
            // Map filtered options to JSX options
            var isSelected = selectedOptionId === option.id;
            if (isMultiSelect) {
                isSelected = selectedOptionId.includes(option.id);
            }
            return (react.createElement("div", { key: option.id, onClick: function (event) {
                    event.stopPropagation();
                    _this.selectOption(option);
                }, onMouseDown: function (event) {
                    event.stopPropagation();
                    event.nativeEvent.stopImmediatePropagation();
                }, className: "optionItem ".concat(isSelected ? 'optionItemHighlighted' : '') },
                option.name,
                isSelected ? react.createElement(IconCheck, null) : null));
        });
        // Render the Modal
        return (react.createElement(DivMobileFullScreenList, null,
            react.createElement("div", { className: "modalContainer ".concat(isOpen ? 'modalContainerIsOpen' : '') },
                react.createElement("div", { className: 'modalHeader' },
                    react.createElement("div", { className: 'inputWrapper' },
                        react.createElement("input", { tabIndex: -1, value: keyword, onChange: this.handleKeywordChange, type: 'text', ref: this.inputRef, onFocus: function () { return (_this.isCheckedFocusOnScroll = false); } }),
                        react.createElement(IconArrowLeft, { onClick: this.props.onBack }),
                        keyword ? react.createElement(IconClose, { onClick: function () { return _this.setState({ keyword: '' }); } }) : null)),
                react.createElement("div", { className: 'modalBody', ref: this.optionContainerRef }, optionListNode),
                react.createElement("div", { className: "limitAlert ".concat(isShowLimitAlert ? 'limitAlertActive' : '') },
                    react.createElement("span", { className: 'limitAlertContent' },
                        react.createElement("span", { className: 'limitAlertContentText' }, limitAlertText !== undefined ? limitAlertText : ''),
                        react.createElement("span", { className: 'limitAlertCloseIcon', onClick: this.handleOnClickCloseAlert },
                            react.createElement(IconClose2, null)))))));
    };
    MobileFullScreenList.defaultProps = {
        isOpen: false,
        isMultiSelect: false,
        options: [{ id: -1, name: 'All options' }],
        onOptionSelected: function () {
            console.info('Option selected, no handler bound!');
        },
        onOptionMultiSelected: function () {
            console.info('Multi Option selected, no handler bound!');
        },
        onBack: function () {
            console.info('Backed, no handler bound!');
        },
        selectedOptionId: -1,
        limit: -1,
        limitAlertText: ''
    };
    return MobileFullScreenList;
}(react.PureComponent));


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/types/index.js
var types = __webpack_require__(39816);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/fullScreenModal.module.css.js
'use client';

var styles = {"modalContainer":"fullScreenModal-module_modalContainer__2XBc8","modalContainerIsOpen":"fullScreenModal-module_modalContainerIsOpen__1YooO","modalHeader":"fullScreenModal-module_modalHeader__1kfbF","modalBody":"fullScreenModal-module_modalBody__bDlLw","optionItem":"fullScreenModal-module_optionItem__3vh5c","optionItemHighlighted":"fullScreenModal-module_optionItemHighlighted__59F_S","iconOptionCheck":"fullScreenModal-module_iconOptionCheck__13Lyy","inputWrapper":"fullScreenModal-module_inputWrapper__3GKse","iconArrowLeft":"fullScreenModal-module_iconArrowLeft__3UJmg","filterClose":"fullScreenModal-module_filterClose__26FLT","modalMultiple":"fullScreenModal-module_modalMultiple__3U_BW","limitAlert":"fullScreenModal-module_limitAlert__2HlsB","limitAlertContent":"fullScreenModal-module_limitAlertContent__3Kk2x","limitAlertContentText":"fullScreenModal-module_limitAlertContentText__1Xlkx","limitAlertCloseIcon":"fullScreenModal-module_limitAlertCloseIcon__2yY9N","limitAlertActive":"fullScreenModal-module_limitAlertActive__2AKQ1"};


//# sourceMappingURL=fullScreenModal.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/icons/IconArrowLeft.js
'use client';




var IconArrowLeft_IconArrowLeft = function (props) {
    return (react.createElement("svg", { onClick: props.onClick, className: styles.iconArrowLeft, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        react.createElement("path", { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '2', d: 'M19.946 35.891L9.057 25 19.947 14.11M41 25L9.662 25' })));
};


//# sourceMappingURL=IconArrowLeft.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/icons/IconCheck.js
'use client';




var IconCheck_IconCheck = function () {
    return (react.createElement("svg", { className: styles.iconOptionCheck, viewBox: '0 0 50 50' },
        react.createElement("path", { d: 'M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z' })));
};


//# sourceMappingURL=IconCheck.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/icons/IconClose.js
'use client';




var IconClose_IconClose = function (props) {
    return (react.createElement("svg", { onClick: props.onClick, className: styles.filterClose, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 44 44' },
        react.createElement("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' })));
};


//# sourceMappingURL=IconClose.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/FullScreenModal/index.js
'use client';











var FullScreenModalMode;
(function (FullScreenModalMode) {
    FullScreenModalMode[FullScreenModalMode["Single"] = 0] = "Single";
    FullScreenModalMode[FullScreenModalMode["Multiple"] = 1] = "Multiple";
})(FullScreenModalMode || (FullScreenModalMode = {}));
var FullScreenModal = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(FullScreenModal, _super);
    function FullScreenModal(props) {
        var _this = _super.call(this, props) || this;
        _this.isCheckedFocusOnScroll = false;
        _this.isTouchedOptionList = false;
        _this.state = {
            keyword: '',
            isShowLimitAlert: false
        };
        _this._bindMethods();
        _this.inputRef = (0,react.createRef)();
        _this.optionContainerRef = (0,react.createRef)();
        return _this;
    }
    FullScreenModal.prototype._bindMethods = function () {
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handleOnClickCloseAlert = this.handleOnClickCloseAlert.bind(this);
        this._clearKeywordInput = this._clearKeywordInput.bind(this);
        this.handleOnScroll = this.handleOnScroll.bind(this);
        this.handleOnTouch = this.handleOnTouch.bind(this);
    };
    FullScreenModal.prototype._clearKeywordInput = function () {
        this.setState({ keyword: '' });
    };
    FullScreenModal.prototype.componentDidMount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.addEventListener('touchend', this.handleOnTouch);
    };
    FullScreenModal.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (!prevProps.isOpen && this.props.isOpen) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            this.isCheckedFocusOnScroll = false;
        }
    };
    FullScreenModal.prototype.componentWillUnmount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.removeEventListener('touchend', this.handleOnTouch);
    };
    FullScreenModal.prototype.handleOnScroll = function () {
        var _a, _b;
        var isFocusAndScroll = (document === null || document === void 0 ? void 0 : document.hasFocus()) && !this.isCheckedFocusOnScroll && this.isTouchedOptionList;
        if (isFocusAndScroll) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.blur();
            this.isCheckedFocusOnScroll = true;
        }
    };
    FullScreenModal.prototype.handleOnTouch = function (event) {
        if (event.type === 'touchstart') {
            this.isTouchedOptionList = true;
        }
        if (event.type === 'touchend') {
            this.isTouchedOptionList = false;
        }
    };
    FullScreenModal.prototype.handleKeywordChange = function (event) {
        var value = event.target.value;
        this.setState({ keyword: value });
    };
    FullScreenModal.prototype.handleOnClickCloseAlert = function () {
        this.setState({ isShowLimitAlert: false });
    };
    FullScreenModal.prototype.selectOption = function (option) {
        var _this = this;
        var canSelect = true;
        if (this.props.mode === FullScreenModalMode.Multiple && this.props.limit !== undefined) {
            // multi select and have set limit
            var selectedOptionList = (0,_tslib/* __spreadArray */.ev)([], this.props.selectedOptionId, true);
            if (selectedOptionList.length >= this.props.limit) {
                canSelect = false;
            }
            // Check if is de-select item
            if (selectedOptionList.includes(option.id)) {
                // is de-select so it canSelect
                canSelect = true;
            }
        }
        if (canSelect) {
            this._clearKeywordInput();
            this.props.onOptionSelected(option);
        }
        else {
            // show toast alert at bottom
            this.setState({ isShowLimitAlert: true });
            setTimeout(function () { return _this.setState({ isShowLimitAlert: false }); }, 3000);
        }
    };
    FullScreenModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, keyword = _a.keyword, isShowLimitAlert = _a.isShowLimitAlert;
        var _b = this.props, isOpen = _b.isOpen, selectedOptionId = _b.selectedOptionId, limitAlertText = _b.limitAlertText;
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            // Render the list of options
            var optionListNode = this.props.options
                .filter(function (option) {
                // Filter only the options that match our keyword
                var optionNameInLatin = (0,helpers/* transformToLatin */.nr)(option.name);
                var keywordInLatin = (0,helpers/* transformToLatin */.nr)(keyword);
                return optionNameInLatin.includes(keywordInLatin);
            })
                .map(function (option) {
                // Map filtered options to JSX options
                var isSelected = false;
                var _key = "option-".concat(option.id);
                if (_this.props.mode === FullScreenModalMode.Single) {
                    isSelected = selectedOptionId === option.id;
                }
                else {
                    if (typeof selectedOptionId === 'object') {
                        var _arrayValue = selectedOptionId;
                        _key = "".concat(option.id, "-").concat(_arrayValue.join('_'), "-").concat(_arrayValue.length);
                        isSelected = _arrayValue.includes(option.id);
                    }
                    else {
                        isSelected = selectedOptionId === option.id;
                    }
                }
                return (react.createElement("div", { key: _key, onClick: function (event) {
                        event.stopPropagation();
                        _this.selectOption(option);
                    }, onMouseDown: function (event) {
                        event.stopPropagation();
                        event.nativeEvent.stopImmediatePropagation();
                    }, className: "".concat(styles.optionItem, " ").concat(isSelected ? styles.optionItemHighlighted : '') },
                    option.name,
                    isSelected ? react.createElement(IconCheck_IconCheck, null) : null));
            });
            // Render the Modal
            return react_dom.createPortal(react.createElement("div", { className: "".concat(styles.modalContainer, " ").concat(isOpen ? styles.modalContainerIsOpen : '', " ").concat(this.props.mode === FullScreenModalMode.Multiple ? styles.modalMultiple : '') },
                react.createElement("div", { className: styles.modalHeader },
                    react.createElement("div", { className: styles.inputWrapper },
                        react.createElement("input", { tabIndex: -1, value: keyword, onChange: this.handleKeywordChange, type: 'text', ref: this.inputRef, onFocus: function () { return (_this.isCheckedFocusOnScroll = false); } }),
                        react.createElement(IconArrowLeft_IconArrowLeft, { onClick: this.props.onBack }),
                        keyword ? react.createElement(IconClose_IconClose, { onClick: function () { return _this.setState({ keyword: '' }); } }) : null)),
                react.createElement("div", { className: styles.modalBody, ref: this.optionContainerRef }, optionListNode),
                react.createElement("div", { className: isShowLimitAlert ? styles.limitAlert + ' ' + styles.limitAlertActive : styles.limitAlert },
                    react.createElement("span", { className: styles.limitAlertContent },
                        react.createElement("span", { className: styles.limitAlertContentText }, limitAlertText),
                        react.createElement("span", { className: styles.limitAlertCloseIcon, onClick: this.handleOnClickCloseAlert },
                            react.createElement(IconClose2, null))))), bodyNode);
        }
        return null;
    };
    FullScreenModal.defaultProps = {
        isOpen: false,
        options: [{ id: -1, name: 'All options' }],
        onOptionSelected: function () {
            console.info('Option selected, no handler bound!');
        },
        onBack: function () {
            console.info('Backed, no handler bound!');
        },
        selectedOptionId: -1,
        mode: FullScreenModalMode.Single,
        limit: -1,
        limitAlertText: ''
    };
    return FullScreenModal;
}(react.PureComponent));


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/MobileSelect.module.css.js
'use client';

var MobileSelect_module_css_styles = {"MobileSelect":"MobileSelect-module_MobileSelect__U4yGA","title":"MobileSelect-module_title__2YXHC","tag":"MobileSelect-module_tag__1bafn","active":"MobileSelect-module_active__OveCq","multiple":"MobileSelect-module_multiple__13CWB","tagIcon":"MobileSelect-module_tagIcon__1w-EX","labelText":"MobileSelect-module_labelText__1LF_E"};


//# sourceMappingURL=MobileSelect.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSelect/index.js
'use client';









// Empty value may also refer as Select All option
var EMPTY_VALUE_ID = constants/* SELECT_EMPTY_OPTION_ID */.WR;
/**
 * MobileSelect Component
 * A Functional Component using Hooks
 *
 * @param props
 */
var MobileSelect = function (props) {
    var _a, _b;
    var _c = props.title, title = _c === void 0 ? 'Select' : _c, _d = props.options, options = _d === void 0 ? [] : _d, _e = props.mode, mode = _e === void 0 ? types/* MobileSelectMode.Single */.P.Single : _e, _f = props.limit, limit = _f === void 0 ? -1 : _f, _g = props.limitAlertText, limitAlertText = _g === void 0 ? '' : _g, defaultLabel = props.defaultLabel, onSelected = props.onSelected;
    var propValue = props.value;
    var initValue = propValue || EMPTY_VALUE_ID;
    var prevPropValue = (0,hooks/* usePrevious */.D9)(propValue);
    var _h = (0,react.useState)(initValue), value = _h[0], setValue = _h[1];
    var _j = (0,react.useState)(false), isModalOpen = _j[0], setModalOpen = _j[1];
    // Make value state reflect value prop when change
    // TODO: Not a prefered way of detect data update using Hooks
    (0,react.useEffect)(function () {
        if (propValue !== prevPropValue && propValue !== value) {
            setValue(propValue);
        }
    });
    /**
     * Handle actions when user click to select an option from Full Screen Modal
     *
     * @param selectedOption
     */
    var handleOptionSelected = function (selectedOption) {
        var selectedValue = selectedOption.id;
        if (mode === types/* MobileSelectMode.Multiple */.P.Multiple) {
            selectedValue = (0,_tslib/* __spreadArray */.ev)([], value, true);
            if (selectedValue.includes(selectedOption.id)) {
                // remove
                selectedValue = selectedValue.filter(function (_item) { return _item !== selectedOption.id; });
            }
            else {
                selectedValue.push(selectedOption.id);
            }
        }
        else {
            setModalOpen(false);
        }
        setValue(selectedValue);
        onSelected && onSelected(selectedValue);
    };
    var handleCloseModal = function () { return setModalOpen(false); };
    var selectOptions = options;
    if (defaultLabel) {
        if (mode === types/* MobileSelectMode.Single */.P.Single) {
            selectOptions = (0,_tslib/* __spreadArray */.ev)([
                {
                    id: EMPTY_VALUE_ID,
                    name: defaultLabel
                }
            ], options, true);
        }
    }
    var selectedLabel = ((_a = selectOptions.find(function (option) { return option.id === value; })) === null || _a === void 0 ? void 0 : _a.name) || '';
    var styleTag = MobileSelect_module_css_styles.tag;
    if (mode === types/* MobileSelectMode.Multiple */.P.Multiple) {
        // set style tags
        styleTag = MobileSelect_module_css_styles.tag + ' ' + MobileSelect_module_css_styles.multiple;
        // value label
        var valueArray_1 = value;
        var labelList = [];
        var _loop_1 = function (i) {
            var text = ((_b = selectOptions.find(function (_option) { return _option.id === valueArray_1[i]; })) === null || _b === void 0 ? void 0 : _b.name) || '';
            if (text !== '') {
                labelList.push(text);
            }
        };
        for (var i = 0; i < valueArray_1.length; i++) {
            _loop_1(i);
        }
        if (labelList.length > 0) {
            selectedLabel = labelList.join(', ');
            styleTag += ' ' + MobileSelect_module_css_styles.active;
        }
        else {
            selectedLabel = defaultLabel || '';
        }
    }
    return (react.createElement("div", { className: MobileSelect_module_css_styles.MobileSelect },
        react.createElement("div", { className: MobileSelect_module_css_styles.title }, title),
        react.createElement("div", { className: styleTag, onClick: function () { return setModalOpen(true); } },
            react.createElement("span", { className: MobileSelect_module_css_styles.labelText }, selectedLabel),
            react.createElement("span", { className: MobileSelect_module_css_styles.tagIcon },
                react.createElement("svg", { fill: '#000000', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 30 30', width: '30px', height: '30px' },
                    react.createElement("path", { d: 'M12,27h-2c-0.386,0-0.738-0.223-0.904-0.572s-0.115-0.762,0.13-1.062L17.708,15L9.226,4.633 c-0.245-0.299-0.295-0.712-0.13-1.062S9.614,3,10,3h2c0.3,0,0.584,0.135,0.774,0.367l9,11c0.301,0.369,0.301,0.898,0,1.267l-9,11 C12.584,26.865,12.3,27,12,27z' })))),
        react.createElement(FullScreenModal, { isOpen: isModalOpen, options: selectOptions, selectedOptionId: value, onOptionSelected: handleOptionSelected, onBack: handleCloseModal, mode: mode === types/* MobileSelectMode.Multiple */.P.Multiple ? FullScreenModalMode.Multiple : FullScreenModalMode.Single, limit: limit, limitAlertText: limitAlertText })));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Modal/SlideModal.js + 1 modules
var SlideModal = __webpack_require__(85124);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSort/MobileSort.module.css.js
'use client';

var MobileSort_module_css_styles = {"optionsContainer":"MobileSort-module_optionsContainer__39USo","sortingHighLight":"MobileSort-module_sortingHighLight__XUlQA","line":"MobileSort-module_line__1qyq1","svgAnimation":"MobileSort-module_svgAnimation__18Ob9","optionItem":"MobileSort-module_optionItem__3cSZO","selected":"MobileSort-module_selected__1yQ4j","icon":"MobileSort-module_icon__2w57i"};


//# sourceMappingURL=MobileSort.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/IconCheck.js
'use client';



var icons_IconCheck_IconCheck = function () {
    return (react.createElement("svg", { viewBox: '0 0 50 50' },
        react.createElement("path", { d: 'M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z' })));
};


//# sourceMappingURL=IconCheck.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MobileSort/index.js
'use client';






var MobileSort = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, _b = props.value, value = _b === void 0 ? '' : _b, _c = props.title, title = _c === void 0 ? '' : _c, _d = props.isOpen, isOpen = _d === void 0 ? false : _d, onSelected = props.onSelected, onBack = props.onBack, _e = props.showSortingHighlightMobile, showSortingHighlightMobile = _e === void 0 ? false : _e;
    return (react.createElement(SlideModal/* default */.Z, { isOpen: isOpen, title: title, onBack: onBack },
        react.createElement("div", { className: MobileSort_module_css_styles.optionsContainer }, options.map(function (option) {
            var isOptionSelected = option.id === value;
            var selectedClass = isOptionSelected ? MobileSort_module_css_styles.selected : '';
            var isShowHighLight = showSortingHighlightMobile && option.isHighlight === true;
            return (react.createElement("div", { className: isShowHighLight ? "".concat(MobileSort_module_css_styles.sortingHighLight) : '' },
                isShowHighLight ? (react.createElement("svg", { height: '100%', width: '100%', onClick: function () { return onSelected && onSelected(option); } },
                    react.createElement("rect", { rx: '4', ry: '4', className: MobileSort_module_css_styles.line, height: '100%', width: '100%', strokeLinejoin: 'round' }))) : null,
                react.createElement("div", { className: "".concat(MobileSort_module_css_styles.optionItem, " ").concat(selectedClass), key: option.id, onClick: function () { return onSelected && onSelected(option); } },
                    react.createElement("div", null, option.name),
                    isOptionSelected && (react.createElement("span", { className: MobileSort_module_css_styles.icon },
                        react.createElement(icons_IconCheck_IconCheck, null))))));
        }))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Modal/deleteIcon.js
var deleteIcon = __webpack_require__(68856);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Modal/Modal.module.css.js
'use client';

var Modal_module_css_styles = {"container":"Modal-module_container__3WNLk","fullHeight":"Modal-module_fullHeight__2eTDg","isOpen":"Modal-module_isOpen__1NTwW","header":"Modal-module_header__3u27A","left":"Modal-module_left__3XZ16","right":"Modal-module_right__pC5v1","title":"Modal-module_title__I4YyR","icon":"Modal-module_icon__KpEGB","backdrop":"Modal-module_backdrop__1vqZk","closeIcon":"Modal-module_closeIcon__3IfFp","footer":"Modal-module_footer__2vpNe"};


//# sourceMappingURL=Modal.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Modal/index.js
'use client';







var Modal = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, isBlank = props.isBlank, _b = props.onBack, onBack = _b === void 0 ? function () { } : _b, title = props.title, zIndex = props.zIndex, headerRight = props.headerRight, width = props.width, _c = props.fullHeight, fullHeight = _c === void 0 ? true : _c, _d = props.backdrop, backdrop = _d === void 0 ? true : _d, onClickOutside = props.onClickOutside, footerNode = props.footerNode, position = props.position, styleBody = props.styleBody, customModal = props.customModal, _e = props.containerStyle, containerStyle = _e === void 0 ? {} : _e, _f = props.bodyStyle, bodyStyle = _f === void 0 ? {} : _f, _g = props.children, children = _g === void 0 ? null : _g, bottomText = props.bottomText;
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside && onClickOutside) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? Modal_module_css_styles.isOpen : '';
    var modalStyle = {};
    if (width) {
        modalStyle.width = width;
    }
    if (zIndex) {
        modalStyle.zIndex = zIndex;
    }
    var backdropStyle = {};
    if (zIndex) {
        backdropStyle.zIndex = zIndex - 1;
    }
    return react_dom.createPortal(react.createElement("div", null,
        backdrop && react.createElement("div", { style: backdropStyle, className: "".concat(Modal_module_css_styles.backdrop, " ").concat(classOpen) }),
        react.createElement("div", { className: "".concat(Modal_module_css_styles.container, " ").concat(classOpen, " ").concat(position || '', " ").concat(customModal || '', " ").concat(fullHeight ? Modal_module_css_styles.fullHeight : ''), style: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, modalStyle), containerStyle), ref: containerRef }, isBlank ? (react.createElement("div", null,
            react.createElement("span", { onClick: onBack, className: "".concat(Modal_module_css_styles.icon, " ").concat(Modal_module_css_styles.closeIcon) },
                react.createElement(deleteIcon/* default */.Z, null)),
            react.createElement("div", { className: "".concat(Modal_module_css_styles.body || '', " ").concat(styleBody || '') }, children))) : (react.createElement(react.Fragment, null,
            react.createElement("div", { className: Modal_module_css_styles.header },
                react.createElement("span", { onClick: onBack, className: "".concat(Modal_module_css_styles.icon, " ").concat(Modal_module_css_styles.left) },
                    react.createElement(deleteIcon/* default */.Z, null)),
                react.createElement("div", { className: Modal_module_css_styles.title }, title),
                react.createElement("div", { className: "".concat(Modal_module_css_styles.right) }, headerRight || null)),
            react.createElement("div", { className: Modal_module_css_styles.body, style: bodyStyle }, children),
            bottomText,
            footerNode && react.createElement("div", { className: Modal_module_css_styles.footer }, footerNode))))), bodyNode);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelect/iconLibs.js
'use client';



var listBenefits = [
    {
        id: 5,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 26.9375 1.96875 C 26.894531 1.976563 26.851563 1.988281 26.8125 2 C 26.519531 2.054688 26.269531 2.238281 26.125 2.5 L 25 4.4375 L 23.875 2.5 C 23.671875 2.132813 23.257813 1.933594 22.84375 2 C 22.511719 2.046875 22.226563 2.257813 22.082031 2.558594 C 21.9375 2.859375 21.953125 3.210938 22.125 3.5 L 23.84375 6.40625 L 20.5625 12.03125 C 20.230469 12.082031 19.910156 12.195313 19.625 12.34375 L 13.875 2.5 C 13.671875 2.132813 13.257813 1.933594 12.84375 2 C 12.511719 2.046875 12.226563 2.257813 12.082031 2.558594 C 11.9375 2.859375 11.953125 3.210938 12.125 3.5 L 18.21875 13.9375 C 18.089844 14.269531 18 14.621094 18 15 L 18 18.625 C 12.679688 21.226563 9 26.6875 9 33 C 9 41.824219 16.175781 49 25 49 C 33.824219 49 41 41.824219 41 33 C 41 26.6875 37.320313 21.226563 32 18.625 L 32 14.6875 C 32.007813 14.433594 31.917969 14.1875 31.75 14 L 37.875 3.5 C 38.152344 3.015625 37.984375 2.402344 37.5 2.125 C 37.015625 1.847656 36.402344 2.015625 36.125 2.5 L 29.40625 14 L 21.75 14 L 21.90625 13.71875 C 21.929688 13.6875 21.949219 13.65625 21.96875 13.625 C 22.03125 13.550781 22.085938 13.464844 22.125 13.375 C 22.136719 13.34375 22.148438 13.3125 22.15625 13.28125 L 25.65625 7.3125 C 25.679688 7.28125 25.699219 7.25 25.71875 7.21875 C 25.859375 7.082031 25.957031 6.910156 26 6.71875 C 26.011719 6.6875 26.023438 6.65625 26.03125 6.625 L 27.875 3.5 C 28.078125 3.179688 28.082031 2.769531 27.882813 2.441406 C 27.683594 2.117188 27.316406 1.933594 26.9375 1.96875 Z M 20 16 L 30 16 L 30 17.8125 C 28.421875 17.292969 26.75 17 25 17 C 23.25 17 21.578125 17.292969 20 17.8125 Z M 25 19 C 26.910156 19 28.746094 19.371094 30.40625 20.0625 C 30.417969 20.074219 30.425781 20.082031 30.4375 20.09375 C 30.445313 20.097656 30.460938 20.089844 30.46875 20.09375 C 30.546875 20.148438 30.628906 20.1875 30.71875 20.21875 C 30.726563 20.222656 30.742188 20.214844 30.75 20.21875 C 30.769531 20.230469 30.792969 20.242188 30.8125 20.25 C 35.652344 22.453125 39 27.328125 39 33 C 39 40.742188 32.742188 47 25 47 C 17.257813 47 11 40.742188 11 33 C 11 27.28125 14.410156 22.394531 19.3125 20.21875 C 19.390625 20.1875 19.464844 20.144531 19.53125 20.09375 C 21.207031 19.386719 23.0625 19 25 19 Z M 25 21 C 18.382813 21 13 26.382813 13 33 C 13 39.617188 18.382813 45 25 45 C 31.617188 45 37 39.617188 37 33 C 37 26.382813 31.617188 21 25 21 Z M 25 23 C 30.535156 23 35 27.464844 35 33 C 35 38.535156 30.535156 43 25 43 C 19.464844 43 15 38.535156 15 33 C 15 27.464844 19.464844 23 25 23 Z M 22 28 L 22 30 L 24 30 L 24 36 L 22 36 L 22 38 L 28 38 L 28 36 L 26 36 L 26 30 L 28 30 L 28 28 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 11 0 C 10.640625 0 10.300781 0.1875 10.125 0.5 C 9.945313 0.8125 9.96875 1.191406 10.15625 1.5 L 17.65625 14.0625 L 23.84375 3.78125 L 21.84375 0.5 C 21.664063 0.199219 21.351563 0 21 0 Z M 29 0 C 28.648438 0 28.335938 0.199219 28.15625 0.5 L 25 5.75 L 20.65625 13 L 20.625 13 L 18 17 L 18 19.625 C 12.679688 22.226563 9 27.6875 9 34 C 9 42.820313 16.179688 50 25 50 C 33.820313 50 41 42.820313 41 34 C 41 27.6875 37.320313 22.226563 32 19.625 L 32 15.6875 C 32.007813 15.433594 31.917969 15.1875 31.75 15 L 39.84375 1.5 C 40.03125 1.191406 40.054688 0.8125 39.875 0.5 C 39.695313 0.1875 39.359375 0 39 0 Z M 20 17 L 30 17 L 30 18.8125 C 28.425781 18.292969 26.75 18 25 18 C 23.25 18 21.574219 18.292969 20 18.8125 Z M 25 22 C 31.617188 22 37 27.382813 37 34 C 37 40.617188 31.617188 46 25 46 C 18.382813 46 13 40.617188 13 34 C 13 27.382813 18.382813 22 25 22 Z M 25 24 C 19.484375 24 15 28.484375 15 34 C 15 39.515625 19.484375 44 25 44 C 30.515625 44 35 39.515625 35 34 C 35 28.484375 30.515625 24 25 24 Z M 22 29 L 28 29 L 28 31 L 26 31 L 26 38 L 28 38 L 28 40 L 22 40 L 22 38 L 24 38 L 24 31 L 22 31 Z' }))); }
    },
    {
        id: 1,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 20 4 C 19.448 4 19 4.448 19 5 L 19 18 C 19 24.063407 23.936593 29 30 29 C 36.063407 29 41 24.063407 41 18 L 41 5 C 41 4.448 40.552 4 40 4 C 39.448 4 39 4.448 39 5 L 39 18 C 39 22.982593 34.982593 27 30 27 C 25.017407 27 21 22.982593 21 18 L 21 5 C 21 4.448 20.552 4 20 4 z M 24 4 C 23.448 4 23 4.448 23 5 L 23 10.863281 C 23.598 10.277281 24.271 9.7716094 25 9.3496094 L 25 5 C 25 4.448 24.552 4 24 4 z M 28 4 C 27.448 4 27 4.448 27 5 L 27 8.4589844 C 27.641 8.2579844 28.31 8.1197812 29 8.0507812 L 29 5 C 29 4.448 28.552 4 28 4 z M 32 4 C 31.448 4 31 4.448 31 5 L 31 8.0507812 C 31.69 8.1197812 32.359 8.2579844 33 8.4589844 L 33 5 C 33 4.448 32.552 4 32 4 z M 36 4 C 35.448 4 35 4.448 35 5 L 35 9.3496094 C 35.729 9.7716094 36.402 10.277281 37 10.863281 L 37 5 C 37 4.448 36.552 4 36 4 z M 29 11 L 29 12.769531 C 26.352 13.213531 26.267578 15.566703 26.267578 15.845703 C 26.267578 18.321703 28.271813 18.768906 29.882812 19.128906 C 31.328813 19.452906 32.146484 19.68425 32.146484 20.65625 C 32.146484 21.23925 31.867953 22.21875 30.001953 22.21875 C 29.960953 22.21875 28.990813 22.211516 28.382812 21.603516 C 28.023812 21.244516 27.850187 20.7255 27.867188 20.0625 L 27.869141 20 L 26.011719 20 L 26.013672 20.064453 C 26.073672 22.164453 27.055953 23.364375 29.001953 23.734375 L 29.001953 25 L 29.097656 25 L 30.917969 25 L 31 25 L 31 23.765625 C 33.846 23.303625 34 21.097578 34 20.642578 C 34.001 18.251578 31.996719 17.791875 30.386719 17.421875 C 28.940719 17.089875 28.123047 16.856406 28.123047 15.941406 C 28.123047 14.846406 28.728297 14.335937 30.029297 14.335938 C 31.445297 14.335938 31.818141 15.207 31.869141 16 L 33.724609 16 C 33.725609 15.224 33.410469 14.38925 32.855469 13.78125 C 32.369469 13.25025 31.731047 12.908484 30.998047 12.771484 L 30.998047 11 L 30.917969 11 L 29.095703 11 L 29 11 z M 44.158203 25.984375 C 43.976081 25.987088 43.794527 26.003877 43.613281 26.033203 C 43.129958 26.111403 42.654568 26.286441 42.216797 26.5625 L 31.117188 33.402344 C 30.860975 33.262254 30.546838 33.107561 30.132812 32.908203 C 29.657062 32.679123 29.159549 32.445393 28.878906 32.318359 C 27.368214 31.6352 22.551898 29.647251 18.896484 28.042969 C 17.33274 27.356725 15.661395 27.005995 13.988281 26.990234 C 12.315168 26.974474 10.638837 27.294229 9.0625 27.951172 L 2.6152344 30.636719 A 1.0001 1.0001 0 1 0 3.3847656 32.482422 L 9.8320312 29.796875 C 12.481356 28.692761 15.463286 28.721482 18.091797 29.875 C 21.782383 31.494718 26.67738 33.517784 28.054688 34.140625 C 28.302045 34.252592 28.801627 34.487516 29.265625 34.710938 C 29.729623 34.934357 30.21732 35.181535 30.257812 35.205078 C 30.703995 35.464594 31 35.929151 31 36.488281 C 31 37.329093 30.340812 37.988281 29.5 37.988281 C 29.380834 37.988281 29.267782 37.974949 29.160156 37.949219 A 1.0001 1.0001 0 0 0 29.158203 37.949219 C 29.132973 37.943219 28.341821 37.721019 27.382812 37.439453 C 26.423804 37.157887 25.203555 36.796274 24.003906 36.439453 C 21.604609 35.725811 19.287109 35.03125 19.287109 35.03125 A 1.0001054 1.0001054 0 0 0 18.712891 36.947266 C 18.712891 36.947266 21.033844 37.641111 23.435547 38.355469 C 24.636398 38.712648 25.857071 39.074613 26.820312 39.357422 C 27.782628 39.639959 28.395226 39.823361 28.695312 39.894531 C 28.955687 39.956791 29.225166 39.988281 29.5 39.988281 C 31.421188 39.988281 33 38.40947 33 36.488281 C 33 35.89616 32.845356 35.339664 32.582031 34.849609 L 43.275391 28.259766 A 1.0001 1.0001 0 0 0 43.285156 28.253906 C 44.122074 27.726144 45.198996 27.970034 45.726562 28.806641 C 46.239013 29.618936 46.024802 30.663506 45.234375 31.208984 A 1.0001 1.0001 0 0 0 45.197266 31.234375 L 29.423828 43.185547 C 28.347119 44.001891 26.936059 44.221423 25.662109 43.769531 L 14.013672 39.640625 C 11.320349 38.529005 8.2378995 38.903354 5.8886719 40.626953 L 2.4042969 43.183594 A 1.0001 1.0001 0 1 0 3.5878906 44.794922 L 7.0722656 42.240234 C 8.861038 40.927834 11.199323 40.643854 13.25 41.490234 A 1.0001 1.0001 0 0 0 13.296875 41.507812 L 24.994141 45.654297 C 26.900191 46.330405 29.021523 46.000953 30.632812 44.779297 L 46.369141 32.855469 C 48.024714 31.712947 48.491519 29.441939 47.417969 27.740234 C 46.693184 26.590883 45.433055 25.965387 44.158203 25.984375 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 20 4 C 19.448 4 19 4.448 19 5 L 19 17.677734 C 19 23.402734 23.239453 28.413219 28.939453 28.949219 C 35.479453 29.565219 41 24.415 41 18 L 41 5 C 41 4.448 40.552 4 40 4 C 39.448 4 39 4.448 39 5 L 39 10.494141 C 39 11.387141 37.908828 11.823875 37.298828 11.171875 C 37.290828 11.163875 37.283391 11.154484 37.275391 11.146484 C 37.103391 10.961484 37 10.723703 37 10.470703 L 37 5 C 37 4.448 36.552 4 36 4 C 35.448 4 35 4.448 35 5 L 35 7.7695312 C 35 8.4545313 34.312734 8.9561719 33.677734 8.7011719 C 33.670734 8.6981719 33.66225 8.6963594 33.65625 8.6933594 C 33.26725 8.5383594 33 8.1806719 33 7.7636719 L 33 5 C 33 4.448 32.552 4 32 4 C 31.448 4 31 4.448 31 5 L 31 7.0390625 C 31 7.5840625 30.558672 8.0253906 30.013672 8.0253906 L 29.988281 8.0253906 C 29.442281 8.0253906 29 7.5840625 29 7.0390625 L 29 5 C 29 4.448 28.552 4 28 4 C 27.448 4 27 4.448 27 5 L 27 7.7636719 C 27 8.1806719 26.732703 8.5383594 26.345703 8.6933594 C 26.337703 8.6963594 26.329266 8.6981719 26.322266 8.7011719 C 25.687266 8.9561719 25 8.4554844 25 7.7714844 L 25 5 C 25 4.448 24.552 4 24 4 C 23.448 4 23 4.448 23 5 L 23 10.470703 C 23 10.723703 22.897609 10.962484 22.724609 11.146484 C 22.716609 11.154484 22.707219 11.163875 22.699219 11.171875 C 22.090219 11.824875 21 11.387141 21 10.494141 L 21 5 C 21 4.448 20.552 4 20 4 z M 29 11 L 29.095703 11 L 30.917969 11 L 30.998047 11 L 30.998047 12.771484 C 31.731047 12.908484 32.369469 13.25025 32.855469 13.78125 C 33.410469 14.38925 33.725609 15.224 33.724609 16 L 31.869141 16 C 31.818141 15.207 31.445297 14.335937 30.029297 14.335938 C 28.728297 14.335938 28.123047 14.846406 28.123047 15.941406 C 28.123047 16.856406 28.940719 17.089875 30.386719 17.421875 C 31.996719 17.791875 34.001 18.251578 34 20.642578 C 34 21.097578 33.846 23.303625 31 23.765625 L 31 25 L 30.917969 25 L 29.097656 25 L 29.001953 25 L 29.001953 23.734375 C 27.055953 23.364375 26.073672 22.164453 26.013672 20.064453 L 26.011719 20 L 27.869141 20 L 27.867188 20.0625 C 27.850188 20.7255 28.023812 21.244516 28.382812 21.603516 C 28.990813 22.211516 29.960953 22.21875 30.001953 22.21875 C 31.867953 22.21875 32.146484 21.23925 32.146484 20.65625 C 32.146484 19.68425 31.328813 19.452906 29.882812 19.128906 C 28.271812 18.768906 26.267578 18.321703 26.267578 15.845703 C 26.267578 15.566703 26.352 13.213531 29 12.769531 L 29 11 z M 44.345703 26.001953 C 43.620652 25.978035 42.882812 26.162922 42.226562 26.576172 L 32.876953 32.339844 C 33.585953 33.062844 34 34.043172 34 35.076172 C 34 37.246172 32.234453 39.011719 30.064453 39.011719 C 29.758453 39.011719 29.455109 38.97525 29.162109 38.90625 C 28.393109 38.72425 18.569172 35.783219 17.451172 35.449219 C 16.922172 35.290219 16.62325 34.732125 16.78125 34.203125 C 16.94025 33.674125 17.497391 33.375203 18.025391 33.533203 C 22.391391 34.841203 29.084047 36.834891 29.623047 36.962891 C 29.766047 36.996891 29.914453 37.013672 30.064453 37.013672 C 31.131453 37.013672 32 36.145125 32 35.078125 C 32 34.389125 31.641969 33.769875 31.042969 33.421875 C 30.751969 33.252875 20.881484 28.937406 18.896484 28.066406 C 15.786484 26.700406 12.2005 26.666656 9.0625 27.972656 L 2.6152344 30.658203 C 2.1052344 30.868203 2 31.331844 2 31.964844 L 2 44.009766 C 2 44.561766 2.448 45.009766 3 45.009766 C 3.305 45.009766 3.5488906 44.845406 3.5878906 44.816406 L 7.0722656 42.259766 C 8.8482656 40.956766 11.215828 40.670344 13.298828 41.527344 L 24.994141 45.673828 C 25.651141 45.906828 26.331813 46.021484 27.007812 46.021484 C 28.298813 46.021484 29.570813 45.605781 30.632812 44.800781 L 46.369141 32.875 C 48.040141 31.723 48.500969 29.476766 47.417969 27.759766 C 46.725469 26.661016 45.554121 26.041816 44.345703 26.001953 z' }))); }
    },
    {
        id: 12,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 10.8125 0 C 10.335938 0.0898438 9.992188 0.511719 10 1 L 10 15 C 10 18.054688 11.523438 19.878906 12.875 21 C 13.550781 21.558594 14.179688 22 14.5625 22.34375 C 14.945313 22.6875 15 22.828125 15 23 C 15 23.949219 14.75 26.75 14.5 29.84375 C 14.25 32.9375 14 36.382813 14 39 C 14 43.71875 14.433594 46.320313 15.25 47.9375 C 15.65625 48.746094 16.207031 49.308594 16.8125 49.625 C 17.417969 49.941406 18.027344 50 18.5 50 C 18.972656 50 19.582031 49.941406 20.1875 49.625 C 20.792969 49.308594 21.34375 48.746094 21.75 47.9375 C 22.566406 46.320313 23 43.71875 23 39 C 23 36.382813 22.75 32.9375 22.5 29.84375 C 22.25 26.75 22 23.949219 22 23 C 22 22.828125 22.058594 22.679688 22.4375 22.34375 C 22.816406 22.007813 23.449219 21.617188 24.125 21.0625 C 25.480469 19.953125 27 18.097656 27 15 L 27 1 C 27 0.449219 26.550781 0 26 0 L 23 0 C 22.449219 0 22 0.449219 22 1 L 22 11.5 C 22 11.714844 21.714844 12 21.5 12 C 21.285156 12 21 11.714844 21 11.5 L 21 1 C 21 0.449219 20.550781 0 20 0 L 17 0 C 16.96875 0 16.9375 0 16.90625 0 C 16.390625 0.046875 15.996094 0.480469 16 1 L 16 11.5 C 16 11.714844 15.714844 12 15.5 12 C 15.285156 12 15 11.714844 15 11.5 L 15 1 C 15 0.449219 14.550781 0 14 0 L 11 0 C 10.96875 0 10.9375 0 10.90625 0 C 10.875 0 10.84375 0 10.8125 0 Z M 29.8125 0 C 29.335938 0.0898438 28.992188 0.511719 29 1 L 29 13 C 29 28.957031 28 32.378906 28 38 C 28 43.148438 28.351563 45.964844 29.09375 47.71875 C 29.464844 48.59375 29.980469 49.234375 30.625 49.59375 C 31.269531 49.953125 31.933594 50 32.5 50 C 33.066406 50 33.730469 49.953125 34.375 49.59375 C 35.019531 49.234375 35.535156 48.59375 35.90625 47.71875 C 36.648438 45.964844 37 43.148438 37 38 C 37 35.066406 36.1875 32.980469 35.40625 31.40625 C 34.625 29.832031 34 28.785156 34 28 C 34 27.25 34.269531 26.699219 34.75 26.0625 C 35.230469 25.425781 35.949219 24.765625 36.71875 24 C 38.261719 22.472656 40 20.378906 40 17 C 40 15.105469 39.75 11.046875 38.4375 7.3125 C 37.78125 5.445313 36.871094 3.652344 35.5 2.28125 C 34.128906 0.910156 32.257813 0 30 0 C 29.96875 0 29.9375 0 29.90625 0 C 29.875 0 29.84375 0 29.8125 0 Z M 12 2 L 13 2 L 13 11.5 C 13 12.882813 14.117188 14 15.5 14 C 16.882813 14 18 12.882813 18 11.5 L 18 2 L 19 2 L 19 11.5 C 19 12.882813 20.117188 14 21.5 14 C 22.882813 14 24 12.882813 24 11.5 L 24 2 L 25 2 L 25 15 C 25 17.503906 24.019531 18.5625 22.875 19.5 C 22.300781 19.96875 21.683594 20.382813 21.125 20.875 C 20.566406 21.367188 20 22.070313 20 23 C 20 24.25 20.25 26.917969 20.5 30 C 20.75 33.082031 21 36.515625 21 39 C 21 43.582031 20.503906 45.972656 19.96875 47.03125 C 19.703125 47.558594 19.453125 47.738281 19.25 47.84375 C 19.046875 47.949219 18.828125 48 18.5 48 C 18.171875 48 17.953125 47.949219 17.75 47.84375 C 17.546875 47.738281 17.296875 47.558594 17.03125 47.03125 C 16.496094 45.972656 16 43.582031 16 39 C 16 36.515625 16.25 33.082031 16.5 30 C 16.75 26.917969 17 24.25 17 23 C 17 22.070313 16.429688 21.34375 15.875 20.84375 C 15.320313 20.34375 14.699219 19.945313 14.125 19.46875 C 12.976563 18.515625 12 17.445313 12 15 Z M 31 2.1875 C 32.207031 2.398438 33.230469 2.855469 34.0625 3.6875 C 35.128906 4.753906 35.96875 6.285156 36.5625 7.96875 C 37.75 11.335938 38 15.292969 38 17 C 38 19.722656 36.738281 21.117188 35.28125 22.5625 C 34.550781 23.285156 33.769531 23.996094 33.125 24.84375 C 32.480469 25.691406 32 26.75 32 28 C 32 29.617188 32.875 30.828125 33.59375 32.28125 C 34.3125 33.734375 35 35.433594 35 38 C 35 43.050781 34.601563 45.742188 34.09375 46.9375 C 33.839844 47.535156 33.605469 47.734375 33.40625 47.84375 C 33.207031 47.953125 32.933594 48 32.5 48 C 32.066406 48 31.792969 47.953125 31.59375 47.84375 C 31.394531 47.734375 31.160156 47.535156 30.90625 46.9375 C 30.398438 45.742188 30 43.050781 30 38 C 30 32.621094 31 29.042969 31 13 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 11 0 C 10.449219 0 10 0.449219 10 1 L 10 15 C 10 18.867188 12.234375 20.566406 13.71875 21.6875 C 14.402344 22.203125 15 22.644531 15 23 C 15 23.832031 14.839844 25.746094 14.65625 27.96875 C 14.363281 31.492188 14 35.882813 14 39 C 14 46.914063 15.261719 50 18.5 50 C 21.738281 50 23 46.914063 23 39 C 23 35.882813 22.636719 31.492188 22.34375 27.96875 C 22.160156 25.746094 22 23.832031 22 23 C 22 22.65625 22.578125 22.214844 23.25 21.71875 C 24.742188 20.609375 27 18.945313 27 15 L 27 1 C 27 0.449219 26.554688 0 26 0 L 23 0 C 22.449219 0 22 0.449219 22 1 L 22 11.5 C 22 11.746094 21.746094 12 21.5 12 C 21.253906 12 21 11.746094 21 11.5 L 21 1 C 21 0.449219 20.550781 0 20 0 L 17 0 C 16.449219 0 16 0.449219 16 1 L 16 11.5 C 16 11.746094 15.746094 12 15.5 12 C 15.253906 12 15 11.746094 15 11.5 L 15 1 C 15 0.449219 14.550781 0 14 0 Z M 30 0 C 29.445313 0 29 0.449219 29 1 L 29 13 C 29 23.046875 28.601563 28.164063 28.3125 31.90625 C 28.136719 34.148438 28 35.929688 28 38 C 28 47.085938 29.09375 50 32.5 50 C 35.90625 50 37 47.085938 37 38 C 37 34.441406 35.808594 32.167969 34.9375 30.5 C 34.414063 29.503906 34 28.710938 34 28 C 34 26.699219 34.835938 25.8125 36.21875 24.46875 C 37.898438 22.832031 40 20.792969 40 17 C 40 10.6875 37.894531 0 30 0 Z' }))); }
    },
    {
        id: 2,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '22px', height: '22px' },
            react.createElement("path", { d: 'M 25 0 C 21.101563 0 18.875 0.546875 17.53125 1.1875 C 16.859375 1.507813 16.410156 1.851563 16.125 2.15625 C 15.839844 2.460938 15.65625 2.84375 15.65625 2.84375 C 15.625 2.925781 15.605469 3.007813 15.59375 3.09375 L 14 16.875 C 13.984375 17.011719 13.992188 17.148438 14.03125 17.28125 C 14.027344 17.457031 14 17.625 14 17.8125 C 14 23.859375 18.953125 28.8125 25 28.8125 C 31.046875 28.8125 36 23.859375 36 17.8125 C 36 17.636719 35.972656 17.480469 35.96875 17.3125 C 36.011719 17.171875 36.023438 17.019531 36 16.875 L 34.40625 3.09375 C 34.394531 3.007813 34.375 2.925781 34.34375 2.84375 C 34.34375 2.84375 34.160156 2.460938 33.875 2.15625 C 33.589844 1.851563 33.140625 1.507813 32.46875 1.1875 C 31.125 0.546875 28.898438 0 25 0 Z M 25 2 C 28.703125 2 30.667969 2.542969 31.625 3 C 32.101563 3.230469 32.335938 3.425781 32.4375 3.53125 L 33.53125 13 C 33.339844 12.9375 33.136719 12.875 32.9375 12.84375 C 31.019531 12.523438 28.625 13 25 13 C 23.1875 13 21.667969 12.890625 20.375 12.8125 C 19.082031 12.734375 18.019531 12.683594 17.0625 12.84375 C 16.863281 12.875 16.660156 12.9375 16.46875 13 L 17.5625 3.53125 C 17.664063 3.425781 17.898438 3.230469 18.375 3 C 19.332031 2.542969 21.296875 2 25 2 Z M 24 4 L 24 7 L 21 7 L 21 9 L 24 9 L 24 12 L 26 12 L 26 9 L 29 9 L 29 7 L 26 7 L 26 4 Z M 17.90625 14.75 C 19.285156 14.6875 21.695313 15 25 15 C 28.777344 15 31.390625 14.605469 32.625 14.8125 C 33.242188 14.914063 33.421875 15.054688 33.625 15.40625 C 33.828125 15.757813 34 16.515625 34 17.8125 C 34 22.765625 29.953125 26.8125 25 26.8125 C 20.046875 26.8125 16 22.765625 16 17.8125 C 16 16.515625 16.171875 15.757813 16.375 15.40625 C 16.578125 15.054688 16.757813 14.914063 17.375 14.8125 C 17.527344 14.785156 17.710938 14.757813 17.90625 14.75 Z M 25 29.8125 C 18.785156 29.8125 13.15625 31.339844 9 33.59375 C 4.84375 35.847656 2 38.820313 2 42.09375 L 2 50 L 24.78125 50 C 24.914063 50.027344 25.054688 50.027344 25.1875 50 L 48 50 L 48 42.09375 C 48 38.820313 45.15625 35.847656 41 33.59375 C 38.667969 32.328125 35.855469 31.289063 32.75 30.625 C 32.578125 30.527344 32.382813 30.484375 32.1875 30.5 C 29.921875 30.050781 27.515625 29.8125 25 29.8125 Z M 25 31.8125 C 27.023438 31.8125 28.984375 31.96875 30.84375 32.28125 L 25 46.375 L 19.15625 32.28125 C 21.015625 31.96875 22.976563 31.8125 25 31.8125 Z M 17.1875 32.71875 L 23.5 48 L 4 48 L 4 42.09375 C 4 40.066406 6.117188 37.414063 9.9375 35.34375 C 11.96875 34.242188 14.441406 33.347656 17.1875 32.71875 Z M 32.8125 32.71875 C 35.558594 33.347656 38.03125 34.242188 40.0625 35.34375 C 43.882813 37.414063 46 40.066406 46 42.09375 L 46 48 L 26.5 48 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '22px', height: '22px' },
            react.createElement("path", { d: 'M 25 0 C 17.296875 0 15.898438 2.171875 15.65625 2.84375 C 15.628906 2.917969 15.601563 3.015625 15.59375 3.09375 L 14.4375 13.28125 C 15.96875 12.613281 18.066406 12.699219 20.78125 12.84375 C 22.042969 12.910156 23.472656 13 25 13 C 26.523438 13 27.957031 12.910156 29.21875 12.84375 C 31.929688 12.699219 34.03125 12.613281 35.5625 13.28125 L 34.40625 3.09375 C 34.398438 3.015625 34.371094 2.917969 34.34375 2.84375 C 34.101563 2.171875 32.699219 0 25 0 Z M 24 4 L 26 4 L 26 7 L 29 7 L 29 9 L 26 9 L 26 12 L 24 12 L 24 9 L 21 9 L 21 7 L 24 7 Z M 18.65625 14.75 C 16.78125 14.695313 15.34375 14.816406 14.65625 15.46875 C 14.207031 15.898438 14 16.664063 14 17.8125 C 14 23.878906 18.933594 28.8125 25 28.8125 C 31.066406 28.8125 36 23.878906 36 17.8125 C 36 16.664063 35.792969 15.898438 35.34375 15.46875 C 34.429688 14.601563 32.160156 14.695313 29.3125 14.84375 C 28.027344 14.910156 26.578125 15 25 15 C 23.421875 15 21.972656 14.910156 20.6875 14.84375 C 19.976563 14.804688 19.28125 14.769531 18.65625 14.75 Z M 25 29.8125 C 22.757813 29.8125 20.527344 30.015625 18.40625 30.40625 L 25 46.40625 L 31.6875 30.4375 C 29.53125 30.03125 27.28125 29.8125 25 29.8125 Z M 16.4375 30.84375 C 8.300781 32.820313 2 37.347656 2 42.09375 L 2 50 L 25 50 C 24.597656 50 24.214844 49.75 24.0625 49.375 Z M 25 50 L 48 50 L 48 42.09375 C 48 37.371094 41.769531 32.835938 33.6875 30.84375 L 25.9375 49.375 C 25.78125 49.746094 25.402344 50 25 50 Z' }))); }
    },
    {
        id: 14,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 0 C 8.699219 0 6 2.699219 6 6 C 6 9.300781 8.699219 12 12 12 C 15.300781 12 18 9.300781 18 6 C 18 2.699219 15.300781 0 12 0 Z M 12 2 C 14.222656 2 16 3.777344 16 6 C 16 8.222656 14.222656 10 12 10 C 9.777344 10 8 8.222656 8 6 C 8 3.777344 9.777344 2 12 2 Z M 9.09375 13 C 7.5625 13 6.402344 13.675781 5.65625 14.46875 C 4.910156 15.261719 4.523438 16.144531 4.34375 16.6875 C 4.34375 16.6875 1.253906 26.136719 0.34375 28.96875 C 0.339844 28.976563 0.347656 28.992188 0.34375 29 C 0.015625 29.941406 0.109375 30.945313 0.59375 31.71875 C 1.082031 32.5 1.992188 33 3 33 L 2.5625 34.28125 C 2.550781 34.300781 2.539063 34.324219 2.53125 34.34375 C 2.402344 34.859375 2.410156 35.601563 2.78125 36.15625 C 2.816406 36.210938 2.859375 36.265625 2.90625 36.3125 C 3.222656 36.628906 3.660156 37 4.40625 37 L 7 37 L 7 47 C 7 48.644531 8.355469 50 10 50 C 10.765625 50 11.46875 49.699219 12 49.21875 C 12.53125 49.699219 13.234375 50 14 50 C 15.644531 50 17 48.644531 17 47 L 17 37 L 19.59375 37 C 20.339844 37 20.777344 36.628906 21.09375 36.3125 C 21.140625 36.265625 21.183594 36.210938 21.21875 36.15625 C 21.589844 35.601563 21.597656 34.859375 21.46875 34.34375 C 21.460938 34.324219 21.449219 34.300781 21.4375 34.28125 L 21 33 C 22.007813 33 22.917969 32.5 23.40625 31.71875 C 23.890625 30.945313 23.984375 29.941406 23.65625 29 C 23.652344 28.992188 23.660156 28.976563 23.65625 28.96875 C 22.746094 26.136719 19.65625 16.6875 19.65625 16.6875 C 19.476563 16.144531 19.089844 15.261719 18.34375 14.46875 C 17.597656 13.675781 16.4375 13 14.90625 13 Z M 9.09375 15 L 14.90625 15 C 15.875 15 16.449219 15.359375 16.90625 15.84375 C 17.363281 16.328125 17.632813 16.957031 17.75 17.3125 C 17.75 17.3125 20.851563 26.804688 21.75 29.59375 C 21.75 29.605469 21.75 29.613281 21.75 29.625 C 21.910156 30.074219 21.855469 30.4375 21.71875 30.65625 C 21.582031 30.875 21.390625 31 21 31 C 20.617188 31 20.292969 30.792969 20.125 30.34375 C 20.117188 30.3125 20.105469 30.28125 20.09375 30.25 L 17.25 21.6875 C 17.097656 21.179688 16.578125 20.878906 16.0625 21 C 15.785156 21.0625 15.546875 21.242188 15.40625 21.496094 C 15.269531 21.746094 15.246094 22.042969 15.34375 22.3125 L 18.1875 30.8125 L 18.1875 30.84375 C 18.199219 30.917969 18.222656 30.992188 18.25 31.0625 C 18.265625 31.105469 18.292969 31.144531 18.3125 31.1875 L 19.53125 34.84375 C 19.589844 35.082031 19.578125 34.996094 19.5625 35 L 4.4375 35 C 4.421875 34.996094 4.410156 35.082031 4.46875 34.84375 L 5.75 31.0625 C 5.785156 30.972656 5.804688 30.878906 5.8125 30.78125 L 8.65625 22.3125 C 8.777344 21.96875 8.703125 21.589844 8.464844 21.316406 C 8.222656 21.042969 7.855469 20.921875 7.5 21 C 7.144531 21.074219 6.855469 21.339844 6.75 21.6875 L 3.875 30.34375 C 3.707031 30.792969 3.382813 31 3 31 C 2.609375 31 2.417969 30.875 2.28125 30.65625 C 2.144531 30.4375 2.089844 30.074219 2.25 29.625 C 2.25 29.613281 2.25 29.605469 2.25 29.59375 C 3.148438 26.804688 6.25 17.3125 6.25 17.3125 C 6.367188 16.957031 6.636719 16.328125 7.09375 15.84375 C 7.550781 15.359375 8.125 15 9.09375 15 Z M 39.34375 19 C 39.015625 19.050781 38.734375 19.261719 38.59375 19.5625 L 33.375 30 L 25 30 C 24.96875 30 24.9375 30 24.90625 30 C 24.875 30 24.84375 30 24.8125 30 C 24.335938 30.089844 23.992188 30.511719 24 31 C 24 34.855469 25.980469 38.25 29 40.4375 C 27.242188 41.214844 26 42.964844 26 45 C 26 47.75 28.25 50 31 50 C 33.75 50 36 47.75 36 45 C 36 44.253906 35.828125 43.546875 35.53125 42.90625 C 36.015625 42.957031 36.503906 43 37 43 C 37.875 43 38.730469 42.90625 39.5625 42.75 C 39.214844 43.429688 39 44.1875 39 45 C 39 47.75 41.25 50 44 50 C 46.75 50 49 47.75 49 45 C 49 42.707031 47.425781 40.769531 45.3125 40.1875 C 48.078125 38.054688 49.875 34.882813 49.96875 31.28125 C 49.980469 31.261719 49.992188 31.238281 50 31.21875 C 50 31.144531 50 31.074219 50 31 C 50.003906 30.957031 50.003906 30.917969 50 30.875 C 49.9375 25.21875 45.578125 20.515625 39.75 19.03125 C 39.617188 18.992188 39.480469 18.984375 39.34375 19 Z M 40 21.28125 C 44.332031 22.667969 47.355469 26.003906 47.8125 30 L 35.625 30 Z M 26.21875 32 L 47.78125 32 C 47.207031 37.019531 42.710938 41 37 41 C 31.289063 41 26.792969 37.019531 26.21875 32 Z M 9 37 L 11 37 L 11 47 C 11 47.554688 10.554688 48 10 48 C 9.445313 48 9 47.554688 9 47 Z M 13 37 L 15 37 L 15 47 C 15 47.554688 14.554688 48 14 48 C 13.445313 48 13 47.554688 13 47 Z M 31 42 C 32.667969 42 34 43.332031 34 45 C 34 46.667969 32.667969 48 31 48 C 29.332031 48 28 46.667969 28 45 C 28 43.332031 29.332031 42 31 42 Z M 44 42 C 45.667969 42 47 43.332031 47 45 C 47 46.667969 45.667969 48 44 48 C 42.332031 48 41 46.667969 41 45 C 41 43.332031 42.332031 42 44 42 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 0 C 8.699219 0 6 2.699219 6 6 C 6 9.300781 8.699219 12 12 12 C 15.300781 12 18 9.300781 18 6 C 18 2.699219 15.300781 0 12 0 Z M 9.40625 13 C 6.304688 13 4.914063 14.800781 4.3125 17 C 4.3125 17 0.3125 29.398438 0.3125 29.5 C -0.1875 30.898438 -0.0546875 32.40625 1.84375 32.40625 C 2.945313 32.40625 3.230469 31.785156 3.53125 31.1875 L 6.875 21.78125 C 6.882813 21.753906 6.894531 21.742188 6.90625 21.71875 L 6.90625 21.6875 C 6.988281 21.523438 7.148438 21.40625 7.34375 21.40625 C 7.621094 21.40625 7.84375 21.628906 7.84375 21.90625 C 7.84375 21.945313 7.820313 21.992188 7.8125 22.03125 L 3.0625 35.59375 C 2.960938 35.894531 3.042969 36.199219 3.1875 36.5 C 3.386719 36.800781 3.664063 37 4.0625 37 L 19.9375 37 C 20.335938 37 20.644531 36.800781 20.84375 36.5 C 20.988281 36.199219 21.039063 35.894531 20.9375 35.59375 L 16.21875 22.03125 C 16.210938 21.992188 16.1875 21.976563 16.1875 21.9375 C 16.1875 21.660156 16.410156 21.4375 16.6875 21.4375 C 16.882813 21.4375 17.042969 21.523438 17.125 21.6875 L 17.125 21.71875 C 17.136719 21.742188 17.148438 21.753906 17.15625 21.78125 L 20.46875 31.1875 C 20.769531 31.789063 21.085938 32.40625 22.1875 32.40625 C 24.089844 32.40625 24.21875 30.898438 23.71875 29.5 C 23.71875 29.398438 19.71875 17 19.71875 17 C 19.117188 14.800781 17.726563 13 14.625 13 Z M 39.4375 18.96875 C 39.105469 19 38.839844 19.199219 38.6875 19.5 L 34.40625 28 L 49.59375 28 C 48.394531 23.800781 44.714844 20.300781 39.8125 19 C 39.6875 18.976563 39.546875 18.957031 39.4375 18.96875 Z M 25 30 C 24.398438 30 24 30.398438 24 31 C 24 34.8125 25.945313 38.203125 28.96875 40.40625 C 27.203125 41.171875 26 42.925781 26 45 C 26 47.800781 28.199219 50 31 50 C 33.800781 50 36 47.800781 36 45 C 36 44.257813 35.839844 43.566406 35.5625 42.9375 C 36.03125 42.984375 36.519531 43 37 43 C 37.867188 43 38.710938 42.898438 39.53125 42.75 C 39.195313 43.425781 39 44.183594 39 45 C 39 47.800781 41.199219 50 44 50 C 46.800781 50 49 47.800781 49 45 C 49 42.667969 47.472656 40.761719 45.34375 40.1875 C 48.191406 37.980469 50 34.683594 50 31 C 50 30.398438 49.601563 30 49 30 Z M 7 38 L 7 48 C 7 49.101563 7.898438 50 9 50 C 10.101563 50 11 49.101563 11 48 L 11 38 Z M 12 38 L 12 48 C 12 49.101563 12.898438 50 14 50 C 15.101563 50 16 49.101563 16 48 L 16 38 Z M 31 42 C 32.699219 42 34 43.300781 34 45 C 34 46.699219 32.699219 48 31 48 C 29.300781 48 28 46.699219 28 45 C 28 43.300781 29.300781 42 31 42 Z M 44 42 C 45.699219 42 47 43.300781 47 45 C 47 46.699219 45.699219 48 44 48 C 42.300781 48 41 46.699219 41 45 C 41 43.300781 42.300781 42 44 42 Z' }))); }
    },
    {
        id: 8,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 9 3 C 7.355469 3 6 4.355469 6 6 L 6 8.832031 C 5.980469 8.941406 5.980469 9.050781 6 9.15625 L 6 39.832031 C 5.980469 39.941406 5.980469 40.050781 6 40.15625 L 6 44 C 6 45.644531 7.355469 47 9 47 L 29 47 C 30.644531 47 32 45.644531 32 44 L 32 40.167969 C 32.019531 40.058594 32.019531 39.949219 32 39.84375 L 32 9.167969 C 32.019531 9.058594 32.019531 8.949219 32 8.84375 L 32 6 C 32 4.355469 30.644531 3 29 3 Z M 9 5 L 29 5 C 29.554688 5 30 5.445313 30 6 L 30 8 L 8 8 L 8 6 C 8 5.445313 8.445313 5 9 5 Z M 8 10 L 30 10 L 30 39 L 8 39 Z M 40.636719 12.363281 L 39.21875 13.78125 C 42.144531 16.4375 44 20.246094 44 24.5 C 44 28.496094 42.367188 32.117188 39.742188 34.742188 L 41.144531 36.144531 C 44.136719 33.160156 46 29.050781 46 24.5 C 46 19.695313 43.921875 15.382813 40.636719 12.363281 Z M 36.394531 16.605469 L 34.96875 18.03125 C 36.816406 19.585938 38 21.902344 38 24.5 C 38 26.84375 37.03125 28.953125 35.492188 30.492188 L 36.90625 31.90625 C 38.808594 30.007813 40 27.394531 40 24.5 C 40 21.351563 38.597656 18.53125 36.394531 16.605469 Z M 8 41 L 30 41 L 30 44 C 30 44.554688 29.554688 45 29 45 L 9 45 C 8.445313 45 8 44.554688 8 44 Z M 16 42 C 15.640625 41.996094 15.304688 42.183594 15.121094 42.496094 C 14.941406 42.808594 14.941406 43.191406 15.121094 43.503906 C 15.304688 43.816406 15.640625 44.003906 16 44 L 22 44 C 22.359375 44.003906 22.695313 43.816406 22.878906 43.503906 C 23.058594 43.191406 23.058594 42.808594 22.878906 42.496094 C 22.695313 42.183594 22.359375 41.996094 22 42 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 9 3 C 7.355469 3 6 4.355469 6 6 L 6 44 C 6 45.644531 7.355469 47 9 47 L 29 47 C 30.644531 47 32 45.644531 32 44 L 32 6 C 32 4.355469 30.644531 3 29 3 Z M 8 10 L 30 10 L 30 39 L 8 39 Z M 40.636719 12.363281 L 39.21875 13.78125 C 42.144531 16.4375 44 20.246094 44 24.5 C 44 28.496094 42.367188 32.117188 39.742188 34.742188 L 41.144531 36.144531 C 44.136719 33.160156 46 29.050781 46 24.5 C 46 19.695313 43.921875 15.382813 40.636719 12.363281 Z M 36.394531 16.605469 L 34.96875 18.03125 C 36.816406 19.585938 38 21.902344 38 24.5 C 38 26.84375 37.03125 28.953125 35.492188 30.492188 L 36.90625 31.90625 C 38.808594 30.007813 40 27.394531 40 24.5 C 40 21.351563 38.597656 18.53125 36.394531 16.605469 Z M 16 42 L 22 42 C 22.550781 42 23 42.449219 23 43 C 23 43.550781 22.550781 44 22 44 L 16 44 C 15.449219 44 15 43.550781 15 43 C 15 42.449219 15.449219 42 16 42 Z' }))); }
    },
    {
        id: 3,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12.962891 3 A 1.0001 1.0001 0 0 0 12 4 L 12 26 L 10 26 C 7.8045455 26 6 27.804545 6 30 L 6 46 A 1.0001 1.0001 0 1 0 8 46 L 8 30 C 8 28.895455 8.8954545 28 10 28 L 12 28 L 12 30 C 10.895 30 10 30.895 10 32 C 10 33.105 10.895 34 12 34 L 38 34 C 39.105 34 40 33.105 40 32 C 40 30.895 39.105 30 38 30 L 38 28 L 40 28 C 41.104545 28 42 28.895455 42 30 L 42 46 A 1.0001 1.0001 0 1 0 44 46 L 44 30 C 44 27.804545 42.195455 26 40 26 L 38 26 L 38 4 A 1.0001 1.0001 0 0 0 36.552734 3.1054688 L 35 3.8828125 L 33.447266 3.1054688 A 1.0001 1.0001 0 0 0 32.552734 3.1054688 L 31 3.8828125 L 29.447266 3.1054688 A 1.0001 1.0001 0 0 0 28.552734 3.1054688 L 27 3.8828125 L 25.447266 3.1054688 A 1.0001 1.0001 0 0 0 24.552734 3.1054688 L 23 3.8828125 L 21.447266 3.1054688 A 1.0001 1.0001 0 0 0 20.552734 3.1054688 L 19 3.8828125 L 17.447266 3.1054688 A 1.0001 1.0001 0 0 0 16.552734 3.1054688 L 15 3.8828125 L 13.447266 3.1054688 A 1.0001 1.0001 0 0 0 12.962891 3 z M 17 5.1171875 L 18.552734 5.8945312 A 1.0001 1.0001 0 0 0 19.447266 5.8945312 L 21 5.1171875 L 22.552734 5.8945312 A 1.0001 1.0001 0 0 0 23.447266 5.8945312 L 25 5.1171875 L 26.552734 5.8945312 A 1.0001 1.0001 0 0 0 27.447266 5.8945312 L 29 5.1171875 L 30.552734 5.8945312 A 1.0001 1.0001 0 0 0 31.447266 5.8945312 L 33 5.1171875 L 34.552734 5.8945312 A 1.0001 1.0001 0 0 0 35.447266 5.8945312 L 36 5.6171875 L 36 26.832031 A 1.0001 1.0001 0 0 0 36 27.158203 L 36 32 L 14 32 L 14 27.167969 A 1.0001 1.0001 0 0 0 14 26.841797 L 14 5.6171875 L 14.552734 5.8945312 A 1.0001 1.0001 0 0 0 15.447266 5.8945312 L 17 5.1171875 z M 24 9 L 24 11.220703 C 22.400034 11.480913 21.210789 12.144211 20.664062 12.978516 C 19.996547 13.997145 20 15.052734 20 15.052734 C 20 16.481825 20.858999 17.58482 21.873047 18.224609 C 22.887094 18.864398 24.071516 19.216963 25.189453 19.582031 C 26.30739 19.9471 27.353422 20.323621 28.021484 20.789062 C 28.689546 21.254504 29 21.665308 29 22.544922 C 29 22.544922 29.0039 23.078058 28.564453 23.685547 C 28.125008 24.293036 27.2696 25 25 25 C 22.766667 25 21.938855 24.216621 21.472656 23.470703 C 21.006457 22.724785 21 22 21 22 L 19 22 C 19 22 18.9935 23.275215 19.777344 24.529297 C 20.444342 25.596494 21.919248 26.48535 24 26.771484 L 24 29 L 26 29 L 26 26.802734 C 28.044643 26.558744 29.497361 25.80877 30.185547 24.857422 C 30.996102 23.736911 31 22.544922 31 22.544922 C 31 21.037036 30.185454 19.858684 29.166016 19.148438 C 28.146578 18.438191 26.94261 18.051322 25.810547 17.681641 C 24.678484 17.311959 23.612906 16.958102 22.939453 16.533203 C 22.266001 16.108305 22 15.789144 22 15.052734 C 22 15.052734 22.0035 14.58159 22.335938 14.074219 C 22.668422 13.566848 23.254333 13 25 13 C 26.75 13 27.338646 13.560702 27.667969 14.054688 C 27.997292 14.548671 28 15 28 15 L 30 15 C 30 15 30.0027 13.951329 29.332031 12.945312 C 28.78297 12.121722 27.595647 11.472184 26 11.216797 L 26 9 L 24 9 z M 12 37 C 11.448 37 11 37.448 11 38 L 11 40 C 11 40.552 11.448 41 12 41 L 18 41 C 18.552 41 19 40.552 19 40 L 19 38 C 19 37.448 18.552 37 18 37 L 12 37 z M 22 37 C 21.448 37 21 37.448 21 38 L 21 40 C 21 40.552 21.448 41 22 41 L 28 41 C 28.552 41 29 40.552 29 40 L 29 38 C 29 37.448 28.552 37 28 37 L 22 37 z M 32 37 C 31.448 37 31 37.448 31 38 L 31 40 C 31 40.552 31.448 41 32 41 L 38 41 C 38.552 41 39 40.552 39 40 L 39 38 C 39 37.448 38.552 37 38 37 L 32 37 z M 12 43 C 11.448 43 11 43.448 11 44 L 11 46 C 11 46.552 11.448 47 12 47 L 18 47 C 18.552 47 19 46.552 19 46 L 19 44 C 19 43.448 18.552 43 18 43 L 12 43 z M 22 43 C 21.448 43 21 43.448 21 44 L 21 46 C 21 46.552 21.448 47 22 47 L 28 47 C 28.552 47 29 46.552 29 46 L 29 44 C 29 43.448 28.552 43 28 43 L 22 43 z M 32 43 C 31.448 43 31 43.448 31 44 L 31 46 C 31 46.552 31.448 47 32 47 L 38 47 C 38.552 47 39 46.552 39 46 L 39 44 C 39 43.448 38.552 43 38 43 L 32 43 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12.962891 3 A 1.0001 1.0001 0 0 0 12 4 L 12 26 L 9.9707031 26 C 7.7647031 26 6 27.794 6 30 L 6 46 C 6 46.553 6.4177031 47 6.9707031 47 L 10.970703 47 L 10.970703 45 C 10.970703 44.448 11.418703 44 11.970703 44 L 17.970703 44 C 18.522703 44 18.970703 44.448 18.970703 45 L 18.970703 47 L 20.970703 47 L 20.970703 45 C 20.970703 44.448 21.418703 44 21.970703 44 L 27.970703 44 C 28.522703 44 28.970703 44.448 28.970703 45 L 28.970703 47 L 30.970703 47 L 30.970703 45 C 30.970703 44.448 31.418703 44 31.970703 44 L 37.970703 44 C 38.522703 44 38.970703 44.448 38.970703 45 L 38.970703 47 L 42.970703 47 C 43.523703 47 43.970703 46.553 43.970703 46 L 43.970703 30 C 43.970703 27.794 42.176703 26 39.970703 26 L 38 26 L 38 4 A 1.0001 1.0001 0 0 0 36.552734 3.1054688 L 35 3.8828125 L 33.447266 3.1054688 A 1.0001 1.0001 0 0 0 32.552734 3.1054688 L 31 3.8828125 L 29.447266 3.1054688 A 1.0001 1.0001 0 0 0 28.552734 3.1054688 L 27 3.8828125 L 25.447266 3.1054688 A 1.0001 1.0001 0 0 0 24.552734 3.1054688 L 23 3.8828125 L 21.447266 3.1054688 A 1.0001 1.0001 0 0 0 20.552734 3.1054688 L 19 3.8828125 L 17.447266 3.1054688 A 1.0001 1.0001 0 0 0 16.552734 3.1054688 L 15 3.8828125 L 13.447266 3.1054688 A 1.0001 1.0001 0 0 0 12.962891 3 z M 17 5.1171875 L 18.552734 5.8945312 A 1.0001 1.0001 0 0 0 19.447266 5.8945312 L 21 5.1171875 L 22.552734 5.8945312 A 1.0001 1.0001 0 0 0 23.447266 5.8945312 L 25 5.1171875 L 26.552734 5.8945312 A 1.0001 1.0001 0 0 0 27.447266 5.8945312 L 29 5.1171875 L 30.552734 5.8945312 A 1.0001 1.0001 0 0 0 31.447266 5.8945312 L 33 5.1171875 L 34.552734 5.8945312 A 1.0001 1.0001 0 0 0 35.447266 5.8945312 L 36 5.6171875 L 36 34 L 14 34 L 14 5.6171875 L 14.552734 5.8945312 A 1.0001 1.0001 0 0 0 15.447266 5.8945312 L 17 5.1171875 z M 24 10 L 24 12.220703 C 22.400034 12.480913 21.210789 13.144211 20.664062 13.978516 C 19.996547 14.997145 20 16.052734 20 16.052734 C 20 17.481825 20.858999 18.58482 21.873047 19.224609 C 22.887094 19.864398 24.071516 20.216963 25.189453 20.582031 C 26.30739 20.9471 27.353422 21.323621 28.021484 21.789062 C 28.689546 22.254504 29 22.665308 29 23.544922 C 29 23.544922 29.0039 24.078058 28.564453 24.685547 C 28.125008 25.293036 27.2696 26 25 26 C 22.766667 26 21.938855 25.216621 21.472656 24.470703 C 21.006457 23.724785 21 23 21 23 L 19 23 C 19 23 18.9935 24.275215 19.777344 25.529297 C 20.444342 26.596494 21.919248 27.48535 24 27.771484 L 24 30 L 26 30 L 26 27.802734 C 28.044643 27.558744 29.497361 26.80877 30.185547 25.857422 C 30.996102 24.736911 31 23.544922 31 23.544922 C 31 22.037036 30.185454 20.858684 29.166016 20.148438 C 28.146578 19.438191 26.94261 19.051322 25.810547 18.681641 C 24.678484 18.311959 23.612906 17.958102 22.939453 17.533203 C 22.266001 17.108305 22 16.789144 22 16.052734 C 22 16.052734 22.0035 15.58159 22.335938 15.074219 C 22.668422 14.566848 23.254333 14 25 14 C 26.75 14 27.338646 14.560702 27.667969 15.054688 C 27.997292 15.548671 28 16 28 16 L 30 16 C 30 16 30.0027 14.951329 29.332031 13.945312 C 28.78297 13.121722 27.595647 12.472184 26 12.216797 L 26 10 L 24 10 z M 11.970703 30 L 12 30 L 12 34 L 11.970703 34 C 10.865703 34 9.9707031 33.105 9.9707031 32 C 9.9707031 30.895 10.865703 30 11.970703 30 z M 38 30.003906 C 39.091121 30.019968 39.970703 30.905041 39.970703 32 C 39.970703 33.094959 39.091121 33.980032 38 33.996094 L 38 30.003906 z M 11.970703 38 L 17.970703 38 C 18.522703 38 18.970703 38.448 18.970703 39 L 18.970703 41 C 18.970703 41.552 18.522703 42 17.970703 42 L 11.970703 42 C 11.417703 42 10.970703 41.552 10.970703 41 L 10.970703 39 C 10.970703 38.448 11.418703 38 11.970703 38 z M 21.970703 38 L 27.970703 38 C 28.522703 38 28.970703 38.448 28.970703 39 L 28.970703 41 C 28.970703 41.552 28.522703 42 27.970703 42 L 21.970703 42 C 21.418703 42 20.970703 41.552 20.970703 41 L 20.970703 39 C 20.970703 38.448 21.418703 38 21.970703 38 z M 31.970703 38 L 37.970703 38 C 38.522703 38 38.970703 38.448 38.970703 39 L 38.970703 41 C 38.970703 41.552 38.522703 42 37.970703 42 L 31.970703 42 C 31.418703 42 30.970703 41.552 30.970703 41 L 30.970703 39 C 30.970703 38.448 31.418703 38 31.970703 38 z' }))); }
    },
    {
        id: 10,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22.5 12 C 22.007813 12 21.589844 12.207031 21.167969 12.390625 C 21.011719 12.386719 20.855469 12.425781 20.714844 12.496094 L 8.980469 18.347656 C 8.8125 18.429688 8.671875 18.558594 8.578125 18.71875 C 7.671875 19.351563 7 20.3125 7 21.5 C 7 23.421875 8.578125 25 10.5 25 C 10.917969 25 11.269531 24.847656 11.628906 24.714844 C 11.785156 24.71875 11.941406 24.6875 12.082031 24.621094 L 21.203125 20.328125 L 23.414063 23.917969 L 7.582031 33.558594 C 3.734375 32.164063 1.679688 30.265625 1.679688 30.265625 C 1.480469 30.078125 1.21875 29.980469 0.945313 29.992188 C 0.539063 30.007813 0.183594 30.269531 0.046875 30.652344 C -0.0898438 31.035156 0.0195313 31.464844 0.320313 31.734375 C 0.320313 31.734375 2.789063 33.96875 7.242188 35.527344 C 7.335938 35.578125 7.4375 35.613281 7.542969 35.628906 C 9.867188 36.410156 12.695313 37 16 37 C 20.921875 37 24.386719 35.953125 27.371094 34.949219 C 30.351563 33.941406 32.8125 33 36 33 C 42.371094 33 48.457031 36.84375 48.457031 36.84375 C 48.925781 37.140625 49.542969 37.007813 49.84375 36.542969 C 50.140625 36.074219 50.007813 35.457031 49.542969 35.15625 C 49.542969 35.15625 43.160156 31 36 31 C 35.617188 31 35.246094 31.019531 34.878906 31.042969 C 34.949219 30.703125 35 30.355469 35 30 C 35 29.214844 34.699219 28.53125 34.378906 27.878906 C 34.382813 27.683594 34.328125 27.488281 34.222656 27.324219 L 25.421875 13.574219 C 25.417969 13.570313 25.414063 13.5625 25.410156 13.558594 C 24.785156 12.621094 23.707031 12 22.5 12 Z M 22.5 14 C 23.027344 14 23.476563 14.265625 23.746094 14.667969 L 32.1875 27.847656 L 32.542969 27.3125 C 32.324219 27.644531 32.316406 28.070313 32.53125 28.40625 C 32.828125 28.875 33 29.414063 33 30 C 33 30.476563 32.886719 30.917969 32.691406 31.3125 C 30.585938 31.699219 28.695313 32.386719 26.730469 33.050781 C 23.792969 34.046875 20.644531 35 16 35 C 13.820313 35 11.878906 34.730469 10.171875 34.324219 L 25.3125 25.105469 C 25.539063 24.964844 25.703125 24.742188 25.765625 24.484375 C 25.824219 24.222656 25.78125 23.949219 25.640625 23.722656 L 22.4375 18.515625 C 22.167969 18.085938 21.617188 17.921875 21.15625 18.136719 L 12.113281 22.394531 L 12.546875 23.261719 C 12.425781 23.019531 12.214844 22.839844 11.957031 22.753906 C 11.703125 22.671875 11.425781 22.695313 11.1875 22.820313 C 10.964844 22.9375 10.738281 23 10.5 23 C 9.65625 23 9 22.34375 9 21.5 C 9 20.894531 9.351563 20.394531 9.859375 20.152344 C 9.902344 20.132813 9.9375 20.109375 9.976563 20.085938 L 21.292969 14.441406 L 20.953125 14.363281 C 21.210938 14.421875 21.480469 14.375 21.703125 14.234375 C 21.945313 14.082031 22.207031 14 22.5 14 Z M 39.5 18 C 36.472656 18 34 20.472656 34 23.5 C 34 26.527344 36.472656 29 39.5 29 C 42.523438 29 45 26.527344 45 23.5 C 45 20.472656 42.523438 18 39.5 18 Z M 39.5 20 C 41.445313 20 43 21.554688 43 23.5 C 43 25.445313 41.445313 27 39.5 27 C 37.550781 27 36 25.449219 36 23.5 C 36 21.554688 37.554688 20 39.5 20 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22.5 13 C 22.011719 13 21.554688 13.148438 21.171875 13.390625 L 21.160156 13.390625 L 9.429688 19.242188 L 9.429688 19.25 C 8.585938 19.648438 8 20.503906 8 21.5 C 8 22.882813 9.117188 24 10.5 24 C 10.917969 24 11.304688 23.886719 11.652344 23.707031 L 11.65625 23.71875 L 21.582031 19.042969 L 24.792969 24.25 L 8.832031 33.96875 C 4.179688 32.574219 1.679688 30.265625 1.679688 30.265625 C 1.480469 30.078125 1.21875 29.980469 0.945313 29.992188 C 0.539063 30.007813 0.183594 30.269531 0.046875 30.652344 C -0.0898438 31.035156 0.0195313 31.464844 0.320313 31.734375 C 0.320313 31.734375 6.085938 37 16 37 C 20.921875 37 24.386719 35.953125 27.371094 34.949219 C 30.351563 33.941406 32.8125 33 36 33 C 42.371094 33 48.457031 36.84375 48.457031 36.84375 C 48.925781 37.140625 49.542969 37.007813 49.84375 36.542969 C 50.140625 36.074219 50.007813 35.457031 49.542969 35.15625 C 49.542969 35.15625 43.160156 31 36 31 C 35.242188 31 34.527344 31.054688 33.832031 31.140625 C 33.941406 30.777344 34 30.394531 34 30 C 34 29.214844 33.765625 28.484375 33.375 27.871094 L 33.378906 27.859375 L 24.578125 14.113281 C 24.128906 13.441406 23.367188 13 22.5 13 Z M 40 18 C 37.238281 18 35 20.238281 35 23 C 35 25.761719 37.238281 28 40 28 C 42.761719 28 45 25.761719 45 23 C 45 20.238281 42.761719 18 40 18 Z' }))); }
    },
    {
        id: 4,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 2 C 9.25 2 7 4.25 7 7 C 7 9.75 9.25 12 12 12 C 14.75 12 17 9.75 17 7 C 17 4.25 14.75 2 12 2 Z M 29 2 L 29 4 L 19 4 L 19 6 L 46 6 L 46 32 L 20 32 L 20 34 L 28.5 34 L 23 45 L 25 45 L 30 35 L 35 45 L 37 45 L 31.5 34 L 47 34 C 47.550781 34 48 33.550781 48 33 L 48 5 C 48 4.449219 47.550781 4 47 4 L 31 4 L 31 2 Z M 12 4 C 13.667969 4 15 5.332031 15 7 C 15 8.667969 13.667969 10 12 10 C 10.332031 10 9 8.667969 9 7 C 9 5.332031 10.332031 4 12 4 Z M 7.5 13 C 4.472656 13 2 15.472656 2 18.5 L 2 30.8125 C 1.996094 30.855469 1.996094 30.894531 2 30.9375 L 2 31 C 1.996094 31.09375 2.007813 31.191406 2.03125 31.28125 C 2.179688 32.792969 3.453125 34 5 34 C 5.351563 34 5.683594 33.925781 6 33.8125 L 6 44.5 C 6 46.421875 7.578125 48 9.5 48 C 10.476563 48 11.363281 47.589844 12 46.9375 C 12.636719 47.589844 13.523438 48 14.5 48 C 16.421875 48 18 46.421875 18 44.5 L 18 19 L 29 19 C 30.644531 19 32 17.644531 32 16 C 32 14.375 30.679688 13.035156 29.0625 13 C 29.042969 13 29.019531 13 29 13 L 15 13 C 14.613281 12.996094 14.261719 13.214844 14.09375 13.5625 L 12 17.75 L 9.90625 13.5625 C 9.738281 13.214844 9.386719 12.996094 9 13 Z M 7.5 15 L 8.375 15 L 11.09375 20.4375 C 11.257813 20.789063 11.613281 21.015625 12 21.015625 C 12.386719 21.015625 12.742188 20.789063 12.90625 20.4375 L 15.625 15 L 29 15 C 29.03125 15 29.0625 15 29.09375 15 C 29.613281 15.046875 30 15.46875 30 16 C 30 16.566406 29.566406 17 29 17 L 17 17 C 16.449219 17 16 17.449219 16 18 L 16 44.5 C 16 45.339844 15.339844 46 14.5 46 C 13.710938 46 13.074219 45.421875 13 44.65625 L 13 44.40625 C 13 44.375 13 44.34375 13 44.3125 L 13 34 C 13.011719 33.710938 12.894531 33.433594 12.6875 33.238281 C 12.476563 33.039063 12.191406 32.941406 11.90625 32.96875 C 11.863281 32.976563 11.820313 32.988281 11.78125 33 C 11.316406 33.105469 10.988281 33.523438 11 34 L 11 44.3125 C 10.996094 44.355469 10.996094 44.394531 11 44.4375 L 11 44.65625 C 10.925781 45.421875 10.289063 46 9.5 46 C 8.660156 46 8 45.339844 8 44.5 L 8 21 C 8.007813 20.691406 7.871094 20.398438 7.632813 20.203125 C 7.398438 20.007813 7.082031 19.933594 6.78125 20 C 6.316406 20.105469 5.988281 20.523438 6 21 L 6 30.84375 C 6 30.875 6 30.90625 6 30.9375 L 6 31 C 6 31.566406 5.566406 32 5 32 C 4.457031 32 4.03125 31.597656 4 31.0625 C 4 31.042969 4 31.019531 4 31 C 4.007813 30.9375 4.007813 30.875 4 30.8125 L 4 18.5 C 4 16.554688 5.554688 15 7.5 15 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 2 C 9.242188 2 7 4.242188 7 7 C 7 9.757813 9.242188 12 12 12 C 14.757813 12 17 9.757813 17 7 C 17 4.242188 14.757813 2 12 2 Z M 29 2 L 29 4 L 18.3125 4 C 18.746094 4.910156 19 5.925781 19 7 C 19 8.488281 18.542969 9.863281 17.75 11 L 28.5 11 C 30.980469 11 33 13.019531 33 15.5 C 33 17.980469 30.980469 20 28.5 20 L 20 20 L 20 34 L 47 34 C 47.554688 34 48 33.554688 48 33 L 48 5 C 48 4.449219 47.554688 4 47 4 L 31 4 L 31 2 Z M 7.5 13 C 4.46875 13 2 15.46875 2 18.5 L 2 32 C 2 33.105469 2.898438 34 4 34 C 5.101563 34 6 33.105469 6 32 L 6 20.5625 C 6 20.292969 6.230469 20.0625 6.5 20.0625 C 6.769531 20.0625 7 20.292969 7 20.5625 L 7 45.3125 C 7 46.875 7.839844 48 9.40625 48 C 10.886719 48 12 46.851563 12 45.3125 L 12 33.6875 C 12 33.410156 12.222656 33.1875 12.5 33.1875 C 12.777344 33.1875 13 33.410156 13 33.6875 L 13 45.59375 C 13.003906 45.601563 13.027344 45.585938 13.03125 45.59375 C 13.167969 46.976563 14.210938 48 15.59375 48 C 17.15625 48 18 46.875 18 45.3125 L 18 18 L 28.5 18 C 29.882813 18 31 16.882813 31 15.5 C 31 14.117188 29.882813 13 28.5 13 L 15.53125 13 L 12 20 L 8.53125 13 Z M 27.5 36 L 23 45 L 25 45 L 29.5 36 Z M 30.5 36 L 35 45 L 37 45 L 32.5 36 Z' }))); }
    },
    {
        id: 11,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22 12 C 20.34375 12 19 13.375 19 15.03125 L 19 16.3125 C 18.496094 16.375 18.039063 16.433594 17.65625 16.5 C 16.269531 16.746094 15.667969 17.03125 15.59375 17.0625 C 15.589844 17.066406 15.46875 17.09375 15.46875 17.09375 C 13.988281 17.59375 11.734375 18.28125 10.6875 20.3125 L 10.6875 20.34375 C 10.433594 20.835938 10.054688 21.804688 9.5 23.21875 C 9.074219 24.304688 8.574219 25.675781 8.0625 27 L 5.09375 27 C 3.609375 27 2.507813 27.496094 1.84375 28.25 C 1.179688 29.003906 1 29.898438 1 30.59375 C 1 31.371094 1.40625 32.148438 2.03125 32.53125 C 2.65625 32.914063 3.355469 33 4.09375 33 L 5.75 33 C 5.59375 33.417969 5.0625 34.8125 5.0625 34.8125 L 5 35 L 5 47 C 5 48.644531 6.355469 50 8 50 L 12 50 C 13.644531 50 15 48.644531 15 47 L 15 46 L 35 46 L 35 47 C 35 48.644531 36.355469 50 38 50 L 42 50 C 43.644531 50 45 48.644531 45 47 L 45 35 L 44.9375 34.8125 C 44.9375 34.8125 44.414063 33.421875 44.25 33 L 45.90625 33 C 46.644531 33 47.34375 32.914063 47.96875 32.53125 C 48.59375 32.148438 49 31.371094 49 30.59375 C 49 29.898438 48.820313 29.003906 48.15625 28.25 C 47.492188 27.496094 46.390625 27 44.90625 27 L 41.9375 27 C 41.875 26.851563 41.8125 26.707031 41.78125 26.625 C 40.699219 23.828125 39.652344 21.164063 39.28125 20.3125 C 38.324219 18.140625 35.863281 17.46875 34.53125 17.09375 C 34.488281 17.082031 34.414063 17.042969 34.375 17.03125 L 34.375 17.0625 C 34.28125 17.023438 33.710938 16.746094 32.34375 16.5 C 31.960938 16.433594 31.503906 16.375 31 16.3125 L 31 15.03125 C 31 13.375 29.65625 12 28 12 Z M 22 14 L 28 14 C 28.550781 14 29 14.4375 29 15.03125 L 29 16.125 C 27.871094 16.050781 26.578125 16 25 16 C 23.421875 16 22.128906 16.050781 21 16.125 L 21 15.03125 C 21 14.4375 21.449219 14 22 14 Z M 25 18 C 28.453125 18 30.671875 18.261719 32 18.5 C 33.328125 18.738281 33.65625 18.90625 33.65625 18.90625 L 33.75 18.9375 L 33.8125 18.96875 C 35.03125 19.316406 36.996094 20.117188 37.4375 21.125 C 37.726563 21.785156 38.863281 24.707031 39.90625 27.375 C 40.15625 28.011719 40.574219 29.050781 40.4375 29.6875 C 40.367188 30.007813 40.246094 30.238281 39.78125 30.5 C 39.316406 30.761719 38.441406 31 37 31 L 13 31 C 11.558594 31 10.683594 30.761719 10.21875 30.5 C 9.753906 30.238281 9.632813 30.007813 9.5625 29.6875 C 9.425781 29.050781 9.84375 28.011719 10.09375 27.375 L 10.03125 27.34375 C 10.488281 26.152344 10.957031 24.917969 11.34375 23.9375 C 11.894531 22.535156 12.386719 21.410156 12.46875 21.25 C 13.023438 20.171875 14.753906 19.4375 16.21875 18.9375 L 16.28125 18.9375 L 16.34375 18.90625 C 16.34375 18.90625 16.671875 18.738281 18 18.5 C 19.328125 18.261719 21.546875 18 25 18 Z M 5.09375 29 L 7.25 29 C 6.871094 29.996094 6.804688 30.191406 6.5 31 L 4.09375 31 C 3.535156 31 3.1875 30.902344 3.09375 30.84375 C 3 30.785156 3 30.875 3 30.59375 C 3 30.230469 3.101563 29.835938 3.34375 29.5625 C 3.585938 29.289063 4.007813 29 5.09375 29 Z M 42.6875 29 L 44.90625 29 C 45.992188 29 46.414063 29.289063 46.65625 29.5625 C 46.898438 29.835938 47 30.230469 47 30.59375 C 47 30.875 47 30.785156 46.90625 30.84375 C 46.8125 30.902344 46.460938 31 45.90625 31 L 43.46875 31 C 43.148438 30.179688 43.078125 30.011719 42.6875 29 Z M 8.4375 31.59375 C 8.667969 31.835938 8.933594 32.070313 9.25 32.25 C 10.152344 32.757813 11.347656 33 13 33 L 37 33 C 38.652344 33 39.847656 32.757813 40.75 32.25 C 41.066406 32.070313 41.332031 31.835938 41.5625 31.59375 C 42.148438 33.132813 42.964844 35.289063 43 35.375 L 43 43.15625 C 43 43.621094 42.609375 44 42.09375 44 L 7.90625 44 C 7.390625 44 7 43.625 7 43.15625 L 7 35.375 C 7.03125 35.289063 7.867188 33.117188 8.4375 31.59375 Z M 11 34 C 9.355469 34 8 35.355469 8 37 C 8 37.886719 8.367188 38.675781 8.875 39.21875 C 9.382813 39.761719 9.996094 40.128906 10.59375 40.46875 C 11.441406 40.949219 12.019531 41.316406 12.6875 41.59375 C 13.355469 41.871094 14.074219 42 15 42 C 17.195313 42 19 40.199219 19 38 C 19 35.800781 17.195313 34 15 34 Z M 35 34 C 32.804688 34 31 35.800781 31 38 C 31 40.199219 32.804688 42 35 42 C 35.925781 42 36.644531 41.871094 37.3125 41.59375 C 37.980469 41.316406 38.558594 40.949219 39.40625 40.46875 C 40.003906 40.128906 40.617188 39.761719 41.125 39.21875 C 41.632813 38.675781 42 37.886719 42 37 C 42 35.355469 40.644531 34 39 34 Z M 11 36 L 15 36 C 16.117188 36 17 36.882813 17 38 C 17 39.117188 16.117188 40 15 40 C 14.25 40 13.878906 39.933594 13.4375 39.75 C 12.996094 39.566406 12.449219 39.21875 11.5625 38.71875 C 11 38.402344 10.585938 38.101563 10.34375 37.84375 C 10.101563 37.585938 10 37.417969 10 37 C 10 36.4375 10.4375 36 11 36 Z M 35 36 L 39 36 C 39.5625 36 40 36.4375 40 37 C 40 37.417969 39.898438 37.585938 39.65625 37.84375 C 39.414063 38.101563 39 38.402344 38.4375 38.71875 C 37.550781 39.21875 37.003906 39.566406 36.5625 39.75 C 36.121094 39.933594 35.75 40 35 40 C 33.882813 40 33 39.117188 33 38 C 33 36.882813 33.882813 36 35 36 Z M 7 45.84375 C 7.289063 45.9375 7.589844 46 7.90625 46 L 13 46 L 13 47 C 13 47.5625 12.5625 48 12 48 L 8 48 C 7.4375 48 7 47.5625 7 47 Z M 43 45.84375 L 43 47 C 43 47.5625 42.5625 48 42 48 L 38 48 C 37.4375 48 37 47.5625 37 47 L 37 46 L 42.09375 46 C 42.410156 46 42.710938 45.9375 43 45.84375 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22 12 C 20.347656 12 19 13.355469 19 15.03125 L 19 16.3125 C 16.8125 16.582031 15.808594 16.941406 15.53125 17.0625 C 13.980469 17.589844 11.683594 18.378906 10.6875 20.3125 C 10.011719 21.628906 5.566406 33.46875 5.0625 34.8125 L 5 35 L 5 47 C 5 48.652344 6.347656 50 8 50 L 12 50 C 13.652344 50 15 48.652344 15 47 L 15 46 L 35 46 L 35 47 C 35 48.652344 36.347656 50 38 50 L 42 50 C 43.652344 50 45 48.652344 45 47 L 45 35 L 44.9375 34.8125 C 44.832031 34.53125 43.410156 30.816406 42 27.1875 C 41.984375 27.15625 41.980469 27.125 41.96875 27.09375 C 40.796875 24.078125 39.648438 21.152344 39.28125 20.3125 C 38.441406 18.410156 36.128906 17.546875 34.4375 17.0625 C 34.128906 16.933594 33.109375 16.574219 31 16.3125 L 31 15.03125 C 31 13.355469 29.652344 12 28 12 Z M 25 18 C 31.550781 18 33.648438 18.902344 33.65625 18.90625 L 33.8125 18.96875 C 34.566406 19.183594 36.871094 19.835938 37.4375 21.125 C 37.773438 21.886719 38.808594 24.546875 39.90625 27.375 L 40 27.5625 C 40.015625 27.601563 40.011719 27.640625 40.03125 27.6875 C 40.058594 27.757813 40.097656 27.835938 40.125 27.90625 C 40.371094 28.550781 40.640625 29.511719 40.25 30.09375 C 39.847656 30.6875 38.703125 31 37 31 L 13 31 C 11.296875 31 10.085938 30.597656 9.6875 30 C 9.21875 29.304688 9.726563 28.0625 9.96875 27.46875 L 10.0625 27.28125 C 11.222656 24.253906 12.21875 21.734375 12.46875 21.25 C 13.105469 20.015625 14.972656 19.359375 16.21875 18.9375 L 16.3125 18.90625 C 16.332031 18.898438 18.449219 18 25 18 Z M 5.09375 27 C 2.070313 27 1 28.859375 1 30.59375 C 1 31.4375 1.378906 32.796875 3.625 32.96875 C 4.253906 31.300781 5.0625 29.128906 5.875 27 Z M 44.0625 27 C 44.96875 29.339844 45.863281 31.640625 46.375 32.96875 C 48.628906 32.800781 49 31.441406 49 30.59375 C 49 28.859375 47.929688 27 44.90625 27 Z M 11 35 L 15 35 C 16.65625 35 18 36.34375 18 38 C 18 39.65625 16.65625 41 15 41 C 13.324219 41 12.828125 40.574219 11.09375 39.59375 C 9.933594 38.9375 9 38.308594 9 37 C 9 35.894531 9.894531 35 11 35 Z M 35 35 L 39 35 C 40.105469 35 41 35.894531 41 37 C 41 38.308594 40.066406 38.9375 38.90625 39.59375 C 37.175781 40.574219 36.675781 41 35 41 C 33.34375 41 32 39.65625 32 38 C 32 36.34375 33.34375 35 35 35 Z' }))); }
    },
    {
        id: 7,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 3 8 A 1.0001 1.0001 0 0 0 2 9 L 2 38 L 1 38 A 1.0001 1.0001 0 0 0 0 39 L 0 41 C 0 42.45797 0.70876816 43.570962 1.5507812 44.183594 C 2.3927944 44.796225 3.2884028 45 4 45 L 46 45 C 47.080199 45 48.110329 44.821981 48.892578 44.117188 C 49.674828 43.412394 50 42.319379 50 41 L 50 39 A 1.0001 1.0001 0 0 0 49 38 L 48 38 L 48 9 A 1.0001 1.0001 0 0 0 47 8 L 3 8 z M 4 10 L 46 10 L 46 38 L 31.167969 38 A 1.0001 1.0001 0 0 0 30.283203 38.289062 A 1.0001 1.0001 0 0 0 30.277344 38.294922 A 1.0001 1.0001 0 0 0 30.263672 38.308594 A 1.0001 1.0001 0 0 0 29.986328 39 L 20.013672 39 A 1.0001 1.0001 0 0 0 19.707031 38.279297 A 1.0001 1.0001 0 0 0 19.705078 38.277344 A 1.0001 1.0001 0 0 0 19.699219 38.271484 A 1.0001 1.0001 0 0 0 19.691406 38.263672 A 1.0001 1.0001 0 0 0 18.984375 37.986328 A 1.0001 1.0001 0 0 0 18.839844 38 L 4 38 L 4 10 z M 27.408203 16.888672 C 26.708203 16.988672 25.908203 17.388281 25.408203 17.988281 C 24.908203 18.588281 24.608594 19.288281 24.808594 19.988281 C 25.608594 19.988281 26.308594 19.588281 26.808594 18.988281 C 27.208594 18.488281 27.508203 17.688672 27.408203 16.888672 z M 22.708984 19.988281 C 21.708984 19.988281 20.709766 20.589844 20.009766 21.589844 C 19.009766 23.089844 19.208984 25.889453 20.708984 28.189453 C 21.208984 29.089453 21.908203 29.988281 22.908203 29.988281 C 23.808203 30.088281 24.008984 29.488281 25.208984 29.488281 C 26.308984 29.388281 26.508203 29.988281 27.408203 29.988281 C 28.308203 29.988281 29.108984 28.889844 29.708984 28.089844 C 30.008984 27.489844 30.209375 27.188281 30.609375 26.488281 C 28.409375 25.588281 28.008984 22.489062 30.208984 21.289062 C 29.508984 20.489063 28.608984 19.988281 27.708984 19.988281 C 26.508984 19.988281 26.008984 20.589844 25.208984 20.589844 C 24.408984 20.589844 23.708984 19.988281 22.708984 19.988281 z M 2 40 L 18 40 A 1.0001 1.0001 0 0 0 19 41 L 31 41 A 1.0001 1.0001 0 0 0 32 40 L 48 40 L 48 41 C 48 42.013621 47.789938 42.420856 47.554688 42.632812 C 47.319437 42.844769 46.849801 43 46 43 L 4 43 C 3.7515972 43 3.1465025 42.870525 2.7285156 42.566406 C 2.3105288 42.262288 2 41.87503 2 41 L 2 40 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 3 8 A 1.0001 1.0001 0 0 0 2 9 L 2 38 L 1 38 A 1.0001 1.0001 0 0 0 0 39 L 0 41 C 0 42.45797 0.70876816 43.570962 1.5507812 44.183594 C 2.3927944 44.796225 3.2884028 45 4 45 L 46 45 C 47.080199 45 48.110329 44.821981 48.892578 44.117188 C 49.674828 43.412394 50 42.319379 50 41 L 50 39 A 1.0001 1.0001 0 0 0 49 38 L 48 38 L 48 9 A 1.0001 1.0001 0 0 0 47 8 L 3 8 z M 27.408203 18 C 27.508203 18.8 27.208594 19.599609 26.808594 20.099609 C 26.308594 20.699609 25.608594 21.099609 24.808594 21.099609 C 24.608594 20.399609 24.908203 19.699609 25.408203 19.099609 C 25.908203 18.499609 26.708203 18.1 27.408203 18 z M 22.708984 21.099609 C 23.708984 21.099609 24.408984 21.699219 25.208984 21.699219 C 26.008984 21.699219 26.508984 21.099609 27.708984 21.099609 C 28.608984 21.099609 29.508984 21.600391 30.208984 22.400391 C 28.008984 23.600391 28.409375 26.699609 30.609375 27.599609 C 30.209375 28.299609 30.008984 28.599219 29.708984 29.199219 C 29.108984 29.999219 28.308203 31.099609 27.408203 31.099609 C 26.508203 31.099609 26.308984 30.499609 25.208984 30.599609 C 24.008984 30.599609 23.808203 31.199609 22.908203 31.099609 C 21.908203 31.099609 21.208984 30.200781 20.708984 29.300781 C 19.208984 27.000781 19.009766 24.199219 20.009766 22.699219 C 20.709766 21.699219 21.708984 21.099609 22.708984 21.099609 z M 2 40 L 18 40 A 1.0001 1.0001 0 0 0 19 41 L 31 41 A 1.0001 1.0001 0 0 0 32 40 L 47 40 L 48 40 L 48 41 C 48 42.013621 47.789938 42.420856 47.554688 42.632812 C 47.319437 42.844769 46.849801 43 46 43 L 4 43 C 3.7515972 43 3.1465025 42.870525 2.7285156 42.566406 C 2.3105288 42.262288 2 41.87503 2 41 L 2 40 z' }))); }
    },
    {
        id: 6,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 6 4 L 6 39 L 7 39 C 16.734375 39 24.550781 42.894531 24.550781 42.894531 L 25 43.117188 L 25.449219 42.894531 C 25.449219 42.894531 33.265625 39 43 39 L 44 39 L 44 4 L 43 4 C 33.160156 4 25.640625 7.621094 25 7.9375 C 24.359375 7.621094 16.839844 4 7 4 Z M 8 6.089844 C 16.246094 6.324219 22.652344 9.046875 24 9.65625 L 24 40.503906 C 21.871094 39.585938 15.886719 37.300781 8 37.089844 Z M 42 6.089844 L 42 37.089844 C 34.113281 37.300781 28.128906 39.585938 26 40.503906 L 26 9.65625 C 27.347656 9.046875 33.753906 6.324219 42 6.089844 Z M 2 9 L 2 43 L 3 43 C 15.792969 43 24.59375 46.914063 24.59375 46.914063 L 25 47.09375 L 25.40625 46.914063 C 25.40625 46.914063 34.207031 43 47 43 L 48 43 L 48 9 L 46 9 L 46 41.070313 C 33.800781 41.277344 25.558594 44.710938 25 44.953125 C 24.441406 44.710938 16.199219 41.277344 4 41.070313 L 4 9 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 6 4 L 6 8 L 2 8 L 2 43 L 3 43 C 15.613281 43 24.507813 46.875 24.59375 46.914063 L 25 47.09375 L 25.40625 46.914063 C 25.492188 46.875 34.386719 43 47 43 L 48 43 L 48 8 L 44 8 L 44 4 L 43 4 C 33.160156 4 25.640625 7.621094 25 7.9375 C 24.359375 7.621094 16.839844 4 7 4 Z M 8 6.089844 C 16.246094 6.324219 22.652344 9.046875 24 9.65625 L 24 40.503906 C 21.871094 39.585938 15.886719 37.300781 8 37.089844 Z M 42 6.089844 L 42 37.089844 C 34.113281 37.300781 28.128906 39.585938 26 40.503906 L 26 9.65625 C 27.347656 9.046875 33.753906 6.324219 42 6.089844 Z' }))); }
    },
    {
        id: 9,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 46.40625 0.1875 C 46.085938 0.210938 45.757813 0.277344 45.4375 0.34375 C 44.15625 0.617188 42.78125 1.210938 41.4375 1.90625 C 38.765625 3.289063 36.34375 5.039063 35.3125 6.125 L 35.28125 6.125 L 28.53125 12.84375 L 4.53125 9.59375 C 4.214844 9.558594 3.902344 9.675781 3.6875 9.90625 L 0.28125 13.40625 C 0.0507813 13.644531 -0.0507813 13.984375 0.0195313 14.308594 C 0.0898438 14.636719 0.316406 14.90625 0.625 15.03125 L 19.125 22.28125 L 9.59375 32 L 5 32 C 4.757813 32 4.523438 32.089844 4.34375 32.25 L 0.34375 35.625 C 0.046875 35.867188 -0.0859375 36.253906 0 36.625 C 0.0859375 37 0.378906 37.289063 0.75 37.375 L 10.28125 39.71875 L 12.625 49.25 C 12.710938 49.585938 12.96875 49.851563 13.296875 49.953125 C 13.628906 50.054688 13.988281 49.976563 14.25 49.75 L 17.65625 46.75 C 17.875 46.5625 18 46.289063 18 46 L 18 40.40625 L 27.8125 30.875 L 34.96875 49.375 C 35.09375 49.683594 35.363281 49.910156 35.691406 49.980469 C 36.015625 50.050781 36.355469 49.949219 36.59375 49.71875 L 40.09375 46.3125 C 40.324219 46.097656 40.441406 45.785156 40.40625 45.46875 L 37.15625 21.46875 L 43.90625 14.71875 C 44.945313 13.679688 46.707031 11.203125 48.09375 8.53125 C 48.789063 7.195313 49.382813 5.835938 49.65625 4.5625 C 49.929688 3.289063 49.933594 1.945313 49.03125 1 C 49.019531 0.988281 49.011719 0.980469 49 0.96875 C 48.527344 0.515625 47.957031 0.296875 47.34375 0.21875 C 47.039063 0.179688 46.726563 0.164063 46.40625 0.1875 Z M 46.5 2.21875 C 47.070313 2.179688 47.402344 2.296875 47.5625 2.4375 C 47.753906 2.652344 47.894531 3.191406 47.6875 4.15625 C 47.476563 5.136719 46.957031 6.386719 46.3125 7.625 C 45.023438 10.105469 43.164063 12.617188 42.5 13.28125 L 35.40625 20.40625 C 35.183594 20.613281 35.070313 20.914063 35.09375 21.21875 L 38.34375 45.25 L 36.3125 47.21875 L 29.125 28.75 C 29.007813 28.4375 28.738281 28.203125 28.414063 28.125 C 28.085938 28.050781 27.742188 28.144531 27.5 28.375 L 16.3125 39.28125 C 16.113281 39.46875 16.003906 39.726563 16 40 L 16 45.5625 L 14.15625 47.15625 L 12.0625 38.65625 C 11.972656 38.304688 11.695313 38.027344 11.34375 37.9375 L 3.125 35.90625 L 5.375 34 L 10 34 C 10.273438 33.996094 10.53125 33.886719 10.71875 33.6875 L 21.625 22.59375 C 21.855469 22.351563 21.949219 22.007813 21.875 21.679688 C 21.796875 21.355469 21.5625 21.085938 21.25 20.96875 L 2.78125 13.71875 L 4.75 11.65625 L 28.78125 14.90625 C 29.085938 14.929688 29.386719 14.816406 29.59375 14.59375 L 36.71875 7.5 C 37.296875 6.886719 39.851563 4.976563 42.34375 3.6875 C 43.589844 3.042969 44.855469 2.523438 45.84375 2.3125 C 46.085938 2.261719 46.308594 2.230469 46.5 2.21875 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 46.78125 0.1875 C 43.019531 0.1875 36.601563 4.6875 35.28125 6.09375 L 28.53125 12.84375 L 4.53125 9.59375 C 4.21875 9.550781 3.910156 9.679688 3.6875 9.90625 L 0.28125 13.40625 C 0.046875 13.644531 -0.0390625 13.984375 0.03125 14.3125 C 0.101563 14.640625 0.3125 14.910156 0.625 15.03125 L 19.125 22.28125 L 9.59375 32 L 5 32 C 4.761719 32 4.523438 32.09375 4.34375 32.25 L 0.34375 35.625 C 0.0585938 35.867188 -0.0546875 36.261719 0.03125 36.625 C 0.117188 36.988281 0.386719 37.285156 0.75 37.375 L 10.28125 39.71875 L 12.625 49.25 C 12.710938 49.589844 12.976563 49.863281 13.3125 49.96875 C 13.644531 50.074219 13.988281 49.980469 14.25 49.75 L 17.65625 46.75 C 17.871094 46.558594 18 46.285156 18 46 L 18 40.4375 L 27.8125 30.875 L 34.96875 49.375 C 35.089844 49.6875 35.359375 49.898438 35.6875 49.96875 C 35.757813 49.984375 35.835938 50 35.90625 50 C 36.164063 50 36.40625 49.902344 36.59375 49.71875 L 40.09375 46.3125 C 40.320313 46.089844 40.449219 45.78125 40.40625 45.46875 L 37.15625 21.46875 L 43.90625 14.71875 C 45.289063 13.335938 52.070313 4.175781 49 0.96875 C 48.457031 0.449219 47.707031 0.1875 46.78125 0.1875 Z' }))); }
    },
    {
        id: 13,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 33 0.0625 C 32.28125 0.0625 31.582031 0.367188 31.03125 0.90625 L 31 0.875 L 25.09375 6.71875 C 24.933594 6.816406 24.804688 6.957031 24.71875 7.125 L 0.78125 30.875 C 0.78125 30.886719 0.78125 30.894531 0.78125 30.90625 C -0.324219 32.011719 -0.324219 33.800781 0.78125 34.90625 L 3.90625 38 C 4.257813 38.355469 4.820313 38.394531 5.21875 38.09375 C 6.078125 37.40625 7.199219 36.90625 8.3125 36.90625 C 10.972656 36.90625 13 39.03125 13 41.59375 C 13 42.753906 12.578125 43.808594 11.84375 44.625 C 11.496094 45.027344 11.523438 45.632813 11.90625 46 L 15 49.09375 C 16.105469 50.199219 17.894531 50.199219 19 49.09375 L 42.6875 25.4375 C 43.078125 25.34375 43.375 25.023438 43.4375 24.625 L 49 19.09375 C 49.039063 19.066406 49.058594 19.03125 49.09375 19 C 50.296875 17.992188 50.292969 16.167969 49.21875 15.09375 L 46.09375 12 C 45.742188 11.644531 45.179688 11.605469 44.78125 11.90625 C 43.925781 12.589844 42.972656 13 41.8125 13 C 39.152344 13 37.09375 10.875 37.09375 8.3125 C 37.09375 7.152344 37.503906 6.167969 38.1875 5.3125 C 38.488281 4.914063 38.449219 4.351563 38.09375 4 L 35 0.90625 C 34.449219 0.355469 33.726563 0.0625 33 0.0625 Z M 33 2.09375 C 33.222656 2.09375 33.445313 2.164063 33.59375 2.3125 L 36.15625 4.875 C 35.546875 5.875 35.09375 7.019531 35.09375 8.3125 C 35.09375 11.949219 38.070313 15 41.8125 15 C 43.109375 15 44.21875 14.546875 45.21875 13.9375 L 47.78125 16.5 C 48.078125 16.796875 48.101563 17.285156 47.8125 17.5 C 47.769531 17.527344 47.726563 17.558594 47.6875 17.59375 L 42.34375 22.9375 C 42.140625 22.753906 41.867188 22.664063 41.59375 22.6875 C 41.21875 22.722656 40.898438 22.964844 40.757813 23.316406 C 40.621094 23.664063 40.6875 24.0625 40.9375 24.34375 L 17.59375 47.6875 C 17.296875 47.984375 16.703125 47.984375 16.40625 47.6875 L 13.84375 45.125 C 14.523438 44.078125 15 42.890625 15 41.59375 C 15 37.957031 12.054688 34.90625 8.3125 34.90625 C 6.972656 34.90625 5.796875 35.421875 4.78125 36.0625 L 2.21875 33.5 C 1.921875 33.203125 1.921875 32.609375 2.21875 32.3125 L 25.625 9.03125 C 26.011719 9.429688 26.648438 9.433594 27.046875 9.046875 C 27.445313 8.660156 27.449219 8.023438 27.0625 7.625 L 32.40625 2.3125 C 32.554688 2.164063 32.777344 2.09375 33 2.09375 Z M 28.96875 10.125 L 28.21875 10.625 L 28.1875 11.53125 L 28.40625 11.8125 L 29.78125 13.21875 L 30.65625 13.5 L 31.375 12.96875 L 31.40625 12.09375 L 31.21875 11.78125 L 29.8125 10.40625 Z M 33.15625 14.3125 L 32.4375 14.84375 L 32.40625 15.71875 L 32.59375 16.03125 L 34 17.4375 L 34.84375 17.71875 L 35.59375 17.1875 L 35.625 16.3125 L 35.4375 16 L 34.03125 14.59375 Z M 37.375 18.53125 L 36.65625 19.03125 L 36.625 19.9375 L 36.8125 20.21875 L 38.21875 21.625 L 39.0625 21.90625 L 39.8125 21.40625 L 39.84375 20.5 L 39.625 20.21875 L 38.21875 18.8125 Z M 27.40625 19 L 22.8125 23 L 17.3125 20.5 L 19.6875 26.09375 L 15.59375 30.59375 L 21.59375 30.09375 L 24.59375 35.40625 L 25.90625 29.5 L 31.8125 28.3125 L 26.59375 25.1875 Z M 24.8125 24 L 24.6875 24.90625 L 24.5 26.1875 L 25.59375 26.90625 L 26.40625 27.3125 L 25.5 27.5 L 24.1875 27.8125 L 24 28.90625 L 23.8125 29.8125 L 23.3125 29 L 22.6875 27.90625 L 21.40625 28 L 20.5 28.09375 L 21.09375 27.5 L 22 26.5 L 21.5 25.3125 L 21.1875 24.5 L 22 24.90625 L 23.1875 25.40625 L 24.1875 24.5 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 49.207031 15.09375 L 46.105469 11.992188 C 45.746094 11.632813 45.171875 11.601563 44.773438 11.917969 C 43.878906 12.636719 42.878906 13 41.800781 13 C 39.207031 13 37.101563 10.890625 37.101563 8.300781 C 37.101563 7.222656 37.464844 6.222656 38.179688 5.324219 C 38.5 4.925781 38.46875 4.351563 38.109375 3.992188 L 35.007813 0.894531 C 33.953125 -0.164063 32.046875 -0.160156 30.996094 0.890625 L 25.632813 6.21875 L 27.007813 7.59375 C 27.398438 7.984375 27.398438 8.617188 27.007813 9.007813 C 26.8125 9.203125 26.554688 9.300781 26.300781 9.300781 C 26.042969 9.300781 25.789063 9.203125 25.59375 9.007813 L 24.214844 7.628906 L 0.792969 30.894531 C 0.265625 31.421875 -0.0234375 32.132813 -0.0234375 32.898438 C -0.0234375 33.667969 0.265625 34.378906 0.792969 34.90625 L 3.894531 38.007813 C 4.253906 38.367188 4.824219 38.402344 5.226563 38.082031 C 6.175781 37.320313 7.269531 36.898438 8.300781 36.898438 C 10.890625 36.898438 13 39.007813 13 41.597656 C 13 42.734375 12.59375 43.8125 11.855469 44.628906 C 11.5 45.027344 11.515625 45.628906 11.894531 46.007813 L 14.992188 49.105469 C 15.519531 49.632813 16.234375 49.925781 17 49.925781 C 17.765625 49.925781 18.480469 49.632813 19.007813 49.105469 L 42.351563 25.761719 L 40.992188 24.40625 C 40.601563 24.015625 40.601563 23.382813 40.992188 22.992188 C 41.386719 22.601563 42.015625 22.601563 42.40625 22.992188 L 43.765625 24.347656 L 49.0625 19.050781 C 49.613281 18.609375 49.957031 17.953125 50.007813 17.234375 C 50.0625 16.4375 49.769531 15.65625 49.207031 15.09375 Z M 28.394531 10.394531 C 28.785156 10.003906 29.414063 10.003906 29.808594 10.394531 L 31.210938 11.796875 C 31.601563 12.1875 31.601563 12.820313 31.210938 13.210938 C 31.015625 13.40625 30.761719 13.503906 30.503906 13.503906 C 30.246094 13.503906 29.992188 13.40625 29.796875 13.210938 L 28.394531 11.808594 C 28.003906 11.417969 28.003906 10.785156 28.394531 10.394531 Z M 25.898438 29.5 L 24.601563 35.398438 L 21.601563 30.097656 L 15.601563 30.597656 L 19.699219 26.097656 L 17.300781 20.5 L 22.800781 23 L 27.402344 19 L 26.601563 25.199219 L 31.800781 28.300781 Z M 35.421875 17.421875 C 35.226563 17.617188 34.972656 17.714844 34.714844 17.714844 C 34.460938 17.714844 34.203125 17.617188 34.007813 17.421875 L 32.605469 16.019531 C 32.214844 15.628906 32.214844 14.992188 32.605469 14.605469 C 32.996094 14.214844 33.628906 14.214844 34.019531 14.605469 L 35.421875 16.007813 C 35.8125 16.398438 35.8125 17.03125 35.421875 17.421875 Z M 39.632813 21.632813 C 39.4375 21.828125 39.183594 21.925781 38.925781 21.925781 C 38.671875 21.925781 38.414063 21.828125 38.21875 21.632813 L 36.816406 20.230469 C 36.425781 19.839844 36.425781 19.207031 36.816406 18.816406 C 37.207031 18.425781 37.839844 18.425781 38.230469 18.816406 L 39.632813 20.21875 C 40.023438 20.609375 40.023438 21.242188 39.632813 21.632813 Z' }))); }
    },
    {
        id: 15,
        icon: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 8 20 C 4.699219 20 2 22.699219 2 26 C 2 29.300781 4.699219 32 8 32 C 11.300781 32 14 29.300781 14 26 C 14 22.699219 11.300781 20 8 20 Z M 25 20 C 21.699219 20 19 22.699219 19 26 C 19 29.300781 21.699219 32 25 32 C 28.300781 32 31 29.300781 31 26 C 31 22.699219 28.300781 20 25 20 Z M 42 20 C 38.699219 20 36 22.699219 36 26 C 36 29.300781 38.699219 32 42 32 C 45.300781 32 48 29.300781 48 26 C 48 22.699219 45.300781 20 42 20 Z M 8 22 C 10.222656 22 12 23.777344 12 26 C 12 28.222656 10.222656 30 8 30 C 5.777344 30 4 28.222656 4 26 C 4 23.777344 5.777344 22 8 22 Z M 25 22 C 27.222656 22 29 23.777344 29 26 C 29 28.222656 27.222656 30 25 30 C 22.777344 30 21 28.222656 21 26 C 21 23.777344 22.777344 22 25 22 Z M 42 22 C 44.222656 22 46 23.777344 46 26 C 46 28.222656 44.222656 30 42 30 C 39.777344 30 38 28.222656 38 26 C 38 23.777344 39.777344 22 42 22 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: '#555555', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z' }))); }
    }
];


//# sourceMappingURL=iconLibs.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelect/index.js
'use client';






var StyledMultiTagSelect = styled_components_browser_esm/* default.div */.ZP.div(MultiTagSelect_templateObject_1 || (MultiTagSelect_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .tags-container {\n        display: grid;\n        grid-template-columns: repeat(\n            ", ",\n            minmax(120px, 1fr)\n        );\n        column-gap: 8px;\n        row-gap: 8px;\n        position: relative;\n    }\n\n    .tag-item {\n        display: inline-flex;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n        color: #333333;\n        background: #fbfbfb;\n        border: 1px solid #dddddd;\n        border-radius: 2px;\n        padding: 8px;\n        cursor: pointer;\n        outline: none;\n        transition: box-shadow 0.3s, border-color 0.3s;\n\n        &:hover {\n            background: white;\n            border: 1px solid #ff7d55;\n        }\n\n        &:focus {\n            box-shadow: 0 0 0 0.2rem rgba(0, 185, 242, 0.5);\n            border-color: #005aff;\n            outline: none;\n        }\n\n        &.selected {\n            background: #f4fbfe;\n            border: 1px solid #005aff;\n            color: #005aff;\n\n            svg {\n                fill: #005aff;\n            }\n\n            &:hover {\n                background: white;\n                border: 1px solid #ff7d55;\n                color: #ff7d55;\n\n                svg {\n                    fill: #ff7d55;\n                }\n            }\n        }\n    }\n\n    .heading {\n        margin-bottom: 5px;\n        color: #555;\n    }\n\n    .title {\n        font-weight: 600;\n        text-transform: uppercase;\n    }\n\n    .actions-container {\n        display: inline-flex;\n    }\n\n    .status {\n        margin-left: 14px;\n    }\n\n    button.action-clear {\n        background: none;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n        margin-left: 14px;\n        color: #005aff;\n    }\n\n    .tag-name {\n        line-height: 1.5;\n    }\n\n    .multi-select-tag-cover {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 1;\n    }\n"], ["\n    .tags-container {\n        display: grid;\n        grid-template-columns: repeat(\n            ", ",\n            minmax(120px, 1fr)\n        );\n        column-gap: 8px;\n        row-gap: 8px;\n        position: relative;\n    }\n\n    .tag-item {\n        display: inline-flex;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n        color: #333333;\n        background: #fbfbfb;\n        border: 1px solid #dddddd;\n        border-radius: 2px;\n        padding: 8px;\n        cursor: pointer;\n        outline: none;\n        transition: box-shadow 0.3s, border-color 0.3s;\n\n        &:hover {\n            background: white;\n            border: 1px solid #ff7d55;\n        }\n\n        &:focus {\n            box-shadow: 0 0 0 0.2rem rgba(0, 185, 242, 0.5);\n            border-color: #005aff;\n            outline: none;\n        }\n\n        &.selected {\n            background: #f4fbfe;\n            border: 1px solid #005aff;\n            color: #005aff;\n\n            svg {\n                fill: #005aff;\n            }\n\n            &:hover {\n                background: white;\n                border: 1px solid #ff7d55;\n                color: #ff7d55;\n\n                svg {\n                    fill: #ff7d55;\n                }\n            }\n        }\n    }\n\n    .heading {\n        margin-bottom: 5px;\n        color: #555;\n    }\n\n    .title {\n        font-weight: 600;\n        text-transform: uppercase;\n    }\n\n    .actions-container {\n        display: inline-flex;\n    }\n\n    .status {\n        margin-left: 14px;\n    }\n\n    button.action-clear {\n        background: none;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n        margin-left: 14px;\n        color: #005aff;\n    }\n\n    .tag-name {\n        line-height: 1.5;\n    }\n\n    .multi-select-tag-cover {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 1;\n    }\n"])), function (props) { return (props.itemsPerRow > 0 ? props.itemsPerRow : 'auto-fit'); });
function MultiTagSelect(props) {
    var title = props.title, options = props.options, _a = props.selectionText, selectionText = _a === void 0 ? 'option selected' : _a, _b = props.clearText, clearText = _b === void 0 ? 'Clear' : _b, _c = props.initValues, initValues = _c === void 0 ? [] : _c, _d = props.itemsPerRow, itemsPerRow = _d === void 0 ? 0 : _d, readonly = props.readonly, hideNumberOfSelectedOption = props.hideNumberOfSelectedOption; props.minSelect; props.maxSelect;
    var _g = (0,react.useState)(initValues), selections = _g[0], setSelections = _g[1];
    var handleSelectOption = function (id) {
        var selectionPos = selections.indexOf(id);
        /**
         * Deselect
         */
        if (selectionPos > -1) {
            var newSelections = selections.filter(function (value) { return value !== id; });
            setSelections(newSelections);
            props.onSelected && props.onSelected(newSelections);
        }
        else if (!props.maxSelect || (props.maxSelect > 0 && selections.length < props.maxSelect)) {
            /**
             * Allowed maximum of selection
             */
            var newSelections = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], selections, true), [id], false);
            setSelections(newSelections);
            props.onSelected && props.onSelected(newSelections);
        }
    };
    var handleEnter = function (e, id) {
        if (e.keyCode === 13) {
            e.preventDefault();
            handleSelectOption(id);
        }
    };
    (0,react.useEffect)(function () { return setSelections(initValues); }, [initValues]);
    var numberOfSelections = selections.length;
    return (react.createElement(StyledMultiTagSelect, { itemsPerRow: itemsPerRow },
        !readonly && (react.createElement("div", { className: 'heading' },
            react.createElement("span", { className: 'title' }, title),
            numberOfSelections > 0 && !hideNumberOfSelectedOption && (react.createElement("div", { className: 'actions-container' },
                react.createElement("span", { className: 'status' }, "".concat(numberOfSelections, " ").concat(selectionText)),
                react.createElement("button", { className: 'action-clear', onClick: function () {
                        setSelections([]);
                        props.onSelected && props.onSelected([]);
                    } }, clearText))))),
        react.createElement("div", { className: 'tags-container' },
            options.map(function (_a) {
                var id = _a.id, name = _a.name;
                var iconData = listBenefits.filter(function (value) { return value.id === id; })[0];
                var isSelected = selections.includes(id);
                return (react.createElement("div", { className: "tag-item ".concat(isSelected ? 'selected' : ''), onClick: function () { return handleSelectOption(id); }, key: id, tabIndex: 0, onKeyDown: function (e) { return handleEnter(e, id); } },
                    react.createElement("div", null, isSelected ? iconData.iconActive() : iconData.icon()),
                    react.createElement("div", { className: 'tag-name' }, name)));
            }),
            readonly && react.createElement("div", { className: 'multi-select-tag-cover' }))));
}
var MultiTagSelect_templateObject_1;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelectV2/MultiTagSelect.css.js
'use client';






var Container = styled_components_browser_esm/* default.div */.ZP.div(MultiTagSelect_css_templateObject_1 || (MultiTagSelect_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: repeat(", ", minmax(0, 1fr));\n    gap: 8px;\n    width: 100%;\n    pointer-events: ", ";\n    @media screen and (max-width: ", "px) {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n"], ["\n    display: grid;\n    grid-template-columns: repeat(", ", minmax(0, 1fr));\n    gap: 8px;\n    width: 100%;\n    pointer-events: ", ";\n    @media screen and (max-width: ", "px) {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n"])), function (_a) {
    var columns = _a.columns;
    return columns;
}, function (_a) {
    var readonly = _a.readonly;
    return (readonly ? 'none' : 'auto');
}, responsiveHelper/* screens.mobile */.FB.mobile);
var BenefitCard = styled_components_browser_esm/* default.div */.ZP.div(MultiTagSelect_css_templateObject_2 || (MultiTagSelect_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    user-select: none;\n    > p {\n        margin: 0;\n        line-height: 20px;\n        @media screen and (max-width: ", "px) {\n            font-size: 12px;\n        }\n    }\n    &:hover {\n        border-color: ", ";\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    user-select: none;\n    > p {\n        margin: 0;\n        line-height: 20px;\n        @media screen and (max-width: ", "px) {\n            font-size: 12px;\n        }\n    }\n    &:hover {\n        border-color: ", ";\n    }\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? "".concat(constants/* colors.borderFocus */.O9.borderFocus) : "".concat(constants/* colors.borderNormal */.O9.borderNormal));
}, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? "".concat(constants/* colors.borderFocus */.O9.borderFocus) : "".concat(constants/* colors.textColor */.O9.textColor));
}, responsiveHelper/* screens.mobile */.FB.mobile, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? "".concat(constants/* colors.borderFocus */.O9.borderFocus) : "".concat(constants/* colors.borderHover */.O9.borderHover));
});
var MultiTagSelect_css_templateObject_1, MultiTagSelect_css_templateObject_2;


//# sourceMappingURL=MultiTagSelect.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelectV2/constant.js
'use client';



var constant_listBenefits = [
    {
        id: 5,
        name: 'Awards',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 26.9375 1.96875 C 26.894531 1.976563 26.851563 1.988281 26.8125 2 C 26.519531 2.054688 26.269531 2.238281 26.125 2.5 L 25 4.4375 L 23.875 2.5 C 23.671875 2.132813 23.257813 1.933594 22.84375 2 C 22.511719 2.046875 22.226563 2.257813 22.082031 2.558594 C 21.9375 2.859375 21.953125 3.210938 22.125 3.5 L 23.84375 6.40625 L 20.5625 12.03125 C 20.230469 12.082031 19.910156 12.195313 19.625 12.34375 L 13.875 2.5 C 13.671875 2.132813 13.257813 1.933594 12.84375 2 C 12.511719 2.046875 12.226563 2.257813 12.082031 2.558594 C 11.9375 2.859375 11.953125 3.210938 12.125 3.5 L 18.21875 13.9375 C 18.089844 14.269531 18 14.621094 18 15 L 18 18.625 C 12.679688 21.226563 9 26.6875 9 33 C 9 41.824219 16.175781 49 25 49 C 33.824219 49 41 41.824219 41 33 C 41 26.6875 37.320313 21.226563 32 18.625 L 32 14.6875 C 32.007813 14.433594 31.917969 14.1875 31.75 14 L 37.875 3.5 C 38.152344 3.015625 37.984375 2.402344 37.5 2.125 C 37.015625 1.847656 36.402344 2.015625 36.125 2.5 L 29.40625 14 L 21.75 14 L 21.90625 13.71875 C 21.929688 13.6875 21.949219 13.65625 21.96875 13.625 C 22.03125 13.550781 22.085938 13.464844 22.125 13.375 C 22.136719 13.34375 22.148438 13.3125 22.15625 13.28125 L 25.65625 7.3125 C 25.679688 7.28125 25.699219 7.25 25.71875 7.21875 C 25.859375 7.082031 25.957031 6.910156 26 6.71875 C 26.011719 6.6875 26.023438 6.65625 26.03125 6.625 L 27.875 3.5 C 28.078125 3.179688 28.082031 2.769531 27.882813 2.441406 C 27.683594 2.117188 27.316406 1.933594 26.9375 1.96875 Z M 20 16 L 30 16 L 30 17.8125 C 28.421875 17.292969 26.75 17 25 17 C 23.25 17 21.578125 17.292969 20 17.8125 Z M 25 19 C 26.910156 19 28.746094 19.371094 30.40625 20.0625 C 30.417969 20.074219 30.425781 20.082031 30.4375 20.09375 C 30.445313 20.097656 30.460938 20.089844 30.46875 20.09375 C 30.546875 20.148438 30.628906 20.1875 30.71875 20.21875 C 30.726563 20.222656 30.742188 20.214844 30.75 20.21875 C 30.769531 20.230469 30.792969 20.242188 30.8125 20.25 C 35.652344 22.453125 39 27.328125 39 33 C 39 40.742188 32.742188 47 25 47 C 17.257813 47 11 40.742188 11 33 C 11 27.28125 14.410156 22.394531 19.3125 20.21875 C 19.390625 20.1875 19.464844 20.144531 19.53125 20.09375 C 21.207031 19.386719 23.0625 19 25 19 Z M 25 21 C 18.382813 21 13 26.382813 13 33 C 13 39.617188 18.382813 45 25 45 C 31.617188 45 37 39.617188 37 33 C 37 26.382813 31.617188 21 25 21 Z M 25 23 C 30.535156 23 35 27.464844 35 33 C 35 38.535156 30.535156 43 25 43 C 19.464844 43 15 38.535156 15 33 C 15 27.464844 19.464844 23 25 23 Z M 22 28 L 22 30 L 24 30 L 24 36 L 22 36 L 22 38 L 28 38 L 28 36 L 26 36 L 26 30 L 28 30 L 28 28 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 11 0 C 10.640625 0 10.300781 0.1875 10.125 0.5 C 9.945313 0.8125 9.96875 1.191406 10.15625 1.5 L 17.65625 14.0625 L 23.84375 3.78125 L 21.84375 0.5 C 21.664063 0.199219 21.351563 0 21 0 Z M 29 0 C 28.648438 0 28.335938 0.199219 28.15625 0.5 L 25 5.75 L 20.65625 13 L 20.625 13 L 18 17 L 18 19.625 C 12.679688 22.226563 9 27.6875 9 34 C 9 42.820313 16.179688 50 25 50 C 33.820313 50 41 42.820313 41 34 C 41 27.6875 37.320313 22.226563 32 19.625 L 32 15.6875 C 32.007813 15.433594 31.917969 15.1875 31.75 15 L 39.84375 1.5 C 40.03125 1.191406 40.054688 0.8125 39.875 0.5 C 39.695313 0.1875 39.359375 0 39 0 Z M 20 17 L 30 17 L 30 18.8125 C 28.425781 18.292969 26.75 18 25 18 C 23.25 18 21.574219 18.292969 20 18.8125 Z M 25 22 C 31.617188 22 37 27.382813 37 34 C 37 40.617188 31.617188 46 25 46 C 18.382813 46 13 40.617188 13 34 C 13 27.382813 18.382813 22 25 22 Z M 25 24 C 19.484375 24 15 28.484375 15 34 C 15 39.515625 19.484375 44 25 44 C 30.515625 44 35 39.515625 35 34 C 35 28.484375 30.515625 24 25 24 Z M 22 29 L 28 29 L 28 31 L 26 31 L 26 38 L 28 38 L 28 40 L 22 40 L 22 38 L 24 38 L 24 31 L 22 31 Z' }))); }
    },
    {
        id: 1,
        name: 'Bonus',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 20 4 C 19.448 4 19 4.448 19 5 L 19 18 C 19 24.063407 23.936593 29 30 29 C 36.063407 29 41 24.063407 41 18 L 41 5 C 41 4.448 40.552 4 40 4 C 39.448 4 39 4.448 39 5 L 39 18 C 39 22.982593 34.982593 27 30 27 C 25.017407 27 21 22.982593 21 18 L 21 5 C 21 4.448 20.552 4 20 4 z M 24 4 C 23.448 4 23 4.448 23 5 L 23 10.863281 C 23.598 10.277281 24.271 9.7716094 25 9.3496094 L 25 5 C 25 4.448 24.552 4 24 4 z M 28 4 C 27.448 4 27 4.448 27 5 L 27 8.4589844 C 27.641 8.2579844 28.31 8.1197812 29 8.0507812 L 29 5 C 29 4.448 28.552 4 28 4 z M 32 4 C 31.448 4 31 4.448 31 5 L 31 8.0507812 C 31.69 8.1197812 32.359 8.2579844 33 8.4589844 L 33 5 C 33 4.448 32.552 4 32 4 z M 36 4 C 35.448 4 35 4.448 35 5 L 35 9.3496094 C 35.729 9.7716094 36.402 10.277281 37 10.863281 L 37 5 C 37 4.448 36.552 4 36 4 z M 29 11 L 29 12.769531 C 26.352 13.213531 26.267578 15.566703 26.267578 15.845703 C 26.267578 18.321703 28.271813 18.768906 29.882812 19.128906 C 31.328813 19.452906 32.146484 19.68425 32.146484 20.65625 C 32.146484 21.23925 31.867953 22.21875 30.001953 22.21875 C 29.960953 22.21875 28.990813 22.211516 28.382812 21.603516 C 28.023812 21.244516 27.850187 20.7255 27.867188 20.0625 L 27.869141 20 L 26.011719 20 L 26.013672 20.064453 C 26.073672 22.164453 27.055953 23.364375 29.001953 23.734375 L 29.001953 25 L 29.097656 25 L 30.917969 25 L 31 25 L 31 23.765625 C 33.846 23.303625 34 21.097578 34 20.642578 C 34.001 18.251578 31.996719 17.791875 30.386719 17.421875 C 28.940719 17.089875 28.123047 16.856406 28.123047 15.941406 C 28.123047 14.846406 28.728297 14.335937 30.029297 14.335938 C 31.445297 14.335938 31.818141 15.207 31.869141 16 L 33.724609 16 C 33.725609 15.224 33.410469 14.38925 32.855469 13.78125 C 32.369469 13.25025 31.731047 12.908484 30.998047 12.771484 L 30.998047 11 L 30.917969 11 L 29.095703 11 L 29 11 z M 44.158203 25.984375 C 43.976081 25.987088 43.794527 26.003877 43.613281 26.033203 C 43.129958 26.111403 42.654568 26.286441 42.216797 26.5625 L 31.117188 33.402344 C 30.860975 33.262254 30.546838 33.107561 30.132812 32.908203 C 29.657062 32.679123 29.159549 32.445393 28.878906 32.318359 C 27.368214 31.6352 22.551898 29.647251 18.896484 28.042969 C 17.33274 27.356725 15.661395 27.005995 13.988281 26.990234 C 12.315168 26.974474 10.638837 27.294229 9.0625 27.951172 L 2.6152344 30.636719 A 1.0001 1.0001 0 1 0 3.3847656 32.482422 L 9.8320312 29.796875 C 12.481356 28.692761 15.463286 28.721482 18.091797 29.875 C 21.782383 31.494718 26.67738 33.517784 28.054688 34.140625 C 28.302045 34.252592 28.801627 34.487516 29.265625 34.710938 C 29.729623 34.934357 30.21732 35.181535 30.257812 35.205078 C 30.703995 35.464594 31 35.929151 31 36.488281 C 31 37.329093 30.340812 37.988281 29.5 37.988281 C 29.380834 37.988281 29.267782 37.974949 29.160156 37.949219 A 1.0001 1.0001 0 0 0 29.158203 37.949219 C 29.132973 37.943219 28.341821 37.721019 27.382812 37.439453 C 26.423804 37.157887 25.203555 36.796274 24.003906 36.439453 C 21.604609 35.725811 19.287109 35.03125 19.287109 35.03125 A 1.0001054 1.0001054 0 0 0 18.712891 36.947266 C 18.712891 36.947266 21.033844 37.641111 23.435547 38.355469 C 24.636398 38.712648 25.857071 39.074613 26.820312 39.357422 C 27.782628 39.639959 28.395226 39.823361 28.695312 39.894531 C 28.955687 39.956791 29.225166 39.988281 29.5 39.988281 C 31.421188 39.988281 33 38.40947 33 36.488281 C 33 35.89616 32.845356 35.339664 32.582031 34.849609 L 43.275391 28.259766 A 1.0001 1.0001 0 0 0 43.285156 28.253906 C 44.122074 27.726144 45.198996 27.970034 45.726562 28.806641 C 46.239013 29.618936 46.024802 30.663506 45.234375 31.208984 A 1.0001 1.0001 0 0 0 45.197266 31.234375 L 29.423828 43.185547 C 28.347119 44.001891 26.936059 44.221423 25.662109 43.769531 L 14.013672 39.640625 C 11.320349 38.529005 8.2378995 38.903354 5.8886719 40.626953 L 2.4042969 43.183594 A 1.0001 1.0001 0 1 0 3.5878906 44.794922 L 7.0722656 42.240234 C 8.861038 40.927834 11.199323 40.643854 13.25 41.490234 A 1.0001 1.0001 0 0 0 13.296875 41.507812 L 24.994141 45.654297 C 26.900191 46.330405 29.021523 46.000953 30.632812 44.779297 L 46.369141 32.855469 C 48.024714 31.712947 48.491519 29.441939 47.417969 27.740234 C 46.693184 26.590883 45.433055 25.965387 44.158203 25.984375 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 20 4 C 19.448 4 19 4.448 19 5 L 19 17.677734 C 19 23.402734 23.239453 28.413219 28.939453 28.949219 C 35.479453 29.565219 41 24.415 41 18 L 41 5 C 41 4.448 40.552 4 40 4 C 39.448 4 39 4.448 39 5 L 39 10.494141 C 39 11.387141 37.908828 11.823875 37.298828 11.171875 C 37.290828 11.163875 37.283391 11.154484 37.275391 11.146484 C 37.103391 10.961484 37 10.723703 37 10.470703 L 37 5 C 37 4.448 36.552 4 36 4 C 35.448 4 35 4.448 35 5 L 35 7.7695312 C 35 8.4545313 34.312734 8.9561719 33.677734 8.7011719 C 33.670734 8.6981719 33.66225 8.6963594 33.65625 8.6933594 C 33.26725 8.5383594 33 8.1806719 33 7.7636719 L 33 5 C 33 4.448 32.552 4 32 4 C 31.448 4 31 4.448 31 5 L 31 7.0390625 C 31 7.5840625 30.558672 8.0253906 30.013672 8.0253906 L 29.988281 8.0253906 C 29.442281 8.0253906 29 7.5840625 29 7.0390625 L 29 5 C 29 4.448 28.552 4 28 4 C 27.448 4 27 4.448 27 5 L 27 7.7636719 C 27 8.1806719 26.732703 8.5383594 26.345703 8.6933594 C 26.337703 8.6963594 26.329266 8.6981719 26.322266 8.7011719 C 25.687266 8.9561719 25 8.4554844 25 7.7714844 L 25 5 C 25 4.448 24.552 4 24 4 C 23.448 4 23 4.448 23 5 L 23 10.470703 C 23 10.723703 22.897609 10.962484 22.724609 11.146484 C 22.716609 11.154484 22.707219 11.163875 22.699219 11.171875 C 22.090219 11.824875 21 11.387141 21 10.494141 L 21 5 C 21 4.448 20.552 4 20 4 z M 29 11 L 29.095703 11 L 30.917969 11 L 30.998047 11 L 30.998047 12.771484 C 31.731047 12.908484 32.369469 13.25025 32.855469 13.78125 C 33.410469 14.38925 33.725609 15.224 33.724609 16 L 31.869141 16 C 31.818141 15.207 31.445297 14.335937 30.029297 14.335938 C 28.728297 14.335938 28.123047 14.846406 28.123047 15.941406 C 28.123047 16.856406 28.940719 17.089875 30.386719 17.421875 C 31.996719 17.791875 34.001 18.251578 34 20.642578 C 34 21.097578 33.846 23.303625 31 23.765625 L 31 25 L 30.917969 25 L 29.097656 25 L 29.001953 25 L 29.001953 23.734375 C 27.055953 23.364375 26.073672 22.164453 26.013672 20.064453 L 26.011719 20 L 27.869141 20 L 27.867188 20.0625 C 27.850188 20.7255 28.023812 21.244516 28.382812 21.603516 C 28.990813 22.211516 29.960953 22.21875 30.001953 22.21875 C 31.867953 22.21875 32.146484 21.23925 32.146484 20.65625 C 32.146484 19.68425 31.328813 19.452906 29.882812 19.128906 C 28.271812 18.768906 26.267578 18.321703 26.267578 15.845703 C 26.267578 15.566703 26.352 13.213531 29 12.769531 L 29 11 z M 44.345703 26.001953 C 43.620652 25.978035 42.882812 26.162922 42.226562 26.576172 L 32.876953 32.339844 C 33.585953 33.062844 34 34.043172 34 35.076172 C 34 37.246172 32.234453 39.011719 30.064453 39.011719 C 29.758453 39.011719 29.455109 38.97525 29.162109 38.90625 C 28.393109 38.72425 18.569172 35.783219 17.451172 35.449219 C 16.922172 35.290219 16.62325 34.732125 16.78125 34.203125 C 16.94025 33.674125 17.497391 33.375203 18.025391 33.533203 C 22.391391 34.841203 29.084047 36.834891 29.623047 36.962891 C 29.766047 36.996891 29.914453 37.013672 30.064453 37.013672 C 31.131453 37.013672 32 36.145125 32 35.078125 C 32 34.389125 31.641969 33.769875 31.042969 33.421875 C 30.751969 33.252875 20.881484 28.937406 18.896484 28.066406 C 15.786484 26.700406 12.2005 26.666656 9.0625 27.972656 L 2.6152344 30.658203 C 2.1052344 30.868203 2 31.331844 2 31.964844 L 2 44.009766 C 2 44.561766 2.448 45.009766 3 45.009766 C 3.305 45.009766 3.5488906 44.845406 3.5878906 44.816406 L 7.0722656 42.259766 C 8.8482656 40.956766 11.215828 40.670344 13.298828 41.527344 L 24.994141 45.673828 C 25.651141 45.906828 26.331813 46.021484 27.007812 46.021484 C 28.298813 46.021484 29.570813 45.605781 30.632812 44.800781 L 46.369141 32.875 C 48.040141 31.723 48.500969 29.476766 47.417969 27.759766 C 46.725469 26.661016 45.554121 26.041816 44.345703 26.001953 z' }))); }
    },
    {
        id: 12,
        name: 'Canteen',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 10.8125 0 C 10.335938 0.0898438 9.992188 0.511719 10 1 L 10 15 C 10 18.054688 11.523438 19.878906 12.875 21 C 13.550781 21.558594 14.179688 22 14.5625 22.34375 C 14.945313 22.6875 15 22.828125 15 23 C 15 23.949219 14.75 26.75 14.5 29.84375 C 14.25 32.9375 14 36.382813 14 39 C 14 43.71875 14.433594 46.320313 15.25 47.9375 C 15.65625 48.746094 16.207031 49.308594 16.8125 49.625 C 17.417969 49.941406 18.027344 50 18.5 50 C 18.972656 50 19.582031 49.941406 20.1875 49.625 C 20.792969 49.308594 21.34375 48.746094 21.75 47.9375 C 22.566406 46.320313 23 43.71875 23 39 C 23 36.382813 22.75 32.9375 22.5 29.84375 C 22.25 26.75 22 23.949219 22 23 C 22 22.828125 22.058594 22.679688 22.4375 22.34375 C 22.816406 22.007813 23.449219 21.617188 24.125 21.0625 C 25.480469 19.953125 27 18.097656 27 15 L 27 1 C 27 0.449219 26.550781 0 26 0 L 23 0 C 22.449219 0 22 0.449219 22 1 L 22 11.5 C 22 11.714844 21.714844 12 21.5 12 C 21.285156 12 21 11.714844 21 11.5 L 21 1 C 21 0.449219 20.550781 0 20 0 L 17 0 C 16.96875 0 16.9375 0 16.90625 0 C 16.390625 0.046875 15.996094 0.480469 16 1 L 16 11.5 C 16 11.714844 15.714844 12 15.5 12 C 15.285156 12 15 11.714844 15 11.5 L 15 1 C 15 0.449219 14.550781 0 14 0 L 11 0 C 10.96875 0 10.9375 0 10.90625 0 C 10.875 0 10.84375 0 10.8125 0 Z M 29.8125 0 C 29.335938 0.0898438 28.992188 0.511719 29 1 L 29 13 C 29 28.957031 28 32.378906 28 38 C 28 43.148438 28.351563 45.964844 29.09375 47.71875 C 29.464844 48.59375 29.980469 49.234375 30.625 49.59375 C 31.269531 49.953125 31.933594 50 32.5 50 C 33.066406 50 33.730469 49.953125 34.375 49.59375 C 35.019531 49.234375 35.535156 48.59375 35.90625 47.71875 C 36.648438 45.964844 37 43.148438 37 38 C 37 35.066406 36.1875 32.980469 35.40625 31.40625 C 34.625 29.832031 34 28.785156 34 28 C 34 27.25 34.269531 26.699219 34.75 26.0625 C 35.230469 25.425781 35.949219 24.765625 36.71875 24 C 38.261719 22.472656 40 20.378906 40 17 C 40 15.105469 39.75 11.046875 38.4375 7.3125 C 37.78125 5.445313 36.871094 3.652344 35.5 2.28125 C 34.128906 0.910156 32.257813 0 30 0 C 29.96875 0 29.9375 0 29.90625 0 C 29.875 0 29.84375 0 29.8125 0 Z M 12 2 L 13 2 L 13 11.5 C 13 12.882813 14.117188 14 15.5 14 C 16.882813 14 18 12.882813 18 11.5 L 18 2 L 19 2 L 19 11.5 C 19 12.882813 20.117188 14 21.5 14 C 22.882813 14 24 12.882813 24 11.5 L 24 2 L 25 2 L 25 15 C 25 17.503906 24.019531 18.5625 22.875 19.5 C 22.300781 19.96875 21.683594 20.382813 21.125 20.875 C 20.566406 21.367188 20 22.070313 20 23 C 20 24.25 20.25 26.917969 20.5 30 C 20.75 33.082031 21 36.515625 21 39 C 21 43.582031 20.503906 45.972656 19.96875 47.03125 C 19.703125 47.558594 19.453125 47.738281 19.25 47.84375 C 19.046875 47.949219 18.828125 48 18.5 48 C 18.171875 48 17.953125 47.949219 17.75 47.84375 C 17.546875 47.738281 17.296875 47.558594 17.03125 47.03125 C 16.496094 45.972656 16 43.582031 16 39 C 16 36.515625 16.25 33.082031 16.5 30 C 16.75 26.917969 17 24.25 17 23 C 17 22.070313 16.429688 21.34375 15.875 20.84375 C 15.320313 20.34375 14.699219 19.945313 14.125 19.46875 C 12.976563 18.515625 12 17.445313 12 15 Z M 31 2.1875 C 32.207031 2.398438 33.230469 2.855469 34.0625 3.6875 C 35.128906 4.753906 35.96875 6.285156 36.5625 7.96875 C 37.75 11.335938 38 15.292969 38 17 C 38 19.722656 36.738281 21.117188 35.28125 22.5625 C 34.550781 23.285156 33.769531 23.996094 33.125 24.84375 C 32.480469 25.691406 32 26.75 32 28 C 32 29.617188 32.875 30.828125 33.59375 32.28125 C 34.3125 33.734375 35 35.433594 35 38 C 35 43.050781 34.601563 45.742188 34.09375 46.9375 C 33.839844 47.535156 33.605469 47.734375 33.40625 47.84375 C 33.207031 47.953125 32.933594 48 32.5 48 C 32.066406 48 31.792969 47.953125 31.59375 47.84375 C 31.394531 47.734375 31.160156 47.535156 30.90625 46.9375 C 30.398438 45.742188 30 43.050781 30 38 C 30 32.621094 31 29.042969 31 13 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 11 0 C 10.449219 0 10 0.449219 10 1 L 10 15 C 10 18.867188 12.234375 20.566406 13.71875 21.6875 C 14.402344 22.203125 15 22.644531 15 23 C 15 23.832031 14.839844 25.746094 14.65625 27.96875 C 14.363281 31.492188 14 35.882813 14 39 C 14 46.914063 15.261719 50 18.5 50 C 21.738281 50 23 46.914063 23 39 C 23 35.882813 22.636719 31.492188 22.34375 27.96875 C 22.160156 25.746094 22 23.832031 22 23 C 22 22.65625 22.578125 22.214844 23.25 21.71875 C 24.742188 20.609375 27 18.945313 27 15 L 27 1 C 27 0.449219 26.554688 0 26 0 L 23 0 C 22.449219 0 22 0.449219 22 1 L 22 11.5 C 22 11.746094 21.746094 12 21.5 12 C 21.253906 12 21 11.746094 21 11.5 L 21 1 C 21 0.449219 20.550781 0 20 0 L 17 0 C 16.449219 0 16 0.449219 16 1 L 16 11.5 C 16 11.746094 15.746094 12 15.5 12 C 15.253906 12 15 11.746094 15 11.5 L 15 1 C 15 0.449219 14.550781 0 14 0 Z M 30 0 C 29.445313 0 29 0.449219 29 1 L 29 13 C 29 23.046875 28.601563 28.164063 28.3125 31.90625 C 28.136719 34.148438 28 35.929688 28 38 C 28 47.085938 29.09375 50 32.5 50 C 35.90625 50 37 47.085938 37 38 C 37 34.441406 35.808594 32.167969 34.9375 30.5 C 34.414063 29.503906 34 28.710938 34 28 C 34 26.699219 34.835938 25.8125 36.21875 24.46875 C 37.898438 22.832031 40 20.792969 40 17 C 40 10.6875 37.894531 0 30 0 Z' }))); }
    },
    {
        id: 2,
        name: 'Healthcare Plan',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '22px', height: '22px' },
            react.createElement("path", { d: 'M 25 0 C 21.101563 0 18.875 0.546875 17.53125 1.1875 C 16.859375 1.507813 16.410156 1.851563 16.125 2.15625 C 15.839844 2.460938 15.65625 2.84375 15.65625 2.84375 C 15.625 2.925781 15.605469 3.007813 15.59375 3.09375 L 14 16.875 C 13.984375 17.011719 13.992188 17.148438 14.03125 17.28125 C 14.027344 17.457031 14 17.625 14 17.8125 C 14 23.859375 18.953125 28.8125 25 28.8125 C 31.046875 28.8125 36 23.859375 36 17.8125 C 36 17.636719 35.972656 17.480469 35.96875 17.3125 C 36.011719 17.171875 36.023438 17.019531 36 16.875 L 34.40625 3.09375 C 34.394531 3.007813 34.375 2.925781 34.34375 2.84375 C 34.34375 2.84375 34.160156 2.460938 33.875 2.15625 C 33.589844 1.851563 33.140625 1.507813 32.46875 1.1875 C 31.125 0.546875 28.898438 0 25 0 Z M 25 2 C 28.703125 2 30.667969 2.542969 31.625 3 C 32.101563 3.230469 32.335938 3.425781 32.4375 3.53125 L 33.53125 13 C 33.339844 12.9375 33.136719 12.875 32.9375 12.84375 C 31.019531 12.523438 28.625 13 25 13 C 23.1875 13 21.667969 12.890625 20.375 12.8125 C 19.082031 12.734375 18.019531 12.683594 17.0625 12.84375 C 16.863281 12.875 16.660156 12.9375 16.46875 13 L 17.5625 3.53125 C 17.664063 3.425781 17.898438 3.230469 18.375 3 C 19.332031 2.542969 21.296875 2 25 2 Z M 24 4 L 24 7 L 21 7 L 21 9 L 24 9 L 24 12 L 26 12 L 26 9 L 29 9 L 29 7 L 26 7 L 26 4 Z M 17.90625 14.75 C 19.285156 14.6875 21.695313 15 25 15 C 28.777344 15 31.390625 14.605469 32.625 14.8125 C 33.242188 14.914063 33.421875 15.054688 33.625 15.40625 C 33.828125 15.757813 34 16.515625 34 17.8125 C 34 22.765625 29.953125 26.8125 25 26.8125 C 20.046875 26.8125 16 22.765625 16 17.8125 C 16 16.515625 16.171875 15.757813 16.375 15.40625 C 16.578125 15.054688 16.757813 14.914063 17.375 14.8125 C 17.527344 14.785156 17.710938 14.757813 17.90625 14.75 Z M 25 29.8125 C 18.785156 29.8125 13.15625 31.339844 9 33.59375 C 4.84375 35.847656 2 38.820313 2 42.09375 L 2 50 L 24.78125 50 C 24.914063 50.027344 25.054688 50.027344 25.1875 50 L 48 50 L 48 42.09375 C 48 38.820313 45.15625 35.847656 41 33.59375 C 38.667969 32.328125 35.855469 31.289063 32.75 30.625 C 32.578125 30.527344 32.382813 30.484375 32.1875 30.5 C 29.921875 30.050781 27.515625 29.8125 25 29.8125 Z M 25 31.8125 C 27.023438 31.8125 28.984375 31.96875 30.84375 32.28125 L 25 46.375 L 19.15625 32.28125 C 21.015625 31.96875 22.976563 31.8125 25 31.8125 Z M 17.1875 32.71875 L 23.5 48 L 4 48 L 4 42.09375 C 4 40.066406 6.117188 37.414063 9.9375 35.34375 C 11.96875 34.242188 14.441406 33.347656 17.1875 32.71875 Z M 32.8125 32.71875 C 35.558594 33.347656 38.03125 34.242188 40.0625 35.34375 C 43.882813 37.414063 46 40.066406 46 42.09375 L 46 48 L 26.5 48 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '22px', height: '22px' },
            react.createElement("path", { d: 'M 25 0 C 17.296875 0 15.898438 2.171875 15.65625 2.84375 C 15.628906 2.917969 15.601563 3.015625 15.59375 3.09375 L 14.4375 13.28125 C 15.96875 12.613281 18.066406 12.699219 20.78125 12.84375 C 22.042969 12.910156 23.472656 13 25 13 C 26.523438 13 27.957031 12.910156 29.21875 12.84375 C 31.929688 12.699219 34.03125 12.613281 35.5625 13.28125 L 34.40625 3.09375 C 34.398438 3.015625 34.371094 2.917969 34.34375 2.84375 C 34.101563 2.171875 32.699219 0 25 0 Z M 24 4 L 26 4 L 26 7 L 29 7 L 29 9 L 26 9 L 26 12 L 24 12 L 24 9 L 21 9 L 21 7 L 24 7 Z M 18.65625 14.75 C 16.78125 14.695313 15.34375 14.816406 14.65625 15.46875 C 14.207031 15.898438 14 16.664063 14 17.8125 C 14 23.878906 18.933594 28.8125 25 28.8125 C 31.066406 28.8125 36 23.878906 36 17.8125 C 36 16.664063 35.792969 15.898438 35.34375 15.46875 C 34.429688 14.601563 32.160156 14.695313 29.3125 14.84375 C 28.027344 14.910156 26.578125 15 25 15 C 23.421875 15 21.972656 14.910156 20.6875 14.84375 C 19.976563 14.804688 19.28125 14.769531 18.65625 14.75 Z M 25 29.8125 C 22.757813 29.8125 20.527344 30.015625 18.40625 30.40625 L 25 46.40625 L 31.6875 30.4375 C 29.53125 30.03125 27.28125 29.8125 25 29.8125 Z M 16.4375 30.84375 C 8.300781 32.820313 2 37.347656 2 42.09375 L 2 50 L 25 50 C 24.597656 50 24.214844 49.75 24.0625 49.375 Z M 25 50 L 48 50 L 48 42.09375 C 48 37.371094 41.769531 32.835938 33.6875 30.84375 L 25.9375 49.375 C 25.78125 49.746094 25.402344 50 25 50 Z' }))); }
    },
    {
        id: 14,
        name: 'Kindergarten',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 0 C 8.699219 0 6 2.699219 6 6 C 6 9.300781 8.699219 12 12 12 C 15.300781 12 18 9.300781 18 6 C 18 2.699219 15.300781 0 12 0 Z M 12 2 C 14.222656 2 16 3.777344 16 6 C 16 8.222656 14.222656 10 12 10 C 9.777344 10 8 8.222656 8 6 C 8 3.777344 9.777344 2 12 2 Z M 9.09375 13 C 7.5625 13 6.402344 13.675781 5.65625 14.46875 C 4.910156 15.261719 4.523438 16.144531 4.34375 16.6875 C 4.34375 16.6875 1.253906 26.136719 0.34375 28.96875 C 0.339844 28.976563 0.347656 28.992188 0.34375 29 C 0.015625 29.941406 0.109375 30.945313 0.59375 31.71875 C 1.082031 32.5 1.992188 33 3 33 L 2.5625 34.28125 C 2.550781 34.300781 2.539063 34.324219 2.53125 34.34375 C 2.402344 34.859375 2.410156 35.601563 2.78125 36.15625 C 2.816406 36.210938 2.859375 36.265625 2.90625 36.3125 C 3.222656 36.628906 3.660156 37 4.40625 37 L 7 37 L 7 47 C 7 48.644531 8.355469 50 10 50 C 10.765625 50 11.46875 49.699219 12 49.21875 C 12.53125 49.699219 13.234375 50 14 50 C 15.644531 50 17 48.644531 17 47 L 17 37 L 19.59375 37 C 20.339844 37 20.777344 36.628906 21.09375 36.3125 C 21.140625 36.265625 21.183594 36.210938 21.21875 36.15625 C 21.589844 35.601563 21.597656 34.859375 21.46875 34.34375 C 21.460938 34.324219 21.449219 34.300781 21.4375 34.28125 L 21 33 C 22.007813 33 22.917969 32.5 23.40625 31.71875 C 23.890625 30.945313 23.984375 29.941406 23.65625 29 C 23.652344 28.992188 23.660156 28.976563 23.65625 28.96875 C 22.746094 26.136719 19.65625 16.6875 19.65625 16.6875 C 19.476563 16.144531 19.089844 15.261719 18.34375 14.46875 C 17.597656 13.675781 16.4375 13 14.90625 13 Z M 9.09375 15 L 14.90625 15 C 15.875 15 16.449219 15.359375 16.90625 15.84375 C 17.363281 16.328125 17.632813 16.957031 17.75 17.3125 C 17.75 17.3125 20.851563 26.804688 21.75 29.59375 C 21.75 29.605469 21.75 29.613281 21.75 29.625 C 21.910156 30.074219 21.855469 30.4375 21.71875 30.65625 C 21.582031 30.875 21.390625 31 21 31 C 20.617188 31 20.292969 30.792969 20.125 30.34375 C 20.117188 30.3125 20.105469 30.28125 20.09375 30.25 L 17.25 21.6875 C 17.097656 21.179688 16.578125 20.878906 16.0625 21 C 15.785156 21.0625 15.546875 21.242188 15.40625 21.496094 C 15.269531 21.746094 15.246094 22.042969 15.34375 22.3125 L 18.1875 30.8125 L 18.1875 30.84375 C 18.199219 30.917969 18.222656 30.992188 18.25 31.0625 C 18.265625 31.105469 18.292969 31.144531 18.3125 31.1875 L 19.53125 34.84375 C 19.589844 35.082031 19.578125 34.996094 19.5625 35 L 4.4375 35 C 4.421875 34.996094 4.410156 35.082031 4.46875 34.84375 L 5.75 31.0625 C 5.785156 30.972656 5.804688 30.878906 5.8125 30.78125 L 8.65625 22.3125 C 8.777344 21.96875 8.703125 21.589844 8.464844 21.316406 C 8.222656 21.042969 7.855469 20.921875 7.5 21 C 7.144531 21.074219 6.855469 21.339844 6.75 21.6875 L 3.875 30.34375 C 3.707031 30.792969 3.382813 31 3 31 C 2.609375 31 2.417969 30.875 2.28125 30.65625 C 2.144531 30.4375 2.089844 30.074219 2.25 29.625 C 2.25 29.613281 2.25 29.605469 2.25 29.59375 C 3.148438 26.804688 6.25 17.3125 6.25 17.3125 C 6.367188 16.957031 6.636719 16.328125 7.09375 15.84375 C 7.550781 15.359375 8.125 15 9.09375 15 Z M 39.34375 19 C 39.015625 19.050781 38.734375 19.261719 38.59375 19.5625 L 33.375 30 L 25 30 C 24.96875 30 24.9375 30 24.90625 30 C 24.875 30 24.84375 30 24.8125 30 C 24.335938 30.089844 23.992188 30.511719 24 31 C 24 34.855469 25.980469 38.25 29 40.4375 C 27.242188 41.214844 26 42.964844 26 45 C 26 47.75 28.25 50 31 50 C 33.75 50 36 47.75 36 45 C 36 44.253906 35.828125 43.546875 35.53125 42.90625 C 36.015625 42.957031 36.503906 43 37 43 C 37.875 43 38.730469 42.90625 39.5625 42.75 C 39.214844 43.429688 39 44.1875 39 45 C 39 47.75 41.25 50 44 50 C 46.75 50 49 47.75 49 45 C 49 42.707031 47.425781 40.769531 45.3125 40.1875 C 48.078125 38.054688 49.875 34.882813 49.96875 31.28125 C 49.980469 31.261719 49.992188 31.238281 50 31.21875 C 50 31.144531 50 31.074219 50 31 C 50.003906 30.957031 50.003906 30.917969 50 30.875 C 49.9375 25.21875 45.578125 20.515625 39.75 19.03125 C 39.617188 18.992188 39.480469 18.984375 39.34375 19 Z M 40 21.28125 C 44.332031 22.667969 47.355469 26.003906 47.8125 30 L 35.625 30 Z M 26.21875 32 L 47.78125 32 C 47.207031 37.019531 42.710938 41 37 41 C 31.289063 41 26.792969 37.019531 26.21875 32 Z M 9 37 L 11 37 L 11 47 C 11 47.554688 10.554688 48 10 48 C 9.445313 48 9 47.554688 9 47 Z M 13 37 L 15 37 L 15 47 C 15 47.554688 14.554688 48 14 48 C 13.445313 48 13 47.554688 13 47 Z M 31 42 C 32.667969 42 34 43.332031 34 45 C 34 46.667969 32.667969 48 31 48 C 29.332031 48 28 46.667969 28 45 C 28 43.332031 29.332031 42 31 42 Z M 44 42 C 45.667969 42 47 43.332031 47 45 C 47 46.667969 45.667969 48 44 48 C 42.332031 48 41 46.667969 41 45 C 41 43.332031 42.332031 42 44 42 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 0 C 8.699219 0 6 2.699219 6 6 C 6 9.300781 8.699219 12 12 12 C 15.300781 12 18 9.300781 18 6 C 18 2.699219 15.300781 0 12 0 Z M 9.40625 13 C 6.304688 13 4.914063 14.800781 4.3125 17 C 4.3125 17 0.3125 29.398438 0.3125 29.5 C -0.1875 30.898438 -0.0546875 32.40625 1.84375 32.40625 C 2.945313 32.40625 3.230469 31.785156 3.53125 31.1875 L 6.875 21.78125 C 6.882813 21.753906 6.894531 21.742188 6.90625 21.71875 L 6.90625 21.6875 C 6.988281 21.523438 7.148438 21.40625 7.34375 21.40625 C 7.621094 21.40625 7.84375 21.628906 7.84375 21.90625 C 7.84375 21.945313 7.820313 21.992188 7.8125 22.03125 L 3.0625 35.59375 C 2.960938 35.894531 3.042969 36.199219 3.1875 36.5 C 3.386719 36.800781 3.664063 37 4.0625 37 L 19.9375 37 C 20.335938 37 20.644531 36.800781 20.84375 36.5 C 20.988281 36.199219 21.039063 35.894531 20.9375 35.59375 L 16.21875 22.03125 C 16.210938 21.992188 16.1875 21.976563 16.1875 21.9375 C 16.1875 21.660156 16.410156 21.4375 16.6875 21.4375 C 16.882813 21.4375 17.042969 21.523438 17.125 21.6875 L 17.125 21.71875 C 17.136719 21.742188 17.148438 21.753906 17.15625 21.78125 L 20.46875 31.1875 C 20.769531 31.789063 21.085938 32.40625 22.1875 32.40625 C 24.089844 32.40625 24.21875 30.898438 23.71875 29.5 C 23.71875 29.398438 19.71875 17 19.71875 17 C 19.117188 14.800781 17.726563 13 14.625 13 Z M 39.4375 18.96875 C 39.105469 19 38.839844 19.199219 38.6875 19.5 L 34.40625 28 L 49.59375 28 C 48.394531 23.800781 44.714844 20.300781 39.8125 19 C 39.6875 18.976563 39.546875 18.957031 39.4375 18.96875 Z M 25 30 C 24.398438 30 24 30.398438 24 31 C 24 34.8125 25.945313 38.203125 28.96875 40.40625 C 27.203125 41.171875 26 42.925781 26 45 C 26 47.800781 28.199219 50 31 50 C 33.800781 50 36 47.800781 36 45 C 36 44.257813 35.839844 43.566406 35.5625 42.9375 C 36.03125 42.984375 36.519531 43 37 43 C 37.867188 43 38.710938 42.898438 39.53125 42.75 C 39.195313 43.425781 39 44.183594 39 45 C 39 47.800781 41.199219 50 44 50 C 46.800781 50 49 47.800781 49 45 C 49 42.667969 47.472656 40.761719 45.34375 40.1875 C 48.191406 37.980469 50 34.683594 50 31 C 50 30.398438 49.601563 30 49 30 Z M 7 38 L 7 48 C 7 49.101563 7.898438 50 9 50 C 10.101563 50 11 49.101563 11 48 L 11 38 Z M 12 38 L 12 48 C 12 49.101563 12.898438 50 14 50 C 15.101563 50 16 49.101563 16 48 L 16 38 Z M 31 42 C 32.699219 42 34 43.300781 34 45 C 34 46.699219 32.699219 48 31 48 C 29.300781 48 28 46.699219 28 45 C 28 43.300781 29.300781 42 31 42 Z M 44 42 C 45.699219 42 47 43.300781 47 45 C 47 46.699219 45.699219 48 44 48 C 42.300781 48 41 46.699219 41 45 C 41 43.300781 42.300781 42 44 42 Z' }))); }
    },
    {
        id: 8,
        name: 'Mobile',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 9 3 C 7.355469 3 6 4.355469 6 6 L 6 8.832031 C 5.980469 8.941406 5.980469 9.050781 6 9.15625 L 6 39.832031 C 5.980469 39.941406 5.980469 40.050781 6 40.15625 L 6 44 C 6 45.644531 7.355469 47 9 47 L 29 47 C 30.644531 47 32 45.644531 32 44 L 32 40.167969 C 32.019531 40.058594 32.019531 39.949219 32 39.84375 L 32 9.167969 C 32.019531 9.058594 32.019531 8.949219 32 8.84375 L 32 6 C 32 4.355469 30.644531 3 29 3 Z M 9 5 L 29 5 C 29.554688 5 30 5.445313 30 6 L 30 8 L 8 8 L 8 6 C 8 5.445313 8.445313 5 9 5 Z M 8 10 L 30 10 L 30 39 L 8 39 Z M 40.636719 12.363281 L 39.21875 13.78125 C 42.144531 16.4375 44 20.246094 44 24.5 C 44 28.496094 42.367188 32.117188 39.742188 34.742188 L 41.144531 36.144531 C 44.136719 33.160156 46 29.050781 46 24.5 C 46 19.695313 43.921875 15.382813 40.636719 12.363281 Z M 36.394531 16.605469 L 34.96875 18.03125 C 36.816406 19.585938 38 21.902344 38 24.5 C 38 26.84375 37.03125 28.953125 35.492188 30.492188 L 36.90625 31.90625 C 38.808594 30.007813 40 27.394531 40 24.5 C 40 21.351563 38.597656 18.53125 36.394531 16.605469 Z M 8 41 L 30 41 L 30 44 C 30 44.554688 29.554688 45 29 45 L 9 45 C 8.445313 45 8 44.554688 8 44 Z M 16 42 C 15.640625 41.996094 15.304688 42.183594 15.121094 42.496094 C 14.941406 42.808594 14.941406 43.191406 15.121094 43.503906 C 15.304688 43.816406 15.640625 44.003906 16 44 L 22 44 C 22.359375 44.003906 22.695313 43.816406 22.878906 43.503906 C 23.058594 43.191406 23.058594 42.808594 22.878906 42.496094 C 22.695313 42.183594 22.359375 41.996094 22 42 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 9 3 C 7.355469 3 6 4.355469 6 6 L 6 44 C 6 45.644531 7.355469 47 9 47 L 29 47 C 30.644531 47 32 45.644531 32 44 L 32 6 C 32 4.355469 30.644531 3 29 3 Z M 8 10 L 30 10 L 30 39 L 8 39 Z M 40.636719 12.363281 L 39.21875 13.78125 C 42.144531 16.4375 44 20.246094 44 24.5 C 44 28.496094 42.367188 32.117188 39.742188 34.742188 L 41.144531 36.144531 C 44.136719 33.160156 46 29.050781 46 24.5 C 46 19.695313 43.921875 15.382813 40.636719 12.363281 Z M 36.394531 16.605469 L 34.96875 18.03125 C 36.816406 19.585938 38 21.902344 38 24.5 C 38 26.84375 37.03125 28.953125 35.492188 30.492188 L 36.90625 31.90625 C 38.808594 30.007813 40 27.394531 40 24.5 C 40 21.351563 38.597656 18.53125 36.394531 16.605469 Z M 16 42 L 22 42 C 22.550781 42 23 42.449219 23 43 C 23 43.550781 22.550781 44 22 44 L 16 44 C 15.449219 44 15 43.550781 15 43 C 15 42.449219 15.449219 42 16 42 Z' }))); }
    },
    {
        id: 3,
        name: 'Paid Leave',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12.962891 3 A 1.0001 1.0001 0 0 0 12 4 L 12 26 L 10 26 C 7.8045455 26 6 27.804545 6 30 L 6 46 A 1.0001 1.0001 0 1 0 8 46 L 8 30 C 8 28.895455 8.8954545 28 10 28 L 12 28 L 12 30 C 10.895 30 10 30.895 10 32 C 10 33.105 10.895 34 12 34 L 38 34 C 39.105 34 40 33.105 40 32 C 40 30.895 39.105 30 38 30 L 38 28 L 40 28 C 41.104545 28 42 28.895455 42 30 L 42 46 A 1.0001 1.0001 0 1 0 44 46 L 44 30 C 44 27.804545 42.195455 26 40 26 L 38 26 L 38 4 A 1.0001 1.0001 0 0 0 36.552734 3.1054688 L 35 3.8828125 L 33.447266 3.1054688 A 1.0001 1.0001 0 0 0 32.552734 3.1054688 L 31 3.8828125 L 29.447266 3.1054688 A 1.0001 1.0001 0 0 0 28.552734 3.1054688 L 27 3.8828125 L 25.447266 3.1054688 A 1.0001 1.0001 0 0 0 24.552734 3.1054688 L 23 3.8828125 L 21.447266 3.1054688 A 1.0001 1.0001 0 0 0 20.552734 3.1054688 L 19 3.8828125 L 17.447266 3.1054688 A 1.0001 1.0001 0 0 0 16.552734 3.1054688 L 15 3.8828125 L 13.447266 3.1054688 A 1.0001 1.0001 0 0 0 12.962891 3 z M 17 5.1171875 L 18.552734 5.8945312 A 1.0001 1.0001 0 0 0 19.447266 5.8945312 L 21 5.1171875 L 22.552734 5.8945312 A 1.0001 1.0001 0 0 0 23.447266 5.8945312 L 25 5.1171875 L 26.552734 5.8945312 A 1.0001 1.0001 0 0 0 27.447266 5.8945312 L 29 5.1171875 L 30.552734 5.8945312 A 1.0001 1.0001 0 0 0 31.447266 5.8945312 L 33 5.1171875 L 34.552734 5.8945312 A 1.0001 1.0001 0 0 0 35.447266 5.8945312 L 36 5.6171875 L 36 26.832031 A 1.0001 1.0001 0 0 0 36 27.158203 L 36 32 L 14 32 L 14 27.167969 A 1.0001 1.0001 0 0 0 14 26.841797 L 14 5.6171875 L 14.552734 5.8945312 A 1.0001 1.0001 0 0 0 15.447266 5.8945312 L 17 5.1171875 z M 24 9 L 24 11.220703 C 22.400034 11.480913 21.210789 12.144211 20.664062 12.978516 C 19.996547 13.997145 20 15.052734 20 15.052734 C 20 16.481825 20.858999 17.58482 21.873047 18.224609 C 22.887094 18.864398 24.071516 19.216963 25.189453 19.582031 C 26.30739 19.9471 27.353422 20.323621 28.021484 20.789062 C 28.689546 21.254504 29 21.665308 29 22.544922 C 29 22.544922 29.0039 23.078058 28.564453 23.685547 C 28.125008 24.293036 27.2696 25 25 25 C 22.766667 25 21.938855 24.216621 21.472656 23.470703 C 21.006457 22.724785 21 22 21 22 L 19 22 C 19 22 18.9935 23.275215 19.777344 24.529297 C 20.444342 25.596494 21.919248 26.48535 24 26.771484 L 24 29 L 26 29 L 26 26.802734 C 28.044643 26.558744 29.497361 25.80877 30.185547 24.857422 C 30.996102 23.736911 31 22.544922 31 22.544922 C 31 21.037036 30.185454 19.858684 29.166016 19.148438 C 28.146578 18.438191 26.94261 18.051322 25.810547 17.681641 C 24.678484 17.311959 23.612906 16.958102 22.939453 16.533203 C 22.266001 16.108305 22 15.789144 22 15.052734 C 22 15.052734 22.0035 14.58159 22.335938 14.074219 C 22.668422 13.566848 23.254333 13 25 13 C 26.75 13 27.338646 13.560702 27.667969 14.054688 C 27.997292 14.548671 28 15 28 15 L 30 15 C 30 15 30.0027 13.951329 29.332031 12.945312 C 28.78297 12.121722 27.595647 11.472184 26 11.216797 L 26 9 L 24 9 z M 12 37 C 11.448 37 11 37.448 11 38 L 11 40 C 11 40.552 11.448 41 12 41 L 18 41 C 18.552 41 19 40.552 19 40 L 19 38 C 19 37.448 18.552 37 18 37 L 12 37 z M 22 37 C 21.448 37 21 37.448 21 38 L 21 40 C 21 40.552 21.448 41 22 41 L 28 41 C 28.552 41 29 40.552 29 40 L 29 38 C 29 37.448 28.552 37 28 37 L 22 37 z M 32 37 C 31.448 37 31 37.448 31 38 L 31 40 C 31 40.552 31.448 41 32 41 L 38 41 C 38.552 41 39 40.552 39 40 L 39 38 C 39 37.448 38.552 37 38 37 L 32 37 z M 12 43 C 11.448 43 11 43.448 11 44 L 11 46 C 11 46.552 11.448 47 12 47 L 18 47 C 18.552 47 19 46.552 19 46 L 19 44 C 19 43.448 18.552 43 18 43 L 12 43 z M 22 43 C 21.448 43 21 43.448 21 44 L 21 46 C 21 46.552 21.448 47 22 47 L 28 47 C 28.552 47 29 46.552 29 46 L 29 44 C 29 43.448 28.552 43 28 43 L 22 43 z M 32 43 C 31.448 43 31 43.448 31 44 L 31 46 C 31 46.552 31.448 47 32 47 L 38 47 C 38.552 47 39 46.552 39 46 L 39 44 C 39 43.448 38.552 43 38 43 L 32 43 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12.962891 3 A 1.0001 1.0001 0 0 0 12 4 L 12 26 L 9.9707031 26 C 7.7647031 26 6 27.794 6 30 L 6 46 C 6 46.553 6.4177031 47 6.9707031 47 L 10.970703 47 L 10.970703 45 C 10.970703 44.448 11.418703 44 11.970703 44 L 17.970703 44 C 18.522703 44 18.970703 44.448 18.970703 45 L 18.970703 47 L 20.970703 47 L 20.970703 45 C 20.970703 44.448 21.418703 44 21.970703 44 L 27.970703 44 C 28.522703 44 28.970703 44.448 28.970703 45 L 28.970703 47 L 30.970703 47 L 30.970703 45 C 30.970703 44.448 31.418703 44 31.970703 44 L 37.970703 44 C 38.522703 44 38.970703 44.448 38.970703 45 L 38.970703 47 L 42.970703 47 C 43.523703 47 43.970703 46.553 43.970703 46 L 43.970703 30 C 43.970703 27.794 42.176703 26 39.970703 26 L 38 26 L 38 4 A 1.0001 1.0001 0 0 0 36.552734 3.1054688 L 35 3.8828125 L 33.447266 3.1054688 A 1.0001 1.0001 0 0 0 32.552734 3.1054688 L 31 3.8828125 L 29.447266 3.1054688 A 1.0001 1.0001 0 0 0 28.552734 3.1054688 L 27 3.8828125 L 25.447266 3.1054688 A 1.0001 1.0001 0 0 0 24.552734 3.1054688 L 23 3.8828125 L 21.447266 3.1054688 A 1.0001 1.0001 0 0 0 20.552734 3.1054688 L 19 3.8828125 L 17.447266 3.1054688 A 1.0001 1.0001 0 0 0 16.552734 3.1054688 L 15 3.8828125 L 13.447266 3.1054688 A 1.0001 1.0001 0 0 0 12.962891 3 z M 17 5.1171875 L 18.552734 5.8945312 A 1.0001 1.0001 0 0 0 19.447266 5.8945312 L 21 5.1171875 L 22.552734 5.8945312 A 1.0001 1.0001 0 0 0 23.447266 5.8945312 L 25 5.1171875 L 26.552734 5.8945312 A 1.0001 1.0001 0 0 0 27.447266 5.8945312 L 29 5.1171875 L 30.552734 5.8945312 A 1.0001 1.0001 0 0 0 31.447266 5.8945312 L 33 5.1171875 L 34.552734 5.8945312 A 1.0001 1.0001 0 0 0 35.447266 5.8945312 L 36 5.6171875 L 36 34 L 14 34 L 14 5.6171875 L 14.552734 5.8945312 A 1.0001 1.0001 0 0 0 15.447266 5.8945312 L 17 5.1171875 z M 24 10 L 24 12.220703 C 22.400034 12.480913 21.210789 13.144211 20.664062 13.978516 C 19.996547 14.997145 20 16.052734 20 16.052734 C 20 17.481825 20.858999 18.58482 21.873047 19.224609 C 22.887094 19.864398 24.071516 20.216963 25.189453 20.582031 C 26.30739 20.9471 27.353422 21.323621 28.021484 21.789062 C 28.689546 22.254504 29 22.665308 29 23.544922 C 29 23.544922 29.0039 24.078058 28.564453 24.685547 C 28.125008 25.293036 27.2696 26 25 26 C 22.766667 26 21.938855 25.216621 21.472656 24.470703 C 21.006457 23.724785 21 23 21 23 L 19 23 C 19 23 18.9935 24.275215 19.777344 25.529297 C 20.444342 26.596494 21.919248 27.48535 24 27.771484 L 24 30 L 26 30 L 26 27.802734 C 28.044643 27.558744 29.497361 26.80877 30.185547 25.857422 C 30.996102 24.736911 31 23.544922 31 23.544922 C 31 22.037036 30.185454 20.858684 29.166016 20.148438 C 28.146578 19.438191 26.94261 19.051322 25.810547 18.681641 C 24.678484 18.311959 23.612906 17.958102 22.939453 17.533203 C 22.266001 17.108305 22 16.789144 22 16.052734 C 22 16.052734 22.0035 15.58159 22.335938 15.074219 C 22.668422 14.566848 23.254333 14 25 14 C 26.75 14 27.338646 14.560702 27.667969 15.054688 C 27.997292 15.548671 28 16 28 16 L 30 16 C 30 16 30.0027 14.951329 29.332031 13.945312 C 28.78297 13.121722 27.595647 12.472184 26 12.216797 L 26 10 L 24 10 z M 11.970703 30 L 12 30 L 12 34 L 11.970703 34 C 10.865703 34 9.9707031 33.105 9.9707031 32 C 9.9707031 30.895 10.865703 30 11.970703 30 z M 38 30.003906 C 39.091121 30.019968 39.970703 30.905041 39.970703 32 C 39.970703 33.094959 39.091121 33.980032 38 33.996094 L 38 30.003906 z M 11.970703 38 L 17.970703 38 C 18.522703 38 18.970703 38.448 18.970703 39 L 18.970703 41 C 18.970703 41.552 18.522703 42 17.970703 42 L 11.970703 42 C 11.417703 42 10.970703 41.552 10.970703 41 L 10.970703 39 C 10.970703 38.448 11.418703 38 11.970703 38 z M 21.970703 38 L 27.970703 38 C 28.522703 38 28.970703 38.448 28.970703 39 L 28.970703 41 C 28.970703 41.552 28.522703 42 27.970703 42 L 21.970703 42 C 21.418703 42 20.970703 41.552 20.970703 41 L 20.970703 39 C 20.970703 38.448 21.418703 38 21.970703 38 z M 31.970703 38 L 37.970703 38 C 38.522703 38 38.970703 38.448 38.970703 39 L 38.970703 41 C 38.970703 41.552 38.522703 42 37.970703 42 L 31.970703 42 C 31.418703 42 30.970703 41.552 30.970703 41 L 30.970703 39 C 30.970703 38.448 31.418703 38 31.970703 38 z' }))); }
    },
    {
        id: 10,
        name: 'Team Activities',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22.5 12 C 22.007813 12 21.589844 12.207031 21.167969 12.390625 C 21.011719 12.386719 20.855469 12.425781 20.714844 12.496094 L 8.980469 18.347656 C 8.8125 18.429688 8.671875 18.558594 8.578125 18.71875 C 7.671875 19.351563 7 20.3125 7 21.5 C 7 23.421875 8.578125 25 10.5 25 C 10.917969 25 11.269531 24.847656 11.628906 24.714844 C 11.785156 24.71875 11.941406 24.6875 12.082031 24.621094 L 21.203125 20.328125 L 23.414063 23.917969 L 7.582031 33.558594 C 3.734375 32.164063 1.679688 30.265625 1.679688 30.265625 C 1.480469 30.078125 1.21875 29.980469 0.945313 29.992188 C 0.539063 30.007813 0.183594 30.269531 0.046875 30.652344 C -0.0898438 31.035156 0.0195313 31.464844 0.320313 31.734375 C 0.320313 31.734375 2.789063 33.96875 7.242188 35.527344 C 7.335938 35.578125 7.4375 35.613281 7.542969 35.628906 C 9.867188 36.410156 12.695313 37 16 37 C 20.921875 37 24.386719 35.953125 27.371094 34.949219 C 30.351563 33.941406 32.8125 33 36 33 C 42.371094 33 48.457031 36.84375 48.457031 36.84375 C 48.925781 37.140625 49.542969 37.007813 49.84375 36.542969 C 50.140625 36.074219 50.007813 35.457031 49.542969 35.15625 C 49.542969 35.15625 43.160156 31 36 31 C 35.617188 31 35.246094 31.019531 34.878906 31.042969 C 34.949219 30.703125 35 30.355469 35 30 C 35 29.214844 34.699219 28.53125 34.378906 27.878906 C 34.382813 27.683594 34.328125 27.488281 34.222656 27.324219 L 25.421875 13.574219 C 25.417969 13.570313 25.414063 13.5625 25.410156 13.558594 C 24.785156 12.621094 23.707031 12 22.5 12 Z M 22.5 14 C 23.027344 14 23.476563 14.265625 23.746094 14.667969 L 32.1875 27.847656 L 32.542969 27.3125 C 32.324219 27.644531 32.316406 28.070313 32.53125 28.40625 C 32.828125 28.875 33 29.414063 33 30 C 33 30.476563 32.886719 30.917969 32.691406 31.3125 C 30.585938 31.699219 28.695313 32.386719 26.730469 33.050781 C 23.792969 34.046875 20.644531 35 16 35 C 13.820313 35 11.878906 34.730469 10.171875 34.324219 L 25.3125 25.105469 C 25.539063 24.964844 25.703125 24.742188 25.765625 24.484375 C 25.824219 24.222656 25.78125 23.949219 25.640625 23.722656 L 22.4375 18.515625 C 22.167969 18.085938 21.617188 17.921875 21.15625 18.136719 L 12.113281 22.394531 L 12.546875 23.261719 C 12.425781 23.019531 12.214844 22.839844 11.957031 22.753906 C 11.703125 22.671875 11.425781 22.695313 11.1875 22.820313 C 10.964844 22.9375 10.738281 23 10.5 23 C 9.65625 23 9 22.34375 9 21.5 C 9 20.894531 9.351563 20.394531 9.859375 20.152344 C 9.902344 20.132813 9.9375 20.109375 9.976563 20.085938 L 21.292969 14.441406 L 20.953125 14.363281 C 21.210938 14.421875 21.480469 14.375 21.703125 14.234375 C 21.945313 14.082031 22.207031 14 22.5 14 Z M 39.5 18 C 36.472656 18 34 20.472656 34 23.5 C 34 26.527344 36.472656 29 39.5 29 C 42.523438 29 45 26.527344 45 23.5 C 45 20.472656 42.523438 18 39.5 18 Z M 39.5 20 C 41.445313 20 43 21.554688 43 23.5 C 43 25.445313 41.445313 27 39.5 27 C 37.550781 27 36 25.449219 36 23.5 C 36 21.554688 37.554688 20 39.5 20 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22.5 13 C 22.011719 13 21.554688 13.148438 21.171875 13.390625 L 21.160156 13.390625 L 9.429688 19.242188 L 9.429688 19.25 C 8.585938 19.648438 8 20.503906 8 21.5 C 8 22.882813 9.117188 24 10.5 24 C 10.917969 24 11.304688 23.886719 11.652344 23.707031 L 11.65625 23.71875 L 21.582031 19.042969 L 24.792969 24.25 L 8.832031 33.96875 C 4.179688 32.574219 1.679688 30.265625 1.679688 30.265625 C 1.480469 30.078125 1.21875 29.980469 0.945313 29.992188 C 0.539063 30.007813 0.183594 30.269531 0.046875 30.652344 C -0.0898438 31.035156 0.0195313 31.464844 0.320313 31.734375 C 0.320313 31.734375 6.085938 37 16 37 C 20.921875 37 24.386719 35.953125 27.371094 34.949219 C 30.351563 33.941406 32.8125 33 36 33 C 42.371094 33 48.457031 36.84375 48.457031 36.84375 C 48.925781 37.140625 49.542969 37.007813 49.84375 36.542969 C 50.140625 36.074219 50.007813 35.457031 49.542969 35.15625 C 49.542969 35.15625 43.160156 31 36 31 C 35.242188 31 34.527344 31.054688 33.832031 31.140625 C 33.941406 30.777344 34 30.394531 34 30 C 34 29.214844 33.765625 28.484375 33.375 27.871094 L 33.378906 27.859375 L 24.578125 14.113281 C 24.128906 13.441406 23.367188 13 22.5 13 Z M 40 18 C 37.238281 18 35 20.238281 35 23 C 35 25.761719 37.238281 28 40 28 C 42.761719 28 45 25.761719 45 23 C 45 20.238281 42.761719 18 40 18 Z' }))); }
    },
    {
        id: 4,
        name: 'Training',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 2 C 9.25 2 7 4.25 7 7 C 7 9.75 9.25 12 12 12 C 14.75 12 17 9.75 17 7 C 17 4.25 14.75 2 12 2 Z M 29 2 L 29 4 L 19 4 L 19 6 L 46 6 L 46 32 L 20 32 L 20 34 L 28.5 34 L 23 45 L 25 45 L 30 35 L 35 45 L 37 45 L 31.5 34 L 47 34 C 47.550781 34 48 33.550781 48 33 L 48 5 C 48 4.449219 47.550781 4 47 4 L 31 4 L 31 2 Z M 12 4 C 13.667969 4 15 5.332031 15 7 C 15 8.667969 13.667969 10 12 10 C 10.332031 10 9 8.667969 9 7 C 9 5.332031 10.332031 4 12 4 Z M 7.5 13 C 4.472656 13 2 15.472656 2 18.5 L 2 30.8125 C 1.996094 30.855469 1.996094 30.894531 2 30.9375 L 2 31 C 1.996094 31.09375 2.007813 31.191406 2.03125 31.28125 C 2.179688 32.792969 3.453125 34 5 34 C 5.351563 34 5.683594 33.925781 6 33.8125 L 6 44.5 C 6 46.421875 7.578125 48 9.5 48 C 10.476563 48 11.363281 47.589844 12 46.9375 C 12.636719 47.589844 13.523438 48 14.5 48 C 16.421875 48 18 46.421875 18 44.5 L 18 19 L 29 19 C 30.644531 19 32 17.644531 32 16 C 32 14.375 30.679688 13.035156 29.0625 13 C 29.042969 13 29.019531 13 29 13 L 15 13 C 14.613281 12.996094 14.261719 13.214844 14.09375 13.5625 L 12 17.75 L 9.90625 13.5625 C 9.738281 13.214844 9.386719 12.996094 9 13 Z M 7.5 15 L 8.375 15 L 11.09375 20.4375 C 11.257813 20.789063 11.613281 21.015625 12 21.015625 C 12.386719 21.015625 12.742188 20.789063 12.90625 20.4375 L 15.625 15 L 29 15 C 29.03125 15 29.0625 15 29.09375 15 C 29.613281 15.046875 30 15.46875 30 16 C 30 16.566406 29.566406 17 29 17 L 17 17 C 16.449219 17 16 17.449219 16 18 L 16 44.5 C 16 45.339844 15.339844 46 14.5 46 C 13.710938 46 13.074219 45.421875 13 44.65625 L 13 44.40625 C 13 44.375 13 44.34375 13 44.3125 L 13 34 C 13.011719 33.710938 12.894531 33.433594 12.6875 33.238281 C 12.476563 33.039063 12.191406 32.941406 11.90625 32.96875 C 11.863281 32.976563 11.820313 32.988281 11.78125 33 C 11.316406 33.105469 10.988281 33.523438 11 34 L 11 44.3125 C 10.996094 44.355469 10.996094 44.394531 11 44.4375 L 11 44.65625 C 10.925781 45.421875 10.289063 46 9.5 46 C 8.660156 46 8 45.339844 8 44.5 L 8 21 C 8.007813 20.691406 7.871094 20.398438 7.632813 20.203125 C 7.398438 20.007813 7.082031 19.933594 6.78125 20 C 6.316406 20.105469 5.988281 20.523438 6 21 L 6 30.84375 C 6 30.875 6 30.90625 6 30.9375 L 6 31 C 6 31.566406 5.566406 32 5 32 C 4.457031 32 4.03125 31.597656 4 31.0625 C 4 31.042969 4 31.019531 4 31 C 4.007813 30.9375 4.007813 30.875 4 30.8125 L 4 18.5 C 4 16.554688 5.554688 15 7.5 15 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 12 2 C 9.242188 2 7 4.242188 7 7 C 7 9.757813 9.242188 12 12 12 C 14.757813 12 17 9.757813 17 7 C 17 4.242188 14.757813 2 12 2 Z M 29 2 L 29 4 L 18.3125 4 C 18.746094 4.910156 19 5.925781 19 7 C 19 8.488281 18.542969 9.863281 17.75 11 L 28.5 11 C 30.980469 11 33 13.019531 33 15.5 C 33 17.980469 30.980469 20 28.5 20 L 20 20 L 20 34 L 47 34 C 47.554688 34 48 33.554688 48 33 L 48 5 C 48 4.449219 47.554688 4 47 4 L 31 4 L 31 2 Z M 7.5 13 C 4.46875 13 2 15.46875 2 18.5 L 2 32 C 2 33.105469 2.898438 34 4 34 C 5.101563 34 6 33.105469 6 32 L 6 20.5625 C 6 20.292969 6.230469 20.0625 6.5 20.0625 C 6.769531 20.0625 7 20.292969 7 20.5625 L 7 45.3125 C 7 46.875 7.839844 48 9.40625 48 C 10.886719 48 12 46.851563 12 45.3125 L 12 33.6875 C 12 33.410156 12.222656 33.1875 12.5 33.1875 C 12.777344 33.1875 13 33.410156 13 33.6875 L 13 45.59375 C 13.003906 45.601563 13.027344 45.585938 13.03125 45.59375 C 13.167969 46.976563 14.210938 48 15.59375 48 C 17.15625 48 18 46.875 18 45.3125 L 18 18 L 28.5 18 C 29.882813 18 31 16.882813 31 15.5 C 31 14.117188 29.882813 13 28.5 13 L 15.53125 13 L 12 20 L 8.53125 13 Z M 27.5 36 L 23 45 L 25 45 L 29.5 36 Z M 30.5 36 L 35 45 L 37 45 L 32.5 36 Z' }))); }
    },
    {
        id: 11,
        name: 'Transportation',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22 12 C 20.34375 12 19 13.375 19 15.03125 L 19 16.3125 C 18.496094 16.375 18.039063 16.433594 17.65625 16.5 C 16.269531 16.746094 15.667969 17.03125 15.59375 17.0625 C 15.589844 17.066406 15.46875 17.09375 15.46875 17.09375 C 13.988281 17.59375 11.734375 18.28125 10.6875 20.3125 L 10.6875 20.34375 C 10.433594 20.835938 10.054688 21.804688 9.5 23.21875 C 9.074219 24.304688 8.574219 25.675781 8.0625 27 L 5.09375 27 C 3.609375 27 2.507813 27.496094 1.84375 28.25 C 1.179688 29.003906 1 29.898438 1 30.59375 C 1 31.371094 1.40625 32.148438 2.03125 32.53125 C 2.65625 32.914063 3.355469 33 4.09375 33 L 5.75 33 C 5.59375 33.417969 5.0625 34.8125 5.0625 34.8125 L 5 35 L 5 47 C 5 48.644531 6.355469 50 8 50 L 12 50 C 13.644531 50 15 48.644531 15 47 L 15 46 L 35 46 L 35 47 C 35 48.644531 36.355469 50 38 50 L 42 50 C 43.644531 50 45 48.644531 45 47 L 45 35 L 44.9375 34.8125 C 44.9375 34.8125 44.414063 33.421875 44.25 33 L 45.90625 33 C 46.644531 33 47.34375 32.914063 47.96875 32.53125 C 48.59375 32.148438 49 31.371094 49 30.59375 C 49 29.898438 48.820313 29.003906 48.15625 28.25 C 47.492188 27.496094 46.390625 27 44.90625 27 L 41.9375 27 C 41.875 26.851563 41.8125 26.707031 41.78125 26.625 C 40.699219 23.828125 39.652344 21.164063 39.28125 20.3125 C 38.324219 18.140625 35.863281 17.46875 34.53125 17.09375 C 34.488281 17.082031 34.414063 17.042969 34.375 17.03125 L 34.375 17.0625 C 34.28125 17.023438 33.710938 16.746094 32.34375 16.5 C 31.960938 16.433594 31.503906 16.375 31 16.3125 L 31 15.03125 C 31 13.375 29.65625 12 28 12 Z M 22 14 L 28 14 C 28.550781 14 29 14.4375 29 15.03125 L 29 16.125 C 27.871094 16.050781 26.578125 16 25 16 C 23.421875 16 22.128906 16.050781 21 16.125 L 21 15.03125 C 21 14.4375 21.449219 14 22 14 Z M 25 18 C 28.453125 18 30.671875 18.261719 32 18.5 C 33.328125 18.738281 33.65625 18.90625 33.65625 18.90625 L 33.75 18.9375 L 33.8125 18.96875 C 35.03125 19.316406 36.996094 20.117188 37.4375 21.125 C 37.726563 21.785156 38.863281 24.707031 39.90625 27.375 C 40.15625 28.011719 40.574219 29.050781 40.4375 29.6875 C 40.367188 30.007813 40.246094 30.238281 39.78125 30.5 C 39.316406 30.761719 38.441406 31 37 31 L 13 31 C 11.558594 31 10.683594 30.761719 10.21875 30.5 C 9.753906 30.238281 9.632813 30.007813 9.5625 29.6875 C 9.425781 29.050781 9.84375 28.011719 10.09375 27.375 L 10.03125 27.34375 C 10.488281 26.152344 10.957031 24.917969 11.34375 23.9375 C 11.894531 22.535156 12.386719 21.410156 12.46875 21.25 C 13.023438 20.171875 14.753906 19.4375 16.21875 18.9375 L 16.28125 18.9375 L 16.34375 18.90625 C 16.34375 18.90625 16.671875 18.738281 18 18.5 C 19.328125 18.261719 21.546875 18 25 18 Z M 5.09375 29 L 7.25 29 C 6.871094 29.996094 6.804688 30.191406 6.5 31 L 4.09375 31 C 3.535156 31 3.1875 30.902344 3.09375 30.84375 C 3 30.785156 3 30.875 3 30.59375 C 3 30.230469 3.101563 29.835938 3.34375 29.5625 C 3.585938 29.289063 4.007813 29 5.09375 29 Z M 42.6875 29 L 44.90625 29 C 45.992188 29 46.414063 29.289063 46.65625 29.5625 C 46.898438 29.835938 47 30.230469 47 30.59375 C 47 30.875 47 30.785156 46.90625 30.84375 C 46.8125 30.902344 46.460938 31 45.90625 31 L 43.46875 31 C 43.148438 30.179688 43.078125 30.011719 42.6875 29 Z M 8.4375 31.59375 C 8.667969 31.835938 8.933594 32.070313 9.25 32.25 C 10.152344 32.757813 11.347656 33 13 33 L 37 33 C 38.652344 33 39.847656 32.757813 40.75 32.25 C 41.066406 32.070313 41.332031 31.835938 41.5625 31.59375 C 42.148438 33.132813 42.964844 35.289063 43 35.375 L 43 43.15625 C 43 43.621094 42.609375 44 42.09375 44 L 7.90625 44 C 7.390625 44 7 43.625 7 43.15625 L 7 35.375 C 7.03125 35.289063 7.867188 33.117188 8.4375 31.59375 Z M 11 34 C 9.355469 34 8 35.355469 8 37 C 8 37.886719 8.367188 38.675781 8.875 39.21875 C 9.382813 39.761719 9.996094 40.128906 10.59375 40.46875 C 11.441406 40.949219 12.019531 41.316406 12.6875 41.59375 C 13.355469 41.871094 14.074219 42 15 42 C 17.195313 42 19 40.199219 19 38 C 19 35.800781 17.195313 34 15 34 Z M 35 34 C 32.804688 34 31 35.800781 31 38 C 31 40.199219 32.804688 42 35 42 C 35.925781 42 36.644531 41.871094 37.3125 41.59375 C 37.980469 41.316406 38.558594 40.949219 39.40625 40.46875 C 40.003906 40.128906 40.617188 39.761719 41.125 39.21875 C 41.632813 38.675781 42 37.886719 42 37 C 42 35.355469 40.644531 34 39 34 Z M 11 36 L 15 36 C 16.117188 36 17 36.882813 17 38 C 17 39.117188 16.117188 40 15 40 C 14.25 40 13.878906 39.933594 13.4375 39.75 C 12.996094 39.566406 12.449219 39.21875 11.5625 38.71875 C 11 38.402344 10.585938 38.101563 10.34375 37.84375 C 10.101563 37.585938 10 37.417969 10 37 C 10 36.4375 10.4375 36 11 36 Z M 35 36 L 39 36 C 39.5625 36 40 36.4375 40 37 C 40 37.417969 39.898438 37.585938 39.65625 37.84375 C 39.414063 38.101563 39 38.402344 38.4375 38.71875 C 37.550781 39.21875 37.003906 39.566406 36.5625 39.75 C 36.121094 39.933594 35.75 40 35 40 C 33.882813 40 33 39.117188 33 38 C 33 36.882813 33.882813 36 35 36 Z M 7 45.84375 C 7.289063 45.9375 7.589844 46 7.90625 46 L 13 46 L 13 47 C 13 47.5625 12.5625 48 12 48 L 8 48 C 7.4375 48 7 47.5625 7 47 Z M 43 45.84375 L 43 47 C 43 47.5625 42.5625 48 42 48 L 38 48 C 37.4375 48 37 47.5625 37 47 L 37 46 L 42.09375 46 C 42.410156 46 42.710938 45.9375 43 45.84375 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 22 12 C 20.347656 12 19 13.355469 19 15.03125 L 19 16.3125 C 16.8125 16.582031 15.808594 16.941406 15.53125 17.0625 C 13.980469 17.589844 11.683594 18.378906 10.6875 20.3125 C 10.011719 21.628906 5.566406 33.46875 5.0625 34.8125 L 5 35 L 5 47 C 5 48.652344 6.347656 50 8 50 L 12 50 C 13.652344 50 15 48.652344 15 47 L 15 46 L 35 46 L 35 47 C 35 48.652344 36.347656 50 38 50 L 42 50 C 43.652344 50 45 48.652344 45 47 L 45 35 L 44.9375 34.8125 C 44.832031 34.53125 43.410156 30.816406 42 27.1875 C 41.984375 27.15625 41.980469 27.125 41.96875 27.09375 C 40.796875 24.078125 39.648438 21.152344 39.28125 20.3125 C 38.441406 18.410156 36.128906 17.546875 34.4375 17.0625 C 34.128906 16.933594 33.109375 16.574219 31 16.3125 L 31 15.03125 C 31 13.355469 29.652344 12 28 12 Z M 25 18 C 31.550781 18 33.648438 18.902344 33.65625 18.90625 L 33.8125 18.96875 C 34.566406 19.183594 36.871094 19.835938 37.4375 21.125 C 37.773438 21.886719 38.808594 24.546875 39.90625 27.375 L 40 27.5625 C 40.015625 27.601563 40.011719 27.640625 40.03125 27.6875 C 40.058594 27.757813 40.097656 27.835938 40.125 27.90625 C 40.371094 28.550781 40.640625 29.511719 40.25 30.09375 C 39.847656 30.6875 38.703125 31 37 31 L 13 31 C 11.296875 31 10.085938 30.597656 9.6875 30 C 9.21875 29.304688 9.726563 28.0625 9.96875 27.46875 L 10.0625 27.28125 C 11.222656 24.253906 12.21875 21.734375 12.46875 21.25 C 13.105469 20.015625 14.972656 19.359375 16.21875 18.9375 L 16.3125 18.90625 C 16.332031 18.898438 18.449219 18 25 18 Z M 5.09375 27 C 2.070313 27 1 28.859375 1 30.59375 C 1 31.4375 1.378906 32.796875 3.625 32.96875 C 4.253906 31.300781 5.0625 29.128906 5.875 27 Z M 44.0625 27 C 44.96875 29.339844 45.863281 31.640625 46.375 32.96875 C 48.628906 32.800781 49 31.441406 49 30.59375 C 49 28.859375 47.929688 27 44.90625 27 Z M 11 35 L 15 35 C 16.65625 35 18 36.34375 18 38 C 18 39.65625 16.65625 41 15 41 C 13.324219 41 12.828125 40.574219 11.09375 39.59375 C 9.933594 38.9375 9 38.308594 9 37 C 9 35.894531 9.894531 35 11 35 Z M 35 35 L 39 35 C 40.105469 35 41 35.894531 41 37 C 41 38.308594 40.066406 38.9375 38.90625 39.59375 C 37.175781 40.574219 36.675781 41 35 41 C 33.34375 41 32 39.65625 32 38 C 32 36.34375 33.34375 35 35 35 Z' }))); }
    },
    {
        id: 7,
        name: 'Laptop',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 3 8 A 1.0001 1.0001 0 0 0 2 9 L 2 38 L 1 38 A 1.0001 1.0001 0 0 0 0 39 L 0 41 C 0 42.45797 0.70876816 43.570962 1.5507812 44.183594 C 2.3927944 44.796225 3.2884028 45 4 45 L 46 45 C 47.080199 45 48.110329 44.821981 48.892578 44.117188 C 49.674828 43.412394 50 42.319379 50 41 L 50 39 A 1.0001 1.0001 0 0 0 49 38 L 48 38 L 48 9 A 1.0001 1.0001 0 0 0 47 8 L 3 8 z M 4 10 L 46 10 L 46 38 L 31.167969 38 A 1.0001 1.0001 0 0 0 30.283203 38.289062 A 1.0001 1.0001 0 0 0 30.277344 38.294922 A 1.0001 1.0001 0 0 0 30.263672 38.308594 A 1.0001 1.0001 0 0 0 29.986328 39 L 20.013672 39 A 1.0001 1.0001 0 0 0 19.707031 38.279297 A 1.0001 1.0001 0 0 0 19.705078 38.277344 A 1.0001 1.0001 0 0 0 19.699219 38.271484 A 1.0001 1.0001 0 0 0 19.691406 38.263672 A 1.0001 1.0001 0 0 0 18.984375 37.986328 A 1.0001 1.0001 0 0 0 18.839844 38 L 4 38 L 4 10 z M 27.408203 16.888672 C 26.708203 16.988672 25.908203 17.388281 25.408203 17.988281 C 24.908203 18.588281 24.608594 19.288281 24.808594 19.988281 C 25.608594 19.988281 26.308594 19.588281 26.808594 18.988281 C 27.208594 18.488281 27.508203 17.688672 27.408203 16.888672 z M 22.708984 19.988281 C 21.708984 19.988281 20.709766 20.589844 20.009766 21.589844 C 19.009766 23.089844 19.208984 25.889453 20.708984 28.189453 C 21.208984 29.089453 21.908203 29.988281 22.908203 29.988281 C 23.808203 30.088281 24.008984 29.488281 25.208984 29.488281 C 26.308984 29.388281 26.508203 29.988281 27.408203 29.988281 C 28.308203 29.988281 29.108984 28.889844 29.708984 28.089844 C 30.008984 27.489844 30.209375 27.188281 30.609375 26.488281 C 28.409375 25.588281 28.008984 22.489062 30.208984 21.289062 C 29.508984 20.489063 28.608984 19.988281 27.708984 19.988281 C 26.508984 19.988281 26.008984 20.589844 25.208984 20.589844 C 24.408984 20.589844 23.708984 19.988281 22.708984 19.988281 z M 2 40 L 18 40 A 1.0001 1.0001 0 0 0 19 41 L 31 41 A 1.0001 1.0001 0 0 0 32 40 L 48 40 L 48 41 C 48 42.013621 47.789938 42.420856 47.554688 42.632812 C 47.319437 42.844769 46.849801 43 46 43 L 4 43 C 3.7515972 43 3.1465025 42.870525 2.7285156 42.566406 C 2.3105288 42.262288 2 41.87503 2 41 L 2 40 z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 3 8 A 1.0001 1.0001 0 0 0 2 9 L 2 38 L 1 38 A 1.0001 1.0001 0 0 0 0 39 L 0 41 C 0 42.45797 0.70876816 43.570962 1.5507812 44.183594 C 2.3927944 44.796225 3.2884028 45 4 45 L 46 45 C 47.080199 45 48.110329 44.821981 48.892578 44.117188 C 49.674828 43.412394 50 42.319379 50 41 L 50 39 A 1.0001 1.0001 0 0 0 49 38 L 48 38 L 48 9 A 1.0001 1.0001 0 0 0 47 8 L 3 8 z M 27.408203 18 C 27.508203 18.8 27.208594 19.599609 26.808594 20.099609 C 26.308594 20.699609 25.608594 21.099609 24.808594 21.099609 C 24.608594 20.399609 24.908203 19.699609 25.408203 19.099609 C 25.908203 18.499609 26.708203 18.1 27.408203 18 z M 22.708984 21.099609 C 23.708984 21.099609 24.408984 21.699219 25.208984 21.699219 C 26.008984 21.699219 26.508984 21.099609 27.708984 21.099609 C 28.608984 21.099609 29.508984 21.600391 30.208984 22.400391 C 28.008984 23.600391 28.409375 26.699609 30.609375 27.599609 C 30.209375 28.299609 30.008984 28.599219 29.708984 29.199219 C 29.108984 29.999219 28.308203 31.099609 27.408203 31.099609 C 26.508203 31.099609 26.308984 30.499609 25.208984 30.599609 C 24.008984 30.599609 23.808203 31.199609 22.908203 31.099609 C 21.908203 31.099609 21.208984 30.200781 20.708984 29.300781 C 19.208984 27.000781 19.009766 24.199219 20.009766 22.699219 C 20.709766 21.699219 21.708984 21.099609 22.708984 21.099609 z M 2 40 L 18 40 A 1.0001 1.0001 0 0 0 19 41 L 31 41 A 1.0001 1.0001 0 0 0 32 40 L 47 40 L 48 40 L 48 41 C 48 42.013621 47.789938 42.420856 47.554688 42.632812 C 47.319437 42.844769 46.849801 43 46 43 L 4 43 C 3.7515972 43 3.1465025 42.870525 2.7285156 42.566406 C 2.3105288 42.262288 2 41.87503 2 41 L 2 40 z' }))); }
    },
    {
        id: 6,
        name: 'Library',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 6 4 L 6 39 L 7 39 C 16.734375 39 24.550781 42.894531 24.550781 42.894531 L 25 43.117188 L 25.449219 42.894531 C 25.449219 42.894531 33.265625 39 43 39 L 44 39 L 44 4 L 43 4 C 33.160156 4 25.640625 7.621094 25 7.9375 C 24.359375 7.621094 16.839844 4 7 4 Z M 8 6.089844 C 16.246094 6.324219 22.652344 9.046875 24 9.65625 L 24 40.503906 C 21.871094 39.585938 15.886719 37.300781 8 37.089844 Z M 42 6.089844 L 42 37.089844 C 34.113281 37.300781 28.128906 39.585938 26 40.503906 L 26 9.65625 C 27.347656 9.046875 33.753906 6.324219 42 6.089844 Z M 2 9 L 2 43 L 3 43 C 15.792969 43 24.59375 46.914063 24.59375 46.914063 L 25 47.09375 L 25.40625 46.914063 C 25.40625 46.914063 34.207031 43 47 43 L 48 43 L 48 9 L 46 9 L 46 41.070313 C 33.800781 41.277344 25.558594 44.710938 25 44.953125 C 24.441406 44.710938 16.199219 41.277344 4 41.070313 L 4 9 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 6 4 L 6 8 L 2 8 L 2 43 L 3 43 C 15.613281 43 24.507813 46.875 24.59375 46.914063 L 25 47.09375 L 25.40625 46.914063 C 25.492188 46.875 34.386719 43 47 43 L 48 43 L 48 8 L 44 8 L 44 4 L 43 4 C 33.160156 4 25.640625 7.621094 25 7.9375 C 24.359375 7.621094 16.839844 4 7 4 Z M 8 6.089844 C 16.246094 6.324219 22.652344 9.046875 24 9.65625 L 24 40.503906 C 21.871094 39.585938 15.886719 37.300781 8 37.089844 Z M 42 6.089844 L 42 37.089844 C 34.113281 37.300781 28.128906 39.585938 26 40.503906 L 26 9.65625 C 27.347656 9.046875 33.753906 6.324219 42 6.089844 Z' }))); }
    },
    {
        id: 9,
        name: 'Travel',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 46.40625 0.1875 C 46.085938 0.210938 45.757813 0.277344 45.4375 0.34375 C 44.15625 0.617188 42.78125 1.210938 41.4375 1.90625 C 38.765625 3.289063 36.34375 5.039063 35.3125 6.125 L 35.28125 6.125 L 28.53125 12.84375 L 4.53125 9.59375 C 4.214844 9.558594 3.902344 9.675781 3.6875 9.90625 L 0.28125 13.40625 C 0.0507813 13.644531 -0.0507813 13.984375 0.0195313 14.308594 C 0.0898438 14.636719 0.316406 14.90625 0.625 15.03125 L 19.125 22.28125 L 9.59375 32 L 5 32 C 4.757813 32 4.523438 32.089844 4.34375 32.25 L 0.34375 35.625 C 0.046875 35.867188 -0.0859375 36.253906 0 36.625 C 0.0859375 37 0.378906 37.289063 0.75 37.375 L 10.28125 39.71875 L 12.625 49.25 C 12.710938 49.585938 12.96875 49.851563 13.296875 49.953125 C 13.628906 50.054688 13.988281 49.976563 14.25 49.75 L 17.65625 46.75 C 17.875 46.5625 18 46.289063 18 46 L 18 40.40625 L 27.8125 30.875 L 34.96875 49.375 C 35.09375 49.683594 35.363281 49.910156 35.691406 49.980469 C 36.015625 50.050781 36.355469 49.949219 36.59375 49.71875 L 40.09375 46.3125 C 40.324219 46.097656 40.441406 45.785156 40.40625 45.46875 L 37.15625 21.46875 L 43.90625 14.71875 C 44.945313 13.679688 46.707031 11.203125 48.09375 8.53125 C 48.789063 7.195313 49.382813 5.835938 49.65625 4.5625 C 49.929688 3.289063 49.933594 1.945313 49.03125 1 C 49.019531 0.988281 49.011719 0.980469 49 0.96875 C 48.527344 0.515625 47.957031 0.296875 47.34375 0.21875 C 47.039063 0.179688 46.726563 0.164063 46.40625 0.1875 Z M 46.5 2.21875 C 47.070313 2.179688 47.402344 2.296875 47.5625 2.4375 C 47.753906 2.652344 47.894531 3.191406 47.6875 4.15625 C 47.476563 5.136719 46.957031 6.386719 46.3125 7.625 C 45.023438 10.105469 43.164063 12.617188 42.5 13.28125 L 35.40625 20.40625 C 35.183594 20.613281 35.070313 20.914063 35.09375 21.21875 L 38.34375 45.25 L 36.3125 47.21875 L 29.125 28.75 C 29.007813 28.4375 28.738281 28.203125 28.414063 28.125 C 28.085938 28.050781 27.742188 28.144531 27.5 28.375 L 16.3125 39.28125 C 16.113281 39.46875 16.003906 39.726563 16 40 L 16 45.5625 L 14.15625 47.15625 L 12.0625 38.65625 C 11.972656 38.304688 11.695313 38.027344 11.34375 37.9375 L 3.125 35.90625 L 5.375 34 L 10 34 C 10.273438 33.996094 10.53125 33.886719 10.71875 33.6875 L 21.625 22.59375 C 21.855469 22.351563 21.949219 22.007813 21.875 21.679688 C 21.796875 21.355469 21.5625 21.085938 21.25 20.96875 L 2.78125 13.71875 L 4.75 11.65625 L 28.78125 14.90625 C 29.085938 14.929688 29.386719 14.816406 29.59375 14.59375 L 36.71875 7.5 C 37.296875 6.886719 39.851563 4.976563 42.34375 3.6875 C 43.589844 3.042969 44.855469 2.523438 45.84375 2.3125 C 46.085938 2.261719 46.308594 2.230469 46.5 2.21875 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 46.78125 0.1875 C 43.019531 0.1875 36.601563 4.6875 35.28125 6.09375 L 28.53125 12.84375 L 4.53125 9.59375 C 4.21875 9.550781 3.910156 9.679688 3.6875 9.90625 L 0.28125 13.40625 C 0.046875 13.644531 -0.0390625 13.984375 0.03125 14.3125 C 0.101563 14.640625 0.3125 14.910156 0.625 15.03125 L 19.125 22.28125 L 9.59375 32 L 5 32 C 4.761719 32 4.523438 32.09375 4.34375 32.25 L 0.34375 35.625 C 0.0585938 35.867188 -0.0546875 36.261719 0.03125 36.625 C 0.117188 36.988281 0.386719 37.285156 0.75 37.375 L 10.28125 39.71875 L 12.625 49.25 C 12.710938 49.589844 12.976563 49.863281 13.3125 49.96875 C 13.644531 50.074219 13.988281 49.980469 14.25 49.75 L 17.65625 46.75 C 17.871094 46.558594 18 46.285156 18 46 L 18 40.4375 L 27.8125 30.875 L 34.96875 49.375 C 35.089844 49.6875 35.359375 49.898438 35.6875 49.96875 C 35.757813 49.984375 35.835938 50 35.90625 50 C 36.164063 50 36.40625 49.902344 36.59375 49.71875 L 40.09375 46.3125 C 40.320313 46.089844 40.449219 45.78125 40.40625 45.46875 L 37.15625 21.46875 L 43.90625 14.71875 C 45.289063 13.335938 52.070313 4.175781 49 0.96875 C 48.457031 0.449219 47.707031 0.1875 46.78125 0.1875 Z' }))); }
    },
    {
        id: 13,
        name: 'Vouchers',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 33 0.0625 C 32.28125 0.0625 31.582031 0.367188 31.03125 0.90625 L 31 0.875 L 25.09375 6.71875 C 24.933594 6.816406 24.804688 6.957031 24.71875 7.125 L 0.78125 30.875 C 0.78125 30.886719 0.78125 30.894531 0.78125 30.90625 C -0.324219 32.011719 -0.324219 33.800781 0.78125 34.90625 L 3.90625 38 C 4.257813 38.355469 4.820313 38.394531 5.21875 38.09375 C 6.078125 37.40625 7.199219 36.90625 8.3125 36.90625 C 10.972656 36.90625 13 39.03125 13 41.59375 C 13 42.753906 12.578125 43.808594 11.84375 44.625 C 11.496094 45.027344 11.523438 45.632813 11.90625 46 L 15 49.09375 C 16.105469 50.199219 17.894531 50.199219 19 49.09375 L 42.6875 25.4375 C 43.078125 25.34375 43.375 25.023438 43.4375 24.625 L 49 19.09375 C 49.039063 19.066406 49.058594 19.03125 49.09375 19 C 50.296875 17.992188 50.292969 16.167969 49.21875 15.09375 L 46.09375 12 C 45.742188 11.644531 45.179688 11.605469 44.78125 11.90625 C 43.925781 12.589844 42.972656 13 41.8125 13 C 39.152344 13 37.09375 10.875 37.09375 8.3125 C 37.09375 7.152344 37.503906 6.167969 38.1875 5.3125 C 38.488281 4.914063 38.449219 4.351563 38.09375 4 L 35 0.90625 C 34.449219 0.355469 33.726563 0.0625 33 0.0625 Z M 33 2.09375 C 33.222656 2.09375 33.445313 2.164063 33.59375 2.3125 L 36.15625 4.875 C 35.546875 5.875 35.09375 7.019531 35.09375 8.3125 C 35.09375 11.949219 38.070313 15 41.8125 15 C 43.109375 15 44.21875 14.546875 45.21875 13.9375 L 47.78125 16.5 C 48.078125 16.796875 48.101563 17.285156 47.8125 17.5 C 47.769531 17.527344 47.726563 17.558594 47.6875 17.59375 L 42.34375 22.9375 C 42.140625 22.753906 41.867188 22.664063 41.59375 22.6875 C 41.21875 22.722656 40.898438 22.964844 40.757813 23.316406 C 40.621094 23.664063 40.6875 24.0625 40.9375 24.34375 L 17.59375 47.6875 C 17.296875 47.984375 16.703125 47.984375 16.40625 47.6875 L 13.84375 45.125 C 14.523438 44.078125 15 42.890625 15 41.59375 C 15 37.957031 12.054688 34.90625 8.3125 34.90625 C 6.972656 34.90625 5.796875 35.421875 4.78125 36.0625 L 2.21875 33.5 C 1.921875 33.203125 1.921875 32.609375 2.21875 32.3125 L 25.625 9.03125 C 26.011719 9.429688 26.648438 9.433594 27.046875 9.046875 C 27.445313 8.660156 27.449219 8.023438 27.0625 7.625 L 32.40625 2.3125 C 32.554688 2.164063 32.777344 2.09375 33 2.09375 Z M 28.96875 10.125 L 28.21875 10.625 L 28.1875 11.53125 L 28.40625 11.8125 L 29.78125 13.21875 L 30.65625 13.5 L 31.375 12.96875 L 31.40625 12.09375 L 31.21875 11.78125 L 29.8125 10.40625 Z M 33.15625 14.3125 L 32.4375 14.84375 L 32.40625 15.71875 L 32.59375 16.03125 L 34 17.4375 L 34.84375 17.71875 L 35.59375 17.1875 L 35.625 16.3125 L 35.4375 16 L 34.03125 14.59375 Z M 37.375 18.53125 L 36.65625 19.03125 L 36.625 19.9375 L 36.8125 20.21875 L 38.21875 21.625 L 39.0625 21.90625 L 39.8125 21.40625 L 39.84375 20.5 L 39.625 20.21875 L 38.21875 18.8125 Z M 27.40625 19 L 22.8125 23 L 17.3125 20.5 L 19.6875 26.09375 L 15.59375 30.59375 L 21.59375 30.09375 L 24.59375 35.40625 L 25.90625 29.5 L 31.8125 28.3125 L 26.59375 25.1875 Z M 24.8125 24 L 24.6875 24.90625 L 24.5 26.1875 L 25.59375 26.90625 L 26.40625 27.3125 L 25.5 27.5 L 24.1875 27.8125 L 24 28.90625 L 23.8125 29.8125 L 23.3125 29 L 22.6875 27.90625 L 21.40625 28 L 20.5 28.09375 L 21.09375 27.5 L 22 26.5 L 21.5 25.3125 L 21.1875 24.5 L 22 24.90625 L 23.1875 25.40625 L 24.1875 24.5 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 49.207031 15.09375 L 46.105469 11.992188 C 45.746094 11.632813 45.171875 11.601563 44.773438 11.917969 C 43.878906 12.636719 42.878906 13 41.800781 13 C 39.207031 13 37.101563 10.890625 37.101563 8.300781 C 37.101563 7.222656 37.464844 6.222656 38.179688 5.324219 C 38.5 4.925781 38.46875 4.351563 38.109375 3.992188 L 35.007813 0.894531 C 33.953125 -0.164063 32.046875 -0.160156 30.996094 0.890625 L 25.632813 6.21875 L 27.007813 7.59375 C 27.398438 7.984375 27.398438 8.617188 27.007813 9.007813 C 26.8125 9.203125 26.554688 9.300781 26.300781 9.300781 C 26.042969 9.300781 25.789063 9.203125 25.59375 9.007813 L 24.214844 7.628906 L 0.792969 30.894531 C 0.265625 31.421875 -0.0234375 32.132813 -0.0234375 32.898438 C -0.0234375 33.667969 0.265625 34.378906 0.792969 34.90625 L 3.894531 38.007813 C 4.253906 38.367188 4.824219 38.402344 5.226563 38.082031 C 6.175781 37.320313 7.269531 36.898438 8.300781 36.898438 C 10.890625 36.898438 13 39.007813 13 41.597656 C 13 42.734375 12.59375 43.8125 11.855469 44.628906 C 11.5 45.027344 11.515625 45.628906 11.894531 46.007813 L 14.992188 49.105469 C 15.519531 49.632813 16.234375 49.925781 17 49.925781 C 17.765625 49.925781 18.480469 49.632813 19.007813 49.105469 L 42.351563 25.761719 L 40.992188 24.40625 C 40.601563 24.015625 40.601563 23.382813 40.992188 22.992188 C 41.386719 22.601563 42.015625 22.601563 42.40625 22.992188 L 43.765625 24.347656 L 49.0625 19.050781 C 49.613281 18.609375 49.957031 17.953125 50.007813 17.234375 C 50.0625 16.4375 49.769531 15.65625 49.207031 15.09375 Z M 28.394531 10.394531 C 28.785156 10.003906 29.414063 10.003906 29.808594 10.394531 L 31.210938 11.796875 C 31.601563 12.1875 31.601563 12.820313 31.210938 13.210938 C 31.015625 13.40625 30.761719 13.503906 30.503906 13.503906 C 30.246094 13.503906 29.992188 13.40625 29.796875 13.210938 L 28.394531 11.808594 C 28.003906 11.417969 28.003906 10.785156 28.394531 10.394531 Z M 25.898438 29.5 L 24.601563 35.398438 L 21.601563 30.097656 L 15.601563 30.597656 L 19.699219 26.097656 L 17.300781 20.5 L 22.800781 23 L 27.402344 19 L 26.601563 25.199219 L 31.800781 28.300781 Z M 35.421875 17.421875 C 35.226563 17.617188 34.972656 17.714844 34.714844 17.714844 C 34.460938 17.714844 34.203125 17.617188 34.007813 17.421875 L 32.605469 16.019531 C 32.214844 15.628906 32.214844 14.992188 32.605469 14.605469 C 32.996094 14.214844 33.628906 14.214844 34.019531 14.605469 L 35.421875 16.007813 C 35.8125 16.398438 35.8125 17.03125 35.421875 17.421875 Z M 39.632813 21.632813 C 39.4375 21.828125 39.183594 21.925781 38.925781 21.925781 C 38.671875 21.925781 38.414063 21.828125 38.21875 21.632813 L 36.816406 20.230469 C 36.425781 19.839844 36.425781 19.207031 36.816406 18.816406 C 37.207031 18.425781 37.839844 18.425781 38.230469 18.816406 L 39.632813 20.21875 C 40.023438 20.609375 40.023438 21.242188 39.632813 21.632813 Z' }))); }
    },
    {
        id: 15,
        name: 'Others',
        icon: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 8 20 C 4.699219 20 2 22.699219 2 26 C 2 29.300781 4.699219 32 8 32 C 11.300781 32 14 29.300781 14 26 C 14 22.699219 11.300781 20 8 20 Z M 25 20 C 21.699219 20 19 22.699219 19 26 C 19 29.300781 21.699219 32 25 32 C 28.300781 32 31 29.300781 31 26 C 31 22.699219 28.300781 20 25 20 Z M 42 20 C 38.699219 20 36 22.699219 36 26 C 36 29.300781 38.699219 32 42 32 C 45.300781 32 48 29.300781 48 26 C 48 22.699219 45.300781 20 42 20 Z M 8 22 C 10.222656 22 12 23.777344 12 26 C 12 28.222656 10.222656 30 8 30 C 5.777344 30 4 28.222656 4 26 C 4 23.777344 5.777344 22 8 22 Z M 25 22 C 27.222656 22 29 23.777344 29 26 C 29 28.222656 27.222656 30 25 30 C 22.777344 30 21 28.222656 21 26 C 21 23.777344 22.777344 22 25 22 Z M 42 22 C 44.222656 22 46 23.777344 46 26 C 46 28.222656 44.222656 30 42 30 C 39.777344 30 38 28.222656 38 26 C 38 23.777344 39.777344 22 42 22 Z' }))); },
        iconActive: function () { return (react.createElement("svg", { fill: 'currentColor', className: 'benefit-icons', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '24px', height: '24px' },
            react.createElement("path", { d: 'M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z' }))); }
    }
];


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelectV2/vi.json.js
'use client';

var Awards = "Giải thưởng";
var Bonus = "Thưởng";
var Canteen = "Căn-tin";
var Kindergarten = "Trông trẻ";
var Mobile = "Điện thoại";
var Training = "Đào tạo";
var Transportation = "Trợ cấp đi lại";
var Library = "Thư viện";
var Travel = "Du lịch";
var Vouchers = "Thưởng quà";
var Others = "Khác";
var viLang = {
	Awards: Awards,
	Bonus: Bonus,
	Canteen: Canteen,
	"Healthcare Plan": "Khám sức khoẻ",
	Kindergarten: Kindergarten,
	Mobile: Mobile,
	"Paid Leave": "Nghỉ phép",
	"Team Activities": "Hoạt động nhóm",
	Training: Training,
	Transportation: Transportation,
	Library: Library,
	Travel: Travel,
	Vouchers: Vouchers,
	Others: Others
};


//# sourceMappingURL=vi.json.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelectV2/helper.js
'use client';



var t = function (key, langCode) {
    if (langCode === 'en')
        return key;
    if (typeof viLang[key] === 'undefined')
        return key;
    return viLang[key];
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/MultiTagSelectV2/index.js
'use client';







var MultiTagSelectV2_MultiTagSelect = function (_a) {
    var _b = _a.numOfColumns, numOfColumns = _b === void 0 ? 3 : _b, _c = _a.langCode, langCode = _c === void 0 ? 'vi' : _c, _d = _a.values, values = _d === void 0 ? [] : _d, onChange = _a.onChange, _e = _a.maxSelect, maxSelect = _e === void 0 ? 0 : _e, _f = _a.readonly, readonly = _f === void 0 ? false : _f, customTag = _a.customTag;
    var _g = (0,react.useState)(values), benefits = _g[0], setBenefit = _g[1];
    var handleChange = function (value) {
        if (readonly)
            return;
        var cpBenefits = (0,_tslib/* __spreadArray */.ev)([], benefits, true);
        if (cpBenefits.includes(value)) {
            var result = cpBenefits.filter(function (benefit) { return benefit !== value; });
            setBenefit(result);
            onChange(result);
            return;
        }
        if (maxSelect && cpBenefits.length >= maxSelect)
            return;
        cpBenefits.push(value);
        setBenefit(cpBenefits);
        onChange(cpBenefits);
    };
    (0,react.useEffect)(function () {
        setBenefit(values);
    }, [values]);
    return (react.createElement(Container, { columns: String(numOfColumns), readonly: readonly }, constant_listBenefits.map(function (_a) {
        var id = _a.id, icon = _a.icon, iconActive = _a.iconActive, name = _a.name;
        var isActive = benefits.includes(id);
        return (customTag || (react.createElement(BenefitCard, { key: name, isActive: isActive, onClick: function () { return handleChange(id); } },
            isActive ? iconActive() : icon(),
            react.createElement("p", null, t(name, langCode)))));
    })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/NoResult/icons.js
'use client';




function IconNoResultInterview(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 250, height: 98, viewBox: '0 0 423 182' }, props),
        react.createElement("defs", null,
            react.createElement("path", { id: 'prefix__a', d: 'M0 0h123v87H0z' })),
        react.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react.createElement("path", { fill: '#D7D7D7', d: 'M277.532 18.266l-1.529-3.708 2.947-1.216 1.529 3.708zM251.034 10.782l.165-2.962 2.354.133-.165 2.962zM293.704 26.953l2.198 1.992-1.585 1.746-2.198-1.992z' }),
            react.createElement("path", { fill: '#E5E7EB', opacity: 0.189, d: 'M294.532 22.14l-1.939-2.245 1.785-1.54 1.94 2.246z' }),
            react.createElement("path", { fill: '#B8E7F8', d: 'M279.292 43.234l4.741 2.19-1.804 3.912-4.742-2.19z' }),
            react.createElement("path", { fill: '#D7D7D7', d: 'M110.25 83.914l3.054-2.6 2.067 2.428-3.055 2.6z' }),
            react.createElement("path", { fill: '#FFF', d: 'M130.841 169.096l1.024-2.784 2.212.815-1.023 2.784z' }),
            react.createElement("path", { fill: '#B8E7F8', d: 'M116.856 107.639l4.603-2.47 2.039 3.796-4.603 2.47z' }),
            react.createElement("g", { transform: 'translate(144 25)' },
                react.createElement("mask", { id: 'prefix__b', fill: '#fff' },
                    react.createElement("use", { xlinkHref: '#prefix__a' })),
                react.createElement("path", { d: 'M60.468 20.936h45.067v-3.461H60.468v3.461zM83 43.256h22.535V39.79H83v3.465zm22.535-11.157H66.189c1.526 2.378 2.422 5.162 2.422 8.15v15.04h28.566C110.275 55.942 123 67 123 67c-4.092-9.975-4.092-23.64-4.092-23.64-.082.241 0-1.044 0-1.946V13.875c0-7.662-6.51-13.875-14.544-13.875h-46.82C49.515 0 43 6.213 43 13.875v10.696h9.177c4.232 0 8.083 1.547 11 4.063h42.358V32.1z', fillOpacity: 0.389, fill: '#C2C2C2', mask: 'url(#prefix__b)' }),
                react.createElement("path", { d: 'M63 32a19.586 19.586 0 00-2-1v1h2z', fill: '#B8E7F8', mask: 'url(#prefix__b)' }),
                react.createElement("path", { d: 'M59.743 59.795c0 4.006-3.374 7.263-7.526 7.263l-27.806.004c-4.982.25-9.804 2.4-13.425 4.527a63.42 63.42 0 001.017-10.14c.035-.318.027-.643.016-.977a22.872 22.872 0 01-.014-.677V40.341c0-4.008 3.377-7.268 7.529-7.268h32.683c4.152 0 7.526 3.26 7.526 7.268v19.454zm2.027-27.626h-1.337V30.9A12.996 12.996 0 0052.217 28H19.534c-7.05 0-12.782 5.535-12.782 12.341v19.454l.001.172-.001 1.2c0 .092-.041 9.273-2.676 15.778L0 87l8.29-7.258c.082-.07 8.324-7.207 16.258-7.61h27.669C59.264 72.132 65 66.595 65 59.795V40.341c0-3.136-1.228-5.992-3.23-8.172z', fillOpacity: 0.764, fill: '#B8E7F8', mask: 'url(#prefix__b)' }),
                react.createElement("path", { fill: '#B8E7F8', mask: 'url(#prefix__b)', d: 'M19 43h34v-3H19zM19 52h34v-3H19zM19 60h17v-3H19z' })),
            react.createElement("ellipse", { fill: '#C2C2C2', fillRule: 'nonzero', opacity: 0.125, transform: 'rotate(-1 211.5 126.667)', cx: 211.5, cy: 126.667, rx: 210.5, ry: 34 }),
            react.createElement("g", { transform: 'translate(205 83)' },
                react.createElement("circle", { fill: '#B8E7F8', fillRule: 'nonzero', cx: 40, cy: 26, r: 19 }),
                react.createElement("path", { d: 'M49.518 48.157a6.955 6.955 0 019.824.515l15.71 17.457a6.962 6.962 0 01-.515 9.83 6.955 6.955 0 01-9.824-.516l-15.71-17.457a6.962 6.962 0 01.515-9.829z', fill: '#B8E7F8', fillRule: 'nonzero' }),
                react.createElement("path", { d: 'M49.23 55.764a6.085 6.085 0 018.596.45l15.71 17.457a6.091 6.091 0 01-.45 8.6 6.085 6.085 0 01-8.596-.45L48.78 64.364a6.091 6.091 0 01.45-8.6z', stroke: '#C2C2C2', strokeWidth: 2.2 }),
                react.createElement("g", { fillRule: 'nonzero' },
                    react.createElement("circle", { fill: '#FFF', cx: 28, cy: 28, r: 28 }),
                    react.createElement("circle", { stroke: '#C2C2C2', strokeWidth: 2.2, fill: '#FFF', cx: 28.438, cy: 28.438, r: 23.188 }),
                    react.createElement("circle", { fill: '#B8E7F8', cx: 29.75, cy: 25.375, r: 14 }),
                    react.createElement("circle", { fill: '#FFF', cx: 32.375, cy: 21.875, r: 8.75 }))))));
}
function IconNoResultJobs(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 250, height: 98, viewBox: '0 0 423 182' }, props),
        react.createElement("defs", null,
            react.createElement("path", { d: 'M1.732 0h58.535C61.224 0 62 .776 62 1.732v76.535c0 .957-.776 1.733-1.733 1.733H1.733A1.733 1.733 0 010 78.267V1.733C0 .776.776 0 1.732 0z', id: 'prefix__b' }),
            react.createElement("path", { d: 'M2.475 0h79.05A2.475 2.475 0 0184 2.475v104.05A2.475 2.475 0 0181.525 109H2.475A2.475 2.475 0 010 106.525V2.475A2.475 2.475 0 012.475 0z', id: 'prefix__d' }),
            react.createElement("path", { id: 'prefix__e', d: 'M0 0h22v22H0z' }),
            react.createElement("filter", { x: '-40.4%', y: '-18.8%', width: '180.9%', height: '162.7%', filterUnits: 'objectBoundingBox', id: 'prefix__a' },
                react.createElement("feMorphology", { radius: 0.578, operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dy: 10, in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: 6.5, in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387 0 0 0 0 0.540303432 0 0 0 0 0.621678359 0 0 0 0.0983355978 0', in: 'shadowBlurOuter1' })),
            react.createElement("filter", { x: '-43.2%', y: '-20.5%', width: '186.5%', height: '166.7%', filterUnits: 'objectBoundingBox', id: 'prefix__c' },
                react.createElement("feMorphology", { radius: 0.825, operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dy: 14, in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: 9.5, in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387 0 0 0 0 0.540303432 0 0 0 0 0.621678359 0 0 0 0.0983355978 0', in: 'shadowBlurOuter1' }))),
        react.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react.createElement("ellipse", { fill: '#C2C2C2', fillRule: 'nonzero', opacity: 0.125, transform: 'rotate(-1 211.5 121)', cx: 211.5, cy: 121, rx: 210.5, ry: 34 }),
            react.createElement("g", { transform: 'translate(207 20)' },
                react.createElement("use", { fill: '#000', filter: 'url(#prefix__a)', xlinkHref: '#prefix__b' }),
                react.createElement("path", { strokeOpacity: 0.105, stroke: '#C9D1DB', strokeWidth: 0.578, d: 'M60.267-.289c.559 0 1.064.226 1.43.592.366.366.592.871.592 1.43h0v76.534c0 .559-.226 1.064-.592 1.43a2.015 2.015 0 01-1.43.592h0H1.733a2.015 2.015 0 01-1.429-.592 2.015 2.015 0 01-.592-1.43h0V1.733c0-.559.226-1.064.592-1.43a2.015 2.015 0 011.43-.592h0z', fill: '#FFF' })),
            react.createElement("path", { d: 'M260.5 25c-1.1 0-2 .787-2 1.75v.438h-1c-.3 0-.5.175-.5.437v3.938c0 .262.2.437.5.437h6c.3 0 .5-.175.5-.438v-3.937c0-.263-.2-.438-.5-.438h-1v-.437c0-.963-.9-1.75-2-1.75zm.5 5.119v.568h-1v-.568a.837.837 0 01-.5-.744c0-.481.45-.875 1-.875s1 .394 1 .875c0 .306-.2.613-.5.744zm.5-2.932h-2v-.437c0-.481.45-.875 1-.875s1 .394 1 .875v.438z', fill: '#E5E7EB', fillRule: 'nonzero' }),
            react.createElement("path", { fill: '#E5E7EB', d: 'M218 65h40v2h-40zM218 70h40v2h-40zM218 75h40v2h-40zM218 81h40v2h-40zM229 86h18v2h-18z' }),
            react.createElement("g", null,
                react.createElement("path", { fill: '#D7D7D7', d: 'M277.532 20.266l-1.529-3.708 2.947-1.216 1.529 3.708zM251.034 12.782l.165-2.962 2.354.133-.165 2.962zM293.704 28.953l2.198 1.992-1.585 1.746-2.198-1.992z' }),
                react.createElement("path", { fill: '#E5E7EB', opacity: 0.189, d: 'M294.532 24.14l-1.939-2.245 1.785-1.54 1.94 2.246z' }),
                react.createElement("path", { fill: '#B8E7F8', d: 'M279.292 45.234l4.741 2.19-1.804 3.912-4.742-2.19z' }),
                react.createElement("path", { fill: '#D7D7D7', d: 'M110.25 85.914l3.054-2.6 2.067 2.428-3.055 2.6z' }),
                react.createElement("path", { fill: '#FFF', d: 'M130.841 171.096l1.024-2.784 2.212.815-1.023 2.784z' }),
                react.createElement("path", { fill: '#B8E7F8', d: 'M116.856 109.639l4.603-2.47 2.039 3.796-4.603 2.47z' })),
            react.createElement("g", null,
                react.createElement("g", { transform: 'translate(141 33)' },
                    react.createElement("use", { fill: '#000', filter: 'url(#prefix__c)', xlinkHref: '#prefix__d' }),
                    react.createElement("path", { strokeOpacity: 0.105, stroke: '#C9D1DB', strokeWidth: 0.825, d: 'M81.525-.412c.797 0 1.52.323 2.042.845.522.523.846 1.245.846 2.042h0v104.05c0 .797-.324 1.52-.846 2.042a2.878 2.878 0 01-2.042.846h0-79.05c-.797 0-1.52-.324-2.042-.846a2.878 2.878 0 01-.845-2.042h0V2.475c0-.797.323-1.52.845-2.042a2.878 2.878 0 012.042-.845h0z', fill: '#FFF' })),
                react.createElement("path", { d: 'M215.5 40c-1.1 0-2 .9-2 2v.5h-1c-.3 0-.5.2-.5.5v4.5c0 .3.2.5.5.5h6c.3 0 .5-.2.5-.5V43c0-.3-.2-.5-.5-.5h-1V42c0-1.1-.9-2-2-2zm.5 5.85v.65h-1v-.65c-.3-.15-.5-.5-.5-.85 0-.55.45-1 1-1s1 .45 1 1c0 .35-.2.7-.5.85zm.5-3.35h-2V42c0-.55.45-1 1-1s1 .45 1 1v.5z', fill: '#E5E7EB', fillRule: 'nonzero' }),
                react.createElement("path", { fill: '#E5E7EB', d: 'M154 94h58v2h-58zM154 102h58v2h-58zM154 109h58v2h-58zM154 117h58v2h-58zM170 124h26v2h-26z' })),
            react.createElement("path", { d: 'M185.554 77.06c.375.494.806.942 1.286 1.329l-2.28 2.316a.893.893 0 01-1.29 0 .932.932 0 010-1.312l2.284-2.333zm5.903-8.304c-.276 0-.5.228-.5.51 0 .28.224.509.5.509 1.02 0 1.94.618 2.34 1.575a.499.499 0 00.657.269.513.513 0 00.264-.668 3.54 3.54 0 00-3.261-2.195zm0-.93c2.457 0 4.457 2.037 4.457 4.54s-2 4.54-4.457 4.54c-2.458 0-4.457-2.037-4.457-4.54s2-4.54 4.457-4.54zm0-1.018c-3.009 0-5.457 2.493-5.457 5.558s2.448 5.559 5.457 5.559 5.457-2.494 5.457-5.559-2.448-5.558-5.457-5.558zm.043-1.02c2.315 0 4.35 1.238 5.5 3.097.634 1.024 1 2.23 1 3.525a6.668 6.668 0 01-1.375 4.064c-1.185 1.553-3.04 2.556-5.125 2.556-1.29 0-2.49-.382-3.5-1.044a6.557 6.557 0 01-1.62-1.502 5.214 5.214 0 01-.395-.58 6.542 6.542 0 01-.905-2.475 6.211 6.211 0 01-.08-1.02c0-3.651 2.915-6.62 6.5-6.62zm-9.5 0h2v-3.055h-2v3.055zm-13-3.717l12 2.766v.951c0 .56.45 1.02 1 1.02h2c.55 0 1-.46 1-1.02v-.951l12-2.766v5.154c-1.37-1.507-3.33-2.455-5.5-2.455-4.135 0-7.5 3.427-7.5 7.64h-13.5c-.275 0-.5.229-.5.509s.225.51.5.51h13.57c.09.717.285 1.4.56 2.036H169.5a.506.506 0 01-.5-.51V62.072zm26.5-6.978c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.277 0-.5.228-.5.51v1.018c0 .282.223.51.5.51.276 0 .5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2.5 0c-.276 0-.5.228-.5.51v1.018c0 .282.224.51.5.51s.5-.228.5-.51v-1.018a.505.505 0 00-.5-.51zm-2-1.019h29c.275 0 .5.23.5.51v.51c-.276 0-.5.227-.5.509v1.018c0 .282.224.51.5.51v2.444a1.516 1.516 0 01-1.17 1.493L185 63.788v-1.055c0-.56-.45-1.02-1-1.02h-2c-.55 0-1 .46-1 1.02v1.054l-11.83-2.72a1.516 1.516 0 01-1.17-1.493v-2.443c.276 0 .5-.228.5-.51v-1.018a.505.505 0 00-.5-.51v-.51c0-.28.225-.509.5-.509zm11.535-3.055h5.93c.167 0 .323.084.415.226l1.186 1.811h-9.132l1.185-1.81a.498.498 0 01.416-.227zm0-1.019c-.503 0-.97.254-1.248.68l-1.554 2.376H168.5c-.825 0-1.5.687-1.5 1.528v4.991c0 .83.38 1.574 1 2.038v13.343c0 .84.675 1.528 1.5 1.528h15.21l-2.15 2.185a1.985 1.985 0 000 2.76c.374.378.865.571 1.355.571s.98-.193 1.354-.57l2.29-2.339c.04-.04.076-.075.106-.121a7.308 7.308 0 003.835 1.08c4.135 0 7.5-3.428 7.5-7.64a7.698 7.698 0 00-1-3.805v-6.992c.62-.464 1-1.208 1-2.038v-4.991c0-.84-.675-1.528-1.5-1.528h-8.733l-1.554-2.375a1.491 1.491 0 00-1.248-.681h-5.93z', fill: '#C2C2C2' }),
            react.createElement("g", { transform: 'translate(227 33)' },
                react.createElement("mask", { id: 'prefix__f', fill: '#fff' },
                    react.createElement("use", { xlinkHref: '#prefix__e' })),
                react.createElement("path", { d: 'M12.756 18.604c.258.34.554.648.884.913l-1.568 1.593a.615.615 0 01-.887 0 .643.643 0 010-.903l1.571-1.603zm4.058-5.71a.347.347 0 00-.343.35c0 .194.153.35.343.35.702 0 1.334.426 1.61 1.084a.343.343 0 00.45.185.352.352 0 00.182-.46 2.433 2.433 0 00-2.242-1.508zm0-.639c1.69 0 3.064 1.4 3.064 3.122 0 1.72-1.375 3.121-3.064 3.121-1.69 0-3.064-1.4-3.064-3.121s1.374-3.122 3.064-3.122zm0-.7c-2.068 0-3.752 1.714-3.752 3.822 0 2.106 1.684 3.822 3.752 3.822 2.069 0 3.752-1.716 3.752-3.822 0-2.108-1.683-3.822-3.752-3.822zm.03-.7c1.591 0 2.99.85 3.78 2.128.437.704.688 1.535.688 2.424 0 1.05-.354 2.024-.945 2.794a4.425 4.425 0 01-3.523 1.757 4.371 4.371 0 01-2.407-.718 4.5 4.5 0 01-1.556-1.732 4.507 4.507 0 01-.451-1.401 4.28 4.28 0 01-.055-.7c0-2.511 2.004-4.552 4.469-4.552zm-6.532 0h1.375V8.754h-1.375v2.101zM1.375 8.298l8.25 1.902v.655c0 .385.309.7.687.7h1.375a.696.696 0 00.688-.7V10.2l8.25-1.902v3.545a5.1 5.1 0 00-3.781-1.688c-2.844 0-5.157 2.356-5.157 5.252h-9.28a.348.348 0 00-.344.35c0 .193.154.35.343.35h9.33c.062.493.196.963.384 1.4H1.72a.348.348 0 01-.344-.35V8.299zm18.219-4.796a.347.347 0 00-.344.35v.7c0 .193.154.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.72 0a.347.347 0 00-.343.35v.7c0 .193.154.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.718 0a.347.347 0 00-.343.35v.7c0 .193.153.35.343.35.19 0 .344-.157.344-.35v-.7a.347.347 0 00-.344-.35zm-1.719 0a.347.347 0 00-.343.35v.7c0 .193.153.35.343.35.19 0 .344-.157.344-.35v-.7a.347.347 0 00-.344-.35zm-1.718 0a.347.347 0 00-.344.35v.7c0 .193.153.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.72 0a.347.347 0 00-.343.35v.7c0 .193.154.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.718 0a.347.347 0 00-.343.35v.7c0 .193.153.35.343.35.19 0 .344-.157.344-.35v-.7a.347.347 0 00-.344-.35zm-1.718 0a.347.347 0 00-.344.35v.7c0 .193.153.35.344.35.189 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.72 0a.347.347 0 00-.343.35v.7c0 .193.154.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.718 0a.347.347 0 00-.344.35v.7c0 .193.154.35.344.35.19 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35zm-1.719 0a.347.347 0 00-.343.35v.7c0 .193.153.35.343.35.19 0 .344-.157.344-.35v-.7a.347.347 0 00-.344-.35zm-1.375-.7H20.97c.189 0 .343.157.343.35v.35a.347.347 0 00-.343.35v.7c0 .193.153.35.343.35v1.68a1.042 1.042 0 01-.804 1.027l-8.133 1.87v-.725c0-.385-.31-.7-.688-.7h-1.375a.696.696 0 00-.687.7v.725l-8.133-1.87a1.042 1.042 0 01-.804-1.026V4.902c.189 0 .343-.157.343-.35v-.7a.347.347 0 00-.343-.35v-.35c0-.193.154-.35.343-.35zM8.961.7h4.077c.116 0 .222.058.286.156l.815 1.245H7.861L8.676.856A.34.34 0 018.962.7zm0-.7c-.345 0-.666.175-.858.468L7.035 2.1H1.03C.464 2.101 0 2.574 0 3.151v3.432c0 .57.261 1.082.688 1.4v9.175c0 .577.463 1.05 1.03 1.05h10.457l-1.478 1.501a1.364 1.364 0 000 1.899c.258.26.595.392.932.392.337 0 .673-.133.931-.392L14.134 20c.028-.028.052-.051.073-.083.77.473 1.674.742 2.637.742 2.843 0 5.156-2.357 5.156-5.252a5.29 5.29 0 00-.688-2.616V7.984c.427-.32.688-.83.688-1.401V3.152c0-.578-.465-1.05-1.031-1.05h-6.004L13.896.467A1.024 1.024 0 0013.038 0H8.962z', fill: '#C2C2C2', mask: 'url(#prefix__f)' })),
            react.createElement("g", { transform: 'translate(205 83)' },
                react.createElement("circle", { fill: '#B8E7F8', fillRule: 'nonzero', cx: 40, cy: 26, r: 19 }),
                react.createElement("path", { d: 'M49.518 48.157a6.955 6.955 0 019.824.515l15.71 17.457a6.962 6.962 0 01-.515 9.83 6.955 6.955 0 01-9.824-.516l-15.71-17.457a6.962 6.962 0 01.515-9.829z', fill: '#B8E7F8', fillRule: 'nonzero' }),
                react.createElement("path", { d: 'M49.23 55.764a6.085 6.085 0 018.596.45l15.71 17.457a6.091 6.091 0 01-.45 8.6 6.085 6.085 0 01-8.596-.45L48.78 64.364a6.091 6.091 0 01.45-8.6z', stroke: '#C2C2C2', strokeWidth: 2.2 }),
                react.createElement("g", { fillRule: 'nonzero' },
                    react.createElement("circle", { fill: '#FFF', cx: 28, cy: 28, r: 28 }),
                    react.createElement("circle", { stroke: '#C2C2C2', strokeWidth: 2.2, fill: '#FFF', cx: 28.438, cy: 28.438, r: 23.188 }),
                    react.createElement("circle", { fill: '#B8E7F8', cx: 29.75, cy: 25.375, r: 14 }),
                    react.createElement("circle", { fill: '#FFF', cx: 32.375, cy: 21.875, r: 8.75 }))))));
}
function IconNoResultManagementJobs(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 250, height: 98, viewBox: '0 0 423 182' }, props),
        react.createElement("defs", null,
            react.createElement("path", { d: 'M1.732 0h58.535C61.224 0 62 .776 62 1.732v76.535c0 .957-.776 1.733-1.733 1.733H1.733A1.733 1.733 0 010 78.267V1.733C0 .776.776 0 1.732 0z', id: 'prefix__b' }),
            react.createElement("path", { d: 'M25.633 12.8c0 7.06-5.738 12.784-12.817 12.784C5.738 25.584 0 19.86 0 12.8 0 5.74 5.738.014 12.816.014c7.079 0 12.817 5.724 12.817 12.785', id: 'prefix__c' }),
            react.createElement("path", { d: 'M2.475 0h79.05A2.475 2.475 0 0184 2.475v104.05A2.475 2.475 0 0181.525 109H2.475A2.475 2.475 0 010 106.525V2.475A2.475 2.475 0 012.475 0z', id: 'prefix__f' }),
            react.createElement("path", { d: 'M41.162 20.486c0 11.315-9.215 20.487-20.581 20.487C9.214 40.973 0 31.8 0 20.486 0 9.172 9.214 0 20.58 0c11.367 0 20.582 9.172 20.582 20.486', id: 'prefix__g' }),
            react.createElement("filter", { x: '-40.4%', y: '-18.8%', width: '180.9%', height: '162.7%', filterUnits: 'objectBoundingBox', id: 'prefix__a' },
                react.createElement("feMorphology", { radius: 0.578, operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dy: 10, in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: 6.5, in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387 0 0 0 0 0.540303432 0 0 0 0 0.621678359 0 0 0 0.0983355978 0', in: 'shadowBlurOuter1' })),
            react.createElement("filter", { x: '-43.2%', y: '-20.5%', width: '186.5%', height: '166.7%', filterUnits: 'objectBoundingBox', id: 'prefix__e' },
                react.createElement("feMorphology", { radius: 0.825, operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dy: 14, in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: 9.5, in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387 0 0 0 0 0.540303432 0 0 0 0 0.621678359 0 0 0 0.0983355978 0', in: 'shadowBlurOuter1' }))),
        react.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react.createElement("ellipse", { fill: '#C2C2C2', fillRule: 'nonzero', opacity: 0.125, transform: 'rotate(-1 211.5 126.667)', cx: 211.5, cy: 126.667, rx: 210.5, ry: 34 }),
            react.createElement("g", { transform: 'translate(207 18)' },
                react.createElement("use", { fill: '#000', filter: 'url(#prefix__a)', xlinkHref: '#prefix__b' }),
                react.createElement("path", { strokeOpacity: 0.105, stroke: '#C9D1DB', strokeWidth: 0.578, d: 'M60.267-.289c.559 0 1.064.226 1.43.592.366.366.592.871.592 1.43h0v76.534c0 .559-.226 1.064-.592 1.43a2.015 2.015 0 01-1.43.592h0H1.733a2.015 2.015 0 01-1.429-.592 2.015 2.015 0 01-.592-1.43h0V1.733c0-.559.226-1.064.592-1.43a2.015 2.015 0 011.43-.592h0z', fill: '#FFF' })),
            react.createElement("path", { d: 'M260.5 23c-1.1 0-2 .787-2 1.75v.438h-1c-.3 0-.5.175-.5.437v3.938c0 .262.2.437.5.437h6c.3 0 .5-.175.5-.438v-3.937c0-.263-.2-.438-.5-.438h-1v-.437c0-.963-.9-1.75-2-1.75zm.5 5.119v.568h-1v-.568a.837.837 0 01-.5-.744c0-.481.45-.875 1-.875s1 .394 1 .875c0 .306-.2.613-.5.744zm.5-2.932h-2v-.437c0-.481.45-.875 1-.875s1 .394 1 .875v.438z', fill: '#E5E7EB', fillRule: 'nonzero' }),
            react.createElement("g", { transform: 'translate(225 28)' },
                react.createElement("mask", { id: 'prefix__d', fill: '#fff' },
                    react.createElement("use", { xlinkHref: '#prefix__c' })),
                react.createElement("use", { fill: '#F3F1F8', xlinkHref: '#prefix__c' }),
                react.createElement("path", { d: 'M12.921 1.892s-8.058-.519-4.517 14.443h9.768s4.81-14.653-5.25-14.443', fill: '#2F3A5B', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M15.004 13.46c-.058.052-.114.11-.167.173a3.187 3.187 0 00-.518.861c-.297.75.24 1.463.24 1.463h-2.796c.045-.573.44-1.05.323-1.424a3.065 3.065 0 00-.323-.716c-.109-.178-.193-.269-.193-.269l3.434-.088zM16.573 10.802c.873.005.634-.416 1.197-1.68.563-1.264-.65-.338-.65-.338l-.547 2.018zM9.79 10.802c-.873.005-.635-.416-1.198-1.68s.65-.338.65-.338l.547 2.018z', fill: '#F4C5BE', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M17.442 8.704v.004c-.094 1.827-1.1 3.99-2.51 5.014a3.187 3.187 0 00-.52.861c-.367.18-.755.281-1.157.281a2.59 2.59 0 01-1.075-.242 3.492 3.492 0 00-.077-.221V14.4a3.086 3.086 0 00-.246-.495 3.624 3.624 0 01-.103-.063c-.751-.484-1.398-1.292-1.87-2.217-.47-.925-.766-1.966-.816-2.917v-.004c.13-2.406 1.955-4.312 4.187-4.312s4.057 1.906 4.187 4.312', fill: '#000', opacity: 0.219, style: {
                        mixBlendMode: 'multiply'
                    }, mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M17.457 8.353c0 .09-.003.181-.008.273v.004c-.094 1.827-1.1 3.99-2.51 5.014l-.045.031c-.043.031-.087.06-.13.089-.466.3-.972.475-1.502.475-.49 0-.96-.15-1.398-.412a3.62 3.62 0 01-.103-.063c-.75-.484-1.398-1.292-1.87-2.217-.47-.925-.766-1.966-.815-2.917v-.004a5.17 5.17 0 01-.008-.273c0-2.533 1.878-4.587 4.194-4.587 2.317 0 4.195 2.054 4.195 4.587M18.275 23.682H8.132c-1.12-1.474-2.318-6.981-.961-7.553.344-.145.862-.247 1.444-.318.234-.029.48-.053.727-.072a29.178 29.178 0 011.632-.08 42.322 42.322 0 011.566-.005h1.328l.273-.003c.282-.003.722-.004 1.233.008.494.01 1.056.032 1.605.073.527.04 1.045.098 1.482.182.305.058.57.129.776.215 1.357.572.158 6.079-.962 7.553', fill: '#F4C5BE', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M9.076 25.937c-2.122-2.469-3.095-9.398-1.737-9.97.344-.145.862-.247 1.443-.318.07.032 2.978 2.292 7.733.866a53.611 53.611 0 002.114-.763c.305.058.57.129.776.215 1.357.572-.242 7.878-1.895 9.97H9.076z', fill: '#B8E7F8', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M13.476 5.088s3.56.628 3.865 3.557c0 0 .266-2.24-.695-3.678-1.341-2.007-3.475-2.068-3.17.121', fill: '#212B44', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M15.998 4.75s-.283 2.222-3.27 2.344c-1.342.054-3.33.57-3.498 2.278 0 0-1.28-5.9 3.354-6.204.877-.058 3.414-.182 3.414 1.581', fill: '#2A3551', mask: 'url(#prefix__d)' }),
                react.createElement("path", { fill: '#1E283F', mask: 'url(#prefix__d)', d: 'M15.41 8.029v4.719H8.13v-4.72h2.635l.848-1.135h2.084l.772 1.136z' }),
                react.createElement("path", { d: 'M14.522 10.241c0 .986-.801 1.784-1.789 1.784a1.786 1.786 0 01-1.789-1.784c0-.985.801-1.784 1.79-1.784.987 0 1.788.799 1.788 1.784', fill: '#2F3A5B', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M13.957 10.429c0 .744-.604 1.346-1.35 1.346-.745 0-1.35-.602-1.35-1.346 0-.744.605-1.347 1.35-1.347.746 0 1.35.603 1.35 1.347', fill: '#1E283F', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M14.007 10.298c0 .67-.546 1.215-1.219 1.215a1.218 1.218 0 01-1.218-1.215 1.217 1.217 0 011.907-1.003c.32.219.53.586.53 1.003', fill: '#2F3A5B', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M13.557 9.729a1.217 1.217 0 01-1.907 1.003 1.217 1.217 0 011.827-1.437c.052.135.08.281.08.434', fill: '#FFF', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M12.761 9.833a.439.439 0 11-.877 0 .439.439 0 01.877 0M13.59 10.823a.278.278 0 11-.556 0 .278.278 0 01.556 0', fill: '#FFF', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M8.468 10.131a.72.72 0 01.32-.586c.53-.36 1.373-.797 1.599-.07.213.687.142 1.818-.038 2.533a.744.744 0 01-.68.553l-.59.038a.588.588 0 01-.636-.582l.025-1.886z', fill: '#121826', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M8.327 9.395l-.197.1c.064-.038.13-.072.197-.1', fill: '#FCD1C3', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M17.93 15.733l-2.763.327-1.805-3.021c-1.116.205-2.056-.403-2.554-.943-.284-.308-.176-.52-.018-.651.135-.111.306-.162.306-.162.319.49.872.813 1.5.813a1.787 1.787 0 001.421-2.868c.006-.003.144-.099.33-.133.243-.046.568.014.789.522.416.959.224 1.827-.205 2.438l1.266 1.552 1.734 2.126z', fill: '#F4C5BE', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M14.884 10.3a2.131 2.131 0 01-2.133 2.128 2.132 2.132 0 01-1.807-.995c.135-.111.306-.163.306-.163.319.49.872.814 1.5.814a1.787 1.787 0 001.421-2.869c.006-.002.144-.098.33-.133.242.345.383.765.383 1.218', fill: '#D6A8A3', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M10.066 11.826c-.076.34-.341.588-.657.612l-1.119.046.075 1.277.127 2.156c.011.865-1.942.21-1.925-.49l.192-1.666.21-3.676a.536.536 0 01.32-.46l1.508-.662.197-.098h.003c.443-.183.92-.138 1.08.462.202.757.165 1.709-.011 2.499', fill: '#FCD1C3', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M8.452 9.395v.001a.016.016 0 00-.01.003l.01-.004z', fill: '#FCD1C3', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M20.63 20.1a.41.41 0 01-.019.03l-.993 1.394a.795.795 0 01-1.224.085l-3.697-6.187 1.6-1.732 1.956 2.173.652.434.482.108s2.153 2.264 1.26 3.668a.624.624 0 01-.017.027z', fill: '#B8E7F8', mask: 'url(#prefix__d)' }),
                react.createElement("path", { fill: '#000', mask: 'url(#prefix__d)', d: 'M14.912 15.694h-.001l-.214-.358z' }),
                react.createElement("path", { d: 'M19.236 21.716c-.09.285-.187.556-.287.806-.903-.236-2.965-3.88-3.98-5.763-.358-.665-.585-1.11-.585-1.11l.654.002.614 1.028 2.87 4.801c.192.204.463.28.714.236', fill: '#000', opacity: 0.219, style: {
                        mixBlendMode: 'multiply'
                    }, mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M7.821 16.015a8.304 8.304 0 01-.004-.053l.004.053z', fill: '#FCD1C3', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M8.238 22.166l-1.386.27c-.63.045-.927-.56-.91-1.189l.888-7.162h1.65l.426 6.766c.012.78.112 1.26-.668 1.315', fill: '#B8E7F8', mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M7.757 22.737a8.908 8.908 0 01-.252-.613l.795-.155c.78-.054.68-.535.669-1.315l-.316-5.001.032-.004c.014.007.194.09.512.207.16 2.141.694 6.107.097 6.504-.245.164-.972.292-1.537.377', fill: '#000', opacity: 0.219, style: {
                        mixBlendMode: 'multiply'
                    }, mask: 'url(#prefix__d)' }),
                react.createElement("path", { d: 'M13.931 14.197a2.819 2.819 0 01-.204.062l-.488-.846c-.947.245-1.668-.284-1.982-.578h.246c.496.293 1.127.484 1.827.356l.601 1.006z', fill: '#D6A8A3', mask: 'url(#prefix__d)' })),
            react.createElement("path", { fill: '#E5E7EB', d: 'M218 63h40v2h-40zM218 68h40v2h-40zM218 73h40v2h-40zM218 79h40v2h-40zM229 84h18v2h-18z' }),
            react.createElement("g", null,
                react.createElement("path", { fill: '#D7D7D7', d: 'M277.532 18.266l-1.529-3.708 2.947-1.216 1.529 3.708zM251.034 10.782l.165-2.962 2.354.133-.165 2.962zM293.704 26.953l2.198 1.992-1.585 1.746-2.198-1.992z' }),
                react.createElement("path", { fill: '#E5E7EB', opacity: 0.189, d: 'M294.532 22.14l-1.939-2.245 1.785-1.54 1.94 2.246z' }),
                react.createElement("path", { fill: '#B8E7F8', d: 'M279.292 43.234l4.741 2.19-1.804 3.912-4.742-2.19z' }),
                react.createElement("path", { fill: '#D7D7D7', d: 'M110.25 83.914l3.054-2.6 2.067 2.428-3.055 2.6z' }),
                react.createElement("path", { fill: '#FFF', d: 'M130.841 169.096l1.024-2.784 2.212.815-1.023 2.784z' }),
                react.createElement("path", { fill: '#B8E7F8', d: 'M116.856 107.639l4.603-2.47 2.039 3.796-4.603 2.47z' })),
            react.createElement("g", null,
                react.createElement("g", { transform: 'translate(141 31)' },
                    react.createElement("use", { fill: '#000', filter: 'url(#prefix__e)', xlinkHref: '#prefix__f' }),
                    react.createElement("path", { strokeOpacity: 0.105, stroke: '#C9D1DB', strokeWidth: 0.825, d: 'M81.525-.412c.797 0 1.52.323 2.042.845.522.523.846 1.245.846 2.042h0v104.05c0 .797-.324 1.52-.846 2.042a2.878 2.878 0 01-2.042.846h0-79.05c-.797 0-1.52-.324-2.042-.846a2.878 2.878 0 01-.845-2.042h0V2.475c0-.797.323-1.52.845-2.042a2.878 2.878 0 012.042-.845h0z', fill: '#FFF' })),
                react.createElement("path", { d: 'M215.5 38c-1.1 0-2 .9-2 2v.5h-1c-.3 0-.5.2-.5.5v4.5c0 .3.2.5.5.5h6c.3 0 .5-.2.5-.5V41c0-.3-.2-.5-.5-.5h-1V40c0-1.1-.9-2-2-2zm.5 5.85v.65h-1v-.65c-.3-.15-.5-.5-.5-.85 0-.55.45-1 1-1s1 .45 1 1c0 .35-.2.7-.5.85zm.5-3.35h-2V40c0-.55.45-1 1-1s1 .45 1 1v.5z', fill: '#E5E7EB', fillRule: 'nonzero' }),
                react.createElement("g", { transform: 'translate(162 44)' },
                    react.createElement("mask", { id: 'prefix__h', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__g' })),
                    react.createElement("use", { fill: '#F8F6FC', xlinkHref: '#prefix__g' }),
                    react.createElement("path", { d: 'M24.012 24.37c-.12.11-.239.233-.35.364-.028.03-.062.184-.1.42-.061.378-.132.969-.19 1.598-.115 1.238-.185 2.63-.056 2.868H17.64c.051-.654-.039-1.846-.157-2.84-.099-.832-.217-1.524-.289-1.64l-.011-.02c-.23-.372-.408-.564-.408-.564l7.236-.185zM13.52 19.08c-1.8-.376-1.121-1.136-1.72-3.982-.598-2.847 1.49-.408 1.49-.408l.23 4.39z', fill: '#C1867C', mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M28.007 14.484c-.089 1.475-.627 6.785-2.164 9.305-.222.367-1.178.98-2.316 1.484-.062.379-.132.97-.19 1.599-.045.02-.09.037-.136.056-.96.395-2.008.692-2.842.692-.853 0-1.932-.31-2.91-.72-.1-.832-.217-1.524-.29-1.64-1.126-.5-2.066-1.108-2.287-1.471-1.536-2.52-2.074-7.83-2.163-9.305.31-4.971 3.617-8.883 7.65-8.883 4.031 0 7.338 3.912 7.648 8.883', fill: '#000', opacity: 0.219, style: {
                            mixBlendMode: 'multiply'
                        }, mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M28.053 13.723c0 .189-.005.38-.014.574v.008l-.009.172c-.089 1.476-.627 6.786-2.163 9.305-.223.367-1.179.981-2.317 1.485-1.043.463-2.24.831-3.168.831-.938 0-2.15-.374-3.2-.845-1.126-.5-2.066-1.108-2.287-1.47-1.536-2.52-2.074-7.83-2.163-9.306l-.009-.172v-.008a12.508 12.508 0 01-.014-.574c0-5.327 3.436-9.644 7.673-9.644 4.236 0 7.671 4.317 7.671 9.644', fill: '#C1867C', mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M27.452 19.08c1.8-.376 1.121-1.136 1.72-3.982.598-2.847-1.49-.408-1.49-.408l-.23 4.39zM33.583 31.991l-.344 7.475-25.612-.718-.504-6.755a1.888 1.888 0 011.325-1.943c1.444-.45 3.911-1.094 7.17-1.418a41.592 41.592 0 016.165-.153c.95.045 1.937.124 2.957.243 2.126.246 4.395.666 6.782 1.318.855.233 2.101 1.07 2.06 1.951', fill: '#C1867C', mask: 'url(#prefix__h)' }),
                    react.createElement("g", { fill: '#B8E7F8', mask: 'url(#prefix__h)' },
                        react.createElement("path", { d: 'M33.583 31.788l-.304 6.598-9.187.015-6.488.05-10.008-.32-.473-6.34a1.888 1.888 0 011.325-1.944c1.444-.45 3.911-1.094 7.17-1.418 1.357 1.628 4.894 4.791 9.122.09 2.126.246 4.395.666 6.782 1.318.855.233 2.101 1.07 2.06 1.951' }),
                        react.createElement("path", { d: 'M5.592 39.035l8.122-1.475.44 3.901-8.013 4.529zM35.925 39.144l-8.444-1.584-.537 3.982 8.645 4.572z' })),
                    react.createElement("path", { d: 'M29.294 11.666a1.365 1.365 0 00.018-1.366 1.372 1.372 0 00-.724-1.666 1.373 1.373 0 00-.576-1.257 1.381 1.381 0 00-1.43-1.912 1.38 1.38 0 00-.727-.948 1.383 1.383 0 00-2.486-.731 1.383 1.383 0 00-1.105-.552l-.015.001a1.384 1.384 0 00-2.694-.207 1.382 1.382 0 00-1.177-.086 1.384 1.384 0 00-1.128-.582 1.381 1.381 0 00-1.36 1.642 1.383 1.383 0 00-2.168.836c-.376.246-.626.67-.626 1.153l.001.032a1.381 1.381 0 00-1.678 1.346c0 .526.296.983.732 1.216a1.37 1.37 0 00-.44 1.005l.002.046a1.372 1.372 0 00-.51 2.414 1.376 1.376 0 00.122.583.99.99 0 00.029 1.376 1 1 0 00.886.274c1.067.563.896 3.364.896 3.364l.787.488c-.356-2.408-.31-4.014-.083-5.086a1.383 1.383 0 001.153-.894 1.382 1.382 0 002.42-.722 1.387 1.387 0 001.115-.108c.68.158 1.286.276 1.827.164a16.3 16.3 0 00.151-.016 1.384 1.384 0 002.317-.068 1.38 1.38 0 001.71-.045 1.384 1.384 0 002.055.78c.435.99.676 2.778.2 5.995l.788-.488s-.17-2.755.867-3.35a1 1 0 00.4-.11c.035-.002.07-.003.107 0l.007-.071a.991.991 0 00.204-1.43.99.99 0 00.133-1.02', fill: '#2F3A5B', mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M23.95 44.596h-6.863a1.325 1.325 0 01-1.327-1.322V30.258c0-.73.594-1.322 1.327-1.322h6.862c.733 0 1.328.592 1.328 1.322v13.016c0 .73-.595 1.322-1.328 1.322', fill: '#F7F7F7', mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M18.456 31.294a.838.838 0 01-.84.836.838.838 0 01-.84-.836c0-.462.376-.836.84-.836.464 0 .84.374.84.836', fill: '#EAEAEA', mask: 'url(#prefix__h)' }),
                    react.createElement("path", { d: 'M18.634 36.585c-1.94.206-2.684-.357-2.684-.357v-1.204c-1.508.845-2.05 2.033-2.143 2.263l-.08.04.44 3.9 2.208.192.411.035h.004c.966.019 1.981.22 2.399.001.56-.293.186-4.948-.555-4.87M22.684 36.585c1.94.206 2.684-.357 2.684-.357v-1.204c1.508.845 2.05 2.033 2.143 2.263l.081.04-.44 3.9-2.209.192-.41.035h-.004c-.967.019-1.982.22-2.4.001-.559-.293-.186-4.948.555-4.87', fill: '#C1867C', mask: 'url(#prefix__h)' })),
                react.createElement("path", { fill: '#E5E7EB', d: 'M154 92h58v2h-58zM154 100h58v2h-58zM154 107h58v2h-58zM154 115h58v2h-58zM170 122h26v2h-26z' })),
            react.createElement("g", { transform: 'translate(205 83)' },
                react.createElement("circle", { fill: '#B8E7F8', fillRule: 'nonzero', cx: 40, cy: 26, r: 19 }),
                react.createElement("path", { d: 'M49.518 48.157a6.955 6.955 0 019.824.515l15.71 17.457a6.962 6.962 0 01-.515 9.83 6.955 6.955 0 01-9.824-.516l-15.71-17.457a6.962 6.962 0 01.515-9.829z', fill: '#B8E7F8', fillRule: 'nonzero' }),
                react.createElement("path", { d: 'M49.23 55.764a6.085 6.085 0 018.596.45l15.71 17.457a6.091 6.091 0 01-.45 8.6 6.085 6.085 0 01-8.596-.45L48.78 64.364a6.091 6.091 0 01.45-8.6z', stroke: '#C2C2C2', strokeWidth: 2.2 }),
                react.createElement("g", { fillRule: 'nonzero' },
                    react.createElement("circle", { fill: '#FFF', cx: 28, cy: 28, r: 28 }),
                    react.createElement("circle", { stroke: '#C2C2C2', strokeWidth: 2.2, fill: '#FFF', cx: 28.438, cy: 28.438, r: 23.188 }),
                    react.createElement("circle", { fill: '#B8E7F8', cx: 29.75, cy: 25.375, r: 14 }),
                    react.createElement("circle", { fill: '#FFF', cx: 32.375, cy: 21.875, r: 8.75 }))))));
}
function IconNoResultSalary(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 250, height: 98, viewBox: '0 0 423 182' }, props),
        react.createElement("defs", null,
            react.createElement("path", { d: 'M22.799.117H4.73c-3.8 0-5.936 4.22-3.605 7.115L11.38 19.957h22.84L44.47 7.232c2.332-2.894.194-7.115-3.606-7.115H22.8z', id: 'prefix__a' }),
            react.createElement("path", { d: 'M3.674.567C1.1.567-.658 3.26.32 5.727c.055.17.127.32.2.49 2.465 6.42 6.271 16.55 7.83 20.712.453 1.187.707 1.883.707 1.883h14.5s5.581-14.931 8.736-23.085c.978-2.467-.78-5.16-3.354-5.16H3.674z', id: 'prefix__c' }),
            react.createElement("path", { d: 'M28.365.25c-10.25 6.71-20.24 18.473-25.13 30.161C1.255 35.105.117 39.8.117 44.134c0 4.185.634 7.748 1.792 10.783 5.806 15.57 24.905 16.966 39.432 16.966 5.619 0 12.321-.208 18.838-1.376 13.592-2.394 26.306-8.955 26.306-26.373 0-3.186-.616-6.54-1.718-9.953C80.64 21.325 69.588 7.677 58.237.25H28.366z', id: 'prefix__e' }),
            react.createElement("path", { d: 'M8.819 2.966v1.823C3.896 6.081.309 9.99.309 14.596c0 7.326 6.114 10.03 10.577 12.002 4.578 2.024 6.443 3.113 6.443 5.786 0 1.853-2.275 3.42-4.965 3.42s-4.965-1.567-4.965-3.42c0-1.889-1.588-3.42-3.545-3.42-1.958 0-3.546 1.531-3.546 3.42 0 4.608 3.588 8.514 8.511 9.808v1.821c0 1.506 1.277 2.738 2.837 2.738 1.56 0 2.837-1.232 2.837-2.738v-1.536c5.634-.86 9.928-5.053 9.928-10.093 0-7.324-6.114-10.028-10.578-12.003C9.264 18.356 7.4 17.268 7.4 14.596c0-1.853 2.273-3.42 4.964-3.42 2.692 0 4.966 1.567 4.966 3.42 0 1.888 1.587 3.42 3.544 3.42 1.958 0 3.546-1.532 3.546-3.42 0-5.04-4.294-9.233-9.928-10.091v-1.54c0-1.505-1.277-2.734-2.837-2.734-1.56 0-2.837 1.231-2.837 2.735z', id: 'prefix__g' }),
            react.createElement("path", { d: 'M15.197 1.05C14.595 1.402.47 9.934.47 27.132c0 2.096 1.647 3.797 3.678 3.797 2.03 0 3.679-1.7 3.679-3.797 0-12.696 10.543-19.202 11.033-19.495 1.753-1.044 2.363-3.359 1.357-5.176A3.654 3.654 0 0017.02.549c-.62 0-1.246.161-1.822.5z', id: 'prefix__i' }),
            react.createElement("path", { d: 'M1.315 2.6C.895 3.41-1.09 8.02.958 19.82c.316 1.826 1.963 3.12 3.832 3.12.21 0 .428-.016.644-.053 2.116-.34 3.55-2.262 3.196-4.297-1.565-9.022-.388-12.516-.288-12.789.852-1.816.064-3.973-1.808-4.87A4.02 4.02 0 004.796.534c-1.428 0-2.8.759-3.48 2.066z', id: 'prefix__k' }),
            react.createElement("path", { d: 'M.678 2.37C-.233 4.052.505 6.094 2.33 6.934c.333.154 8.275 3.76 18.258 3.76 9.983 0 17.925-3.606 18.257-3.76 1.82-.838 2.556-2.876 1.651-4.554C39.588.701 37.376.015 35.55.846c-.065.03-6.782 3.046-14.962 3.046C12.44 3.892 5.744.9 5.623.846a3.958 3.958 0 00-1.64-.354c-1.356 0-2.66.687-3.305 1.878z', id: 'prefix__m' })),
        react.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react.createElement("path", { fill: '#D7D7D7', d: 'M277.532 18.266l-1.529-3.708 2.947-1.216 1.529 3.708zM251.034 10.782l.165-2.962 2.354.133-.165 2.962zM293.704 26.953l2.198 1.992-1.585 1.746-2.198-1.992z' }),
            react.createElement("path", { fill: '#E5E7EB', opacity: 0.189, d: 'M294.532 22.14l-1.939-2.245 1.785-1.54 1.94 2.246z' }),
            react.createElement("path", { fill: '#B8E7F8', d: 'M279.292 43.234l4.741 2.19-1.804 3.912-4.742-2.19z' }),
            react.createElement("path", { fill: '#D7D7D7', d: 'M110.25 83.914l3.054-2.6 2.067 2.428-3.055 2.6z' }),
            react.createElement("path", { fill: '#FFF', d: 'M130.841 169.096l1.024-2.784 2.212.815-1.023 2.784z' }),
            react.createElement("path", { fill: '#B8E7F8', d: 'M116.856 107.639l4.603-2.47 2.039 3.796-4.603 2.47z' }),
            react.createElement("ellipse", { fill: '#C2C2C2', fillRule: 'nonzero', opacity: 0.125, transform: 'rotate(-1 211.5 126.667)', cx: 211.5, cy: 126.667, rx: 210.5, ry: 34 }),
            react.createElement("g", null,
                react.createElement("g", { transform: 'translate(181 32)' },
                    react.createElement("mask", { id: 'prefix__b', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__a' })),
                    react.createElement("path", { fill: '#B8E7F8', mask: 'url(#prefix__b)', d: 'M-2.873 22.847H48.47v-25.62H-2.873z' })),
                react.createElement("g", { transform: 'translate(187 21)' },
                    react.createElement("mask", { id: 'prefix__d', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__c' })),
                    react.createElement("path", { fill: '#B8E7F8', mask: 'url(#prefix__d)', d: 'M-2.864 31.83h38.34V-2.45h-38.34z' })),
                react.createElement("g", { transform: 'translate(160 47)' },
                    react.createElement("mask", { id: 'prefix__f', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__e' })),
                    react.createElement("path", { fill: '#B8E7F8', mask: 'url(#prefix__f)', d: 'M-2.88 74.903h92.363V-2.77H-2.881z' })),
                react.createElement("g", { transform: 'translate(191 62)' },
                    react.createElement("mask", { id: 'prefix__h', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__g' })),
                    react.createElement("path", { fill: '#FFF', mask: 'url(#prefix__h)', d: 'M-2.788 49.732h30.306V-2.75H-2.788z' })),
                react.createElement("g", { transform: 'translate(170 44)' },
                    react.createElement("mask", { id: 'prefix__j', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__i' })),
                    react.createElement("path", { fill: '#E2F3F8', mask: 'url(#prefix__j)', d: 'M-2.484 33.973h26.137V-2.494H-2.484z' })),
                react.createElement("g", { transform: 'translate(182 44)' },
                    react.createElement("mask", { id: 'prefix__l', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__k' })),
                    react.createElement("path", { fill: '#E2F3F8', mask: 'url(#prefix__l)', d: 'M-3.076 25.931h14.882V-2.456H-3.076z' })),
                react.createElement("g", { transform: 'translate(183 44)' },
                    react.createElement("mask", { id: 'prefix__n', fill: '#fff' },
                        react.createElement("use", { xlinkHref: '#prefix__m' })),
                    react.createElement("path", { fill: '#E2F3F8', mask: 'url(#prefix__n)', d: 'M-2.675 13.419h46.52V-2.233h-46.52z' }))),
            react.createElement("g", { transform: 'translate(205 83)' },
                react.createElement("circle", { fill: '#B8E7F8', fillRule: 'nonzero', cx: 40, cy: 26, r: 19 }),
                react.createElement("path", { d: 'M49.518 48.157a6.955 6.955 0 019.824.515l15.71 17.457a6.962 6.962 0 01-.515 9.83 6.955 6.955 0 01-9.824-.516l-15.71-17.457a6.962 6.962 0 01.515-9.829z', fill: '#B8E7F8', fillRule: 'nonzero' }),
                react.createElement("path", { d: 'M49.23 55.764a6.085 6.085 0 018.596.45l15.71 17.457a6.091 6.091 0 01-.45 8.6 6.085 6.085 0 01-8.596-.45L48.78 64.364a6.091 6.091 0 01.45-8.6z', stroke: '#C2C2C2', strokeWidth: 2.2 }),
                react.createElement("g", { fillRule: 'nonzero' },
                    react.createElement("circle", { fill: '#FFF', cx: 28, cy: 28, r: 28 }),
                    react.createElement("circle", { stroke: '#C2C2C2', strokeWidth: 2.2, fill: '#FFF', cx: 28.438, cy: 28.438, r: 23.188 }),
                    react.createElement("circle", { fill: '#B8E7F8', cx: 29.75, cy: 25.375, r: 14 }),
                    react.createElement("circle", { fill: '#FFF', cx: 32.375, cy: 21.875, r: 8.75 }))))));
}
function IconNoResult404(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 251, height: 123, viewBox: '0 0 251 123', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        react.createElement("g", { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: '404', transform: 'translate(-524.000000, -140.000000)' },
                react.createElement("g", { id: 'emptystates/noresult-nojobs', transform: 'translate(200.000000, 140.000000)' },
                    react.createElement("g", { id: 'icons/icon-states/icon-successfulapply', transform: 'translate(324.722459, -0.000000)' },
                        react.createElement("ellipse", { id: 'Oval', fill: '#C2C2C2', fillRule: 'nonzero', opacity: '0.125023251', transform: 'translate(124.893254, 91.974343) rotate(-1.000000) translate(-124.893254, -91.974343) ', cx: '124.893254', cy: '91.9743426', rx: '124.303019', ry: '20.2241571' }),
                        react.createElement("g", { id: 'Dots-Copy', transform: 'translate(45.000000, 81.000000)' },
                            react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(2.822747, 2.442876) rotate(133.000000) translate(-2.822747, -2.442876) ', points: '4.35892013 3.98239793 0.965225554 3.60210543 1.28657397 0.903354058 4.6802691 1.28349549' }),
                            react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(17.701254, 13.307527) rotate(133.000000) translate(-17.701254, -13.307527) ', points: '19.2088291 15.75589 15.0001125 14.3380161 16.1936786 10.8591643 20.4023952 12.2770382' })),
                        react.createElement("g", { id: 'Dots-Copy', transform: 'translate(204.000000, 40.000000)' },
                            react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(2.857910, 3.674704) rotate(61.000000) translate(-2.857910, -3.674704) ', points: '4.62836256 5.44303924 0.7403355 4.98309435 1.08745711 1.90636863 4.97548363 2.36614115' }),
                            react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(18.156151, 16.396170) rotate(245.000000) translate(-18.156151, -16.396170) ', points: '19.9373579 16.8984361 17.271536 18.0081259 16.374944 15.8940774 19.0405925 14.7842149' }),
                            react.createElement("polygon", { id: 'Fill-30', fill: '#E5E7EB', opacity: '0.188825335', transform: 'translate(18.587836, 8.017625) rotate(72.000000) translate(-18.587836, -8.017625) ', points: '20.3697947 8.51843616 17.7016335 9.62917679 16.8058778 7.51698679 19.4738655 6.4060736' }),
                            react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(5.301912, 33.461457) rotate(186.000000) translate(-5.301912, -33.461457) ', points: '7.03055839 36.2779008 2.23177986 34.6300799 3.57326543 30.6450136 8.37204396 32.2928344' })),
                        react.createElement("text", { id: '404', fontSize: '80', fontWeight: '500', fill: '#D1DEE5' },
                            react.createElement("tspan", { x: '57', y: '86' }, "404")),
                        react.createElement("g", { id: 'Group', transform: 'translate(134.054927, 69.370830)' },
                            react.createElement("ellipse", { id: 'Oval', fill: '#B8E7F8', fillRule: 'nonzero', cx: '23.6204735', cy: '15.4655612', rx: '11.2197249', ry: '11.3017563' }),
                            react.createElement("path", { d: 'M36.6707939,25.826069 C38.9299096,25.8173205 40.7683768,27.6416035 40.7771253,29.9007192 C40.7771662,29.9112753 40.7771662,29.9218315 40.7771254,29.9323876 L40.7232218,43.863127 C40.7143926,46.1449449 38.8668067,47.9925366 36.5849888,48.001373 C34.3258731,48.0101216 32.4874059,46.1858385 32.4786574,43.9267228 C32.4786165,43.9161668 32.4786165,43.9056106 32.4786573,43.8950545 L32.5325609,29.964315 C32.5413902,27.6824971 34.388976,25.8349054 36.6707939,25.826069 Z', id: 'Rectangle', fill: '#B8E7F8', fillRule: 'nonzero', transform: 'translate(36.627891, 36.913721) rotate(-42.000000) translate(-36.627891, -36.913721) ' }),
                            react.createElement("path", { d: 'M36.1553099,30.4817855 C38.1320361,30.4741305 39.7406949,32.0703782 39.7483499,34.0471044 C39.7483857,34.056341 39.7483857,34.0655777 39.7483499,34.0748143 L39.6944496,48.0047148 C39.686724,50.0013054 38.0700864,51.6179482 36.0734957,51.6256801 C34.0967695,51.633335 32.4881107,50.0370874 32.4804557,48.0603611 C32.4804199,48.0511246 32.4804199,48.0418879 32.4804557,48.0326513 L32.534356,34.1027508 C32.5420816,32.1061601 34.1587192,30.4895174 36.1553099,30.4817855 Z', id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2.2', transform: 'translate(36.114403, 41.053733) rotate(-42.000000) translate(-36.114403, -41.053733) ' }),
                            react.createElement("g", { id: 'Group-7', fillRule: 'nonzero' },
                                react.createElement("ellipse", { id: 'Oval', fill: '#FFFFFF', cx: '16.5343314', cy: '16.6552198', rx: '16.5343314', ry: '16.6552198' }),
                                react.createElement("ellipse", { id: 'Oval', stroke: '#C2C2C2', strokeWidth: '2.2', fill: '#FFFFFF', cx: '16.7926804', cy: '16.9154576', rx: '13.6924932', ry: '13.7926039' }),
                                react.createElement("ellipse", { id: 'Oval', fill: '#B8E7F8', cx: '17.5677272', cy: '15.0937929', rx: '8.26716572', ry: '8.32760989' }),
                                react.createElement("ellipse", { id: 'Oval', fill: '#FFFFFF', cx: '19.1178207', cy: '13.0118905', rx: '5.16697858', ry: '5.20475618' })))))))));
}
function IconNoResultJobAlert(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: '251px', height: '108px', viewBox: '0 0 251 108' }, props),
        react.createElement("defs", null,
            react.createElement("filter", { id: 'filter-1' },
                react.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.976471 0 0 0 0 0.976471 0 0 0 0 0.976471 0 0 0 1.000000 0' })),
            react.createElement("path", { d: 'M1.7325,0 L34.910526,0 C35.8673593,-3.13103308e-15 36.643026,0.775666671 36.643026,1.7325 L36.643026,45.5488239 C36.643026,46.5056572 35.8673593,47.2813239 34.910526,47.2813239 L1.7325,47.2813239 C0.775666671,47.2813239 -1.43713395e-15,46.5056572 0,45.5488239 L0,1.7325 C1.04866318e-16,0.775666671 0.775666671,1.95212427e-15 1.7325,0 Z', id: 'path-2' }),
            react.createElement("filter", { x: '-68.4%', y: '-31.9%', width: '236.9%', height: '206.1%', filterUnits: 'objectBoundingBox', id: 'filter-3' },
                react.createElement("feMorphology", { radius: '0.5775', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '10', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '6.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("filter", { id: 'filter-4' },
                react.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 1.000000 0' })),
            react.createElement("path", { d: 'M2.475,1 L47.1703901,1 C48.5372948,1 49.6453901,2.10809524 49.6453901,3.475 L49.6453901,62.9458038 C49.6453901,64.3127085 48.5372948,65.4208038 47.1703901,65.4208038 L2.475,65.4208038 C1.10809524,65.4208038 1.94375439e-15,64.3127085 0,62.9458038 L0,3.475 C2.76691656e-16,2.10809524 1.10809524,1 2.475,1 Z', id: 'path-5' }),
            react.createElement("filter", { x: '-73.2%', y: '-34.7%', width: '246.3%', height: '212.8%', filterUnits: 'objectBoundingBox', id: 'filter-6' },
                react.createElement("feMorphology", { radius: '0.825', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '14', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '9.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("filter", { id: 'filter-7' },
                react.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 1.000000 0' }))),
        react.createElement("g", { id: 'DESKTOP', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/JOBSALERTS-NOJA', transform: 'translate(-524.000000, -235.000000)' },
                react.createElement("g", { id: 'Group-5', transform: 'translate(312.000000, 191.000000)' },
                    react.createElement("g", { id: 'emptystates/noresult-nojobs', transform: 'translate(24.000000, 24.000000)' },
                        react.createElement("g", { id: 'icons/icon-states/icon-successfulapply', transform: 'translate(188.339026, 20.000000)' },
                            react.createElement("g", { id: 'Group', transform: 'translate(0.000000, 5.319149)' },
                                react.createElement("ellipse", { id: 'Oval', fill: '#C2C2C2', fillRule: 'nonzero', opacity: '0.125023251', transform: 'translate(125.000000, 66.193853) rotate(-1.000000) translate(-125.000000, -66.193853) ', cx: '125', cy: '66.1938534', rx: '124.408983', ry: '20.0945626' }),
                                react.createElement("g", { id: 'Group-11-Copy', transform: 'translate(122.340426, 6.501182)' },
                                    react.createElement("g", { id: 'Rectangle-10' },
                                        react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-3)' }),
                                        react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.5775', d: 'M34.910526,-0.28875 C35.4686788,-0.28875 35.9739913,-0.0625138876 36.3397656,0.303260419 C36.7055399,0.669034725 36.931776,1.17434722 36.931776,1.7325 L36.931776,1.7325 L36.931776,45.5488239 C36.931776,46.1069767 36.7055399,46.6122892 36.3397656,46.9780635 C35.9739913,47.3438378 35.4686788,47.5700739 34.910526,47.5700739 L34.910526,47.5700739 L1.7325,47.5700739 C1.17434722,47.5700739 0.669034725,47.3438378 0.303260419,46.9780635 C-0.0625138876,46.6122892 -0.28875,46.1069767 -0.28875,45.5488239 L-0.28875,45.5488239 L-0.28875,1.7325 C-0.28875,1.17434722 -0.0625138876,0.669034725 0.303260419,0.303260419 C0.669034725,-0.0625138876 1.17434722,-0.28875 1.7325,-0.28875 L1.7325,-0.28875 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.50118203', y: '26.5957447', width: '23.6406619', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.50118203', y: '29.5508274', width: '23.6406619', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.50118203', y: '32.5059102', width: '23.6406619', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.50118203', y: '36.0520095', width: '23.6406619', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '13.0023641', y: '39.0070922', width: '10.6382979', height: '1.1820331' })),
                                react.createElement("g", { id: 'Dots-Copy', transform: 'translate(65.011820, 0.000000)' },
                                    react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(99.433206, 5.203210) rotate(61.000000) translate(-99.433206, -5.203210) ', points: '100.50249 6.2753504 98.1478556 6.00291265 98.3639222 4.13106925 100.718556 4.40340218' }),
                                    react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(84.097646, 1.399330) rotate(116.000000) translate(-84.097646, -1.399330) ', points: '85.1754653 1.70190427 83.5592073 2.38158354 83.0198262 1.09685975 84.6359795 0.417075659' }),
                                    react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(108.753138, 12.897077) rotate(245.000000) translate(-108.753138, -12.897077) ', points: '109.830958 13.1996515 108.2147 13.8793308 107.675318 12.594607 109.291472 11.9148229' }),
                                    react.createElement("polygon", { id: 'Fill-30', fill: '#E5E7EB', opacity: '0.188825335', transform: 'translate(109.016127, 7.829783) rotate(72.000000) translate(-109.016127, -7.829783) ', points: '110.093947 8.13235719 108.477689 8.81203646 107.938308 7.52731267 109.554461 6.84752858' }),
                                    react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(100.922131, 23.218061) rotate(186.000000) translate(-100.922131, -23.218061) ', points: '101.973872 24.9207703 99.0513688 23.9263044 99.8703902 21.5153508 102.792893 22.5098168' }),
                                    react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(1.660721, 45.406468) rotate(133.000000) translate(-1.660721, -45.406468) ', points: '2.73000456 46.478609 0.375370454 46.2061713 0.591437093 44.3343279 2.9460712 44.6066608' }),
                                    react.createElement("polygon", { id: 'Fill-30', fill: '#FFFFFF', transform: 'translate(13.273777, 95.219655) rotate(133.000000) translate(-13.273777, -95.219655) ', points: '14.3515968 95.5222296 12.7353387 96.2019088 12.1959576 94.917185 13.8121109 94.237401' }),
                                    react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(6.014704, 59.871173) rotate(133.000000) translate(-6.014704, -59.871173) ', points: '7.06644504 61.5738827 4.14394215 60.5794168 4.96296353 58.1684632 7.88546642 59.1629292' })),
                                react.createElement("g", { id: 'Group-11-Copy-2', transform: 'translate(83.333333, 13.184397)' },
                                    react.createElement("g", { filter: 'url(#filter-4)', id: 'icons/icon-lg/icon-search-copy' },
                                        react.createElement("g", { transform: 'translate(52.009456, 0.000000)' },
                                            react.createElement("g", { id: 'icon-bell', transform: 'translate(2.213168, 2.115126)' },
                                                react.createElement("path", { d: 'M4.21613153,0.0683286396 C4.55858651,0.0636501358 4.84745555,0.312118325 4.90316009,0.640316205 L4.91269694,0.740994042 L4.9186725,1.0222105 C6.57043114,1.30934746 7.86581484,2.69635549 7.99365067,4.4057112 L8.00317338,4.60433085 L8.05276746,6.93829089 C8.06104889,7.32801748 8.14300723,7.71251855 8.2940477,8.07134635 L8.39292507,8.28339866 L8.52511716,8.54012864 C8.72663452,8.93328946 8.46476664,9.42001778 8.04510017,9.48841161 L7.95286773,9.49647779 L5.93246147,9.52408007 C6.12570084,10.0768977 6.01226032,10.7153269 5.58260094,11.1602523 C4.97458477,11.7898714 3.95611538,11.8037854 3.32170238,11.1911399 C2.91085014,10.7943845 2.75834679,10.2278949 2.86629825,9.70668284 L2.9021987,9.5658182 L0.88247186,9.5934111 C0.441635846,9.59943363 0.117312896,9.14702049 0.237281577,8.739113 L0.269908986,8.65256875 L0.362509806,8.4532399 C0.546758594,8.05655093 0.650901704,7.62782454 0.670047575,7.19110481 L0.672514761,6.97219015 L0.624002595,4.7051426 C0.602404213,3.68869893 0.997178638,2.76089319 1.65116787,2.08366751 C2.09910176,1.61981839 2.66950215,1.27527166 3.31081071,1.09897564 L3.55452454,1.04084699 L3.54854901,0.759630569 C3.54054557,0.382979956 3.83960126,0.0732987256 4.21613153,0.0683286396 Z M5.48176752,9.54669753 L3.44115843,9.54669753 C3.38802806,9.67690354 3.35872745,9.81951899 3.35872745,9.96903078 C3.35872745,10.5827557 3.85243896,11.080278 4.46146298,11.080278 C5.07048699,11.080278 5.56419851,10.5827557 5.56419851,9.96903078 C5.56419851,9.81951899 5.53489789,9.67690354 5.48176752,9.54669753 L5.48176752,9.54669753 Z M1.09213726,7.94956024 C1.04558551,8.12934516 0.988115877,8.30622432 0.918980011,8.47881071 L0.806432987,8.73429733 L0.763623011,8.82359653 L7.99168395,8.88562682 L7.91546317,8.73085454 C7.83850094,8.57537957 7.7739465,8.41524519 7.71902523,8.25213759 L7.64352139,8.00545705 L1.09213726,7.94956024 Z M4.31279355,1.5838921 C3.45430286,1.57609935 2.68221056,1.91456022 2.12675944,2.47001134 C1.61759591,2.97917487 1.29076447,3.67037717 1.24583082,4.44329812 L1.2406402,4.65604545 L1.26190508,7.03800266 L1.25939485,7.20650603 L1.25939485,7.20650603 L1.25032872,7.37437756 L7.47589947,7.43088876 L7.46767145,7.29808611 L7.46767145,7.29808611 L7.46385143,7.16494955 L7.44123136,4.71232991 C7.42564585,2.99534853 6.02977492,1.59947761 4.31279355,1.5838921 Z', id: 'Combined-Shape', fill: '#555555', fillRule: 'nonzero' }),
                                                react.createElement("g", { id: 'Group-3', transform: 'translate(4.484019, 10.445940) rotate(-45.000000) translate(-4.484019, -10.445940) translate(3.056169, 9.007068)' })))),
                                    react.createElement("g", { id: 'Rectangle-10' },
                                        react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-6)' }),
                                        react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.825', d: 'M47.1703901,0.5875 C47.9677512,0.5875 48.6896262,0.910694446 49.2121609,1.43322917 C49.7346956,1.95576389 50.0578901,2.67763889 50.0578901,3.475 L50.0578901,3.475 L50.0578901,62.9458038 C50.0578901,63.7431649 49.7346956,64.4650399 49.2121609,64.9875746 C48.6896262,65.5101093 47.9677512,65.8333038 47.1703901,65.8333038 L47.1703901,65.8333038 L2.475,65.8333038 C1.67763889,65.8333038 0.955763892,65.5101093 0.433229169,64.9875746 C-0.0893055538,64.4650399 -0.4125,63.7431649 -0.4125,62.9458038 L-0.4125,62.9458038 L-0.4125,3.475 C-0.4125,2.67763889 -0.0893055538,1.95576389 0.433229169,1.43322917 C0.955763892,0.910694446 1.67763889,0.5875 2.475,0.5875 L2.475,0.5875 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.68321513', y: '37.0520095', width: '34.2789598', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.68321513', y: '41.7801418', width: '34.2789598', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.68321513', y: '45.9172577', width: '34.2789598', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.68321513', y: '50.6453901', width: '34.2789598', height: '1.1820331' }),
                                    react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '17.1394799', y: '54.7825059', width: '15.3664303', height: '1.1820331' }))),
                            react.createElement("g", { id: 'Group', transform: 'translate(114.066194, 40.780142)' },
                                react.createElement("circle", { id: 'Oval', fill: '#B8E7F8', fillRule: 'nonzero', cx: '23.6406619', cy: '15.3664303', r: '11.2293144' }),
                                react.createElement("path", { d: 'M36.6619445,25.624621 C38.9319983,25.6240567 40.7726979,27.4638415 40.7732622,29.7338953 C40.7732624,29.7345764 40.7732624,29.7352575 40.7732622,29.7359386 L40.7698121,43.6162407 C40.7692475,45.8877539 38.9279632,47.7290382 36.65645,47.7296028 C34.3863962,47.7301671 32.5456966,45.8903823 32.5451323,43.6203285 C32.5451321,43.6196474 32.5451321,43.6189663 32.5451323,43.6182852 L32.5485824,29.7379831 C32.549147,27.4664698 34.3904312,25.6251856 36.6619445,25.624621 Z', id: 'Rectangle', fill: '#B8E7F8', fillRule: 'nonzero', transform: 'translate(36.659197, 36.677112) rotate(-42.000000) translate(-36.659197, -36.677112) ' }),
                                react.createElement("path", { d: 'M36.1478893,30.2521655 C38.1341863,30.2516718 39.7447985,31.8614834 39.7452923,33.8477805 C39.7452924,33.8483765 39.7452924,33.8489725 39.7452923,33.8495684 L39.7418422,47.7298168 C39.7413481,49.7173909 38.1302244,51.3285146 36.1426504,51.3290087 C34.1563533,51.3295024 32.5457411,49.7196907 32.5452474,47.7333937 C32.5452472,47.7327977 32.5452472,47.7322017 32.5452474,47.7316057 L32.5486975,33.8513573 C32.5491915,31.8637833 34.1603152,30.2526596 36.1478893,30.2521655 Z', id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2.2', transform: 'translate(36.145270, 40.790587) rotate(-42.000000) translate(-36.145270, -40.790587) ' }),
                                react.createElement("g", { id: 'Group-7', fillRule: 'nonzero' },
                                    react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '16.5484634', cy: '16.5484634', r: '16.5484634' }),
                                    react.createElement("circle", { id: 'Oval', stroke: '#C2C2C2', strokeWidth: '2.2', fill: '#FFFFFF', cx: '16.8070331', cy: '16.8070331', r: '13.7041962' }),
                                    react.createElement("circle", { id: 'Oval', fill: '#B8E7F8', cx: '17.5827423', cy: '14.9970449', r: '8.27423168' }),
                                    react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '19.1341608', cy: '12.928487', r: '5.1713948' }))),
                            react.createElement("g", { filter: 'url(#filter-7)', id: 'icons/icon-lg/icon-search-copy' },
                                react.createElement("g", { transform: 'translate(91.016548, 25.595745)' },
                                    react.createElement("g", { id: 'icon-bell', transform: 'translate(4.124541, 3.051831)' },
                                        react.createElement("path", { d: 'M7.93365769,0.0499693385 C8.58755102,0.0368617406 9.13275786,0.523076554 9.20689824,1.1586675 L9.21533805,1.28767368 L9.2230798,1.80848084 C12.3159474,2.32722 14.7191051,4.93873778 14.8832498,8.15814243 L14.891434,8.4069629 L14.9556864,12.7294094 C14.967131,13.4992928 15.1338452,14.2571738 15.4457983,14.9571531 L15.5695692,15.2168416 L15.8112781,15.6908034 C16.1880987,16.4331443 15.66641,17.3624856 14.8579029,17.460678 L14.7405168,17.4689415 L10.9995991,17.5439302 C11.3508342,18.5655936 11.1332693,19.7494517 10.3325405,20.5786307 C9.19941943,21.7520119 7.31365503,21.7898129 6.14633511,20.6625451 C5.37318589,19.9159236 5.10243055,18.837271 5.33552328,17.8525869 L5.38886024,17.6570293 L1.64920049,17.7319926 C0.814412182,17.7487263 0.210916876,16.8758567 0.481534871,16.1057757 L0.526210345,15.9965706 L0.700006304,15.6262739 C1.05861843,14.8620443 1.25814016,14.0350146 1.28815452,13.1949182 L1.29144391,12.8793667 L1.22840426,8.68084476 C1.20042209,6.79841175 1.94226803,5.07523886 3.16106614,3.81313646 C4.03311925,2.91009904 5.15106594,2.24662902 6.40542833,1.92677681 L6.69726832,1.85911185 L6.68952664,1.33830475 C6.67915764,0.640755479 7.2364887,0.0636222763 7.93365769,0.0499693385 Z M10.216212,17.5663849 L6.41287733,17.5663849 C6.31398221,17.8058395 6.25944661,18.0680916 6.25944661,18.3430166 C6.25944661,19.4722704 7.17954534,20.3877115 8.31454464,20.3877115 C9.44954394,20.3877115 10.3696427,19.4722704 10.3696427,18.3430166 C10.3696427,18.0680916 10.3151071,17.8058395 10.216212,17.5663849 L10.216212,17.5663849 Z M2.05549229,14.6848893 C1.95612091,15.0600533 1.83120469,15.4285704 1.67879378,15.786796 L1.51714576,16.1414562 L1.43681411,16.307328 L14.8211357,16.3367743 L14.6818178,16.051065 C14.5235498,15.7281879 14.3944318,15.394205 14.2871196,15.0536088 L14.1868039,14.7109746 L2.05549229,14.6848893 Z M8.09479279,2.858767 C6.50511622,2.85448204 5.07134166,3.49037476 4.03618276,4.52553367 C3.06191555,5.49980087 2.44132358,6.82716707 2.37525633,8.3052803 L2.36941609,8.5841437 L2.38064438,12.9948441 L2.37400448,13.3069113 L2.37400448,13.3069113 L2.35523173,13.617886 L13.883189,13.6489596 L13.8695217,13.4031304 L13.8695217,13.4031304 L13.8640211,13.1566309 L13.8511184,8.61509256 C13.8425484,5.43573943 11.2741459,2.86733693 8.09479279,2.858767 Z', id: 'Combined-Shape', fill: '#555555', fillRule: 'nonzero' }),
                                        react.createElement("g", { id: 'Group-3', transform: 'translate(8.356581, 19.220529) rotate(-45.000000) translate(-8.356581, -19.220529) translate(5.695587, 16.573005)' })))))))))));
}
function IconNoProfileViews(props) {
    return (react.createElement("svg", { width: '423px', height: '182px', viewBox: '0 0 423 182' },
        react.createElement("defs", null,
            react.createElement("path", { d: 'M1.7325,0 L60.2675,0 C61.2243333,-3.97812036e-16 62,0.775666671 62,1.7325 L62,78.2675 C62,79.2243333 61.2243333,80 60.2675,80 L1.7325,80 C0.775666671,80 1.89353513e-15,79.2243333 0,78.2675 L0,1.7325 C-3.39222892e-16,0.775666671 0.775666671,1.95212427e-15 1.7325,0 Z', id: 'path-1' }),
            react.createElement("filter", { x: '-40.4%', y: '-18.8%', width: '180.9%', height: '162.7%', filterUnits: 'objectBoundingBox', id: 'filter-2' },
                react.createElement("feMorphology", { radius: '0.5775', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '10', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '6.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("path", { d: 'M25.6328113,12.799087 C25.6328113,19.8601093 19.8946974,25.5841793 12.8163899,25.5841793 C5.73811386,25.5841793 0,19.8601093 0,12.799087 C0,5.73806481 5.73811386,0.0139634373 12.8163899,0.0139634373 C19.8946974,0.0139634373 25.6328113,5.73806481 25.6328113,12.799087', id: 'path-3' }),
            react.createElement("path", { d: 'M2.475,0 L81.525,0 C82.8919048,-2.5109633e-16 84,1.10809524 84,2.475 L84,106.525 C84,107.891905 82.8919048,109 81.525,109 L2.475,109 C1.10809524,109 1.49966518e-15,107.891905 0,106.525 L0,2.475 C-1.67397553e-16,1.10809524 1.10809524,-5.07797419e-15 2.475,0 Z', id: 'path-5' }),
            react.createElement("filter", { x: '-43.2%', y: '-20.5%', width: '186.5%', height: '166.7%', filterUnits: 'objectBoundingBox', id: 'filter-6' },
                react.createElement("feMorphology", { radius: '0.825', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '14', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '9.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("path", { d: 'M41.1616567,20.4864617 C41.1616567,31.8008076 31.9473312,40.9729233 20.5808028,40.9729233 C9.21437667,40.9729233 0,31.8008076 0,20.4864617 C0,9.17211575 9.21437667,0 20.5808028,0 C31.9473312,0 41.1616567,9.17211575 41.1616567,20.4864617', id: 'path-7' })),
        react.createElement("g", { id: 'icons/icon-states/icon-noresult-profileviews', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("ellipse", { id: 'Oval', fill: '#C2C2C2', fillRule: 'nonzero', opacity: '0.125023251', transform: 'translate(211.500000, 126.667487) rotate(-1.000000) translate(-211.500000, -126.667487) ', cx: '211.5', cy: '126.667487', rx: '210.5', ry: '34' }),
            react.createElement("g", { id: 'Group-11', transform: 'translate(207.000000, 18.000000)' },
                react.createElement("g", { id: 'Rectangle-10' },
                    react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-2)', xlinkHref: '#path-1' }),
                    react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.5775', d: 'M60.2675,-0.28875 C60.8256528,-0.28875 61.3309653,-0.0625138876 61.6967396,0.303260419 C62.0625139,0.669034725 62.28875,1.17434722 62.28875,1.7325 L62.28875,1.7325 L62.28875,78.2675 C62.28875,78.8256528 62.0625139,79.3309653 61.6967396,79.6967396 C61.3309653,80.0625139 60.8256528,80.28875 60.2675,80.28875 L60.2675,80.28875 L1.7325,80.28875 C1.17434722,80.28875 0.669034725,80.0625139 0.303260419,79.6967396 C-0.0625138876,79.3309653 -0.28875,78.8256528 -0.28875,78.2675 L-0.28875,78.2675 L-0.28875,1.7325 C-0.28875,1.17434722 -0.0625138876,0.669034725 0.303260419,0.303260419 C0.669034725,-0.0625138876 1.17434722,-0.28875 1.7325,-0.28875 L1.7325,-0.28875 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                react.createElement("g", { id: 'Page-1', transform: 'translate(18.000000, 10.000000)' },
                    react.createElement("mask", { id: 'mask-4', fill: 'white' },
                        react.createElement("use", { xlinkHref: '#path-3' })),
                    react.createElement("use", { id: 'Fill-1', fill: '#F3F1F8', xlinkHref: '#path-3' }),
                    react.createElement("path", { d: 'M12.921485,1.89240737 C12.921485,1.89240737 4.86274784,1.37300507 8.40436528,16.3350473 L18.171628,16.3350473 C18.171628,16.3350473 22.9815993,1.68195395 12.921485,1.89240737', id: 'Fill-4', fill: '#2F3A5B', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M15.0037327,13.4600526 C14.9464241,13.5123372 14.8903394,13.5707582 14.8372991,13.6327797 C14.6495239,13.849933 14.4921919,14.1132659 14.3928276,14.3237194 C14.3659936,14.3802932 14.3410113,14.4374619 14.3190734,14.4940044 C14.0221418,15.24396 14.5590883,15.9567841 14.5590883,15.9567841 L11.7631582,15.9567841 C11.8076933,15.3844397 12.2033614,14.9069903 12.0863275,14.5329518 C12.0619415,14.4544935 12.0357352,14.3808881 12.0089012,14.3115405 C11.9283992,14.1053763 11.8393919,13.939944 11.7631582,13.8164646 C11.6540333,13.6394796 11.5698907,13.5482477 11.5698907,13.5482477 L15.0037327,13.4600526 Z', id: 'Fill-7', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M16.5730866,10.8024191 C17.4455212,10.8067709 17.2071537,10.3857388 17.7702911,9.12182859 C18.3333657,7.85794967 17.1200295,8.78407621 17.1200295,8.78407621 L16.5730866,10.8024191 Z', id: 'Fill-10', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M9.78916196,10.8024191 C8.91672736,10.8067709 9.1550949,10.3857388 8.59198887,9.12182859 C8.02888284,7.85794967 9.24225048,8.78407621 9.24225048,8.78407621 L9.78916196,10.8024191 Z', id: 'Fill-13', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M17.4419135,8.7039887 L17.4419135,8.70765175 C17.3480416,10.5347018 16.341437,12.6981266 14.9311925,13.7217468 C14.7434173,13.9389001 14.5860853,14.202233 14.486721,14.4126865 C14.4598556,14.4692603 14.4348733,14.526429 14.4129353,14.5829715 C14.0452624,14.7636196 13.6568756,14.8639622 13.2551188,14.8639622 C12.8838052,14.8639622 12.523445,14.7776143 12.1802209,14.6218875 C12.1558035,14.5434606 12.1295972,14.4698551 12.1027946,14.4005076 L12.1027946,14.3999127 C12.0222612,14.1943434 11.9332539,14.0289111 11.8570516,13.9054317 C11.8223086,13.8847683 11.788162,13.8634475 11.7540153,13.8415631 C11.0028516,13.3580399 10.3559795,12.549726 9.88407772,11.6246326 C9.41336853,10.7001341 9.11769235,9.65888744 9.06829268,8.70765175 L9.06829268,8.7039887 C9.19816297,6.29848919 11.0230006,4.3917599 13.2551188,4.3917599 C15.4872369,4.3917599 17.3120746,6.29848919 17.4419135,8.7039887', id: 'Fill-16', fill: '#000000', opacity: '0.218805804', style: { mixBlendMode: 'multiply' }, mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M17.4565702,8.35291126 C17.4565702,8.4429222 17.4541536,8.53415417 17.4492575,8.6260123 L17.4492575,8.62964404 C17.3553542,10.4567254 16.3487496,12.6201189 14.9385365,13.6437704 C14.9238798,13.6541021 14.9086268,13.6650599 14.8940015,13.6753916 C14.8507219,13.706418 14.8074109,13.7355972 14.7635349,13.7635867 C14.2977217,14.064051 13.7916733,14.238594 13.2624314,14.238594 C12.7722323,14.238594 12.3021822,14.0883775 11.8643643,13.827424 C11.8296213,13.8067606 11.795506,13.7854711 11.7613594,13.7635867 C11.0101956,13.2800322 10.3633236,12.4717496 9.89139037,11.5466249 C9.42071257,10.6221577 9.12500501,9.58091104 9.07560534,8.62964404 L9.07560534,8.6260123 C9.0707407,8.53415417 9.06829268,8.4429222 9.06829268,8.35291126 C9.06829268,5.81970578 10.9461706,3.76636041 13.2624314,3.76636041 C15.5787236,3.76636041 17.4565702,5.81970578 17.4565702,8.35291126', id: 'Fill-19', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M18.2753126,23.6822876 L8.13227965,23.6822876 C7.01228178,22.2079866 5.81360222,16.7006002 7.17080639,16.128882 C7.51465823,15.9841131 8.03291538,15.8819546 8.61456983,15.8107912 L8.61519752,15.8107912 C8.84932811,15.7822068 9.09441199,15.7584752 9.34194389,15.7390329 C9.89679572,15.6946066 10.4674655,15.6715012 10.973514,15.6599485 C11.5265141,15.6471747 12.0014602,15.6483958 12.2929308,15.6508378 C12.4038761,15.6520275 12.4880187,15.6532485 12.539835,15.6544695 L13.8677572,15.6544695 C13.9232455,15.6532485 14.0165525,15.6520275 14.1409305,15.6508378 C14.422609,15.6478009 14.8628122,15.6471747 15.3737253,15.6587274 C15.8682242,15.6696853 16.4297296,15.6909748 16.9790577,15.7323329 C17.5064792,15.7718438 18.0235123,15.8296387 18.4612675,15.9135758 C18.7661394,15.9719655 19.0319373,16.0425028 19.2368172,16.128882 C20.5940214,16.7006002 19.3953418,22.2079866 18.2753126,23.6822876', id: 'Fill-22', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M9.07642659,25.9365915 C6.95359439,23.4683811 5.98147758,16.5387912 7.33865037,15.9670417 C7.68253359,15.8223041 8.20079074,15.7201143 8.78244519,15.6489508 C8.85125212,15.6813133 11.7599094,17.9409402 16.5147867,16.5147867 C16.8566709,16.4122437 18.2804857,15.8901244 18.6291428,15.7517355 C18.9339834,15.8101565 19.1998126,15.8806938 19.4046612,15.9670417 C20.7618967,16.5387912 19.1632493,23.845332 17.5104318,25.9365915 L9.07642659,25.9365915 Z', id: 'Fill-25', fill: '#B8E7F8', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M13.4755096,5.08832257 C13.4755096,5.08832257 17.0358009,5.71580062 17.3406415,8.64467856 C17.3406415,8.64467856 17.6067218,6.40432958 16.6459704,4.96669039 C15.3046155,2.95955585 13.170669,2.89875541 13.4755096,5.08832257', id: 'Fill-28', fill: '#212B44', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M15.998192,4.74938075 C15.998192,4.74938075 15.7151953,6.9719154 12.7276765,7.09357889 C11.3860706,7.14818031 9.39790642,7.66319947 9.23049991,9.37181074 C9.23049991,9.37181074 7.95012573,3.47213324 12.5838713,3.16803713 C13.4614217,3.11043012 15.998192,2.9855732 15.998192,4.74938075', id: 'Fill-31', fill: '#2A3551', mask: 'url(#mask-4)' }),
                    react.createElement("polygon", { id: 'Fill-34', fill: '#1E283F', mask: 'url(#mask-4)', points: '15.4098971 8.0285916 15.4098971 12.747983 8.13019344 12.747983 8.13019344 8.0285916 10.7649472 8.0285916 11.6129644 6.89335789 13.6972288 6.89335789 14.4686671 8.0285916' }),
                    react.createElement("path", { d: 'M14.521699,10.2411084 C14.521699,11.2265326 13.7209159,12.0253602 12.7330794,12.0253602 C11.7452743,12.0253602 10.9444912,11.2265326 10.9444912,10.2411084 C10.9444912,9.25568421 11.7452743,8.45685662 12.7330794,8.45685662 C13.7209159,8.45685662 14.521699,9.25568421 14.521699,10.2411084', id: 'Fill-37', fill: '#2F3A5B', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M13.9569426,10.4288199 C13.9569426,11.1725138 13.3525655,11.7753837 12.607051,11.7753837 C11.861568,11.7753837 11.2571909,11.1725138 11.2571909,10.4288199 C11.2571909,9.68512596 11.861568,9.08225612 12.607051,9.08225612 C13.3525655,9.08225612 13.9569426,9.68512596 13.9569426,10.4288199', id: 'Fill-40', fill: '#1E283F', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M14.0068888,10.2976387 C14.0068888,10.9688856 13.461421,11.5130213 12.7882485,11.5130213 C12.2684849,11.5130213 11.8250177,11.1886688 11.6498905,10.7315697 C11.5981056,10.5969447 11.5698907,10.4504225 11.5698907,10.2976387 C11.5698907,9.62639186 12.1153271,9.08225612 12.7882485,9.08225612 C13.0437207,9.08225612 13.2809584,9.16052651 13.4767996,9.2948385 C13.7969559,9.5136825 14.0068888,9.88124025 14.0068888,10.2976387', id: 'Fill-43', fill: '#2F3A5B', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M13.5568622,9.72876953 C13.5568622,10.4000164 13.0113944,10.9441521 12.3385357,10.9441521 C12.0830635,10.9441521 11.845763,10.8655687 11.6499219,10.7315697 C11.598137,10.5969447 11.5698907,10.4504225 11.5698907,10.2976387 C11.5698907,9.62639186 12.1153584,9.08225612 12.7882799,9.08225612 C13.0437207,9.08225612 13.2809898,9.16052651 13.4768309,9.2948385 C13.5286472,9.42977665 13.5568622,9.57598573 13.5568622,9.72876953', id: 'Fill-46', fill: '#FFFFFF', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M12.7613647,9.83327004 C12.7613647,10.0753447 12.5646448,10.2715842 12.3219776,10.2715842 C12.0793417,10.2715842 11.8825904,10.0753447 11.8825904,9.83327004 C11.8825904,9.59119539 12.0793417,9.39495587 12.3219776,9.39495587 C12.5646448,9.39495587 12.7613647,9.59119539 12.7613647,9.83327004', id: 'Fill-49', fill: '#FFFFFF', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M13.5898107,10.8234913 C13.5898107,10.9767734 13.4652673,11.1010615 13.3115609,11.1010615 C13.1578545,11.1010615 13.0333111,10.9767734 13.0333111,10.8234913 C13.0333111,10.6702091 13.1578545,10.545921 13.3115609,10.545921 C13.4652673,10.545921 13.5898107,10.6702091 13.5898107,10.8234913', id: 'Fill-52', fill: '#FFFFFF', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M8.46798825,10.1312065 C8.47109535,9.89714674 8.59004373,9.67964899 8.78783072,9.54549354 C9.31823379,9.18579414 10.1614178,8.74813744 10.3868861,9.47536327 C10.5998948,10.1624207 10.5287454,11.2930209 10.3486281,12.0080365 C10.2710449,12.3161088 9.99633372,12.5393672 9.66817428,12.5606254 L9.07908164,12.5987588 C8.73259348,12.6212067 8.43848654,12.3522071 8.44294318,12.0169593 L8.46798825,10.1312065 Z', id: 'Fill-55', fill: '#121826', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M8.32730011,9.39495587 L8.13019344,9.49495587 C8.19443329,9.45709873 8.26055333,9.42317015 8.32730011,9.39495587', id: 'Fill-58', fill: '#FCD1C3', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M17.930534,15.7330966 L15.1671026,16.0596406 L13.3621629,13.0387167 C12.2461195,13.2437851 11.3055172,12.6360938 10.8080995,12.0960281 C10.524381,11.788269 10.6319994,11.5753735 10.7904927,11.4448185 C10.9248196,11.3339876 11.0958667,11.2826423 11.0958667,11.2826423 C11.4147363,11.7723018 11.9677364,12.0960281 12.5966877,12.0960281 C13.5843987,12.0960281 14.3853073,11.297044 14.3853073,10.3117764 C14.3853073,9.90383109 14.2481558,9.52782014 14.0174775,9.22757493 C14.023472,9.22507028 14.1609374,9.12926733 14.3470179,9.09451527 C14.5896224,9.04943153 14.9147689,9.10860394 15.1357178,9.61704839 C15.5521941,10.5760172 15.3598367,11.4441923 14.9311203,12.0550145 L16.1968692,13.6072728 L17.930534,15.7330966 Z', id: 'Fill-61', fill: '#F4C5BE', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M14.8842248,10.2995172 C14.8842248,11.4748254 13.9289029,12.4278456 12.7506862,12.4278456 C11.9896049,12.4278456 11.3220503,12.0305451 10.9444912,11.4325593 C11.0788181,11.3217285 11.2498652,11.2703831 11.2498652,11.2703831 C11.5687348,11.7600427 12.1217349,12.083769 12.7506862,12.083769 C13.7383658,12.083769 14.5393058,11.2847849 14.5393058,10.2995172 C14.5393058,9.89157194 14.4021543,9.51556099 14.171476,9.21531578 C14.1774391,9.21281113 14.3149045,9.11700817 14.5010164,9.08225612 C14.7426793,9.42727199 14.8842248,9.84680128 14.8842248,10.2995172', id: 'Fill-64', fill: '#D6A8A3', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M10.0657659,11.8257231 C9.9901285,12.1659802 9.72492696,12.4138155 9.4091959,12.4384864 L8.29001403,12.4843528 L8.3650237,13.7606298 L8.49150443,15.9166033 C8.50311681,16.7820233 6.55016642,16.1261488 6.56680036,15.4275386 L6.75906363,13.7606298 L6.96896515,10.085021 C6.98045199,9.88377218 7.10410809,9.70597316 7.28902731,9.62479112 L8.79656466,8.96281148 L8.99397504,8.86547442 C8.99491658,8.86478564 8.99585812,8.86444125 8.99679967,8.86444125 L8.99679967,8.86409686 C9.44026685,8.68163293 9.91606038,8.7268106 10.0764367,9.32670617 C10.2791825,10.0843948 10.2415207,11.0356931 10.0657659,11.8257231', id: 'Fill-67', fill: '#FCD1C3', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M8.45189319,9.39495587 L8.45189319,9.39595587 C8.44889319,9.39595587 8.44589319,9.39695587 8.44289319,9.39895587 L8.45189319,9.39495587 Z', id: 'Fill-70', fill: '#FCD1C3', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M20.6304665,20.1004436 C20.6245348,20.1101492 20.617944,20.1198547 20.6110393,20.1292471 L19.617993,21.5240255 C19.3283427,21.9310315 18.7376808,21.9720452 18.3939859,21.6088706 L14.6968881,15.422066 L16.2974868,13.689889 L18.2531853,15.8628872 L18.9050847,16.2974868 L19.3868439,16.4047977 C19.3868439,16.4047977 21.5403118,18.6690348 20.6477595,20.0732055 C20.6424241,20.0822849 20.636461,20.0913643 20.6304665,20.1004436 Z', id: 'Fill-73', fill: '#B8E7F8', mask: 'url(#mask-4)' }),
                    react.createElement("polygon", { id: 'Fill-76', fill: '#000000', mask: 'url(#mask-4)', points: '14.9118566 15.6944164 14.9106032 15.6944164 14.6968881 15.3362511' }),
                    react.createElement("path", { d: 'M19.2359642,21.7164713 C19.1452621,22.0013756 19.0489108,22.2721911 18.9491071,22.5220302 C18.0461665,22.2862798 15.9835577,18.6426366 14.9695149,16.7588249 C14.6113829,16.0944659 14.3841884,15.6489508 14.3841884,15.6489508 L15.0382476,15.6514555 L15.6524167,16.6789891 L18.521301,21.4800948 C18.714035,21.6839109 18.9845406,21.7603028 19.2359642,21.7164713', id: 'Fill-79', fill: '#000000', opacity: '0.218805804', style: { mixBlendMode: 'multiply' }, mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M7.82149369,16.0146506 L7.82049369,16.0146506 C7.81949369,15.9976506 7.81849369,15.9806506 7.81749369,15.9616506 L7.82149369,16.0146506 Z', id: 'Fill-82', fill: '#FCD1C3', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M8.23775462,22.1664001 L6.85211582,22.4369025 C6.22222294,22.480734 5.92532276,21.8764866 5.9419567,21.2471926 L6.82961292,14.0854521 L8.4799511,14.0854521 L8.9062508,20.8514576 C8.91786317,21.6310306 9.01766683,22.1119239 8.23775462,22.1664001', id: 'Fill-85', fill: '#B8E7F8', mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M7.75681387,22.7374303 C7.67050567,22.5492683 7.58608057,22.3435737 7.50479394,22.1244166 L8.30008471,21.9691282 C9.07999692,21.914652 8.98019326,21.4337587 8.96858089,20.6541856 L8.65347752,15.6530209 C8.6638345,15.6514555 8.67419149,15.6502031 8.68454847,15.6489508 L8.68517617,15.6489508 C8.69898548,15.6558386 8.87913421,15.7397445 9.19737606,15.8562108 C9.35725021,17.9974695 9.89079177,21.9631796 9.29448062,22.3604801 C9.04876904,22.5241591 8.32155191,22.651959 7.75681387,22.7374303', id: 'Fill-88', fill: '#000000', opacity: '0.218805804', style: { mixBlendMode: 'multiply' }, mask: 'url(#mask-4)' }),
                    react.createElement("path", { d: 'M13.9311756,14.197184 C13.8636983,14.2203521 13.7958758,14.2410154 13.7274883,14.2588611 L13.2385132,13.4129147 C12.2922301,13.6580576 11.570725,13.1292628 11.2571909,12.8346531 L11.5032477,12.8346531 C11.9990961,13.1283236 12.6299619,13.3193033 13.3298429,13.1906268 L13.9311756,14.197184 Z', id: 'Fill-91', fill: '#D6A8A3', mask: 'url(#mask-4)' })),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '11', y: '45', width: '40', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '11', y: '50', width: '40', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '11', y: '55', width: '40', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '11', y: '61', width: '40', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '22', y: '66', width: '18', height: '2' })),
            react.createElement("g", { id: 'Dots', transform: 'translate(110.000000, 7.000000)' },
                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(168.240984, 8.803831) rotate(61.000000) translate(-168.240984, -8.803831) ', points: '170.050213 10.6178929 166.066172 10.1569282 166.431756 6.98976916 170.415797 7.45055648' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(142.293217, 2.367666) rotate(116.000000) translate(-142.293217, -2.367666) ', points: '144.116887 2.87962203 141.382179 4.02963934 140.469546 1.85588669 143.204077 0.705692015' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(184.010310, 21.821854) rotate(245.000000) translate(-184.010310, -21.821854) ', points: '185.83398 22.3338104 183.099272 23.4838277 182.186639 21.3100751 184.92117 20.1598804' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#E5E7EB', opacity: '0.188825335', transform: 'translate(184.455287, 13.247992) rotate(72.000000) translate(-184.455287, -13.247992) ', points: '186.278958 13.7599484 183.544249 14.9099657 182.631617 12.736213 185.366148 11.5860184' }),
                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(170.760246, 39.284959) rotate(186.000000) translate(-170.760246, -39.284959) ', points: '172.539791 42.1659434 167.594916 40.4833071 168.9807 36.4039736 173.925575 38.08661' }),
                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(2.809940, 76.827745) rotate(133.000000) translate(-2.809940, -76.827745) ', points: '4.61916771 78.6418065 0.635126809 78.1808418 1.00071156 75.0136828 4.98475246 75.4744701' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#FFFFFF', transform: 'translate(22.459231, 161.111656) rotate(133.000000) translate(-22.459231, -161.111656) ', points: '24.2829017 161.623612 21.5481931 162.77363 20.6355603 160.599877 23.3700917 159.449682' }),
                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(10.176880, 101.302025) rotate(133.000000) translate(-10.176880, -101.302025) ', points: '11.956425 104.18301 7.01155012 102.500373 8.39733429 98.4210398 13.3422092 100.103676' })),
            react.createElement("g", { id: 'Group-11', transform: 'translate(141.000000, 31.000000)' },
                react.createElement("g", { id: 'Rectangle-10' },
                    react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-6)', xlinkHref: '#path-5' }),
                    react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.825', d: 'M81.525,-0.4125 C82.3223611,-0.4125 83.0442361,-0.0893055538 83.5667708,0.433229169 C84.0893056,0.955763892 84.4125,1.67763889 84.4125,2.475 L84.4125,2.475 L84.4125,106.525 C84.4125,107.322361 84.0893056,108.044236 83.5667708,108.566771 C83.0442361,109.089306 82.3223611,109.4125 81.525,109.4125 L81.525,109.4125 L2.475,109.4125 C1.67763889,109.4125 0.955763892,109.089306 0.433229169,108.566771 C-0.0893055538,108.044236 -0.4125,107.322361 -0.4125,106.525 L-0.4125,106.525 L-0.4125,2.475 C-0.4125,1.67763889 -0.0893055538,0.955763892 0.433229169,0.433229169 C0.955763892,-0.0893055538 1.67763889,-0.4125 2.475,-0.4125 L2.475,-0.4125 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                react.createElement("g", { id: 'Page-1', transform: 'translate(21.000000, 13.000000)' },
                    react.createElement("mask", { id: 'mask-8', fill: 'white' },
                        react.createElement("use", { xlinkHref: '#path-7' })),
                    react.createElement("use", { id: 'Fill-1', fill: '#F8F6FC', xlinkHref: '#path-7' }),
                    react.createElement("path", { d: 'M24.012054,24.3706811 C23.891278,24.4806811 23.7731077,24.6034459 23.6613235,24.7338899 C23.6342971,24.7645556 23.5996583,24.918037 23.5623628,25.1533447 C23.5006976,25.5318609 23.4300406,26.1227491 23.3722582,26.7519313 C23.2566424,27.9898519 23.1872115,29.3825252 23.315702,29.6204265 L17.6409698,29.6204265 C17.692366,28.965664 17.6024482,27.7737675 17.4842267,26.7800543 C17.3852661,25.9475016 17.2670957,25.2556656 17.1951104,25.1392577 C17.1912787,25.1329008 17.1873959,25.1264931 17.1835641,25.1200853 C16.9536096,24.7479259 16.7763285,24.5560996 16.7763285,24.5560996 L24.012054,24.3706811 Z', id: 'Fill-3', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M13.5197674,19.0804675 C11.720543,18.7044431 12.3987582,17.944105 11.8003962,15.0975793 C11.201983,12.2510028 13.2900172,14.6901772 13.2900172,14.6901772 L13.5197674,19.0804675 Z', id: 'Fill-6', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M28.0069615,14.4836197 C27.918321,15.9594415 27.3800404,21.2692979 25.8434169,23.7886712 C25.6211769,24.1556942 24.6653405,24.7695181 23.527012,25.2734436 C23.4652957,25.6519599 23.3946898,26.2427972 23.3368563,26.8719794 C23.2918463,26.8912027 23.2469385,26.9091038 23.2006512,26.9282762 C22.2409832,27.3234222 21.1925724,27.6201631 20.3587893,27.6201631 C19.5057453,27.6201631 18.4265786,27.3106575 17.4488248,26.9001024 C17.3498641,26.0676005 17.2316937,25.3757137 17.1597595,25.2593567 C16.0329772,24.7592962 15.0925699,24.1518292 14.8716072,23.7886712 C13.336312,21.2692979 12.7980314,15.9594415 12.7093398,14.4836197 C13.0189431,9.51266317 16.3259253,5.60066734 20.3587893,5.60066734 C24.390376,5.60066734 27.6973071,9.51266317 28.0069615,14.4836197', id: 'Fill-9', fill: '#000000', opacity: '0.218805804', style: { mixBlendMode: 'multiply' }, mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M28.0532487,13.7227259 C28.0532487,13.9120094 28.0480887,14.1038358 28.0390969,14.2969335 L28.0390969,14.3046126 C28.0364913,14.3544509 28.0339368,14.4120191 28.0301051,14.4772156 C27.9414646,15.9530375 27.4031329,21.2628939 25.8665605,23.7822672 C25.6443205,24.1492902 24.6884841,24.763165 23.5501045,25.2670396 C22.5068538,25.7299757 21.3107939,26.0982701 20.3819329,26.0982701 C19.444029,26.0982701 18.2325401,25.723568 17.182852,25.2529527 C16.0561208,24.752943 15.1157136,24.1454761 14.8946997,23.7822672 C13.3594556,21.2628939 12.8211239,15.9530375 12.7324834,14.4772156 C12.7286006,14.4120191 12.7260461,14.3544509 12.7234405,14.3046126 L12.7234405,14.2969335 C12.7145509,14.1038358 12.7093398,13.9120094 12.7093398,13.7227259 C12.7093398,8.39623975 16.1448124,4.07877433 20.3819329,4.07877433 C24.6177761,4.07877433 28.0532487,8.39623975 28.0532487,13.7227259', id: 'Fill-12', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M27.4521739,19.0804675 C29.2513472,18.7044431 28.5731831,17.944105 29.1715451,15.0975793 C29.7699071,12.2510028 27.6819241,14.6901772 27.6819241,14.6901772 L27.4521739,19.0804675 Z', id: 'Fill-15', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M33.5826523,31.991264 L33.2388701,39.4663372 L7.62706468,38.7480056 L7.12250326,31.9934 C7.05715959,31.1175694 7.60484068,30.3122243 8.44771779,30.0499125 C9.89161358,29.6000462 12.3591928,28.9562176 15.6184061,28.6321166 C16.5134458,28.5432214 17.4685158,28.4781775 18.4779451,28.4478168 C19.5233416,28.4163882 20.6264183,28.4228977 21.7828837,28.4792454 C22.73356,28.523693 23.7201012,28.6028239 24.7404638,28.7220796 C26.8659977,28.9681178 29.1354002,29.3876234 31.5223599,30.0401482 C32.377192,30.2732182 33.6229621,31.1099919 33.5826523,31.991264', id: 'Fill-18', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("g", { id: 'Group-3', mask: 'url(#mask-8)' },
                        react.createElement("g", { transform: 'translate(5.592110, 28.429062)' },
                            react.createElement("path", { d: 'M27.9905428,3.35914748 L27.6871214,9.95706785 L18.4999755,9.97196847 L12.0115895,10.0228238 L2.00399485,9.70213006 L1.53039376,3.3612834 C1.46505009,2.48545281 2.01273118,1.68010772 2.85560829,1.4177959 C4.29950408,0.967929601 6.76708326,0.324101053 10.0262966,5.32907052e-15 C11.3831357,1.62808271 14.9199702,4.79103031 19.1483543,0.0899630886 C21.2738882,0.336001202 23.5432907,0.755506865 25.9302504,1.40803167 C26.7850825,1.64110168 28.0308526,2.47787537 27.9905428,3.35914748', id: 'Fill-21', fill: '#B8E7F8' }),
                            react.createElement("g", { id: 'Group-2', strokeWidth: '1', fill: 'none', transform: 'translate(0.000000, 9.131358)' },
                                react.createElement("polygon", { id: 'Fill-39', fill: '#B8E7F8', points: '-1.55431223e-13 1.47465216 8.1219266 3.55271368e-15 8.56262596 3.90090937 0.548396343 8.42952614' }),
                                react.createElement("polygon", { id: 'Fill-42', fill: '#B8E7F8', points: '30.3332008 1.58399114 21.8884387 -3.55271368e-15 21.3516908 3.98192192 29.9972864 8.55386744' })))),
                    react.createElement("path", { d: 'M29.2938348,11.6660733 C29.4150195,11.461228 29.4857787,11.2233268 29.4857787,10.9684398 C29.4857787,10.7258599 29.4223764,10.4981806 29.3118184,10.3002007 C29.3548359,10.1669598 29.3786947,10.0251751 29.3786947,9.87769461 C29.3786947,9.32850784 29.055144,8.85570578 28.5881334,8.6342308 C28.5924761,8.58988494 28.5950305,8.54497968 28.5950305,8.49946416 C28.5950305,8.03607034 28.364514,7.62704088 28.0121487,7.37718861 C28.084134,7.21038311 28.1243416,7.02679535 28.1243416,6.8337485 C28.1243416,6.07254583 27.5044708,5.45546719 26.7397609,5.45546719 C26.6861167,5.45546719 26.6334433,5.45928134 26.5813318,5.46518056 C26.4961143,5.05055701 26.2231934,4.70474073 25.855399,4.51698283 C25.8058931,3.80063457 25.2078887,3.23446212 24.4756718,3.23446212 C24.0231196,3.23446212 23.6224746,3.45156355 23.3698362,3.78583567 C23.1171979,3.45156355 22.7166039,3.23446212 22.2640007,3.23446212 C22.2589428,3.23446212 22.2540382,3.2351741 22.2489292,3.23522495 C22.1546177,2.56546019 21.5782242,2.04958366 20.87942,2.04958366 C20.2543891,2.04958366 19.7265819,2.46196958 19.5544609,3.02814203 C19.353372,2.91478549 19.121425,2.84928381 18.8737934,2.84928381 C18.6989135,2.84928381 18.532208,2.88295005 18.3781727,2.94184052 C18.1272714,2.59022673 17.7157442,2.36005549 17.2495001,2.36005549 C16.4847901,2.36005549 15.8648683,2.97713413 15.8648683,3.73828593 C15.8648683,3.82840159 15.8742177,3.91627961 15.8907707,4.00156401 C15.6626043,3.83669101 15.3827863,3.73828593 15.0792116,3.73828593 C14.410448,3.73828593 13.8524468,4.21032516 13.7230367,4.83788 C13.3455353,5.08407068 13.0957069,5.50820418 13.0957069,5.99092302 C13.0957069,6.0016535 13.0970863,6.01202799 13.0973417,6.02270761 C13.0025704,6.00226376 12.9044783,5.99092302 12.8036273,5.99092302 C12.0389685,5.99092302 11.4190466,6.60800166 11.4190466,7.36915347 C11.4190466,7.89535363 11.7154688,8.35233967 12.1510081,8.58459599 C11.8809482,8.83612648 11.7111772,9.19302922 11.7111772,9.59020939 C11.7111772,9.60551685 11.7129654,9.62036661 11.7134763,9.63557235 C11.1170557,9.78910461 10.6758454,10.3267981 10.6758454,10.9684398 C10.6758454,11.4070163 10.8823498,11.7969241 11.2030906,12.0493191 C11.2020178,12.1503687 11.2109584,12.2529439 11.2332335,12.3558751 C11.2543846,12.4533648 11.2858559,12.5458706 11.3254504,12.6332401 C10.9650129,13.0234531 10.9737492,13.6302081 11.3539073,14.0086227 C11.5948461,14.2484564 11.9282572,14.3397417 12.2399552,14.2833432 C13.3073713,14.8461592 13.1361699,17.6466099 13.1361699,17.6466099 L13.9226951,18.1346686 C13.5668046,15.7270244 13.6125298,14.1210129 13.8398788,13.049135 C14.3723862,12.9938553 14.8136476,12.6376137 14.9925635,12.1547423 C15.2464791,12.4479233 15.6214772,12.6342064 16.0407699,12.6342064 C16.7449897,12.6342064 17.3250617,12.1104473 17.4126293,11.4331559 C17.549805,11.4784171 17.6959725,11.5038957 17.8484241,11.5038957 C18.095698,11.5038957 18.3274407,11.4385466 18.5283763,11.3254443 C19.2071534,11.4830958 19.8135365,11.6005208 20.3553934,11.4894019 C20.4067385,11.4842147 20.4567042,11.4787223 20.5064655,11.4732299 C20.7565493,11.8308446 21.1720104,12.0653894 21.6429548,12.0653894 C22.1430714,12.0653894 22.579888,11.8006366 22.8232791,11.4050838 C23.0538978,11.5761102 23.3388248,11.6785837 23.6485814,11.6785837 C23.9851089,11.6785837 24.2933839,11.5589211 24.5333009,11.3602293 C24.7029696,11.9304194 25.2324628,12.3466703 25.8603036,12.3466703 C26.127809,12.3466703 26.3767178,12.2698787 26.5884844,12.1390788 C27.0226954,13.1309104 27.2636342,14.9177126 26.7880917,18.1346686 L27.575843,17.6466099 C27.575843,17.6466099 27.4059699,14.8920307 28.4434986,14.2968707 C28.581594,14.2881236 28.7182077,14.2519146 28.843735,14.1863112 C28.8784759,14.1851415 28.9131658,14.1837684 28.9497971,14.1864638 C28.9497971,14.1864638 28.952607,14.1615955 28.9568475,14.1158766 C29.0019596,14.0839394 29.0455902,14.0488492 29.0860021,14.0086227 C29.449505,13.6467869 29.4739769,13.0758341 29.1604397,12.685316 C29.3958098,12.3921858 29.4399001,11.9978027 29.2938348,11.6660733', id: 'Fill-24', fill: '#2F3A5B', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M23.9492017,44.5960401 L17.0872482,44.5960401 C16.3540094,44.5960401 15.7595813,44.0043383 15.7595813,43.2744625 L15.7595813,35.7304295 L15.7595813,30.2579885 C15.7595813,29.5280619 16.3540094,28.9363601 17.0872482,28.9363601 L23.9492017,28.9363601 C24.6824915,28.9363601 25.2768685,29.5280619 25.2768685,30.2579885 L25.2768685,43.2744625 C25.2768685,44.0043383 24.6824915,44.5960401 23.9492017,44.5960401', id: 'Fill-27', fill: '#F7F7F7', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M18.455952,31.2942131 C18.455952,31.7559287 18.0799832,32.1301731 17.6161402,32.1301731 C17.1522973,32.1301731 16.7763285,31.7559287 16.7763285,31.2942131 C16.7763285,30.8324975 17.1522973,30.4582531 17.6161402,30.4582531 C18.0799832,30.4582531 18.455952,30.8324975 18.455952,31.2942131', id: 'Fill-30', fill: '#EAEAEA', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M18.6337591,36.5852926 C16.6937317,36.7912058 15.9498663,36.227983 15.9498663,36.227983 L15.9498663,35.0239321 C14.4420063,35.8693512 13.9003027,37.0570775 13.8067575,37.2868419 L13.726087,37.3267125 L14.1667863,41.2276219 L16.3750855,41.4185837 L16.7861529,41.4541824 L16.789678,41.4546401 C17.7563454,41.4726938 18.7713435,41.6739792 19.1885927,41.4553012 C19.7481777,41.161866 19.3749678,36.5066194 18.6337591,36.5852926', id: 'Fill-33', fill: '#C1867C', mask: 'url(#mask-8)' }),
                    react.createElement("path", { d: 'M22.6844814,36.5852926 C24.6244577,36.7912058 25.3683741,36.227983 25.3683741,36.227983 L25.3683741,35.0239321 C26.8762342,35.8693512 27.4179378,37.0570775 27.5114318,37.2868419 L27.5921535,37.3267125 L27.1514541,41.2276219 L24.943155,41.4185837 L24.5320876,41.4541824 L24.5285624,41.4546401 C23.561844,41.4726938 22.5468969,41.6739792 22.1296477,41.4553012 C21.5700628,41.161866 21.9432216,36.5066194 22.6844814,36.5852926', id: 'Fill-36', fill: '#C1867C', mask: 'url(#mask-8)' })),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '13', y: '61', width: '58', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '13', y: '69', width: '58', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '13', y: '76', width: '58', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '13', y: '84', width: '58', height: '2' }),
                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '29', y: '91', width: '26', height: '2' })),
            react.createElement("g", { id: 'icons8-preview-file-(1)', transform: 'translate(207.000000, 91.000000)' },
                react.createElement("path", { d: 'M44.9659615,14.8831452 L45.2419354,15.2945119 L45.6026862,15.8529339 C46.1958022,16.7394354 46.4807901,17.8169298 46.4990808,18.8919314 C46.5174654,19.9724561 46.2665218,21.0654524 45.7082802,21.9807006 C40.5495533,30.0943815 32.9731233,34.3314008 25.3033703,34.4648912 C17.7377973,34.5965683 10.2271767,30.728864 5.03403854,23.1168548 L4.75806457,22.7054881 L4.39731376,22.1470661 C3.80419783,21.2605646 3.51920988,20.1830702 3.50091924,19.1080686 C3.48253463,18.0275439 3.73347816,16.9345476 4.2917198,16.0192994 C9.45044665,7.90561853 17.0268767,3.66859918 24.6966297,3.53510885 C32.2622027,3.40343174 39.7728233,7.27113603 44.9659615,14.8831452 Z M24.9971996,6.05508399 C21.7559815,6.05514262 18.5088166,7.32633198 16.033617,9.89162839 C13.606368,12.4072288 12.3827831,15.7017718 12.3828386,19.0013305 C12.3828942,22.3008915 13.6065916,25.5953919 16.0339268,28.1109061 C18.5092144,30.6761146 21.756424,31.9471881 24.9976443,31.9471294 C28.2388624,31.9470708 31.4860273,30.6758815 33.9612269,28.110585 C36.3884759,25.5949846 37.6120609,22.3004417 37.6120053,19.0008829 C37.6119497,15.701322 36.3882524,12.4068215 33.9609171,9.89130738 C31.4856295,7.32609884 28.2384199,6.05502536 24.9971996,6.05508399 Z', id: 'Combined-Shape', stroke: '#B8E7F8', strokeWidth: '7', fill: '#B7E7F8', fillRule: 'nonzero' }),
                react.createElement("circle", { id: 'Oval', stroke: '#979797', fill: '#B8E7F8', cx: '25', cy: '20', r: '9' }),
                react.createElement("path", { d: 'M42.6114532,14.8601067 L42.8823529,15.2666667 C44.3211629,17.3693487 44.3707771,20.342106 43.0311954,22.5047931 L42.8823529,22.7333333 C34.0305882,36.2853333 16.4155765,36.4208533 7.38854682,23.1398933 L7.11764706,22.7333333 C5.67883705,20.6306513 5.62922291,17.657894 6.96880464,15.4952069 L7.11764706,15.2666667 C15.9694118,1.71466667 33.5844235,1.57914667 42.6114532,14.8601067 Z M20.0997533,14.0792632 C17.3946205,16.7974627 17.3946971,21.2044349 20.0999243,23.9225396 C22.8051801,26.6406157 27.1911667,26.6405387 29.8963281,23.9223678 C32.6014609,21.2041682 32.6013843,16.7971961 29.8961571,14.0790914 C27.1909013,11.3610153 22.8049147,11.3610922 20.0997533,14.0792632 Z', id: 'Combined-Shape', fill: '#FFFFFF', fillRule: 'nonzero' })))));
}
function IconNoSearchable(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: '423px', height: '182px', viewBox: '0 0 423 182' }, props),
        react.createElement("defs", null,
            react.createElement("polygon", { id: 'path-1', points: '0 0 123 0 123 87 0 87' })),
        react.createElement("g", { id: 'icons/icon-states/icon-nosearchresult-interview', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Dots', transform: 'translate(110.000000, 7.000000)' },
                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(168.240984, 8.803831) rotate(61.000000) translate(-168.240984, -8.803831) ', points: '170.050213 10.6178929 166.066172 10.1569282 166.431756 6.98976916 170.415797 7.45055648' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(142.293217, 2.367666) rotate(116.000000) translate(-142.293217, -2.367666) ', points: '144.116887 2.87962203 141.382179 4.02963934 140.469546 1.85588669 143.204077 0.705692015' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(184.010310, 21.821854) rotate(245.000000) translate(-184.010310, -21.821854) ', points: '185.83398 22.3338104 183.099272 23.4838277 182.186639 21.3100751 184.92117 20.1598804' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#E5E7EB', opacity: '0.188825335', transform: 'translate(184.455287, 13.247992) rotate(72.000000) translate(-184.455287, -13.247992) ', points: '186.278958 13.7599484 183.544249 14.9099657 182.631617 12.736213 185.366148 11.5860184' }),
                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(170.760246, 39.284959) rotate(186.000000) translate(-170.760246, -39.284959) ', points: '172.539791 42.1659434 167.594916 40.4833071 168.9807 36.4039736 173.925575 38.08661' }),
                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(2.809940, 76.827745) rotate(133.000000) translate(-2.809940, -76.827745) ', points: '4.61916771 78.6418065 0.635126809 78.1808418 1.00071156 75.0136828 4.98475246 75.4744701' }),
                react.createElement("polygon", { id: 'Fill-30', fill: '#FFFFFF', transform: 'translate(22.459231, 161.111656) rotate(133.000000) translate(-22.459231, -161.111656) ', points: '24.2829017 161.623612 21.5481931 162.77363 20.6355603 160.599877 23.3700917 159.449682' }),
                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(10.176880, 101.302025) rotate(133.000000) translate(-10.176880, -101.302025) ', points: '11.956425 104.18301 7.01155012 102.500373 8.39733429 98.4210398 13.3422092 100.103676' })),
            react.createElement("g", { id: 'Group-8', transform: 'translate(144.000000, 25.000000)' },
                react.createElement("mask", { id: 'mask-2', fill: 'white' },
                    react.createElement("use", { xlinkHref: '#path-1' })),
                react.createElement("g", { id: 'Clip-2' }),
                react.createElement("path", { d: 'M60.4677216,20.9364721 L105.535036,20.9364721 L105.535036,17.475043 L60.4677216,17.475043 L60.4677216,20.9364721 Z M83,43.2551857 L105.535036,43.2551857 L105.535036,39.7896449 L83,39.7896449 L83,43.2551857 Z M105.535036,32.0985701 L66.1887056,32.0985701 C67.7153126,34.4765465 68.6110048,37.2609034 68.6110048,40.2481078 L68.6110048,55.2882947 L97.1773112,55.2882947 C110.274827,55.9427522 123,67 123,67 C118.908362,57.0248343 118.908362,43.360036 118.908362,43.360036 C118.826309,43.6012601 118.908362,42.3163305 118.908362,41.4137959 L118.908362,13.8751841 C118.908362,6.21289174 112.397183,0 104.364224,0 L57.5448277,0 C49.513937,0 43,6.21289174 43,13.8751841 L43,24.571281 L52.1768802,24.571281 C56.409181,24.571281 60.2601748,26.1179936 63.1775525,28.6343998 L105.535036,28.6343998 L105.535036,32.0985701 Z', id: 'Fill-1', fillOpacity: '0.388822115', fill: '#C2C2C2', mask: 'url(#mask-2)' }),
                react.createElement("path", { d: 'M63,32 C62.3789581,31.6450216 61.7139939,31.3062771 61,31 L61,32 L63,32 Z', id: 'Fill-3', fill: '#B8E7F8', mask: 'url(#mask-2)' }),
                react.createElement("path", { d: 'M59.7431545,59.7949712 C59.7431545,63.8008641 56.368634,67.0584865 52.216587,67.0584865 L24.4114679,67.0619221 C19.4286015,67.3113456 14.6069796,69.4620222 10.9864929,71.5886498 C11.8719714,66.8557869 11.9881221,62.5812312 12.0031534,61.4488622 C12.0379986,61.1307269 12.030483,60.8057205 12.0188679,60.4717816 C12.0120355,60.2539655 12.0052031,60.0052291 12.0052031,59.7949712 L12.0052031,40.3413109 C12.0052031,36.3333566 15.3824565,33.0729858 19.5338204,33.0729858 L52.216587,33.0729858 C56.368634,33.0729858 59.7431545,36.3333566 59.7431545,40.3413109 L59.7431545,59.7949712 Z M61.7703264,32.1694268 L60.4325432,32.1694268 L60.4325432,30.8996343 C58.2099648,29.0938905 55.3444579,28 52.216587,28 L19.5338204,28 C12.4848373,28 6.7517738,33.5354156 6.7517738,40.3413109 L6.7517738,59.7949712 C6.7517738,59.8492535 6.7517738,59.9104069 6.75314027,59.9674376 L6.7517738,61.166457 C6.7517738,61.2585307 6.71077942,70.440477 4.07620749,76.9454149 L0,87 L8.28906291,79.7419817 C8.3717349,79.6712086 16.6143375,72.5348101 24.5481158,72.1321594 L52.216587,72.1321594 C59.2642035,72.1321594 65,66.5953695 65,59.7949712 L65,40.3413109 C65,37.2053083 63.7722184,34.3489623 61.7703264,32.1694268 L61.7703264,32.1694268 Z', id: 'Fill-4', fillOpacity: '0.764040647', fill: '#B8E7F8', mask: 'url(#mask-2)' }),
                react.createElement("polygon", { id: 'Fill-5', fill: '#B8E7F8', mask: 'url(#mask-2)', points: '19 43 53 43 53 40 19 40' }),
                react.createElement("polygon", { id: 'Fill-6', fill: '#B8E7F8', mask: 'url(#mask-2)', points: '19 52 53 52 53 49 19 49' }),
                react.createElement("polygon", { id: 'Fill-7', fill: '#B8E7F8', mask: 'url(#mask-2)', points: '19 60 36 60 36 57 19 57' })),
            react.createElement("ellipse", { id: 'Oval', fill: '#C2C2C2', fillRule: 'nonzero', opacity: '0.125023251', transform: 'translate(211.500000, 126.667487) rotate(-1.000000) translate(-211.500000, -126.667487) ', cx: '211.5', cy: '126.667487', rx: '210.5', ry: '34' }),
            react.createElement("g", { id: 'Group', transform: 'translate(205.000000, 83.000000)' },
                react.createElement("circle", { id: 'Oval', fill: '#B8E7F8', fillRule: 'nonzero', cx: '40', cy: '26', r: '19' }),
                react.createElement("path", { d: 'M62.03201,43.3568587 C65.8729411,43.3559039 68.9874049,46.4688197 68.9883596,50.3097508 C68.9883599,50.3109032 68.9883599,50.3120557 68.9883596,50.3132082 L68.982522,73.7986793 C68.9815667,77.6420797 65.8661138,80.7575326 62.0227134,80.758488 C58.1817824,80.7594427 55.0673186,77.6465269 55.0663639,73.8055959 C55.0663636,73.8044434 55.0663636,73.803291 55.0663639,73.8021385 L55.0722015,50.3166674 C55.0731568,46.473267 58.1886097,43.3578141 62.03201,43.3568587 Z', id: 'Rectangle', fill: '#B8E7F8', fillRule: 'nonzero', transform: 'translate(62.027362, 62.057673) rotate(-42.000000) translate(-62.027362, -62.057673) ' }),
                react.createElement("path", { d: 'M61.1622286,51.186664 C64.5230433,51.1858286 67.2481991,53.9096299 67.2490345,57.2704446 C67.2490348,57.271453 67.2490348,57.2724614 67.2490345,57.2734698 L67.2431969,80.75885 C67.242361,84.1218254 64.5163398,86.8478467 61.1533644,86.8486826 C57.7925498,86.8495181 55.067394,84.1257167 55.0665585,80.7649021 C55.0665583,80.7638937 55.0665583,80.7628853 55.0665585,80.7618768 L55.0723961,57.2764966 C55.073232,53.9135213 57.7992533,51.1875 61.1622286,51.186664 Z', id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2.2', transform: 'translate(61.157797, 69.017673) rotate(-42.000000) translate(-61.157797, -69.017673) ' }),
                react.createElement("g", { id: 'Group-7', fillRule: 'nonzero' },
                    react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '28', cy: '28', r: '28' }),
                    react.createElement("circle", { id: 'Oval', stroke: '#C2C2C2', strokeWidth: '2.2', fill: '#FFFFFF', cx: '28.4375', cy: '28.4375', r: '23.1875' }),
                    react.createElement("circle", { id: 'Oval', fill: '#B8E7F8', cx: '29.75', cy: '25.375', r: '14' }),
                    react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '32.375', cy: '21.875', r: '8.75' }))))));
}
function IconNoAppliedJob(props) {
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: 251, height: 123, viewBox: '0 0 251 123', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        react.createElement("defs", null,
            react.createElement("path", { d: 'M1.7325,0 L34.8792339,0 C35.8360673,-3.35307768e-15 36.6117339,0.775666671 36.6117339,1.7325 L36.6117339,45.8538422 C36.6117339,46.8106756 35.8360673,47.5863422 34.8792339,47.5863422 L1.7325,47.5863422 C0.775666671,47.5863422 -1.65917855e-15,46.8106756 0,45.8538422 L0,1.7325 C-3.39222892e-16,0.775666671 0.775666671,-1.60058941e-15 1.7325,0 Z', id: 'path-1' }),
            react.createElement("filter", { x: '-68.5%', y: '-31.7%', width: '237.0%', height: '205.4%', filterUnits: 'objectBoundingBox', id: 'filter-2' },
                react.createElement("feMorphology", { radius: '0.5775', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '10', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '6.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("path", { d: 'M2.475,0 L47.1279943,0 C48.4948991,1.9299288e-16 49.6029943,1.10809524 49.6029943,2.475 L49.6029943,62.3613913 C49.6029943,63.728296 48.4948991,64.8363913 47.1279943,64.8363913 L2.475,64.8363913 C1.10809524,64.8363913 1.49966518e-15,63.728296 0,62.3613913 L0,2.475 C-1.67397553e-16,1.10809524 1.10809524,1.58336396e-15 2.475,0 Z', id: 'path-3' }),
            react.createElement("filter", { x: '-73.2%', y: '-34.4%', width: '246.5%', height: '212.1%', filterUnits: 'objectBoundingBox', id: 'filter-4' },
                react.createElement("feMorphology", { radius: '0.825', operator: 'dilate', in: 'SourceAlpha', result: 'shadowSpreadOuter1' }),
                react.createElement("feOffset", { dx: '0', dy: '14', in: 'shadowSpreadOuter1', result: 'shadowOffsetOuter1' }),
                react.createElement("feGaussianBlur", { stdDeviation: '9.5', in: 'shadowOffsetOuter1', result: 'shadowBlurOuter1' }),
                react.createElement("feComposite", { in: 'shadowBlurOuter1', in2: 'SourceAlpha', operator: 'out', result: 'shadowBlurOuter1' }),
                react.createElement("feColorMatrix", { values: '0 0 0 0 0.488519387   0 0 0 0 0.540303432   0 0 0 0 0.621678359  0 0 0 0.0983355978 0', type: 'matrix', in: 'shadowBlurOuter1' })),
            react.createElement("polygon", { id: 'path-5', points: '0 0 12.9912604 0 12.9912604 13.0862441 0 13.0862441' })),
        react.createElement("g", { id: 'MY-JOBS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/MYJOBS-APPLIED-EMPTYSTATE', transform: 'translate(-524.000000, -277.000000)' },
                react.createElement("g", { id: 'Group-6', transform: 'translate(312.000000, 191.000000)' },
                    react.createElement("g", { id: 'emptystates/noresult-nojobs', transform: 'translate(11.510675, 66.000000)' },
                        react.createElement("g", { id: 'icons/icon-states/icon-successfulapply', transform: 'translate(200.828352, 20.000000)' },
                            react.createElement("ellipse", { id: 'Oval', fill: '#C2C2C2', fillRule: 'nonzero', opacity: '0.125023251', transform: 'translate(124.893254, 71.974343) rotate(-1.000000) translate(-124.893254, -71.974343) ', cx: '124.893254', cy: '71.9743426', rx: '124.303019', ry: '20.2241571' }),
                            react.createElement("g", { id: 'Group-11-Copy', transform: 'translate(122.235950, 11.896586)' },
                                react.createElement("g", { id: 'Rectangle-10' },
                                    react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-2)', xlinkHref: '#path-1' }),
                                    react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.5775', d: 'M34.8792339,-0.28875 C35.4373867,-0.28875 35.9426992,-0.0625138876 36.3084735,0.303260419 C36.6742478,0.669034725 36.9004839,1.17434722 36.9004839,1.7325 L36.9004839,1.7325 L36.9004839,45.8538422 C36.9004839,46.411995 36.6742478,46.9173075 36.3084735,47.2830818 C35.9426992,47.6488561 35.4373867,47.8750922 34.8792339,47.8750922 L34.8792339,47.8750922 L1.7325,47.8750922 C1.17434722,47.8750922 0.669034725,47.6488561 0.303260419,47.2830818 C-0.0625138876,46.9173075 -0.28875,46.411995 -0.28875,45.8538422 L-0.28875,45.8538422 L-0.28875,1.7325 C-0.28875,1.17434722 -0.0625138876,0.669034725 0.303260419,0.303260419 C0.669034725,-0.0625138876 1.17434722,-0.28875 1.7325,-0.28875 L1.7325,-0.28875 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                                react.createElement("path", { d: 'M31.5923833,2.97414639 C30.9428203,2.97414639 30.4113596,3.44257445 30.4113596,4.01509763 L30.4113596,4.27533543 L29.8208478,4.27533543 C29.6436942,4.27533543 29.5255919,4.37943056 29.5255919,4.53557324 L29.5255919,6.87771353 C29.5255919,7.03385621 29.6436942,7.13795133 29.8208478,7.13795133 L33.3639188,7.13795133 C33.5410724,7.13795133 33.6591747,7.03385621 33.6591747,6.87771353 L33.6591747,4.53557324 C33.6591747,4.37943056 33.5410724,4.27533543 33.3639188,4.27533543 L32.773407,4.27533543 L32.773407,4.01509763 C32.773407,3.44257445 32.2419463,2.97414639 31.5923833,2.97414639 Z M31.8876392,6.01892876 L31.8876392,6.35723791 L31.2971274,6.35723791 L31.2971274,6.01892876 C31.1199738,5.94085741 31.0018715,5.75869095 31.0018715,5.57652448 C31.0018715,5.29026289 31.2676018,5.05604886 31.5923833,5.05604886 C31.9171648,5.05604886 32.1828951,5.29026289 32.1828951,5.57652448 C32.1828951,5.75869095 32.0647928,5.94085741 31.8876392,6.01892876 Z M32.1828951,4.27533543 L31.0018715,4.27533543 L31.0018715,4.01509763 C31.0018715,3.72883604 31.2676018,3.49462201 31.5923833,3.49462201 C31.9171648,3.49462201 32.1828951,3.72883604 32.1828951,4.01509763 L32.1828951,4.27533543 Z', id: 'Shape', fill: '#E5E7EB', fillRule: 'nonzero' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.49563021', y: '26.7673175', width: '23.6204735', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.49563021', y: '29.7414639', width: '23.6204735', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.49563021', y: '32.7156103', width: '23.6204735', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '6.49563021', y: '36.2845859', width: '23.6204735', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '12.9912604', y: '39.2587323', width: '10.6292131', height: '1.18965856' })),
                            react.createElement("g", { id: 'Dots-Copy', transform: 'translate(64.956302, 5.353464)' },
                                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(99.348293, 5.236776) rotate(61.000000) translate(-99.348293, -5.236776) ', points: '100.42596 6.31315432 98.0593347 6.03318787 98.2706261 4.16039829 100.637251 4.44025983' }),
                                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(84.025829, 1.408357) rotate(116.000000) translate(-84.025829, -1.408357) ', points: '85.1082177 1.70799532 83.4818456 2.3927003 82.9434398 1.10882259 84.569707 0.424013026' }),
                                react.createElement("polygon", { id: 'Fill-30', fill: '#D7D7D7', transform: 'translate(108.660266, 12.980278) rotate(245.000000) translate(-108.660266, -12.980278) ', points: '109.744479 13.2860046 108.121805 13.9614679 107.576053 12.6746558 109.198622 11.9990873' }),
                                react.createElement("polygon", { id: 'Fill-30', fill: '#E5E7EB', opacity: '0.188825335', transform: 'translate(108.923031, 7.880294) rotate(72.000000) translate(-108.923031, -7.880294) ', points: '110.007701 8.18513506 108.383603 8.86123805 107.83836 7.57555718 109.462353 6.89934915' }),
                                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(100.835946, 23.367843) rotate(186.000000) translate(-100.835946, -23.367843) ', points: '101.888166 25.0822005 98.9671703 24.0791791 99.7837268 21.6534865 102.704722 22.6565079' }),
                                react.createElement("polygon", { id: 'Fill-28', fill: '#D7D7D7', transform: 'translate(1.659302, 45.699392) rotate(133.000000) translate(-1.659302, -45.699392) ', points: '2.72794444 46.7703638 0.367113429 46.5058125 0.590660155 44.6284202 2.95149155 44.8928664' }),
                                react.createElement("polygon", { id: 'Fill-30', fill: '#FFFFFF', transform: 'translate(13.262442, 95.833930) rotate(133.000000) translate(-13.262442, -95.833930) ', points: '14.34245 96.1333467 12.7187804 96.8206441 12.1824335 95.5346175 13.8059984 94.8472155' }),
                                react.createElement("polygon", { id: 'Fill-36', fill: '#B8E7F8', transform: 'translate(6.009568, 60.257410) rotate(133.000000) translate(-6.009568, -60.257410) ', points: '7.05831592 61.9606191 4.13051303 60.9742721 4.96081988 58.5542013 7.88862277 59.5405483' })),
                            react.createElement("g", { id: 'Group-11-Copy-2', transform: 'translate(83.262169, 19.629366)' },
                                react.createElement("g", { id: 'Rectangle-10' },
                                    react.createElement("use", { fill: 'black', fillOpacity: '1', filter: 'url(#filter-4)', xlinkHref: '#path-3' }),
                                    react.createElement("path", { strokeOpacity: '0.104959239', stroke: '#C9D1DB', strokeWidth: '0.825', d: 'M47.1279943,-0.4125 C47.9253555,-0.4125 48.6472305,-0.0893055538 49.1697652,0.433229169 C49.6922999,0.955763892 50.0154943,1.67763889 50.0154943,2.475 L50.0154943,2.475 L50.0154943,62.3613913 C50.0154943,63.1587524 49.6922999,63.8806274 49.1697652,64.4031621 C48.6472305,64.9256968 47.9253555,65.2488913 47.1279943,65.2488913 L47.1279943,65.2488913 L2.475,65.2488913 C1.67763889,65.2488913 0.955763892,64.9256968 0.433229169,64.4031621 C-0.0893055538,63.8806274 -0.4125,63.1587524 -0.4125,62.3613913 L-0.4125,62.3613913 L-0.4125,2.475 C-0.4125,1.67763889 -0.0893055538,0.955763892 0.433229169,0.433229169 C0.955763892,-0.0893055538 1.67763889,-0.4125 2.475,-0.4125 L2.475,-0.4125 Z', fill: '#FFFFFF', fillRule: 'evenodd' })),
                                react.createElement("path", { d: 'M43.9931319,4.16380495 C43.3435689,4.16380495 42.8121082,4.6991513 42.8121082,5.3534635 L42.8121082,5.65087814 L42.2215964,5.65087814 C42.0444428,5.65087814 41.9263405,5.769844 41.9263405,5.94829278 L41.9263405,8.62502453 C41.9263405,8.80347331 42.0444428,8.92243917 42.2215964,8.92243917 L45.7646674,8.92243917 C45.941821,8.92243917 46.0599233,8.80347331 46.0599233,8.62502453 L46.0599233,5.94829278 C46.0599233,5.769844 45.941821,5.65087814 45.7646674,5.65087814 L45.1741556,5.65087814 L45.1741556,5.3534635 C45.1741556,4.6991513 44.6426949,4.16380495 43.9931319,4.16380495 Z M44.2883878,7.64355622 L44.2883878,8.03019525 L43.697876,8.03019525 L43.697876,7.64355622 C43.5207224,7.55433183 43.4026201,7.34614158 43.4026201,7.13795133 C43.4026201,6.81079523 43.6683504,6.54312206 43.9931319,6.54312206 C44.3179134,6.54312206 44.5836437,6.81079523 44.5836437,7.13795133 C44.5836437,7.34614158 44.4655414,7.55433183 44.2883878,7.64355622 Z M44.5836437,5.65087814 L43.4026201,5.65087814 L43.4026201,5.3534635 C43.4026201,5.0263074 43.6683504,4.75863422 43.9931319,4.75863422 C44.3179134,4.75863422 44.5836437,5.0263074 44.5836437,5.3534635 L44.5836437,5.65087814 Z', id: 'Shape', fill: '#E5E7EB', fillRule: 'nonzero' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.67665389', y: '36.2845859', width: '34.2496866', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.67665389', y: '41.0432202', width: '34.2496866', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.67665389', y: '45.2070251', width: '34.2496866', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '7.67665389', y: '49.9656593', width: '34.2496866', height: '1.18965856' }),
                                react.createElement("rect", { id: 'Rectangle-11', fill: '#E5E7EB', x: '17.1248433', y: '54.1294643', width: '15.3533078', height: '1.18965856' })),
                            react.createElement("path", { d: 'M109.572106,45.8375264 C109.793481,46.1314563 110.0478,46.3977658 110.331047,46.6277979 L108.984721,48.0059292 C108.774997,48.2244185 108.432691,48.2244185 108.222967,48.0059292 C108.01003,47.7911501 108.01003,47.4403306 108.222967,47.2251393 L109.572106,45.8375264 Z M113.057448,40.8980201 C112.894732,40.8980201 112.762148,41.0336484 112.762148,41.2010194 C112.762148,41.3683904 112.894732,41.5040187 113.057448,41.5040187 C113.660503,41.5040187 114.20289,41.8717402 114.439934,42.441049 C114.487744,42.5564773 114.596623,42.625322 114.711529,42.625322 C114.750099,42.625322 114.789472,42.6174894 114.827238,42.6009996 C114.9775,42.5350406 115.047006,42.3569513 114.983125,42.2035965 C114.653273,41.4104393 113.897546,40.8980201 113.057448,40.8980201 L113.057448,40.8980201 Z M113.057448,40.3447889 C114.508636,40.3447889 115.689434,41.5563736 115.689434,43.0453985 C115.689434,44.5344235 114.508636,45.7460082 113.057448,45.7460082 C111.60626,45.7460082 110.425864,44.5344235 110.425864,43.0453985 C110.425864,41.5563736 111.60626,40.3447889 113.057448,40.3447889 L113.057448,40.3447889 Z M113.057448,39.7392026 C111.280828,39.7392026 109.835265,41.2220438 109.835265,43.0453985 C109.835265,44.868341 111.280828,46.3520067 113.057448,46.3520067 C114.83447,46.3520067 116.280033,44.868341 116.280033,43.0453985 C116.280033,41.2220438 114.83447,39.7392026 113.057448,39.7392026 L113.057448,39.7392026 Z M113.082759,39.1327918 C114.449978,39.1327918 115.651667,39.8690594 116.330656,40.9751098 C116.705506,41.583994 116.921256,42.3017106 116.921256,43.0713699 C116.921256,43.9803677 116.617117,44.8225819 116.109282,45.4891803 C115.409401,46.4130188 114.31418,47.0095357 113.082759,47.0095357 C112.321006,47.0095357 111.612688,46.7823894 111.016062,46.3882842 C110.650051,46.146297 110.325422,45.8461835 110.059451,45.4949517 C109.973875,45.3857071 109.897539,45.270691 109.826426,45.1494913 C109.773392,45.0645691 109.723171,44.9771734 109.678977,44.8889532 C109.489744,44.5162847 109.353946,44.1073388 109.292074,43.6773684 C109.25953,43.4803158 109.244665,43.2774918 109.244665,43.0713699 C109.244665,40.8992569 110.965841,39.1327918 113.082759,39.1327918 L113.082759,39.1327918 Z M107.473267,39.1327918 L108.654065,39.1327918 L108.654065,37.3152085 L107.473267,37.3152085 L107.473267,39.1327918 Z M99.7966763,36.9215156 L106.882668,38.566781 L106.882668,39.1327918 C106.882668,39.4662971 107.148237,39.7392026 107.473267,39.7392026 L108.654065,39.7392026 C108.978694,39.7392026 109.244665,39.4662971 109.244665,39.1327918 L109.244665,38.566781 L116.330656,36.9215156 L116.330656,39.9873734 C115.521896,39.090743 114.364401,38.5272056 113.082759,38.5272056 C110.641212,38.5272056 108.654065,40.5657516 108.654065,43.0713699 L100.682576,43.0713699 C100.51986,43.0713699 100.387276,43.2078226 100.387276,43.3743692 C100.387276,43.5409157 100.51986,43.6773684 100.682576,43.6773684 L108.695447,43.6773684 C108.748882,44.1044531 108.863788,44.5105133 109.026103,44.8889532 L100.091976,44.8889532 C99.9296617,44.8889532 99.7966763,44.7529127 99.7966763,44.5859539 L99.7966763,36.9215156 Z M115.445158,32.7710442 C115.28204,32.7710442 115.149457,32.9066724 115.149457,33.0740435 L115.149457,33.680042 C115.149457,33.847413 115.28204,33.9830412 115.445158,33.9830412 C115.607875,33.9830412 115.740458,33.847413 115.740458,33.680042 L115.740458,33.0740435 C115.740458,32.9066724 115.607875,32.7710442 115.445158,32.7710442 L115.445158,32.7710442 Z M113.968659,32.7710442 C113.805943,32.7710442 113.673359,32.9066724 113.673359,33.0740435 L113.673359,33.680042 C113.673359,33.847413 113.805943,33.9830412 113.968659,33.9830412 C114.131777,33.9830412 114.263959,33.847413 114.263959,33.680042 L114.263959,33.0740435 C114.263959,32.9066724 114.131777,32.7710442 113.968659,32.7710442 L113.968659,32.7710442 Z M112.492562,32.7710442 C112.329444,32.7710442 112.197262,32.9066724 112.197262,33.0740435 L112.197262,33.680042 C112.197262,33.847413 112.329444,33.9830412 112.492562,33.9830412 C112.655278,33.9830412 112.78746,33.847413 112.78746,33.680042 L112.78746,33.0740435 C112.78746,32.9066724 112.655278,32.7710442 112.492562,32.7710442 L112.492562,32.7710442 Z M111.016062,32.7710442 C110.852944,32.7710442 110.720762,32.9066724 110.720762,33.0740435 L110.720762,33.680042 C110.720762,33.847413 110.852944,33.9830412 111.016062,33.9830412 C111.17918,33.9830412 111.311362,33.847413 111.311362,33.680042 L111.311362,33.0740435 C111.311362,32.9066724 111.17918,32.7710442 111.016062,32.7710442 L111.016062,32.7710442 Z M109.539965,32.7710442 C109.376847,32.7710442 109.244665,32.9066724 109.244665,33.0740435 L109.244665,33.680042 C109.244665,33.847413 109.376847,33.9830412 109.539965,33.9830412 C109.703083,33.9830412 109.835265,33.847413 109.835265,33.680042 L109.835265,33.0740435 C109.835265,32.9066724 109.703083,32.7710442 109.539965,32.7710442 L109.539965,32.7710442 Z M108.063867,32.7710442 C107.900749,32.7710442 107.768567,32.9066724 107.768567,33.0740435 L107.768567,33.680042 C107.768567,33.847413 107.900749,33.9830412 108.063867,33.9830412 C108.226583,33.9830412 108.358765,33.847413 108.358765,33.680042 L108.358765,33.0740435 C108.358765,32.9066724 108.226583,32.7710442 108.063867,32.7710442 L108.063867,32.7710442 Z M106.587368,32.7710442 C106.424652,32.7710442 106.292068,32.9066724 106.292068,33.0740435 L106.292068,33.680042 C106.292068,33.847413 106.424652,33.9830412 106.587368,33.9830412 C106.750486,33.9830412 106.882668,33.847413 106.882668,33.680042 L106.882668,33.0740435 C106.882668,32.9066724 106.750486,32.7710442 106.587368,32.7710442 L106.587368,32.7710442 Z M105.110869,32.7710442 C104.948152,32.7710442 104.81597,32.9066724 104.81597,33.0740435 L104.81597,33.680042 C104.81597,33.847413 104.948152,33.9830412 105.110869,33.9830412 C105.273987,33.9830412 105.406168,33.847413 105.406168,33.680042 L105.406168,33.0740435 C105.406168,32.9066724 105.273987,32.7710442 105.110869,32.7710442 L105.110869,32.7710442 Z M103.634771,32.7710442 C103.471653,32.7710442 103.339471,32.9066724 103.339471,33.0740435 L103.339471,33.680042 C103.339471,33.847413 103.471653,33.9830412 103.634771,33.9830412 C103.797889,33.9830412 103.930071,33.847413 103.930071,33.680042 L103.930071,33.0740435 C103.930071,32.9066724 103.797889,32.7710442 103.634771,32.7710442 L103.634771,32.7710442 Z M102.158673,32.7710442 C101.995555,32.7710442 101.863374,32.9066724 101.863374,33.0740435 L101.863374,33.680042 C101.863374,33.847413 101.995555,33.9830412 102.158673,33.9830412 C102.321791,33.9830412 102.453973,33.847413 102.453973,33.680042 L102.453973,33.0740435 C102.453973,32.9066724 102.321791,32.7710442 102.158673,32.7710442 L102.158673,32.7710442 Z M100.682576,32.7710442 C100.519458,32.7710442 100.387276,32.9066724 100.387276,33.0740435 L100.387276,33.680042 C100.387276,33.847413 100.519458,33.9830412 100.682576,33.9830412 C100.845292,33.9830412 100.977474,33.847413 100.977474,33.680042 L100.977474,33.0740435 C100.977474,32.9066724 100.845292,32.7710442 100.682576,32.7710442 L100.682576,32.7710442 Z M99.5013764,32.1650457 L104.26394,32.1650457 L111.862589,32.1650457 L116.625956,32.1650457 C116.788271,32.1650457 116.921256,32.3014984 116.921256,32.4680449 L116.921256,32.7710442 C116.758138,32.7710442 116.625956,32.9066724 116.625956,33.0740435 L116.625956,33.680042 C116.625956,33.847413 116.758138,33.9830412 116.921256,33.9830412 L116.921256,35.4370254 C116.921256,35.8282449 116.685016,36.1675216 116.330656,36.2949049 C116.298113,36.30686 116.265971,36.3155171 116.230214,36.3249987 L109.244665,37.9426437 L109.244665,37.3152085 C109.244665,36.9821155 108.978694,36.70921 108.654065,36.70921 L107.473267,36.70921 C107.148237,36.70921 106.882668,36.9821155 106.882668,37.3152085 L106.882668,37.9426437 L99.8967167,36.3249987 C99.8617628,36.3155171 99.8292196,36.30686 99.7966763,36.2949049 C99.4423165,36.1675216 99.2060766,35.8282449 99.2060766,35.4370254 L99.2060766,33.9830412 C99.3687928,33.9830412 99.5013764,33.847413 99.5013764,33.680042 L99.5013764,33.0740435 C99.5013764,32.9066724 99.3687928,32.7710442 99.2060766,32.7710442 L99.2060766,32.4680449 C99.2060766,32.3014984 99.339062,32.1650457 99.5013764,32.1650457 L99.5013764,32.1650457 Z M106.31296,30.3474624 L109.814373,30.3474624 C109.913208,30.3474624 110.005213,30.3977562 110.059853,30.4822662 L110.759734,31.5594594 L105.367599,31.5594594 L106.067078,30.4822662 C106.12212,30.3977562 106.214125,30.3474624 106.31296,30.3474624 L106.31296,30.3474624 Z M106.31296,29.7414639 C106.016053,29.7414639 105.74044,29.8927574 105.576116,30.1462874 L104.658075,31.5594594 L99.5013764,31.5594594 C99.0140312,31.5594594 98.6154769,31.9679931 98.6154769,32.4680449 L98.6154769,35.4370254 C98.6154769,35.9308936 98.8400655,36.3732313 99.2060766,36.6490224 L99.2060766,44.5859539 C99.2060766,45.0860058 99.604631,45.4949517 100.091976,45.4949517 L109.073511,45.4949517 L107.803521,46.7943444 C107.363585,47.2486372 107.363585,47.9824313 107.803521,48.4367241 C108.024896,48.6609847 108.314571,48.7760008 108.603844,48.7760008 C108.893519,48.7760008 109.182391,48.6609847 109.403765,48.4367241 L110.756118,47.0458132 C110.779822,47.0214908 110.800714,47.0008786 110.818392,46.9736705 C111.479703,47.3826165 112.256322,47.6155342 113.082759,47.6155342 C115.524709,47.6155342 117.511856,45.5769882 117.511856,43.0713699 C117.511856,42.2472944 117.296106,41.4747493 116.921256,40.808151 L116.921256,36.6490224 C117.287267,36.3732313 117.511856,35.9308936 117.511856,35.4370254 L117.511856,32.4680449 C117.511856,31.9679931 117.113301,31.5594594 116.625956,31.5594594 L111.469257,31.5594594 L110.551618,30.1462874 C110.386491,29.8927574 110.11128,29.7414639 109.814373,29.7414639 L106.31296,29.7414639 Z', id: 'Fill-41', fill: '#C2C2C2' }),
                            react.createElement("g", { id: 'Group-3', transform: 'translate(134.046187, 19.629366)' },
                                react.createElement("mask", { id: 'mask-6', fill: 'white' },
                                    react.createElement("use", { xlinkHref: '#path-5' })),
                                react.createElement("g", { id: 'Clip-2' }),
                                react.createElement("path", { d: 'M7.53275105,11.0660357 C7.68470272,11.2680981 7.85975105,11.451451 8.0546544,11.6094422 L7.12876219,12.5569736 C6.9845094,12.7070653 6.74908561,12.7070653 6.60483282,12.5569736 C6.45895921,12.4089608 6.45895921,12.1678164 6.60483282,12.0198036 L7.53275105,11.0660357 Z M9.92913027,7.6700566 C9.81688863,7.6700566 9.72612283,7.76318825 9.72612283,7.87835551 C9.72612283,7.99352277 9.81688863,8.08665442 9.92913027,8.08665442 C10.3436544,8.08665442 10.7164425,8.33944033 10.8793347,8.73109218 C10.9121563,8.81008778 10.9871191,8.85748513 11.066134,8.85748513 C11.0924723,8.85748513 11.119621,8.85249594 11.1455541,8.84085448 C11.2488812,8.79595172 11.2966953,8.67330067 11.2525281,8.56769603 C11.0260188,8.02262641 10.5065466,7.6700566 9.92913027,7.6700566 L9.92913027,7.6700566 Z M9.92913027,7.28963044 C10.9263385,7.28963044 11.7383682,8.12282609 11.7383682,9.14644271 C11.7383682,10.1700593 10.9263385,11.003255 9.92913027,11.003255 C8.93111166,11.003255 8.11948711,10.1700593 8.11948711,9.14644271 C8.11948711,8.12282609 8.93111166,7.28963044 9.92913027,7.28963044 L9.92913027,7.28963044 Z M9.92913027,6.87344838 C8.7074388,6.87344838 7.71347224,7.89290733 7.71347224,9.14644271 C7.71347224,10.3995623 8.7074388,11.4198528 9.92913027,11.4198528 C11.1504165,11.4198528 12.1443831,10.3995623 12.1443831,9.14644271 C12.1443831,7.89290733 11.1504165,6.87344838 9.92913027,6.87344838 L9.92913027,6.87344838 Z M9.94655406,6.45685055 C10.8862232,6.45685055 11.7124351,6.96283813 12.1792307,7.72285892 C12.4369407,8.14153557 12.5852455,8.63546593 12.5852455,9.16432066 C12.5852455,9.7892174 12.37616,10.3683798 12.0268738,10.8265543 C11.5458961,11.4618452 10.792621,11.8717908 9.94655406,11.8717908 C9.42262468,11.8717908 8.93556891,11.7154626 8.52550199,11.4447988 C8.27387002,11.2780765 8.05019715,11.0722722 7.86785514,10.830712 C7.80869529,10.7554583 7.75642391,10.6764627 7.70739417,10.5928936 C7.67092577,10.5346864 7.63648339,10.4744003 7.60609305,10.4141141 C7.47602242,10.1575863 7.38242019,9.87652832 7.33987372,9.58091849 C7.31758747,9.44579444 7.30745736,9.30609697 7.30745736,9.16432066 C7.30745736,7.67088813 8.49105961,6.45685055 9.94655406,6.45685055 L9.94655406,6.45685055 Z M6.08941273,6.45685055 L6.90144249,6.45685055 L6.90144249,5.20705707 L6.08941273,5.20705707 L6.08941273,6.45685055 Z M0.812029752,4.93597745 L5.68380306,6.06727753 L5.68380306,6.45685055 C5.68380306,6.68593778 5.86614507,6.87344838 6.08941273,6.87344838 L6.90144249,6.87344838 C7.12471015,6.87344838 7.30745736,6.68593778 7.30745736,6.45685055 L7.30745736,6.06727753 L12.1792307,4.93597745 L12.1792307,7.04432832 C11.6228849,6.42774691 10.8274686,6.04025272 9.94655406,6.04025272 C8.26738675,6.04025272 6.90144249,7.4418009 6.90144249,9.16432066 L1.42105207,9.16432066 C1.30921563,9.16432066 1.21804463,9.25786808 1.21804463,9.37261957 C1.21804463,9.48737107 1.30921563,9.58091849 1.42105207,9.58091849 L6.930212,9.58091849 C6.96668041,9.87444949 7.04569528,10.1538444 7.15712651,10.4141141 L1.01503719,10.4141141 C0.903200758,10.4141141 0.812029752,10.3205667 0.812029752,10.2058152 L0.812029752,4.93597745 Z M11.5702084,2.08298913 C11.4583719,2.08298913 11.3672009,2.17612078 11.3672009,2.29128805 L11.3672009,2.70747011 C11.3672009,2.82263737 11.4583719,2.91576902 11.5702084,2.91576902 C11.68245,2.91576902 11.7732158,2.82263737 11.7732158,2.70747011 L11.7732158,2.29128805 C11.7732158,2.17612078 11.68245,2.08298913 11.5702084,2.08298913 L11.5702084,2.08298913 Z M10.5551712,2.08298913 C10.4433347,2.08298913 10.3521637,2.17612078 10.3521637,2.29128805 L10.3521637,2.70747011 C10.3521637,2.82263737 10.4433347,2.91576902 10.5551712,2.91576902 C10.6674128,2.91576902 10.7581786,2.82263737 10.7581786,2.70747011 L10.7581786,2.29128805 C10.7581786,2.17612078 10.6674128,2.08298913 10.5551712,2.08298913 L10.5551712,2.08298913 Z M9.54053918,2.08298913 C9.42829754,2.08298913 9.33753174,2.17612078 9.33753174,2.29128805 L9.33753174,2.70747011 C9.33753174,2.82263737 9.42829754,2.91576902 9.54053918,2.91576902 C9.65237561,2.91576902 9.74354662,2.82263737 9.74354662,2.70747011 L9.74354662,2.29128805 C9.74354662,2.17612078 9.65237561,2.08298913 9.54053918,2.08298913 L9.54053918,2.08298913 Z M8.52550199,2.08298913 C8.41326035,2.08298913 8.32249455,2.17612078 8.32249455,2.29128805 L8.32249455,2.70747011 C8.32249455,2.82263737 8.41326035,2.91576902 8.52550199,2.91576902 C8.63774363,2.91576902 8.72850943,2.82263737 8.72850943,2.70747011 L8.72850943,2.29128805 C8.72850943,2.17612078 8.63774363,2.08298913 8.52550199,2.08298913 L8.52550199,2.08298913 Z M7.5104648,2.08298913 C7.39822316,2.08298913 7.30745736,2.17612078 7.30745736,2.29128805 L7.30745736,2.70747011 C7.30745736,2.82263737 7.39822316,2.91576902 7.5104648,2.91576902 C7.62270644,2.91576902 7.71347224,2.82263737 7.71347224,2.70747011 L7.71347224,2.29128805 C7.71347224,2.17612078 7.62270644,2.08298913 7.5104648,2.08298913 L7.5104648,2.08298913 Z M6.49542761,2.08298913 C6.38359118,2.08298913 6.29242017,2.17612078 6.29242017,2.29128805 L6.29242017,2.70747011 C6.29242017,2.82263737 6.38359118,2.91576902 6.49542761,2.91576902 C6.60766925,2.91576902 6.69843505,2.82263737 6.69843505,2.70747011 L6.69843505,2.29128805 C6.69843505,2.17612078 6.60766925,2.08298913 6.49542761,2.08298913 L6.49542761,2.08298913 Z M5.48079562,2.08298913 C5.36855399,2.08298913 5.27778819,2.17612078 5.27778819,2.29128805 L5.27778819,2.70747011 C5.27778819,2.82263737 5.36855399,2.91576902 5.48079562,2.91576902 C5.59263206,2.91576902 5.68380306,2.82263737 5.68380306,2.70747011 L5.68380306,2.29128805 C5.68380306,2.17612078 5.59263206,2.08298913 5.48079562,2.08298913 L5.48079562,2.08298913 Z M4.46575843,2.08298913 C4.3535168,2.08298913 4.262751,2.17612078 4.262751,2.29128805 L4.262751,2.70747011 C4.262751,2.82263737 4.3535168,2.91576902 4.46575843,2.91576902 C4.57759487,2.91576902 4.66876587,2.82263737 4.66876587,2.70747011 L4.66876587,2.29128805 C4.66876587,2.17612078 4.57759487,2.08298913 4.46575843,2.08298913 L4.46575843,2.08298913 Z M3.45072124,2.08298913 C3.33847961,2.08298913 3.24771381,2.17612078 3.24771381,2.29128805 L3.24771381,2.70747011 C3.24771381,2.82263737 3.33847961,2.91576902 3.45072124,2.91576902 C3.56296288,2.91576902 3.65372868,2.82263737 3.65372868,2.70747011 L3.65372868,2.29128805 C3.65372868,2.17612078 3.56296288,2.08298913 3.45072124,2.08298913 L3.45072124,2.08298913 Z M2.43568405,2.08298913 C2.32384762,2.08298913 2.23267661,2.17612078 2.23267661,2.29128805 L2.23267661,2.70747011 C2.23267661,2.82263737 2.32384762,2.91576902 2.43568405,2.91576902 C2.54792569,2.91576902 2.63869149,2.82263737 2.63869149,2.70747011 L2.63869149,2.29128805 C2.63869149,2.17612078 2.54792569,2.08298913 2.43568405,2.08298913 L2.43568405,2.08298913 Z M1.42105207,2.08298913 C1.30881043,2.08298913 1.21804463,2.17612078 1.21804463,2.29128805 L1.21804463,2.70747011 C1.21804463,2.82263737 1.30881043,2.91576902 1.42105207,2.91576902 C1.5328885,2.91576902 1.6236543,2.82263737 1.6236543,2.70747011 L1.6236543,2.29128805 C1.6236543,2.17612078 1.5328885,2.08298913 1.42105207,2.08298913 L1.42105207,2.08298913 Z M0.609022314,1.66639131 L3.88347961,1.66639131 L9.10737561,1.66639131 L12.3822381,1.66639131 C12.4940745,1.66639131 12.5852455,1.75993872 12.5852455,1.87469022 L12.5852455,2.08298913 C12.4730039,2.08298913 12.3822381,2.17612078 12.3822381,2.29128805 L12.3822381,2.70747011 C12.3822381,2.82263737 12.4730039,2.91576902 12.5852455,2.91576902 L12.5852455,3.91568696 C12.5852455,4.18468775 12.4227586,4.41793264 12.1792307,4.50524357 C12.1569444,4.51355889 12.1346582,4.51979539 12.1103459,4.52603188 L7.30745736,5.63820672 L7.30745736,5.20705707 C7.30745736,4.97796984 7.12471015,4.79045924 6.90144249,4.79045924 L6.08941273,4.79045924 C5.86614507,4.79045924 5.68380306,4.97796984 5.68380306,5.20705707 L5.68380306,5.63820672 L0.880914512,4.52603188 C0.856602244,4.51979539 0.834315998,4.51355889 0.812029752,4.50524357 C0.568501868,4.41793264 0.406014876,4.18468775 0.406014876,3.91568696 L0.406014876,2.91576902 C0.517851309,2.91576902 0.609022314,2.82263737 0.609022314,2.70747011 L0.609022314,2.29128805 C0.609022314,2.17612078 0.517851309,2.08298913 0.406014876,2.08298913 L0.406014876,1.87469022 C0.406014876,1.75993872 0.497185881,1.66639131 0.609022314,1.66639131 L0.609022314,1.66639131 Z M5.29197034,0.416597827 L7.69929008,0.416597827 C7.76736443,0.416597827 7.83017113,0.451106429 7.86826035,0.509313711 L8.34923805,1.24979348 L4.64202238,1.24979348 L5.12300008,0.509313711 C5.1606841,0.451106429 5.22389599,0.416597827 5.29197034,0.416597827 L5.29197034,0.416597827 Z M5.29197034,0 C5.08774729,0 4.8985168,0.103941574 4.78505955,0.278147651 L4.1541562,1.24979348 L0.609022314,1.24979348 C0.27391822,1.24979348 0,1.5308515 0,1.87469022 L0,3.91568696 C0,4.25536802 0.154382902,4.55929318 0.406014876,4.74888261 L0.406014876,10.2058152 C0.406014876,10.5492382 0.679933096,10.830712 1.01503719,10.830712 L7.18954286,10.830712 L6.31673244,11.723778 C6.0140447,12.0360185 6.0140447,12.5407587 6.31673244,12.8529992 C6.46908932,13.0072485 6.66804471,13.0862441 6.86700011,13.0862441 C7.0659555,13.0862441 7.26450569,13.0072485 7.41686257,12.8529992 L8.34640162,11.8967367 C8.363015,11.8801061 8.37719716,11.86597 8.38935329,11.8472606 C8.8439927,12.1283186 9.37805219,12.2883886 9.94655406,12.2883886 C11.6253162,12.2883886 12.9912604,10.8868404 12.9912604,9.16432066 C12.9912604,8.5976312 12.8429556,8.06669764 12.5852455,7.60852319 L12.5852455,4.74888261 C12.8368775,4.55929318 12.9912604,4.25536802 12.9912604,3.91568696 L12.9912604,1.87469022 C12.9912604,1.5308515 12.716937,1.24979348 12.3822381,1.24979348 L8.83710423,1.24979348 L8.20579567,0.278147651 C8.09274362,0.103941574 7.90310793,0 7.69929008,0 L5.29197034,0 Z', id: 'Fill-1', fill: '#C2C2C2', mask: 'url(#mask-6)' })))))))));
}


//# sourceMappingURL=icons.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/NoResult/index.js
'use client';






var StyledNoResult = styled_components_browser_esm/* default.div */.ZP.div(NoResult_templateObject_1 || (NoResult_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: center !important;\n    font-size: 14px;\n\n    > .icon-wrapper {\n        margin-bottom: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    > .title {\n        font-size: 15px;\n        margin-bottom: 10px;\n        font-weight: 600;\n        line-height: 1.5;\n    }\n"], ["\n    text-align: center !important;\n    font-size: 14px;\n\n    > .icon-wrapper {\n        margin-bottom: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    > .title {\n        font-size: 15px;\n        margin-bottom: 10px;\n        font-weight: 600;\n        line-height: 1.5;\n    }\n"])));
var STATIC_DATA = {
    searchResult: {
        icon: IconNoResultJobs,
        vi: {
            title: 'Hiện chưa có công việc nào theo tiêu chí bạn tìm',
            description: ''
        },
        en: {
            title: 'We have not found jobs for this search at the moment',
            description: ''
        }
    },
    topManagementJobs: {
        icon: IconNoResultManagementJobs,
        vi: {
            title: 'Hiện chưa có công việc nào theo tiêu chí bạn tìm',
            description: ''
        },
        en: {
            title: 'We have not found jobs for this search at the moment',
            description: ''
        }
    },
    interview: {
        icon: IconNoResultInterview,
        vi: {
            title: 'Hiện tại VietnamWorks chưa có bộ câu hỏi phỏng vấn cho vị trí này.',
            description: 'Bạn hãy quay lại sau nhé. VietnamWorks sẽ chuẩn bị sớm thôi.'
        },
        en: {
            title: 'Currently, VietnamWorks have no interview questions for this position.',
            description: 'Please come back later. VietnamWorks will prepare soon.'
        }
    },
    salary: {
        icon: IconNoResultSalary,
        vi: {
            title: 'Hiện tại VietnamWorks chưa có bộ câu hỏi phỏng vấn cho vị trí này.',
            description: 'Bạn hãy quay lại sau nhé. VietnamWorks sẽ chuẩn bị sớm thôi.'
        },
        en: {
            title: 'Currently, VietnamWorks have no interview questions for this position.',
            description: 'Please come back later. VietnamWorks will prepare soon.'
        }
    },
    error404: {
        icon: IconNoResult404,
        vi: {
            title: 'Xin lỗi. chúng tôi không thể tìm thấy trang bạn đã yêu cầu. Cùng nhau khám phá thêm nhiều việc làm chứ?',
            description: ''
        },
        en: {
            title: "Sorry, we couldn't find the page you requested. Let's discover more jobs, shall we?",
            description: ''
        }
    },
    jobAlert: {
        icon: IconNoResultJobAlert,
        vi: {
            title: 'Bạn chưa tạo Thông báo việc làm nào',
            description: ''
        },
        en: {
            title: 'You have not created any job alert yet',
            description: ''
        }
    },
    profileViews: {
        icon: IconNoProfileViews,
        vi: {
            title: 'Bạn chưa có lượt ghé thăm nào',
            description: ''
        },
        en: {
            title: 'You have not had any visits yet',
            description: ''
        }
    },
    searchable: {
        icon: IconNoSearchable,
        vi: {
            title: 'Nhà tuyển dụng không thể xem hồ sơ của bạn',
            description: ''
        },
        en: {
            title: 'Employers can not view your resume',
            description: ''
        }
    },
    appliedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa ứng tuyển vị trí nào',
            description: ''
        },
        en: {
            title: 'You have not applied for any job yet',
            description: ''
        }
    },
    viewedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa xem công việc nào',
            description: ''
        },
        en: {
            title: 'You have not viewed for any job yet',
            description: ''
        }
    },
    savedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa lưu công việc nào',
            description: ''
        },
        en: {
            title: 'You have not saved for any job yet',
            description: ''
        }
    }
};
function NoResult(_a) {
    var _b, _c, _d, _e, _f;
    var pageName = _a.pageName, _g = _a.language, language = _g === void 0 ? 'vi' : _g, children = _a.children, title = _a.title, _h = _a.customIcon, customIcon = _h === void 0 ? null : _h;
    var titleText = !title ? ((_c = (_b = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _b === void 0 ? void 0 : _b[language]) === null || _c === void 0 ? void 0 : _c.title) || '' : title;
    var description = ((_e = (_d = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _d === void 0 ? void 0 : _d[language]) === null || _e === void 0 ? void 0 : _e.description) || '';
    var Icon = ((_f = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _f === void 0 ? void 0 : _f.icon) || '';
    var CustomIcon = customIcon;
    return (react.createElement(StyledNoResult, null,
        react.createElement("div", { className: 'icon-wrapper' }, CustomIcon || react.createElement(Icon, null)),
        react.createElement("h2", { className: 'title' }, titleText),
        react.createElement("div", null, children || description)));
}
var NoResult_templateObject_1;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupNewUser/PopupNewUser.css.js
'use client';




var generalStyled = "\n    position:fixed;\n    bottom: 0;\n    left:0;\n    right:0;\n    width: 100%;\n    transition:all .3s;\n    z-index:201;\n";
var ratingStart = "\n    .app-rating{\n        display: flex;\n        align-items: center;\n        svg{\n            &:not(:first-child){\n                margin-left:5px;\n            }\n        }\n        .app-score{\n            color:#757575;\n            font-size:13px;\n            margin-left:5px;\n        }\n    }\n";
var downloadBtn = "\n        background: #ff7d55;\n        color: white;\n        border-radius: 5px;\n        text-align: center;\n        width: 100%;\n        border: 1px solid #ff7d55;\n        transition:all .3s;\n        cursor:pointer;\n        &:focus{\n            outline:none;\n        }\n";
var vnwLogo = "\n    background:#005AFF;\n    border-radius:10px;\n    padding:5px;\n";
var returnNMinimum = "\n    display:flex;\n    align-items: center;\n    transition:all .3s;\n    .content-popup{\n        margin-left:12px;\n        margin-bottom:0;\n        .app-title{\n            font-weight:600;\n        }\n        .app-brief{\n            color:#8a8a8a;\n            font-size:12px;\n        }\n    }\n        .download-btn{\n            margin-left:auto;\n            ".concat(downloadBtn, "\n            width:93px;\n            height:37px;\n            border-radius:5px;\n            font-weight:600;\n            font-size:14px;\n            padding:0;\n        }\n");
styled_components_browser_esm/* default.div */.ZP.div(PopupNewUser_css_templateObject_1 || (PopupNewUser_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 77px;\n    background: #f4f4f7;\n    border-top: 1px solid #c5c5c5;\n    border-bottom: 1px solid #eaeaf0;\n    padding: 12px 5px 15px 5px;\n    ", ";\n    .content-popup {\n        margin-left: 7px;\n    }\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n    .logo {\n        ", ";\n        margin-left: 5px;\n    }\n    ", ";\n"], ["\n    width: 100%;\n    height: 77px;\n    background: #f4f4f7;\n    border-top: 1px solid #c5c5c5;\n    border-bottom: 1px solid #eaeaf0;\n    padding: 12px 5px 15px 5px;\n    ", ";\n    .content-popup {\n        margin-left: 7px;\n    }\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n    .logo {\n        ", ";\n        margin-left: 5px;\n    }\n    ", ";\n"])), returnNMinimum, vnwLogo, ratingStart);
var NewPopup = styled_components_browser_esm/* default.div */.ZP.div(PopupNewUser_css_templateObject_2 || (PopupNewUser_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", ";\n    border-top-left-radius: 7px;\n    border-top-right-radius: 7px;\n    color: black;\n    padding: 25px 15px 15px;\n    z-index: 201;\n    background: white;\n    .title {\n        margin-bottom: 15px;\n        font-size: 17px;\n        padding: 0 15px 0 5px;\n        font-weight: 600;\n        position: relative;\n        line-height: 1.5;\n    }\n    .filter-close {\n        position: absolute;\n        top: -12px;\n        right: 12px;\n        background: white;\n        border-radius: 20px;\n        fill: #3c3c43;\n        padding: 0;\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n\n    .download-btn {\n        padding: 15px;\n        ", ";\n        font-size: 17px;\n        font-weight: 600;\n    }\n"], ["\n    ", ";\n    border-top-left-radius: 7px;\n    border-top-right-radius: 7px;\n    color: black;\n    padding: 25px 15px 15px;\n    z-index: 201;\n    background: white;\n    .title {\n        margin-bottom: 15px;\n        font-size: 17px;\n        padding: 0 15px 0 5px;\n        font-weight: 600;\n        position: relative;\n        line-height: 1.5;\n    }\n    .filter-close {\n        position: absolute;\n        top: -12px;\n        right: 12px;\n        background: white;\n        border-radius: 20px;\n        fill: #3c3c43;\n        padding: 0;\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n\n    .download-btn {\n        padding: 15px;\n        ", ";\n        font-size: 17px;\n        font-weight: 600;\n    }\n"])), generalStyled, downloadBtn);
var Introduction = styled_components_browser_esm/* default.div */.ZP.div(PopupNewUser_css_templateObject_3 || (PopupNewUser_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: #f4f4f7;\n    padding: 10px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    .logo {\n        ", ";\n    }\n    .content {\n        margin-left: 10px;\n        .app-title {\n            font-weight: 600;\n            font-size: 15px;\n        }\n        .app-brief {\n            color: #757575;\n            font-size: 14px;\n        }\n        ", ";\n    }\n"], ["\n    background: #f4f4f7;\n    padding: 10px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    .logo {\n        ", ";\n    }\n    .content {\n        margin-left: 10px;\n        .app-title {\n            font-weight: 600;\n            font-size: 15px;\n        }\n        .app-brief {\n            color: #757575;\n            font-size: 14px;\n        }\n        ", ";\n    }\n"])), vnwLogo, ratingStart);
var MinimumPopup = styled_components_browser_esm/* default.div */.ZP.div(PopupNewUser_css_templateObject_4 || (PopupNewUser_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", ";\n    background: #f8f8f8;\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: 3px;\n        right: 7px;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    .wrap-content-minimum {\n        ", ";\n        padding: 25px 12px 15px 15px;\n        height: 93px;\n        align-items: center;\n        .logo {\n            ", ";\n        }\n        ", ";\n        .download-btn {\n            margin-top: 5px;\n            cursor: pointer;\n            font-size: 14px;\n            padding: 0;\n        }\n    }\n"], ["\n    ", ";\n    background: #f8f8f8;\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: 3px;\n        right: 7px;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    .wrap-content-minimum {\n        ", ";\n        padding: 25px 12px 15px 15px;\n        height: 93px;\n        align-items: center;\n        .logo {\n            ", ";\n        }\n        ", ";\n        .download-btn {\n            margin-top: 5px;\n            cursor: pointer;\n            font-size: 14px;\n            padding: 0;\n        }\n    }\n"])), generalStyled, returnNMinimum, vnwLogo, ratingStart);
var PopupOverlay = styled_components_browser_esm/* default.div */.ZP.div(PopupNewUser_css_templateObject_5 || (PopupNewUser_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    width: ", ";\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 200;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity 0.3s;\n"], ["\n    position: fixed;\n    width: ", ";\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 200;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity 0.3s;\n"])), function (props) { return (props.active ? '100%' : '0'); }, function (props) { return (props.active ? '1' : '0'); });
var PopupNewUser_css_templateObject_1, PopupNewUser_css_templateObject_2, PopupNewUser_css_templateObject_3, PopupNewUser_css_templateObject_4, PopupNewUser_css_templateObject_5;


//# sourceMappingURL=PopupNewUser.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupNewUser/PopupService.js
'use client';



var hasLocalStorage = !!(typeof window !== 'undefined' && window.localStorage);
var PopupNewUser = /** @class */ (function () {
    function PopupNewUser() {
    }
    PopupNewUser.prototype.initializePopup = function () {
        if (hasLocalStorage) {
            localStorage.setItem('popupNewUser', JSON.stringify([]));
        }
    };
    PopupNewUser.prototype.getPopup = function () {
        if (hasLocalStorage) {
            var popupLocals = localStorage.getItem('popupNewUser');
            popupLocals = popupLocals ? JSON.parse(popupLocals) : [];
            return popupLocals;
        }
        return [];
    };
    PopupNewUser.prototype.setWhenUserClose = function () {
        if (hasLocalStorage) {
            var popupLocals = this.getPopup();
            if (popupLocals.length < 3) {
                var currentTimeStamp = new Date();
                popupLocals = (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], popupLocals, true), [currentTimeStamp.getTime()], false);
                localStorage.setItem('popupNewUser', JSON.stringify(popupLocals));
            }
        }
    };
    PopupNewUser.prototype.getJobLevelList = function (url) {
        return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
            var response;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, {
                            method: 'GET'
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PopupNewUser;
}());
var PopupService = new PopupNewUser();


//# sourceMappingURL=PopupService.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupNewUser/vi.js
'use client';

var vi = {
    'Job Search and Recruitment': 'Việc Làm và Tuyển Dụng',
    "Experience VietnamWorks - Vietnam's largest job search application": 'Trải nghiệm VietnamWorks - Ứng dụng tìm việc làm lớn nhất Việt Nam',
    'Install Application': 'Cài Đặt Ứng Dụng',
    Install: 'Cài Đặt',
    'Open App': 'Mở App'
};


//# sourceMappingURL=vi.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupNewUser/index.js
'use client';








var PopupNewUser_hasLocalStorage = !!(typeof window !== 'undefined' && window.localStorage);
if (typeof window !== 'undefined') {
    window.opera = window.opera || {};
    window._gaq = window._gaq || [];
}
var ETypePopup;
(function (ETypePopup) {
    ETypePopup["New"] = "new";
    ETypePopup["Return"] = "return";
    ETypePopup["Minimum"] = "minimum";
})(ETypePopup || (ETypePopup = {}));
var PopupNewUser_PopupNewUser = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(PopupNewUser, _super);
    function PopupNewUser(props) {
        var _this = _super.call(this, props) || this;
        _this.isSafariBrowser = function () {
            if (typeof navigator !== 'undefined' && typeof window !== 'undefined') {
                return !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
            }
            return false;
        };
        _this.getLinkDownload = function () {
            if (typeof window !== 'undefined') {
                window.location.href = "https://vietnamworks.onelink.me/UtAm?pid=mobile&url=".concat(encodeURIComponent(window.location.pathname));
            }
        };
        _this.pushGA = function (bannerType) {
            if (typeof window !== 'undefined') {
                if (window._gaq && window._gaq.push) {
                    window._gaq.push(['_trackEvent', 'NoThanksBanner', 'Click', bannerType]);
                }
            }
        };
        _this.initPopup = function () {
            if (PopupNewUser_hasLocalStorage) {
                var popupLocals = localStorage.getItem('popupNewUser');
                if (!popupLocals) {
                    PopupService.initializePopup();
                    _this.setState({ isShowNewPopup: true });
                }
                else {
                    popupLocals = JSON.parse(popupLocals);
                    // check User Click close btn in the last 30 days or not
                    /**
                     * VNW-20838 [Responsive] Always show banner app install if VNW app is not installed
                     *
                     * Changed timestamps 30 days to 1 day
                     *
                     * @author Thien Tran
                     * @since Mar 08, 2023
                     */
                    var timestamps1Day_1 = new Date();
                    timestamps1Day_1.setDate(timestamps1Day_1.getDate() - 1);
                    var isClick3Times = popupLocals.length >= 3;
                    if (isClick3Times) {
                        var isClicksTooOld = !!popupLocals.every(function (item) { return timestamps1Day_1.getTime() > item; });
                        if (isClicksTooOld) {
                            PopupService.initializePopup();
                            _this.setState({ isShowReturnPopup: true });
                        }
                    }
                    else {
                        _this.setState({ isShowReturnPopup: true });
                    }
                }
            }
        };
        _this.handleClickoverlay = function () {
            _this.setState({
                isShowNewPopup: false,
                isShowReturnPopup: true
            });
        };
        _this.renderPopupOverlay = function () {
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return react_dom.createPortal(react.createElement(PopupOverlay, { onClick: _this.handleClickoverlay, active: _this.state.isShowNewPopup }), bodyNode);
            }
            return null;
        };
        _this.handleClosePopup = function (position) {
            var onClosePopup = _this.props.onClosePopup;
            switch (position) {
                case ETypePopup.New:
                    _this.setState({ isShowNewPopup: false });
                    _this.pushGA('NEW_USER_BANNER');
                    break;
                case ETypePopup.Minimum:
                    PopupService.setWhenUserClose();
                    _this.setState({ isShowMinimumPopup: false });
                    _this.pushGA('MINIMUM_USER_BANNER');
                    break;
                case ETypePopup.Return:
                    PopupService.setWhenUserClose();
                    _this.setState({ isShowReturnPopup: false });
                    _this.pushGA('RETURN_USER_BANNER');
                    break;
            }
            onClosePopup && onClosePopup();
        };
        _this.renderStarIcon = function () {
            var ratingStartList = [];
            for (var i = 0; i < 5; i++) {
                ratingStartList.push(react.createElement("svg", { className: 'rating', width: '14px', height: '13px', viewBox: '0 0 14 13', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', key: i },
                    react.createElement("g", { id: 'Popup-Install-App', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                        react.createElement("g", { id: 'New-User', transform: 'translate(-115.000000, -557.000000)', fill: '#ff7d55', fillRule: 'nonzero' },
                            react.createElement("g", { id: 'Group-4', transform: 'translate(0.000000, 387.000000)' },
                                react.createElement("g", { id: 'Group-3', transform: 'translate(16.000000, 103.000000)' },
                                    react.createElement("path", { d: 'M102.349306,79.533297 L105.577822,77.1675744 L108.801699,79.533297 C109.135683,79.774508 109.404726,79.8255334 109.627382,79.6631798 C109.840761,79.5008263 109.891787,79.2317834 109.757265,78.8421349 L108.490908,75.0477013 L111.742617,72.7098107 C112.076601,72.4732384 112.201845,72.2273888 112.118349,71.9676232 C112.034853,71.7171349 111.789003,71.5826134 111.376162,71.5872521 L107.382265,71.6104455 L106.166933,67.8020959 C106.03705,67.4078087 105.846865,67.2129845 105.577822,67.2129845 C105.30414,67.2129845 105.113955,67.4078087 104.988711,67.8020959 L103.76874,71.6104455 L99.7748433,71.5872521 C99.3620015,71.5826134 99.1207906,71.7171349 99.0372945,71.9676232 C98.9491597,72.2273888 99.0790425,72.4732384 99.4083882,72.7098107 L102.660097,75.0477013 L101.39374,78.8421349 C101.263857,79.2317834 101.314882,79.5008263 101.528261,79.6631798 C101.746279,79.8255334 102.019961,79.774508 102.349306,79.533297 Z', id: 'icon-star-l' })))))));
            }
            return ratingStartList;
        };
        _this.renderCloseBtn = function (position) {
            return (react.createElement("svg", { className: 'filter-close', viewBox: '0 0 50 50', onClick: function () { return _this.handleClosePopup(position); } },
                react.createElement("path", { d: 'M 14.40625 13 L 13 14.40625 L 23.625 25 L 13 35.59375 L 14.40625 37 L 25.0625 26.40625 L 35.6875 37 L 37.09375 35.59375 L 26.46875 25 L 37.09375 14.40625 L 35.6875 13 L 25.0625 23.59375 Z' })));
        };
        _this.renderVietnamworksLogo = function () {
            return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '68', height: '68' },
                react.createElement("defs", null,
                    react.createElement("clipPath", { id: 'a' },
                        react.createElement("path", { d: 'M62 0a6 6 0 0 1 6 6v56a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h56Z' })),
                    react.createElement("clipPath", { id: 'b' },
                        react.createElement("path", { d: 'M29.401 6.242c.227.407-.168.87-.675.787l-.515-.084c-3.37-.478-7.263.643-7.626.75l-.027.009c-4.626 1.297-8.872.908-8.872.908-3.35-.137-6.803-1.157-6.803-1.157C2.703 6.87 0 6.765 0 6.765S5.784 1.682 14.411.25c0 0 10.476-2.12 14.99 5.992Z' })),
                    react.createElement("clipPath", { id: 'd' },
                        react.createElement("path", { d: 'm25.997 10.596.003.114v.198c-.025 1.627-.593 9.355-8.885 16.66 0 0-7.869 7.308-16.649 7.094-.487-.012-.644-.634-.22-.864 2.326-1.257 6.957-4.468 11.855-11.866 0 0 7.772-10.601 2.98-21.93h.015l.02-.001h.211c1.595.025 10.379.618 10.67 10.595Z' })),
                    react.createElement("clipPath", { id: 'f' },
                        react.createElement("path", { d: 'm25.965 16.763-.06.04c-1.179.777-13.186 8.356-21.906.37 0 0-.026-.023-.073-.07l-.067-.066C2.938 16.107-2.123 10.42 1.013.43A.604.604 0 0 1 2.14.35c1.436 3.02 5.387 10.2 11.758 13.464 0 0 4.435 2.91 11.703 2.927l.398-.003a.577.577 0 0 1-.034.024Z' })),
                    react.createElement("clipPath", { id: 'h' },
                        react.createElement("path", { d: 'M13.465.147c.426.055.551.597.19.823-2.557 1.596-8.847 6.589-11.179 18.097 0 0-5.303-8.239-.388-15.087 0 0 3.286-4.878 11.377-3.833Z' })),
                    react.createElement("linearGradient", { id: 'c', x1: '-.001', y1: '4.333', x2: '29.466', y2: '4.333', gradientUnits: 'userSpaceOnUse' },
                        react.createElement("stop", { stopColor: '#3baaff', offset: '0%' }),
                        react.createElement("stop", { stopColor: '#47b2ff', offset: '24%' }),
                        react.createElement("stop", { stopColor: '#67c9ff', offset: '68%' }),
                        react.createElement("stop", { stopColor: '#82dcff', offset: '100%' })),
                    react.createElement("linearGradient", { id: 'e', x1: '22.651', y1: '8.871', x2: '-3.642', y2: '28.797', gradientUnits: 'userSpaceOnUse' },
                        react.createElement("stop", { stopColor: '#0059ff', offset: '10%' }),
                        react.createElement("stop", { stopColor: '#035eff', offset: '13%' }),
                        react.createElement("stop", { stopColor: '#2187ff', offset: '50%' }),
                        react.createElement("stop", { stopColor: '#34a0ff', offset: '79%' }),
                        react.createElement("stop", { stopColor: '#3baaff', offset: '96%' })),
                    react.createElement("linearGradient", { id: 'g', x1: '-1.609', y1: '10.4', x2: '17.891', y2: '10.4', gradientUnits: 'userSpaceOnUse' },
                        react.createElement("stop", { stopColor: '#82dcff', offset: '0%' }),
                        react.createElement("stop", { stopColor: '#65c7ff', offset: '25%' }),
                        react.createElement("stop", { stopColor: '#47b2ff', offset: '57%' }),
                        react.createElement("stop", { stopColor: '#3baaff', offset: '75%' })),
                    react.createElement("linearGradient", { id: 'i', x1: '-2.266', y1: '13.235', x2: '14.73', y2: '4.889', gradientUnits: 'userSpaceOnUse' },
                        react.createElement("stop", { stopColor: '#0059ff', offset: '0%' }),
                        react.createElement("stop", { stopColor: '#1271ff', offset: '26%' }),
                        react.createElement("stop", { stopColor: '#309aff', offset: '75%' }),
                        react.createElement("stop", { stopColor: '#3baaff', offset: '100%' }))),
                react.createElement("g", { clipPath: 'url(#a)' },
                    react.createElement("path", { fill: '#001644', d: 'M0 0h68v68H0V0z' })),
                react.createElement("g", { clipPath: 'url(#b)', transform: 'translate(20.133 10)' },
                    react.createElement("path", { fill: 'url(#c)', d: 'M0 0h29.467v8.667H0V0z' })),
                react.createElement("g", { clipPath: 'url(#d)', transform: 'translate(34 16.933)' },
                    react.createElement("path", { fill: 'url(#e)', d: 'M0 0h26v34.667H0V0z' })),
                react.createElement("g", { clipPath: 'url(#f)', transform: 'translate(8 37.733)' },
                    react.createElement("path", { fill: 'url(#g)', d: 'M0 0h26v20.8H0V0z' })),
                react.createElement("g", { clipPath: 'url(#h)', transform: 'translate(8 18.667)' },
                    react.createElement("path", { fill: 'url(#i)', d: 'M0 0h13.867v19.067H0V0z' }))));
        };
        _this.renderNewPopup = function () {
            var langCode = _this.props.langCode;
            var closeBtn = _this.renderCloseBtn(ETypePopup.New);
            var logo = _this.renderVietnamworksLogo();
            var ratingStart = _this.renderStarIcon();
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return react_dom.createPortal(react.createElement(NewPopup, null,
                    closeBtn,
                    react.createElement("div", { className: 'title' }, langCode === 'en'
                        ? "Experience VietnamWorks - Vietnam's largest job search application"
                        : vi["Experience VietnamWorks - Vietnam's largest job search application"]),
                    react.createElement(Introduction, null,
                        logo,
                        react.createElement("div", { className: 'content' },
                            react.createElement("div", { className: 'app-title' }, "VietnamWorks"),
                            react.createElement("div", { className: 'app-brief' }, langCode === 'en' ? 'Job Search and Recruitment' : vi["Job Search and Recruitment"]),
                            react.createElement("div", { className: 'app-rating' },
                                ratingStart,
                                react.createElement("span", { className: 'app-score' }, "(4,7)"),
                                ' '))),
                    react.createElement("button", { onClick: _this.getLinkDownload, className: 'download-btn' }, langCode === 'en' ? 'Install Application' : vi["Install Application"])), bodyNode);
            }
            return null;
        };
        _this.renderMinimumPopup = function () {
            var langCode = _this.props.langCode;
            var closeBtn = _this.renderCloseBtn(ETypePopup.Minimum);
            var logo = _this.renderVietnamworksLogo();
            var ratingStart = _this.renderStarIcon();
            return (react.createElement(MinimumPopup, null,
                closeBtn,
                react.createElement("div", { className: 'wrap-content-minimum' },
                    logo,
                    react.createElement("div", { className: 'content-popup' },
                        react.createElement("div", { className: 'app-title' }, "VietnamWorks"),
                        react.createElement("div", { className: 'app-brief' }, langCode === 'en' ? 'Job Search and Recruitment' : vi["Job Search and Recruitment"]),
                        react.createElement("div", { className: 'app-rating' },
                            ratingStart,
                            react.createElement("span", { className: 'app-score' }, "(4,7)"),
                            ' ')),
                    react.createElement("button", { onClick: _this.getLinkDownload, className: 'download-btn' }, langCode === 'en' ? 'Open App' : vi["Open App"]))));
        };
        _this.checkIsMobile = function () {
            if (typeof window !== 'undefined') {
                _this.setState({ isMobile: window.innerWidth < 900 });
            }
        };
        _this.state = {
            isMobile: false,
            isShowNewPopup: false,
            isShowMinimumPopup: false,
            isShowReturnPopup: false
        };
        return _this;
    }
    PopupNewUser.prototype.componentDidMount = function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkIsMobile);
        }
        this.checkIsMobile();
        this.initPopup();
    };
    PopupNewUser.prototype.componentWillUnmount = function () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.checkIsMobile);
        }
    };
    PopupNewUser.prototype.render = function () {
        var _a = this.state, isMobile = _a.isMobile, isShowNewPopup = _a.isShowNewPopup, isShowReturnPopup = _a.isShowReturnPopup, isShowMinimumPopup = _a.isShowMinimumPopup;
        if (!isMobile || isShowReturnPopup) {
            return null;
        }
        var newPopup = this.renderNewPopup();
        var minimumPopup = this.renderMinimumPopup();
        var overlay = this.renderPopupOverlay();
        return (react.createElement(react.Fragment, null,
            isShowNewPopup ? newPopup : null,
            isShowNewPopup ? overlay : null,
            isShowMinimumPopup ? minimumPopup : null));
    };
    return PopupNewUser;
}(react.PureComponent));


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Proficiency/Proficiency.css.js
'use client';




var ListProficiency = styled_components_browser_esm/* default.div */.ZP.div(Proficiency_css_templateObject_1 || (Proficiency_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    border-radius: 4px;\n    position: relative;\n    width: 100%;\n"], ["\n    display: flex;\n    border-radius: 4px;\n    position: relative;\n    width: 100%;\n"])));
var ProficiencyItem = styled_components_browser_esm/* default.div */.ZP.div(Proficiency_css_templateObject_2 || (Proficiency_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #fff;\n    font-size: 14px;\n    width: ", ";\n    height: 40px;\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: ", ";\n    border-radius: ", ";\n    &:after {\n        position: absolute;\n        content: '';\n        width: 1px;\n        height: 14px;\n        top: 13px;\n        left: 0;\n        opacity: 0.5;\n        background: ", ";\n    }\n    &:hover {\n        background: ", " !important;\n        border-radius: 4px;\n    }\n    &:first-child {\n        &:after {\n            content: none;\n        }\n    }\n\n    /* @media all and (max-width: 991px) {\n        width: ", ";\n    } */\n"], ["\n    color: #fff;\n    font-size: 14px;\n    width: ", ";\n    height: 40px;\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: ", ";\n    border-radius: ", ";\n    &:after {\n        position: absolute;\n        content: '';\n        width: 1px;\n        height: 14px;\n        top: 13px;\n        left: 0;\n        opacity: 0.5;\n        background: ", ";\n    }\n    &:hover {\n        background: ", " !important;\n        border-radius: 4px;\n    }\n    &:first-child {\n        &:after {\n            content: none;\n        }\n    }\n\n    /* @media all and (max-width: 991px) {\n        width: ", ";\n    } */\n"])), function (props) { return "".concat(100 / props.style.listLength, "%"); }, function (props) { return props.style.background; }, function (props) { return props.style.borderRadius; }, function (props) { return props.style.backgroundSeparator; }, function (props) { return props.style.backgroundHover; }, function (props) { return "".concat(100 / props.style.listLength, "%"); });
var CurrentItemBox = styled_components_browser_esm/* default.div */.ZP.div(Proficiency_css_templateObject_3 || (Proficiency_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 100%;\n    transition: transform 0.2s ease 0s, opacity 0.2s ease 0s;\n    will-change: transform, opacity;\n    opacity: 1;\n    width: ", ";\n    transform: ", ";\n\n    &:before {\n        content: '';\n        position: absolute;\n        left: -3px;\n        right: -3px;\n        top: 0px;\n        height: 100%;\n        border-radius: 4px;\n        transition: background-color 0.2s ease 0s;\n        background: ", ";\n    }\n"], ["\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 100%;\n    transition: transform 0.2s ease 0s, opacity 0.2s ease 0s;\n    will-change: transform, opacity;\n    opacity: 1;\n    width: ", ";\n    transform: ", ";\n\n    &:before {\n        content: '';\n        position: absolute;\n        left: -3px;\n        right: -3px;\n        top: 0px;\n        height: 100%;\n        border-radius: 4px;\n        transition: background-color 0.2s ease 0s;\n        background: ", ";\n    }\n"])), function (props) { return "".concat(100 / props.style.listLength, "%"); }, function (props) { return props.style.transform; }, function (props) { return props.style.background; });
var Proficiency_css_templateObject_1, Proficiency_css_templateObject_2, Proficiency_css_templateObject_3;


//# sourceMappingURL=Proficiency.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Proficiency/index.js
'use client';





/* eslint-disable no-unused-expressions */
var Proficiency = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, _b = props.onSelected, onSelected = _b === void 0 ? function () { } : _b, _c = props.value, value = _c === void 0 ? 1 : _c;
    if (options.length === 0)
        return null;
    var selected = options.find(function (item) { return item.id === value; });
    var currentIndex = options.findIndex(function (item) { return item.id === value; });
    return (react.createElement(ListProficiency, null,
        options.map(function (item, index) {
            return (react.createElement(ProficiencyItem, { key: index, onClick: function () { return onSelected(item.id); }, style: {
                    listLength: options.length,
                    backgroundSeparator: (selected === null || selected === void 0 ? void 0 : selected.bgColor) || 'transparent',
                    borderRadius: index === 0 || index === options.length - 1 ? '4px' : '0',
                    background: selected
                        ? (0,helpers/* ConvertHexToRgbA */.mT)(selected.bgColor, '0.1')
                        : (0,helpers/* ConvertHexToRgbA */.mT)(item.bgColor, '0.1'),
                    backgroundHover: selected
                        ? (0,helpers/* ConvertHexToRgbA */.mT)(selected.bgColor, '0.3')
                        : (0,helpers/* ConvertHexToRgbA */.mT)(item.bgColor, '1')
                } }));
        }),
        react.createElement(CurrentItemBox, { style: {
                listLength: options.length,
                background: (selected === null || selected === void 0 ? void 0 : selected.bgColor) || 'transparent',
                transform: "translateX(".concat(currentIndex || 0, "00%)")
            } })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Radio/Radio.css.js
'use client';




styled_components_browser_esm/* default.div */.ZP.div(Radio_css_templateObject_1 || (Radio_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .abc-radio.radio-inline {\n        margin-top: 0;\n    }\n\n    label .was-validated .form-check-input:invalid .abc-checkbox:before,\n    label .was-validated .form-check-input:invalid .abc-radio:before,\n    label .form-check-input.is-invalid .abc-checkbox:before,\n    label .form-check-input.is-invalid .abc-radio:before {\n        border-color: #dc3545;\n    }\n"], ["\n    .abc-radio.radio-inline {\n        margin-top: 0;\n    }\n\n    label .was-validated .form-check-input:invalid .abc-checkbox:before,\n    label .was-validated .form-check-input:invalid .abc-radio:before,\n    label .form-check-input.is-invalid .abc-checkbox:before,\n    label .form-check-input.is-invalid .abc-radio:before {\n        border-color: #dc3545;\n    }\n"])));
var RadioWrapper = styled_components_browser_esm/* default.div */.ZP.div(Radio_css_templateObject_2 || (Radio_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n"], ["\n    display: block;\n"])));
var RadioContainer = styled_components_browser_esm/* default.div */.ZP.div(Radio_css_templateObject_7 || (Radio_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: default;\n    padding-left: 8px;\n    label {\n        cursor: pointer;\n        display: inline;\n        vertical-align: top;\n        position: relative;\n        padding-left: 5px;\n        &::before {\n            cursor: pointer;\n            content: '';\n            display: inline-block;\n            position: absolute;\n            width: 17px;\n            height: 17px;\n            top: 2px;\n            left: 0;\n            margin-left: -20px;\n            border: 1px solid #ced4da;\n            border-radius: 50%;\n            background-color: #fff;\n            transition: border 0.15s ease-in-out;\n        }\n        &::after {\n            cursor: pointer;\n            display: inline-block;\n            position: absolute;\n            content: ' ';\n            width: 11px;\n            height: 11px;\n            left: 3px;\n            top: 5px;\n            margin-left: -20px;\n            border-radius: 50%;\n            background-color: #495057;\n            transform: scale(0, 0);\n            transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n        }\n    }\n    input[type='radio'] {\n        position: static;\n        margin-left: 0;\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n    }\n    input[type='radio']:focus + label::before {\n        outline: none;\n    }\n    input[type='radio']:checked + label::after {\n        transform: scale(1, 1);\n    }\n    input[type='radio']:disabled + label {\n        opacity: 0.65;\n    }\n    input[type='radio']:disabled + label::before {\n        cursor: not-allowed;\n    }\n    input[type='radio']:disabled + label::after {\n        cursor: not-allowed;\n    }\n    ", "\n"], ["\n    cursor: default;\n    padding-left: 8px;\n    label {\n        cursor: pointer;\n        display: inline;\n        vertical-align: top;\n        position: relative;\n        padding-left: 5px;\n        &::before {\n            cursor: pointer;\n            content: '';\n            display: inline-block;\n            position: absolute;\n            width: 17px;\n            height: 17px;\n            top: 2px;\n            left: 0;\n            margin-left: -20px;\n            border: 1px solid #ced4da;\n            border-radius: 50%;\n            background-color: #fff;\n            transition: border 0.15s ease-in-out;\n        }\n        &::after {\n            cursor: pointer;\n            display: inline-block;\n            position: absolute;\n            content: ' ';\n            width: 11px;\n            height: 11px;\n            left: 3px;\n            top: 5px;\n            margin-left: -20px;\n            border-radius: 50%;\n            background-color: #495057;\n            transform: scale(0, 0);\n            transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n        }\n    }\n    input[type='radio'] {\n        position: static;\n        margin-left: 0;\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n    }\n    input[type='radio']:focus + label::before {\n        outline: none;\n    }\n    input[type='radio']:checked + label::after {\n        transform: scale(1, 1);\n    }\n    input[type='radio']:disabled + label {\n        opacity: 0.65;\n    }\n    input[type='radio']:disabled + label::before {\n        cursor: not-allowed;\n    }\n    input[type='radio']:disabled + label::after {\n        cursor: not-allowed;\n    }\n    ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case 'info':
            return (0,styled_components_browser_esm/* css */.iv)(Radio_css_templateObject_3 || (Radio_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    input[type='radio'] + label::after {\n                        background-color: #005aff;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #005aff;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #005aff;\n                    }\n                "], ["\n                    input[type='radio'] + label::after {\n                        background-color: #005aff;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #005aff;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #005aff;\n                    }\n                "])));
        case 'danger':
            return (0,styled_components_browser_esm/* css */.iv)(Radio_css_templateObject_4 || (Radio_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    input[type='radio'] + label::after {\n                        background-color: #f85a5a;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #f85a5a;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #f85a5a;\n                    }\n                "], ["\n                    input[type='radio'] + label::after {\n                        background-color: #f85a5a;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #f85a5a;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #f85a5a;\n                    }\n                "])));
        case 'warning':
            return (0,styled_components_browser_esm/* css */.iv)(Radio_css_templateObject_5 || (Radio_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    input[type='radio'] + label::after {\n                        background-color: #ff7d55;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #ff7d55;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #ff7d55;\n                    }\n                "], ["\n                    input[type='radio'] + label::after {\n                        background-color: #ff7d55;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #ff7d55;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #ff7d55;\n                    }\n                "])));
        case 'success':
        default:
            return (0,styled_components_browser_esm/* css */.iv)(Radio_css_templateObject_6 || (Radio_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    input[type='radio'] + label::after {\n                        background-color: #28a745;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #28a745;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #28a745;\n                    }\n                "], ["\n                    input[type='radio'] + label::after {\n                        background-color: #28a745;\n                    }\n                    input[type='radio']:checked + label::before {\n                        border-color: #28a745;\n                    }\n                    input[type='radio']:checked + label::after {\n                        background-color: #28a745;\n                    }\n                "])));
    }
});
var Radio_css_templateObject_1, Radio_css_templateObject_2, Radio_css_templateObject_3, Radio_css_templateObject_4, Radio_css_templateObject_5, Radio_css_templateObject_6, Radio_css_templateObject_7;


//# sourceMappingURL=Radio.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Radio/index.js
'use client';




var SPACE_KEYCODE = 32;
function Radio(props) {
    var type = props.type, name = props.name, value = props.value, checked = props.checked, tabIndex = props.tabIndex, label = props.label, onChange = props.onChange;
    var typeClass;
    switch (type) {
        case 'info': {
            typeClass = 'abc-radio-info';
            break;
        }
        case 'success': {
            typeClass = 'abc-radio-success';
            break;
        }
        case 'danger': {
            typeClass = 'abc-radio-danger';
            break;
        }
        case 'warning': {
            typeClass = 'abc-radio-warning';
            break;
        }
        default: {
            typeClass = '';
        }
    }
    var uid = "".concat(name, "-").concat(value, "-radio");
    var handleOnKeyUp = (0,react.useCallback)(function (event) {
        if ((event === null || event === void 0 ? void 0 : event.keyCode) === SPACE_KEYCODE) {
            onChange && onChange(event);
        }
    }, [onChange]);
    return (react.createElement(RadioWrapper, null,
        react.createElement(RadioContainer, { type: type, className: "abc-radio radio ".concat(typeClass) },
            react.createElement("input", { onChange: onChange, type: 'radio', id: uid, name: name, value: value, checked: checked, tabIndex: -1 }),
            react.createElement("label", { htmlFor: uid, tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : -1, onKeyUp: handleOnKeyUp }, label))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SlideShow/index.js + 3 modules
var SlideShow = __webpack_require__(5817);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LoadingIcon/index.js
var LoadingIcon = __webpack_require__(50293);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/RemoveIcon/index.js
var RemoveIcon = __webpack_require__(10786);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LimitedTextarea/index.js + 1 modules
var LimitedTextarea = __webpack_require__(21221);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 2 modules
var Popup = __webpack_require__(30744);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/urlBuilder.js
var urlBuilder = __webpack_require__(60332);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/helper.js
'use client';

var EventHelper = /** @class */ (function () {
    function EventHelper() {
        this.on = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.addEventListener(eventName, handler);
            }
        };
        this.off = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventName, handler);
            }
        };
        this.emit = function (eventName, pamarater) {
            if (typeof window !== 'undefined') {
                var event_1 = new CustomEvent(eventName, pamarater);
                window.dispatchEvent(event_1);
            }
        };
    }
    return EventHelper;
}());
var eventHelper = new EventHelper();
var getSliderItems = function (language) {
    var link = 'vi/infographic-tips/tim-viec-truc-tuyen-an-toan';
    var sliderItems = [
        {
            image: 'job-detail/cheating-5.png',
            link: link,
            titleVi: 'Lừa đảo thu phí',
            descriptionVi: 'Đưa ra lời mời làm việc dễ dàng bất thường, đãi ngộ cao, kèm theo yêu cầu nộp các loại phí.',
            titleEn: 'Fee Scam',
            descriptionEn: 'Give an unusual job offer with high benefit and paying fee requirement.'
        },
        {
            image: 'job-detail/cheating-6.png',
            link: link,
            titleVi: 'Đánh cắp thông tin ngân hàng',
            descriptionVi: 'Yêu cầu cung cấp thông tin tài khoản ngân hàng, mật khẩu, thẻ thanh toán, mã OTP.',
            titleEn: 'Banking information stealing',
            descriptionEn: 'Request to provide banking information, password, credit card, OTP code.'
        },
        {
            image: 'job-detail/cheating-7.png',
            link: link,
            titleVi: 'Đánh cắp danh tính',
            descriptionVi: 'Yêu cầu cung cấp bản Scan, chụp Giấy tờ tuỳ thân, mật khẩu Email để sử dụng trái phép danh tính của ứng viên.',
            titleEn: 'Personal information stealing ',
            descriptionEn: 'Request to provide Scan, photo of ID documents, Email password for illegally purpose.'
        },
        {
            image: 'job-detail/cheating-8.png',
            link: link,
            titleVi: 'Buôn bán lao động',
            descriptionVi: 'Đưa ra lời mời làm việc dễ dàng bất thường, mức đãi ngộ cao, yêu cầu không rõ ràng, địa điểm làm việc ở nước ngoài.',
            titleEn: 'Labor sale scam',
            descriptionEn: 'Giving an unusual job offers, high compensation, but unclear requirements, overseas location.'
        },
        {
            image: 'job-detail/cheating-9.png',
            link: link,
            titleVi: 'Giả dạng công ty lớn, uy tín',
            descriptionVi: 'Đăng tin mạo danh các tập đoàn quy mô lớn, gửi thông tin trực tiếp qua tin nhắn riêng cho người tìm việc.',
            titleEn: 'Famous companies scam',
            descriptionEn: 'Fake job posting from famous company, sending private message to candidates.'
        },
        {
            image: 'job-detail/cheating-10.png',
            link: link,
            titleVi: 'Tham gia thực hiện nhiệm vụ',
            descriptionVi: 'Yêu cầu ứng viên tham gia khảo sát/thử việc hoặc làm nhiệm vụ bằng cách cài đặt các ứng dụng điện thoại.',
            titleEn: 'Mission scam',
            descriptionEn: 'Ask candidates to take part in a survey/trial or task by installing mobile apps.'
        }
    ];
    return sliderItems;
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/hooks.js
'use client';



var ReportJobModalContext = react.createContext({
    data: null,
    language: '',
    useGlobalToast: false,
    t: function (text) { return ''; },
    locationClassName: "",
});
var useReportJob = function () { return (0,react.useContext)(ReportJobModalContext); };


//# sourceMappingURL=hooks.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/services.js
'use client';



var getReportList = function (url, tokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headerData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: headerData
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var makeReport = function (postData, url, tokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headerData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: headerData,
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var reportJobService = {
    getReportList: getReportList,
    makeReport: makeReport
};


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/styles.css.js
'use client';







var WHITE_COLOR = '#FFFFFF';
var TEXT_COLOR = '#333333';
var LINK_COLOR = '#005AFF';
var PRIMARY_COLOR = '#FF7D55';
var BORDER_COLOR = '#D9D9D9';
var BORDER_COLOR_DISBALE = '#FFCBBB';
var BACKGROUND_COLOR_DISABLE = '#FFF9F7';
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_1 || (styles_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    background: ", ";\n    border-radius: 12px;\n"], ["\n    width: 100%;\n    background: ", ";\n    border-radius: 12px;\n"])), WHITE_COLOR);
var styles_css_Container = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_2 || (styles_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
var styles_css_Title = styled_components_browser_esm/* default.p */.ZP.p(styles_css_templateObject_3 || (styles_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-transform: uppercase;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    margin: 0px 0px 16px 0px;\n    color: ", ";\n    margin-bottom: 20px;\n    font-weight: 700;\n"], ["\n    text-transform: uppercase;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    margin: 0px 0px 16px 0px;\n    color: ", ";\n    margin-bottom: 20px;\n    font-weight: 700;\n"])), TEXT_COLOR);
var SliderContainer = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_4 || (styles_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 32px;\n    width: 100%;\n"], ["\n    margin-bottom: 32px;\n    width: 100%;\n"])));
var SliderItemContainer = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_5 || (styles_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
var Image = styled_components_browser_esm/* default.img */.ZP.img(styles_css_templateObject_6 || (styles_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 186px;\n    object-fit: contain;\n    margin-bottom: 24px;\n"], ["\n    width: 100%;\n    height: 186px;\n    object-fit: contain;\n    margin-bottom: 24px;\n"])));
var NextImageWraper = styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_7 || (styles_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    height: 186px;\n    margin-bottom: 24px;\n    img {\n        object-fit: contain;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n    height: 186px;\n    margin-bottom: 24px;\n    img {\n        object-fit: contain;\n    }\n"])));
var SliderItemTitle = styled_components_browser_esm/* default.p */.ZP.p(styles_css_templateObject_8 || (styles_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    margin-bottom: 8px;\n    font-size: 20px;\n    color: ", ";\n    font-weight: 700;\n    line-height: 24px;\n    text-align: center;\n"], ["\n    margin: 0;\n    margin-bottom: 8px;\n    font-size: 20px;\n    color: ", ";\n    font-weight: 700;\n    line-height: 24px;\n    text-align: center;\n"])), TEXT_COLOR);
var SliderItemDescription = styled_components_browser_esm/* default.p */.ZP.p(styles_css_templateObject_9 || (styles_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 400;\n    line-height: 22px;\n    text-align: center;\n"], ["\n    margin: 0;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 400;\n    line-height: 22px;\n    text-align: center;\n"])), TEXT_COLOR);
var styles_css_Link = styled_components_browser_esm/* default.a */.ZP.a(styles_css_templateObject_10 || (styles_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 500;\n    line-height: 22px;\n    text-align: center;\n"], ["\n    margin: 0;\n    font-size: 14px;\n    color: ", ";\n    font-weight: 500;\n    line-height: 22px;\n    text-align: center;\n"])), LINK_COLOR);
var ReportJobDialog = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_11 || (styles_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: ", ";\n        height: 100%;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n    "], ["\n        border-radius: 12px;\n        background: ", ";\n        height: 100%;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n    "])), WHITE_COLOR),
    Header: styled_components_browser_esm/* default.div */.ZP.div(styles_css_templateObject_12 || (styles_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        border-bottom: 1px solid ", ";\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    "], ["\n        padding: 24px;\n        border-bottom: 1px solid ", ";\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    "])), BORDER_COLOR),
    Title: styled_components_browser_esm/* default.p */.ZP.p(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n    "], ["\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n    "])), TEXT_COLOR),
    Action: styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        cursor: pointer;\n    "], ["\n        cursor: pointer;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        overflow-y: scroll;\n    "], ["\n        padding: 24px;\n        overflow-y: scroll;\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 0px 24px 24px 24px;\n    "], ["\n        padding: 0px 24px 24px 24px;\n    "]))),
    Button: (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        text-align: center;\n    "], ["\n        width: 100%;\n        text-align: center;\n    "]))),
    TextError: styled_components_browser_esm/* default.span */.ZP.span(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])))
};
var Job = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        align-items: center;\n    "], ["\n        display: flex;\n        align-items: center;\n    "]))),
    Image: styled_components_browser_esm/* default.img */.ZP.img(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 44px;\n        height: 44px;\n        border-radius: 4px;\n        border: 1px solid ", ";\n        margin-right: 16px;\n    "], ["\n        width: 44px;\n        height: 44px;\n        border-radius: 4px;\n        border: 1px solid ", ";\n        margin-right: 16px;\n    "])), BORDER_COLOR),
    Wrapper: styled_components_browser_esm/* default.div */.ZP.div(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""]))),
    Name: styled_components_browser_esm/* default.p */.ZP.p(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        margin-bottom: 4px;\n        font-size: 16px;\n        font-weight: 500;\n        color: ", ";\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "], ["\n        margin: 0;\n        margin-bottom: 4px;\n        font-size: 16px;\n        font-weight: 500;\n        color: ", ";\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "])), TEXT_COLOR),
    Description: styled_components_browser_esm/* default.a */.ZP.a(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        &:hover {\n            color: ", ";\n        }\n        &:visited {\n            color: ", ";\n            &:hover {\n                color: ", ";\n            }\n        }\n    "], ["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        &:hover {\n            color: ", ";\n        }\n        &:visited {\n            color: ", ";\n            &:hover {\n                color: ", ";\n            }\n        }\n    "])), LINK_COLOR, constants/* colors.buttonColor */.O9.buttonColor, LINK_COLOR, constants/* colors.buttonColor */.O9.buttonColor),
    AnonymousCompany: styled_components_browser_esm/* default.p */.ZP.p(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "], ["\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-transform: uppercase;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 1;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    "])), LINK_COLOR)
};
var Reason = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 16px 0 16px -8px;\n    "], ["\n        margin: 16px 0 16px -8px;\n    "]))),
    Skeleton: (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-bottom: 10px;\n    "], ["\n        margin-bottom: 10px;\n    "]))),
    SkeletonContainer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 16px 0px;\n    "], ["\n        margin: 16px 0px;\n    "])))
};
var ReportJobSuccess = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: ", ";\n        padding: 24px;\n    "], ["\n        border-radius: 12px;\n        background: ", ";\n        padding: 24px;\n    "])), WHITE_COLOR),
    Header: styled_components_browser_esm/* default.div */.ZP.div(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    "], ["\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-top: 24px;\n    "], ["\n        margin-top: 24px;\n    "]))),
    Action: styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        cursor: pointer;\n    "], ["\n        cursor: pointer;\n    "]))),
    Button: (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        text-align: center;\n        background-color: ", ";\n        color: ", ";\n        border: 1px solid ", ";\n        :hover {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            color: ", " !important;\n        }\n        :focus,\n        :active {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            box-shadow: 0 0 0 1px ", " !important;\n            color: ", " !important;\n        }\n        &.btn-disabled,\n        &[disabled] {\n            cursor: not-allowed;\n            opacity: 0.5;\n            pointer-events: none;\n            background-color: ", " !important;\n            color: ", " !important;\n            border: 1px solid ", " !important;\n        }\n    "], ["\n        width: 100%;\n        text-align: center;\n        background-color: ", ";\n        color: ", ";\n        border: 1px solid ", ";\n        :hover {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            color: ", " !important;\n        }\n        :focus,\n        :active {\n            background-color: ", " !important;\n            border: 1px solid ", " !important;\n            box-shadow: 0 0 0 1px ", " !important;\n            color: ", " !important;\n        }\n        &.btn-disabled,\n        &[disabled] {\n            cursor: not-allowed;\n            opacity: 0.5;\n            pointer-events: none;\n            background-color: ", " !important;\n            color: ", " !important;\n            border: 1px solid ", " !important;\n        }\n    "])), PRIMARY_COLOR, WHITE_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, WHITE_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, PRIMARY_COLOR, WHITE_COLOR, BACKGROUND_COLOR_DISABLE, PRIMARY_COLOR, BORDER_COLOR_DISBALE),
    IconWrapper: styled_components_browser_esm/* default.div */.ZP.div(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    "], ["\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    "]))),
    Title: styled_components_browser_esm/* default.p */.ZP.p(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 30px 0px 0px 0px;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n        text-align: center;\n    "], ["\n        margin: 30px 0px 0px 0px;\n        font-size: 18px;\n        font-weight: 600;\n        color: ", ";\n        text-align: center;\n    "])), TEXT_COLOR),
    Description: styled_components_browser_esm/* default.p */.ZP.p(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin: 8px 0px 0px 0px;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-align: center;\n    "], ["\n        margin: 8px 0px 0px 0px;\n        font-size: 14px;\n        font-weight: 400;\n        color: ", ";\n        text-align: center;\n    "])), TEXT_COLOR)
};
var styles_css_templateObject_1, styles_css_templateObject_2, styles_css_templateObject_3, styles_css_templateObject_4, styles_css_templateObject_5, styles_css_templateObject_6, styles_css_templateObject_7, styles_css_templateObject_8, styles_css_templateObject_9, styles_css_templateObject_10, styles_css_templateObject_11, styles_css_templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36;


//# sourceMappingURL=styles.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(36802);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/ReportJobDialog.js
'use client';


















var LIMIT_TEXT = 500;
var OPEN_REPORT_DIALOG = 'open-report-job-dialog';
var CLOSE_REPORT_DIALOG = 'close-report-job-dialog';
var DEFAULT_COMPANY_LOGO = 'img/company-default-logo.svg';
var otherReasonID = 1;
var openReportDialog = function (locationClassName) {
    return new Promise(function (resolve, reject) {
        eventHelper.emit("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function (e) {
            resolve(e.detail);
        });
    });
};
var ReportJobDialog_ReportJobDialog = function () {
    var _a, _b, _c, _d, _e;
    var _f = useReportJob(), data = _f.data, language = _f.language, t = _f.t, locationClassName = _f.locationClassName;
    var _g = (0,react.useState)(false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = (0,react.useState)([]), reasonsSelected = _h[0], setReasonsSelected = _h[1];
    var _j = (0,react.useState)([]), reasons = _j[0], setReasons = _j[1];
    var _k = (0,react.useState)(false), isLoadingFetchReasons = _k[0], setIsLoadingFetchReason = _k[1];
    var _l = (0,react.useState)(false), isLoadingReportJob = _l[0], setIsLoadingReportJob = _l[1];
    var _m = (0,react.useState)(''), detailDescription = _m[0], setDetailDescription = _m[1];
    var _o = (0,react.useState)(false), isShowButton = _o[0], setIsShowButton = _o[1];
    var _p = (0,react.useState)(false), isShowError = _p[0], setIsShowError = _p[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var handleClose = function (status) {
        if (status === void 0) { status = false; }
        setIsOpen(false);
        setDetailDescription('');
        setIsShowButton(false);
        setIsShowError(false);
        eventHelper.emit("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), {
            detail: status
        });
    };
    var fetchReasons = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingFetchReason(true);
                    if (!(data === null || data === void 0 ? void 0 : data.apiTokenAccess)) return [3 /*break*/, 2];
                    return [4 /*yield*/, reportJobService.getReportList("".concat(data.apiGetway, "/job/report-reasons"), data.apiTokenAccess)];
                case 1:
                    response = _a.sent();
                    setReasons((response === null || response === void 0 ? void 0 : response.data) || []);
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingFetchReason(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var companyUrl = (0,urlBuilder/* buildCompanyUrl */.kQ)({
        companyId: (data === null || data === void 0 ? void 0 : data.job.companyId) || 0,
        companySlug: (data === null || data === void 0 ? void 0 : data.job.companyName) || '',
        langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN
    });
    if (data === null || data === void 0 ? void 0 : data.job.isCCP) {
        companyUrl = data.job.companyCCPUrl;
    }
    (0,react.useEffect)(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    (0,react.useEffect)(function () {
        if (isOpen && reasons.length === 0) {
            fetchReasons();
        }
    }, [isOpen]);
    var handleReportJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var postData, reportJobResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (detailDescription.length === 0) {
                        setIsShowError(true);
                        return [2 /*return*/];
                    }
                    if (detailDescription.length > LIMIT_TEXT) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoadingReportJob(true);
                    postData = {
                        reasonIds: reasonsSelected,
                        description: detailDescription,
                        jobId: data === null || data === void 0 ? void 0 : data.job.jobId
                    };
                    return [4 /*yield*/, reportJobService.makeReport(postData, "".concat(data === null || data === void 0 ? void 0 : data.apiGetway, "/job/").concat(data === null || data === void 0 ? void 0 : data.job.jobId, "/report"), (data === null || data === void 0 ? void 0 : data.apiTokenAccess) || '')];
                case 2:
                    reportJobResponse = _a.sent();
                    if ((reportJobResponse === null || reportJobResponse === void 0 ? void 0 : reportJobResponse.success) === true) {
                        tracking({
                            eventName: 'js_job_management:report_job_sucess',
                            properties: {
                                jobId: data === null || data === void 0 ? void 0 : data.job.jobId
                            }
                        });
                        handleClose(true);
                    }
                    else {
                        (0,Toast/* showToast */.CF)(t('Report Job error'), t("Can't update this Report Job"), Toast/* TOAST_TYPE_ERROR */.rn);
                        handleClose(false);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a.sent();
                    (0,Toast/* showToast */.CF)(t('Report Job error'), t("Can't update this Report Job"), Toast/* TOAST_TYPE_ERROR */.rn);
                    handleClose(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingReportJob(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleReasonChecked = function (checked, item) {
        var myReasonList = reasonsSelected;
        if (checked) {
            myReasonList.push(item.reasonId);
        }
        else {
            myReasonList = myReasonList.filter(function (reason) { return reason !== item.reasonId; });
        }
        if (item.reasonId === otherReasonID) {
            if (isShowError && !checked) {
                setIsShowError(false);
            }
        }
        if (myReasonList.length === 0) {
            setIsShowButton(false);
        }
        else {
            setIsShowButton(true);
        }
        setReasonsSelected(myReasonList);
    };
    var getInputText = function (text) {
        var finalText = text.trim();
        if (finalText.length > 0) {
            setIsShowError(false);
        }
        setDetailDescription(finalText);
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(Popup/* default */.Z, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, custom: {
                footer: react.createElement(react.Fragment, null),
                header: react.createElement(react.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            react.createElement(ReportJobDialog.Container, null,
                react.createElement(ReportJobDialog.Header, null,
                    react.createElement(ReportJobDialog.Title, null, t('Report job')),
                    react.createElement(ReportJobDialog.Action, { onClick: function () { return handleClose(); } },
                        react.createElement(RemoveIcon/* default */.Z, null))),
                react.createElement(ReportJobDialog.Body, null,
                    react.createElement(Job.Container, null,
                        react.createElement(Job.Image, { src: ((_a = data === null || data === void 0 ? void 0 : data.job) === null || _a === void 0 ? void 0 : _a.companyLogo) || "".concat(data === null || data === void 0 ? void 0 : data.imagesService, "/").concat(DEFAULT_COMPANY_LOGO) }),
                        react.createElement(Job.Wrapper, null,
                            react.createElement(Job.Name, null, (_b = data === null || data === void 0 ? void 0 : data.job) === null || _b === void 0 ? void 0 : _b.jobName),
                            ((_c = data === null || data === void 0 ? void 0 : data.job) === null || _c === void 0 ? void 0 : _c.isAnonymous) === 1 ? (react.createElement(Job.AnonymousCompany, null, (_d = data === null || data === void 0 ? void 0 : data.job) === null || _d === void 0 ? void 0 : _d.companyName)) : (react.createElement(Job.Description, { href: companyUrl, target: '_blank' }, (_e = data === null || data === void 0 ? void 0 : data.job) === null || _e === void 0 ? void 0 : _e.companyName)))),
                    isLoadingFetchReasons && (react.createElement(Reason.SkeletonContainer, null, new Array(9).fill(1).map(function (_, index) {
                        return react.createElement(Reason.Skeleton, { height: 28, key: index });
                    }))),
                    !isLoadingFetchReasons && reasons.length > 0 && (react.createElement(Reason.Container, null, reasons.map(function (item, index) { return (react.createElement(CheckBox/* default */.Z, { label: language === 'vi' ? item.reasonVi : item.reasonEn, onCheckChange: function (checked) { return handleReasonChecked(checked === 'checked', item); }, key: "report-job-checkbox-".concat(index) })); }))),
                    react.createElement(LimitedTextarea/* default */.Z, { rows: 4, limit: LIMIT_TEXT, value: detailDescription, language: language, inputText: getInputText, placeholder: t('Details of the reason.') }),
                    isShowError && (react.createElement(ReportJobDialog.TextError, { className: 'text-danger', style: {
                            marginTop: 8
                        } }, t('Please input detail description.')))),
                react.createElement(ReportJobDialog.Footer, null,
                    react.createElement(ReportJobDialog.Button, { type: 'primary', onClick: handleReportJob, disabled: !isShowButton },
                        isLoadingReportJob && react.createElement(LoadingIcon/* default */.Z, { bgColor: constants/* colors.bgNormal */.O9.bgNormal }),
                        react.createElement("span", { style: {
                                marginLeft: isLoadingReportJob ? 8 : 0
                            } }, t('Send'))))))));
};


//# sourceMappingURL=ReportJobDialog.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/icons.js
'use client';



var IconSuccess = function () {
    return (react.createElement("svg", { width: '66px', height: '66px', viewBox: '0 0 66 66', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: '\u27A4-Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Job-Detail---Report-Popup---Thanks', transform: 'translate(-650.000000, -301.000000)', fill: '#00B70B', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Popup', transform: 'translate(451.000000, 253.000000)' },
                    react.createElement("g", { id: 'Body', transform: 'translate(15.000000, 48.000000)' },
                        react.createElement("g", { id: 'icons8-checked', transform: 'translate(184.000000, 0.000000)' },
                            react.createElement("path", { d: 'M33,0 C14.804688,0 0,14.804688 0,33 C0,51.195313 14.804688,66 33,66 C51.195313,66 66,51.195313 66,33 C66,27.417969 64.601563,22.160156 62.144531,17.546875 L60.648438,19.007813 C62.785156,23.214844 64,27.96875 64,33 C64,50.09375 50.09375,64 33,64 C15.90625,64 2,50.09375 2,33 C2,15.90625 15.90625,2 33,2 C41.789063,2 49.726563,5.679688 55.375,11.578125 L56.800781,10.179688 C50.792969,3.914063 42.347656,0 33,0 Z M33,5 C32.449219,5 32,5.449219 32,6 C32,6.550781 32.449219,7 33,7 C33.550781,7 34,6.550781 34,6 C34,5.449219 33.550781,5 33,5 Z M38.292969,5.515625 C37.804688,5.503906 37.382813,5.84375 37.285156,6.324219 C37.179688,6.863281 37.53125,7.390625 38.074219,7.5 C38.613281,7.605469 39.140625,7.253906 39.25,6.714844 C39.355469,6.171875 39.003906,5.644531 38.464844,5.535156 C38.40625,5.527344 38.351563,5.519531 38.292969,5.515625 Z M27.738281,5.519531 C27.671875,5.519531 27.605469,5.523438 27.539063,5.535156 C26.996094,5.644531 26.644531,6.171875 26.753906,6.714844 C26.804688,6.972656 26.957031,7.203125 27.179688,7.351563 C27.398438,7.496094 27.667969,7.550781 27.929688,7.5 C28.472656,7.390625 28.824219,6.867188 28.714844,6.324219 C28.621094,5.859375 28.214844,5.523438 27.738281,5.519531 Z M22.675781,7.054688 C22.542969,7.054688 22.410156,7.078125 22.285156,7.128906 C21.773438,7.34375 21.53125,7.925781 21.746094,8.4375 C21.957031,8.949219 22.539063,9.191406 23.050781,8.980469 C23.5625,8.765625 23.804688,8.183594 23.59375,7.671875 C23.4375,7.300781 23.078125,7.058594 22.675781,7.054688 Z M43.355469,7.054688 C42.941406,7.046875 42.566406,7.289063 42.40625,7.671875 C42.195313,8.183594 42.4375,8.765625 42.949219,8.980469 C43.460938,9.191406 44.042969,8.949219 44.253906,8.4375 C44.46875,7.925781 44.226563,7.34375 43.714844,7.128906 C43.601563,7.082031 43.476563,7.058594 43.355469,7.054688 Z M18.011719,9.546875 C17.808594,9.546875 17.609375,9.605469 17.441406,9.71875 C16.984375,10.023438 16.859375,10.644531 17.167969,11.105469 C17.472656,11.5625 18.09375,11.6875 18.554688,11.378906 C19.015625,11.074219 19.136719,10.453125 18.832031,9.996094 C18.648438,9.71875 18.339844,9.550781 18.011719,9.546875 Z M48.015625,9.546875 C47.675781,9.542969 47.355469,9.710938 47.167969,9.996094 C46.859375,10.453125 46.984375,11.074219 47.441406,11.378906 C47.902344,11.6875 48.523438,11.5625 48.828125,11.105469 C48.976563,10.886719 49.03125,10.613281 48.980469,10.355469 C48.929688,10.09375 48.777344,9.863281 48.554688,9.71875 C48.394531,9.609375 48.210938,9.550781 48.015625,9.546875 Z M61.113281,10.15625 L30.859375,39.777344 L20.035156,28.722656 L17.890625,30.824219 L30.8125,44.019531 L63.214844,12.300781 L61.113281,10.15625 Z M13.921875,12.90625 C13.652344,12.90625 13.390625,13.011719 13.203125,13.203125 C12.8125,13.589844 12.8125,14.226563 13.203125,14.613281 C13.589844,15.003906 14.226563,15.003906 14.613281,14.613281 C15.003906,14.226563 15.003906,13.589844 14.613281,13.203125 C14.429688,13.015625 14.183594,12.910156 13.921875,12.90625 Z M52.105469,12.90625 C51.835938,12.90625 51.574219,13.011719 51.386719,13.203125 C50.996094,13.589844 50.996094,14.226563 51.386719,14.613281 C51.773438,15.003906 52.410156,15.003906 52.796875,14.613281 C53.1875,14.226563 53.1875,13.589844 52.796875,13.203125 C52.613281,13.015625 52.367188,12.910156 52.105469,12.90625 Z M10.566406,17 C10.226563,16.992188 9.90625,17.160156 9.71875,17.441406 C9.414063,17.902344 9.535156,18.523438 9.996094,18.828125 C10.457031,19.136719 11.074219,19.011719 11.382813,18.554688 C11.6875,18.09375 11.566406,17.472656 11.105469,17.167969 C10.945313,17.0625 10.761719,17.003906 10.566406,17 Z M57.953125,21.667969 C57.820313,21.664063 57.6875,21.691406 57.5625,21.742188 C57.050781,21.953125 56.808594,22.539063 57.019531,23.046875 C57.234375,23.558594 57.816406,23.800781 58.328125,23.589844 C58.839844,23.378906 59.082031,22.792969 58.871094,22.28125 C58.714844,21.914063 58.355469,21.667969 57.953125,21.667969 Z M8.078125,21.667969 C7.664063,21.660156 7.289063,21.902344 7.132813,22.285156 C6.921875,22.796875 7.164063,23.378906 7.671875,23.59375 C8.183594,23.804688 8.769531,23.5625 8.980469,23.050781 C9.191406,22.539063 8.949219,21.957031 8.4375,21.746094 C8.324219,21.695313 8.203125,21.671875 8.078125,21.667969 Z M59.484375,26.734375 C59.417969,26.730469 59.351563,26.738281 59.285156,26.75 C58.746094,26.859375 58.394531,27.386719 58.5,27.925781 C58.609375,28.46875 59.136719,28.820313 59.675781,28.714844 C60.21875,28.605469 60.570313,28.078125 60.464844,27.535156 C60.371094,27.070313 59.960938,26.734375 59.484375,26.734375 Z M6.546875,26.734375 C6.058594,26.722656 5.636719,27.058594 5.539063,27.535156 C5.488281,27.796875 5.539063,28.070313 5.6875,28.289063 C5.835938,28.511719 6.066406,28.664063 6.328125,28.714844 C6.585938,28.765625 6.855469,28.710938 7.078125,28.566406 C7.296875,28.417969 7.449219,28.1875 7.5,27.925781 C7.609375,27.386719 7.257813,26.859375 6.71875,26.75 C6.660156,26.742188 6.605469,26.734375 6.546875,26.734375 Z M6,32 C5.449219,32 5,32.449219 5,33 C5,33.550781 5.449219,34 6,34 C6.550781,34 7,33.550781 7,33 C7,32.449219 6.550781,32 6,32 Z M60,32 C59.449219,32 59,32.449219 59,33 C59,33.550781 59.449219,34 60,34 C60.550781,34 61,33.550781 61,33 C61,32.449219 60.550781,32 60,32 Z M6.523438,37.265625 C6.457031,37.265625 6.390625,37.273438 6.324219,37.285156 C5.78125,37.394531 5.429688,37.921875 5.539063,38.464844 C5.648438,39.003906 6.171875,39.355469 6.714844,39.25 C7.257813,39.140625 7.609375,38.613281 7.5,38.074219 C7.40625,37.605469 7,37.269531 6.523438,37.265625 Z M59.507813,37.265625 C59.019531,37.253906 58.597656,37.59375 58.5,38.074219 C58.394531,38.613281 58.746094,39.140625 59.285156,39.25 C59.828125,39.355469 60.355469,39.003906 60.464844,38.464844 C60.570313,37.921875 60.21875,37.394531 59.675781,37.285156 C59.621094,37.277344 59.566406,37.269531 59.507813,37.265625 Z M57.96875,42.328125 C57.554688,42.320313 57.179688,42.566406 57.019531,42.949219 C56.808594,43.457031 57.050781,44.042969 57.5625,44.253906 C58.074219,44.464844 58.65625,44.222656 58.871094,43.714844 C59.082031,43.203125 58.839844,42.617188 58.328125,42.40625 C58.214844,42.359375 58.089844,42.332031 57.96875,42.328125 Z M8.0625,42.332031 C7.929688,42.332031 7.796875,42.355469 7.671875,42.40625 C7.429688,42.507813 7.234375,42.703125 7.132813,42.949219 C7.03125,43.195313 7.03125,43.46875 7.128906,43.714844 C7.34375,44.226563 7.925781,44.46875 8.4375,44.253906 C8.683594,44.15625 8.878906,43.960938 8.980469,43.714844 C9.082031,43.46875 9.082031,43.195313 8.980469,42.949219 C8.828125,42.578125 8.464844,42.335938 8.0625,42.332031 Z M55.46875,47 C55.128906,46.992188 54.808594,47.160156 54.621094,47.441406 C54.3125,47.902344 54.4375,48.519531 54.894531,48.828125 C55.113281,48.976563 55.386719,49.03125 55.644531,48.976563 C55.90625,48.925781 56.136719,48.773438 56.28125,48.550781 C56.589844,48.09375 56.464844,47.472656 56.003906,47.167969 C55.847656,47.058594 55.660156,47 55.46875,47 Z M10.5625,47 C10.359375,46.996094 10.164063,47.054688 9.996094,47.167969 C9.539063,47.476563 9.414063,48.09375 9.71875,48.554688 C10.027344,49.011719 10.648438,49.136719 11.109375,48.828125 C11.566406,48.523438 11.691406,47.902344 11.382813,47.441406 C11.199219,47.167969 10.890625,47.003906 10.5625,47 Z M13.921875,51.09375 C13.652344,51.089844 13.390625,51.195313 13.203125,51.386719 C12.8125,51.773438 12.8125,52.410156 13.203125,52.796875 C13.589844,53.1875 14.226563,53.1875 14.613281,52.796875 C15.003906,52.410156 15.003906,51.773438 14.613281,51.386719 C14.429688,51.199219 14.183594,51.09375 13.921875,51.09375 Z M52.105469,51.09375 C51.835938,51.089844 51.574219,51.195313 51.386719,51.386719 C50.996094,51.773438 50.996094,52.410156 51.386719,52.796875 C51.773438,53.1875 52.410156,53.1875 52.796875,52.796875 C53.1875,52.410156 53.1875,51.773438 52.796875,51.386719 C52.613281,51.199219 52.367188,51.09375 52.105469,51.09375 Z M18.019531,54.449219 C17.679688,54.441406 17.359375,54.609375 17.171875,54.890625 C16.863281,55.351563 16.988281,55.972656 17.449219,56.28125 C17.90625,56.585938 18.527344,56.460938 18.832031,56.003906 C19.140625,55.542969 19.015625,54.925781 18.558594,54.617188 C18.398438,54.511719 18.210938,54.449219 18.019531,54.449219 Z M48.011719,54.449219 C47.808594,54.445313 47.613281,54.503906 47.445313,54.613281 C47.222656,54.761719 47.070313,54.992188 47.019531,55.253906 C46.96875,55.511719 47.023438,55.785156 47.171875,56.003906 C47.476563,56.460938 48.097656,56.585938 48.558594,56.28125 C49.015625,55.972656 49.140625,55.351563 48.832031,54.890625 C48.652344,54.617188 48.34375,54.449219 48.011719,54.449219 Z M22.691406,56.941406 C22.277344,56.933594 21.902344,57.179688 21.746094,57.5625 C21.535156,58.070313 21.777344,58.65625 22.285156,58.867188 C22.796875,59.078125 23.382813,58.835938 23.59375,58.328125 C23.804688,57.816406 23.5625,57.230469 23.050781,57.019531 C22.9375,56.972656 22.816406,56.945313 22.691406,56.941406 Z M43.339844,56.941406 C43.207031,56.941406 43.074219,56.96875 42.953125,57.019531 C42.707031,57.121094 42.511719,57.316406 42.410156,57.558594 C42.308594,57.804688 42.308594,58.082031 42.40625,58.328125 C42.621094,58.835938 43.203125,59.078125 43.714844,58.867188 C43.960938,58.765625 44.15625,58.570313 44.257813,58.328125 C44.359375,58.082031 44.359375,57.804688 44.257813,57.5625 C44.105469,57.1875 43.742188,56.945313 43.339844,56.941406 Z M27.761719,58.480469 C27.273438,58.46875 26.847656,58.808594 26.753906,59.285156 C26.644531,59.828125 26.996094,60.351563 27.539063,60.460938 C28.082031,60.570313 28.605469,60.21875 28.714844,59.675781 C28.824219,59.132813 28.472656,58.609375 27.929688,58.5 C27.875,58.488281 27.816406,58.480469 27.761719,58.480469 Z M38.269531,58.484375 C38.203125,58.480469 38.136719,58.488281 38.074219,58.5 C37.53125,58.609375 37.179688,59.132813 37.285156,59.675781 C37.339844,59.9375 37.492188,60.164063 37.710938,60.3125 C37.933594,60.460938 38.203125,60.515625 38.464844,60.464844 C38.722656,60.410156 38.953125,60.257813 39.101563,60.039063 C39.246094,59.816406 39.300781,59.546875 39.25,59.285156 C39.15625,58.820313 38.746094,58.484375 38.269531,58.484375 Z M33,59 C32.449219,59 32,59.449219 32,60 C32,60.550781 32.449219,61 33,61 C33.550781,61 34,60.550781 34,60 C34,59.449219 33.550781,59 33,59 Z', id: 'Shape' }))))))));
};


//# sourceMappingURL=icons.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/ReportSuccessDialog.js
'use client';










var OPEN_REPORT_SUCCESS_DIALOG = 'open-report-success-dialog';
var CLOSE_REPORT_SUCCESS_DIALOG = 'close-report-success-dialog';
var openReportSuccessDialog = function (locationClassName) {
    return new Promise(function (res, _) {
        eventHelper.emit("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () {
            res(null);
        });
    });
};
var ReportJobSuccessDialog = function () {
    var _a = (0,react.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useReportJob(), language = _b.language, t = _b.t, locationClassName = _b.locationClassName;
    var handleClose = function () {
        setIsOpen(false);
        eventHelper.emit("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
    };
    (0,react.useEffect)(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    return (react.createElement(react.Fragment, null,
        react.createElement(Popup/* default */.Z, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, custom: {
                footer: react.createElement(react.Fragment, null),
                header: react.createElement(react.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            react.createElement(ReportJobSuccess.Container, null,
                react.createElement(ReportJobSuccess.Header, null,
                    react.createElement(ReportJobSuccess.Action, { onClick: function () { return handleClose(); } },
                        react.createElement(RemoveIcon/* default */.Z, null))),
                react.createElement(ReportJobSuccess.Body, null,
                    react.createElement(ReportJobSuccess.IconWrapper, null,
                        react.createElement(IconSuccess, null)),
                    react.createElement(ReportJobSuccess.Title, null, t('Report a job successfully')),
                    react.createElement(ReportJobSuccess.Description, null, t('Your comments make an important contribution to protecting the Job Seeker Community.'))),
                react.createElement(ReportJobSuccess.Footer, null,
                    react.createElement(ReportJobSuccess.Button, { onClick: handleClose }, t('Close')))))));
};


//# sourceMappingURL=ReportSuccessDialog.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/translation.js
'use client';

var translation_translations = {
    'Report job': 'Báo cáo tin tuyển dụng',
    'Reported this job': 'Đã báo cáo việc làm này',
    Send: 'Gửi',
    'Please input detail description.': 'Bạn cần nhập mô tả chi tiết.',
    'Your comments make an important contribution to protecting the Job Seeker Community.': 'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a job successfully': 'Báo cáo việc làm thành công',
    'Scam detection': 'Nhận diện một số hình thức lừa đảo',
    'View detail': 'Xem chi tiết',
    Close: 'Đóng',
    "Can't update this Report Job": 'Không thể cập nhật báo cáo tin tuyển dụng này',
    'Report Job error': 'Lỗi báo cáo tin tuyển dụng',
    'Details of the reason.': 'Mô tả chi tiết lý do báo cáo.',
    login: 'dang-nhap'
};


//# sourceMappingURL=translation.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/constants.js
var LoginModal_constants = __webpack_require__(33874);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDelay.js
'use client';




function delay(ms) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            return [2 /*return*/, ms ? new Promise(function (resolve) { return setTimeout(resolve, ms); }) : Promise.resolve()];
        });
    });
}
function useDelay(ms, defaultSetting) {
    if (defaultSetting === void 0) { defaultSetting = true; }
    var _a = (0,react.useState)(defaultSetting), isDelay = _a[0], setIsDelay = _a[1];
    (0,react.useEffect)(function () {
        if (ms) {
            delay(ms).then(function () { return setIsDelay(!defaultSetting); });
        }
    }, [ms, defaultSetting]);
    return isDelay;
}


//# sourceMappingURL=useDelay.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementOnScreen/index.js
var UseElementOnScreen = __webpack_require__(85694);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ReportJobModal/index.js
'use client';




















var SliderItem = function (_a) {
    var sliderItem = _a.sliderItem, buildId = _a.buildId, nextImage = _a.nextImage;
    var link = sliderItem.link, image = sliderItem.image, titleVi = sliderItem.titleVi, descriptionVi = sliderItem.descriptionVi, descriptionEn = sliderItem.descriptionEn, titleEn = sliderItem.titleEn;
    var _b = useReportJob(), data = _b.data, language = _b.language, t = _b.t;
    var _c = data || {}, imagesService = _c.imagesService, faqService = _c.faqService;
    var sliderItemContainerRef = (0,react.useRef)(null);
    var isRenderedRef = (0,react.useRef)(false);
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: sliderItemContainerRef
    })[0];
    var renderImage = function () {
        var src = "".concat(imagesService, "/images/").concat(image, "?version=").concat(buildId !== null && buildId !== void 0 ? buildId : 0);
        var alt = 'report-job';
        if (!isElementOnScreen && !isRenderedRef.current) {
            return react.createElement(NextImageWraper, null);
        }
        isRenderedRef.current = true;
        if (!nextImage) {
            return react.createElement(Image, { src: src, alt: alt, loading: 'lazy' });
        }
        return react.createElement(NextImageWraper, null, nextImage(src, alt));
    };
    return (react.createElement(SliderItemContainer, { ref: sliderItemContainerRef },
        renderImage(),
        react.createElement(SliderItemTitle, null, language === 'vi' ? titleVi : titleEn),
        react.createElement(SliderItemDescription, null, language === 'vi' ? descriptionVi : descriptionEn),
        react.createElement(styles_css_Link, { href: "".concat(faqService, "/").concat(link) }, t('View detail'))));
};
var ReportJobModal = function (props) {
    var _a = (0,react.useState)(false), isReportSuccess = _a[0], setIsReportSuccess = _a[1];
    var buttonRef = (0,react.useRef)(null);
    var _b = props.data, data = _b === void 0 ? {
        job: {
            jobId: 0,
            companyLogo: '',
            companyName: '',
            jobName: '',
            companyId: 0,
            companyCCPUrl: '',
            isCCP: false,
            isAnonymous: 0
        },
        apiTokenAccess: 'NTFmNWExMDIxMGE4NTFkYTBhZDNjMjZkNzAzZmNkYjg0NmJhMzY3MzY4NzE3ZGE5NDZmNDJmZDY3NjlmYzBmMg',
        isAuthenticated: 0,
        apiGetway: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0',
        isReportJob: false,
        imagesService: 'https://staging-images.vietnamworks.com/images',
        faqService: '',
        redirectPage: '',
        wnwBaseURL: ''
    } : _b, _c = props.language, language = _c === void 0 ? 'vi' : _c, _d = props.useGlobalToast, useGlobalToast = _d === void 0 ? false : _d, _e = props.locationClassName, locationClassName = _e === void 0 ? '' : _e, styles = props.styles, _f = props.buildId, buildId = _f === void 0 ? 0 : _f, nextImage = props.nextImage, _g = props.delayTime, delayTime = _g === void 0 ? 1000 : _g;
    var delay = useDelay(delayTime);
    var _h = data || {}, isAuthenticated = _h.isAuthenticated, isReportJob = _h.isReportJob;
    var t = function (text) {
        if (language === 'vi') {
            return translation_translations[text];
        }
        return text;
    };
    var handleReport = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var isSuccess;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openReportDialog(locationClassName)];
                case 1:
                    isSuccess = _a.sent();
                    if (!isSuccess) return [3 /*break*/, 3];
                    return [4 /*yield*/, openReportSuccessDialog(locationClassName)];
                case 2:
                    _a.sent();
                    setIsReportSuccess(true);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickReport = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var loginEvent;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            if (!isAuthenticated) {
                loginEvent = new CustomEvent(LoginModal_constants/* LOGIN_POPUP */.eS, {
                    detail: {
                        langCode: language,
                        isNeedReload: true
                    }
                });
                window.dispatchEvent(loginEvent);
                return [2 /*return*/];
            }
            handleReport();
            return [2 /*return*/];
        });
    }); };
    (0,react.useEffect)(function () {
        var timeout = setTimeout(function () {
            var queryParams = new URLSearchParams(window.location.search.substring(1));
            var reportParam = queryParams.get('report');
            if (reportParam === 'true') {
                handleClickReport();
            }
        }, 0);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    var isReportedJob = isReportJob || isReportSuccess;
    var sliderItems = getSliderItems();
    return (react.createElement(ReportJobModalContext.Provider, { value: {
            data: data,
            language: language,
            useGlobalToast: useGlobalToast,
            locationClassName: locationClassName,
            t: t
        } },
        react.createElement(react.Fragment, null,
            !useGlobalToast && react.createElement(Toast/* default */.ZP, null),
            react.createElement(ReportJobDialog_ReportJobDialog, null),
            react.createElement(ReportJobSuccessDialog, null),
            react.createElement(Wrapper, { style: styles },
                react.createElement(styles_css_Container, null,
                    react.createElement(styles_css_Title, null, t('Scam detection')),
                    react.createElement(SliderContainer, null, delay ? (react.createElement(react.Fragment, null,
                        react.createElement(SliderItem, { sliderItem: sliderItems[0], buildId: buildId, nextImage: nextImage }),
                        react.createElement("div", { style: { width: '100%', height: '52px' } }))) : (react.createElement(SlideShow/* default */.Z, { id: 'slider-cheating', transitionTime: 1000, pagination: {
                            maxShow: 6
                        }, autoEnable: true }, sliderItems.map(function (sliderItem, index) {
                        return (react.createElement(SliderItem, { key: index, sliderItem: sliderItem, buildId: buildId, nextImage: nextImage }));
                    })))),
                    react.createElement(Button/* default */.Z, { id: 'reportBtn', type: 'primary', ref: buttonRef, onClick: handleClickReport, disabled: isReportedJob, outline: 'outline', style: { width: '100%' } }, isReportedJob ? t('Reported this job') : t('Report job')))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ReportCompanyModal/index.js + 8 modules
var ReportCompanyModal = __webpack_require__(52665);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/HRInsider/translation.js
'use client';

var HRInsider_translation_translations = {
    'Career Advice From HR Insider': 'Tư Vấn Nghề Nghiệp Từ HR Insider',
    'View all': 'Xem tất cả',
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/HRInsider/LineClampText.js
'use client';





var StyledParagraph = styled_components_browser_esm/* default.p */.ZP.p(LineClampText_templateObject_1 || (LineClampText_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"], ["\n    margin: 0px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"])), function (props) { var _a; return (_a = props.lines) !== null && _a !== void 0 ? _a : 1; });
var LineClampText = function (_a) {
    var lines = _a.lines, content = _a.content;
    return (react.createElement("div", null,
        react.createElement(StyledParagraph, { lines: lines }, content)));
};
var LineClampText_templateObject_1;


//# sourceMappingURL=LineClampText.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/HRInsider/HRInsider.css.js
'use client';




var HRInsiderWrapper = styled_components_browser_esm/* default.div */.ZP.div(HRInsider_css_templateObject_1 || (HRInsider_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .article-list {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 20px;\n        font-size: 14px;\n\n        .article-item {\n            flex: 1;\n            border: 1px solid transparent;\n            padding: 0px;\n            box-shadow: none;\n            border-radius: 6px;\n            overflow: hidden;\n            text-align: left;\n            height: 390px;\n            background-color: #ffffff;\n\n            transition: border-color 250ms ease;\n            -webkit-transition: border-color 250ms ease;\n            -moz-transition: border-color 250ms ease;\n\n            .image-wrapper {\n                max-height: 160px;\n                overflow: hidden;\n            }\n\n            &:hover {\n                border-color: #ff7d55;\n\n                .article-link {\n                    color: #ff7d55;\n                }\n            }\n\n            .article-content {\n                padding: 1rem;\n            }\n\n            .article-link {\n                text-decoration: none;\n                color: inherit;\n                display: block;\n                height: 66px;\n\n                font-size: 16px;\n                font-weight: 600;\n                margin: 6px 0;\n\n                .title {\n                    font-size: 18px;\n                    margin: 10px 0;\n                }\n\n                .description {\n                    font-size: 14px;\n                    color: #666;\n                    margin-bottom: 10px;\n                    height: 84px;\n                }\n\n                .category {\n                    font-size: 12px;\n                    color: #999;\n                    text-transform: uppercase;\n                }\n            }\n        }\n    }\n\n    .el-wrapper169 {\n        position: relative;\n        width: 100%;\n        padding-top: 56.25%; /* 16:9 Aspect Ratio */\n    }\n\n    .el-inner {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n    }\n\n    .el-img-fit {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .el-img-fit-container {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .ellipsis {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n    .cardBlock__category {\n        align-items: center;\n        color: #757575;\n        font-size: 14px;\n        font-weight: 400;\n        text-transform: none;\n        margin: 16px 0 0;\n        height: 21px;\n    }\n\n    .cardBlock__point {\n        display: inline-block;\n        margin-right: 6px;\n        width: 10px;\n        height: 10px;\n        background-color: #ff7d55;\n    }\n\n    .flex-space-between {\n        display: flex;\n        justify-content: space-between;\n        align-content: center;\n    }\n    .article-title {\n        margin: 1rem 0;\n        h2 {\n            font-size: 22px;\n            text-align: left;\n            font-weight: 600;\n            padding: 0;\n            text-transform: capitalize;\n            margin: 0;\n        }\n        a {\n            color: #005aff;\n            text-decoration: none;\n            font-size: 14px;\n            &:hover {\n                text-decoration: none;\n                color: #ff7d55 !important;\n            }\n        }\n    }\n\n    @media (max-width: 768px) {\n        .article-title h2 {\n            font-size: 16px;\n            line-height: 19px;\n        }\n        .article-title a {\n            font-size: 14px;\n            line-height: 19px;\n        }\n        .article-list {\n            flex-direction: column;\n            .article-item {\n                width: 100%; /* Full width for mobile */\n\n                .article-link {\n                    height: auto;\n                }\n            }\n        }\n    }\n"], ["\n    .article-list {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 20px;\n        font-size: 14px;\n\n        .article-item {\n            flex: 1;\n            border: 1px solid transparent;\n            padding: 0px;\n            box-shadow: none;\n            border-radius: 6px;\n            overflow: hidden;\n            text-align: left;\n            height: 390px;\n            background-color: #ffffff;\n\n            transition: border-color 250ms ease;\n            -webkit-transition: border-color 250ms ease;\n            -moz-transition: border-color 250ms ease;\n\n            .image-wrapper {\n                max-height: 160px;\n                overflow: hidden;\n            }\n\n            &:hover {\n                border-color: #ff7d55;\n\n                .article-link {\n                    color: #ff7d55;\n                }\n            }\n\n            .article-content {\n                padding: 1rem;\n            }\n\n            .article-link {\n                text-decoration: none;\n                color: inherit;\n                display: block;\n                height: 66px;\n\n                font-size: 16px;\n                font-weight: 600;\n                margin: 6px 0;\n\n                .title {\n                    font-size: 18px;\n                    margin: 10px 0;\n                }\n\n                .description {\n                    font-size: 14px;\n                    color: #666;\n                    margin-bottom: 10px;\n                    height: 84px;\n                }\n\n                .category {\n                    font-size: 12px;\n                    color: #999;\n                    text-transform: uppercase;\n                }\n            }\n        }\n    }\n\n    .el-wrapper169 {\n        position: relative;\n        width: 100%;\n        padding-top: 56.25%; /* 16:9 Aspect Ratio */\n    }\n\n    .el-inner {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n    }\n\n    .el-img-fit {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .el-img-fit-container {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .ellipsis {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n    .cardBlock__category {\n        align-items: center;\n        color: #757575;\n        font-size: 14px;\n        font-weight: 400;\n        text-transform: none;\n        margin: 16px 0 0;\n        height: 21px;\n    }\n\n    .cardBlock__point {\n        display: inline-block;\n        margin-right: 6px;\n        width: 10px;\n        height: 10px;\n        background-color: #ff7d55;\n    }\n\n    .flex-space-between {\n        display: flex;\n        justify-content: space-between;\n        align-content: center;\n    }\n    .article-title {\n        margin: 1rem 0;\n        h2 {\n            font-size: 22px;\n            text-align: left;\n            font-weight: 600;\n            padding: 0;\n            text-transform: capitalize;\n            margin: 0;\n        }\n        a {\n            color: #005aff;\n            text-decoration: none;\n            font-size: 14px;\n            &:hover {\n                text-decoration: none;\n                color: #ff7d55 !important;\n            }\n        }\n    }\n\n    @media (max-width: 768px) {\n        .article-title h2 {\n            font-size: 16px;\n            line-height: 19px;\n        }\n        .article-title a {\n            font-size: 14px;\n            line-height: 19px;\n        }\n        .article-list {\n            flex-direction: column;\n            .article-item {\n                width: 100%; /* Full width for mobile */\n\n                .article-link {\n                    height: auto;\n                }\n            }\n        }\n    }\n"])));
var HRInsider_css_templateObject_1;


//# sourceMappingURL=HRInsider.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/HRInsider/index.js
'use client';







function stripHtmlTags(html) {
    return html.replace(/<[^>]*>/g, '');
}
var ArticleList = function (props) {
    var _a = props.apiUrl, apiUrl = _a === void 0 ? 'https://ms.vietnamworks.com' : _a, _b = props.viewAllUrl, viewAllUrl = _b === void 0 ? 'https://www.vietnamworks.com/hrinsider' : _b, _c = props.vnwUrl, vnwUrl = _c === void 0 ? 'https://www.vietnamworks.com' : _c, tagIds = props.tagIds, _d = props.language, language = _d === void 0 ? 'vi' : _d, _e = props.limit, limit = _e === void 0 ? 4 : _e, _f = props.utm, utm = _f === void 0 ? '' : _f;
    var _g = (0,react.useState)([]), articles = _g[0], setArticles = _g[1];
    var utmData = utm.startsWith('?') ? utm : '?' + utm;
    var t = function (text) {
        if (language === 'vi') {
            return HRInsider_translation_translations[text];
        }
        return text;
    };
    var getArticles = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var url, response, data, articles;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = tagIds && tagIds.length > 0
                        ? "".concat(apiUrl, "/navi-api/api/blogs-by-hr-tag?tag_ids=").concat(tagIds.join(','), "&limit=").concat(limit)
                        : "".concat(apiUrl, "/navi-api/api/blogs?limit=").concat(limit);
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (Array.isArray(data) && data.length > limit) {
                        data = data.slice(0, limit);
                    }
                    articles = data.map(function (item) {
                        var image = item.cover_picture;
                        var tags = item.tags || [];
                        var category = tags.map(function (item) { return item.name; }).join(', ');
                        return {
                            id: item.id,
                            title: stripHtmlTags(item.title),
                            image: image,
                            description: stripHtmlTags(item.short_description),
                            url: vnwUrl + item.hrDetailSlug + utmData,
                            category: category
                        };
                    });
                    setArticles(articles);
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        getArticles();
    }, []);
    (0,react.useEffect)(function () {
        getArticles();
    }, [tagIds]);
    return (react.createElement(HRInsiderWrapper, null,
        react.createElement("div", { className: 'flex-space-between article-title' },
            react.createElement("h2", null, t('Career Advice From HR Insider')),
            react.createElement("a", { href: viewAllUrl + utmData, target: 'blank' }, t('View all'))),
        react.createElement("div", { className: 'article-list' }, articles.map(function (article) { return (react.createElement("div", { key: article.id, className: 'article-item' },
            react.createElement("div", { className: 'image-wrapper' },
                react.createElement("div", { className: 'el-wrapper169' },
                    react.createElement("div", { className: 'el-inner' },
                        react.createElement("img", { src: article.image, alt: article.title, className: ' el-img-fit' })))),
            react.createElement("div", { className: 'article-content' },
                react.createElement("a", { href: article.url, className: 'article-link' },
                    react.createElement(LineClampText, { content: article.title, lines: 3 })),
                react.createElement(LineClampText, { content: article.description, lines: 4 }),
                article.category !== '' && (react.createElement("div", { className: 'cardBlock__category ellipsis' },
                    react.createElement("span", { className: 'cardBlock__point' }),
                    react.createElement("span", null, article.category)))))); }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Input/input.module.css.js
'use client';

var input_module_css_s = {"inputWrapper":"input-module_inputWrapper__3YvBT","clearValue":"input-module_clearValue__krWnE","inputWrapperIcon":"input-module_inputWrapperIcon__1xOnT","input":"input-module_input__3wsvS","removeIcon":"input-module_removeIcon__1ECIm","labelWrapper":"input-module_labelWrapper__1RHjc","inputError":"input-module_inputError__3I3tm","inputRecommendation":"input-module_inputRecommendation__3V5nQ","listRecommend":"input-module_listRecommend__3k1K3","activeRecommendedItem":"input-module_activeRecommendedItem__1Hyte"};


//# sourceMappingURL=input.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Select/styled.js
'use client';




var StyledSelect = styled_components_browser_esm/* default.div */.ZP.div(styled_templateObject_1 || (styled_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    > .select-container{\n        display: inline-flex;\n        flex-wrap: wrap;\n        align-items: center;\n        position: relative;\n        max-width: 250px;\n        height: 40px;\n        :focus{\n            outline: none;\n        }\n        &:hover, &:focus{\n            .active-item{\n                .active-text{\n                    color: #FF7D55;\n                }\n            }\n            svg{\n                .path-arrow-down{\n                    fill: #FF7D55;\n                    g{\n                        fill: #FF7D55;\n                    }\n                }\n            }\n        }\n\n        &.full-width{\n            display: flex;\n            max-width: unset;\n        }\n\n        &.disabled{\n            background: #f9f9f9;\n            border-color: #e6e6e6;\n            color: #969696;\n            position: relative;\n            pointer-events: none;\n\n            svg{opacity: 0.5}\n        }\n\n    }\n\n    .full-width{\n        .active-item{\n            display: flex;\n            width: 100%;\n        }\n\n        .select-dropdown{\n            width: 100%;\n        }\n    }\n\n    .title{\n        margin-bottom: 5px;\n    }\n\n    .bordered{\n        border: 1px solid #ddd;\n        border-radius: 3px;\n\n        .active-item{\n            padding: 10px 10px 10px 14px;\n        }\n\n        .select-dropdown{\n            top: 42px;\n        }\n    }\n\n    .expand{\n        .select-dropdown{\n            visibility: visible;\n            opacity: 1;\n            max-height: 350px;\n        }\n    }\n    .error{\n        border-color: #f85a5a\n    }\n\n    .multiple-select-selected-values{\n        padding: 4px 4px 2px 4px;\n        min-height: 40px;\n\n        .multiple-option-item{\n            color: #333;\n            display: inline-flex;\n            align-items: center;\n            font-size: 14px;\n            user-select: none;\n            padding: 4px 7px 4px 10px;\n            margin: 0 2px;\n            background: #FBFBFB;\n            border: 1px solid #E0E0E0;\n            cursor: pointer;\n            height: 30px;\n            transition: border-color .3s;\n            border-radius: 4px;\n\n            i{font-style: normal; margin-left: 4px; transition: color 0.3s;}\n\n            &:hover i{color: #f85a5a}\n        }\n    }\n\n    .not-show-tag {\n        .multiple-option-item{\n            color: #333;\n            display: inline-flex;\n            align-items: center;\n            font-size: 14px;\n            user-select: none;\n            padding: 4px 0 4px 0 !important;\n            margin: 0;\n            background: transparent;\n            border: none;\n            cursor: pointer;\n            height: 30px;\n\n            i{font-style: normal; margin-left: 4px; transition: color 0.3s;}\n\n            &:hover i{color: #f85a5a}\n        }\n    }\n\n    .active-item{\n        display: inline-flex;\n        cursor: pointer;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        &:focus{\n            outline: none;\n        }\n    }\n\n    .active-text{\n        font-size: 13px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-weight: 600;\n        padding-right: 6px;\n        &.text-default{\n            font-weight: normal;\n        }\n    }\n\n    .input-item{\n        position: relative;\n\n        .input{\n            display: inline-flex;\n            width: 100%;\n            padding: 10px 30px 10px 35px;\n            position: relative;\n            border: none;\n            border-radius: 3px;\n            width: 100%;\n            line-height: 1;\n            transition: border-color 0.3s;\n            background: #f2f2f2;\n            font-weight: 500;\n            &:focus{\n                outline: none;\n                border-color: none;\n            }\n        }\n\n        .icon{\n            position: absolute;\n            right: 4px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n        .filter-close{\n            display: none;\n            position: absolute;\n            top: 13px;\n            background: #999;\n            right: 10px;\n            cursor: pointer;\n            opacity: 0.5;\n            border-radius: 50px;\n            fill: #fff;\n            transition: all .3s;\n            &.active{\n                display: block;\n            }\n            &:hover{\n                opacity: 1;\n            }\n            &:focus{\n                outline: none;\n                box-shadow: 0 0 0 3px rgba(0, 185, 242, 0.4);\n            }\n        }\n    }\n\n    .icon{\n        display: inline-flex;\n        align-items: center;\n\n        svg{\n            fill: black;\n            opacity: 0.6;\n            width: 10px;\n            height: auto;\n        }\n    }\n\n    .select-dropdown{\n        position: absolute;\n        overflow: hidden;\n        z-index: 5;\n        top: 28px;\n        width: 335px;\n        visibility: hidden;\n        opacity: 0;\n        max-height: 0;\n        transition: all 0.3s;\n        border: 1px solid #ccc;\n        border-radius: 2px;\n        background-color: #FFF;\n        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1)\n    }\n    .select-dropdown-align-left{\n        left: 0;\n    }\n    .select-dropdown-align-right{\n        right: 0;\n    }\n\n    .select-search{\n        padding: 15px 15px 0 15px;\n        margin-bottom: 5px;\n        &.select-search-no-searchBox{\n            padding-top: 0;\n        }\n    }\n\n    .select-options{\n        overflow: hidden scroll;\n        max-height: 260px;\n        margin: 0 15px 10px 15px;\n        &::-webkit-scrollbar{\n            display: none;\n        }\n        &:-ms-overflow-style: none;\n        scrollbar-width: none;\n        .max-number-of-selection-message {\n            color: #FF7D55;\n            display: block;\n            width: 100%;\n            padding: 4px 0 2px 0;\n        }\n        .clear-selected-section {\n            font-size: 12px;\n            color: rgba(51,51,51, 0.7);\n            line-height: 20px;\n            text-transform: uppercase;\n            > span {\n                float: right;\n                color:#005AFF;\n                cursor: pointer;\n                font-size: 14px;\n                line-height: 16px;\n                text-transform: none;\n            }\n        }\n    }\n\n    .select-item{\n        border-top: 1px solid #e5e5e5;\n        padding: 10px 0;\n        cursor: pointer;\n        display: flex;\n        &:first-child{\n            border-top: none;\n        }\n        &:hover,\n        &.active,\n        &:focus{\n            color: #FF7D55;\n        }\n\n        &:hover,\n        &:focus{\n            background: #fbfbfb;\n            outline: none;\n        }\n\n        &.active{\n            color: #333;\n            font-weight: 500;\n            background: #fff;\n            cursor: auto;\n        }\n\n        &.read-only{\n            cursor: auto;\n\n            &:hover{\n                color: unset;\n            }\n        }\n\n        &.focusing {\n            color: #FF7D55;\n            background: #fbfbfb;\n        }\n\n        .icon{\n            svg{\n                width: 14px;\n                fill: #005aff;\n            }\n        }\n\n        .item-text{\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            margin-right: 8px;\n        }\n    }\n\n    > .title{\n        font-weight: 600;\n        text-transform: uppercase;\n    }\n}\n.show-checked {\n    > span[width] {\n        padding-right: 10px;\n        padding-left: 10px;\n        cursor: pointer;\n        height: 100%;\n    }\n    .multiple-select-selected-values {\n        height: 40px;\n        width: 86%;\n        overflow: hidden;\n        white-space: nowrap;\n        .multiple-option-item {\n            margin-bottom: 10px;\n            padding: 4px 10px;\n            &.hide {\n                display: none;\n            }\n            &:first-child {\n                margin-left: 0;\n            }\n        }\n        @media screen and (min-width: 768px) and (max-width: 1023px) {\t\n            width: 80%;\n        }\n        @media screen and (min-width: 1024px) and (max-width: 1160px) {\t\n            width: 84%;\n        }\n    }\n    .active-item {\n        width: 86%;\n    }\n    .select-item {\n        border-top: none;\n        cursor: pointer;\n        &:hover {\n            background-color: #fbfbfb;\n        }\n        > span {\n            width: 18px;\n            height: 18px;\n            background-color:#fff;\n            border: 1px solid #005AFF;\n            border-radius: 4px;\n            min-width: 18px;\n            padding-left: 1px;\n            &.unchecked {\n                margin-left: auto;\n                background-color: transparent;\n                border:1px solid #cacacd;\n            }\n        }\n        &:first-child {\n            padding-top: 10px;\n        }\n    }\n    .select-item.active {\n        font-weight: 400;\n    }\n    .divided-section {\n        border-bottom: 1px solid #e3e3e3;\n    }\n}\n"], ["\n    > .select-container{\n        display: inline-flex;\n        flex-wrap: wrap;\n        align-items: center;\n        position: relative;\n        max-width: 250px;\n        height: 40px;\n        :focus{\n            outline: none;\n        }\n        &:hover, &:focus{\n            .active-item{\n                .active-text{\n                    color: #FF7D55;\n                }\n            }\n            svg{\n                .path-arrow-down{\n                    fill: #FF7D55;\n                    g{\n                        fill: #FF7D55;\n                    }\n                }\n            }\n        }\n\n        &.full-width{\n            display: flex;\n            max-width: unset;\n        }\n\n        &.disabled{\n            background: #f9f9f9;\n            border-color: #e6e6e6;\n            color: #969696;\n            position: relative;\n            pointer-events: none;\n\n            svg{opacity: 0.5}\n        }\n\n    }\n\n    .full-width{\n        .active-item{\n            display: flex;\n            width: 100%;\n        }\n\n        .select-dropdown{\n            width: 100%;\n        }\n    }\n\n    .title{\n        margin-bottom: 5px;\n    }\n\n    .bordered{\n        border: 1px solid #ddd;\n        border-radius: 3px;\n\n        .active-item{\n            padding: 10px 10px 10px 14px;\n        }\n\n        .select-dropdown{\n            top: 42px;\n        }\n    }\n\n    .expand{\n        .select-dropdown{\n            visibility: visible;\n            opacity: 1;\n            max-height: 350px;\n        }\n    }\n    .error{\n        border-color: #f85a5a\n    }\n\n    .multiple-select-selected-values{\n        padding: 4px 4px 2px 4px;\n        min-height: 40px;\n\n        .multiple-option-item{\n            color: #333;\n            display: inline-flex;\n            align-items: center;\n            font-size: 14px;\n            user-select: none;\n            padding: 4px 7px 4px 10px;\n            margin: 0 2px;\n            background: #FBFBFB;\n            border: 1px solid #E0E0E0;\n            cursor: pointer;\n            height: 30px;\n            transition: border-color .3s;\n            border-radius: 4px;\n\n            i{font-style: normal; margin-left: 4px; transition: color 0.3s;}\n\n            &:hover i{color: #f85a5a}\n        }\n    }\n\n    .not-show-tag {\n        .multiple-option-item{\n            color: #333;\n            display: inline-flex;\n            align-items: center;\n            font-size: 14px;\n            user-select: none;\n            padding: 4px 0 4px 0 !important;\n            margin: 0;\n            background: transparent;\n            border: none;\n            cursor: pointer;\n            height: 30px;\n\n            i{font-style: normal; margin-left: 4px; transition: color 0.3s;}\n\n            &:hover i{color: #f85a5a}\n        }\n    }\n\n    .active-item{\n        display: inline-flex;\n        cursor: pointer;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        &:focus{\n            outline: none;\n        }\n    }\n\n    .active-text{\n        font-size: 13px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-weight: 600;\n        padding-right: 6px;\n        &.text-default{\n            font-weight: normal;\n        }\n    }\n\n    .input-item{\n        position: relative;\n\n        .input{\n            display: inline-flex;\n            width: 100%;\n            padding: 10px 30px 10px 35px;\n            position: relative;\n            border: none;\n            border-radius: 3px;\n            width: 100%;\n            line-height: 1;\n            transition: border-color 0.3s;\n            background: #f2f2f2;\n            font-weight: 500;\n            &:focus{\n                outline: none;\n                border-color: none;\n            }\n        }\n\n        .icon{\n            position: absolute;\n            right: 4px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n        .filter-close{\n            display: none;\n            position: absolute;\n            top: 13px;\n            background: #999;\n            right: 10px;\n            cursor: pointer;\n            opacity: 0.5;\n            border-radius: 50px;\n            fill: #fff;\n            transition: all .3s;\n            &.active{\n                display: block;\n            }\n            &:hover{\n                opacity: 1;\n            }\n            &:focus{\n                outline: none;\n                box-shadow: 0 0 0 3px rgba(0, 185, 242, 0.4);\n            }\n        }\n    }\n\n    .icon{\n        display: inline-flex;\n        align-items: center;\n\n        svg{\n            fill: black;\n            opacity: 0.6;\n            width: 10px;\n            height: auto;\n        }\n    }\n\n    .select-dropdown{\n        position: absolute;\n        overflow: hidden;\n        z-index: 5;\n        top: 28px;\n        width: 335px;\n        visibility: hidden;\n        opacity: 0;\n        max-height: 0;\n        transition: all 0.3s;\n        border: 1px solid #ccc;\n        border-radius: 2px;\n        background-color: #FFF;\n        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1)\n    }\n    .select-dropdown-align-left{\n        left: 0;\n    }\n    .select-dropdown-align-right{\n        right: 0;\n    }\n\n    .select-search{\n        padding: 15px 15px 0 15px;\n        margin-bottom: 5px;\n        &.select-search-no-searchBox{\n            padding-top: 0;\n        }\n    }\n\n    .select-options{\n        overflow: hidden scroll;\n        max-height: 260px;\n        margin: 0 15px 10px 15px;\n        &::-webkit-scrollbar{\n            display: none;\n        }\n        &:-ms-overflow-style: none;\n        scrollbar-width: none;\n        .max-number-of-selection-message {\n            color: #FF7D55;\n            display: block;\n            width: 100%;\n            padding: 4px 0 2px 0;\n        }\n        .clear-selected-section {\n            font-size: 12px;\n            color: rgba(51,51,51, 0.7);\n            line-height: 20px;\n            text-transform: uppercase;\n            > span {\n                float: right;\n                color:#005AFF;\n                cursor: pointer;\n                font-size: 14px;\n                line-height: 16px;\n                text-transform: none;\n            }\n        }\n    }\n\n    .select-item{\n        border-top: 1px solid #e5e5e5;\n        padding: 10px 0;\n        cursor: pointer;\n        display: flex;\n        &:first-child{\n            border-top: none;\n        }\n        &:hover,\n        &.active,\n        &:focus{\n            color: #FF7D55;\n        }\n\n        &:hover,\n        &:focus{\n            background: #fbfbfb;\n            outline: none;\n        }\n\n        &.active{\n            color: #333;\n            font-weight: 500;\n            background: #fff;\n            cursor: auto;\n        }\n\n        &.read-only{\n            cursor: auto;\n\n            &:hover{\n                color: unset;\n            }\n        }\n\n        &.focusing {\n            color: #FF7D55;\n            background: #fbfbfb;\n        }\n\n        .icon{\n            svg{\n                width: 14px;\n                fill: #005aff;\n            }\n        }\n\n        .item-text{\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            margin-right: 8px;\n        }\n    }\n\n    > .title{\n        font-weight: 600;\n        text-transform: uppercase;\n    }\n}\n.show-checked {\n    > span[width] {\n        padding-right: 10px;\n        padding-left: 10px;\n        cursor: pointer;\n        height: 100%;\n    }\n    .multiple-select-selected-values {\n        height: 40px;\n        width: 86%;\n        overflow: hidden;\n        white-space: nowrap;\n        .multiple-option-item {\n            margin-bottom: 10px;\n            padding: 4px 10px;\n            &.hide {\n                display: none;\n            }\n            &:first-child {\n                margin-left: 0;\n            }\n        }\n        @media screen and (min-width: 768px) and (max-width: 1023px) {\t\n            width: 80%;\n        }\n        @media screen and (min-width: 1024px) and (max-width: 1160px) {\t\n            width: 84%;\n        }\n    }\n    .active-item {\n        width: 86%;\n    }\n    .select-item {\n        border-top: none;\n        cursor: pointer;\n        &:hover {\n            background-color: #fbfbfb;\n        }\n        > span {\n            width: 18px;\n            height: 18px;\n            background-color:#fff;\n            border: 1px solid #005AFF;\n            border-radius: 4px;\n            min-width: 18px;\n            padding-left: 1px;\n            &.unchecked {\n                margin-left: auto;\n                background-color: transparent;\n                border:1px solid #cacacd;\n            }\n        }\n        &:first-child {\n            padding-top: 10px;\n        }\n    }\n    .select-item.active {\n        font-weight: 400;\n    }\n    .divided-section {\n        border-bottom: 1px solid #e3e3e3;\n    }\n}\n"])));
var StyledIcon = styled_components_browser_esm/* default.span */.ZP.span(styled_templateObject_2 || (styled_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n\n    > svg {\n        fill: ", ";\n        width: ", "px;\n        height: auto;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n\n    > svg {\n        fill: ", ";\n        width: ", "px;\n        height: auto;\n    }\n"])), function (props) { return (props.primary ? '#005AFF' : '#717171'); }, function (props) { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : 10; });
var RightAlignedIcon = (0,styled_components_browser_esm/* default */.ZP)(StyledIcon)(styled_templateObject_3 || (styled_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: auto;\n"], ["\n    margin-left: auto;\n"])));
(0,styled_components_browser_esm/* default */.ZP)(StyledIcon)(styled_templateObject_4 || (styled_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n"], ["\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n"])));
var LeftAlignedAbsIcon = (0,styled_components_browser_esm/* default */.ZP)(StyledIcon)(styled_templateObject_5 || (styled_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 1;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n"], ["\n    position: absolute;\n    z-index: 1;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n"])));
var styled_templateObject_1, styled_templateObject_2, styled_templateObject_3, styled_templateObject_4, styled_templateObject_5;


//# sourceMappingURL=styled.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/constants.js
var SearchBarUnstable_constants = __webpack_require__(37148);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Select/index.js
'use client';










var DEFAULT_ID = -1;
var DEFAULT_LIMIT_SHOW_RESULT = 4;
var DEFAULT_LIMIT_CHARACTER = 26;
function Select(props) {
    /**
     * Data for rendering
     */
    var dropdownWidth = props.dropdownWidth, presetOptions = props.options, _a = props.initValue, initValue = _a === void 0 ? -1 : _a, allOptionText = props.allOptionText, _b = props.searchNotFound, searchNotFound = _b === void 0 ? 'No Result' : _b, onSelected = props.onSelected, title = props.title, _c = props.bordered, bordered = _c === void 0 ? false : _c, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.fullDropdownWidth, fullDropdownWidth = _e === void 0 ? false : _e, _f = props.hasSearchBox, hasSearchBox = _f === void 0 ? true : _f, _g = props.alignDropdown, alignDropdown = _g === void 0 ? 'left' : _g, hasError = props.hasError, _h = props.disabled, disabled = _h === void 0 ? false : _h, mode = props.mode, maxNumberOfSelectionMessage = props.maxNumberOfSelectionMessage, maxNumberOfSelection = props.maxNumberOfSelection, onFocus = props.onFocus, onBlur = props.onBlur, label = props.label, isRequired = props.isRequired, _j = props.isShowChecked, isShowChecked = _j === void 0 ? false : _j, _k = props.showCheckedMaxShowCount, showCheckedMaxShowCount = _k === void 0 ? DEFAULT_LIMIT_SHOW_RESULT : _k, _l = props.isDisplayCount, isDisplayCount = _l === void 0 ? false : _l, _m = props.limitCharacterShow, limitCharacterShow = _m === void 0 ? DEFAULT_LIMIT_CHARACTER : _m, _o = props.isShowAlertInside, isShowAlertInside = _o === void 0 ? false : _o, _p = props.isShowTag, isShowTag = _p === void 0 ? true : _p, _q = props.showTagMinusLength, showTagMinusLength = _q === void 0 ? 6 : _q, onKeyDown = props.onKeyDown, onExpandToggle = props.onExpandToggle;
    /**
     * Data for rendering
     */
    var _r = (0,react.useState)(false), expand = _r[0], setExpand = _r[1];
    var _s = (0,react.useState)(''), query = _s[0], setQuery = _s[1];
    var isMultiple = mode === 'multiple'; // TODO: will do the tag mode later
    var initialSingleValue = isMultiple ? -1 : initValue;
    // Process initial value to make sure it works for the multiple case
    var initialMultipleValue = (function () {
        if (isMultiple) {
            if (Array.isArray(initValue)) {
                return initValue;
            }
            // Convert the single value into an array
            return [initValue];
        }
        return [];
    })();
    var _t = (0,react.useState)(initialSingleValue), value = _t[0], setValue = _t[1];
    var _u = (0,react.useState)(initialMultipleValue), multipleValue = _u[0], setMultipleValue = _u[1];
    var _v = (0,react.useState)(false), isValueChanged = _v[0], setIsValueChanged = _v[1];
    var hasReachedMaxSelection = maxNumberOfSelection && multipleValue.length >= maxNumberOfSelection;
    // Focus event option list
    var _w = (0,react.useState)(-1), selectedIndex = _w[0], setSelectedIndex = _w[1];
    var selectedOptionItemRef = (0,react.useRef)(null);
    // END Focus event option list
    var inputRef = (0,react.useRef)(null);
    var selectContainerRef = (0,react.useRef)(null);
    var optionContainerRef = (0,react.useRef)(null);
    var options = (0,react.useMemo)(function () {
        if (allOptionText && !isShowChecked) {
            return (0,_tslib/* __spreadArray */.ev)([
                {
                    id: DEFAULT_ID,
                    name: allOptionText
                }
            ], presetOptions, true);
        }
        return (0,_tslib/* __spreadArray */.ev)([], presetOptions, true);
    }, [presetOptions]);
    var normalizedSearchableOptions = (0,react.useMemo)(function () {
        return options.map(function (option) {
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, option), { searchableName: (0,helpers/* transformToLatin */.nr)(option.name.toLowerCase()).replace(/[^\w\s]/gi, ' ') });
        });
    }, [options]);
    // let focusOptionIndex = -1
    // const totalOptions = options.length
    var expandClass = expand ? 'expand' : '';
    var borderClass = bordered ? 'bordered' : '';
    var disabledClass = disabled ? 'disabled' : '';
    var fullWidthClass = fullWidth ? 'full-width' : '';
    var hasErrorClass = hasError ? 'error' : '';
    var isShowItem = false;
    var isFocusOnSelect = false;
    if (isMultiple && isValueChanged) {
        expandClass = 'expand';
    }
    var handleUpdateSelection = function (id, isKeyUp) {
        var _a;
        if (isKeyUp === void 0) { isKeyUp = false; }
        // some cases ID is not really a number
        var parsedId = (0,helpers/* filterInt */.fJ)(id);
        var canSetValue = true;
        if (isShowChecked && hasReachedMaxSelection) {
            // TODO: scroll to alert message
            (_a = optionContainerRef.current) === null || _a === void 0 ? void 0 : _a.scroll(0, 0);
            canSetValue = false;
        }
        // Update the internal state for rendering
        if (isMultiple) {
            if (canSetValue) {
                setMultipleValue((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], multipleValue, true), [parsedId], false));
                setIsValueChanged(true);
            }
        }
        else {
            if (isNaN(parsedId)) {
                setValue(id);
            }
            else {
                setValue(parsedId);
            }
        }
        // Output this value
        if (onSelected) {
            if (isMultiple) {
                if (canSetValue) {
                    onSelected((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], multipleValue, true), [parsedId], false));
                }
            }
            else {
                onSelected(id, isKeyUp);
            }
        }
        if (isShowChecked) {
            // This prevent Select div lost focus and can't close
            setTimeout(function () {
                var _a;
                (_a = selectContainerRef === null || selectContainerRef === void 0 ? void 0 : selectContainerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 50);
        }
    };
    /**
     * un-select option by click it again
     * @param id id of option
     * @param isKeyUp is key up = false
     */
    var handleUncheckedSelection = function (id, isKeyUp) {
        var parsedId = (0,helpers/* filterInt */.fJ)(id);
        // Update the internal state for rendering
        // This function is only work when isShowChecked. Because when isShowChecked = true it will have this function bind
        if (isMultiple && isShowChecked) {
            var filteredMultipleValue = multipleValue.filter(function (item) { return item !== parsedId; });
            setMultipleValue(filteredMultipleValue);
            setIsValueChanged(true);
            onSelected && onSelected(filteredMultipleValue);
            // This prevent Select div lost focus and can't close
            setTimeout(function () {
                var _a;
                (_a = selectContainerRef === null || selectContainerRef === void 0 ? void 0 : selectContainerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 50);
        }
    };
    // Clicking out side would close the dropdown
    var isClickOutside = function (event, ref) {
        if (ref.current) {
            if (ref.current.contains(event.target))
                return false;
        }
        return true;
    };
    var handleClickOnScreen = function (e) {
        if (isClickOutside(e, selectContainerRef) && expand) {
            setExpand(false);
        }
        // why have this condition:
        // in multiple select mode, expand will return false right after first click.
        // So checking expand is no longer correct
        if (isClickOutside(e, selectContainerRef) && isShowChecked) {
            isFocusOnSelect = false;
            // handle close
            setExpand(false);
            // reset change to hide expand section
            setIsValueChanged(false);
        }
    };
    // ESC would blur the current active element
    var handleClickEsc = function (e) {
        if (e.keyCode === 27) {
            setExpand(false);
            // reset change to hide expand section
            setIsValueChanged(false);
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    };
    (0,react.useEffect)(function () {
        document.addEventListener('keydown', handleClickEsc);
        return function () {
            document.removeEventListener('keydown', handleClickEsc);
        };
    }, []);
    // Show/hide the dropdown when users click on the select
    (0,react.useEffect)(function () {
        if (expand) {
            setTimeout(function () {
                var _a;
                (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                isShowItem = true;
            }, 200);
            onExpandToggle && onExpandToggle(expand);
        }
        else {
            isShowItem = false;
            if (query !== '') {
                setQuery('');
            }
        }
        document.addEventListener('mousedown', handleClickOnScreen);
        return function () {
            document.removeEventListener('mousedown', handleClickOnScreen);
        };
    }, [expand]);
    // Everytime the select values change, we close the dropdown
    (0,react.useEffect)(function () {
        if (expand) {
            setExpand(false);
        }
    }, [value, JSON.stringify(multipleValue)]);
    // If the values from the props change, we force update it to the internal state
    (0,react.useEffect)(function () {
        if (isMultiple) {
            setMultipleValue(initValue);
        }
        else {
            setValue(initValue);
        }
    }, [initValue]);
    var selectedOption = options.find(function (item) { return item.id === value; });
    var selectedLabel = selectedOption ? selectedOption.name : allOptionText;
    var allOptions = normalizedSearchableOptions.filter(function (option) {
        var normalizedQuery = (0,helpers/* transformToLatin */.nr)(query.toLowerCase());
        var isContain = true;
        if (query !== '') {
            isContain = option.searchableName.indexOf(normalizedQuery) > -1;
            if (!isContain) {
                // Check for name
                var optionName = (0,helpers/* transformToLatin */.nr)(option.name.toLowerCase());
                isContain = optionName.indexOf(normalizedQuery) > -1;
            }
        }
        return isContain;
    });
    var filteredOptions = allOptions;
    var filteredSelectedOptions = allOptions;
    if (isMultiple) {
        filteredOptions = filteredOptions.filter(function (item) { return !multipleValue.includes(item.id); });
    }
    if (isShowChecked) {
        var sortedList_1 = [];
        multipleValue.map(function (itemId) {
            var filteredValue = allOptions.filter(function (item) { return item.id === itemId; });
            if (filteredValue.length > 0) {
                sortedList_1.push(filteredValue[0]);
            }
        });
        filteredSelectedOptions = sortedList_1;
    }
    var getOptionNameInfo = function (options, id, index) {
        var _a, _b, _c, _d;
        var optionInfo = {
            name: ((_a = options.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.name) || '',
            isShow: true
        };
        var concatStrValue = '';
        var countValueIndex = -1;
        var isHavePlus = false;
        // Only get those option that index smaller than showCheckedMaxShowCount (default: 4)
        // concat all text in those option to get final text display
        var valueListFiltered = multipleValue.filter(function (_, valueIndex) { return valueIndex < showCheckedMaxShowCount; });
        valueListFiltered.map(function (valueItem, _) {
            var optionValueListFiltered = options.filter(function (item) { return item.id === valueItem; });
            if (optionValueListFiltered.length > 0) {
                concatStrValue += optionValueListFiltered[0].name;
                countValueIndex += 1;
            }
        });
        // Check if
        // - text length is large than limit and
        // - index is larger than count and
        // - index is not 0 (not first item)
        // Then make option name as '+1' or '...'
        if (concatStrValue.length > limitCharacterShow && index >= countValueIndex && index > 0) {
            optionInfo.name = isDisplayCount ? "+".concat(multipleValue.length - countValueIndex) : '...';
            if (isDisplayCount) {
                isHavePlus = true;
            }
            if (!isShowTag) {
                optionInfo.name = ', ' + optionInfo.name;
            }
        }
        // Check if
        // index is 0 and
        //  text length is larger than limit
        if (index === 0 && optionInfo.name !== undefined && ((_b = optionInfo.name) === null || _b === void 0 ? void 0 : _b.length) > limitCharacterShow) {
            var limitCharacter = limitCharacterShow;
            if (multipleValue.length > 1) {
                limitCharacter = limitCharacterShow - showTagMinusLength;
            }
            optionInfo.name = ((_c = optionInfo.name) === null || _c === void 0 ? void 0 : _c.substring(0, limitCharacter)) + '...';
        }
        if (concatStrValue.length > limitCharacterShow && index > countValueIndex) {
            optionInfo.isShow = false;
            // allow last option item '(+ number)' to display
            if (optionInfo !== undefined &&
                (optionInfo === null || optionInfo === void 0 ? void 0 : optionInfo.name) !== undefined &&
                ((_d = optionInfo === null || optionInfo === void 0 ? void 0 : optionInfo.name) === null || _d === void 0 ? void 0 : _d.indexOf('+')) > -1 &&
                !isHavePlus) {
                optionInfo.isShow = true;
            }
        }
        return optionInfo;
    };
    var removeOneMultipleOption = function (id) {
        var newValues = multipleValue.filter(function (item) { return item !== id; });
        setMultipleValue(newValues);
        setIsValueChanged(true);
        // Output the new values
        if (onSelected) {
            onSelected(newValues);
        }
    };
    var handleOnClickArrowDown = function () {
        var isShow = false;
        if (isShowItem) {
            isShow = false;
        }
        else if (!isShowItem && !isFocusOnSelect) {
            isShow = true;
        }
        if (!isShow) {
            // This is trick to force Select hide
            setIsValueChanged(false);
            setTimeout(function () {
                var _a;
                setExpand(isShow);
                (_a = selectContainerRef === null || selectContainerRef === void 0 ? void 0 : selectContainerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                onExpandToggle && onExpandToggle(false);
            }, 50);
        }
    };
    /**
     * Handlers
     */
    // Navigate the dropdown list by pressing up/down
    var handleInputKeydown = function (e) {
        var _a, _b;
        onKeyDown && onKeyDown(e.key);
        // select option by arrow key
        var defaultMaxItemCount = allOptions.length;
        var maxIndex = defaultMaxItemCount - 1;
        if (e.key === SearchBarUnstable_constants/* keyCode.ArrowUp */.rw.ArrowUp) {
            e.preventDefault();
            (_a = selectContainerRef === null || selectContainerRef === void 0 ? void 0 : selectContainerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            // move up 1 select index
            var nextIndex = selectedIndex - 1;
            if (nextIndex < 0) {
                // is over current then reset to 0
                nextIndex = maxIndex;
            }
            setSelectedIndex(nextIndex);
        }
        else if (e.key === SearchBarUnstable_constants/* keyCode.ArrowDown */.rw.ArrowDown) {
            e.preventDefault();
            (_b = selectContainerRef === null || selectContainerRef === void 0 ? void 0 : selectContainerRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            // move down
            var nextIndex = selectedIndex + 1;
            if (nextIndex > maxIndex) {
                // is over current then reset to 0
                nextIndex = 0;
            }
            setSelectedIndex(nextIndex);
        }
        else if (e.key === SearchBarUnstable_constants/* keyCode.Tab */.rw.Tab) {
            if (expand) {
                setExpand(false);
                // reset change to hide expand section
                setIsValueChanged(false);
            }
        }
        else if (e.key === SearchBarUnstable_constants/* keyCode.Enter */.rw.Enter) {
            e.preventDefault();
            // Check item is selected or not
            if (selectedIndex >= filteredSelectedOptions.length) {
                // use un-select list
                var fixedIndex = selectedIndex - filteredSelectedOptions.length;
                if (hasReachedMaxSelection) {
                    return;
                }
                handleUpdateSelection(filteredOptions[fixedIndex].id);
            }
            else {
                handleUncheckedSelection(filteredSelectedOptions[selectedIndex].id);
            }
        }
    };
    (0,react.useEffect)(function () {
        if (selectedOptionItemRef !== null &&
            (selectedOptionItemRef === null || selectedOptionItemRef === void 0 ? void 0 : selectedOptionItemRef.current) !== undefined &&
            (selectedOptionItemRef === null || selectedOptionItemRef === void 0 ? void 0 : selectedOptionItemRef.current) !== null) {
            selectedOptionItemRef.current.focus();
            if (inputRef !== null && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) !== null) {
                inputRef.current.focus();
            }
        }
    }, [selectedIndex, selectedOptionItemRef]);
    /* Render */
    // Render multiple values
    var renderMultipleValues = function () {
        if (multipleValue.length === 0) {
            return (react.createElement(react.Fragment, null,
                react.createElement("div", { className: 'active-item', onClick: function () {
                        if (isShowChecked && expand) {
                            handleOnClickArrowDown();
                        }
                    } },
                    react.createElement("span", { className: "active-text ".concat(!selectedOption || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) === DEFAULT_ID ? 'text-default' : '') }, selectedLabel)),
                isShowChecked ? (react.createElement(RightAlignedIcon, { onClick: handleOnClickArrowDown, width: 11 },
                    react.createElement(icons/* IconChevronDown */.C2, null))) : (react.createElement(react.Fragment, null))));
        }
        var optionNodes = multipleValue.map(function (id, index) {
            var _a;
            var optionName = ((_a = options.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.name) || '';
            var isShowOption = true;
            if (isShowChecked) {
                var optionInfo = getOptionNameInfo(options, id, index);
                optionName = optionInfo.name || '';
                isShowOption = optionInfo.isShow || false;
            }
            if (isShowChecked && index === showCheckedMaxShowCount) {
                optionName = isDisplayCount ? "+".concat(multipleValue.length - showCheckedMaxShowCount) : '...';
            }
            if (isShowChecked && index > showCheckedMaxShowCount) {
                isShowOption = false;
            }
            return (react.createElement("span", { className: "multiple-option-item ".concat(isShowOption ? '' : 'hide'), key: "option-item-".concat(id) },
                optionName,
                ' ',
                !isShowChecked ? (react.createElement("i", { onClick: function (event) {
                        event.stopPropagation();
                        // Blur, so that it would be able to focus again.
                        // WHY: We're only showing the dropdown when the input focuses.
                        // When users click on the delete button, it already focuses, therefore it will never focus
                        // again if we don't blur it
                        if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                        }
                        removeOneMultipleOption(id);
                    } }, "\u00D7")) : (react.createElement(react.Fragment, null))));
        });
        return (react.createElement(react.Fragment, null,
            react.createElement("div", { className: 'multiple-select-selected-values', onClick: function () {
                    if (isShowChecked && expand) {
                        handleOnClickArrowDown();
                    }
                } }, optionNodes),
            react.createElement(RightAlignedIcon, { onClick: handleOnClickArrowDown, width: 11 },
                react.createElement(icons/* IconChevronDown */.C2, null))));
    };
    // Render the select
    return (react.createElement(StyledSelect, null,
        title && react.createElement("div", { className: 'title' }, title),
        label ? (react.createElement("div", { className: input_module_css_s.labelWrapper },
            isRequired ? react.createElement("span", { className: 'text-danger' }, "*") : null,
            " ",
            react.createElement("label", null, label))) : null,
        react.createElement("div", { className: "select-container ".concat(expandClass, " ").concat(borderClass, " ").concat(disabledClass, " ").concat(fullWidthClass, " ").concat(hasErrorClass, " ").concat(isShowChecked ? 'show-checked' : '', " ").concat(isShowTag ? '' : 'not-show-tag'), tabIndex: 0, onFocus: function (event) {
                if (isShowChecked) {
                    isFocusOnSelect = true;
                    setExpand(true);
                }
                else {
                    if (!hasReachedMaxSelection && !expand) {
                        setExpand(true);
                    }
                }
                onFocus && onFocus(event);
            }, onBlur: function (event) {
                if (isShowChecked) {
                    isFocusOnSelect = false;
                }
                onBlur && onBlur(event);
            }, onKeyDown: handleInputKeydown, ref: selectContainerRef },
            isMultiple ? (renderMultipleValues()) : (react.createElement("div", { className: 'active-item', onMouseDown: function (e) {
                    e.preventDefault();
                    setExpand(!expand);
                } },
                react.createElement("span", { className: "active-text ".concat(!selectedOption || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) === DEFAULT_ID ? 'text-default' : '') }, selectedLabel),
                react.createElement(RightAlignedIcon, { width: 11 },
                    react.createElement(icons/* IconChevronDown */.C2, null)))),
            react.createElement("div", { className: "select-dropdown select-dropdown-align-".concat(alignDropdown), style: {
                    width: fullDropdownWidth ? '100%' : dropdownWidth || '335px'
                } },
                react.createElement("div", { className: "select-search ".concat(!hasSearchBox ? 'select-search-no-searchBox' : '') }, hasSearchBox ? (react.createElement("div", { className: 'input-item' },
                    react.createElement(LeftAlignedAbsIcon, { width: 16 },
                        react.createElement(icons/* IconSearch */.jV, null)),
                    react.createElement("input", { type: 'text', className: 'input', ref: inputRef, value: query, onChange: function (e) { return setQuery(e.target.value); } }),
                    react.createElement("svg", { width: 14, height: 14, className: "filter-close ".concat(query ? 'active' : ''), viewBox: '0 0 50 50', onClick: function () { return setQuery(''); } },
                        react.createElement("path", { d: 'M 14.40625 13 L 13 14.40625 L 23.625 25 L 13 35.59375 L 14.40625 37 L 25.0625 26.40625 L 35.6875 37 L 37.09375 35.59375 L 26.46875 25 L 37.09375 14.40625 L 35.6875 13 L 25.0625 23.59375 Z' })))) : (
                // This div is not necessary in UI but a tricky way to trigger handleUpDownKey when tabbing in case of No Search Box (hasSearchBox = false)
                react.createElement("div", { ref: inputRef, tabIndex: 0 }))),
                react.createElement("div", { className: 'select-options', ref: optionContainerRef, tabIndex: -1 },
                    isShowChecked ? (filteredSelectedOptions.map(function (item, index) {
                        var isSelectedByArrow = selectedIndex === index;
                        return (react.createElement("div", { key: item.id, className: "select-item ".concat('active' , " ").concat(isSelectedByArrow ? 'focusing' : ''), title: item.name, onClick: function (e) {
                                handleUncheckedSelection(item.id);
                            }, tabIndex: -1, "data-option-id": item.id, ref: isSelectedByArrow ? selectedOptionItemRef : null },
                            item.svgImg || react.createElement("div", { className: 'item-text' }, item.name),
                            (react.createElement(RightAlignedIcon, { width: 14, primary: true },
                                react.createElement(icons_IconCheck_IconCheck, null)))));
                    })) : (react.createElement(react.Fragment, null)),
                    isShowChecked && filteredSelectedOptions.length > 0 ? (react.createElement("div", { className: 'divided-section' })) : (react.createElement(react.Fragment, null)),
                    isShowAlertInside && maxNumberOfSelectionMessage && hasReachedMaxSelection && (react.createElement("span", { className: 'max-number-of-selection-message small mt-1' }, maxNumberOfSelectionMessage)),
                    isShowChecked
                        ? filteredOptions.map(function (item, index) {
                            var isSelectedByArrow = selectedIndex === filteredSelectedOptions.length + index;
                            return (react.createElement("div", { key: item.id, className: "select-item ".concat(isSelectedByArrow ? 'focusing' : ''), title: item.name, onClick: function () {
                                    handleUpdateSelection(item.id);
                                }, tabIndex: -1, "data-option-id": item.id, ref: isSelectedByArrow ? selectedOptionItemRef : null },
                                item.svgImg || react.createElement("div", { className: 'item-text' }, item.name),
                                react.createElement("span", { className: 'unchecked' })));
                        })
                        : filteredOptions.map(function (_a) {
                            var id = _a.id, name = _a.name, svgImg = _a.svgImg;
                            var isSelected = id === value;
                            return (react.createElement("div", { key: id, className: "select-item ".concat(isSelected ? 'active' : ''), title: name, onClick: function (e) {
                                    if (isSelected) {
                                        e.preventDefault();
                                        return;
                                    }
                                    handleUpdateSelection(id);
                                }, tabIndex: -1, "data-option-id": id },
                                svgImg || react.createElement("div", { className: 'item-text' }, name),
                                isSelected && (react.createElement(RightAlignedIcon, { width: 14, primary: true },
                                    react.createElement(icons_IconCheck_IconCheck, null)))));
                        }),
                    filteredOptions.length === 0 && react.createElement("div", { className: 'select-item read-only' }, searchNotFound)))),
        !isShowAlertInside && maxNumberOfSelectionMessage && hasReachedMaxSelection && (react.createElement("span", { className: 'max-number-of-selection-message small text-muted mt-1' }, maxNumberOfSelectionMessage))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SelectedTag/SelectedTag.module.css.js
'use client';

var S = {"NormalStatus":"SelectedTag-module_NormalStatus__3nN0K","wrapIcon":"SelectedTag-module_wrapIcon__3TBpH","NormalStatusHover":"SelectedTag-module_NormalStatusHover__1qi18","ReviewingStatus":"SelectedTag-module_ReviewingStatus__2_fAr","ReviewingStatusHover":"SelectedTag-module_ReviewingStatusHover__2jCT9","DeletedTag":"SelectedTag-module_DeletedTag__1BE_7"};


//# sourceMappingURL=SelectedTag.module.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SelectedTag/index.js
'use client';





/* eslint-disable no-unused-expressions */
var SelectedTag = function (props) {
    var _a = props.tagName, tagName = _a === void 0 ? '' : _a, _b = props.isSelecting, isSelecting = _b === void 0 ? false : _b, _c = props.hasApproved, hasApproved = _c === void 0 ? true : _c, _d = props.readOnly, readOnly = _d === void 0 ? false : _d, _e = props.type, type = _e === void 0 ? 'default' : _e, _f = props.onClick, onClick = _f === void 0 ? function () { } : _f, _g = props.onDelete, onDelete = _g === void 0 ? function () { } : _g;
    var _h = (0,react.useState)(false), isHovered = _h[0], setIsHovered = _h[1];
    var deleteIconRef = (0,react.useRef)(null);
    // normal status
    var styleSelected = "".concat(S.NormalStatus);
    // normal status with hover or is selecting
    if ((hasApproved && isHovered && !readOnly) || (hasApproved && isSelecting)) {
        styleSelected = "".concat(styleSelected, " ").concat(S.NormalStatusHover);
    }
    // reviewing status
    if (!hasApproved && !readOnly) {
        styleSelected = "".concat(styleSelected, " ").concat(S.ReviewingStatus);
    }
    // reviewing status with hover or is selecting
    if ((!hasApproved && isHovered && !readOnly) || (!hasApproved && isSelecting)) {
        styleSelected = "".concat(styleSelected, " ").concat(S.ReviewingStatusHover);
    }
    // ReadOnly status
    if (readOnly) {
        styleSelected = "".concat(styleSelected, " ").concat(S.DeletedTag);
    }
    var styledCheckIcon = isSelecting ? '#fff' : '#888';
    if (!hasApproved && !readOnly && !isSelecting) {
        styledCheckIcon = '#FF7D55';
    }
    var handleClickOnTag = function (e) {
        if (deleteIconRef.current) {
            if (deleteIconRef.current.contains(e.target)) {
                e.stopPropagation();
                onDelete(tagName);
                return;
            }
        }
        onClick();
    };
    var isMobile = !!(typeof window !== 'undefined' && window.innerWidth < 992);
    return (react.createElement("div", { className: styleSelected, onClick: function (e) {
            if (!readOnly) {
                handleClickOnTag(e);
            }
        }, onMouseEnter: function () { return (!isMobile ? setIsHovered(true) : undefined); }, onMouseLeave: function () { return (!isMobile ? setIsHovered(false) : undefined); } },
        react.createElement("div", null, tagName),
        react.createElement("div", { ref: deleteIconRef, className: S.wrapIcon }, (isHovered && !isMobile && !readOnly && type !== 'add') || // desktop
            (isMobile && isSelecting && !readOnly && type !== 'add') ? ( // mobile
        react.createElement(icons/* IconDeleteWhite */.k$, { stroke: '#fff', width: 22, height: 22, className: S.IconDelete, onClick: handleClickOnTag })) : type !== 'add' ? (react.createElement(icons/* IconCheck */.NO, { stroke: styledCheckIcon, width: 22, height: 22 })) : null),
        type === 'add' ? react.createElement(icons/* IconAdd */.N_, { fill: isHovered ? '#fff' : '#777' }) : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tooltip/index.js
'use client';





var StyledToolTip = styled_components_browser_esm/* default.div */.ZP.div(Tooltip_templateObject_1 || (Tooltip_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    padding: ", ";\n    background: ", ";\n    width: ", ";\n    max-width: ", ";\n    border-radius: ", ";\n    position: absolute;\n    z-index: 1;\n    box-shadow: ", ";\n    text-align: ", ";\n    min-width: ", ";\n\n    &.tooltip-left {\n        transform: translateX(-100%) translateY(-50%);\n        top: 50%;\n        left: -15px;\n\n        > .arrow-right {\n            position: absolute;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-top: 8px solid transparent;\n            border-bottom: 8px solid transparent;\n            border-left: 8px solid white;\n            -webkit-filter: drop-shadow(3px 0 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(3px 0 4px rgba(0, 0, 0, 0.1));\n            top: 50%;\n            right: -8px;\n            transform: translateY(-50%);\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: -4px;\n                top: -6.5px;\n                transform: translateX(-50%);\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-top: 6.5px solid transparent;\n                border-bottom: 6.5px solid transparent;\n                border-left: 6.5px solid white;\n            }\n        }\n    }\n\n    &.tooltip-bottom {\n        top: 100%;\n        margin-top: ", ";\n        left: 50%;\n        transform: translateX(", ");\n\n        > .arrow-up {\n            position: absolute;\n            left: ", ";\n            transform: translateX(-50%);\n            top: -8px;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-left: 8px solid transparent;\n            border-right: 8px solid transparent;\n            border-bottom: 8px solid ", ";\n            -webkit-filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: 50%;\n                transform: translateX(-50%);\n                top: 1.5px;\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-left: 6.5px solid transparent;\n                border-right: 6.5px solid transparent;\n                border-bottom: 6.5px solid ", ";\n            }\n        }\n    }\n\n    &.tooltip-customSort{\n        top: 100%;\n        margin-top: ", ";\n        right: 8px;\n        > .arrow-up {\n            position: absolute;\n            left: ", ";\n            transform: translateX(-50%);\n            top: -8px;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-left: 8px solid transparent;\n            border-right: 8px solid transparent;\n            border-bottom: 8px solid ", ";\n            -webkit-filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: 50%;\n                transform: translateX(-50%);\n                top: 1.5px;\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-left: 6.5px solid transparent;\n                border-right: 6.5px solid transparent;\n                border-bottom: 6.5px solid ", ";\n            }\n        }\n    }\n\n    > .title {\n        font-weight: bold;\n        margin-bottom: 4px;\n        font-size: 14px;\n    }\n\n    > .description {\n        font-size: 13px;\n    }\n"], ["\n    display: inline-block;\n    padding: ", ";\n    background: ", ";\n    width: ", ";\n    max-width: ", ";\n    border-radius: ", ";\n    position: absolute;\n    z-index: 1;\n    box-shadow: ", ";\n    text-align: ", ";\n    min-width: ", ";\n\n    &.tooltip-left {\n        transform: translateX(-100%) translateY(-50%);\n        top: 50%;\n        left: -15px;\n\n        > .arrow-right {\n            position: absolute;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-top: 8px solid transparent;\n            border-bottom: 8px solid transparent;\n            border-left: 8px solid white;\n            -webkit-filter: drop-shadow(3px 0 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(3px 0 4px rgba(0, 0, 0, 0.1));\n            top: 50%;\n            right: -8px;\n            transform: translateY(-50%);\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: -4px;\n                top: -6.5px;\n                transform: translateX(-50%);\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-top: 6.5px solid transparent;\n                border-bottom: 6.5px solid transparent;\n                border-left: 6.5px solid white;\n            }\n        }\n    }\n\n    &.tooltip-bottom {\n        top: 100%;\n        margin-top: ", ";\n        left: 50%;\n        transform: translateX(", ");\n\n        > .arrow-up {\n            position: absolute;\n            left: ", ";\n            transform: translateX(-50%);\n            top: -8px;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-left: 8px solid transparent;\n            border-right: 8px solid transparent;\n            border-bottom: 8px solid ", ";\n            -webkit-filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: 50%;\n                transform: translateX(-50%);\n                top: 1.5px;\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-left: 6.5px solid transparent;\n                border-right: 6.5px solid transparent;\n                border-bottom: 6.5px solid ", ";\n            }\n        }\n    }\n\n    &.tooltip-customSort{\n        top: 100%;\n        margin-top: ", ";\n        right: 8px;\n        > .arrow-up {\n            position: absolute;\n            left: ", ";\n            transform: translateX(-50%);\n            top: -8px;\n            z-index: 5;\n            width: 0;\n            height: 0;\n            border-left: 8px solid transparent;\n            border-right: 8px solid transparent;\n            border-bottom: 8px solid ", ";\n            -webkit-filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n            filter: drop-shadow(0 -3px 4px rgba(0, 0, 0, 0.1));\n\n            &:after {\n                content: '';\n                position: absolute;\n                left: 50%;\n                transform: translateX(-50%);\n                top: 1.5px;\n                z-index: 5;\n                width: 0;\n                height: 0;\n                border-left: 6.5px solid transparent;\n                border-right: 6.5px solid transparent;\n                border-bottom: 6.5px solid ", ";\n            }\n        }\n    }\n\n    > .title {\n        font-weight: bold;\n        margin-bottom: 4px;\n        font-size: 14px;\n    }\n\n    > .description {\n        font-size: 13px;\n    }\n"])), function (props) { return (props.padding ? props.padding : '16px'); }, function (props) { return (props.bgColor ? props.bgColor : '#ffffff'); }, function (props) { return (props.width ? props.width : 'auto'); }, function (props) { return (props.maxWidth ? "".concat(props.maxWidth, "px") : 'initial'); }, function (props) { return (props.borderRadius ? "".concat(props.borderRadius) : 'initial'); }, function (props) { return (props.boxShadow ? "".concat(props.boxShadow) : '0 3px 10px 0 rgba(0, 0, 0, 0.1)'); }, function (props) { return (props.textAlign ? props.textAlign : 'left'); }, function (props) { return (props.minWidth ? "".concat(props.minWidth, "px") : 'initial'); }, function (props) { return (props.marginTop ? props.marginTop : '16px'); }, function (props) { return (props.transform ? props.transform : '-50%'); }, function (props) { return (props.arrowPosition ? props.arrowPosition : '50%'); }, function (props) { return (props.bgColor ? props.bgColor : '#ffffff'); }, function (props) { return (props.bgColor ? props.bgColor : '#ffffff'); }, function (props) { return (props.marginTop ? props.marginTop : '16px'); }, function (props) { return (props.arrowPosition ? props.arrowPosition : '50%'); }, function (props) { return (props.bgColor ? props.bgColor : '#ffffff'); }, function (props) { return (props.bgColor ? props.bgColor : '#ffffff'); });
function Tooltip(props) {
    var isShow = props.isShow, title = props.title, description = props.description, customStyle = props.customStyle, _a = props.placement, placement = _a === void 0 ? 'bottom' : _a, _b = props.classNameElement, classNameElement = _b === void 0 ? '' : _b;
    var isBottom = placement === 'bottom';
    var isLeft = placement === 'left';
    var isCustomSort = placement === 'customSort';
    var className = 'animated fadeIn ';
    switch (placement) {
        case 'left':
            className = className + 'tooltip-left';
            break;
        case 'bottom':
            className = className + 'tooltip-bottom';
            break;
        case 'customSort':
            className = className + 'tooltip-customSort';
            break;
    }
    className = "".concat(className, " ").concat(classNameElement);
    return (react.createElement(StyledToolTip, (0,_tslib/* __assign */.pi)({ className: className, style: { display: isShow ? 'block' : 'none' } }, customStyle),
        (isBottom || isCustomSort) && react.createElement("span", { className: 'arrow-up' }),
        isLeft && react.createElement("span", { className: 'arrow-right' }),
        title ? react.createElement("div", { className: 'title' }, title) : null,
        react.createElement("div", { className: 'description' }, description)));
}
var Tooltip_templateObject_1;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/facebook-color.svg.js
'use client';

var facebookColorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FSALARY-BYEXPERIENCE-TOOPTIP%22%20transform%3D%22translate%28-690.000000%2C%20-1651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22JobDetail%2FShare-Social%22%20transform%3D%22translate%28650.000000%2C%201651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Fb%22%20transform%3D%22translate%2840.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-facebook-f-%282%29%22%20transform%3D%22translate%288.800000%2C%206.400000%29%22%20fill%3D%22%23495AA0%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.61533779%2C2.15217391%20L5.76917224%2C2.15217391%20C5.89655557%2C2.15217391%205.99993913%2C2.04504348%205.99993913%2C1.91304348%20L5.99993913%2C0.302021739%20C5.99993913%2C0.176717391%205.90694008%2C0.0724565217%205.78647976%2C0.0636086957%20C5.41932964%2C0.0365869565%204.70210615%2C0%204.18634215%2C0%20C2.76920268%2C0%201.84613512%2C0.88%201.84613512%2C2.47930435%20L1.84613512%2C4.06521739%20L0.23076689%2C4.06521739%20C0.103383567%2C4.06521739%200%2C4.17234783%200%2C4.30434783%20L0%2C5.97826087%20C0%2C6.11026087%200.103383567%2C6.2173913%200.23076689%2C6.2173913%20L1.84613512%2C6.2173913%20L1.84613512%2C10.7608696%20C1.84613512%2C10.8928696%201.94951868%2C11%202.07690201%2C11%20L3.69227024%2C11%20C3.81965356%2C11%203.92303713%2C10.8928696%203.92303713%2C10.7608696%20L3.92303713%2C6.2173913%20L5.5896356%2C6.2173913%20C5.70732672%2C6.2173913%205.80609495%2C6.12580435%205.81901789%2C6.00456522%20L5.99855453%2C4.33065217%20C6.01378515%2C4.18908696%205.90670931%2C4.06521739%205.76917224%2C4.06521739%20L3.92303713%2C4.06521739%20L3.92303713%2C2.86956522%20C3.92303713%2C2.47332609%204.23295706%2C2.15217391%204.61533779%2C2.15217391%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=facebook-color.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/facebookIcon.svg.js
'use client';

var facebookIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.61533779%2C2.15217391%20L5.76917224%2C2.15217391%20C5.89655557%2C2.15217391%205.99993913%2C2.04504348%205.99993913%2C1.91304348%20L5.99993913%2C0.302021739%20C5.99993913%2C0.176717391%205.90694008%2C0.0724565217%205.78647976%2C0.0636086957%20C5.41932964%2C0.0365869565%204.70210615%2C0%204.18634215%2C0%20C2.76920268%2C0%201.84613512%2C0.88%201.84613512%2C2.47930435%20L1.84613512%2C4.06521739%20L0.23076689%2C4.06521739%20C0.103383567%2C4.06521739%200%2C4.17234783%200%2C4.30434783%20L0%2C5.97826087%20C0%2C6.11026087%200.103383567%2C6.2173913%200.23076689%2C6.2173913%20L1.84613512%2C6.2173913%20L1.84613512%2C10.7608696%20C1.84613512%2C10.8928696%201.94951868%2C11%202.07690201%2C11%20L3.69227024%2C11%20C3.81965356%2C11%203.92303713%2C10.8928696%203.92303713%2C10.7608696%20L3.92303713%2C6.2173913%20L5.5896356%2C6.2173913%20C5.70732672%2C6.2173913%205.80609495%2C6.12580435%205.81901789%2C6.00456522%20L5.99855453%2C4.33065217%20C6.01378515%2C4.18908696%205.90670931%2C4.06521739%205.76917224%2C4.06521739%20L3.92303713%2C4.06521739%20L3.92303713%2C2.86956522%20C3.92303713%2C2.47332609%204.23295706%2C2.15217391%204.61533779%2C2.15217391%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22SEARCH-RESULT%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FINTERVIEW%22%20transform%3D%22translate%28-913.000000%2C%20-1307.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22section%2Fsearchresult%2Finterview-content%22%20transform%3D%22translate%28245.000000%2C%20168.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28566.000000%2C%201133.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%2862.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Fb%22%20transform%3D%22translate%2840.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-facebook-f-%282%29%22%20transform%3D%22translate%288.800000%2C%206.400000%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Path%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23495AA0%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23999999%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=facebookIcon.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/inIcon.svg.js
'use client';

var linkedInIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.215775%2C2.36842105%20L1.230075%2C2.36842105%20L1.230075%2C2.36842105%20C1.997325%2C2.36842105%202.475%2C1.84210526%202.475%2C1.18421053%20C2.4607%2C0.511842105%201.997325%2C0%201.24465%2C0%20C0.491975%2C0%200%2C0.511842105%200%2C1.18421053%20C0%2C1.84210526%200.4774%2C2.36842105%201.215775%2C2.36842105%20Z%20M0%2C3.15789474%20L2.475%2C3.15789474%20L2.475%2C10%20L0%2C10%20L0%2C3.15789474%20Z%20M11%2C5.65789474%20C11%2C4.27710526%209.830425%2C3.15789474%208.3875%2C3.15789474%20C7.547925%2C3.15789474%206.80295%2C3.53842105%206.325%2C4.12736842%20L6.325%2C3.15789474%20L3.85%2C3.15789474%20L3.85%2C10%20L6.325%2C10%20L6.325%2C6.05263158%20L6.325%2C6.05263158%20C6.325%2C5.47131579%206.817525%2C5%207.425%2C5%20C8.032475%2C5%208.525%2C5.47131579%208.525%2C6.05263158%20L8.525%2C10%20L11%2C10%20C11%2C10%2011%2C6.04078947%2011%2C5.65789474%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22SEARCH-RESULT%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FINTERVIEW%22%20transform%3D%22translate%28-973.000000%2C%20-1307.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22section%2Fsearchresult%2Finterview-content%22%20transform%3D%22translate%28245.000000%2C%20168.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28566.000000%2C%201133.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%2862.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%20transform%3D%22translate%28100.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-Copy%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-linkedin-2-%282%29%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Shape%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%230288D1%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23999999%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=inIcon.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/link-color.svg.js
'use client';

var linkColorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FSALARY-BYEXPERIENCE-TOOPTIP%22%20transform%3D%22translate%28-780.000000%2C%20-1651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22JobDetail%2FShare-Social%22%20transform%3D%22translate%28650.000000%2C%201651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22CopyLink%22%20transform%3D%22translate%28130.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-Copy-2%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-link-%281%29%22%20transform%3D%22translate%286.000000%2C%206.000000%29%22%20fill%3D%22%23005AFF%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.1797273%2C0%20C9.46865883%2C0%208.7573639%2C0.251004817%208.21590597%2C0.75240711%20L6.67329077%2C2.18131082%20C5.90445136%2C2.8934764%205.68470583%2C3.92187608%206.00803797%2C4.81808446%20L7.11618979%2C3.79161808%20C7.16246824%2C3.49812127%207.30240781%2C3.21501545%207.54583249%2C2.98953445%20L9.08844769%2C1.56063074%20C9.38925765%2C1.28228031%209.78481781%2C1.14256477%2010.1797273%2C1.14256477%20C10.5746368%2C1.14256477%2010.9699029%2C1.2819945%2011.2704044%2C1.56063074%20C11.8717158%2C2.11790322%2011.8717158%2C3.02420308%2011.2704044%2C3.58118973%20L9.72778918%2C5.01009338%20C9.4843645%2C5.23557438%209.17903776%2C5.36491245%208.86187608%2C5.40806534%20L7.75312141%2C6.43508985%20C8.03943079%2C6.52368187%208.33755074%2C6.57072424%208.63650956%2C6.57072424%20C9.34765517%2C6.57072424%2010.058873%2C6.3198622%2010.6003309%2C5.81831701%20L12.1429461%2C4.38941336%20C13.225862%2C3.38660877%2013.2255534%2C1.75521175%2012.1429461%2C0.75240711%20C11.6014882%2C0.251147679%2010.8907958%2C0%2010.1797273%2C0%20Z%20M8.31653754%2C3.7084516%20C8.15622981%2C3.71287615%208.00407873%2C3.77493584%207.89231836%2C3.88148298%20L4.1900419%2C7.31085175%20C4.02884429%2C7.45420884%203.96390955%2C7.66708714%204.02028092%2C7.86738632%20C4.07665229%2C8.0676855%204.24552106%2C8.22410637%204.46175996%2C8.2763224%20C4.67799886%2C8.32853844%204.90781793%2C8.26839027%205.06258331%2C8.1190751%20L8.76485978%2C4.68970632%20C8.94735742%2C4.52538732%209.00223023%2C4.27414354%208.90303752%2C4.05703783%20C8.80384481%2C3.83993213%208.57093535%2C3.7015024%208.31653754%2C3.7084516%20Z%20M4.45638398%2C5.4354157%20C3.69986142%2C5.39975541%202.93143173%2C5.64755874%202.35457077%2C6.18168293%20L0.811955519%2C7.61058658%20C-0.270651824%2C8.61339117%20-0.270651855%2C10.2453463%200.811955519%2C11.2481509%20C1.35341345%2C11.7494103%202.06433729%2C12%202.77517437%2C12%20C3.48601145%2C12%204.19693523%2C11.749138%204.73839316%2C11.2475928%20L6.28100836%2C9.81868912%20C7.04984777%2C9.10652354%207.27019585%2C8.07812386%206.9468637%2C7.18191549%20L5.83810903%2C8.20893999%20C5.79183058%2C8.5024368%205.65189131%2C8.78554262%205.40846664%2C9.01102362%20L3.86585144%2C10.4399273%20C3.26454004%2C10.9971997%202.2858087%2C10.9971997%201.68449724%2C10.4399273%20C1.08318584%2C9.88265485%201.08318584%2C8.97635499%201.68449724%2C8.41936834%20L3.22711249%2C6.99046469%20C3.47053717%2C6.76498369%203.77617243%2C6.6350872%204.0930256%2C6.59193431%20L5.20117772%2C5.56546823%20C4.95929566%2C5.49059367%204.70855806%2C5.44730218%204.45638398%2C5.4354157%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=link-color.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/linkedin-color.svg.js
'use client';

var linkedInColorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FSALARY-BYEXPERIENCE-TOOPTIP%22%20transform%3D%22translate%28-750.000000%2C%20-1651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22JobDetail%2FShare-Social%22%20transform%3D%22translate%28650.000000%2C%201651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Linkedin%22%20transform%3D%22translate%28100.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-Copy%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-linkedin-2-%282%29%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%20fill%3D%22%230173B1%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.215775%2C2.36842105%20L1.230075%2C2.36842105%20L1.230075%2C2.36842105%20C1.997325%2C2.36842105%202.475%2C1.84210526%202.475%2C1.18421053%20C2.4607%2C0.511842105%201.997325%2C0%201.24465%2C0%20C0.491975%2C0%200%2C0.511842105%200%2C1.18421053%20C0%2C1.84210526%200.4774%2C2.36842105%201.215775%2C2.36842105%20Z%20M0%2C3.15789474%20L2.475%2C3.15789474%20L2.475%2C10%20L0%2C10%20L0%2C3.15789474%20Z%20M11%2C5.65789474%20C11%2C4.27710526%209.830425%2C3.15789474%208.3875%2C3.15789474%20C7.547925%2C3.15789474%206.80295%2C3.53842105%206.325%2C4.12736842%20L6.325%2C3.15789474%20L3.85%2C3.15789474%20L3.85%2C10%20L6.325%2C10%20L6.325%2C6.05263158%20L6.325%2C6.05263158%20C6.325%2C5.47131579%206.817525%2C5%207.425%2C5%20C8.032475%2C5%208.525%2C5.47131579%208.525%2C6.05263158%20L8.525%2C10%20L11%2C10%20C11%2C10%2011%2C6.04078947%2011%2C5.65789474%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=linkedin-color.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/linkIcon.svg.js
'use client';

var linkIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.1797273%2C0%20C9.46865883%2C0%208.7573639%2C0.251004817%208.21590597%2C0.75240711%20L6.67329077%2C2.18131082%20C5.90445136%2C2.8934764%205.68470583%2C3.92187608%206.00803797%2C4.81808446%20L7.11618979%2C3.79161808%20C7.16246824%2C3.49812127%207.30240781%2C3.21501545%207.54583249%2C2.98953445%20L9.08844769%2C1.56063074%20C9.38925765%2C1.28228031%209.78481781%2C1.14256477%2010.1797273%2C1.14256477%20C10.5746368%2C1.14256477%2010.9699029%2C1.2819945%2011.2704044%2C1.56063074%20C11.8717158%2C2.11790322%2011.8717158%2C3.02420308%2011.2704044%2C3.58118973%20L9.72778918%2C5.01009338%20C9.4843645%2C5.23557438%209.17903776%2C5.36491245%208.86187608%2C5.40806534%20L7.75312141%2C6.43508985%20C8.03943079%2C6.52368187%208.33755074%2C6.57072424%208.63650956%2C6.57072424%20C9.34765517%2C6.57072424%2010.058873%2C6.3198622%2010.6003309%2C5.81831701%20L12.1429461%2C4.38941336%20C13.225862%2C3.38660877%2013.2255534%2C1.75521175%2012.1429461%2C0.75240711%20C11.6014882%2C0.251147679%2010.8907958%2C0%2010.1797273%2C0%20Z%20M8.31653754%2C3.7084516%20C8.15622981%2C3.71287615%208.00407873%2C3.77493584%207.89231836%2C3.88148298%20L4.1900419%2C7.31085175%20C4.02884429%2C7.45420884%203.96390955%2C7.66708714%204.02028092%2C7.86738632%20C4.07665229%2C8.0676855%204.24552106%2C8.22410637%204.46175996%2C8.2763224%20C4.67799886%2C8.32853844%204.90781793%2C8.26839027%205.06258331%2C8.1190751%20L8.76485978%2C4.68970632%20C8.94735742%2C4.52538732%209.00223023%2C4.27414354%208.90303752%2C4.05703783%20C8.80384481%2C3.83993213%208.57093535%2C3.7015024%208.31653754%2C3.7084516%20Z%20M4.45638398%2C5.4354157%20C3.69986142%2C5.39975541%202.93143173%2C5.64755874%202.35457077%2C6.18168293%20L0.811955519%2C7.61058658%20C-0.270651824%2C8.61339117%20-0.270651855%2C10.2453463%200.811955519%2C11.2481509%20C1.35341345%2C11.7494103%202.06433729%2C12%202.77517437%2C12%20C3.48601145%2C12%204.19693523%2C11.749138%204.73839316%2C11.2475928%20L6.28100836%2C9.81868912%20C7.04984777%2C9.10652354%207.27019585%2C8.07812386%206.9468637%2C7.18191549%20L5.83810903%2C8.20893999%20C5.79183058%2C8.5024368%205.65189131%2C8.78554262%205.40846664%2C9.01102362%20L3.86585144%2C10.4399273%20C3.26454004%2C10.9971997%202.2858087%2C10.9971997%201.68449724%2C10.4399273%20C1.08318584%2C9.88265485%201.08318584%2C8.97635499%201.68449724%2C8.41936834%20L3.22711249%2C6.99046469%20C3.47053717%2C6.76498369%203.77617243%2C6.6350872%204.0930256%2C6.59193431%20L5.20117772%2C5.56546823%20C4.95929566%2C5.49059367%204.70855806%2C5.44730218%204.45638398%2C5.4354157%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22SEARCH-RESULT%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FINTERVIEW%22%20transform%3D%22translate%28-1003.000000%2C%20-1307.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22section%2Fsearchresult%2Finterview-content%22%20transform%3D%22translate%28245.000000%2C%20168.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28566.000000%2C%201133.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%2862.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%28130.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-Copy-2%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-link-%281%29%22%20transform%3D%22translate%286.000000%2C%206.000000%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Shape%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23005AFF%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23999999%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=linkIcon.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/twitterColor.svg.js
'use client';

var twitterColorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FSALARY-BYEXPERIENCE-TOOPTIP%22%20transform%3D%22translate%28-750.000000%2C%20-1651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22JobDetail%2FShare-Social%22%20transform%3D%22translate%28620.000000%2C%201651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22twitter%22%20transform%3D%22translate%28130.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-twitter%22%20transform%3D%22translate%285.000000%2C%207.000000%29%22%20fill%3D%22%2303A9F4%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.6551724%2C1.30065517%20C13.1533448%2C1.52293103%2012.6135862%2C1.67124138%2012.0442414%2C1.74141379%20C12.623069%2C1.39775862%2013.0683793%2C0.849655172%2013.2773793%2C0.202172414%20C12.7357241%2C0.519655172%2012.1356552%2C0.752931034%2011.4972759%2C0.875827586%20C10.9874828%2C0.335310345%2010.2603448%2C0%209.45468966%2C0%20C7.90710345%2C0%206.65272414%2C1.24337931%206.65272414%2C2.77655172%20C6.65272414%2C2.99351724%206.67813793%2C3.2047931%206.72593103%2C3.41%20C4.39772414%2C3.29317241%202.33275862%2C2.18634483%200.951310345%2C0.506758621%20C0.708551724%2C0.917172414%200.572%2C1.39775862%200.572%2C1.90489655%20C0.572%2C2.86872414%201.06548276%2C3.71724138%201.81803448%2C4.21717241%20C1.35868966%2C4.20313793%200.926275862%2C4.07531034%200.547724138%2C3.87048276%20C0.547724138%2C3.87882759%200.547724138%2C3.89134483%200.547724138%2C3.90310345%20C0.547724138%2C5.25003448%201.51382759%2C6.37165517%202.79437931%2C6.62693103%20C2.56034483%2C6.69103448%202.31303448%2C6.72668966%202.05813793%2C6.72668966%20C1.8772069%2C6.72668966%201.70082759%2C6.7062069%201.53013793%2C6.67548276%20C1.88668966%2C7.77624138%202.92106897%2C8.58075862%204.14662069%2C8.60465517%20C3.18772414%2C9.34810345%201.98%2C9.79341379%200.666827586%2C9.79341379%20C0.44%2C9.79341379%200.218103448%2C9.78051724%20-0.00113793103%2C9.75396552%20C1.23958621%2C10.5395172%202.71282759%2C11%204.29417241%2C11%20C9.44710345%2C11%2012.2661379%2C6.76841379%2012.2661379%2C3.09744828%20C12.2661379%2C2.9772069%2012.2623448%2C2.85734483%2012.2566552%2C2.739%20C12.8066552%2C2.35058621%2013.2807931%2C1.86051724%2013.6551724%2C1.30065517%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=twitterColor.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/twitterIcon.svg.js
'use client';

var twitterIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FINTERVIEW%22%20transform%3D%22translate%28-973.000000%2C%20-1307.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22section%2Fsearchresult%2Finterview-content%22%20transform%3D%22translate%28245.000000%2C%20168.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28566.000000%2C%201133.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%2832.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22twitter%22%20transform%3D%22translate%28130.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icons8-twitter%22%20transform%3D%22translate%285.000000%2C%207.000000%29%22%20fill%3D%22%23999999%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.6551724%2C1.30065517%20C13.1533448%2C1.52293103%2012.6135862%2C1.67124138%2012.0442414%2C1.74141379%20C12.623069%2C1.39775862%2013.0683793%2C0.849655172%2013.2773793%2C0.202172414%20C12.7357241%2C0.519655172%2012.1356552%2C0.752931034%2011.4972759%2C0.875827586%20C10.9874828%2C0.335310345%2010.2603448%2C0%209.45468966%2C0%20C7.90710345%2C0%206.65272414%2C1.24337931%206.65272414%2C2.77655172%20C6.65272414%2C2.99351724%206.67813793%2C3.2047931%206.72593103%2C3.41%20C4.39772414%2C3.29317241%202.33275862%2C2.18634483%200.951310345%2C0.506758621%20C0.708551724%2C0.917172414%200.572%2C1.39775862%200.572%2C1.90489655%20C0.572%2C2.86872414%201.06548276%2C3.71724138%201.81803448%2C4.21717241%20C1.35868966%2C4.20313793%200.926275862%2C4.07531034%200.547724138%2C3.87048276%20C0.547724138%2C3.87882759%200.547724138%2C3.89134483%200.547724138%2C3.90310345%20C0.547724138%2C5.25003448%201.51382759%2C6.37165517%202.79437931%2C6.62693103%20C2.56034483%2C6.69103448%202.31303448%2C6.72668966%202.05813793%2C6.72668966%20C1.8772069%2C6.72668966%201.70082759%2C6.7062069%201.53013793%2C6.67548276%20C1.88668966%2C7.77624138%202.92106897%2C8.58075862%204.14662069%2C8.60465517%20C3.18772414%2C9.34810345%201.98%2C9.79341379%200.666827586%2C9.79341379%20C0.44%2C9.79341379%200.218103448%2C9.78051724%20-0.00113793103%2C9.75396552%20C1.23958621%2C10.5395172%202.71282759%2C11%204.29417241%2C11%20C9.44710345%2C11%2012.2661379%2C6.76841379%2012.2661379%2C3.09744828%20C12.2661379%2C2.9772069%2012.2623448%2C2.85734483%2012.2566552%2C2.739%20C12.8066552%2C2.35058621%2013.2807931%2C1.86051724%2013.6551724%2C1.30065517%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=twitterIcon.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/zalo-color.svg.js
'use client';

var zaloColorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FSALARY-BYEXPERIENCE-TOOPTIP%22%20transform%3D%22translate%28-720.000000%2C%20-1651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22JobDetail%2FShare-Social%22%20transform%3D%22translate%28650.000000%2C%201651.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Zalo%22%20transform%3D%22translate%2870.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22zalo-1%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.5091924%2C11.6170168%20C2.45426791%2C11.5926059%202.41460022%2C11.5651436%202.47867879%2C11.5102191%20C2.51834648%2C11.4797055%202.56106553%2C11.4522433%202.60378458%2C11.424781%20C3.00351281%2C11.1654154%203.37883017%2C10.8816389%203.62599037%2C10.4636025%20C3.83348289%2C10.1157473%203.79991793%2C9.91130619%203.54055228%2C9.6549919%20C2.09420736%2C8.20864698%201.45952436%2C6.47852553%201.77686586%2C4.43411393%20C1.95689613%2C3.28069963%202.48478151%2C2.28290472%203.25372438%2C1.41631831%20C3.71753119%2C0.891484289%204.26982746%2C0.467345167%204.87399685%2C0.113387339%20C4.91061318%2C0.0920278148%204.96248631%2C0.0859250936%204.96858903%2C0.031000603%20C4.95638359%2C0.00048699715%204.93502407%2C0.00964107892%204.9167159%2C0.00964107892%20C3.88840738%2C0.00964107892%202.86009887%2C-0.0117184452%201.83484171%2C0.0157438001%20C0.852303599%2C0.046257406%200.00402535489%2C0.806046193%200.00706850876%2C1.89538192%20C0.0131794367%2C5.07795102%200.00706850876%2C8.26052011%200.00706850876%2C11.4461406%20C0.00706850876%2C12.4347814%200.760762781%2C13.2617001%201.74635225%2C13.2983164%20C2.57937369%2C13.3318814%203.41239513%2C13.3044192%204.24846793%2C13.3013678%20C4.30949515%2C13.3044192%204.37052236%2C13.3074705%204.43154957%2C13.3074705%20L8.83771426%2C13.3074705%20C9.93620407%2C13.3074705%2011.0346939%2C13.3135732%2012.1331837%2C13.3074705%20C13.1523381%2C13.3074705%2013.9792569%2C12.4836032%2013.9792569%2C11.4675001%20L13.9792569%2C11.4491919%20L13.9792569%2C9.66414598%20C13.9792569%2C9.62142693%2013.9945137%2C9.57565652%2013.9670514%2C9.52988612%20C13.9121269%2C9.53293748%2013.8907674%2C9.57870788%2013.8602538%2C9.60922149%20C13.2682898%2C10.2042368%2012.5695283%2C10.6833004%2011.8036368%2C11.0220014%20C9.92704999%2C11.8489202%208.01689826%2C11.906896%206.07928429%2C11.2416994%20C5.91145945%2C11.1806722%205.72837782%2C11.1745695%205.55445027%2C11.2172885%20C5.29813598%2C11.2813671%205.04487305%2C11.3576511%204.79161012%2C11.4339351%20C4.04707813%2C11.6658385%203.28728935%2C11.7695848%202.5091924%2C11.6170168%20Z%20M4.72142882%2C6.47547417%20C4.77330195%2C6.40834423%204.8007642%2C6.36867655%204.83127781%2C6.32900886%20C5.23100604%2C5.822483%205.63073428%2C5.31595714%206.03046252%2C4.80637992%20C6.14641422%2C4.65991462%206.26236592%2C4.51039795%206.33559858%2C4.33341903%20C6.42103667%2C4.13202923%206.32949586%2C3.94284488%206.12200334%2C3.86961222%20C6.03046252%2C3.84214998%205.93281898%2C3.82994454%205.83517544%2C3.83604726%20C5.29203325%2C3.8329959%204.74583971%2C3.8329959%204.20269752%2C3.83604726%20C4.12641351%2C3.83604726%204.0501295%2C3.84520134%203.97689684%2C3.8635095%20C3.80602065%2C3.90622855%203.70227439%2C4.0801561%203.74499344%2C4.25408366%20C3.77550704%2C4.37003536%203.86704786%2C4.46157618%203.98299956%2C4.48903842%20C4.05623222%2C4.50734659%204.13251623%2C4.51650067%204.20880025%2C4.51344931%20C4.53834719%2C4.51650067%204.87094549%2C4.51344931%205.20049244%2C4.51650067%20C5.23710876%2C4.51650067%205.28287917%2C4.49208978%205.31034142%2C4.54701427%20C5.28287917%2C4.5836306%205.25541693%2C4.62024693%205.22795468%2C4.65381189%20C4.75499379%2C5.25187857%204.28508426%2C5.85299661%203.81212337%2C6.45106328%20C3.69617167%2C6.60057995%203.63514446%2C6.76535342%203.72058255%2C6.94843506%20C3.80602065%2C7.13151669%203.9799482%2C7.16508166%204.15692712%2C7.1772871%20C4.2972897%2C7.18644118%204.44070365%2C7.18033846%204.5841176%2C7.18033846%20C5.07843801%2C7.18033846%205.56970707%2C7.18338982%206.06402748%2C7.1772871%20C6.32644449%2C7.17423574%206.46680708%2C7.01556499%206.43934484%2C6.77145614%20C6.41798531%2C6.57922043%206.28677681%2C6.47852553%206.04266796%2C6.47547417%20C5.61242612%2C6.47242281%205.18218427%2C6.47547417%204.72142882%2C6.47547417%20L4.72142882%2C6.47547417%20Z%20M8.26100711%2C4.8704585%20C7.87958703%2C4.53786019%207.45849927%2C4.51650067%207.04656559%2C4.76060952%20C6.54614246%2C5.05354013%206.36306082%2C5.53260374%206.42408803%2C6.08795137%20C6.48206388%2C6.60668267%206.70786457%2C7.03082179%207.25100675%2C7.20474935%20C7.58970778%2C7.31459833%207.90399792%2C7.27493064%208.18167173%2C7.04912996%20C8.25490439%2C6.99115411%208.27626391%2C7.00335955%208.32813704%2C7.06743812%20C8.42883194%2C7.19559527%208.60275949%2C7.24441703%208.75532752%2C7.18644118%20C8.90789555%2C7.14067077%209.00859045%2C7.00030819%209.00859045%2C6.84163744%20C9.01164181%2C6.23136532%209.01469317%2C5.6210932%209.00859045%2C5.01082108%20C9.00553909%2C4.76671224%208.77668705%2C4.61109285%208.53868092%2C4.65991462%20C8.40747242%2C4.68737686%208.33423976%2C4.77586632%208.26100711%2C4.8704585%20Z%20M10.3756%2C6.00251327%20C10.3633946%2C6.76535342%2010.9950262%2C7.34206057%2011.7883799%2C7.2627252%20C12.5176551%2C7.18949254%2012.990616%2C6.643299%2012.9662051%2C5.87130477%20C12.9417943%2C5.10846462%2012.3742412%2C4.58668196%2011.5961442%2C4.61109285%20C10.8668691%2C4.63245237%2010.3511891%2C5.2183136%2010.3756%2C6.00251327%20L10.3756%2C6.00251327%20Z%20M10.1070803%2C5.39529252%20C10.1070803%2C4.91622891%2010.1101316%2C4.44021665%2010.1070803%2C3.96115304%20C10.1070803%2C3.71704419%209.95146087%2C3.56447616%209.71955747%2C3.56752753%20C9.49375679%2C3.57057889%209.34424012%2C3.72314692%209.34118876%2C3.95810168%20C9.3381374%2C4.10151563%209.34118876%2C4.24187822%209.34118876%2C4.38529216%20L9.34118876%2C6.81112383%20C9.34118876%2C7.00030819%209.45714046%2C7.16508166%209.60970849%2C7.20474935%20C9.82025237%2C7.2627252%2010.036899%2C7.13761941%2010.0918235%2C6.92707553%20C10.1009775%2C6.89045921%2010.1070803%2C6.85384288%2010.1040289%2C6.81417519%20C10.1101316%2C6.3412143%2010.1070803%2C5.86825341%2010.1070803%2C5.39529252%20L10.1070803%2C5.39529252%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23FDFEFE%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.24541657%2C13.3044192%20C3.41239513%2C13.3044192%202.57632233%2C13.3318814%201.74330089%2C13.3013678%20C0.75771142%2C13.2617001%200.00402535489%2C12.4347814%200.00402535489%2C11.4491919%20C0.00402535489%2C8.26662283%200.0101280761%2C5.08405374%200.00402535489%2C1.89843328%20C0.00402535489%2C0.809097553%200.855354959%2C0.0493087666%201.83484171%2C0.0218465213%20C2.86009887%2C-0.00561572403%203.88840738%2C0.0157438001%204.9167159%2C0.0157438001%20C4.93502407%2C0.0157438001%204.95943495%2C0.00658971833%204.96858903%2C0.0371033242%20C4.96248631%2C0.0920278148%204.90756182%2C0.098130536%204.87399685%2C0.11949006%20C4.26982746%2C0.473447888%203.71753119%2C0.89758701%203.25372438%2C1.42242103%20C2.48783287%2C2.28900744%201.95689613%2C3.28375099%201.77686586%2C4.44021665%20C1.45952436%2C6.48157689%202.09725872%2C8.2147497%203.54055228%2C9.66109462%20C3.79686657%2C9.92046027%203.83043153%2C10.1218501%203.62599037%2C10.4697052%20C3.37883017%2C10.8877416%203.00351281%2C11.1715181%202.60378458%2C11.4308838%20C2.56106553%2C11.4552946%202.51834648%2C11.4858083%202.47562743%2C11.5132705%20C2.41154886%2C11.568195%202.45121655%2C11.5956572%202.50614104%2C11.6200681%20C2.51834648%2C11.6475304%202.53360328%2C11.6719412%202.55191145%2C11.6963521%20C2.90281791%2C12.0075909%203.23541622%2C12.3401892%203.58021996%2C12.6575307%20C3.74194208%2C12.8070474%203.90366419%2C12.9626668%204.05928358%2C13.1182862%20C4.12336215%2C13.176262%204.23015977%2C13.1945702%204.24541657%2C13.3044192%20Z%22%20id%3D%22Path%22%20fill%3D%22%230180C7%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.24541657%2C13.3044192%20C4.23015977%2C13.1976215%204.12336215%2C13.1793134%204.05928358%2C13.1152348%20C3.90366419%2C12.9565641%203.74194208%2C12.803996%203.58021996%2C12.6544794%20C3.23541622%2C12.3371379%202.90281791%2C12.0045396%202.55191145%2C11.6933008%20C2.53360328%2C11.6688899%202.51834648%2C11.644479%202.50614104%2C11.6170168%20C3.28423799%2C11.7695848%204.04402677%2C11.6658385%204.79161012%2C11.4369865%20C5.04487305%2C11.3607025%205.29813598%2C11.2844185%205.55445027%2C11.2203399%20C5.72837782%2C11.1745695%205.91145945%2C11.1837236%206.07928429%2C11.2447508%20C8.0138469%2C11.9099474%209.92399863%2C11.8489202%2011.8036368%2C11.0250528%20C12.5695283%2C10.6863518%2013.2682898%2C10.2103395%2013.8602538%2C9.61532421%20C13.8907674%2C9.58481061%2013.9121269%2C9.5390402%2013.9670514%2C9.53598884%20C13.9945137%2C9.57870788%2013.9792569%2C9.62447829%2013.9792569%2C9.6702487%20L13.9792569%2C11.4552946%20C13.9853596%2C12.4744491%2013.1675949%2C13.3044192%2012.1484405%2C13.3135732%20L12.1331837%2C13.3135732%20C11.0346939%2C13.319676%209.93620407%2C13.3135732%208.83771426%2C13.3135732%20L4.42849821%2C13.3135732%20C4.367471%2C13.3074705%204.30644378%2C13.3044192%204.24541657%2C13.3044192%20L4.24541657%2C13.3044192%20Z%22%20id%3D%22Path%22%20fill%3D%22%230172B1%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.72142882%2C6.47547417%20C5.18218427%2C6.47547417%205.61547748%2C6.47242281%206.04571932%2C6.47547417%20C6.28677681%2C6.47852553%206.41798531%2C6.57922043%206.4423962%2C6.77145614%20C6.46985844%2C7.01251363%206.32949586%2C7.17423574%206.06707884%2C7.1772871%20C5.57275843%2C7.18338982%205.08148937%2C7.18033846%204.58716896%2C7.18033846%20C4.44375501%2C7.18033846%204.30339242%2C7.18644118%204.15997848%2C7.1772871%20C3.98299956%2C7.16813302%203.80907201%2C7.13151669%203.72363391%2C6.94843506%20C3.63819582%2C6.76535342%203.69922303%2C6.60057995%203.81517473%2C6.45106328%20C4.28508426%2C5.85299661%204.75804515%2C5.25187857%205.23100604%2C4.65381189%20C5.25846829%2C4.61719557%205.28593053%2C4.58057924%205.31339278%2C4.54701427%20C5.28287917%2C4.49514114%205.24016012%2C4.51955203%205.2035438%2C4.51650067%20C4.87399685%2C4.51344931%204.54139855%2C4.51650067%204.21185161%2C4.51344931%20C4.13556759%2C4.51344931%204.05928358%2C4.50429523%203.98605092%2C4.48903842%20C3.81212337%2C4.44937074%203.70532575%2C4.27544318%203.74499344%2C4.10456699%20C3.77245568%2C3.98861529%203.8639965%2C3.89402311%203.9799482%2C3.86656086%20C4.05318086%2C3.8482527%204.12946487%2C3.83909862%204.20574889%2C3.83909862%20C4.74889107%2C3.83604726%205.29508462%2C3.83604726%205.8382268%2C3.83909862%20C5.93587034%2C3.83604726%206.03046252%2C3.8482527%206.1250547%2C3.87266358%20C6.33254722%2C3.94284488%206.42103667%2C4.13508059%206.33864994%2C4.33647039%20C6.26541728%2C4.51039795%206.14946558%2C4.65991462%206.03351388%2C4.80943128%20C5.63378564%2C5.3190085%205.2340574%2C5.82553436%204.83432917%2C6.32900886%20C4.8007642%2C6.36867655%204.77025059%2C6.40834423%204.72142882%2C6.47547417%20L4.72142882%2C6.47547417%20Z%22%20id%3D%22Path%22%20fill%3D%22%230180C7%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.26100711%2C4.8704585%20C8.33423976%2C4.77586632%208.41052378%2C4.68737686%208.53562956%2C4.66296598%20C8.77668705%2C4.61414421%209.00248773%2C4.7697636%209.00553909%2C5.01387244%20C9.01469317%2C5.62414456%209.01164181%2C6.23441668%209.00553909%2C6.8446888%20C9.00553909%2C7.00335955%208.90179283%2C7.14372214%208.75227616%2C7.18949254%20C8.59970813%2C7.2474684%208.42578058%2C7.20169799%208.32508568%2C7.07048948%20C8.27321255%2C7.00641091%208.25185303%2C6.99420547%208.17862037%2C7.05218132%20C7.90094656%2C7.277982%207.58665642%2C7.31764969%207.24795539%2C7.20780071%20C6.70481321%2C7.03082179%206.48206388%2C6.60668267%206.42103667%2C6.09100273%20C6.3569581%2C5.53260374%206.5430911%2C5.05659149%207.04351423%2C4.76366088%20C7.45849927%2C4.51650067%207.87958703%2C4.53786019%208.26100711%2C4.8704585%20L8.26100711%2C4.8704585%20Z%20M7.18082546%2C5.98420511%20C7.18692818%2C6.11846498%207.22964723%2C6.24662212%207.3089826%2C6.35341974%20C7.47375608%2C6.57311771%207.78804622%2C6.61888811%208.01079554%2C6.45411464%20C8.04741187%2C6.4266524%208.08097683%2C6.39308743%208.11149044%2C6.35341974%20C8.28236663%2C6.12151634%208.28236663%2C5.74009626%208.11149044%2C5.50819286%20C8.02605234%2C5.3891898%207.89179248%2C5.3190085%207.74837853%2C5.31595714%20C7.41272886%2C5.29459762%207.1777741%2C5.55396327%207.18082546%2C5.98420511%20L7.18082546%2C5.98420511%20Z%20M10.3756%2C6.00251327%20C10.3511891%2C5.2183136%2010.8668691%2C4.63245237%2011.5991956%2C4.61109285%20C12.3772925%2C4.58668196%2012.9448456%2C5.10846462%2012.9692565%2C5.87130477%20C12.9936674%2C6.643299%2012.5207065%2C7.18949254%2011.7914313%2C7.2627252%20C10.9950262%2C7.34206057%2010.3633946%2C6.76535342%2010.3756%2C6.00251327%20L10.3756%2C6.00251327%20Z%20M11.1414915%2C5.92928062%20C11.1353888%2C6.08184865%2011.1811592%2C6.23136532%2011.2727%2C6.3564711%20C11.4405248%2C6.57616907%2011.754815%2C6.61888811%2011.9745129%2C6.44801192%20C12.0080779%2C6.42360104%2012.0355402%2C6.39308743%2012.0630024%2C6.36257382%20C12.2399813%2C6.13067042%2012.2399813%2C5.74009626%2012.0660538%2C5.50819286%20C11.9806157%2C5.39224116%2011.8463558%2C5.3190085%2011.7029419%2C5.31595714%20C11.3733949%2C5.29764898%2011.1414915%2C5.54786055%2011.1414915%2C5.92928062%20L11.1414915%2C5.92928062%20Z%20M10.1070803%2C5.39529252%20C10.1070803%2C5.86825341%2010.1101316%2C6.3412143%2010.1070803%2C6.81417519%20C10.1101316%2C7.03082179%209.93925543%2C7.21085207%209.72260883%2C7.21695479%20C9.6859925%2C7.21695479%209.64632481%2C7.21390343%209.60970849%2C7.20474935%20C9.45714046%2C7.16508166%209.34118876%2C7.00335955%209.34118876%2C6.81112383%20L9.34118876%2C4.38529216%20C9.34118876%2C4.24187822%209.3381374%2C4.10151563%209.34118876%2C3.95810168%20C9.34424012%2C3.72314692%209.49375679%2C3.57057889%209.71955747%2C3.57057889%20C9.95146087%2C3.56752753%2010.1070803%2C3.72009555%2010.1070803%2C3.9642044%20C10.1101316%2C4.44021665%2010.1070803%2C4.91928027%2010.1070803%2C5.39529252%20L10.1070803%2C5.39529252%20Z%22%20id%3D%22Shape%22%20fill%3D%22%230180C7%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.18082546%2C5.98420511%20C7.1777741%2C5.55396327%207.41272886%2C5.29459762%207.74532717%2C5.31290578%20C7.88874112%2C5.3190085%208.02300098%2C5.3891898%208.10843908%2C5.50819286%20C8.27931527%2C5.7370449%208.27931527%2C6.12151634%208.10843908%2C6.35341974%20C7.94366561%2C6.57311771%207.62937547%2C6.61888811%207.40662614%2C6.45411464%20C7.37000982%2C6.4266524%207.33644485%2C6.39308743%207.30593124%2C6.35341974%20C7.22964723%2C6.24662212%207.18692818%2C6.11846498%207.18082546%2C5.98420511%20L7.18082546%2C5.98420511%20Z%20M11.1414915%2C5.92928062%20C11.1414915%2C5.55091191%2011.3733949%2C5.29764898%2011.7029419%2C5.31595714%20C11.8463558%2C5.3190085%2011.9806157%2C5.39224116%2012.0660538%2C5.50819286%20C12.2399813%2C5.74009626%2012.2399813%2C6.13372178%2012.0630024%2C6.36257382%20C11.8921262%2C6.57922043%2011.5747847%2C6.61583675%2011.3581381%2C6.44496056%20C11.3245731%2C6.42054968%2011.2971109%2C6.39003607%2011.2727%2C6.3564711%20C11.1811592%2C6.23136532%2011.1384401%2C6.08184865%2011.1414915%2C5.92928062%20L11.1414915%2C5.92928062%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23ECECEC%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.00266654%2C0.0248978819%20L12.0141806%2C0.0248978819%20C13.1096191%2C0.0248978819%2013.997565%2C0.912843813%2013.997565%2C2.00828226%20L13.997565%2C11.2539048%20C13.997565%2C12.3493433%2013.1096191%2C13.2372892%2012.0141806%2C13.2372892%20L2.00266654%2C13.2372892%20C0.907228089%2C13.2372892%200.0192821578%2C12.3493433%200.0192821578%2C11.2539048%20L0.0192821578%2C2.00828226%20C0.0192821578%2C0.912843813%200.907228089%2C0.0248978819%202.00266654%2C0.0248978819%20Z%22%20id%3D%22Path%22%20stroke%3D%22%230180C7%22%20stroke-width%3D%220.5%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=zalo-color.svg.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/images/zaloIcon.svg.js
'use client';

var zaloIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22SEARCH-RESULT%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PAGES%2FSEARCH%2FINTERVIEW%22%20transform%3D%22translate%28-943.000000%2C%20-1307.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22section%2Fsearchresult%2Finterview-content%22%20transform%3D%22translate%28245.000000%2C%20168.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28566.000000%2C%201133.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%20transform%3D%22translate%2862.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Zalo%22%20transform%3D%22translate%2870.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.400000006%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-12%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.23407737%2C11.3432938%20C3.18517496%2C11.3215594%203.14985655%2C11.2971082%203.20690937%2C11.2482058%20C3.24222778%2C11.2210378%203.28026299%2C11.1965866%203.3182982%2C11.1721354%20C3.67419909%2C10.9412073%204.00836557%2C10.6885449%204.22842643%2C10.3163432%20C4.41316888%2C10.0066279%204.38328407%2C9.82460226%204.15235601%2C9.596391%20C2.86459248%2C8.30862747%202.29949794%2C6.76820148%202.58204521%2C4.94794501%20C2.74233645%2C3.92099435%203.21234297%2C3.03260052%203.89697674%2C2.26102912%20C4.30993045%2C1.7937394%204.80167138%2C1.41610411%205.33959791%2C1.10095523%20C5.37219952%2C1.08193762%205.41838513%2C1.07650402%205.42381874%2C1.02760161%20C5.41295153%2C1.0004336%205.39393393%2C1.008584%205.37763312%2C1.008584%20C4.46207129%2C1.008584%203.54650945%2C0.989566399%202.63366442%2C1.0140176%20C1.7588546%2C1.04118561%201.003584%2C1.71766899%201.0062935%2C2.68756683%20C1.01173441%2C5.52118996%201.0062935%2C8.35481308%201.0062935%2C11.191153%20C1.0062935%2C12.0713964%201.67735058%2C12.8076494%202.5548772%2C12.840251%20C3.29656379%2C12.8701358%204.03825038%2C12.8456846%204.78265377%2C12.8429678%20C4.83698978%2C12.8456846%204.8913258%2C12.8484014%204.94566181%2C12.8484014%20L8.86872202%2C12.8484014%20C9.84677027%2C12.8484014%2010.8248185%2C12.853835%2011.8028668%2C12.8484014%20C12.7102782%2C12.8484014%2013.4465312%2C12.1148652%2013.4465312%2C11.2101706%20L13.4465312%2C11.1938698%20L13.4465312%2C9.6045414%20C13.4465312%2C9.56650619%2013.4601152%2C9.52575418%2013.435664%2C9.48500217%20C13.3867616%2C9.48771897%2013.367744%2C9.52847098%2013.340576%2C9.55563899%20C12.8135166%2C10.0854151%2012.1913693%2C10.5119528%2011.5094523%2C10.8135177%20C9.83861987%2C11.5497707%208.13790263%2C11.6013899%206.41273419%2C11.0091274%20C6.26331015%2C10.9547913%206.10030211%2C10.9493577%205.94544447%2C10.987393%20C5.71723321%2C11.0444458%205.49173875%2C11.1123658%205.26624429%2C11.1802858%20C4.60334493%2C11.3867627%203.92686155%2C11.4791339%203.23407737%2C11.3432938%20Z%20M5.20375788%2C6.76548468%20C5.24994349%2C6.70571506%205.2743947%2C6.67039665%205.3015627%2C6.63507824%20C5.65746359%2C6.18408933%206.01336449%2C5.73310041%206.36926538%2C5.2793947%20C6.4725038%2C5.14898826%206.57574223%2C5.01586503%206.64094545%2C4.85829059%20C6.71701587%2C4.67898174%206.63551185%2C4.5105401%206.4507694%2C4.44533688%20C6.36926538%2C4.42088568%206.28232775%2C4.41001847%206.19539013%2C4.41545208%20C5.71179961%2C4.41273527%205.22549228%2C4.41273527%204.74190176%2C4.41545208%20C4.67398174%2C4.41545208%204.60606173%2C4.42360248%204.54085851%2C4.43990328%20C4.38871767%2C4.47793849%204.29634645%2C4.63279613%204.33438166%2C4.78765377%20C4.36154966%2C4.8908922%204.44305368%2C4.97239622%204.54629211%2C4.99684742%20C4.61149533%2C5.01314823%204.67941534%2C5.02129863%204.74733536%2C5.01858183%20C5.04074984%2C5.02129863%205.33688111%2C5.01858183%205.63029559%2C5.02129863%20C5.6628972%2C5.02129863%205.70364921%2C4.99956423%205.72810041%2C5.04846664%20C5.70364921%2C5.08106825%205.679198%2C5.11366985%205.65474679%2C5.14355466%20C5.23364269%2C5.6760476%204.81525538%2C6.21125734%204.39415127%2C6.74375027%20C4.29091285%2C6.87687351%204.23657683%2C7.02358074%204.31264725%2C7.18658879%20C4.38871767%2C7.34959683%204.54357531%2C7.37948163%204.70114975%2C7.39034884%20C4.82612258%2C7.39849924%204.95381221%2C7.39306564%205.08150185%2C7.39306564%20C5.52162356%2C7.39306564%205.95902847%2C7.39578244%206.39915018%2C7.39034884%20C6.63279504%2C7.38763204%206.75776788%2C7.2463584%206.73331667%2C7.02901434%20C6.71429907%2C6.8578559%206.59747664%2C6.76820148%206.38013258%2C6.76548468%20C5.99706368%2C6.76276788%205.61399478%2C6.76548468%205.20375788%2C6.76548468%20L5.20375788%2C6.76548468%20Z%20M8.35524669%2C5.33644751%20C8.0156466%2C5.04031624%207.6407281%2C5.02129863%207.27396001%2C5.23864269%20C6.82840469%2C5.49945555%206.66539665%2C5.92599326%206.71973267%2C6.42045099%20C6.77135188%2C6.88230711%206.97239513%2C7.2599424%207.45598566%2C7.41480004%20C7.75755053%2C7.51260487%208.037381%2C7.47728646%208.28460987%2C7.27624321%20C8.34981308%2C7.22462399%208.36883069%2C7.2354912%208.4150163%2C7.29254401%20C8.50467072%2C7.40664964%208.65952836%2C7.45011845%208.7953684%2C7.39849924%20C8.93120843%2C7.35774723%209.02086286%2C7.2327744%209.02086286%2C7.09150076%20C9.02357966%2C6.54814062%209.02629646%2C6.00478048%209.02086286%2C5.46142034%20C9.01814606%2C5.24407629%208.814386%2C5.10551945%208.60247555%2C5.14898826%20C8.48565312%2C5.17343947%208.4204499%2C5.25222669%208.35524669%2C5.33644751%20Z%20M10.2379896%2C6.34438057%20C10.2271224%2C7.02358074%2010.7895001%2C7.53705607%2011.4958683%2C7.46641926%20C12.1451837%2C7.40121604%2012.5662878%2C6.91490872%2012.5445534%2C6.22755814%20C12.522819%2C5.54835797%2012.017494%2C5.08378505%2011.3247098%2C5.10551945%20C10.6753945%2C5.12453706%2010.2162552%2C5.64616279%2010.2379896%2C6.34438057%20L10.2379896%2C6.34438057%20Z%20M9.99891111%2C5.80373723%20C9.99891111%2C5.37719952%2010.0016279%2C4.95337861%209.99891111%2C4.5268409%20C9.99891111%2C4.30949685%209.86035427%2C4.17365681%209.65387742%2C4.17637361%20C9.45283417%2C4.17909042%209.31971093%2C4.31493045%209.31699413%2C4.5241241%20C9.31427733%2C4.65181374%209.31699413%2C4.77678657%209.31699413%2C4.9044762%20L9.31699413%2C7.06433275%20C9.31699413%2C7.2327744%209.42023256%2C7.37948163%209.55607259%2C7.41480004%20C9.74353184%2C7.46641926%209.93642469%2C7.35503043%209.9853271%2C7.16757118%20C9.9934775%2C7.13496957%209.99891111%2C7.10236796%209.99619431%2C7.06704955%20C10.0016279%2C6.64594545%209.99891111%2C6.22484134%209.99891111%2C5.80373723%20L9.99891111%2C5.80373723%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23FDFEFE%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.77993697%2C12.8456846%20C4.03825038%2C12.8456846%203.29384699%2C12.8701358%202.5521604%2C12.8429678%20C1.67463378%2C12.8076494%201.003584%2C12.0713964%201.003584%2C11.1938698%20C1.003584%2C8.36024669%201.0090176%2C5.52662356%201.003584%2C2.69028363%20C1.003584%2C1.72038579%201.7615714%2C1.04390241%202.63366442%2C1.01945121%20C3.54650945%2C0.995%204.46207129%2C1.0140176%205.37763312%2C1.0140176%20C5.39393393%2C1.0140176%205.41566833%2C1.0058672%205.42381874%2C1.03303521%20C5.41838513%2C1.08193762%205.36948272%2C1.08737122%205.33959791%2C1.10638883%20C4.80167138%2C1.42153771%204.30993045%2C1.79917301%203.89697674%2C2.26646273%20C3.21505977%2C3.03803412%202.74233645%2C3.92371115%202.58204521%2C4.95337861%20C2.29949794%2C6.77091828%202.86730928%2C8.31406107%204.15235601%2C9.6018246%20C4.38056727%2C9.83275266%204.41045208%2C10.0120615%204.22842643%2C10.3217768%20C4.00836557%2C10.6939785%203.67419909%2C10.9466409%203.3182982%2C11.177569%20C3.28026299%2C11.1993034%203.24222778%2C11.2264714%203.20419257%2C11.2509226%20C3.14713975%2C11.299825%203.18245816%2C11.3242762%203.23136057%2C11.3460106%20C3.24222778%2C11.3704619%203.25581178%2C11.3921963%203.27211258%2C11.4139307%20C3.58454466%2C11.6910443%203.88067594%2C11.9871756%204.18767442%2C12.2697229%20C4.33166486%2C12.4028461%204.47565529%2C12.541403%204.61421213%2C12.6799598%20C4.67126494%2C12.731579%204.76635297%2C12.7478798%204.77993697%2C12.8456846%20Z%22%20id%3D%22Path%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.77993697%2C12.8456846%20C4.76635297%2C12.7505966%204.67126494%2C12.7342958%204.61421213%2C12.677243%20C4.47565529%2C12.5359694%204.33166486%2C12.4001293%204.18767442%2C12.2670061%20C3.88067594%2C11.9844588%203.58454466%2C11.6883275%203.27211258%2C11.4112139%20C3.25581178%2C11.3894795%203.24222778%2C11.3677451%203.23136057%2C11.3432938%20C3.92414475%2C11.4791339%204.60062812%2C11.3867627%205.26624429%2C11.1830026%20C5.49173875%2C11.1150826%205.71723321%2C11.0471626%205.94544447%2C10.9901098%20C6.10030211%2C10.9493577%206.26331015%2C10.9575082%206.41273419%2C11.0118442%20C8.13518583%2C11.6041067%209.83590306%2C11.5497707%2011.5094523%2C10.8162345%20C12.1913693%2C10.5146696%2012.8135166%2C10.0908487%2013.340576%2C9.56107259%20C13.367744%2C9.53390459%2013.3867616%2C9.49315258%2013.435664%2C9.49043577%20C13.4601152%2C9.52847098%2013.4465312%2C9.569223%2013.4465312%2C9.60997501%20L13.4465312%2C11.1993034%20C13.4519648%2C12.1067148%2012.7238622%2C12.8456846%2011.8164508%2C12.853835%20L11.8028668%2C12.853835%20C10.8248185%2C12.8592686%209.84677027%2C12.853835%208.86872202%2C12.853835%20L4.94294501%2C12.853835%20C4.888609%2C12.8484014%204.83427298%2C12.8456846%204.77993697%2C12.8456846%20L4.77993697%2C12.8456846%20Z%22%20id%3D%22Path%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.20375788%2C6.76548468%20C5.61399478%2C6.76548468%205.99978048%2C6.76276788%206.38284938%2C6.76548468%20C6.59747664%2C6.76820148%206.71429907%2C6.8578559%206.73603347%2C7.02901434%20C6.76048468%2C7.2436416%206.63551185%2C7.38763204%206.40186699%2C7.39034884%20C5.96174527%2C7.39578244%205.52434036%2C7.39306564%205.08421865%2C7.39306564%20C4.95652902%2C7.39306564%204.83155618%2C7.39849924%204.70386655%2C7.39034884%20C4.54629211%2C7.38219844%204.39143447%2C7.34959683%204.31536405%2C7.18658879%20C4.23929363%2C7.02358074%204.29362965%2C6.87687351%204.39686807%2C6.74375027%20C4.81525538%2C6.21125734%205.23635949%2C5.6760476%205.65746359%2C5.14355466%20C5.6819148%2C5.11095305%205.70636601%2C5.07835145%205.73081721%2C5.04846664%20C5.70364921%2C5.00228103%205.665614%2C5.02401543%205.63301239%2C5.02129863%20C5.33959791%2C5.01858183%205.04346664%2C5.02129863%204.75005216%2C5.01858183%20C4.68213215%2C5.01858183%204.61421213%2C5.01043143%204.54900891%2C4.99684742%20C4.39415127%2C4.96152902%204.29906325%2C4.80667138%204.33438166%2C4.65453054%20C4.35883286%2C4.55129211%204.44033688%2C4.46707129%204.54357531%2C4.44262008%20C4.60877853%2C4.42631928%204.67669854%2C4.41816888%204.74461856%2C4.41816888%20C5.22820908%2C4.41545208%205.71451641%2C4.41545208%206.19810693%2C4.41816888%20C6.28504456%2C4.41545208%206.36926538%2C4.42631928%206.4534862%2C4.44805368%20C6.63822865%2C4.5105401%206.71701587%2C4.68169854%206.64366225%2C4.86100739%20C6.57845903%2C5.01586503%206.4752206%2C5.14898826%206.37198218%2C5.2821115%20C6.01608129%2C5.73581721%205.6601804%2C6.18680613%205.3042795%2C6.63507824%20C5.2743947%2C6.67039665%205.24722669%2C6.70571506%205.20375788%2C6.76548468%20L5.20375788%2C6.76548468%20Z%22%20id%3D%22Path%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.35524669%2C5.33644751%20C8.4204499%2C5.25222669%208.48836992%2C5.17343947%208.59975875%2C5.15170506%20C8.814386%2C5.10823625%209.01542925%2C5.24679309%209.01814606%2C5.46413714%20C9.02629646%2C6.00749728%209.02357966%2C6.55085742%209.01814606%2C7.09421756%20C9.01814606%2C7.2354912%208.92577483%2C7.36046403%208.7926516%2C7.40121604%20C8.65681156%2C7.45283525%208.50195392%2C7.41208324%208.4122995%2C7.29526081%20C8.36611389%2C7.238208%208.34709628%2C7.2273408%208.28189307%2C7.27896001%20C8.0346642%2C7.48000326%207.75483373%2C7.51532167%207.45326885%2C7.41751684%20C6.96967833%2C7.2599424%206.77135188%2C6.88230711%206.71701587%2C6.42316779%20C6.65996305%2C5.92599326%206.82568789%2C5.50217235%207.27124321%2C5.24135949%20C7.6407281%2C5.02129863%208.0156466%2C5.04031624%208.35524669%2C5.33644751%20Z%20M7.89882417%2C5.73310041%20C7.59997609%2C5.71408281%207.39078244%2C5.94501087%207.39349924%2C6.32807977%20C7.39893284%2C6.447619%207.43696805%2C6.56172463%207.50760487%2C6.65681265%20C7.65431211%2C6.8524223%207.93414258%2C6.89317431%208.13246903%2C6.74646707%20C8.16507064%2C6.72201587%208.19495544%2C6.69213106%208.22212345%2C6.65681265%20C8.37426429%2C6.4503358%208.37426429%2C6.11073571%208.22212345%2C5.90425886%20C8.14605303%2C5.79830363%208.0265138%2C5.73581721%207.89882417%2C5.73310041%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.3274266%2C5.10551945%20C12.0202108%2C5.08378505%2012.5255358%2C5.54835797%2012.5472702%2C6.22755814%20C12.5690046%2C6.91490872%2012.1479005%2C7.40121604%2011.4985851%2C7.46641926%20C10.7895001%2C7.53705607%2010.2271224%2C7.02358074%2010.2379896%2C6.34438057%20C10.2162552%2C5.64616279%2010.6753945%2C5.12453706%2011.3274266%2C5.10551945%20Z%20M11.4197979%2C5.73310041%20C11.1263834%2C5.71679961%2010.9199065%2C5.93957727%2010.9199065%2C6.27917735%20C10.9144729%2C6.41501739%2010.955225%2C6.54814062%2011.036729%2C6.65952945%20C11.186153%2C6.8551391%2011.4659835%2C6.89317431%2011.6615931%2C6.74103347%20C11.6914779%2C6.71929907%2011.7159291%2C6.69213106%2011.7403804%2C6.66496305%20C11.8979548%2C6.4584862%2011.8979548%2C6.11073571%2011.7430972%2C5.90425886%20C11.6670267%2C5.80102043%2011.5474875%2C5.73581721%2011.4197979%2C5.73310041%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.99891111%2C5.80373723%20C9.99891111%2C6.22484134%2010.0016279%2C6.64594545%209.99891111%2C7.06704955%20C10.0016279%2C7.2599424%209.84948707%2C7.42023364%209.65659422%2C7.42566725%20C9.62399261%2C7.42566725%209.5886742%2C7.42295045%209.55607259%2C7.41480004%20C9.42023256%2C7.37948163%209.31699413%2C7.2354912%209.31699413%2C7.06433275%20L9.31699413%2C4.9044762%20C9.31699413%2C4.77678657%209.31427733%2C4.65181374%209.31699413%2C4.5241241%20C9.31971093%2C4.31493045%209.45283417%2C4.17909042%209.65387742%2C4.17909042%20C9.86035427%2C4.17637361%209.99891111%2C4.31221365%209.99891111%2C4.5295577%20C10.0016279%2C4.95337861%209.99891111%2C5.37991632%209.99891111%2C5.80373723%20L9.99891111%2C5.80373723%20Z%22%20id%3D%22Path%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.39349924%2C6.32807977%20C7.39078244%2C5.94501087%207.59997609%2C5.71408281%207.89610737%2C5.73038361%20C8.023797%2C5.73581721%208.14333623%2C5.79830363%208.21940665%2C5.90425886%20C8.37154749%2C6.10801891%208.37154749%2C6.4503358%208.21940665%2C6.65681265%20C8.07269941%2C6.8524223%207.79286894%2C6.89317431%207.59454249%2C6.74646707%20C7.56194088%2C6.72201587%207.53205607%2C6.69213106%207.50488807%2C6.65681265%20C7.43696805%2C6.56172463%207.39893284%2C6.447619%207.39349924%2C6.32807977%20L7.39349924%2C6.32807977%20Z%20M10.9199065%2C6.27917735%20C10.9199065%2C5.94229407%2011.1263834%2C5.71679961%2011.4197979%2C5.73310041%20C11.5474875%2C5.73581721%2011.6670267%2C5.80102043%2011.7430972%2C5.90425886%20C11.8979548%2C6.11073571%2011.8979548%2C6.461203%2011.7403804%2C6.66496305%20C11.5882395%2C6.8578559%2011.3056922%2C6.89045751%2011.1127994%2C6.73831667%20C11.0829146%2C6.71658226%2011.0584634%2C6.68941426%2011.036729%2C6.65952945%20C10.955225%2C6.54814062%2010.9171897%2C6.41501739%2010.9199065%2C6.27917735%20L10.9199065%2C6.27917735%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23FDFEFE%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.6969115%2C0.772168007%20L2.78308846%2C0.772168007%20C1.66968582%2C0.772168007%200.767168007%2C1.67468582%200.767168007%2C2.78808846%20L0.767168007%2C11.0199946%20C0.767168007%2C12.1333972%201.66968582%2C13.035915%202.78308846%2C13.035915%20L11.6969115%2C13.035915%20C12.8103142%2C13.035915%2013.712832%2C12.1333972%2013.712832%2C11.0199946%20L13.712832%2C2.78808846%20C13.712832%2C1.67468582%2012.8103142%2C0.772168007%2011.6969115%2C0.772168007%20Z%20M2.78308846%2C1.27216801%20L11.6969115%2C1.27216801%20C12.5341718%2C1.27216801%2013.212832%2C1.9508282%2013.212832%2C2.78808846%20L13.212832%2C11.0199946%20C13.212832%2C11.8572548%2012.5341718%2C12.535915%2011.6969115%2C12.535915%20L2.78308846%2C12.535915%20C1.9458282%2C12.535915%201.26716801%2C11.8572548%201.26716801%2C11.0199946%20L1.26716801%2C2.78808846%20C1.26716801%2C1.9508282%201.9458282%2C1.27216801%202.78308846%2C1.27216801%20Z%22%20id%3D%22Path%22%20fill%3D%22%23999999%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";


//# sourceMappingURL=zaloIcon.svg.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/SocialShare.css.js
'use client';





var DivShare = styled_components_browser_esm/* default.div */.ZP.div(SocialShare_css_templateObject_1 || (SocialShare_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n    .share-text {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        padding: 0 12px;\n    }\n\n    .icons {\n        margin-left: 8px;\n        display: inline-grid;\n        grid-template-columns: repeat(5, auto);\n        gap: 8px;\n    }\n\n    .btn-share {\n        width: 24px;\n        height: 24px;\n        display: inline-block;\n        cursor: pointer;\n        position: relative;\n\n        img {\n            position: absolute;\n            width: 24px;\n            height: 24px;\n            top: 0;\n            left: 0;\n            transition: opacity 0.3s;\n        }\n\n        img:first-child {\n            opacity: 1;\n\n            & + img {\n                opacity: 0;\n            }\n        }\n\n        :hover {\n            img:first-child {\n                opacity: 0;\n\n                & + img {\n                    opacity: 1;\n                }\n            }\n        }\n\n        .zalo-share-button {\n            position: relative;\n            width: 24px;\n            height: 24px;\n            z-index: 2;\n        }\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n    .share-text {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        padding: 0 12px;\n    }\n\n    .icons {\n        margin-left: 8px;\n        display: inline-grid;\n        grid-template-columns: repeat(5, auto);\n        gap: 8px;\n    }\n\n    .btn-share {\n        width: 24px;\n        height: 24px;\n        display: inline-block;\n        cursor: pointer;\n        position: relative;\n\n        img {\n            position: absolute;\n            width: 24px;\n            height: 24px;\n            top: 0;\n            left: 0;\n            transition: opacity 0.3s;\n        }\n\n        img:first-child {\n            opacity: 1;\n\n            & + img {\n                opacity: 0;\n            }\n        }\n\n        :hover {\n            img:first-child {\n                opacity: 0;\n\n                & + img {\n                    opacity: 1;\n                }\n            }\n        }\n\n        .zalo-share-button {\n            position: relative;\n            width: 24px;\n            height: 24px;\n            z-index: 2;\n        }\n    }\n"])), function (_a) {
    var isNewShareSocial = _a.isNewShareSocial;
    return (isNewShareSocial ? '20px' : '8px');
});
var IconsContainer = styled_components_browser_esm/* default.div */.ZP.div(SocialShare_css_templateObject_2 || (SocialShare_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n"])), function (_a) {
    var isNewShareSocial = _a.isNewShareSocial;
    return (isNewShareSocial ? '15px' : '8px');
});
var IconWrap = styled_components_browser_esm/* default.span */.ZP.span(SocialShare_css_templateObject_3 || (SocialShare_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    border-radius: 4px;\n    border: ", ";\n    .zalo-share-button {\n        position: relative;\n        width: 20px;\n        height: 20px;\n        z-index: 2;\n    }\n    svg {\n        position: absolute;\n        z-index: 1;\n    }\n"], ["\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    border-radius: 4px;\n    border: ", ";\n    .zalo-share-button {\n        position: relative;\n        width: 20px;\n        height: 20px;\n        z-index: 2;\n    }\n    svg {\n        position: absolute;\n        z-index: 1;\n    }\n"])), function (_a) {
    var isBorder = _a.isBorder;
    return (isBorder ? "1px solid ".concat(Colors/* colors.grey.60 */.O9.grey[60]) : 'none');
});
var SocialShare_css_templateObject_1, SocialShare_css_templateObject_2, SocialShare_css_templateObject_3;


//# sourceMappingURL=SocialShare.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ShareIcon/index.js
var ShareIcon = __webpack_require__(67468);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/Facebook.js
'use client';




var FacebookIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fills, fills = _d === void 0 ? ['none', Colors/* colors.grey.50 */.O9.grey[50]] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: fills[0] },
        react.createElement("path", { d: 'M10.3333 22.4V12.4H7V9.06669H10.3333V7.27669C10.3333 3.88752 11.9842 2.40002 14.8008 2.40002C16.15 2.40002 16.8633 2.50002 17.2008 2.54586V5.73336H15.28C14.0842 5.73336 13.6667 6.36419 13.6667 7.64252V9.06669H17.1708L16.695 12.4H13.6667V22.4H10.3333Z', fill: fills[1] })));
};
var FacebookIcon$1 = react.memo(FacebookIcon);


//# sourceMappingURL=Facebook.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/Linkedin.js
'use client';




var LinkedinIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fills, fills = _d === void 0 ? ['none', Colors/* colors.grey.50 */.O9.grey[50]] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: fills[0] },
        react.createElement("path", { d: 'M7.1157 21.1091H3V8.76198H7.1157V21.1091ZM5.05867 7.1157C3.92027 7.1157 3 6.19296 3 5.05703C3 3.92109 3.92192 3 5.05867 3C6.19296 3 7.1157 3.92274 7.1157 5.05703C7.1157 6.19296 6.19296 7.1157 5.05867 7.1157ZM21.9322 21.1091H17.9754V15.1002C17.9754 13.6671 17.9482 11.8241 15.9184 11.8241C13.858 11.8241 13.5411 13.3847 13.5411 14.9964V21.1091H9.58512V8.75293H13.3831V10.4412H13.4366C13.9651 9.46988 15.2566 8.4459 17.1827 8.4459C21.1914 8.4459 21.9322 11.005 21.9322 14.3322V21.1091Z', fill: fills[1] })));
};
var LinkedinIcon$1 = react.memo(LinkedinIcon);


//# sourceMappingURL=Linkedin.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/Twitter.js
'use client';




var TwitterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fill, fill = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M21.0955 20.8L14.0595 10.5424L14.0715 10.552L20.4155 3.19995H18.2955L13.1275 9.18395L9.02352 3.19995H3.46352L10.0323 12.7768L10.0315 12.776L3.10352 20.8H5.22352L10.9691 14.1424L15.5355 20.8H21.0955ZM8.18352 4.79995L18.0555 19.2H16.3755L6.49552 4.79995H8.18352Z', fill: fill })));
};
var TwitterIcon$1 = react.memo(TwitterIcon);


//# sourceMappingURL=Twitter.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/Zalo.js
'use client';




var ZaloIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fills, fills = _d === void 0 ? ['none', Colors/* colors.grey.50 */.O9.grey[50], Colors/* colors.grey.50 */.O9.grey[50], Colors/* colors.grey.50 */.O9.grey[50], Colors/* colors.grey.50 */.O9.grey[50], Colors/* colors.grey.50 */.O9.grey[50]] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: fills[0] },
        react.createElement("path", { d: 'M15.2093 13.2029C15.3114 13.5643 15.7635 13.3904 16.0351 13.4285C16.0305 11.8035 16.0305 10.1778 16.0351 8.55273H15.2022C15.208 10.1028 15.1925 11.6535 15.2093 13.2029Z', fill: fills[1] }),
        react.createElement("path", { d: 'M6.71855 9.43346C7.6103 9.42376 8.50269 9.43087 9.39442 9.42958C8.52661 10.5257 7.64457 11.6114 6.77288 12.7049C6.59956 12.9021 6.59698 13.1763 6.59375 13.424C7.76549 13.4363 8.93789 13.424 10.1103 13.4305C10.2441 13.4292 10.4058 13.4401 10.495 13.3173C10.6373 13.1272 10.5603 12.8717 10.5778 12.6525C9.6408 12.6525 8.70379 12.6564 7.76678 12.6506C8.64819 11.5526 9.51146 10.4403 10.3935 9.34228C10.5629 9.13793 10.5772 8.86246 10.5862 8.60961C9.29613 8.60056 8.00669 8.60897 6.71596 8.61026C6.71467 8.88444 6.71272 9.15927 6.71855 9.43346H6.71855Z', fill: fills[2] }),
        react.createElement("path", { d: 'M19.0659 13.3748C20.0275 13.0851 20.6094 11.9541 20.2906 11.0029C20.0365 10.0885 19.029 9.47871 18.1004 9.68628C17.5482 9.80333 17.0535 10.1726 16.7974 10.6776C16.4954 11.2499 16.5154 11.978 16.8478 12.5342C17.2714 13.2869 18.2491 13.6626 19.0659 13.3748ZM18.0849 10.5101C18.6501 10.2786 19.3517 10.6136 19.5328 11.1943C19.7494 11.7808 19.3801 12.4967 18.7691 12.6428C18.2336 12.8045 17.6174 12.4824 17.4343 11.9561C17.2132 11.3993 17.5184 10.7099 18.0849 10.5101V10.5101Z', fill: fills[3] }),
        react.createElement("path", { d: 'M13.7461 13.093C13.7985 13.2107 13.8393 13.3549 13.9712 13.4085C14.1594 13.4473 14.354 13.4247 14.5454 13.4299C14.5422 12.2135 14.5435 10.9978 14.5448 9.78207C14.2842 9.78336 14.0242 9.78272 13.7636 9.78401C13.7655 9.8448 13.7701 9.96572 13.772 10.0265C13.5728 9.90558 13.3665 9.79177 13.1389 9.73422C12.4496 9.53699 11.6671 9.80988 11.2203 10.3634C10.6299 11.0631 10.6629 12.1857 11.2998 12.8446C11.8973 13.5249 13.0271 13.6517 13.7461 13.093L13.7461 13.093ZM12.273 10.5264C12.8137 10.2962 13.492 10.6027 13.6931 11.1498C13.9007 11.6529 13.6776 12.2821 13.1945 12.5355C12.674 12.8343 11.9458 12.6067 11.6872 12.0648C11.3839 11.5086 11.6742 10.7372 12.273 10.5264V10.5264Z', fill: fills[4] }),
        react.createElement("path", { d: 'M21.9622 16.7821L21.9111 16.8377C20.9896 17.8685 19.7506 18.5662 18.4554 19.0176C16.71 19.6125 14.8405 19.8039 13.006 19.6642C11.1714 19.5065 9.3226 19.0273 7.76674 18.0133C6.97134 18.3671 6.09383 18.5404 5.22278 18.4686C5.19174 18.4362 5.16135 18.4039 5.13031 18.3716C5.60367 17.8659 5.9535 17.1992 5.9257 16.4917C5.92182 16.1619 5.67415 15.922 5.52542 15.6504C4.63691 14.1327 4.21788 12.3771 4.12863 10.6311C4.03875 8.48676 4.43515 6.27454 5.52283 4.40376C6.06537 3.46933 6.81615 2.65519 7.72147 2.06221L7.78096 2.00724C7.08904 1.99172 6.39259 1.99237 5.70778 2.10036C4.73326 2.23616 3.8066 2.71598 3.15218 3.45381C2.32576 4.32487 2.01471 5.55352 2.00049 6.72785C1.99984 10.2411 1.99984 13.7544 2.00049 17.2684C2.02635 18.0295 2.12593 18.8061 2.45896 19.5006C3.00862 20.7021 4.15967 21.601 5.45623 21.8525C6.48635 22.0472 7.54105 21.9987 8.58347 21.9832C9.17646 22.0142 9.77267 21.9864 10.3676 21.9961C12.4363 21.9955 14.5049 21.9961 16.5736 21.9955C17.2461 22.0039 17.9232 21.9735 18.5834 21.837C19.7603 21.5861 20.8066 20.8024 21.3834 19.747C21.8794 18.8475 21.9887 17.7928 21.9622 16.7821H21.9622Z', fill: fills[5] })));
};
var ZaloIcon$1 = react.memo(ZaloIcon);


//# sourceMappingURL=Zalo.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/FacebooksColorFull.js
'use client';



var FacebooksColorFull_FacebookIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z', fill: '#1877F2' }),
        react.createElement("path", { d: 'M17.184 12.5H15.5V19H13V12.5H11.5V10.5H13V9.295C13.001 7.541 13.7295 6.5 15.796 6.5H17.5V8.5H16.3565C15.552 8.5 15.5 8.8 15.5 9.3615V10.5H17.5L17.184 12.5Z', fill: 'white' })));
};
var FacebookIconColorFull = react.memo(FacebooksColorFull_FacebookIcon);


//# sourceMappingURL=FacebooksColorFull.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/LinkedinColorFull.js
'use client';



var LinkedinColorFull_LinkedinIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z', fill: '#0288D1' }),
        react.createElement("path", { d: 'M6 9.5H8.5V18H6V9.5ZM7.2425 8.5H7.2285C6.4825 8.5 6 7.944 6 7.2495C6 6.54 6.4975 6 7.257 6C8.0175 6 8.486 6.54 8.5 7.2495C8.5 7.9435 8.0175 8.5 7.2425 8.5ZM18 18H15.5V13.4505C15.5 12.3515 14.8875 11.6015 13.904 11.6015C13.1535 11.6015 12.7475 12.1075 12.5505 12.5965C12.4785 12.7715 12.5 13.2555 12.5 13.5V18H10V9.5H12.5V10.808C12.8605 10.25 13.425 9.5 14.869 9.5C16.658 9.5 17.9995 10.625 17.9995 13.137L18 18Z', fill: 'white' })));
};
var LinkedinIconColorFull = react.memo(LinkedinColorFull_LinkedinIcon);


//# sourceMappingURL=LinkedinColorFull.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/TwitterColorFull.js
'use client';



var TwitterColorFull_TwitterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M19 21H5C3.8955 21 3 20.1045 3 19V5C3 3.8955 3.8955 3 5 3H19C20.1045 3 21 3.8955 21 5V19C21 20.1045 20.1045 21 19 21Z', fill: '#212121' }),
        react.createElement("path", { d: 'M17.1281 17H13.9096L6.91406 7H10.1326L17.1281 17ZM14.2931 16.152H15.5746L9.74906 7.848H8.46756L14.2931 16.152Z', fill: 'white' }),
        react.createElement("path", { d: 'M7.93263 17L11.5341 12.828L11.0631 12.2035L6.91113 17H7.93263Z', fill: 'white' }),
        react.createElement("path", { d: 'M12.2246 10.8605L12.6771 11.505L16.5676 7H15.5676L12.2246 10.8605Z', fill: 'white' })));
};
var TwitterIconColorFull = react.memo(TwitterColorFull_TwitterIcon);


//# sourceMappingURL=TwitterColorFull.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/ZaloColorFull.js
'use client';



var ZaloColorFull_ZaloIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5.14286 3C3.96449 3 3 3.96449 3 5.14286V18.8571C3 20.0355 3.96449 21 5.14286 21H18.8571C20.0355 21 21 20.0355 21 18.8571V5.14286C21 3.96449 20.0355 3 18.8571 3H5.14286ZM5.14286 3.85714H7.96289C6.43242 5.44958 5.57143 7.50775 5.57143 9.64286C5.57143 11.8543 6.47578 13.9714 8.10435 15.5742C8.15578 15.6642 8.19854 16.1055 8.0014 16.6155C7.87711 16.9369 7.62844 17.3568 7.14844 17.5153C6.96415 17.5753 6.84429 17.7561 6.85714 17.9489C6.87 18.1418 7.01176 18.3046 7.20033 18.3432C8.43033 18.5875 9.22684 18.2186 9.8697 17.9272C10.4483 17.6615 10.8303 17.4813 11.4174 17.7213C12.6174 18.1884 13.8943 18.4286 15.2143 18.4286C16.9687 18.4286 18.6563 18.0003 20.1429 17.1914V18.8571C20.1429 19.5722 19.5722 20.1429 18.8571 20.1429H5.14286C4.42779 20.1429 3.85714 19.5722 3.85714 18.8571V5.14286C3.85714 4.42779 4.42779 3.85714 5.14286 3.85714ZM15.4286 7.71429C15.6643 7.71429 15.8571 7.90714 15.8571 8.14286V12C15.8571 12.2357 15.6643 12.4286 15.4286 12.4286C15.1929 12.4286 15 12.2357 15 12V8.14286C15 7.90714 15.1929 7.71429 15.4286 7.71429ZM9 8.14286H11.1429C11.2971 8.14286 11.4432 8.22837 11.5204 8.36551C11.5932 8.49837 11.5884 8.66541 11.507 8.79827L9.77176 11.5714H11.1429C11.3786 11.5714 11.5714 11.7643 11.5714 12C11.5714 12.2357 11.3786 12.4286 11.1429 12.4286H9C8.84571 12.4286 8.69963 12.3431 8.62249 12.2059C8.54963 12.0731 8.55445 11.906 8.63588 11.7732L10.3711 9H9C8.76429 9 8.57143 8.80714 8.57143 8.57143C8.57143 8.33571 8.76429 8.14286 9 8.14286ZM13.0714 9.42857C13.3329 9.42857 13.5769 9.50109 13.7955 9.62109C13.8726 9.50967 13.9929 9.42857 14.1429 9.42857C14.3786 9.42857 14.5714 9.62143 14.5714 9.85714V12C14.5714 12.2357 14.3786 12.4286 14.1429 12.4286C13.9929 12.4286 13.8726 12.3475 13.7955 12.236C13.5769 12.356 13.3329 12.4286 13.0714 12.4286C12.2443 12.4286 11.5714 11.7557 11.5714 10.9286C11.5714 10.1014 12.2443 9.42857 13.0714 9.42857ZM17.7857 9.42857C18.6129 9.42857 19.2857 10.1014 19.2857 10.9286C19.2857 11.7557 18.6129 12.4286 17.7857 12.4286C16.9586 12.4286 16.2857 11.7557 16.2857 10.9286C16.2857 10.1014 16.9586 9.42857 17.7857 9.42857ZM13.0714 10.2857C13.027 10.2857 12.9836 10.2906 12.9417 10.2991C12.8579 10.3162 12.7799 10.3492 12.7115 10.3954C12.6431 10.4415 12.5844 10.5003 12.5382 10.5686C12.4921 10.637 12.4591 10.715 12.442 10.7988C12.4334 10.8407 12.4286 10.8841 12.4286 10.9286C12.4286 10.973 12.4334 11.0164 12.442 11.0583C12.4505 11.1002 12.4626 11.1404 12.4788 11.1789C12.495 11.2173 12.5151 11.2543 12.5382 11.2885C12.5613 11.3227 12.5878 11.354 12.6169 11.3831C12.646 11.4122 12.6773 11.4387 12.7115 11.4618C12.7799 11.5079 12.8579 11.5409 12.9417 11.558C12.9836 11.5666 13.027 11.5714 13.0714 11.5714C13.1159 11.5714 13.1593 11.5666 13.2012 11.558C13.4944 11.4982 13.7143 11.2398 13.7143 10.9286C13.7143 10.5729 13.4271 10.2857 13.0714 10.2857ZM17.7857 10.2857C17.7412 10.2857 17.6979 10.2906 17.656 10.2991C17.6141 10.3077 17.5739 10.3197 17.5354 10.3359C17.497 10.3522 17.46 10.3723 17.4258 10.3954C17.3916 10.4184 17.3603 10.445 17.3312 10.4741C17.2731 10.5322 17.2256 10.6014 17.1931 10.6783C17.1768 10.7168 17.1648 10.7569 17.1562 10.7988C17.1477 10.8407 17.1429 10.8841 17.1429 10.9286C17.1429 10.973 17.1477 11.0164 17.1562 11.0583C17.1648 11.1002 17.1768 11.1404 17.1931 11.1789C17.2093 11.2173 17.2294 11.2543 17.2525 11.2885C17.2756 11.3227 17.3021 11.354 17.3312 11.3831C17.3603 11.4122 17.3916 11.4387 17.4258 11.4618C17.46 11.4849 17.497 11.505 17.5354 11.5212C17.5739 11.5374 17.6141 11.5495 17.656 11.558C17.6979 11.5666 17.7412 11.5714 17.7857 11.5714C17.8302 11.5714 17.8736 11.5666 17.9155 11.558C18.2087 11.4982 18.4286 11.2398 18.4286 10.9286C18.4286 10.5729 18.1414 10.2857 17.7857 10.2857Z', fill: '#0082E7' })));
};
var ZaloIconColorFull = react.memo(ZaloColorFull_ZaloIcon);


//# sourceMappingURL=ZaloColorFull.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/Share.js
'use client';




var Share_ShareIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M18 3.00012C17.2044 3.00012 16.4413 3.31619 15.8787 3.8788C15.3161 4.44141 15 5.20447 15 6.00012C15.0013 6.211 15.0249 6.42114 15.0703 6.62708L8.25879 10.0328C7.97785 9.7094 7.63091 9.44988 7.24128 9.27175C6.85166 9.09362 6.42841 9.001 6 9.00012C5.20435 9.00012 4.44129 9.31619 3.87868 9.8788C3.31607 10.4414 3 11.2045 3 12.0001C3 12.7958 3.31607 13.5588 3.87868 14.1214C4.44129 14.6841 5.20435 15.0001 6 15.0001C6.42854 14.9996 6.85201 14.9073 7.24189 14.7295C7.63178 14.5516 7.97902 14.2922 8.26025 13.9689L15.0674 17.3732C15.023 17.5792 15.0004 17.7894 15 18.0001C15 18.7958 15.3161 19.5588 15.8787 20.1214C16.4413 20.6841 17.2044 21.0001 18 21.0001C18.7956 21.0001 19.5587 20.6841 20.1213 20.1214C20.6839 19.5588 21 18.7958 21 18.0001C21 17.2045 20.6839 16.4414 20.1213 15.8788C19.5587 15.3162 18.7956 15.0001 18 15.0001C17.5715 15.0006 17.148 15.0929 16.7581 15.2708C16.3682 15.4487 16.021 15.708 15.7397 16.0314L8.93262 12.6271C8.97704 12.421 8.99963 12.2109 9 12.0001C8.99856 11.7897 8.97499 11.5801 8.92969 11.3746L15.7412 7.96887C16.0223 8.29204 16.3693 8.55128 16.7589 8.72916C17.1485 8.90704 17.5717 8.99943 18 9.00012C18.7956 9.00012 19.5587 8.68405 20.1213 8.12144C20.6839 7.55883 21 6.79577 21 6.00012C21 5.20447 20.6839 4.44141 20.1213 3.8788C19.5587 3.31619 18.7956 3.00012 18 3.00012Z', fill: color })));
};
var ShareIcon$1 = react.memo(Share_ShareIcon);


//# sourceMappingURL=Share.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/SocialMediaGroupIcons/index.js
'use client';











var SocialMedia = {
    FacebookIconColorFull: FacebookIconColorFull,
    LinkedinIconColorFull: LinkedinIconColorFull,
    TwitterIconColorFull: TwitterIconColorFull,
    ZaloIconColorFull: ZaloIconColorFull,
    FacebookIcon: FacebookIcon$1,
    LinkedinIcon: LinkedinIcon$1,
    TwitterIcon: TwitterIcon$1,
    ZaloIcon: ZaloIcon$1,
    ShareIcon: ShareIcon$1
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/MiscGroupIcons/index.js + 6 modules
var MiscGroupIcons = __webpack_require__(70203);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialShare/index.js
'use client';






















/* eslint-disable no-unused-vars */
function SocialShare(props) {
    var _a;
    var lang = props.lang, isNewShareSocial = props.isNewShareSocial;
    var btnRefList = (0,react.useRef)([]);
    var _b = (0,react.useState)(false), showCopyLinkTooltip = _b[0], setShowCopyLinkTooltip = _b[1];
    // Copy the current address bar link
    var copyAddressBarLink = function () {
        // Create a temporary textarea element
        var textArea = document.createElement('textarea');
        textArea.id = 'copyTextArea';
        textArea.style.position = 'absolute';
        textArea.style.opacity = '0';
        document.body.append(textArea);
        // Set the content of the area with the current HREF
        textArea.innerHTML = window.location.href;
        // Copy the value of the textarea
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
        setShowCopyLinkTooltip(true);
        setTimeout(function () {
            setShowCopyLinkTooltip(false);
        }, 2000);
    };
    // Add scripts on load
    (0,react.useEffect)(function () {
        // Zalo Script
        var zaloShareElement = document.querySelector('#share-zalo-script');
        if (!zaloShareElement) {
            // Add - readd zalo script
            var zaloScriptTag = document.createElement('script');
            zaloScriptTag.type = 'text/javascript';
            zaloScriptTag.id = 'share-zalo-script';
            zaloScriptTag.src = 'https://sp.zalo.me/plugins/sdk.js';
            document.body.append(zaloScriptTag);
        }
        // Rebinding click events from ZaloSDK
        if (btnRefList.current.length > 0) {
            btnRefList.current.forEach(function (btn) {
                var domEl = react_dom.findDOMNode(btn);
                if (domEl) {
                    var innerHTML = domEl.innerHTML;
                    domEl.innerHTML = '';
                    domEl.innerHTML = innerHTML;
                }
            });
            if (zaloShareElement) {
                typeof ZaloSocialSDK !== 'undefined' && ZaloSocialSDK.reload();
            }
        }
    }, []);
    // Get page title and page URL
    var currentHref = '';
    var pageTitle = '';
    if (typeof window !== 'undefined') {
        pageTitle = encodeURIComponent(((_a = document.querySelector('meta[property="og:title"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '');
        currentHref = encodeURIComponent(window.location.href);
    }
    // Get share links
    var facebookShareLink = "https://www.facebook.com/sharer.php?t=".concat(pageTitle, "&u=").concat(currentHref);
    var twitterShareLink = "https://twitter.com/intent/tweet?text=".concat(pageTitle, "&url=").concat(currentHref);
    var linkedinShareLink = "https://www.linkedin.com/shareArticle?title=".concat(pageTitle, "&url=").concat(currentHref);
    // Open new window with size method
    var openInNewWindow = function (link) {
        var left = window.innerWidth / 2 - 720 / 2;
        var top = window.innerHeight / 2 - 480 / 2;
        window.open(link, '_blank', "toolbar=no,\n                    location=no,\n                    status=no,\n                    menubar=no,\n                    scrollbars=yes,\n                    resizable=yes,\n                    width=720,\n                    height=480\n                    top=".concat(top, ",\n                    left=").concat(left, "\n                    "));
    };
    return (react.createElement(DivShare, { className: 'share-button-group', isNewShareSocial: isNewShareSocial },
        react.createElement("div", { className: 'share-text' },
            isNewShareSocial && react.createElement(ShareIcon/* default */.Z, null),
            react.createElement(Typography/* default */.Z, { variant: 'span', color: Colors/* colors.grey.50 */.O9.grey[50], name: 'paragraph', size: 'medium' },
                lang === constants/* ELanguage.EN */.Df.EN ? 'Share' : 'Chia sẻ',
                ":")),
        react.createElement(IconsContainer, { isNewShareSocial: isNewShareSocial },
            isNewShareSocial ? (react.createElement(IconWrap, { onClick: function () { return openInNewWindow(facebookShareLink); } },
                react.createElement(SocialMedia.FacebookIconColorFull, { width: 24, height: 24 }))) : (react.createElement("span", { onClick: function () { return openInNewWindow(facebookShareLink); }, className: 'btn-share btn-share-facebook' },
                react.createElement("img", { src: facebookIcon, alt: 'Share on Facebook' }),
                react.createElement("img", { src: facebookColorIcon, alt: 'Share on Facebook' }))),
            isNewShareSocial ? (react.createElement(IconWrap, { ref: function (el) { return el && btnRefList.current.push(el); } },
                react.createElement(SocialMedia.ZaloIconColorFull, { width: 24, height: 24 }),
                react.createElement("div", { className: 'zalo-share-button', "data-href": '', "data-oaid": '935978607505933955', "data-layout": '2', "data-color": 'blue', "data-customize": true }))) : (react.createElement("span", { className: 'btn-share', ref: function (el) { return el && btnRefList.current.push(el); } },
                react.createElement("img", { src: zaloIcon, alt: 'Share on Zalo' }),
                react.createElement("img", { src: zaloColorIcon, alt: 'Share on Zalo' }),
                react.createElement("div", { className: 'zalo-share-button', "data-href": '', "data-oaid": '935978607505933955', "data-layout": '2', "data-color": 'blue', "data-customize": true }))),
            isNewShareSocial ? (react.createElement(IconWrap, { onClick: function () { return openInNewWindow(twitterShareLink); } },
                react.createElement(SocialMedia.TwitterIconColorFull, { width: 24, height: 24 }))) : (react.createElement("span", { onClick: function () { return openInNewWindow(twitterShareLink); }, className: 'btn-share btn-share-twitter' },
                react.createElement("img", { src: twitterIcon, alt: 'Share on Twitter' }),
                react.createElement("img", { src: twitterColorIcon, alt: 'Share on Twitter' }))),
            isNewShareSocial ? (react.createElement(IconWrap, { onClick: function () { return openInNewWindow(linkedinShareLink); } },
                react.createElement(SocialMedia.LinkedinIconColorFull, { width: 24, height: 24 }))) : (react.createElement("span", { onClick: function () { return openInNewWindow(linkedinShareLink); }, className: 'btn-share btn-share-linkedin' },
                react.createElement("img", { src: linkedInIcon, alt: 'Share on LinkedIn' }),
                react.createElement("img", { src: linkedInColorIcon, alt: 'Share on LinkedIn' }))),
            isNewShareSocial ? (react.createElement(IconWrap, { isBorder: true, onClick: copyAddressBarLink },
                react.createElement(MiscGroupIcons/* default.LinkIcon */.Z.LinkIcon, { width: 20, height: 20 }),
                react.createElement(Tooltip, { isShow: showCopyLinkTooltip, placement: 'left', customStyle: { width: '200px' }, description: lang === constants/* ELanguage.EN */.Df.EN ? "\u2713 Page Link Was Copied!" : "\u2713 Li\u00EAn k\u1EBFt trang \u0111\u00E3 \u0111\u01B0\u1EE3c sao ch\u00E9p!" }))) : (react.createElement("span", { onClick: copyAddressBarLink, className: 'btn-share copy-link', style: { position: 'relative' } },
                react.createElement("img", { src: linkIcon, alt: 'Copy the current link' }),
                react.createElement("img", { src: linkColorIcon, alt: 'Copy the current link' }),
                react.createElement(Tooltip, { isShow: showCopyLinkTooltip, placement: 'left', customStyle: { width: '200px' }, description: lang === constants/* ELanguage.EN */.Df.EN ? "\u2713 Page Link Was Copied!" : "\u2713 Li\u00EAn k\u1EBFt trang \u0111\u00E3 \u0111\u01B0\u1EE3c sao ch\u00E9p!" }))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TagSelect/TagSelect.css.js
'use client';





var TagSelect_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(TagSelect_css_templateObject_1 || (TagSelect_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var SPACE = '8px';
var TagSelect_css_Title = styled_components_browser_esm/* default.p */.ZP.p(TagSelect_css_templateObject_2 || (TagSelect_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-weight: 500;\n    font-size: 14px;\n    margin-bottom: 8px;\n"], ["\n    color: ", ";\n    font-weight: 500;\n    font-size: 14px;\n    margin-bottom: 8px;\n"])), constants/* colors.textColor */.O9.textColor);
var Block = styled_components_browser_esm/* default.div */.ZP.div(TagSelect_css_templateObject_3 || (TagSelect_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1 * ", ");\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1 * ", ");\n"])), SPACE);
var Tag = styled_components_browser_esm/* default.div */.ZP.div(TagSelect_css_templateObject_4 || (TagSelect_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid ", ";\n    padding: 8px 10px;\n    border-radius: 8px;\n    color: ", ";\n    line-height: 1.5;\n    align-items: center;\n    display: inline-flex;\n    margin-right: ", ";\n    margin-top: ", ";\n    &:last-of-type {\n        margin-right: 0;\n    }\n    ", "\n"], ["\n    border: 1px solid ", ";\n    padding: 8px 10px;\n    border-radius: 8px;\n    color: ", ";\n    line-height: 1.5;\n    align-items: center;\n    display: inline-flex;\n    margin-right: ", ";\n    margin-top: ", ";\n    &:last-of-type {\n        margin-right: 0;\n    }\n    ", "\n"])), constants/* colors.borderNormal */.O9.borderNormal, constants/* colors.textColor */.O9.textColor, SPACE, SPACE, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected &&
        "\n    border: 1px solid ".concat(constants/* colors.borderFocus */.O9.borderFocus, ";\n    color: ").concat(constants/* colors.borderFocus */.O9.borderFocus, ";\n    ");
});
var TagSelect_css_templateObject_1, TagSelect_css_templateObject_2, TagSelect_css_templateObject_3, TagSelect_css_templateObject_4;


//# sourceMappingURL=TagSelect.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TagSelect/index.js
'use client';







var SelectOptionType;
(function (SelectOptionType) {
    SelectOptionType[SelectOptionType["Single"] = 0] = "Single";
    SelectOptionType[SelectOptionType["Multiple"] = 1] = "Multiple";
})(SelectOptionType || (SelectOptionType = {}));
// Empty value may also refer as Select All option
var TagSelect_EMPTY_VALUE_ID = constants/* SELECT_EMPTY_OPTION_ID */.WR;
/**
 * TagSelect Component
 *
 * @param props
 */
var TagSelect = function (props) {
    var title = props.title, _a = props.options, options = _a === void 0 ? [] : _a, defaultLabel = props.defaultLabel, onSelected = props.onSelected, _b = props.mode, mode = _b === void 0 ? SelectOptionType.Single : _b;
    var propValue = props.value;
    var initValue = propValue || TagSelect_EMPTY_VALUE_ID;
    var prevPropValue = (0,hooks/* usePrevious */.D9)(propValue);
    var _c = (0,react.useState)(initValue), value = _c[0], setValue = _c[1];
    (0,react.useEffect)(function () {
        if (propValue !== prevPropValue && propValue !== value) {
            setValue(propValue);
        }
    }, [prevPropValue, propValue, value]);
    var handleOptionSelected = function (selectedOption) {
        var _selectValue = TagSelect_EMPTY_VALUE_ID;
        if (mode === SelectOptionType.Single) {
            _selectValue = selectedOption.id;
        }
        if (mode === SelectOptionType.Multiple) {
            _selectValue = (0,_tslib/* __spreadArray */.ev)([], value, true);
            if (_selectValue.includes(selectedOption.id)) {
                // remove
                _selectValue = _selectValue.filter(function (_item) { return _item !== selectedOption.id; });
            }
            else {
                _selectValue.push(selectedOption.id);
            }
        }
        setValue(_selectValue);
        onSelected && onSelected(_selectValue);
    };
    var selectOptions = options;
    if (defaultLabel) {
        if (mode === SelectOptionType.Single) {
            selectOptions = (0,_tslib/* __spreadArray */.ev)([
                {
                    id: TagSelect_EMPTY_VALUE_ID,
                    name: defaultLabel
                }
            ], options, true);
        }
    }
    return (react.createElement(TagSelect_css_Wrapper, null,
        title ? react.createElement(TagSelect_css_Title, null, title) : null,
        react.createElement(Block, null, selectOptions.map(function (option) {
            var isSelected = false;
            var _key = "option-".concat(option.id);
            if (mode === SelectOptionType.Single) {
                isSelected = value === option.id;
            }
            else {
                if (typeof value === 'object') {
                    var _arrayValue = value;
                    _key = "".concat(option.id, "-").concat(_arrayValue.join('_'), "-").concat(_arrayValue.length);
                    isSelected = _arrayValue.includes(option.id);
                }
                else {
                    isSelected = value === option.id;
                }
            }
            return (react.createElement(Tag, { key: _key, isSelected: isSelected, onClick: function () { return handleOptionSelected(option); }, title: option.name }, option.name));
        }))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/styledCss.js
var styledCss = __webpack_require__(79962);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/index.css.js
'use client';





styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_1 || (index_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: rgba(0, 0, 0, 0.3);\n    display: ", ";\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    z-index: 99;\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    right: -1px;\n    border-radius: 12px;\n"], ["\n    background-color: rgba(0, 0, 0, 0.3);\n    display: ", ";\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    z-index: 99;\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    right: -1px;\n    border-radius: 12px;\n"])), function (_a) {
    var isDisplay = _a.isDisplay;
    return (isDisplay ? 'flex' : 'none');
});
var WarpBody = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_2 || (index_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        padding: 24px;\n        gap: 16px;\n        flex-direction: column;\n        align-items: center;\n    "], ["\n        display: flex;\n        padding: 24px;\n        gap: 16px;\n        flex-direction: column;\n        align-items: center;\n    "]))),
    HeaderTab: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_3 || (index_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: grid;\n        grid-template-columns: repeat(", ", 1fr);\n        align-items: start;\n        align-content: center;\n        justify-content: center;\n        padding: 0px 16px;\n    "], ["\n        display: grid;\n        grid-template-columns: repeat(", ", 1fr);\n        align-items: start;\n        align-content: center;\n        justify-content: center;\n        padding: 0px 16px;\n    "])), function (props) { return (3 - (props.hiddenStep || 0)); }),
    Tab: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_7 || (index_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        gap: 16px;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        justify-content: center;\n        color: #616161;\n        font-weight: ", ";\n        ", "\n        span {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 32px;\n            height: 32px;\n            border: 1px solid #838da3;\n            border-radius: 50%;\n            text-align: center;\n            ", "\n        }\n\n        p {\n            margin: 0;\n            padding: 0;\n            color: ", ";\n        }\n    "], ["\n        display: flex;\n        gap: 16px;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        justify-content: center;\n        color: #616161;\n        font-weight: ", ";\n        ", "\n        span {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 32px;\n            height: 32px;\n            border: 1px solid #838da3;\n            border-radius: 50%;\n            text-align: center;\n            ", "\n        }\n\n        p {\n            margin: 0;\n            padding: 0;\n            color: ", ";\n        }\n    "])), function (_a) {
        var actived = _a.actived;
        return (actived ? 600 : 400);
    }, function (_a) {
        var isMobile = _a.isMobile;
        if (!isMobile) {
            return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_4 || (index_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    padding: 16px 16px 0 16px;\n                "], ["\n                    padding: 16px 16px 0 16px;\n                "])));
        }
        else {
            return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_5 || (index_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    padding: 8px 8px 0 8px;\n                    font-size: 14px;\n                "], ["\n                    padding: 8px 8px 0 8px;\n                    font-size: 14px;\n                "])));
        }
    }, function (_a) {
        var actived = _a.actived;
        return actived
            ? (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_6 || (index_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                          color: #ffffff;\n                          background: #616161;\n                      "], ["\n                          color: #ffffff;\n                          background: #616161;\n                      "]))) : "";
    }, function (_a) {
        var tabStatus = _a.tabStatus;
        return (tabStatus ? '#005AFF' : '#616161');
    }),
    UploadCV: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_8 || (index_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        margin-top: 16px;\n        input {\n            display: none;\n        }\n    "], ["\n        width: 100%;\n        margin-top: 16px;\n        input {\n            display: none;\n        }\n    "]))),
    UploadSection: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_10 || (index_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        width: 100%;\n        border: 1px dashed #939393;\n        border-radius: 6px;\n        background-color: #f9f9f9;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        text-align: center;\n        ", "\n        ", "\n    "], ["\n        display: flex;\n        width: 100%;\n        border: 1px dashed #939393;\n        border-radius: 6px;\n        background-color: #f9f9f9;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        text-align: center;\n        ", "\n        ", "\n    "])), function (_a) {
        var isMobile = _a.isMobile;
        return "\n\t\t\tpadding: ".concat(isMobile ? "80px 10% 60px" : '0 60px', ";\n\t\t\theight: ").concat(isMobile ? 'auto' : '401px', ";\n\t\t");
    }, function (_a) {
        var isDragOver = _a.isDragOver;
        return isDragOver
            ? (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_9 || (index_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      border: 1px dashed #ff7d55;\n                      background-color: rgba(255, 153, 0, 0.12);\n                  "], ["\n                      border: 1px dashed #ff7d55;\n                      background-color: rgba(255, 153, 0, 0.12);\n                  "]))) : '';
    }),
    Title: styled_components_browser_esm/* default.p */.ZP.p(index_css_templateObject_11 || (index_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 30px;\n        line-height: 24px;\n        color: #777;\n        margin-top: 30px;\n        margin-bottom: 0;\n        text-align: center;\n    "], ["\n        font-size: 30px;\n        line-height: 24px;\n        color: #777;\n        margin-top: 30px;\n        margin-bottom: 0;\n        text-align: center;\n    "]))),
    SubTitle: styled_components_browser_esm/* default.p */.ZP.p(index_css_templateObject_12 || (index_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 14px;\n        line-height: 20px;\n        color: #333;\n        margin: 18px 0;\n        font-weight: 500;\n\n        &.fileName {\n            margin-bottom: 0;\n        }\n\n        &.fileSize {\n            margin-top: 4px;\n            font-weight: 700;\n        }\n\n        &.changeFile {\n            cursor: pointer;\n        }\n    "], ["\n        font-size: 14px;\n        line-height: 20px;\n        color: #333;\n        margin: 18px 0;\n        font-weight: 500;\n\n        &.fileName {\n            margin-bottom: 0;\n        }\n\n        &.fileSize {\n            margin-top: 4px;\n            font-weight: 700;\n        }\n\n        &.changeFile {\n            cursor: pointer;\n        }\n    "]))),
    Description: styled_components_browser_esm/* default.p */.ZP.p(index_css_templateObject_13 || (index_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 14px;\n        line-height: 20px;\n        color: #333;\n        margin: 18px 0;\n\n        &.error {\n            color: #f85a5a;\n        }\n    "], ["\n        font-size: 14px;\n        line-height: 20px;\n        color: #333;\n        margin: 18px 0;\n\n        &.error {\n            color: #f85a5a;\n        }\n    "])))
};
var Contact = {
    Section: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_14 || (index_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n    "], ["\n        width: 100%;\n    "]))),
    SectionWrapper: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_17 || (index_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        ", "\n    "], ["\n        ", "\n    "])), function (_a) {
        var isMobile = _a.isMobile;
        if (!isMobile) {
            return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_15 || (index_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    height: 391px;\n                    overflow-y: auto;\n                    padding-right: 8px;\n                    ", "\n                "], ["\n                    height: 391px;\n                    overflow-y: auto;\n                    padding-right: 8px;\n                    ", "\n                "])), styledCss/* default.scrollbar */.ZP.scrollbar);
        }
        else {
            return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_16 || (index_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
        }
    }),
    Form: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_18 || (index_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-direction: column;\n        grid-gap: 24px;\n        gap: 24px;\n    "], ["\n        display: flex;\n        flex-direction: column;\n        grid-gap: 24px;\n        gap: 24px;\n    "]))),
    Label: styled_components_browser_esm/* default.span */.ZP.span(index_css_templateObject_19 || (index_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-bottom: 4px;\n        font-weight: 500;\n        display: inline-block;\n    "], ["\n        margin-bottom: 4px;\n        font-weight: 500;\n        display: inline-block;\n    "]))),
    Star: styled_components_browser_esm/* default.span */.ZP.span(index_css_templateObject_20 || (index_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        color: #f85a5a;\n        display: inline-block;\n        margin-right: 4px;\n    "], ["\n        color: #f85a5a;\n        display: inline-block;\n        margin-right: 4px;\n    "]))),
    RadioGroup: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_21 || (index_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n    "], ["\n        display: flex;\n    "])))
};
var Working = {
    Section: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_22 || (index_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        display: block;\n    "], ["\n        width: 100%;\n        display: block;\n    "]))),
    Title: styled_components_browser_esm/* default.p */.ZP.p(index_css_templateObject_23 || (index_css_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 15px;\n        line-height: 20px;\n        margin: 16px 0 12px;\n        color: #333;\n        font-weight: 500;\n    "], ["\n        font-size: 15px;\n        line-height: 20px;\n        margin: 16px 0 12px;\n        color: #333;\n        font-weight: 500;\n    "])))
};
var Footer = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_24 || (index_css_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        border-top: 1px solid #f1f1f1;\n        color: #005aff;\n    "], ["\n        width: 100%;\n        border-top: 1px solid #f1f1f1;\n        color: #005aff;\n    "]))),
    Tab: styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_28 || (index_css_templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        padding: 24px;\n        align-items: center;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 14px;\n        display: flex;\n\n        ", "\n\n        div.goBack {\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n            svg path {\n                fill: #005aff;\n            }\n\n            :hover {\n                color: #ff7d55;\n                svg path {\n                    fill: #ff7d55;\n                }\n            }\n        }\n    "], ["\n        width: 100%;\n        padding: 24px;\n        align-items: center;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 14px;\n        display: flex;\n\n        ", "\n\n        div.goBack {\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n            svg path {\n                fill: #005aff;\n            }\n\n            :hover {\n                color: #ff7d55;\n                svg path {\n                    fill: #ff7d55;\n                }\n            }\n        }\n    "])), function (_a) {
        var tab = _a.tab;
        switch (tab) {
            case 1:
                return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_25 || (index_css_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        justify-content: flex-end;\n                        cursor: pointer;\n                    "], ["\n                        justify-content: flex-end;\n                        cursor: pointer;\n                    "])));
            case 2:
            case 3:
                return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_26 || (index_css_templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        justify-content: space-between;\n                    "], ["\n                        justify-content: space-between;\n                    "])));
            default:
                return (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_27 || (index_css_templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
        }
    })
};
var Required = styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_29 || (index_css_templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    font-style: italic;\n    span {\n        color: #f85a5a;\n    }\n"], ["\n    font-size: 12px;\n    font-style: italic;\n    span {\n        color: #f85a5a;\n    }\n"])));
styled_components_browser_esm/* default.div */.ZP.div(index_css_templateObject_32 || (index_css_templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 20px;\n    color: #6fb920;\n    background-color: hsla(88, 52%, 89%, 0.8);\n    border: 1px solid #a8db82;\n    padding: 16px;\n    border-radius: 4px;\n    margin: 16px 0 0;\n\n    ", "\n"], ["\n    font-size: 14px;\n    line-height: 20px;\n    color: #6fb920;\n    background-color: hsla(88, 52%, 89%, 0.8);\n    border: 1px solid #a8db82;\n    padding: 16px;\n    border-radius: 4px;\n    margin: 16px 0 0;\n\n    ", "\n"])), function (_a) {
    var isUploaded = _a.isUploaded;
    return isUploaded
        ? (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_30 || (index_css_templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""]))) : (0,styled_components_browser_esm/* css */.iv)(index_css_templateObject_31 || (index_css_templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  display: flex;\n              "], ["\n                  display: flex;\n              "])));
});
var index_css_templateObject_1, index_css_templateObject_2, index_css_templateObject_3, index_css_templateObject_4, index_css_templateObject_5, index_css_templateObject_6, index_css_templateObject_7, index_css_templateObject_8, index_css_templateObject_9, index_css_templateObject_10, index_css_templateObject_11, index_css_templateObject_12, index_css_templateObject_13, index_css_templateObject_14, index_css_templateObject_15, index_css_templateObject_16, index_css_templateObject_17, index_css_templateObject_18, index_css_templateObject_19, index_css_templateObject_20, index_css_templateObject_21, index_css_templateObject_22, index_css_templateObject_23, index_css_templateObject_24, index_css_templateObject_25, index_css_templateObject_26, index_css_templateObject_27, index_css_templateObject_28, index_css_templateObject_29, index_css_templateObject_30, index_css_templateObject_31, index_css_templateObject_32;


//# sourceMappingURL=index.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/translations.js
'use client';

var UploadResumeModal_translations_translations = {
    'Cập nhật': 'Update',
    'Cập nhật ngay thông tin hồ sơ để Nhà tuyển dụng có thể dễ dàng tìm tiếm và chủ động liên hệ với bạn.': 'Update your profile so that Employers can easily find and actively contact you.',
    'Hồ sơ đính kèm của bạn': 'Your Attached CV',
    'Tải Hồ Sơ': 'Attached CV',
    'Hoàn Chỉnh Hồ Sơ': 'Working Preference',
    'Thông tin liên hệ': 'Contact information',
    'Nhập chức danh': 'Enter job title',
    'Chọn hồ sơ': 'Choose upload file',
    'Tải lên thành công': 'Upload successful',
    'Tải lên thất bại': 'Upload failed',
    'Vui lòng chọn tập tin đính kèm với định dạng .doc, .docx, .pdf nhỏ hơn 5120KB.': 'You can attach .doc, .docx, and .pdf files that are less than 5120KB in size.',
    'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB': '.doc, .docx and .pdf files that are less than 5120KB in size',
    'Đây là thông tin bắt buộc': 'This is a required field',
    'Không có kết quả': 'No result',
    'Cập nhật hồ sơ': 'Update',
    'Không thể cập nhật hồ sơ của bạn': "Can't update your resume",
    'Lỗi ': 'Error',
    'Không thể cập nhật thông tin!': "Can't update your information!",
    'Thành công': 'Successful',
    'Bỏ qua bước này': 'Skip this step',
    'Chọn hồ sơ từ máy bạn': 'Choose file to upload',
    'Hoặc bạn có thể': 'Or you can',
    'Kéo hồ sơ của bạn vào đây': 'Drag your CV here',
    'Hồ sơ của bạn đã được tải lên thành công!': 'Your CV has been uploaded successfully!',
    'Chức danh hiện tại': 'Your Job Title',
    Năm: 'Years',
    'Thông tin bắt buộc': 'This field is required',
    'Vui lòng nhập trường này': 'This field is required',
    'Nơi làm việc mong muốn': 'Places You Want To Work',
    'Ngành nghề mong muốn': 'Job Function You Want To Get Jobs',
    'Bạn chỉ có thể chọn tối đa 3 địa điểm': 'You can only choose maximum 3 locations',
    'Chọn địa điểm': 'Select location',
    'Chọn ngành nghề': 'Select job category',
    'Thông tin được tự động điền cho bạn nếu có thể.': 'Information is parsed and filled in for you automatically if possible.',
    'Trình độ học vấn': 'Highest Education',
    'Mức lương mong muốn tối thiểu': 'Expected Minimum Salary',
    'Mức lương mong muốn': 'Expected Salary',
    'USD/tháng': 'USD/month',
    'Cấp bậc hiện tại': 'Your Current Job Level',
    'Vui lòng chọn ...': 'Please select ...',
    'Hồ sơ đính kèm': 'Attached CV',
    'Lưu hồ sơ': 'Save Profile',
    'Đổi tập tin': 'Change file',
    'Hủy tải tập tin': 'Cancel upload',
    'Tiếp tục': 'Next',
    'Số năm kinh nghiệm': 'Years of Experience',
    'Phiên Sử Dụng Hết Hạn': 'Session Expired',
    'Bạn vui lòng đăng nhập lại': 'Please log in again',
    'Cập nhật thông tin hồ sơ đính kèm': 'Update attachment information',
    'Cho phép tìm kiếm hồ sơ đính kèm': 'Make your attachCV searchable',
    'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email: ': 'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email: ',
    'Lĩnh vực mong muốn': 'Industries You Want To Get Jobs',
    'Thông Tin Liên Hệ của bạn đã được cập nhật thành công!': 'Your Contact Information has been updated successfully!',
    Email: 'Email',
    'Ngày sinh': 'Date of Birth',
    'Ví dụ: 23/09/1990': 'e.g. 23/09/1990',
    'Giới tính': 'Gender',
    'Quốc gia': 'Country',
    'Chọn quốc gia': 'Select a country',
    'Quận/Huyện': 'District',
    'Địa chỉ': 'Address',
    'Điện thoại': 'Cell Number',
    'Quốc tịch': 'Nationality',
    'Tình trạng hôn nhân': 'Marital Status',
    'Tỉnh/Thành phố': 'Province/City',
    Nam: 'Male',
    Nữ: 'Female',
    'Độc thân': 'Single',
    'Đã kết hôn': 'Married',
    'Người Việt Nam': 'Local Vietnamese',
    'Người nước ngoài': 'Foreigner',
    'Chọn quốc tịch': 'Select nationality',
    'Vui lòng chọn...': 'Please select...',
    'Không Có Kết Quả Nào': 'No Result Found',
    Tìm: 'Search',
    'Bạn chưa có sẵn hồ sơ đính kèm?': "You don't have a ready attachment?",
    'Cập nhật Hồ sơ VietnamWorks': 'Update VietnamWorks Profile',
    '/ho-so': '/my-profile',
    'Vui lòng nhập thông tin.': 'This field is required.',
    'Vui lòng không nhập số hoặc kí tự đặc biệt.': 'Please do not enter numbers or special characters.',
    'Vui lòng không nhập số điện thoại hoặc email': 'Please do not enter phone number or email.',
    'Vui lòng không nhập kí tự đặc biệt.': 'Please do not enter special characters.',
    'Số điện thoại không hợp lệ': 'This is not a valid phone number',
    'Số điện thoại của bạn không hợp lệ.': 'The phone number format is invalid.'
};
var educationListVi = [
    { id: 0, name: 'Vui lòng chọn học vấn' },
    { id: 2, name: 'Trung học' },
    { id: 3, name: 'Trung cấp' },
    { id: 12, name: 'Cao đẳng' },
    { id: 4, name: 'Cử nhân' },
    { id: 5, name: 'Thạc sĩ' },
    { id: 6, name: 'Tiến sĩ' },
    { id: 11, name: 'Khác' }
];
var educationListEn = [
    { id: 0, name: 'Please select education' },
    { id: 2, name: 'High school' },
    { id: 3, name: "Associate's degree" },
    { id: 12, name: 'College' },
    { id: 4, name: 'Bachelors' },
    { id: 5, name: 'Masters' },
    { id: 6, name: 'Doctorate' },
    { id: 11, name: 'Others' }
];


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/apiServices.js
var apiServices = __webpack_require__(84214);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/constants.js
var UploadResumeModal_constants = __webpack_require__(53001);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/type.js
var type = __webpack_require__(88845);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/context/index.js
'use client';




var ResumeModalContext = (0,react.createContext)({
    t: function () { return ''; },
    lang: constants/* ELanguage.VI */.Df.VI,
    isShowLoading: false,
    setShowLoading: function () { },
    isUploading: false,
    setIsUploading: function () { },
    uploadFile: undefined,
    setUploadFile: function () { },
    step: 1,
    setStep: function () { }
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/images.js
'use client';




var IconUploadButton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 42 : _b, _c = _a.height, height = _c === void 0 ? 47 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, rest = (0,_tslib/* __rest */._T)(_a, ["width", "height", "className", "onClick"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: width, height: height, viewBox: '0 0 42 47', version: '1.1', className: className, onClick: onClick }, rest),
        react.createElement("g", { id: 'PROFILE-SETTINGS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/PROFILE-SETTINGS-SEARCHABLE-CV-POPUP', transform: 'translate(-629.000000, -294.000000)', fill: '#777777', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-32', transform: 'translate(300.000000, 85.500000)' },
                    react.createElement("g", { id: 'pages/careercenter/section-profile-attachedcv', transform: 'translate(23.000000, 85.000000)' },
                        react.createElement("g", { id: 'Group-30', transform: 'translate(100.000000, 120.581511)' },
                            react.createElement("path", { d: 'M246.534884,35.6875563 C245.704651,35.6875563 245.069767,36.3829051 245.069767,37.2922074 L245.069767,46.3852307 L208.930233,46.3852307 L208.930233,37.2922074 C208.930233,36.3829051 208.295349,35.6875563 207.465116,35.6875563 C206.634884,35.6875563 206,36.3829051 206,37.2922074 L206,47.9898819 C206,48.8991842 206.634884,49.594533 207.465116,49.594533 L246.534884,49.594533 C247.365116,49.594533 248,48.8991842 248,47.9898819 L248,37.2922074 C248,36.3829051 247.365116,35.6875563 246.534884,35.6875563 Z M228.025581,4.07592838 C227.439535,3.43406791 226.511628,3.43406791 225.974419,4.07592838 L218.648837,12.0991842 C218.062791,12.7410447 218.062791,13.7573237 218.648837,14.3456958 C219.234884,14.9875563 220.162791,14.9875563 220.7,14.3456958 L225.534884,9.05034698 L225.534884,31.9433702 C225.534884,32.8526726 226.169767,33.5480214 227,33.5480214 C227.830233,33.5480214 228.465116,32.8526726 228.465116,31.9433702 L228.465116,9.05034698 L233.3,14.3456958 C233.593023,14.6666261 233.983721,14.8270912 234.325581,14.8270912 C234.667442,14.8270912 235.05814,14.6666261 235.351163,14.3456958 C235.937209,13.7038354 235.937209,12.6875563 235.351163,12.0991842 L228.025581,4.07592838 Z', id: 'Shape' }))))))));
};


//# sourceMappingURL=images.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/context/useResumeModal.js
'use client';




var useResumeModal = function () { return (0,react.useContext)(ResumeModalContext); };


//# sourceMappingURL=useResumeModal.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/styles.css.js
var styles_css = __webpack_require__(42661);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/Components/AttachCV.js
'use client';











var AttachCV = function (_a) {
    var uploadErrorMessage = _a.uploadErrorMessage, doUploadFile = _a.doUploadFile;
    var _b = useResumeModal(), t = _b.t, setUploadFile = _b.setUploadFile, uploadFile = _b.uploadFile, isUploading = _b.isUploading, setIsUploading = _b.setIsUploading;
    var inputFileRef = (0,react.useRef)(null);
    var isMobile = !(0,helpers/* isDesktop */.nI)();
    var _c = (0,react.useState)(false), isShowUploadFileError = _c[0], setShowUploadError = _c[1];
    var _d = (0,react.useState)(false), isDragOver = _d[0], setDragOver = _d[1];
    // upload file
    var checkUploadFile = function (file) {
        var uploadFileInfo = file;
        // check file extensions
        if (!UploadResumeModal_constants/* DEFAULT_ALLOW_FILES_EXT.includes */.Ri.includes(uploadFileInfo.type)) {
            // show error file type doesn't support
            setShowUploadError(true);
            setUploadFile(undefined);
            return;
        }
        // check file size
        if (uploadFileInfo.size > UploadResumeModal_constants/* DEFAULT_LIMIT_FILE_SIZE */.hS) {
            // File is over 5MB
            setShowUploadError(true);
            setUploadFile(undefined);
            return;
        }
        // do upload file and move to next tab
        doUploadFile(uploadFileInfo);
    };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            setShowUploadError(false);
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnClickCancelUpload = function () {
        if (!isUploading) {
            return;
        }
        // cancel
        setIsUploading(false);
        setUploadFile(undefined);
        if (inputFileRef.current) {
            inputFileRef.current.files = null;
        }
    };
    var handleOnClickOpenFile = function () {
        if (isUploading) {
            return;
        }
        if (inputFileRef !== null && inputFileRef.current !== null) {
            inputFileRef.current.click();
        }
    };
    var formatFileSize = function (value) {
        var checkSize = UploadResumeModal_constants/* DEFAULT_1KB_SIZE */.al;
        var sizeText = 'KB';
        if (value >= UploadResumeModal_constants/* DEFAULT_1MB_SIZE */.QB) {
            checkSize = UploadResumeModal_constants/* DEFAULT_1MB_SIZE */.QB;
            sizeText = 'MB';
        }
        var formattedValue = value / checkSize;
        return "<b>".concat(formattedValue.toFixed(2), " ").concat(sizeText, "</b>");
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setDragOver(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setDragOver(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDragEnd = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    return (react.createElement(WarpBody.UploadCV, { onClick: handleOnClickOpenFile, onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDragEnd: handleOnDragEnd, onDrop: handleOnDrop },
        react.createElement("input", { type: 'file', accept: UploadResumeModal_constants/* DEFAULT_ALLOW_EXT */.Wx, style: { visibility: 'hidden' }, ref: inputFileRef, onChange: handleOnFileChange }),
        react.createElement(WarpBody.UploadSection, { isMobile: isMobile, isDragOver: isDragOver }, uploadFile !== undefined && uploadFile.name !== '' ? (react.createElement(react.Fragment, null,
            react.createElement(WarpBody.SubTitle, { className: 'fileName' }, uploadFile.name),
            react.createElement(WarpBody.SubTitle, { className: 'fileSize', dangerouslySetInnerHTML: { __html: formatFileSize(uploadFile.size) } }),
            react.createElement(WarpBody.SubTitle, { className: 'changeFile', onClick: handleOnClickCancelUpload }, isUploading ? t('Hủy tải tập tin') : t('Đổi tập tin')),
            uploadErrorMessage !== '' ? (react.createElement(styles_css/* ResponseMsg */.bU, { variant: 'p', name: 'body', size: 'small', isPlaceholder: true, color: Colors/* colors.error.40 */.O9.error[40] }, uploadErrorMessage)) : null)) : (react.createElement(react.Fragment, null,
            react.createElement(IconUploadButton, null),
            react.createElement(WarpBody.Title, null, t('Kéo hồ sơ của bạn vào đây')),
            react.createElement(WarpBody.SubTitle, null, t('Hoặc bạn có thể')),
            react.createElement(Button/* default */.Z, { size: 'xs', type: 'primary' }, t('Chọn hồ sơ từ máy bạn')),
            react.createElement(WarpBody.Description, { dangerouslySetInnerHTML: {
                    __html: t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB')
                } }),
            isShowUploadFileError && (react.createElement(WarpBody.Description, { className: 'error', dangerouslySetInnerHTML: {
                    __html: t('Vui lòng chọn tập tin đính kèm với định dạng .doc, .docx, .pdf nhỏ hơn 5120KB.')
                } })))))));
};


//# sourceMappingURL=AttachCV.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/index.js
var SingleRadio = __webpack_require__(12056);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/utils/index.js
'use client';



var rules = function (_a) {
    var types = _a.types, custom = _a.custom, t = _a.t;
    var fieldRules = types.map(function (type, _) {
        var _a;
        if (!type)
            return;
        switch (type) {
            case 'required':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Vui lòng nhập thông tin.') });
            case 'no-special-chars':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Vui lòng không nhập số hoặc kí tự đặc biệt.') });
            case 'no-special-chars-without-number':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Vui lòng không nhập kí tự đặc biệt.') });
            case 'no-special-chars-for-job-title':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Vui lòng không nhập kí tự đặc biệt.') });
            case 'no-number-email':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Vui lòng không nhập số điện thoại hoặc email') });
            case 'email':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('This is not a valid email address') });
            case 'number':
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Số điện thoại không hợp lệ') });
            case 'vn-phone-number': {
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Số điện thoại của bạn không hợp lệ.') });
            }
            case 'international-phone-number': {
                return (0,_tslib/* __assign */.pi)({ type: type }, { msg: t('Số điện thoại của bạn không hợp lệ.') });
            }
            case 'custom':
                if (custom === null || custom === void 0 ? void 0 : custom.validator) {
                    return (0,_tslib/* __assign */.pi)({ type: type }, { msg: (_a = custom === null || custom === void 0 ? void 0 : custom.msg) !== null && _a !== void 0 ? _a : '', validator: custom === null || custom === void 0 ? void 0 : custom.validator });
                }
                return undefined;
            default:
                return undefined;
        }
    });
    return fieldRules && fieldRules.length > 0 ? fieldRules : undefined;
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/index.js + 11 modules
var Calendar = __webpack_require__(21810);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/styles.css.js
var DatePicker_styles_css = __webpack_require__(1620);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Calendar/types.js
var Calendar_types = __webpack_require__(36433);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/type.js
var DatePicker_type = __webpack_require__(46685);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/utils/dateTimeFormat.js + 1 modules
var dateTimeFormat = __webpack_require__(9865);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/Calendar/Calendar.js
var Calendar_Calendar = __webpack_require__(43762);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DateInput.tsx/index.js + 2 modules
var DateInput_tsx = __webpack_require__(70034);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDropdownAnimation.js
var useDropdownAnimation = __webpack_require__(91623);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/components/DatePicker.js
'use client';


















function DatePicker(_a) {
    var defaultDate = _a.defaultDate, onChangeProps = _a.onChange, _b = _a.min, min = _b === void 0 ? new Date(1900, 0, 1) : _b, max = _a.max, _c = _a.type, type = _c === void 0 ? DatePicker_type/* EDatePicker.date */.f.date : _c, placeholder = _a.placeholder, _d = _a.hasError, hasError = _d === void 0 ? false : _d, onBlur = _a.onBlur, onFocus = _a.onFocus, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.langCode, langCode = _f === void 0 ? constants/* ELanguage.EN */.Df.EN : _f, calendarConfig = _a.calendarConfig, _g = _a.isFlip, isFlip = _g === void 0 ? false : _g, _h = _a.isShowIcon, isShowIcon = _h === void 0 ? true : _h, present = _a.present;
    var _j = calendarConfig || {}, floatingConfig = _j.floatingConfig, _k = _j.placement, placement = _k === void 0 ? 'bottom-start' : _k, _l = _j.dropdownOffset, dropdownOffset = _l === void 0 ? 0 : _l;
    var _m = (0,react.useState)(defaultDate), date = _m[0], setDate = _m[1];
    var inputValue = date && (0,dateTimeFormat/* datetimeFormat */._I)(date, type);
    var _o = (0,react.useState)(false), showCalendar = _o[0], setShowCalendar = _o[1];
    var _p = (0,react.useState)(present === null || present === void 0 ? void 0 : present.defaultCheck), isCheckPresent = _p[0], setCheckPresent = _p[1];
    var presentText = (present === null || present === void 0 ? void 0 : present.text) ? present === null || present === void 0 ? void 0 : present.text : langCode === constants/* ELanguage.EN */.Df.EN ? 'Present' : 'Hiện tại';
    var presentLabelText = langCode === constants/* ELanguage.EN */.Df.EN ? 'Current' : 'Hiện tại';
    var _q = (0,useFloating/* default */.Z)({
        placement: placement,
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: {
            offset: dropdownOffset,
            detectHidden: true,
            useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false,
            isFlip: isFlip
        }
    }), refs = _q.refs, context = _q.context, FloatingPortal = _q.FloatingPortal;
    (0,useClickAway/* default */.Z)(function () {
        setShowCalendar(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    var _r = (0,useDropdownAnimation/* default */.Z)(showCalendar, context.placement), isMounted = _r.isMounted, dropdownStyles = _r.styles;
    var onCheckPresent = function (isChecked) {
        setCheckPresent(isChecked);
        present && present.onCheck(isChecked);
    };
    var onShowCalendar = function () {
        if (disabled)
            return;
        setShowCalendar(function (state) { return !state; });
    };
    var onChange = function (date) {
        if (date !== null) {
            onCheckPresent(false);
        }
        var timer = null;
        timer && clearTimeout(timer);
        if ((date && min && min > new Date(date)) || (date && max && max < new Date(date))) {
            onChangeProps && onChangeProps(null);
            setDate(null);
            setShowCalendar(false);
            return;
        }
        timer = setTimeout(function () {
            setDate(date);
            onChangeProps && onChangeProps(date);
            if (date instanceof Date) {
                setShowCalendar(false);
            }
        }, 0);
    };
    var onKeyDown = function (e) {
        if (e.key === 'Tab' || e.code === 'Tab') {
            setShowCalendar(false);
            onBlur && onBlur();
        }
    };
    /*
     * Update date after defaultDate updated
     * */
    (0,react.useEffect)(function () {
        // check invalid date, if not return null
        if (defaultDate) {
            var newDate = !isNaN(new Date(defaultDate).getTime()) ? new Date(defaultDate) : null;
            setDate(newDate);
        }
        else {
            setDate(null);
        }
    }, [defaultDate]);
    /*
     * Set default check present
     * */
    (0,react.useEffect)(function () {
        setCheckPresent(present === null || present === void 0 ? void 0 : present.defaultCheck);
    }, [present === null || present === void 0 ? void 0 : present.defaultCheck]);
    return (react.createElement(DatePicker_styles_css/* PickerContainer */.U1, null,
        react.createElement(DatePicker_styles_css/* InputWrap */.Rd, { ref: refs.setReference, onKeyDown: onKeyDown },
            react.createElement(DateInput_tsx/* default */.Z, { type: type, value: isCheckPresent ? presentText : inputValue, placeholder: placeholder, onChange: onChange, onBlur: function (value) {
                    var isValid = value && (0,dateTimeFormat/* isValidDateFormat */.Gt)(value, type);
                    if (!isValid) {
                        setDate(null);
                    }
                }, onFocus: function () {
                    setShowCalendar(true);
                    onFocus && onFocus();
                }, disabled: disabled, hasError: hasError, min: min, max: max, isShowIcon: isShowIcon, isPresent: isCheckPresent }),
            isShowIcon && (react.createElement(DatePicker_styles_css/* Icon */.JO, { isIcon: true, onClick: onShowCalendar, position: 'absolute', outline: 'none' },
                react.createElement(Calendar_Calendar/* CalendarIcon */.Q, { size: 20 })))),
        isMounted ? (react.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
            react.createElement(DatePicker_styles_css/* Wrapper */.im, { ref: refs.setPopup, style: {
                    position: context.position,
                    left: context.x,
                    top: context.y,
                    display: context.isReferenceHidden ? 'none' : 'block'
                } },
                react.createElement("div", { style: dropdownStyles },
                    react.createElement(Calendar/* default */.ZP, { langCode: langCode, initDates: date ? [date] : null, min: min, max: max, type: (0,dateTimeFormat/* calendarType */.NW)(type), pickerType: Calendar_types/* ECalendarStyle.single */.w.single, calendarStyle: Calendar_types/* ECalendarStyle.single */.w.single, handleDateClick: function (dates) {
                            if (dates && dates.length > 0) {
                                onChange(dates[0]);
                                return;
                            }
                            onChange(null);
                        }, disabled: isCheckPresent }),
                    (present === null || present === void 0 ? void 0 : present.isShow) && (react.createElement(DatePicker_styles_css/* Present */.Rc, null,
                        react.createElement(SingleCheckBox/* default */.Z, { id: 'present', label: presentLabelText, onChecked: function (value) { return onCheckPresent(!!value); }, isChecked: isCheckPresent, isLeftCheckbox: true, hoverBgOff: true }))))))) : null));
}


//# sourceMappingURL=DatePicker.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Form/index.js + 21 modules
var Form = __webpack_require__(83948);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/Components/ContactInfo.js
'use client';




























var ContactInfo = function (_a, ref) {
    var formData = _a.formData, baseApiUrl = _a.baseApiUrl, nationalityOptions = _a.nationalityOptions, countryOptions = _a.countryOptions, cityOptions = _a.cityOptions, districtOptions = _a.districtOptions, accessToken = _a.accessToken, apiGetUserContactInfo = _a.apiGetUserContactInfo, setContactInfo = _a.setContactInfo, checkDoneStep = _a.checkDoneStep;
    var _b = useResumeModal(), t = _b.t, lang = _b.lang, setStep = _b.setStep, setShowLoading = _b.setShowLoading;
    var isMobileScreenSize = (0,helpers/* isMobile */.tq)();
    var formRef = (0,react.useRef)(null);
    var i11lPhoneNumberRef = (0,react.useRef)(null);
    var onSubmit = function () {
        if (formRef.current) {
            // formRef.current.requestSubmit()
            formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    var handleUpdateContactInfo = function (data) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var body, update, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, data), { cityId: data.countryId !== UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb ? UploadResumeModal_constants/* INTERNATIONAL_CITY_ID */.F6 : data.cityId, districtId: data.cityId === UploadResumeModal_constants/* INTERNATIONAL_CITY_ID */.F6 || data.countryId !== UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb ? 0 : data.districtId });
                    /*
                     * Set contact info back to global data
                     * */
                    setContactInfo(body);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setShowLoading(true);
                    return [4 /*yield*/, (0,apiServices/* updateUserContactInfo */.$N)({
                            accessToken: accessToken || '',
                            url: "".concat(baseApiUrl).concat(apiGetUserContactInfo),
                            data: body
                        })];
                case 2:
                    update = _a.sent();
                    setShowLoading(false);
                    if (update.data) {
                        setStep(3);
                        checkDoneStep && checkDoneStep(2);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('save form contact info: ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getLocalizedOptions = function (data) {
        if (data === void 0) { data = []; }
        return (data || []).map(function (_a) {
            var id = _a.id, name = _a.name, nameEn = _a.nameEn;
            return ({
                id: id,
                name: lang === constants/* ELanguage.EN */.Df.EN ? nameEn : name
            });
        });
    };
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth();
    var date = today.getDate();
    var maxDate = new Date(year, month, date, 23, 59, 59);
    return (react.createElement(Contact.Section, null,
        react.createElement(Contact.SectionWrapper, { isMobile: isMobileScreenSize },
            react.createElement(Working.Title, null, t('Thông tin được tự động điền cho bạn nếu có thể.')),
            react.createElement(Form/* default */.Z, { key: "key-".concat(JSON.stringify(formData)), ref: formRef, initialValues: formData, requestScrollToFirstErrorElement: true, onSubmit: function (values) { return handleUpdateContactInfo(values); } },
                react.createElement("button", { hidden: true, type: 'submit' }, "button"),
                react.createElement(Contact.Form, null,
                    react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'email', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null, t('Email')),
                                react.createElement(components_Input/* default */.Z, { type: 'text', value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError, disabled: true }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        }),
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'phone', rules: rules({
                                types: ['required', 'international-phone-number', 'vn-phone-number'],
                                t: t
                            }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Điện thoại')),
                                react.createElement(I11lPhoneNumberInput/* default */.Z, { value: field.value, hasError: field.isError, onChange: field.onChange, onBlur: field.onBlur, urlMeta: "".concat(baseApiUrl).concat(UploadResumeModal_constants/* META_API_LINK */.jY), language: lang, ref: i11lPhoneNumberRef, floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    } }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        })),
                    react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'birthday', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Ngày sinh')),
                                react.createElement(DatePicker, { type: DatePicker_type/* EDatePicker.date */.f.date, langCode: lang, defaultDate: field.value, onChange: function (value) {
                                        field.onChange(value);
                                    }, hasError: field.isError, onBlur: function () {
                                        field.onBlur();
                                    }, max: maxDate, calendarConfig: {
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        }),
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'nationalityId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Quốc tịch')),
                                react.createElement(MultipleRadio/* default */.Z, { options: nationalityOptions !== null && nationalityOptions !== void 0 ? nationalityOptions : [], name: 'nationalityId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, hasError: field.isError, onBlur: field.onBlur }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        })),
                    react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'genderId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Giới tính')),
                                react.createElement(Contact.RadioGroup, null,
                                    react.createElement(SingleRadio/* default */.Z, { id: 'gender-male', label: t('Nam'), onChange: function (value) {
                                            field.onChange(1);
                                        }, name: '', isLeftRadio: true, checked: field.value === 1, width: 'fit-content' }),
                                    react.createElement(SingleRadio/* default */.Z, { id: 'gender-female', label: t('Nữ'), onChange: function (value) { return field.onChange(2); }, name: 'gender', isLeftRadio: true, checked: field.value === 2, width: 'fit-content' })),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        }),
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'maritalStatusId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Tình trạng hôn nhân')),
                                react.createElement(Contact.RadioGroup, null,
                                    react.createElement(SingleRadio/* default */.Z, { id: 'marital-status-single', label: t('Độc thân'), onChange: function () { return field.onChange(type/* EMaritalStatus.SINGLE */.oj.SINGLE); }, name: 'marital-status', isLeftRadio: true, checked: field.value === type/* EMaritalStatus.SINGLE */.oj.SINGLE, width: 'fit-content' }),
                                    react.createElement(SingleRadio/* default */.Z, { id: 'marital-status-married', label: t('Đã kết hôn'), onChange: function () { return field.onChange(type/* EMaritalStatus.MARRIED */.oj.MARRIED); }, name: 'marital-status', isLeftRadio: true, checked: field.value === type/* EMaritalStatus.MARRIED */.oj.MARRIED, width: 'fit-content' })),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        })),
                    react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'countryId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Quốc gia')),
                                react.createElement(MultipleRadio/* default */.Z, { options: countryOptions !== null && countryOptions !== void 0 ? countryOptions : [], name: 'countryId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) {
                                        field.onChange(item.value);
                                        if (item.value !== UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) {
                                            field.setFieldValue('cityId', UploadResumeModal_constants/* INTERNATIONAL_CITY_ID */.F6);
                                            return;
                                        }
                                        field.setFieldValue('cityId', undefined);
                                    }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        }),
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'cityId', watch: ['countryId'], rules: [
                                {
                                    type: 'custom',
                                    validator: function (value, watch) {
                                        if (!value && (watch === null || watch === void 0 ? void 0 : watch.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) {
                                            return false;
                                        }
                                        return true;
                                    },
                                    msg: t('Vui lòng nhập thông tin.')
                                }
                            ] }, function (field) {
                            var _a, _b, _c;
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb }, t('Tỉnh/Thành phố')),
                                react.createElement(MultipleRadio/* default */.Z, { options: cityOptions !== null && cityOptions !== void 0 ? cityOptions : [], name: 'cityId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) {
                                        field.setFieldValue('districtId', undefined);
                                        field.onChange(item.value);
                                    }, onBlur: field.onBlur, disable: !(((_b = field === null || field === void 0 ? void 0 : field.watch) === null || _b === void 0 ? void 0 : _b.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb), hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                react.createElement(Form/* default.Error */.Z.Error, { disable: !(((_c = field === null || field === void 0 ? void 0 : field.watch) === null || _c === void 0 ? void 0 : _c.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) })));
                        })),
                    react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'districtId', watch: ['countryId', 'cityId'], rules: [
                                {
                                    type: 'custom',
                                    validator: function (value, watch) {
                                        var isCheckCityId = UploadResumeModal_constants/* notAllowCityId.includes */.I6.includes(watch === null || watch === void 0 ? void 0 : watch.cityId);
                                        if (watch.countryId !== UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb || isCheckCityId) {
                                            return true;
                                        }
                                        if (!value && !isCheckCityId && watch.countryId === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) {
                                            return false;
                                        }
                                        return true;
                                    },
                                    msg: t('Vui lòng nhập thông tin.')
                                }
                            ] }, function (field) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb &&
                                        !UploadResumeModal_constants/* notAllowCityId.includes */.I6.includes((_b = field.watch) === null || _b === void 0 ? void 0 : _b.cityId) }, t('Quận/Huyện')),
                                react.createElement(MultipleRadio/* default */.Z, { options: ((_c = field.watch) === null || _c === void 0 ? void 0 : _c.cityId) && districtOptions
                                        ? getLocalizedOptions(districtOptions["".concat(Number((_d = field.watch) === null || _d === void 0 ? void 0 : _d.cityId))])
                                        : [], name: 'District', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    }, disable: !(((_e = field.watch) === null || _e === void 0 ? void 0 : _e.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) ||
                                        UploadResumeModal_constants/* notAllowCityId.includes */.I6.includes((_f = field.watch) === null || _f === void 0 ? void 0 : _f.cityId) }),
                                react.createElement(Form/* default.Error */.Z.Error, { disable: !(((_g = field.watch) === null || _g === void 0 ? void 0 : _g.countryId) === UploadResumeModal_constants/* VIETNAM_COUNTRY_ID */.Jb) ||
                                        UploadResumeModal_constants/* notAllowCityId.includes */.I6.includes((_h = field.watch) === null || _h === void 0 ? void 0 : _h.cityId) })));
                        }),
                        react.createElement(Form/* default.Item */.Z.Item, { name: 'address' }, function (field) {
                            return (react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                                react.createElement(Form/* default.Label */.Z.Label, null,
                                    " ",
                                    t('Địa chỉ')),
                                react.createElement(components_Input/* default */.Z, { type: 'text', value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError }),
                                react.createElement(Form/* default.Error */.Z.Error, null)));
                        })),
                    react.createElement(Row/* default */.Z, null,
                        react.createElement(Col/* default */.Z, null,
                            react.createElement(Required, null,
                                react.createElement("span", null, "*"),
                                " ",
                                t('Thông tin bắt buộc')))))))));
};
var ContactInfo$1 = react.forwardRef(ContactInfo);


//# sourceMappingURL=ContactInfo.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CompanyIndustry/index.js + 1 modules
var CompanyIndustry = __webpack_require__(21319);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultipleSelect/index.js + 2 modules
var MultipleSelect = __webpack_require__(42865);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobFunction/index.js + 1 modules
var JobFunction = __webpack_require__(53704);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/Components/WorkingReference.js
'use client';























var WorkingReference = function (_a, ref) {
    var _b = _a.isReloadOnClose, isReloadOnClose = _b === void 0 ? true : _b, baseApiUrl = _a.baseApiUrl, apiAutoCompleteJobTitle = _a.apiAutoCompleteJobTitle, apiGetJobLevelList = _a.apiGetJobLevelList, accessToken = _a.accessToken, jobLocationOptions = _a.jobLocationOptions, formData = _a.formData, jobIndustryOptions = _a.jobIndustryOptions, checkBeforeSubmitForm = _a.checkBeforeSubmitForm, handleClosePopup = _a.handleClosePopup, apiUpdateResume = _a.apiUpdateResume, logoutUrl = _a.logoutUrl, resumeId = _a.resumeId, setWorkingPreferenceData = _a.setWorkingPreferenceData, _c = _a.jobFunctionOptions, jobFunctionOptions = _c === void 0 ? {
        parent: [],
        child: {}
    } : _c, checkDoneStep = _a.checkDoneStep;
    var _d = useResumeModal(), t = _d.t, lang = _d.lang, step = _d.step, setShowLoading = _d.setShowLoading;
    var isMobile = !(0,helpers/* isDesktop */.nI)();
    var formRef = (0,react.useRef)(null);
    var _e = (0,react.useState)(), jobsTitleRecommend = _e[0], setJobsTitleRecommend = _e[1];
    var _f = (0,react.useState)([]), jobsLevel = _f[0], setJobsLevel = _f[1];
    var eventTimeout;
    var currentValue;
    var handleDebounceChangeEvent = function (value) {
        if (eventTimeout) {
            clearTimeout(eventTimeout);
            eventTimeout = null;
        }
        currentValue = value;
        var getRecommendJobTitle = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var autoCompleteResponse, recommendList, mappedList_1, error_1;
            var _a, _b, _c;
            return (0,_tslib/* __generator */.Jh)(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (currentValue !== value) {
                            setJobsTitleRecommend(undefined);
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0,apiServices/* autoCompleteJobTitle */.e2)("".concat(baseApiUrl).concat(apiAutoCompleteJobTitle), value, accessToken)];
                    case 2:
                        autoCompleteResponse = _d.sent();
                        recommendList = (_c = (_b = (_a = autoCompleteResponse === null || autoCompleteResponse === void 0 ? void 0 : autoCompleteResponse.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.suggestJobTitle) !== null && _c !== void 0 ? _c : [];
                        if (recommendList.length > 0) {
                            mappedList_1 = [];
                            recommendList.map(function (item, index) {
                                mappedList_1.push({
                                    id: index,
                                    name: item
                                });
                            });
                            setJobsTitleRecommend(mappedList_1);
                            return [2 /*return*/];
                        }
                        setJobsTitleRecommend([]);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        setJobsTitleRecommend([]);
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        eventTimeout = setTimeout(getRecommendJobTitle, 500);
    };
    var doGetJobLevelList = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var getJobLevelListRespone, returnJobLevelList_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (jobsLevel.length > 0) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, (0,apiServices/* getJobLevelList */.e1)(apiGetJobLevelList)];
                case 1:
                    getJobLevelListRespone = _a.sent();
                    if (getJobLevelListRespone.data !== undefined &&
                        getJobLevelListRespone.data.relationships !== undefined &&
                        getJobLevelListRespone.data.relationships.data !== undefined) {
                        returnJobLevelList_1 = [];
                        getJobLevelListRespone.data.relationships.data.map(function (item) {
                            returnJobLevelList_1.push({
                                id: item.id,
                                name: lang === constants/* ELanguage.EN */.Df.EN ? item.attributes.nameEn : item.attributes.nameVi
                            });
                        });
                        setJobsLevel(returnJobLevelList_1);
                    }
                    return [2 /*return*/, false];
            }
        });
    }); };
    var getOptions = function (values) {
        var _a;
        return ((_a = values === null || values === void 0 ? void 0 : values.map(function (e) {
            var _a;
            return {
                id: parseInt(String(e.id)),
                name: (_a = e === null || e === void 0 ? void 0 : e.name) !== null && _a !== void 0 ? _a : ''
            };
        })) !== null && _a !== void 0 ? _a : []);
    };
    (0,react.useEffect)(function () {
        if (step === type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE) {
            doGetJobLevelList();
        }
    }, [step]);
    var handleOnClickSaveProfile = function (values) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, isUpdateSuccess, params, postResumeResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShowLoading(true);
                    _a = checkBeforeSubmitForm;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, checkBeforeSubmitForm(values)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    /*
                     * Check before submit data
                     * */
                    if (_a) {
                        // Hide loading overlay
                        handleClosePopup();
                        checkDoneStep &&
                            checkDoneStep(3, {
                                jobTitle: values.jobTitle
                            });
                        return [2 /*return*/];
                    }
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    isUpdateSuccess = false;
                    params = {
                        url: "".concat(baseApiUrl).concat(apiUpdateResume),
                        accessToken: accessToken || '',
                        data: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), { locations: values.locations.map(function (location) { return ({ cityId: location }); }), yearsExperience: values.yearsExperience ? Number(values.yearsExperience) : 0, salary: values.salary ? Number(values.salary) : 0 }), (!resumeId ? null : { resumeId: resumeId }))
                    };
                    return [4 /*yield*/, (0,apiServices/* apiPostResume */._s)(params)];
                case 4:
                    postResumeResponse = _b.sent();
                    isUpdateSuccess = postResumeResponse.meta.code === UploadResumeModal_constants/* DEFAULT_SUCCESS_CODE */.se;
                    // Check Error when call API
                    if (isUpdateSuccess) {
                        handleClosePopup();
                        checkDoneStep &&
                            checkDoneStep(3, {
                                jobTitle: values.jobTitle
                            });
                        // Do reload when save success!
                        isReloadOnClose && window.location.reload();
                    }
                    else {
                        (0,Toast/* showToast */.CF)(t('Phiên Sử Dụng Hết Hạn'), t('Bạn vui lòng đăng nhập lại'), Toast/* TOAST_TYPE_ERROR */.rn);
                        setTimeout(function () {
                            window.location.href = logoutUrl;
                        }, 3000);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    _b.sent();
                    (0,Toast/* showToast */.CF)(t('Lỗi '), t('Không thể cập nhật thông tin!'), Toast/* TOAST_TYPE_ERROR */.rn);
                    return [3 /*break*/, 6];
                case 6:
                    setShowLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };
    var syncData = function (field, value) {
        setWorkingPreferenceData(function (state) {
            var _a;
            return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), (_a = {}, _a[field] = value, _a)));
        });
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    return (react.createElement(Working.Section, null,
        react.createElement(Contact.SectionWrapper, { isMobile: isMobile },
            react.createElement(Working.Title, null, t('Thông tin được tự động điền cho bạn nếu có thể.')),
            react.createElement(Form/* default */.Z, { ref: formRef, initialValues: formData, requestScrollToFirstErrorElement: true, onSubmit: function (values) { return handleOnClickSaveProfile(values); } },
                react.createElement("button", { type: 'submit', hidden: true }, "button"),
                react.createElement(Row/* default */.Z, { gutter: [24, 16] },
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'jobTitle', rules: rules({
                            types: ['required', 'no-special-chars-for-job-title'],
                            t: t
                        }) }, function (field) { return (react.createElement(Col/* default */.Z, { xs: 24 },
                        react.createElement(Form/* default.Label */.Z.Label, null,
                            " ",
                            t('Chức danh hiện tại')),
                        react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Nhập chức danh'), value: field.value, onChange: function (value) {
                                field.onChange(value);
                                handleDebounceChangeEvent(value);
                                syncData('jobTitle', value);
                            }, listRecommend: jobsTitleRecommend, searchNotFound: t('Không có kết quả'), onClickSuggestionItem: function (item) {
                                if ((item === null || item === void 0 ? void 0 : item.id) === -1)
                                    return;
                                field.onChange(item.name);
                                syncData('jobTitle', item.name);
                            }, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: UploadResumeModal_constants/* DEFAULT_MAX_LENGTH_JOB_TITLE */.r3, autoFocus: true }),
                        react.createElement(Form/* default.Error */.Z.Error, null))); }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'jobLevelId', rules: rules({
                            types: ['required'],
                            t: t
                        }) }, function (field) {
                        return (react.createElement(Col/* default */.Z, { md: 12, xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, null,
                                " ",
                                t('Cấp bậc hiện tại')),
                            react.createElement(MultipleRadio/* default */.Z, { options: jobsLevel, name: 'jobLevelId', placeholder: t('Vui lòng chọn ...'), value: field.value, onBlur: field.onBlur, onChange: function (value) {
                                    field.onChange(value.value);
                                    syncData('jobLevelId', value.value);
                                }, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('Không Có Kết Quả Nào'),
                                    searchBoxPlaceholder: t('Tìm'),
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    }
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'yearsExperience', watch: ['jobLevelId'], rules: rules({
                            types: ['custom'],
                            custom: {
                                validator: function (value, watch) {
                                    var isHightLevel = ![UploadResumeModal_constants/* INTERNSHIP_ID */.dv, UploadResumeModal_constants/* FRESHER_ID */.yE].includes(watch.jobLevelId);
                                    var isValid = !isHightLevel || (value && isHightLevel);
                                    return isValid;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            },
                            t: t
                        }) }, function (field) {
                        var _a, _b;
                        var isHightLevel = ![UploadResumeModal_constants/* INTERNSHIP_ID */.dv, UploadResumeModal_constants/* FRESHER_ID */.yE].includes((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobLevelId);
                        return (react.createElement(Col/* default */.Z, { md: 12, xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, { require: isHightLevel }, t('Số năm kinh nghiệm')),
                            react.createElement(InputYOE/* default */.Z, { onChange: function (value) {
                                    field.onChange(value);
                                    syncData('yearsExperience', value);
                                }, onBlur: function () { return field.onBlur(); }, postfixText: t('Năm'), defaultValue: (_b = field.value) !== null && _b !== void 0 ? _b : 0, isError: !isHightLevel ? false : field.isError, options: {
                                    min: UploadResumeModal_constants/* MIN_YEAR_OF_EXPERIENCE */.sE,
                                    max: UploadResumeModal_constants/* MAX_YEAR_OF_EXPERIENCE */.kF,
                                    fontSizeErrorText: 14
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, { disable: !isHightLevel })));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'jobFunction', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (react.createElement(Col/* default */.Z, null,
                            react.createElement(Form/* default.Label */.Z.Label, { require: true }, t('Ngành nghề mong muốn')),
                            react.createElement(JobFunction/* default */.Z, { isMobile: isMobile, data: jobFunctionOptions, value: field.value, langCode: lang, onChange: function (value) {
                                    field.onChange(value);
                                    syncData('jobFunction', value);
                                }, dropdownStyleOptions: {
                                    width: '100%'
                                }, onBlur: field.onBlur, hasError: field.isError, isSingleSelect: true, displayAsPopup: true, isFlex: true, textOptions: {
                                    placeholder: t('Chọn ngành nghề')
                                }, selectOptions: {
                                    isSingleSelect: true
                                }, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                }, scrollLockMode: 'soft' }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'companyIndustries', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (react.createElement(Col/* default */.Z, null,
                            react.createElement(Form/* default.Label */.Z.Label, { require: true },
                                " ",
                                t('Lĩnh vực mong muốn')),
                            react.createElement(CompanyIndustry/* default */.Z, { type: 'multiple-select', options: jobIndustryOptions !== null && jobIndustryOptions !== void 0 ? jobIndustryOptions : [], value: field.value, onChange: function (value) {
                                    field.onChange(value);
                                    syncData('companyIndustries', value);
                                }, onBlur: field.onBlur, hasError: field.isError, langCode: lang, isMobile: false, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                }, optionsStyle: { maxHeight: '150px' } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'locations', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (react.createElement(Col/* default */.Z, null,
                            react.createElement(Form/* default.Label */.Z.Label, { require: true },
                                " ",
                                t('Nơi làm việc mong muốn')),
                            react.createElement(MultipleSelect/* default */.Z, { name: 'locations', options: getOptions(jobLocationOptions), defaultSelect: field.value, onChange: function (e) {
                                    field.onChange(e.value);
                                    syncData('locations', e.value);
                                }, onBlur: field.onBlur, selectPlaceholder: t('Chọn địa điểm'), optionsStyle: { maxHeight: '200px' }, dropdownStyle: { width: '100%' }, limitText: t('Bạn chỉ có thể chọn tối đa 3 địa điểm'), limit: UploadResumeModal_constants/* LITMIT_SELECTION */.FG, isMobile: false, langCode: lang, hasError: field.isError, sortEnable: true, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'highestDegreeId', rules: rules({
                            types: ['required'],
                            t: t
                        }) }, function (field) {
                        return (react.createElement(Col/* default */.Z, { md: 12, xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, null,
                                " ",
                                t('Trình độ học vấn')),
                            react.createElement(MultipleRadio/* default */.Z, { options: (lang === constants/* ELanguage.VI */.Df.VI ? educationListVi : educationListEn).filter(function (item) { return item.id !== 0; }), name: 'highestDegree', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (value) {
                                    syncData('highestDegreeId', value.value);
                                    field.onChange(value.value);
                                }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('Không Có Kết Quả Nào'),
                                    searchBoxPlaceholder: t('Tìm'),
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    }
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'salary', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!parseInt(value)) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (react.createElement(Col/* default */.Z, { md: 12, xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, { require: true }, t('Mức lương mong muốn')),
                            react.createElement(InputYOE/* default */.Z, { postfixText: t('USD/tháng'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: field.isError, options: {
                                    min: UploadResumeModal_constants/* MIN_SALARY */.s9,
                                    max: UploadResumeModal_constants/* MAX_SALARY */.lk,
                                    canBeEmpty: true,
                                    fontSizeErrorText: 14
                                }, typeInput: 'text', onChange: function (value) {
                                    syncData('salary', value);
                                    field.onChange(value);
                                }, onBlur: field.onBlur }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Required, null,
                            react.createElement("span", null, "*"),
                            " ",
                            t('Thông tin bắt buộc'))))))));
};
var WorkingReference$1 = react.forwardRef(WorkingReference);


//# sourceMappingURL=WorkingReference.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CircleChecked/index.js
'use client';



var CircleChecked = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("circle", { cx: 16, cy: 16, r: 15.25, fill: "white", stroke: "#005AFF", strokeWidth: 1.5 }),
        react.createElement("path", { d: "M10.1665 16.834L13.4998 20.1673L21.8332 11.834", stroke: "#005AFF", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
var CircleChecked$1 = react.memo(CircleChecked);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/Components/Layouts/Tabs.js
'use client';







var Tabs = function (_a) {
    var contactInfo = _a.contactInfo, _b = _a.hiddenStep, hiddenStep = _b === void 0 ? 0 : _b;
    var _c = useResumeModal(), step = _c.step, uploadFile = _c.uploadFile, t = _c.t;
    return (react.createElement(WarpBody.HeaderTab, { hiddenStep: hiddenStep },
        hiddenStep > 0
            ? null
            : react.createElement(WarpBody.Tab, { actived: step === type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV, tabStatus: step > type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV && !!uploadFile },
                step > type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV && !!uploadFile ? react.createElement(CircleChecked$1, null) : react.createElement("span", null, type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV - hiddenStep),
                react.createElement("p", null, t('Tải Hồ Sơ'))),
        hiddenStep > 1
            ? null
            : react.createElement(WarpBody.Tab, { actived: step === type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION, tabStatus: step > type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION && (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.address) !== '' },
                step > type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION && (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.address) !== '' ? (react.createElement(CircleChecked$1, null)) : (react.createElement("span", null, type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION - hiddenStep)),
                react.createElement("p", null, t('Thông tin liên hệ'))),
        hiddenStep > 2
            ? null
            : react.createElement(WarpBody.Tab, { actived: step === type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE, tabStatus: step > type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE },
                step > type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE ? react.createElement(CircleChecked$1, null) : react.createElement("span", null, type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE - hiddenStep),
                react.createElement("p", null, t('Hoàn Chỉnh Hồ Sơ')))));
};


//# sourceMappingURL=Tabs.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/images.js
'use client';



var iconLinkedin = 'https://images.vietnamworks.com/images/linkedin/icon-linkedin.svg';
var IconLinkedIn = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 120 : _b, _c = _a.height, height = _c === void 0 ? 120 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? '#D4E6F0' : _e;
    return (react.createElement("img", { width: width, height: height, src: iconLinkedin, alt: 'Icon linkedin', className: className, style: { background: backgroundColor } }));
};
var IconLinkedInButton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, _f = _a.style, style = _f === void 0 ? {} : _f;
    return (react.createElement("svg", { width: width, height: height, className: className, style: style, viewBox: '0 0 20 20', version: '1.1' },
        react.createElement("g", { id: 'DASHBOARD', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/DASHBOARD-LINKEDIN', transform: 'translate(-1094.000000, -251.000000)' },
                react.createElement("rect", { fill: '#F9F9F9', x: '0', y: '0', width: '1300', height: '1238' }),
                react.createElement("g", { id: 'Group-31', transform: 'translate(311.833333, 191.000000)' },
                    react.createElement("g", { id: 'bg-section-copy-2', fill: '#D4E6F0', stroke: '#D4E6F0' },
                        react.createElement("rect", { id: 'Rectangle-4', x: '0.5', y: '0.5', width: '969', height: '155', rx: '6' })),
                    react.createElement("g", { id: 'Group-34', transform: 'translate(145.000000, 20.000000)', opacity: isDisabled ? '0.5' : '1' },
                        react.createElement("g", { id: 'Group-24', transform: 'translate(0.000000, 30.000000)' },
                            react.createElement("g", { id: 'Group-8', transform: 'translate(620.166667, 0.000000)' },
                                react.createElement("rect", { id: 'BG', stroke: '#0584B9', fill: '#0073B5', x: '0.5', y: '0.5', width: '181', height: '39', rx: '4' }),
                                react.createElement("g", { id: 'Group-2', transform: 'translate(17.000000, 10.000000)', fill: '#FFFFFF', fillRule: 'nonzero' },
                                    react.createElement("g", { id: 'cc/icons/linkedin-white' },
                                        react.createElement("path", { d: 'M17.6190461,0 L2.38095094,0 C1.06666438,0 0,1.06666438 0,2.38095094 L0,17.6190461 C0,18.9333326 1.06666438,20 2.38095094,20 L17.6190461,20 C18.9333326,20 20,18.9333326 20,17.6190461 L20,2.38095094 C20,1.06666438 18.9333326,0 17.6190461,0 Z M6.19047721,7.61904956 L6.19047721,16.6666645 L3.33333251,16.6666645 L3.33333251,7.61904956 L6.19047721,7.61904956 Z M3.33333251,4.98571452 C3.33333251,4.31904743 3.90476145,3.80952329 4.76190486,3.80952329 C5.61904827,3.80952329 6.15714385,4.31904743 6.19047721,4.98571452 C6.19047721,5.65238162 5.65714353,6.19047721 4.76190486,6.19047721 C3.90476145,6.19047721 3.33333251,5.65238162 3.33333251,4.98571452 Z M16.6666645,16.6666645 L13.8095198,16.6666645 C13.8095198,16.6666645 13.8095198,12.2571379 13.8095198,11.9047567 C13.8095198,10.9523751 13.333329,9.99999355 12.1428521,9.98094592 L12.1047568,9.98094592 C10.9523751,9.98094592 10.4761843,10.9618989 10.4761843,11.9047567 C10.4761843,12.3380903 10.4761843,16.6666645 10.4761843,16.6666645 L7.61904956,16.6666645 L7.61904956,7.61904956 L10.4761843,7.61904956 L10.4761843,8.83809796 C10.4761843,8.83809796 11.3952325,7.61904956 13.2428528,7.61904956 C15.1333302,7.61904956 16.6666645,8.91905039 16.6666645,11.5523755 L16.6666645,16.6666645 Z', id: 'Shape' })))))))))));
};
var IconLinkElipse = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M12.294.5c-.859 0-1.666.335-2.273.942L8.235 3.227A3.19 3.19 0 0 0 7.294 5.5c0 .489.112.96.317 1.387l.545-.545a2.484 2.484 0 0 1 .585-2.61l1.785-1.785a2.484 2.484 0 0 1 1.768-.733c.668 0 1.295.26 1.767.733.473.472.733 1.1.733 1.767 0 .668-.26 1.295-.733 1.768l-1.785 1.786a2.484 2.484 0 0 1-2.61.584l-.545.545a3.2 3.2 0 0 0 1.387.317c.859 0 1.665-.334 2.273-.941l1.785-1.786a3.193 3.193 0 0 0 .942-2.273c0-.858-.335-1.665-.942-2.272A3.193 3.193 0 0 0 12.294.5Zm-2.15 4.997a.357.357 0 0 0-.246.108L5.613 9.89a.357.357 0 1 0 .505.505l4.285-4.285a.357.357 0 0 0-.26-.613ZM5.508 7.286c-.859 0-1.665.334-2.273.941L1.45 10.013a3.189 3.189 0 0 0-.942 2.273c0 .858.335 1.665.942 2.272a3.193 3.193 0 0 0 2.272.942c.859 0 1.666-.335 2.273-.942l1.786-1.785a3.193 3.193 0 0 0 .941-2.273 3.2 3.2 0 0 0-.317-1.387l-.545.545a2.484 2.484 0 0 1-.585 2.61L5.49 14.053c-.473.472-1.1.733-1.768.733-.668 0-1.295-.26-1.767-.733a2.482 2.482 0 0 1-.733-1.767c0-.668.26-1.295.733-1.768L3.74 8.732a2.484 2.484 0 0 1 2.61-.584l.545-.545a3.2 3.2 0 0 0-1.387-.317Z', fill: '#333' })));
};
var IconLinkedInSuccess = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 80 : _b, _c = _a.height, height = _c === void 0 ? 54 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: "0 0 ".concat(width, " ").concat(height), version: '1.1' },
        react.createElement("g", { id: 'DASHBOARD', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/DASHBOARD-LINKEDIN-SUCCESS', transform: 'translate(-320.000000, -195.000000)' },
                react.createElement("g", { id: 'Group-18', transform: 'translate(312.000000, 187.000000)' },
                    react.createElement("g", { id: 'colors/color-darkblue', transform: 'translate(8.000000, 8.000000)' },
                        react.createElement("g", { id: 'icon-successful', transform: 'translate(0.000000, -0.000000)' },
                            react.createElement("path", { d: 'M5.76955827,26.3459078 C5.76955827,15.1963841 25.7830282,14.6323968 34.5691644,21.3273528 C43.3553002,28.0223088 50.0303256,26.3459078 65.784816,29.4977564 C81.5393064,32.6496051 84.4172212,45.1767242 72.4845384,49.8368402 C60.5518557,54.4969558 60.4085195,44.3864986 34.5691644,50.5427954 C8.72980908,56.6990926 -1.83978861,49.7266599 0.259416151,41.8013838 C2.35862091,33.8761081 5.76955827,37.4954315 5.76955827,26.3459078 Z', id: 'Path-5', fillOpacity: '0.05', fill: '#005AFF', fillRule: 'nonzero' }),
                            react.createElement("g", { id: 'Group-2', transform: 'translate(4.244898, 0.000000)' },
                                react.createElement("g", { id: 'search-no-2', transform: 'translate(12.081633, 0.000000)' },
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(30.367347, 0.000000)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '2.61284201', y1: '1.79591837', x2: '2.61284201', y2: '0.269604004', id: 'Line-2' }),
                                        react.createElement("line", { x1: '2.61284201', y1: '5.06122449', x2: '2.61284201', y2: '3.53491014', id: 'Line-2' }),
                                        react.createElement("line", { x1: '0.926422645', y1: '3.37599926', x2: '0.926422645', y2: '1.8496849', id: 'Line-2', transform: 'translate(0.926423, 2.612842) rotate(90.000000) translate(-0.926423, -2.612842) ' }),
                                        react.createElement("line", { x1: '4.19172875', y1: '3.37599928', x2: '4.19172875', y2: '1.8496849', id: 'Line-2', transform: 'translate(4.191729, 2.612842) rotate(90.000000) translate(-4.191729, -2.612842) ' })),
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(0.000000, 40.489796)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '2.61284201', y1: '1.79591837', x2: '2.61284201', y2: '0.269604004', id: 'Line-2' }),
                                        react.createElement("line", { x1: '2.61284201', y1: '5.06122449', x2: '2.61284201', y2: '3.53491014', id: 'Line-2' }),
                                        react.createElement("line", { x1: '0.926422645', y1: '3.37599926', x2: '0.926422645', y2: '1.8496849', id: 'Line-2', transform: 'translate(0.926423, 2.612842) rotate(90.000000) translate(-0.926423, -2.612842) ' }),
                                        react.createElement("line", { x1: '4.19172875', y1: '3.37599928', x2: '4.19172875', y2: '1.8496849', id: 'Line-2', transform: 'translate(4.191729, 2.612842) rotate(90.000000) translate(-4.191729, -2.612842) ' })),
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(44.408163, 18.285714)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '2.61284201', y1: '1.79591837', x2: '2.61284201', y2: '0.269604004', id: 'Line-2' }),
                                        react.createElement("line", { x1: '2.61284201', y1: '5.06122449', x2: '2.61284201', y2: '3.53491014', id: 'Line-2' }),
                                        react.createElement("line", { x1: '0.926422645', y1: '3.37599926', x2: '0.926422645', y2: '1.8496849', id: 'Line-2', transform: 'translate(0.926423, 2.612842) rotate(90.000000) translate(-0.926423, -2.612842) ' }),
                                        react.createElement("line", { x1: '4.19172875', y1: '3.37599928', x2: '4.19172875', y2: '1.8496849', id: 'Line-2', transform: 'translate(4.191729, 2.612842) rotate(90.000000) translate(-4.191729, -2.612842) ' })),
                                    react.createElement("polygon", { id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2', fill: '#FFFFFF', fillRule: 'nonzero', points: '22.7944594 3.29715719 0.0361848163 9.47996839 8.22594873 40.4579448 30.9842233 34.2751337' }),
                                    react.createElement("rect", { id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2', fill: '#FFFFFF', fillRule: 'nonzero', x: '11.4285714', y: '10.4489796', width: '26.122449', height: '32.3265306', rx: '1' }),
                                    react.createElement("rect", { id: 'Rectangle', fill: '#D8D8D8', fillRule: 'nonzero', x: '23.1836735', y: '16', width: '11.4285714', height: '2.28571429' }),
                                    react.createElement("g", { id: 'icons8-change', opacity: '0.5', transform: 'translate(14.367347, 13.714286)', fill: '#000000', fillRule: 'nonzero' },
                                        react.createElement("path", { d: 'M4.79935711,0 L3.06810212,1.74335993 L4.10206118,1.74335993 L4.10206118,2.16466279 L2.01017337,2.16466279 C1.4724928,2.16466279 1.03395906,2.60626275 1.03395906,3.14770279 L1.03395906,5.11378279 L0,5.11378279 L1.73125499,6.85714286 L3.46251013,5.11378279 L2.42855093,5.11378279 L2.42855093,4.69247993 L4.52043874,4.69247993 C5.05811931,4.69247993 5.49665305,4.25087996 5.49665305,3.70943993 L5.49665305,1.74335993 L6.53061224,1.74335993 L4.79935711,0 Z M4.79935711,0.397165714 L5.85728586,1.46249136 L5.21773467,1.46249136 L5.21773467,3.70943993 C5.21773467,4.09892571 4.90722015,4.41161136 4.52043874,4.41161136 L2.42855093,4.41161136 L2.42855093,3.56900564 L4.38097955,3.56900564 L4.38097955,1.46249136 L3.7414285,1.46249136 L4.79935711,0.397165714 Z M2.01017337,2.44553136 L4.10206118,2.44553136 L4.10206118,3.28813707 L2.14963256,3.28813707 L2.14963256,5.39465136 L2.78918374,5.39465136 L1.73125499,6.45997714 L0.673326388,5.39465136 L1.31287743,5.39465136 L1.31287743,3.14770279 C1.31287743,2.75821714 1.6233921,2.44553136 2.01017337,2.44553136 Z', id: 'Shape' }),
                                        react.createElement("path", { d: 'M7.34693878,10.4489796 C5.27346939,10.4489796 3.59183673,12.1306122 3.59183673,14.2040816 C3.59183673,16.277551 5.27346939,17.9591837 7.34693878,17.9591837 C9.42040816,17.9591837 11.1020408,16.277551 11.1020408,14.2040816 C11.1020408,12.1306122 9.42040816,10.4489796 7.34693878,10.4489796 Z M7.34693878,11.4285714 C8.88163265,11.4285714 10.122449,12.6693878 10.122449,14.2040816 C10.122449,15.7387755 8.88163265,16.9795918 7.34693878,16.9795918 C5.8122449,16.9795918 4.57142857,15.7387755 4.57142857,14.2040816 C4.57142857,12.6693878 5.8122449,11.4285714 7.34693878,11.4285714 Z M7.50992725,18.9387755 C4.70407508,18.9387755 2.10366279,20.7287251 0.717845561,23.5847255 C0.580974723,23.8663029 0.666385376,24.2483654 0.923018197,24.4092668 C1.00856247,24.4696048 1.09410674,24.4897959 1.17965102,24.4897959 C1.35073956,24.4897959 1.53887007,24.3892325 1.62441434,24.1881058 C2.82203417,21.6941336 5.08046988,20.1455361 7.50992725,20.1455361 C9.93938461,20.1455361 12.1977534,21.6941336 13.4124821,24.1881058 C13.549353,24.4696832 13.8743545,24.5701682 14.1138784,24.4092668 C14.3534024,24.2483654 14.4388799,23.8663029 14.3020091,23.5847255 C12.9161917,20.7287251 10.3157794,18.9387755 7.50992725,18.9387755 Z', id: 'Shape', opacity: '0.699999988' }))),
                                react.createElement("g", { id: 'Group', opacity: '0.5', transform: 'translate(63.346939, 32.979592)', fillRule: 'nonzero' },
                                    react.createElement("g", null,
                                        react.createElement("g", { id: 'Group-13', transform: 'translate(0.443149, 10.013606)' },
                                            react.createElement("polygon", { id: 'Path', fill: '#BCAAA4', points: '4.13884153 4.55163882 0.735794047 4.55163882 0 0 4.87463556 0' }),
                                            react.createElement("path", { d: 'M4.43148689,2.27581942 L4.35795687,2.85966281 C4.04346109,3.05108687 3.30195974,3.18614719 2.43731778,3.18614719 C1.57267583,3.18614719 0.831174482,3.05108687 0.516678691,2.85966281 L0.443148689,2.27581942 C0.700946648,2.49489362 1.49560221,2.65441368 2.43731778,2.65441368 C3.37903334,2.65441368 4.17368891,2.49489362 4.43148689,2.27581942 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("path", { d: 'M4.43148689,1.36549165 L4.36298171,1.94228042 C4.02129123,2.13985448 3.28778452,2.27581942 2.43731778,2.27581942 C1.58685103,2.27581942 0.853344343,2.13985448 0.511653868,1.94228042 L0.443148689,1.36549165 C0.746409427,1.5874969 1.52502928,1.74470637 2.43731778,1.74470637 C3.3496063,1.74470637 4.12822616,1.5874969 4.43148689,1.36549165 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("ellipse", { id: 'Oval', fill: '#BCAAA4', cx: '2.43731778', cy: '4.55163882', rx: '1.9941691', ry: '1' })),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#4E342E', cx: '2.88046647', cy: '10.2411874', rx: '2.43731778', ry: '1' }),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#424242', cx: '2.88046647', cy: '10.4687693', rx: '1.9941691', ry: '1' }),
                                        react.createElement("g", { id: 'Path' },
                                            react.createElement("path", { d: 'M3.03794762,7.85378456 C3.01735238,8.28399474 2.99234386,8.70064313 2.96586426,9.09318168 C2.94379792,9.42619902 2.92026049,9.73887367 2.89745861,10.0274385 C2.88348326,10.2067555 2.86950792,10.3762779 2.85553257,10.5352522 C2.84229277,10.6957335 2.82905296,10.8449132 2.81654871,10.9812845 C2.81507762,10.9993669 2.81287098,11.0174493 2.8113999,11.0347783 C2.81066435,11.0423126 2.80992881,11.0490935 2.80992881,11.0566278 C2.80698663,11.0807377 2.80477999,11.1040941 2.8033089,11.1274505 C2.79963118,11.1598481 2.796689,11.1914923 2.79374682,11.2223831 C2.78859801,11.2773836 2.7834492,11.330124 2.77903593,11.3790971 L2.70842365,11.3790971 C2.70695256,11.3617681 2.70621702,11.3436857 2.70474593,11.3256034 C2.70401038,11.3135484 2.70253929,11.3014935 2.70180375,11.2894386 C2.70106821,11.2721096 2.69959712,11.2562875 2.69812603,11.2412189 C2.6878284,11.1116284 2.67532415,10.9812845 2.65914216,10.8501872 C2.6414891,10.6972403 2.6201583,10.54354 2.59588533,10.3883328 C2.42671008,9.31845812 2.11704581,8.2033774 1.81105926,7.01747402 C1.58009826,6.12164232 1.35060836,5.18512522 1.18584637,4.19662126 C0.734221995,1.49481087 0.744519618,0.205687182 1.55508975,0.0233564199 C1.62275985,0.00753432901 1.69631431,0 1.77501758,0 C2.34727126,0 2.92320267,0.83405022 3.07398931,4.11826423 C3.08502248,4.35860934 3.09237792,4.60573531 3.09679119,4.85738191 C3.11444426,5.83533783 3.08575802,6.87884238 3.03794762,7.85378456 Z', fill: '#50B704' }),
                                            react.createElement("path", { d: 'M2.96218002,11.3790971 L2.97754934,11.3790971 L2.98446553,11.3790971 L3.00214024,11.3790971 L3.0144357,11.3790971 L3.02135189,11.3790971 L3.02596269,11.3790971 L3.03287888,11.3790971 L3.03902661,11.3790971 L3.05132206,11.3790971 L3.06899678,11.3790971 L3.10204082,11.3790971 L3.09743002,11.3020889 L3.09051383,11.1828016 L3.08743996,11.1201381 L3.08359763,11.0559646 L3.08282917,11.0484147 L3.07207064,10.8604241 L3.07207064,10.8543842 L3.02673115,10.0752422 C3.02673115,10.0722223 3.02596269,10.0692024 3.02596269,10.0661824 C2.99138172,9.58676849 2.96141155,9.10659961 2.92375672,8.62718567 C2.90992433,8.46712937 2.89762888,8.30631807 2.88379649,8.14626178 C2.85843712,7.82388424 2.83230927,7.50226165 2.8000337,7.18063909 L2.7324087,6.45812078 L2.65556211,5.73635745 C2.55028228,4.77450968 2.43270699,3.81341688 2.28977233,2.85609901 C2.21753653,2.37744007 2.14222687,1.89953611 2.05692715,1.42314212 C1.97316436,0.946748127 1.88248538,0.471864098 1.77259475,0 C1.87633765,0.473374064 1.96010044,0.949013074 2.0377155,1.42616205 C2.11686749,1.90331102 2.18526096,2.38196997 2.2521175,2.86138389 C2.38121977,3.81945675 2.48726807,4.78130452 2.57948398,5.7439073 L2.64634052,6.46567063 L2.70474393,7.1889439 C2.74624109,7.66986779 2.77390586,8.15305662 2.80848683,8.63473551 C2.82769848,8.92842371 2.84383626,9.22211193 2.85997405,9.51580013 C2.86765871,9.64641211 2.8745749,9.77626913 2.88225956,9.90688111 C2.88225956,9.91367595 2.88225956,9.92047079 2.88302803,9.92651066 C2.88610189,9.97860444 2.88917575,10.0306983 2.89224962,10.082792 L2.89993428,10.258703 C2.90070274,10.2602129 2.90070274,10.2624779 2.90070274,10.2639879 L2.9129982,10.5539012 L2.92606212,10.8490993 L2.94143144,11.1873315 L2.94373683,11.2311205 L2.94373683,11.2318755 L2.9445053,11.2492401 L2.94988456,11.3790971 L2.96218002,11.3790971 L2.96218002,11.3790971 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M5.33936865,3.67802433 C5.25980291,3.87921025 5.06490328,4.39875631 4.81744647,5.08853659 C4.81744647,5.08927353 4.81744647,5.08927353 4.81744647,5.08927353 C4.38895931,6.28533489 3.8020706,7.99283592 3.38380287,9.44019543 C3.34949469,9.55810658 3.31664643,9.67380692 3.28525812,9.78729639 C3.28525812,9.78729639 3.28525812,9.78729639 3.28525812,9.78803334 C3.15313516,10.2626258 3.04291103,10.700371 2.96918496,11.0703172 C2.96918496,11.0710542 2.968455,11.0710542 2.968455,11.0717911 C2.95093593,11.1587506 2.93560675,11.2420254 2.92173749,11.3208785 C2.9195476,11.3326696 2.91808768,11.3451976 2.9158978,11.3569887 C2.91443788,11.3643582 2.91370792,11.3717276 2.91224799,11.3790971 L2.79107445,11.3790971 C2.78888457,11.367306 2.78815461,11.3555149 2.78669468,11.3437238 C2.78596472,11.3393021 2.78523476,11.3348804 2.7845048,11.3297218 C2.77720519,11.2648707 2.76917562,11.194124 2.76187601,11.1189556 C2.74581686,10.966408 2.72975772,10.7939629 2.71588846,10.6038312 C2.70858885,10.5043437 2.70128923,10.3996975 2.69471959,10.2906297 C2.69471959,10.2891558 2.69471959,10.2869449 2.69398962,10.2854711 C2.68814994,10.1815619 2.68231025,10.073231 2.67793048,9.96121538 C2.67720052,9.9553198 2.67720052,9.94868731 2.67720052,9.94205479 C2.67209079,9.83667171 2.66844099,9.72760389 2.66552114,9.61485133 C2.66552114,9.61411438 2.66552114,9.61337744 2.66552114,9.61337744 C2.65457173,9.18816033 2.65603165,8.71946344 2.67866044,8.22349962 C2.72464799,7.21978087 2.85823087,6.10330952 3.15313516,5.00010322 C3.28671804,4.49971771 3.45314916,4.00228 3.66045812,3.51884424 C4.34589159,1.91967411 4.82839589,1.36549165 5.26637254,1.36549165 C5.35980758,1.36549165 5.43718344,1.38317832 5.50142002,1.41486695 C6.08757881,1.70669708 5.52331886,3.2166969 5.33936865,3.67802433 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M5.76093293,1.36549165 C5.32166844,2.12312188 4.96361842,2.92963148 4.65005982,3.75169362 C4.33932607,4.57523693 4.07025891,5.41655458 3.86545711,6.27564653 C3.65924291,7.13325727 3.48975177,8.00197701 3.39370681,8.88032447 L3.36333966,9.13212728 L3.36333966,9.13508967 L3.35415889,9.20988989 L3.33438491,9.37430233 L3.32308549,9.53945535 L3.27576924,10.200808 C3.2743568,10.2171012 3.27294436,10.2326537 3.27153195,10.2489468 C3.2637636,10.3489273 3.25952632,10.4496485 3.25740769,10.549629 C3.25528905,10.6488689 3.25387662,10.7481089 3.25175798,10.8473488 C3.25105177,10.852533 3.25105177,10.8577172 3.25105177,10.8629013 L3.24893313,10.9658442 L3.24540206,11.1702489 L3.24328343,11.2554175 L3.24328343,11.2828196 L3.24116479,11.3790971 L3.10204082,11.3790971 L3.10486567,11.2909661 L3.10486567,11.2791166 L3.10627809,11.2435679 L3.11051537,11.1176665 L3.11898993,10.8577172 C3.11969614,10.837721 3.12040235,10.8169843 3.12110857,10.7969882 C3.12534585,10.6621997 3.1281707,10.5281517 3.13593904,10.3941037 C3.14017632,10.3267095 3.14511981,10.2593152 3.15218194,10.1919209 L3.1606565,10.0911998 L3.20867899,9.52760581 L3.22280325,9.3617122 L3.24469585,9.19655918 L3.28848104,8.86625313 C3.328029,8.54705603 3.37605149,8.22934011 3.43254854,7.91384601 C3.53283079,7.35617685 3.6578305,6.80369185 3.79695445,6.25639102 C4.01376186,5.39729907 4.29483464,4.5582032 4.61757401,3.73762227 C4.94243203,2.91926313 5.31178145,2.11719711 5.76093293,1.36549165 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M2.93393153,11.3790971 L2.94071621,11.3790971 L2.95805484,11.3790971 L2.97011649,11.3790971 L2.97690117,11.3790971 L2.98142429,11.3790971 L2.98820897,11.3790971 L2.99423979,11.3790971 L3.00630145,11.3790971 L3.02364007,11.3790971 L3.05605576,11.3790971 L3.06736357,11.3790971 L3.08319448,11.3790971 L3.09148687,11.3790971 L3.10204082,11.3790971 C3.0990254,11.3593641 3.09600999,11.340362 3.09299458,11.3213598 C3.08922531,11.2906641 3.08470219,11.2606991 3.08017907,11.2307342 C3.07716366,11.2110012 3.07414824,11.1919991 3.07188668,11.172997 C3.06585586,11.1357235 3.06057889,11.099181 3.05530191,11.0633692 C3.0522865,11.0443671 3.04927109,11.025365 3.04700952,11.0070937 C3.04625567,11.0027086 3.04550182,10.9975926 3.04474797,10.9932075 C3.03871714,10.9537415 3.03268631,10.9150064 3.02665549,10.8770021 L3.02665549,10.8711553 C3.00177833,10.7067137 2.97840888,10.552504 2.95503942,10.4070646 C2.91056208,10.1154548 2.8683463,9.85892594 2.82839207,9.62943856 C2.82839207,9.62870772 2.82839207,9.62797685 2.82839207,9.62797685 C2.8246228,9.61043641 2.82160739,9.592896 2.81859198,9.57535556 C2.62334397,8.48053998 2.44995771,7.99817799 2.01423051,7.14819765 C1.89587554,6.91651775 1.75792039,6.65779631 1.59433422,6.3515695 C1.10809884,5.44019768 0.689710266,5.00680271 0.237398287,5.00680271 C0.182366996,5.00680271 0.138643505,5.01995804 0.103966253,5.04407615 C-0.196067359,5.25017626 0.208751861,6.28433117 0.614324934,7.06341887 C0.969389838,7.74603422 1.54081064,8.82330936 2.05418473,9.78584078 C2.28863311,10.2258134 2.51101983,10.6423988 2.69496004,10.9866298 C2.77260693,11.1313384 2.84346914,11.2636226 2.90528511,11.3790971 L2.91885447,11.3790971 L2.93393153,11.3790971 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M5.73116584,6.54679024 C5.38583775,7.22068839 5.03369848,7.9130192 4.63796748,8.7048864 C4.55010292,8.87962805 4.46019504,9.06026811 4.36688153,9.24754397 C4.34508568,9.29178237 4.32328983,9.33675807 4.30081283,9.38173378 C4.00520656,9.97895203 3.68303657,10.6351548 3.32272385,11.3790971 L3.10204082,11.3790971 C3.10885202,11.280298 3.11702547,11.169702 3.12724227,11.0487838 C3.13201012,10.9920112 3.13745908,10.9330266 3.14290805,10.8725675 L3.14290805,10.8666691 C3.16061718,10.6801305 3.18241303,10.474422 3.20897673,10.2539674 C3.21715017,10.1890844 3.22532362,10.1234641 3.23417819,10.0563692 C3.39696598,8.8088466 3.72322269,7.17644999 4.3689249,5.9879119 C4.56440647,5.62810635 4.7714671,5.32212415 4.97171651,5.08618606 C4.97171651,5.08618606 4.97171651,5.08618606 4.97171651,5.08544875 C5.25846821,4.74628777 5.5302353,4.55163882 5.73116584,4.55163882 C5.83605838,4.55163882 5.91983621,4.57080882 5.98658599,4.60619951 C6.52671455,4.88785061 5.91302498,6.19140852 5.73116584,6.54679024 Z', fill: '#94E93A' }),
                                            react.createElement("path", { d: 'M3.10204082,11.3790971 L2.96785499,11.3790971 C2.96517128,11.3621886 2.96181663,11.344545 2.95846198,11.3269013 C2.95577827,11.3151389 2.95376548,11.3033765 2.95108176,11.291614 C2.95041083,11.2879383 2.94973991,11.2842625 2.94839805,11.2798516 C2.94772712,11.2754407 2.94705619,11.271765 2.94571433,11.2673541 C2.94101783,11.2423589 2.93632132,11.2173637 2.93028296,11.1923686 C2.83366917,10.7306934 2.70887635,10.2741642 2.56865216,9.8242514 C2.38884315,9.26406583 2.18219698,8.71270211 1.9614613,8.16868989 C1.7380419,7.62614798 1.49784927,7.09169277 1.24490899,6.56385388 C0.991297783,6.03675017 0.726951709,5.51552764 0.443148689,5.00680271 C0.736344715,5.50964643 1.01075473,6.02498772 1.27442987,6.5469454 C1.53743409,7.06890305 1.78836159,7.5989474 2.02251585,8.13781352 C2.2539864,8.67888513 2.47203837,9.22657309 2.66325317,9.78749381 C2.73235887,9.99407141 2.79810992,10.2021193 2.85916447,10.4123727 C2.87526677,10.4667739 2.89069814,10.5211752 2.90545858,10.5755764 C2.90881323,10.5858685 2.91149694,10.5954254 2.91418066,10.6057176 C2.93229575,10.6704109 2.94973991,10.7358394 2.96651313,10.8012679 C2.98865379,10.8836049 3.00878167,10.966677 3.02890954,11.0497492 C3.03427697,11.0725389 3.03964441,11.0945934 3.04434091,11.1173831 C3.0463537,11.1225292 3.04769556,11.1284104 3.04836648,11.1335564 C3.05037928,11.1401728 3.05172113,11.146054 3.05239206,11.1526704 C3.05574671,11.1644328 3.05843042,11.1761952 3.06044321,11.1879577 C3.0671525,11.2144231 3.07319086,11.2408886 3.0785583,11.2680892 C3.07990016,11.2732353 3.08124201,11.2783813 3.08258387,11.2835274 C3.0879513,11.3077874 3.09331874,11.3320474 3.09801524,11.3570425 C3.10002803,11.3643941 3.10136989,11.3717456 3.10204082,11.3790971 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M6.20408163,4.55163882 C5.87093215,5.09495171 5.55763928,5.65089976 5.25611324,6.21205051 C4.95385182,6.77394456 4.66629894,7.34327102 4.40154439,7.92300294 C4.16252986,8.44550491 3.93454678,8.97543935 3.74259974,9.51726573 C3.72127229,9.57523892 3.70141571,9.63321211 3.68155912,9.69192856 C3.55432983,10.0672678 3.43739657,10.4470665 3.34988049,10.832068 C3.34914508,10.8328112 3.34914508,10.8335545 3.34914508,10.8342977 C3.30796101,11.0149065 3.27339585,11.1962586 3.24765582,11.3790971 L3.10204082,11.3790971 C3.11013054,11.3270699 3.11895569,11.2757859 3.12851627,11.2245019 C3.13292885,11.1992315 3.13807685,11.1747044 3.14248943,11.1501773 C3.14469572,11.1412584 3.14616658,11.1323394 3.14837286,11.1241637 C3.15205001,11.1018663 3.15646259,11.0795689 3.16161059,11.0580148 C3.16749402,11.0267985 3.17484832,10.9955821 3.18146718,10.9643658 C3.26015812,10.6128104 3.36458909,10.2694307 3.48078691,9.93125378 C3.51241038,9.83834802 3.54476927,9.7461855 3.57786358,9.65402299 C3.60580989,9.57672542 3.63449162,9.50017107 3.6639088,9.42361672 C3.86321016,8.90111474 4.09339951,8.39273443 4.33535576,7.89104336 C4.61187719,7.31502766 4.9111969,6.75016065 5.22375435,6.1942126 C5.53704725,5.63826456 5.86063615,5.0882625 6.20408163,4.55163882 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M4.59880669,9.83292692 C4.10256056,10.2504951 3.6435329,10.9191881 3.3603807,11.3790971 L3.10204082,11.3790971 C3.11225765,11.2973355 3.1246638,11.2097338 3.13925928,11.119212 C3.14290814,11.0995016 3.14582724,11.0797912 3.14947611,11.0593509 C3.15020588,11.0549708 3.15093565,11.0505907 3.15166543,11.0454806 C3.15458452,11.0330703 3.15677384,11.0206601 3.15896316,11.0075198 C3.16845022,10.9571489 3.17866706,10.9067779 3.18961366,10.8549469 C3.25383375,10.5498009 3.34870433,10.2300547 3.48371246,9.95702932 C3.50925453,9.90373829 3.53698596,9.8519073 3.56690668,9.80299634 C3.56690668,9.80226632 3.56690668,9.80226632 3.56690668,9.80226632 C3.59317851,9.75773544 3.62090991,9.71539461 3.65010087,9.67524385 C3.68075138,9.632173 3.71213162,9.59056219 3.7435119,9.5504114 C4.0792078,9.12116304 4.43825646,8.85470782 4.74111256,8.73133541 C4.87758024,8.67512431 5.00310132,8.6481138 5.10964829,8.6481138 C5.18700431,8.6481138 5.24173734,8.66782416 5.27530691,8.7043249 C5.43293802,8.86930811 5.13956901,9.37812803 4.59880669,9.83292692 Z', fill: '#AEF265' }),
                                            react.createElement("path", { d: 'M2.61338414,11.3790971 L2.62676885,11.3790971 L2.63279196,11.3790971 L2.64818437,11.3790971 L2.65889213,11.3790971 C2.65353825,11.3668902 2.6488536,11.3554463 2.64416896,11.3424765 C2.63747661,11.326455 2.63078425,11.3104334 2.62342267,11.2936489 C2.62275343,11.2913602 2.62141496,11.2890714 2.62074573,11.2860197 C2.61940726,11.2829679 2.61806879,11.2799162 2.61606108,11.2761016 C2.61472261,11.2722869 2.61271491,11.2677094 2.6107072,11.2631318 C2.60669179,11.2524507 2.60200715,11.2410068 2.5973225,11.2303258 L2.5973225,11.2295629 C2.41194439,10.7863007 2.14558883,10.2026594 1.84577152,9.71591027 C1.82167906,9.67547497 1.79691736,9.63656555 1.77215566,9.59841907 C1.50446164,9.18567409 1.29833724,9.10327768 1.1029206,9.10327768 C1.03064321,9.10327768 0.977773639,9.12540264 0.942973417,9.16507497 C0.750233718,9.3809841 1.07682043,10.1111079 1.50446164,10.5063055 C1.80829436,10.7878265 2.19444299,11.1029165 2.47752942,11.3790971 L2.59263786,11.3790971 L2.60133791,11.3790971 L2.60267638,11.3790971 L2.61338414,11.3790971 L2.61338414,11.3790971 Z', fill: '#A9E965' }),
                                            react.createElement("path", { d: 'M5.31778426,8.6481138 C5.03505208,8.7807871 4.78785038,8.97457959 4.56332777,9.18476989 C4.50360627,9.24141695 4.44615265,9.29955468 4.390211,9.35992849 C4.23674942,9.52539745 4.09689525,9.70428284 3.96838064,9.88913104 L3.84288986,10.0821782 C3.80055562,10.1462788 3.76653704,10.2148515 3.72722671,10.2811881 C3.64860598,10.4131161 3.58661659,10.553243 3.52009136,10.6903884 C3.48456085,10.7589611 3.45885793,10.8305153 3.42937515,10.9013241 L3.34395073,11.1144958 C3.31295602,11.2024478 3.28422919,11.2903998 3.25474644,11.3790971 L3.10204082,11.3790971 C3.1118684,11.353755 3.12094003,11.3284129 3.13001165,11.3030708 C3.13530343,11.2903998 3.13983924,11.2784741 3.14361908,11.2665484 C3.14588698,11.2620762 3.14739892,11.2583495 3.14815489,11.2546227 C3.15193473,11.2456784 3.15495861,11.2367341 3.15873845,11.2277899 C3.17839363,11.1741243 3.19880477,11.121204 3.21997189,11.0682838 C3.21997189,11.0675384 3.22072786,11.0675384 3.22072786,11.066793 L3.31673584,10.8536213 C3.31975971,10.8469131 3.32278361,10.8402049 3.32656343,10.8327513 C3.32656343,10.832006 3.32656343,10.8312606 3.32731941,10.8305153 C3.3560462,10.7671601 3.38250511,10.7030595 3.41727964,10.6426856 C3.49136454,10.5047948 3.56015768,10.3654133 3.64558211,10.2342307 C3.68791634,10.1686394 3.72495879,10.1000667 3.77107288,10.0367115 L3.90639122,9.84590041 C4.0742162,9.62378442 4.25867249,9.41284875 4.46353995,9.22427376 C4.48773094,9.20191308 4.51267788,9.17955242 4.53762485,9.15793708 C4.77348699,8.95445499 5.02976029,8.76960676 5.31778426,8.6481138 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M2.60584518,11.3790971 L2.61962361,11.3790971 L2.6258239,11.3790971 L2.64166909,11.3790971 L2.65269184,11.3790971 L2.65889213,11.3790971 L2.64235801,11.3398859 C2.64029125,11.3351805 2.63822449,11.3304752 2.6354688,11.3265541 C2.62995743,11.3140065 2.62306822,11.3030273 2.616179,11.291264 C2.61549008,11.2896955 2.61411224,11.2881271 2.61342332,11.2857744 C2.61204547,11.2834217 2.60997871,11.281069 2.60860087,11.2779321 C2.60791194,11.2763637 2.60722302,11.2747952 2.60584518,11.2732268 C2.60240057,11.2677372 2.59964489,11.2622476 2.59620028,11.2559738 C2.59413352,11.2520527 2.59206675,11.2481316 2.58999999,11.2442105 C2.56106529,11.1916674 2.52799706,11.144614 2.49630668,11.0959921 C2.46530521,11.0489386 2.43361483,11.0034536 2.40123553,10.9579686 C2.36265593,10.9022886 2.32269849,10.8481771 2.28205212,10.7940656 C2.13531187,10.5964411 1.98306024,10.4058745 1.82943077,10.2160922 C1.5214829,9.838096 1.2059569,9.46794204 0.886297375,9.10327768 C1.19837877,9.47656852 1.50494879,9.85613316 1.80394068,10.2427558 C1.95343662,10.4356751 2.1008658,10.6309469 2.24209468,10.8317084 C2.31374251,10.9313049 2.38263465,11.0332541 2.44808218,11.1367717 C2.47977256,11.1885305 2.51352971,11.2402894 2.54108657,11.2944008 C2.554865,11.3218487 2.57139911,11.3485123 2.58311078,11.375176 L2.58448862,11.3790971 L2.59344459,11.3790971 L2.59482244,11.3790971 L2.60584518,11.3790971 L2.60584518,11.3790971 Z', fill: '#4EB9E3' })),
                                        react.createElement("path", { d: 'M3.54518952,10.5279733 C3.54518952,10.6568712 3.37771406,10.9239332 2.88046647,10.9239332 C2.38321887,10.9239332 2.21574344,10.6567795 2.21574344,10.5279733 C2.21574344,10.399167 2.41262648,10.5208174 2.90987409,10.5208174 C3.4071217,10.5208174 3.54518952,10.3990753 3.54518952,10.5279733 Z', id: 'Path', fill: '#424242' }),
                                        react.createElement("path", { d: 'M5.31778426,10.7938864 C5.31778426,11.1171178 4.22655004,11.3790971 2.88046647,11.3790971 C1.5343829,11.3790971 0.443148689,11.1171178 0.443148689,10.7938864 L0.443148689,10.0136055 C0.443148689,10.3368368 1.5343829,10.5988162 2.88046647,10.5988162 C4.22655004,10.5988162 5.31778426,10.3368368 5.31778426,10.0136055 L5.31778426,10.7938864 Z', id: 'Path', fill: '#8D6E63' }))),
                                react.createElement("g", { id: 'Group', opacity: '0.5', transform: 'translate(0.000000, 32.979592)', fillRule: 'nonzero' },
                                    react.createElement("g", null,
                                        react.createElement("g", { id: 'Group-13', transform: 'translate(0.256560, 5.877551)' },
                                            react.createElement("polygon", { id: 'Path', fill: '#BCAAA4', points: '2.39617141 2.6716141 0.425986028 2.6716141 0 0 2.82215743 0' }),
                                            react.createElement("path", { d: 'M2.56559767,1.33580705 L2.52302767,1.67849774 C2.34095115,1.79085534 1.9116609,1.87012987 1.41107872,1.87012987 C0.910496532,1.87012987 0.481206279,1.79085534 0.299129768,1.67849774 L0.256559767,1.33580705 C0.405811216,1.46439408 0.865874965,1.55802542 1.41107872,1.55802542 C1.95628247,1.55802542 2.41634622,1.46439408 2.56559767,1.33580705 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("path", { d: 'M2.56559767,0.801484229 L2.52593677,1.14003416 C2.32811597,1.25600154 1.90345421,1.33580705 1.41107872,1.33580705 C0.918703229,1.33580705 0.49404146,1.25600154 0.296220661,1.14003416 L0.256559767,0.801484229 C0.432131771,0.931791664 0.88291169,1.02406678 1.41107872,1.02406678 C1.93924574,1.02406678 2.39002566,0.931791664 2.56559767,0.801484229 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("ellipse", { id: 'Oval', fill: '#BCAAA4', cx: '1.41107872', cy: '2.6716141', rx: '1.15451895', ry: '1' })),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#4E342E', cx: '1.66763848', cy: '6.01113172', rx: '1.41107872', ry: '1' }),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#424242', cx: '1.66763848', cy: '6.14471242', rx: '1.15451895', ry: '1' }),
                                        react.createElement("g", { id: 'Path' },
                                            react.createElement("path", { d: 'M1.75881178,4.60983007 C1.74688822,4.86234475 1.7324096,5.10689923 1.71707931,5.3373023 C1.70430406,5.53276898 1.69067713,5.71629541 1.67747604,5.8856704 C1.66938505,5.9909217 1.66129406,6.090424 1.65320307,6.18373502 C1.64553792,6.27793051 1.63787277,6.36549251 1.63063346,6.44553656 C1.62978178,6.45615014 1.62850425,6.46676372 1.62765257,6.47693505 C1.62722673,6.48135739 1.62680089,6.48533747 1.62680089,6.4897598 C1.62509752,6.50391125 1.62382,6.51762044 1.62296831,6.53132963 C1.62083911,6.55034563 1.61913574,6.56891938 1.61743237,6.58705091 C1.61445148,6.61933388 1.61147059,6.65029016 1.60891554,6.67903527 L1.56803475,6.67903527 C1.56718306,6.6688639 1.56675722,6.65825032 1.56590554,6.64763677 C1.5654797,6.64056104 1.56462801,6.63348532 1.56420217,6.6264096 C1.56377633,6.61623827 1.56292465,6.60695138 1.56207296,6.59810674 C1.55611118,6.52204278 1.54887188,6.44553656 1.53950336,6.36858815 C1.52928316,6.27881496 1.51693375,6.18859958 1.50288098,6.09749969 C1.40493741,5.46952976 1.2256581,4.81502586 1.04850799,4.11895216 C0.914793731,3.59313789 0.781931154,3.04344306 0.686542635,2.46323421 C0.425075892,0.877388993 0.431037675,0.120729433 0.900315118,0.013709203 C0.939492545,0.00442232356 0.982076705,0 1.02764176,0 C1.35894652,0 1.69238049,0.489551216 1.77967802,2.41724205 C1.78606565,2.55831417 1.79032406,2.70336638 1.79287911,2.85107199 C1.80309931,3.4250896 1.78649149,4.03758139 1.75881178,4.60983007 Z', fill: '#50B704' }),
                                            react.createElement("path", { d: 'M1.71494632,6.67903527 L1.72384435,6.67903527 L1.72784846,6.67903527 L1.7380812,6.67903527 L1.74519961,6.67903527 L1.74920373,6.67903527 L1.75187314,6.67903527 L1.75587725,6.67903527 L1.75943646,6.67903527 L1.76655488,6.67903527 L1.77678761,6.67903527 L1.79591837,6.67903527 L1.79324896,6.63383478 L1.78924485,6.56381835 L1.78746524,6.52703755 L1.78524073,6.48937051 L1.78479583,6.48493907 L1.77856722,6.37459673 L1.77856722,6.37105159 L1.75231804,5.91372914 C1.75231804,5.91195657 1.75187314,5.910184 1.75187314,5.90841143 C1.73185257,5.62701629 1.71450142,5.34517802 1.69270126,5.06378289 C1.68469304,4.9698368 1.67757461,4.87544758 1.66956639,4.78150149 C1.65488465,4.59227987 1.639758,4.40350142 1.62107214,4.21472294 L1.58192083,3.79063611 L1.53743069,3.36699242 C1.47647921,2.8024296 1.40840931,2.23830992 1.32565766,1.67640594 C1.28383694,1.39545396 1.24023661,1.11494511 1.19085256,0.835322547 C1.14235832,0.555699987 1.08985996,0.27696371 1.02623907,0 C1.08630075,0.277849993 1.13479499,0.557029414 1.17973002,0.837095115 C1.22555486,1.11716082 1.26515108,1.39811281 1.3038575,1.67950793 C1.37860092,2.24185505 1.4399973,2.80641788 1.49338546,3.37142384 L1.53209188,3.79506753 L1.56590438,4.21959752 C1.58992905,4.50187892 1.6059455,4.78548976 1.62596606,5.0682143 C1.63708859,5.24059654 1.64643152,5.41297874 1.65577445,5.58536095 C1.66022346,5.66202452 1.66422757,5.73824493 1.66867659,5.81490847 C1.66867659,5.81889675 1.66867659,5.82288503 1.66912149,5.82643017 C1.67090109,5.85700696 1.6726807,5.88758374 1.6744603,5.91816056 L1.67890932,6.0214126 C1.67935422,6.02229891 1.67935422,6.02362834 1.67935422,6.02451461 L1.68647264,6.19468111 L1.69403596,6.36794962 L1.70293399,6.56647719 L1.70426869,6.59217943 L1.70426869,6.59262256 L1.70471359,6.60281482 L1.70782791,6.67903527 L1.71494632,6.67903527 L1.71494632,6.67903527 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M3.09121344,2.15884036 C3.04514905,2.27692775 2.93231243,2.5818787 2.78904796,2.98674974 C2.78904796,2.9871823 2.78904796,2.9871823 2.78904796,2.9871823 C2.54097644,3.68921832 2.20119876,4.69144715 1.95904376,5.54098426 C1.93918114,5.61019298 1.92016373,5.67810407 1.90199154,5.74471745 C1.90199154,5.74471745 1.90199154,5.74471745 1.90199154,5.74515001 C1.8254993,6.02371513 1.76168534,6.28065254 1.71900182,6.49779491 C1.71900182,6.49822746 1.71857921,6.49822746 1.71857921,6.49866002 C1.70843659,6.54970145 1.6995618,6.59858011 1.69153223,6.64486344 C1.6902644,6.65178433 1.68941918,6.65913773 1.68815136,6.66605861 C1.68730614,6.67038416 1.68688353,6.67470971 1.68603831,6.67903527 L1.61588521,6.67903527 C1.61461738,6.67211438 1.61419477,6.6651935 1.61334955,6.65827262 C1.61292695,6.65567729 1.61250434,6.65308199 1.61208173,6.65005411 C1.60785564,6.61198929 1.60320694,6.57046407 1.59898085,6.52634351 C1.58968345,6.4368047 1.58038605,6.33558694 1.57235648,6.22398789 C1.56813038,6.16559301 1.56390429,6.10417029 1.56010081,6.0401522 C1.56010081,6.03928709 1.56010081,6.03798942 1.5596782,6.03712431 C1.55629733,5.97613414 1.55291646,5.9125486 1.5503808,5.84680033 C1.54995819,5.84333989 1.54995819,5.83944689 1.54995819,5.83555389 C1.54699993,5.77369861 1.54488689,5.70968052 1.54319645,5.64349969 C1.54319645,5.64306713 1.54319645,5.64263458 1.54319645,5.64263458 C1.53685731,5.39305061 1.53770253,5.11794593 1.55080341,4.82683673 C1.57742778,4.23769747 1.65476524,3.58237734 1.8254993,2.9348432 C1.90283676,2.64113867 1.99919162,2.34916436 2.1192126,2.06540858 C2.51604251,1.12676524 2.7953871,0.801484229 3.04895253,0.801484229 C3.10304649,0.801484229 3.14784305,0.811865538 3.18503265,0.830465384 C3.52438772,1.00175698 3.19771092,1.88806122 3.09121344,2.15884036 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M3.33527696,0.801484229 C3.08096593,1.24618024 2.87367382,1.71956631 2.6921399,2.20208104 C2.51224141,2.68546516 2.35646568,3.17928203 2.23789623,3.68353166 C2.11850905,4.1869119 2.02038261,4.69681257 1.96477762,5.21236434 L1.94719664,5.36016167 L1.94719664,5.36190044 L1.94188145,5.40580493 L1.93043337,5.50230789 L1.9238916,5.59924555 L1.89649797,5.98743079 C1.89568025,5.99699416 1.89486253,6.00612281 1.89404481,6.01568617 C1.88954735,6.07437038 1.88709419,6.13348931 1.88586761,6.19217355 C1.88464103,6.25042305 1.88382331,6.30867259 1.88259673,6.36692212 C1.88218787,6.369965 1.88218787,6.3730079 1.88218787,6.37605078 L1.88096129,6.4364738 L1.87891699,6.55645042 L1.8776904,6.60644069 L1.8776904,6.62252451 L1.87646382,6.67903527 L1.79591837,6.67903527 L1.79755381,6.62730619 L1.79755381,6.62035102 L1.79837153,6.59948552 L1.80082469,6.52558687 L1.80573101,6.3730079 C1.80613987,6.36127105 1.80654873,6.34909949 1.80695759,6.33736264 C1.80941075,6.25824764 1.81104619,6.17956731 1.81554366,6.10088699 C1.81799682,6.06132947 1.82085884,6.02177195 1.82494744,5.98221443 L1.82985376,5.92309551 L1.85765625,5.59229038 L1.86583346,5.49491804 L1.87850812,5.39798038 L1.90385746,5.20410511 C1.92675363,5.01675027 1.95455612,4.83026485 1.98726493,4.64508353 C2.04532308,4.31775598 2.11769133,3.99347128 2.19823679,3.67222952 C2.32375687,3.16797989 2.48648322,2.67546711 2.67333233,2.19382177 C2.86140801,1.71348054 3.07524189,1.24270265 3.33527696,0.801484229 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M1.69859194,6.67903527 L1.70251991,6.67903527 L1.71255806,6.67903527 L1.71954113,6.67903527 L1.7234691,6.67903527 L1.72608775,6.67903527 L1.73001572,6.67903527 L1.73350725,6.67903527 L1.74049031,6.67903527 L1.75052846,6.67903527 L1.76929544,6.67903527 L1.77584206,6.67903527 L1.78500733,6.67903527 L1.78980819,6.67903527 L1.79591837,6.67903527 C1.7941726,6.66745283 1.79242684,6.65629943 1.79068107,6.64514599 C1.78849886,6.62712891 1.78588022,6.6095408 1.78326157,6.59195272 C1.7815158,6.58037029 1.77977004,6.56921688 1.77846071,6.55806344 C1.77496918,6.53618557 1.77191409,6.51473665 1.768859,6.49371673 C1.76711324,6.4825633 1.76536747,6.47140986 1.76405815,6.46068542 C1.7636217,6.45811154 1.76318526,6.4551087 1.76274882,6.45253482 C1.75925729,6.42937002 1.75576576,6.40663419 1.75227423,6.38432731 L1.75227423,6.38089551 C1.73787166,6.28437544 1.72434198,6.19386106 1.7108123,6.10849443 C1.68506226,5.93733218 1.66062154,5.78676088 1.63749015,5.65206178 C1.63749015,5.65163278 1.63749015,5.65120382 1.63749015,5.65120382 C1.63530794,5.64090834 1.63356217,5.63061287 1.63181641,5.62031739 C1.51877809,4.97770824 1.41839657,4.69458273 1.16613345,4.19568124 C1.09761216,4.05969518 1.01774338,3.90783696 0.923035602,3.72809515 C0.641530909,3.1931595 0.399305943,2.93877551 0.137441113,2.93877551 C0.105580892,2.93877551 0.0802672921,2.94649712 0.0601909887,2.96065339 C-0.113512682,3.0816252 0.120856341,3.68862916 0.355661806,4.14591977 C0.561225695,4.54658531 0.892048264,5.17889897 1.18926485,5.74386309 C1.32499812,6.00210785 1.45374832,6.24662537 1.56024002,6.44867402 C1.60519348,6.53361169 1.64621897,6.61125672 1.68200717,6.67903527 L1.68986311,6.67903527 L1.69859194,6.67903527 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M3.31804336,3.84268124 C3.11811659,4.23823014 2.91424648,4.64459824 2.68513907,5.10938984 C2.63427012,5.21195559 2.58221818,5.31798348 2.52819457,5.42790625 C2.51557592,5.45387226 2.50295726,5.48027105 2.48994428,5.50666981 C2.3188038,5.85721097 2.13228433,6.24237349 1.92368223,6.67903527 L1.79591837,6.67903527 C1.7998617,6.62104451 1.80459369,6.55612947 1.81050869,6.48515569 C1.81326902,6.45183265 1.81642368,6.4172113 1.81957834,6.38172441 L1.81957834,6.37826227 C1.829831,6.26877228 1.84244965,6.1480303 1.85782863,6.01863301 C1.86256063,5.98054952 1.86729262,5.94203327 1.87241895,5.90265149 C1.96666452,5.17040996 2.15554998,4.21226413 2.52937757,3.51464395 C2.64255111,3.30345371 2.76242831,3.12385547 2.87836219,2.98537008 C2.87836219,2.98537008 2.87836219,2.98537008 2.87836219,2.98493731 C3.04437634,2.78586455 3.20171517,2.6716141 3.31804336,2.6716141 C3.37877064,2.6716141 3.4272736,2.68286604 3.4659182,2.70363885 C3.7786242,2.86895579 3.42333025,3.63408761 3.31804336,3.84268124 Z', fill: '#94E93A' }),
                                            react.createElement("path", { d: 'M1.79591837,6.67903527 L1.71823184,6.67903527 C1.71667811,6.66911069 1.71473594,6.65875464 1.71279378,6.6483986 C1.71124005,6.64149456 1.71007475,6.63459053 1.70852102,6.6276865 C1.70813259,6.62552901 1.70774416,6.62337149 1.70696729,6.62078247 C1.70657886,6.61819347 1.70619043,6.61603595 1.70541356,6.61344696 C1.70269453,6.59877587 1.6999755,6.58410482 1.69647961,6.56943373 C1.64054531,6.29845045 1.56829683,6.03048767 1.48711441,5.76640842 C1.38301446,5.43760385 1.2633772,5.11397734 1.13558286,4.79466583 C1.00623479,4.47621731 0.867175896,4.16251533 0.720736787,3.85269685 C0.573909244,3.54330988 0.420866779,3.23737493 0.256559767,2.93877551 C0.426304836,3.23392291 0.585173789,3.53640584 0.737827824,3.84277231 C0.890093424,4.14913874 1.03536724,4.46025172 1.17093023,4.77654273 C1.30493949,5.09412823 1.43118011,5.41559726 1.54188341,5.74483331 C1.58189198,5.86608539 1.61995838,5.98820049 1.65530575,6.11161006 C1.66462813,6.14354122 1.67356208,6.17547236 1.6821076,6.20740353 C1.68404976,6.21344454 1.68560349,6.21905407 1.68715722,6.22509509 C1.69764491,6.26306727 1.70774416,6.30147096 1.71745497,6.33987464 C1.73027325,6.38820287 1.74192623,6.43696261 1.75357921,6.48572232 C1.75668667,6.49909891 1.75979413,6.51204395 1.76251316,6.52542051 C1.76367846,6.52844104 1.76445532,6.53189306 1.76484376,6.53491357 C1.76600905,6.53879709 1.76678592,6.54224911 1.76717435,6.5461326 C1.76911652,6.55303664 1.77067025,6.55994067 1.77183554,6.5668447 C1.77571987,6.58237881 1.77921576,6.59791288 1.78232323,6.61387843 C1.78310009,6.61689897 1.78387696,6.61991948 1.78465382,6.62293998 C1.78776128,6.63717956 1.79086874,6.65141913 1.79358777,6.66609019 C1.79475307,6.67040522 1.79552994,6.67472023 1.79591837,6.67903527 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M3.59183673,2.6716141 C3.39896072,2.99051513 3.21758063,3.31683246 3.04301294,3.64620356 C2.86801947,3.97601094 2.7015415,4.3101808 2.54826255,4.65045825 C2.40988572,4.9571442 2.27789551,5.26819265 2.16676827,5.58622119 C2.1544208,5.62024895 2.14292488,5.65427667 2.13142896,5.68874067 C2.05776991,5.90904849 1.9900717,6.13197384 1.9394045,6.35795295 C1.93897872,6.35838919 1.93897872,6.35882547 1.93897872,6.35926171 C1.91513533,6.46527122 1.89512391,6.571717 1.88022179,6.67903527 L1.79591837,6.67903527 C1.80060189,6.64849753 1.80571119,6.61839608 1.81124626,6.5882946 C1.81380091,6.57346201 1.81678134,6.55906563 1.81933598,6.54466929 C1.82061331,6.53943425 1.82146486,6.53419922 1.82274218,6.52940042 C1.82487106,6.51631285 1.82742571,6.50322524 1.83040613,6.49057391 C1.83381233,6.47225127 1.83807008,6.45392865 1.84190205,6.43560601 C1.88745996,6.22925829 1.94791999,6.02770936 2.01519242,5.82921417 C2.03350074,5.77468255 2.05223483,5.72058713 2.0713947,5.66649176 C2.08757415,5.62112144 2.10417937,5.57618736 2.12121036,5.53125329 C2.23659535,5.22456735 2.36986288,4.92617022 2.50994281,4.63169936 C2.67003416,4.2936032 2.84332453,3.96205084 3.02427884,3.63573349 C3.20565894,3.30941616 3.39299987,2.98658885 3.59183673,2.6716141 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M2.66246703,5.77150057 C2.37516664,6.01659494 2.10941379,6.40908869 1.94548357,6.67903527 L1.79591837,6.67903527 C1.80183337,6.63104473 1.80901589,6.57962635 1.8174659,6.52649401 C1.8195784,6.51492487 1.8212684,6.50335572 1.8233809,6.49135811 C1.82380341,6.4887872 1.82422591,6.48621626 1.8246484,6.48321685 C1.82633841,6.4759326 1.82760591,6.46864833 1.82887341,6.46093554 C1.83436592,6.43136999 1.84028093,6.40180441 1.84661844,6.37138184 C1.88379848,6.19227445 1.93872356,6.00459729 2.01688616,5.84434331 C2.03167368,5.81306377 2.04772871,5.78264124 2.06505123,5.75393264 C2.06505123,5.75350413 2.06505123,5.75350413 2.06505123,5.75350413 C2.08026125,5.72736647 2.09631627,5.70251422 2.11321629,5.67894746 C2.13096132,5.65366678 2.14912884,5.62924304 2.16729637,5.60567624 C2.36164663,5.35372614 2.5695169,5.19732849 2.74485464,5.12491425 C2.82386225,5.09192078 2.89653234,5.07606678 2.95821743,5.07606678 C3.00300248,5.07606678 3.03469003,5.08763592 3.05412505,5.10906024 C3.14538518,5.20589825 2.97553995,5.5045534 2.66246703,5.77150057 Z', fill: '#AEF265' }),
                                            react.createElement("path", { d: 'M1.51301187,6.67903527 L1.52076091,6.67903527 L1.52424798,6.67903527 L1.53315937,6.67903527 L1.5393586,6.67903527 C1.53625898,6.67187033 1.53354682,6.66515324 1.53083466,6.65754054 C1.52696014,6.64813659 1.52308562,6.63873267 1.51882365,6.62888091 C1.5184362,6.6275375 1.5176613,6.62619406 1.51727384,6.62440284 C1.51649894,6.62261162 1.51572404,6.62082041 1.51456168,6.61858136 C1.51378678,6.61634233 1.51262442,6.61365548 1.51146206,6.61096865 C1.50913736,6.60469936 1.50642519,6.59798227 1.50371303,6.59171298 L1.50371303,6.59126518 C1.39638886,6.33108953 1.24218301,5.98851749 1.06860456,5.70281688 C1.0546563,5.67908313 1.04032058,5.656245 1.02598486,5.63385466 C0.871004108,5.39159131 0.751668927,5.34322821 0.638532976,5.34322821 C0.596688173,5.34322821 0.566079478,5.3562146 0.545931977,5.37950054 C0.434345835,5.50622981 0.623422354,5.9347807 0.871004108,6.16674452 C1.04690726,6.33198514 1.27046699,6.51692927 1.43435914,6.67903527 L1.50100087,6.67903527 L1.50603774,6.67903527 L1.50681264,6.67903527 L1.51301187,6.67903527 L1.51301187,6.67903527 Z', fill: '#A9E965' }),
                                            react.createElement("path", { d: 'M3.0787172,5.07606678 C2.91503015,5.15394024 2.77191338,5.26768803 2.64192661,5.3910606 C2.607351,5.42430994 2.57408839,5.45843425 2.54170111,5.49387109 C2.45285493,5.59099416 2.37188673,5.6959921 2.29748352,5.80448996 L2.22483098,5.91780023 C2.20032168,5.95542449 2.18062672,5.9956737 2.15786809,6.03461042 C2.11235083,6.1120464 2.07646223,6.19429479 2.03794762,6.27479321 C2.01737733,6.31504242 2.00249669,6.3570416 1.98542771,6.39860327 L1.93597146,6.52372581 C1.91802716,6.57534978 1.90139586,6.62697378 1.88432688,6.67903527 L1.79591837,6.67903527 C1.80160802,6.66416056 1.80686002,6.64928584 1.81211201,6.63441113 C1.81517567,6.62697378 1.81780167,6.61997391 1.81998999,6.61297404 C1.82130299,6.61034909 1.82217832,6.60816163 1.82261599,6.6059742 C1.82480432,6.60072428 1.82655498,6.59547438 1.82874331,6.59022449 C1.84012263,6.55872513 1.8519396,6.52766322 1.86419425,6.49660134 C1.86419425,6.49616385 1.86463192,6.49616385 1.86463192,6.49572637 L1.92021549,6.37060382 C1.92196616,6.36666638 1.92371682,6.36272898 1.92590515,6.35835406 C1.92590515,6.35791657 1.92590515,6.35747909 1.92634281,6.3570416 C1.94297412,6.31985482 1.95829243,6.28223056 1.97842506,6.24679376 C2.02131632,6.16585786 2.06114392,6.08404696 2.11060017,6.00704846 C2.13510946,5.96854922 2.15655509,5.92830002 2.18325271,5.89111324 L2.26159492,5.77911546 C2.35875675,5.64874302 2.46554724,5.52493296 2.5841547,5.41424764 C2.59816001,5.40112291 2.61260299,5.38799814 2.62704596,5.37531089 C2.76359773,5.25587576 2.91196648,5.14737789 3.0787172,5.07606678 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M1.50864721,6.67903527 L1.5166242,6.67903527 L1.52021384,6.67903527 L1.52938737,6.67903527 L1.53576896,6.67903527 L1.5393586,6.67903527 L1.52978622,6.65601995 C1.52858967,6.65325812 1.52739312,6.65049629 1.52579773,6.64819478 C1.52260693,6.64082988 1.51861844,6.6343856 1.51462995,6.62748101 C1.5142311,6.62656039 1.5134334,6.6256398 1.51303455,6.62425887 C1.51223685,6.62287794 1.5110403,6.62149704 1.51024261,6.6196558 C1.50984376,6.61873522 1.50944491,6.6178146 1.50864721,6.61689398 C1.50665296,6.61367184 1.50505757,6.6104497 1.50306332,6.60676725 C1.50186677,6.60446573 1.50067023,6.60216421 1.49947368,6.59986266 C1.48272201,6.5690222 1.46357725,6.54140385 1.44523018,6.51286491 C1.42728197,6.48524656 1.4089349,6.45854883 1.39018899,6.4318511 C1.36785343,6.3991694 1.34472018,6.36740833 1.32118807,6.33564722 C1.23623319,6.21965019 1.14808751,6.10779592 1.05914413,5.99640196 C0.880858524,5.7745346 0.698185577,5.55727033 0.513119533,5.34322821 C0.693798233,5.56233371 0.871286142,5.78512163 1.04438671,6.01205234 C1.13093699,6.12528754 1.21629072,6.23990364 1.29805482,6.35774188 C1.33953514,6.41620072 1.37942006,6.47604046 1.41731074,6.53680078 C1.4356578,6.56718096 1.45520141,6.59756114 1.47115538,6.62932225 C1.47913237,6.64543295 1.48870475,6.66108333 1.49548519,6.67673371 L1.49628288,6.67903527 L1.50146792,6.67903527 L1.50226562,6.67903527 L1.50864721,6.67903527 L1.50864721,6.67903527 Z', fill: '#4EB9E3' })),
                                        react.createElement("path", { d: 'M2.05247814,6.17946256 C2.05247814,6.2551201 1.95551867,6.41187383 1.66763848,6.41187383 C1.3797583,6.41187383 1.28279883,6.25506625 1.28279883,6.17946256 C1.28279883,6.10385891 1.39678376,6.17526237 1.68466394,6.17526237 C1.97254413,6.17526237 2.05247814,6.10380506 2.05247814,6.17946256 Z', id: 'Path', fill: '#424242' }),
                                        react.createElement("path", { d: 'M3.0787172,6.33554201 C3.0787172,6.52526478 2.44695003,6.67903527 1.66763848,6.67903527 C0.888326939,6.67903527 0.256559767,6.52526478 0.256559767,6.33554201 L0.256559767,5.87755102 C0.256559767,6.0672738 0.888326939,6.22104428 1.66763848,6.22104428 C2.44695003,6.22104428 3.0787172,6.0672738 3.0787172,5.87755102 L3.0787172,6.33554201 Z', id: 'Path', fill: '#8D6E63' }))))),
                        react.createElement("g", { id: 'Group-3', transform: 'translate(38.530612, 9.469388)', fillRule: 'nonzero' },
                            react.createElement("g", { id: 'Group' },
                                react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '11.1020408', cy: '11.1020408', r: '11.1020408' }),
                                react.createElement("g", { id: 'icons8-checked', transform: 'translate(1.959184, 1.959184)', fill: '#85C33D' },
                                    react.createElement("path", { d: 'M8.97959184,0 C4.00681891,0 0,4.07967014 0,9.14285714 C0,14.2060441 4.00681891,18.2857143 8.97959184,18.2857143 C13.9523648,18.2857143 17.9591837,14.2060441 17.9591837,9.14285714 C17.9591837,8.159341 17.8296703,7.17857127 17.4843014,6.26373626 L16.9160782,6.68258008 C17.0536863,7.24576673 17.2492173,8.51098936 17.2492173,9.14285714 C17.2492173,11.0744644 16.591224,13.1717528 15.3378536,14.6910166 C13.8067683,16.5469102 11.297058,17.6311895 8.97959184,17.6311895 C6.84142374,17.6311895 4.53012189,16.7111883 2.94800565,15.0864329 C1.41158548,13.508605 0.573025094,11.2570221 0.573025094,9.14285714 C0.573025094,6.82307223 1.71475714,4.42387971 3.50618599,2.80202237 C5.02859657,1.42371884 7.04337228,0.634920633 8.97959184,0.634920633 C11.0518053,0.634920633 13.2822075,1.73914292 14.5935298,3.0743074 L15.1962323,2.59340659 C13.6069959,0.9752749 11.3971743,0 8.97959184,0 Z M17.2492173,3.44486531 L8.97959184,11.8979979 L5.50602309,8.47310534 L5.02943484,8.94505496 L8.48312402,12.4615384 L8.97959184,12.945055 L9.47605966,12.4615384 L16.7357157,5.06988869 L17.7649137,4.02197802 L17.2492173,3.44486531 Z', id: 'Shape' }))),
                            react.createElement("ellipse", { id: 'Oval', fill: '#85C33D', opacity: '0.101190476', cx: '11.1020408', cy: '11.1020408', rx: '7.18367347', ry: '6.85714286' }))))))));
};
var IconLinkedInSuccessMobile = function () {
    return (react.createElement("svg", { width: '121px', height: '80px', viewBox: '0 0 121 80', version: '1.1' },
        react.createElement("g", { id: 'RESPONSIVE', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/RES/DASHBOARD-IMPORTSUCCESSFULLY-LINKEDIN', transform: 'translate(-127.000000, -166.000000)' },
                react.createElement("rect", { fill: '#F8F8F8', x: '0', y: '0', width: '375', height: '1610' }),
                react.createElement("g", { id: 'Group-48', transform: 'translate(8.000000, 146.000000)' },
                    react.createElement("g", { id: 'bg-section-copy-2' },
                        react.createElement("rect", { id: 'BG', stroke: '#A8DB82', fillOpacity: '0.8', fill: '#E3F1D3', x: '0', y: '0', width: '360', height: '230', rx: '4' }),
                        react.createElement("text", { id: '15:15:15:15', fontSize: '14', fontWeight: 'normal', "line-spacing": '20' })),
                    react.createElement("g", { id: 'colors/color-darkblue', transform: 'translate(119.992434, 20.000000)' },
                        react.createElement("g", { id: 'icon-successful', transform: 'translate(0.000000, 0.000000)' },
                            react.createElement("path", { d: 'M8.6543374,39.5188617 C8.6543374,22.7945761 38.6745424,21.9485952 51.8537466,31.9910292 C65.0329504,42.0334632 75.0454883,39.5188617 98.677224,44.2466347 C122.30896,48.9744076 126.625832,67.7650864 108.726808,74.7552602 C90.8277835,81.7454336 90.6127793,66.5797479 51.8537466,75.8141931 C13.0947136,85.0486389 -2.75968291,74.5899899 0.389124226,62.7020758 C3.53793137,50.8141621 8.6543374,56.2431473 8.6543374,39.5188617 Z', id: 'Path-5', fillOpacity: '0.05', fill: '#005AFF', fillRule: 'nonzero' }),
                            react.createElement("g", { id: 'Group-2', transform: 'translate(6.367347, 0.000000)' },
                                react.createElement("g", { id: 'search-no-2', transform: 'translate(18.122449, 0.000000)' },
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(45.551020, 0.000000)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '3.91926302', y1: '2.69387755', x2: '3.91926302', y2: '0.404406005', id: 'Line-2' }),
                                        react.createElement("line", { x1: '3.91926302', y1: '7.59183673', x2: '3.91926302', y2: '5.30236521', id: 'Line-2' }),
                                        react.createElement("line", { x1: '1.38963397', y1: '5.06399888', x2: '1.38963397', y2: '2.77452736', id: 'Line-2', transform: 'translate(1.389634, 3.919263) rotate(90.000000) translate(-1.389634, -3.919263) ' }),
                                        react.createElement("line", { x1: '6.28759312', y1: '5.06399892', x2: '6.28759312', y2: '2.77452735', id: 'Line-2', transform: 'translate(6.287593, 3.919263) rotate(90.000000) translate(-6.287593, -3.919263) ' })),
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(0.000000, 60.734694)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '3.91926302', y1: '2.69387755', x2: '3.91926302', y2: '0.404406005', id: 'Line-2' }),
                                        react.createElement("line", { x1: '3.91926302', y1: '7.59183673', x2: '3.91926302', y2: '5.30236521', id: 'Line-2' }),
                                        react.createElement("line", { x1: '1.38963397', y1: '5.06399888', x2: '1.38963397', y2: '2.77452736', id: 'Line-2', transform: 'translate(1.389634, 3.919263) rotate(90.000000) translate(-1.389634, -3.919263) ' }),
                                        react.createElement("line", { x1: '6.28759312', y1: '5.06399892', x2: '6.28759312', y2: '2.77452735', id: 'Line-2', transform: 'translate(6.287593, 3.919263) rotate(90.000000) translate(-6.287593, -3.919263) ' })),
                                    react.createElement("g", { id: 'Group-5', strokeLinecap: 'square', transform: 'translate(66.612245, 27.428571)', stroke: '#F5A623' },
                                        react.createElement("line", { x1: '3.91926302', y1: '2.69387755', x2: '3.91926302', y2: '0.404406005', id: 'Line-2' }),
                                        react.createElement("line", { x1: '3.91926302', y1: '7.59183673', x2: '3.91926302', y2: '5.30236521', id: 'Line-2' }),
                                        react.createElement("line", { x1: '1.38963397', y1: '5.06399888', x2: '1.38963397', y2: '2.77452736', id: 'Line-2', transform: 'translate(1.389634, 3.919263) rotate(90.000000) translate(-1.389634, -3.919263) ' }),
                                        react.createElement("line", { x1: '6.28759312', y1: '5.06399892', x2: '6.28759312', y2: '2.77452735', id: 'Line-2', transform: 'translate(6.287593, 3.919263) rotate(90.000000) translate(-6.287593, -3.919263) ' })),
                                    react.createElement("polygon", { id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2', fill: '#FFFFFF', fillRule: 'nonzero', points: '34.1916891 4.94573579 0.0542772245 14.2199526 12.3389231 60.6869172 46.476335 51.4127006' }),
                                    react.createElement("rect", { id: 'Rectangle', stroke: '#C2C2C2', strokeWidth: '2', fill: '#FFFFFF', fillRule: 'nonzero', x: '17.1428571', y: '15.6734694', width: '39.1836735', height: '48.4897959', rx: '1' }),
                                    react.createElement("rect", { id: 'Rectangle', fill: '#D8D8D8', fillRule: 'nonzero', x: '34.7755102', y: '24', width: '17.1428571', height: '3.42857143' }),
                                    react.createElement("g", { id: 'icons8-change', opacity: '0.5', transform: 'translate(21.551020, 20.571429)', fill: '#000000', fillRule: 'nonzero' },
                                        react.createElement("path", { d: 'M7.19903567,0 L4.60215317,2.61503989 L6.15309176,2.61503989 L6.15309176,3.24699418 L3.01526005,3.24699418 C2.20873919,3.24699418 1.55093859,3.90939413 1.55093859,4.72155418 L1.55093859,7.67067418 L0,7.67067418 L2.59688249,10.2857143 L5.19376519,7.67067418 L3.6428264,7.67067418 L3.6428264,7.03871989 L6.7806581,7.03871989 C7.58717896,7.03871989 8.24497957,6.37631995 8.24497957,5.56415989 L8.24497957,2.61503989 L9.79591837,2.61503989 L7.19903567,0 Z M7.19903567,0.595748571 L8.78592879,2.19373704 L7.82660201,2.19373704 L7.82660201,5.56415989 C7.82660201,6.14838857 7.36083022,6.61741704 6.7806581,6.61741704 L3.6428264,6.61741704 L3.6428264,5.35350847 L6.57146932,5.35350847 L6.57146932,2.19373704 L5.61214275,2.19373704 L7.19903567,0.595748571 Z M3.01526005,3.66829704 L6.15309176,3.66829704 L6.15309176,4.93220561 L3.22444883,4.93220561 L3.22444883,8.09197704 L4.18377561,8.09197704 L2.59688249,9.68996571 L1.00998958,8.09197704 L1.96931615,8.09197704 L1.96931615,4.72155418 C1.96931615,4.13732571 2.43508815,3.66829704 3.01526005,3.66829704 Z', id: 'Shape' }),
                                        react.createElement("path", { d: 'M11.0204082,15.6734694 C7.91020408,15.6734694 5.3877551,18.1959184 5.3877551,21.3061224 C5.3877551,24.4163265 7.91020408,26.9387755 11.0204082,26.9387755 C14.1306122,26.9387755 16.6530612,24.4163265 16.6530612,21.3061224 C16.6530612,18.1959184 14.1306122,15.6734694 11.0204082,15.6734694 Z M11.0204082,17.1428571 C13.322449,17.1428571 15.1836735,19.0040816 15.1836735,21.3061224 C15.1836735,23.6081633 13.322449,25.4693878 11.0204082,25.4693878 C8.71836735,25.4693878 6.85714286,23.6081633 6.85714286,21.3061224 C6.85714286,19.0040816 8.71836735,17.1428571 11.0204082,17.1428571 Z M11.2648909,28.4081633 C7.05611262,28.4081633 3.15549418,31.0930877 1.07676834,35.3770882 C0.871462085,35.7994544 0.999578065,36.372548 1.3845273,36.6139002 C1.51284371,36.7044072 1.64116012,36.7346939 1.76947653,36.7346939 C2.02610935,36.7346939 2.3083051,36.5838488 2.43662151,36.2821586 C4.23305126,32.5412004 7.62070483,30.2183042 11.2648909,30.2183042 C14.9090769,30.2183042 18.2966301,32.5412004 20.1187232,36.2821586 C20.3240294,36.7045249 20.8115317,36.8552523 21.1708176,36.6139002 C21.5301036,36.372548 21.6583199,35.7994544 21.4530137,35.3770882 C19.3742876,31.0930877 15.4736691,28.4081633 11.2648909,28.4081633 Z', id: 'Shape', opacity: '0.699999988' }))),
                                react.createElement("g", { id: 'Group', opacity: '0.5', transform: 'translate(95.020408, 49.469388)', fillRule: 'nonzero' },
                                    react.createElement("g", null,
                                        react.createElement("g", { id: 'Group-13', transform: 'translate(0.664723, 15.020408)' },
                                            react.createElement("polygon", { id: 'Path', fill: '#BCAAA4', points: '6.2082623 6.82745824 1.10369107 6.82745824 0 0 7.31195334 0' }),
                                            react.createElement("path", { d: 'M6.64723033,3.41372913 L6.5369353,4.28949422 C6.06519164,4.57663031 4.95293961,4.77922078 3.65597667,4.77922078 C2.35901375,4.77922078 1.24676172,4.57663031 0.775018036,4.28949422 L0.664723033,3.41372913 C1.05141997,3.74234043 2.24340332,3.98162052 3.65597667,3.98162052 C5.06855001,3.98162052 6.26053337,3.74234043 6.64723033,3.41372913 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("path", { d: 'M6.64723033,2.04823748 L6.54447257,2.91342064 C6.03193685,3.20978172 4.93167678,3.41372913 3.65597667,3.41372913 C2.38027655,3.41372913 1.28001651,3.20978172 0.767480802,2.91342064 L0.664723033,2.04823748 C1.11961414,2.38124536 2.28754392,2.61705955 3.65597667,2.61705955 C5.02440945,2.61705955 6.19233923,2.38124536 6.64723033,2.04823748 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("ellipse", { id: 'Oval', fill: '#BCAAA4', cx: '3.65597667', cy: '6.82745824', rx: '2.99125365', ry: '1' })),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#4E342E', cx: '4.32069971', cy: '15.3617811', rx: '3.65597667', ry: '1.02411874' }),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#424242', cx: '4.32069971', cy: '15.703154', rx: '2.99125365', ry: '1' }),
                                        react.createElement("g", { id: 'Path' },
                                            react.createElement("path", { d: 'M4.55692144,11.7806768 C4.52602856,12.4259921 4.48851579,13.0509647 4.44879639,13.6397725 C4.41569688,14.1392985 4.38039074,14.6083105 4.34618791,15.0411577 C4.32522489,15.3101332 4.30426187,15.5644169 4.28329885,15.8028784 C4.26343915,16.0436002 4.24357944,16.2673698 4.22482306,16.4719268 C4.22261642,16.4990504 4.21930648,16.526174 4.21709984,16.5521674 C4.21599652,16.5634689 4.21489321,16.5736402 4.21489321,16.5849417 C4.21047994,16.6211065 4.20716999,16.6561411 4.20496336,16.6911758 C4.19944677,16.7397722 4.1950335,16.7872385 4.19062024,16.8335746 C4.18289702,16.9160755 4.1751738,16.9951859 4.1685539,17.0686456 L4.06263548,17.0686456 C4.06042885,17.0426522 4.05932553,17.0155286 4.05711889,16.988405 C4.05601558,16.9703227 4.05380894,16.9522403 4.05270563,16.9341578 C4.05160231,16.9081644 4.04939568,16.8844313 4.04718904,16.8618283 C4.03174261,16.6674426 4.01298622,16.4719268 3.98871325,16.2752808 C3.96223365,16.0458605 3.93023745,15.81531 3.893828,15.5824992 C3.64006512,13.9776872 3.17556871,12.3050661 2.71658889,10.526211 C2.37014739,9.18246348 2.02591253,7.77768784 1.77876955,6.29493189 C1.10133299,2.24221631 1.11677943,0.308530773 2.33263463,0.0350346299 C2.43413977,0.0113014935 2.54447146,0 2.66252637,0 C3.52090689,0 4.38480401,1.25107533 4.61098396,6.17739634 C4.62753372,6.53791401 4.63856688,6.90860297 4.64518679,7.28607287 C4.67166639,8.75300674 4.62863704,10.3182636 4.55692144,11.7806768 Z', fill: '#50B704' }),
                                            react.createElement("path", { d: 'M4.44327002,17.0686456 L4.466324,17.0686456 L4.47669829,17.0686456 L4.50321037,17.0686456 L4.52165355,17.0686456 L4.53202784,17.0686456 L4.53894403,17.0686456 L4.54931832,17.0686456 L4.55853991,17.0686456 L4.5769831,17.0686456 L4.60349517,17.0686456 L4.65306122,17.0686456 L4.64614503,16.9531333 L4.63577074,16.7742024 L4.63115995,16.6802071 L4.62539645,16.5839469 L4.62424375,16.5726221 L4.60810597,16.2906361 L4.60810597,16.2815763 L4.54009673,15.1128633 C4.54009673,15.1083335 4.53894403,15.1038035 4.53894403,15.0992736 C4.48707258,14.3801527 4.44211732,13.6598994 4.38563508,12.9407785 C4.3648865,12.7006941 4.34644332,12.4594771 4.32569473,12.2193927 C4.28765568,11.7358264 4.24846391,11.2533925 4.20005056,10.7709586 L4.09861305,9.68718118 L3.98334316,8.60453618 C3.82542341,7.16176452 3.64906048,5.72012532 3.43465849,4.28414852 C3.32630479,3.56616011 3.2133403,2.84930417 3.08539072,2.13471318 C2.95974654,1.42012219 2.82372807,0.707796147 2.65889213,0 C2.81450648,0.710061096 2.94015066,1.42351961 3.05657325,2.13924308 C3.17530124,2.85496654 3.27789144,3.57295495 3.37817624,4.29207583 C3.57182966,5.72918513 3.7309021,7.17195678 3.86922597,8.61586095 L3.96951078,9.69850594 L4.05711589,10.7834159 C4.11936164,11.5048017 4.1608588,12.2295849 4.21273025,12.9521033 C4.24154772,13.3926356 4.26575439,13.8331679 4.28996107,14.2737002 C4.30148806,14.4696182 4.31186235,14.6644037 4.32338934,14.8603217 C4.32338934,14.8705139 4.32338934,14.8807062 4.32454204,14.889766 C4.32915284,14.9679067 4.33376363,15.0460474 4.33837442,15.124188 L4.34990141,15.3880545 C4.35105411,15.3903194 4.35105411,15.3937168 4.35105411,15.3959818 L4.3694973,15.8308517 L4.38909318,16.273649 L4.41214715,16.7809973 L4.41560525,16.8466808 L4.41560525,16.8478132 L4.41675795,16.8738601 L4.42482684,17.0686456 L4.44327002,17.0686456 L4.44327002,17.0686456 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M8.00905298,5.51703649 C7.88970436,5.81881538 7.59735492,6.59813447 7.2261697,7.63280488 C7.2261697,7.6339103 7.2261697,7.6339103 7.2261697,7.6339103 C6.58343897,9.42800233 5.70310589,11.9892539 5.07570431,14.1602931 C5.02424204,14.3371599 4.97496965,14.5107104 4.92788718,14.6809446 C4.92788718,14.6809446 4.92788718,14.6809446 4.92788718,14.68205 C4.72970274,15.3939386 4.56436655,16.0505565 4.45377744,16.6054758 C4.45377744,16.6065813 4.4526825,16.6065813 4.4526825,16.6076867 C4.4264039,16.7381259 4.40341012,16.8630381 4.38260623,16.9813177 C4.37932141,16.9990044 4.37713152,17.0177965 4.3738467,17.0354831 C4.37165682,17.0465373 4.37056187,17.0575915 4.36837199,17.0686456 L4.18661168,17.0686456 C4.18332685,17.050959 4.18223191,17.0332723 4.18004203,17.0155856 C4.17894708,17.0089531 4.17785214,17.0023206 4.1767572,16.9945827 C4.16580778,16.897306 4.15376343,16.7911859 4.14281401,16.6784334 C4.11872529,16.449612 4.09463658,16.1909444 4.07383269,15.9057468 C4.06288327,15.7565155 4.05193385,15.5995463 4.04207938,15.4359445 C4.04207938,15.4337337 4.04207938,15.4304174 4.04098443,15.4282066 C4.0322249,15.2723428 4.02346537,15.1098465 4.01689572,14.9418231 C4.01580078,14.9329797 4.01580078,14.923031 4.01580078,14.9130822 C4.00813619,14.7550076 4.00266148,14.5914058 3.99828171,14.422277 C3.99828171,14.4211716 3.99828171,14.4200662 3.99828171,14.4200662 C3.98185759,13.7822405 3.98404747,13.0791952 4.01799066,12.3352494 C4.08697199,10.8296713 4.28734631,9.15496428 4.72970274,7.50015482 C4.93007706,6.74957657 5.17972374,6.00342 5.49068718,5.27826637 C6.51883739,2.87951117 7.24259383,2.04823748 7.89955881,2.04823748 C8.03971136,2.04823748 8.15577517,2.07476749 8.25213002,2.12230043 C9.13136821,2.56004562 8.28497829,4.82504535 8.00905298,5.51703649 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M8.6413994,2.04823748 C7.98250266,3.18468283 7.44542762,4.39444723 6.97508973,5.62754042 C6.50898911,6.8628554 6.10538836,8.12483187 5.79818567,9.4134698 C5.48886436,10.6998859 5.23462766,12.0029655 5.09056021,13.3204867 L5.04500949,13.6981909 L5.04500949,13.7026345 L5.03123833,13.8148348 L5.00157737,14.0614535 L4.98462823,14.309183 L4.91365386,15.301212 C4.9115352,15.3256517 4.90941654,15.3489805 4.90729793,15.3734202 C4.89564541,15.523391 4.88928949,15.6744727 4.88611153,15.8244435 C4.88293357,15.9733034 4.88081493,16.1221633 4.87763697,16.2710232 C4.87657765,16.2787994 4.87657765,16.2865757 4.87657765,16.294352 L4.87339969,16.4487664 L4.8681031,16.7553733 L4.86492514,16.8831262 L4.86492514,16.9242293 L4.86174718,17.0686456 L4.65306122,17.0686456 L4.6572985,16.9364492 L4.6572985,16.9186749 L4.65941714,16.8653519 L4.66577306,16.6764998 L4.67848489,16.2865757 C4.67954422,16.2565816 4.68060353,16.2254765 4.68166285,16.1954824 C4.68801877,15.9932995 4.69225605,15.7922276 4.70390856,15.5911556 C4.71026448,15.4900642 4.71767972,15.3889728 4.72827291,15.2878813 L4.74098475,15.1367997 L4.81301848,14.2914087 L4.83420487,14.0425683 L4.86704378,13.7948388 L4.93272157,13.2993797 C4.99204349,12.820584 5.06407724,12.3440102 5.14882281,11.870769 C5.29924619,11.0342653 5.48674575,10.2055378 5.69543167,9.38458653 C6.02064279,8.0959486 6.44225197,6.8373048 6.92636101,5.6064334 C7.41364805,4.3788947 7.96767218,3.17579567 8.6413994,2.04823748 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M4.40089729,17.0686456 L4.41107432,17.0686456 L4.43708226,17.0686456 L4.45517473,17.0686456 L4.46535175,17.0686456 L4.47213643,17.0686456 L4.48231345,17.0686456 L4.49135969,17.0686456 L4.50945217,17.0686456 L4.53546011,17.0686456 L4.58408365,17.0686456 L4.60104535,17.0686456 L4.62479173,17.0686456 L4.63723031,17.0686456 L4.65306122,17.0686456 C4.64853811,17.0390462 4.64401498,17.0105429 4.63949186,16.9820398 C4.63383796,16.9359961 4.62705329,16.8910487 4.6202686,16.8461014 C4.61574549,16.8165019 4.61122237,16.7879987 4.60783003,16.7594954 C4.59878379,16.7035853 4.59086833,16.6487714 4.58295287,16.5950539 C4.57842975,16.5665506 4.57390663,16.5380474 4.57051429,16.5106405 C4.56938351,16.5040629 4.56825273,16.4963889 4.56712195,16.4898112 C4.55807571,16.4306123 4.54902947,16.3725096 4.53998323,16.3155031 L4.53998323,16.3067329 C4.50266749,16.0600705 4.46761331,15.828756 4.43255913,15.6105969 C4.36584312,15.1731822 4.30251944,14.7883889 4.2425881,14.4441578 C4.2425881,14.4430616 4.2425881,14.4419653 4.2425881,14.4419653 C4.2369342,14.4156546 4.23241108,14.389344 4.22788797,14.3630333 C3.93501596,12.72081 3.67493657,11.997267 3.02134576,10.7222965 C2.84381331,10.3747766 2.63688058,9.98669447 2.39150133,9.52735425 C1.66214827,8.16029652 1.0345654,7.51020407 0.35609743,7.51020407 C0.273550494,7.51020407 0.207965257,7.52993706 0.15594938,7.56611422 C-0.294101039,7.87526439 0.313127792,9.42649675 0.921487401,10.5951283 C1.45408476,11.6190513 2.31121596,13.234964 3.0812771,14.6787612 C3.43294966,15.3387201 3.76652975,15.9635981 4.04244005,16.4799448 C4.15891039,16.6970076 4.2652037,16.8954338 4.35792766,17.0686456 L4.3782817,17.0686456 L4.40089729,17.0686456 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M8.59674877,9.82018536 C8.07875662,10.8310326 7.55054772,11.8695288 6.95695122,13.0573296 C6.82515438,13.3194421 6.69029256,13.5904022 6.5503223,13.871316 C6.51762852,13.9376736 6.48493474,14.0051371 6.45121925,14.0726007 C6.00780984,14.968428 5.52455486,15.9527323 4.98408578,17.0686456 L4.65306122,17.0686456 C4.66327803,16.920447 4.6755382,16.7545531 4.69086341,16.5731757 C4.69801517,16.4880168 4.70618862,16.39954 4.71436207,16.3088513 L4.71436207,16.3000036 C4.74092576,16.0201958 4.77361955,15.711633 4.8134651,15.3809511 C4.82572526,15.2836266 4.83798543,15.1851961 4.85126728,15.0845538 C5.09544896,13.2132699 5.58483404,10.764675 6.55338735,8.98186785 C6.8466097,8.44215953 7.15720065,7.98318622 7.45757476,7.62927909 C7.45757476,7.62927909 7.45757476,7.62927909 7.45757476,7.62817313 C7.88770232,7.11943166 8.29535295,6.82745824 8.59674877,6.82745824 C8.75408758,6.82745824 8.87975432,6.85621322 8.97987899,6.90929927 C9.79007182,7.33177592 8.86953747,9.28711278 8.59674877,9.82018536 Z', fill: '#94E93A' }),
                                            react.createElement("path", { d: 'M4.65306122,17.0686456 L4.45178249,17.0686456 C4.44775691,17.0432829 4.44272495,17.0168175 4.43769297,16.990352 C4.4336674,16.9727084 4.43064822,16.9550647 4.42662264,16.9374211 C4.42561625,16.9319074 4.42460986,16.9263938 4.42259707,16.9197774 C4.42159068,16.9131611 4.42058428,16.9076474 4.4185715,16.9010311 C4.41152674,16.8635383 4.40448198,16.8260456 4.39542444,16.7885529 C4.25050375,16.09604 4.06331452,15.4112463 3.85297824,14.7363771 C3.58326473,13.8960987 3.27329547,13.0690532 2.94219195,12.2530348 C2.60706286,11.439222 2.24677391,10.6375392 1.86736349,9.84578082 C1.48694667,9.05512526 1.09042756,8.27329146 0.664723033,7.51020407 C1.10451707,8.26446965 1.51613209,9.03748158 1.91164481,9.82041811 C2.30615114,10.6033546 2.68254238,11.3984211 3.03377378,12.2067203 C3.3809796,13.0183277 3.70805755,13.8398596 3.99487975,14.6812407 C4.0985383,14.9911071 4.19716488,15.303179 4.28874671,15.6185591 C4.31290016,15.7001609 4.33604721,15.7817627 4.35818787,15.8633645 C4.36321984,15.8788027 4.36724542,15.8931382 4.37127099,15.9085764 C4.39844362,16.0056164 4.42460986,16.1037591 4.4497697,16.2019019 C4.48298069,16.3254073 4.5131725,16.4500155 4.54336431,16.5746237 C4.55141546,16.6088083 4.55946661,16.6418901 4.56651137,16.6760747 C4.56953055,16.6837938 4.57154333,16.6926156 4.57254973,16.7003347 C4.57556891,16.7102592 4.5775817,16.7190811 4.57858809,16.7290056 C4.58362006,16.7466492 4.58764563,16.7642928 4.59066481,16.7819365 C4.60072875,16.8216347 4.6097863,16.8613329 4.61783744,16.9021338 C4.61985024,16.9098529 4.62186302,16.917572 4.62387581,16.9252911 C4.63192696,16.9616811 4.6399781,16.9980711 4.64702286,17.0355638 C4.65004204,17.0465911 4.65205483,17.0576184 4.65306122,17.0686456 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M9.30612245,6.82745824 C8.80639822,7.64242756 8.33645892,8.47634963 7.88416986,9.31807577 C7.43077773,10.1609168 6.99944841,11.0149065 6.60231659,11.8845044 C6.24379479,12.6682574 5.90182016,13.463159 5.61389961,14.2758986 C5.58190844,14.3628584 5.55212356,14.4498182 5.52233868,14.5378928 C5.33149474,15.1009017 5.15609486,15.6705998 5.02482073,16.248102 C5.02371762,16.2492168 5.02371762,16.2503317 5.02371762,16.2514466 C4.96194152,16.5223598 4.91009378,16.7943879 4.87148373,17.0686456 L4.65306122,17.0686456 C4.66519581,16.9906048 4.67843353,16.9136788 4.69277441,16.8367529 C4.69939327,16.7988473 4.70711528,16.7620566 4.71373414,16.725266 C4.71704357,16.7118875 4.71924986,16.6985091 4.72255929,16.6862455 C4.72807501,16.6527995 4.73469388,16.6193534 4.74241588,16.5870222 C4.75124104,16.5401977 4.76227248,16.4933732 4.77220077,16.4465487 C4.89023717,15.9192156 5.04688364,15.4041461 5.22118036,14.8968807 C5.26861558,14.757522 5.31715391,14.6192783 5.36679536,14.4810345 C5.40871484,14.3650881 5.45173744,14.2502566 5.4958632,14.1354251 C5.79481523,13.3516721 6.14009927,12.5891016 6.50303363,11.836565 C6.91781579,10.9725415 7.36679535,10.125241 7.83563153,9.29131891 C8.30557087,8.45739683 8.79095422,7.63239375 9.30612245,6.82745824 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M6.89821004,14.7493904 C6.15384083,15.3757426 5.46529935,16.3787822 5.04057105,17.0686456 L4.65306122,17.0686456 C4.66838647,16.9460033 4.6869957,16.8146007 4.70888891,16.678818 C4.71436222,16.6492525 4.71874086,16.6196869 4.72421416,16.5890263 C4.72530882,16.5824562 4.72640348,16.575886 4.72749814,16.5682209 C4.73187678,16.5496055 4.73516077,16.5309901 4.73844475,16.5112798 C4.75267534,16.4357233 4.76800058,16.3601668 4.78442049,16.2824203 C4.88075062,15.8247014 5.02305649,15.345082 5.22556869,14.935544 C5.2638818,14.8556074 5.30547894,14.7778609 5.35036002,14.7044945 C5.35036002,14.7033995 5.35036002,14.7033995 5.35036002,14.7033995 C5.38976777,14.6366032 5.43136487,14.5730919 5.4751513,14.5128658 C5.52112707,14.4482595 5.56819744,14.3858433 5.61526785,14.3256171 C6.11881171,13.6817446 6.65738469,13.2820617 7.11166883,13.0970031 C7.31637037,13.0126865 7.50465198,12.9721707 7.66447244,12.9721707 C7.78050647,12.9721707 7.86260601,13.0017362 7.91296036,13.0564873 C8.14940704,13.3039622 7.70935352,14.067192 6.89821004,14.7493904 Z', fill: '#AEF265' }),
                                            react.createElement("path", { d: 'M3.92007622,17.0686456 L3.94015327,17.0686456 L3.94918794,17.0686456 L3.97227655,17.0686456 L3.98833819,17.0686456 C3.98030737,17.0503353 3.9732804,17.0331694 3.96625344,17.0137147 C3.95621491,16.9896824 3.94617638,16.9656501 3.93513401,16.9404734 C3.93413015,16.9370402 3.93212245,16.9336071 3.9311186,16.9290295 C3.92911089,16.9244519 3.92710319,16.9198743 3.92409163,16.9141524 C3.92208392,16.9084304 3.91907236,16.901564 3.9160608,16.8946977 C3.91003769,16.8786761 3.90301072,16.8615102 3.89598375,16.8454887 L3.89598375,16.8443443 C3.61791658,16.179451 3.21838325,15.3039891 2.76865728,14.5738654 C2.73251859,14.5132125 2.69537604,14.4548483 2.6582335,14.3976286 C2.25669246,13.7785111 1.94750586,13.6549165 1.6543809,13.6549165 C1.54596481,13.6549165 1.46666046,13.688104 1.41446013,13.7476125 C1.12535058,14.0714761 1.61523065,15.1666618 2.25669246,15.7594582 C2.71244154,16.1817398 3.29166449,16.6543748 3.71629414,17.0686456 L3.88895679,17.0686456 L3.90200687,17.0686456 L3.90401457,17.0686456 L3.92007622,17.0686456 L3.92007622,17.0686456 Z', fill: '#A9E965' }),
                                            react.createElement("path", { d: 'M7.97667639,12.9721707 C7.55257812,13.1711807 7.18177558,13.4618694 6.84499166,13.7771548 C6.7554094,13.8621254 6.66922898,13.949332 6.58531651,14.0398927 C6.35512413,14.2880962 6.14534287,14.5564243 5.95257096,14.8336966 L5.76433479,15.1232672 C5.70083344,15.2194181 5.64980557,15.3222772 5.59084007,15.4217822 C5.47290896,15.6196742 5.37992488,15.8298645 5.28013704,16.0355826 C5.22684127,16.1384417 5.18828689,16.2457729 5.14406273,16.3519861 L5.01592609,16.6717437 C4.96943402,16.8036717 4.92634379,16.9355997 4.88211965,17.0686456 L4.65306122,17.0686456 C4.66780261,17.0306325 4.68141004,16.9926193 4.69501747,16.9546062 C4.70295514,16.9355997 4.70975885,16.9177111 4.71542862,16.8998226 C4.71883048,16.8931144 4.72109838,16.8875242 4.72223233,16.881934 C4.7279021,16.8685176 4.73243791,16.8551012 4.73810767,16.8416848 C4.76759044,16.7611864 4.79820716,16.681806 4.82995783,16.6024256 C4.82995783,16.6013076 4.83109179,16.6013076 4.83109179,16.6001896 L4.97510376,16.280432 C4.97963956,16.2703697 4.98417541,16.2603074 4.98984514,16.249127 C4.98984514,16.248009 4.98984514,16.246891 4.99097912,16.2457729 C5.03406931,16.1507401 5.07375767,16.0545892 5.12591946,15.9640285 C5.23704681,15.7571923 5.34023652,15.54812 5.46837316,15.3513461 C5.53187451,15.2529592 5.58743819,15.1501001 5.65660932,15.0550672 L5.85958682,14.7688506 C6.11132429,14.4356766 6.38800873,14.1192731 6.69530993,13.8364106 C6.73159641,13.8028696 6.76901682,13.7693286 6.80643727,13.7369056 C7.16023048,13.4316825 7.54464044,13.1544101 7.97667639,12.9721707 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M3.90876777,17.0686456 L3.92943541,17.0686456 L3.93873585,17.0686456 L3.96250364,17.0686456 L3.97903776,17.0686456 L3.98833819,17.0686456 L3.96353702,17.0098288 C3.96043687,17.0027708 3.95733673,16.9957128 3.9532032,16.9898311 C3.94493615,16.9710097 3.93460232,16.954541 3.9242685,16.936896 C3.92323512,16.9345433 3.92116836,16.9321906 3.92013498,16.9286616 C3.91806821,16.9251326 3.91496807,16.9216035 3.9129013,16.9168982 C3.91186792,16.9145455 3.91083454,16.9121928 3.90876777,16.9098402 C3.90360086,16.9016058 3.89946733,16.8933715 3.89430042,16.8839608 C3.89120028,16.8780791 3.88810013,16.8721974 3.88499999,16.8663157 C3.84159793,16.7875011 3.7919956,16.716921 3.74446002,16.6439881 C3.69795782,16.5734079 3.65042225,16.5051804 3.60185329,16.4369528 C3.54398389,16.3534329 3.48404773,16.2722657 3.42307819,16.1910984 C3.2029678,15.8946616 2.97459036,15.6088118 2.74414615,15.3241383 C2.28222435,14.757144 1.80893536,14.2019131 1.32944606,13.6549165 C1.79756815,14.2148528 2.25742319,14.7841997 2.70591101,15.3641337 C2.93015493,15.6535126 3.15129869,15.9464204 3.36314203,16.2475626 C3.47061376,16.3969574 3.57395197,16.5498812 3.67212327,16.7051576 C3.71965885,16.7827958 3.77029457,16.8604341 3.81162985,16.9416013 C3.83229749,16.9827731 3.85709867,17.0227685 3.87466616,17.062764 L3.87673293,17.0686456 L3.89016689,17.0686456 L3.89223366,17.0686456 L3.90876777,17.0686456 L3.90876777,17.0686456 Z', fill: '#4EB9E3' })),
                                        react.createElement("path", { d: 'M5.31778428,15.7919599 C5.31778428,15.9853069 5.06657109,16.3858998 4.32069971,16.3858998 C3.57482831,16.3858998 3.32361516,15.9851693 3.32361516,15.7919599 C3.32361516,15.5987505 3.61893973,15.7812261 4.36481113,15.7812261 C5.11068255,15.7812261 5.31778428,15.5986129 5.31778428,15.7919599 Z', id: 'Path', fill: '#424242' }),
                                        react.createElement("path", { d: 'M7.97667639,16.1908296 C7.97667639,16.6756767 6.33982506,17.0686456 4.32069971,17.0686456 C2.30157434,17.0686456 0.664723033,16.6756767 0.664723033,16.1908296 L0.664723033,15.0204082 C0.664723033,15.5052552 2.30157434,15.8982242 4.32069971,15.8982242 C6.33982506,15.8982242 7.97667639,15.5052552 7.97667639,15.0204082 L7.97667639,16.1908296 Z', id: 'Path', fill: '#8D6E63' }))),
                                react.createElement("g", { id: 'Group', opacity: '0.5', transform: 'translate(0.000000, 49.469388)', fillRule: 'nonzero' },
                                    react.createElement("g", null,
                                        react.createElement("g", { id: 'Group-13', transform: 'translate(0.384840, 8.816327)' },
                                            react.createElement("polygon", { id: 'Path', fill: '#BCAAA4', points: '3.59425711 4.00742115 0.638979042 4.00742115 0 0 4.23323615 0' }),
                                            react.createElement("path", { d: 'M3.8483965,2.00371057 L3.7845415,2.51774661 C3.51142673,2.68628301 2.86749135,2.80519481 2.11661808,2.80519481 C1.3657448,2.80519481 0.721809419,2.68628301 0.448694652,2.51774661 L0.38483965,2.00371057 C0.608716824,2.19659112 1.29881245,2.33703813 2.11661808,2.33703813 C2.9344237,2.33703813 3.62451933,2.19659112 3.8483965,2.00371057 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("path", { d: 'M3.8483965,1.20222634 L3.78890516,1.71005124 C3.49217396,1.88400231 2.85518131,2.00371057 2.11661808,2.00371057 C1.37805484,2.00371057 0.741062189,1.88400231 0.444330991,1.71005124 L0.38483965,1.20222634 C0.648197657,1.3976875 1.32436753,1.53610017 2.11661808,1.53610017 C2.90886862,1.53610017 3.58503849,1.3976875 3.8483965,1.20222634 Z', id: 'Path', fill: '#CCBDB8' }),
                                            react.createElement("ellipse", { id: 'Oval', fill: '#BCAAA4', cx: '2.11661808', cy: '4.00742115', rx: '1.73177843', ry: '1' })),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#4E342E', cx: '2.50145773', cy: '9.01669758', rx: '2.11661808', ry: '1' }),
                                        react.createElement("ellipse", { id: 'Oval', fill: '#424242', cx: '2.50145773', cy: '9.21706864', rx: '1.73177843', ry: '1' }),
                                        react.createElement("g", { id: 'Path' },
                                            react.createElement("path", { d: 'M2.63821768,6.91474511 C2.62033233,7.29351713 2.5986144,7.66034885 2.57561896,8.00595345 C2.55645609,8.29915347 2.53601569,8.57444312 2.51621405,8.8285056 C2.50407757,8.98638255 2.49194109,9.135636 2.4798046,9.27560253 C2.46830688,9.41689577 2.45680915,9.54823876 2.44595019,9.66830483 C2.44467267,9.68422521 2.44275638,9.70014558 2.44147886,9.71540258 C2.44084009,9.72203608 2.44020133,9.7280062 2.44020133,9.73463971 C2.43764628,9.75586687 2.43573,9.77643066 2.43445247,9.79699445 C2.43125866,9.82551845 2.42870361,9.85337907 2.42614856,9.88057636 C2.42167722,9.92900082 2.41720588,9.97543523 2.41337331,10.0185529 L2.35205212,10.0185529 C2.35077459,10.0032959 2.35013583,9.98737548 2.34885831,9.97145515 C2.34821954,9.96084157 2.34694202,9.95022798 2.34630326,9.9396144 C2.34566449,9.9243574 2.34438697,9.91042707 2.34310944,9.89716011 C2.33416677,9.78306416 2.32330781,9.66830483 2.30925504,9.55288222 C2.29392474,9.41822243 2.27540063,9.28289936 2.25432147,9.14624953 C2.10740612,8.20429464 1.83848715,7.22253879 1.57276199,6.17842824 C1.3721906,5.38970684 1.17289673,4.56516459 1.02981395,3.69485132 C0.637613838,1.31608349 0.646556513,0.181094149 1.35047268,0.0205638045 C1.40923882,0.00663348534 1.47311506,0 1.54146264,0 C2.03841978,0 2.53857074,0.734326824 2.66951703,3.62586308 C2.67909847,3.83747126 2.68548609,4.05504958 2.68931867,4.27660799 C2.70464897,5.1376344 2.67973723,6.05637208 2.63821768,6.91474511 Z', fill: '#50B704' }),
                                            react.createElement("path", { d: 'M2.57241949,10.0185529 L2.58576653,10.0185529 L2.5917727,10.0185529 L2.60712179,10.0185529 L2.61779942,10.0185529 L2.62380559,10.0185529 L2.6278097,10.0185529 L2.63381587,10.0185529 L2.63915469,10.0185529 L2.64983232,10.0185529 L2.66518142,10.0185529 L2.69387755,10.0185529 L2.68987344,9.95075216 L2.68386727,9.84572753 L2.68119786,9.79055633 L2.6778611,9.73405577 L2.67719375,9.7274086 L2.66785082,9.5618951 L2.66785082,9.55657739 L2.62847706,8.87059371 C2.62847706,8.86793486 2.6278097,8.865276 2.6278097,8.86261714 C2.59777886,8.44052444 2.57175214,8.01776704 2.53905189,7.59567433 C2.52703955,7.4547552 2.51636192,7.31317136 2.50434959,7.17225223 C2.48232697,6.8884198 2.459637,6.60525213 2.43160822,6.32208441 L2.37288124,5.68595417 L2.30614604,5.05048864 C2.21471882,4.2036444 2.11261396,3.35746488 1.98848649,2.51460891 C1.92575541,2.09318093 1.86035491,1.67241767 1.78627884,1.25298382 C1.71353747,0.83354998 1.63478994,0.415445565 1.5393586,0 C1.62945112,0.41677499 1.70219249,0.835544121 1.76959504,1.25564267 C1.8383323,1.67574123 1.89772662,2.09716921 1.95578624,2.5192619 C2.06790138,3.36278257 2.15999595,4.20962682 2.24007819,5.05713576 L2.29813782,5.69260129 L2.34885657,6.32939628 C2.38489358,6.75281838 2.40891825,7.17823464 2.43894909,7.60232145 C2.45563289,7.86089481 2.46964728,8.11946811 2.48366167,8.37804142 C2.49033519,8.49303678 2.49634136,8.6073674 2.50301488,8.72236271 C2.50301488,8.72834513 2.50301488,8.73432754 2.50368223,8.73964526 C2.50635164,8.78551043 2.50902105,8.83137561 2.51169046,8.87724083 L2.51836398,9.03211891 C2.51903133,9.03344836 2.51903133,9.03544251 2.51903133,9.03677192 L2.52970896,9.29202167 L2.54105395,9.55192442 L2.55440098,9.84971579 L2.55640304,9.88826914 L2.55640304,9.88893384 L2.55707039,9.90422224 L2.56174186,10.0185529 L2.57241949,10.0185529 L2.57241949,10.0185529 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M4.63682016,3.23826054 C4.56772358,3.41539162 4.39846865,3.87281805 4.18357194,4.48012461 C4.18357194,4.48077344 4.18357194,4.48077344 4.18357194,4.48077344 C3.81146466,5.53382748 3.30179813,7.03717073 2.93856565,8.31147639 C2.90877171,8.41528947 2.8802456,8.5171561 2.85298731,8.61707618 C2.85298731,8.61707618 2.85298731,8.61707618 2.85298731,8.61772501 C2.73824895,9.0355727 2.642528,9.42097881 2.57850273,9.74669236 C2.57850273,9.74734119 2.57786881,9.74734119 2.57786881,9.74799002 C2.56265489,9.82455218 2.5493427,9.89787017 2.53729834,9.96729517 C2.5353966,9.97767649 2.53412878,9.9887066 2.53222704,9.99908792 C2.53095921,10.0055762 2.53032529,10.0120646 2.52905747,10.0185529 L2.42382781,10.0185529 C2.42192607,10.0081716 2.42129216,9.99779025 2.42002433,9.98740893 C2.41939042,9.98351593 2.4187565,9.97962299 2.41812259,9.97508116 C2.41178346,9.91798393 2.4048104,9.8556961 2.39847127,9.78951527 C2.38452517,9.65520705 2.37057907,9.50338041 2.35853472,9.33598183 C2.35219558,9.24838952 2.34585644,9.15625543 2.34015122,9.06022829 C2.34015122,9.05893063 2.34015122,9.05698413 2.33951731,9.05568647 C2.334446,8.96420121 2.32937469,8.86882291 2.3255712,8.77020049 C2.32493729,8.76500983 2.32493729,8.75917033 2.32493729,8.75333084 C2.3204999,8.66054792 2.31733033,8.56452078 2.31479468,8.46524953 C2.31479468,8.4646007 2.31479468,8.46395187 2.31479468,8.46395187 C2.30528597,8.08957592 2.3065538,7.67691889 2.32620512,7.2402551 C2.36614168,6.3565462 2.48214786,5.37356601 2.73824895,4.4022648 C2.85425514,3.961708 2.99878744,3.52374653 3.1788189,3.09811287 C3.77406376,1.69014786 4.19308064,1.20222634 4.5734288,1.20222634 C4.65456974,1.20222634 4.72176458,1.21779831 4.77754897,1.24569808 C5.28658158,1.50263547 4.79656638,2.83209183 4.63682016,3.23826054 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M5.00291544,1.20222634 C4.6214489,1.86927035 4.31051073,2.57934946 4.03820984,3.30312155 C3.76836212,4.02819774 3.53469852,4.76892305 3.35684434,5.52529749 C3.17776358,6.28036785 3.03057391,7.04521886 2.94716643,7.81854651 L2.92079496,8.0402425 L2.92079496,8.04285066 L2.91282218,8.1087074 L2.89565005,8.25346183 L2.88583741,8.39886833 L2.84474696,8.98114619 C2.84352038,8.99549123 2.8422938,9.00918421 2.84106722,9.02352926 C2.83432103,9.11155558 2.83064128,9.20023396 2.82880141,9.28826033 C2.82696154,9.37563458 2.82573496,9.46300888 2.82389509,9.55038318 C2.8232818,9.55494749 2.8232818,9.55951185 2.8232818,9.56407616 L2.82144193,9.65471069 L2.81837548,9.83467562 L2.8165356,9.90966103 L2.8165356,9.93378676 L2.81469574,10.0185529 L2.69387755,10.0185529 L2.69633071,9.94095928 L2.69633071,9.93052653 L2.69755729,9.89922828 L2.70123703,9.78838031 L2.70859652,9.55951185 C2.70920981,9.54190658 2.7098231,9.52364924 2.71043639,9.50604397 C2.71411613,9.38737146 2.71656929,9.26935097 2.72331549,9.15133048 C2.72699522,9.0919942 2.73128826,9.03265793 2.73742116,8.97332165 L2.74478064,8.88464327 L2.78648438,8.38843558 L2.79875019,8.24237706 L2.81776219,8.09697056 L2.85578618,7.80615767 C2.89013044,7.5251254 2.93183418,7.24539727 2.9808974,6.96762529 C3.06798462,6.47663398 3.176537,5.99020692 3.29735519,5.50834428 C3.4856353,4.75196983 3.72972483,4.01320066 4.00999849,3.29073266 C4.29211202,2.5702208 4.61286284,1.86405398 5.00291544,1.20222634 Z', fill: '#2BC2FD' }),
                                            react.createElement("path", { d: 'M2.54788791,10.0185529 L2.55377987,10.0185529 L2.5688371,10.0185529 L2.57931169,10.0185529 L2.58520365,10.0185529 L2.58913162,10.0185529 L2.59502358,10.0185529 L2.60026087,10.0185529 L2.61073547,10.0185529 L2.6257927,10.0185529 L2.65394316,10.0185529 L2.6637631,10.0185529 L2.677511,10.0185529 L2.68471228,10.0185529 L2.69387755,10.0185529 C2.6912589,10.0011792 2.68864026,9.98444914 2.68602161,9.96771899 C2.6827483,9.94069337 2.67882032,9.9143112 2.67489235,9.88792908 C2.6722737,9.87055543 2.66965506,9.85382532 2.66769107,9.83709517 C2.66245377,9.80427835 2.65787113,9.77210498 2.6532885,9.7405751 C2.65066986,9.72384495 2.64805121,9.70711479 2.64608722,9.69102813 C2.64543256,9.68716731 2.6447779,9.68266305 2.64412323,9.67880224 C2.63888593,9.64405504 2.63364864,9.60995128 2.62841135,9.57649097 L2.62841135,9.57134327 C2.6068075,9.42656317 2.58651297,9.29079159 2.56621845,9.16274165 C2.52759338,8.90599827 2.49093231,8.68014132 2.45623522,8.47809267 C2.45623522,8.47744918 2.45623522,8.47680573 2.45623522,8.47680573 C2.45296191,8.46136251 2.45034326,8.4459193 2.44772461,8.43047608 C2.27816713,7.46656237 2.12759486,7.04187409 1.74920018,6.29352186 C1.64641824,6.08954278 1.52661507,5.86175544 1.3845534,5.59214273 C0.962296364,4.78973926 0.598958914,4.40816327 0.20616167,4.40816327 C0.158371339,4.40816327 0.120400938,4.41974568 0.0902864831,4.44098009 C-0.170269023,4.62243781 0.181284511,5.53294374 0.533492709,6.21887966 C0.841838542,6.81987796 1.3380724,7.76834846 1.78389727,8.61579463 C1.98749717,9.00316178 2.18062248,9.36993806 2.34036003,9.67301104 C2.40779022,9.80041753 2.46932846,9.91688508 2.52301075,10.0185529 L2.53479467,10.0185529 L2.54788791,10.0185529 Z', fill: '#6FB920' }),
                                            react.createElement("path", { d: 'M4.97706504,5.76402186 C4.67717489,6.35734521 4.37136972,6.96689736 4.0277086,7.66408477 C3.95140518,7.81793339 3.87332727,7.97697522 3.79229185,8.14185938 C3.77336387,8.18080839 3.7544359,8.22040658 3.73491642,8.26000472 C3.4782057,8.78581646 3.1984265,9.36356023 2.88552334,10.0185529 L2.69387755,10.0185529 C2.69979255,9.93156676 2.70689054,9.8341942 2.71576303,9.72773353 C2.71990352,9.67774898 2.72463552,9.62581695 2.72936751,9.57258661 L2.72936751,9.5673934 C2.7447465,9.40315842 2.76367447,9.22204545 2.78674295,9.02794952 C2.79384094,8.97082428 2.80093894,8.91304991 2.80862843,8.85397724 C2.94999677,7.75561494 3.23332496,6.3183962 3.79406635,5.27196593 C3.96382667,4.95518057 4.14364247,4.68578321 4.31754328,4.47805512 C4.31754328,4.47805512 4.31754328,4.47805512 4.31754328,4.47740596 C4.56656451,4.17879683 4.80257275,4.00742115 4.97706504,4.00742115 C5.06815597,4.00742115 5.1409104,4.02429906 5.19887731,4.05545827 C5.66793629,4.30343369 5.13499538,5.45113141 4.97706504,5.76402186 Z', fill: '#94E93A' }),
                                            react.createElement("path", { d: 'M2.69387755,10.0185529 L2.57734776,10.0185529 C2.57501716,10.003666 2.57210392,9.98813197 2.56919067,9.97259789 C2.56686007,9.96224184 2.56511213,9.9518858 2.56278153,9.94152975 C2.56219888,9.93829352 2.56161624,9.93505724 2.56045094,9.9311737 C2.55986829,9.9272902 2.55928564,9.92405393 2.55812034,9.92017043 C2.5540418,9.8981638 2.54996326,9.87615722 2.54471941,9.8541506 C2.46081796,9.44767567 2.35244525,9.04573151 2.23067161,8.64961264 C2.07452169,8.15640578 1.8950658,7.67096601 1.70337429,7.19199874 C1.50935218,6.71432596 1.30076384,6.243773 1.08110518,5.77904527 C0.860863866,5.31496482 0.631300168,4.85606239 0.38483965,4.40816327 C0.639457254,4.85088436 0.877760684,5.30460877 1.10674174,5.76415847 C1.33514014,6.22370811 1.55305085,6.69037758 1.75639535,7.16481409 C1.95740924,7.64119234 2.14677016,8.12339589 2.31282512,8.61724996 C2.37283797,8.79912808 2.42993757,8.98230073 2.48295862,9.16741509 C2.4969422,9.21531184 2.51034312,9.26320854 2.5231614,9.31110529 C2.52607464,9.32016681 2.52840524,9.32858111 2.53073584,9.33764263 C2.54646736,9.3946009 2.56161624,9.45220643 2.57618246,9.50981197 C2.59540988,9.58230431 2.61288935,9.65544392 2.63036881,9.72858348 C2.63503001,9.74864836 2.6396912,9.76806593 2.64376974,9.78813076 C2.64551769,9.79266157 2.64668299,9.79783959 2.64726563,9.80237035 C2.64901358,9.80819564 2.65017888,9.81337367 2.65076153,9.81919891 C2.65367477,9.82955496 2.65600537,9.839911 2.65775331,9.85026705 C2.6635798,9.87356821 2.66882365,9.89686932 2.67348484,9.92081765 C2.67465014,9.92534846 2.67581544,9.92987922 2.67698073,9.93440998 C2.68164192,9.95576934 2.68630312,9.9771287 2.69038166,9.99913528 C2.69212961,10.0056078 2.6932949,10.0120803 2.69387755,10.0185529 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M5.3877551,4.00742115 C5.09844108,4.4857727 4.82637095,4.97524869 4.56451941,5.46930534 C4.30202921,5.96401641 4.05231225,6.4652712 3.82239382,6.97568738 C3.61482858,7.43571629 3.41684327,7.90228898 3.25015241,8.37933179 C3.2316312,8.43037342 3.21438732,8.481415 3.19714344,8.533111 C3.08665486,8.86357273 2.98510755,9.19796077 2.90910674,9.53692942 C2.90846808,9.53758379 2.90846808,9.5382382 2.90846808,9.53889257 C2.87270299,9.69790682 2.84268586,9.85757549 2.82033268,10.0185529 L2.69387755,10.0185529 C2.70090284,9.9727463 2.70856679,9.92759412 2.71686939,9.88244189 C2.72070137,9.86019301 2.725172,9.83859845 2.72900398,9.81700393 C2.73091996,9.80915138 2.73219729,9.80129882 2.73411328,9.79410064 C2.73730658,9.77446927 2.74113856,9.75483786 2.7456092,9.73586087 C2.75071849,9.7083769 2.75710512,9.68089298 2.76285308,9.65340901 C2.83118995,9.34388743 2.92187999,9.04156403 3.02278863,8.74382126 C3.05025111,8.66202382 3.07835225,8.5808807 3.10709206,8.49973763 C3.13136122,8.43168216 3.15626905,8.36428104 3.18181554,8.29687993 C3.35489303,7.83685102 3.55479432,7.38925533 3.76491422,6.94754904 C4.00505124,6.4404048 4.26498679,5.94307626 4.53641827,5.45360023 C4.8084884,4.96412424 5.0894998,4.47988328 5.3877551,4.00742115 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M3.99370055,8.65725086 C3.56274997,9.02489241 3.16412068,9.61363303 2.91822535,10.0185529 L2.69387755,10.0185529 C2.70275006,9.9465671 2.71352383,9.86943953 2.72619885,9.78974101 C2.7293676,9.7723873 2.7319026,9.75503358 2.73507136,9.73703716 C2.73570511,9.7331808 2.73633886,9.72932439 2.73697261,9.72482527 C2.73950761,9.71389891 2.74140887,9.70297249 2.74331012,9.69140331 C2.75154888,9.64705499 2.76042139,9.60270661 2.76992765,9.55707277 C2.82569773,9.28841167 2.90808534,9.00689593 3.02532925,8.76651497 C3.04751053,8.71959566 3.07159306,8.67396186 3.09757684,8.63089896 C3.09757684,8.6302562 3.09757684,8.6302562 3.09757684,8.6302562 C3.12039187,8.5910497 3.14447441,8.55377133 3.16982444,8.51842119 C3.19644197,8.48050016 3.22369326,8.44386456 3.25094455,8.40851437 C3.54246994,8.03058921 3.85427536,7.79599273 4.11728196,7.68737138 C4.23579337,7.63788118 4.34479851,7.61410016 4.43732614,7.61410016 C4.50450373,7.61410016 4.55203504,7.63145388 4.58118758,7.66359037 C4.71807777,7.80884738 4.46330993,8.25683011 3.99370055,8.65725086 Z', fill: '#AEF265' }),
                                            react.createElement("path", { d: 'M2.26951781,10.0185529 L2.28114137,10.0185529 L2.28637197,10.0185529 L2.29973905,10.0185529 L2.3090379,10.0185529 C2.30438848,10.0078055 2.30032023,9.99772986 2.29625199,9.98631081 C2.29044021,9.97220488 2.28462843,9.958099 2.27823548,9.94332137 C2.2776543,9.94130625 2.27649194,9.93929109 2.27591077,9.93660426 C2.27474841,9.93391744 2.27358605,9.93123061 2.27184252,9.92787203 C2.27068016,9.9245135 2.26893663,9.92048322 2.2671931,9.91645298 C2.26370603,9.90704904 2.25963779,9.8969734 2.25556954,9.88756947 L2.25556954,9.88689776 C2.09458328,9.4966343 1.86327451,8.98277623 1.60290685,8.55422532 C1.58198445,8.5186247 1.56048087,8.48436749 1.53897729,8.45078199 C1.30650616,8.08738697 1.12750339,8.01484232 0.957799464,8.01484232 C0.89503226,8.01484232 0.849119216,8.03432189 0.818897966,8.06925081 C0.651518753,8.25934472 0.935133531,8.90217105 1.30650616,9.25011678 C1.57036089,9.49797771 1.90570049,9.77539391 2.15153871,10.0185529 L2.2515013,10.0185529 L2.25905661,10.0185529 L2.26021896,10.0185529 L2.26951781,10.0185529 L2.26951781,10.0185529 Z', fill: '#A9E965' }),
                                            react.createElement("path", { d: 'M4.6180758,7.61410016 C4.37254522,7.73091037 4.15787008,7.90153205 3.96288991,8.08659091 C3.9110265,8.13646491 3.86113258,8.18765138 3.81255166,8.24080663 C3.67928239,8.38649123 3.55783009,8.54398815 3.44622528,8.70673494 L3.33724647,8.87670034 C3.30048253,8.93313673 3.27094008,8.99351055 3.23680213,9.05191562 C3.16852625,9.1680696 3.11469334,9.29144219 3.05692144,9.41218981 C3.02606599,9.47256362 3.00374503,9.5355624 2.97814157,9.5979049 L2.9039572,9.78558872 C2.87704074,9.86302467 2.85209378,9.94046067 2.82649032,10.0185529 L2.69387755,10.0185529 C2.70241203,9.99624083 2.71029002,9.97392877 2.71816801,9.9516167 C2.7227635,9.94046067 2.7267025,9.92996087 2.72998499,9.91946106 C2.73195449,9.91552364 2.73326748,9.91224245 2.73392399,9.90896131 C2.73720648,9.90108642 2.73983247,9.89321158 2.74311497,9.88533673 C2.76018394,9.83808769 2.77790941,9.79149482 2.79629138,9.74490201 C2.79629138,9.74424578 2.79694788,9.74424578 2.79694788,9.74358955 L2.88032324,9.55590573 C2.88294923,9.54999958 2.88557523,9.54409347 2.88885772,9.53753109 C2.88885772,9.53687486 2.88885772,9.53621863 2.88951422,9.5355624 C2.91446118,9.47978224 2.93743864,9.42334584 2.96763759,9.37019064 C3.03197448,9.24878679 3.09171588,9.12607043 3.16590025,9.01057269 C3.20266419,8.95282384 3.23483264,8.89245002 3.27487907,8.83666986 L3.39239237,8.66867319 C3.53813513,8.47311453 3.69832085,8.28739944 3.87623206,8.12137146 C3.89724002,8.10168436 3.91890448,8.08199721 3.94056894,8.06296633 C4.1453966,7.88381363 4.36794972,7.72106684 4.6180758,7.61410016 Z', fill: '#4EB9E3' }),
                                            react.createElement("path", { d: 'M2.26297081,10.0185529 L2.27493629,10.0185529 L2.28032076,10.0185529 L2.29408105,10.0185529 L2.30365344,10.0185529 L2.3090379,10.0185529 L2.29467933,9.98402993 C2.29288451,9.97988718 2.29108968,9.97574444 2.28869659,9.97229216 C2.2839104,9.96124482 2.27792766,9.9515784 2.27194492,9.94122152 C2.27134665,9.93984059 2.2701501,9.93845971 2.26955183,9.93638831 C2.26835528,9.93431691 2.26656046,9.93224557 2.26536391,9.92948371 C2.26476564,9.92810282 2.26416736,9.92672189 2.26297081,9.92534096 C2.25997944,9.92050776 2.25758635,9.91567455 2.25459498,9.91015087 C2.25280016,9.9066986 2.25100534,9.90324632 2.24921052,9.89979399 C2.22408302,9.85353331 2.19536587,9.81210578 2.16784527,9.76929737 C2.14092295,9.72786984 2.11340235,9.68782325 2.08528348,9.64777665 C2.05178015,9.59875411 2.01708026,9.55111249 1.98178211,9.50347082 C1.85434978,9.32947528 1.72213126,9.16169388 1.58871619,8.99460294 C1.32128779,8.66180189 1.04727837,8.3359055 0.7696793,8.01484232 C1.04069735,8.34350057 1.30692921,8.67768245 1.56658006,9.01807851 C1.69640548,9.18793131 1.82443608,9.35985546 1.94708223,9.53661282 C2.00930271,9.62430108 2.06913009,9.71406069 2.1259661,9.80520118 C2.1534867,9.85077144 2.18280212,9.89634171 2.20673307,9.94398338 C2.21869855,9.96814942 2.23305712,9.991625 2.24322778,10.0151006 L2.24442432,10.0185529 L2.25220189,10.0185529 L2.25339843,10.0185529 L2.26297081,10.0185529 L2.26297081,10.0185529 Z', fill: '#4EB9E3' })),
                                        react.createElement("path", { d: 'M3.0787172,9.26919384 C3.0787172,9.38268015 2.93327801,9.61781074 2.50145773,9.61781074 C2.06963744,9.61781074 1.92419825,9.38259938 1.92419825,9.26919384 C1.92419825,9.15578836 2.09517563,9.26289355 2.52699592,9.26289355 C2.9588162,9.26289355 3.0787172,9.15570759 3.0787172,9.26919384 Z', id: 'Path', fill: '#424242' }),
                                        react.createElement("path", { d: 'M4.6180758,9.50331301 C4.6180758,9.78789718 3.67042504,10.0185529 2.50145773,10.0185529 C1.33249041,10.0185529 0.38483965,9.78789718 0.38483965,9.50331301 L0.38483965,8.81632653 C0.38483965,9.10091069 1.33249041,9.33156642 2.50145773,9.33156642 C3.67042504,9.33156642 4.6180758,9.10091069 4.6180758,8.81632653 L4.6180758,9.50331301 Z', id: 'Path', fill: '#8D6E63' }))))),
                        react.createElement("g", { id: 'Group-3', transform: 'translate(57.795918, 14.204082)', fillRule: 'nonzero' },
                            react.createElement("g", { id: 'Group' },
                                react.createElement("circle", { id: 'Oval', fill: '#FFFFFF', cx: '16.6530612', cy: '16.6530612', r: '16.6530612' }),
                                react.createElement("g", { id: 'icons8-checked', transform: 'translate(2.938776, 2.938776)', fill: '#85C33D' },
                                    react.createElement("path", { d: 'M13.4693878,0 C6.01022836,0 0,6.11950521 0,13.7142857 C0,21.3090662 6.01022836,27.4285714 13.4693878,27.4285714 C20.9285472,27.4285714 26.9387755,21.3090662 26.9387755,13.7142857 C26.9387755,12.2390115 26.7445055,10.7678569 26.2264521,9.39560439 L25.3741174,10.0238701 C25.5805295,10.8686501 25.873826,12.766484 25.873826,13.7142857 C25.873826,16.6116966 24.886836,19.7576292 23.0067803,22.0365249 C20.7101524,24.8203654 16.945587,26.4467843 13.4693878,26.4467843 C10.2621356,26.4467843 6.79518284,25.0667825 4.42200847,22.6296493 C2.11737822,20.2629075 0.859537641,16.8855331 0.859537641,13.7142857 C0.859537641,10.2346083 2.5721357,6.63581956 5.25927899,4.20303356 C7.54289486,2.13557826 10.5650584,0.95238095 13.4693878,0.95238095 C16.577708,0.95238095 19.9233112,2.60871437 21.8902946,4.6114611 L22.7943485,3.89010989 C20.4104938,1.46291235 17.0957614,0 13.4693878,0 Z M25.873826,5.16729796 L13.4693878,17.8469969 L8.25903463,12.709658 L7.54415226,13.4175824 L12.724686,18.6923077 L13.4693878,19.4175824 L14.2140895,18.6923077 L25.1035735,7.60483303 L26.6473705,6.03296704 L25.873826,5.16729796 Z', id: 'Shape' }))),
                            react.createElement("ellipse", { id: 'Oval', fill: '#85C33D', opacity: '0.101190476', cx: '16.6530612', cy: '16.6530612', rx: '10.7755102', ry: '10.2857143' }))))))));
};
var IconBack = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'icons/nav/icon-back-outline/size-s', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("path", { d: 'M9.07634583,5.00758555 C8.94900799,5.03032475 8.83531378,5.09399367 8.74890567,5.18949676 L2.40020465,11.5200067 L2,11.9384024 L2.40020465,12.3567982 L8.74890567,18.6873081 C8.88988714,18.8601237 9.11500182,18.93971 9.33329526,18.8896842 C9.54931496,18.8396589 9.71985686,18.669117 9.76988215,18.4530973 C9.81990802,18.2348038 9.74032173,18.0096891 9.56750608,17.8687077 L4.21931669,12.5205183 L21.4099255,12.5205183 C21.6191233,12.522792 21.8146782,12.4136453 21.9215506,12.2317341 C22.0261498,12.0498229 22.0261498,11.826982 21.9215506,11.6450708 C21.8146782,11.4631595 21.6191233,11.3540128 21.4099255,11.3562866 L4.21931669,11.3562866 L9.56750608,6.00809718 C9.7562391,5.83300779 9.80626439,5.55559291 9.69257018,5.32593016 C9.58114971,5.09399367 9.32874777,4.96665582 9.07634583,5.00758555 Z', id: 'Path', fill: '#555555', fillRule: 'nonzero' }))));
};
var images_IconLoading = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid' },
        react.createElement("circle", { cx: '50', cy: '50', fill: 'none', stroke: '#FF7D55', strokeWidth: '4', r: '35', strokeDasharray: '164.93361431346415 56.97787143782138' },
            react.createElement("animateTransform", { attributeName: 'transform', type: 'rotate', repeatCount: 'indefinite', dur: '1s', values: '0 50 50;360 50 50', keyTimes: '0;1' }))));
};
var IconCloudUpload = function () {
    return (react.createElement("svg", { width: '80', height: '53', viewBox: '0 0 80 53' },
        react.createElement("path", { d: 'M70.381 24.963C70 15.559 62.256 8.03 52.8 8.03c-1.631 0-3.194.214-4.744.653C44.475 3.3 38.431 0 32 0 21.731 0 13.319 8.13 12.825 18.32 5.319 20.39 0 27.346 0 35.332 0 45.076 7.894 53 17.6 53h48C73.544 53 80 46.52 80 38.545c0-6.154-3.975-11.669-9.619-13.582ZM48.47 30.045 41.6 23.15v18.608h-3.2V23.15l-6.869 6.895-2.262-2.271L40 17.002l10.731 10.772-2.262 2.27Z', fill: '#757575' })));
};
var IconChecked = function () {
    return (react.createElement("svg", { width: '53px', height: '53px', viewBox: '0 0 53 53', version: '1.1' },
        react.createElement("g", { id: 'DASHBOARD', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC-DASHBOARD-A-LINKEDIN-IMPORT-PROCESS-SUCCESS', transform: 'translate(-624.000000, -251.000000)', fill: '#00B70B', fillRule: 'nonzero' },
                react.createElement("g", { id: 'organism-/-exit-popup-/-desktop-/-Job-Alert-01', transform: 'translate(384.000000, 122.000000)' },
                    react.createElement("g", { id: 'pages/careercenter/section-profile-attachedcv', transform: 'translate(24.000000, 94.000000)' },
                        react.createElement("g", { id: 'Group-28', transform: 'translate(52.000000, 35.000000)' },
                            react.createElement("g", { id: 'Group-27', transform: 'translate(99.000000, 0.000000)' },
                                react.createElement("g", { id: 'icons8-checked', transform: 'translate(65.000000, 0.000000)' },
                                    react.createElement("path", { d: 'M26.5,0 C11.8886131,0 0,11.8886131 0,26.5 C0,41.1113877 11.8886131,53 26.5,53 C41.1113877,53 53,41.1113877 53,26.5 C53,22.01746 51.8770127,17.7952768 49.9039416,14.0906723 L48.7025335,15.2638498 C50.4183828,18.6422232 51.3939394,22.4597538 51.3939394,26.5 C51.3939394,40.2267992 40.2267992,51.3939394 26.5,51.3939394 C12.7732008,51.3939394 1.60606061,40.2267992 1.60606061,26.5 C1.60606061,12.7732008 12.7732008,1.60606061 26.5,1.60606061 C33.5578839,1.60606061 39.931937,4.56096158 44.467803,9.29758523 L45.6127484,8.17459794 C40.7882933,3.1431112 34.006451,0 26.5,0 Z M26.5,4.01515152 C26.0577062,4.01515152 25.6969697,4.37588798 25.6969697,4.81818182 C25.6969697,5.26047565 26.0577062,5.62121212 26.5,5.62121212 C26.9422938,5.62121212 27.3030303,5.26047565 27.3030303,4.81818182 C27.3030303,4.37588798 26.9422938,4.01515152 26.5,4.01515152 Z M30.7504145,4.42921402 C30.3583101,4.4198033 30.0195317,4.69270833 29.9411101,5.0785395 C29.8564161,5.51142262 30.1387311,5.93489583 30.5747516,6.02272727 C31.0076347,6.10742208 31.431108,5.82510633 31.5189394,5.39222321 C31.6036342,4.95620265 31.3213185,4.53272944 30.8884353,4.444898 C30.8413826,4.43862473 30.7974673,4.43235065 30.7504145,4.42921402 Z M22.2746802,4.43235065 C22.2213542,4.43235065 22.1680281,4.43548809 22.1147021,4.444898 C21.6786815,4.53272944 21.3963658,4.95620265 21.4841972,5.39222321 C21.5249767,5.59925406 21.6473128,5.78432765 21.8261131,5.90352786 C22.001776,6.01959064 22.2182175,6.06350595 22.4283858,6.02272727 C22.8644056,5.93489583 23.1467213,5.51456006 23.0588899,5.0785395 C22.9836058,4.70525568 22.6573747,4.43548809 22.2746802,4.43235065 Z M18.2093393,5.66512824 C18.1026872,5.66512824 17.9960344,5.68394886 17.8956556,5.72472755 C17.4847305,5.89725379 17.2902462,6.36464232 17.4627725,6.77556818 C17.6321613,7.18649405 18.0995506,7.38097755 18.5104757,7.21158874 C18.9214015,7.0390625 19.1158858,6.57167397 18.9464962,6.16074811 C18.8210227,5.86274838 18.5324337,5.66826488 18.2093393,5.66512824 Z M34.8157554,5.66512824 C34.4832503,5.65885417 34.1821139,5.85333847 34.0535038,6.16074811 C33.884115,6.57167397 34.0785985,7.0390625 34.4895243,7.21158874 C34.9004502,7.38097755 35.3678387,7.18649405 35.5372275,6.77556818 C35.7097538,6.36464232 35.5152703,5.89725379 35.1043444,5.72472755 C35.0133763,5.6870855 34.9129976,5.66826488 34.8157554,5.66512824 Z M14.4639562,7.66642992 C14.3008406,7.66642992 14.1408617,7.71348268 14.0059775,7.80445076 C13.6389678,8.04912445 13.538589,8.54788095 13.7863993,8.91802814 C14.0310722,9.28503788 14.5298295,9.38541667 14.8999767,9.13760633 C15.2701231,8.89293344 15.3673653,8.39417614 15.1226916,8.02716639 C14.9752608,7.80445076 14.7274505,7.66956656 14.4639562,7.66642992 Z M38.5580019,7.66642992 C38.2850969,7.66329329 38.0278766,7.79817748 37.8773084,8.02716639 C37.6294981,8.39417614 37.7298769,8.89293344 38.0968866,9.13760633 C38.4670338,9.38541667 38.9657911,9.28503788 39.210464,8.91802814 C39.3296642,8.74236526 39.3735795,8.52278626 39.3328009,8.31575541 C39.2920222,8.10558712 39.1696853,7.92051353 38.9908858,7.80445076 C38.8622749,7.71661932 38.7148442,7.66956656 38.5580019,7.66642992 Z M49.0758166,8.15577652 L24.7810133,31.9424126 L16.0888374,23.0651632 L14.366714,24.7527819 L24.7433712,35.3490173 L50.7634353,9.87789989 L49.0758166,8.15577652 Z M11.1796875,10.3641098 C10.9632459,10.3641098 10.7530777,10.4488047 10.6025095,10.6025095 C10.2888258,10.9130565 10.2888258,11.4243612 10.6025095,11.7349075 C10.9130565,12.0485912 11.4243612,12.0485912 11.7349075,11.7349075 C12.0485912,11.4243612 12.0485912,10.9130565 11.7349075,10.6025095 C11.5874767,10.4519413 11.3898558,10.3672465 11.1796875,10.3641098 Z M41.8422706,10.3641098 C41.625829,10.3641098 41.4156607,10.4488047 41.2650925,10.6025095 C40.9514088,10.9130565 40.9514088,11.4243612 41.2650925,11.7349075 C41.5756396,12.0485912 42.0869435,12.0485912 42.3974905,11.7349075 C42.7111742,11.4243612 42.7111742,10.9130565 42.3974905,10.6025095 C42.250059,10.4519413 42.0524388,10.3672465 41.8422706,10.3641098 Z M8.48514421,13.6515152 C8.21223998,13.6452419 7.95501894,13.7801253 7.80445076,14.0059775 C7.55977786,14.3761247 7.65701921,14.874882 8.02716639,15.1195549 C8.39731277,15.3673653 8.89293344,15.2669865 9.14074377,14.8999767 C9.38541667,14.5298295 9.28817452,14.0310722 8.91802814,13.7863993 C8.78941802,13.7017045 8.64198647,13.6546518 8.48514421,13.6515152 Z M46.5381155,17.4000357 C46.4314635,17.3968991 46.3248106,17.4188563 46.2244318,17.4596358 C45.813506,17.6290246 45.6190225,18.0995506 45.7884113,18.507339 C45.9609375,18.9182649 46.428326,19.1127484 46.8392519,18.9433596 C47.2501778,18.77397 47.4446613,18.3034448 47.2752725,17.8925189 C47.149799,17.5976567 46.86121,17.4000357 46.5381155,17.4000357 Z M6.48697917,17.4000357 C6.15447483,17.3937616 5.85333847,17.5882459 5.72786498,17.8956556 C5.55847538,18.3065814 5.75295968,18.77397 6.16074811,18.9464962 C6.57167397,19.1158858 7.04219914,18.9214015 7.21158874,18.5104757 C7.38097755,18.0995506 7.18649405,17.6321613 6.77556818,17.4627725 C6.68460011,17.4219938 6.58735795,17.4031723 6.48697917,17.4000357 Z M47.7677557,21.4685133 C47.7144297,21.4653766 47.6611036,21.4716499 47.6077768,21.4810606 C47.1748937,21.568892 46.8925779,21.9923653 46.9772727,22.4252484 C47.0651042,22.8612689 47.4885774,23.1435847 47.9214605,23.0588899 C48.3574811,22.9710584 48.6397968,22.5475852 48.555102,22.1115647 C48.4798179,21.7382817 48.1504502,21.4685133 47.7677557,21.4685133 Z M5.25733902,21.4685133 C4.86523458,21.4591025 4.52645617,21.7288709 4.44803544,22.1115647 C4.40725595,22.321733 4.44803544,22.541312 4.56723485,22.7169748 C4.68643506,22.8957743 4.87150785,23.0181112 5.08167614,23.0588899 C5.28870779,23.0996686 5.50514935,23.0557532 5.68394886,22.9396897 C5.85961174,22.8204903 5.98194859,22.6354167 6.02272727,22.4252484 C6.11055871,21.9923653 5.82824377,21.568892 5.39535985,21.4810606 C5.34830709,21.4747873 5.30439177,21.4685133 5.25733902,21.4685133 Z M4.81818182,25.6969697 C4.37588798,25.6969697 4.01515152,26.0577062 4.01515152,26.5 C4.01515152,26.9422938 4.37588798,27.3030303 4.81818182,27.3030303 C5.26047565,27.3030303 5.62121212,26.9422938 5.62121212,26.5 C5.62121212,26.0577062 5.26047565,25.6969697 4.81818182,25.6969697 Z M48.1818182,25.6969697 C47.7395243,25.6969697 47.3787879,26.0577062 47.3787879,26.5 C47.3787879,26.9422938 47.7395243,27.3030303 48.1818182,27.3030303 C48.624112,27.3030303 48.9848485,26.9422938 48.9848485,26.5 C48.9848485,26.0577062 48.624112,25.6969697 48.1818182,25.6969697 Z M5.23851839,29.9254261 C5.18519156,29.9254261 5.13186553,29.9317002 5.0785395,29.9411101 C4.64251894,30.0289416 4.360204,30.4524148 4.44803544,30.8884353 C4.53586688,31.3213185 4.95620265,31.6036342 5.39222321,31.5189394 C5.82824377,31.431108 6.11055871,31.0076347 6.02272727,30.5747516 C5.94744318,30.1983312 5.62121212,29.9285628 5.23851839,29.9254261 Z M47.7865771,29.9254261 C47.3944719,29.9160154 47.0556935,30.1889205 46.9772727,30.5747516 C46.8925779,31.0076347 47.1748937,31.431108 47.6077768,31.5189394 C48.0437973,31.6036342 48.4672706,31.3213185 48.555102,30.8884353 C48.6397968,30.4524148 48.3574811,30.0289416 47.9214605,29.9411101 C47.8775452,29.9348368 47.8336291,29.9285628 47.7865771,29.9254261 Z M46.5506629,33.990767 C46.2181585,33.9844938 45.9170222,34.1821139 45.7884113,34.4895243 C45.6190225,34.8973128 45.813506,35.3678387 46.2244318,35.5372275 C46.6353577,35.7066172 47.1027462,35.5121328 47.2752725,35.1043444 C47.4446613,34.6934186 47.2501778,34.2228934 46.8392519,34.0535038 C46.7482838,34.0158617 46.647905,33.9939037 46.5506629,33.990767 Z M6.47443182,33.9939037 C6.36777976,33.9939037 6.26112689,34.0127251 6.16074811,34.0535038 C5.96626461,34.135062 5.80942235,34.2919034 5.72786498,34.4895243 C5.64630682,34.6871453 5.64630682,34.9067235 5.72472755,35.1043444 C5.89725379,35.5152703 6.36464232,35.7097538 6.77556818,35.5372275 C6.97318912,35.4588068 7.13003058,35.3019654 7.21158874,35.1043444 C7.29314611,34.9067235 7.29314611,34.6871453 7.21158874,34.4895243 C7.08925189,34.1915246 6.79752624,33.9970411 6.47443182,33.9939037 Z M44.5430871,37.7424242 C44.2701821,37.736151 44.0129618,37.8710344 43.8623937,38.0968866 C43.6145833,38.4670338 43.7149621,38.9626537 44.0819719,39.210464 C44.2576347,39.3296642 44.4772137,39.3735795 44.6842446,39.3296642 C44.8944129,39.2888847 45.0794865,39.1665487 45.1955492,38.9877484 C45.4433596,38.6207386 45.3429808,38.1219813 44.9728336,37.8773084 C44.8473601,37.789477 44.6967919,37.7424242 44.5430871,37.7424242 Z M8.48200758,37.7424242 C8.31889205,37.7392876 8.16205059,37.7863404 8.02716639,37.8773084 C7.66015665,38.1251188 7.55977786,38.6207386 7.80445076,38.9908858 C8.05226109,39.3578956 8.55101839,39.4582743 8.92116477,39.210464 C9.28817452,38.9657911 9.3885533,38.4670338 9.14074377,38.0968866 C8.99331223,37.8773084 8.74550189,37.7455609 8.48200758,37.7424242 Z M11.1796875,41.0298295 C10.9632459,41.0266929 10.7530777,41.1113877 10.6025095,41.2650925 C10.2888258,41.5756396 10.2888258,42.0869435 10.6025095,42.3974905 C10.9130565,42.7111742 11.4243612,42.7111742 11.7349075,42.3974905 C12.0485912,42.0869435 12.0485912,41.5756396 11.7349075,41.2650925 C11.5874767,41.1145243 11.3898558,41.0298295 11.1796875,41.0298295 Z M41.8422706,41.0298295 C41.625829,41.0266929 41.4156607,41.1113877 41.2650925,41.2650925 C40.9514088,41.5756396 40.9514088,42.0869435 41.2650925,42.3974905 C41.5756396,42.7111742 42.0869435,42.7111742 42.3974905,42.3974905 C42.7111742,42.0869435 42.7111742,41.5756396 42.3974905,41.2650925 C42.250059,41.1145243 42.0524388,41.0298295 41.8422706,41.0298295 Z M14.4702294,43.7243728 C14.1973252,43.7180988 13.9401042,43.852983 13.789536,44.0788352 C13.5417257,44.4489824 13.6421044,44.9477389 14.0122516,45.1955492 C14.3792614,45.4402229 14.8780187,45.3398442 15.1226916,44.9728336 C15.3705019,44.6026872 15.2701231,44.1070666 14.9031134,43.859257 C14.7745032,43.7745622 14.6239351,43.7243728 14.4702294,43.7243728 Z M38.5548653,43.7243728 C38.3917497,43.7212362 38.2349075,43.7682882 38.1000241,43.8561196 C37.9212238,43.9753198 37.7988877,44.1603934 37.7581082,44.3705609 C37.7173295,44.5775925 37.7612457,44.7971707 37.8804451,44.9728336 C38.1251188,45.3398442 38.6238753,45.4402229 38.9940225,45.1955492 C39.3610322,44.9477389 39.461411,44.4489824 39.2136007,44.0788352 C39.0693065,43.859257 38.8214962,43.7243728 38.5548653,43.7243728 Z M18.2218866,45.7256745 C17.8893823,45.7194012 17.5882459,45.9170222 17.4627725,46.2244318 C17.2933828,46.632221 17.4878672,47.1027462 17.8956556,47.2721358 C18.3065814,47.4415246 18.7771074,47.2470411 18.9464962,46.8392519 C19.1158858,46.428326 18.9214015,45.9578009 18.5104757,45.7884113 C18.4195076,45.7507692 18.3222654,45.728812 18.2218866,45.7256745 Z M34.8032081,45.7256745 C34.6965552,45.7256745 34.5899031,45.7476326 34.492661,45.7884113 C34.29504,45.8699694 34.1381986,46.0268109 34.0566404,46.2212952 C33.9750831,46.4189161 33.9750831,46.641631 34.0535038,46.8392519 C34.22603,47.2470411 34.6934186,47.4415246 35.1043444,47.2721358 C35.3019654,47.1905777 35.4588068,47.0337362 35.540365,46.8392519 C35.6219223,46.641631 35.6219223,46.4189161 35.540365,46.2244318 C35.4180281,45.9232955 35.1263025,45.728812 34.8032081,45.7256745 Z M22.2935016,46.9615887 C21.9013972,46.952178 21.5594813,47.2250831 21.4841972,47.6077768 C21.3963658,48.0437973 21.6786815,48.4641339 22.1147021,48.5519654 C22.5507219,48.6397968 22.9710584,48.3574811 23.0588899,47.9214605 C23.1467213,47.4854407 22.8644056,47.0651042 22.4283858,46.9772727 C22.3844697,46.967862 22.3374169,46.9615887 22.2935016,46.9615887 Z M30.7315931,46.9647254 C30.678267,46.9615887 30.624941,46.967862 30.5747516,46.9772727 C30.1387311,47.0651042 29.8564161,47.4854407 29.9411101,47.9214605 C29.9850262,48.1316288 30.1073631,48.3135657 30.283026,48.4327652 C30.4618255,48.5519654 30.678267,48.5958807 30.8884353,48.555102 C31.0954662,48.5111859 31.2805398,48.3888498 31.39974,48.213187 C31.5158028,48.0343866 31.5597181,47.8179451 31.5189394,47.6077768 C31.4436553,47.2344938 31.1142876,46.9647254 30.7315931,46.9647254 Z M26.5,47.3787879 C26.0577062,47.3787879 25.6969697,47.7395243 25.6969697,48.1818182 C25.6969697,48.624112 26.0577062,48.9848485 26.5,48.9848485 C26.9422938,48.9848485 27.3030303,48.624112 27.3030303,48.1818182 C27.3030303,47.7395243 26.9422938,47.3787879 26.5,47.3787879 Z', id: 'Shape' }))))))))));
};


//# sourceMappingURL=images.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/Components/Layouts/Footer.js
'use client';











var Footer_Footer = function (_a) {
    var handleClosePopup = _a.handleClosePopup, checkBeforeSubmitForm = _a.checkBeforeSubmitForm, onSaveContactInfo = _a.onSaveContactInfo, onSaveWoringPreference = _a.onSaveWoringPreference, workingPreferenceData = _a.workingPreferenceData, _b = _a.hiddenStep, hiddenStep = _b === void 0 ? 0 : _b;
    var _c = useResumeModal(), step = _c.step, setStep = _c.setStep, t = _c.t, isShowLoading = _c.isShowLoading;
    // {isShowLoading && <LoadingIcon bgColor={colors.grey[99]} />}
    var render = function () {
        switch (step) {
            case type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV:
                return (react.createElement(Footer.Tab, { tab: step },
                    react.createElement("div", { style: { marginRight: 'auto' } },
                        react.createElement("span", { style: { color: Colors/* colors.grey.50 */.O9.grey[50] } }, t('Bạn chưa có sẵn hồ sơ đính kèm?')),
                        ' ',
                        react.createElement("a", { href: t('/ho-so') }, t('Cập nhật Hồ sơ VietnamWorks')))));
            case type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION:
                return (react.createElement(Footer.Tab, { tab: step },
                    hiddenStep > 0 ? null : (react.createElement("div", { onClick: function () { return setStep(1); }, className: 'goBack' },
                        react.createElement(IconBack, null),
                        " ",
                        t('Hồ sơ đính kèm'))),
                    react.createElement("div", { style: { marginLeft: 'auto' } },
                        react.createElement(Button/* default */.Z, { type: 'primary', onClick: function () {
                                onSaveContactInfo();
                            }, disabled: isShowLoading },
                            isShowLoading && react.createElement(LoadingIcon/* default */.Z, { bgColor: Colors/* colors.grey.80 */.O9.grey[80] }),
                            " ",
                            t('Tiếp tục')))));
            case type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE:
                return (react.createElement(Footer.Tab, { tab: step },
                    hiddenStep > 1 ? null : (react.createElement("div", { onClick: function () { return setStep(2); }, className: 'goBack' },
                        react.createElement(IconBack, null),
                        " ",
                        t('Thông tin liên hệ'))),
                    react.createElement("div", { style: { marginLeft: 'auto' } },
                        react.createElement(Button/* default */.Z, { type: 'primary', disabled: isShowLoading, onClick: function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
                                var _a;
                                return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = workingPreferenceData &&
                                                checkBeforeSubmitForm;
                                            if (!_a) return [3 /*break*/, 2];
                                            return [4 /*yield*/, checkBeforeSubmitForm(workingPreferenceData)];
                                        case 1:
                                            _a = (_b.sent());
                                            _b.label = 2;
                                        case 2:
                                            if (_a) {
                                                // Hide loading overlay
                                                handleClosePopup();
                                                return [2 /*return*/];
                                            }
                                            onSaveWoringPreference();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } },
                            isShowLoading && react.createElement(LoadingIcon/* default */.Z, { bgColor: Colors/* colors.grey.80 */.O9.grey[80] }),
                            " ",
                            t('Lưu hồ sơ')))));
        }
        return react.createElement(react.Fragment, null);
    };
    return react.createElement(Footer.Container, null, render());
};


//# sourceMappingURL=Footer.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/index.js
var resumes = __webpack_require__(93843);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/index.js
'use client';



















var UploadResumeModal = function (props) {
    var _a = props.lang, lang = _a === void 0 ? constants/* ELanguage.VI */.Df.VI : _a, _b = props.isHomepage, isHomepage = _b === void 0 ? false : _b, _c = props.isReloadOnClose, isReloadOnClose = _c === void 0 ? false : _c, 
    // jobLevelOptions = [],
    _d = props.jobLocationOptions, 
    // jobLevelOptions = [],
    jobLocationOptions = _d === void 0 ? [] : _d, _e = props.jobCategoryOptions, jobCategoryOptions = _e === void 0 ? [] : _e, _f = props.jobIndustryOptions, jobIndustryOptions = _f === void 0 ? [] : _f, _g = props.jobFunctionOptions, jobFunctionOptions = _g === void 0 ? {
        parent: [],
        child: {}
    } : _g, _h = props.customHeaderTitle, customHeaderTitle = _h === void 0 ? '' : _h, _j = props.isCloseable, isCloseable = _j === void 0 ? true : _j, _k = props.nationalityOptions, nationalityOptions = _k === void 0 ? [] : _k, _l = props.countryOptions, countryOptions = _l === void 0 ? [] : _l, _m = props.cityOptions, cityOptions = _m === void 0 ? [] : _m, _o = props.districtOptions, districtOptions = _o === void 0 ? [] : _o, _p = props.baseApiUrl, baseApiUrl = _p === void 0 ? 'https://staging-ms.vietnamworks.com' : _p, _q = props.apiUpload, apiUpload = _q === void 0 ? '/api-gateway/v2.0/profile/update-resume-file' : _q, accessToken = props.accessToken, _r = props.apiGetResumeInfo, apiGetResumeInfo = _r === void 0 ? '/api-gateway/v1.0/attached-resume' : _r, _s = props.apiAutoCompleteJobTitle, apiAutoCompleteJobTitle = _s === void 0 ? '/api-gateway/v1.0/suggest-job-title' : _s, _t = props.apiUpdateResume, apiUpdateResume = _t === void 0 ? '/api-gateway/v1.0/profile/attached-profile' : _t, _u = props.apiGetJobLevelList, apiGetJobLevelList = _u === void 0 ? 'https://ms.vietnamworks.com/meta/v1.0/job-levels' : _u, _v = props.logoutUrl, logoutUrl = _v === void 0 ? 'https://secure.vietnamworks.com/logout/en?client_id=3' : _v, _w = props.apiGetUserContactInfo, apiGetUserContactInfo = _w === void 0 ? '/api-gateway/v1.0/profile/contact' : _w, stepJump = props.stepJump, resumeId = props.resumeId, onClose = props.onClose, onCancel = props.onCancel, uploadedFile = props.uploadedFile, _x = props.isUncontactable, isUncontactable = _x === void 0 ? false : _x, checkBeforeSubmitForm = props.checkBeforeSubmitForm, _y = props.enableJobFunction, enableJobFunction = _y === void 0 ? false : _y, hiddenStep = props.hiddenStep, checkDoneStep = props.checkDoneStep, isReplace = props.isReplace;
    var contactInfoRef = (0,react.useRef)(null);
    var workingPreferenceRef = (0,react.useRef)(null);
    var _z = (0,react.useState)(props.isOpen || false), isOpen = _z[0], setIsOpen = _z[1];
    var _0 = (0,react.useState)(1), step = _0[0], setStep = _0[1];
    // Form
    var currentResumeId = (0,react.useRef)(resumeId);
    var tracking = (0,useHog/* default */.Z)().tracking;
    // drag, drop zone
    // upload file
    var _1 = (0,react.useState)(false), isUploading = _1[0], setIsUploading = _1[1];
    var _2 = (0,react.useState)(uploadedFile), uploadFile = _2[0], setUploadFile = _2[1];
    var _3 = (0,react.useState)(false), isShowLoading = _3[0], setShowLoading = _3[1];
    var _4 = (0,react.useState)(undefined), uploadResponseData = _4[0], setUploadResponseData = _4[1];
    var _5 = (0,react.useState)(''), uploadErrorMessage = _5[0], setUploadErrorMessage = _5[1];
    var _6 = (0,react.useState)(UploadResumeModal_constants/* defaultProps.initialData */.lG.initialData), contactInfo = _6[0], setContactInfo = _6[1];
    var _7 = (0,react.useState)(UploadResumeModal_constants/* initWorkingReferenceData */.s1), workingPreferenceData = _7[0], setWorkingPreferenceData = _7[1];
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return UploadResumeModal_translations_translations[text];
        }
    };
    var handleClosePopup = function () {
        setIsUploading(false);
        setUploadFile(undefined);
        // reset step to 1
        setStep(1);
        // Hide loading overlay
        setShowLoading(false);
        setIsOpen(false);
        if (isHomepage) {
            window.location.reload();
        }
        if (isReloadOnClose) {
            window.location.reload();
        }
        // DO reset all error alert
        onClose && onClose();
        props.onTogglePopup && props.onTogglePopup(false, uploadResponseData);
    };
    // End
    var validateResume = function (uploadFileInfo) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b, _c, _d, _e;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* validateFile */.D0)({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: uploadFileInfo,
                            baseUrl: baseApiUrl !== null && baseApiUrl !== void 0 ? baseApiUrl : '',
                            userId: 0,
                            jobId: 0
                        })];
                case 1:
                    response = _f.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) && ((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.spam)) {
                        setUploadErrorMessage((_e = (_d = response === null || response === void 0 ? void 0 : response.meta) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : '');
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _f.sent();
                    console.error(error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var doUploadFile = function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var isValid, response, jobAlertData, responseMessage, error_2;
        var _a, _b, _c, _d, _e;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 7, , 8]);
                    setUploadFile(file);
                    setIsUploading(true);
                    setShowLoading(true);
                    return [4 /*yield*/, validateResume(file)];
                case 1:
                    isValid = _f.sent();
                    if (!isValid) {
                        setIsUploading(false);
                        setShowLoading(false);
                        return [2 /*return*/];
                    }
                    // Reset error message when file is valid
                    setUploadErrorMessage('');
                    return [4 /*yield*/, (0,apiServices/* apiDoUpload */.$W)(accessToken, lang, "".concat(baseApiUrl).concat(apiUpload), file, uploadResponseData === null || uploadResponseData === void 0 ? void 0 : uploadResponseData.id, isReplace)];
                case 2:
                    response = _f.sent();
                    setIsUploading(false);
                    setShowLoading(false);
                    if (!(response.status === UploadResumeModal_constants/* DEFAULT_SUCCESS_CODE */.se)) return [3 /*break*/, 5];
                    tracking({
                        eventName: 'js_profile_management:attachment_resume_upload_success'
                    });
                    setUploadResponseData(response.data);
                    setStep(2);
                    checkDoneStep && checkDoneStep(1, response);
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.extract_error) {
                        return [2 /*return*/];
                    }
                    jobAlertData = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.job_alert_data;
                    setWorkingPreferenceData((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, workingPreferenceData), (jobAlertData.title ? { jobTitle: jobAlertData.title } : undefined)), (jobAlertData.year_of_exp ? { yearsExperience: jobAlertData.year_of_exp } : undefined)), (jobAlertData.locationId ? { locations: [jobAlertData.locationId] } : undefined)), (jobAlertData.level ? { jobLevelId: jobAlertData.level } : undefined)), (jobAlertData.salary ? { salary: Number(jobAlertData.salary) } : undefined)), (jobAlertData.industry && jobAlertData.industry.length > 0
                        ? { industries: jobAlertData.industry }
                        : undefined)));
                    currentResumeId.current = (response === null || response === void 0 ? void 0 : response.id) || 0;
                    if (!(jobAlertData.summary && jobAlertData.summary !== '')) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0,apiServices/* updateSummaryProfileSetting */.ni)({
                            url: baseApiUrl,
                            summary: (_c = jobAlertData.summary) !== null && _c !== void 0 ? _c : '',
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : ''
                        })];
                case 3:
                    _f.sent();
                    _f.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (typeof response.message === 'string') {
                        setUploadErrorMessage((_d = response.message) !== null && _d !== void 0 ? _d : '');
                    }
                    else {
                        responseMessage = response.message;
                        if (!(responseMessage === null || responseMessage === void 0 ? void 0 : responseMessage.Message)) {
                            return [2 /*return*/];
                        }
                        setUploadErrorMessage((_e = responseMessage.Message) !== null && _e !== void 0 ? _e : '');
                    }
                    _f.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_2 = _f.sent();
                    console.error(error_2);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        // Check if user is on boarding (just created account and logged in)
        // then show modal to ask them upload cv
        var checkNeedToShowProfileModal = function () {
            if (window.requireOnboarding !== undefined && window.requireOnboarding !== null) {
                if (window.requireOnboarding) {
                    setIsOpen(true);
                }
            }
        };
        checkNeedToShowProfileModal();
    }, []);
    var userContactInfo = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response, contactInfo_1, parsedTimestamp, parsedDate, transformedData;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0,apiServices/* getUserContactInfo */.Sk)(accessToken, lang, "".concat(baseApiUrl).concat(apiGetUserContactInfo))];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        contactInfo_1 = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.attributes;
                        parsedTimestamp = Date.parse(contactInfo_1.birthday);
                        parsedDate = new Date(parsedTimestamp);
                        transformedData = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, contactInfo_1), { isSearchable: Boolean(contactInfo_1.isSearchable), birthday: contactInfo_1.birthday ? parsedDate : null });
                        setContactInfo(transformedData);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getResumeInfo = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var resume, _a, title, yearOfExp, companyIndustry, city, highestDegree, industry, level, salary, jobFunction, error_3;
        var _b, _c, _d, _e;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,apiServices/* apiGetResume */.PS)(accessToken, lang, "".concat(baseApiUrl).concat(apiGetResumeInfo))];
                case 1:
                    resume = _f.sent();
                    if ((_b = resume === null || resume === void 0 ? void 0 : resume.data) === null || _b === void 0 ? void 0 : _b.extraInfo) {
                        _a = (_c = resume === null || resume === void 0 ? void 0 : resume.data) === null || _c === void 0 ? void 0 : _c.extraInfo, title = _a.title, yearOfExp = _a.yearOfExp, companyIndustry = _a.companyIndustry, city = _a.city, highestDegree = _a.highestDegree, industry = _a.industry, level = _a.level, salary = _a.salary, jobFunction = _a.jobFunction;
                        setWorkingPreferenceData({
                            jobTitle: title !== null && title !== void 0 ? title : '',
                            yearsExperience: yearOfExp !== null && yearOfExp !== void 0 ? yearOfExp : 0,
                            locations: city !== null && city !== void 0 ? city : [],
                            jobLevelId: level !== null && level !== void 0 ? level : 0,
                            highestDegreeId: highestDegree !== null && highestDegree !== void 0 ? highestDegree : 0,
                            salary: salary !== null && salary !== void 0 ? salary : 0,
                            isSearchable: 0,
                            companyIndustries: companyIndustry !== null && companyIndustry !== void 0 ? companyIndustry : [],
                            industries: industry !== null && industry !== void 0 ? industry : [],
                            resumeId: (_e = (_d = resume === null || resume === void 0 ? void 0 : resume.data) === null || _d === void 0 ? void 0 : _d.resumeId) !== null && _e !== void 0 ? _e : -1,
                            jobFunction: jobFunction !== null && jobFunction !== void 0 ? jobFunction : []
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _f.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (stepJump)
            setStep(stepJump);
        var isPopupOpen = props.isOpen || isOpen;
        // Do get Job Level
        if (isPopupOpen) {
            // call API to get resume info
            getResumeInfo();
            userContactInfo();
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isPopupOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [props.isOpen, isOpen]);
    var renderBody = function () {
        var _a;
        switch (step) {
            case type/* ETab.UPLOAD_CV */.JF.UPLOAD_CV:
                return react.createElement(AttachCV, { doUploadFile: doUploadFile, uploadErrorMessage: uploadErrorMessage });
            case type/* ETab.CONTACT_INFORMATION */.JF.CONTACT_INFORMATION:
                return (react.createElement(ContactInfo$1, { formData: contactInfo, ref: contactInfoRef, baseApiUrl: baseApiUrl, cityOptions: cityOptions, districtOptions: districtOptions, countryOptions: countryOptions, nationalityOptions: nationalityOptions, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '', apiGetUserContactInfo: apiGetUserContactInfo, setContactInfo: setContactInfo, checkDoneStep: checkDoneStep }));
            case type/* ETab.WORKING_PREFERENCE */.JF.WORKING_PREFERENCE:
                return (react.createElement(WorkingReference$1, { isReloadOnClose: isReloadOnClose, ref: workingPreferenceRef, formData: workingPreferenceData, baseApiUrl: baseApiUrl, apiAutoCompleteJobTitle: apiAutoCompleteJobTitle, apiGetJobLevelList: apiGetJobLevelList, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '', jobCategoryOptions: jobCategoryOptions, jobIndustryOptions: jobIndustryOptions, jobLocationOptions: jobLocationOptions, isUncontactable: isUncontactable, checkBeforeSubmitForm: checkBeforeSubmitForm, checkDoneStep: checkDoneStep, logoutUrl: logoutUrl, handleClosePopup: handleClosePopup, apiUpdateResume: apiUpdateResume, resumeId: (_a = currentResumeId.current) !== null && _a !== void 0 ? _a : 0, setWorkingPreferenceData: setWorkingPreferenceData, jobFunctionOptions: jobFunctionOptions, enableJobFunction: enableJobFunction }));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(ResumeModalContext.Provider, { value: {
            t: t,
            lang: lang,
            isShowLoading: isShowLoading,
            setShowLoading: setShowLoading,
            uploadFile: uploadFile,
            setUploadFile: setUploadFile,
            isUploading: isUploading,
            setIsUploading: setIsUploading,
            step: step,
            setStep: setStep
        } },
        react.createElement(Popup/* default */.Z, { text: { header: customHeaderTitle !== '' ? customHeaderTitle : t('Cập nhật thông tin hồ sơ đính kèm') }, styleOption: {
                size: 'md'
            }, onClickOutside: function () {
                if (!isCloseable)
                    return;
                handleClosePopup();
                onCancel && onCancel();
            }, onClose: function () {
                if (!isCloseable)
                    return;
                handleClosePopup();
                onCancel && onCancel();
            }, isShow: props.isOpen || false, option: { isShowClose: isCloseable, isCloseOnClickBackdrop: isCloseable }, lang: lang, custom: {
                bodyOverflow: 'visible',
                additionalFooterHeight: 88,
                footer: (react.createElement(Footer_Footer, { checkBeforeSubmitForm: checkBeforeSubmitForm, handleClosePopup: handleClosePopup, hiddenStep: hiddenStep, onSaveContactInfo: function () {
                        var _a;
                        (_a = contactInfoRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    }, onSaveWoringPreference: function () {
                        var _a;
                        (_a = workingPreferenceRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    }, workingPreferenceData: workingPreferenceData }))
            } },
            react.createElement(WarpBody.Container, null,
                react.createElement(Tabs, { contactInfo: contactInfo, hiddenStep: hiddenStep }),
                renderBody()))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/constants.js
'use client';



// Gap between text and bar in top (in Pixel)
var DEFAULT_BAR_TEXT_GAP_TOP = 5;
// Gap between text value and bar in bottom (in Pixel)
var DEFAULT_BAR_TEXT_GAP_BOTTOM = 6;
// Default border radius (in Pixel)
var DEFAULT_BORDER_RADIUS = 4;
// Default Padding spacing of top/bottom of chart
var DEFAULT_HEIGHT_PADDING = 16;
// Additional height of chart
var ADDITION_HEIGHT = DEFAULT_HEIGHT_PADDING * 2 + DEFAULT_BAR_TEXT_GAP_BOTTOM * 2 + 32;
// Max percent
var DEFAULT_MAX_PERCENT = 100;
// Animation duration
var ANIMATION_DURATION = '0.5s';
// Default top text label font size (used for calculate position when chart is horizontal)
var DEFAULT_FONT_SIZE = 14;
var DEFAULT_STYLE_OPTIONS = {
    barColor: '#4083FF',
    labelColor: '#001744',
    gridColor: '#bcd2fa',
    barWidth: 30,
    barHeight: 300,
    lineCount: 6,
    topPadding: 32,
    leftPadding: 16,
    rightPadding: 0,
    bottomPadding: 0,
    labelFontWeight: 400,
    highlightFontWeight: 700,
    mobileFontSize: 10,
    desktopFontSize: 14,
    barBackgroundColor: '',
    isShowWhenBarZero: true,
    strokeDasharray: {
        width: 4,
        spacing: 4
    },
    isRotateBottomText: false,
    bottomBarTextFontSize: 14,
    isShowBarText: true,
    renderYAxisText: function () { return ''; },
    highlightColor: constants/* colors.successColor */.O9.successColor
};
// Default text options
var DEFAULT_TEXT_OPTIONS = {
    yAxisText: '(Y)',
    xAxisText: '(X)',
    tooltipText: '',
    xAxisPosition: 'end',
    highlightText: 'You are here',
    topLabelPostfixText: '%',
    tooltipDisplayValues: []
};
// Default bar chart options
var DEFAULT_OPTIONS = {
    isHorizontal: false
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/BarChart.css.js
'use client';






var barAnimX = (0,styled_components_browser_esm/* keyframes */.F4)(BarChart_css_templateObject_1 || (BarChart_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n"])));
var barAnimY = (0,styled_components_browser_esm/* keyframes */.F4)(BarChart_css_templateObject_2 || (BarChart_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n"], ["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n"])));
var BarChartWrapper = styled_components_browser_esm/* default.div */.ZP.div(BarChart_css_templateObject_3 || (BarChart_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    position: relative;\n"], ["\n    width: 100%;\n    position: relative;\n"])));
var BarRect = styled_components_browser_esm/* default.rect */.ZP.rect(BarChart_css_templateObject_5 || (BarChart_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHaveAnim = _a.isHaveAnim;
    if (!isHaveAnim) {
        return '`';
    }
    return (0,styled_components_browser_esm/* css */.iv)(BarChart_css_templateObject_4 || (BarChart_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            transition: height ", " ease-in-out, fill ", " ease-in-out, opacity ", " ease-in-out;\n            opacity: ", ";\n            animation: ", " ", " ease-in-out;\n        "], ["\n            transition: height ", " ease-in-out, fill ", " ease-in-out, opacity ", " ease-in-out;\n            opacity: ", ";\n            animation: ", " ", " ease-in-out;\n        "])), ANIMATION_DURATION, ANIMATION_DURATION, ANIMATION_DURATION, function (_a) {
        var opacity = _a.opacity;
        return opacity;
    }, function (_a) {
        var isHorizontal = _a.isHorizontal;
        return (isHorizontal ? barAnimX : barAnimY);
    }, ANIMATION_DURATION);
});
var BarText = styled_components_browser_esm/* default.text */.ZP.text(BarChart_css_templateObject_6 || (BarChart_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: height ", " ease-in-out;\n    animation: ", " ", " ease-in-out;\n"], ["\n    transition: height ", " ease-in-out;\n    animation: ", " ", " ease-in-out;\n"])), ANIMATION_DURATION, function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? barAnimX : barAnimY);
}, ANIMATION_DURATION);
var AxisText = styled_components_browser_esm/* default.text */.ZP.text(BarChart_css_templateObject_7 || (BarChart_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    fill: #888;\n    font-size: 12px;\n"], ["\n    fill: #888;\n    font-size: 12px;\n"])));
var TooltipDot = styled_components_browser_esm/* default.span */.ZP.span(BarChart_css_templateObject_8 || (BarChart_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n"], ["\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return bgColor;
});
var TooltipText = styled_components_browser_esm/* default.span */.ZP.span(BarChart_css_templateObject_9 || (BarChart_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 22px;\n    margin-left: ", "px;\n"], ["\n    color: ", ";\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 22px;\n    margin-left: ", "px;\n"])), function (_a) {
    var isYou = _a.isYou, highlightColor = _a.highlightColor;
    return (isYou ? highlightColor : constants/* colors.darkBlueColor */.O9.darkBlueColor);
}, function (_a) {
    var isMarginLeft = _a.isMarginLeft;
    return (isMarginLeft ? 4 : 0);
});
styled_components_browser_esm/* default.g */.ZP.g(BarChart_css_templateObject_11 || (BarChart_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    if (!isHorizontal) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(BarChart_css_templateObject_10 || (BarChart_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            transform: rotate(-90deg);\n            translate: 0 ", "px;\n        "], ["\n            transform: rotate(-90deg);\n            translate: 0 ", "px;\n        "])), function (_a) {
        var leftPadding = _a.leftPadding;
        return leftPadding;
    });
});
styled_components_browser_esm/* default.g */.ZP.g(BarChart_css_templateObject_13 || (BarChart_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    if (!isHorizontal) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(BarChart_css_templateObject_12 || (BarChart_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            transform: rotate(90deg);\n            translate: ", "px 0;\n        "], ["\n            transform: rotate(90deg);\n            translate: ", "px 0;\n        "])), function (_a) {
        var leftPadding = _a.leftPadding;
        return leftPadding;
    });
});
var BarChart_css_templateObject_1, BarChart_css_templateObject_2, BarChart_css_templateObject_3, BarChart_css_templateObject_4, BarChart_css_templateObject_5, BarChart_css_templateObject_6, BarChart_css_templateObject_7, BarChart_css_templateObject_8, BarChart_css_templateObject_9, BarChart_css_templateObject_10, BarChart_css_templateObject_11, BarChart_css_templateObject_12, BarChart_css_templateObject_13;


//# sourceMappingURL=BarChart.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/helpers.js
'use client';

/**
 * Calculate spacing number of bar
 * @param chartWidth Total chart width in pixel
 * @param barWidth bar width in pixel
 * @param totalBars total Bars count
 * @param currentIndex current bar index
 * @returns number of spacing base on index of bar
 */
var calculateBarSpacing = function (chartWidth, barWidth, totalBars, currentIndex, xAxisPosition, isHorizontal) {
    if (isHorizontal === void 0) { isHorizontal = false; }
    // total chartWidth (32 Left spacing of X Axis to charts and minus Right spacing of X Axis)
    var displayWidth = chartWidth;
    if (!isHorizontal) {
        displayWidth -= 54;
        if (xAxisPosition === 'end') {
            displayWidth -= 40;
        }
    }
    var totalBarWidth = totalBars * barWidth;
    // Do not include last bar because we don't need right spacing of last bar
    var remainSpacing = (displayWidth - totalBarWidth) / (totalBars - 1);
    return remainSpacing * currentIndex;
};


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/components/Tooltip/Tooltip.css.js
'use client';




var ToolTipWrapper = styled_components_browser_esm/* default.div */.ZP.div(Tooltip_css_templateObject_1 || (Tooltip_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);\n    border-radius: 4px;\n    transition: all 0.25s ease-in-out;\n    pointer-events: none;\n    padding: 8px;\n"], ["\n    position: absolute;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);\n    border-radius: 4px;\n    transition: all 0.25s ease-in-out;\n    pointer-events: none;\n    padding: 8px;\n"])));
var Tooltip_css_templateObject_1;


//# sourceMappingURL=Tooltip.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/context/index.js
'use client';

var initialBarChart = {
    tooltip: {
        x: 0,
        y: 0
    }
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/context/reducer.js
'use client';





var barChartReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case 'UPDATE_TOOLTIP_POSITION':
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, state), { tooltip: {
                    x: payload.x || 0,
                    y: payload.y || 0
                } });
        default:
            console.error('Unknown type of BarChart Reducer');
            return (0,_tslib/* __assign */.pi)({}, state);
    }
};
var BarChartContext = (0,react.createContext)({
    barChartState: initialBarChart,
    dispatch: function () { }
});


//# sourceMappingURL=reducer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/components/Tooltip/index.js
'use client';





var Tooltip_Tooltip = function (props) {
    var children = props.children, chartRef = props.chartRef;
    var _a = (0,react.useContext)(BarChartContext), barChartState = _a.barChartState, dispatch = _a.dispatch;
    var tooltipRef = (0,react.useRef)(null);
    var calculateXPosition = function (x) {
        if (!tooltipRef.current) {
            return x;
        }
        var windowWidth = window.screen.width;
        var length = windowWidth - x;
        if (length < 200) {
            x = x - 200;
        }
        return x;
    };
    var onMouseClick = function (e) {
        var x = calculateXPosition(e.clientX);
        var y = e.clientY;
        if (chartRef && (chartRef === null || chartRef === void 0 ? void 0 : chartRef.current)) {
            var chartRect = chartRef === null || chartRef === void 0 ? void 0 : chartRef.current.getBoundingClientRect();
            x = x - chartRect.x;
            y = e.clientY - chartRect.y;
        }
        dispatch({
            type: 'UPDATE_TOOLTIP_POSITION',
            payload: {
                x: x,
                y: y
            }
        });
    };
    (0,react.useEffect)(function () {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('mousemove', onMouseClick);
        window.addEventListener('click', onMouseClick);
        return function () {
            window.removeEventListener('mousemove', onMouseClick);
            window.removeEventListener('click', onMouseClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (tooltipRef.current === null) {
            return;
        }
        var x = calculateXPosition(barChartState.tooltip.x);
        dispatch({
            type: 'UPDATE_TOOLTIP_POSITION',
            payload: {
                x: x,
                y: barChartState.tooltip.y
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tooltipRef]);
    return (react.createElement(ToolTipWrapper, { style: {
            top: barChartState.tooltip.y,
            left: barChartState.tooltip.x + 8
        }, ref: tooltipRef }, children));
};
var Tooltip$1 = react.memo(Tooltip_Tooltip);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementResize/index.js
'use client';



var useElementResize = function (ref) {
    var _a = (0,react.useState)({
        width: 0,
        height: 0
    }), size = _a[0], setSize = _a[1];
    var onResize = (0,react.useCallback)(function () {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0,react.useEffect)(function () {
        if (typeof window === 'undefined')
            return;
        onResize();
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [size];
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/BarChart/index.js
'use client';












var BarChart = function (props) {
    var data = props.data, labels = props.labels, options = props.options, styleOptions = props.styleOptions, textOptions = props.textOptions, _a = props.highlight, highlight = _a === void 0 ? '' : _a;
    var _b = (0,react.useReducer)(barChartReducer, initialBarChart), barChartState = _b[0], dispatch = _b[1];
    var _c = (0,react.useState)(300), chartWidth = _c[0], setChartWidth = _c[1];
    var _d = (0,react.useState)(-1), hoverBarIndex = _d[0], setHoverBarIndex = _d[1];
    var wrapperRef = (0,react.useRef)(null);
    var elementSize = useElementResize((wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) || null)[0];
    var isInMobile = (0,helpers/* isMobile */.tq)();
    var mergedOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTIONS), options);
    var mergedStyleOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_STYLE_OPTIONS), styleOptions);
    var mergedTextOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_TEXT_OPTIONS), textOptions);
    var chartHeight = mergedStyleOptions.barHeight + ADDITION_HEIGHT;
    var displayLineCount = mergedStyleOptions.lineCount - 1;
    // line spacing is calculated by 100% / lineCount
    var lineSpacing = 100 / displayLineCount;
    var lineSpacingText = Math.round(lineSpacing);
    (0,react.useEffect)(function () {
        if (wrapperRef.current === null) {
            return;
        }
        setChartWidth(wrapperRef.current.offsetWidth);
    }, [wrapperRef, elementSize]);
    var renderTooltip = function () {
        var _a, _b;
        if (typeof window === 'undefined') {
            return null;
        }
        if (hoverBarIndex === -1) {
            return null;
        }
        var itemLabel = (_a = labels[hoverBarIndex]) !== null && _a !== void 0 ? _a : '';
        if (mergedTextOptions.tooltipDisplayValues && mergedTextOptions.tooltipDisplayValues.length > 0) {
            itemLabel = (_b = mergedTextOptions.tooltipDisplayValues[hoverBarIndex].toString()) !== null && _b !== void 0 ? _b : '';
        }
        var isHighLight = itemLabel === highlight;
        return (react.createElement(Tooltip$1, { chartRef: wrapperRef },
            react.createElement(TooltipDot, { bgColor: isHighLight ? mergedStyleOptions.highlightColor : mergedStyleOptions.barColor }),
            itemLabel,
            " ",
            mergedTextOptions.tooltipText,
            isHighLight && (react.createElement(TooltipText, { isYou: isHighLight, highlightColor: mergedStyleOptions.highlightColor },
                ' ',
                mergedTextOptions.highlightText))));
    };
    var renderBottomText = function (text, textX) {
        if (text !== 'Chưa xác định') {
            return text;
        }
        if (mergedStyleOptions.isRotateBottomText) {
            return text;
        }
        return (react.createElement(react.Fragment, null,
            react.createElement("tspan", { x: textX }, "Ch\u01B0a"),
            react.createElement("tspan", { x: textX, dy: '1.2em' }, "x\u00E1c \u0111\u1ECBnh")));
    };
    var chartLeftPadding = 32 + mergedStyleOptions.leftPadding;
    var chartTopPadding = mergedStyleOptions.topPadding;
    var chartBottomPadding = mergedStyleOptions.bottomPadding;
    var isSmaller1024 = true;
    if (typeof window !== 'undefined') {
        isSmaller1024 = window.innerWidth <= 1024;
    }
    return (react.createElement(BarChartContext.Provider, { value: {
            barChartState: barChartState,
            dispatch: dispatch
        } },
        react.createElement(BarChartWrapper, { ref: wrapperRef },
            react.createElement("svg", { width: chartWidth, height: chartHeight },
                react.createElement("g", { id: 'bars-bg' }, data.map(function (value, index) {
                    var itemBarHeight = (value * mergedStyleOptions.barHeight) / DEFAULT_MAX_PERCENT;
                    if (mergedStyleOptions.isShowWhenBarZero && itemBarHeight === 0) {
                        itemBarHeight = 1;
                    }
                    var barSpacing = calculateBarSpacing(mergedOptions.isHorizontal
                        ? mergedStyleOptions.barHeight
                        : chartWidth - mergedStyleOptions.rightPadding, mergedStyleOptions.barWidth, data.length, index, mergedTextOptions.xAxisPosition, mergedOptions.isHorizontal);
                    var barX = mergedStyleOptions.barWidth * index +
                        barSpacing +
                        (mergedOptions.isHorizontal ? chartTopPadding : chartLeftPadding);
                    var barY = DEFAULT_HEIGHT_PADDING + 32;
                    return (react.createElement("g", { key: index }, mergedStyleOptions.barBackgroundColor !== '' && (react.createElement(BarRect, { isHaveAnim: false, isHorizontal: mergedOptions.isHorizontal, x: mergedOptions.isHorizontal ? chartLeftPadding : barX, y: mergedOptions.isHorizontal ? barX : barY, width: mergedOptions.isHorizontal
                            ? chartWidth - chartLeftPadding - mergedStyleOptions.rightPadding
                            : mergedStyleOptions.barWidth, height: mergedOptions.isHorizontal ? mergedStyleOptions.barWidth : chartHeight, fill: mergedStyleOptions.barBackgroundColor, rx: DEFAULT_BORDER_RADIUS, ry: DEFAULT_BORDER_RADIUS }))));
                })),
                react.createElement("g", { id: 'grid' },
                    Array.from({ length: mergedStyleOptions.lineCount }).map(function (_, index) {
                        var barHeight = mergedOptions.isHorizontal
                            ? chartWidth - chartLeftPadding - mergedStyleOptions.rightPadding
                            : mergedStyleOptions.barHeight - chartBottomPadding;
                        var gapSpace = (barHeight / displayLineCount) * index;
                        var lineY = barHeight - gapSpace + DEFAULT_HEIGHT_PADDING + 32;
                        if (mergedOptions.isHorizontal) {
                            lineY = gapSpace + chartLeftPadding;
                        }
                        var lineText = index * lineSpacingText;
                        var renderLineText = (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.renderYAxisText)
                            ? styleOptions.renderYAxisText(lineText)
                            : lineText;
                        var textX = chartHeight - DEFAULT_HEIGHT_PADDING + DEFAULT_BAR_TEXT_GAP_BOTTOM;
                        return (react.createElement("g", { key: "g-line-".concat(index) },
                            react.createElement("line", { x1: mergedOptions.isHorizontal ? lineY : chartLeftPadding, y1: mergedOptions.isHorizontal ? chartTopPadding : lineY, x2: mergedOptions.isHorizontal ? lineY : chartWidth, y2: mergedOptions.isHorizontal
                                    ? chartHeight - chartTopPadding - DEFAULT_BAR_TEXT_GAP_BOTTOM - 2
                                    : lineY, stroke: mergedStyleOptions.gridColor, strokeWidth: 1, strokeDasharray: "".concat(mergedStyleOptions.strokeDasharray.width, " ").concat(mergedStyleOptions.strokeDasharray.spacing) }),
                            react.createElement("text", { x: mergedOptions.isHorizontal ? lineY : 2, y: mergedOptions.isHorizontal ? textX : lineY, fill: mergedStyleOptions.labelColor, textAnchor: mergedOptions.isHorizontal ? 'middle' : 'start', fontSize: isInMobile
                                    ? mergedStyleOptions.mobileFontSize
                                    : mergedStyleOptions.desktopFontSize }, renderLineText)));
                    }),
                    react.createElement(AxisText, { x: 2, y: 16, fill: mergedStyleOptions.labelColor, textAnchor: 'start' }, mergedOptions.isHorizontal ? mergedTextOptions.xAxisText : mergedTextOptions.yAxisText)),
                react.createElement("g", { id: 'bars' },
                    data.map(function (value, index) {
                        var isHighLight = labels[index] === highlight;
                        var barHeight = mergedOptions.isHorizontal
                            ? chartWidth - chartLeftPadding - mergedStyleOptions.rightPadding
                            : mergedStyleOptions.barHeight - chartBottomPadding;
                        var itemBarHeight = (value * barHeight) / DEFAULT_MAX_PERCENT;
                        // Do not completely hide bar when it percent is zero
                        // Should keep it as 1 pixel
                        if (mergedStyleOptions.isShowWhenBarZero && itemBarHeight === 0) {
                            itemBarHeight = 1;
                        }
                        // Calculate spacing between bar item
                        var barSpacing = calculateBarSpacing(mergedOptions.isHorizontal
                            ? mergedStyleOptions.barHeight
                            : chartWidth - mergedStyleOptions.rightPadding, mergedStyleOptions.barWidth, data.length, index, mergedTextOptions.xAxisPosition, mergedOptions.isHorizontal);
                        // calculate bar position X
                        var barX = mergedStyleOptions.barWidth * index +
                            barSpacing +
                            (mergedOptions.isHorizontal ? chartTopPadding : chartLeftPadding);
                        // calculate bar position Y
                        var barY = mergedStyleOptions.barHeight -
                            itemBarHeight +
                            DEFAULT_HEIGHT_PADDING +
                            32 -
                            chartBottomPadding;
                        var textX = barX + mergedStyleOptions.barWidth / 2;
                        if (mergedOptions.isHorizontal) {
                            textX = barX + mergedStyleOptions.barWidth / 2 + DEFAULT_FONT_SIZE / 2 - 2;
                        }
                        // Fill bar color by highlight or not
                        var fillColor = isHighLight
                            ? mergedStyleOptions.highlightColor
                            : mergedStyleOptions.barColor;
                        var barOpacity = 1;
                        var overlayBarOpacity = 1;
                        var textOpacity = 1;
                        if (hoverBarIndex !== -1) {
                            barOpacity = hoverBarIndex === index ? 1 : 0.2;
                            textOpacity = hoverBarIndex === index ? 1 : 0.2;
                            overlayBarOpacity = hoverBarIndex === index ? 1 : 0;
                        }
                        var overflowBottomBarHeight = itemBarHeight - DEFAULT_BORDER_RADIUS;
                        var topTextPosX = mergedOptions.isHorizontal
                            ? chartLeftPadding + itemBarHeight + DEFAULT_BAR_TEXT_GAP_TOP
                            : textX;
                        if (topTextPosX < chartLeftPadding) {
                            // DEFAULT_BORDER_RADIUS is used for fixed value only (constant)
                            // No meaning in formular
                            topTextPosX = chartLeftPadding + DEFAULT_BORDER_RADIUS;
                        }
                        var horizontalBarWidth = itemBarHeight;
                        // Do not completely hide bar item when it percent is zero
                        // Should keep it as 1 pixel
                        if (itemBarHeight === 1 && horizontalBarWidth < chartLeftPadding) {
                            horizontalBarWidth = 1;
                        }
                        var bottomTextX = mergedOptions.isHorizontal ? 0 : textX;
                        var bottomTextY = mergedOptions.isHorizontal
                            ? textX
                            : chartHeight -
                                DEFAULT_HEIGHT_PADDING -
                                chartBottomPadding +
                                DEFAULT_BAR_TEXT_GAP_BOTTOM;
                        // If this chart is vertical chart and is rotated bottom text
                        // then we need to add 10 more pixels for margin-top
                        if (!mergedOptions.isHorizontal && mergedStyleOptions.isRotateBottomText) {
                            bottomTextX += 10;
                        }
                        var bottomTextAnchor = 'middle';
                        if (mergedOptions.isHorizontal) {
                            bottomTextAnchor = 'start';
                        }
                        else {
                            if (mergedStyleOptions.isRotateBottomText) {
                                bottomTextAnchor = 'end';
                            }
                        }
                        var barWidth = mergedOptions.isHorizontal ? horizontalBarWidth : mergedStyleOptions.barWidth;
                        if (barWidth < 0) {
                            barWidth = 0;
                        }
                        var overflowBottomBarWidth = mergedOptions.isHorizontal
                            ? overflowBottomBarHeight - mergedStyleOptions.rightPadding
                            : mergedStyleOptions.barWidth;
                        if (overflowBottomBarWidth < 0) {
                            overflowBottomBarWidth = 0;
                        }
                        var overflowBarWidth = mergedOptions.isHorizontal
                            ? chartLeftPadding
                            : mergedStyleOptions.barWidth;
                        if (overflowBarWidth < 0) {
                            overflowBarWidth = 0;
                        }
                        var bottomTextLabel = labels[index];
                        // splitString
                        var barHeightAnimationDuration = "".concat((value * 1.2) / 100, "s");
                        return (react.createElement("g", { key: index },
                            react.createElement(BarRect, { isHaveAnim: true, isHorizontal: mergedOptions.isHorizontal, opacity: barOpacity, x: mergedOptions.isHorizontal ? chartLeftPadding : barX, y: mergedOptions.isHorizontal ? barX : barY, width: barWidth, height: mergedOptions.isHorizontal ? mergedStyleOptions.barWidth : itemBarHeight, fill: fillColor, rx: DEFAULT_BORDER_RADIUS, ry: DEFAULT_BORDER_RADIUS, style: {
                                    animationDuration: barHeightAnimationDuration
                                }, onMouseOver: function () { return setHoverBarIndex(index); }, onMouseLeave: function () { return setHoverBarIndex(-1); }, onClick: function () { return setHoverBarIndex(index); } }),
                            overflowBottomBarHeight > 0 && (react.createElement(BarRect, { isHaveAnim: true, opacity: overlayBarOpacity, isHorizontal: mergedOptions.isHorizontal, x: mergedOptions.isHorizontal ? chartLeftPadding : barX, y: mergedOptions.isHorizontal ? barX : barY + DEFAULT_BORDER_RADIUS, width: overflowBottomBarWidth, height: mergedOptions.isHorizontal
                                    ? mergedStyleOptions.barWidth
                                    : overflowBottomBarHeight, fill: fillColor, style: {
                                    pointerEvents: 'none',
                                    animationDuration: barHeightAnimationDuration
                                } })),
                            mergedStyleOptions.isShowBarText ? (react.createElement(BarText, { isHorizontal: mergedOptions.isHorizontal, x: topTextPosX, y: mergedOptions.isHorizontal ? textX : barY - DEFAULT_BAR_TEXT_GAP_TOP, fill: isHighLight
                                    ? mergedStyleOptions.highlightColor
                                    : mergedStyleOptions.labelColor, opacity: textOpacity, textAnchor: mergedOptions.isHorizontal ? 'start' : 'middle', style: {
                                    fontWeight: isHighLight
                                        ? mergedStyleOptions.highlightFontWeight
                                        : mergedStyleOptions.labelFontWeight,
                                    animationDuration: barHeightAnimationDuration
                                }, fontSize: isInMobile
                                    ? mergedStyleOptions.mobileFontSize
                                    : mergedStyleOptions.desktopFontSize },
                                value,
                                mergedTextOptions.topLabelPostfixText)) : null,
                            react.createElement("rect", { x: mergedOptions.isHorizontal ? 0 - 2 : barX - 1, y: mergedOptions.isHorizontal ? barX - 1 : itemBarHeight + barY, fill: '#fff', width: overflowBarWidth + 2, height: mergedOptions.isHorizontal
                                    ? mergedStyleOptions.barWidth + 2
                                    : chartHeight -
                                        itemBarHeight -
                                        barY +
                                        mergedStyleOptions.bottomPadding +
                                        2 }),
                            react.createElement("g", null,
                                react.createElement("text", { x: bottomTextX, y: mergedOptions.isHorizontal ? textX : bottomTextY, fill: mergedStyleOptions.labelColor, textAnchor: bottomTextAnchor, transform: mergedStyleOptions.isRotateBottomText
                                        ? "rotate(-45 ".concat(bottomTextX, ",").concat(bottomTextY, ")")
                                        : '', fontSize: isInMobile
                                        ? mergedStyleOptions.mobileFontSize
                                        : mergedStyleOptions.desktopFontSize }, isSmaller1024
                                    ? bottomTextLabel
                                    : renderBottomText(bottomTextLabel, bottomTextX)))));
                    }),
                    react.createElement(AxisText, { x: mergedTextOptions.xAxisPosition === 'start' ? 0 : chartWidth, y: chartHeight - DEFAULT_HEIGHT_PADDING + DEFAULT_BAR_TEXT_GAP_BOTTOM, fill: mergedStyleOptions.labelColor, textAnchor: mergedTextOptions.xAxisPosition }, mergedOptions.isHorizontal ? mergedTextOptions.yAxisText : mergedTextOptions.xAxisText))),
            renderTooltip())));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/constant.js
'use client';

var secondaryColor = '#FF7D55';


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonPrimary/ButtonPrimary.css.js
'use client';





var ButtonPrimary_css_Button = styled_components_browser_esm/* default.button */.ZP.button(ButtonPrimary_css_templateObject_3 || (ButtonPrimary_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 10px 24px;\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 20px;\n    outline: none;\n    border: none;\n    cursor: pointer;\n\n    ", "\n"], ["\n    padding: 10px 24px;\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 20px;\n    outline: none;\n    border: none;\n    cursor: pointer;\n\n    ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case 'primary':
            return (0,styled_components_browser_esm/* css */.iv)(ButtonPrimary_css_templateObject_1 || (ButtonPrimary_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    color: white;\n                "], ["\n                    background-color: ", ";\n                    color: white;\n                "])), secondaryColor);
        default:
            return (0,styled_components_browser_esm/* css */.iv)(ButtonPrimary_css_templateObject_2 || (ButtonPrimary_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    color: white;\n                "], ["\n                    background-color: ", ";\n                    color: white;\n                "])), secondaryColor);
    }
});
var ButtonPrimary_css_templateObject_1, ButtonPrimary_css_templateObject_2, ButtonPrimary_css_templateObject_3;


//# sourceMappingURL=ButtonPrimary.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonPrimary/index.js
'use client';





var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["primary"] = 0] = "primary";
    ButtonType[ButtonType["secondary"] = 1] = "secondary";
})(ButtonType || (ButtonType = {}));
function ButtonPrimary(props) {
    var children = props.children, onClick = props.onClick, _a = props.type, type = _a === void 0 ? ButtonType.primary : _a, rest = (0,_tslib/* __rest */._T)(props, ["children", "onClick", "type"]);
    return (react.createElement(ButtonPrimary_css_Button, (0,_tslib/* __assign */.pi)({ type: type, onClick: onClick }, rest), children));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OptionGroup/OptionGroup.style.js
'use client';






var mapTypeToColor = function (type) {
    var _a;
    return type ? (_a = {},
        _a[constants/* EAlertType.info */.P.info] = Colors/* colors.primary */.O9.primary,
        _a[constants/* EAlertType.warning */.P.warning] = Colors/* colors.yellow */.O9.yellow,
        _a[constants/* EAlertType.danger */.P.danger] = Colors/* colors.error */.O9.error,
        _a[constants/* EAlertType.success */.P.success] = Colors/* colors.green */.O9.green,
        _a)[type] : Colors/* colors.primary */.O9.primary;
};
var OptionGroupWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function (props) {
    return {
        colorRangeBaseOnType: mapTypeToColor(props.alertType),
    };
})(OptionGroup_style_templateObject_3 || (OptionGroup_style_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 8px;\n    position: relative;\n    cursor: ", ";\n    ", "\n"], ["\n    border-radius: 8px;\n    position: relative;\n    cursor: ", ";\n    ", "\n"])), function (props) { return props.disabled ? 'unset' : 'pointer'; }, function (props) {
    if (props.disabled && props.contentDisable) {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_1 || (OptionGroup_style_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                &:after {\n                    content: '';\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 100%;\n                    background-color: transparent;\n                    cursor: not-allowed;\n                    border-radius: 8px;\n                }\n            "], ["\n                &:after {\n                    content: '';\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 100%;\n                    background-color: transparent;\n                    cursor: not-allowed;\n                    border-radius: 8px;\n                }\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_2 || (OptionGroup_style_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var OptionGroupInput = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(function (props) {
    return {
        colorRangeBaseOnType: mapTypeToColor(props.alertType),
    };
})(OptionGroup_style_templateObject_6 || (OptionGroup_style_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    appearance: none;\n    position: relative;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    margin-right: 8px;\n    &:before {\n        top: 3px;\n        left: 3px;\n    }\n\n\n    &[type=\"radio\"] {\n        &:before {\n            content: '';\n            position: absolute;\n            background-color: transparent;\n            border-radius: 50%;\n            border: 1px solid ", ";\n            width: 16px;\n            height: 16px;\n            ", ":hover & {\n                border-color: ", "\n            }\n        }\n        &:checked {\n            &:before {\n                background-color: ", ";\n            }\n            &:after {\n                content: '';\n                position: absolute;\n                border-radius: 50%;\n                top: 7px;\n                left: 7px;\n                width: 8px;\n                height: 8px;\n                background-color: #fff;\n            }\n        }\n    }\n    &[type=\"checkbox\"] {\n\n    }\n    ", "\n\n"], ["\n    appearance: none;\n    position: relative;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    margin-right: 8px;\n    &:before {\n        top: 3px;\n        left: 3px;\n    }\n\n\n    &[type=\"radio\"] {\n        &:before {\n            content: '';\n            position: absolute;\n            background-color: transparent;\n            border-radius: 50%;\n            border: 1px solid ", ";\n            width: 16px;\n            height: 16px;\n            ", ":hover & {\n                border-color: ", "\n            }\n        }\n        &:checked {\n            &:before {\n                background-color: ", ";\n            }\n            &:after {\n                content: '';\n                position: absolute;\n                border-radius: 50%;\n                top: 7px;\n                left: 7px;\n                width: 8px;\n                height: 8px;\n                background-color: #fff;\n            }\n        }\n    }\n    &[type=\"checkbox\"] {\n\n    }\n    ", "\n\n"])), function (props) {
    if (props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return Colors/* colors.grey.40 */.O9.grey[40];
}, OptionGroupWrapper, function (props) {
    if (props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    else if (props.disabled) {
        return Colors/* colors.grey.40 */.O9.grey[40];
    }
    return props.colorRangeBaseOnType[70];
}, function (props) { return props.colorRangeBaseOnType[40]; }, function (props) {
    if (props.multiple) {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_4 || (OptionGroup_style_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n\n            "], ["\n\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_5 || (OptionGroup_style_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            "], ["\n            "])));
});
var OptionGroup_style_Label = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function (props) {
    return {
        colorRangeBaseOnType: mapTypeToColor(props.alertType),
    };
})(OptionGroup_style_templateObject_9 || (OptionGroup_style_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 4px;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 4px;\n    ", "\n"])), function (props) {
    if (props.multiple) {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_7 || (OptionGroup_style_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                > div:first-child {\n                    margin-left: -5px\n                }\n            "], ["\n                > div:first-child {\n                    margin-left: -5px\n                }\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_8 || (OptionGroup_style_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            label {\n                padding-left: 3px;\n                height: unset;\n                min-height: 24px;\n            }\n        "], ["\n            label {\n                padding-left: 3px;\n                height: unset;\n                min-height: 24px;\n            }\n        "])));
});
var ContentWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function (props) {
    return {
        colorRangeBaseOnType: mapTypeToColor(props.alertType),
    };
})(OptionGroup_style_templateObject_15 || (OptionGroup_style_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    border-radius: 12px;\n    padding: 12px;\n    margin-bottom: 12px;\n    width: 100%;\n    box-shadow: inset 0 0 0 1px ", ";\n    background: ", ";\n    transition: all 0.25s;\n\n    &:hover {\n        ", "\n    }\n    will-change: box-shadow, opacity, background-color;\n\n\n    // Override children styles\n    // Make checkbox background color transparent\n    input[type=\"checkbox\"] ~ label {\n        ", "\n    }\n\n    &:hover {\n        // Force checkbox border color change on parent hover\n        input[type=\"radio\"], input[type=\"checkbox\"] ~ label {\n            ", "\n        }\n    }\n"], ["\n    position: relative;\n    border-radius: 12px;\n    padding: 12px;\n    margin-bottom: 12px;\n    width: 100%;\n    box-shadow: inset 0 0 0 1px ", ";\n    background: ", ";\n    transition: all 0.25s;\n\n    &:hover {\n        ", "\n    }\n    will-change: box-shadow, opacity, background-color;\n\n\n    // Override children styles\n    // Make checkbox background color transparent\n    input[type=\"checkbox\"] ~ label {\n        ", "\n    }\n\n    &:hover {\n        // Force checkbox border color change on parent hover\n        input[type=\"radio\"], input[type=\"checkbox\"] ~ label {\n            ", "\n        }\n    }\n"])), function (props) {
    if (props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return props.colorRangeBaseOnType[80];
    }
    return Colors/* colors.grey.90 */.O9.grey[90];
}, function (props) {
    if (props.checked) {
        return props.colorRangeBaseOnType[99];
    }
    else {
        return Colors/* colors.grey.99 */.O9.grey[99];
    }
}, function (props) {
    if (props.checked || props.alertType === constants/* EAlertType.danger */.P.danger || props.disabled) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_10 || (OptionGroup_style_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                box-shadow: inset 0 0 0 1px ", ";\n                background-color: ", ";\n            "], ["\n                box-shadow: inset 0 0 0 1px ", ";\n                background-color: ", ";\n            "])), props.colorRangeBaseOnType[80], props.colorRangeBaseOnType[95]);
}, function (props) {
    if (props.checked) {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_11 || (OptionGroup_style_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_12 || (OptionGroup_style_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["background-color: transparent"], ["background-color: transparent"])));
}, function (props) {
    if (props.disabled || props.alertType === constants/* EAlertType.danger */.P.danger || props.checked) {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_13 || (OptionGroup_style_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_14 || (OptionGroup_style_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["border-color: ", ""], ["border-color: ", ""])), props.colorRangeBaseOnType[70]);
});
var Content = styled_components_browser_esm/* default.div */.ZP.div(OptionGroup_style_templateObject_18 || (OptionGroup_style_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: ", ";\n    ", "\n"], ["\n    opacity: ", ";\n    ", "\n"])), function (props) { return props.disabled ? 0.4 : 1; }, function (props) {
    if (props.align === 'left') {
        return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_16 || (OptionGroup_style_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n              padding-left: 30px;\n            "], ["\n              padding-left: 30px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(OptionGroup_style_templateObject_17 || (OptionGroup_style_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-left: 8px;\n            padding-right: 30px;\n        "], ["\n            padding-left: 8px;\n            padding-right: 30px;\n        "])));
});
var OptionGroupStyled = {
    Wrapper: OptionGroupWrapper,
    Input: OptionGroupInput,
    Label: OptionGroup_style_Label,
    ContentWrapper: ContentWrapper,
    Content: Content
};
var OptionGroup_style_templateObject_1, OptionGroup_style_templateObject_2, OptionGroup_style_templateObject_3, OptionGroup_style_templateObject_4, OptionGroup_style_templateObject_5, OptionGroup_style_templateObject_6, OptionGroup_style_templateObject_7, OptionGroup_style_templateObject_8, OptionGroup_style_templateObject_9, OptionGroup_style_templateObject_10, OptionGroup_style_templateObject_11, OptionGroup_style_templateObject_12, OptionGroup_style_templateObject_13, OptionGroup_style_templateObject_14, OptionGroup_style_templateObject_15, OptionGroup_style_templateObject_16, OptionGroup_style_templateObject_17, OptionGroup_style_templateObject_18;


//# sourceMappingURL=OptionGroup.style.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OptionGroup/index.js
'use client';







var OptionGroup = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? {} : _b, onChange = _a.onChange, value = _a.value, name = _a.name, id = _a.id, _c = _a.alertType, alertType = _c === void 0 ? constants/* EAlertType.info */.P.info : _c, _d = _a.align, align = _d === void 0 ? 'left' : _d, _e = _a.checked, checked = _e === void 0 ? false : _e, _f = _a.multiple, multiple = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.contentDisable, contentDisable = _h === void 0 ? false : _h, _j = _a.label, label = _j === void 0 ? '' : _j, children = _a.children, customLabel = _a.customLabel;
    var optionGroupRef = (0,react.useRef)(null);
    var labelRef = (0,react.useRef)(null);
    var _k = (0,react.useState)(checked), currentCheckStatus = _k[0], setCurrentCheckStatus = _k[1];
    var handleCheckStateChange = function (checkValue) {
        if (currentCheckStatus && checkValue) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var handleOnClick = function (e) {
        var _a, _b, _c;
        if (disabled || ((_a = labelRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        (_c = (_b = optionGroupRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('input')) === null || _c === void 0 ? void 0 : _c.click();
    };
    (0,react.useEffect)(function () { return setCurrentCheckStatus(checked); }, [checked]);
    return (react.createElement(OptionGroupStyled.Wrapper, { onClick: handleOnClick, checked: checked, alertType: alertType, id: id || "option-group-".concat(value), disabled: disabled, ref: optionGroupRef, contentDisable: contentDisable, style: (styles === null || styles === void 0 ? void 0 : styles.groupStyle) || {} },
        react.createElement(OptionGroupStyled.ContentWrapper, { disabled: disabled, alertType: alertType, checked: checked, style: (styles === null || styles === void 0 ? void 0 : styles.wrapperStyle) || {} },
            react.createElement(OptionGroupStyled.Label, { ref: labelRef, multiple: multiple }, multiple === true ? (react.createElement(SingleCheckBox/* default */.Z, { height: 24, noBg: true, hoverBgOff: true, alertType: alertType, isLeftCheckbox: align === 'left', id: "".concat(value), name: name, isChecked: checked, label: label, disabled: disabled, onChecked: handleCheckStateChange })) : (react.createElement(SingleRadio/* default */.Z, { height: 24, noBg: true, alertType: alertType, hoverBgOff: true, isLeftRadio: align === 'left', id: "".concat(value), onChange: handleCheckStateChange, label: label, name: name, checked: checked, disabled: disabled, customValue: customLabel ? customLabel : null }))),
            react.createElement(OptionGroupStyled.Content, { align: align, disabled: contentDisable && disabled, style: styles === null || styles === void 0 ? void 0 : styles.contentStyle }, children))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/canvas.js
'use client';

function createHiPPICanvas(canvas, width, height) {
    var _a;
    /*
     * Ref: https://stackoverflow.com/questions/15661339/how-do-i-fix-blurry-text-in-my-html5-canvas
     * */
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    var ratio = window.devicePixelRatio;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    (_a = canvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.scale(ratio, ratio);
    return canvas;
}
/*
 * Curve helper
 * */
var EPSILON = 1e-6;
/**
 * Compute slope from point 'p0' to 'p1'
 * @param {Array} p0
 * @param {Array} p1
 * @returns {Number}
 */
function computeSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
}
/*
 * Find reflection for point to respected point
 * @param {Array} point
 * @param {Array} respected point
 * */
function reflectionPoints(point, respectedPoint) {
    var x = respectedPoint[0] * 2 - point[0];
    var y = respectedPoint[1] * 2 - point[1];
    return [x, y];
}
/**
 * Compute three-point differences for 'points'
 * @param {Array} points
 * @returns {Array}
 */
function finiteDifferences(points) {
    var m = [];
    var p0 = points[0];
    var p1 = points[1];
    var d = (m[0] = computeSlope(p0, p1));
    var i = 1;
    for (var n = points.length - 1; i < n; i++) {
        p0 = p1;
        p1 = points[i + 1];
        m[i] = (d + (d = computeSlope(p0, p1))) * 0.5;
    }
    m[i] = d;
    return m;
}
/**
 * Generate tangents for 'points'
 * @param {Array} points
 * @returns {Array}
 */
function computeTangents(points) {
    var m = finiteDifferences(points);
    var n = points.length - 1;
    var tangents = [];
    var a, b, d, s;
    for (var i = 0; i < n; i++) {
        d = computeSlope(points[i], points[i + 1]);
        if (Math.abs(d) < EPSILON) {
            m[i] = m[i + 1] = 0;
        }
        else {
            a = m[i] / d;
            b = m[i + 1] / d;
            s = a * a + b * b;
            if (s > 9) {
                s = (d * 3) / Math.sqrt(s);
                m[i] = s * a;
                m[i + 1] = s * b;
            }
        }
    }
    for (var i = 0; i <= n; i++) {
        s = (points[Math.min(n, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
        tangents.push([s || 0, m[i] * s || 0]);
    }
    return tangents;
}
/**
 * Convert 'points' to bezier
 * @param {Array} points
 * @returns {Array}
 */
function computePoints(points) {
    var tangents = computeTangents(points);
    var p = points[1];
    var p0 = points[0];
    var pts = [];
    var t = tangents[1];
    var t0 = tangents[0];
    // Add starting 'M' and 'C' points
    pts.push(p0, [p0[0] + t0[0], p0[1] + t0[1], p[0] - t[0], p[1] - t[1], p[0], p[1]]);
    for (var i = 2, n = tangents.length; i < n; i++) {
        var p_1 = points[i];
        var t_1 = tangents[i];
        var prevPts = pts[i - 1];
        var reflectedPoints = reflectionPoints([prevPts[2], prevPts[3]], [prevPts[4], prevPts[5]]);
        pts.push([reflectedPoints[0], reflectedPoints[1], p_1[0] - t_1[0], p_1[1] - t_1[1], p_1[0], p_1[1]]);
    }
    return pts;
}
/* function getControlPoints(x0: number, y0: number, x1: number, y1: number, x2: number, y2: number, t: number) { */
/*     Ref: http://scaledinnovation.com/analytics/splines/aboutSplines.html */
/*     const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)) */
/*     const d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)) */
/*     const fa = (t * d01) / (d01 + d12) // scaling factor for triangle Ta */
/*     const fb = (t * d12) / (d01 + d12) // ditto for Tb, simplifies to fb=t-fa */
/*     const p1x = x1 - fa * (x2 - x0) // x2-x0 is the width of triangle T */
/*     const p1y = y1 - fa * (y2 - y0) // y2-y0 is the height of T */
/*     const p2x = x1 + fb * (x2 - x0) */
/*     const p2y = y1 + fb * (y2 - y0) */
/*     return [p1x, p1y, p2x, p2y] */
/* } */
/*
 * End curve helper
 * */
var canvasHelper = {
    createHiPPICanvas: createHiPPICanvas,
    computePoints: computePoints
};


//# sourceMappingURL=canvas.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/data.js
'use client';



var THRESHOLD_1 = 1;
var THRESHOLD_2 = 6;
var THRESHOLD_3 = 8;
var THRESHOLD_4 = 10;
var STEP_1 = 0.5;
var STEP_2 = 1;
var STEP_3 = 2;
var MINIMUM_NUMERIC_DATA = 6;
/*
 * Get number information
 * Return:
 *   numberLength    Length of number (ex: length of 212 is 3)
 *   powOf10Number   Power of 10 of number by it's length - 1
 *   integer         integer part of number after divided by powOf10Number
 *   decimal         decimal part of number (fixed to 1 number) after divided by powOf10Number
 *
 * */
function getNumberInformation(number) {
    if (number < 10) {
        return [{ integer: number, decimal: 0 }, 1, 1];
    }
    var numberLength = Math.floor(Math.log10(number)) + 1;
    var powOf10Number = Math.pow(10, numberLength - 1);
    var dividedNumber = number / powOf10Number;
    var decimalNumber = dividedNumber.toString().split('.')[1];
    return [
        {
            integer: Math.floor(dividedNumber),
            decimal: decimalNumber ? parseInt(decimalNumber.substring(0, 1)) : 0
        },
        numberLength,
        powOf10Number
    ];
}
/*
 * Get maxNumber and step after converted
 * @param number     Number between 1 to 9
 * @param powOf10    Power of 10 of number
 * @param step       maxNumber will be roundup by number + step * powOf10
 *   ex: 121 will be roundup to 150 and step is 50
 * */
function convertMaxNumber(number, step, powOf10) {
    var convertedStep = step * powOf10;
    if (number > THRESHOLD_2 && number < THRESHOLD_3) {
        /*
         * The number between THRESHOLD_2 and THRESHOLD_3 is 7
         * if number is equal to 7, i don't want it to be 9 and step 2
         * so that, i have to minus it by 1 and it will be 8 and step 2 after converted
         * */
        var convertedNumber = (number - 1) * powOf10 + convertedStep;
        return {
            maxNumber: convertedNumber,
            step: convertedStep
        };
    }
    if (number > THRESHOLD_3) {
        /*
         * Since, i just want number after converted is between 1 to 10
         * so, if the number is greater than 8, i have to roundup number by
         * add it with (10 - number)
         * */
        return {
            maxNumber: (number + (THRESHOLD_4 - number)) * powOf10,
            step: convertedStep
        };
    }
    return {
        maxNumber: number * powOf10 + convertedStep,
        step: convertedStep
    };
}
/*
 * Apply logic to get step and maxNumber corresponding
 * @param number     Max number in chart data
 * */
function getStepAndConvertMaxNumber(number) {
    var maxNumber = number;
    if (maxNumber === 0) {
        maxNumber = MINIMUM_NUMERIC_DATA;
    }
    var _a = getNumberInformation(maxNumber), _b = _a[0], integer = _b.integer, decimal = _b.decimal, numberLength = _a[1], powOf10Number = _a[2];
    if (numberLength === THRESHOLD_1 && integer < THRESHOLD_4) {
        /*
         * This logic is for number between 0 to 10
         * If number is less than 6, step will be 1, otherwise step will be 2
         * and the number will be MINIMUM_NUMERIC_NUMBER, cause i don't want
         * the range in axes will be in 0 to 1 or 0 to number less than 5
         * */
        if (integer <= THRESHOLD_2) {
            return convertMaxNumber(MINIMUM_NUMERIC_DATA, STEP_2, powOf10Number);
        }
        return convertMaxNumber(integer, STEP_3, powOf10Number);
    }
    if (integer === THRESHOLD_1) {
        /*
         * This logic is for number which greater than 10 and integer part is 1
         * Step is 0.5
         * */
        if (decimal < THRESHOLD_2 - 1) {
            return convertMaxNumber(integer, STEP_1, powOf10Number);
        }
        /*
         * If decimal part of number is greater than 5
         * i have to add number's integer part by step 0.5 before convertMaxNumber
         * Example:
         * Number: 151
         *   - integer: 1
         *   - decimal: 5
         * if i don't add integer by step 0.5 so that number after
         * convertMaxNumber(integer, STEP_1, powOf10Number) is 150.
         * This is wrong since 150 is less than 151
         * so that i have to add integer by step 0.5 before convert
         * */
        var convertedNumber = integer + STEP_1;
        return convertMaxNumber(convertedNumber, STEP_1, powOf10Number);
    }
    if (integer > THRESHOLD_1 && integer < THRESHOLD_2) {
        /*
         * This logic is for for number which integer part is between 2 and 6
         * Step is 1
         * */
        return convertMaxNumber(integer, STEP_2, powOf10Number);
    }
    /* Otherwise step is 2 */
    return convertMaxNumber(integer, STEP_3, powOf10Number);
}
function getDataRangeInAxes(chartConfig) {
    var data = chartConfig.data, xField = chartConfig.xField, yField = chartConfig.yField, _a = chartConfig.series, series = _a === void 0 ? '' : _a;
    var convertedData = {};
    var seriesValues = [];
    var numericData = [];
    var xAxis = [];
    var yAxis = [];
    var dataBySeries = {};
    data.map(function (item) {
        var _a;
        numericData.push(item[yField]);
        if (!xAxis.includes(item[xField])) {
            xAxis.push(item[xField]);
        }
        if (!seriesValues.includes(item[series])) {
            seriesValues.push(item[series]);
        }
        convertedData[item[xField]] = series
            ? (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, convertedData[item[xField]]), (_a = {}, _a[item[series]] = item[yField], _a)) : item[yField];
        if (series) {
            dataBySeries[item[series]] = dataBySeries[item[series]]
                ? dataBySeries[item[series]].concat([item[yField]])
                : [item[yField]];
        }
    });
    var _b = getStepAndConvertMaxNumber(Math.max.apply(Math, numericData)), maxNumber = _b.maxNumber, step = _b.step;
    for (var i = maxNumber; i >= 0; i -= step) {
        yAxis.push(i);
    }
    return {
        xAxis: xAxis,
        yAxis: yAxis,
        series: seriesValues,
        data: convertedData,
        step: step,
        dataBySeries: dataBySeries
    };
}
var data = {
    getDataRangeInAxes: getDataRangeInAxes
};


//# sourceMappingURL=data.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/config.js
'use client';

var X_LABEL_HEIGHT = 20;
var CHART_START_DRAWING = 20;
/*
 * Chart config
 * */
var CHART_DECREASE_RATIO = 0.02;
var SPECIFIC_CHART = ['line'];
/* Line */
var CHART_LINE_WIDTH = 3;
/*
 * Color config
 * */
var LIST_COLORS = [
    { foreground: '#001744', background: '#ccd0d9' },
    { foreground: '#6FB920', background: '#e2f1d2' },
    { foreground: '#FF7D55', background: '#ffe5dd' },
    { foreground: '#005AFF', background: '#ccdeff' },
    { foreground: '#f7bf06', background: '#fdf2cd' },
    { foreground: '#48BBFF', background: '#daf1ff' }
];
var HOVER_COLOR = '#f7faff';
/*
 * Text style
 * */
var TEST_TEXT = 'VNW_WITH_LOVE';
var LINE_HEIGHT = 2;
var config_TEXT_COLOR = '#848484';
/* Axes cross line style */
var CROSS_LINE_COLOR = '#dddddd';
var CROSS_LINE_WIDTH = 1;
/*
 * Default font
 * */
var defaultFont = {
    color: config_TEXT_COLOR,
    family: 'Inter',
    size: 12,
    weight: 500
};
var defaultTooltip = {
    title: {
        color: '#999',
        size: 14,
        weight: 700
    },
    content: {
        color: '#999',
        size: 13,
        weight: 500
    },
    padding: 10,
    borderRadius: 8,
    boxShadow: {
        offsetX: 0,
        offsetY: 2,
        blur: 8,
        color: 'rgba(51, 51, 51, 0.15)'
    },
    backgroundColor: '#fff'
};


//# sourceMappingURL=config.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/drawing.js
'use client';



/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 * @param {CanvasRenderingContext2D} ctx
 * @param {Number} x The top left x coordinate
 * @param {Number} y The top left y coordinate
 * @param {Number} width The width of the rectangle
 * @param {Number} height The height of the rectangle
 * @param {Number} [radius = 5] The corner radius; It can also be an object
 *                 to specify different radii for corners
 * @param {Number} [radius.tl = 0] Top left
 * @param {Number} [radius.tr = 0] Top right
 * @param {Number} [radius.br = 0] Bottom right
 * @param {Number} [radius.bl = 0] Bottom left
 */
function roundRect(ctx, x, y, width, height, radius) {
    var borderRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
    if (typeof radius === 'number') {
        borderRadius = { tl: radius, tr: radius, br: radius, bl: radius };
    }
    else {
        borderRadius = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, borderRadius), radius);
    }
    ctx.beginPath();
    ctx.moveTo(x + borderRadius.tl, y);
    ctx.lineTo(x + width - borderRadius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + borderRadius.tr);
    ctx.lineTo(x + width, y + height - borderRadius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - borderRadius.br, y + height);
    ctx.lineTo(x + borderRadius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - borderRadius.bl);
    ctx.lineTo(x, y + borderRadius.tl);
    ctx.quadraticCurveTo(x, y, x + borderRadius.tl, y);
    ctx.closePath();
}
// @description: wrapText wraps HTML canvas text onto a canvas of fixed width
// @param ctx - the context for the canvas we want to wrap text on
// @param text - the text we want to wrap.
// @param x - the X starting point of the text on the canvas.
// @param y - the Y starting point of the text on the canvas.
// @param maxWidth - the width at which we want line breaks to begin - i.e. the maximum width of the canvas.
// @param lineHeight - the height of each line, so we can space them below each other.
// @returns an array of [ lineText, x, y ] for all lines
function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    // First, start by splitting all of our text into words, but splitting it into an array split by spaces
    var words = text.split(' ');
    var line = ''; // This will store the text of the current line
    var testLine = ''; // This will store the text when we add a word, to test if it's too long
    var lineArray = []; // This is an array of lines, which the function will return
    var textArray = [];
    var textHeightHasIncreased = 0;
    // Lets iterate over each word
    for (var i = 0; i < words.length; i++) {
        // Create a test line, and measure it..
        testLine += "".concat(words[i], " ");
        var _a = ctx.measureText(testLine), textWidth = _a.width, actualBoundingBoxAscent = _a.actualBoundingBoxAscent, actualBoundingBoxDescent = _a.actualBoundingBoxDescent;
        // If the width of this test line is more than the max width
        if (textWidth > maxWidth && i > 0) {
            // Then the line is finished, push the current line into "lineArray"
            lineArray.push([line, x, y]);
            textArray.push(line);
            // Increase the line height, so a new line is started
            var increasedLineHeight = actualBoundingBoxAscent + actualBoundingBoxDescent + lineHeight;
            y += increasedLineHeight;
            textHeightHasIncreased += increasedLineHeight;
            // Update line and test line to use this word as the first word on the next line
            line = "".concat(words[i], " ");
            testLine = "".concat(words[i], " ");
        }
        else {
            // If the test line is still less than the max width, then add the word to the current line
            line += "".concat(words[i], " ");
        }
        // If we never reach the full max width, then there is only one line.. so push it into the lineArray so we return something
        if (i === words.length - 1) {
            lineArray.push([line, x, y]);
            textArray.push(line);
        }
    }
    var largestTextWidth = Math.max.apply(Math, textArray.map(function (item) { return ctx.measureText(item).width; }));
    return { lineArray: lineArray, textHeightHasIncreased: textHeightHasIncreased, largestTextWidth: largestTextWidth };
}
var drawing = {
    roundRect: roundRect,
    wrapText: wrapText
};


//# sourceMappingURL=drawing.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/calculation.js
'use client';




function getLargestTextWidth(ctx, textList) {
    if (!ctx)
        return 0;
    var textWidthList = textList.map(function (item) { return ctx.measureText(item).width; });
    return Math.max.apply(Math, textWidthList);
}
function calculation_responsiveHelper(_a) {
    var type = _a.type, ctx = _a.ctx, xRange = _a.xRange, chartStartingPointInYAxis = _a.chartStartingPointInYAxis, chartEndingPointInYAxis = _a.chartEndingPointInYAxis, chartStartingPointInXAxis = _a.chartStartingPointInXAxis, chartInformation = _a.chartInformation, axesConfig = _a.axesConfig;
    var xAxis = chartInformation.xAxis, yAxis = chartInformation.yAxis;
    /*
     * Coordinate of y-axis and x-axis label
     * */
    var startLabelingInYAxis = chartStartingPointInYAxis + X_LABEL_HEIGHT;
    var startLabelingInXAxis = chartStartingPointInXAxis;
    /*
     * Check single data
     * */
    if (SPECIFIC_CHART.includes(type)) {
        startLabelingInXAxis += xRange / 2;
    }
    /*
     * Calculate the increased text height if text is wrapped
     * */
    var _b = axesConfig || {}, decorationForHorizontalLabel = _b.decorationForHorizontalLabel, _c = _b.hideXAxis, hideXAxis = _c === void 0 ? false : _c;
    var largestTextInLabels = 0;
    var textHeight = 0;
    var convertedLabelOnXAxis = xAxis.map(function (item) {
        return decorationForHorizontalLabel ? decorationForHorizontalLabel(item) : item;
    });
    convertedLabelOnXAxis.forEach(function (item) {
        var _a = drawing.wrapText(ctx, item.toString(), startLabelingInXAxis, startLabelingInYAxis, xRange, LINE_HEIGHT), largestTextWidth = _a.largestTextWidth, textHeightHasIncreased = _a.textHeightHasIncreased;
        if (largestTextInLabels < largestTextWidth) {
            largestTextInLabels = largestTextWidth;
        }
        if (textHeight < textHeightHasIncreased) {
            textHeight = textHeightHasIncreased;
        }
        startLabelingInXAxis += xRange;
    });
    /*
     * Reset the increased text height if i hidden x-axis
     * The text height now is equal to the negative X_LABEL_HEIGHT
     * */
    if (hideXAxis) {
        textHeight = -X_LABEL_HEIGHT;
    }
    var yRange = (chartStartingPointInYAxis - (chartEndingPointInYAxis + textHeight)) / (yAxis.length - 1);
    var rsChartStartingPointInYAxis = chartStartingPointInYAxis - textHeight;
    var xLabelTextMaxLength = largestTextInLabels;
    return {
        yRange: yRange,
        chartStartingPointInYAxis: rsChartStartingPointInYAxis,
        xLabelTextMaxLength: xLabelTextMaxLength,
        startLabelingInXAxis: startLabelingInXAxis,
        startLabelingInYAxis: startLabelingInYAxis
    };
}
function getNecessaryInformation(ctx, chartInformation, width, height, config) {
    var _a;
    /* const { dataRange, dataLabels, labels } = chartInformation; */
    var yAxis = chartInformation.yAxis, xAxis = chartInformation.xAxis;
    var type = config.chart.type;
    var _b = ((_a = config.default) === null || _a === void 0 ? void 0 : _a.font) || {}, _c = _b.weight, weight = _c === void 0 ? defaultFont.weight : _c, _d = _b.size, size = _d === void 0 ? defaultFont.size : _d, _e = _b.family, family = _e === void 0 ? defaultFont.family : _e;
    /*
     * Set default font
     * */
    ctx.font = "".concat(weight, " ").concat(size, "px ").concat(family);
    /*
     * End set default font
     * */
    /* Get config */
    var decorationForVerticalLabel = ((config === null || config === void 0 ? void 0 : config.axes) || {}).decorationForVerticalLabel;
    var convertedDataRange = yAxis.map(function (item) {
        return decorationForVerticalLabel ? decorationForVerticalLabel(item) : item.toString();
    });
    var labelLengthInYAxis = getLargestTextWidth(ctx, convertedDataRange);
    var _f = ctx.measureText(TEST_TEXT), actualBoundingBoxAscent = _f.actualBoundingBoxAscent, actualBoundingBoxDescent = _f.actualBoundingBoxDescent;
    var textHeight = actualBoundingBoxAscent + actualBoundingBoxDescent;
    var chartStartingPointInYAxis = height - X_LABEL_HEIGHT - textHeight;
    var chartEndingPointInYAxis = textHeight / 2 + 1;
    var chartStartingPointInXAxis = labelLengthInYAxis + CHART_START_DRAWING;
    /*
     * Detect when last label in x-axis overflow over chart area
     *
     * */
    var largestTextWidth = drawing.wrapText(ctx, xAxis[xAxis.length - 1].toString(), 0, 0, 1, 10).largestTextWidth;
    var rangeInXAxis = (width / xAxis.length - 1) / 2;
    var lastLabelLengthInXAxis = 0;
    if (largestTextWidth / 2 - rangeInXAxis > 0) {
        /*
         * If text is overflow, i will calculate the width of overflow part by
         * minus half of largestTextWidth with range in xAxis         * */
        lastLabelLengthInXAxis = largestTextWidth / 2 - rangeInXAxis + 2;
    }
    if (SPECIFIC_CHART.includes(type)) {
        /*
         * For specific chart, just use the half of textWidth
         * */
        var width_1 = ctx.measureText(xAxis[xAxis.length - 1].toString()).width;
        lastLabelLengthInXAxis = width_1 / 2;
    }
    var chartEndingPointInXAxis = width - lastLabelLengthInXAxis;
    var yAxisLabelAt = 0; // Labeling position in y-axis
    /*
     * Check if data is single or not
     * */
    var labelsLength = xAxis.length;
    if (SPECIFIC_CHART.includes(type)) {
        labelsLength = xAxis.length - 1;
    }
    var xRange = (chartEndingPointInXAxis - chartStartingPointInXAxis) / labelsLength; // Range between XAxis threshold
    var _g = calculation_responsiveHelper({
        type: type,
        ctx: ctx,
        xRange: xRange,
        chartStartingPointInYAxis: chartStartingPointInYAxis,
        chartEndingPointInYAxis: chartEndingPointInYAxis,
        chartStartingPointInXAxis: chartStartingPointInXAxis,
        chartInformation: chartInformation,
        axesConfig: config === null || config === void 0 ? void 0 : config.axes
    }), rsChartStartingPointInYAxis = _g.chartStartingPointInYAxis, rsYRange = _g.yRange, xLabelTextMaxLength = _g.xLabelTextMaxLength, startLabelingInXAxis = _g.startLabelingInXAxis, startLabelingInYAxis = _g.startLabelingInYAxis;
    return {
        chartArea: {
            chartStartingPointInXAxis: chartStartingPointInXAxis,
            chartEndingPointInXAxis: chartEndingPointInXAxis,
            chartStartingPointInYAxis: rsChartStartingPointInYAxis,
            chartEndingPointInYAxis: chartEndingPointInYAxis
        },
        yAxisLabelAt: yAxisLabelAt,
        xRange: xRange,
        yRange: rsYRange,
        yLabelTextMaxLength: labelLengthInYAxis,
        xLabelTextMaxLength: xLabelTextMaxLength,
        startLabelingInXAxis: startLabelingInXAxis,
        startLabelingInYAxis: startLabelingInYAxis
    };
}
/*
 * Get calculate data point position in y-axis
 * @param {ChartInformation} chartInformation
 * @param {number} chartStartingPointInYAxis
 * @param {number} chartEndingPointInYAxis
 * @data {number} data
 * */
function getPointCoordinateInYAxis(props, controlRatio) {
    var chartInformation = props.chartInformation, data = props.data, chartStartingPointInYAxis = props.chartStartingPointInYAxis, chartEndingPointInYAxis = props.chartEndingPointInYAxis;
    var yAxis = chartInformation.yAxis;
    var maxValue = yAxis[0] || 0;
    var ratio = (data / maxValue) * controlRatio;
    var controlArea = (chartStartingPointInYAxis - chartEndingPointInYAxis) * ratio;
    var pointCoordinateInYAxis = chartStartingPointInYAxis - controlArea;
    return { pointCoordinateInYAxis: pointCoordinateInYAxis, ratio: ratio };
}
var calculation = {
    getLargestTextWidth: getLargestTextWidth,
    getNecessaryInformation: getNecessaryInformation,
    getPointCoordinateInYAxis: getPointCoordinateInYAxis
};


//# sourceMappingURL=calculation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/helper/animation.js
'use client';

function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
}
function easeOutElastic(x) {
    var c4 = (2 * Math.PI) / 3;
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
}
function easeInOutCirc(x) {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
}
var animation = {
    easeInOutSine: easeInOutSine,
    easeOutElastic: easeOutElastic,
    easeInOutCirc: easeInOutCirc
};


//# sourceMappingURL=animation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/modules/tooltip.js
'use client';






var ALPHA = 0.05;
var VELOCITY = 7;
var OFFSET = 10;
/* Tooltip style */
var TITLE_MARGIN = 12;
var CONTENT_MARGIN = 10;
var CONTENT_GAP = 4;
function tooltip_Tooltip(props) {
    var tooltipData = props.tooltipData, config = props.config, ctx = props.ctx, mouse = props.mouse; props.canvasSize; var chartArea = props.chartArea, control = props.control;
    function draw() {
        var _a;
        /*
         * Getting config
         * */
        var _b = (((_a = config.default) === null || _a === void 0 ? void 0 : _a.font) || {}).family, fontFamily = _b === void 0 ? defaultFont.family : _b;
        var _c = config.tooltip || {}, title = _c.title, content = _c.content, padding = _c.padding, boxShadow = _c.boxShadow, borderRadius = _c.borderRadius, backgroundColor = _c.backgroundColor;
        var _d = (config.default || {}).listColors, listColors = _d === void 0 ? LIST_COLORS : _d;
        var tooltipPadding = padding || defaultTooltip.padding;
        var tooltipBorderRadius = borderRadius || defaultTooltip.borderRadius;
        var tooltipBackgroundColor = backgroundColor || defaultTooltip.backgroundColor;
        var _e = title || {}, _f = _e.size, titleSize = _f === void 0 ? defaultTooltip.title.size : _f, _g = _e.weight, titleWeight = _g === void 0 ? defaultTooltip.title.weight : _g, _h = _e.color, titleColor = _h === void 0 ? defaultTooltip.title.color : _h, titleDecoration = _e.decoration;
        var _j = content || {}, _k = _j.color, contentColor = _k === void 0 ? defaultTooltip.content.color : _k, _l = _j.weight, contentWeight = _l === void 0 ? defaultTooltip.content.weight : _l, _m = _j.size, contentSize = _m === void 0 ? defaultTooltip.content.size : _m, contentDecoration = _j.decoration;
        var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartEndingPointInXAxis = chartArea.chartEndingPointInXAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis;
        /*
         * Calculating tooltip size
         * */
        var name = tooltipData.name, data = tooltipData.data;
        /* Title */
        ctx.save();
        /*
         * Set default title font for calculating
         * */
        ctx.font = "".concat(titleWeight, " ").concat(titleSize, "px ").concat(fontFamily);
        var displayTitle = titleDecoration ? titleDecoration({ key: name, value: '' }) : name;
        var _o = ctx.measureText(displayTitle), titleBoundingBoxAscent = _o.actualBoundingBoxAscent, titleBoundingBoxDescent = _o.actualBoundingBoxDescent, titleWidth = _o.width;
        ctx.restore();
        var contentWidth = titleWidth;
        var totalHeight = tooltipPadding + titleBoundingBoxAscent + titleBoundingBoxDescent + TITLE_MARGIN;
        var titleHeight = titleBoundingBoxAscent + titleBoundingBoxDescent;
        /*
         * Set default content font for calculating
         * */
        ctx.save();
        ctx.font = "".concat(contentWeight, " ").concat(contentSize, "px ").concat(fontFamily);
        if (typeof data === 'object') {
            Object.keys(data).map(function (key, index) {
                var displayKey = contentDecoration ? contentDecoration({ key: key, value: data[key].toString() }) : key;
                var _a = ctx.measureText("".concat(displayKey).concat(data[key])), textWidth = _a.width, actualBoundingBoxAscent = _a.actualBoundingBoxAscent, actualBoundingBoxDescent = _a.actualBoundingBoxDescent;
                if (contentWidth < textWidth + CONTENT_GAP) {
                    contentWidth = textWidth + CONTENT_GAP;
                }
                if (index !== Object.keys(data).length - 1) {
                    totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + CONTENT_MARGIN;
                }
                else {
                    totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + tooltipPadding;
                }
            });
        }
        else {
            var decorationValue = contentDecoration
                ? contentDecoration({ key: '', value: String(data) })
                : String(data);
            var _p = ctx.measureText(decorationValue), actualBoundingBoxAscent = _p.actualBoundingBoxAscent, actualBoundingBoxDescent = _p.actualBoundingBoxDescent, textWidth = _p.width;
            if (contentWidth < textWidth) {
                contentWidth = textWidth;
            }
            totalHeight += actualBoundingBoxAscent + actualBoundingBoxDescent + tooltipPadding;
        }
        ctx.restore();
        var rectWidth = contentWidth + tooltipPadding * 2;
        var rectHeight = totalHeight;
        if (mouse) {
            /*
             * Collision detection
             * */
            if (mouse.x >= chartStartingPointInXAxis &&
                mouse.x <= chartEndingPointInXAxis &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                control.dx = mouse.x + OFFSET - control.xPos;
                control.dy = mouse.y - totalHeight - control.yPos;
                control.xPos += control.dx / VELOCITY;
                control.yPos += control.dy / VELOCITY;
                control.opacity += ALPHA;
                if (control.opacity >= 1) {
                    control.opacity = 1;
                }
            }
            else {
                control.opacity -= ALPHA * 2;
                if (control.opacity <= 0) {
                    control.opacity = 0;
                }
            }
        }
        else {
            control.opacity -= ALPHA * 2;
            if (control.opacity <= 0) {
                control.opacity = 0;
            }
        }
        var tooltipReachTheEndOfChartArea = control.xPos + contentWidth + tooltipPadding * 2;
        if (tooltipReachTheEndOfChartArea >= chartEndingPointInXAxis) {
            control.xPos = chartEndingPointInXAxis - (contentWidth + tooltipPadding * 2);
        }
        if (control.yPos <= chartEndingPointInYAxis) {
            control.yPos = chartEndingPointInYAxis;
        }
        ctx.beginPath();
        ctx.save();
        ctx.globalAlpha = animation.easeInOutSine(control.opacity);
        ctx.fillStyle = tooltipBackgroundColor;
        /*
         * Box shadow
         * */
        ctx.shadowOffsetX = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.offsetX) || defaultTooltip.boxShadow.offsetX;
        ctx.shadowOffsetY = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.offsetY) || defaultTooltip.boxShadow.offsetY;
        ctx.shadowBlur = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.blur) || defaultTooltip.boxShadow.blur;
        ctx.shadowColor = (boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.color) || defaultTooltip.boxShadow.color;
        /*
         * End box shadow
         * */
        /*
         * Drawing card
         * */
        drawing.roundRect(ctx, control.xPos, control.yPos, rectWidth, rectHeight, tooltipBorderRadius);
        ctx.fill();
        ctx.fillStyle = '#333';
        /*
         * Title
         * */
        var xStartingPosition = control.xPos + tooltipPadding;
        ctx.save();
        /*
         * Setting default font style for title
         * */
        ctx.font = "".concat(titleWeight, " ").concat(titleSize, "px ").concat(fontFamily);
        ctx.fillStyle = titleColor || '';
        /*
         * Fill title
         * */
        ctx.fillText(displayTitle, xStartingPosition, control.yPos + titleHeight + tooltipPadding);
        ctx.restore();
        /*
         * Content
         * */
        ctx.save();
        ctx.font = "".concat(contentWeight, " ").concat(contentSize, "px ").concat(fontFamily);
        ctx.fillStyle = contentColor || '';
        ctx.save();
        var contentStartPosition = control.yPos + titleHeight + tooltipPadding + TITLE_MARGIN;
        if (typeof data === 'object') {
            Object.keys(data).forEach(function (key, index) {
                var startPosition = xStartingPosition;
                var decorationValue = contentDecoration
                    ? contentDecoration({ key: key, value: data[key].toString() })
                    : key;
                var _a = ctx.measureText(data[key].toString()), width = _a.width, actualBoundingBoxAscent = _a.actualBoundingBoxAscent, actualBoundingBoxDescent = _a.actualBoundingBoxDescent;
                contentStartPosition += actualBoundingBoxAscent + actualBoundingBoxDescent;
                if (!(content === null || content === void 0 ? void 0 : content.decoration)) {
                    ctx.save();
                    ctx.fillStyle = listColors[index].foreground;
                    ctx.fillText(data[key].toString(), startPosition, contentStartPosition);
                    ctx.restore();
                    startPosition += width + CONTENT_GAP;
                }
                ctx.fillText(decorationValue, startPosition, contentStartPosition);
                contentStartPosition += CONTENT_MARGIN;
            });
        }
        else {
            var decorationValue = contentDecoration
                ? contentDecoration({ key: '', value: String(data) })
                : String(data);
            var _q = ctx.measureText(decorationValue), actualBoundingBoxAscent = _q.actualBoundingBoxAscent, actualBoundingBoxDescent = _q.actualBoundingBoxDescent;
            contentStartPosition += actualBoundingBoxAscent + actualBoundingBoxDescent;
            ctx.fillText(decorationValue, xStartingPosition, contentStartPosition);
        }
        ctx.restore();
        ctx.restore();
        ctx.restore();
        ctx.closePath();
    }
    return { draw: draw };
}


//# sourceMappingURL=tooltip.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/modules/axes.js
'use client';





var props;
var tooltipDetail = {
    data: {},
    name: ''
};
function setProps(value) {
    props = value;
}
function fillLabelsInYAxis() {
    var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, chartInformation = props.chartInformation, config = props.config;
    var _a = (config === null || config === void 0 ? void 0 : config.axes) || {}, _b = _a.horizontalCrossLine, horizontalCrossLine = _b === void 0 ? true : _b, decorationForVerticalLabel = _a.decorationForVerticalLabel;
    var chartArea = chartNecessaryInformation.chartArea, yRange = chartNecessaryInformation.yRange, yLabelTextMaxLength = chartNecessaryInformation.yLabelTextMaxLength;
    var yAxis = chartInformation.yAxis;
    var chartEndingPointInXAxis = chartArea.chartEndingPointInXAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
    /*
     * Get text height
     * */
    var _c = ctx.measureText(TEST_TEXT), actualBoundingBoxAscent = _c.actualBoundingBoxAscent, actualBoundingBoxDescent = _c.actualBoundingBoxDescent;
    var textHeight = actualBoundingBoxAscent + actualBoundingBoxDescent;
    /*
     * Draw label and cross line
     * */
    var yLabelPosition = textHeight;
    var crossLinePosition = chartEndingPointInYAxis;
    ctx.beginPath();
    yAxis.forEach(function (number) {
        var displayLabel = decorationForVerticalLabel ? decorationForVerticalLabel(number) : number.toString();
        ctx.save();
        /*
         * Because i use text-align: right, so that i have to fillText by text max length
         * in x position. If not do that, text will go outside of the viewport
         * */
        ctx.textAlign = 'right';
        ctx.fillText(displayLabel, yLabelTextMaxLength, yLabelPosition);
        if (horizontalCrossLine) {
            ctx.save();
            ctx.moveTo(chartStartingPointInXAxis, crossLinePosition);
            ctx.lineTo(chartEndingPointInXAxis, crossLinePosition);
            ctx.setLineDash([5, 3]);
            ctx.lineWidth = CROSS_LINE_WIDTH;
            ctx.strokeStyle = CROSS_LINE_COLOR;
            ctx.stroke();
            ctx.restore();
        }
        ctx.restore();
        yLabelPosition += yRange;
        crossLinePosition += yRange;
    });
    ctx.closePath();
}
function fillLabelsInXAxis() {
    var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, chartInformation = props.chartInformation, config = props.config;
    var _a = config.axes || {}, decorationForVerticalLabel = _a.decorationForVerticalLabel, _b = _a.hideXAxis, hideXAxis = _b === void 0 ? false : _b;
    /*
     * Hide x-axis if it not enable
     * */
    if (hideXAxis) {
        return;
    }
    var type = config.chart.type;
    var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange, xLabelTextMaxLength = chartNecessaryInformation.xLabelTextMaxLength;
    var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis;
    var xAxis = chartInformation.xAxis;
    var labelYPosition = chartStartingPointInYAxis + X_LABEL_HEIGHT;
    var labelXPosition = chartStartingPointInXAxis;
    /*
     * Check single data
     * */
    if (!SPECIFIC_CHART.includes(type)) {
        labelXPosition += xRange / 2;
    }
    var xLabelSkipValue = Math.floor(xLabelTextMaxLength / xRange);
    var skipValue = 0;
    xAxis.forEach(function (item) {
        if (skipValue > 0) {
            skipValue -= 1;
            labelXPosition += xRange;
            return;
        }
        var displayLabel = decorationForVerticalLabel ? decorationForVerticalLabel(item) : item;
        var lineArray = drawing.wrapText(ctx, displayLabel.toString(), labelXPosition, labelYPosition, xRange, LINE_HEIGHT).lineArray;
        /*
         * Hidden text when x-range less than xLabelAdjacentSideWidth after rotate
         * */
        if (skipValue === 0) {
            lineArray.forEach(function (item) {
                ctx.save();
                ctx.textAlign = 'center';
                ctx.fillText(item[0].toString(), item[1], item[2]);
                ctx.restore();
            });
            labelXPosition += xRange;
            skipValue = xLabelSkipValue;
        }
    });
}
function hover() {
    /*
     * Get props and config
     * */
    var mouse = props.mouse, chartInformation = props.chartInformation, ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, config = props.config;
    var type = config.chart.type;
    var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
    var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
    var data = chartInformation.data, xAxis = chartInformation.xAxis;
    /*
     * End get props and config
     * */
    var startingPosition = chartStartingPointInXAxis;
    xAxis.map(function (xItem, index) {
        var pointTo = xRange;
        if (SPECIFIC_CHART.includes(type)) {
            if (index === 0 || index === xAxis.length - 1) {
                pointTo = xRange / 2;
            }
        }
        if (mouse) {
            if (mouse.x >= startingPosition &&
                mouse.x <= startingPosition + pointTo &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                /*
                 * Getting tooltip data
                 * */
                Object.assign(tooltipDetail, {
                    name: xItem,
                    data: data[xItem]
                });
                /*
                 * Draw the hover background
                 * */
                if (!SPECIFIC_CHART.includes(type)) {
                    ctx.beginPath();
                    ctx.save();
                    ctx.fillStyle = HOVER_COLOR;
                    ctx.fillRect(startingPosition, chartEndingPointInYAxis, pointTo, chartStartingPointInYAxis - chartEndingPointInYAxis);
                    ctx.restore();
                    ctx.closePath();
                }
            }
        }
        startingPosition += pointTo;
    });
}
function draw() {
    hover();
    fillLabelsInYAxis();
    fillLabelsInXAxis();
    return tooltipDetail;
}
var axes = {
    setProps: setProps,
    draw: draw
};


//# sourceMappingURL=axes.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/charts/line.js
'use client';







function LineChart(props) {
    var control = props.control, config = props.config;
    var _a = config.chart.smooth, smooth = _a === void 0 ? true : _a;
    var _b = (config.default || {}).listColors, listColors = _b === void 0 ? LIST_COLORS : _b;
    function calculatingPoints(props) {
        var chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var dataBySeries = chartInformation.dataBySeries, series = chartInformation.series;
        var pointCoordinates = {};
        series.map(function (item, index) {
            var _a;
            var points = [];
            var xPoint = chartStartingPointInXAxis;
            dataBySeries[item].forEach(function (data) {
                var yPoint = calculation.getPointCoordinateInYAxis({
                    chartInformation: chartInformation,
                    chartStartingPointInYAxis: chartStartingPointInYAxis,
                    chartEndingPointInYAxis: chartEndingPointInYAxis,
                    data: data
                }, animation.easeInOutSine(control.controlRatio)).pointCoordinateInYAxis;
                points.push([xPoint, yPoint]);
                xPoint += xRange;
            });
            Object.assign(pointCoordinates, (_a = {},
                _a[item] = {
                    points: points,
                    color: listColors[index]
                },
                _a));
        });
        return pointCoordinates;
    }
    function point(dataPoints) {
        var ctx = props.ctx;
        var points = dataPoints.points, color = dataPoints.color;
        for (var i = 0; i < points.length; i++) {
            ctx.beginPath();
            ctx.arc(points[i][0], points[i][1], 3, 0, 2 * Math.PI);
            ctx.fillStyle = color.background;
            ctx.strokeStyle = color.foreground;
            ctx.lineWidth = 1;
            ctx.fill();
            ctx.stroke();
        }
    }
    function chartLine(dataPoints) {
        var ctx = props.ctx;
        var points = dataPoints.points, color = dataPoints.color;
        var listBezierPoints = canvasHelper.computePoints(points);
        ctx.beginPath();
        ctx.save();
        listBezierPoints.forEach(function (point) {
            if (point.length < 6) {
                ctx.moveTo(point[0], point[1]);
                return;
            }
            if (smooth) {
                ctx.bezierCurveTo(point[0], point[1], point[2], point[3], point[4], point[5]);
                return;
            }
            ctx.lineTo(point[4], point[5]);
        });
        /*
         * Line style configuration
         * */
        ctx.lineWidth = CHART_LINE_WIDTH;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = color.foreground;
        ctx.stroke();
        ctx.restore();
        ctx.closePath();
    }
    function drawVerticalLine(dataPoints) {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation, mouse = props.mouse;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var xAxis = chartInformation.xAxis, series = chartInformation.series;
        /* Do nothing when mouse is null */
        if (!mouse)
            return;
        var startingPoint = chartStartingPointInXAxis;
        xAxis.forEach(function (_, index) {
            var pointTo = xRange;
            if (index === 0 || index === xAxis.length - 1) {
                pointTo = xRange / 2;
            }
            /*
             * Collision detection
             * */
            if (mouse.x >= startingPoint &&
                mouse.x <= startingPoint + pointTo &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                /*
                 * Draw points and vertical line
                 * */
                series.map(function (item) {
                    var _a = dataPoints[item], points = _a.points, color = _a.color;
                    var x = points[index][0];
                    var y = points[index][1];
                    ctx.beginPath();
                    ctx.save();
                    ctx.moveTo(x, chartEndingPointInYAxis);
                    ctx.lineTo(x, chartStartingPointInYAxis);
                    ctx.setLineDash([5, 3]);
                    ctx.strokeStyle = CROSS_LINE_COLOR;
                    ctx.lineWidth = CROSS_LINE_WIDTH;
                    ctx.stroke();
                    ctx.restore();
                    ctx.closePath();
                    ctx.beginPath();
                    ctx.arc(x || 0, y || 0, 4, 0, 2 * Math.PI);
                    ctx.lineWidth = 2;
                    ctx.fillStyle = color.background;
                    ctx.strokeStyle = color.foreground;
                    ctx.fill();
                    ctx.stroke();
                    ctx.closePath();
                });
            }
            startingPoint += pointTo;
        });
    }
    function draw() {
        var chartInformation = props.chartInformation;
        var series = chartInformation.series;
        var dataPoints = calculatingPoints(props);
        series.forEach(function (item) {
            chartLine(dataPoints[item]);
            point(dataPoints[item]);
        });
        drawVerticalLine(dataPoints);
        control.controlRatio += CHART_DECREASE_RATIO;
        if (control.controlRatio >= 1) {
            control.controlRatio = 1;
        }
    }
    return {
        draw: draw
    };
}


//# sourceMappingURL=line.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/charts/lollipop.js
'use client';







/*
 * Constant
 * */
var STICK_WIDTH = 10;
var BORDER_RADIUS = 8;
var MAX_RADIUS = 30;
var GAP = 2.5;
function LollipopChart(props) {
    var _a, _b, _c;
    var config = props.config, control = props.control;
    var fontFamily = ((_b = (_a = config.default) === null || _a === void 0 ? void 0 : _a.font) === null || _b === void 0 ? void 0 : _b.family) || defaultFont.family;
    var listColors = ((_c = config.default) === null || _c === void 0 ? void 0 : _c.listColors) || LIST_COLORS;
    var decorationValue = config.chart.decorationValue;
    function candy(data, displayValue, startingPosition, valueMaxLength, color) {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
        var _a = calculation.getPointCoordinateInYAxis({
            chartInformation: chartInformation,
            chartStartingPointInYAxis: chartStartingPointInYAxis,
            chartEndingPointInYAxis: chartEndingPointInYAxis,
            data: data
        }, animation.easeInOutSine(control.controlRatio)), pointCoordinateInYAxis = _a.pointCoordinateInYAxis, ratio = _a.ratio;
        var maxRadius = MAX_RADIUS; // Circle radius
        var yPosition = pointCoordinateInYAxis;
        /*
         * Circle radius handler
         * */
        if (valueMaxLength / 2 + GAP > maxRadius) {
            maxRadius = valueMaxLength / 2 + GAP;
        }
        if (xRange / 3 < maxRadius) {
            maxRadius = xRange / 3;
        }
        /*
         * Text handler
         * */
        ctx.font = "700 11px ".concat(fontFamily);
        var _b = ctx.measureText(displayValue), textWidth = _b.width, actualBoundingBoxAscent = _b.actualBoundingBoxAscent, actualBoundingBoxDescent = _b.actualBoundingBoxDescent;
        var textHeight = actualBoundingBoxAscent + actualBoundingBoxDescent;
        /*
         * Calculate growth value, this will control, radius of circle base on data
         * */
        var calcTextWidth = textWidth / 2 + GAP;
        if (xRange / 4 < valueMaxLength) {
            calcTextWidth = STICK_WIDTH / 2;
        }
        var growthValue = (maxRadius - calcTextWidth) * ratio * control.controlRatio;
        if (growthValue <= 0) {
            growthValue = 0;
        }
        var radius = calcTextWidth + growthValue;
        /*
         * Calculating y-position
         * */
        if (yPosition + radius > chartStartingPointInYAxis) {
            yPosition = chartStartingPointInYAxis - radius;
        }
        if (yPosition - maxRadius < chartEndingPointInYAxis) {
            yPosition = chartEndingPointInYAxis + radius;
        }
        ctx.beginPath();
        ctx.arc(startingPosition, yPosition, radius, 0, 2 * Math.PI);
        ctx.fillStyle = color.foreground;
        ctx.fill();
        if (xRange / 4 > valueMaxLength) {
            ctx.save();
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.fillText(displayValue, startingPosition, yPosition + textHeight / 2);
            ctx.restore();
        }
        ctx.closePath();
    }
    function stick(x, color) {
        var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
        ctx.beginPath();
        drawing.roundRect(ctx, x, chartEndingPointInYAxis, STICK_WIDTH, chartStartingPointInYAxis - chartEndingPointInYAxis, BORDER_RADIUS);
        ctx.fillStyle = color.background;
        ctx.fill();
    }
    function draw() {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var xRange = chartNecessaryInformation.xRange, chartArea = chartNecessaryInformation.chartArea;
        var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var data = chartInformation.data, xAxis = chartInformation.xAxis;
        /*
         * Find max length of value in data
         * */
        var valueMaxLength = 0;
        Object.keys(data).forEach(function (key) {
            var width = ctx.measureText(data[key]).width;
            if (valueMaxLength < width) {
                valueMaxLength = width;
            }
        });
        var startingPosition = chartStartingPointInXAxis + xRange / 2;
        xAxis.map(function (label, index) {
            var displayValue = decorationValue ? decorationValue(data[label]) : data[label].toString();
            stick(startingPosition - STICK_WIDTH / 2, LIST_COLORS[index]);
            candy(data[label], displayValue, startingPosition, valueMaxLength, listColors[index]);
            startingPosition += xRange;
        });
        control.controlRatio += CHART_DECREASE_RATIO;
        if (control.controlRatio >= 1) {
            control.controlRatio = 1;
        }
    }
    return {
        draw: draw
    };
}


//# sourceMappingURL=lollipop.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/init.js
'use client';












var Init = function (canvas, container, config) {
    var mouse;
    var reqId;
    var width, height;
    var chartInformation;
    var chartNecessaryInformation;
    var resizeObserver;
    var _a = config.chart, type = _a.type, autoResize = _a.autoResize;
    var _b = config.default || {}, defaultWidth = _b.width, defaultHeight = _b.height;
    function resetSize(cvWidth, cvHeight) {
        width = cvWidth;
        height = cvHeight;
    }
    function windowResetSize() {
        var width = defaultWidth || container.offsetWidth;
        var height = defaultHeight || container.offsetHeight;
        resetSize(width, height);
    }
    function animate(params) {
        var _a;
        var resizedCanvas = canvasHelper.createHiPPICanvas(canvas, width, height);
        var _b = ((_a = config.default) === null || _a === void 0 ? void 0 : _a.font) || {}, _c = _b.size, size = _c === void 0 ? defaultFont.size : _c, _d = _b.color, color = _d === void 0 ? defaultFont.color : _d, _e = _b.family, family = _e === void 0 ? defaultFont.family : _e, _f = _b.weight, weight = _f === void 0 ? defaultFont.weight : _f;
        var ctx = resizedCanvas.getContext('2d');
        if (ctx) {
            chartNecessaryInformation = calculation.getNecessaryInformation(ctx, chartInformation, width, height, config);
            ctx.clearRect(0, 0, width, height);
            /*
             * Set default font style
             * */
            ctx.fillStyle = color;
            ctx.font = "".concat(weight, " ").concat(size, "px ").concat(family);
            /*
             * End set default font style
             * */
            axes.setProps({
                ctx: ctx,
                chartInformation: chartInformation,
                chartNecessaryInformation: chartNecessaryInformation,
                config: config,
                mouse: mouse
            });
            var tooltipData = axes.draw();
            /*
             * Chart will go here
             * */
            switch (type) {
                case 'line':
                    {
                        LineChart({
                            ctx: ctx,
                            chartNecessaryInformation: chartNecessaryInformation,
                            chartInformation: chartInformation,
                            config: config,
                            mouse: mouse,
                            control: params.chart
                        }).draw();
                    }
                    break;
                case 'lollipop': {
                    LollipopChart({
                        ctx: ctx,
                        chartNecessaryInformation: chartNecessaryInformation,
                        chartInformation: chartInformation,
                        config: config,
                        control: params.chart
                    }).draw();
                }
            }
            /*
             * Tooltip is on top of all object, so that it alway been called at the end
             * of function
             * */
            tooltip_Tooltip({
                config: config,
                chartArea: chartNecessaryInformation.chartArea,
                mouse: mouse,
                ctx: ctx,
                canvasSize: { width: width, height: height },
                tooltipData: tooltipData,
                control: params.tooltip
            }).draw();
        }
        reqId = requestAnimationFrame(animate.bind(null, params));
    }
    function handleMouseMove(e) {
        var canvas = e.target;
        var _a = canvas.getBoundingClientRect(), top = _a.top, left = _a.left;
        mouse = {
            x: e.clientX - left,
            y: e.clientY - top
        };
    }
    function handleMouseLeave() {
        mouse = null;
    }
    function run() {
        var getDefaultWidth = defaultWidth || container.offsetWidth;
        var getDefaultHeight = defaultHeight || container.offsetHeight;
        resetSize(getDefaultWidth, getDefaultHeight);
        chartInformation = data.getDataRangeInAxes(config.chart);
        animate({
            tooltip: {
                opacity: 0,
                yPos: 0,
                xPos: 0,
                dy: 0,
                dx: 0
            },
            chart: {
                controlRatio: 0
            }
        });
        canvas.addEventListener('mousemove', handleMouseMove);
        canvas.addEventListener('mouseleave', handleMouseLeave);
        if (autoResize) {
            resizeObserver = new ResizeObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    if (entry.borderBoxSize) {
                        var contentBoxSize = entry.contentBoxSize[0];
                        var getWidth = defaultWidth || contentBoxSize.inlineSize;
                        var getHeight = defaultHeight || contentBoxSize.blockSize;
                        resetSize(getWidth, getHeight);
                    }
                }
            });
            resizeObserver.observe(container);
        }
        else {
            window.addEventListener('resize', windowResetSize);
        }
    }
    function destroy() {
        if (autoResize && resizeObserver) {
            resizeObserver.disconnect();
        }
        else {
            window.removeEventListener('resize', windowResetSize);
        }
        canvas.removeEventListener('mousemove', handleMouseMove);
        canvas.removeEventListener('mouseleave', handleMouseLeave);
        cancelAnimationFrame(reqId);
    }
    return {
        run: run,
        destroy: destroy
    };
};


//# sourceMappingURL=init.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/Chart.css.js
'use client';




var Chart_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Chart_css_templateObject_1 || (Chart_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Chart_css_templateObject_1;


//# sourceMappingURL=Chart.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/icons/CurveLine.js
'use client';



var CurveLine = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, className = _a.className;
    return (react.createElement("svg", { className: className, width: 18, height: 6, viewBox: '0 0 18 6', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M1.3 3.992v0C2.363 1.393 5.634.56 7.81 2.334l1.077.877a4.946 4.946 0 0 0 2.168 1.019v0A4.944 4.944 0 0 0 15.8 2.555l.648-.773', stroke: color, strokeWidth: 2, strokeLinecap: 'round' })));
};
var CurveLine$1 = (0,react.memo)(CurveLine);


//# sourceMappingURL=CurveLine.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/icons/Circle.js
'use client';



var Circle = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, className = _a.className;
    return (react.createElement("svg", { className: className, width: 10, height: 11, viewBox: '0 0 10 11', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("rect", { y: '.5', width: 10, height: 10, rx: 5, fill: color })));
};
var Circle$1 = (0,react.memo)(Circle);


//# sourceMappingURL=Circle.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/core/modules/legend.rc.js
'use client';









var List = styled_components_browser_esm/* default.ul */.ZP.ul(legend_rc_templateObject_1 || (legend_rc_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: ", ";\n    justify-content: ", ";\n    margin-top: 8px;\n    flex-wrap: wrap;\n    flex-direction: ", ";\n"], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: ", ";\n    justify-content: ", ";\n    margin-top: 8px;\n    flex-wrap: wrap;\n    flex-direction: ", ";\n"])), function (_a) {
    var align = _a.align;
    return align;
}, function (_a) {
    var justify = _a.justify;
    return justify;
}, function (_a) {
    var direction = _a.direction;
    return direction;
});
var Item = styled_components_browser_esm/* default.li */.ZP.li(legend_rc_templateObject_2 || (legend_rc_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 4px;\n    font-size: 12px;\n    font-weight: ", ";\n    margin-bottom: 4px;\n    color: ", ";\n    user-select: none;\n    & > .icon {\n        margin-right: 8px;\n    }\n    &:not(:last-of-type) {\n        margin-right: 24px;\n    }\n"], ["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 4px;\n    font-size: 12px;\n    font-weight: ", ";\n    margin-bottom: 4px;\n    color: ", ";\n    user-select: none;\n    & > .icon {\n        margin-right: 8px;\n    }\n    &:not(:last-of-type) {\n        margin-right: 24px;\n    }\n"])), function (_a) {
    var weight = _a.weight;
    return weight;
}, function (_a) {
    var color = _a.color;
    return color;
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(legend_rc_templateObject_3 || (legend_rc_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: ", ";\n    padding: ", ";\n"], ["\n    display: flex;\n    align-items: ", ";\n    padding: ", ";\n"])), function (_a) {
    var iconAlign = _a.iconAlign;
    return iconAlign;
}, function (_a) {
    var padding = _a.padding;
    return padding;
});
var Legend = function (_a) {
    var config = _a.config;
    var _b = config.chart, data = _b.data, series = _b.series, xField = _b.xField, legend = _b.legend;
    var _c = (config.default || {}).listColors, listColors = _c === void 0 ? LIST_COLORS : _c;
    var _d = legend || {}, line = _d.line, text = _d.text, _e = _d.align, align = _e === void 0 ? 'center' : _e, _f = _d.justify, justify = _f === void 0 ? 'center' : _f, _g = _d.direction, direction = _g === void 0 ? 'row' : _g, icons = _d.icons, decorationValue = _d.decorationValue;
    var _h = icons || {}, _j = _h.align, iconAlign = _j === void 0 ? 'center' : _j, _k = _h.padding, padding = _k === void 0 ? '' : _k;
    var _l = text || {}, _m = _l.color, color = _m === void 0 ? constants/* colors.textColor */.O9.textColor : _m, _o = _l.weight, weight = _o === void 0 ? 700 : _o;
    var legendData = (0,react.useMemo)(function () {
        var result = [];
        data.forEach(function (item) {
            if (series) {
                if (!result.includes(item[series])) {
                    result.push(item[series]);
                    return;
                }
                return;
            }
            if (!result.includes(item[xField])) {
                result.push(item[xField]);
            }
        });
        return result;
    }, [series, xField, data]);
    return (react.createElement(List, { align: align, direction: direction, justify: justify }, legendData.map(function (item, index) {
        return (react.createElement(Item, { key: "".concat(item, "-").concat(index), color: color, weight: weight },
            react.createElement(IconWrapper, { iconAlign: iconAlign, padding: padding }, line ? (react.createElement(CurveLine$1, { className: 'icon', color: listColors[index].foreground })) : (react.createElement(Circle$1, { className: 'icon', color: listColors[index].foreground }))),
            decorationValue ? decorationValue(data[index]) : item));
    })));
};
var legend_rc_templateObject_1, legend_rc_templateObject_2, legend_rc_templateObject_3;


//# sourceMappingURL=legend.rc.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chart/index.js
'use client';







var Chart = function (_a) {
    var config = _a.config;
    var canvasRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var _b = (config.chart.legend || {}).enable, enable = _b === void 0 ? true : _b;
    (0,react.useEffect)(function () {
        if (canvasRef && canvasRef.current && containerRef && containerRef.current) {
            var container = containerRef.current;
            var canvas = canvasRef.current;
            var init_1 = Init(canvas, container, config);
            document.fonts.ready.then(function () { return init_1.run(); });
            return function () {
                init_1.destroy();
            };
        }
        else {
            return function () { };
        }
    }, [config]);
    return (react.createElement(Chart_css_Container, { className: 'vnw-chart-container', ref: containerRef },
        react.createElement("canvas", { id: 'vnw-chart', ref: canvasRef }),
        enable ? react.createElement(Legend, { config: config }) : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Chip.css.js
'use client';




var ChipWrapper = styled_components_browser_esm/* default.div */.ZP.div(Chip_css_templateObject_2 || (Chip_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: ", ";\n    color: ", ";\n    padding: 2px 8px;\n    font-weight: 500;\n    line-height: 20px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    ", ";\n"], ["\n    background-color: ", ";\n    color: ", ";\n    padding: 2px 8px;\n    font-weight: 500;\n    line-height: 20px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var isHaveIcon = _a.isHaveIcon;
    if (!isHaveIcon) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(Chip_css_templateObject_1 || (Chip_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            svg {\n                margin-right: 4px;\n            }\n        "], ["\n            svg {\n                margin-right: 4px;\n            }\n        "])));
});
var Chip_css_templateObject_1, Chip_css_templateObject_2;


//# sourceMappingURL=Chip.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/CheckIcon/index.js
'use client';



var CheckIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M12.5902 2.79537C12.469 2.79898 12.3539 2.84965 12.2694 2.93664L5.13267 10.0734L2.19595 7.13665C2.15295 7.09186 2.10145 7.0561 2.04445 7.03147C1.98746 7.00683 1.92613 6.99382 1.86404 6.99319C1.80195 6.99256 1.74037 7.00432 1.68288 7.02779C1.6254 7.05126 1.57318 7.08596 1.52928 7.12986C1.48537 7.17377 1.45067 7.22599 1.4272 7.28347C1.40373 7.34095 1.39197 7.40254 1.3926 7.46463C1.39323 7.52671 1.40625 7.58805 1.43088 7.64504C1.45551 7.70203 1.49127 7.75354 1.53606 7.79654L4.80272 11.0632C4.89025 11.1507 5.00893 11.1998 5.13267 11.1998C5.25642 11.1998 5.3751 11.1507 5.46262 11.0632L12.9293 3.59654C12.9967 3.53099 13.0428 3.4466 13.0614 3.35442C13.0801 3.26225 13.0704 3.16659 13.0338 3.07998C12.9971 2.99337 12.9352 2.91986 12.856 2.86907C12.7769 2.81829 12.6842 2.7926 12.5902 2.79537Z', fill: '#6FB920' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M12.5902 2.79537C12.469 2.79898 12.3539 2.84965 12.2694 2.93664L5.13267 10.0734L2.19595 7.13665C2.15295 7.09186 2.10145 7.0561 2.04445 7.03147C1.98746 7.00683 1.92613 6.99382 1.86404 6.99319C1.80195 6.99256 1.74037 7.00432 1.68288 7.02779C1.6254 7.05126 1.57318 7.08596 1.52928 7.12986C1.48537 7.17377 1.45067 7.22599 1.4272 7.28347C1.40373 7.34095 1.39197 7.40254 1.3926 7.46463C1.39323 7.52671 1.40625 7.58805 1.43088 7.64504C1.45551 7.70203 1.49127 7.75354 1.53606 7.79654L4.80272 11.0632C4.89025 11.1507 5.00893 11.1998 5.13267 11.1998C5.25642 11.1998 5.3751 11.1507 5.46262 11.0632L12.9293 3.59654C12.9967 3.53099 13.0428 3.4466 13.0614 3.35442C13.0801 3.26225 13.0704 3.16659 13.0338 3.07998C12.9971 2.99337 12.9352 2.91986 12.856 2.86907C12.7769 2.81829 12.6842 2.7926 12.5902 2.79537Z', fill: 'white' })));
};
var CheckIcon$1 = react.memo(CheckIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/WarningIcon/index.js
'use client';



var WarningIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M7.00026 1.3999C6.6122 1.3999 6.27976 1.63637 6.13893 1.97321L1.07396 10.7086V10.7095C0.982548 10.8568 0.933945 11.0266 0.933594 11.1999C0.933594 11.4474 1.03193 11.6848 1.20696 11.8599C1.38199 12.0349 1.61939 12.1332 1.86693 12.1332C1.88883 12.1331 1.91072 12.1322 1.93255 12.1305L1.93438 12.1332H7.00026H12.0661L12.068 12.1296C12.0898 12.1316 12.1117 12.1328 12.1336 12.1332C12.3811 12.1332 12.6185 12.0349 12.7936 11.8599C12.9686 11.6848 13.0669 11.4474 13.0669 11.1999C13.0667 11.0263 13.0181 10.8561 12.9266 10.7086L12.9193 10.6959C12.919 10.6956 12.9187 10.6953 12.9184 10.695L7.86159 1.97321C7.72076 1.63637 7.38833 1.3999 7.00026 1.3999ZM6.43424 5.30094H7.56628L7.4724 8.32152H6.52812L6.43424 5.30094ZM7.00208 9.24482C7.38568 9.24482 7.61549 9.45122 7.61549 9.80355C7.61549 10.1493 7.38568 10.355 7.00208 10.355C6.61568 10.355 6.38412 10.1493 6.38412 9.80355C6.38412 9.45122 6.61522 9.24482 7.00208 9.24482Z', fill: '#FF7D55' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7.00026 1.3999C6.6122 1.3999 6.27976 1.63637 6.13893 1.97321L1.07396 10.7086V10.7095C0.982548 10.8568 0.933945 11.0266 0.933594 11.1999C0.933594 11.4474 1.03193 11.6848 1.20696 11.8599C1.38199 12.0349 1.61939 12.1332 1.86693 12.1332C1.88883 12.1331 1.91072 12.1322 1.93255 12.1305L1.93438 12.1332H7.00026H12.0661L12.068 12.1296C12.0898 12.1316 12.1117 12.1328 12.1336 12.1332C12.3811 12.1332 12.6185 12.0349 12.7936 11.8599C12.9686 11.6848 13.0669 11.4474 13.0669 11.1999C13.0667 11.0263 13.0181 10.8561 12.9266 10.7086L12.9193 10.6959C12.919 10.6956 12.9187 10.6953 12.9184 10.695L7.86159 1.97321C7.72076 1.63637 7.38833 1.3999 7.00026 1.3999ZM6.43424 5.30094H7.56628L7.4724 8.32152H6.52812L6.43424 5.30094ZM7.00208 9.24482C7.38568 9.24482 7.61549 9.45122 7.61549 9.80355C7.61549 10.1493 7.38568 10.355 7.00208 10.355C6.61568 10.355 6.38412 10.1493 6.38412 9.80355C6.38412 9.45122 6.61522 9.24482 7.00208 9.24482Z', fill: 'white' })));
};
var WarningIcon$1 = react.memo(WarningIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/AttachIcon/index.js
'use client';



var AttachIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M9.00836 1.16675C8.32081 1.16675 7.63394 1.43914 7.11891 1.9825L3.38193 5.92456C1.98467 7.39906 1.98467 9.76933 3.38193 11.2438C3.42501 11.2892 3.47677 11.3255 3.53414 11.3505C3.53505 11.3508 3.53597 11.3511 3.53688 11.3514C4.94464 12.6854 7.14054 12.6705 8.49248 11.2438L11.1211 8.47026C11.1656 8.42627 11.2008 8.37378 11.2246 8.31591C11.2484 8.25804 11.2604 8.19598 11.2597 8.13341C11.259 8.07084 11.2458 8.00904 11.2208 7.95169C11.1957 7.89434 11.1594 7.84261 11.114 7.79957C11.0686 7.75653 11.015 7.72306 10.9564 7.70116C10.8977 7.67926 10.8353 7.66937 10.7728 7.67208C10.7103 7.67479 10.649 7.69004 10.5925 7.71693C10.536 7.74382 10.4854 7.78179 10.4439 7.8286L7.81526 10.6022C6.76443 11.7111 5.11088 11.7111 4.06006 10.6022C3.00918 9.4932 3.00918 7.67519 4.06006 6.56623L7.79612 2.62417C8.47966 1.90303 9.53798 1.90303 10.2215 2.62417C10.905 3.34523 10.905 4.5354 10.2215 5.25646L6.82086 8.84487C6.50404 9.17889 6.04157 9.17865 5.72529 8.84487C5.409 8.5111 5.409 7.94909 5.72529 7.61532L8.46058 4.72873C8.50507 4.68474 8.54027 4.63225 8.56408 4.57438C8.58788 4.51651 8.59981 4.45444 8.59915 4.39187C8.59848 4.3293 8.58525 4.26751 8.56022 4.21015C8.53519 4.1528 8.49889 4.10107 8.45347 4.05803C8.40804 4.01499 8.35443 3.98153 8.29581 3.95963C8.2372 3.93773 8.17478 3.92784 8.11226 3.93055C8.04975 3.93325 7.98841 3.9485 7.93191 3.97539C7.87541 4.00228 7.82489 4.04026 7.78336 4.08706L5.04716 6.97365C4.38439 7.67307 4.38439 8.78712 5.04716 9.48654C5.0914 9.53309 5.14477 9.57002 5.20394 9.595C5.87623 10.1566 6.88054 10.1376 7.49808 9.48654L10.8987 5.89813C11.8864 4.85616 11.9006 3.22551 10.9944 2.13381C10.9726 2.07767 10.9401 2.02629 10.8987 1.9825C10.3837 1.43914 9.69591 1.16675 9.00836 1.16675Z', fill: '#888888' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M9.00836 1.16675C8.32081 1.16675 7.63394 1.43914 7.11891 1.9825L3.38193 5.92456C1.98467 7.39906 1.98467 9.76933 3.38193 11.2438C3.42501 11.2892 3.47677 11.3255 3.53414 11.3505C3.53505 11.3508 3.53597 11.3511 3.53688 11.3514C4.94464 12.6854 7.14054 12.6705 8.49248 11.2438L11.1211 8.47026C11.1656 8.42627 11.2008 8.37378 11.2246 8.31591C11.2484 8.25804 11.2604 8.19598 11.2597 8.13341C11.259 8.07084 11.2458 8.00904 11.2208 7.95169C11.1957 7.89434 11.1594 7.84261 11.114 7.79957C11.0686 7.75653 11.015 7.72306 10.9564 7.70116C10.8977 7.67926 10.8353 7.66937 10.7728 7.67208C10.7103 7.67479 10.649 7.69004 10.5925 7.71693C10.536 7.74382 10.4854 7.78179 10.4439 7.8286L7.81526 10.6022C6.76443 11.7111 5.11088 11.7111 4.06006 10.6022C3.00918 9.4932 3.00918 7.67519 4.06006 6.56623L7.79612 2.62417C8.47966 1.90303 9.53798 1.90303 10.2215 2.62417C10.905 3.34523 10.905 4.5354 10.2215 5.25646L6.82086 8.84487C6.50404 9.17889 6.04157 9.17865 5.72529 8.84487C5.409 8.5111 5.409 7.94909 5.72529 7.61532L8.46058 4.72873C8.50507 4.68474 8.54027 4.63225 8.56408 4.57438C8.58788 4.51651 8.59981 4.45444 8.59915 4.39187C8.59848 4.3293 8.58525 4.26751 8.56022 4.21015C8.53519 4.1528 8.49889 4.10107 8.45347 4.05803C8.40804 4.01499 8.35443 3.98153 8.29581 3.95963C8.2372 3.93773 8.17478 3.92784 8.11226 3.93055C8.04975 3.93325 7.98841 3.9485 7.93191 3.97539C7.87541 4.00228 7.82489 4.04026 7.78336 4.08706L5.04716 6.97365C4.38439 7.67307 4.38439 8.78712 5.04716 9.48654C5.0914 9.53309 5.14477 9.57002 5.20394 9.595C5.87623 10.1566 6.88054 10.1376 7.49808 9.48654L10.8987 5.89813C11.8864 4.85616 11.9006 3.22551 10.9944 2.13381C10.9726 2.07767 10.9401 2.02629 10.8987 1.9825C10.3837 1.43914 9.69591 1.16675 9.00836 1.16675Z', fill: 'white' })));
};
var AttachIcon$1 = react.memo(AttachIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/QuestionMarkIcon/index.js
'use client';



var QuestionMarkIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M7.00039 1.3999C3.90779 1.3999 1.40039 3.9073 1.40039 6.9999C1.40039 10.0925 3.90779 12.5999 7.00039 12.5999C10.093 12.5999 12.6004 10.0925 12.6004 6.9999C12.6004 3.9073 10.093 1.3999 7.00039 1.3999ZM7.00039 10.4999C6.61399 10.4999 6.30039 10.1863 6.30039 9.7999C6.30039 9.4135 6.61399 9.0999 7.00039 9.0999C7.38679 9.0999 7.70039 9.4135 7.70039 9.7999C7.70039 10.1863 7.38679 10.4999 7.00039 10.4999ZM7.96546 7.23324C7.65652 7.51837 7.46706 7.7055 7.46706 7.93324H6.53372C6.53372 7.28504 6.97659 6.87624 7.33219 6.54724C7.70506 6.20284 7.93372 5.97277 7.93372 5.5999C7.93372 5.08517 7.51512 4.66657 7.00039 4.66657C6.48566 4.66657 6.06706 5.08517 6.06706 5.5999H5.13372C5.13372 4.57044 5.97092 3.73324 7.00039 3.73324C8.02986 3.73324 8.86706 4.57044 8.86706 5.5999C8.86706 6.40024 8.36726 6.86177 7.96546 7.23324Z', fill: '#48BBFF' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7.00039 1.3999C3.90779 1.3999 1.40039 3.9073 1.40039 6.9999C1.40039 10.0925 3.90779 12.5999 7.00039 12.5999C10.093 12.5999 12.6004 10.0925 12.6004 6.9999C12.6004 3.9073 10.093 1.3999 7.00039 1.3999ZM7.00039 10.4999C6.61399 10.4999 6.30039 10.1863 6.30039 9.7999C6.30039 9.4135 6.61399 9.0999 7.00039 9.0999C7.38679 9.0999 7.70039 9.4135 7.70039 9.7999C7.70039 10.1863 7.38679 10.4999 7.00039 10.4999ZM7.96546 7.23324C7.65652 7.51837 7.46706 7.7055 7.46706 7.93324H6.53372C6.53372 7.28504 6.97659 6.87624 7.33219 6.54724C7.70506 6.20284 7.93372 5.97277 7.93372 5.5999C7.93372 5.08517 7.51512 4.66657 7.00039 4.66657C6.48566 4.66657 6.06706 5.08517 6.06706 5.5999H5.13372C5.13372 4.57044 5.97092 3.73324 7.00039 3.73324C8.02986 3.73324 8.86706 4.57044 8.86706 5.5999C8.86706 6.40024 8.36726 6.86177 7.96546 7.23324Z', fill: 'white' })));
};
var QuestionMarkIcon$1 = react.memo(QuestionMarkIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/DangerIcon/index.js
'use client';



var DangerIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M7.00039 1.3999C3.90779 1.3999 1.40039 3.9073 1.40039 6.9999C1.40039 10.0925 3.90779 12.5999 7.00039 12.5999C10.093 12.5999 12.6004 10.0925 12.6004 6.9999C12.6004 3.9073 10.093 1.3999 7.00039 1.3999ZM10.7337 7.93324C10.7337 8.19084 10.5247 8.3999 10.2671 8.3999H3.73372C3.47612 8.3999 3.26706 8.19084 3.26706 7.93324V6.06657C3.26706 5.80897 3.47612 5.5999 3.73372 5.5999H10.2671C10.5247 5.5999 10.7337 5.80897 10.7337 6.06657V7.93324Z', fill: '#FF4A53' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7.00039 1.3999C3.90779 1.3999 1.40039 3.9073 1.40039 6.9999C1.40039 10.0925 3.90779 12.5999 7.00039 12.5999C10.093 12.5999 12.6004 10.0925 12.6004 6.9999C12.6004 3.9073 10.093 1.3999 7.00039 1.3999ZM10.7337 7.93324C10.7337 8.19084 10.5247 8.3999 10.2671 8.3999H3.73372C3.47612 8.3999 3.26706 8.19084 3.26706 7.93324V6.06657C3.26706 5.80897 3.47612 5.5999 3.73372 5.5999H10.2671C10.5247 5.5999 10.7337 5.80897 10.7337 6.06657V7.93324Z', fill: 'white' })));
};
var DangerIcon$1 = react.memo(DangerIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/Icons/ViewIcon/index.js
'use client';



var ViewIcon = function (props) {
    var _a = props.isLight, isLight = _a === void 0 ? false : _a;
    if (isLight) {
        return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            react.createElement("path", { d: 'M7 2.33325C2.83813 2.33325 0.149794 6.6318 0.101172 6.71008C0.0357249 6.79251 7.07572e-05 6.89466 0 6.99992C8.27882e-05 7.09022 0.026362 7.17855 0.075651 7.25422C0.0762555 7.25513 0.0768631 7.25604 0.077474 7.25695C0.0854977 7.27351 2.34212 11.6666 7 11.6666C11.6381 11.6666 13.8914 7.31666 13.9189 7.26333C13.9207 7.26031 13.9226 7.25727 13.9243 7.25422C13.9736 7.17855 13.9999 7.09022 14 6.99992C14 6.89508 13.9647 6.7933 13.8997 6.71099C13.8994 6.71068 13.8991 6.71038 13.8988 6.71008C13.8502 6.6318 11.1619 2.33325 7 2.33325ZM7 3.73325C8.80413 3.73325 10.2667 5.19579 10.2667 6.99992C10.2667 8.80405 8.80413 10.2666 7 10.2666C5.19587 10.2666 3.73333 8.80405 3.73333 6.99992C3.73333 5.19579 5.19587 3.73325 7 3.73325ZM7 5.59992C6.6287 5.59992 6.2726 5.74742 6.01005 6.00997C5.7475 6.27252 5.6 6.62862 5.6 6.99992C5.6 7.37122 5.7475 7.72732 6.01005 7.98987C6.2726 8.25242 6.6287 8.39992 7 8.39992C7.3713 8.39992 7.7274 8.25242 7.98995 7.98987C8.2525 7.72732 8.4 7.37122 8.4 6.99992C8.4 6.62862 8.2525 6.27252 7.98995 6.00997C7.7274 5.74742 7.3713 5.59992 7 5.59992Z', fill: '#999999' })));
    }
    return (react.createElement("svg", { width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M7 2.33325C2.83813 2.33325 0.149794 6.6318 0.101172 6.71008C0.0357249 6.79251 7.07572e-05 6.89466 0 6.99992C8.27882e-05 7.09022 0.026362 7.17855 0.075651 7.25422C0.0762555 7.25513 0.0768631 7.25604 0.077474 7.25695C0.0854977 7.27351 2.34212 11.6666 7 11.6666C11.6381 11.6666 13.8914 7.31666 13.9189 7.26333C13.9207 7.26031 13.9226 7.25727 13.9243 7.25422C13.9736 7.17855 13.9999 7.09022 14 6.99992C14 6.89508 13.9647 6.7933 13.8997 6.71099C13.8994 6.71068 13.8991 6.71038 13.8988 6.71008C13.8502 6.6318 11.1619 2.33325 7 2.33325ZM7 3.73325C8.80413 3.73325 10.2667 5.19579 10.2667 6.99992C10.2667 8.80405 8.80413 10.2666 7 10.2666C5.19587 10.2666 3.73333 8.80405 3.73333 6.99992C3.73333 5.19579 5.19587 3.73325 7 3.73325ZM7 5.59992C6.6287 5.59992 6.2726 5.74742 6.01005 6.00997C5.7475 6.27252 5.6 6.62862 5.6 6.99992C5.6 7.37122 5.7475 7.72732 6.01005 7.98987C6.2726 8.25242 6.6287 8.39992 7 8.39992C7.3713 8.39992 7.7274 8.25242 7.98995 7.98987C8.2525 7.72732 8.4 7.37122 8.4 6.99992C8.4 6.62862 8.2525 6.27252 7.98995 6.00997C7.7274 5.74742 7.3713 5.59992 7 5.59992Z', fill: 'white' })));
};
var ViewIcon$1 = react.memo(ViewIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/constants.js
'use client';










var DEFAULT_COLOR = [
    {
        name: 'success',
        color: '#fff',
        backgroundColor: constants/* colors.successColor */.O9.successColor,
        icon: react.createElement(CheckIcon$1, null)
    },
    {
        name: 'warning',
        color: '#fff',
        backgroundColor: constants/* colors.buttonColor */.O9.buttonColor,
        icon: react.createElement(WarningIcon$1, null)
    },
    {
        name: 'default',
        color: '#fff',
        backgroundColor: constants/* colors.primaryColor */.O9.primaryColor,
        icon: react.createElement(AttachIcon$1, null)
    },
    {
        name: 'info',
        color: '#fff',
        backgroundColor: constants/* colors.infoColor */.O9.infoColor,
        icon: react.createElement(QuestionMarkIcon$1, null)
    },
    {
        name: 'danger',
        color: '#fff',
        backgroundColor: constants/* colors.dangerColor */.O9.dangerColor,
        icon: react.createElement(DangerIcon$1, null)
    },
    {
        name: 'secondary',
        color: '#fff',
        backgroundColor: constants/* colors.secondaryColor */.O9.secondaryColor,
        icon: react.createElement(ViewIcon$1, null)
    }
];
var DEFAULT_LIGHT_COLOR = [
    {
        name: 'success',
        color: constants/* colors.successColor */.O9.successColor,
        backgroundColor: '#D6EBE0',
        icon: react.createElement(CheckIcon$1, { isLight: true })
    },
    {
        name: 'warning',
        color: constants/* colors.buttonColor */.O9.buttonColor,
        backgroundColor: '#FFE5DD',
        icon: react.createElement(WarningIcon$1, { isLight: true })
    },
    {
        name: 'default',
        color: constants/* colors.primaryColor */.O9.primaryColor,
        backgroundColor: '#CCDEFF',
        icon: react.createElement(AttachIcon$1, { isLight: true })
    },
    {
        name: 'info',
        color: constants/* colors.infoColor */.O9.infoColor,
        backgroundColor: '#DAEFFF',
        icon: react.createElement(QuestionMarkIcon$1, { isLight: true })
    },
    {
        name: 'danger',
        color: constants/* colors.dangerColor */.O9.dangerColor,
        backgroundColor: '#FFDBDD',
        icon: react.createElement(DangerIcon$1, { isLight: true })
    },
    {
        name: 'secondary',
        color: constants/* colors.secondaryColor */.O9.secondaryColor,
        backgroundColor: '#E6EAF0',
        icon: react.createElement(ViewIcon$1, { isLight: true })
    }
];


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Chip/index.js
'use client';





var Chip = function (props) {
    var _a = props.color, color = _a === void 0 ? 'default' : _a, _b = props.isLightColor, isLightColor = _b === void 0 ? false : _b, _c = props.children, children = _c === void 0 ? '' : _c, _d = props.isHaveIcon, isHaveIcon = _d === void 0 ? true : _d;
    // Get color info
    var filteredColors = (isLightColor ? DEFAULT_LIGHT_COLOR : DEFAULT_COLOR).filter(function (item) { return item.name === color; });
    var colorInfo = isLightColor ? DEFAULT_LIGHT_COLOR[0] : DEFAULT_COLOR[0];
    if (filteredColors.length > 0) {
        colorInfo = filteredColors[0];
    }
    return (react.createElement(ChipWrapper, { color: colorInfo.color, backgroundColor: colorInfo.backgroundColor, isHaveIcon: isHaveIcon },
        isHaveIcon && colorInfo.icon,
        children));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CircleProgressBar/CircleProgressBar.css.js
'use client';




var ScorePercentWrapper = styled_components_browser_esm/* default.div */.ZP.div(CircleProgressBar_css_templateObject_1 || (CircleProgressBar_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"], ["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"])), function (_a) {
    var diameter = _a.diameter;
    return diameter;
}, function (_a) {
    var diameter = _a.diameter;
    return diameter;
});
var LabelPercent = styled_components_browser_esm/* default.span */.ZP.span(CircleProgressBar_css_templateObject_2 || (CircleProgressBar_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"])), function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var label = _a.label;
    return label.weight;
}, function (_a) {
    var label = _a.label;
    return label.size;
}, function (_a) {
    var label = _a.label;
    return label.lineHeight;
}, function (_a) {
    var color = _a.color;
    return color;
});
var CircleItem = styled_components_browser_esm/* default.circle */.ZP.circle(CircleProgressBar_css_templateObject_5 || (CircleProgressBar_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"], ["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"])), function (_a) {
    var strokeDashoffset = _a.strokeDashoffset;
    return strokeDashoffset;
}, function (_a) {
    var duration = _a.duration;
    return "stroke-dashoffset ".concat(duration, "ms ease 0s, stroke-dasharray ").concat(duration, "ms ease ").concat(duration, "ms, stroke ").concat(duration, "ms ease 0s,\n        stroke-width 0.06s ease ").concat(duration, "ms, opacity ").concat(duration, "ms ease 0s");
}, function (_a) {
    var customStrokeDashArray = _a.customStrokeDashArray;
    if (!customStrokeDashArray) {
        return (0,styled_components_browser_esm/* css */.iv)(CircleProgressBar_css_templateObject_3 || (CircleProgressBar_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                stroke-dasharray: ", ";\n            "], ["\n                stroke-dasharray: ", ";\n            "])), function (_a) {
            var perimeter = _a.perimeter;
            return "".concat(perimeter, "px, ").concat(perimeter, "px");
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(CircleProgressBar_css_templateObject_4 || (CircleProgressBar_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            stroke-dasharray: ", ";\n        "], ["\n            stroke-dasharray: ", ";\n        "])), function (_a) {
        var customStrokeDashArray = _a.customStrokeDashArray;
        return "".concat(customStrokeDashArray);
    });
});
var CircleProgressBar_css_templateObject_1, CircleProgressBar_css_templateObject_2, CircleProgressBar_css_templateObject_3, CircleProgressBar_css_templateObject_4, CircleProgressBar_css_templateObject_5;


//# sourceMappingURL=CircleProgressBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CircleProgressBar/constants.js
'use client';



var constants_DEFAULT_OPTIONS = {
    radius: 102,
    strokeWidth: 6,
    color: constants/* colors.primaryColor */.O9.primaryColor,
    label: {
        size: 24,
        weight: 700,
        lineHeight: 29,
        extend: ''
    },
    segmentSpace: 10,
    segmentAtPercent: 80,
    isShowSegment: false,
    duration: 1000,
    isUsingGradient: false
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextCountUp/index.js
'use client';



var easeOutQuad = function (t) {
    return t * (2 - t); // Ease-out function
};
var CountUp = function (_a) {
    var start = _a.start, end = _a.end, duration = _a.duration;
    var _b = (0,react.useState)(start), count = _b[0], setCount = _b[1];
    (0,react.useEffect)(function () {
        var startTime = performance.now();
        var tick = function () {
            var currentTime = performance.now();
            var elapsed = currentTime - startTime;
            // Calculate the progress (0 to 1)
            var progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1
            var easedProgress = easeOutQuad(progress); // Apply easing
            // Calculate the current count based on eased progress
            var newCount = Math.round(easedProgress * end);
            setCount(newCount);
            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        };
        requestAnimationFrame(tick);
    }, [end, duration]);
    return react.createElement(react.Fragment, null, Math.round(count));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AICircleProgressBar/AICircleProgressBar.css.js
'use client';




var AICircleProgressBar_css_ScorePercentWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICircleProgressBar_css_templateObject_1 || (AICircleProgressBar_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"], ["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"])), function (_a) {
    var diameter = _a.diameter;
    return diameter;
}, function (_a) {
    var diameter = _a.diameter;
    return diameter;
});
var AICircleProgressBar_css_LabelPercent = styled_components_browser_esm/* default.p */.ZP.p(AICircleProgressBar_css_templateObject_2 || (AICircleProgressBar_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    margin: 0;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    margin: 0;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"])), function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var label = _a.label;
    return label.weight;
}, function (_a) {
    var label = _a.label;
    return label.size;
}, function (_a) {
    var label = _a.label;
    return label.lineHeight;
}, function (_a) {
    var color = _a.color;
    return color;
});
var LabelExtend = styled_components_browser_esm/* default.span */.ZP.span(AICircleProgressBar_css_templateObject_3 || (AICircleProgressBar_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n"], ["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n"])));
var AICircleProgressBar_css_CircleItem = styled_components_browser_esm/* default.circle */.ZP.circle(AICircleProgressBar_css_templateObject_6 || (AICircleProgressBar_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"], ["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"])), function (_a) {
    var strokeDashoffset = _a.strokeDashoffset;
    return strokeDashoffset;
}, function (_a) {
    var duration = _a.duration, delay = _a.delay;
    return "stroke-dashoffset ".concat(duration, "ms ease-out ").concat(delay, "ms,\n    stroke-dasharray ").concat(duration, "ms ease ").concat(delay, "ms, stroke ").concat(duration, "ms ease ").concat(delay, "ms,\n        stroke-width 0.06s ease ").concat(delay, "ms, opacity ").concat(duration, "ms ease ").concat(delay, "ms");
}, function (_a) {
    var customStrokeDashArray = _a.customStrokeDashArray;
    if (!customStrokeDashArray) {
        return (0,styled_components_browser_esm/* css */.iv)(AICircleProgressBar_css_templateObject_4 || (AICircleProgressBar_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                stroke-dasharray: ", ";\n            "], ["\n                stroke-dasharray: ", ";\n            "])), function (_a) {
            var perimeter = _a.perimeter;
            return "".concat(perimeter, "px, ").concat(perimeter, "px");
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(AICircleProgressBar_css_templateObject_5 || (AICircleProgressBar_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            stroke-dasharray: ", ";\n        "], ["\n            stroke-dasharray: ", ";\n        "])), function (_a) {
        var customStrokeDashArray = _a.customStrokeDashArray;
        return "".concat(customStrokeDashArray);
    });
});
var AICircleProgressBar_css_templateObject_1, AICircleProgressBar_css_templateObject_2, AICircleProgressBar_css_templateObject_3, AICircleProgressBar_css_templateObject_4, AICircleProgressBar_css_templateObject_5, AICircleProgressBar_css_templateObject_6;


//# sourceMappingURL=AICircleProgressBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CircleProgressBar/index.js
'use client';














var circlePercent = 100; // Total percent of a circle
var circleRadius = 360; // Total radius of a circle
var CircleProgressBar = function (props) {
    var options = props.options;
    var mergedOptions = (0,helpers/* deepMerge */.RH)(constants_DEFAULT_OPTIONS, options);
    var divRef = (0,react.useRef)(null);
    var _a = (0,react.useState)(0), percent = _a[0], setPercent = _a[1];
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: divRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    (0,react.useEffect)(function () {
        if (!isElementOnScreen) {
            return;
        }
        setTimeout(function () { return setPercent(props.percent > circlePercent ? circlePercent : props.percent); }, 500);
    }, [props.percent, isElementOnScreen]);
    var radius = mergedOptions.radius / 2 - mergedOptions.strokeWidth / 2;
    // Total Perimeter in pixel of circle
    var perimeter = Math.PI * 2 * radius;
    // Convert StrokeWidth into radius
    var strokeRadius = (mergedOptions.strokeWidth * circleRadius) / perimeter;
    // Convert SegmentSpace into radius
    var segmentSpacing = (mergedOptions.segmentSpace * circleRadius) / perimeter;
    // Convert percentage to radius
    // Minus 90 deg (CSS Rotation)
    var segmentRotation = Math.round((mergedOptions.segmentAtPercent * circleRadius) / circlePercent) - 90 + strokeRadius + segmentSpacing;
    var segmentStrokeWidth = mergedOptions.strokeWidth;
    var currentPercent = percent;
    var remainPercent = 0;
    if (percent > mergedOptions.segmentAtPercent && mergedOptions.isShowSegment) {
        remainPercent = percent - mergedOptions.segmentAtPercent;
        currentPercent = mergedOptions.segmentAtPercent;
    }
    else if (percent < mergedOptions.segmentAtPercent) {
        remainPercent = 0;
    }
    var strokeDashoffset = ((circlePercent - currentPercent) / circlePercent) * perimeter;
    var segmentDashOffset = ((circlePercent - mergedOptions.segmentAtPercent) / circlePercent) * perimeter -
        mergedOptions.segmentSpace * 2 -
        mergedOptions.strokeWidth * 2;
    var totalRemainPercent = circlePercent - mergedOptions.segmentAtPercent;
    var remainDashoffset = (remainPercent * segmentDashOffset) / totalRemainPercent;
    if (remainPercent <= 0) {
        remainDashoffset = segmentDashOffset;
    }
    if (percent <= mergedOptions.segmentAtPercent) {
        remainDashoffset = 0;
    }
    if (remainDashoffset <= 0) {
        segmentStrokeWidth = 0;
    }
    return (react.createElement(ScorePercentWrapper, { ref: divRef, diameter: mergedOptions.radius },
        react.createElement("svg", { viewBox: "-".concat(mergedOptions.radius / 2, " -").concat(mergedOptions.radius / 2, " ").concat(mergedOptions.radius, " ").concat(mergedOptions.radius), role: 'presentation' },
            mergedOptions.isUsingGradient ? (react.createElement("defs", null,
                react.createElement("linearGradient", { id: 'paint0_linear_36250_774849', x1: '-198.5', y1: '-95', x2: '-119.5', y2: '160.5', gradientUnits: 'userSpaceOnUse' },
                    react.createElement("stop", { offset: '0.0230633', stopColor: '#B900F6' }),
                    react.createElement("stop", { offset: '0.375817', stopColor: '#DC1EAF' }),
                    react.createElement("stop", { offset: '0.632849', stopColor: '#FF6200' }),
                    react.createElement("stop", { offset: '1', stopColor: '#FDB92E' })))) : null,
            react.createElement(CircleItem, { r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: 0, stroke: '#f4f4f7', style: {
                    strokeDasharray: mergedOptions.isShowSegment
                        ? "".concat(perimeter * (mergedOptions.segmentAtPercent / circlePercent), "px, ").concat(perimeter, "px")
                        : "".concat(perimeter, "px, ").concat(perimeter, "px")
                }, duration: mergedOptions.duration }),
            react.createElement(CircleItem, { r: radius, cx: '0', cy: '0', 
                // stroke={mergedOptions.color}
                stroke: mergedOptions.isUsingGradient ? 'url(#paint0_linear_36250_774849)' : mergedOptions.color, strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, opacity: '1', perimeter: perimeter, strokeDashoffset: strokeDashoffset, duration: mergedOptions.duration }),
            mergedOptions.isShowSegment ? (react.createElement(CircleItem, { r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, stroke: '#f4f4f7', style: {
                    strokeDasharray: "".concat(segmentDashOffset, "px, ").concat(perimeter, "px"),
                    transform: "rotate(".concat(segmentRotation, "deg)")
                }, duration: mergedOptions.duration, strokeDashoffset: 0, opacity: 1 })) : null,
            mergedOptions.isShowSegment ? (react.createElement(CircleItem, { r: radius, cx: '0', cy: '0', stroke: mergedOptions.color, strokeLinecap: 'round', strokeWidth: segmentStrokeWidth, opacity: '1', perimeter: perimeter, strokeDashoffset: 0, customStrokeDashArray: "".concat(remainDashoffset, "px, ").concat(perimeter, "px"), style: {
                    transform: "rotate(".concat(segmentRotation, "deg)")
                }, duration: mergedOptions.duration })) : null),
        react.createElement(LabelPercent, { color: mergedOptions.isUsingGradient ? '#343434' : mergedOptions.color, sizes: mergedOptions.radius, label: mergedOptions.label },
            react.createElement(CountUp, { start: 0, end: percent, duration: mergedOptions.duration * (mergedOptions.isShowSegment ? 2 : 1) }),
            "%",
            mergedOptions.label.extend ? (react.createElement(react.Fragment, null,
                react.createElement("br", null),
                react.createElement(LabelExtend, null, mergedOptions.label.extend))) : null)));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(50697);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(6017);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/apiServices.js
'use client';




var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_ERROR_CODE = 400;
var followCompany = function (companyId, isFollow, api, accessToken, langCode) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var postData, requestOptions, response, err_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                postData = {
                    companyId: companyId,
                    status: isFollow ? 1 : 0
                };
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': langCode || constants/* ELanguage.VI */.Df.VI,
                        Authorization: "Bearer ".concat(accessToken)
                    },
                    body: JSON.stringify(postData)
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [2 /*return*/, {
                        meta: {
                            code: DEFAULT_ERROR_CODE,
                            message: 'ERROR'
                        },
                        data: null
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getRecommendCompanyList = function (api) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var requestOptions, response, err_2;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_2 = _a.sent();
                console.error(err_2);
                return [2 /*return*/, {
                        companies: []
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=apiServices.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/CompaniesYouWillLove.css.js
'use client';





var CompaniesYouWillLoveWrapper = styled_components_browser_esm/* default.div */.ZP.div(CompaniesYouWillLove_css_templateObject_2 || (CompaniesYouWillLove_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    button {\n        cursor: pointer;\n    }\n    ", "\n"], ["\n    button {\n        cursor: pointer;\n    }\n    ", "\n"])), function (_a) {
    var isSideView = _a.isSideView;
    if (!isSideView) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(CompaniesYouWillLove_css_templateObject_1 || (CompaniesYouWillLove_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-radius: 6px;\n            background-color: #fff;\n            margin-bottom: 8px;\n            border: 1px solid #b3ceff;\n            overflow: hidden;\n            h2 {\n                padding: 16px;\n                border-bottom: 1px solid #b3ceff;\n                background-color: #e6efff;\n                color: #555;\n                font-weight: 700;\n                font-size: 16px;\n                margin: 0;\n            }\n            > div > div {\n                border-top: 0;\n                border-left: 0;\n                border-right: 0;\n                border-radius: 0;\n                margin-bottom: 0;\n                &:last-child {\n                    border-bottom: 0;\n                }\n                &:hover {\n                    background-color: ", ";\n                }\n            }\n        "], ["\n            border-radius: 6px;\n            background-color: #fff;\n            margin-bottom: 8px;\n            border: 1px solid #b3ceff;\n            overflow: hidden;\n            h2 {\n                padding: 16px;\n                border-bottom: 1px solid #b3ceff;\n                background-color: #e6efff;\n                color: #555;\n                font-weight: 700;\n                font-size: 16px;\n                margin: 0;\n            }\n            > div > div {\n                border-top: 0;\n                border-left: 0;\n                border-right: 0;\n                border-radius: 0;\n                margin-bottom: 0;\n                &:last-child {\n                    border-bottom: 0;\n                }\n                &:hover {\n                    background-color: ", ";\n                }\n            }\n        "])), constants/* colors.bgHover */.O9.bgHover);
});
var CompaniesList = styled_components_browser_esm/* default.div */.ZP.div(CompaniesYouWillLove_css_templateObject_3 || (CompaniesYouWillLove_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-right: -8px;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    margin-right: -8px;\n"])), function (_a) {
    var maxItemOnRow = _a.maxItemOnRow;
    return maxItemOnRow || 1;
});
var CompaniesYouWillLove_css_templateObject_1, CompaniesYouWillLove_css_templateObject_2, CompaniesYouWillLove_css_templateObject_3;


//# sourceMappingURL=CompaniesYouWillLove.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/constants.js
'use client';

var EMPTY_COMPANY_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/CompanyItem/CompanyItem.css.js
'use client';




var CompanyItemWrapper = styled_components_browser_esm/* default.div */.ZP.div(CompanyItem_css_templateObject_1 || (CompanyItem_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    border-radius: 6px;\n    border: 1px solid #efefef;\n    padding: 16px;\n    margin-right: 8px;\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n"], ["\n    background-color: #fff;\n    border-radius: 6px;\n    border: 1px solid #efefef;\n    padding: 16px;\n    margin-right: 8px;\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n"])));
var LogoSection = styled_components_browser_esm/* default.a */.ZP.a(CompanyItem_css_templateObject_2 || (CompanyItem_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 70px;\n    height: 70px;\n    border-radius: 10px;\n    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));\n    background-color: #fff;\n    margin-right: 8px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    padding: 10px;\n    img {\n        width: 100%;\n    }\n"], ["\n    width: 70px;\n    height: 70px;\n    border-radius: 10px;\n    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));\n    background-color: #fff;\n    margin-right: 8px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    padding: 10px;\n    img {\n        width: 100%;\n    }\n"])));
var ContentSection = styled_components_browser_esm/* default.div */.ZP.div(CompanyItem_css_templateObject_3 || (CompanyItem_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    margin-right: 16px;\n"], ["\n    width: ", ";\n    margin-right: 16px;\n"])), function (_a) {
    var isShowFollow = _a.isShowFollow;
    return (isShowFollow ? 'calc(100% - 186px)' : 'calc(100% - 86px)');
});
var CompanyDescription = styled_components_browser_esm/* default.p */.ZP.p(CompanyItem_css_templateObject_4 || (CompanyItem_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #333;\n    font-size: 12px;\n    line-height: 15px;\n    margin: 0;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    display: flex;\n"], ["\n    color: #333;\n    font-size: 12px;\n    line-height: 15px;\n    margin: 0;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    display: flex;\n"])));
var ActionSection = styled_components_browser_esm/* default.div */.ZP.div(CompanyItem_css_templateObject_5 || (CompanyItem_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100px;\n    display: flex;\n    justify-content: flex-end;\n"], ["\n    width: 100px;\n    display: flex;\n    justify-content: flex-end;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(CompanyItem_css_templateObject_6 || (CompanyItem_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 8px;\n"], ["\n    margin-left: 8px;\n"])));
var CompanyJobCount = styled_components_browser_esm/* default.div */.ZP.div(CompanyItem_css_templateObject_7 || (CompanyItem_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #333;\n    font-size: 12px;\n    line-height: 15px;\n    margin-top: 4px;\n"], ["\n    color: #333;\n    font-size: 12px;\n    line-height: 15px;\n    margin-top: 4px;\n"])));
var CompanyItem_css_templateObject_1, CompanyItem_css_templateObject_2, CompanyItem_css_templateObject_3, CompanyItem_css_templateObject_4, CompanyItem_css_templateObject_5, CompanyItem_css_templateObject_6, CompanyItem_css_templateObject_7;


//# sourceMappingURL=CompanyItem.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/CompanyItem/index.js
'use client';











var CompanyItem = function (props) {
    var companyInfo = props.companyInfo, t = props.t, langCode = props.langCode, accessToken = props.accessToken, msUrl = props.msUrl, isShowFollow = props.isShowFollow, _a = props.classSelector, classSelector = _a === void 0 ? '' : _a;
    var _b = (0,react.useState)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isFollowed) === 1 || false), isFollow = _b[0], setFollowed = _b[1];
    var _c = (0,react.useState)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) || 0), followCount = _c[0], setFollowCount = _c[1];
    var companyUrl = (0,urlBuilder/* buildCompanyUrl */.kQ)({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0,
        companySlug: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName,
        langCode: langCode
    });
    var doFollow = (0,react.useCallback)(function (isFollowed) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var apiUrl, response, toastTitle, toastMessage;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (accessToken === null || accessToken === '') {
                        return [2 /*return*/];
                    }
                    if (companyInfo === null || !companyInfo.companyId) {
                        return [2 /*return*/];
                    }
                    apiUrl = "".concat(msUrl, "/api-gateway/v1.0/profile/follow");
                    return [4 /*yield*/, followCompany(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId, isFollowed, apiUrl, accessToken, langCode)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        return [2 /*return*/];
                    }
                    toastTitle = t('Unfollowed');
                    toastMessage = t("You'll stop receive the newest jobs from this company.");
                    if (isFollowed) {
                        toastTitle = t('Yay! Thanks for following');
                        toastMessage = t('You will receive the newest jobs from this company.');
                    }
                    (0,Toast/* showToast */.CF)(toastTitle, toastMessage, 'success');
                    return [2 /*return*/];
            }
        });
    }); }, [companyInfo, langCode, t, accessToken, msUrl]);
    var handleOnClickFollow = (0,react.useCallback)(function () {
        var followed = !isFollow;
        doFollow(followed);
        setFollowed(followed);
        setFollowCount(followed ? followCount + 1 : followCount - 1);
    }, [doFollow, followCount, isFollow]);
    (0,react.useEffect)(function () {
        if (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) {
            setFollowCount(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount);
        }
    }, [companyInfo]);
    return (react.createElement(CompanyItemWrapper, { className: "".concat(classSelector, " view_job_item") },
        react.createElement(LogoSection, { href: companyUrl },
            react.createElement("img", { src: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) || EMPTY_COMPANY_IMAGE, alt: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName })),
        react.createElement(ContentSection, { isShowFollow: isShowFollow },
            react.createElement(TrustedCompanyName/* default */.Z, { name: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || '', href: companyUrl, isTrusted: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1, style: { marginBottom: 4 }, tooltip: t('Trusted company') }),
            react.createElement(CompanyDescription, null,
                react.createElement("span", null,
                    followCount,
                    ' ',
                    companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) > 1
                        ? t('followers')
                        : t('follower'))),
            companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 0 ? (react.createElement(CompanyJobCount, null, companyInfo === null || companyInfo === void 0 ? void 0 :
                companyInfo.onlineJobCount,
                ' ',
                (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 1 ? t('opening jobs') : t('opening job'))) : null),
        isShowFollow && (react.createElement(ActionSection, null,
            react.createElement(Button/* default */.Z, { type: 'primary', isOutline: true, size: 'sm', onClick: handleOnClickFollow }, isFollow ? t('Following') : t('Follow'))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/translation.js
'use client';

var CompaniesYouWillLove_translation_translations = {
    'Companies You Will Love': 'Công Ty Bạn Sẽ Thích',
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    Following: 'Đang theo dõi',
    Follow: 'Theo dõi',
    Unfollowed: 'Đã bỏ theo dõi',
    'Yay! Thanks for following': 'Cảm ơn bạn đã theo dõi',
    Unfollow: 'Bỏ theo dõi',
    'You will receive the newest jobs from this company.': 'Bạn sẽ nhận được thông báo về công việc mới nhất từ công ty này.',
    'You will not able to received notifications from this company.': 'Bạn sẽ ngừng nhận thông tin việc làm từ công ty này.',
    'Unfollow company?': 'Bỏ theo dõi công ty?',
    "You'll stop receive the newest jobs from this company.": 'Bạn sẽ ngừng nhận thông báo về công việc mới nhất từ ​​công ty này.',
    'opening jobs': 'việc làm',
    'opening job': 'việc làm',
    'Trusted company': 'Công ty uy tín'
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/index.js
'use client';










var DEFAULT_MAX_ITEM_ON_ROW = 2;
var MAX_ITEM_SHOW_NOSIDE = 6;
var MAX_ITEM_SHOW_SIDE = 4;
var DEFAULT_LIMIT_COMPANIES = 12;
var CompaniesYouWillLove_DEFAULT_OPTIONS = {
    maxItemOnRow: DEFAULT_MAX_ITEM_ON_ROW,
    isSideView: false,
    isShowFollow: false,
    limitCompanies: DEFAULT_LIMIT_COMPANIES
};
var CompaniesYouWillLove = function (props) {
    var langCode = props.langCode, _a = props.options, options = _a === void 0 ? CompaniesYouWillLove_DEFAULT_OPTIONS : _a, userId = props.userId, _b = props.jobId, jobId = _b === void 0 ? -1 : _b, accessToken = props.accessToken, _c = props.msUrl, msUrl = _c === void 0 ? 'https://ms.vietnamworks.com' : _c, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d;
    var mergedOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, CompaniesYouWillLove_DEFAULT_OPTIONS), options);
    var limit = options.isSideView ? MAX_ITEM_SHOW_SIDE : MAX_ITEM_SHOW_NOSIDE;
    var _e = (0,react.useState)(false), isShowList = _e[0], setShowList = _e[1];
    var _f = (0,react.useState)([]), companyList = _f[0], setCompanyList = _f[1];
    var t = (0,react.useCallback)(function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return CompaniesYouWillLove_translation_translations[text];
        }
    }, [langCode]);
    var getLastViewJobId = function (userId) {
        var rawCookie = (0,cookie/* getCookie */.e)('VNW_LAST_JOB_SEEN');
        var lastViewCookie = decodeURIComponent(rawCookie !== null ? rawCookie : '');
        if (lastViewCookie) {
            var lastViewJobData = decodeURIComponent(lastViewCookie).split(',');
            var jobId_1 = lastViewJobData[0];
            var userViewJob = lastViewJobData[1] || '-1';
            // not return job Id if logged in user is different than last viewed user
            if (userId !== parseInt(userViewJob)) {
                return null;
            }
            // other than that case, return job Id
            return jobId_1;
        }
        return null;
    };
    var getRecommendCompany = (0,react.useCallback)(function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var lastViewJobId, jobIdStr, API_URL, responseCompany;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (userId === undefined || userId === null || userId === 0) {
                        setShowList(false);
                        return [2 /*return*/];
                    }
                    lastViewJobId = getLastViewJobId(userId);
                    jobIdStr = '';
                    if (jobId !== -1) {
                        jobIdStr = "&jobId=".concat(jobId);
                    }
                    if (jobId === -1 && lastViewJobId !== null) {
                        jobIdStr = "&jobId=".concat(lastViewJobId);
                    }
                    API_URL = "".concat(msUrl, "/smartnavi/v1/companies?user=").concat(userId, "&limit=").concat(mergedOption.limitCompanies).concat(jobIdStr);
                    return [4 /*yield*/, getRecommendCompanyList(API_URL)];
                case 1:
                    responseCompany = _b.sent();
                    if (!((_a = responseCompany === null || responseCompany === void 0 ? void 0 : responseCompany.companies) === null || _a === void 0 ? void 0 : _a.length)) {
                        setShowList(false);
                        return [2 /*return*/];
                    }
                    setCompanyList((responseCompany === null || responseCompany === void 0 ? void 0 : responseCompany.companies) || []);
                    setShowList(true);
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken, jobId, langCode, mergedOption.limitCompanies, msUrl, userId]);
    (0,react.useEffect)(function () {
        getRecommendCompany();
    }, [getRecommendCompany]);
    return (react.createElement(react.Fragment, null, isShowList && (react.createElement(CompaniesYouWillLoveWrapper, { isSideView: options.isSideView || false },
        react.createElement("h2", null, t('Companies You Will Love')),
        react.createElement(CompaniesList, { maxItemOnRow: options.maxItemOnRow || DEFAULT_MAX_ITEM_ON_ROW }, Array.from(Array(limit), function (_item, index) {
            if (companyList[index] === undefined || companyList[index] === null) {
                return null;
            }
            return (react.createElement(CompanyItem, { key: "company-item-".concat(index), t: t, langCode: langCode, companyInfo: companyList[index], accessToken: accessToken, msUrl: msUrl, isShowFollow: options.isShowFollow || false, classSelector: classSelector }));
        }))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCard/CompanyCard.js
'use client';




var imageWidth = 70;
var buttonWidth = 90;
var gapWidth = 16;
var CardContainer = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_1 || (CompanyCard_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid #efefef;\n    border-radius: 6px;\n    background-color: white;\n    padding: 16px;\n    margin-top: 8px;\n\n    &:hover {\n        background-color: #f9fcff;\n    }\n"], ["\n    border: 1px solid #efefef;\n    border-radius: 6px;\n    background-color: white;\n    padding: 16px;\n    margin-top: 8px;\n\n    &:hover {\n        background-color: #f9fcff;\n    }\n"])));
var CardItem = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_2 || (CompanyCard_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: ", "px;\n    align-items: ", ";\n"], ["\n    display: flex;\n    gap: ", "px;\n    align-items: ", ";\n"])), gapWidth, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 'stretch' : 'center');
});
var CardImage = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_3 || (CompanyCard_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 0 0 ", "px;\n    height: 70px;\n    padding: 8px;\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n    background-color: white !important;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        background-color: white !important;\n    }\n"], ["\n    flex: 0 0 ", "px;\n    height: 70px;\n    padding: 8px;\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n    background-color: white !important;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        background-color: white !important;\n    }\n"])), imageWidth);
var CardContent = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_7 || (CompanyCard_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    ", "\n"])), function (_a) {
    var isHaveButton = _a.isHaveButton;
    return isHaveButton
        ? (0,styled_components_browser_esm/* css */.iv)(CompanyCard_templateObject_4 || (CompanyCard_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  width: calc(100% - ", "px - ", "px);\n              "], ["\n                  width: calc(100% - ", "px - ", "px);\n              "])), imageWidth + gapWidth, buttonWidth + gapWidth) : (0,styled_components_browser_esm/* css */.iv)(CompanyCard_templateObject_5 || (CompanyCard_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  width: calc(100% - ", "px);\n              "], ["\n                  width: calc(100% - ", "px);\n              "])), imageWidth + gapWidth);
}, function (_a) {
    var isMobile = _a.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(CompanyCard_templateObject_6 || (CompanyCard_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: calc(100% - 86px);\n        "], ["\n            width: calc(100% - 86px);\n        "])));
});
var CardButton = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_8 || (CompanyCard_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 0 0 ", "px;\n"], ["\n    flex: 0 0 ", "px;\n"])), buttonWidth);
var CardButtonMobile = styled_components_browser_esm/* default.div */.ZP.div(CompanyCard_templateObject_9 || (CompanyCard_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    margin-top: 10px;\n"], ["\n    width: 100%;\n    margin-top: 10px;\n"])));
var CompanyCard_templateObject_1, CompanyCard_templateObject_2, CompanyCard_templateObject_3, CompanyCard_templateObject_4, CompanyCard_templateObject_5, CompanyCard_templateObject_6, CompanyCard_templateObject_7, CompanyCard_templateObject_8, CompanyCard_templateObject_9;


//# sourceMappingURL=CompanyCard.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCard/index.js
'use client';




var CompanyCard = function (props) {
    var isMobile = props.isMobile, imageProp = props.imageProp, contentProp = props.contentProp, buttonProp = props.buttonProp, headerProp = props.headerProp;
    return (react.createElement(CardContainer, { className: 'view_job_item imp-click myjobs_list' },
        headerProp,
        react.createElement(CardItem, { isMobile: isMobile },
            react.createElement(CardImage, null, imageProp),
            react.createElement(CardContent, { isMobile: isMobile, isHaveButton: !!buttonProp }, contentProp),
            !isMobile && buttonProp && react.createElement(CardButton, null, buttonProp)),
        isMobile && buttonProp && react.createElement(CardButtonMobile, null, buttonProp)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyInfo/CompanyInfo.css.js
'use client';





var CompanyInfoWrapper = styled_components_browser_esm/* default.div */.ZP.div(CompanyInfo_css_templateObject_1 || (CompanyInfo_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 6px;\n    background-color: #fff;\n    display: flex;\n    border: 1px solid #efefef;\n    border-radius: 6px;\n    padding: 16px;\n    align-items: center;\n"], ["\n    border-radius: 6px;\n    background-color: #fff;\n    display: flex;\n    border: 1px solid #efefef;\n    border-radius: 6px;\n    padding: 16px;\n    align-items: center;\n"])));
var CompanyInfoLogo = (0,styled_components_browser_esm/* default */.ZP)(LogoSection)(CompanyInfo_css_templateObject_2 || (CompanyInfo_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 64px;\n    height: 64px;\n    min-width: 64px;\n    margin-right: 16px;\n"], ["\n    width: 64px;\n    height: 64px;\n    min-width: 64px;\n    margin-right: 16px;\n"])));
var CompanyInfoDescription = (0,styled_components_browser_esm/* default */.ZP)(CompanyDescription)(CompanyInfo_css_templateObject_3 || (CompanyInfo_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n"], ["\n    display: inline-flex;\n"])));
var CompanyInfoJobCount = (0,styled_components_browser_esm/* default */.ZP)(CompanyJobCount)(CompanyInfo_css_templateObject_4 || (CompanyInfo_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    margin-left: 16px;\n"], ["\n    display: inline-flex;\n    margin-left: 16px;\n"])));
var CompanyInfoContentSection = (0,styled_components_browser_esm/* default */.ZP)(ContentSection)(CompanyInfo_css_templateObject_5 || (CompanyInfo_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-right: 0;\n"], ["\n    margin-right: 0;\n"])));
var CompanyInfo_css_templateObject_1, CompanyInfo_css_templateObject_2, CompanyInfo_css_templateObject_3, CompanyInfo_css_templateObject_4, CompanyInfo_css_templateObject_5;


//# sourceMappingURL=CompanyInfo.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyInfo/translation.js
'use client';

var CompanyInfo_translation_translations = {
    Follow: 'Theo dõi',
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    Following: 'Đang theo dõi',
    'opening jobs': 'việc làm',
    'opening job': 'việc làm',
    'Trusted company': 'Công ty uy tín'
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/CompanyInfo/index.js
'use client';









var CompanyInfo = function (props) {
    var langCode = props.langCode, companyInfo = props.companyInfo;
    var followCount = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) || 0;
    var companyUrl = (0,urlBuilder/* buildCompanyUrl */.kQ)({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0,
        companySlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || '',
        langCode: langCode
    });
    var t = function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return CompanyInfo_translation_translations[text];
        }
    };
    return (react.createElement(CompanyInfoWrapper, { className: 'view_job_item' },
        react.createElement(CompanyInfoLogo, { href: companyUrl },
            react.createElement("img", { src: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) || EMPTY_COMPANY_IMAGE, alt: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName })),
        react.createElement(CompanyInfoContentSection, { isShowFollow: false },
            react.createElement(TrustedCompanyName/* default */.Z, { name: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName, href: companyUrl, style: { marginBottom: 4 }, isTrusted: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1, tooltip: t('Trusted company') }),
            react.createElement(CompanyInfoDescription, null,
                react.createElement("span", null,
                    followCount,
                    ' ',
                    companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) > 1
                        ? t('followers')
                        : t('follower'))),
            companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 0 ? (react.createElement(CompanyInfoJobCount, null, companyInfo === null || companyInfo === void 0 ? void 0 :
                companyInfo.onlineJobCount,
                ' ',
                (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 1 ? t('opening jobs') : t('opening job'))) : null)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/EmptyResult/EmptyResult.css.js
'use client';





var NoResultWrapper = styled_components_browser_esm/* default.div */.ZP.div(EmptyResult_css_templateObject_1 || (EmptyResult_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #f6f8fb;\n    border-radius: 6px;\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    p {\n        margin: 8px 0 0 0;\n        line-height: 22px;\n        text-align: center;\n    }\n"], ["\n    background-color: #f6f8fb;\n    border-radius: 6px;\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    p {\n        margin: 8px 0 0 0;\n        line-height: 22px;\n        text-align: center;\n    }\n"])));
var NoResultIcon = styled_components_browser_esm/* default.div */.ZP.div(EmptyResult_css_templateObject_2 || (EmptyResult_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ButtonSection = styled_components_browser_esm/* default.p */.ZP.p(EmptyResult_css_templateObject_3 || (EmptyResult_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", " !important;\n    cursor: pointer;\n    margin-top: 16px !important;\n    &:hover {\n        color: ", " !important;\n    }\n"], ["\n    color: ", " !important;\n    cursor: pointer;\n    margin-top: 16px !important;\n    &:hover {\n        color: ", " !important;\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor);
var TitleWrapper = styled_components_browser_esm/* default.p */.ZP.p(EmptyResult_css_templateObject_4 || (EmptyResult_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n"], ["\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n"])));
var Description = styled_components_browser_esm/* default.p */.ZP.p(EmptyResult_css_templateObject_5 || (EmptyResult_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"])));
var EmptyResult_css_templateObject_1, EmptyResult_css_templateObject_2, EmptyResult_css_templateObject_3, EmptyResult_css_templateObject_4, EmptyResult_css_templateObject_5;


//# sourceMappingURL=EmptyResult.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/EmptyResult/index.js
'use client';




var EmptyResult = function (props) {
    var icon = props.icon, title = props.title, description = props.description, style = props.style, _a = props.buttonTitle, buttonTitle = _a === void 0 ? '' : _a, onClick = props.onClick;
    return (react.createElement(NoResultWrapper, { style: style },
        react.createElement(NoResultIcon, null, icon),
        react.createElement(TitleWrapper, null, title),
        description ? react.createElement(Description, null, description) : null,
        react.createElement(ButtonSection, { onClick: function () {
                onClick && onClick();
            } }, buttonTitle)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Switcher/Switcher.css.js
'use client';





var SwitcherWrapper = styled_components_browser_esm/* default.div */.ZP.div(Switcher_css_templateObject_2 || (Switcher_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    label {\n        user-select: none;\n        margin-left: 10px;\n        font-weight: 400;\n        cursor: pointer;\n    }\n\n    input {\n        display: none;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    label {\n        user-select: none;\n        margin-left: 10px;\n        font-weight: 400;\n        cursor: pointer;\n    }\n\n    input {\n        display: none;\n    }\n\n    ", "\n"])), function (_a) {
    var isLabelLeft = _a.isLabelLeft;
    if (!isLabelLeft) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(Switcher_css_templateObject_1 || (Switcher_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            flex-direction: row-reverse;\n            justify-content: space-between;\n            label {\n                margin-left: 0;\n                margin-right: 10px;\n            }\n        "], ["\n            flex-direction: row-reverse;\n            justify-content: space-between;\n            label {\n                margin-left: 0;\n                margin-right: 10px;\n            }\n        "])));
});
var Switch = styled_components_browser_esm/* default.span */.ZP.span(Switcher_css_templateObject_3 || (Switcher_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    box-shadow: ", ";\n    transition: border 0.4s ease 0s, box-shadow 0.4s ease 0s;\n    background-color: ", ";\n    border: ", ";\n    border-radius: 20px;\n    cursor: pointer;\n    display: inline-block;\n    height: 18px;\n    width: 32px;\n    min-width: 32px;\n    position: relative;\n    vertical-align: middle;\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n"], ["\n    box-shadow: ", ";\n    transition: border 0.4s ease 0s, box-shadow 0.4s ease 0s;\n    background-color: ", ";\n    border: ", ";\n    border-radius: 20px;\n    cursor: pointer;\n    display: inline-block;\n    height: 18px;\n    width: 32px;\n    min-width: 32px;\n    position: relative;\n    vertical-align: middle;\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n"])), function (_a) {
    var isChecked = _a.isChecked;
    return isChecked ? "".concat(constants/* colors.primaryColor */.O9.primaryColor, " 0px 0px 0px 0px inset") : '#dfdfdf 0px 0px 0px 0px inset';
}, function (_a) {
    var isChecked = _a.isChecked;
    return (isChecked ? "".concat(constants/* colors.primaryColor */.O9.primaryColor) : '#e5e5e5');
}, function (_a) {
    var isChecked = _a.isChecked;
    return (isChecked ? "1px solid ".concat(constants/* colors.primaryColor */.O9.primaryColor) : '1px solid #e5e5e5');
});
var Toggle = styled_components_browser_esm/* default.span */.ZP.span(Switcher_css_templateObject_4 || (Switcher_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: #fff;\n    border-radius: 100%;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);\n    position: absolute;\n    top: 1px;\n    transition: background-color 0.4s ease 0s, left 0.2s ease 0s;\n    left: ", "px;\n    width: 16px;\n    height: 16px;\n"], ["\n    background: #fff;\n    border-radius: 100%;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);\n    position: absolute;\n    top: 1px;\n    transition: background-color 0.4s ease 0s, left 0.2s ease 0s;\n    left: ", "px;\n    width: 16px;\n    height: 16px;\n"])), function (_a) {
    var isChecked = _a.isChecked;
    return (isChecked ? 15 : 2);
});
var Switcher_css_templateObject_1, Switcher_css_templateObject_2, Switcher_css_templateObject_3, Switcher_css_templateObject_4;


//# sourceMappingURL=Switcher.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Switcher/index.js
'use client';




/**
 * Switch Toggle Component
 *
 * @param props
 */
var Switcher = function (props) {
    var _a = props.label, label = _a === void 0 ? '' : _a, _b = props.value, value = _b === void 0 ? false : _b, _c = props.isLabelLeft, isLabelLeft = _c === void 0 ? false : _c, onChange = props.onChange;
    var onChangeSwitch = (0,react.useCallback)(function () {
        var checked = !value;
        onChange && onChange(checked);
    }, [onChange, value]);
    return (react.createElement(SwitcherWrapper, { "data-checked": value, isLabelLeft: isLabelLeft, onClick: onChangeSwitch },
        react.createElement(Switch, { isChecked: value },
            react.createElement(Toggle, { isChecked: value })),
        label ? react.createElement("label", null, label) : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/JobAlert.module.scss.js
'use client';

var JobAlert_module_scss_styles = {"jobAlertModal":"JobAlert-module_jobAlertModal__1QGom","errorMessage":"JobAlert-module_errorMessage__35ghe","overlayLock":"JobAlert-module_overlayLock__3_GE3","backdrop":"JobAlert-module_backdrop__zeeLE","isOpen":"JobAlert-module_isOpen__12S3H","header":"JobAlert-module_header__yztzJ","left":"JobAlert-module_left__plG6X","right":"JobAlert-module_right__21ZTT","modalTitle":"JobAlert-module_modalTitle__32KsQ","body":"JobAlert-module_body__2Pd0t","footer":"JobAlert-module_footer__2K0h-","row":"JobAlert-module_row__1fSlv","select-container":"JobAlert-module_select-container__2jGTU","bordered":"JobAlert-module_bordered__1SnM8","title":"JobAlert-module_title__3sNDB","icon":"JobAlert-module_icon__3wRto","iconDelete":"JobAlert-module_iconDelete__3JgtV","flexCenter":"JobAlert-module_flexCenter__Zn9Gh","colSmall6":"JobAlert-module_colSmall6__2WVBM","alignMiddle":"JobAlert-module_alignMiddle__WkQnT","colSmall8":"JobAlert-module_colSmall8__20EZ5","colSmall4":"JobAlert-module_colSmall4__2qX_L","colBottomRight":"JobAlert-module_colBottomRight__1Pp8f","jobAlertInput":"JobAlert-module_jobAlertInput__1Y2zC","inputWithPrepend":"JobAlert-module_inputWithPrepend__3APRE","focus":"JobAlert-module_focus__1zJSH","prependText":"JobAlert-module_prependText__1FxHZ","wraperFloatingIcon":"JobAlert-module_wraperFloatingIcon__24NXO","extendJobAlertIcon":"JobAlert-module_extendJobAlertIcon__1lND4","inputSalary":"JobAlert-module_inputSalary__3Shp1","jobAlertBtn":"JobAlert-module_jobAlertBtn__1Ai4Q","mailBoxText":"JobAlert-module_mailBoxText__1B7qt","showBtn":"JobAlert-module_showBtn__2OFoW","mailBoxFloating":"JobAlert-module_mailBoxFloating__1Rbqo","jobAlertBanner":"JobAlert-module_jobAlertBanner__1ZZ5K","borderWrap":"JobAlert-module_borderWrap__3phYo","borderWrapHeader":"JobAlert-module_borderWrapHeader__2dtWW","borderWrapFooter":"JobAlert-module_borderWrapFooter__377Bw","borderWrapRadius":"JobAlert-module_borderWrapRadius__3Teou","textBlue":"JobAlert-module_textBlue__38jSa","borderWrapBetween":"JobAlert-module_borderWrapBetween__yCjO5","shortFormModal":"JobAlert-module_shortFormModal__oE6Rz","shortFormText":"JobAlert-module_shortFormText__2irQv","mb0":"JobAlert-module_mb0__EYaih","borderMobile":"JobAlert-module_borderMobile__2awE8","mobile":"JobAlert-module_mobile__NiPwl","hideOnMobile":"JobAlert-module_hideOnMobile__TXnXr"};


//# sourceMappingURL=JobAlert.module.scss.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/JobTitle/index.js
'use client';







var JobTitle = function (props) {
    var _a = props.jobTitle, jobTitle = _a === void 0 ? '' : _a, _b = props.isValidate, isValidate = _b === void 0 ? true : _b, _c = props.language, language = _c === void 0 ? 'en' : _c, setJobTitle = props.setJobTitle, shortForm = props.shortForm;
    var _d = (0,react.useState)(isValidate), isFieldValidate = _d[0], setValidate = _d[1];
    var handleOnChangeValue = function (value) {
        setValidate(value.length > 0);
        setJobTitle && setJobTitle(value);
    };
    return (react.createElement(react.Fragment, null,
        shortForm ? (react.createElement("label", { htmlFor: 'jobTitle' },
            (0,helpers.t)('Job title', language),
            " ",
            react.createElement("span", { style: { color: '#DC362E' } }, "*")))
            : (react.createElement("label", { htmlFor: 'jobTitle' },
                (0,helpers.t)('Job title', language),
                " ",
                react.createElement("span", null,
                    "(",
                    (0,helpers.t)('Required', language),
                    ")"))),
        react.createElement(components_Input/* default */.Z, { type: 'text', id: 'jobTitle', isRequired: true, onChange: function (value) { return handleOnChangeValue(value); }, value: jobTitle !== null && jobTitle !== void 0 ? jobTitle : '', className: JobAlert_module_scss_styles.jobAlertInput, maxLength: 100, placeholder: (0,helpers.t)('Enter job title', language), autoFocus: true, onBlur: function (e) {
                setTimeout(function () {
                    setValidate(e.target.value.length > 0);
                }, 0);
            }, hasError: !isFieldValidate }),
        react.createElement("p", (0,_tslib/* __assign */.pi)({ className: "error-message ".concat(JobAlert_module_scss_styles.errorMessage) }, (isFieldValidate ? { hidden: true } : '')), (0,helpers.t)('This field is required', language))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/JobLevel/index.js
'use client';






var JobLevel = function (props) {
    var _a = props.isMobile, isMobile = _a === void 0 ? false : _a, _b = props.language, language = _b === void 0 ? constants/* ELanguage.EN */.Df.EN : _b, _c = props.customTitle, customTitle = _c === void 0 ? '' : _c, setJobLevel = props.setJobLevel, jobLevelOptions = props.jobLevelOptions, jobLevel = props.jobLevel;
    var memoOptions = (0,react.useMemo)(function () {
        var optionList = [];
        if (jobLevelOptions !== undefined && (jobLevelOptions === null || jobLevelOptions === void 0 ? void 0 : jobLevelOptions.length) > 0) {
            jobLevelOptions.map(function (item, _) {
                var _a, _b, _c;
                // Required to parse toString because some time data is number
                if (item.id !== '-1' || item.id.toString() !== '-1') {
                    var itemId = (_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '-1';
                    optionList.push({
                        id: parseInt(itemId),
                        name: (_c = item.text) !== null && _c !== void 0 ? _c : ''
                    });
                }
            });
        }
        return optionList;
    }, [jobLevelOptions]);
    var handleOnChangeValue = function (value) {
        setJobLevel && setJobLevel(value);
    };
    return (react.createElement(react.Fragment, null,
        react.createElement("label", null, customTitle || (0,helpers.t)('Job level', language)),
        react.createElement("div", null,
            react.createElement(MultipleSelect/* default */.Z, { key: "job-level-multiple-select-".concat(jobLevelOptions === null || jobLevelOptions === void 0 ? void 0 : jobLevelOptions.length), name: 'job-level', options: memoOptions, defaultSelect: jobLevel, onChange: function (e) { return handleOnChangeValue(e.value); }, selectPlaceholder: (0,helpers.t)('Please select ...', language), optionsStyle: { maxHeight: '220px' }, dropdownStyle: { width: '100%', boxShadow: 'none' }, isMobile: isMobile, langCode: language, sortEnable: true }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/JobAlertSelect/index.js
'use client';




var JobAlertSelect = function (props) {
    var _a = props.isMobile, isMobile = _a === void 0 ? false : _a, _b = props.isOpened, isOpened = _b === void 0 ? false : _b, _c = props.customClass, customClass = _c === void 0 ? '' : _c, title = props.title, jobSelectValue = props.jobSelectValue, pleaseSelect = props.pleaseSelect, limitAlertText = props.limitAlertText, _d = props.limitSelectCount, limitSelectCount = _d === void 0 ? 3 : _d, _e = props.jobOptions, jobOptions = _e === void 0 ? [] : _e, _f = props.customWidth, customWidth = _f === void 0 ? '350px' : _f, setJobSelect = props.setJobSelect, langCode = props.langCode, hasError = props.hasError, sortEnable = props.sortEnable;
    var _g = (0,react.useState)(false), isValueChange = _g[0], setIsValueChange = _g[1];
    var jobValue = (0,react.useState)(jobSelectValue || [])[0];
    // parse props.jobOptions to TSelectOption[]
    var memoOptions = (0,react.useMemo)(function () {
        var optionList = [];
        if (jobOptions !== undefined && (jobOptions === null || jobOptions === void 0 ? void 0 : jobOptions.length) > 0) {
            jobOptions.map(function (item, _) {
                var _a, _b, _c;
                var itemId = (_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '-1';
                optionList.push({
                    id: parseInt(itemId),
                    name: (_c = item.text) !== null && _c !== void 0 ? _c : ''
                });
            });
        }
        return optionList;
    }, [jobOptions]);
    var handleOnChangeValue = function (value) {
        setJobSelect && setJobSelect(value);
    };
    (0,react.useEffect)(function () {
        // Auto set value change after modal opened 1s
        if (isOpened) {
            setTimeout(function () {
                setIsValueChange(true);
            }, 1000);
        }
    });
    (0,react.useEffect)(function () {
        if (isOpened && !isValueChange && jobValue !== jobSelectValue) {
            setIsValueChange(true);
        }
    }, [jobSelectValue]);
    return (react.createElement("div", { className: customClass },
        react.createElement("label", { className: "".concat(isValueChange ? 'changed' : '') }, title),
        react.createElement("div", null,
            react.createElement(MultipleSelect/* default */.Z, { name: 'job-alert-select', options: memoOptions, defaultSelect: jobSelectValue, onChange: function (e) { return handleOnChangeValue(e.value); }, selectPlaceholder: pleaseSelect, optionsStyle: { maxHeight: '200px' }, dropdownStyle: { width: customWidth, boxShadow: 'none' }, limitText: limitAlertText, limit: limitSelectCount, isMobile: isMobile, langCode: langCode, sortEnable: sortEnable, hasError: hasError }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/NotificationBy/index.js
'use client';






var NotificationBy = function (_a) {
    var _b = _a.alertId, alertId = _b === void 0 ? '' : _b, _c = _a.language, language = _c === void 0 ? 'en' : _c, setJobNotificationBy = _a.setJobNotificationBy, jobNotificationBy = _a.jobNotificationBy;
    return (react.createElement(react.Fragment, null,
        react.createElement("label", null, (0,helpers.t)('Notify via', language)),
        react.createElement("div", null,
            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall4 },
                react.createElement(SingleRadio/* default */.Z, { id: 'notifications_by-radio-1', label: (0,helpers.t)('Email', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(1); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 1, isLeftRadio: true })),
            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall4 },
                react.createElement(SingleRadio/* default */.Z, { id: 'notifications_by-radio-2', label: (0,helpers.t)('App', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(2); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 2, isLeftRadio: true })),
            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall4 },
                react.createElement(SingleRadio/* default */.Z, { id: 'notifications_by-radio-3', label: (0,helpers.t)('Both', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(3); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 3, isLeftRadio: true })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/Interval/index.js
'use client';






var Interval = function (_a) {
    var _b = _a.alertId, alertId = _b === void 0 ? '' : _b, _c = _a.language, language = _c === void 0 ? 'en' : _c, setJobInterval = _a.setJobInterval, jobInterval = _a.jobInterval;
    return (react.createElement(react.Fragment, null,
        react.createElement("label", null, (0,helpers.t)('Frequency', language)),
        react.createElement("div", null,
            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.mobile },
                react.createElement(SingleRadio/* default */.Z, { id: 'interval-radio-2', label: (0,helpers.t)('Daily', language), onChange: function () { return setJobInterval && setJobInterval(2); }, name: "interval-".concat(alertId), checked: jobInterval === 2, isLeftRadio: true })),
            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.mobile },
                react.createElement(SingleRadio/* default */.Z, { id: 'interval-radio-3', label: (0,helpers.t)('Weekly', language), onChange: function () { return setJobInterval && setJobInterval(3); }, name: "interval-".concat(alertId), checked: jobInterval === 3, isLeftRadio: true })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/constants.js
'use client';

var maxJobTitleLength = 100;
var duplicatedJobAlert = 6001;
var TOTAL_MAX_JOB_ALERT_CODE = 6002;
var successCode = 200;
var ESalaryPeriod;
(function (ESalaryPeriod) {
    ESalaryPeriod[ESalaryPeriod["MONTHLY"] = 1] = "MONTHLY";
    ESalaryPeriod[ESalaryPeriod["YEARLY"] = 2] = "YEARLY";
})(ESalaryPeriod || (ESalaryPeriod = {}));
var SalaryPeriodOptions = {
    vi: [
        {
            id: 1,
            name: 'Hàng tháng'
        },
        {
            id: 2,
            name: 'Hàng năm'
        }
    ],
    en: [
        {
            id: 1,
            name: 'Monthly'
        },
        {
            id: 2,
            name: 'Yearly'
        }
    ]
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/apiServices.js
'use client';



var createEditJobAlert = function (postData, isEdit, url, apiTokenAccess, isAnonymous) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headerData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json'
                };
                if (!isAnonymous) {
                    headerData.Authorization = "Bearer ".concat(apiTokenAccess);
                }
                return [4 /*yield*/, fetch(url, {
                        method: isEdit ? 'PUT' : 'POST',
                        headers: headerData,
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var deleteJobAlert = function (url, apiTokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'DELETE',
                    headers: {
                        Authorization: "Bearer ".concat(apiTokenAccess),
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getJobLevelList = function (url) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET'
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var jobAlertService = {
    createEditJobAlert: createEditJobAlert,
    deleteJobAlert: deleteJobAlert,
    getJobLevelList: getJobLevelList
};


//# sourceMappingURL=apiServices.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputSalary/InputSalary.css.js
'use client';





var SelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(InputSalary_css_templateObject_1 || (InputSalary_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    z-index: 1;\n    width: 130px;\n    border-left: 1px solid ", ";\n"], ["\n    position: relative;\n    z-index: 1;\n    width: 130px;\n    border-left: 1px solid ", ";\n"])), Colors/* colors.neutral.80 */.O9.neutral[80]);
var InputSalaryWrapper = styled_components_browser_esm/* default.div */.ZP.div(InputSalary_css_templateObject_4 || (InputSalary_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    border-radius: 8px;\n    border: 1px solid ", ";\n    .class-input-recommend {\n        border: none !important;\n        border-radius: 8px;\n        height: 38px !important;\n    }\n    .remove-icon {\n        top: 10px !important;\n    }\n    .multiple-radio-container {\n        border: none !important;\n        background: ", ";\n        border-radius: 0 8px 8px 0;\n        padding: 0 4px 0 12px;\n        height: 38px !important;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    border-radius: 8px;\n    border: 1px solid ", ";\n    .class-input-recommend {\n        border: none !important;\n        border-radius: 8px;\n        height: 38px !important;\n    }\n    .remove-icon {\n        top: 10px !important;\n    }\n    .multiple-radio-container {\n        border: none !important;\n        background: ", ";\n        border-radius: 0 8px 8px 0;\n        padding: 0 4px 0 12px;\n        height: 38px !important;\n    }\n\n    ", "\n"])), Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.neutral.95 */.O9.neutral[95], function (_a) {
    var isFocus = _a.isFocus;
    if (!isFocus) {
        return (0,styled_components_browser_esm/* css */.iv)(InputSalary_css_templateObject_2 || (InputSalary_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                &:hover {\n                    border: 1px solid ", ";\n                }\n            "], ["\n                &:hover {\n                    border: 1px solid ", ";\n                }\n            "])), Colors/* colors.primary.80 */.O9.primary[80]);
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputSalary_css_templateObject_3 || (InputSalary_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid ", ";\n            ", " {\n                border-left: 1px solid ", ";\n            }\n        "], ["\n            border: 1px solid ", ";\n            ", " {\n                border-left: 1px solid ", ";\n            }\n        "])), Colors/* colors.primary.50 */.O9.primary[50], SelectWrapper, Colors/* colors.primary.50 */.O9.primary[50]);
});
var InputSalary_css_InputWrapper = styled_components_browser_esm/* default.div */.ZP.div(InputSalary_css_templateObject_5 || (InputSalary_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: calc(100% - 80px);\n"], ["\n    width: calc(100% - 80px);\n"])));
var SalaryLabel = styled_components_browser_esm/* default.label */.ZP.label(InputSalary_css_templateObject_6 || (InputSalary_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 500;\n    display: block;\n    margin-bottom: 4px;\n"], ["\n    font-weight: 500;\n    display: block;\n    margin-bottom: 4px;\n"])));
var InputSalary_css_templateObject_1, InputSalary_css_templateObject_2, InputSalary_css_templateObject_3, InputSalary_css_templateObject_4, InputSalary_css_templateObject_5, InputSalary_css_templateObject_6;


//# sourceMappingURL=InputSalary.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputSalary/services.js
'use client';



var API_SALARY_CURRENCIES = '/meta/v1.0/salary-currencies';
var getSalaryCurrencies = function (msBaseUrl) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(msBaseUrl).concat(API_SALARY_CURRENCIES), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                _a.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/InputSalary/index.js
'use client';









var MAX_JOB_SALARY_LENGTH = 12;
var DEFAULT_INPUT_SALARY_OPTIONS = {
    maxLength: MAX_JOB_SALARY_LENGTH,
    label: ''
};
var InputSalary = function (props) {
    var salary = props.salary, currencyId = props.currencyId, _a = props.options, options = _a === void 0 ? DEFAULT_INPUT_SALARY_OPTIONS : _a, _b = props.onChange, onChange = _b === void 0 ? function () { } : _b, msBaseUrl = props.msBaseUrl, _c = props.langCode, langCode = _c === void 0 ? constants/* ELanguage */.Df : _c, _d = props.isMobile, isMobile = _d === void 0 ? false : _d;
    var _e = (0,react.useState)(false), isFocus = _e[0], setFocus = _e[1];
    var _f = (0,react.useState)([]), currencies = _f[0], setCurrencies = _f[1];
    var handleOnChangeValue = function (value) {
        // check is number
        value = value.replaceAll(',', '');
        var parsedValue = parseInt(value);
        if (value.length <= MAX_JOB_SALARY_LENGTH) {
            onChange && onChange(isNaN(parsedValue) ? 0 : parsedValue, currencyId);
        }
    };
    var handleOnChangeCurrency = function (currencyId) {
        if (salary.toString().length <= MAX_JOB_SALARY_LENGTH) {
            onChange && onChange(salary, currencyId);
        }
    };
    var formatCurrency = function (value) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
        });
        return formatter.format(value).replace('$', '');
    };
    (0,react.useEffect)(function () {
        (function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var salaryCurrencies, formattedCurrencies;
            var _a, _b, _c, _d, _e, _f;
            return (0,_tslib/* __generator */.Jh)(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, getSalaryCurrencies(msBaseUrl)];
                    case 1:
                        salaryCurrencies = _g.sent();
                        if (!((_b = (_a = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _a === void 0 ? void 0 : _a.relationships) === null || _b === void 0 ? void 0 : _b.data)) {
                            return [2 /*return*/];
                        }
                        if (((_d = (_c = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _c === void 0 ? void 0 : _c.relationships) === null || _d === void 0 ? void 0 : _d.data.length) === 0) {
                            return [2 /*return*/];
                        }
                        formattedCurrencies = (_f = (_e = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _e === void 0 ? void 0 : _e.relationships) === null || _f === void 0 ? void 0 : _f.data.map(function (item) { return ({
                            id: item.id,
                            name: langCode === constants/* ELanguage.VI */.Df.VI ? item.attributes.nameVi : item.attributes.nameEn
                        }); });
                        setCurrencies(formattedCurrencies);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (react.createElement(react.Fragment, null,
        options.label !== '' ? react.createElement(SalaryLabel, { htmlFor: 'jobSalary' }, options.label) : react.createElement(react.Fragment, null),
        react.createElement(InputSalaryWrapper, { isFocus: isFocus },
            react.createElement(InputSalary_css_InputWrapper, null,
                react.createElement(components_Input/* default */.Z, { type: 'text', id: 'jobSalary', isRequired: true, onChange: handleOnChangeValue, onFocus: function () { return setFocus(true); }, onBlur: function () { return setFocus(false); }, value: salary > 0 ? formatCurrency(salary !== null && salary !== void 0 ? salary : 0).toString() : '', placeholder: '0', maxLength: options.maxLength })),
            react.createElement(SelectWrapper, null,
                react.createElement(MultipleRadio/* default */.Z, { options: currencies, name: 'select-currency', value: currencyId, onChange: function (_a) {
                        var value = _a.value;
                        return handleOnChangeCurrency(value);
                    }, dropdownStyle: {
                        minWidth: 120
                    }, placement: 'bottom-end', isMobile: isMobile })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobAlert/index.js
'use client';












































































































































































var EMPTY_JOB_ALERT_ID = -1;
/**
 * Job Alert Modal Component
 *
 * @param props
 */
var JobAlert = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = props.id, id = _p === void 0 ? '' : _p, _q = props.title, title = _q === void 0 ? 'Create Job Alert' : _q, _r = props.isOpen, isOpen = _r === void 0 ? false : _r, _s = props.isMobile, isMobile = _s === void 0 ? false : _s, _t = props.jobAlertInfo, jobAlertInfo = _t === void 0 ? null : _t, _u = props.jobLocationOptions, jobLocationOptions = _u === void 0 ? [] : _u, _v = props.jobFunctionOptions, jobFunctionOptions = _v === void 0 ? {
        parent: [],
        child: {}
    } : _v, _w = props.jobIndustryOptions, jobIndustryOptions = _w === void 0 ? [] : _w, _x = props.apiTokenAccess, apiTokenAccess = _x === void 0 ? '' : _x, _y = props.apiJobAlert, apiJobAlert = _y === void 0 ? 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts' : _y, _z = props.apiGetJobLevelList, apiGetJobLevelList = _z === void 0 ? 'https://ms.vietnamworks.com/meta/v1.0/job-levels' : _z, _0 = props.msBaseUrl, msBaseUrl = _0 === void 0 ? 'https://ms.vietnamworks.com' : _0, apiJobAlertAnonymous = props.apiJobAlertAnonymous, _1 = props.language, language = _1 === void 0 ? 'vi' : _1, onToggleChange = props.onToggleChange, onDeleteJobAlert = props.onDeleteJobAlert, onAddEditJobAlert = props.onAddEditJobAlert, onClose = props.onClose;
    var isLoggedInProp = props.isLoggedIn;
    var _2 = (0,react.useState)(isOpen !== null && isOpen !== void 0 ? isOpen : false), isModalOpen = _2[0], setIsModalOpen = _2[1];
    var _3 = (0,react.useState)(isLoggedInProp !== null && isLoggedInProp !== void 0 ? isLoggedInProp : true), isLoggedIn = _3[0], setIsLoggedIn = _3[1];
    var jobCategory = (_a = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobCategory) !== null && _a !== void 0 ? _a : [];
    // Job Alert info
    var _4 = (0,react.useState)((_b = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobTitle) !== null && _b !== void 0 ? _b : ''), jobTitle = _4[0], setJobTitle = _4[1];
    var _5 = (0,react.useState)((_c = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobSalary) !== null && _c !== void 0 ? _c : 0), jobSalary = _5[0], setJobSalary = _5[1];
    var _6 = (0,react.useState)((_d = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobLevel) !== null && _d !== void 0 ? _d : []), jobLevel = _6[0], setJobLevel = _6[1];
    var _7 = (0,react.useState)((_e = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobLocation) !== null && _e !== void 0 ? _e : []), jobLocation = _7[0], setJobLocation = _7[1];
    var _8 = (0,react.useState)((_f = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobFunction) !== null && _f !== void 0 ? _f : []), jobFunction = _8[0], setJobFunction = _8[1];
    var _9 = (0,react.useState)((_g = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobIndustry) !== null && _g !== void 0 ? _g : []), jobIndustry = _9[0], setJobIndustry = _9[1];
    var _10 = (0,react.useState)((_h = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.isReceivedJobAlert) !== null && _h !== void 0 ? _h : true), isReceivedJobAlert = _10[0], setReceivedJobAlert = _10[1];
    var _11 = (0,react.useState)((_j = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobInterval) !== null && _j !== void 0 ? _j : 2), jobInterval = _11[0], setJobInterval = _11[1];
    var _12 = (0,react.useState)((_k = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobNotificationBy) !== null && _k !== void 0 ? _k : 1), jobNotificationBy = _12[0], setJobNotificationBy = _12[1];
    var _13 = (0,react.useState)((_l = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.userEmail) !== null && _l !== void 0 ? _l : ''), userEmail = _13[0], setUserEmail = _13[1];
    var _14 = (0,react.useState)((_m = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryCurrencyId) !== null && _m !== void 0 ? _m : 1), salaryCurrencyId = _14[0], setSalaryCurrencyId = _14[1];
    var _15 = (0,react.useState)((_o = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryPeriodId) !== null && _o !== void 0 ? _o : ESalaryPeriod.MONTHLY), salaryPeriodId = _15[0], setSalaryPeriodId = _15[1];
    var _16 = (0,react.useState)(true), isEmailValid = _16[0], setEmailValid = _16[1];
    var _17 = (0,react.useState)(false), shortForm = _17[0], setShortForm = _17[1];
    // modal
    var _18 = (0,react.useState)(false), isShowLoading = _18[0], setShowLoading = _18[1];
    var _19 = (0,react.useState)(false), isDeleteConfirmOpen = _19[0], setDeleteConfirmOpen = _19[1];
    var _20 = (0,react.useState)(false), isAskCloseWithoutSave = _20[0], setAskCloseWithoutSaveOpen = _20[1];
    var _21 = (0,react.useState)(false), isFormChanged = _21[0], setIsFormChange = _21[1];
    var _22 = (0,react.useState)({
        jobTitle: true
    }), validateForm = _22[0], setValidateForm = _22[1];
    // job level list
    var _23 = (0,react.useState)([]), jobLevelList = _23[0], setJobLevelList = _23[1];
    var isEdit = (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== undefined && (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== null;
    var tracking = (0,useHog/* default */.Z)().tracking;
    (0,react.useEffect)(function () {
        var currentPage = window.location.href;
        setShortForm(currentPage.indexOf('/viec-lam') > 0 || currentPage.indexOf('/jobs') > 0 || currentPage.indexOf('/tim-viec-lam/tim-tat-ca-viec-lam') > 0 || currentPage.indexOf('/job-search/all-jobs') > 0);
    }, []);
    (0,react.useEffect)(function () {
        // Detect Dialog show/hide and pass that value to callback function
        onToggleChange && onToggleChange(isModalOpen);
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isModalOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [isModalOpen]);
    (0,react.useEffect)(function () {
        // Do get Job Level
        var doGetJobLevelList = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var getJobLevelListRespone, returnJobLevelList_1;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (jobLevelList.length > 0) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, jobAlertService.getJobLevelList(apiGetJobLevelList || '')];
                    case 1:
                        getJobLevelListRespone = _a.sent();
                        if (getJobLevelListRespone.data !== undefined &&
                            getJobLevelListRespone.data.relationships !== undefined &&
                            getJobLevelListRespone.data.relationships.data !== undefined) {
                            returnJobLevelList_1 = [];
                            getJobLevelListRespone.data.relationships.data.map(function (item) {
                                returnJobLevelList_1.push({
                                    id: item.id,
                                    text: language === 'en' ? item.attributes.nameEn : item.attributes.nameVi
                                });
                            });
                            setJobLevelList(returnJobLevelList_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (isLoggedIn) {
            doGetJobLevelList();
        }
    }, [isLoggedIn]);
    var handleOnClickClose = function () {
        // check if any data new then show ask close popup,
        // if don't have anything new then just close main modal
        if (isFormChanged) {
            setAskCloseWithoutSaveOpen(true);
        }
        else {
            setIsModalOpen(false);
            onClose && onClose();
        }
    };
    var isFormValidate = function () {
        var result = true;
        var jobTitleValid = true;
        // check job title
        if (jobTitle === '' || jobTitle.length > maxJobTitleLength) {
            result = false;
            jobTitleValid = false;
        }
        setValidateForm({
            jobTitle: jobTitleValid
        });
        return result;
    };
    var handleOnClickSaveUserEmail = function () {
        // check email valid
        var isValid = false;
        if (userEmail.indexOf('@') > 0) {
            isValid = true;
            if (userEmail.indexOf('.') > 0) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        if (isValid) {
            // Done input email for user who didn't log in
            setIsLoggedIn(true);
        }
        else {
            // only set valid false. No need to set true for better performance
            setEmailValid(false);
        }
    };
    var handleOnClickDelete = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var jobAlertResult, isDeleted, deletedNotifyContent;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, jobAlertService.deleteJobAlert("".concat(apiJobAlert).concat(jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId), "".concat(apiTokenAccess))];
                case 1:
                    jobAlertResult = _b.sent();
                    isDeleted = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode) {
                        isDeleted = true;
                        // Hide confirm delete dialog
                        setDeleteConfirmOpen(false);
                        // close edit modal
                        setIsModalOpen(false);
                        deletedNotifyContent = (0,helpers.t)('Job alert "{0}" deleted', language);
                        (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert deleted successfully', language), deletedNotifyContent.replace('{0}', jobTitle));
                    }
                    onDeleteJobAlert && onDeleteJobAlert(isDeleted);
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    setDeleteConfirmOpen(false);
                    (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)("Can't delete this job alert", language), Toast/* TOAST_TYPE_ERROR */.rn);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickSave = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var postData, isAnonymous, apiUrl, jobAlertResult, isSuccess, notifyTitle, notifyContent, notifyTitle, notifyContent;
        var _a, _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    postData = {
                        keyword: jobTitle,
                        salary_min: jobSalary,
                        job_level: jobLevel,
                        location: jobLocation,
                        industry: jobCategory,
                        status: isReceivedJobAlert ? 1 : 0,
                        period_type_id: jobInterval,
                        notification_by: jobNotificationBy,
                        user_email: userEmail,
                        language_id: language === 'en' ? 2 : 1,
                        company_industry: jobIndustry,
                        job_function: jobFunction.map(function (item) { return item.childrenIds[0]; }),
                        salaryPeriodId: salaryPeriodId,
                        salaryCurrencyId: salaryCurrencyId
                    };
                    // Check form valid
                    if (!isFormValidate())
                        return [2 /*return*/];
                    setShowLoading(true);
                    isAnonymous = false;
                    apiUrl = isEdit ? (apiJobAlert || '') + (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) : apiJobAlert;
                    if (isLoggedInProp !== undefined && !isLoggedInProp) {
                        // If user is not logged in then using anonymous url
                        apiUrl = apiJobAlertAnonymous || '';
                        if (jobLevel.length > 0) {
                            postData.job_level_id = jobLevel[0];
                        }
                        isAnonymous = true;
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, jobAlertService.createEditJobAlert(postData, isEdit, "".concat(apiUrl), "".concat(apiTokenAccess), isAnonymous)];
                case 2:
                    jobAlertResult = _e.sent();
                    isSuccess = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        tracking({
                            eventName: 'js_job_management:job_alert_create',
                            properties: {
                                keyword: jobTitle,
                                frequencyId: jobInterval,
                                chanelId: jobNotificationBy,
                                isEnable: !!isReceivedJobAlert,
                                isAnonymous: isAnonymous
                            }
                        });
                    }
                    if (((_b = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _b === void 0 ? void 0 : _b.code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = (0,helpers.t)('Job alert created successfully', language);
                        notifyContent = (0,helpers.t)('Job alert "{0}" created', language);
                        if (isEdit) {
                            // show edit success
                            notifyTitle = (0,helpers.t)('Job alert updated successfully', language);
                            notifyContent = (0,helpers.t)('Job alert "{0}" updated', language);
                        }
                        (0,Toast/* showToast */.CF)(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = (0,helpers.t)('Job alert created successfully', language);
                        notifyContent = (0,helpers.t)('Job alert "{0}" created', language);
                        (0,Toast/* showToast */.CF)(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === duplicatedJobAlert) {
                        isSuccess = false;
                        // show duplicate
                        (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)('You already created this job alert', language), Toast/* TOAST_TYPE_ERROR */.rn);
                    }
                    setShowLoading(false);
                    onAddEditJobAlert && onAddEditJobAlert(isSuccess, (_d = (_c = jobAlertResult.data) === null || _c === void 0 ? void 0 : _c.job_alert_id) !== null && _d !== void 0 ? _d : EMPTY_JOB_ALERT_ID);
                    return [3 /*break*/, 4];
                case 3:
                    _e.sent();
                    setShowLoading(false);
                    (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)("Can't update this job alert", language), Toast/* TOAST_TYPE_ERROR */.rn);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickCloseAskSave = function () {
        setAskCloseWithoutSaveOpen(false);
        setIsModalOpen(false);
        onClose && onClose();
    };
    var isShowJobAlertModal = isModalOpen;
    if (isAskCloseWithoutSave) {
        isShowJobAlertModal = false;
    }
    if (isDeleteConfirmOpen) {
        isShowJobAlertModal = false;
    }
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.backdrop + ' ' + (isShowJobAlertModal ? JobAlert_module_scss_styles.isOpen : '')), onClick: handleOnClickClose }),
        react.createElement("div", { className: "".concat('box-dialog ' + JobAlert_module_scss_styles.jobAlertModal + ' ' + (isShowJobAlertModal ? JobAlert_module_scss_styles.isOpen : ''), " ").concat(shortForm ? JobAlert_module_scss_styles.shortFormModal : "") },
            react.createElement("div", { className: JobAlert_module_scss_styles.overlayLock, style: { display: isShowLoading ? 'flex' : 'none' } },
                react.createElement(IconLoading, { width: 64, height: 64 })),
            react.createElement("div", { className: shortForm ? "".concat(JobAlert_module_scss_styles.borderWrapHeader, " ").concat(JobAlert_module_scss_styles.header) : JobAlert_module_scss_styles.header },
                react.createElement("div", { className: JobAlert_module_scss_styles.modalTitle }, (0,helpers.t)(title || 'Job alert', language)),
                react.createElement("span", { onClick: handleOnClickClose, className: "".concat(JobAlert_module_scss_styles.icon, " ").concat(isMobile ? JobAlert_module_scss_styles.left : JobAlert_module_scss_styles.right) },
                    react.createElement(closeIcon, null))),
            isLoggedIn ? (react.createElement(react.Fragment, null,
                react.createElement("div", { className: JobAlert_module_scss_styles.body },
                    isMobile && !shortForm ? (react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall12 },
                            react.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                    setReceivedJobAlert(value);
                                    if (value !== isReceivedJobAlert)
                                        setIsFormChange(true);
                                }, value: isReceivedJobAlert, label: (0,helpers.t)('Receive Job Alerts', language) })))) : (react.createElement(react.Fragment, null)),
                    shortForm ? (react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("p", { className: JobAlert_module_scss_styles.shortFormText }, (0,helpers.t)("Create a job alert to seize a new opportunity. Don't miss the opportunity to find your dream job", language)),
                        react.createElement("div", { className: JobAlert_module_scss_styles.jobAlertBanner },
                            react.createElement("img", { src: 'https://images.vietnamworks.com/images/banner_job_alert.png', alt: '' })))) : null,
                    react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.mb0, " ").concat(shortForm ? "".concat(JobAlert_module_scss_styles.borderWrap) : "") },
                        react.createElement("div", { className: isMobile || shortForm ? JobAlert_module_scss_styles.colSmall6 : JobAlert_module_scss_styles.row },
                            react.createElement(JobTitle, { key: "jobTitle-".concat(validateForm.jobTitle ? 'true' : 'false'), jobTitle: jobTitle, setJobTitle: function (value) {
                                    setJobTitle(value);
                                    if (value !== jobTitle)
                                        setIsFormChange(true);
                                }, isValidate: validateForm.jobTitle, language: language, shortForm: shortForm })),
                        !shortForm ? (react.createElement("div", { className: isMobile ? '' : JobAlert_module_scss_styles.row },
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.inputSalary },
                                react.createElement(InputSalary, { salary: jobSalary, currencyId: salaryCurrencyId, msBaseUrl: msBaseUrl, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, options: {
                                        label: (0,helpers.t)('Salary from', language)
                                    }, onChange: function (value, currencyId) {
                                        setJobSalary(value);
                                        setSalaryCurrencyId(currencyId);
                                        if (value !== jobSalary)
                                            setIsFormChange(true);
                                    }, isMobile: isMobile })),
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement("label", { htmlFor: 'jobSalary' }, (0,helpers.t)('Pay period', language)),
                                react.createElement(MultipleRadio/* default */.Z, { name: 'currencyPeriod', value: salaryPeriodId, options: language === 'vi' ? SalaryPeriodOptions.vi : SalaryPeriodOptions.en, onChange: function (_a) {
                                        var value = _a.value;
                                        setSalaryPeriodId(value);
                                    }, isMobile: isMobile })))) : (react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                    setJobLocation(id);
                                    if (id !== jobLocation)
                                        setIsFormChange(true);
                                }, title: (0,helpers.t)('Expected working location', language), jobOptions: jobLocationOptions, limitAlertText: (0,helpers.t)('You can only choose maximum 3 locations', language), errorText: (0,helpers.t)('This field is required', language), noResult: (0,helpers.t)('No result', language), pleaseSelect: (0,helpers.t)('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN })))),
                    !shortForm ? (react.createElement(react.Fragment, null,
                        react.createElement("div", { className: JobAlert_module_scss_styles.row },
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement(JobLevel, { isMobile: isMobile, jobLevelOptions: jobLevelList, jobLevel: jobLevel, setJobLevel: function (value) {
                                        setJobLevel(value);
                                        if (value !== jobLevel)
                                            setIsFormChange(true);
                                    }, language: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, limitCharacterShow: 120, limitMaxShowItem: 3 })),
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                        setJobLocation(id);
                                        if (id !== jobLocation)
                                            setIsFormChange(true);
                                    }, title: (0,helpers.t)('Location', language), jobOptions: jobLocationOptions, limitAlertText: (0,helpers.t)('You can only choose maximum 3 locations', language), errorText: (0,helpers.t)('This field is required', language), noResult: (0,helpers.t)('No result', language), pleaseSelect: (0,helpers.t)('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN }))),
                        react.createElement("div", { className: JobAlert_module_scss_styles.row },
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement(react.Fragment, null,
                                    react.createElement("label", null, language === constants/* ELanguage.VI */.Df.VI ? 'Ngành nghề' : 'Job function'),
                                    react.createElement(JobFunction/* default */.Z, { isMobile: isMobile, data: jobFunctionOptions, value: jobFunction, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, onChange: function (value) {
                                            setJobFunction(value);
                                            setIsFormChange(true);
                                        }, dropdownStyleOptions: {
                                            width: '100%'
                                        }, isFlex: true, textOptions: {
                                            placeholder: (0,helpers.t)('Select job function', language)
                                        }, isSingleSelect: true, displayAsPopup: true }))),
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement("label", { htmlFor: 'userEmail' }, language === constants/* ELanguage.VI */.Df.VI ? 'Lĩnh vực công ty' : 'Industry'),
                                react.createElement(CompanyIndustry/* default */.Z, { type: 'multiple-select', options: jobIndustryOptions, value: jobIndustry, onChange: function (ids) {
                                        setJobIndustry(ids);
                                        setIsFormChange(true);
                                    }, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, dropdownStyle: { width: '100%' }, isMobile: isMobile }))),
                        react.createElement("div", { className: JobAlert_module_scss_styles.row },
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement(Interval, { alertId: id, jobInterval: jobInterval, setJobInterval: function (value) {
                                        setJobInterval(value);
                                        if (value !== jobInterval)
                                            setIsFormChange(true);
                                    }, language: language })),
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement(NotificationBy, { alertId: id, jobNotificationBy: jobNotificationBy, setJobNotificationBy: function (value) {
                                        setJobNotificationBy(value);
                                        if (value !== jobNotificationBy)
                                            setIsFormChange(true);
                                    }, language: language }))))) : null),
                react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.footer, " ").concat(shortForm ? "".concat(JobAlert_module_scss_styles.borderWrapFooter) : "") },
                    react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.flexCenter, " ").concat(shortForm ? "".concat(JobAlert_module_scss_styles.borderWrapBetween) : "") },
                        !shortForm ? (react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.alignMiddle + ' ' + JobAlert_module_scss_styles.hideOnMobile }, isMobile ? (react.createElement("div", null)) : (react.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: (0,helpers.t)('Receive Job Alerts', language) })))) : (react.createElement("div", null,
                            react.createElement("span", { className: "".concat(JobAlert_module_scss_styles.textBlue), onClick: function () { return setShortForm(false); } },
                                react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', style: { marginRight: '10px' } },
                                    react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.00034 9.99993C2.00034 5.58961 5.59002 1.99992 10.0003 1.99992C14.4106 1.99992 18.0003 5.58961 18.0003 9.99993C18.0003 14.4102 14.4106 17.9999 10.0003 17.9999C5.59002 17.9999 2.00034 14.4102 2.00034 9.99993ZM16.667 9.99993C16.667 6.31023 13.69 3.33326 10.0003 3.33326C6.31065 3.33326 3.33367 6.31023 3.33367 9.99993C3.33367 13.6896 6.31065 16.6666 10.0003 16.6666C13.69 16.6666 16.667 13.6896 16.667 9.99993ZM10.6675 10.6667H13.3342C13.7022 10.6667 14.0009 10.3687 14.0009 10C14.0009 9.63133 13.7022 9.33333 13.3342 9.33333H10.6675V6.66666C10.6675 6.298 10.3689 6 10.0009 6C9.63285 6 9.33418 6.298 9.33418 6.66666V9.33333H6.66752C6.29952 9.33333 6.00085 9.63133 6.00085 10C6.00085 10.3687 6.29952 10.6667 6.66752 10.6667H9.33418V13.3333C9.33418 13.702 9.63285 14 10.0009 14C10.3689 14 10.6675 13.702 10.6675 13.3333V10.6667Z', fill: '#005AFF' })),
                                (0,helpers.t)('Add more criteria', language)))),
                        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.colSmall6, " ").concat(JobAlert_module_scss_styles.colBottomRight) },
                            isEdit ? (react.createElement("div", { className: JobAlert_module_scss_styles.iconDelete, onClick: function () { return setDeleteConfirmOpen(true); } },
                                react.createElement(Trash$1, { width: 24, height: 24 }))) : (react.createElement("div", null)),
                            react.createElement("div", null,
                                react.createElement(Button/* default */.Z, { type: 'primary', style: { float: 'right' }, onClick: handleOnClickSave }, (0,helpers.t)(shortForm ? 'Create alert' : 'Save alert', language)),
                                !shortForm ? (react.createElement(Button/* default */.Z, { style: { marginRight: 10 }, onClick: handleOnClickClose }, (0,helpers.t)('Cancel', language))) : null)))))) : (react.createElement(react.Fragment, null,
                react.createElement("div", { className: JobAlert_module_scss_styles.body },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall8 },
                            react.createElement("label", { htmlFor: 'userEmail' }, (0,helpers.t)('Your email', language)),
                            react.createElement(components_Input/* default */.Z, { type: 'text', id: 'userEmail', isRequired: true, onChange: function (value) {
                                    setEmailValid(true);
                                    setUserEmail(value);
                                }, onPressEnter: handleOnClickSaveUserEmail, value: userEmail, className: JobAlert_module_scss_styles.jobAlertInput, maxLength: 100, placeholder: (0,helpers.t)('Email to receive jobs', language), autoFocus: true, hasError: !isEmailValid })),
                        isMobile ? (react.createElement(react.Fragment, null)) : (react.createElement("div", { className: JobAlert_module_scss_styles.colSmall4, style: { paddingLeft: 10 } },
                            react.createElement(Button/* default */.Z, { type: 'primary', size: 'md', onClick: handleOnClickSaveUserEmail, style: { width: '100%' } }, (0,helpers.t)('Send me jobs', language))))),
                    react.createElement("div", (0,_tslib/* __assign */.pi)({ className: JobAlert_module_scss_styles.row }, (isEmailValid ? { hidden: true } : '')),
                        react.createElement("p", (0,_tslib/* __assign */.pi)({ className: "error-message ".concat(JobAlert_module_scss_styles.errorMessage) }, (isEmailValid ? { hidden: true } : '')), (0,helpers.t)('This is not a valid email address', language)))),
                isMobile ? (react.createElement("div", { className: JobAlert_module_scss_styles.footer },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.flexCenter },
                        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.colSmall6, " ").concat(JobAlert_module_scss_styles.colBottomRight) },
                            react.createElement("div", null,
                                react.createElement(Button/* default */.Z, { type: 'primary', size: 'sm', className: 'SJ_SaveSendJob', onClick: handleOnClickSaveUserEmail, style: { float: 'right' } }, (0,helpers.t)('Send me jobs', language)),
                                react.createElement(Button/* default */.Z, { size: 'sm', style: { marginRight: 10 }, onClick: handleOnClickClose }, (0,helpers.t)('Cancel', language))))))) : (react.createElement(react.Fragment, null))))),
        react.createElement(Dialog, { title: (0,helpers.t)('Delete this Job Alert?', language), isOpen: isDeleteConfirmOpen, onBack: function () { return setDeleteConfirmOpen(false); }, onClickAction: handleOnClickDelete, type: 'delete', deleteText: (0,helpers.t)('Remove', language), secondaryButtonText: (0,helpers.t)('Cancel', language), backdrop: true },
            react.createElement("div", null, (0,helpers.t)('You will not be able to receive email for job alert', language))),
        react.createElement(Dialog, { title: (0,helpers.t)('Discard this job alert?', language), isOpen: isAskCloseWithoutSave, onBack: function () { return setAskCloseWithoutSaveOpen(false); }, onClickAction: handleOnClickCloseAskSave, type: 'delete', deleteText: (0,helpers.t)('Yes', language), secondaryButtonText: (0,helpers.t)('No', language), backdrop: true },
            react.createElement("div", null, (0,helpers.t)('This job alert will not be saved', language)))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/JobYouWillLove.css.js
'use client';




var JobYouWillLove_css_Container = styled_components_browser_esm/* default.div */.ZP.div(JobYouWillLove_css_templateObject_1 || (JobYouWillLove_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    line-height: 1.2;\n"], ["\n    width: 100%;\n    line-height: 1.2;\n"])));
var JobYouWillLove_css_Title = styled_components_browser_esm/* default.div */.ZP.div(JobYouWillLove_css_templateObject_2 || (JobYouWillLove_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    margin-bottom: 16px;\n"], ["\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    margin-bottom: 16px;\n"])));
var JobYouWillLove_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(JobYouWillLove_css_templateObject_3 || (JobYouWillLove_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    background-color: white;\n    padding: 16px;\n    border-radius: 12px;\n"], ["\n    width: 100%;\n    background-color: white;\n    padding: 16px;\n    border-radius: 12px;\n"])));
var ListJob = styled_components_browser_esm/* default.div */.ZP.div(JobYouWillLove_css_templateObject_6 || (JobYouWillLove_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    ", "\n"])), function (_a) {
    var gridColumn = _a.gridColumn;
    return (0,styled_components_browser_esm/* css */.iv)(JobYouWillLove_css_templateObject_4 || (JobYouWillLove_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n\n        > div {\n            width: calc((100% - 16px * ", ") / ", ");\n        }\n    "], ["\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n\n        > div {\n            width: calc((100% - 16px * ", ") / ", ");\n        }\n    "])), (gridColumn || 1) - 1, gridColumn || 1);
}, function (_a) {
    var gridMobileColumn = _a.gridMobileColumn;
    return gridMobileColumn && (0,styled_components_browser_esm/* css */.iv)(JobYouWillLove_css_templateObject_5 || (JobYouWillLove_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            @media (max-width: 768px) {\n                > div {\n                    width: calc((100% - 16px * ", ") / ", ");\n                }\n            }\n        "], ["\n            @media (max-width: 768px) {\n                > div {\n                    width: calc((100% - 16px * ", ") / ", ");\n                }\n            }\n        "])), (gridMobileColumn || 1) - 1, gridMobileColumn || 1);
});
var JobYouWillLove_css_templateObject_1, JobYouWillLove_css_templateObject_2, JobYouWillLove_css_templateObject_3, JobYouWillLove_css_templateObject_4, JobYouWillLove_css_templateObject_5, JobYouWillLove_css_templateObject_6;


//# sourceMappingURL=JobYouWillLove.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/services.js
var services = __webpack_require__(39668);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/translations.js
'use client';

/* eslint-disable prettier/prettier */
var JobYouWillLove_translations_translations = {
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    'Undo': 'Hoàn tác',
    'Jobs You Will Love': 'Việc Làm Bạn Sẽ Thích',
    'Apply All Jobs': 'Nộp Đơn Tất Cả',
    'apply-multiple-jobs': 'ung-tuyen-nhieu-viec-lam',
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/constants.js
var LayoutSystem_constants = __webpack_require__(61032);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/JobCardMini.css.js
'use client';








var JobCardMini_css_Container = styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_1 || (JobCardMini_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    background-color: white;\n    border: 1px solid #f1f1f1;\n    border-radius: 12px;\n    padding: 16px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    transition: all 0.25s;\n\n    &:hover {\n        background: #f9fbff;\n        border: 1px solid #cfe0ff;\n    }\n"], ["\n    width: 100%;\n    background-color: white;\n    border: 1px solid #f1f1f1;\n    border-radius: 12px;\n    padding: 16px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    transition: all 0.25s;\n\n    &:hover {\n        background: #f9fbff;\n        border: 1px solid #cfe0ff;\n    }\n"])));
var Logo = styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_2 || (JobCardMini_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: white;\n    border-radius: 12px;\n    width: 86px;\n    height: 86px;\n    padding: 4px;\n    flex: 0 0 86px;\n\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: contain;\n    }\n"], ["\n    background-color: white;\n    border-radius: 12px;\n    width: 86px;\n    height: 86px;\n    padding: 4px;\n    flex: 0 0 86px;\n\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: contain;\n    }\n"])));
var SettingContainer = styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_3 || (JobCardMini_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    height: 100%;\n"], ["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    height: 100%;\n"])));
var SettingWrapper = styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_5 || (JobCardMini_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: 0;\n    transition: 0.25s;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 100%;\n\n    ", ":hover & {\n        opacity: 1;\n    }\n\n    ", "\n"], ["\n    opacity: 0;\n    transition: 0.25s;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 100%;\n\n    ", ":hover & {\n        opacity: 1;\n    }\n\n    ", "\n"])), JobCardMini_css_Container, function (_a) {
    var isShow = _a.isShow;
    return isShow && (0,styled_components_browser_esm/* css */.iv)(JobCardMini_css_templateObject_4 || (JobCardMini_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            opacity: 1;\n        "], ["\n            opacity: 1;\n        "])));
});
var Desc = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_6 || (JobCardMini_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        min-width: 0;\n\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    "], ["\n        width: 100%;\n        min-width: 0;\n\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    "]))),
    Title: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_7 || (JobCardMini_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        h3 {\n            display: flex;\n            align-items: center;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 20px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            margin: 0;\n        }\n        a {\n            color: ", ";\n            transition: all 0.25s;\n            &:hover {\n                color: ", ";\n            }\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n        }\n    "], ["\n        h3 {\n            display: flex;\n            align-items: center;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 20px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            margin: 0;\n        }\n        a {\n            color: ", ";\n            transition: all 0.25s;\n            &:hover {\n                color: ", ";\n            }\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n        }\n    "])), constants/* colors.textColor */.O9.textColor, constants/* colors.buttonColor */.O9.buttonColor),
    SubTitle: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_8 || (JobCardMini_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 14px;\n        line-height: 18px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        color: rgb(51, 51, 51) !important;\n\n        a {\n            transition: all 0.25s;\n            color: rgb(51, 51, 51);\n            &:hover {\n                color: ", ";\n            }\n        }\n    "], ["\n        font-size: 14px;\n        line-height: 18px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        color: rgb(51, 51, 51) !important;\n\n        a {\n            transition: all 0.25s;\n            color: rgb(51, 51, 51);\n            &:hover {\n                color: ", ";\n            }\n        }\n    "])), constants/* colors.buttonColor */.O9.buttonColor),
    Salary: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_9 || (JobCardMini_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 14px;\n        line-height: 18px;\n        font-weight: 500;\n        color: ", ";\n    "], ["\n        font-size: 14px;\n        line-height: 18px;\n        font-weight: 500;\n        color: ", ";\n    "])), constants/* colors.buttonColor */.O9.buttonColor)
};
var Hide = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_10 || (JobCardMini_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        height: 86px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n    "], ["\n        height: 86px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n    "]))),
    Info: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_11 || (JobCardMini_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""]))),
    Title: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_12 || (JobCardMini_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-weight: 500;\n        font-size: 16px;\n    "], ["\n        font-weight: 500;\n        font-size: 16px;\n    "]))),
    Text: styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_13 || (JobCardMini_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-top: 8px;\n        font-size: 14px;\n        line-height: 18px;\n    "], ["\n        margin-top: 8px;\n        font-size: 14px;\n        line-height: 18px;\n    "])))
};
var SalaryLocationWrapper = styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_14 || (JobCardMini_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    .line-break {\n        display: none;\n        height: 14px;\n        width: 1px;\n        background-color: rgb(201, 201, 201);\n    }\n    @media screen and (min-width: ", "px) {\n        flex-direction: row;\n        align-items: center;\n        gap: 6px;\n        .line-break {\n            display: block;\n        }\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    .line-break {\n        display: none;\n        height: 14px;\n        width: 1px;\n        background-color: rgb(201, 201, 201);\n    }\n    @media screen and (min-width: ", "px) {\n        flex-direction: row;\n        align-items: center;\n        gap: 6px;\n        .line-break {\n            display: block;\n        }\n    }\n"])), LayoutSystem_constants/* BREAKPOINTS.sm */.j$.sm);
styled_components_browser_esm/* default.div */.ZP.div(JobCardMini_css_templateObject_15 || (JobCardMini_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    [data-cname='preview-job'] {\n        width: calc(100% - 24px);\n        h3 {\n            margin-bottom: 0;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    [data-cname='preview-job'] {\n        width: calc(100% - 24px);\n        h3 {\n            margin-bottom: 0;\n        }\n    }\n"])));
styled_components_browser_esm/* default.span */.ZP.span(JobCardMini_css_templateObject_16 || (JobCardMini_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 400;\n"], ["\n    font-weight: 400;\n"])));
var JobCardMini_css_templateObject_1, JobCardMini_css_templateObject_2, JobCardMini_css_templateObject_3, JobCardMini_css_templateObject_4, JobCardMini_css_templateObject_5, JobCardMini_css_templateObject_6, JobCardMini_css_templateObject_7, JobCardMini_css_templateObject_8, JobCardMini_css_templateObject_9, JobCardMini_css_templateObject_10, JobCardMini_css_templateObject_11, JobCardMini_css_templateObject_12, JobCardMini_css_templateObject_13, JobCardMini_css_templateObject_14, JobCardMini_css_templateObject_15, JobCardMini_css_templateObject_16;


//# sourceMappingURL=JobCardMini.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SettingJob/index.js + 2 modules
var SettingJob = __webpack_require__(67366);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/constant.js
'use client';

var DEFAULT_JOB_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/type.js
'use client';

var EVariant;
(function (EVariant) {
    EVariant["PRIMARY"] = "PRIMARY";
    EVariant["SECONDARY"] = "SECONDARY";
})(EVariant || (EVariant = {}));


//# sourceMappingURL=type.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/BadgeTag/index.js + 8 modules
var BadgeTag = __webpack_require__(25139);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/translations.js
'use client';

var JobCardMini_translations_translations = {
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    Undo: 'Hoàn tác',
    'Accept invitation': 'Chấp nhận lời mời',
    'Invited by employer': 'Được mời ứng tuyển'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/SkillTag/SkillTag.css.js
'use client';




var ListItem = styled_components_browser_esm/* default.ul */.ZP.ul(SkillTag_css_templateObject_1 || (SkillTag_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-flow: row wrap;\n    margin-left: -2px;\n    margin-right: -2px;\n    margin-top: -4px;\n    list-style: none;\n    margin-bottom: 0;\n    padding: 0;\n    width: fit-content;\n"], ["\n    display: flex;\n    flex-flow: row wrap;\n    margin-left: -2px;\n    margin-right: -2px;\n    margin-top: -4px;\n    list-style: none;\n    margin-bottom: 0;\n    padding: 0;\n    width: fit-content;\n"])));
var SkillTag_css_Item = styled_components_browser_esm/* default.li */.ZP.li(SkillTag_css_templateObject_2 || (SkillTag_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 2px;\n    padding-right: 2px;\n    margin-top: 4px;\n"], ["\n    padding-left: 2px;\n    padding-right: 2px;\n    margin-top: 4px;\n"])));
var SkillTagWrapper = styled_components_browser_esm/* default.div */.ZP.div(SkillTag_css_templateObject_3 || (SkillTag_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
var SkillTag_css_templateObject_1, SkillTag_css_templateObject_2, SkillTag_css_templateObject_3;


//# sourceMappingURL=SkillTag.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(41524);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Tag/index.js + 2 modules
var components_Tag = __webpack_require__(149);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SimpleTooltip/index.js + 2 modules
var SimpleTooltip = __webpack_require__(17068);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/SkillTag/index.js
'use client';













var LIMIT_ITEMS = 3;
var LIMIT_RATIO = 0.8;
var SkillTag = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b;
    var _c = (0,react.useState)(data ? data.filter(function (item) { return item; }) : []), listSkills = _c[0], setListSkills = _c[1];
    var _d = (0,react.useState)([]), hiddenSkills = _d[0], setHiddenSkills = _d[1];
    var containerRef = (0,react.useRef)(null);
    var isComplete = (0,react.useRef)(false);
    var handleSliceData = function (data, to, limit) {
        var cloneData = (0,_tslib/* __spreadArray */.ev)([], data, true);
        var listSkills = cloneData.slice(0, to);
        var hiddenSkills = cloneData.slice(to, limit);
        setListSkills(listSkills);
        setHiddenSkills(hiddenSkills);
        isComplete.current = true;
    };
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        var _a;
        if (!(0,responsiveHelper/* isPhone */.Mn)())
            return;
        var filtedData = data ? data.filter(function (item) { return item; }) : [];
        if (!isComplete.current) {
            if (containerRef && containerRef.current) {
                var containerElement = containerRef.current;
                var containerWidth = containerElement.getBoundingClientRect().width;
                var parentWidth = ((_a = containerElement.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
                var limitWidth_1 = parentWidth * LIMIT_RATIO;
                if (containerWidth > limitWidth_1) {
                    var validWidth_1 = 0;
                    var validChildren_1 = 0;
                    Array.from(containerElement.childNodes).some(function (children) {
                        if (validWidth_1 > limitWidth_1) {
                            return true;
                        }
                        validWidth_1 += children.clientWidth;
                        validChildren_1++;
                        if (validChildren_1 > LIMIT_ITEMS)
                            return true;
                        return false;
                    });
                    handleSliceData(filtedData, validChildren_1 - 1, filtedData.length);
                    return;
                }
                if (filtedData.length > LIMIT_ITEMS) {
                    handleSliceData(filtedData, LIMIT_ITEMS, filtedData.length);
                }
            }
        }
    }, [data]);
    var renderHiddenSkillText = hiddenSkills.map(function (skill) { return skill; }).join(', ');
    return (react.createElement(ListItem, { ref: containerRef },
        listSkills.map(function (skill, index) {
            return (react.createElement(SkillTag_css_Item, { key: "".concat(skill, "_").concat(index) },
                react.createElement(components_Tag/* default */.Z, { maxWidth: (0,responsiveHelper/* isPhone */.Mn)() ? 'unset' : '150px', size: 'extra-small', label: skill, isMobile: false, readOnly: true, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792'
                    } })));
        }),
        hiddenSkills.length > 0 && (react.createElement(SkillTag_css_Item, { key: 'hidden-skills' },
            react.createElement(SimpleTooltip/* default */.Z, { content: renderHiddenSkillText, referenceElement: react.createElement(components_Tag/* default */.Z, { size: 'extra-small', label: "+".concat(hiddenSkills.length), isMobile: false, readOnly: true, enableTooltip: false, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792'
                    } }) })))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/JobCard.css.js
var JobCard_css = __webpack_require__(8203);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MailAddIcon/index.js
var MailAddIcon = __webpack_require__(29082);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/types.js
var ApplyJobs_types = __webpack_require__(36615);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMini/index.js
'use client';


















var PreviewJobWrapper = function (_a) {
    var children = _a.children, props = (0,_tslib/* __rest */._T)(_a, ["children"]);
    var langCode = props.langCode, setShowPopup = props.setShowPopup, api = props.api, isApplied = props.isApplied, isBlackList = props.isBlackList, redirectTo = props.redirectTo, previewJob = props.previewJob, isMobile = props.isMobile, isNldPage = props.isNldPage, jobId = props.jobId, jobLogo = props.jobLogo, jobTitle = props.jobTitle, prettySalary = props.prettySalary, jobLevelText = props.jobLevelText, address = props.address, jobDescription = props.jobDescription, jobRequirement = props.jobRequirement, jobUrl = props.jobUrl, isSaved = props.isSaved, jobInvitation = props.jobInvitation;
    return (previewJob === null || previewJob === void 0 ? void 0 : previewJob.enable) && !isMobile ? (react.createElement(PreviewJob/* default */.Z, { isNLDPage: isNldPage, content: {
            jobId: jobId,
            logo: jobLogo,
            title: jobTitle,
            salary: prettySalary || '',
            jobLevel: jobLevelText,
            address: address,
            jobDescription: jobDescription,
            jobRequirements: jobRequirement,
            link: jobUrl,
            isSaved: !!isSaved,
            isApplied: !!isApplied,
            isBlackList: !!isBlackList,
            redirectTo: redirectTo || '',
            jobInvitation: jobInvitation
        }, api: {
            accessToken: api.accessToken,
            baseUrl: api.baseUrl
        }, onApplyClick: function () { return setShowPopup(true); }, langCode: langCode, isLogin: !!api.accessToken }, children)) : (react.createElement(react.Fragment, null, children));
};
var JobCardMini = function (props) {
    var _a, _b, _c, _d, _e;
    var item = props.item, langCode = props.langCode, api = props.api, previewJob = props.previewJob, displayOptions = props.displayOptions, settingJob = props.settingJob, isMobile = props.isMobile, _f = props.classSelector, classSelector = _f === void 0 ? 'top_recommend' : _f, userInfo = props.userInfo, _g = props.isNldPage, isNldPage = _g === void 0 ? false : _g;
    var isAnonymous = item.isAnonymous, company = item.company, companyLogo = item.companyLogo, companyUrl = item.companyUrl, jobDescription = item.jobDescription, jobId = item.jobId, jobLevelText = item.jobLevelText, jobRequirement = item.jobRequirement, jobTitle = item.jobTitle, jobUrl = item.jobUrl, locationText = item.locationText, prettySalary = item.prettySalary, address = item.address, isApplied = item.isApplied, isBlackList = item.isBlackList, isSaved = item.isSaved, redirectTo = item.redirectTo, skills = item.skills;
    var _h = (0,react.useState)(false), isHideJob = _h[0], setHideJob = _h[1];
    var _j = (0,react.useState)(false), showPopup = _j[0], setShowPopup = _j[1];
    var _k = (0,react.useState)(false), showSettingJob = _k[0], setShowSettingJob = _k[1];
    var settingJobRef = (0,react.useRef)(null);
    var jobLogo = companyLogo && !isAnonymous ? companyLogo : DEFAULT_JOB_IMAGE;
    var showCompanyUrl = isAnonymous ? '' : companyUrl;
    var formatLocationText = String(locationText)
        .split(', ')
        .filter(function (item, index, self) { return self.indexOf(item) === index; })
        .join(', ');
    var previewJobProps = {
        langCode: langCode,
        setShowPopup: setShowPopup,
        api: api,
        isApplied: isApplied,
        isBlackList: isBlackList,
        redirectTo: redirectTo,
        previewJob: previewJob,
        isMobile: isMobile,
        isNldPage: isNldPage,
        jobId: jobId,
        jobLogo: jobLogo,
        jobTitle: jobTitle,
        prettySalary: prettySalary,
        jobLevelText: jobLevelText,
        address: address,
        jobDescription: jobDescription,
        jobRequirement: jobRequirement,
        jobUrl: jobUrl,
        isSaved: isSaved,
        jobInvitation: props.item.jobInvitation
    };
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return JobCardMini_translations_translations[key] || key;
        }
    };
    var isHaveJobInvitation = item.jobInvitation &&
        ((_a = item.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 &&
        ((_b = item.jobInvitation) === null || _b === void 0 ? void 0 : _b.status) === ApplyJobs_types/* EJobInvitationStatus.WAITING */.Z.WAITING;
    return (react.createElement(JobCardMini_css_Container, { className: classSelector }, isHideJob ? (react.createElement(Hide.Container, null,
        react.createElement(Hide.Info, null,
            react.createElement(Hide.Title, null, t('Job hidden')),
            react.createElement(Hide.Text, null, t('You will not see this job on the search page.'))),
        react.createElement("div", null,
            react.createElement(SettingJob/* default */.Z, { api: api, jobId: jobId, langCode: langCode, onHideJobClick: function () { return setHideJob(false); }, isHide: isHideJob })))) : (react.createElement(react.Fragment, null,
        react.createElement(Logo, null,
            react.createElement("img", { src: jobLogo, alt: 'logo', loading: 'lazy' })),
        react.createElement(Desc.Container, null,
            react.createElement(PreviewJobWrapper, (0,_tslib/* __assign */.pi)({}, previewJobProps),
                react.createElement(Desc.Title, null,
                    react.createElement("h3", { style: { fontSize: '18px' } },
                        isHaveJobInvitation ? (react.createElement(JobCard_css/* JobInvitationIcon */.YZ, null,
                            react.createElement(MailAddIcon/* default */.Z, { width: 20, height: 20 }))) : null,
                        react.createElement("a", { href: jobUrl, target: isMobile ? '_self' : '_blank' }, jobTitle)))),
            react.createElement(Desc.SubTitle, null, showCompanyUrl ? (react.createElement(react.Fragment, null,
                react.createElement("a", { target: isMobile ? '_self' : '_blank', href: showCompanyUrl }, company))) : (company)),
            (settingJob === null || settingJob === void 0 ? void 0 : settingJob.variant) === EVariant.SECONDARY ? (react.createElement(SalaryLocationWrapper, null,
                react.createElement(Desc.Salary, null, prettySalary),
                react.createElement("span", { className: 'line-break' }),
                react.createElement(Desc.SubTitle, null, formatLocationText))) : (react.createElement(react.Fragment, null,
                react.createElement(Desc.Salary, null, prettySalary),
                react.createElement(Desc.SubTitle, null, formatLocationText))),
            (settingJob === null || settingJob === void 0 ? void 0 : settingJob.isShowSkills) && skills && skills.length > 0 && !isMobile ? (react.createElement(SkillTagWrapper, null,
                react.createElement(SkillTag, { data: skills }))) : null),
        react.createElement(SettingContainer, null,
            (displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.isHot) ? (react.createElement(BadgeTag/* default */.Z, { type: 'Hot', langCode: langCode })) : (react.createElement("div", { style: { height: '100%' } })),
            !isNldPage && (previewJob === null || previewJob === void 0 ? void 0 : previewJob.enable) ? (react.createElement(SettingWrapper, { isShow: isMobile ? true : showSettingJob },
                react.createElement(SettingJob/* default */.Z, { ref: settingJobRef, type: 'horizontal', showPopupType: settingJob === null || settingJob === void 0 ? void 0 : settingJob.showType, api: api, jobId: jobId, langCode: langCode, onHideJobClick: function () { return setHideJob(true); }, onShowChange: function (e) { return setShowSettingJob(e); }, isHide: isHideJob }))) : null,
            !isNldPage && !isMobile ? (react.createElement(ApplyJobs/* default */.ZP, { accessToken: (_c = api === null || api === void 0 ? void 0 : api.accessToken) !== null && _c !== void 0 ? _c : '', isOpen: showPopup, langCode: langCode, user: userInfo, jobInfo: (0,_tslib/* __assign */.pi)({}, props.item), baseMsUrl: (_d = api.baseUrl) !== null && _d !== void 0 ? _d : '', baseUrl: (_e = previewJob === null || previewJob === void 0 ? void 0 : previewJob.baseUrl) !== null && _e !== void 0 ? _e : '', initData: props.initData, onClose: function () { return setShowPopup(false); } })) : null)))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/index.js
'use client';













var JobYouWillLove = function (props) {
    var typeOptions = props.typeOptions, api = props.api, langCode = props.langCode, utmType = props.utmType, utmString = props.utmString, robot = props.robot, previewJob = props.previewJob, _a = props.title, title = _a === void 0 ? '' : _a, isMobile = props.isMobile, isShowApplyAll = props.isShowApplyAll, _b = props.classSelector, classSelector = _b === void 0 ? '' : _b, titleNode = props.titleNode, userInfo = props.userInfo, _c = props.ignoreJobIds, ignoreJobIds = _c === void 0 ? [] : _c, getJobIdsProps = props.getJobIds, _d = props.enableTrackingImpression, enableTrackingImpression = _d === void 0 ? false : _d, _e = props.trackingImpressionSection, trackingImpressionSection = _e === void 0 ? 'none' : _e, _f = props.trackingData, trackingData = _f === void 0 ? null : _f;
    var _g = (0,react.useState)(true), loading = _g[0], setLoading = _g[1];
    var _h = (0,react.useState)({
        jobs: [],
        source: ''
    }), data = _h[0], setData = _h[1];
    var isCalledTracking = (0,react.useRef)(false);
    var _j = (0,react.useState)(null), jobYouWillLoveWrapperState = _j[0], setJobRef = _j[1];
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: jobYouWillLoveWrapperState,
        options: {
            isUseReactRef: false,
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var isLoading = (robot === null || robot === void 0 ? void 0 : robot.enable) ? false : loading;
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return JobYouWillLove_translations_translations[key] || key;
        }
    };
    var createdUtm = function (type, source) {
        switch (type) {
            case 'my-profile':
                return "/?utm_source_navi=CareerCenter&utm_medium_navi=MyProfile&utm_campaign_navi=JobsYouWillLove&utm_content_navi=".concat(source, "&utm_term_navi=VB");
            case 'job-detail':
                return "/?utm_source_navi=jobalertemail&utm_medium_navi=JobDescription&utm_campaign_navi=PeopleAlsoView&utm_content_navi=".concat(source, "&utm_term_navi=VB");
            case 'job-detail-right-corner':
                return "/?utm_source_navi=jobdetail&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
            case 'event':
                return "/?utm_source_navi=eventPage&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
            case 'competitive':
                return "?utm_source_navi=competitive&utm_medium_navi=job-will-love&utm_campaign_navi=result&utm_content_navi=".concat(source);
            case 'single-success-apply':
                return "?utm_source_navi=success-apply-single&utm_medium_navi=job-will-love&utm_campaign_navi=bottom&utm_content_navi=".concat(source);
            default:
                return utmString ? "".concat(utmString, "&utm_content_navi=").concat(source) : '';
        }
    };
    var formatJobs = function (jobs, source, ignoreJobIds) {
        var jobUnIgnore = (jobs || []).filter(function (job) { return !ignoreJobIds.includes(job.jobId); });
        return jobUnIgnore.map(function (item) {
            var locationText = '';
            if (item.workingLocations) {
                locationText = (item.workingLocations || [])
                    .map(function (item) { return (langCode === constants/* ELanguage.VI */.Df.VI ? item.cityNameVI : item.cityName); })
                    .join(', ');
            }
            else if (item.locations) {
                locationText =
                    langCode === constants/* ELanguage.VI */.Df.VI ? item.locations['1'].join(', ') : item.locations['2'].join(', ');
            }
            return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { jobTitle: item.jobTitle, jobId: item.jobId, jobUrl: item.jobLink ||
                    (0,urlBuilder/* buildJobUrl */.Ty)({
                        alias: item.alias,
                        jobId: item.jobId,
                        langCode: langCode,
                        utm: createdUtm(utmType || '', source)
                    }), companyLogo: item.companyLogo, company: item.company, companyUrl: (0,urlBuilder/* buildCompanyUrl */.kQ)({ companyId: item.companyId, companySlug: item.company, langCode: langCode }), jobLevelText: langCode === constants/* ELanguage.VI */.Df.VI ? item.jobLevelVI : item.jobLevel, jobLevelId: item.jobLevelId, address: item.address, jobDescription: item.jobDescription, jobRequirement: item.jobRequirement, isAnonymous: item.isAnonymous, locationText: locationText, prettySalary: item.prettySalary });
        });
    };
    var getJobs = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var clientIP, query, response, data, newData, jobs_1;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    clientIP = '';
                    if (typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'string') {
                        clientIP = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP;
                    }
                    else if ((trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) &&
                        typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'object' &&
                        (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP.length) > 0) {
                        clientIP = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === null || _a === void 0 ? void 0 : _a.join(',');
                    }
                    query = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ jobId: '0' }, api.query), { clientIP: clientIP });
                    if (trackingImpressionSection !== 'none') {
                        query.section = trackingImpressionSection;
                    }
                    return [4 /*yield*/, (0,services/* getJobYouWillLove */.SX)({
                            baseUrl: api.baseUrl,
                            langCode: langCode,
                            query: query,
                            smartNaviVersion: api.smartNaviVersion || 'v2',
                            formDataExcludeJobIds: api.formDataExcludeJobIds
                        })];
                case 1:
                    response = _b.sent();
                    data = response.data;
                    newData = formatJobs(data.jobs, data.source, ignoreJobIds);
                    if (!((api === null || api === void 0 ? void 0 : api.accessToken) && newData.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0,services/* getSpecialJob */.nL)({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: newData
                        })];
                case 2:
                    jobs_1 = (_b.sent()).data;
                    setData({
                        jobs: jobs_1,
                        source: data.source
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setData({
                        jobs: newData,
                        source: data.source
                    });
                    _b.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var memoJobIds = (0,react.useMemo)(function () {
        if (!data.jobs || data.jobs.length < 1)
            return null;
        var jobIds = data.jobs.map(function (job) {
            return job.jobId;
        });
        return jobIds;
    }, [data.jobs]);
    (0,react.useEffect)(function () {
        if (!(robot === null || robot === void 0 ? void 0 : robot.enable)) {
            getJobs();
        }
    }, []);
    (0,react.useEffect)(function () {
        var _a, _b, _c;
        if (!isElementOnScreen || !enableTrackingImpression || isCalledTracking.current) {
            return;
        }
        var clientIP = '';
        if (typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'string') {
            clientIP = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP;
            var splittedClientIPs = clientIP.split(',').map(function (ip) { return ip.trim(); });
            var filterPublic = (0,helpers/* filterPrivateIP */.zD)(splittedClientIPs);
            clientIP = filterPublic.length > 0 ? filterPublic[0] : clientIP;
        }
        else if ((trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) &&
            typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'object' &&
            (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP.length) > 0) {
            var filterPublic = (0,helpers/* filterPrivateIP */.zD)(trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP);
            clientIP = filterPublic.length > 0 ? filterPublic[0] : (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === null || _a === void 0 ? void 0 : _a.join(',');
        }
        var jobIds = data.jobs.map(function (jobItem) { return jobItem.jobId; });
        (0,services/* trackImpression */.hX)({
            baseMsUrl: api.baseUrl,
            langCode: langCode,
            body: {
                section: trackingImpressionSection,
                jobRecommend: jobIds,
                version: data.source,
                clientIP: clientIP,
                jobID: (_b = trackingData === null || trackingData === void 0 ? void 0 : trackingData.jobID) !== null && _b !== void 0 ? _b : -1,
                userID: (_c = trackingData === null || trackingData === void 0 ? void 0 : trackingData.userID) !== null && _c !== void 0 ? _c : ''
            }
        });
        isCalledTracking.current = true;
    }, [jobYouWillLoveWrapperState, isLoading, isElementOnScreen, data, enableTrackingImpression, isCalledTracking]);
    (0,react.useEffect)(function () {
        if (memoJobIds && (memoJobIds === null || memoJobIds === void 0 ? void 0 : memoJobIds.length) > 0) {
            getJobIdsProps && getJobIdsProps(memoJobIds);
        }
    }, [memoJobIds, getJobIdsProps]);
    var titleSection = title || t('Jobs You Will Love');
    var jobs = (robot === null || robot === void 0 ? void 0 : robot.enable) ? formatJobs(robot === null || robot === void 0 ? void 0 : robot.data, (robot === null || robot === void 0 ? void 0 : robot.source) || '', ignoreJobIds) : data.jobs;
    return !isLoading && jobs && (jobs === null || jobs === void 0 ? void 0 : jobs.length) > 0 ? (react.createElement(JobYouWillLove_css_Container, { className: 'job-you-will-love', ref: function (ref) { return setJobRef(ref); } },
        react.createElement(JobYouWillLove_css_Wrapper, { className: 'jobs-section' },
            titleNode || react.createElement(JobYouWillLove_css_Title, { className: 'title' }, titleSection),
            react.createElement(ListJob, { gridColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridColumn, gridMobileColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridMobileColumn, isMobile: isMobile }, jobs.map(function (item, idx) {
                var _a;
                return (react.createElement(JobCardMini, { key: idx, isMobile: isMobile, item: item, langCode: langCode, api: api, previewJob: previewJob, classSelector: classSelector, userInfo: userInfo, settingJob: {
                        isShowSkills: (_a = typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.isShowSkill) !== null && _a !== void 0 ? _a : false,
                        variant: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.variant
                    }, initData: props.initData }));
            })),
            isShowApplyAll && data.jobs.length > 0 && (react.createElement(Button/* default */.Z, { type: 'outline', onClick: function () {
                    return (window.location.href =
                        "".concat(window.location.origin, "/").concat(t('apply-multiple-jobs')) +
                            '/' +
                            data.jobs.map(function (item) { return item.jobId; }).join('_') +
                            createdUtm(utmType || '', data.source));
                }, style: { marginTop: 16, marginLeft: 'auto', display: 'block' } }, t('Apply All Jobs')))))) : (react.createElement(react.Fragment, null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/service.js
'use client';



var getLinkedInStatus = function (url, accessToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET',
                    headers: {
                        Authorization: "Bearer ".concat(accessToken),
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var uploadLinkedIn = function (url, accessToken, file, resumeId, lang) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var formData, response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                formData.append('resumeId', String(resumeId));
                formData.append('file', file);
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': lang
                        },
                        body: formData
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var postLinkedIn = function (url, postData, apiTokenAccess) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    headers: {
                        Authorization: "Bearer ".concat(apiTokenAccess),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(postData)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var makeLinkedIn = function (url, apiTokenAccess, lang, resumeId) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    headers: {
                        Authorization: "Bearer ".concat(apiTokenAccess),
                        'Content-Type': 'application/json',
                        'Accept-Language': lang
                    },
                    body: JSON.stringify({
                        resumeId: resumeId,
                        LinkedIn: 1
                    })
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var checkLinkedInAvailable = function (url, accessToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET',
                    headers: {
                        Authorization: "Bearer ".concat(accessToken),
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var service_apiServices = {
    postLinkedIn: postLinkedIn,
    makeLinkedIn: makeLinkedIn,
    getLinkedInStatus: getLinkedInStatus,
    checkLinkedInAvailable: checkLinkedInAvailable,
    uploadLinkedIn: uploadLinkedIn
};


//# sourceMappingURL=service.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/styles.js
'use client';






var styles_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(LinkedIn_styles_templateObject_1 || (LinkedIn_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #333333;\n"], ["\n    color: #333333;\n"])));
var AlertContent = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_2 || (styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding-right: 25px;\n    font-weight: bold;\n    color: #ff4a53;\n"], ["\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding-right: 25px;\n    font-weight: bold;\n    color: #ff4a53;\n"])));
var AlertContentText = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_3 || (styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 10px;\n"], ["\n    margin-left: 10px;\n"])));
var AlertCancel = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_4 || (styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n    cursor: pointer;\n"])));
var styles_Container = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_5 || (styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid #ebebeb;\n    border-radius: 5px;\n    display: flex;\n    background-color: ", ";\n"], ["\n    border: 1px solid #ebebeb;\n    border-radius: 5px;\n    display: flex;\n    background-color: ", ";\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return bgColor || 'white';
});
var ContainerImage = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_7 || (styles_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 120px;\n    position: relative;\n\n    ", "\n"], ["\n    width: 120px;\n    position: relative;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_6 || (styles_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: none;\n    "], ["\n        display: none;\n    "]))));
var ContainerSvgImage = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_8 || (styles_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 120px;\n    position: absolute;\n"], ["\n    display: flex;\n    width: 120px;\n    position: absolute;\n"])));
var ContainerContent = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_10 || (styles_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    flex: 1;\n    padding: 15px 30px 15px 0;\n\n    ", "\n"], ["\n    position: relative;\n    flex: 1;\n    padding: 15px 30px 15px 0;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_9 || (styles_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 10px;\n    "], ["\n        padding: 10px;\n    "]))));
var ContentTitle = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_12 || (styles_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 600;\n\n    ", "\n"], ["\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 600;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_11 || (styles_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding-right: 30px;\n    "], ["\n        padding-right: 30px;\n    "]))));
var ContentDesc = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_13 || (styles_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 13px;\n    line-height: 18px;\n    margin: 10px 0;\n"], ["\n    font-size: 13px;\n    line-height: 18px;\n    margin: 10px 0;\n"])));
var ContentCVFile = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_14 || (styles_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-wrap: wrap;\n    min-height: 40px;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    min-height: 40px;\n"])));
var ContentTextWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_16 || (styles_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    background-color: #eaeaf0;\n    margin-right: 10px;\n    margin-top: 10px;\n    border-radius: 5px;\n    padding: 4px 5px;\n\n    ", "\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    background-color: #eaeaf0;\n    margin-right: 10px;\n    margin-top: 10px;\n    border-radius: 5px;\n    padding: 4px 5px;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_15 || (styles_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        margin-right: 0;\n    "], ["\n        margin-right: 0;\n    "]))));
var ContentNormalText = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_17 || (styles_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 4px 5px;\n"], ["\n    margin: 4px 5px;\n"])));
var ContentFileWrapper = styled_components_browser_esm/* default.p */.ZP.p(styles_templateObject_18 || (styles_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 5px 13px;\n    margin: 4px 5px;\n    border-radius: 25px;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 16px;\n    background-color: white;\n"], ["\n    padding: 5px 13px;\n    margin: 4px 5px;\n    border-radius: 25px;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 16px;\n    background-color: white;\n"])));
var ContentFileText = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_19 || (styles_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    white-space: nowrap;\n    max-width: 100px;\n    margin-left: 5px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    white-space: nowrap;\n    max-width: 100px;\n    margin-left: 5px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var ContentFileTail = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_20 || (styles_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var ContentButton = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_22 || (styles_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_21 || (styles_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        button {\n            width: 100%;\n        }\n    "], ["\n        button {\n            width: 100%;\n        }\n    "]))));
var ContainerCloseIcon = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_23 || (styles_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 10px;\n    top: 0;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 10px;\n    top: 0;\n    cursor: pointer;\n"])));
var SuccessUploadCV = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_25 || (styles_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    border: 1px solid #a3d67c;\n    border-radius: 5px;\n    background-color: rgba(227, 241, 211, 0.8);\n    padding: 10px 12px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n\n    ", "\n"], ["\n    position: relative;\n    border: 1px solid #a3d67c;\n    border-radius: 5px;\n    background-color: rgba(227, 241, 211, 0.8);\n    padding: 10px 12px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_24 || (styles_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        flex-direction: column;\n        text-align: center;\n        padding: 20px 10px;\n    "], ["\n        flex-direction: column;\n        text-align: center;\n        padding: 20px 10px;\n    "]))));
var SuccessText = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_27 || (styles_templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 10px;\n    padding-right: 50px;\n\n    ", "\n"], ["\n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 10px;\n    padding-right: 50px;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_26 || (styles_templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding-right: 0;\n        margin: 10px 30px 0 30px;\n    "], ["\n        padding-right: 0;\n        margin: 10px 30px 0 30px;\n    "]))));
var SuccessTextSpan = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_29 || (styles_templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    a {\n        text-decoration: none !important;\n    }\n\n    ", "\n"], ["\n    a {\n        text-decoration: none !important;\n    }\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_28 || (styles_templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: block;\n        margin-top: 10px;\n    "], ["\n        display: block;\n        margin-top: 10px;\n    "]))));
var SuccessLink = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject_30 || (styles_templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: bold;\n    color: ", ";\n    transition: 0.25s;\n    cursor: pointer;\n\n    :hover {\n        color: ", ";\n    }\n"], ["\n    font-weight: bold;\n    color: ", ";\n    transition: 0.25s;\n    cursor: pointer;\n\n    :hover {\n        color: ", ";\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor);
var CloseIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject_32 || (styles_templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    padding: 0 10px;\n    cursor: pointer;\n\n    ", "\n"], ["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    padding: 0 10px;\n    cursor: pointer;\n\n    ", "\n"])), (0,helpers/* isMobile */.tq)() && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject_31 || (styles_templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        top: 0;\n        transform: translateY(0);\n    "], ["\n        top: 0;\n        transform: translateY(0);\n    "]))));
var LinkedIn_styles_templateObject_1, styles_templateObject_2, styles_templateObject_3, styles_templateObject_4, styles_templateObject_5, styles_templateObject_6, styles_templateObject_7, styles_templateObject_8, styles_templateObject_9, styles_templateObject_10, styles_templateObject_11, styles_templateObject_12, styles_templateObject_13, styles_templateObject_14, styles_templateObject_15, styles_templateObject_16, styles_templateObject_17, styles_templateObject_18, styles_templateObject_19, styles_templateObject_20, styles_templateObject_21, styles_templateObject_22, styles_templateObject_23, styles_templateObject_24, styles_templateObject_25, styles_templateObject_26, styles_templateObject_27, styles_templateObject_28, styles_templateObject_29, styles_templateObject_30, styles_templateObject_31, styles_templateObject_32;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/translations.js
'use client';

var LinkedIn_translations_translations = {
    'my-profile': 'ho-so',
    Close: 'Đóng',
    'Import from LinkedIn': 'Nhập hồ sơ từ LinkedIn',
    'Import profile': 'Nhập hồ sơ',
    'Import again': 'Nhập lại',
    'Open LinkedIn': 'Đăng nhập LinkedIn',
    'Now upload your LinkedIn profile': 'Bây giờ tải lên hồ sơ LinkedIn của bạn',
    'Drag your file here': 'Kéo hồ sơ của bạn vào đây',
    'Or you can': 'Hoặc bạn có thể',
    'Choose file to upload': 'Chọn hồ sơ từ máy bạn',
    '.pdf files that are less than 5120KB in size': 'Hỗ trợ định dạng pdf có kích thước dưới 5120KB',
    'You can attach .pdf file that is less than 5120 KB in size.': 'Vui lòng chọn tập tin đính kèm với định dạng .pdf nhỏ hơn 5120KB.',
    'Profile imported:': 'Hồ sơ đã nhập:',
    'File uploading': 'Đang tải tệp hồ sơ lên',
    'Save time by importing your existing LinkedIn profile!': 'Tiết kiệm thời gian bằng cách nhập hồ sơ LinkedIn hiện có của bạn!',
    'Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.': 'Hồ sơ trên Linkedln của bạn đã được cập nhật thành công lên hồ sơ của VietnamWorks.',
    'Go to': 'Đi tới',
    'My Profile': '"Hồ sơ của tôi"',
    'to review your updated profile.': 'để xem lại hồ sơ cập nhật của bạn.',
    'You can attach .pdf files that are less than 5120KB in size.': 'Vui lòng chọn tập tin đính kèm với định dạng .pdf nhỏ hơn 5120KB.',
    'Something went wrong. Can not import data, please try again.': 'Có lỗi xảy ra không thể tự động điền dữ liệu. Vui lòng thử lại.',
    'It may take a few minutes to import the data...': 'Có thể mất vài phút để nhập dữ liệu ...',
    'Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.': '	Thông tin hồ sơ VietnamWorks sẽ được thay thế bằng thông tin từ tài khoản LinkedIn của bạn. Ví dụ: kỹ năng, học vấn, kinh nghiệm,… và bạn không thể hoàn tác.',
    'Save your LinkedIn profile as a': 'Đăng nhập vào tài khoản LinkedIn. Chọn',
    'PDF and upload it ': 'More → Save to PDF',
    'to VietnamWorks. Click the': '. Sau đó,',
    '"More..."': 'tải tệp PDF',
    'button on your LinkedIn profile.': 'lên VietnamWorks.',
    'Profile upload successful': 'Tải hồ sơ lên thành công',
    'Review profile': 'Xem lại hồ sơ',
    "Your LinkedIn profile has been updated to VietnamWorks's profile successfully.": 'Hồ sơ LinkedIn của bạn đã được cập nhật thành công trên VietnamWorks.'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/constants.js
'use client';

var FILE_UPLOAD_SIZE = 5120000;
var LOADING_STATUS = 2;
var FAIL_STATUS = 1;
var SUCCESS_STATUS = 3;
var INIT_STATUS = -1;


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/UploadDialog/styles.js
'use client';




var UploadDialog_styles_Container = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_1 || (UploadDialog_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #333;\n"], ["\n    color: #333;\n"])));
var UploadText = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_2 || (UploadDialog_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"], ["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"])));
var UploadDropFile = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_3 || (UploadDialog_styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: center;\n    margin: auto;\n    padding: 50px 10px;\n    border: 4px dashed ", ";\n    background-color: ", ";\n    border-radius: 6px;\n"], ["\n    text-align: center;\n    margin: auto;\n    padding: 50px 10px;\n    border: 4px dashed ", ";\n    background-color: ", ";\n    border-radius: 6px;\n"])), function (_a) {
    var isDragOver = _a.isDragOver;
    return (isDragOver ? 'rgba(247,148,29,1)' : '#ebebeb');
}, function (_a) {
    var isDragOver = _a.isDragOver;
    return (isDragOver ? '#f7951d44' : '#f9f9f9');
});
var DropFileIcon = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_4 || (UploadDialog_styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var DropFileInput = styled_components_browser_esm/* default.input */.ZP.input(UploadDialog_styles_templateObject_5 || (UploadDialog_styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: none !important;\n"], ["\n    display: none !important;\n"])));
var DropFileLabel = styled_components_browser_esm/* default.label */.ZP.label(UploadDialog_styles_templateObject_6 || (UploadDialog_styles_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 15px;\n    width: 100%;\n    font-weight: normal !important;\n"], ["\n    margin-top: 15px;\n    width: 100%;\n    font-weight: normal !important;\n"])));
var DropFileButton = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_7 || (UploadDialog_styles_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 15px;\n"], ["\n    margin-top: 15px;\n"])));
var DropFileDiv = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_8 || (UploadDialog_styles_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    pointer-events: all;\n    cursor: pointer;\n"], ["\n    display: inline-block;\n    pointer-events: all;\n    cursor: pointer;\n"])));
var DropFileBigText = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_9 || (UploadDialog_styles_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 15px;\n    font-size: 25px;\n"], ["\n    margin-top: 15px;\n    font-size: 25px;\n"])));
var DropFileMdText = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_10 || (UploadDialog_styles_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 15px;\n    font-size: 17px;\n"], ["\n    margin-top: 15px;\n    font-size: 17px;\n"])));
var DropFileText = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_11 || (UploadDialog_styles_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 15px;\n    line-height: 18px;\n    padding: 0 16px;\n"], ["\n    margin-top: 15px;\n    line-height: 18px;\n    padding: 0 16px;\n"])));
var LoadingBarWrapper = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_12 || (UploadDialog_styles_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 20px;\n"], ["\n    margin-top: 20px;\n"])));
var LoadingBarContainer = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_13 || (UploadDialog_styles_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    background-color: #eaeaf0;\n    max-width: 380px;\n    height: 80px;\n    padding: 15px;\n    margin: auto;\n    border-radius: 5px;\n"], ["\n    display: flex;\n    align-items: center;\n    background-color: #eaeaf0;\n    max-width: 380px;\n    height: 80px;\n    padding: 15px;\n    margin: auto;\n    border-radius: 5px;\n"])));
var LoadingBarLeft = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_14 || (UploadDialog_styles_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n    position: relative;\n"], ["\n    flex: 1;\n    position: relative;\n"])));
var LoadingBarName = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_15 || (UploadDialog_styles_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: -23px;\n    left: 0;\n    color: #005aff;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 250px;\n"], ["\n    position: absolute;\n    top: -23px;\n    left: 0;\n    color: #005aff;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 250px;\n"])));
var LoadingBar = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_16 || (UploadDialog_styles_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 8px;\n    border-radius: 10px;\n    background-color: white;\n    position: relative;\n    overflow: hidden;\n"], ["\n    width: 100%;\n    height: 8px;\n    border-radius: 10px;\n    background-color: white;\n    position: relative;\n    overflow: hidden;\n"])));
var BarProgress = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_17 || (UploadDialog_styles_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "%;\n    height: 100%;\n    background-color: #005aff;\n    border-radius: 10px;\n    transition: all 0.3s;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "%;\n    height: 100%;\n    background-color: #005aff;\n    border-radius: 10px;\n    transition: all 0.3s;\n"])), function (_a) {
    var progress = _a.progress;
    return progress || 0;
});
var LoadingBarProgress = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_18 || (UploadDialog_styles_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 0;\n    bottom: -22px;\n    color: #757575;\n"], ["\n    position: absolute;\n    right: 0;\n    bottom: -22px;\n    color: #757575;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_19 || (UploadDialog_styles_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 20px;\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n"], ["\n    width: 20px;\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n"])));
var UploadSuccess = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_20 || (UploadDialog_styles_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid #a8db82;\n    background-color: rgba(227, 241, 211, 0.8);\n    padding: 12px 16px;\n    margin: 20px 30px 0 30px;\n"], ["\n    border: 1px solid #a8db82;\n    background-color: rgba(227, 241, 211, 0.8);\n    padding: 12px 16px;\n    margin: 20px 30px 0 30px;\n"])));
var UploadSuccessText = styled_components_browser_esm/* default.div */.ZP.div(UploadDialog_styles_templateObject_21 || (UploadDialog_styles_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: center;\n    line-height: 20px;\n\n    a {\n        text-decoration: none;\n    }\n"], ["\n    text-align: center;\n    line-height: 20px;\n\n    a {\n        text-decoration: none;\n    }\n"])));
var styles_SuccessLink = styled_components_browser_esm/* default.span */.ZP.span(UploadDialog_styles_templateObject_22 || (UploadDialog_styles_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: bold;\n    color: #005aff;\n    cursor: pointer;\n"], ["\n    font-weight: bold;\n    color: #005aff;\n    cursor: pointer;\n"])));
var UploadDialog_styles_templateObject_1, UploadDialog_styles_templateObject_2, UploadDialog_styles_templateObject_3, UploadDialog_styles_templateObject_4, UploadDialog_styles_templateObject_5, UploadDialog_styles_templateObject_6, UploadDialog_styles_templateObject_7, UploadDialog_styles_templateObject_8, UploadDialog_styles_templateObject_9, UploadDialog_styles_templateObject_10, UploadDialog_styles_templateObject_11, UploadDialog_styles_templateObject_12, UploadDialog_styles_templateObject_13, UploadDialog_styles_templateObject_14, UploadDialog_styles_templateObject_15, UploadDialog_styles_templateObject_16, UploadDialog_styles_templateObject_17, UploadDialog_styles_templateObject_18, UploadDialog_styles_templateObject_19, UploadDialog_styles_templateObject_20, UploadDialog_styles_templateObject_21, UploadDialog_styles_templateObject_22;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/UploadDialog/index.js
'use client';












function UploadDialog(props) {
    var _a = (0,react.useState)(), file = _a[0], setFile = _a[1];
    var _b = (0,react.useState)(false), loadingCV = _b[0], setLoadingCV = _b[1];
    var _c = (0,react.useState)(false), loadingSuccess = _c[0], setLoadingSuccess = _c[1];
    var _d = (0,react.useState)(0), progress = _d[0], setProgress = _d[1];
    var _e = (0,react.useState)(''), warning = _e[0], setWarning = _e[1];
    var _f = (0,react.useState)(false), isDragOver = _f[0], setDragOver = _f[1];
    var loadingInterval = (0,react.useRef)(null);
    var _g = (0,_tslib/* __assign */.pi)({}, props), type = _g.type, isOpen = _g.isOpen, onToggleOpen = _g.onToggleOpen, isLoading = _g.isLoading, onChangeLoading = _g.onChangeLoading, onCvUploadLoading = _g.onCvUploadLoading, onCvUpload = _g.onCvUpload, onChangeError = _g.onChangeError, onReloadPage = _g.onReloadPage, onMyProfileClick = _g.onMyProfileClick, onCloseDialog = _g.onCloseDialog, _h = _g.lang, lang = _h === void 0 ? 'vi' : _h, error = _g.error, showErrorMess = _g.showErrorMess, isSuccess = _g.isSuccess, baseUrl = _g.baseUrl;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return LinkedIn_translations_translations[text];
        }
    };
    var handleOnToggleOpen = function (isOpen) {
        onToggleOpen && onToggleOpen(isOpen);
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setDragOver(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setDragOver(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDragEnd = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            setFile(e.dataTransfer.files[0]);
        }
    };
    var handleCloseDialog = function () {
        // Choose file
        if (!loadingCV && !loadingSuccess) {
            onChangeError && onChangeError(false);
        }
        // Upload success dashboard
        if (loadingSuccess && type === 'dashboard') {
            onCloseDialog && onCloseDialog();
        }
        handleOnToggleOpen('');
        // Upload success myprofile
        if (loadingSuccess && type === 'myprofile') {
            onCloseDialog && onCloseDialog();
            location.reload();
        }
    };
    var handleNameButton = function () {
        if (loadingSuccess && type === 'myprofile') {
            return t('Review profile');
        }
        else {
            return t('Close');
        }
    };
    var countUpNumber = function (count) {
        if (count === void 0) { count = 0; }
        loadingInterval.current = setInterval(function () {
            if (count < 99) {
                count++;
                setProgress(count);
            }
        }, 600);
    };
    (0,react.useEffect)(function () {
        if (error && loadingInterval.current) {
            setLoadingCV(false);
            clearInterval(loadingInterval.current);
            setWarning('');
            setProgress(0);
        }
    }, [error]);
    (0,react.useEffect)(function () {
        if (isSuccess && loadingInterval.current && onCvUpload && file && onReloadPage) {
            clearInterval(loadingInterval.current);
            onCvUpload(file.name);
            setProgress(100);
            setTimeout(function () { return setLoadingSuccess(true); }, 1500);
        }
    }, [isSuccess]);
    (0,react.useEffect)(function () {
        if (file && onCvUploadLoading && onChangeError && onReloadPage) {
            onChangeError(false);
            if (file.size < FILE_UPLOAD_SIZE) {
                setLoadingCV(true);
                setWarning(t('File uploading'));
                countUpNumber();
                onCvUploadLoading(file);
                onReloadPage(true);
            }
            else {
                setWarning(t('You can attach .pdf file that is less than 5120 KB in size.'));
            }
        }
    }, [file]);
    (0,react.useEffect)(function () {
        if (progress && progress < 100)
            onChangeLoading && onChangeLoading(true);
        else
            onChangeLoading && onChangeLoading(false);
    }, [progress]);
    return (react.createElement(Dialog, { title: t('Import from LinkedIn'), isOpen: isOpen, onBack: handleCloseDialog, fullScreenOnMobile: true, actionText: handleNameButton(), primaryButtonType: 'default', onClickAction: handleCloseDialog, backdrop: true, modalContainerStyle: { maxWidth: '550px', width: '100%' }, sizeButton: 'md-h', gridButton: (0,helpers/* isMobile */.tq)() ? '1fr' : '1fr 1fr' },
        !loadingCV && !loadingSuccess && (
        // Choose file to upload CV
        react.createElement(UploadDialog_styles_Container, null,
            react.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            react.createElement(DropFileLabel, { htmlFor: 'dropFile', onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDragEnd: handleOnDragEnd, onDrop: handleOnDrop },
                react.createElement(UploadDropFile, { isDragOver: isDragOver },
                    react.createElement("div", { style: { pointerEvents: 'none' } },
                        react.createElement(DropFileIcon, null,
                            react.createElement(IconUploadButton, null)),
                        !(0,helpers/* isMobile */.tq)() && react.createElement(DropFileBigText, null, t('Drag your file here')),
                        !(0,helpers/* isMobile */.tq)() && react.createElement(DropFileText, null, t('Or you can')),
                        react.createElement(DropFileButton, null,
                            react.createElement(DropFileDiv, null,
                                react.createElement(Button/* default */.Z, { style: { cursor: 'no-drop' }, className: 'pointer-disabled', type: 'primary', disabled: isLoading }, t('Choose file to upload')))),
                        react.createElement(DropFileInput, { type: 'file', id: 'dropFile', accept: 'application/pdf', onChange: function (e) {
                                var _a, _b;
                                if (!((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files)) {
                                    return;
                                }
                                setFile((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.files[0]);
                            }, disabled: isLoading }),
                        react.createElement(DropFileText, null, t('.pdf files that are less than 5120KB in size')),
                        error && showErrorMess && (react.createElement(DropFileText, { style: { color: 'red' } }, error)),
                        warning && react.createElement(DropFileText, { style: { color: 'red' } }, warning)))))),
        loadingCV && !loadingSuccess && (
        // Loading CV
        react.createElement(UploadDialog_styles_Container, null,
            react.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            react.createElement(UploadDropFile, null,
                react.createElement(DropFileIcon, null,
                    react.createElement(IconCloudUpload, null)),
                react.createElement(DropFileMdText, null,
                    t('File uploading'),
                    " ..."),
                react.createElement(LoadingBarWrapper, null,
                    react.createElement(LoadingBarContainer, null,
                        react.createElement(LoadingBarLeft, null,
                            react.createElement(LoadingBarName, null, file === null || file === void 0 ? void 0 : file.name),
                            react.createElement(LoadingBar, null,
                                react.createElement(BarProgress, { progress: progress })),
                            react.createElement(LoadingBarProgress, null,
                                progress,
                                "%"))))))),
        loadingSuccess && (
        // loading CV successs
        react.createElement(UploadDialog_styles_Container, null,
            react.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            react.createElement(UploadDropFile, null,
                react.createElement(DropFileIcon, null,
                    react.createElement(IconChecked, null)),
                react.createElement(DropFileMdText, { style: { color: '#00b70b' } }, t('Profile upload successful')),
                react.createElement(UploadSuccess, null, type === 'dashboard' ? (react.createElement(UploadSuccessText, null,
                    t('Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.'),
                    ' ',
                    t('Go to'),
                    ' ',
                    react.createElement("a", { href: "".concat(baseUrl, "\\").concat(t('my-profile')), onClick: function () { return onMyProfileClick(); }, rel: 'noreferrer' },
                        react.createElement(styles_SuccessLink, null, t('My Profile')),
                        ' '),
                    t('to review your updated profile.'))) : (react.createElement(UploadSuccessText, null, t("Your LinkedIn profile has been updated to VietnamWorks's profile successfully.")))))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/GuideDialog/styles.js
'use client';




var GuideDialog_styles_Container = styled_components_browser_esm/* default.div */.ZP.div(GuideDialog_styles_templateObject_1 || (GuideDialog_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var GuideText = styled_components_browser_esm/* default.div */.ZP.div(GuideDialog_styles_templateObject_2 || (GuideDialog_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"], ["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"])));
var GuideImage = styled_components_browser_esm/* default.img */.ZP.img(GuideDialog_styles_templateObject_3 || (GuideDialog_styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var GuideDialog_styles_templateObject_1, GuideDialog_styles_templateObject_2, GuideDialog_styles_templateObject_3;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/GuideDialog/index.js
'use client';







var guideImageUrl = "https://images.vietnamworks.com/images/linkedin-guide-image-logo.png";
function GuideDialog(props) {
    var _a = (0,_tslib/* __assign */.pi)({}, props), isOpen = _a.isOpen, onToggleOpen = _a.onToggleOpen, _b = _a.lang, lang = _b === void 0 ? 'vi' : _b;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return LinkedIn_translations_translations[text];
        }
    };
    var handleOnToggleOpen = function (isOpen) {
        onToggleOpen && onToggleOpen(isOpen);
    };
    var handleOnClickAction = function () {
        window && window.open('https://www.linkedin.com/in/', '_blank').focus();
        onToggleOpen && onToggleOpen('upload');
    };
    var handleOnClickCancel = function () {
        onToggleOpen && onToggleOpen('');
    };
    return (react.createElement(Dialog, { title: t('Import from LinkedIn'), isOpen: isOpen, onBack: function () { return handleOnToggleOpen(''); }, onClickOutside: function () { return handleOnToggleOpen(''); }, fullScreenOnMobile: true, onClickAction: handleOnClickAction, actionText: t('Open LinkedIn'), secondaryButtonText: t('Close'), onClickSecondaryButton: handleOnClickCancel, isSecondaryButtonDisabled: false, isShowSecondaryButton: true, backdrop: true, modalContainerStyle: { maxWidth: '550px', width: '100%' }, sizeButton: 'md-h' },
        react.createElement(GuideDialog_styles_Container, null,
            react.createElement(GuideText, null,
                t('Save your LinkedIn profile as a'),
                " ",
                react.createElement("b", null, t('PDF and upload it ')),
                t('to VietnamWorks. Click the'),
                " ",
                react.createElement("b", null, t('"More..."')),
                " ",
                t('button on your LinkedIn profile.')),
            react.createElement(GuideImage, { src: guideImageUrl }))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/const.js
var resumes_const = __webpack_require__(14313);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LinkedIn/index.js
'use client';



















function LinkedIn(props) {
    var _this = this;
    var _a = props.lang, lang = _a === void 0 ? 'vi' : _a, _b = props.type, type = _b === void 0 ? 'myprofile' : _b, tokenAccess = props.tokenAccess, apiCrawlStatus = props.apiCrawlStatus, apiUploadLinked = props.apiUploadLinked, resumeId = props.resumeId, baseUrl = props.baseUrl;
    var _c = (0,react.useState)(false), showLinkedIn = _c[0], setShowLinkedIn = _c[1];
    var _d = (0,react.useState)(''), showDialog = _d[0], setShowDialog = _d[1];
    var _e = (0,react.useState)(true), showDashboard = _e[0], setShowDashboard = _e[1];
    var _f = (0,react.useState)(true), showErrorMess = _f[0], setShowErrorMess = _f[1];
    var _g = (0,react.useState)(false), showLoading = _g[0], setShowLoading = _g[1];
    var _h = (0,react.useState)(true), showSuccessMyprofile = _h[0], setShowSuccessMyprofile = _h[1];
    var _j = (0,react.useState)(''), cvName = _j[0], setCvName = _j[1];
    var _k = (0,react.useState)(''), error = _k[0], setError = _k[1];
    var _l = (0,react.useState)(false), success = _l[0], setSuccess = _l[1];
    var _m = (0,react.useState)(''), userId = _m[0], setUserId = _m[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return LinkedIn_translations_translations[text];
        }
    };
    var getLocalStorage = function () {
        return JSON.parse(localStorage.getItem('VNW_LINKEDIN_SETTING') || '{}');
    };
    var saveLocalStorage = function (editItem) {
        var item = getLocalStorage();
        item[userId] = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item[userId]), editItem);
        localStorage.setItem('VNW_LINKEDIN_SETTING', JSON.stringify(item));
    };
    var initLocalStorage = function (setting) {
        if (setting === void 0) { setting = {}; }
        setting[userId] = {
            showError: true,
            showSuccess: true,
            showSuccessMyprofile: true,
            reload: false
        };
        localStorage.setItem('VNW_LINKEDIN_SETTING', JSON.stringify(setting));
    };
    var handleReloadPage = function (isReload) {
        saveLocalStorage({ reload: isReload });
    };
    var handleShowError = function (isShow) {
        setShowErrorMess(isShow);
        saveLocalStorage({ showError: isShow });
        if (!isShow)
            setError('');
    };
    var handleShowSuccess = function (isShow) {
        if (type === 'dashboard') {
            setShowDashboard(isShow);
            saveLocalStorage({ showSuccess: isShow });
        }
        else {
            setShowSuccessMyprofile(isShow);
            saveLocalStorage({ showSuccessMyprofile: isShow });
        }
    };
    var checkStatusUpload = function (numberCrawApi) {
        if (numberCrawApi === void 0) { numberCrawApi = 0; }
        return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
            var response;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (tokenAccess === '') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, service_apiServices.getLinkedInStatus(apiCrawlStatus, tokenAccess)];
                    case 1:
                        response = _a.sent();
                        setUserId(String(response === null || response === void 0 ? void 0 : response.userId) || '');
                        if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === LOADING_STATUS) {
                            // LOADING
                            setShowLoading(true);
                            setError('');
                            setTimeout(function () { return checkStatusUpload(numberCrawApi + 1); }, 5000);
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === SUCCESS_STATUS) {
                            // SUCCESS
                            setShowLoading(false);
                            setCvName(response === null || response === void 0 ? void 0 : response.latestSuccessFileName);
                            setSuccess(true);
                            setShowLinkedIn(false);
                            tracking({
                                eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                                properties: {
                                    isDashboard: type === 'dashboard'
                                }
                            });
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === FAIL_STATUS) {
                            // FAIL
                            setSuccess(true);
                            setShowLoading(false);
                            setError('');
                            setCvName(response === null || response === void 0 ? void 0 : response.latestSuccessFileName);
                            tracking({
                                eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                                properties: {
                                    isDashboard: false
                                }
                            });
                            if ((response === null || response === void 0 ? void 0 : response.userId) === undefined) {
                                handleReloadPage(false);
                                return [2 /*return*/];
                            }
                            if (getLocalStorage()[response === null || response === void 0 ? void 0 : response.userId].reload && numberCrawApi !== 0) {
                                handleReloadPage(false);
                                setTimeout(function () { return location.reload(); }, 1500);
                            }
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === INIT_STATUS) {
                            // FIRST IMPORT - NEW ACCOUNT
                            setShowLinkedIn(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var uploadLinkedInCV = function (cv) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var response;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // when upload new file CV, show error success is valid
                    handleShowError(true);
                    handleShowSuccess(true);
                    setSuccess(false);
                    return [4 /*yield*/, service_apiServices.uploadLinkedIn(apiUploadLinked, tokenAccess, cv, resumeId, lang)];
                case 1:
                    response = _b.sent();
                    if (response && response.meta.code && response.meta.code >= resumes_const/* DEFAULT_SUCCESS_CODE */.se && response.meta.code < 400) {
                        // SUCCESS
                        setSuccess(true);
                        setShowLoading(false);
                        setCvName(response === null || response === void 0 ? void 0 : response.data.data.latestSuccessFileName);
                        tracking({
                            eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                            properties: {
                                isDashboard: type === 'dashboard'
                            }
                        });
                    }
                    else {
                        setError((_a = response === null || response === void 0 ? void 0 : response.meta.message) !== null && _a !== void 0 ? _a : '');
                        setShowLoading(false);
                        tracking({
                            eventName: 'js_profile_management:sync_linkedin_profile_error'
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleImportButton = function () {
        // reset error success when press import file button
        if (type === 'myprofile') {
            handleShowSuccess(false);
        }
        handleShowError(false);
        setShowDialog('guide');
        tracking({
            eventName: 'js_profile_management:sync_linkedin_profile_click'
        });
    };
    (0,react.useEffect)(function () {
        var _a, _b, _c;
        if (userId) {
            if (!localStorage.getItem('VNW_LINKEDIN_SETTING'))
                initLocalStorage();
            else if (!Object.keys(getLocalStorage()).includes(userId))
                initLocalStorage(getLocalStorage());
            else {
                setShowSuccessMyprofile((_a = getLocalStorage()[userId]) === null || _a === void 0 ? void 0 : _a.showSuccessMyprofile);
                setShowDashboard((_b = getLocalStorage()[userId]) === null || _b === void 0 ? void 0 : _b.showSuccess);
                setShowErrorMess((_c = getLocalStorage()[userId]) === null || _c === void 0 ? void 0 : _c.showError);
            }
        }
    }, [userId]);
    (0,react.useEffect)(function () {
        checkStatusUpload();
    }, [tokenAccess]);
    return (react.createElement(styles_Wrapper, null,
        showLoading && !showDialog && (
        // Loading
        react.createElement(Alert/* default */.Z, { type: 'warning', style: { padding: '10px', marginBottom: '10px' } },
            react.createElement(AlertContent, null,
                react.createElement(images_IconLoading, null),
                react.createElement(AlertContentText, null, t('It may take a few minutes to import the data...'))))),
        type === 'myprofile' && showErrorMess && error && !showDialog && (
        // Error myprofile
        react.createElement(Alert/* default */.Z, { type: 'error', style: { padding: '10px', marginBottom: '10px' }, isHaveClose: false },
            react.createElement(AlertContent, null,
                error,
                react.createElement(AlertCancel, { onClick: function () { return handleShowError(false); } },
                    react.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'dashboard' && showErrorMess && error && showDashboard && !showDialog && (
        // Error dashboard
        react.createElement(Alert/* default */.Z, { type: 'error', style: { padding: '10px', marginBottom: '10px' }, isHaveClose: false },
            react.createElement(AlertContent, null,
                error,
                react.createElement(AlertCancel, { onClick: function () { return handleShowError(false); } },
                    react.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'myprofile' && showSuccessMyprofile && success && !showDialog && (
        // Success myprofile
        react.createElement(SuccessUploadCV, null,
            (0,helpers/* isMobile */.tq)() ? react.createElement(IconLinkedInSuccessMobile, null) : react.createElement(IconLinkedInSuccess, null),
            react.createElement(SuccessText, null, t("Your LinkedIn profile has been updated to VietnamWorks's profile successfully.")),
            react.createElement(CloseIconWrapper, { onClick: function () { return handleShowSuccess(false); } },
                react.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' })))),
        type === 'dashboard' && showDashboard && success && !showDialog && (
        // Success dashboard
        react.createElement(SuccessUploadCV, null,
            (0,helpers/* isMobile */.tq)() ? react.createElement(IconLinkedInSuccessMobile, null) : react.createElement(IconLinkedInSuccess, null),
            react.createElement(SuccessText, null,
                t('Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.'),
                ' ',
                react.createElement(SuccessTextSpan, null,
                    t('Go to'),
                    ' ',
                    react.createElement("a", { href: "".concat(baseUrl, "/").concat(t('my-profile')), onClick: function () { return handleShowSuccess(false); }, rel: 'noreferrer' },
                        react.createElement(SuccessLink, null, t('My Profile')),
                        ' '),
                    t('to review your updated profile.'))),
            react.createElement(CloseIconWrapper, { onClick: function () { return handleShowSuccess(false); } },
                react.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' })))),
        type === 'dashboard' && showDashboard && !success && showLinkedIn && (react.createElement(styles_Container, { bgColor: '#D4E6F0' },
            react.createElement(ContainerImage, null,
                react.createElement(ContainerSvgImage, null,
                    react.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            react.createElement(ContainerContent, null,
                react.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                react.createElement(ContentDesc, null, t('Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.')),
                react.createElement(ContentButton, null,
                    react.createElement(Button/* default */.Z, { type: 'info', size: 'md-h', onClick: handleImportButton, disabled: showLoading },
                        react.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                        showLoading ? t('File uploading') : t('Import profile'))),
                react.createElement(ContainerCloseIcon, { onClick: function () { return setShowLinkedIn(false); } },
                    react.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'myprofile' && !cvName && (
        // Upload CV from LinkedIn
        react.createElement(styles_Container, null,
            react.createElement(ContainerImage, null,
                react.createElement(ContainerSvgImage, null,
                    react.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            react.createElement(ContainerContent, null,
                react.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                react.createElement(ContentDesc, null, t('Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.')),
                react.createElement(ContentButton, null,
                    react.createElement(Button/* default */.Z, { type: 'info', size: 'md-h', style: { fontWeight: 'bold' }, onClick: handleImportButton, disabled: showLoading },
                        react.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                        showLoading ? t('File uploading') : t('Import profile')))))),
        type === 'myprofile' && cvName && (
        // Already have CV
        react.createElement(styles_Container, null,
            react.createElement(ContainerImage, null,
                react.createElement(ContainerSvgImage, null,
                    react.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            react.createElement(ContainerContent, null,
                react.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                react.createElement(ContentCVFile, null,
                    react.createElement(ContentTextWrapper, null,
                        react.createElement(ContentNormalText, null, t('Profile imported:')),
                        react.createElement(ContentFileWrapper, null,
                            react.createElement(IconLinkElipse, null),
                            react.createElement(ContentFileText, null, cvName.slice(0, cvName.length - 4)),
                            react.createElement(ContentFileTail, null, ".pdf"))),
                    react.createElement(ContentButton, { style: { marginTop: '10px', width: (0,helpers/* isMobile */.tq)() ? '100%' : 'auto' } },
                        react.createElement(Button/* default */.Z, { type: 'info', size: 'md-h', style: { width: (0,helpers/* isMobile */.tq)() ? '100%' : 'auto' }, onClick: handleImportButton, disabled: showLoading },
                            react.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                            showLoading ? t('File uploading') : t('Import again'))))))),
        showDialog === 'guide' && (react.createElement(GuideDialog, { isOpen: showDialog === 'guide', onToggleOpen: function (e) { return setShowDialog(e); }, lang: lang })),
        showDialog === 'upload' && (react.createElement(UploadDialog, { type: type, isOpen: showDialog === 'upload', isLoading: showLoading, isSuccess: success, showErrorMess: showErrorMess, onToggleOpen: function (e) { return setShowDialog(e); }, onCvUploadLoading: function (cv) { return uploadLinkedInCV(cv); }, onCvUpload: function (e) { return setCvName(e); }, onReloadPage: function (e) { return handleReloadPage(e); }, onChangeLoading: function (e) { return setShowLoading(e); }, onChangeError: function (e) { return handleShowError(e); }, onCloseDialog: function () { return handleShowSuccess(false); }, onMyProfileClick: function () { return handleShowSuccess(false); }, error: error, lang: lang, baseUrl: baseUrl }))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PieChart/PieChart.css.js
'use client';







var PieChartWrapper = styled_components_browser_esm/* default.div */.ZP.div(PieChart_css_templateObject_1 || (PieChart_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    ", "\n"], ["\n    position: relative;\n    ", "\n"])), function (_a) {
    var horizontalLegend = _a.horizontalLegend;
    return horizontalLegend
        ? "\n            display: grid;\n            grid-template-columns: auto 1fr;\n            column-gap: 40px;\n            align-items: center;\n        "
        : '';
});
styled_components_browser_esm/* default.div */.ZP.div(PieChart_css_templateObject_2 || (PieChart_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 50%;\n    background-color: #fff;\n"], ["\n    border-radius: 50%;\n    background-color: #fff;\n"])));
var LineDetail = styled_components_browser_esm/* default.div */.ZP.div(PieChart_css_templateObject_3 || (PieChart_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 16px;\n    width: 100%;\n"], ["\n    margin-top: 16px;\n    width: 100%;\n"])));
var PercentView = styled_components_browser_esm/* default.span */.ZP.span(PieChart_css_templateObject_4 || (PieChart_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #001744;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    display: flex;\n    align-items: center;\n"], ["\n    color: #001744;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    display: flex;\n    align-items: center;\n"])));
var PieChart_css_Legend = styled_components_browser_esm/* default.div */.ZP.div(PieChart_css_templateObject_7 || (PieChart_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: space-between;\n    ", "\n    ", "\n"], ["\n    display: flex;\n    justify-content: space-between;\n    ", "\n    ", "\n"])), function (_a) {
    var isHover = _a.isHover, isLegendHover = _a.isLegendHover;
    if (!isHover) {
        return '';
    }
    if (isLegendHover) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(PieChart_css_templateObject_5 || (PieChart_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            opacity: 0.2;\n        "], ["\n            opacity: 0.2;\n        "])));
}, function (_a) {
    var isCurrent = _a.isCurrent, highlightColor = _a.highlightColor;
    if (!isCurrent) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(PieChart_css_templateObject_6 || (PieChart_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin: 0 -12px;\n            padding: 0 12px;\n            background-color: #f5f5f5;\n            ", " {\n                font-weight: 700;\n                color: ", ";\n            }\n        "], ["\n            margin: 0 -12px;\n            padding: 0 12px;\n            background-color: #f5f5f5;\n            ", " {\n                font-weight: 700;\n                color: ", ";\n            }\n        "])), PercentView, highlightColor);
});
var LegendLabel = styled_components_browser_esm/* default.span */.ZP.span(PieChart_css_templateObject_8 || (PieChart_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    margin: 6px 0;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    text-align: left;\n    ::before {\n        content: '';\n        width: 8px;\n        height: 8px;\n        display: inline-block;\n        border-radius: 50%;\n        background-color: ", ";\n        margin-right: 8px;\n        flex-shrink: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    margin: 6px 0;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    text-align: left;\n    ::before {\n        content: '';\n        width: 8px;\n        height: 8px;\n        display: inline-block;\n        border-radius: 50%;\n        background-color: ", ";\n        margin-right: 8px;\n        flex-shrink: 0;\n    }\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var scaleUp = (0,styled_components_browser_esm/* keyframes */.F4)(PieChart_css_templateObject_9 || (PieChart_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    translate: 50% 50%;\n    scale: 0;\n  }\n  100% {\n    translate: 0 0;\n    scale: 1;\n  }\n"], ["\n  0% {\n    translate: 50% 50%;\n    scale: 0;\n  }\n  100% {\n    translate: 0 0;\n    scale: 1;\n  }\n"])));
var GroupCircle = styled_components_browser_esm/* default.g */.ZP.g(PieChart_css_templateObject_10 || (PieChart_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    @media screen and (min-width: 991px) {\n        /* animation: ", " 1s ease-in-out; */\n        /* transition: all 0.25s ease-in-out; */\n    }\n"], ["\n    position: relative;\n    @media screen and (min-width: 991px) {\n        /* animation: ", " 1s ease-in-out; */\n        /* transition: all 0.25s ease-in-out; */\n    }\n"])), scaleUp);
var Path = styled_components_browser_esm/* default.path */.ZP.path(PieChart_css_templateObject_11 || (PieChart_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: all 0.25s ease-in-out;\n    animation: ", " 1s ease-in-out;\n"], ["\n    transition: all 0.25s ease-in-out;\n    animation: ", " 1s ease-in-out;\n"])), scaleUp);
var OneCircle = styled_components_browser_esm/* default.circle */.ZP.circle(PieChart_css_templateObject_12 || (PieChart_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    animation: ", " 1s ease-in-out;\n"], ["\n    animation: ", " 1s ease-in-out;\n"])), scaleUp);
var CenterText = styled_components_browser_esm/* default.text */.ZP.text(PieChart_css_templateObject_13 || (PieChart_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 28px;\n    color: ", ";\n    pointer-events: none;\n"], ["\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 28px;\n    color: ", ";\n    pointer-events: none;\n"])), constants/* colors.darkBlueColor */.O9.darkBlueColor);
var PieChartToolTip = (0,styled_components_browser_esm/* default */.ZP)(ToolTipWrapper)(PieChart_css_templateObject_14 || (PieChart_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 1;\n    right: 0;\n    top: 0;\n    display: flex;\n    align-items: center;\n"], ["\n    position: absolute;\n    z-index: 1;\n    right: 0;\n    top: 0;\n    display: flex;\n    align-items: center;\n"])));
var PieChartToolTipValue = (0,styled_components_browser_esm/* default */.ZP)(TooltipText)(PieChart_css_templateObject_15 || (PieChart_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 14px;\n    margin-left: 4px;\n"], ["\n    font-size: 14px;\n    margin-left: 4px;\n"])));
var PieChart_css_templateObject_1, PieChart_css_templateObject_2, PieChart_css_templateObject_3, PieChart_css_templateObject_4, PieChart_css_templateObject_5, PieChart_css_templateObject_6, PieChart_css_templateObject_7, PieChart_css_templateObject_8, PieChart_css_templateObject_9, PieChart_css_templateObject_10, PieChart_css_templateObject_11, PieChart_css_templateObject_12, PieChart_css_templateObject_13, PieChart_css_templateObject_14, PieChart_css_templateObject_15;


//# sourceMappingURL=PieChart.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PieChart/constants.js
'use client';



var DEFAULT_COLORS = [
    constants/* colors.cardShadow */.O9.cardShadow,
    constants/* colors.darkBlueColor */.O9.darkBlueColor,
    constants/* colors.infoColor */.O9.infoColor,
    constants/* colors.primaryColor */.O9.primaryColor,
    '#4083FF',
    constants/* colors.buttonColor */.O9.buttonColor,
    constants/* colors.dangerColor */.O9.dangerColor,
    constants/* colors.highlightColor */.O9.highlightColor
];
// Max default radius in pixel
var DEFAULT_MAX_RADIUS = 50;
// Default minus radius in pixel
var DEFAULT_MINUS_RADIUS = 3;
var PieChart_constants_DEFAULT_OPTIONS = {
    width: 260,
    height: 260,
    isShowLegend: true,
    isFocusHover: true,
    isFocusHoverOnBottomLegend: false,
    isUsingRadiusRange: true,
    isDonutChart: true,
    highlightText: 'You are here',
    pieStrokeWidth: 1,
    horizontalLegend: false,
    highlightColor: constants/* colors.successColor */.O9.successColor,
    showHighlightTextOnLegend: false
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PieChart/helper.js
'use client';




var findSortedIndex = function (item, sortLargest) {
    var filteredItem = sortLargest.filter(function (sortItem) { return sortItem.label === item.label && sortItem.percent === item.percent; });
    return filteredItem.length > 0 ? filteredItem[0] : null;
};
/**
 * Return list of TValueItem with sorted from largest to smallest
 * @param value list of TValueItem
 * @returns sorted from largest to smallest
 */
var getListLevel = function (value) {
    var sortedRadiusLevel = [];
    var clonedValue = (0,_tslib/* __spreadArray */.ev)([], value, true);
    var sortLargest = clonedValue.sort(function (a, b) { return (a.percent > b.percent ? -1 : 0); });
    var _loop_1 = function (i) {
        var item = sortLargest[i];
        var filteredLevels = sortedRadiusLevel.filter(function (childItem) { return childItem.percent === item.percent; });
        if (filteredLevels.length <= 0) {
            sortedRadiusLevel.push(item);
        }
    };
    // Reduce duplicate percent item
    for (var i = 0; i < sortLargest.length; i++) {
        _loop_1(i);
    }
    var _loop_2 = function (i) {
        var item = sortLargest[i];
        var itemIndex = sortedRadiusLevel.findIndex(function (childItem) { return childItem.percent === item.percent; });
        if (itemIndex >= 0) {
            sortLargest[i].radiusIndex = itemIndex;
        }
    };
    // Find item and update radius level
    for (var i = 0; i < sortLargest.length; i++) {
        _loop_2(i);
    }
    return sortLargest;
};
/**
 * Map list of TValueItem with color and minusRadius
 * @param value list of TValueItem
 * @param sortLargest list of TValueItem are sorted by percent from largest to smallest
 * @returns list of TValueItem with color and minusRadius
 */
var mapRadiusIndex = function (value, sortLargest, highlightColor) {
    return value.map(function (item, index) {
        var _a, _b;
        // get index of sorted
        var sortItemInfo = findSortedIndex(item, sortLargest);
        var sortItemIndex = (_a = sortItemInfo === null || sortItemInfo === void 0 ? void 0 : sortItemInfo.radiusIndex) !== null && _a !== void 0 ? _a : 0;
        // Calculate minusRadius by sorted index of radius level
        var minusRadius = DEFAULT_MAX_RADIUS - sortItemIndex * DEFAULT_MINUS_RADIUS;
        var itemColor = (_b = item.color) !== null && _b !== void 0 ? _b : DEFAULT_COLORS[index];
        if (item.isActive) {
            itemColor = highlightColor;
        }
        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ index: index }, item), { radiusIndex: sortItemIndex, color: itemColor, minusRadius: minusRadius });
    });
};
/**
 * Check have only one value
 * @param value list of TValueItem
 * @returns Object with TValueItem and boolean variable (have one value or not)
 */
var findOnlyOneValue = function (value) {
    var _a;
    var isHaveOneValue = false;
    var filteredValues = value.filter(function (item) { return item.percent === 100; });
    if (filteredValues.length > 0) {
        isHaveOneValue = true;
    }
    // get index
    var filteredIndexValue = value.findIndex(function (item) { return item.percent === 100; });
    return {
        value: value,
        isHaveOneValue: isHaveOneValue,
        onlyValue: (_a = filteredValues[0]) !== null && _a !== void 0 ? _a : null,
        onlyValueIndex: filteredIndexValue
    };
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PieChart/index.js
'use client';









var PieChart = function (props) {
    var value = props.value, options = props.options;
    var mergedOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, PieChart_constants_DEFAULT_OPTIONS), options);
    var _a = (0,react.useState)(-1), currentHoverIndex = _a[0], setCurrentHoverIndex = _a[1];
    var _b = (0,react.useState)(false), isHover = _b[0], setIsHover = _b[1];
    // First sort percent by large to small
    var sortLargest = getListLevel(value);
    // re-mapped values
    var values = mapRadiusIndex(value, sortLargest, mergedOptions.highlightColor);
    var _c = findOnlyOneValue(values), isHaveOneValue = _c.isHaveOneValue, onlyValue = _c.onlyValue, onlyValueIndex = _c.onlyValueIndex;
    var valuesInNumber = values.map(function (item) { return item.percent; });
    var colors = values.map(function (item) { return item.color; });
    var radii = values.map(function (item) { return item.minusRadius; });
    var total = valuesInNumber.reduce(function (acc, curr) { return acc + curr; }, 0);
    var angles = valuesInNumber.map(function (value) { return (value / total) * 360; });
    var getFillColor = function (color, isFullAlpha) {
        var opacity = isFullAlpha ? '1' : '0.2';
        if (!isHover) {
            opacity = '1';
        }
        if (!mergedOptions.isFocusHover) {
            opacity = '1';
        }
        var rgba = (0,helpers/* ConvertHexToRgbA */.mT)(color, opacity);
        return rgba;
    };
    var segments = angles.map(function (angle, index) {
        var _a, _b;
        var prevAngles = angles.slice(0, index);
        var startAngle = prevAngles.reduce(function (acc, curr) { return acc + curr; }, 0);
        var endAngle = startAngle + angle;
        var largeArcFlag = angle > 180 ? 1 : 0;
        var radius = mergedOptions.isUsingRadiusRange ? radii[index] : DEFAULT_MAX_RADIUS;
        var startX = 50 + radius * Math.cos(((startAngle - 90) * Math.PI) / 180);
        var startY = 50 + radius * Math.sin(((startAngle - 90) * Math.PI) / 180);
        var endX = 50 + radius * Math.cos(((endAngle - 90) * Math.PI) / 180);
        var endY = 50 + radius * Math.sin(((endAngle - 90) * Math.PI) / 180);
        var pathData = "M50,50 L".concat(startX, ",").concat(startY, " A").concat(radius, ",").concat(radius, " 0 ").concat(largeArcFlag, ",1 ").concat(endX, ",").concat(endY, " Z");
        if (angle === 0) {
            return null;
        }
        var pieAnimationDuration = "".concat((index + 1) * 0.2, "s");
        return (react.createElement(Path, { key: index, d: pathData, fill: getFillColor((_a = colors[index]) !== null && _a !== void 0 ? _a : DEFAULT_COLORS[0], currentHoverIndex === index), stroke: '#fff', strokeWidth: (_b = mergedOptions.pieStrokeWidth) !== null && _b !== void 0 ? _b : 1, onMouseEnter: function () {
                setCurrentHoverIndex(index);
                setIsHover(true);
            }, style: {
                animationDuration: pieAnimationDuration
            }, onClick: function () {
                setCurrentHoverIndex(index);
                setIsHover(true);
            } }));
    });
    var renderCenterText = function () {
        var _a;
        if (isHaveOneValue) {
            return (react.createElement(CenterText, { x: 50, y: 55, textAnchor: 'middle' },
                onlyValue.percent,
                "%"));
        }
        if (!isHover) {
            return null;
        }
        if (currentHoverIndex < 0) {
            return null;
        }
        var itemValue = (_a = valuesInNumber[currentHoverIndex]) !== null && _a !== void 0 ? _a : 0;
        return (react.createElement(CenterText, { x: 50, y: 55, textAnchor: 'middle' },
            itemValue,
            "%"));
    };
    var renderHover = function () {
        var _a, _b;
        if (!isHover) {
            return null;
        }
        if (currentHoverIndex < 0) {
            return null;
        }
        var item = (_a = values[currentHoverIndex]) !== null && _a !== void 0 ? _a : null;
        if (item === null) {
            return null;
        }
        return (react.createElement(PieChartToolTip, null,
            react.createElement(TooltipDot, { bgColor: (_b = item.color) !== null && _b !== void 0 ? _b : DEFAULT_COLORS[0] }),
            " ",
            item.label,
            ":",
            ' ',
            react.createElement(PieChartToolTipValue, { highlightColor: mergedOptions.highlightColor },
                item.percent,
                "%"),
            item.isActive && (react.createElement(react.Fragment, null,
                ' ',
                react.createElement(TooltipText, { isMarginLeft: true, isYou: item.isActive, highlightColor: mergedOptions.highlightColor }, mergedOptions.highlightText)))));
    };
    return (react.createElement(PieChartWrapper, { horizontalLegend: mergedOptions.horizontalLegend },
        react.createElement("svg", { viewBox: '0 0 100 100', width: mergedOptions.width, height: mergedOptions.height, onMouseLeave: function () { return setIsHover(false); } },
            react.createElement(GroupCircle, { style: { display: 'block' } }, isHaveOneValue ? (react.createElement(OneCircle, { r: 48, cx: '50', cy: '50', fill: onlyValue.color, onMouseEnter: function () {
                    setCurrentHoverIndex(onlyValueIndex);
                    setIsHover(true);
                }, style: {
                    animationDuration: '.4s'
                } })) : (segments)),
            mergedOptions.isDonutChart && (react.createElement(react.Fragment, null,
                react.createElement("circle", { r: 28, cx: '50', cy: '50', fill: '#fff', style: { pointerEvents: 'none' } }),
                react.createElement("circle", { r: 25, cx: '50', cy: '50', fill: '#fff', stroke: 'rgba(69, 68, 89, 0.05)', strokeWidth: 2, style: { pointerEvents: 'none' } }),
                renderCenterText()))),
        renderHover(),
        mergedOptions.isShowLegend && (react.createElement(LineDetail, { onMouseLeave: function () {
                if (!mergedOptions.isFocusHoverOnBottomLegend) {
                    return;
                }
                setIsHover(false);
            } }, values.map(function (item, index) {
            var _a, _b;
            var isLegendHover = currentHoverIndex === index;
            if (!isHover) {
                isLegendHover = false;
            }
            // If option isFocusHover (is focus on hover) not enable
            // then set legend hover as default
            if (!mergedOptions.isFocusHover) {
                isLegendHover = true;
            }
            // Do not fade down legend if isFocusHoverOnBottomLegend is not enable
            if (!mergedOptions.isFocusHoverOnBottomLegend) {
                isLegendHover = true;
            }
            return (react.createElement(PieChart_css_Legend, { key: "key-index-".concat(index), isHover: isHover, isLegendHover: isLegendHover, isCurrent: (_a = item.isActive) !== null && _a !== void 0 ? _a : false, highlightColor: mergedOptions.highlightColor, onMouseEnter: function () {
                    if (!mergedOptions.isFocusHoverOnBottomLegend) {
                        return;
                    }
                    setCurrentHoverIndex(index);
                    setIsHover(true);
                } },
                react.createElement(LegendLabel, { color: (_b = item.color) !== null && _b !== void 0 ? _b : DEFAULT_COLORS[0] },
                    item.label,
                    ' ',
                    mergedOptions.showHighlightTextOnLegend && item.isActive ? (react.createElement(TooltipText, { isMarginLeft: true, isYou: item.isActive, highlightColor: mergedOptions.highlightColor }, mergedOptions.highlightText)) : null),
                react.createElement(PercentView, null,
                    item.percent,
                    "%")));
        })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/LogoIcon/index.js
'use client';



var LogoIcon = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_1_2)' },
            react.createElement("path", { d: 'M12.4135 2.80367C11.3249 2.64922 10.0588 3.03706 10.0588 3.03706C8.6355 3.43622 7.3289 3.31648 7.3289 3.31648C6.2981 3.27441 5.23567 2.96064 5.23567 2.96064C4.5649 2.78048 3.73334 2.74847 3.73334 2.74847C3.73334 2.74847 5.51314 1.18397 8.1676 0.74344C8.1676 0.74344 11.3909 0.0914593 12.7799 2.58718C12.8495 2.71251 12.728 2.85492 12.5721 2.82939L12.4135 2.80367Z', fill: 'white' }),
            react.createElement("path", { d: 'M12.64 2.80045C12.64 2.80045 15.9006 2.68359 15.999 6.06039C15.999 6.06039 16.1363 8.75369 13.2663 11.2822C13.2663 11.2822 10.8449 13.531 8.14351 13.4652C7.99347 13.4616 7.94511 13.27 8.07597 13.1992C8.79141 12.8126 10.2162 11.8246 11.7235 9.54822C11.7235 9.54822 14.1149 6.28629 12.64 2.80045Z', fill: 'white' }),
            react.createElement("path", { d: 'M7.9998 14.3507C7.9998 14.3507 4.0548 17.0705 1.23049 14.4841C1.23049 14.4841 -0.747083 12.7052 0.311834 9.33231C0.363291 9.16864 0.584611 9.15281 0.658117 9.30754C1.10036 10.2367 2.31603 12.4465 4.2763 13.4508C4.2763 13.4508 5.69063 14.3793 7.9998 14.3507Z', fill: 'white' }),
            react.createElement("path", { d: 'M4.2014 3.63172C3.41487 4.12299 1.4795 5.65902 0.761877 9.19999C0.761877 9.19999 -0.869707 6.66499 0.642437 4.55792C0.642437 4.55792 1.65366 3.05698 4.14307 3.37845C4.2741 3.39542 4.31263 3.56232 4.2014 3.63172Z', fill: 'white' })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_1_2' },
                react.createElement("rect", { width: '16', height: '16', fill: 'white' })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PauseIcon/index.js
'use client';




var PauseIcon = function (_a) {
    var language = _a.language;
    return (react.createElement("svg", { role: 'img', height: '24', width: '24', "aria-hidden": 'false', className: 'Svg-sc-ytk21e-0 gQUQL ydKMFPgNHlpYPxfI_zRw', viewBox: '0 0 24 24', "data-encore-id": 'icon', fill: '#fff' },
        react.createElement("title", null, (0,helpers.t)('Pause', language)),
        react.createElement("path", { d: 'M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm7.5-5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-2zm5 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-2z' })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PlayIcon/index.js
'use client';




var PlayIcon = function (_a) {
    var language = _a.language;
    return (react.createElement("svg", { role: 'img', height: '24', width: '24', "aria-hidden": 'false', className: 'Svg-sc-ytk21e-0 gQUQL ydKMFPgNHlpYPxfI_zRw', viewBox: '0 0 24 24', "data-encore-id": 'icon', fill: '#fff' },
        react.createElement("title", null, (0,helpers.t)('Play', language)),
        react.createElement("path", { d: 'M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm8.75-4.567a.5.5 0 0 0-.75.433v8.268a.5.5 0 0 0 .75.433l7.161-4.134a.5.5 0 0 0 0-.866L9.75 7.433z' })));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Podcast/types.js
'use client';



var ReactPlayer = lib/* default */.Z;
var EType;
(function (EType) {
    EType["LARGE"] = "large";
    EType["MEDIUM"] = "medium";
    EType["SMALL"] = "small";
})(EType || (EType = {}));


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Podcast/styles.js
'use client';





var STContainer = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_1 || (Podcast_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(270deg, rgb(0, 90, 255) 0%, rgb(0, 23, 68) 100%);\n    border-radius: 8px;\n    padding: ", "px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    flex-direction: ", ";\n"], ["\n    position: relative;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(270deg, rgb(0, 90, 255) 0%, rgb(0, 23, 68) 100%);\n    border-radius: 8px;\n    padding: ", "px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    flex-direction: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var type = _a.type;
    return (type === EType.MEDIUM ? 16 : 8);
}, function (_a) {
    var type = _a.type;
    return (type === EType.MEDIUM ? 'space-between' : 'unset');
}, function (_a) {
    var type = _a.type;
    return (type !== EType.LARGE ? 'column' : 'row');
});
var STImage = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_2 || (Podcast_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    min-width: ", "px;\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: 4px;\n        object-fit: cover;\n    }\n"], ["\n    min-width: ", "px;\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: 4px;\n        object-fit: cover;\n    }\n"])), function (_a) {
    var imageSize = _a.imageSize;
    return imageSize;
}, function (_a) {
    var imageSize = _a.imageSize;
    return imageSize;
}, function (_a) {
    var imageSize = _a.imageSize;
    return imageSize;
});
var STContent = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_3 || (Podcast_styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-left: ", "px;\n    margin-top: ", "px;\n    overflow: hidden;\n\n    @keyframes marquee {\n        0% {\n            transform: translateX(100%);\n        }\n\n        95% {\n            opacity: 1;\n        }\n\n        100% {\n            opacity: 0;\n            transform: translateX(-150%);\n        }\n    }\n\n    .title {\n        font-size: ", "px;\n        font-weight: 700;\n        margin: 0;\n        cursor: pointer;\n        width: ", ";\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        color: #fff;\n\n        @media screen and (max-width: 769px) {\n            width: fit-content;\n        }\n\n        @media screen and (max-width: 426px) {\n            width: ", "px;\n        }\n\n        @media screen and (max-width: 376px) {\n            width: ", "px;\n        }\n\n        @media screen and (max-width: 321px) {\n            width: ", "px;\n        }\n    }\n\n    .info {\n        font-size: ", "px;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        opacity: 0.7;\n\n        div:nth-of-type(2) {\n            padding-bottom: 4px;\n        }\n\n        div:nth-of-type(3) {\n            cursor: pointer;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-left: ", "px;\n    margin-top: ", "px;\n    overflow: hidden;\n\n    @keyframes marquee {\n        0% {\n            transform: translateX(100%);\n        }\n\n        95% {\n            opacity: 1;\n        }\n\n        100% {\n            opacity: 0;\n            transform: translateX(-150%);\n        }\n    }\n\n    .title {\n        font-size: ", "px;\n        font-weight: 700;\n        margin: 0;\n        cursor: pointer;\n        width: ", ";\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        color: #fff;\n\n        @media screen and (max-width: 769px) {\n            width: fit-content;\n        }\n\n        @media screen and (max-width: 426px) {\n            width: ", "px;\n        }\n\n        @media screen and (max-width: 376px) {\n            width: ", "px;\n        }\n\n        @media screen and (max-width: 321px) {\n            width: ", "px;\n        }\n    }\n\n    .info {\n        font-size: ", "px;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        opacity: 0.7;\n\n        div:nth-of-type(2) {\n            padding-bottom: 4px;\n        }\n\n        div:nth-of-type(3) {\n            cursor: pointer;\n        }\n    }\n"])), function (_a) {
    var type = _a.type;
    return (type !== EType.LARGE ? 0 : 16);
}, function (_a) {
    var type = _a.type;
    return (type === EType.SMALL ? 8 : 0);
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
}, function (_a) {
    var type = _a.type;
    return (type !== EType.LARGE ? '100%' : 'fit-content');
}, function (_a) {
    var type = _a.type;
    return (type === EType.MEDIUM ? 340 : 248);
}, function (_a) {
    var type = _a.type;
    return (type === EType.MEDIUM ? 285 : 200);
}, function (_a) {
    var type = _a.type;
    return (type === EType.MEDIUM ? 240 : 145);
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize - 4;
});
var STControl = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_4 || (Podcast_styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    div:last-child {\n        font-size: ", "px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    div:last-child {\n        font-size: ", "px;\n    }\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize - 4;
});
var STRange = styled_components_browser_esm/* default.input */.ZP.input(Podcast_styles_templateObject_5 || (Podcast_styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    height: 4px;\n    border-radius: 4px;\n    display: flex;\n    align-self: center;\n    cursor: pointer;\n\n    background: rgba(255, 255, 255, 0.5);\n    background-repeat: no-repeat;\n    background-image: linear-gradient(#fff, #fff);\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n\n    &:hover {\n        &:after {\n            content: '", "';\n            width: 40px;\n            height: 20px;\n            position: absolute;\n            background: #333;\n            color: #fff;\n            top: -24px;\n            left: ", "%;\n            border-radius: 4px;\n            font-size: 12px;\n            display: ", ";\n            justify-content: center;\n            align-items: center;\n            transition: all 0.25s ease-in-out;\n        }\n\n        &::-webkit-slider-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n\n        &::-moz-range-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n\n        &::-ms-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n    }\n\n    &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n\n    &::-moz-range-thumb {\n        -moz-appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n\n    &::-ms-thumb {\n        appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n    height: 4px;\n    border-radius: 4px;\n    display: flex;\n    align-self: center;\n    cursor: pointer;\n\n    background: rgba(255, 255, 255, 0.5);\n    background-repeat: no-repeat;\n    background-image: linear-gradient(#fff, #fff);\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n\n    &:hover {\n        &:after {\n            content: '", "';\n            width: 40px;\n            height: 20px;\n            position: absolute;\n            background: #333;\n            color: #fff;\n            top: -24px;\n            left: ", "%;\n            border-radius: 4px;\n            font-size: 12px;\n            display: ", ";\n            justify-content: center;\n            align-items: center;\n            transition: all 0.25s ease-in-out;\n        }\n\n        &::-webkit-slider-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n\n        &::-moz-range-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n\n        &::-ms-thumb {\n            width: 8px;\n            height: 8px;\n            transition: all 0.5s ease-in-out;\n        }\n    }\n\n    &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n\n    &::-moz-range-thumb {\n        -moz-appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n\n    &::-ms-thumb {\n        appearance: none;\n        width: 0;\n        height: 0;\n        background: #fff;\n        border-radius: 100%;\n    }\n"])), function (_a) {
    var prePlayed = _a.prePlayed;
    return prePlayed;
}, function (_a) {
    var prePercent = _a.prePercent;
    return prePercent;
}, function (_a) {
    var prePercent = _a.prePercent;
    return (prePercent === null ? 'none' : 'flex');
});
var STPlay = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_6 || (Podcast_styles_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    min-width: ", "px;\n    width: ", "px;\n    height: ", "px;\n\n    svg {\n        width: 100%;\n        height: 100%;\n        cursor: pointer;\n    }\n"], ["\n    min-width: ", "px;\n    width: ", "px;\n    height: ", "px;\n\n    svg {\n        width: 100%;\n        height: 100%;\n        cursor: pointer;\n    }\n"])), function (_a) {
    var playIconSize = _a.playIconSize;
    return playIconSize;
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return playIconSize;
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return playIconSize;
});
var STLogo = styled_components_browser_esm/* default.div */.ZP.div(Podcast_styles_templateObject_7 || (Podcast_styles_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    cursor: pointer;\n"])));
var Podcast_styles_templateObject_1, Podcast_styles_templateObject_2, Podcast_styles_templateObject_3, Podcast_styles_templateObject_4, Podcast_styles_templateObject_5, Podcast_styles_templateObject_6, Podcast_styles_templateObject_7;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Podcast/index.js
'use client';










var Podcast = (0,react.forwardRef)(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? EType.LARGE : _b, _c = _a.language, language = _c === void 0 ? constants/* ELanguage.EN */.Df.EN : _c, appMode = _a.appMode, podcastData = _a.podcastData;
    var _d = (0,react.useState)(0), duration = _d[0], setDuration = _d[1];
    var _e = (0,react.useState)({
        playing: false,
        playEnd: false,
        prePlayed: 0,
        prePercent: null
    }), play = _e[0], setPlay = _e[1];
    var _f = (0,react.useState)({
        played: 0,
        playedSeconds: 0,
        loaded: 0,
        loadedSeconds: 0
    }), progress = _f[0], setProgress = _f[1];
    var domainImage = appMode !== constants/* EAppMode.production */.Cn.production
        ? "https://".concat(appMode, "-images03.vietnamworks.com")
        : 'https://images03.vietnamworks.com';
    var podcast = podcastData || {
        title: 'Muốn phát triển sự nghiệp đừng ngại hỏi Sếp 5 điều này',
        time: language === constants/* ELanguage.EN */.Df.EN ? 'Apr 7' : '7 tháng 4',
        image: "".concat(domainImage, "/podcast/images/PTSN-300x300.png"),
        url: 'https://www.vietnamworks.com/hrinsider/podcast',
        utm: 'utm_source_navi=banner&utm_medium_navi=PODCASTTRAFFIC&utm_campaign_navi=HRINSIDER2023',
        link: 'https://www.buzzsprout.com/1954516/12606850-mu-n-phat-tri-n-s-nghi-p-d-ng-ng-i-h-i-s-p-5-di-u-nay.mp3'
    };
    var sizePlayer = {
        large: {
            fontSize: 14,
            height: 80,
            playIconSize: 32,
            imageSize: 64
        },
        medium: {
            fontSize: 18,
            height: 352,
            playIconSize: 48,
            imageSize: 176
        },
        small: {
            fontSize: 16,
            height: 192,
            playIconSize: 32,
            imageSize: 90
        }
    };
    var handlePlay = function () {
        if (play.playEnd) {
            setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { playEnd: false })); });
        }
        setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { playing: !play.playing })); });
    };
    var handlePlayEnd = function () { return setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { playing: false, playEnd: true })); }); };
    var handleChangePlayed = function (event) {
        var _a;
        var percent = event.target.valueAsNumber / 100;
        setProgress(function (prev) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, prev), { played: percent })); });
        (_a = play.player) === null || _a === void 0 ? void 0 : _a.seekTo(duration * percent);
    };
    var handleMouseMove = function (event) {
        var percent = ((event.nativeEvent.offsetX / event.target.clientWidth) *
            parseInt(event.target.getAttribute('max'), 10)) /
            100;
        var prePlayed = duration * percent;
        if (prePlayed < 0)
            return;
        setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { prePlayed: Math.ceil(prePlayed), prePercent: percent * 100 })); });
    };
    var handleFormatTime = function (time, isTooltip) {
        return ((time && progress.played && !isTooltip ? '-' : '') +
            '0' +
            Math.floor(time / 60) +
            ':' +
            ('0' + Math.floor(time % 60)).slice(-2));
    };
    var handleRedirectToHRinsiderPodcast = function () {
        return window.open("".concat(podcast.url, "?").concat(podcast.utm));
    };
    var played = (0,react.useMemo)(function () { return Math.ceil(progress.played * 100); }, [progress.played]);
    return (react.createElement(STContainer, (0,_tslib/* __assign */.pi)({}, sizePlayer[type], { type: type }),
        react.createElement(ReactPlayer, { ref: ref, width: 0, height: 0, playing: play.playing, url: podcast.link, onReady: function (_player) { return setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { player: _player })); }); }, onDuration: function (_duration) { return setDuration(Math.floor(_duration)); }, onProgress: function (_progress) {
                return setProgress((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, _progress), { playedSeconds: Math.floor(_progress.playedSeconds), loadedSeconds: Math.floor(_progress.loadedSeconds) }));
            }, onEnded: handlePlayEnd, config: {
                file: {
                    attributes: {
                        preload: 'auto'
                    },
                    forceAudio: true
                }
            } }),
        react.createElement(STImage, (0,_tslib/* __assign */.pi)({}, sizePlayer[type], { onClick: handleRedirectToHRinsiderPodcast }),
            react.createElement("img", { src: podcast.image, alt: 'image' })),
        react.createElement(STContent, (0,_tslib/* __assign */.pi)({}, sizePlayer[type], { type: type }),
            react.createElement("p", { className: 'title', onClick: handleRedirectToHRinsiderPodcast }, podcast.title),
            react.createElement("div", { className: 'info' },
                react.createElement("div", null, podcast.time),
                react.createElement("div", null, " . "),
                react.createElement("div", { onClick: handleRedirectToHRinsiderPodcast }, "VietnamWorks")),
            react.createElement(STControl, (0,_tslib/* __assign */.pi)({}, sizePlayer[type]),
                react.createElement(STRange, { style: {
                        backgroundSize: "".concat(played, "% 100%")
                    }, type: 'range', min: 0, max: 100, value: played, prePlayed: handleFormatTime(play.prePlayed, true), prePercent: play.prePercent, onChange: handleChangePlayed, onClick: function (e) { return e.stopPropagation(); }, onMouseMove: handleMouseMove, onMouseLeave: function () {
                        return play.prePlayed &&
                            setPlay(function (play) { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, play), { prePlayed: 0, prePercent: null })); });
                    }, "aria-label": podcast.title }),
                react.createElement("div", null, handleFormatTime(duration - progress.playedSeconds)),
                react.createElement(STPlay, (0,_tslib/* __assign */.pi)({ onClick: handlePlay, className: 'Homepage_Podcast' }, sizePlayer[type]), play.playing ? react.createElement(PauseIcon, { language: language }) : react.createElement(PlayIcon, { language: language })))),
        react.createElement(STLogo, { onClick: handleRedirectToHRinsiderPodcast },
            react.createElement(LogoIcon, null))));
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/StatsIcon/index.js
'use client';



var StatsIcon = function (props) {
    var onClick = props.onClick, _a = props.onMouseOver, onMouseOver = _a === void 0 ? function () { } : _a, _b = props.onMouseLeave, onMouseLeave = _b === void 0 ? function () { } : _b;
    return (react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        react.createElement("path", { d: 'M10.4093 3.99365C9.96773 3.99365 9.60933 4.35205 9.60933 4.79365V18.3937H13.6093V4.79365C13.6093 4.35205 13.2509 3.99365 12.8093 3.99365H10.4093ZM0.809326 5.59365V21.5937H20.8093V19.9937H2.40933V5.59365H0.809326ZM16.0093 5.59365C15.5677 5.59365 15.2093 5.95205 15.2093 6.39365V18.3937H19.2093V6.39365C19.2093 5.95205 18.8509 5.59365 18.4093 5.59365H16.0093ZM4.80933 8.79365C4.36773 8.79365 4.00933 9.15205 4.00933 9.59365V18.3937H8.00933V9.59365C8.00933 9.15205 7.65093 8.79365 7.20933 8.79365H4.80933Z', fill: '#005AFF' })));
};
var StatsIcon$1 = react.memo(StatsIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/PopoverWhatNew.css.js
'use client';






var whatNewOpen = (0,styled_components_browser_esm/* keyframes */.F4)(PopoverWhatNew_css_templateObject_1 || (PopoverWhatNew_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var whatNewClose = (0,styled_components_browser_esm/* keyframes */.F4)(PopoverWhatNew_css_templateObject_2 || (PopoverWhatNew_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var PopoverWhatNewsWrapper = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_3 || (PopoverWhatNew_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    height: 24px;\n    display: flex;\n    > svg {\n        cursor: pointer;\n        &:hover {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n"], ["\n    position: relative;\n    height: 24px;\n    display: flex;\n    > svg {\n        cursor: pointer;\n        &:hover {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n"])), constants/* colors.buttonColor */.O9.buttonColor);
var WhatNews = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_6 || (PopoverWhatNew_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 350px;\n    z-index: 1;\n    background-color: #fff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);\n    animation: ", " 0.25s ease-in-out;\n    ", "\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 350px;\n    z-index: 1;\n    background-color: #fff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);\n    animation: ", " 0.25s ease-in-out;\n    ", "\n"])), function (_a) {
    var isClose = _a.isClose;
    return (isClose ? whatNewClose : whatNewOpen);
}, function (_a) {
    var position = _a.position;
    if (position === 'left') {
        return (0,styled_components_browser_esm/* css */.iv)(PopoverWhatNew_css_templateObject_4 || (PopoverWhatNew_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                left: initial;\n                right: 44px;\n            "], ["\n                left: initial;\n                right: 44px;\n            "])));
    }
    else {
        return (0,styled_components_browser_esm/* css */.iv)(PopoverWhatNew_css_templateObject_5 || (PopoverWhatNew_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                left: 44px;\n                right: initial;\n            "], ["\n                left: 44px;\n                right: initial;\n            "])));
    }
});
var WhatNewsHeader = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_7 || (PopoverWhatNew_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: #333;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    > svg {\n        margin-right: 8px;\n    }\n"], ["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: #333;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    > svg {\n        margin-right: 8px;\n    }\n"])));
var PopoverWhatNew_css_CloseIconWrapper = styled_components_browser_esm/* default.span */.ZP.span(PopoverWhatNew_css_templateObject_8 || (PopoverWhatNew_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 24px;\n    svg {\n        path {\n            fill: #888;\n        }\n    }\n    &:hover {\n        cursor: pointer;\n        svg {\n            path {\n                fill: #000;\n            }\n        }\n    }\n"], ["\n    position: absolute;\n    right: 24px;\n    svg {\n        path {\n            fill: #888;\n        }\n    }\n    &:hover {\n        cursor: pointer;\n        svg {\n            path {\n                fill: #000;\n            }\n        }\n    }\n"])));
var WhatNewsBody = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_9 || (PopoverWhatNew_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 20px 0;\n    color: #333;\n    p {\n        margin-top: 20px;\n        text-align: initial;\n    }\n"], ["\n    margin: 20px 0;\n    color: #333;\n    p {\n        margin-top: 20px;\n        text-align: initial;\n    }\n"])));
var WhatNewsFooter = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_10 || (PopoverWhatNew_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: right;\n"], ["\n    text-align: right;\n"])));
var WhatNewImg = styled_components_browser_esm/* default.img */.ZP.img(PopoverWhatNew_css_templateObject_11 || (PopoverWhatNew_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    border-radius: 6px;\n"], ["\n    width: 100%;\n    border-radius: 6px;\n"])));
var ResponsiveLine = styled_components_browser_esm/* default.p */.ZP.p(PopoverWhatNew_css_templateObject_12 || (PopoverWhatNew_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 16px !important;\n    color: #333;\n"], ["\n    margin-top: 16px !important;\n    color: #333;\n"])));
var WhatNewsBg = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_13 || (PopoverWhatNew_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.65);\n    z-index: 1;\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.65);\n    z-index: 1;\n"])));
var WowCVLink = styled_components_browser_esm/* default.a */.ZP.a(PopoverWhatNew_css_templateObject_14 || (PopoverWhatNew_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    cursor: pointer !important;\n    &:hover {\n        color: ", ";\n        path {\n            fill: ", ";\n        }\n    }\n"], ["\n    color: ", ";\n    cursor: pointer !important;\n    &:hover {\n        color: ", ";\n        path {\n            fill: ", ";\n        }\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor, constants/* colors.buttonColor */.O9.buttonColor);
var Splitter = styled_components_browser_esm/* default.span */.ZP.span(PopoverWhatNew_css_templateObject_15 || (PopoverWhatNew_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 2px;\n    background-color: #f4f4f7;\n    height: 18px;\n    margin-left: 16px;\n    margin-right: 16px;\n"], ["\n    width: 2px;\n    background-color: #f4f4f7;\n    height: 18px;\n    margin-left: 16px;\n    margin-right: 16px;\n"])));
var StatsIconGroup = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_16 || (PopoverWhatNew_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 24px;\n    height: 24px;\n    position: relative;\n    ", " {\n        min-width: 250px;\n        text-align: center;\n    }\n    &:hover {\n        cursor: pointer;\n        > svg > path {\n            fill: ", ";\n        }\n    }\n    .description {\n        color: #333;\n    }\n"], ["\n    width: 24px;\n    height: 24px;\n    position: relative;\n    ", " {\n        min-width: 250px;\n        text-align: center;\n    }\n    &:hover {\n        cursor: pointer;\n        > svg > path {\n            fill: ", ";\n        }\n    }\n    .description {\n        color: #333;\n    }\n"])), StyledToolTip, constants/* colors.buttonColor */.O9.buttonColor);
var WowCVGroup = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_17 || (PopoverWhatNew_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 24px;\n    height: 24px;\n    position: relative;\n    ", " {\n        min-width: 180px;\n        text-align: center;\n    }\n    .description {\n        color: #333;\n    }\n"], ["\n    width: 24px;\n    height: 24px;\n    position: relative;\n    ", " {\n        min-width: 180px;\n        text-align: center;\n    }\n    .description {\n        color: #333;\n    }\n"])), StyledToolTip);
var ResponseBottomAction = styled_components_browser_esm/* default.div */.ZP.div(PopoverWhatNew_css_templateObject_18 || (PopoverWhatNew_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    margin: 0;\n    padding: 16px;\n    > button {\n        width: 50%;\n        margin: 0;\n        &:first-child {\n            margin-right: 4px !important;\n        }\n        &:last-child {\n            margin-left: 4px;\n        }\n        &:only-child {\n            width: 100%;\n            margin-right: 0;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    margin: 0;\n    padding: 16px;\n    > button {\n        width: 50%;\n        margin: 0;\n        &:first-child {\n            margin-right: 4px !important;\n        }\n        &:last-child {\n            margin-left: 4px;\n        }\n        &:only-child {\n            width: 100%;\n            margin-right: 0;\n        }\n    }\n"])));
var PopoverWhatNew_css_templateObject_1, PopoverWhatNew_css_templateObject_2, PopoverWhatNew_css_templateObject_3, PopoverWhatNew_css_templateObject_4, PopoverWhatNew_css_templateObject_5, PopoverWhatNew_css_templateObject_6, PopoverWhatNew_css_templateObject_7, PopoverWhatNew_css_templateObject_8, PopoverWhatNew_css_templateObject_9, PopoverWhatNew_css_templateObject_10, PopoverWhatNew_css_templateObject_11, PopoverWhatNew_css_templateObject_12, PopoverWhatNew_css_templateObject_13, PopoverWhatNew_css_templateObject_14, PopoverWhatNew_css_templateObject_15, PopoverWhatNew_css_templateObject_16, PopoverWhatNew_css_templateObject_17, PopoverWhatNew_css_templateObject_18;


//# sourceMappingURL=PopoverWhatNew.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CommercialIcon/index.js
'use client';



var CommercialIcon = function () {
    return (react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M18.7998 3.2002C18.1374 3.2002 17.5998 3.7378 17.5998 4.4002V4.49238L8.7998 7.2002V15.2002L17.5998 17.908V18.0002C17.5998 18.6626 18.1374 19.2002 18.7998 19.2002C19.4622 19.2002 19.9998 18.6626 19.9998 18.0002V4.4002C19.9998 3.7378 19.4622 3.2002 18.7998 3.2002ZM7.1998 7.35957L2.24043 7.85645C1.42283 7.93805 0.799805 8.62623 0.799805 9.44863V12.9518C0.799805 13.7742 1.42283 14.4623 2.24043 14.5439L4.18418 14.7393L5.10449 20.1346C5.16929 20.5194 5.50239 20.8002 5.89199 20.8002H6.3998C6.8414 20.8002 7.1998 20.4418 7.1998 20.0002L7.19668 15.0408H7.1998V7.35957ZM21.5998 9.2002V13.2002L21.9873 13.1033C22.6993 12.9249 23.1998 12.2854 23.1998 11.5518V10.8502C23.1998 10.1158 22.6993 9.47547 21.9873 9.29707L21.5998 9.2002Z', fill: '#005AFF' })));
};
var CommercialIcon$1 = react.memo(CommercialIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(54033);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/translations.js
'use client';

var PopoverWhatNew_translations_translations = {
    "What's new": 'Tính năng mới',
    'View Win Rate Details': 'Xem Chi Tiết Tỷ Lệ Thắng',
    'Got It': 'Đã Hiểu',
    'View stats': 'Xem thống kê',
    'Track My Competitive Rate': 'Theo Dõi Tỷ Lệ Cạnh Tranh Của Tôi',
    'Track my competitive rate': 'Theo dõi tỷ lệ cạnh tranh của tôi',
    'VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.': 'VietnamWorks tính toán tỷ lệ cạnh tranh của bạn dựa trên thông tin ứng tuyển của bạn và so sánh nó với các ứng viên khác cho công việc này sau khi bạn ứng tuyển.',
    '/track-my-competitive-rate/': '/theo-doi-ty-le-canh-tranh-cua-toi/',
    'Create CV to apply': 'Tạo CV để ứng tuyển',
    'Apply Now': 'Nộp Đơn'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/constants.js
'use client';

var getBannerImageResponsive = function (langCode) {
    if (langCode === void 0) { langCode = 'vi'; }
    return "https://images.vietnamworks.com/images/view-applied-candidates/responsive-competitive-".concat(langCode, ".png");
};
var VNW_APPLIED_CANDIDATE = 'VNW_APPLIED_CANDIDATE';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/helper.js
'use client';

/**
 * Check is mobile when innerWidth is smaller or equal 768
 * @returns boolean isMobile or not
 */
function isMobile() {
    if (typeof window !== 'undefined') {
        return window.innerWidth <= 768;
    }
    return false;
}


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/WowCVIcon/index.js
'use client';



var WowCVIcon = function (props) {
    var onClick = props.onClick, _a = props.onMouseOver, onMouseOver = _a === void 0 ? function () { } : _a, _b = props.onMouseLeave, onMouseLeave = _b === void 0 ? function () { } : _b;
    return (react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        react.createElement("path", { d: 'M2.69231 1C1.75731 1 1 1.75731 1 2.69231V17.9231C1 18.8581 1.75731 19.6154 2.69231 19.6154H4.00947C3.71839 19.1153 3.53846 18.5425 3.53846 17.9231V2.69231C3.53846 2.07292 3.71839 1.50008 4.00947 1H2.69231ZM6.92308 1C5.98808 1 5.23077 1.75731 5.23077 2.69231V17.9231C5.23077 18.8581 5.98808 19.6154 6.92308 19.6154H12.8462V15.3846H8.61538C8.14831 15.3846 7.76923 15.0055 7.76923 14.5385C7.76923 14.0714 8.14831 13.6923 8.61538 13.6923H12.8462C12.8462 12.7573 13.6035 12 14.5385 12H19.6154V2.69231C19.6154 1.75731 18.8581 1 17.9231 1H6.92308ZM10.7308 3.53846C11.4373 3.53846 11.6562 4.05409 11.6562 4.05409C12.2875 4.05409 12.5817 4.76665 12.5817 5.60096C12.5817 6.01727 12.4181 6.36283 12.4181 6.36283C12.4833 6.40514 12.5923 6.53742 12.5652 6.77434C12.5144 7.21519 12.343 7.32693 12.2347 7.33624C12.1932 7.74747 11.7959 8.27481 11.6562 8.35096V9.03846C11.9338 9.965 13.2853 9.51146 13.6923 11.1538H7.76923C8.17623 9.51146 9.5286 9.965 9.80529 9.03846V8.35096C9.66652 8.27481 9.26917 7.74747 9.22686 7.33624C9.11771 7.32693 8.94545 7.21519 8.89468 6.77434C8.8676 6.53742 8.97661 6.40514 9.04177 6.36283C9.04177 6.36283 8.87816 5.98088 8.87816 5.60096C8.879 4.47304 9.42177 3.53846 10.7308 3.53846ZM15.3846 5.23077H17.0769C17.544 5.23077 17.9231 5.60985 17.9231 6.07692C17.9231 6.544 17.544 6.92308 17.0769 6.92308H15.3846C14.9175 6.92308 14.5385 6.544 14.5385 6.07692C14.5385 5.60985 14.9175 5.23077 15.3846 5.23077ZM15.3846 8.61538H17.0769C17.544 8.61538 17.9231 8.99446 17.9231 9.46154C17.9231 9.92862 17.544 10.3077 17.0769 10.3077H15.3846C14.9175 10.3077 14.5385 9.92862 14.5385 9.46154C14.5385 8.99446 14.9175 8.61538 15.3846 8.61538ZM15.3846 13.6923C14.9175 13.6923 14.5385 14.0714 14.5385 14.5385V16.2308H23V14.5385C23 14.0714 22.6209 13.6923 22.1538 13.6923H15.3846ZM14.5385 17.0769V19.6154H23V17.0769H14.5385ZM14.5385 20.4615V22.1538C14.5385 22.6209 14.9175 23 15.3846 23H22.1538C22.6209 23 23 22.6209 23 22.1538V20.4615H14.5385Z', fill: '#005AFF' })));
};
var WowCVIcon$1 = react.memo(WowCVIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/services.js
'use client';



var API_POST_TRACKING_EVENT = '/api-gateway/v1.0/candidate-report/popup-track-win-rate';
var API_GET_OPEN_STATUS = '/api-gateway/v1.0/candidate-report/popup-track-win-rate';
var apiTrackingEvent = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var baseUrl, accessToken, _a, langCode, postData, apiUrl, response, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                baseUrl = params.baseUrl, accessToken = params.accessToken, _a = params.langCode, langCode = _a === void 0 ? 'vi' : _a, postData = params.postData;
                apiUrl = "".concat(baseUrl).concat(API_POST_TRACKING_EVENT);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_1 = _b.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiGetOpenStatus = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var baseUrl, accessToken, _a, langCode, jobId, apiUrl, response, responseJson, ex_2;
    return (0,_tslib/* __generator */.Jh)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                baseUrl = params.baseUrl, accessToken = params.accessToken, _a = params.langCode, langCode = _a === void 0 ? 'vi' : _a, jobId = params.jobId;
                if (!jobId) {
                    return [2 /*return*/, false];
                }
                if (!accessToken) {
                    return [2 /*return*/, false];
                }
                apiUrl = "".concat(baseUrl).concat(API_GET_OPEN_STATUS, "?jobId=").concat(jobId);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()
                    // API return status true is close, false is open
                ];
            case 2:
                responseJson = _b.sent();
                // API return status true is close, false is open
                return [2 /*return*/, !responseJson.data.status];
            case 3:
                ex_2 = _b.sent();
                console.error(ex_2);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopoverWhatNew/index.js
'use client';


















var PopoverWhatNews = function (props) {
    var _a = props.displayPosition, displayPosition = _a === void 0 ? 'left' : _a, _b = props.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, _c = props.isApplied, isApplied = _c === void 0 ? false : _c, jobId = props.jobId, _d = props.disabledApply, disabledApply = _d === void 0 ? false : _d, _e = props.msBasePath, msBasePath = _e === void 0 ? 'https://ms.vietnamworks.com' : _e, _f = props.accessToken, accessToken = _f === void 0 ? '' : _f;
    var _g = (0,react.useState)(true), isOpen = _g[0], setOpen = _g[1];
    // Animation
    var _h = (0,react.useState)(false), isTracking = _h[0], setTracking = _h[1];
    var _j = (0,react.useState)(false), isMounted = _j[0], setMounted = _j[1];
    var _k = (0,react.useState)(false), isShowTooltip = _k[0], setShowTooltip = _k[1];
    var _l = (0,react.useState)(false), isShowWowCvTooltip = _l[0], setShowWowCVTooltip = _l[1];
    // Ref
    var closeCountRef = (0,react.useRef)(0);
    // Mobile
    var isInMobile = isMobile();
    var t = function (text) {
        var _a;
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = PopoverWhatNew_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClick = function () {
        // If element is mounted
        // Then dont setMounted, setOpen for animation
        if (isMounted) {
            setOpen(false);
            return;
        }
        if (isApplied) {
            // redirect to applied page
            window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
        }
        else {
            setMounted(true);
            setOpen(true);
        }
    };
    var onBottomClick = function () {
        setOpen(false);
        if (!isApplied) {
            // Eval can be harmful in case of dynamic script in it.
            // In this case we only eval initApplyForm (Show apply form in jobDetail page)
            // eslint-disable-next-line no-eval
            window.eval('initApplyModal()');
        }
        else {
            // redirect to applied page
            window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
        }
    };
    var onWhatNewDesktopAnimationEnd = function () {
        if (isOpen) {
            return;
        }
        setMounted(false);
        setOpen(true);
        (0,cookie/* setCookie */.d)(VNW_APPLIED_CANDIDATE, (closeCountRef.current + 1).toString(), 3);
    };
    var trackingClose = function (type) {
        if (!isTracking) {
            return;
        }
        var postData = {
            numberOfClose: 0,
            numberOfGotIt: 0,
            numberOfApplyNow: 0
        };
        if (type === 'CLOSE') {
            postData.numberOfClose++;
        }
        else if (type === 'APPLY_NOW') {
            postData.numberOfApplyNow++;
        }
        else if (type === 'GOT_IT') {
            postData.numberOfGotIt++;
        }
        apiTrackingEvent({
            baseUrl: msBasePath,
            accessToken: accessToken,
            jobId: jobId,
            postData: postData,
            langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'
        });
    };
    (0,react.useEffect)(function () {
        var getStatus = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var isOpenWithUser;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGetOpenStatus({
                            baseUrl: msBasePath,
                            accessToken: accessToken,
                            jobId: jobId,
                            langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'
                        })];
                    case 1:
                        isOpenWithUser = _a.sent();
                        setMounted(isOpenWithUser);
                        setTracking(isOpenWithUser);
                        return [2 /*return*/];
                }
            });
        }); };
        // Check user logged in or not
        if (accessToken === '') {
            var appliedCandidateCloseCount = 0;
            var appliedCandidateCookie = (0,cookie/* getCookie */.e)(VNW_APPLIED_CANDIDATE);
            if (appliedCandidateCookie !== null) {
                appliedCandidateCloseCount = Number(appliedCandidateCookie);
            }
            // Make sure it is not a number
            if (isNaN(appliedCandidateCloseCount)) {
                appliedCandidateCloseCount = 0;
            }
            closeCountRef.current = appliedCandidateCloseCount;
            if (appliedCandidateCloseCount < 2) {
                setMounted(true);
            }
        }
        else {
            getStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var renderBottomAction = function () {
        return isApplied ? (react.createElement(Button/* default */.Z, { type: 'primary', onClick: onBottomClick }, t('View stats'))) : (react.createElement(react.Fragment, null,
            react.createElement(Button/* default */.Z, { type: 'default', onClick: function () {
                    setOpen(false);
                    trackingClose('GOT_IT');
                }, style: { marginRight: 8 } }, t('Got It')),
            react.createElement(Button/* default */.Z, { type: 'primary', onClick: function () {
                    trackingClose('APPLY_NOW');
                    onBottomClick();
                }, disabled: disabledApply }, t('Apply Now'))));
    };
    var renderWhatNew = function () {
        if (isInMobile) {
            var bannerImg_1 = getBannerImageResponsive(langCode);
            return isMounted ? (react.createElement(BottomSheet/* default */.Z, { onClose: function () {
                    setMounted(false);
                    (0,cookie/* setCookie */.d)(VNW_APPLIED_CANDIDATE, (closeCountRef.current + 1).toString(), 3);
                }, trackingOnClose: function (type) {
                    if (type === 'BACKDROP') {
                        trackingClose('CLOSE');
                    }
                }, header: react.createElement(WhatNewsHeader, null,
                    react.createElement(CommercialIcon$1, null),
                    t("What's new")), isOpen: isOpen, footer: react.createElement(ResponseBottomAction, null, renderBottomAction()) },
                react.createElement(react.Fragment, null,
                    react.createElement(WhatNewImg, { src: bannerImg_1, alt: t("What's new") }),
                    react.createElement(ResponsiveLine, null, t('VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.'))))) : null;
        }
        // Desktop
        // Desktop using same image as responsive
        var bannerImg = getBannerImageResponsive(langCode);
        return isMounted ? (react.createElement(react.Fragment, null,
            react.createElement(WhatNewsBg, { onClick: function () {
                    setOpen(false);
                    trackingClose('CLOSE');
                } }),
            react.createElement(WhatNews, { isClose: !isOpen, position: displayPosition, onAnimationEnd: onWhatNewDesktopAnimationEnd },
                react.createElement(WhatNewsHeader, null,
                    react.createElement(CommercialIcon$1, null),
                    t("What's new"),
                    react.createElement(PopoverWhatNew_css_CloseIconWrapper, { onClick: function () {
                            setOpen(false);
                            trackingClose('CLOSE');
                        } },
                        react.createElement(CloseIcon/* default */.Z, null))),
                react.createElement(WhatNewsBody, null,
                    react.createElement(WhatNewImg, { src: bannerImg, alt: t("What's new") }),
                    react.createElement("p", null, t('VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.'))),
                react.createElement(WhatNewsFooter, null, renderBottomAction())))) : null;
    };
    return (react.createElement(PopoverWhatNewsWrapper, { "data-test-update": 'updated' },
        react.createElement(StatsIconGroup, null,
            react.createElement(StatsIcon$1, { onClick: onClick, onMouseOver: function () { return setShowTooltip(true); }, onMouseLeave: function () { return setShowTooltip(false); } }),
            isShowTooltip && (react.createElement(Tooltip, { isShow: isShowTooltip, placement: 'bottom', description: t('Track my competitive rate') })),
            renderWhatNew()),
        react.createElement(Splitter, null),
        react.createElement(WowCVGroup, null,
            react.createElement(WowCVLink, { href: "/wowcv".concat(langCode === constants/* ELanguage.EN */.Df.EN ? '/en' : ''), onMouseOver: function () {
                    if (isInMobile) {
                        return;
                    }
                    setShowWowCVTooltip(true);
                }, onMouseLeave: function () { return setShowWowCVTooltip(false); } },
                react.createElement(WowCVIcon$1, null)),
            isShowWowCvTooltip && (react.createElement(Tooltip, { isShow: isShowWowCvTooltip, placement: 'bottom', description: t('Create CV to apply') })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ProgressBar/constant.js
'use client';



var DEFAULT_STYLE_OPTION = {
    bgColor: constants/* colors.bgHover */.O9.bgHover,
    color: constants/* colors.primaryColor */.O9.primaryColor,
    width: '100%',
    isHaveBorder: true,
    isOverlayMarginBottom: false,
    gutter: 0,
    labelBreakpoint: {
        xs: 8,
        sm: 8,
        md: 8,
        lg: 8,
        xl: 8
    },
    progressBreakpoint: {
        xs: 16,
        sm: 16,
        md: 16,
        lg: 16,
        xl: 16
    }
};


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ProgressBar/ProgressBar.css.js
'use client';







var ProgressWrapper = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z)(ProgressBar_css_templateObject_2 || (ProgressBar_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    border: ", ";\n    border-radius: 6px;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    border: ", ";\n    border-radius: 6px;\n    ", "\n"])), function (_a) {
    var isHaveBorder = _a.isHaveBorder;
    return (isHaveBorder ? '1px solid #edf3ff' : '0px solid transparent');
}, function (_a) {
    var isOverlayMarginBottom = _a.isOverlayMarginBottom;
    if (!isOverlayMarginBottom) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(ProgressBar_css_templateObject_1 || (ProgressBar_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-bottom: -1px;\n        "], ["\n            margin-bottom: -1px;\n        "])));
});
var progressBarStriped = (0,styled_components_browser_esm/* keyframes */.F4)(ProgressBar_css_templateObject_3 || (ProgressBar_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        background-position: 1rem 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n"], ["\n    0% {\n        background-position: 1rem 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n"])));
var ProgressBarView = styled_components_browser_esm/* default.div */.ZP.div(ProgressBar_css_templateObject_4 || (ProgressBar_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    position: relative;\n    top: 1px;\n    overflow: hidden;\n    .progress-bar-striped {\n        \n    }\n    &::before {\n        display: block;\n        content: ' ';\n        height: ", "px;\n        border-radius: ", ";\n        width: ", "%;\n        ", ";\n        animation: ", " 1s linear infinite;\n        background-color: ", ";\n    }\n"], ["\n    width: ", ";\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    position: relative;\n    top: 1px;\n    overflow: hidden;\n    .progress-bar-striped {\n        \n    }\n    &::before {\n        display: block;\n        content: ' ';\n        height: ", "px;\n        border-radius: ", ";\n        width: ", "%;\n        ", ";\n        animation: ", " 1s linear infinite;\n        background-color: ", ";\n    }\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var size = _a.size;
    return size !== null && size !== void 0 ? size : 8;
}, function (_a) {
    var bgColor = _a.bgColor;
    return (!bgColor ? '#007C0A' : bgColor);
}, function (_a) {
    var size = _a.size;
    return size !== null && size !== void 0 ? size : 8;
}, function (_a) {
    var hasAnim = _a.hasAnim;
    return (!hasAnim ? "6px" : "0px");
}, function (_a) {
    var percent = _a.percent;
    return percent;
}, function (_a) {
    var hasAnim = _a.hasAnim;
    return (!hasAnim ? "background-color:" + constants/* colors.primaryColor */.O9.primaryColor : "background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n        background-size: 1rem 1rem;");
}, progressBarStriped, function (_a) {
    var color = _a.color;
    return (!color ? constants/* colors.primaryColor */.O9.primaryColor : color);
});
var ProgressLabel = styled_components_browser_esm/* default.label */.ZP.label(ProgressBar_css_templateObject_5 || (ProgressBar_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-right: 8px;\n    width: 100%;\n    margin-bottom: 0 !important;\n    line-height: 15px;\n"], ["\n    margin-right: 8px;\n    width: 100%;\n    margin-bottom: 0 !important;\n    line-height: 15px;\n"])));
var ProgressValueText = styled_components_browser_esm/* default.div */.ZP.div(ProgressBar_css_templateObject_6 || (ProgressBar_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 8px;\n    width: 42px;\n    color: #333;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 15px;\n    text-align: right;\n    flex: 1;\n"], ["\n    margin-left: 8px;\n    width: 42px;\n    color: #333;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 15px;\n    text-align: right;\n    flex: 1;\n"])));
var ProgressBarWrapper = styled_components_browser_esm/* default.div */.ZP.div(ProgressBar_css_templateObject_7 || (ProgressBar_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n    width: 100%;\n"], ["\n    display: inline-flex;\n    align-items: center;\n    width: 100%;\n"])));
var ProgressCol = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z)(ProgressBar_css_templateObject_8 || (ProgressBar_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var ProgressBar_css_templateObject_1, ProgressBar_css_templateObject_2, ProgressBar_css_templateObject_3, ProgressBar_css_templateObject_4, ProgressBar_css_templateObject_5, ProgressBar_css_templateObject_6, ProgressBar_css_templateObject_7, ProgressBar_css_templateObject_8;


//# sourceMappingURL=ProgressBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ProgressBar/index.js
'use client';






var ProgressBar = function (props) {
    var _a, _b;
    var label = props.label, percent = props.percent, _c = props.valueText, valueText = _c === void 0 ? '' : _c, styleOptions = props.styleOptions, _d = props.style, style = _d === void 0 ? {} : _d, _e = props.className, className = _e === void 0 ? '' : _e, hasAnim = props.hasAnim;
    var mergedStyleOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_STYLE_OPTION), styleOptions);
    var labelBreakpoint = mergedStyleOptions.labelBreakpoint, progressBreakpoint = mergedStyleOptions.progressBreakpoint;
    return (react.createElement(ProgressWrapper, { gutter: mergedStyleOptions.gutter || 0, isHaveBorder: (_a = mergedStyleOptions.isHaveBorder) !== null && _a !== void 0 ? _a : true, isOverlayMarginBottom: (_b = mergedStyleOptions.isOverlayMarginBottom) !== null && _b !== void 0 ? _b : false, className: className, style: style },
        label && (react.createElement(ProgressCol, { xs: labelBreakpoint === null || labelBreakpoint === void 0 ? void 0 : labelBreakpoint.xs, sm: labelBreakpoint === null || labelBreakpoint === void 0 ? void 0 : labelBreakpoint.sm, md: labelBreakpoint === null || labelBreakpoint === void 0 ? void 0 : labelBreakpoint.md, lg: labelBreakpoint === null || labelBreakpoint === void 0 ? void 0 : labelBreakpoint.lg, xl: labelBreakpoint === null || labelBreakpoint === void 0 ? void 0 : labelBreakpoint.xl },
            react.createElement(ProgressLabel, null, label))),
        react.createElement(ProgressCol, { xs: progressBreakpoint === null || progressBreakpoint === void 0 ? void 0 : progressBreakpoint.xs, sm: progressBreakpoint === null || progressBreakpoint === void 0 ? void 0 : progressBreakpoint.sm, md: progressBreakpoint === null || progressBreakpoint === void 0 ? void 0 : progressBreakpoint.md, lg: progressBreakpoint === null || progressBreakpoint === void 0 ? void 0 : progressBreakpoint.lg, xl: progressBreakpoint === null || progressBreakpoint === void 0 ? void 0 : progressBreakpoint.xl },
            react.createElement(ProgressBarWrapper, null,
                react.createElement(ProgressBarView, { percent: percent, bgColor: mergedStyleOptions.bgColor, color: mergedStyleOptions.color, width: mergedStyleOptions.width || '100%', size: mergedStyleOptions.size, hasAnim: hasAnim }),
                valueText && react.createElement(ProgressValueText, null, valueText)))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/UploadIcon/index.js
var UploadIcon = __webpack_require__(63606);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/service.js
'use client';






function changeJobTitle(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/job-title"), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                jobTitle: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function changePhoneNumber(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, err_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/change-phone"), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                phone: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var uploadFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/update-resume-file"), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    error_1 = _b.sent();
                    console.error('apiDoUpload ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var validateFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, userId = _a.userId, jobId = _a.jobId;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var formData, response, data, error_2, data;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('jobId', jobId ? String(jobId) : '0');
                    formData.append('jobseekerId', userId ? String(userId) : '0');
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/attached-resumes-validation/v1/validate-resume"), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_2 = _b.sent();
                    console.error('apiDoValidate ', error_2);
                    data = {
                        meta: {
                            statusCode: 413,
                            message: langCode === constants/* ELanguage.VI */.Df.VI
                                ? 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'
                                : '.doc, .docx and .pdf files that are less than 5120KB in size'
                        }
                    };
                    return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var getInfoWhenApplyOneClick = function (_a) {
    var jobid = _a.jobid, baseUrl = _a.baseUrl, langCode = _a.langCode;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var body, response, data, error_3;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    body = {
                        action: 'loadApplyForm',
                        jobid: String(jobid)
                    };
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/jobseekers/apply_on_oneclick.php"), {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode,
                                'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'x-requested-with': 'XMLHttpRequest'
                            },
                            body: (0,urlBuilder/* objToQueryStr */.G7)(body)
                        })];
                case 1:
                    response = _b.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, data), { resumes: JSON.parse(data === null || data === void 0 ? void 0 : data.resumes) })];
                case 3: return [2 /*return*/, null];
                case 4:
                    error_3 = _b.sent();
                    console.error(error_3);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var applyJobs = function (params, baseUrl, langCode) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var formData, VNW_TRACKING_GA, VNW_TRACKING_GA_FIRST, utmGA, utmGAFirst, newParams, _i, _a, _b, key, value, _c, _d, _e, key, value, response, data, error_4, data;
    var _f, _g;
    return (0,_tslib/* __generator */.Jh)(this, function (_h) {
        switch (_h.label) {
            case 0:
                formData = new FormData();
                VNW_TRACKING_GA = (_f = (0,cookie/* getCookie */.e)('VNW_TRACKING_GA')) !== null && _f !== void 0 ? _f : '';
                VNW_TRACKING_GA_FIRST = (_g = (0,cookie/* getCookie */.e)('VNW_TRACKING_GA_FIRST')) !== null && _g !== void 0 ? _g : '';
                utmGA = JSON.parse(decodeURIComponent(VNW_TRACKING_GA));
                utmGAFirst = JSON.parse(decodeURIComponent(VNW_TRACKING_GA_FIRST));
                newParams = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, params), utmGA);
                for (_i = 0, _a = Object.entries(newParams); _i < _a.length; _i++) {
                    _b = _a[_i], key = _b[0], value = _b[1];
                    if (key && value) {
                        if (key.startsWith('utm')) {
                            formData.append("utms[".concat(key, "]"), value);
                        }
                        else {
                            formData.append(key, value);
                        }
                    }
                }
                for (_c = 0, _d = Object.entries(utmGAFirst); _c < _d.length; _c++) {
                    _e = _d[_c], key = _e[0], value = _e[1];
                    if (key && value) {
                        formData.append("utms[".concat(key, "_first]"), value);
                    }
                }
                _h.label = 1;
            case 1:
                _h.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "/jobseekers/apply_on_oneclick.php"), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept-Language': langCode
                        },
                        body: formData
                    })];
            case 2:
                response = _h.sent();
                if (!response) return [3 /*break*/, 4];
                return [4 /*yield*/, response.json()];
            case 3:
                data = _h.sent();
                return [2 /*return*/, data];
            case 4: return [2 /*return*/];
            case 5:
                error_4 = _h.sent();
                if (error_4.message === 'Timeout' ||
                    error_4.message === 'Network request failed' ||
                    error_4.message === 'Failed to fetch') {
                    data = {
                        status: 'ERROR',
                        message: langCode === constants/* ELanguage.EN */.Df.EN
                            ? 'No internet connection. Please check your internet connection and try again.'
                            : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.'
                    };
                    return [2 /*return*/, data];
                }
                console.error(error_4);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
function getProfileLevel(accessToken, langCode, baseUrl) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, data, err_3;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/level"), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getResumeSettingInfo(accessToken, langCode, baseUrl) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, data, err_4;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.1/profile/resume-setting-info?date=").concat(Date.now()), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_4 = _a.sent();
                    console.error(err_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var service_getJobLevelList = function (langCode, baseMsUrl) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response, dataJs, relationships, err_5;
    var _a, _b;
    return (0,_tslib/* __generator */.Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/meta/v1.0/job-levels"), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                dataJs = _c.sent();
                relationships = (_a = dataJs === null || dataJs === void 0 ? void 0 : dataJs.data) === null || _a === void 0 ? void 0 : _a.relationships;
                if ((relationships === null || relationships === void 0 ? void 0 : relationships.data) && ((_b = relationships === null || relationships === void 0 ? void 0 : relationships.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return [2 /*return*/, relationships.data];
                }
                return [2 /*return*/, null];
            case 3:
                err_5 = _c.sent();
                console.error(err_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
function getPrivacyPolicy(params) {
    var _a, _b, _c;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var langCode, body, _d, accessToken, _e, baseUrl, URL_1, res, responseData, ex_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    langCode = params.langCode, body = params.body, _d = params.accessToken, accessToken = _d === void 0 ? '' : _d, _e = params.baseUrl, baseUrl = _e === void 0 ? '' : _e;
                    if (accessToken === '') {
                        return [2 /*return*/, []];
                    }
                    if (baseUrl === '') {
                        return [2 /*return*/, []];
                    }
                    URL_1 = "".concat(baseUrl, "/api-gateway/v1.0/job/policies");
                    return [4 /*yield*/, fetch(URL_1, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    res = _f.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    responseData = _f.sent();
                    if ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _a === void 0 ? void 0 : _a.jobPolicies) {
                        return [2 /*return*/, (_c = (_b = responseData.data) === null || _b === void 0 ? void 0 : _b.jobPolicies) !== null && _c !== void 0 ? _c : []];
                    }
                    return [2 /*return*/, []];
                case 3:
                    ex_1 = _f.sent();
                    console.error(ex_1);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=service.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/Styled.css.js
'use client';








var PopupQuickApplyJob = (0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(Styled_css_templateObject_1 || (Styled_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .vnw-popup-content {\n        max-width: 630px !important;\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        /* height: 100%; */\n        overflow: hidden auto;\n        @media screen and (max-width: 768px) {\n            max-width: unset !important;\n        }\n    }\n"], ["\n    .vnw-popup-content {\n        max-width: 630px !important;\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        /* height: 100%; */\n        overflow: hidden auto;\n        @media screen and (max-width: 768px) {\n            max-width: unset !important;\n        }\n    }\n"])));
var Styled_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_2 || (Styled_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: auto;\n    padding: 16px;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    p {\n        margin: 0;\n    }\n"], ["\n    width: 100%;\n    height: auto;\n    padding: 16px;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    p {\n        margin: 0;\n    }\n"])));
var ButtonWrap = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_3 || (Styled_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    padding: 0 16px;\n    > button {\n        margin-bottom: 16px;\n        width: 100%;\n    }\n"], ["\n    width: 100%;\n    padding: 0 16px;\n    > button {\n        margin-bottom: 16px;\n        width: 100%;\n    }\n"])));
(0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(Styled_css_templateObject_4 || (Styled_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #fff;\n    background-color: ", ";\n    border: 1px solid ", ";\n    min-height: 40px;\n    margin-bottom: 15px;\n    width: 100%;\n    :hover {\n        background-color: #fd6333;\n        border: 1px solid #fd6333;\n    }\n    :focus,\n    :active {\n        background-color: #ed4d1b !important;\n        border: 1px solid #fff !important;\n        box-shadow: 0 0 0 1px #ed4d1b !important;\n    }\n"], ["\n    color: #fff;\n    background-color: ", ";\n    border: 1px solid ", ";\n    min-height: 40px;\n    margin-bottom: 15px;\n    width: 100%;\n    :hover {\n        background-color: #fd6333;\n        border: 1px solid #fd6333;\n    }\n    :focus,\n    :active {\n        background-color: #ed4d1b !important;\n        border: 1px solid #fff !important;\n        box-shadow: 0 0 0 1px #ed4d1b !important;\n    }\n"])), constants/* colors.buttonColor */.O9.buttonColor, constants/* colors.buttonColor */.O9.buttonColor);
var Head = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_5 || (Styled_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 8px;\n    width: 100%;\n    position: relative;\n"], ["\n    display: flex;\n    gap: 8px;\n    width: 100%;\n    position: relative;\n"])));
var CloseBtn = styled_components_browser_esm/* default.button */.ZP.button(Styled_css_templateObject_6 || (Styled_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    outline: none !important;\n    width: fit-content;\n    top: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    position: absolute;\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    outline: none !important;\n    width: fit-content;\n    top: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
var AvatarCompany = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_7 || (Styled_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 64px;\n    height: 64px;\n    border-radius: 10px;\n    img {\n        border-radius: 10px;\n        width: 64px;\n        height: 64px;\n        object-fit: contain;\n        background-color: #fff;\n    }\n"], ["\n    width: 64px;\n    height: 64px;\n    border-radius: 10px;\n    img {\n        border-radius: 10px;\n        width: 64px;\n        height: 64px;\n        object-fit: contain;\n        background-color: #fff;\n    }\n"])));
var Styled_css_CompanyInfo = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_8 || (Styled_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    color: #333;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    color: #333;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n"])));
var TextTruncate = styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_9 || (Styled_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: calc(100% - 15px);\n    color: ", ";\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: 1;\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    width: calc(100% - 15px);\n    color: ", ";\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: 1;\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])), constants/* colors.textColor */.O9.textColor);
var Body = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_10 || (Styled_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid #b3ceff;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    gap: 16px;\n"], ["\n    border: 1px solid #b3ceff;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    gap: 16px;\n"])));
var User = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_11 || (Styled_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    @media screen and (max-width: 425px) {\n        flex-direction: column;\n        align-items: center;\n        gap: 2px;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    @media screen and (max-width: 425px) {\n        flex-direction: column;\n        align-items: center;\n        gap: 2px;\n    }\n"])));
var UserInfo = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_12 || (Styled_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    font-size: 14px;\n    line-height: 18px;\n    color: #333;\n    gap: 12px;\n    @media screen and (max-width: 425px) {\n        align-items: center;\n        text-align: center;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    font-size: 14px;\n    line-height: 18px;\n    color: #333;\n    gap: 12px;\n    @media screen and (max-width: 425px) {\n        align-items: center;\n        text-align: center;\n    }\n"])));
var Info = {
    Name: styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_13 || (Styled_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-weight: 500;\n    "], ["\n        font-weight: 500;\n    "]))),
    Phone: styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_14 || (Styled_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        span {\n            color: ", ";\n        }\n    "], ["\n        span {\n            color: ", ";\n        }\n    "])), constants/* colors.primaryColor */.O9.primaryColor),
    Common: styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_15 || (Styled_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n    "], ["\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n    "])))
};
styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_16 || (Styled_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    width: auto;\n    gap: 4px;\n    > span {\n        color: ", ";\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    width: auto;\n    gap: 4px;\n    > span {\n        color: ", ";\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor);
var AvatarUser = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_17 || (Styled_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"], ["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"])));
var ApplyCV = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_18 || (Styled_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n    p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n        margin: 0;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n    p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n        margin: 0;\n    }\n"])));
var ApplyCVTitle = styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_19 || (Styled_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    span {\n        font-size: 12px;\n        line-height: 18px;\n        color: ", ";\n    }\n"], ["\n    span {\n        font-size: 12px;\n        line-height: 18px;\n        color: ", ";\n    }\n"])), constants/* colors.textColor */.O9.textColor);
var TextOrg = styled_components_browser_esm/* default.span */.ZP.span(Styled_css_templateObject_20 || (Styled_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), constants/* colors.buttonColor */.O9.buttonColor);
var Styled_css_Title = styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_21 || (Styled_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    width: calc(100% - 15px);\n    color: ", ";\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: 1;\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    width: calc(100% - 15px);\n    color: ", ";\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: 1;\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])), constants/* colors.textColor */.O9.textColor);
var UploadCV = styled_components_browser_esm/* default.label */.ZP.label(Styled_css_templateObject_22 || (Styled_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    pointer-events: ", ";\n    opacity: ", ";\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: 24px 12px;\n    gap: 10px;\n    border: 1px dashed ", ";\n    border-radius: 8px;\n    background-color: ", ";\n    cursor: pointer;\n    input {\n        display: none;\n        visibility: hidden;\n    }\n    div {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 5px;\n        padding: 0 15px;\n        text-align: center;\n        svg {\n            pointer-events: none;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n        }\n    }\n    p {\n        padding: 0 15px;\n        text-align: center;\n    }\n"], ["\n    pointer-events: ", ";\n    opacity: ", ";\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: 24px 12px;\n    gap: 10px;\n    border: 1px dashed ", ";\n    border-radius: 8px;\n    background-color: ", ";\n    cursor: pointer;\n    input {\n        display: none;\n        visibility: hidden;\n    }\n    div {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 5px;\n        padding: 0 15px;\n        text-align: center;\n        svg {\n            pointer-events: none;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n        }\n    }\n    p {\n        padding: 0 15px;\n        text-align: center;\n    }\n"])), function (_a) {
    var disable = _a.disable;
    return (!disable ? 'unset' : 'none');
}, function (_a) {
    var disable = _a.disable;
    return (!disable ? 1 : 0.5);
}, function (_a) {
    var active = _a.active;
    return (!active ? '#b3ceff' : constants/* colors.buttonColor */.O9.buttonColor);
}, function (_a) {
    var active = _a.active;
    return (!active ? '#fff' : 'rgba(255, 153, 0, 0.12)');
});
var CoverLetter = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_23 || (Styled_css_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px;\n    gap: 8px;\n    background: #fff;\n    border: 1px solid #b3ceff;\n    border-radius: 8px;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px;\n    gap: 8px;\n    background: #fff;\n    border: 1px solid #b3ceff;\n    border-radius: 8px;\n    width: 100%;\n"])));
var Styled_css_Textarea = styled_components_browser_esm/* default.textarea */.ZP.textarea(Styled_css_templateObject_24 || (Styled_css_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    resize: none;\n    padding: 8px 0px 8px 12px;\n    gap: 8px;\n    min-height: 44px;\n    height: 44px;\n    line-height: 24px;\n    max-height: calc(24px * 4);\n    background: #fff;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    width: 100%;\n"], ["\n    resize: none;\n    padding: 8px 0px 8px 12px;\n    gap: 8px;\n    min-height: 44px;\n    height: 44px;\n    line-height: 24px;\n    max-height: calc(24px * 4);\n    background: #fff;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    width: 100%;\n"])));
var ErrorMsg = styled_components_browser_esm/* default.p */.ZP.p(Styled_css_templateObject_25 || (Styled_css_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    color: ", ";\n    margin: 4px 0 0 0;\n"], ["\n    font-size: 12px;\n    color: ", ";\n    margin: 4px 0 0 0;\n"])), function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    return (!isPlaceholder ? constants/* colors.borderError */.O9.borderError : constants/* colors.textGrayColor */.O9.textGrayColor);
});
var AlignRight = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_26 || (Styled_css_templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: end;\n    width: 100%;\n"], ["\n    display: flex;\n    justify-content: end;\n    width: 100%;\n"])));
var Styled_css_Link = styled_components_browser_esm/* default.a */.ZP.a(Styled_css_templateObject_27 || (Styled_css_templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: max-content;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: right;\n    color: #005aff;\n    cursor: pointer;\n    &:hover {\n        color: ", " !important;\n    }\n"], ["\n    width: max-content;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: right;\n    color: #005aff;\n    cursor: pointer;\n    &:hover {\n        color: ", " !important;\n    }\n"])), constants/* colors.buttonColor */.O9.buttonColor);
var TextResume = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_28 || (Styled_css_templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n    span {\n        font-size: 14px;\n        max-width: 170px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    span {\n        font-size: 14px;\n        max-width: 170px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n"])));
var Searchable = styled_components_browser_esm/* default.label */.ZP.label(Styled_css_templateObject_29 || (Styled_css_templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 18px;\n    div {\n        margin-bottom: 10px;\n        display: flex;\n        align-items: flex-start;\n        gap: 5px;\n        input {\n            -webkit-appearance: auto !important;\n            appearance: auto !important;\n        }\n        span {\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 16px;\n            color: ", ";\n        }\n    }\n    p {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: ", ";\n        span {\n            color: ", ";\n        }\n    }\n"], ["\n    line-height: 18px;\n    div {\n        margin-bottom: 10px;\n        display: flex;\n        align-items: flex-start;\n        gap: 5px;\n        input {\n            -webkit-appearance: auto !important;\n            appearance: auto !important;\n        }\n        span {\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 16px;\n            color: ", ";\n        }\n    }\n    p {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: ", ";\n        span {\n            color: ", ";\n        }\n    }\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    return (isDisabled ? '#bfbfbf' : '#333');
}, constants/* colors.textColor */.O9.textColor, constants/* colors.primaryColor */.O9.primaryColor);
var RadioCss = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_30 || (Styled_css_templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    padding: 12px;\n    height: auto;\n    min-height: 48px;\n    background: #fff;\n    border: 1px solid #b3ceff;\n    border-radius: 8px;\n    gap: 11px;\n    cursor: pointer;\n    &.active,\n    &:hover {\n        background: #f2f7ff;\n    }\n"], ["\n    display: flex;\n    padding: 12px;\n    height: auto;\n    min-height: 48px;\n    background: #fff;\n    border: 1px solid #b3ceff;\n    border-radius: 8px;\n    gap: 11px;\n    cursor: pointer;\n    &.active,\n    &:hover {\n        background: #f2f7ff;\n    }\n"])));
var RadioBox = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_31 || (Styled_css_templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    background: #fff;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #555;\n    border-radius: 50%;\n    cursor: pointer;\n    &.checked {\n        background: ", ";\n    }\n    /* &.disabled {\n        cursor: not-allowed !important;\n        .checkbox {\n            opacity: 0.5;\n        }\n    } */\n    &::before {\n        position: absolute;\n        content: '';\n        width: 8px;\n        height: 8px;\n        background: #fff;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        border-radius: 50%;\n    }\n"], ["\n    position: relative;\n    background: #fff;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #555;\n    border-radius: 50%;\n    cursor: pointer;\n    &.checked {\n        background: ", ";\n    }\n    /* &.disabled {\n        cursor: not-allowed !important;\n        .checkbox {\n            opacity: 0.5;\n        }\n    } */\n    &::before {\n        position: absolute;\n        content: '';\n        width: 8px;\n        height: 8px;\n        background: #fff;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        border-radius: 50%;\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor);
var Styled_css_Label = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_32 || (Styled_css_templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    gap: 4px;\n    div {\n        p {\n            color: #888;\n            a {\n                font-size: 14px;\n            }\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    gap: 4px;\n    div {\n        p {\n            color: #888;\n            a {\n                font-size: 14px;\n            }\n        }\n    }\n"])));
var CircleSkeleton = (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z)(Styled_css_templateObject_33 || (Styled_css_templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 50%;\n"], ["\n    border-radius: 50%;\n"])));
var SkeletonContainer = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_34 || (Styled_css_templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n"], ["\n    width: 100%;\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n"])));
var PrivacyPolicyContainer = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_35 || (Styled_css_templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: 100%;\n    > div > div[data-check-state] {\n        width: auto !important;\n        > label {\n            display: none;\n        }\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: 100%;\n    > div > div[data-check-state] {\n        width: auto !important;\n        > label {\n            display: none;\n        }\n    }\n"])));
var CheckBoxGroup = styled_components_browser_esm/* default.div */.ZP.div(Styled_css_templateObject_36 || (Styled_css_templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n"], ["\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n"])));
var CheckboxLabel = styled_components_browser_esm/* default.div */.ZP.div(templateObject_37 || (templateObject_37 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n    line-height: 38px;\n    cursor: pointer;\n    font-size: 14px;\n    @media screen and (max-width: 768px) {\n        line-height: 22px;\n    }\n    .required {\n        color: #dc362e;\n    }\n    a {\n        color: #005aff !important;\n        &:hover {\n            color: #ff7d55 !important;\n        }\n    }\n    span {\n        font-size: 14px;\n    }\n"], ["\n    display: block;\n    line-height: 38px;\n    cursor: pointer;\n    font-size: 14px;\n    @media screen and (max-width: 768px) {\n        line-height: 22px;\n    }\n    .required {\n        color: #dc362e;\n    }\n    a {\n        color: #005aff !important;\n        &:hover {\n            color: #ff7d55 !important;\n        }\n    }\n    span {\n        font-size: 14px;\n    }\n"])));
var CheckboxLink = styled_components_browser_esm/* default.a */.ZP.a(templateObject_38 || (templateObject_38 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #005aff !important;\n    &:hover {\n        color: #ff7d55 !important;\n    }\n"], ["\n    color: #005aff !important;\n    &:hover {\n        color: #ff7d55 !important;\n    }\n"])));
var ErrorMessage = styled_components_browser_esm/* default.div */.ZP.div(templateObject_39 || (templateObject_39 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 8px;\n    color: #dc362e;\n"], ["\n    padding-left: 8px;\n    color: #dc362e;\n"])));
var Styled_css_templateObject_1, Styled_css_templateObject_2, Styled_css_templateObject_3, Styled_css_templateObject_4, Styled_css_templateObject_5, Styled_css_templateObject_6, Styled_css_templateObject_7, Styled_css_templateObject_8, Styled_css_templateObject_9, Styled_css_templateObject_10, Styled_css_templateObject_11, Styled_css_templateObject_12, Styled_css_templateObject_13, Styled_css_templateObject_14, Styled_css_templateObject_15, Styled_css_templateObject_16, Styled_css_templateObject_17, Styled_css_templateObject_18, Styled_css_templateObject_19, Styled_css_templateObject_20, Styled_css_templateObject_21, Styled_css_templateObject_22, Styled_css_templateObject_23, Styled_css_templateObject_24, Styled_css_templateObject_25, Styled_css_templateObject_26, Styled_css_templateObject_27, Styled_css_templateObject_28, Styled_css_templateObject_29, Styled_css_templateObject_30, Styled_css_templateObject_31, Styled_css_templateObject_32, Styled_css_templateObject_33, Styled_css_templateObject_34, Styled_css_templateObject_35, Styled_css_templateObject_36, templateObject_37, templateObject_38, templateObject_39;


//# sourceMappingURL=Styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/type.js
'use client';

var ECVOption;
(function (ECVOption) {
    ECVOption["onlineProfile"] = "onlineProfile";
    ECVOption["attachedCV"] = "attachedCV";
})(ECVOption || (ECVOption = {}));
var EEditAction;
(function (EEditAction) {
    EEditAction["editPhone"] = "editPhone";
    EEditAction["editJobTitle"] = "editJobTitle";
    EEditAction["none"] = "none";
})(EEditAction || (EEditAction = {}));
var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var type_DEFAULT_SUCCESS_CODE = 200;
var EUserInfoType;
(function (EUserInfoType) {
    EUserInfoType["phone"] = "phone";
    EUserInfoType["jobTitle"] = "jobTitle";
})(EUserInfoType || (EUserInfoType = {}));
var EApplyType;
(function (EApplyType) {
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(EApplyType || (EApplyType = {}));
var EBlockSuggestion;
(function (EBlockSuggestion) {
    EBlockSuggestion["BasicInfo"] = "BasicInfo";
    EBlockSuggestion["Skills"] = "Skills";
    EBlockSuggestion["Educations"] = "Educations";
    EBlockSuggestion["WorkingHistories"] = "WorkingHistories";
    EBlockSuggestion["Summary"] = "Summary";
})(EBlockSuggestion || (EBlockSuggestion = {}));


//# sourceMappingURL=type.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/UploadFile.js
'use client';










var UploadFile = function (_a, ref) {
    var accessToken = _a.accessToken, lang = _a.lang, baseUrl = _a.baseUrl, t = _a.t, setApplyJobInfo = _a.setApplyJobInfo, applyJobInfo = _a.applyJobInfo, userId = _a.userId, jobId = _a.jobId;
    var _b = (0,react.useState)(false), isDrag = _b[0], setIsDrag = _b[1];
    var _c = (0,react.useState)(false), isError = _c[0], setIsError = _c[1];
    var _d = (0,react.useState)(), errorMes = _d[0], setErrorMes = _d[1];
    var _e = (0,react.useState)(false), isUpload = _e[0], setIsUpload = _e[1];
    var validateResume = function (uploadFileInfo) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var reponse, data, meta, tempApplyonCickInfo, lastAttachmentCVResume, newAttachment, indexNewAttachmentResume, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return (0,_tslib/* __generator */.Jh)(this, function (_k) {
            switch (_k.label) {
                case 0:
                    setIsUpload(true);
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, validateFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: uploadFileInfo,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            userId: userId,
                            jobId: jobId
                        })];
                case 2:
                    reponse = _k.sent();
                    if (reponse && reponse.data) {
                        data = reponse.data, meta = reponse.meta;
                        if (((_a = data.attributes) === null || _a === void 0 ? void 0 : _a.spam) === false) {
                            tempApplyonCickInfo = applyJobInfo;
                            lastAttachmentCVResume = (_b = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _b === void 0 ? void 0 : _b.find(function (e) { return e.type === EApplyType.lastAttachment; });
                            newAttachment = {
                                allowSearchableDisplay: (_c = lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.allowSearchableDisplay) !== null && _c !== void 0 ? _c : 0,
                                value: !(lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.value) ? 'newAttachment' : lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.value,
                                text: (_d = uploadFileInfo.name) !== null && _d !== void 0 ? _d : '',
                                type: EApplyType.newAttachment,
                                enabled: true,
                                resumeFile: uploadFileInfo
                            };
                            indexNewAttachmentResume = (_e = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _e === void 0 ? void 0 : _e.findIndex(function (e) { return e.type === EApplyType.newAttachment; });
                            if (typeof indexNewAttachmentResume === 'number' && indexNewAttachmentResume !== -1) {
                                (_f = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _f === void 0 ? void 0 : _f.splice(indexNewAttachmentResume, 1);
                            }
                            setApplyJobInfo &&
                                setApplyJobInfo((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, tempApplyonCickInfo), { resumes: (0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], ((_g = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) !== null && _g !== void 0 ? _g : []), true), [newAttachment], false) }));
                            setErrorMes('');
                            setIsError(false);
                            setIsUpload(false);
                            return [2 /*return*/];
                        }
                        setErrorMes(meta === null || meta === void 0 ? void 0 : meta.message);
                        setIsError(true);
                    }
                    setErrorMes((_j = (_h = reponse === null || reponse === void 0 ? void 0 : reponse.meta) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : '');
                    setIsUpload(false);
                    setIsError(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _k.sent();
                    setIsUpload(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var doUploadFile = function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var reponse, error_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, uploadFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            file: file,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : ''
                        })];
                case 2:
                    reponse = _a.sent();
                    if (reponse && reponse.data) {
                        setIsError(false);
                        return [2 /*return*/];
                    }
                    setIsError(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setIsUpload(false);
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            doUploadFile: function (file) {
                doUploadFile(file);
            }
        };
    }, []);
    var checkUploadFile = function (file) {
        var uploadFileInfo = file;
        // check file extensions
        if (!DEFAULT_ALLOW_FILES_EXT.includes(uploadFileInfo.type)) {
            // show error file type doesn't support
            setErrorMes(t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'));
            setIsError(true);
            return;
        }
        // check file size
        if (uploadFileInfo.size > DEFAULT_LIMIT_FILE_SIZE) {
            // File is over 5MB
            setErrorMes(t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'));
            setIsError(true);
            return;
        }
        // validate spam cv
        setErrorMes('');
        setIsUpload(false);
        validateResume(file);
        // do upload file and move to next tab
        // doUploadFile(uploadFileInfo)
    };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setIsDrag(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setIsDrag(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDrag(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    return (react.createElement(UploadCV, { className: 'body__uploadCV', htmlFor: 'upload_cv', onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: !applyJobInfo },
        react.createElement("input", { id: 'upload_cv', type: 'file', onChange: handleOnFileChange }),
        react.createElement("div", null,
            !isUpload ? react.createElement(UploadIcon/* default */.Z, null) : react.createElement(LoadingIcon/* default */.Z, null),
            t('Chọn hồ sơ từ máy của bạn')),
        react.createElement(ErrorMsg, { isPlaceholder: !isError },
            errorMes || t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'),
            ".")));
};
var UploadFile$1 = (0,react.forwardRef)(UploadFile);


//# sourceMappingURL=UploadFile.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/DefaultAvatar/index.js
var DefaultAvatar = __webpack_require__(8083);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/UserInfo.js
'use client';












var UserInfo_UserInfo = function (_a, ref) {
    var _b, _c, _d, _e, _f;
    var lang = _a.lang, baseUrl = _a.baseUrl, accessToken = _a.accessToken, userInfo = _a.userInfo, handleChange = _a.handleChange, t = _a.t, applyError = _a.applyError;
    var i11lPhoneNumberRef = (0,react.useRef)(null);
    var _g = (0,react.useState)((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.cellphone) !== null && _b !== void 0 ? _b : ''), phone = _g[0], setPhone = _g[1];
    var _h = (0,react.useState)((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobtitle) !== null && _c !== void 0 ? _c : ''), jobTitle = _h[0], setJobTitle = _h[1];
    var _j = (0,react.useState)({
        phone: '',
        jobTitle: ''
    }), errMes = _j[0], setErrMes = _j[1];
    function validateI11lPhoneNumber() {
        var _a;
        var error = (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
        return !!error;
    }
    var validateJobTitle = function (value) {
        var parsedJobTitle = parseInt(value);
        /**
         * VNW-24427 [Web] HTML encode and decode job title
         * Accept all special characters
         *
         * @author PhongGP
         * @since Aug 07, 2023
         */
        var isNoValue = !value || (value && !value.trim());
        var isNoValid = (0,helpers/* checkIfEmailInString */.n3)(value) || (typeof parsedJobTitle === 'number' && !isNaN(parsedJobTitle));
        var errorJobTitle = '';
        if (isNoValue) {
            errorJobTitle = t('Vui lòng nhập thông tin.');
            setErrMes((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errMes), { jobTitle: errorJobTitle }));
            return !!errorJobTitle;
        }
        if (isNoValid) {
            errorJobTitle = t('Vui lòng không nhập số điện thoại hoặc email.');
            setErrMes((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errMes), { jobTitle: errorJobTitle }));
            return !!errorJobTitle;
        }
        errorJobTitle = UploadResumeModal_constants/* noSpecialCharsForJobTitle.test */.i0.test(value) ? t('Vui lòng không nhập kí tự đặc biệt.') : '';
        setErrMes((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errMes), { jobTitle: errorJobTitle }));
        return !!errorJobTitle;
    };
    (0,react.useImperativeHandle)(ref, function () { return ({
        validateI11lPhoneNumber: validateI11lPhoneNumber,
        validateJobTitle: validateJobTitle
    }); }, []);
    var handleChangePhoneNumber = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var error, respone, error_1;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    error = (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
                    if (phone === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.cellphone))
                        return [2 /*return*/];
                    if (error)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changePhoneNumber({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            value: phone !== null && phone !== void 0 ? phone : ''
                        })];
                case 2:
                    respone = _b.sent();
                    if (respone && respone.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeJobTile = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var isNotValid, respone, error_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isNotValid = validateJobTitle(jobTitle);
                    if (jobTitle === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobtitle) || isNotValid)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changeJobTitle({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            value: jobTitle !== null && jobTitle !== void 0 ? jobTitle : ''
                        })];
                case 2:
                    respone = _a.sent();
                    if (respone && respone.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        var _a;
        if ((applyError === null || applyError === void 0 ? void 0 : applyError.isPhoneError) && !phone) {
            (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
        }
        if ((applyError === null || applyError === void 0 ? void 0 : applyError.isJobtitleError) && !jobTitle) {
            validateJobTitle(jobTitle !== null && jobTitle !== void 0 ? jobTitle : '');
        }
    }, [applyError]);
    return (react.createElement(User, null,
        react.createElement(AvatarUser, { className: 'body__avatar' }, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) ? (react.createElement("img", { src: (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _d !== void 0 ? _d : '', alt: 'avatar user' })) : (react.createElement(DefaultAvatar/* default */.Z, { size: 88 }))),
        react.createElement(UserInfo, { className: 'body__user' },
            react.createElement(Info.Name, null, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstname) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastname)
                ? "".concat((_e = userInfo.firstname) !== null && _e !== void 0 ? _e : '', " ").concat((_f = userInfo.lastname) !== null && _f !== void 0 ? _f : '')
                : ''),
            react.createElement(Info.Common, { onBlur: handleChangeJobTile },
                react.createElement(components_Input/* default */.Z, { placeholder: t('Nhập chức danh' ), className: 'custom_input', onChange: function (value) {
                        setJobTitle(value);
                        setErrMes((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errMes), { jobTitle: '' }));
                        handleChange && handleChange(value, 'jobTitle');
                    }, hasError: !!errMes.jobTitle, value: jobTitle }),
                (errMes === null || errMes === void 0 ? void 0 : errMes.jobTitle) ? react.createElement(ErrorMsg, null, errMes.jobTitle) : ''),
            react.createElement(Info.Common, { onBlur: handleChangePhoneNumber },
                react.createElement(I11lPhoneNumberInput/* default */.Z, { placeholder: t('Nhập số điện thoại' ), value: phone, onChange: function (value) {
                        setPhone(value);
                        setErrMes((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, errMes), { phone: '' }));
                        handleChange && handleChange(value, 'phone');
                    }, language: lang, urlMeta: "".concat(baseUrl, "/meta/v1.0/international-phone-number"), dropdownHeight: '200px', hiddenDefaultError: false, ref: i11lPhoneNumberRef, floatingConfig: {
                        position: 'fixed',
                        enablePortal: true,
                        useWindowAsFlippingContainer: true
                    } })))));
};
var UserInfo$1 = react.forwardRef(UserInfo_UserInfo);


//# sourceMappingURL=UserInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/profileStrength.js
'use client';

var calculateProfileStrength = function (profileLevel) {
    var strengthOption = [
        // { id: 0, name: 'Unfinished' },
        { id: 1, name: 'Beginner' },
        { id: 2, name: 'Intermediate' },
        { id: 3, name: 'Expert' },
        { id: 4, name: 'All Star' }
    ];
    var currentLevelPercentage = (profileLevel.level / strengthOption.length) * 100;
    var nextLevelPercentage = ((profileLevel.level + 1) / strengthOption.length) * 100;
    var percentage = currentLevelPercentage === 100
        ? 100
        : profileLevel.totalPoints > 0
            ? currentLevelPercentage +
                (profileLevel.passedPoints / profileLevel.totalPoints) *
                    (nextLevelPercentage - currentLevelPercentage)
            : 0;
    return percentage;
};


//# sourceMappingURL=profileStrength.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/const.js
'use client';

var ALLOW_SEARCHABLE = 1;
var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/Radio.js
'use client';









function Radio_Radio(_a) {
    var _this = this;
    var resume = _a.resume, type = _a.type, checked = _a.checked, onClick = _a.onClick, t = _a.t, accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, baseMsUrl = _a.baseMsUrl, attachmentInfo = _a.attachmentInfo, setIsDisable = _a.setIsDisable;
    var _b = (0,react.useState)(0), percent = _b[0], setPercent = _b[1];
    var percentProfileStrength = function (profileLevel) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var profileLevelItem = {
            level: (_b = (_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.resumeLevelId) !== null && _b !== void 0 ? _b : 0,
            passedPoints: (_d = (_c = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _c === void 0 ? void 0 : _c.currentPoint) !== null && _d !== void 0 ? _d : 0,
            totalPoints: (_f = (_e = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _e === void 0 ? void 0 : _e.totalPoint) !== null && _f !== void 0 ? _f : 0,
            status: (_h = (_g = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _g === void 0 ? void 0 : _g.resumeStatus) !== null && _h !== void 0 ? _h : ''
        };
        var percent = (_j = calculateProfileStrength(profileLevelItem)) !== null && _j !== void 0 ? _j : 0;
        if (percent) {
            var parseIntPercent = parseInt(percent.toFixed(0));
            setPercent(parseIntPercent);
        }
    };
    var getProfileStrengthByProfileLevel = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var profileLevel, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getProfileLevel(accessToken, langCode, baseMsUrl)];
                case 1:
                    profileLevel = _a.sent();
                    if (profileLevel) {
                        percentProfileStrength(profileLevel);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var TextEllipsis = function (text) {
        var fileName = '';
        var extName = '';
        DEFAULT_ALLOW_EXT.split(',').forEach(function (ext) {
            var isInCludes = text.includes(ext);
            if (isInCludes) {
                extName = ext;
                fileName = text.replace(ext, '');
            }
        });
        return (react.createElement(TextResume, null,
            react.createElement("span", null, fileName),
            extName));
    };
    (0,react.useEffect)(function () {
        if (type === EApplyType.online) {
            getProfileStrengthByProfileLevel();
        }
    }, []);
    var renderRadio = function (type) {
        var _a, _b, _c, _d;
        switch (type) {
            case EApplyType.online:
                return (react.createElement(Styled_css_Label, null,
                    react.createElement("p", null, t('Hồ Sơ VietnamWorks')),
                    react.createElement("div", null,
                        react.createElement("p", null,
                            react.createElement(Styled_css_Link, { href: "".concat(baseUrl, "/").concat(t('ho-so')), target: '_blank' }, t('Xem hồ sơ')),
                            ' ',
                            percent ? "".concat(percent, "% ").concat(t('hoàn thiện')) : null))));
            case EApplyType.lastAttachment:
                return (react.createElement(Styled_css_Label, null,
                    react.createElement("p", null,
                        t('Hồ Sơ Đính Kèm'),
                        ":"),
                    react.createElement("div", null,
                        react.createElement("p", null,
                            react.createElement(Styled_css_Link, { href: (_a = attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.link) !== null && _a !== void 0 ? _a : '', target: '_blank' }, TextEllipsis((_b = resume === null || resume === void 0 ? void 0 : resume.text) !== null && _b !== void 0 ? _b : '')),
                            ' ',
                            "- ", (_c = resume === null || resume === void 0 ? void 0 : resume.hint) !== null && _c !== void 0 ? _c : ''))));
            case EApplyType.newAttachment:
                return (react.createElement(Styled_css_Label, null,
                    react.createElement("p", null,
                        t('Hồ Sơ Vừa Tải Lên'),
                        ":"),
                    react.createElement("div", null,
                        react.createElement("p", null, TextEllipsis((_d = resume === null || resume === void 0 ? void 0 : resume.text) !== null && _d !== void 0 ? _d : '')))));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(RadioCss, { onClick: function () {
            onClick(type);
            setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        }, className: checked ? 'active' : '' },
        react.createElement(RadioBox, { className: checked ? 'checked' : '' }),
        renderRadio(type !== null && type !== void 0 ? type : EApplyType.newAttachment)));
}


//# sourceMappingURL=Radio.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/Warning/index.js
var Warning = __webpack_require__(14083);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/SystemError.js
'use client';







var Wrap = styled_components_browser_esm/* default.div */.ZP.div(SystemError_templateObject_1 || (SystemError_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 10px 15px 10px 8px;\n    background: linear-gradient(0deg, rgba(247, 190, 6, 0.15), rgba(247, 190, 6, 0.15)), #ffffff;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    span {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n    }\n    div {\n        cursor: pointer;\n        position: absolute;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        right: 13px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n"], ["\n    position: relative;\n    padding: 10px 15px 10px 8px;\n    background: linear-gradient(0deg, rgba(247, 190, 6, 0.15), rgba(247, 190, 6, 0.15)), #ffffff;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    span {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n    }\n    div {\n        cursor: pointer;\n        position: absolute;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        right: 13px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n"])));
function SystemError(_a) {
    var message = _a.message, onClose = _a.onClose;
    return (react.createElement(Wrap, null,
        react.createElement(Warning/* default */.Z, null),
        " ",
        react.createElement("span", null, message !== null && message !== void 0 ? message : ''),
        react.createElement("div", { onClick: onClose },
            react.createElement(RemoveIcon/* default */.Z, null))));
}
var SystemError_templateObject_1;


//# sourceMappingURL=SystemError.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/CompanyInfo.js
'use client';





function CompanyInfo_CompanyInfo(_a) {
    var _b, _c, _d, _e;
    var jobInfo = _a.jobInfo, handleClose = _a.handleClose;
    return (react.createElement(react.Fragment, null,
        react.createElement(AvatarCompany, { className: 'head__avatar' },
            react.createElement("img", { src: (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.logo) || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'Company logo' })),
        react.createElement(Styled_css_CompanyInfo, { className: 'head__company' },
            react.createElement(Styled_css_Title, null, (_b = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.title) !== null && _b !== void 0 ? _b : ''),
            react.createElement("div", null,
                react.createElement("p", null,
                    react.createElement(TextOrg, null, (_c = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.salary) !== null && _c !== void 0 ? _c : ''),
                    " | ",
                    react.createElement("span", null, (_d = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevel) !== null && _d !== void 0 ? _d : '')),
                react.createElement(TextTruncate, null, (_e = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.address) !== null && _e !== void 0 ? _e : ''))),
        react.createElement(CloseBtn, { onClick: handleClose },
            react.createElement(RemoveIcon/* default */.Z, null))));
}


//# sourceMappingURL=CompanyInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/utils.js
'use client';




var initProfileSettingOptions = {
    chooseCV: 'attach-cv',
    chooseRefreshType: 2
};
var getProfileSettingCookie = function (userId) {
    if (userId) {
        var data = JSON.parse((0,cookie/* getCookie */.e)('VNW_PROFILE_SETTING_OPTIONS') || '{}');
        !data[userId] && (0,cookie/* setCookie */.d)('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        return !data[userId] ? initProfileSettingOptions : data[userId];
    }
    return null;
};
var setProfileSettingCookie = function (newOptions, userId) {
    if (userId) {
        var data = JSON.parse((0,cookie/* getCookie */.e)('VNW_PROFILE_SETTING_OPTIONS') || '{}');
        if (!data[userId]) {
            data[userId] = initProfileSettingOptions;
            (0,cookie/* setCookie */.d)('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        }
        else {
            data[userId] = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, data[userId]), newOptions);
            (0,cookie/* setCookie */.d)('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        }
    }
};


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/components/Skeletion.js
'use client';





var UserInfoSkeleton = function () {
    return (react.createElement(User, null,
        react.createElement(AvatarUser, null,
            react.createElement(CircleSkeleton, { width: 88, height: 88 })),
        react.createElement(UserInfo, null,
            react.createElement(Skeleton/* default */.Z, { height: 44 }),
            react.createElement(Skeleton/* default */.Z, { height: 44 }))));
};
var JobInfoSkeletion = function () {
    return (react.createElement(SkeletonContainer, null,
        react.createElement(Skeleton/* default */.Z, { height: 16, width: 300 }),
        react.createElement(Skeleton/* default */.Z, { height: 72 }),
        react.createElement(Skeleton/* default */.Z, { height: 72 }),
        react.createElement(Skeleton/* default */.Z, { height: 16, width: 250 }),
        react.createElement(Skeleton/* default */.Z, { height: 14 }),
        react.createElement(Skeleton/* default */.Z, { height: 14 })));
};


//# sourceMappingURL=Skeletion.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/translations.js
'use client';

var QuickApplyJobModal_translations_translations = {
    'Tạo hồ sơ ấn tượng với WowCV': 'Create attracted CV with WowCV',
    'Xem mẫu thư giới thiệu': 'View sample',
    'Thư giới thiệu': 'Cover letter',
    'Thư giới thiệu (Không bắt buộc)': 'Cover letter (Optional)',
    'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng': 'Employers prefer to receive your resume in',
    'Hồ Sơ VietnamWorks': 'VietnamWorks Profile',
    'Hồ Sơ Đính Kèm': 'Attached CV',
    'Hồ Sơ Vừa Tải Lên': 'CV Just Uploaded',
    'Đã tải lên': 'Uploaded',
    'hoàn thiện': 'completed',
    'Chọn hồ sơ từ máy của bạn': 'Upload file from your device',
    'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB': '.doc, .docx and .pdf files that are less than 5120KB in size',
    'Nộp Đơn': 'Send application',
    'Vui lòng nhập thông tin.': 'This field is required.',
    'Vui lòng không nhập số điện thoại hoặc email.': 'Please do not enter phone number or email.',
    'Vui lòng không nhập kí tự đặc biệt.': 'Please do not enter special characters.',
    'Nhập thư giới thiệu': 'Enter cover letter',
    'Nhập chức danh': 'Enter job title',
    'Nhập số điện thoại': 'Enter phone number',
    'Cho phép Nhà tuyển dụng tìm kiếm': 'Allow Employers to search',
    'Chọn hồ sơ ứng tuyển': 'Choose a profile to apply',
    Resume: 'Resume',
    'Xem hồ sơ': 'View profile',
    'Không bắt buộc': 'Optional',
    'ho-so': 'my-profile',
    'thiet-lap-ho-so': 'profile-settings',
    'quan-ly-nghe-nghiep': 'my-career-center',
    'Thiết lập hồ sơ': 'Profile settings',
    'Hồ sơ của tôi': 'My Profile',
    'Đã có sự cố kỹ thuật trong khi xử lý yêu cầu của bạn. Vui lòng chờ 5 phút và thử lại hoặc liên hệ với chúng tôi để được hỗ trợ.': 'Sorry, there were some technical issues while processing your request. Please wait 5 minutes and try again or contact us.',
    'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại': 'Not enough information to use the function Allow Employers to search attached CV. Update information at',
    'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ vừa tải lên. Cập nhật thông tin tại': 'Not enough information to use the function Allow Employers to search CV just uploaded. Update information at',
    'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:': 'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:',
    'Xác nhận ứng tuyển': 'Application confirmation',
    'Cấp bậc hiện tại của bạn': 'Your current job level',
    'chưa phù hợp với yêu cầu công việc này': ' is not matching to this job requirement',
    'Bạn có muốn tiếp tục nộp đơn?': 'Do you want to continue to apply?',
    'Tôi đồng ý với': 'I agree to the',
    'Quy định bảo mật': 'Privacy Policy',
    'của nhà tuyển dụng này.': 'of this employer.',
    'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.': 'Please tick the checkbox if you want to proceed.'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PopupWarning/index.js + 2 modules
var PopupWarning = __webpack_require__(26209);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/QuickApplyJobModal/index.js
'use client';























function QuickApplyJobModal(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var isShow = _a.isShow, lang = _a.lang, handleClose = _a.handleClose, onForceClose = _a.onForceClose, accessToken = _a.accessToken, jobId = _a.jobId, jobInfo = _a.jobInfo, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, pageSource = _a.pageSource, utm = _a.utm, userInfo = _a.userInfo;
    var _l = (0,react.useState)(false), isShowApplyJob = _l[0], setIsShowApplyJob = _l[1];
    var _m = (0,react.useState)(false), isLoading = _m[0], setLoading = _m[1];
    var _o = (0,react.useState)(''), applyMessage = _o[0], setApplyMessage = _o[1];
    var _p = (0,react.useState)(), applyJobInfo = _p[0], setApplyJobInfo = _p[1];
    var _q = (0,react.useState)(EApplyType.lastAttachment), applyType = _q[0], setApplyType = _q[1];
    var _r = (0,react.useState)(null), applyJobParams = _r[0], setApplyJobParams = _r[1];
    var _s = (0,react.useState)(false), isSearchable = _s[0], setIsSearchable = _s[1];
    var _t = (0,react.useState)(true), isDisable = _t[0], setIsDisable = _t[1];
    var _u = (0,react.useState)(null), jobLevels = _u[0], setJobLevels = _u[1];
    var _v = (0,react.useState)({
        isJobtitleError: false,
        isPhoneError: false,
        isCoverLetterError: false
    }), applyError = _v[0], setApplyError = _v[1];
    var _w = (0,react.useState)(), resumeSettingInfo = _w[0], setResumeSettingInfo = _w[1];
    var _x = (0,react.useState)(false), isCheckedPrivacy = _x[0], setCheckedPrivacy = _x[1];
    var _y = (0,react.useState)([]), privacyPolicy = _y[0], setPrivacyPolicy = _y[1];
    var _z = (0,react.useState)(false), isPrivacyError = _z[0], setShowPrivacyError = _z[1];
    var uploadFileRef = (0,react.useRef)(null);
    var userInfoRef = (0,react.useRef)(null);
    var decryptToken = (0,helpers/* decrypt */.pe)(accessToken !== null && accessToken !== void 0 ? accessToken : '');
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return QuickApplyJobModal_translations_translations[text];
        }
    };
    var getProfileResumeSettingInfo = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var resumeSettingInfo_1, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getResumeSettingInfo(decryptToken, lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    resumeSettingInfo_1 = _a.sent();
                    if (resumeSettingInfo_1) {
                        setResumeSettingInfo(resumeSettingInfo_1);
                        return [2 /*return*/, resumeSettingInfo_1];
                    }
                    return [2 /*return*/, undefined];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var infoParamsApplyJob = function (type, response) {
        var _a, _b, _c, _d, _e, _f, _g;
        var resume = (_a = response === null || response === void 0 ? void 0 : response.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === type; });
        setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        setApplyJobParams((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), { appJobTitle: (_c = (_b = response === null || response === void 0 ? void 0 : response.userInfo) === null || _b === void 0 ? void 0 : _b.jobtitle) !== null && _c !== void 0 ? _c : '', appPhoneNumber: (_e = (_d = response === null || response === void 0 ? void 0 : response.userInfo) === null || _d === void 0 ? void 0 : _d.cellphone) !== null && _e !== void 0 ? _e : '', resumeApply: (_f = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _f !== void 0 ? _f : '', onlineResumeId: (_g = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _g !== void 0 ? _g : '', resumeFile: resume === null || resume === void 0 ? void 0 : resume.resumeFile, appliedType: type, jobId: String(jobId !== null && jobId !== void 0 ? jobId : ''), source: pageSource !== null && pageSource !== void 0 ? pageSource : 'searchResults' }));
    };
    var getInfo = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var resumeInfo_1, response, newResumes_1, newApplyJobInfo, applyTypes_1, userId, lastChooseCV, isOnlyLastAttachmentCVOrBoth, isOnlyOnlineProfile, applyType_1, error_2;
        var _a, _b, _c, _d, _e;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getProfileResumeSettingInfo()];
                case 1:
                    resumeInfo_1 = _f.sent();
                    return [4 /*yield*/, getInfoWhenApplyOneClick({
                            jobid: jobId,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang
                        })];
                case 2:
                    response = _f.sent();
                    if (response && response.status === 'SUCCESS') {
                        newResumes_1 = [];
                        if (resumeInfo_1) {
                            // merge allowSearchableDisplay to resume info
                            (_a = response === null || response === void 0 ? void 0 : response.resumes) === null || _a === void 0 ? void 0 : _a.forEach(function (resume) {
                                var _a, _b;
                                var itemAttr = (_a = resumeInfo_1.attributes) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === Number(resume.value); });
                                if (itemAttr && itemAttr.id === Number(resume.value)) {
                                    var itemNewResume = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, resume), { allowSearchableDisplay: (_b = itemAttr === null || itemAttr === void 0 ? void 0 : itemAttr.allowSearchableDisplay) !== null && _b !== void 0 ? _b : 0 });
                                    newResumes_1.push(itemNewResume);
                                }
                            });
                        }
                        newApplyJobInfo = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, response), { resumes: newResumes_1 });
                        setApplyJobInfo(newApplyJobInfo);
                        applyTypes_1 = [];
                        (_b = newApplyJobInfo.resumes) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
                            if (item.type) {
                                applyTypes_1.push(item.type);
                            }
                        });
                        userId = (_d = (_c = newApplyJobInfo === null || newApplyJobInfo === void 0 ? void 0 : newApplyJobInfo.userInfo) === null || _c === void 0 ? void 0 : _c.userid) !== null && _d !== void 0 ? _d : 0;
                        lastChooseCV = (_e = getProfileSettingCookie(String(userId))) === null || _e === void 0 ? void 0 : _e.chooseCV;
                        isOnlyLastAttachmentCVOrBoth = (!applyTypes_1.includes(EApplyType.online) && applyTypes_1.includes(EApplyType.lastAttachment)) ||
                            (applyTypes_1.includes(EApplyType.online) && applyTypes_1.includes(EApplyType.lastAttachment));
                        isOnlyOnlineProfile = applyTypes_1.includes(EApplyType.online) && !applyTypes_1.includes(EApplyType.lastAttachment);
                        if (lastChooseCV) {
                            applyType_1 = applyTypes_1.includes(EApplyType.online) && lastChooseCV === 'profile'
                                ? EApplyType.online
                                : EApplyType.lastAttachment;
                            setApplyType(applyType_1);
                            infoParamsApplyJob(applyType_1, newApplyJobInfo);
                        }
                        else if (isOnlyLastAttachmentCVOrBoth) {
                            setApplyType(EApplyType.lastAttachment);
                            infoParamsApplyJob(EApplyType.lastAttachment, newApplyJobInfo);
                        }
                        else if (isOnlyOnlineProfile) {
                            setApplyType(EApplyType.online);
                            infoParamsApplyJob(EApplyType.online, newApplyJobInfo);
                        }
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _f.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onTextAreaChange = function (e) {
        var _a;
        setApplyError((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyError), { isCoverLetterError: false }));
        var target = e.target;
        target.style.height = "".concat(target.scrollHeight, "px");
        if (!target.value) {
            target.style.height = '44px';
        }
        setApplyJobParams((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), { coverLetter: (_a = target.value) !== null && _a !== void 0 ? _a : '' }));
    };
    var handleChangeResume = function (type) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!type)
            return;
        setApplyType(type);
        var resume = (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === type; });
        setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        setApplyJobParams((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), { appJobTitle: (_c = (_b = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _b === void 0 ? void 0 : _b.jobtitle) !== null && _c !== void 0 ? _c : '', appPhoneNumber: (_e = (_d = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _d === void 0 ? void 0 : _d.cellphone) !== null && _e !== void 0 ? _e : '', resumeApply: (_f = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _f !== void 0 ? _f : '', onlineResumeId: (_g = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _g !== void 0 ? _g : '', resumeFile: resume === null || resume === void 0 ? void 0 : resume.resumeFile, appliedType: type, jobId: String(jobId !== null && jobId !== void 0 ? jobId : ''), source: pageSource !== null && pageSource !== void 0 ? pageSource : 'searchResults' }));
    };
    var handleChangeInput = function (value, type) {
        setApplyJobInfo((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobInfo), { userInfo: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo), (type === 'phone' ? { cellphone: value } : { jobtitle: value })) }));
        setApplyJobParams((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), (type === 'phone' ? { appPhoneNumber: value } : { appJobTitle: value })));
    };
    (0,react.useEffect)(function () {
        if (jobId && isShow && accessToken) {
            getInfo();
        }
    }, [jobId, isShow, accessToken]);
    var onClickMakeSearchable = function (e) {
        var target = e.target;
        setIsSearchable(target.checked);
        setApplyJobParams((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), { appSearchable: target.checked ? '1' : '0' }), (target.checked ? { 'make-searchable': 'on' } : undefined)));
    };
    (0,react.useEffect)(function () {
        var _a;
        if ((_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === EApplyType.newAttachment; })) {
            handleChangeResume(EApplyType.newAttachment);
        }
    }, [applyJobInfo]);
    var validate = function () {
        var _a, _b, _c;
        var isValid = true;
        var error = {
            isJobtitleError: false,
            isPhoneError: false,
            isCoverLetterError: false
        };
        if ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) &&
            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) === 1 &&
            !(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.coverLetter)) {
            error.isCoverLetterError = true;
            isValid = false;
        }
        var isNotValidJobTitle = (_a = userInfoRef.current) === null || _a === void 0 ? void 0 : _a.validateJobTitle((_b = applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appJobTitle) !== null && _b !== void 0 ? _b : '');
        if (!(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appJobTitle) || isNotValidJobTitle) {
            error.isJobtitleError = true;
            isValid = false;
        }
        var isNotValidI11lPhoneNumber = (_c = userInfoRef.current) === null || _c === void 0 ? void 0 : _c.validateI11lPhoneNumber();
        if (!(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appPhoneNumber) || isNotValidI11lPhoneNumber) {
            error.isPhoneError = true;
            isValid = false;
        }
        setApplyError(error);
        return isValid;
    };
    var getJobUrlParams = function () {
        if (!jobInfo.link)
            return {};
        var urlSearch = jobInfo.link.split('?');
        if (!urlSearch || urlSearch.length < 1)
            return {};
        var searchParams = new URLSearchParams(urlSearch[1]);
        var searchParamsObj = Object.fromEntries(searchParams);
        return searchParamsObj;
    };
    var handleApplyJob = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var isValid, jobUrlParams, params, reponse, userId, error_3;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isValid = validate();
                    if (!isValid)
                        return [2 /*return*/];
                    if (!isCheckedPrivacy && privacyPolicy.length > 0) {
                        setShowPrivacyError(true);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    jobUrlParams = getJobUrlParams();
                    params = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, applyJobParams), jobUrlParams);
                    return [4 /*yield*/, applyJobs(params, baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', lang)];
                case 2:
                    reponse = _b.sent();
                    if (((reponse === null || reponse === void 0 ? void 0 : reponse.status) === 'SYSTEM_ERROR' || 'ERROR') && (reponse === null || reponse === void 0 ? void 0 : reponse.message)) {
                        setApplyMessage(reponse === null || reponse === void 0 ? void 0 : reponse.message);
                    }
                    if (reponse === null || reponse === void 0 ? void 0 : reponse.redirectUrl) {
                        userId = (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _a === void 0 ? void 0 : _a.userid;
                        setProfileSettingCookie({ chooseCV: applyType === EApplyType.online ? 'profile' : 'attach-cv' }, userId ? String(userId) : '');
                        window.location.href = reponse.redirectUrl;
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    console.error(error_3);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderRadioGroup = function () {
        var _a;
        return (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.map(function (resume, index) {
            if (!resume || !resume.enabled)
                return;
            return (react.createElement(Radio_Radio, { t: t, resume: resume, key: "".concat(resume, "_").concat(index), type: resume.type, checked: applyType === (resume === null || resume === void 0 ? void 0 : resume.type), onClick: handleChangeResume, accessToken: decryptToken !== null && decryptToken !== void 0 ? decryptToken : '', langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI, baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', attachmentInfo: resumeSettingInfo === null || resumeSettingInfo === void 0 ? void 0 : resumeSettingInfo.AttachmentInfo, setIsDisable: setIsDisable }));
        });
    };
    var hrefWowCV = function () {
        var queryParams = (0,urlBuilder/* objToQueryStr */.G7)(utm !== null && utm !== void 0 ? utm : {});
        var wowCVLink = "wowcv.vietnamworks.com/".concat(lang === constants/* ELanguage.EN */.Df.EN ? 'en' : '', "?").concat(queryParams);
        var appMode = (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.includes('staging')) ? 'staging' : (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.includes('release')) ? 'release' : '';
        return "https://".concat(!appMode ? wowCVLink : "".concat(appMode, "-").concat(wowCVLink));
    };
    var renderValidateSearchable = function (type) {
        var profileSettingsHref = "".concat(baseUrl, "/").concat(t('quan-ly-nghe-nghiep'), "/").concat(t('thiet-lap-ho-so'));
        if (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled) {
            return (react.createElement("p", null,
                t('Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:'),
                ' ',
                react.createElement(Styled_css_Link, { href: 'mailto:contact@vietnamworks.com' }, "contact@vietnamworks.com"),
                "."));
        }
        switch (type) {
            case EApplyType.lastAttachment:
                return (react.createElement("p", null,
                    t('Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại'),
                    ' ',
                    react.createElement(Styled_css_Link, { href: profileSettingsHref }, t('Thiết lập hồ sơ')),
                    "."));
            case EApplyType.newAttachment:
                return (react.createElement("p", null,
                    t('Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ vừa tải lên. Cập nhật thông tin tại'),
                    ' ',
                    react.createElement(Styled_css_Link, { href: profileSettingsHref }, t('Thiết lập hồ sơ')),
                    "."));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    var renderResumeTilte = function () {
        switch (applyType) {
            case EApplyType.online:
                return t('Hồ Sơ VietnamWorks');
            case EApplyType.lastAttachment:
                return t('Hồ Sơ Đính Kèm');
            case EApplyType.newAttachment:
                return t('Hồ Sơ Vừa Tải Lên');
            default:
                return '';
        }
    };
    var getJobLevels = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var jobLevels_1, error_4;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, service_getJobLevelList(lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    jobLevels_1 = _a.sent();
                    if (jobLevels_1 && jobLevels_1.length > 0) {
                        setJobLevels(jobLevels_1);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleUserLevelName = function () {
        var level = jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.find(function (level) { return level.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId); });
        return lang === constants/* ELanguage.EN */.Df.EN ? level === null || level === void 0 ? void 0 : level.attributes.nameEn : level === null || level === void 0 ? void 0 : level.attributes.nameVi;
    };
    (0,react.useEffect)(function () {
        if (jobLevels && (jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.length) > 0) {
            return;
        }
        if (isShow) {
            getJobLevels();
        }
    }, [jobLevels, isShow]);
    (0,react.useEffect)(function () {
        var isUserLowLevel = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === INTERN_LEVEL || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === FRESHER_LEVEL;
        var isJobHighLevel = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === MANAGER_LEVEL || (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === DIRECTOR_LEVEL;
        var isAllowApplyJobs = !(isJobHighLevel && isUserLowLevel);
        if (isAllowApplyJobs && isShow) {
            setIsShowApplyJob(true);
            handleClose();
        }
    }, [isShow, userInfo, jobInfo]);
    (0,react.useEffect)(function () {
        if (!isShow) {
            return;
        }
        (function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
            var privacyPolicyResponse;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!decryptToken) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getPrivacyPolicy({
                                accessToken: decryptToken,
                                body: {
                                    jobIds: [jobId]
                                },
                                langCode: lang,
                                baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : ''
                            })];
                    case 1:
                        privacyPolicyResponse = _a.sent();
                        setPrivacyPolicy(privacyPolicyResponse);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [isShow, decryptToken]);
    var onCheckChanged = function () {
        setCheckedPrivacy(!isCheckedPrivacy);
    };
    return (react.createElement("div", null,
        isShow && userInfo ? (react.createElement(PopupWarning/* default */.Z, { isShow: isShow, langCode: lang, onClose: function () {
                handleClose();
                onForceClose && onForceClose();
            }, onAccept: function () {
                setIsShowApplyJob(true);
                handleClose();
            }, title: t('Xác nhận ứng tuyển'), warningTxt: t('Bạn có muốn tiếp tục nộp đơn?') },
            t('Cấp bậc hiện tại của bạn'),
            ": ", (_b = handleUserLevelName()) !== null && _b !== void 0 ? _b : '',
            ' ',
            t('chưa phù hợp với yêu cầu công việc này'),
            ".")) : null,
        react.createElement(PopupQuickApplyJob, { className: 'popup__quickApply', isShow: isShowApplyJob, lang: lang, onClose: function () {
                setIsShowApplyJob(false);
                onForceClose && onForceClose();
            }, styleOption: {
                size: 'md'
            }, custom: {
                header: react.createElement(react.Fragment, null),
                footer: react.createElement(react.Fragment, null)
            } },
            react.createElement(Styled_css_Container, { className: 'popup_container' },
                react.createElement(Head, { className: 'popup__head' },
                    react.createElement(CompanyInfo_CompanyInfo, { handleClose: function () {
                            setIsShowApplyJob(false);
                            onForceClose && onForceClose();
                        }, jobInfo: jobInfo })),
                react.createElement(Body, { className: 'popup__body' },
                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) ? (react.createElement(UserInfo$1, { ref: userInfoRef, userInfo: applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo, accessToken: decryptToken, lang: lang, baseUrl: baseMsUrl, handleChange: handleChangeInput, t: t, applyError: applyError })) : (react.createElement(UserInfoSkeleton, null)),
                    applyJobInfo ? (react.createElement(react.Fragment, null,
                        (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) &&
                            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) &&
                            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) !== 0 ? (react.createElement(CoverLetter, null,
                            react.createElement("p", null,
                                t('Thư giới thiệu'),
                                (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) === 2 ? (react.createElement("b", null,
                                    " (",
                                    t('Không bắt buộc'),
                                    ")")) : (''),
                                ":"),
                            react.createElement(Styled_css_Textarea, { placeholder: t('Nhập thư giới thiệu'), maxLength: 5000, onChange: onTextAreaChange }),
                            applyError.isCoverLetterError ? (react.createElement(ErrorMsg, null, t('Vui lòng nhập thông tin.'))) : null,
                            react.createElement(AlignRight, null,
                                react.createElement(Styled_css_Link, { href: 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html', target: '_blank' }, t('Xem mẫu thư giới thiệu'))))) : null,
                        react.createElement(ApplyCV, { className: 'body__applyCV' },
                            react.createElement(ApplyCVTitle, null,
                                react.createElement(ApplyCVTitle, null,
                                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && applyJobInfo.resumes.length > 0 ? (react.createElement(react.Fragment, null,
                                        t('Chọn hồ sơ ứng tuyển'),
                                        ": ")) : null,
                                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) &&
                                        ((_c = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) === null || _c === void 0 ? void 0 : _c.selectedid) !== '3' ? (react.createElement("span", null,
                                        t('Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng'),
                                        ' ',
                                        react.createElement("b", null, (_e = (_d = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) === null || _d === void 0 ? void 0 : _d.selectedname) !== null && _e !== void 0 ? _e : ''))) : (''))),
                            renderRadioGroup(),
                            ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && ((_f = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _f === void 0 ? void 0 : _f.length) < 1) ||
                                (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isSearchable) ? null : (react.createElement(Searchable, { isDisabled: isDisable || (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled) },
                                react.createElement("div", null,
                                    react.createElement("input", { type: 'checkbox', disabled: isDisable || (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled), onChange: onClickMakeSearchable, checked: isSearchable }),
                                    react.createElement("span", null,
                                        t('Cho phép Nhà tuyển dụng tìm kiếm'),
                                        " ",
                                        react.createElement("b", null, renderResumeTilte()))),
                                applyJobInfo && (isDisable || applyJobInfo.isDisabled)
                                    ? renderValidateSearchable(applyType)
                                    : null)),
                            react.createElement(AlignRight, null,
                                react.createElement(Styled_css_Link, { href: hrefWowCV(), target: '_blank' }, t('Tạo hồ sơ ấn tượng với WowCV')))))) : (react.createElement(JobInfoSkeletion, null)),
                    react.createElement(UploadFile$1, { ref: uploadFileRef, t: t, accessToken: decryptToken, userId: (_h = Number((_g = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _g === void 0 ? void 0 : _g.userid)) !== null && _h !== void 0 ? _h : 0, jobId: jobId !== null && jobId !== void 0 ? jobId : 0, lang: lang, baseUrl: baseMsUrl, applyJobInfo: applyJobInfo, setApplyJobInfo: setApplyJobInfo }),
                    (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.length) > 0 && (react.createElement(PrivacyPolicyContainer, null,
                        react.createElement(CheckBoxGroup, null,
                            react.createElement(CheckBox/* default */.Z, { label: '', state: isCheckedPrivacy ? 'checked' : 'none', onCheckChange: function (value) { return setCheckedPrivacy(value === 'checked'); } }),
                            react.createElement(CheckboxLabel, null,
                                react.createElement("span", { onClick: onCheckChanged }, t('Tôi đồng ý với')),
                                ' ',
                                react.createElement(CheckboxLink, { href: privacyPolicy && (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.length) > 0 ? (_j = privacyPolicy[0]) === null || _j === void 0 ? void 0 : _j.fileUrl : '#', target: '_blank' }, t('Quy định bảo mật')),
                                ' ',
                                react.createElement("span", { onClick: onCheckChanged }, t('của nhà tuyển dụng này.')),
                                react.createElement("span", { className: 'required' }, "(*)"))),
                        isPrivacyError && (react.createElement(ErrorMessage, null, t('Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.')))))),
                applyMessage ? react.createElement(SystemError, { message: applyMessage, onClose: function () { return setApplyMessage(''); } }) : null),
            react.createElement(ButtonWrap, null,
                react.createElement(Button/* default */.Z, { type: 'primary', className: 'custom-btn', onClick: handleApplyJob, disabled: !applyJobInfo || ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && ((_k = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _k === void 0 ? void 0 : _k.length) < 1) || isLoading },
                    isLoading && react.createElement(LoadingIcon/* default */.Z, { bgColor: constants/* colors.bgNormal */.O9.bgNormal }),
                    t('Nộp Đơn'))))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slider.css.js
'use client';




var Slider_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Slider_css_templateObject_1 || (Slider_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"])), function (_a) {
    var height = _a.height;
    return "".concat(height, "px");
});
var Slider_css_SliderContainer = styled_components_browser_esm/* default.div */.ZP.div(Slider_css_templateObject_2 || (Slider_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"], ["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(Slider_css_templateObject_3 || (Slider_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"], ["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"])), function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement;
});
styled_components_browser_esm/* default.div */.ZP.div(Slider_css_templateObject_5 || (Slider_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: 100%;\n    ", "\n"], ["\n    display: inline-block;\n    height: 100%;\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return (0,styled_components_browser_esm/* css */.iv)(Slider_css_templateObject_4 || (Slider_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: ", "px !important;\n    "], ["\n        width: ", "px !important;\n    "])), widthElement);
});
var Slider_css_templateObject_1, Slider_css_templateObject_2, Slider_css_templateObject_3, Slider_css_templateObject_4, Slider_css_templateObject_5;


//# sourceMappingURL=Slider.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/index.js + 1 modules
var Pagination = __webpack_require__(56479);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slides/Slides.css.js
'use client';




var Slides_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_1 || (Slides_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    height: 100%;\n"], ["\n    display: flex;\n    height: 100%;\n"])));
var Slide = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_4 || (Slides_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: auto;\n\n    ", "\n\n    ", "\n"], ["\n    display: inline-block;\n    height: auto;\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return widthElement && (0,styled_components_browser_esm/* css */.iv)(Slides_css_templateObject_2 || (Slides_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: ", "px !important;\n        "], ["\n            width: ", "px !important;\n        "])), widthElement);
}, function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement && (0,styled_components_browser_esm/* css */.iv)(Slides_css_templateObject_3 || (Slides_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-right: ", "px;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        "], ["\n            margin-right: ", "px;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        "])), spaceElement);
});
var Slides_css_templateObject_1, Slides_css_templateObject_2, Slides_css_templateObject_3, Slides_css_templateObject_4;


//# sourceMappingURL=Slides.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slides/index.js
'use client';






var Slides = function (props) {
    var innerRef = props.innerRef, spaceBetween = props.spaceBetween, elementPerView = props.elementPerView, widthElement = props.widthElement, children = props.children, loading = props.loading, _a = props.loadingHeight, loadingHeight = _a === void 0 ? 250 : _a;
    var renderLoading = function () {
        return (react.createElement(Slides_css_Container, null, (0,_tslib/* __spreadArray */.ev)([], Array(elementPerView), true).map(function (_, idx) { return (react.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween },
            react.createElement(Skeleton/* default */.Z, { height: loadingHeight, width: widthElement }))); })));
    };
    var renderSlides = function () {
        return (react.createElement(Slides_css_Container, { ref: innerRef }, Array.isArray(children) ? (Object.values(children).map(function (item, idx) { return (react.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween }, item)); })) : (react.createElement(Slide, { widthElement: widthElement }, children))));
    };
    return loading ? renderLoading() : renderSlides();
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/index.js
'use client';









/**
 *
 * @author Tri, Tran Minh
 */
var Slider = function (props) {
    var slidesProps = props.slides, id = props.id, paginationProps = props.pagination, containerProps = props.container, autoEnable = props.autoEnable, _a = props.autoTime, autoTime = _a === void 0 ? 4000 : _a, loadingEnable = props.loadingEnable, loadingHeight = props.loadingHeight, _b = props.transitionTime, transitionTime = _b === void 0 ? 250 : _b, _c = props.transitionSensitivity, transitionSensitivity = _c === void 0 ? 0.15 : _c, _d = props.isRobot, isRobot = _d === void 0 ? false : _d, children = props.children;
    // init value props
    var slides = (0,_tslib/* __assign */.pi)({ spaceBetween: 8, elementPerView: 1 }, slidesProps);
    var pagination = (0,_tslib/* __assign */.pi)({ elementPerPage: 1, type: 'default', position: 'default' }, paginationProps);
    var container = (0,_tslib/* __assign */.pi)({}, containerProps);
    var _e = (0,react.useState)(null), sliderContainer = _e[0], setSliderContainer = _e[1];
    var _f = (0,react.useState)(null), innerSlider = _f[0], setInnerSlider = _f[1];
    var _g = (0,react.useState)(null), containerElement = _g[0], setContainerElement = _g[1];
    var calculateAmountOfPagination = function () {
        var childrenLength = Array.isArray(children) ? Object.values(children).length : 1;
        var elementPerView = slides.elementPerView || 0;
        var elementPerPage = pagination.elementPerPage || 0;
        if (children)
            return Math.ceil((childrenLength - elementPerView) / elementPerPage) + 1;
        else
            return 0;
    };
    var _h = (0,react.useState)(0), paginationIndex = _h[0], setPaginationIndex = _h[1];
    var _j = (0,react.useState)(calculateAmountOfPagination()), paginationAmount = _j[0], setPaginationAmount = _j[1];
    var getWidthSlideElement = function () {
        if (sliderContainer) {
            var container_1 = sliderContainer.getBoundingClientRect();
            var elementPerView = slides.elementPerView || 0;
            var spaceBetween = slides.spaceBetween || 0;
            return container_1.width / elementPerView - (spaceBetween * (elementPerView - 1)) / elementPerView;
        }
        return 0;
    };
    var smoothTransition = function (position) {
        if (innerSlider) {
            innerSlider.style.transform = "translateX(-".concat(position, "px)");
            innerSlider.style.transition = "".concat(transitionTime, "ms");
            setTimeout(function () { return (innerSlider.style.transition = '0s'); }, transitionTime);
        }
    };
    var isTouchDevice = function () {
        return !!('ontouchstart' in window);
    };
    var handlePaginationChange = function (idx) {
        if (innerSlider && sliderContainer) {
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            if (idx === paginationAmount - 1) {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var widthEachPage = inner.width - outer.width;
                setPaginationIndex(idx);
                smoothTransition(widthEachPage);
            }
            else {
                var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                setPaginationIndex(idx);
                smoothTransition(idx * widthEachPage);
            }
        }
    };
    // add grab and move slide event
    (0,react.useEffect)(function () {
        if (sliderContainer && innerSlider && paginationAmount) {
            var body_1 = document.querySelector('body');
            var scrollStatus_1 = ''; // detect mouse move is horizontal or vertical
            var pressed_1 = false; // mouse on press
            var startX_1; // position X when mouse down
            var x_1; // position X when mouse move
            var downX_1; // screen X when mouse down
            var downY_1; // screen Y when mouse down
            var upX_1; // screen X when mouse up
            var getInnerPosition_1 = function () {
                var position = innerSlider.style.transform.match(/[-.\d]/g);
                if (position)
                    return Number(position.join(''));
                else
                    return 0;
            };
            // move <Slides> back to position of nearest element
            var checkBoundary_1 = function () {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var position = getInnerPosition_1();
                var spaceBetween = slides.spaceBetween || 0;
                var elementPerPage = pagination.elementPerPage || 0;
                // handle grab slides move out container on left side
                if (position > 0) {
                    setPaginationIndex(0);
                    smoothTransition(0);
                    return;
                }
                // handle grab slides move out container on right side
                if (inner.right < outer.right) {
                    if (inner.width >= outer.width) {
                        setPaginationIndex(paginationAmount - 1);
                        smoothTransition(inner.width - outer.width);
                    }
                    else {
                        setPaginationIndex(0);
                        smoothTransition(0);
                    }
                    return;
                }
                // handle grab slides move in container
                if (position <= 0) {
                    // width on a page, a page can have so many slide
                    var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                    // if move to left downX < upX will rounding 0.85 -> 0 & 0.86 -> 1, make grab move smooth
                    var indexPage = Math.abs((0,helpers/* fixedNumber */.Bs)(position / widthEachPage, downX_1 < upX_1 ? 1 - transitionSensitivity : transitionSensitivity));
                    setPaginationIndex(indexPage);
                    smoothTransition(indexPage >= paginationAmount - 1 ? inner.width - outer.width : indexPage * widthEachPage);
                }
            };
            if (!isTouchDevice()) {
                // Desktop device event
                sliderContainer.addEventListener('mousedown', function (e) {
                    pressed_1 = true;
                    startX_1 = e.clientX - getInnerPosition_1();
                    downX_1 = e.clientX;
                    if (body_1)
                        body_1.style.cursor = 'grabbing';
                });
                window.addEventListener('mousemove', function (e) {
                    if (!pressed_1)
                        return;
                    e.preventDefault();
                    x_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'none'; // prevent click child after mouse up
                    innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                });
                window.addEventListener('mouseup', function (e) {
                    if (!pressed_1)
                        return;
                    if (body_1)
                        body_1.style.cursor = 'default';
                    pressed_1 = false;
                    upX_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'auto';
                    checkBoundary_1();
                });
            }
            else {
                // Mobile device event
                sliderContainer.addEventListener('touchstart', function (e) {
                    pressed_1 = true;
                    downX_1 = e.changedTouches[0].pageX;
                    downY_1 = e.changedTouches[0].pageY;
                    startX_1 = e.changedTouches[0].pageX - getInnerPosition_1();
                });
                sliderContainer.addEventListener('touchmove', function (e) {
                    if (!pressed_1)
                        return;
                    // find out touch move is vertical or horizontal, do nothing if scrollStatus !== 'horizontal'
                    if (scrollStatus_1 === '' && Math.abs(downY_1 - e.changedTouches[0].pageY) > 10) {
                        scrollStatus_1 = 'vertical';
                        return;
                    }
                    if (scrollStatus_1 === '' && Math.abs(downX_1 - e.changedTouches[0].pageX) > 10) {
                        scrollStatus_1 = 'horizontal';
                        return;
                    }
                    if (scrollStatus_1 === 'horizontal') {
                        e.preventDefault();
                        x_1 = e.changedTouches[0].pageX;
                        innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                    }
                });
                sliderContainer.addEventListener('touchend', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
                sliderContainer.addEventListener('touchcancel', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
            }
        }
    }, [innerSlider, sliderContainer, paginationAmount]);
    // add automation translate slide event
    (0,react.useEffect)(function () {
        if (autoEnable && containerElement && paginationAmount) {
            var interval_1 = null;
            var startInterval = function () {
                var elements = containerElement.querySelectorAll("[data-id^=".concat(id, "-pagination]"));
                var max = elements.length;
                var index = paginationIndex;
                elements.forEach(function (e, idx) {
                    var _a;
                    if ((_a = e.getAttribute('data-id')) === null || _a === void 0 ? void 0 : _a.includes('true'))
                        index = idx;
                });
                interval_1 = setInterval(function () {
                    if (index === max - 1) {
                        handlePaginationChange(0);
                        index = 0;
                    }
                    else {
                        handlePaginationChange(index + 1);
                        index++;
                    }
                }, autoTime);
            };
            var stopInterval = function () {
                clearInterval(interval_1);
                interval_1 = null;
            };
            startInterval();
            if (isTouchDevice()) {
                containerElement.addEventListener('touchstart', stopInterval);
                containerElement.addEventListener('touchend', startInterval);
            }
            else {
                containerElement.addEventListener('mouseover', stopInterval);
                containerElement.addEventListener('mouseout', startInterval);
            }
        }
    }, [autoEnable, containerElement, paginationAmount]);
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (children && slides.elementPerView)
            setPaginationAmount(calculateAmountOfPagination());
    }, [children, slides.elementPerView]);
    return !isRobot ? (react.createElement(Slider_css_Container, { id: id, style: container.style, ref: setContainerElement },
        react.createElement(Slider_css_SliderContainer, { style: slides.style, ref: setSliderContainer },
            react.createElement(Slides, { innerRef: setInnerSlider, spaceBetween: slides.spaceBetween, elementPerView: slides.elementPerView, widthElement: getWidthSlideElement(), loading: loadingEnable, loadingHeight: loadingHeight }, children)),
        pagination.type !== 'none' && (react.createElement(Pagination/* default */.Z, { type: pagination.type, position: pagination.position, style: pagination.style, isLoading: loadingEnable, id: "".concat(id, "-pagination"), onItemClick: function (idx) { return handlePaginationChange(idx); }, activeItem: paginationIndex, amountItem: paginationAmount, maxItem: (pagination.maxShow || 0) > paginationAmount ? paginationAmount : pagination.maxShow })))) : (react.createElement(react.Fragment, null, children));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/RecommendJobs/JobBlock/index.js
'use client';






var JobBlock = function (props) {
    var _a;
    var isHotJob = props.isHotJob, job = props.job, accessToken = props.accessToken, msUrl = props.msUrl, langCode = props.langCode, vnwBaseUrl = props.vnwBaseUrl, isFinalIndex = props.isFinalIndex, _b = props.classSelector, classSelector = _b === void 0 ? '' : _b, _c = props.enablePreviewJob, enablePreviewJob = _c === void 0 ? true : _c, userInfo = props.userInfo;
    var address = job.address, jobTitle = job.jobTitle, company = job.company, companyLogo = job.companyLogo, companyId = job.companyId, _d = job.locationsForLanguage, locationsForLanguage = _d === void 0 ? [] : _d, _e = job.url, url = _e === void 0 ? '' : _e, jobId = job.jobId, _f = job.prettySalary, prettySalary = _f === void 0 ? '' : _f, jobLevel = job.jobLevel, jobLevelVI = job.jobLevelVI, jobDescription = job.jobDescription, jobRequirement = job.jobRequirement, _g = job.isSaved, isSaved = _g === void 0 ? false : _g, _h = job.isApplied, isApplied = _h === void 0 ? false : _h, _j = job.isBlackList, isBlackList = _j === void 0 ? false : _j, isAnonymous = job.isAnonymous, _k = job.redirectTo, redirectTo = _k === void 0 ? '' : _k, jobLevelId = job.jobLevelId;
    var locationText = (locationsForLanguage === null || locationsForLanguage === void 0 ? void 0 : locationsForLanguage.join(', ')) || '';
    var companyAlias = (0,helpers/* slugify */.lV)(company || '');
    var companyUrl = "/".concat(langCode === constants/* ELanguage.EN */.Df.EN ? 'companies' : 'nha-tuyen-dung', "/").concat(companyAlias, "-c").concat(companyId);
    if (isAnonymous) {
        companyUrl = '';
    }
    return (react.createElement(react.Fragment, null,
        react.createElement(JobCardMini, { langCode: langCode, isMobile: (0,helpers/* isMobile */.tq)(), item: {
                jobTitle: jobTitle,
                jobId: jobId,
                jobUrl: url,
                companyLogo: companyLogo,
                company: company,
                companyUrl: companyUrl,
                jobLevelId: jobLevelId,
                jobLevel: jobLevel,
                jobLevelVI: jobLevelVI,
                jobLevelText: langCode === constants/* ELanguage.EN */.Df.EN ? jobLevel : jobLevelVI,
                address: address,
                jobDescription: jobDescription,
                jobRequirement: jobRequirement,
                isSaved: isSaved,
                isApplied: isApplied,
                isBlackList: isBlackList,
                isAnonymous: isAnonymous,
                redirectTo: redirectTo,
                locationText: locationText,
                prettySalary: prettySalary,
                jobInvitation: (_a = props.job.jobInvitation) !== null && _a !== void 0 ? _a : { jobInvitationId: 0, status: 0 }
            }, displayOptions: {
                isHot: isHotJob
            }, api: {
                baseUrl: msUrl,
                accessToken: accessToken,
                appId: '',
                source: 'Find Jobs'
            }, previewJob: {
                enable: (0,helpers/* isMobile */.tq)() ? false : enablePreviewJob,
                appMode: 'production',
                baseUrl: vnwBaseUrl
            }, settingJob: {
                showType: isFinalIndex ? 'top' : 'bottom'
            }, classSelector: classSelector, userInfo: userInfo, initData: props.initData })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/RecommendJobs/Section/index.js
'use client';






var Section = function (props) {
    var _a = props.title, title = _a === void 0 ? '' : _a, _b = props.ctaLink, ctaLink = _b === void 0 ? null : _b, children = props.children;
    return (react.createElement(SectionContainer, null,
        react.createElement(SectionHeading, null,
            title && react.createElement(Section_Title, { isMobile: (0,helpers/* isMobile */.tq)() }, title),
            ctaLink && react.createElement(Section_Link, { isMobile: (0,helpers/* isMobile */.tq)() }, ctaLink)),
        react.createElement(SectionContent, null, children)));
};
var SectionContainer = styled_components_browser_esm/* default.section */.ZP.section(Section_templateObject_1 || (Section_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid #ccdeff;\n    border-radius: 6px;\n"], ["\n    border: 1px solid #ccdeff;\n    border-radius: 6px;\n"])));
var SectionHeading = styled_components_browser_esm/* default.div */.ZP.div(Section_templateObject_2 || (Section_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 5px 5px 0 0;\n    padding: 20px 25px 20px 40px;\n    background-color: #f2f7ff;\n    background-image: url('https://www.vietnamworks.com/assets-page-container/images/featured-jobs-background.png');\n    background-repeat: no-repeat;\n    background-position: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n"], ["\n    border-radius: 5px 5px 0 0;\n    padding: 20px 25px 20px 40px;\n    background-color: #f2f7ff;\n    background-image: url('https://www.vietnamworks.com/assets-page-container/images/featured-jobs-background.png');\n    background-repeat: no-repeat;\n    background-position: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n"])));
var SectionContent = styled_components_browser_esm/* default.div */.ZP.div(Section_templateObject_3 || (Section_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 100%;\n    padding: 25px;\n"], ["\n    height: 100%;\n    padding: 25px;\n"])));
var Section_Title = styled_components_browser_esm/* default.h2 */.ZP.h2(Section_templateObject_6 || (Section_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    ", "\n"], ["\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(Section_templateObject_4 || (Section_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                font-size: 18px;\n            "], ["\n                font-size: 18px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(Section_templateObject_5 || (Section_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            font-size: 22px;\n        "], ["\n            font-size: 22px;\n        "])));
});
var Section_Link = styled_components_browser_esm/* default.div */.ZP.div(Section_templateObject_9 || (Section_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #005aff !important;\n    text-transform: uppercase;\n    ", "\n"], ["\n    color: #005aff !important;\n    text-transform: uppercase;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(Section_templateObject_7 || (Section_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                font-size: 14px;\n            "], ["\n                font-size: 14px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(Section_templateObject_8 || (Section_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            font-size: 16px;\n        "], ["\n            font-size: 16px;\n        "])));
});
var Section_templateObject_1, Section_templateObject_2, Section_templateObject_3, Section_templateObject_4, Section_templateObject_5, Section_templateObject_6, Section_templateObject_7, Section_templateObject_8, Section_templateObject_9;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/RecommendJobs/helper.js
'use client';

var getLastViewJobId = function (lastViewCookie, userId) {
    if (!!lastViewCookie) {
        var lastViewJobData = decodeURIComponent(lastViewCookie).split(',');
        var jobId = lastViewJobData[0];
        var userViewJob = parseFloat(lastViewJobData[1]);
        var isAnonymous = !userId || userViewJob === 0;
        if (!isAnonymous && userId !== userViewJob) {
            return;
        }
        return jobId;
    }
    return;
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/RecommendJobs/services.js
'use client';




var API_URL = 'https://staging-ms.vietnamworks.com/smartnavi/v2/jobs';
// const langCode = 'vi'
var LANG_ID_EN = 2;
var VNW_BASE_URL = 'https://staging.vietnamworks.com';
var UTM = {
    utm_source: 'vnw_homepage',
    utm_medium: 'TopJobReco',
    utm_campaign: 'TopJobReco',
    utm_term: 'homepage2',
    source: 'homePage'
};
var makeRequest = function (path, method, body, langCode) {
    if (method === void 0) { method = 'get'; }
    if (body === void 0) { body = null; }
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var res;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(path, {
                        method: method,
                        body: body,
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
                case 1:
                    res = _a.sent();
                    if (res.status !== 200) {
                        throw new Error('Request error');
                    }
                    return [4 /*yield*/, res.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
var buildQueryString = function (params) {
    var queryString = [];
    for (var key in params) {
        if (params.hasOwnProperty(key) && !!params[key]) {
            queryString.push("".concat(key, "=").concat(encodeURIComponent(params[key])));
        }
    }
    return queryString.length > 0 ? queryString.join('&') : '';
};
var buildJobUrl = function (jobId, alias, languageId, queryParams, vnwBaseURL) {
    var queryString = '';
    if (queryParams) {
        queryString = buildQueryString(queryParams);
    }
    var baseJobUrl = "".concat(vnwBaseURL).concat(alias, "-").concat(jobId, "-").concat(languageId === LANG_ID_EN ? 'jd' : 'jv');
    return queryString !== '' ? "".concat(baseJobUrl, "/?").concat(queryString) : baseJobUrl;
};
var utmRecoJob = function (jobSource, utmData) {
    var utm = {
        utm_source_navi: utmData.utm_source,
        utm_medium_navi: utmData.utm_medium,
        utm_campaign_navi: utmData.utm_campaign,
        utm_content_navi: jobSource,
        utm_term_navi: utmData.utm_term,
        source: utmData.source
    };
    return buildQueryString(utm);
};
var buildUrl = function (jobId, userId, limit, apiUrl, language) {
    var queryString = buildQueryString({
        jobId: jobId,
        user: userId,
        limit: limit,
        t: String(Date.now()),
        lang: language
    });
    return "".concat(apiUrl, "?").concat(queryString);
};
var getRecommendJobs = function (jobId, userId, langCode, limit, apiUrl, vnwBaseURL, utmData) {
    if (jobId === void 0) { jobId = 0; }
    if (userId === void 0) { userId = 0; }
    if (langCode === void 0) { langCode = 1; }
    if (limit === void 0) { limit = 80; }
    if (apiUrl === void 0) { apiUrl = API_URL; }
    if (vnwBaseURL === void 0) { vnwBaseURL = VNW_BASE_URL; }
    if (utmData === void 0) { utmData = UTM; }
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var data, trackingSource, utmTracking_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(buildUrl(jobId, userId, limit, apiUrl, langCode === 1 ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN), 'get', null, langCode === 1 ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN)];
                case 1:
                    data = _a.sent();
                    if (data.jobs) {
                        trackingSource = data.source;
                        utmTracking_1 = utmRecoJob(trackingSource, utmData);
                        return [2 /*return*/, data.jobs.map(function (item) {
                                var _a;
                                return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { locationsForLanguage: (_a = item.locations) === null || _a === void 0 ? void 0 : _a[langCode === 1 ? 1 : 2], url: "".concat(buildJobUrl(item.jobId, item.alias, langCode, '', vnwBaseURL), "?").concat(utmTracking_1) }));
                            })];
                    }
                    return [2 /*return*/, []];
            }
        });
    });
};


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/RecommendJobs/index.js
'use client';












var RecommendJobs_isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
var ITEMS_PER_SLIDE = RecommendJobs_isMobile ? 4 : 3;
var LANGUAGE_CODE_VN = 1;
var RecommnendJobs = function (props) {
    var _a;
    var _b = props.jobId, jobId = _b === void 0 ? '' : _b, apiUrl = props.apiUrl, languageCode = props.languageCode, limit = props.limit, user = props.user, userInfo = props.userInfo, userIP = props.userIP, utmData = props.utmData, vnwBaseURL = props.vnwBaseURL, _c = props.sectionTitle, sectionTitle = _c === void 0 ? '' : _c, _d = props.ssrJobs, ssrJobs = _d === void 0 ? [] : _d, _e = props.isWrapper, isWrapper = _e === void 0 ? false : _e, ctaLink = props.ctaLink, _f = props.isHotJob, isHotJob = _f === void 0 ? false : _f, handleNoJobs = props.handleNoJobs, onDataSourceComplete = props.onDataSourceComplete, previewJob = props.previewJob, _g = props.classSelector, classSelector = _g === void 0 ? '' : _g, initData = props.initData;
    var _h = (0,react.useState)(ssrJobs), jobs = _h[0], setJobs = _h[1];
    var _j = (0,react.useState)(false), forceHidden = _j[0], setForceHidden = _j[1];
    var _k = (0,react.useState)(true), isRobot = _k[0], setIsRobot = _k[1];
    var _l = (0,react.useState)((previewJob === null || previewJob === void 0 ? void 0 : previewJob.accessToken) || ''), accessToken = _l[0], setAccessToken = _l[1];
    var _m = previewJob || {}, _o = _m.enablePreviewJob, enablePreviewJob = _o === void 0 ? false : _o, _p = _m.msUrl, msUrl = _p === void 0 ? '' : _p;
    var langCode = languageCode === LANGUAGE_CODE_VN ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN;
    var handleNoJobsFound = function () {
        handleNoJobs === null || handleNoJobs === void 0 ? void 0 : handleNoJobs();
        setForceHidden(true);
    };
    var invokedGetJobs = (0,react.useCallback)(function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var userId, lastViewJobId, data, reformatJobs, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    userId = user;
                    lastViewJobId = jobId || getLastViewJobId(((js_cookie_default()) === null || (js_cookie_default()) === void 0 ? void 0 : js_cookie_default().get('VNW_LAST_JOB_SEEN')) || '', Number.parseInt(userId, 10));
                    return [4 /*yield*/, getRecommendJobs(lastViewJobId || 0, userId || userIP, languageCode, limit, apiUrl, vnwBaseURL, utmData)];
                case 1:
                    data = _a.sent();
                    if (!enablePreviewJob) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0,services/* getSpecialJob */.nL)({
                            baseUrl: msUrl,
                            accessToken: accessToken,
                            jobs: data
                        })];
                case 2:
                    reformatJobs = _a.sent();
                    reformatJobs.data.length > 0 ? setJobs(reformatJobs.data) : handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    onDataSourceComplete === null || onDataSourceComplete === void 0 ? void 0 : onDataSourceComplete(reformatJobs.data);
                    return [3 /*break*/, 4];
                case 3:
                    data.length > 0 ? setJobs(data) : handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    onDataSourceComplete === null || onDataSourceComplete === void 0 ? void 0 : onDataSourceComplete(data);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    console.log(err_1);
                    handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, []);
    (0,react.useEffect)(function () {
        var _a, _b;
        if ((_a = props.previewJob) === null || _a === void 0 ? void 0 : _a.accessToken) {
            setAccessToken((_b = props.previewJob) === null || _b === void 0 ? void 0 : _b.accessToken);
        }
    }, [props.previewJob]);
    (0,react.useEffect)(function () {
        invokedGetJobs();
        setIsRobot(false);
    }, [invokedGetJobs]);
    var tempUserInfo = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, userInfo), { jobLevelId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId[0], id: (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _a !== void 0 ? _a : 0 });
    var renderSlideContent = function () {
        var slidesContent = [];
        var jobsPerPage = [];
        var slideIndex = 0;
        jobs.forEach(function (job, index) {
            var isFinalIndex = (jobs.length <= ITEMS_PER_SLIDE && index === jobs.length - 1) ||
                jobsPerPage.length === ITEMS_PER_SLIDE - 1;
            jobsPerPage.push(react.createElement("div", { className: '', key: index },
                react.createElement(JobBlock, { isFinalIndex: isFinalIndex, langCode: langCode, job: job, enablePreviewJob: enablePreviewJob, isHotJob: isHotJob, accessToken: accessToken, msUrl: msUrl, vnwBaseUrl: vnwBaseURL, classSelector: classSelector, userInfo: tempUserInfo, initData: initData })));
            // Render the full column
            if ((index + 1) % ITEMS_PER_SLIDE === 0) {
                slidesContent.push(react.createElement("div", { className: 'swiper-slide', key: ++slideIndex },
                    react.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16
                        } }, jobsPerPage)));
                jobsPerPage = [];
            }
            // Render the last column
            if (index === jobs.length - 1 && jobsPerPage.length > 0) {
                slidesContent.push(react.createElement("div", { className: 'swiper-slide', key: ++slideIndex },
                    react.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16
                        } }, jobsPerPage)));
            }
        });
        return slidesContent;
    };
    var renderContent = function () {
        var slidesContent = renderSlideContent();
        return (react.createElement("div", { className: 'swiper-container' }, RecommendJobs_isMobile ? (react.createElement(Slider, { id: 'recommend-jobs-mobile', slides: { spaceBetween: 16 }, pagination: { maxShow: 6, type: 'defaultNotArrow' }, loadingEnable: jobs.length === 0, loadingHeight: 445, container: { style: { width: '100%' } }, isRobot: isRobot }, slidesContent)) : (react.createElement(Slider, { id: 'recommend-jobs', slides: { elementPerView: 3, spaceBetween: 16 }, pagination: { maxShow: 8, elementPerPage: 2 }, loadingEnable: jobs.length === 0, loadingHeight: 345, container: { style: { width: '100%' } }, isRobot: isRobot }, slidesContent))));
    };
    var contentNode = renderContent();
    if (forceHidden) {
        return react.createElement(react.Fragment, null);
    }
    if (isWrapper) {
        return (react.createElement(Section, { title: sectionTitle, ctaLink: ctaLink }, contentNode));
    }
    return contentNode;
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Referral/CreateCandidateModal/images.js
'use client';



var Icon8Checked = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 66 : _b, _c = _a.height, height = _c === void 0 ? 66 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 66 66', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'REFERRALS-A', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'REFERRAL/REF-EMAIL-SUCCESSFULLY-1', transform: 'translate(-617.000000, -329.000000)', fill: '#00B70B', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-7', transform: 'translate(165.000000, 281.000000)' },
                    react.createElement("g", { id: 'Group-3', transform: 'translate(249.000000, 48.000000)' },
                        react.createElement("g", { id: 'icons8-checked', transform: 'translate(203.000000, 0.000000)' },
                            react.createElement("path", { d: 'M33,0 C14.804688,0 0,14.804688 0,33 C0,51.195313 14.804688,66 33,66 C51.195313,66 66,51.195313 66,33 C66,27.417969 64.601563,22.160156 62.144531,17.546875 L60.648438,19.007813 C62.785156,23.214844 64,27.96875 64,33 C64,50.09375 50.09375,64 33,64 C15.90625,64 2,50.09375 2,33 C2,15.90625 15.90625,2 33,2 C41.789063,2 49.726563,5.679688 55.375,11.578125 L56.800781,10.179688 C50.792969,3.914063 42.347656,0 33,0 Z M33,5 C32.449219,5 32,5.449219 32,6 C32,6.550781 32.449219,7 33,7 C33.550781,7 34,6.550781 34,6 C34,5.449219 33.550781,5 33,5 Z M38.292969,5.515625 C37.804688,5.503906 37.382813,5.84375 37.285156,6.324219 C37.179688,6.863281 37.53125,7.390625 38.074219,7.5 C38.613281,7.605469 39.140625,7.253906 39.25,6.714844 C39.355469,6.171875 39.003906,5.644531 38.464844,5.535156 C38.40625,5.527344 38.351563,5.519531 38.292969,5.515625 Z M27.738281,5.519531 C27.671875,5.519531 27.605469,5.523438 27.539063,5.535156 C26.996094,5.644531 26.644531,6.171875 26.753906,6.714844 C26.804688,6.972656 26.957031,7.203125 27.179688,7.351563 C27.398438,7.496094 27.667969,7.550781 27.929688,7.5 C28.472656,7.390625 28.824219,6.867188 28.714844,6.324219 C28.621094,5.859375 28.214844,5.523438 27.738281,5.519531 Z M22.675781,7.054688 C22.542969,7.054688 22.410156,7.078125 22.285156,7.128906 C21.773438,7.34375 21.53125,7.925781 21.746094,8.4375 C21.957031,8.949219 22.539063,9.191406 23.050781,8.980469 C23.5625,8.765625 23.804688,8.183594 23.59375,7.671875 C23.4375,7.300781 23.078125,7.058594 22.675781,7.054688 Z M43.355469,7.054688 C42.941406,7.046875 42.566406,7.289063 42.40625,7.671875 C42.195313,8.183594 42.4375,8.765625 42.949219,8.980469 C43.460938,9.191406 44.042969,8.949219 44.253906,8.4375 C44.46875,7.925781 44.226563,7.34375 43.714844,7.128906 C43.601563,7.082031 43.476563,7.058594 43.355469,7.054688 Z M18.011719,9.546875 C17.808594,9.546875 17.609375,9.605469 17.441406,9.71875 C16.984375,10.023438 16.859375,10.644531 17.167969,11.105469 C17.472656,11.5625 18.09375,11.6875 18.554688,11.378906 C19.015625,11.074219 19.136719,10.453125 18.832031,9.996094 C18.648438,9.71875 18.339844,9.550781 18.011719,9.546875 Z M48.015625,9.546875 C47.675781,9.542969 47.355469,9.710938 47.167969,9.996094 C46.859375,10.453125 46.984375,11.074219 47.441406,11.378906 C47.902344,11.6875 48.523438,11.5625 48.828125,11.105469 C48.976563,10.886719 49.03125,10.613281 48.980469,10.355469 C48.929688,10.09375 48.777344,9.863281 48.554688,9.71875 C48.394531,9.609375 48.210938,9.550781 48.015625,9.546875 Z M61.113281,10.15625 L30.859375,39.777344 L20.035156,28.722656 L17.890625,30.824219 L30.8125,44.019531 L63.214844,12.300781 L61.113281,10.15625 Z M13.921875,12.90625 C13.652344,12.90625 13.390625,13.011719 13.203125,13.203125 C12.8125,13.589844 12.8125,14.226563 13.203125,14.613281 C13.589844,15.003906 14.226563,15.003906 14.613281,14.613281 C15.003906,14.226563 15.003906,13.589844 14.613281,13.203125 C14.429688,13.015625 14.183594,12.910156 13.921875,12.90625 Z M52.105469,12.90625 C51.835938,12.90625 51.574219,13.011719 51.386719,13.203125 C50.996094,13.589844 50.996094,14.226563 51.386719,14.613281 C51.773438,15.003906 52.410156,15.003906 52.796875,14.613281 C53.1875,14.226563 53.1875,13.589844 52.796875,13.203125 C52.613281,13.015625 52.367188,12.910156 52.105469,12.90625 Z M10.566406,17 C10.226563,16.992188 9.90625,17.160156 9.71875,17.441406 C9.414063,17.902344 9.535156,18.523438 9.996094,18.828125 C10.457031,19.136719 11.074219,19.011719 11.382813,18.554688 C11.6875,18.09375 11.566406,17.472656 11.105469,17.167969 C10.945313,17.0625 10.761719,17.003906 10.566406,17 Z M57.953125,21.667969 C57.820313,21.664063 57.6875,21.691406 57.5625,21.742188 C57.050781,21.953125 56.808594,22.539063 57.019531,23.046875 C57.234375,23.558594 57.816406,23.800781 58.328125,23.589844 C58.839844,23.378906 59.082031,22.792969 58.871094,22.28125 C58.714844,21.914063 58.355469,21.667969 57.953125,21.667969 Z M8.078125,21.667969 C7.664063,21.660156 7.289063,21.902344 7.132813,22.285156 C6.921875,22.796875 7.164063,23.378906 7.671875,23.59375 C8.183594,23.804688 8.769531,23.5625 8.980469,23.050781 C9.191406,22.539063 8.949219,21.957031 8.4375,21.746094 C8.324219,21.695313 8.203125,21.671875 8.078125,21.667969 Z M59.484375,26.734375 C59.417969,26.730469 59.351563,26.738281 59.285156,26.75 C58.746094,26.859375 58.394531,27.386719 58.5,27.925781 C58.609375,28.46875 59.136719,28.820313 59.675781,28.714844 C60.21875,28.605469 60.570313,28.078125 60.464844,27.535156 C60.371094,27.070313 59.960938,26.734375 59.484375,26.734375 Z M6.546875,26.734375 C6.058594,26.722656 5.636719,27.058594 5.539063,27.535156 C5.488281,27.796875 5.539063,28.070313 5.6875,28.289063 C5.835938,28.511719 6.066406,28.664063 6.328125,28.714844 C6.585938,28.765625 6.855469,28.710938 7.078125,28.566406 C7.296875,28.417969 7.449219,28.1875 7.5,27.925781 C7.609375,27.386719 7.257813,26.859375 6.71875,26.75 C6.660156,26.742188 6.605469,26.734375 6.546875,26.734375 Z M6,32 C5.449219,32 5,32.449219 5,33 C5,33.550781 5.449219,34 6,34 C6.550781,34 7,33.550781 7,33 C7,32.449219 6.550781,32 6,32 Z M60,32 C59.449219,32 59,32.449219 59,33 C59,33.550781 59.449219,34 60,34 C60.550781,34 61,33.550781 61,33 C61,32.449219 60.550781,32 60,32 Z M6.523438,37.265625 C6.457031,37.265625 6.390625,37.273438 6.324219,37.285156 C5.78125,37.394531 5.429688,37.921875 5.539063,38.464844 C5.648438,39.003906 6.171875,39.355469 6.714844,39.25 C7.257813,39.140625 7.609375,38.613281 7.5,38.074219 C7.40625,37.605469 7,37.269531 6.523438,37.265625 Z M59.507813,37.265625 C59.019531,37.253906 58.597656,37.59375 58.5,38.074219 C58.394531,38.613281 58.746094,39.140625 59.285156,39.25 C59.828125,39.355469 60.355469,39.003906 60.464844,38.464844 C60.570313,37.921875 60.21875,37.394531 59.675781,37.285156 C59.621094,37.277344 59.566406,37.269531 59.507813,37.265625 Z M57.96875,42.328125 C57.554688,42.320313 57.179688,42.566406 57.019531,42.949219 C56.808594,43.457031 57.050781,44.042969 57.5625,44.253906 C58.074219,44.464844 58.65625,44.222656 58.871094,43.714844 C59.082031,43.203125 58.839844,42.617188 58.328125,42.40625 C58.214844,42.359375 58.089844,42.332031 57.96875,42.328125 Z M8.0625,42.332031 C7.929688,42.332031 7.796875,42.355469 7.671875,42.40625 C7.429688,42.507813 7.234375,42.703125 7.132813,42.949219 C7.03125,43.195313 7.03125,43.46875 7.128906,43.714844 C7.34375,44.226563 7.925781,44.46875 8.4375,44.253906 C8.683594,44.15625 8.878906,43.960938 8.980469,43.714844 C9.082031,43.46875 9.082031,43.195313 8.980469,42.949219 C8.828125,42.578125 8.464844,42.335938 8.0625,42.332031 Z M55.46875,47 C55.128906,46.992188 54.808594,47.160156 54.621094,47.441406 C54.3125,47.902344 54.4375,48.519531 54.894531,48.828125 C55.113281,48.976563 55.386719,49.03125 55.644531,48.976563 C55.90625,48.925781 56.136719,48.773438 56.28125,48.550781 C56.589844,48.09375 56.464844,47.472656 56.003906,47.167969 C55.847656,47.058594 55.660156,47 55.46875,47 Z M10.5625,47 C10.359375,46.996094 10.164063,47.054688 9.996094,47.167969 C9.539063,47.476563 9.414063,48.09375 9.71875,48.554688 C10.027344,49.011719 10.648438,49.136719 11.109375,48.828125 C11.566406,48.523438 11.691406,47.902344 11.382813,47.441406 C11.199219,47.167969 10.890625,47.003906 10.5625,47 Z M13.921875,51.09375 C13.652344,51.089844 13.390625,51.195313 13.203125,51.386719 C12.8125,51.773438 12.8125,52.410156 13.203125,52.796875 C13.589844,53.1875 14.226563,53.1875 14.613281,52.796875 C15.003906,52.410156 15.003906,51.773438 14.613281,51.386719 C14.429688,51.199219 14.183594,51.09375 13.921875,51.09375 Z M52.105469,51.09375 C51.835938,51.089844 51.574219,51.195313 51.386719,51.386719 C50.996094,51.773438 50.996094,52.410156 51.386719,52.796875 C51.773438,53.1875 52.410156,53.1875 52.796875,52.796875 C53.1875,52.410156 53.1875,51.773438 52.796875,51.386719 C52.613281,51.199219 52.367188,51.09375 52.105469,51.09375 Z M18.019531,54.449219 C17.679688,54.441406 17.359375,54.609375 17.171875,54.890625 C16.863281,55.351563 16.988281,55.972656 17.449219,56.28125 C17.90625,56.585938 18.527344,56.460938 18.832031,56.003906 C19.140625,55.542969 19.015625,54.925781 18.558594,54.617188 C18.398438,54.511719 18.210938,54.449219 18.019531,54.449219 Z M48.011719,54.449219 C47.808594,54.445313 47.613281,54.503906 47.445313,54.613281 C47.222656,54.761719 47.070313,54.992188 47.019531,55.253906 C46.96875,55.511719 47.023438,55.785156 47.171875,56.003906 C47.476563,56.460938 48.097656,56.585938 48.558594,56.28125 C49.015625,55.972656 49.140625,55.351563 48.832031,54.890625 C48.652344,54.617188 48.34375,54.449219 48.011719,54.449219 Z M22.691406,56.941406 C22.277344,56.933594 21.902344,57.179688 21.746094,57.5625 C21.535156,58.070313 21.777344,58.65625 22.285156,58.867188 C22.796875,59.078125 23.382813,58.835938 23.59375,58.328125 C23.804688,57.816406 23.5625,57.230469 23.050781,57.019531 C22.9375,56.972656 22.816406,56.945313 22.691406,56.941406 Z M43.339844,56.941406 C43.207031,56.941406 43.074219,56.96875 42.953125,57.019531 C42.707031,57.121094 42.511719,57.316406 42.410156,57.558594 C42.308594,57.804688 42.308594,58.082031 42.40625,58.328125 C42.621094,58.835938 43.203125,59.078125 43.714844,58.867188 C43.960938,58.765625 44.15625,58.570313 44.257813,58.328125 C44.359375,58.082031 44.359375,57.804688 44.257813,57.5625 C44.105469,57.1875 43.742188,56.945313 43.339844,56.941406 Z M27.761719,58.480469 C27.273438,58.46875 26.847656,58.808594 26.753906,59.285156 C26.644531,59.828125 26.996094,60.351563 27.539063,60.460938 C28.082031,60.570313 28.605469,60.21875 28.714844,59.675781 C28.824219,59.132813 28.472656,58.609375 27.929688,58.5 C27.875,58.488281 27.816406,58.480469 27.761719,58.480469 Z M38.269531,58.484375 C38.203125,58.480469 38.136719,58.488281 38.074219,58.5 C37.53125,58.609375 37.179688,59.132813 37.285156,59.675781 C37.339844,59.9375 37.492188,60.164063 37.710938,60.3125 C37.933594,60.460938 38.203125,60.515625 38.464844,60.464844 C38.722656,60.410156 38.953125,60.257813 39.101563,60.039063 C39.246094,59.816406 39.300781,59.546875 39.25,59.285156 C39.15625,58.820313 38.746094,58.484375 38.269531,58.484375 Z M33,59 C32.449219,59 32,59.449219 32,60 C32,60.550781 32.449219,61 33,61 C33.550781,61 34,60.550781 34,60 C34,59.449219 33.550781,59 33,59 Z', id: 'Shape' }))))))));
};
var Icon8Important = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 66 : _b, _c = _a.height, height = _c === void 0 ? 66 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 66 66', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'REFERRALS-A', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'REFERRAL/REF-EMAIL-ALREADY-APPLIED', transform: 'translate(-617.000000, -329.000000)', fill: '#FF7D55', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-7', transform: 'translate(165.000000, 281.000000)' },
                    react.createElement("g", { id: 'Group-3', transform: 'translate(249.000000, 48.000000)' },
                        react.createElement("g", { id: 'icons8-box_important', transform: 'translate(203.000000, 0.000000)' },
                            react.createElement("path", { d: 'M33,0 C14.785156,0 0,14.785156 0,33 C0,51.214844 14.785156,66 33,66 C51.214844,66 66,51.214844 66,33 C66,14.785156 51.214844,0 33,0 Z M33,2 C50.132813,2 64,15.867188 64,33 C64,50.132813 50.132813,64 33,64 C15.867188,64 2,50.132813 2,33 C2,15.867188 15.867188,2 33,2 Z M33,5 C32.449219,5 32,5.449219 32,6 C32,6.550781 32.449219,7 33,7 C33.550781,7 34,6.550781 34,6 C34,5.449219 33.550781,5 33,5 Z M38.292969,5.515625 C37.804688,5.503906 37.382813,5.84375 37.285156,6.324219 C37.179688,6.863281 37.53125,7.390625 38.074219,7.5 C38.613281,7.605469 39.140625,7.253906 39.25,6.714844 C39.355469,6.171875 39.003906,5.644531 38.464844,5.535156 C38.40625,5.527344 38.351563,5.519531 38.292969,5.515625 Z M27.738281,5.519531 C27.671875,5.519531 27.605469,5.523438 27.539063,5.535156 C26.996094,5.644531 26.644531,6.171875 26.753906,6.714844 C26.804688,6.972656 26.957031,7.203125 27.179688,7.351563 C27.398438,7.496094 27.667969,7.550781 27.929688,7.5 C28.472656,7.390625 28.824219,6.867188 28.714844,6.324219 C28.621094,5.859375 28.214844,5.523438 27.738281,5.519531 Z M22.675781,7.054688 C22.542969,7.054688 22.410156,7.078125 22.285156,7.128906 C21.773438,7.34375 21.53125,7.925781 21.746094,8.4375 C21.957031,8.949219 22.539063,9.191406 23.050781,8.980469 C23.5625,8.765625 23.804688,8.183594 23.59375,7.671875 C23.4375,7.300781 23.078125,7.058594 22.675781,7.054688 Z M43.355469,7.054688 C42.941406,7.046875 42.566406,7.289063 42.40625,7.671875 C42.195313,8.183594 42.4375,8.765625 42.949219,8.980469 C43.460938,9.191406 44.042969,8.949219 44.253906,8.4375 C44.46875,7.925781 44.226563,7.34375 43.714844,7.128906 C43.601563,7.082031 43.476563,7.058594 43.355469,7.054688 Z M18.011719,9.546875 C17.808594,9.546875 17.609375,9.605469 17.441406,9.71875 C16.984375,10.023438 16.859375,10.644531 17.167969,11.105469 C17.472656,11.5625 18.09375,11.6875 18.554688,11.378906 C19.015625,11.074219 19.136719,10.453125 18.832031,9.996094 C18.648438,9.71875 18.339844,9.550781 18.011719,9.546875 Z M48.015625,9.546875 C47.675781,9.542969 47.355469,9.710938 47.167969,9.996094 C46.859375,10.453125 46.984375,11.074219 47.441406,11.378906 C47.902344,11.6875 48.523438,11.5625 48.828125,11.105469 C48.976563,10.886719 49.03125,10.613281 48.980469,10.355469 C48.929688,10.09375 48.777344,9.863281 48.554688,9.71875 C48.394531,9.609375 48.210938,9.550781 48.015625,9.546875 Z M13.921875,12.90625 C13.652344,12.90625 13.390625,13.011719 13.203125,13.203125 C12.8125,13.589844 12.8125,14.226563 13.203125,14.613281 C13.589844,15.003906 14.226563,15.003906 14.613281,14.613281 C15.003906,14.226563 15.003906,13.589844 14.613281,13.203125 C14.429688,13.015625 14.183594,12.910156 13.921875,12.90625 Z M52.105469,12.90625 C51.835938,12.90625 51.574219,13.011719 51.386719,13.203125 C50.996094,13.589844 50.996094,14.226563 51.386719,14.613281 C51.773438,15.003906 52.410156,15.003906 52.796875,14.613281 C53.1875,14.226563 53.1875,13.589844 52.796875,13.203125 C52.613281,13.015625 52.367188,12.910156 52.105469,12.90625 Z M55.460938,17 C55.257813,16.996094 55.0625,17.054688 54.894531,17.167969 C54.4375,17.472656 54.3125,18.09375 54.621094,18.550781 C54.925781,19.011719 55.546875,19.136719 56.003906,18.828125 C56.464844,18.519531 56.589844,17.902344 56.28125,17.441406 C56.097656,17.167969 55.789063,17 55.460938,17 Z M10.566406,17 C10.226563,16.992188 9.90625,17.160156 9.71875,17.441406 C9.414063,17.902344 9.535156,18.523438 9.996094,18.828125 C10.457031,19.136719 11.074219,19.011719 11.382813,18.554688 C11.6875,18.09375 11.566406,17.472656 11.105469,17.167969 C10.945313,17.0625 10.761719,17.003906 10.566406,17 Z M28.945313,17 L30.050781,38 L35.949219,38 L36,37.050781 L37.054688,17 L28.945313,17 Z M31.050781,19 L34.949219,19 L34.050781,36 L31.949219,36 L31.050781,19 Z M57.953125,21.667969 C57.820313,21.664063 57.6875,21.691406 57.5625,21.742188 C57.050781,21.953125 56.808594,22.539063 57.019531,23.046875 C57.234375,23.558594 57.816406,23.800781 58.328125,23.589844 C58.839844,23.378906 59.082031,22.792969 58.871094,22.28125 C58.714844,21.914063 58.355469,21.667969 57.953125,21.667969 Z M8.078125,21.667969 C7.664063,21.660156 7.289063,21.902344 7.132813,22.285156 C6.921875,22.796875 7.164063,23.378906 7.671875,23.59375 C8.183594,23.804688 8.769531,23.5625 8.980469,23.050781 C9.191406,22.539063 8.949219,21.957031 8.4375,21.746094 C8.324219,21.695313 8.203125,21.671875 8.078125,21.667969 Z M59.484375,26.734375 C59.417969,26.730469 59.351563,26.738281 59.285156,26.75 C58.746094,26.859375 58.394531,27.386719 58.5,27.925781 C58.609375,28.46875 59.136719,28.820313 59.675781,28.714844 C60.21875,28.605469 60.570313,28.078125 60.464844,27.535156 C60.371094,27.070313 59.960938,26.734375 59.484375,26.734375 Z M6.546875,26.734375 C6.058594,26.722656 5.636719,27.058594 5.539063,27.535156 C5.488281,27.796875 5.539063,28.070313 5.6875,28.289063 C5.835938,28.511719 6.066406,28.664063 6.328125,28.714844 C6.585938,28.765625 6.855469,28.710938 7.078125,28.566406 C7.296875,28.417969 7.449219,28.1875 7.5,27.925781 C7.609375,27.386719 7.257813,26.859375 6.71875,26.75 C6.660156,26.742188 6.605469,26.734375 6.546875,26.734375 Z M6,32 C5.449219,32 5,32.449219 5,33 C5,33.550781 5.449219,34 6,34 C6.550781,34 7,33.550781 7,33 C7,32.449219 6.550781,32 6,32 Z M60,32 C59.449219,32 59,32.449219 59,33 C59,33.550781 59.449219,34 60,34 C60.550781,34 61,33.550781 61,33 C61,32.449219 60.550781,32 60,32 Z M6.523438,37.265625 C6.457031,37.265625 6.390625,37.273438 6.324219,37.285156 C5.78125,37.394531 5.429688,37.921875 5.539063,38.464844 C5.648438,39.003906 6.171875,39.355469 6.714844,39.25 C7.257813,39.140625 7.609375,38.613281 7.5,38.074219 C7.40625,37.605469 7,37.269531 6.523438,37.265625 Z M59.507813,37.265625 C59.019531,37.253906 58.597656,37.59375 58.5,38.074219 C58.394531,38.613281 58.746094,39.140625 59.285156,39.25 C59.828125,39.355469 60.355469,39.003906 60.464844,38.464844 C60.570313,37.921875 60.21875,37.394531 59.675781,37.285156 C59.621094,37.277344 59.566406,37.269531 59.507813,37.265625 Z M33,41 C30.800781,41 29,42.800781 29,45 C29,47.199219 30.800781,49 33,49 C35.199219,49 37,47.199219 37,45 C37,42.800781 35.199219,41 33,41 Z M57.96875,42.328125 C57.554688,42.320313 57.179688,42.566406 57.019531,42.949219 C56.808594,43.457031 57.050781,44.042969 57.5625,44.253906 C58.074219,44.464844 58.65625,44.222656 58.871094,43.714844 C59.082031,43.203125 58.839844,42.617188 58.328125,42.40625 C58.214844,42.359375 58.089844,42.332031 57.96875,42.328125 Z M8.0625,42.332031 C7.929688,42.332031 7.796875,42.355469 7.671875,42.40625 C7.429688,42.507813 7.234375,42.703125 7.132813,42.949219 C7.03125,43.195313 7.03125,43.46875 7.128906,43.714844 C7.34375,44.226563 7.925781,44.46875 8.4375,44.253906 C8.683594,44.15625 8.878906,43.960938 8.980469,43.714844 C9.082031,43.46875 9.082031,43.195313 8.980469,42.949219 C8.828125,42.578125 8.464844,42.335938 8.0625,42.332031 Z M33,43 C34.117188,43 35,43.882813 35,45 C35,46.117188 34.117188,47 33,47 C31.882813,47 31,46.117188 31,45 C31,43.882813 31.882813,43 33,43 Z M55.46875,47 C55.128906,46.992188 54.808594,47.160156 54.621094,47.441406 C54.3125,47.902344 54.4375,48.519531 54.894531,48.828125 C55.113281,48.976563 55.386719,49.03125 55.644531,48.976563 C55.90625,48.925781 56.136719,48.773438 56.28125,48.550781 C56.589844,48.09375 56.464844,47.472656 56.003906,47.167969 C55.847656,47.058594 55.660156,47 55.46875,47 Z M10.5625,47 C10.359375,46.996094 10.164063,47.054688 9.996094,47.167969 C9.539063,47.476563 9.414063,48.09375 9.71875,48.554688 C10.027344,49.011719 10.648438,49.136719 11.109375,48.828125 C11.566406,48.523438 11.691406,47.902344 11.382813,47.441406 C11.199219,47.167969 10.890625,47.003906 10.5625,47 Z M13.921875,51.09375 C13.652344,51.089844 13.390625,51.195313 13.203125,51.386719 C12.8125,51.773438 12.8125,52.410156 13.203125,52.796875 C13.589844,53.1875 14.226563,53.1875 14.613281,52.796875 C15.003906,52.410156 15.003906,51.773438 14.613281,51.386719 C14.429688,51.199219 14.183594,51.09375 13.921875,51.09375 Z M52.105469,51.09375 C51.835938,51.089844 51.574219,51.195313 51.386719,51.386719 C50.996094,51.773438 50.996094,52.410156 51.386719,52.796875 C51.773438,53.1875 52.410156,53.1875 52.796875,52.796875 C53.1875,52.410156 53.1875,51.773438 52.796875,51.386719 C52.613281,51.199219 52.367188,51.09375 52.105469,51.09375 Z M18.019531,54.449219 C17.679688,54.441406 17.359375,54.609375 17.171875,54.890625 C16.863281,55.351563 16.988281,55.972656 17.449219,56.28125 C17.90625,56.585938 18.527344,56.460938 18.832031,56.003906 C19.140625,55.542969 19.015625,54.925781 18.558594,54.617188 C18.398438,54.511719 18.210938,54.449219 18.019531,54.449219 Z M48.011719,54.449219 C47.808594,54.445313 47.613281,54.503906 47.445313,54.613281 C47.222656,54.761719 47.070313,54.992188 47.019531,55.253906 C46.96875,55.511719 47.023438,55.785156 47.171875,56.003906 C47.476563,56.460938 48.097656,56.585938 48.558594,56.28125 C49.015625,55.972656 49.140625,55.351563 48.832031,54.890625 C48.652344,54.617188 48.34375,54.449219 48.011719,54.449219 Z M22.691406,56.941406 C22.277344,56.933594 21.902344,57.179688 21.746094,57.5625 C21.535156,58.070313 21.777344,58.65625 22.285156,58.867188 C22.796875,59.078125 23.382813,58.835938 23.59375,58.328125 C23.804688,57.816406 23.5625,57.230469 23.050781,57.019531 C22.9375,56.972656 22.816406,56.945313 22.691406,56.941406 Z M43.339844,56.941406 C43.207031,56.941406 43.074219,56.96875 42.953125,57.019531 C42.707031,57.121094 42.511719,57.316406 42.410156,57.558594 C42.308594,57.804688 42.308594,58.082031 42.40625,58.328125 C42.621094,58.835938 43.203125,59.078125 43.714844,58.867188 C43.960938,58.765625 44.15625,58.570313 44.257813,58.328125 C44.359375,58.082031 44.359375,57.804688 44.257813,57.5625 C44.105469,57.1875 43.742188,56.945313 43.339844,56.941406 Z M27.761719,58.480469 C27.273438,58.46875 26.847656,58.808594 26.753906,59.285156 C26.644531,59.828125 26.996094,60.351563 27.539063,60.460938 C28.082031,60.570313 28.605469,60.21875 28.714844,59.675781 C28.824219,59.132813 28.472656,58.609375 27.929688,58.5 C27.875,58.488281 27.816406,58.480469 27.761719,58.480469 Z M38.269531,58.484375 C38.203125,58.480469 38.136719,58.488281 38.074219,58.5 C37.53125,58.609375 37.179688,59.132813 37.285156,59.675781 C37.339844,59.9375 37.492188,60.164063 37.710938,60.3125 C37.933594,60.460938 38.203125,60.515625 38.464844,60.464844 C38.722656,60.410156 38.953125,60.257813 39.101563,60.039063 C39.246094,59.816406 39.300781,59.546875 39.25,59.285156 C39.15625,58.820313 38.746094,58.484375 38.269531,58.484375 Z M33,59 C32.449219,59 32,59.449219 32,60 C32,60.550781 32.449219,61 33,61 C33.550781,61 34,60.550781 34,60 C34,59.449219 33.550781,59 33,59 Z', id: 'Shape' }))))))));
};
var Icon8CheckMask = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'REFERRALS-A', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'REFERRAL/REF-DIALOG-CREATE-COPYLINK-SUCESSFUL', transform: 'translate(-321.000000, -356.000000)', fill: '#6FB920' },
                react.createElement("g", { id: 'Group-19', transform: 'translate(300.000000, 209.000000)' },
                    react.createElement("g", { id: 'Group-34', transform: 'translate(21.000000, 146.000000)' },
                        react.createElement("g", { id: 'icons/icon-check-circle', transform: 'translate(0.000000, 1.000000)' },
                            react.createElement("path", { d: '', id: 'Combined-Shape', stroke: '#6FB920' }),
                            react.createElement("g", { id: 'icons8-checkmark-(3)', transform: 'translate(5.000000, 5.000000)', fillRule: 'nonzero' },
                                react.createElement("path", { d: 'M8.0797067,0.000533951216 C7.9309277,0.00630469882 7.79440098,0.0928639431 7.71563546,0.231358931 L3.50081074,7.31768581 L0.770276453,4.72475187 C0.653003618,4.59106568 0.47709403,4.5410536 0.315187406,4.59683642 C0.154155896,4.65165729 0.0342574918,4.80169353 0.00625201191,4.9844301 C-0.0217534679,5.16812812 0.0456346619,5.35278811 0.182161376,5.46339181 L3.30477238,8.43333988 C3.40279156,8.52470816 3.5323169,8.56510241 3.65921668,8.54490529 C3.78699179,8.52374645 3.89988883,8.44391942 3.96990253,8.32562156 L8.47178341,0.769950551 C8.56805236,0.615105521 8.57592885,0.415057206 8.49278752,0.251556055 C8.4096462,0.0890168601 8.24949003,-0.00812192397 8.0797067,0.000533951216 Z', id: 'Path' })))))))));
};
var Icon8Camera = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 19 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 19', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'REFERRALS-A', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', opacity: '0.5' },
            react.createElement("g", { id: 'REFERRAL/REF-DIALOG-ADDNEW', transform: 'translate(-348.000000, -157.000000)', fill: '#FFFFFF', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-19', transform: 'translate(300.000000, 55.000000)' },
                    react.createElement("g", { id: 'Group-41', transform: 'translate(16.000000, 67.000000)' },
                        react.createElement("g", { id: 'icons8-camera', transform: 'translate(32.000000, 35.000000)' },
                            react.createElement("path", { d: 'M9.2475,0 C8.40524256,0 7.62226848,0.446025534 7.18874976,1.1738496 L6.44812512,2.41758242 L2.79281251,2.41758242 C1.25666549,2.41758242 0,3.6834542 0,5.2308549 L0,16.0448147 C0,17.5918305 1.25666549,18.8571429 2.79281251,18.8571429 L21.2081251,18.8571429 C22.7438899,18.8571429 24,17.5912711 24,16.0438704 L24,5.2308549 C24,3.6834542 22.7433346,2.41758242 21.2071877,2.41758242 L17.5518749,2.41758242 L16.8093749,1.17101648 C16.3769266,0.445391305 15.5966102,0 14.7562502,0 L9.2475,0 Z M9.2475,0.967032967 L14.7562502,0.967032967 C15.2608493,0.967032967 15.7265381,1.23291709 15.9862502,1.6686985 L17.0081251,3.38461538 L21.2071877,3.38461538 C22.2236803,3.38461538 23.04,4.20691543 23.04,5.2308549 L23.04,16.0438704 C23.04,17.0678098 22.2240403,17.8901099 21.2081251,17.8901099 L2.79281251,17.8901099 C1.77631949,17.8901099 0.96,17.0681725 0.96,16.0448147 L0.96,5.2308549 C0.96,4.20691543 1.77631949,3.38461538 2.79281251,3.38461538 L6.99187488,3.38461538 L7.13156256,3.14946773 L8.01187488,1.67153157 C8.27243664,1.23408096 8.74095744,0.967032967 9.2475,0.967032967 Z M12,4.35164835 C8.55942672,4.35164835 5.76,7.17158611 5.76,10.6373626 C5.76,14.1031392 8.55942672,16.9230769 12,16.9230769 C15.4405733,16.9230769 18.24,14.1031392 18.24,10.6373626 C18.24,7.17158611 15.4405733,4.35164835 12,4.35164835 Z M12,5.31868132 C14.9217514,5.31868132 17.28,7.69420844 17.28,10.6373626 C17.28,13.5805168 14.9217514,15.956044 12,15.956044 C9.07824864,15.956044 6.72,13.5805168 6.72,10.6373626 C6.72,7.69420844 9.07824864,5.31868132 12,5.31868132 Z M12,6.52747253 C9.75236256,6.52747253 7.92,8.37326044 7.92,10.6373626 C7.92,12.9014648 9.75236256,14.7472527 12,14.7472527 C14.2476374,14.7472527 16.08,12.9014648 16.08,10.6373626 C16.08,8.37326044 14.2476374,6.52747253 12,6.52747253 Z M12,7.49450549 C13.7288155,7.49450549 15.12,8.89588325 15.12,10.6373626 C15.12,12.378842 13.7288155,13.7802198 12,13.7802198 C10.2711845,13.7802198 8.88,12.378842 8.88,10.6373626 C8.88,8.89588325 10.2711845,7.49450549 12,7.49450549 Z', id: 'Shape' }))))))));
};
var Icon8CameraResponsive = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 20 16', version: '1.1' },
        react.createElement("g", { id: 'RESPONSIVE', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/RES/REF/REF-MANAGECAN-ADD', transform: 'translate(-178.000000, -150.000000)', fill: '#555555', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-10', transform: 'translate(150.000000, 120.000000)' },
                    react.createElement("g", { id: 'Group-7', transform: 'translate(26.000000, 26.000000)' },
                        react.createElement("g", { id: 'icons8-camera-(1)', transform: 'translate(2.250000, 4.500000)' },
                            react.createElement("path", { d: 'M7.40985577,0 C6.73497,0 6.10758692,0.354793038 5.76021615,0.933744 L5.16676692,1.92307692 L2.23783054,1.92307692 C1.0069435,1.92307692 0,2.93002038 0,4.16090731 L0,12.7629208 C0,13.9935015 1.0069435,15 2.23783054,15 L16.99369,15 C18.2242708,15 19.2307692,13.9930565 19.2307692,12.7621696 L19.2307692,4.16090731 C19.2307692,2.93002038 18.2238258,1.92307692 16.9929388,1.92307692 L14.0640023,1.92307692 L13.4690504,0.931490385 C13.1225373,0.354288538 12.4972838,0 11.8239185,0 L7.40985577,0 Z M9.61538462,3.46153846 C12.3723077,3.46153846 14.6153846,5.70461538 14.6153846,8.46153846 C14.6153846,11.2184615 12.3723077,13.4615385 9.61538462,13.4615385 C6.85846154,13.4615385 4.61538462,11.2184615 4.61538462,8.46153846 C4.61538462,5.70461538 6.85846154,3.46153846 9.61538462,3.46153846 Z M9.61538462,4.23076923 C7.28269231,4.23076923 5.38461538,6.12884615 5.38461538,8.46153846 C5.38461538,10.7942308 7.28269231,12.6923077 9.61538462,12.6923077 C11.9480769,12.6923077 13.8461538,10.7942308 13.8461538,8.46153846 C13.8461538,6.12884615 11.9480769,4.23076923 9.61538462,4.23076923 Z M9.61538462,5.19230769 C11.4180769,5.19230769 12.8846154,6.65884615 12.8846154,8.46153846 C12.8846154,10.2642308 11.4180769,11.7307692 9.61538462,11.7307692 C7.81269231,11.7307692 6.34615385,10.2642308 6.34615385,8.46153846 C6.34615385,6.65884615 7.81269231,5.19230769 9.61538462,5.19230769 Z M9.61538462,5.96153846 C8.23467274,5.96153846 7.11538462,7.08082659 7.11538462,8.46153846 C7.11538462,9.84225034 8.23467274,10.9615385 9.61538462,10.9615385 C10.9960965,10.9615385 12.1153846,9.84225032 12.1153846,8.46153846 C12.1153846,7.08082661 10.9960965,5.96153846 9.61538462,5.96153846 L9.61538462,5.96153846 Z', id: 'Shape' }))))))));
};
var Icons = {
    Icon8Checked: Icon8Checked,
    Icon8Important: Icon8Important,
    Icon8CheckMask: Icon8CheckMask,
    Icon8Camera: Icon8Camera,
    Icon8CameraResponsive: Icon8CameraResponsive
};


//# sourceMappingURL=images.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/reducer.js
var reducer = __webpack_require__(38756);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/index.js
var context = __webpack_require__(28704);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/SearchBar.css.js
'use client';





var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(SearchBar_css_templateObject_1 || (SearchBar_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(SearchBar_css_templateObject_2 || (SearchBar_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var SearchBarWrapper = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_8 || (SearchBar_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    z-index: 100;\n    width: 100%;\n    top: 0;\n    transition: all 0.25s ease-in-out;\n    ", "\n"], ["\n    ", "\n    z-index: 100;\n    width: 100%;\n    top: 0;\n    transition: all 0.25s ease-in-out;\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    if (isShow) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_3 || (SearchBar_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                position: absolute;\n            "], ["\n                position: absolute;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_4 || (SearchBar_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: ", ";\n        "], ["\n            position: ", ";\n        "])), function (_a) {
        var isMountedDropdown = _a.isMountedDropdown;
        return (isMountedDropdown ? 'absolute' : 'relative');
    });
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_7 || (SearchBar_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            right: 0;\n            ", "\n        "], ["\n            right: 0;\n            ", "\n        "])), function (_a) {
        var isShow = _a.isShow;
        if (isShow) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_5 || (SearchBar_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        position: fixed;\n                    "], ["\n                        position: fixed;\n                    "])));
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_6 || (SearchBar_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    position: ", ";\n                "], ["\n                    position: ", ";\n                "])), function (_a) {
            var isMountedDropdown = _a.isMountedDropdown;
            return (isMountedDropdown ? 'fixed' : 'relative');
        });
    });
});
var SearchBarContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_10 || (SearchBar_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: all 0.25s ease-in-out;\n    ", "\n"], ["\n    transition: all 0.25s ease-in-out;\n    ", "\n"])), function (_a) {
    var isHomepage = _a.isHomepage;
    if (isHomepage) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_9 || (SearchBar_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            @media (min-width: 767px) {\n                margin-right: 16px;\n            }\n        "], ["\n            @media (min-width: 767px) {\n                margin-right: 16px;\n            }\n        "])));
});
var SearchBlockHolder = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_13 || (SearchBar_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    height: 40px;\n"], ["\n    ", "\n    height: 40px;\n"])), function (_a) {
    var isMountedDropdown = _a.isMountedDropdown;
    if (isMountedDropdown) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_11 || (SearchBar_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: block;\n            "], ["\n                display: block;\n            "])));
    }
    else {
        return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_12 || (SearchBar_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: ", ";\n            "], ["\n                display: ", ";\n            "])), function (_a) {
            var isShow = _a.isShow;
            return (isShow ? 'block' : 'none');
        });
    }
});
var SearchBarBackground = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_14 || (SearchBar_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: 1;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    @supports (height: 100dvh) {\n        height: 100dvh;\n    }\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.6);\n    animation: ", " 0.25s ease-in-out forwards;\n"], ["\n    opacity: 1;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    @supports (height: 100dvh) {\n        height: 100dvh;\n    }\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.6);\n    animation: ", " 0.25s ease-in-out forwards;\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? fadeIn : fadeOut);
});
var SearchBarContent = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_18 || (SearchBar_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 95px;\n    display: block;\n    height: 100%;\n    position: relative;\n    z-index: 10;\n    max-width: 100%;\n    ", "\n    ", "\n"], ["\n    border-radius: 95px;\n    display: block;\n    height: 100%;\n    position: relative;\n    z-index: 10;\n    max-width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    if (isShow) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_15 || (SearchBar_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                width: 100%;\n            "], ["\n                width: 100%;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_16 || (SearchBar_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: ", ";\n        "], ["\n            width: ", ";\n        "])), function (_a) {
        var initialWidth = _a.initialWidth;
        if (initialWidth > -1) {
            return "".concat(initialWidth, "px");
        }
        else if (initialWidth === -2) {
            return "calc(100% - 32px)";
        }
        else {
            return '100%';
        }
    });
}, function (_a) {
    var isMounted = _a.isMounted;
    if (!isMounted) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_17 || (SearchBar_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            transition: all 0.5s cubic-bezier(0.8, -0.1, 0.1, 1.2);\n        "], ["\n            transition: all 0.5s cubic-bezier(0.8, -0.1, 0.1, 1.2);\n        "])));
});
styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_19 || (SearchBar_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var DropDownContentOverflow = styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_21 || (SearchBar_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n    overflow: hidden;\n    border-radius: 24px;\n    margin-top: 8px;\n    ", "\n"], ["\n    display: ", ";\n    overflow: hidden;\n    border-radius: 24px;\n    margin-top: 8px;\n    ", "\n"])), function (_a) {
    var isHidden = _a.isHidden;
    return (!isHidden ? 'block' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchBar_css_templateObject_20 || (SearchBar_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: fixed;\n            z-index: 11;\n            left: 0;\n            top: 16px;\n            margin-top: 58px;\n            margin-left: 8px;\n            margin-right: 8px;\n            border-radius: 12px;\n        "], ["\n            position: fixed;\n            z-index: 11;\n            left: 0;\n            top: 16px;\n            margin-top: 58px;\n            margin-left: 8px;\n            margin-right: 8px;\n            border-radius: 12px;\n        "])));
});
styled_components_browser_esm/* default.div */.ZP.div(SearchBar_css_templateObject_22 || (SearchBar_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50px;\n    height: 50px;\n    border-radius: 48px;\n    background-color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"], ["\n    width: 50px;\n    height: 50px;\n    border-radius: 48px;\n    background-color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])), Colors/* colors.primary.40 */.O9.primary[40]);
var SearchBar_css_templateObject_1, SearchBar_css_templateObject_2, SearchBar_css_templateObject_3, SearchBar_css_templateObject_4, SearchBar_css_templateObject_5, SearchBar_css_templateObject_6, SearchBar_css_templateObject_7, SearchBar_css_templateObject_8, SearchBar_css_templateObject_9, SearchBar_css_templateObject_10, SearchBar_css_templateObject_11, SearchBar_css_templateObject_12, SearchBar_css_templateObject_13, SearchBar_css_templateObject_14, SearchBar_css_templateObject_15, SearchBar_css_templateObject_16, SearchBar_css_templateObject_17, SearchBar_css_templateObject_18, SearchBar_css_templateObject_19, SearchBar_css_templateObject_20, SearchBar_css_templateObject_21, SearchBar_css_templateObject_22;


//# sourceMappingURL=SearchBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/translation.js
'use client';

var SearchBarUnstable_translation_translations = {
    Search: 'Tìm kiếm',
    'Find your dream jobs': 'Tìm kiếm công việc mơ ước',
    'All Locations': 'Tất cả địa điểm',
    'All locations': 'Tất cả địa điểm',
    'All Province/City': 'Tất cả tỉnh/thành phố',
    'Select Province/City': 'Chọn tỉnh/thành phố',
    'You have selected up to three Province/City': 'Bạn đã chọn tối đa ba tỉnh/thành phố',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba địa điểm',
    All: 'Tất cả',
    Location: 'Địa điểm',
    Locations: 'Địa điểm',
    Apply: 'Áp dụng',
    Cancel: 'Huỷ',
    'Selected Locations': 'Địa điểm đã chọn',
    'No Result': 'Không có kết quả',
    'Search for jobs, companies, skills': 'Tìm kiếm việc làm, công ty, kỹ năng',
    'Try Searching For': 'Có Phải Bạn Đang Tìm',
    'Hot Keywords': 'Từ Khoá Phổ Biến',
    'No suggestions for': 'Không có gợi ý cho',
    'Jobs you will love': 'Việc làm bạn sẽ thích',
    Profile: 'Hồ sơ',
    Salary: 'Mức lương',
    Interview: 'Phỏng vấn',
    jobs: 'việc làm',
    job: 'việc làm',
    Job: 'Việc làm',
    Discovery: 'Khám phá',
    Company: 'Công ty',
    'Clear all': 'Xoá hết',
    'Wow CV': 'Wow CV',
    'Recent searchs': 'Tìm kiếm gần đây',
    'Prepare your interview': 'Chuẩn bị cho buổi phỏng vấn',
    'Update your resume': '	Cập nhật hồ sơ của bạn',
    'Impress recruiter': 'Gây ấn tượng với nhà tuyển dụng',
    'Know your worth': 'Tìm hiểu mức lương phù hợp',
    '/job-search/all-jobs': '/tim-viec-lam/tim-tat-ca-viec-lam',
    'You have no keyword search': 'Bạn không có tìm kiếm từ khoá nào',
    'No recent searches': 'Không có tìm kiếm gần đây',
    'Your search will be listed here in the future': 'Lịch sử từ khoá tìm kiếm của bạn sẽ được hiển thị ở đây',
    'Double check your keywords or try another search term.': 'Kiểm tra lại từ khóa hoặc thử một cụm từ tìm kiếm khác.',
    'Enter a job title to view a set of interview questions': 'Nhập chức danh để xem bộ câu hỏi phỏng vấn',
    'Enter a job title to view salary': 'Nhập chức danh để xem mức lương',
    'https://www.vietnamworks.com/my-career-center/dashboard': 'https://www.vietnamworks.com/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-career-center/dashboard': '/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-profile': '/ho-so',
    'All Districts': 'Tất cả Quận/Huyện',
    "There are no suitable job recommendations for you on VietnamWorks at the moment. We'll notify you as soon as new opportunities come up!": 'Hiện tại, chưa có gợi ý công việc phù hợp với bạn trên VietnamWorks. Chúng tôi sẽ thông báo ngay khi có cơ hội mới!'
};


//# sourceMappingURL=translation.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/actions.js
var actions = __webpack_require__(1437);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/types.js
var context_types = __webpack_require__(52077);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchBarBackground/index.js
'use client';







var SearchBackground = function () {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _a.state, dispatch = _a.dispatch;
    var isBlurBackground = state.isBlurBackground, isShow = state.isShow;
    var _b = (0,react.useState)(false), isMounted = _b[0], setMounted = _b[1];
    var onAnimationEnd = function () {
        if (isBlurBackground) {
            return;
        }
        setMounted(false);
    };
    (0,react.useEffect)(function () {
        if (!isBlurBackground) {
            return;
        }
        setMounted(true);
    }, [isBlurBackground]);
    return isMounted ? (react.createElement(SearchBarBackground, { "data-cname": 'SearchBackground', isShow: isBlurBackground, onClick: function () {
            if (isShow) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: context_types/* EForceControDropdown.CLOSE_ALL */.q.CLOSE_ALL
                });
            }
        }, onAnimationEnd: onAnimationEnd })) : (react.createElement(react.Fragment, null));
};
var SearchBackground$1 = react.memo(SearchBackground);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchSection/SearchSection.css.js
'use client';





var effectFadeUp = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_1 || (SearchSection_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var effectFadeDown = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_2 || (SearchSection_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));
var extendFromRight = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_3 || (SearchSection_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    translate: calc(100% - 40px) 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 40px;\n    opacity: 0;\n  }\n  100% {\n    translate: 0% 0;\n    width: 100%;\n    opacity: 1;\n  }\n"], ["\n  0% {\n    translate: calc(100% - 40px) 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 40px;\n    opacity: 0;\n  }\n  100% {\n    translate: 0% 0;\n    width: 100%;\n    opacity: 1;\n  }\n"])));
var collapseToRight = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_4 || (SearchSection_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    translate: 0% 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 100%;\n    opacity: 1;\n  }\n  100% {\n    translate: calc(100% - 40px) 0;\n    width: 40px;\n    opacity: 0;\n  }\n"], ["\n  0% {\n    translate: 0% 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 100%;\n    opacity: 1;\n  }\n  100% {\n    translate: calc(100% - 40px) 0;\n    width: 40px;\n    opacity: 0;\n  }\n"])));
(0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_5 || (SearchSection_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n        translate: 0% 0;\n    }\n    100% {\n        opacity: 1;\n        translate: 0% 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n        translate: 0% 0;\n    }\n    100% {\n        opacity: 1;\n        translate: 0% 0;\n    }\n"])));
var CustomTreeSelect = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_7 || (SearchSection_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    div[data-id='tree-select'] {\n        div.tree-select-input {\n            height: 32px;\n        }\n        ", ";\n    }\n    @media screen and (max-width: 767px) {\n        div[data-id='tree-select'] {\n            div.tree-select-input {\n                height: 40px;\n            }\n        }\n        display: none;\n    }\n"], ["\n    div[data-id='tree-select'] {\n        div.tree-select-input {\n            height: 32px;\n        }\n        ", ";\n    }\n    @media screen and (max-width: 767px) {\n        div[data-id='tree-select'] {\n            div.tree-select-input {\n                height: 40px;\n            }\n        }\n        display: none;\n    }\n"])), function (_a) {
    var isShow = _a.isShow, isHomePage = _a.isHomePage;
    if (isHomePage) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_6 || (SearchSection_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                @media screen and (max-width: 1023px) {\n                    display: ", ";\n                }\n            "], ["\n                @media screen and (max-width: 1023px) {\n                    display: ", ";\n                }\n            "])), isShow ? 'block' : 'none');
});
var ActionGroup = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_8 || (SearchSection_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n    width: auto;\n    align-items: center;\n    > button {\n        width: 100%;\n        height: 32px;\n        border-radius: 48px;\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        .search {\n            &__button {\n                display: ", ";\n            }\n        }\n    }\n    @media screen and (max-width: 767px) {\n        > button {\n            height: 40px;\n        }\n        .search {\n            &__button {\n                display: none;\n            }\n        }\n    }\n"], ["\n    display: ", ";\n    width: auto;\n    align-items: center;\n    > button {\n        width: 100%;\n        height: 32px;\n        border-radius: 48px;\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        .search {\n            &__button {\n                display: ", ";\n            }\n        }\n    }\n    @media screen and (max-width: 767px) {\n        > button {\n            height: 40px;\n        }\n        .search {\n            &__button {\n                display: none;\n            }\n        }\n    }\n"])), function (_a) {
    var isShow = _a.isShow, isMobile = _a.isMobile;
    if (isMobile)
        return 'none';
    return isShow ? 'flex' : 'none';
}, effectFadeUp, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 'block' : 'none');
});
var InputGroup = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_11 || (SearchSection_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 100%;\n    /* max-width: 1200px; */\n    input.class-input-recommend {\n        border: none;\n        border-radius: 32px;\n        background-color: transparent !important;\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n    svg.remove-icon {\n        top: 7px !important;\n    }\n    ", "\n"], ["\n    display: flex;\n    width: 100%;\n    /* max-width: 1200px; */\n    input.class-input-recommend {\n        border: none;\n        border-radius: 32px;\n        background-color: transparent !important;\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n    svg.remove-icon {\n        top: 7px !important;\n    }\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_9 || (SearchSection_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                input.class-input-recommend {\n                    height: 32px;\n                    border-radius: 32px;\n                    background-color: transparent !important;\n                    color: #fff;\n                    -webkit-text-fill-color: #fff;\n                }\n            "], ["\n                input.class-input-recommend {\n                    height: 32px;\n                    border-radius: 32px;\n                    background-color: transparent !important;\n                    color: #fff;\n                    -webkit-text-fill-color: #fff;\n                }\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_10 || (SearchSection_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-radius: 32px;\n            svg.remove-icon {\n                top: 8px !important;\n            }\n            input.class-input-recommend {\n                /* opacity: ", "; */\n                height: 40px;\n                color: #333;\n                -webkit-text-fill-color: #333;\n            }\n        "], ["\n            border-radius: 32px;\n            svg.remove-icon {\n                top: 8px !important;\n            }\n            input.class-input-recommend {\n                /* opacity: ", "; */\n                height: 40px;\n                color: #333;\n                -webkit-text-fill-color: #333;\n            }\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? '1' : '0');
    });
});
var SearchSectionWrapper = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_25 || (SearchSection_css_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border-radius: 32px;\n    padding: ", ";\n    background-color: ", ";\n    input.class-input-recommend {\n        color: ", " !important;\n        -webkit-text-fill-color: ", " !important;\n    }\n    .sb-searchIcon {\n        svg {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    ", "\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        ", " {\n            order: 2;\n            flex-basis: 80%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n        ", " {\n            flex: 1;\n        }\n    }\n    @media screen and (max-width: 425px) {\n        ", " {\n            flex-basis: 70%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border-radius: 32px;\n    padding: ", ";\n    background-color: ", ";\n    input.class-input-recommend {\n        color: ", " !important;\n        -webkit-text-fill-color: ", " !important;\n    }\n    .sb-searchIcon {\n        svg {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    ", "\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        ", " {\n            order: 2;\n            flex-basis: 80%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n        ", " {\n            flex: 1;\n        }\n    }\n    @media screen and (max-width: 425px) {\n        ", " {\n            flex-basis: 70%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 0 : '4px');
}, Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.20 */.O9.grey[20], function (_a) {
    var isMobile = _a.isMobile, isShow = _a.isShow;
    if (!isMobile) {
        return isShow
            ? (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_12 || (SearchSection_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      input.class-input-recommend {\n                          color: ", " !important;\n                          -webkit-text-fill-color: ", " !important;\n                      }\n                      &:hover {\n                          .sb-searchIcon {\n                              svg {\n                                  path {\n                                      fill: ", " !important;\n                                  }\n                              }\n                          }\n                          input.class-input-recommend {\n                              &::placeholder {\n                                  color: ", " !important;\n                                  -webkit-text-fill-color: ", " !important;\n                              }\n                          }\n                      }\n                  "], ["\n                      input.class-input-recommend {\n                          color: ", " !important;\n                          -webkit-text-fill-color: ", " !important;\n                      }\n                      &:hover {\n                          .sb-searchIcon {\n                              svg {\n                                  path {\n                                      fill: ", " !important;\n                                  }\n                              }\n                          }\n                          input.class-input-recommend {\n                              &::placeholder {\n                                  color: ", " !important;\n                                  -webkit-text-fill-color: ", " !important;\n                              }\n                          }\n                      }\n                  "])), Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.50 */.O9.neutral[50], Colors/* colors.neutral.50 */.O9.neutral[50]) : '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_24 || (SearchSection_css_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: fixed;\n            right: 0;\n            width: 100%;\n            max-width: calc(100% - 16px);\n            margin-left: 8px;\n            margin-right: 8px;\n            ", "\n            animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n            min-width: 40px;\n            border: none;\n            ", ";\n            ", "\n            /*  for page-container */\n            ", "\n        "], ["\n            position: fixed;\n            right: 0;\n            width: 100%;\n            max-width: calc(100% - 16px);\n            margin-left: 8px;\n            margin-right: 8px;\n            ", "\n            animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n            min-width: 40px;\n            border: none;\n            ", ";\n            ", "\n            /*  for page-container */\n            ", "\n        "])), function (_a) {
        var pageName = _a.pageName, isSupportAnim = _a.isSupportAnim;
        if (!isSupportAnim) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_13 || (SearchSection_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        animation: none !important;\n                        opacity: ", ";\n                    "], ["\n                        animation: none !important;\n                        opacity: ", ";\n                    "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? 1 : 0);
            });
        }
        if (pageName === 'searchResult') {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_14 || (SearchSection_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        animation: ", " 0.5s forwards;\n                    "], ["\n                        animation: ", " 0.5s forwards;\n                    "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? effectFadeUp : effectFadeDown);
            });
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_15 || (SearchSection_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    animation: ", " 0.5s forwards;\n                "], ["\n                    animation: ", " 0.5s forwards;\n                "])), function (_a) {
            var isShow = _a.isShow;
            return (isShow ? extendFromRight : collapseToRight);
        });
    }, function (_a) {
        var isMountedDropdown = _a.isMountedDropdown;
        if (!isMountedDropdown) {
            return '';
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_16 || (SearchSection_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    top: 16px;\n                "], ["\n                    top: 16px;\n                "])));
    }, function (_a) {
        var isShow = _a.isShow, isMountedDropdown = _a.isMountedDropdown;
        if (!isShow && !isMountedDropdown) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_17 || (SearchSection_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        position: relative;\n                        height: 40px;\n                        width: 40px;\n                        max-width: 40px;\n                        margin: 0;\n                        opacity: 1 !important;\n                        translate: 0% 0 !important;\n                    "], ["\n                        position: relative;\n                        height: 40px;\n                        width: 40px;\n                        max-width: 40px;\n                        margin: 0;\n                        opacity: 1 !important;\n                        translate: 0% 0 !important;\n                    "])));
        }
        if (isMountedDropdown) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_18 || (SearchSection_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        background-color: transparent;\n                        > div:first-child {\n                            background-color: ", ";\n                        }\n                    "], ["\n                        background-color: transparent;\n                        > div:first-child {\n                            background-color: ", ";\n                        }\n                    "])), Colors/* colors.neutral.95 */.O9.neutral[95]);
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_19 || (SearchSection_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }, function (_a) {
        var pageName = _a.pageName;
        if (pageName !== 'searchResult') {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_20 || (SearchSection_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        background-color: ", ";\n                        > div > div > svg {\n                            path {\n                                fill: ", " !important;\n                            }\n                        }\n                    "], ["\n                        background-color: ", ";\n                        > div > div > svg {\n                            path {\n                                fill: ", " !important;\n                            }\n                        }\n                    "])), function (_a) {
                var isMountedDropdown = _a.isMountedDropdown;
                return isMountedDropdown ? 'transparent' : Colors/* colors.primary.40 */.O9.primary[40];
            }, function (_a) {
                var isMountedDropdown = _a.isMountedDropdown;
                return isMountedDropdown ? Colors/* colors.primary.20 */.O9.primary[20] : '#fff';
            });
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_23 || (SearchSection_css_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    left: 0;\n                    width: auto;\n                    max-width: 100%;\n                    ", "\n                    input.class-input-recommend {\n                        opacity: 1 !important;\n                        height: 42px !important;\n                        color: #333 !important;\n                        -webkit-text-fill-color: #333 !important;\n                    }\n                "], ["\n                    left: 0;\n                    width: auto;\n                    max-width: 100%;\n                    ", "\n                    input.class-input-recommend {\n                        opacity: 1 !important;\n                        height: 42px !important;\n                        color: #333 !important;\n                        -webkit-text-fill-color: #333 !important;\n                    }\n                "])), function (_a) {
            var isMountedDropdown = _a.isMountedDropdown;
            if (!isMountedDropdown) {
                return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_21 || (SearchSection_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                background-color: #fff;\n                            "], ["\n                                background-color: #fff;\n                            "])));
            }
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_22 || (SearchSection_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
        });
    });
}, CustomTreeSelect, InputGroup, function (_a) {
    var isShow = _a.isShow;
    return (!isShow ? '100%' : '80%');
}, ActionGroup, CustomTreeSelect, InputGroup, function (_a) {
    var isShow = _a.isShow;
    return (!isShow ? '100%' : '70%');
});
var SearchSection_css_Icon = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_32 || (SearchSection_css_templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: ", "px;\n\n    justify-content: center;\n    align-items: center;\n    ", "\n    ", "\n    @media screen and (max-width: 1023px) {\n        display: inline-flex !important;\n    }\n"], ["\n    padding-left: ", "px;\n\n    justify-content: center;\n    align-items: center;\n    ", "\n    ", "\n    @media screen and (max-width: 1023px) {\n        display: inline-flex !important;\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 8 : 12);
}, function (_a) {
    var isHomePage = _a.isHomePage;
    if (isHomePage) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_26 || (SearchSection_css_templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: inline-flex;\n            "], ["\n                display: inline-flex;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_27 || (SearchSection_css_templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            display: none;\n        "], ["\n            display: none;\n        "])));
}, function (_a) {
    var isHaveKeyword = _a.isHaveKeyword;
    if (!isHaveKeyword) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_31 || (SearchSection_css_templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            svg {\n                path {\n                    ", "\n                }\n            }\n        "], ["\n            svg {\n                path {\n                    ", "\n                }\n            }\n        "])), function (_a) {
        var pageName = _a.pageName, isMobile = _a.isMobile;
        if (pageName === 'searchResult') {
            if (isMobile) {
                return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_28 || (SearchSection_css_templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    fill: ", ";\n                                "], ["\n                                    fill: ", ";\n                                "])), Colors/* colors.grey.20 */.O9.grey[20]);
            }
            else {
                return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_29 || (SearchSection_css_templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    fill: ", ";\n                                "], ["\n                                    fill: ", ";\n                                "])), function (_a) {
                    var isShow = _a.isShow;
                    return (isShow ? Colors/* colors.grey.20 */.O9.grey[20] : Colors/* colors.grey.100 */.O9.grey[100]);
                });
            }
        }
        else {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_30 || (SearchSection_css_templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                fill: ", ";\n                            "], ["\n                                fill: ", ";\n                            "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? Colors/* colors.grey.20 */.O9.grey[20] : Colors/* colors.grey.100 */.O9.grey[100]);
            });
        }
    });
});
var InputContent = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_33 || (SearchSection_css_templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 100%;\n    > div {\n        width: 100%;\n    }\n    input {\n        border: none !important;\n        font-size: 15px;\n        &:focus {\n            border: none !important;\n        }\n    }\n"], ["\n    display: flex;\n    width: 100%;\n    > div {\n        width: 100%;\n    }\n    input {\n        border: none !important;\n        font-size: 15px;\n        &:focus {\n            border: none !important;\n        }\n    }\n"])));
styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_34 || (SearchSection_css_templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-left: 1px solid transparent;\n    width: 1px;\n    height: 24px;\n    margin: auto 10px auto auto;\n    pointer-events: none;\n"], ["\n    border-left: 1px solid transparent;\n    width: 1px;\n    height: 24px;\n    margin: auto 10px auto auto;\n    pointer-events: none;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_35 || (SearchSection_css_templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_36 || (SearchSection_css_templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex: 1;\n    padding: 0 4px 0 8px;\n    gap: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    flex: 1;\n    padding: 0 4px 0 8px;\n    gap: 4px;\n"])));
var SearchIconWrap = styled_components_browser_esm/* default.span */.ZP.span(SearchSection_css_templateObject_37 || (SearchSection_css_templateObject_37 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    display: ", ";\n    @media screen and (max-width: 1023px) {\n        display: none !important;\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    display: ", ";\n    @media screen and (max-width: 1023px) {\n        display: none !important;\n    }\n"])), function (_a) {
    var isHomepage = _a.isHomepage, isShow = _a.isShow;
    if (isHomepage || isShow) {
        return 'none';
    }
    return 'flex';
});
var TextButton = styled_components_browser_esm/* default.span */.ZP.span(SearchSection_css_templateObject_38 || (SearchSection_css_templateObject_38 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n"], ["\n    display: ", ";\n"])), function (_a) {
    var isHomepage = _a.isHomepage, isShow = _a.isShow;
    if (isHomepage || isShow) {
        return 'block';
    }
    return 'none';
});
var SearchSection_css_templateObject_1, SearchSection_css_templateObject_2, SearchSection_css_templateObject_3, SearchSection_css_templateObject_4, SearchSection_css_templateObject_5, SearchSection_css_templateObject_6, SearchSection_css_templateObject_7, SearchSection_css_templateObject_8, SearchSection_css_templateObject_9, SearchSection_css_templateObject_10, SearchSection_css_templateObject_11, SearchSection_css_templateObject_12, SearchSection_css_templateObject_13, SearchSection_css_templateObject_14, SearchSection_css_templateObject_15, SearchSection_css_templateObject_16, SearchSection_css_templateObject_17, SearchSection_css_templateObject_18, SearchSection_css_templateObject_19, SearchSection_css_templateObject_20, SearchSection_css_templateObject_21, SearchSection_css_templateObject_22, SearchSection_css_templateObject_23, SearchSection_css_templateObject_24, SearchSection_css_templateObject_25, SearchSection_css_templateObject_26, SearchSection_css_templateObject_27, SearchSection_css_templateObject_28, SearchSection_css_templateObject_29, SearchSection_css_templateObject_30, SearchSection_css_templateObject_31, SearchSection_css_templateObject_32, SearchSection_css_templateObject_33, SearchSection_css_templateObject_34, SearchSection_css_templateObject_35, SearchSection_css_templateObject_36, SearchSection_css_templateObject_37, SearchSection_css_templateObject_38;


//# sourceMappingURL=SearchSection.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/apiServices.js
var SearchBarUnstable_apiServices = __webpack_require__(31627);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/searchbarHelpers.js + 1 modules
var searchbarHelpers = __webpack_require__(51727);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchInput/index.js
'use client';











var SearchInput = function () {
    var _a;
    var _b = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _b.state, dispatch = _b.dispatch, t = _b.t, props = _b.props, search = _b.search;
    var keyword = state.keyword, isShow = state.isShow, selectedSuggestionIndex = state.selectedSuggestionIndex, suggestions = state.suggestions;
    var pageName = props.pageName, msBaseUrl = props.msBaseUrl, searchBarOptions = props.searchBarOptions, isMobile = props.isMobile;
    var _c = (0,react.useState)(t('Search for jobs, companies, skills')), placeholderText = _c[0], setPlaceholderText = _c[1];
    var timer = (0,react.useRef)();
    var inputRef = (0,react.useRef)(null);
    var doGetSearchTopJob = function (locationList) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var filter, postData, searchTopJob, topJobItem;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (keyword.length === 0) {
                        return [2 /*return*/, false];
                    }
                    filter = [];
                    if (locationList.length > 0) {
                        filter.push({
                            field: 'workingLocations.cityId',
                            value: (_a = locationList === null || locationList === void 0 ? void 0 : locationList.map(function (item) { return item.parentId; })) === null || _a === void 0 ? void 0 : _a.join(',')
                        });
                    }
                    postData = {
                        query: keyword,
                        filter: filter,
                        ranges: [],
                        order: [],
                        hitsPerPage: 1,
                        page: 0,
                        retrieveFields: SearchBarUnstable_constants/* RETRIEVE_FIELDS_SEARCH */.YA
                    };
                    return [4 /*yield*/, (0,SearchBarUnstable_apiServices/* getSearchJob */.tC)(msBaseUrl, postData)];
                case 1:
                    searchTopJob = _c.sent();
                    topJobItem = null;
                    if (((_b = searchTopJob === null || searchTopJob === void 0 ? void 0 : searchTopJob.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && searchTopJob.data[0].priorityOrder !== '1970-01-01T07:00:00') {
                        topJobItem = searchTopJob.data[0];
                    }
                    if (topJobItem !== null) {
                        dispatch({
                            type: actions/* ACTIONS.SET_TOP_JOB_ITEM */.a.SET_TOP_JOB_ITEM,
                            payload: topJobItem
                        });
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var onInputChange = function (keyword) {
        var _a;
        dispatch({
            type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
            payload: keyword
        });
        dispatch({
            type: actions/* ACTIONS.SET_TOP_JOB_ITEM */.a.SET_TOP_JOB_ITEM,
            payload: null
        });
        if (keyword.length <= 0) {
            return;
        }
        var lastCharacterOfKeyword = keyword.substring(keyword.length - 1);
        if (lastCharacterOfKeyword !== ' ') {
            return;
        }
        var localParams = (0,searchbarHelpers/* getLocalStorage */.$o)('params', '');
        doGetSearchTopJob((_a = localParams === null || localParams === void 0 ? void 0 : localParams.locations) !== null && _a !== void 0 ? _a : []);
    };
    var onInputKeydown = function (e) {
        var _a, _b;
        switch (e.key) {
            case SearchBarUnstable_constants/* KEYCODE.ENTER */.Ps.ENTER:
                search();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                dispatch({
                    type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
                });
                break;
            case SearchBarUnstable_constants/* KEYCODE.ESCAPE */.Ps.ESCAPE:
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                dispatch({
                    type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
                });
                break;
            case SearchBarUnstable_constants/* KEYCODE.ARROW_UP */.Ps.ARROW_UP:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex - 1;
                    if (nextIndex < 0) {
                        nextIndex = maxIndex;
                    }
                    dispatch({
                        type: actions/* ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */.a.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            case SearchBarUnstable_constants/* KEYCODE.ARROW_DOWN */.Ps.ARROW_DOWN:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex + 1;
                    if (nextIndex > maxIndex) {
                        nextIndex = 0;
                    }
                    dispatch({
                        type: actions/* ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */.a.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            default:
                {
                    // Release locked debounce
                    dispatch({
                        type: actions/* ACTIONS.TOGGLE_LOCK_DEBOUNCE */.a.TOGGLE_LOCK_DEBOUNCE,
                        payload: false
                    });
                }
                break;
        }
    };
    var onInputFocus = function () {
        if (isShow) {
            return;
        }
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () {
            dispatch({
                type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                payload: context_types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT
            });
        }, 250);
    };
    var onTouchMove = function (e) {
        var _a;
        if (!isMobile) {
            return;
        }
        // Blur input when user scrolling out
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    (0,react.useEffect)(function () {
        var _a;
        if (isShow) {
            return;
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, [isShow]);
    (0,react.useEffect)(function () {
        var newPlaceholderText = placeholderText;
        if (pageName === 'interview') {
            newPlaceholderText = t('Enter a job title to view a set of interview questions');
        }
        else if (pageName === 'salary') {
            newPlaceholderText = t('Enter a job title to view salary');
        }
        // Special breakpoint for place holder
        var isInMobile = typeof window !== 'undefined' ? window.innerWidth <= 1024 : false;
        if (isInMobile) {
            newPlaceholderText = t('Search');
        }
        setPlaceholderText(newPlaceholderText);
    }, [pageName]);
    (0,react.useEffect)(function () {
        window.addEventListener('touchmove', onTouchMove, { passive: false });
        return function () {
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, []);
    return (react.createElement(components_Input/* default */.Z, { value: keyword, onChange: onInputChange, onKeyDown: onInputKeydown, placeholder: placeholderText, autoComplete: 'off', maxLength: (_a = searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.maxInputLength) !== null && _a !== void 0 ? _a : SearchBarUnstable_constants/* DEFAULT_MAX_LENGTH_INPUT */.m5, onFocus: onInputFocus, inputRef: inputRef, enterKeyHint: 'search' }));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
var ArrowDownIcon = __webpack_require__(98277);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CheckTagIcon/index.js
var CheckTagIcon = __webpack_require__(17362);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/constants.js
var TreeSelect_constants = __webpack_require__(71490);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/types.js
var TreeSelect_types = __webpack_require__(35617);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/components/InputContainer/InputContainer.css.js
'use client';






var dimAnim = (0,styled_components_browser_esm/* keyframes */.F4)(InputContainer_css_templateObject_1 || (InputContainer_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var SInputContainer = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_9 || (InputContainer_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    width: 100%;\n    cursor: pointer;\n    height: ", ";\n    gap: ", ";\n    ", ";\n\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    width: 100%;\n    cursor: pointer;\n    height: ", ";\n    gap: ", ";\n    ", ";\n\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var forResponsive = _a.forResponsive;
    return (forResponsive ? '32px' : '40px');
}, function (_a) {
    var variant = _a.variant;
    return (variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? '4px' : 0);
}, function (_a) {
    var variant = _a.variant, isDisabled = _a.isDisabled;
    switch (variant) {
        case TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY:
            return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_2 || (InputContainer_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    border: 1px solid ", ";\n                    border-radius: 6px;\n                    padding: 3px;\n                    justify-content: space-between;\n\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                "], ["\n                    background-color: ", ";\n                    border: 1px solid ", ";\n                    border-radius: 6px;\n                    padding: 3px;\n                    justify-content: space-between;\n\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                "])), isDisabled ? '#F6F8FB' : '#fff', isDisabled ? '#F6F8FB' : Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.primary.70 */.O9.primary[70]);
        case TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY:
            return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_3 || (InputContainer_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    border: none;\n                    border-radius: 48px;\n                    padding: 5px 8px;\n                    justify-content: flex-start;\n                "], ["\n                    background-color: ", ";\n                    border: none;\n                    border-radius: 48px;\n                    padding: 5px 8px;\n                    justify-content: flex-start;\n                "])), isDisabled ? '#F6F8FB' : Colors/* colors.neutral.95 */.O9.neutral[95]);
        default:
            return '';
    }
}, function (_a) {
    var isError = _a.isError;
    return isError && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_4 || (InputContainer_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid #ff4a53;\n            :hover {\n                border: 1px solid #ff4a53;\n            }\n        "], ["\n            border: 1px solid #ff4a53;\n            :hover {\n                border: 1px solid #ff4a53;\n            }\n        "])));
}, function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    return isPlaceholder && "color:#999;";
}, function (_a) {
    var isTransparentBackground = _a.isTransparentBackground;
    if (!isTransparentBackground) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_5 || (InputContainer_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: transparent;\n            border: 1px solid transparent;\n            :hover {\n                border: 1px solid transparent;\n            }\n        "], ["\n            background-color: transparent;\n            border: 1px solid transparent;\n            :hover {\n                border: 1px solid transparent;\n            }\n        "])));
}, function (_a) {
    var markHasValue = _a.markHasValue;
    return markHasValue && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_6 || (InputContainer_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid ", ";\n        "], ["\n            border: 1px solid ", ";\n        "])), Colors/* colors.primary.70 */.O9.primary[70]);
}, function (_a) {
    var forResponsive = _a.forResponsive;
    return forResponsive && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_7 || (InputContainer_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: none;\n            color: #333 !important;\n            background: #f1f2f4 !important;\n        "], ["\n            border: none;\n            color: #333 !important;\n            background: #f1f2f4 !important;\n        "])));
}, function (_a) {
    var forResponsive = _a.forResponsive, markHasValue = _a.markHasValue;
    return forResponsive && markHasValue
        ? (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_8 || (InputContainer_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background: #eff5ff !important;\n                  border: none;\n              "], ["\n                  background: #eff5ff !important;\n                  border: none;\n              "]))) : "";
});
var SelectedItem = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_10 || (InputContainer_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n"], ["\n    display: flex;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n"])));
var NumberDistricts = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_11 || (InputContainer_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 500;\n    line-height: 18px;\n    margin-left: 4px;\n"], ["\n    font-weight: 500;\n    line-height: 18px;\n    margin-left: 4px;\n"])));
var RemoveSpan = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_12 || (InputContainer_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"], ["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"])));
var ItemTag = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_17 || (InputContainer_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    font-size: 14px;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    will-change: transform;\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n"], ["\n    ", "\n    font-size: 14px;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    will-change: transform;\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n"])), function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY : _b, forResponsive = _a.forResponsive;
    if (variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_13 || (InputContainer_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background: ", ";\n                color: ", ";\n                font-weight: 500;\n                line-height: 18px;\n                border-radius: 12px;\n                padding: 2px 6px;\n                @media screen and (max-width: 767px) {\n                    padding: 6px 8px;\n                    border-radius: 16px;\n                }\n            "], ["\n                background: ", ";\n                color: ", ";\n                font-weight: 500;\n                line-height: 18px;\n                border-radius: 12px;\n                padding: 2px 6px;\n                @media screen and (max-width: 767px) {\n                    padding: 6px 8px;\n                    border-radius: 16px;\n                }\n            "])), Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.20 */.O9.primary[20]);
    }
    if (forResponsive) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_14 || (InputContainer_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background-color: transparent;\n                color: #003699;\n            "], ["\n                background-color: transparent;\n                color: #003699;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_15 || (InputContainer_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: #e6efff;\n            border: 1px solid tranparent;\n            color: #003699;\n            line-height: 20px;\n            font-weight: 400;\n            border-radius: 4px;\n            padding: 4px 8px;\n        "], ["\n            background-color: #e6efff;\n            border: 1px solid tranparent;\n            color: #003699;\n            line-height: 20px;\n            font-weight: 400;\n            border-radius: 4px;\n            padding: 4px 8px;\n        "])));
}, dimAnim, function (_a) {
    var isHover = _a.isHover, isDisabledClearValue = _a.isDisabledClearValue;
    if (!isHover || isDisabledClearValue) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_16 || (InputContainer_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-right: 26px;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "], ["\n            padding-right: 26px;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "])), RemoveSpan);
});
var SingleItem = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_18 || (InputContainer_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 4px;\n    padding-right: 3px;\n    font-size: 14px;\n    line-height: 24px;\n    color: #333;\n"], ["\n    padding-left: 4px;\n    padding-right: 3px;\n    font-size: 14px;\n    line-height: 24px;\n    color: #333;\n"])));
var PlaceHolder = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_21 || (InputContainer_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 4px;\n    ", "\n    ", "\n"], ["\n    margin-left: 4px;\n    ", "\n    ", "\n"])), function (_a) {
    var clearSpaceLeft = _a.clearSpaceLeft;
    if (clearSpaceLeft) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_19 || (InputContainer_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-left: 0 !important;\n                padding-left: 0 !important;\n            "], ["\n                margin-left: 0 !important;\n                padding-left: 0 !important;\n            "])));
    }
    return '';
}, function (_a) {
    var isInFilter = _a.isInFilter, _b = _a.variant, variant = _b === void 0 ? TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY : _b;
    if (!isInFilter) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_20 || (InputContainer_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            font-size: 14px;\n            line-height: ", ";\n            font-weight: ", ";\n            color: ", ";\n            padding-left: ", ";\n        "], ["\n            font-size: 14px;\n            line-height: ", ";\n            font-weight: ", ";\n            color: ", ";\n            padding-left: ", ";\n        "])), variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? '18px' : '24px', variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? 500 : 400, variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? Colors/* colors.grey.20 */.O9.grey[20] : '#333', variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? 0 : '5px');
});
var InputContainer_css_templateObject_1, InputContainer_css_templateObject_2, InputContainer_css_templateObject_3, InputContainer_css_templateObject_4, InputContainer_css_templateObject_5, InputContainer_css_templateObject_6, InputContainer_css_templateObject_7, InputContainer_css_templateObject_8, InputContainer_css_templateObject_9, InputContainer_css_templateObject_10, InputContainer_css_templateObject_11, InputContainer_css_templateObject_12, InputContainer_css_templateObject_13, InputContainer_css_templateObject_14, InputContainer_css_templateObject_15, InputContainer_css_templateObject_16, InputContainer_css_templateObject_17, InputContainer_css_templateObject_18, InputContainer_css_templateObject_19, InputContainer_css_templateObject_20, InputContainer_css_templateObject_21;


//# sourceMappingURL=InputContainer.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/components/InputContainer/index.js
'use client';











var InputContainer = (0,react.forwardRef)(function (props, ref) {
    var placeholder = props.placeholder, isError = props.isError, styleOptions = props.styleOptions, value = props.value, options = props.options, childrenList = props.childrenList, _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, _b = props.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, onClick = props.onClick, onRemoveItem = props.onRemoveItem, selectOptions = props.selectOptions, isDisabledClearValue = props.isDisabledClearValue, markHasValue = props.markHasValue, forResponsive = props.forResponsive;
    var mergedStyleOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_INPUT_STYLE */.v1), styleOptions);
    var mergedSelectOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_SELECT_OPTIONS */.mt), selectOptions);
    var _c = (0,react.useState)(mergedStyleOption.limitDisplay), showLimit = _c[0], setShowLimit = _c[1];
    var _d = (0,react.useState)(false), isStripFirstLabel = _d[0], setIsRequireStripFirstLabel = _d[1];
    var itemTagWrapperRef = (0,react.useRef)(null);
    var _e = (0,react.useState)(0), parentTagsWrapperWidth = _e[0], setParentTagsWrapperWidth = _e[1];
    var getSelectedItemInText = (0,react.useCallback)(function (limit) {
        var _a, _b;
        var selectedItem = (_a = (value &&
            value.map(function (item) {
                var filteredOptions = options.filter(function (optionItem) { return optionItem.id === item.parentId; });
                if (filteredOptions.length === 0) {
                    return {
                        id: -1,
                        name: ''
                    };
                }
                return filteredOptions[0];
            }))) !== null && _a !== void 0 ? _a : [];
        // Filter empty item out of array
        var filteredNotEmpty = selectedItem.filter(function (item) { return item.id !== -1; });
        filteredNotEmpty = filteredNotEmpty.slice(0, limit);
        // Count total text length
        var joinedText = filteredNotEmpty.map(function (item) { return item.name; }).join('');
        return {
            selectedItem: filteredNotEmpty,
            totalLength: (_b = joinedText === null || joinedText === void 0 ? void 0 : joinedText.length) !== null && _b !== void 0 ? _b : 0
        };
    }, [options, value]);
    var calculateDisplayItem = (0,react.useCallback)(function (limit) {
        var _a;
        var _b = getSelectedItemInText(limit), selectedItem = _b.selectedItem, _c = _b.totalLength, totalLength = _c === void 0 ? 0 : _c;
        if (!selectedItem || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            return [0, 0];
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return [0, 0];
        }
        // Calculate width being use
        var totalTextWidth = totalLength * TreeSelect_constants/* DEFAULT_CHARACTER_WIDTH */.r$;
        var totalPaddingWidth = limit * TreeSelect_constants/* DEFAULT_PADDING_WIDTH */.Rm;
        var totalMarginWidth = limit > 1 ? (limit - 1) * TreeSelect_constants/* DEFAULT_MARGIN_WIDTH */.P7 : 0;
        var totalBorderWidth = limit * TreeSelect_constants/* DEFAULT_BORDER_WIDTH */.Z0;
        // calculate total
        var totalWidth = totalTextWidth + totalPaddingWidth + totalBorderWidth + totalMarginWidth + TreeSelect_constants/* DEFAULT_REMOVE_ICON_WIDTH */.mG;
        return [totalWidth, parentTagsWrapperWidth];
    }, [getSelectedItemInText, itemTagWrapperRef, parentTagsWrapperWidth]);
    var updateDisplayItem = (0,react.useCallback)(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
            return;
        }
        var isFit = false;
        var isStripFirstItem = false;
        var calcTotalWidth = 0;
        var calcItemWrapperWidth = 0;
        var limitCount = mergedStyleOption.limitDisplay;
        while (!isFit) {
            var _a = calculateDisplayItem(limitCount), totalWidth = _a[0], itemWrapperWidth = _a[1];
            if (totalWidth === 0 && itemWrapperWidth === 0) {
                isFit = true;
            }
            if (totalWidth < itemWrapperWidth) {
                isFit = true;
                calcTotalWidth = totalWidth;
                calcItemWrapperWidth = itemWrapperWidth;
            }
            else {
                limitCount--;
            }
            if (limitCount <= 0) {
                limitCount = 1;
                isFit = true;
                isStripFirstItem = totalWidth > itemWrapperWidth;
            }
        }
        var displayItemCount = limitCount;
        if (calcTotalWidth >= calcItemWrapperWidth) {
            // minus 1 item
            displayItemCount = (limitCount !== null && limitCount !== void 0 ? limitCount : 2) - 1;
        }
        // Allow to display all
        if (displayItemCount === 0) {
            displayItemCount = 1;
        }
        setShowLimit(displayItemCount);
        setIsRequireStripFirstLabel(isStripFirstItem);
    }, [calculateDisplayItem, value]);
    (0,react.useEffect)(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            // delay 600ms wait for transitions 500ms in searchbar
            if ((_b = (_a = itemTagWrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) {
                setParentTagsWrapperWidth((_d = (_c = itemTagWrapperRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.clientWidth);
            }
        }, 600);
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay) {
            setShowLimit(styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay);
            return;
        }
        updateDisplayItem();
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', updateDisplayItem);
        return function () {
            if (typeof window === 'undefined') {
                return;
            }
            window.removeEventListener('resize', updateDisplayItem);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, value, styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay, itemTagWrapperRef.current]);
    var renderSelectedItem = function () {
        var _a;
        var selectedItem = getSelectedItemInText(showLimit).selectedItem;
        var itemTagList = [];
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 0 && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            itemTagList.push(react.createElement(ItemTag, { variant: mergedStyleOption.variant, key: 'item-tag-plus', isHover: false, forResponsive: forResponsive },
                "+",
                value.length - showLimit));
        }
        if ((value && (value === null || value === void 0 ? void 0 : value.length) === 0) || !selectedItem) {
            return (react.createElement(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft }, placeholder));
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return (react.createElement(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft }, placeholder));
        }
        itemTagList = selectedItem.map(function (item, index) {
            var _a;
            var filteredValue = value === null || value === void 0 ? void 0 : value.filter(function (valueItem) {
                return valueItem.parentId === item.id;
            });
            var countChild = 0;
            if (filteredValue && (filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) > 0) {
                countChild = filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length;
            }
            // get number districts
            var numberDistricts;
            var province = value === null || value === void 0 ? void 0 : value.find(function (_a) {
                var parentId = _a.parentId;
                return parentId === item.id;
            });
            if (province && province.childrenIds[0] !== -1) {
                numberDistricts = province.childrenIds.length;
            }
            var itemLabel = item.name;
            if ((selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isStripFirstItem) && isStripFirstLabel) {
                var totalTextWidth = item.name.length * TreeSelect_constants/* DEFAULT_CHARACTER_WIDTH */.r$;
                var inputWidth = (((_a = itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) -
                    (TreeSelect_constants/* DEFAULT_REMOVE_ICON_WIDTH */.mG + TreeSelect_constants/* DEFAULT_MARGIN_WIDTH */.P7 + TreeSelect_constants/* DEFAULT_BORDER_WIDTH */.Z0);
                if (value && value.length > 1) {
                    inputWidth -= TreeSelect_constants/* FIXED_WIDTH_OF_INPUT */.mg;
                }
                var isSplit = itemLabel.length > mergedSelectOptions.limitFirstItemLength;
                if (isSplit && totalTextWidth > inputWidth) {
                    itemLabel = itemLabel.slice(0, mergedSelectOptions.limitFirstItemLength) + '...';
                }
            }
            return (react.createElement(ItemTag, { key: "item-tag-".concat(index), "data-selected-child-count": countChild, variant: mergedStyleOption.variant, isDisabledClearValue: isDisabledClearValue, isHover: true, forResponsive: forResponsive },
                react.createElement("span", null, itemLabel),
                !!numberDistricts && (react.createElement(NumberDistricts, null, (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.variant) === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? "(".concat(numberDistricts, ")") : numberDistricts)),
                !isDisabledClearValue ? (react.createElement(RemoveSpan, { onClick: function (e) {
                        e.stopPropagation();
                        onRemoveItem(item.id);
                    } },
                    react.createElement(CheckTagIcon/* default */.Z, null))) : null));
        });
        if (value && (value === null || value === void 0 ? void 0 : value.length) > showLimit) {
            itemTagList.push(react.createElement(ItemTag, { variant: mergedStyleOption.variant, key: 'item-tag-plus', isHover: false, forResponsive: forResponsive },
                "+",
                value.length - showLimit));
        }
        return itemTagList;
    };
    var renderSingleSelectItem = function () {
        var placeHolderComponent = react.createElement(SingleItem, { className: 'placeholder' }, placeholder);
        if (!value || (value && (value === null || value === void 0 ? void 0 : value.length) === 0)) {
            return placeHolderComponent;
        }
        if (value[0].childrenIds.length === 0) {
            return placeHolderComponent;
        }
        var selectedParentId = value[0].parentId;
        var selectedChildId = value[0].childrenIds[0];
        // Find child item by selected id
        var keys = Object.keys(childrenList);
        var values = Object.values(childrenList);
        var index = keys.indexOf(selectedParentId.toString());
        var childItems = values[index];
        if (!childItems) {
            return placeHolderComponent;
        }
        var childItemInfo = childItems.filter(function (item) { return item.id === selectedChildId; });
        if (childItemInfo.length === 0) {
            return placeHolderComponent;
        }
        return react.createElement(SingleItem, null, langCode === constants/* ELanguage.VI */.Df.VI ? childItemInfo[0].name : childItemInfo[0].nameEn);
    };
    var leftIcon = function () {
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon) {
            var Icon = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon;
            return (react.createElement(Icon, { color: value && value.length > 0 ? Colors/* colors.primary.30 */.O9.primary[30] : undefined, width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }));
        }
        return null;
    };
    return (react.createElement(SInputContainer, { isError: isError, isDisabled: isDisabled, isPlaceholder: true, onClick: function () { return onClick && onClick(); }, isTransparentBackground: mergedStyleOption.isTransparentBackground, variant: mergedStyleOption.variant, ref: ref, className: 'tree-select-input', markHasValue: markHasValue, forResponsive: forResponsive },
        mergedStyleOption.variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? leftIcon() : null,
        react.createElement(SelectedItem, { ref: itemTagWrapperRef }, mergedSelectOptions.isSingleSelect ? renderSingleSelectItem() : renderSelectedItem()),
        mergedStyleOption.variant === TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY && (react.createElement(ArrowDownIcon/* default */.Z, { width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }))));
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/components/MobileDialog/MobileDialog.css.js
'use client';




var MobileDialogWrapper = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_1 || (MobileDialog_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999;\n    display: ", ";\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999;\n    display: ", ";\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 'block' : 'none');
});
var MobileContent = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_2 || (MobileDialog_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n"], ["\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n"])));
var MobileBody = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_3 || (MobileDialog_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 100%;\n"], ["\n    height: 100%;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_4 || (MobileDialog_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 60px;\n    display: flex;\n    justify-content: space-between;\n    padding-top: 20px;\n    border-top: 1px solid #eaeaf0;\n    > button {\n        width: 50%;\n        &:nth-child(1) {\n            margin-right: 5px;\n        }\n        &:nth-child(2) {\n            margin-left: 5px;\n        }\n    }\n"], ["\n    height: 60px;\n    display: flex;\n    justify-content: space-between;\n    padding-top: 20px;\n    border-top: 1px solid #eaeaf0;\n    > button {\n        width: 50%;\n        &:nth-child(1) {\n            margin-right: 5px;\n        }\n        &:nth-child(2) {\n            margin-left: 5px;\n        }\n    }\n"])));
var MobileDialog_css_templateObject_1, MobileDialog_css_templateObject_2, MobileDialog_css_templateObject_3, MobileDialog_css_templateObject_4;


//# sourceMappingURL=MobileDialog.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/components/MobileDialog/index.js
'use client';





var MobileDialog = function (props) {
    var children = props.children, _a = props.isShow, isShow = _a === void 0 ? false : _a, onUnmount = props.onUnmount;
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    (0,react.useEffect)(function () {
        if (!bodyNode) {
            return;
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isShow) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [bodyNode, isShow]);
    (0,react.useEffect)(function () {
        // Trigger onUnmount when component is un-mounted
        return function () {
            onUnmount && onUnmount();
        };
    }, [onUnmount]);
    if (!bodyNode || !isShow) {
        return react.createElement(react.Fragment, null);
    }
    return (0,react_dom.createPortal)(react.createElement(MobileDialogWrapper, { "data-cname": 'portal-mobile-dialog', isShow: isShow },
        react.createElement(MobileContent, null,
            react.createElement(MobileBody, null, children))), bodyNode);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/translations.js
'use client';

var TreeSelect_translations_translations = {
    All: 'Tất cả',
    Back: 'Trở về',
    Apply: 'Áp dụng',
    Cancel: 'Hủy',
    Select: 'Chọn',
    Search: 'Tìm kiếm',
    'Remove all': 'Xóa tất cả',
    'No result': 'Không có kết quả',
    'You have selected up to three options': 'Bạn đã chọn tối đa ba tuỳ chọn',
    districts: 'quận/huyện'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/Popup.css.js
var Popup_css = __webpack_require__(46021);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/TreeSelect.css.js
'use client';






var TreeSelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(TreeSelect_css_templateObject_3 || (TreeSelect_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    if (!isDisabled) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(TreeSelect_css_templateObject_1 || (TreeSelect_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n        "], ["\n            pointer-events: none;\n        "])));
}, function (_a) {
    var cssString = _a.cssString;
    if (!cssString)
        return;
    return (0,styled_components_browser_esm/* css */.iv)(TreeSelect_css_templateObject_2 || (TreeSelect_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            ", "\n        "], ["\n            ", "\n        "])), cssString);
});
(0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(TreeSelect_css_templateObject_4 || (TreeSelect_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", " {\n        background-color: #fff;\n    }\n"], ["\n    ", " {\n        background-color: #fff;\n    }\n"])), Popup_css/* PopupContent */.pP);
var TreeSelect_css_templateObject_1, TreeSelect_css_templateObject_2, TreeSelect_css_templateObject_3, TreeSelect_css_templateObject_4;


//# sourceMappingURL=TreeSelect.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/context/reducer.js
var context_reducer = __webpack_require__(55561);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/context/index.js
var TreeSelect_context = __webpack_require__(48901);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/context/types.js
var TreeSelect_context_types = __webpack_require__(3810);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/helpers.js
var TreeSelect_helpers = __webpack_require__(33294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TreeSelect/index.js
'use client';



















var Dropdown = react.lazy(function () { return __webpack_require__.e(/* import() */ 75).then(__webpack_require__.bind(__webpack_require__, 6075)); });
var TreeSelect = function (props) {
    var langCode = props.langCode, textOptions = props.textOptions, selectOptions = props.selectOptions, _a = props.hasError, hasError = _a === void 0 ? false : _a, _b = props.isMobile, isMobile = _b === void 0 ? false : _b, _c = props.isEnableFooter, isEnableFooter = _c === void 0 ? false : _c, _d = props.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = props.options, options = _e === void 0 ? [] : _e, _f = props.childrenList, childrenList = _f === void 0 ? {} : _f, _g = props.value, value = _g === void 0 ? [] : _g, dropdownStyleOptions = props.dropdownStyleOptions, styleOptions = props.styleOptions, onValueChange = props.onValueChange, onRemoveEachValue = props.onRemoveEachValue, onCloseDropdown = props.onCloseDropdown, onShowDropdown = props.onShowDropdown, floatingConfig = props.floatingConfig, onBlur = props.onBlur, onApplyChangeProps = props.onClickApply, onClickCancel = props.onClickCancel, isDisabledClearValue = props.isDisabledClearValue, forResponsive = props.forResponsive;
    var _h = floatingConfig || {}, _j = _h.placement, placement = _j === void 0 ? 'bottom-start' : _j, _k = _h.position, position = _k === void 0 ? 'absolute' : _k, _l = _h.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _l === void 0 ? false : _l, _m = _h.enablePortal, enablePortal = _m === void 0 ? false : _m, _o = _h.isFlip, isFlip = _o === void 0 ? true : _o;
    var mergedSelectOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_SELECT_OPTIONS */.mt), selectOptions);
    var mergedDropdownStyleOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_DROPDOWN_STYLE_OPTIONS */.tX), dropdownStyleOptions);
    var _p = (0,react.useReducer)(context_reducer/* treeSelectReducer */.s, TreeSelect_context/* initialTreeSelect */.b), treeSelectState = _p[0], dispatch = _p[1];
    // Dropdown state
    var _q = (0,react.useState)(false), isVisible = _q[0], setElementVisible = _q[1];
    var _r = (0,useFloating/* default */.Z)({
        placement: placement,
        position: position,
        config: {
            useWindowAsFlippingContainer: useWindowAsFlippingContainer,
            isFlip: isFlip,
            detectHidden: !mergedDropdownStyleOptions.isForceClose
        }
    }), refs = _r.refs, context = _r.context, FloatingPortal = _r.FloatingPortal;
    // Value
    var _s = (0,react.useState)(value), selectedValue = _s[0], setSelectedValue = _s[1];
    // Mobile temporary Value
    var _t = (0,react.useState)(value), tempSelectedValue = _t[0], setTempSelectedValue = _t[1];
    // Dropdown state
    var _u = (0,react.useState)(true), isFirstLevelMounted = _u[0], setFirstLevelMounted = _u[1];
    var _v = (0,react.useState)(false), isSecondLevelMounted = _v[0], setSecondLevelMounted = _v[1];
    var resetSelectView = function () {
        if (!mergedSelectOptions.isSingleSelect) {
            return;
        }
        dispatch({
            type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
            payload: 0
        });
        dispatch({
            type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
            payload: -1
        });
        setFirstLevelMounted(true);
        setSecondLevelMounted(false);
    };
    (0,useClickAway/* default */.Z)(function () {
        resetSelectView();
        setElementVisible(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    // End dropdown state
    var sortedOptions = (0,TreeSelect_helpers/* sortOptionsAlphabet */.t_)((0,_tslib/* __spreadArray */.ev)([], options, true), mergedSelectOptions.isSortAlphabet);
    var sortedChildOptions = (0,TreeSelect_helpers/* sortChildOptionAlphabet */.j5)((0,_tslib/* __assign */.pi)({}, childrenList), langCode, mergedSelectOptions.isSortAlphabet);
    // isApply Click
    var isApplyClick = (0,react.useRef)(false);
    var isAlreadyOpened = (0,react.useRef)(false);
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    var t = function (text) {
        var _a;
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = TreeSelect_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    // this cb handle for case just apply value changed when
    var dispatchValueChanged = function (clonedSelectedValue) {
        // Only callback onValueChange when value is different with value from prop
        if (value.length === 0 && clonedSelectedValue.length === 0) {
            return;
        }
        var isChange = (0,helpers/* isLocationChanged */.G)(value, clonedSelectedValue);
        if (!isChange) {
            return;
        }
        onValueChange && onValueChange(clonedSelectedValue);
    };
    var onRemoveItem = function (id) {
        var clonedSelectedValue = (0,_tslib/* __spreadArray */.ev)([], selectedValue, true).filter(function (item) { return item.parentId !== id; });
        setSelectedValue(clonedSelectedValue);
        dispatchValueChanged(clonedSelectedValue);
        if (onRemoveEachValue) {
            var itemRemove = selectedValue.find(function (item) { return item.parentId === id; });
            onRemoveEachValue(clonedSelectedValue, itemRemove);
        }
        setTempSelectedValue(clonedSelectedValue);
    };
    var onSetSelectedValue = function (value) {
        var clonedValue = (0,_tslib/* __spreadArray */.ev)([], value, true);
        // Do update temporary selectedValue when isMobile or isEnableFooter
        if (!(selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) && (isMobile || isEnableFooter)) {
            setTempSelectedValue(clonedValue);
            return;
        }
        if (selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) {
            setTempSelectedValue(clonedValue);
        }
        setSelectedValue(clonedValue);
        dispatchValueChanged(clonedValue);
        if ((selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) && clonedValue.length > 0) {
            setElementVisible(false);
        }
    };
    var onClickApply = function () {
        isApplyClick.current = true;
        // When apply button clicked, set selectedValue from tempSelectedValue
        setSelectedValue(tempSelectedValue);
        dispatchValueChanged(tempSelectedValue);
        onApplyChangeProps && onApplyChangeProps(tempSelectedValue);
    };
    var resetTemporarySelectedValue = function () {
        if (isApplyClick.current) {
            isApplyClick.current = false;
            return;
        }
        if (isVisible) {
            return;
        }
        // Reset tempSelectedValue when apply is not triggered
        setTempSelectedValue(selectedValue);
    };
    var getInputContainerValue = function () {
        if (isApplyClick.current && isMobile) {
            return tempSelectedValue;
        }
        if (isEnableFooter) {
            return tempSelectedValue;
        }
        return (0,TreeSelect_helpers/* deepCloneArray */.NU)(selectedValue);
    };
    var updateMountedLevel = function (level) {
        if (level === TreeSelect_constants/* SELECT_CATE_LEVEL_PARENT */.av) {
            return;
        }
        setFirstLevelMounted(false);
        setSecondLevelMounted(true);
    };
    var checkAndUpdateHistory = function () {
        // This function is not ready for mutiple select yet
        // TODO: make this into option that allow to show current view from history
        if (!mergedSelectOptions.isSingleSelect) {
            return;
        }
        var history = treeSelectState.history, selectLevel = treeSelectState.selectLevel, selectedParentId = treeSelectState.selectedParentId;
        var isHistoryChange = false;
        if (selectLevel !== history.selectLevel) {
            // Update select level
            dispatch({
                type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
                payload: history.selectLevel
            });
            updateMountedLevel(history.selectLevel);
            isHistoryChange = true;
        }
        if (selectedParentId !== history.selectedParentId) {
            // Update select parent
            dispatch({
                type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
                payload: history.selectedParentId
            });
            isHistoryChange = true;
        }
        // Check history change
        if (isHistoryChange) {
            return;
        }
        // Check value and set level
        if (value.length === 0) {
            return;
        }
        var levelFromValue = value[0].parentId === -1 ? TreeSelect_constants/* SELECT_CATE_LEVEL_PARENT */.av : TreeSelect_constants/* SELECT_CATE_LEVEL_SUB */.Rh;
        dispatch({
            type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
            payload: levelFromValue
        });
        dispatch({
            type: TreeSelect_context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
            payload: value[0].parentId
        });
        dispatch({
            type: TreeSelect_context_types/* TreeSelectAction.UPDATE_HISTORY */.N.UPDATE_HISTORY,
            payload: {
                selectedParentId: value[0].parentId,
                selectLevel: levelFromValue
            }
        });
        updateMountedLevel(levelFromValue);
    };
    var onClickInputContainer = function () {
        var delayTime = mergedDropdownStyleOptions.delayTime;
        if (delayTime && delayTime > 0) {
            if (isVisible) {
                setElementVisible(false);
            }
            else {
                setTimeout(function () {
                    setElementVisible(true);
                }, delayTime);
            }
        }
        else {
            setElementVisible(!isVisible);
        }
        onShowDropdown && onShowDropdown(!isVisible);
        if (!isVisible) {
            return;
        }
        resetSelectView();
    };
    // We have a issue when parent component change
    // make treeselect component infinity loop
    // this hook useMemo help by pass this error
    var memoValueProps = (0,react.useMemo)(function () {
        if (!value || value.length < 1) {
            return null;
        }
        return value;
    }, [value]);
    (0,react.useEffect)(function () {
        var _a;
        if (!memoValueProps) {
            if (isMobile || isEnableFooter) {
                setTempSelectedValue([]);
            }
            setSelectedValue([]);
            return;
        }
        var mappedValues = [];
        // Re-mapped list with empty child
        for (var i = 0; i < memoValueProps.length; i++) {
            var valueItem = memoValueProps[i];
            if (!(valueItem === null || valueItem === void 0 ? void 0 : valueItem.parentId)) {
                continue;
            }
            mappedValues.push({
                parentId: valueItem === null || valueItem === void 0 ? void 0 : valueItem.parentId,
                childrenIds: (_a = valueItem === null || valueItem === void 0 ? void 0 : valueItem.childrenIds) !== null && _a !== void 0 ? _a : [-1]
            });
        }
        // Make sure filter out undefined and null value
        var filteredValues = mappedValues.filter(function (item) { return item !== undefined && item !== null; });
        // only setMobileSelectedValue for mobile or Desktop with option Enable Footer
        if (isMobile || isEnableFooter) {
            setTempSelectedValue(filteredValues);
        }
        setSelectedValue(filteredValues);
    }, [isMobile, memoValueProps, isEnableFooter]);
    (0,react.useEffect)(function () {
        if (isVisible) {
            checkAndUpdateHistory();
            isAlreadyOpened.current = true;
            return;
        }
        if (isEnableFooter) {
            resetTemporarySelectedValue();
        }
        if (!isAlreadyOpened.current) {
            return;
        }
        onCloseDropdown && onCloseDropdown(selectedValue, isVisible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible, isAlreadyOpened]);
    (0,react.useEffect)(function () {
        if (!(mergedDropdownStyleOptions === null || mergedDropdownStyleOptions === void 0 ? void 0 : mergedDropdownStyleOptions.isForceClose)) {
            return;
        }
        var onForceClose = function () {
            setElementVisible(false);
            return function () {
                window.removeEventListener('scroll', onForceClose);
            };
        };
        window.addEventListener('scroll', onForceClose);
    }, [mergedDropdownStyleOptions === null || mergedDropdownStyleOptions === void 0 ? void 0 : mergedDropdownStyleOptions.isForceClose]);
    var renderDropdown = function () {
        var _a;
        var parsedSelectedValue = isMobile || isEnableFooter ? tempSelectedValue : selectedValue;
        var isEnableFooterChecked = isMobile ? true : isEnableFooter;
        if (bodyNode === null) {
            return react.createElement(react.Fragment, null);
        }
        var width;
        if (dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width) {
            width = dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width;
        }
        if (!(dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width) && context.position === 'fixed') {
            width = "".concat((_a = refs.reference.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, "px");
        }
        var dropdownStyle = isMobile
            ? {}
            : {
                position: context.position,
                top: context.y,
                left: context.x,
                display: context.isReferenceHidden ? 'none' : 'block',
                width: width,
                marginTop: mergedDropdownStyleOptions.marginTop
            };
        return (react.createElement(FloatingPortal, { enable: isMobile ? false : enablePortal },
            react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                react.createElement(Dropdown, { ref: refs.setPopup, isShow: isVisible, isMobile: isMobile, options: sortedOptions, childrenList: sortedChildOptions, selectOptions: selectOptions, selectedValue: parsedSelectedValue, setSelectedValue: onSetSelectedValue, firstLevelMount: [isFirstLevelMounted, setFirstLevelMounted], secondLevelMount: [isSecondLevelMounted, setSecondLevelMounted], t: t, textOptions: {
                        headerLabel: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.headerLabel) || t('Select'),
                        searchPlaceholder: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.searchPlaceholder) || t('Search'),
                        allText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.allOptionText) || t('All'),
                        subOptionText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.subOptionText) || t('districts'),
                        selectAllText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.selectAllText) || t('All'),
                        maxLimitText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.maxLimitText) || t('You have selected up to three options'),
                        removeAllText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.removeAllText) || t('Remove all'),
                        backText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.backText) || t('Back'),
                        noResultText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.noResultText) || t('No result'),
                        selectedCountText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.selectedCountText) || '',
                        primaryButtonText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.primaryButtonText) || ''
                    }, footerOptions: {
                        isEnableFooter: isEnableFooterChecked,
                        setElementVisible: setElementVisible,
                        onClickApply: onClickApply,
                        onClickCancel: onClickCancel,
                        resetSelectedValue: function () { return setTempSelectedValue(selectedValue); }
                    }, langCode: langCode, styleOptions: dropdownStyleOptions, style: dropdownStyle, placement: context.placement }))));
    };
    return (react.createElement(context_reducer/* TreeSelectContext.Provider */.E.Provider, { value: {
            state: treeSelectState,
            dispatch: dispatch
        } },
        react.createElement(TreeSelectWrapper, { "data-id": 'tree-select', cssString: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.cssString, isDisabled: isDisabled },
            react.createElement(InputContainer, { placeholder: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.inputPlaceholder) || t('All'), isError: hasError, isDisabledClearValue: isDisabledClearValue, value: getInputContainerValue(), options: sortedOptions, isDisabled: isDisabled, onClick: onClickInputContainer, childrenList: sortedChildOptions, onRemoveItem: function (id) { return onRemoveItem(id); }, styleOptions: styleOptions, selectOptions: selectOptions, dropdownStyleOptions: mergedDropdownStyleOptions, langCode: langCode, ref: refs.setReference, markHasValue: tempSelectedValue.length > 0, forResponsive: forResponsive }),
            isMobile ? (react.createElement(MobileDialog, { isShow: isVisible, onUnmount: resetTemporarySelectedValue }, renderDropdown())) : (renderDropdown()))));
};
var TreeSelect$1 = (0,react.memo)(TreeSelect);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/index.js + 14 modules
var InfoOverviewGroupIcons = __webpack_require__(67824);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/utilities.js
'use client';

function parseJSON(value) {
    try {
        if (!value)
            return;
        var parsedObject = JSON.parse(value);
        return parsedObject;
    }
    catch (error) {
        if (error instanceof SyntaxError) {
            // Handle SyntaxError specifically, like logging or returning a default value
            console.error('Invalid JSON format:', error.message);
            throw error; // Or any other appropriate default value
        }
        else {
            // Handle other potential errors
            console.error('Error parsing JSON:', error);
            throw error; // Re-throw the error for further handling
        }
    }
}


//# sourceMappingURL=utilities.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/Locations/index.js
'use client';











function Locations() {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _a.state, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isShow = state.isShow;
    var _b = (0,react.useState)([]), locations = _b[0], setLocations = _b[1];
    var isMobile = props.isMobile, langCode = props.langCode, dataProvider = props.dataProvider, optionList = props.optionList, searchBarOptions = props.searchBarOptions;
    var locationDistricts = dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.getDistricts();
    var forceLimitDisplay = (0,react.useMemo)(function () {
        if (isShow || ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isMobile)) {
            return 3;
        }
        return 1;
    }, [isMobile, isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var memoDelayTimeToShowDroupdown = (0,react.useMemo)(function () {
        if ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) || isShow) {
            return 0;
        }
        return 380;
    }, [isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var updateLocations = function (locations) {
        setLocations(locations);
        dispatch({
            type: actions/* ACTIONS.SET_LOCATIONS */.a.SET_LOCATIONS,
            payload: locations
        });
    };
    (0,react.useEffect)(function () {
        var _a;
        // case default update locations
        if (searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate) {
            var localStorageParams = parseJSON(localStorage.getItem('params') || '');
            updateLocations((_a = localStorageParams === null || localStorageParams === void 0 ? void 0 : localStorageParams.locations) !== null && _a !== void 0 ? _a : []);
        }
        var handleOnEventSearch = function (e) {
            var _a;
            var searchEvent = e;
            var locations = ((_a = searchEvent === null || searchEvent === void 0 ? void 0 : searchEvent.detail) === null || _a === void 0 ? void 0 : _a.params).locations;
            if (typeof locations !== 'object')
                return;
            updateLocations(locations !== null && locations !== void 0 ? locations : []);
        };
        window.addEventListener('SEARCH', handleOnEventSearch);
        return function () {
            window.removeEventListener('SEARCH', handleOnEventSearch);
        };
    }, [searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate]);
    return (react.createElement(TreeSelect$1, { langCode: langCode, textOptions: {
            headerLabel: t('Location'),
            inputPlaceholder: t('All locations'),
            maxLimitText: t('You have selected up to three locations')
        }, options: optionList, childrenList: locationDistricts, value: locations, onValueChange: function (value) {
            updateLocations(value !== null && value !== void 0 ? value : []);
        }, onShowDropdown: function (isShowDropdown) {
            if (isShowDropdown || !isShow) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: context_types/* EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */.q.JUST_SHOW_DROPDOWN_TREE_SELECT
                });
            }
        }, onCloseDropdown: function (_, isShowDropdown) {
            if (!isShow) {
                return;
            }
            if (!isShowDropdown) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: context_types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT
                });
            }
        }, selectOptions: { isFilter: true }, styleOptions: {
            variant: TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY,
            leftIcon: function (props) { return react.createElement(InfoOverviewGroupIcons/* default.LocationIOS16GlyphIcon */.Z.LocationIOS16GlyphIcon, (0,_tslib/* __assign */.pi)({}, props)); },
            forceLimitDisplay: forceLimitDisplay,
            arrowDownSize: {
                width: 20,
                height: 20
            }
        }, dropdownStyleOptions: {
            width: '350px',
            borderRadius: 16,
            marginTop: 12,
            delayTime: memoDelayTimeToShowDroupdown,
            isForceClose: true
        }, floatingConfig: {
            position: 'fixed',
            enablePortal: true,
            useWindowAsFlippingContainer: true,
            isFlip: false,
            placement: 'bottom-end'
        }, isMobile: isMobile, isDisabledClearValue: !(searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isShow }));
}
var Locations$1 = (0,react.memo)(Locations);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(82100);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchSection/index.js
'use client';



















var SearchSection = function (params) {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), props = _a.props, state = _a.state, dispatch = _a.dispatch, t = _a.t, search = _a.search;
    var isMountedDropdown = params.isMountedDropdown;
    var searchBarOptions = props.searchBarOptions, isMobile = props.isMobile, pageName = props.pageName;
    var isShow = state.isShow, keyword = state.keyword;
    var mergedSearchBarOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, SearchBarUnstable_constants/* DEFAULT_SEARCH_BAR_OPTIONS */.Uj), searchBarOptions);
    var _b = mergedSearchBarOptions.isHomepage, isHomepage = _b === void 0 ? false : _b;
    var _c = (0,react.useState)(true), isSupportAnim = _c[0], setSupportAnim = _c[1];
    var inputContentRef = (0,react.useRef)(null);
    var searchSectionWrapperRef = (0,react.useRef)(null);
    var matcher = (0,useMediaQuery/* default */.Z)(!isHomepage ? '(max-width: 1023px)' : '(max-width: 767px)');
    var matcherMobile = (0,useMediaQuery/* default */.Z)('(max-width: 767px)');
    var handleClickSearchIcon = function () {
        var _a;
        if (!inputContentRef.current) {
            return;
        }
        var inputElement = (_a = inputContentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(SearchBarUnstable_constants/* SEARCH_INPUT_QUERY_STRING */._o);
        inputElement && inputElement.focus();
    };
    var onClickCancel = function () {
        dispatch({
            type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
        });
    };
    var onClickSearch = function () {
        search();
    };
    (0,react.useEffect)(function () {
        var iOSVersion = (0,helpers/* getiOSVersion */.u1)();
        setSupportAnim(iOSVersion === -2 || iOSVersion >= 16);
    }, []);
    return (react.createElement(SearchSectionWrapper, { "data-cname": 'seachSection', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow, pageName: pageName, isMountedDropdown: isMountedDropdown, ref: searchSectionWrapperRef, isSupportAnim: isSupportAnim },
        react.createElement(InputGroup, { "data-cname": 'InputGroup', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow },
            react.createElement(SearchSection_css_Icon, { className: 'sb-searchIcon', isHaveKeyword: keyword !== '', isShow: isShow, isMobile: isMobile, pageName: pageName, isHomePage: isHomepage, onClick: handleClickSearchIcon },
                react.createElement(icons/* IconSearch */.jV, { fill: Colors/* colors.grey.20 */.O9.grey[20] })),
            react.createElement(InputContent, { ref: inputContentRef },
                react.createElement(SearchInput, null))),
        react.createElement(CustomTreeSelect, { isShow: isShow, isHomePage: isHomepage },
            react.createElement(Locations$1, null)),
        react.createElement(ActionGroup, { isShow: !matcher || isShow, isHomepage: isHomepage, isMobile: matcherMobile },
            react.createElement(Button/* default */.Z, { className: 'search__button', type: 'primary', onClick: onClickSearch, "aria-label": t('Search') },
                react.createElement(TextButton, { isShow: isShow, isHomepage: isHomepage }, t('Search')),
                react.createElement(SearchIconWrap, { isShow: isShow, isHomepage: isHomepage },
                    react.createElement(icons/* IconSearch */.jV, { width: 20, height: 20, fill: Colors/* colors.primary.100 */.O9.primary[100] })))),
        react.createElement(ActionGroup, { isShow: isMobile && isMountedDropdown && isShow },
            react.createElement(Button/* default */.Z, { className: 'cancel__button', type: 'info', onClick: onClickCancel }, t('Cancel')))));
};
var SearchSection$1 = (0,react.memo)(SearchSection);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SearchBarUnstable/index.js
'use client';




















var DropdownContent = react.lazy(function () { return __webpack_require__.e(/* import() */ 70).then(__webpack_require__.bind(__webpack_require__, 40070)); });
var SearchBar = function (props) {
    var isMobile = props.isMobile, searchBarOptions = props.searchBarOptions, pageName = props.pageName, langCode = props.langCode, optionList = props.optionList, _a = props.domain, domain = _a === void 0 ? '' : _a;
    var mergedSearchBarOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, SearchBarUnstable_constants/* DEFAULT_SEARCH_BAR_OPTIONS */.Uj), searchBarOptions);
    var _b = (0,react.useReducer)(reducer/* searchBarReducer */.V, context/* initialSearchBar */.n), state = _b[0], dispatch = _b[1];
    var isShow = state.isShow, keyword = state.keyword, locations = state.locations, forceControllDropdown = state.forceControllDropdown;
    var tracking = (0,useHog/* default */.Z)().tracking;
    // State
    var _c = (0,react.useState)(false), isMountedDropdown = _c[0], setMountedDropdown = _c[1];
    var _d = (0,react.useState)(-1), initialWidth = _d[0], setInitialWidth = _d[1];
    var _e = (0,react.useState)(false), isMountedSearchBar = _e[0], setMountedSearchBar = _e[1];
    var searchBarContentRef = (0,react.useRef)(null);
    var searchBarWrapperRef = (0,react.useRef)(null);
    var dropdownContentOverflowRef = (0,react.useRef)(null);
    var isSearchOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: searchBarWrapperRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var t = (0,react.useCallback)(function (text) {
        var _a;
        if (props.langCode === 'en') {
            return text;
        }
        else {
            return (_a = SearchBarUnstable_translation_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    }, [props.langCode]);
    var search = (0,react.useCallback)(function (params) {
        var _a;
        if (params === void 0) { params = {}; }
        var _b = params.withKeyword, withKeyword = _b === void 0 ? '' : _b, _c = params.withJobFunction, withJobFunction = _c === void 0 ? [] : _c, _d = params.onlyFillInput, onlyFillInput = _d === void 0 ? false : _d;
        var localStorageParams = (0,searchbarHelpers/* getLocalStorage */.$o)('params', '');
        // VNW-30947 remove special word
        var searchKeyword = (_a = keyword === null || keyword === void 0 ? void 0 : keyword.toLowerCase().replace(/[`~,/':;\\"\s]+/g, ' ')) !== null && _a !== void 0 ? _a : '';
        if (withKeyword !== '') {
            searchKeyword = withKeyword === null || withKeyword === void 0 ? void 0 : withKeyword.toLowerCase();
        }
        var searchUrl = t('/job-search/all-jobs');
        var latinKeyword = (0,helpers/* transformToLatin */.nr)(searchKeyword).replace(/ +/g, ' ');
        if (searchKeyword !== latinKeyword && mergedSearchBarOptions.isNeedNavigate) {
            searchKeyword = latinKeyword;
        }
        var searchLocations = locations;
        searchUrl = "".concat(domain).concat((0,searchbarHelpers/* buildSearchUrl */.aH)(searchKeyword, searchLocations, langCode));
        if (typeof window !== 'undefined' && searchKeyword === '') {
            if (localStorageParams !== undefined && localStorageParams !== null) {
                localStorageParams.query = '';
            }
            localStorage.setItem('params', JSON.stringify(localStorageParams));
        }
        // update cookies
        var locationsIds = searchLocations === null || searchLocations === void 0 ? void 0 : searchLocations.map(function (e) { return e.parentId; });
        if (locationsIds.length > 0) {
            (0,cookie/* setCookie */.d)(SearchBarUnstable_constants/* VNW_SEARCH_JOB_CITY_COOKIE_NAME */.Kr, locationsIds === null || locationsIds === void 0 ? void 0 : locationsIds.join(','), 30);
        }
        else {
            (0,cookie/* setCookie */.d)(SearchBarUnstable_constants/* VNW_SEARCH_JOB_CITY_COOKIE_NAME */.Kr, 'all', 30);
        }
        var districtId = (0,searchbarHelpers/* getDistrictIdFromLocations */.Ak)(searchLocations);
        tracking({
            eventName: 'js_search_result_page:search_button_click',
            properties: {
                keyword: keyword,
                filterLocationCityId: locationsIds,
                filterLocationDistrictId: districtId
            }
        });
        if (mergedSearchBarOptions.isNeedNavigate) {
            // Delay 300ms for finished transition
            // (UX: make user feeling smooth when navigating to search page)
            setTimeout(function () {
                var _a;
                // update localStorage search params
                if (localStorageParams !== undefined && localStorageParams !== null) {
                    localStorageParams.query = searchKeyword;
                    localStorageParams.locationId = (_a = searchLocations.map(function (item) { return item.parentId; })) !== null && _a !== void 0 ? _a : [];
                    localStorageParams.locations = searchLocations;
                    localStorageParams.districtId = districtId;
                }
                localStorage.setItem('params', JSON.stringify(localStorageParams));
                (0,searchbarHelpers/* changeLocation */.zF)(searchUrl, false, onlyFillInput);
            }, 300);
        }
        else {
            // for page-container, the page should stay
            if (!onlyFillInput) {
                if (typeof window === 'undefined') {
                    return;
                }
                var params_1 = {
                    query: searchKeyword,
                    page: 0
                };
                params_1.locationId = searchLocations.map(function (item) { return item.parentId; }) || [];
                params_1.districtId = districtId || [];
                params_1.locations = searchLocations || [];
                if (withJobFunction && withJobFunction.length > 0) {
                    params_1.jobFunctionId = withJobFunction;
                }
                var searchEvent = new CustomEvent('SEARCH', {
                    detail: {
                        params: params_1,
                        from: 'AppShell > SearchBar > Search',
                        hideFilter: true,
                        clearCurrentParams: false
                    }
                });
                window.dispatchEvent(searchEvent);
                // await 500ms then get recent keyword
                setTimeout(function () {
                    var recentSearchList = (0,searchbarHelpers/* getLocalStorage */.$o)(SearchBarUnstable_constants/* RECENT_SEARCH */.Mt, '');
                    dispatch({
                        type: actions/* ACTIONS.SET_RECENT_KEYWORDS */.a.SET_RECENT_KEYWORDS,
                        payload: Array.isArray(recentSearchList) ? recentSearchList.reverse() : []
                    });
                }, 500);
            }
        }
        dispatch({
            type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
            payload: context_types/* EForceControDropdown.CLOSE_ALL */.q.CLOSE_ALL
        });
    }, [domain, keyword, langCode, locations, mergedSearchBarOptions.isNeedNavigate, optionList, t]);
    var handleAnimationEnd = function () {
        if (isShow) {
            return;
        }
        setMountedDropdown(false);
    };
    (0,react.useEffect)(function () {
        if (!isShow) {
            setMountedDropdown(false);
            return;
        }
        setMountedDropdown(forceControllDropdown === context_types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT || isShow);
    }, [forceControllDropdown, isShow]);
    (0,react.useEffect)(function () {
        if (initialWidth !== -1) {
            return;
        }
        var calculateInitialWidth = function () {
            var _a;
            if (!searchBarContentRef.current) {
                return;
            }
            var initWidth = (_a = searchBarContentRef === null || searchBarContentRef === void 0 ? void 0 : searchBarContentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
            if (!mergedSearchBarOptions.isHomepage && !isMobile) {
                initWidth -= 2;
            }
            if (isMobile && pageName !== 'searchResult') {
                initWidth = 40;
            }
            if (isMobile && pageName === 'searchResult') {
                initWidth = -1;
            }
            setInitialWidth(initWidth);
        };
        setTimeout(function () {
            calculateInitialWidth();
        }, 300);
    }, [searchBarContentRef, initialWidth, mergedSearchBarOptions.isHomepage, isMobile, pageName]);
    (0,react.useEffect)(function () {
        if (!isShow) {
            return;
        }
        if (isSearchOnScreen) {
            return;
        }
        if (isMobile) {
            return;
        }
        dispatch({
            type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
        });
    }, [isSearchOnScreen, isMobile, isShow]);
    var handleOnEventSearch = function (e) {
        var _a, _b, _c;
        var searchEvent = e;
        var query = (_c = (_b = (_a = searchEvent === null || searchEvent === void 0 ? void 0 : searchEvent.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.query) !== null && _c !== void 0 ? _c : '';
        if (query === '' || isShow) {
            return;
        }
        dispatch({
            type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
            payload: query
        });
    };
    (0,react.useEffect)(function () {
        var onWindowResize = function () {
            setInitialWidth(-1);
        };
        var setKeywordFromLocalStorage = function () {
            var queryKeyword = (0,searchbarHelpers/* getLocalStorage */.$o)('params', 'query');
            if (queryKeyword === '') {
                return;
            }
            dispatch({
                type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
                payload: queryKeyword
            });
        };
        // This setTimeout is used for preventing layout shifting
        // when component first render
        setTimeout(function () {
            setMountedSearchBar(true);
            setKeywordFromLocalStorage();
        }, 50);
        // Listen on Resize to make initialWidth responsive
        window.addEventListener('resize', onWindowResize);
        window.addEventListener('SEARCH', handleOnEventSearch);
        return function () {
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('SEARCH', handleOnEventSearch);
        };
    }, [searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate]);
    return (react.createElement(reducer/* SearchBarContext.Provider */.O.Provider, { value: {
            state: (0,_tslib/* __assign */.pi)({}, state),
            props: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, props), { searchBarOptions: mergedSearchBarOptions }),
            t: t,
            search: search,
            dispatch: dispatch
        } },
        react.createElement(SearchBarContentWrapper, { "data-cname": 'SearchBarContentWrapper', isHomepage: mergedSearchBarOptions.isHomepage, ref: searchBarContentRef },
            react.createElement(SearchBackground$1, null),
            react.createElement(SearchBlockHolder, { isMountedDropdown: isMountedDropdown, isShow: isShow, isHomepage: mergedSearchBarOptions.isHomepage, isMobile: isMobile }),
            react.createElement(SearchBarWrapper, { isShow: isShow, isMobile: isMobile, isHomepage: mergedSearchBarOptions.isHomepage, isMountedDropdown: isMountedDropdown, "data-id": 'search-bar', ref: searchBarWrapperRef },
                react.createElement(SearchBarContent, { "data-cname": 'SearchBarContent', isMounted: isMountedSearchBar, isMountedDropdown: isMountedDropdown, isShow: isShow, isMobile: isMobile, initialWidth: initialWidth, isHomepage: mergedSearchBarOptions.isHomepage },
                    react.createElement(SearchSection$1, { isMountedDropdown: isMountedDropdown })),
                isMountedDropdown ? (react.createElement(DropDownContentOverflow, { isHidden: forceControllDropdown !== context_types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT, isMobile: isMobile, isHomepage: mergedSearchBarOptions.isHomepage, ref: dropdownContentOverflowRef },
                    react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                        react.createElement(DropdownContent, { dropdownContentOverflowRef: dropdownContentOverflowRef, onAnimationEnd: handleAnimationEnd })))) : null))));
};
var index = react.memo(SearchBar);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ShareButton/index.js + 2 modules
var ShareButton = __webpack_require__(32053);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tabs/styles/index.css.js
'use client';





var index_css_Container = styled_components_browser_esm/* default.div */.ZP.div(styles_index_css_templateObject_1 || (styles_index_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));
var TabWrap = styled_components_browser_esm/* default.div */.ZP.div(styles_index_css_templateObject_2 || (styles_index_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-bottom: 1px solid ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-bottom: 1px solid ", ";\n"])), constants/* colors.borderCard */.O9.borderCard);
var TabCss = styled_components_browser_esm/* default.div */.ZP.div(styles_index_css_templateObject_3 || (styles_index_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: max-content;\n    padding: 10px 20px;\n    cursor: ", ";\n    opacity: ", ";\n    position: relative;\n    text-align: center;\n    span {\n        text-transform: uppercase;\n        color: ", ";\n        font-weight: ", ";\n    }\n    &::before {\n        content: '';\n        display: ", ";\n        transition: all 0.25;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 2px;\n        background-color: ", ";\n    }\n    @media screen and (max-width: 768px) {\n        flex: 1;\n    }\n"], ["\n    width: max-content;\n    padding: 10px 20px;\n    cursor: ", ";\n    opacity: ", ";\n    position: relative;\n    text-align: center;\n    span {\n        text-transform: uppercase;\n        color: ", ";\n        font-weight: ", ";\n    }\n    &::before {\n        content: '';\n        display: ", ";\n        transition: all 0.25;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 2px;\n        background-color: ", ";\n    }\n    @media screen and (max-width: 768px) {\n        flex: 1;\n    }\n"])), function (props) { return (props.disable ? 'not-allowed' : 'pointer'); }, function (props) { return (props.disable ? 0.5 : 1); }, function (props) { return (props.active ? constants/* colors.primaryColor */.O9.primaryColor : constants/* colors.textColor */.O9.textColor); }, function (props) { return (props.active ? 'bold' : 'normal'); }, function (props) { return (props.active ? 'block' : 'none'); }, constants/* colors.primaryColor */.O9.primaryColor);
var PanelWrap = styled_components_browser_esm/* default.div */.ZP.div(styles_index_css_templateObject_4 || (styles_index_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var PanelCss = styled_components_browser_esm/* default.div */.ZP.div(styles_index_css_templateObject_5 || (styles_index_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 1000%;\n"], ["\n    width: 100%;\n    height: 1000%;\n"])));
var styles_index_css_templateObject_1, styles_index_css_templateObject_2, styles_index_css_templateObject_3, styles_index_css_templateObject_4, styles_index_css_templateObject_5;


//# sourceMappingURL=index.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tabs/components/Tab.js
'use client';




function Tab(_a) {
    var label = _a.label, id = _a.id, onChangeTab = _a.onChangeTab, active = _a.active, disable = _a.disable;
    return (react.createElement(TabCss, { active: active, disable: disable, onClick: function () { return !disable && onChangeTab(id); } },
        react.createElement("span", null, label)));
}


//# sourceMappingURL=Tab.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tabs/components/Panel.js
'use client';




function Panel(_a) {
    var children = _a.children;
    return react.createElement(PanelCss, null, children);
}


//# sourceMappingURL=Panel.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Tabs/index.js
'use client';






function Tabs_Tabs(_a) {
    var labels = _a.labels, contentPanels = _a.contentPanels, autoActive = _a.autoActive, disableTabs = _a.disableTabs;
    var _b = (0,react.useState)(autoActive !== null && autoActive !== void 0 ? autoActive : 0), indexTab = _b[0], setIndexTab = _b[1];
    var onChangeTab = function (index) {
        setIndexTab(index);
    };
    return (react.createElement(index_css_Container, null,
        react.createElement(TabWrap, null, labels.map(function (item, index) {
            var _a;
            return (react.createElement(Tab, { disable: (_a = (disableTabs && disableTabs.includes(index))) !== null && _a !== void 0 ? _a : false, active: index === indexTab, label: item, id: index, key: "".concat(item, "_").concat(index), onChangeTab: onChangeTab }));
        })),
        react.createElement(PanelWrap, null, contentPanels.map(function (content, index) {
            if (index !== indexTab)
                return;
            return react.createElement(Panel, { key: index }, content);
        }))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TagBasic/styles.js
'use client';





var styles_STContainer = styled_components_browser_esm/* default.div */.ZP.div(TagBasic_styles_templateObject_1 || (TagBasic_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 30px;\n    padding: 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    line-height: 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    &.customBg {\n        background: ", ";\n    }\n"], ["\n    height: 30px;\n    padding: 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    line-height: 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    ", "\n\n    &.customBg {\n        background: ", ";\n    }\n"])), function (_a) {
    var isActive = _a.isActive;
    return "\n        background: ".concat(isActive ? '#EBF2FF' : '#fff', " ;\n        border: ").concat(isActive ? '1px solid rgba(0, 90, 255, 0.2)' : 'unset', ";\n        color: ").concat(isActive ? constants/* colors.primaryColor */.O9.primaryColor : constants/* colors.textColor */.O9.textColor, ";\n        font-weight: ").concat(isActive ? 500 : 400, ";\n    ");
}, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? '#EBF2FF' : '#F1F2F4');
});
var TagBasic_styles_templateObject_1;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TagBasic/index.js
'use client';





var TagBasic = function (_a) {
    var props = (0,_tslib/* __rest */._T)(_a, []);
    return (react.createElement(styles_STContainer, { isActive: props.isActive, onClick: function () { return props.onClick(props.value); }, className: "".concat(props === null || props === void 0 ? void 0 : props.className, " ").concat(props.isActive ? 'active' : '') }, props.children));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditorQuill/TextEditorQuill.css.js
'use client';




var orangeColor = '#FF7D55';
var textColor = '#808080';
var blueColor = '#005AFF';
var TextEditorQuillWrapper = /*#__PURE__*/ styled_components_browser_esm/* default.div */.ZP.div(TextEditorQuill_css_templateObject_2 || (TextEditorQuill_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    div[class*='ql-toolbar ql-snow'] {\n        border-radius: 3px 3px 0 0;\n        border: 1px solid #ddd;\n        border-bottom: none !important;\n    }\n    div[class*='ql-container ql-snow'] {\n        border-radius: 0 0 3px 3px;\n        border: 1px solid #ddd;\n    }\n    div[class*='ql-editor'] {\n        padding-top: 0 !important;\n        max-height: ", ";\n        &::before {\n            content: ", ";\n        }\n    }\n    span[class*='ql-formats'] {\n        margin-right: 0 !important;\n        &::after {\n            content: ' ';\n            display: inline-flex;\n            width: 1px;\n            height: 21px;\n            margin: 2px 10px;\n            background-color: #ddd;\n        }\n        &:last-child {\n            &::after {\n                display: none;\n            }\n        }\n    }\n    button {\n        border-radius: 3px;\n        border: 1px solid #ccc !important;\n        width: 25px !important;\n        height: 25px !important;\n        display: flex !important;\n        padding: 4px !important;\n        margin: 0 4px;\n        color: rgb(128, 128, 128);\n        svg {\n            path,\n            line {\n                stroke: ", " !important;\n            }\n            rect {\n                fill: ", " !important;\n            }\n        }\n    }\n    button:hover,\n    button[class*='ql-active'] {\n        color: ", " !important;\n        border: 1px solid ", " !important;\n        svg {\n            path,\n            line {\n                stroke: ", " !important;\n            }\n            rect {\n                fill: ", " !important;\n            }\n        }\n    }\n    a {\n        color: ", " !important;\n    }\n"], ["\n    div[class*='ql-toolbar ql-snow'] {\n        border-radius: 3px 3px 0 0;\n        border: 1px solid #ddd;\n        border-bottom: none !important;\n    }\n    div[class*='ql-container ql-snow'] {\n        border-radius: 0 0 3px 3px;\n        border: 1px solid #ddd;\n    }\n    div[class*='ql-editor'] {\n        padding-top: 0 !important;\n        max-height: ", ";\n        &::before {\n            content: ", ";\n        }\n    }\n    span[class*='ql-formats'] {\n        margin-right: 0 !important;\n        &::after {\n            content: ' ';\n            display: inline-flex;\n            width: 1px;\n            height: 21px;\n            margin: 2px 10px;\n            background-color: #ddd;\n        }\n        &:last-child {\n            &::after {\n                display: none;\n            }\n        }\n    }\n    button {\n        border-radius: 3px;\n        border: 1px solid #ccc !important;\n        width: 25px !important;\n        height: 25px !important;\n        display: flex !important;\n        padding: 4px !important;\n        margin: 0 4px;\n        color: rgb(128, 128, 128);\n        svg {\n            path,\n            line {\n                stroke: ", " !important;\n            }\n            rect {\n                fill: ", " !important;\n            }\n        }\n    }\n    button:hover,\n    button[class*='ql-active'] {\n        color: ", " !important;\n        border: 1px solid ", " !important;\n        svg {\n            path,\n            line {\n                stroke: ", " !important;\n            }\n            rect {\n                fill: ", " !important;\n            }\n        }\n    }\n    a {\n        color: ", " !important;\n    }\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return "".concat(maxHeight, "px") || 0;
}, function (_a) {
    var placeholder = _a.placeholder;
    return placeholder;
}, textColor, textColor, orangeColor, orangeColor, orangeColor, orangeColor, blueColor);
var QuillSnowCss = /*#__PURE__*/ styled_components_browser_esm/* default.div */.ZP.div(TextEditorQuill_css_templateObject_1 || (TextEditorQuill_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([void 0], ["\n    /*!\n    * Quill Editor v1.3.7\n    * https://quilljs.com/\n    * Copyright (c) 2014, Jason Chen\n    * Copyright (c) 2013, salesforce.com\n    */\n    .ql-container {\n        box-sizing: border-box;\n        font-family: Helvetica, Arial, sans-serif;\n        font-size: 13px;\n        height: 100%;\n        margin: 0px;\n        position: relative;\n    }\n    .ql-container.ql-disabled .ql-tooltip {\n        visibility: hidden;\n    }\n    .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n        pointer-events: none;\n    }\n    .ql-clipboard {\n        left: -100000px;\n        height: 1px;\n        overflow-y: hidden;\n        position: absolute;\n        top: 50%;\n    }\n    .ql-clipboard p {\n        margin: 0;\n        padding: 0;\n    }\n    .ql-editor {\n        box-sizing: border-box;\n        line-height: 1.42;\n        height: 100%;\n        outline: none;\n        overflow-y: auto;\n        padding: 12px 15px;\n        tab-size: 4;\n        -moz-tab-size: 4;\n        text-align: left;\n        white-space: pre-wrap;\n        word-wrap: break-word;\n    }\n    .ql-editor > * {\n        cursor: text;\n    }\n    .ql-editor p,\n    .ql-editor ol,\n    .ql-editor ul,\n    .ql-editor pre,\n    .ql-editor blockquote,\n    .ql-editor h1,\n    .ql-editor h2,\n    .ql-editor h3,\n    .ql-editor h4,\n    .ql-editor h5,\n    .ql-editor h6 {\n        margin: 0;\n        padding: 0;\n        counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol,\n    .ql-editor ul {\n        padding-left: 1.5em;\n    }\n    .ql-editor ol > li,\n    .ql-editor ul > li {\n        list-style-type: none;\n    }\n    .ql-editor ul > li::before {\n        content: '\\\\2022';\n    }\n    .ql-editor ul[data-checked='true'],\n    .ql-editor ul[data-checked='false'] {\n        pointer-events: none;\n    }\n    .ql-editor ul[data-checked='true'] > li *,\n    .ql-editor ul[data-checked='false'] > li * {\n        pointer-events: all;\n    }\n    .ql-editor ul[data-checked='true'] > li::before,\n    .ql-editor ul[data-checked='false'] > li::before {\n        color: #777;\n        cursor: pointer;\n        pointer-events: all;\n    }\n    .ql-editor ul[data-checked='true'] > li::before {\n        content: '\\2611';\n    }\n    .ql-editor ul[data-checked='false'] > li::before {\n        content: '\\2610';\n    }\n    .ql-editor li::before {\n        display: inline-block;\n        white-space: nowrap;\n        width: 1.2em;\n    }\n    .ql-editor li:not(.ql-direction-rtl)::before {\n        margin-left: -1.5em;\n        margin-right: 0.3em;\n        text-align: right;\n    }\n    .ql-editor li.ql-direction-rtl::before {\n        margin-left: 0.3em;\n        margin-right: -1.5em;\n    }\n    .ql-editor ol li:not(.ql-direction-rtl),\n    .ql-editor ul li:not(.ql-direction-rtl) {\n        padding-left: 1.5em;\n    }\n    .ql-editor ol li.ql-direction-rtl,\n    .ql-editor ul li.ql-direction-rtl {\n        padding-right: 1.5em;\n    }\n    .ql-editor ol li {\n        counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n        counter-increment: list-0;\n    }\n    .ql-editor ol li:before {\n        content: counter(list-0, decimal) '. ';\n    }\n    .ql-editor ol li.ql-indent-1 {\n        counter-increment: list-1;\n    }\n    .ql-editor ol li.ql-indent-1:before {\n        content: counter(list-1, lower-alpha) '. ';\n    }\n    .ql-editor ol li.ql-indent-1 {\n        counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-2 {\n        counter-increment: list-2;\n    }\n    .ql-editor ol li.ql-indent-2:before {\n        content: counter(list-2, lower-roman) '. ';\n    }\n    .ql-editor ol li.ql-indent-2 {\n        counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-3 {\n        counter-increment: list-3;\n    }\n    .ql-editor ol li.ql-indent-3:before {\n        content: counter(list-3, decimal) '. ';\n    }\n    .ql-editor ol li.ql-indent-3 {\n        counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-4 {\n        counter-increment: list-4;\n    }\n    .ql-editor ol li.ql-indent-4:before {\n        content: counter(list-4, lower-alpha) '. ';\n    }\n    .ql-editor ol li.ql-indent-4 {\n        counter-reset: list-5 list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-5 {\n        counter-increment: list-5;\n    }\n    .ql-editor ol li.ql-indent-5:before {\n        content: counter(list-5, lower-roman) '. ';\n    }\n    .ql-editor ol li.ql-indent-5 {\n        counter-reset: list-6 list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-6 {\n        counter-increment: list-6;\n    }\n    .ql-editor ol li.ql-indent-6:before {\n        content: counter(list-6, decimal) '. ';\n    }\n    .ql-editor ol li.ql-indent-6 {\n        counter-reset: list-7 list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-7 {\n        counter-increment: list-7;\n    }\n    .ql-editor ol li.ql-indent-7:before {\n        content: counter(list-7, lower-alpha) '. ';\n    }\n    .ql-editor ol li.ql-indent-7 {\n        counter-reset: list-8 list-9;\n    }\n    .ql-editor ol li.ql-indent-8 {\n        counter-increment: list-8;\n    }\n    .ql-editor ol li.ql-indent-8:before {\n        content: counter(list-8, lower-roman) '. ';\n    }\n    .ql-editor ol li.ql-indent-8 {\n        counter-reset: list-9;\n    }\n    .ql-editor ol li.ql-indent-9 {\n        counter-increment: list-9;\n    }\n    .ql-editor ol li.ql-indent-9:before {\n        content: counter(list-9, decimal) '. ';\n    }\n    .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n        padding-left: 3em;\n    }\n    .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n        padding-left: 4.5em;\n    }\n    .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n        padding-right: 3em;\n    }\n    .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n        padding-right: 4.5em;\n    }\n    .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n        padding-left: 6em;\n    }\n    .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n        padding-left: 7.5em;\n    }\n    .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n        padding-right: 6em;\n    }\n    .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n        padding-right: 7.5em;\n    }\n    .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n        padding-left: 9em;\n    }\n    .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n        padding-left: 10.5em;\n    }\n    .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n        padding-right: 9em;\n    }\n    .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n        padding-right: 10.5em;\n    }\n    .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n        padding-left: 12em;\n    }\n    .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n        padding-left: 13.5em;\n    }\n    .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n        padding-right: 12em;\n    }\n    .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n        padding-right: 13.5em;\n    }\n    .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n        padding-left: 15em;\n    }\n    .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n        padding-left: 16.5em;\n    }\n    .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n        padding-right: 15em;\n    }\n    .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n        padding-right: 16.5em;\n    }\n    .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n        padding-left: 18em;\n    }\n    .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n        padding-left: 19.5em;\n    }\n    .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n        padding-right: 18em;\n    }\n    .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n        padding-right: 19.5em;\n    }\n    .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n        padding-left: 21em;\n    }\n    .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n        padding-left: 22.5em;\n    }\n    .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n        padding-right: 21em;\n    }\n    .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n        padding-right: 22.5em;\n    }\n    .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n        padding-left: 24em;\n    }\n    .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n        padding-left: 25.5em;\n    }\n    .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n        padding-right: 24em;\n    }\n    .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n        padding-right: 25.5em;\n    }\n    .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n        padding-left: 27em;\n    }\n    .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n        padding-left: 28.5em;\n    }\n    .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n        padding-right: 27em;\n    }\n    .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n        padding-right: 28.5em;\n    }\n    .ql-editor .ql-video {\n        display: block;\n        max-width: 100%;\n    }\n    .ql-editor .ql-video.ql-align-center {\n        margin: 0 auto;\n    }\n    .ql-editor .ql-video.ql-align-right {\n        margin: 0 0 0 auto;\n    }\n    .ql-editor .ql-bg-black {\n        background-color: #000;\n    }\n    .ql-editor .ql-bg-red {\n        background-color: #e60000;\n    }\n    .ql-editor .ql-bg-orange {\n        background-color: #f90;\n    }\n    .ql-editor .ql-bg-yellow {\n        background-color: #ff0;\n    }\n    .ql-editor .ql-bg-green {\n        background-color: #008a00;\n    }\n    .ql-editor .ql-bg-blue {\n        background-color: #06c;\n    }\n    .ql-editor .ql-bg-purple {\n        background-color: #93f;\n    }\n    .ql-editor .ql-color-white {\n        color: #fff;\n    }\n    .ql-editor .ql-color-red {\n        color: #e60000;\n    }\n    .ql-editor .ql-color-orange {\n        color: #f90;\n    }\n    .ql-editor .ql-color-yellow {\n        color: #ff0;\n    }\n    .ql-editor .ql-color-green {\n        color: #008a00;\n    }\n    .ql-editor .ql-color-blue {\n        color: #06c;\n    }\n    .ql-editor .ql-color-purple {\n        color: #93f;\n    }\n    .ql-editor .ql-font-serif {\n        font-family: Georgia, Times New Roman, serif;\n    }\n    .ql-editor .ql-font-monospace {\n        font-family: Monaco, Courier New, monospace;\n    }\n    .ql-editor .ql-size-small {\n        font-size: 0.75em;\n    }\n    .ql-editor .ql-size-large {\n        font-size: 1.5em;\n    }\n    .ql-editor .ql-size-huge {\n        font-size: 2.5em;\n    }\n    .ql-editor .ql-direction-rtl {\n        direction: rtl;\n        text-align: inherit;\n    }\n    .ql-editor .ql-align-center {\n        text-align: center;\n    }\n    .ql-editor .ql-align-justify {\n        text-align: justify;\n    }\n    .ql-editor .ql-align-right {\n        text-align: right;\n    }\n    .ql-editor.ql-blank::before {\n        color: rgba(0, 0, 0, 0.6);\n        content: attr(data-placeholder);\n        font-style: italic;\n        left: 15px;\n        pointer-events: none;\n        position: absolute;\n        right: 15px;\n    }\n    .ql-snow.ql-toolbar:after,\n    .ql-snow .ql-toolbar:after {\n        clear: both;\n        content: '';\n        display: table;\n    }\n    .ql-snow.ql-toolbar button,\n    .ql-snow .ql-toolbar button {\n        background: none;\n        border: none;\n        cursor: pointer;\n        display: inline-block;\n        float: left;\n        height: 24px;\n        padding: 3px 5px;\n        width: 28px;\n    }\n    .ql-snow.ql-toolbar button svg,\n    .ql-snow .ql-toolbar button svg {\n        float: left;\n        height: 100%;\n    }\n    .ql-snow.ql-toolbar button:active:hover,\n    .ql-snow .ql-toolbar button:active:hover {\n        outline: none;\n    }\n    .ql-snow.ql-toolbar input.ql-image[type='file'],\n    .ql-snow .ql-toolbar input.ql-image[type='file'] {\n        display: none;\n    }\n    .ql-snow.ql-toolbar button:hover,\n    .ql-snow .ql-toolbar button:hover,\n    .ql-snow.ql-toolbar button:focus,\n    .ql-snow .ql-toolbar button:focus,\n    .ql-snow.ql-toolbar button.ql-active,\n    .ql-snow .ql-toolbar button.ql-active,\n    .ql-snow.ql-toolbar .ql-picker-label:hover,\n    .ql-snow .ql-toolbar .ql-picker-label:hover,\n    .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n    .ql-snow .ql-toolbar .ql-picker-label.ql-active,\n    .ql-snow.ql-toolbar .ql-picker-item:hover,\n    .ql-snow .ql-toolbar .ql-picker-item:hover,\n    .ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n    .ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n        color: #06c;\n    }\n    .ql-snow.ql-toolbar button:hover .ql-fill,\n    .ql-snow .ql-toolbar button:hover .ql-fill,\n    .ql-snow.ql-toolbar button:focus .ql-fill,\n    .ql-snow .ql-toolbar button:focus .ql-fill,\n    .ql-snow.ql-toolbar button.ql-active .ql-fill,\n    .ql-snow .ql-toolbar button.ql-active .ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n    .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n        fill: #06c;\n    }\n    .ql-snow.ql-toolbar button:hover .ql-stroke,\n    .ql-snow .ql-toolbar button:hover .ql-stroke,\n    .ql-snow.ql-toolbar button:focus .ql-stroke,\n    .ql-snow .ql-toolbar button:focus .ql-stroke,\n    .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n    .ql-snow .ql-toolbar button.ql-active .ql-stroke,\n    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n    .ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n    .ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n    .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n    .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n        stroke: #06c;\n    }\n    @media (pointer: coarse) {\n        .ql-snow.ql-toolbar button:hover:not(.ql-active),\n        .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n            color: #444;\n        }\n        .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n        .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n        .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n        .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n            fill: #444;\n        }\n        .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n        .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n        .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n        .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n            stroke: #444;\n        }\n    }\n    .ql-snow {\n        box-sizing: border-box;\n    }\n    .ql-snow * {\n        box-sizing: border-box;\n    }\n    .ql-snow .ql-hidden {\n        display: none;\n    }\n    .ql-snow .ql-out-bottom,\n    .ql-snow .ql-out-top {\n        visibility: hidden;\n    }\n    .ql-snow .ql-tooltip {\n        position: absolute;\n        transform: translateY(10px);\n    }\n    .ql-snow .ql-tooltip a {\n        cursor: pointer;\n        text-decoration: none;\n    }\n    .ql-snow .ql-tooltip.ql-flip {\n        transform: translateY(-10px);\n    }\n    .ql-snow .ql-formats {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    .ql-snow .ql-stroke {\n        fill: none;\n        stroke: #444;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2;\n    }\n    .ql-snow .ql-stroke-miter {\n        fill: none;\n        stroke: #444;\n        stroke-miterlimit: 10;\n        stroke-width: 2;\n    }\n    .ql-snow .ql-fill,\n    .ql-snow .ql-stroke.ql-fill {\n        fill: #444;\n    }\n    .ql-snow .ql-empty {\n        fill: none;\n    }\n    .ql-snow .ql-even {\n        fill-rule: evenodd;\n    }\n    .ql-snow .ql-thin,\n    .ql-snow .ql-stroke.ql-thin {\n        stroke-width: 1;\n    }\n    .ql-snow .ql-transparent {\n        opacity: 0.4;\n    }\n    .ql-snow .ql-direction svg:last-child {\n        display: none;\n    }\n    .ql-snow .ql-direction.ql-active svg:last-child {\n        display: inline;\n    }\n    .ql-snow .ql-direction.ql-active svg:first-child {\n        display: none;\n    }\n    .ql-snow .ql-editor h1 {\n        font-size: 2em;\n    }\n    .ql-snow .ql-editor h2 {\n        font-size: 1.5em;\n    }\n    .ql-snow .ql-editor h3 {\n        font-size: 1.17em;\n    }\n    .ql-snow .ql-editor h4 {\n        font-size: 1em;\n    }\n    .ql-snow .ql-editor h5 {\n        font-size: 0.83em;\n    }\n    .ql-snow .ql-editor h6 {\n        font-size: 0.67em;\n    }\n    .ql-snow .ql-editor a {\n        text-decoration: underline;\n    }\n    .ql-snow .ql-editor blockquote {\n        border-left: 4px solid #ccc;\n        margin-bottom: 5px;\n        margin-top: 5px;\n        padding-left: 16px;\n    }\n    .ql-snow .ql-editor code,\n    .ql-snow .ql-editor pre {\n        background-color: #f0f0f0;\n        border-radius: 3px;\n    }\n    .ql-snow .ql-editor pre {\n        white-space: pre-wrap;\n        margin-bottom: 5px;\n        margin-top: 5px;\n        padding: 5px 10px;\n    }\n    .ql-snow .ql-editor code {\n        font-size: 85%;\n        padding: 2px 4px;\n    }\n    .ql-snow .ql-editor pre.ql-syntax {\n        background-color: #23241f;\n        color: #f8f8f2;\n        overflow: visible;\n    }\n    .ql-snow .ql-editor img {\n        max-width: 100%;\n    }\n    .ql-snow .ql-picker {\n        color: #444;\n        display: inline-block;\n        float: left;\n        font-size: 14px;\n        font-weight: 500;\n        height: 24px;\n        position: relative;\n        vertical-align: middle;\n    }\n    .ql-snow .ql-picker-label {\n        cursor: pointer;\n        display: inline-block;\n        height: 100%;\n        padding-left: 8px;\n        padding-right: 2px;\n        position: relative;\n        width: 100%;\n    }\n    .ql-snow .ql-picker-label::before {\n        display: inline-block;\n        line-height: 22px;\n    }\n    .ql-snow .ql-picker-options {\n        background-color: #fff;\n        display: none;\n        min-width: 100%;\n        padding: 4px 8px;\n        position: absolute;\n        white-space: nowrap;\n    }\n    .ql-snow .ql-picker-options .ql-picker-item {\n        cursor: pointer;\n        display: block;\n        padding-bottom: 5px;\n        padding-top: 5px;\n    }\n    .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n        color: #ccc;\n        z-index: 2;\n    }\n    .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n        fill: #ccc;\n    }\n    .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n        stroke: #ccc;\n    }\n    .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n        display: block;\n        margin-top: -1px;\n        top: 100%;\n        z-index: 1;\n    }\n    .ql-snow .ql-color-picker,\n    .ql-snow .ql-icon-picker {\n        width: 28px;\n    }\n    .ql-snow .ql-color-picker .ql-picker-label,\n    .ql-snow .ql-icon-picker .ql-picker-label {\n        padding: 2px 4px;\n    }\n    .ql-snow .ql-color-picker .ql-picker-label svg,\n    .ql-snow .ql-icon-picker .ql-picker-label svg {\n        right: 4px;\n    }\n    .ql-snow .ql-icon-picker .ql-picker-options {\n        padding: 4px 0px;\n    }\n    .ql-snow .ql-icon-picker .ql-picker-item {\n        height: 24px;\n        width: 24px;\n        padding: 2px 4px;\n    }\n    .ql-snow .ql-color-picker .ql-picker-options {\n        padding: 3px 5px;\n        width: 152px;\n    }\n    .ql-snow .ql-color-picker .ql-picker-item {\n        border: 1px solid transparent;\n        float: left;\n        height: 16px;\n        margin: 2px;\n        padding: 0px;\n        width: 16px;\n    }\n    .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n        position: absolute;\n        margin-top: -9px;\n        right: 0;\n        top: 50%;\n        width: 18px;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n    .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n    .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n        content: attr(data-label);\n    }\n    .ql-snow .ql-picker.ql-header {\n        width: 98px;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item::before {\n        content: 'Normal';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n        content: 'Heading 1';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n        content: 'Heading 2';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n        content: 'Heading 3';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n        content: 'Heading 4';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n        content: 'Heading 5';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n        content: 'Heading 6';\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n        font-size: 2em;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n        font-size: 1.5em;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n        font-size: 1.17em;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n        font-size: 1em;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n        font-size: 0.83em;\n    }\n    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n        font-size: 0.67em;\n    }\n    .ql-snow .ql-picker.ql-font {\n        width: 108px;\n    }\n    .ql-snow .ql-picker.ql-font .ql-picker-label::before,\n    .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n        content: 'Sans Serif';\n    }\n    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,\n    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n        content: 'Serif';\n    }\n    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,\n    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n        content: 'Monospace';\n    }\n    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n        font-family: Georgia, Times New Roman, serif;\n    }\n    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n        font-family: Monaco, Courier New, monospace;\n    }\n    .ql-snow .ql-picker.ql-size {\n        width: 98px;\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-label::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n        content: 'Normal';\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n        content: 'Small';\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n        content: 'Large';\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n        content: 'Huge';\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n        font-size: 10px;\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n        font-size: 18px;\n    }\n    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n        font-size: 32px;\n    }\n    .ql-snow .ql-color-picker.ql-background .ql-picker-item {\n        background-color: #fff;\n    }\n    .ql-snow .ql-color-picker.ql-color .ql-picker-item {\n        background-color: #000;\n    }\n    .ql-toolbar.ql-snow {\n        border: 1px solid #ccc;\n        box-sizing: border-box;\n        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n        padding: 8px;\n    }\n    .ql-toolbar.ql-snow .ql-formats {\n        margin-right: 15px;\n    }\n    .ql-toolbar.ql-snow .ql-picker-label {\n        border: 1px solid transparent;\n    }\n    .ql-toolbar.ql-snow .ql-picker-options {\n        border: 1px solid transparent;\n        box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;\n    }\n    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n        border-color: #ccc;\n    }\n    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n        border-color: #ccc;\n    }\n    .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n    .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n        border-color: #000;\n    }\n    .ql-toolbar.ql-snow + .ql-container.ql-snow {\n        border-top: 0px;\n    }\n    .ql-snow .ql-tooltip {\n        background-color: #fff;\n        border: 1px solid #ccc;\n        box-shadow: 0px 0px 5px #ddd;\n        color: #444;\n        padding: 5px 12px;\n        white-space: nowrap;\n    }\n    .ql-snow .ql-tooltip::before {\n        content: 'Visit URL:';\n        line-height: 26px;\n        margin-right: 8px;\n    }\n    .ql-snow .ql-tooltip input[type='text'] {\n        display: none;\n        border: 1px solid #ccc;\n        font-size: 13px;\n        height: 26px;\n        margin: 0px;\n        padding: 3px 5px;\n        width: 170px;\n    }\n    .ql-snow .ql-tooltip a.ql-preview {\n        display: inline-block;\n        max-width: 200px;\n        overflow-x: hidden;\n        text-overflow: ellipsis;\n        vertical-align: top;\n    }\n    .ql-snow .ql-tooltip a.ql-action::after {\n        border-right: 1px solid #ccc;\n        content: 'Edit';\n        margin-left: 16px;\n        padding-right: 8px;\n    }\n    .ql-snow .ql-tooltip a.ql-remove::before {\n        content: 'Remove';\n        margin-left: 8px;\n    }\n    .ql-snow .ql-tooltip a {\n        line-height: 26px;\n    }\n    .ql-snow .ql-tooltip.ql-editing a.ql-preview,\n    .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n        display: none;\n    }\n    .ql-snow .ql-tooltip.ql-editing input[type='text'] {\n        display: inline-block;\n    }\n    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n        border-right: 0px;\n        content: 'Save';\n        padding-right: 0px;\n    }\n    .ql-snow .ql-tooltip[data-mode='link']::before {\n        content: 'Enter link:';\n    }\n    .ql-snow .ql-tooltip[data-mode='formula']::before {\n        content: 'Enter formula:';\n    }\n    .ql-snow .ql-tooltip[data-mode='video']::before {\n        content: 'Enter video:';\n    }\n    .ql-container.ql-snow {\n        border: 1px solid #ccc;\n    }\n"])));
var LimitCharacter = /*#__PURE__*/ styled_components_browser_esm/* default.div */.ZP.div(TextEditorQuill_css_templateObject_3 || (TextEditorQuill_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n    margin-top: 4px;\n    font-size: 12px;\n    text-align: ", ";\n    color: ", ";\n"], ["\n    display: block;\n    margin-top: 4px;\n    font-size: 12px;\n    text-align: ", ";\n    color: ", ";\n"])), function (_a) {
    var isShowLimitLeft = _a.isShowLimitLeft;
    return (isShowLimitLeft ? 'left' : 'right');
}, function (_a) {
    var isMax = _a.isMax;
    return (isMax ? '#f85a5a !important' : '#777');
});
var TextEditorQuill_css_templateObject_1;
var TextEditorQuill_css_templateObject_2, TextEditorQuill_css_templateObject_3;


//# sourceMappingURL=TextEditorQuill.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditorQuill/translate.js
'use client';

/* eslint-disable prettier/prettier */
var translate_translations = {
    'characters remaining': ' ký tự còn lại',
    'You have entered too many characters': 'Bạn đã nhập quá nhiều ký tự'
};


//# sourceMappingURL=translate.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TextEditorQuill/index.js
'use client';






var TextEditorQuill = function (props) {
    var _a = props.lang, lang = _a === void 0 ? 'vi' : _a, content = props.content, placeholder = props.placeholder, _b = props.limit, limit = _b === void 0 ? -1 : _b, _c = props.maxHeight, maxHeight = _c === void 0 ? 150 : _c, customRef = props.customRef, textEditor = props.textEditor, _d = props.isShowLimitLeft, isShowLimitLeft = _d === void 0 ? true : _d, onChange = props.onChange;
    var contentFilter = (0,helpers/* filterHTMLTag */.SO)(content);
    var _e = (0,react.useState)(limit - contentFilter.length), remainingChars = _e[0], setRemainingChars = _e[1];
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translate_translations[text];
        }
    };
    var onEditorTextChange = function () {
        var content = customRef.current.querySelector('.ql-editor').innerHTML;
        // Check limit
        if (limit > -1) {
            var remainingChars_1 = limit - (0,helpers/* filterHTMLTag */.SO)(content).length;
            setRemainingChars(remainingChars_1);
            if (remainingChars_1 < 0) {
                return;
            }
        }
        onChange && onChange(content);
    };
    var renderRemainCharacter = function () {
        if (limit === -1) {
            return react.createElement(react.Fragment, null);
        }
        if (remainingChars >= 0) {
            return (react.createElement(LimitCharacter, { isShowLimitLeft: isShowLimitLeft },
                remainingChars,
                " ",
                t('characters remaining')));
        }
        else {
            return react.createElement(LimitCharacter, { isMax: true }, t('You have entered too many characters'));
        }
    };
    (0,react.useEffect)(function () {
        if (customRef === undefined || customRef === null) {
            return;
        }
        if (customRef.current === undefined || customRef.current === null) {
            return;
        }
        if (customRef.current.__quill === undefined || customRef.current.__quill === null) {
            return;
        }
        if (textEditor === undefined || textEditor === null) {
            return;
        }
        // Set default value to editor
        var delta = customRef.current.__quill.clipboard.convert(content);
        customRef.current.__quill.setContents(delta, 'silent');
        // Add event listen on change
        customRef.current.__quill.on('text-change', onEditorTextChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customRef, textEditor]);
    if (typeof window === undefined || typeof document === undefined) {
        return react.createElement(react.Fragment, null);
    }
    return (react.createElement(QuillSnowCss, null,
        react.createElement(TextEditorQuillWrapper, { maxHeight: maxHeight, placeholder: placeholder },
            react.createElement("div", { className: 'snow', ref: customRef, defaultValue: content }),
            renderRemainCharacter())));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TravelLine/styles.js
'use client';




var TravelLineContainer = styled_components_browser_esm/* default.div */.ZP.div(TravelLine_styles_templateObject_1 || (TravelLine_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-left: 1px solid #d9d5d5;\n\n    > div {\n        position: relative;\n\n        > div:nth-child(1) {\n            position: absolute;\n            top: ", "px;\n            left: -", "px;\n        }\n\n        > div:nth-child(2) {\n            padding-left: ", "px;\n        }\n    }\n"], ["\n    border-left: 1px solid #d9d5d5;\n\n    > div {\n        position: relative;\n\n        > div:nth-child(1) {\n            position: absolute;\n            top: ", "px;\n            left: -", "px;\n        }\n\n        > div:nth-child(2) {\n            padding-left: ", "px;\n        }\n    }\n"])), function (_a) {
    var positionTopIcon = _a.positionTopIcon;
    return positionTopIcon;
}, function (_a) {
    var widthIcon = _a.widthIcon;
    return widthIcon / 2;
}, function (_a) {
    var gap = _a.gap;
    return gap;
});
var TravelLine_styles_templateObject_1;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/TravelLine/index.js
'use client';




/*
    How to use:
    TravelLineContainer receive children with format:
    <div> -> block line
        <div /> -> icon of block on left side
        <div /> -> content of block on right side
    </div>
    <div> ->
        <div />
        <div />
    </div>
    <div> ->
        <div />
        <div />
    </div>
*/
var TravelLine = function (_a) {
    var children = _a.children, widthIcon = _a.widthIcon, _b = _a.gap, gap = _b === void 0 ? 20 : _b, _c = _a.positionTopIcon, positionTopIcon = _c === void 0 ? 5 : _c;
    return (react.createElement(TravelLineContainer, { widthIcon: widthIcon, gap: gap, positionTopIcon: positionTopIcon }, children));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/utmTracking.js
var utmTracking = __webpack_require__(17804);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/YourResumeScore/YourResumeScore.css.js
'use client';





var YourResumeScoreWrapper = styled_components_browser_esm/* default.div */.ZP.div(YourResumeScore_css_templateObject_1 || (YourResumeScore_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    background-color: ", ";\n    border-radius: 12px;\n    padding: 20px 16px 20px 20px;\n    @media screen and (max-width: 767px) {\n        flex-direction: column;\n        text-align: center;\n    }\n"], ["\n    display: flex;\n    background-color: ", ";\n    border-radius: 12px;\n    padding: 20px 16px 20px 20px;\n    @media screen and (max-width: 767px) {\n        flex-direction: column;\n        text-align: center;\n    }\n"])), constants/* colors.bgHover */.O9.bgHover);
var LeftSide = styled_components_browser_esm/* default.div */.ZP.div(YourResumeScore_css_templateObject_2 || (YourResumeScore_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    @media screen and (max-width: 767px) {\n        display: inline-flex;\n        justify-content: center;\n        margin-bottom: 20px;\n    }\n"], ["\n    @media screen and (max-width: 767px) {\n        display: inline-flex;\n        justify-content: center;\n        margin-bottom: 20px;\n    }\n"])));
var RightSide = styled_components_browser_esm/* default.div */.ZP.div(YourResumeScore_css_templateObject_3 || (YourResumeScore_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    justify-content: space-between;\n    margin-left: 20px;\n    width: calc(100% - 122px);\n    vertical-align: top;\n    @media screen and (max-width: 767px) {\n        margin-left: 0;\n        width: 100%;\n        flex-direction: column;\n    }\n"], ["\n    display: inline-flex;\n    justify-content: space-between;\n    margin-left: 20px;\n    width: calc(100% - 122px);\n    vertical-align: top;\n    @media screen and (max-width: 767px) {\n        margin-left: 0;\n        width: 100%;\n        flex-direction: column;\n    }\n"])));
var YourResumeScore_css_Content = styled_components_browser_esm/* default.div */.ZP.div(YourResumeScore_css_templateObject_4 || (YourResumeScore_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-right: 16px;\n    display: inline-flex;\n    flex-direction: column;\n    width: calc(100% - 206px);\n    justify-content: center;\n    @media screen and (max-width: 767px) {\n        padding-right: 0;\n        display: block;\n        width: 100%;\n    }\n"], ["\n    padding-right: 16px;\n    display: inline-flex;\n    flex-direction: column;\n    width: calc(100% - 206px);\n    justify-content: center;\n    @media screen and (max-width: 767px) {\n        padding-right: 0;\n        display: block;\n        width: 100%;\n    }\n"])));
var Action = styled_components_browser_esm/* default.div */.ZP.div(YourResumeScore_css_templateObject_5 || (YourResumeScore_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 100%;\n    @media screen and (max-width: 767px) {\n        justify-content: center;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 100%;\n    @media screen and (max-width: 767px) {\n        justify-content: center;\n    }\n"])));
var YourResumeScore_css_ContentTitle = styled_components_browser_esm/* default.p */.ZP.p(YourResumeScore_css_templateObject_6 || (YourResumeScore_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 8px 0;\n    font-weight: 700;\n    font-size: 22px;\n    line-height: 28px;\n    color: #6fb920;\n"], ["\n    margin: 0 0 8px 0;\n    font-weight: 700;\n    font-size: 22px;\n    line-height: 28px;\n    color: #6fb920;\n"])));
var DescriptionText = styled_components_browser_esm/* default.p */.ZP.p(YourResumeScore_css_templateObject_7 || (YourResumeScore_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    color: ", ";\n"], ["\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    color: ", ";\n"])), constants/* colors.textColor */.O9.textColor);
var YourResumeScore_css_templateObject_1, YourResumeScore_css_templateObject_2, YourResumeScore_css_templateObject_3, YourResumeScore_css_templateObject_4, YourResumeScore_css_templateObject_5, YourResumeScore_css_templateObject_6, YourResumeScore_css_templateObject_7;


//# sourceMappingURL=YourResumeScore.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/YourResumeScore/translations.js
'use client';

var YourResumeScore_translations_translations = {
    'View stats': 'Xem thống kê',
    'Competitive rate': 'Tỷ lệ cạnh tranh',
    'Analyzed using your application profile compared to other candidates applying for this job.': 'Được phân tích bằng cách sử dụng hồ sơ ứng tuyển của bạn so với các ứng viên khác đang ứng tuyển cho công việc này.',
    '/track-my-competitive-rate/': '/theo-doi-ty-le-canh-tranh-cua-toi/'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/YourResumeScore/service.js
'use client';



var apiGetResumeScore = function (jobId, apiGetScore, accessToken, langCode) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var url, res, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                url = "".concat(apiGetScore, "?jobId=").concat(jobId);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    })];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.error('GET Resume Score', ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=service.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/YourResumeScore/index.js
'use client';









var YourResumeScore = function (props) {
    var langCode = props.langCode, jobId = props.jobId, accessToken = props.accessToken, apiGetScore = props.apiGetScore;
    var _a = (0,react.useState)(0), score = _a[0], setScore = _a[1];
    var t = function (text) {
        var _a;
        if (langCode === 'en') {
            return text;
        }
        else {
            return (_a = YourResumeScore_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClick = function () {
        window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
    };
    var getResumeScore = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, apiGetResumeScore(jobId, apiGetScore, accessToken, langCode)];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.score) {
                        setScore((_b = response === null || response === void 0 ? void 0 : response.result) === null || _b === void 0 ? void 0 : _b.score);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        getResumeScore();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react.createElement(YourResumeScoreWrapper, null,
        react.createElement(LeftSide, null,
            react.createElement(CircleProgressBar, { percent: score, options: {
                    color: '#6FB920'
                } })),
        react.createElement(RightSide, null,
            react.createElement(YourResumeScore_css_Content, null,
                react.createElement(YourResumeScore_css_ContentTitle, null, t('Competitive rate')),
                react.createElement(DescriptionText, null, t('Analyzed using your application profile compared to other candidates applying for this job.'))),
            react.createElement(Action, null,
                react.createElement(Button/* default */.Z, { type: 'primary', onClick: onClick }, t('View stats'))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ZaloWidget/styles.js
'use client';




var ZaloWidgetContainer = styled_components_browser_esm/* default.a */.ZP.a(ZaloWidget_styles_templateObject_1 || (ZaloWidget_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    z-index: 99;\n    bottom: 165px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    border-radius: 50%;\n    box-shadow: rgb(0 0 0 / 20%) 0px 0px 6px 0px;\n\n    @media (max-width: 769px) {\n        right: 10px;\n        bottom: 100px;\n    }\n"], ["\n    position: fixed;\n    z-index: 99;\n    bottom: 165px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    border-radius: 50%;\n    box-shadow: rgb(0 0 0 / 20%) 0px 0px 6px 0px;\n\n    @media (max-width: 769px) {\n        right: 10px;\n        bottom: 100px;\n    }\n"])));
var ZaloWidget_styles_templateObject_1;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ZaloWidget/ZaloIcon.js
'use client';



var ZaloIcon_ZaloIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 50 : _b;
    return (react.createElement("svg", { width: size, height: size, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22.782.166h4.417c6.066 0 9.611.891 12.758 2.578 3.147 1.687 5.63 4.152 7.299 7.299 1.687 3.147 2.578 6.692 2.578 12.758v4.398c0 6.066-.891 9.611-2.578 12.758-1.688 3.147-4.152 5.63-7.299 7.299-3.147 1.687-6.692 2.578-12.758 2.578h-4.398c-6.066 0-9.611-.89-12.758-2.578-3.147-1.687-5.63-4.152-7.299-7.299C1.057 36.81.166 33.265.166 27.2v-4.398c0-6.066.891-9.611 2.578-12.758 1.687-3.147 4.152-5.63 7.299-7.299C13.17 1.057 16.735.166 22.782.166Z', fill: '#0068FF' }),
        react.createElement("path", { opacity: 0.12, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M49.834 26.474v.725c0 6.067-.891 9.612-2.579 12.759-1.687 3.147-4.151 5.63-7.298 7.298-3.147 1.687-6.692 2.578-12.758 2.578H22.8c-4.964 0-8.24-.596-10.99-1.737l-4.536-4.67 42.559-16.953Z', fill: '#001A33' }),
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.779 43.59c2.323.256 5.227-.406 7.29-1.408 8.954 4.95 22.95 4.713 31.423-.709a18.69 18.69 0 0 0 .92-1.537C49.107 36.778 50 33.22 50 27.132v-4.415c0-6.088-.894-9.646-2.587-12.804-1.674-3.159-4.167-5.632-7.325-7.325C36.929.894 33.37 0 27.283 0H22.85c-5.186 0-8.552.653-11.38 1.899-.155.138-.306.28-.455.422-8.298 8-8.928 25.338-1.892 34.757a.631.631 0 0 0 .026.042c1.084 1.599.038 4.395-1.598 6.032-.267.247-.172.4.228.437Z', fill: '#fff' }),
        react.createElement("path", { d: 'M20.563 17h-9.725v2.085h6.749l-6.654 8.247c-.209.303-.36.587-.36 1.232v.53h9.175a.84.84 0 0 0 .834-.833v-1.119h-7.09l6.256-7.848c.095-.114.265-.322.341-.417l.038-.057c.36-.53.436-.986.436-1.536V17Zm12.379 12.095h1.383V17H32.24v11.393a.7.7 0 0 0 .702.702Zm-7.128-9.403a4.741 4.741 0 0 0-4.74 4.74 4.741 4.741 0 0 0 4.74 4.739 4.741 4.741 0 0 0 4.74-4.74c.018-2.615-2.105-4.739-4.74-4.739Zm0 7.526a2.791 2.791 0 0 1-2.787-2.786 2.791 2.791 0 0 1 2.787-2.787 2.791 2.791 0 0 1 2.787 2.787 2.78 2.78 0 0 1-2.787 2.786Zm14.673-7.602a4.781 4.781 0 0 0-4.778 4.777 4.781 4.781 0 0 0 4.778 4.778 4.782 4.782 0 0 0 4.777-4.778 4.782 4.782 0 0 0-4.777-4.777Zm0 7.602a2.8 2.8 0 0 1-2.806-2.806 2.8 2.8 0 0 1 2.806-2.805 2.8 2.8 0 0 1 2.805 2.805 2.8 2.8 0 0 1-2.805 2.806Z', fill: '#0068FF' }),
        react.createElement("path", { d: 'M29.456 29.094h1.119v-9.137h-1.953v8.322c0 .436.38.815.834.815Z', fill: '#0068FF' })));
};


//# sourceMappingURL=ZaloIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ZaloWidget/index.js
'use client';





function ZaloWidget(_a) {
    var oaid = _a.oaid, className = _a.className;
    var _b = (0,react.useState)(false), isClient = _b[0], setIsClient = _b[1];
    var ZALO_LINK = "https://zalo.me/".concat(oaid);
    (0,react.useEffect)(function () {
        setIsClient(true);
    }, []);
    return isClient ? (react.createElement(ZaloWidgetContainer, { "aria-label": 'chat with vietnamworks', href: ZALO_LINK, target: '_blank', className: "zalo-widget ".concat(className) },
        react.createElement(ZaloIcon_ZaloIcon, { size: 44 }))) : null;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/index.js + 5 modules
var JobCard = __webpack_require__(59304);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardList/JobCardList.css.js
'use client';




var JobCardList_css_Container = styled_components_browser_esm/* default.div */.ZP.div(JobCardList_css_templateObject_1 || (JobCardList_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"])));
var MoreButton = styled_components_browser_esm/* default.div */.ZP.div(JobCardList_css_templateObject_2 || (JobCardList_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: center;\n\n"], ["\n    display: flex;\n    justify-content: center;\n\n"])));
var JobCardList_css_templateObject_1, JobCardList_css_templateObject_2;


//# sourceMappingURL=JobCardList.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardList/constant.js
'use client';

var SUCCESS_CODE = 200;
var LIMIT_PER_PAGE = 50;


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardList/services.js
'use client';





var searchJobs = function (_a) {
    var baseUrl = _a.baseUrl, params = _a.params, _b = _a.xSource, xSource = _b === void 0 ? 'Page-Container' : _b, _c = _a.langCode, langCode = _c === void 0 ? constants/* ELanguage.VI */.Df.VI : _c;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var urlApi, retrieveFields, finalParams, response, data, error_1;
        var _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/job-search/v1.0/search");
                    retrieveFields = [
                        'address',
                        'benefits',
                        'jobTitle',
                        'isSalaryVisible',
                        'isShowLogo',
                        'companyLogo',
                        'userId',
                        'jobLevel',
                        'jobLevelId',
                        'jobLevelVI',
                        'jobId',
                        'companyId',
                        'approvedOn',
                        'isAnonymous',
                        'alias',
                        'expiredOn',
                        'industries',
                        'workingLocations',
                        'services',
                        'companyName',
                        'onlineOn',
                        'simpleServices',
                        'visibilityDisplay',
                        'isShowLogoInSearch',
                        'priorityOrder',
                        'skills',
                        'profilePublishedSiteMask',
                        'salaryMin',
                        'salaryMax',
                        'prettySalary',
                        'jobDescription',
                        'jobRequirement'
                    ];
                    finalParams = (0,_tslib/* __assign */.pi)({ userId: 0, query: '', filter: [], ranges: [], order: [], hitsPerPage: LIMIT_PER_PAGE, page: 0, retrieveFields: retrieveFields }, params);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'X-Source': xSource,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(finalParams)
                        })];
                case 2:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _e.sent();
                    if (((_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.code) === SUCCESS_CODE) {
                        return [2 /*return*/, {
                                data: data.data,
                                meta: data.meta,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: [],
                                meta: [],
                                error: data === null || data === void 0 ? void 0 : data.message
                            }];
                    }
                case 4:
                    error_1 = _e.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
};


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardList/translations.js
'use client';

var JobCardList_translations_translations = {
    "More...": "Thêm..."
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardList/index.js
'use client';












var JobCardList = function (props) {
    var _a;
    var api = props.api, langCode = props.langCode, previewJob = props.previewJob, _b = props.forceNormalJob, forceNormalJob = _b === void 0 ? false : _b, _c = props.useLoadMore, useLoadMore = _c === void 0 ? false : _c, userInfo = props.userInfo, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d, _e = props.isForceJobLinkVI, isForceJobLinkVI = _e === void 0 ? false : _e, headingTagTitleJob = props.headingTagTitleJob;
    var _f = (0,react.useState)([]), jobFull = _f[0], setJobFull = _f[1];
    var _g = (0,react.useState)(((_a = api === null || api === void 0 ? void 0 : api.params) === null || _a === void 0 ? void 0 : _a.page) || 0), page = _g[0], setPage = _g[1];
    var _h = (0,react.useState)(false), isShowLoadMore = _h[0], setIsShowLoadMore = _h[1];
    var isMobile$1 = (0,helpers/* isMobile */.tq)();
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return JobCardList_translations_translations[key] || key;
        }
    };
    var updateJobList = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var resultSearch, formatJobs, jobsNew;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, searchJobs({
                        baseUrl: api.baseUrl,
                        params: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, api.params), { page: page }),
                        langCode: langCode
                    })];
                case 1:
                    resultSearch = _b.sent();
                    if (!((resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data.length) > 0)) return [3 /*break*/, 5];
                    if (!(api === null || api === void 0 ? void 0 : api.accessToken)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0,services/* getSpecialJob */.nL)({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data
                        })];
                case 2:
                    formatJobs = _b.sent();
                    jobsNew = formatJobs === null || formatJobs === void 0 ? void 0 : formatJobs.data;
                    setJobFull((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], jobFull, true), jobsNew, true));
                    return [3 /*break*/, 4];
                case 3:
                    setJobFull((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], jobFull, true), resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data, true));
                    _b.label = 4;
                case 4:
                    if (((_a = resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.meta) === null || _a === void 0 ? void 0 : _a.nbPages) - 1 > page) {
                        setPage(page + 1);
                        setIsShowLoadMore(true);
                    }
                    else {
                        setIsShowLoadMore(false);
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleLoadMore = function () {
        updateJobList();
    };
    (0,react.useEffect)(function () {
        updateJobList();
    }, [api === null || api === void 0 ? void 0 : api.params]);
    return (react.createElement(JobCardList_css_Container, null,
        jobFull.map(function (job, idx) { return (react.createElement(JobCard/* default */.Z, { key: idx, data: job, langCode: langCode, isMobile: isMobile$1, api: { accessToken: api.accessToken, baseUrl: api.baseUrl }, previewJob: previewJob, isManagementJobPage: false, custom: { forceNormalJob: forceNormalJob }, userInfo: userInfo, classSelector: classSelector, initData: props.initData, isForceJobLinkVI: isForceJobLinkVI, headingTagTitleJob: headingTagTitleJob })); }),
        useLoadMore && isShowLoadMore && (react.createElement(MoreButton, null,
            react.createElement(Button/* default */.Z, { type: 'outline', className: 'customButton', onClick: handleLoadMore },
                ' ',
                t('More...'),
                ' ')))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMiniList/JobCardMiniList.css.js
'use client';




var JobCardMiniList_css_Container = styled_components_browser_esm/* default.div */.ZP.div(JobCardMiniList_css_templateObject_1 || (JobCardMiniList_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    line-height: 1.2;\n"], ["\n    width: 100%;\n    line-height: 1.2;\n"])));
var JobCardMiniList_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(JobCardMiniList_css_templateObject_2 || (JobCardMiniList_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var JobCardMiniList_css_ListJob = styled_components_browser_esm/* default.div */.ZP.div(JobCardMiniList_css_templateObject_4 || (JobCardMiniList_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var gridColumn = _a.gridColumn;
    return (0,styled_components_browser_esm/* css */.iv)(JobCardMiniList_css_templateObject_3 || (JobCardMiniList_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            > div {\n                width: calc((100% - 8px * ", ") / ", ");\n            }\n        "], ["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            > div {\n                width: calc((100% - 8px * ", ") / ", ");\n            }\n        "])), (gridColumn || 1) - 1, gridColumn || 1);
});
var JobCardMiniList_css_templateObject_1, JobCardMiniList_css_templateObject_2, JobCardMiniList_css_templateObject_3, JobCardMiniList_css_templateObject_4;


//# sourceMappingURL=JobCardMiniList.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMiniList/services.js
'use client';



var getJobYouWillLove = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, query = _a.query;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var encodeQuery, urlApi, res;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    encodeQuery = query ? "?".concat(new URLSearchParams(query).toString()) : '';
                    urlApi = "".concat(baseUrl, "/smartnavi/v2/jobs").concat(encodeQuery);
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'GET',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.total) > 0) {
                        return [2 /*return*/, {
                                data: res,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: {
                                    jobs: [],
                                    source: ''
                                },
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var STATUS_CODE = 200;
var getSpecialJob = function (_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, jobs = _a.jobs;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var emptySpecialJob, urlApi, ids, res;
        var _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    emptySpecialJob = jobs.map(function (item) {
                        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { isSaved: false, isApplied: false, isBlackList: false, isMatching: false });
                    });
                    if (!accessToken) {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: ''
                            }];
                    }
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/special-jobs");
                    ids = jobs.map(function (item) { return item.jobId; });
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({ jobId: ids })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _c.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.status) === null || _b === void 0 ? void 0 : _b.code) === STATUS_CODE) {
                        return [2 /*return*/, {
                                data: jobs.map(function (item, idx) {
                                    var _a, _b, _c, _d;
                                    return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { isMatching: (_a = res.data[idx].attributes) === null || _a === void 0 ? void 0 : _a.matching, isSaved: (_b = res.data[idx].attributes) === null || _b === void 0 ? void 0 : _b.saved, isApplied: (_c = res.data[idx].attributes) === null || _c === void 0 ? void 0 : _c.applied, isBlackList: (_d = res.data[idx].attributes) === null || _d === void 0 ? void 0 : _d.userBlackList });
                                }),
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobCardMiniList/index.js
'use client';








var JobCardMiniList = function (props) {
    var typeOptions = props.typeOptions, api = props.api, langCode = props.langCode, robot = props.robot, previewJob = props.previewJob, type = props.type, isMobile = props.isMobile, userInfo = props.userInfo;
    var _a = (0,react.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0,react.useState)([]), data = _b[0], setData = _b[1];
    var isLoading = (robot === null || robot === void 0 ? void 0 : robot.enable) ? false : loading;
    var listJob = (robot === null || robot === void 0 ? void 0 : robot.enable) ? robot === null || robot === void 0 ? void 0 : robot.data : data;
    var getJobs = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var data, createdUtm, formatJobs, jobs;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getJobYouWillLove({
                        baseUrl: api.baseUrl,
                        langCode: langCode,
                        query: (0,_tslib/* __assign */.pi)({ jobId: '0' }, api.query)
                    })];
                case 1:
                    data = (_a.sent()).data;
                    createdUtm = function (type, source) {
                        switch (type) {
                            case 'my-profile':
                                return "/?utm_source_navi=CareerCenter&utm_medium_navi=MyProfile&utm_campaign_navi=JobsYouWillLove&utm_content_navi=".concat(source, "&utm_term_navi=VB");
                            case 'job-detail':
                                return "/?utm_source_navi=jobalertemail&utm_medium_navi=JobDescription&utm_campaign_navi=PeopleAlsoView&utm_content_navi=".concat(source, "&utm_term_navi=VB");
                            case 'job-detail-right-corner':
                                return "/?utm_source_navi=jobdetail&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
                            case 'event':
                                return "/?utm_source_navi=eventPage&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
                            default:
                                return '';
                        }
                    };
                    formatJobs = data.jobs.map(function (item) {
                        var formatUtm = createdUtm('my-profile' , data.source);
                        var jobUrl = "".concat(item.alias, "-").concat(item.jobId).concat(langCode === constants/* ELanguage.EN */.Df.EN ? '-jd' : '-jv').concat(formatUtm);
                        var locationText = (item.workingLocations || [])
                            .map(function (item) { return (langCode === constants/* ELanguage.VI */.Df.VI ? item.cityNameVI : item.cityName); })
                            .join(', ');
                        var jobLevelText = langCode === constants/* ELanguage.VI */.Df.VI ? item.jobLevelVI : item.jobLevel;
                        return (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, item), { jobUrl: jobUrl, locationText: locationText, jobLevelText: jobLevelText });
                    });
                    if (!((api === null || api === void 0 ? void 0 : api.accessToken) && data.jobs.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: formatJobs
                        })];
                case 2:
                    jobs = (_a.sent()).data;
                    setData(jobs);
                    return [3 /*break*/, 4];
                case 3:
                    setData(formatJobs);
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        getJobs();
    }, []);
    return (react.createElement(JobCardMiniList_css_Container, { className: type }, !isLoading && (react.createElement(JobCardMiniList_css_Wrapper, { className: 'jobs-section' },
        react.createElement(JobCardMiniList_css_ListJob, { gridColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridColumn }, listJob.map(function (item, idx) { return (react.createElement(JobCardMini, { key: idx, isMobile: isMobile, item: item, langCode: langCode, api: api, previewJob: previewJob, userInfo: userInfo, isNldPage: true, initData: props.initData })); }))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/LoginModal.css.js
'use client';





var openPopup = (0,styled_components_browser_esm/* keyframes */.F4)(LoginModal_css_templateObject_1 || (LoginModal_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var closePopup = (0,styled_components_browser_esm/* keyframes */.F4)(LoginModal_css_templateObject_2 || (LoginModal_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_3 || (LoginModal_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    animation: ", " 0.25s ease-in-out forwards;\n"], ["\n    position: fixed;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    animation: ", " 0.25s ease-in-out forwards;\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? openPopup : closePopup);
});
styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_4 || (LoginModal_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.65);\n    z-index: 1;\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.65);\n    z-index: 1;\n"])));
var LoginModalContainerWrapper = styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_5 || (LoginModal_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n"], ["\n    padding: 24px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_6 || (LoginModal_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 650px;\n    margin: auto;\n    z-index: 2;\n    background-color: #fff;\n    border-radius: 6px;\n    padding: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 650px;\n    margin: auto;\n    z-index: 2;\n    background-color: #fff;\n    border-radius: 6px;\n    padding: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n"])));
var ForgotPasswordLink = styled_components_browser_esm/* default.a */.ZP.a(LoginModal_css_templateObject_7 || (LoginModal_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    cursor: pointer;\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"], ["\n    color: ", ";\n    cursor: pointer;\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor, constants/* colors.buttonColor */.O9.buttonColor);
styled_components_browser_esm/* default.p */.ZP.p(LoginModal_css_templateObject_8 || (LoginModal_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 24px 0;\n    font-size: 32px;\n    color: #555;\n    text-align: center;\n"], ["\n    margin: 0 0 24px 0;\n    font-size: 32px;\n    color: #555;\n    text-align: center;\n"])));
var SmallLabel = styled_components_browser_esm/* default.p */.ZP.p(LoginModal_css_templateObject_9 || (LoginModal_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #333;\n    text-align: center;\n"], ["\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #333;\n    text-align: center;\n"])));
var LabelInput = styled_components_browser_esm/* default.p */.ZP.p(LoginModal_css_templateObject_10 || (LoginModal_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 5px 0;\n    font-weight: 500;\n    display: inline-block;\n    color: #333;\n    font-size: 14px;\n    line-height: 18px;\n    > span {\n        color: #ff4a53;\n        font-weight: 700;\n        margin-left: 4px;\n    }\n"], ["\n    margin: 0 0 5px 0;\n    font-weight: 500;\n    display: inline-block;\n    color: #333;\n    font-size: 14px;\n    line-height: 18px;\n    > span {\n        color: #ff4a53;\n        font-weight: 700;\n        margin-left: 4px;\n    }\n"])));
var LoginModal_css_InputGroup = styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_11 || (LoginModal_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 16px;\n"], ["\n    margin-bottom: 16px;\n"])));
var ForgotGroup = styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_12 || (LoginModal_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: right;\n"], ["\n    text-align: right;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_13 || (LoginModal_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    margin: 16px 0;\n    button {\n        width: 100%;\n    }\n"], ["\n    width: 100%;\n    margin: 16px 0;\n    button {\n        width: 100%;\n    }\n"])));
var SocialLoginGroup = styled_components_browser_esm/* default.div */.ZP.div(LoginModal_css_templateObject_14 || (LoginModal_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: center;\n    margin: 0 -15px 24px -15px;\n    > button {\n        &:first-child {\n            margin-right: 8px;\n        }\n        &:last-child {\n            margin-left: 8px;\n        }\n        > span {\n            margin-left: 8px;\n        }\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    margin: 0 -15px 24px -15px;\n    > button {\n        &:first-child {\n            margin-right: 8px;\n        }\n        &:last-child {\n            margin-left: 8px;\n        }\n        > span {\n            margin-left: 8px;\n        }\n    }\n"])));
styled_components_browser_esm/* default.a */.ZP.a(LoginModal_css_templateObject_15 || (LoginModal_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px 10px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    border-radius: 4px;\n    margin: 0 15px;\n    color: #555;\n    background: #f4f4f7;\n    border-radius: 6px;\n    width: auto;\n    svg {\n        width: 25px;\n        height: 25px;\n        margin-right: 8px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    padding: 8px 10px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    border-radius: 4px;\n    margin: 0 15px;\n    color: #555;\n    background: #f4f4f7;\n    border-radius: 6px;\n    width: auto;\n    svg {\n        width: 25px;\n        height: 25px;\n        margin-right: 8px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
styled_components_browser_esm/* default.p */.ZP.p(LoginModal_css_templateObject_16 || (LoginModal_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 24px 0 16px 0;\n    text-align: center;\n    > a {\n        margin-left: 4px;\n        font-weight: 700;\n    }\n"], ["\n    margin: 24px 0 16px 0;\n    text-align: center;\n    > a {\n        margin-left: 4px;\n        font-weight: 700;\n    }\n"])));
var LoginModal_css_ErrorMessage = styled_components_browser_esm/* default.p */.ZP.p(LoginModal_css_templateObject_17 || (LoginModal_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 8px 0 8px 0;\n    color: #ff4a53;\n"], ["\n    margin: 8px 0 8px 0;\n    color: #ff4a53;\n"])));
styled_components_browser_esm/* default.span */.ZP.span(LoginModal_css_templateObject_18 || (LoginModal_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    > svg {\n        cursor: pointer;\n    }\n"], ["\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    > svg {\n        cursor: pointer;\n    }\n"])));
var RegisterLink = styled_components_browser_esm/* default.a */.ZP.a(LoginModal_css_templateObject_19 || (LoginModal_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 4px;\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"], ["\n    margin-left: 4px;\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"])), constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor, constants/* colors.buttonColor */.O9.buttonColor);
var LoginModal_css_templateObject_1, LoginModal_css_templateObject_2, LoginModal_css_templateObject_3, LoginModal_css_templateObject_4, LoginModal_css_templateObject_5, LoginModal_css_templateObject_6, LoginModal_css_templateObject_7, LoginModal_css_templateObject_8, LoginModal_css_templateObject_9, LoginModal_css_templateObject_10, LoginModal_css_templateObject_11, LoginModal_css_templateObject_12, LoginModal_css_templateObject_13, LoginModal_css_templateObject_14, LoginModal_css_templateObject_15, LoginModal_css_templateObject_16, LoginModal_css_templateObject_17, LoginModal_css_templateObject_18, LoginModal_css_templateObject_19;


//# sourceMappingURL=LoginModal.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/translations.js
'use client';

var LoginModal_translations_translations = {
    'Sign in to continue': 'Đăng nhập để tiếp tục',
    'or with your email': 'hoặc đăng nhập bằng email',
    'Forgot Password?': 'Quên mật khẩu?',
    Email: 'Email',
    Password: 'Mật khẩu',
    'with Facebook account': 'với tài khoản Facebook',
    'with Google account': 'với tài khoản Google',
    Login: 'Đăng nhập',
    "Don't have an account yet?": 'Chưa có tài khoản?',
    'Register now': 'Đăng Ký',
    'The Email field is required.': 'Vui lòng nhập Email',
    'The Password field is required.': 'Vui lòng nhập Mật Khẩu',
    'The Email must be a valid Email address.': 'Email không hợp lệ.',
    'Wrong email or password. Please check again.': 'Email hoặc mật khẩu không đúng. Hãy kiểm tra lại.',
    'You have not verified your email. Please check your email inbox for instruction.': 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.',
    'This email address is registered as Employer, please Sign in from Employer Site.': 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.',
    'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.': 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/GoogleLogoIcon/index.js
'use client';



var GoogleLogoIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M18.1713 8.36775H17.5001V8.33317H10.0001V11.6665H14.7097C14.0226 13.6069 12.1763 14.9998 10.0001 14.9998C7.23883 14.9998 5.00008 12.7611 5.00008 9.99984C5.00008 7.23859 7.23883 4.99984 10.0001 4.99984C11.2747 4.99984 12.4342 5.48067 13.3172 6.26609L15.6742 3.909C14.1859 2.52192 12.1951 1.6665 10.0001 1.6665C5.398 1.6665 1.66675 5.39775 1.66675 9.99984C1.66675 14.6019 5.398 18.3332 10.0001 18.3332C14.6022 18.3332 18.3334 14.6019 18.3334 9.99984C18.3334 9.44109 18.2759 8.89567 18.1713 8.36775Z', fill: '#FFC107' }),
        react.createElement("path", { d: 'M2.62732 6.12109L5.36524 8.129C6.10607 6.29484 7.90024 4.99984 9.99982 4.99984C11.2744 4.99984 12.434 5.48067 13.3169 6.26609L15.674 3.909C14.1857 2.52192 12.1948 1.6665 9.99982 1.6665C6.79899 1.6665 4.02315 3.47359 2.62732 6.12109Z', fill: '#FF3D00' }),
        react.createElement("path", { d: 'M10 18.3331C12.1525 18.3331 14.1084 17.5094 15.5871 16.1698L13.008 13.9873C12.1713 14.621 11.1313 14.9998 10 14.9998C7.83255 14.9998 5.99213 13.6177 5.2988 11.689L2.5813 13.7827C3.96047 16.4815 6.7613 18.3331 10 18.3331Z', fill: '#4CAF50' }),
        react.createElement("path", { d: 'M18.1712 8.36808H17.5V8.3335H10V11.6668H14.7096C14.3796 12.5989 13.78 13.4027 13.0067 13.9881L13.0079 13.9872L15.5871 16.1697C15.4046 16.3356 18.3333 14.1668 18.3333 10.0002C18.3333 9.44141 18.2758 8.896 18.1712 8.36808Z', fill: '#1976D2' })));
};
var GoogleLogoIcon$1 = react.memo(GoogleLogoIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/FacebookLogoIcon/index.js
'use client';



var FacebookLogoIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_8755_164691)' },
            react.createElement("path", { d: 'M10.02 23.88C4.32 22.86 0 17.94 0 12C0 5.4 5.4 0 12 0C18.6 0 24 5.4 24 12C24 17.94 19.68 22.86 13.98 23.88L13.32 23.34H10.68L10.02 23.88Z', fill: 'url(#paint0_linear_8755_164691)' }),
            react.createElement("path", { d: 'M16.6801 15.3602L17.2201 12.0002H14.0401V9.66018C14.0401 8.70018 14.4001 7.98018 15.8401 7.98018H17.4001V4.92018C16.5601 4.80018 15.6001 4.68018 14.7601 4.68018C12.0001 4.68018 10.0801 6.36018 10.0801 9.36018V12.0002H7.08008V15.3602H10.0801V23.8202C10.7401 23.9402 11.4001 24.0002 12.0601 24.0002C12.7201 24.0002 13.3801 23.9402 14.0401 23.8202V15.3602H16.6801Z', fill: 'white' })),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'paint0_linear_8755_164691', x1: '12.0006', y1: '23.1654', x2: '12.0006', y2: '-0.00442066', gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#0062E0' }),
                react.createElement("stop", { offset: '1', stopColor: '#19AFFF' })),
            react.createElement("clipPath", { id: 'clip0_8755_164691' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var FacebookLogoIcon$1 = react.memo(FacebookLogoIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/helper.js
'use client';




var helper_isMobile = function () {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
};
var getBaseMsUrl = function () {
    var locationUrl = 'https://ms.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-ms.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-ms.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'ms.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-ms.vietnamworks.com';
    }
    return locationUrl;
};
var secureUrl = function () {
    var locationUrl = 'https://secure.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-secure.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-secure.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'secure.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-secure.vietnamworks.com';
    }
    // Only for wowCV
    if (locationUrl.indexOf('wowcv.') >= 0) {
        return locationUrl.replace('wowcv.', 'secure.');
    }
    return locationUrl;
};
/**
 * Get Vietnamworks url base on current location path (Without using APP_MODE)
 *
 * isHaveLocal true then this function will return base url as localhost
 * (This allow for user login cookie can be saved in localhost)
 *
 * @author Thien Tran
 * @since Jun 09, 2023
 * @param isHaveLocal boolean is isHaveLocal or just want link
 * @returns vietnamworks url
 */
var getBaseUrl = function (isHaveLocal) {
    if (isHaveLocal === void 0) { isHaveLocal = true; }
    var locationUrl = 'www.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0 || locationUrl.indexOf('staging-wowcv.') >= 0) {
        return 'staging.vietnamworks.com';
    }
    // release
    if (locationUrl.indexOf('release.') >= 0 || locationUrl.indexOf('release-wowcv.') >= 0) {
        return 'release.vietnamworks.com';
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0 || locationUrl.indexOf('wowcv.') >= 0) {
        return 'www.vietnamworks.com';
    }
    // Make sure cookie was saved in localhost if logged in via localhost
    if (locationUrl.indexOf('localhost:') >= 0) {
        return isHaveLocal ? 'localhost' : 'www.vietnamworks.com';
    }
    return locationUrl;
};
var getRegisterUrl = function (langCode, utmTracking) {
    if (utmTracking === void 0) { utmTracking = ''; }
    var langKey = langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en';
    var registerLink = "".concat(secureUrl(), "/register/").concat(langKey, "?client_id=3");
    if (utmTracking !== '') {
        registerLink += "&".concat(utmTracking);
    }
    return registerLink;
};
var getForgotPasswordUrl = function (langCode) {
    var langKey = langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en';
    return "".concat(secureUrl(), "/password/").concat(langKey, "/reset?client_id=3");
};
var buildUtm = function (pageName) {
    var utmSource = LoginModal_constants/* UTM_SOURCE_MAPPING */.z4[pageName] || '';
    return "utm_source_navi=".concat(utmSource, "&utm_medium_navi=Header");
};
var getSocialLoginUrl = function (type, langCode, isApply, pageName) {
    // getBaseUrl(false) mean it should return base url without localhost
    var vnwUrl = getBaseUrl(false);
    var loginPath = langCode === constants/* ELanguage.VI */.Df.VI ? 'dang-nhap' : 'login';
    var loginUrl = "https://".concat(vnwUrl, "/").concat(loginPath, "?type=").concat(type);
    if (typeof window === 'undefined') {
        return loginUrl;
    }
    var locationUrl = window.location.href;
    if (isApply) {
        if (locationUrl.indexOf('?') > 0) {
            locationUrl += '&applyJob=1';
        }
        else {
            locationUrl += '?applyJob=1';
        }
    }
    if (window.location.href.indexOf('.com/logout') >= 1) {
        locationUrl =
            langCode === constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change password page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
        locationUrl =
            langCode === constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change email page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
        locationUrl =
            langCode === constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // add utm
    if (locationUrl.indexOf('?') > 0) {
        locationUrl += '&' + buildUtm(pageName);
    }
    else {
        locationUrl += '?' + buildUtm(pageName);
    }
    var encodedRedirectUrl = typeof window !== 'undefined' ? encodeURIComponent(locationUrl) : '';
    if (encodedRedirectUrl !== '') {
        loginUrl += "&redirectURL=".concat(encodedRedirectUrl);
    }
    return loginUrl;
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/services.js
'use client';







var apiGetCSRFToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var API_GET_CSRF_TOKEN, response, repsonseJson, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                API_GET_CSRF_TOKEN = "".concat(secureUrl(), "/api/v1/getCsrfToken");
                return [4 /*yield*/, fetch(API_GET_CSRF_TOKEN)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                repsonseJson = _a.sent();
                return [2 /*return*/, {
                        code: repsonseJson.code,
                        jwtToken: repsonseJson.jwt_token,
                        csrfToken: repsonseJson.csrf_token
                    }];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiDoLogin = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var username, password, csrfToken, jwtToken, langCode, headers, formData, LOGIN_API, requestOptions, response, responseJson, ex_2;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                username = params.username, password = params.password, csrfToken = params.csrfToken, jwtToken = params.jwtToken, langCode = params.langCode;
                headers = new Headers();
                headers.append('X-XSRF-TOKEN', csrfToken);
                headers.append('X-JWT-TOKEN', jwtToken);
                headers.append('Accept-Language', langCode);
                formData = new FormData();
                formData.set('username', username);
                formData.set('password', password);
                LOGIN_API = "".concat(secureUrl(), "/api/v1/login");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: formData
                };
                return [4 /*yield*/, fetch(LOGIN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                responseJson = _a.sent();
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        code: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.code) || 400,
                        message: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.message) || '',
                        accessToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.access_token) || '',
                        refreshToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.refresh_token) || '',
                        expiresIn: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.expires_in) || 0,
                        wsToken: responseJson[LoginModal_constants/* WS_TOKEN */.dD] || '',
                        jsToken: responseJson[LoginModal_constants/* JS_TOKEN */.h4] || '',
                        jsAllToken: responseJson[LoginModal_constants/* JS_ALL_TOKEN */.xX] || '',
                        userCookie: responseJson[LoginModal_constants/* USER_COOKIE */.fT] || '',
                        newRegistered: responseJson[LoginModal_constants/* VNW_NEW_REGISTERED */.JT] || false,
                        scope: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.scope) || ''
                    }];
            case 3:
                ex_2 = _a.sent();
                console.error(ex_2);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiGetUserInfoFromToken = function (jsToken, wsToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var GET_INFO_FROM_TOKEN, response, responseData, user, ex_3;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (jsToken === '') {
                    console.error('Missing jsToken');
                    return [2 /*return*/, null];
                }
                if (wsToken === '') {
                    console.error('Missing wsToken');
                    return [2 /*return*/, null];
                }
                GET_INFO_FROM_TOKEN = "".concat(secureUrl(), "/api/v1/users/get-info-from-token");
                return [4 /*yield*/, fetch(GET_INFO_FROM_TOKEN, {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json'
                        },
                        body: JSON.stringify({ jsToken: jsToken, wsToken: wsToken })
                    })];
            case 1:
                response = _a.sent();
                if (response.status !== type_DEFAULT_SUCCESS_CODE) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                user = responseData.data[0];
                return [2 /*return*/, (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, user.id), user.attributes), { accessToken: (0,helpers/* encrypt */.HI)(user.attributes.accessToken) })];
            case 3:
                ex_3 = _a.sent();
                console.error(ex_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiVerifyAuthToken = function (authToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headers, VERIFY_AUTH_TOKEN_API, requestOptions, response, responseJson, ex_4;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                headers = new Headers();
                headers.append('Content-Type', 'application/json');
                VERIFY_AUTH_TOKEN_API = "".concat(secureUrl(), "/api/v1/users/verify-auth-token");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        auth_token: authToken
                    })
                };
                return [4 /*yield*/, fetch(VERIFY_AUTH_TOKEN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()
                    // Reponse error
                ];
            case 2:
                responseJson = _a.sent();
                // Reponse error
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                // Response success failed
                if (!responseJson.success) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        wsToken: responseJson.data[LoginModal_constants/* WS_TOKEN */.dD] || '',
                        jsToken: responseJson.data[LoginModal_constants/* JS_TOKEN */.h4] || '',
                        jsAllToken: responseJson.data[LoginModal_constants/* JS_ALL_TOKEN */.xX] || '',
                        userCookie: responseJson.data[LoginModal_constants/* USER_COOKIE */.fT] || ''
                    }];
            case 3:
                ex_4 = _a.sent();
                console.error(ex_4);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useIdentify/index.js
var useIdentify = __webpack_require__(205);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/utils.js
var utils = __webpack_require__(32322);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LoginModal/index.js
'use client';






















var LoginModal = function (props) {
    var langCode = props.langCode, _a = props.isReloadOnLoggedIn, isReloadOnLoggedIn = _a === void 0 ? false : _a, _b = props.pageName, pageName = _b === void 0 ? LoginModal_constants/* EPages.OTHER */.QS.OTHER : _b, _c = props.utmTracking, utmTracking = _c === void 0 ? '' : _c;
    var _d = (0,react.useState)(langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'), modalLangCode = _d[0], setLangCode = _d[1];
    var _e = (0,react.useState)(false), isMounted = _e[0], setMounted = _e[1];
    // Forms
    var _f = (0,react.useState)(''), username = _f[0], setUsername = _f[1];
    var _g = (0,react.useState)(''), password = _g[0], setPassword = _g[1];
    var _h = (0,react.useState)(''), csrfToken = _h[0], setCsrfToken = _h[1];
    var _j = (0,react.useState)(''), jwtToken = _j[0], setJwtToken = _j[1];
    // Errors
    var _k = (0,react.useState)(false), isUsernameError = _k[0], setUsernameError = _k[1];
    var _l = (0,react.useState)(false), isPasswordError = _l[0], setPasswordError = _l[1];
    var _m = (0,react.useState)('NONE'), apiError = _m[0], setAPIError = _m[1];
    // End Forms
    var _o = (0,react.useState)(false), isLoginDisabled = _o[0], setIsLoginDisabled = _o[1];
    var _p = (0,react.useState)(false), isLoggingIn = _p[0], setIsLoggingIn = _p[1];
    // Other
    var _q = (0,react.useState)(isReloadOnLoggedIn), isNeedReload = _q[0], setIsNeedReload = _q[1];
    var _r = (0,react.useState)(false), isApply = _r[0], setIsApply = _r[1];
    var _s = (0,react.useState)(''), socialUtm = _s[0], setSocialUtm = _s[1];
    var _t = (0,react.useState)(false), isRegisterOnNewTab = _t[0], setRegisterOnNewTab = _t[1];
    // Callback on success
    var onLoggedInRef = (0,react.useRef)(null);
    // Callback on close popup login
    var onCancelPopupRef = (0,react.useRef)(null);
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = function (text) {
        var _a;
        if (modalLangCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = LoginModal_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var showLoginModal = function (e, isNeedReload) {
        var _a, _b, _c, _d, _e;
        if (isNeedReload === void 0) { isNeedReload = false; }
        // window function
        if (typeof e === 'string') {
            setLangCode(e);
            setIsNeedReload(isNeedReload);
        }
        // window event
        if (typeof e === 'object') {
            var eventDetail = e.detail;
            setLangCode((_a = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.langCode) !== null && _a !== void 0 ? _a : 'vi');
            setIsNeedReload((_b = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNeedReload) !== null && _b !== void 0 ? _b : false);
            setIsApply((_c = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isApply) !== null && _c !== void 0 ? _c : false);
            setSocialUtm((_d = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.utm) !== null && _d !== void 0 ? _d : '');
            setRegisterOnNewTab((_e = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNewTabOnRegister) !== null && _e !== void 0 ? _e : false);
            onLoggedInRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onLoggedIn;
            onCancelPopupRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onCancelPopup;
        }
        setMounted(true);
    };
    var doLogin = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var hasError, response, letCheckReload, jsToken, wsToken, userInfo;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoginDisabled(true);
                    setIsLoggingIn(true);
                    hasError = false;
                    // username
                    if (username.length === 0) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // email not valid
                    if (!(0,helpers/* checkIfEmailInString */.n3)(username)) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // password
                    if (password.length === 0) {
                        setPasswordError(true);
                        hasError = true;
                    }
                    if (hasError) {
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiDoLogin({
                            username: username,
                            password: password,
                            csrfToken: csrfToken,
                            jwtToken: jwtToken,
                            langCode: modalLangCode
                        })];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== type_DEFAULT_SUCCESS_CODE) {
                        // show login error
                        // waiting backend response correct error message for user not active
                        if ((response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_NOT_ACTIVE_EN */.S3 || (response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_NOT_ACTIVE_VI */.$v) {
                            setAPIError('USER_NOT_ACTIVE');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_EMPLOYER_EN */.Ic || (response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_EMPLOYER_VI */.fQ) {
                            setAPIError('USER_EMPLOYER');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_BANNED_EN */.$p || (response === null || response === void 0 ? void 0 : response.message) === LoginModal_constants/* USER_BANNED_VI */.bU) {
                            setAPIError('USER_BANNED');
                        }
                        else {
                            setAPIError('WRONG_USER_PASS');
                        }
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    tracking({
                        eventName: 'js_registration:login_success',
                        properties: {
                            isEmail: true,
                            isFacebook: false,
                            isGoogle: false,
                            isAppleid: false
                        }
                    });
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_TOKEN */.dD, encodeURIComponent(response.wsToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_TOKEN */.h4, encodeURIComponent(response.jsToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_ALL_TOKEN */.xX, encodeURIComponent(response.jsAllToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* USER_COOKIE */.fT, encodeURIComponent(response.userCookie), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_COOKIE */.kd, encodeURIComponent(response.wsToken), 730);
                    letCheckReload = isNeedReload;
                    if (response.newRegistered) {
                        // Temporary disabled reload request when showing up onboarding
                        letCheckReload = false;
                    }
                    if (!letCheckReload) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0,utils/* delay */.gw)(200)];
                case 2:
                    _a.sent();
                    window.location.reload();
                    return [2 /*return*/];
                case 3:
                    // Change password page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
                        window.location.href =
                            langCode === constants/* ELanguage.VI */.Df.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    // Change email page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
                        window.location.href =
                            langCode === constants/* ELanguage.VI */.Df.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    _a.label = 4;
                case 4:
                    jsToken = decodeURIComponent(response.jsToken || '');
                    wsToken = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsToken, wsToken)
                        // Delay 100ms for cookie all done
                    ];
                case 5:
                    userInfo = _a.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        if (!userInfo) {
                            setAPIError('WRONG_USER_PASS');
                            return;
                        }
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(LoginModal_constants/* UPDATE_USER */.AX, {
                            detail: {
                                user: userInfo,
                                isNewRegistered: response.newRegistered,
                                isApply: isApply
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                        if (typeof window !== 'undefined') {
                            try {
                                (0,useIdentify/* sendHogIdentify */.PJ)(window.posthog, userInfo, getBaseMsUrl());
                            }
                            catch (ex) {
                                console.error('postHog', ex);
                            }
                        }
                        setAPIError('NONE');
                        setMounted(false);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var inputKeyUp = function (e, type) {
        // turn off error message when keyUp
        if (type === 'email') {
            setUsernameError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
        }
        if (type === 'password') {
            setIsLoginDisabled(false);
            setPasswordError(false);
        }
        if (e.key === 'Enter') {
            setUsernameError(false);
            setAPIError('NONE');
            setPasswordError(false);
            doLogin();
        }
    };
    var getCSRFToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var csrfTokenResponse;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Don't get csrf token again if it already exists
                    if (csrfToken !== null && csrfToken !== '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiGetCSRFToken()];
                case 1:
                    csrfTokenResponse = _a.sent();
                    setIsLoginDisabled(false);
                    if (csrfTokenResponse === null) {
                        return [2 /*return*/];
                    }
                    setCsrfToken((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.csrfToken) || '');
                    setJwtToken((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.jwtToken) || '');
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* VNW_CSRF_JWT_TOKEN */.uK, encodeURIComponent((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.jwtToken) || ''), 730);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderErrorMessage = function () {
        if (apiError === 'NONE') {
            return null;
        }
        if (apiError === 'USER_NOT_ACTIVE') {
            return (react.createElement(LoginModal_css_ErrorMessage, null, t('You have not verified your email. Please check your email inbox for instruction.')));
        }
        else if (apiError === 'USER_EMPLOYER') {
            return (react.createElement(LoginModal_css_ErrorMessage, null, t('This email address is registered as Employer, please Sign in from Employer Site.')));
        }
        else if (apiError === 'USER_BANNED') {
            return (react.createElement(LoginModal_css_ErrorMessage, null, t('The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.')));
        }
        return react.createElement(LoginModal_css_ErrorMessage, null, t('Wrong email or password. Please check again.'));
    };
    /**
     * Verify Auth Token and login in WebView (Mobile)
     */
    var getAuthTokenFromUrl = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var rawSearchParams, searchParamsPair, searchParams, filteredParams, authToken, response, jsToken, wsToken, userInfo;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (typeof window === 'undefined') {
                        return [2 /*return*/];
                    }
                    rawSearchParams = window.location.search.replace('?', '');
                    searchParamsPair = rawSearchParams.split('&');
                    searchParams = [];
                    searchParamsPair.map(function (item) {
                        var _a, _b, _c;
                        var query = item.split('=');
                        // Only check if query have a pair key value
                        if (query.length < 2) {
                            return;
                        }
                        searchParams.push({
                            key: (_b = (_a = query[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '',
                            value: (_c = query[1]) !== null && _c !== void 0 ? _c : ''
                        });
                    });
                    filteredParams = searchParams.filter(function (item) { return item.key === LoginModal_constants/* KEY_AUTH_TOKEN */.vG; });
                    if (filteredParams.length === 0) {
                        return [2 /*return*/];
                    }
                    authToken = (_b = (_a = filteredParams[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                    if (authToken === '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiVerifyAuthToken(authToken)
                        // handle response null error first
                    ];
                case 1:
                    response = _c.sent();
                    // handle response null error first
                    if (response === null) {
                        return [2 /*return*/];
                    }
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_TOKEN */.dD, encodeURIComponent(response.wsToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_TOKEN */.h4, encodeURIComponent(response.jsToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_ALL_TOKEN */.xX, encodeURIComponent(response.jsAllToken), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* USER_COOKIE */.fT, encodeURIComponent(response.userCookie), 730);
                    (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_COOKIE */.kd, encodeURIComponent(response.wsToken), 730);
                    jsToken = decodeURIComponent(response.jsToken || '');
                    wsToken = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsToken, wsToken)
                        // Delay 100ms for cookie all done
                    ];
                case 2:
                    userInfo = _c.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(LoginModal_constants/* UPDATE_USER */.AX, {
                            detail: {
                                user: userInfo
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var buildSocialLink = function (socialName) {
        var socialLoginLink = getSocialLoginUrl(socialName, langCode, isApply, pageName);
        if (utmTracking !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(utmTracking));
        }
        if (socialUtm !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(socialUtm));
        }
        return socialLoginLink;
    };
    (0,react.useEffect)(function () {
        window.addEventListener(LoginModal_constants/* LOGIN_POPUP */.eS, showLoginModal);
        window.showLoginModal = showLoginModal;
        // For mobile WebView
        getAuthTokenFromUrl();
        return function () {
            window.removeEventListener(LoginModal_constants/* LOGIN_POPUP */.eS, showLoginModal);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (!isMounted) {
            setUsernameError(false);
            setPasswordError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
            return;
        }
        getCSRFToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMounted]);
    (0,react.useEffect)(function () {
        setLangCode(langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en');
    }, [langCode]);
    return (react.createElement(Popup/* default */.Z, { isShow: isMounted, lang: modalLangCode === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, text: {
            header: t('Sign in to continue'),
            primaryBtn: (react.createElement(react.Fragment, null,
                isLoggingIn ? (react.createElement(react.Fragment, null,
                    react.createElement(LoadingIcon/* default */.Z, { bgColor: '#fff' }))) : null,
                ' ',
                t('Login')))
        }, option: {
            isCloseOnClickBackdrop: true,
            disabledPrimary: isLoginDisabled
        }, custom: {
            leftFooterAlert: (react.createElement(react.Fragment, null,
                t("Don't have an account yet?"),
                ' ',
                react.createElement(RegisterLink, (0,_tslib/* __assign */.pi)({ href: getRegisterUrl(modalLangCode === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, utmTracking) }, (isRegisterOnNewTab
                    ? {
                        target: '_blank'
                    }
                    : null)), t('Register now'))))
        }, onClose: function () {
            setMounted(false);
            onCancelPopupRef.current && onCancelPopupRef.current();
        }, onClickPrimary: doLogin },
        react.createElement(LoginModalContainerWrapper, null,
            react.createElement(SocialLoginGroup, null,
                react.createElement(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('google')); } },
                    react.createElement(GoogleLogoIcon$1, null),
                    " ",
                    !helper_isMobile() ? react.createElement("span", null, t('with Google account')) : null),
                react.createElement(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('facebook')); } },
                    react.createElement(FacebookLogoIcon$1, null),
                    " ",
                    !helper_isMobile() ? react.createElement("span", null, t('with Facebook account')) : null)),
            react.createElement(SmallLabel, null, t('or with your email')),
            react.createElement(LoginModal_css_InputGroup, null,
                react.createElement(LabelInput, null,
                    t('Email'),
                    react.createElement("span", null, "*")),
                react.createElement(components_Input/* default */.Z, { hasError: isUsernameError || apiError !== 'NONE', value: username, name: 'username', onChange: function (e) { return setUsername(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'email'); }, autoFocus: true, disabled: isLoggingIn }),
                isUsernameError ? (react.createElement(LoginModal_css_ErrorMessage, null, username.length === 0
                    ? t('The Email field is required.')
                    : t('The Email must be a valid Email address.'))) : null,
                renderErrorMessage()),
            react.createElement(LoginModal_css_InputGroup, null,
                react.createElement(LabelInput, null,
                    t('Password'),
                    react.createElement("span", null, "*")),
                react.createElement(components_Input/* default */.Z, { hasError: isPasswordError, value: password, type: 'password', icon: 'password', onChange: function (e) { return setPassword(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'password'); }, disabled: isLoggingIn }),
                isPasswordError ? react.createElement(LoginModal_css_ErrorMessage, null, t('The Password field is required.')) : null),
            react.createElement(ForgotGroup, null,
                react.createElement(ForgotPasswordLink, { href: getForgotPasswordUrl(modalLangCode === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN) }, t('Forgot Password?'))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadFile/UploadFile.css.js
'use client';





var progressBarStripes = (0,styled_components_browser_esm/* keyframes */.F4)(UploadFile_css_templateObject_1 || (UploadFile_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        background-position-x: 32px;\n    }\n"], ["\n    0% {\n        background-position-x: 32px;\n    }\n"])));
var UploadFileWrapper = styled_components_browser_esm/* default.div */.ZP.div(UploadFile_css_templateObject_2 || (UploadFile_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 100%;\n    gap: 12px;\n"], ["\n    display: flex;\n    width: 100%;\n    gap: 12px;\n"])));
var ImgPreview = styled_components_browser_esm/* default.img */.ZP.img(UploadFile_css_templateObject_3 || (UploadFile_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 44px;\n    height: 44px;\n    overflow: hidden;\n    border-radius: 4px;\n"], ["\n    width: 44px;\n    height: 44px;\n    overflow: hidden;\n    border-radius: 4px;\n"])));
var Filename = styled_components_browser_esm/* default.div */.ZP.div(UploadFile_css_templateObject_4 || (UploadFile_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-overflow: ellipsis;\n    line-height: 20px;\n    height: 20px;\n    width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n"], ["\n    text-overflow: ellipsis;\n    line-height: 20px;\n    height: 20px;\n    width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n"])));
var UploadFile_css_Row = styled_components_browser_esm/* default.div */.ZP.div(UploadFile_css_templateObject_5 || (UploadFile_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n"])));
var Column = styled_components_browser_esm/* default.div */.ZP.div(UploadFile_css_templateObject_6 || (UploadFile_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
var ProgressBarItem = styled_components_browser_esm/* default.div */.ZP.div(UploadFile_css_templateObject_7 || (UploadFile_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 5px;\n    background-color: #d9e6ff;\n    width: 100%;\n    width: 386px;\n    height: 10px;\n    position: relative;\n    overflow: hidden;\n"], ["\n    border-radius: 5px;\n    background-color: #d9e6ff;\n    width: 100%;\n    width: 386px;\n    height: 10px;\n    position: relative;\n    overflow: hidden;\n"])));
var Progress = styled_components_browser_esm/* default.span */.ZP.span(UploadFile_css_templateObject_9 || (UploadFile_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: ", ";\n    border-radius: 5px;\n    height: 10px;\n    display: flex;\n    ", "\n"], ["\n    background-color: ", ";\n    border-radius: 5px;\n    height: 10px;\n    display: flex;\n    ", "\n"])), function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : constants/* colors.primaryColor */.O9.primaryColor;
}, function (_a) {
    var isUploading = _a.isUploading;
    if (!isUploading) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(UploadFile_css_templateObject_8 || (UploadFile_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            animation: 1s linear infinite ", ";\n            background-image: linear-gradient(\n                45deg,\n                rgba(255, 255, 255, 0.15) 25%,\n                transparent 25%,\n                transparent 50%,\n                rgba(255, 255, 255, 0.15) 50%,\n                rgba(255, 255, 255, 0.15) 75%,\n                transparent 75%,\n                transparent\n            );\n            background-size: 32px 32px;\n        "], ["\n            animation: 1s linear infinite ", ";\n            background-image: linear-gradient(\n                45deg,\n                rgba(255, 255, 255, 0.15) 25%,\n                transparent 25%,\n                transparent 50%,\n                rgba(255, 255, 255, 0.15) 50%,\n                rgba(255, 255, 255, 0.15) 75%,\n                transparent 75%,\n                transparent\n            );\n            background-size: 32px 32px;\n        "])), progressBarStripes);
});
var UploadFile_css_templateObject_1, UploadFile_css_templateObject_2, UploadFile_css_templateObject_3, UploadFile_css_templateObject_4, UploadFile_css_templateObject_5, UploadFile_css_templateObject_6, UploadFile_css_templateObject_7, UploadFile_css_templateObject_8, UploadFile_css_templateObject_9;


//# sourceMappingURL=UploadFile.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadFile/services.js
'use client';



/**
 * Upload with progress value
 * Only in XMLHttpRequest allow for addEventListener
 */
var services_uploadFile = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var file, apiUpload, onProgress, onLoad_1, onError_1, data, request_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        try {
            file = params.file, apiUpload = params.apiUpload, onProgress = params.onProgress, onLoad_1 = params.onLoad, onError_1 = params.onError;
            data = new FormData();
            data.append('file', file);
            data.append('jobId', '0');
            data.append('jobseekerId', '0');
            request_1 = new XMLHttpRequest();
            request_1.open('POST', apiUpload);
            // upload progress event
            onProgress && request_1.upload.addEventListener('progress', onProgress);
            // Error progress event
            onError_1 &&
                request_1.addEventListener('error', function (e) {
                    onError_1(e.type);
                });
            // request finished event
            onLoad_1 &&
                request_1.addEventListener('load', function () {
                    onLoad_1(request_1);
                });
            // send POST request to server
            request_1.send(data);
        }
        catch (ex) {
            console.error('upload error', ex);
        }
        return [2 /*return*/];
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadFile/constants.js
'use client';

var UploadFile_constants_DEFAULT_OPTIONS = {
    isShowDeleteButton: true,
    isShowPreviewButton: true
};


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/EyesOpenIcon/index.js
var EyesOpenIcon = __webpack_require__(18585);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/UploadFile/index.js
'use client';











var UploadFile_UploadFile = function (props) {
    var _a = props.file, file = _a === void 0 ? null : _a, apiUpload = props.apiUpload, _b = props.color, color = _b === void 0 ? constants/* colors.primaryColor */.O9.primaryColor : _b, options = props.options, onClickPreviewButton = props.onClickPreviewButton, onClickDeleteButton = props.onClickDeleteButton, onProgress = props.onProgress, onDone = props.onDone;
    var mergedOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, UploadFile_constants_DEFAULT_OPTIONS), options);
    var _c = (0,react.useState)(0), uploadPercent = _c[0], setUploadPercent = _c[1];
    var _d = (0,react.useState)('NONE'), uploadState = _d[0], setUploadState = _d[1];
    var onUploadProgress = function (e) {
        // upload progress as percentage
        var percentCompleted = Math.round((e.loaded / e.total) * 100);
        setUploadPercent(percentCompleted);
        onProgress && onProgress(percentCompleted);
    };
    var onUploadLoad = function (request) {
        if (request.status === 200) {
            setUploadState('SUCCESS');
            onDone && onDone('SUCCESS');
        }
    };
    var onUploadError = function (type) {
        setUploadState('ERROR');
        onDone && onDone('ERROR');
    };
    (0,react.useEffect)(function () {
        if (file === null) {
            return;
        }
        setUploadState('UPLOADING');
        // do bind upload function
        services_uploadFile({
            file: file,
            apiUpload: apiUpload,
            onProgress: onUploadProgress,
            onLoad: onUploadLoad,
            onError: onUploadError
        });
    }, [file]);
    var renderRightInfo = function () {
        if (uploadState === 'UPLOADING') {
            return react.createElement(react.Fragment, null,
                uploadPercent,
                "%");
        }
        return (react.createElement(UploadFile_css_Row, null,
            mergedOptions.isShowPreviewButton ? (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return onClickPreviewButton && onClickPreviewButton(); } },
                react.createElement(EyesOpenIcon/* default */.Z, null))) : null,
            mergedOptions.isShowDeleteButton ? (react.createElement(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return onClickDeleteButton && onClickDeleteButton(); } },
                react.createElement(Trash$1, null))) : null));
    };
    var getUploadColor = function () {
        if (uploadState === 'SUCCESS') {
            return constants/* colors.successColor */.O9.successColor;
        }
        else if (uploadState === 'ERROR') {
            return constants/* colors.dangerColor */.O9.dangerColor;
        }
        return color;
    };
    var renderPreview = (0,react.useMemo)(function () {
        var objBlob = null;
        if (file !== null) {
            objBlob = URL.createObjectURL(file);
        }
        return react.createElement(Column, null, objBlob !== null ? react.createElement(ImgPreview, { src: objBlob, alt: file === null || file === void 0 ? void 0 : file.name }) : null);
    }, [file]);
    return (react.createElement(UploadFileWrapper, null,
        renderPreview,
        react.createElement(Column, null,
            react.createElement(Filename, null, file === null || file === void 0 ? void 0 : file.name),
            react.createElement(UploadFile_css_Row, null,
                react.createElement(Column, null,
                    react.createElement(ProgressBarItem, null,
                        react.createElement(Progress, { color: getUploadColor(), isUploading: uploadState === 'UPLOADING', style: {
                                width: "".concat(uploadPercent, "%")
                            } }))),
                react.createElement(Column, null, renderRightInfo())))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AspectRatio/styles.js
'use client';




var AspectRatio_styles_Container = styled_components_browser_esm/* default.div */.ZP.div(AspectRatio_styles_templateObject_1 || (AspectRatio_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    ", "\n    &::before {\n        content: '';\n        display: block;\n        height: 0;\n        padding-bottom: ", "%;\n    }\n"], ["\n    position: relative;\n    ", "\n    &::before {\n        content: '';\n        display: block;\n        height: 0;\n        padding-bottom: ", "%;\n    }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "max-width: ".concat(maxWidth, "px;") : '');
}, function (_a) {
    var ratioInPercent = _a.ratioInPercent;
    return ratioInPercent;
});
var styles_Content = styled_components_browser_esm/* default.div */.ZP.div(AspectRatio_styles_templateObject_2 || (AspectRatio_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"], ["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"])));
var AspectRatio_styles_templateObject_1, AspectRatio_styles_templateObject_2;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AspectRatio/index.js
'use client';




var AspectRatio = function (_a) {
    var ratio = _a.ratio, maxWidth = _a.maxWidth, children = _a.children;
    var ratioInPercent = Math.pow(ratio, -1) * 100;
    return (react.createElement(AspectRatio_styles_Container, { maxWidth: maxWidth, ratioInPercent: ratioInPercent },
        react.createElement(styles_Content, null, children)));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Avatar/index.js + 1 modules
var Avatar = __webpack_require__(1247);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/type.js
'use client';

var type_EApplyType;
(function (EApplyType) {
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(type_EApplyType || (type_EApplyType = {}));


//# sourceMappingURL=type.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/styled.css.js
'use client';






var styled_css_Container = styled_components_browser_esm/* default.div */.ZP.div(ApplyJobsForm_styled_css_templateObject_1 || (ApplyJobsForm_styled_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 12px;\n    border: 1px solid ", ";\n    background: ", ";\n    padding: ", ";\n    @media screen and (max-width: 768px) {\n        padding: 16px;\n    }\n"], ["\n    border-radius: 12px;\n    border: 1px solid ", ";\n    background: ", ";\n    padding: ", ";\n    @media screen and (max-width: 768px) {\n        padding: 16px;\n    }\n"])), Colors/* colors.primary.80 */.O9.primary[80], Colors/* colors.primary.99 */.O9.primary[99], function (_a) {
    var isInPopup = _a.isInPopup;
    return (isInPopup ? '16px' : '24px');
});
var WrapInfo = styled_components_browser_esm/* default.div */.ZP.div(ApplyJobsForm_styled_css_templateObject_2 || (ApplyJobsForm_styled_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n"], ["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n"])));
var WrapLabel = styled_components_browser_esm/* default.div */.ZP.div(ApplyJobsForm_styled_css_templateObject_3 || (ApplyJobsForm_styled_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    position: relative;\n"], ["\n    width: 100%;\n    position: relative;\n"])));
var LinkCover = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Anchor */.ee)(ApplyJobsForm_styled_css_templateObject_4 || (ApplyJobsForm_styled_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: max-content;\n    text-align: right;\n"], ["\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: max-content;\n    text-align: right;\n"])));
var Box = styled_components_browser_esm/* default.div */.ZP.div(ApplyJobsForm_styled_css_templateObject_8 || (ApplyJobsForm_styled_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var display = _a.display;
    switch (display) {
        case 'grid':
            return (0,styled_components_browser_esm/* css */.iv)(ApplyJobsForm_styled_css_templateObject_5 || (ApplyJobsForm_styled_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    display: grid;\n                    grid-template-columns: max-content auto;\n                    gap: 24px 16px;\n                "], ["\n                    display: grid;\n                    grid-template-columns: max-content auto;\n                    gap: 24px 16px;\n                "])));
        case 'block':
            return (0,styled_components_browser_esm/* css */.iv)(ApplyJobsForm_styled_css_templateObject_6 || (ApplyJobsForm_styled_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
        default:
            return (0,styled_components_browser_esm/* css */.iv)(ApplyJobsForm_styled_css_templateObject_7 || (ApplyJobsForm_styled_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }
});
var ApplyJobsForm_styled_css_templateObject_1, ApplyJobsForm_styled_css_templateObject_2, ApplyJobsForm_styled_css_templateObject_3, ApplyJobsForm_styled_css_templateObject_4, ApplyJobsForm_styled_css_templateObject_5, ApplyJobsForm_styled_css_templateObject_6, ApplyJobsForm_styled_css_templateObject_7, ApplyJobsForm_styled_css_templateObject_8;


//# sourceMappingURL=styled.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TextareaNew/index.js + 1 modules
var TextareaNew = __webpack_require__(30178);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/index.js + 4 modules
var DragDropResumeUpload = __webpack_require__(46475);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/helper.js
var helper = __webpack_require__(35753);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/translations.js
'use client';

var ApplyJobsForm_translations_translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Please upload your attached CV to apply': 'Vui lòng đính kèm CV của bạn để ứng tuyển',
    'Upload your attached CV to apply': 'Đính kèm CV của bạn để ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks Profile': 'Hồ Sơ VietnamWorks',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'This is not a valid number.': 'Số không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    'Attached CV': 'Hồ Sơ Đính Kèm',
    'CV Just Uploaded': 'Hồ Sơ Vừa Tải Lên',
    'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:': 'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:',
    'Not enough information to use the function Allow Employers to search attached CV. Update information at': 'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại',
    'Profile settings': 'Thiết lập hồ sơ',
    'my-profile': 'ho-so',
    'profile-settings': 'thiet-lap-ho-so',
    'my-career-center': 'quan-ly-nghe-nghiep',
    Updated: 'Đã cập nhật',
    Uploaded: 'Đã tải lên',
    Update: 'Cập nhật',
    'Update profile': 'Cập nhật',
    'VietnamWorks online Profile': 'Hồ sơ online VietnamWorks',
    Resume: 'Resume',
    View: 'Xem',
    'View CV': 'Xem hồ sơ',
    Any: 'Bất kỳ',
    completed: 'hoàn thiện',
    'By Vietnamworks profile': 'Bằng hồ sơ Vietnamworks',
    'By attached CVs': 'Bằng hồ sơ đính kèm',
    'Cancel': 'Huỷ',
    'Just uploaded': 'Vừa tải lên',
    'Not approved': 'Chưa được duyệt',
    'preview-resume/': 'xem-truoc-ho-so/',
    'View as employer': 'Xem như nhà tuyển dụng',
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/const.js
var ApplyJobsForm_const = __webpack_require__(79506);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PopupCVReplace/index.js + 2 modules
var PopupCVReplace = __webpack_require__(33288);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/resumes/types.js
var resumes_types = __webpack_require__(53877);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PDFIcon/index.js
'use client';



var PDFIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#005AFF' : _e;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'PDF' },
            react.createElement("path", { id: 'Vector', d: 'M5.6 2.40039C4.716 2.40039 4 3.11639 4 4.00039V20.8004C4 21.6844 4.716 22.4004 5.6 22.4004H18.4C19.284 22.4004 20 21.6844 20 20.8004V8.40039C20 8.18839 19.916 7.98517 19.7656 7.83477L14.5656 2.63477C14.4152 2.48437 14.212 2.40039 14 2.40039H5.6ZM13.6 3.92383L18.4766 8.80039H14.4C13.9584 8.80039 13.6 8.44199 13.6 8.00039V3.92383ZM7.65469 12.1363C7.90029 12.1363 8.14209 12.1595 8.37969 12.2051C8.61729 12.2507 8.82923 12.3387 9.01563 12.4723C9.20203 12.6059 9.35508 12.7939 9.47188 13.0363C9.58868 13.2795 9.64688 13.596 9.64688 13.9848C9.64768 14.3368 9.5984 14.6345 9.5 14.8801C9.4008 15.1257 9.26949 15.3257 9.10469 15.4801C8.93909 15.6345 8.74725 15.7464 8.53125 15.816C8.31445 15.8856 8.09286 15.9207 7.86406 15.9207H7.75938C7.71058 15.9207 7.66061 15.9192 7.60781 15.916C7.55501 15.9128 7.50196 15.9107 7.45156 15.9051C7.40116 15.9003 7.36535 15.8935 7.34375 15.8879V17.816H6.33594V12.2723C6.52794 12.2299 6.73915 12.1963 6.96875 12.1723C7.19755 12.1483 7.42589 12.1363 7.65469 12.1363ZM11.7188 12.1363C12.1612 12.1363 12.5306 12.205 12.8266 12.341C13.1226 12.477 13.3607 12.668 13.5391 12.916C13.7183 13.164 13.8436 13.4618 13.9188 13.8082C13.9931 14.1546 14.0313 14.5427 14.0313 14.9691C14.0313 15.3587 13.9954 15.7304 13.9234 16.0848C13.8514 16.4392 13.7254 16.7511 13.5438 17.0207C13.3613 17.2903 13.1159 17.5045 12.8063 17.6645C12.4967 17.8245 12.1087 17.9051 11.6391 17.9051C11.5703 17.9051 11.4754 17.9013 11.3578 17.8957C11.241 17.8901 11.1186 17.885 10.9906 17.877C10.8626 17.869 10.7395 17.86 10.6219 17.852C10.5051 17.844 10.414 17.835 10.35 17.8238V12.216C10.446 12.2 10.555 12.1881 10.675 12.1801C10.7942 12.1721 10.9166 12.1646 11.0422 12.1566C11.167 12.1486 11.2894 12.1434 11.4062 12.141C11.5239 12.1386 11.6276 12.1363 11.7188 12.1363ZM14.8313 12.216H17.6313V13.1441H15.8406V14.6004H17.4875V15.5285H15.8406V17.816H14.8313V12.216ZM7.75156 13.0316C7.58676 13.0316 7.45095 13.0459 7.34375 13.0723V14.9848C7.37575 14.996 7.43544 15.0049 7.52344 15.0129C7.61144 15.0209 7.67269 15.0238 7.70469 15.0238C7.82149 15.0238 7.93343 15.009 8.04063 14.977C8.14703 14.945 8.24184 14.8905 8.32344 14.8129C8.40664 14.7353 8.47311 14.6286 8.52031 14.4926C8.56911 14.3566 8.59219 14.185 8.59219 13.977C8.59219 13.801 8.56904 13.6509 8.52344 13.5285C8.47784 13.4061 8.41743 13.3083 8.34063 13.2363C8.26303 13.1643 8.17268 13.1121 8.07188 13.0801C7.97027 13.0481 7.86356 13.0316 7.75156 13.0316ZM11.8234 13.0645C11.7386 13.0645 11.6521 13.0659 11.5641 13.0691C11.4769 13.0715 11.4074 13.0775 11.3594 13.0879V16.9441C11.3762 16.9489 11.4038 16.9542 11.4438 16.9566C11.4838 16.959 11.5271 16.9621 11.5719 16.9645C11.6167 16.9669 11.6584 16.9699 11.6984 16.9723C11.7384 16.9747 11.7668 16.977 11.7828 16.977C12.0228 16.977 12.2198 16.9202 12.375 16.8082C12.5286 16.6962 12.6519 16.5462 12.7391 16.3598C12.8271 16.1734 12.8875 15.9584 12.9219 15.716C12.9563 15.4736 12.975 15.2184 12.975 14.952C12.975 14.7064 12.9593 14.4706 12.9297 14.241C12.9025 14.0122 12.8457 13.8099 12.7625 13.6363C12.6793 13.4635 12.5637 13.3247 12.4125 13.2207C12.2605 13.1167 12.0626 13.0645 11.8234 13.0645Z', fill: color }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/EditIcon.js
'use client';




var EditIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.fill, fill = _c === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _c;
    return (react.createElement("svg", { width: size, height: size, viewBox: "0 0 20 20", fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M15.2188 2C14.8776 2 14.5364 2.13029 14.276 2.39062L12.6667 4L16 7.33333L17.6094 5.72396C18.13 5.20329 18.13 4.35921 17.6094 3.83854L16.1615 2.39062C15.9011 2.13029 15.5599 2 15.2188 2ZM11.3333 5.33333L3.50651 13.1602C3.50651 13.1602 4.11835 13.1053 4.34635 13.3333C4.57435 13.5613 4.38667 15.0533 4.66667 15.3333C4.94667 15.6133 6.42926 15.4162 6.64193 15.6289C6.85459 15.8416 6.83984 16.4935 6.83984 16.4935L14.6667 8.66667L11.3333 5.33333ZM2.66667 15.3333L2.03776 17.1146C2.01304 17.1849 2.00027 17.2588 2 17.3333C2 17.5101 2.07024 17.6797 2.19526 17.8047C2.32029 17.9298 2.48986 18 2.66667 18C2.74118 17.9997 2.81512 17.987 2.88542 17.9622C2.88759 17.9614 2.88976 17.9605 2.89193 17.9596L2.90885 17.9544C2.91016 17.9536 2.91146 17.9527 2.91276 17.9518L4.66667 17.3333L3.66667 16.3333L2.66667 15.3333Z", fill: fill })));
};
var EditIcon$1 = react.memo(EditIcon);


//# sourceMappingURL=EditIcon.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/components/ResponsiveSheet/index.js
var ResponsiveSheet = __webpack_require__(90231);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/EmployerViewIcon/index.js
'use client';



var EmployerViewIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 21 : _b, _c = _a.height, height = _c === void 0 ? 21 : _c, _d = _a.color, color = _d === void 0 ? '#797979' : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M0 0V15.6213C0 16.4805 0.695148 17.1834 1.56213 17.1834H8.21644C7.95088 16.4492 7.81065 15.6604 7.81065 14.8402C7.81065 10.9583 10.9583 7.81065 14.8402 7.81065C15.6604 7.81065 16.4492 7.95088 17.1834 8.21644V0H0ZM6.24852 1.56213H10.9349C11.3645 1.56213 11.716 1.91361 11.716 2.3432C11.716 2.77278 11.3645 3.12426 10.9349 3.12426H6.24852C5.81893 3.12426 5.46746 2.77278 5.46746 2.3432C5.46746 1.91361 5.81893 1.56213 6.24852 1.56213ZM14.8402 9.37278C12.3564 9.37278 10.2703 11.0208 9.59856 13.2781C9.52436 13.5241 9.46883 13.7787 9.43075 14.0393C9.39267 14.3 9.37278 14.5669 9.37278 14.8402C9.37278 15.4729 9.47865 16.0745 9.67636 16.6358C9.74226 16.8229 9.81774 17.0057 9.90366 17.1834C10.7785 19.0346 12.6533 20.3077 14.8402 20.3077C17.863 20.3077 20.3077 17.863 20.3077 14.8402C20.3077 12.6533 19.0346 10.7785 17.1834 9.90366C16.4727 9.55999 15.6838 9.37278 14.8402 9.37278ZM14.8402 12.404C15.7775 12.404 16.5664 12.7627 17.1834 13.2079C18.1832 13.9109 18.7456 14.8402 18.7456 14.8402C18.7456 14.8402 17.9794 16.1128 16.6281 16.8158C16.6281 16.8236 16.6283 16.8234 16.6205 16.8234C16.3393 16.9718 16.0348 17.0899 15.7067 17.1758C15.6911 17.1758 15.6766 17.1834 15.661 17.1834C15.5321 17.2147 15.398 17.238 15.2613 17.2536C15.1246 17.2692 14.9847 17.2765 14.8402 17.2765C14.5512 17.2765 14.2773 17.2459 14.0195 17.1834C13.7764 17.1278 13.5458 17.0491 13.3284 16.9546C11.8073 16.2931 10.9349 14.8402 10.9349 14.8402C10.9349 14.8402 11.0261 14.6873 11.2019 14.4589C11.7291 13.7735 13.0125 12.404 14.8402 12.404ZM14.8402 13.3712C14.7387 13.3712 14.64 13.3821 14.5443 13.4017C14.3529 13.4407 14.1742 13.5174 14.018 13.6229C13.9399 13.6756 13.8677 13.735 13.8014 13.8014C13.735 13.8677 13.6756 13.9399 13.6229 14.018C13.5702 14.0961 13.5242 14.1803 13.4871 14.2682C13.45 14.356 13.4212 14.4486 13.4017 14.5443C13.3821 14.64 13.3712 14.7387 13.3712 14.8402C13.3712 14.9418 13.3821 15.0405 13.4017 15.1362C13.4212 15.2319 13.45 15.3244 13.4871 15.4123C13.5242 15.5002 13.5702 15.5844 13.6229 15.6625C13.6756 15.7406 13.735 15.8127 13.8014 15.8791C13.8677 15.9455 13.9399 16.0049 14.018 16.0576C14.0961 16.1103 14.1803 16.1563 14.2682 16.1934C14.356 16.2305 14.4486 16.2593 14.5443 16.2788C14.64 16.2983 14.7387 16.3093 14.8402 16.3093C14.9418 16.3093 15.0405 16.2983 15.1362 16.2788C15.806 16.1421 16.3093 15.551 16.3093 14.8402C16.3093 14.6137 16.2535 14.4024 16.1598 14.2071C16.1168 14.254 16.0643 14.2916 16.0057 14.317C15.9472 14.3424 15.883 14.3566 15.8166 14.3566C15.7502 14.3566 15.686 14.3424 15.6274 14.317C15.5688 14.2916 15.5152 14.2551 15.4703 14.2102C15.4254 14.1653 15.3889 14.1116 15.3635 14.0531C15.3381 13.9945 15.3238 13.9303 15.3238 13.8639C15.3238 13.7975 15.3381 13.7333 15.3635 13.6747C15.3889 13.6162 15.4265 13.5636 15.4733 13.5207C15.3757 13.4738 15.2737 13.4362 15.1682 13.4108C15.0628 13.3854 14.9535 13.3712 14.8402 13.3712ZM8.59172 17.1529C8.59172 17.1607 8.58427 17.1756 8.57646 17.1834H8.60697C8.59916 17.1756 8.59172 17.1607 8.59172 17.1529Z", fill: color })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/EmployerViewProfileIcon/index.js
'use client';



var EmployerViewProfileIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 21 : _b, _c = _a.height, height = _c === void 0 ? 21 : _c, _d = _a.color, color = _d === void 0 ? '#797979' : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M3 2V12.7692C3 13.3615 3.51346 13.8462 4.15385 13.8462H9.06896C8.87281 13.34 8.76923 12.7962 8.76923 12.2308C8.76923 9.55461 11.0942 7.38461 13.9615 7.38461C14.5673 7.38461 15.15 7.48129 15.6923 7.66436V2H3ZM7.61538 3.07692H11.0769C11.3942 3.07692 11.6538 3.31923 11.6538 3.61538C11.6538 3.91154 11.3942 4.15385 11.0769 4.15385H7.61538C7.29808 4.15385 7.03846 3.91154 7.03846 3.61538C7.03846 3.31923 7.29808 3.07692 7.61538 3.07692ZM13.9615 8.46154C12.1269 8.46154 10.586 9.59769 10.0898 11.1538C10.035 11.3235 9.99402 11.4989 9.96589 11.6786C9.93777 11.8583 9.92308 12.0423 9.92308 12.2308C9.92308 12.6669 10.0013 13.0817 10.1473 13.4686C10.196 13.5976 10.2517 13.7237 10.3152 13.8462C10.9614 15.1223 12.3462 16 13.9615 16C16.1942 16 18 14.3146 18 12.2308C18 10.7231 17.0596 9.4306 15.6923 8.82752C15.1673 8.5906 14.5846 8.46154 13.9615 8.46154ZM13.9615 10.5512C14.6538 10.5512 15.2365 10.7985 15.6923 11.1055C16.4308 11.5901 16.8462 12.2308 16.8462 12.2308C16.8462 12.2308 16.2802 13.1081 15.2822 13.5927C15.2822 13.5981 15.2823 13.598 15.2765 13.598C15.0688 13.7003 14.8439 13.7817 14.6016 13.8409C14.59 13.8409 14.5793 13.8462 14.5678 13.8462C14.4726 13.8677 14.3735 13.8838 14.2725 13.8945C14.1716 13.9053 14.0683 13.9103 13.9615 13.9103C13.7481 13.9103 13.5457 13.8892 13.3553 13.8462C13.1758 13.8078 13.0054 13.7536 12.8449 13.6884C11.7213 13.2323 11.0769 12.2308 11.0769 12.2308C11.0769 12.2308 11.1443 12.1253 11.2741 11.9678C11.6635 11.4953 12.6115 10.5512 13.9615 10.5512ZM13.9615 11.218C13.8865 11.218 13.8136 11.2256 13.7429 11.239C13.6016 11.266 13.4696 11.3188 13.3542 11.3915C13.2965 11.4279 13.2432 11.4688 13.1942 11.5146C13.1451 11.5603 13.1013 11.6101 13.0623 11.6639C13.0234 11.7178 12.9895 11.7758 12.9621 11.8364C12.9347 11.897 12.9134 11.9608 12.899 12.0267C12.8845 12.0927 12.8764 12.1608 12.8764 12.2308C12.8764 12.3008 12.8845 12.3688 12.899 12.4348C12.9134 12.5008 12.9347 12.5646 12.9621 12.6251C12.9895 12.6857 13.0234 12.7438 13.0623 12.7976C13.1013 12.8515 13.1451 12.9012 13.1942 12.947C13.2432 12.9927 13.2965 13.0337 13.3542 13.07C13.4119 13.1064 13.4741 13.138 13.539 13.1636C13.6039 13.1892 13.6723 13.209 13.7429 13.2225C13.8136 13.236 13.8865 13.2435 13.9615 13.2435C14.0365 13.2435 14.1095 13.236 14.1801 13.2225C14.6748 13.1283 15.0466 12.7208 15.0466 12.2308C15.0466 12.0746 15.0055 11.9289 14.9362 11.7943C14.9045 11.8266 14.8657 11.8525 14.8224 11.87C14.7791 11.8875 14.7317 11.8974 14.6827 11.8974C14.6337 11.8974 14.5862 11.8875 14.543 11.87C14.4997 11.8525 14.4601 11.8274 14.4269 11.7964C14.3937 11.7655 14.3668 11.7285 14.348 11.6881C14.3293 11.6477 14.3187 11.6035 14.3187 11.5577C14.3187 11.5119 14.3293 11.4677 14.348 11.4273C14.3668 11.3869 14.3945 11.3507 14.4292 11.3211C14.357 11.2888 14.2817 11.2628 14.2038 11.2453C14.1259 11.2278 14.0452 11.218 13.9615 11.218ZM9.34615 13.8251C9.34615 13.8305 9.34065 13.8408 9.33489 13.8462H9.35742C9.35165 13.8408 9.34615 13.8305 9.34615 13.8251Z", fill: color })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/components/RadioGroup.js
'use client';























var RightButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(RadioGroup_templateObject_1 || (RadioGroup_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    gap: 8px;\n    opacity: ", ";\n    ", ":hover & {\n        opacity: 1;\n    }\n"], ["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    gap: 8px;\n    opacity: ", ";\n    ", ":hover & {\n        opacity: 1;\n    }\n"])), function (props) { return props.active ? 1 : 0; }, OptionGroupStyled.Wrapper);
var CustomLabel = styled_components_browser_esm/* default.p */.ZP.p(RadioGroup_templateObject_2 || (RadioGroup_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n    span {\n        line-height: 24px;\n        padding: 5px 8px;\n        background: ", ";\n        border-radius: 14px;\n        color: ", ";\n        font-size: 12px;\n        &.profile-status {\n            background: ", ";\n            color: ", ";\n            margin-left: 6px;\n        }\n    }\n"], ["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n    span {\n        line-height: 24px;\n        padding: 5px 8px;\n        background: ", ";\n        border-radius: 14px;\n        color: ", ";\n        font-size: 12px;\n        &.profile-status {\n            background: ", ";\n            color: ", ";\n            margin-left: 6px;\n        }\n    }\n"])), Colors/* colors.grey.20 */.O9.grey[20], function (_a) {
    var isDisable = _a.isDisable;
    return (isDisable ? 0.4 : 1);
}, Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.green.50 */.O9.green[50], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.grey.20 */.O9.grey[20]);
var ProfileStatus = styled_components_browser_esm/* default.span */.ZP.span(RadioGroup_templateObject_3 || (RadioGroup_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    line-height: 14px;\n    padding: 5px 8px;\n    border-radius: 14px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    background: ", ";\n    color: ", ";\n"], ["\n    display: inline-block;\n    line-height: 14px;\n    padding: 5px 8px;\n    border-radius: 14px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    background: ", ";\n    color: ", ";\n"])), Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.grey.20 */.O9.grey[20]);
var RadioGroup = function (_a) {
    var resumeSettingInfo = _a.resumeSettingInfo, field = _a.field, t = _a.t, baseUrl = _a.baseUrl, baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, lang = _a.lang, _b = _a.newResumeId, newResumeId = _b === void 0 ? -1 : _b;
    var _c = (0,react.useState)(), onlineProfile = _c[0], setOnlineProfile = _c[1];
    var _d = (0,react.useState)(), lastAttachments = _d[0], setLastAttachments = _d[1];
    var _e = (0,react.useState)(), moreOption = _e[0], setMoreOption = _e[1];
    var _f = (0,react.useState)([]), contentOption = _f[0], setcontentOption = _f[1];
    var _g = (0,react.useState)(''), titleOption = _g[0], setTitleOption = _g[1];
    var _h = (0,react.useState)(0), percent = _h[0], setPercent = _h[1];
    var percentProfileStrength = function (profileLevel) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // Note: profileStrength percent is processed from API
        if ((_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.profileStrength) {
            setPercent((_b = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength);
            return;
        }
        var profileLevelItem = {
            level: (_d = (_c = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _c === void 0 ? void 0 : _c.resumeLevelId) !== null && _d !== void 0 ? _d : 0,
            passedPoints: (_f = (_e = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _e === void 0 ? void 0 : _e.currentPoint) !== null && _f !== void 0 ? _f : 0,
            totalPoints: (_h = (_g = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _g === void 0 ? void 0 : _g.totalPoint) !== null && _h !== void 0 ? _h : 0,
            status: (_k = (_j = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _j === void 0 ? void 0 : _j.resumeStatus) !== null && _k !== void 0 ? _k : ''
        };
        var percent = (_l = calculateProfileStrength(profileLevelItem)) !== null && _l !== void 0 ? _l : 0;
        if (percent) {
            var parseIntPercent = parseInt(percent.toFixed(0));
            setPercent(parseIntPercent);
        }
    };
    var getProfileStrengthByProfileLevel = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var profileLevel, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getProfileLevel(accessToken !== null && accessToken !== void 0 ? accessToken : '', lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    profileLevel = _a.sent();
                    if (profileLevel) {
                        percentProfileStrength(profileLevel);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // options lastAttachment
    var memoListLastAttachment = (0,react.useMemo)(function () {
        if (!resumeSettingInfo || resumeSettingInfo.attributes.length < 1)
            return [];
        var attachCVs = resumeSettingInfo.attributes
            .filter(function (item) { return item.isAttach === ApplyJobsForm_const/* IS_RESUME_ATTACHMENT */.Xh; })
            .map(function (attachCV) { return attachCV; });
        return attachCVs === null || attachCVs === void 0 ? void 0 : attachCVs.map(function (item) {
            var _a, _b;
            var updatedText = "".concat((0,helper/* dateToString */.UW)((_a = item.lastProcessedOn) !== null && _a !== void 0 ? _a : 0));
            return {
                id: item.id,
                name: (0,helper/* fileName */.Yp)((_b = item.fileName) !== null && _b !== void 0 ? _b : ''),
                link: item.link,
                updatedText: updatedText,
                isNewUploadCV: newResumeId === item.id
            };
        });
    }, [resumeSettingInfo, field]);
    var handleOption = function (resumeId, resumeType) {
        if (!resumeId)
            return;
        setMoreOption(resumeType);
        if (resumeType === resumes_types/* EApplyType.online */.bf.online) {
            setTitleOption(t('VietnamWorks online Profile'));
            var contentOption_1 = [{
                    label: t('Update profile'),
                    icon: react.createElement(EditIcon$1, { size: 21 }),
                    isCloseOnClick: true,
                    onClick: function () {
                        window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                    }
                }];
            if (onlineProfile && onlineProfile.allowSearchableDisplay === 1) {
                contentOption_1.push({
                    label: t('View as employer'),
                    icon: react.createElement(EmployerViewIcon, { width: 21, height: 21 }),
                    isCloseOnClick: true,
                    onClick: function () {
                        window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(resumeId), '_blank');
                    }
                });
            }
            setcontentOption(contentOption_1);
            return;
        }
        // For attachment
        var resumeAttachment = memoListLastAttachment.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === resumeId; })[0];
        setTitleOption(resumeAttachment ? resumeAttachment.name : '');
        setcontentOption([
            {
                label: t('View CV'),
                icon: react.createElement(PDFIcon, { width: 22, height: 22, className: 'pdf-icon', color: Colors/* colors.grey.50 */.O9.grey[50] }),
                isCloseOnClick: true,
                onClick: function () {
                    var _a;
                    if (!(resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id)) {
                        return;
                    }
                    (0,helpers/* downloadAttachFile */.jE)({
                        resumeId: resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id,
                        downloadRequest: 'new-window',
                        msBaseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                        accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                        fileName: (_a = resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.name) !== null && _a !== void 0 ? _a : ''
                    });
                }
            },
            {
                label: t('View as employer'),
                icon: react.createElement(EmployerViewProfileIcon, { width: 24, height: 24 }),
                isCloseOnClick: true,
                onClick: function () {
                    window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id), '_blank');
                }
            }
        ]);
    };
    var setOffToggleOption = function (value) {
        if (!value) {
            setMoreOption(undefined);
        }
    };
    (0,react.useEffect)(function () {
        var _a, _b;
        if (!resumeSettingInfo)
            return;
        var onlineProfile = (_a = resumeSettingInfo.attributes) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.isAttach !== ApplyJobsForm_const/* IS_RESUME_ATTACHMENT */.Xh; });
        var attachCVs = (_b = resumeSettingInfo.attributes) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.isAttach === 1; }).map(function (attachCV) { return attachCV; });
        setOnlineProfile(onlineProfile);
        setLastAttachments(attachCVs);
    }, [resumeSettingInfo]);
    (0,react.useEffect)(function () {
        if (accessToken) {
            getProfileStrengthByProfileLevel();
        }
    }, [accessToken]);
    var renderDescription = function () {
        return (react.createElement(react.Fragment, null,
            (0,helpers/* isMobile */.tq)() && !(onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) ? (react.createElement(ProfileStatus, null, t('Not approved'))) : null,
            (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.updatedDate) ? (react.createElement(Variant/* Paragraph */.nv, { size: (0,helpers/* isMobile */.tq)() ? 'small' : 'medium', color: Colors/* colors.grey.60 */.O9.grey[60], style: { marginBottom: 6 } },
                t('Updated'),
                ": ",
                (0,helper/* dateToString */.UW)(onlineProfile.updatedDate),
                react.createElement("span", null, " - "),
                percent ? "".concat(percent, "% ").concat(t('completed')) : null)) : ('')));
    };
    var renderDescriptionAttach = function (cv) {
        return (cv === null || cv === void 0 ? void 0 : cv.updatedText) ? (react.createElement(Variant/* Paragraph */.nv, { size: (0,helpers/* isMobile */.tq)() ? 'small' : 'medium', color: Colors/* colors.grey.60 */.O9.grey[60], style: { marginBottom: 6 } },
            t('Updated'),
            ": ",
            cv.updatedText)) : null;
    };
    var onChange = function (type, id) {
        field.onChange({
            type: type,
            id: id
        });
        field.setFieldValue('resumeApply', type);
    };
    var renderListAttachment = function () {
        return memoListLastAttachment.map(function (item, index) {
            var _a, _b;
            return (react.createElement(OptionGroup, { key: "".concat(item.id, "_").concat(index), value: "".concat(resumes_types/* EApplyType.lastAttachment */.bf.lastAttachment, "-").concat(item.id), checked: ((_a = field === null || field === void 0 ? void 0 : field.value) === null || _a === void 0 ? void 0 : _a.id) === item.id, name: 'apply-type', onChange: function (value) {
                    if (item.id) {
                        onChange(value, item.id);
                    }
                }, label: react.createElement(CustomLabel, null,
                    item.name,
                    " ",
                    !(0,helpers/* isMobile */.tq)() && (item === null || item === void 0 ? void 0 : item.isNewUploadCV) ? (react.createElement("span", null, t('Just uploaded'))) : null), styles: { wrapperStyle: {} } },
                renderDescriptionAttach(item),
                react.createElement(RightButtonWrapper, { active: ((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.id) === item.id }, !(0,helpers/* isMobile */.tq)() ? (react.createElement(react.Fragment, null,
                    react.createElement(Button/* default */.Z, { type: 'info', size: 'sm', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            if (!(item === null || item === void 0 ? void 0 : item.id)) {
                                return;
                            }
                            var body = (item === null || item === void 0 ? void 0 : item.isNewUploadCV) ? { type: 2 } : null;
                            (0,helpers/* downloadAttachFile */.jE)({
                                resumeId: item === null || item === void 0 ? void 0 : item.id,
                                downloadRequest: 'new-window',
                                msBaseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                                accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                                fileName: item === null || item === void 0 ? void 0 : item.name,
                                body: body
                            });
                        } }, t('View CV')),
                    react.createElement(Button/* default */.Z, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(item === null || item === void 0 ? void 0 : item.id), '_blank');
                        } }, t('View as employer')))) : (react.createElement(ThreeDotIcon/* default */.Z, { onClick: function () { return handleOption(item.id || 0, resumes_types/* EApplyType.attachment */.bf.attachment); } })))));
        });
    };
    var renderOnlineProfile = function () {
        var _a, _b, _c;
        return (react.createElement(react.Fragment, null,
            react.createElement(Variant/* Paragraph */.nv, { size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], style: { marginBottom: 8, fontWeight: 500 } }, t('By Vietnamworks profile')),
            (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) === 1 ? (react.createElement(OptionGroup, { value: resumes_types/* EApplyType.online */.bf.online, checked: ((_a = field === null || field === void 0 ? void 0 : field.value) === null || _a === void 0 ? void 0 : _a.type) === resumes_types/* EApplyType.online */.bf.online, name: 'apply-type', onChange: function (value) {
                    if (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) {
                        onChange(value, onlineProfile.id);
                    }
                }, label: t('VietnamWorks online Profile') },
                renderDescription(),
                react.createElement(RightButtonWrapper, { active: ((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.type) === resumes_types/* EApplyType.online */.bf.online }, !(0,helpers/* isMobile */.tq)() ? (react.createElement(react.Fragment, null,
                    react.createElement(Button/* default */.Z, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                        } }, t('Update profile')),
                    react.createElement(Button/* default */.Z, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(onlineProfile.id), '_blank');
                        } }, t('View as employer')))) : (react.createElement(ThreeDotIcon/* default */.Z, { onClick: function () { return handleOption(onlineProfile.id || 0, resumes_types/* EApplyType.online */.bf.online); } }))))) : (react.createElement(OptionGroup, { disabled: true, contentDisable: false, value: resumes_types/* EApplyType.online */.bf.online, checked: ((_c = field === null || field === void 0 ? void 0 : field.value) === null || _c === void 0 ? void 0 : _c.type) === resumes_types/* EApplyType.online */.bf.online, name: 'apply-type', onChange: function (value) {
                    if (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) {
                        onChange(value, onlineProfile.id);
                    }
                }, customLabel: react.createElement(CustomLabel, { style: { opacity: 1 } },
                    t('VietnamWorks online Profile'),
                    " ",
                    (0,helpers/* isMobile */.tq)() ? null : (react.createElement("span", { className: 'profile-status' }, t('Not approved')))) },
                renderDescription(),
                react.createElement(RightButtonWrapper, { active: true }, !(0,helpers/* isMobile */.tq)() ? (react.createElement(react.Fragment, null,
                    react.createElement(Button/* default */.Z, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                        } }, t('Update profile')))) : (react.createElement(ThreeDotIcon/* default */.Z, { onClick: function () { return handleOption((onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) || 0, resumes_types/* EApplyType.online */.bf.online); } })))))));
    };
    return (react.createElement(react.Fragment, null,
        onlineProfile && (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) === 1 ? renderOnlineProfile() : null,
        lastAttachments && lastAttachments.length > 0 ? (react.createElement(react.Fragment, null,
            react.createElement(Variant/* Paragraph */.nv, { size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], style: { marginBottom: 8, fontWeight: 500 } }, t('By attached CVs')),
            renderListAttachment())) : null,
        (0,helpers/* isMobile */.tq)() && moreOption ? (react.createElement(ResponsiveSheet/* default */.Z, { isShow: !!moreOption, header: titleOption, options: contentOption, textOptions: { closeText: t('Cancel') }, responsiveButton: {
                type: 'default'
            }, sheetStyles: { zIndex: 1100 }, setIsShow: setOffToggleOption })) : null));
};
var RadioGroup$1 = react.memo(RadioGroup);
var RadioGroup_templateObject_1, RadioGroup_templateObject_2, RadioGroup_templateObject_3;


//# sourceMappingURL=RadioGroup.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Form/utils/validators.js + 1 modules
var validators = __webpack_require__(90488);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsForm/index.js
'use client';

























var ApplyJobsForm = react.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g;
    var userInfo = _a.userInfo, jobInfo = _a.jobInfo, popupOption = _a.popupOption, accessToken = _a.accessToken, lang = _a.lang, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _h = _a.utmSourceWowCV, utmSourceWowCV = _h === void 0 ? '' : _h, handleApply = _a.handleApply;
    var formRef = (0,react.useRef)(null);
    var _j = (0,react.useState)(), resumeInfo = _j[0], setResumeInfo = _j[1];
    var _k = (0,react.useState)((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobTitle) !== null && _b !== void 0 ? _b : ''), jobTitle = _k[0], setJobTitle = _k[1];
    var t = (0,helpers/* createTranslator */.eX)({ translations: ApplyJobsForm_translations_translations, currentLanguage: lang });
    var _l = (0,react.useState)(0), newResumeId = _l[0], setNewResumeId = _l[1];
    var popupCVReplaceRef = (0,react.useRef)(null);
    var dropFileComponentRef = (0,react.useRef)(null);
    var validator = Form/* default.validator */.Z.validator(t);
    var rules = {
        jobTitle: validator.string().require().noSpecialCharsForJobTitle().generate(),
        phone: validator.string().require().internationalPhoneNumber().vnPhoneNumber().generate(),
        coverLetter: (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) === ApplyJobsForm_const/* IS_REQUIRED_COVER_LETTER */.Lx
            ? validator.string().require().generate()
            : undefined,
        resume: validator
            .string()
            .custom(function (value) {
            if (typeof value.id !== 'number' || (value === null || value === void 0 ? void 0 : value.id) <= 0) {
                return false;
            }
            return true;
        }, t('Please upload your attached CV to apply'))
            .generate(),
        resumeFile: validator
            .string()
            .custom(function (_, watch) {
            if (typeof (watch === null || watch === void 0 ? void 0 : watch.resume.id) !== 'number' || (watch === null || watch === void 0 ? void 0 : watch.resume.id) <= 0) {
                return false;
            }
            return true;
        }, t('Please upload your attached CV to apply'))
            .generate()
    };
    // api user , resume
    var getResume = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var resumeSettingInfo, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* getResumeSettingInfo */.Z0)(accessToken, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', lang)];
                case 1:
                    resumeSettingInfo = _a.sent();
                    if (resumeSettingInfo && resumeSettingInfo) {
                        setResumeInfo(resumeSettingInfo);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateJobTitle = function (value) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var update, error_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* changeJobTitle */.tE)({
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                            accessToken: accessToken,
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            value: value
                        })];
                case 1:
                    update = _a.sent();
                    if (update && update.data) {
                        setJobTitle(value);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleFileUpload = function (uploadFileField) { return function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var data;
        var _a, _b, _c, _d, _e;
        return (0,_tslib/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!((resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) &&
                        ((_b = (_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.filter(function (cv) { return !!cv.isAttach; }).length) >= ApplyJobsForm_const/* MAX_NUMBER_OF_CV */.h9 &&
                        popupCVReplaceRef.current)) return [3 /*break*/, 2];
                    return [4 /*yield*/, popupCVReplaceRef.current.open()];
                case 1:
                    data = (_f.sent()).data;
                    if (!data.resumeId) {
                        (_c = dropFileComponentRef.current) === null || _c === void 0 ? void 0 : _c.reset(); // allow popup to trigger again if user drop the same file after cancel replacement request
                        uploadFileField.onChange(null);
                        return [2 /*return*/];
                    }
                    (_d = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _d === void 0 ? void 0 : _d.doUploadFile(file, data === null || data === void 0 ? void 0 : data.resumeId);
                    return [3 /*break*/, 3];
                case 2:
                    (_e = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _e === void 0 ? void 0 : _e.doUploadFile(file);
                    _f.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }; };
    var onUploadDone = function (response) {
        var _a, _b;
        getResume();
        if ((response === null || response === void 0 ? void 0 : response.code) === ApplyJobsForm_const/* HTTP_CODE_SUCCESS */.CI) {
            setNewResumeId((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
        }
    };
    var updatePhone = function (value) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var update, error_3;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* changePhoneNumber */.Sl)({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                            value: value !== null && value !== void 0 ? value : ''
                        })];
                case 1:
                    update = _a.sent();
                    if (update && update.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (accessToken) {
            getResume();
        }
    }, [accessToken]);
    // submit form
    var defaultResumeValue = (0,react.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (!((_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.profileSetting))
            return null;
        var latestAttachResumeId = (_e = (_d = (_c = (_b = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 1; })[0]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : 0;
        var latestAppliedResume = (_h = (_g = (_f = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isLastApplied) === true; })[0]) !== null && _h !== void 0 ? _h : null;
        var onlineResumeId = (_m = (_l = (_k = (_j = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _j === void 0 ? void 0 : _j.attributes) === null || _k === void 0 ? void 0 : _k.find(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 0; })) === null || _l === void 0 ? void 0 : _l.id) !== null && _m !== void 0 ? _m : 0;
        // priority 1: checked upload new file
        if (newResumeId > 0) {
            return {
                type: type_EApplyType.lastAttachment,
                resumeId: (_r = (_q = (_p = (_o = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _o === void 0 ? void 0 : _o.attributes) === null || _p === void 0 ? void 0 : _p.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 1 && (e === null || e === void 0 ? void 0 : e.id) === newResumeId; })[0]) === null || _q === void 0 ? void 0 : _q.id) !== null && _r !== void 0 ? _r : 0
            };
        }
        // priority 2: checked last Applied
        // if attachment, priority last updated
        if (latestAppliedResume) {
            return {
                type: (latestAppliedResume === null || latestAppliedResume === void 0 ? void 0 : latestAppliedResume.isAttach) == ApplyJobsForm_const/* IS_RESUME_ATTACHMENT */.Xh
                    ? type_EApplyType.lastAttachment
                    : type_EApplyType.online,
                resumeId: (latestAppliedResume === null || latestAppliedResume === void 0 ? void 0 : latestAppliedResume.isAttach) == ApplyJobsForm_const/* IS_RESUME_ATTACHMENT */.Xh ? latestAttachResumeId : onlineResumeId
            };
        }
        // At least one valid profile
        // priority 3: checked last updated resume attachment if it valid, else online profile
        if (latestAttachResumeId) {
            return {
                type: type_EApplyType.lastAttachment,
                resumeId: latestAttachResumeId
            };
        }
        if (resumeInfo.data.searchableStatus) {
            var isProfileAllowSearchable = resumeInfo.data.attributes.find(function (e) { return e.isAttach !== ApplyJobsForm_const/* IS_RESUME_ATTACHMENT */.Xh && e.allowSearchableDisplay === 1; });
            if (isProfileAllowSearchable) {
                return {
                    type: type_EApplyType.online,
                    resumeId: onlineResumeId
                };
            }
        }
        // none resume
        return {
            type: type_EApplyType.lastAttachment,
            resumeId: 0
        };
    }, [resumeInfo]);
    var formData = {
        jobTitle: jobTitle,
        phone: userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone,
        coverLetter: '',
        resume: {
            type: defaultResumeValue === null || defaultResumeValue === void 0 ? void 0 : defaultResumeValue.type,
            id: defaultResumeValue === null || defaultResumeValue === void 0 ? void 0 : defaultResumeValue.resumeId
        },
        tempAttachResumeId: (_e = (_d = (_c = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _c === void 0 ? void 0 : _c.attributes.filter(function (item) { return item.isAttach === 1; })[0]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : null,
        resumeFile: null,
        isReplaced: null,
        attachLink: null
    };
    var onSubmit = function () {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    };
    // render custom element & styling
    var settingCol = function (size) {
        if (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) {
            return;
        }
        return size;
    };
    var settingRow = !(popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? [24, 16] : [12, 8];
    (0,react.useImperativeHandle)(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    return (react.createElement(styled_css_Container, { isInPopup: popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup },
        react.createElement(Form/* default */.Z, { ref: formRef, initialValues: formData, onSubmit: function (values) {
                handleApply && handleApply(values);
            } },
            react.createElement(Row/* default */.Z, { gutter: settingRow, align: 'middle', justify: 'center' },
                (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (react.createElement(Col/* default */.Z, null,
                    react.createElement(WrapInfo, null,
                        react.createElement(Avatar/* default */.Z, { image: (_f = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _f !== void 0 ? _f : '' }),
                        react.createElement(Variant/* Paragraph */.nv, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'title', size: 'medium' }, userInfo === null || userInfo === void 0 ? void 0 :
                            userInfo.firstName,
                            " ", userInfo === null || userInfo === void 0 ? void 0 :
                            userInfo.lastName)))),
                react.createElement(Col/* default */.Z, null,
                    react.createElement(Box, { display: (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? 'grid' : 'block' },
                        (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) && react.createElement(Avatar/* default */.Z, { image: (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _g !== void 0 ? _g : '' }),
                        react.createElement(Row/* default */.Z, { gutter: settingRow },
                            (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) && (react.createElement(Col/* default */.Z, null,
                                react.createElement(Variant/* Paragraph */.nv, { color: Colors/* colors.grey.20 */.O9.grey[20], name: 'title', size: 'medium' }, userInfo === null || userInfo === void 0 ? void 0 :
                                    userInfo.firstName,
                                    " ", userInfo === null || userInfo === void 0 ? void 0 :
                                    userInfo.lastName))),
                            react.createElement(Form/* default.Item */.Z.Item, { name: 'jobTitle', rules: rules.jobTitle }, function (field) {
                                return (react.createElement(Col/* default */.Z, { md: settingCol(12), xs: 24 },
                                    (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (react.createElement(Form/* default.Label */.Z.Label, null, t('Job Title'))),
                                    react.createElement(components_Input/* default */.Z, { value: field.value, onChange: function (value) {
                                            field.onChange(value);
                                        }, onBlur: function () {
                                            field.onBlur();
                                            var validateNoNumberAndEmail = validators/* default.validateNoNumberAndEmail */.Z.validateNoNumberAndEmail, validateNoSpecialCharsForJobTitle = validators/* default.validateNoSpecialCharsForJobTitle */.Z.validateNoSpecialCharsForJobTitle;
                                            if (field.value && typeof field.value === 'string') {
                                                var validJobTitle = !validateNoNumberAndEmail(field.value) &&
                                                    !validateNoSpecialCharsForJobTitle(field.value);
                                                validJobTitle ? updateJobTitle(field.value) : undefined;
                                            }
                                        }, hasError: field.isError, placeholder: t('Enter job title') }),
                                    react.createElement(Form/* default.Error */.Z.Error, null)));
                            }),
                            react.createElement(Form/* default.Item */.Z.Item, { name: 'phone', rules: rules.phone }, function (field) {
                                return (react.createElement(Col/* default */.Z, { md: settingCol(12), xs: 24 },
                                    (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (react.createElement(Form/* default.Label */.Z.Label, null, t('Phone'))),
                                    react.createElement(I11lPhoneNumberInput/* default */.Z, { value: field.value, onChange: field.onChange, onBlur: function () {
                                            field.onBlur();
                                            if (field.value && !field.isError) {
                                                updatePhone(field.value);
                                            }
                                        }, hasError: field.isError, placeholder: t('Enter phone number'), floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        } }),
                                    react.createElement(Form/* default.Error */.Z.Error, null)));
                            })))),
                (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) && (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) !== 0 ? (react.createElement(Form/* default.Item */.Z.Item, { name: 'coverLetter', rules: rules.coverLetter }, function (field) {
                    return (react.createElement(Col/* default */.Z, null,
                        react.createElement(WrapLabel, null,
                            react.createElement(Form/* default.Label */.Z.Label, null, t('Cover letter')),
                            react.createElement(LinkCover, { href: ApplyJobsForm_const/* HRINSIDER_ATTACH_RESUME_LINK */.Fp, target: '_blank', color: Colors/* colors.primary.40 */.O9.primary[40], name: 'body', size: 'small' }, t('View sample'))),
                        react.createElement(TextareaNew/* default */.Z, { hasError: field.isError, placeholder: t('Enter cover letter'), maxLength: ApplyJobsForm_const/* LIMIT_CHARACTERS */.kH, onChange: field.onChange, onBlur: field.onBlur }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                })) : null,
                react.createElement(Form/* default.Item */.Z.Item, { name: 'isReplaced' }, function (field) {
                    var _a;
                    return (react.createElement(PopupCVReplace/* default */.Z, { ref: popupCVReplaceRef, langCode: lang, formControl: field, maxNumberOfCV: ApplyJobsForm_const/* MAX_NUMBER_OF_CV */.h9, cvList: ((_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.attributes) || [] }));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'resume', rules: rules.resume, watch: ['resumeFile', 'tempAttachResumeId', 'attachLink', 'isReplaced'] }, function (field) {
                    var _a, _b, _c, _d;
                    return (react.createElement(Col/* default */.Z, null,
                        react.createElement(Form/* default.Label */.Z.Label, { require: !((_a = field.value) === null || _a === void 0 ? void 0 : _a.type) },
                            (((_b = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _b === void 0 ? void 0 : _b.attributes) && (resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data.attributes.length) > 0) ||
                                ((_c = field.watch) === null || _c === void 0 ? void 0 : _c.resumeFile) ? (react.createElement(Variant/* Span */.Dr, { name: 'title', size: 'small', color: Colors/* colors.grey.20 */.O9.grey[20] },
                                t('Choose a profile to apply'),
                                ":",
                                ' ')) : (react.createElement(Variant/* Span */.Dr, { name: 'title', size: 'small', color: Colors/* colors.grey.20 */.O9.grey[20] },
                                t('Upload your attached CV to apply'),
                                ":",
                                ' ')),
                            (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedId) && (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedId) !== 3 ? (react.createElement(react.Fragment, null,
                                react.createElement(Variant/* Span */.Dr, { name: 'body', size: 'medium' },
                                    t('Employers prefer to receive your resume in'),
                                    ' '),
                                react.createElement(Variant/* Span */.Dr, { name: 'title', size: 'small' }, lang === constants/* ELanguage.VI */.Df.VI
                                    ? jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedVI
                                    : jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelected))) : null),
                        react.createElement(RadioGroup$1, { field: field, resumeSettingInfo: resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data, t: t, newAttach: (_d = field.watch) === null || _d === void 0 ? void 0 : _d.resumeFile, baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken: accessToken, lang: lang, newResumeId: newResumeId })));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'resumeFile', rules: rules.resumeFile, watch: ['tempAttachResumeId', 'resume'] }, function (field) {
                    var _a, _b;
                    return (react.createElement(Col/* default */.Z, null,
                        react.createElement(DragDropResumeUpload/* default */.Z, { lang: lang, accessToken: accessToken, ref: dropFileComponentRef, baseUrl: baseMsUrl, isCheckSpam: true, onUpload: handleFileUpload(field), isLoading: true, onUploadDone: onUploadDone }),
                        react.createElement(Form/* default.Error */.Z.Error, { disable: !!((_b = (_a = field.watch) === null || _a === void 0 ? void 0 : _a.resume) === null || _b === void 0 ? void 0 : _b.id) })));
                }),
                react.createElement(Col/* default */.Z, { xs: 24 },
                    react.createElement(Row/* default */.Z, { gutter: settingRow, align: 'middle' },
                        react.createElement(Col/* default */.Z, { xs: 24 },
                            react.createElement(Variant/* Anchor */.ee, { href: (0,helper/* hrefWowCV */.Wb)({
                                    source: utmSourceWowCV !== null && utmSourceWowCV !== void 0 ? utmSourceWowCV : '',
                                    langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI,
                                    baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : ''
                                }), target: '_blank', color: Colors/* colors.primary.40 */.O9.primary[40], name: 'body', size: 'small', style: { textAlign: 'right', display: 'block' } }, t('Create attracted CV with WowCV')))))),
            react.createElement("button", { type: 'submit', hidden: true }, "submit"))));
});
var ApplyJobsForm$1 = react.memo(ApplyJobsForm);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useOnClickOutSide.js
'use client';



function useOnClickOutside(ref, handler, mouseEvent) {
    if (mouseEvent === void 0) { mouseEvent = 'mousedown'; }
    var handleClick = function (event) {
        var el = ref === null || ref === void 0 ? void 0 : ref.current;
        // Do nothing if clicking ref's element or descendent elements
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    };
    (0,react.useEffect)(function () {
        window.addEventListener(mouseEvent, handleClick);
        return function () {
            window.removeEventListener(mouseEvent, handleClick);
        };
    }, []);
}


//# sourceMappingURL=useOnClickOutSide.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/Arrows/index.js
var Arrows = __webpack_require__(17499);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/components/RangePicker.js
'use client';











function RangePicker(_a) {
    var defaultDates = _a.defaultDates, onChange = _a.onChange, min = _a.min, max = _a.max, _b = _a.type, type = _b === void 0 ? DatePicker_type/* EDatePicker.month */.f.month : _b, pickerType = _a.pickerType, calendarStyle = _a.calendarStyle, placeholder = _a.placeholder;
    var _c = (0,react.useState)(defaultDates), dates = _c[0], setDates = _c[1];
    var _d = (0,react.useState)(''), startValue = _d[0], setStartValue = _d[1];
    var _e = (0,react.useState)(''), endValue = _e[0], setEndValue = _e[1];
    var _f = (0,react.useState)(false), isShowCalendar = _f[0], setIsShowCalendar = _f[1];
    var calendarRef = (0,react.useRef)(null);
    var datePickerRef = (0,react.useRef)(null);
    var handleClickCalendar = function (dates) {
        setDates(dates);
        var startDate = (0,dateTimeFormat/* datetimeFormat */._I)(dates[0], type);
        var endDate = (0,dateTimeFormat/* datetimeFormat */._I)(dates[1], type);
        setStartValue(startDate);
        setEndValue(endDate);
        onChange && onChange(dates);
        if (dates && dates.length > 1) {
            setIsShowCalendar(false);
        }
    };
    var validate = function (value) {
        if (!(0,dateTimeFormat/* formatInputDate */.zB)(value, type)) {
            setStartValue('');
            setEndValue('');
            onChange && onChange(null);
        }
    };
    var handleChangeInputStart = function (value) {
        var _a;
        setStartValue(value);
        var formattedDate = (0,dateTimeFormat/* formatInputDate */.zB)(value, type, 'string');
        if (formattedDate && calendarRef.current) {
            var date = (0,dateTimeFormat/* formatInputDate */.zB)(value, type, 'Date');
            var endDate = (_a = (dates && dates[1])) !== null && _a !== void 0 ? _a : null;
            if (endDate && date && date > endDate) {
                setEndValue('');
                calendarRef.current.onPicker(null);
                return;
            }
            calendarRef.current.onPicker(new Date(date));
        }
        if (!value && calendarRef.current) {
            setEndValue('');
            setDates(null);
            calendarRef.current.onPicker(null);
        }
    };
    var handleChangeInputEnd = function (value) {
        var _a;
        setEndValue(value);
        var formattedDate = (0,dateTimeFormat/* formatInputDate */.zB)(value, type, 'string');
        if (formattedDate && calendarRef.current) {
            var date = (0,dateTimeFormat/* formatInputDate */.zB)(value, type, 'Date');
            var startDate = (_a = (dates && dates[0])) !== null && _a !== void 0 ? _a : null;
            if (startDate && date && date < startDate) {
                setEndValue('');
                calendarRef.current.onPicker(null);
                return;
            }
            calendarRef.current.onPicker(new Date(date));
        }
        if (!value && calendarRef.current) {
            setStartValue('');
            calendarRef.current.onPicker(null);
            setDates(null);
        }
    };
    var onShowCalendar = function () {
        setIsShowCalendar(!isShowCalendar);
    };
    (0,react.useEffect)(function () {
        if (dates && dates.length > 0) {
            var startDate = (0,dateTimeFormat/* datetimeFormat */._I)(dates[0], type);
            setStartValue(startDate);
        }
        if (dates && dates.length > 1) {
            var endDate = (0,dateTimeFormat/* datetimeFormat */._I)(dates[1], type);
            setEndValue(endDate);
        }
    }, [dates]);
    var handleClickOutside = function () {
        setIsShowCalendar(false);
    };
    useOnClickOutside(datePickerRef, handleClickOutside);
    return (react.createElement(DatePicker_styles_css/* PickerContainer */.U1, { ref: datePickerRef, onFocus: function () {
            setIsShowCalendar(true);
        } },
        react.createElement(DatePicker_styles_css/* InputRange */.OX, null,
            react.createElement(DatePicker_styles_css/* InputRangeField */.zY, null,
                react.createElement(components_Input/* default */.Z, { type: 'text', value: startValue, onBlur: function () { return validate(startValue); }, onFocus: function () { return setIsShowCalendar(true); }, onChange: function (value) { return handleChangeInputStart(value !== null && value !== void 0 ? value : ''); }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'dd/mm/yyyy', clearValue: false }),
                react.createElement("div", { style: { zIndex: 0 } },
                    react.createElement(Arrows/* LongArrowRight */.RD, null)),
                react.createElement(components_Input/* default */.Z, { type: 'text', value: endValue !== null && endValue !== void 0 ? endValue : '', disabled: !startValue, onBlur: function () { return validate(endValue); }, onFocus: function () { return setIsShowCalendar(true); }, onChange: function (value) { return handleChangeInputEnd(value !== null && value !== void 0 ? value : ''); }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'dd/mm/yyyy', clearValue: true })),
            react.createElement(DatePicker_styles_css/* Icon */.JO, { isRounded: true, isIcon: true, type: 'transparent', isOutline: false, onClick: onShowCalendar },
                react.createElement(Calendar_Calendar/* CalendarIcon */.Q, null))),
        react.createElement(DatePicker_styles_css/* CalendarWrap */._z, { show: isShowCalendar ? 1 : 0 },
            react.createElement(Calendar/* default */.ZP, { ref: calendarRef, initDates: dates, pickerType: pickerType, calendarStyle: calendarStyle, min: min, max: max, type: type, handleDateClick: handleClickCalendar }))));
}


//# sourceMappingURL=RangePicker.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DatePicker/components/CombinePicker.js
var CombinePicker = __webpack_require__(81599);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Contexts/translator/index.js
'use client';




var TranslateContext = react.createContext({
    t: function () { return ''; }
});
var useTranslate = function () { return (0,react.useContext)(TranslateContext); };


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/index.js + 2 modules
var ButtonViewMore = __webpack_require__(76236);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ForceLogOut/ForceLogOut.css.js
'use client';





var ForceLogOut_css_Dialog = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(ForceLogOut_css_templateObject_1 || (ForceLogOut_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: white;\n        padding: 24px;\n    "], ["\n        border-radius: 12px;\n        background: white;\n        padding: 24px;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(ForceLogOut_css_templateObject_2 || (ForceLogOut_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        text-align: center;\n\n        svg {\n            margin: auto;\n        }\n    "], ["\n        text-align: center;\n\n        svg {\n            margin: auto;\n        }\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(ForceLogOut_css_templateObject_4 || (ForceLogOut_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        border-top: 1px solid ", ";\n        display: flex;\n        gap: 8px;\n\n        ", "\n    "], ["\n        padding: 24px;\n        border-top: 1px solid ", ";\n        display: flex;\n        gap: 8px;\n\n        ", "\n    "])), Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
        var isMobile = _a.isMobile;
        return isMobile && (0,styled_components_browser_esm/* css */.iv)(ForceLogOut_css_templateObject_3 || (ForceLogOut_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                flex-direction: column;\n            "], ["\n                flex-direction: column;\n            "])));
    })
};
var ListStyle = styled_components_browser_esm/* default.ul */.ZP.ul(ForceLogOut_css_templateObject_5 || (ForceLogOut_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    margin: 0;\n"], ["\n    display: inline-block;\n    margin: 0;\n"])));
var ForceLogOut_css_templateObject_1, ForceLogOut_css_templateObject_2, ForceLogOut_css_templateObject_3, ForceLogOut_css_templateObject_4, ForceLogOut_css_templateObject_5;


//# sourceMappingURL=ForceLogOut.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ForceLogOut/services.js
'use client';



var checkRefreshToken = function (accessToken, refreshToken, langCode, baseURL) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var searchParams, res;
    var _a, _b, _c;
    return (0,_tslib/* __generator */.Jh)(this, function (_d) {
        switch (_d.label) {
            case 0:
                searchParams = JSON.stringify({
                    accessToken: accessToken,
                    refreshToken: refreshToken
                });
                return [4 /*yield*/, fetch("".concat(baseURL, "/api/v1/checkExpireSessionWS"), {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'Accept-Language': langCode,
                            'Cache-Control': 'no-cache'
                        },
                        body: searchParams
                    })
                        .then(function (res) { return res.json(); })
                        .catch(function (e) { return console.log(e); })];
            case 1:
                res = _d.sent();
                if ((res === null || res === void 0 ? void 0 : res.data) && (res === null || res === void 0 ? void 0 : res.data.length) > 0 && ((_a = res === null || res === void 0 ? void 0 : res.data[0]) === null || _a === void 0 ? void 0 : _a.attributes)) {
                    return [2 /*return*/, (_c = (_b = res === null || res === void 0 ? void 0 : res.data[0]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.isExpireSessionWS];
                }
                else {
                    return [2 /*return*/, false];
                }
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ForceLogOut/translations.js
'use client';

var ForceLogOut_translations_translations = {
    'Your session expired for one of two reasons:': 'Phiên làm việc của bạn đã hết hạn vì một trong hai lý do:',
    "You've been active for a long time.": 'Bạn đã hoạt động trong một thời gian dài.',
    "You've signed out on another device.": 'Bạn đã đăng xuất trên một thiết bị khác.',
    'Ready to log back in?': 'Bạn đã sẵn sàng để đăng nhập lại chưa?',
    'Stay logged out': 'Đăng xuất',
    'Login to continue': 'Đăng nhập để tiếp tục'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ForceLogOut/index.js
'use client';















var ForceLogOut = function (props) {
    var langCode = props.langCode, mode = props.mode, user = props.user, pageName = props.pageName;
    var _a = (0,react.useState)(false), openPopup = _a[0], setOpenPopup = _a[1];
    var baseSecureURL = "https://".concat(mode === 'production' ? "" : "".concat(mode, "-"), "secure.vietnamworks.com");
    var isResponsive = (0,helpers/* isMobile */.tq)();
    var t = function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return ForceLogOut_translations_translations[text] || text;
        }
    };
    var stopBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'hidden';
        }
    };
    var resumeBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'initial';
        }
    };
    var checkExpireToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, accessToken, _b, refreshToken, TOKEN_LENGTH, encodeAccessToken, encodeRefreshToken, isExpireSessionWS;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!user) return [3 /*break*/, 2];
                    _a = user.accessToken, accessToken = _a === void 0 ? '' : _a, _b = user.refreshToken, refreshToken = _b === void 0 ? '' : _b;
                    TOKEN_LENGTH = 86;
                    encodeAccessToken = accessToken.length === TOKEN_LENGTH ? (0,helpers/* encrypt */.HI)(accessToken) : accessToken;
                    encodeRefreshToken = refreshToken.length === TOKEN_LENGTH ? (0,helpers/* encrypt */.HI)(refreshToken) : refreshToken;
                    if (!encodeAccessToken && !encodeRefreshToken) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, checkRefreshToken(encodeAccessToken, encodeRefreshToken, langCode, baseSecureURL)];
                case 1:
                    isExpireSessionWS = _c.sent();
                    if (isExpireSessionWS) {
                        setOpenPopup(true);
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_TOKEN */.dD, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_TOKEN */.h4, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_ALL_TOKEN */.xX, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* USER_COOKIE */.fT, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_COOKIE */.kd, '');
                        stopBodyScrolling();
                    }
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleLogin = function () {
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode,
                isNeedReload: false,
                onLoggedIn: function () {
                    setOpenPopup(false);
                }
            }
        });
        window.dispatchEvent(loginEvent);
    };
    var handleLogOut = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            fetch('/jobseekers/ajax.php?action=track-logout', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var _a;
                if (data.status === 'success') {
                    var logOutUrl = "".concat(baseSecureURL, "/logout/").concat(langCode, "?client_id=3").concat((user === null || user === void 0 ? void 0 : user.userId) ? '&accessToken=' + (0,helpers/* detectEncryptAccessToken */.If)((_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '') : '');
                    location.assign("".concat(logOutUrl, "&as=1"));
                }
                resumeBodyScrolling();
            })
                .catch(function (err) {
                console.log(err);
            });
            return [2 /*return*/];
        });
    }); };
    (0,react.useEffect)(function () {
        if (window) {
            // authtoken will direct login, it's from mobile link, not check expire token
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            if (!urlParams.get('authtoken') && !urlParams.get('authToken') && pageName !== 'wowCv') {
                checkExpireToken();
            }
        }
    }, [user]);
    var renderFooter = function () { return (react.createElement(ForceLogOut_css_Dialog.Footer, { isMobile: isResponsive },
        react.createElement(Button/* default */.Z, { style: { width: '100%' }, onClick: handleLogOut }, t('Stay logged out')),
        react.createElement(Button/* default */.Z, { style: { width: '100%' }, onClick: handleLogin, type: 'primary' }, t('Login to continue')))); };
    var renderBody = function () { return (react.createElement(ForceLogOut_css_Dialog.Container, null,
        react.createElement(ForceLogOut_css_Dialog.Body, null,
            react.createElement("div", { style: { padding: 16 } },
                react.createElement("img", { width: 200, height: 110, src: "".concat(props.baseImgUrl, "/images/force-logout.jpg") })),
            react.createElement(Variant/* Paragraph */.nv, { name: 'title', size: 'large' }, t('Your session expired for one of two reasons:')),
            react.createElement(ListStyle, { style: { marginTop: 8 } },
                react.createElement("li", null,
                    react.createElement(Variant/* Paragraph */.nv, { name: 'paragraph', size: 'medium' }, t("You've been active for a long time.")))),
            react.createElement(ListStyle, null,
                react.createElement("li", null,
                    react.createElement(Variant/* Paragraph */.nv, { name: 'paragraph', size: 'medium' }, t("You've signed out on another device.")))),
            react.createElement(Variant/* Paragraph */.nv, { name: 'paragraph', size: 'medium', style: { marginTop: 8 } }, t('Ready to log back in?'))))); };
    return !isResponsive ? (react.createElement(Popup/* default */.Z, { isShow: openPopup, onClose: function () { }, lang: langCode, custom: {
            footer: renderFooter(),
            header: react.createElement(react.Fragment, null)
        }, styleOption: {
            size: 'xs'
        } }, renderBody())) : (react.createElement(BottomSheet/* default */.Z, { onClose: function () { }, options: { isCloseOnClickBackdrop: false, isHaveCloseIcon: false }, isOpen: openPopup, header: react.createElement(react.Fragment, null), footer: renderFooter() }, renderBody()));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/translations.js
'use client';

var OnBoarding_translations_translations = {
    'I already have a CV': 'Tôi đã có hồ sơ ứng tuyển',
    'Create VietnamWorks Profile': 'Tạo Hồ Sơ VietnamWorks',
    'It takes about 5 - 8 minutes for a turn. Easily to apply CV whenever you want.': 'It takes about 5 - 8 minutes for a turn. Easily to apply CV whenever you want.',
    'It takes about 15 - 20 minutes for a turn. When you build a full profile, you get a lot jobs relevant from email.': 'It takes about 15 - 20 minutes for a turn. When you build a full profile, you get a lot jobs relevant from email.',
    'Job title': 'Chức danh',
    'First name': 'Tên',
    'Last name': 'Họ',
    'Current job level': 'Cấp bậc hiện tại',
    'Current job function': 'Ngành nghề hiện tại',
    'Current industry': 'Lĩnh vực hiện tại',
    'Current salary': 'Mức lương hiện tại',
    'Contact information': 'Thông tin cá nhân',
    'Basic information': 'Thông tin cơ bản',
    Email: 'Email',
    'Date of birth': 'Ngày sinh',
    'Phone number': 'Số điện thoại',
    Nationality: 'Quốc tịch',
    'Marital status': 'Tình trạng hôn nhân',
    Male: 'Nam',
    Female: 'Nữ',
    Single: 'Độc thân',
    Married: 'Đã kết hôn',
    Gender: 'Giới tính',
    Country: 'Quốc gia',
    'Select a country': 'Chọn quốc gia',
    'Select categories': 'Chọn ngành nghề',
    'Select a category': 'Chọn ngành nghề',
    'Province/City': 'Tỉnh/Thành phố',
    District: 'Quận/Huyện',
    Address: 'Địa chỉ',
    Skills: 'Kỹ năng',
    'Suggested Skills For You': 'Kỹ năng được đề xuất',
    'Working preference': 'Công việc mong muốn',
    'Expected location': 'Nơi làm việc',
    'Expected job function': 'Ngành nghề',
    'Expected industry': 'Lĩnh vực',
    'Expected job level': 'Cấp bậc mong muốn',
    'Expected salary': 'Mức lương mong muốn',
    'Expected top 5 benefits': 'Top 5 phúc lợi tôi mong muốn nhất',
    'This is required field': 'Thông tin bắt buộc',
    'Suggested skills for you': 'Kỹ năng được đề xuất',
    'Highest education': 'Bằng cấp cao nhất',
    'Years of experience': 'Số năm kinh nghiệm',
    Welcome: 'Xin chào',
    "You're all set to embark on a journey with Vietnamworks! Let's begin by getting to know the platform.": 'Bạn đã sẵn sàng khám phá Vietnamworks! Hãy bắt đầu bằng việc khám phá về nền tảng này.',
    "Let's go": 'Khám phá ngay',
    'Do you have a CV yet?': 'Bạn đã có hồ sơ ứng tuyển chưa?',
    "We're using this info to make your experience unique.": 'Chúng tôi sử dụng thông tin này để làm trải nghiệm của bạn trở nên độc đáo hơn.',
    'Allocating 5 - 8 minutes for your information can pave the way to your dream job or the right company for you.': 'Dành 5 - 8 phút để chia sẻ thông tin có thể mở ra cơ hội tìm được công việc mơ ước hoặc công ty phù hợp nhất với bạn.',
    "No profile yet? Let's build your VietnamWorks profile together.": 'Chưa có hồ sơ? Hãy cùng tạo hồ sơ VietnamWorks của bạn.',
    'Allocating 15 - 20 minutes to provide your details, ensuring you have a professional CV and easy profile management down the road.': 'Dành 15 - 20 phút để chia sẻ thông tin để đảm bảo bạn có một hồ sơ chuyên nghiệp và quản lý hồ sơ dễ dàng trong tương lai.',
    Back: 'Trở lại',
    Continue: 'Tiếp tục',
    'Upload your CV now': 'Hãy tải lên hồ sơ của bạn ngay bây giờ',
    'You can make CV updates whenever you need, no worries.': 'Hãy yên tâm, bạn có thể dễ dàng thay đổi hồ sơ sau này.',
    'Share a bit about who you are': 'Hãy giới thiệu một chút về bản thân bạn',
    "This information plays a key role in introducing you to employers, and it's editable at any time.": 'Thông tin này đóng vai trò quan trọng trong việc giới thiệu bạn đến nhà tuyển dụng và bạn có thể sửa đổi nó bất cứ lúc nào.',
    // trans
    'This field is required.': 'Vui lòng nhập thông tin.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    "You've successfully set up your profile": 'Bạn đã thiết lập hồ sơ thành công',
    'Congratulations! Your profile is good to go. Start your journey towards your dream job and connect with potential employers.': 'Xin chúc mừng! Hồ sơ của bạn đã hoàn thiện. Bắt đầu hành trình tìm kiếm công việc mơ ước và kết nối với các nhà tuyển dụng tiềm năng.',
    'Enter your job title': 'Nhập chức danh của bạn',
    'Enter your address': 'Nhập địa chỉ của bạn',
    'Enter your current salary': 'Nhập mức lương hiện tại của bạn',
    'Enter your expected salary': 'Nhập mức lương mong muốn của bạn',
    'Enter your year experience': 'Nhập số năm kinh nghiệm của bạn',
    'Please select...': 'Vui lòng chọn...',
    'No Result Found': 'Không Có Kết Quả Nào',
    Search: 'Tìm',
    'USD/month': 'USD/tháng',
    Year: 'Năm',
    'Add location': 'Thêm nơi làm việc',
    'Required field': 'Thông tin bắt buộc',
    Bonus: 'Tiền thưởng',
    'Healthcare Plan': 'Chăm sóc sức khỏe',
    'Paid Leave': 'Nghỉ phép có lương ',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Máy tính xách tay',
    Mobile: 'Điện thoại',
    Travel: 'Cơ hội du lịch',
    'Team Activities': 'Hoạt động nhóm',
    Transportation: 'Xe đưa đón',
    Canteen: 'Căn tin',
    Vouchers: 'Phiếu quà tặng',
    Kindergarten: 'Nhà trẻ',
    Others: 'Khác',
    'View my profile': 'Xem hồ sơ',
    'You have added a maximum of 3 locations': 'Bạn đã tạo tối đa 3 khu vực',
    'You have selected the max number of 3 categories': 'Bạn đã lựa chọn tối đa 3 ngành nghề',
    'my-profile': 'ho-so'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/type.js
'use client';

var EStep;
(function (EStep) {
    EStep["Welcome"] = "Welcome";
    EStep["PersonalInformatoion"] = "PersonalInformatoion";
    EStep["HaveCV"] = "HaveCV";
    EStep["UploadCV"] = "UploadCV";
    EStep["BasicInformation"] = "BasicInformation";
    EStep["Skill"] = "Skill";
    EStep["WorkingPreference"] = "WorkingPreference";
    EStep["Recommendation"] = "Recommendation";
    EStep["Successfully"] = "Successfully";
})(EStep || (EStep = {}));


//# sourceMappingURL=type.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/const.js
var OnBoarding_const = __webpack_require__(19891);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/context/index.js
'use client';






var initState = {
    hash: "#".concat(EStep.Welcome),
    setHash: function () { },
    lang: constants/* ELanguage.VI */.Df.VI,
    accessToken: '',
    baseUrl: '',
    baseMsUrl: '',
    baseImageUrl: '',
    jobLevels: [],
    countries: [],
    cities: [],
    districts: {},
    categories: [],
    industries: [],
    user: null,
    formResumeInfo: OnBoarding_const/* initFormData */.G2,
    setFormResumeInfo: function () { },
    resumeType: 'attachCV',
    setResumeType: function () { },
    fileInfo: {},
    setFileInfo: function () { },
    isLoading: false,
    setIsLoading: function () { }
};
var OnBoardingContext = react.createContext(initState);
var useOnBoarding = function () { return (0,react.useContext)(OnBoardingContext); };


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/helper.js
'use client';



var getOptions = function (data, lang) {
    if (!data)
        return [];
    var options = data.map(function (item) {
        return {
            id: item.id,
            name: lang === constants/* ELanguage.EN */.Df.EN ? item.nameEn : item.name
        };
    });
    return options;
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/styles.css.js
'use client';









var CustomRadio = (0,styled_components_browser_esm/* default */.ZP)(SingleRadio/* default */.Z)(OnBoarding_styles_css_templateObject_1 || (OnBoarding_styles_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n    border-radius: 12px;\n    border: 1px solid ", ";\n    min-height: 390px;\n    &:hover {\n        border: 1px solid ", ";\n    }\n"], ["\n    padding: 24px;\n    border-radius: 12px;\n    border: 1px solid ", ";\n    min-height: 390px;\n    &:hover {\n        border: 1px solid ", ";\n    }\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.90 */.O9.grey[90]);
}, Colors/* colors.primary.40 */.O9.primary[40]);
var LabelRadio = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z)(OnBoarding_styles_css_templateObject_2 || (OnBoarding_styles_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));
var ImageWrap = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_3 || (OnBoarding_styles_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 280px;\n    height: 206px;\n    display: flex;\n    margin: 0 auto;\n    img {\n        flex: 1;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        user-select: none;\n        pointer-events: none;\n    }\n"], ["\n    width: 280px;\n    height: 206px;\n    display: flex;\n    margin: 0 auto;\n    img {\n        flex: 1;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        user-select: none;\n        pointer-events: none;\n    }\n"])));
styled_components_browser_esm/* default.hr */.ZP.hr(OnBoarding_styles_css_templateObject_4 || (OnBoarding_styles_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 1px;\n    background-color: ", ";\n    border: none;\n    margin: 18px 0;\n"], ["\n    height: 1px;\n    background-color: ", ";\n    border: none;\n    margin: 18px 0;\n"])), Colors/* colors.grey.90 */.O9.grey[90]);
styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_5 || (OnBoarding_styles_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 8px;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 8px;\n"])));
var ImgContainer = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_6 || (OnBoarding_styles_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", ";\n    height: ", ";\n    overflow: hidden;\n    margin: 0 auto;\n    @media screen and (max-width: 768px) {\n        max-width: ", ";\n        width: 100%;\n        height: auto;\n    }\n"], ["\n    width: ", ";\n    height: ", ";\n    overflow: hidden;\n    margin: 0 auto;\n    @media screen and (max-width: 768px) {\n        max-width: ", ";\n        width: 100%;\n        height: auto;\n    }\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
});
var styles_css_Image = styled_components_browser_esm/* default.img */.ZP.img(OnBoarding_styles_css_templateObject_7 || (OnBoarding_styles_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    @media screen and (max-width: 768px) {\n        object-fit: contain;\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    @media screen and (max-width: 768px) {\n        object-fit: contain;\n    }\n"])));
var OnBoarding_styles_css_Container = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_8 || (OnBoarding_styles_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 9999;\n"], ["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 9999;\n"])));
var BodyContainer = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_9 || (OnBoarding_styles_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: calc(100vh - 70px);\n    background-color: #fff;\n    padding: 24px 0;\n    overflow: auto;\n"], ["\n    width: 100%;\n    height: calc(100vh - 70px);\n    background-color: #fff;\n    padding: 24px 0;\n    overflow: auto;\n"])));
var HeaderContainer = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_10 || (OnBoarding_styles_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 70px;\n    background: linear-gradient(270deg, #005aff 0%, #001744 73.72%);\n    padding: 12px 48px;\n"], ["\n    width: 100%;\n    height: 70px;\n    background: linear-gradient(270deg, #005aff 0%, #001744 73.72%);\n    padding: 12px 48px;\n"])));
var FooterContainer = styled_components_browser_esm/* default.div */.ZP.div(OnBoarding_styles_css_templateObject_11 || (OnBoarding_styles_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    z-index: 10;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: #fff;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    padding: 16px 0;\n"], ["\n    position: absolute;\n    z-index: 10;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: #fff;\n    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n    padding: 16px 0;\n"])));
var CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(OnBoarding_styles_css_templateObject_12 || (OnBoarding_styles_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    @media screen and (max-width: 768px) {\n        width: 100%;\n    }\n"], ["\n    width: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    @media screen and (max-width: 768px) {\n        width: 100%;\n    }\n"])));
var OnBoarding_styles_css_templateObject_1, OnBoarding_styles_css_templateObject_2, OnBoarding_styles_css_templateObject_3, OnBoarding_styles_css_templateObject_4, OnBoarding_styles_css_templateObject_5, OnBoarding_styles_css_templateObject_6, OnBoarding_styles_css_templateObject_7, OnBoarding_styles_css_templateObject_8, OnBoarding_styles_css_templateObject_9, OnBoarding_styles_css_templateObject_10, OnBoarding_styles_css_templateObject_11, OnBoarding_styles_css_templateObject_12;


//# sourceMappingURL=styles.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Layout/Header.js
'use client';






var Header = function () {
    return (react.createElement(HeaderContainer, null,
        react.createElement(Row/* default */.Z, null,
            react.createElement(Col/* default */.Z, { xs: 'auto' },
                react.createElement(ImgContainer, { width: '184px', height: '44px' },
                    react.createElement(styles_css_Image, { src: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png', alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))))));
};


//# sourceMappingURL=Header.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Layout/Footer.js
'use client';











var Layout_Footer_Footer = function (_a) {
    var onBack = _a.onBack, onContinue = _a.onContinue;
    var t = useTranslate().t;
    var _b = useOnBoarding(), isLoading = _b.isLoading, hash = _b.hash, setHash = _b.setHash;
    var onClickContinue = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        if (!onContinue)
            return;
        onContinue();
        switch (hashValue) {
            case EStep.PersonalInformatoion:
                setHash(EStep.HaveCV);
                break;
            case EStep.HaveCV:
                setHash(EStep.UploadCV);
                break;
            case EStep.UploadCV:
                setHash(EStep.BasicInformation);
                break;
            case EStep.BasicInformation:
                setHash(EStep.Skill);
                break;
            case EStep.Skill:
                setHash(EStep.WorkingPreference);
                break;
            case EStep.WorkingPreference:
                setHash(EStep.Recommendation);
                break;
            case EStep.Recommendation:
                setHash(EStep.Successfully);
                break;
        }
    };
    var onClickBack = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        if (!onBack)
            return;
        onBack();
        switch (hashValue) {
            case EStep.PersonalInformatoion:
                setHash(EStep.Welcome);
                break;
            case EStep.HaveCV:
                setHash(EStep.PersonalInformatoion);
                break;
            case EStep.UploadCV:
                setHash(EStep.HaveCV);
                break;
            case EStep.BasicInformation:
                setHash(EStep.UploadCV);
                break;
            case EStep.Skill:
                setHash(EStep.BasicInformation);
                break;
            case EStep.WorkingPreference:
                setHash(EStep.Skill);
                break;
            case EStep.Recommendation:
                setHash(EStep.WorkingPreference);
                break;
        }
    };
    return (react.createElement(FooterContainer, null,
        react.createElement(Row/* default */.Z, { container: { md: 12 }, gutter: 12, justify: 'center' },
            react.createElement(Col/* default */.Z, { xs: 12, sm: 'auto' },
                react.createElement(CustomButton, { onClick: onClickBack }, t('Back'))),
            react.createElement(Col/* default */.Z, { xs: 12, sm: 'auto' },
                react.createElement(CustomButton, { type: 'primary', 
                    // disabled={resumeType === 'attachCV' && step === 3 ? !fileInfo?.name : false || isLoading}
                    onClick: onClickContinue },
                    isLoading && react.createElement(LoadingIcon/* default */.Z, { bgColor: Colors/* colors.grey.80 */.O9.grey[80] }),
                    " ",
                    t('Continue'))))));
};


//# sourceMappingURL=Footer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseHash/index.js
'use client';



function useHash() {
    var _a = react.useState(function () { return window.location.hash; }), hash = _a[0], setHash = _a[1];
    var hashChangeHandler = react.useCallback(function () {
        setHash(window.location.hash);
    }, []);
    react.useEffect(function () {
        window.addEventListener('hashchange', hashChangeHandler);
        return function () {
            window.removeEventListener('hashchange', hashChangeHandler);
        };
    }, []);
    var updateHash = react.useCallback(function (newHash) {
        if (newHash !== hash)
            window.location.hash = newHash;
    }, [hash]);
    return [hash, updateHash];
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Title.js
'use client';





var Title_Title = function (_a) {
    var title = _a.title, subTitle = _a.subTitle;
    return (react.createElement(Typography/* default */.Z, { variant: 'h2', style: { textAlign: 'center', padding: '24px 0 ' } },
        react.createElement(Typography/* default */.Z, { variant: 'p', name: 'headline', size: 'large', style: { marginBottom: 8 } }, title),
        react.createElement(Typography/* default */.Z, { variant: 'p', name: 'body', size: 'large', color: Colors/* colors.grey.50 */.O9.grey[50] }, subTitle)));
};


//# sourceMappingURL=Title.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Welcome/index.js
'use client';












var Welcome = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), user = _a.user, lang = _a.lang, baseImageUrl = _a.baseImageUrl, setHash = _a.setHash;
    var name = lang === constants/* ELanguage.EN */.Df.EN ? user === null || user === void 0 ? void 0 : user.lastName : user === null || user === void 0 ? void 0 : user.firstName;
    return (react.createElement(Col/* default */.Z, null,
        react.createElement(Row/* default */.Z, { gutter: [40, 0], justify: 'center' },
            react.createElement(Col/* default */.Z, { xs: 24 },
                react.createElement(Row/* default */.Z, { gutter: 8 },
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Title_Title, { title: "".concat(t('Welcome'), ", ").concat(name), subTitle: t("You're all set to embark on a journey with Vietnamworks! Let's begin by getting to know the platform.") })),
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(ImgContainer, { width: '110px', height: '26px' },
                            react.createElement(styles_css_Image, { src: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png', alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))),
                    react.createElement(Col/* default */.Z, { xs: 24 },
                        react.createElement(ImgContainer, { width: '423px', height: '318px' },
                            react.createElement(styles_css_Image, { src: "".concat(baseImageUrl, "/onboarding/welcome.png"), alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))))),
            react.createElement(Col/* default */.Z, { xs: 'auto' },
                react.createElement(Button/* default */.Z, { type: 'primary', size: 'lg', style: { width: 200 }, onClick: function () { return setHash(EStep.PersonalInformatoion); } }, t("Let's go"))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AvatarGroupIcon/index.js
'use client';




var AvatarGroupIcon_Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 25 : _b, _c = _a.rectColor, rectColor = _c === void 0 ? Colors/* colors.grey.95 */.O9.grey[95] : _c, _d = _a.fillColor, fillColor = _d === void 0 ? Colors/* colors.grey.80 */.O9.grey[80] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 25 25', fill: 'none' },
        react.createElement("rect", { width: '25', height: '25', rx: '12.5', fill: rectColor }),
        react.createElement("path", { d: 'M12.5 6.10001C10.7325 6.10001 9.3 7.53254 9.3 9.30001V9.83334C9.3 11.6008 10.7325 13.0333 12.5 13.0333C14.2675 13.0333 15.7 11.6008 15.7 9.83334V9.30001C15.7 7.53254 14.2675 6.10001 12.5 6.10001ZM12.499 14.6333C10.3624 14.6333 7.6211 15.789 6.8323 16.8146C6.34483 17.4487 6.80887 18.3667 7.60834 18.3667H17.3906C18.1901 18.3667 18.6541 17.4487 18.1667 16.8146C17.3779 15.7895 14.6355 14.6333 12.499 14.6333Z', fill: fillColor })));
};
var Avatars = { Avatar: AvatarGroupIcon_Avatar };


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/ContactInfo/index.js
'use client';





























var ContactInfo_ContactInfo = function () {
    var _a;
    var t = useTranslate().t;
    var _b = useOnBoarding(), accessToken = _b.accessToken, baseMsUrl = _b.baseMsUrl, lang = _b.lang, countries = _b.countries, cities = _b.cities, districts = _b.districts, user = _b.user, formResumeInfo = _b.formResumeInfo, setFormResumeInfo = _b.setFormResumeInfo, setIsLoading = _b.setIsLoading;
    var nationalityOptions = (0,OnBoarding_const/* nationalityList */.Ah)(lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI);
    var validator = Form/* default.validator */.Z.validator(t);
    var rules = {
        firstName: validator.string().require().noSpecialChars().generate(),
        lastName: validator.string().require().noSpecialChars().generate(),
        email: validator.string().require().generate(),
        phone: validator.string().require().vnPhoneNumber().internationalPhoneNumber().generate(),
        birthday: validator.string().require().generate(),
        nationalityId: validator.string().require().generate(),
        genderId: validator.string().require().generate(),
        maritalStatusId: validator.string().require().generate(),
        countryId: validator.string().require().generate(),
        cityId: validator
            .number()
            .custom(function (value, watch) {
            if (!value && (watch === null || watch === void 0 ? void 0 : watch.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        districtId: validator
            .number()
            .custom(function (value, watch) {
            var isCheckCityId = OnBoarding_const/* notAllowCityId.includes */.I6.includes(watch === null || watch === void 0 ? void 0 : watch.cityId);
            if (watch.countryId !== OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb || isCheckCityId) {
                return true;
            }
            if (!value && !isCheckCityId && watch.countryId === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        address: validator.string().require().generate()
    };
    var handleUploadResumeInfo = function (values) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, (0,resumes/* updateBasicInfo */.mL)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react.createElement(Form/* default */.Z, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        react.createElement(Row/* default */.Z, { gutter: [16, 24], justify: 'center', align: 'middle' },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Title_Title, { title: t('Share a bit about who you are'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            react.createElement(Col/* default */.Z, null,
                react.createElement(ImgContainer, { width: '110px', height: '110px' }, (user === null || user === void 0 ? void 0 : user.profilePicture) ? (react.createElement(styles_css_Image, { src: (_a = user === null || user === void 0 ? void 0 : user.profilePicture) !== null && _a !== void 0 ? _a : '', alt: 'avatar' })) : (react.createElement(Avatars.Avatar, { size: 110 })))),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'firstName', rules: rules.firstName }, function (field) { return (react.createElement(Col/* default */.Z, { md: 12, xs: 24, ref: field.setItemRef },
                react.createElement(Form/* default.Label */.Z.Label, null, t('First name')),
                react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Enter your firstname'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                react.createElement(Form/* default.Error */.Z.Error, null))); }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'lastName', rules: rules.lastName }, function (field) { return (react.createElement(Col/* default */.Z, { md: 12, xs: 24, ref: field.setItemRef },
                react.createElement(Form/* default.Label */.Z.Label, null, t('Last name')),
                react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Enter your lastname'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                react.createElement(Form/* default.Error */.Z.Error, null))); }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'email', rules: rules.email }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null, t('Email')),
                    react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Enter your email'), value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError, disabled: true, readOnly: true }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'phone', rules: rules.phone }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Phone number')),
                    react.createElement(I11lPhoneNumberInput/* default */.Z, { value: field.value, placeholder: t('Enter your phone number'), hasError: field.isError, onChange: field.onChange, onBlur: field.onBlur, urlMeta: "".concat(baseMsUrl, "/").concat(OnBoarding_const/* INTERNATION_PHONE_NUMBER_END_POINT */.QV), language: lang }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'birthday', rules: rules.birthday }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Date of birth')),
                    react.createElement(DatePicker, { type: DatePicker_type/* EDatePicker.date */.f.date, langCode: lang, defaultDate: field.value ? new Date(field.value) : null, onChange: field.onChange, hasError: field.isError, onBlur: field.onBlur, max: OnBoarding_const/* MAX_DATE */.f1 }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'nationalityId', rules: rules.nationalityId }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Nationality')),
                    react.createElement(MultipleRadio/* default */.Z, { options: nationalityOptions, name: 'nationalityId', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, hasError: field.isError, onBlur: field.onBlur }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'genderId', rules: rules.genderId }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Gender')),
                    react.createElement(Row/* default */.Z, null,
                        react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(SingleRadio/* default */.Z, { id: 'gender-male', label: t('Male'), onChange: function (value) {
                                    field.onChange(OnBoarding_const/* EGender.MALE */.P2.MALE);
                                }, name: '', isLeftRadio: true, checked: field.value === OnBoarding_const/* EGender.MALE */.P2.MALE, width: 'fit-content' })),
                        react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(SingleRadio/* default */.Z, { id: 'gender-female', label: t('Female'), onChange: function (value) { return field.onChange(OnBoarding_const/* EGender.FEMALE */.P2.FEMALE); }, name: 'gender', isLeftRadio: true, checked: field.value === OnBoarding_const/* EGender.FEMALE */.P2.FEMALE, width: 'fit-content' }))),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'maritalStatusId', rules: rules.maritalStatusId }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Marital status')),
                    react.createElement(Row/* default */.Z, null,
                        react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(SingleRadio/* default */.Z, { id: 'marital-status-single', label: t('Single'), onChange: function () { return field.onChange(OnBoarding_const/* EMaritalStatus.SINGLE */.oj.SINGLE); }, name: 'marital-status', isLeftRadio: true, checked: field.value === OnBoarding_const/* EMaritalStatus.SINGLE */.oj.SINGLE, width: 'fit-content' })),
                        react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(SingleRadio/* default */.Z, { id: 'marital-status-married', label: t('Married'), onChange: function () { return field.onChange(OnBoarding_const/* EMaritalStatus.MARRIED */.oj.MARRIED); }, name: 'marital-status', isLeftRadio: true, checked: field.value === OnBoarding_const/* EMaritalStatus.MARRIED */.oj.MARRIED, width: 'fit-content' }))),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'countryId', rules: rules.countryId }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Country')),
                    react.createElement(MultipleRadio/* default */.Z, { options: countries !== null && countries !== void 0 ? countries : [], name: 'countryId', placeholder: t('Please select...'), value: field.value, onChange: function (item) {
                            field.onChange(item.value);
                            if (item.value !== OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) {
                                field.setFieldValue('cityId', OnBoarding_const/* INTERNATIONAL_CITY_ID */.F6);
                                return;
                            }
                            field.setFieldValue('cityId', undefined);
                        }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        } }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'cityId', watch: ['countryId'], rules: rules.cityId }, function (field) {
                var _a, _b, _c;
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb }, t('Province/City')),
                    react.createElement(MultipleRadio/* default */.Z, { options: cities !== null && cities !== void 0 ? cities : [], name: 'cityId', placeholder: t('Please select...'), value: field.value, onChange: function (item) {
                            field.setFieldValue('districtId', undefined);
                            field.onChange(item.value);
                        }, onBlur: field.onBlur, disable: !(((_b = field === null || field === void 0 ? void 0 : field.watch) === null || _b === void 0 ? void 0 : _b.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb), hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        } }),
                    react.createElement(Form/* default.Error */.Z.Error, { disable: !(((_c = field === null || field === void 0 ? void 0 : field.watch) === null || _c === void 0 ? void 0 : _c.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) })));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'districtId', watch: ['countryId', 'cityId'], rules: rules.districtId }, function (field) {
                var _a, _b, _c, _d, _e, _f, _g;
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb &&
                            !OnBoarding_const/* notAllowCityId.includes */.I6.includes((_b = field.watch) === null || _b === void 0 ? void 0 : _b.cityId) }, t('District')),
                    react.createElement(MultipleRadio/* default */.Z, { options: getOptions(districts === null || districts === void 0 ? void 0 : districts[(_c = field.watch) === null || _c === void 0 ? void 0 : _c.cityId], lang), name: 'District', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        }, disable: !(((_d = field.watch) === null || _d === void 0 ? void 0 : _d.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) ||
                            OnBoarding_const/* notAllowCityId.includes */.I6.includes((_e = field.watch) === null || _e === void 0 ? void 0 : _e.cityId) }),
                    react.createElement(Form/* default.Error */.Z.Error, { disable: !(((_f = field.watch) === null || _f === void 0 ? void 0 : _f.countryId) === OnBoarding_const/* VIETNAM_COUNTRY_ID */.Jb) ||
                            OnBoarding_const/* notAllowCityId.includes */.I6.includes((_g = field.watch) === null || _g === void 0 ? void 0 : _g.cityId) })));
            }),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'address', rules: rules.address }, function (field) {
                return (react.createElement(Col/* default */.Z, { xs: 24, md: 12, ref: field.setItemRef },
                    react.createElement(Form/* default.Label */.Z.Label, null,
                        " ",
                        t('Address')),
                    react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Enter your address'), value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError }),
                    react.createElement(Form/* default.Error */.Z.Error, null)));
            }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/ChooseResume/Radio.js
'use client';








var ChooseResume_Radio_Radio = function (_a) {
    var title = _a.title, value = _a.value, description = _a.description, image = _a.image, onChange = _a.onChange, name = _a.name, _b = _a.layout, layout = _b === void 0 ? 'col' : _b;
    var renderLabel = function () {
        return (react.createElement(LabelRadio, { gutter: 16 },
            react.createElement(Col/* default */.Z, { xs: layout === 'col' ? 24 : 'auto' },
                react.createElement(ImageWrap, null,
                    react.createElement("img", { src: image, alt: 'icon' }))),
            react.createElement(Col/* default */.Z, { xs: layout === 'col' ? 24 : 'fill' },
                react.createElement(Typography/* default */.Z, { variant: 'p', name: 'title', size: 'extraLarge', color: Colors/* colors.primary.0 */.O9.primary[0], style: { textAlign: 'center' } }, title),
                react.createElement(Typography/* default */.Z, { variant: 'p', name: 'paragraph', size: 'medium', color: Colors/* colors.primary.0 */.O9.primary[0], style: { whiteSpace: 'pre-wrap', marginTop: 8, textAlign: 'center' } }, description))));
    };
    return (react.createElement(CustomRadio, { id: "".concat(name, "-radio"), name: name, customValue: renderLabel(), isCustomLabel: true, onChange: onChange, checked: value, isActive: value }));
};


//# sourceMappingURL=Radio.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/ChooseResume/index.js
'use client';









var ChooseResume = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), resumeType = _a.resumeType, setResumeType = _a.setResumeType;
    return (react.createElement(Col/* default */.Z, null,
        react.createElement(Row/* default */.Z, { gutter: [24, 0] },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Title_Title, { title: t('Do you have a CV yet?'), subTitle: t("We're using this info to make your experience unique.") })),
            react.createElement(Col/* default */.Z, { xs: 24 },
                react.createElement(Row/* default */.Z, { gutter: 12 },
                    react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                        react.createElement(ChooseResume_Radio_Radio, { title: t('I already have a CV'), description: t('Allocating 5 - 8 minutes for your information can pave the way to your dream job or the right company for you.'), image: 'https://staging-images.vietnamworks.com/onboarding/already-have-cv.png', value: resumeType === 'attachCV', onChange: function () { return setResumeType('attachCV'); }, name: 'attachCV' })),
                    react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                        react.createElement(ChooseResume_Radio_Radio, { title: t("No profile yet? Let's build your VietnamWorks profile together."), description: t('Allocating 15 - 20 minutes to provide your details, ensuring you have a professional CV and easy profile management down the road.'), image: 'https://staging-images.vietnamworks.com/onboarding/create-vnw-profile.png', value: resumeType === 'vnwProfile', onChange: function () { return setResumeType('vnwProfile'); }, name: 'profile' })))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/DragDropResumeUpload/type.js
var DragDropResumeUpload_type = __webpack_require__(65834);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/UploadAttachResume/index.js
'use client';











var UploadAttachResume = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), accessToken = _a.accessToken, baseMsUrl = _a.baseMsUrl, lang = _a.lang, setFileInfo = _a.setFileInfo, fileInfo = _a.fileInfo, formResumeInfo = _a.formResumeInfo, setFormResumeInfo = _a.setFormResumeInfo;
    return (react.createElement(Col/* default */.Z, { xs: 24 },
        react.createElement(Row/* default */.Z, { gutter: [24, 0] },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Title_Title, { title: t('Upload your CV now'), subTitle: t('You can make CV updates whenever you need, no worries.') })),
            react.createElement(Col/* default */.Z, { xs: 24 },
                react.createElement(DragDropResumeUpload/* default */.Z, { style: { maxWidth: 684, margin: '0 auto' }, accessToken: accessToken, baseUrl: baseMsUrl, boxType: DragDropResumeUpload_type/* EBoxType.secondary */.Y.secondary, isUploadResume: true, fileInfo: fileInfo, lang: lang, onUploadDone: function (res) {
                        var _a, _b, _c, _d, _e, _f;
                        var jobAlertData = res === null || res === void 0 ? void 0 : res.data.job_alert_data;
                        setFileInfo && setFileInfo({ name: (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.name, link: (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.link });
                        setFormResumeInfo((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, formResumeInfo), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.title) ? { jobTitle: (_c = jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.title) !== null && _c !== void 0 ? _c : '' } : undefined)), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.year_of_exp)
                            ? { yearsExperience: (_d = jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.year_of_exp) !== null && _d !== void 0 ? _d : 0 }
                            : undefined)), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.locationId)
                            ? { locations: (_e = [{ cityId: jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.locationId, districtId: -1 }]) !== null && _e !== void 0 ? _e : [] }
                            : undefined)), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.level) ? { jobLevelId: (_f = jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.level) !== null && _f !== void 0 ? _f : 0 } : undefined)), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.salary) ? { salary: Number(jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.salary) } : undefined)), ((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.industry) && (jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.industry.length) > 0
                            ? { industries: jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.industry }
                            : undefined)));
                    }, apiUploadVersion: 'v1.0' })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/BasicInfo/index.js
'use client';

















var BasicInfo = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, jobLevels = _a.jobLevels, categories = _a.categories, industries = _a.industries, lang = _a.lang, formResumeInfo = _a.formResumeInfo, setFormResumeInfo = _a.setFormResumeInfo, setIsLoading = _a.setIsLoading;
    var validator = Form/* default.validator */.Z.validator(t);
    var rules = {
        jobTitle: validator.string().require().noNumberAndEmail().noSpecialCharsForJobTitle().generate(),
        currentJobFunction: validator.string().require().generate(),
        currentIndustries: validator
            .array()
            .custom(function (value) {
            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        currentSalary: validator
            .number()
            .custom(function (value) {
            if (!parseInt(value)) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        jobLevelId: validator.string().require().generate(),
        yearsExperience: validator
            .number()
            .custom(function (value, watch) {
            var isHightLevel = ![OnBoarding_const/* INTERNSHIP_ID */.dv, OnBoarding_const/* FRESHER_ID */.yE].includes(watch.jobLevelId);
            var isValid = !isHightLevel || (value && isHightLevel);
            return isValid;
        }, t('This field is required.'))
            .generate(),
        highestDegreeId: validator.string().require().generate()
    };
    var handleUploadResumeInfo = function (values) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, (0,resumes/* updateBasicInfo */.mL)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react.createElement(Form/* default */.Z, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        react.createElement(Row/* default */.Z, { gutter: [16, 24], justify: 'center', align: 'middle' },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Title_Title, { title: t('Share a bit about who you are'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            react.createElement(Col/* default */.Z, { xs: 24, md: 12 },
                react.createElement(Row/* default */.Z, { gutter: [16, 24], justify: 'center', align: 'middle' },
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'jobTitle', rules: rules.jobTitle }, function (field) { return (react.createElement(Col/* default */.Z, { xs: 24, ref: field.setItemRef },
                        react.createElement(Form/* default.Label */.Z.Label, null, t('Job title')),
                        react.createElement(components_Input/* default */.Z, { type: 'text', placeholder: t('Enter your job title'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 80 }),
                        react.createElement(Form/* default.Error */.Z.Error, null))); }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'currentJobFunction', rules: rules.currentJobFunction }, function (field) {
                        return (react.createElement(Col/* default */.Z, { xs: 24, ref: field.setItemRef },
                            react.createElement(Form/* default.Label */.Z.Label, null, t('Current job function')),
                            react.createElement(MultipleRadio/* default */.Z, { options: categories !== null && categories !== void 0 ? categories : [], name: 'jobLevelId', placeholder: t('Please select...'), value: field.value, onBlur: field.onBlur, onChange: function (value) { return field.onChange(value.value); }, hasError: field.isError, dropdown: {
                                    maxHeight: '330px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'currentIndustries', rules: rules.currentIndustries }, function (field) {
                        var _a;
                        return (react.createElement(Col/* default */.Z, { xs: 24, ref: field.setItemRef },
                            react.createElement(Form/* default.Label */.Z.Label, null, t('Current industry')),
                            react.createElement(CompanyIndustry/* default */.Z, { type: 'multiple-select', options: (_a = industries) !== null && _a !== void 0 ? _a : [], value: field.value, onChange: function (value) { return field.onChange(value); }, onBlur: field.onBlur, hasError: field.isError, langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI, isMobile: false, dropdownStyle: { width: '100%' } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'currentSalary', rules: rules.currentSalary }, function (field) {
                        return (react.createElement(Col/* default */.Z, { xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, { require: true }, t('Current salary')),
                            react.createElement(InputYOE/* default */.Z, { postfixText: t('USD/month'), placeholder: t('Enter your current salary'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: field.isError, options: {
                                    min: OnBoarding_const/* DEFAULT_MIN_SALARY */.DE,
                                    max: OnBoarding_const/* DEFAULT_MAX_SALARY */.X4,
                                    canBeEmpty: true
                                }, typeInput: 'text', onChange: field.onChange, onBlur: field.onBlur }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'jobLevelId', rules: rules.jobLevelId }, function (field) {
                        return (react.createElement(Col/* default */.Z, { xs: 24 },
                            react.createElement(Form/* default.Label */.Z.Label, { require: true }, t('Current job level')),
                            react.createElement(MultipleRadio/* default */.Z, { options: jobLevels !== null && jobLevels !== void 0 ? jobLevels : [], name: 'level-list', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'yearsExperience', watch: ['jobLevelId'], rules: rules.yearsExperience }, function (field) {
                        var _a;
                        var isHightLevel = ![OnBoarding_const/* INTERNSHIP_ID */.dv, OnBoarding_const/* FRESHER_ID */.yE].includes((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobLevelId);
                        return (react.createElement(Col/* default */.Z, { xs: 24, ref: field.setItemRef },
                            react.createElement(Form/* default.Label */.Z.Label, { require: isHightLevel }, t('Years of experience')),
                            react.createElement(InputYOE/* default */.Z, { onChange: function (value) { return field.onChange(parseInt(value)); }, onBlur: function () { return field.onBlur(); }, postfixText: Number(field.value) > 1 ? t('Years') : t('Year'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: !isHightLevel ? false : field.isError, placeholder: t('Enter your year experience') }),
                            react.createElement(Form/* default.Error */.Z.Error, { disable: !isHightLevel })));
                    }),
                    react.createElement(Form/* default.Item */.Z.Item, { name: 'highestDegreeId', rules: rules.highestDegreeId }, function (field) {
                        return (react.createElement(Col/* default */.Z, { xs: 24, ref: field.setItemRef },
                            react.createElement(Form/* default.Label */.Z.Label, null, t('Highest education')),
                            react.createElement(MultipleRadio/* default */.Z, { options: OnBoarding_const/* educations.map */.vI.map(function (education) { return ({
                                    id: education.id,
                                    name: lang === constants/* ELanguage.EN */.Df.EN ? education.nameEn : education.name
                                }); }), name: 'highestDegree', placeholder: t('Please select...'), value: field.value, onChange: function (value) { return field.onChange(value.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '330px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            react.createElement(Form/* default.Error */.Z.Error, null)));
                    }))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var Images_SearchIcon = __webpack_require__(6538);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Skill/SkillField.js
'use client';




















var SkillField = function (_a) {
    var _b;
    var field = _a.field;
    var t = useTranslate().t;
    var _c = useOnBoarding(), baseMsUrl = _c.baseMsUrl, accessToken = _c.accessToken, lang = _c.lang;
    var _d = (0,react.useState)(''), inputValue = _d[0], setInputValue = _d[1];
    var _e = (0,react.useState)(), userSelectskills = _e[0], setUserSelectSkills = _e[1];
    var _f = (0,react.useState)(), suggetionSkills = _f[0], setSuggetionSkills = _f[1];
    var _g = (0,react.useState)(), recommendSkills = _g[0], setRecommendSkills = _g[1];
    var debounceValue = (0,useDebounce/* default */.Z)(inputValue, OnBoarding_const/* SEARCH_DELAY_TIME */.JC);
    var getSuggetionSkills = function (searchKeyworks, limit) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var selectedSkills, suggetionSkills_1, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    selectedSkills = userSelectskills === null || userSelectskills === void 0 ? void 0 : userSelectskills.map(function (skill) { return skill.name; });
                    return [4 /*yield*/, (0,resumes/* getSkills */.SM)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', searchKeyworks, selectedSkills, limit, lang)];
                case 1:
                    suggetionSkills_1 = _a.sent();
                    return [2 /*return*/, suggetionSkills_1];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRecommendSkills = function (value) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var recommendSkills;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSuggetionSkills(value)];
                case 1:
                    recommendSkills = _a.sent();
                    if (recommendSkills) {
                        setRecommendSkills(recommendSkills);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (debounceValue) {
            getRecommendSkills(debounceValue);
        }
    }, [debounceValue, userSelectskills]);
    (0,react.useEffect)(function () {
        var _a, _b;
        if (!((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobTitle))
            return;
        getSuggetionSkills((_b = field.watch) === null || _b === void 0 ? void 0 : _b.jobTitle, 5)
            .then(function (skills) {
            if (skills) {
                setSuggetionSkills(skills);
            }
        })
            .catch(function (error) { return console.error(error); });
    }, [(_b = field.watch) === null || _b === void 0 ? void 0 : _b.jobTitle, userSelectskills]);
    (0,react.useEffect)(function () {
        if (field.value && field.value.length > 0) {
            var userSelectedSkills = field.value.map(function (skill, index) {
                return {
                    id: index--,
                    name: skill.skillName
                };
            });
            setUserSelectSkills(userSelectedSkills);
        }
    }, [field.value]);
    return (react.createElement(Row/* default */.Z, { gutter: [16, 24] },
        react.createElement(Col/* default */.Z, null,
            react.createElement(components_Input/* default */.Z, { type: 'text', value: inputValue, placeholder: t('Search'), clearValue: true, onChange: setInputValue, prefixIcon: react.createElement(Images_SearchIcon/* default */.Z, null), hasError: field.isError, onClickSuggestionItem: function (suggestion) {
                    var _a;
                    field.onChange((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], ((_a = field.value) !== null && _a !== void 0 ? _a : []), true), [
                        {
                            skillName: suggestion.name,
                            skillLevel: 1
                        }
                    ], false));
                    setUserSelectSkills((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], (userSelectskills !== null && userSelectskills !== void 0 ? userSelectskills : []), true), [suggestion], false));
                    setInputValue('');
                }, listRecommend: recommendSkills, searchNotFound: t('No Result Found') })),
        userSelectskills && userSelectskills.length > 0 ? (react.createElement(Col/* default */.Z, null,
            react.createElement(Row/* default */.Z, { gutter: 8 }, userSelectskills === null || userSelectskills === void 0 ? void 0 : userSelectskills.map(function (skill, index) {
                return (react.createElement(Col/* default */.Z, { xs: 'auto', key: "".concat(skill.name, "_").concat(skill.id, "_").concat(index) },
                    react.createElement(components_Tag/* default */.Z, { iconType: 'remove', label: skill.name, onClick: (0,helpers/* debounceHandler */.BN)(function () {
                            var _a;
                            setUserSelectSkills(userSelectskills.filter(function (_, indexSkill) { return indexSkill !== index; }));
                            field.onChange((_a = field.value) === null || _a === void 0 ? void 0 : _a.filter(function (_, indexValue) { return indexValue !== index; }));
                        }, OnBoarding_const/* CLICK_DELAY_TIME */.GM), size: 'medium', isMobile: false })));
            })))) : null,
        suggetionSkills && suggetionSkills.length > 0 ? (react.createElement(Col/* default */.Z, null,
            react.createElement(Form/* default.Label */.Z.Label, null, t('Suggested skills for you')),
            react.createElement(Row/* default */.Z, { gutter: 8 }, suggetionSkills.map(function (skill) {
                return (react.createElement(Col/* default */.Z, { xs: 'auto', key: "".concat(skill.name, "_").concat(skill.id) },
                    react.createElement(components_Tag/* default */.Z, { iconType: 'add', label: skill.name, onClick: (0,helpers/* debounceHandler */.BN)(function () {
                            setUserSelectSkills((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], (userSelectskills !== null && userSelectskills !== void 0 ? userSelectskills : []), true), [skill], false));
                            // change field value when selected recommendSkill
                            field.onChange((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], field.value, true), [
                                {
                                    skillName: skill.name,
                                    skillLevel: 1
                                }
                            ], false));
                        }, OnBoarding_const/* CLICK_DELAY_TIME */.GM), size: 'medium', isMobile: true })));
            })))) : null));
};


//# sourceMappingURL=SkillField.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Skill/index.js
'use client';













var Skills = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), formResumeInfo = _a.formResumeInfo, setFormResumeInfo = _a.setFormResumeInfo, setIsLoading = _a.setIsLoading, baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, lang = _a.lang;
    var handleUploadResumeInfo = function (values) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, (0,resumes/* updateBasicInfo */.mL)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react.createElement(Form/* default */.Z, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        react.createElement(Row/* default */.Z, { gutter: [16, 24] },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Title_Title, { title: t('Skill'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            react.createElement(Col/* default */.Z, null,
                react.createElement(Typography/* default */.Z, { variant: 'label', name: 'title', size: 'large' }, t('Skills'))),
            react.createElement(Form/* default.Item */.Z.Item, { name: 'skills', watch: ['jobTitle'] }, function (field) {
                return (react.createElement(Col/* default */.Z, null,
                    react.createElement(SkillField, { field: field })));
            }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/components/Successfully/index.js
'use client';












var Successfully = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), baseImageUrl = _a.baseImageUrl, baseUrl = _a.baseUrl;
    return (react.createElement(Col/* default */.Z, null,
        react.createElement(Row/* default */.Z, { gutter: [16, 0], justify: 'center', style: { marginTop: 50 } },
            react.createElement(Col/* default */.Z, { xs: 24, md: 16 },
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(ImgContainer, { width: '423px', height: '318px' },
                            react.createElement(styles_css_Image, { src: "".concat(baseImageUrl, "/onboarding/create-profile-success.png"), alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))),
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Title_Title, { title: t("You've successfully set up your profile"), subTitle: t('Congratulations! Your profile is good to go. Start your journey towards your dream job and connect with potential employers.') })))),
            react.createElement(Col/* default */.Z, { xs: 24, md: 16 },
                react.createElement(Button/* default */.Z, { type: 'primary', size: 'lg', style: { width: '100% ' }, onClick: function () {
                        var VNW_NEW_REGISTERED_COOKIES = (0,cookie/* getCookie */.e)(OnBoarding_const/* VNW_NEW_REGISTERED */.JT);
                        if (VNW_NEW_REGISTERED_COOKIES) {
                            (0,cookie/* setCookie */.d)(OnBoarding_const/* VNW_NEW_REGISTERED */.JT, 'false', -1);
                        }
                        window.location.assign("".concat(baseUrl, "/").concat(t('my-profile')));
                    } }, t('View my profile'))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Contexts/translator/helper.js
var translator_helper = __webpack_require__(16697);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/OnBoarding/ index.js
'use client';


























var OnBoarding = function (_a) {
    var _b, _c, _d, _e;
    var isShow = _a.isShow, _f = _a.lang, lang = _f === void 0 ? constants/* ELanguage.VI */.Df.VI : _f, accessToken = _a.accessToken, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, baseImageUrl = _a.baseImageUrl, jobLevels = _a.jobLevels, countries = _a.countries, cities = _a.cities, districts = _a.districts, categories = _a.categories, industries = _a.industries, user = _a.user;
    var _g = useHash(), hash = _g[0], setHash = _g[1];
    // const [step, setStep] = useState<EStep>(EStep.Welcome)
    var _h = (0,react.useState)('attachCV'), resumeType = _h[0], setResumeType = _h[1];
    var _j = (0,react.useState)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, OnBoarding_const/* initFormData */.G2), { firstName: (_b = user.firstName) !== null && _b !== void 0 ? _b : '', lastName: (_c = user.lastName) !== null && _c !== void 0 ? _c : '', email: (_d = user.userName) !== null && _d !== void 0 ? _d : '', phone: (_e = user.phone) !== null && _e !== void 0 ? _e : '' })), formResumeInfo = _j[0], setFormResumeInfo = _j[1];
    var _k = (0,react.useState)(), fileInfo = _k[0], setFileInfo = _k[1];
    var _l = (0,react.useState)(false), isLoading = _l[0], setIsLoading = _l[1];
    var t = function (txt) {
        var text = (0,translator_helper/* translator */.O)(txt, OnBoarding_translations_translations, lang);
        return text;
    };
    var contextValue = {
        lang: lang,
        hash: hash,
        setHash: setHash,
        accessToken: accessToken,
        baseMsUrl: baseMsUrl,
        baseUrl: baseUrl,
        baseImageUrl: baseImageUrl,
        jobLevels: getOptions(jobLevels, lang),
        countries: getOptions(countries, lang),
        cities: getOptions(cities, lang),
        districts: districts,
        categories: getOptions(categories, lang),
        industries: industries,
        user: user,
        resumeType: resumeType,
        setResumeType: setResumeType,
        fileInfo: fileInfo,
        setFileInfo: setFileInfo,
        formResumeInfo: formResumeInfo,
        setFormResumeInfo: setFormResumeInfo,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
    var renderStep = function () {
        var hashValue = hash.split('#').pop();
        switch (hashValue) {
            case EStep.Welcome:
                return react.createElement(Welcome, null);
            case EStep.PersonalInformatoion:
                return react.createElement(ContactInfo_ContactInfo, null);
            case EStep.HaveCV:
                return react.createElement(ChooseResume, null);
            case EStep.UploadCV:
                return react.createElement(UploadAttachResume, null);
            case EStep.BasicInformation:
                return react.createElement(BasicInfo, null);
            case EStep.Skill:
                return react.createElement(Skills, null);
            case EStep.Recommendation:
                return react.createElement(Welcome, null);
            case EStep.Successfully:
                return react.createElement(Successfully, null);
        }
    };
    var renderFooter = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        var isHideFooter = hashValue === EStep.Welcome || hashValue === EStep.Successfully;
        if (isHideFooter)
            return;
        return react.createElement(Layout_Footer_Footer, { onBack: function () { }, onContinue: function () { } });
    };
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    (0,react.useEffect)(function () {
        if (!bodyNode) {
            return;
        }
        document.body.style.overflow = 'initial';
        setHash(EStep.BasicInformation);
        if (isShow) {
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.body.style.overflow = 'initial';
        };
    }, [bodyNode, isShow]);
    if (!bodyNode)
        return react.createElement(react.Fragment, null);
    return isShow ? ((0,react_dom.createPortal)(react.createElement(OnBoardingContext.Provider, { value: contextValue },
        react.createElement(TranslateContext.Provider, { value: { t: t } },
            react.createElement(OnBoarding_styles_css_Container, null,
                react.createElement(Header, null),
                react.createElement(BodyContainer, null,
                    react.createElement(Row/* default */.Z, { gutter: 16, container: { sm: 12 } }, renderStep())),
                renderFooter()))), bodyNode)) : (react.createElement(react.Fragment, null));
};


//# sourceMappingURL= index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/QuestionMarkIcon.js
'use client';




var QuestionMarkIcon_QuestionMarkIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.fill, fill = _c === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _c, onBlur = _a.onBlur, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (react.createElement("svg", { width: size, height: size, viewBox: "0 0 ".concat(size, " ").concat(size), fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); }, onBlur: function () { return onBlur === null || onBlur === void 0 ? void 0 : onBlur(); }, onMouseLeave: function () { return onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(); }, onMouseEnter: function () { return onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(); } },
        react.createElement("path", { d: "M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8 13C7.448 13 7 12.552 7 12C7 11.448 7.448 11 8 11C8.552 11 9 11.448 9 12C9 12.552 8.552 13 8 13ZM9.37867 8.33333C8.93733 8.74067 8.66667 9.008 8.66667 9.33333H7.33333C7.33333 8.40733 7.966 7.82333 8.474 7.35333C9.00667 6.86133 9.33333 6.53267 9.33333 6C9.33333 5.26467 8.73533 4.66667 8 4.66667C7.26467 4.66667 6.66667 5.26467 6.66667 6H5.33333C5.33333 4.52933 6.52933 3.33333 8 3.33333C9.47067 3.33333 10.6667 4.52933 10.6667 6C10.6667 7.14333 9.95267 7.80267 9.37867 8.33333Z", fill: fill })));
};
var QuestionMarkIcon_QuestionMarkIcon$1 = react.memo(QuestionMarkIcon_QuestionMarkIcon);


//# sourceMappingURL=QuestionMarkIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/XaloLead/styled.js
'use client';







var styled_Container = styled_components_browser_esm/* default.div */.ZP.div(XaloLead_styled_templateObject_1 || (XaloLead_styled_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 12px;\n    background: ", ";\n    padding: 23.5px;\n    transition: all 0.25s ease-in;\n"], ["\n    border-radius: 12px;\n    background: ", ";\n    padding: 23.5px;\n    transition: all 0.25s ease-in;\n"])), Colors/* colors.primary.100 */.O9.primary[100]);
var LogoWrap = styled_components_browser_esm/* default.div */.ZP.div(XaloLead_styled_templateObject_2 || (XaloLead_styled_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 auto;\n    width: 174px;\n    height: 63px;\n"], ["\n    margin: 0 auto;\n    width: 174px;\n    height: 63px;\n"])));
var styled_Logo = styled_components_browser_esm/* default.img */.ZP.img(XaloLead_styled_templateObject_3 || (XaloLead_styled_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    flex: 1;\n"], ["\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    flex: 1;\n"])));
var styled_Box = styled_components_browser_esm/* default.div */.ZP.div(XaloLead_styled_templateObject_4 || (XaloLead_styled_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
var FormWrapper = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z)(styled_templateObject_6 || (styled_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    max-height: ", "px;\n    ", ";\n    overflow: hidden;\n    transition: all 0.25s ease-in;\n"], ["\n    max-height: ", "px;\n    ", ";\n    overflow: hidden;\n    transition: all 0.25s ease-in;\n"])), function (_a) {
    var activeForm = _a.activeForm;
    return (activeForm ? 500 : 0);
}, function (_a) {
    var activeForm = _a.activeForm;
    if (!activeForm) {
        return (0,styled_components_browser_esm/* css */.iv)(XaloLead_styled_templateObject_5 || (XaloLead_styled_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                padding: 0 9px;\n            "], ["\n                padding: 0 9px;\n            "])));
    }
});
var XaloLead_styled_templateObject_1, XaloLead_styled_templateObject_2, XaloLead_styled_templateObject_3, XaloLead_styled_templateObject_4, XaloLead_styled_templateObject_5, styled_templateObject_6;


//# sourceMappingURL=styled.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/xaloLead/const.js
'use client';

var XALOLEAD_ENDPOINT = 'xalolead/v1.0/xalolead';
var SEND_MAIL_ENDPOINT = 'xalolead/v1.0/sendMail';


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/xaloLead/index.js
'use client';




function getXaloLead(baseMsUrl, langCode) {
    var _a, _b;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, resData, xaloleadInfo, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(XALOLEAD_ENDPOINT), {
                            method: 'GET',
                            headers: {
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _c.sent();
                    if ((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        xaloleadInfo = (_b = resData === null || resData === void 0 ? void 0 : resData.data) === null || _b === void 0 ? void 0 : _b.attributes;
                        return [2 /*return*/, xaloleadInfo];
                    }
                    return [2 /*return*/];
                case 3:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function sendMailXaloLead(baseMsUrl, langCode, data) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var formData, _i, _a, _b, key, value, response, resData, err_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    for (_i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
                        _b = _a[_i], key = _b[0], value = _b[1];
                        if (value) {
                            formData.append(key, value);
                        }
                    }
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(SEND_MAIL_ENDPOINT), {
                            method: 'POST',
                            headers: {
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _c.sent();
                    if ((resData === null || resData === void 0 ? void 0 : resData.status) === 'SUCCESS') {
                        return [2 /*return*/, resData];
                    }
                    return [2 /*return*/];
                case 3:
                    err_2 = _c.sent();
                    console.error(err_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CheckSuccessIcon/index.js
'use client';



function CheckSuccessIcon() {
    return (react.createElement("svg", { width: '15', height: '15', viewBox: '0 0 15 15', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'MY-JOBS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
            react.createElement("g", { id: 'CC/MYJOBS-SAVED-APPLYMULTIPLE-CHOOSEFILE', transform: 'translate(-1003.000000, -365.000000)', stroke: '#45C500', strokeWidth: '1.6' },
                react.createElement("g", { id: 'Group-25', transform: 'translate(190.000000, 267.000000)' },
                    react.createElement("g", { id: 'Group-26', transform: 'translate(562.344262, 0.000000)' },
                        react.createElement("g", { id: 'Group-22', transform: 'translate(0.000000, 62.000000)' },
                            react.createElement("g", { id: 'Group-11', transform: 'translate(244.000000, 28.000000)' },
                                react.createElement("g", { transform: 'translate(2.000000, 2.000000)', id: 'Group-27' },
                                    react.createElement("g", { id: 'icons8-checkmark-(5)', transform: 'translate(6.000000, 7.000000)' },
                                        react.createElement("polyline", { id: 'Path', points: '0 6.07896794 4.91329412 10 12 0' })))))))))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/XaloLead/components/XaloLeadInformation.js
'use client';









function XaloLeadInformation(_a) {
    var _b, _c, _d;
    var xaloLead = _a.xaloLead;
    return (react.createElement(react.Fragment, null,
        react.createElement(Col/* default */.Z, { xs: 24 },
            react.createElement(Row/* default */.Z, { gutter: [4, 0] },
                react.createElement(Col/* default */.Z, null,
                    react.createElement(LogoWrap, null,
                        react.createElement(styled_Logo, { src: (_b = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupImage) !== null && _b !== void 0 ? _b : '', alt: 'logo xalo lead' }))),
                react.createElement(Col/* default */.Z, null,
                    react.createElement(Typography/* default */.Z, { variant: 'p', color: Colors/* colors.primary.0 */.O9.primary[0], name: 'label', size: 'medium' }, (_c = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupTitle) !== null && _c !== void 0 ? _c : '')))),
        (xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.benefits) && xaloLead.benefits.length > 0 ? (react.createElement(Col/* default */.Z, { xs: 24 },
            react.createElement(Row/* default */.Z, { gutter: 8 },
                react.createElement(Col/* default */.Z, null,
                    react.createElement(Typography/* default */.Z, { variant: 'p', color: Colors/* colors.primary.0 */.O9.primary[0], name: 'label', size: 'medium' }, (_d = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupPointTitle) !== null && _d !== void 0 ? _d : '')),
                xaloLead.benefits.map(function (item, index) {
                    if (!item)
                        return;
                    return (react.createElement(Col/* default */.Z, { key: index },
                        react.createElement(Row/* default */.Z, { gutter: [0, 6], align: 'top' },
                            react.createElement(Col/* default */.Z, { xs: 'auto', style: { marginTop: 3 } },
                                react.createElement(CheckSuccessIcon, null)),
                            react.createElement(Col/* default */.Z, { xs: 'fill' },
                                react.createElement(Typography/* default */.Z, { variant: 'p', color: Colors/* colors.primary.0 */.O9.primary[0], name: 'paragraph', size: 'medium' }, item)))));
                })))) : null));
}


//# sourceMappingURL=XaloLeadInformation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/XaloLead/components/FormRegisterXaloLead.js
'use client';













function FormRegisterXaloLead(_a, ref) {
    var _this = this;
    var xaloLead = _a.xaloLead, active = _a.active, formData = _a.formData, baseMsUrl = _a.baseMsUrl, _b = _a.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, setIsSuccess = _a.setIsSuccess, user = _a.user;
    var formRef = (0,react.useRef)(null);
    var validator = Form/* default.validator */.Z.validator();
    var rules = {
        txtCMBFullName: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .noSpecialChars('Thông tin này bắt buộc.')
            .generate(),
        txtCMBEmail: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .email('Địa chỉ Email không hợp lệ')
            .generate(),
        txtCMBCellphone: validator.string().require('Thông tin này bắt buộc.').generate(),
        txtCMBAddress: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .noSpecialCharsWithoutNumber('Vui lòng không nhập số hoặc ký tự đặc biệt.')
            .generate(),
        txtCMBYearExp: validator.number().require('Thông tin này bắt buộc.').generate(),
        chkCMBAgreeTerm: validator
            .string()
            .custom(function (value) {
            if (value === 'off') {
                return false;
            }
            return true;
        }, 'Thông tin này bắt buộc.')
            .generate()
    };
    var handleSendLead = function (data) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var sendLead;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendMailXaloLead(baseMsUrl, langCode, data)];
                case 1:
                    sendLead = _a.sent();
                    if (sendLead) {
                        setIsSuccess(true);
                        (0,cookie/* setCookie */.d)('xaloLeadRegistered', String(user.userId), 180);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    console.error();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, [user]);
    return (react.createElement(FormWrapper, { xs: 24, activeForm: active },
        react.createElement(Form/* default */.Z, { ref: formRef, initialValues: formData, onSubmit: function (values) { return handleSendLead(values); } },
            react.createElement(Row/* default */.Z, { gutter: 8 },
                react.createElement(Form/* default.Item */.Z.Item, { name: 'txtCMBFullName', rules: rules.txtCMBFullName }, function (field) {
                    return (react.createElement(Col/* default */.Z, { xs: 24 },
                        react.createElement(components_Input/* default */.Z, { placeholder: 'H\u1ECD v\u00E0 t\u00EAn', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'txtCMBEmail', rules: rules.txtCMBEmail }, function (field) {
                    return (react.createElement(Col/* default */.Z, { xs: 12 },
                        react.createElement(components_Input/* default */.Z, { placeholder: 'Email', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'txtCMBCellphone', rules: rules.txtCMBCellphone }, function (field) {
                    return (react.createElement(Col/* default */.Z, { xs: 12 },
                        react.createElement(components_Input/* default */.Z, { placeholder: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 13 }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'txtCMBAddress', rules: rules.txtCMBAddress }, function (field) {
                    return (react.createElement(Col/* default */.Z, { xs: 12 },
                        react.createElement(components_Input/* default */.Z, { placeholder: 'Khu v\u1EF1c', type: 'text', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'txtCMBYearExp', rules: rules.txtCMBYearExp }, function (field) {
                    return (react.createElement(Col/* default */.Z, { xs: 12 },
                        react.createElement(components_Input/* default */.Z, { placeholder: 'S\u1ED1 tu\u1ED5i', type: 'number', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 3 }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                }),
                react.createElement(Form/* default.Item */.Z.Item, { name: 'chkCMBAgreeTerm', rules: rules.chkCMBAgreeTerm }, function (field) {
                    var _a;
                    return (react.createElement(Col/* default */.Z, { xs: 24 },
                        react.createElement(CheckBox/* default */.Z, { labelRightMargin: 0, customLabel: react.createElement("label", { style: { marginLeft: 8 }, dangerouslySetInnerHTML: { __html: (_a = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupTermsAndCond) !== null && _a !== void 0 ? _a : '' } }), state: field.value === 'on' ? 'checked' : 'none', onCheckChange: function (value) {
                                field.onChange(value === 'checked' ? 'on' : 'off');
                            } }),
                        react.createElement(Form/* default.Error */.Z.Error, null)));
                })))));
}
var FormRegisterXaloLead$1 = react.forwardRef(FormRegisterXaloLead);


//# sourceMappingURL=FormRegisterXaloLead.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/XaloLead/const.js
'use client';

var TRIGGER_HASH = '#formCallMeBack';


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/XaloLead/index.js
'use client';
















var XaloLead = function (_a) {
    var _b, _c, _d, _e, _f;
    var baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _g = _a.langCode, langCode = _g === void 0 ? constants/* ELanguage.VI */.Df.VI : _g, user = _a.user;
    var _h = (0,react.useState)(null), xaloLead = _h[0], setXaloLead = _h[1];
    var _j = (0,react.useState)(false), activeForm = _j[0], setActiveForm = _j[1];
    var _k = (0,react.useState)(false), isSuccess = _k[0], setIsSuccess = _k[1];
    var ref = (0,react.useRef)(null);
    var xaloLeadRegistered = (0,cookie/* getCookie */.e)('xaloLeadRegistered');
    var isXaloLeadRegistered = Number(xaloLeadRegistered) === (user === null || user === void 0 ? void 0 : user.userId);
    var xaloleadInfo = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var info, error_1;
        var _a, _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getXaloLead(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', langCode)];
                case 1:
                    info = _e.sent();
                    if (info) {
                        setXaloLead((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, info), { benefits: [
                                (_a = info.popupPoint1Title) !== null && _a !== void 0 ? _a : '',
                                (_b = info.popupPoint2Title) !== null && _b !== void 0 ? _b : '',
                                (_c = info.popupPoint3Title) !== null && _c !== void 0 ? _c : '',
                                (_d = info.popupPoint4Title) !== null && _d !== void 0 ? _d : ''
                            ] }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    throw Error(error_1);
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        xaloleadInfo();
    }, []);
    if (isXaloLeadRegistered && !isSuccess) {
        return react.createElement(react.Fragment, null);
    }
    var formData = {
        txtCMBFullName: "".concat((_b = user === null || user === void 0 ? void 0 : user.firstName) !== null && _b !== void 0 ? _b : '', " ").concat((_c = user === null || user === void 0 ? void 0 : user.lastName) !== null && _c !== void 0 ? _c : ''),
        txtCMBEmail: (_d = user === null || user === void 0 ? void 0 : user.userName) !== null && _d !== void 0 ? _d : '',
        txtCMBCellphone: (_e = user === null || user === void 0 ? void 0 : user.phone) !== null && _e !== void 0 ? _e : '',
        txtCMBYearExp: '',
        txtCMBAddress: '',
        chkCMBAgreeTerm: 'on',
        action: 'sendLead',
        txtCMBEnLevel: 'None Require'
    };
    return (react.createElement(styled_Container, null, isSuccess ? (react.createElement(Alert/* default */.Z, { isHaveClose: false, type: 'success' }, "C\u1EA3m \u01A1n b\u1EA1n \u0111\u00E3 \u0111\u0103ng k\u00FD ch\u01B0\u01A1ng tr\u00ECnh. Ch\u00FAng t\u00F4i s\u1EBD li\u00EAn h\u1EC7 l\u1EA1i v\u1EDBi b\u1EA1n s\u1EDBm")) : (react.createElement(Row/* default */.Z, { gutter: 18, justify: 'center' },
        xaloLead ? react.createElement(XaloLeadInformation, { xaloLead: xaloLead }) : null,
        user ? (react.createElement(FormRegisterXaloLead$1, { ref: ref, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', formData: formData, xaloLead: xaloLead, active: activeForm, setIsSuccess: setIsSuccess, user: user })) : null,
        react.createElement(Col/* default */.Z, { xs: 24 },
            react.createElement(styled_Box, null,
                react.createElement(Button/* default */.Z, { htmlType: 'submit', type: 'primary', onClick: function () {
                        if (!user || !user.userId) {
                            var loginUrl = "".concat(baseUrl, "/").concat(langCode === constants/* ELanguage.EN */.Df.EN ? 'login?from=home-v2' : 'dang-nhap?from=home-v2').concat(TRIGGER_HASH);
                            window.location.assign((0,urlBuilder/* buildLoginUrl */.Te)(loginUrl));
                            return;
                        }
                        if (!activeForm || !ref.current) {
                            setActiveForm(true);
                            return;
                        }
                        ref.current.onSubmit();
                    } }, (_f = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupCallToAction) !== null && _f !== void 0 ? _f : '')))))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Accordion/index.js + 2 modules
var Accordion = __webpack_require__(83065);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/index.js + 6 modules
var CompanyCardSquare = __webpack_require__(15225);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Container/index.js
var components_Container = __webpack_require__(91461);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AdrTurboBanner/styled.js
'use client';




var AdrTurboBanner_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(AdrTurboBanner_styled_templateObject_1 || (AdrTurboBanner_styled_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    img {\n        object-fit: contain;\n        width: 100%;\n        height: 100%;\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    img {\n        object-fit: contain;\n        width: 100%;\n        height: 100%;\n    }\n"])));
var AdrTurboBanner_styled_templateObject_1;


//# sourceMappingURL=styled.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/adr-turbo/const.js
'use client';

var ADR_TURBO_ONE = 'banners/v1.0/adr-turbo1';
var ADR_TURBO_TWO = 'banners/v1.0/adr-turbo2';


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/adr-turbo/index.js
'use client';





function getAdrTurbo(baseMsUrl, type, lang) {
    if (lang === void 0) { lang = constants/* ELanguage.VI */.Df.VI; }
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var url, response, resData, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    url = "".concat(baseMsUrl, "/").concat(type === 1 ? ADR_TURBO_ONE : ADR_TURBO_TWO);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                'Accept-Language': lang
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _a.sent();
                    return [2 /*return*/, resData];
                case 3: return [2 /*return*/];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AdrTurboBanner/index.js
'use client';









var ADR1_SETTING = 'ADR1_SETTING';
var ADR2_SETTING = 'ADR2_SETTING';
function AdrTurboBanner(_a) {
    var _this = this;
    var baseMsUrl = _a.baseMsUrl, type = _a.type, lang = _a.lang;
    var _b = (0,react.useState)(null), adrTubos = _b[0], setAdrTubos = _b[1];
    var _c = (0,react.useState)(true), loading = _c[0], setLoading = _c[1];
    var shuffleArray = function (array) {
        var _a;
        if (!Array.isArray(array))
            return [];
        var currentIndex = array.length;
        var randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex > 0) {
            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            _a = [array[randomIndex], array[currentIndex]], array[currentIndex] = _a[0], array[randomIndex] = _a[1];
        }
        return array;
    };
    var getBanner = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var adrTurboResponse, banners, bannerIds, adrKeySetting, adrSetting, newIndex, indexBanner, adrTurbo, error_1;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAdrTurbo(baseMsUrl, type, lang)];
                case 1:
                    adrTurboResponse = _c.sent();
                    if ((adrTurboResponse === null || adrTurboResponse === void 0 ? void 0 : adrTurboResponse.data) && adrTurboResponse.data.length > 0) {
                        banners = adrTurboResponse.data;
                        bannerIds = banners.map(function (item) { return item.id; });
                        adrKeySetting = type === 1 ? ADR1_SETTING : ADR2_SETTING;
                        adrSetting = JSON.parse(localStorage.getItem(adrKeySetting)) || {
                            bannerIds: [],
                            sufferIndex: [],
                            index: 0
                        };
                        if (JSON.stringify(bannerIds) === JSON.stringify(adrSetting.bannerIds)) {
                            newIndex = (adrSetting.index + 1) % adrSetting.bannerIds.length;
                            adrSetting.index = newIndex;
                            localStorage.setItem(adrKeySetting, JSON.stringify(adrSetting));
                        }
                        else {
                            adrSetting.bannerIds = bannerIds;
                            adrSetting.index = 0;
                            adrSetting.sufferIndex = shuffleArray(Array.from(Array(banners.length).keys()));
                            localStorage.setItem(adrKeySetting, JSON.stringify(adrSetting));
                        }
                        indexBanner = adrSetting.sufferIndex[adrSetting.index];
                        adrTurbo = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, adrTurboResponse.data[indexBanner].attributes), { altImg: lang === constants/* ELanguage.EN */.Df.EN
                                ? "Latest ".concat((_a = adrTurboResponse.data[indexBanner].attributes) === null || _a === void 0 ? void 0 : _a.companyName, " employment/hiring with high salary & attractive benefits")
                                : "".concat((_b = adrTurboResponse.data[indexBanner].attributes) === null || _b === void 0 ? void 0 : _b.companyName, " tuy\u1EC3n d\u1EE5ng - T\u00ECm vi\u1EC7c m\u1EDBi nh\u1EA5t, l\u01B0\u01A1ng th\u01B0\u1EDFng h\u1EA5p d\u1EABn. ") });
                        setAdrTubos(adrTurbo);
                        setLoading(false);
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (type) {
            getBanner();
        }
    }, [type]);
    var renderSkeleton = function () {
        return loading ? (react.createElement(AdrTurboBanner_styled_Container, null,
            react.createElement(Skeleton/* default */.Z, { height: 350 }))) : (react.createElement(react.Fragment, null));
    };
    return adrTubos ? (react.createElement(AdrTurboBanner_styled_Container, null,
        react.createElement(Variant/* Anchor */.ee, { href: adrTubos.companyURL, target: '_blank', rel: 'noreferrer', style: { width: '100%', height: '100%', display: 'inline-block' } },
            react.createElement("img", { loading: 'lazy', src: adrTubos === null || adrTubos === void 0 ? void 0 : adrTubos.image, alt: adrTubos.altImg })))) : (renderSkeleton());
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/style.css.js
'use client';







var style_css_HeaderContainer = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_1 || (style_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 16px;\n"], ["\n    position: relative;\n    padding: 16px;\n"])));
var style_css_BodyContainer = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_2 || (style_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: -16px;\n    margin-bottom: 0;\n"], ["\n    margin-top: -16px;\n    margin-bottom: 0;\n"])));
var style_css_FooterContainer = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_3 || (style_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    @media screen and (max-width: 768px) {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        background-color: #fff;\n        z-index: 1;\n    }\n"], ["\n    position: relative;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    @media screen and (max-width: 768px) {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        background-color: #fff;\n        z-index: 1;\n    }\n"])));
var style_css_AvatarCompany = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_4 || (style_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 64px;\n    height: 64px;\n    border-radius: 10px;\n    img {\n        border-radius: 10px;\n        width: 64px;\n        height: 64px;\n        object-fit: contain;\n        background-color: #fff;\n    }\n"], ["\n    width: 64px;\n    height: 64px;\n    border-radius: 10px;\n    img {\n        border-radius: 10px;\n        width: 64px;\n        height: 64px;\n        object-fit: contain;\n        background-color: #fff;\n    }\n"])));
var TxtTruncate = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Paragraph */.nv)(style_css_templateObject_5 || (style_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: calc(100% - 45px);\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: ", ";\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n"], ["\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: calc(100% - 45px);\n    display: -webkit-box;\n    max-width: 100%;\n    -webkit-line-clamp: ", ";\n    /* autoprefixer: off */\n    -webkit-box-orient: vertical;\n    /* autoprefixer: on */\n"])), function (_a) {
    var lineClamp = _a.lineClamp;
    return lineClamp !== null && lineClamp !== void 0 ? lineClamp : 1;
});
var CloseButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(style_css_templateObject_6 || (style_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n"], ["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n"])));
var SystemAlert = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_7 || (style_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 24px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 24px;\n"])));
var AgreePrivacyPolicy = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_8 || (style_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #f8f9fa !important;\n    border-radius: 8px;\n    padding: 2px 6px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    [data-check-state] {\n        border-radius: 8px;\n    }\n    a {\n        color: ", ";\n        &:hover {\n            color: ", ";\n        }\n    }\n    .required {\n        color: #dc362e;\n    }\n    > div > label > span {\n        text-overflow: unset;\n        max-width: 100%;\n        white-space: pre-wrap;\n    }\n    @media screen and (max-width: 768px) {\n        background-color: #fff;\n    }\n"], ["\n    background-color: #f8f9fa !important;\n    border-radius: 8px;\n    padding: 2px 6px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    [data-check-state] {\n        border-radius: 8px;\n    }\n    a {\n        color: ", ";\n        &:hover {\n            color: ", ";\n        }\n    }\n    .required {\n        color: #dc362e;\n    }\n    > div > label > span {\n        text-overflow: unset;\n        max-width: 100%;\n        white-space: pre-wrap;\n    }\n    @media screen and (max-width: 768px) {\n        background-color: #fff;\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '0' : '16px');
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '16px' : '0');
}, constants/* colors.primaryColor */.O9.primaryColor, constants/* colors.buttonColor */.O9.buttonColor);
var style_css_ErrorMessage = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_9 || (style_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #dc362e;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    margin-left: 8px;\n    margin-bottom: 10px;\n"], ["\n    color: #dc362e;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    margin-left: 8px;\n    margin-bottom: 10px;\n"])));
var style_css_templateObject_1, style_css_templateObject_2, style_css_templateObject_3, style_css_templateObject_4, style_css_templateObject_5, style_css_templateObject_6, style_css_templateObject_7, style_css_templateObject_8, style_css_templateObject_9;


//# sourceMappingURL=style.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/components/Header.js
'use client';










function Header_Header(_a) {
    var job = _a.job, onClose = _a.onClose, _b = _a.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b;
    var jobLevelText = (job === null || job === void 0 ? void 0 : job.jobLevelText) ? job === null || job === void 0 ? void 0 : job.jobLevelText : (langCode === constants/* ELanguage.VI */.Df.VI ? job === null || job === void 0 ? void 0 : job.jobLevelVI : job === null || job === void 0 ? void 0 : job.jobLevel);
    return (react.createElement(style_css_HeaderContainer, null,
        react.createElement(Row/* default */.Z, { gutter: 8 },
            react.createElement(Col/* default */.Z, { xs: 'auto' },
                react.createElement(style_css_AvatarCompany, null,
                    react.createElement("img", { src: (job === null || job === void 0 ? void 0 : job.companyLogo) || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'Company logo' }))),
            react.createElement(Col/* default */.Z, { xs: 'fill' },
                react.createElement(TxtTruncate, { name: 'title', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], lineClamp: 2 }, job === null || job === void 0 ? void 0 : job.jobTitle),
                react.createElement(TxtTruncate, { lineClamp: 2 },
                    react.createElement(Variant/* Span */.Dr, { name: 'paragraph', size: 'medium', color: Colors/* colors.secondary.40 */.O9.secondary[40] }, job === null || job === void 0 ? void 0 : job.prettySalary),
                    react.createElement(Variant/* Span */.Dr, { name: 'paragraph', size: 'medium' },
                        ' ',
                        "|",
                        ' '),
                    react.createElement(Variant/* Span */.Dr, { name: 'paragraph', size: 'medium' }, jobLevelText)),
                react.createElement(TxtTruncate, { name: 'paragraph', size: 'medium', lineClamp: 1 }, job === null || job === void 0 ? void 0 : job.address)),
            react.createElement(CloseButton, { outline: 'none', isIcon: true, isRounded: true, onClick: onClose },
                react.createElement(CloseIcon/* default */.Z, null)))));
}


//# sourceMappingURL=Header.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/components/Footer.js
'use client';









function components_Footer_Footer(_a) {
    var _b;
    var isLoading = _a.isLoading, lang = _a.lang, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c, privacyPolicies = _a.privacyPolicies, privacyErrorState = _a.privacyErrorState, checkedPrivacyPolicyState = _a.checkedPrivacyPolicyState, t = _a.t, onClick = _a.onClick;
    var isPrivacyError = privacyErrorState[0], setPrivacyError = privacyErrorState[1];
    var isCheckedPrivacyPolicy = checkedPrivacyPolicyState[0], setCheckedPrivacyPolicy = checkedPrivacyPolicyState[1];
    return (react.createElement(style_css_FooterContainer, null,
        isMobile && privacyPolicies.length > 0 && (react.createElement(AgreePrivacyPolicy, { isMobile: true },
            react.createElement(CheckBox/* default */.Z, { state: isCheckedPrivacyPolicy ? 'checked' : 'none', onCheckChange: function (value) {
                    setCheckedPrivacyPolicy(value === 'checked');
                    setPrivacyError(false);
                }, label: react.createElement(react.Fragment, null,
                    react.createElement("span", null, t('I agree to the')),
                    ' ',
                    react.createElement("a", { target: '__blank', href: privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                            ? (_b = privacyPolicies[0]) === null || _b === void 0 ? void 0 : _b.fileUrl
                            : '#', onClick: function (e) {
                            var _a;
                            e.stopPropagation();
                            window.open(privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                                ? (_a = privacyPolicies[0]) === null || _a === void 0 ? void 0 : _a.fileUrl
                                : '#', '_blank');
                        } }, t('Privacy Policy')),
                    ' ',
                    react.createElement("span", null, t('of this employer.')),
                    react.createElement("span", { className: 'required' }, "(*)")) }),
            isPrivacyError && (react.createElement(style_css_ErrorMessage, null, t('Please tick the checkbox if you want to proceed.'))))),
        react.createElement(Button/* default */.Z, { type: 'primary', onClick: onClick, disabled: isLoading },
            isLoading && react.createElement(LoadingIcon/* default */.Z, { bgColor: Colors/* colors.grey.80 */.O9.grey[80] }),
            lang === constants/* ELanguage.VI */.Df.VI ? 'Nộp Đơn' : 'Apply')));
}


//# sourceMappingURL=Footer.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/helper.js
var ApplyJobsModal_helper = __webpack_require__(63235);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/index.js + 1 modules
var jobs = __webpack_require__(10650);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/translations.js
'use client';

var ApplyJobsModal_translations_translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks Profile': 'Hồ Sơ VietnamWorks',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    '/success-apply': '/ung-tuyen-thanh-cong',
    'Application confirmation': 'Xác nhận ứng tuyển',
    'Your current job level': 'Cấp bậc hiện tại của bạn',
    'is not matching to this job requirement': 'chưa phù hợp với yêu cầu công việc này',
    'Do you want to continue to apply?': 'Bạn có muốn tiếp tục nộp đơn?',
    'I agree to the': 'Tôi đồng ý với',
    'Privacy Policies': 'Quy định bảo mật',
    'Privacy Policy': 'Quy định bảo mật',
    'of this employer.': 'của nhà tuyển dụng này.',
    'of these Employers.': 'của các nhà tuyển dụng này.',
    'Please tick the checkbox if you want to proceed.': 'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.',
    'employer-privacy-policy': 'quy-dinh-bao-mat-nha-tuyen-dung'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/const.js
var ApplyJobsModal_const = __webpack_require__(77634);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/tracking/applyJob.js
var applyJob = __webpack_require__(25491);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/index.js
'use client';

























function ApplyJobsModal(_a) {
    var _this = this;
    var _b, _c;
    var userInfo = _a.userInfo, isOpen = _a.isOpen, accessToken = _a.accessToken, lang = _a.lang, jobInfo = _a.jobInfo, onClose = _a.onClose, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _d = _a.enableTracking, enableTracking = _d === void 0 ? false : _d, rest = (0,_tslib/* __rest */._T)(_a, ["userInfo", "isOpen", "accessToken", "lang", "jobInfo", "onClose", "baseMsUrl", "baseUrl", "enableTracking"]);
    var _e = (0,react.useState)(false), isOpenPopupApply = _e[0], setIsOpenPopupApply = _e[1];
    var _f = (0,react.useState)(false), isOpenPopupWarning = _f[0], setIsOpenPopupWarning = _f[1];
    var _g = (0,react.useState)(null), jobLevels = _g[0], setJobLevels = _g[1];
    var _h = (0,react.useState)(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = (0,react.useState)(''), errorSystemMessage = _j[0], setErrorSystemMessage = _j[1];
    var applyJobsFormRef = (0,react.useRef)(null);
    var _k = (0,react.useState)([]), privacyPolicies = _k[0], setPrivacyPolicies = _k[1];
    var _l = (0,react.useState)(false), isCheckedPrivacyPolicy = _l[0], setCheckedPrivacyPolicy = _l[1];
    var _m = (0,react.useState)(false), isPrivacyError = _m[0], setPrivacyError = _m[1];
    var privacyErrorRef = (0,react.useRef)(null);
    var errorRef = (0,react.useRef)(null);
    var isMobile = typeof window !== ApplyJobsModal_const/* UNDEFINED_VALUE */.c8 ? window.innerWidth <= ApplyJobsModal_const/* SCREEN_WIDTH_MOBILE */.$8 : false;
    var t = function (txt) {
        var text = (0,translator_helper/* translator */.O)(txt, ApplyJobsModal_translations_translations, lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI);
        return text;
    };
    var handleApplyJob = function (values) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var resumeType, body, jobSearchParams, apply, info, ABAnalysis, link, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0,_tslib/* __generator */.Jh)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!jobInfo)
                        return [2 /*return*/];
                    setIsLoading(true);
                    resumeType = ((_a = values.resume.type) === null || _a === void 0 ? void 0 : _a.includes(resumes_types/* EApplyType.lastAttachment */.bf.lastAttachment))
                        ? resumes_types/* EApplyType.lastAttachment */.bf.lastAttachment
                        : values.resume.type;
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 7, , 8]);
                    body = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ 'jobIds[]': jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId, resumeId: (_c = (_b = values.resume) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : 0, resumeApply: resumeType, appliedType: resumeType, resumeFile: values.resume.type === resumes_types/* EApplyType.newAttachment */.bf.newAttachment ? values.resumeFile : undefined }, (!values.coverLetter ? undefined : { coverLetter: values.coverLetter })), (values.resume.type === resumes_types/* EApplyType.newAttachment */.bf.newAttachment && values.isReplaced
                        ? { isReplaced: !!values.isReplaced }
                        : undefined)), ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIp) ? { client_ip: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIp } : undefined));
                    jobSearchParams = (0,ApplyJobsModal_helper/* getJobUrlParams */.zj)((_d = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobUrl) !== null && _d !== void 0 ? _d : '');
                    return [4 /*yield*/, (0,jobs/* applyJobs */.m)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken, body, lang, jobSearchParams)];
                case 2:
                    apply = _j.sent();
                    if (apply instanceof model/* default */.Z) {
                        setIsLoading(false);
                        setErrorSystemMessage((_f = (_e = apply.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : '');
                        return [2 /*return*/];
                    }
                    if (!(apply && (apply === null || apply === void 0 ? void 0 : apply["".concat(jobInfo.jobId)]))) return [3 /*break*/, 6];
                    info = apply === null || apply === void 0 ? void 0 : apply["".concat(jobInfo.jobId)];
                    if (!(info.code === 200)) return [3 /*break*/, 5];
                    ABAnalysis = (0,cookie/* getCookie */.e)('ABJobAnalysis');
                    if (!(enableTracking && ABAnalysis)) return [3 /*break*/, 4];
                    // Wait for tracking first then redirect later
                    return [4 /*yield*/, (0,applyJob/* trackingABJobAnalysis */.y)(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', {
                            userId: (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) !== null && _g !== void 0 ? _g : -1,
                            version: ABAnalysis,
                            action: 'apply'
                        })];
                case 3:
                    // Wait for tracking first then redirect later
                    _j.sent();
                    _j.label = 4;
                case 4:
                    link = (0,ApplyJobsModal_helper/* applySuccessLink */.Vw)(baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', t, jobInfo);
                    setIsLoading(false);
                    setIsOpenPopupApply(false);
                    onClose && onClose();
                    link && window.location.assign(link);
                    return [3 /*break*/, 6];
                case 5:
                    setErrorSystemMessage((_h = info.message) !== null && _h !== void 0 ? _h : '');
                    setIsLoading(false);
                    _j.label = 6;
                case 6:
                    setIsLoading(false);
                    return [3 /*break*/, 8];
                case 7:
                    error_1 = _j.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var getJobLevels = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var jobLevels_1, error_2;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* getJobLevelList */.e1)(lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    jobLevels_1 = _a.sent();
                    if (jobLevels_1 && jobLevels_1.length > 0) {
                        setJobLevels(jobLevels_1);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleUserLevelName = function () {
        var level = jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.find(function (level) { return level.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId); });
        return lang === constants/* ELanguage.EN */.Df.EN ? level === null || level === void 0 ? void 0 : level.attributes.nameEn : level === null || level === void 0 ? void 0 : level.attributes.nameVi;
    };
    var handleOpenPopup = function () {
        var isUserLowLevel = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === ApplyJobsModal_const/* INTERN_LEVEL */.fs || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === ApplyJobsModal_const/* FRESHER_LEVEL */.jH;
        var isJobHighLevel = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === ApplyJobsModal_const/* MANAGER_LEVEL */.wK || (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === ApplyJobsModal_const/* DIRECTOR_LEVEL */.T0;
        var isAllowApplyJobs = !(isJobHighLevel && isUserLowLevel);
        if (isAllowApplyJobs) {
            setIsOpenPopupApply(isOpen);
        }
        else {
            setIsOpenPopupWarning(isOpen);
        }
    };
    var calculateFooterAdditionalHeight = function () {
        if (privacyPolicies.length <= 0) {
            return 0;
        }
        if (!isCheckedPrivacyPolicy && isPrivacyError) {
            return ApplyJobsModal_const/* ADDITIONAL_HEIGHT_PRIVACY_POLICY */.bp + ApplyJobsModal_const/* POLICY_ERROR */.rS;
        }
        return ApplyJobsModal_const/* ADDITIONAL_HEIGHT_PRIVACY_POLICY */.bp;
    };
    (0,react.useEffect)(function () {
        if (isOpen && (!jobLevels || jobLevels.length < 1)) {
            getJobLevels();
        }
        handleOpenPopup();
    }, [isOpen]);
    (0,react.useEffect)(function () {
        if (!isOpen) {
            return;
        }
        if (!accessToken || accessToken === '') {
            return;
        }
        if (!(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId)) {
            return;
        }
        (function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
            var privacyPolicyResponse;
            var _a;
            return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getPrivacyPolicy({
                            accessToken: accessToken,
                            body: {
                                jobIds: [(_a = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId) !== null && _a !== void 0 ? _a : -1]
                            },
                            langCode: lang,
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : ''
                        })];
                    case 1:
                        privacyPolicyResponse = _b.sent();
                        setPrivacyPolicies(privacyPolicyResponse);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [isOpen, accessToken]);
    (0,react.useEffect)(function () {
        var _a;
        if (errorSystemMessage) {
            (_a = errorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    }, [errorSystemMessage]);
    (0,react.useEffect)(function () {
        var _a;
        if (!isPrivacyError) {
            return;
        }
        if (!privacyErrorRef.current) {
            return;
        }
        (_a = privacyErrorRef === null || privacyErrorRef === void 0 ? void 0 : privacyErrorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }, [isPrivacyError, privacyErrorRef]);
    return (react.createElement(react.Fragment, null,
        isOpenPopupWarning && (react.createElement(PopupWarning/* default */.Z, { isShow: isOpenPopupWarning, langCode: lang, onClose: function () {
                setIsOpenPopupWarning(false);
                onClose && onClose();
                // onForceClose && onForceClose()
            }, onAccept: function () {
                setIsOpenPopupApply(true);
                setIsOpenPopupWarning(false);
                // onClose && onClose()
            }, title: t('Application confirmation'), warningTxt: t('Do you want to continue to apply?') },
            t('Your current job level'),
            ": ", (_b = handleUserLevelName()) !== null && _b !== void 0 ? _b : '',
            ' ',
            t('is not matching to this job requirement'),
            ".")),
        react.createElement(Popup/* default */.Z, { isShow: isOpenPopupApply, lang: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI, onClickOutside: function () {
                setIsOpenPopupApply(false);
                setPrivacyError(false);
                setErrorSystemMessage('');
                onClose && onClose();
            }, custom: {
                header: (react.createElement(Header_Header, { langCode: lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI, job: jobInfo, onClose: function () {
                        setIsOpenPopupApply(false);
                        setPrivacyError(false);
                        setErrorSystemMessage('');
                        onClose && onClose();
                    } })),
                footer: (react.createElement(components_Footer_Footer, { lang: lang, isLoading: isLoading, isMobile: isMobile, t: t, privacyPolicies: privacyPolicies, privacyErrorState: [isPrivacyError, setPrivacyError], checkedPrivacyPolicyState: [isCheckedPrivacyPolicy, setCheckedPrivacyPolicy], onClick: function () {
                        var _a;
                        if (privacyPolicies.length > 0 && !isCheckedPrivacyPolicy) {
                            setPrivacyError(true);
                            return;
                        }
                        (_a = applyJobsFormRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    } })),
                additionalFooterHeight: calculateFooterAdditionalHeight(),
                withDefaultBody: true
            } },
            react.createElement(style_css_BodyContainer, null,
                react.createElement(ApplyJobsForm$1, (0,_tslib/* __assign */.pi)({}, rest, { baseMsUrl: baseMsUrl, baseUrl: baseUrl, ref: applyJobsFormRef, accessToken: accessToken, lang: lang, popupOption: {
                        isInPopup: true
                    }, handleApply: handleApplyJob, jobInfo: jobInfo, userInfo: userInfo })),
                !isMobile && privacyPolicies.length > 0 && (react.createElement(AgreePrivacyPolicy, { isMobile: false },
                    react.createElement(CheckBox/* default */.Z, { state: isCheckedPrivacyPolicy ? 'checked' : 'none', onCheckChange: function (value) {
                            setCheckedPrivacyPolicy(value === 'checked');
                            setPrivacyError(false);
                        }, label: react.createElement(react.Fragment, null,
                            react.createElement("span", null, t('I agree to the')),
                            ' ',
                            react.createElement("a", { target: '__blank', href: privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                                    ? (_c = privacyPolicies[0]) === null || _c === void 0 ? void 0 : _c.fileUrl
                                    : '#', onClick: function (e) { return e.stopPropagation(); } }, t('Privacy Policy')),
                            ' ',
                            react.createElement("span", null, t('of this employer.')),
                            react.createElement("span", { className: 'required' }, "(*)")) }),
                    isPrivacyError && (react.createElement(style_css_ErrorMessage, { ref: privacyErrorRef }, t('Please tick the checkbox if you want to proceed.'))))),
                errorSystemMessage ? (react.createElement(Alert/* default */.Z, { type: 'warning', style: { marginTop: 10 } },
                    react.createElement(SystemAlert, { ref: errorRef },
                        react.createElement(Warning/* default */.Z, null),
                        " ",
                        errorSystemMessage))) : null))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/index.js + 32 modules
var Cascader = __webpack_require__(1136);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialEmbed/TikTok/styled.js
'use client';




var TikTok_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(TikTok_styled_templateObject_6 || (TikTok_styled_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    blockquote {\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    }\n"], ["\n    blockquote {\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    }\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth
        ? (0,styled_components_browser_esm/* css */.iv)(TikTok_styled_templateObject_1 || (TikTok_styled_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      min-width: ", "px !important;\n                  "], ["\n                      min-width: ", "px !important;\n                  "])), minWidth) : undefined;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth
        ? (0,styled_components_browser_esm/* css */.iv)(TikTok_styled_templateObject_2 || (TikTok_styled_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      max-width: ", "px !important;\n                  "], ["\n                      max-width: ", "px !important;\n                  "])), maxWidth) : undefined;
}, function (_a) {
    var width = _a.width;
    return width
        ? (0,styled_components_browser_esm/* css */.iv)(TikTok_styled_templateObject_3 || (TikTok_styled_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      width: ", "px !important;\n                  "], ["\n                      width: ", "px !important;\n                  "])), width) : undefined;
}, function (_a) {
    var height = _a.height;
    return height
        ? (0,styled_components_browser_esm/* css */.iv)(TikTok_styled_templateObject_4 || (TikTok_styled_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      height: ", "px !important;\n                  "], ["\n                      height: ", "px !important;\n                  "])), height) : undefined;
}, function (_a) {
    var overflow = _a.overflow;
    return overflow
        ? (0,styled_components_browser_esm/* css */.iv)(TikTok_styled_templateObject_5 || (TikTok_styled_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      overflow: ", "px !important;\n                  "], ["\n                      overflow: ", "px !important;\n                  "])), overflow) : undefined;
});
var TikTok_styled_templateObject_1, TikTok_styled_templateObject_2, TikTok_styled_templateObject_3, TikTok_styled_templateObject_4, TikTok_styled_templateObject_5, TikTok_styled_templateObject_6;


//# sourceMappingURL=styled.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialEmbed/TikTok/const.js
'use client';

var SCRIPT_TIKTOK_EMBED_ID = 'tiktok-embed-script';
var CDN_TIKTOK_EMBED = 'https://www.tiktok.com/embed.js';


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialEmbed/TikTok/type.js
'use client';

var EStatusTikTokEmbed;
(function (EStatusTikTokEmbed) {
    EStatusTikTokEmbed["PROCESSING"] = "PROCESSING";
    EStatusTikTokEmbed["SUCCESS"] = "SUCCESS";
})(EStatusTikTokEmbed || (EStatusTikTokEmbed = {}));


//# sourceMappingURL=type.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/social-embed/const.js
'use client';

var TIKTOK_EMBED_ENDPOINT = 'navi-api/api/tiktok';
var FIRST_EMBED = 0;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/social-embed/index.js
'use client';





function getTikTokEmbed(baseMsUrl, langCode, groupJobFuncions) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var groupJobFunctionStr, response, data, err_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    groupJobFunctionStr = "".concat(groupJobFuncions.join(','));
                    if (groupJobFuncions.length > 0) {
                        groupJobFunctionStr = "?group_job_function_ids=".concat(groupJobFunctionStr);
                    }
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(TIKTOK_EMBED_ENDPOINT).concat(groupJobFunctionStr), {
                            method: 'GET',
                            headers: {
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data && data.length > FIRST_EMBED) {
                        return [2 /*return*/, data[0]];
                    }
                    return [2 /*return*/, new model/* default */.Z({
                            data: null,
                            error: {
                                details: {
                                    ERROR_TIKTOK_EMBED: 'ERROR_TIKTOK_EMBED'
                                },
                                message: 'ERROR_TIKTOK_EMBED',
                                status: 500
                            }
                        })];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, new model/* default */.Z({
                            data: err_1,
                            error: {
                                details: {
                                    ERROR_TIKTOK_EMBED: err_1
                                },
                                message: 'ERROR_TIKTOK_EMBED',
                                status: 500
                            }
                        })];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/SocialEmbed/TikTok/index.js
'use client';









function TikTok(_a) {
    var _this = this;
    var blockStyle = _a.blockStyle, baseMsUrl = _a.baseMsUrl, langCode = _a.langCode, groupJobFunctions = _a.groupJobFunctions;
    var _b = (0,react.useState)(EStatusTikTokEmbed.PROCESSING), status = _b[0], setStatus = _b[1];
    var _c = (0,react.useState)(), source = _c[0], setSource = _c[1];
    var getSourceTikTok = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var tikTokEmbed, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getTikTokEmbed(baseMsUrl, langCode, groupJobFunctions)];
                case 1:
                    tikTokEmbed = _a.sent();
                    if (tikTokEmbed instanceof model/* default */.Z) {
                        return [2 /*return*/];
                    }
                    setSource(tikTokEmbed.source);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (status === EStatusTikTokEmbed.PROCESSING) {
            var prevScript = document.querySelector(SCRIPT_TIKTOK_EMBED_ID);
            if (prevScript) {
                prevScript.remove();
            }
            var scriptElement = document.createElement('script');
            scriptElement.setAttribute('src', "".concat(CDN_TIKTOK_EMBED, "?t=").concat(Date.now()));
            scriptElement.setAttribute('id', SCRIPT_TIKTOK_EMBED_ID);
            document.head.appendChild(scriptElement);
            setStatus(EStatusTikTokEmbed.SUCCESS);
        }
        else if (status === EStatusTikTokEmbed.SUCCESS) {
            getSourceTikTok();
        }
    }, [status, groupJobFunctions]);
    return source ? react.createElement(TikTok_styled_Container, (0,_tslib/* __assign */.pi)({}, blockStyle, { dangerouslySetInnerHTML: { __html: source } })) : react.createElement(react.Fragment, null);
}
var TikTok_index = (0,react.memo)(TikTok, function (prevProps, nextProps) {
    if (prevProps.groupJobFunctions !== nextProps.groupJobFunctions) {
        return true;
    }
    return false;
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/translations.js
'use client';

var JobMatchingAnalysis_translations_translations = {
    'How you match this job': 'Mức độ phù hợp công việc',
    'View detail': 'Xem chi tiết',
    'You match this job': 'Bạn phù hợp với công việc này',
    'Job matching analysis': 'Phân tích độ phù hợp công việc',
    'Matching': 'Phù hợp',
    'Highly matching': 'Rất phù hợp',
    'Skills': 'Kỹ năng',
    'You possess {numOfSkill} skills required for this job. Add more skills to make your profile more impressive.': 'Bạn thoả {numOfSkill} kỹ năng được yêu cầu. Hãy thêm các kỹ năng khác để hồ sơ của bạn nổi bật hơn.',
    'Congratulations! You possess {numOfSkill} skills required for this job.': 'Chúc mừng! Bạn thỏa {numOfSkill} kỹ năng được yêu cầu.',
    'Skills on your profile': 'Những kỹ năng có trong hồ sơ của bạn',
    'Skills missing on your profile': 'Những kỹ năng cần bổ sung trong hồ sơ của bạn',
    'Work experience': 'Kinh nghiệm làm việc',
    'Your level vs. required job level.': 'Cấp bậc của bạn so với yêu cầu công việc.',
    'Career path': 'Định hướng nghề nghiệp',
    'This job matches {numOfCriteria} criteria in your career path. Update your profile frequently to let us know your latest career path.': 'Công việc này thỏa {numOfCriteria} tiêu chí định hướng nghề nghiệp của bạn. Hãy cập nhật hồ sơ thường xuyên để chúng tôi biết được định hướng mới nhất của bạn nhé.',
    'My VietnamWorks profile:': 'Hồ sơ VietnamWorks của tôi:',
    'A complete and updated profile is more attractive to employers.': 'Hồ sơ hoàn chỉnh và được cập nhật mới sẽ thu hút nhà tuyển dụng hơn.',
    'Profile strength': 'Hoàn chỉnh hồ sơ',
    'Last update:': 'Cập nhật lần cuối:',
    'Update My profile': 'Cập nhật Hồ sơ của tôi',
    'Apply now': 'Ứng tuyển ngay',
    'Job level:': 'Cấp bậc:',
    'Working location': 'Địa điểm làm việc',
    'Salary': 'Mức lương',
    '/my-profile': '/ho-so',
    'Job function': 'Ngành nghề',
    'Industry': 'Lĩnh vực',
    'Job title': 'Chức danh',
    'Added successfully': 'Thêm thành công',
    'Removed successfully': 'Xóa thành công',
    'Error: unable to add skills': 'Lỗi: không thể thêm kỹ năng',
    'You had the maximum of skills.': 'Bạn đã đạt số lượng kỹ năng tối đa.',
    'The assessment is for reference only, based on your VietnamWorks profile and the requirements of this job.': 'Đánh giá mang tính tham khảo, dựa trên Hồ sơ VietnamWorks của bạn và yêu cầu công việc này.',
    'Your Skill has been added successfully': 'Kỹ Năng của bạn đã được thêm thành công',
    'Your Skill has been removed successfully': 'Kỹ Năng của bạn đã được xóa thành công',
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/style.css.js
'use client';







var CustomPopup = (0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(JobMatchingAnalysis_style_css_templateObject_1 || (JobMatchingAnalysis_style_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .vnw-popup-content {\n        width: 824px;\n    }\n    .vnw-popup-body{\n        background: #F7F8FA;\n        padding: 8px 16px;\n    }\n"], ["\n    .vnw-popup-content {\n        width: 824px;\n    }\n    .vnw-popup-body{\n        background: #F7F8FA;\n        padding: 8px 16px;\n    }\n"])));
var JobMatchingAnalysis_style_css_BodyContainer = styled_components_browser_esm/* default.div */.ZP.div(JobMatchingAnalysis_style_css_templateObject_2 || (JobMatchingAnalysis_style_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n"])));
var style_css_Section = styled_components_browser_esm/* default.div */.ZP.div(JobMatchingAnalysis_style_css_templateObject_5 || (JobMatchingAnalysis_style_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-direction: column;\n    flex: 16px;\n    padding: 16px;\n    border-radius: 12px;\n    background: #FFFFFF;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 16px;\n    padding: 16px;\n    border-radius: 12px;\n    background: #FFFFFF;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(JobMatchingAnalysis_style_css_templateObject_3 || (JobMatchingAnalysis_style_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-bottom: 110px;\n            "], ["\n                margin-bottom: 110px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(JobMatchingAnalysis_style_css_templateObject_4 || (JobMatchingAnalysis_style_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var Line = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Paragraph */.nv)(JobMatchingAnalysis_style_css_templateObject_6 || (JobMatchingAnalysis_style_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 22px;\n    font-weight: 600;\n    font-size: 18px;\n    color: ", "\n"], ["\n    line-height: 22px;\n    font-weight: 600;\n    font-size: 18px;\n    color: ", "\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var LineDefault = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Paragraph */.nv)(JobMatchingAnalysis_style_css_templateObject_7 || (JobMatchingAnalysis_style_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    line-height: 18px;\n    font-weight: 500;\n    font-size: 14px;\n    color: ", "\n"], ["\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    line-height: 18px;\n    font-weight: 500;\n    font-size: 14px;\n    color: ", "\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var LineMatching = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Paragraph */.nv)(JobMatchingAnalysis_style_css_templateObject_8 || (JobMatchingAnalysis_style_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    line-height: 24px;\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 8px;\n"], ["\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    line-height: 24px;\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 8px;\n"])));
var Note = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Paragraph */.nv)(JobMatchingAnalysis_style_css_templateObject_9 || (JobMatchingAnalysis_style_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-style: italic;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n"], ["\n    color: ", ";\n    font-style: italic;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n"])), Colors/* colors.grey.60 */.O9.grey[60]);
var BorderBottom = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_10 || (style_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 80%;\n    height: 1px;\n    background: ", ";\n    margin: 8px 0;\n"], ["\n    width: 80%;\n    height: 1px;\n    background: ", ";\n    margin: 8px 0;\n"])), Colors/* colors.primary.95 */.O9.primary[95]);
styled_components_browser_esm/* default.a */.ZP.a(style_css_templateObject_11 || (style_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n\n"], ["\n\n"])));
var style_css_Image = styled_components_browser_esm/* default.img */.ZP.img(style_css_templateObject_12 || (style_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    object-fit: cover;\n    @media screen and (max-width: 768px) {\n        object-fit: contain;\n    }\n"], ["\n    object-fit: cover;\n    @media screen and (max-width: 768px) {\n        object-fit: contain;\n    }\n"])));
var Detail = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_15 || (style_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: ", ";\n    color: ", ";\n    ", "\n"], ["\n    padding-left: ", ";\n    color: ", ";\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 0 : '24px');
}, Colors/* colors.grey.20 */.O9.grey[20], function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject_13 || (style_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-top: 8px;\n            "], ["\n                margin-top: 8px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject_14 || (style_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var TagList = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_16 || (style_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n"], ["\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n"])));
var CircleWrapper = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_18 || (style_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        position: relative;\n        border-radius: 50%;\n\n        ", "\n    "], ["\n        position: relative;\n        border-radius: 50%;\n\n        ", "\n    "])), function (_a) {
    var width = _a.width;
    return (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject_17 || (style_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: ", "px;\n            height: ", "px;\n        "], ["\n            width: ", "px;\n            height: ", "px;\n        "])), width, width);
});
var style_css_Circle = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_19 || (style_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n"], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n"])));
var ProfileStrength = styled_components_browser_esm/* default.span */.ZP.span(style_css_templateObject_20 || (style_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 34%;\n    font-size: 12px;\n    width: ", ";\n    display: flex;\n    justify-content: center;\n"], ["\n    position: absolute;\n    top: 34%;\n    font-size: 12px;\n    width: ", ";\n    display: flex;\n    justify-content: center;\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '100%' : '50px');
});
var BoxInfo = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_21 || (style_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 16px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 16px;\n"])));
var HorizonalBorder = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_22 || (style_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 2px;\n    height: auto;\n    background: ", ";\n"], ["\n    width: 2px;\n    height: auto;\n    background: ", ";\n"])), Colors/* colors.primary.95 */.O9.primary[95]);
var JobMatchingAnalysis_style_css_FooterContainer = styled_components_browser_esm/* default.div */.ZP.div(style_css_templateObject_25 || (style_css_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    padding: 16px 32px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid ", ";\n    ", "\n"], ["\n    position: relative;\n    padding: 16px 32px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid ", ";\n    ", "\n"])), Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject_23 || (style_css_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                width: 100%;\n                gap: 16px;\n                flex-direction: column;\n                justify-content: space-between;\n                background-color: #fff;\n                z-index: 1;\n                Button {\n                    width: 100%;\n                }\n            "], ["\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                width: 100%;\n                gap: 16px;\n                flex-direction: column;\n                justify-content: space-between;\n                background-color: #fff;\n                z-index: 1;\n                Button {\n                    width: 100%;\n                }\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject_24 || (style_css_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
});
var JobMatchingAnalysis_style_css_templateObject_1, JobMatchingAnalysis_style_css_templateObject_2, JobMatchingAnalysis_style_css_templateObject_3, JobMatchingAnalysis_style_css_templateObject_4, JobMatchingAnalysis_style_css_templateObject_5, JobMatchingAnalysis_style_css_templateObject_6, JobMatchingAnalysis_style_css_templateObject_7, JobMatchingAnalysis_style_css_templateObject_8, JobMatchingAnalysis_style_css_templateObject_9, style_css_templateObject_10, style_css_templateObject_11, style_css_templateObject_12, style_css_templateObject_13, style_css_templateObject_14, style_css_templateObject_15, style_css_templateObject_16, style_css_templateObject_17, style_css_templateObject_18, style_css_templateObject_19, style_css_templateObject_20, style_css_templateObject_21, style_css_templateObject_22, style_css_templateObject_23, style_css_templateObject_24, style_css_templateObject_25;


//# sourceMappingURL=style.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/LocationIcon/index.js
'use client';



var LocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? '#50596E' : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("circle", { cx: width / 2, cy: height / 2, r: "11.5", fill: "#F4F4F7", stroke: "white" }),
        react.createElement("path", { d: "M12.0002 6.24023C9.88328 6.24023 8.16016 7.96336 8.16016 10.0802C8.16016 13.4674 11.6711 17.5071 11.8202 17.6777C11.8661 17.7302 11.9308 17.7602 12.0002 17.7602C12.0742 17.7555 12.1342 17.7302 12.1802 17.6777C12.3292 17.5043 15.8402 13.3952 15.8402 10.0802C15.8402 7.96336 14.117 6.24023 12.0002 6.24023ZM12.0002 8.88023C12.7952 8.88023 13.4402 9.52523 13.4402 10.3202C13.4402 11.1152 12.7952 11.7602 12.0002 11.7602C11.2052 11.7602 10.5602 11.1152 10.5602 10.3202C10.5602 9.52523 11.2052 8.88023 12.0002 8.88023Z", fill: color })));
};
var LocationIcon$1 = /*#__PURE__*/ react.memo(LocationIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/SuitableIcon/index.js
'use client';



var SuitableIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.color, color = _d === void 0 ? '#FFAF00' : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("circle", { cx: "12.5", cy: "12.5", r: "12.5", fill: color }),
        react.createElement("path", { d: "M13.5 6.25V11.75H19C19 8.7125 16.5375 6.25 13.5 6.25ZM12.5 7.25C9.4625 7.25 7 9.7125 7 12.75C7 15.7875 9.4625 18.25 12.5 18.25C15.5375 18.25 18 15.7875 18 12.75H12.5V7.25Z", fill: "white" })));
};
var SuitableIcon$1 = /*#__PURE__*/ react.memo(SuitableIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/const.js
'use client';

var MATCH_SCORE_UN_SUITABLE = 16;
var MATCH_SCORE_VERY_SUITABLE = 21;
var MATCH_SCORE_SKILL_PERCENT_POINT = 60;
var EMatching;
(function (EMatching) {
    EMatching["PENDING_FOR_QUERY"] = "PENDING_FOR_QUERY";
    EMatching["NOT_LOGIN"] = "NOT_LOGIN";
    EMatching["NOT_MATCHING"] = "NOT_MATCHING";
    EMatching["MATCHING"] = "MATCHING";
    EMatching["VERRY_MATCHING"] = "VERRY_MATCHING";
})(EMatching || (EMatching = {}));


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/VerySuitableIcon/index.js
'use client';



var VerySuitableIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 25 : _b, _c = _a.height, height = _c === void 0 ? 26 : _c, _d = _a.color, color = _d === void 0 ? '#005AFF' : _d;
    return (react.createElement("svg", { width: width, height: height, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("circle", { cx: "12.5", cy: "12.7158", r: "12.5", fill: color }),
        react.createElement("path", { d: "M12.7199 6.46582C9.00885 6.46582 6 9.3762 6 12.9658C6 16.5554 9.00885 19.4658 12.7199 19.4658C16.431 19.4658 19.4398 16.5554 19.4398 12.9658C19.4398 11.7853 19.1095 10.6817 18.5408 9.72746L12.242 15.8191C12.1372 15.9204 11.995 15.9778 11.846 15.9778C11.6976 15.9778 11.5548 15.9209 11.4501 15.8191L8.95637 13.407C8.73742 13.1952 8.73742 12.8528 8.95637 12.641C9.17533 12.4292 9.52928 12.4292 9.74824 12.641L11.846 14.6702L17.8944 8.81974C16.6619 7.38162 14.802 6.46582 12.7199 6.46582ZM17.8944 8.81974C18.1361 9.10172 18.35 9.4071 18.5408 9.7264L19.8358 8.4738C20.0547 8.26146 20.0547 7.91964 19.8358 7.70785C19.6168 7.49605 19.2629 7.49605 19.0439 7.70785L17.8944 8.81974Z", fill: "white" })));
};
var VerySuitableIcon$1 = /*#__PURE__*/ react.memo(VerySuitableIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/components/ProficiencyBar.css.js
'use client';




var ProficiencyBar_css_ListProficiency = styled_components_browser_esm/* default.div */.ZP.div(ProficiencyBar_css_templateObject_1 || (ProficiencyBar_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    position: relative;\n    width: 100%;\n"], ["\n    display: flex;\n    position: relative;\n    width: 100%;\n"])));
var ProficiencyBar_css_ProficiencyItem = styled_components_browser_esm/* default.div */.ZP.div(ProficiencyBar_css_templateObject_2 || (ProficiencyBar_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #fff;\n    font-size: 14px;\n    height: 8px;\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: ", ";\n    &:after {\n        position: absolute;\n        content: '';\n        width: 1px;\n        height: 14px;\n        top: 13px;\n        left: 0;\n        opacity: 0.5;\n    }\n    &:first-child {\n        &:after {\n            content: none;\n        }\n    }\n"], ["\n    color: #fff;\n    font-size: 14px;\n    height: 8px;\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: ", ";\n    &:after {\n        position: absolute;\n        content: '';\n        width: 1px;\n        height: 14px;\n        top: 13px;\n        left: 0;\n        opacity: 0.5;\n    }\n    &:first-child {\n        &:after {\n            content: none;\n        }\n    }\n"])), function (_a) {
    var background = _a.background;
    return background;
});
var ProficiencyBar_css_templateObject_1, ProficiencyBar_css_templateObject_2;


//# sourceMappingURL=ProficiencyBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/components/ProficiencyBar.js
'use client';




var ProficiencyBar = function (props) {
    var totalCol = props.totalCol, value = props.value, background = props.background, borderRadius = props.borderRadius, borderRight = props.borderRight, backgroundSeparator = props.backgroundSeparator;
    if (totalCol === 0)
        return null;
    var listProficiency = [];
    for (var i = 1; i <= totalCol; i++) {
        listProficiency.push(react.createElement(ProficiencyBar_css_ProficiencyItem, { style: {
                width: "".concat(100 / totalCol, "%"),
                borderRight: i === totalCol ? 'none' : borderRight,
                borderBottomLeftRadius: i === 1 ? borderRadius : 'unset',
                borderTopLeftRadius: i === 1 ? borderRadius : 'unset',
                borderBottomRightRadius: i === totalCol ? borderRadius : 'unset',
                borderTopRightRadius: i === totalCol ? borderRadius : 'unset',
            }, key: i, background: i <= value ? backgroundSeparator : background }));
    }
    return (react.createElement(ProficiencyBar_css_ListProficiency, null, listProficiency));
};


//# sourceMappingURL=ProficiencyBar.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/components/CirclePercent/CirclePercent.css.js
'use client';




var CirclePercent_css_Container = styled_components_browser_esm/* default.div */.ZP.div(CirclePercent_css_templateObject_1 || (CirclePercent_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", "px;\n    justify-content: space-around;\n\n    .circle {\n        fill: none;\n        stroke-width: ", "px;\n        stroke-linecap: round;\n        animation: progress 1s ease-out forwards;\n    }\n\n    @keyframes progress {\n        0% {\n            stroke-dasharray: 0 100;\n        }\n    }\n"], ["\n    width: ", "px;\n    justify-content: space-around;\n\n    .circle {\n        fill: none;\n        stroke-width: ", "px;\n        stroke-linecap: round;\n        animation: progress 1s ease-out forwards;\n    }\n\n    @keyframes progress {\n        0% {\n            stroke-dasharray: 0 100;\n        }\n    }\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var strokeWidth = _a.strokeWidth;
    return strokeWidth ? strokeWidth : 1;
});
var CirclePercent_css_templateObject_1;


//# sourceMappingURL=CirclePercent.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/components/CirclePercent/index.js
'use client';




var CirclePercent = function (_a) {
    var _b = _a.percent, percent = _b === void 0 ? 30 : _b, _c = _a.width, width = _c === void 0 ? 36 : _c, _d = _a.color, color = _d === void 0 ? '#E6EFFF' : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 1 : _e;
    return (react.createElement(CirclePercent_css_Container, { width: width, strokeWidth: strokeWidth },
        react.createElement("svg", { viewBox: '0 0 36 36' },
            react.createElement("path", { width: width, height: width, style: { stroke: color }, className: 'circle', strokeDasharray: "".concat(percent, ", 100"), d: 'M18 2.0845\n          a 15.9155 15.9155 0 0 1 0 31.831\n          a 15.9155 15.9155 0 0 1 0 -31.831' }))));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/time.js
var time = __webpack_require__(56665);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/tracking/jobMatching.js
'use client';



var API_TRACKING_JOB_MATCHING = 'log-aggregator/v1/track-job-matching';
var trackingJobMatching = function (baseMsUrl, body) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var response, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (typeof window === 'undefined') {
                    return [2 /*return*/, false];
                }
                body.datetime = new Date().toISOString();
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(API_TRACKING_JOB_MATCHING), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=jobMatching.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobMatchingAnalysis/index.js
'use client';





























var imageUrl = function (matchScore) {
    if (matchScore > MATCH_SCORE_UN_SUITABLE && matchScore < MATCH_SCORE_VERY_SUITABLE) {
        return 'https://images.vietnamworks.com/img/problem-solving.png';
    }
    if (matchScore >= MATCH_SCORE_VERY_SUITABLE) {
        return 'https://images.vietnamworks.com/img/very-matching.png';
    }
    return 'https://images.vietnamworks.com/img/none-matching.png';
};
var JobMatchingAnalysis = function (props) {
    var langCode = props.langCode, isOpen = props.isOpen, onClose = props.onClose, token = props.token, baseMsUrl = props.baseMsUrl, jobInfo = props.jobInfo, _a = props.hiddenApplyBtn, hiddenApplyBtn = _a === void 0 ? false : _a, userId = props.userId;
    var _b = (0,react.useState)(false), isShowPopup = _b[0], setIsShowPopup = _b[1];
    var _c = (0,react.useState)(), matchingJob = _c[0], setMatchingJob = _c[1];
    var _d = (0,react.useState)([]), skillMatchList = _d[0], setSkillMatchList = _d[1];
    var _e = (0,react.useState)([]), skillNoMatchList = _e[0], setSkillNoMatchList = _e[1];
    var _f = (0,react.useState)(0), skillMatching = _f[0], setSkillMatching = _f[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = function (txt) {
        return (0,translator_helper/* translator */.O)(txt, JobMatchingAnalysis_translations_translations, langCode || constants/* ELanguage.VI */.Df.VI);
    };
    var matchStatusCode = function (matchScore) {
        var score = matchScore !== null && matchScore !== void 0 ? matchScore : 0;
        switch (true) {
            case score < MATCH_SCORE_UN_SUITABLE:
                return EMatching.NOT_MATCHING;
            case score >= MATCH_SCORE_UN_SUITABLE && score < MATCH_SCORE_VERY_SUITABLE:
                return EMatching.MATCHING;
            case score >= MATCH_SCORE_VERY_SUITABLE:
                return EMatching.VERRY_MATCHING;
            default:
                return EMatching.PENDING_FOR_QUERY;
        }
    };
    var getMatchingJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var result, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return (0,_tslib/* __generator */.Jh)(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,jobs/* matchingJobAPI */.B)({
                            accessToken: token,
                            langCode: langCode,
                            baseUrl: baseMsUrl,
                            body: {
                                jobId: jobInfo.jobId
                            }
                        })];
                case 1:
                    result = _k.sent();
                    if ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        setMatchingJob((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.attributes);
                        if ((_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.attributes.matchSkills.notMatchedSkills) === null || _d === void 0 ? void 0 : _d.length) {
                            setSkillNoMatchList(((_e = result === null || result === void 0 ? void 0 : result.data) === null || _e === void 0 ? void 0 : _e.attributes.matchSkills.notMatchedSkills) || []);
                        }
                        setSkillMatchList(((_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.attributes.matchSkills.matchedSkills) || []);
                        setSkillMatching(result === null || result === void 0 ? void 0 : result.data.attributes.matchSkills.countMatching);
                        // Tracking view job matching
                        trackingJobMatching(baseMsUrl, {
                            userId: userId,
                            jobId: jobInfo.jobId,
                            action: 'View',
                            status: matchStatusCode((_j = (_h = (_g = result === null || result === void 0 ? void 0 : result.data) === null || _g === void 0 ? void 0 : _g.attributes) === null || _h === void 0 ? void 0 : _h.matchScore) !== null && _j !== void 0 ? _j : 0).toString()
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _k.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        setIsShowPopup(isOpen);
        if (isOpen && token) {
            tracking({
                eventName: 'js_job_management:job_analysis_view'
            });
            getMatchingJob();
        }
    }, [isOpen, token]);
    // format data
    var msgSkilltext = function () {
        var skillText = t('You possess {numOfSkill} skills required for this job. Add more skills to make your profile more impressive.').replace('{numOfSkill}', "".concat(skillMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal));
        if (skillMatching === (matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal)) {
            skillText = t('Congratulations! You possess {numOfSkill} skills required for this job.').replace('{numOfSkill}', "".concat(skillMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal));
        }
        return skillText;
    };
    var matchingStatus = function () {
        if ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) === undefined || Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) < MATCH_SCORE_UN_SUITABLE) {
            return '';
        }
        if (Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) >= MATCH_SCORE_UN_SUITABLE &&
            Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) < MATCH_SCORE_VERY_SUITABLE) {
            return (react.createElement(LineMatching, { style: { color: Colors/* colors.green.50 */.O9.green[50] } },
                react.createElement(SuitableIcon$1, { width: 25, height: 25, color: Colors/* colors.green.50 */.O9.green[50] }),
                react.createElement("span", null, matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScoreLabel)));
        }
        if ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) >= MATCH_SCORE_VERY_SUITABLE) {
            return (react.createElement(LineMatching, { style: { color: Colors/* colors.primary.40 */.O9.primary[40] } },
                react.createElement(VerySuitableIcon$1, { width: 25, height: 25, color: Colors/* colors.primary.40 */.O9.primary[40] }),
                react.createElement("span", null, matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScoreLabel)));
        }
        return '';
    };
    var msgCareerPathtext = function () {
        var numOfCriteria = "".concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.countMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.careerPathTotal);
        return t('This job matches {numOfCriteria} criteria in your career path. Update your profile frequently to let us know your latest career path.').replace('{numOfCriteria}', numOfCriteria);
    };
    var lastUpdated = (0,time/* convertDateTime */.jF)(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.lastUpdated, 7);
    var removeSkillMatching = function (skill) {
        var skillAddListNew = skillMatchList.filter(function (item) { return item.skillId !== skill.skillId; });
        setSkillMatchList(skillAddListNew);
        setSkillNoMatchList((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], skillNoMatchList, true), [skill], false));
        setSkillMatching(skillMatching - 1);
        (0,resumes/* updateSkills */.MU)(baseMsUrl, token, skill, langCode, 'DELETE');
        (0,Toast/* showToast */.CF)(t('Removed successfully'), t('Your Skill has been removed successfully'), 'success');
    };
    var addSkillToMatching = function (skill) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var result, skillNoMatchListNew;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0,resumes/* updateSkills */.MU)(baseMsUrl, token, (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, skill), { skillId: -1, skillLevel: 0 }), langCode, 'POST')
                    // Tracking Add skill
                ];
                case 1:
                    result = _b.sent();
                    // Tracking Add skill
                    trackingJobMatching(baseMsUrl, {
                        userId: userId,
                        jobId: jobInfo.jobId,
                        action: 'Add Skill',
                        status: matchStatusCode((_a = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) !== null && _a !== void 0 ? _a : 0).toString()
                    });
                    if ((result === null || result === void 0 ? void 0 : result.showMessage) === true && (result === null || result === void 0 ? void 0 : result.message) === 'you get maximum skill') {
                        (0,Toast/* showToast */.CF)(t('Error: unable to add skills'), t('You had the maximum of skills.'), 'error');
                    }
                    else {
                        setSkillMatchList((0,_tslib/* __spreadArray */.ev)((0,_tslib/* __spreadArray */.ev)([], skillMatchList, true), [skill], false));
                        skillNoMatchListNew = skillNoMatchList.filter(function (item) { return item.skillId !== skill.skillId; });
                        setSkillNoMatchList(skillNoMatchListNew);
                        setSkillMatching(skillMatching + 1);
                        (0,Toast/* showToast */.CF)(t('Added successfully'), t('Your Skill has been added successfully'), 'success');
                        tracking({
                            eventName: 'js_job_management:job_analysis_skill_add',
                            properties: {
                                skillName: skill.skillName
                            }
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var renderTagListMatching = function () {
        if (skillMatchList.length === 0) {
            return null;
        }
        return (react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { marginBottom: skillNoMatchList.length > 0 ? 16 : 0 } },
            react.createElement(LineDefault, { style: { margin: '0 0 16px 0', fontWeight: 600 } }, t('Skills on your profile')),
            react.createElement(TagList, null, skillMatchList === null || skillMatchList === void 0 ? void 0 : skillMatchList.map(function (skill, index) {
                return (react.createElement(components_Tag/* default */.Z, { iconType: 'remove', key: "skill-".concat(skill.skillId, "-").concat(index), isActive: true, label: skill.skillName, onClick: function () {
                        removeSkillMatching(skill);
                    }, size: 'large', isMobile: false, isHiddenIconActive: true }));
            }))));
    };
    var renderTagListNoMatch = function () {
        if (!skillNoMatchList.length) {
            return null;
        }
        return (react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)() },
            react.createElement(LineDefault, { style: { margin: '0 0 16px 0', fontWeight: 600 } }, t('Skills missing on your profile')),
            react.createElement(TagList, null, skillNoMatchList.map(function (skill, index) {
                return (react.createElement(components_Tag/* default */.Z, { iconType: 'add', key: "add-".concat(skill === null || skill === void 0 ? void 0 : skill.skillId, "-").concat(index), isShowIcon: true, label: skill.skillName, onClick: function () {
                        addSkillToMatching(skill);
                    }, size: 'large', isMobile: false, classSelector: 'add-skill-job-match' }));
            }))));
    };
    var renderTagJobLevelMatching = function () {
        var _a, _b;
        return (react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)() },
            react.createElement(components_Tag/* default */.Z, { isActive: (_a = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience) === null || _a === void 0 ? void 0 : _a.isMatch, isShowIcon: true, label: "".concat(t('Job level:'), " ").concat((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelText) || ''), size: 'large', isMobile: false, readOnly: true, custom: ((_b = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience) === null || _b === void 0 ? void 0 : _b.isMatch)
                    ? {
                        color: Colors/* colors.primary.40 */.O9.primary[40],
                        backgroundColor: Colors/* colors.primary.95 */.O9.primary[95],
                        borderColor: Colors/* colors.primary.80 */.O9.primary[80]
                    }
                    : {
                        color: Colors/* colors.grey.90 */.O9.grey[90],
                        backgroundColor: Colors/* colors.grey.99 */.O9.grey[99],
                        borderColor: Colors/* colors.grey.90 */.O9.grey[90]
                    }, isHiddenIconActive: true })));
    };
    var renderTagCareerPathMatching = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var matchCareerPath = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath;
        var careerPathList = [
            {
                id: 0,
                name: "".concat(t('Job function'), ": ").concat((_b = (_a = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobFunction) === null || _a === void 0 ? void 0 : _a.jobFunction) === null || _b === void 0 ? void 0 : _b.jobFunctionV3Name),
                isMatch: (_c = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobFunction) === null || _c === void 0 ? void 0 : _c.isMatch
            },
            {
                id: 1,
                name: "".concat(t('Industry'), ": ").concat((_e = (_d = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchCompanyIndustry) === null || _d === void 0 ? void 0 : _d.industry) === null || _e === void 0 ? void 0 : _e.industryV3Name),
                isMatch: (_f = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchCompanyIndustry) === null || _f === void 0 ? void 0 : _f.isMatch
            },
            {
                id: 2,
                name: "".concat(t('Job title'), ": ").concat((_g = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobTitle) === null || _g === void 0 ? void 0 : _g.jobTitle),
                isMatch: (_h = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobTitle) === null || _h === void 0 ? void 0 : _h.isMatch
            },
            {
                id: 3,
                name: t('Working location'),
                isMatch: matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchLocation.isMatch
            },
            {
                id: 4,
                name: t('Salary'),
                isMatch: matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchSalary.isMatch
            }
        ];
        return (react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)() },
            react.createElement(TagList, null, careerPathList.map(function (item, index) {
                var custom = {
                    color: Colors/* colors.grey.90 */.O9.grey[90],
                    backgroundColor: Colors/* colors.grey.99 */.O9.grey[99],
                    borderColor: Colors/* colors.grey.90 */.O9.grey[90]
                };
                if (item.isMatch) {
                    custom = {
                        color: Colors/* colors.primary.40 */.O9.primary[40],
                        backgroundColor: Colors/* colors.primary.95 */.O9.primary[95],
                        borderColor: Colors/* colors.primary.80 */.O9.primary[80]
                    };
                }
                return (react.createElement(components_Tag/* default */.Z, { key: "career-".concat(item.id, "-").concat(index), isActive: !!item.isMatch, label: item.name || '', size: 'large', isMobile: false, readOnly: true, custom: custom }));
            }))));
    };
    return (react.createElement(CustomPopup, { isShow: isShowPopup, lang: langCode, onClickOutside: function () {
            setIsShowPopup(false);
            onClose && onClose();
        }, onClose: function () {
            setIsShowPopup(false);
            onClose && onClose();
        }, text: {
            header: t('Job matching analysis')
        }, custom: {
            additionalFooterHeight: 40,
            bodyClass: 'vnw-popup-body',
            footer: (react.createElement(JobMatchingAnalysis_style_css_FooterContainer, { isMobile: (0,helpers/* isMobile */.tq)() },
                react.createElement(Variant/* Anchor */.ee, { color: Colors/* colors.primary.40 */.O9.primary[40], onClick: function () {
                        return tracking({ eventName: 'js_job_management:job_analysis_update_profile_click' });
                    }, href: '/my-profile', className: 'update-profile-job-match' }, t('Update My profile')),
                !hiddenApplyBtn ? (react.createElement(Button/* default */.Z, { type: 'primary', onClick: function () {
                        setIsShowPopup(false);
                        onClose && onClose();
                        (props === null || props === void 0 ? void 0 : props.onOpenApplyCallBack) && (props === null || props === void 0 ? void 0 : props.onOpenApplyCallBack());
                        tracking({ eventName: 'js_job_management:job_analysis_apply_click' });
                    }, disabled: false, className: 'apply-job-match' }, t('Apply now'))) : null)),
            withDefaultBody: true
        } },
        react.createElement(JobMatchingAnalysis_style_css_BodyContainer, null,
            react.createElement(style_css_Section, null,
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, { sm: 14, xs: 24 },
                        react.createElement(Line, { name: 'body', size: 'extraLarge', style: { marginBottom: 8 } }, jobInfo.jobTitle),
                        (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.companyUrl) ? (react.createElement(Variant/* Anchor */.ee, { style: { fontWeight: 500, fontSize: 14, lineHeight: '18px' }, name: 'body', size: 'small', href: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.companyUrl, color: Colors/* colors.primary.40 */.O9.primary[40] }, jobInfo.companyName)) : (react.createElement(Line, { name: 'body', size: 'small', style: {
                                fontWeight: 500,
                                fontSize: 14,
                                lineHeight: '18px',
                                color: Colors/* colors.primary.40 */.O9.primary[40]
                            } }, jobInfo.companyName)),
                        (0,helpers/* isMobile */.tq)() ? (react.createElement(react.Fragment, null,
                            react.createElement(LineDefault, { style: { margin: '8px 0', color: Colors/* colors.secondary.40 */.O9.secondary[40] } }, jobInfo.prettySalary),
                            react.createElement(LineDefault, { style: { margin: '8px 0' } },
                                react.createElement(LocationIcon$1, { width: 24, height: 24 }),
                                react.createElement("span", null, (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.locationText) || '')))) : (react.createElement(LineDefault, { style: { margin: '8px 0' } },
                            react.createElement("span", { style: { color: Colors/* colors.secondary.40 */.O9.secondary[40] } }, jobInfo.prettySalary),
                            react.createElement("span", null, "|"),
                            react.createElement(LocationIcon$1, { width: 24, height: 24 }),
                            react.createElement("span", { style: { maxWidth: '275px' } }, (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.locationText) || ''))),
                        react.createElement(BorderBottom, null),
                        matchingStatus(),
                        react.createElement(Note, null,
                            "\"",
                            t('The assessment is for reference only, based on your VietnamWorks profile and the requirements of this job.'),
                            "\"")),
                    !(0,helpers/* isMobile */.tq)() ? (react.createElement(Col/* default */.Z, { sm: 10, style: { textAlign: 'center' } },
                        react.createElement(style_css_Image, { src: imageUrl((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) || 0), width: 250 }))) : null)),
            react.createElement(style_css_Section, null,
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'label', size: 'medium', color: Colors/* colors.grey.0 */.O9.grey[0], style: { marginBottom: 8 } }, t('Skills')))),
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, { sm: 10, xs: 24 },
                        react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            react.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                react.createElement(ProficiencyBar, { totalCol: (matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal) || 0, value: skillMatching, background: Colors/* colors.primary.90 */.O9.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(Colors/* colors.grey.100 */.O9.grey[100]), backgroundSeparator: parseFloat((skillMatching / ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal) || 0)).toFixed(2)) *
                                        100 <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? Colors/* colors.yellow.40 */.O9.yellow[40]
                                        : Colors/* colors.primary.50 */.O9.primary[50] })),
                            react.createElement(BorderBottom, { style: { width: '100%' } }),
                            react.createElement(LineDefault, { style: { margin: '8px 0', fontWeight: 400 } }, msgSkilltext()))),
                    react.createElement(Col/* default */.Z, { sm: 14, xs: 24 },
                        renderTagListMatching(),
                        renderTagListNoMatch()))),
            react.createElement(style_css_Section, null,
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'label', size: 'medium', color: Colors/* colors.grey.0 */.O9.grey[0], style: { marginBottom: 8 } }, t('Work experience')))),
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, { sm: 10, xs: 24 },
                        react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            react.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                react.createElement(ProficiencyBar, { totalCol: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.levelTotal), value: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.countMatching), background: Colors/* colors.primary.90 */.O9.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(Colors/* colors.grey.100 */.O9.grey[100]), backgroundSeparator: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.percentage) <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? Colors/* colors.yellow.40 */.O9.yellow[40]
                                        : Colors/* colors.primary.50 */.O9.primary[50] })),
                            react.createElement(BorderBottom, { style: { width: '100%' } }),
                            react.createElement(Variant/* Label */.__, { name: 'body', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], style: { margin: '8px 0' } }, t('Your level vs. required job level.')))),
                    react.createElement(Col/* default */.Z, { sm: 14, xs: 24 }, renderTagJobLevelMatching()))),
            react.createElement(style_css_Section, null,
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'label', size: 'medium', color: Colors/* colors.grey.0 */.O9.grey[0], style: { marginBottom: 8 } }, t('Career path')))),
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, { sm: 10, xs: 24 },
                        react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            react.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                react.createElement(ProficiencyBar, { totalCol: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.careerPathTotal), value: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.countMatching), background: Colors/* colors.primary.90 */.O9.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(Colors/* colors.grey.100 */.O9.grey[100]), backgroundSeparator: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.percentage) <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? Colors/* colors.yellow.40 */.O9.yellow[40]
                                        : Colors/* colors.primary.50 */.O9.primary[50] })),
                            react.createElement(BorderBottom, { style: { width: '100%' } }),
                            react.createElement(Variant/* Label */.__, { name: 'body', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], style: { margin: '8px 0' } }, msgCareerPathtext()))),
                    react.createElement(Col/* default */.Z, { sm: 14, xs: 24 }, renderTagCareerPathMatching()))),
            react.createElement(style_css_Section, { isMobile: (0,helpers/* isMobile */.tq)() },
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, null,
                        react.createElement(Variant/* Paragraph */.nv, { name: 'label', size: 'medium', color: Colors/* colors.grey.0 */.O9.grey[0], style: { marginBottom: 8 } }, t('My VietnamWorks profile:')))),
                react.createElement(Row/* default */.Z, null,
                    react.createElement(Col/* default */.Z, { sm: 10, xs: 24 },
                        react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            react.createElement(Variant/* Label */.__, { name: 'body', size: 'medium', color: Colors/* colors.grey.20 */.O9.grey[20], style: { margin: '8px 0' } }, t('A complete and updated profile is more attractive to employers.')))),
                    react.createElement(Col/* default */.Z, { sm: 14, xs: 24 },
                        react.createElement(Detail, { isMobile: (0,helpers/* isMobile */.tq)(), style: { display: 'flex', gap: '12px' } },
                            react.createElement(BoxInfo, null,
                                react.createElement(Variant/* Label */.__, { size: 'medium' }, t('Profile strength')),
                                react.createElement(CircleWrapper, { width: 50 },
                                    react.createElement(ProfileStrength, { isMobile: (0,helpers/* isMobile */.tq)() }, "".concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.profileStrength, "%")),
                                    react.createElement(style_css_Circle, null,
                                        react.createElement(CirclePercent, { percent: 100, width: 50, strokeWidth: 4 })),
                                    react.createElement(style_css_Circle, null,
                                        react.createElement(CirclePercent, { percent: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.profileStrength), width: 50, color: '#005AFF', strokeWidth: 4 })))),
                            react.createElement(HorizonalBorder, null),
                            react.createElement(BoxInfo, null,
                                react.createElement(Variant/* Label */.__, { name: 'body', size: 'medium' },
                                    t('Last update:'),
                                    " ",
                                    lastUpdated)))))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupCreateJobAlertUMD/mailboxIcon.js
'use client';



function MailboxIcon () {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 48 48', width: '30px', height: '30px' },
        react.createElement("path", { fill: '#005AFF', d: 'M45,34V18c0-4.418-3.582-8-8-8H16c-4.418,0-8,3.582-8,8v16H45z' }),
        react.createElement("path", { fill: '#005AFF', d: 'M11,33c0,0.552-0.448,1-1,1H4c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h6C10.552,32,11,32.448,11,33L11,33z' }),
        react.createElement("path", { fill: '#0D47A1', d: 'M16,12c-3.309,0-6,2.691-6,6v14h12V18C22,14.691,19.309,12,16,12z' }),
        react.createElement("path", { fill: '#FF3D00', d: 'M28 4H34V8H28z' }),
        react.createElement("path", { fill: '#FF3D00', d: 'M28 6H30V17H28z' }),
        react.createElement("path", { fill: '#FF3D00', d: 'M29 16A2 2 0 1 0 29 20A2 2 0 1 0 29 16Z' }),
        react.createElement("path", { fill: '#DD2C00', d: 'M29 17A1 1 0 1 0 29 19A1 1 0 1 0 29 17Z' }),
        react.createElement("path", { fill: '#FFCC80', d: 'M25 34H30V44H25z' }),
        react.createElement("path", { fill: '#FFA726', d: 'M25 34H30V36H25z' }),
        react.createElement("path", { fill: '#CFD8DC', d: 'M13,21v9c0,1.025,0.975,2,2,2h7V19h-7C13.975,19,13,19.975,13,21z' }),
        react.createElement("path", { fill: '#78909C', d: 'M13,21v1l9,7v-2l-8.782-6.831C13.083,20.43,13,20.711,13,21z' })));
}


//# sourceMappingURL=mailboxIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/PopupCreateJobAlertUMD/PopupUMD.js
'use client';





























/**
 * Job Alert Modal Component
 *
 * @param props
 */
var PopupUMD_JobAlert = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = props.language, language = _o === void 0 ? 'vi' : _o, _p = props.isMobile, isMobile = _p === void 0 ? false : _p, _q = props.jobAlertInfo, jobAlertInfo = _q === void 0 ? null : _q, _r = props.jobLocationOptions, jobLocationOptions = _r === void 0 ? [] : _r, _s = props.jobIndustryOptions, jobIndustryOptions = _s === void 0 ? [] : _s, _t = props.jobFunctionOptions, jobFunctionOptions = _t === void 0 ? {
        parent: [],
        child: {}
    } : _t, _u = props.defaultData, defaultData = _u === void 0 ? {
        jobTitle: '',
        jobSalary: 0,
        jobLevel: [1],
        jobLocation: [24],
        jobCategory: [35],
        jobIndustry: [],
        jobFunction: [],
        userEmail: 'user@gmail.com',
        apiJobAlert: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts',
        apiJobAlertAnonymous: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
        apiTokenAccess: 'ZGQwY2E0MDgzYjQ1N2EyNzI2ODgyNGVkZjU3ZjliMDUyMTM2N2FkNmYxYTQwOWJmNmEwNWEyYTMxZDc5ZjUyYQ',
        apiJobLevelList: 'https://ms.vietnamworks.com/meta/v1.0/job-levels',
        isAuthenticated: 0,
        userTotalJobAlert: 0,
        msBaseUrl: 'https://ms.vietnamworks.com'
    } : _u, onDeleteJobAlert = props.onDeleteJobAlert, onAddEditJobAlert = props.onAddEditJobAlert, _v = props.useGlobalToast, useGlobalToast = _v === void 0 ? false : _v;
    var tracking = (0,useHog/* default */.Z)().tracking;
    var IS_AUTHENTICATED = defaultData.isAuthenticated === 1;
    var _w = (0,react.useState)(false), isModalOpen = _w[0], setIsModalOpen = _w[1];
    var _x = (0,react.useState)(IS_AUTHENTICATED), isLoggedIn = _x[0], setIsLoggedIn = _x[1];
    var _y = (0,react.useState)(false), isButtonOpen = _y[0], setIsButtonOpen = _y[1];
    // Job Alert info
    var defaultJobTitle = defaultData.jobTitle.substring(0, 100);
    var _z = (0,react.useState)(defaultJobTitle !== null && defaultJobTitle !== void 0 ? defaultJobTitle : ''), jobTitle = _z[0], setJobTitle = _z[1];
    var _0 = (0,react.useState)((_a = defaultData.jobSalary) !== null && _a !== void 0 ? _a : 0), jobSalary = _0[0], setJobSalary = _0[1];
    var _1 = (0,react.useState)((_b = defaultData.jobLevel) !== null && _b !== void 0 ? _b : []), jobLevel = _1[0], setJobLevel = _1[1];
    var _2 = (0,react.useState)((_c = defaultData.jobLocation) !== null && _c !== void 0 ? _c : []), jobLocation = _2[0], setJobLocation = _2[1];
    var jobCategory = (_d = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobCategory) !== null && _d !== void 0 ? _d : [];
    var _3 = (0,react.useState)((_e = defaultData === null || defaultData === void 0 ? void 0 : defaultData.jobFunction) !== null && _e !== void 0 ? _e : []), jobFunction = _3[0], setJobFunction = _3[1];
    var _4 = (0,react.useState)((_f = defaultData.jobIndustry) !== null && _f !== void 0 ? _f : []), jobIndustry = _4[0], setJobIndustry = _4[1];
    var _5 = (0,react.useState)((_g = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.isReceivedJobAlert) !== null && _g !== void 0 ? _g : true), isReceivedJobAlert = _5[0], setReceivedJobAlert = _5[1];
    var _6 = (0,react.useState)((_h = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobInterval) !== null && _h !== void 0 ? _h : 2), jobInterval = _6[0], setJobInterval = _6[1];
    var _7 = (0,react.useState)((_j = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobNotificationBy) !== null && _j !== void 0 ? _j : 1), jobNotificationBy = _7[0], setJobNotificationBy = _7[1];
    var _8 = (0,react.useState)((_k = defaultData === null || defaultData === void 0 ? void 0 : defaultData.userEmail) !== null && _k !== void 0 ? _k : ''), userEmail = _8[0], setUserEmail = _8[1];
    var _9 = (0,react.useState)(true), isEmailValid = _9[0], setEmailValid = _9[1];
    var _10 = (0,react.useState)((_l = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryCurrencyId) !== null && _l !== void 0 ? _l : 1), salaryCurrencyId = _10[0], setSalaryCurrencyId = _10[1];
    var _11 = (0,react.useState)((_m = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryPeriodId) !== null && _m !== void 0 ? _m : ESalaryPeriod.MONTHLY), salaryPeriodId = _11[0], setSalaryPeriodId = _11[1];
    // modal
    var _12 = (0,react.useState)(false), isShowLoading = _12[0], setShowLoading = _12[1];
    var _13 = (0,react.useState)(false), isDeleteConfirmOpen = _13[0], setDeleteConfirmOpen = _13[1];
    var _14 = (0,react.useState)(false), isAskCloseWithoutSave = _14[0], setAskCloseWithoutSaveOpen = _14[1];
    var _15 = (0,react.useState)(false), isFormChanged = _15[0], setIsFormChange = _15[1];
    var _16 = (0,react.useState)({
        jobTitle: true
    }), validateForm = _16[0], setValidateForm = _16[1];
    // job level list
    var _17 = (0,react.useState)([]), jobLevelList = _17[0], setJobLevelList = _17[1];
    var isEdit = (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== undefined && (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== null;
    (0,react.useEffect)(function () {
        // Do get Job Level
        var doGetJobLevelList = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var getJobLevelListRespone, returnJobLevelList_1;
            return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (jobLevelList.length > 0) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, jobAlertService.getJobLevelList(defaultData.apiJobLevelList)];
                    case 1:
                        getJobLevelListRespone = _a.sent();
                        if (getJobLevelListRespone.data !== undefined &&
                            getJobLevelListRespone.data.relationships !== undefined &&
                            getJobLevelListRespone.data.relationships.data !== undefined) {
                            returnJobLevelList_1 = [];
                            getJobLevelListRespone.data.relationships.data.map(function (item) {
                                returnJobLevelList_1.push({
                                    id: item.id,
                                    text: language === 'en' ? item.attributes.nameEn : item.attributes.nameVi
                                });
                            });
                            setJobLevelList(returnJobLevelList_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isModalOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
            doGetJobLevelList();
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [isModalOpen, props]);
    var handleOnClickClose = function () {
        // check if any data new then show ask close popup,
        // if don't have anything new then just close main modal
        if (isFormChanged) {
            setAskCloseWithoutSaveOpen(true);
        }
        else {
            setIsModalOpen(false);
        }
    };
    var isFormValidate = function () {
        var result = true;
        var jobTitleValid = true;
        // check job title
        if (jobTitle === '' || jobTitle.length > maxJobTitleLength) {
            result = false;
            jobTitleValid = false;
        }
        setValidateForm({
            jobTitle: jobTitleValid
        });
        return result;
    };
    var handleOnChangeUserEmail = function (value) {
        setEmailValid(true);
        setUserEmail(value);
    };
    // const validateEmail = (email: string) => {
    //     const regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/
    //     return regExp.test(String(email).toLowerCase())
    // }
    var handleOnClickSaveUserEmail = function () {
        // check email valid
        var isValid = false;
        if (userEmail.indexOf('@') > 0) {
            isValid = true;
            if (userEmail.indexOf('.') > 0) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        if (isValid) {
            // Done input email for user who didn't log in
            setIsLoggedIn(true);
        }
        else {
            // only set valid false. No need to set true for better performance
            setEmailValid(false);
        }
    };
    var handleOnClickDelete = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var jobAlertResult, isDeleted, deletedNotifyContent;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, jobAlertService.deleteJobAlert("".concat(defaultData.apiJobAlert).concat(jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId), "".concat(defaultData.apiTokenAccess))];
                case 1:
                    jobAlertResult = _b.sent();
                    isDeleted = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode) {
                        isDeleted = true;
                        // Hide confirm delete dialog
                        setDeleteConfirmOpen(false);
                        // close edit modal
                        setIsModalOpen(false);
                        deletedNotifyContent = (0,helpers.t)('Job alert "{0}" deleted', language);
                        (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert deleted successfully', language), deletedNotifyContent.replace('{0}', defaultData === null || defaultData === void 0 ? void 0 : defaultData.jobTitle));
                    }
                    onDeleteJobAlert && onDeleteJobAlert(isDeleted);
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    setDeleteConfirmOpen(false);
                    (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)("Can't delete this job alert", language), Toast/* TOAST_TYPE_ERROR */.rn);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickSave = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var postData, isAnonymous, apiUrl, jobAlertResult, isSuccess, notifyTitle, notifyContent, notifyTitle, notifyContent;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    postData = {
                        keyword: jobTitle,
                        salary_min: jobSalary,
                        job_level: jobLevel,
                        location: jobLocation,
                        industry: jobCategory,
                        status: isReceivedJobAlert ? 1 : 0,
                        period_type_id: jobInterval,
                        notification_by: jobNotificationBy,
                        user_email: userEmail,
                        language_id: language === 'en' ? 2 : 1,
                        company_industry: jobIndustry,
                        job_function: jobFunction.map(function (item) { return item.childrenIds[0]; }),
                        salaryPeriodId: salaryPeriodId,
                        salaryCurrencyId: salaryCurrencyId
                    };
                    // Check form valid
                    if (!isFormValidate())
                        return [2 /*return*/];
                    setShowLoading(true);
                    isAnonymous = false;
                    apiUrl = isEdit ? (defaultData.apiJobAlert || '') + (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) : defaultData.apiJobAlert;
                    if (IS_AUTHENTICATED !== undefined && !IS_AUTHENTICATED) {
                        // If user is not logged in then using anonymous url
                        apiUrl = defaultData.apiJobAlertAnonymous;
                        postData.job_level_id = defaultData.jobLevel[0];
                        isAnonymous = true;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, jobAlertService.createEditJobAlert(postData, isEdit, "".concat(apiUrl), "".concat(defaultData.apiTokenAccess), isAnonymous)];
                case 2:
                    jobAlertResult = _c.sent();
                    isSuccess = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        tracking({
                            eventName: 'js_job_management:job_alert_create',
                            properties: {
                                keyword: jobTitle,
                                frequencyId: jobInterval,
                                chanelId: jobNotificationBy,
                                isEnable: !!isReceivedJobAlert,
                                isAnonymous: isAnonymous
                            }
                        });
                    }
                    if (((_b = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _b === void 0 ? void 0 : _b.code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = (0,helpers.t)('Job alert created successfully', language);
                        notifyContent = (0,helpers.t)('Job alert "{0}" created', language);
                        if (isEdit) {
                            // show edit success
                            notifyTitle = (0,helpers.t)('Job alert updated successfully', language);
                            notifyContent = (0,helpers.t)('Job alert "{0}" updated', language);
                        }
                        (0,Toast/* showToast */.CF)(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = (0,helpers.t)('Job alert created successfully', language);
                        notifyContent = (0,helpers.t)('Job alert "{0}" created', language);
                        (0,Toast/* showToast */.CF)(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === duplicatedJobAlert) {
                        isSuccess = false;
                        // show duplicate
                        (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)('You already created this job alert', language), Toast/* TOAST_TYPE_ERROR */.rn);
                    }
                    if (defaultData.userTotalJobAlert === 10 || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === TOTAL_MAX_JOB_ALERT_CODE) {
                        isSuccess = false;
                        (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)('You already created 10 job alerts!', language), Toast/* TOAST_TYPE_ERROR */.rn);
                    }
                    setShowLoading(false);
                    onAddEditJobAlert && onAddEditJobAlert(isSuccess);
                    return [3 /*break*/, 4];
                case 3:
                    _c.sent();
                    setShowLoading(false);
                    (0,Toast/* showToast */.CF)((0,helpers.t)('Job alert error', language), (0,helpers.t)("Can't update this job alert", language), Toast/* TOAST_TYPE_ERROR */.rn);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickCloseAskSave = function () {
        setAskCloseWithoutSaveOpen(false);
        setIsModalOpen(false);
    };
    var isShowJobAlertModal = isModalOpen;
    if (isAskCloseWithoutSave) {
        isShowJobAlertModal = false;
    }
    if (isDeleteConfirmOpen) {
        isShowJobAlertModal = false;
    }
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.wraperFloatingIcon, " ").concat(isButtonOpen ? JobAlert_module_scss_styles.showBtn : ''), onMouseEnter: function () { return setIsButtonOpen(true); }, onMouseLeave: function () { return setIsButtonOpen(false); } },
            react.createElement("div", { className: 'd-flex' },
                react.createElement("span", { className: JobAlert_module_scss_styles.mailBoxFloating },
                    react.createElement(MailboxIcon, null)),
                react.createElement("div", { className: JobAlert_module_scss_styles.extendJobAlertIcon },
                    react.createElement("div", { className: JobAlert_module_scss_styles.mailBoxText }, (0,helpers.t)('Receive job alerts for jobs like this search!', language)),
                    react.createElement(Button/* default */.Z, { type: 'primary', onClick: function () { return setIsModalOpen(true); } }, (0,helpers.t)('Send me jobs', language))))),
        react.createElement("div", { className: JobAlert_module_scss_styles.backdrop + ' ' + (isShowJobAlertModal ? JobAlert_module_scss_styles.isOpen : ''), onClick: handleOnClickClose }),
        react.createElement("div", { className: 'box-dialog ' + JobAlert_module_scss_styles.jobAlertModal + ' ' + (isShowJobAlertModal ? JobAlert_module_scss_styles.isOpen : '') },
            react.createElement("div", { className: JobAlert_module_scss_styles.overlayLock, style: { display: isShowLoading ? 'flex' : 'none' } },
                react.createElement(IconLoading, { width: 64, height: 64 })),
            react.createElement("div", { className: JobAlert_module_scss_styles.header },
                react.createElement("div", { className: JobAlert_module_scss_styles.modalTitle }, (0,helpers.t)('Create Job Alert', language)),
                react.createElement("span", { onClick: handleOnClickClose, className: "".concat(JobAlert_module_scss_styles.icon, " ").concat(isMobile ? JobAlert_module_scss_styles.left : JobAlert_module_scss_styles.right) },
                    react.createElement(closeIcon, null))),
            isLoggedIn ? (react.createElement(react.Fragment, null,
                react.createElement("div", { className: JobAlert_module_scss_styles.body },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row }, isMobile ? (react.createElement("div", { className: JobAlert_module_scss_styles.colSmall12 },
                        react.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: (0,helpers.t)('Receive Job Alerts', language) }))) : (react.createElement("div", { className: JobAlert_module_scss_styles.hideOnMobile }))),
                    react.createElement("div", { className: JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.mb0 },
                        react.createElement("div", { className: isMobile ? JobAlert_module_scss_styles.colSmall6 : JobAlert_module_scss_styles.row },
                            react.createElement(JobTitle, { key: "jobTitle-".concat(validateForm.jobTitle ? 'true' : 'false'), jobTitle: jobTitle, setJobTitle: function (value) {
                                    setJobTitle(value);
                                    if (value !== jobTitle)
                                        setIsFormChange(true);
                                }, isValidate: validateForm.jobTitle, language: language })),
                        react.createElement("div", { className: isMobile ? '' : JobAlert_module_scss_styles.row },
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.inputSalary },
                                react.createElement(InputSalary, { salary: jobSalary, currencyId: salaryCurrencyId, msBaseUrl: defaultData.msBaseUrl, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, options: {
                                        label: (0,helpers.t)('Salary from', language)
                                    }, onChange: function (value, currencyId) {
                                        setJobSalary(value);
                                        setSalaryCurrencyId(currencyId);
                                        if (value !== jobSalary)
                                            setIsFormChange(true);
                                    } })),
                            react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                                react.createElement("label", { htmlFor: 'jobSalary' }, (0,helpers.t)('Pay period', language)),
                                react.createElement(MultipleRadio/* default */.Z, { name: 'currencyPeriod', value: salaryPeriodId, options: language === 'vi' ? SalaryPeriodOptions.vi : SalaryPeriodOptions.en, onChange: function (_a) {
                                        var value = _a.value;
                                        setSalaryPeriodId(value);
                                    } })))),
                    react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement(JobLevel, { isMobile: isMobile, jobLevelOptions: jobLevelList, jobLevel: jobLevel, setJobLevel: function (value) {
                                    setJobLevel(value);
                                    if (value !== jobLevel)
                                        setIsFormChange(true);
                                }, limitCharacterShow: 120, limitMaxShowItem: 3, language: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN })),
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                    setJobLocation(id);
                                    if (id !== jobLocation)
                                        setIsFormChange(true);
                                }, title: (0,helpers.t)('Location', language), jobOptions: jobLocationOptions, limitAlertText: (0,helpers.t)('You can only choose maximum 3 locations', language), errorText: (0,helpers.t)('This field is required', language), noResult: (0,helpers.t)('No result', language), pleaseSelect: (0,helpers.t)('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN }))),
                    react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement("label", null, language === constants/* ELanguage.VI */.Df.VI ? 'Ngành nghề' : 'Job function'),
                            react.createElement(JobFunction/* default */.Z, { isMobile: isMobile, data: jobFunctionOptions, value: jobFunction, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, onChange: function (value) {
                                    setJobFunction(value);
                                    setIsFormChange(true);
                                }, dropdownStyleOptions: {
                                    width: '100%'
                                }, isFlex: true, isSingleSelect: true, displayAsPopup: true })),
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement("label", { htmlFor: 'userEmail' }, language === constants/* ELanguage.VI */.Df.VI ? 'Lĩnh vực công ty' : 'Industries'),
                            react.createElement(CompanyIndustry/* default */.Z, { type: 'multiple-select', options: jobIndustryOptions, value: jobIndustry, onChange: function (ids) {
                                    setJobIndustry(ids);
                                    setIsFormChange(true);
                                }, langCode: language === 'vi' ? constants/* ELanguage.VI */.Df.VI : constants/* ELanguage.EN */.Df.EN, dropdownStyle: { width: '100%' }, isMobile: isMobile }))),
                    react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement(Interval, { jobInterval: jobInterval, setJobInterval: function (value) {
                                    setJobInterval(value);
                                    if (value !== jobInterval)
                                        setIsFormChange(true);
                                }, language: language })),
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 },
                            react.createElement(NotificationBy, { jobNotificationBy: jobNotificationBy, setJobNotificationBy: function (value) {
                                    setJobNotificationBy(value);
                                    if (value !== jobNotificationBy)
                                        setIsFormChange(true);
                                }, language: language })))),
                react.createElement("div", { className: JobAlert_module_scss_styles.footer },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.flexCenter },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall6 + ' ' + JobAlert_module_scss_styles.alignMiddle + ' ' + JobAlert_module_scss_styles.hideOnMobile }, isMobile ? (react.createElement("div", null)) : (react.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: (0,helpers.t)('Receive Job Alerts', language) }))),
                        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.colSmall6, " ").concat(JobAlert_module_scss_styles.colBottomRight) },
                            isEdit ? (react.createElement("div", { className: JobAlert_module_scss_styles.iconDelete, onClick: function () { return setDeleteConfirmOpen(true); } },
                                react.createElement(icons/* IconDeleteGrey */.A_, null))) : (react.createElement("div", null)),
                            react.createElement("div", null,
                                react.createElement(Button/* default */.Z, { type: 'primary', style: { float: 'right' }, onClick: handleOnClickSave }, (0,helpers.t)('Save', language)),
                                react.createElement(Button/* default */.Z, { style: { marginRight: 10 }, onClick: handleOnClickClose }, (0,helpers.t)('Cancel', language)))))))) : (react.createElement(react.Fragment, null,
                react.createElement("div", { className: JobAlert_module_scss_styles.body },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row },
                        react.createElement("div", { className: JobAlert_module_scss_styles.colSmall8 },
                            react.createElement("label", { htmlFor: 'userEmail' }, (0,helpers.t)('Your email', language)),
                            react.createElement(components_Input/* default */.Z, { type: 'text', id: 'userEmail', isRequired: true, onChange: function (value) {
                                    handleOnChangeUserEmail(value);
                                }, onPressEnter: handleOnClickSaveUserEmail, value: userEmail, className: JobAlert_module_scss_styles.jobAlertInput, maxLength: 100, placeholder: (0,helpers.t)('Email to receive jobs', language), autoFocus: true, hasError: !isEmailValid })),
                        isMobile ? (react.createElement(react.Fragment, null)) : (react.createElement("div", { className: JobAlert_module_scss_styles.colSmall4, style: { paddingLeft: 10 } },
                            react.createElement(Button/* default */.Z, { type: 'primary', size: 'md', onClick: handleOnClickSaveUserEmail, style: { width: '100%' } }, (0,helpers.t)('Send me jobs', language))))),
                    react.createElement("div", (0,_tslib/* __assign */.pi)({ className: JobAlert_module_scss_styles.row }, (isEmailValid ? { hidden: true } : '')),
                        react.createElement("p", (0,_tslib/* __assign */.pi)({ className: "error-message ".concat(JobAlert_module_scss_styles.errorMessage) }, (isEmailValid ? { hidden: true } : '')), (0,helpers.t)('This is not a valid email address', language)))),
                isMobile ? (react.createElement("div", { className: JobAlert_module_scss_styles.footer },
                    react.createElement("div", { className: JobAlert_module_scss_styles.row + ' ' + JobAlert_module_scss_styles.flexCenter },
                        react.createElement("div", { className: "".concat(JobAlert_module_scss_styles.colSmall6, " ").concat(JobAlert_module_scss_styles.colBottomRight) },
                            react.createElement("div", null,
                                react.createElement(Button/* default */.Z, { type: 'primary', size: 'sm', onClick: handleOnClickSaveUserEmail, style: { float: 'right' } }, (0,helpers.t)('Send me jobs', language)),
                                react.createElement(Button/* default */.Z, { size: 'sm', style: { marginRight: 10 }, onClick: handleOnClickClose }, (0,helpers.t)('Cancel', language))))))) : (react.createElement(react.Fragment, null))))),
        react.createElement(Dialog, { title: (0,helpers.t)('Delete this Job Alert?', language), isOpen: isDeleteConfirmOpen, onBack: function () { return setDeleteConfirmOpen(false); }, onClickAction: handleOnClickDelete, type: 'delete', deleteText: (0,helpers.t)('Remove', language), secondaryButtonText: (0,helpers.t)('Cancel', language), backdrop: true },
            react.createElement("div", null, (0,helpers.t)('You will not be able to receive email for job alert', language))),
        react.createElement(Dialog, { title: (0,helpers.t)('Discard this job alert?', language), isOpen: isAskCloseWithoutSave, onBack: function () { return setAskCloseWithoutSaveOpen(false); }, onClickAction: handleOnClickCloseAskSave, type: 'delete', deleteText: (0,helpers.t)('Yes', language), secondaryButtonText: (0,helpers.t)('No', language), backdrop: true },
            react.createElement("div", null, (0,helpers.t)('This job alert will not be saved', language))),
        !useGlobalToast && react.createElement(Toast/* default */.ZP, null)));
};


//# sourceMappingURL=PopupUMD.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CustomRadio/index.js + 1 modules
var components_CustomRadio = __webpack_require__(70092);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/HogProvider/index.js
var HogProvider = __webpack_require__(74313);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Cascader/helper.js
var Cascader_helper = __webpack_require__(90081);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/image.js
var Utils_image = __webpack_require__(4053);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/index.js
'use client';













//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/services.js
var JobCard_services = __webpack_require__(79430);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/index.js
'use client';




//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/Sort/index.js
'use client';



var SortIcon = function (_a) {
    var size = _a.size, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : '24', height: size !== null && size !== void 0 ? size : '24', viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M17.5876 3.18906C17.3757 3.19237 17.1738 3.27962 17.0261 3.43166C16.8785 3.58369 16.7972 3.78809 16.8001 4V18.0687L14.9657 16.2344C14.8912 16.1577 14.802 16.0968 14.7035 16.0552C14.605 16.0136 14.4992 15.9922 14.3923 15.9922C14.2332 15.9922 14.0776 16.0397 13.9456 16.1286C13.8136 16.2175 13.7111 16.3438 13.6512 16.4912C13.5914 16.6387 13.5768 16.8006 13.6094 16.9564C13.6421 17.1121 13.7204 17.2546 13.8345 17.3656L16.9642 20.4953C17.0386 20.593 17.1346 20.6723 17.2446 20.7269C17.3546 20.7815 17.4757 20.8101 17.5986 20.8104C17.7214 20.8107 17.8427 20.7827 17.9529 20.7286C18.0632 20.6745 18.1596 20.5958 18.2345 20.4984C18.2355 20.4969 18.2366 20.4953 18.2376 20.4937L21.3657 17.3656C21.4425 17.2919 21.5038 17.2036 21.546 17.1059C21.5883 17.0082 21.6106 16.9031 21.6117 16.7966C21.6128 16.6902 21.5926 16.5846 21.5524 16.4861C21.5121 16.3875 21.4526 16.298 21.3774 16.2227C21.3021 16.1475 21.2126 16.088 21.114 16.0478C21.0155 16.0075 20.9099 15.9874 20.8035 15.9884C20.6971 15.9895 20.5919 16.0118 20.4942 16.0541C20.3965 16.0963 20.3082 16.1576 20.2345 16.2344L18.4001 18.0687V4C18.4016 3.89297 18.3816 3.78673 18.3412 3.68758C18.3009 3.58843 18.2411 3.49838 18.1653 3.42276C18.0895 3.34714 17.9994 3.2875 17.9001 3.24735C17.8009 3.20721 17.6946 3.18739 17.5876 3.18906ZM4.00011 3.2C3.89411 3.1985 3.78885 3.21809 3.69048 3.25762C3.59211 3.29715 3.50257 3.35584 3.42707 3.43027C3.35158 3.50471 3.29163 3.59341 3.25071 3.69121C3.20979 3.78902 3.18872 3.89398 3.18872 4C3.18872 4.10602 3.20979 4.21098 3.25071 4.30879C3.29163 4.40659 3.35158 4.49529 3.42707 4.56973C3.50257 4.64416 3.59211 4.70285 3.69048 4.74238C3.78885 4.78191 3.89411 4.8015 4.00011 4.8H4.80011C4.90612 4.8015 5.01137 4.78191 5.10975 4.74238C5.20812 4.70285 5.29766 4.64416 5.37316 4.56973C5.44865 4.49529 5.5086 4.40659 5.54952 4.30879C5.59044 4.21098 5.61151 4.10602 5.61151 4C5.61151 3.89398 5.59044 3.78902 5.54952 3.69121C5.5086 3.59341 5.44865 3.50471 5.37316 3.43027C5.29766 3.35584 5.20812 3.29715 5.10975 3.25762C5.01137 3.21809 4.90612 3.1985 4.80011 3.2H4.00011ZM4.00011 6.4C3.89411 6.3985 3.78885 6.41809 3.69048 6.45762C3.59211 6.49715 3.50257 6.55584 3.42707 6.63027C3.35158 6.70471 3.29163 6.79341 3.25071 6.89121C3.20979 6.98902 3.18872 7.09398 3.18872 7.2C3.18872 7.30602 3.20979 7.41098 3.25071 7.50879C3.29163 7.60659 3.35158 7.69529 3.42707 7.76973C3.50257 7.84416 3.59211 7.90285 3.69048 7.94238C3.78885 7.98191 3.89411 8.0015 4.00011 8H6.40011C6.50612 8.0015 6.61137 7.98191 6.70975 7.94238C6.80812 7.90285 6.89766 7.84416 6.97316 7.76973C7.04865 7.69529 7.1086 7.60659 7.14952 7.50879C7.19044 7.41098 7.21151 7.30602 7.21151 7.2C7.21151 7.09398 7.19044 6.98902 7.14952 6.89121C7.1086 6.79341 7.04865 6.70471 6.97316 6.63027C6.89766 6.55584 6.80812 6.49715 6.70975 6.45762C6.61137 6.41809 6.50612 6.3985 6.40011 6.4H4.00011ZM4.00011 9.6C3.89411 9.5985 3.78885 9.61808 3.69048 9.65762C3.59211 9.69715 3.50257 9.75584 3.42707 9.83027C3.35158 9.90471 3.29163 9.9934 3.25071 10.0912C3.20979 10.189 3.18872 10.294 3.18872 10.4C3.18872 10.506 3.20979 10.611 3.25071 10.7088C3.29163 10.8066 3.35158 10.8953 3.42707 10.9697C3.50257 11.0442 3.59211 11.1029 3.69048 11.1424C3.78885 11.1819 3.89411 11.2015 4.00011 11.2H8.00011C8.10612 11.2015 8.21137 11.1819 8.30975 11.1424C8.40812 11.1029 8.49766 11.0442 8.57316 10.9697C8.64865 10.8953 8.7086 10.8066 8.74952 10.7088C8.79044 10.611 8.81151 10.506 8.81151 10.4C8.81151 10.294 8.79044 10.189 8.74952 10.0912C8.7086 9.9934 8.64865 9.90471 8.57316 9.83027C8.49766 9.75584 8.40812 9.69715 8.30975 9.65762C8.21137 9.61808 8.10612 9.5985 8.00011 9.6H4.00011ZM4.00011 12.8C3.89411 12.7985 3.78885 12.8181 3.69048 12.8576C3.59211 12.8971 3.50257 12.9558 3.42707 13.0303C3.35158 13.1047 3.29163 13.1934 3.25071 13.2912C3.20979 13.389 3.18872 13.494 3.18872 13.6C3.18872 13.706 3.20979 13.811 3.25071 13.9088C3.29163 14.0066 3.35158 14.0953 3.42707 14.1697C3.50257 14.2442 3.59211 14.3029 3.69048 14.3424C3.78885 14.3819 3.89411 14.4015 4.00011 14.4H8.80011C8.90612 14.4015 9.01137 14.3819 9.10975 14.3424C9.20812 14.3029 9.29766 14.2442 9.37316 14.1697C9.44865 14.0953 9.5086 14.0066 9.54952 13.9088C9.59044 13.811 9.61151 13.706 9.61151 13.6C9.61151 13.494 9.59044 13.389 9.54952 13.2912C9.5086 13.1934 9.44865 13.1047 9.37316 13.0303C9.29766 12.9558 9.20812 12.8971 9.10975 12.8576C9.01137 12.8181 8.90612 12.7985 8.80011 12.8H4.00011ZM4.00011 16C3.89411 15.9985 3.78885 16.0181 3.69048 16.0576C3.59211 16.0971 3.50257 16.1558 3.42707 16.2303C3.35158 16.3047 3.29163 16.3934 3.25071 16.4912C3.20979 16.589 3.18872 16.694 3.18872 16.8C3.18872 16.906 3.20979 17.011 3.25071 17.1088C3.29163 17.2066 3.35158 17.2953 3.42707 17.3697C3.50257 17.4442 3.59211 17.5029 3.69048 17.5424C3.78885 17.5819 3.89411 17.6015 4.00011 17.6H10.4001C10.5061 17.6015 10.6114 17.5819 10.7097 17.5424C10.8081 17.5029 10.8977 17.4442 10.9732 17.3697C11.0487 17.2953 11.1086 17.2066 11.1495 17.1088C11.1904 17.011 11.2115 16.906 11.2115 16.8C11.2115 16.694 11.1904 16.589 11.1495 16.4912C11.1086 16.3934 11.0487 16.3047 10.9732 16.2303C10.8977 16.1558 10.8081 16.0971 10.7097 16.0576C10.6114 16.0181 10.5061 15.9985 10.4001 16H4.00011ZM4.00011 19.2C3.89411 19.1985 3.78885 19.2181 3.69048 19.2576C3.59211 19.2971 3.50257 19.3558 3.42707 19.4303C3.35158 19.5047 3.29163 19.5934 3.25071 19.6912C3.20979 19.789 3.18872 19.894 3.18872 20C3.18872 20.106 3.20979 20.211 3.25071 20.3088C3.29163 20.4066 3.35158 20.4953 3.42707 20.5697C3.50257 20.6442 3.59211 20.7029 3.69048 20.7424C3.78885 20.7819 3.89411 20.8015 4.00011 20.8H12.0001C12.1061 20.8015 12.2114 20.7819 12.3097 20.7424C12.4081 20.7029 12.4977 20.6442 12.5732 20.5697C12.6487 20.4953 12.7086 20.4066 12.7495 20.3088C12.7904 20.211 12.8115 20.106 12.8115 20C12.8115 19.894 12.7904 19.789 12.7495 19.6912C12.7086 19.5934 12.6487 19.5047 12.5732 19.4303C12.4977 19.3558 12.4081 19.2971 12.3097 19.2576C12.2114 19.2181 12.1061 19.1985 12.0001 19.2H4.00011Z', fill: color !== null && color !== void 0 ? color : '#797979' })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddIcon/index.js
'use client';




var AddIcon = react.memo(function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.rotate, rotate = _e === void 0 ? 0 : _e, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 50 50', className: className, style: (0,_tslib/* __assign */.pi)({ transform: "rotate(".concat(rotate, "deg)") }, (color ? { fill: color } : null)) },
        react.createElement("path", { d: 'M25 2C12.264 2 2 12.264 2 25s10.264 23 23 23 23-10.264 23-23S37.736 2 25 2zm0 2c11.664 0 21 9.336 21 21s-9.336 21-21 21S4 36.664 4 25 13.336 4 25 4zm-1 9v11H13v2h11v11h2V26h11v-2H26V13h-2z' })));
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddOutlinedIcon/index.js
'use client';



var AddOutlinedIcon = react.memo(function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#FF7D55' : _e;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 21 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Add-outline' },
            react.createElement("path", { id: 'Add', fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.50024 10C2.50024 5.58969 6.08993 2 10.5002 2C14.9106 2 18.5002 5.58969 18.5002 10C18.5002 14.4103 14.9106 18 10.5002 18C6.08993 18 2.50024 14.4103 2.50024 10ZM17.1669 10C17.1669 6.31031 14.1899 3.33333 10.5002 3.33333C6.81056 3.33333 3.83358 6.31031 3.83358 10C3.83358 13.6897 6.81056 16.6667 10.5002 16.6667C14.1899 16.6667 17.1669 13.6897 17.1669 10ZM11.1674 10.6667H13.8341C14.2021 10.6667 14.5008 10.3687 14.5008 10.0001C14.5008 9.63141 14.2021 9.33341 13.8341 9.33341H11.1674V6.66674C11.1674 6.29807 10.8688 6.00007 10.5008 6.00007C10.1328 6.00007 9.83409 6.29807 9.83409 6.66674V9.33341H7.16743C6.79943 9.33341 6.50076 9.63141 6.50076 10.0001C6.50076 10.3687 6.79943 10.6667 7.16743 10.6667H9.83409V13.3334C9.83409 13.7021 10.1328 14.0001 10.5008 14.0001C10.8688 14.0001 11.1674 13.7021 11.1674 13.3334V10.6667Z', fill: color }))));
});


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowBackIcon/index.js
var ArrowBackIcon = __webpack_require__(40468);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRightIcon/index.js
'use client';



var ArrowRightIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.color, color = _e === void 0 ? '#005aff' : _e;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 20 20', onClick: function () { return onClick && onClick(); } },
        react.createElement("g", { id: 'icons/nav/icon-arrow-right/size-xs', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
            react.createElement("polyline", { id: 'Stroke-718', stroke: color, strokeWidth: '1.5', transform: 'translate(10.000000, 10.000000) scale(-1, 1) rotate(180.000000) translate(-10.000000, -10.000000) ', points: '7 4 13 10 7 16' }))));
};
var ArrowRightIcon_index = /*#__PURE__*/ react.memo(ArrowRightIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedLeft/index.js
var ArrowRoundedLeft = __webpack_require__(68996);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedRight/index.js
var ArrowRoundedRight = __webpack_require__(2284);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AwardsIcon/index.js
var AwardsIcon = __webpack_require__(88073);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/BonusIcon/index.js
var BonusIcon = __webpack_require__(27553);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CancelIcon/index.js
'use client';



function CancelIcon() {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '13', height: '13', viewBox: '0 0 13 13', className: '' },
        react.createElement("g", { id: 'MY-JOBS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'CC/MYJOBS-SAVED-APPLYMULTIPLE-CHOOSEFILE', transform: 'translate(-1040.000000, -365.000000)', fill: '#FF0000', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-25', transform: 'translate(190.000000, 267.000000)' },
                    react.createElement("g", { id: 'Group-26', transform: 'translate(562.344262, 0.000000)' },
                        react.createElement("g", { id: 'Group-22', transform: 'translate(0.000000, 62.000000)' },
                            react.createElement("g", { id: 'Group-11', transform: 'translate(244.000000, 28.000000)' },
                                react.createElement("g", { id: 'Group-28', transform: 'translate(36.000000, 0.000000)' },
                                    react.createElement("g", { id: 'icons8-close', transform: 'translate(8.000000, 8.000000)' },
                                        react.createElement("path", { d: 'M0.752398486,0.000327615426 C0.447676997,0.000407642063 0.173386346,0.185108686 0.0587220133,0.467433469 C-0.0559423192,0.749758252 0.0118849522,1.07340821 0.230256049,1.28593881 L4.94270174,5.9983842 L0.230256049,10.7108297 C0.0346299462,10.8986525 -0.0441726876,11.1775583 0.0242395587,11.439983 C0.092651805,11.7024077 0.29758879,11.9073446 0.560013509,11.9757568 C0.822438228,12.044169 1.10134403,11.9653663 1.28916672,11.7697401 L6.00161211,7.05729458 L10.7140577,11.7697401 C10.9018799,11.9653685 11.1807868,12.0441728 11.4432128,11.9757609 C11.7056389,11.907349 11.9105769,11.702411 11.9789888,11.4399849 C12.0474007,11.1775588 11.9685964,10.898652 11.772968,10.7108297 L7.06052249,5.9983842 L11.772968,1.28593881 C11.9944461,1.07065294 12.0610395,0.741480633 11.9406599,0.457035041 C11.8202802,0.172589449 11.5376228,-0.00877712235 11.2288872,0.000327615426 C11.0343388,0.00612451054 10.8496893,0.0874332576 10.7140577,0.22702814 L6.00161211,4.93947383 L1.28916672,0.22702814 C1.14818126,0.0821025075 0.954587359,0.000339401564 0.752398486,0.000327615426 Z', id: 'Path' })))))))))));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CanteenIcon/index.js
var CanteenIcon = __webpack_require__(29683);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CompanySizeIcon/index.js
'use client';



var CompanySizeIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'icons/company-info/size-xl/icon-company-size', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react.createElement("path", { d: 'M18.8800295,9 C16.7675418,9 15.0400516,10.7274902 15.0400516,12.8399779 C15.0400516,14.1099706 15.6650483,15.2399641 16.6200425,15.93996 C16.1075456,16.1974587 15.6400482,16.5299566 15.2400505,16.9399543 C14.7750535,16.7749555 14.280056,16.6799558 13.760059,16.6799558 C11.292573,16.6799558 9.28008478,18.692444 9.28008478,21.15993 C9.28008478,22.7274211 10.0925799,24.1199129 11.320073,24.9199083 C9.36508461,25.8449033 8.00004521,27.8248919 8.00004521,30.1198784 L8.00004521,32.9998618 C7.99759216,33.2048609 8.09509192,33.3973597 8.26009065,33.5198588 C8.26009065,33.5198588 8.71258789,33.8398569 9.58008305,34.0998554 C10.4475782,34.359854 11.7875705,34.5998526 13.760059,34.5998526 C15.7325475,34.5998526 17.0725397,34.359854 17.9400349,34.0998554 C18.0525341,34.0673558 18.1425336,34.0348561 18.2400332,33.999856 L18.2400332,36.8398397 C18.2375334,37.0448388 18.335033,37.2373375 18.5000317,37.3598367 C18.5000317,37.3598367 18.9525289,37.6798348 19.8200241,37.9398333 C20.6875192,38.1998318 22.0275115,38.4398305 24,38.4398305 C25.9724885,38.4398305 27.3124808,38.1998318 28.1799759,37.9398333 C29.0474711,37.6798348 29.4999683,37.3598367 29.4999683,37.3598367 C29.6649677,37.2373375 29.7624667,37.0448388 29.7599668,36.8398397 L29.7599668,33.999856 C29.8574664,34.0348561 29.9474659,34.0673558 30.0599651,34.0998554 C30.9274603,34.359854 32.2674526,34.5998526 34.239941,34.5998526 C36.2124295,34.5998526 37.5524218,34.359854 38.419917,34.0998554 C39.2874121,33.8398569 39.7399094,33.5198588 39.7399094,33.5198588 C39.9049087,33.3973597 40.0024077,33.2048609 39.9999548,32.9998618 L39.9999548,30.1198784 C39.9999548,27.8248919 38.634916,25.8449033 36.679927,24.9199083 C37.9074201,24.1199129 38.7199152,22.7274211 38.7199152,21.15993 C38.7199152,18.692444 36.707427,16.6799558 34.239941,16.6799558 C33.6824441,16.6799558 33.1524471,16.792455 32.6599501,16.979954 C32.2574526,16.5574566 31.782455,16.2049588 31.2599582,15.93996 C32.214953,15.2399641 32.8399491,14.1099706 32.8399491,12.8399779 C32.8399491,10.7274902 31.1124589,9 28.9999712,9 C26.8874835,9 25.1599933,10.7274902 25.1599933,12.8399779 C25.1599933,14.1099706 25.78499,15.2399641 26.7399842,15.93996 C25.2699927,16.6649562 24.1949992,18.0599478 23.9400004,19.7399381 C23.6850021,18.057448 22.6125078,16.6624557 21.1400165,15.93996 C22.0950113,15.2399641 22.7200074,14.1099706 22.7200074,12.8399779 C22.7200074,10.7274902 20.9925172,9 18.8800295,9 Z M18.8800295,10.2799926 C20.3025211,10.2799926 21.4400147,11.4174862 21.4400147,12.8399779 C21.4400147,14.2624695 20.3025211,15.3999631 18.8800295,15.3999631 C17.4575378,15.3999631 16.3200442,14.2624695 16.3200442,12.8399779 C16.3200442,11.4174862 17.4575378,10.2799926 18.8800295,10.2799926 Z M28.9999712,10.2799926 C30.4224629,10.2799926 31.5599565,11.4174862 31.5599565,12.8399779 C31.5599565,14.2624695 30.4224629,15.3999631 28.9999712,15.3999631 C27.5774796,15.3999631 26.439986,14.2624695 26.439986,12.8399779 C26.439986,11.4174862 27.5774796,10.2799926 28.9999712,10.2799926 Z M18.8800295,16.6799558 C21.0375172,16.6799558 22.7200074,18.3624459 22.7200074,20.5199337 L22.7200074,20.7199325 C20.880018,21.2774295 19.5200258,22.9824193 19.5200258,24.9999079 C19.5200258,26.567399 20.332521,27.9598908 21.5600141,28.7598862 C20.7575188,29.139884 20.0700226,29.697381 19.5200258,30.3798769 L19.5200258,30.1198784 C19.5200258,27.8248919 18.155034,25.8449033 16.2000449,24.9199083 C17.427538,24.1199129 18.2400332,22.7274211 18.2400332,21.15993 C18.2400332,19.6999384 17.5275374,18.3999459 16.4400435,17.5799506 C17.10504,17.0124537 17.930035,16.6799558 18.8800295,16.6799558 Z M28.9999712,16.6799558 C29.9774657,16.6799558 30.8274608,17.0224536 31.4999568,17.6199504 C30.4449632,18.4399456 29.7599668,19.7274384 29.7599668,21.15993 C29.7599668,22.7274211 30.572462,24.1199129 31.7999551,24.9199083 C29.8449667,25.8449033 28.4799742,27.8248919 28.4799742,30.1198784 L28.4799742,30.3798769 C27.9299774,29.697381 27.2424812,29.139884 26.439986,28.7598862 C27.667479,27.9598908 28.4799742,26.567399 28.4799742,24.9999079 C28.4799742,22.9374199 27.0649827,21.1949301 25.1599933,20.6799327 L25.1599933,20.5199337 C25.1599933,18.3624459 26.8424835,16.6799558 28.9999712,16.6799558 Z M13.760059,17.9599484 C14.2575563,17.9599484 14.7200534,18.0799477 15.140051,18.2799466 C16.2150452,18.7949439 16.9600405,19.8824372 16.9600405,21.15993 C16.9600405,22.9349201 15.5350491,24.3599115 13.760059,24.3599115 C11.9850695,24.3599115 10.5600774,22.9349201 10.5600774,21.15993 C10.5600774,19.3849405 11.9850695,17.9599484 13.760059,17.9599484 Z M34.239941,17.9599484 C36.0149311,17.9599484 37.4399226,19.3849405 37.4399226,21.15993 C37.4399226,22.9349201 36.0149311,24.3599115 34.239941,24.3599115 C32.4649516,24.3599115 31.0399595,22.9349201 31.0399595,21.15993 C31.0399595,19.9774369 31.6724557,18.954943 32.6199504,18.3999459 C32.6249507,18.397446 32.6349506,18.4024457 32.6399502,18.3999459 C32.73495,18.379946 32.822449,18.3399462 32.8999487,18.2799466 C32.9224485,18.2699466 32.9374487,18.2499467 32.9599484,18.2399468 C32.9724482,18.2349471 32.9874484,18.227447 32.9999482,18.2199469 C33.3824458,18.057448 33.7974437,17.9599484 34.239941,17.9599484 Z M24,21.7999263 C25.7749901,21.7999263 27.1999816,23.2249184 27.1999816,24.9999079 C27.1999816,26.774898 25.7749901,28.1998894 24,28.1998894 C22.2250105,28.1998894 20.8000184,26.774898 20.8000184,24.9999079 C20.8000184,23.2249184 22.2250105,21.7999263 24,21.7999263 Z M13.760059,25.6399042 C16.2275449,25.6399042 18.2400332,27.6523924 18.2400332,30.1198784 L18.2400332,32.5798642 C18.145034,32.637364 18.1075341,32.7023633 17.580037,32.8598626 C16.8475414,33.0798613 15.6275484,33.3198599 13.760059,33.3198599 C11.8925696,33.3198599 10.6725766,33.0798613 9.94008098,32.8598626 C9.41258386,32.7023633 9.37508455,32.637364 9.28008478,32.5798642 L9.28008478,30.1198784 C9.28008478,27.6523924 11.292573,25.6399042 13.760059,25.6399042 Z M34.239941,25.6399042 C36.707427,25.6399042 38.7199152,27.6523924 38.7199152,30.1198784 L38.7199152,32.5798642 C38.6249161,32.637364 38.5874162,32.7023633 38.059919,32.8598626 C37.3274234,33.0798613 36.1074304,33.3198599 34.239941,33.3198599 C32.3724516,33.3198599 31.1524587,33.0798613 30.419963,32.8598626 C29.8924659,32.7023633 29.8549666,32.637364 29.7599668,32.5798642 L29.7599668,30.1198784 C29.7599668,27.6523924 31.7724551,25.6399042 34.239941,25.6399042 Z M24,29.4798821 C26.467486,29.4798821 28.4799742,31.4923703 28.4799742,33.9598563 L28.4799742,36.4198421 C28.3849751,36.4773419 28.3474751,36.5423412 27.819978,36.6998405 C27.0874824,36.9198392 25.8674894,37.1598378 24,37.1598378 C22.1325106,37.1598378 20.9125176,36.9198392 20.180022,36.6998405 C19.6525249,36.5423412 19.6150256,36.4773419 19.5200258,36.4198421 L19.5200258,33.9598563 C19.5200258,31.4923703 21.5325141,29.4798821 24,29.4798821 Z', id: 'Shape', fill: '#555555', fillRule: 'nonzero' }))));
};
var CompanySizeIcon_index = react.memo(CompanySizeIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ContactIcon/index.js
'use client';



var ContactIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'icons/company-info/size-xl/icon-contactus', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react.createElement("path", { d: 'M25.3391918,5 C21.4151713,5 18.3161893,6.15756113 16.2276136,8.297972 C14.1390401,10.4383829 13.1104152,13.5006954 13.1104152,17.130035 C13.1104152,18.3400571 13.5576429,20.4818883 14.009724,22.1825708 C13.6290547,22.2394274 13.2140752,22.3271634 12.7564643,22.4924674 C11.9245156,22.7932165 11.3769524,23.475208 10.9365792,24.1710766 C10.4962061,24.8669444 10.1891675,25.570251 10.0949963,26.2097118 C9.96911559,27.0640229 9.90951698,28.2013155 10.3015943,29.4499582 C10.5130813,30.1237293 10.8029119,31.0130359 11.2829346,32.1402888 C12.3268644,34.5881098 14.0337108,36.5603047 15.5105979,37.9630094 C16.2490399,38.6643622 16.9311433,39.2226367 17.4504915,39.62187 C17.9698398,40.0211024 18.4029547,40.3201855 18.375625,40.29939 L18.377144,40.29939 L18.377144,40.300909 C18.6669614,40.5200938 20.9230104,42.3334682 23.5375362,42.3334682 C26.0452867,42.3334682 27.4717075,40.8694767 27.8502689,40.5181407 C28.2790344,40.1202103 28.4913561,39.667164 28.590072,39.2588043 C30.5579938,38.3042583 32.1534341,36.5963704 33.3190386,34.842773 C34.4101699,33.2012158 35.0727534,31.5926527 35.2938718,30.2960987 C35.8809421,30.0138756 37.6393065,29.0548978 37.9674926,26.2765527 C38.0809746,25.3114717 37.796709,24.4952991 37.4190966,23.9204243 C37.1918159,23.5744131 36.9695604,23.4453645 36.7370196,23.2474621 C37.2828349,21.5127812 37.999394,18.8336452 37.999394,15.8889282 C37.999394,14.5355107 37.7189512,12.686923 36.8038605,11.0764108 C35.9462656,9.56708958 34.3976181,8.32583677 32.2009791,8.17036737 C31.2054767,6.65045282 29.0448987,5 25.3391918,5 Z M25.3391918,6.55556117 C28.8357916,6.55556117 30.5050573,8.18175727 31.0935533,9.26108308 C31.2299245,9.51128993 31.4921922,9.66690218 31.7771493,9.66668352 C33.6773225,9.66668352 34.7283965,10.5744949 35.4503395,11.8450768 C36.1722824,13.115659 36.4438328,14.7666702 36.4438328,15.8889282 C36.4438328,18.7723335 35.6641482,21.6034043 35.1358851,23.2216367 C35.0247124,23.5624449 35.1608495,23.9350961 35.4655311,24.1239843 C35.5995707,24.2071407 35.9015494,24.4435036 36.1187447,24.7741599 C36.3359399,25.1048162 36.4910846,25.5130771 36.4225652,26.0957794 C36.1257252,28.602196 34.3763341,29.0975264 34.3763341,29.0975264 C34.0900593,29.1958088 33.8867904,29.4512283 33.8552818,29.7522597 C33.7650966,30.6116023 33.1035919,32.3561082 32.0232437,33.9814417 C31.1272802,35.3293774 29.9447838,36.6136464 28.6341255,37.4495529 C28.6163447,37.3256229 28.5860384,37.1860012 28.5141171,37.0317999 C28.3262076,36.6289181 27.9367138,36.3207646 27.3960575,36.0929939 L27.3945377,36.0929939 C26.9355336,35.8996462 26.1518504,35.5745292 25.453125,35.2833126 C25.1037615,35.1377043 24.7761417,35.0013749 24.5234338,34.8944223 C24.2732272,34.7885501 24.0595265,34.6918828 24.0783364,34.7014962 L24.0737794,34.6999772 C23.7514321,34.5376738 23.1387759,34.3814768 22.5820203,34.6619997 C22.3026641,34.8027554 22.0036627,34.932686 21.6644827,35.2271055 C21.4252622,35.4347574 21.0990587,35.6805034 20.825938,35.9577938 L20.824419,35.9593136 C20.7864166,35.9979608 20.8127452,35.9775012 20.7909985,35.9957713 C20.3351366,35.7244542 18.9780308,34.8643549 17.8971079,33.6366049 L17.8955889,33.6366049 C17.1683804,32.8116799 16.6989455,32.05782 16.3810432,31.4551738 C16.063141,30.8525268 15.9230137,30.4452778 15.7582113,30.1122866 C15.7055634,30.005915 15.7163504,30.0293122 15.7141571,30.0256978 C16.0205987,29.7564551 17.0630425,28.8733241 17.3882084,28.653948 C17.7312618,28.4225046 18.0216687,28.024974 18.0672474,27.6224779 C18.1128254,27.2199812 17.9945016,26.9410045 17.9122988,26.7125353 C17.7833575,26.3509171 17.4971599,25.7637216 17.1740147,25.0855762 C16.8505062,24.4066671 16.5199743,23.7297818 16.4023109,23.4920376 C16.2046045,23.0925625 16.1595967,22.7102701 15.6731416,22.3663822 C15.2078359,20.7045287 14.6659764,17.9674263 14.6659764,17.130035 C14.6659764,13.7912384 15.5907606,11.1779282 17.3411162,9.38413046 C19.0914725,7.5903326 21.7164081,6.55556117 25.3391918,6.55556117 Z M31.3472435,12.4770233 C31.3396334,12.477924 31.3320371,12.478937 31.3244569,12.4800621 C31.3214186,12.4800443 31.3183803,12.4800443 31.3153421,12.4800621 C31.3046779,12.4813607 31.2940418,12.48288 31.2834406,12.4846191 C31.2773525,12.4855596 31.2712758,12.4865723 31.2652118,12.4876572 C31.2437845,12.4908181 31.2224986,12.4948725 31.2014097,12.49981 C31.1978579,12.5007974 31.1943132,12.5018101 31.1907758,12.502848 C30.9576308,12.5615266 30.7647205,12.7247154 30.6682045,12.9449074 C30.6571211,12.9676574 30.3434796,13.6220859 29.4407695,14.3637487 C28.5225257,15.1181586 27.0679531,15.8889282 24.777124,15.8889282 C23.3188826,15.8889282 21.5030769,15.8994749 19.9281482,16.4692257 C19.1406842,16.7541026 18.398295,17.1939103 17.8545727,17.877434 C17.3108504,18.5609569 16.99924,19.4740736 16.99924,20.5556117 C16.9953512,20.8361074 17.1427217,21.0970103 17.3849984,21.2384158 C17.6272752,21.3798212 17.9269223,21.3798212 18.169199,21.2384158 C18.4114758,21.0970103 18.5588462,20.8361074 18.5548793,20.5556117 C18.5548793,19.7572542 18.7561962,19.2447473 19.0728936,18.8466209 C19.3895911,18.4484952 19.8559227,18.1494962 20.4567955,17.9321213 C21.6585451,17.4973715 23.3420216,17.4444894 24.777124,17.4444894 C27.4252017,17.4444894 29.2755954,16.5138423 30.4281861,15.5668788 C30.8335109,15.2338643 31.0639587,14.9303891 31.3153421,14.6280728 C31.9850905,15.6209696 33.3327105,17.8022008 33.3327105,20.5556117 C33.3287436,20.8361074 33.476114,21.0970103 33.7183908,21.2384158 C33.9606675,21.3798212 34.2603146,21.3798212 34.5025914,21.2384158 C34.7448681,21.0970103 34.8922386,20.8361074 34.8883498,20.5556117 C34.8883498,16.5119305 32.3378085,13.250341 32.1174283,12.972251 C32.0009781,12.6736602 31.7133112,12.4770576 31.392816,12.4770233 C31.3776285,12.4765783 31.3624311,12.4765783 31.3472435,12.4770233 Z M14.7480081,23.6728101 C14.748509,23.7117575 14.8513269,23.8625598 15.0092934,24.1817096 C15.1187419,24.402856 15.4508433,25.0834412 15.7703641,25.7539814 C16.089885,26.4245216 16.426503,27.1765818 16.4478841,27.2366257 L16.4478841,27.2381447 L16.4494032,27.2381447 C16.4967233,27.3696619 16.4921033,27.3641685 16.4980144,27.3809405 C15.9176369,27.7766449 14.9760409,28.6012627 14.6614194,28.8787756 L14.6599004,28.8802946 C14.4241037,29.0888137 14.1935828,29.4163783 14.1479621,29.7963132 C14.1023452,30.1762482 14.2172312,30.5029985 14.3651938,30.8019594 C14.4275018,30.9278595 14.6403306,31.4905021 15.0047364,32.1813051 C15.3691421,32.8721072 15.9106758,33.736846 16.7289181,34.6650377 C18.0265275,36.1389078 19.5701941,37.0873132 20.0587912,37.375117 C20.4257761,37.5912863 20.9173272,37.6541683 21.2755924,37.5194318 C21.63331,37.3849014 21.8160589,37.1694414 21.9333637,37.0500288 C22.0678,36.9135407 22.3925747,36.6556855 22.6838007,36.4028912 C22.875067,36.2368654 22.9550517,36.2145936 23.2808079,36.0504594 C23.3272103,36.0270793 23.2421834,36.0211199 23.3749925,36.0884369 L23.3765115,36.0899559 L23.3780305,36.0899559 C23.5153345,36.1586106 23.6593584,36.2177631 23.9173117,36.3269363 C24.175265,36.4361087 24.5041534,36.5728052 24.854598,36.7188646 C25.5554887,37.0109834 26.3420108,37.3377073 26.7914544,37.5270268 C27.1351331,37.6718146 27.1276018,37.7393407 27.1043898,37.6895713 C27.0815386,37.6405867 27.0825816,37.6247425 27.0952749,37.8794594 C27.0952749,37.8794594 27.0952749,37.8809784 27.0952749,37.8809784 C27.0952749,37.8809784 27.0952749,37.8824974 27.0952749,37.8824974 C27.1066235,38.1293736 27.1104658,38.423776 27.1104658,38.7225612 C27.1104658,38.8368646 27.0696323,39.119118 26.7914544,39.3772945 C26.261568,39.8690727 25.4942463,40.777907 23.5375362,40.777907 C21.6886732,40.777907 19.636111,39.3022566 19.3174691,39.0613212 L19.3159501,39.0598021 C19.137395,38.9240452 18.8849818,38.7612262 18.3999306,38.3883582 C17.9139733,38.0147933 17.2716129,37.489705 16.5815652,36.8343168 C15.2015048,35.523576 13.6346734,33.6885832 12.7139294,31.5296097 C12.2606154,30.465077 11.9927166,29.6429388 11.7857576,28.983594 C11.4871657,28.0326724 11.5263939,27.1668276 11.6338474,26.4375774 C11.6695654,26.1950359 11.9100846,25.5401058 12.250603,25.0020255 C12.5911217,24.4639452 13.0585012,24.0372828 13.285112,23.9553638 C13.7480204,23.7881456 14.1804142,23.7046486 14.4927989,23.6773679 C14.6054184,23.6675313 14.6795759,23.6701843 14.7480081,23.6728101 Z M21.2771114,24.4445147 C20.633109,24.4445147 20.1104405,24.9671832 20.1104405,25.6111856 C20.1104405,26.2551879 20.633109,26.7778564 21.2771114,26.7778564 C21.9211137,26.7778564 22.4437823,26.2551879 22.4437823,25.6111856 C22.4437823,24.9671832 21.9211137,24.4445147 21.2771114,24.4445147 Z M29.8326978,24.4445147 C29.1886955,24.4445147 28.666027,24.9671832 28.666027,25.6111856 C28.666027,26.2551879 29.1886955,26.7778564 29.8326978,26.7778564 C30.4767002,26.7778564 30.9993687,26.2551879 30.9993687,25.6111856 C30.9993687,24.9671832 30.4767002,24.4445147 29.8326978,24.4445147 Z', id: 'Shape', fill: '#555555', fillRule: 'nonzero' }))));
};
var ContactIcon_index = react.memo(ContactIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CopyIcon/index.js
var CopyIcon = __webpack_require__(708);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DefaultCompanyLogo/index.js
'use client';



var DefaultCompanyLogo = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b;
    return (react.createElement("svg", { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_5240_18652)' },
            react.createElement("rect", { width: 24, height: 24, rx: 4, fill: '#D9E6FF' }),
            react.createElement("g", { clipPath: 'url(#clip1_5240_18652)' },
                react.createElement("path", { d: 'M12.8483 6.94835C14.5906 6.94835 16.0031 8.36083 16.0031 10.1032V25.2899H6.35822V7.79838C6.35822 6.0062 7.81106 4.55336 9.60324 4.55336H10.4533C11.776 4.55336 12.8483 5.62563 12.8483 6.94835Z', fill: 'url(#paint0_linear_5240_18652)' }),
                react.createElement("path", { d: 'M7.32704 13.0666C7.77759 12.7395 8.40901 13.0614 8.40901 13.6181V27.6526H-1.05557V20.6171H1.01732V17.647L7.32704 13.0666Z', fill: 'url(#paint1_linear_5240_18652)' }),
                react.createElement("path", { d: 'M27.706 17.9345V27.6526H18.3315V17.9345C19.1283 17.9345 19.7742 17.2887 19.7742 16.4919V14.5179C19.7742 13.9706 20.2178 13.527 20.7651 13.527V11.9151C20.7651 11.2179 21.3302 10.6528 22.0274 10.6528C22.1715 9.53891 23.7889 9.5373 23.9199 10.6528H25.2724V13.527H26.2642V17.9345H27.706Z', fill: 'url(#paint2_linear_5240_18652)' }),
                react.createElement("path", { d: 'M11.8415 16.3209C11.8415 14.3544 13.4356 12.7603 15.4021 12.7603C17.3686 12.7603 18.9627 14.3544 18.9627 16.3209V24.092C18.9627 26.0585 17.3686 27.6526 15.4021 27.6526C13.4356 27.6526 11.8415 26.0585 11.8415 24.092V16.3209Z', fill: 'url(#paint3_linear_5240_18652)' }),
                react.createElement("path", { d: 'M4.18491 18.429C4.18491 18.2052 4.36636 18.0237 4.5902 18.0237C4.81404 18.0237 4.9955 18.2052 4.9955 18.429V26.6656C4.9955 26.8895 4.81404 27.0709 4.5902 27.0709C4.36636 27.0709 4.18491 26.8895 4.18491 26.6656V18.429Z', fill: 'url(#paint4_linear_5240_18652)' }),
                react.createElement("path", { d: 'M2.50745 18.429C2.50745 18.2052 2.6889 18.0237 2.91274 18.0237C3.13658 18.0237 3.31804 18.2052 3.31804 18.429V26.6656C3.31804 26.8895 3.13658 27.0709 2.91274 27.0709C2.6889 27.0709 2.50745 26.8895 2.50745 26.6656V18.429Z', fill: 'url(#paint5_linear_5240_18652)' }),
                react.createElement("path", { d: 'M5.98721 18.4295C5.98721 18.2054 6.16887 18.0237 6.39295 18.0237C6.61703 18.0237 6.79869 18.2054 6.79869 18.4295V26.6652C6.79869 26.8893 6.61703 27.0709 6.39295 27.0709C6.16887 27.0709 5.98721 26.8893 5.98721 26.6652V18.4295Z', fill: 'url(#paint6_linear_5240_18652)' }))),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'paint0_linear_5240_18652', x1: 11.1807, y1: 4.55336, x2: 11.1957, y2: 30.83, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#689DFF' }),
                react.createElement("stop", { offset: 0.560316, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint1_linear_5240_18652', x1: 3.67672, y1: 12.2811, x2: 3.67101, y2: 43.8735, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#689DFF' }),
                react.createElement("stop", { offset: 0.662716, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint2_linear_5240_18652', x1: 23.0187, y1: 2.98769, x2: 18.1543, y2: 33.1656, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { offset: 0.134948, stopColor: '#689DFF' }),
                react.createElement("stop", { offset: 0.834247, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint3_linear_5240_18652', x1: 15.4021, y1: 12.7603, x2: 15.4031, y2: 38.751, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { offset: 0.0285672, stopColor: '#689DFF' }),
                react.createElement("stop", { offset: 1, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint4_linear_5240_18652', x1: 4.5902, y1: 18.0237, x2: 4.5902, y2: 27.0709, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#0048CE' }),
                react.createElement("stop", { offset: 1, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint5_linear_5240_18652', x1: 2.91274, y1: 18.0237, x2: 2.91274, y2: 27.0709, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#0048CE' }),
                react.createElement("stop", { offset: 1, stopColor: '#004AD2' })),
            react.createElement("linearGradient", { id: 'paint6_linear_5240_18652', x1: 6.39295, y1: 18.0237, x2: 6.39295, y2: 27.0709, gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#0048CE' }),
                react.createElement("stop", { offset: 1, stopColor: '#004AD2' })),
            react.createElement("clipPath", { id: 'clip0_5240_18652' },
                react.createElement("rect", { width: 24, height: 24, rx: 4, fill: 'white' })),
            react.createElement("clipPath", { id: 'clip1_5240_18652' },
                react.createElement("rect", { width: 56.1493, height: 24.7589, fill: 'white', transform: 'translate(-5.55225 2.94071)' })))));
};
var DefaultCompanyLogoUrl = 'https://images.vietnamworks.com/img/company-default-logo.svg';


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DangerIcon/index.js
'use client';



var DangerIcon_DangerIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M10.0001 1.66663C7.76609 1.66663 5.73911 2.55607 4.24108 3.99274C4.13795 4.05268 4.052 4.13816 3.99151 4.24095C2.5552 5.73892 1.66675 7.7663 1.66675 9.99996C1.66675 14.5941 5.40593 18.3333 10.0001 18.3333C12.2293 18.3333 14.2525 17.4479 15.7496 16.0167C15.861 15.9542 15.9529 15.8622 16.0154 15.7508C17.4474 14.2536 18.3334 12.2298 18.3334 9.99996C18.3334 5.40581 14.5942 1.66663 10.0001 1.66663ZM10.0001 3.05551C13.8436 3.05551 16.9445 6.15642 16.9445 9.99996C16.9445 11.6711 16.3578 13.2007 15.3793 14.3972L5.60284 4.62073C6.79934 3.6422 8.32899 3.05551 10.0001 3.05551ZM4.62085 5.60272L14.3973 15.3792C13.2008 16.3577 11.6712 16.9444 10.0001 16.9444C6.15655 16.9444 3.05564 13.8435 3.05564 9.99996C3.05564 8.32887 3.64232 6.79922 4.62085 5.60272Z', fill: '#888888' })));
};
var DangerIcon_index = react.memo(DangerIcon_DangerIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ExternalLinkIcon/index.js
'use client';



var ExternalLinkIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'JOB-DETAIL-COMPANY', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'PAGES/JOB-DETAIL/JD-CLP-FINAL', transform: 'translate(-407.000000, -524.000000)', fill: '#005aff', fillRule: 'nonzero' },
                react.createElement("g", { id: 'Group-45', transform: 'translate(203.000000, 524.000000)' },
                    react.createElement("g", { id: 'Shape', transform: 'translate(204.000000, 0.000000)' },
                        react.createElement("path", { d: 'M16.035041,0 C15.7706655,0.0243750864 15.575665,0.260625787 15.6000399,0.525001343 C15.6244149,0.7893769 15.8606657,0.984377399 16.1250413,0.960002456 L22.3500572,0.960002456 L12.3300315,10.9950281 C12.1875312,11.1112787 12.1219059,11.2969038 12.1631562,11.4769042 C12.2044061,11.6550298 12.3450316,11.7956553 12.5231572,11.8369052 C12.7031576,11.8781555 12.8887832,11.8125302 13.0050333,11.6700299 L23.040059,1.65000422 L23.040059,7.87502015 C23.0381841,8.04752059 23.1281843,8.20877124 23.2781847,8.29689611 C23.4281851,8.38314657 23.6119353,8.38314657 23.7619357,8.29689611 C23.9119361,8.20877124 24.0019363,8.04752059 24.0000901,7.87502015 L24.0000901,0 L16.1250413,0 C16.1100412,0 16.0950412,0 16.0800411,0 C16.0650411,0 16.0500411,0 16.035041,0 Z M0.960002456,4.79998355 C0.708752053,4.79998355 0.451876036,4.88813763 0.270000691,5.07001297 C0.0881253455,5.25188832 0,5.50876433 0,5.76001474 L0,23.040059 C0,23.2913098 0.0881253455,23.5481854 0.270000691,23.7300607 C0.451876036,23.9119361 0.708752053,24.0000614 0.960002456,24.0000614 L18.2400467,24.0000614 C18.4912976,24.0000614 18.7481731,23.9119361 18.9300484,23.7300607 C19.1119238,23.5481854 19.2000779,23.2913098 19.2000779,23.040059 L19.2000779,8.64002211 C19.201924,8.46752167 19.1119238,8.30627149 18.9619234,8.21814615 C18.811923,8.13189569 18.6281728,8.13189569 18.4781724,8.21814615 C18.328172,8.30627149 18.2381718,8.46752167 18.2400467,8.64002211 L18.2400467,23.040059 L0.960002456,23.040059 L0.960002456,5.76001474 L15.3600393,5.76001474 C15.5325397,5.76188962 15.6937904,5.67188939 15.7819153,5.52188901 C15.8681657,5.37188862 15.8681657,5.18813839 15.7819153,5.03813801 C15.6937904,4.88813763 15.5325397,4.7981374 15.3600393,4.79998355 L0.960002456,4.79998355 Z' })))))));
};
var ExternalLinkIcon_index = react.memo(ExternalLinkIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/EyesCloseIcon/index.js
var EyesCloseIcon = __webpack_require__(2237);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/FacebookIcon/index.js
var Images_FacebookIcon = __webpack_require__(66887);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ForwardIcon/index.js
'use client';



var ForwardIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.8309 3.00015C13.3993 3.00638 13.0527 3.35801 13.0527 3.78963V7.88711C11.6539 8.04314 9.35422 8.44403 7.0391 9.94305C4.41054 11.645 2.07378 14.7741 2.01953 19.94C2.01874 19.944 2.0162 19.9464 2.01542 19.9503H2.01748C2.01691 20.0071 2 20.0482 2 20.1055C2.00043 20.5111 2.30801 20.8503 2.71156 20.8904C3.11511 20.9305 3.48338 20.6583 3.56354 20.2608C4.18846 17.1364 6.13644 15.7518 8.29528 15.0418C10.1174 14.4425 11.9013 14.4423 13.0527 14.5031V18.5266C13.0528 18.8458 13.2452 19.1336 13.5401 19.2557C13.8351 19.3779 14.1746 19.3104 14.4004 19.0848L21.7689 11.7163C22.077 11.408 22.077 10.9082 21.7689 10.5999L14.4004 3.23144C14.2496 3.08059 14.0442 2.99716 13.8309 3.00015ZM14.6317 5.69548L20.0943 11.1581L14.6317 16.6207V13.7291C14.6318 13.3216 14.3219 12.9809 13.9162 12.9427C12.8194 12.84 10.3104 12.7169 7.80185 13.542C6.62989 13.9274 5.46604 14.5762 4.46712 15.5033C5.26664 13.5485 6.49779 12.1754 7.89745 11.2691C10.1996 9.77853 12.8449 9.41625 13.8998 9.3386C14.3123 9.3084 14.6317 8.96487 14.6317 8.55118V5.69548Z', fill: '#333333' })));
};
var ForwardIcon_index = react.memo(ForwardIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/HealthcarePlanIcon/index.js
var HealthcarePlanIcon = __webpack_require__(82999);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/HeartIcon/index.js
'use client';



var HeartIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 20, height: height !== null && height !== void 0 ? height : 20, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M4.36328 0.666626C1.95328 0.666626 0 2.61991 0 5.02991C0 9.22484 4.86598 13.2332 7.13932 15.0182C7.14149 15.0199 7.14366 15.0217 7.14583 15.0234C7.16141 15.0356 7.18259 15.053 7.19792 15.0651L7.19922 15.0638C7.42987 15.238 7.71091 15.3326 8 15.3333C8.28953 15.3329 8.57108 15.2383 8.80208 15.0638V15.0651C8.80657 15.0615 8.8132 15.0569 8.81771 15.0533C8.82114 15.0507 8.82599 15.0469 8.82943 15.0442C8.83379 15.0404 8.83813 15.0364 8.84245 15.0325C11.1087 13.2539 16 9.23485 16 5.02991C16 2.61991 14.0467 0.666626 11.6367 0.666626C9.33339 0.666626 8 2.66663 8 2.66663C8 2.66663 6.66662 0.666626 4.36328 0.666626Z', fill: color !== null && color !== void 0 ? color : '#669CFF' })));
};
var HeartIcon_index = react.memo(HeartIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/HeartOutlineIcon/index.js
'use client';



var HeartOutlineIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 20, height: height !== null && height !== void 0 ? height : 20, viewBox: '0 0 18 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M5.36326 0C2.59303 0 0.333313 2.25972 0.333313 5.02995C0.333313 7.5221 2.26701 10.0565 4.10675 12.0794C5.94649 14.1024 7.78123 15.5794 7.78123 15.5794C7.7868 15.5839 7.79244 15.5882 7.79816 15.5924C8.09518 15.8168 8.46784 15.9626 8.87237 15.9896C8.91448 15.9971 8.95721 16.0006 8.99998 16C9.04232 16.0005 9.08461 15.9971 9.12628 15.9896C9.12845 15.9892 9.13062 15.9887 9.13279 15.9883C9.53526 15.9603 9.90608 15.8158 10.2018 15.5924C10.2075 15.5882 10.2132 15.5839 10.2187 15.5794C10.2187 15.5794 12.0535 14.1024 13.8932 12.0794C15.7329 10.0565 17.6666 7.5221 17.6666 5.02995C17.6666 2.25972 15.4069 0 12.6367 0C10.894 0 9.65994 0.959033 8.99998 1.63802C8.34002 0.959033 7.10595 0 5.36326 0ZM5.36326 1.33333C7.18406 1.33333 8.29186 2.8283 8.40232 2.98307C8.45876 3.09171 8.54402 3.18272 8.64875 3.24611C8.75348 3.3095 8.87365 3.34283 8.99607 3.34245C9.00128 3.34251 9.00649 3.34251 9.0117 3.34245C9.01691 3.34208 9.02212 3.34164 9.02732 3.34115C9.04429 3.34049 9.06123 3.33919 9.0781 3.33724C9.18644 3.32535 9.29021 3.28709 9.38033 3.2258C9.47044 3.16451 9.54416 3.08206 9.59503 2.98568C9.69994 2.83834 10.8107 1.33333 12.6367 1.33333C14.6865 1.33333 16.3333 2.98018 16.3333 5.02995C16.3333 6.76513 14.6665 9.24674 12.9062 11.1823C11.152 13.1113 9.40516 14.5203 9.39321 14.5299C9.27614 14.6171 9.14604 14.6667 8.99998 14.6667C8.85391 14.6667 8.72382 14.6171 8.60675 14.5299C8.5948 14.5203 6.848 13.1113 5.09373 11.1823C3.33347 9.24674 1.66665 6.76513 1.66665 5.02995C1.66665 2.98018 3.31349 1.33333 5.36326 1.33333Z', fill: color !== null && color !== void 0 ? color : '#669CFF' })));
};
var HeartOutlineIcon_index = react.memo(HeartOutlineIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/HideIcon/index.js
var HideIcon = __webpack_require__(98616);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/HyperLinkIcon/index.js
'use client';



var HyperLinkIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1' },
        react.createElement("g", { id: '\u27A4-Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Exit-Popups-/-Attach-CV-01-1', transform: 'translate(-513.000000, -264.000000)' },
                react.createElement("g", { id: 'organism-/-exit-popup-/-desktop-/-Job-Alert-03', transform: 'translate(283.000000, 129.000000)' },
                    react.createElement("g", { id: 'Job-Alert', transform: 'translate(223.000000, 20.000000)' },
                        react.createElement("g", { id: 'Stacked-Group', transform: 'translate(0.000000, 81.000000)' },
                            react.createElement("g", { id: 'atom-/-bar-/-desktop-/-field', transform: 'translate(0.000000, 26.000000)' },
                                react.createElement("rect", { id: 'Background', stroke: '#D9F5FD', fill: '#F1F9FF', x: '0.5', y: '0.5', width: '270', height: '39', rx: '4' }),
                                react.createElement("g", { id: 'atom-/-ic-/-Pencil-Thin', transform: 'translate(7.000000, 8.000000)' },
                                    react.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                                    react.createElement("path", { d: 'M16.5714286,4 C15.655619,4 14.7949406,4.35684526 14.1473215,5.0044643 L12.2425596,6.90922629 C11.6920834,7.45970248 11.3518095,8.16407162 11.2619048,8.92559543 C11.2462857,9.05969067 11.2380952,9.19619048 11.2380952,9.33333333 C11.2380952,9.85447619 11.3575893,10.3568632 11.576637,10.8132442 L12.1577379,10.2313989 C12.0560236,9.94644648 12,9.64457143 12,9.33333333 C12,8.62095238 12.2776309,7.95191657 12.7812499,7.44791657 L14.6860118,5.54315474 C15.1900118,5.0395357 15.8590476,4.76190476 16.5714286,4.76190476 C17.2838095,4.76190476 17.9528453,5.0395357 18.4568453,5.54315474 C18.9608453,6.04677383 19.2380952,6.71619048 19.2380952,7.42857143 C19.2380952,8.14095238 18.9604644,8.80998819 18.4568453,9.31398819 L16.5520834,11.2187501 C16.0480834,11.7223691 15.3790476,12 14.6666667,12 C14.3554286,12 14.0535535,11.9439764 13.7686011,11.8422621 L13.1867558,12.423363 C13.6431368,12.6424107 14.1455238,12.7619048 14.6666667,12.7619048 C15.5824762,12.7619048 16.4431547,12.4050594 17.0907737,11.7574404 L18.9955356,9.85267848 C19.6431547,9.20505943 20,8.34438095 20,7.42857143 C20,6.5127619 19.6431547,5.65208331 18.9955356,5.0044643 C18.3479166,4.35684522 17.4872381,4 16.5714286,4 Z M14.2782739,9.32961295 C14.179303,9.33256202 14.0853678,9.37392559 14.0163691,9.44494057 L9.44494057,14.0163691 C9.34542027,14.1119183 9.30533081,14.2538042 9.34013341,14.3873059 C9.374936,14.5208077 9.47919234,14.625064 9.61269408,14.6598666 C9.74619581,14.6946692 9.88808169,14.6545797 9.98363086,14.5550594 L14.5550594,9.98363086 C14.6677301,9.87411035 14.7016076,9.70665334 14.6403679,9.56194977 C14.5791282,9.4172462 14.4353343,9.32498114 14.2782739,9.32961295 L14.2782739,9.32961295 Z M9.33333333,11.2380952 C8.41752381,11.2380952 7.55684533,11.5949406 6.90922629,12.2425596 L5.0044643,14.1473215 C4.40865474,14.7427501 4.0588869,15.5187916 4.00669642,16.3519345 C4.00212499,16.4246964 4,16.4979048 4,16.5714286 C4,17.4872381 4.35684526,18.3479166 5.0044643,18.9955356 C5.65208331,19.6431547 6.5127619,20 7.42857143,20 C8.34438095,20 9.20505943,19.6431547 9.85267848,18.9955356 L11.7574404,17.0907737 C12.4050594,16.4431547 12.7619048,15.5824762 12.7619048,14.6666667 C12.7619048,14.1455238 12.6424107,13.6431368 12.423363,13.1867558 L11.8422621,13.7686011 C11.9439764,14.0535535 12,14.3554286 12,14.6666667 C12,15.3790476 11.7223691,16.0480834 11.2187501,16.5520834 L9.31398819,18.4568453 C8.80998819,18.9604644 8.14095238,19.2380952 7.42857143,19.2380952 C6.71619048,19.2380952 6.04715478,18.9604644 5.54315474,18.4568453 C5.03915474,17.9532263 4.76190476,17.2838095 4.76190476,16.5714286 C4.76190476,15.8590476 5.0395357,15.1900118 5.54315474,14.6860118 L7.44791657,12.7812499 C7.95191657,12.2776309 8.62095238,12 9.33333333,12 C9.64457143,12 9.94644648,12.0560236 10.2313989,12.1577379 L10.8132442,11.576637 C10.3568632,11.3575893 9.85447619,11.2380952 9.33333333,11.2380952 Z', id: 'Hyperlink-Thin', fill: '#005AFF' }))))))))));
};
var HyperLinkIcon_index = /*#__PURE__*/ react.memo(HyperLinkIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/KindergartenIcon/index.js
var KindergartenIcon = __webpack_require__(21835);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LaptopIcon/index.js
var LaptopIcon = __webpack_require__(66074);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LibraryIcon/index.js
var LibraryIcon = __webpack_require__(51785);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/LinkIcon/index.js
'use client';



var LinkIcon = function () {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17.3846 2C16.1515 2 14.9937 2.48062 14.1214 3.35216L12.5829 4.89062C11.7114 5.76293 11.2308 6.92077 11.2308 8.15385C11.2308 9.12636 11.5334 10.0492 12.0871 10.8251L10.8251 12.0871C10.0491 11.5337 9.12577 11.2308 8.15385 11.2308C6.92077 11.2308 5.76293 11.7114 4.89062 12.5829L3.35216 14.1214C2.48062 14.9937 2 16.1515 2 17.3846C2 18.6177 2.48062 19.7755 3.35216 20.6478C4.2237 21.5201 5.38231 22 6.61538 22C7.84846 22 9.0063 21.5194 9.87861 20.6478L11.4171 19.1094C12.2886 18.2371 12.7692 17.0792 12.7692 15.8462C12.7692 15.4223 12.7087 15.0089 12.5995 14.6112L11.2157 15.9949C11.1804 16.7326 10.8909 17.4593 10.3293 18.0216L8.79087 19.5601C7.59087 20.7601 5.63913 20.7601 4.4399 19.5601C3.24067 18.3601 3.2399 16.4084 4.4399 15.2091L5.97837 13.6707C6.57837 13.0707 7.36689 12.7722 8.15535 12.7722C8.69517 12.7722 9.22972 12.9224 9.70883 13.2034L7.60998 15.3023C7.40902 15.4952 7.32807 15.7817 7.39835 16.0513C7.46862 16.3209 7.67914 16.5314 7.94871 16.6017C8.21828 16.6719 8.50478 16.591 8.69772 16.39L16.39 8.69772C16.6175 8.47657 16.6859 8.13843 16.5623 7.84624C16.4386 7.55406 16.1483 7.36775 15.8311 7.3771C15.6313 7.38306 15.4416 7.46658 15.3023 7.60998L13.2034 9.70883C12.5102 8.52951 12.6594 6.98901 13.6707 5.97837L15.2091 4.4399C15.8091 3.8399 16.5962 3.54147 17.3846 3.54147C18.1731 3.54147 18.9601 3.84067 19.5601 4.4399C20.7601 5.6399 20.7601 7.59163 19.5601 8.79087L18.0216 10.3293C17.4601 10.8909 16.7326 11.1804 15.9949 11.2157L14.6112 12.5995C15.0089 12.7087 15.4223 12.7692 15.8462 12.7692C17.0792 12.7692 18.2371 12.2886 19.1094 11.4171L20.6478 9.87861C21.5194 9.0063 22 7.84846 22 6.61538C22 5.38231 21.5194 4.22447 20.6478 3.35216C19.7755 2.48062 18.6177 2 17.3846 2Z', fill: '#333333' })));
};
var LinkIcon_index = react.memo(LinkIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/LinkedInIcon/index.js
var LinkedInIcon = __webpack_require__(10545);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/LoadingCircleIcon/index.js
'use client';





var LoadingCircleIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(LoadingCircleIcon_templateObject_1 || (LoadingCircleIcon_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: ", "px;\n    height: ", "px;\n    svg {\n        position: relative;\n        margin: 0;\n        left: -6px;\n        top: -6px;\n        width: ", "px;\n        height: ", "px;\n    }\n"], ["\n    width: ", "px;\n    height: ", "px;\n    svg {\n        position: relative;\n        margin: 0;\n        left: -6px;\n        top: -6px;\n        width: ", "px;\n        height: ", "px;\n    }\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width + 12;
}, function (_a) {
    var height = _a.height;
    return height + 12;
});
var LoadingCircleIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b;
    return (react.createElement(LoadingCircleIconWrapper, { width: width, height: height },
        react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid' },
            react.createElement("circle", { cx: 75, cy: 50, fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.9166666666666666s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.9166666666666666s' })),
            react.createElement("circle", { cx: '71.65063509461098', cy: '62.5', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.8333333333333334s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.8333333333333334s' })),
            react.createElement("circle", { cx: '62.5', cy: '71.65063509461096', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.75s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.75s' })),
            react.createElement("circle", { cx: 50, cy: 75, fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.6666666666666666s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.6666666666666666s' })),
            react.createElement("circle", { cx: '37.50000000000001', cy: '71.65063509461098', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.5833333333333334s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.5833333333333334s' })),
            react.createElement("circle", { cx: '28.34936490538903', cy: '62.5', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.5s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.5s' })),
            react.createElement("circle", { cx: 25, cy: 50, fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.4166666666666667s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.4166666666666667s' })),
            react.createElement("circle", { cx: '28.34936490538903', cy: '37.50000000000001', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.3333333333333333s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.3333333333333333s' })),
            react.createElement("circle", { cx: '37.499999999999986', cy: '28.34936490538904', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.25s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.25s' })),
            react.createElement("circle", { cx: '49.99999999999999', cy: 25, fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.16666666666666666s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.16666666666666666s' })),
            react.createElement("circle", { cx: '62.5', cy: '28.349364905389034', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '-0.08333333333333333s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '-0.08333333333333333s' })),
            react.createElement("circle", { cx: '71.65063509461096', cy: '37.499999999999986', fill: '#ffc3b0', r: 5 },
                react.createElement("animate", { attributeName: 'r', values: '3;3;5;3;3', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', repeatCount: 'indefinite', begin: '0s' }),
                react.createElement("animate", { attributeName: 'fill', values: '#ffc3b0;#ffc3b0;#ff7d55;#ffc3b0;#ffc3b0', repeatCount: 'indefinite', 
                    // @ts-ignore
                    times: '0;0.1;0.2;0.3;1', dur: '1s', begin: '0s' })))));
};
var LoadingCircleIcon_templateObject_1;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/MarkerIcon/index.js
'use client';



var MarkerIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 48 48', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'icons/company-info/size-xl/icon-location', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("rect", { id: 'Rectangle', x: '0', y: '0', width: '48', height: '48' }),
            react.createElement("path", { d: 'M24,7 C18.877604,7 14.7083333,11.1692707 14.7083333,16.2916667 C14.7083333,20.5364587 16.934896,25.403646 19.125,29.2708333 C21.315104,33.1380207 23.5,36 23.5,36 C23.6171873,36.158854 23.8020833,36.2552087 24,36.2552087 C24.1979167,36.2552087 24.3828127,36.158854 24.5,36 C24.5,36 26.6875,33.0989587 28.875,29.2083333 C31.0625,25.3177087 33.2916667,20.4479167 33.2916667,16.2916667 C33.2916667,11.1692707 29.122396,7 24,7 Z M24,8.25 C28.4531253,8.25 32.0416667,11.838542 32.0416667,16.2916667 C32.0416667,19.994792 29.9375,24.7916667 27.7916667,28.6041667 C26.0390627,31.721354 24.5807293,33.7656253 24,34.5625 C23.4166667,33.776042 21.9583333,31.7578127 20.2083333,28.6666667 C18.065104,24.8802087 15.9583333,20.09375 15.9583333,16.2916667 C15.9583333,11.838542 19.5468753,8.25 24,8.25 Z M24,12.3125 C21.4427087,12.3125 19.3541667,14.401042 19.3541667,16.9583333 C19.3541667,19.5156253 21.4427087,21.6041667 24,21.6041667 C26.557292,21.6041667 28.6458333,19.5156253 28.6458333,16.9583333 C28.6458333,14.401042 26.557292,12.3125 24,12.3125 Z M24,13.6041667 C25.8619793,13.6041667 27.3541667,15.096354 27.3541667,16.9583333 C27.3541667,18.8203127 25.8619793,20.3125 24,20.3125 C22.1380207,20.3125 20.6458333,18.8203127 20.6458333,16.9583333 C20.6458333,15.096354 22.1380207,13.6041667 24,13.6041667 Z M17.4375,29.7291667 C14.7708333,30.119792 12.5156253,30.7369793 10.8541667,31.5416667 C10.0234373,31.9427087 9.33593733,32.3906253 8.83333333,32.9166667 C8.33072933,33.4427087 8,34.096354 8,34.7916667 C8,35.744792 8.60937533,36.559896 9.47916667,37.2083333 C10.3489587,37.8567707 11.5234373,38.3802087 12.9583333,38.8333333 C15.8255207,39.7395833 19.7083333,40.2916667 24,40.2916667 C28.2916667,40.2916667 32.1744793,39.7395833 35.0416667,38.8333333 C36.4765627,38.3802087 37.651042,37.8567707 38.5208333,37.2083333 C39.3906253,36.559896 40,35.744792 40,34.7916667 C40,34.0989587 39.6692707,33.4427087 39.1666667,32.9166667 C38.6640627,32.3906253 37.9765627,31.9427087 37.1458333,31.5416667 C35.4843753,30.7369793 33.2291667,30.119792 30.5625,29.7291667 C30.1953127,29.6718753 29.8489587,29.9244793 29.7916667,30.2916667 C29.7343753,30.658854 29.9869793,31.0052087 30.3541667,31.0625 C32.9270833,31.440104 35.09375,32.0390627 36.5625,32.75 C37.2968753,33.1067707 37.8645833,33.494792 38.2083333,33.8541667 C38.5520833,34.213542 38.6666667,34.5130207 38.6666667,34.7916667 C38.6666667,35.1744793 38.4114587,35.6145833 37.7291667,36.125 C37.0468753,36.6354167 35.9869793,37.1380207 34.6458333,37.5625 C31.963542,38.408854 28.1770833,38.9583333 24,38.9583333 C19.8229167,38.9583333 16.0364587,38.408854 13.3541667,37.5625 C12.0130207,37.1380207 10.9531253,36.6354167 10.2708333,36.125 C9.588542,35.6145833 9.33333333,35.1744793 9.33333333,34.7916667 C9.33333333,34.5130207 9.44791667,34.213542 9.79166667,33.8541667 C10.1354167,33.494792 10.7031253,33.1067707 11.4375,32.75 C12.90625,32.0390627 15.0729167,31.440104 17.6458333,31.0625 C18.0130207,31.0052087 18.2656253,30.658854 18.2083333,30.2916667 C18.151042,29.9244793 17.8046873,29.6718753 17.4375,29.7291667 Z', id: 'Shape', fill: '#555555', fillRule: 'nonzero' }))));
};
var MarkerIcon_index = react.memo(MarkerIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/MobileIcon/index.js
var MobileIcon = __webpack_require__(1492);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/PaidLeaveIcon/index.js
var PaidLeaveIcon = __webpack_require__(62095);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PencilIcon/index.js
'use client';




var PencilIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1' },
        react.createElement("g", { id: '\u27A4-Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Exit-Popups-/-Attach-CV-01-1', transform: 'translate(-743.000000, -264.000000)' },
                react.createElement("g", { id: 'organism-/-exit-popup-/-desktop-/-Job-Alert-03', transform: 'translate(283.000000, 129.000000)' },
                    react.createElement("g", { id: 'Job-Alert', transform: 'translate(223.000000, 20.000000)' },
                        react.createElement("g", { id: 'Stacked-Group', transform: 'translate(0.000000, 81.000000)' },
                            react.createElement("g", { id: 'atom-/-bar-/-desktop-/-field', transform: 'translate(0.000000, 26.000000)' },
                                react.createElement("rect", { id: 'Background', stroke: '#D9F5FD', fill: '#F1F9FF', x: '0.5', y: '0.5', width: '270', height: '39', rx: '4' }),
                                react.createElement("g", { id: 'atom-/-ic-/-Pencil-Thin', transform: 'translate(237.000000, 8.000000)' },
                                    react.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                                    react.createElement("path", { d: 'M18.3043831,4 C17.8709681,4 17.4389121,4.16983333 17.1087558,4.49998959 L16.826153,4.78259241 L19.2174076,7.17385185 C19.216049,7.17520557 19.5000104,6.89124417 19.5000104,6.89124417 C20.1616815,6.22957307 20.1603229,5.16030211 19.5000104,4.49998959 C19.1684956,4.16983333 18.7377981,4 18.3043831,4 Z M16.2935554,5.40214473 C16.2147529,5.41301407 16.1413847,5.45241534 16.087038,5.51083812 L4.80466408,16.8040813 C4.75982815,16.8448415 4.72586155,16.8978293 4.70684003,16.9562521 L4.01120233,19.5648934 C3.9799529,19.6844562 4.01527842,19.8108122 4.10223314,19.8977669 C4.18918785,19.9847216 4.31554383,20.0200471 4.43510656,19.9887977 L7.04374792,19.29316 C7.1021707,19.2741388 7.15515881,19.2401719 7.19591866,19.1953359 L18.4891619,7.91296204 C18.6277461,7.77845388 18.6291047,7.55699136 18.4945965,7.41840711 C18.3600884,7.27982322 18.1386259,7.27846429 18.0000416,7.41297245 L6.77201444,18.6409996 L5.35900037,17.2279856 L16.5870276,5.99995838 C16.6916449,5.89941716 16.7228943,5.74317033 16.6644715,5.61002075 C16.6060491,5.47687152 16.4715409,5.3939929 16.3261634,5.40214473 C16.3152941,5.40214473 16.3044247,5.40214473 16.2935554,5.40214473 Z', id: 'Shape', fill: constants/* colors.buttonColor */.O9.buttonColor }))))))))));
};
var PencilIcon_index = /*#__PURE__*/ react.memo(PencilIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PencilIconV2/index.js
'use client';



function PencilIconV2() {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none' },
        react.createElement("path", { d: 'M11.175 0.599976C10.902 0.599976 10.6291 0.704209 10.4208 0.912476L9.13331 2.19998L11.8 4.86664L13.0875 3.57914C13.504 3.16261 13.504 2.48734 13.0875 2.07081L11.9291 0.912476C11.7209 0.704209 11.4479 0.599976 11.175 0.599976ZM8.06664 3.26664L1.80518 9.5281C1.80518 9.5281 2.29466 9.48424 2.47706 9.66664C2.65946 9.84904 2.50931 11.0426 2.73331 11.2666C2.95731 11.4906 4.14338 11.333 4.31352 11.5031C4.48365 11.6732 4.47185 12.1948 4.47185 12.1948L10.7333 5.93331L8.06664 3.26664ZM1.13331 11.2666L0.630184 12.6916C0.610405 12.7479 0.600194 12.807 0.599976 12.8666C0.599976 13.0081 0.656166 13.1437 0.756185 13.2438C0.856205 13.3438 0.99186 13.4 1.13331 13.4C1.19292 13.3998 1.25207 13.3895 1.30831 13.3698C1.31005 13.3691 1.31178 13.3684 1.31352 13.3677L1.32706 13.3635C1.3281 13.3628 1.32914 13.3621 1.33018 13.3614L2.73331 12.8666L1.93331 12.0666L1.13331 11.2666Z', fill: '#888888' })));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/ReportIcon/index.js
var ReportIcon = __webpack_require__(35425);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TeamActivitiesIcon/index.js
var TeamActivitiesIcon = __webpack_require__(84485);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TrainingIcon/index.js
var TrainingIcon = __webpack_require__(97379);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TransportationIcon/index.js
var TransportationIcon = __webpack_require__(55007);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/TrashIcon/index.js
'use client';



var TrashIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32 32', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("defs", null,
            react.createElement("filter", { id: 'filter-delete-formModal' },
                react.createElement("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0' }))),
        react.createElement("g", { id: 'icons/action/icon-delete/size-m', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
            react.createElement("g", { filter: 'url(#filter-delete-formModal)', id: 'icons8-trash-can-(3)' },
                react.createElement("g", { transform: 'translate(8.000000, 5.000000)' },
                    react.createElement("path", { d: 'M5.28,2.4 L5.28,0.96 C5.28,0.432 5.712,0 6.24,0 L10.08,0 C10.608,0 11.04,0.432 11.04,0.96 L11.04,2.4 M0,2.4 L16.32,2.4 M8.16,5.76 L8.16,17.76 M11.04,5.76 L11.04,17.76 M5.28,5.76 L5.28,17.76', id: 'Shape', stroke: '#000000', strokeWidth: '0.96' }),
                    react.createElement("path", { d: 'M15.36,2.4 L15.36,20.16 C15.36,20.688 14.928,21.12 14.4,21.12 L1.92,21.12 C1.392,21.12 0.96,20.688 0.96,20.16 L0.96,2.4', id: 'Path', stroke: '#000000', strokeWidth: '0.96' }))))));
};
var TrashIcon_index = (0,react.memo)(TrashIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/TravelOpportunitiesIcon/index.js
var TravelOpportunitiesIcon = __webpack_require__(61431);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/VerticalMoreIcon/index.js
var VerticalMoreIcon = __webpack_require__(37373);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/VoucherIcon/index.js
var VoucherIcon = __webpack_require__(7408);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/WorkingLocationIcon/index.js
'use client';




var WorkingLocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#616161' : _c, rest = (0,_tslib/* __rest */._T)(_a, ["width", "color"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 16 16', fill: 'none' }, rest),
        react.createElement("path", { d: 'M7.99974 1.06641C5.64347 1.06641 3.73307 2.97681 3.73307 5.33307C3.73307 8.53307 7.46641 9.59974 7.46641 11.7331C7.46641 12.0275 7.70534 12.2664 7.99974 12.2664C8.29414 12.2664 8.53307 12.0275 8.53307 11.7331C8.53307 9.59974 12.2664 8.53307 12.2664 5.33307C12.2664 2.97681 10.356 1.06641 7.99974 1.06641ZM7.99974 4.26641C8.58907 4.26641 9.06641 4.74374 9.06641 5.33307C9.06641 5.92241 8.58907 6.39974 7.99974 6.39974C7.41041 6.39974 6.93307 5.92241 6.93307 5.33307C6.93307 4.74374 7.41041 4.26641 7.99974 4.26641ZM5.00286 9.84349C2.78686 10.2222 1.06641 11.0376 1.06641 12.2664C1.06641 14.0168 4.55441 14.9331 7.99974 14.9331C11.4451 14.9331 14.9331 14.0168 14.9331 12.2664C14.9331 11.0376 13.2126 10.2222 10.9966 9.84349C10.9534 9.88669 10.9096 9.92948 10.8664 9.97161C10.5747 10.2591 10.3033 10.5292 10.0852 10.7852C12.5449 11.0748 13.8664 11.8333 13.8664 12.2664C13.8664 12.8099 11.7955 13.8664 7.99974 13.8664C4.20401 13.8664 2.13307 12.8099 2.13307 12.2664C2.13307 11.8333 3.45459 11.0748 5.91432 10.7852C5.69566 10.5292 5.42427 10.2591 5.13307 9.97161C5.09041 9.92948 5.0466 9.88669 5.00286 9.84349Z', fill: color })));
};
var WorkingLocationIcon$1 = react.memo(WorkingLocationIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ZaloIcon/index.js
'use client';



var Images_ZaloIcon_ZaloIcon = function () {
    return (react.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_375_6275)' },
            react.createElement("path", { d: 'M15.209 13.2029C15.3112 13.5643 15.7632 13.3904 16.0348 13.4285C16.0303 11.8035 16.0303 10.1778 16.0348 8.55273H15.2019C15.2077 10.1028 15.1922 11.6535 15.209 13.2029Z', fill: '#333333' }),
            react.createElement("path", { d: 'M6.71782 9.43346C7.60956 9.42376 8.50196 9.43087 9.39369 9.42958C8.52587 10.5257 7.64384 11.6114 6.77214 12.7049C6.59883 12.9021 6.59625 13.1763 6.59302 13.424C7.76475 13.4363 8.93715 13.424 10.1095 13.4305C10.2434 13.4292 10.4051 13.4401 10.4943 13.3173C10.6366 13.1272 10.5596 12.8717 10.5771 12.6525C9.64006 12.6525 8.70306 12.6564 7.76605 12.6506C8.64745 11.5526 9.51073 10.4403 10.3928 9.34228C10.5622 9.13793 10.5764 8.86246 10.5855 8.60961C9.2954 8.60056 8.00596 8.60897 6.71523 8.61026C6.71393 8.88444 6.71199 9.15927 6.71782 9.43346H6.71782Z', fill: '#333333' }),
            react.createElement("path", { d: 'M19.0651 13.3748C20.0267 13.0851 20.6087 11.9541 20.2899 11.0029C20.0358 10.0885 19.0283 9.47871 18.0997 9.68628C17.5474 9.80333 17.0527 10.1726 16.7967 10.6776C16.4947 11.2499 16.5147 11.978 16.8471 12.5342C17.2707 13.2869 18.2484 13.6626 19.0651 13.3748ZM18.0842 10.5101C18.6493 10.2786 19.351 10.6136 19.532 11.1943C19.7487 11.7808 19.3794 12.4967 18.7683 12.6428C18.2329 12.8045 17.6166 12.4824 17.4336 11.9561C17.2125 11.3993 17.5177 10.7099 18.0842 10.5101V10.5101Z', fill: '#333333' }),
            react.createElement("path", { d: 'M13.7464 13.093C13.7988 13.2107 13.8395 13.3549 13.9714 13.4085C14.1596 13.4473 14.3542 13.4247 14.5457 13.4299C14.5424 12.2135 14.5437 10.9978 14.545 9.78207C14.2844 9.78336 14.0244 9.78272 13.7638 9.78401C13.7658 9.8448 13.7703 9.96572 13.7722 10.0265C13.5731 9.90558 13.3668 9.79177 13.1392 9.73422C12.4498 9.53699 11.6674 9.80988 11.2205 10.3634C10.6301 11.0631 10.6631 12.1857 11.3001 12.8446C11.8976 13.5249 13.0273 13.6517 13.7464 13.093L13.7464 13.093ZM12.2733 10.5264C12.8139 10.2962 13.4922 10.6027 13.6934 11.1498C13.9009 11.6529 13.6778 12.2821 13.1948 12.5355C12.6742 12.8343 11.9461 12.6067 11.6874 12.0648C11.3841 11.5086 11.6745 10.7372 12.2733 10.5264V10.5264Z', fill: '#333333' }),
            react.createElement("path", { d: 'M21.9622 16.7821L21.9111 16.8377C20.9896 17.8685 19.7506 18.5662 18.4554 19.0176C16.71 19.6125 14.8405 19.8039 13.006 19.6642C11.1714 19.5065 9.3226 19.0273 7.76674 18.0133C6.97134 18.3671 6.09383 18.5404 5.22278 18.4686C5.19174 18.4362 5.16135 18.4039 5.13031 18.3716C5.60367 17.8659 5.9535 17.1992 5.9257 16.4917C5.92182 16.1619 5.67415 15.922 5.52542 15.6504C4.63691 14.1327 4.21788 12.3771 4.12863 10.6311C4.03875 8.48676 4.43515 6.27454 5.52283 4.40376C6.06537 3.46933 6.81615 2.65519 7.72147 2.06221L7.78096 2.00724C7.08904 1.99172 6.39259 1.99237 5.70778 2.10036C4.73326 2.23616 3.8066 2.71598 3.15218 3.45381C2.32576 4.32487 2.01471 5.55352 2.00049 6.72785C1.99984 10.2411 1.99984 13.7544 2.00049 17.2684C2.02635 18.0295 2.12593 18.8061 2.45896 19.5006C3.00862 20.7021 4.15967 21.601 5.45623 21.8525C6.48635 22.0472 7.54105 21.9987 8.58347 21.9832C9.17646 22.0142 9.77267 21.9864 10.3676 21.9961C12.4363 21.9955 14.5049 21.9961 16.5736 21.9955C17.2461 22.0039 17.9232 21.9735 18.5834 21.837C19.7603 21.5861 20.8066 20.8024 21.3834 19.747C21.8794 18.8475 21.9887 17.7928 21.9622 16.7821H21.9622Z', fill: '#333333' })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_375_6275' },
                react.createElement("rect", { width: '19.9659', height: '20', fill: 'white', transform: 'translate(2 2)' })))));
};
var ZaloIcon_index = react.memo(Images_ZaloIcon_ZaloIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DragReorderIcon/index.js
'use client';



var DragReorderIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 20, height: height !== null && height !== void 0 ? height : 20, viewBox: '0 0 20 20', fill: 'none' },
        react.createElement("path", { d: 'M10.0001 1.3335L7.33339 4.00016H12.6667L10.0001 1.3335ZM3.33339 6.00016C3.24505 5.99891 3.15734 6.01523 3.07536 6.04818C2.99338 6.08112 2.91877 6.13003 2.85585 6.19206C2.79294 6.25409 2.74298 6.328 2.70888 6.40951C2.67479 6.49101 2.65723 6.57848 2.65723 6.66683C2.65723 6.75518 2.67479 6.84265 2.70888 6.92415C2.74298 7.00566 2.79294 7.07957 2.85585 7.1416C2.91877 7.20363 2.99338 7.25254 3.07536 7.28548C3.15734 7.31843 3.24505 7.33475 3.33339 7.3335H16.6667C16.7551 7.33475 16.8428 7.31843 16.9248 7.28548C17.0067 7.25254 17.0813 7.20363 17.1443 7.1416C17.2072 7.07957 17.2571 7.00566 17.2912 6.92415C17.3253 6.84265 17.3429 6.75518 17.3429 6.66683C17.3429 6.57848 17.3253 6.49101 17.2912 6.40951C17.2571 6.328 17.2072 6.25409 17.1443 6.19206C17.0813 6.13003 17.0067 6.08112 16.9248 6.04818C16.8428 6.01523 16.7551 5.99891 16.6667 6.00016H3.33339ZM3.33339 9.3335C3.24505 9.33225 3.15734 9.34857 3.07536 9.38151C2.99338 9.41445 2.91877 9.46336 2.85585 9.52539C2.79294 9.58742 2.74298 9.66133 2.70888 9.74284C2.67479 9.82434 2.65723 9.91181 2.65723 10.0002C2.65723 10.0885 2.67479 10.176 2.70888 10.2575C2.74298 10.339 2.79294 10.4129 2.85585 10.4749C2.91877 10.537 2.99338 10.5859 3.07536 10.6188C3.15734 10.6518 3.24505 10.6681 3.33339 10.6668H16.6667C16.7551 10.6681 16.8428 10.6518 16.9248 10.6188C17.0067 10.5859 17.0813 10.537 17.1443 10.4749C17.2072 10.4129 17.2571 10.339 17.2912 10.2575C17.3253 10.176 17.3429 10.0885 17.3429 10.0002C17.3429 9.91181 17.3253 9.82434 17.2912 9.74284C17.2571 9.66133 17.2072 9.58742 17.1443 9.52539C17.0813 9.46336 17.0067 9.41445 16.9248 9.38151C16.8428 9.34857 16.7551 9.33225 16.6667 9.3335H3.33339ZM3.33339 12.6668C3.24505 12.6656 3.15734 12.6819 3.07536 12.7148C2.99338 12.7478 2.91877 12.7967 2.85585 12.8587C2.79294 12.9208 2.74298 12.9947 2.70888 13.0762C2.67479 13.1577 2.65723 13.2451 2.65723 13.3335C2.65723 13.4218 2.67479 13.5093 2.70888 13.5908C2.74298 13.6723 2.79294 13.7462 2.85585 13.8083C2.91877 13.8703 2.99338 13.9192 3.07536 13.9521C3.15734 13.9851 3.24505 14.0014 3.33339 14.0002H16.6667C16.7551 14.0014 16.8428 13.9851 16.9248 13.9521C17.0067 13.9192 17.0813 13.8703 17.1443 13.8083C17.2072 13.7462 17.2571 13.6723 17.2912 13.5908C17.3253 13.5093 17.3429 13.4218 17.3429 13.3335C17.3429 13.2451 17.3253 13.1577 17.2912 13.0762C17.2571 12.9947 17.2072 12.9208 17.1443 12.8587C17.0813 12.7967 17.0067 12.7478 16.9248 12.7148C16.8428 12.6819 16.7551 12.6656 16.6667 12.6668H3.33339ZM7.33339 16.0002L10.0001 18.6668L12.6667 16.0002H7.33339Z', fill: color !== null && color !== void 0 ? color : '#888888' })));
};
var DragReorderIcon_index = react.memo(DragReorderIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CheckIcon/index.js
'use client';



function CheckIcon_WarningIcon(_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M17.987 3.99345C17.8138 3.99861 17.6494 4.071 17.5287 4.19528L7.33335 14.3906L3.13804 10.1953C3.07661 10.1313 3.00303 10.0802 2.92161 10.045C2.84019 10.0098 2.75257 9.99124 2.66387 9.99034C2.57518 9.98944 2.4872 10.0062 2.40508 10.0398C2.32296 10.0733 2.24836 10.1229 2.18564 10.1856C2.12292 10.2483 2.07334 10.3229 2.03982 10.405C2.00629 10.4871 1.98949 10.5751 1.99039 10.6638C1.99129 10.7525 2.00988 10.8401 2.04507 10.9216C2.08026 11.003 2.13135 11.0766 2.19533 11.138L6.86199 15.8047C6.98702 15.9296 7.15657 15.9998 7.33335 15.9998C7.51013 15.9998 7.67967 15.9296 7.8047 15.8047L18.4714 5.13799C18.5677 5.04434 18.6335 4.92378 18.6601 4.7921C18.6868 4.66042 18.673 4.52377 18.6207 4.40004C18.5683 4.27632 18.4798 4.1713 18.3667 4.09875C18.2536 4.02619 18.1213 3.98949 17.987 3.99345Z', fill: '#888888' })));
}
var CheckIcon_index = react.memo(CheckIcon_WarningIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DownloadIcon/index.js
'use client';



var DownloadIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#005AFF' : _e;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Download' },
            react.createElement("path", { id: 'Vector', d: 'M12 0.800781C11.5584 0.800781 11.2 1.15918 11.2 1.60078V4.80078H12.8V1.60078C12.8 1.15918 12.4416 0.800781 12 0.800781ZM12.8 4.80078V14.8695L14.6344 13.0352C14.9472 12.7224 15.4528 12.7224 15.7656 13.0352C16.0784 13.348 16.0784 13.8536 15.7656 14.1664L12.5656 17.3664C12.4096 17.5224 12.2048 17.6008 12 17.6008C11.7952 17.6008 11.5904 17.5224 11.4344 17.3664L8.23439 14.1664C7.92159 13.8536 7.92159 13.348 8.23439 13.0352C8.54719 12.7224 9.05284 12.7224 9.36564 13.0352L11.2 14.8695V4.80078H4.80001C3.91601 4.80078 3.20001 5.51678 3.20001 6.40078V20.0008C3.20001 20.8848 3.91601 21.6008 4.80001 21.6008H19.2C20.084 21.6008 20.8 20.8848 20.8 20.0008V6.40078C20.8 5.51678 20.084 4.80078 19.2 4.80078H12.8Z', fill: color }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/SyncProfileIcon/index.js
'use client';



var SyncProfileIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#005AFF' : _e;
    return (react.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M12 4.12539C16.0453 4.12539 19.3654 7.15544 19.8218 11.0754H17.6H17.3664L17.496 11.2697L20.696 16.0697L20.8 16.2257L20.904 16.0697L24.104 11.2697L24.2336 11.0754H24H21.6737C21.2053 6.14714 17.049 2.27539 12 2.27539C9.595 2.27539 7.38422 3.15294 5.68601 4.604C5.58963 4.68112 5.50965 4.77674 5.45079 4.88525C5.39157 4.99443 5.35494 5.11441 5.34308 5.23804C5.33123 5.36167 5.34439 5.48643 5.38178 5.60486C5.41918 5.7233 5.48004 5.833 5.56073 5.92741C5.64143 6.02182 5.74032 6.09901 5.85149 6.15439C5.96266 6.20976 6.08385 6.24218 6.20782 6.24972C6.33179 6.25725 6.45601 6.23974 6.57307 6.19824C6.68942 6.15699 6.79633 6.09287 6.8875 6.00967C8.26406 4.83356 10.0449 4.12539 12 4.12539ZM3.30401 7.93105L3.2 7.77504L3.09599 7.93105L-0.104006 12.7311L-0.233565 12.9254H0H2.32627C2.79471 17.8536 6.95104 21.7254 12 21.7254C14.405 21.7254 16.6158 20.8478 18.314 19.3968C18.4104 19.3197 18.4904 19.224 18.5492 19.1155C18.6084 19.0064 18.6451 18.8864 18.6569 18.7627C18.6688 18.6391 18.6556 18.5144 18.6182 18.3959C18.5808 18.2775 18.52 18.1678 18.4393 18.0734L18.3442 18.1546L18.4393 18.0734C18.3586 17.979 18.2597 17.9018 18.1485 17.8464C18.0373 17.791 17.9162 17.7586 17.7922 17.7511C17.6682 17.7435 17.544 17.761 17.4269 17.8025C17.3106 17.8438 17.2037 17.9079 17.1125 17.9911C15.736 19.1672 13.9551 19.8754 12 19.8754C7.95471 19.8754 4.63456 16.8453 4.17823 12.9254H6.4H6.63356L6.50401 12.7311L3.30401 7.93105Z", fill: color, stroke: color, strokeWidth: "0.25" })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/SalaryIcon/index.js
'use client';




var SalaryIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#616161' : _c, rest = (0,_tslib/* __rest */._T)(_a, ["width", "color"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 16 16', fill: 'none' }, rest),
        react.createElement("path", { d: 'M2.13307 2.66602C2.06381 2.66625 1.99473 2.67322 1.92682 2.68685C1.92117 2.68798 1.91577 2.68979 1.91016 2.69102C1.67161 2.74199 1.45774 2.87319 1.3042 3.06275C1.15067 3.2523 1.06674 3.48875 1.06641 3.73268V10.1327C1.06664 10.2019 1.07362 10.271 1.08724 10.3389C1.08837 10.3446 1.09018 10.35 1.09141 10.3556C1.14238 10.5941 1.27358 10.808 1.46314 10.9616C1.65269 11.1151 1.88914 11.199 2.13307 11.1993H13.8664C13.9357 11.1991 14.0047 11.1921 14.0727 11.1785C14.0783 11.1774 14.0837 11.1756 14.0893 11.1743C14.3279 11.1234 14.5417 10.9922 14.6953 10.8026C14.8488 10.6131 14.9327 10.3766 14.9331 10.1327V3.73268C14.9328 3.66342 14.9259 3.59434 14.9122 3.52643C14.9111 3.52078 14.9093 3.51538 14.9081 3.50977C14.8571 3.27122 14.7259 3.05735 14.5363 2.90381C14.3468 2.75028 14.1103 2.66635 13.8664 2.66602H2.13307ZM3.19974 3.73268H12.7997C12.7997 4.01558 12.9121 4.28689 13.1122 4.48693C13.3122 4.68697 13.5835 4.79935 13.8664 4.79935V9.06602C13.5835 9.06602 13.3122 9.1784 13.1122 9.37844C12.9121 9.57847 12.7997 9.84978 12.7997 10.1327H3.19974C3.19974 9.84978 3.08736 9.57847 2.88732 9.37844C2.68728 9.1784 2.41597 9.06602 2.13307 9.06602V4.79935C2.41597 4.79935 2.68728 4.68697 2.88732 4.48693C3.08736 4.28689 3.19974 4.01558 3.19974 3.73268ZM7.99974 4.79935C6.82161 4.79935 5.86641 5.87402 5.86641 7.19935C5.86641 7.95775 6.18516 8.62602 6.6737 9.06602H9.32578C9.81431 8.62602 10.1331 7.95775 10.1331 7.19935C10.1331 5.87402 9.17787 4.79935 7.99974 4.79935ZM3.73307 6.39935C3.59162 6.39935 3.45597 6.45554 3.35595 6.55556C3.25593 6.65558 3.19974 6.79123 3.19974 6.93268C3.19974 7.07413 3.25593 7.20979 3.35595 7.30981C3.45597 7.40983 3.59162 7.46602 3.73307 7.46602C3.87452 7.46602 4.01018 7.40983 4.1102 7.30981C4.21022 7.20979 4.26641 7.07413 4.26641 6.93268C4.26641 6.79123 4.21022 6.65558 4.1102 6.55556C4.01018 6.45554 3.87452 6.39935 3.73307 6.39935ZM12.2664 6.39935C12.125 6.39935 11.9893 6.45554 11.8893 6.55556C11.7893 6.65558 11.7331 6.79123 11.7331 6.93268C11.7331 7.07413 11.7893 7.20979 11.8893 7.30981C11.9893 7.40983 12.125 7.46602 12.2664 7.46602C12.4079 7.46602 12.5435 7.40983 12.6435 7.30981C12.7435 7.20979 12.7997 7.07413 12.7997 6.93268C12.7997 6.79123 12.7435 6.65558 12.6435 6.55556C12.5435 6.45554 12.4079 6.39935 12.2664 6.39935ZM2.13307 12.266C2.0624 12.265 1.99223 12.2781 1.92665 12.3044C1.86107 12.3308 1.80138 12.3699 1.75105 12.4195C1.70071 12.4692 1.66075 12.5283 1.63347 12.5935C1.60619 12.6587 1.59214 12.7287 1.59214 12.7993C1.59214 12.87 1.60619 12.94 1.63347 13.0052C1.66075 13.0704 1.70071 13.1295 1.75105 13.1792C1.80138 13.2288 1.86107 13.2679 1.92665 13.2943C1.99223 13.3206 2.0624 13.3337 2.13307 13.3327H13.8664C13.9371 13.3337 14.0072 13.3206 14.0728 13.2943C14.1384 13.2679 14.1981 13.2288 14.2484 13.1792C14.2988 13.1295 14.3387 13.0704 14.366 13.0052C14.3933 12.94 14.4073 12.87 14.4073 12.7993C14.4073 12.7287 14.3933 12.6587 14.366 12.5935C14.3387 12.5283 14.2988 12.4692 14.2484 12.4195C14.1981 12.3699 14.1384 12.3308 14.0728 12.3044C14.0072 12.2781 13.9371 12.265 13.8664 12.266H2.13307Z', fill: color })));
};
var SalaryIcon$1 = react.memo(SalaryIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/BriefcaseIcon/index.js
'use client';



var BriefcaseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Briefcase-Fill' },
            react.createElement("path", { id: 'Briefcase-Fill_2', d: 'M6.02111 4.0884C6.02111 3.52326 6.30708 3.23729 6.87903 3.23729H11.121C11.6929 3.23729 11.9789 3.52326 11.9789 4.0884V4.7012H6.02111V4.0884ZM16.5 6.69621C16.5 5.37528 15.7987 4.7012 14.4778 4.7012H13.0343V4.1633C13.0343 2.83557 12.3738 2.25 11.1074 2.25H6.89265C5.69428 2.25 4.96573 2.83557 4.96573 4.1633V4.7012H3.52224C2.26941 4.7012 1.5 5.37528 1.5 6.69621V8.4529H16.5V6.69621ZM3.52224 15.2754H14.4778C15.7987 15.2754 16.5 14.6081 16.5 13.2804V9.37891H11.7338V9.78064C11.7338 10.339 11.4069 10.659 10.8418 10.659H7.13096C6.56582 10.659 6.2458 10.339 6.2458 9.78064V9.37891H1.5V13.2804C1.5 14.6081 2.20132 15.2754 3.52224 15.2754Z', fill: '#797979' }))));
};
var BriefcaseIcon_index = react.memo(BriefcaseIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/GraduationCapIcon/index.js
'use client';



var GraduationCapIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Graduationcap-Fill' },
            react.createElement("path", { id: 'Graduationcap-Fill_2', d: 'M15.9689 5.12435L10.4955 2.61969C9.92527 2.36251 9.46124 2.23952 8.9972 2.2507C8.53876 2.23952 8.07473 2.36251 7.49888 2.61969L2.03112 5.12435C1.67331 5.28648 1.5 5.57161 1.5 5.85674C1.5 6.14187 1.67331 6.4214 2.03112 6.58913L4.33451 7.64019L7.87346 5.97973C7.83992 5.9406 7.82874 5.89587 7.82874 5.85674C7.82874 5.50452 8.42136 5.23616 9.01957 5.23616C9.62337 5.23616 10.2048 5.50452 10.2048 5.85674C10.2048 6.22014 9.62337 6.49408 9.01957 6.49408C8.83507 6.49408 8.65058 6.46613 8.48845 6.4214L5.11163 8.00359L7.49888 9.09938C8.07473 9.36214 8.53876 9.47396 8.9972 9.46837C9.46124 9.47396 9.92527 9.36214 10.4955 9.09938L15.9689 6.58913C16.3267 6.4214 16.5 6.14187 16.5 5.85674C16.5 5.57161 16.3267 5.28648 15.9689 5.12435ZM5.08927 8.83102V12.2302C6.02851 12.8005 7.37029 13.1471 8.9972 13.1471C12.2958 13.1471 14.4202 11.7326 14.4202 10.061V8.13777L10.8142 9.78704C10.1601 10.0889 9.56746 10.2399 8.9972 10.2343C8.43254 10.2399 7.83433 10.0889 7.18021 9.78704L5.08927 8.83102ZM3.57976 8.13777V10.061C3.57976 10.5474 3.8593 11.1512 4.36247 11.6655V8.50116L3.57976 8.13777ZM3.9208 13.5664V15.0368C3.9208 15.4784 4.20593 15.7636 4.6476 15.7636H4.79855C5.24022 15.7636 5.52534 15.4784 5.52534 15.0368V13.5664C5.52534 13.2309 5.35762 12.9905 5.08927 12.8899V12.2302C4.80973 12.0625 4.56373 11.8724 4.36247 11.6655V12.8899C4.08852 12.985 3.9208 13.2309 3.9208 13.5664Z', fill: '#797979' }))));
};
var GraduationCapIcon_index = react.memo(GraduationCapIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/EnvelopeIcon/index.js
'use client';



var EnvelopeIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Envelope-Fill' },
            react.createElement("path", { id: 'Envelope-Fill_2', d: 'M9.01359 9.63723C9.29212 9.63723 9.55027 9.50815 9.84918 9.20924L15.7595 3.36005C15.5082 3.11549 15.0394 3 14.3668 3H3.42935C2.8587 3 2.45788 3.1087 2.2337 3.33288L8.17799 9.20924C8.47011 9.50136 8.72826 9.63723 9.01359 9.63723ZM1.66984 13.6114L6.47283 8.86277L1.65625 4.11413C1.55435 4.30435 1.5 4.63043 1.5 5.09918V12.5992C1.5 13.0815 1.55435 13.4212 1.66984 13.6114ZM16.337 13.6046C16.4457 13.4076 16.5 13.0747 16.5 12.5992V5.09918C16.5 4.64402 16.4457 4.31793 16.3505 4.13451L11.5476 8.86277L16.337 13.6046ZM3.63315 14.7052H14.5707C15.1413 14.7052 15.5353 14.5965 15.7595 14.3791L10.8614 9.52853L10.413 9.9837C9.94429 10.4321 9.50272 10.6359 9.01359 10.6359C8.51766 10.6359 8.07609 10.4321 7.61413 9.9837L7.15897 9.52853L2.27446 14.3723C2.53261 14.5965 2.98098 14.7052 3.63315 14.7052Z', fill: '#797979' }))));
};
var EnvelopeIcon_index = react.memo(EnvelopeIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AddFilledIcon/index.js
var AddFilledIcon = __webpack_require__(94864);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/HomeIcon/index.js
'use client';



var HomeIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#797979' : _e;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M8.99981 1.19922C8.84298 1.19923 8.69238 1.26064 8.58028 1.37031L2.03535 6.72344C2.02779 6.72912 2.02037 6.73498 2.01309 6.74102L1.99082 6.75977V6.76094C1.93064 6.817 1.88263 6.88484 1.84977 6.96023C1.81691 7.03563 1.7999 7.11697 1.7998 7.19922C1.7998 7.35835 1.86302 7.51096 1.97554 7.62348C2.08806 7.73601 2.24067 7.79922 2.3998 7.79922H2.99981V14.3992C2.99981 15.0622 3.53681 15.5992 4.19981 15.5992H13.7998C14.4628 15.5992 14.9998 15.0622 14.9998 14.3992V7.79922H15.5998C15.7589 7.79922 15.9116 7.73601 16.0241 7.62348C16.1366 7.51096 16.1998 7.35835 16.1998 7.19922C16.1999 7.11678 16.1829 7.03521 16.1501 6.9596C16.1172 6.88399 16.0691 6.81596 16.0088 6.75977L15.9994 6.75274C15.9863 6.74081 15.9726 6.72947 15.9584 6.71875L13.7998 4.95274V2.39922C13.7998 2.06802 13.531 1.79922 13.1998 1.79922H12.5998C12.2686 1.79922 11.9998 2.06802 11.9998 2.39922V3.48086L9.40645 1.35977C9.29592 1.25701 9.15072 1.19969 8.99981 1.19922ZM7.19981 9.59922H10.7998V14.3992H7.19981V9.59922Z', fill: color })));
};
var HomeIcon_index = react.memo(HomeIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/PhoneIcon/index.js
'use client';



var PhoneIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#797979' : _e;
    return (react.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Phone' },
            react.createElement("path", { id: 'Vector', d: 'M12.735 10.734C12.4914 10.5912 12.192 10.5942 11.9496 10.7382L10.722 11.4696C10.4472 11.6334 10.104 11.6142 9.852 11.4174C9.4164 11.0772 8.715 10.5048 8.1048 9.89462C7.4946 9.28442 6.9222 8.58302 6.582 8.14742C6.3852 7.89542 6.366 7.55222 6.5298 7.27742L7.2612 6.04982C7.4058 5.80742 7.407 5.50562 7.2642 5.26202L5.463 2.18522C5.2884 1.88762 4.9416 1.74122 4.6062 1.82342C4.2804 1.90262 3.8574 2.09582 3.414 2.53982C2.0256 3.92822 1.2882 6.27002 6.5094 11.4912C11.7306 16.7124 14.0718 15.9756 15.4608 14.5866C15.9054 14.142 16.098 13.7184 16.1778 13.392C16.2588 13.0572 16.1148 12.7128 15.8178 12.5388C15.0762 12.105 13.4766 11.1684 12.735 10.734Z', fill: color }))));
};
var PhoneIcon_index = react.memo(PhoneIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/AttachIcon/index.js
var Images_AttachIcon = __webpack_require__(1556);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/PlusIcon/index.js
var PlusIcon = __webpack_require__(60819);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/FilterIcon/index.js
'use client';



var FilterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M16 3.19922C14.9655 3.19922 14.0839 3.87335 13.75 4.79922H3.2C3.094 4.79772 2.98874 4.8173 2.89037 4.85684C2.792 4.89637 2.70246 4.95506 2.62696 5.02949C2.55147 5.10393 2.49152 5.19262 2.4506 5.29043C2.40968 5.38824 2.38861 5.4932 2.38861 5.59922C2.38861 5.70524 2.40968 5.8102 2.4506 5.90801C2.49152 6.00581 2.55147 6.09451 2.62696 6.16895C2.70246 6.24338 2.792 6.30207 2.89037 6.3416C2.98874 6.38113 3.094 6.40072 3.2 6.39922H13.75C14.0839 7.32508 14.9655 7.99922 16 7.99922C17.0345 7.99922 17.9161 7.32508 18.25 6.39922H20.8C20.906 6.40072 21.0113 6.38113 21.1096 6.3416C21.208 6.30207 21.2976 6.24338 21.373 6.16895C21.4485 6.09451 21.5085 6.00581 21.5494 5.90801C21.5903 5.8102 21.6114 5.70524 21.6114 5.59922C21.6114 5.4932 21.5903 5.38824 21.5494 5.29043C21.5085 5.19262 21.4485 5.10393 21.373 5.02949C21.2976 4.95506 21.208 4.89637 21.1096 4.85684C21.0113 4.8173 20.906 4.79772 20.8 4.79922H18.25C17.9161 3.87335 17.0345 3.19922 16 3.19922ZM16 4.79922C16.4351 4.79922 16.7667 5.12627 16.7906 5.55391C16.7889 5.58461 16.7889 5.61539 16.7906 5.64609C16.766 6.07295 16.4345 6.39922 16 6.39922C15.5649 6.39922 15.2333 6.07217 15.2094 5.64453C15.2112 5.61383 15.2112 5.58305 15.2094 5.55234C15.234 5.12549 15.5655 4.79922 16 4.79922ZM9.6 9.59922C8.56548 9.59922 7.68389 10.2734 7.35 11.1992H3.2C3.094 11.1977 2.98874 11.2173 2.89037 11.2568C2.792 11.2964 2.70246 11.3551 2.62696 11.4295C2.55147 11.5039 2.49152 11.5926 2.4506 11.6904C2.40968 11.7882 2.38861 11.8932 2.38861 11.9992C2.38861 12.1052 2.40968 12.2102 2.4506 12.308C2.49152 12.4058 2.55147 12.4945 2.62696 12.5689C2.70246 12.6434 2.792 12.7021 2.89037 12.7416C2.98874 12.7811 3.094 12.8007 3.2 12.7992H7.35C7.68389 13.7251 8.56548 14.3992 9.6 14.3992C10.6345 14.3992 11.5161 13.7251 11.85 12.7992H20.8C20.906 12.8007 21.0113 12.7811 21.1096 12.7416C21.208 12.7021 21.2976 12.6434 21.373 12.5689C21.4485 12.4945 21.5085 12.4058 21.5494 12.308C21.5903 12.2102 21.6114 12.1052 21.6114 11.9992C21.6114 11.8932 21.5903 11.7882 21.5494 11.6904C21.5085 11.5926 21.4485 11.5039 21.373 11.4295C21.2976 11.3551 21.208 11.2964 21.1096 11.2568C21.0113 11.2173 20.906 11.1977 20.8 11.1992H11.85C11.5161 10.2734 10.6345 9.59922 9.6 9.59922ZM9.6 11.1992C10.0351 11.1992 10.3667 11.5263 10.3906 11.9539C10.3889 11.9846 10.3889 12.0154 10.3906 12.0461C10.366 12.4729 10.0345 12.7992 9.6 12.7992C9.16494 12.7992 8.83326 12.4722 8.80938 12.0445C8.81115 12.0138 8.81115 11.983 8.80938 11.9523C8.83401 11.5255 9.16548 11.1992 9.6 11.1992ZM12.8 15.9992C11.7655 15.9992 10.8839 16.6734 10.55 17.5992H3.2C3.094 17.5977 2.98874 17.6173 2.89037 17.6568C2.792 17.6964 2.70246 17.7551 2.62696 17.8295C2.55147 17.9039 2.49152 17.9926 2.4506 18.0904C2.40968 18.1882 2.38861 18.2932 2.38861 18.3992C2.38861 18.5052 2.40968 18.6102 2.4506 18.708C2.49152 18.8058 2.55147 18.8945 2.62696 18.9689C2.70246 19.0434 2.792 19.1021 2.89037 19.1416C2.98874 19.1811 3.094 19.2007 3.2 19.1992H10.55C10.8839 20.1251 11.7655 20.7992 12.8 20.7992C13.8345 20.7992 14.7161 20.1251 15.05 19.1992H20.8C20.906 19.2007 21.0113 19.1811 21.1096 19.1416C21.208 19.1021 21.2976 19.0434 21.373 18.9689C21.4485 18.8945 21.5085 18.8058 21.5494 18.708C21.5903 18.6102 21.6114 18.5052 21.6114 18.3992C21.6114 18.2932 21.5903 18.1882 21.5494 18.0904C21.5085 17.9926 21.4485 17.9039 21.373 17.8295C21.2976 17.7551 21.208 17.6964 21.1096 17.6568C21.0113 17.6173 20.906 17.5977 20.8 17.5992H15.05C14.7161 16.6734 13.8345 15.9992 12.8 15.9992ZM12.8 17.5992C13.2351 17.5992 13.5667 17.9263 13.5906 18.3539C13.5889 18.3846 13.5889 18.4154 13.5906 18.4461C13.566 18.8729 13.2345 19.1992 12.8 19.1992C12.3649 19.1992 12.0333 18.8722 12.0094 18.4445C12.0112 18.4138 12.0112 18.383 12.0094 18.3523C12.034 17.9255 12.3655 17.5992 12.8 17.5992Z', fill: '#005AFF' })));
};
var FilterIcon_index = react.memo(FilterIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/EmptyIcon/index.js
'use client';




var EmptyIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 138 : _b, _c = _a.height, height = _c === void 0 ? 137 : _c, restProps = (0,_tslib/* __rest */._T)(_a, ["width", "height"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: width, height: height, viewBox: '0 0 138 137', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react.createElement("path", { d: 'M65.9624 103.417C89.4861 103.417 108.556 84.3474 108.556 60.8238C108.556 37.3001 89.4861 18.2305 65.9624 18.2305C42.4388 18.2305 23.3691 37.3001 23.3691 60.8238C23.3691 84.3474 42.4388 103.417 65.9624 103.417Z', fill: '#F1F3F9' }),
        react.createElement("path", { d: 'M55.4918 24.665L51.2951 25.8204L26.3839 32.6658C24.1554 33.2778 22.8402 35.5839 23.4567 37.8125L38.1522 91.2973C38.7641 93.5258 41.0703 94.841 43.2988 94.2245L83.2526 83.2462C85.4811 82.6343 86.7963 80.3281 86.1798 78.0996L74.4618 35.4606L55.4873 24.6696L55.4918 24.665Z', fill: 'white', stroke: '#D6DCE8', strokeWidth: 2, strokeMiterlimit: 10 }),
        react.createElement("path", { d: 'M74.4621 35.46L63.2464 38.5425C61.2234 39.0996 59.1318 37.9077 58.5747 35.8847L55.4922 24.6689L74.4667 35.46H74.4621Z', fill: '#D6DCE8' }),
        react.createElement("path", { d: 'M30.6172 39.5064L53.4323 33.2363', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M34.6992 54.362L71.1549 44.3428', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M36.5039 60.9236L72.9596 50.9043', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M38.2207 67.1709L74.6764 57.1562', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M39.9375 73.4226L76.3932 63.4033', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M43.8418 87.6296L80.2975 77.6104', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M31.7305 43.5616L43.3435 40.374', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M96.0669 28.1302L91.7788 27.3813L66.3287 22.9516C64.05 22.5543 61.8808 24.0796 61.4835 26.3583L51.9711 81.0031C51.5738 83.2818 53.0991 85.451 55.3779 85.8483L96.1993 92.954C98.4781 93.3513 100.647 91.8261 101.045 89.5473L108.63 45.9813L96.0714 28.1302H96.0669Z', fill: 'white', stroke: '#D6DCE8', strokeWidth: 2, strokeMiterlimit: 10 }),
        react.createElement("path", { d: 'M108.625 45.9865L97.1625 43.9909C95.0938 43.6301 93.7101 41.6619 94.0709 39.5932L96.0665 28.1309L108.625 45.982V45.9865Z', fill: '#D6DCE8' }),
        react.createElement("path", { d: 'M67.2422 30.9482L90.555 35.008', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M64.6016 46.1279L101.847 52.6126', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M63.4336 52.832L100.679 59.3167', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M62.3242 59.2158L99.5699 65.7005', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M61.209 65.6006L98.4593 72.0853', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M58.6836 80.1172L95.9293 86.6019', stroke: '#D6DCE8', strokeWidth: 5, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M66.5195 35.0947L78.3837 37.1589', stroke: '#D6DCE8', strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: 'round' }),
        react.createElement("path", { d: 'M16.1274 92.7538C18.8664 92.7538 21.0868 90.5334 21.0868 87.7944C21.0868 85.0554 18.8664 82.835 16.1274 82.835C13.3884 82.835 11.168 85.0554 11.168 87.7944C11.168 90.5334 13.3884 92.7538 16.1274 92.7538Z', fill: '#F1F3F9' }),
        react.createElement("path", { d: 'M109.151 39.9676C111.89 39.9676 114.11 37.7472 114.11 35.0082C114.11 32.2692 111.89 30.0488 109.151 30.0488C106.412 30.0488 104.191 32.2692 104.191 35.0082C104.191 37.7472 106.412 39.9676 109.151 39.9676Z', fill: '#F1F3F9' }),
        react.createElement("path", { d: 'M21.0319 29.9525C22.4367 29.9525 23.5755 28.8137 23.5755 27.4089C23.5755 26.0041 22.4367 24.8652 21.0319 24.8652C19.6271 24.8652 18.4883 26.0041 18.4883 27.4089C18.4883 28.8137 19.6271 29.9525 21.0319 29.9525Z', fill: '#F1F3F9' }),
        react.createElement("path", { d: 'M119.956 24.222C121.361 24.222 122.499 23.0832 122.499 21.6784C122.499 20.2736 121.361 19.1348 119.956 19.1348C118.551 19.1348 117.412 20.2736 117.412 21.6784C117.412 23.0832 118.551 24.222 119.956 24.222Z', fill: '#F1F3F9' }),
        react.createElement("path", { d: 'M73.1383 82.1273C81.2822 82.1273 87.8841 75.5254 87.8841 67.3815C87.8841 59.2376 81.2822 52.6357 73.1383 52.6357C64.9945 52.6357 58.3926 59.2376 58.3926 67.3815C58.3926 75.5254 64.9945 82.1273 73.1383 82.1273Z', fill: 'white' }),
        react.createElement("path", { d: 'M102.25 90.3741L90.5413 78.5281C92.8703 75.0301 94.1718 70.7922 93.9983 66.2392C93.601 55.7724 85.2303 47.1003 74.7863 46.3514C62.6527 45.4837 52.332 55.0829 52.5101 67.0475C52.6882 78.7245 61.9357 87.9629 73.261 87.7985C77.7501 87.7345 81.9011 86.3554 85.2942 83.9305L96.8524 95.6942C98.3092 97.1738 100.684 97.2104 102.182 95.7719C103.707 94.306 103.739 91.8765 102.25 90.3741ZM87.847 67.3352C87.847 75.3908 81.3121 81.9257 73.2565 81.9257C65.2009 81.9257 58.666 75.3954 58.666 67.3352C58.666 59.2751 65.1963 52.7447 73.2565 52.7447C81.3166 52.7447 87.847 59.2751 87.847 67.3352Z', fill: '#D6DCE8', stroke: '#C6CCD7', strokeMiterlimit: 10 }),
        react.createElement("path", { d: 'M73.1969 59.5264C75.6994 59.5264 77.9554 60.8142 77.9554 63.4948C77.9554 65.3854 76.832 66.285 75.7679 67.0751C74.4801 68.0432 74.0006 68.4085 74.0006 69.6552V70.2672H71.5757L71.562 69.5C71.4844 67.8651 72.384 66.8422 73.5851 65.9882C74.6171 65.221 75.2884 64.7232 75.2884 63.6318C75.2884 62.2298 74.2107 61.6544 73.0645 61.6544C71.5438 61.6544 70.7766 62.6774 70.7629 63.988H68.3197C68.2512 60.6863 70.8222 59.5309 73.2015 59.5309L73.1969 59.5264ZM72.8316 72.313C73.8454 72.313 74.4893 72.9021 74.4893 73.7789C74.4893 74.6557 73.8454 75.2357 72.8316 75.2357C71.8863 75.2357 71.2104 74.6375 71.2104 73.7789C71.2104 72.9204 71.8771 72.313 72.8316 72.313Z', fill: '#797D8B' })));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AIStarListIcon/index.js
'use client';



var AIStarListIcon = function () { return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none' },
    react.createElement("g", { clipPath: 'url(#clip0_37938_279327)' },
        react.createElement("path", { d: 'M15.944 5.798a.32.32 0 0 0-.264-.245L11.4 4.9l.315-4.318a.32.32 0 0 0-.536-.258l-3.18 2.938L4.82.324a.32.32 0 0 0-.536.258L4.598 4.9l-4.28.653a.32.32 0 0 0-.132.58L3.758 8.58l-2.157 3.753a.32.32 0 0 0 .371.466l4.14-1.268 1.59 4.027a.32.32 0 0 0 .595 0l1.59-4.027 4.14 1.268a.32.32 0 0 0 .37-.466L12.24 8.58l3.572-2.447a.32.32 0 0 0 .132-.335', fill: 'url(#paint0_linear_37938_279327)' })),
    react.createElement("defs", null,
        react.createElement("linearGradient", { id: 'paint0_linear_37938_279327', x1: 0.047, y1: 7.999, x2: 15.951, y2: 7.999, gradientUnits: 'userSpaceOnUse' },
            react.createElement("stop", { stopColor: '#FE8323' }),
            react.createElement("stop", { offset: 0.5, stopColor: '#FF3C68' }),
            react.createElement("stop", { offset: 0.75, stopColor: '#DC1EAF' }),
            react.createElement("stop", { offset: 1, stopColor: '#B300D7' })),
        react.createElement("clipPath", { id: 'clip0_37938_279327' },
            react.createElement("path", { fill: '#fff', d: 'M0 0h16v16H0z' }))))); };


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AISalaryIcon/index.js
'use client';



var AISalaryIcon = function () { return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 20, height: 21, viewBox: '0 0 20 21', fill: 'none' },
    react.createElement("path", { d: 'M2.665 3.834q-.13 0-.257.026l-.021.005a1.33 1.33 0 0 0-1.055 1.302v8q0 .13.026.258l.005.021a1.33 1.33 0 0 0 1.302 1.055h14.667q.13-.001.258-.026l.02-.006a1.33 1.33 0 0 0 1.055-1.302v-8q0-.13-.026-.257l-.005-.021a1.33 1.33 0 0 0-1.302-1.055zM4 5.167h12a1.334 1.334 0 0 0 1.333 1.334v5.333A1.334 1.334 0 0 0 16 13.167H4a1.333 1.333 0 0 0-1.334-1.333V6.501A1.333 1.333 0 0 0 4 5.167m6 1.334c-1.473 0-2.667 1.343-2.667 3a3.13 3.13 0 0 0 1.01 2.333h3.314a3.13 3.13 0 0 0 1.01-2.333c0-1.657-1.195-3-2.667-3m-5.334 2a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m10.667 0a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333M2.665 15.834a.667.667 0 1 0 0 1.333h14.667a.667.667 0 1 0 0-1.333z', fill: 'url(#paint0_linear_37938_279357)' }),
    react.createElement("defs", null,
        react.createElement("linearGradient", { id: 'paint0_linear_37938_279357', x1: 1.332, y1: 10.501, x2: 18.665, y2: 10.501, gradientUnits: 'userSpaceOnUse' },
            react.createElement("stop", { stopColor: '#FE8323' }),
            react.createElement("stop", { offset: 0.5, stopColor: '#FF3C68' }),
            react.createElement("stop", { offset: 0.75, stopColor: '#DC1EAF' }),
            react.createElement("stop", { offset: 1, stopColor: '#B300D7' }))))); };


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/icons/WarnIcon.js
var WarnIcon = __webpack_require__(29451);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountSettingsIcon.js
'use client';



var AccountSettingsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_3011_6580)' },
            react.createElement("path", { d: 'M22.6368 10.186L19.8 9.72236C19.6339 9.15308 19.4069 8.60588 19.1227 8.08796L20.7787 5.7278C20.9126 5.53724 20.8896 5.27756 20.7249 5.11244L18.8582 3.24668C18.6917 3.0806 18.4296 3.059 18.2385 3.19676L15.9139 4.86764C15.3912 4.57868 14.8392 4.34924 14.2665 4.18268L13.7717 1.3574C13.7313 1.12796 13.5321 0.959961 13.2989 0.959961H10.6589C10.4237 0.959961 10.223 1.13036 10.1851 1.36268L9.72622 4.1726C9.15022 4.3382 8.59726 4.56524 8.07646 4.85036L5.75806 3.19436C5.56654 3.05756 5.3059 3.07964 5.13934 3.24524L3.27358 5.111C3.10894 5.27564 3.0859 5.53484 3.21982 5.7254L4.85134 8.05964C4.56094 8.58524 4.32958 9.14156 4.1611 9.72044L1.36222 10.1865C1.13086 10.2249 0.960938 10.4256 0.960938 10.6598V13.2998C0.960938 13.5326 1.12798 13.7318 1.35694 13.7726L4.15582 14.2689C4.32334 14.8464 4.5547 15.4027 4.84606 15.9297L3.19438 18.24C3.05806 18.4305 3.07966 18.6921 3.24526 18.8587L5.1115 20.7264C5.27614 20.891 5.53582 20.914 5.72638 20.7801L8.06398 19.1428C8.58862 19.4313 9.14302 19.6603 9.71758 19.8264L10.1861 22.6396C10.224 22.8705 10.4241 23.04 10.6589 23.04H13.2989C13.5317 23.04 13.7309 22.8729 13.7712 22.644L14.2728 19.8168C14.8483 19.6473 15.3998 19.4169 15.9192 19.128L18.2736 20.7796C18.4646 20.9145 18.7238 20.891 18.8889 20.7264L20.7552 18.8587C20.9213 18.6921 20.9429 18.4296 20.8051 18.2385L19.1261 15.9072C19.4107 15.3888 19.6368 14.8406 19.8014 14.2713L22.6421 13.7726C22.872 13.7323 23.039 13.5326 23.039 13.2998V10.6598C23.0395 10.4246 22.8691 10.224 22.6368 10.186ZM12 15.36C10.1443 15.36 8.63998 13.8556 8.63998 12C8.63998 10.1443 10.1443 8.63996 12 8.63996C13.8557 8.63996 15.36 10.1443 15.36 12C15.36 13.8556 13.8557 15.36 12 15.36Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_3011_6580' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var AccountSettingsIcon$1 = react.memo(AccountSettingsIcon);


//# sourceMappingURL=AccountSettingsIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/DashboardIcon.js
'use client';



var DashboardIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M12 3.35986C5.91184 3.35986 0.959961 8.31174 0.959961 14.3999C0.959961 16.048 1.28809 17.5424 1.94621 18.9449C1.97621 19.0105 2.00809 19.0742 2.03809 19.1399C2.08309 19.228 2.12621 19.318 2.17309 19.4061C2.35121 19.753 2.54059 20.0942 2.75621 20.4224C2.84434 20.5574 2.99434 20.6399 3.15746 20.6399H20.8425C21.0056 20.6399 21.1556 20.5574 21.2437 20.4224C21.4593 20.0942 21.6487 19.753 21.8268 19.4061C21.8718 19.318 21.9168 19.228 21.9618 19.1399C21.9918 19.0742 22.0237 19.0105 22.0537 18.9449C22.7118 17.5424 23.04 16.048 23.04 14.3999C23.04 8.31174 18.0881 3.35986 12 3.35986ZM14.88 18.7199H9.11996C8.85371 18.7199 8.63996 18.5042 8.63996 18.2399C8.63996 17.9755 8.85371 17.7599 9.11996 17.7599H14.88C15.1462 17.7599 15.36 17.9755 15.36 18.2399C15.36 18.5042 15.1462 18.7199 14.88 18.7199ZM17.4412 11.7636L12.9581 14.3905C12.9581 14.3942 12.96 14.3961 12.96 14.3999C12.96 14.9305 12.5306 15.3599 12 15.3599C11.4693 15.3599 11.04 14.9305 11.04 14.3999C11.04 13.8692 11.4693 13.4399 12 13.4399C12.1706 13.4399 12.3281 13.4886 12.4668 13.5655L16.9518 10.9367C17.1787 10.8017 17.475 10.8767 17.61 11.1055C17.745 11.3342 17.67 11.6286 17.4412 11.7636ZM20.7206 19.4399C20.6306 19.5936 20.4693 19.6799 20.3043 19.6799C20.2818 19.6799 20.2575 19.6742 20.235 19.6705C20.2106 19.6742 20.1843 19.6799 20.16 19.6799C20.0681 19.6799 19.9762 19.6536 19.8937 19.5992L18.4537 18.6392C18.2325 18.493 18.1725 18.1949 18.3206 17.9736C18.4668 17.7524 18.765 17.6924 18.9862 17.8405L20.0943 18.5792C20.1 18.568 20.1056 18.5567 20.1112 18.5474C20.1131 18.5192 20.1131 18.4911 20.1337 18.4967C20.1356 18.4967 20.1375 18.4967 20.1375 18.4967C20.7075 17.368 21.0375 16.1342 21.105 14.8799H19.68C19.4137 14.8799 19.2 14.6661 19.2 14.3999C19.2 14.1355 19.4137 13.9199 19.68 13.9199H21.0956C21.0281 12.6299 20.6943 11.413 20.1431 10.318C20.1318 10.2974 20.115 10.2805 20.1037 10.258L18.9712 10.9536C18.8925 11.0024 18.8062 11.0249 18.72 11.0249C18.5587 11.0249 18.4012 10.9424 18.3112 10.7942C18.1725 10.5692 18.2437 10.273 18.4687 10.1342L19.6237 9.42736C19.5881 9.37299 19.56 9.31861 19.53 9.26424C18.8137 8.21799 17.8818 7.33299 16.8018 6.66174C16.7831 6.65049 16.7606 6.63924 16.7418 6.62799L16.05 7.88236C15.9618 8.03986 15.7987 8.12986 15.6281 8.12986C15.5512 8.12986 15.4706 8.11111 15.3975 8.06986C15.165 7.94236 15.0806 7.64986 15.21 7.41736L15.8981 6.17049C15.8868 6.16486 15.8756 6.15736 15.8643 6.15174C14.8256 5.66236 13.6837 5.36799 12.4781 5.30424V6.71986C12.4781 6.98424 12.2643 7.19986 11.9981 7.19986C11.7337 7.19986 11.5181 6.98424 11.5181 6.71986V5.30424C10.2112 5.37361 8.97559 5.71486 7.86934 6.27924C7.82996 6.30361 7.78871 6.32799 7.74934 6.34861L8.48809 7.54299C8.62684 7.76799 8.55746 8.06424 8.33059 8.20299C8.25184 8.25174 8.16559 8.27424 8.07934 8.27424C7.91809 8.27424 7.76246 8.19361 7.67059 8.04736L6.92621 6.83986C6.89246 6.86236 6.85871 6.87924 6.82496 6.89799C5.77871 7.62361 4.89746 8.56111 4.23184 9.64674L5.42809 10.2974C5.66246 10.4249 5.74871 10.7155 5.62121 10.948C5.53496 11.1092 5.36996 11.1992 5.19934 11.1992C5.12246 11.1992 5.04371 11.1805 4.97059 11.1411L3.77246 10.4905C3.27184 11.5405 2.96809 12.6974 2.90434 13.9199H4.31996C4.58621 13.9199 4.79996 14.1355 4.79996 14.3999C4.79996 14.6642 4.58621 14.8799 4.31996 14.8799H2.89496C2.96246 16.1249 3.28496 17.3474 3.84746 18.4686C3.85121 18.478 3.86059 18.4874 3.86621 18.4949C3.88121 18.5249 3.91121 18.5755 3.91121 18.5755L5.01371 17.8405C5.23496 17.6924 5.53309 17.7524 5.67934 17.9736C5.82746 18.193 5.76746 18.4911 5.54621 18.6392L4.10621 19.5992C4.02371 19.6536 3.93184 19.6799 3.83996 19.6799C3.83434 19.6799 3.82684 19.6649 3.81746 19.6555C3.61496 19.7099 3.38996 19.633 3.27934 19.4399C2.39059 17.9042 1.91996 16.1624 1.91996 14.3999C1.91996 8.84236 6.44246 4.31986 12 4.31986C17.5575 4.31986 22.08 8.84236 22.08 14.3999C22.08 16.1624 21.6093 17.9042 20.7206 19.4399Z', fill: color })));
};
var DashboardIcon$1 = react.memo(DashboardIcon);


//# sourceMappingURL=DashboardIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/JobAlertsIcon.js
'use client';



var JobAlertsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M12 2.3999C11.116 2.3999 10.4 3.1159 10.4 3.9999V4.20928C7.64139 4.92094 5.59999 7.41914 5.59999 10.3999V12.3155C5.59999 13.5875 5.33876 14.8375 4.85156 15.9999H19.1484C18.6612 14.8383 18.4 13.5875 18.4 12.3155V10.3999C18.4 7.41914 16.3586 4.92094 13.6 4.20928V3.9999C13.6 3.1159 12.884 2.3999 12 2.3999ZM3.99999 17.5999C3.89398 17.5984 3.78873 17.618 3.69036 17.6575C3.59198 17.6971 3.50245 17.7557 3.42695 17.8302C3.35146 17.9046 3.29151 17.9933 3.25059 18.0911C3.20967 18.1889 3.1886 18.2939 3.1886 18.3999C3.1886 18.5059 3.20967 18.6109 3.25059 18.7087C3.29151 18.8065 3.35146 18.8952 3.42695 18.9696C3.50245 19.0441 3.59198 19.1028 3.69036 19.1423C3.78873 19.1818 3.89398 19.2014 3.99999 19.1999H9.74062C9.64863 19.4566 9.60107 19.7272 9.59999 19.9999C9.59999 20.6364 9.85285 21.2469 10.3029 21.697C10.753 22.147 11.3635 22.3999 12 22.3999C12.6365 22.3999 13.247 22.147 13.697 21.697C14.1471 21.2469 14.4 20.6364 14.4 19.9999C14.3994 19.7273 14.3524 19.4567 14.2609 19.1999H20C20.106 19.2014 20.2113 19.1818 20.3096 19.1423C20.408 19.1028 20.4975 19.0441 20.573 18.9696C20.6485 18.8952 20.7085 18.8065 20.7494 18.7087C20.7903 18.6109 20.8114 18.5059 20.8114 18.3999C20.8114 18.2939 20.7903 18.1889 20.7494 18.0911C20.7085 17.9933 20.6485 17.9046 20.573 17.8302C20.4975 17.7557 20.408 17.6971 20.3096 17.6575C20.2113 17.618 20.106 17.5984 20 17.5999H12H3.99999Z', fill: color })));
};
var JobAlertsIcon$1 = react.memo(JobAlertsIcon);


//# sourceMappingURL=JobAlertsIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/LogoutIcon.js
'use client';



var LogoutIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M3.33333 2C2.598 2 2 2.598 2 3.33333V16.6667C2 17.402 2.598 18 3.33333 18H12.6667C13.402 18 14 17.402 14 16.6667V10.6667H8.66667C8.29867 10.6667 8 10.368 8 10C8 9.632 8.29867 9.33333 8.66667 9.33333H14V3.33333C14 2.598 13.402 2 12.6667 2H3.33333ZM14 9.33333V10.6667H17.724L16.1953 12.1953C16.1313 12.2567 16.0802 12.3303 16.0451 12.4117C16.0099 12.4932 15.9913 12.5808 15.9904 12.6695C15.9895 12.7582 16.0063 12.8462 16.0398 12.9283C16.0733 13.0104 16.1229 13.085 16.1856 13.1477C16.2483 13.2104 16.3229 13.26 16.4051 13.2935C16.4872 13.3271 16.5752 13.3439 16.6639 13.343C16.7526 13.3421 16.8402 13.3235 16.9216 13.2883C17.003 13.2531 17.0766 13.202 17.138 13.138L19.8047 10.4714C19.9297 10.3463 19.9999 10.1768 19.9999 10C19.9999 9.82322 19.9297 9.65368 19.8047 9.52865L17.138 6.86198C17.0759 6.79812 17.0016 6.74735 16.9195 6.71269C16.8374 6.67802 16.7493 6.66016 16.6602 6.66016C16.5275 6.66019 16.3979 6.69978 16.2879 6.77385C16.1779 6.84793 16.0925 6.95313 16.0426 7.076C15.9927 7.19888 15.9806 7.33384 16.0078 7.46365C16.035 7.59345 16.1003 7.71219 16.1953 7.80469L17.724 9.33333H14Z', fill: color })));
};


//# sourceMappingURL=LogoutIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MyCompaniesIcon.js
'use client';



var MyCompaniesIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M4.80002 2.39998C4.69401 2.39848 4.58876 2.41807 4.49038 2.4576C4.39201 2.49713 4.30247 2.55582 4.22698 2.63025C4.15148 2.70469 4.09153 2.79339 4.05061 2.89119C4.00969 2.989 3.98862 3.09396 3.98862 3.19998C3.98862 3.306 4.00969 3.41097 4.05061 3.50877C4.09153 3.60658 4.15148 3.69527 4.22698 3.76971C4.30247 3.84415 4.39201 3.90283 4.49038 3.94237C4.58876 3.9819 4.69401 4.00148 4.80002 3.99998H12.8C12.906 4.00148 13.0113 3.9819 13.1097 3.94237C13.208 3.90283 13.2976 3.84415 13.3731 3.76971C13.4486 3.69527 13.5085 3.60658 13.5494 3.50877C13.5903 3.41097 13.6114 3.306 13.6114 3.19998C13.6114 3.09396 13.5903 2.989 13.5494 2.89119C13.5085 2.79339 13.4486 2.70469 13.3731 2.63025C13.2976 2.55582 13.208 2.49713 13.1097 2.4576C13.0113 2.41807 12.906 2.39848 12.8 2.39998H4.80002ZM2.40002 5.59998C2.29401 5.59848 2.18876 5.61807 2.09038 5.6576C1.99201 5.69713 1.90247 5.75582 1.82698 5.83025C1.75148 5.90469 1.69153 5.99339 1.65061 6.09119C1.60969 6.189 1.58862 6.29396 1.58862 6.39998C1.58862 6.506 1.60969 6.61097 1.65061 6.70877C1.69153 6.80658 1.75148 6.89528 1.82698 6.96971C1.90247 7.04415 1.99201 7.10284 2.09038 7.14237C2.18876 7.1819 2.29401 7.20148 2.40002 7.19998V20.8H7.20002V17.6H10.4V20.8H15.2V7.19998C15.306 7.20148 15.4113 7.1819 15.5097 7.14237C15.608 7.10284 15.6976 7.04415 15.7731 6.96971C15.8486 6.89528 15.9085 6.80658 15.9494 6.70877C15.9903 6.61097 16.0114 6.506 16.0114 6.39998C16.0114 6.29396 15.9903 6.189 15.9494 6.09119C15.9085 5.99339 15.8486 5.90469 15.7731 5.83025C15.6976 5.75582 15.608 5.69713 15.5097 5.6576C15.4113 5.61807 15.306 5.59848 15.2 5.59998H2.40002ZM4.00002 7.99998H5.60002V9.59998H4.00002V7.99998ZM7.20002 7.99998H10.4V9.59998H7.20002V7.99998ZM12 7.99998H13.6V9.59998H12V7.99998ZM16.8 7.99998V10.4V12V13.6V15.2V16.8V18.4V20.8H21.6V7.99998H16.8ZM18.4 10.4H20V12H18.4V10.4ZM4.00002 11.2H5.60002V12.8H4.00002V11.2ZM7.20002 11.2H10.4V12.8H7.20002V11.2ZM12 11.2H13.6V12.8H12V11.2ZM18.4 13.6H20V15.2H18.4V13.6ZM4.00002 14.4H5.60002V16H4.00002V14.4ZM7.20002 14.4H10.4V16H7.20002V14.4ZM12 14.4H13.6V16H12V14.4ZM18.4 16.8H20V18.4H18.4V16.8ZM4.00002 17.6H5.60002V19.2H4.00002V17.6ZM12 17.6H13.6V19.2H12V17.6Z', fill: color })));
};
var MyCompaniesIcon$1 = react.memo(MyCompaniesIcon);


//# sourceMappingURL=MyCompaniesIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MyJobsIcon.js
'use client';



var MyJobsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M11.2 2.3999C10.316 2.3999 9.59998 3.1159 9.59998 3.9999H3.19998C2.31598 3.9999 1.59998 4.7159 1.59998 5.5999V12.7999C1.59998 13.6839 2.31598 14.3999 3.19998 14.3999H20.8C21.684 14.3999 22.4 13.6839 22.4 12.7999V5.5999C22.4 4.7159 21.684 3.9999 20.8 3.9999H14.4C14.4 3.1159 13.684 2.3999 12.8 2.3999H11.2ZM12 11.1999C12.4416 11.1999 12.8 11.5583 12.8 11.9999C12.8 12.4415 12.4416 12.7999 12 12.7999C11.5584 12.7999 11.2 12.4415 11.2 11.9999C11.2 11.5583 11.5584 11.1999 12 11.1999ZM1.59998 15.5546V18.3999C1.59998 19.2839 2.31598 19.9999 3.19998 19.9999H20.8C21.684 19.9999 22.4 19.2839 22.4 18.3999V15.5546C21.9272 15.8298 21.3856 15.9999 20.8 15.9999H3.19998C2.61438 15.9999 2.07278 15.8298 1.59998 15.5546Z', fill: color })));
};
var MyJobsIcon$1 = react.memo(MyJobsIcon);


//# sourceMappingURL=MyJobsIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/MyProfileIcon.js
'use client';



var MyProfileIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M5.6 1.6001C4.716 1.6001 4 2.3161 4 3.2001V20.8001C4 21.6841 4.716 22.4001 5.6 22.4001H13.05C13.6612 20.6225 15.2518 20.0363 16.1078 19.7235C16.1574 19.7051 16.2135 19.6842 16.2703 19.6626C16.0815 19.4146 15.9031 19.1368 15.7688 18.8392C15.3703 18.4136 15.0797 17.7903 15.0797 17.0079C15.0797 16.8727 15.0894 16.7443 15.1078 16.6235C14.9766 16.2699 14.8687 15.8289 14.8688 15.3329C14.8703 12.9385 16.6912 11.2001 19.2 11.2001C19.4856 11.2001 19.7496 11.2523 20 11.3251V7.6001C20 7.3881 19.916 7.18407 19.7656 7.03447L14.5656 1.83447C14.4152 1.68407 14.212 1.6001 14 1.6001H5.6ZM13.6 3.12354L18.4766 8.0001H14.4C13.9584 8.0001 13.6 7.6417 13.6 7.2001V3.12354ZM19.2 12.7985C17.6928 12.7985 16.4703 13.7073 16.4703 15.3329C16.4703 16.0201 16.8547 16.5548 16.8547 16.5548C16.8547 16.5548 16.6797 16.6407 16.6797 17.0079C16.6797 17.7207 17.1391 17.8923 17.1391 17.8923C17.2031 18.4571 18.0797 19.2845 18.0797 19.2845V20.2267C17.6085 21.6419 14.4 20.8313 14.4 24.0001H24C24 20.8313 20.7915 21.6419 20.3203 20.2267V19.2845C20.3203 19.2845 21.1977 18.4571 21.2609 17.8923C21.2609 17.8923 21.7203 17.5751 21.7203 17.0079C21.7203 16.6143 21.5453 16.5548 21.5453 16.5548C21.5453 16.5548 21.8594 15.9572 21.8594 15.386C21.8594 14.2412 21.2859 13.3595 20.3203 13.3595C20.3203 13.3595 19.9096 12.7985 19.2 12.7985Z', fill: color })));
};
var MyProfileIcon$1 = react.memo(MyProfileIcon);


//# sourceMappingURL=MyProfileIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/ProfileSettingsIcon.js
'use client';



var ProfileSettingsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_3011_6543)' },
            react.createElement("path", { d: 'M12 2.40137C8.60642 2.40137 7.20002 4.57817 7.20002 7.20137C7.20002 8.08457 7.6219 8.97168 7.6219 8.97168C7.4523 9.06928 7.17337 9.37909 7.24377 9.92949C7.37497 10.9559 7.81995 11.2173 8.10315 11.2389C8.21115 12.1965 9.24002 13.4214 9.60002 13.5998V15.1998C9.59827 15.2051 9.59402 15.2086 9.59221 15.2139C9.32765 15.2467 9.09162 15.4028 8.9719 15.6451L8.7219 16.1482C6.74746 17.2553 2.40002 16.9808 2.40002 21.5998H10.6438L11.6 18.467L10.6891 16.7998H11.9781H13.2703C13.5431 16.1262 13.9272 15.5124 14.4 14.9764V13.5998C14.76 13.4214 15.7889 12.1965 15.8969 11.2389C16.1801 11.2173 16.6251 10.9559 16.7563 9.92949C16.8267 9.37829 16.5477 9.06928 16.3781 8.97168C16.3781 8.97168 16.8 8.17017 16.8 7.20137C16.8 5.25897 16.0376 3.60137 14.4 3.60137C14.4 3.60137 13.8312 2.40137 12 2.40137ZM18.9516 14.3998C18.8644 14.3998 18.7909 14.4657 18.7813 14.5529L18.7625 14.7279C18.7377 14.9527 18.5677 15.13 18.3469 15.1764C18.2029 15.2068 18.0626 15.2441 17.925 15.2889C17.7106 15.3585 17.4758 15.2892 17.3422 15.1076L17.2375 14.9654C17.1855 14.895 17.0901 14.8754 17.0141 14.9186L16.5844 15.167C16.5084 15.211 16.4789 15.3042 16.5141 15.3842L16.586 15.5498C16.6764 15.7562 16.6188 15.9939 16.4516 16.1451C16.3436 16.2419 16.2414 16.3449 16.1438 16.4529C15.9926 16.6209 15.7549 16.6785 15.5485 16.5873L15.3828 16.5154C15.3028 16.4802 15.2097 16.5097 15.1656 16.5857L14.9172 17.0154C14.8732 17.0914 14.8937 17.1869 14.9641 17.2389L15.1063 17.3436C15.2879 17.4772 15.3571 17.7112 15.2875 17.9264C15.2427 18.064 15.2046 18.2042 15.175 18.3482C15.1286 18.569 14.9514 18.7391 14.7266 18.7639L14.5797 18.7795C14.4661 18.7907 14.4 18.8642 14.4 18.9514V19.4467C14.4 19.5339 14.466 19.6074 14.5531 19.617L14.7281 19.6373C14.9529 19.6621 15.1302 19.8306 15.1766 20.0514C15.207 20.1954 15.2443 20.3372 15.2891 20.4748C15.3587 20.6892 15.2894 20.924 15.1078 21.0576L14.9656 21.1607C14.8952 21.2127 14.8756 21.3097 14.9188 21.3857L15.1672 21.8139C15.2112 21.8899 15.3044 21.9209 15.3844 21.8857L15.55 21.8139C15.7564 21.7235 15.9941 21.781 16.1453 21.9482C16.2421 22.0562 16.3451 22.1585 16.4531 22.2561C16.6212 22.4073 16.6787 22.645 16.5875 22.8514L16.5156 23.0154C16.4804 23.0954 16.51 23.1902 16.586 23.2342L17.0156 23.4811C17.0917 23.5251 17.1871 23.5046 17.2391 23.4342L17.3438 23.292C17.4774 23.1104 17.7114 23.0427 17.9266 23.1123C18.0642 23.1571 18.2045 23.1936 18.3485 23.2232C18.5693 23.2696 18.7393 23.4477 18.7641 23.6717L18.7828 23.8482C18.7908 23.9346 18.8644 23.9998 18.9516 23.9998H19.4469C19.5341 23.9998 19.6076 23.9339 19.6172 23.8467L19.6375 23.6717C19.6623 23.4469 19.8308 23.2696 20.0516 23.2232C20.1956 23.1928 20.3374 23.1555 20.475 23.1107C20.6894 23.0411 20.9242 23.1104 21.0578 23.292L21.161 23.4342C21.213 23.5046 21.31 23.5243 21.386 23.4811L21.8141 23.2326C21.8901 23.1886 21.9212 23.0954 21.886 23.0154L21.8141 22.8498C21.7237 22.6434 21.7813 22.4057 21.9485 22.2545C22.0565 22.1577 22.1587 22.0547 22.2563 21.9467C22.4075 21.7787 22.6452 21.7211 22.8516 21.8123L23.0156 21.8842C23.0956 21.9194 23.1904 21.8899 23.2344 21.8139L23.4813 21.3842C23.5253 21.3082 23.5048 21.2127 23.4344 21.1607L23.2922 21.0561C23.1106 20.9225 23.0429 20.6884 23.1125 20.4732C23.1573 20.3356 23.1939 20.1954 23.2235 20.0514C23.2699 19.8306 23.4487 19.6605 23.6735 19.6357C23.7375 19.6285 23.7973 19.6226 23.8485 19.617C23.9349 19.609 24 19.5354 24 19.4482V18.9514C24 18.8642 23.9341 18.7907 23.8469 18.7811L23.6719 18.7623C23.4471 18.7375 23.2699 18.5675 23.2235 18.3467C23.1931 18.2027 23.1558 18.0624 23.111 17.9248C23.0414 17.7104 23.1106 17.4756 23.2922 17.342L23.4344 17.2373C23.5048 17.1853 23.5245 17.0899 23.4813 17.0139L23.2328 16.5842C23.1888 16.5082 23.0956 16.4787 23.0156 16.5139L22.85 16.5857C22.6436 16.6761 22.4059 16.6186 22.2547 16.4514C22.1579 16.3434 22.0549 16.2412 21.9469 16.1436C21.7789 15.9924 21.7213 15.7546 21.8125 15.5482L21.8844 15.3826C21.9196 15.3026 21.8901 15.2094 21.8141 15.1654L21.3844 14.917C21.3084 14.873 21.213 14.8935 21.161 14.9639L21.0563 15.1061C20.9227 15.2877 20.6887 15.3569 20.4735 15.2873C20.3359 15.2425 20.1956 15.2044 20.0516 15.1748C19.8308 15.1284 19.6608 14.9504 19.636 14.7264L19.6172 14.5514C19.6092 14.4658 19.5357 14.3998 19.4485 14.3998H18.9516ZM19.2 16.7998C20.5256 16.7998 21.6 17.8742 21.6 19.1998C21.6 20.5254 20.5256 21.5998 19.2 21.5998C17.8744 21.5998 16.8 20.5254 16.8 19.1998C16.8 17.8742 17.8744 16.7998 19.2 16.7998ZM19.2 18.3998C18.7584 18.3998 18.4 18.7582 18.4 19.1998C18.4 19.6414 18.7584 19.9998 19.2 19.9998C19.6416 19.9998 20 19.6414 20 19.1998C20 18.7582 19.6416 18.3998 19.2 18.3998Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_3011_6543' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var ProfileSettingsIcon$1 = react.memo(ProfileSettingsIcon);


//# sourceMappingURL=ProfileSettingsIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/LanguageIcon.js
'use client';



var LanguageIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#616161' : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12 2.3999C6.70754 2.3999 2.39999 6.70744 2.39999 11.9999C2.39999 17.2924 6.70754 21.5999 12 21.5999C17.2925 21.5999 21.6 17.2924 21.6 11.9999C21.6 6.70744 17.2925 2.3999 12 2.3999ZM12 3.9999C12.3145 3.9999 12.6403 4.13017 13.0125 4.47646C13.3846 4.82276 13.7698 5.38125 14.1 6.10771C14.2502 6.43807 14.3862 6.80692 14.5109 7.1999H9.48906C9.61381 6.80692 9.74983 6.43807 9.89999 6.10771C10.2302 5.38125 10.6153 4.82276 10.9875 4.47646C11.3596 4.13017 11.6855 3.9999 12 3.9999ZM8.87031 4.63428C8.71974 4.891 8.575 5.15802 8.44374 5.44678C8.2015 5.97971 7.99468 6.57027 7.81874 7.1999H5.60468C6.44431 6.08179 7.5651 5.18778 8.87031 4.63428ZM15.1297 4.63428C16.4349 5.18778 17.5557 6.08179 18.3953 7.1999H16.1812C16.0053 6.57027 15.7985 5.97971 15.5562 5.44678C15.425 5.15802 15.2802 4.891 15.1297 4.63428ZM4.66718 8.7999H7.46406C7.33533 9.56149 7.25121 10.3641 7.21874 11.1999H4.03906C4.12271 10.3532 4.34155 9.54732 4.66718 8.7999ZM9.09062 8.7999H14.9094C15.0497 9.54803 15.1444 10.3536 15.1812 11.1999H8.81874C8.85558 10.3536 8.95032 9.54803 9.09062 8.7999ZM16.5359 8.7999H19.3328C19.6584 9.54732 19.8773 10.3532 19.9609 11.1999H16.7812C16.7488 10.3641 16.6647 9.56149 16.5359 8.7999ZM4.03906 12.7999H7.21874C7.25121 13.6357 7.33533 14.4383 7.46406 15.1999H4.66718C4.34155 14.4525 4.12271 13.6466 4.03906 12.7999ZM8.81874 12.7999H15.1812C15.1444 13.6462 15.0497 14.4518 14.9094 15.1999H9.09062C8.95032 14.4518 8.85558 13.6462 8.81874 12.7999ZM16.7812 12.7999H19.9609C19.8773 13.6466 19.6584 14.4525 19.3328 15.1999H16.5359C16.6647 14.4383 16.7488 13.6357 16.7812 12.7999ZM5.60468 16.7999H7.81874C7.99468 17.4295 8.2015 18.0201 8.44374 18.553C8.575 18.8418 8.71974 19.1088 8.87031 19.3655C7.5651 18.812 6.44431 17.918 5.60468 16.7999ZM9.48906 16.7999H14.5109C14.3862 17.1929 14.2502 17.5617 14.1 17.8921C13.7698 18.6186 13.3846 19.177 13.0125 19.5233C12.6403 19.8696 12.3145 19.9999 12 19.9999C11.6855 19.9999 11.3596 19.8696 10.9875 19.5233C10.6153 19.177 10.2302 18.6186 9.89999 17.8921C9.74983 17.5617 9.61381 17.1929 9.48906 16.7999ZM16.1812 16.7999H18.3953C17.5557 17.918 16.4349 18.812 15.1297 19.3655C15.2802 19.1088 15.425 18.8418 15.5562 18.553C15.7985 18.0201 16.0053 17.4295 16.1812 16.7999Z', fill: color })));
};
var LanguageIcon$1 = react.memo(LanguageIcon);


//# sourceMappingURL=LanguageIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/ActivityIcon.js
'use client';




var ActivityIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M13.6002 2.3999C12.9637 2.3999 12.3532 2.65276 11.9031 3.10285C11.4531 3.55293 11.2002 4.16338 11.2002 4.7999C11.2002 5.43642 11.4531 6.04687 11.9031 6.49696C12.3532 6.94705 12.9637 7.1999 13.6002 7.1999C14.2367 7.1999 14.8472 6.94705 15.2973 6.49696C15.7473 6.04687 16.0002 5.43642 16.0002 4.7999C16.0002 4.16338 15.7473 3.55293 15.2973 3.10285C14.8472 2.65276 14.2367 2.3999 13.6002 2.3999ZM20.4002 7.1999C20.1296 7.19986 19.867 7.29127 19.6549 7.45928L16.4002 9.5999L13.2377 8.18428L13.2361 8.18584C12.9742 8.06423 12.689 8.0008 12.4002 7.9999C11.9819 8.0002 11.5741 8.13166 11.2344 8.37579C10.8947 8.61992 10.6401 8.96444 10.5064 9.36084L10.5049 9.3624L5.69707 19.9296C5.63342 20.0782 5.60047 20.2382 5.6002 20.3999C5.6002 20.7182 5.72662 21.0234 5.95167 21.2484C6.17671 21.4735 6.48194 21.5999 6.8002 21.5999C7.01684 21.5998 7.22942 21.5411 7.41539 21.43C7.60136 21.3188 7.75376 21.1594 7.85645 20.9687L9.97051 17.6093L14.8674 16.7968C15.1733 16.7796 15.4611 16.6461 15.6717 16.4235C15.8824 16.201 15.9999 15.9063 16.0002 15.5999C16 15.3591 15.9273 15.1239 15.7916 14.9249C15.6558 14.7259 15.4634 14.5724 15.2393 14.4843V14.4827L15.1549 14.453C15.1528 14.4525 15.1507 14.452 15.1486 14.4515L12.5283 13.5452L14.0408 11.1437L15.9299 11.9046H15.933C16.0808 11.9673 16.2397 11.9997 16.4002 11.9999C16.6443 11.9997 16.8825 11.925 17.083 11.7858L21.0486 9.40928C21.2177 9.30068 21.3569 9.15134 21.4532 8.97498C21.5496 8.79862 21.6001 8.60088 21.6002 8.3999C21.6002 8.08164 21.4738 7.77642 21.2487 7.55137C21.0237 7.32633 20.7185 7.1999 20.4002 7.1999ZM6.0002 7.9999C5.77151 8.00013 5.54766 8.0657 5.355 8.18889C5.16233 8.31207 5.00887 8.48774 4.9127 8.69521L4.91113 8.69678L3.32988 11.853L3.33301 11.8546C3.24625 12.0233 3.20074 12.2102 3.2002 12.3999C3.2002 12.7182 3.32662 13.0234 3.55167 13.2484C3.77671 13.4735 4.08194 13.5999 4.4002 13.5999C4.62663 13.5995 4.84832 13.535 5.03965 13.4139C5.23099 13.2928 5.38415 13.12 5.48145 12.9155L5.48301 12.9171L6.83613 10.3999H8.28144L9.02988 8.75615C9.13068 8.48335 9.27072 8.2343 9.42832 7.9999H6.0002Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var ActivityIcon$1 = react.memo(ActivityIcon);


//# sourceMappingURL=ActivityIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/AwardsIcon.js
'use client';




var AwardsIcon_AwardsIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5.59961 2.39998C5.4936 2.39848 5.38835 2.41807 5.28997 2.4576C5.1916 2.49713 5.10206 2.55582 5.02657 2.63025C4.95107 2.70469 4.89112 2.79339 4.8502 2.89119C4.80929 2.989 4.78822 3.09396 4.78822 3.19998C4.78822 3.306 4.80929 3.41097 4.8502 3.50877C4.89112 3.60658 4.95107 3.69527 5.02657 3.76971C5.10206 3.84415 5.1916 3.90283 5.28997 3.94237C5.38835 3.9819 5.4936 4.00148 5.59961 3.99998V5.89842C5.24737 5.71841 4.85238 5.59998 4.39961 5.59998C2.86266 5.59998 1.59961 6.86303 1.59961 8.39998C1.59961 9.48093 2.30456 10.3215 3.14023 11.0109C3.97591 11.7004 5.02147 12.2805 6.05586 12.7719C6.97301 13.2075 7.85848 13.5547 8.59023 13.8234C9.56106 15.1403 10.3996 16 10.3996 16H11.9996H13.5996C13.5996 16 14.4382 15.1403 15.409 13.8234C16.1407 13.5547 17.0262 13.2075 17.9434 12.7719C18.9778 12.2805 20.0233 11.7004 20.859 11.0109C21.6947 10.3215 22.3996 9.48093 22.3996 8.39998C22.3996 6.86303 21.1366 5.59998 19.5996 5.59998C19.1468 5.59998 18.7518 5.71841 18.3996 5.89842V3.99998C18.5056 4.00148 18.6109 3.9819 18.7092 3.94237C18.8076 3.90283 18.8972 3.84415 18.9727 3.76971C19.0481 3.69527 19.1081 3.60658 19.149 3.50877C19.1899 3.41097 19.211 3.306 19.211 3.19998C19.211 3.09396 19.1899 2.989 19.149 2.89119C19.1081 2.79339 19.0481 2.70469 18.9727 2.63025C18.8972 2.55582 18.8076 2.49713 18.7092 2.4576C18.6109 2.41807 18.5056 2.39848 18.3996 2.39998H5.59961ZM4.39961 7.19998C4.97294 7.19998 5.4648 7.70252 5.85273 8.39217C5.85929 8.40382 5.86349 8.41489 5.86992 8.42655C6.13589 9.49738 6.57326 10.5329 7.08242 11.4765C6.96753 11.4242 6.85851 11.3828 6.74336 11.3281C5.77775 10.8694 4.82331 10.3246 4.15898 9.77655C3.49466 9.22848 3.19961 8.71903 3.19961 8.39998C3.19961 7.72733 3.72696 7.19998 4.39961 7.19998ZM19.5996 7.19998C20.2723 7.19998 20.7996 7.72733 20.7996 8.39998C20.7996 8.71903 20.5046 9.22848 19.8402 9.77655C19.1759 10.3246 18.2215 10.8694 17.2559 11.3281C17.1407 11.3828 17.0317 11.4242 16.9168 11.4765C17.426 10.5329 17.8633 9.49738 18.1293 8.42655C18.1357 8.41489 18.1399 8.40382 18.1465 8.39217C18.5344 7.70252 19.0263 7.19998 19.5996 7.19998ZM9.59961 17.6C8.71561 17.6 7.99961 18.316 7.99961 19.2V20C7.8936 19.9985 7.78835 20.0181 7.68997 20.0576C7.5916 20.0971 7.50206 20.1558 7.42657 20.2303C7.35107 20.3047 7.29112 20.3934 7.25021 20.4912C7.20929 20.589 7.18822 20.694 7.18822 20.8C7.18822 20.906 7.20929 21.011 7.25021 21.1088C7.29112 21.2066 7.35107 21.2953 7.42657 21.3697C7.50206 21.4441 7.5916 21.5028 7.68997 21.5424C7.78835 21.5819 7.8936 21.6015 7.99961 21.6H15.9996C16.1056 21.6015 16.2109 21.5819 16.3092 21.5424C16.4076 21.5028 16.4972 21.4441 16.5727 21.3697C16.6481 21.2953 16.7081 21.2066 16.749 21.1088C16.7899 21.011 16.811 20.906 16.811 20.8C16.811 20.694 16.7899 20.589 16.749 20.4912C16.7081 20.3934 16.6481 20.3047 16.5727 20.2303C16.4972 20.1558 16.4076 20.0971 16.3092 20.0576C16.2109 20.0181 16.1056 19.9985 15.9996 20V19.2C15.9996 18.316 15.2836 17.6 14.3996 17.6H9.59961Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var AwardsIcon$1 = react.memo(AwardsIcon_AwardsIcon);


//# sourceMappingURL=AwardsIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/BonusIcon.js
'use client';




var BonusIcon_BonusIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M15.1996 1.6001C12.1068 1.6001 9.59961 4.1073 9.59961 7.2001C9.59961 10.2929 12.1068 12.8001 15.1996 12.8001C18.2924 12.8001 20.7996 10.2929 20.7996 7.2001C20.7996 4.1073 18.2924 1.6001 15.1996 1.6001ZM14.4012 3.2001H16.0012V4.00322C17.0156 4.24162 17.6772 4.92679 17.698 5.85479H16.2293C16.1949 5.41319 15.7752 5.10479 15.2152 5.10479C14.6552 5.10479 14.2871 5.37004 14.2871 5.78604C14.2871 6.12844 14.5646 6.32675 15.223 6.45635L16.0293 6.6126C17.2645 6.851 17.8199 7.41122 17.8199 8.40322C17.8191 9.47202 17.142 10.1846 15.9996 10.411V11.2001H14.3996V10.4173C13.2844 10.2053 12.6017 9.53421 12.5809 8.54541H14.0965C14.1357 9.00061 14.5912 9.29072 15.2496 9.29072C15.8432 9.29072 16.2512 9.00429 16.2512 8.59229C16.2512 8.24589 15.9765 8.06048 15.2621 7.91729L14.4402 7.75166C13.2962 7.53486 12.7059 6.91142 12.7059 5.92822C12.7059 4.93862 13.3564 4.23297 14.4012 3.99697V3.2001ZM6.39961 12.0001C6.09336 12.0004 5.78998 12.0592 5.50586 12.1735L1.59961 13.6001V20.0001L4.97617 18.5329C5.37457 18.3601 5.82533 18.354 6.22773 18.5188L13.4793 21.4813C13.4793 21.4813 13.4824 21.4813 13.4824 21.4813C13.6438 21.559 13.8205 21.5996 13.9996 21.6001C14.2068 21.5994 14.4103 21.545 14.5902 21.4423C14.5903 21.4423 14.5949 21.4423 14.5949 21.4423L21.784 17.4485L21.7824 17.447C21.9692 17.3432 22.1248 17.1915 22.2333 17.0074C22.3418 16.8234 22.3992 16.6137 22.3996 16.4001C22.3996 16.0818 22.2732 15.7766 22.0481 15.5516C21.8231 15.3265 21.5179 15.2001 21.1996 15.2001C21.0234 15.2008 20.8495 15.2402 20.6902 15.3157V15.3142L15.1996 17.6001H13.9996C14.3179 17.6001 14.6231 17.4737 14.8481 17.2486C15.0732 17.0236 15.1996 16.7184 15.1996 16.4001C15.1995 16.1469 15.1194 15.9003 14.9707 15.6954C14.8219 15.4905 14.6122 15.3379 14.3715 15.2595V15.2579L7.4168 12.2251H7.40742C7.09179 12.0779 6.74789 12.0011 6.39961 12.0001Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var BonusIcon$1 = react.memo(BonusIcon_BonusIcon);


//# sourceMappingURL=BonusIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/CanteenIcon.js
'use client';




var CanteenIcon_CanteenIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5.16094 1.6001C4.95054 1.6001 4.76969 1.74915 4.72969 1.95635C4.53609 2.97075 4 5.8897 4 7.2001C4 10.4001 6.4 11.2001 6.4 11.2001V21.2001C6.4 21.8625 6.9376 22.4001 7.6 22.4001C8.2624 22.4001 8.8 21.8625 8.8 21.2001V11.2001C8.8 11.2001 11.2 10.4001 11.2 7.2001C11.2 5.8897 10.6639 2.97075 10.4703 1.95635C10.4303 1.74915 10.2495 1.6001 10.0391 1.6001C9.79666 1.6001 9.6 1.79676 9.6 2.03916V6.68447C9.6 6.96927 9.36917 7.2001 9.08437 7.2001C8.82118 7.2001 8.60068 7.00232 8.57188 6.74072L8.04375 1.98916C8.01895 1.76756 7.83181 1.6001 7.60781 1.6001H7.6H7.59219C7.36819 1.6001 7.18105 1.76832 7.15625 1.99072L6.62812 6.74228C6.59933 7.00308 6.37882 7.2001 6.11563 7.2001C5.83083 7.2001 5.6 6.96927 5.6 6.68447V2.03916C5.6 1.79676 5.40334 1.6001 5.16094 1.6001ZM18.4 1.6001C18.2653 1.60023 18.1328 1.63439 18.0148 1.6994C17.8968 1.76441 17.7971 1.85816 17.725 1.97197C17.725 1.97197 15.2 5.6441 15.2 9.6001V11.1845C15.2 11.7101 15.3911 12.2182 15.7375 12.6142L16.8 13.6454V21.2001C16.8 21.8625 17.3376 22.4001 18 22.4001C18.6624 22.4001 19.2 21.8625 19.2 21.2001V2.4001C19.2 2.18792 19.1157 1.98444 18.9657 1.83441C18.8157 1.68438 18.6122 1.6001 18.4 1.6001Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var CanteenIcon$1 = react.memo(CanteenIcon_CanteenIcon);


//# sourceMappingURL=CanteenIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/HealthcareIcon.js
'use client';




var HealthcareIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0004 2.3999C9.60039 2.3999 8.00039 3.1999 8.00039 3.1999C8.00039 3.1999 7.20039 4.7999 7.20039 7.9999H7.30039C7.42519 8.5487 7.62227 8.97178 7.62227 8.97178C7.45267 9.06938 7.17374 9.37919 7.24414 9.92959C7.37534 10.956 7.82032 11.2158 8.10352 11.2374C8.21152 12.1958 9.24039 13.4215 9.60039 13.5999V15.1999C9.59864 15.2052 9.59439 15.2087 9.59258 15.214C9.32802 15.2468 9.09199 15.4029 8.97227 15.6452L8.72227 16.1483C6.74782 17.2554 2.40039 16.9809 2.40039 21.5999H21.6004C21.6004 16.9809 17.253 17.2554 15.2785 16.1483L15.0285 15.6452C14.9088 15.4029 14.6728 15.2468 14.4082 15.214C14.4064 15.2087 14.4021 15.2052 14.4004 15.1999V13.5999C14.7604 13.4215 15.7893 12.1966 15.8973 11.239C16.1805 11.2174 16.6254 10.956 16.7566 9.92959C16.827 9.37839 16.5481 9.06938 16.3785 8.97178L16.7082 7.9999H16.8004C16.8004 5.5999 16.0004 3.1999 16.0004 3.1999C16.0004 3.1999 14.4004 2.3999 12.0004 2.3999ZM12.0004 3.1999C12.442 3.1999 12.8004 3.5583 12.8004 3.9999V4.7999H13.6004C14.042 4.7999 14.4004 5.1583 14.4004 5.5999C14.4004 6.0415 14.042 6.3999 13.6004 6.3999H12.8004V7.1999C12.8004 7.6415 12.442 7.9999 12.0004 7.9999C11.5588 7.9999 11.2004 7.6415 11.2004 7.1999V6.3999H10.4004C9.95879 6.3999 9.60039 6.0415 9.60039 5.5999C9.60039 5.1583 9.95879 4.7999 10.4004 4.7999H11.2004V3.9999C11.2004 3.5583 11.5588 3.1999 12.0004 3.1999Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var HealthcareIcon$1 = react.memo(HealthcareIcon);


//# sourceMappingURL=HealthcareIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/KindergartenIcon.js
'use client';




var KindergartenIcon_KindergartenIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 22 23', fill: 'none' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.61404 2.64217C2.61404 1.18863 3.80267 0 5.2562 0C6.70973 0 7.89837 1.18863 7.89837 2.64217C7.89837 4.0957 6.70973 5.28433 5.2562 5.28433C3.80267 5.28433 2.61404 4.0957 2.61404 2.64217ZM1.87101 7.48615C2.13592 6.5177 2.74829 5.7247 4.1141 5.7247H6.41223C7.77804 5.7247 8.39042 6.5177 8.65532 7.48615C8.65532 7.48615 10.4168 12.9459 10.4168 12.9907C10.6369 13.6065 10.5802 14.2705 9.74246 14.2705C9.25738 14.2705 9.11805 13.9987 8.98559 13.7338L7.5269 9.59162C7.52465 9.58375 7.52167 9.57882 7.51843 9.57347C7.51671 9.57063 7.51493 9.56768 7.51314 9.5641V9.55034C7.47701 9.47809 7.40649 9.44025 7.32048 9.44025C7.19835 9.44025 7.1003 9.5383 7.1003 9.66043C7.1003 9.6701 7.10356 9.6765 7.10702 9.68332C7.10973 9.68863 7.11255 9.69418 7.11406 9.70171L9.19201 15.6741C9.23674 15.8066 9.21437 15.9407 9.15073 16.0732C9.063 16.2056 8.92711 16.2934 8.75165 16.2934H1.76092C1.58547 16.2934 1.46333 16.2056 1.37561 16.0732C1.31196 15.9407 1.27584 15.8066 1.32056 15.6741L3.41227 9.70171C3.4136 9.69509 3.41594 9.68796 3.41832 9.68072C3.42213 9.66913 3.42604 9.65725 3.42604 9.64667C3.42604 9.52454 3.32799 9.42649 3.20586 9.42649C3.11985 9.42649 3.04932 9.47809 3.0132 9.55034V9.5641C3.01141 9.56768 3.00962 9.57063 3.0079 9.57347C3.00467 9.57882 3.00168 9.58375 2.99944 9.59162L1.52698 13.7338L1.51757 13.7525C1.38837 14.0098 1.25746 14.2705 0.78387 14.2705C-0.0521272 14.2705 -0.110613 13.6065 0.109568 12.9907C0.109568 12.9459 1.87101 7.48615 1.87101 7.48615ZM17.3387 8.35319C17.1925 8.36696 17.0755 8.45468 17.0084 8.58714L15.1231 12.3302H21.8111C21.283 10.481 19.6626 8.93977 17.5038 8.36696C17.4488 8.35664 17.3869 8.34803 17.3387 8.35319ZM10.5405 13.6511C10.5405 13.3862 10.716 13.2107 10.9809 13.2107H21.5496C21.8145 13.2107 21.9899 13.3862 21.9899 13.6511C21.9899 15.2732 21.1935 16.725 19.9395 17.6969C20.877 17.9497 21.5496 18.7892 21.5496 19.8161C21.5496 21.0495 20.5811 22.0179 19.3477 22.0179C18.1144 22.0179 17.1459 21.0495 17.1459 19.8161C17.1459 19.4566 17.232 19.1229 17.3799 18.8253C17.0187 18.8907 16.6471 18.9354 16.2652 18.9354C16.0536 18.9354 15.8386 18.9285 15.6322 18.9079C15.7543 19.1848 15.8249 19.4893 15.8249 19.8161C15.8249 21.0495 14.8564 22.0179 13.6231 22.0179C12.3897 22.0179 11.4213 21.0495 11.4213 19.8161C11.4213 18.9027 11.9511 18.1304 12.7286 17.7932C11.3972 16.823 10.5405 15.3299 10.5405 13.6511ZM3.05453 16.7338V21.1374C3.05453 21.6225 3.45017 22.0181 3.93526 22.0181C4.42034 22.0181 4.81598 21.6225 4.81598 21.1374V16.7338H3.05453ZM5.2562 21.1374V16.7338H7.01764V21.1374C7.01764 21.6225 6.62201 22.0181 6.13692 22.0181C5.65184 22.0181 5.2562 21.6225 5.2562 21.1374ZM13.6231 18.4953C14.3714 18.4953 14.9442 19.0681 14.9442 19.8164C14.9442 20.5646 14.3714 21.1375 13.6231 21.1375C12.8748 21.1375 12.302 20.5646 12.302 19.8164C12.302 19.0681 12.8748 18.4953 13.6231 18.4953ZM20.669 19.8164C20.669 19.0681 20.0962 18.4953 19.3479 18.4953C18.5997 18.4953 18.0268 19.0681 18.0268 19.8164C18.0268 20.5646 18.5997 21.1375 19.3479 21.1375C20.0962 21.1375 20.669 20.5646 20.669 19.8164Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var KindergartenIcon$1 = react.memo(KindergartenIcon_KindergartenIcon);


//# sourceMappingURL=KindergartenIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/LaptopIcon.js
'use client';




var LaptopIcon_LaptopIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M2.88 3.83984C2.08608 3.83984 1.44 4.48592 1.44 5.27984V16.7998H2.4V5.27984C2.4 5.01536 2.61552 4.79984 2.88 4.79984H10.56C10.56 5.0648 10.775 5.27984 11.04 5.27984H12.96C13.225 5.27984 13.44 5.0648 13.44 4.79984H21.12C21.3845 4.79984 21.6 5.01536 21.6 5.27984V16.7998H22.56V5.27984C22.56 4.48592 21.9139 3.83984 21.12 3.83984H2.88ZM3.36 5.75984V16.7998H20.64V5.75984H3.36ZM0 17.7598V18.7198C0 19.2502 0.4296 19.6798 0.96 19.6798H23.04C23.5704 19.6798 24 19.2502 24 18.7198V17.7598H14.4C14.0928 18.067 13.6756 18.2398 13.2413 18.2398H10.7587C10.3239 18.2398 9.9072 18.067 9.6 17.7598H0Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var LaptopIcon$1 = react.memo(LaptopIcon_LaptopIcon);


//# sourceMappingURL=LaptopIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/LibraryIcon.js
'use client';




var LibraryIcon_LibraryIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0003 1.6001C11.8683 1.60019 11.7384 1.63294 11.6221 1.69541C11.6206 1.69645 11.619 1.69749 11.6174 1.69854L2.89401 6.46104C2.74786 6.5216 2.62294 6.62414 2.53505 6.75569C2.44717 6.88724 2.40026 7.04189 2.40026 7.2001C2.40026 7.41227 2.48455 7.61575 2.63458 7.76578C2.7846 7.91581 2.98809 8.0001 3.20026 8.0001H4.80026V16.0001H4.00026C3.89425 15.9986 3.789 16.0182 3.69063 16.0577C3.59225 16.0972 3.50272 16.1559 3.42722 16.2304C3.35172 16.3048 3.29177 16.3935 3.25086 16.4913C3.20994 16.5891 3.18887 16.6941 3.18887 16.8001C3.18887 16.9061 3.20994 17.0111 3.25086 17.1089C3.29177 17.2067 3.35172 17.2954 3.42722 17.3698C3.50272 17.4443 3.59225 17.5029 3.69063 17.5425C3.789 17.582 3.89425 17.6016 4.00026 17.6001H20.0003C20.1063 17.6016 20.2115 17.582 20.3099 17.5425C20.4083 17.5029 20.4978 17.4443 20.5733 17.3698C20.6488 17.2954 20.7087 17.2067 20.7497 17.1089C20.7906 17.0111 20.8117 16.9061 20.8117 16.8001C20.8117 16.6941 20.7906 16.5891 20.7497 16.4913C20.7087 16.3935 20.6488 16.3048 20.5733 16.2304C20.4978 16.1559 20.4083 16.0972 20.3099 16.0577C20.2115 16.0182 20.1063 15.9986 20.0003 16.0001H19.2003V8.0001H20.8003C21.0124 8.0001 21.2159 7.91581 21.3659 7.76578C21.516 7.61575 21.6003 7.41227 21.6003 7.2001C21.6 7.04216 21.5529 6.88784 21.465 6.7566C21.3772 6.62536 21.2524 6.52306 21.1065 6.4626C21.1065 6.46208 21.1065 6.46156 21.1065 6.46104L12.3784 1.69541C12.2621 1.63294 12.1322 1.60019 12.0003 1.6001ZM12.0003 4.0001C12.4419 4.0001 12.8003 4.3585 12.8003 4.8001C12.8003 5.2417 12.4419 5.6001 12.0003 5.6001C11.5587 5.6001 11.2003 5.2417 11.2003 4.8001C11.2003 4.3585 11.5587 4.0001 12.0003 4.0001ZM6.40026 8.0001H8.00026V16.0001H6.40026V8.0001ZM9.60026 8.0001H11.2003V16.0001H9.60026V8.0001ZM12.8003 8.0001H14.4003V16.0001H12.8003V8.0001ZM16.0003 8.0001H17.6003V16.0001H16.0003V8.0001ZM2.40026 19.2001C2.29425 19.1986 2.189 19.2182 2.09063 19.2577C1.99225 19.2972 1.90272 19.3559 1.82722 19.4304C1.75172 19.5048 1.69177 19.5935 1.65086 19.6913C1.60994 19.7891 1.58887 19.8941 1.58887 20.0001C1.58887 20.1061 1.60994 20.2111 1.65086 20.3089C1.69177 20.4067 1.75172 20.4954 1.82722 20.5698C1.90272 20.6443 1.99225 20.7029 2.09063 20.7425C2.189 20.782 2.29425 20.8016 2.40026 20.8001H21.6003C21.7063 20.8016 21.8115 20.782 21.9099 20.7425C22.0083 20.7029 22.0978 20.6443 22.1733 20.5698C22.2488 20.4954 22.3087 20.4067 22.3497 20.3089C22.3906 20.2111 22.4117 20.1061 22.4117 20.0001C22.4117 19.8941 22.3906 19.7891 22.3497 19.6913C22.3087 19.5935 22.2488 19.5048 22.1733 19.4304C22.0978 19.3559 22.0083 19.2972 21.9099 19.2577C21.8115 19.2182 21.7063 19.1986 21.6003 19.2001H2.40026Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var LibraryIcon$1 = react.memo(LibraryIcon_LibraryIcon);


//# sourceMappingURL=LibraryIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/MoreIcon.js
'use client';




var MoreIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5 10C3.89533 10 3 10.8953 3 12C3 13.1047 3.89533 14 5 14C6.10467 14 7 13.1047 7 12C7 10.8953 6.10467 10 5 10ZM11.6667 10C10.562 10 9.66667 10.8953 9.66667 12C9.66667 13.1047 10.562 14 11.6667 14C12.7713 14 13.6667 13.1047 13.6667 12C13.6667 10.8953 12.7713 10 11.6667 10ZM18.3333 10C17.2287 10 16.3333 10.8953 16.3333 12C16.3333 13.1047 17.2287 14 18.3333 14C19.438 14 20.3333 13.1047 20.3333 12C20.3333 10.8953 19.438 10 18.3333 10Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var MoreIcon$1 = react.memo(MoreIcon);


//# sourceMappingURL=MoreIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/PaidLeaveIcon.js
'use client';




var PaidLeaveIcon_PaidLeaveIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M3.19961 3.2002C3.09571 3.20054 2.9921 3.21101 2.89023 3.23145C2.88176 3.23315 2.87366 3.23586 2.86523 3.2377C2.50741 3.31416 2.18661 3.51096 1.95631 3.79529C1.726 4.07962 1.60011 4.4343 1.59961 4.8002V14.4002C1.59996 14.5041 1.61042 14.6077 1.63086 14.7096C1.63256 14.718 1.63527 14.7261 1.63711 14.7346C1.71358 15.0924 1.91038 15.4132 2.19471 15.6435C2.47903 15.8738 2.83371 15.9997 3.19961 16.0002H20.7996C20.9035 15.9998 21.0071 15.9894 21.109 15.9689C21.1175 15.9672 21.1256 15.9645 21.134 15.9627C21.4918 15.8862 21.8126 15.6894 22.0429 15.4051C22.2732 15.1208 22.3991 14.7661 22.3996 14.4002V4.8002C22.3993 4.6963 22.3888 4.59269 22.3684 4.49082C22.3667 4.48235 22.3639 4.47425 22.3621 4.46582C22.2856 4.108 22.0888 3.7872 21.8045 3.55689C21.5202 3.32659 21.1655 3.20069 20.7996 3.2002H3.19961ZM4.79961 4.8002H19.1996C19.1996 5.22454 19.3682 5.63151 19.6682 5.93157C19.9683 6.23162 20.3753 6.4002 20.7996 6.4002V12.8002C20.3753 12.8002 19.9683 12.9688 19.6682 13.2688C19.3682 13.5689 19.1996 13.9758 19.1996 14.4002H4.79961C4.79961 13.9758 4.63104 13.5689 4.33098 13.2688C4.03092 12.9688 3.62396 12.8002 3.19961 12.8002V6.4002C3.62396 6.4002 4.03092 6.23162 4.33098 5.93157C4.63104 5.63151 4.79961 5.22454 4.79961 4.8002ZM11.9996 6.4002C10.2324 6.4002 8.79961 8.0122 8.79961 10.0002C8.79961 11.1378 9.27775 12.1402 10.0105 12.8002H13.9887C14.7215 12.1402 15.1996 11.1378 15.1996 10.0002C15.1996 8.0122 13.7668 6.4002 11.9996 6.4002ZM5.59961 8.8002C5.38744 8.8002 5.18395 8.88448 5.03392 9.03451C4.88389 9.18454 4.79961 9.38802 4.79961 9.6002C4.79961 9.81237 4.88389 10.0159 5.03392 10.1659C5.18395 10.3159 5.38744 10.4002 5.59961 10.4002C5.81178 10.4002 6.01527 10.3159 6.16529 10.1659C6.31532 10.0159 6.39961 9.81237 6.39961 9.6002C6.39961 9.38802 6.31532 9.18454 6.16529 9.03451C6.01527 8.88448 5.81178 8.8002 5.59961 8.8002ZM18.3996 8.8002C18.1874 8.8002 17.984 8.88448 17.8339 9.03451C17.6839 9.18454 17.5996 9.38802 17.5996 9.6002C17.5996 9.81237 17.6839 10.0159 17.8339 10.1659C17.984 10.3159 18.1874 10.4002 18.3996 10.4002C18.6118 10.4002 18.8153 10.3159 18.9653 10.1659C19.1153 10.0159 19.1996 9.81237 19.1996 9.6002C19.1996 9.38802 19.1153 9.18454 18.9653 9.03451C18.8153 8.88448 18.6118 8.8002 18.3996 8.8002ZM20.7871 17.5893C20.7484 17.5901 20.7097 17.5938 20.6715 17.6002H19.9996V18.4002V19.2002C19.3286 19.2002 18.7561 19.6133 18.5184 20.1986C17.7539 19.9139 16.7973 19.5778 15.559 19.2299C12.6529 18.4134 8.48166 17.6002 3.19961 17.6002C3.0936 17.5987 2.98835 17.6183 2.88997 17.6578C2.7916 17.6973 2.70206 17.756 2.62657 17.8305C2.55107 17.9049 2.49112 17.9936 2.4502 18.0914C2.40929 18.1892 2.38822 18.2942 2.38822 18.4002C2.38822 18.5062 2.40929 18.6112 2.4502 18.709C2.49112 18.8068 2.55107 18.8955 2.62657 18.9699C2.70206 19.0444 2.7916 19.103 2.88997 19.1426C2.98835 19.1821 3.0936 19.2017 3.19961 19.2002C8.31756 19.2002 12.3372 19.987 15.1262 20.7705C16.5206 21.1623 17.6055 21.5527 18.373 21.8471C18.7568 21.9943 19.0608 22.1172 19.2934 22.208C19.4096 22.2534 19.506 22.2905 19.5996 22.3221C19.6818 22.3498 19.7378 22.3848 19.934 22.3939C19.9563 22.396 19.9771 22.408 19.9996 22.408C20.8605 22.408 21.5491 21.7274 21.5918 20.8814C21.597 20.8442 21.5997 20.8066 21.5996 20.7689V19.2002V18.4002V17.6002H20.923C20.8781 17.5927 20.8326 17.589 20.7871 17.5893Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var PaidLeaveIcon$1 = react.memo(PaidLeaveIcon_PaidLeaveIcon);


//# sourceMappingURL=PaidLeaveIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/PhoneIcon.js
'use client';




var PhoneIcon_PhoneIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M2.88043 0C2.0873 0 1.44043 0.646875 1.44043 1.44V17.28C1.44043 18.0731 2.0873 18.72 2.88043 18.72H9.60043V14.88H3.84043V2.4H11.5204V4.8H13.9204V1.44C13.9204 0.646875 13.2736 0 12.4804 0H2.88043ZM11.5204 5.28C10.7273 5.28 10.0804 5.92687 10.0804 6.72V22.56C10.0804 23.3531 10.7273 24 11.5204 24H21.1204C21.9136 24 22.5604 23.3531 22.5604 22.56V6.72C22.5604 5.92687 21.9136 5.28 21.1204 5.28H11.5204ZM12.4804 7.68H20.1604V20.16H12.4804V7.68ZM7.68043 15.84C8.07793 15.84 8.40043 16.1625 8.40043 16.56C8.40043 16.9575 8.07793 17.28 7.68043 17.28C7.28293 17.28 6.96043 16.9575 6.96043 16.56C6.96043 16.1625 7.28293 15.84 7.68043 15.84ZM16.3204 21.12C16.7179 21.12 17.0404 21.4425 17.0404 21.84C17.0404 22.2375 16.7179 22.56 16.3204 22.56C15.9229 22.56 15.6004 22.2375 15.6004 21.84C15.6004 21.4425 15.9229 21.12 16.3204 21.12Z', fill: color })));
};
var PhoneIcon$1 = react.memo(PhoneIcon_PhoneIcon);


//# sourceMappingURL=PhoneIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/TrainingIcon.js
'use client';




var TrainingIcon_TrainingIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 20 20', fill: 'none' },
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.34786 0C3.14881 0 2.17394 0.974864 2.17394 2.17391C2.17394 3.37296 3.14881 4.34783 4.34786 4.34783C5.54691 4.34783 6.52177 3.37296 6.52177 2.17391C6.52177 0.974864 5.54691 0 4.34786 0ZM11.7392 0V0.869565H7.09245C7.28097 1.26529 7.39137 1.70686 7.39137 2.17391C7.39137 2.82099 7.19266 3.41882 6.84789 3.91304H11.5218C12.6003 3.91304 13.4783 4.7911 13.4783 5.86956C13.4783 6.94803 12.6003 7.82609 11.5218 7.82609H7.82615V13.913H19.5653C19.8064 13.913 20.0001 13.7194 20.0001 13.4783V1.30435C20.0001 1.06488 19.8064 0.869565 19.5653 0.869565H12.6088V0H11.7392ZM0 7.17395C0 5.85602 1.07337 4.78265 2.3913 4.78265H2.83967L4.34783 7.82613L5.88315 4.78265H11.5217C12.123 4.78265 12.6087 5.26838 12.6087 5.86961C12.6087 6.47083 12.123 6.95656 11.5217 6.95656H6.95652V18.8316C6.95652 19.5109 6.58967 20 5.91033 20C5.3091 20 4.85564 19.5551 4.79619 18.9538C4.79535 18.9521 4.79237 18.953 4.7894 18.9538C4.78643 18.9547 4.78346 18.9555 4.78261 18.9538V13.7772C4.78261 13.6566 4.6858 13.5598 4.56522 13.5598C4.44463 13.5598 4.34783 13.6566 4.34783 13.7772V18.8316C4.34783 19.5007 3.86379 20 3.22011 20C2.53906 20 2.17391 19.5109 2.17391 18.8316V8.07069C2.17391 7.95351 2.07371 7.8533 1.95652 7.8533C1.83933 7.8533 1.73913 7.95351 1.73913 8.07069V13.0435C1.73913 13.5242 1.34851 13.9131 0.869565 13.9131C0.390625 13.9131 0 13.5242 0 13.0435V7.17395ZM11.087 14.7827L9.13047 18.6957H10L11.9566 14.7827H11.087ZM14.3478 18.6957L12.3913 14.7827H13.2609L15.2174 18.6957H14.3478Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var TrainingIcon$1 = react.memo(TrainingIcon_TrainingIcon);


//# sourceMappingURL=TrainingIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/TransportationIcon.js
'use client';




var TransportationIcon_TransportationIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M6.4002 2.3999C4.633 2.3999 3.2002 3.8327 3.2002 5.5999V19.1999V19.9999V20.7999C3.2002 21.6839 3.9162 22.3999 4.8002 22.3999C5.6842 22.3999 6.4002 21.6839 6.4002 20.7999V20.5046C7.83461 20.6635 9.70227 20.7999 12.0002 20.7999C14.2981 20.7999 16.1658 20.6635 17.6002 20.5046V20.7999C17.6002 21.6839 18.3162 22.3999 19.2002 22.3999C20.0842 22.3999 20.8002 21.6839 20.8002 20.7999V19.9999V19.1999V5.5999C20.8002 3.8327 19.3674 2.3999 17.6002 2.3999H6.4002ZM8.8002 3.9999H15.2002C15.6418 3.9999 16.0002 4.3583 16.0002 4.7999C16.0002 5.2415 15.6418 5.5999 15.2002 5.5999H8.8002C8.3586 5.5999 8.0002 5.2415 8.0002 4.7999C8.0002 4.3583 8.3586 3.9999 8.8002 3.9999ZM4.8002 7.1999H19.2002V11.5437C19.2002 11.9309 18.9271 12.264 18.5455 12.3312C17.5343 12.5072 15.353 12.7999 12.0002 12.7999C8.6474 12.7999 6.46608 12.5064 5.45488 12.3296C5.07328 12.2632 4.8002 11.9309 4.8002 11.5437V7.1999ZM6.4002 15.1999C7.2842 15.1999 8.0002 15.9159 8.0002 16.7999C8.0002 17.6839 7.2842 18.3999 6.4002 18.3999C5.5162 18.3999 4.8002 17.6839 4.8002 16.7999C4.8002 15.9159 5.5162 15.1999 6.4002 15.1999ZM17.6002 15.1999C18.4842 15.1999 19.2002 15.9159 19.2002 16.7999C19.2002 17.6839 18.4842 18.3999 17.6002 18.3999C16.7162 18.3999 16.0002 17.6839 16.0002 16.7999C16.0002 15.9159 16.7162 15.1999 17.6002 15.1999Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var TransportationIcon$1 = react.memo(TransportationIcon_TransportationIcon);


//# sourceMappingURL=TransportationIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/TravelIcon.js
'use client';




var TravelIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0004 1.6001C11.1164 1.6001 10.4004 2.3161 10.4004 3.2001V9.38135L2.40039 15.2001V16.8001L10.4004 14.6188V19.6798L7.20039 21.6001V22.4001H11.2004H13.6004H16.8004V21.6001L13.6004 19.6798V14.6188L21.6004 16.8001V15.2001L13.6004 9.38135V3.2001C13.6004 2.3161 12.8844 1.6001 12.0004 1.6001Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var TravelIcon$1 = react.memo(TravelIcon);


//# sourceMappingURL=TravelIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/VoucherIcon.js
'use client';




var VoucherIcon_VoucherIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M3.19961 4C2.31561 4 1.59961 4.716 1.59961 5.6V9.74688C2.53001 10.0773 3.19961 10.9568 3.19961 12C3.19961 13.0432 2.53001 13.9227 1.59961 14.2531V18.4C1.59961 19.284 2.31561 20 3.19961 20H20.7996C21.6836 20 22.3996 19.284 22.3996 18.4V14.2531C21.4692 13.9227 20.7996 13.0432 20.7996 12C20.7996 10.9568 21.4692 10.0773 22.3996 9.74688V5.6C22.3996 4.716 21.6836 4 20.7996 4H3.19961ZM9.2793 7.54844C10.5377 7.54844 11.359 8.41263 11.359 9.74062C11.359 11.063 10.5377 11.9328 9.2793 11.9328C8.0281 11.9328 7.19961 11.063 7.19961 9.74062C7.19961 8.41823 8.0225 7.54844 9.2793 7.54844ZM13.8043 7.76094H15.759L12.5215 12.2312L10.2543 16.2391H8.2918L11.4777 11.7906L13.8043 7.76094ZM9.2793 8.8125C8.9209 8.8125 8.7043 9.15434 8.7043 9.73594C8.7043 10.3119 8.9209 10.6578 9.2793 10.6578C9.6321 10.6578 9.84961 10.3111 9.84961 9.73594C9.84961 9.14874 9.6441 8.8125 9.2793 8.8125ZM14.7262 12.0672C15.9774 12.0672 16.7996 12.9315 16.7996 14.2531C16.7996 15.5819 15.9774 16.45 14.7262 16.45C13.475 16.45 12.6527 15.5811 12.6527 14.2531C12.6527 12.9315 13.475 12.0672 14.7262 12.0672ZM14.7262 13.3313C14.3678 13.3313 14.1496 13.6715 14.1496 14.2531C14.1496 14.8291 14.3678 15.1766 14.7262 15.1766C15.079 15.1766 15.2949 14.8291 15.2949 14.2531C15.2949 13.6651 15.0838 13.3313 14.7262 13.3313Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var VoucherIcon$1 = react.memo(VoucherIcon_VoucherIcon);


//# sourceMappingURL=VoucherIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/Physics.js
'use client';




var PhysicsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 18 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M13.5996 0.799805C13.2995 0.799886 13.0055 0.884352 12.7512 1.04355C12.5098 0.959815 12.2617 0.899805 11.9996 0.899805C11.2014 0.899805 10.4886 1.3265 9.92461 1.94668C9.36066 2.56686 8.9017 3.39843 8.51836 4.39512C8.39768 4.70888 8.28854 5.04484 8.18398 5.39043C7.83251 5.30821 7.48628 5.23498 7.1543 5.18262C6.09947 5.01626 5.14993 4.99806 4.33086 5.17637C3.51179 5.35467 2.7862 5.75856 2.38711 6.4498C1.98802 7.14105 2.00074 7.97163 2.25586 8.77012C2.51098 9.5686 3.00156 10.382 3.67305 11.2123C3.88432 11.4736 4.11994 11.7366 4.3668 11.9998C4.11994 12.263 3.88432 12.5261 3.67305 12.7873C3.45078 13.0621 3.25683 13.3349 3.07617 13.6061C2.67465 13.6371 2.29961 13.8185 2.02591 14.1139C1.75221 14.4093 1.59998 14.7971 1.59961 15.1998C1.59983 15.4126 1.64251 15.6233 1.72514 15.8194C1.80778 16.0155 1.92871 16.1932 2.08086 16.342C2.08395 16.7666 2.17298 17.1789 2.38711 17.5498C2.7862 18.2411 3.51179 18.6449 4.33086 18.8232C5.14993 19.0015 6.09947 18.9834 7.1543 18.817C7.48628 18.7646 7.83251 18.6914 8.18398 18.6092C8.28854 18.9548 8.39768 19.2907 8.51836 19.6045C8.9017 20.6012 9.36066 21.4327 9.92461 22.0529C10.4886 22.6731 11.2014 23.0998 11.9996 23.0998C12.7978 23.0998 13.5107 22.6731 14.0746 22.0529C14.6386 21.4327 15.0975 20.6012 15.4809 19.6045C15.6015 19.2907 15.7107 18.9548 15.8152 18.6092C16.1667 18.6914 16.5129 18.7646 16.8449 18.817C17.1346 18.8627 17.4138 18.8946 17.6871 18.917C17.7949 19.2326 17.9987 19.5066 18.2698 19.7008C18.541 19.8949 18.8661 19.9995 19.1996 19.9998C19.624 19.9998 20.0309 19.8312 20.331 19.5312C20.631 19.2311 20.7996 18.8242 20.7996 18.3998C20.7991 18.393 20.7986 18.3863 20.798 18.3795C21.1318 18.1698 21.4126 17.8954 21.6121 17.5498C22.0112 16.8586 21.9985 16.028 21.7434 15.2295C21.4882 14.431 20.9977 13.6176 20.3262 12.7873C20.1149 12.5261 19.8793 12.263 19.6324 11.9998C19.8793 11.7366 20.1149 11.4736 20.3262 11.2123C20.9977 10.382 21.4882 9.5686 21.7434 8.77012C21.9985 7.97166 22.0112 7.14105 21.6121 6.4498C21.213 5.75856 20.4874 5.35467 19.6684 5.17637C18.8493 4.99806 17.8997 5.01626 16.8449 5.18262C16.5129 5.23498 16.1667 5.30821 15.8152 5.39043C15.7107 5.04484 15.6015 4.70888 15.4809 4.39512C15.321 3.97943 15.1442 3.6 14.9559 3.24512C15.1145 2.99166 15.1989 2.69882 15.1996 2.3998C15.1996 1.97546 15.031 1.56849 14.731 1.26843C14.4309 0.968376 14.024 0.799805 13.5996 0.799805ZM11.9996 2.2998H12.0043C12.0017 2.33308 12.0001 2.36643 11.9996 2.3998C11.9996 2.82415 12.1682 3.23112 12.4682 3.53118C12.7683 3.83123 13.1753 3.9998 13.5996 3.9998C13.6544 3.99897 13.7092 3.99532 13.7637 3.98887C13.9063 4.26478 14.0458 4.56179 14.1746 4.89668C14.2784 5.16649 14.3748 5.45884 14.4668 5.7623C13.6711 6.01631 12.8434 6.33998 11.9996 6.72324C11.1558 6.33998 10.3281 6.01631 9.53242 5.7623C9.62445 5.45884 9.72084 5.16649 9.82461 4.89668C10.1651 4.01134 10.5674 3.31966 10.9605 2.8873C11.3537 2.45495 11.6932 2.2998 11.9996 2.2998ZM5.64492 6.45137C6.03346 6.45367 6.46705 6.48998 6.93555 6.56387C7.22146 6.60896 7.52317 6.67296 7.83242 6.74512C7.65445 7.56165 7.51927 8.4394 7.4293 9.3623C6.67558 9.90136 5.983 10.4565 5.36523 11.0186C5.14806 10.7868 4.9426 10.5577 4.76055 10.3326C4.16408 9.59505 3.76653 8.90022 3.58867 8.34355C3.41082 7.78689 3.44642 7.41514 3.59961 7.1498C3.7528 6.88447 4.05673 6.66786 4.62773 6.54355C4.91324 6.4814 5.25639 6.44907 5.64492 6.45137ZM18.3543 6.45137C18.7428 6.44907 19.086 6.4814 19.3715 6.54355C19.9425 6.66786 20.2464 6.88447 20.3996 7.1498C20.5528 7.41514 20.5884 7.78689 20.4105 8.34355C20.2327 8.90021 19.8351 9.59505 19.2387 10.3326C19.0566 10.5577 18.8512 10.7868 18.634 11.0186C18.0162 10.4565 17.3236 9.90136 16.5699 9.3623C16.4799 8.4394 16.3448 7.56165 16.1668 6.74512C16.476 6.67296 16.7778 6.60896 17.0637 6.56387C17.5322 6.48998 17.9658 6.45367 18.3543 6.45137ZM9.18398 7.12168C9.55929 7.24375 9.94737 7.39381 10.3402 7.54824C10.1101 7.67267 9.88025 7.79633 9.64961 7.92949C9.41928 8.06247 9.19712 8.20044 8.97461 8.3373C9.03731 7.91976 9.10203 7.50783 9.18398 7.12168ZM14.8152 7.12168C14.8972 7.50783 14.9619 7.91976 15.0246 8.3373C14.8021 8.20044 14.5799 8.06247 14.3496 7.92949C14.119 7.79633 13.8891 7.67267 13.659 7.54824C14.0518 7.39381 14.4399 7.24375 14.8152 7.12168ZM11.9996 8.27012C12.5453 8.53465 13.0968 8.82282 13.6496 9.14199C14.2027 9.46132 14.7287 9.7953 15.2309 10.1357C15.2745 10.7401 15.2996 11.362 15.2996 11.9998C15.2996 12.6376 15.2745 13.2595 15.2309 13.8639C14.7287 14.2043 14.2027 14.5383 13.6496 14.8576C13.0968 15.1768 12.5453 15.465 11.9996 15.7295C11.454 15.465 10.9024 15.1768 10.3496 14.8576C9.79652 14.5383 9.27049 14.2043 8.76836 13.8639C8.7247 13.2595 8.69961 12.6376 8.69961 11.9998C8.69961 11.362 8.7247 10.7401 8.76836 10.1357C9.27049 9.7953 9.79652 9.46132 10.3496 9.14199C10.9024 8.82282 11.454 8.53465 11.9996 8.27012ZM7.31367 11.2107C7.30638 11.4722 7.29961 11.7335 7.29961 11.9998C7.29961 12.2661 7.30638 12.5274 7.31367 12.7889C6.98376 12.526 6.65996 12.2636 6.3668 11.9998C6.65996 11.736 6.98376 11.4736 7.31367 11.2107ZM16.6855 11.2107C17.0155 11.4736 17.3393 11.736 17.6324 11.9998C17.3393 12.2636 17.0155 12.526 16.6855 12.7889C16.6928 12.5274 16.6996 12.2661 16.6996 11.9998C16.6996 11.7335 16.6928 11.4722 16.6855 11.2107ZM5.36523 12.9811C5.983 13.5431 6.67558 14.0982 7.4293 14.6373C7.51927 15.5602 7.65445 16.438 7.83242 17.2545C7.52317 17.3266 7.22146 17.3906 6.93555 17.4357C5.99856 17.5835 5.19874 17.5804 4.62773 17.4561C4.05672 17.3318 3.7528 17.1151 3.59961 16.8498C3.58332 16.8216 3.57406 16.7868 3.56055 16.7561C3.91241 16.6746 4.22636 16.4764 4.45133 16.1939C4.67629 15.9113 4.79904 15.561 4.79961 15.1998C4.79916 14.8115 4.65755 14.4367 4.40117 14.1451C4.51282 13.9883 4.6295 13.829 4.76055 13.667C4.9426 13.4419 5.14806 13.2128 5.36523 12.9811ZM18.634 12.9811C18.8512 13.2128 19.0566 13.4419 19.2387 13.667C19.8351 14.4046 20.2327 15.0994 20.4105 15.6561C20.5884 16.2127 20.5528 16.5845 20.3996 16.8498C20.3432 16.9475 20.2574 17.0363 20.1543 17.1186C19.8786 16.9124 19.5438 16.8006 19.1996 16.7998C18.934 16.8001 18.6727 16.8666 18.4392 16.9932C18.2057 17.1197 18.0074 17.3024 17.8621 17.5248C17.608 17.5068 17.3449 17.4801 17.0637 17.4357C16.7778 17.3906 16.476 17.3266 16.1668 17.2545C16.3448 16.438 16.4799 15.5602 16.5699 14.6373C17.3236 14.0982 18.0162 13.5431 18.634 12.9811ZM8.97461 15.6623C9.19712 15.7992 9.41928 15.9371 9.64961 16.0701C9.88025 16.2033 10.1101 16.3269 10.3402 16.4514C9.94737 16.6058 9.55929 16.7559 9.18398 16.8779C9.10203 16.4918 9.03731 16.0798 8.97461 15.6623ZM15.0246 15.6623C14.9619 16.0798 14.8972 16.4918 14.8152 16.8779C14.4399 16.7559 14.0518 16.6058 13.659 16.4514C13.8891 16.3269 14.119 16.2033 14.3496 16.0701C14.5799 15.9371 14.8021 15.7992 15.0246 15.6623ZM11.9996 17.2764C12.8434 17.6596 13.6711 17.9833 14.4668 18.2373C14.3748 18.5408 14.2784 18.8331 14.1746 19.1029C13.8341 19.9883 13.4318 20.6799 13.0387 21.1123C12.6455 21.5447 12.306 21.6998 11.9996 21.6998C11.6932 21.6998 11.3537 21.5447 10.9605 21.1123C10.5674 20.6799 10.1651 19.9883 9.82461 19.1029C9.72084 18.8331 9.62445 18.5408 9.53242 18.2373C10.3281 17.9833 11.1558 17.6596 11.9996 17.2764Z', fill: color })));
};
var PhysicsIcon$1 = react.memo(PhysicsIcon);


//# sourceMappingURL=Physics.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/WorkingHourIcon.js
'use client';




var WorkingHourIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("path", { d: 'M4.25747 1.5918C4.23163 1.59236 4.20587 1.5948 4.18038 1.5991H3.19913C3.12846 1.5981 3.05829 1.61115 2.99271 1.63751C2.92713 1.66386 2.86744 1.70299 2.8171 1.75261C2.76677 1.80223 2.72681 1.86137 2.69953 1.92657C2.67225 1.99177 2.6582 2.06175 2.6582 2.13243C2.6582 2.20311 2.67225 2.27308 2.69953 2.33829C2.72681 2.40349 2.76677 2.46262 2.8171 2.51225C2.86744 2.56187 2.92713 2.601 2.99271 2.62735C3.05829 2.6537 3.12846 2.66676 3.19913 2.66576H3.73247V3.73243C3.73247 6.19208 5.39229 7.49423 6.11372 7.9991C5.39229 8.50396 3.73247 9.80611 3.73247 12.2658V13.3324H3.19913C3.12846 13.3314 3.05829 13.3445 2.99271 13.3708C2.92713 13.3972 2.86744 13.4363 2.8171 13.4859C2.76677 13.5356 2.72681 13.5947 2.69953 13.6599C2.67225 13.7251 2.6582 13.7951 2.6582 13.8658C2.6582 13.9364 2.67225 14.0064 2.69953 14.0716C2.72681 14.1368 2.76677 14.196 2.8171 14.2456C2.86744 14.2952 2.92713 14.3343 2.99271 14.3607C3.05829 14.387 3.12846 14.4001 3.19913 14.3991H4.17622C4.23381 14.4086 4.29258 14.4086 4.35017 14.3991H11.6429C11.7005 14.4086 11.7592 14.4086 11.8168 14.3991H12.7991C12.8698 14.4001 12.94 14.387 13.0056 14.3607C13.0711 14.3343 13.1308 14.2952 13.1812 14.2456C13.2315 14.196 13.2715 14.1368 13.2987 14.0716C13.326 14.0064 13.3401 13.9364 13.3401 13.8658C13.3401 13.7951 13.326 13.7251 13.2987 13.6599C13.2715 13.5947 13.2315 13.5356 13.1812 13.4859C13.1308 13.4363 13.0711 13.3972 13.0056 13.3708C12.94 13.3445 12.8698 13.3314 12.7991 13.3324H12.2658V12.2658C12.2658 9.80611 10.606 8.50396 9.88455 7.9991C10.606 7.49423 12.2658 6.19208 12.2658 3.73243V2.66576H12.7991C12.8698 2.66676 12.94 2.6537 13.0056 2.62735C13.0711 2.601 13.1308 2.56187 13.1812 2.51225C13.2315 2.46262 13.2715 2.40349 13.2987 2.33829C13.326 2.27308 13.3401 2.20311 13.3401 2.13243C13.3401 2.06175 13.326 1.99177 13.2987 1.92657C13.2715 1.86137 13.2315 1.80223 13.1812 1.75261C13.1308 1.70299 13.0711 1.66386 13.0056 1.63751C12.94 1.61115 12.8698 1.5981 12.7991 1.5991H11.8148C11.7848 1.59409 11.7545 1.59165 11.7241 1.5918C11.6983 1.59236 11.6725 1.5948 11.647 1.5991H4.34809C4.31815 1.59409 4.28783 1.59165 4.25747 1.5918ZM4.84705 4.26576H11.1512C10.827 6.27032 8.79184 7.5418 8.79184 7.5418C8.7129 7.5892 8.64757 7.65623 8.60221 7.73637C8.55686 7.8165 8.53302 7.90701 8.53302 7.9991C8.53302 8.09118 8.55686 8.18169 8.60221 8.26182C8.64757 8.34196 8.7129 8.40899 8.79184 8.45639C8.79184 8.45639 10.827 9.72787 11.1512 11.7324H4.84705C5.17124 9.72787 7.20642 8.45639 7.20642 8.45639C7.28537 8.40899 7.3507 8.34196 7.39605 8.26182C7.44141 8.18169 7.46525 8.09118 7.46525 7.9991C7.46525 7.90701 7.44141 7.8165 7.39605 7.73637C7.3507 7.65623 7.28537 7.5892 7.20642 7.5418C7.20642 7.5418 5.17124 6.27032 4.84705 4.26576Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.20 */.O9.grey[20] })));
};
var WorkingHourIcon$1 = react.memo(WorkingHourIcon);


//# sourceMappingURL=WorkingHourIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/WorkingDayIcon.js
'use client';




var WorkingDayIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { clipPath: 'url(#clip0_30729_453126)' },
            react.createElement("path", { d: 'M2.13307 2.13281C1.54374 2.13281 1.06641 2.61015 1.06641 3.19948V5.33281V13.8661H7.74557C7.62504 13.5259 7.53872 13.1701 7.49766 12.7995H2.13307V5.33281H13.8664V7.74531C14.2456 7.87971 14.6045 8.05525 14.9331 8.27552V3.73281V3.19948C14.9331 2.61015 14.4557 2.13281 13.8664 2.13281H2.13307ZM4.26641 6.93281C4.12496 6.93281 3.9893 6.989 3.88928 7.08902C3.78926 7.18904 3.73307 7.3247 3.73307 7.46615C3.73307 7.60759 3.78926 7.74325 3.88928 7.84327C3.9893 7.94329 4.12496 7.99948 4.26641 7.99948C4.40786 7.99948 4.54351 7.94329 4.64353 7.84327C4.74355 7.74325 4.79974 7.60759 4.79974 7.46615C4.79974 7.3247 4.74355 7.18904 4.64353 7.08902C4.54351 6.989 4.40786 6.93281 4.26641 6.93281V6.93281ZM6.39974 6.93281C6.10534 6.93281 5.86641 7.17175 5.86641 7.46615C5.86641 7.76055 6.10534 7.99948 6.39974 7.99948H10.0737C10.5793 7.73921 11.1364 7.5651 11.7268 7.49844C11.7274 7.48724 11.7331 7.47735 11.7331 7.46615C11.7331 7.17175 11.4941 6.93281 11.1997 6.93281H6.39974ZM12.2664 8.53281C10.2077 8.53281 8.53307 10.2075 8.53307 12.2661C8.53307 14.3248 10.2077 15.9995 12.2664 15.9995C14.3251 15.9995 15.9997 14.3248 15.9997 12.2661C15.9997 10.2075 14.3251 8.53281 12.2664 8.53281ZM4.26641 9.06615C4.12496 9.06615 3.9893 9.12234 3.88928 9.22236C3.78926 9.32237 3.73307 9.45803 3.73307 9.59948C3.73307 9.74093 3.78926 9.87658 3.88928 9.9766C3.9893 10.0766 4.12496 10.1328 4.26641 10.1328C4.40786 10.1328 4.54351 10.0766 4.64353 9.9766C4.74355 9.87658 4.79974 9.74093 4.79974 9.59948C4.79974 9.45803 4.74355 9.32237 4.64353 9.22236C4.54351 9.12234 4.40786 9.06615 4.26641 9.06615V9.06615ZM6.39974 9.06615C6.10534 9.06615 5.86641 9.30508 5.86641 9.59948C5.86641 9.89388 6.10534 10.1328 6.39974 10.1328H7.97161C8.16521 9.74401 8.40915 9.38615 8.69661 9.06615H6.39974ZM12.2664 9.59948C13.7368 9.59948 14.9331 10.7957 14.9331 12.2661C14.9331 13.7365 13.7368 14.9328 12.2664 14.9328C10.796 14.9328 9.59974 13.7365 9.59974 12.2661C9.59974 10.7957 10.796 9.59948 12.2664 9.59948ZM12.2664 10.1328C11.972 10.1328 11.7331 10.3717 11.7331 10.6661V12.487L12.6852 13.4391C12.7892 13.5431 12.9257 13.5953 13.0622 13.5953C13.1988 13.5953 13.3353 13.5431 13.4393 13.4391C13.6479 13.2305 13.6479 12.8934 13.4393 12.6849L12.7997 12.0453V10.6661C12.7997 10.3717 12.5608 10.1328 12.2664 10.1328Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.20 */.O9.grey[20] })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_30729_453126' },
                react.createElement("rect", { width: '16', height: '16', fill: 'white' })))));
};
var WorkingDayIcon$1 = react.memo(WorkingDayIcon);


//# sourceMappingURL=WorkingDayIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/WorkingTypeIcon.js
'use client';




var WorkingTypeIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: '0 0 16 16', fill: 'none' },
        react.createElement("path", { d: 'M8.00065 1.33343C4.32539 1.33343 1.33398 4.32482 1.33398 8.00007C1.33398 11.6753 4.32539 14.6667 8.00065 14.6667C11.6759 14.6667 14.6673 11.6753 14.6673 8.00007C14.6673 5.70024 13.4995 3.66684 11.7224 2.46841L12.3594 1.65135L9.66732 1.5537L10.4442 4.1112L11.0345 3.35274C12.4048 4.24852 13.3558 5.72742 13.5258 7.4456C13.384 7.45337 13.2505 7.51516 13.1529 7.61829C13.0552 7.72141 13.0007 7.85803 13.0007 8.00007C13.0008 8.14264 13.0557 8.27972 13.154 8.38292C13.2524 8.48613 13.3867 8.54758 13.5291 8.55454C13.2697 11.1847 11.1853 13.2691 8.55512 13.5285C8.54816 13.3861 8.48672 13.2518 8.38351 13.1534C8.2803 13.0551 8.14322 13.0002 8.00065 13C7.85808 13.0002 7.721 13.0551 7.61779 13.1534C7.51459 13.2518 7.45314 13.3861 7.44618 13.5285C4.81596 13.2691 2.73161 11.1847 2.47222 8.55454C2.61463 8.54758 2.7489 8.48613 2.84726 8.38292C2.94563 8.27972 3.00054 8.14264 3.00065 8.00007C3.00054 7.8575 2.94563 7.72042 2.84726 7.61721C2.7489 7.51401 2.61463 7.45256 2.47222 7.4456C2.74961 4.63283 5.11331 2.44454 8.00065 2.44454C8.07427 2.44558 8.14736 2.43198 8.21568 2.40452C8.28399 2.37707 8.34617 2.33632 8.3986 2.28463C8.45102 2.23293 8.49266 2.17134 8.52107 2.10342C8.54949 2.0355 8.56412 1.96261 8.56412 1.88898C8.56412 1.81536 8.54949 1.74247 8.52107 1.67455C8.49266 1.60663 8.45102 1.54503 8.3986 1.49334C8.34617 1.44165 8.28399 1.40089 8.21568 1.37344C8.14736 1.34599 8.07427 1.33239 8.00065 1.33343ZM7.99197 4.1036C7.84482 4.1059 7.70459 4.16649 7.60206 4.27207C7.49953 4.37765 7.44308 4.51959 7.4451 4.66675V7.72229L5.44531 9.22185C5.32732 9.3102 5.24926 9.4418 5.2283 9.5877C5.20734 9.7336 5.2452 9.88186 5.33355 9.99984C5.4219 10.1178 5.5535 10.1959 5.6994 10.2169C5.8453 10.2378 5.99356 10.2 6.11155 10.1116L8.33377 8.44495C8.40286 8.39317 8.45894 8.32601 8.49755 8.24879C8.53616 8.17157 8.55624 8.08641 8.55621 8.00007V4.66675C8.55722 4.59242 8.54332 4.51865 8.51531 4.44979C8.4873 4.38094 8.44576 4.3184 8.39315 4.26589C8.34053 4.21338 8.27792 4.17196 8.20901 4.14408C8.1401 4.1162 8.0663 4.10244 7.99197 4.1036Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.20 */.O9.grey[20] })));
};
var WorkingTypeIcon$1 = react.memo(WorkingTypeIcon);


//# sourceMappingURL=WorkingTypeIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/BenefitGroupIcons/index.js
'use client';





















var Benefit = {
    ActivityIcon: ActivityIcon$1,
    AwardsIcon: AwardsIcon$1,
    BonusIcon: BonusIcon$1,
    CanteenIcon: CanteenIcon$1,
    HealthcareIcon: HealthcareIcon$1,
    KindergartenIcon: KindergartenIcon$1,
    LaptopIcon: LaptopIcon$1,
    LibraryIcon: LibraryIcon$1,
    MoreIcon: MoreIcon$1,
    PaidLeaveIcon: PaidLeaveIcon$1,
    PhoneIcon: PhoneIcon$1,
    TrainingIcon: TrainingIcon$1,
    TransportationIcon: TransportationIcon$1,
    TravelIcon: TravelIcon$1,
    VoucherIcon: VoucherIcon$1,
    PhysicsIcon: PhysicsIcon$1,
    WorkingDayIcon: WorkingDayIcon$1,
    WorkingHourIcon: WorkingHourIcon$1,
    WorkingTypeIcon: WorkingTypeIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountCenterGroupIcons/ChartVertical.js
'use client';




var ChartVertical = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M10.4096 3.99365C9.96797 3.99365 9.60957 4.35205 9.60957 4.79365V18.3937H13.6096V4.79365C13.6096 4.35205 13.2512 3.99365 12.8096 3.99365H10.4096ZM0.80957 5.59365V21.5937H20.8096V19.9937H2.40957V5.59365H0.80957ZM16.0096 5.59365C15.568 5.59365 15.2096 5.95205 15.2096 6.39365V18.3937H19.2096V6.39365C19.2096 5.95205 18.8512 5.59365 18.4096 5.59365H16.0096ZM4.80957 8.79365C4.36797 8.79365 4.00957 9.15205 4.00957 9.59365V18.3937H8.00957V9.59365C8.00957 9.15205 7.65117 8.79365 7.20957 8.79365H4.80957Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var ChartVerticalIcon = react.memo(ChartVertical);


//# sourceMappingURL=ChartVertical.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountCenterGroupIcons/Language.js
'use client';




var Language_LanguageIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0004 2.3999C6.70793 2.3999 2.40039 6.70744 2.40039 11.9999C2.40039 17.2924 6.70793 21.5999 12.0004 21.5999C17.2928 21.5999 21.6004 17.2924 21.6004 11.9999C21.6004 6.70744 17.2928 2.3999 12.0004 2.3999ZM12.0004 3.9999C12.3149 3.9999 12.6407 4.13017 13.0129 4.47646C13.385 4.82276 13.7702 5.38125 14.1004 6.10771C14.2506 6.43807 14.3866 6.80692 14.5113 7.1999H9.48945C9.61421 6.80692 9.75023 6.43807 9.90039 6.10771C10.2306 5.38125 10.6157 4.82276 10.9879 4.47646C11.36 4.13017 11.6859 3.9999 12.0004 3.9999ZM8.8707 4.63428C8.72014 4.891 8.5754 5.15802 8.44414 5.44678C8.2019 5.97971 7.99508 6.57027 7.81914 7.1999H5.60508C6.44471 6.08179 7.5655 5.18778 8.8707 4.63428ZM15.1301 4.63428C16.4353 5.18778 17.5561 6.08179 18.3957 7.1999H16.1816C16.0057 6.57027 15.7989 5.97971 15.5566 5.44678C15.4254 5.15802 15.2806 4.891 15.1301 4.63428ZM4.66758 8.7999H7.46445C7.33572 9.56149 7.25161 10.3641 7.21914 11.1999H4.03945C4.12311 10.3532 4.34194 9.54732 4.66758 8.7999ZM9.09102 8.7999H14.9098C15.0501 9.54803 15.1448 10.3536 15.1816 11.1999H8.81914C8.85598 10.3536 8.95072 9.54803 9.09102 8.7999ZM16.5363 8.7999H19.3332C19.6588 9.54732 19.8777 10.3532 19.9613 11.1999H16.7816C16.7492 10.3641 16.6651 9.56149 16.5363 8.7999ZM4.03945 12.7999H7.21914C7.25161 13.6357 7.33572 14.4383 7.46445 15.1999H4.66758C4.34194 14.4525 4.12311 13.6466 4.03945 12.7999ZM8.81914 12.7999H15.1816C15.1448 13.6462 15.0501 14.4518 14.9098 15.1999H9.09102C8.95072 14.4518 8.85598 13.6462 8.81914 12.7999ZM16.7816 12.7999H19.9613C19.8777 13.6466 19.6588 14.4525 19.3332 15.1999H16.5363C16.6651 14.4383 16.7492 13.6357 16.7816 12.7999ZM5.60508 16.7999H7.81914C7.99508 17.4295 8.2019 18.0201 8.44414 18.553C8.5754 18.8418 8.72014 19.1088 8.8707 19.3655C7.5655 18.812 6.44471 17.918 5.60508 16.7999ZM9.48945 16.7999H14.5113C14.3866 17.1929 14.2506 17.5617 14.1004 17.8921C13.7702 18.6186 13.385 19.177 13.0129 19.5233C12.6407 19.8696 12.3149 19.9999 12.0004 19.9999C11.6859 19.9999 11.36 19.8696 10.9879 19.5233C10.6157 19.177 10.2306 18.6186 9.90039 17.8921C9.75023 17.5617 9.61421 17.1929 9.48945 16.7999ZM16.1816 16.7999H18.3957C17.5561 17.918 16.4353 18.812 15.1301 19.3655C15.2806 19.1088 15.4254 18.8418 15.5566 18.553C15.7989 18.0201 16.0057 17.4295 16.1816 16.7999Z', fill: color })));
};
var Language_LanguageIcon$1 = react.memo(Language_LanguageIcon);


//# sourceMappingURL=Language.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountCenterGroupIcons/EmptyHotCategory.js
'use client';




var EmptyHotCategoryIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M4.6 3C3.716 3 3 3.716 3 4.6V9.4C3 10.284 3.716 11 4.6 11H9.4C10.284 11 11 10.284 11 9.4V4.6C11 3.716 10.284 3 9.4 3H4.6ZM14.2 3C13.3255 3 12.6 3.72555 12.6 4.6V9.4C12.6 10.2745 13.3255 11 14.2 11H19C19.8745 11 20.6 10.2745 20.6 9.4V4.6C20.6 3.72555 19.8745 3 19 3H14.2ZM14.2 4.6H19V9.4H14.2V4.6ZM4.6 12.6C3.72555 12.6 3 13.3255 3 14.2V19C3 19.8745 3.72555 20.6 4.6 20.6H9.4C10.2745 20.6 11 19.8745 11 19V14.2C11 13.3255 10.2745 12.6 9.4 12.6H4.6ZM14.2 12.6C13.3255 12.6 12.6 13.3255 12.6 14.2V19C12.6 19.8745 13.3255 20.6 14.2 20.6H19C19.8745 20.6 20.6 19.8745 20.6 19V14.2C20.6 13.3255 19.8745 12.6 19 12.6H14.2ZM4.6 14.2H6.2C6.2 14.4122 6.28429 14.6157 6.43431 14.7657C6.58434 14.9157 6.78783 15 7 15C7.21217 15 7.41566 14.9157 7.56569 14.7657C7.71571 14.6157 7.8 14.4122 7.8 14.2H9.4V15.8C9.18783 15.8 8.98434 15.8843 8.83431 16.0343C8.68429 16.1843 8.6 16.3878 8.6 16.6C8.6 16.8122 8.68429 17.0157 8.83431 17.1657C8.98434 17.3157 9.18783 17.4 9.4 17.4V19H7.8C7.8 18.7878 7.71571 18.5843 7.56569 18.4343C7.41566 18.2843 7.21217 18.2 7 18.2C6.78783 18.2 6.58434 18.2843 6.43431 18.4343C6.28429 18.5843 6.2 18.7878 6.2 19H4.6V17.4C4.81217 17.4 5.01566 17.3157 5.16569 17.1657C5.31571 17.0157 5.4 16.8122 5.4 16.6C5.4 16.3878 5.31571 16.1843 5.16569 16.0343C5.01566 15.8843 4.81217 15.8 4.6 15.8V14.2ZM15 14.2H18.2V15H19V18.2H18.2V19H15V18.2H14.2V15H15V14.2ZM15.8 15.8V17.4H17.4V15.8H15.8Z', fill: color })));
};
var EmptyHotCategoryIcon$1 = react.memo(EmptyHotCategoryIcon);


//# sourceMappingURL=EmptyHotCategory.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountCenterGroupIcons/Lawyer.js
'use client';




var LawyerIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_10004_5294)' },
            react.createElement("path", { d: 'M12.0004 2.3999C8.60839 2.3999 7.20039 4.5759 7.20039 7.1999C7.20039 8.0879 7.62383 8.97646 7.62383 8.97646C7.45583 9.07246 7.17702 9.38403 7.24102 9.92803C7.37702 10.96 7.81708 11.2165 8.10508 11.2405C8.20908 12.1925 9.24039 13.4239 9.60039 13.5999V15.1999C9.59864 15.2052 9.59439 15.2087 9.59258 15.214C9.32802 15.2468 9.09199 15.4029 8.97227 15.6452L8.72227 16.1483C6.74782 17.2554 2.40039 16.9809 2.40039 21.5999H11.2004V16.7999C11.2004 15.4799 12.2804 14.3999 13.6004 14.3999H14.4004V13.5999C14.7604 13.4239 15.7917 12.1925 15.8957 11.2405C16.1837 11.2165 16.6238 10.96 16.7598 9.92803C16.8238 9.37603 16.545 9.07246 16.377 8.97646C16.377 8.97646 16.8004 8.1679 16.8004 7.1999C16.8004 5.2559 16.0404 3.5999 14.4004 3.5999C14.4004 3.5999 13.8324 2.3999 12.0004 2.3999ZM17.6004 14.3999C16.7164 14.3999 16.0004 15.1159 16.0004 15.9999H13.6004C13.1604 15.9999 12.8004 16.3599 12.8004 16.7999V19.9999C12.8004 20.4399 13.1604 20.7999 13.6004 20.7999H16.8004C16.8004 20.3599 17.1604 19.9999 17.6004 19.9999H19.2004C19.6404 19.9999 20.0004 20.3599 20.0004 20.7999H23.2004C23.6404 20.7999 24.0004 20.4399 24.0004 19.9999V16.7999C24.0004 16.3599 23.6404 15.9999 23.2004 15.9999H20.8004C20.8004 15.1159 20.0844 14.3999 19.2004 14.3999H17.6004ZM12.8004 22.2562V23.1999C12.8004 23.6399 13.1604 23.9999 13.6004 23.9999H23.2004C23.6404 23.9999 24.0004 23.6399 24.0004 23.1999V22.2562C23.7524 22.3522 23.4804 22.3999 23.2004 22.3999H13.6004C13.3204 22.3999 13.0484 22.3522 12.8004 22.2562Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_10004_5294' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var LawyerIcon$1 = react.memo(LawyerIcon);


//# sourceMappingURL=Lawyer.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AccountCenterGroupIcons/index.js
'use client';






var AccountCenter = {
    ChartVerticalIcon: ChartVerticalIcon,
    LanguageIcon: Language_LanguageIcon$1,
    EmptyHotCategoryIcon: EmptyHotCategoryIcon$1,
    LawyerIcon: LawyerIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Vertical.js
'use client';




var VerticalIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M13.666 5.33325C13.666 4.22859 12.7707 3.33325 11.666 3.33325C10.5613 3.33325 9.66602 4.22859 9.66602 5.33325C9.66602 6.43792 10.5613 7.33325 11.666 7.33325C12.7707 7.33325 13.666 6.43792 13.666 5.33325ZM13.666 11.9999C13.666 10.8953 12.7707 9.99992 11.666 9.99992C10.5613 9.99992 9.66602 10.8953 9.66602 11.9999C9.66602 13.1046 10.5613 13.9999 11.666 13.9999C12.7707 13.9999 13.666 13.1046 13.666 11.9999ZM13.666 18.6666C13.666 17.5619 12.7707 16.6666 11.666 16.6666C10.5613 16.6666 9.66602 17.5619 9.66601 18.6666C9.66601 19.7712 10.5613 20.6666 11.666 20.6666C12.7707 20.6666 13.666 19.7712 13.666 18.6666Z', fill: color })));
};
var VerticalIcon$1 = react.memo(VerticalIcon);


//# sourceMappingURL=Vertical.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/More.js
'use client';




var More_MoreIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M5 10C3.89533 10 3 10.8953 3 12C3 13.1047 3.89533 14 5 14C6.10467 14 7 13.1047 7 12C7 10.8953 6.10467 10 5 10ZM11.6667 10C10.562 10 9.66667 10.8953 9.66667 12C9.66667 13.1047 10.562 14 11.6667 14C12.7713 14 13.6667 13.1047 13.6667 12C13.6667 10.8953 12.7713 10 11.6667 10ZM18.3333 10C17.2287 10 16.3333 10.8953 16.3333 12C16.3333 13.1047 17.2287 14 18.3333 14C19.438 14 20.3333 13.1047 20.3333 12C20.3333 10.8953 19.438 10 18.3333 10Z', fill: color })));
};
var More_MoreIcon$1 = react.memo(More_MoreIcon);


//# sourceMappingURL=More.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Close.js
'use client';




var Close_CloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M4.9411 4C4.70027 4 4.45942 4.09197 4.27565 4.27574C3.90812 4.64326 3.90812 5.23909 4.27565 5.60662L10.6691 12L4.27565 18.3934C3.90812 18.7609 3.90812 19.3567 4.27565 19.7243C4.45965 19.9083 4.70015 20 4.9411 20C5.18204 20 5.42255 19.9083 5.60655 19.7243L12 13.3309L18.3935 19.7243C18.5775 19.9083 18.818 20 19.0589 20C19.2998 20 19.5403 19.9083 19.7243 19.7243C20.0919 19.3567 20.0919 18.7609 19.7243 18.3934L13.3309 12L19.7243 5.60662C20.0919 5.23909 20.0919 4.64326 19.7243 4.27574C19.3568 3.90821 18.761 3.90821 18.3935 4.27574L12 10.6691L5.60655 4.27574C5.42278 4.09197 5.18192 4 4.9411 4Z', fill: color })));
};
var CloseIcon$1 = react.memo(Close_CloseIcon);


//# sourceMappingURL=Close.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Expand.js
'use client';




var ExpandIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M20.1633 7.00023C19.9477 7.00532 19.7429 7.09541 19.5934 7.25085L11.9982 14.846L4.40302 7.25085C4.32685 7.17255 4.23577 7.11032 4.13515 7.06782C4.03452 7.02533 3.9264 7.00343 3.81717 7.00342C3.65459 7.00346 3.4957 7.05199 3.36084 7.14281C3.22598 7.23362 3.12126 7.36259 3.06008 7.51323C2.9989 7.66387 2.98403 7.82933 3.01738 7.98847C3.05073 8.1476 3.13078 8.29317 3.24729 8.40657L11.4204 16.5796C11.5737 16.7329 11.7815 16.8189 11.9982 16.8189C12.215 16.8189 12.4228 16.7329 12.5761 16.5796L20.7492 8.40657C20.8679 8.29243 20.9493 8.1451 20.9829 7.98389C21.0164 7.82267 21.0005 7.65508 20.9372 7.50307C20.8738 7.35106 20.7661 7.22172 20.628 7.132C20.4899 7.04227 20.328 6.99634 20.1633 7.00023Z', fill: color })));
};
var ExpandIcon$1 = react.memo(ExpandIcon);


//# sourceMappingURL=Expand.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Collapse.js
'use client';




var CollapseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M11.9872 7.09152C11.775 7.09471 11.5723 7.18088 11.4223 7.33089L3.25163 15.5016C3.03779 15.7058 2.95161 16.0107 3.02662 16.2979C3.10162 16.5836 3.32504 16.807 3.61069 16.882C3.89794 16.957 4.20275 16.8708 4.40701 16.657L12 9.06397L19.593 16.657C19.7973 16.8708 20.1021 16.957 20.3893 16.882C20.675 16.807 20.8984 16.5836 20.9734 16.2979C21.0484 16.0107 20.9622 15.7058 20.7484 15.5016L12.5777 7.33089C12.4213 7.1745 12.2091 7.08832 11.9872 7.09152Z', fill: color })));
};
var CollapseIcon$1 = react.memo(CollapseIcon);


//# sourceMappingURL=Collapse.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Next.js
'use client';




var NextIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M7.91197 3C7.74938 3.00004 7.59051 3.04857 7.45565 3.13938C7.32078 3.23019 7.21607 3.35916 7.15489 3.5098C7.09371 3.66043 7.07885 3.82589 7.11219 3.98501C7.14554 4.14414 7.22559 4.28971 7.3421 4.40311L14.9371 11.9981L7.3421 19.593C7.26367 19.6683 7.20104 19.7585 7.1579 19.8584C7.11476 19.9582 7.09197 20.0656 7.09086 20.1743C7.08976 20.2831 7.11036 20.3909 7.15146 20.4916C7.19256 20.5923 7.25333 20.6837 7.33022 20.7606C7.40711 20.8375 7.49857 20.8983 7.59924 20.9394C7.69991 20.9805 7.80777 21.0011 7.91651 21C8.02524 20.9989 8.13266 20.9761 8.23247 20.9329C8.33229 20.8898 8.42249 20.8272 8.4978 20.7487L16.6707 12.5759C16.8239 12.4226 16.91 12.2148 16.91 11.9981C16.91 11.7814 16.8239 11.5735 16.6707 11.4202L8.4978 3.24742C8.42164 3.16913 8.33055 3.1069 8.22993 3.0644C8.12931 3.0219 8.0212 3.00001 7.91197 3Z', fill: color })));
};
var NextIcon$1 = react.memo(NextIcon);


//# sourceMappingURL=Next.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/Back.js
'use client';




var BackIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M15.975 3.00036C15.7627 3.00668 15.5612 3.09542 15.4131 3.24777L7.24026 11.4204C7.08705 11.5737 7.00098 11.7815 7.00098 11.9982C7.00098 12.215 7.08705 12.4228 7.24026 12.5761L15.4131 20.7487C15.4884 20.8272 15.5786 20.8898 15.6785 20.9329C15.7783 20.9761 15.8857 20.9988 15.9944 21C16.1032 21.0011 16.211 20.9805 16.3117 20.9394C16.4124 20.8983 16.5038 20.8375 16.5807 20.7606C16.6576 20.6837 16.7184 20.5923 16.7595 20.4916C16.8006 20.3909 16.8212 20.2831 16.8201 20.1743C16.819 20.0656 16.7962 19.9582 16.753 19.8584C16.7099 19.7586 16.6473 19.6684 16.5688 19.5931L8.9738 11.9982L16.5688 4.40343C16.6869 4.28864 16.7676 4.14084 16.8003 3.97942C16.8329 3.81799 16.816 3.65046 16.7519 3.49879C16.6877 3.34712 16.5791 3.21838 16.4405 3.12943C16.3019 3.04049 16.1397 2.9955 15.975 3.00036Z', fill: color })));
};
var BackIcon$1 = react.memo(BackIcon);


//# sourceMappingURL=Back.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/ExternalLink.js
'use client';




var ExternalLink_ExternalLinkIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M20.7836 2.39218C20.7538 2.39312 20.7241 2.39573 20.6945 2.39999H15.9992C15.8932 2.39849 15.788 2.41808 15.6896 2.45761C15.5912 2.49714 15.5017 2.55583 15.4262 2.63026C15.3507 2.7047 15.2907 2.7934 15.2498 2.8912C15.2089 2.98901 15.1878 3.09397 15.1878 3.19999C15.1878 3.30601 15.2089 3.41097 15.2498 3.50878C15.2907 3.60659 15.3507 3.69528 15.4262 3.76972C15.5017 3.84416 15.5912 3.90284 15.6896 3.94237C15.788 3.98191 15.8932 4.00149 15.9992 3.99999H18.868L10.6336 12.2344C10.5568 12.3081 10.4955 12.3964 10.4533 12.4941C10.4111 12.5918 10.3887 12.6969 10.3877 12.8034C10.3866 12.9098 10.4067 13.0154 10.447 13.1139C10.4872 13.2125 10.5467 13.302 10.622 13.3772C10.6972 13.4525 10.7867 13.512 10.8853 13.5522C10.9838 13.5925 11.0894 13.6126 11.1958 13.6115C11.3023 13.6105 11.4074 13.5882 11.5051 13.5459C11.6028 13.5037 11.6911 13.4424 11.7648 13.3656L19.9992 5.13124V7.99999C19.9977 8.106 20.0173 8.21125 20.0568 8.30963C20.0964 8.408 20.1551 8.49754 20.2295 8.57303C20.3039 8.64853 20.3926 8.70848 20.4904 8.7494C20.5882 8.79031 20.6932 8.81139 20.7992 8.81139C20.9052 8.81139 21.0102 8.79031 21.108 8.7494C21.2058 8.70848 21.2945 8.64853 21.3689 8.57303C21.4434 8.49754 21.5021 8.408 21.5416 8.30963C21.5811 8.21125 21.6007 8.106 21.5992 7.99999V3.30155C21.6152 3.18637 21.6058 3.06911 21.5718 2.95791C21.5378 2.84672 21.4799 2.74428 21.4023 2.65772C21.3247 2.57116 21.2291 2.50256 21.1222 2.4567C21.0154 2.41084 20.8998 2.38882 20.7836 2.39218ZM4.79922 5.59999C3.92477 5.59999 3.19922 6.32554 3.19922 7.19999V19.2C3.19922 20.0744 3.92477 20.8 4.79922 20.8H16.7992C17.6737 20.8 18.3992 20.0744 18.3992 19.2V11.2V9.13749L16.7992 10.7375V12.8V19.2H4.79922V7.19999H11.1992H12.7992H13.2617L14.8617 5.59999H12.7992H11.1992H4.79922Z', fill: color })));
};
var ExternalLinkIcon$1 = react.memo(ExternalLink_ExternalLinkIcon);


//# sourceMappingURL=ExternalLink.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/RightArrow.js
'use client';




var RightArrowIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M18.3926 7.19214C18.2335 7.19218 18.078 7.23968 17.946 7.32857C17.814 7.41747 17.7115 7.54371 17.6516 7.69116C17.5917 7.8386 17.5771 8.00056 17.6098 8.15633C17.6424 8.31209 17.7208 8.45458 17.8348 8.56558L20.4692 11.2H1.60046C1.49445 11.1985 1.3892 11.218 1.29082 11.2576C1.19245 11.2971 1.10291 11.3558 1.02741 11.4302C0.951919 11.5047 0.89197 11.5934 0.851052 11.6912C0.810134 11.789 0.789062 11.8939 0.789062 12C0.789062 12.106 0.810134 12.2109 0.851052 12.3087C0.89197 12.4065 0.951919 12.4952 1.02741 12.5697C1.10291 12.6441 1.19245 12.7028 1.29082 12.7423C1.3892 12.7819 1.49445 12.8015 1.60046 12.8H20.4692L17.8348 15.4343C17.7581 15.508 17.6968 15.5963 17.6545 15.694C17.6123 15.7917 17.59 15.8969 17.5889 16.0033C17.5878 16.1098 17.608 16.2153 17.6482 16.3139C17.6884 16.4124 17.7479 16.5019 17.8232 16.5772C17.8985 16.6525 17.988 16.712 18.0865 16.7522C18.1851 16.7924 18.2907 16.8126 18.3971 16.8115C18.5035 16.8104 18.6087 16.7881 18.7064 16.7459C18.8041 16.7037 18.8924 16.6424 18.9661 16.5656L22.8958 12.6359C22.9935 12.5614 23.0727 12.4655 23.1274 12.3555C23.182 12.2455 23.2106 12.1243 23.2109 12.0015C23.2112 11.8787 23.1832 11.7574 23.1291 11.6471C23.075 11.5369 22.9962 11.4405 22.8989 11.3656C22.8973 11.3645 22.8958 11.3635 22.8942 11.3625L18.9661 7.43433C18.8915 7.35769 18.8024 7.29677 18.7039 7.25518C18.6054 7.21358 18.4996 7.19214 18.3926 7.19214Z', fill: color })));
};
var RightArrowIcon$1 = react.memo(RightArrowIcon);


//# sourceMappingURL=RightArrow.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/NavigationGroupIcons/index.js
'use client';











var Navigation = {
    VerticalIcon: VerticalIcon$1,
    MoreIcon: More_MoreIcon$1,
    CloseIcon: CloseIcon$1,
    ExpandIcon: ExpandIcon$1,
    CollapseIcon: CollapseIcon$1,
    NextIcon: NextIcon$1,
    BackIcon: BackIcon$1,
    ExternalLinkIcon: ExternalLinkIcon$1,
    RightArrowIcon: RightArrowIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AlertGroupIcons/SuccessIcon.js
'use client';




var SuccessIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.0004 2.3999C6.69879 2.3999 2.40039 6.6983 2.40039 11.9999C2.40039 17.3015 6.69879 21.5999 12.0004 21.5999C17.302 21.5999 21.6004 17.3015 21.6004 11.9999C21.6004 6.6983 17.302 2.3999 12.0004 2.3999ZM17.366 10.1655L11.318 16.2135C11.1676 16.3639 10.9644 16.4479 10.7524 16.4479C10.5404 16.4479 10.3364 16.3639 10.1868 16.2135L7.42439 13.4511C7.11159 13.1383 7.11159 12.6327 7.42439 12.3199C7.73719 12.0071 8.24279 12.0071 8.55559 12.3199L10.7524 14.5167L16.2348 9.0343C16.5476 8.7215 17.0532 8.7215 17.366 9.0343C17.6788 9.3471 17.6788 9.8527 17.366 10.1655Z', fill: color !== null && color !== void 0 ? color : Colors/* colors.grey.50 */.O9.grey[50] })));
};
var SuccessIcon$1 = react.memo(SuccessIcon);


//# sourceMappingURL=SuccessIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AlertGroupIcons/CareerPath.js
'use client';




var CareerPathIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 28', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_10011_84687)' },
            react.createElement("path", { d: 'M18.4218 17.7865V14.9502H23.9996V27.7044H3.91354V23.5312H8.7406V20.6588H13.4279V17.7865H18.4218ZM4.69814 11.6788L4.26977 11.3316C4.26239 11.3296 4.2546 11.3296 4.24722 11.3316C4.24289 11.3319 4.23865 11.333 4.23477 11.3349C4.23089 11.3369 4.22746 11.3396 4.22467 11.3429L3.49194 12.2447C3.48992 12.2521 3.48992 12.2599 3.49194 12.2673C3.49257 12.2717 3.4941 12.276 3.49642 12.2799C3.49874 12.2838 3.50182 12.2872 3.50546 12.2898L3.92482 12.6258C3.93292 12.6281 3.94151 12.6281 3.94962 12.6258C3.95366 12.6257 3.95763 12.6246 3.96116 12.6226C3.9647 12.6207 3.9677 12.6179 3.96991 12.6145L4.70265 11.7126C4.70413 11.7091 4.7049 11.7052 4.7049 11.7014C4.7049 11.6975 4.70413 11.6937 4.70265 11.6901C4.70242 11.6858 4.7013 11.6815 4.69936 11.6777C4.69742 11.6738 4.6947 11.6703 4.69137 11.6676L4.69814 11.6788ZM3.46939 7.50335L4.95967 8.70955L5.65408 7.89114C5.70387 7.8294 5.77594 7.78972 5.85474 7.78066C5.93526 7.7713 6.01624 7.79398 6.08019 7.84379C6.39358 7.48531 6.70471 7.11782 7.01134 6.75708C7.23679 6.46399 7.46225 6.19795 7.68771 5.96347C7.90267 5.72665 8.1457 5.51693 8.41143 5.33895C8.69706 5.15222 9.01062 5.01218 9.34032 4.92411C9.74491 4.8209 10.1605 4.76714 10.5781 4.76403H10.5961C10.9388 4.746 11.3401 4.76403 11.6761 4.76403H12.0909C13.7773 4.76403 14.616 5.58921 15.2654 6.23177C15.3984 6.36253 15.5246 6.48653 15.6419 6.58573C15.7397 6.67803 15.8515 6.75413 15.9733 6.81119C16.0274 6.82923 16.1717 6.75708 16.3318 6.67592C16.4593 6.60878 16.5911 6.55004 16.7263 6.50006C17.29 6.24078 17.8671 5.9274 18.4285 5.69743C18.5476 5.64846 18.6768 5.62912 18.805 5.64107C18.9403 5.65349 19.072 5.69176 19.1928 5.75379C19.2816 5.79859 19.3642 5.85467 19.4386 5.92063C19.5144 5.98732 19.5818 6.06303 19.6392 6.14609V6.15736C19.6992 6.24311 19.7477 6.33634 19.7835 6.43468C19.8787 6.71554 19.8659 7.02178 19.7475 7.29367C19.7069 7.40776 19.6491 7.51497 19.5761 7.61157C19.4352 7.80054 19.2426 7.94463 19.0215 8.02641C18.5999 8.23158 18.176 8.44125 17.7499 8.62387C17.3933 8.79036 17.0219 8.9232 16.6406 9.02068C16.2038 9.10832 15.754 9.10832 15.3172 9.02068H15.2766C14.766 8.86187 14.2986 8.58806 13.9103 8.2203L13.6849 10.3915C13.8585 10.4816 14.0298 10.5606 14.1967 10.6327C14.4018 10.7206 14.598 10.7973 14.7896 10.8717C16.0116 11.3474 17.0172 11.742 17.3508 13.6088C17.3914 13.8342 17.4297 14.2851 17.4613 14.8037C17.5132 15.5815 17.5515 16.4901 17.5605 16.8215C17.5627 16.835 17.5627 16.8487 17.5605 16.8621C17.5517 16.8949 17.5323 16.9239 17.5055 16.9446C17.4786 16.9654 17.4457 16.9768 17.4117 16.9771H17.3869C17.3391 16.9844 17.2909 16.9889 17.2426 16.9906H16.8503C16.3994 16.9906 15.8335 16.9906 15.5675 16.9906H15.5021C15.4074 16.9906 15.3623 16.9906 15.3037 16.9275C15.2836 16.9033 15.2688 16.8751 15.2603 16.8448C15.2517 16.8145 15.2496 16.7828 15.2541 16.7516V16.6615C15.2338 16.2849 15.1932 15.6537 15.1526 15.0832C15.1211 14.6774 15.0917 14.3122 15.0669 14.1183C15.0576 14.0514 15.044 13.9851 15.0264 13.9199C15.008 13.8584 14.9838 13.7987 14.9542 13.7418L14.9339 13.7057C14.8663 13.5817 14.8054 13.4667 14.7581 13.4487C14.6701 13.4126 14.5529 13.3743 14.4176 13.3337C14.2824 13.2931 14.084 13.239 13.9058 13.1917C13.7277 13.1443 13.5181 13.0947 13.3016 13.0451L12.7876 12.9301C12.6388 13.5501 12.5193 14.204 12.3998 14.8916C12.1022 16.5217 11.7865 18.2487 11.1936 19.6262C11.178 19.663 11.1492 19.6924 11.1128 19.7087C11.0764 19.7251 11.0352 19.727 10.9974 19.7142C10.837 19.7382 10.6749 19.7488 10.5127 19.7457C10.0325 19.7457 9.36737 19.7457 9.08104 19.7277H9.01791C8.92096 19.7277 8.87136 19.7277 8.81725 19.6488C8.79918 19.6207 8.78757 19.5889 8.78328 19.5557C8.77899 19.5226 8.78213 19.4889 8.79245 19.4571L8.80824 19.3827C8.83755 19.2317 8.88489 18.9972 8.94577 18.7064L9.19828 17.5317C9.36512 16.7584 9.59283 15.7281 9.81378 14.7383C10.1001 13.4442 10.3549 12.3146 10.4428 11.9268C10.3616 11.8344 10.2805 11.7397 10.2173 11.6405C10.1228 11.5143 10.0384 11.3809 9.96484 11.2414C9.88275 11.0823 9.82137 10.9134 9.78221 10.7387C9.74213 10.5551 9.73374 10.366 9.75741 10.1795L10.1452 7.16065C10.0082 7.16184 9.87327 7.19422 9.75065 7.25534C9.62615 7.32597 9.51355 7.41575 9.41697 7.52139C9.3065 7.63862 9.19151 7.78066 9.07878 7.93172C8.98635 8.04896 8.8894 8.17521 8.76991 8.315C8.47907 8.65318 8.18597 9.0049 7.89062 9.34534C7.90989 9.39505 7.91566 9.44898 7.90735 9.50165C7.89903 9.55431 7.87693 9.60384 7.84328 9.6452L7.12406 10.4681L8.60983 11.6743C8.69418 11.7431 8.74904 11.8415 8.76314 11.9494C8.76918 12.0048 8.76412 12.0608 8.74825 12.1143C8.73238 12.1677 8.70601 12.2174 8.67071 12.2605L8.0259 13.0767C7.45861 13.0326 6.89645 12.9376 6.34623 12.7926C5.80552 12.6495 5.28056 12.4523 4.7793 12.2041L5.03632 11.8863C5.06472 11.8515 5.08596 11.8115 5.09884 11.7685C5.11172 11.7256 5.11598 11.6805 5.11137 11.6358C5.10676 11.5912 5.09337 11.5479 5.07198 11.5085C5.05059 11.469 5.02162 11.4342 4.98672 11.406L4.49072 11.0025C4.45598 10.9741 4.41597 10.9528 4.37299 10.9399C4.33002 10.9271 4.28492 10.9228 4.24029 10.9274C4.19566 10.932 4.15239 10.9454 4.11295 10.9668C4.07351 10.9882 4.03869 11.0172 4.01049 11.0521L3.75798 11.3632C3.42246 10.9326 3.12949 10.4705 2.8832 9.98339C2.62275 9.45711 2.41216 8.9076 2.25417 8.34205L2.8832 7.56873C2.95385 7.48157 3.05618 7.42599 3.16776 7.41415C3.27933 7.40232 3.39104 7.4352 3.47841 7.5056L3.46939 7.50335ZM5.68564 8.61711L5.3452 9.01843L6.7498 10.1457L7.01134 9.8436C6.61227 9.50091 6.06216 9.00941 5.71044 8.64191L5.68564 8.61486V8.61711ZM7.64262 13.5276L5.89081 15.6875C5.85628 15.7309 5.81331 15.7669 5.76448 15.7932C5.71565 15.8196 5.66199 15.8358 5.60673 15.8408C5.49519 15.8529 5.38339 15.8204 5.2956 15.7506L0.155158 11.5886C0.0674155 11.5176 0.0114641 11.4146 -0.000407559 11.3023C-0.00652292 11.2473 -0.00148991 11.1915 0.0143914 11.1385C0.0302727 11.0854 0.0566771 11.0361 0.0920302 10.9934L1.85962 8.81326C2.01268 9.27757 2.20033 9.72976 2.42101 10.166C2.70141 10.7271 3.04157 11.2562 3.43557 11.7442L3.156 12.0892C3.12774 12.124 3.10665 12.1642 3.09395 12.2072C3.08125 12.2503 3.0772 12.2954 3.08202 12.3401C3.08684 12.3847 3.10044 12.4279 3.12203 12.4673C3.14363 12.5067 3.1728 12.5413 3.20786 12.5694L3.70387 12.973C3.7386 13.0014 3.77861 13.0226 3.82159 13.0355C3.86457 13.0484 3.90966 13.0526 3.95429 13.048C3.99892 13.0434 4.0422 13.03 4.08163 13.0086C4.12107 12.9872 4.15589 12.9583 4.18409 12.9234L4.47493 12.5649L4.46141 12.5897C5.02872 12.8793 5.62597 13.1061 6.24252 13.2661C6.70202 13.3881 7.17004 13.4755 7.64262 13.5276ZM17.2809 16.8418C17.2809 16.8576 17.2809 16.8599 17.2809 16.8418V16.8418ZM11.87 0.157927C12.127 0.0509639 12.4032 -0.00272591 12.6816 0.000106503C13.0968 -0.00149674 13.5032 0.120494 13.8489 0.350551C14.1945 0.580607 14.464 0.908323 14.6228 1.29198C14.7301 1.54595 14.7853 1.8189 14.7851 2.09461C14.7867 2.50985 14.6647 2.91617 14.4347 3.26186C14.2046 3.60755 13.8769 3.87696 13.4933 4.0358C13.2393 4.14312 12.9663 4.19832 12.6906 4.19813C12.4154 4.19832 12.1427 4.14471 11.888 4.04031C11.3778 3.82867 10.9723 3.42325 10.7607 2.91302C10.6517 2.65712 10.5957 2.38178 10.5961 2.10363C10.5938 1.68942 10.7144 1.28383 10.9428 0.938256C11.1712 0.592681 11.497 0.322672 11.879 0.162436L11.87 0.157927Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_10011_84687' },
                react.createElement("rect", { width: '24', height: '27.7043', fill: 'white' })))));
};
var CareerPathIcon$1 = react.memo(CareerPathIcon);


//# sourceMappingURL=CareerPath.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AlertGroupIcons/Hot.js
'use client';




var HotIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M10.4 1.6001C10.1878 1.6001 9.98434 1.68438 9.83431 1.83441C9.68429 1.98444 9.6 2.18792 9.6 2.4001C9.6 6.4457 4 9.6001 4 15.2001C4 19.4544 8.6108 22.2048 10.2344 22.3829C10.2888 22.3944 10.3443 22.4001 10.4 22.4001C10.6122 22.4001 10.8157 22.3158 10.9657 22.1658C11.1157 22.0158 11.2 21.8123 11.2 21.6001C11.1999 21.4813 11.1734 21.3639 11.1223 21.2566C11.0712 21.1493 10.9969 21.0548 10.9047 20.9798V20.9782C10.1767 20.3878 8.8 18.675 8.8 17.111C8.8 14.5438 11.2 13.6001 11.2 13.6001C9.8312 17.4721 14.3163 17.9399 15.2188 21.7735H15.2203C15.2597 21.951 15.3584 22.1098 15.5002 22.2237C15.6419 22.3376 15.8182 22.3998 16 22.4001C16.1685 22.3997 16.3325 22.3461 16.4688 22.247C16.4832 22.2365 16.4972 22.2256 16.5109 22.2142C16.6411 22.1296 20 19.9081 20 15.2001C20 13.278 19.0387 9.9765 18.3469 8.51416L18.3453 8.50947L18.3438 8.50635C18.2848 8.35711 18.1824 8.22904 18.0498 8.13876C17.9172 8.04848 17.7604 8.00017 17.6 8.0001C17.4132 8.00027 17.2323 8.06584 17.0887 8.18542C16.9452 8.305 16.848 8.47106 16.8141 8.65478V8.65791C16.8121 8.66665 16.4447 10.2985 15.2 11.2001C15.2 7.43079 12.4787 3.53739 11.0438 1.92666C11.0222 1.89749 10.9987 1.86983 10.9734 1.84385C10.899 1.76693 10.8099 1.70572 10.7114 1.66385C10.6129 1.62198 10.507 1.6003 10.4 1.6001Z', fill: color })));
};
var HotIcon$1 = react.memo(HotIcon);


//# sourceMappingURL=Hot.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AlertGroupIcons/Urgent.js
'use client';




var UrgentIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M9.2 2C9.012 2.00008 8.83003 2.06636 8.68602 2.18722C8.54202 2.30808 8.44518 2.4758 8.4125 2.66094L6.02813 12.9859L6.02969 12.9875C6.01029 13.0567 6.00031 13.1282 6 13.2C6 13.4122 6.08429 13.6157 6.23431 13.7657C6.38434 13.9157 6.58783 14 6.8 14H11.2L10.0156 21.8406C10.0051 21.8931 9.99986 21.9465 10 22C10 22.2122 10.0843 22.4157 10.2343 22.5657C10.3843 22.7157 10.5878 22.8 10.8 22.8C10.9454 22.7998 11.0879 22.7599 11.2124 22.6848C11.3368 22.6096 11.4384 22.502 11.5062 22.3734H11.5078L17.0453 12.0719L17.0375 12.0578C17.1322 11.9264 17.2 11.7742 17.2 11.6C17.2 11.1584 16.8416 10.8 16.4 10.8H12L14.7297 3.12812C14.7761 3.02495 14.8 2.91312 14.8 2.8C14.8 2.58783 14.7157 2.38434 14.5657 2.23431C14.4157 2.08429 14.2122 2 14 2H9.2Z', fill: color })));
};
var UrgentIcon$1 = react.memo(UrgentIcon);


//# sourceMappingURL=Urgent.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/AlertGroupIcons/index.js
'use client';






var AlertGroupIcons_Alert = {
    SuccessIcon: SuccessIcon$1,
    CareerPathIcon: CareerPathIcon$1,
    HotIcon: HotIcon$1,
    UrgentIcon: UrgentIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/FormActionGroupIcons/Exchange.js
'use client';




var ExchangeIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M8.46154 19.1508C7.11615 18.6338 6.13385 17.7531 5.59154 16.6154H3.84615V14.3077L0 18.1538L3.84615 22V19.6923H8.46154V19.1508ZM23.0769 5.84615L19.2308 2V4.30769H14.6154V4.93923C15.8177 5.47385 16.7254 6.32538 17.2454 7.38462H19.2308V9.69231L23.0769 5.84615ZM16.43 14.2454C16.43 12.3923 15.3946 11.3485 13.0885 10.9031L11.5831 10.6115C10.3531 10.3685 9.83539 9.99692 9.83539 9.35769C9.83539 8.58077 10.5231 8.08692 11.5669 8.08692C12.6108 8.08692 13.3954 8.66154 13.4608 9.48692H16.2038C16.1646 7.76769 14.9492 6.49 13.0769 6.03769V4.30769H10V6.03077C8.07308 6.47923 6.88154 7.79154 6.88154 9.62462C6.88154 11.4615 7.98231 12.6269 10.1185 13.0315L11.6562 13.3392C12.9915 13.6062 13.5008 13.9538 13.5008 14.6015C13.5008 15.37 12.74 15.9046 11.6315 15.9046C10.4015 15.9046 9.55231 15.3623 9.47923 14.5131H6.64692C6.68615 16.3454 7.94308 17.5915 10 17.9954V19.6923H13.0769V17.9831C15.1831 17.5523 16.43 16.2262 16.43 14.2454Z', fill: color })));
};
var ExchangeIcon$1 = react.memo(ExchangeIcon);


//# sourceMappingURL=Exchange.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/FormActionGroupIcons/AddTag.js
'use client';




var AddTagIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_720_5754)' },
            react.createElement("path", { d: 'M13.6002 2.3999C13.1906 2.3999 12.781 2.55585 12.469 2.86865L2.86899 12.4687C2.24419 13.0935 2.24419 14.1064 2.86899 14.7312L9.26899 21.1312C9.89379 21.756 10.9067 21.756 11.5315 21.1312L11.6846 20.978C11.3766 20.1764 11.2002 19.3103 11.2002 18.3999C11.2002 14.4231 14.4234 11.1999 18.4002 11.1999C19.3106 11.1999 20.1783 11.3763 20.9799 11.6843L21.1315 11.5312C21.4435 11.2192 21.6002 10.8095 21.6002 10.3999V5.5999C21.6002 3.8327 20.1674 2.3999 18.4002 2.3999H13.6002ZM18.4002 3.9999C19.2842 3.9999 20.0002 4.7159 20.0002 5.5999C20.0002 6.4839 19.2842 7.1999 18.4002 7.1999C17.5162 7.1999 16.8002 6.4839 16.8002 5.5999C16.8002 4.7159 17.5162 3.9999 18.4002 3.9999ZM18.4002 12.7999C15.3074 12.7999 12.8002 15.3071 12.8002 18.3999C12.8002 21.4927 15.3074 23.9999 18.4002 23.9999C21.493 23.9999 24.0002 21.4927 24.0002 18.3999C24.0002 15.3071 21.493 12.7999 18.4002 12.7999ZM18.4002 15.1999C18.8418 15.1999 19.2002 15.5575 19.2002 15.9999V17.5999H20.8002C21.2418 17.5999 21.6002 17.9575 21.6002 18.3999C21.6002 18.8423 21.2418 19.1999 20.8002 19.1999H19.2002V20.7999C19.2002 21.2423 18.8418 21.5999 18.4002 21.5999C17.9586 21.5999 17.6002 21.2423 17.6002 20.7999V19.1999H16.0002C15.5586 19.1999 15.2002 18.8423 15.2002 18.3999C15.2002 17.9575 15.5586 17.5999 16.0002 17.5999H17.6002V15.9999C17.6002 15.5575 17.9586 15.1999 18.4002 15.1999Z', fill: color })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_720_5754' },
                react.createElement("rect", { width: '24', height: '24', fill: 'white' })))));
};
var AddTagIcon$1 = react.memo(AddTagIcon);


//# sourceMappingURL=AddTag.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/FormActionGroupIcons/index.js
'use client';




var FormAction = {
    ExchangeIcon: ExchangeIcon$1,
    AddTagIcon: AddTagIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/RewardsTypeGroupIcons/Hospital.js
'use client';




var HospitalIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M7.19968 2.39998C7.09367 2.39848 6.98842 2.41807 6.89004 2.4576C6.79167 2.49713 6.70213 2.55582 6.62663 2.63025C6.55114 2.70469 6.49119 2.79339 6.45027 2.89119C6.40935 2.989 6.38828 3.09396 6.38828 3.19998C6.38828 3.306 6.40935 3.41097 6.45027 3.50877C6.49119 3.60658 6.55114 3.69527 6.62663 3.76971C6.70213 3.84415 6.79167 3.90283 6.89004 3.94237C6.98842 3.9819 7.09367 4.00148 7.19968 3.99998H16.7997C16.9057 4.00148 17.0109 3.9819 17.1093 3.94237C17.2077 3.90283 17.2972 3.84415 17.3727 3.76971C17.4482 3.69527 17.5082 3.60658 17.5491 3.50877C17.59 3.41097 17.6111 3.306 17.6111 3.19998C17.6111 3.09396 17.59 2.989 17.5491 2.89119C17.5082 2.79339 17.4482 2.70469 17.3727 2.63025C17.2972 2.55582 17.2077 2.49713 17.1093 2.4576C17.0109 2.41807 16.9057 2.39848 16.7997 2.39998H7.19968ZM4.79968 5.59998C4.69367 5.59848 4.58842 5.61807 4.49004 5.6576C4.39167 5.69713 4.30213 5.75582 4.22663 5.83025C4.15114 5.90469 4.09119 5.99339 4.05027 6.09119C4.00935 6.189 3.98828 6.29396 3.98828 6.39998C3.98828 6.506 4.00935 6.61097 4.05027 6.70877C4.09119 6.80658 4.15114 6.89528 4.22663 6.96971C4.30213 7.04415 4.39167 7.10284 4.49004 7.14237C4.58842 7.1819 4.69367 7.20148 4.79968 7.19998V21.6H9.59968V17.6H14.3997V21.6H19.1997V7.19998C19.3057 7.20148 19.4109 7.1819 19.5093 7.14237C19.6077 7.10284 19.6972 7.04415 19.7727 6.96971C19.8482 6.89528 19.9082 6.80658 19.9491 6.70877C19.99 6.61097 20.0111 6.506 20.0111 6.39998C20.0111 6.29396 19.99 6.189 19.9491 6.09119C19.9082 5.99339 19.8482 5.90469 19.7727 5.83025C19.6972 5.75582 19.6077 5.69713 19.5093 5.6576C19.4109 5.61807 19.3057 5.59848 19.1997 5.59998H4.79968ZM11.9997 8.79998C12.4413 8.79998 12.7997 9.15838 12.7997 9.59998V11.2H14.3997C14.8413 11.2 15.1997 11.5584 15.1997 12C15.1997 12.4416 14.8413 12.8 14.3997 12.8H12.7997V14.4C12.7997 14.8416 12.4413 15.2 11.9997 15.2C11.5581 15.2 11.1997 14.8416 11.1997 14.4V12.8H9.59968C9.15807 12.8 8.79967 12.4416 8.79967 12C8.79967 11.5584 9.15807 11.2 9.59968 11.2H11.1997V9.59998C11.1997 9.15838 11.5581 8.79998 11.9997 8.79998Z', fill: color })));
};
var HospitalIcon$1 = react.memo(HospitalIcon);


//# sourceMappingURL=Hospital.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/RewardsTypeGroupIcons/index.js
'use client';



var RewardsType = {
    HospitalIcon: HospitalIcon$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/DoubleTickIcon/index.js
'use client';




var DoubleTickIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#609B2D' : _c, rest = (0,_tslib/* __rest */._T)(_a, ["width", "color"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 16 16', fill: 'none' }, rest),
        react.createElement("path", { d: 'M11.7227 4.26097C11.5841 4.2651 11.4526 4.32301 11.356 4.42243L6.39978 9.37868L4.64874 7.62764C4.64702 7.62589 4.64528 7.62416 4.64353 7.62243C4.54353 7.52241 4.40789 7.4662 4.26645 7.46618C4.125 7.46618 3.98935 7.52237 3.88933 7.62239C3.78931 7.72241 3.73312 7.85807 3.73312 7.99952C3.73314 8.14096 3.78934 8.2766 3.88937 8.3766L5.64562 10.1328L4.79978 10.9787L1.44353 7.62243C1.39439 7.57125 1.33553 7.53038 1.27039 7.50223C1.20526 7.47408 1.13516 7.4592 1.0642 7.45848C0.993249 7.45776 0.922863 7.4712 0.857169 7.49803C0.791474 7.52485 0.731791 7.56451 0.681616 7.61468C0.631441 7.66486 0.591781 7.72454 0.56496 7.79023C0.538139 7.85593 0.524696 7.92631 0.525418 7.99727C0.52614 8.06822 0.541013 8.13832 0.569164 8.20346C0.597316 8.26859 0.638182 8.32746 0.689368 8.3766L4.4227 12.1099C4.52272 12.2099 4.65836 12.2661 4.79978 12.2661C4.94121 12.2661 5.07684 12.2099 5.17687 12.1099L12.1102 5.1766C12.1873 5.10169 12.2399 5.00524 12.2612 4.89989C12.2825 4.79455 12.2715 4.68522 12.2296 4.58625C12.1877 4.48727 12.1169 4.40325 12.0265 4.34521C11.936 4.28717 11.8301 4.25781 11.7227 4.26097ZM14.9331 4.26618C14.7917 4.2662 14.656 4.32241 14.556 4.42243L7.99978 10.9787L7.84353 10.8224L7.08937 11.5766L7.6227 12.1099C7.72272 12.2099 7.85836 12.2661 7.99978 12.2661C8.14121 12.2661 8.27684 12.2099 8.37687 12.1099L15.305 5.18181C15.3561 5.13211 15.3967 5.07267 15.4244 5.00701C15.4522 4.94135 15.4665 4.87079 15.4665 4.79952C15.4665 4.65807 15.4103 4.52241 15.3102 4.42239C15.2102 4.32237 15.0746 4.26618 14.9331 4.26618Z', fill: color })));
};
var DoubleTickIcon$1 = react.memo(DoubleTickIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/BellIcon/index.js
'use client';



var BellIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? '#005AFF' : _e;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', className: className, width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M12.8719 2.39941C11.9879 2.39941 11.2719 3.11541 11.2719 3.99941V4.20879C8.51334 4.92045 6.47194 7.41865 6.47194 10.3994V12.315C6.47194 13.587 6.2107 14.837 5.7235 15.9994H20.0204C19.5332 14.8378 19.2719 13.587 19.2719 12.315V10.3994C19.2719 7.41865 17.2305 4.92045 14.4719 4.20879V3.99941C14.4719 3.11541 13.7559 2.39941 12.8719 2.39941ZM4.87194 17.5994C4.76593 17.5979 4.66068 17.6175 4.56231 17.657C4.46393 17.6966 4.3744 17.7553 4.2989 17.8297C4.2234 17.9041 4.16345 17.9928 4.12254 18.0906C4.08162 18.1884 4.06055 18.2934 4.06055 18.3994C4.06055 18.5054 4.08162 18.6104 4.12254 18.7082C4.16345 18.806 4.2234 18.8947 4.2989 18.9691C4.3744 19.0436 4.46393 19.1023 4.56231 19.1418C4.66068 19.1813 4.76593 19.2009 4.87194 19.1994H10.6126C10.5206 19.4562 10.473 19.7267 10.4719 19.9994C10.4719 20.6359 10.7248 21.2464 11.1749 21.6965C11.625 22.1466 12.2354 22.3994 12.8719 22.3994C13.5085 22.3994 14.1189 22.1466 14.569 21.6965C15.0191 21.2464 15.2719 20.6359 15.2719 19.9994C15.2714 19.7268 15.2243 19.4562 15.1329 19.1994H20.8719C20.978 19.2009 21.0832 19.1813 21.1816 19.1418C21.28 19.1023 21.3695 19.0436 21.445 18.9691C21.5205 18.8947 21.5804 18.806 21.6213 18.7082C21.6623 18.6104 21.6833 18.5054 21.6833 18.3994C21.6833 18.2934 21.6623 18.1884 21.6213 18.0906C21.5804 17.9928 21.5205 17.9041 21.445 17.8297C21.3695 17.7553 21.28 17.6966 21.1816 17.657C21.0832 17.6175 20.978 17.5979 20.8719 17.5994H12.8719H4.87194Z', fill: color })));
};
var BellIcon_index = react.memo(BellIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/AiIcon/index.js
'use client';




var AiIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 32 : _a, _b = props.height, height = _b === void 0 ? (width / 32) * 24 : _b, _c = props.className, className = _c === void 0 ? '' : _c, onClick = props.onClick, _d = props.type, type = _d === void 0 ? 'primary' : _d, rest = (0,_tslib/* __rest */._T)(props, ["width", "height", "className", "onClick", "type"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ width: width, height: height, className: className, viewBox: '0 0 32 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: function () { return onClick && onClick(); } }, rest),
        react.createElement("path", { d: 'M7.00212 3.07087C6.45598 3.25137 6.45598 4.0243 7.00212 4.20326C8.26102 4.61672 9.24839 5.60564 9.66339 6.86453C9.84389 7.41067 10.6168 7.41067 10.7958 6.86453C11.2092 5.60564 12.1981 4.61826 13.457 4.20326C14.0032 4.02276 14.0032 3.24983 13.457 3.07087C12.1981 2.65741 11.2108 1.6685 10.7958 0.409604C10.6153 -0.136535 9.84235 -0.136535 9.66339 0.409604C9.24839 1.67004 8.26102 2.65741 7.00212 3.07087ZM24.3366 2.14521C24.1237 1.49725 23.2058 1.49725 22.9929 2.14521L21.9963 5.17829C21.5057 6.67168 20.3332 7.84264 18.8413 8.33324L15.8082 9.32987C15.1603 9.54277 15.1603 10.4607 15.8082 10.6736L18.8413 11.6702C20.3347 12.1608 21.5057 13.3333 21.9963 14.8252L22.9929 17.8583C23.2058 18.5062 24.1237 18.5062 24.3366 17.8583L25.3348 14.8252C25.8254 13.3318 26.9964 12.1608 28.4898 11.6702L31.5228 10.6736C32.1708 10.4607 32.1708 9.54277 31.5228 9.32987L28.4898 8.3317C26.9964 7.8411 25.8254 6.67014 25.3348 5.17675L24.3366 2.14521ZM13.7301 14.873C13.5172 14.225 12.5993 14.225 12.3864 14.873L12.2645 15.2448C11.7739 16.7382 10.6029 17.9092 9.10954 18.3998L8.73773 18.5216C8.08977 18.7345 8.08977 19.6525 8.73773 19.8654L9.10954 19.9873C10.6029 20.4779 11.7739 21.6488 12.2645 23.1422L12.3864 23.514C12.5993 24.162 13.5172 24.162 13.7301 23.514L13.852 23.1422C14.3426 21.6488 15.5151 20.4779 17.007 19.9873L17.3788 19.8654C18.0267 19.6525 18.0267 18.7345 17.3788 18.5216L17.007 18.3998C15.5136 17.9092 14.3426 16.7367 13.852 15.2448L13.7301 14.873Z', fill: 'url(#paint0_linear_35033_166622)' }),
        react.createElement("path", { d: 'M0.409604 11.9911C-0.136535 12.1716 -0.136535 12.9446 0.409604 13.1235C1.6685 13.537 2.65587 14.5259 3.07087 15.7848C3.25138 16.3309 4.0243 16.3309 4.20326 15.7848C4.61672 14.5259 5.60563 13.5385 6.86453 13.1235C7.41067 12.943 7.41067 12.1701 6.86453 11.9911C5.60563 11.5777 4.61826 10.5888 4.20326 9.32987C4.02276 8.78373 3.24983 8.78373 3.07087 9.32987C2.65587 10.5903 1.6685 11.5777 0.409604 11.9911Z', fill: 'url(#paint1_linear_35033_166622)' }),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'paint0_linear_35033_166622', x1: '32.0088', y1: '12', x2: '0', y2: '12', gradientUnits: 'userSpaceOnUse' },
                type === 'primary' && (react.createElement(react.Fragment, null,
                    react.createElement("stop", { stopColor: '#B900F6' }),
                    react.createElement("stop", { offset: '0.67', stopColor: '#FF3C68', stopOpacity: '0.3' }),
                    react.createElement("stop", { offset: '1', stopColor: '#FF6200', stopOpacity: '0' }))),
                type === 'secondary' && (react.createElement(react.Fragment, null,
                    react.createElement("stop", { stopColor: '#BA02F2' }),
                    react.createElement("stop", { offset: '1', stopColor: 'white', stopOpacity: '0.15' })))),
            react.createElement("linearGradient", { id: 'paint1_linear_35033_166622', x1: '32.0088', y1: '12', x2: '0', y2: '12', gradientUnits: 'userSpaceOnUse' },
                type === 'primary' && (react.createElement(react.Fragment, null,
                    react.createElement("stop", { stopColor: '#B900F6' }),
                    react.createElement("stop", { offset: '0.67', stopColor: '#FF3C68', stopOpacity: '0.3' }),
                    react.createElement("stop", { offset: '1', stopColor: '#FF6200', stopOpacity: '0' }))),
                type === 'secondary' && (react.createElement(react.Fragment, null,
                    react.createElement("stop", { stopColor: '#BA02F2' }),
                    react.createElement("stop", { offset: '1', stopColor: 'white', stopOpacity: '0.15' })))))));
};
var AiIcon$1 = react.memo(AiIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SortMobileIcon/index.js
var SortMobileIcon = __webpack_require__(22204);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/CircleArrowRightIcon/index.js
'use client';



var CircleArrowRightIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("g", { id: 'Circled Right' },
            react.createElement("path", { id: 'Vector', d: 'M10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM13.8047 10.4713L11.138 13.138C11.008 13.268 10.8373 13.3333 10.6667 13.3333C10.496 13.3333 10.3253 13.268 10.1953 13.138C9.93467 12.8773 9.93467 12.456 10.1953 12.1953L11.724 10.6667H6.66667C6.29867 10.6667 6 10.3687 6 10C6 9.63133 6.29867 9.33333 6.66667 9.33333H11.724L10.1953 7.80467C9.93467 7.544 9.93467 7.12267 10.1953 6.862C10.456 6.60133 10.8773 6.60133 11.138 6.862L13.8047 9.52867C14.0653 9.78933 14.0653 10.2107 13.8047 10.4713Z', fill: 'white' }))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/MiniAiIcon/index.js
'use client';




var MiniAiIcon_AiIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? 'white' : _c, rest = (0,_tslib/* __rest */._T)(_a, ["width", "color"]);
    return (react.createElement("svg", (0,_tslib/* __assign */.pi)({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 14 14', fill: 'none' }, rest),
        react.createElement("path", { d: 'M1.92423 3.05627C1.69192 3.13305 1.69192 3.46183 1.92423 3.53795C2.45973 3.71383 2.87973 4.13448 3.05627 4.66998C3.13305 4.9023 3.46183 4.9023 3.53795 4.66998C3.71383 4.13448 4.13448 3.71448 4.66998 3.53795C4.9023 3.46117 4.9023 3.13239 4.66998 3.05627C4.13448 2.88039 3.71448 2.45973 3.53795 1.92423C3.46117 1.69192 3.13239 1.69192 3.05627 1.92423C2.87973 2.46039 2.45973 2.88039 1.92423 3.05627ZM9.29786 2.66252C9.2073 2.38689 8.81683 2.38689 8.72627 2.66252L8.30233 3.9527C8.09364 4.58795 7.59489 5.08605 6.9603 5.29473L5.67011 5.71867C5.39448 5.80923 5.39448 6.1997 5.67011 6.29027L6.9603 6.7142C7.59555 6.92289 8.09364 7.42164 8.30233 8.05623L8.72627 9.34642C8.81683 9.62205 9.2073 9.62205 9.29786 9.34642L9.72245 8.05623C9.93114 7.42098 10.4292 6.92289 11.0645 6.7142L12.3547 6.29027C12.6303 6.1997 12.6303 5.80923 12.3547 5.71867L11.0645 5.29408C10.4292 5.08539 9.93114 4.5873 9.72245 3.95205L9.29786 2.66252ZM4.78614 8.07658C4.69558 7.80095 4.30511 7.80095 4.21455 8.07658L4.1627 8.23473C3.95402 8.86998 3.45592 9.36808 2.82067 9.57677L2.66252 9.62861C2.38689 9.71917 2.38689 10.1096 2.66252 10.2002L2.82067 10.252C3.45592 10.4607 3.95402 10.9588 4.1627 11.5941L4.21455 11.7522C4.30511 12.0279 4.69558 12.0279 4.78614 11.7522L4.83798 11.5941C5.04667 10.9588 5.54542 10.4607 6.18001 10.252L6.33817 10.2002C6.6138 10.1096 6.6138 9.71917 6.33817 9.62861L6.18001 9.57677C5.54476 9.36808 5.04667 8.86933 4.83798 8.23473L4.78614 8.07658Z', fill: color })));
};
var MiniAiIcon = react.memo(MiniAiIcon_AiIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/icons/OrderManagementIcon.js
'use client';



var OrderManagementIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#797979' : _c;
    return (react.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none' },
        react.createElement("path", { d: 'M1.59997 1.60164C1.49396 1.60014 1.38871 1.61973 1.29033 1.65926C1.19196 1.69879 1.10242 1.75748 1.02693 1.83191C0.951431 1.90635 0.891482 1.99505 0.850564 2.09285C0.809646 2.19066 0.788574 2.29562 0.788574 2.40164C0.788574 2.50766 0.809646 2.61263 0.850564 2.71043C0.891482 2.80824 0.951431 2.89693 1.02693 2.97137C1.10242 3.04581 1.19196 3.10449 1.29033 3.14403C1.38871 3.18356 1.49396 3.20314 1.59997 3.20164H3.10309C3.28381 3.20164 3.43462 3.31481 3.48591 3.48914L6.89528 15.0798C7.19451 16.0971 8.13549 16.8016 9.19684 16.8016H17.9781C19.0568 16.8016 20.0093 16.0726 20.2937 15.0329L22.3718 7.41258C22.4043 7.29387 22.4089 7.16928 22.3853 7.0485C22.3618 6.92772 22.3106 6.814 22.236 6.71619C22.1613 6.61838 22.065 6.53911 21.9547 6.48456C21.8444 6.43001 21.723 6.40163 21.6 6.40164H6.01091L5.02184 3.03758C5.02132 3.03758 5.0208 3.03758 5.02028 3.03758C4.77077 2.18951 3.98637 1.60164 3.10309 1.60164H1.59997ZM9.59997 18.4016C9.17562 18.4016 8.76866 18.5702 8.4686 18.8703C8.16854 19.1703 7.99997 19.5773 7.99997 20.0016C7.99997 20.426 8.16854 20.833 8.4686 21.133C8.76866 21.4331 9.17562 21.6016 9.59997 21.6016C10.0243 21.6016 10.4313 21.4331 10.7313 21.133C11.0314 20.833 11.2 20.426 11.2 20.0016C11.2 19.5773 11.0314 19.1703 10.7313 18.8703C10.4313 18.5702 10.0243 18.4016 9.59997 18.4016ZM17.6 18.4016C17.1756 18.4016 16.7687 18.5702 16.4686 18.8703C16.1685 19.1703 16 19.5773 16 20.0016C16 20.426 16.1685 20.833 16.4686 21.133C16.7687 21.4331 17.1756 21.6016 17.6 21.6016C18.0243 21.6016 18.4313 21.4331 18.7313 21.133C19.0314 20.833 19.2 20.426 19.2 20.0016C19.2 19.5773 19.0314 19.1703 18.7313 18.8703C18.4313 18.5702 18.0243 18.4016 17.6 18.4016Z', fill: color })));
};
var OrderManagementIcon$1 = react.memo(OrderManagementIcon);


//# sourceMappingURL=OrderManagementIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/TwinkleLinearGradientIcon/index.js
'use client';



var TwinkleLinearGradientIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 16 16', fill: 'none' },
        react.createElement("path", { d: 'M2.19912 3.49287C1.93362 3.58062 1.93362 3.95637 2.19912 4.04338C2.81112 4.24437 3.29113 4.72513 3.49288 5.33713C3.58063 5.60263 3.95637 5.60263 4.04337 5.33713C4.24437 4.72513 4.72513 4.24512 5.33712 4.04338C5.60262 3.95562 5.60262 3.57987 5.33712 3.49287C4.72513 3.29187 4.24512 2.81113 4.04337 2.19913C3.95562 1.93362 3.57988 1.93362 3.49288 2.19913C3.29113 2.81187 2.81112 3.29187 2.19912 3.49287ZM10.6261 3.04288C10.5226 2.72788 10.0764 2.72788 9.97288 3.04288L9.48838 4.51737C9.24988 5.24337 8.67988 5.81263 7.95463 6.05113L6.48013 6.53563C6.16513 6.63913 6.16513 7.08538 6.48013 7.18888L7.95463 7.67338C8.68063 7.91188 9.24988 8.48187 9.48838 9.20712L9.97288 10.6816C10.0764 10.9966 10.5226 10.9966 10.6261 10.6816L11.1114 9.20712C11.3499 8.48112 11.9191 7.91188 12.6451 7.67338L14.1196 7.18888C14.4346 7.08538 14.4346 6.63913 14.1196 6.53563L12.6451 6.05037C11.9191 5.81188 11.3499 5.24263 11.1114 4.51663L10.6261 3.04288ZM5.46988 9.23037C5.36638 8.91537 4.92012 8.91537 4.81662 9.23037L4.75738 9.41113C4.51888 10.1371 3.94963 10.7064 3.22363 10.9449L3.04288 11.0041C2.72788 11.1076 2.72788 11.5539 3.04288 11.6574L3.22363 11.7166C3.94963 11.9551 4.51888 12.5244 4.75738 13.2504L4.81662 13.4311C4.92012 13.7461 5.36638 13.7461 5.46988 13.4311L5.52912 13.2504C5.76762 12.5244 6.33762 11.9551 7.06287 11.7166L7.24362 11.6574C7.55862 11.5539 7.55862 11.1076 7.24362 11.0041L7.06287 10.9449C6.33687 10.7064 5.76762 10.1364 5.52912 9.41113L5.46988 9.23037Z', fill: 'url(#paint0_linear_38028_270500)' }),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'paint0_linear_38028_270500', x1: '14.3559', y1: '3.59682', x2: '2', y2: '3.59682', gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#B300D7' }),
                react.createElement("stop", { offset: '0.245', stopColor: '#DC1EAF' }),
                react.createElement("stop", { offset: '0.5', stopColor: '#FF3C68' }),
                react.createElement("stop", { offset: '1', stopColor: '#FE8323' })))));
};
var TwinkleLinearGradientIcon$1 = react.memo(TwinkleLinearGradientIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/index.js
'use client';






















































































































//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useClickOutSide.js
var useClickOutSide = __webpack_require__(67094);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/usePlacement.js
'use client';





var placements = {
    'top-start': { inset: 'auto auto 0 0' },
    'top-end': { inset: 'auto 0 0 auto' },
    'bottom-start': { inset: '0 auto auto 0' },
    'bottom-end': { inset: '0 0 auto auto' }
};
var usePlacement = function (referrenceElement, popupElement, option) {
    var _a = option || {}, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = _a.spacingElement, spacingElement = _c === void 0 ? 0 : _c;
    var _d = (0,react.useState)(placements[placement]), styles = _d[0], setStyles = _d[1];
    var _e = (0,react.useState)('bottom'), intendedPosition = _e[0], setIntendedPosition = _e[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (referrenceElement && popupElement) {
            if (typeof window === 'undefined')
                return;
            var _a = referrenceElement.getBoundingClientRect(), referrenceHeight = _a.height, top_1 = _a.top, bottom = _a.bottom;
            var height = popupElement.getBoundingClientRect().height;
            var windowHeight = window.innerHeight;
            var placementStyle = {};
            var popupBottomPosition = bottom + height;
            var popupTopPosition = top_1 - height;
            if (placement === 'bottom-start' || placement === 'bottom-end') {
                if (windowHeight < popupBottomPosition) {
                    /* Another placement's style */
                    /* placementStyle = { */
                    /*     ...styles, */
                    /*     transform: `translateY(${windowHeight - popupBottomPosition + GAP}px)` */
                    /* } */
                    if (popupTopPosition < 0)
                        return;
                    if (placement === 'bottom-start') {
                        placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements['top-start']);
                    }
                    if (placement === 'bottom-end') {
                        placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements['top-end']);
                    }
                    placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, placementStyle), { transform: "translateY(-".concat(referrenceHeight + spacingElement, "px)") });
                    setStyles(placementStyle);
                    setIntendedPosition('top');
                    return;
                }
                placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements[placement]), { transform: "translateY(".concat(referrenceHeight + spacingElement, "px)") });
                setStyles(placementStyle);
                setIntendedPosition('bottom');
                return;
            }
            if (placement === 'top-start' || placement === 'top-end') {
                if (popupTopPosition < 0) {
                    /* Another placement's style */
                    /* placementStyle = { ...styles, transform: `translateY(${-popupTopPosition - GAP}px)` } */
                    var popupBottomPosition_1 = bottom + height;
                    if (popupBottomPosition_1 > windowHeight)
                        return;
                    if (placement === 'top-start') {
                        placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements['bottom-start']);
                    }
                    if (placement === 'top-end') {
                        placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements['bottom-end']);
                    }
                    placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, placementStyle), { transform: "translateY(".concat(referrenceHeight + spacingElement, "px)") });
                    setStyles(placementStyle);
                    setIntendedPosition('bottom');
                    return;
                }
                placementStyle = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, styles), placements[placement]), { transform: "translateY(-".concat(referrenceHeight + spacingElement, "px)") });
                setStyles(placementStyle);
                setIntendedPosition('top');
            }
        }
        return function () {
            setStyles(placements[placement]);
        };
    }, [referrenceElement, popupElement]);
    return { styles: styles, intendedPosition: intendedPosition };
};


//# sourceMappingURL=usePlacement.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useElementSize.js
var useElementSize = __webpack_require__(19191);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useThrottle.js
'use client';



function useThrottle(value, interval) {
    if (interval === void 0) { interval = 500; }
    var _a = (0,react.useState)(value), throttledValue = _a[0], setThrottledValue = _a[1];
    var lastExecuted = (0,react.useRef)(Date.now());
    var timerId = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        if (Date.now() >= lastExecuted.current + interval) {
            lastExecuted.current = Date.now();
            setThrottledValue(value);
        }
        else {
            timerId.current = setTimeout(function () {
                lastExecuted.current = Date.now();
                setThrottledValue(value);
            }, interval);
        }
        return function () { return clearTimeout(timerId.current); };
    }, [value, interval]);
    return throttledValue;
}


//# sourceMappingURL=useThrottle.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useCountdown.js
'use client';



var useCountdown = function (expireDate) {
    var _a = (0,react.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), times = _a[0], setTimes = _a[1];
    (0,react.useEffect)(function () {
        var interval = setInterval(function () {
            var now = new Date();
            var targetDate = new Date(expireDate);
            var timeDifference = targetDate.getTime() - now.getTime();
            var seconds = Math.max(0, Math.floor(timeDifference / 1000));
            var minutes = Math.max(0, Math.floor(seconds / 60));
            var hours = Math.max(0, Math.floor(minutes / 60));
            var days = Math.max(0, Math.floor(hours / 24));
            var remainingSeconds = seconds % 60;
            var remainingMinutes = minutes % 60;
            var remainingHours = hours % 24;
            setTimes({
                days: days,
                hours: remainingHours,
                minutes: remainingMinutes,
                seconds: remainingSeconds
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [expireDate]);
    return { times: times };
};


//# sourceMappingURL=useCountdown.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useAnimationControl.js
'use client';



function useAnimationControl(state, handler) {
    var _a = (0,react.useState)(state), isMounted = _a[0], setMounted = _a[1];
    var handleAnimationEnd = (0,react.useCallback)(function () {
        if (!state) {
            setMounted(false);
            handler && handler();
        }
    }, [state, handler]);
    (0,react.useEffect)(function () {
        if (state) {
            setMounted(true);
        }
    }, [state]);
    return { isMounted: isMounted, handleAnimationEnd: handleAnimationEnd };
}


//# sourceMappingURL=useAnimationControl.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useBeforeunload.js
'use client';



var useBeforeunload = function (handler) {
    var enabled = typeof handler === 'function';
    // Persist handler in ref
    var handlerRef = (0,react.useRef)(handler);
    (0,react.useEffect)(function () {
        handlerRef.current = handler;
    }, []);
    (0,react.useEffect)(function () {
        if (enabled) {
            var listener_1 = function (event) {
                var returnValue = handlerRef.current ? handlerRef.current(event) : '';
                if (typeof returnValue === 'string') {
                    event.preventDefault();
                    // Handle legacy `event.returnValue` and `return` activation.
                    // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
                    return (event.returnValue = returnValue);
                }
                // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`.
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
                if (event.defaultPrevented) {
                    return (event.returnValue = '');
                }
            };
            window.addEventListener('beforeunload', listener_1);
            return function () {
                window.removeEventListener('beforeunload', listener_1);
            };
        }
    }, [enabled]);
};


//# sourceMappingURL=useBeforeunload.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useInterval.js
'use client';



function useInterval(callback, delay) {
    var savedCallback = (0,react.useRef)(callback);
    // Remember the latest callback if it changes.
    (0,react.useEffect)(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    (0,react.useEffect)(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function () { return savedCallback.current(); }, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}


//# sourceMappingURL=useInterval.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMakeSearchable/types.js
'use client';

var ESearchable;
(function (ESearchable) {
    ESearchable[ESearchable["On"] = 1] = "On";
    ESearchable[ESearchable["Off"] = 0] = "Off";
})(ESearchable || (ESearchable = {}));
var EResumeType;
(function (EResumeType) {
    EResumeType[EResumeType["Attach"] = 1] = "Attach";
    EResumeType[EResumeType["ProfileOnline"] = 0] = "ProfileOnline";
})(EResumeType || (EResumeType = {}));


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMakeSearchable/const.js
'use client';

var const_SUCCESS_CODE = 200;
var SUCCESS_MESSAGE = 'Success';
var ERROR_MESSAGE = 'Error';


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMakeSearchable/index.js
'use client';











function useMakeSearchable(_a) {
    var _this = this;
    var data = _a.data, accessToken = _a.accessToken, _b = _a.langCode, langCode = _b === void 0 ? constants/* ELanguage.VI */.Df.VI : _b, baseMsUrl = _a.baseMsUrl, _c = _a.isFetchData, isFetchData = _c === void 0 ? false : _c, _d = _a.isUpdateCookies, isUpdateCookies = _d === void 0 ? true : _d;
    var _e = (0,react.useState)(false), isSearchable = _e[0], setIsSearchable = _e[1];
    var _f = (0,react.useState)(), resumesInfo = _f[0], setResumeInfo = _f[1];
    // Avoid infinity loop when using useEffect with setState in Project career-center-container
    // To switch back and forth between dataProps and dataState of the resume
    var memoInitDataSearchable = (0,react.useMemo)(function () {
        var isHaveDataState = (resumesInfo === null || resumesInfo === void 0 ? void 0 : resumesInfo.resumes) && resumesInfo.resumes.length > 0;
        if (isHaveDataState) {
            return resumesInfo;
        }
        if ((data === null || data === void 0 ? void 0 : data.resumes) && data.resumes.length > 0 && !isHaveDataState) {
            return data;
        }
        return null;
    }, [resumesInfo, data]);
    // check have resumes or not
    var isEmptyResumes = !(memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes) || (memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.length) < 1;
    // separate attachments & profile online in resumes
    var memoResumes = (0,react.useMemo)(function () {
        // profile online
        var profileOnline = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.find(function (e) { return e.isAttach === EResumeType.ProfileOnline && (e === null || e === void 0 ? void 0 : e.allowSearchableDisplay) === ESearchable.On; });
        // attachments
        var attachments = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.filter(function (e) { return e.isAttach === EResumeType.Attach; });
        return {
            profileOnline: profileOnline,
            attachments: attachments
        };
    }, [memoInitDataSearchable]);
    // check have attachment or not
    var isEmptyAttachment = !memoResumes.attachments || memoResumes.attachments.length < 1;
    // this value Check if the resume is  contactable or not
    var isUnContactable = (0,react.useMemo)(function () {
        return !!(memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.unContactable);
    }, [memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.unContactable]);
    // this value Check if the attach is eligible or not
    var isAttachAllowSearchable = (0,react.useMemo)(function () {
        var _a;
        return !!((_a = memoResumes.attachments) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.allowSearchableDisplay === ESearchable.On; }));
    }, [memoResumes.attachments]);
    // this value Check if the resume is eligible or not
    var isAllowSearchable = (0,react.useMemo)(function () {
        // check resumes file & searchable status
        if (isEmptyResumes) {
            return false;
        }
        if ((memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.searchableStatus) === ESearchable.Off) {
            return false;
        }
        // if user not have profile online | attachment. This resume is not allow searchable
        if (!memoResumes.profileOnline && isEmptyAttachment) {
            return false;
        }
        // if have attach cvs & attach cv not allow searchable
        if (!memoResumes.profileOnline && !isAttachAllowSearchable) {
            return false;
        }
        return true;
    }, [isEmptyResumes, isEmptyAttachment, memoInitDataSearchable, memoResumes, isAttachAllowSearchable]);
    // searchable priority attachment | online profile
    var priorityResume = (0,react.useMemo)(function () {
        var _a, _b;
        // if not allow searchable, can't not turn on
        if (isEmptyResumes) {
            return null;
        }
        var attachments = memoResumes.attachments, profileOnline = memoResumes.profileOnline;
        var isLastSearchableResumeId = (_b = (_a = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.profileSetting) === null || _a === void 0 ? void 0 : _a.resumeId) !== null && _b !== void 0 ? _b : 0;
        var lastResumeMakeSearchable = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.find(function (e) { return e.id === isLastSearchableResumeId; });
        // priority last resume make searchable
        if (lastResumeMakeSearchable) {
            return lastResumeMakeSearchable;
        }
        // priority attachment
        if (attachments && !isEmptyAttachment && isAttachAllowSearchable) {
            var lastUploadAttachment = attachments[0];
            return lastUploadAttachment;
        }
        // priority online profile
        if ((isEmptyAttachment || !isAttachAllowSearchable) && profileOnline) {
            return profileOnline;
        }
        return null;
    }, [isEmptyAttachment, isEmptyResumes, memoResumes, memoInitDataSearchable, isAttachAllowSearchable]);
    // this value Check if the profile is searchable or not
    var memoIsSearchable = (0,react.useMemo)(function () {
        // searchable status lets you know whether a record is searchable or not
        if (isEmptyResumes || (memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.searchableStatus) === ESearchable.Off)
            return false;
        // find resume is searchable
        var resumeSearchable = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.find(function (e) { return e.isSearchable === ESearchable.On; });
        if (resumeSearchable) {
            return true;
        }
        return false;
    }, [memoInitDataSearchable, isEmptyResumes]);
    /**
     * @return latest resume is turn on searchable
     */
    var memoLatestSearchableResume = (0,react.useMemo)(function () {
        if (!(data === null || data === void 0 ? void 0 : data.resumes)) {
            return null;
        }
        var filterResumeIsSearchable = data === null || data === void 0 ? void 0 : data.resumes.filter(function (resume) { return resume.isSearchable === 1; });
        if (filterResumeIsSearchable.length === 0) {
            return null;
        }
        return filterResumeIsSearchable[0];
    }, [data === null || data === void 0 ? void 0 : data.resumes]);
    // when props resumes data is undefined
    // & has props isFetch === true
    var getResume = function () { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var resumeSettingInfo, data_1, resumeInfo, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0,resumes/* getResumeSettingInfo */.Z0)(accessToken, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', langCode)];
                case 1:
                    resumeSettingInfo = _a.sent();
                    if (resumeSettingInfo && resumeSettingInfo.data) {
                        data_1 = resumeSettingInfo.data;
                        resumeInfo = {
                            resumes: data_1 === null || data_1 === void 0 ? void 0 : data_1.attributes,
                            profileSetting: data_1 === null || data_1 === void 0 ? void 0 : data_1.profileSetting,
                            searchableStatus: data_1 === null || data_1 === void 0 ? void 0 : data_1.searchableStatus,
                            unContactable: data_1 === null || data_1 === void 0 ? void 0 : data_1.unContactable
                        };
                        setResumeInfo(resumeInfo);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // query api make searchable
    var doSeachable = function (resumeId, searchAble, resumeType) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var body, response, bodyProfileCookie, profileCookieRespone, type, bodyRefreshProfile, error_2;
        var _a, _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 7, , 8]);
                    setIsSearchable(!!searchAble);
                    body = {
                        resumeId: resumeId,
                        searchAble: searchAble
                    };
                    return [4 /*yield*/, (0,resumes/* makeSearchable */.ZR)(baseMsUrl, accessToken, body, langCode)];
                case 1:
                    response = _e.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.code) === const_SUCCESS_CODE)) return [3 /*break*/, 6];
                    bodyProfileCookie = {
                        chooseCV: resumeType === EResumeType.Attach ? 'attach-cv' : 'profile',
                        resumeId: resumeId,
                        chooseRefreshType: (_b = (_a = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.profileSetting) === null || _a === void 0 ? void 0 : _a.chooseRefreshType) !== null && _b !== void 0 ? _b : resumes_types/* ERefreshProfile.Unset */.mI.Unset
                    };
                    profileCookieRespone = null;
                    if (!(searchAble === ESearchable.On && isUpdateCookies)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0,resumes/* updateProfileCookie */.w9)(baseMsUrl, accessToken, bodyProfileCookie, langCode)];
                case 2:
                    profileCookieRespone = _e.sent();
                    _e.label = 3;
                case 3:
                    if (!(searchAble === ESearchable.Off)) return [3 /*break*/, 5];
                    type = (_d = (_c = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.profileSetting) === null || _c === void 0 ? void 0 : _c.chooseRefreshType) !== null && _d !== void 0 ? _d : resumes_types/* ERefreshProfile.Unset */.mI.Unset;
                    bodyRefreshProfile = { type: type, status: resumes_types/* EOnOffStatus.Off */.cz.Off };
                    return [4 /*yield*/, (0,resumes/* makeRefreshProfile */.S3)(baseMsUrl, accessToken, bodyRefreshProfile, langCode)];
                case 4:
                    _e.sent();
                    _e.label = 5;
                case 5:
                    setIsSearchable(!!searchAble);
                    // renew resumes using isFetch props
                    if (isFetchData) {
                        if (!data || data.resumes.length < 1) {
                            getResume();
                        }
                    }
                    return [2 /*return*/, {
                            message: SUCCESS_MESSAGE,
                            lastMakeSearchableInfo: profileCookieRespone && (profileCookieRespone === null || profileCookieRespone === void 0 ? void 0 : profileCookieRespone.data)
                                ? (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.profileSetting), bodyProfileCookie) : null
                        }];
                case 6:
                    setIsSearchable(!isSearchable);
                    return [2 /*return*/, new model/* default */.Z({
                            data: response,
                            error: {
                                details: {
                                    ERROR_SEARCHABLE: 'ERROR_SEARCHABLE'
                                },
                                message: response === null || response === void 0 ? void 0 : response.message,
                                status: response === null || response === void 0 ? void 0 : response.code
                            }
                        })];
                case 7:
                    error_2 = _e.sent();
                    setIsSearchable(!isSearchable);
                    console.error(error_2);
                    return [2 /*return*/, new model/* default */.Z({
                            data: error_2,
                            error: {
                                details: {
                                    ERROR_SEARCHABLE: 'ERROR_SEARCHABLE'
                                },
                                message: ERROR_MESSAGE
                            }
                        })];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // get type of resume for update profile setting cookie when change resume searchable
    var getResumeType = function (resumeId) {
        var _a, _b;
        var resumeType = (_b = (_a = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.id === resumeId; })) === null || _b === void 0 ? void 0 : _b.isAttach;
        return resumeType;
    };
    // handle turn on/off searchable
    // params value* is requied, using for on/off searchable
    // params resume is optional, using for case:
    //  + not using useMakeSearchable Hook in checkbox | switcher | func(value:boolean)=> any,
    //  + hard on/off | change resume searchable (attach | online) when clicked in each element
    var callbackMakeSearchable = (0,react.useCallback)(function (value, resumeId) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var profileOnline, attachments, isLastSearchableResumeId, lastResumeMakeSearchable, lastAttachment, resumeSearchable, _a, respone, respone, respone, isNotAllowLastResumeMakeSearchable, respone_1, respone, response;
        var _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    profileOnline = memoResumes.profileOnline, attachments = memoResumes.attachments;
                    isLastSearchableResumeId = (_c = (_b = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.profileSetting) === null || _b === void 0 ? void 0 : _b.resumeId) !== null && _c !== void 0 ? _c : 0;
                    lastResumeMakeSearchable = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.find(function (e) { return e.id === isLastSearchableResumeId; });
                    lastAttachment = attachments && (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0 ? attachments[0] : null;
                    resumeSearchable = memoInitDataSearchable === null || memoInitDataSearchable === void 0 ? void 0 : memoInitDataSearchable.resumes.find(function (e) { return e.isSearchable === ESearchable.On; });
                    _a = value;
                    switch (_a) {
                        case true: return [3 /*break*/, 1];
                        case false: return [3 /*break*/, 12];
                    }
                    return [3 /*break*/, 15];
                case 1:
                    // if not allow searchable, can't not turn on
                    if (!isAllowSearchable) {
                        return [2 /*return*/, new model/* default */.Z({
                                data: null,
                                error: {
                                    details: {
                                        ALLOW_SEARCHABLE: isAllowSearchable
                                    },
                                    message: ERROR_MESSAGE
                                }
                            })];
                    }
                    if (!resumeId) return [3 /*break*/, 3];
                    return [4 /*yield*/, doSeachable(resumeId, ESearchable.On, getResumeType(resumeId))];
                case 2:
                    respone = _e.sent();
                    return [2 /*return*/, respone];
                case 3:
                    if (!!lastResumeMakeSearchable) return [3 /*break*/, 7];
                    if (!((lastAttachment === null || lastAttachment === void 0 ? void 0 : lastAttachment.id) && lastAttachment.allowSearchableDisplay === ESearchable.On)) return [3 /*break*/, 5];
                    return [4 /*yield*/, doSeachable(lastAttachment.id, ESearchable.On, EResumeType.Attach)];
                case 4:
                    respone = _e.sent();
                    return [2 /*return*/, respone];
                case 5:
                    if (!((profileOnline === null || profileOnline === void 0 ? void 0 : profileOnline.id) && (isEmptyAttachment || !isAttachAllowSearchable))) return [3 /*break*/, 7];
                    return [4 /*yield*/, doSeachable(profileOnline.id, ESearchable.On, EResumeType.ProfileOnline)];
                case 6:
                    respone = _e.sent();
                    return [2 /*return*/, respone];
                case 7:
                    if (!(lastResumeMakeSearchable === null || lastResumeMakeSearchable === void 0 ? void 0 : lastResumeMakeSearchable.id)) return [3 /*break*/, 11];
                    isNotAllowLastResumeMakeSearchable = lastResumeMakeSearchable.allowSearchableDisplay === ESearchable.Off;
                    if (!(lastResumeMakeSearchable.isAttach === EResumeType.ProfileOnline &&
                        isNotAllowLastResumeMakeSearchable)) return [3 /*break*/, 9];
                    return [4 /*yield*/, doSeachable((_d = lastAttachment === null || lastAttachment === void 0 ? void 0 : lastAttachment.id) !== null && _d !== void 0 ? _d : 0, ESearchable.On, EResumeType.ProfileOnline)];
                case 8:
                    respone_1 = _e.sent();
                    return [2 /*return*/, respone_1];
                case 9: return [4 /*yield*/, doSeachable(lastResumeMakeSearchable.id, ESearchable.On, getResumeType(lastResumeMakeSearchable === null || lastResumeMakeSearchable === void 0 ? void 0 : lastResumeMakeSearchable.id))];
                case 10:
                    respone = _e.sent();
                    return [2 /*return*/, respone];
                case 11: return [2 /*return*/, null];
                case 12:
                    if (!(resumeSearchable === null || resumeSearchable === void 0 ? void 0 : resumeSearchable.id)) return [3 /*break*/, 14];
                    return [4 /*yield*/, doSeachable(resumeSearchable.id, ESearchable.Off, getResumeType(resumeSearchable === null || resumeSearchable === void 0 ? void 0 : resumeSearchable.id))];
                case 13:
                    response = _e.sent();
                    return [2 /*return*/, response];
                case 14: return [2 /*return*/, null];
                case 15: return [2 /*return*/, null];
            }
        });
    }); }, [memoInitDataSearchable, isEmptyAttachment, memoResumes, isAllowSearchable, getResumeType]);
    (0,react.useEffect)(function () {
        if (typeof memoIsSearchable === 'boolean') {
            setIsSearchable(memoIsSearchable);
        }
    }, [memoIsSearchable]);
    (0,react.useEffect)(function () {
        if (isFetchData) {
            if (!data || data.resumes.length < 1) {
                getResume();
            }
        }
    }, [isFetchData, accessToken]);
    return [
        {
            isUnContactable: isUnContactable,
            isSearchable: isSearchable,
            isAllowSearchable: isAllowSearchable,
            isAttachAllowSearchable: isAttachAllowSearchable
        },
        callbackMakeSearchable,
        priorityResume,
        memoLatestSearchableResume
    ];
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useTransition.js
var useTransition = __webpack_require__(98638);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useLatestRef.js
var useLatestRef = __webpack_require__(42533);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useScrollLock.js
var useScrollLock = __webpack_require__(35394);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useKeyboardAccessibility.js
var useKeyboardAccessibility = __webpack_require__(18094);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useCountNumber.js
'use client';



function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}
function useCountNumber(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, to = _a.to, _c = _a.duration, duration = _c === void 0 ? 5000 : _c, _d = _a.enable, enable = _d === void 0 ? true : _d;
    // state
    var _e = (0,react.useState)(from), count = _e[0], setCount = _e[1];
    // refs
    var hasCountedUp = (0,react.useRef)(false);
    // logic
    var countNumber = (0,react.useCallback)(function () {
        var startTime = performance.now();
        var updateNumber = function (currentTime) {
            var ellapsedTime = currentTime - startTime;
            if (ellapsedTime > duration) {
                setCount(to);
            }
            else {
                var rate = easeOutExpo(ellapsedTime / duration);
                var ellapsedNumber = to - from;
                var currentNumber = from + Math.round(ellapsedNumber * rate);
                setCount(currentNumber);
                requestAnimationFrame(updateNumber);
            }
        };
        requestAnimationFrame(updateNumber);
    }, [duration, to, from]);
    // effects
    (0,react.useEffect)(function () {
        if (enable && !hasCountedUp.current) {
            countNumber();
            hasCountedUp.current = true;
        }
    }, [countNumber, enable]);
    return count;
}


//# sourceMappingURL=useCountNumber.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseInitNotification/index.js
var UseInitNotification = __webpack_require__(72831);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseWindowResize/index.js
'use client';



var useResize = function () {
    var _a = (0,react.useState)(1024), windowSize = _a[0], setWindowSize = _a[1];
    var _b = (0,react.useState)(null), breakpoint = _b[0], setBreakpoint = _b[1];
    var getBreakpointFromWidth = (0,react.useCallback)(function (width) {
        var currentBreakpoint = 'md';
        // Check breakpoint by screen width
        if (width < 768) {
            currentBreakpoint = 'xs';
        }
        else if (width >= 768 && width <= 1024) {
            currentBreakpoint = 'sm';
        }
        else if (width > 1024 && width < 1300) {
            currentBreakpoint = 'md';
        }
        else if (width >= 1301 && width < 1440) {
            currentBreakpoint = 'lg';
        }
        else {
            currentBreakpoint = 'xl';
        }
        return currentBreakpoint;
    }, []);
    var callbackObserve = (0,react.useCallback)(function () {
        var screenWidth = window.innerWidth;
        var currentBreakpoint = getBreakpointFromWidth(screenWidth);
        // Detect if breakpoint change
        if (breakpoint !== null && breakpoint === currentBreakpoint) {
            return;
        }
        setWindowSize(screenWidth);
        setBreakpoint(currentBreakpoint);
    }, [breakpoint, getBreakpointFromWidth]);
    (0,react.useEffect)(function () {
        // on mount
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', callbackObserve);
        // on Unmount
        return function () {
            window.removeEventListener('resize', callbackObserve);
        };
    }, [callbackObserve]);
    if (breakpoint === null) {
        if (typeof window === 'undefined') {
            return ['lg', windowSize];
        }
        var screenWidth = window.innerWidth;
        var calculatedBreakpoint = getBreakpointFromWidth(screenWidth);
        return [calculatedBreakpoint, screenWidth];
    }
    return [breakpoint, windowSize];
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useCollapseElement.js
'use client';



var useCollapseElement = function (_a) {
    var element = _a.element, // container element to collapse
    _b = _a.transition, // container element to collapse
    transition = _b === void 0 ? 500 : _b, _c = _a.defaultCollapse, defaultCollapse = _c === void 0 ? false : _c, // collapse status at beginning
    _d = _a.collapseHeight, // collapse status at beginning
    collapseHeight = _d === void 0 ? 0 : _d, // minimum collapse height
    _e = _a.dependencies // calculate height again when data change
    , // minimum collapse height
    dependencies = _e === void 0 ? [] : _e // calculate height again when data change
    ;
    var _f = (0,react.useState)(defaultCollapse), isCollapse = _f[0], setCollapse = _f[1];
    var _g = (0,react.useState)(false), isAlreadyFitHeight = _g[0], setAlreadyFitHeight = _g[1];
    var onCollapseClick = function () {
        if (!element.current)
            return;
        if (!isCollapse) {
            element.current.style.height = "".concat(collapseHeight, "px");
            setCollapse(true);
        }
        else {
            element.current.style.height = "".concat(element.current.scrollHeight, "px");
            setCollapse(false);
        }
    };
    (0,react.useEffect)(function () {
        var _a;
        if (element.current) {
            element.current.style.transition = "height ".concat(transition, "ms");
            element.current.style.overflow = 'hidden';
            element.current.style.height = 'auto';
            // example: if element height = 190 but initial collapse height = 200
            // so element height should be itself, not 200
            if (collapseHeight < Number((_a = element.current) === null || _a === void 0 ? void 0 : _a.scrollHeight)) {
                element.current.style.height = isCollapse ? "".concat(collapseHeight, "px") : "".concat(element.current.scrollHeight, "px");
                setAlreadyFitHeight(false);
            }
            else {
                setAlreadyFitHeight(true);
            }
        }
    }, dependencies);
    return {
        isAlreadyFitHeight: isAlreadyFitHeight,
        isCollapse: isCollapse,
        onCollapseClick: onCollapseClick
    };
};


//# sourceMappingURL=useCollapseElement.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/hooks/index.js
'use client';





























//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TextField/index.js + 4 modules
var TextField = __webpack_require__(65906);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AutoComplete/styles.js
'use client';





var AutoCompleteContainer = styled_components_browser_esm/* default.div */.ZP.div(AutoComplete_styles_templateObject_1 || (AutoComplete_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var InputRecommend = styled_components_browser_esm/* default.div */.ZP.div(AutoComplete_styles_templateObject_2 || (AutoComplete_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"], ["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"])));
var ListRecommend = styled_components_browser_esm/* default.ul */.ZP.ul(AutoComplete_styles_templateObject_3 || (AutoComplete_styles_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var RecommendItem = styled_components_browser_esm/* default.li */.ZP.li(AutoComplete_styles_templateObject_6 || (AutoComplete_styles_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px 16px;\n    cursor: pointer;\n    ", "\n    ", "\n"], ["\n    padding: 8px 16px;\n    cursor: pointer;\n    ", "\n    ", "\n"])), function (_a) {
    var isActive = _a.isActive, isHover = _a.isHover;
    if (!isActive && !isHover) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(AutoComplete_styles_templateObject_4 || (AutoComplete_styles_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background: #f2f2f2;\n        "], ["\n            background: #f2f2f2;\n        "])));
}, function (_a) {
    var isEmpty = _a.isEmpty;
    if (!isEmpty) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(AutoComplete_styles_templateObject_5 || (AutoComplete_styles_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), Colors/* colors.grey.60 */.O9.grey[60]);
});
var AutoComplete_styles_templateObject_1, AutoComplete_styles_templateObject_2, AutoComplete_styles_templateObject_3, AutoComplete_styles_templateObject_4, AutoComplete_styles_templateObject_5, AutoComplete_styles_templateObject_6;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AutoComplete/helper.js
'use client';




function helper_getOptions(options, keywords, fieldSearch, selectedItems, fieldKey) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var selectedItemIds, filtedContainOptions;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof options === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, options({
                            keywords: keywords
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    selectedItemIds = selectedItems.map(function (item) { return item[fieldKey]; });
                    filtedContainOptions = (0,helpers/* filterObjectArrayBasedOnObjectArray */.ec)(options, selectedItems, fieldKey);
                    options.filter(function (option) { return !selectedItemIds.includes(option[fieldKey]); });
                    if (filtedContainOptions.length === 0) {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, filtedContainOptions.filter(function (option) {
                            if (keywords === '') {
                                return true;
                            }
                            return (0,helpers/* transformToLatin */.nr)(option[fieldSearch]).indexOf(keywords) > -1;
                        })];
            }
        });
    });
}


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AutoComplete/index.js
'use client';














function AutoComplete(_a) {
    var options = _a.options, renderInput = _a.renderInput, _b = _a.fieldKey, fieldKey = _b === void 0 ? 'id' : _b, _c = _a.fieldValue, fieldValue = _c === void 0 ? 'name' : _c, _d = _a.value, value = _d === void 0 ? null : _d, onChange = _a.onChange, _e = _a.multiple, multiple = _e === void 0 ? false : _e, _f = _a.debounce, debounce = _f === void 0 ? 200 : _f, _g = _a.clearKeywordsAfterChange, clearKeywordsAfterChange = _g === void 0 ? true : _g, _h = _a.creatable, creatable = _h === void 0 ? {
        enable: false,
        defaultKey: -1
    } : _h;
    /*
     * State and hooks
     * */
    var _j = (0,react.useState)([]), selectedItems = _j[0], setSelectedItems = _j[1];
    var _k = (0,react.useState)(''), keywords = _k[0], setKeywords = _k[1];
    var debouncedKeywords = (0,useDebounce/* default */.Z)(keywords, debounce, true);
    var _l = (0,react.useState)([]), optionsState = _l[0], setOptionsState = _l[1];
    var _m = (0,react.useState)(false), showRecommend = _m[0], setShowRecommend = _m[1];
    var dropdownRef = (0,react.useRef)(null);
    /**
     * Effects
     * */
    // Get options
    (0,react.useEffect)(function () {
        function getOptionsPromise() {
            return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
                var response;
                return (0,_tslib/* __generator */.Jh)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, helper_getOptions(options, debouncedKeywords, fieldValue, selectedItems, fieldKey)];
                        case 1:
                            response = _a.sent();
                            setOptionsState(response);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getOptionsPromise();
    }, [options, debouncedKeywords, selectedItems]);
    // Get selected items
    (0,react.useEffect)(function () {
        if (value !== null) {
            var convertedValue = Array.isArray(value) ? value : [value];
            setSelectedItems(convertedValue);
        }
        else {
            setSelectedItems([]);
        }
    }, [value]);
    /**
     * Handle logics and actions
     * */
    var _o = (0,useFloating/* default */.Z)({
        placement: 'bottom-start',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true
        }
    }), context = _o.context, refs = _o.refs, FloatingPortal = _o.FloatingPortal;
    var handleChange = (0,react.useCallback)(function (option, canSelect) {
        if (!canSelect) {
            return;
        }
        var changedValues;
        if (multiple) {
            changedValues = (0,_tslib/* __spreadArray */.ev)([], selectedItems, true);
            changedValues.push(option);
            if (clearKeywordsAfterChange) {
                setKeywords('');
            }
        }
        else {
            changedValues = option;
            setKeywords(option[fieldValue]);
        }
        onChange(changedValues);
    }, [onChange, selectedItems]);
    // Keyboard navigation
    var activeIndex = (0,useKeyboardAccessibility/* default */.Z)(showRecommend && optionsState.length > 0, {
        onClickEscape: function () { return setShowRecommend(false); },
        optionsLength: optionsState.length,
        target: dropdownRef,
        resetIndex: true,
        forceResetIndexDeps: [keywords === '', !showRecommend],
        onSelelected: function (index) {
            var valueIds = selectedItems.map(function (item) { return item[fieldKey]; });
            var isActive = valueIds.includes(optionsState[index][fieldKey]) && !creatable.enable;
            var canSelect = !creatable.enable
                ? !isActive
                : !selectedItems.some(function (item) { return item[fieldValue] === optionsState[index][fieldValue]; });
            handleChange(optionsState[index], canSelect);
        }
    }).activeIndex;
    (0,useClickAway/* default */.Z)(function () {
        setShowRecommend(false);
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    var _p = (0,useDropdownAnimation/* default */.Z)(showRecommend && optionsState.length > 0, 'bottom-start'), isMounted = _p.isMounted, styles = _p.styles;
    /**
     * Render components
     * */
    var handleInputFocus = function () {
        setShowRecommend(true);
    };
    var handleDelete = (0,react.useCallback)(function (option) {
        if (multiple) {
            var filtedValues = (0,_tslib/* __spreadArray */.ev)([], selectedItems, true);
            if (creatable.enable && option[fieldKey] === creatable.defaultKey) {
                filtedValues = filtedValues.filter(function (item) { return item[fieldValue] !== option[fieldValue]; });
            }
            else {
                filtedValues = filtedValues.filter(function (item) { return item[fieldKey] !== option[fieldKey]; });
            }
            onChange(filtedValues);
        }
    }, [multiple, selectedItems, creatable.enable, creatable.defaultKey, fieldKey, onChange, fieldValue]);
    var handleChangeKeywords = (0,react.useCallback)(function (value) {
        if (!multiple && value === '') {
            onChange(null);
        }
        setKeywords(value);
    }, [onChange]);
    var handleKeyDown = (0,react.useCallback)(function (event) {
        if (multiple) {
            if (event.key === 'Backspace' || event.keyCode === 8) {
                if (keywords.length === 0 && selectedItems.length > 0) {
                    var changedItems = (0,_tslib/* __spreadArray */.ev)([], selectedItems, true);
                    changedItems.pop();
                    onChange(changedItems);
                }
            }
        }
    }, [keywords, selectedItems, onChange]);
    var input = renderInput({
        value: keywords,
        onChange: handleChangeKeywords,
        onFocus: handleInputFocus,
        onDelete: handleDelete,
        onKeyDown: handleKeyDown,
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        autoCapitalize: 'off',
        autoCorrect: 'off',
        spellCheck: 'false'
    });
    return (react.createElement(AutoCompleteContainer, null,
        react.createElement("div", { ref: refs.setReference }, input),
        isMounted ? (react.createElement(FloatingPortal, { enable: true },
            react.createElement(InputRecommend, { ref: refs.setPopup, style: (0,_tslib/* __assign */.pi)({ position: context.position, top: context.y, left: context.x, width: refs.reference.current.offsetWidth, zIndex: 1100 }, styles) },
                react.createElement(ListRecommend, { ref: dropdownRef }, optionsState.map(function (option, index) {
                    var valueIds = selectedItems.map(function (item) { return item[fieldKey]; });
                    var isActive = valueIds.includes(option[fieldKey]) && !creatable.enable;
                    var canSelect = !creatable.enable
                        ? !isActive
                        : !selectedItems.some(function (item) { return item[fieldValue] === option[fieldValue]; });
                    return (react.createElement(RecommendItem, { isActive: isActive, isHover: index === activeIndex, key: option[fieldKey], onClick: function () {
                            handleChange(option, canSelect);
                            setShowRecommend(false);
                        } }, option[fieldValue]));
                }))))) : null));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/NTag/themes.js
'use client';



var sizes = {
    medium: {
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '34px'
    },
    small: {
        paddingLeft: '',
        paddingRight: '',
        height: ''
    }
};
var neutral = {
    outline: {
        border: Colors/* colors.grey.80 */.O9.grey[80],
        background: '#fff',
        text: Colors/* colors.grey.20 */.O9.grey[20]
    },
    filled: {
        border: Colors/* colors.neutral.95 */.O9.neutral[95],
        background: Colors/* colors.neutral.95 */.O9.neutral[95],
        text: Colors/* colors.grey.20 */.O9.grey[20]
    }
};
var themes = { neutral: neutral };


//# sourceMappingURL=themes.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/NTag/styles.js
'use client';





var tagVars = ['--vnw-tag-gap-top', '--vnw-tag-gap-right', '--vnw-tag-gap-bottom', '--vnw-tag-gap-left'];
var TagContainer = styled_components_browser_esm/* default.div */.ZP.div(NTag_styles_templateObject_1 || (NTag_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var variant = _a.variant, color = _a.color, size = _a.size;
    /**
     * Theme color
     * */
    var theme = themes[color][variant];
    var backgroundColor = theme.background;
    var borderColor = theme.border;
    /**
     * Size
     * */
    var tagSize = sizes[size];
    var height = tagSize.height;
    var paddingLeft = tagSize.paddingLeft;
    var paddingRight = tagSize.paddingRight;
    return "\n            display: flex;\n            align-items: center;\n            background-color: ".concat(backgroundColor, ";\n            border: 1px solid ").concat(borderColor, ";\n            height: calc(").concat(height, " - var(").concat(tagVars[0], ", 0px) - var(").concat(tagVars[2], ", 0px));\n            padding-left: calc(").concat(paddingLeft, ");\n            padding-right: ").concat(paddingRight, ";\n            border-radius: 6px;\n            cursor: pointer;\n            margin: var(").concat(tagVars[0], ", 0px) var(").concat(tagVars[1], ", 0px) var(").concat(tagVars[2], ", 0px) var(").concat(tagVars[3], ", 0px);\n            & > .tag-typo {\n                display: -webkit-box;\n                -webkit-line-clamp: 1;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                word-break: break-all;\n            }\n        ");
});
var styles_CloseButton = styled_components_browser_esm/* default.span */.ZP.span(NTag_styles_templateObject_2 || (NTag_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    margin-left: 4px;\n    cursor: pointer;\n"], ["\n    display: flex;\n    margin-left: 4px;\n    cursor: pointer;\n"])));
var NTag_styles_templateObject_1, NTag_styles_templateObject_2;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/NTag/index.js
'use client';







function NTag(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'filled' : _b, _c = _a.color, color = _c === void 0 ? 'neutral' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, label = _a.label, onClick = _a.onClick, onDelete = _a.onDelete;
    var isHaveCloseButton = !!onDelete;
    var handleClick = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        onClick && onClick();
    }, [onClick]);
    var handleClickDelete = (0,react.useCallback)(function (e) {
        e.stopPropagation();
        onDelete && onDelete();
    }, [onDelete]);
    return (react.createElement(TagContainer, { variant: variant, color: color, size: size, onClick: handleClick, id: 'vnw-tag' },
        react.createElement(Typography/* default */.Z, { variant: 'span', size: 'medium', color: themes[color][variant].text, className: 'tag-typo' }, label),
        isHaveCloseButton ? (react.createElement(styles_CloseButton, { onClick: handleClickDelete },
            react.createElement(CloseIcon/* default */.Z, { width: 16 }))) : null));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Skills/services.js
'use client';







var SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion';
function getSuggestionSkills(baseMsUrl, accessToken, searchKeywork, selectedSkills, limit, lang) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var queryParams, response, jsonData, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchKeywork === '') {
                        return [2 /*return*/, []];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    queryParams = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ query: searchKeywork }, (!selectedSkills ? undefined : { selectedSkill: selectedSkills.join('|') })), (!limit ? undefined : { limit: limit }));
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(SKILL_TAGS, "?").concat((0,urlBuilder/* objToQueryStr */.G7)(queryParams)), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': lang !== null && lang !== void 0 ? lang : constants/* ELanguage.VI */.Df.VI
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    jsonData = _a.sent();
                    if (jsonData.data && jsonData.data.length > 0) {
                        return [2 /*return*/, jsonData.data.map(function (item) { return ({
                                skillName: item.name,
                                skillId: item.id,
                                skillLevel: 0
                            }); })];
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, []];
            }
        });
    });
}


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Skills/translations.js
'use client';

var Skills_translations_translations = {
    'Add a skill': 'Thêm kỹ năng',
    'Or select from suggested list': 'Hoặc chọn từ danh sách gợi ý',
    'Select all': 'Chọn tất cả',
    'You can get maximum': 'Bạn chỉ có thể thêm tối đa',
    'skills on profile': 'kỹ năng vào hồ sơ'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Skills/styles.js
'use client';




var SkillContainer = styled_components_browser_esm/* default.div */.ZP.div(Skills_styles_templateObject_1 || (Skills_styles_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var styles_Button = styled_components_browser_esm/* default.span */.ZP.span(Skills_styles_templateObject_2 || (Skills_styles_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n"])));
var Skills_styles_templateObject_1, Skills_styles_templateObject_2;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Skills/index.js
'use client';



















var LIMIT_SUGGESTION_SKILLS = 5;
function Skills_Skills(_a) {
    var _this = this;
    var skills = _a.skills, accessToken = _a.accessToken, langCode = _a.langCode, baseMsUrl = _a.baseMsUrl, userJobTitle = _a.userJobTitle, onChange = _a.onChange, _b = _a.limit, limit = _b === void 0 ? 5 : _b, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c, _d = _a.hasRecommendSkills, hasRecommendSkills = _d === void 0 ? true : _d;
    /**
     * State
     * */
    var _e = (0,react.useState)([]), recommendSkills = _e[0], setRecommendSkills = _e[1];
    /**
     * Helper function
     * */
    var t = (0,helpers/* createTranslator */.eX)({
        translations: Skills_translations_translations,
        currentLanguage: langCode
    });
    /**
     * Api helper function
     * */
    var getSuggestion = (0,react.useCallback)(function (searchKeyworks, limit) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var selectedSkills, suggestionSkills;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedSkills = skills.map(function (skill) { return skill.skillName; }) || [];
                    return [4 /*yield*/, getSuggestionSkills(baseMsUrl, accessToken !== null && accessToken !== void 0 ? accessToken : '', searchKeyworks, selectedSkills, limit, langCode)];
                case 1:
                    suggestionSkills = _a.sent();
                    return [2 /*return*/, suggestionSkills];
            }
        });
    }); }, [accessToken, skills]);
    /**
     * Effect
     * */
    // Get recommend skills based on user's job title
    var getRecommendSkills = (0,react.useCallback)(function (value) { return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var recommendSkills, filtedRecommendSkills;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSuggestion(value, LIMIT_SUGGESTION_SKILLS)];
                case 1:
                    recommendSkills = _a.sent();
                    filtedRecommendSkills = (0,helpers/* filterObjectArrayBasedOnObjectArray */.ec)(recommendSkills, skills, 'skillId', [-1]);
                    setRecommendSkills(filtedRecommendSkills);
                    return [2 /*return*/];
            }
        });
    }); }, [skills]);
    (0,react.useEffect)(function () {
        getRecommendSkills(userJobTitle);
    }, [userJobTitle, getRecommendSkills]);
    /**
     * Handle logic and action
     * */
    var concatSelectedSkills = (0,react.useCallback)(function (incomingSkills) {
        if (skills.length >= limit) {
            return skills;
        }
        if (Array.isArray(incomingSkills)) {
            var skillsToAdd = (0,_tslib/* __spreadArray */.ev)([], incomingSkills, true);
            var containSizeOfSkills = limit - skills.length;
            if (containSizeOfSkills < skillsToAdd.length) {
                skillsToAdd = skillsToAdd.slice(0, containSizeOfSkills);
            }
            return (0,_tslib/* __spreadArray */.ev)([], skills, true).concat(skillsToAdd);
        }
        var result = (0,_tslib/* __spreadArray */.ev)([], skills, true);
        result.push(incomingSkills);
        return result;
    }, [skills]);
    var handleSelectedRecommendSkills = function (selectedSkills) {
        onChange(concatSelectedSkills(selectedSkills));
    };
    var handleSelectDropdown = function (selectedSkills) {
        if (selectedSkills.length > limit) {
            return;
        }
        onChange(selectedSkills);
    };
    var handleClearAllSkills = function () { return onChange([]); };
    return (react.createElement(Row/* default */.Z, { gutter: { xs: [20, 0], sm: [40, 0] } },
        react.createElement(Col/* default */.Z, null,
            react.createElement(AutoComplete, { multiple: true, fieldKey: 'skillId', fieldValue: 'skillName', options: function (_a) {
                    var keywords = _a.keywords;
                    return (0,_tslib/* __awaiter */.mG)(_this, void 0, void 0, function () {
                        var creatableSuggestion, suggestions;
                        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    creatableSuggestion = [];
                                    if (keywords !== '') {
                                        creatableSuggestion.push({
                                            skillName: keywords,
                                            skillId: -1,
                                            skillLevel: 0
                                        });
                                    }
                                    return [4 /*yield*/, getSuggestion(keywords)];
                                case 1:
                                    suggestions = _b.sent();
                                    return [2 /*return*/, creatableSuggestion.concat(suggestions)];
                            }
                        });
                    });
                }, value: skills, onChange: handleSelectDropdown, creatable: { enable: true, defaultKey: -1 }, renderInput: function (_a) {
                    var onDelete = _a.onDelete, params = (0,_tslib/* __rest */._T)(_a, ["onDelete"]);
                    var isError = skills.length >= limit;
                    return (react.createElement(SkillContainer, { style: { position: 'relative' } },
                        react.createElement(TextField/* default */.Z, (0,_tslib/* __assign */.pi)({ id: 'vnw-skills-input', hasError: isError, prefix: skills.map(function (value) { return (react.createElement(NTag, { key: value.skillId, label: value.skillName, onDelete: function () { return onDelete(value); } })); }), suffix: react.createElement("div", { style: { width: 16 } }), allowClear: false, placeholder: t('Add a skill'), styles: {
                                container: isMobile ? { maxHeight: 74, overflow: 'auto' } : {}
                            } }, params)),
                        skills.length > 0 ? (react.createElement(styles_Button, { onClick: handleClearAllSkills, "aria-label": 'Delete all skills' },
                            react.createElement(RemoveFillIcon/* default */.Z, { fill: Colors/* colors.grey.60 */.O9.grey[60] }))) : null,
                        isError ? (react.createElement(Form/* default.Error */.Z.Error, { forceMsg: "".concat(t('You can get maximum'), " ").concat(limit, " ").concat(t('skills on profile')) })) : null));
                } })),
        recommendSkills.length > 0 && hasRecommendSkills === true ? (react.createElement(Col/* default */.Z, null,
            react.createElement(Row/* default */.Z, { gutter: { xs: [24, 0] }, justify: 'center' },
                react.createElement(Col/* default */.Z, { xs: 'auto' },
                    react.createElement(Typography/* default */.Z, { name: 'label', size: 'medium', variant: 'p' }, t('Or select from suggested list'))),
                react.createElement(Col/* default */.Z, null,
                    react.createElement(Row/* default */.Z, { gutter: 12, justify: 'center' }, recommendSkills.map(function (item) {
                        return (react.createElement(Col/* default */.Z, { key: item.skillId, xs: 'auto' },
                            react.createElement(NTag, { label: item.skillName, variant: 'outline', onClick: function () { return handleSelectedRecommendSkills(item); } })));
                    }))),
                react.createElement(Col/* default */.Z, { xs: 'auto' },
                    react.createElement(Typography/* default */.Z, { variant: 'p', size: 'small', name: 'label', color: Colors/* colors.primary.40 */.O9.primary[40], style: { cursor: 'pointer' }, onClick: function () { return handleSelectedRecommendSkills(recommendSkills); } }, t('Select all')))))) : null));
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/MultiLevelSelect/MultiLevelSelect/index.js + 10 modules
var MultiLevelSelect = __webpack_require__(81234);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/JobPostCard.css.js
'use client';






var Left = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_1 || (JobPostCard_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        a {\n            display: inline-flex;\n            height: fit-content;\n        }\n    "], ["\n        display: flex;\n        a {\n            display: inline-flex;\n            height: fit-content;\n        }\n    "]))),
    Avatar: styled_components_browser_esm/* default.img */.ZP.img(JobPostCard_css_templateObject_2 || (JobPostCard_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: 108px;\n        height: 108px;\n        object-fit: contain;\n        background-color: white;\n        border-radius: 8px;\n        overflow: hidden;\n        padding: 6px;\n        border: 1px solid ", ";\n    "], ["\n        width: 108px;\n        height: 108px;\n        object-fit: contain;\n        background-color: white;\n        border-radius: 8px;\n        overflow: hidden;\n        padding: 6px;\n        border: 1px solid ", ";\n    "])), Colors/* colors.neutral.90 */.O9.neutral[90])
};
var Right = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_3 || (JobPostCard_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    "], ["\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    "]))),
    Title: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_5 || (JobPostCard_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: inline-flex;\n        font-size: 16px !important;\n        line-height: 20px !important;\n        width: fit-content;\n\n        a {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n            color: ", ";\n            font-weight: 500;\n            transition: all 0.25s;\n        }\n\n        ", "\n    "], ["\n        display: inline-flex;\n        font-size: 16px !important;\n        line-height: 20px !important;\n        width: fit-content;\n\n        a {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n            color: ", ";\n            font-weight: 500;\n            transition: all 0.25s;\n        }\n\n        ", "\n    "])), function (_a) {
        var isViewed = _a.isViewed;
        return (isViewed ? Colors/* colors.neutral.40 */.O9.neutral[40] : Colors/* colors.grey.20 */.O9.grey[20]);
    }, function (_a) {
        var isBoldAndRed = _a.isBoldAndRed, isViewed = _a.isViewed;
        return isBoldAndRed && (0,styled_components_browser_esm/* css */.iv)(JobPostCard_css_templateObject_4 || (JobPostCard_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                a {\n                    color: ", ";\n                }\n            "], ["\n                a {\n                    color: ", ";\n                }\n            "])), isViewed ? Colors/* colors.error.30 */.O9.error[30] : Colors/* colors.error.40 */.O9.error[40]);
    }),
    Text: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_6 || (JobPostCard_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 14px;\n    "], ["\n        font-size: 14px;\n    "]))),
    Bottom: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_7 || (JobPostCard_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n    "], ["\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n    "]))),
    BottomRight: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_8 || (JobPostCard_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    "], ["\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    "])))
};
var AppliedText = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_9 || (JobPostCard_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 4px;\n    font-weight: 500;\n    color: ", ";\n    white-space: nowrap;\n"], ["\n    display: flex;\n    gap: 4px;\n    font-weight: 500;\n    color: ", ";\n    white-space: nowrap;\n"])), Colors/* colors.green.50 */.O9.green[50]);
var Salary = styled_components_browser_esm/* default.span */.ZP.span(JobPostCard_css_templateObject_10 || (JobPostCard_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: ", ";\n    line-height: 18px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: ", ";\n    line-height: 18px;\n"])), Colors/* colors.secondary.40 */.O9.secondary[40]);
var Location = styled_components_browser_esm/* default.span */.ZP.span(JobPostCard_css_templateObject_11 || (JobPostCard_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    line-height: 18px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    line-height: 18px;\n"])));
var CompanyName = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_12 || (JobPostCard_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 18px;\n    & a,\n    span {\n        word-break: break-word;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n    }\n    a {\n        color: ", ";\n    }\n    span {\n        color: ", ";\n    }\n"], ["\n    line-height: 18px;\n    & a,\n    span {\n        word-break: break-word;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n    }\n    a {\n        color: ", ";\n    }\n    span {\n        color: ", ";\n    }\n"])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.grey.20 */.O9.grey[20]);
var SaveJobWrapper = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_13 || (JobPostCard_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n\n    height: 32px;\n    padding: 0 8px;\n    color: ", ";\n    border-radius: 48px;\n\n    font-size: 12px;\n    font-weight: 500;\n    transition: 0.25s;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n\n    height: 32px;\n    padding: 0 8px;\n    color: ", ";\n    border-radius: 48px;\n\n    font-size: 12px;\n    font-weight: 500;\n    transition: 0.25s;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (_a) {
    var isSaved = _a.isSaved;
    return (isSaved ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.20 */.O9.grey[20]);
}, Colors/* colors.primary.95 */.O9.primary[95]);
var NextImageContainer = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_14 || (JobPostCard_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 108px;\n    height: 108px;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    border: 1px solid ", ";\n    padding: 6px;\n\n    & > div {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n\n    img {\n        object-fit: contain;\n    }\n"], ["\n    width: 108px;\n    height: 108px;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    border: 1px solid ", ";\n    padding: 6px;\n\n    & > div {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n\n    img {\n        object-fit: contain;\n    }\n"])), Colors/* colors.neutral.90 */.O9.neutral[90]);
var Badge = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_15 || (JobPostCard_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 4px;\n    "], ["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 4px;\n    "]))),
    UpdatedTime: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_16 || (JobPostCard_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        background: ", ";\n        padding: 7px 6px;\n        border-radius: 6px;\n        font-size: 12px;\n        color: ", ";\n        white-space: nowrap;\n        line-height: 14px;\n    "], ["\n        background: ", ";\n        padding: 7px 6px;\n        border-radius: 6px;\n        font-size: 12px;\n        color: ", ";\n        white-space: nowrap;\n        line-height: 14px;\n    "])), Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.50 */.O9.neutral[50]),
    Viewed: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_17 || (JobPostCard_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 4px;\n        color: ", ";\n    "], ["\n        padding: 4px;\n        color: ", ";\n    "])), Colors/* colors.neutral.20 */.O9.neutral[20])
};
var JobInvitationBlock = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_18 || (JobPostCard_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 8px;\n    padding: 4px 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n    font-size: 12px;\n\n    > p {\n        margin: 0;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n    }\n    > svg {\n        flex: 0 0 20px;\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 8px;\n    padding: 4px 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n    font-size: 12px;\n\n    > p {\n        margin: 0;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n    }\n    > svg {\n        flex: 0 0 20px;\n    }\n"])), Colors/* colors.green.95 */.O9.green[95], Colors/* colors.green.50 */.O9.green[50]);
var TopContainer = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_19 || (JobPostCard_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 16px;\n"], ["\n    display: flex;\n    gap: 16px;\n"])));
var BottomContainer = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_20 || (JobPostCard_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid ", ";\n"], ["\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid ", ";\n"])), Colors/* colors.neutral.95 */.O9.neutral[95]);
styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_21 || (JobPostCard_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 4px;\n    width: calc(100% - 120px);\n"], ["\n    display: flex;\n    gap: 4px;\n    width: calc(100% - 120px);\n"])));
var JobPostCard_css_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_24 || (JobPostCard_css_templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    border: 1px solid ", ";\n    border-radius: 20px;\n    background: white;\n    transition: all 0.25s;\n\n    &:hover {\n        background: rgb(249, 251, 255);\n    }\n\n    ", "\n    ", "\n"], ["\n    padding: 16px;\n    border: 1px solid ", ";\n    border-radius: 20px;\n    background: white;\n    transition: all 0.25s;\n\n    &:hover {\n        background: rgb(249, 251, 255);\n    }\n\n    ", "\n    ", "\n"])), function (_a) {
    var isPriorityJob = _a.isPriorityJob;
    return (isPriorityJob ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.neutral.95 */.O9.neutral[95]);
}, function (_a) {
    var layout = _a.layout;
    return layout === 'secondary' && (0,styled_components_browser_esm/* css */.iv)(JobPostCard_css_templateObject_22 || (JobPostCard_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            ", " {\n                width: 48px;\n                height: 48px;\n            }\n            ", " {\n                width: 48px;\n                height: 48px;\n            }\n            ", " {\n                padding-top: 8px;\n            }\n            ", " {\n                flex-direction: column;\n                gap: 8px;\n            }\n            ", " {\n                gap: 8px;\n            }\n            ", " {\n                a {\n                    -webkit-line-clamp: 2;\n                }\n            }\n        "], ["\n            ", " {\n                width: 48px;\n                height: 48px;\n            }\n            ", " {\n                width: 48px;\n                height: 48px;\n            }\n            ", " {\n                padding-top: 8px;\n            }\n            ", " {\n                flex-direction: column;\n                gap: 8px;\n            }\n            ", " {\n                gap: 8px;\n            }\n            ", " {\n                a {\n                    -webkit-line-clamp: 2;\n                }\n            }\n        "])), Left.Avatar, NextImageContainer, BottomContainer, TopContainer, Left.Container, Right.Title);
}, function (_a) {
    var isPriorityJob = _a.isPriorityJob;
    if (!isPriorityJob) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(JobPostCard_css_templateObject_23 || (JobPostCard_css_templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            ", " {\n                margin-right: 36px;\n            }\n        "], ["\n            ", " {\n                margin-right: 36px;\n            }\n        "])), CompanyName);
});
var AISummary = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_25 || (JobPostCard_css_templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        ul {\n            margin: 0;\n            padding-left: 26px;\n            li {\n                margin: 4px 0;\n            }\n        }\n    "], ["\n        ul {\n            margin: 0;\n            padding-left: 26px;\n            li {\n                margin: 4px 0;\n            }\n        }\n    "]))),
    Label: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_26 || (JobPostCard_css_templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        padding: 4px 0;\n        font-weight: 500;\n        span {\n            background: linear-gradient(270deg, #b300d7 0%, #dc1eaf 24.5%, #ff3c68 50%, #fe8323 100%);\n            background-clip: text;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n    "], ["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        padding: 4px 0;\n        font-weight: 500;\n        span {\n            background: linear-gradient(270deg, #b300d7 0%, #dc1eaf 24.5%, #ff3c68 50%, #fe8323 100%);\n            background-clip: text;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n    "]))),
    Badge: styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_27 || (JobPostCard_css_templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        color: ", ";\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 14px;\n        border-radius: 4px;\n        background: ", ";\n        padding: 2px 4px;\n    "], ["\n        color: ", ";\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 14px;\n        border-radius: 4px;\n        background: ", ";\n        padding: 2px 4px;\n    "])), Colors/* colors.green.50 */.O9.green[50], Colors/* colors.green.90 */.O9.green[90])
};
var JobPostCard_css_Container = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_28 || (JobPostCard_css_templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    color: ", ";\n\n    a {\n        transition: all 0.25s;\n        &:hover {\n            color: ", ";\n        }\n    }\n\n    &:hover {\n        ", " {\n            a {\n                color: ", ";\n            }\n        }\n    }\n"], ["\n    position: relative;\n    color: ", ";\n\n    a {\n        transition: all 0.25s;\n        &:hover {\n            color: ", ";\n        }\n    }\n\n    &:hover {\n        ", " {\n            a {\n                color: ", ";\n            }\n        }\n    }\n"])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.secondary.40 */.O9.secondary[40], Right.Title, Colors/* colors.secondary.40 */.O9.secondary[40]);
var NewBadgeWrapper = styled_components_browser_esm/* default.span */.ZP.span(JobPostCard_css_templateObject_29 || (JobPostCard_css_templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-right: 4px;\n"], ["\n    margin-right: 4px;\n"])));
var MatchingText = styled_components_browser_esm/* default.span */.ZP.span(JobPostCard_css_templateObject_30 || (JobPostCard_css_templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), Colors/* colors.grey.20 */.O9.grey[20]);
var Separator = styled_components_browser_esm/* default.div */.ZP.div(JobPostCard_css_templateObject_31 || (JobPostCard_css_templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 70%;\n    width: 1px;\n    background-color: ", ";\n"], ["\n    height: 70%;\n    width: 1px;\n    background-color: ", ";\n"])), Colors/* colors.grey.80 */.O9.grey[80]);
var StyledTooltip = (0,styled_components_browser_esm/* default */.ZP)(SimpleTooltip/* default */.Z)(JobPostCard_css_templateObject_32 || (JobPostCard_css_templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-flex;\n"], ["\n    display: inline-flex;\n"])));
var CustomH2 = styled_components_browser_esm/* default.h2 */.ZP.h2(JobPostCard_css_templateObject_33 || (JobPostCard_css_templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0px 36px 0px 0px !important;\n    font-size: 16px !important;\n"], ["\n    margin: 0px 36px 0px 0px !important;\n    font-size: 16px !important;\n"])));
var JobPostCard_css_templateObject_1, JobPostCard_css_templateObject_2, JobPostCard_css_templateObject_3, JobPostCard_css_templateObject_4, JobPostCard_css_templateObject_5, JobPostCard_css_templateObject_6, JobPostCard_css_templateObject_7, JobPostCard_css_templateObject_8, JobPostCard_css_templateObject_9, JobPostCard_css_templateObject_10, JobPostCard_css_templateObject_11, JobPostCard_css_templateObject_12, JobPostCard_css_templateObject_13, JobPostCard_css_templateObject_14, JobPostCard_css_templateObject_15, JobPostCard_css_templateObject_16, JobPostCard_css_templateObject_17, JobPostCard_css_templateObject_18, JobPostCard_css_templateObject_19, JobPostCard_css_templateObject_20, JobPostCard_css_templateObject_21, JobPostCard_css_templateObject_22, JobPostCard_css_templateObject_23, JobPostCard_css_templateObject_24, JobPostCard_css_templateObject_25, JobPostCard_css_templateObject_26, JobPostCard_css_templateObject_27, JobPostCard_css_templateObject_28, JobPostCard_css_templateObject_29, JobPostCard_css_templateObject_30, JobPostCard_css_templateObject_31, JobPostCard_css_templateObject_32, JobPostCard_css_templateObject_33;


//# sourceMappingURL=JobPostCard.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/constant.js
'use client';

var DEFAULT_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';
var SERVICE_CODE_URGENT_JOB = 'UJ';
var SERVICE_CODE_TOP_MANAGEMENT_JOB = 'TMJ';
var SERVICE_CODE_HEADHUNT_JOB = 'JPHH';
var SERVICE_CODE_HEADHUNT_JOB_MOBILE = 'JPHM';
var constant_SUCCESS_CODE = 200;
var REQUIRED_COVER_LETTER = 1;
var badgeSettings = {
    premium: {
        name: 'Premium'
    },
    urgent: {
        name: 'Urgent'
    },
    topManagement: {
        name: 'Top management',
        utm: '?utm_source_navi=vnw_searchresults&utm_medium_navi=TopManagementJobs'
    },
    headHunter: {
        name: 'Head hunter'
    },
    new: {
        name: 'New'
    },
    matching: {
        name: 'Matching'
    }
};


//# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/translations.js
'use client';

var JobPostCard_translations_translations = {
    New: 'Mới',
    'Login to view salary': 'Đăng nhập để xem lương',
    Posted: 'Đã đăng',
    'Expires: ': 'Hết hạn: ',
    in: 'trong',
    'Expires on today': 'Hết hạn trong hôm nay',
    day: 'ngày',
    s: '',
    ago: 'trước',
    hour: 'giờ',
    Bonus: 'Thưởng',
    'Healthcare Plan': 'Khám sức khỏe',
    'Paid Leave': 'Nghỉ phép',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Laptop',
    Mobile: 'Điện thoại',
    'Travel Opportunities': 'Du lịch',
    'Team Activities': 'Hoạt động',
    Transportation: 'Trợ cấp đi lại',
    Canteen: 'Căn-tin',
    Vouchers: 'Thưởng quà',
    Kindergarten: 'Trông trẻ',
    Others: 'Khác',
    Applied: 'Đã nộp đơn',
    'You should': 'Bạn phải',
    'Sign In': 'đăng nhập',
    'to save jobs': 'để lưu công việc',
    'Save job successfully': 'Lưu công việc thành công',
    'Remove job successfully': 'Xóa công việc thành công',
    Updated: 'Cập nhật',
    Today: 'Hôm nay',
    Expire: 'Hết hạn',
    'TODAY!': 'HÔM NAY!',
    'Latest ': '',
    'employment/hiring with high salary & attractive benefits': 'tuyển dụng - Tìm việc mới nhất, lương thưởng hấp dẫn.',
    '/job-channel/top-management': '/kenh-viec-lam/quan-ly',
    '/management-jobs': '/viec-lam-quan-ly',
    Featured: 'Tiêu biểu',
    Matching: 'Phù Hợp',
    'This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.': 'Việc làm này phù hợp với các tiêu chí sau trong hồ sơ của bạn: Chức danh, Kỹ năng, Địa điểm làm việc, Ngành nghề.',
    'Information of this employer is hidden for confidentiality purposes.': 'Thông tin nhà tuyển dụng đã được ẩn đi vì mục đích bảo mật.',
    'Trusted company': 'Công ty uy tín',
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    Success: 'Thành công',
    'Just removed 1 saved job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Employer highly values your resume and has sent you an invitation to apply.': 'Nhà tuyển dụng đánh giá cao hồ sơ của bạn và đã gửi lời mời ứng tuyển.',
    'Save job': 'Lưu việc làm',
    'Saved job': 'Đã lưu',
    'AI summary': 'AI tóm tắt',
    'Viewed': 'Đã xem'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/utils.js
'use client';




function convertISOToMillisecond(dateTime) {
    return Date.parse(dateTime) / 1000;
}
var SERVICE_CODE_REFRESH_JOB_CLP_REWARD = 'RJF';
var checkIsNew = function (item) {
    if (item.onlineServiceCode === SERVICE_CODE_REFRESH_JOB_CLP_REWARD) {
        return false;
    }
    return (0,time/* convertDateTime */.jF)(new Date(item.onlineOn || ''), 7) === (0,time/* convertDateTime */.jF)(Date.now(), 7);
};
var buildCompanyUrl = function (companyId, companyName, langCode) {
    var companyNameStr = (0,helpers/* slugify */.lV)(companyName);
    var prefixCompanyPath = langCode === 'vi' ? 'nha-tuyen-dung' : 'companies';
    return "/".concat(prefixCompanyPath, "/").concat(companyNameStr, "-c").concat(companyId);
};
var formatedJob = function (job) {
    var categoryVIs = [];
    var categoryIds = [];
    var categories = [];
    var locationIds = [];
    var locationVIs = [];
    var locations = [];
    var services = [];
    if (job.industries !== null && job.industries !== undefined) {
        job.industries.map(function (industry) {
            categoryVIs.push(industry.industryNameVI);
            categoryIds.push(industry.industryId);
            categories.push(industry.industryName);
        });
    }
    if (job.workingLocations !== null && job.workingLocations !== undefined) {
        job.workingLocations.map(function (wl) {
            locationIds.push(wl.workingLocationId);
            if (locationVIs && locationVIs.indexOf(wl.cityNameVI) < 0) {
                locationVIs.push(wl.cityNameVI);
            }
            if (locations && locations.indexOf(wl.cityName) < 0) {
                locations.push(wl.cityName);
            }
        });
    }
    if (job.services !== null && job.services !== undefined) {
        job.services.map(function (service) {
            services.push(service.serviceCode);
        });
    }
    return {
        categoryVIs: categoryVIs,
        categoryIds: categoryIds,
        categories: categories,
        locationVIs: locationVIs,
        locationIds: locationIds,
        locations: locations,
        serviceCode: services,
        isPremium: !job.simpleServices ? false : job.simpleServices.includes('isPremium'),
        isHeadhuntJob: !job.simpleServices ? false : job.simpleServices.includes('isHeadhunt'),
        /**
         * VNW-18143 Add service Urgent Job -M
         *
         * Because UJ and UJ-M are same rule search on Web
         *
         * @author Thai Tran
         * @since Otc 6, 2022
         */
        isUrgentJob: job.isUrgentJob,
        isTopManagementJob: !services ? false : services.includes('TMJ'),
        isPriorityJob: !services ? false : services.includes('PJ')
    };
};


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/services.js
'use client';





var saveJob = function (_a) {
    var _b = _a.jobId, jobId = _b === void 0 ? -1 : _b, _c = _a.accessToken, accessToken = _c === void 0 ? '' : _c, _d = _a.language, language = _d === void 0 ? constants/* ELanguage.VI */.Df.VI : _d, _e = _a.baseUrl, baseUrl = _e === void 0 ? '' : _e;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var apiUrl, res;
        var _f;
        return (0,_tslib/* __generator */.Jh)(this, function (_g) {
            switch (_g.label) {
                case 0:
                    apiUrl = baseUrl + '/api-gateway/v1.0/save-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': language
                            },
                            body: JSON.stringify({ jobId: jobId })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _g.sent();
                    if (((_f = res === null || res === void 0 ? void 0 : res.meta) === null || _f === void 0 ? void 0 : _f.code) === constant_SUCCESS_CODE) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var unsaveJob = function (_a) {
    var _b = _a.jobId, jobId = _b === void 0 ? -1 : _b, _c = _a.accessToken, accessToken = _c === void 0 ? '' : _c, _d = _a.language, language = _d === void 0 ? constants/* ELanguage.VI */.Df.VI : _d, _e = _a.baseUrl, baseUrl = _e === void 0 ? '' : _e;
    return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var apiUrl, res;
        var _f;
        return (0,_tslib/* __generator */.Jh)(this, function (_g) {
            switch (_g.label) {
                case 0:
                    apiUrl = baseUrl + '/api-gateway/v1.0/unsave-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': language
                            },
                            body: JSON.stringify({ jobId: jobId })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _g.sent();
                    if (((_f = res === null || res === void 0 ? void 0 : res.meta) === null || _f === void 0 ? void 0 : _f.code) === constant_SUCCESS_CODE) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PreviewJob/Images/HeartFillIcon.js
var HeartFillIcon = __webpack_require__(8842);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobCard/Components/Images/SaveLoadingIcon.js
var SaveLoadingIcon = __webpack_require__(75243);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/RibbonTag.js
'use client';





var RibbonTagWrapper = styled_components_browser_esm/* default.div */.ZP.div(RibbonTag_templateObject_1 || (RibbonTag_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    right: 16px;\n    pointer-events: none;\n    label {\n        position: absolute;\n        bottom: 12px;\n        left: 0;\n        color: #fff;\n        font-weight: 700;\n        line-height: 14px;\n        font-size: 10px;\n        text-align: center;\n        width: 100%;\n        margin: 0;\n    }\n"], ["\n    position: absolute;\n    top: 0;\n    right: 16px;\n    pointer-events: none;\n    label {\n        position: absolute;\n        bottom: 12px;\n        left: 0;\n        color: #fff;\n        font-weight: 700;\n        line-height: 14px;\n        font-size: 10px;\n        text-align: center;\n        width: 100%;\n        margin: 0;\n    }\n"])));
var RibbonTag = function (props) {
    var _a = props.color, color = _a === void 0 ? '#005AFF' : _a, _b = props.children, children = _b === void 0 ? '' : _b;
    return (react.createElement(RibbonTagWrapper, null,
        react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '29', height: '39', viewBox: '0 0 29 39', fill: 'none' },
            react.createElement("path", { d: 'M0 0H29V39L14.5 33L0 39V0Z', fill: color })),
        react.createElement("label", null, children)));
};
var RibbonTag_templateObject_1;


//# sourceMappingURL=RibbonTag.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/JobPostCard/index.js
'use client';







































































































































































var JobPostCard = function (props) {
    var _a;
    var data = props.data, langCode = props.langCode, robot = props.robot, api = props.api, custom = props.custom, _b = props.utm, utm = _b === void 0 ? '' : _b, _c = props.companyUTM, companyUTM = _c === void 0 ? '' : _c, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d, userInfo = props.userInfo, _e = props.nextImage, nextImage = _e === void 0 ? null : _e, _f = props.isForceJobLinkVI, isForceJobLinkVI = _f === void 0 ? false : _f, headingTagTitleJob = props.headingTagTitleJob, _g = props.layout, layout = _g === void 0 ? 'primary' : _g, onSave = props.onSave, trackingSetting = props.trackingSetting, _h = props.enableVisualized, enableVisualized = _h === void 0 ? false : _h, _j = props.enableAISummary, enableAISummary = _j === void 0 ? false : _j, _k = props.isJobSearchPage, isJobSearchPage = _k === void 0 ? false : _k, _l = props.sorting, sorting = _l === void 0 ? 'default' : _l;
    var previewJob = (0,_tslib/* __assign */.pi)({ enable: true }, props.previewJob);
    var jobCardRef = (0,react.useRef)(null);
    var jobCardHeight = (0,react.useRef)(0);
    var isAleadyTrackingViewJob = (0,react.useRef)(false);
    var _m = (custom || {}).forceNormalJob, forceNormalJob = _m === void 0 ? false : _m;
    var _o = (0,react.useState)(false), isShowApplyPopup = _o[0], setShowApplyPopup = _o[1];
    var _p = (0,react.useState)(!!(data === null || data === void 0 ? void 0 : data.isSaved)), isSaved = _p[0], setSaved = _p[1];
    var _q = (0,react.useState)(false), isSaveLoading = _q[0], setSaveLoading = _q[1];
    var formatedJobData = formatedJob(data);
    var tracking = (0,useHog/* default */.Z)().tracking;
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: jobCardRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var isNewJob = checkIsNew(data);
    var showLogo = !!(data.companyLogo && data.isShowLogo && !data.isAnonymous);
    var location = langCode === constants/* ELanguage.EN */.Df.EN
        ? (formatedJobData.locations || []).join(', ')
        : (formatedJobData.locationVIs || []).join(', ');
    var isLogin = !!(api === null || api === void 0 ? void 0 : api.accessToken);
    var isBoldAndRed = !!data.isBoldAndRedJob || !!data.visibilityDisplay;
    var shouldMakeJobPriority = data.priorityOrder !== undefined && convertISOToMillisecond(data.priorityOrder) > 0;
    var companyUrl = buildCompanyUrl(data.companyId || 0, data.companyName || '', langCode);
    var serviceCode = formatedJobData.serviceCode, isPremium = formatedJobData.isPremium, isUrgentJob = formatedJobData.isUrgentJob, isTopManagementJob = formatedJobData.isTopManagementJob, isHeadhuntJob = formatedJobData.isHeadhuntJob;
    var t = function (key) {
        var _a;
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return (_a = JobPostCard_translations_translations[key]) !== null && _a !== void 0 ? _a : key;
        }
    };
    var isLayoutPrimary = layout === 'primary';
    var isLayoutSecondary = layout === 'secondary';
    var handleUnsavedJob = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var success;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLogin) {
                        /* redirectToLogin() */
                        return [2 /*return*/];
                    }
                    setSaveLoading(true);
                    return [4 /*yield*/, unsaveJob({
                            jobId: data.jobId,
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    success = (_a.sent()).data;
                    setSaveLoading(false);
                    if (success) {
                        setSaved(false);
                        onSave && onSave(false);
                        (0,Toast/* showToast */.CF)(t('Success'), t('Just removed 1 saved job'));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveJob = function (isFromPreviewJob) {
        if (isFromPreviewJob === void 0) { isFromPreviewJob = false; }
        return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
            var success;
            var _a;
            return (0,_tslib/* __generator */.Jh)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isLogin) {
                            /* redirectToLogin() */
                            return [2 /*return*/];
                        }
                        setSaveLoading(true);
                        return [4 /*yield*/, saveJob({
                                jobId: data.jobId,
                                accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                                language: langCode,
                                baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                            })];
                    case 1:
                        success = (_b.sent()).data;
                        setSaveLoading(false);
                        if (success) {
                            tracking({
                                eventName: 'js_job_management:save_job_click',
                                properties: {
                                    jobId: (_a = data === null || data === void 0 ? void 0 : data.jobId) !== null && _a !== void 0 ? _a : -1,
                                    pageZone: isFromPreviewJob ? 'preview' : 'job_card_full'
                                }
                            });
                            setSaved(true);
                            onSave && onSave(true);
                            (0,Toast/* showToast */.CF)(t('Success'), react.createElement("div", null,
                                t('You have saved job, view'),
                                ' ',
                                react.createElement("a", { href: t('/my-career-center/my-jobs?section=saved') }, t('My jobs'))));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleLogin = function () {
        if (isLogin) {
            return;
        }
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode === constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en',
                isNeedReload: false
            }
        });
        window.dispatchEvent(loginEvent);
    };
    (0,react.useEffect)(function () {
        setSaved(data.isSaved || false);
    }, [data]);
    (0,react.useEffect)(function () {
        var _a;
        jobCardHeight.current = ((_a = jobCardRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
    }, []);
    (0,react.useEffect)(function () {
        var _a, _b, _c, _d;
        if ((trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.isTrackingOnSeen) && isElementOnScreen && !isAleadyTrackingViewJob.current) {
            var properties = {
                jobTitle: data.jobTitle,
                prettySalary: (data === null || data === void 0 ? void 0 : data.prettySalary) === 'Thương lượng' ? 'Negotiable' : (data === null || data === void 0 ? void 0 : data.prettySalary) || '',
                createdOn: (data === null || data === void 0 ? void 0 : data.createdOn) || '',
                workingLocationCityId: ((data === null || data === void 0 ? void 0 : data.workingLocations) || []).map(function (item) { return item.cityId; }),
                expiredDate: data.expiredOn,
                jobIndustryId: ((data === null || data === void 0 ? void 0 : data.industriesV3) || []).map(function (item) { return item.industryIdV3; }),
                jobFunctionId: (_a = data === null || data === void 0 ? void 0 : data.jobFunctionsV3) === null || _a === void 0 ? void 0 : _a.jobFunctionV3Id,
                jobGroupFunctionId: (_b = data === null || data === void 0 ? void 0 : data.groupJobFunctionsV3) === null || _b === void 0 ? void 0 : _b.groupJobFunctionV3Id,
                jobLevelId: Number(data === null || data === void 0 ? void 0 : data.jobLevelId),
                typeWorkingId: data === null || data === void 0 ? void 0 : data.typeWorkingId,
                skillTag: ((data === null || data === void 0 ? void 0 : data.skills) || []).map(function (item) { return item.skillName; }).join(', '),
                isCoverLetterRequired: (data === null || data === void 0 ? void 0 : data.requiredCoverLetter)
                    ? (data === null || data === void 0 ? void 0 : data.requiredCoverLetter) === REQUIRED_COVER_LETTER
                    : false,
                jobId: data.jobId,
                isAnonymous: data.isAnonymous,
                isPremium: isPremium,
                isHeadhunt: isHeadhuntJob,
                isUrgent: isUrgentJob,
                isUrgentM: data === null || data === void 0 ? void 0 : data.isUrgentJobM,
                isTopmanagement: isTopManagementJob,
                isAdr: data === null || data === void 0 ? void 0 : data.isAdrLiteJob,
                isBoldandred: data.isBoldAndRedJob,
                isBoldandredM: data === null || data === void 0 ? void 0 : data.isBoldAndRedJobM,
                isPriority: shouldMakeJobPriority,
                isPriorityM: shouldMakeJobPriority && (data === null || data === void 0 ? void 0 : data.isTopPriorityM),
                isNew: isNewJob,
                companyId: Number(data === null || data === void 0 ? void 0 : data.companyId)
            };
            if ((data === null || data === void 0 ? void 0 : data.jobInvitation) && ((_c = data === null || data === void 0 ? void 0 : data.jobInvitation) === null || _c === void 0 ? void 0 : _c.jobInvitationId) > 0) {
                properties.invitationId = (_d = data === null || data === void 0 ? void 0 : data.jobInvitation) === null || _d === void 0 ? void 0 : _d.jobInvitationId;
            }
            tracking({
                eventName: 'js_search_result_page:search_job_impression',
                properties: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.additionalField), properties)
            });
            isAleadyTrackingViewJob.current = true;
        }
    }, [isElementOnScreen, isNewJob]);
    var renderMatchTooltipBadge = function (isHaveSeparator) {
        return (data === null || data === void 0 ? void 0 : data.isMatching) ? (react.createElement(react.Fragment, null,
            isHaveSeparator ? react.createElement(Separator, null) : null,
            react.createElement(StyledTooltip, { className: 'matched-job', tooltipClassName: 'matched-job-tooltip', custom: { maxWidth: '220px' }, content: react.createElement(MatchingText, null, t('This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.')), referenceElement: react.createElement(BadgeTag/* default */.Z, { type: 'Matching', langCode: langCode }) }))) : null;
    };
    var renderBadges = function () {
        if (forceNormalJob) {
            return null;
        }
        // Premium job can't detect by service code
        var badges = [];
        if (robot === null || robot === void 0 ? void 0 : robot.enable) {
            isUrgentJob = serviceCode.indexOf(SERVICE_CODE_URGENT_JOB) > -1;
            isTopManagementJob = serviceCode.indexOf(SERVICE_CODE_TOP_MANAGEMENT_JOB) > -1;
            isHeadhuntJob =
                serviceCode.indexOf(SERVICE_CODE_HEADHUNT_JOB) > -1 ||
                    serviceCode.indexOf(SERVICE_CODE_HEADHUNT_JOB_MOBILE) > -1;
        }
        if (isUrgentJob || data.isUrgentJobM) {
            badges.push(badgeSettings.urgent);
        }
        if (isPremium) {
            badges.push(badgeSettings.premium);
        }
        if (isHeadhuntJob) {
            badges.push(badgeSettings.headHunter);
        }
        if (isTopManagementJob) {
            badges.push(badgeSettings.topManagement);
        }
        if (badges.length === 0) {
            return renderMatchTooltipBadge(false);
        }
        return (react.createElement(Badge.Container, null,
            badges.map(function (badge) {
                if (badge.utm) {
                    return react.createElement(BadgeTag/* default */.Z, { key: badge.name, type: badge.name, langCode: langCode, utm: badge.utm });
                }
                else {
                    return react.createElement(BadgeTag/* default */.Z, { key: badge.name, type: badge.name, langCode: langCode });
                }
            }),
            renderMatchTooltipBadge(true)));
    };
    var renderAppliedTextAndSaveIcon = function () {
        var isApplied = data.isApplied;
        return isApplied ? (react.createElement(AppliedText, null,
            react.createElement(DoubleTickIcon$1, null),
            " ",
            t('Applied')) // applied Text
        ) : (react.createElement(SaveJobWrapper, { onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (!isLogin) {
                    handleLogin();
                    return;
                }
                isSaved ? handleUnsavedJob() : handleSaveJob();
            }, isSaved: isSaved }, !isSaveLoading ? (isSaved ? (react.createElement(react.Fragment, null,
            react.createElement(HeartFillIcon/* default */.Z, { width: 20, color: Colors/* colors.primary.40 */.O9.primary[40] }),
            ' ',
            isLayoutPrimary ? t('Saved job') : null)) : (react.createElement(react.Fragment, null,
            react.createElement(MiscGroupIcons/* default.UnFavoriteIcon */.Z.UnFavoriteIcon, { width: 18, height: 18, color: Colors/* colors.grey.20 */.O9.grey[20] }),
            ' ',
            isLayoutPrimary ? t('Save job') : null))) : (react.createElement(SaveLoadingIcon/* default */.Z, { iconColor: Colors/* colors.grey.20 */.O9.grey[20] }))));
    };
    var renderAISummary = function () {
        var _a;
        if (!data.summary || !shouldMakeJobPriority || !enableAISummary)
            return null;
        var summary = (_a = data.summary) !== null && _a !== void 0 ? _a : [];
        return (react.createElement(AISummary.Container, null,
            react.createElement(AISummary.Label, null,
                react.createElement(TwinkleLinearGradientIcon$1, null),
                react.createElement("span", null, t('AI summary'))),
            react.createElement("ul", null, summary === null || summary === void 0 ? void 0 : summary.map(function (item, idx) { return (react.createElement("li", { key: idx }, item)); }))));
    };
    var linkJobLangCode = langCode === constants/* ELanguage.EN */.Df.EN ? 'en' : 'vi';
    if (isForceJobLinkVI) {
        linkJobLangCode = 'vi';
    }
    var jobUrl = (0,helpers/* generateJobUrl */.z6)(data.jobId || 0, data.alias || '', linkJobLangCode, '', utm);
    var previewJobUrl = jobUrl;
    if (data.jobInvitation && data.jobInvitation.jobInvitationId > 0) {
        var prefixQueryParams = jobUrl.indexOf('?') > 0 ? '&' : '?';
        jobUrl += "".concat(prefixQueryParams, "utm_source=job_search_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
        previewJobUrl += "".concat(prefixQueryParams, "utm_source=preview_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
    }
    var renderTitle = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var title = function () {
            return headingTagTitleJob === 'h3' ? (react.createElement("h3", null,
                react.createElement("a", { href: jobUrl, title: data.jobTitle, target: '_blank' },
                    isNewJob ? (react.createElement(NewBadgeWrapper, null,
                        react.createElement(BadgeTag/* default */.Z, { type: 'New', langCode: langCode }))) : null,
                    data.jobTitle))) : (react.createElement(CustomH2, { isPriority: shouldMakeJobPriority },
                react.createElement("a", { href: jobUrl, title: data.jobTitle, target: '_blank' },
                    isNewJob ? (react.createElement(NewBadgeWrapper, null,
                        react.createElement(BadgeTag/* default */.Z, { type: 'New', langCode: langCode }))) : null,
                    data.jobTitle)));
        };
        return previewJob.enable ? (react.createElement(react.Fragment, null,
            react.createElement(PreviewJob/* default */.Z, { content: {
                    jobId: (_a = data.jobId) !== null && _a !== void 0 ? _a : 0,
                    logo: (_b = data.companyLogo) !== null && _b !== void 0 ? _b : '',
                    title: (_c = data.jobTitle) !== null && _c !== void 0 ? _c : '',
                    salary: (_d = data.prettySalary) !== null && _d !== void 0 ? _d : '',
                    jobLevel: langCode === constants/* ELanguage.VI */.Df.VI ? data.jobLevelVI : data.jobLevel,
                    address: (_e = data.address) !== null && _e !== void 0 ? _e : '',
                    jobDescription: (_f = data.jobDescription) !== null && _f !== void 0 ? _f : '',
                    jobRequirements: (_g = data.jobRequirement) !== null && _g !== void 0 ? _g : '',
                    link: previewJobUrl,
                    isSaved: isSaved,
                    isApplied: !!data.isApplied,
                    isBlackList: !!data.isBlackList,
                    redirectTo: data.redirectTo || '',
                    jobInvitation: (_h = data.jobInvitation) !== null && _h !== void 0 ? _h : { jobInvitationId: 0, status: 0 }
                }, api: {
                    disableSelfApi: true
                }, onSaveClick: function () { return (isSaved ? handleUnsavedJob() : handleSaveJob(true)); }, onApplyClick: function () { return setShowApplyPopup(true); }, langCode: langCode, isLogin: isLogin }, title()),
            react.createElement(ApplyJobs/* default */.ZP, { accessToken: (_j = api === null || api === void 0 ? void 0 : api.accessToken) !== null && _j !== void 0 ? _j : '', isOpen: isShowApplyPopup, langCode: langCode, user: userInfo, jobInfo: data, baseMsUrl: (_k = api.baseUrl) !== null && _k !== void 0 ? _k : '', baseUrl: (_l = previewJob === null || previewJob === void 0 ? void 0 : previewJob.baseUrl) !== null && _l !== void 0 ? _l : '', initData: props.initData, onClose: function () { return setShowApplyPopup(false); } }))) : (title());
    };
    var renderCompanyName = function () {
        if (companyUrl && !data.isAnonymous) {
            var companyUrlWithUtm = "".concat(companyUrl);
            if (companyUTM !== '') {
                companyUrlWithUtm += "?".concat(companyUTM);
            }
            return (react.createElement(react.Fragment, null,
                react.createElement("a", { href: companyUrlWithUtm, title: data.companyName, target: '_blank' }, data.companyName)));
        }
        return (react.createElement("span", { className: 'company-name', title: !data.isAnonymous
                ? data.companyName
                : t('Information of this employer is hidden for confidentiality purposes.') }, !data.isAnonymous ? data.companyName : "Vietnamworks' Client"));
    };
    var renderPostedJobDay = function () {
        var today = new Date();
        var postedDate = data.onlineOn || '';
        var priorityOrder = new Date(data.priorityOrder || '').getTime();
        if (['lasted', 'oldest'].includes(sorting)) {
            postedDate = data.approvedOn || '';
        }
        else if (priorityOrder > 0) {
            postedDate = data.priorityOrder || '';
        }
        var target = new Date(postedDate);
        var diffTime = today.getTime() - target.getTime();
        var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        var diffHours = Math.floor(diffTime / (1000 * 60 * 60)) || 1;
        if (diffDays >= 1) {
            // If difference is 1 day or more, return the difference in days
            return "".concat(diffDays, " ").concat(t('day')).concat(diffDays > 1 ? t('s') : '', " ").concat(t('ago'));
        }
        else {
            // If difference is less than 1 day, return the difference in hours
            return "".concat(diffHours, " ").concat(t('hour')).concat(diffHours > 1 ? t('s') : '', " ").concat(t('ago'));
        }
    };
    // Init next/image component
    var NextImageWrapper = nextImage !== null ? nextImage() : null;
    return (react.createElement(react.Fragment, null,
        react.createElement("a", { href: jobUrl, target: '_blank' },
            react.createElement(JobPostCard_css_Container, { ref: jobCardRef, className: classSelector }, jobCardHeight.current > 0 && !isElementOnScreen && enableVisualized ? (react.createElement("div", { style: { width: '100%', height: jobCardHeight.current } })) : (react.createElement(JobPostCard_css_Wrapper, { isPriorityJob: shouldMakeJobPriority && !forceNormalJob, layout: layout },
                shouldMakeJobPriority && !forceNormalJob && react.createElement(RibbonTag, null, "TOP"),
                react.createElement(TopContainer, null,
                    react.createElement(Left.Container, null,
                        react.createElement("a", { className: 'img_job_card', href: jobUrl, title: data.jobTitle, target: '_blank' }, nextImage !== null && NextImageWrapper !== null ? (react.createElement(NextImageContainer, null,
                            react.createElement("div", null,
                                react.createElement(NextImageWrapper, { src: showLogo ? data.companyLogo : DEFAULT_IMAGE, alt: data.jobTitle, layout: 'fill' })))) : (react.createElement(Left.Avatar, { src: showLogo ? data.companyLogo : DEFAULT_IMAGE, loading: 'lazy', alt: data.jobTitle }))),
                        isLayoutSecondary ? (react.createElement("div", null,
                            react.createElement(Right.Title, { isBoldAndRed: isBoldAndRed && forceNormalJob === false, isViewed: !!(isJobSearchPage && data.isViewed) }, renderTitle()),
                            react.createElement(CompanyName, null, renderCompanyName()))) : null),
                    react.createElement(Right.Container, null,
                        isLayoutPrimary ? (react.createElement(react.Fragment, null,
                            react.createElement(Right.Title, { isBoldAndRed: isBoldAndRed && forceNormalJob === false, isViewed: !!(isJobSearchPage && data.isViewed) }, renderTitle()),
                            react.createElement(CompanyName, null, renderCompanyName()))) : null,
                        renderBadges(),
                        react.createElement(Salary, null,
                            react.createElement(SalaryIcon$1, null),
                            data.prettySalary),
                        react.createElement(Location, null,
                            react.createElement(WorkingLocationIcon$1, null),
                            location),
                        renderAISummary())),
                react.createElement(BottomContainer, null,
                    react.createElement(Row/* default */.Z, { gutter: [0, 8], align: 'middle' },
                        react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(Badge.UpdatedTime, null, renderPostedJobDay())),
                        data.isViewed && (react.createElement(Col/* default */.Z, { xs: 'auto' },
                            react.createElement(Badge.Viewed, null, t('Viewed')))),
                        react.createElement(Col/* default */.Z, { xs: 'fill' }, data.jobInvitation &&
                            ((_a = data.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 &&
                            data.jobInvitation.status === 0 ? (react.createElement(JobInvitationBlock, { title: t('Employer highly values your resume and has sent you an invitation to apply.') },
                            react.createElement(MailAddIcon/* default */.Z, null),
                            react.createElement("p", null, t('Employer highly values your resume and has sent you an invitation to apply.')))) : null),
                        react.createElement(Col/* default */.Z, { xs: 'auto' }, renderAppliedTextAndSaveIcon())))))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/LazyloadCSR/index.js
'use client';









/**
 * @author ThienTD
 * @since Oct 19, 2024
 *
 * This component is used for lazyload element which is being
 * outside of viewport
 *
 * @param props ILazyloadCSRProps
 * @returns LazyloadCSR
 */
var LazyloadCSR = function (props) {
    var _a = (0,react.useState)(false), isRendered = _a[0], setIsRendered = _a[1];
    var divRef = (0,react.useRef)(null);
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: divRef
    })[0];
    (0,react.useEffect)(function () {
        if (!isElementOnScreen) {
            return;
        }
        // Once it rendered then it should be render
        // for the rest of time
        if (!isRendered) {
            setIsRendered(true);
        }
    }, [isRendered, isElementOnScreen]);
    return react.createElement("div", { ref: divRef }, isRendered ? props.children : null);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/Radio.css.js
var Radio_css = __webpack_require__(51979);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/ResumeItem/ResumeItem.css.js
'use client';











var ResumeItemWrapper = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z)(ResumeItem_css_templateObject_1 || (ResumeItem_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border: 1px solid ", ";\n    border-radius: 12px;\n    padding: 8px;\n    user-select: none;\n    cursor: ", ";\n    text-align: left;\n    transition: all 0.25s ease-in-out;\n    background: #fff;\n    // SingleRadio Wrapper\n    ", " {\n        width: 32px;\n        height: 32px;\n        justify-content: center;\n    }\n"], ["\n    border: 1px solid ", ";\n    border-radius: 12px;\n    padding: 8px;\n    user-select: none;\n    cursor: ", ";\n    text-align: left;\n    transition: all 0.25s ease-in-out;\n    background: #fff;\n    // SingleRadio Wrapper\n    ", " {\n        width: 32px;\n        height: 32px;\n        justify-content: center;\n    }\n"])), function (_a) {
    var isSelected = _a.isSelected;
    return (isSelected ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.neutral.90 */.O9.neutral[90]);
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return (isDisabled ? 'not-allowed' : 'pointer');
}, Radio_css/* Container */.W2);
var CvSection = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z)(ResumeItem_css_templateObject_2 || (ResumeItem_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 8px;\n    p:first-child {\n        margin-bottom: 4px;\n    }\n    p:nth-child(2) {\n        svg {\n            vertical-align: middle;\n        }\n    }\n"], ["\n    margin: 0 8px;\n    p:first-child {\n        margin-bottom: 4px;\n    }\n    p:nth-child(2) {\n        svg {\n            vertical-align: middle;\n        }\n    }\n"])));
var FileName = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(ResumeItem_css_templateObject_3 || (ResumeItem_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n"])));
var JustUploadTag = styled_components_browser_esm/* default.span */.ZP.span(ResumeItem_css_templateObject_4 || (ResumeItem_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 24px;\n    padding: 0px 8px;\n    background: ", ";\n    border-radius: 14px;\n    color: ", ";\n    font-size: 12px;\n    &.profile-status {\n        background: ", ";\n        color: ", ";\n        margin-left: 6px;\n    }\n"], ["\n    line-height: 24px;\n    padding: 0px 8px;\n    background: ", ";\n    border-radius: 14px;\n    color: ", ";\n    font-size: 12px;\n    &.profile-status {\n        background: ", ";\n        color: ", ";\n        margin-left: 6px;\n    }\n"])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.green.50 */.O9.green[50], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.grey.20 */.O9.grey[20]);
var NotApprovedTag = styled_components_browser_esm/* default.span */.ZP.span(ResumeItem_css_templateObject_5 || (ResumeItem_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    line-height: 24px;\n    padding: 2px 4px;\n    background: ", ";\n    border-radius: 4px;\n    color: ", ";\n    font-size: 12px;\n"], ["\n    line-height: 24px;\n    padding: 2px 4px;\n    background: ", ";\n    border-radius: 4px;\n    color: ", ";\n    font-size: 12px;\n"])), Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.40 */.O9.neutral[40]);
var ResumeItem_css_LabelWrapper = styled_components_browser_esm/* default.label */.ZP.label(ResumeItem_css_templateObject_6 || (ResumeItem_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: block;\n"], ["\n    display: block;\n"])));
var Dot = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(ResumeItem_css_templateObject_7 || (ResumeItem_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: none;\n    @media screen and (min-width: ", "px) {\n        display: block;\n    }\n"], ["\n    display: none;\n    @media screen and (min-width: ", "px) {\n        display: block;\n    }\n"])), LayoutSystem_constants/* BREAKPOINTS.sm */.j$.sm);
var LabelWithIcon = styled_components_browser_esm/* default.span */.ZP.span(ResumeItem_css_templateObject_8 || (ResumeItem_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 2px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 2px;\n"])));
var ResumeItem_css_Link = (0,styled_components_browser_esm/* default */.ZP)(Variant/* Anchor */.ee)(ResumeItem_css_templateObject_9 || (ResumeItem_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", " !important;\n    margin-bottom: 4px;\n    &:hover {\n        color: ", " !important;\n    }\n"], ["\n    color: ", " !important;\n    margin-bottom: 4px;\n    &:hover {\n        color: ", " !important;\n    }\n"])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.secondary.40 */.O9.secondary[40]);
var ResumeItem_css_ErrorMessage = styled_components_browser_esm/* default.div */.ZP.div(ResumeItem_css_templateObject_10 || (ResumeItem_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: ", ";\n    border-radius: 8px;\n    padding: 8px;\n    margin-bottom: 16px;\n    p {\n        display: flex;\n        align-items: center;\n        svg {\n            margin-right: 8px;\n            flex: 0 0 22px;\n        }\n    }\n"], ["\n    background: ", ";\n    border-radius: 8px;\n    padding: 8px;\n    margin-bottom: 16px;\n    p {\n        display: flex;\n        align-items: center;\n        svg {\n            margin-right: 8px;\n            flex: 0 0 22px;\n        }\n    }\n"])), Colors/* colors.yellow.95 */.O9.yellow[95]);
var DeleteContent = styled_components_browser_esm/* default.div */.ZP.div(ResumeItem_css_templateObject_11 || (ResumeItem_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px;\n    text-align: center;\n    p {\n        margin-bottom: 16px;\n        word-break: break-word;\n        &:last-child {\n            margin: 0;\n        }\n    }\n"], ["\n    padding: 8px;\n    text-align: center;\n    p {\n        margin-bottom: 16px;\n        word-break: break-word;\n        &:last-child {\n            margin: 0;\n        }\n    }\n"])));
var TagSearchable = styled_components_browser_esm/* default.span */.ZP.span(ResumeItem_css_templateObject_12 || (ResumeItem_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    /* min-width: 100px; */\n    background-color: ", ";\n    color: ", ";\n    border-radius: 14px;\n    display: inline-flex !important;\n    height: 22px;\n    padding: 2px 8px;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14px;\n    justify-content: center;\n"], ["\n    /* min-width: 100px; */\n    background-color: ", ";\n    color: ", ";\n    border-radius: 14px;\n    display: inline-flex !important;\n    height: 22px;\n    padding: 2px 8px;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14px;\n    justify-content: center;\n"])), Colors/* colors.green.90 */.O9.green[90], Colors/* colors.green.50 */.O9.green[50]);
var ResumeItem_css_templateObject_1, ResumeItem_css_templateObject_2, ResumeItem_css_templateObject_3, ResumeItem_css_templateObject_4, ResumeItem_css_templateObject_5, ResumeItem_css_templateObject_6, ResumeItem_css_templateObject_7, ResumeItem_css_templateObject_8, ResumeItem_css_templateObject_9, ResumeItem_css_templateObject_10, ResumeItem_css_templateObject_11, ResumeItem_css_templateObject_12;


//# sourceMappingURL=ResumeItem.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/AIReviewCV.css.js
'use client';






var AIReviewCVWrapper = styled_components_browser_esm/* default.div */.ZP.div({
    padding: 16
});
var CVSelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(AIReviewCV_css_templateObject_1 || (AIReviewCV_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    @media screen and (max-width: 768px) {\n        padding-bottom: 106px;\n    }\n"], ["\n    @media screen and (max-width: 768px) {\n        padding-bottom: 106px;\n    }\n"])));
var AIReviewCVContainer = styled_components_browser_esm/* default.div */.ZP.div({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 24
});
var ResumeList = styled_components_browser_esm/* default.div */.ZP.div(AIReviewCV_css_templateObject_2 || (AIReviewCV_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 8px 0;\n    ", " {\n        margin-bottom: 8px;\n    }\n"], ["\n    margin: 8px 0;\n    ", " {\n        margin-bottom: 8px;\n    }\n"])), ResumeItemWrapper);
({
    color: Colors/* colors.error.40 */.O9.error[40],
    marginTop: 8
});
var LeftSection = styled_components_browser_esm/* default.div */.ZP.div({
    width: 440,
    padding: '12px 16px',
    background: Colors/* colors.neutral.99 */.O9.neutral[99],
    borderRadius: 12
});
var RightSection = styled_components_browser_esm/* default.div */.ZP.div({
    padding: '12px 0'
});
var CTAWrapper = styled_components_browser_esm/* default.div */.ZP.div({
    padding: 24,
    borderTop: "1px solid ".concat(Colors/* colors.grey.95 */.O9.grey[95]),
    textAlign: 'right'
});
var AIReviewCV_css_templateObject_1, AIReviewCV_css_templateObject_2;


//# sourceMappingURL=AIReviewCV.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/translations.js
'use client';

var AIReviewCV_translations_translations = {
    'Select your CV to analyse': 'Lựa chọn hồ sơ để đánh giá',
    'Checkout to see result': 'Thanh toán để xem kết quả',
    'View result': 'Xem kết quả',
    'Select an available profile on VietnamWorks.': 'Chọn hồ sơ có sẵn trên VietnamWorks',
    '/cv-review': '/phan-tich-ho-so',
    'Sorry, we cannot process your CV. Please select another CV.': 'Rất tiếc, chúng tôi không thể xử lý CV của bạn. Vui lòng chọn CV khác.',
    'Please upload your CV to see the evaluation.': 'Vui lòng tải hồ sơ của bạn để xem đánh giá.',
    'Uploaded attachment will be added to your VietnamWorks account': 'Hồ sơ tải lên sẽ được thêm vào tài khoản VietnamWorks của bạn',
    "Scanning file's content": 'Đang quét nội dung hồ sơ',
    'Evaluated for the position of': 'Đánh giá cho vị trí',
    Price: 'Giá',
    'You have {0} free trial': 'Bạn có {0} lần dùng thử miễn phí',
    time: 'lượt',
    'Maximize your competitive advantage with VietnamWorks AI': 'Tối ưu lợi thế cạnh tranh cùng VietnamWorks AI',
    "Assess matching rate from employer's viewpoint": 'Đánh giá độ phù hợp với góc nhìn của nhà tuyển dụng',
    'Suggest to improve the matching': 'Gợi ý cách cải thiện mức độ phù hợp',
    'Analyze the profiles of applicants': 'Phân tích hồ sơ của các ứng viên đã nộp đơn',
    'Check salary reference and hiring demand': 'Tham khảo mức lương và nhu cầu tuyển dụng'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/constants.js
var ApplyJobs_constants = __webpack_require__(46641);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/translations.js
var ApplyJobs_translations = __webpack_require__(54028);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/ai-review/index.js
'use client';



var validateAiResume = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var msBaseUrl, accessToken, langCode, resumeId, apiUrl, res;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                msBaseUrl = params.msBaseUrl, accessToken = params.accessToken, langCode = params.langCode, resumeId = params.resumeId;
                apiUrl = "".concat(msBaseUrl, "/api-gateway/v1.0/ai-resume-file-extract");
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify({
                            resumeId: resumeId
                        })
                    })];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/, null];
            case 4:
                _a.sent();
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
var deleteAttachedResume = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var accessToken, msBaseUrl, langCode, resumeId, API_DOWNLOAD_CV, requestOptions, response, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, langCode = params.langCode, resumeId = params.resumeId;
                API_DOWNLOAD_CV = "".concat(msBaseUrl, "/api-gateway/v1.0/profile/resume-attached?resumeId=").concat(resumeId);
                requestOptions = {
                    method: 'DELETE',
                    headers: {
                        Authorization: "Bearer ".concat(accessToken),
                        'Accept-Language': langCode
                    }
                };
                return [4 /*yield*/, fetch(API_DOWNLOAD_CV, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/ResumeItem/ResumeItem.js
'use client';








































































































































































var ResumeItem = function (props) {
    var _a, _b, _c;
    var radioId = props.radioId, resumeId = props.resumeId, cvInfo = props.cvInfo, isAttach = props.isAttach, profileStrength = props.profileStrength, baseUrl = props.baseUrl, msBaseUrl = props.msBaseUrl, accessToken = props.accessToken, langCode = props.langCode, isAIParseError = props.isAIParseError, isDeletable = props.isDeletable, onChange = props.onChange, setIsLoadingResumes = props.setIsLoadingResumes, handleGetResume = props.handleGetResume, applyResumeId = props.applyResumeId;
    var _d = (0,react.useState)(false), isShowDelete = _d[0], setShowDelete = _d[1];
    var _e = (0,react.useState)(false), isLockView = _e[0], setLockView = _e[1];
    var t = (0,react.useCallback)(function (text) {
        var _a;
        if (props.langCode === constants/* ELanguage.VI */.Df.VI) {
            return (_a = ApplyJobs_translations/* default */.Z[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [props.langCode]);
    var isSelected = (cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) === resumeId;
    var isDisabled = !isAttach && (cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.allowSearchableDisplay) !== ApplyJobs_constants/* ALLOW_SEARCHABLE */.b2;
    var onChangeRadio = function () {
        var _a;
        if (isDisabled) {
            return;
        }
        var isAttach = cvInfo.isAttach === ApplyJobs_constants/* EResumeType.ATTACH */.lY.ATTACH;
        var applyType = isAttach ? resumes_types/* EApplyType.lastAttachment */.bf.lastAttachment : resumes_types/* EApplyType.online */.bf.online;
        onChange({
            resumeId: (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) !== null && _a !== void 0 ? _a : -1,
            type: applyType
        });
    };
    var onClickViewResume = function () {
        var _a;
        if ((0,helpers/* isMobile */.tq)()) {
            window.open("".concat(baseUrl, "/").concat(t('preview-resume'), "/").concat(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id), '_blank');
            return;
        }
        if (!isAttach) {
            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
            return;
        }
        if (!(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) || isLockView) {
            return;
        }
        var body = props.isJustUploaded ? { type: 2 } : null;
        (0,helpers/* downloadAttachFile */.jE)({
            resumeId: cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id,
            downloadRequest: 'new-window',
            msBaseUrl: msBaseUrl !== null && msBaseUrl !== void 0 ? msBaseUrl : '',
            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
            fileName: (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _a !== void 0 ? _a : '',
            body: body,
            onOpenOrDownload: function () { return setLockView(false); }
        });
    };
    var onClickDeleteConfirm = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var deleteResponse;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id)) {
                        return [2 /*return*/];
                    }
                    setIsLoadingResumes(true);
                    return [4 /*yield*/, deleteAttachedResume({
                            resumeId: cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id,
                            langCode: langCode,
                            msBaseUrl: msBaseUrl,
                            accessToken: accessToken
                        })];
                case 1:
                    deleteResponse = _b.sent();
                    if (((_a = deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.meta) === null || _a === void 0 ? void 0 : _a.code) === resumes_const/* DEFAULT_SUCCESS_CODE */.se) {
                        (0,Toast/* showToast */.CF)(t('Success'), t('Delete CV successfully'));
                    }
                    setShowDelete(false);
                    // Trigger reload resume
                    handleGetResume();
                    return [2 /*return*/];
            }
        });
    }); };
    var viewMoreOptions = (0,react.useMemo)(function () {
        var returnOptions = [
            {
                label: t('View'),
                icon: react.createElement(EyesOpenIcon/* default */.Z, null),
                isCloseOnClick: false,
                onClick: onClickViewResume
            }
        ];
        if (isAttach && isDeletable) {
            returnOptions.push({
                label: t('Delete'),
                icon: react.createElement(Trash$1, null),
                isCloseOnClick: true,
                onClick: function () { return setShowDelete(true); }
            });
        }
        return returnOptions;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAttach, isDeletable]);
    var labelColor = isSelected ? Colors/* colors.primary.40 */.O9.primary[40] : Colors/* colors.grey.20 */.O9.grey[20];
    if (!isAttach && isDisabled) {
        labelColor = Colors/* colors.grey.50 */.O9.grey[50];
    }
    return (react.createElement(react.Fragment, null,
        react.createElement(Popup/* default */.Z, { lang: langCode, isShow: isShowDelete, onClose: function () { return setShowDelete(false); }, onClickOutside: function () { return setShowDelete(false); }, onClickPrimary: onClickDeleteConfirm, text: {
                primaryBtn: t('Delete'),
                secondaryBtn: t('Cancel'),
                header: t('Delete the attached CV')
            }, styleOption: {
                size: 'xs',
                isFooterButtonFullWidth: true,
                primaryBtnOutline: 'outline',
                primaryBtnStyle: 'danger'
            }, option: {
                isCenterFooter: false
            } },
            react.createElement(DeleteContent, null,
                react.createElement("p", null, t('The attached CV “{0}” will be deleted from our system.').replace('{0}', (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _a !== void 0 ? _a : '')),
                react.createElement("p", null, t('Are you sure to delete it?')))),
        react.createElement(ResumeItem_css_LabelWrapper, { htmlFor: "".concat(radioId, "-apply-type-radio-button") },
            react.createElement(ResumeItemWrapper, { isSelected: isSelected, isDisabled: !isAttach && isDisabled, align: 'middle' },
                react.createElement(Col/* default */.Z, { xs: 'auto' },
                    react.createElement(SingleRadio/* default */.Z, { id: radioId, name: 'apply-type', disabled: isDisabled, checked: isSelected, onChange: onChangeRadio, noBg: true })),
                react.createElement(CvSection, { xs: 'fill' },
                    react.createElement(FileName, { name: 'label', size: 'medium', color: labelColor },
                        isAttach
                            ? (0,helper/* fileName */.Yp)((_b = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _b !== void 0 ? _b : '', (0,helpers/* isMobile */.tq)() ? 15 : 25)
                            : t('VietnamWorks profile'),
                        ' ',
                        props.isJustUploaded && react.createElement(JustUploadTag, null, t('Just uploaded')),
                        !isAttach && isDisabled && react.createElement(NotApprovedTag, null, t('Not approved')),
                        cvInfo.id === applyResumeId ? (react.createElement(TagSearchable, null, t('Job applied'))) : (cvInfo.isSearchable === 1 && react.createElement(TagSearchable, null, t('Searchable')))),
                    react.createElement(Row/* default */.Z, { align: 'middle', gutter: { xs: 0, sm: 6 } },
                        react.createElement(Col/* default */.Z, { xs: 24, sm: 'auto' },
                            react.createElement(Typography/* default */.Z, { name: 'body', size: 'small', color: Colors/* colors.grey.50 */.O9.grey[50], style: { display: 'flex', alignItems: 'center' } }, isAttach ? (react.createElement(LabelWithIcon, null,
                                react.createElement(Images_AttachIcon/* default */.Z, { width: 14, height: 14, color: Colors/* colors.grey.50 */.O9.grey[50] }),
                                ' ',
                                t('Attached resume'),
                                ' ')) : (t('Profile online')))),
                        react.createElement(Dot, { variant: 'span', name: 'body', size: 'small', color: Colors/* colors.grey.50 */.O9.grey[50] }, "\u2022"),
                        react.createElement(Col/* default */.Z, { xs: 24, sm: 'auto' },
                            react.createElement(Typography/* default */.Z, { name: 'body', size: 'small', color: Colors/* colors.grey.50 */.O9.grey[50] },
                                isAttach ? (react.createElement(react.Fragment, null,
                                    t('Uploaded:'),
                                    " ",
                                    (0,helper/* dateToString */.UW)((_c = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.lastProcessedOn) !== null && _c !== void 0 ? _c : ''))) : (react.createElement(react.Fragment, null,
                                    t('Completed:'),
                                    " ",
                                    profileStrength,
                                    "%")),
                                ' ')),
                        !isAttach && isDisabled ? (react.createElement(react.Fragment, null,
                            react.createElement(Dot, { variant: 'span', name: 'body', size: 'small', color: Colors/* colors.grey.50 */.O9.grey[50] }, "\u2022"),
                            react.createElement(Col/* default */.Z, { xs: 24, sm: 'auto' },
                                react.createElement(Typography/* default */.Z, { name: 'body', size: 'small' },
                                    react.createElement(ResumeItem_css_Link, { name: 'body', size: 'small', href: t('/my-profile'), color: Colors/* colors.primary.40 */.O9.primary[40] }, t('Update profile')))))) : null)),
                react.createElement(Col/* default */.Z, { xs: 'auto' },
                    react.createElement(ButtonViewMore/* default */.Z, { options: viewMoreOptions, textOptions: {
                            closeText: t('Close')
                        }, styleOptions: {
                            customPadding: '8px'
                        } }))),
            isAIParseError ? (react.createElement(ResumeItem_css_ErrorMessage, null,
                react.createElement(Typography/* default */.Z, { name: 'paragraph', size: 'small', color: '#333' },
                    react.createElement(Warning/* default */.Z, { width: 16, height: 16, fill: Colors/* colors.yellow.40 */.O9.yellow[40] }),
                    t('We cannot process this file. Please ensure that the selected file contains the content of a CV and does not include too many images.')))) : null)));
};


//# sourceMappingURL=ResumeItem.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/services/your-resume.js
var your_resume = __webpack_require__(76681);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobs/components/Forms/YourResume/helpers/getDefaultResume.js
var getDefaultResume = __webpack_require__(80832);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/ResumeItem/ResumeItem.skeleton.js
'use client';







var ResumeItemSkeleton = function () {
    return (react.createElement(ResumeItem_css_LabelWrapper, null,
        react.createElement(ResumeItemWrapper, { align: 'middle' },
            react.createElement(Col/* default */.Z, { xs: 'auto' },
                react.createElement(Skeleton/* default */.Z, { height: 32, width: 32 })),
            react.createElement(CvSection, { isSkeleton: true, xs: 'fill' },
                react.createElement("div", { style: { marginBottom: 8 } },
                    react.createElement(Skeleton/* default */.Z, { height: 17 })),
                react.createElement(Skeleton/* default */.Z, { height: 15, width: 150 })))));
};


//# sourceMappingURL=ResumeItem.skeleton.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/services.js
'use client';



var AI_BUY_COMPETITIVE_ANALYSIS = '/api-gateway/v1.0/buy-package/competitive-analysis-report';
var buyCompetitiveAnalysis = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var jobId, resumeId, productId, quantity, accessToken, msBaseUrl, langCode, api, res, e_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                jobId = params.jobId, resumeId = params.resumeId, productId = params.productId, quantity = params.quantity, accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, langCode = params.langCode;
                api = "".concat(msBaseUrl).concat(AI_BUY_COMPETITIVE_ANALYSIS);
                return [4 /*yield*/, fetch(api, {
                        method: 'POST',
                        headers: {
                            'Accept-Language': langCode,
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify({
                            jobId: jobId,
                            resumeId: resumeId,
                            product: [
                                {
                                    productId: productId,
                                    quantity: quantity
                                }
                            ]
                        })
                    })];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/, null];
            case 4:
                e_1 = _a.sent();
                console.error('error', e_1);
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/PricingInfo/styles.js
'use client';




var PricingInfoWrapper = styled_components_browser_esm/* default.div */.ZP.div({
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '18px'
});
var PricingInfoContainer = styled_components_browser_esm/* default.div */.ZP.div({
    padding: '12px 0',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 12
});
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div({
    width: 62,
    height: 62,
    padding: 6,
    border: "1px solid ".concat(Colors/* colors.neutral.90 */.O9.neutral[90]),
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
});
var PricingInfoSection = styled_components_browser_esm/* default.div */.ZP.div({
    display: 'grid',
    rowGap: 4
});
var LimitTextLine = styled_components_browser_esm/* default.span */.ZP.span(function (_a) {
    var _b = _a.limitLine, limitLine = _b === void 0 ? 1 : _b;
    return ({
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        marginBottom: 0,
        wordBreak: 'break-word',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: limitLine
    });
});
var CompanyText = styled_components_browser_esm/* default.p */.ZP.p({
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 400
});
var SalaryText = styled_components_browser_esm/* default.span */.ZP.span({
    color: Colors/* colors.secondary.40 */.O9.secondary[40]
});
var Text = styled_components_browser_esm/* default.p */.ZP.p({
    margin: 0
});
var styles_List = styled_components_browser_esm/* default.ul */.ZP.ul({
    display: 'grid',
    rowGap: 16,
    margin: 0,
    padding: 0,
    '& > li': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        columnGap: 11,
        '& > svg': {
            marginTop: 2
        }
    }
});
var PricingSection = styled_components_browser_esm/* default.div */.ZP.div({});
var PricingText = styled_components_browser_esm/* default.div */.ZP.div({
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
    '& p': {
        margin: '0 12px 0 0',
        '& > .highlight': {
            fontSize: 14,
            lineHeight: '18px'
        }
    }
});
var FreeTrialText = styled_components_browser_esm/* default.div */.ZP.div({
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    marginTop: -2,
    '& > svg': {
        marginTop: 1
    },
    '& > .highlight': {
        margin: '0 4px 0 0',
        background: 'linear-gradient(90deg, #FE8323 0%, #FF3C68 50%, #DC1EAF 75%, #B300D7 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    }
});


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/PricingInfo/index.js
'use client';



























































































































































var PricingInfo_DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
function PricingInfo(_a) {
    var _b;
    var job = _a.job, t = _a.t, numsOfTrial = _a.numsOfTrial;
    var _c = job !== null && job !== void 0 ? job : {}, _d = _c.companyLogo, companyLogo = _d === void 0 ? '' : _d, _e = _c.jobTitle, jobTitle = _e === void 0 ? '' : _e, _f = _c.jobUrl, jobUrl = _f === void 0 ? '' : _f, _g = _c.companyName, companyName = _g === void 0 ? '' : _g, _h = _c.prettySalary, prettySalary = _h === void 0 ? '' : _h;
    // variables
    var isTrial = numsOfTrial > 0;
    return (react.createElement(PricingInfoWrapper, null,
        react.createElement(Row/* default */.Z, { gutter: [16, 0] },
            react.createElement(Col/* default */.Z, null,
                react.createElement(Text, null, t('Evaluated for the position of'))),
            react.createElement(Col/* default */.Z, null,
                react.createElement(PricingInfoContainer, null,
                    react.createElement(ImageWrapper, null,
                        react.createElement("img", { src: companyLogo || PricingInfo_DEFAULT_COMPANY_LOGO, alt: (_b = job === null || job === void 0 ? void 0 : job.jobTitle) !== null && _b !== void 0 ? _b : '' })),
                    react.createElement(PricingInfoSection, null,
                        react.createElement("a", { href: jobUrl, target: '_blank', rel: 'noreferrer' },
                            react.createElement(LimitTextLine, { limitLine: 2, className: 'section-title' }, jobTitle)),
                        react.createElement(CompanyText, null, companyName),
                        react.createElement(LimitTextLine, null,
                            react.createElement(SalaryText, null, prettySalary))))),
            react.createElement(Col/* default */.Z, null,
                react.createElement(Text, null, t('Maximize your competitive advantage with VietnamWorks AI'))),
            react.createElement(Col/* default */.Z, null,
                react.createElement(styles_List, null,
                    react.createElement("li", null,
                        react.createElement(AIStarListIcon, null),
                        t("Assess matching rate from employer's viewpoint")),
                    react.createElement("li", null,
                        react.createElement(AIStarListIcon, null),
                        t('Suggest to improve the matching')),
                    react.createElement("li", null,
                        react.createElement(AIStarListIcon, null),
                        t('Analyze the profiles of applicants')),
                    react.createElement("li", null,
                        react.createElement(AIStarListIcon, null),
                        t('Check salary reference and hiring demand')))),
            react.createElement(Col/* default */.Z, null,
                react.createElement(PricingSection, null,
                    react.createElement(PricingText, null,
                        react.createElement("p", null,
                            t('Price'),
                            ' ',
                            react.createElement("strong", { className: 'highlight', style: { textDecorationLine: isTrial ? 'line-through' : undefined } },
                                "29.000",
                                react.createElement("u", null, "\u0111"),
                                " / ",
                                t('time'))),
                        isTrial ? (react.createElement(FreeTrialText, null,
                            react.createElement("span", { className: 'highlight' },
                                "0",
                                react.createElement("u", null, "\u0111")),
                            ' ',
                            react.createElement(AISalaryIcon, null))) : null),
                    isTrial ? (react.createElement(PricingText, null, t('You have {0} free trial').replace('{0}', numsOfTrial.toString()))) : null)))));
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonAI/ButtonAI.css.js
'use client';




var ButtonAI_css_Text = styled_components_browser_esm/* default.span */.ZP.span(ButtonAI_css_templateObject_1 || (ButtonAI_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n"])));
var ButtonAIWrapper = styled_components_browser_esm/* default.button */.ZP.button(ButtonAI_css_templateObject_2 || (ButtonAI_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 8px;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%);\n    border: none;\n    height: 40px;\n    cursor: pointer;\n    ", " {\n        color: #fff;\n    }\n    &:hover,\n    &:focus,\n    &:active {\n        background: linear-gradient(90deg, rgba(224, 54, 155, 0.8) 0%, rgba(192, 6, 233, 0.8) 100%);\n    }\n"], ["\n    border-radius: 8px;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%);\n    border: none;\n    height: 40px;\n    cursor: pointer;\n    ", " {\n        color: #fff;\n    }\n    &:hover,\n    &:focus,\n    &:active {\n        background: linear-gradient(90deg, rgba(224, 54, 155, 0.8) 0%, rgba(192, 6, 233, 0.8) 100%);\n    }\n"])), ButtonAI_css_Text);
var ButtonAI_css_templateObject_1, ButtonAI_css_templateObject_2;


//# sourceMappingURL=ButtonAI.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/ButtonAI/index.js
'use client';




var ButtonAI = function (props) {
    var style = props.style;
    return (react.createElement(ButtonAIWrapper, { onClick: function () { return props.onClick && props.onClick(); }, style: style },
        react.createElement(ButtonAI_css_Text, null, props.children)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIReviewCV/index.js
'use client';









































































































































































var AIReviewCV = function (props) {
    var accessToken = props.accessToken, langCode = props.langCode, baseMsUrl = props.baseMsUrl, baseUrl = props.baseUrl, job = props.job, isTrial = props.isTrial, onClickPay = props.onClickPay, resumeOption = props.resumeOption, numsOfTrial = props.numsOfTrial, _a = props.isNewUI, isNewUI = _a === void 0 ? false : _a;
    var _b = props.showState, isShow = _b[0], setIsShow = _b[1];
    var _c = (0,react.useState)(false), isDisplayNone = _c[0], setIsDisplayNone = _c[1];
    var _d = (0,react.useState)(null), resumeInfos = _d[0], setResumeInfos = _d[1];
    var _e = (0,react.useState)(-1), selectResume = _e[0], setSelectResume = _e[1];
    var _f = (0,react.useState)(true), isLoadingResumes = _f[0], setIsLoadingResumes = _f[1];
    var _g = (0,react.useState)(0), profileStrength = _g[0], setProfileStrength = _g[1];
    var _h = (0,react.useState)(-1), replacingResumeId = _h[0], setReplacingId = _h[1];
    var _j = (0,react.useState)(true), isLockedPrimaryBtn = _j[0], setIsLockedPrimaryBtn = _j[1];
    var _k = (0,react.useState)(-1), resumeIdAIParseError = _k[0], setResumeIdAIParseError = _k[1];
    var _l = (0,react.useState)(-1), justUploadResumeId = _l[0], setJustUploadResumeId = _l[1];
    var dropFileComponentRef = (0,react.useRef)(null);
    var popupCVReplaceRef = (0,react.useRef)(null);
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = (0,react.useCallback)(function (text) {
        var _a;
        if (langCode === constants/* ELanguage.VI */.Df.VI) {
            return (_a = AIReviewCV_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [langCode]);
    var onPay = (0,react.useCallback)(function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var cvType, filteredCV, response;
        var _a, _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    cvType = 'online';
                    setIsLockedPrimaryBtn(true);
                    filteredCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.id === selectResume; });
                    if (filteredCV && (filteredCV === null || filteredCV === void 0 ? void 0 : filteredCV.length) > 0) {
                        cvType = filteredCV[0].isAttach === ApplyJobs_constants/* IS_RESUME_ATTACHMENT */.Xh ? 'attach_before' : 'online';
                    }
                    if (justUploadResumeId !== -1) {
                        cvType = 'attach_new';
                    }
                    // for mobile JD source
                    onClickPay && onClickPay(cvType, isTrial);
                    tracking({
                        eventName: 'js_cv_review:finish_select_cv',
                        properties: {
                            cvType: cvType,
                            freeTrial: isTrial
                        }
                    }, {
                        transport: 'sendBeacon'
                    });
                    return [4 /*yield*/, buyCompetitiveAnalysis({
                            jobId: (_a = job === null || job === void 0 ? void 0 : job.jobId) !== null && _a !== void 0 ? _a : 0,
                            productId: 1,
                            quantity: 1,
                            resumeId: selectResume,
                            accessToken: accessToken,
                            msBaseUrl: baseMsUrl,
                            langCode: langCode
                        })];
                case 1:
                    response = _e.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) === resumes_const/* DEFAULT_SUCCESS_CODE */.se &&
                        ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.redirectUrl) &&
                        ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.redirectUrl) !== '') {
                        window.location.assign((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.redirectUrl);
                    }
                    setIsLockedPrimaryBtn(false);
                    return [2 /*return*/];
            }
        });
    }); }, [selectResume, resumeInfos, justUploadResumeId, job === null || job === void 0 ? void 0 : job.jobId]);
    var validateResume = (0,react.useCallback)(function (resumeId) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var filteredCV, response;
        var _a, _b, _c;
        return (0,_tslib/* __generator */.Jh)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    filteredCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.id === resumeId; });
                    if (filteredCV && (filteredCV === null || filteredCV === void 0 ? void 0 : filteredCV.length) > 0 && filteredCV[0].isAttach === 0) {
                        // Don't need to validate online profile
                        setResumeIdAIParseError(-1);
                        setIsLockedPrimaryBtn(false);
                        return [2 /*return*/];
                    }
                    // Attach CV
                    setIsLockedPrimaryBtn(true);
                    return [4 /*yield*/, validateAiResume({
                            accessToken: accessToken,
                            msBaseUrl: baseMsUrl,
                            langCode: langCode,
                            resumeId: resumeId !== null && resumeId !== void 0 ? resumeId : -1
                        })];
                case 1:
                    response = _d.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.meta) === null || _a === void 0 ? void 0 : _a.status) === 400 ||
                        (((_b = response === null || response === void 0 ? void 0 : response.meta) === null || _b === void 0 ? void 0 : _b.code) && ((_c = response === null || response === void 0 ? void 0 : response.meta) === null || _c === void 0 ? void 0 : _c.code) !== resumes_const/* DEFAULT_SUCCESS_CODE */.se) ||
                        !response) {
                        // Show error
                        setResumeIdAIParseError(resumeId);
                        return [2 /*return*/];
                    }
                    setIsLockedPrimaryBtn(false);
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken, baseMsUrl, langCode, resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes]);
    var handleGetResume = (0,react.useCallback)(function (isDidMount) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var resumeInfo, resumeData, defaultResumeData;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoadingResumes(true);
                    return [4 /*yield*/, (0,your_resume/* getResume */.I)({
                            accessToken: accessToken,
                            baseMsUrl: baseMsUrl,
                            langCode: langCode
                        })];
                case 1:
                    resumeInfo = _c.sent();
                    if (!resumeInfo || resumeInfo.error) {
                        setIsLockedPrimaryBtn(true);
                        return [2 /*return*/];
                    }
                    resumeData = (0,getDefaultResume/* getDefaultResume */.R)(resumeInfo.data);
                    defaultResumeData = (resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.defaultResumeId)
                        ? resumeInfo.data.attributes.find(function (item) { return item.id === (resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.defaultResumeId); })
                        : null;
                    if (defaultResumeData) {
                        resumeData = defaultResumeData;
                    }
                    if (isDidMount && (resumeData === null || resumeData === void 0 ? void 0 : resumeData.isAttach) === 1) {
                        validateResume((_a = resumeData === null || resumeData === void 0 ? void 0 : resumeData.id) !== null && _a !== void 0 ? _a : -1);
                    }
                    setResumeInfos(resumeInfo.data);
                    // Set default select Resume
                    setSelectResume((_b = resumeData === null || resumeData === void 0 ? void 0 : resumeData.id) !== null && _b !== void 0 ? _b : -1);
                    setIsLoadingResumes(false);
                    // Unlock primary btn when resume is online profile
                    if ((resumeData === null || resumeData === void 0 ? void 0 : resumeData.isAttach) === 0) {
                        setIsLockedPrimaryBtn(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accessToken, selectResume]);
    var handleGetProfileLevel = (0,react.useCallback)(function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var profileLevel;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0,your_resume/* getProfileLevel */.M)({
                        accessToken: accessToken,
                        langCode: langCode,
                        baseMsUrl: baseMsUrl
                    })];
                case 1:
                    profileLevel = _c.sent();
                    if ((_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.profileStrength) {
                        setProfileStrength((_b = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken]);
    var onUploadDone = (0,react.useCallback)(function (response) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return (0,_tslib/* __generator */.Jh)(this, function (_h) {
            switch (_h.label) {
                case 0:
                    (_a = dropFileComponentRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== ApplyJobs_constants/* HTTP_CODE_SUCCESS */.CI) {
                        return [2 /*return*/];
                    }
                    if (!((response === null || response === void 0 ? void 0 : response.code) === ApplyJobs_constants/* HTTP_CODE_SUCCESS */.CI)) return [3 /*break*/, 2];
                    setResumeIdAIParseError(-1);
                    return [4 /*yield*/, handleGetResume()];
                case 1:
                    _h.sent();
                    setIsLockedPrimaryBtn(false);
                    setSelectResume((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : -1);
                    setJustUploadResumeId((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : -1);
                    // DO validate again
                    validateResume((_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : -1);
                    setReplacingId(-1);
                    _h.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleGetResume]);
    var onUploadError = (0,react.useCallback)(function (response) {
        if (!(response === null || response === void 0 ? void 0 : response.error)) {
            return;
        }
        setReplacingId(-1);
    }, []);
    var handleFileUpload = (0,react.useCallback)(function (file) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var attachedCVs, isMaxCV, data;
        var _a, _b, _c, _d;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    attachedCVs = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (cv) { return cv.isAttach; });
                    isMaxCV = attachedCVs && (attachedCVs === null || attachedCVs === void 0 ? void 0 : attachedCVs.length) >= ApplyJobs_constants/* MAX_NUMBER_OF_CV */.h9;
                    setIsLockedPrimaryBtn(true);
                    if (!(isMaxCV && popupCVReplaceRef.current)) return [3 /*break*/, 2];
                    // Open replace popup
                    setIsDisplayNone(true);
                    return [4 /*yield*/, popupCVReplaceRef.current.open()];
                case 1:
                    data = (_e.sent()).data;
                    setIsDisplayNone(false);
                    if (!data.resumeId) {
                        // Allow popup to trigger again if user drop the same file after cancel replacement request
                        (_a = dropFileComponentRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                        return [2 /*return*/];
                    }
                    setReplacingId((_b = data === null || data === void 0 ? void 0 : data.resumeId) !== null && _b !== void 0 ? _b : -1);
                    // Set state loading resume
                    (_c = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _c === void 0 ? void 0 : _c.doUploadFile(file, data === null || data === void 0 ? void 0 : data.resumeId);
                    return [3 /*break*/, 3];
                case 2:
                    setIsLoadingResumes(true);
                    // Set state loading resume
                    (_d = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _d === void 0 ? void 0 : _d.doUploadFile(file);
                    _e.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes]);
    var onSelectResume = function (values) {
        setSelectResume(values.resumeId);
        validateResume(values.resumeId);
        setResumeIdAIParseError(-1);
    };
    (0,react.useEffect)(function () {
        if (!isShow) {
            return;
        }
        handleGetResume(true);
        handleGetProfileLevel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken, isShow]);
    var primaryButtonText = function () {
        if (isLockedPrimaryBtn && resumeIdAIParseError === -1 && selectResume !== -1) {
            return t("Scanning file's content");
        }
        return t(isTrial ? 'View result' : 'Checkout to see result');
    };
    var renderRightSide = function () {
        var _a;
        return (react.createElement(CVSelectWrapper, null,
            react.createElement(Typography/* default */.Z, { name: 'label', size: 'medium' }, t('Select an available profile on VietnamWorks.')),
            react.createElement(ResumeList, null, isLoadingResumes ? (react.createElement(react.Fragment, null,
                react.createElement(ResumeItemSkeleton, null),
                react.createElement(ResumeItemSkeleton, null),
                react.createElement(ResumeItemSkeleton, null),
                react.createElement(ResumeItemSkeleton, null))) : ((_a = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                var isAttachedResume = item.isAttach === ApplyJobs_constants/* IS_RESUME_ATTACHMENT */.Xh;
                var radioId = "attach-resume-".concat(item.id);
                if (!isAttachedResume) {
                    radioId = 'profile-online';
                }
                if (item.id === replacingResumeId) {
                    return react.createElement(ResumeItemSkeleton, { key: "cv-".concat(index, "-replace-").concat(item.id) });
                }
                // Check if cv is deletable
                var filteredAttachCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.isAttach === 1; });
                var isDeletable = filteredAttachCV.length > 1;
                return (react.createElement(ResumeItem, { key: "cv-".concat(index, "-").concat(item.id), isAttach: isAttachedResume, radioId: radioId, cvInfo: item, profileStrength: profileStrength, resumeId: selectResume, applyResumeId: resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.applyResumeId, onChange: onSelectResume, langCode: langCode, baseUrl: baseUrl, isJustUploaded: justUploadResumeId === item.id, isAIParseError: resumeIdAIParseError === item.id, msBaseUrl: baseMsUrl, accessToken: accessToken, isDeletable: isDeletable, setIsLoadingResumes: setIsLoadingResumes, handleGetResume: handleGetResume }));
            }))),
            react.createElement(DragDropResumeUpload/* default */.Z, { lang: langCode, accessToken: accessToken, ref: dropFileComponentRef, baseUrl: baseMsUrl, isCheckSpam: true, onUpload: handleFileUpload, isLoading: true, onUploadDone: onUploadDone, onUploadError: onUploadError, contentOptions: {
                    placeholder: '',
                    msg: '',
                    customMsg: t('Uploaded attachment will be added to your VietnamWorks account')
                } }),
            !isLoadingResumes && selectResume === -1 ? (react.createElement(Typography/* default */.Z, { name: 'body', size: 'small', style: { marginTop: 8, color: Colors/* colors.error.40 */.O9.error[40] } }, t('Please upload your CV to see the evaluation.'))) : null));
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(PopupCVReplace/* default */.Z, { ref: popupCVReplaceRef, langCode: langCode, maxNumberOfCV: ApplyJobs_constants/* MAX_NUMBER_OF_CV */.h9, cvList: (resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes) || [] }),
        react.createElement(Popup/* default */.Z, { isShow: isShow, lang: langCode, option: {
                isShowSecondaryButton: false
            }, styleOption: {
                size: isNewUI ? 'lg' : 'sm',
                headerBg: 'linear-gradient(269deg, #B900F6 0.91%, #DC1EAF 23.38%, #FF6200 45.85%, #FDB92E 92.62%)',
                headerTextColor: '#fff',
                isHaveBorder: false,
                closeIconColor: '#fff',
                isDisplayNone: isDisplayNone
            }, custom: {
                footer: (react.createElement(CTAWrapper, null,
                    react.createElement(ButtonAI, { style: { width: isNewUI ? undefined : '100%' }, onClick: function () {
                            if (isLockedPrimaryBtn) {
                                return;
                            }
                            onPay();
                        } },
                        isLockedPrimaryBtn && resumeIdAIParseError === -1 && selectResume !== -1 ? (react.createElement(LoadingIcon/* default */.Z, { bgColor: '#fff' })) : null,
                        ' ',
                        primaryButtonText())))
            }, text: {
                header: t('Select your CV to analyse')
            }, onClickOutside: function () { return setIsShow(false); }, onClose: function () { return setIsShow(false); } },
            react.createElement(AIReviewCVWrapper, null, isNewUI ? (react.createElement(AIReviewCVContainer, null,
                react.createElement(LeftSection, null,
                    react.createElement(PricingInfo, { job: job, t: t, numsOfTrial: numsOfTrial })),
                react.createElement(RightSection, null, renderRightSide()))) : (renderRightSide())))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AICircleProgressBar/constants.js
'use client';



var AICircleProgressBar_constants_DEFAULT_OPTIONS = {
    radius: 102,
    strokeWidth: 6,
    color: constants/* colors.primaryColor */.O9.primaryColor,
    label: {
        size: 24,
        weight: 700,
        lineHeight: 29,
        extend: ''
    },
    segmentSpace: 10,
    pieceCount: 4,
    duration: 1000 // Duration in milliseconds
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AICircleProgressBar/helpers.js
'use client';

var calculatePiece = function (params) {
    var perimeter = params.perimeter, percent = params.percent, index = params.index, piecePerimeter = params.piecePerimeter, piecePercent = params.piecePercent;
    // Calculate "from percent" "to percent" by index
    var fromPercent = index * piecePercent;
    var toPercent = (index + 1) * piecePercent;
    if (percent >= toPercent) {
        // return full
        return perimeter - piecePerimeter;
    }
    if (fromPercent < percent && percent <= toPercent) {
        // return calculate
        var segmentPercent = percent - fromPercent;
        return perimeter - (segmentPercent * piecePerimeter) / piecePercent;
    }
    return perimeter;
};


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AICircleProgressBar/index.js
'use client';














var AICircleProgressBar_circlePercent = 100; // Total percent of a circle
var AICircleProgressBar_circleRadius = 360; // Total radius of a circle
var AICircleProgressBar = function (props) {
    var options = props.options;
    var mergedOptions = (0,helpers/* deepMerge */.RH)(AICircleProgressBar_constants_DEFAULT_OPTIONS, options);
    var divRef = (0,react.useRef)(null);
    var pieces = mergedOptions.pieceCount;
    var _a = (0,react.useState)(0), percent = _a[0], setPercent = _a[1];
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: divRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    (0,react.useEffect)(function () {
        if (!isElementOnScreen) {
            return;
        }
        setTimeout(function () { return setPercent(props.percent > AICircleProgressBar_circlePercent ? AICircleProgressBar_circlePercent : props.percent); }, 500);
    }, [props.percent, isElementOnScreen]);
    var radius = mergedOptions.radius / 2 - mergedOptions.strokeWidth / 2;
    // Total Perimeter in pixel of circle
    var perimeter = Math.PI * 2 * radius;
    var piecesPerimeter = perimeter / pieces;
    // Convert SegmentSpace into radius
    var segmentSpacing = (mergedOptions.segmentSpace * AICircleProgressBar_circleRadius) / perimeter;
    // Calculate the dash length for each piece by subtracting
    //   the segment spacing and stroke width from the total perimeter
    var totalDashPerimeter = piecesPerimeter - segmentSpacing - mergedOptions.strokeWidth;
    var anglePiece = 360 / pieces;
    // Calculate the dash length for each piece by subtracting
    //   the segment spacing and stroke width from the total perimeter
    var dash = piecesPerimeter - segmentSpacing - mergedOptions.strokeWidth;
    return (react.createElement(AICircleProgressBar_css_ScorePercentWrapper, { ref: divRef, diameter: mergedOptions.radius },
        react.createElement("svg", { viewBox: "-".concat(mergedOptions.radius / 2, " -").concat(mergedOptions.radius / 2, " ").concat(mergedOptions.radius, " ").concat(mergedOptions.radius), role: 'presentation' },
            Array.from({ length: pieces }).map(function (_, index) {
                // Calculate the angle for each piece. The base angle (index * 90)
                //    aligns each piece correctly in a square formation,
                //    offset by -90 degrees to start from the top, and adjusted by the segment spacing
                var angle = index * anglePiece - 90 + segmentSpacing;
                return (react.createElement(AICircleProgressBar_css_CircleItem, { key: "piece-item-bg-".concat(index), r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: 0, stroke: '#f4f4f7', delay: 0, style: {
                        strokeDasharray: "".concat(dash, "px, ").concat(perimeter, "px"),
                        transform: "rotate(".concat(angle, "deg)")
                    }, duration: mergedOptions.duration }));
            }),
            Array.from({ length: pieces }).map(function (_, index) {
                // Calculate the angle for each piece. The base angle (index * 90)
                //    aligns each piece correctly in a square formation,
                //    offset by -90 degrees to start from the top, and adjusted by the segment spacing
                var angle = index * anglePiece - 90 + segmentSpacing;
                var dash = calculatePiece({
                    percent: percent,
                    perimeter: perimeter,
                    index: index,
                    piecePerimeter: totalDashPerimeter,
                    piecePercent: 100 / pieces
                });
                var color = '#FDB92E';
                if (index === 1) {
                    color = '#FF6200';
                }
                else if (index === 2) {
                    color = '#FF3C68';
                }
                else if (index === 3) {
                    color = '#B900F6';
                }
                return (react.createElement(AICircleProgressBar_css_CircleItem, { key: "piece-item-fg-".concat(index), r: radius, cx: '0', cy: '0', stroke: color, strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: dash, delay: index * mergedOptions.duration, duration: mergedOptions.duration, style: {
                        transform: "rotate(".concat(angle, "deg)")
                    } }));
            })),
        react.createElement(AICircleProgressBar_css_LabelPercent, { color: mergedOptions.color, sizes: mergedOptions.radius, label: mergedOptions.label },
            react.createElement(CountUp, { start: 0, end: percent, duration: mergedOptions.duration * pieces }),
            "%",
            mergedOptions.label.extend ? (react.createElement(react.Fragment, null,
                react.createElement("br", null),
                react.createElement(LabelExtend, null, mergedOptions.label.extend))) : null)));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AttachName/AttachName.css.js
'use client';




var TitleH3 = styled_components_browser_esm/* default.span */.ZP.span(AttachName_css_templateObject_1 || (AttachName_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: ", "px;\n    width: 100%;\n    margin: 0;\n    ::before {\n        content: attr(data-filename);\n        text-overflow: ellipsis;\n        display: inline-block;\n        max-width: ", " !important;\n        overflow: hidden;\n        white-space: pre;\n    }\n    ::after {\n        content: attr(data-extension);\n        text-overflow: clip;\n        display: inline-block;\n        max-width: 10%;\n        min-width: ", "px;\n        width: 26px;\n        overflow: hidden;\n        white-space: pre;\n    }\n    @media screen and (min-width: 768px) and (max-width: 825px) {\n        ::before {\n            max-width: 80%;\n        }\n        ::after {\n            max-width: 20%;\n        }\n    }\n    @media screen and (min-width: 825px) and (max-width: 846px) {\n        ::before {\n            max-width: 86%;\n        }\n        ::after {\n            max-width: 14%;\n        }\n    }\n    @media screen and (min-width: 847px) and (max-width: 922px) {\n        ::before {\n            max-width: 88%;\n        }\n        ::after {\n            max-width: 12%;\n        }\n    }\n"], ["\n    font-size: ", "px;\n    width: 100%;\n    margin: 0;\n    ::before {\n        content: attr(data-filename);\n        text-overflow: ellipsis;\n        display: inline-block;\n        max-width: ", " !important;\n        overflow: hidden;\n        white-space: pre;\n    }\n    ::after {\n        content: attr(data-extension);\n        text-overflow: clip;\n        display: inline-block;\n        max-width: 10%;\n        min-width: ", "px;\n        width: 26px;\n        overflow: hidden;\n        white-space: pre;\n    }\n    @media screen and (min-width: 768px) and (max-width: 825px) {\n        ::before {\n            max-width: 80%;\n        }\n        ::after {\n            max-width: 20%;\n        }\n    }\n    @media screen and (min-width: 825px) and (max-width: 846px) {\n        ::before {\n            max-width: 86%;\n        }\n        ::after {\n            max-width: 14%;\n        }\n    }\n    @media screen and (min-width: 847px) and (max-width: 922px) {\n        ::before {\n            max-width: 88%;\n        }\n        ::after {\n            max-width: 12%;\n        }\n    }\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize || 16;
}, function (_a) {
    var minWidth = _a.minWidth;
    return "calc(100% - ".concat(minWidth, "px)");
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
});
var AttachName_css_templateObject_1;


//# sourceMappingURL=AttachName.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AttachName/index.js
'use client';




var CHARACTER_LENGTH = 10.5; // Assume the average length of a character is 10.5px
var DEFAULT_MIN_WIDTH = 25; // Default minimum width for the extension (.pdf = 25px)
// Split file name and extension
var splitFileExtension = function (fileName, extension) {
    var lastDotIndex = fileName.lastIndexOf('.');
    // If there's no dot in the file name, assume no extension
    if (lastDotIndex === -1) {
        return [fileName, extension];
    }
    var name = fileName.slice(0, lastDotIndex);
    var extensionName = fileName.slice(lastDotIndex);
    return [name, extensionName];
};
var AttachName = function (props) {
    var _a = splitFileExtension(props.fileName), fileName = _a[0], fileExtension = _a[1];
    var minWidthExtension = fileExtension ? (fileExtension === null || fileExtension === void 0 ? void 0 : fileExtension.length) * CHARACTER_LENGTH : DEFAULT_MIN_WIDTH;
    return react.createElement(TitleH3, { "data-filename": fileName, "data-extension": fileExtension, minWidth: minWidthExtension });
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/index.js + 7 modules
var Notifications_context = __webpack_require__(36234);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/context/action.js
var action = __webpack_require__(12103);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/components/NotificationMain/NotificationMain.css.js
'use client';





var NotificationMain_css_extendFromRight = (0,styled_components_browser_esm/* keyframes */.F4)(NotificationMain_css_templateObject_1 || (NotificationMain_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    right: -390px;\n  }\n  100% {\n    right: 0;\n  }\n"], ["\n  0% {\n    right: -390px;\n  }\n  100% {\n    right: 0;\n  }\n"])));
var NotificationMain_css_collapseToRight = (0,styled_components_browser_esm/* keyframes */.F4)(NotificationMain_css_templateObject_2 || (NotificationMain_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -390px;\n  }\n"], ["\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -390px;\n  }\n"])));
var DropdownContainerWrapper = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_3 || (NotificationMain_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 390px;\n    position: fixed;\n    right: 0;\n    top: initial;\n    bottom: 0;\n    z-index: 9;\n    height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media (max-width: 992px) {\n        width: 100%;\n    }\n"], ["\n    width: 390px;\n    position: fixed;\n    right: 0;\n    top: initial;\n    bottom: 0;\n    z-index: 9;\n    height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media (max-width: 992px) {\n        width: 100%;\n    }\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? NotificationMain_css_extendFromRight : NotificationMain_css_collapseToRight);
});
var DropdownContainerBodyWrapper = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_5 || (NotificationMain_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    ", "\n"], ["\n    background-color: #fff;\n    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(NotificationMain_css_templateObject_4 || (NotificationMain_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            will-change: transform;\n            overflow: hidden;\n        "], ["\n            will-change: transform;\n            overflow: hidden;\n        "])));
});
var HeaderTitle = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_6 || (NotificationMain_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: #000;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    width: 100%;\n    padding: 12px;\n"], ["\n    color: #000;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    width: 100%;\n    padding: 12px;\n"])));
var NotifyIcon = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_7 || (NotificationMain_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    background-color: ", ";\n"], ["\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    background-color: ", ";\n"])), Colors/* colors.primary.95 */.O9.primary[95]);
var TitleContent = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_8 || (NotificationMain_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: calc(100% - 102px);\n    margin: 0 16px;\n"], ["\n    width: calc(100% - 102px);\n    margin: 0 16px;\n"])));
var NotificationMain_css_CloseIcon = styled_components_browser_esm/* default.span */.ZP.span(NotificationMain_css_templateObject_9 || (NotificationMain_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    float: right;\n    cursor: pointer;\n    &:hover {\n        svg {\n            path {\n                fill: #333;\n            }\n        }\n    }\n"], ["\n    float: right;\n    cursor: pointer;\n    &:hover {\n        svg {\n            path {\n                fill: #333;\n            }\n        }\n    }\n"])));
var Background = styled_components_browser_esm/* default.div */.ZP.div(NotificationMain_css_templateObject_10 || (NotificationMain_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 99;\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 99;\n"])));
var NotifyBadge = styled_components_browser_esm/* default.span */.ZP.span(NotificationMain_css_templateObject_11 || (NotificationMain_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    top: 0;\n    right: 0;\n    background: #dc362e;\n    color: #ffffff;\n    width: fit-content;\n    padding: 0;\n    min-width: 14px;\n    height: 14px;\n    border-radius: 8px;\n    font-size: 9px;\n    position: absolute;\n    text-align: center;\n    z-index: 5;\n\n    &&&& svg {\n        width: 7px;\n        height: 7px;\n        fill: #f7941d;\n        position: absolute;\n        top: 0;\n        left: 5px;\n    }\n"], ["\n    top: 0;\n    right: 0;\n    background: #dc362e;\n    color: #ffffff;\n    width: fit-content;\n    padding: 0;\n    min-width: 14px;\n    height: 14px;\n    border-radius: 8px;\n    font-size: 9px;\n    position: absolute;\n    text-align: center;\n    z-index: 5;\n\n    &&&& svg {\n        width: 7px;\n        height: 7px;\n        fill: #f7941d;\n        position: absolute;\n        top: 0;\n        left: 5px;\n    }\n"])));
var NotificationMain_css_templateObject_1, NotificationMain_css_templateObject_2, NotificationMain_css_templateObject_3, NotificationMain_css_templateObject_4, NotificationMain_css_templateObject_5, NotificationMain_css_templateObject_6, NotificationMain_css_templateObject_7, NotificationMain_css_templateObject_8, NotificationMain_css_templateObject_9, NotificationMain_css_templateObject_10, NotificationMain_css_templateObject_11;


//# sourceMappingURL=NotificationMain.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/services/jobInvitation.js
var jobInvitation = __webpack_require__(19692);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/helpers/utils.js
'use client';

function isPhone() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/components/NotificationMain/index.js
'use client';































































































































































// Lazy import
var NotificationBody = react.lazy(function () { return __webpack_require__.e(/* import() */ 960).then(__webpack_require__.bind(__webpack_require__, 93960)); });
var MAX_DISPLAY_NOTIFY_COUNT = 9;
var NotificationMain = function () {
    var _a = (0,Notifications_context/* useNotifyStore */.PV)(), state = _a.state, firebase = _a.firebase, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isOpen = state.isOpen, notificationCount = state.notificationCount;
    var _b = (0,react.useState)(false), isMounted = _b[0], setMounted = _b[1];
    var isInMobile = isPhone();
    var _c = (0,useFloating/* default */.Z)({
        placement: 'bottom-end',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true,
            isFlip: false,
            detectHidden: false
        }
    }), refs = _c.refs, context = _c.context, FloatingPortal = _c.FloatingPortal;
    var onOpenNotification = function () {
        if (isOpen) {
            dispatch({
                type: action/* NOTIFY_ACTION.HIDE */.D.HIDE
            });
            return;
        }
        firebase.getNotification();
        dispatch({
            type: action/* NOTIFY_ACTION.SHOW */.D.SHOW
        });
    };
    var onClose = function () {
        dispatch({
            type: action/* NOTIFY_ACTION.HIDE */.D.HIDE
        });
    };
    var onAnimationEnd = function () {
        if (isOpen) {
            return;
        }
        setMounted(false);
    };
    var fetchJobInvitationNotifications = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var responseNotifications;
        var _a, _b, _c, _d, _e, _f, _g;
        return (0,_tslib/* __generator */.Jh)(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!((_a = props.config) === null || _a === void 0 ? void 0 : _a.baseMsUrl) || ((_b = props.config) === null || _b === void 0 ? void 0 : _b.baseMsUrl) === '') {
                        return [2 /*return*/];
                    }
                    if (!((_c = props.user) === null || _c === void 0 ? void 0 : _c.accessToken) || ((_d = props.user) === null || _d === void 0 ? void 0 : _d.accessToken) === '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0,jobInvitation/* getJobInvitationNotifications */.q)({
                            msBaseUrl: (_e = props.config) === null || _e === void 0 ? void 0 : _e.baseMsUrl,
                            accessToken: (_f = props.user) === null || _f === void 0 ? void 0 : _f.accessToken,
                            langCode: (_g = props.langCode) !== null && _g !== void 0 ? _g : constants/* ELanguage.VI */.Df.VI
                        })];
                case 1:
                    responseNotifications = _h.sent();
                    if (!responseNotifications) {
                        return [2 /*return*/];
                    }
                    dispatch({
                        type: action/* NOTIFY_ACTION.MAP_JOB_INVITATION_NOTIFICATIONS */.D.MAP_JOB_INVITATION_NOTIFICATIONS,
                        payload: responseNotifications
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        if (!isOpen) {
            return;
        }
        var onKeyUp = function (e) {
            if (!isOpen) {
                return;
            }
            if (e.key === 'Escape') {
                onClose();
            }
        };
        setMounted(true);
        fetchJobInvitationNotifications();
        window.addEventListener('keyup', onKeyUp);
        return function () {
            window.removeEventListener('keyup', onKeyUp);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    (0,react.useEffect)(function () {
        window.addEventListener('VNW_OPEN_NOTIFICATION', onOpenNotification);
        return function () {
            window.removeEventListener('VNW_OPEN_NOTIFICATION', onOpenNotification);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var dropdownStyle = {
        position: context.position,
        bottom: 0,
        right: 0,
        display: context.isReferenceHidden ? 'none' : 'block',
        zIndex: 201
    };
    var desktopRedDotContainer = typeof document !== 'undefined' ? document.querySelector('#desktopRedDotContainer') : null;
    var mobileRedDotContainer = typeof document !== 'undefined' ? document.querySelector('#mobileRedDotContainer') : null;
    var labelOfNumberNotify = "".concat(notificationCount);
    // If current number of notification is larger than MAX_DISPLAY_NOTIFY_COUNT
    // then we should display it as 'MAX_DISPLAY_NOTIFY_COUNT+'
    if (notificationCount > MAX_DISPLAY_NOTIFY_COUNT) {
        labelOfNumberNotify = "".concat(MAX_DISPLAY_NOTIFY_COUNT, "+");
    }
    if (!labelOfNumberNotify) {
        labelOfNumberNotify = '0';
    }
    return (react.createElement(react.Fragment, null,
        react.createElement(FloatingPortal, { enable: true }, isMounted ? (react.createElement(react.Fragment, null,
            react.createElement(Background, { onClick: onClose }),
            react.createElement(DropdownContainerWrapper, { isShow: isOpen, ref: refs.setPopup, style: dropdownStyle, onAnimationEnd: onAnimationEnd },
                react.createElement(DropdownContainerBodyWrapper, { isShow: isOpen, isMobile: isInMobile, "data-floating-placement": 'bottom-end' },
                    react.createElement(HeaderTitle, null,
                        react.createElement(NotifyIcon, null,
                            react.createElement(BellIcon_index, null)),
                        react.createElement(TitleContent, null,
                            react.createElement(Typography/* default */.Z, { name: 'title', size: 'large', color: '#000' }, t('Notifications')),
                            react.createElement(Typography/* default */.Z, { size: 'medium', color: Colors/* colors.grey.40 */.O9.grey[40] }, t('Get notifications for jobs'))),
                        react.createElement(NotificationMain_css_CloseIcon, { onClick: onClose },
                            react.createElement(CloseIcon/* default */.Z, null))),
                    react.createElement(react.Suspense, { fallback: react.createElement(react.Fragment, null) },
                        react.createElement(NotificationBody, null)))))) : (react.createElement(react.Fragment, null))),
        desktopRedDotContainer && notificationCount > 0
            ? react_dom.createPortal(react.createElement(NotifyBadge, { className: 'custom__red_dot totalNumber' }, labelOfNumberNotify), desktopRedDotContainer)
            : null,
        mobileRedDotContainer && notificationCount > 0
            ? react_dom.createPortal(
            // UI change, replace red dot to total notification
            react.createElement(NotifyBadge, { className: 'totalNumber' }, labelOfNumberNotify), mobileRedDotContainer)
            : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/index.js
'use client';






function openNotification() {
    if (typeof window === 'undefined') {
        return;
    }
    var event = new CustomEvent('VNW_OPEN_NOTIFICATION');
    window.dispatchEvent(event);
}
var Notifications = function (props) {
    return (react.createElement(Notifications_context/* default */.ZP, (0,_tslib/* __assign */.pi)({}, props),
        react.createElement(NotificationMain, null)));
};
var Notifications_index = react.memo(Notifications, function (prevProps, nextProps) {
    var _a, _b;
    // User logged in or User logged out
    if ((typeof prevProps.user === null && typeof nextProps.user !== null) ||
        (typeof prevProps.user !== null && typeof nextProps.user === null)) {
        return false;
    }
    // userId match then don't need to render
    return ((_a = prevProps.user) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = nextProps.user) === null || _b === void 0 ? void 0 : _b.userId);
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Pagination/Pagination.css.js
'use client';





var PaginationWrapper = styled_components_browser_esm/* default.div */.ZP.div(Pagination_css_templateObject_1 || (Pagination_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    button {\n        color: ", " !important;\n        > div {\n            margin: 0;\n        }\n        &:hover {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    .current {\n        background-color: #eff5ff !important;\n        box-shadow: inset 0 0 0 1px #fff !important;\n        color: #005aff !important;\n        border: 2px solid #80adff !important;\n    }\n"], ["\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    button {\n        color: ", " !important;\n        > div {\n            margin: 0;\n        }\n        &:hover {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    .current {\n        background-color: #eff5ff !important;\n        box-shadow: inset 0 0 0 1px #fff !important;\n        color: #005aff !important;\n        border: 2px solid #80adff !important;\n    }\n"])), Colors/* colors.grey.40 */.O9.grey[40], Colors/* colors.primary.40 */.O9.primary[40]);
var Pagination_css_templateObject_1;


//# sourceMappingURL=Pagination.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Pagination/index.js
'use client';

























































































































































var Pagination_Pagination = function (props) {
    var current = props.current, total = props.total, onGoTo = props.onGoTo;
    var _a = (0,react.useState)(current), currentPage = _a[0], setCurrentPage = _a[1];
    var isShowPrevious = false;
    var isShowNext = false;
    // Make a list of pagination
    var displayPage = [];
    if (currentPage - 1 > 0) {
        displayPage.push(current - 1);
    }
    displayPage.push(current);
    if (currentPage + 1 <= total) {
        displayPage.push(current + 1);
    }
    // Show more left (3 dots)
    var isShowMoreLeft = false;
    if (displayPage.indexOf(1) < 0) {
        isShowMoreLeft = true;
        isShowPrevious = true;
    }
    if (displayPage.indexOf(3) > 0) {
        isShowMoreLeft = false;
    }
    // Show more right (3 dots)
    var isShowMoreRight = false;
    if (displayPage.indexOf(total) < 0) {
        isShowMoreRight = true;
        isShowNext = true;
    }
    if (displayPage.indexOf(total - 1) > 0) {
        isShowMoreRight = false;
    }
    return (react.createElement(PaginationWrapper, null,
        isShowPrevious ? (react.createElement(react.Fragment, null,
            react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, iconComponent: react.createElement(Arrows/* ArrowLeft */.Xd, null), onClick: function () {
                    var previousPage = current - 1;
                    onGoTo && onGoTo(current - 1);
                    setCurrentPage(previousPage);
                } }),
            react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, onClick: function () {
                    onGoTo && onGoTo(1);
                    setCurrentPage(1);
                } }, "1"))) : null,
        isShowMoreLeft ? (react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, disabled: true, iconComponent: react.createElement(ThreeDotIcon/* default */.Z, null) })) : null,
        displayPage.map(function (item) {
            return (react.createElement(Button/* default */.Z, { key: "page-".concat(item), type: 'highlight', className: currentPage === item ? 'current' : '', outline: 'none', isIcon: true, isRounded: true, disabled: currentPage === item, onClick: function () {
                    onGoTo && onGoTo(item);
                    setCurrentPage(item);
                } }, item));
        }),
        isShowMoreRight ? (react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, disabled: true, iconComponent: react.createElement(ThreeDotIcon/* default */.Z, null) })) : null,
        isShowNext ? (react.createElement(react.Fragment, null,
            react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, onClick: function () {
                    onGoTo && onGoTo(total);
                    setCurrentPage(total);
                } }, total),
            react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, iconComponent: react.createElement(Arrows/* ArrowRight */.ol, null), onClick: function () {
                    var nextPage = current + 1;
                    onGoTo && onGoTo(nextPage);
                    setCurrentPage(nextPage);
                } }))) : null));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/AICVReview.css.js
'use client';





var AiReviewBlockWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_1 || (AICVReview_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var AIReviewHeader = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_2 || (AICVReview_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    color: #fff;\n    padding: 10px 16px 8px 16px;\n    border-radius: 16px 16px 0 0;\n    background: linear-gradient(269deg, #b900f6 0.91%, #dc1eaf 23.38%, #ff6200 45.85%, #fdb92e 92.62%);\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    position: relative;\n    color: #fff;\n    padding: 10px 16px 8px 16px;\n    border-radius: 16px 16px 0 0;\n    background: linear-gradient(269deg, #b900f6 0.91%, #dc1eaf 23.38%, #ff6200 45.85%, #fdb92e 92.62%);\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"])));
var AIReviewBody = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_3 || (AICVReview_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-image: url('", "');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    border-radius: 0 0 16px 16px;\n    overflow: hidden;\n"], ["\n    background-image: url('", "');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    border-radius: 0 0 16px 16px;\n    overflow: hidden;\n"])), function (props) { return props.imageUrl; });
var PreviewList = styled_components_browser_esm/* default.ul */.ZP.ul(AICVReview_css_templateObject_4 || (AICVReview_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    > li {\n        margin-bottom: 12px;\n        display: flex;\n        svg {\n            margin-right: 12px;\n            min-width: 18px;\n        }\n    }\n    > li:last-child {\n        margin: 0;\n    }\n"], ["\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    > li {\n        margin-bottom: 12px;\n        display: flex;\n        svg {\n            margin-right: 12px;\n            min-width: 18px;\n        }\n    }\n    > li:last-child {\n        margin: 0;\n    }\n"])));
var AIReviewContent = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_5 || (AICVReview_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 16px;\n    margin: 16px;\n    padding: 16px;\n    background: linear-gradient(180deg, #6a3cd6 0%, rgba(181, 108, 215, 0.7) 50%, rgba(255, 126, 15, 0.3) 100%);\n    color: white;\n    font-weight: 500;\n\n    display: flex;\n    gap: 32px;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n        margin: 16px 8px;\n        font-size: 12px;\n        line-height: 14px;\n\n        > div:nth-child(2) {\n            display: none;\n        }\n    }\n"], ["\n    border-radius: 16px;\n    margin: 16px;\n    padding: 16px;\n    background: linear-gradient(180deg, #6a3cd6 0%, rgba(181, 108, 215, 0.7) 50%, rgba(255, 126, 15, 0.3) 100%);\n    color: white;\n    font-weight: 500;\n\n    display: flex;\n    gap: 32px;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n        margin: 16px 8px;\n        font-size: 12px;\n        line-height: 14px;\n\n        > div:nth-child(2) {\n            display: none;\n        }\n    }\n"])));
var AIReviewFooter = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_6 || (AICVReview_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: linear-gradient(100deg, rgba(172, 113, 242, 0.3) 0.76%, rgba(44, 8, 127, 0.3) 90.49%);\n    backdrop-filter: blur(2px); // 6.5px\n    padding: 16px 25px;\n    border-radius: 0 0 16px 16px;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    background: linear-gradient(100deg, rgba(172, 113, 242, 0.3) 0.76%, rgba(44, 8, 127, 0.3) 90.49%);\n    backdrop-filter: blur(2px); // 6.5px\n    padding: 16px 25px;\n    border-radius: 0 0 16px 16px;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"])));
var AIReviewFooterItem = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_7 || (AICVReview_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    height: 40px;\n    flex-direction: column;\n    justify-content: center;\n"], ["\n    display: flex;\n    height: 40px;\n    flex-direction: column;\n    justify-content: center;\n"])));
var PreviewImage = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_8 || (AICVReview_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    height: 250px;\n    user-select: none;\n\n    > img {\n        width: 100%;\n        height: 100%;\n    }\n"], ["\n    position: relative;\n    height: 250px;\n    user-select: none;\n\n    > img {\n        width: 100%;\n        height: 100%;\n    }\n"])));
var TextPreview = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_9 || (AICVReview_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n"], ["\n    display: flex;\n    align-items: center;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_10 || (AICVReview_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: center;\n    margin-top: 8px;\n"], ["\n    text-align: center;\n    margin-top: 8px;\n"])));
var LabelSelectResumeWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_11 || (AICVReview_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px;\n    display: flex;\n    width: calc(100% - 20px);\n    [data-filename] {\n        line-height: 16px;\n    }\n"], ["\n    padding: 8px;\n    display: flex;\n    width: calc(100% - 20px);\n    [data-filename] {\n        line-height: 16px;\n    }\n"])));
var AICVReview_css_ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_12 || (AICVReview_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    background-color: ", ";\n    border-radius: 0 0 12px 12px;\n"], ["\n    padding: 16px;\n    background-color: ", ";\n    border-radius: 0 0 12px 12px;\n"])), Colors/* colors.error.95 */.O9.error[95]);
var SelectResumeWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_13 || (AICVReview_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    margin-bottom: 8px;\n    align-items: center;\n"], ["\n    display: flex;\n    margin-bottom: 8px;\n    align-items: center;\n"])));
var SelectResume = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_14 || (AICVReview_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n    & > div > div {\n        display: flex;\n    }\n"], ["\n    flex: 1;\n    & > div > div {\n        display: flex;\n    }\n"])));
var ScoreWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_15 || (AICVReview_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 8px;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n    }\n"], ["\n    display: flex;\n    gap: 8px;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n    }\n"])));
var ScoreItem = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_16 || (AICVReview_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    flex: 1;\n    background: #fff;\n    border-radius: 14px;\n    border: 1px solid ", ";\n    padding: 8px 16px;\n    display: flex;\n    gap: 8px;\n\n    > div {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        gap: 8px;\n        padding: 6px;\n    }\n"], ["\n    flex: 1;\n    background: #fff;\n    border-radius: 14px;\n    border: 1px solid ", ";\n    padding: 8px 16px;\n    display: flex;\n    gap: 8px;\n\n    > div {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        gap: 8px;\n        padding: 6px;\n    }\n"])), Colors/* colors.neutral.95 */.O9.neutral[95]);
var ButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(AICVReview_css_templateObject_17 || (AICVReview_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 16px;\n    button {\n        height: 52px;\n    }\n\n    @media (max-width: 768px) {\n        margin-left: 8px;\n    }\n"], ["\n    margin-left: 16px;\n    button {\n        height: 52px;\n    }\n\n    @media (max-width: 768px) {\n        margin-left: 8px;\n    }\n"])));
var AICVReview_css_templateObject_1, AICVReview_css_templateObject_2, AICVReview_css_templateObject_3, AICVReview_css_templateObject_4, AICVReview_css_templateObject_5, AICVReview_css_templateObject_6, AICVReview_css_templateObject_7, AICVReview_css_templateObject_8, AICVReview_css_templateObject_9, AICVReview_css_templateObject_10, AICVReview_css_templateObject_11, AICVReview_css_templateObject_12, AICVReview_css_templateObject_13, AICVReview_css_templateObject_14, AICVReview_css_templateObject_15, AICVReview_css_templateObject_16, AICVReview_css_templateObject_17;


//# sourceMappingURL=AICVReview.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/AiTagIcon.js
'use client';



var AiTagIcon = function (_a) {
    var style = _a.style;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '14', height: '14', viewBox: '0 0 14 14', fill: 'none', style: style },
        react.createElement("path", { d: 'M1.92423 3.05627C1.69192 3.13305 1.69192 3.46183 1.92423 3.53795C2.45973 3.71383 2.87973 4.13448 3.05627 4.66998C3.13305 4.9023 3.46183 4.9023 3.53795 4.66998C3.71383 4.13448 4.13448 3.71448 4.66998 3.53795C4.9023 3.46117 4.9023 3.13239 4.66998 3.05627C4.13448 2.88039 3.71448 2.45973 3.53795 1.92423C3.46117 1.69192 3.13239 1.69192 3.05627 1.92423C2.87973 2.46039 2.45973 2.88039 1.92423 3.05627ZM9.29786 2.66252C9.2073 2.38689 8.81683 2.38689 8.72627 2.66252L8.30233 3.9527C8.09364 4.58795 7.59489 5.08605 6.9603 5.29473L5.67011 5.71867C5.39448 5.80923 5.39448 6.1997 5.67011 6.29027L6.9603 6.7142C7.59555 6.92289 8.09364 7.42164 8.30233 8.05623L8.72627 9.34642C8.81683 9.62205 9.2073 9.62205 9.29786 9.34642L9.72245 8.05623C9.93114 7.42098 10.4292 6.92289 11.0645 6.7142L12.3547 6.29027C12.6303 6.1997 12.6303 5.80923 12.3547 5.71867L11.0645 5.29408C10.4292 5.08539 9.93114 4.5873 9.72245 3.95205L9.29786 2.66252ZM4.78614 8.07658C4.69558 7.80095 4.30511 7.80095 4.21455 8.07658L4.1627 8.23473C3.95402 8.86998 3.45592 9.36808 2.82067 9.57677L2.66252 9.62861C2.38689 9.71917 2.38689 10.1096 2.66252 10.2002L2.82067 10.252C3.45592 10.4607 3.95402 10.9588 4.1627 11.5941L4.21455 11.7522C4.30511 12.0279 4.69558 12.0279 4.78614 11.7522L4.83798 11.5941C5.04667 10.9588 5.54542 10.4607 6.18001 10.252L6.33817 10.2002C6.6138 10.1096 6.6138 9.71917 6.33817 9.62861L6.18001 9.57677C5.54476 9.36808 5.04667 8.86933 4.83798 8.23473L4.78614 8.07658Z', fill: 'white' })));
};
var AiTagIcon$1 = react.memo(AiTagIcon);


//# sourceMappingURL=AiTagIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/AiCheckIcon.js
'use client';



var AiCheckIcon = function (_a) {
    var style = _a.style;
    return (react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", style: style },
        react.createElement("path", { d: "M9.00078 2.30078C5.02458 2.30078 1.80078 5.52458 1.80078 9.50078C1.80078 13.477 5.02458 16.7008 9.00078 16.7008C12.977 16.7008 16.2008 13.477 16.2008 9.50078C16.2008 5.52458 12.977 2.30078 9.00078 2.30078ZM13.025 8.12498L8.48898 12.661C8.37618 12.7738 8.22378 12.8368 8.06478 12.8368C7.90578 12.8368 7.75278 12.7738 7.64058 12.661L5.56878 10.5892C5.33418 10.3546 5.33418 9.97538 5.56878 9.74078C5.80338 9.50618 6.18258 9.50618 6.41718 9.74078L8.06478 11.3884L12.1766 7.27658C12.4112 7.04198 12.7904 7.04198 13.025 7.27658C13.2596 7.51118 13.2596 7.89038 13.025 8.12498Z", fill: "#00B70B" })));
};
var AiCheckIcon$1 = react.memo(AiCheckIcon);


//# sourceMappingURL=AiCheckIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/LabelSelectResume.js
'use client';









var LabelSelectResume = function (props) {
    var t = props.t;
    var evaluateTime = (0,time/* convertDateTime */.jF)(new Date(props.createdOn).getTime(), 7);
    return (react.createElement(LabelSelectResumeWrapper, null,
        react.createElement("div", { style: {
                height: 32,
                display: 'flex',
                alignItems: 'center',
                maxWidth: 32
            } },
            react.createElement(AiCheckIcon$1, { style: {
                    marginRight: 8
                } })),
        react.createElement("div", { style: { width: 'calc(100% - 32px)' } },
            react.createElement(Typography/* default */.Z, { name: 'label', size: 'medium', style: { marginBottom: 4 } },
                react.createElement(AttachName, { fileName: props.fileName })),
            react.createElement(Typography/* default */.Z, { name: 'label', size: 'small', color: Colors/* colors.grey.50 */.O9.grey[50] },
                t('Evaluated on'),
                " ",
                evaluateTime))));
};


//# sourceMappingURL=LabelSelectResume.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/AIComboChartIcon.js
'use client';



var AIComboChartIcon = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("rect", { width: '16', height: '16', rx: '4', fill: '#FF6301' }),
        react.createElement("path", { d: 'M11.6016 3.59961C11.3894 3.59961 11.1859 3.68389 11.0359 3.83392C10.8858 3.98395 10.8016 4.18744 10.8016 4.39961C10.8016 4.44517 10.8055 4.49065 10.8133 4.53555L9.47656 5.64961C9.38854 5.61693 9.29545 5.60001 9.20156 5.59961C9.04485 5.59977 8.89163 5.64595 8.76094 5.73242L7.59922 5.15117C7.58689 4.94791 7.49751 4.757 7.3493 4.61735C7.20109 4.4777 7.0052 4.39983 6.80156 4.39961C6.58939 4.39961 6.38591 4.48389 6.23588 4.63392C6.08585 4.78395 6.00156 4.98744 6.00156 5.19961C6.00179 5.21682 6.00257 5.23401 6.00391 5.25117L4.75547 6.0832C4.64548 6.02854 4.52438 5.99994 4.40156 5.99961C4.18939 5.99961 3.98591 6.08389 3.83588 6.23392C3.68585 6.38395 3.60156 6.58744 3.60156 6.79961C3.60156 7.01178 3.68585 7.21527 3.83588 7.36529C3.98591 7.51532 4.18939 7.59961 4.40156 7.59961C4.61374 7.59961 4.81722 7.51532 4.96725 7.36529C5.11728 7.21527 5.20156 7.01178 5.20156 6.79961C5.20132 6.78266 5.20054 6.76573 5.19922 6.74883L6.44766 5.91602C6.55764 5.97068 6.67874 5.99928 6.80156 5.99961C6.95828 5.99945 7.11149 5.95327 7.24219 5.8668L8.40391 6.44805C8.41624 6.65131 8.50562 6.84222 8.65383 6.98187C8.80204 7.12152 8.99793 7.19939 9.20156 7.19961C9.41374 7.19961 9.61722 7.11532 9.76725 6.96529C9.91728 6.81527 10.0016 6.61178 10.0016 6.39961C10.0015 6.35405 9.99761 6.30857 9.98984 6.26367L11.3266 5.14961C11.4146 5.18228 11.5077 5.19921 11.6016 5.19961C11.8137 5.19961 12.0172 5.11532 12.1672 4.96529C12.3173 4.81527 12.4016 4.61178 12.4016 4.39961C12.4016 4.18744 12.3173 3.98395 12.1672 3.83392C12.0172 3.68389 11.8137 3.59961 11.6016 3.59961ZM11.2016 6.79961C10.9808 6.79961 10.8016 6.97881 10.8016 7.19961V12.3996H12.4016V7.19961C12.4016 6.97881 12.2224 6.79961 12.0016 6.79961H11.2016ZM6.40156 7.59961C6.18076 7.59961 6.00156 7.77881 6.00156 7.99961V12.3996H7.60156V7.99961C7.60156 7.77881 7.42236 7.59961 7.20156 7.59961H6.40156ZM8.80156 8.39961C8.58076 8.39961 8.40156 8.57881 8.40156 8.79961V12.3996H10.0016V8.79961C10.0016 8.57881 9.82236 8.39961 9.60156 8.39961H8.80156ZM4.00156 9.19961C3.78076 9.19961 3.60156 9.37881 3.60156 9.59961V12.3996H5.20156V9.59961C5.20156 9.37881 5.02236 9.19961 4.80156 9.19961H4.00156Z', fill: 'white' })));
};


//# sourceMappingURL=AIComboChartIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/AIMoneyStackIcon.js
'use client';



var AIMoneyStackIcon = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("rect", { width: '16', height: '16', rx: '4', fill: '#FF6301' }),
        react.createElement("path", { d: 'M3.60078 4C3.54883 4.00017 3.49703 4.00541 3.44609 4.01562C3.44186 4.01648 3.43781 4.01783 3.43359 4.01875C3.25468 4.05698 3.09428 4.15538 2.97913 4.29755C2.86398 4.43971 2.80103 4.61705 2.80078 4.8V9.6C2.80095 9.65195 2.80619 9.70375 2.81641 9.75469C2.81726 9.75892 2.81861 9.76297 2.81953 9.76719C2.85776 9.9461 2.95617 10.1065 3.09833 10.2217C3.24049 10.3368 3.41783 10.3998 3.60078 10.4H12.4008C12.4527 10.3998 12.5045 10.3946 12.5555 10.3844C12.5597 10.3835 12.5638 10.3822 12.568 10.3812C12.7469 10.343 12.9073 10.2446 13.0224 10.1025C13.1376 9.96029 13.2005 9.78295 13.2008 9.6V4.8C13.2006 4.74805 13.1954 4.69625 13.1852 4.64531C13.1843 4.64108 13.183 4.63703 13.182 4.63281C13.1438 4.4539 13.0454 4.2935 12.9032 4.17835C12.7611 4.0632 12.5837 4.00025 12.4008 4H3.60078ZM4.40078 4.8H11.6008C11.6008 5.01217 11.6851 5.21566 11.8351 5.36569C11.9851 5.51571 12.1886 5.6 12.4008 5.6V8.8C12.1886 8.8 11.9851 8.88429 11.8351 9.03431C11.6851 9.18434 11.6008 9.38783 11.6008 9.6H4.40078C4.40078 9.38783 4.3165 9.18434 4.16647 9.03431C4.01644 8.88429 3.81295 8.8 3.60078 8.8V5.6C3.81295 5.6 4.01644 5.51571 4.16647 5.36569C4.3165 5.21566 4.40078 5.01217 4.40078 4.8ZM8.00078 5.6C7.11718 5.6 6.40078 6.406 6.40078 7.4C6.40078 7.9688 6.63985 8.47 7.00625 8.8H8.99531C9.36171 8.47 9.60078 7.9688 9.60078 7.4C9.60078 6.406 8.88438 5.6 8.00078 5.6ZM4.80078 6.8C4.69469 6.8 4.59295 6.84214 4.51794 6.91716C4.44292 6.99217 4.40078 7.09391 4.40078 7.2C4.40078 7.30609 4.44292 7.40783 4.51794 7.48284C4.59295 7.55786 4.69469 7.6 4.80078 7.6C4.90687 7.6 5.00861 7.55786 5.08362 7.48284C5.15864 7.40783 5.20078 7.30609 5.20078 7.2C5.20078 7.09391 5.15864 6.99217 5.08362 6.91716C5.00861 6.84214 4.90687 6.8 4.80078 6.8ZM11.2008 6.8C11.0947 6.8 10.993 6.84214 10.9179 6.91716C10.8429 6.99217 10.8008 7.09391 10.8008 7.2C10.8008 7.30609 10.8429 7.40783 10.9179 7.48284C10.993 7.55786 11.0947 7.6 11.2008 7.6C11.3069 7.6 11.4086 7.55786 11.4836 7.48284C11.5586 7.40783 11.6008 7.30609 11.6008 7.2C11.6008 7.09391 11.5586 6.99217 11.4836 6.91716C11.4086 6.84214 11.3069 6.8 11.2008 6.8ZM3.60078 11.2C3.54778 11.1993 3.49515 11.209 3.44596 11.2288C3.39678 11.2486 3.35201 11.2779 3.31426 11.3151C3.27651 11.3524 3.24654 11.3967 3.22608 11.4456C3.20562 11.4945 3.19508 11.547 3.19508 11.6C3.19508 11.653 3.20562 11.7055 3.22608 11.7544C3.24654 11.8033 3.27651 11.8476 3.31426 11.8849C3.35201 11.9221 3.39678 11.9514 3.44596 11.9712C3.49515 11.991 3.54778 12.0007 3.60078 12H12.4008C12.4538 12.0007 12.5064 11.991 12.5556 11.9712C12.6048 11.9514 12.6496 11.9221 12.6873 11.8849C12.725 11.8476 12.755 11.8033 12.7755 11.7544C12.7959 11.7055 12.8065 11.653 12.8065 11.6C12.8065 11.547 12.7959 11.4945 12.7755 11.4456C12.755 11.3967 12.725 11.3524 12.6873 11.3151C12.6496 11.2779 12.6048 11.2486 12.5556 11.2288C12.5064 11.209 12.4538 11.1993 12.4008 11.2H3.60078Z', fill: 'white' })));
};


//# sourceMappingURL=AIMoneyStackIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/AILeaderboardIcon.js
'use client';



var AILeaderboardIcon = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("rect", { width: '16', height: '16', rx: '4', fill: '#FF6301' }),
        react.createElement("g", { clipPath: 'url(#clip0_35813_727181)' },
            react.createElement("path", { d: 'M6.00179 3.59961C5.78099 3.59961 5.60179 3.77881 5.60179 3.99961V5.59961H2.80179C2.58099 5.59961 2.40179 5.77881 2.40179 5.99961V11.1996C2.34879 11.1989 2.29616 11.2087 2.24697 11.2284C2.19779 11.2482 2.15302 11.2775 2.11527 11.3147C2.07752 11.352 2.04755 11.3963 2.02709 11.4452C2.00663 11.4941 1.99609 11.5466 1.99609 11.5996C1.99609 11.6526 2.00663 11.7051 2.02709 11.754C2.04755 11.8029 2.07752 11.8473 2.11527 11.8845C2.15302 11.9217 2.19779 11.951 2.24697 11.9708C2.29616 11.9906 2.34879 12.0004 2.40179 11.9996H13.6018C13.6548 12.0004 13.7074 11.9906 13.7566 11.9708C13.8058 11.951 13.8506 11.9217 13.8883 11.8845C13.9261 11.8473 13.956 11.8029 13.9765 11.754C13.997 11.7051 14.0075 11.6526 14.0075 11.5996C14.0075 11.5466 13.997 11.4941 13.9765 11.4452C13.956 11.3963 13.9261 11.352 13.8883 11.3147C13.8506 11.2775 13.8058 11.2482 13.7566 11.2284C13.7074 11.2087 13.6548 11.1989 13.6018 11.1996V7.19961C13.6018 6.97881 13.4226 6.79961 13.2018 6.79961H10.4018V3.99961C10.4018 3.77881 10.2226 3.59961 10.0018 3.59961H6.00179ZM7.75335 4.79961H8.36351V7.19961H7.75335V5.35039H7.7221L7.1432 5.74102V5.21523L7.75335 4.79961ZM4.40179 6.79961C4.92499 6.79961 5.27445 7.07938 5.27445 7.49258C5.27445 7.75178 5.12244 7.98197 4.70804 8.35117L4.3221 8.70586V8.73711H5.30726V9.19961H3.5307V8.80273L4.26898 8.1082C4.61218 7.7906 4.69945 7.67237 4.69945 7.53477C4.69945 7.36317 4.5735 7.24805 4.3807 7.24805C4.1799 7.24805 4.04085 7.38415 4.04085 7.57695V7.58789H3.49632V7.57852C3.49632 7.11372 3.85939 6.79961 4.40179 6.79961ZM11.5916 7.99961C12.0964 7.99961 12.444 8.25388 12.444 8.62148C12.444 8.88348 12.2683 9.08991 12.0127 9.13711V9.16758C12.3267 9.20078 12.5276 9.40719 12.5276 9.70039C12.528 10.1124 12.1391 10.3996 11.5823 10.3996C11.0507 10.3996 10.6925 10.1093 10.6721 9.66289H11.2244C11.2324 9.83649 11.3732 9.94336 11.5924 9.94336C11.7976 9.94336 11.9393 9.82704 11.9393 9.65664C11.9393 9.48144 11.805 9.37383 11.5838 9.37383H11.3049V8.97461H11.5838C11.7778 8.97461 11.9065 8.86599 11.9065 8.70039C11.9065 8.53479 11.7811 8.43164 11.5791 8.43164C11.3803 8.43164 11.2465 8.55012 11.2401 8.72852H10.7143C10.7223 8.28332 11.0632 7.99961 11.5916 7.99961Z', fill: 'white' })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: 'clip0_35813_727181' },
                react.createElement("rect", { width: '12', height: '12', fill: 'white', transform: 'translate(2 2)' })))));
};


//# sourceMappingURL=AILeaderboardIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/AIPeopleIcon.js
'use client';



var AIPeopleIcon = function () {
    return (react.createElement("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react.createElement("rect", { width: '16', height: '16', rx: '4', fill: '#FF6301' }),
        react.createElement("path", { d: 'M4.64062 3.19922C4.27503 3.19922 4 3.59922 4 3.59922C1.906 3.59922 3.06129 6.94158 2.44609 7.43438C2.44609 7.43438 2.8232 7.90078 4 7.90078V8.3C3.6748 9.1472 2 8.83402 2 10.3992H5.20938C5.49098 10.2288 6.4 9.75625 6.4 9.75625C6.1828 9.52425 5.86947 9.12313 5.75547 8.81953C5.50587 8.69433 5.2948 8.5472 5.2 8.3V7.89609C5.276 7.89609 5.50011 7.87854 5.57891 7.86094C5.40051 7.58614 5.25 6.95979 5.25 6.60859C5.25 5.71539 5.63466 4.98071 6.27266 4.52031C6.08026 3.78391 5.65302 3.19922 4.64062 3.19922ZM11.2 3.19922C10.3108 3.19922 9.76481 3.8109 9.63281 4.6125C10.2792 4.9589 10.7 5.70569 10.7 6.64609C10.7 6.94009 10.6314 7.22299 10.557 7.44219C10.5846 7.55059 10.6 7.67147 10.6 7.80547C10.6 8.79347 9.6 9.77891 9.6 9.77891C9.8172 9.87371 10.5121 10.2268 10.7961 10.3992H14C14 8.29922 12.2948 8.89922 12 7.99922V7.39922C12.1328 7.33242 12.4491 6.87248 12.4891 6.51328C12.5931 6.50528 12.8 6.25104 12.8 6.02344C12.8 5.79584 12.7276 5.70008 12.6648 5.66328C12.6648 5.66328 12.8 5.36282 12.8 4.99922C12.8 4.27082 12.6032 3.59922 12 3.59922C12 3.59922 11.8268 3.19922 11.2 3.19922ZM8 4.79922C6.9232 4.79922 6.05 5.44779 6.05 6.60859C6.05 7.09939 6.325 7.48203 6.325 7.48203C6.325 7.48203 6.2 7.54347 6.2 7.80547C6.2 8.31467 6.52734 8.43672 6.52734 8.43672C6.57294 8.83992 7.2 9.43047 7.2 9.43047V10.1047C6.8632 11.1151 4.8 10.4492 4.8 12.7992H11.2C11.2 10.4412 9.1368 11.1151 8.8 10.1047V9.43047C8.8 9.43047 9.42706 8.83992 9.47266 8.43672C9.47266 8.43672 9.8 8.21067 9.8 7.80547C9.8 7.52467 9.675 7.48203 9.675 7.48203C9.675 7.48203 9.9 7.05409 9.9 6.64609C9.9 5.82809 9.4896 5.19922 8.8 5.19922C8.8 5.19922 8.5072 4.79922 8 4.79922Z', fill: 'white' })));
};


//# sourceMappingURL=AIPeopleIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/CandidateCompareIcon.js
'use client';



var CandidateCompareIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 48 : _b, _c = _a.height, height = _c === void 0 ? 48 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 48', fill: 'none' },
        react.createElement("path", { opacity: 0.21, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0 24V25C0 37.7025 10.2975 48 23 48H24H25C37.7025 48 48 37.7025 48 25V24V23C48 10.2975 37.7025 0 25 0H24H23C10.2975 0 0 10.2975 0 23V24Z', fill: '#FF6200' }),
        react.createElement("path", { opacity: 0.587821, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.5234 18.669C16.5234 21.0254 18.4337 22.9357 20.7901 22.9357C23.1465 22.9357 25.0568 21.0254 25.0568 18.669C25.0568 16.3126 23.1465 14.4023 20.7901 14.4023C18.4337 14.4023 16.5234 16.3126 16.5234 18.669ZM27.1992 22.9344C27.1992 24.7017 28.6319 26.1344 30.3992 26.1344C32.1665 26.1344 33.5992 24.7017 33.5992 22.9344C33.5992 21.1671 32.1665 19.7344 30.3992 19.7344C28.6319 19.7344 27.1992 21.1671 27.1992 22.9344Z', fill: '#FF6200' }),
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M20.7854 25.0664C15.7492 25.0664 11.6173 27.6547 11.2038 32.7456C11.1813 33.0229 11.7116 33.5997 11.9791 33.5997H29.5996C30.4009 33.5997 30.4134 32.9549 30.4009 32.7464C30.0883 27.5125 25.8924 25.0664 20.7854 25.0664ZM36.2199 33.6051H32.1029L32.1029 33.6003C32.1029 31.2014 31.311 28.9875 29.9744 27.2057C33.6082 27.2453 36.5754 29.0824 36.7987 32.9651C36.8076 33.1215 36.7987 33.6051 36.2199 33.6051Z', fill: '#FF6200' })));
};


//# sourceMappingURL=CandidateCompareIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/AiCVPreviewImage.js
'use client';










var AiCVPreviewImage = function (props) {
    var langCode = props.langCode, env = props.env;
    var baseImageUrl = env.baseImageUrl;
    var _a = (0,react.useState)(false), isRendered = _a[0], setIsRendered = _a[1];
    var previewImageRef = (0,react.useRef)(null);
    var isElementOnScreen = (0,UseElementOnScreen/* default */.Z)({
        target: previewImageRef
    })[0];
    (0,react.useEffect)(function () {
        if (!isElementOnScreen || isRendered) {
            return;
        }
        setIsRendered(true);
    }, [isElementOnScreen, isRendered]);
    var aiCVReviewImage = (0,react.useMemo)(function () {
        return "".concat(baseImageUrl, "/images/ai_cv_review_").concat(langCode, ".png");
    }, [langCode]);
    return (react.createElement(PreviewImage, { ref: previewImageRef }, isRendered ? (react.createElement("img", { src: aiCVReviewImage, alt: 'VietnamWorks AI', style: {
            objectFit: 'contain'
        } })) : null));
};


//# sourceMappingURL=AiCVPreviewImage.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/icons/JobFitIcon.js
'use client';



var JobFitIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 48 : _b, _c = _a.height, height = _c === void 0 ? 48 : _c;
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 48', fill: 'none' },
        react.createElement("path", { opacity: 0.21, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0 24v1c0 12.703 10.298 23 23 23h2c12.703 0 23-10.297 23-23v-2C48 10.298 37.703 0 25 0h-2C10.298 0 0 10.298 0 23z', fill: '#FEC53D' }),
        react.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'm12 19.453 10.32 5.959q.168.095.347.14v11.556l-9.93-5.877A1.5 1.5 0 0 1 12 29.94zm24.003-.158V29.94a1.5 1.5 0 0 1-.736 1.291l-9.931 5.877V25.45l.072-.04z', fill: '#FEC53D' }),
        react.createElement("path", { opacity: 0.499, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.328 16.562c.126-.16.285-.294.47-.393l10.5-5.593a1.5 1.5 0 0 1 1.411 0l10.5 5.593a1.5 1.5 0 0 1 .379.287l-11.512 6.647a1.4 1.4 0 0 0-.21.149 1.4 1.4 0 0 0-.208-.15z', fill: '#FEC53D' })));
};


//# sourceMappingURL=JobFitIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIBanner.css.js
'use client';





var AIBanner_css_CustomPopup = (0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(AIBanner_css_templateObject_1 || (AIBanner_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .vnw-popup-content {\n        background: transparent !important;\n        border: none !important;\n    }\n"], ["\n    .vnw-popup-content {\n        background: transparent !important;\n        border: none !important;\n    }\n"])));
var BlockAI = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_2 || (AIBanner_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        height: 63px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        cursor: pointer;\n\n        border-radius: 8px;\n        background: linear-gradient(269deg, #b900f6 0.91%, #dc1eaf 23.38%, #ff6200 45.85%, #fdb92e 92.62%);\n        color: white;\n    "], ["\n        height: 63px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        cursor: pointer;\n\n        border-radius: 8px;\n        background: linear-gradient(269deg, #b900f6 0.91%, #dc1eaf 23.38%, #ff6200 45.85%, #fdb92e 92.62%);\n        color: white;\n    "]))),
    Left: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_3 || (AIBanner_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        flex: 1;\n        padding: 0 24px;\n    "], ["\n        flex: 1;\n        padding: 0 24px;\n    "]))),
    Title: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_4 || (AIBanner_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 22px;\n    "], ["\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 22px;\n    "]))),
    BlockAIText: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_5 || (AIBanner_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        margin-top: 8px;\n\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 14px;\n    "], ["\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        margin-top: 8px;\n\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 14px;\n    "]))),
    Right: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_6 || (AIBanner_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        gap: 16px;\n    "], ["\n        display: flex;\n        gap: 16px;\n    "])))
};
var TextAI = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_7 || (AIBanner_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        display: flex;\n        align-items: center;\n        gap: 12px;\n\n        > svg {\n            flex: 0 0 20px;\n        }\n    "], ["\n        display: flex;\n        align-items: center;\n        gap: 12px;\n\n        > svg {\n            flex: 0 0 20px;\n        }\n    "]))),
    Content: styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_8 || (AIBanner_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        background: linear-gradient(90deg, #b900f6 0%, #ff3c68 50%, #ff6200 100%);\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        cursor: pointer;\n        &:hover {\n            background: #b900f6;\n            background-clip: text;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n    "], ["\n        background: linear-gradient(90deg, #b900f6 0%, #ff3c68 50%, #ff6200 100%);\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        cursor: pointer;\n        &:hover {\n            background: #b900f6;\n            background-clip: text;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n    "])))
};
var AIBannerButton = styled_components_browser_esm/* default.button */.ZP.button(AIBanner_css_templateObject_9 || (AIBanner_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 44px;\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n\n    outline: none !important;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    color: white;\n    border-radius: 8px;\n    border: 1px solid white;\n    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%);\n"], ["\n    height: 44px;\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n\n    outline: none !important;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    color: white;\n    border-radius: 8px;\n    border: 1px solid white;\n    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%);\n"])));
var AIBannerContainer = styled_components_browser_esm/* default.div */.ZP.div(AIBanner_css_templateObject_10 || (AIBanner_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    @media (max-width: 768px) {\n        ", " {\n            display: none;\n        }\n        ", " {\n            height: 45px;\n        }\n        ", " {\n            margin-top: 0;\n            font-size: 10px;\n            line-height: 14px;\n        }\n        ", " {\n            font-size: 14px;\n            line-height: 18px;\n        }\n        ", " {\n            > svg {\n                width: 32px;\n                height: 24px;\n            }\n        }\n    }\n"], ["\n    @media (max-width: 768px) {\n        ", " {\n            display: none;\n        }\n        ", " {\n            height: 45px;\n        }\n        ", " {\n            margin-top: 0;\n            font-size: 10px;\n            line-height: 14px;\n        }\n        ", " {\n            font-size: 14px;\n            line-height: 18px;\n        }\n        ", " {\n            > svg {\n                width: 32px;\n                height: 24px;\n            }\n        }\n    }\n"])), AIBannerButton, BlockAI.Container, BlockAI.BlockAIText, BlockAI.Title, BlockAI.Right);
var AIBanner_css_templateObject_1, AIBanner_css_templateObject_2, AIBanner_css_templateObject_3, AIBanner_css_templateObject_4, AIBanner_css_templateObject_5, AIBanner_css_templateObject_6, AIBanner_css_templateObject_7, AIBanner_css_templateObject_8, AIBanner_css_templateObject_9, AIBanner_css_templateObject_10;


//# sourceMappingURL=AIBanner.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Utils/showLogin.js
'use client';

var LOGIN_POPUP = 'LOGIN_POPUP';
var showLogin = function (params) {
    var langCode = params.langCode, _a = params.isApply, isApply = _a === void 0 ? false : _a, onLoggedIn = params.onLoggedIn;
    var loginPopupDetail = {
        langCode: langCode,
        trackingProperties: {
            pageName: 'job_detail'
        },
        onLoggedIn: function () {
            onLoggedIn && onLoggedIn();
        }
    };
    if (isApply) {
        loginPopupDetail.isApply = true;
    }
    var loginEvent = new CustomEvent(LOGIN_POPUP, {
        detail: loginPopupDetail
    });
    window.dispatchEvent(loginEvent);
};


//# sourceMappingURL=showLogin.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/AIPreviewBlock/index.js
'use client';















































































































































































var AIReviewBlock = function (props) {
    var _a;
    var user = props.user, langCode = props.langCode, cvReviews = props.cvReviews, env = props.env, t = props.t, cvReviewTrial = props.cvReviewTrial, showBannerState = props.showBannerState;
    var baseUrl = env.baseUrl, baseMsUrl = env.baseMsUrl, baseImageUrl = env.baseImageUrl;
    var showBanner = showBannerState[0], setShowBanner = showBannerState[1];
    var _b = (0,react.useState)(false), isShow = _b[0], setShow = _b[1];
    var _c = (0,react.useState)(''), selectedCVId = _c[0], setSelectedCVId = _c[1];
    var tracking = (0,useHog/* default */.Z)().tracking;
    var optionAIResumes = (0,react.useMemo)(function () {
        return cvReviews.map(function (item) {
            return {
                id: item.attributes.soNo,
                name: item.attributes.fileName
            };
        });
    }, [cvReviews]);
    var selectedCV = (0,react.useMemo)(function () {
        var cv = cvReviews.filter(function (item) { return item.attributes.soNo === selectedCVId; });
        return cv.length > 0 ? cv[0] : null;
    }, [cvReviews, selectedCVId]);
    var cvScore = (0,react.useMemo)(function () {
        if (!selectedCV) {
            return '';
        }
        var text = '';
        if (selectedCV.attributes.score < 50) {
            text = t('Low');
        }
        if (selectedCV.attributes.score >= 50 && selectedCV.attributes.score < 70) {
            text = t('Medium');
        }
        if (selectedCV.attributes.score >= 70 && selectedCV.attributes.score < 90) {
            text = t('High');
        }
        if (selectedCV.attributes.score >= 90) {
            text = t('Very high');
        }
        return "".concat(selectedCV.attributes.score, "% ").concat(text);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCV]);
    var cvRank = (0,react.useMemo)(function () {
        if (!selectedCV) {
            return '';
        }
        return "".concat(t('Rank'), " #").concat(selectedCV.attributes.rank);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCV]);
    var onClickAIReview = function () {
        var showDialogSelectResume = function () {
            setShow(true);
            setShowBanner(false);
        };
        tracking({
            eventName: 'js_cv_review:click_use'
        });
        if (!(user === null || user === void 0 ? void 0 : user.accessToken)) {
            // Not logged in? Then show login modal
            // and callback to show dialog select resume
            showLogin({
                langCode: langCode,
                onLoggedIn: showDialogSelectResume
            });
            return;
        }
        // Show dialog select resume
        showDialogSelectResume();
    };
    var onClickViewReview = function (e) {
        e.stopPropagation();
        var url = "".concat(t('/cv-review'), "/").concat(selectedCV === null || selectedCV === void 0 ? void 0 : selectedCV.attributes.soNo);
        window.location.assign(url);
    };
    (0,react.useEffect)(function () {
        if (cvReviews.length > 0) {
            setSelectedCVId(cvReviews[0].attributes.soNo);
        }
    }, [cvReviews]);
    return (react.createElement(react.Fragment, null,
        react.createElement(AIBanner_css_CustomPopup, { isShow: showBanner, lang: langCode, custom: { header: react.createElement(react.Fragment, null), footer: react.createElement(react.Fragment, null), isPopupCenter: true }, onClickOutside: function () { return setShowBanner(false); } },
            react.createElement(AiReviewBlockWrapper, { id: 'AI-Review' },
                react.createElement(AIReviewHeader, null,
                    react.createElement("div", null,
                        react.createElement(Typography/* default */.Z, { name: 'title', size: 'large', color: '#fff' }, t('Competitive Analysis')),
                        react.createElement(Typography/* default */.Z, { name: 'label', size: 'small', color: '#fff', style: { marginTop: 8 } },
                            react.createElement(AiTagIcon$1, { style: { marginRight: 4 } }),
                            "VietnamWorks AI")),
                    react.createElement(Button/* default */.Z, { className: 'close-btn', isRounded: true, isIcon: true, type: 'opacity', onClick: function () { return setShowBanner(false); } },
                        react.createElement(CloseIcon/* default */.Z, { fill: '#fff' }))),
                react.createElement(AIReviewBody, { imageUrl: encodeURI("".concat(baseImageUrl, "/images/ai_cv_review_bg_2.png")) }, cvReviews.length === 0 ? (react.createElement(react.Fragment, null,
                    react.createElement(AIReviewContent, null,
                        react.createElement(TextPreview, null,
                            react.createElement(PreviewList, null,
                                react.createElement("li", null,
                                    react.createElement(AIPeopleIcon, null),
                                    (0,helpers/* isMobile */.tq)()
                                        ? t('How you match this job?')
                                        : t('What percentage are you suitable for this position?')),
                                react.createElement("li", null,
                                    react.createElement(AILeaderboardIcon, null),
                                    (0,helpers/* isMobile */.tq)()
                                        ? t('Your ranking vs. other application?')
                                        : t('What is your ranking compared to other applicants?')),
                                react.createElement("li", null,
                                    react.createElement(AIMoneyStackIcon, null),
                                    (0,helpers/* isMobile */.tq)()
                                        ? t('Market salary for this position?')
                                        : t('What is the market salary for similar positions?')),
                                react.createElement("li", null,
                                    react.createElement(AIComboChartIcon, null),
                                    (0,helpers/* isMobile */.tq)()
                                        ? t('Hiring demand for this position?')
                                        : t('Is the demand for this position on the market high or low?')))),
                        react.createElement(AiCVPreviewImage, (0,_tslib/* __assign */.pi)({}, props))),
                    react.createElement(AIReviewFooter, null,
                        react.createElement(AIReviewFooterItem, null,
                            react.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 4 } },
                                !(0,helpers/* isMobile */.tq)() && (react.createElement(Typography/* default */.Z, { name: 'body', size: 'small', color: '#fff' }, t('Price'))),
                                react.createElement(Typography/* default */.Z, { name: 'title', size: 'small', color: '#fff' },
                                    "29.000",
                                    react.createElement("u", null, "\u0111"),
                                    " / ",
                                    t('time'))),
                            (cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) ? (react.createElement(Typography/* default */.Z, { name: 'body', size: 'small', color: '#fff' }, (0,helpers/* isMobile */.tq)()
                                ? t('{0} free trial remaining').replace('{0}', cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial.toString())
                                : t('You have {0} free trial').replace('{0}', cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial.toString()))) : null),
                        react.createElement(ButtonAI, { onClick: onClickAIReview },
                            (cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) ? t('Try for free') : t('View analysis now'),
                            ' ',
                            !(0,helpers/* isMobile */.tq)() && react.createElement(CircleArrowRightIcon, null))))) : (react.createElement(AICVReview_css_ContentWrapper, null,
                    react.createElement(SelectResumeWrapper, null,
                        react.createElement(SelectResume, null,
                            react.createElement(MultipleRadio/* default */.Z, { name: 'select-resume-ai', options: optionAIResumes, value: selectedCVId, onChange: function (_a) {
                                    var value = _a.value;
                                    return setSelectedCVId(value);
                                }, customValue: function (value) {
                                    var selectedResumeInfo = cvReviews.filter(function (item) { return item.attributes.soNo === value.id; });
                                    var fileName = selectedResumeInfo.length > 0
                                        ? selectedResumeInfo[0].attributes.fileName
                                        : '';
                                    var createdOn = selectedResumeInfo.length > 0
                                        ? selectedResumeInfo[0].attributes.createdOn
                                        : '';
                                    return (react.createElement(LabelSelectResume, { fileName: fileName, createdOn: createdOn, t: t }));
                                }, dropdownStyle: {
                                    maxHeight: 400
                                }, dropdown: {
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true
                                    }
                                }, selectStyle: {
                                    height: 'auto',
                                    paddingRight: 12,
                                    borderRadius: 12
                                } })),
                        react.createElement(ButtonWrapper, null,
                            react.createElement(Button/* default */.Z, { type: 'highlight', outline: 'outline', onClick: function (e) { return onClickViewReview(e); } }, !(0,helpers/* isMobile */.tq)() ? t('See report') : react.createElement(EyesOpenIcon/* default */.Z, null)))),
                    react.createElement(ScoreWrapper, null,
                        react.createElement(ScoreItem, null,
                            react.createElement(JobFitIcon, { width: 36, height: 36 }),
                            react.createElement("div", null,
                                react.createElement(Typography/* default */.Z, { name: 'body', size: 'medium' }, t('Matching rate to job requirements')),
                                react.createElement(Typography/* default */.Z, { name: 'title', size: 'medium' }, cvScore))),
                        react.createElement(ScoreItem, null,
                            react.createElement(CandidateCompareIcon, { width: 36, height: 36 }),
                            react.createElement("div", null,
                                react.createElement(Typography/* default */.Z, { name: 'body', size: 'medium' }, t('Comparison with other applicants')),
                                react.createElement(Typography/* default */.Z, { name: 'title', size: 'medium' }, cvRank)))),
                    react.createElement(Row/* default */.Z, { style: { marginTop: 16 } },
                        react.createElement(Col/* default */.Z, { xs: 24 },
                            react.createElement(ButtonAI, { onClick: onClickAIReview, style: { width: '100%' } }, t('Evaluate another CV'))))))))),
        react.createElement(AIReviewCV, (0,_tslib/* __assign */.pi)({ showState: [isShow, setShow], accessToken: (_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '', baseMsUrl: baseMsUrl, baseUrl: baseUrl, isTrial: !!(cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial), numsOfTrial: Number(cvReviewTrial === null || cvReviewTrial === void 0 ? void 0 : cvReviewTrial.trial) }, props))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/translations.js
'use client';

var AIBanner_translations_translations = {
    'Do you want to see your competitive analysis?': 'Bạn muốn phân tích CV trước khi ứng tuyển?',
    'View competitive analysis before applying': 'Xem phân tích mức độ cạnh tranh trước khi ứng tuyển',
    'View competitive analysis': 'Xem phân tích mức độ cạnh tranh',
    'Competitive Analysis': 'Phân tích mức độ cạnh tranh',
    'What percentage are you suitable for this position?': 'Bạn phù hợp bao nhiêu % cho vị trí này?',
    'What is your ranking compared to other applicants?': 'Bạn xếp hạng Top bao nhiêu so với những hồ sơ ứng tuyển?',
    'What is the market salary for similar positions?': 'Thị trường đang trả mức lương bao nhiêu cho vị trí tương tự?',
    'Is the demand for this position on the market high or low?': 'Nhu cầu tuyển dụng cho vị trí này trên thị trường cao hay thấp?',
    'Trial price': 'Giá dùng thử',
    'View analysis now': 'Xem đánh giá ngay',
    '/cv-review': '/phan-tich-ho-so',
    'See report': 'Xem đánh giá',
    'Evaluated on': 'Đánh giá',
    'Matching rate to job requirements': 'Độ phù hợp với công việc',
    'Comparison with other applicants': 'So với ứng viên khác',
    'Evaluate another CV': 'Đánh giá hồ sơ khác',
    'You can use this feature multiple times with different CVs.': 'Bạn có thể sử dụng tính năng này nhiều lần với nhiều CV khác nhau.',
    time: 'lượt',
    High: 'Cao',
    Low: 'Thấp',
    Medium: 'Trung bình',
    'Very high': 'Rất cao',
    Rank: 'Xếp hạng',
    'Try for free': 'Dùng thử miễn phí',
    'You have {0} free trial': 'Bạn có {0} lần dùng thử miễn phí',
    '{0} free trial remaining': 'Còn {0} lần dùng thử',
    Price: 'Giá',
    'View analysis': 'Xem phân tích',
    'How you match this job?': 'Bạn phù hợp bao nhiêu %?',
    'Your ranking vs. other application?': 'Xếp hạng so với ứng viên khác?',
    'Market salary for this position?': 'Mức lương thị trường đang trả?',
    'Hiring demand for this position?': 'Nhu cầu tuyển dụng của ngành?'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/services.js
'use client';



var getCVReviews = function (jobId, accessToken, baseMsUrl) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var apiUrl, res, response, e_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiUrl = "".concat(baseMsUrl, "/api-gateway/v1.0/ai-resume-review?jobId=").concat(jobId);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    })];
            case 2:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 4];
                return [4 /*yield*/, res.json()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 4: return [2 /*return*/, []];
            case 5:
                e_1 = _a.sent();
                console.log('error', e_1);
                return [2 /*return*/, []];
            case 6: return [2 /*return*/];
        }
    });
}); };
function getAITrial(_a) {
    var _b;
    var baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, responseData, error_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/api-gateway/v1.0/buy-package/count-trial-car-package"), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _c.sent();
                    if (responseData.data) {
                        return [2 /*return*/, {
                                trial: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _b === void 0 ? void 0 : _b.trial
                            }];
                    }
                    return [2 /*return*/, null];
                case 3:
                    error_1 = _c.sent();
                    console.error('error', error_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBanner/index.js
'use client';



























































































































































var AIBanner = function (props) {
    var user = props.user, job = props.job, _a = props.type, type = _a === void 0 ? 'text' : _a, env = props.env, langCode = props.langCode, text = props.text;
    var baseMsUrl = env.baseMsUrl;
    var _b = (0,react.useState)([]), cvReviews = _b[0], setCvReviews = _b[1];
    var _c = (0,react.useState)(null), cvReviewTrial = _c[0], setCvReviewTrial = _c[1];
    var _d = (0,react.useState)(false), showBanner = _d[0], setShowBanner = _d[1];
    var t = function (key) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return key;
        }
        else {
            return AIBanner_translations_translations[key] || key;
        }
    };
    var getReviewTrial = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var cvReviewPromise, cvReviewTrialPromise, response;
        var _a;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cvReviewPromise = getCVReviews(job.jobId, (_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '', baseMsUrl);
                    cvReviewTrialPromise = getAITrial({
                        accessToken: String(user === null || user === void 0 ? void 0 : user.accessToken),
                        baseMsUrl: baseMsUrl
                    });
                    return [4 /*yield*/, Promise.allSettled([cvReviewPromise, cvReviewTrialPromise])
                        // Get CV Reviews
                    ];
                case 1:
                    response = _b.sent();
                    // Get CV Reviews
                    setCvReviews(response[0].status === 'fulfilled' ? response[0].value : []);
                    // Get AI CV Review trial
                    setCvReviewTrial(response[1].status === 'fulfilled' ? response[1].value : null);
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        getReviewTrial();
    }, []);
    return (react.createElement(AIBannerContainer, null,
        type === 'text' && (react.createElement(TextAI.Container, null,
            react.createElement(AiIcon$1, { width: 20 }),
            react.createElement(TextAI.Content, { onClick: function () { return setShowBanner(true); } }, text || t('View competitive analysis')))),
        type === 'block' && (react.createElement(BlockAI.Container, { onClick: function () { return setShowBanner(true); } },
            react.createElement(BlockAI.Left, null,
                react.createElement(BlockAI.Title, null, t('Competitive Analysis')),
                react.createElement(BlockAI.BlockAIText, null,
                    react.createElement(MiniAiIcon, null),
                    " VietnamWorks AI")),
            react.createElement(BlockAI.Right, null,
                react.createElement(AIBannerButton, null,
                    t('View analysis'),
                    react.createElement(CircleArrowRightIcon, { width: 24 })),
                react.createElement(AiIcon$1, { width: 58, type: 'secondary' })))),
        react.createElement(AIReviewBlock, (0,_tslib/* __assign */.pi)({ cvReviews: cvReviews, cvReviewTrial: cvReviewTrial, t: t, showBannerState: [showBanner, setShowBanner] }, props))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBeforeApply/translations.js
'use client';

var AIBeforeApply_translations_translations = {
    'View analysis before applying': 'Xem phân tích trước khi ứng tuyển',
    'Continue applying': 'Tiếp tục ứng tuyển',
    'Maximize your competitive advantage before applying': 'Tối ưu lợi thế cạnh tranh trước khi ứng tuyển',
    'Maximize your competitive advantage with VietnamWorks AI before applying': 'Tối ưu lợi thế cạnh tranh trước khi ứng tuyển cùng VietnamWorks AI',
    "Assess matching rate from employer's viewpoint": 'Đánh giá mức độ phù hợp với góc nhìn của nhà tuyển dụng',
    'Suggest to improve the matching': 'Gợi ý cách cải thiện mức độ phù hợp',
    'Analyze the profiles of applicants': 'Phân tích hồ sơ của các ứng viên đã nộp đơn',
    'Check salary reference and hiring demand': 'Tham khảo mức lương và nhu cầu tuyển dụng',
    'Explore the': 'Khám phá ngay',
    'Competitive analysis report': 'Báo cáo phân tích mức độ cạnh tranh',
    'now to get closer to your dream job!': 'để tiến gần hơn đến công việc mơ ước!',
    'View analysis to maximize now': 'Xem phân tích để tối ưu ngay',
    'Do you want to maximize competitive advantage before applying?': 'Bạn có muốn tối ưu lợi thế cạnh tranh trước khi ứng tuyển?'
};


//# sourceMappingURL=translations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/StarBurstIcon/index.js
'use client';



var StarBurstIcon = function () {
    return (react.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
        react.createElement("g", { clipPath: 'url(#clip0_37944_279674)' },
            react.createElement("path", { d: 'M15.9435 5.79841C15.9144 5.67041 15.8098 5.57313 15.6798 5.55329L11.4002 4.89953L11.715 0.581766C11.7246 0.450566 11.653 0.327366 11.5349 0.270086C11.4162 0.212806 11.2754 0.234246 11.1787 0.323526L7.9992 3.26177L4.81968 0.323526C4.72304 0.234246 4.58192 0.213126 4.46352 0.270086C4.34512 0.327046 4.27376 0.450566 4.28336 0.581766L4.59824 4.89953L0.318558 5.55329C0.188638 5.57313 0.083998 5.67041 0.054878 5.79841C0.025758 5.92641 0.077598 6.05953 0.186078 6.13377L3.75824 8.57985L1.60112 12.3334C1.53552 12.4474 1.54672 12.5898 1.62832 12.6925C1.70992 12.7952 1.84592 12.8374 1.97232 12.799L6.11184 11.5312L7.7016 15.5578C7.74992 15.68 7.868 15.7603 7.9992 15.7603C8.1304 15.7603 8.24848 15.68 8.2968 15.5578L9.88656 11.5309L14.0261 12.7987C14.1515 12.8371 14.2882 12.7952 14.3701 12.6922C14.452 12.5894 14.4629 12.447 14.3973 12.3331L12.2402 8.57953L15.8123 6.13345C15.9208 6.05953 15.9726 5.92641 15.9435 5.79841Z', fill: 'url(#paint0_linear_37944_279674)' })),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: 'paint0_linear_37944_279674', x1: '0.046875', y1: '7.9993', x2: '15.9515', y2: '7.9993', gradientUnits: 'userSpaceOnUse' },
                react.createElement("stop", { stopColor: '#FE8323' }),
                react.createElement("stop", { offset: '0.5', stopColor: '#FF3C68' }),
                react.createElement("stop", { offset: '0.75', stopColor: '#DC1EAF' }),
                react.createElement("stop", { offset: '1', stopColor: '#B300D7' })),
            react.createElement("clipPath", { id: 'clip0_37944_279674' },
                react.createElement("rect", { width: '16', height: '16', fill: 'white' })))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBeforeApply/AIBeforeApply.css.js
'use client';






var AIBeforeApplyTypo = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(AIBeforeApply_css_templateObject_1 || (AIBeforeApply_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    span {\n        font-weight: 500;\n    }\n"], ["\n    span {\n        font-weight: 500;\n    }\n"])));
var AIBeforeApplyContainer = styled_components_browser_esm/* default.div */.ZP.div(AIBeforeApply_css_templateObject_2 || (AIBeforeApply_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    ul.list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        li {\n            display: flex;\n            align-items: center;\n            margin-bottom: 16px;\n            svg {\n                margin-right: 8px;\n            }\n        }\n    }\n"], ["\n    padding: 16px;\n    ul.list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        li {\n            display: flex;\n            align-items: center;\n            margin-bottom: 16px;\n            svg {\n                margin-right: 8px;\n            }\n        }\n    }\n"])));
var AIBeforeApply_css_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(AIBeforeApply_css_templateObject_3 || (AIBeforeApply_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: center;\n    margin-bottom: 16px;\n"], ["\n    text-align: center;\n    margin-bottom: 16px;\n"])));
var ListWrapper = styled_components_browser_esm/* default.div */.ZP.div(AIBeforeApply_css_templateObject_4 || (AIBeforeApply_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px 24px;\n"], ["\n    padding: 16px 24px;\n"])));
var AIBeforeApply_css_CTAWrapper = styled_components_browser_esm/* default.div */.ZP.div(AIBeforeApply_css_templateObject_5 || (AIBeforeApply_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n    border-top: 1px solid ", ";\n"], ["\n    padding: 24px;\n    border-top: 1px solid ", ";\n"])), Colors/* colors.grey.95 */.O9.grey[95]);
var AIBeforeApply_css_templateObject_1, AIBeforeApply_css_templateObject_2, AIBeforeApply_css_templateObject_3, AIBeforeApply_css_templateObject_4, AIBeforeApply_css_templateObject_5;


//# sourceMappingURL=AIBeforeApply.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/AIBeforeApply/index.js
'use client';













var AIBeforeApply = function (props) {
    var imageUrl = props.imageUrl, langCode = props.langCode, onContinueApply = props.onContinueApply, onViewAnalysis = props.onViewAnalysis;
    var _a = props.showState, isShow = _a[0], setIsShow = _a[1];
    var t = (0,react.useCallback)(function (text) {
        var _a;
        if (langCode === constants/* ELanguage.VI */.Df.VI) {
            return (_a = AIBeforeApply_translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [langCode]);
    return (react.createElement(Popup/* default */.Z, { isShow: isShow, lang: langCode, styleOption: {
            size: 'md',
            headerBg: 'linear-gradient(269deg, #B900F6 0.91%, #DC1EAF 23.38%, #FF6200 45.85%, #FDB92E 92.62%)',
            headerTextColor: '#fff',
            isHaveBorder: false,
            closeIconColor: '#fff'
        }, custom: {
            footer: (react.createElement(AIBeforeApply_css_CTAWrapper, null,
                react.createElement(Row/* default */.Z, { gutter: [0, 8], justify: 'end' },
                    react.createElement(Col/* default */.Z, { xs: 'auto' },
                        react.createElement(Button/* default */.Z, { type: 'ai', outline: 'outline', onClick: function () { return onViewAnalysis && onViewAnalysis(); } }, t('View analysis to maximize now'))),
                    react.createElement(Col/* default */.Z, { xs: 'auto' },
                        react.createElement(ButtonAI, { onClick: function () { return onContinueApply && onContinueApply(); } }, t('Continue applying'))))))
        }, text: {
            header: t('Do you want to maximize competitive advantage before applying?')
        }, onClickOutside: function () { return setIsShow(false); }, onClose: function () { return onContinueApply && onContinueApply(); } },
        react.createElement(AIBeforeApplyContainer, null,
            react.createElement(AIBeforeApply_css_ImageWrapper, null,
                react.createElement("img", { src: "".concat(imageUrl, "/images/AI-review-before-apply.png"), alt: t('Maximize your competitive advantage with VietnamWorks AI before applying') })),
            react.createElement(ListWrapper, null,
                react.createElement(Typography/* default */.Z, { name: 'body', size: 'large', style: { marginBottom: '16px' } }, t('Maximize your competitive advantage with VietnamWorks AI before applying')),
                react.createElement("ul", { className: 'list' },
                    react.createElement("li", null,
                        react.createElement(StarBurstIcon, null),
                        ' ',
                        react.createElement(Typography/* default */.Z, { name: 'body', size: 'large' }, t("Assess matching rate from employer's viewpoint"))),
                    react.createElement("li", null,
                        react.createElement(StarBurstIcon, null),
                        ' ',
                        react.createElement(Typography/* default */.Z, { name: 'body', size: 'large' }, t('Suggest to improve the matching'))),
                    react.createElement("li", null,
                        react.createElement(StarBurstIcon, null),
                        ' ',
                        react.createElement(Typography/* default */.Z, { name: 'body', size: 'large' }, t('Analyze the profiles of applicants'))),
                    react.createElement("li", null,
                        react.createElement(StarBurstIcon, null),
                        ' ',
                        react.createElement(Typography/* default */.Z, { name: 'body', size: 'large' }, t('Check salary reference and hiring demand')))),
                react.createElement(AIBeforeApplyTypo, { size: 'large', name: 'body' },
                    t('Explore the'),
                    " ",
                    react.createElement("span", null, t('Competitive analysis report')),
                    ' ',
                    t('now to get closer to your dream job!'))))));
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/FormComponent/ContentEditable/index.js
'use client';





var StyledDiv = styled_components_browser_esm/* default.div */.ZP.div(ContentEditable_templateObject_1 || (ContentEditable_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100px;\n    padding: 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #333;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    overflow-y: auto;\n    outline: none;\n    transition: all 0.3s;\n    background: white;\n    word-break: break-word;\n\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n\n    &:focus {\n        box-shadow: rgb(226, 226, 226) 0px 0px 0px 3px;\n        outline: none;\n    }\n    @media all and (max-width: 991px) {\n        font-size: 16px;\n    }\n"], ["\n    width: 100%;\n    height: 100px;\n    padding: 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #333;\n    border: 1px solid ", ";\n    border-radius: 3px;\n    overflow-y: auto;\n    outline: none;\n    transition: all 0.3s;\n    background: white;\n    word-break: break-word;\n\n    &:hover,\n    &:focus {\n        border: 1px solid ", ";\n    }\n\n    &:focus {\n        box-shadow: rgb(226, 226, 226) 0px 0px 0px 3px;\n        outline: none;\n    }\n    @media all and (max-width: 991px) {\n        font-size: 16px;\n    }\n"])), function (props) { return (props.hasError ? '#f85a5a' : '#ccc'); }, function (props) { return (props.hasError ? '#f85a5a' : '#FF7D55'); });
var StyledLabel = styled_components_browser_esm/* default.div */.ZP.div(ContentEditable_templateObject_2 || (ContentEditable_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    display: inline-block;\n    color: #333;\n    font-weight: 600;\n    font-size: 13px;\n"], ["\n    margin-bottom: 4px;\n    display: inline-block;\n    color: #333;\n    font-weight: 600;\n    font-size: 13px;\n"])));
function ContentEditable(_a) {
    var value = _a.value, onChange = _a.onChange, hasError = _a.hasError, label = _a.label, isRequired = _a.isRequired, name = _a.name, onEditableChange = _a.onEditableChange;
    var valueRef = (0,react.useRef)(value);
    return (react.createElement("div", null,
        label && (react.createElement(StyledLabel, null,
            react.createElement("label", { htmlFor: name },
                isRequired && react.createElement("span", { className: 'text-danger' }, "*"),
                " ",
                label))),
        react.createElement(StyledDiv, { contentEditable: true, dangerouslySetInnerHTML: { __html: valueRef.current }, hasError: hasError || false, onInput: function (e) {
                var target = e.target;
                if (onChange) {
                    onChange(target.innerHTML);
                }
                if (onEditableChange) {
                    onEditableChange(target.innerHTML, target.innerText);
                }
            }, id: name })));
}
var ContentEditable_templateObject_1, ContentEditable_templateObject_2;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/index.js
'use client';






















































































































































































/**
 * Don't import ReferralButton here regarding it cause "document is not defined" issue on NextJS projects.
 * e.g. microfrontends/referral-candidate
 *
 * @author Tuan, Phan Thanh
 * @since 27 Jul, 2022
 */
var components_Colors = {
    text: constants/* colors.textColor */.O9.textColor,
    textPlaceholder: constants/* colors.textPlaceholder */.O9.textPlaceholder,
    textGray: constants/* colors.textGrayColor */.O9.textGrayColor,
    primary: constants/* colors.primaryColor */.O9.primaryColor,
    secondary: constants/* colors.secondaryColor */.O9.secondaryColor,
    button: constants/* colors.buttonColor */.O9.buttonColor,
    info: constants/* colors.infoColor */.O9.infoColor,
    success: constants/* colors.successColor */.O9.successColor,
    danger: constants/* colors.dangerColor */.O9.dangerColor,
    highlight: constants/* colors.highlightColor */.O9.highlightColor,
    darkBlue: constants/* colors.darkBlueColor */.O9.darkBlueColor,
    bgNormal: constants/* colors.bgNormal */.O9.bgNormal,
    bgHover: constants/* colors.bgHover */.O9.bgHover,
    bgError: constants/* colors.bgError */.O9.bgError,
    bgDisable: constants/* colors.bgDisable */.O9.bgDisable,
    bgHeader: constants/* colors.bgHeader */.O9.bgHeader,
    borderNormal: constants/* colors.borderNormal */.O9.borderNormal,
    borderHover: constants/* colors.borderHover */.O9.borderHover,
    borderFocus: constants/* colors.borderFocus */.O9.borderFocus,
    borderError: constants/* colors.borderError */.O9.borderError,
    borderDisable: constants/* colors.borderDisable */.O9.borderDisable,
    borderCard: constants/* colors.borderCard */.O9.borderCard,
    cardShadow: constants/* colors.cardShadow */.O9.cardShadow,
    tagSelect: constants/* colors.tagSelect */.O9.tagSelect,
    tagSelectBorder: constants/* colors.tagSelectBorder */.O9.tagSelectBorder,
    tagHover: constants/* colors.tagHover */.O9.tagHover
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vw": function() { return /* binding */ applySuccessLink; },
/* harmony export */   "ki": function() { return /* binding */ createFormData; },
/* harmony export */   "zj": function() { return /* binding */ getJobUrlParams; }
/* harmony export */ });
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55613);
'use client';



function createFormData(body) {
    var formData = new FormData();
    for (var _i = 0, _a = Object.entries(body); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (key && value !== null && value !== undefined) {
            formData.append(key, value);
        }
    }
    return formData;
}
var getJobUrlParams = function (link) {
    if (!link)
        return '';
    var urlSearch = link.split('?');
    if (!urlSearch || urlSearch.length < 1)
        return '';
    return urlSearch[1];
};
var applySuccessLink = function (baseUrl, t, jobInfo) {
    if (typeof window === undefined)
        return;
    var searchParams = new URLSearchParams(window.location.href);
    var isHaveCompetitiveParam = !!searchParams.has('applycompetitive');
    var alias = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.alias) || (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .lV)((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobTitle) || '');
    var link = "".concat(baseUrl).concat(t('/success-apply'), "/").concat(alias, "-").concat(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId).concat(isHaveCompetitiveParam ? '?applycompetitive' : '');
    return link;
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 10650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ applyJobs; },
  "B": function() { return /* binding */ matchingJobAPI; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ApplyJobsModal/helper.js
var helper = __webpack_require__(63235);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/const.js
'use client';

var APPLY_MULTIPLE = 'api-gateway/v2.0/job/apply-multiple';
var MATCHING_JOB_URI = 'api-gateway/v1.0/profile/matching-job';


//# sourceMappingURL=const.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/helper.js
var jobs_helper = __webpack_require__(4488);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/services/jobs/index.js
'use client';








// https://staging-ms.vietnamworks.com/api-gateway/v1.0/job/apply-multiple
function applyJobs(baseUrl, accessToken, body, langCode, queryString) {
    var _a, _b, _c, _d;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var formData, headerUtmsGAfirst, headderUtmsGA, query, response, json, applyJobRes, data, msg, error_1, data;
        return (0,_tslib/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 4]);
                    formData = (0,jobs_helper/* createFormData */.ki)(body);
                    headerUtmsGAfirst = (_a = (0,helper/* getUTMTracking */.yC)()) === null || _a === void 0 ? void 0 : _a.headerUtmsGAfirst;
                    headderUtmsGA = (_b = (0,helper/* getUTMTracking */.yC)()) === null || _b === void 0 ? void 0 : _b.headderUtmsGA;
                    query = queryString ? "?".concat(queryString) : '';
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(APPLY_MULTIPLE).concat(query), {
                            method: 'POST',
                            headers: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({ Authorization: "Bearer ".concat(accessToken), Accept: 'multipart/form-data', 'X-Requested-With': 'XMLHttpRequest', 'X-Tracking-Single-Apply': 'true', 'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : constants/* ELanguage.VI */.Df.VI }, headderUtmsGA), headerUtmsGAfirst),
                            body: formData
                        })];
                case 1:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _e.sent();
                    if (json.data) {
                        applyJobRes = JSON.parse((_c = json.data) !== null && _c !== void 0 ? _c : '{}');
                        if (applyJobRes.code === 500) {
                            return [2 /*return*/, new model/* default */.Z({
                                    error: {
                                        message: applyJobRes.message,
                                        status: 500
                                    }
                                })];
                        }
                        if (applyJobRes.code === 'SY01') {
                            return [2 /*return*/, new model/* default */.Z({
                                    error: {
                                        message: applyJobRes.message,
                                        status: 500
                                    }
                                })];
                        }
                        return [2 /*return*/, applyJobRes];
                    }
                    if (!json.data) {
                        data = void 0;
                        if (json.error === 'bad request') {
                            data = {
                                data: {
                                    ERR_SYSTEM_BAD_REQUEST: 'ERR_SYSTEM_BAD_REQUEST'
                                },
                                error: {
                                    message: langCode === constants/* ELanguage.EN */.Df.EN
                                        ? 'Sorry, there were some technical issues while processing your request. Please wait 5 minutes and try again or contact us.'
                                        : 'Đã có sự cố kỹ thuật trong khi xử lý yêu cầu của bạn. Vui lòng chờ 5 phút và thử lại hoặc liên hệ với chúng tôi để được hỗ trợ.',
                                    status: 400
                                }
                            };
                            return [2 /*return*/, new model/* default */.Z(data)];
                        }
                        if ((json === null || json === void 0 ? void 0 : json.success) === false && (json === null || json === void 0 ? void 0 : json.message)) {
                            msg = JSON.parse((_d = json === null || json === void 0 ? void 0 : json.message) !== null && _d !== void 0 ? _d : '{}');
                            data = {
                                data: {
                                    ERR_SYSTEM_BAD_REQUEST: 'ERR_SYSTEM_BAD_REQUEST'
                                },
                                error: {
                                    message: msg === null || msg === void 0 ? void 0 : msg.message,
                                    status: 400
                                }
                            };
                            return [2 /*return*/, new model/* default */.Z(data)];
                        }
                    }
                    return [2 /*return*/, null];
                case 3:
                    error_1 = _e.sent();
                    console.error(error_1);
                    if (error_1.message === 'Timeout' ||
                        error_1.message === 'Network request failed' ||
                        error_1.message === 'Failed to fetch') {
                        data = {
                            data: {
                                ERR_INTERNET_DISCONNECTED: 'ERR_INTERNET_DISCONNECTED'
                            },
                            error: {
                                message: langCode === constants/* ELanguage.EN */.Df.EN
                                    ? 'No internet connection. Please check your internet connection and try again.'
                                    : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.',
                                status: 503
                            }
                        };
                        return [2 /*return*/, new model/* default */.Z(data)];
                    }
                    return [2 /*return*/, new model/* default */.Z(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function matchingJobAPI(data) {
    var _a;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, result, e_1;
        return (0,_tslib/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(data.baseUrl, "/").concat(MATCHING_JOB_URI), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': (_a = data.langCode) !== null && _a !== void 0 ? _a : constants/* ELanguage.VI */.Df.VI,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(data.body)
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    return [2 /*return*/, result];
                case 3:
                    e_1 = _b.sent();
                    console.log('matchingJob: ', e_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/, null];
            }
        });
    });
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModelError; }
/* harmony export */ });
'use client';

var ModelError = /** @class */ (function () {
    function ModelError(data) {
        Object.assign(this, data);
    }
    return ModelError;
}());


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 14313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ PROFILE_COOKIE; },
/* harmony export */   "LB": function() { return /* binding */ JOBLEVEL; },
/* harmony export */   "M7": function() { return /* binding */ SEARCHABLE; },
/* harmony export */   "Ri": function() { return /* binding */ DEFAULT_ALLOW_FILES_EXT; },
/* harmony export */   "Sl": function() { return /* binding */ ENDPOINT_UPDATE_RESUME_FILE; },
/* harmony export */   "TW": function() { return /* binding */ PROFILE_LEVEL; },
/* harmony export */   "Wx": function() { return /* binding */ DEFAULT_ALLOW_EXT; },
/* harmony export */   "_y": function() { return /* binding */ BASIC_INFO_V2; },
/* harmony export */   "bg": function() { return /* binding */ ATTACHED_RESUME_VALIDATE; },
/* harmony export */   "c0": function() { return /* binding */ USER_SKILL; },
/* harmony export */   "fL": function() { return /* binding */ CHANGE_PHONE_NUMBER; },
/* harmony export */   "fc": function() { return /* binding */ REFRESH_PROFILE; },
/* harmony export */   "gy": function() { return /* binding */ BASIC_INFO; },
/* harmony export */   "hS": function() { return /* binding */ DEFAULT_LIMIT_FILE_SIZE; },
/* harmony export */   "se": function() { return /* binding */ DEFAULT_SUCCESS_CODE; },
/* harmony export */   "t2": function() { return /* binding */ CHANGE_JOB_TITLE; },
/* harmony export */   "uS": function() { return /* binding */ RESUME_SETTING_INFO; },
/* harmony export */   "xB": function() { return /* binding */ SKILL_TAGS; }
/* harmony export */ });
'use client';

var CHANGE_JOB_TITLE = 'api-gateway/v1.0/profile/job-title';
var CHANGE_PHONE_NUMBER = 'api-gateway/v1.0/profile/change-phone';
var ATTACHED_RESUME_VALIDATE = 'attached-resumes-validation/v1/validate-resume';
var ENDPOINT_UPDATE_RESUME_FILE = 'profile/update-resume-file';
var PROFILE_LEVEL = 'api-gateway/v1.0/profile/level';
var RESUME_SETTING_INFO = 'api-gateway/v2.0/profile/resume-setting-info';
var JOBLEVEL = 'meta/v1.0/job-levels';
var BASIC_INFO = 'api-gateway/v1.0/profile/basic-info';
var SEARCHABLE = 'api-gateway/v1.0/profile/resume-change-searchable';
var PROFILE_COOKIE = 'api-gateway/v1.0/profile/cookie';
var SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion';
var REFRESH_PROFILE = 'api-gateway/v1.0/profile/refresh-profile';
var USER_SKILL = 'api-gateway/v1.0/profile/skill';
var BASIC_INFO_V2 = 'api-gateway/v2.0/profile/info';
var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var DEFAULT_SUCCESS_CODE = 200;


//# sourceMappingURL=const.js.map


/***/ }),

/***/ 93843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ validateFile; },
/* harmony export */   "MU": function() { return /* binding */ updateSkills; },
/* harmony export */   "Mz": function() { return /* binding */ getProfileLevel; },
/* harmony export */   "S3": function() { return /* binding */ makeRefreshProfile; },
/* harmony export */   "SM": function() { return /* binding */ getSkills; },
/* harmony export */   "Sl": function() { return /* binding */ changePhoneNumber; },
/* harmony export */   "Z0": function() { return /* binding */ getResumeSettingInfo; },
/* harmony export */   "ZR": function() { return /* binding */ makeSearchable; },
/* harmony export */   "cT": function() { return /* binding */ uploadFile; },
/* harmony export */   "e1": function() { return /* binding */ getJobLevelList; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "mL": function() { return /* binding */ updateBasicInfo; },
/* harmony export */   "tE": function() { return /* binding */ changeJobTitle; },
/* harmony export */   "w9": function() { return /* binding */ updateProfileCookie; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96306);
/* harmony import */ var _Utils_urlBuilder_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60332);
/* harmony import */ var _model_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90222);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14313);
/* harmony import */ var _Utils_time_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56665);
'use client';








function changeJobTitle(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, err_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_JOB_TITLE */ .t2), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                jobTitle: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function changePhoneNumber(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, err_2;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_PHONE_NUMBER */ .fL), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                phone: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var uploadFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, resumeId = _a.resumeId, apiUploadVersion = _a.apiUploadVersion, action = _a.action;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var errorSystem, formData, endPointUploadResumeFile, response, responeJson, error_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorSystem = new _model_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z({
                        data: file,
                        error: {
                            details: {
                                ERROR_UPLOAD: langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.EN */ .Df.EN ? "Can't not upload file" : 'Không thể tải tệp lên'
                            },
                            message: langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.EN */ .Df.EN ? "Can't not upload file" : 'Không thể tải tệp lên',
                            status: 500
                        }
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    if (resumeId && resumeId > 0) {
                        formData.append('resume_id', resumeId.toString());
                        // When resumeId is provided it always replaced
                        formData.append('is_replaced', 'true');
                    }
                    // Action=1 param is used for by-pass old parsing cv flow
                    if (action) {
                        formData.append('action', action.toString());
                    }
                    endPointUploadResumeFile = "api-gateway/".concat(apiUploadVersion, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .ENDPOINT_UPDATE_RESUME_FILE */ .Sl);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(endPointUploadResumeFile), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    responeJson = _b.sent();
                    if (!responeJson.data) {
                        if (responeJson.Message || responeJson.Status === 400) {
                            return [2 /*return*/, new _model_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z({
                                    data: file,
                                    error: {
                                        details: {
                                            ERROR_UPLOAD: responeJson.Message
                                        },
                                        message: responeJson.Message,
                                        status: responeJson.Status
                                    }
                                })];
                        }
                        return [2 /*return*/, errorSystem];
                    }
                    return [2 /*return*/, responeJson];
                case 4:
                    error_1 = _b.sent();
                    console.error('apiDoUpload ', error_1);
                    return [2 /*return*/, errorSystem];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var validateFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, userId = _a.userId, jobId = _a.jobId;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var formData, response, data, error_2, data;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('jobId', jobId ? String(jobId) : '0');
                    formData.append('jobseekerId', userId ? String(userId) : '0');
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .ATTACHED_RESUME_VALIDATE */ .bg), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_2 = _b.sent();
                    console.error('apiDoValidate ', error_2);
                    data = {
                        meta: {
                            statusCode: 413,
                            message: langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                                ? 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'
                                : '.doc, .docx and .pdf files that are less than 5120KB in size'
                        }
                    };
                    return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getProfileLevel(accessToken, langCode, baseUrl) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, data, err_3;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_LEVEL */ .TW), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getResumeSettingInfo(accessToken, baseUrl, langCode) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, err_4;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .RESUME_SETTING_INFO */ .uS, "?date=").concat(Date.now()), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    err_4 = _a.sent();
                    console.error(err_4);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var getJobLevelList = function (langCode, baseMsUrl) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var response, dataJs, relationships, err_5;
    var _a, _b;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .JOBLEVEL */ .LB), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                dataJs = _c.sent();
                relationships = (_a = dataJs === null || dataJs === void 0 ? void 0 : dataJs.data) === null || _a === void 0 ? void 0 : _a.relationships;
                if ((relationships === null || relationships === void 0 ? void 0 : relationships.data) && ((_b = relationships === null || relationships === void 0 ? void 0 : relationships.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return [2 /*return*/, relationships.data];
                }
                return [2 /*return*/, null];
            case 3:
                err_5 = _c.sent();
                console.error(err_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateProfileCookie = function (baseUrl, accessToken, body, langCode) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var response, error_3;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_COOKIE */ .BN), {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error(error_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
function makeSearchable(baseUrl, accessToken, body, langCode) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, data, err_6;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCHABLE */ .M7), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_6 = _a.sent();
                    console.error(err_6);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var makeRefreshProfile = function (baseMsUrl, accessToken, body, langCode) {
    if (langCode === void 0) { langCode = _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response, data, e_1, error;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .REFRESH_PROFILE */ .fc), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    e_1 = _a.sent();
                    error = {
                        details: {
                            RESFRESH_PROFILE: 'ERROR_RESFRESH_PROFILE'
                        },
                        message: 'bad request',
                        status: 400
                    };
                    return [2 /*return*/, new _model_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z({ data: e_1, error: error })];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getSkills(baseUrl, accessToken, searchKeywork, selectedSkills, limit, lang) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var queryParams, response, jsonData, error_4;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    queryParams = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ query: searchKeywork }, (!selectedSkills ? undefined : { selectedSkill: selectedSkills.join('|') })), (!limit ? undefined : { limit: limit }));
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .SKILL_TAGS */ .xB, "?").concat((0,_Utils_urlBuilder_js__WEBPACK_IMPORTED_MODULE_4__/* .objToQueryStr */ .G7)(queryParams)), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': lang !== null && lang !== void 0 ? lang : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    jsonData = _a.sent();
                    return [2 /*return*/, jsonData.data];
                case 3: throw response;
                case 4:
                    error_4 = _a.sent();
                    console.log(error_4);
                    return [2 /*return*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function updateBasicInfo(baseUrl, accessToken, body, langCode) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, data, err_7;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .BASIC_INFO */ .gy), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_7 = _a.sent();
                    console.error(err_7);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function updateSkills(baseMsUrl, accessToken, body, langCode, method) {
    if (method === void 0) { method = 'POST'; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, error_5;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .USER_SKILL */ .c0), {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_5 = _a.sent();
                    console.error(error_5);
                    return [2 /*return*/, {
                            errorCode: '',
                            message: '',
                            showMessage: true
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getUserProfile(accessToken, baseMsUrl, langCode) {
    var _a, _b;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var response, responseData, userProfileInfo, error_6;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(_const_js__WEBPACK_IMPORTED_MODULE_1__/* .BASIC_INFO_V2 */ ._y), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : _Utils_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _c.sent();
                    userProfileInfo = (_a = responseData.data) === null || _a === void 0 ? void 0 : _a.attributes;
                    if (userProfileInfo && userProfileInfo.birthday) {
                        userProfileInfo.birthday = (0,_Utils_time_js__WEBPACK_IMPORTED_MODULE_5__/* .formatInvalidDate */ .QE)(userProfileInfo.birthday, 'YYYY-MM-DD HH:MM:SS');
                    }
                    if (!userProfileInfo) {
                        return [2 /*return*/, new _model_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z({
                                data: null,
                                error: {
                                    details: {
                                        ERROR: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.data) !== null && _b !== void 0 ? _b : ''
                                    },
                                    message: response.statusText,
                                    status: response.status
                                }
                            })];
                    }
                    return [2 /*return*/, userProfileInfo];
                case 3:
                    error_6 = _c.sent();
                    throw new _model_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(error_6);
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 53877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bf": function() { return /* binding */ EApplyType; },
/* harmony export */   "cz": function() { return /* binding */ EOnOffStatus; },
/* harmony export */   "mI": function() { return /* binding */ ERefreshProfile; }
/* harmony export */ });
/* unused harmony exports EBlockSuggestion, ECVOption, EEditAction, EOptionGroupType, ESearchSetting, EUserInfoType */
'use client';

var ECVOption;
(function (ECVOption) {
    ECVOption["onlineProfile"] = "onlineProfile";
    ECVOption["attachedCV"] = "attachedCV";
})(ECVOption || (ECVOption = {}));
var EEditAction;
(function (EEditAction) {
    EEditAction["editPhone"] = "editPhone";
    EEditAction["editJobTitle"] = "editJobTitle";
    EEditAction["none"] = "none";
})(EEditAction || (EEditAction = {}));
var ESearchSetting;
(function (ESearchSetting) {
    ESearchSetting[ESearchSetting["DEFAULT"] = 0] = "DEFAULT";
    ESearchSetting[ESearchSetting["RELEVANT"] = 1] = "RELEVANT";
})(ESearchSetting || (ESearchSetting = {}));
var EUserInfoType;
(function (EUserInfoType) {
    EUserInfoType["phone"] = "phone";
    EUserInfoType["jobTitle"] = "jobTitle";
})(EUserInfoType || (EUserInfoType = {}));
var EApplyType;
(function (EApplyType) {
    EApplyType["none"] = "none";
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["attachment"] = "attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(EApplyType || (EApplyType = {}));
var EOptionGroupType;
(function (EOptionGroupType) {
    EOptionGroupType["applyForm"] = "apply-popup-form";
    EOptionGroupType["other"] = "other";
})(EOptionGroupType || (EOptionGroupType = {}));
var EBlockSuggestion;
(function (EBlockSuggestion) {
    EBlockSuggestion["BasicInfo"] = "BasicInfo";
    EBlockSuggestion["Skills"] = "Skills";
    EBlockSuggestion["Educations"] = "Educations";
    EBlockSuggestion["WorkingHistories"] = "WorkingHistories";
    EBlockSuggestion["Summary"] = "Summary";
})(EBlockSuggestion || (EBlockSuggestion = {}));
var ERefreshProfile;
(function (ERefreshProfile) {
    ERefreshProfile[ERefreshProfile["Unset"] = 0] = "Unset";
    ERefreshProfile[ERefreshProfile["Daily"] = 1] = "Daily";
    ERefreshProfile[ERefreshProfile["Weekly"] = 2] = "Weekly";
})(ERefreshProfile || (ERefreshProfile = {}));
var EOnOffStatus;
(function (EOnOffStatus) {
    EOnOffStatus[EOnOffStatus["Off"] = 0] = "Off";
    EOnOffStatus[EOnOffStatus["On"] = 1] = "On";
})(EOnOffStatus || (EOnOffStatus = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 25491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ trackingABJobAnalysis; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5895);
'use client';



var API_TRACKING_ANALYSIS = 'log-aggregator/v1/track-job-analysis';
var LAST_3_CHARACTER_JOB_DETAIL = 3; // This number is used for substring pathname
function trackingABJobAnalysis(baseMsUrl, body) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        var last3Character, response, ex_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (typeof window === 'undefined') {
                        return [2 /*return*/, false];
                    }
                    last3Character = window.location.pathname.substring(window.location.pathname.length - LAST_3_CHARACTER_JOB_DETAIL);
                    // Only tracking from job detail page
                    if (last3Character.indexOf('-jv') < 0 && last3Character.indexOf('-jd') < 0) {
                        return [2 /*return*/, false];
                    }
                    if (!baseMsUrl || baseMsUrl === '') {
                        console.error('Missing URL.');
                        return [2 /*return*/, false];
                    }
                    // Get current time in ISO
                    body.datetime = new Date().toISOString();
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(API_TRACKING_ANALYSIS), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
                case 3:
                    ex_1 = _a.sent();
                    console.error(ex_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=applyJob.js.map


/***/ }),

/***/ 39816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ MobileSelectMode; },
/* harmony export */   "X": function() { return /* binding */ ENestedDatasetName; }
/* harmony export */ });
'use client';

var ENestedDatasetName;
(function (ENestedDatasetName) {
    ENestedDatasetName["JOB_FUNCTION"] = "jobFunction";
})(ENestedDatasetName || (ENestedDatasetName = {}));
var MobileSelectMode;
(function (MobileSelectMode) {
    MobileSelectMode[MobileSelectMode["Single"] = 0] = "Single";
    MobileSelectMode[MobileSelectMode["Multiple"] = 1] = "Multiple";
})(MobileSelectMode || (MobileSelectMode = {}));
// export type TTranslation = Record<string, string>
// export type TTranslatorFunction<T extends TTranslation> = ReturnType<typeof createTranslator<T>>
// export type TTranslatorFactoryProps<T extends TTranslation> = Parameters<typeof createTranslator<T>>
// export type TTranslatorFactory<T extends TTranslation> = typeof createTranslator<T>


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 21924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBind = __webpack_require__(55559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var GetIntrinsic = __webpack_require__(40210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 86559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ defaultLocale; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);

/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 33276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66979);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59025);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84314);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 66979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 58545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),

/***/ 11640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 63500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, days);
}

/***/ }),

/***/ 21593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, amount * 12);
}

/***/ }),

/***/ 36948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qk": function() { return /* binding */ millisecondsInSecond; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 84129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarMonths; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),

/***/ 52724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarWeeks; }
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(584);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfWeekLeft = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft, options);
  var startOfWeekRight = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),

/***/ 91857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarYears; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),

/***/ 83894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 4135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 67090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfWeek; }
/* harmony export */ });
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);





/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 42298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(86559);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate["default"])(dirtyDate);

  if (!(0,isValid["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 55855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDate; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),

/***/ 20466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),

/***/ 85817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getHours; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),

/***/ 90259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ getISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,startOfWeek["default"])(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 39159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMinutes; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),

/***/ 78966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),

/***/ 56605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),

/***/ 77881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getSeconds; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),

/***/ 28789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ 95570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getFullYear();
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 71381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 96843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isEqual; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyLeftDate);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),

/***/ 3151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 49160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 86117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameQuarter; }
/* harmony export */ });
/* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94431);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),

/***/ 60792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 12274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isValid; }
/* harmony export */ });
/* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71381);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);

  if (!(0,_isDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 24257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isWithinInterval; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var time = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var startTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.start).getTime();
  var endTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),

/***/ 99890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ max; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 37950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ min; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 35337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ parse; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(86559);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);

    _defineProperty(this, "subPriority", 0);
  }

  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);

  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);

  var _super = _createSuper(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);

  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);

    return _this2;
  }

  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }

      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);

  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js
function Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Parser_defineProperties(Constructor, staticProps); return Constructor; }


var Parser = /*#__PURE__*/function () {
  function Parser() {
    Parser_classCallCheck(this, Parser);
  }

  Parser_createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);

      if (!result) {
        return null;
      }

      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);

  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
function EraParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { EraParser_typeof = function _typeof(obj) { return typeof obj; }; } else { EraParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return EraParser_typeof(obj); }

function EraParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EraParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function EraParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) EraParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) EraParser_defineProperties(Constructor, staticProps); return Constructor; }

function EraParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) EraParser_setPrototypeOf(subClass, superClass); }

function EraParser_setPrototypeOf(o, p) { EraParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return EraParser_setPrototypeOf(o, p); }

function EraParser_createSuper(Derived) { var hasNativeReflectConstruct = EraParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = EraParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = EraParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return EraParser_possibleConstructorReturn(this, result); }; }

function EraParser_possibleConstructorReturn(self, call) { if (call && (EraParser_typeof(call) === "object" || typeof call === "function")) { return call; } return EraParser_assertThisInitialized(self); }

function EraParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function EraParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function EraParser_getPrototypeOf(o) { EraParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return EraParser_getPrototypeOf(o); }

function EraParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EraParser = /*#__PURE__*/function (_Parser) {
  EraParser_inherits(EraParser, _Parser);

  var _super = EraParser_createSuper(EraParser);

  function EraParser() {
    var _this;

    EraParser_classCallCheck(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "priority", 140);

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);

    return _this;
  }

  EraParser_createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return EraParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
function YearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { YearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { YearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return YearParser_typeof(obj); }

function YearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function YearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function YearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) YearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) YearParser_defineProperties(Constructor, staticProps); return Constructor; }

function YearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) YearParser_setPrototypeOf(subClass, superClass); }

function YearParser_setPrototypeOf(o, p) { YearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return YearParser_setPrototypeOf(o, p); }

function YearParser_createSuper(Derived) { var hasNativeReflectConstruct = YearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = YearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = YearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return YearParser_possibleConstructorReturn(this, result); }; }

function YearParser_possibleConstructorReturn(self, call) { if (call && (YearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return YearParser_assertThisInitialized(self); }

function YearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function YearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function YearParser_getPrototypeOf(o) { YearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return YearParser_getPrototypeOf(o); }

function YearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  YearParser_inherits(YearParser, _Parser);

  var _super = YearParser_createSuper(YearParser);

  function YearParser() {
    var _this;

    YearParser_classCallCheck(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "priority", 130);

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  YearParser_createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return YearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
function LocalWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekYearParser_typeof(obj); }

function LocalWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekYearParser_setPrototypeOf(subClass, superClass); }

function LocalWeekYearParser_setPrototypeOf(o, p) { LocalWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekYearParser_setPrototypeOf(o, p); }

function LocalWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekYearParser_possibleConstructorReturn(this, result); }; }

function LocalWeekYearParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekYearParser_assertThisInitialized(self); }

function LocalWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekYearParser_getPrototypeOf(o) { LocalWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekYearParser_getPrototypeOf(o); }

function LocalWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  LocalWeekYearParser_inherits(LocalWeekYearParser, _Parser);

  var _super = LocalWeekYearParser_createSuper(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    LocalWeekYearParser_classCallCheck(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "priority", 130);

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekYearParser_createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);

  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
function ISOWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekYearParser_typeof(obj); }

function ISOWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekYearParser_setPrototypeOf(subClass, superClass); }

function ISOWeekYearParser_setPrototypeOf(o, p) { ISOWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekYearParser_setPrototypeOf(o, p); }

function ISOWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekYearParser_possibleConstructorReturn(this, result); }; }

function ISOWeekYearParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekYearParser_assertThisInitialized(self); }

function ISOWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekYearParser_getPrototypeOf(o) { ISOWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekYearParser_getPrototypeOf(o); }

function ISOWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO week-numbering year

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  ISOWeekYearParser_inherits(ISOWeekYearParser, _Parser);

  var _super = ISOWeekYearParser_createSuper(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    ISOWeekYearParser_classCallCheck(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "priority", 130);

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekYearParser_createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);

  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
function ExtendedYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ExtendedYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ExtendedYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ExtendedYearParser_typeof(obj); }

function ExtendedYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ExtendedYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ExtendedYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ExtendedYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ExtendedYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ExtendedYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ExtendedYearParser_setPrototypeOf(subClass, superClass); }

function ExtendedYearParser_setPrototypeOf(o, p) { ExtendedYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ExtendedYearParser_setPrototypeOf(o, p); }

function ExtendedYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ExtendedYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ExtendedYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ExtendedYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ExtendedYearParser_possibleConstructorReturn(this, result); }; }

function ExtendedYearParser_possibleConstructorReturn(self, call) { if (call && (ExtendedYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ExtendedYearParser_assertThisInitialized(self); }

function ExtendedYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ExtendedYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ExtendedYearParser_getPrototypeOf(o) { ExtendedYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ExtendedYearParser_getPrototypeOf(o); }

function ExtendedYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  ExtendedYearParser_inherits(ExtendedYearParser, _Parser);

  var _super = ExtendedYearParser_createSuper(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    ExtendedYearParser_classCallCheck(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "priority", 130);

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  ExtendedYearParser_createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
function QuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { QuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { QuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return QuarterParser_typeof(obj); }

function QuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function QuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function QuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) QuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) QuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function QuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) QuarterParser_setPrototypeOf(subClass, superClass); }

function QuarterParser_setPrototypeOf(o, p) { QuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return QuarterParser_setPrototypeOf(o, p); }

function QuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = QuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = QuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = QuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return QuarterParser_possibleConstructorReturn(this, result); }; }

function QuarterParser_possibleConstructorReturn(self, call) { if (call && (QuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return QuarterParser_assertThisInitialized(self); }

function QuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function QuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function QuarterParser_getPrototypeOf(o) { QuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return QuarterParser_getPrototypeOf(o); }

function QuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var QuarterParser = /*#__PURE__*/function (_Parser) {
  QuarterParser_inherits(QuarterParser, _Parser);

  var _super = QuarterParser_createSuper(QuarterParser);

  function QuarterParser() {
    var _this;

    QuarterParser_classCallCheck(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "priority", 120);

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  QuarterParser_createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
function StandAloneQuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneQuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneQuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneQuarterParser_typeof(obj); }

function StandAloneQuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneQuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneQuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneQuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneQuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneQuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneQuarterParser_setPrototypeOf(subClass, superClass); }

function StandAloneQuarterParser_setPrototypeOf(o, p) { StandAloneQuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneQuarterParser_setPrototypeOf(o, p); }

function StandAloneQuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneQuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneQuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneQuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneQuarterParser_possibleConstructorReturn(this, result); }; }

function StandAloneQuarterParser_possibleConstructorReturn(self, call) { if (call && (StandAloneQuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneQuarterParser_assertThisInitialized(self); }

function StandAloneQuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneQuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneQuarterParser_getPrototypeOf(o) { StandAloneQuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneQuarterParser_getPrototypeOf(o); }

function StandAloneQuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  StandAloneQuarterParser_inherits(StandAloneQuarterParser, _Parser);

  var _super = StandAloneQuarterParser_createSuper(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    StandAloneQuarterParser_classCallCheck(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "priority", 120);

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneQuarterParser_createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
function MonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MonthParser_typeof(obj); }

function MonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function MonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MonthParser_setPrototypeOf(subClass, superClass); }

function MonthParser_setPrototypeOf(o, p) { MonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MonthParser_setPrototypeOf(o, p); }

function MonthParser_createSuper(Derived) { var hasNativeReflectConstruct = MonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MonthParser_possibleConstructorReturn(this, result); }; }

function MonthParser_possibleConstructorReturn(self, call) { if (call && (MonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MonthParser_assertThisInitialized(self); }

function MonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MonthParser_getPrototypeOf(o) { MonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MonthParser_getPrototypeOf(o); }

function MonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MonthParser = /*#__PURE__*/function (_Parser) {
  MonthParser_inherits(MonthParser, _Parser);

  var _super = MonthParser_createSuper(MonthParser);

  function MonthParser() {
    var _this;

    MonthParser_classCallCheck(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "priority", 110);

    return _this;
  }

  MonthParser_createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
function StandAloneMonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneMonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneMonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneMonthParser_typeof(obj); }

function StandAloneMonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneMonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneMonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneMonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneMonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneMonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneMonthParser_setPrototypeOf(subClass, superClass); }

function StandAloneMonthParser_setPrototypeOf(o, p) { StandAloneMonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneMonthParser_setPrototypeOf(o, p); }

function StandAloneMonthParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneMonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneMonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneMonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneMonthParser_possibleConstructorReturn(this, result); }; }

function StandAloneMonthParser_possibleConstructorReturn(self, call) { if (call && (StandAloneMonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneMonthParser_assertThisInitialized(self); }

function StandAloneMonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneMonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneMonthParser_getPrototypeOf(o) { StandAloneMonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneMonthParser_getPrototypeOf(o); }

function StandAloneMonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  StandAloneMonthParser_inherits(StandAloneMonthParser, _Parser);

  var _super = StandAloneMonthParser_createSuper(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    StandAloneMonthParser_classCallCheck(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "priority", 110);

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneMonthParser_createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
function LocalWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekParser_typeof(obj); }

function LocalWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekParser_setPrototypeOf(subClass, superClass); }

function LocalWeekParser_setPrototypeOf(o, p) { LocalWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekParser_setPrototypeOf(o, p); }

function LocalWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekParser_possibleConstructorReturn(this, result); }; }

function LocalWeekParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekParser_assertThisInitialized(self); }

function LocalWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekParser_getPrototypeOf(o) { LocalWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekParser_getPrototypeOf(o); }

function LocalWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // Local week of year

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  LocalWeekParser_inherits(LocalWeekParser, _Parser);

  var _super = LocalWeekParser_createSuper(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    LocalWeekParser_classCallCheck(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "priority", 100);

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekParser_createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);

  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
function ISOWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekParser_typeof(obj); }

function ISOWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekParser_setPrototypeOf(subClass, superClass); }

function ISOWeekParser_setPrototypeOf(o, p) { ISOWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekParser_setPrototypeOf(o, p); }

function ISOWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekParser_possibleConstructorReturn(this, result); }; }

function ISOWeekParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekParser_assertThisInitialized(self); }

function ISOWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekParser_getPrototypeOf(o) { ISOWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekParser_getPrototypeOf(o); }

function ISOWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // ISO week of year

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  ISOWeekParser_inherits(ISOWeekParser, _Parser);

  var _super = ISOWeekParser_createSuper(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    ISOWeekParser_classCallCheck(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "priority", 100);

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekParser_createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);

  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
function DateParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DateParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DateParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DateParser_typeof(obj); }

function DateParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DateParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DateParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DateParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DateParser_defineProperties(Constructor, staticProps); return Constructor; }

function DateParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DateParser_setPrototypeOf(subClass, superClass); }

function DateParser_setPrototypeOf(o, p) { DateParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DateParser_setPrototypeOf(o, p); }

function DateParser_createSuper(Derived) { var hasNativeReflectConstruct = DateParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DateParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DateParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DateParser_possibleConstructorReturn(this, result); }; }

function DateParser_possibleConstructorReturn(self, call) { if (call && (DateParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DateParser_assertThisInitialized(self); }

function DateParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DateParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DateParser_getPrototypeOf(o) { DateParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DateParser_getPrototypeOf(o); }

function DateParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser = /*#__PURE__*/function (_Parser) {
  DateParser_inherits(DateParser, _Parser);

  var _super = DateParser_createSuper(DateParser);

  function DateParser() {
    var _this;

    DateParser_classCallCheck(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "priority", 90);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "subPriority", 1);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DateParser_createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);

        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
function DayOfYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayOfYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayOfYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayOfYearParser_typeof(obj); }

function DayOfYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayOfYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayOfYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayOfYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayOfYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayOfYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayOfYearParser_setPrototypeOf(subClass, superClass); }

function DayOfYearParser_setPrototypeOf(o, p) { DayOfYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayOfYearParser_setPrototypeOf(o, p); }

function DayOfYearParser_createSuper(Derived) { var hasNativeReflectConstruct = DayOfYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayOfYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayOfYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayOfYearParser_possibleConstructorReturn(this, result); }; }

function DayOfYearParser_possibleConstructorReturn(self, call) { if (call && (DayOfYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayOfYearParser_assertThisInitialized(self); }

function DayOfYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayOfYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayOfYearParser_getPrototypeOf(o) { DayOfYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayOfYearParser_getPrototypeOf(o); }

function DayOfYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  DayOfYearParser_inherits(DayOfYearParser, _Parser);

  var _super = DayOfYearParser_createSuper(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    DayOfYearParser_classCallCheck(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "priority", 90);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "subpriority", 1);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayOfYearParser_createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);

        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayOfYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate["default"])(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
function DayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayParser_typeof(obj); }

function DayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayParser_setPrototypeOf(subClass, superClass); }

function DayParser_setPrototypeOf(o, p) { DayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayParser_setPrototypeOf(o, p); }

function DayParser_createSuper(Derived) { var hasNativeReflectConstruct = DayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayParser_possibleConstructorReturn(this, result); }; }

function DayParser_possibleConstructorReturn(self, call) { if (call && (DayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayParser_assertThisInitialized(self); }

function DayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayParser_getPrototypeOf(o) { DayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayParser_getPrototypeOf(o); }

function DayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // Day of week

var DayParser = /*#__PURE__*/function (_Parser) {
  DayParser_inherits(DayParser, _Parser);

  var _super = DayParser_createSuper(DayParser);

  function DayParser() {
    var _this;

    DayParser_classCallCheck(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "priority", 90);

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayParser_createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
function LocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalDayParser_typeof(obj); }

function LocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalDayParser_setPrototypeOf(subClass, superClass); }

function LocalDayParser_setPrototypeOf(o, p) { LocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalDayParser_setPrototypeOf(o, p); }

function LocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalDayParser_possibleConstructorReturn(this, result); }; }

function LocalDayParser_possibleConstructorReturn(self, call) { if (call && (LocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalDayParser_assertThisInitialized(self); }

function LocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalDayParser_getPrototypeOf(o) { LocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalDayParser_getPrototypeOf(o); }

function LocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Local day of week

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  LocalDayParser_inherits(LocalDayParser, _Parser);

  var _super = LocalDayParser_createSuper(LocalDayParser);

  function LocalDayParser() {
    var _this;

    LocalDayParser_classCallCheck(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "priority", 90);

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);

    return _this;
  }

  LocalDayParser_createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
function StandAloneLocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneLocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneLocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneLocalDayParser_typeof(obj); }

function StandAloneLocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneLocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneLocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneLocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneLocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneLocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneLocalDayParser_setPrototypeOf(subClass, superClass); }

function StandAloneLocalDayParser_setPrototypeOf(o, p) { StandAloneLocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneLocalDayParser_setPrototypeOf(o, p); }

function StandAloneLocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneLocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneLocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneLocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneLocalDayParser_possibleConstructorReturn(this, result); }; }

function StandAloneLocalDayParser_possibleConstructorReturn(self, call) { if (call && (StandAloneLocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneLocalDayParser_assertThisInitialized(self); }

function StandAloneLocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneLocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneLocalDayParser_getPrototypeOf(o) { StandAloneLocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneLocalDayParser_getPrototypeOf(o); }

function StandAloneLocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Stand-alone local day of week

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  StandAloneLocalDayParser_inherits(StandAloneLocalDayParser, _Parser);

  var _super = StandAloneLocalDayParser_createSuper(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    StandAloneLocalDayParser_classCallCheck(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "priority", 90);

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);

    return _this;
  }

  StandAloneLocalDayParser_createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0,toDate["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
function ISODayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISODayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISODayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISODayParser_typeof(obj); }

function ISODayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISODayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISODayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISODayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISODayParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISODayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISODayParser_setPrototypeOf(subClass, superClass); }

function ISODayParser_setPrototypeOf(o, p) { ISODayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISODayParser_setPrototypeOf(o, p); }

function ISODayParser_createSuper(Derived) { var hasNativeReflectConstruct = ISODayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISODayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISODayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISODayParser_possibleConstructorReturn(this, result); }; }

function ISODayParser_possibleConstructorReturn(self, call) { if (call && (ISODayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISODayParser_assertThisInitialized(self); }

function ISODayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISODayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISODayParser_getPrototypeOf(o) { ISODayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISODayParser_getPrototypeOf(o); }

function ISODayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO day of week

var ISODayParser = /*#__PURE__*/function (_Parser) {
  ISODayParser_inherits(ISODayParser, _Parser);

  var _super = ISODayParser_createSuper(ISODayParser);

  function ISODayParser() {
    var _this;

    ISODayParser_classCallCheck(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "priority", 90);

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISODayParser_createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd

        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T

        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu

        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday

        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
function AMPMParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMParser_typeof(obj); }

function AMPMParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMParser_setPrototypeOf(subClass, superClass); }

function AMPMParser_setPrototypeOf(o, p) { AMPMParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMParser_setPrototypeOf(o, p); }

function AMPMParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMParser_possibleConstructorReturn(this, result); }; }

function AMPMParser_possibleConstructorReturn(self, call) { if (call && (AMPMParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMParser_assertThisInitialized(self); }

function AMPMParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMParser_getPrototypeOf(o) { AMPMParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMParser_getPrototypeOf(o); }

function AMPMParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMParser = /*#__PURE__*/function (_Parser) {
  AMPMParser_inherits(AMPMParser, _Parser);

  var _super = AMPMParser_createSuper(AMPMParser);

  function AMPMParser() {
    var _this;

    AMPMParser_classCallCheck(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "priority", 80);

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMParser_createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
function AMPMMidnightParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMMidnightParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMMidnightParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMMidnightParser_typeof(obj); }

function AMPMMidnightParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMMidnightParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMMidnightParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMMidnightParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMMidnightParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMMidnightParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMMidnightParser_setPrototypeOf(subClass, superClass); }

function AMPMMidnightParser_setPrototypeOf(o, p) { AMPMMidnightParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMMidnightParser_setPrototypeOf(o, p); }

function AMPMMidnightParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMMidnightParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMMidnightParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMMidnightParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMMidnightParser_possibleConstructorReturn(this, result); }; }

function AMPMMidnightParser_possibleConstructorReturn(self, call) { if (call && (AMPMMidnightParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMMidnightParser_assertThisInitialized(self); }

function AMPMMidnightParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMMidnightParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMMidnightParser_getPrototypeOf(o) { AMPMMidnightParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMMidnightParser_getPrototypeOf(o); }

function AMPMMidnightParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  AMPMMidnightParser_inherits(AMPMMidnightParser, _Parser);

  var _super = AMPMMidnightParser_createSuper(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    AMPMMidnightParser_classCallCheck(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "priority", 80);

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMMidnightParser_createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
function DayPeriodParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayPeriodParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayPeriodParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayPeriodParser_typeof(obj); }

function DayPeriodParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayPeriodParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayPeriodParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayPeriodParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayPeriodParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayPeriodParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayPeriodParser_setPrototypeOf(subClass, superClass); }

function DayPeriodParser_setPrototypeOf(o, p) { DayPeriodParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayPeriodParser_setPrototypeOf(o, p); }

function DayPeriodParser_createSuper(Derived) { var hasNativeReflectConstruct = DayPeriodParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayPeriodParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayPeriodParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayPeriodParser_possibleConstructorReturn(this, result); }; }

function DayPeriodParser_possibleConstructorReturn(self, call) { if (call && (DayPeriodParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayPeriodParser_assertThisInitialized(self); }

function DayPeriodParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayPeriodParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayPeriodParser_getPrototypeOf(o) { DayPeriodParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayPeriodParser_getPrototypeOf(o); }

function DayPeriodParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // in the morning, in the afternoon, in the evening, at night

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  DayPeriodParser_inherits(DayPeriodParser, _Parser);

  var _super = DayPeriodParser_createSuper(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    DayPeriodParser_classCallCheck(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "priority", 80);

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);

    return _this;
  }

  DayPeriodParser_createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
function Hour1to12Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1to12Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1to12Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1to12Parser_typeof(obj); }

function Hour1to12Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1to12Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1to12Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1to12Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1to12Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1to12Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1to12Parser_setPrototypeOf(subClass, superClass); }

function Hour1to12Parser_setPrototypeOf(o, p) { Hour1to12Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1to12Parser_setPrototypeOf(o, p); }

function Hour1to12Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1to12Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1to12Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1to12Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1to12Parser_possibleConstructorReturn(this, result); }; }

function Hour1to12Parser_possibleConstructorReturn(self, call) { if (call && (Hour1to12Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1to12Parser_assertThisInitialized(self); }

function Hour1to12Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1to12Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1to12Parser_getPrototypeOf(o) { Hour1to12Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1to12Parser_getPrototypeOf(o); }

function Hour1to12Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  Hour1to12Parser_inherits(Hour1to12Parser, _Parser);

  var _super = Hour1to12Parser_createSuper(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    Hour1to12Parser_classCallCheck(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "priority", 70);

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour1to12Parser_createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);

        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
function Hour0to23Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0to23Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0to23Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0to23Parser_typeof(obj); }

function Hour0to23Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0to23Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0to23Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0to23Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0to23Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0to23Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0to23Parser_setPrototypeOf(subClass, superClass); }

function Hour0to23Parser_setPrototypeOf(o, p) { Hour0to23Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0to23Parser_setPrototypeOf(o, p); }

function Hour0to23Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0to23Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0to23Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0to23Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0to23Parser_possibleConstructorReturn(this, result); }; }

function Hour0to23Parser_possibleConstructorReturn(self, call) { if (call && (Hour0to23Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0to23Parser_assertThisInitialized(self); }

function Hour0to23Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0to23Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0to23Parser_getPrototypeOf(o) { Hour0to23Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0to23Parser_getPrototypeOf(o); }

function Hour0to23Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  Hour0to23Parser_inherits(Hour0to23Parser, _Parser);

  var _super = Hour0to23Parser_createSuper(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    Hour0to23Parser_classCallCheck(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "priority", 70);

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour0to23Parser_createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);

        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);

  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
function Hour0To11Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0To11Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0To11Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0To11Parser_typeof(obj); }

function Hour0To11Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0To11Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0To11Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0To11Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0To11Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0To11Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0To11Parser_setPrototypeOf(subClass, superClass); }

function Hour0To11Parser_setPrototypeOf(o, p) { Hour0To11Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0To11Parser_setPrototypeOf(o, p); }

function Hour0To11Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0To11Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0To11Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0To11Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0To11Parser_possibleConstructorReturn(this, result); }; }

function Hour0To11Parser_possibleConstructorReturn(self, call) { if (call && (Hour0To11Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0To11Parser_assertThisInitialized(self); }

function Hour0To11Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0To11Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0To11Parser_getPrototypeOf(o) { Hour0To11Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0To11Parser_getPrototypeOf(o); }

function Hour0To11Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  Hour0To11Parser_inherits(Hour0To11Parser, _Parser);

  var _super = Hour0To11Parser_createSuper(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    Hour0To11Parser_classCallCheck(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "priority", 70);

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  Hour0To11Parser_createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);

        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
function Hour1To24Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1To24Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1To24Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1To24Parser_typeof(obj); }

function Hour1To24Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1To24Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1To24Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1To24Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1To24Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1To24Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1To24Parser_setPrototypeOf(subClass, superClass); }

function Hour1To24Parser_setPrototypeOf(o, p) { Hour1To24Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1To24Parser_setPrototypeOf(o, p); }

function Hour1To24Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1To24Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1To24Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1To24Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1To24Parser_possibleConstructorReturn(this, result); }; }

function Hour1To24Parser_possibleConstructorReturn(self, call) { if (call && (Hour1To24Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1To24Parser_assertThisInitialized(self); }

function Hour1To24Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1To24Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1To24Parser_getPrototypeOf(o) { Hour1To24Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1To24Parser_getPrototypeOf(o); }

function Hour1To24Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  Hour1To24Parser_inherits(Hour1To24Parser, _Parser);

  var _super = Hour1To24Parser_createSuper(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    Hour1To24Parser_classCallCheck(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "priority", 70);

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  Hour1To24Parser_createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);

        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);

  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
function MinuteParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MinuteParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MinuteParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MinuteParser_typeof(obj); }

function MinuteParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MinuteParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MinuteParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MinuteParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MinuteParser_defineProperties(Constructor, staticProps); return Constructor; }

function MinuteParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MinuteParser_setPrototypeOf(subClass, superClass); }

function MinuteParser_setPrototypeOf(o, p) { MinuteParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MinuteParser_setPrototypeOf(o, p); }

function MinuteParser_createSuper(Derived) { var hasNativeReflectConstruct = MinuteParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MinuteParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MinuteParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MinuteParser_possibleConstructorReturn(this, result); }; }

function MinuteParser_possibleConstructorReturn(self, call) { if (call && (MinuteParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MinuteParser_assertThisInitialized(self); }

function MinuteParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MinuteParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MinuteParser_getPrototypeOf(o) { MinuteParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MinuteParser_getPrototypeOf(o); }

function MinuteParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MinuteParser = /*#__PURE__*/function (_Parser) {
  MinuteParser_inherits(MinuteParser, _Parser);

  var _super = MinuteParser_createSuper(MinuteParser);

  function MinuteParser() {
    var _this;

    MinuteParser_classCallCheck(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "priority", 60);

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  MinuteParser_createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);

        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);

  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
function SecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { SecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SecondParser_typeof(obj); }

function SecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) SecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) SecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function SecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SecondParser_setPrototypeOf(subClass, superClass); }

function SecondParser_setPrototypeOf(o, p) { SecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SecondParser_setPrototypeOf(o, p); }

function SecondParser_createSuper(Derived) { var hasNativeReflectConstruct = SecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SecondParser_possibleConstructorReturn(this, result); }; }

function SecondParser_possibleConstructorReturn(self, call) { if (call && (SecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return SecondParser_assertThisInitialized(self); }

function SecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SecondParser_getPrototypeOf(o) { SecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SecondParser_getPrototypeOf(o); }

function SecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SecondParser = /*#__PURE__*/function (_Parser) {
  SecondParser_inherits(SecondParser, _Parser);

  var _super = SecondParser_createSuper(SecondParser);

  function SecondParser() {
    var _this;

    SecondParser_classCallCheck(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "priority", 50);

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  SecondParser_createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);

        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);

  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
function FractionOfSecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FractionOfSecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { FractionOfSecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FractionOfSecondParser_typeof(obj); }

function FractionOfSecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FractionOfSecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FractionOfSecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) FractionOfSecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) FractionOfSecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function FractionOfSecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FractionOfSecondParser_setPrototypeOf(subClass, superClass); }

function FractionOfSecondParser_setPrototypeOf(o, p) { FractionOfSecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FractionOfSecondParser_setPrototypeOf(o, p); }

function FractionOfSecondParser_createSuper(Derived) { var hasNativeReflectConstruct = FractionOfSecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = FractionOfSecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = FractionOfSecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return FractionOfSecondParser_possibleConstructorReturn(this, result); }; }

function FractionOfSecondParser_possibleConstructorReturn(self, call) { if (call && (FractionOfSecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return FractionOfSecondParser_assertThisInitialized(self); }

function FractionOfSecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FractionOfSecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function FractionOfSecondParser_getPrototypeOf(o) { FractionOfSecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FractionOfSecondParser_getPrototypeOf(o); }

function FractionOfSecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  FractionOfSecondParser_inherits(FractionOfSecondParser, _Parser);

  var _super = FractionOfSecondParser_createSuper(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    FractionOfSecondParser_classCallCheck(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "priority", 30);

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  FractionOfSecondParser_createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);

  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
function ISOTimezoneWithZParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneWithZParser_typeof(obj); }

function ISOTimezoneWithZParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneWithZParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneWithZParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneWithZParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneWithZParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneWithZParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneWithZParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneWithZParser_setPrototypeOf(o, p) { ISOTimezoneWithZParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneWithZParser_setPrototypeOf(o, p); }

function ISOTimezoneWithZParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneWithZParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneWithZParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneWithZParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneWithZParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneWithZParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneWithZParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneWithZParser_assertThisInitialized(self); }

function ISOTimezoneWithZParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneWithZParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneWithZParser_getPrototypeOf(o) { ISOTimezoneWithZParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneWithZParser_getPrototypeOf(o); }

function ISOTimezoneWithZParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601. +00:00 is `'Z'`)

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneWithZParser_inherits(ISOTimezoneWithZParser, _Parser);

  var _super = ISOTimezoneWithZParser_createSuper(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    ISOTimezoneWithZParser_classCallCheck(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);

    return _this;
  }

  ISOTimezoneWithZParser_createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
function ISOTimezoneParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneParser_typeof(obj); }

function ISOTimezoneParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneParser_setPrototypeOf(o, p) { ISOTimezoneParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneParser_setPrototypeOf(o, p); }

function ISOTimezoneParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneParser_assertThisInitialized(self); }

function ISOTimezoneParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneParser_getPrototypeOf(o) { ISOTimezoneParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneParser_getPrototypeOf(o); }

function ISOTimezoneParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601)

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneParser_inherits(ISOTimezoneParser, _Parser);

  var _super = ISOTimezoneParser_createSuper(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    ISOTimezoneParser_classCallCheck(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);

    return _this;
  }

  ISOTimezoneParser_createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
function TimestampSecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampSecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampSecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampSecondsParser_typeof(obj); }

function TimestampSecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampSecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampSecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampSecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampSecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampSecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampSecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampSecondsParser_setPrototypeOf(o, p) { TimestampSecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampSecondsParser_setPrototypeOf(o, p); }

function TimestampSecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampSecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampSecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampSecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampSecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampSecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampSecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampSecondsParser_assertThisInitialized(self); }

function TimestampSecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampSecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampSecondsParser_getPrototypeOf(o) { TimestampSecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampSecondsParser_getPrototypeOf(o); }

function TimestampSecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampSecondsParser_inherits(TimestampSecondsParser, _Parser);

  var _super = TimestampSecondsParser_createSuper(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    TimestampSecondsParser_classCallCheck(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "priority", 40);

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampSecondsParser_createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
function TimestampMillisecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampMillisecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampMillisecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampMillisecondsParser_typeof(obj); }

function TimestampMillisecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampMillisecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampMillisecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampMillisecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampMillisecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampMillisecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampMillisecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampMillisecondsParser_setPrototypeOf(o, p) { TimestampMillisecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampMillisecondsParser_setPrototypeOf(o, p); }

function TimestampMillisecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampMillisecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampMillisecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampMillisecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampMillisecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampMillisecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampMillisecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampMillisecondsParser_assertThisInitialized(self); }

function TimestampMillisecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampMillisecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampMillisecondsParser_getPrototypeOf(o) { TimestampMillisecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampMillisecondsParser_getPrototypeOf(o); }

function TimestampMillisecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampMillisecondsParser_inherits(TimestampMillisecondsParser, _Parser);

  var _super = TimestampMillisecondsParser_createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    TimestampMillisecondsParser_classCallCheck(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "priority", 20);

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampMillisecondsParser_createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js
function parse_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { parse_typeof = function _typeof(obj) { return typeof obj; }; } else { parse_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return parse_typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate["default"])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper(tokens),
      _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (parse_typeof(_ret) === "object") return _ret.v;
    } // Check if the remaining input contains something other than whitespace

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate["default"])(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 23855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36948);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 37042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),

/***/ 4543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),

/***/ 16218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ setMonth; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),

/***/ 11503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setQuarter; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16218);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),

/***/ 39880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setSeconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),

/***/ 44749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setYear; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 43703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 94431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 38148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var cleanDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 88330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subHours; }
/* harmony export */ });
/* harmony import */ var _addHours_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78343);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addHours_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 91218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subMilliseconds; }
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 1784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subMinutes; }
/* harmony export */ });
/* harmony import */ var _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58545);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 54559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 77982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63500);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 59319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21593);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addYears_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 10251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectKeys = __webpack_require__(82215);
var isArguments = __webpack_require__(82584);
var is = __webpack_require__(20609);
var isRegex = __webpack_require__(98420);
var flags = __webpack_require__(2847);
var isDate = __webpack_require__(18923);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),

/***/ 9996:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 4289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(82215);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(31044)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 81923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var firebase = __webpack_require__(5752);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var firebase__default = /*#__PURE__*/_interopDefaultLegacy(firebase);

var name = "firebase";
var version = "7.24.0";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase__default['default'].registerVersion(name, version, 'app');

module.exports = firebase__default['default'];
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 25972:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 47815:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return __webpack_require__.g[key] = (__webpack_require__.g[key] || 0) + 1;
};


/***/ }),

/***/ 31044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 96410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(55419);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 17642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 82584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(96410)();
var callBound = __webpack_require__(21924);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 18923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(96410)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 98420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(21924);
var hasToStringTag = __webpack_require__(96410)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 49090:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 30845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 24244:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 20609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(55559);

var implementation = __webpack_require__(24244);
var getPolyfill = __webpack_require__(75624);
var shim = __webpack_require__(52281);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 75624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(24244);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 52281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(75624);
var define = __webpack_require__(4289);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 18987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(21414); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 82215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(21414);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(18987);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 21414:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(67294),__webpack_require__(45697),__webpack_require__(94184),__webpack_require__(71381),__webpack_require__(12274),__webpack_require__(42298),__webpack_require__(58545),__webpack_require__(78343),__webpack_require__(77349),__webpack_require__(63500),__webpack_require__(11640),__webpack_require__(21593),__webpack_require__(1784),__webpack_require__(88330),__webpack_require__(7069),__webpack_require__(77982),__webpack_require__(54559),__webpack_require__(59319),__webpack_require__(77881),__webpack_require__(39159),__webpack_require__(85817),__webpack_require__(20466),__webpack_require__(55855),__webpack_require__(90259),__webpack_require__(78966),__webpack_require__(56605),__webpack_require__(95570),__webpack_require__(28789),__webpack_require__(39880),__webpack_require__(4543),__webpack_require__(37042),__webpack_require__(16218),__webpack_require__(11503),__webpack_require__(44749),__webpack_require__(37950),__webpack_require__(99890),__webpack_require__(92300),__webpack_require__(84129),__webpack_require__(52724),__webpack_require__(91857),__webpack_require__(69119),__webpack_require__(584),__webpack_require__(43703),__webpack_require__(94431),__webpack_require__(38148),__webpack_require__(83894),__webpack_require__(67090),__webpack_require__(4135),__webpack_require__(96843),__webpack_require__(3151),__webpack_require__(49160),__webpack_require__(60792),__webpack_require__(86117),__webpack_require__(42699),__webpack_require__(313),__webpack_require__(24257),__webpack_require__(19013),__webpack_require__(35337),__webpack_require__(23855),__webpack_require__(58949),__webpack_require__(33557),__webpack_require__(73935)):0}(this,(function(e,t,r,a,n,o,s,i,p,l,d,c,u,f,h,m,y,v,D,w,k,g,b,C,S,_,M,P,E,N,O,Y,x,T,I,L,F,R,q,A,W,B,j,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ce=le(a),ue=le(n),fe=le(o),he=le(s),me=le(i),ye=le(p),ve=le(l),De=le(d),we=le(c),ke=le(u),ge=le(m),be=le(y),Ce=le(v),Se=le(D),_e=le(w),Me=le(k),Pe=le(g),Ee=le(b),Ne=le(C),Oe=le(S),Ye=le(_),xe=le(M),Te=le(P),Ie=le(E),Le=le(N),Fe=le(O),Re=le(Y),qe=le(x),Ae=le(T),We=le(I),Be=le(L),je=le(F),He=le(R),Ke=le(q),Qe=le(W),Ve=le(B),Ue=le(j),$e=le(H),ze=le(K),Ge=le(Q),Je=le(V),Xe=le(z),Ze=le(G),et=le(J),tt=le(X),rt=le(Z),at=le(ee),nt=le(te),ot=le(re),st=le(ae),it=le(ne),pt=le(oe),lt=le(se),dt=le(pe);function ct(e){return(ct="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ut(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ft(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ht(e,t,r){return t&&ft(e.prototype,t),r&&ft(e,r),e}function mt(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function yt(){return(yt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e}).apply(this,arguments)}function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){mt(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function wt(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&gt(e,t)}function kt(e){return(kt=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function gt(e,t){return(gt=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function bt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ct(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?bt(e):t}function St(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=kt(e);if(t){var n=kt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return Ct(this,r)}}function _t(e){return function(e){if(Array.isArray(e))return Mt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Mt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Mt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Mt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Pt(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Et(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var Nt={p:Et,P:function(e,t){var r,a=e.match(/(P+)(p+)?/),n=a[1],o=a[2];if(!o)return Pt(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Pt(n,t)).replace("{{time}}",Et(o,t))}},Ot=12,Yt=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function xt(e){var t=e?"string"==typeof e||e instanceof String?pt.default(e):st.default(e):new Date;return It(t)?t:null}function Tt(e,t,r,a){var n=null,o=Jt(r)||Jt(Gt()),s=!0;return Array.isArray(t)?(t.forEach((function(t){var r=it.default(e,t,new Date,{locale:o});a&&(s=It(r)&&e===he.default(r,t,{awareOfUnicodeTokens:!0})),It(r)&&s&&(n=r)})),n):(n=it.default(e,t,new Date,{locale:o}),a?s=It(n)&&e===he.default(n,t,{awareOfUnicodeTokens:!0}):It(n)||(t=t.match(Yt).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,Nt[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(n=it.default(e,t.slice(0,e.length),new Date)),It(n)||(n=new Date(e))),It(n)&&s?n:null)}function It(e){return fe.default(e)&&at.default(e,new Date("1/1/1000"))}function Lt(e,t,r){if("en"===r)return he.default(e,t,{awareOfUnicodeTokens:!0});var a=Jt(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&Gt()&&Jt(Gt())&&(a=Jt(Gt())),he.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Ft(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Re.default(Fe.default(Le.default(e,i),o),a)}function Rt(e,t){var r=t&&Jt(t)||Gt()&&Jt(Gt());return Oe.default(e,r?{locale:r}:null)}function qt(e,t){return Lt(e,"ddd",t)}function At(e){return Ve.default(e)}function Wt(e,t){var r=Jt(t||Gt());return Ue.default(e,{locale:r})}function Bt(e){return $e.default(e)}function jt(e){return Ge.default(e)}function Ht(e){return ze.default(e)}function Kt(e,t){return e&&t?tt.default(e,t):!e&&!t}function Qt(e,t){return e&&t?et.default(e,t):!e&&!t}function Vt(e,t){return e&&t?rt.default(e,t):!e&&!t}function Ut(e,t){return e&&t?Ze.default(e,t):!e&&!t}function $t(e,t){return e&&t?Xe.default(e,t):!e&&!t}function zt(e,t,r){var a,n=Ve.default(t),o=Je.default(r);try{a=ot.default(e,{start:n,end:o})}catch(e){a=!1}return a}function Gt(){return("undefined"!=typeof window?window:__webpack_require__.g).__localeId__}function Jt(e){if("string"==typeof e){var t="undefined"!=typeof window?window:__webpack_require__.g;return t.__localeData__?t.__localeData__[e]:null}return e}function Xt(e,t){return Lt(qe.default(xt(),e),"LLLL",t)}function Zt(e,t){return Lt(qe.default(xt(),e),"LLL",t)}function er(e,t){return Lt(Ae.default(xt(),e),"QQQ",t)}function tr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Ut(e,t)}))||o&&!o.some((function(t){return Ut(e,t)}))||s&&!s(xt(e))||!1}function rr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Ut(e,t)}))||!1}function ar(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Qt(e,t)}))||o&&!o.some((function(t){return Qt(e,t)}))||s&&!s(xt(e))||!1}function nr(e,t,r,a){var n=Te.default(e),o=Ye.default(e),s=Te.default(t),i=Ye.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Vt(e,t)}))||o&&!o.some((function(t){return Vt(e,t)}))||s&&!s(xt(e))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=new Date(e,0,1);return pr(n,{minDate:r,maxDate:a})||!1}function ir(e,t,r,a){var n=Te.default(e),o=xe.default(e),s=Te.default(t),i=xe.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&He.default(e,r)<0||a&&He.default(e,a)>0}function lr(e,t){return t.some((function(t){return Pe.default(t)===Pe.default(e)&&Me.default(t)===Me.default(e)}))}function dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&lr(e,r)||a&&!lr(e,a)||n&&!n(e)||!1}function cr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=xt(),s=Re.default(Fe.default(o,Me.default(e)),Pe.default(e)),i=Re.default(Fe.default(o,Me.default(r)),Pe.default(r)),p=Re.default(Fe.default(o,Me.default(a)),Pe.default(a));try{n=!ot.default(s,{start:i,end:p})}catch(e){n=!1}return n}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ce.default(e,1);return r&&Ke.default(r,n)>0||a&&a.every((function(e){return Ke.default(e,n)>0}))||!1}function fr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&Ke.default(n,r)>0||a&&a.every((function(e){return Ke.default(n,e)>0}))||!1}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Se.default(e,1);return r&&Qe.default(r,n)>0||a&&a.every((function(e){return Qe.default(e,n)>0}))||!1}function mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Qe.default(n,r)>0||a&&a.every((function(e){return Qe.default(n,e)>0}))||!1}function yr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)>=0}));return Be.default(a)}return r?Be.default(r):t}function vr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function Dr(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(ue.default(o)){var s=Lt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===ct(o)){var p=Object.keys(o),l=p[0],d=o[p[0]];if("string"==typeof l&&d.constructor===Array)for(var c=0,u=d.length;c<u;c++){var f=Lt(d[c],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function wr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=me.default(ye.default(e,Pe.default(n[i])),Me.default(n[i])),l=me.default(e,(r+1)*a);at.default(p,t)&&nt.default(p,l)&&s.push(n[i])}return s}function kr(e){return e<10?"0".concat(e):"".concat(e)}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ot,r=Math.ceil(Te.default(e)/t)*t,a=r-(t-1);return{startPeriod:a,endPeriod:r}}function br(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Te.default(r)<=s),a&&i&&(i=Te.default(a)>=s),i&&n.push(s)}return n}var Cr=function(e){wt(r,e);var t=St(r);function r(e){var a;ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){var e=a.props.year,t=a.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:a.onChange.bind(bt(a),t)},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=a.props.minDate?Te.default(a.props.minDate):null,n=a.props.maxDate?Te.default(a.props.maxDate):null;return n&&a.state.yearsList.find((function(e){return e===n}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:a.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&a.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:a.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),mt(bt(a),"onChange",(function(e){a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),mt(bt(a),"shiftYears",(function(e){var t=a.state.yearsList.map((function(t){return t+e}));a.setState({yearsList:t})})),mt(bt(a),"incrementYears",(function(){return a.shiftYears(1)})),mt(bt(a),"decrementYears",(function(){return a.shiftYears(-1)}));var n=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=n||(o?10:5);return a.state={yearsList:br(a.props.year,s,a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Sr=lt.default(Cr),_r=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Te.default(e.props.minDate):1900,r=e.props.maxDate?Te.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Sr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),mt(bt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),mt(bt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),mt(bt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Mr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(bt(e),r)},e.props.month===r?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),mt(bt(e),"onChange",(function(t){return e.props.onChange(t)})),mt(bt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Pr=lt.default(Mr),Er=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),mt(bt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),mt(bt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),mt(bt(e),"renderDropdown",(function(t){return de.default.createElement(Pr,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),mt(bt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Zt(e,t.props.locale)}:function(e){return Xt(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Nr(e,t){for(var r=[],a=Bt(e),n=Bt(t);!at.default(a,n);)r.push(xt(a)),a=we.default(a,1);return r}var Or=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Ie.default(e),r=Kt(a.props.date,e)&&Qt(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(bt(a),t)},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Lt(e,a.props.dateFormat,a.props.locale))}))})),mt(bt(a),"onChange",(function(e){return a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Nr(a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Yr=lt.default(Or),xr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=Bt(e.props.minDate),r=Bt(e.props.maxDate),a=[];!at.default(t,r);){var n=Ie.default(t);a.push(de.default.createElement("option",{key:n,value:n},Lt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Ie.default(Bt(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){var r=Lt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Yr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown();var r=xt(parseInt(t));Kt(e.props.date,r)&&Qt(e.props.date,r)||e.props.onChange(r)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Tr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),mt(bt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),mt(bt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),mt(bt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),mt(bt(e),"isSameDay",(function(t){return Ut(e.props.day,t)})),mt(bt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),mt(bt(e),"isDisabled",(function(){return tr(e.props.day,e.props)})),mt(bt(e),"isExcluded",(function(){return rr(e.props.day,e.props)})),mt(bt(e),"getHighLightedClass",(function(t){var r=e.props,a=r.day,n=r.highlightDates;if(!n)return!1;var o=Lt(a,"MM.dd.yyyy");return n.get(o)})),mt(bt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&zt(r,a,n)})),mt(bt(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,a=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.selectingDate,i=t.startDate,p=t.endDate;return!(!(a||n||o)||!s||e.isDisabled())&&(a&&p&&(nt.default(s,p)||$t(s,p))?zt(r,s,p):(n&&i&&(at.default(s,i)||$t(s,i))||!(!o||!i||p||!at.default(s,i)&&!$t(s,i)))&&zt(r,i,s))})),mt(bt(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.startDate;return Ut(r,t.selectsStart?a:n)})),mt(bt(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.endDate;return Ut(r,t.selectsEnd?a:n)})),mt(bt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(a,r)})),mt(bt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(n,r)})),mt(bt(e),"isWeekend",(function(){var t=Ee.default(e.props.day);return 0===t||6===t})),mt(bt(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==Ye.default(e.props.day)})),mt(bt(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return ce.default("react-datepicker__day",r,"react-datepicker__day--"+qt(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(xt()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),mt(bt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Lt(r,"PPPP"))})),mt(bt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&Ut(n,a)?0:-1})),mt(bt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),mt(bt(e),"renderDayContents",(function(){if(e.isOutsideMonth()){if(e.props.monthShowsDuplicateDaysEnd&&Ne.default(e.props.day)<10)return null;if(e.props.monthShowsDuplicateDaysStart&&Ne.default(e.props.day)>20)return null}return e.props.renderDayContents?e.props.renderDayContents(Ne.default(e.props.day),e.props.day):Ne.default(e.props.day)})),mt(bt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.renderDayContents())})),e}return ht(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),Ir=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ce.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}]),r}(de.default.Component),Lr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),mt(bt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Rt(t)})),mt(bt(e),"renderDays",(function(){var t=Wt(e.props.day,e.props.locale),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(bt(e),t,a):void 0;r.push(de.default.createElement(Ir,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=ve.default(t,r);return de.default.createElement(Tr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(bt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(bt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})})))})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Fr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",_t(Array(12)).map((function(){return de.default.createRef()}))),mt(bt(e),"isDisabled",(function(t){return tr(t,e.props)})),mt(bt(e),"isExcluded",(function(t){return rr(t,e.props)})),mt(bt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),mt(bt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),n)})),mt(bt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),n)})),mt(bt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),o)})),mt(bt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),o)})),mt(bt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=ve.default(t,6);return Qt(t,r)||Qt(a,r)})),mt(bt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=Wt(Bt(e.props.day),e.props.locale),n=0,o=!1;t.push(de.default.createElement(Lr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:n,day:a,month:Ye.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!o;){n++,a=De.default(a,1);var s=r&&n>=6,i=!r&&!e.isWeekInMonth(a);if(s||i){if(!e.props.peekNextMonth)break;o=!0}}return t})),mt(bt(e),"onMonthClick",(function(t,r){e.handleDayClick(Bt(qe.default(e.props.day,r)),t)})),mt(bt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),mt(bt(e),"onMonthKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onMonthClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,Ce.default(e.props.preSelection,1))}})),mt(bt(e),"onQuarterClick",(function(t,r){e.handleDayClick(Ht(Ae.default(e.props.day,r)),t)})),mt(bt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,d=r.monthClassName,c=d?d(a):void 0;return ce.default("react-datepicker__month-text","react-datepicker__month-".concat(t),c,{"react-datepicker__month--disabled":(i||p)&&ar(qe.default(a,t),e.props),"react-datepicker__month--selected":Ye.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__month-text--keyboard-selected":Ye.default(l)===t,"react-datepicker__month--in-range":nr(n,o,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),mt(bt(e),"getTabIndex",(function(t){var r=Ye.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),mt(bt(e),"getAriaLabel",(function(t){var r=e.props,a=r.ariaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=qe.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Lt(p,"MMMM yyyy"))})),mt(bt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate;return ce.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||p)&&or(Ae.default(a,t),e.props),"react-datepicker__quarter--selected":xe.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__quarter--in-range":ir(n,o,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),mt(bt(e),"renderMonths",(function(){var t=e.props,r=t.showFullMonthYearPicker,a=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,o=t.locale;return(n?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,a){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:a},t.map((function(t,a){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:a,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"button","aria-label":e.getAriaLabel(t)},r?Xt(t,o):Zt(t,o))})))}))})),mt(bt(e),"renderQuarters",(function(){return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,r){return de.default.createElement("div",{key:r,onClick:function(r){e.onQuarterClick(r,t)},className:e.getQuarterClassNames(t)},er(t,e.props.locale))})))})),mt(bt(e),"getClassNames",(function(){var t=e.props;t.day;var r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ce.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Lt(a,"yyyy-MM"))},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Rr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),mt(bt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props)||e.props.onChange(t)})),mt(bt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.props.selected&&r===Pe.default(t)&&a===Me.default(t)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Pe.default(t)+Me.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),mt(bt(e),"renderTimes",(function(){for(var t=[],r=e.props.format?e.props.format:"p",a=e.props.intervals,n=At(xt(e.props.selected)),o=1440/a,s=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),i=e.props.selected||e.props.openToDate||xt(),p=Pe.default(i),l=Me.default(i),d=Re.default(Fe.default(n,l),p),c=0;c<o;c++){var u=me.default(n,c*a);if(t.push(u),s){var f=wr(n,u,c,a,s);t=t.concat(f)}}return t.map((function(t,a){return de.default.createElement("li",{key:a,onClick:e.handleClick.bind(bt(e),t),className:e.liClasses(t,p,l),ref:function(r){(nt.default(t,d)||$t(t,d))&&(e.centerLi=r)},tabIndex:"0"},Lt(t,r,e.props.locale))}))})),e}return ht(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);mt(Rr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),mt(bt(a),"isSameDay",(function(e,t){return Ut(e,t)})),mt(bt(a),"isKeyboardSelected",(function(e){var t=jt(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Ut(t,jt(a.props.selected))&&Ut(t,jt(a.props.preSelection))})),mt(bt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(We.default(r,t)),e)})),mt(bt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected;return ce.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Te.default(o),"react-datepicker__year-text--disabled":(r||n)&&sr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--today":e===Te.default(xt())})})),a}return ht(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=gr(r.date,r.yearItemNumber),n=a.startPeriod,o=a.endPeriod,s=function(r){t.push(de.default.createElement("div",{onClick:function(t){e.onYearClick(t,r)},className:e.getYearClassNames(r),key:r},r))},i=n;i<=o;i++)s(i);return de.default.createElement("div",{className:"react-datepicker__year"},de.default.createElement("div",{className:"react-datepicker__year-wrapper"},t))}}]),r}(de.default.Component),Ar=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),mt(bt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Wr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",yt({className:"react-datepicker__triangle"},o)),r)}var Br=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],jr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),mt(bt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),mt(bt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Br.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),mt(bt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=yr(a.props),s=vr(a.props),i=xt(),p=n||r||t;return p||(o&&nt.default(i,o)?o:s&&at.default(i,s)?s:i)})),mt(bt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:Ce.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),mt(bt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),mt(bt(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),mt(bt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:qe.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(qe.default(r,Ye.default(e)),Te.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),mt(bt(a),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=Wt(e,a.props.locale),r=[];return a.props.showWeekNumbers&&r.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map((function(e){var r=ve.default(t,e),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:e,className:ce.default("react-datepicker__day-name",o)},n)})))})),mt(bt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Lt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Lt(e,"EEE",t)}(e,t):function(e,t){return Lt(e,"EEEEEE",t)}(e,t)})),mt(bt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Se.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=hr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(jt(Se.default(e,n)),n).endPeriod,s=r&&Te.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=ur(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthAriaLabel,i=void 0===s?"Previous Month":s,p=o.previousYearAriaLabel,l=void 0===p?"Previous Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel)}}})),mt(bt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:ke.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=mr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(ke.default(e,n),n).startPeriod,s=r&&Te.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=fr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthAriaLabel,i=void 0===s?"Next Month":s,p=o.nextYearAriaLabel,l=void 0===p?"Next Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel)}}})),mt(bt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Lt(e,a.props.dateFormat,a.props.locale))})),mt(bt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(_r,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Te.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),mt(bt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Er,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Ye.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),mt(bt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(xr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),mt(bt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(Ve.default(xt()),e)}},a.props.todayButton)})),mt(bt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=ur(a.state.date,a.props),o=fr(a.state.date,a.props),s=hr(a.state.date,a.props),i=mr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=gr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Te.default(e))})),mt(bt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),mt(bt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=Ce.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Fr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),mt(bt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(qr,yt({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),mt(bt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Rr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,showTimeSelectOnly:a.props.showTimeSelectOnly})})),mt(bt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=It(e)&&Boolean(a.props.selected)?"".concat(kr(e.getHours()),":").concat(kr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Ar,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return ht(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ut(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ut(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Wr;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ce.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ot}}}]),r}(de.default.Component),Hr=function(e){return!e.disabled&&-1!==e.tabIndex},Kr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Hr)})),mt(bt(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),mt(bt(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return ht(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),Qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return ht(r,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return dt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),Vr=function(e){wt(r,e);var t=St(r);function r(){return ut(this,r),t.apply(this,arguments)}return ht(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,d=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId;if(!n){var f=ce.default("react-datepicker-popper",r);e=de.default.createElement(ie.Popper,yt({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(Kr,{enableTabLoop:d},de.default.createElement("div",{ref:t,style:r,className:f,"data-placement":a,onKeyDown:c},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(Qr,{portalId:u},e));var h=ce.default("react-datepicker-wrapper",a);return de.default.createElement(ie.Manager,{className:"react-datepicker-manager"},de.default.createElement(ie.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:h},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),Ur="react-datepicker-ignore-onclickoutside",$r=lt.default(jr);var zr="Date input not valid.",Gr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:xt()})),mt(bt(a),"calcInitialState",(function(){var e=a.getPreSelection(),t=yr(a.props),r=vr(a.props),n=t&&nt.default(e,Ve.default(t))?t:r&&at.default(e,Je.default(r))?r:e;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:a.props.selected?a.props.selected:n,highlightDates:Dr(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),mt(bt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),mt(bt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),mt(bt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),mt(bt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Xr},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),mt(bt(a),"inputOk",(function(){return ue.default(a.state.preSelection)})),mt(bt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),mt(bt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),mt(bt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),mt(bt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),mt(bt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),mt(bt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),mt(bt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),mt(bt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(bt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Jr});var o=Tt(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing);!o&&n.target.value||a.setSelected(o,n,!0)}})),mt(bt(a),"handleSelect",(function(e,t,r){a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect?a.setPreSelection(e):a.props.inline||a.setOpen(!1)})),mt(bt(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!tr(o,a.props)){var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,d=s.endDate;if(!$t(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Ft(o,{hour:Pe.default(a.props.selected),minute:Me.default(a.props.selected),second:_e.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var c=l&&!d,u=l&&d;!l&&!d?i([o,null],t):c&&(nt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))}})),mt(bt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){var o=Ve.default(e);if(t&&r)n=zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=Ve.default(a.props.minDate);n=at.default(e,s)||$t(o,s)}else if(r){var i=Je.default(a.props.maxDate);n=nt.default(e,i)||$t(o,i)}}n&&a.setState({preSelection:e})})),mt(bt(a),"handleTimeChange",(function(e){var t=Ft(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Pe.default(e),minute:Me.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null})})),mt(bt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),mt(bt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=xt(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Xr?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:zr})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),mt(bt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=xt(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:zr});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=ge.default(r,1);break;case"ArrowRight":n=ve.default(r,1);break;case"ArrowUp":n=be.default(r,1);break;case"ArrowDown":n=De.default(r,1);break;case"PageUp":n=Ce.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Se.default(r,1);break;case"End":n=ke.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:zr}));if(e.preventDefault(),a.setState({lastPreSelectChange:Xr}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Ye.default(r),s=Ye.default(n),i=Te.default(r),p=Te.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),mt(bt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),mt(bt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.onChange(null,e),a.setState({inputValue:null})})),mt(bt(a),"clear",(function(){a.onClearClick()})),mt(bt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),mt(bt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement($r,{ref:function(e){a.calendar=e},locale:a.props.locale,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:Ur,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),mt(bt(a),"renderDateInput",(function(){var e,t,r,n,o,s=ce.default(a.props.className,mt({},Ur,a.state.open)),i=a.props.customInput||de.default.createElement("input",{type:"text"}),p=a.props.customInputRef||"ref",l="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:(t=a.props.selected,r=a.props,n=r.dateFormat,o=r.locale,t&&Lt(t,Array.isArray(n)?n[0]:n,o)||"");return de.default.cloneElement(i,(mt(e={},p,(function(e){a.input=e})),mt(e,"value",l),mt(e,"onBlur",a.handleBlur),mt(e,"onChange",a.handleChange),mt(e,"onClick",a.onInputClick),mt(e,"onFocus",a.handleFocus),mt(e,"onKeyDown",a.onInputKeyDown),mt(e,"id",a.props.id),mt(e,"name",a.props.name),mt(e,"autoFocus",a.props.autoFocus),mt(e,"placeholder",a.props.placeholderText),mt(e,"disabled",a.props.disabled),mt(e,"autoComplete",a.props.autoComplete),mt(e,"className",ce.default(i.props.className,s)),mt(e,"title",a.props.title),mt(e,"readOnly",a.props.readOnly),mt(e,"required",a.props.required),mt(e,"tabIndex",a.props.tabIndex),mt(e,"aria-describedby",a.props.ariaDescribedBy),mt(e,"aria-invalid",a.props.ariaInvalid),mt(e,"aria-labelledby",a.props.ariaLabelledBy),mt(e,"aria-required",a.props.ariaRequired),e))})),mt(bt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.clearButtonTitle,o=e.clearButtonClassName,s=e.ariaLabelClose,i=void 0===s?"Close":s;return t&&null!=r?de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(o),"aria-label":i,onClick:a.onClearClick,title:n,tabIndex:-1}):null})),a.state=a.calcInitialState(),a}return ht(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Ye.default(r)!==Ye.default(a)||Te.default(r)!==Te.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Dr(this.props.highlightDates)}),t.focused||$t(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?de.default.createElement("div",null,this.props.inline?null:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?de.default.createElement("div",{className:"react-datepicker__portal"},e):null):de.default.createElement(Vr,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ot,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),r}(de.default.Component),Jr="input",Xr="navigate";e.CalendarContainer=Wr,e.default=Gr,e.getDefaultLocale=Gt,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:__webpack_require__.g;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:__webpack_require__.g).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IGNORE_CLASS_NAME": function() { return /* binding */ IGNORE_CLASS_NAME; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),

/***/ 60722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _reactFastCompare = _interopRequireDefault(__webpack_require__(69590));

var _props = __webpack_require__(85741);

var _utils = __webpack_require__(38045);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "handlePlayerMount", function (player) {
      if (_this.player) {
        _this.progress(); // Ensure onProgress is still called in strict mode


        return; // Return here to prevent loading twice in strict mode
      }

      _this.player = player;

      _this.player.load(_this.props.url);

      _this.progress();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady && this.props.stopOnUnmount) {
        this.player.stop();

        if (this.player.disablePIP) {
          this.player.disablePIP();
        }
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // If there isn’t a player available, don’t do anything
      if (!this.player) {
        return;
      } // Invoke player methods based on changed props


      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer,
          disableDeferredLoading = _this$props5.disableDeferredLoading;

      if (!(0, _reactFastCompare["default"])(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, _utils.isMediaStream)(url)) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady) {
        if (amount !== 0) {
          this.seekOnPlay = amount;
          setTimeout(function () {
            _this3.seekOnPlay = null;
          }, SEEK_ON_PLAY_EXPIRY);
        }

        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", _props.propTypes);

_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ }),

/***/ 83855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';
var cache = {};

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        _this.props.onClick();
      }
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light,
          oEmbedUrl = _ref.oEmbedUrl;

      if ( /*#__PURE__*/_react["default"].isValidElement(light)) {
        return;
      }

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      if (cache[url]) {
        this.setState({
          image: cache[url]
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch(oEmbedUrl.replace('{url}', url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480').replace('-d_295x166', '-d_640');

          _this2.setState({
            image: image
          });

          cache[url] = image;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          light = _this$props2.light,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon,
          previewTabIndex = _this$props2.previewTabIndex;
      var image = this.state.image;

      var isElement = /*#__PURE__*/_react["default"].isValidElement(light);

      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image && !isElement ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE,
          position: isElement ? 'absolute' : undefined
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick,
        tabIndex: previewTabIndex,
        onKeyPress: this.handleKeyPress
      }, isElement ? light : null, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;

/***/ }),

/***/ 70390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createReactPlayer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _deepmerge = _interopRequireDefault(__webpack_require__(9996));

var _memoizeOne = _interopRequireDefault(__webpack_require__(30845));

var _reactFastCompare = _interopRequireDefault(__webpack_require__(69590));

var _props = __webpack_require__(85741);

var _utils = __webpack_require__(38045);

var _Player3 = _interopRequireDefault(__webpack_require__(60722));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Preview = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(__webpack_require__(83855));
  });
});
var IS_BROWSER = typeof window !== 'undefined' && window.document;
var IS_GLOBAL = typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.window && __webpack_require__.g.window.document;
var SUPPORTED_PROPS = Object.keys(_props.propTypes); // Return null when rendering on the server
// as Suspense is not supported yet

var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
  return null;
};
var customPlayers = [];

var createReactPlayer = function createReactPlayer(players, fallback) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(ReactPlayer, _Component);

    var _super = _createSuper(ReactPlayer);

    function ReactPlayer() {
      var _this;

      _classCallCheck(this, ReactPlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        showPreview: !!_this.props.light
      });

      _defineProperty(_assertThisInitialized(_this), "references", {
        wrapper: function wrapper(_wrapper) {
          _this.wrapper = _wrapper;
        },
        player: function player(_player) {
          _this.player = _player;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function (e) {
        _this.setState({
          showPreview: false
        });

        _this.props.onClickPreview(e);
      });

      _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
        _this.setState({
          showPreview: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
        _this.props.onReady(_assertThisInitialized(_this));
      });

      _defineProperty(_assertThisInitialized(_this), "getActivePlayer", (0, _memoizeOne["default"])(function (url) {
        for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
          var player = _arr[_i];

          if (player.canPlay(url)) {
            return player;
          }
        }

        if (fallback) {
          return fallback;
        }

        return null;
      }));

      _defineProperty(_assertThisInitialized(_this), "getConfig", (0, _memoizeOne["default"])(function (url, key) {
        var config = _this.props.config;
        return _deepmerge["default"].all([_props.defaultProps.config, _props.defaultProps.config[key] || {}, config, config[key] || {}]);
      }));

      _defineProperty(_assertThisInitialized(_this), "getAttributes", (0, _memoizeOne["default"])(function (url) {
        return (0, _utils.omit)(_this.props, SUPPORTED_PROPS);
      }));

      _defineProperty(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
        if (!url) return null;

        var player = _this.getActivePlayer(url);

        if (!player) return null;

        var config = _this.getConfig(url, player.key);

        return /*#__PURE__*/_react["default"].createElement(_Player3["default"], _extends({}, _this.props, {
          key: player.key,
          ref: _this.references.player,
          config: config,
          activePlayer: player.lazyPlayer || player,
          onReady: _this.handleReady
        }));
      });

      return _this;
    }

    _createClass(ReactPlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _reactFastCompare["default"])(this.props, nextProps) || !(0, _reactFastCompare["default"])(this.state, nextState);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var light = this.props.light;

        if (!prevProps.light && light) {
          this.setState({
            showPreview: true
          });
        }

        if (prevProps.light && !light) {
          this.setState({
            showPreview: false
          });
        }
      }
    }, {
      key: "renderPreview",
      value: function renderPreview(url) {
        if (!url) return null;
        var _this$props = this.props,
            light = _this$props.light,
            playIcon = _this$props.playIcon,
            previewTabIndex = _this$props.previewTabIndex,
            oEmbedUrl = _this$props.oEmbedUrl;
        return /*#__PURE__*/_react["default"].createElement(Preview, {
          url: url,
          light: light,
          playIcon: playIcon,
          previewTabIndex: previewTabIndex,
          oEmbedUrl: oEmbedUrl,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            url = _this$props2.url,
            style = _this$props2.style,
            width = _this$props2.width,
            height = _this$props2.height,
            fallback = _this$props2.fallback,
            Wrapper = _this$props2.wrapper;
        var showPreview = this.state.showPreview;
        var attributes = this.getAttributes(url);
        var wrapperRef = typeof Wrapper === 'string' ? this.references.wrapper : undefined;
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          ref: wrapperRef,
          style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height
          })
        }, attributes), /*#__PURE__*/_react["default"].createElement(UniversalSuspense, {
          fallback: fallback
        }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
      }
    }]);

    return ReactPlayer;
  }(_react.Component), _defineProperty(_class, "displayName", 'ReactPlayer'), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "addCustomPlayer", function (player) {
    customPlayers.push(player);
  }), _defineProperty(_class, "removeCustomPlayers", function () {
    customPlayers.length = 0;
  }), _defineProperty(_class, "canPlay", function (url) {
    for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
      var _Player = _arr2[_i2];

      if (_Player.canPlay(url)) {
        return true;
      }
    }

    return false;
  }), _defineProperty(_class, "canEnablePIP", function (url) {
    for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
      var _Player2 = _arr3[_i3];

      if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
        return true;
      }
    }

    return false;
  }), _temp;
};

exports.createReactPlayer = createReactPlayer;

/***/ }),

/***/ 22004:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _players = _interopRequireDefault(__webpack_require__(86497));

var _ReactPlayer = __webpack_require__(70390);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Fall back to FilePlayer if nothing else can play the URL
var fallback = _players["default"][_players["default"].length - 1];

var _default = (0, _ReactPlayer.createReactPlayer)(_players["default"], fallback);

exports.Z = _default;

/***/ }),

/***/ 71776:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;

var _utils = __webpack_require__(38045);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
var MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
var AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlayFile(item)) {
          return true;
        }

        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url) || (0, _utils.isBlobUrl)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};

var canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return MATCH_URL_YOUTUBE.test(item);
      });
    }

    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
  },
  facebook: function facebook(url) {
    return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};
exports.canPlay = canPlay;

/***/ }),

/***/ 36807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(_patterns.MATCH_URL_DAILYMOTION),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports["default"] = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", _patterns.canPlay.dailymotion);

_defineProperty(DailyMotion, "loopOnEnded", true);

/***/ }),

/***/ 31972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.appId,
          xfbml: true,
          version: _this2.props.config.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (_this2.props.muted) {
              _this2.callPlayer('mute');
            } else {
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var attributes = this.props.config.attributes;
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      }, attributes));
    }
  }]);

  return Facebook;
}(_react.Component);

exports["default"] = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", _patterns.canPlay.facebook);

_defineProperty(Facebook, "loopOnEnded", true);

/***/ }),

/***/ 14926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HAS_NAVIGATOR = typeof navigator !== 'undefined';
var IS_IPAD_PRO = HAS_NAVIGATOR && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_IOS = HAS_NAVIGATOR && (/iPad|iPhone|iPod/.test(navigator.userAgent) || IS_IPAD_PRO) && !window.MSStream;
var IS_SAFARI = HAS_NAVIGATOR && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !window.MSStream;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var FLV_SDK_URL = 'https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js';
var FLV_GLOBAL = 'flvjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
var MATCH_CLOUDFLARE_STREAM = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/;
var REPLACE_CLOUDFLARE_STREAM = 'https://videodelivery.net/{id}/manifest/video.m3u8';

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayBackRateChange", function (event) {
      return _this.props.onPlaybackRateChange(event.target.playbackRate);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && (0, _utils.supportsWebKitPresentationMode)(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
      this.addListeners(this.player);
      this.player.src = this.getSource(this.props.url); // Ensure src is set in strict mode

      if (IS_IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer, prevProps.url);
        this.addListeners(this.player);
      }

      if (this.props.url !== prevProps.url && !(0, _utils.isMediaStream)(this.props.url)) {
        this.player.srcObject = null;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.player.src = '';
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playsinline = _this$props10.playsinline;
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('ratechange', this.onPlayBackRateChange);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.addEventListener('canplay', this.onReady);
      }

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player, url) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('ratechange', this.onPlayBackRateChange);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.removeEventListener('canplay', this.onReady);
      }
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.forceVideo) {
        return false;
      }

      if (props.config.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return _patterns.AUDIO_EXTENSIONS.test(props.url) || props.config.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      if (this.props.config.forceHLS) {
        return true;
      }

      if (IS_SAFARI && this.props.config.forceSafariHLS) {
        return true;
      }

      if (IS_IOS) {
        return false;
      }

      return _patterns.HLS_EXTENSIONS.test(url) || MATCH_CLOUDFLARE_STREAM.test(url);
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return _patterns.DASH_EXTENSIONS.test(url) || this.props.config.forceDASH;
    }
  }, {
    key: "shouldUseFLV",
    value: function shouldUseFLV(url) {
      return _patterns.FLV_EXTENSIONS.test(url) || this.props.config.forceFLV;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config = this.props.config,
          hlsVersion = _this$props$config.hlsVersion,
          hlsOptions = _this$props$config.hlsOptions,
          dashVersion = _this$props$config.dashVersion,
          flvVersion = _this$props$config.flvVersion;

      if (this.hls) {
        this.hls.destroy();
      }

      if (this.dash) {
        this.dash.reset();
      }

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(hlsOptions);

          _this2.hls.on(Hls.Events.MANIFEST_PARSED, function () {
            _this2.props.onReady();
          });

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          if (MATCH_CLOUDFLARE_STREAM.test(url)) {
            var id = url.match(MATCH_CLOUDFLARE_STREAM)[1];

            _this2.hls.loadSource(REPLACE_CLOUDFLARE_STREAM.replace('{id}', id));
          } else {
            _this2.hls.loadSource(url);
          }

          _this2.hls.attachMedia(_this2.player);

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          if (parseInt(dashVersion) < 3) {
            _this2.dash.getDebug().setLogToBrowserConsole(false);
          } else {
            _this2.dash.updateSettings({
              debug: {
                logLevel: dashjs.Debug.LOG_LEVEL_NONE
              }
            });
          }

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseFLV(url)) {
        (0, _utils.getSDK)(FLV_SDK_URL.replace('VERSION', flvVersion), FLV_GLOBAL).then(function (flvjs) {
          _this2.flv = flvjs.createPlayer({
            type: 'flv',
            url: url
          });

          _this2.flv.attachMediaElement(_this2.player);

          _this2.flv.on(flvjs.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.flv, flvjs);
          });

          _this2.flv.load();

          _this2.props.onLoaded();
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if ((0, _utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if ((0, _utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      try {
        this.player.playbackRate = rate;
      } catch (error) {
        this.props.onError(error);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      var useFLV = this.shouldUseFLV(url);

      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH || useFLV) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          url = _this$props11.url,
          playing = _this$props11.playing,
          loop = _this$props11.loop,
          controls = _this$props11.controls,
          muted = _this$props11.muted,
          config = _this$props11.config,
          width = _this$props11.width,
          height = _this$props11.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.attributes), url instanceof Array && url.map(this.renderSourceElement), config.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports["default"] = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", _patterns.canPlay.file);

/***/ }),

/***/ 73911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Kaltura = /*#__PURE__*/function (_Component) {
  _inherits(Kaltura, _Component);

  var _super = _createSuper(Kaltura);

  function Kaltura() {
    var _this;

    _classCallCheck(this, Kaltura);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Kaltura, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.on('ready', function () {
          // An arbitrary timeout is required otherwise
          // the event listeners won’t work
          setTimeout(function () {
            _this2.player.isReady = true;

            _this2.player.setLoop(_this2.props.loop);

            if (_this2.props.muted) {
              _this2.player.mute();
            }

            _this2.addListeners(_this2.player, _this2.props);

            _this2.props.onReady();
          }, 500);
        });
      }, this.props.onError);
    }
  }, {
    key: "addListeners",
    value: function addListeners(player, props) {
      var _this3 = this;

      player.on('play', props.onPlay);
      player.on('pause', props.onPause);
      player.on('ended', props.onEnded);
      player.on('error', props.onError);
      player.on('timeupdate', function (_ref) {
        var duration = _ref.duration,
            seconds = _ref.seconds;
        _this3.duration = duration;
        _this3.currentTime = seconds;
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: this.props.url,
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allow: "encrypted-media; autoplay; fullscreen;",
        referrerPolicy: "no-referrer-when-downgrade"
      });
    }
  }]);

  return Kaltura;
}(_react.Component);

exports["default"] = Kaltura;

_defineProperty(Kaltura, "displayName", 'Kaltura');

_defineProperty(Kaltura, "canPlay", _patterns.canPlay.kaltura);

/***/ }),

/***/ 50143:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(_patterns.MATCH_URL_MIXCLOUD)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_objectSpread(_objectSpread({}, config.options), {}, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0",
        allow: "autoplay"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports["default"] = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", _patterns.canPlay.mixcloud);

_defineProperty(Mixcloud, "loopOnEnded", true);

/***/ }),

/***/ 72648:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, function () {
            var remaining = _this2.duration - _this2.currentTime;

            if (remaining < 0.05) {
              // Prevent onPause firing right before onEnded
              return;
            }

            _this2.props.onPause();
          });

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread(_objectSpread({}, _this2.props.config.options), {}, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports["default"] = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", _patterns.canPlay.soundcloud);

_defineProperty(SoundCloud, "loopOnEnded", true);

/***/ }),

/***/ 50993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(_patterns.MATCH_URL_STREAMABLE)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allow: "encrypted-media; autoplay; fullscreen;"
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports["default"] = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", _patterns.canPlay.streamable);

/***/ }),

/***/ 29482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;

      var isChannel = _patterns.MATCH_URL_TWITCH_CHANNEL.test(url);

      var id = isChannel ? url.match(_patterns.MATCH_URL_TWITCH_CHANNEL)[1] : url.match(_patterns.MATCH_URL_TWITCH_VIDEO)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls,
          time: (0, _utils.parseStartTime)(url)
        }, config.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE,
            SEEK = _Twitch$Player.SEEK;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded);

        _this2.player.addEventListener(SEEK, _this2.props.onSeek); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports["default"] = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", _patterns.canPlay.twitch);

_defineProperty(Twitch, "loopOnEnded", true);

/***/ }),

/***/ 36596:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://play.vidyard.com/embed/v4.js';
var SDK_GLOBAL = 'VidyardV4';
var SDK_GLOBAL_READY = 'onVidyardAPI';

var Vidyard = /*#__PURE__*/function (_Component) {
  _inherits(Vidyard, _Component);

  var _super = _createSuper(Vidyard);

  function Vidyard() {
    var _this;

    _classCallCheck(this, Vidyard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vidyard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          playing = _this$props.playing,
          config = _this$props.config,
          onError = _this$props.onError,
          onDuration = _this$props.onDuration;
      var id = url && url.match(_patterns.MATCH_URL_VIDYARD)[1];

      if (this.player) {
        this.stop();
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (Vidyard) {
        if (!_this2.container) return;
        Vidyard.api.addReadyListener(function (data, player) {
          if (_this2.player) {
            return;
          }

          _this2.player = player;

          _this2.player.on('ready', _this2.props.onReady);

          _this2.player.on('play', _this2.props.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seek', _this2.props.onSeek);

          _this2.player.on('playerComplete', _this2.props.onEnded);
        }, id);
        Vidyard.api.renderPlayer(_objectSpread({
          uuid: id,
          container: _this2.container,
          autoplay: playing ? 1 : 0
        }, config.options));
        Vidyard.api.getPlayerMetadata(id).then(function (meta) {
          _this2.duration = meta.length_in_seconds;
          onDuration(meta.length_in_seconds);
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      window.VidyardV4.api.destroyPlayer(this.player);
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seek', amount);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackSpeed', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('currentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return Vidyard;
}(_react.Component);

exports["default"] = Vidyard;

_defineProperty(Vidyard, "displayName", 'Vidyard');

_defineProperty(Vidyard, "canPlay", _patterns.canPlay.vidyard);

/***/ }),

/***/ 80868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setMuted(true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.setMuted(false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        var _this2$props$config = _this2.props.config,
            playerOptions = _this2$props$config.playerOptions,
            title = _this2$props$config.title;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';

          if (title) {
            iframe.title = title;
          }
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });

        _this2.player.on('bufferstart', _this2.props.onBuffer);

        _this2.player.on('bufferend', _this2.props.onBufferEnd);

        _this2.player.on('playbackratechange', function (e) {
          return _this2.props.onPlaybackRateChange(e.playbackRate);
        });
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.callPlayer('setMuted', muted);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports["default"] = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "canPlay", _patterns.canPlay.vimeo);

_defineProperty(Vimeo, "forceLoad", true);

/***/ }),

/***/ 8018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var PLAYER_ID_PREFIX = 'wistia-player-';

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlaybackRateChange", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPlaybackRateChange.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props6 = this.props,
          playing = _this$props6.playing,
          muted = _this$props6.muted,
          controls = _this$props6.controls,
          _onReady = _this$props6.onReady,
          config = _this$props6.config,
          onError = _this$props6.onError;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Wistia) {
        if (config.customControls) {
          config.customControls.forEach(function (control) {
            return Wistia.defineControl(control);
          });
        }

        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.playerID,
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls,
            fullscreenButton: controls,
            playbar: controls,
            playbackRateControl: controls,
            qualityControl: controls,
            volumeControl: controls,
            settingsControl: controls,
            smallPlayButton: controls
          }, config.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _this2.player.bind('playbackratechange', _this2.onPlaybackRateChange);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
      this.player.unbind('playbackratechange', this.onPlaybackRateChange);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.props.url;
      var videoID = url && url.match(_patterns.MATCH_URL_WISTIA)[1];
      var className = "wistia_embed wistia_async_".concat(videoID);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.playerID,
        key: videoID,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports["default"] = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", _patterns.canPlay.wistia);

_defineProperty(Wistia, "loopOnEnded", true);

/***/ }),

/***/ 60356:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "parsePlaylist", function (url) {
      if (url instanceof Array) {
        return {
          listType: 'playlist',
          playlist: url.map(_this.getID).join(',')
        };
      }

      if (MATCH_PLAYLIST.test(url)) {
        var _url$match = url.match(MATCH_PLAYLIST),
            _url$match2 = _slicedToArray(_url$match, 2),
            playlistId = _url$match2[1];

        return {
          listType: 'playlist',
          list: playlistId.replace(/^UC/, 'UU')
        };
      }

      if (MATCH_USER_UPLOADS.test(url)) {
        var _url$match3 = url.match(MATCH_USER_UPLOADS),
            _url$match4 = _slicedToArray(_url$match3, 2),
            username = _url$match4[1];

        return {
          listType: 'user_uploads',
          list: username
        };
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
      var data = event.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop,
          _this$props$config = _this$props.config,
          playerVars = _this$props$config.playerVars,
          onUnstarted = _this$props$config.onUnstarted;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;
      if (data === UNSTARTED) onUnstarted();

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist'); // Only loop manually if not playing a playlist

        if (loop && !isPlaylist) {
          if (playerVars.start) {
            _this.seekTo(playerVars.start);
          } else {
            _this.play();
          }
        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "getID",
    value: function getID(url) {
      if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
        return null;
      }

      return url.match(_patterns.MATCH_URL_YOUTUBE)[1];
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var playerVars = config.playerVars,
          embedOptions = config.embedOptions;
      var id = this.getID(url);

      if (isReady) {
        if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
          this.player.loadPlaylist(this.parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread(_objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline ? 1 : 0
          }, _this2.parsePlaylist(url)), playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onPlaybackRateChange: function onPlaybackRateChange(event) {
              return _this2.props.onPlaybackRateChange(event.data);
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          },
          host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
        }, embedOptions));
      }, _onError);

      if (embedOptions.events) {
        console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause');
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports["default"] = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", _patterns.canPlay.youtube);

/***/ }),

/***/ 86497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = __webpack_require__(67294);

var _utils = __webpack_require__(38045);

var _patterns = __webpack_require__(71776);

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = [{
  key: 'youtube',
  name: 'YouTube',
  canPlay: _patterns.canPlay.youtube,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(60356));
    });
  })
}, {
  key: 'soundcloud',
  name: 'SoundCloud',
  canPlay: _patterns.canPlay.soundcloud,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(72648));
    });
  })
}, {
  key: 'vimeo',
  name: 'Vimeo',
  canPlay: _patterns.canPlay.vimeo,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(80868));
    });
  })
}, {
  key: 'facebook',
  name: 'Facebook',
  canPlay: _patterns.canPlay.facebook,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(31972));
    });
  })
}, {
  key: 'streamable',
  name: 'Streamable',
  canPlay: _patterns.canPlay.streamable,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(50993));
    });
  })
}, {
  key: 'wistia',
  name: 'Wistia',
  canPlay: _patterns.canPlay.wistia,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(8018));
    });
  })
}, {
  key: 'twitch',
  name: 'Twitch',
  canPlay: _patterns.canPlay.twitch,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(29482));
    });
  })
}, {
  key: 'dailymotion',
  name: 'DailyMotion',
  canPlay: _patterns.canPlay.dailymotion,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(36807));
    });
  })
}, {
  key: 'mixcloud',
  name: 'Mixcloud',
  canPlay: _patterns.canPlay.mixcloud,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(50143));
    });
  })
}, {
  key: 'vidyard',
  name: 'Vidyard',
  canPlay: _patterns.canPlay.vidyard,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(36596));
    });
  })
}, {
  key: 'kaltura',
  name: 'Kaltura',
  canPlay: _patterns.canPlay.kaltura,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(73911));
    });
  })
}, {
  key: 'file',
  name: 'FilePlayer',
  canPlay: _patterns.canPlay.file,
  canEnablePIP: function canEnablePIP(url) {
    return _patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, _utils.supportsWebKitPresentationMode)()) && !_patterns.AUDIO_EXTENSIONS.test(url);
  },
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(__webpack_require__(14926));
    });
  })
}];
exports["default"] = _default;

/***/ }),

/***/ 85741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string, object]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  oEmbedUrl: string,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object,
      title: string
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceSafariHLS: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onPlaybackRateChange: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;

var noop = function noop() {};

var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: 'div',
  previewTabIndex: 0,
  oEmbedUrl: 'https://noembed.com/embed?url={url}',
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: '1.1.4',
      dashVersion: '3.1.3',
      flvVersion: '1.5.0'
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onPlaybackRateChange: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};
exports.defaultProps = defaultProps;

/***/ }),

/***/ 38045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isMediaStream = isMediaStream;
exports.isBlobUrl = isBlobUrl;
exports.supportsWebKitPresentationMode = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(__webpack_require__(49090));

var _deepmerge = _interopRequireDefault(__webpack_require__(9996));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video');
  // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function
  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}

/***/ }),

/***/ 33557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper_Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "placements": function() { return /* reexport */ Popper_placements; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(10251);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/popper.js/dist/esm/popper.js
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var popper_extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return popper_extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return popper_extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = popper_extends({}, attributes, data.attributes);
  data.styles = popper_extends({}, styles, data.styles);
  data.arrowStyles = popper_extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = popper_extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = popper_extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = popper_extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = popper_extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(popper_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = popper_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return popper_extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ var popper = (Popper);
//# sourceMappingURL=popper.js.map

// EXTERNAL MODULE: ./node_modules/@hypnosphi/create-react-context/lib/index.js
var lib = __webpack_require__(88740);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Manager.js





var ManagerReferenceNodeContext = lib_default()();
var ManagerReferenceNodeSetterContext = lib_default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "referenceNode", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return react.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, react.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(react.Component);


;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Popper.js










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popperInstance", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popperNode", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "arrowNode", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends({}, _this.props.modifiers, {
          arrow: _extends({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new popper(referenceElement, popperNode, _this.getOptions());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deep_equal_default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {}

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(react.Component);

_defineProperty(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var Popper_placements = popper.placements;

function Popper_Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = _objectWithoutPropertiesLoose(_ref, ["referenceElement"]);

  return react.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return react.createElement(InnerPopper, _extends({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Reference.js









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(react.Component);

function Reference(props) {
  return react.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return react.createElement(InnerReference, _extends({
      setReferenceNode: setReferenceNode
    }, props));
  });
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/index.js
// Public components



 // Public types

/***/ }),

/***/ 53697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = (__webpack_require__(25972).functionsHaveConfigurableNames)();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, "name", ({ value: 'get flags' }));
}


/***/ }),

/***/ 2847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(55559);

var implementation = __webpack_require__(53697);
var getPolyfill = __webpack_require__(71721);
var shim = __webpack_require__(32753);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 71721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(53697);

var supportsDescriptors = (__webpack_require__(4289).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 32753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(4289).supportsDescriptors);
var getPolyfill = __webpack_require__(71721);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);